// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$resolve(url) {  url = importMap[url] || url;  return new URL(distDir + url, import.meta.url).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"cOeZF":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "1Xblb": "amex.127d08f0.svg",
    "ewRQr": "diners.2ceba43a.svg",
    "gMuLB": "discover.8eb27399.svg",
    "f9TbO": "jcb.696e77d8.svg",
    "60G3e": "mastercard.0b9eef61.svg",
    "6aFFz": "visa.44ea302f.svg",
    "4kkJF": "question-circle.81378910.svg",
    "70W3O": "powered_by_stripe_white.e991860f.svg",
    "kd7mq": "powered_by_stripe.67e1a3d0.svg",
    "aMOPZ": "logo_hearcom_payment-portal.58793f68.svg",
    "2BFe3": "logo-de.69297b46.svg",
    "fTazY": "StepProgress.3698e063.js",
    "9Mym1": "allegro-logo.b2c0dfd2.png",
    "1T57B": "paperwork.df8d69be.svg",
    "CDRKO": "warning.373569c0.svg",
    "kvkdd": "browser-ponyfill.95afc79c.js"
});

},{}],"3ef6L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _reactLocation = require("react-location");
var _reactLocationRankRoutes = require("react-location-rank-routes");
var _reactI18Next = require("react-i18next");
var _reactQuery = require("react-query");
var _devtools = require("react-query/devtools");
var _reactStripeJs = require("@stripe/react-stripe-js");
var _stripeJs = require("@stripe/stripe-js");
var _reactToastify = require("react-toastify");
var _payment = require("Core/stores/payment");
var _paymentDefault = parcelHelpers.interopDefault(_payment);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _container = require("Core/components/Dialog/Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _teleaudiologyReturnHandler = require("Core/components/TeleaudiologyReturnHandler");
var _teleaudiologyReturnHandlerDefault = parcelHelpers.interopDefault(_teleaudiologyReturnHandler);
var _errorBoundary = require("Core/components/ErrorBoundary");
var _appConfig = require("Core/config/appConfig");
var _routes = require("./routes");
var _i18N = require("./i18n");
const stripePromise = (0, _stripeJs.loadStripe)((0, _appConfig.getAppConfig)().stripePublicKey);
const location = new (0, _reactLocation.ReactLocation)();
const queryClientOptions = {
    defaultOptions: {
        queries: {
            retry: 0,
            staleTime: 300000,
            cacheTime: 600000,
            refetchOnWindowFocus: false
        }
    }
};
function PaymentOfficeApp() {
    const [queryClient] = (0, _react.useState)(()=>new _reactQuery.QueryClient(queryClientOptions));
    const { t } = (0, _reactI18Next.useTranslation)();
    const fallback = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.component')
    });
    const setPaymentState = (0, _paymentDefault.default)((0, _payment.setPaymentStateSelector));
    setPaymentState({
        stripePromise
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactQuery.QueryClientProvider, {
        client: queryClient,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _devtools.ReactQueryDevtools), {
                initialIsOpen: false
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _containerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _teleaudiologyReturnHandlerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactToastify.ToastContainer), {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: true,
                newestOnTop: false,
                closeOnClick: true,
                rtl: false,
                pauseOnFocusLoss: false,
                draggable: true,
                pauseOnHover: true,
                limit: 3,
                theme: "colored"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Suspense, {
                    fallback: fallback,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactStripeJs.Elements), {
                        stripe: stripePromise,
                        options: {
                            locale: (0, _appConfig.getAppConfig)().stripeLocale
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Router), {
                            location: location,
                            routes: (0, _routes.routes)[(0, _appConfig.getAppConfig)().country],
                            filterRoutes: (0, _reactLocationRankRoutes.rankRoutes),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Outlet), {})
                        })
                    })
                })
            })
        ]
    });
}
(0, _client.createRoot)(document.getElementById('app-container')).render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Suspense, {
    fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: "Loading translations"
    }),
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaymentOfficeApp, {
        className: "font-poppins"
    })
}));

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-dom/client":"527y0","react-location":"8hNco","react-location-rank-routes":"dfBtT","react-i18next":"244ua","react-query":"ksTpv","react-query/devtools":"g2bIt","@stripe/react-stripe-js":"jEv7X","@stripe/stripe-js":"4tXMr","react-toastify":"8eTVO","Core/stores/payment":"cVa46","Core/components/Loader":"6S7S4","Core/components/Dialog/Container":"4LGjI","Core/components/TeleaudiologyReturnHandler":"1Lg8U","Core/components/ErrorBoundary":"23d2B","Core/config/appConfig":"7qX5H","./routes":"jOoo6","./i18n":"4DOSg","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9x2lT":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c4c10cbba9862d5f");

},{"c4c10cbba9862d5f":"iujbP"}],"iujbP":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        try {
            testStringCoercion(value);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        if (JSCompiler_inline_result) {
            JSCompiler_inline_result = console;
            var JSCompiler_temp_const = JSCompiler_inline_result.error;
            var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
            JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
            return testStringCoercion(value);
        }
    }
    function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
        try {
            var name = getComponentNameFromType(type);
            return name ? "<" + name + ">" : "<...>";
        } catch (x) {
            return "<...>";
        }
    }
    function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
        return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return !1;
        }
        return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
            specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
        }
        warnAboutAccessingKey.isReactWarning = !0;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: !0
        });
    }
    function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key,
            props: props,
            _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
            enumerable: !1,
            get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", {
            enumerable: !1,
            value: null
        });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: null
        });
        Object.defineProperty(type, "_debugStack", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
    }
    function jsxDEVImpl(type, config, maybeKey, isStaticChildren, debugStack, debugTask) {
        var children = config.children;
        if (void 0 !== children) {
            if (isStaticChildren) {
                if (isArrayImpl(children)) {
                    for(isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)validateChildKeys(children[isStaticChildren]);
                    Object.freeze && Object.freeze(children);
                } else console.error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            } else validateChildKeys(children);
        }
        if (hasOwnProperty.call(config, "key")) {
            children = getComponentNameFromType(type);
            var keys = Object.keys(config).filter(function(k) {
                return "key" !== k;
            });
            isStaticChildren = 0 < keys.length ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
            didWarnAboutKeySpread[children + isStaticChildren] || (keys = 0 < keys.length ? "{" + keys.join(": ..., ") + ": ...}" : "{}", console.error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', isStaticChildren, children, keys, children), didWarnAboutKeySpread[children + isStaticChildren] = !0);
        }
        children = null;
        void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
        hasValidKey(config) && (checkKeyStringCoercion(config.key), children = "" + config.key);
        if ("key" in config) {
            maybeKey = {};
            for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
        } else maybeKey = config;
        children && defineKeyPropWarningGetter(maybeKey, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
        return ReactElement(type, children, maybeKey, getOwner(), debugStack, debugTask);
    }
    function validateChildKeys(node) {
        isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React = require("593632ccebda0d3a"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
        return null;
    };
    React = {
        react_stack_bottom_frame: function(callStackForError) {
            return callStackForError();
        }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React.react_stack_bottom_frame.bind(React, UnknownOwner)();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.jsx = function(type, config, maybeKey) {
        var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        return jsxDEVImpl(type, config, maybeKey, !1, trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack, trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
    exports.jsxs = function(type, config, maybeKey) {
        var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        return jsxDEVImpl(type, config, maybeKey, !0, trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack, trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
})();

},{"593632ccebda0d3a":"2o0ib"}],"2o0ib":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("a569817e6ea559f6");

},{"a569817e6ea559f6":"gqOZC"}],"gqOZC":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function defineDeprecationWarning(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
            }
        });
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function warnNoop(publicInstance, callerName) {
        publicInstance = (publicInstance = publicInstance.constructor) && (publicInstance.displayName || publicInstance.name) || "ReactClass";
        var warningKey = publicInstance + "." + callerName;
        didWarnStateUpdateForUnmountedComponent[warningKey] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, publicInstance), didWarnStateUpdateForUnmountedComponent[warningKey] = !0);
    }
    function Component(props, context, updater) {
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    function ComponentDummy() {}
    function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    function noop() {}
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        try {
            testStringCoercion(value);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        if (JSCompiler_inline_result) {
            JSCompiler_inline_result = console;
            var JSCompiler_temp_const = JSCompiler_inline_result.error;
            var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
            JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
            return testStringCoercion(value);
        }
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
        try {
            var name = getComponentNameFromType(type);
            return name ? "<" + name + ">" : "<...>";
        } catch (x) {
            return "<...>";
        }
    }
    function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
        return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return !1;
        }
        return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
            specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
        }
        warnAboutAccessingKey.isReactWarning = !0;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: !0
        });
    }
    function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key,
            props: props,
            _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
            enumerable: !1,
            get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", {
            enumerable: !1,
            value: null
        });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: null
        });
        Object.defineProperty(type, "_debugStack", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        newKey = ReactElement(oldElement.type, newKey, oldElement.props, oldElement._owner, oldElement._debugStack, oldElement._debugTask);
        oldElement._store && (newKey._store.validated = oldElement._store.validated);
        return newKey;
    }
    function validateChildKeys(node) {
        isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function escape(key) {
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        return "$" + key.replace(/[=:]/g, function(match) {
            return escaperLookup[match];
        });
    }
    function getElementKey(element, index) {
        return "object" === typeof element && null !== element && null != element.key ? (checkKeyStringCoercion(element.key), escape("" + element.key)) : index.toString(36);
    }
    function resolveThenable(thenable) {
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                throw thenable.reason;
            default:
                switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                    "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
                }, function(error) {
                    "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
                })), thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw thenable.reason;
                }
        }
        throw thenable;
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if ("undefined" === type || "boolean" === type) children = null;
        var invokeCallback = !1;
        if (null === children) invokeCallback = !0;
        else switch(type){
            case "bigint":
            case "string":
            case "number":
                invokeCallback = !0;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = !0;
                        break;
                    case REACT_LAZY_TYPE:
                        return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
                }
        }
        if (invokeCallback) {
            invokeCallback = children;
            callback = callback(invokeCallback);
            var childKey = "" === nameSoFar ? "." + getElementKey(invokeCallback, 0) : nameSoFar;
            isArrayImpl(callback) ? (escapedPrefix = "", null != childKey && (escapedPrefix = childKey.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
                return c;
            })) : null != callback && (isValidElement(callback) && (null != callback.key && (invokeCallback && invokeCallback.key === callback.key || checkKeyStringCoercion(callback.key)), escapedPrefix = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || invokeCallback && invokeCallback.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + childKey), "" !== nameSoFar && null != invokeCallback && isValidElement(invokeCallback) && null == invokeCallback.key && invokeCallback._store && !invokeCallback._store.validated && (escapedPrefix._store.validated = 2), callback = escapedPrefix), array.push(callback));
            return 1;
        }
        invokeCallback = 0;
        childKey = "" === nameSoFar ? "." : nameSoFar + ":";
        if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = childKey + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
        else if (i = getIteratorFn(children), "function" === typeof i) for(i === children.entries && (didWarnAboutMaps || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0), children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = childKey + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
        else if ("object" === type) {
            if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
            array = String(children);
            throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
        }
        return invokeCallback;
    }
    function mapChildren(children, func, context) {
        if (null == children) return children;
        var result = [], count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    function lazyInitializer(payload) {
        if (-1 === payload._status) {
            var ioInfo = payload._ioInfo;
            null != ioInfo && (ioInfo.start = ioInfo.end = performance.now());
            ioInfo = payload._result;
            var thenable = ioInfo();
            thenable.then(function(moduleObject) {
                if (0 === payload._status || -1 === payload._status) {
                    payload._status = 1;
                    payload._result = moduleObject;
                    var _ioInfo = payload._ioInfo;
                    null != _ioInfo && (_ioInfo.end = performance.now());
                    void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
                }
            }, function(error) {
                if (0 === payload._status || -1 === payload._status) {
                    payload._status = 2;
                    payload._result = error;
                    var _ioInfo2 = payload._ioInfo;
                    null != _ioInfo2 && (_ioInfo2.end = performance.now());
                    void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
                }
            });
            ioInfo = payload._ioInfo;
            if (null != ioInfo) {
                ioInfo.value = thenable;
                var displayName = thenable.displayName;
                "string" === typeof displayName && (ioInfo.name = displayName);
            }
            -1 === payload._status && (payload._status = 0, payload._result = thenable);
        }
        if (1 === payload._status) return ioInfo = payload._result, void 0 === ioInfo && console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", ioInfo), "default" in ioInfo || console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", ioInfo), ioInfo.default;
        throw payload._result;
    }
    function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
    }
    function enqueueTask(task) {
        if (null === enqueueTaskImpl) try {
            var requireString = ("require" + Math.random()).slice(0, 7);
            enqueueTaskImpl = (module && module[requireString]).call(module, "timers").setImmediate;
        } catch (_err) {
            enqueueTaskImpl = function(callback) {
                !1 === didWarnAboutMessageChannel && (didWarnAboutMessageChannel = !0, "undefined" === typeof MessageChannel && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(void 0);
            };
        }
        return enqueueTaskImpl(task);
    }
    function aggregateErrors(errors) {
        return 1 < errors.length && "function" === typeof AggregateError ? new AggregateError(errors) : errors[0];
    }
    function popActScope(prevActQueue, prevActScopeDepth) {
        prevActScopeDepth !== actScopeDepth - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactSharedInternals.actQueue;
        if (null !== queue) {
            if (0 !== queue.length) try {
                flushActQueue(queue);
                enqueueTask(function() {
                    return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                });
                return;
            } catch (error) {
                ReactSharedInternals.thrownErrors.push(error);
            }
            else ReactSharedInternals.actQueue = null;
        }
        0 < ReactSharedInternals.thrownErrors.length ? (queue = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(queue)) : resolve(returnValue);
    }
    function flushActQueue(queue) {
        if (!isFlushing) {
            isFlushing = !0;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do {
                        ReactSharedInternals.didUsePromise = !1;
                        var continuation = callback(!1);
                        if (null !== continuation) {
                            if (ReactSharedInternals.didUsePromise) {
                                queue[i] = callback;
                                queue.splice(0, i);
                                return;
                            }
                            callback = continuation;
                        } else break;
                    }while (1);
                }
                queue.length = 0;
            } catch (error) {
                queue.splice(0, i + 1), ReactSharedInternals.thrownErrors.push(error);
            } finally{
                isFlushing = !1;
            }
        }
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, didWarnStateUpdateForUnmountedComponent = {}, ReactNoopUpdateQueue = {
        isMounted: function() {
            return !1;
        },
        enqueueForceUpdate: function(publicInstance) {
            warnNoop(publicInstance, "forceUpdate");
        },
        enqueueReplaceState: function(publicInstance) {
            warnNoop(publicInstance, "replaceState");
        },
        enqueueSetState: function(publicInstance) {
            warnNoop(publicInstance, "setState");
        }
    }, assign = Object.assign, emptyObject = {};
    Object.freeze(emptyObject);
    Component.prototype.isReactComponent = {};
    Component.prototype.setState = function(partialState, callback) {
        if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    for(fnName in deprecatedAPIs)deprecatedAPIs.hasOwnProperty(fnName) && defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    ComponentDummy.prototype = Component.prototype;
    deprecatedAPIs = PureComponent.prototype = new ComponentDummy();
    deprecatedAPIs.constructor = PureComponent;
    assign(deprecatedAPIs, Component.prototype);
    deprecatedAPIs.isPureReactComponent = !0;
    var isArrayImpl = Array.isArray, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = {
        H: null,
        A: null,
        T: null,
        S: null,
        actQueue: null,
        asyncTransitions: 0,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
    }, hasOwnProperty = Object.prototype.hasOwnProperty, createTask = console.createTask ? console.createTask : function() {
        return null;
    };
    deprecatedAPIs = {
        react_stack_bottom_frame: function(callStackForError) {
            return callStackForError();
        }
    };
    var specialPropKeyWarningShown, didWarnAboutOldJSXRuntime;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = deprecatedAPIs.react_stack_bottom_frame.bind(deprecatedAPIs, UnknownOwner)();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutMaps = !1, userProvidedKeyEscapeRegex = /\/+/g, reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, didWarnAboutMessageChannel = !1, enqueueTaskImpl = null, actScopeDepth = 0, didWarnNoAwaitAct = !1, isFlushing = !1, queueSeveralMicrotasks = "function" === typeof queueMicrotask ? function(callback) {
        queueMicrotask(function() {
            return queueMicrotask(callback);
        });
    } : enqueueTask;
    deprecatedAPIs = Object.freeze({
        __proto__: null,
        c: function(size) {
            return resolveDispatcher().useMemoCache(size);
        }
    });
    var fnName = {
        map: mapChildren,
        forEach: function(children, forEachFunc, forEachContext) {
            mapChildren(children, function() {
                forEachFunc.apply(this, arguments);
            }, forEachContext);
        },
        count: function(children) {
            var n = 0;
            mapChildren(children, function() {
                n++;
            });
            return n;
        },
        toArray: function(children) {
            return mapChildren(children, function(child) {
                return child;
            }) || [];
        },
        only: function(children) {
            if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
            return children;
        }
    };
    exports.Activity = REACT_ACTIVITY_TYPE;
    exports.Children = fnName;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
    exports.__COMPILER_RUNTIME = deprecatedAPIs;
    exports.act = function(callback) {
        var prevActQueue = ReactSharedInternals.actQueue, prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        var queue = ReactSharedInternals.actQueue = null !== prevActQueue ? prevActQueue : [], didAwaitActCall = !1;
        try {
            var result = callback();
        } catch (error) {
            ReactSharedInternals.thrownErrors.push(error);
        }
        if (0 < ReactSharedInternals.thrownErrors.length) throw popActScope(prevActQueue, prevActScopeDepth), callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        if (null !== result && "object" === typeof result && "function" === typeof result.then) {
            var thenable = result;
            queueSeveralMicrotasks(function() {
                didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            });
            return {
                then: function(resolve, reject) {
                    didAwaitActCall = !0;
                    thenable.then(function(returnValue) {
                        popActScope(prevActQueue, prevActScopeDepth);
                        if (0 === prevActScopeDepth) {
                            try {
                                flushActQueue(queue), enqueueTask(function() {
                                    return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                                });
                            } catch (error$0) {
                                ReactSharedInternals.thrownErrors.push(error$0);
                            }
                            if (0 < ReactSharedInternals.thrownErrors.length) {
                                var _thrownError = aggregateErrors(ReactSharedInternals.thrownErrors);
                                ReactSharedInternals.thrownErrors.length = 0;
                                reject(_thrownError);
                            }
                        } else resolve(returnValue);
                    }, function(error) {
                        popActScope(prevActQueue, prevActScopeDepth);
                        0 < ReactSharedInternals.thrownErrors.length ? (error = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(error)) : reject(error);
                    });
                }
            };
        }
        var returnValue$jscomp$0 = result;
        popActScope(prevActQueue, prevActScopeDepth);
        0 === prevActScopeDepth && (flushActQueue(queue), 0 !== queue.length && queueSeveralMicrotasks(function() {
            didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
        }), ReactSharedInternals.actQueue = null);
        if (0 < ReactSharedInternals.thrownErrors.length) throw callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        return {
            then: function(resolve, reject) {
                didAwaitActCall = !0;
                0 === prevActScopeDepth ? (ReactSharedInternals.actQueue = queue, enqueueTask(function() {
                    return recursivelyFlushAsyncActWork(returnValue$jscomp$0, resolve, reject);
                })) : resolve(returnValue$jscomp$0);
            }
        };
    };
    exports.cache = function(fn) {
        return function() {
            return fn.apply(null, arguments);
        };
    };
    exports.cacheSignal = function() {
        return null;
    };
    exports.captureOwnerStack = function() {
        var getCurrentStack = ReactSharedInternals.getCurrentStack;
        return null === getCurrentStack ? null : getCurrentStack();
    };
    exports.cloneElement = function(element, config, children) {
        if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
        var props = assign({}, element.props), key = element.key, owner = element._owner;
        if (null != config) {
            var JSCompiler_inline_result;
            a: {
                if (hasOwnProperty.call(config, "ref") && (JSCompiler_inline_result = Object.getOwnPropertyDescriptor(config, "ref").get) && JSCompiler_inline_result.isReactWarning) {
                    JSCompiler_inline_result = !1;
                    break a;
                }
                JSCompiler_inline_result = void 0 !== config.ref;
            }
            JSCompiler_inline_result && (owner = getOwner());
            hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key);
            for(propName in config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
        }
        var propName = arguments.length - 2;
        if (1 === propName) props.children = children;
        else if (1 < propName) {
            JSCompiler_inline_result = Array(propName);
            for(var i = 0; i < propName; i++)JSCompiler_inline_result[i] = arguments[i + 2];
            props.children = JSCompiler_inline_result;
        }
        props = ReactElement(element.type, key, props, owner, element._debugStack, element._debugTask);
        for(key = 2; key < arguments.length; key++)validateChildKeys(arguments[key]);
        return props;
    };
    exports.createContext = function(defaultValue) {
        defaultValue = {
            $$typeof: REACT_CONTEXT_TYPE,
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        };
        defaultValue.Provider = defaultValue;
        defaultValue.Consumer = {
            $$typeof: REACT_CONSUMER_TYPE,
            _context: defaultValue
        };
        defaultValue._currentRenderer = null;
        defaultValue._currentRenderer2 = null;
        return defaultValue;
    };
    exports.createElement = function(type, config, children) {
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i]);
        i = {};
        var key = null;
        if (null != config) for(propName in didWarnAboutOldJSXRuntime || !("__self" in config) || "key" in config || (didWarnAboutOldJSXRuntime = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (i[propName] = config[propName]);
        var childrenLength = arguments.length - 2;
        if (1 === childrenLength) i.children = children;
        else if (1 < childrenLength) {
            for(var childArray = Array(childrenLength), _i = 0; _i < childrenLength; _i++)childArray[_i] = arguments[_i + 2];
            Object.freeze && Object.freeze(childArray);
            i.children = childArray;
        }
        if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === i[propName] && (i[propName] = childrenLength[propName]);
        key && defineKeyPropWarningGetter(i, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
        var propName = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        return ReactElement(type, key, i, getOwner(), propName ? Error("react-stack-top-frame") : unknownOwnerDebugStack, propName ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
    exports.createRef = function() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    };
    exports.forwardRef = function(render) {
        null != render && render.$$typeof === REACT_MEMO_TYPE ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : "function" !== typeof render ? console.error("forwardRef requires a render function but was given %s.", null === render ? "null" : typeof render) : 0 !== render.length && 2 !== render.length && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", 1 === render.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        null != render && null != render.defaultProps && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        }, ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                render.name || render.displayName || (Object.defineProperty(render, "name", {
                    value: name
                }), render.displayName = name);
            }
        });
        return elementType;
    };
    exports.isValidElement = isValidElement;
    exports.lazy = function(ctor) {
        ctor = {
            _status: -1,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: ctor,
            _init: lazyInitializer
        }, ioInfo = {
            name: "lazy",
            start: -1,
            end: -1,
            value: null,
            owner: null,
            debugStack: Error("react-stack-top-frame"),
            debugTask: console.createTask ? console.createTask("lazy()") : null
        };
        ctor._ioInfo = ioInfo;
        lazyType._debugInfo = [
            {
                awaited: ioInfo
            }
        ];
        return lazyType;
    };
    exports.memo = function(type, compare) {
        null == type && console.error("memo: The first argument must be a component. Instead received: %s", null === type ? "null" : typeof type);
        compare = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: void 0 === compare ? null : compare
        };
        var ownName;
        Object.defineProperty(compare, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                type.name || type.displayName || (Object.defineProperty(type, "name", {
                    value: name
                }), type.displayName = name);
            }
        });
        return compare;
    };
    exports.startTransition = function(scope) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition._updatedFibers = new Set();
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(noop, reportGlobalError));
        } catch (error) {
            reportGlobalError(error);
        } finally{
            null === prevTransition && currentTransition._updatedFibers && (scope = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < scope && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    };
    exports.unstable_useCacheRefresh = function() {
        return resolveDispatcher().useCacheRefresh();
    };
    exports.use = function(usable) {
        return resolveDispatcher().use(usable);
    };
    exports.useActionState = function(action, initialState, permalink) {
        return resolveDispatcher().useActionState(action, initialState, permalink);
    };
    exports.useCallback = function(callback, deps) {
        return resolveDispatcher().useCallback(callback, deps);
    };
    exports.useContext = function(Context) {
        var dispatcher = resolveDispatcher();
        Context.$$typeof === REACT_CONSUMER_TYPE && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?");
        return dispatcher.useContext(Context);
    };
    exports.useDebugValue = function(value, formatterFn) {
        return resolveDispatcher().useDebugValue(value, formatterFn);
    };
    exports.useDeferredValue = function(value, initialValue) {
        return resolveDispatcher().useDeferredValue(value, initialValue);
    };
    exports.useEffect = function(create, deps) {
        null == create && console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useEffect(create, deps);
    };
    exports.useEffectEvent = function(callback) {
        return resolveDispatcher().useEffectEvent(callback);
    };
    exports.useId = function() {
        return resolveDispatcher().useId();
    };
    exports.useImperativeHandle = function(ref, create, deps) {
        return resolveDispatcher().useImperativeHandle(ref, create, deps);
    };
    exports.useInsertionEffect = function(create, deps) {
        null == create && console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useInsertionEffect(create, deps);
    };
    exports.useLayoutEffect = function(create, deps) {
        null == create && console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useLayoutEffect(create, deps);
    };
    exports.useMemo = function(create, deps) {
        return resolveDispatcher().useMemo(create, deps);
    };
    exports.useOptimistic = function(passthrough, reducer) {
        return resolveDispatcher().useOptimistic(passthrough, reducer);
    };
    exports.useReducer = function(reducer, initialArg, init) {
        return resolveDispatcher().useReducer(reducer, initialArg, init);
    };
    exports.useRef = function(initialValue) {
        return resolveDispatcher().useRef(initialValue);
    };
    exports.useState = function(initialState) {
        return resolveDispatcher().useState(initialState);
    };
    exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
        return resolveDispatcher().useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    };
    exports.useTransition = function() {
        return resolveDispatcher().useTransition();
    };
    exports.version = "19.2.6";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

},{}],"527y0":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}
module.exports = require("2b53550ce04dc092");

},{"2b53550ce04dc092":"93NSH"}],"93NSH":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
(function() {
    function findHook(fiber, id) {
        for(fiber = fiber.memoizedState; null !== fiber && 0 < id;)fiber = fiber.next, id--;
        return fiber;
    }
    function copyWithSetImpl(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    }
    function copyWithRename(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) console.warn("copyWithRename() expects paths of the same length");
        else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                console.warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
            return copyWithRenameImpl(obj, oldPath, newPath, 0);
        }
    }
    function copyWithRenameImpl(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        index + 1 === oldPath.length ? (updated[newPath[index]] = updated[oldKey], isArrayImpl(updated) ? updated.splice(oldKey, 1) : delete updated[oldKey]) : updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    }
    function copyWithDeleteImpl(obj, path, index) {
        var key = path[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) return isArrayImpl(updated) ? updated.splice(key, 1) : delete updated[key], updated;
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    }
    function shouldSuspendImpl() {
        return !1;
    }
    function shouldErrorImpl() {
        return null;
    }
    function warnInvalidHookAccess() {
        console.error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks");
    }
    function warnInvalidContextAccess() {
        console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    }
    function noop() {}
    function warnForMissingKey() {}
    function setToSortedString(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    }
    function createFiber(tag, pendingProps, key, mode) {
        return new FiberNode(tag, pendingProps, key, mode);
    }
    function scheduleRoot(root, element) {
        root.context === emptyContextObject && (updateContainerImpl(root.current, 2, element, root, null, null), flushSyncWork$1());
    }
    function scheduleRefresh(root, update) {
        if (null !== resolveFamily) {
            var staleFamilies = update.staleFamilies;
            update = update.updatedFamilies;
            flushPendingEffects();
            scheduleFibersWithFamiliesRecursively(root.current, update, staleFamilies);
            flushSyncWork$1();
        }
    }
    function setRefreshHandler(handler) {
        resolveFamily = handler;
    }
    function isValidContainer(node) {
        return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
    }
    function getNearestMountedFiber(fiber) {
        var node = fiber, nearestMounted = fiber;
        if (fiber.alternate) for(; node.return;)node = node.return;
        else {
            fiber = node;
            do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
            while (fiber);
        }
        return 3 === node.tag ? nearestMounted : null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (13 === fiber.tag) {
            var suspenseState = fiber.memoizedState;
            null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
            if (null !== suspenseState) return suspenseState.dehydrated;
        }
        return null;
    }
    function getActivityInstanceFromFiber(fiber) {
        if (31 === fiber.tag) {
            var activityState = fiber.memoizedState;
            null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
            if (null !== activityState) return activityState.dehydrated;
        }
        return null;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            alternate = getNearestMountedFiber(fiber);
            if (null === alternate) throw Error("Unable to find node on an unmounted component.");
            return alternate !== fiber ? null : fiber;
        }
        for(var a = fiber, b = alternate;;){
            var parentA = a.return;
            if (null === parentA) break;
            var parentB = parentA.alternate;
            if (null === parentB) {
                b = parentA.return;
                if (null !== b) {
                    a = b;
                    continue;
                }
                break;
            }
            if (parentA.child === parentB.child) {
                for(parentB = parentA.child; parentB;){
                    if (parentB === a) return assertIsMounted(parentA), fiber;
                    if (parentB === b) return assertIsMounted(parentA), alternate;
                    parentB = parentB.sibling;
                }
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) a = parentA, b = parentB;
            else {
                for(var didFindChild = !1, _child = parentA.child; _child;){
                    if (_child === a) {
                        didFindChild = !0;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = !0;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    for(_child = parentB.child; _child;){
                        if (_child === a) {
                            didFindChild = !0;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = !0;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (3 !== a.tag) throw Error("Unable to find node on an unmounted component.");
        return a.stateNode.current === a ? fiber : alternate;
    }
    function findCurrentHostFiberImpl(node) {
        var tag = node.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
        for(node = node.child; null !== node;){
            tag = findCurrentHostFiberImpl(node);
            if (null !== tag) return tag;
            node = node.sibling;
        }
        return null;
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function getComponentNameFromOwner(owner) {
        return "number" === typeof owner.tag ? getComponentNameFromFiber(owner) : "string" === typeof owner.name ? owner.name : null;
    }
    function getComponentNameFromFiber(fiber) {
        var type = fiber.type;
        switch(fiber.tag){
            case 31:
                return "Activity";
            case 24:
                return "Cache";
            case 9:
                return (type._context.displayName || "Context") + ".Consumer";
            case 10:
                return type.displayName || "Context";
            case 18:
                return "DehydratedFragment";
            case 11:
                return fiber = type.render, fiber = fiber.displayName || fiber.name || "", type.displayName || ("" !== fiber ? "ForwardRef(" + fiber + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 26:
            case 27:
            case 5:
                return type;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return getComponentNameFromType(type);
            case 8:
                return type === REACT_STRICT_MODE_TYPE ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 14:
            case 15:
                if ("function" === typeof type) return type.displayName || type.name || null;
                if ("string" === typeof type) return type;
                break;
            case 29:
                type = fiber._debugInfo;
                if (null != type) {
                    for(var i = type.length - 1; 0 <= i; i--)if ("string" === typeof type[i].name) return type[i].name;
                }
                if (null !== fiber.return) return getComponentNameFromFiber(fiber.return);
        }
        return null;
    }
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        0 > index$jscomp$0 ? console.error("Unexpected pop.") : (fiber !== fiberStack[index$jscomp$0] && console.error("Unexpected Fiber popped."), cursor.current = valueStack[index$jscomp$0], valueStack[index$jscomp$0] = null, fiberStack[index$jscomp$0] = null, index$jscomp$0--);
    }
    function push(cursor, value, fiber) {
        index$jscomp$0++;
        valueStack[index$jscomp$0] = cursor.current;
        fiberStack[index$jscomp$0] = fiber;
        cursor.current = value;
    }
    function requiredContext(c) {
        null === c && console.error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        push(rootInstanceStackCursor, nextRootInstance, fiber);
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor, null, fiber);
        var nextRootContext = nextRootInstance.nodeType;
        switch(nextRootContext){
            case 9:
            case 11:
                nextRootContext = 9 === nextRootContext ? "#document" : "#fragment";
                nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? getOwnHostContext(nextRootInstance) : HostContextNamespaceNone : HostContextNamespaceNone;
                break;
            default:
                if (nextRootContext = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), nextRootInstance = getChildHostContextProd(nextRootInstance, nextRootContext);
                else switch(nextRootContext){
                    case "svg":
                        nextRootInstance = HostContextNamespaceSvg;
                        break;
                    case "math":
                        nextRootInstance = HostContextNamespaceMath;
                        break;
                    default:
                        nextRootInstance = HostContextNamespaceNone;
                }
        }
        nextRootContext = nextRootContext.toLowerCase();
        nextRootContext = updatedAncestorInfoDev(null, nextRootContext);
        nextRootContext = {
            context: nextRootInstance,
            ancestorInfo: nextRootContext
        };
        pop(contextStackCursor, fiber);
        push(contextStackCursor, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        return requiredContext(contextStackCursor.current);
    }
    function pushHostContext(fiber) {
        null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber, fiber);
        var context = requiredContext(contextStackCursor.current);
        var type = fiber.type;
        var nextContext = getChildHostContextProd(context.context, type);
        type = updatedAncestorInfoDev(context.ancestorInfo, type);
        nextContext = {
            context: nextContext,
            ancestorInfo: type
        };
        context !== nextContext && (push(contextFiberStackCursor, fiber, fiber), push(contextStackCursor, nextContext, fiber));
    }
    function popHostContext(fiber) {
        contextFiberStackCursor.current === fiber && (pop(contextStackCursor, fiber), pop(contextFiberStackCursor, fiber));
        hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor, fiber), HostTransitionContext._currentValue = NotPendingTransition);
    }
    function disabledLog() {}
    function disableLogs() {
        if (0 === disabledDepth) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
                configurable: !0,
                enumerable: !0,
                value: disabledLog,
                writable: !0
            };
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (0 === disabledDepth) {
            var props = {
                configurable: !0,
                enumerable: !0,
                writable: !0
            };
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        }
        0 > disabledDepth && console.error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    function formatOwnerStack(error) {
        var prevPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        error = error.stack;
        Error.prepareStackTrace = prevPrepareStackTrace;
        error.startsWith("Error: react-stack-top-frame\n") && (error = error.slice(29));
        prevPrepareStackTrace = error.indexOf("\n");
        -1 !== prevPrepareStackTrace && (error = error.slice(prevPrepareStackTrace + 1));
        prevPrepareStackTrace = error.indexOf("react_stack_bottom_frame");
        -1 !== prevPrepareStackTrace && (prevPrepareStackTrace = error.lastIndexOf("\n", prevPrepareStackTrace));
        if (-1 !== prevPrepareStackTrace) error = error.slice(0, prevPrepareStackTrace);
        else return "";
        return error;
    }
    function describeBuiltInComponentFrame(name) {
        if (void 0 === prefix) try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
            suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
        return "\n" + prefix + name + suffix;
    }
    function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (void 0 !== frame) return frame;
        reentry = !0;
        frame = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher = null;
        previousDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = null;
        disableLogs();
        try {
            var RunInRootFrame = {
                DetermineComponentFrameRoot: function() {
                    try {
                        if (construct) {
                            var Fake = function() {
                                throw Error();
                            };
                            Object.defineProperty(Fake.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            });
                            if ("object" === typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(Fake, []);
                                } catch (x) {
                                    var control = x;
                                }
                                Reflect.construct(fn, [], Fake);
                            } else {
                                try {
                                    Fake.call();
                                } catch (x$0) {
                                    control = x$0;
                                }
                                fn.call(Fake.prototype);
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (x$1) {
                                control = x$1;
                            }
                            (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                        }
                    } catch (sample) {
                        if (sample && control && "string" === typeof sample.stack) return [
                            sample.stack,
                            control.stack
                        ];
                    }
                    return [
                        null,
                        null
                    ];
                }
            };
            RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
            var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
            namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot"
            });
            var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
            if (sampleStack && controlStack) {
                var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
                for(_RunInRootFrame$Deter = namePropDescriptor = 0; namePropDescriptor < sampleLines.length && !sampleLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
                for(; _RunInRootFrame$Deter < controlLines.length && !controlLines[_RunInRootFrame$Deter].includes("DetermineComponentFrameRoot");)_RunInRootFrame$Deter++;
                if (namePropDescriptor === sampleLines.length || _RunInRootFrame$Deter === controlLines.length) for(namePropDescriptor = sampleLines.length - 1, _RunInRootFrame$Deter = controlLines.length - 1; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter && sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter];)_RunInRootFrame$Deter--;
                for(; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter; namePropDescriptor--, _RunInRootFrame$Deter--)if (sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                    if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
                        do if (namePropDescriptor--, _RunInRootFrame$Deter--, 0 > _RunInRootFrame$Deter || sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                            var _frame = "\n" + sampleLines[namePropDescriptor].replace(" at new ", " at ");
                            fn.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn.displayName));
                            "function" === typeof fn && componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                        while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
                    }
                    break;
                }
            }
        } finally{
            reentry = !1, ReactSharedInternals.H = previousDispatcher, reenableLogs(), Error.prepareStackTrace = frame;
        }
        sampleLines = (sampleLines = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(sampleLines) : "";
        "function" === typeof fn && componentFrameCache.set(fn, sampleLines);
        return sampleLines;
    }
    function describeFiber(fiber, childFiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return describeBuiltInComponentFrame(fiber.type);
            case 16:
                return describeBuiltInComponentFrame("Lazy");
            case 13:
                return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
            case 19:
                return describeBuiltInComponentFrame("SuspenseList");
            case 0:
            case 15:
                return describeNativeComponentFrame(fiber.type, !1);
            case 11:
                return describeNativeComponentFrame(fiber.type.render, !1);
            case 1:
                return describeNativeComponentFrame(fiber.type, !0);
            case 31:
                return describeBuiltInComponentFrame("Activity");
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "", previous = null;
            do {
                info += describeFiber(workInProgress, previous);
                var debugInfo = workInProgress._debugInfo;
                if (debugInfo) for(var i = debugInfo.length - 1; 0 <= i; i--){
                    var entry = debugInfo[i];
                    if ("string" === typeof entry.name) {
                        var JSCompiler_temp_const = info;
                        a: {
                            var name = entry.name, env = entry.env, location = entry.debugLocation;
                            if (null != location) {
                                var childStack = formatOwnerStack(location), idx = childStack.lastIndexOf("\n"), lastLine = -1 === idx ? childStack : childStack.slice(idx + 1);
                                if (-1 !== lastLine.indexOf(name)) {
                                    var JSCompiler_inline_result = "\n" + lastLine;
                                    break a;
                                }
                            }
                            JSCompiler_inline_result = describeBuiltInComponentFrame(name + (env ? " [" + env + "]" : ""));
                        }
                        info = JSCompiler_temp_const + JSCompiler_inline_result;
                    }
                }
                previous = workInProgress;
                workInProgress = workInProgress.return;
            }while (workInProgress);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function describeFunctionComponentFrameWithoutLineNumber(fn) {
        return (fn = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(fn) : "";
    }
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (null === current) return null;
        var owner = current._debugOwner;
        return null != owner ? getComponentNameFromOwner(owner) : null;
    }
    function getCurrentFiberStackInDev() {
        if (null === current) return "";
        var workInProgress = current;
        try {
            var info = "";
            6 === workInProgress.tag && (workInProgress = workInProgress.return);
            switch(workInProgress.tag){
                case 26:
                case 27:
                case 5:
                    info += describeBuiltInComponentFrame(workInProgress.type);
                    break;
                case 13:
                    info += describeBuiltInComponentFrame("Suspense");
                    break;
                case 19:
                    info += describeBuiltInComponentFrame("SuspenseList");
                    break;
                case 31:
                    info += describeBuiltInComponentFrame("Activity");
                    break;
                case 30:
                case 0:
                case 15:
                case 1:
                    workInProgress._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(workInProgress.type));
                    break;
                case 11:
                    workInProgress._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(workInProgress.type.render));
            }
            for(; workInProgress;)if ("number" === typeof workInProgress.tag) {
                var fiber = workInProgress;
                workInProgress = fiber._debugOwner;
                var debugStack = fiber._debugStack;
                if (workInProgress && debugStack) {
                    var formattedStack = formatOwnerStack(debugStack);
                    "" !== formattedStack && (info += "\n" + formattedStack);
                }
            } else if (null != workInProgress.debugStack) {
                var ownerStack = workInProgress.debugStack;
                (workInProgress = workInProgress.owner) && ownerStack && (info += "\n" + formatOwnerStack(ownerStack));
            } else break;
            var JSCompiler_inline_result = info;
        } catch (x) {
            JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
        }
        return JSCompiler_inline_result;
    }
    function runWithFiberInDEV(fiber, callback, arg0, arg1, arg2, arg3, arg4) {
        var previousFiber = current;
        setCurrentFiber(fiber);
        try {
            return null !== fiber && fiber._debugTask ? fiber._debugTask.run(callback.bind(null, arg0, arg1, arg2, arg3, arg4)) : callback(arg0, arg1, arg2, arg3, arg4);
        } finally{
            setCurrentFiber(previousFiber);
        }
        throw Error("runWithFiberInDEV should never be called in production. This is a bug in React.");
    }
    function setCurrentFiber(fiber) {
        ReactSharedInternals.getCurrentStack = null === fiber ? null : getCurrentFiberStackInDev;
        isRendering = !1;
        current = fiber;
    }
    function typeName(value) {
        return "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
    }
    function willCoercionThrow(value) {
        try {
            return testStringCoercion(value), !1;
        } catch (e) {
            return !0;
        }
    }
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) return console.error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.", attributeName, typeName(value)), testStringCoercion(value);
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) return console.error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.", propName, typeName(value)), testStringCoercion(value);
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) return console.error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.", typeName(value)), testStringCoercion(value);
    }
    function injectInternals(internals) {
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) return !0;
        if (!hook.supportsFiber) return console.error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"), !0;
        try {
            rendererID = hook.inject(internals), injectedHook = hook;
        } catch (err) {
            console.error("React instrumentation encountered an error: %o.", err);
        }
        return hook.checkDCE ? !0 : !1;
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
        if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
    }
    function clz32Fallback(x) {
        x >>>= 0;
        return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
    }
    function getHighestPriorityLanes(lanes) {
        var pendingSyncLanes = lanes & 42;
        if (0 !== pendingSyncLanes) return pendingSyncLanes;
        switch(lanes & -lanes){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
                return 64;
            case 128:
                return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
                return lanes & 261888;
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return lanes & 3932160;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return lanes & 62914560;
            case 67108864:
                return 67108864;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 0;
            default:
                return console.error("Should have found matching lanes. This is a bug in React."), lanes;
        }
    }
    function getNextLanes(root, wipLanes, rootHasPendingCommit) {
        var pendingLanes = root.pendingLanes;
        if (0 === pendingLanes) return 0;
        var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
        root = root.warmLanes;
        var nonIdlePendingLanes = pendingLanes & 134217727;
        0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
        return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
    }
    function checkIfRootIsPrerendering(root, renderLanes) {
        return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
                return currentTime + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return currentTime + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return console.error("Should have found matching lanes. This is a bug in React."), -1;
        }
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
        return lane;
    }
    function createLaneMap(initial) {
        for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated$1(root, updateLane) {
        root.pendingLanes |= updateLane;
        268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
    }
    function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
        var previouslyPendingLanes = root.pendingLanes;
        root.pendingLanes = remainingLanes;
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.warmLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        root.errorRecoveryDisabledLanes &= remainingLanes;
        root.shellSuspendCounter = 0;
        var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
        for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
            var index = 31 - clz32(remainingLanes), lane = 1 << index;
            entanglements[index] = 0;
            expirationTimes[index] = -1;
            var hiddenUpdatesForLane = hiddenUpdates[index];
            if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index] = null, index = 0; index < hiddenUpdatesForLane.length; index++){
                var update = hiddenUpdatesForLane[index];
                null !== update && (update.lane &= -536870913);
            }
            remainingLanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
        0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
    }
    function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
        root.pendingLanes |= spawnedLane;
        root.suspendedLanes &= ~spawnedLane;
        var spawnedLaneIndex = 31 - clz32(spawnedLane);
        root.entangledLanes |= spawnedLane;
        root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
    }
    function markRootEntangled(root, entangledLanes) {
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        for(root = root.entanglements; rootEntangledLanes;){
            var index = 31 - clz32(rootEntangledLanes), lane = 1 << index;
            lane & entangledLanes | root[index] & entangledLanes && (root[index] |= entangledLanes);
            rootEntangledLanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = renderLanes & -renderLanes;
        renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
        return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
    }
    function getBumpedLaneForHydrationByLane(lane) {
        switch(lane){
            case 2:
                lane = 1;
                break;
            case 8:
                lane = 4;
                break;
            case 32:
                lane = 16;
                break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                lane = 128;
                break;
            case 268435456:
                lane = 134217728;
                break;
            default:
                lane = 0;
        }
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (isDevToolsPresent) for(root = root.pendingUpdatersLaneMap; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index;
            root[index].add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (isDevToolsPresent) for(var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap, memoizedUpdaters = root.memoizedUpdaters; 0 < lanes;){
            var index = 31 - clz32(lanes);
            root = 1 << index;
            index = pendingUpdatersLaneMap[index];
            0 < index.size && (index.forEach(function(fiber) {
                var alternate = fiber.alternate;
                null !== alternate && memoizedUpdaters.has(alternate) || memoizedUpdaters.add(fiber);
            }), index.clear());
            lanes &= ~root;
        }
    }
    function lanesToEventPriority(lanes) {
        lanes &= -lanes;
        return 0 !== DiscreteEventPriority && DiscreteEventPriority < lanes ? 0 !== ContinuousEventPriority && ContinuousEventPriority < lanes ? 0 !== (lanes & 134217727) ? DefaultEventPriority : IdleEventPriority : ContinuousEventPriority : DiscreteEventPriority;
    }
    function resolveUpdatePriority() {
        var updatePriority = ReactDOMSharedInternals.p;
        if (0 !== updatePriority) return updatePriority;
        updatePriority = window.event;
        return void 0 === updatePriority ? DefaultEventPriority : getEventPriority(updatePriority.type);
    }
    function runWithPriority(priority, fn) {
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            return ReactDOMSharedInternals.p = priority, fn();
        } finally{
            ReactDOMSharedInternals.p = previousPriority;
        }
    }
    function detachDeletedInstance(node) {
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) return targetInst;
        for(var parentNode = targetNode.parentNode; parentNode;){
            if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
                parentNode = targetInst.alternate;
                if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentHydrationBoundary(targetNode); null !== targetNode;){
                    if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                    targetNode = getParentHydrationBoundary(targetNode);
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    function getInstanceFromNode(node) {
        if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
            var tag = node.tag;
            if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
        }
        return null;
    }
    function getNodeFromInstance(inst) {
        var tag = inst.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getResourcesFromRoot(root) {
        var resources = root[internalRootNodeResourcesKey];
        resources || (resources = root[internalRootNodeResourcesKey] = {
            hoistableStyles: new Map(),
            hoistableScripts: new Map()
        });
        return resources;
    }
    function markNodeAsHoistable(node) {
        node[internalHoistableMarker] = !0;
    }
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        registrationNameDependencies[registrationName] && console.error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        "onDoubleClick" === registrationName && (possibleRegistrationNames.ondblclick = registrationName);
        for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
    }
    function checkControlledValueProps(tagName, props) {
        hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || null == props.value || ("select" === tagName ? console.error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`.") : console.error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."));
        props.onChange || props.readOnly || props.disabled || null == props.checked || console.error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
        illegalAttributeNameCache[attributeName] = !0;
        console.error("Invalid attribute name: `%s`", attributeName);
        return !1;
    }
    function getValueForAttributeOnCustomComponent(node, name, expected) {
        if (isAttributeNameSafe(name)) {
            if (!node.hasAttribute(name)) {
                switch(typeof expected){
                    case "symbol":
                    case "object":
                        return expected;
                    case "function":
                        return expected;
                    case "boolean":
                        if (!1 === expected) return expected;
                }
                return void 0 === expected ? void 0 : null;
            }
            node = node.getAttribute(name);
            if ("" === node && !0 === expected) return !0;
            checkAttributeStringCoercion(expected, name);
            return node === "" + expected ? expected : node;
        }
    }
    function setValueForAttribute(node, name, value) {
        if (isAttributeNameSafe(name)) {
            if (null === value) node.removeAttribute(name);
            else {
                switch(typeof value){
                    case "undefined":
                    case "function":
                    case "symbol":
                        node.removeAttribute(name);
                        return;
                    case "boolean":
                        var prefix = name.toLowerCase().slice(0, 5);
                        if ("data-" !== prefix && "aria-" !== prefix) {
                            node.removeAttribute(name);
                            return;
                        }
                }
                checkAttributeStringCoercion(value, name);
                node.setAttribute(name, "" + value);
            }
        }
    }
    function setValueForKnownAttribute(node, name, value) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    node.removeAttribute(name);
                    return;
            }
            checkAttributeStringCoercion(value, name);
            node.setAttribute(name, "" + value);
        }
    }
    function setValueForNamespacedAttribute(node, namespace, name, value) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    node.removeAttribute(name);
                    return;
            }
            checkAttributeStringCoercion(value, name);
            node.setAttributeNS(namespace, name, "" + value);
        }
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                return checkFormFieldValueStringCoercion(value), value;
            default:
                return "";
        }
    }
    function isCheckable(elem) {
        var type = elem.type;
        return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
    }
    function trackValueOnNode(node, valueField, currentValue) {
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
            var get = descriptor.get, set = descriptor.set;
            Object.defineProperty(node, valueField, {
                configurable: !0,
                get: function() {
                    return get.call(this);
                },
                set: function(value) {
                    checkFormFieldValueStringCoercion(value);
                    currentValue = "" + value;
                    set.call(this, value);
                }
            });
            Object.defineProperty(node, valueField, {
                enumerable: descriptor.enumerable
            });
            return {
                getValue: function() {
                    return currentValue;
                },
                setValue: function(value) {
                    checkFormFieldValueStringCoercion(value);
                    currentValue = "" + value;
                },
                stopTracking: function() {
                    node._valueTracker = null;
                    delete node[valueField];
                }
            };
        }
    }
    function track(node) {
        if (!node._valueTracker) {
            var valueField = isCheckable(node) ? "checked" : "value";
            node._valueTracker = trackValueOnNode(node, valueField, "" + node[valueField]);
        }
    }
    function updateValueIfChanged(node) {
        if (!node) return !1;
        var tracker = node._valueTracker;
        if (!tracker) return !0;
        var lastValue = tracker.getValue();
        var value = "";
        node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
        node = value;
        return node !== lastValue ? (tracker.setValue(node), !0) : !1;
    }
    function getActiveElement(doc) {
        doc = doc || ("undefined" !== typeof document ? document : void 0);
        if ("undefined" === typeof doc) return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
        return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
            return "\\" + ch.charCodeAt(0).toString(16) + " ";
        });
    }
    function validateInputProps(element, props) {
        void 0 === props.checked || void 0 === props.defaultChecked || didWarnCheckedDefaultChecked || (console.error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type), didWarnCheckedDefaultChecked = !0);
        void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue$1 || (console.error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type), didWarnValueDefaultValue$1 = !0);
    }
    function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
        element.name = "";
        null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? (checkAttributeStringCoercion(type, "type"), element.type = type) : element.removeAttribute("type");
        if (null != value) {
            if ("number" === type) {
                if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
            } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
        } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
        null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
        null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
        null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
        null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? (checkAttributeStringCoercion(name, "name"), element.name = "" + getToStringValue(name)) : element.removeAttribute("name");
    }
    function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
        null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (checkAttributeStringCoercion(type, "type"), element.type = type);
        if (null != value || null != defaultValue) {
            if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
                track(element);
                return;
            }
            defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
            value = null != value ? "" + getToStringValue(value) : defaultValue;
            isHydrating || value === element.value || (element.value = value);
            element.defaultValue = value;
        }
        checked = null != checked ? checked : defaultChecked;
        checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
        element.checked = isHydrating ? element.checked : !!checked;
        element.defaultChecked = !!checked;
        null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (checkAttributeStringCoercion(name, "name"), element.name = name);
        track(element);
    }
    function setDefaultValue(node, type, value) {
        "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
    }
    function validateOptionProps(element, props) {
        null == props.value && ("object" === typeof props.children && null !== props.children ? React.Children.forEach(props.children, function(child) {
            null == child || "string" === typeof child || "number" === typeof child || "bigint" === typeof child || didWarnInvalidChild || (didWarnInvalidChild = !0, console.error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."));
        }) : null == props.dangerouslySetInnerHTML || didWarnInvalidInnerHTML || (didWarnInvalidInnerHTML = !0, console.error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")));
        null == props.selected || didWarnSelectedSetOnOption || (console.error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), didWarnSelectedSetOnOption = !0);
    }
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        return ownerName ? "\n\nCheck the render method of `" + ownerName + "`." : "";
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        node = node.options;
        if (multiple) {
            multiple = {};
            for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
            for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
        } else {
            propValue = "" + getToStringValue(propValue);
            multiple = null;
            for(i = 0; i < node.length; i++){
                if (node[i].value === propValue) {
                    node[i].selected = !0;
                    setDefaultSelected && (node[i].defaultSelected = !0);
                    return;
                }
                null !== multiple || node[i].disabled || (multiple = node[i]);
            }
            null !== multiple && (multiple.selected = !0);
        }
    }
    function validateSelectProps(element, props) {
        for(element = 0; element < valuePropNames.length; element++){
            var propName = valuePropNames[element];
            if (null != props[propName]) {
                var propNameIsArray = isArrayImpl(props[propName]);
                props.multiple && !propNameIsArray ? console.error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum()) : !props.multiple && propNameIsArray && console.error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
            }
        }
        void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue || (console.error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"), didWarnValueDefaultValue = !0);
    }
    function validateTextareaProps(element, props) {
        void 0 === props.value || void 0 === props.defaultValue || didWarnValDefaultVal || (console.error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component"), didWarnValDefaultVal = !0);
        null != props.children && null == props.value && console.error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
    }
    function updateTextarea(element, value, defaultValue) {
        if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
            element.defaultValue !== value && (element.defaultValue = value);
            return;
        }
        element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
    }
    function initTextarea(element, value, defaultValue, children) {
        if (null == value) {
            if (null != children) {
                if (null != defaultValue) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArrayImpl(children)) {
                    if (1 < children.length) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            null == defaultValue && (defaultValue = "");
            value = defaultValue;
        }
        defaultValue = getToStringValue(value);
        element.defaultValue = defaultValue;
        children = element.textContent;
        children === defaultValue && "" !== children && null !== children && (element.value = children);
        track(element);
    }
    function findNotableNode(node, indent) {
        return void 0 === node.serverProps && 0 === node.serverTail.length && 1 === node.children.length && 3 < node.distanceFromLeaf && node.distanceFromLeaf > 15 - indent ? findNotableNode(node.children[0], indent) : node;
    }
    function indentation(indent) {
        return "  " + "  ".repeat(indent);
    }
    function added(indent) {
        return "+ " + "  ".repeat(indent);
    }
    function removed(indent) {
        return "- " + "  ".repeat(indent);
    }
    function describeFiberType(fiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return fiber.type;
            case 16:
                return "Lazy";
            case 31:
                return "Activity";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 0:
            case 15:
                return fiber = fiber.type, fiber.displayName || fiber.name || null;
            case 11:
                return fiber = fiber.type.render, fiber.displayName || fiber.name || null;
            case 1:
                return fiber = fiber.type, fiber.displayName || fiber.name || null;
            default:
                return null;
        }
    }
    function describeTextNode(content, maxLength) {
        return needsEscaping.test(content) ? (content = JSON.stringify(content), content.length > maxLength - 2 ? 8 > maxLength ? '{"..."}' : "{" + content.slice(0, maxLength - 7) + '..."}' : "{" + content + "}") : content.length > maxLength ? 5 > maxLength ? '{"..."}' : content.slice(0, maxLength - 3) + "..." : content;
    }
    function describeTextDiff(clientText, serverProps, indent) {
        var maxLength = 120 - 2 * indent;
        if (null === serverProps) return added(indent) + describeTextNode(clientText, maxLength) + "\n";
        if ("string" === typeof serverProps) {
            for(var firstDiff = 0; firstDiff < serverProps.length && firstDiff < clientText.length && serverProps.charCodeAt(firstDiff) === clientText.charCodeAt(firstDiff); firstDiff++);
            firstDiff > maxLength - 8 && 10 < firstDiff && (clientText = "..." + clientText.slice(firstDiff - 8), serverProps = "..." + serverProps.slice(firstDiff - 8));
            return added(indent) + describeTextNode(clientText, maxLength) + "\n" + removed(indent) + describeTextNode(serverProps, maxLength) + "\n";
        }
        return indentation(indent) + describeTextNode(clientText, maxLength) + "\n";
    }
    function objectName(object) {
        return Object.prototype.toString.call(object).replace(/^\[object (.*)\]$/, function(m, p0) {
            return p0;
        });
    }
    function describeValue(value, maxLength) {
        switch(typeof value){
            case "string":
                return value = JSON.stringify(value), value.length > maxLength ? 5 > maxLength ? '"..."' : value.slice(0, maxLength - 4) + '..."' : value;
            case "object":
                if (null === value) return "null";
                if (isArrayImpl(value)) return "[...]";
                if (value.$$typeof === REACT_ELEMENT_TYPE) return (maxLength = getComponentNameFromType(value.type)) ? "<" + maxLength + ">" : "<...>";
                var name = objectName(value);
                if ("Object" === name) {
                    name = "";
                    maxLength -= 2;
                    for(var propName in value)if (value.hasOwnProperty(propName)) {
                        var jsonPropName = JSON.stringify(propName);
                        jsonPropName !== '"' + propName + '"' && (propName = jsonPropName);
                        maxLength -= propName.length - 2;
                        jsonPropName = describeValue(value[propName], 15 > maxLength ? maxLength : 15);
                        maxLength -= jsonPropName.length;
                        if (0 > maxLength) {
                            name += "" === name ? "..." : ", ...";
                            break;
                        }
                        name += ("" === name ? "" : ",") + propName + ":" + jsonPropName;
                    }
                    return "{" + name + "}";
                }
                return name;
            case "function":
                return (maxLength = value.displayName || value.name) ? "function " + maxLength : "function";
            default:
                return String(value);
        }
    }
    function describePropValue(value, maxLength) {
        return "string" !== typeof value || needsEscaping.test(value) ? "{" + describeValue(value, maxLength - 2) + "}" : value.length > maxLength - 2 ? 5 > maxLength ? '"..."' : '"' + value.slice(0, maxLength - 5) + '..."' : '"' + value + '"';
    }
    function describeExpandedElement(type, props, rowPrefix) {
        var remainingRowLength = 120 - rowPrefix.length - type.length, properties = [], propName;
        for(propName in props)if (props.hasOwnProperty(propName) && "children" !== propName) {
            var propValue = describePropValue(props[propName], 120 - rowPrefix.length - propName.length - 1);
            remainingRowLength -= propName.length + propValue.length + 2;
            properties.push(propName + "=" + propValue);
        }
        return 0 === properties.length ? rowPrefix + "<" + type + ">\n" : 0 < remainingRowLength ? rowPrefix + "<" + type + " " + properties.join(" ") + ">\n" : rowPrefix + "<" + type + "\n" + rowPrefix + "  " + properties.join("\n" + rowPrefix + "  ") + "\n" + rowPrefix + ">\n";
    }
    function describePropertiesDiff(clientObject, serverObject, indent) {
        var properties = "", remainingServerProperties = assign({}, serverObject), propName;
        for(propName in clientObject)if (clientObject.hasOwnProperty(propName)) {
            delete remainingServerProperties[propName];
            var maxLength = 120 - 2 * indent - propName.length - 2, clientPropValue = describeValue(clientObject[propName], maxLength);
            serverObject.hasOwnProperty(propName) ? (maxLength = describeValue(serverObject[propName], maxLength), properties += added(indent) + propName + ": " + clientPropValue + "\n", properties += removed(indent) + propName + ": " + maxLength + "\n") : properties += added(indent) + propName + ": " + clientPropValue + "\n";
        }
        for(var _propName in remainingServerProperties)remainingServerProperties.hasOwnProperty(_propName) && (clientObject = describeValue(remainingServerProperties[_propName], 120 - 2 * indent - _propName.length - 2), properties += removed(indent) + _propName + ": " + clientObject + "\n");
        return properties;
    }
    function describeElementDiff(type, clientProps, serverProps, indent) {
        var content = "", serverPropNames = new Map();
        for(propName$jscomp$0 in serverProps)serverProps.hasOwnProperty(propName$jscomp$0) && serverPropNames.set(propName$jscomp$0.toLowerCase(), propName$jscomp$0);
        if (1 === serverPropNames.size && serverPropNames.has("children")) content += describeExpandedElement(type, clientProps, indentation(indent));
        else {
            for(var _propName2 in clientProps)if (clientProps.hasOwnProperty(_propName2) && "children" !== _propName2) {
                var maxLength$jscomp$0 = 120 - 2 * (indent + 1) - _propName2.length - 1, serverPropName = serverPropNames.get(_propName2.toLowerCase());
                if (void 0 !== serverPropName) {
                    serverPropNames.delete(_propName2.toLowerCase());
                    var propName$jscomp$0 = clientProps[_propName2];
                    serverPropName = serverProps[serverPropName];
                    var clientPropValue = describePropValue(propName$jscomp$0, maxLength$jscomp$0);
                    maxLength$jscomp$0 = describePropValue(serverPropName, maxLength$jscomp$0);
                    "object" === typeof propName$jscomp$0 && null !== propName$jscomp$0 && "object" === typeof serverPropName && null !== serverPropName && "Object" === objectName(propName$jscomp$0) && "Object" === objectName(serverPropName) && (2 < Object.keys(propName$jscomp$0).length || 2 < Object.keys(serverPropName).length || -1 < clientPropValue.indexOf("...") || -1 < maxLength$jscomp$0.indexOf("...")) ? content += indentation(indent + 1) + _propName2 + "={{\n" + describePropertiesDiff(propName$jscomp$0, serverPropName, indent + 2) + indentation(indent + 1) + "}}\n" : (content += added(indent + 1) + _propName2 + "=" + clientPropValue + "\n", content += removed(indent + 1) + _propName2 + "=" + maxLength$jscomp$0 + "\n");
                } else content += indentation(indent + 1) + _propName2 + "=" + describePropValue(clientProps[_propName2], maxLength$jscomp$0) + "\n";
            }
            serverPropNames.forEach(function(propName) {
                if ("children" !== propName) {
                    var maxLength = 120 - 2 * (indent + 1) - propName.length - 1;
                    content += removed(indent + 1) + propName + "=" + describePropValue(serverProps[propName], maxLength) + "\n";
                }
            });
            content = "" === content ? indentation(indent) + "<" + type + ">\n" : indentation(indent) + "<" + type + "\n" + content + indentation(indent) + ">\n";
        }
        type = serverProps.children;
        clientProps = clientProps.children;
        if ("string" === typeof type || "number" === typeof type || "bigint" === typeof type) {
            serverPropNames = "";
            if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps) serverPropNames = "" + clientProps;
            content += describeTextDiff(serverPropNames, "" + type, indent + 1);
        } else if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps) content = null == type ? content + describeTextDiff("" + clientProps, null, indent + 1) : content + describeTextDiff("" + clientProps, void 0, indent + 1);
        return content;
    }
    function describeSiblingFiber(fiber, indent) {
        var type = describeFiberType(fiber);
        if (null === type) {
            type = "";
            for(fiber = fiber.child; fiber;)type += describeSiblingFiber(fiber, indent), fiber = fiber.sibling;
            return type;
        }
        return indentation(indent) + "<" + type + ">\n";
    }
    function describeNode(node, indent) {
        var skipToNode = findNotableNode(node, indent);
        if (skipToNode !== node && (1 !== node.children.length || node.children[0] !== skipToNode)) return indentation(indent) + "...\n" + describeNode(skipToNode, indent + 1);
        skipToNode = "";
        var debugInfo = node.fiber._debugInfo;
        if (debugInfo) for(var i = 0; i < debugInfo.length; i++){
            var serverComponentName = debugInfo[i].name;
            "string" === typeof serverComponentName && (skipToNode += indentation(indent) + "<" + serverComponentName + ">\n", indent++);
        }
        debugInfo = "";
        i = node.fiber.pendingProps;
        if (6 === node.fiber.tag) debugInfo = describeTextDiff(i, node.serverProps, indent), indent++;
        else if (serverComponentName = describeFiberType(node.fiber), null !== serverComponentName) {
            if (void 0 === node.serverProps) {
                debugInfo = indent;
                var maxLength = 120 - 2 * debugInfo - serverComponentName.length - 2, content = "";
                for(propName in i)if (i.hasOwnProperty(propName) && "children" !== propName) {
                    var propValue = describePropValue(i[propName], 15);
                    maxLength -= propName.length + propValue.length + 2;
                    if (0 > maxLength) {
                        content += " ...";
                        break;
                    }
                    content += " " + propName + "=" + propValue;
                }
                debugInfo = indentation(debugInfo) + "<" + serverComponentName + content + ">\n";
                indent++;
            } else null === node.serverProps ? (debugInfo = describeExpandedElement(serverComponentName, i, added(indent)), indent++) : "string" === typeof node.serverProps ? console.error("Should not have matched a non HostText fiber to a Text node. This is a bug in React.") : (debugInfo = describeElementDiff(serverComponentName, i, node.serverProps, indent), indent++);
        }
        var propName = "";
        i = node.fiber.child;
        for(serverComponentName = 0; i && serverComponentName < node.children.length;)maxLength = node.children[serverComponentName], maxLength.fiber === i ? (propName += describeNode(maxLength, indent), serverComponentName++) : propName += describeSiblingFiber(i, indent), i = i.sibling;
        i && 0 < node.children.length && (propName += indentation(indent) + "...\n");
        i = node.serverTail;
        null === node.serverProps && indent--;
        for(node = 0; node < i.length; node++)serverComponentName = i[node], propName = "string" === typeof serverComponentName ? propName + (removed(indent) + describeTextNode(serverComponentName, 120 - 2 * indent) + "\n") : propName + describeExpandedElement(serverComponentName.type, serverComponentName.props, removed(indent));
        return skipToNode + debugInfo + propName;
    }
    function describeDiff(rootNode) {
        try {
            return "\n\n" + describeNode(rootNode, 0);
        } catch (x) {
            return "";
        }
    }
    function describeAncestors(ancestor, child, props) {
        for(var fiber = child, node = null, distanceFromLeaf = 0; fiber;)fiber === ancestor && (distanceFromLeaf = 0), node = {
            fiber: fiber,
            children: null !== node ? [
                node
            ] : [],
            serverProps: fiber === child ? props : fiber === ancestor ? null : void 0,
            serverTail: [],
            distanceFromLeaf: distanceFromLeaf
        }, distanceFromLeaf++, fiber = fiber.return;
        return null !== node ? describeDiff(node).replaceAll(/^[+-]/gm, ">") : "";
    }
    function updatedAncestorInfoDev(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfoDev), info = {
            tag: tag
        };
        -1 !== inScopeTags.indexOf(tag) && (ancestorInfo.aTagInScope = null, ancestorInfo.buttonTagInScope = null, ancestorInfo.nobrTagInScope = null);
        -1 !== buttonScopeTags.indexOf(tag) && (ancestorInfo.pTagInButtonScope = null);
        -1 !== specialTags.indexOf(tag) && "address" !== tag && "div" !== tag && "p" !== tag && (ancestorInfo.listItemTagAutoclosing = null, ancestorInfo.dlItemTagAutoclosing = null);
        ancestorInfo.current = info;
        "form" === tag && (ancestorInfo.formTag = info);
        "a" === tag && (ancestorInfo.aTagInScope = info);
        "button" === tag && (ancestorInfo.buttonTagInScope = info);
        "nobr" === tag && (ancestorInfo.nobrTagInScope = info);
        "p" === tag && (ancestorInfo.pTagInButtonScope = info);
        "li" === tag && (ancestorInfo.listItemTagAutoclosing = info);
        if ("dd" === tag || "dt" === tag) ancestorInfo.dlItemTagAutoclosing = info;
        "#document" === tag || "html" === tag ? ancestorInfo.containerTagInScope = null : ancestorInfo.containerTagInScope || (ancestorInfo.containerTagInScope = info);
        null !== oldInfo || "#document" !== tag && "html" !== tag && "body" !== tag ? !0 === ancestorInfo.implicitRootScope && (ancestorInfo.implicitRootScope = !1) : ancestorInfo.implicitRootScope = !0;
        return ancestorInfo;
    }
    function isTagValidWithParent(tag, parentTag, implicitRootScope) {
        switch(parentTag){
            case "select":
                return "hr" === tag || "option" === tag || "optgroup" === tag || "script" === tag || "template" === tag || "#text" === tag;
            case "optgroup":
                return "option" === tag || "#text" === tag;
            case "option":
                return "#text" === tag;
            case "tr":
                return "th" === tag || "td" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "tbody":
            case "thead":
            case "tfoot":
                return "tr" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "colgroup":
                return "col" === tag || "template" === tag;
            case "table":
                return "caption" === tag || "colgroup" === tag || "tbody" === tag || "tfoot" === tag || "thead" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "head":
                return "base" === tag || "basefont" === tag || "bgsound" === tag || "link" === tag || "meta" === tag || "title" === tag || "noscript" === tag || "noframes" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "html":
                if (implicitRootScope) break;
                return "head" === tag || "body" === tag || "frameset" === tag;
            case "frameset":
                return "frame" === tag;
            case "#document":
                if (!implicitRootScope) return "html" === tag;
        }
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return "h1" !== parentTag && "h2" !== parentTag && "h3" !== parentTag && "h4" !== parentTag && "h5" !== parentTag && "h6" !== parentTag;
            case "rp":
            case "rt":
                return -1 === impliedEndTags.indexOf(parentTag);
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                return null == parentTag;
            case "head":
                return implicitRootScope || null === parentTag;
            case "html":
                return implicitRootScope && "#document" === parentTag || null === parentTag;
            case "body":
                return implicitRootScope && ("#document" === parentTag || "html" === parentTag) || null === parentTag;
        }
        return !0;
    }
    function findInvalidAncestorForTag(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    }
    function findAncestor(parent, tagName) {
        for(; parent;){
            switch(parent.tag){
                case 5:
                case 26:
                case 27:
                    if (parent.type === tagName) return parent;
            }
            parent = parent.return;
        }
        return null;
    }
    function validateDOMNesting(childTag, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfoDev;
        var parentInfo = ancestorInfo.current;
        ancestorInfo = (parentInfo = isTagValidWithParent(childTag, parentInfo && parentInfo.tag, ancestorInfo.implicitRootScope) ? null : parentInfo) ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        ancestorInfo = parentInfo || ancestorInfo;
        if (!ancestorInfo) return !0;
        var ancestorTag = ancestorInfo.tag;
        ancestorInfo = String(!!parentInfo) + "|" + childTag + "|" + ancestorTag;
        if (didWarn[ancestorInfo]) return !1;
        didWarn[ancestorInfo] = !0;
        var ancestor = (ancestorInfo = current) ? findAncestor(ancestorInfo.return, ancestorTag) : null, ancestorDescription = null !== ancestorInfo && null !== ancestor ? describeAncestors(ancestor, ancestorInfo, null) : "", tagDisplayName = "<" + childTag + ">";
        parentInfo ? (parentInfo = "", "table" === ancestorTag && "tr" === childTag && (parentInfo += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error("In HTML, %s cannot be a child of <%s>.%s\nThis will cause a hydration error.%s", tagDisplayName, ancestorTag, parentInfo, ancestorDescription)) : console.error("In HTML, %s cannot be a descendant of <%s>.\nThis will cause a hydration error.%s", tagDisplayName, ancestorTag, ancestorDescription);
        ancestorInfo && (childTag = ancestorInfo.return, null === ancestor || null === childTag || ancestor === childTag && childTag._debugOwner === ancestorInfo._debugOwner || runWithFiberInDEV(ancestor, function() {
            console.error("<%s> cannot contain a nested %s.\nSee this log for the ancestor stack trace.", ancestorTag, tagDisplayName);
        }));
        return !1;
    }
    function validateTextNesting(childText, parentTag, implicitRootScope) {
        if (implicitRootScope || isTagValidWithParent("#text", parentTag, !1)) return !0;
        implicitRootScope = "#text|" + parentTag;
        if (didWarn[implicitRootScope]) return !1;
        didWarn[implicitRootScope] = !0;
        var ancestor = (implicitRootScope = current) ? findAncestor(implicitRootScope, parentTag) : null;
        implicitRootScope = null !== implicitRootScope && null !== ancestor ? describeAncestors(ancestor, implicitRootScope, 6 !== implicitRootScope.tag ? {
            children: null
        } : null) : "";
        /\S/.test(childText) ? console.error("In HTML, text nodes cannot be a child of <%s>.\nThis will cause a hydration error.%s", parentTag, implicitRootScope) : console.error("In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.\nThis will cause a hydration error.%s", parentTag, implicitRootScope);
        return !1;
    }
    function setTextContent(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    }
    function camelize(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    }
    function setValueForStyle(style, styleName, value) {
        var isCustomProperty = 0 === styleName.indexOf("--");
        isCustomProperty || (-1 < styleName.indexOf("-") ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = !0, console.error("Unsupported style property %s. Did you mean %s?", styleName, camelize(styleName.replace(msPattern, "ms-")))) : badVendoredStyleNamePattern.test(styleName) ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = !0, console.error("Unsupported vendor-prefixed style property %s. Did you mean %s?", styleName, styleName.charAt(0).toUpperCase() + styleName.slice(1))) : !badStyleValueWithSemicolonPattern.test(value) || warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value] || (warnedStyleValues[value] = !0, console.error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', styleName, value.replace(badStyleValueWithSemicolonPattern, ""))), "number" === typeof value && (isNaN(value) ? warnedForNaNValue || (warnedForNaNValue = !0, console.error("`NaN` is an invalid value for the `%s` css style property.", styleName)) : isFinite(value) || warnedForInfinityValue || (warnedForInfinityValue = !0, console.error("`Infinity` is an invalid value for the `%s` css style property.", styleName))));
        null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : (checkCSSPropertyStringCoercion(value, styleName), style[styleName] = ("" + value).trim()) : style[styleName] = value + "px";
    }
    function setValueForStyles(node, styles, prevStyles) {
        if (null != styles && "object" !== typeof styles) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        styles && Object.freeze(styles);
        node = node.style;
        if (null != prevStyles) {
            if (styles) {
                var expandedUpdates = {};
                if (prevStyles) {
                    for(var key in prevStyles)if (prevStyles.hasOwnProperty(key) && !styles.hasOwnProperty(key)) for(var longhands = shorthandToLonghand[key] || [
                        key
                    ], i = 0; i < longhands.length; i++)expandedUpdates[longhands[i]] = key;
                }
                for(var _key in styles)if (styles.hasOwnProperty(_key) && (!prevStyles || prevStyles[_key] !== styles[_key])) for(key = shorthandToLonghand[_key] || [
                    _key
                ], longhands = 0; longhands < key.length; longhands++)expandedUpdates[key[longhands]] = _key;
                _key = {};
                for(var key$jscomp$0 in styles)for(key = shorthandToLonghand[key$jscomp$0] || [
                    key$jscomp$0
                ], longhands = 0; longhands < key.length; longhands++)_key[key[longhands]] = key$jscomp$0;
                key$jscomp$0 = {};
                for(var _key2 in expandedUpdates)if (key = expandedUpdates[_key2], (longhands = _key[_key2]) && key !== longhands && (i = key + "," + longhands, !key$jscomp$0[i])) {
                    key$jscomp$0[i] = !0;
                    i = console;
                    var value = styles[key];
                    i.error.call(i, "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", null == value || "boolean" === typeof value || "" === value ? "Removing" : "Updating", key, longhands);
                }
            }
            for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
            for(var _styleName in styles)_key2 = styles[_styleName], styles.hasOwnProperty(_styleName) && prevStyles[_styleName] !== _key2 && setValueForStyle(node, _styleName, _key2);
        } else for(expandedUpdates in styles)styles.hasOwnProperty(expandedUpdates) && setValueForStyle(node, expandedUpdates, styles[expandedUpdates]);
    }
    function isCustomElement(tagName) {
        if (-1 === tagName.indexOf("-")) return !1;
        switch(tagName){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return !1;
            default:
                return !0;
        }
    }
    function getAttributeAlias(name) {
        return aliases.get(name) || name;
    }
    function validateProperty$1(tagName, name) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return !0;
        if (rARIACamel$1.test(name)) {
            tagName = "aria-" + name.slice(4).toLowerCase();
            tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
            if (null == tagName) return console.error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name), warnedProperties$1[name] = !0;
            if (name !== tagName) return console.error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, tagName), warnedProperties$1[name] = !0;
        }
        if (rARIA$1.test(name)) {
            tagName = name.toLowerCase();
            tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
            if (null == tagName) return warnedProperties$1[name] = !0, !1;
            name !== tagName && (console.error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, tagName), warnedProperties$1[name] = !0);
        }
        return !0;
    }
    function validateProperties$2(type, props) {
        var invalidProps = [], key;
        for(key in props)validateProperty$1(type, key) || invalidProps.push(key);
        props = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        1 === invalidProps.length ? console.error("Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", props, type) : 1 < invalidProps.length && console.error("Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", props, type);
    }
    function validateProperty(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return !0;
        var lowerCasedName = name.toLowerCase();
        if ("onfocusin" === lowerCasedName || "onfocusout" === lowerCasedName) return console.error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), warnedProperties[name] = !0;
        if ("function" === typeof value && ("form" === tagName && "action" === name || "input" === tagName && "formAction" === name || "button" === tagName && "formAction" === name)) return !0;
        if (null != eventRegistry) {
            tagName = eventRegistry.possibleRegistrationNames;
            if (eventRegistry.registrationNameDependencies.hasOwnProperty(name)) return !0;
            eventRegistry = tagName.hasOwnProperty(lowerCasedName) ? tagName[lowerCasedName] : null;
            if (null != eventRegistry) return console.error("Invalid event handler property `%s`. Did you mean `%s`?", name, eventRegistry), warnedProperties[name] = !0;
            if (EVENT_NAME_REGEX.test(name)) return console.error("Unknown event handler property `%s`. It will be ignored.", name), warnedProperties[name] = !0;
        } else if (EVENT_NAME_REGEX.test(name)) return INVALID_EVENT_NAME_REGEX.test(name) && console.error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name), warnedProperties[name] = !0;
        if (rARIA.test(name) || rARIACamel.test(name)) return !0;
        if ("innerhtml" === lowerCasedName) return console.error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), warnedProperties[name] = !0;
        if ("aria" === lowerCasedName) return console.error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), warnedProperties[name] = !0;
        if ("is" === lowerCasedName && null !== value && void 0 !== value && "string" !== typeof value) return console.error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value), warnedProperties[name] = !0;
        if ("number" === typeof value && isNaN(value)) return console.error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name), warnedProperties[name] = !0;
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            if (lowerCasedName = possibleStandardNames[lowerCasedName], lowerCasedName !== name) return console.error("Invalid DOM property `%s`. Did you mean `%s`?", name, lowerCasedName), warnedProperties[name] = !0;
        } else if (name !== lowerCasedName) return console.error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName), warnedProperties[name] = !0;
        switch(name){
            case "dangerouslySetInnerHTML":
            case "children":
            case "style":
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                return !0;
            case "innerText":
            case "textContent":
                return !0;
        }
        switch(typeof value){
            case "boolean":
                switch(name){
                    case "autoFocus":
                    case "checked":
                    case "multiple":
                    case "muted":
                    case "selected":
                    case "contentEditable":
                    case "spellCheck":
                    case "draggable":
                    case "value":
                    case "autoReverse":
                    case "externalResourcesRequired":
                    case "focusable":
                    case "preserveAlpha":
                    case "allowFullScreen":
                    case "async":
                    case "autoPlay":
                    case "controls":
                    case "default":
                    case "defer":
                    case "disabled":
                    case "disablePictureInPicture":
                    case "disableRemotePlayback":
                    case "formNoValidate":
                    case "hidden":
                    case "loop":
                    case "noModule":
                    case "noValidate":
                    case "open":
                    case "playsInline":
                    case "readOnly":
                    case "required":
                    case "reversed":
                    case "scoped":
                    case "seamless":
                    case "itemScope":
                    case "capture":
                    case "download":
                    case "inert":
                        return !0;
                    default:
                        lowerCasedName = name.toLowerCase().slice(0, 5);
                        if ("data-" === lowerCasedName || "aria-" === lowerCasedName) return !0;
                        value ? console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name) : console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
                        return warnedProperties[name] = !0;
                }
            case "function":
            case "symbol":
                return warnedProperties[name] = !0, !1;
            case "string":
                if ("false" === value || "true" === value) {
                    switch(name){
                        case "checked":
                        case "selected":
                        case "multiple":
                        case "muted":
                        case "allowFullScreen":
                        case "async":
                        case "autoPlay":
                        case "controls":
                        case "default":
                        case "defer":
                        case "disabled":
                        case "disablePictureInPicture":
                        case "disableRemotePlayback":
                        case "formNoValidate":
                        case "hidden":
                        case "loop":
                        case "noModule":
                        case "noValidate":
                        case "open":
                        case "playsInline":
                        case "readOnly":
                        case "required":
                        case "reversed":
                        case "scoped":
                        case "seamless":
                        case "itemScope":
                        case "inert":
                            break;
                        default:
                            return !0;
                    }
                    console.error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, "false" === value ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
                    warnedProperties[name] = !0;
                }
        }
        return !0;
    }
    function warnUnknownProperties(type, props, eventRegistry) {
        var unknownProps = [], key;
        for(key in props)validateProperty(type, key, props[key], eventRegistry) || unknownProps.push(key);
        props = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        1 === unknownProps.length ? console.error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ", props, type) : 1 < unknownProps.length && console.error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ", props, type);
    }
    function sanitizeURL(url) {
        return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
    }
    function noop$1() {}
    function getEventTarget(nativeEvent) {
        nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
        nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
        return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
    }
    function restoreStateOfTarget(target) {
        var internalInstance = getInstanceFromNode(target);
        if (internalInstance && (target = internalInstance.stateNode)) {
            var props = target[internalPropsKey] || null;
            a: switch(target = internalInstance.stateNode, internalInstance.type){
                case "input":
                    updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                    internalInstance = props.name;
                    if ("radio" === props.type && null != internalInstance) {
                        for(props = target; props.parentNode;)props = props.parentNode;
                        checkAttributeStringCoercion(internalInstance, "name");
                        props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                        for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                            var otherNode = props[internalInstance];
                            if (otherNode !== target && otherNode.form === target.form) {
                                var otherProps = otherNode[internalPropsKey] || null;
                                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                                updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                            }
                        }
                        for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                    }
                    break a;
                case "textarea":
                    updateTextarea(target, props.value, props.defaultValue);
                    break a;
                case "select":
                    internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
            }
        }
    }
    function batchedUpdates$1(fn, a, b) {
        if (isInsideEventHandler) return fn(a, b);
        isInsideEventHandler = !0;
        try {
            var JSCompiler_inline_result = fn(a);
            return JSCompiler_inline_result;
        } finally{
            if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
                if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
            }
        }
    }
    function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (null === stateNode) return null;
        var props = stateNode[internalPropsKey] || null;
        if (null === props) return null;
        stateNode = props[registrationName];
        a: switch(registrationName){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
                inst = !props;
                break a;
            default:
                inst = !1;
        }
        if (inst) return null;
        if (stateNode && "function" !== typeof stateNode) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof stateNode + "` type.");
        return stateNode;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
        for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
        return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
    }
    function getEventCharCode(nativeEvent) {
        var keyCode = nativeEvent.keyCode;
        "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
        10 === nativeEvent && (nativeEvent = 13);
        return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
    }
    function functionThatReturnsTrue() {
        return !0;
    }
    function functionThatReturnsFalse() {
        return !1;
    }
    function createSyntheticEvent(Interface) {
        function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
            this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = !0;
                var event = this.nativeEvent;
                event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
            },
            persist: function() {},
            isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    function modifierStateGetter(keyArg) {
        var nativeEvent = this.nativeEvent;
        return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
    }
    function getEventModifierState() {
        return modifierStateGetter;
    }
    function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
            case "keydown":
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                return !0;
            default:
                return !1;
        }
    }
    function getDataFromCustomEvent(nativeEvent) {
        nativeEvent = nativeEvent.detail;
        return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                if (nativeEvent.which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = !0;
                return SPACEBAR_CHAR;
            case "textInput":
                return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
            default:
                return null;
        }
    }
    function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
        switch(domEventName){
            case "paste":
                return null;
            case "keypress":
                if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                    if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                    if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
    }
    function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return !1;
        eventNameSuffix = "on" + eventNameSuffix;
        var isSupported = eventNameSuffix in document;
        isSupported || (isSupported = document.createElement("div"), isSupported.setAttribute(eventNameSuffix, "return;"), isSupported = "function" === typeof isSupported[eventNameSuffix]);
        return isSupported;
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
            target
        ] : restoreTarget = target;
        inst = accumulateTwoPhaseListeners(inst, "onChange");
        0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
            event: nativeEvent,
            listeners: inst
        }));
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if ("change" === domEventName) return targetInst;
    }
    function stopWatchingForValueChange() {
        activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
    }
    function handlePropertyChange(nativeEvent) {
        if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
            var dispatchQueue = [];
            createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
            batchedUpdates$1(runEventInBatch, dispatchQueue);
        }
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
    }
    function getTargetInstForInputEventPolyfill(domEventName) {
        if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if ("click" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return !0;
        if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
        var keysA = Object.keys(objA), keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return !1;
        for(keysB = 0; keysB < keysA.length; keysB++){
            var currentKey = keysA[keysB];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
        }
        return !0;
    }
    function getLeafNode(node) {
        for(; node && node.firstChild;)node = node.firstChild;
        return node;
    }
    function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        root = 0;
        for(var nodeEnd; node;){
            if (3 === node.nodeType) {
                nodeEnd = root + node.textContent.length;
                if (root <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - root
                };
                root = nodeEnd;
            }
            a: {
                for(; node;){
                    if (node.nextSibling) {
                        node = node.nextSibling;
                        break a;
                    }
                    node = node.parentNode;
                }
                node = void 0;
            }
            node = getLeafNode(node);
        }
    }
    function containsNode(outerNode, innerNode) {
        return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
    }
    function getActiveElementDeep(containerInfo) {
        containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
        for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
            try {
                var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
            } catch (err) {
                JSCompiler_inline_result = !1;
            }
            if (JSCompiler_inline_result) containerInfo = element.contentWindow;
            else break;
            element = getActiveElement(containerInfo.document);
        }
        return element;
    }
    function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
    }
    function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
        mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
            start: doc.selectionStart,
            end: doc.selectionEnd
        } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
            anchorNode: doc.anchorNode,
            anchorOffset: doc.anchorOffset,
            focusNode: doc.focusNode,
            focusOffset: doc.focusOffset
        }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
            event: nativeEvent,
            listeners: doc
        }), nativeEvent.target = activeElement)));
    }
    function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName], styleProp;
        for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        return eventName;
    }
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function getArrayKind(array) {
        for(var kind = EMPTY_ARRAY, i = 0; i < array.length; i++){
            var value = array[i];
            if ("object" === typeof value && null !== value) {
                if (isArrayImpl(value) && 2 === value.length && "string" === typeof value[0]) {
                    if (kind !== EMPTY_ARRAY && kind !== ENTRIES_ARRAY) return COMPLEX_ARRAY;
                    kind = ENTRIES_ARRAY;
                } else return COMPLEX_ARRAY;
            } else {
                if ("function" === typeof value || "string" === typeof value && 50 < value.length || kind !== EMPTY_ARRAY && kind !== PRIMITIVE_ARRAY) return COMPLEX_ARRAY;
                kind = PRIMITIVE_ARRAY;
            }
        }
        return kind;
    }
    function addObjectToProperties(object, properties, indent, prefix) {
        for(var key in object)hasOwnProperty.call(object, key) && "_" !== key[0] && addValueToProperties(key, object[key], properties, indent, prefix);
    }
    function addValueToProperties(propertyName, value, properties, indent, prefix) {
        switch(typeof value){
            case "object":
                if (null === value) {
                    value = "null";
                    break;
                } else {
                    if (value.$$typeof === REACT_ELEMENT_TYPE) {
                        var typeName = getComponentNameFromType(value.type) || "\u2026", key = value.key;
                        value = value.props;
                        var propsKeys = Object.keys(value), propsLength = propsKeys.length;
                        if (null == key && 0 === propsLength) {
                            value = "<" + typeName + " />";
                            break;
                        }
                        if (3 > indent || 1 === propsLength && "children" === propsKeys[0] && null == key) {
                            value = "<" + typeName + " \u2026 />";
                            break;
                        }
                        properties.push([
                            prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                            "<" + typeName
                        ]);
                        null !== key && addValueToProperties("key", key, properties, indent + 1, prefix);
                        propertyName = !1;
                        for(var propKey in value)"children" === propKey ? null != value.children && (!isArrayImpl(value.children) || 0 < value.children.length) && (propertyName = !0) : hasOwnProperty.call(value, propKey) && "_" !== propKey[0] && addValueToProperties(propKey, value[propKey], properties, indent + 1, prefix);
                        properties.push([
                            "",
                            propertyName ? ">\u2026</" + typeName + ">" : "/>"
                        ]);
                        return;
                    }
                    typeName = Object.prototype.toString.call(value);
                    typeName = typeName.slice(8, typeName.length - 1);
                    if ("Array" === typeName) {
                        if (propKey = getArrayKind(value), propKey === PRIMITIVE_ARRAY || propKey === EMPTY_ARRAY) {
                            value = JSON.stringify(value);
                            break;
                        } else if (propKey === ENTRIES_ARRAY) {
                            properties.push([
                                prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                                ""
                            ]);
                            for(propertyName = 0; propertyName < value.length; propertyName++)typeName = value[propertyName], addValueToProperties(typeName[0], typeName[1], properties, indent + 1, prefix);
                            return;
                        }
                    }
                    if ("Promise" === typeName) {
                        if ("fulfilled" === value.status) {
                            if (typeName = properties.length, addValueToProperties(propertyName, value.value, properties, indent, prefix), properties.length > typeName) {
                                properties = properties[typeName];
                                properties[1] = "Promise<" + (properties[1] || "Object") + ">";
                                return;
                            }
                        } else if ("rejected" === value.status && (typeName = properties.length, addValueToProperties(propertyName, value.reason, properties, indent, prefix), properties.length > typeName)) {
                            properties = properties[typeName];
                            properties[1] = "Rejected Promise<" + properties[1] + ">";
                            return;
                        }
                        properties.push([
                            "\u00a0\u00a0".repeat(indent) + propertyName,
                            "Promise"
                        ]);
                        return;
                    }
                    "Object" === typeName && (propKey = Object.getPrototypeOf(value)) && "function" === typeof propKey.constructor && (typeName = propKey.constructor.name);
                    properties.push([
                        prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                        "Object" === typeName ? 3 > indent ? "" : "\u2026" : typeName
                    ]);
                    3 > indent && addObjectToProperties(value, properties, indent + 1, prefix);
                    return;
                }
            case "function":
                value = "" === value.name ? "() => {}" : value.name + "() {}";
                break;
            case "string":
                value = value === OMITTED_PROP_ERROR ? "\u2026" : JSON.stringify(value);
                break;
            case "undefined":
                value = "undefined";
                break;
            case "boolean":
                value = value ? "true" : "false";
                break;
            default:
                value = String(value);
        }
        properties.push([
            prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
            value
        ]);
    }
    function addObjectDiffToProperties(prev, next, properties, indent) {
        var isDeeplyEqual = !0;
        for(key in prev)key in next || (properties.push([
            REMOVED + "\u00a0\u00a0".repeat(indent) + key,
            "\u2026"
        ]), isDeeplyEqual = !1);
        for(var _key in next)if (_key in prev) {
            var key = prev[_key];
            var nextValue = next[_key];
            if (key !== nextValue) {
                if (0 === indent && "children" === _key) isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key, properties.push([
                    REMOVED + isDeeplyEqual,
                    "\u2026"
                ], [
                    ADDED + isDeeplyEqual,
                    "\u2026"
                ]);
                else {
                    if (!(3 <= indent)) {
                        if ("object" === typeof key && "object" === typeof nextValue && null !== key && null !== nextValue && key.$$typeof === nextValue.$$typeof) {
                            if (nextValue.$$typeof === REACT_ELEMENT_TYPE) {
                                if (key.type === nextValue.type && key.key === nextValue.key) {
                                    key = getComponentNameFromType(nextValue.type) || "\u2026";
                                    isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key;
                                    key = "<" + key + " \u2026 />";
                                    properties.push([
                                        REMOVED + isDeeplyEqual,
                                        key
                                    ], [
                                        ADDED + isDeeplyEqual,
                                        key
                                    ]);
                                    isDeeplyEqual = !1;
                                    continue;
                                }
                            } else {
                                var prevKind = Object.prototype.toString.call(key), nextKind = Object.prototype.toString.call(nextValue);
                                if (prevKind === nextKind && ("[object Object]" === nextKind || "[object Array]" === nextKind)) {
                                    prevKind = [
                                        UNCHANGED + "\u00a0\u00a0".repeat(indent) + _key,
                                        "[object Array]" === nextKind ? "Array" : ""
                                    ];
                                    properties.push(prevKind);
                                    nextKind = properties.length;
                                    addObjectDiffToProperties(key, nextValue, properties, indent + 1) ? nextKind === properties.length && (prevKind[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : isDeeplyEqual = !1;
                                    continue;
                                }
                            }
                        } else if ("function" === typeof key && "function" === typeof nextValue && key.name === nextValue.name && key.length === nextValue.length && (prevKind = Function.prototype.toString.call(key), nextKind = Function.prototype.toString.call(nextValue), prevKind === nextKind)) {
                            key = "" === nextValue.name ? "() => {}" : nextValue.name + "() {}";
                            properties.push([
                                UNCHANGED + "\u00a0\u00a0".repeat(indent) + _key,
                                key + " Referentially unequal function closure. Consider memoization."
                            ]);
                            continue;
                        }
                    }
                    addValueToProperties(_key, key, properties, indent, REMOVED);
                    addValueToProperties(_key, nextValue, properties, indent, ADDED);
                }
                isDeeplyEqual = !1;
            }
        } else properties.push([
            ADDED + "\u00a0\u00a0".repeat(indent) + _key,
            "\u2026"
        ]), isDeeplyEqual = !1;
        return isDeeplyEqual;
    }
    function setCurrentTrackFromLanes(lanes) {
        currentTrack = lanes & 63 ? "Blocking" : lanes & 64 ? "Gesture" : lanes & 4194176 ? "Transition" : lanes & 62914560 ? "Suspense" : lanes & 2080374784 ? "Idle" : "Other";
    }
    function logComponentTrigger(fiber, startTime, endTime, trigger) {
        supportsUserTiming && (reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = trigger, reusableComponentDevToolDetails.properties = null, (fiber = fiber._debugTask) ? fiber.run(performance.measure.bind(performance, trigger, reusableComponentOptions)) : performance.measure(trigger, reusableComponentOptions));
    }
    function logComponentReappeared(fiber, startTime, endTime) {
        logComponentTrigger(fiber, startTime, endTime, "Reconnect");
    }
    function logComponentRender(fiber, startTime, endTime, wasHydrated, committedLanes) {
        var name = getComponentNameFromFiber(fiber);
        if (null !== name && supportsUserTiming) {
            var alternate = fiber.alternate, selfTime = fiber.actualDuration;
            if (null === alternate || alternate.child !== fiber.child) for(var child = fiber.child; null !== child; child = child.sibling)selfTime -= child.actualDuration;
            wasHydrated = 0.5 > selfTime ? wasHydrated ? "tertiary-light" : "primary-light" : 10 > selfTime ? wasHydrated ? "tertiary" : "primary" : 100 > selfTime ? wasHydrated ? "tertiary-dark" : "primary-dark" : "error";
            var props = fiber.memoizedProps;
            selfTime = fiber._debugTask;
            null !== props && null !== alternate && alternate.memoizedProps !== props ? (child = [
                resuableChangedPropsEntry
            ], props = addObjectDiffToProperties(alternate.memoizedProps, props, child, 0), 1 < child.length && (props && !alreadyWarnedForDeepEquality && 0 === (alternate.lanes & committedLanes) && 100 < fiber.actualDuration ? (alreadyWarnedForDeepEquality = !0, child[0] = reusableDeeplyEqualPropsEntry, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = DEEP_EQUALITY_WARNING) : (reusableComponentDevToolDetails.color = wasHydrated, reusableComponentDevToolDetails.tooltipText = name), reusableComponentDevToolDetails.properties = child, reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, null != selfTime ? selfTime.run(performance.measure.bind(performance, "\u200b" + name, reusableComponentOptions)) : performance.measure("\u200b" + name, reusableComponentOptions))) : null != selfTime ? selfTime.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, wasHydrated)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, wasHydrated);
        }
    }
    function logComponentErrored(fiber, startTime, endTime, errors) {
        if (supportsUserTiming) {
            var name = getComponentNameFromFiber(fiber);
            if (null !== name) {
                for(var debugTask = null, properties = [], i = 0; i < errors.length; i++){
                    var capturedValue = errors[i];
                    null == debugTask && null !== capturedValue.source && (debugTask = capturedValue.source._debugTask);
                    capturedValue = capturedValue.value;
                    properties.push([
                        "Error",
                        "object" === typeof capturedValue && null !== capturedValue && "string" === typeof capturedValue.message ? String(capturedValue.message) : String(capturedValue)
                    ]);
                }
                null !== fiber.key && addValueToProperties("key", fiber.key, properties, 0, "");
                null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, properties, 0, "");
                null == debugTask && (debugTask = fiber._debugTask);
                fiber = {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            color: "error",
                            track: COMPONENTS_TRACK,
                            tooltipText: 13 === fiber.tag ? "Hydration failed" : "Error boundary caught an error",
                            properties: properties
                        }
                    }
                };
                debugTask ? debugTask.run(performance.measure.bind(performance, "\u200b" + name, fiber)) : performance.measure("\u200b" + name, fiber);
            }
        }
    }
    function logComponentEffect(fiber, startTime, endTime, selfTime, errors) {
        if (null !== errors) {
            if (supportsUserTiming) {
                var name = getComponentNameFromFiber(fiber);
                if (null !== name) {
                    selfTime = [];
                    for(var i = 0; i < errors.length; i++){
                        var error = errors[i].value;
                        selfTime.push([
                            "Error",
                            "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                        ]);
                    }
                    null !== fiber.key && addValueToProperties("key", fiber.key, selfTime, 0, "");
                    null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, selfTime, 0, "");
                    startTime = {
                        start: startTime,
                        end: endTime,
                        detail: {
                            devtools: {
                                color: "error",
                                track: COMPONENTS_TRACK,
                                tooltipText: "A lifecycle or effect errored",
                                properties: selfTime
                            }
                        }
                    };
                    (fiber = fiber._debugTask) ? fiber.run(performance.measure.bind(performance, "\u200b" + name, startTime)) : performance.measure("\u200b" + name, startTime);
                }
            }
        } else name = getComponentNameFromFiber(fiber), null !== name && supportsUserTiming && (errors = 1 > selfTime ? "secondary-light" : 100 > selfTime ? "secondary" : 500 > selfTime ? "secondary-dark" : "error", (fiber = fiber._debugTask) ? fiber.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, errors)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, errors));
    }
    function logRenderPhase(startTime, endTime, lanes, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark";
            lanes = (lanes & 536870912) === lanes ? "Prepared" : (lanes & 201326741) === lanes ? "Hydrated" : "Render";
            debugTask ? debugTask.run(console.timeStamp.bind(console, lanes, startTime, endTime, currentTrack, LANES_TRACK_GROUP, color)) : console.timeStamp(lanes, startTime, endTime, currentTrack, LANES_TRACK_GROUP, color);
        }
    }
    function logSuspendedRenderPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(console.timeStamp.bind(console, "Prewarm", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes)) : console.timeStamp("Prewarm", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes));
    }
    function logSuspendedWithDelayPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(console.timeStamp.bind(console, "Suspended", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes)) : console.timeStamp("Suspended", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes));
    }
    function logRecoveredRenderPhase(startTime, endTime, lanes, recoverableErrors, hydrationFailed, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            lanes = [];
            for(var i = 0; i < recoverableErrors.length; i++){
                var error = recoverableErrors[i].value;
                lanes.push([
                    "Recoverable Error",
                    "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                ]);
            }
            startTime = {
                start: startTime,
                end: endTime,
                detail: {
                    devtools: {
                        color: "primary-dark",
                        track: currentTrack,
                        trackGroup: LANES_TRACK_GROUP,
                        tooltipText: hydrationFailed ? "Hydration Failed" : "Recovered after Error",
                        properties: lanes
                    }
                }
            };
            debugTask ? debugTask.run(performance.measure.bind(performance, "Recovered", startTime)) : performance.measure("Recovered", startTime);
        }
    }
    function logErroredRenderPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, "Errored", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "error")) : console.timeStamp("Errored", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "error"));
    }
    function logSuspendedCommitPhase(startTime, endTime, reason, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, reason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(reason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
    }
    function logCommitErrored(startTime, endTime, errors, passive, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            for(var properties = [], i = 0; i < errors.length; i++){
                var error = errors[i].value;
                properties.push([
                    "Error",
                    "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                ]);
            }
            startTime = {
                start: startTime,
                end: endTime,
                detail: {
                    devtools: {
                        color: "error",
                        track: currentTrack,
                        trackGroup: LANES_TRACK_GROUP,
                        tooltipText: passive ? "Remaining Effects Errored" : "Commit Errored",
                        properties: properties
                    }
                }
            };
            debugTask ? debugTask.run(performance.measure.bind(performance, "Errored", startTime)) : performance.measure("Errored", startTime);
        }
    }
    function logAnimatingPhase(startTime, endTime, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, "Animating", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark")) : console.timeStamp("Animating", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark"));
    }
    function finishQueueingConcurrentUpdates() {
        for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
            var fiber = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var queue = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var update = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var lane = concurrentQueues[i];
            concurrentQueues[i++] = null;
            if (null !== queue && null !== update) {
                var pending = queue.pending;
                null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
                queue.pending = update;
            }
            0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
        }
    }
    function enqueueUpdate$1(fiber, queue, update, lane) {
        concurrentQueues[concurrentQueuesIndex++] = fiber;
        concurrentQueues[concurrentQueuesIndex++] = queue;
        concurrentQueues[concurrentQueuesIndex++] = update;
        concurrentQueues[concurrentQueuesIndex++] = lane;
        concurrentlyUpdatedLanes |= lane;
        fiber.lanes |= lane;
        fiber = fiber.alternate;
        null !== fiber && (fiber.lanes |= lane);
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        enqueueUpdate$1(fiber, queue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        enqueueUpdate$1(fiber, null, null, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
        sourceFiber.lanes |= lane;
        var alternate = sourceFiber.alternate;
        null !== alternate && (alternate.lanes |= lane);
        for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & OffscreenVisible || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
        return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
            update
        ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
    }
    function getRootForUpdatedFiber(sourceFiber) {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) throw nestedPassiveUpdateCount = nestedUpdateCount = 0, rootWithPassiveNestedUpdates = rootWithNestedUpdates = null, Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT && (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, console.error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
        null === sourceFiber.alternate && 0 !== (sourceFiber.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        for(var node = sourceFiber, parent = node.return; null !== parent;)null === node.alternate && 0 !== (node.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber), node = parent, parent = node.return;
        return 3 === node.tag ? node.stateNode : null;
    }
    function resolveFunctionForHotReloading(type) {
        if (null === resolveFamily) return type;
        var family = resolveFamily(type);
        return void 0 === family ? type : family.current;
    }
    function resolveForwardRefForHotReloading(type) {
        if (null === resolveFamily) return type;
        var family = resolveFamily(type);
        return void 0 === family ? null !== type && void 0 !== type && "function" === typeof type.render && (family = resolveFunctionForHotReloading(type.render), type.render !== family) ? (family = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: family
        }, void 0 !== type.displayName && (family.displayName = type.displayName), family) : type : family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (null === resolveFamily) return !1;
        var prevType = fiber.elementType;
        element = element.type;
        var needsCompareFamilies = !1, $$typeofNextType = "object" === typeof element && null !== element ? element.$$typeof : null;
        switch(fiber.tag){
            case 1:
                "function" === typeof element && (needsCompareFamilies = !0);
                break;
            case 0:
                "function" === typeof element ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            case 11:
                $$typeofNextType === REACT_FORWARD_REF_TYPE ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            case 14:
            case 15:
                $$typeofNextType === REACT_MEMO_TYPE ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            default:
                return !1;
        }
        return needsCompareFamilies && (fiber = resolveFamily(prevType), void 0 !== fiber && fiber === resolveFamily(element)) ? !0 : !1;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        null !== resolveFamily && "function" === typeof WeakSet && (null === failedBoundaries && (failedBoundaries = new WeakSet()), failedBoundaries.add(fiber));
    }
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        do {
            var _fiber = fiber, alternate = _fiber.alternate, child = _fiber.child, sibling = _fiber.sibling, tag = _fiber.tag;
            _fiber = _fiber.type;
            var candidateType = null;
            switch(tag){
                case 0:
                case 15:
                case 1:
                    candidateType = _fiber;
                    break;
                case 11:
                    candidateType = _fiber.render;
            }
            if (null === resolveFamily) throw Error("Expected resolveFamily to be set during hot reload.");
            var needsRender = !1;
            _fiber = !1;
            null !== candidateType && (candidateType = resolveFamily(candidateType), void 0 !== candidateType && (staleFamilies.has(candidateType) ? _fiber = !0 : updatedFamilies.has(candidateType) && (1 === tag ? _fiber = !0 : needsRender = !0)));
            null !== failedBoundaries && (failedBoundaries.has(fiber) || null !== alternate && failedBoundaries.has(alternate)) && (_fiber = !0);
            _fiber && (fiber._debugNeedsRemount = !0);
            if (_fiber || needsRender) alternate = enqueueConcurrentRenderForLane(fiber, 2), null !== alternate && scheduleUpdateOnFiber(alternate, fiber, 2);
            null === child || _fiber || scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
            if (null === sibling) break;
            fiber = sibling;
        }while (1);
    }
    function FiberNode(tag, pendingProps, key, mode) {
        this.tag = tag;
        this.key = key;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.refCleanup = this.ref = null;
        this.pendingProps = pendingProps;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = mode;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
        this.actualDuration = -0;
        this.actualStartTime = -1.1;
        this.treeBaseDuration = this.selfBaseDuration = -0;
        this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null;
        this._debugNeedsRemount = !1;
        this._debugHookTypes = null;
        hasBadMapPolyfill || "function" !== typeof Object.preventExtensions || Object.preventExtensions(this);
    }
    function shouldConstruct(Component) {
        Component = Component.prototype;
        return !(!Component || !Component.isReactComponent);
    }
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        null === workInProgress ? (workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress._debugOwner = current._debugOwner, workInProgress._debugStack = current._debugStack, workInProgress._debugTask = current._debugTask, workInProgress._debugHookTypes = current._debugHookTypes, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.actualDuration = -0, workInProgress.actualStartTime = -1.1);
        workInProgress.flags = current.flags & 65011712;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue;
        pendingProps = current.dependencies;
        workInProgress.dependencies = null === pendingProps ? null : {
            lanes: pendingProps.lanes,
            firstContext: pendingProps.firstContext,
            _debugThenableState: pendingProps._debugThenableState
        };
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.refCleanup = current.refCleanup;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugInfo = current._debugInfo;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case 0:
            case 15:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case 1:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case 11:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
        }
        return workInProgress;
    }
    function resetWorkInProgress(workInProgress, renderLanes) {
        workInProgress.flags &= 65011714;
        var current = workInProgress.alternate;
        null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null, workInProgress.selfBaseDuration = 0, workInProgress.treeBaseDuration = 0) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
            lanes: renderLanes.lanes,
            firstContext: renderLanes.firstContext,
            _debugThenableState: renderLanes._debugThenableState
        }, workInProgress.selfBaseDuration = current.selfBaseDuration, workInProgress.treeBaseDuration = current.treeBaseDuration);
        return workInProgress;
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = 0, resolvedType = type;
        if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1), resolvedType = resolveFunctionForHotReloading(resolvedType);
        else if ("string" === typeof type) fiberTag = getHostContext(), fiberTag = isHostHoistableType(type, pendingProps, fiberTag) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
        else a: switch(type){
            case REACT_ACTIVITY_TYPE:
                return key = createFiber(31, pendingProps, key, mode), key.elementType = REACT_ACTIVITY_TYPE, key.lanes = lanes, key;
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = 8;
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return type = pendingProps, owner = mode, "string" !== typeof type.id && console.error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof type.id), key = createFiber(12, type, key, owner | ProfileMode), key.elementType = REACT_PROFILER_TYPE, key.lanes = lanes, key.stateNode = {
                    effectDuration: 0,
                    passiveEffectDuration: 0
                }, key;
            case REACT_SUSPENSE_TYPE:
                return key = createFiber(13, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_TYPE, key.lanes = lanes, key;
            case REACT_SUSPENSE_LIST_TYPE:
                return key = createFiber(19, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_LIST_TYPE, key.lanes = lanes, key;
            default:
                if ("object" === typeof type && null !== type) switch(type.$$typeof){
                    case REACT_CONTEXT_TYPE:
                        fiberTag = 10;
                        break a;
                    case REACT_CONSUMER_TYPE:
                        fiberTag = 9;
                        break a;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = 11;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break a;
                    case REACT_MEMO_TYPE:
                        fiberTag = 14;
                        break a;
                    case REACT_LAZY_TYPE:
                        fiberTag = 16;
                        resolvedType = null;
                        break a;
                }
                resolvedType = "";
                if (void 0 === type || "object" === typeof type && null !== type && 0 === Object.keys(type).length) resolvedType += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                null === type ? pendingProps = "null" : isArrayImpl(type) ? pendingProps = "array" : void 0 !== type && type.$$typeof === REACT_ELEMENT_TYPE ? (pendingProps = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />", resolvedType = " Did you accidentally export a JSX literal instead of a component?") : pendingProps = typeof type;
                (fiberTag = owner ? getComponentNameFromOwner(owner) : null) && (resolvedType += "\n\nCheck the render method of `" + fiberTag + "`.");
                fiberTag = 29;
                pendingProps = Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (pendingProps + "." + resolvedType));
                resolvedType = null;
        }
        key = createFiber(fiberTag, pendingProps, key, mode);
        key.elementType = type;
        key.type = resolvedType;
        key.lanes = lanes;
        key._debugOwner = owner;
        return key;
    }
    function createFiberFromElement(element, mode, lanes) {
        mode = createFiberFromTypeAndProps(element.type, element.key, element.props, element._owner, mode, lanes);
        mode._debugOwner = element._owner;
        mode._debugStack = element._debugStack;
        mode._debugTask = element._debugTask;
        return mode;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        elements = createFiber(7, elements, key, mode);
        elements.lanes = lanes;
        return elements;
    }
    function createFiberFromText(content, mode, lanes) {
        content = createFiber(6, content, null, mode);
        content.lanes = lanes;
        return content;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(18, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        mode = createFiber(4, null !== portal.children ? portal.children : [], portal.key, mode);
        mode.lanes = lanes;
        mode.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            implementation: portal.implementation
        };
        return mode;
    }
    function createCapturedValueAtFiber(value, source) {
        if ("object" === typeof value && null !== value) {
            var existing = CapturedStacks.get(value);
            if (void 0 !== existing) return existing;
            source = {
                value: value,
                source: source,
                stack: getStackByFiberInDevAndProd(source)
            };
            CapturedStacks.set(value, source);
            return source;
        }
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    function pushTreeFork(workInProgress, totalChildren) {
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        workInProgress = treeContextOverflow;
        var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
        baseIdWithLeadingBit &= ~(1 << baseLength);
        index += 1;
        var length = 32 - clz32(totalChildren) + baseLength;
        if (30 < length) {
            var numberOfOverflowBits = baseLength - baseLength % 5;
            length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
            baseIdWithLeadingBit >>= numberOfOverflowBits;
            baseLength -= numberOfOverflowBits;
            treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
            treeContextOverflow = length + workInProgress;
        } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating();
        null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
    }
    function popTreeContext(workInProgress) {
        for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
        for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        return null !== treeContextProvider ? {
            id: treeContextId,
            overflow: treeContextOverflow
        } : null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        isHydrating || console.error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    function buildHydrationDiffNode(fiber, distanceFromLeaf) {
        if (null === fiber.return) {
            if (null === hydrationDiffRootDEV) hydrationDiffRootDEV = {
                fiber: fiber,
                children: [],
                serverProps: void 0,
                serverTail: [],
                distanceFromLeaf: distanceFromLeaf
            };
            else {
                if (hydrationDiffRootDEV.fiber !== fiber) throw Error("Saw multiple hydration diff roots in a pass. This is a bug in React.");
                hydrationDiffRootDEV.distanceFromLeaf > distanceFromLeaf && (hydrationDiffRootDEV.distanceFromLeaf = distanceFromLeaf);
            }
            return hydrationDiffRootDEV;
        }
        var siblings = buildHydrationDiffNode(fiber.return, distanceFromLeaf + 1).children;
        if (0 < siblings.length && siblings[siblings.length - 1].fiber === fiber) return siblings = siblings[siblings.length - 1], siblings.distanceFromLeaf > distanceFromLeaf && (siblings.distanceFromLeaf = distanceFromLeaf), siblings;
        distanceFromLeaf = {
            fiber: fiber,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: distanceFromLeaf
        };
        siblings.push(distanceFromLeaf);
        return distanceFromLeaf;
    }
    function warnIfHydrating() {
        isHydrating && console.error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function warnNonHydratedInstance(fiber, rejectedCandidate) {
        didSuspendOrErrorDEV || (fiber = buildHydrationDiffNode(fiber, 0), fiber.serverProps = null, null !== rejectedCandidate && (rejectedCandidate = describeHydratableInstanceForDevWarnings(rejectedCandidate), fiber.serverTail.push(rejectedCandidate)));
    }
    function throwOnHydrationMismatch(fiber) {
        var fromText = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : !1, diff = "", diffRoot = hydrationDiffRootDEV;
        null !== diffRoot && (hydrationDiffRootDEV = null, diff = describeDiff(diffRoot));
        queueHydrationError(createCapturedValueAtFiber(Error("Hydration failed because the server rendered " + (fromText ? "text" : "HTML") + " didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\nhttps://react.dev/link/hydration-mismatch" + diff), fiber));
        throw HydrationMismatchException;
    }
    function prepareToHydrateHostInstance(fiber) {
        var didHydrate = fiber.stateNode;
        var type = fiber.type, props = fiber.memoizedProps;
        didHydrate[internalInstanceKey] = fiber;
        didHydrate[internalPropsKey] = props;
        validatePropertiesInDevelopment(type, props);
        switch(type){
            case "dialog":
                listenToNonDelegatedEvent("cancel", didHydrate);
                listenToNonDelegatedEvent("close", didHydrate);
                break;
            case "iframe":
            case "object":
            case "embed":
                listenToNonDelegatedEvent("load", didHydrate);
                break;
            case "video":
            case "audio":
                for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], didHydrate);
                break;
            case "source":
                listenToNonDelegatedEvent("error", didHydrate);
                break;
            case "img":
            case "image":
            case "link":
                listenToNonDelegatedEvent("error", didHydrate);
                listenToNonDelegatedEvent("load", didHydrate);
                break;
            case "details":
                listenToNonDelegatedEvent("toggle", didHydrate);
                break;
            case "input":
                checkControlledValueProps("input", props);
                listenToNonDelegatedEvent("invalid", didHydrate);
                validateInputProps(didHydrate, props);
                initInput(didHydrate, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
                break;
            case "option":
                validateOptionProps(didHydrate, props);
                break;
            case "select":
                checkControlledValueProps("select", props);
                listenToNonDelegatedEvent("invalid", didHydrate);
                validateSelectProps(didHydrate, props);
                break;
            case "textarea":
                checkControlledValueProps("textarea", props), listenToNonDelegatedEvent("invalid", didHydrate), validateTextareaProps(didHydrate, props), initTextarea(didHydrate, props.value, props.defaultValue, props.children);
        }
        type = props.children;
        "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || didHydrate.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(didHydrate.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", didHydrate), listenToNonDelegatedEvent("toggle", didHydrate)), null != props.onScroll && listenToNonDelegatedEvent("scroll", didHydrate), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", didHydrate), null != props.onClick && (didHydrate.onclick = noop$1), didHydrate = !0) : didHydrate = !1;
        didHydrate || throwOnHydrationMismatch(fiber, !0);
    }
    function popToNextHostParent(fiber) {
        for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
            case 5:
            case 31:
            case 13:
                rootOrSingletonContext = !1;
                return;
            case 27:
            case 3:
                rootOrSingletonContext = !0;
                return;
            default:
                hydrationParentFiber = hydrationParentFiber.return;
        }
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) return !1;
        if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
        var tag = fiber.tag, JSCompiler_temp;
        if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
            if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
            JSCompiler_temp = !JSCompiler_temp;
        }
        if (JSCompiler_temp && nextHydratableInstance) {
            for(JSCompiler_temp = nextHydratableInstance; JSCompiler_temp;){
                var diffNode = buildHydrationDiffNode(fiber, 0), description = describeHydratableInstanceForDevWarnings(JSCompiler_temp);
                diffNode.serverTail.push(description);
                JSCompiler_temp = "Suspense" === description.type ? getNextHydratableInstanceAfterHydrationBoundary(JSCompiler_temp) : getNextHydratable(JSCompiler_temp.nextSibling);
            }
            throwOnHydrationMismatch(fiber);
        }
        popToNextHostParent(fiber);
        if (13 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
        } else if (31 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
        } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
        return !0;
    }
    function resetHydrationState() {
        nextHydratableInstance = hydrationParentFiber = null;
        didSuspendOrErrorDEV = isHydrating = !1;
    }
    function upgradeHydrationErrorsToRecoverable() {
        var queuedErrors = hydrationErrors;
        null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
        return queuedErrors;
    }
    function queueHydrationError(error) {
        null === hydrationErrors ? hydrationErrors = [
            error
        ] : hydrationErrors.push(error);
    }
    function emitPendingHydrationWarnings() {
        var diffRoot = hydrationDiffRootDEV;
        if (null !== diffRoot) {
            hydrationDiffRootDEV = null;
            for(var diff = describeDiff(diffRoot); 0 < diffRoot.children.length;)diffRoot = diffRoot.children[0];
            runWithFiberInDEV(diffRoot.fiber, function() {
                console.error("A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\n%s%s", "https://react.dev/link/hydration-mismatch", diff);
            });
        }
    }
    function resetContextDependencies() {
        lastContextDependency = currentlyRenderingFiber$1 = null;
        isDisallowedContextReadInDEV = !1;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        push(rendererCursorDEV, context._currentRenderer, providerFiber);
        void 0 !== context._currentRenderer && null !== context._currentRenderer && context._currentRenderer !== rendererSigil && console.error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        context._currentValue = valueCursor.current;
        var currentRenderer = rendererCursorDEV.current;
        pop(rendererCursorDEV, providerFiber);
        context._currentRenderer = currentRenderer;
        pop(valueCursor, providerFiber);
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        for(; null !== parent;){
            var alternate = parent.alternate;
            (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
            if (parent === propagationRoot) break;
            parent = parent.return;
        }
        parent !== propagationRoot && console.error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
        var fiber = workInProgress.child;
        null !== fiber && (fiber.return = workInProgress);
        for(; null !== fiber;){
            var list = fiber.dependencies;
            if (null !== list) {
                var nextFiber = fiber.child;
                list = list.firstContext;
                a: for(; null !== list;){
                    var dependency = list;
                    list = fiber;
                    for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                        list.lanes |= renderLanes;
                        dependency = list.alternate;
                        null !== dependency && (dependency.lanes |= renderLanes);
                        scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                        forcePropagateEntireTree || (nextFiber = null);
                        break a;
                    }
                    list = dependency.next;
                }
            } else if (18 === fiber.tag) {
                nextFiber = fiber.return;
                if (null === nextFiber) throw Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                nextFiber.lanes |= renderLanes;
                list = nextFiber.alternate;
                null !== list && (list.lanes |= renderLanes);
                scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
                nextFiber = null;
            } else nextFiber = fiber.child;
            if (null !== nextFiber) nextFiber.return = fiber;
            else for(nextFiber = fiber; null !== nextFiber;){
                if (nextFiber === workInProgress) {
                    nextFiber = null;
                    break;
                }
                fiber = nextFiber.sibling;
                if (null !== fiber) {
                    fiber.return = nextFiber.return;
                    nextFiber = fiber;
                    break;
                }
                nextFiber = nextFiber.return;
            }
            fiber = nextFiber;
        }
    }
    function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
        current = null;
        for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
            if (!isInsidePropagationBailout) {
                if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
                else if (0 !== (parent.flags & 262144)) break;
            }
            if (10 === parent.tag) {
                var currentParent = parent.alternate;
                if (null === currentParent) throw Error("Should have a current fiber. This is a bug in React.");
                currentParent = currentParent.memoizedProps;
                if (null !== currentParent) {
                    var context = parent.type;
                    objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                        context
                    ]);
                }
            } else if (parent === hostTransitionProviderCursor.current) {
                currentParent = parent.alternate;
                if (null === currentParent) throw Error("Should have a current fiber. This is a bug in React.");
                currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                    HostTransitionContext
                ]);
            }
            parent = parent.return;
        }
        null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
        workInProgress.flags |= 262144;
    }
    function checkIfContextChanged(currentDependencies) {
        for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
            if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
            currentDependencies = currentDependencies.next;
        }
        return !1;
    }
    function prepareToReadContext(workInProgress) {
        currentlyRenderingFiber$1 = workInProgress;
        lastContextDependency = null;
        workInProgress = workInProgress.dependencies;
        null !== workInProgress && (workInProgress.firstContext = null);
    }
    function readContext(context) {
        isDisallowedContextReadInDEV && console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        return readContextForConsumer(currentlyRenderingFiber$1, context);
    }
    function readContextDuringReconciliation(consumer, context) {
        null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
        return readContextForConsumer(consumer, context);
    }
    function readContextForConsumer(consumer, context) {
        var value = context._currentValue;
        context = {
            context: context,
            memoizedValue: value,
            next: null
        };
        if (null === lastContextDependency) {
            if (null === consumer) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            lastContextDependency = context;
            consumer.dependencies = {
                lanes: 0,
                firstContext: context,
                _debugThenableState: null
            };
            consumer.flags |= 524288;
        } else lastContextDependency = lastContextDependency.next = context;
        return value;
    }
    function createCache() {
        return {
            controller: new AbortControllerLocal(),
            data: new Map(),
            refCount: 0
        };
    }
    function retainCache(cache) {
        cache.controller.signal.aborted && console.warn("A cache instance was retained after it was already freed. This likely indicates a bug in React.");
        cache.refCount++;
    }
    function releaseCache(cache) {
        cache.refCount--;
        0 > cache.refCount && console.warn("A cache instance was released after it was already freed. This likely indicates a bug in React.");
        0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
            cache.controller.abort();
        });
    }
    function startUpdateTimerByLane(lane, method, fiber) {
        if (0 !== (lane & 127)) 0 > blockingUpdateTime && (blockingUpdateTime = now(), blockingUpdateTask = createTask(method), blockingUpdateMethodName = method, null != fiber && (blockingUpdateComponentName = getComponentNameFromFiber(fiber)), (executionContext & (RenderContext | CommitContext)) !== NoContext && (componentEffectSpawnedUpdate = !0, blockingUpdateType = SPAWNED_UPDATE), lane = resolveEventTimeStamp(), method = resolveEventType(), lane !== blockingEventRepeatTime || method !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== method && (blockingUpdateType = SPAWNED_UPDATE), blockingEventTime = lane, blockingEventType = method);
        else if (0 !== (lane & 4194048) && 0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = createTask(method), transitionUpdateMethodName = method, null != fiber && (transitionUpdateComponentName = getComponentNameFromFiber(fiber)), 0 > transitionStartTime)) {
            lane = resolveEventTimeStamp();
            method = resolveEventType();
            if (lane !== transitionEventRepeatTime || method !== transitionEventType) transitionEventRepeatTime = -1.1;
            transitionEventTime = lane;
            transitionEventType = method;
        }
    }
    function startHostActionTimer(fiber) {
        if (0 > blockingUpdateTime) {
            blockingUpdateTime = now();
            blockingUpdateTask = null != fiber._debugTask ? fiber._debugTask : null;
            (executionContext & (RenderContext | CommitContext)) !== NoContext && (blockingUpdateType = SPAWNED_UPDATE);
            var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
            newEventTime !== blockingEventRepeatTime || newEventType !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== newEventType && (blockingUpdateType = SPAWNED_UPDATE);
            blockingEventTime = newEventTime;
            blockingEventType = newEventType;
        }
        if (0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = null != fiber._debugTask ? fiber._debugTask : null, 0 > transitionStartTime)) {
            fiber = resolveEventTimeStamp();
            newEventTime = resolveEventType();
            if (fiber !== transitionEventRepeatTime || newEventTime !== transitionEventType) transitionEventRepeatTime = -1.1;
            transitionEventTime = fiber;
            transitionEventType = newEventTime;
        }
    }
    function pushNestedEffectDurations() {
        var prevEffectDuration = profilerEffectDuration;
        profilerEffectDuration = 0;
        return prevEffectDuration;
    }
    function popNestedEffectDurations(prevEffectDuration) {
        var elapsedTime = profilerEffectDuration;
        profilerEffectDuration = prevEffectDuration;
        return elapsedTime;
    }
    function bubbleNestedEffectDurations(prevEffectDuration) {
        var elapsedTime = profilerEffectDuration;
        profilerEffectDuration += prevEffectDuration;
        return elapsedTime;
    }
    function resetComponentEffectTimers() {
        componentEffectEndTime = componentEffectStartTime = -1.1;
    }
    function pushComponentEffectStart() {
        var prevEffectStart = componentEffectStartTime;
        componentEffectStartTime = -1.1;
        return prevEffectStart;
    }
    function popComponentEffectStart(prevEffectStart) {
        0 <= prevEffectStart && (componentEffectStartTime = prevEffectStart);
    }
    function pushComponentEffectDuration() {
        var prevEffectDuration = componentEffectDuration;
        componentEffectDuration = -0;
        return prevEffectDuration;
    }
    function popComponentEffectDuration(prevEffectDuration) {
        0 <= prevEffectDuration && (componentEffectDuration = prevEffectDuration);
    }
    function pushComponentEffectErrors() {
        var prevErrors = componentEffectErrors;
        componentEffectErrors = null;
        return prevErrors;
    }
    function pushComponentEffectDidSpawnUpdate() {
        var prev = componentEffectSpawnedUpdate;
        componentEffectSpawnedUpdate = !1;
        return prev;
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now();
        0 > fiber.actualStartTime && (fiber.actualStartTime = profilerStartTime);
    }
    function stopProfilerTimerIfRunningAndRecordDuration(fiber) {
        if (0 <= profilerStartTime) {
            var elapsedTime = now() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function stopProfilerTimerIfRunningAndRecordIncompleteDuration(fiber) {
        if (0 <= profilerStartTime) {
            var elapsedTime = now() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordEffectDuration() {
        if (0 <= profilerStartTime) {
            var endTime = now(), elapsedTime = endTime - profilerStartTime;
            profilerStartTime = -1;
            profilerEffectDuration += elapsedTime;
            componentEffectDuration += elapsedTime;
            componentEffectEndTime = endTime;
        }
    }
    function recordEffectError(errorInfo) {
        null === componentEffectErrors && (componentEffectErrors = []);
        componentEffectErrors.push(errorInfo);
        null === commitErrors && (commitErrors = []);
        commitErrors.push(errorInfo);
    }
    function startEffectTimer() {
        profilerStartTime = now();
        0 > componentEffectStartTime && (componentEffectStartTime = profilerStartTime);
    }
    function transferActualDuration(fiber) {
        for(var child = fiber.child; child;)fiber.actualDuration += child.actualDuration, child = child.sibling;
    }
    function entangleAsyncAction(transition, thenable) {
        if (null === currentEntangledListeners) {
            var entangledListeners = currentEntangledListeners = [];
            currentEntangledPendingCount = 0;
            currentEntangledLane = requestTransitionLane();
            currentEntangledActionThenable = {
                status: "pending",
                value: void 0,
                then: function(resolve) {
                    entangledListeners.push(resolve);
                }
            };
        }
        currentEntangledPendingCount++;
        thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
        return thenable;
    }
    function pingEngtangledActionScope() {
        if (0 === --currentEntangledPendingCount && (-1 < transitionUpdateTime || (transitionStartTime = -1.1), null !== currentEntangledListeners)) {
            null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
            var listeners = currentEntangledListeners;
            currentEntangledListeners = null;
            currentEntangledLane = 0;
            currentEntangledActionThenable = null;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
        }
    }
    function chainThenableValue(thenable, result) {
        var listeners = [], thenableWithOverride = {
            status: "pending",
            value: null,
            reason: null,
            then: function(resolve) {
                listeners.push(resolve);
            }
        };
        thenable.then(function() {
            thenableWithOverride.status = "fulfilled";
            thenableWithOverride.value = result;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
        }, function(error) {
            thenableWithOverride.status = "rejected";
            thenableWithOverride.reason = error;
            for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
        });
        return thenableWithOverride;
    }
    function peekCacheFromPool() {
        var cacheResumedFromPreviousRender = resumedCache.current;
        return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
    }
    function pushTransition(offscreenWorkInProgress, prevCachePool) {
        null === prevCachePool ? push(resumedCache, resumedCache.current, offscreenWorkInProgress) : push(resumedCache, prevCachePool.pool, offscreenWorkInProgress);
    }
    function getSuspendedCache() {
        var cacheFromPool = peekCacheFromPool();
        return null === cacheFromPool ? null : {
            parent: CacheContext._currentValue,
            pool: cacheFromPool
        };
    }
    function createThenableState() {
        return {
            didWarnAboutUncachedPromise: !1,
            thenables: []
        };
    }
    function isThenableResolved(thenable) {
        thenable = thenable.status;
        return "fulfilled" === thenable || "rejected" === thenable;
    }
    function trackUsedThenable(thenableState, thenable, index) {
        null !== ReactSharedInternals.actQueue && (ReactSharedInternals.didUsePromise = !0);
        var trackedThenables = thenableState.thenables;
        index = trackedThenables[index];
        void 0 === index ? trackedThenables.push(thenable) : index !== thenable && (thenableState.didWarnAboutUncachedPromise || (thenableState.didWarnAboutUncachedPromise = !0, console.error("A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework.")), thenable.then(noop$1, noop$1), thenable = index);
        if (void 0 === thenable._debugInfo) {
            thenableState = performance.now();
            trackedThenables = thenable.displayName;
            var ioInfo = {
                name: "string" === typeof trackedThenables ? trackedThenables : "Promise",
                start: thenableState,
                end: thenableState,
                value: thenable
            };
            thenable._debugInfo = [
                {
                    awaited: ioInfo
                }
            ];
            "fulfilled" !== thenable.status && "rejected" !== thenable.status && (thenableState = function() {
                ioInfo.end = performance.now();
            }, thenable.then(thenableState, thenableState));
        }
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            default:
                if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
                else {
                    thenableState = workInProgressRoot;
                    if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error("An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
                    thenableState = thenable;
                    thenableState.status = "pending";
                    thenableState.then(function(fulfilledValue) {
                        if ("pending" === thenable.status) {
                            var fulfilledThenable = thenable;
                            fulfilledThenable.status = "fulfilled";
                            fulfilledThenable.value = fulfilledValue;
                        }
                    }, function(error) {
                        if ("pending" === thenable.status) {
                            var rejectedThenable = thenable;
                            rejectedThenable.status = "rejected";
                            rejectedThenable.reason = error;
                        }
                    });
                }
                switch(thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
                }
                suspendedThenable = thenable;
                needsToResetSuspendedThenableDEV = !0;
                throw SuspenseException;
        }
    }
    function resolveLazy(lazyType) {
        try {
            return callLazyInitInDEV(lazyType);
        } catch (x) {
            if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, needsToResetSuspendedThenableDEV = !0, SuspenseException;
            throw x;
        }
    }
    function getSuspendedThenable() {
        if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
        var thenable = suspendedThenable;
        suspendedThenable = null;
        needsToResetSuspendedThenableDEV = !1;
        return thenable;
    }
    function checkIfUseWrappedInAsyncCatch(rejectedReason) {
        if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error("Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
    }
    function pushDebugInfo(debugInfo) {
        var previousDebugInfo = currentDebugInfo;
        null != debugInfo && (currentDebugInfo = null === previousDebugInfo ? debugInfo : previousDebugInfo.concat(debugInfo));
        return previousDebugInfo;
    }
    function getCurrentDebugTask() {
        var debugInfo = currentDebugInfo;
        if (null != debugInfo) {
            for(var i = debugInfo.length - 1; 0 <= i; i--)if (null != debugInfo[i].name) {
                var debugTask = debugInfo[i].debugTask;
                if (null != debugTask) return debugTask;
            }
        }
        return null;
    }
    function validateFragmentProps(element, fiber, returnFiber) {
        for(var keys = Object.keys(element.props), i = 0; i < keys.length; i++){
            var key = keys[i];
            if ("children" !== key && "key" !== key) {
                null === fiber && (fiber = createFiberFromElement(element, returnFiber.mode, 0), fiber._debugInfo = currentDebugInfo, fiber.return = returnFiber);
                runWithFiberInDEV(fiber, function(erroredKey) {
                    console.error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", erroredKey);
                }, key);
                break;
            }
        }
    }
    function unwrapThenable(thenable) {
        var index = thenableIndexCounter$1;
        thenableIndexCounter$1 += 1;
        null === thenableState$1 && (thenableState$1 = createThenableState());
        return trackUsedThenable(thenableState$1, thenable, index);
    }
    function coerceRef(workInProgress, element) {
        element = element.props.ref;
        workInProgress.ref = void 0 !== element ? element : null;
    }
    function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
        if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        returnFiber = Object.prototype.toString.call(newChild);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber) + "). If you meant to render a collection of children, use an array instead.");
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(throwOnInvalidObjectTypeImpl.bind(null, returnFiber, newChild)) : throwOnInvalidObjectTypeImpl(returnFiber, newChild);
    }
    function warnOnFunctionTypeImpl(returnFiber, invalidChild) {
        var parentName = getComponentNameFromFiber(returnFiber) || "Component";
        ownerHasFunctionTypeWarning[parentName] || (ownerHasFunctionTypeWarning[parentName] = !0, invalidChild = invalidChild.displayName || invalidChild.name || "Component", 3 === returnFiber.tag ? console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  root.render(%s)", invalidChild, invalidChild, invalidChild) : console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  <%s>{%s}</%s>", invalidChild, invalidChild, parentName, invalidChild, parentName));
    }
    function warnOnFunctionType(returnFiber, invalidChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(warnOnFunctionTypeImpl.bind(null, returnFiber, invalidChild)) : warnOnFunctionTypeImpl(returnFiber, invalidChild);
    }
    function warnOnSymbolTypeImpl(returnFiber, invalidChild) {
        var parentName = getComponentNameFromFiber(returnFiber) || "Component";
        ownerHasSymbolTypeWarning[parentName] || (ownerHasSymbolTypeWarning[parentName] = !0, invalidChild = String(invalidChild), 3 === returnFiber.tag ? console.error("Symbols are not valid as a React child.\n  root.render(%s)", invalidChild) : console.error("Symbols are not valid as a React child.\n  <%s>%s</%s>", parentName, invalidChild, parentName));
    }
    function warnOnSymbolType(returnFiber, invalidChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(warnOnSymbolTypeImpl.bind(null, returnFiber, invalidChild)) : warnOnSymbolTypeImpl(returnFiber, invalidChild);
    }
    function createChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (shouldTrackSideEffects) {
                var deletions = returnFiber.deletions;
                null === deletions ? (returnFiber.deletions = [
                    childToDelete
                ], returnFiber.flags |= 16) : deletions.push(childToDelete);
            }
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) return null;
            for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return null;
        }
        function mapRemainingChildren(currentFirstChild) {
            for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            fiber = createWorkInProgress(fiber, pendingProps);
            fiber.index = 0;
            fiber.sibling = null;
            return fiber;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
            newIndex = newFiber.alternate;
            if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
            newFiber.flags |= 67108866;
            return lastPlacedIndex;
        }
        function placeSingleChild(newFiber) {
            shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current._debugOwner = returnFiber, current._debugTask = returnFiber._debugTask, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, textContent);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return current = updateFragment(returnFiber, current, element.props.children, lanes, element.key), validateFragmentProps(element, current, returnFiber), current;
            if (null !== current && (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current._debugOwner = element._owner, current._debugInfo = currentDebugInfo, current;
            current = createFiberFromElement(element, returnFiber.mode, lanes);
            coerceRef(current, element);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, portal.children || []);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current._debugOwner = returnFiber, current._debugTask = returnFiber._debugTask, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, fragment);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function createChild(returnFiber, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild._debugOwner = returnFiber, newChild._debugTask = returnFiber._debugTask, newChild._debugInfo = currentDebugInfo, newChild;
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return lanes = createFiberFromElement(newChild, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
                    case REACT_PORTAL_TYPE:
                        return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild._debugInfo = currentDebugInfo, newChild;
                    case REACT_LAZY_TYPE:
                        var _prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                        newChild = resolveLazy(newChild);
                        returnFiber = createChild(returnFiber, newChild, lanes);
                        currentDebugInfo = _prevDebugInfo;
                        return returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return lanes = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
                if ("function" === typeof newChild.then) return _prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = createChild(returnFiber, unwrapThenable(newChild), lanes), currentDebugInfo = _prevDebugInfo, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            var key = null !== oldFiber ? oldFiber.key : null;
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newChild.key === key ? (key = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(returnFiber, oldFiber, newChild, lanes), currentDebugInfo = key, returnFiber) : null;
                    case REACT_PORTAL_TYPE:
                        return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                    case REACT_LAZY_TYPE:
                        return key = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = updateSlot(returnFiber, oldFiber, newChild, lanes), currentDebugInfo = key, returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) {
                    if (null !== key) return null;
                    key = pushDebugInfo(newChild._debugInfo);
                    returnFiber = updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                    currentDebugInfo = key;
                    return returnFiber;
                }
                if ("function" === typeof newChild.then) return key = pushDebugInfo(newChild._debugInfo), returnFiber = updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes), currentDebugInfo = key, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newIdx = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(returnFiber, newIdx, newChild, lanes), currentDebugInfo = existingChildren, returnFiber;
                    case REACT_PORTAL_TYPE:
                        return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo);
                        newChild = resolveLazy(newChild);
                        returnFiber = updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
                        currentDebugInfo = _prevDebugInfo7;
                        return returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newIdx = existingChildren.get(newIdx) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateFragment(returnFiber, newIdx, newChild, lanes, null), currentDebugInfo = existingChildren, returnFiber;
                if ("function" === typeof newChild.then) return _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo), returnFiber = updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes), currentDebugInfo = _prevDebugInfo7, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys) {
            if ("object" !== typeof child || null === child) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(returnFiber, workInProgress, child);
                    var key = child.key;
                    if ("string" !== typeof key) break;
                    if (null === knownKeys) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    runWithFiberInDEV(workInProgress, function() {
                        console.error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    });
                    break;
                case REACT_LAZY_TYPE:
                    child = resolveLazy(child), warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys);
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            for(var knownKeys = null, resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                knownKeys = warnOnInvalidKey(returnFiber, newFiber, newChildren[newIdx], knownKeys);
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(returnFiber, oldFiber, newChildren[newIdx], knownKeys), currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(returnFiber, nextOldFiber, newChildren[newIdx], knownKeys), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
            if (null == newChildren) throw Error("An iterable object provided no iterator.");
            for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, knownKeys = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                knownKeys = warnOnInvalidKey(returnFiber, newFiber, step.value, knownKeys);
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; !step.done; newIdx++, step = newChildren.next())oldFiber = createChild(returnFiber, step.value, lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(returnFiber, oldFiber, step.value, knownKeys), currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(returnFiber, nextOldFiber, step.value, knownKeys), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
            "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (validateFragmentProps(newChild, null, returnFiber), newChild = newChild.props.children);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                        a: {
                            for(var key = newChild.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === key) {
                                    key = newChild.type;
                                    if (key === REACT_FRAGMENT_TYPE) {
                                        if (7 === currentFirstChild.tag) {
                                            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                            lanes = useFiber(currentFirstChild, newChild.props.children);
                                            lanes.return = returnFiber;
                                            lanes._debugOwner = newChild._owner;
                                            lanes._debugInfo = currentDebugInfo;
                                            validateFragmentProps(newChild, lanes, returnFiber);
                                            returnFiber = lanes;
                                            break a;
                                        }
                                    } else if (currentFirstChild.elementType === key || isCompatibleFamilyForHotReloading(currentFirstChild, newChild) || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props);
                                        coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        lanes._debugOwner = newChild._owner;
                                        lanes._debugInfo = currentDebugInfo;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, validateFragmentProps(newChild, lanes, returnFiber), returnFiber = lanes) : (lanes = createFiberFromElement(newChild, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes._debugInfo = currentDebugInfo, returnFiber = lanes);
                        }
                        returnFiber = placeSingleChild(returnFiber);
                        currentDebugInfo = prevDebugInfo;
                        return returnFiber;
                    case REACT_PORTAL_TYPE:
                        a: {
                            prevDebugInfo = newChild;
                            for(newChild = prevDebugInfo.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === newChild) {
                                    if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === prevDebugInfo.containerInfo && currentFirstChild.stateNode.implementation === prevDebugInfo.implementation) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, prevDebugInfo.children || []);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    } else {
                                        deleteRemainingChildren(returnFiber, currentFirstChild);
                                        break;
                                    }
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            lanes = createFiberFromPortal(prevDebugInfo, returnFiber.mode, lanes);
                            lanes.return = returnFiber;
                            returnFiber = lanes;
                        }
                        return placeSingleChild(returnFiber);
                    case REACT_LAZY_TYPE:
                        return prevDebugInfo = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                }
                if (isArrayImpl(newChild)) return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                if (getIteratorFn(newChild)) {
                    prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                    key = getIteratorFn(newChild);
                    if ("function" !== typeof key) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
                    var newChildren = key.call(newChild);
                    if (newChildren === newChild) {
                        if (0 !== returnFiber.tag || "[object GeneratorFunction]" !== Object.prototype.toString.call(returnFiber.type) || "[object Generator]" !== Object.prototype.toString.call(newChildren)) didWarnAboutGenerators || console.error("Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."), didWarnAboutGenerators = !0;
                    } else newChild.entries !== key || didWarnAboutMaps || (console.error("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0);
                    returnFiber = reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes);
                    currentDebugInfo = prevDebugInfo;
                    return returnFiber;
                }
                if ("function" === typeof newChild.then) return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return prevDebugInfo = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, prevDebugInfo), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(prevDebugInfo, returnFiber.mode, lanes), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, returnFiber = lanes), placeSingleChild(returnFiber);
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return function(returnFiber, currentFirstChild, newChild, lanes) {
            var prevDebugInfo = currentDebugInfo;
            currentDebugInfo = null;
            try {
                thenableIndexCounter$1 = 0;
                var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
                thenableState$1 = null;
                return firstChildFiber;
            } catch (x) {
                if (x === SuspenseException || x === SuspenseActionException) throw x;
                var fiber = createFiber(29, x, null, returnFiber.mode);
                fiber.lanes = lanes;
                fiber.return = returnFiber;
                var debugInfo = fiber._debugInfo = currentDebugInfo;
                fiber._debugOwner = returnFiber._debugOwner;
                fiber._debugTask = returnFiber._debugTask;
                if (null != debugInfo) {
                    for(var i = debugInfo.length - 1; 0 <= i; i--)if ("string" === typeof debugInfo[i].stack) {
                        fiber._debugOwner = debugInfo[i];
                        fiber._debugTask = debugInfo[i].debugTask;
                        break;
                    }
                }
                return fiber;
            } finally{
                currentDebugInfo = prevDebugInfo;
            }
        };
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArrayImpl(childSlot);
        childSlot = !isAnArray && "function" === typeof getIteratorFn(childSlot);
        return isAnArray || childSlot ? (isAnArray = isAnArray ? "array" : "iterable", console.error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", isAnArray, index, isAnArray), !1) : !0;
    }
    function initializeUpdateQueue(fiber) {
        fiber.updateQueue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                lanes: 0,
                hiddenCallbacks: null
            },
            callbacks: null
        };
    }
    function cloneUpdateQueue(current, workInProgress) {
        current = current.updateQueue;
        workInProgress.updateQueue === current && (workInProgress.updateQueue = {
            baseState: current.baseState,
            firstBaseUpdate: current.firstBaseUpdate,
            lastBaseUpdate: current.lastBaseUpdate,
            shared: current.shared,
            callbacks: null
        });
    }
    function createUpdate(lane) {
        return {
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (null === updateQueue) return null;
        updateQueue = updateQueue.shared;
        if (currentlyProcessingQueue === updateQueue && !didWarnUpdateInsideUpdate) {
            var componentName = getComponentNameFromFiber(fiber);
            console.error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.\n\nPlease update the following component: %s", componentName);
            didWarnUpdateInsideUpdate = !0;
        }
        if ((executionContext & RenderContext) !== NoContext) return componentName = updateQueue.pending, null === componentName ? update.next = update : (update.next = componentName.next, componentName.next = update), updateQueue.pending = update, update = getRootForUpdatedFiber(fiber), markUpdateLaneFromFiberToRoot(fiber, null, lane), update;
        enqueueUpdate$1(fiber, updateQueue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function entangleTransitions(root, fiber, lane) {
        fiber = fiber.updateQueue;
        if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
            var queueLanes = fiber.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            fiber.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        var queue = workInProgress.updateQueue, current = workInProgress.alternate;
        if (null !== current && (current = current.updateQueue, queue === current)) {
            var newFirst = null, newLast = null;
            queue = queue.firstBaseUpdate;
            if (null !== queue) {
                do {
                    var clone = {
                        lane: queue.lane,
                        tag: queue.tag,
                        payload: queue.payload,
                        callback: null,
                        next: null
                    };
                    null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                    queue = queue.next;
                }while (null !== queue);
                null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
            } else newFirst = newLast = capturedUpdate;
            queue = {
                baseState: current.baseState,
                firstBaseUpdate: newFirst,
                lastBaseUpdate: newLast,
                shared: current.shared,
                callbacks: current.callbacks
            };
            workInProgress.updateQueue = queue;
            return;
        }
        workInProgress = queue.lastBaseUpdate;
        null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function suspendIfUpdateReadFromEntangledAsyncAction() {
        if (didReadFromEntangledAsyncAction) {
            var entangledActionThenable = currentEntangledActionThenable;
            if (null !== entangledActionThenable) throw entangledActionThenable;
        }
    }
    function processUpdateQueue(workInProgress, props, instance$jscomp$0, renderLanes) {
        didReadFromEntangledAsyncAction = !1;
        var queue = workInProgress.updateQueue;
        hasForceUpdate = !1;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
        if (null !== pendingQueue) {
            queue.shared.pending = null;
            var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null;
            null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate;
            var current = workInProgress.alternate;
            null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
        }
        if (null !== firstBaseUpdate) {
            var newState = queue.baseState;
            lastBaseUpdate = 0;
            current = firstPendingUpdate = lastPendingUpdate = null;
            pendingQueue = firstBaseUpdate;
            do {
                var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
                if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    null !== current && (current = current.next = {
                        lane: 0,
                        tag: pendingQueue.tag,
                        payload: pendingQueue.payload,
                        callback: null,
                        next: null
                    });
                    a: {
                        updateLane = workInProgress;
                        var partialState = pendingQueue;
                        var nextProps = props, instance = instance$jscomp$0;
                        switch(partialState.tag){
                            case ReplaceState:
                                partialState = partialState.payload;
                                if ("function" === typeof partialState) {
                                    isDisallowedContextReadInDEV = !0;
                                    var nextState = partialState.call(instance, newState, nextProps);
                                    if (updateLane.mode & StrictLegacyMode) {
                                        setIsStrictModeForDevtools(!0);
                                        try {
                                            partialState.call(instance, newState, nextProps);
                                        } finally{
                                            setIsStrictModeForDevtools(!1);
                                        }
                                    }
                                    isDisallowedContextReadInDEV = !1;
                                    newState = nextState;
                                    break a;
                                }
                                newState = partialState;
                                break a;
                            case CaptureUpdate:
                                updateLane.flags = updateLane.flags & -65537 | 128;
                            case UpdateState:
                                nextState = partialState.payload;
                                if ("function" === typeof nextState) {
                                    isDisallowedContextReadInDEV = !0;
                                    partialState = nextState.call(instance, newState, nextProps);
                                    if (updateLane.mode & StrictLegacyMode) {
                                        setIsStrictModeForDevtools(!0);
                                        try {
                                            nextState.call(instance, newState, nextProps);
                                        } finally{
                                            setIsStrictModeForDevtools(!1);
                                        }
                                    }
                                    isDisallowedContextReadInDEV = !1;
                                } else partialState = nextState;
                                if (null === partialState || void 0 === partialState) break a;
                                newState = assign({}, newState, partialState);
                                break a;
                            case ForceUpdate:
                                hasForceUpdate = !0;
                        }
                    }
                    updateLane = pendingQueue.callback;
                    null !== updateLane && (workInProgress.flags |= 64, isHiddenUpdate && (workInProgress.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                        updateLane
                    ] : isHiddenUpdate.push(updateLane));
                } else isHiddenUpdate = {
                    lane: updateLane,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: pendingQueue.callback,
                    next: null
                }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
                pendingQueue = pendingQueue.next;
                if (null === pendingQueue) {
                    if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                    else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
                }
            }while (1);
            null === current && (lastPendingUpdate = newState);
            queue.baseState = lastPendingUpdate;
            queue.firstBaseUpdate = firstPendingUpdate;
            queue.lastBaseUpdate = current;
            null === firstBaseUpdate && (queue.shared.lanes = 0);
            workInProgressRootSkippedLanes |= lastBaseUpdate;
            workInProgress.lanes = lastBaseUpdate;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if ("function" !== typeof callback) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function commitHiddenCallbacks(updateQueue, context) {
        var hiddenCallbacks = updateQueue.shared.hiddenCallbacks;
        if (null !== hiddenCallbacks) for(updateQueue.shared.hiddenCallbacks = null, updateQueue = 0; updateQueue < hiddenCallbacks.length; updateQueue++)callCallback(hiddenCallbacks[updateQueue], context);
    }
    function commitCallbacks(updateQueue, context) {
        var callbacks = updateQueue.callbacks;
        if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
    }
    function pushHiddenContext(fiber, context) {
        var prevEntangledRenderLanes = entangledRenderLanes;
        push(prevEntangledRenderLanesCursor, prevEntangledRenderLanes, fiber);
        push(currentTreeHiddenStackCursor, context, fiber);
        entangledRenderLanes = prevEntangledRenderLanes | context.baseLanes;
    }
    function reuseHiddenContextOnStack(fiber) {
        push(prevEntangledRenderLanesCursor, entangledRenderLanes, fiber);
        push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current, fiber);
    }
    function popHiddenContext(fiber) {
        entangledRenderLanes = prevEntangledRenderLanesCursor.current;
        pop(currentTreeHiddenStackCursor, fiber);
        pop(prevEntangledRenderLanesCursor, fiber);
    }
    function pushPrimaryTreeSuspenseHandler(handler) {
        var current = handler.alternate;
        push(suspenseStackCursor, suspenseStackCursor.current & SubtreeSuspenseContextMask, handler);
        push(suspenseHandlerStackCursor, handler, handler);
        null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
    }
    function pushDehydratedActivitySuspenseHandler(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current, fiber);
        push(suspenseHandlerStackCursor, fiber, fiber);
        null === shellBoundary && (shellBoundary = fiber);
    }
    function pushOffscreenSuspenseHandler(fiber) {
        22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current, fiber), push(suspenseHandlerStackCursor, fiber, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
    }
    function reuseSuspenseHandlerOnStack(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current, fiber);
        push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current, fiber);
    }
    function popSuspenseHandler(fiber) {
        pop(suspenseHandlerStackCursor, fiber);
        shellBoundary === fiber && (shellBoundary = null);
        pop(suspenseStackCursor, fiber);
    }
    function findFirstSuspended(row) {
        for(var node = row; null !== node;){
            if (13 === node.tag) {
                var state = node.memoizedState;
                if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
            } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
                if (0 !== (node.flags & 128)) return node;
            } else if (null !== node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        null === hookTypesDev ? hookTypesDev = [
            hookName
        ] : hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (null !== hookTypesDev && (hookTypesUpdateIndexDev++, hookTypesDev[hookTypesUpdateIndexDev] !== hookName)) {
            var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
            if (!didWarnAboutMismatchedHooksForComponent.has(componentName) && (didWarnAboutMismatchedHooksForComponent.add(componentName), null !== hookTypesDev)) {
                for(var table = "", i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i], newHookName = i === hookTypesUpdateIndexDev ? hookName : oldHookName;
                    for(oldHookName = i + 1 + ". " + oldHookName; 30 > oldHookName.length;)oldHookName += " ";
                    oldHookName += newHookName + "\n";
                    table += oldHookName;
                }
                console.error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function checkDepsAreArrayDev(deps) {
        void 0 === deps || null === deps || isArrayImpl(deps) || console.error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnUseFormStateInDev() {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
        didWarnAboutUseFormState.has(componentName) || (didWarnAboutUseFormState.add(componentName), console.error("ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.", componentName));
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) return !1;
        if (null === prevDeps) return console.error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev), !1;
        nextDeps.length !== prevDeps.length && console.error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
        return !0;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber = workInProgress;
        hookTypesDev = null !== current ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1;
        ignorePreviousDependencies = null !== current && current.type !== workInProgress.type;
        if ("[object AsyncFunction]" === Object.prototype.toString.call(Component) || "[object AsyncGeneratorFunction]" === Object.prototype.toString.call(Component)) nextRenderLanes = getComponentNameFromFiber(currentlyRenderingFiber), didWarnAboutAsyncClientComponent.has(nextRenderLanes) || (didWarnAboutAsyncClientComponent.add(nextRenderLanes), console.error("%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.", null === nextRenderLanes ? "An unknown Component" : "<" + nextRenderLanes + ">"));
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = 0;
        ReactSharedInternals.H = null !== current && null !== current.memoizedState ? HooksDispatcherOnUpdateInDEV : null !== hookTypesDev ? HooksDispatcherOnMountWithHookTypesInDEV : HooksDispatcherOnMountInDEV;
        shouldDoubleInvokeUserFnsInHooksDEV = nextRenderLanes = (workInProgress.mode & StrictLegacyMode) !== NoMode;
        var children = callComponentInDEV(Component, props, secondArg);
        shouldDoubleInvokeUserFnsInHooksDEV = !1;
        didScheduleRenderPhaseUpdateDuringThisPass && (children = renderWithHooksAgain(workInProgress, Component, props, secondArg));
        if (nextRenderLanes) {
            setIsStrictModeForDevtools(!0);
            try {
                children = renderWithHooksAgain(workInProgress, Component, props, secondArg);
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        finishRenderingHooks(current, workInProgress);
        return children;
    }
    function finishRenderingHooks(current, workInProgress) {
        workInProgress._debugHookTypes = hookTypesDev;
        null === workInProgress.dependencies ? null !== thenableState && (workInProgress.dependencies = {
            lanes: 0,
            firstContext: null,
            _debugThenableState: thenableState
        }) : workInProgress.dependencies._debugThenableState = thenableState;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
        renderLanes = 0;
        hookTypesDev = currentHookNameInDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
        hookTypesUpdateIndexDev = -1;
        null !== current && (current.flags & 65011712) !== (workInProgress.flags & 65011712) && console.error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = !1;
        thenableIndexCounter = 0;
        thenableState = null;
        if (didRenderTooFewHooks) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
        needsToResetSuspendedThenableDEV ? (needsToResetSuspendedThenableDEV = !1, current = !0) : current = !1;
        current && (workInProgress = getComponentNameFromFiber(workInProgress) || "Unknown", didWarnAboutUseWrappedInTryCatch.has(workInProgress) || didWarnAboutAsyncClientComponent.has(workInProgress) || (didWarnAboutUseWrappedInTryCatch.add(workInProgress), console.error("`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary.")));
    }
    function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
        currentlyRenderingFiber = workInProgress;
        var numberOfReRenders = 0;
        do {
            didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
            thenableIndexCounter = 0;
            didScheduleRenderPhaseUpdateDuringThisPass = !1;
            if (numberOfReRenders >= RE_RENDER_LIMIT) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
            numberOfReRenders += 1;
            ignorePreviousDependencies = !1;
            workInProgressHook = currentHook = null;
            if (null != workInProgress.updateQueue) {
                var children = workInProgress.updateQueue;
                children.lastEffect = null;
                children.events = null;
                children.stores = null;
                null != children.memoCache && (children.memoCache.index = 0);
            }
            hookTypesUpdateIndexDev = -1;
            ReactSharedInternals.H = HooksDispatcherOnRerenderInDEV;
            children = callComponentInDEV(Component, props, secondArg);
        }while (didScheduleRenderPhaseUpdateDuringThisPass);
        return children;
    }
    function TransitionAwareHostComponent() {
        var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
        maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
        dispatcher = dispatcher.useState()[0];
        (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
        return maybeThenable;
    }
    function checkDidRenderIdHook() {
        var didRenderIdHook = 0 !== localIdCounter;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags = (workInProgress.mode & StrictEffectsMode) !== NoMode ? workInProgress.flags & -402655237 : workInProgress.flags & -2053;
        current.lanes &= ~lanes;
    }
    function resetHooksOnUnwind(workInProgress) {
        if (didScheduleRenderPhaseUpdate) {
            for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
                var queue = workInProgress.queue;
                null !== queue && (queue.pending = null);
                workInProgress = workInProgress.next;
            }
            didScheduleRenderPhaseUpdate = !1;
        }
        renderLanes = 0;
        hookTypesDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        thenableIndexCounter = localIdCounter = 0;
        thenableState = null;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        if (null === currentHook) {
            var nextCurrentHook = currentlyRenderingFiber.alternate;
            nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
        if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
        else {
            if (null === nextCurrentHook) {
                if (null === currentlyRenderingFiber.alternate) throw Error("Update hook called on initial render. This is likely a bug in React. Please file an issue.");
                throw Error("Rendered more hooks than during the previous render.");
            }
            currentHook = nextCurrentHook;
            nextCurrentHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        };
    }
    function useThenable(thenable) {
        var index = thenableIndexCounter;
        thenableIndexCounter += 1;
        null === thenableState && (thenableState = createThenableState());
        thenable = trackUsedThenable(thenableState, thenable, index);
        index = currentlyRenderingFiber;
        null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null !== index && null !== index.memoizedState ? HooksDispatcherOnUpdateInDEV : HooksDispatcherOnMountInDEV);
        return thenable;
    }
    function use(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return useThenable(usable);
            if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
        }
        throw Error("An unsupported type was passed to use(): " + String(usable));
    }
    function useMemoCache(size) {
        var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
        null !== updateQueue && (memoCache = updateQueue.memoCache);
        if (null == memoCache) {
            var current = currentlyRenderingFiber.alternate;
            null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
                data: current.data.map(function(array) {
                    return array.slice();
                }),
                index: 0
            })));
        }
        null == memoCache && (memoCache = {
            data: [],
            index: 0
        });
        null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
        updateQueue.memoCache = memoCache;
        updateQueue = memoCache.data[memoCache.index];
        if (void 0 === updateQueue || ignorePreviousDependencies) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
        else updateQueue.length !== size && console.error("Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.", updateQueue.length, size);
        memoCache.index++;
        return updateQueue;
    }
    function basicStateReducer(state, action) {
        return "function" === typeof action ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    }
    function updateReducer(reducer) {
        var hook = updateWorkInProgressHook();
        return updateReducerImpl(hook, currentHook, reducer);
    }
    function updateReducerImpl(hook, current, reducer) {
        var queue = hook.queue;
        if (null === queue) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
        queue.lastRenderedReducer = reducer;
        var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
        if (null !== pendingQueue) {
            if (null !== baseQueue) {
                var baseFirst = baseQueue.next;
                baseQueue.next = pendingQueue.next;
                pendingQueue.next = baseFirst;
            }
            current.baseQueue !== baseQueue && console.error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        pendingQueue = hook.baseState;
        if (null === baseQueue) hook.memoizedState = pendingQueue;
        else {
            current = baseQueue.next;
            var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction = !1;
            do {
                var updateLane = update.lane & -536870913;
                if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    var revertLane = update.revertLane;
                    if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                        lane: 0,
                        revertLane: 0,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    else if ((renderLanes & revertLane) === revertLane) {
                        update = update.next;
                        revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                        continue;
                    } else updateLane = {
                        lane: 0,
                        revertLane: update.revertLane,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                    updateLane = update.action;
                    shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                    pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
                } else revertLane = {
                    lane: updateLane,
                    revertLane: update.revertLane,
                    gesture: update.gesture,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
                update = update.next;
            }while (null !== update && update !== current);
            null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
            if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
            hook.memoizedState = pendingQueue;
            hook.baseState = baseFirst;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = pendingQueue;
        }
        null === baseQueue && (queue.lanes = 0);
        return [
            hook.memoizedState,
            queue.dispatch
        ];
    }
    function rerenderReducer(reducer) {
        var hook = updateWorkInProgressHook(), queue = hook.queue;
        if (null === queue) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
        queue.lastRenderedReducer = reducer;
        var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
        if (null !== lastRenderPhaseUpdate) {
            queue.pending = null;
            var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            do newState = reducer(newState, update.action), update = update.next;
            while (update !== lastRenderPhaseUpdate);
            objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
            hook.memoizedState = newState;
            null === hook.baseQueue && (hook.baseState = newState);
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            var nextSnapshot = getServerSnapshot();
            didWarnUncachedGetSnapshot || nextSnapshot === getServerSnapshot() || (console.error("The result of getServerSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        } else {
            nextSnapshot = getSnapshot();
            didWarnUncachedGetSnapshot || (getServerSnapshot = getSnapshot(), objectIs(nextSnapshot, getServerSnapshot) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0));
            if (null === workInProgressRoot) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        hook.memoizedState = nextSnapshot;
        getServerSnapshot = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = getServerSnapshot;
        mountEffect(subscribeToStore.bind(null, fiber, getServerSnapshot, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(HasEffect | Passive, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, getServerSnapshot, nextSnapshot, getSnapshot), null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
        if (isHydrating$jscomp$0) {
            if (void 0 === getServerSnapshot) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            getServerSnapshot = getServerSnapshot();
        } else if (getServerSnapshot = getSnapshot(), !didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            objectIs(getServerSnapshot, cachedSnapshot) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        if (cachedSnapshot = !objectIs((currentHook || hook).memoizedState, getServerSnapshot)) hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0;
        hook = hook.queue;
        var create = subscribeToStore.bind(null, fiber, hook, subscribe);
        updateEffectImpl(2048, Passive, create, [
            subscribe
        ]);
        if (hook.getSnapshot !== getSnapshot || cachedSnapshot || null !== workInProgressHook && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= 2048;
            pushSimpleEffect(HasEffect | Passive, {
                destroy: void 0
            }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
            if (null === workInProgressRoot) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        return getServerSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= 16384;
        fiber = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        getSnapshot = currentlyRenderingFiber.updateQueue;
        null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
            fiber
        ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
            fiber
        ] : renderedSnapshot.push(fiber));
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && (startUpdateTimerByLane(2, "updateSyncExternalStore()", fiber), forceStoreRerender(fiber));
        });
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    }
    function mountStateImpl(initialState) {
        var hook = mountWorkInProgressHook();
        if ("function" === typeof initialState) {
            var initialStateInitializer = initialState;
            initialState = initialStateInitializer();
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    initialStateInitializer();
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        }
        hook.memoizedState = hook.baseState = initialState;
        hook.queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        return hook;
    }
    function mountState(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    }
    function mountOptimistic(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    }
    function updateOptimistic(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    }
    function updateOptimisticImpl(hook, current, passthrough, reducer) {
        hook.baseState = passthrough;
        return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
    }
    function rerenderOptimistic(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    }
    function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
        if (isRenderPhaseUpdate(fiber)) throw Error("Cannot update form state while rendering.");
        fiber = actionQueue.action;
        if (null !== fiber) {
            var actionNode = {
                payload: payload,
                action: fiber,
                next: null,
                isTransition: !0,
                status: "pending",
                value: null,
                reason: null,
                listeners: [],
                then: function(listener) {
                    actionNode.listeners.push(listener);
                }
            };
            null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
            setState(actionNode);
            setPendingState = actionQueue.pending;
            null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
        }
    }
    function runActionStateAction(actionQueue, node) {
        var action = node.action, payload = node.payload, prevState = actionQueue.state;
        if (node.isTransition) {
            var prevTransition = ReactSharedInternals.T, currentTransition = {};
            currentTransition._updatedFibers = new Set();
            ReactSharedInternals.T = currentTransition;
            try {
                var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
                null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
                handleActionReturnValue(actionQueue, node, returnValue);
            } catch (error) {
                onActionError(actionQueue, node, error);
            } finally{
                null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (actionQueue = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < actionQueue && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
            }
        } else try {
            currentTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, currentTransition);
        } catch (error$4) {
            onActionError(actionQueue, node, error$4);
        }
    }
    function handleActionReturnValue(actionQueue, node, returnValue) {
        null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(function(nextState) {
            onActionSuccess(actionQueue, node, nextState);
        }, function(error) {
            return onActionError(actionQueue, node, error);
        }), node.isTransition || console.error("An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop.")) : onActionSuccess(actionQueue, node, returnValue);
    }
    function onActionSuccess(actionQueue, actionNode, nextState) {
        actionNode.status = "fulfilled";
        actionNode.value = nextState;
        notifyActionListeners(actionNode);
        actionQueue.state = nextState;
        actionNode = actionQueue.pending;
        null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
    }
    function onActionError(actionQueue, actionNode, error) {
        var last = actionQueue.pending;
        actionQueue.pending = null;
        if (null !== last) {
            last = last.next;
            do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
            while (actionNode !== last);
        }
        actionQueue.action = null;
    }
    function notifyActionListeners(actionNode) {
        actionNode = actionNode.listeners;
        for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
    }
    function actionStateReducer(oldState, newState) {
        return newState;
    }
    function mountActionState(action, initialStateProp) {
        if (isHydrating) {
            var ssrFormState = workInProgressRoot.formState;
            if (null !== ssrFormState) {
                a: {
                    var isMatching = currentlyRenderingFiber;
                    if (isHydrating) {
                        if (nextHydratableInstance) {
                            b: {
                                var markerInstance = nextHydratableInstance;
                                for(var inRootOrSingleton = rootOrSingletonContext; 8 !== markerInstance.nodeType;){
                                    if (!inRootOrSingleton) {
                                        markerInstance = null;
                                        break b;
                                    }
                                    markerInstance = getNextHydratable(markerInstance.nextSibling);
                                    if (null === markerInstance) {
                                        markerInstance = null;
                                        break b;
                                    }
                                }
                                inRootOrSingleton = markerInstance.data;
                                markerInstance = inRootOrSingleton === FORM_STATE_IS_MATCHING || inRootOrSingleton === FORM_STATE_IS_NOT_MATCHING ? markerInstance : null;
                            }
                            if (markerInstance) {
                                nextHydratableInstance = getNextHydratable(markerInstance.nextSibling);
                                isMatching = markerInstance.data === FORM_STATE_IS_MATCHING;
                                break a;
                            }
                        }
                        throwOnHydrationMismatch(isMatching);
                    }
                    isMatching = !1;
                }
                isMatching && (initialStateProp = ssrFormState[0]);
            }
        }
        ssrFormState = mountWorkInProgressHook();
        ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
        isMatching = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: actionStateReducer,
            lastRenderedState: initialStateProp
        };
        ssrFormState.queue = isMatching;
        ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, isMatching);
        isMatching.dispatch = ssrFormState;
        isMatching = mountStateImpl(!1);
        inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, isMatching.queue);
        isMatching = mountWorkInProgressHook();
        markerInstance = {
            state: initialStateProp,
            dispatch: null,
            action: action,
            pending: null
        };
        isMatching.queue = markerInstance;
        ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, markerInstance, inRootOrSingleton, ssrFormState);
        markerInstance.dispatch = ssrFormState;
        isMatching.memoizedState = action;
        return [
            initialStateProp,
            ssrFormState,
            !1
        ];
    }
    function updateActionState(action) {
        var stateHook = updateWorkInProgressHook();
        return updateActionStateImpl(stateHook, currentHook, action);
    }
    function updateActionStateImpl(stateHook, currentStateHook, action) {
        currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
        stateHook = updateReducer(basicStateReducer)[0];
        if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
            var state = useThenable(currentStateHook);
        } catch (x) {
            if (x === SuspenseException) throw SuspenseActionException;
            throw x;
        }
        else state = currentStateHook;
        currentStateHook = updateWorkInProgressHook();
        var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
        action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(HasEffect | Passive, {
            destroy: void 0
        }, actionStateActionEffect.bind(null, actionQueue, action), null));
        return [
            state,
            dispatch,
            stateHook
        ];
    }
    function actionStateActionEffect(actionQueue, action) {
        actionQueue.action = action;
    }
    function rerenderActionState(action) {
        var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
        if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
        updateWorkInProgressHook();
        stateHook = stateHook.memoizedState;
        currentStateHook = updateWorkInProgressHook();
        var dispatch = currentStateHook.queue.dispatch;
        currentStateHook.memoizedState = action;
        return [
            stateHook,
            dispatch,
            !1
        ];
    }
    function pushSimpleEffect(tag, inst, create, deps) {
        tag = {
            tag: tag,
            create: create,
            deps: deps,
            inst: inst,
            next: null
        };
        inst = currentlyRenderingFiber.updateQueue;
        null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
        create = inst.lastEffect;
        null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
        return tag;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        currentlyRenderingFiber.flags |= fiberFlags;
        hook.memoizedState = pushSimpleEffect(HasEffect | hookFlags, {
            destroy: void 0
        }, create, void 0 === deps ? null : deps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var inst = hook.memoizedState.inst;
        null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(HasEffect | hookFlags, inst, create, deps));
    }
    function mountEffect(create, deps) {
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode ? mountEffectImpl(276826112, Passive, create, deps) : mountEffectImpl(8390656, Passive, create, deps);
    }
    function useEffectEventImpl(payload) {
        currentlyRenderingFiber.flags |= 4;
        var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
        if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
            payload
        ];
        else {
            var events = componentUpdateQueue.events;
            null === events ? componentUpdateQueue.events = [
                payload
            ] : events.push(payload);
        }
    }
    function mountEvent(callback) {
        var hook = mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if ((executionContext & RenderContext) !== NoContext) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
            return ref.impl.apply(void 0, arguments);
        };
    }
    function updateEvent(callback) {
        var ref = updateWorkInProgressHook().memoizedState;
        useEffectEventImpl({
            ref: ref,
            nextImpl: callback
        });
        return function() {
            if ((executionContext & RenderContext) !== NoContext) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
            return ref.impl.apply(void 0, arguments);
        };
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = 4194308;
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if ("function" === typeof ref) {
            create = create();
            var refCleanup = ref(create);
            return function() {
                "function" === typeof refCleanup ? refCleanup() : ref(null);
            };
        }
        if (null !== ref && void 0 !== ref) return ref.hasOwnProperty("current") || console.error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(ref).join(", ") + "}"), create = create(), ref.current = create, function() {
            ref.current = null;
        };
    }
    function mountImperativeHandle(ref, create, deps) {
        "function" !== typeof create && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== create ? typeof create : "null");
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = 4194308;
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
        mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function updateImperativeHandle(ref, create, deps) {
        "function" !== typeof create && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== create ? typeof create : "null");
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        updateEffectImpl(4, Layout, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function mountCallback(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        hook.memoizedState = [
            callback,
            deps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        prevState = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            prevState,
            deps
        ];
        return prevState;
    }
    function mountDeferredValue(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    }
    function updateDeferredValue(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    }
    function rerenderDeferredValue(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    }
    function mountDeferredValueImpl(hook, value, initialValue) {
        if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
        hook.memoizedState = initialValue;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return initialValue;
    }
    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
        if (objectIs(value, prevValue)) return value;
        if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
        if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return prevValue;
    }
    function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
    }
    function startTransition(fiber, queue, pendingState, finishedState, callback) {
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 0 !== previousPriority && previousPriority < ContinuousEventPriority ? previousPriority : ContinuousEventPriority;
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition._updatedFibers = new Set();
        ReactSharedInternals.T = currentTransition;
        dispatchOptimisticSetState(fiber, !1, queue, pendingState);
        try {
            var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
                ReactSharedInternals.asyncTransitions++;
                returnValue.then(releaseAsyncTransition, releaseAsyncTransition);
                var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
                dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
            } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
        } catch (error) {
            dispatchSetStateInternal(fiber, queue, {
                then: function() {},
                status: "rejected",
                reason: error
            }, requestUpdateLane(fiber));
        } finally{
            ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (fiber = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < fiber && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
        }
    }
    function startHostTransition(formFiber, pendingState, action, formData) {
        if (5 !== formFiber.tag) throw Error("Expected the form instance to be a HostComponent. This is a bug in React.");
        var queue = ensureFormComponentIsStateful(formFiber).queue;
        startHostActionTimer(formFiber);
        startTransition(formFiber, queue, pendingState, NotPendingTransition, null === action ? noop : function() {
            requestFormReset$1(formFiber);
            return action(formData);
        });
    }
    function ensureFormComponentIsStateful(formFiber) {
        var existingStateHook = formFiber.memoizedState;
        if (null !== existingStateHook) return existingStateHook;
        existingStateHook = {
            memoizedState: NotPendingTransition,
            baseState: NotPendingTransition,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: NotPendingTransition
            },
            next: null
        };
        var initialResetState = {};
        existingStateHook.next = {
            memoizedState: initialResetState,
            baseState: initialResetState,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: initialResetState
            },
            next: null
        };
        formFiber.memoizedState = existingStateHook;
        formFiber = formFiber.alternate;
        null !== formFiber && (formFiber.memoizedState = existingStateHook);
        return existingStateHook;
    }
    function requestFormReset$1(formFiber) {
        null === ReactSharedInternals.T && console.error("requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition.");
        var stateHook = ensureFormComponentIsStateful(formFiber);
        null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
        dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane(formFiber));
    }
    function mountTransition() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    }
    function updateTransition() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    }
    function rerenderTransition() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    }
    function useHostTransitionStatus() {
        return readContext(HostTransitionContext);
    }
    function mountId() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var treeId = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            treeId = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + treeId;
            identifierPrefix = "_" + identifierPrefix + "R_" + treeId;
            treeId = localIdCounter++;
            0 < treeId && (identifierPrefix += "H" + treeId.toString(32));
            identifierPrefix += "_";
        } else treeId = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + treeId.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    }
    function mountRefresh() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    }
    function refreshCache(fiber, seedKey) {
        for(var provider = fiber.return; null !== provider;){
            switch(provider.tag){
                case 24:
                case 3:
                    var lane = requestUpdateLane(provider), refreshUpdate = createUpdate(lane), root = enqueueUpdate(provider, refreshUpdate, lane);
                    null !== root && (startUpdateTimerByLane(lane, "refresh()", fiber), scheduleUpdateOnFiber(root, provider, lane), entangleTransitions(root, provider, lane));
                    fiber = createCache();
                    null !== seedKey && void 0 !== seedKey && null !== root && console.error("The seed argument is not enabled outside experimental channels.");
                    refreshUpdate.payload = {
                        cache: fiber
                    };
                    return;
            }
            provider = provider.return;
        }
    }
    function dispatchReducerAction(fiber, queue, action) {
        var args = arguments;
        "function" === typeof args[3] && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        args = requestUpdateLane(fiber);
        var update = {
            lane: args,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, update) : (update = enqueueConcurrentHookUpdate(fiber, queue, update, args), null !== update && (startUpdateTimerByLane(args, "dispatch()", fiber), scheduleUpdateOnFiber(update, fiber, args), entangleTransitionUpdate(update, queue, args)));
    }
    function dispatchSetState(fiber, queue, action) {
        var args = arguments;
        "function" === typeof args[3] && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        args = requestUpdateLane(fiber);
        dispatchSetStateInternal(fiber, queue, action, args) && startUpdateTimerByLane(args, "setState()", fiber);
    }
    function dispatchSetStateInternal(fiber, queue, action, lane) {
        var update = {
            lane: lane,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) {
                var prevDispatcher = ReactSharedInternals.H;
                ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
                try {
                    var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
                    update.hasEagerState = !0;
                    update.eagerState = eagerState;
                    if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
                } catch (error) {} finally{
                    ReactSharedInternals.H = prevDispatcher;
                }
            }
            action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
        }
        return !1;
    }
    function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
        null === ReactSharedInternals.T && 0 === currentEntangledLane && console.error("An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition.");
        action = {
            lane: 2,
            revertLane: requestTransitionLane(),
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) {
            if (throwIfDuringRender) throw Error("Cannot update optimistic state while rendering.");
            console.error("Cannot call startTransition while rendering.");
        } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && (startUpdateTimerByLane(2, "setOptimistic()", fiber), scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2));
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
        var pending = queue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        queue.pending = update;
    }
    function entangleTransitionUpdate(root, queue, lane) {
        if (0 !== (lane & 4194048)) {
            var queueLanes = queue.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            queue.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function warnOnInvalidCallback(callback) {
        if (null !== callback && "function" !== typeof callback) {
            var key = String(callback);
            didWarnOnInvalidCallback.has(key) || (didWarnOnInvalidCallback.add(key), console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", callback));
        }
    }
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState, partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(!0);
            try {
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        void 0 === partialState && (ctor = getComponentNameFromType(ctor) || "Component", didWarnAboutUndefinedDerivedState.has(ctor) || (didWarnAboutUndefinedDerivedState.add(ctor), console.error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", ctor)));
        prevState = null === partialState || void 0 === partialState ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = prevState;
        0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = prevState);
    }
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if ("function" === typeof instance.shouldComponentUpdate) {
            oldProps = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    oldProps = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            void 0 === oldProps && console.error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return oldProps;
        }
        return ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
        "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        instance.state !== oldState && (workInProgress = getComponentNameFromFiber(workInProgress) || "Component", didWarnAboutStateAssignmentForComponent.has(workInProgress) || (didWarnAboutStateAssignmentForComponent.add(workInProgress), console.error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", workInProgress)), classComponentUpdater.enqueueReplaceState(instance, instance.state, null));
    }
    function resolveClassComponentProps(Component, baseProps) {
        var newProps = baseProps;
        if ("ref" in baseProps) {
            newProps = {};
            for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
        }
        if (Component = Component.defaultProps) {
            newProps === baseProps && (newProps = assign({}, newProps));
            for(var _propName in Component)void 0 === newProps[_propName] && (newProps[_propName] = Component[_propName]);
        }
        return newProps;
    }
    function defaultOnUncaughtError(error) {
        reportGlobalError(error);
        console.warn("%s\n\n%s\n", componentName ? "An error occurred in the <" + componentName + "> component." : "An error occurred in one of your React components.", "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://react.dev/link/error-boundaries to learn more about error boundaries.");
    }
    function defaultOnCaughtError(error) {
        var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component." : "The above error occurred in one of your React components.", recreateMessage = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((errorBoundaryName || "Anonymous") + ".");
        if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
            var JSCompiler_inline_result = error.environmentName;
            error = [
                "%o\n\n%s\n\n%s\n",
                error,
                componentNameMessage,
                recreateMessage
            ].slice(0);
            "string" === typeof error[0] ? error.splice(0, 1, badgeFormat + " " + error[0], badgeStyle, pad + JSCompiler_inline_result + pad, resetStyle) : error.splice(0, 0, badgeFormat, badgeStyle, pad + JSCompiler_inline_result + pad, resetStyle);
            error.unshift(console);
            JSCompiler_inline_result = bind.apply(console.error, error);
            JSCompiler_inline_result();
        } else console.error("%o\n\n%s\n\n%s\n", error, componentNameMessage, recreateMessage);
    }
    function defaultOnRecoverableError(error) {
        reportGlobalError(error);
    }
    function logUncaughtError(root, errorInfo) {
        try {
            componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
            errorBoundaryName = null;
            var error = errorInfo.value;
            if (null !== ReactSharedInternals.actQueue) ReactSharedInternals.thrownErrors.push(error);
            else {
                var onUncaughtError = root.onUncaughtError;
                onUncaughtError(error, {
                    componentStack: errorInfo.stack
                });
            }
        } catch (e$5) {
            setTimeout(function() {
                throw e$5;
            });
        }
    }
    function logCaughtError(root, boundary, errorInfo) {
        try {
            componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
            errorBoundaryName = getComponentNameFromFiber(boundary);
            var onCaughtError = root.onCaughtError;
            onCaughtError(errorInfo.value, {
                componentStack: errorInfo.stack,
                errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
            });
        } catch (e$6) {
            setTimeout(function() {
                throw e$6;
            });
        }
    }
    function createRootErrorUpdate(root, errorInfo, lane) {
        lane = createUpdate(lane);
        lane.tag = CaptureUpdate;
        lane.payload = {
            element: null
        };
        lane.callback = function() {
            runWithFiberInDEV(errorInfo.source, logUncaughtError, root, errorInfo);
        };
        return lane;
    }
    function createClassErrorUpdate(lane) {
        lane = createUpdate(lane);
        lane.tag = CaptureUpdate;
        return lane;
    }
    function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if ("function" === typeof getDerivedStateFromError) {
            var error = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                runWithFiberInDEV(errorInfo.source, logCaughtError, root, fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
            runWithFiberInDEV(errorInfo.source, logCaughtError, root, fiber, errorInfo);
            "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
                this
            ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
            callComponentDidCatchInDEV(this, errorInfo);
            "function" === typeof getDerivedStateFromError || 0 === (fiber.lanes & 2) && console.error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
        });
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        sourceFiber.flags |= 32768;
        isDevToolsPresent && restorePendingUpdaters(root, rootRenderLanes);
        if (null !== value && "object" === typeof value && "function" === typeof value.then) {
            returnFiber = sourceFiber.alternate;
            null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
            isHydrating && (didSuspendOrErrorDEV = !0);
            sourceFiber = suspenseHandlerStackCursor.current;
            if (null !== sourceFiber) {
                switch(sourceFiber.tag){
                    case 31:
                    case 13:
                        return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootSuspended), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                            value
                        ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                    case 22:
                        return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                            transitions: null,
                            markerInstances: null,
                            retryQueue: new Set([
                                value
                            ])
                        }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                            value
                        ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
                }
                throw Error("Unexpected Suspense handler tag (" + sourceFiber.tag + "). This is a bug in React.");
            }
            attachPingListener(root, value, rootRenderLanes);
            renderDidSuspendDelayIfPossible();
            return !1;
        }
        if (isHydrating) return didSuspendOrErrorDEV = !0, returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && queueHydrationError(createCapturedValueAtFiber(Error("There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.", {
            cause: value
        }), sourceFiber))) : (value !== HydrationMismatchException && queueHydrationError(createCapturedValueAtFiber(Error("There was an error while hydrating but React was able to recover by instead client rendering the entire root.", {
            cause: value
        }), sourceFiber)), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored)), !1;
        var error = createCapturedValueAtFiber(Error("There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.", {
            cause: value
        }), sourceFiber);
        null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
            error
        ] : workInProgressRootConcurrentErrors.push(error);
        workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored);
        if (null === returnFiber) return !0;
        value = createCapturedValueAtFiber(value, sourceFiber);
        sourceFiber = returnFiber;
        do {
            switch(sourceFiber.tag){
                case 3:
                    return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
                case 1:
                    if (returnFiber = sourceFiber.type, error = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== error && "function" === typeof error.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(error)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
            }
            sourceFiber = sourceFiber.return;
        }while (null !== sourceFiber);
        return !1;
    }
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        Component = Component.render;
        var ref = workInProgress.ref;
        if ("ref" in nextProps) {
            var propsWithoutRef = {};
            for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
        } else propsWithoutRef = nextProps;
        prepareToReadContext(workInProgress);
        nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
        key = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && key && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null === current) {
            var type = Component.type;
            if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return Component = resolveFunctionForHotReloading(type), workInProgress.tag = 15, workInProgress.type = Component, validateFunctionComponentInDev(workInProgress, type), updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes);
            current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            current.ref = workInProgress.ref;
            current.return = workInProgress;
            return workInProgress.child = current;
        }
        type = current.child;
        if (!checkScheduledUpdateOrContext(current, renderLanes)) {
            var prevProps = type.memoizedProps;
            Component = Component.compare;
            Component = null !== Component ? Component : shallowEqual;
            if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        workInProgress.flags |= 1;
        current = createWorkInProgress(type, nextProps);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null !== current) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
                else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
        var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
        null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
            _visibility: OffscreenVisible,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        if ("hidden" === nextProps.mode) {
            if (0 !== (workInProgress.flags & 128)) {
                prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
                if (null !== current) {
                    nextProps = workInProgress.child = current.child;
                    for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                    nextProps = nextChildren & ~prevState;
                } else nextProps = 0, workInProgress.child = null;
                return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
            }
            if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(workInProgress), pushOffscreenSuspenseHandler(workInProgress);
            else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
        } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(workInProgress), reuseSuspenseHandlerOnStack(workInProgress));
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function bailoutOffscreenComponent(current, workInProgress) {
        null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
            _visibility: OffscreenVisible,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        return workInProgress.sibling;
    }
    function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
        var JSCompiler_inline_result = peekCacheFromPool();
        JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
            parent: CacheContext._currentValue,
            pool: JSCompiler_inline_result
        };
        workInProgress.memoizedState = {
            baseLanes: nextBaseLanes,
            cachePool: JSCompiler_inline_result
        };
        null !== current && pushTransition(workInProgress, null);
        reuseHiddenContextOnStack(workInProgress);
        pushOffscreenSuspenseHandler(workInProgress);
        null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
        workInProgress.childLanes = remainingChildLanes;
        return null;
    }
    function mountActivityChildren(workInProgress, nextProps) {
        var hiddenProp = nextProps.hidden;
        void 0 !== hiddenProp && console.error('<Activity> doesn\'t accept a hidden prop. Use mode="hidden" instead.\n- <Activity %s>\n+ <Activity %s>', !0 === hiddenProp ? "hidden" : !1 === hiddenProp ? "hidden={false}" : "hidden={...}", hiddenProp ? 'mode="hidden"' : 'mode="visible"');
        nextProps = mountWorkInProgressOffscreenFiber({
            mode: nextProps.mode,
            children: nextProps.children
        }, workInProgress.mode);
        nextProps.ref = workInProgress.ref;
        workInProgress.child = nextProps;
        nextProps.return = workInProgress;
        return nextProps;
    }
    function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
        current.flags |= 2;
        popSuspenseHandler(workInProgress);
        workInProgress.memoizedState = null;
        return current;
    }
    function updateActivityComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
        workInProgress.flags &= -129;
        if (null === current) {
            if (isHydrating) {
                if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, bailoutOffscreenComponent(null, current);
                pushDehydratedActivitySuspenseHandler(workInProgress);
                (current = nextHydratableInstance) ? (renderLanes = canHydrateHydrationBoundary(current, rootOrSingletonContext), renderLanes = null !== renderLanes && renderLanes.data === ACTIVITY_START_DATA ? renderLanes : null, null !== renderLanes && (nextProps = {
                    dehydrated: renderLanes,
                    treeContext: getSuspendedTreeContext(),
                    retryLane: 536870912,
                    hydrationErrors: null
                }, workInProgress.memoizedState = nextProps, nextProps = createFiberFromDehydratedFragment(renderLanes), nextProps.return = workInProgress, workInProgress.child = nextProps, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : renderLanes = null;
                if (null === renderLanes) throw warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress);
                workInProgress.lanes = 536870912;
                return null;
            }
            return mountActivityChildren(workInProgress, nextProps);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var activityInstance = prevState.dehydrated;
            pushDehydratedActivitySuspenseHandler(workInProgress);
            if (didSuspend) {
                if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
                else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
                else throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
            } else if (warnIfHydrating(), 0 !== (renderLanes & 536870912) && markRenderDerivedCause(workInProgress), didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
                nextProps = workInProgressRoot;
                if (null !== nextProps && (activityInstance = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== activityInstance && activityInstance !== prevState.retryLane)) throw prevState.retryLane = activityInstance, enqueueConcurrentRenderForLane(current, activityInstance), scheduleUpdateOnFiber(nextProps, current, activityInstance), SelectiveHydrationException;
                renderDidSuspendDelayIfPossible();
                workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            } else current = prevState.treeContext, nextHydratableInstance = getNextHydratable(activityInstance.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
            return workInProgress;
        }
        prevState = current.child;
        nextProps = {
            mode: nextProps.mode,
            children: nextProps.children
        };
        0 !== (renderLanes & 536870912) && 0 !== (renderLanes & current.lanes) && markRenderDerivedCause(workInProgress);
        current = createWorkInProgress(prevState, nextProps);
        current.ref = workInProgress.ref;
        workInProgress.child = current;
        current.return = workInProgress;
        return current;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
        else {
            if ("function" !== typeof ref && "object" !== typeof ref) throw Error("Expected ref to be a function, an object returned by React.createRef(), or undefined/null.");
            if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (Component.prototype && "function" === typeof Component.prototype.render) {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            didWarnAboutBadClass[componentName] || (console.error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName), didWarnAboutBadClass[componentName] = !0);
        }
        workInProgress.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        null === current && (validateFunctionComponentInDev(workInProgress, workInProgress.type), Component.contextTypes && (componentName = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypes[componentName] || (didWarnAboutContextTypes[componentName] = !0, console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)", componentName))));
        prepareToReadContext(workInProgress);
        Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
        nextProps = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, Component, renderLanes);
        return workInProgress.child;
    }
    function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
        prepareToReadContext(workInProgress);
        hookTypesUpdateIndexDev = -1;
        ignorePreviousDependencies = null !== current && current.type !== workInProgress.type;
        workInProgress.updateQueue = null;
        nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
        finishRenderingHooks(current, workInProgress);
        Component = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && Component && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        switch(shouldErrorImpl(workInProgress)){
            case !1:
                var _instance = workInProgress.stateNode, state = new workInProgress.type(workInProgress.memoizedProps, _instance.context).state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case !0:
                workInProgress.flags |= 128;
                workInProgress.flags |= 65536;
                _instance = Error("Simulated error coming from DevTools");
                var lane = renderLanes & -renderLanes;
                workInProgress.lanes |= lane;
                state = workInProgressRoot;
                if (null === state) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
                lane = createClassErrorUpdate(lane);
                initializeClassErrorUpdate(lane, state, workInProgress, createCapturedValueAtFiber(_instance, workInProgress));
                enqueueCapturedUpdate(workInProgress, lane);
        }
        prepareToReadContext(workInProgress);
        if (null === workInProgress.stateNode) {
            state = emptyContextObject;
            _instance = Component.contextType;
            "contextType" in Component && null !== _instance && (void 0 === _instance || _instance.$$typeof !== REACT_CONTEXT_TYPE) && !didWarnAboutInvalidateContextType.has(Component) && (didWarnAboutInvalidateContextType.add(Component), lane = void 0 === _instance ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : "object" !== typeof _instance ? " However, it is set to a " + typeof _instance + "." : _instance.$$typeof === REACT_CONSUMER_TYPE ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(_instance).join(", ") + "}.", console.error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(Component) || "Component", lane));
            "object" === typeof _instance && null !== _instance && (state = readContext(_instance));
            _instance = new Component(nextProps, state);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    _instance = new Component(nextProps, state);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            state = workInProgress.memoizedState = null !== _instance.state && void 0 !== _instance.state ? _instance.state : null;
            _instance.updater = classComponentUpdater;
            workInProgress.stateNode = _instance;
            _instance._reactInternals = workInProgress;
            _instance._reactInternalInstance = fakeInternalInstance;
            "function" === typeof Component.getDerivedStateFromProps && null === state && (state = getComponentNameFromType(Component) || "Component", didWarnAboutUninitializedState.has(state) || (didWarnAboutUninitializedState.add(state), console.error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", state, null === _instance.state ? "null" : "undefined", state)));
            if ("function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate) {
                var foundWillUpdateName = lane = state = null;
                "function" === typeof _instance.componentWillMount && !0 !== _instance.componentWillMount.__suppressDeprecationWarning ? state = "componentWillMount" : "function" === typeof _instance.UNSAFE_componentWillMount && (state = "UNSAFE_componentWillMount");
                "function" === typeof _instance.componentWillReceiveProps && !0 !== _instance.componentWillReceiveProps.__suppressDeprecationWarning ? lane = "componentWillReceiveProps" : "function" === typeof _instance.UNSAFE_componentWillReceiveProps && (lane = "UNSAFE_componentWillReceiveProps");
                "function" === typeof _instance.componentWillUpdate && !0 !== _instance.componentWillUpdate.__suppressDeprecationWarning ? foundWillUpdateName = "componentWillUpdate" : "function" === typeof _instance.UNSAFE_componentWillUpdate && (foundWillUpdateName = "UNSAFE_componentWillUpdate");
                if (null !== state || null !== lane || null !== foundWillUpdateName) {
                    _instance = getComponentNameFromType(Component) || "Component";
                    var newApiName = "function" === typeof Component.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                    didWarnAboutLegacyLifecyclesAndDerivedState.has(_instance) || (didWarnAboutLegacyLifecyclesAndDerivedState.add(_instance), console.error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://react.dev/link/unsafe-component-lifecycles", _instance, newApiName, null !== state ? "\n  " + state : "", null !== lane ? "\n  " + lane : "", null !== foundWillUpdateName ? "\n  " + foundWillUpdateName : ""));
                }
            }
            _instance = workInProgress.stateNode;
            state = getComponentNameFromType(Component) || "Component";
            _instance.render || (Component.prototype && "function" === typeof Component.prototype.render ? console.error("No `render` method found on the %s instance: did you accidentally return an object from the constructor?", state) : console.error("No `render` method found on the %s instance: you may have forgotten to define `render`.", state));
            !_instance.getInitialState || _instance.getInitialState.isReactClassApproved || _instance.state || console.error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", state);
            _instance.getDefaultProps && !_instance.getDefaultProps.isReactClassApproved && console.error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", state);
            _instance.contextType && console.error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", state);
            Component.childContextTypes && !didWarnAboutChildContextTypes.has(Component) && (didWarnAboutChildContextTypes.add(Component), console.error("%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)", state));
            Component.contextTypes && !didWarnAboutContextTypes$1.has(Component) && (didWarnAboutContextTypes$1.add(Component), console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)", state));
            "function" === typeof _instance.componentShouldUpdate && console.error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", state);
            Component.prototype && Component.prototype.isPureReactComponent && "undefined" !== typeof _instance.shouldComponentUpdate && console.error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(Component) || "A pure component");
            "function" === typeof _instance.componentDidUnmount && console.error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", state);
            "function" === typeof _instance.componentDidReceiveProps && console.error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", state);
            "function" === typeof _instance.componentWillRecieveProps && console.error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", state);
            "function" === typeof _instance.UNSAFE_componentWillRecieveProps && console.error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", state);
            lane = _instance.props !== nextProps;
            void 0 !== _instance.props && lane && console.error("When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", state);
            _instance.defaultProps && console.error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", state, state);
            "function" !== typeof _instance.getSnapshotBeforeUpdate || "function" === typeof _instance.componentDidUpdate || didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(Component) || (didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(Component), console.error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(Component)));
            "function" === typeof _instance.getDerivedStateFromProps && console.error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", state);
            "function" === typeof _instance.getDerivedStateFromError && console.error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", state);
            "function" === typeof Component.getSnapshotBeforeUpdate && console.error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", state);
            (lane = _instance.state) && ("object" !== typeof lane || isArrayImpl(lane)) && console.error("%s.state: must be set to an object or null", state);
            "function" === typeof _instance.getChildContext && "object" !== typeof Component.childContextTypes && console.error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", state);
            _instance = workInProgress.stateNode;
            _instance.props = nextProps;
            _instance.state = workInProgress.memoizedState;
            _instance.refs = {};
            initializeUpdateQueue(workInProgress);
            state = Component.contextType;
            _instance.context = "object" === typeof state && null !== state ? readContext(state) : emptyContextObject;
            _instance.state === nextProps && (state = getComponentNameFromType(Component) || "Component", didWarnAboutDirectlyAssigningPropsToState.has(state) || (didWarnAboutDirectlyAssigningPropsToState.add(state), console.error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", state)));
            workInProgress.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, _instance);
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, _instance);
            _instance.state = workInProgress.memoizedState;
            state = Component.getDerivedStateFromProps;
            "function" === typeof state && (applyDerivedStateFromProps(workInProgress, Component, state, nextProps), _instance.state = workInProgress.memoizedState);
            "function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || (state = _instance.state, "function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount(), state !== _instance.state && (console.error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component"), classComponentUpdater.enqueueReplaceState(_instance, _instance.state, null)), processUpdateQueue(workInProgress, nextProps, _instance, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), _instance.state = workInProgress.memoizedState);
            "function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308);
            (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728);
            _instance = !0;
        } else if (null === current) {
            _instance = workInProgress.stateNode;
            var unresolvedOldProps = workInProgress.memoizedProps;
            lane = resolveClassComponentProps(Component, unresolvedOldProps);
            _instance.props = lane;
            var oldContext = _instance.context;
            foundWillUpdateName = Component.contextType;
            state = emptyContextObject;
            "object" === typeof foundWillUpdateName && null !== foundWillUpdateName && (state = readContext(foundWillUpdateName));
            newApiName = Component.getDerivedStateFromProps;
            foundWillUpdateName = "function" === typeof newApiName || "function" === typeof _instance.getSnapshotBeforeUpdate;
            unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
            foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (unresolvedOldProps || oldContext !== state) && callComponentWillReceiveProps(workInProgress, _instance, nextProps, state);
            hasForceUpdate = !1;
            var oldState = workInProgress.memoizedState;
            _instance.state = oldState;
            processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            oldContext = workInProgress.memoizedState;
            unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof newApiName && (applyDerivedStateFromProps(workInProgress, Component, newApiName, nextProps), oldContext = workInProgress.memoizedState), (lane = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, lane, nextProps, oldState, oldContext, state)) ? (foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || ("function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount()), "function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728)) : ("function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), _instance.props = nextProps, _instance.state = oldContext, _instance.context = state, _instance = lane) : ("function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728), _instance = !1);
        } else {
            _instance = workInProgress.stateNode;
            cloneUpdateQueue(current, workInProgress);
            state = workInProgress.memoizedProps;
            foundWillUpdateName = resolveClassComponentProps(Component, state);
            _instance.props = foundWillUpdateName;
            newApiName = workInProgress.pendingProps;
            oldState = _instance.context;
            oldContext = Component.contextType;
            lane = emptyContextObject;
            "object" === typeof oldContext && null !== oldContext && (lane = readContext(oldContext));
            unresolvedOldProps = Component.getDerivedStateFromProps;
            (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof _instance.getSnapshotBeforeUpdate) || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (state !== newApiName || oldState !== lane) && callComponentWillReceiveProps(workInProgress, _instance, nextProps, lane);
            hasForceUpdate = !1;
            oldState = workInProgress.memoizedState;
            _instance.state = oldState;
            processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            var newState = workInProgress.memoizedState;
            state !== newApiName || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (foundWillUpdateName = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, foundWillUpdateName, nextProps, oldState, newState, lane) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof _instance.UNSAFE_componentWillUpdate && "function" !== typeof _instance.componentWillUpdate || ("function" === typeof _instance.componentWillUpdate && _instance.componentWillUpdate(nextProps, newState, lane), "function" === typeof _instance.UNSAFE_componentWillUpdate && _instance.UNSAFE_componentWillUpdate(nextProps, newState, lane)), "function" === typeof _instance.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof _instance.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof _instance.componentDidUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), _instance.props = nextProps, _instance.state = newState, _instance.context = lane, _instance = foundWillUpdateName) : ("function" !== typeof _instance.componentDidUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), _instance = !1);
        }
        lane = _instance;
        markRef(current, workInProgress);
        state = 0 !== (workInProgress.flags & 128);
        if (lane || state) {
            lane = workInProgress.stateNode;
            setCurrentFiber(workInProgress);
            if (state && "function" !== typeof Component.getDerivedStateFromError) Component = null, profilerStartTime = -1;
            else if (Component = callRenderInDEV(lane), workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    callRenderInDEV(lane);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            workInProgress.flags |= 1;
            null !== current && state ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes);
            workInProgress.memoizedState = lane.state;
            current = workInProgress.child;
        } else current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        renderLanes = workInProgress.stateNode;
        _instance && renderLanes.props !== nextProps && (didWarnAboutReassigningProps || console.error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component"), didWarnAboutReassigningProps = !0);
        return current;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
        resetHydrationState();
        workInProgress.flags |= 256;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        Component && Component.childContextTypes && console.error("childContextTypes cannot be defined on a function component.\n  %s.childContextTypes = ...", Component.displayName || Component.name || "Component");
        "function" === typeof Component.getDerivedStateFromProps && (workInProgress = getComponentNameFromType(Component) || "Unknown", didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] || (console.error("%s: Function components do not support getDerivedStateFromProps.", workInProgress), didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] = !0));
        "object" === typeof Component.contextType && null !== Component.contextType && (Component = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypeOnFunctionComponent[Component] || (console.error("%s: Function components do not support contextType.", Component), didWarnAboutContextTypeOnFunctionComponent[Component] = !0));
    }
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache()
        };
    }
    function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
        current = null !== current ? current.childLanes & ~renderLanes : 0;
        primaryTreeDidDefer && (current |= workInProgressDeferredLane);
        return current;
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var JSCompiler_object_inline_digest_2724;
        var JSCompiler_object_inline_stack_2725 = workInProgress.pendingProps;
        shouldSuspendImpl(workInProgress) && (workInProgress.flags |= 128);
        var JSCompiler_object_inline_message_2723 = !1;
        var didSuspend = 0 !== (workInProgress.flags & 128);
        (JSCompiler_object_inline_digest_2724 = didSuspend) || (JSCompiler_object_inline_digest_2724 = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & ForceSuspenseFallback));
        JSCompiler_object_inline_digest_2724 && (JSCompiler_object_inline_message_2723 = !0, workInProgress.flags &= -129);
        JSCompiler_object_inline_digest_2724 = 0 !== (workInProgress.flags & 32);
        workInProgress.flags &= -33;
        if (null === current) {
            if (isHydrating) {
                JSCompiler_object_inline_message_2723 ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
                (current = nextHydratableInstance) ? (renderLanes = canHydrateHydrationBoundary(current, rootOrSingletonContext), renderLanes = null !== renderLanes && renderLanes.data !== ACTIVITY_START_DATA ? renderLanes : null, null !== renderLanes && (JSCompiler_object_inline_digest_2724 = {
                    dehydrated: renderLanes,
                    treeContext: getSuspendedTreeContext(),
                    retryLane: 536870912,
                    hydrationErrors: null
                }, workInProgress.memoizedState = JSCompiler_object_inline_digest_2724, JSCompiler_object_inline_digest_2724 = createFiberFromDehydratedFragment(renderLanes), JSCompiler_object_inline_digest_2724.return = workInProgress, workInProgress.child = JSCompiler_object_inline_digest_2724, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : renderLanes = null;
                if (null === renderLanes) throw warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress);
                isSuspenseInstanceFallback(renderLanes) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
                return null;
            }
            var nextPrimaryChildren = JSCompiler_object_inline_stack_2725.children;
            JSCompiler_object_inline_stack_2725 = JSCompiler_object_inline_stack_2725.fallback;
            if (JSCompiler_object_inline_message_2723) {
                reuseSuspenseHandlerOnStack(workInProgress);
                var mode = workInProgress.mode;
                nextPrimaryChildren = mountWorkInProgressOffscreenFiber({
                    mode: "hidden",
                    children: nextPrimaryChildren
                }, mode);
                JSCompiler_object_inline_stack_2725 = createFiberFromFragment(JSCompiler_object_inline_stack_2725, mode, renderLanes, null);
                nextPrimaryChildren.return = workInProgress;
                JSCompiler_object_inline_stack_2725.return = workInProgress;
                nextPrimaryChildren.sibling = JSCompiler_object_inline_stack_2725;
                workInProgress.child = nextPrimaryChildren;
                JSCompiler_object_inline_stack_2725 = workInProgress.child;
                JSCompiler_object_inline_stack_2725.memoizedState = mountSuspenseOffscreenState(renderLanes);
                JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_object_inline_digest_2724, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725);
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var JSCompiler_object_inline_componentStack_2726 = prevState.dehydrated;
            if (null !== JSCompiler_object_inline_componentStack_2726) {
                if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = JSCompiler_object_inline_stack_2725.fallback, mode = workInProgress.mode, JSCompiler_object_inline_stack_2725 = mountWorkInProgressOffscreenFiber({
                    mode: "visible",
                    children: JSCompiler_object_inline_stack_2725.children
                }, mode), nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, mode, renderLanes, null), nextPrimaryChildren.flags |= 2, JSCompiler_object_inline_stack_2725.return = workInProgress, nextPrimaryChildren.return = workInProgress, JSCompiler_object_inline_stack_2725.sibling = nextPrimaryChildren, workInProgress.child = JSCompiler_object_inline_stack_2725, reconcileChildFibers(workInProgress, current.child, null, renderLanes), JSCompiler_object_inline_stack_2725 = workInProgress.child, JSCompiler_object_inline_stack_2725.memoizedState = mountSuspenseOffscreenState(renderLanes), JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_object_inline_digest_2724, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725));
                else if (pushPrimaryTreeSuspenseHandler(workInProgress), warnIfHydrating(), 0 !== (renderLanes & 536870912) && markRenderDerivedCause(workInProgress), isSuspenseInstanceFallback(JSCompiler_object_inline_componentStack_2726)) {
                    JSCompiler_object_inline_digest_2724 = JSCompiler_object_inline_componentStack_2726.nextSibling && JSCompiler_object_inline_componentStack_2726.nextSibling.dataset;
                    if (JSCompiler_object_inline_digest_2724) {
                        nextPrimaryChildren = JSCompiler_object_inline_digest_2724.dgst;
                        var message = JSCompiler_object_inline_digest_2724.msg;
                        mode = JSCompiler_object_inline_digest_2724.stck;
                        var componentStack = JSCompiler_object_inline_digest_2724.cstck;
                    }
                    JSCompiler_object_inline_message_2723 = message;
                    JSCompiler_object_inline_digest_2724 = nextPrimaryChildren;
                    JSCompiler_object_inline_stack_2725 = mode;
                    JSCompiler_object_inline_componentStack_2726 = componentStack;
                    nextPrimaryChildren = JSCompiler_object_inline_message_2723;
                    mode = JSCompiler_object_inline_componentStack_2726;
                    nextPrimaryChildren = nextPrimaryChildren ? Error(nextPrimaryChildren) : Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                    nextPrimaryChildren.stack = JSCompiler_object_inline_stack_2725 || "";
                    nextPrimaryChildren.digest = JSCompiler_object_inline_digest_2724;
                    JSCompiler_object_inline_digest_2724 = void 0 === mode ? null : mode;
                    JSCompiler_object_inline_stack_2725 = {
                        value: nextPrimaryChildren,
                        source: null,
                        stack: JSCompiler_object_inline_digest_2724
                    };
                    "string" === typeof JSCompiler_object_inline_digest_2724 && CapturedStacks.set(nextPrimaryChildren, JSCompiler_object_inline_stack_2725);
                    queueHydrationError(JSCompiler_object_inline_stack_2725);
                    workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
                } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_object_inline_digest_2724 = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_object_inline_digest_2724) {
                    JSCompiler_object_inline_digest_2724 = workInProgressRoot;
                    if (null !== JSCompiler_object_inline_digest_2724 && (JSCompiler_object_inline_stack_2725 = getBumpedLaneForHydration(JSCompiler_object_inline_digest_2724, renderLanes), 0 !== JSCompiler_object_inline_stack_2725 && JSCompiler_object_inline_stack_2725 !== prevState.retryLane)) throw prevState.retryLane = JSCompiler_object_inline_stack_2725, enqueueConcurrentRenderForLane(current, JSCompiler_object_inline_stack_2725), scheduleUpdateOnFiber(JSCompiler_object_inline_digest_2724, current, JSCompiler_object_inline_stack_2725), SelectiveHydrationException;
                    isSuspenseInstancePending(JSCompiler_object_inline_componentStack_2726) || renderDidSuspendDelayIfPossible();
                    workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
                } else isSuspenseInstancePending(JSCompiler_object_inline_componentStack_2726) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, nextHydratableInstance = getNextHydratable(JSCompiler_object_inline_componentStack_2726.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountSuspensePrimaryChildren(workInProgress, JSCompiler_object_inline_stack_2725.children), workInProgress.flags |= 4096);
                return workInProgress;
            }
        }
        if (JSCompiler_object_inline_message_2723) return reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = JSCompiler_object_inline_stack_2725.fallback, mode = workInProgress.mode, componentStack = current.child, JSCompiler_object_inline_componentStack_2726 = componentStack.sibling, JSCompiler_object_inline_stack_2725 = createWorkInProgress(componentStack, {
            mode: "hidden",
            children: JSCompiler_object_inline_stack_2725.children
        }), JSCompiler_object_inline_stack_2725.subtreeFlags = componentStack.subtreeFlags & 65011712, null !== JSCompiler_object_inline_componentStack_2726 ? nextPrimaryChildren = createWorkInProgress(JSCompiler_object_inline_componentStack_2726, nextPrimaryChildren) : (nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, mode, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, JSCompiler_object_inline_stack_2725.return = workInProgress, JSCompiler_object_inline_stack_2725.sibling = nextPrimaryChildren, workInProgress.child = JSCompiler_object_inline_stack_2725, bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725), JSCompiler_object_inline_stack_2725 = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes) : (mode = nextPrimaryChildren.cachePool, null !== mode ? (componentStack = CacheContext._currentValue, mode = mode.parent !== componentStack ? {
            parent: componentStack,
            pool: componentStack
        } : mode) : mode = getSuspendedCache(), nextPrimaryChildren = {
            baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
            cachePool: mode
        }), JSCompiler_object_inline_stack_2725.memoizedState = nextPrimaryChildren, JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_object_inline_digest_2724, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, JSCompiler_object_inline_stack_2725);
        null !== prevState && (renderLanes & 62914560) === renderLanes && 0 !== (renderLanes & current.lanes) && markRenderDerivedCause(workInProgress);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        renderLanes = current.child;
        current = renderLanes.sibling;
        renderLanes = createWorkInProgress(renderLanes, {
            mode: "visible",
            children: JSCompiler_object_inline_stack_2725.children
        });
        renderLanes.return = workInProgress;
        renderLanes.sibling = null;
        null !== current && (JSCompiler_object_inline_digest_2724 = workInProgress.deletions, null === JSCompiler_object_inline_digest_2724 ? (workInProgress.deletions = [
            current
        ], workInProgress.flags |= 16) : JSCompiler_object_inline_digest_2724.push(current));
        workInProgress.child = renderLanes;
        workInProgress.memoizedState = null;
        return renderLanes;
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
        primaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: primaryChildren
        }, workInProgress.mode);
        primaryChildren.return = workInProgress;
        return workInProgress.child = primaryChildren;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
        offscreenProps = createFiber(22, offscreenProps, null, mode);
        offscreenProps.lanes = 0;
        return offscreenProps;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
        current.flags |= 2;
        workInProgress.memoizedState = null;
        return current;
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes |= renderLanes;
        var alternate = fiber.alternate;
        null !== alternate && (alternate.lanes |= renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
        var renderState = workInProgress.memoizedState;
        null === renderState ? workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode,
            treeForkCount: treeForkCount
        } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
    }
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail, newChildren = nextProps.children, suspenseContext = suspenseStackCursor.current;
        (nextProps = 0 !== (suspenseContext & ForceSuspenseFallback)) ? (suspenseContext = suspenseContext & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress.flags |= 128) : suspenseContext &= SubtreeSuspenseContextMask;
        push(suspenseStackCursor, suspenseContext, workInProgress);
        suspenseContext = null == revealOrder ? "null" : revealOrder;
        if ("forwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && "together" !== revealOrder && "independent" !== revealOrder && !didWarnAboutRevealOrder[suspenseContext]) {
            if (didWarnAboutRevealOrder[suspenseContext] = !0, null == revealOrder) console.error('The default for the <SuspenseList revealOrder="..."> prop is changing. To be future compatible you must explictly specify either "independent" (the current default), "together", "forwards" or "legacy_unstable-backwards".');
            else if ("backwards" === revealOrder) console.error('The rendering order of <SuspenseList revealOrder="backwards"> is changing. To be future compatible you must specify revealOrder="legacy_unstable-backwards" instead.');
            else if ("string" === typeof revealOrder) switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                case "independent":
                    console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    console.error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?', revealOrder);
            }
            else console.error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?', revealOrder);
        }
        suspenseContext = null == tailMode ? "null" : tailMode;
        if (!didWarnAboutTailOptions[suspenseContext]) {
            if (null == tailMode) {
                if ("forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder) didWarnAboutTailOptions[suspenseContext] = !0, console.error('The default for the <SuspenseList tail="..."> prop is changing. To be future compatible you must explictly specify either "visible" (the current default), "collapsed" or "hidden".');
            } else "visible" !== tailMode && "collapsed" !== tailMode && "hidden" !== tailMode ? (didWarnAboutTailOptions[suspenseContext] = !0, console.error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?', tailMode)) : "forwards" !== revealOrder && "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && (didWarnAboutTailOptions[suspenseContext] = !0, console.error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode));
        }
        a: if (("forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder) && void 0 !== newChildren && null !== newChildren && !1 !== newChildren) {
            if (isArrayImpl(newChildren)) for(suspenseContext = 0; suspenseContext < newChildren.length; suspenseContext++){
                if (!validateSuspenseListNestedChild(newChildren[suspenseContext], suspenseContext)) break a;
            }
            else if (suspenseContext = getIteratorFn(newChildren), "function" === typeof suspenseContext) {
                if (suspenseContext = suspenseContext.call(newChildren)) for(var step = suspenseContext.next(), _i = 0; !step.done; step = suspenseContext.next()){
                    if (!validateSuspenseListNestedChild(step.value, _i)) break a;
                    _i++;
                }
            } else console.error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
        }
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        isHydrating ? (warnIfNotHydrating(), newChildren = treeForkCount) : newChildren = 0;
        if (!nextProps && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        switch(revealOrder){
            case "forwards":
                renderLanes = workInProgress.child;
                for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
                renderLanes = revealOrder;
                null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
                initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, newChildren);
                break;
            case "backwards":
            case "unstable_legacy-backwards":
                renderLanes = null;
                revealOrder = workInProgress.child;
                for(workInProgress.child = null; null !== revealOrder;){
                    current = revealOrder.alternate;
                    if (null !== current && null === findFirstSuspended(current)) {
                        workInProgress.child = revealOrder;
                        break;
                    }
                    current = revealOrder.sibling;
                    revealOrder.sibling = renderLanes;
                    renderLanes = revealOrder;
                    revealOrder = current;
                }
                initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, newChildren);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, !1, null, null, void 0, newChildren);
                break;
            default:
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        null !== current && (workInProgress.dependencies = current.dependencies);
        profilerStartTime = -1;
        workInProgressRootSkippedLanes |= workInProgress.lanes;
        if (0 === (renderLanes & workInProgress.childLanes)) {
            if (null !== current) {
                if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
            } else return null;
        }
        if (null !== current && workInProgress.child !== current.child) throw Error("Resuming work not yet implemented.");
        if (null !== workInProgress.child) {
            current = workInProgress.child;
            renderLanes = createWorkInProgress(current, current.pendingProps);
            workInProgress.child = renderLanes;
            for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
            renderLanes.sibling = null;
        }
        return workInProgress.child;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        if (0 !== (current.lanes & renderLanes)) return !0;
        current = current.dependencies;
        return null !== current && checkIfContextChanged(current) ? !0 : !1;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case 3:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
                resetHydrationState();
                break;
            case 27:
            case 5:
                pushHostContext(workInProgress);
                break;
            case 4:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case 10:
                pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
                break;
            case 12:
                0 !== (renderLanes & workInProgress.childLanes) && (workInProgress.flags |= 4);
                workInProgress.flags |= 2048;
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = -0;
                stateNode.passiveEffectDuration = -0;
                break;
            case 31:
                if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
                break;
            case 13:
                stateNode = workInProgress.memoizedState;
                if (null !== stateNode) {
                    if (null !== stateNode.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                    if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                    pushPrimaryTreeSuspenseHandler(workInProgress);
                    current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                    return null !== current ? current.sibling : null;
                }
                pushPrimaryTreeSuspenseHandler(workInProgress);
                break;
            case 19:
                var didSuspendBefore = 0 !== (current.flags & 128);
                stateNode = 0 !== (renderLanes & workInProgress.childLanes);
                stateNode || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), stateNode = 0 !== (renderLanes & workInProgress.childLanes));
                if (didSuspendBefore) {
                    if (stateNode) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                    workInProgress.flags |= 128;
                }
                didSuspendBefore = workInProgress.memoizedState;
                null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
                push(suspenseStackCursor, suspenseStackCursor.current, workInProgress);
                if (stateNode) break;
                else return null;
            case 22:
                return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && null !== current) {
            renderLanes = createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes);
            renderLanes._debugStack = workInProgress._debugStack;
            renderLanes._debugTask = workInProgress._debugTask;
            var returnFiber = workInProgress.return;
            if (null === returnFiber) throw Error("Cannot swap the root fiber.");
            current.alternate = null;
            workInProgress.alternate = null;
            renderLanes.index = workInProgress.index;
            renderLanes.sibling = workInProgress.sibling;
            renderLanes.return = workInProgress.return;
            renderLanes.ref = workInProgress.ref;
            renderLanes._debugInfo = workInProgress._debugInfo;
            if (workInProgress === returnFiber.child) returnFiber.child = renderLanes;
            else {
                var prevSibling = returnFiber.child;
                if (null === prevSibling) throw Error("Expected parent to have a child.");
                for(; prevSibling.sibling !== workInProgress;)if (prevSibling = prevSibling.sibling, null === prevSibling) throw Error("Expected to find the previous sibling.");
                prevSibling.sibling = renderLanes;
            }
            workInProgress = returnFiber.deletions;
            null === workInProgress ? (returnFiber.deletions = [
                current
            ], returnFiber.flags |= 16) : workInProgress.push(current);
            renderLanes.flags |= 2;
            return renderLanes;
        }
        if (null !== current) {
            if (current.memoizedProps !== workInProgress.pendingProps || workInProgress.type !== current.type) didReceiveUpdate = !0;
            else {
                if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
            }
        } else {
            didReceiveUpdate = !1;
            if (returnFiber = isHydrating) warnIfNotHydrating(), returnFiber = 0 !== (workInProgress.flags & 1048576);
            returnFiber && (returnFiber = workInProgress.index, warnIfNotHydrating(), pushTreeId(workInProgress, treeForkCount, returnFiber));
        }
        workInProgress.lanes = 0;
        switch(workInProgress.tag){
            case 16:
                a: if (returnFiber = workInProgress.pendingProps, current = resolveLazy(workInProgress.elementType), workInProgress.type = current, "function" === typeof current) shouldConstruct(current) ? (returnFiber = resolveClassComponentProps(current, returnFiber), workInProgress.tag = 1, workInProgress.type = current = resolveFunctionForHotReloading(current), workInProgress = updateClassComponent(null, workInProgress, current, returnFiber, renderLanes)) : (workInProgress.tag = 0, validateFunctionComponentInDev(workInProgress, current), workInProgress.type = current = resolveFunctionForHotReloading(current), workInProgress = updateFunctionComponent(null, workInProgress, current, returnFiber, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        if (prevSibling = current.$$typeof, prevSibling === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress.type = current = resolveForwardRefForHotReloading(current);
                            workInProgress = updateForwardRef(null, workInProgress, current, returnFiber, renderLanes);
                            break a;
                        } else if (prevSibling === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, current, returnFiber, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = "";
                    null !== current && "object" === typeof current && current.$$typeof === REACT_LAZY_TYPE && (workInProgress = " Did you wrap a component in React.lazy() more than once?");
                    renderLanes = getComponentNameFromType(current) || current;
                    throw Error("Element type is invalid. Received a promise that resolves to: " + renderLanes + ". Lazy element type must resolve to a class or function." + workInProgress);
                }
                return workInProgress;
            case 0:
                return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 1:
                return returnFiber = workInProgress.type, prevSibling = resolveClassComponentProps(returnFiber, workInProgress.pendingProps), updateClassComponent(current, workInProgress, returnFiber, prevSibling, renderLanes);
            case 3:
                a: {
                    pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                    if (null === current) throw Error("Should have a current fiber. This is a bug in React.");
                    returnFiber = workInProgress.pendingProps;
                    var prevState = workInProgress.memoizedState;
                    prevSibling = prevState.element;
                    cloneUpdateQueue(current, workInProgress);
                    processUpdateQueue(workInProgress, returnFiber, null, renderLanes);
                    var nextState = workInProgress.memoizedState;
                    returnFiber = nextState.cache;
                    pushProvider(workInProgress, CacheContext, returnFiber);
                    returnFiber !== prevState.cache && propagateContextChanges(workInProgress, [
                        CacheContext
                    ], renderLanes, !0);
                    suspendIfUpdateReadFromEntangledAsyncAction();
                    returnFiber = nextState.element;
                    if (prevState.isDehydrated) {
                        if (prevState = {
                            element: returnFiber,
                            isDehydrated: !1,
                            cache: nextState.cache
                        }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, returnFiber, renderLanes);
                            break a;
                        } else if (returnFiber !== prevSibling) {
                            prevSibling = createCapturedValueAtFiber(Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                            queueHydrationError(prevSibling);
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, returnFiber, renderLanes);
                            break a;
                        } else {
                            current = workInProgress.stateNode.containerInfo;
                            switch(current.nodeType){
                                case 9:
                                    current = current.body;
                                    break;
                                default:
                                    current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                            }
                            nextHydratableInstance = getNextHydratable(current.firstChild);
                            hydrationParentFiber = workInProgress;
                            isHydrating = !0;
                            hydrationErrors = null;
                            didSuspendOrErrorDEV = !1;
                            hydrationDiffRootDEV = null;
                            rootOrSingletonContext = !0;
                            renderLanes = mountChildFibers(workInProgress, null, returnFiber, renderLanes);
                            for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                        }
                    } else {
                        resetHydrationState();
                        if (returnFiber === prevSibling) {
                            workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                            break a;
                        }
                        reconcileChildren(current, workInProgress, returnFiber, renderLanes);
                    }
                    workInProgress = workInProgress.child;
                }
                return workInProgress;
            case 26:
                return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, returnFiber = requiredContext(rootInstanceStackCursor.current), returnFiber = getOwnerDocumentFromRootContainer(returnFiber).createElement(renderLanes), returnFiber[internalInstanceKey] = workInProgress, returnFiber[internalPropsKey] = current, setInitialProperties(returnFiber, renderLanes, current), markNodeAsHoistable(returnFiber), workInProgress.stateNode = returnFiber) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
            case 27:
                return pushHostContext(workInProgress), null === current && isHydrating && (returnFiber = requiredContext(rootInstanceStackCursor.current), prevSibling = getHostContext(), returnFiber = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, returnFiber, prevSibling, !1), didSuspendOrErrorDEV || (prevSibling = diffHydratedProperties(returnFiber, workInProgress.type, workInProgress.pendingProps, prevSibling), null !== prevSibling && (buildHydrationDiffNode(workInProgress, 0).serverProps = prevSibling)), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, prevSibling = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = prevSibling, nextHydratableInstance = getNextHydratable(returnFiber.firstChild)) : nextHydratableInstance = prevSibling), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
            case 5:
                return null === current && isHydrating && (prevState = getHostContext(), returnFiber = validateDOMNesting(workInProgress.type, prevState.ancestorInfo), prevSibling = nextHydratableInstance, (nextState = !prevSibling) || (nextState = canHydrateInstance(prevSibling, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== nextState ? (workInProgress.stateNode = nextState, didSuspendOrErrorDEV || (prevState = diffHydratedProperties(nextState, workInProgress.type, workInProgress.pendingProps, prevState), null !== prevState && (buildHydrationDiffNode(workInProgress, 0).serverProps = prevState)), hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(nextState.firstChild), rootOrSingletonContext = !1, prevState = !0) : prevState = !1, nextState = !prevState), nextState && (returnFiber && warnNonHydratedInstance(workInProgress, prevSibling), throwOnHydrationMismatch(workInProgress))), pushHostContext(workInProgress), prevSibling = workInProgress.type, prevState = workInProgress.pendingProps, nextState = null !== current ? current.memoizedProps : null, returnFiber = prevState.children, shouldSetTextContent(prevSibling, prevState) ? returnFiber = null : null !== nextState && shouldSetTextContent(prevSibling, nextState) && (workInProgress.flags |= 32), null !== workInProgress.memoizedState && (prevSibling = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = prevSibling), markRef(current, workInProgress), reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 6:
                return null === current && isHydrating && (renderLanes = workInProgress.pendingProps, current = getHostContext(), returnFiber = current.ancestorInfo.current, renderLanes = null != returnFiber ? validateTextNesting(renderLanes, returnFiber.tag, current.ancestorInfo.implicitRootScope) : !0, current = nextHydratableInstance, (returnFiber = !current) || (returnFiber = canHydrateTextInstance(current, workInProgress.pendingProps, rootOrSingletonContext), null !== returnFiber ? (workInProgress.stateNode = returnFiber, hydrationParentFiber = workInProgress, nextHydratableInstance = null, returnFiber = !0) : returnFiber = !1, returnFiber = !returnFiber), returnFiber && (renderLanes && warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress))), null;
            case 13:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case 4:
                return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), returnFiber = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, returnFiber, renderLanes) : reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 11:
                return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 7:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
            case 8:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 12:
                return workInProgress.flags |= 4, workInProgress.flags |= 2048, returnFiber = workInProgress.stateNode, returnFiber.effectDuration = -0, returnFiber.passiveEffectDuration = -0, reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 10:
                return returnFiber = workInProgress.type, prevSibling = workInProgress.pendingProps, prevState = prevSibling.value, "value" in prevSibling || hasWarnedAboutUsingNoValuePropOnContextProvider || (hasWarnedAboutUsingNoValuePropOnContextProvider = !0, console.error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?")), pushProvider(workInProgress, returnFiber, prevState), reconcileChildren(current, workInProgress, prevSibling.children, renderLanes), workInProgress.child;
            case 9:
                return prevSibling = workInProgress.type._context, returnFiber = workInProgress.pendingProps.children, "function" !== typeof returnFiber && console.error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), prepareToReadContext(workInProgress), prevSibling = readContext(prevSibling), returnFiber = callComponentInDEV(returnFiber, prevSibling, void 0), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 14:
                return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 15:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 19:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case 31:
                return updateActivityComponent(current, workInProgress, renderLanes);
            case 22:
                return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                return prepareToReadContext(workInProgress), returnFiber = readContext(CacheContext), null === current ? (prevSibling = peekCacheFromPool(), null === prevSibling && (prevSibling = workInProgressRoot, prevState = createCache(), prevSibling.pooledCache = prevState, retainCache(prevState), null !== prevState && (prevSibling.pooledCacheLanes |= renderLanes), prevSibling = prevState), workInProgress.memoizedState = {
                    parent: returnFiber,
                    cache: prevSibling
                }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, prevSibling)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), prevSibling = current.memoizedState, prevState = workInProgress.memoizedState, prevSibling.parent !== returnFiber ? (prevSibling = {
                    parent: returnFiber,
                    cache: returnFiber
                }, workInProgress.memoizedState = prevSibling, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = prevSibling), pushProvider(workInProgress, CacheContext, returnFiber)) : (returnFiber = prevState.cache, pushProvider(workInProgress, CacheContext, returnFiber), returnFiber !== prevSibling.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 29:
                throw workInProgress.pendingProps;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        workInProgress.flags |= 4;
    }
    function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
        if (type = (workInProgress.mode & SuspenseyImagesMode) !== NoMode) type = !1;
        if (type) {
            if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
                if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
                else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
                else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
            }
        } else workInProgress.flags &= -16777217;
    }
    function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
        if ("stylesheet" !== resource.type || (resource.state.loading & Inserted) !== NotLoaded) workInProgress.flags &= -16777217;
        else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
            if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        }
    }
    function scheduleRetryEffect(workInProgress, retryQueue) {
        null !== retryQueue && (workInProgress.flags |= 4);
        workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (!isHydrating) switch(renderState.tailMode){
            case "hidden":
                hasRenderedATailFallback = renderState.tail;
                for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
                null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
                break;
            case "collapsed":
                lastTailNode = renderState.tail;
                for(var _lastTailNode = null; null !== lastTailNode;)null !== lastTailNode.alternate && (_lastTailNode = lastTailNode), lastTailNode = lastTailNode.sibling;
                null === _lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : _lastTailNode.sibling = null;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
        if (didBailout) {
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                for(var _treeBaseDuration = completedWork.selfBaseDuration, _child2 = completedWork.child; null !== _child2;)newChildLanes |= _child2.lanes | _child2.childLanes, subtreeFlags |= _child2.subtreeFlags & 65011712, subtreeFlags |= _child2.flags & 65011712, _treeBaseDuration += _child2.treeBaseDuration, _child2 = _child2.sibling;
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else for(_treeBaseDuration = completedWork.child; null !== _treeBaseDuration;)newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags & 65011712, subtreeFlags |= _treeBaseDuration.flags & 65011712, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
        } else if ((completedWork.mode & ProfileMode) !== NoMode) {
            _treeBaseDuration = completedWork.actualDuration;
            _child2 = completedWork.selfBaseDuration;
            for(var child = completedWork.child; null !== child;)newChildLanes |= child.lanes | child.childLanes, subtreeFlags |= child.subtreeFlags, subtreeFlags |= child.flags, _treeBaseDuration += child.actualDuration, _child2 += child.treeBaseDuration, child = child.sibling;
            completedWork.actualDuration = _treeBaseDuration;
            completedWork.treeBaseDuration = _child2;
        } else for(_treeBaseDuration = completedWork.child; null !== _treeBaseDuration;)newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags, subtreeFlags |= _treeBaseDuration.flags, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
        completedWork.subtreeFlags |= subtreeFlags;
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return bubbleProperties(workInProgress), null;
            case 1:
                return bubbleProperties(workInProgress), null;
            case 3:
                renderLanes = workInProgress.stateNode;
                newProps = null;
                null !== current && (newProps = current.memoizedState.cache);
                workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
                popProvider(CacheContext, workInProgress);
                popHostContainer(workInProgress);
                renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
                if (null === current || null === current.child) popHydrationState(workInProgress) ? (emitPendingHydrationWarnings(), markUpdate(workInProgress)) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
                bubbleProperties(workInProgress);
                return null;
            case 26:
                var type = workInProgress.type, nextResource = workInProgress.memoizedState;
                null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
                return null;
            case 27:
                popHostContext(workInProgress);
                renderLanes = requiredContext(rootInstanceStackCursor.current);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    current = getHostContext();
                    popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes, current, !0), workInProgress.stateNode = current, markUpdate(workInProgress));
                }
                bubbleProperties(workInProgress);
                return null;
            case 5:
                popHostContext(workInProgress);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var _currentHostContext = getHostContext();
                    if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, _currentHostContext);
                    else {
                        nextResource = requiredContext(rootInstanceStackCursor.current);
                        validateDOMNesting(type, _currentHostContext.ancestorInfo);
                        _currentHostContext = _currentHostContext.context;
                        nextResource = getOwnerDocumentFromRootContainer(nextResource);
                        switch(_currentHostContext){
                            case HostContextNamespaceSvg:
                                nextResource = nextResource.createElementNS(SVG_NAMESPACE, type);
                                break;
                            case HostContextNamespaceMath:
                                nextResource = nextResource.createElementNS(MATH_NAMESPACE, type);
                                break;
                            default:
                                switch(type){
                                    case "svg":
                                        nextResource = nextResource.createElementNS(SVG_NAMESPACE, type);
                                        break;
                                    case "math":
                                        nextResource = nextResource.createElementNS(MATH_NAMESPACE, type);
                                        break;
                                    case "script":
                                        nextResource = nextResource.createElement("div");
                                        nextResource.innerHTML = "<script>\x3c/script>";
                                        nextResource = nextResource.removeChild(nextResource.firstChild);
                                        break;
                                    case "select":
                                        nextResource = "string" === typeof newProps.is ? nextResource.createElement("select", {
                                            is: newProps.is
                                        }) : nextResource.createElement("select");
                                        newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                        break;
                                    default:
                                        nextResource = "string" === typeof newProps.is ? nextResource.createElement(type, {
                                            is: newProps.is
                                        }) : nextResource.createElement(type), -1 === type.indexOf("-") && (type !== type.toLowerCase() && console.error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type), "[object HTMLUnknownElement]" !== Object.prototype.toString.call(nextResource) || hasOwnProperty.call(warnedUnknownTags, type) || (warnedUnknownTags[type] = !0, console.error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type)));
                                }
                        }
                        nextResource[internalInstanceKey] = workInProgress;
                        nextResource[internalPropsKey] = newProps;
                        a: for(_currentHostContext = workInProgress.child; null !== _currentHostContext;){
                            if (5 === _currentHostContext.tag || 6 === _currentHostContext.tag) nextResource.appendChild(_currentHostContext.stateNode);
                            else if (4 !== _currentHostContext.tag && 27 !== _currentHostContext.tag && null !== _currentHostContext.child) {
                                _currentHostContext.child.return = _currentHostContext;
                                _currentHostContext = _currentHostContext.child;
                                continue;
                            }
                            if (_currentHostContext === workInProgress) break a;
                            for(; null === _currentHostContext.sibling;){
                                if (null === _currentHostContext.return || _currentHostContext.return === workInProgress) break a;
                                _currentHostContext = _currentHostContext.return;
                            }
                            _currentHostContext.sibling.return = _currentHostContext.return;
                            _currentHostContext = _currentHostContext.sibling;
                        }
                        workInProgress.stateNode = nextResource;
                        a: switch(setInitialProperties(nextResource, type, newProps), type){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                newProps = !!newProps.autoFocus;
                                break a;
                            case "img":
                                newProps = !0;
                                break a;
                            default:
                                newProps = !1;
                        }
                        newProps && markUpdate(workInProgress);
                    }
                }
                bubbleProperties(workInProgress);
                preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
                return null;
            case 6:
                if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    current = requiredContext(rootInstanceStackCursor.current);
                    renderLanes = getHostContext();
                    if (popHydrationState(workInProgress)) {
                        current = workInProgress.stateNode;
                        renderLanes = workInProgress.memoizedProps;
                        type = !didSuspendOrErrorDEV;
                        newProps = null;
                        nextResource = hydrationParentFiber;
                        if (null !== nextResource) switch(nextResource.tag){
                            case 3:
                                type && (type = diffHydratedTextForDevWarnings(current, renderLanes, newProps), null !== type && (buildHydrationDiffNode(workInProgress, 0).serverProps = type));
                                break;
                            case 27:
                            case 5:
                                newProps = nextResource.memoizedProps, type && (type = diffHydratedTextForDevWarnings(current, renderLanes, newProps), null !== type && (buildHydrationDiffNode(workInProgress, 0).serverProps = type));
                        }
                        current[internalInstanceKey] = workInProgress;
                        current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                        current || throwOnHydrationMismatch(workInProgress, !0);
                    } else type = renderLanes.ancestorInfo.current, null != type && validateTextNesting(newProps, type.tag, renderLanes.ancestorInfo.implicitRootScope), current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
                }
                bubbleProperties(workInProgress);
                return null;
            case 31:
                renderLanes = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState) {
                    newProps = popHydrationState(workInProgress);
                    if (null !== renderLanes) {
                        if (null === current) {
                            if (!newProps) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            current = workInProgress.memoizedState;
                            current = null !== current ? current.dehydrated : null;
                            if (!current) throw Error("Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue.");
                            current[internalInstanceKey] = workInProgress;
                            bubbleProperties(workInProgress);
                            (workInProgress.mode & ProfileMode) !== NoMode && null !== renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                        } else emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress.flags & 128) && (renderLanes = workInProgress.memoizedState = null), workInProgress.flags |= 4, bubbleProperties(workInProgress), (workInProgress.mode & ProfileMode) !== NoMode && null !== renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                        current = !1;
                    } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                    if (!current) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                    if (0 !== (workInProgress.flags & 128)) throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
                }
                bubbleProperties(workInProgress);
                return null;
            case 13:
                newProps = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                    type = newProps;
                    nextResource = popHydrationState(workInProgress);
                    if (null !== type && null !== type.dehydrated) {
                        if (null === current) {
                            if (!nextResource) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            nextResource = workInProgress.memoizedState;
                            nextResource = null !== nextResource ? nextResource.dehydrated : null;
                            if (!nextResource) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
                            nextResource[internalInstanceKey] = workInProgress;
                            bubbleProperties(workInProgress);
                            (workInProgress.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress.child, null !== type && (workInProgress.treeBaseDuration -= type.treeBaseDuration));
                        } else emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress.flags & 128) && (type = workInProgress.memoizedState = null), workInProgress.flags |= 4, bubbleProperties(workInProgress), (workInProgress.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress.child, null !== type && (workInProgress.treeBaseDuration -= type.treeBaseDuration));
                        type = !1;
                    } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                    if (!type) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                }
                popSuspenseHandler(workInProgress);
                if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress;
                renderLanes = null !== newProps;
                current = null !== current && null !== current.memoizedState;
                renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
                renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
                scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
                bubbleProperties(workInProgress);
                (workInProgress.mode & ProfileMode) !== NoMode && renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                return null;
            case 4:
                return popHostContainer(workInProgress), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type, workInProgress), bubbleProperties(workInProgress), null;
            case 19:
                pop(suspenseStackCursor, workInProgress);
                newProps = workInProgress.memoizedState;
                if (null === newProps) return bubbleProperties(workInProgress), null;
                type = 0 !== (workInProgress.flags & 128);
                nextResource = newProps.rendering;
                if (null === nextResource) {
                    if (type) cutOffTailIfNeeded(newProps, !1);
                    else {
                        if (workInProgressRootExitStatus !== RootInProgress || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                            nextResource = findFirstSuspended(current);
                            if (null !== nextResource) {
                                workInProgress.flags |= 128;
                                cutOffTailIfNeeded(newProps, !1);
                                current = nextResource.updateQueue;
                                workInProgress.updateQueue = current;
                                scheduleRetryEffect(workInProgress, current);
                                workInProgress.subtreeFlags = 0;
                                current = renderLanes;
                                for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                                push(suspenseStackCursor, suspenseStackCursor.current & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress);
                                isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                                return workInProgress.child;
                            }
                            current = current.sibling;
                        }
                        null !== newProps.tail && now$1() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                } else {
                    if (!type) {
                        if (current = findFirstSuspended(nextResource), null !== current) {
                            if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                        } else 2 * now$1() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                    newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
                }
                if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = now$1(), current.sibling = null, renderLanes = suspenseStackCursor.current, renderLanes = type ? renderLanes & SubtreeSuspenseContextMask | ForceSuspenseFallback : renderLanes & SubtreeSuspenseContextMask, push(suspenseStackCursor, renderLanes, workInProgress), isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount), current;
                bubbleProperties(workInProgress);
                return null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(workInProgress), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache, workInProgress), null;
            case 24:
                return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext, workInProgress), bubbleProperties(workInProgress), null;
            case 25:
                return null;
            case 30:
                return null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(current, workInProgress) {
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 1:
                return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 3:
                return popProvider(CacheContext, workInProgress), popHostContainer(workInProgress), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 26:
            case 27:
            case 5:
                return popHostContext(workInProgress), null;
            case 31:
                if (null !== workInProgress.memoizedState) {
                    popSuspenseHandler(workInProgress);
                    if (null === workInProgress.alternate) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 13:
                popSuspenseHandler(workInProgress);
                current = workInProgress.memoizedState;
                if (null !== current && null !== current.dehydrated) {
                    if (null === workInProgress.alternate) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 19:
                return pop(suspenseStackCursor, workInProgress), null;
            case 4:
                return popHostContainer(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type, workInProgress), null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(workInProgress), null !== current && pop(resumedCache, workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 24:
                return popProvider(CacheContext, workInProgress), null;
            case 25:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork) {
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case 3:
                popProvider(CacheContext, interruptedWork);
                popHostContainer(interruptedWork);
                break;
            case 26:
            case 27:
            case 5:
                popHostContext(interruptedWork);
                break;
            case 4:
                popHostContainer(interruptedWork);
                break;
            case 31:
                null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
                break;
            case 13:
                popSuspenseHandler(interruptedWork);
                break;
            case 19:
                pop(suspenseStackCursor, interruptedWork);
                break;
            case 10:
                popProvider(interruptedWork.type, interruptedWork);
                break;
            case 22:
            case 23:
                popSuspenseHandler(interruptedWork);
                popHiddenContext(interruptedWork);
                null !== current && pop(resumedCache, interruptedWork);
                break;
            case 24:
                popProvider(CacheContext, interruptedWork);
        }
    }
    function shouldProfile(current) {
        return (current.mode & ProfileMode) !== NoMode;
    }
    function commitHookLayoutEffects(finishedWork, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookLayoutUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor), recordEffectDuration()) : commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor);
    }
    function commitHookEffectListMount(flags, finishedWork) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags && (lastEffect = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !0), lastEffect = runWithFiberInDEV(finishedWork, callCreateInDEV, updateQueue), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !1), void 0 !== lastEffect && "function" !== typeof lastEffect)) {
                        var hookName = void 0;
                        hookName = 0 !== (updateQueue.tag & Layout) ? "useLayoutEffect" : 0 !== (updateQueue.tag & Insertion) ? "useInsertionEffect" : "useEffect";
                        var addendum = void 0;
                        addendum = null === lastEffect ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : "function" === typeof lastEffect.then ? "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + hookName + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching" : " You returned: " + lastEffect;
                        runWithFiberInDEV(finishedWork, function(n, a) {
                            console.error("%s must not return anything besides a function, which is used for clean-up.%s", n, a);
                        }, hookName, addendum);
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags) {
                        var inst = updateQueue.inst, destroy = inst.destroy;
                        void 0 !== destroy && (inst.destroy = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !0), lastEffect = finishedWork, runWithFiberInDEV(lastEffect, callDestroyInDEV, lastEffect, nearestMountedAncestor, destroy), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !1));
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookPassiveMountEffects(finishedWork, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookPassiveUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor), recordEffectDuration()) : commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor);
    }
    function commitClassCallbacks(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        if (null !== updateQueue) {
            var instance = finishedWork.stateNode;
            finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (instance.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), instance.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
            try {
                runWithFiberInDEV(finishedWork, commitCallbacks, updateQueue, instance);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function callGetSnapshotBeforeUpdates(instance, prevProps, prevState) {
        return instance.getSnapshotBeforeUpdate(prevProps, prevState);
    }
    function commitClassSnapshot(finishedWork, current) {
        var prevProps = current.memoizedProps, prevState = current.memoizedState;
        current = finishedWork.stateNode;
        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (current.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), current.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
        try {
            var resolvedPrevProps = resolveClassComponentProps(finishedWork.type, prevProps);
            var snapshot = runWithFiberInDEV(finishedWork, callGetSnapshotBeforeUpdates, current, resolvedPrevProps, prevState);
            prevProps = didWarnAboutUndefinedSnapshotBeforeUpdate;
            void 0 !== snapshot || prevProps.has(finishedWork.type) || (prevProps.add(finishedWork.type), runWithFiberInDEV(finishedWork, function() {
                console.error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
            }));
            current.__reactInternalSnapshotBeforeUpdate = snapshot;
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
        instance.state = current.memoizedState;
        shouldProfile(current) ? (startEffectTimer(), runWithFiberInDEV(current, callComponentWillUnmountInDEV, current, nearestMountedAncestor, instance), recordEffectDuration()) : runWithFiberInDEV(current, callComponentWillUnmountInDEV, current, nearestMountedAncestor, instance);
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (null !== ref) {
            switch(finishedWork.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = finishedWork.stateNode;
                    break;
                case 30:
                    instanceToUse = finishedWork.stateNode;
                    break;
                default:
                    instanceToUse = finishedWork.stateNode;
            }
            if ("function" === typeof ref) {
                if (shouldProfile(finishedWork)) try {
                    startEffectTimer(), finishedWork.refCleanup = ref(instanceToUse);
                } finally{
                    recordEffectDuration();
                }
                else finishedWork.refCleanup = ref(instanceToUse);
            } else "string" === typeof ref ? console.error("String refs are no longer supported.") : ref.hasOwnProperty("current") || console.error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork)), ref.current = instanceToUse;
        }
    }
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            runWithFiberInDEV(current, commitAttachRef, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref, refCleanup = current.refCleanup;
        if (null !== ref) {
            if ("function" === typeof refCleanup) try {
                if (shouldProfile(current)) try {
                    startEffectTimer(), runWithFiberInDEV(current, refCleanup);
                } finally{
                    recordEffectDuration(current);
                }
                else runWithFiberInDEV(current, refCleanup);
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            } finally{
                current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
            }
            else if ("function" === typeof ref) try {
                if (shouldProfile(current)) try {
                    startEffectTimer(), runWithFiberInDEV(current, ref, null);
                } finally{
                    recordEffectDuration(current);
                }
                else runWithFiberInDEV(current, ref, null);
            } catch (error$7) {
                captureCommitPhaseError(current, nearestMountedAncestor, error$7);
            }
            else ref.current = null;
        }
    }
    function commitProfiler(finishedWork, current, commitStartTime, effectDuration) {
        var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onCommit = _finishedWork$memoize.onCommit;
        _finishedWork$memoize = _finishedWork$memoize.onRender;
        current = null === current ? "mount" : "update";
        currentUpdateIsNested && (current = "nested-update");
        "function" === typeof _finishedWork$memoize && _finishedWork$memoize(id, current, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitStartTime);
        "function" === typeof onCommit && onCommit(id, current, effectDuration, commitStartTime);
    }
    function commitProfilerPostCommitImpl(finishedWork, current, commitStartTime, passiveEffectDuration) {
        var _finishedWork$memoize2 = finishedWork.memoizedProps;
        finishedWork = _finishedWork$memoize2.id;
        _finishedWork$memoize2 = _finishedWork$memoize2.onPostCommit;
        current = null === current ? "mount" : "update";
        currentUpdateIsNested && (current = "nested-update");
        "function" === typeof _finishedWork$memoize2 && _finishedWork$memoize2(finishedWork, current, passiveEffectDuration, commitStartTime);
    }
    function commitHostMount(finishedWork) {
        var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
        try {
            runWithFiberInDEV(finishedWork, commitMount, instance, type, props, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHostUpdate(finishedWork, newProps, oldProps) {
        try {
            runWithFiberInDEV(finishedWork, commitUpdate, finishedWork.stateNode, finishedWork.type, oldProps, newProps, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function isHostParent(fiber) {
        return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
    }
    function getHostSibling(fiber) {
        a: for(;;){
            for(; null === fiber.sibling;){
                if (null === fiber.return || isHostParent(fiber.return)) return null;
                fiber = fiber.return;
            }
            fiber.sibling.return = fiber.return;
            for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
                if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
                if (fiber.flags & 2) continue a;
                if (null === fiber.child || 4 === fiber.tag) continue a;
                else fiber.child.return = fiber, fiber = fiber.child;
            }
            if (!(fiber.flags & 2)) return fiber.stateNode;
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) node = node.stateNode, before ? (warnForReactChildrenConflict(parent), (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before)) : (warnForReactChildrenConflict(parent), before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
        else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
        else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
    }
    function commitPlacement(finishedWork) {
        for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
            if (isHostParent(parentFiber)) {
                hostParentFiber = parentFiber;
                break;
            }
            parentFiber = parentFiber.return;
        }
        if (null == hostParentFiber) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        switch(hostParentFiber.tag){
            case 27:
                hostParentFiber = hostParentFiber.stateNode;
                parentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNode(finishedWork, parentFiber, hostParentFiber);
                break;
            case 5:
                parentFiber = hostParentFiber.stateNode;
                hostParentFiber.flags & 32 && (resetTextContent(parentFiber), hostParentFiber.flags &= -33);
                hostParentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNode(finishedWork, hostParentFiber, parentFiber);
                break;
            case 3:
            case 4:
                hostParentFiber = hostParentFiber.stateNode.containerInfo;
                parentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, parentFiber, hostParentFiber);
                break;
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function commitHostSingletonAcquisition(finishedWork) {
        var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
        try {
            runWithFiberInDEV(finishedWork, acquireSingletonInstance, finishedWork.type, props, singleton, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function isHydratingParent(current, finishedWork) {
        return 31 === finishedWork.tag ? (finishedWork = finishedWork.memoizedState, null !== current.memoizedState && null === finishedWork) : 13 === finishedWork.tag ? (current = current.memoizedState, finishedWork = finishedWork.memoizedState, null !== current && null !== current.dehydrated && (null === finishedWork || null === finishedWork.dehydrated)) : 3 === finishedWork.tag ? current.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256) : !1;
    }
    function commitBeforeMutationEffects(root, firstChild) {
        root = root.containerInfo;
        eventsEnabled = _enabled;
        root = getActiveElementDeep(root);
        if (hasSelectionCapabilities(root)) {
            if ("selectionStart" in root) var JSCompiler_temp = {
                start: root.selectionStart,
                end: root.selectionEnd
            };
            else a: {
                JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
                var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
                if (selection && 0 !== selection.rangeCount) {
                    JSCompiler_temp = selection.anchorNode;
                    var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                    selection = selection.focusOffset;
                    try {
                        JSCompiler_temp.nodeType, focusNode.nodeType;
                    } catch (e$2) {
                        JSCompiler_temp = null;
                        break a;
                    }
                    var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                    b: for(;;){
                        for(var next;;){
                            node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                            node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                            3 === node.nodeType && (length += node.nodeValue.length);
                            if (null === (next = node.firstChild)) break;
                            parentNode = node;
                            node = next;
                        }
                        for(;;){
                            if (node === root) break b;
                            parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                            parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                            if (null !== (next = node.nextSibling)) break;
                            node = parentNode;
                            parentNode = node.parentNode;
                        }
                        node = next;
                    }
                    JSCompiler_temp = -1 === start || -1 === end ? null : {
                        start: start,
                        end: end
                    };
                } else JSCompiler_temp = null;
            }
            JSCompiler_temp = JSCompiler_temp || {
                start: 0,
                end: 0
            };
        } else JSCompiler_temp = null;
        selectionInformation = {
            focusedElem: root,
            selectionRange: JSCompiler_temp
        };
        _enabled = !1;
        for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, nextEffect = root;
        else for(; null !== nextEffect;){
            root = firstChild = nextEffect;
            JSCompiler_temp = root.alternate;
            anchorOffset = root.flags;
            switch(root.tag){
                case 0:
                    if (0 !== (anchorOffset & 4) && (root = root.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                    break;
                case 11:
                case 15:
                    break;
                case 1:
                    0 !== (anchorOffset & 1024) && null !== JSCompiler_temp && commitClassSnapshot(root, JSCompiler_temp);
                    break;
                case 3:
                    if (0 !== (anchorOffset & 1024)) {
                        if (root = root.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                        else if (1 === JSCompiler_temp) switch(root.nodeName){
                            case "HEAD":
                            case "HTML":
                            case "BODY":
                                clearContainerSparingly(root);
                                break;
                            default:
                                root.textContent = "";
                        }
                    }
                    break;
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    if (0 !== (anchorOffset & 1024)) throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            root = firstChild.sibling;
            if (null !== root) {
                root.return = firstChild.return;
                nextEffect = root;
                break;
            }
            nextEffect = firstChild.return;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitHookLayoutEffects(finishedWork, Layout | HasEffect);
                break;
            case 1:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 4) {
                    if (finishedRoot = finishedWork.stateNode, null === current) finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), finishedRoot.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance")), shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, finishedRoot), recordEffectDuration()) : runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, finishedRoot);
                    else {
                        var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                        current = current.memoizedState;
                        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), finishedRoot.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
                        shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(finishedWork, callComponentDidUpdateInDEV, finishedWork, finishedRoot, prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate), recordEffectDuration()) : runWithFiberInDEV(finishedWork, callComponentDidUpdateInDEV, finishedWork, finishedRoot, prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    }
                }
                flags & 64 && commitClassCallbacks(finishedWork);
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 3:
                current = pushNestedEffectDurations();
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                    prevProps = null;
                    if (null !== finishedWork.child) switch(finishedWork.child.tag){
                        case 27:
                        case 5:
                            prevProps = finishedWork.child.stateNode;
                            break;
                        case 1:
                            prevProps = finishedWork.child.stateNode;
                    }
                    try {
                        runWithFiberInDEV(finishedWork, commitCallbacks, flags, prevProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                finishedRoot.effectDuration += popNestedEffectDurations(current);
                break;
            case 27:
                null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (null === current) {
                    if (flags & 4) commitHostMount(finishedWork);
                    else if (flags & 64) {
                        finishedRoot = finishedWork.type;
                        current = finishedWork.memoizedProps;
                        prevProps = finishedWork.stateNode;
                        try {
                            runWithFiberInDEV(finishedWork, commitHydratedInstance, prevProps, finishedRoot, current, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                if (flags & 4) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    finishedRoot = finishedWork.stateNode;
                    finishedRoot.effectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfiler, finishedWork, current, commitStartTime, finishedRoot.effectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                break;
            case 31:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (flags = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, flags))));
                break;
            case 22:
                flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
                if (!flags) {
                    current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                    prevProps = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeIsHidden = flags;
                    (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? (recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    offscreenSubtreeIsHidden = prevProps;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                }
                break;
            case 30:
                break;
            default:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(finishedWork.return.alternate, finishedWork.return) || logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount")));
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null;
        5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
        fiber.stateNode = null;
        fiber._debugOwner = null;
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null;
        fiber.updateQueue = null;
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
            injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(deletedFiber.tag){
            case 26:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (finishedRoot = deletedFiber.stateNode, finishedRoot.parentNode.removeChild(finishedRoot));
                break;
            case 27:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
                isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                runWithFiberInDEV(deletedFiber, releaseSingletonInstance, deletedFiber.stateNode);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                break;
            case 5:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            case 6:
                prevHostParent = hostParent;
                prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (null !== hostParent) {
                    if (hostParentIsContainer) try {
                        runWithFiberInDEV(deletedFiber, removeChildFromContainer, hostParent, deletedFiber.stateNode);
                    } catch (error) {
                        captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                    }
                    else try {
                        runWithFiberInDEV(deletedFiber, removeChild, hostParent, deletedFiber.stateNode);
                    } catch (error) {
                        captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                    }
                }
                break;
            case 18:
                null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
                break;
            case 4:
                prevHostParent = hostParent;
                prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = !0;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(Insertion, deletedFiber, nearestMountedAncestor);
                offscreenSubtreeWasHidden || commitHookLayoutUnmountEffects(deletedFiber, nearestMountedAncestor, Layout);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 1:
                offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 21:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 22:
                offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                offscreenSubtreeWasHidden = prevHostParent;
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
        }
        (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(deletedFiber, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
        if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
            finishedRoot = finishedRoot.dehydrated;
            try {
                runWithFiberInDEV(finishedWork, commitHydratedActivityInstance, finishedRoot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
            runWithFiberInDEV(finishedWork, commitHydratedSuspenseInstance, finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function getRetryCache(finishedWork) {
        switch(finishedWork.tag){
            case 31:
            case 13:
            case 19:
                var retryCache = finishedWork.stateNode;
                null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
                return retryCache;
            case 22:
                return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
            default:
                throw Error("Unexpected Suspense handler tag (" + finishedWork.tag + "). This is a bug in React.");
        }
    }
    function attachSuspenseRetryListeners(finishedWork, wakeables) {
        var retryCache = getRetryCache(finishedWork);
        wakeables.forEach(function(wakeable) {
            if (!retryCache.has(wakeable)) {
                retryCache.add(wakeable);
                if (isDevToolsPresent) {
                    if (null !== inProgressLanes && null !== inProgressRoot) restorePendingUpdaters(inProgressRoot, inProgressLanes);
                    else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                }
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                wakeable.then(retry, retry);
            }
        });
    }
    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
        var deletions = parentFiber.deletions;
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var root = root$jscomp$0, returnFiber = parentFiber, deletedFiber = deletions[i], prevEffectStart = pushComponentEffectStart(), parent = returnFiber;
            a: for(; null !== parent;){
                switch(parent.tag){
                    case 27:
                        if (isSingletonScope(parent.type)) {
                            hostParent = parent.stateNode;
                            hostParentIsContainer = !1;
                            break a;
                        }
                        break;
                    case 5:
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    case 3:
                    case 4:
                        hostParent = parent.stateNode.containerInfo;
                        hostParentIsContainer = !0;
                        break a;
                }
                parent = parent.return;
            }
            if (null === hostParent) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
            commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
            hostParent = null;
            hostParentIsContainer = !1;
            (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(deletedFiber, componentEffectStartTime, componentEffectEndTime, "Unmount");
            popComponentEffectStart(prevEffectStart);
            root = deletedFiber;
            returnFiber = root.alternate;
            null !== returnFiber && (returnFiber.return = null);
            root.return = null;
        }
        if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
    }
    function commitMutationEffectsOnFiber(finishedWork, root) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), current = finishedWork.alternate, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return), commitHookEffectListMount(Insertion | HasEffect, finishedWork), commitHookLayoutUnmountEffects(finishedWork, finishedWork.return, Layout | HasEffect));
                break;
            case 1:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (flags & 64 && offscreenSubtreeIsHidden && (flags = finishedWork.updateQueue, null !== flags && (current = flags.callbacks, null !== current))) {
                    var existingHiddenCallbacks = flags.shared.hiddenCallbacks;
                    flags.shared.hiddenCallbacks = null === existingHiddenCallbacks ? current : existingHiddenCallbacks.concat(current);
                }
                break;
            case 26:
                existingHiddenCallbacks = currentHoistableRoot;
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (flags & 4) {
                    var currentResource = null !== current ? current.memoizedState : null;
                    flags = finishedWork.memoizedState;
                    if (null === current) {
                        if (null === flags) {
                            if (null === finishedWork.stateNode) {
                                a: {
                                    flags = finishedWork.type;
                                    current = finishedWork.memoizedProps;
                                    existingHiddenCallbacks = existingHiddenCallbacks.ownerDocument || existingHiddenCallbacks;
                                    b: switch(flags){
                                        case "title":
                                            currentResource = existingHiddenCallbacks.getElementsByTagName("title")[0];
                                            if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || currentResource.namespaceURI === SVG_NAMESPACE || currentResource.hasAttribute("itemprop")) currentResource = existingHiddenCallbacks.createElement(flags), existingHiddenCallbacks.head.insertBefore(currentResource, existingHiddenCallbacks.querySelector("head > title"));
                                            setInitialProperties(currentResource, flags, current);
                                            currentResource[internalInstanceKey] = finishedWork;
                                            markNodeAsHoistable(currentResource);
                                            flags = currentResource;
                                            break a;
                                        case "link":
                                            var maybeNodes = getHydratableHoistableCache("link", "href", existingHiddenCallbacks).get(flags + (current.href || ""));
                                            if (maybeNodes) {
                                                for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                    maybeNodes.splice(i, 1);
                                                    break b;
                                                }
                                            }
                                            currentResource = existingHiddenCallbacks.createElement(flags);
                                            setInitialProperties(currentResource, flags, current);
                                            existingHiddenCallbacks.head.appendChild(currentResource);
                                            break;
                                        case "meta":
                                            if (maybeNodes = getHydratableHoistableCache("meta", "content", existingHiddenCallbacks).get(flags + (current.content || ""))) {
                                                for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], checkAttributeStringCoercion(current.content, "content"), currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                    maybeNodes.splice(i, 1);
                                                    break b;
                                                }
                                            }
                                            currentResource = existingHiddenCallbacks.createElement(flags);
                                            setInitialProperties(currentResource, flags, current);
                                            existingHiddenCallbacks.head.appendChild(currentResource);
                                            break;
                                        default:
                                            throw Error('getNodesForType encountered a type it did not expect: "' + flags + '". This is a bug in React.');
                                    }
                                    currentResource[internalInstanceKey] = finishedWork;
                                    markNodeAsHoistable(currentResource);
                                    flags = currentResource;
                                }
                                finishedWork.stateNode = flags;
                            } else mountHoistable(existingHiddenCallbacks, finishedWork.type, finishedWork.stateNode);
                        } else finishedWork.stateNode = acquireResource(existingHiddenCallbacks, flags, finishedWork.memoizedProps);
                    } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(existingHiddenCallbacks, finishedWork.type, finishedWork.stateNode) : acquireResource(existingHiddenCallbacks, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                }
                break;
            case 27:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                break;
            case 5:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (finishedWork.flags & 32) {
                    existingHiddenCallbacks = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, resetTextContent, existingHiddenCallbacks);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                flags & 4 && null != finishedWork.stateNode && (existingHiddenCallbacks = finishedWork.memoizedProps, commitHostUpdate(finishedWork, existingHiddenCallbacks, null !== current ? current.memoizedProps : existingHiddenCallbacks));
                flags & 1024 && (needsFormReset = !0, "form" !== finishedWork.type && console.error("Unexpected host component type. Expected a form. This is a bug in React."));
                break;
            case 6:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & 4) {
                    if (null === finishedWork.stateNode) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    flags = finishedWork.memoizedProps;
                    current = null !== current ? current.memoizedProps : flags;
                    existingHiddenCallbacks = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, commitTextUpdate, existingHiddenCallbacks, current, flags);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                break;
            case 3:
                existingHiddenCallbacks = pushNestedEffectDurations();
                tagCaches = null;
                currentResource = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(root.containerInfo);
                recursivelyTraverseMutationEffects(root, finishedWork);
                currentHoistableRoot = currentResource;
                commitReconciliationEffects(finishedWork);
                if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                    runWithFiberInDEV(finishedWork, commitHydratedContainer, root.containerInfo);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
                root.effectDuration += popNestedEffectDurations(existingHiddenCallbacks);
                break;
            case 4:
                flags = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                currentHoistableRoot = flags;
                break;
            case 12:
                flags = pushNestedEffectDurations();
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                finishedWork.stateNode.effectDuration += bubbleNestedEffectDurations(flags);
                break;
            case 31:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 13:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now$1());
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 22:
                existingHiddenCallbacks = null !== finishedWork.memoizedState;
                var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || existingHiddenCallbacks;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
                recursivelyTraverseMutationEffects(root, finishedWork);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                wasHidden && !existingHiddenCallbacks && !prevOffscreenSubtreeIsHidden && !prevOffscreenSubtreeWasHidden && (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime);
                commitReconciliationEffects(finishedWork);
                if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = existingHiddenCallbacks ? root._visibility & ~OffscreenVisible : root._visibility | OffscreenVisible, !existingHiddenCallbacks || null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || (recursivelyTraverseDisappearLayoutEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Disconnect")), current = null, root = finishedWork;;){
                    if (5 === root.tag || 26 === root.tag) {
                        if (null === current) {
                            wasHidden = current = root;
                            try {
                                currentResource = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(wasHidden, hideInstance, currentResource) : runWithFiberInDEV(wasHidden, unhideInstance, wasHidden.stateNode, wasHidden.memoizedProps);
                            } catch (error) {
                                captureCommitPhaseError(wasHidden, wasHidden.return, error);
                            }
                        }
                    } else if (6 === root.tag) {
                        if (null === current) {
                            wasHidden = root;
                            try {
                                maybeNodes = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(wasHidden, hideTextInstance, maybeNodes) : runWithFiberInDEV(wasHidden, unhideTextInstance, maybeNodes, wasHidden.memoizedProps);
                            } catch (error) {
                                captureCommitPhaseError(wasHidden, wasHidden.return, error);
                            }
                        }
                    } else if (18 === root.tag) {
                        if (null === current) {
                            wasHidden = root;
                            try {
                                i = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(wasHidden, hideDehydratedBoundary, i) : runWithFiberInDEV(wasHidden, unhideDehydratedBoundary, wasHidden.stateNode);
                            } catch (error) {
                                captureCommitPhaseError(wasHidden, wasHidden.return, error);
                            }
                        }
                    } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                        root.child.return = root;
                        root = root.child;
                        continue;
                    }
                    if (root === finishedWork) break a;
                    for(; null === root.sibling;){
                        if (null === root.return || root.return === finishedWork) break a;
                        current === root && (current = null);
                        root = root.return;
                    }
                    current === root && (current = null);
                    root.sibling.return = root.return;
                    root = root.sibling;
                }
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
                break;
            case 19:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 30:
                break;
            case 21:
                break;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(finishedWork.return.alternate, finishedWork.return) || logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount")));
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitReconciliationEffects(finishedWork) {
        var flags = finishedWork.flags;
        if (flags & 2) {
            try {
                runWithFiberInDEV(finishedWork, commitPlacement, finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            finishedWork.flags &= -3;
        }
        flags & 4096 && (finishedWork.flags &= -4097);
    }
    function recursivelyResetForms(parentFiber) {
        if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var fiber = parentFiber;
            recursivelyResetForms(fiber);
            5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseLayoutEffects(root, parentFiber) {
        if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
    }
    function disappearLayoutEffects(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookLayoutUnmountEffects(finishedWork, finishedWork.return, Layout);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                runWithFiberInDEV(finishedWork, releaseSingletonInstance, finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
        for(parentFiber = parentFiber.child; null !== parentFiber;)disappearLayoutEffects(parentFiber), parentFiber = parentFiber.sibling;
    }
    function reappearLayoutEffects(finishedRoot, current, finishedWork, includeWorkInProgressEffects) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookLayoutEffects(finishedWork, Layout);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork.stateNode;
                "function" === typeof current.componentDidMount && runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, current);
                current = finishedWork.updateQueue;
                if (null !== current) {
                    finishedRoot = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, commitHiddenCallbacks, current, finishedRoot);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                if (includeWorkInProgressEffects && flags & 4) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    includeWorkInProgressEffects = finishedWork.stateNode;
                    includeWorkInProgressEffects.effectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfiler, finishedWork, current, commitStartTime, includeWorkInProgressEffects.effectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseReappearLayoutEffects(finishedRoot, parentFiber, includeWorkInProgressEffects) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
        for(parentFiber = parentFiber.child; null !== parentFiber;)reappearLayoutEffects(finishedRoot, parentFiber.alternate, parentFiber, includeWorkInProgressEffects), parentFiber = parentFiber.sibling;
    }
    function commitOffscreenPassiveMountEffects(current, finishedWork) {
        var previousCache = null;
        null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
        current = null;
        null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
        current !== previousCache && (null != current && retainCache(current), null != previousCache && releaseCache(previousCache));
    }
    function commitCachePassiveMountEffect(current, finishedWork) {
        current = null;
        null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
        finishedWork = finishedWork.memoizedState.cache;
        finishedWork !== current && (retainCache(finishedWork), null != current && releaseCache(current));
    }
    function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions, endTime) {
        if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child)) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var nextSibling = parentFiber.sibling;
            commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions, null !== nextSibling ? nextSibling.actualStartTime : endTime);
            parentFiber = nextSibling;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                flags & 2048 && commitHookPassiveMountEffects(finishedWork, Passive | HasEffect);
                break;
            case 1:
                (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && (0 !== (finishedWork.flags & 128) ? logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, []) : 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes));
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            case 3:
                var prevProfilerEffectDuration = pushNestedEffectDurations(), wasInHydratedSubtree = inHydratedSubtree;
                inHydratedSubtree = null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = wasInHydratedSubtree;
                flags & 2048 && (committedLanes = null, null !== finishedWork.alternate && (committedLanes = finishedWork.alternate.memoizedState.cache), committedTransitions = finishedWork.memoizedState.cache, committedTransitions !== committedLanes && (retainCache(committedTransitions), null != committedLanes && releaseCache(committedLanes)));
                finishedRoot.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 12:
                if (flags & 2048) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                    finishedRoot = finishedWork.stateNode;
                    finishedRoot.passiveEffectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfilerPostCommitImpl, finishedWork, finishedWork.alternate, commitStartTime, finishedRoot.passiveEffectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            case 31:
                flags = inHydratedSubtree;
                prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
                wasInHydratedSubtree = finishedWork.memoizedState;
                null !== prevProfilerEffectDuration && null === wasInHydratedSubtree ? (wasInHydratedSubtree = finishedWork.deletions, null !== wasInHydratedSubtree && 0 < wasInHydratedSubtree.length && 18 === wasInHydratedSubtree[0].tag ? (inHydratedSubtree = !1, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, prevProfilerEffectDuration)) : inHydratedSubtree = !0) : inHydratedSubtree = !1;
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = flags;
                break;
            case 13:
                flags = inHydratedSubtree;
                prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
                wasInHydratedSubtree = finishedWork.memoizedState;
                null === prevProfilerEffectDuration || null === prevProfilerEffectDuration.dehydrated || null !== wasInHydratedSubtree && null !== wasInHydratedSubtree.dehydrated ? inHydratedSubtree = !1 : (wasInHydratedSubtree = finishedWork.deletions, null !== wasInHydratedSubtree && 0 < wasInHydratedSubtree.length && 18 === wasInHydratedSubtree[0].tag ? (inHydratedSubtree = !1, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, prevProfilerEffectDuration)) : inHydratedSubtree = !0);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = flags;
                break;
            case 23:
                break;
            case 22:
                wasInHydratedSubtree = finishedWork.stateNode;
                prevProfilerEffectDuration = finishedWork.alternate;
                null !== finishedWork.memoizedState ? wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : (wasInHydratedSubtree._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== finishedWork.actualDuration && (null === finishedWork.alternate || finishedWork.alternate.child !== finishedWork.child), endTime), (finishedWork.mode & ProfileMode) === NoMode || inHydratedSubtree || (finishedRoot = finishedWork.actualStartTime, 0 <= finishedRoot && 0.05 < endTime - finishedRoot && logComponentReappeared(finishedWork, finishedRoot, endTime), 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime)));
                flags & 2048 && commitOffscreenPassiveMountEffects(prevProfilerEffectDuration, finishedWork);
                break;
            case 24:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
        }
        if ((finishedWork.mode & ProfileMode) !== NoMode) {
            if (finishedRoot = !inHydratedSubtree && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate) committedLanes = finishedWork.actualStartTime, 0 <= committedLanes && 0.05 < endTime - committedLanes && logComponentTrigger(finishedWork, committedLanes, endTime, "Mount");
            0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), finishedRoot && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount"));
        }
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseReconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child));
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var nextSibling = parentFiber.sibling;
            reconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, null !== nextSibling ? nextSibling.actualStartTime : endTime);
            parentFiber = nextSibling;
        }
    }
    function reconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality;
        includeWorkInProgressEffects && (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes);
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
                commitHookPassiveMountEffects(finishedWork, Passive);
                break;
            case 23:
                break;
            case 22:
                var _instance2 = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? _instance2._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : (_instance2._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, endTime$jscomp$0) {
        if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child)) for(var child = parentFiber.child; null !== child;){
            parentFiber = child.sibling;
            var finishedRoot = finishedRoot$jscomp$0, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, endTime = null !== parentFiber ? parentFiber.actualStartTime : endTime$jscomp$0, prevDeepEquality = alreadyWarnedForDeepEquality;
            (child.mode & ProfileMode) !== NoMode && 0 < child.actualStartTime && 0 !== (child.flags & 1) && logComponentRender(child, child.actualStartTime, endTime, inHydratedSubtree, committedLanes);
            var flags = child.flags;
            switch(child.tag){
                case 22:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
                    flags & 2048 && commitOffscreenPassiveMountEffects(child.alternate, child);
                    break;
                case 24:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
                    flags & 2048 && commitCachePassiveMountEffect(child.alternate, child);
                    break;
                default:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
            }
            alreadyWarnedForDeepEquality = prevDeepEquality;
            child = parentFiber;
        }
    }
    function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
        if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
    }
    function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
        switch(fiber.tag){
            case 26:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
                break;
            case 5:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                break;
            case 3:
            case 4:
                var previousHoistableRoot = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                currentHoistableRoot = previousHoistableRoot;
                break;
            case 22:
                null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
                break;
            default:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
        }
    }
    function detachAlternateSiblings(parentFiber) {
        var previousFiber = parentFiber.alternate;
        if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
            previousFiber.child = null;
            do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
            while (null !== parentFiber);
        }
    }
    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i], prevEffectStart = pushComponentEffectStart();
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
                (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(childToDelete, componentEffectStartTime, componentEffectEndTime, "Unmount");
                popComponentEffectStart(prevEffectStart);
            }
            detachAlternateSiblings(parentFiber);
        }
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.flags & 2048 && commitHookPassiveUnmountEffects(finishedWork, finishedWork.return, Passive | HasEffect);
                break;
            case 3:
                var prevProfilerEffectDuration = pushNestedEffectDurations();
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.stateNode.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 12:
                prevProfilerEffectDuration = pushNestedEffectDurations();
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.stateNode.passiveEffectDuration += bubbleNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 22:
                prevProfilerEffectDuration = finishedWork.stateNode;
                null !== finishedWork.memoizedState && prevProfilerEffectDuration._visibility & OffscreenPassiveEffectsConnected && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (prevProfilerEffectDuration._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Disconnect")) : recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            default:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
    }
    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i], prevEffectStart = pushComponentEffectStart();
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
                (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(childToDelete, componentEffectStartTime, componentEffectEndTime, "Unmount");
                popComponentEffectStart(prevEffectStart);
            }
            detachAlternateSiblings(parentFiber);
        }
        for(parentFiber = parentFiber.child; null !== parentFiber;)disconnectPassiveEffect(parentFiber), parentFiber = parentFiber.sibling;
    }
    function disconnectPassiveEffect(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                commitHookPassiveUnmountEffects(finishedWork, finishedWork.return, Passive);
                recursivelyTraverseDisconnectPassiveEffects(finishedWork);
                break;
            case 22:
                var instance = finishedWork.stateNode;
                instance._visibility & OffscreenPassiveEffectsConnected && (instance._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor$jscomp$0) {
        for(; null !== nextEffect;){
            var fiber = nextEffect, current = fiber, nearestMountedAncestor = nearestMountedAncestor$jscomp$0, prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
            switch(current.tag){
                case 0:
                case 11:
                case 15:
                    commitHookPassiveUnmountEffects(current, nearestMountedAncestor, Passive);
                    break;
                case 23:
                case 22:
                    null !== current.memoizedState && null !== current.memoizedState.cachePool && (nearestMountedAncestor = current.memoizedState.cachePool.pool, null != nearestMountedAncestor && retainCache(nearestMountedAncestor));
                    break;
                case 24:
                    releaseCache(current.memoizedState.cache);
            }
            (current.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(current, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
            popComponentEffectStart(prevEffectStart);
            popComponentEffectDuration(prevEffectDuration);
            componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
            componentEffectErrors = prevEffectErrors;
            current = fiber.child;
            if (null !== current) current.return = fiber, nextEffect = current;
            else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
                current = nextEffect;
                prevEffectStart = current.sibling;
                prevEffectDuration = current.return;
                detachFiberAfterEffects(current);
                if (current === fiber) {
                    nextEffect = null;
                    break a;
                }
                if (null !== prevEffectStart) {
                    prevEffectStart.return = prevEffectDuration;
                    nextEffect = prevEffectStart;
                    break a;
                }
                nextEffect = prevEffectDuration;
            }
        }
    }
    function onCommitRoot() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = "undefined" !== typeof IS_REACT_ACT_ENVIRONMENT ? IS_REACT_ACT_ENVIRONMENT : void 0;
        isReactActEnvironmentGlobal || null === ReactSharedInternals.actQueue || console.error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    function requestUpdateLane(fiber) {
        if ((executionContext & RenderContext) !== NoContext && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
        var transition = ReactSharedInternals.T;
        return null !== transition ? (transition._updatedFibers || (transition._updatedFibers = new Set()), transition._updatedFibers.add(fiber), requestTransitionLane()) : resolveUpdatePriority();
    }
    function requestDeferredLane() {
        if (0 === workInProgressDeferredLane) {
            if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
                var lane = nextTransitionDeferredLane;
                nextTransitionDeferredLane <<= 1;
                0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
                workInProgressDeferredLane = lane;
            } else workInProgressDeferredLane = 536870912;
        }
        lane = suspenseHandlerStackCursor.current;
        null !== lane && (lane.flags |= 32);
        return workInProgressDeferredLane;
    }
    function scheduleUpdateOnFiber(root, fiber, lane) {
        isRunningInsertionEffect && console.error("useInsertionEffect must not schedule updates.");
        isFlushingPassiveEffects && (didScheduleUpdateDuringPassiveEffects = !0);
        if (root === workInProgressRoot && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
        markRootUpdated$1(root, lane);
        if ((executionContext & RenderContext) !== NoContext && root === workInProgressRoot) {
            if (isRendering) switch(fiber.tag){
                case 0:
                case 11:
                case 15:
                    root = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown";
                    didWarnAboutUpdateInRenderForAnotherComponent.has(root) || (didWarnAboutUpdateInRenderForAnotherComponent.add(root), fiber = getComponentNameFromFiber(fiber) || "Unknown", console.error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render", fiber, root, root));
                    break;
                case 1:
                    didWarnAboutUpdateInRender || (console.error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), didWarnAboutUpdateInRender = !0);
            }
        } else isDevToolsPresent && addFiberToLanesMap(root, fiber, lane), warnIfUpdatesNotWrappedWithActDEV(fiber), root === workInProgressRoot && ((executionContext & RenderContext) === NoContext && (workInProgressRootInterleavedUpdatedLanes |= lane), workInProgressRootExitStatus === RootSuspendedWithDelay && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
    }
    function performWorkOnRoot(root, lanes, forceSync) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Should not already be working.");
        if (0 !== workInProgressRootRenderLanes && null !== workInProgress) {
            var yieldedFiber = workInProgress, yieldEndTime = now$1();
            switch(yieldReason){
                case SuspendedOnImmediate:
                case SuspendedOnData:
                    var startTime = yieldStartTime;
                    supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(console.timeStamp.bind(console, "Suspended", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light")) : console.timeStamp("Suspended", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light"));
                    break;
                case SuspendedOnAction:
                    startTime = yieldStartTime;
                    supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(console.timeStamp.bind(console, "Action", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light")) : console.timeStamp("Action", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light"));
                    break;
                default:
                    supportsUserTiming && (yieldedFiber = yieldEndTime - yieldStartTime, 3 > yieldedFiber || console.timeStamp("Blocked", yieldStartTime, yieldEndTime, COMPONENTS_TRACK, void 0, 5 > yieldedFiber ? "primary-light" : 10 > yieldedFiber ? "primary" : 100 > yieldedFiber ? "primary-dark" : "error"));
            }
        }
        startTime = (forceSync = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root.expiredLanes) || checkIfRootIsPrerendering(root, lanes)) ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes, !0);
        var renderWasConcurrent = forceSync;
        do {
            if (startTime === RootInProgress) {
                workInProgressRootIsPrerendering && !forceSync && markRootSuspended(root, lanes, 0, !1);
                lanes = workInProgressSuspendedReason;
                yieldStartTime = now();
                yieldReason = lanes;
                break;
            } else {
                yieldedFiber = now$1();
                yieldEndTime = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(yieldEndTime)) {
                    setCurrentTrackFromLanes(lanes);
                    yieldEndTime = renderStartTime;
                    startTime = yieldedFiber;
                    !supportsUserTiming || startTime <= yieldEndTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(console.timeStamp.bind(console, "Teared Render", yieldEndTime, startTime, currentTrack, LANES_TRACK_GROUP, "error")) : console.timeStamp("Teared Render", yieldEndTime, startTime, currentTrack, LANES_TRACK_GROUP, "error"));
                    finalizeRender(lanes, yieldedFiber);
                    startTime = renderRootSync(root, lanes, !1);
                    renderWasConcurrent = !1;
                    continue;
                }
                if (startTime === RootErrored) {
                    renderWasConcurrent = lanes;
                    if (root.errorRecoveryDisabledLanes & renderWasConcurrent) var errorRetryLanes = 0;
                    else errorRetryLanes = root.pendingLanes & -536870913, errorRetryLanes = 0 !== errorRetryLanes ? errorRetryLanes : errorRetryLanes & 536870912 ? 536870912 : 0;
                    if (0 !== errorRetryLanes) {
                        setCurrentTrackFromLanes(lanes);
                        logErroredRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                        finalizeRender(lanes, yieldedFiber);
                        lanes = errorRetryLanes;
                        a: {
                            yieldedFiber = root;
                            startTime = renderWasConcurrent;
                            renderWasConcurrent = workInProgressRootConcurrentErrors;
                            var wasRootDehydrated = yieldedFiber.current.memoizedState.isDehydrated;
                            wasRootDehydrated && (prepareFreshStack(yieldedFiber, errorRetryLanes).flags |= 256);
                            errorRetryLanes = renderRootSync(yieldedFiber, errorRetryLanes, !1);
                            if (errorRetryLanes !== RootErrored) {
                                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                    yieldedFiber.errorRecoveryDisabledLanes |= startTime;
                                    workInProgressRootInterleavedUpdatedLanes |= startTime;
                                    startTime = RootSuspendedWithDelay;
                                    break a;
                                }
                                yieldedFiber = workInProgressRootRecoverableErrors;
                                workInProgressRootRecoverableErrors = renderWasConcurrent;
                                null !== yieldedFiber && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = yieldedFiber : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, yieldedFiber));
                            }
                            startTime = errorRetryLanes;
                        }
                        renderWasConcurrent = !1;
                        if (startTime !== RootErrored) continue;
                        else yieldedFiber = now$1();
                    }
                }
                if (startTime === RootFatalErrored) {
                    setCurrentTrackFromLanes(lanes);
                    logErroredRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                    finalizeRender(lanes, yieldedFiber);
                    prepareFreshStack(root, 0);
                    markRootSuspended(root, lanes, 0, !0);
                    break;
                }
                a: {
                    forceSync = root;
                    switch(startTime){
                        case RootInProgress:
                        case RootFatalErrored:
                            throw Error("Root did not complete. This is a bug in React.");
                        case RootSuspendedWithDelay:
                            if ((lanes & 4194048) !== lanes) break;
                        case RootSuspendedAtTheShell:
                            setCurrentTrackFromLanes(lanes);
                            logSuspendedRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                            finalizeRender(lanes, yieldedFiber);
                            yieldEndTime = lanes;
                            0 !== (yieldEndTime & 127) ? blockingSuspendedTime = yieldedFiber : 0 !== (yieldEndTime & 4194048) && (transitionSuspendedTime = yieldedFiber);
                            markRootSuspended(forceSync, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        case RootErrored:
                            workInProgressRootRecoverableErrors = null;
                            break;
                        case RootSuspended:
                        case RootCompleted:
                            break;
                        default:
                            throw Error("Unknown root exit status.");
                    }
                    if (null !== ReactSharedInternals.actQueue) commitRoot(forceSync, yieldEndTime, lanes, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, startTime, null, null, renderStartTime, yieldedFiber);
                    else {
                        if ((lanes & 62914560) === lanes && (renderWasConcurrent = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now$1(), 10 < renderWasConcurrent)) {
                            markRootSuspended(forceSync, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            if (0 !== getNextLanes(forceSync, 0, !0)) break a;
                            pendingEffectsLanes = lanes;
                            forceSync.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, forceSync, yieldEndTime, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, "Throttled", renderStartTime, yieldedFiber), renderWasConcurrent);
                            break a;
                        }
                        commitRootWhenReady(forceSync, yieldEndTime, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, null, renderStartTime, yieldedFiber);
                    }
                }
            }
            break;
        }while (1);
        ensureRootIsScheduled(root);
    }
    function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.timeoutHandle = noTimeout;
        var subtreeFlags = finishedWork.subtreeFlags, suspendedState = null;
        if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
            if (suspendedState = {
                stylesheets: null,
                count: 0,
                imgCount: 0,
                imgBytes: 0,
                suspenseyImages: [],
                waitingForImages: !0,
                waitingForViewTransition: !1,
                unsuspend: noop$1
            }, accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedState), subtreeFlags = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now$1() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now$1() : 0, subtreeFlags = waitForCommitToBeReady(suspendedState, subtreeFlags), null !== subtreeFlags) {
                pendingEffectsLanes = lanes;
                root.cancelPendingCommit = subtreeFlags(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedState.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < suspendedState.count ? 0 < suspendedState.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : 1 === suspendedState.imgCount ? "Suspended on an Image" : 0 < suspendedState.imgCount ? "Suspended on Images" : null, completedRenderStartTime, completedRenderEndTime));
                markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
                return;
            }
        }
        commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        for(var node = finishedWork;;){
            var tag = node.tag;
            if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
                var check = tag[i], getSnapshot = check.getSnapshot;
                check = check.value;
                try {
                    if (!objectIs(getSnapshot(), check)) return !1;
                } catch (error) {
                    return !1;
                }
            }
            tag = node.child;
            if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
            else {
                if (node === finishedWork) break;
                for(; null === node.sibling;){
                    if (null === node.return || node.return === finishedWork) return !0;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
        return !0;
    }
    function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
        suspendedLanes &= ~workInProgressRootPingedLanes;
        suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes;
        didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
        didAttemptEntireTree = root.expirationTimes;
        for(var lanes = suspendedLanes; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index;
            didAttemptEntireTree[index] = -1;
            lanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
    }
    function flushSyncWork$1() {
        return (executionContext & (RenderContext | CommitContext)) === NoContext ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
    }
    function resetWorkInProgressStack() {
        if (null !== workInProgress) {
            if (workInProgressSuspendedReason === NotSuspended) var interruptedWork = workInProgress.return;
            else interruptedWork = workInProgress, resetContextDependencies(), resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
            for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
            workInProgress = null;
        }
    }
    function finalizeRender(lanes, finalizationTime) {
        0 !== (lanes & 127) && (blockingClampTime = finalizationTime);
        0 !== (lanes & 4194048) && (transitionClampTime = finalizationTime);
        0 !== (lanes & 62914560) && (retryClampTime = finalizationTime);
        0 !== (lanes & 2080374784) && (idleClampTime = finalizationTime);
    }
    function prepareFreshStack(root, lanes) {
        supportsUserTiming && (console.timeStamp("Blocking Track", 0.003, 0.003, "Blocking", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Transition Track", 0.003, 0.003, "Transition", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Suspense Track", 0.003, 0.003, "Suspense", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Idle Track", 0.003, 0.003, "Idle", LANES_TRACK_GROUP, "primary-light"));
        var previousRenderStartTime = renderStartTime;
        renderStartTime = now();
        if (0 !== workInProgressRootRenderLanes && 0 < previousRenderStartTime) {
            setCurrentTrackFromLanes(workInProgressRootRenderLanes);
            if (workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootSuspendedWithDelay) logSuspendedRenderPhase(previousRenderStartTime, renderStartTime, lanes, workInProgressUpdateTask);
            else {
                var endTime = renderStartTime, debugTask = workInProgressUpdateTask;
                if (supportsUserTiming && !(endTime <= previousRenderStartTime)) {
                    var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", label = (lanes & 536870912) === lanes ? "Prewarm" : (lanes & 201326741) === lanes ? "Interrupted Hydration" : "Interrupted Render";
                    debugTask ? debugTask.run(console.timeStamp.bind(console, label, previousRenderStartTime, endTime, currentTrack, LANES_TRACK_GROUP, color)) : console.timeStamp(label, previousRenderStartTime, endTime, currentTrack, LANES_TRACK_GROUP, color);
                }
            }
            finalizeRender(workInProgressRootRenderLanes, renderStartTime);
        }
        previousRenderStartTime = workInProgressUpdateTask;
        workInProgressUpdateTask = null;
        if (0 !== (lanes & 127)) {
            workInProgressUpdateTask = blockingUpdateTask;
            debugTask = 0 <= blockingUpdateTime && blockingUpdateTime < blockingClampTime ? blockingClampTime : blockingUpdateTime;
            endTime = 0 <= blockingEventTime && blockingEventTime < blockingClampTime ? blockingClampTime : blockingEventTime;
            color = 0 <= endTime ? endTime : 0 <= debugTask ? debugTask : renderStartTime;
            0 <= blockingSuspendedTime ? (setCurrentTrackFromLanes(2), logSuspendedWithDelayPhase(blockingSuspendedTime, color, lanes, previousRenderStartTime)) : 0 !== (animatingLanes & 127) && (setCurrentTrackFromLanes(2), logAnimatingPhase(blockingClampTime, color, animatingTask));
            previousRenderStartTime = debugTask;
            var eventTime = endTime, eventType = blockingEventType, eventIsRepeat = 0 < blockingEventRepeatTime, isSpawnedUpdate = blockingUpdateType === SPAWNED_UPDATE, isPingedUpdate = blockingUpdateType === PINGED_UPDATE;
            debugTask = renderStartTime;
            endTime = blockingUpdateTask;
            color = blockingUpdateMethodName;
            label = blockingUpdateComponentName;
            if (supportsUserTiming) {
                currentTrack = "Blocking";
                0 < previousRenderStartTime ? previousRenderStartTime > debugTask && (previousRenderStartTime = debugTask) : previousRenderStartTime = debugTask;
                0 < eventTime ? eventTime > previousRenderStartTime && (eventTime = previousRenderStartTime) : eventTime = previousRenderStartTime;
                if (null !== eventType && previousRenderStartTime > eventTime) {
                    var color$jscomp$0 = eventIsRepeat ? "secondary-light" : "warning";
                    endTime ? endTime.run(console.timeStamp.bind(console, eventIsRepeat ? "Consecutive" : "Event: " + eventType, eventTime, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)) : console.timeStamp(eventIsRepeat ? "Consecutive" : "Event: " + eventType, eventTime, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, color$jscomp$0);
                }
                debugTask > previousRenderStartTime && (eventTime = isSpawnedUpdate ? "error" : (lanes & 738197653) === lanes ? "tertiary-light" : "primary-light", isSpawnedUpdate = isPingedUpdate ? "Promise Resolved" : isSpawnedUpdate ? "Cascading Update" : 5 < debugTask - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != label && isPingedUpdate.push([
                    "Component name",
                    label
                ]), null != color && isPingedUpdate.push([
                    "Method name",
                    color
                ]), previousRenderStartTime = {
                    start: previousRenderStartTime,
                    end: debugTask,
                    detail: {
                        devtools: {
                            properties: isPingedUpdate,
                            track: currentTrack,
                            trackGroup: LANES_TRACK_GROUP,
                            color: eventTime
                        }
                    }
                }, endTime ? endTime.run(performance.measure.bind(performance, isSpawnedUpdate, previousRenderStartTime)) : performance.measure(isSpawnedUpdate, previousRenderStartTime));
            }
            blockingUpdateTime = -1.1;
            blockingUpdateType = 0;
            blockingUpdateComponentName = blockingUpdateMethodName = null;
            blockingSuspendedTime = -1.1;
            blockingEventRepeatTime = blockingEventTime;
            blockingEventTime = -1.1;
            blockingClampTime = now();
        }
        0 !== (lanes & 4194048) && (workInProgressUpdateTask = transitionUpdateTask, debugTask = 0 <= transitionStartTime && transitionStartTime < transitionClampTime ? transitionClampTime : transitionStartTime, previousRenderStartTime = 0 <= transitionUpdateTime && transitionUpdateTime < transitionClampTime ? transitionClampTime : transitionUpdateTime, endTime = 0 <= transitionEventTime && transitionEventTime < transitionClampTime ? transitionClampTime : transitionEventTime, color = 0 <= endTime ? endTime : 0 <= previousRenderStartTime ? previousRenderStartTime : renderStartTime, 0 <= transitionSuspendedTime ? (setCurrentTrackFromLanes(256), logSuspendedWithDelayPhase(transitionSuspendedTime, color, lanes, workInProgressUpdateTask)) : 0 !== (animatingLanes & 4194048) && (setCurrentTrackFromLanes(256), logAnimatingPhase(transitionClampTime, color, animatingTask)), isPingedUpdate = endTime, eventTime = transitionEventType, eventType = 0 < transitionEventRepeatTime, eventIsRepeat = transitionUpdateType === PINGED_UPDATE, color = renderStartTime, endTime = transitionUpdateTask, label = transitionUpdateMethodName, isSpawnedUpdate = transitionUpdateComponentName, supportsUserTiming && (currentTrack = "Transition", 0 < previousRenderStartTime ? previousRenderStartTime > color && (previousRenderStartTime = color) : previousRenderStartTime = color, 0 < debugTask ? debugTask > previousRenderStartTime && (debugTask = previousRenderStartTime) : debugTask = previousRenderStartTime, 0 < isPingedUpdate ? isPingedUpdate > debugTask && (isPingedUpdate = debugTask) : isPingedUpdate = debugTask, debugTask > isPingedUpdate && null !== eventTime && (color$jscomp$0 = eventType ? "secondary-light" : "warning", endTime ? endTime.run(console.timeStamp.bind(console, eventType ? "Consecutive" : "Event: " + eventTime, isPingedUpdate, debugTask, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)) : console.timeStamp(eventType ? "Consecutive" : "Event: " + eventTime, isPingedUpdate, debugTask, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)), previousRenderStartTime > debugTask && (endTime ? endTime.run(console.timeStamp.bind(console, "Action", debugTask, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, "primary-dark")) : console.timeStamp("Action", debugTask, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, "primary-dark")), color > previousRenderStartTime && (debugTask = eventIsRepeat ? "Promise Resolved" : 5 < color - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != isSpawnedUpdate && isPingedUpdate.push([
            "Component name",
            isSpawnedUpdate
        ]), null != label && isPingedUpdate.push([
            "Method name",
            label
        ]), previousRenderStartTime = {
            start: previousRenderStartTime,
            end: color,
            detail: {
                devtools: {
                    properties: isPingedUpdate,
                    track: currentTrack,
                    trackGroup: LANES_TRACK_GROUP,
                    color: "primary-light"
                }
            }
        }, endTime ? endTime.run(performance.measure.bind(performance, debugTask, previousRenderStartTime)) : performance.measure(debugTask, previousRenderStartTime))), transitionUpdateTime = transitionStartTime = -1.1, transitionUpdateType = 0, transitionSuspendedTime = -1.1, transitionEventRepeatTime = transitionEventTime, transitionEventTime = -1.1, transitionClampTime = now());
        0 !== (lanes & 62914560) && 0 !== (animatingLanes & 62914560) && (setCurrentTrackFromLanes(4194304), logAnimatingPhase(retryClampTime, renderStartTime, animatingTask));
        0 !== (lanes & 2080374784) && 0 !== (animatingLanes & 2080374784) && (setCurrentTrackFromLanes(268435456), logAnimatingPhase(idleClampTime, renderStartTime, animatingTask));
        previousRenderStartTime = root.timeoutHandle;
        previousRenderStartTime !== noTimeout && (root.timeoutHandle = noTimeout, cancelTimeout(previousRenderStartTime));
        previousRenderStartTime = root.cancelPendingCommit;
        null !== previousRenderStartTime && (root.cancelPendingCommit = null, previousRenderStartTime());
        pendingEffectsLanes = 0;
        resetWorkInProgressStack();
        workInProgressRoot = root;
        workInProgress = previousRenderStartTime = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = lanes;
        workInProgressSuspendedReason = NotSuspended;
        workInProgressThrownValue = null;
        workInProgressRootDidSkipSuspendedSiblings = !1;
        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        workInProgressRootDidAttachPingListener = !1;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = 0;
        workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
        workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
        0 !== (lanes & 8) && (lanes |= lanes & 32);
        endTime = root.entangledLanes;
        if (0 !== endTime) for(root = root.entanglements, endTime &= lanes; 0 < endTime;)debugTask = 31 - clz32(endTime), color = 1 << debugTask, lanes |= root[debugTask], endTime &= ~color;
        entangledRenderLanes = lanes;
        finishQueueingConcurrentUpdates();
        root = getCurrentTime();
        1e3 < root - lastResetTime && (ReactSharedInternals.recentlyCreatedOwnerStacks = 0, lastResetTime = root);
        ReactStrictModeWarnings.discardPendingWarnings();
        return previousRenderStartTime;
    }
    function handleThrow(root, thrownValue) {
        currentlyRenderingFiber = null;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        ReactSharedInternals.getCurrentStack = null;
        isRendering = !1;
        current = null;
        thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnImmediate) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnInstance) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? SuspendedOnHydration : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? SuspendedOnDeprecatedThrowPromise : SuspendedOnError;
        workInProgressThrownValue = thrownValue;
        var erroredWork = workInProgress;
        null === erroredWork ? (workInProgressRootExitStatus = RootFatalErrored, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current))) : erroredWork.mode & ProfileMode && stopProfilerTimerIfRunningAndRecordDuration(erroredWork);
    }
    function shouldRemainOnPreviousScreen() {
        var handler = suspenseHandlerStackCursor.current;
        return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
    }
    function pushDispatcher() {
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
    }
    function pushAsyncDispatcher() {
        var prevAsyncDispatcher = ReactSharedInternals.A;
        ReactSharedInternals.A = DefaultAsyncDispatcher;
        return prevAsyncDispatcher;
    }
    function markRenderDerivedCause(fiber) {
        null === workInProgressUpdateTask && (workInProgressUpdateTask = null == fiber._debugTask ? null : fiber._debugTask);
    }
    function renderDidSuspendDelayIfPossible() {
        workInProgressRootExitStatus = RootSuspendedWithDelay;
        workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
        0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    }
    function renderRootSync(root, lanes, shouldYieldForPrerendering) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                0 < memoizedUpdaters.size && (restorePendingUpdaters(root, workInProgressRootRenderLanes), memoizedUpdaters.clear());
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = null;
            prepareFreshStack(root, lanes);
        }
        lanes = !1;
        memoizedUpdaters = workInProgressRootExitStatus;
        a: do try {
            if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) {
                var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
                switch(workInProgressSuspendedReason){
                    case SuspendedOnHydration:
                        resetWorkInProgressStack();
                        memoizedUpdaters = RootSuspendedAtTheShell;
                        break a;
                    case SuspendedOnImmediate:
                    case SuspendedOnData:
                    case SuspendedOnAction:
                    case SuspendedOnDeprecatedThrowPromise:
                        null === suspenseHandlerStackCursor.current && (lanes = !0);
                        var reason = workInProgressSuspendedReason;
                        workInProgressSuspendedReason = NotSuspended;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                        if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                            memoizedUpdaters = RootInProgress;
                            break a;
                        }
                        break;
                    default:
                        reason = workInProgressSuspendedReason, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                }
            }
            workLoopSync();
            memoizedUpdaters = workInProgressRootExitStatus;
            break;
        } catch (thrownValue$8) {
            handleThrow(root, thrownValue$8);
        }
        while (1);
        lanes && root.shellSuspendCounter++;
        resetContextDependencies();
        executionContext = prevExecutionContext;
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
        return memoizedUpdaters;
    }
    function workLoopSync() {
        for(; null !== workInProgress;)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                0 < memoizedUpdaters.size && (restorePendingUpdaters(root, workInProgressRootRenderLanes), memoizedUpdaters.clear());
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = null;
            workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS;
            prepareFreshStack(root, lanes);
        } else workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        a: do try {
            if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) b: switch(lanes = workInProgress, memoizedUpdaters = workInProgressThrownValue, workInProgressSuspendedReason){
                case SuspendedOnError:
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnError);
                    break;
                case SuspendedOnData:
                case SuspendedOnAction:
                    if (isThenableResolved(memoizedUpdaters)) {
                        workInProgressSuspendedReason = NotSuspended;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        workInProgressSuspendedReason !== SuspendedOnData && workInProgressSuspendedReason !== SuspendedOnAction || workInProgressRoot !== root || (workInProgressSuspendedReason = SuspendedAndReadyToContinue);
                        ensureRootIsScheduled(root);
                    };
                    memoizedUpdaters.then(lanes, lanes);
                    break a;
                case SuspendedOnImmediate:
                    workInProgressSuspendedReason = SuspendedAndReadyToContinue;
                    break a;
                case SuspendedOnInstance:
                    workInProgressSuspendedReason = SuspendedOnInstanceAndReadyToContinue;
                    break a;
                case SuspendedAndReadyToContinue:
                    isThenableResolved(memoizedUpdaters) ? (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedAndReadyToContinue));
                    break;
                case SuspendedOnInstanceAndReadyToContinue:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                                workInProgressSuspendedReason = NotSuspended;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                            break;
                        default:
                            console.error("Unexpected type of fiber triggered a suspensey commit. This is a bug in React.");
                    }
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnInstanceAndReadyToContinue);
                    break;
                case SuspendedOnDeprecatedThrowPromise:
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnDeprecatedThrowPromise);
                    break;
                case SuspendedOnHydration:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = RootSuspendedAtTheShell;
                    break a;
                default:
                    throw Error("Unexpected SuspendedReason. This is a bug in React.");
            }
            null !== ReactSharedInternals.actQueue ? workLoopSync() : workLoopConcurrentByScheduler();
            break;
        } catch (thrownValue$9) {
            handleThrow(root, thrownValue$9);
        }
        while (1);
        resetContextDependencies();
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        executionContext = prevExecutionContext;
        if (null !== workInProgress) return RootInProgress;
        workInProgressRoot = null;
        workInProgressRootRenderLanes = 0;
        finishQueueingConcurrentUpdates();
        return workInProgressRootExitStatus;
    }
    function workLoopConcurrentByScheduler() {
        for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        var current = unitOfWork.alternate;
        (unitOfWork.mode & ProfileMode) !== NoMode ? (startProfilerTimer(unitOfWork), current = runWithFiberInDEV(unitOfWork, beginWork, current, unitOfWork, entangledRenderLanes), stopProfilerTimerIfRunningAndRecordDuration(unitOfWork)) : current = runWithFiberInDEV(unitOfWork, beginWork, current, unitOfWork, entangledRenderLanes);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === current ? completeUnitOfWork(unitOfWork) : workInProgress = current;
    }
    function replaySuspendedUnitOfWork(unitOfWork) {
        var next = runWithFiberInDEV(unitOfWork, replayBeginWork, unitOfWork);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function replayBeginWork(unitOfWork) {
        var current = unitOfWork.alternate, isProfilingMode = (unitOfWork.mode & ProfileMode) !== NoMode;
        isProfilingMode && startProfilerTimer(unitOfWork);
        switch(unitOfWork.tag){
            case 15:
            case 0:
                current = replayFunctionComponent(current, unitOfWork, unitOfWork.pendingProps, unitOfWork.type, void 0, workInProgressRootRenderLanes);
                break;
            case 11:
                current = replayFunctionComponent(current, unitOfWork, unitOfWork.pendingProps, unitOfWork.type.render, unitOfWork.ref, workInProgressRootRenderLanes);
                break;
            case 5:
                resetHooksOnUnwind(unitOfWork);
            default:
                unwindInterruptedWork(current, unitOfWork), unitOfWork = workInProgress = resetWorkInProgress(unitOfWork, entangledRenderLanes), current = beginWork(current, unitOfWork, entangledRenderLanes);
        }
        isProfilingMode && stopProfilerTimerIfRunningAndRecordDuration(unitOfWork);
        return current;
    }
    function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
        resetContextDependencies();
        resetHooksOnUnwind(unitOfWork);
        thenableState$1 = null;
        thenableIndexCounter$1 = 0;
        var returnFiber = unitOfWork.return;
        try {
            if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
                workInProgressRootExitStatus = RootFatalErrored;
                logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
                workInProgress = null;
                return;
            }
        } catch (error) {
            if (null !== returnFiber) throw workInProgress = returnFiber, error;
            workInProgressRootExitStatus = RootFatalErrored;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
        if (unitOfWork.flags & 32768) {
            if (isHydrating || suspendedReason === SuspendedOnError) root = !0;
            else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
            else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, suspendedReason === SuspendedOnData || suspendedReason === SuspendedOnAction || suspendedReason === SuspendedOnImmediate || suspendedReason === SuspendedOnDeprecatedThrowPromise) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
            unwindUnitOfWork(unitOfWork, root);
        } else completeUnitOfWork(unitOfWork);
    }
    function completeUnitOfWork(unitOfWork) {
        var completedWork = unitOfWork;
        do {
            if (0 !== (completedWork.flags & 32768)) {
                unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
                return;
            }
            var current = completedWork.alternate;
            unitOfWork = completedWork.return;
            startProfilerTimer(completedWork);
            current = runWithFiberInDEV(completedWork, completeWork, current, completedWork, entangledRenderLanes);
            (completedWork.mode & ProfileMode) !== NoMode && stopProfilerTimerIfRunningAndRecordIncompleteDuration(completedWork);
            if (null !== current) {
                workInProgress = current;
                return;
            }
            completedWork = completedWork.sibling;
            if (null !== completedWork) {
                workInProgress = completedWork;
                return;
            }
            workInProgress = completedWork = unitOfWork;
        }while (null !== completedWork);
        workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootCompleted);
    }
    function unwindUnitOfWork(unitOfWork, skipSiblings) {
        do {
            var next = unwindWork(unitOfWork.alternate, unitOfWork);
            if (null !== next) {
                next.flags &= 32767;
                workInProgress = next;
                return;
            }
            if ((unitOfWork.mode & ProfileMode) !== NoMode) {
                stopProfilerTimerIfRunningAndRecordIncompleteDuration(unitOfWork);
                next = unitOfWork.actualDuration;
                for(var child = unitOfWork.child; null !== child;)next += child.actualDuration, child = child.sibling;
                unitOfWork.actualDuration = next;
            }
            next = unitOfWork.return;
            null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
            if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
                workInProgress = unitOfWork;
                return;
            }
            workInProgress = unitOfWork = next;
        }while (null !== unitOfWork);
        workInProgressRootExitStatus = RootSuspendedAtTheShell;
        workInProgress = null;
    }
    function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.cancelPendingCommit = null;
        do flushPendingEffects();
        while (pendingEffectsStatus !== NO_PENDING_EFFECTS);
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Should not already be working.");
        setCurrentTrackFromLanes(lanes);
        exitStatus === RootErrored ? logErroredRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, workInProgressUpdateTask) : null !== recoverableErrors ? logRecoveredRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, recoverableErrors, null !== finishedWork && null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 !== (finishedWork.flags & 256), workInProgressUpdateTask) : logRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, workInProgressUpdateTask);
        if (null !== finishedWork) {
            0 === lanes && console.error("finishedLanes should not be empty during a commit. This is a bug in React.");
            if (finishedWork === root.current) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
            didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
            didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
            markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
            root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
            pendingFinishedWork = finishedWork;
            pendingEffectsRoot = root;
            pendingEffectsLanes = lanes;
            pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
            pendingPassiveTransitions = transitions;
            pendingRecoverableErrors = recoverableErrors;
            pendingEffectsRenderEndTime = completedRenderEndTime;
            pendingSuspendedCommitReason = suspendedCommitReason;
            pendingDelayedCommitReason = IMMEDIATE_COMMIT;
            pendingSuspendedViewTransitionReason = null;
            0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
                schedulerEvent = window.event;
                pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
                flushPassiveEffects();
                return null;
            })) : (root.callbackNode = null, root.callbackPriority = 0);
            commitErrors = null;
            commitStartTime = now();
            null !== suspendedCommitReason && logSuspendedCommitPhase(completedRenderEndTime, commitStartTime, suspendedCommitReason, workInProgressUpdateTask);
            recoverableErrors = 0 !== (finishedWork.flags & 13878);
            if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
                recoverableErrors = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                transitions = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                spawnedLane = executionContext;
                executionContext |= CommitContext;
                try {
                    commitBeforeMutationEffects(root, finishedWork, lanes);
                } finally{
                    executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
                }
            }
            pendingEffectsStatus = PENDING_MUTATION_PHASE;
            flushMutationEffects();
            flushLayoutEffects();
            flushSpawnedWork();
        }
    }
    function flushMutationEffects() {
        if (pendingEffectsStatus === PENDING_MUTATION_PHASE) {
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
            if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
                rootMutationHasEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var previousPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                var prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                try {
                    inProgressLanes = lanes;
                    inProgressRoot = root;
                    resetComponentEffectTimers();
                    commitMutationEffectsOnFiber(finishedWork, root);
                    inProgressRoot = inProgressLanes = null;
                    lanes = selectionInformation;
                    var curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                    if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                        if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                            var start = priorSelectionRange.start, end = priorSelectionRange.end;
                            void 0 === end && (end = start);
                            if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                            else {
                                var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                                if (win.getSelection) {
                                    var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                    !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                    var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                    if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                        var range = doc.createRange();
                                        range.setStart(startMarker.node, startMarker.offset);
                                        selection.removeAllRanges();
                                        start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                    }
                                }
                            }
                        }
                        doc = [];
                        for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                            element: selection,
                            left: selection.scrollLeft,
                            top: selection.scrollTop
                        });
                        "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                        for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                            var info = doc[priorFocusedElem];
                            info.element.scrollLeft = info.left;
                            info.element.scrollTop = info.top;
                        }
                    }
                    _enabled = !!eventsEnabled;
                    selectionInformation = eventsEnabled = null;
                } finally{
                    executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
                }
            }
            root.current = finishedWork;
            pendingEffectsStatus = PENDING_LAYOUT_PHASE;
        }
    }
    function flushLayoutEffects() {
        if (pendingEffectsStatus === PENDING_LAYOUT_PHASE) {
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            var suspendedViewTransitionReason = pendingSuspendedViewTransitionReason;
            if (null !== suspendedViewTransitionReason) {
                commitStartTime = now();
                var startTime = commitEndTime, endTime = commitStartTime;
                !supportsUserTiming || endTime <= startTime || (animatingTask ? animatingTask.run(console.timeStamp.bind(console, suspendedViewTransitionReason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(suspendedViewTransitionReason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
            }
            suspendedViewTransitionReason = pendingEffectsRoot;
            startTime = pendingFinishedWork;
            endTime = pendingEffectsLanes;
            var rootHasLayoutEffect = 0 !== (startTime.flags & 8772);
            if (0 !== (startTime.subtreeFlags & 8772) || rootHasLayoutEffect) {
                rootHasLayoutEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var _previousPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                var _prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                try {
                    inProgressLanes = endTime, inProgressRoot = suspendedViewTransitionReason, resetComponentEffectTimers(), commitLayoutEffectOnFiber(suspendedViewTransitionReason, startTime.alternate, startTime), inProgressRoot = inProgressLanes = null;
                } finally{
                    executionContext = _prevExecutionContext, ReactDOMSharedInternals.p = _previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
                }
            }
            suspendedViewTransitionReason = pendingEffectsRenderEndTime;
            startTime = pendingSuspendedCommitReason;
            commitEndTime = now();
            suspendedViewTransitionReason = null === startTime ? suspendedViewTransitionReason : commitStartTime;
            startTime = commitEndTime;
            endTime = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
            rootHasLayoutEffect = workInProgressUpdateTask;
            null !== commitErrors ? logCommitErrored(suspendedViewTransitionReason, startTime, commitErrors, !1, rootHasLayoutEffect) : !supportsUserTiming || startTime <= suspendedViewTransitionReason || (rootHasLayoutEffect ? rootHasLayoutEffect.run(console.timeStamp.bind(console, endTime ? "Commit Interrupted View Transition" : "Commit", suspendedViewTransitionReason, startTime, currentTrack, LANES_TRACK_GROUP, endTime ? "error" : "secondary-dark")) : console.timeStamp(endTime ? "Commit Interrupted View Transition" : "Commit", suspendedViewTransitionReason, startTime, currentTrack, LANES_TRACK_GROUP, endTime ? "error" : "secondary-dark"));
            pendingEffectsStatus = PENDING_AFTER_MUTATION_PHASE;
        }
    }
    function flushSpawnedWork() {
        if (pendingEffectsStatus === PENDING_SPAWNED_WORK || pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE) {
            if (pendingEffectsStatus === PENDING_SPAWNED_WORK) {
                var startViewTransitionStartTime = commitEndTime;
                commitEndTime = now();
                var endTime = commitEndTime, abortedViewTransition = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
                !supportsUserTiming || endTime <= startViewTransitionStartTime || (animatingTask ? animatingTask.run(console.timeStamp.bind(console, abortedViewTransition ? "Interrupted View Transition" : "Starting Animation", startViewTransitionStartTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? "error" : "secondary-light")) : console.timeStamp(abortedViewTransition ? "Interrupted View Transition" : "Starting Animation", startViewTransitionStartTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? " error" : "secondary-light"));
                pendingDelayedCommitReason !== ABORTED_VIEW_TRANSITION_COMMIT && (pendingDelayedCommitReason = ANIMATION_STARTED_COMMIT);
            }
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            requestPaint();
            startViewTransitionStartTime = pendingEffectsRoot;
            var finishedWork = pendingFinishedWork;
            endTime = pendingEffectsLanes;
            abortedViewTransition = pendingRecoverableErrors;
            var rootDidHavePassiveEffects = 0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256);
            rootDidHavePassiveEffects ? pendingEffectsStatus = PENDING_PASSIVE_PHASE : (pendingEffectsStatus = NO_PENDING_EFFECTS, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(startViewTransitionStartTime, startViewTransitionStartTime.pendingLanes), nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null);
            var remainingLanes = startViewTransitionStartTime.pendingLanes;
            0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
            rootDidHavePassiveEffects || commitDoubleInvokeEffectsInDEV(startViewTransitionStartTime);
            remainingLanes = lanesToEventPriority(endTime);
            finishedWork = finishedWork.stateNode;
            if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
                var didError = 128 === (finishedWork.current.flags & 128);
                switch(remainingLanes){
                    case DiscreteEventPriority:
                        var schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority$1;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority$1;
                }
                injectedHook.onCommitFiberRoot(rendererID, finishedWork, schedulerPriority, didError);
            } catch (err) {
                hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
            }
            isDevToolsPresent && startViewTransitionStartTime.memoizedUpdaters.clear();
            onCommitRoot();
            if (null !== abortedViewTransition) {
                didError = ReactSharedInternals.T;
                schedulerPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                ReactSharedInternals.T = null;
                try {
                    var onRecoverableError = startViewTransitionStartTime.onRecoverableError;
                    for(finishedWork = 0; finishedWork < abortedViewTransition.length; finishedWork++){
                        var recoverableError = abortedViewTransition[finishedWork], errorInfo = makeErrorInfo(recoverableError.stack);
                        runWithFiberInDEV(recoverableError.source, onRecoverableError, recoverableError.value, errorInfo);
                    }
                } finally{
                    ReactSharedInternals.T = didError, ReactDOMSharedInternals.p = schedulerPriority;
                }
            }
            0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
            ensureRootIsScheduled(startViewTransitionStartTime);
            remainingLanes = startViewTransitionStartTime.pendingLanes;
            0 !== (endTime & 261930) && 0 !== (remainingLanes & 42) ? (nestedUpdateScheduled = !0, startViewTransitionStartTime === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = startViewTransitionStartTime)) : nestedUpdateCount = 0;
            rootDidHavePassiveEffects || finalizeRender(endTime, commitEndTime);
            flushSyncWorkAcrossRoots_impl(0, !1);
        }
    }
    function makeErrorInfo(componentStack) {
        componentStack = {
            componentStack: componentStack
        };
        Object.defineProperty(componentStack, "digest", {
            get: function() {
                console.error('You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.');
            }
        });
        return componentStack;
    }
    function releaseRootPooledCache(root, remainingLanes) {
        0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
    }
    function flushPendingEffects() {
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
        return flushPassiveEffects();
    }
    function flushPassiveEffects() {
        if (pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return !1;
        var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
        pendingEffectsRemainingLanes = 0;
        var renderPriority = lanesToEventPriority(pendingEffectsLanes), priority = 0 === DefaultEventPriority || DefaultEventPriority > renderPriority ? DefaultEventPriority : renderPriority;
        renderPriority = ReactSharedInternals.T;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = priority;
            ReactSharedInternals.T = null;
            var transitions = pendingPassiveTransitions;
            pendingPassiveTransitions = null;
            priority = pendingEffectsRoot;
            var lanes = pendingEffectsLanes;
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            pendingFinishedWork = pendingEffectsRoot = null;
            pendingEffectsLanes = 0;
            if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Cannot flush passive effects while already rendering.");
            setCurrentTrackFromLanes(lanes);
            isFlushingPassiveEffects = !0;
            didScheduleUpdateDuringPassiveEffects = !1;
            var passiveEffectStartTime = 0;
            commitErrors = null;
            passiveEffectStartTime = now$1();
            if (pendingDelayedCommitReason === ANIMATION_STARTED_COMMIT) logAnimatingPhase(commitEndTime, passiveEffectStartTime, animatingTask);
            else {
                var startTime = commitEndTime, endTime = passiveEffectStartTime, delayedUntilPaint = pendingDelayedCommitReason === DELAYED_PASSIVE_COMMIT;
                !supportsUserTiming || endTime <= startTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(console.timeStamp.bind(console, delayedUntilPaint ? "Waiting for Paint" : "Waiting", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(delayedUntilPaint ? "Waiting for Paint" : "Waiting", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
            }
            startTime = executionContext;
            executionContext |= CommitContext;
            var finishedWork = priority.current;
            resetComponentEffectTimers();
            commitPassiveUnmountOnFiber(finishedWork);
            var finishedWork$jscomp$0 = priority.current;
            finishedWork = pendingEffectsRenderEndTime;
            resetComponentEffectTimers();
            commitPassiveMountOnFiber(priority, finishedWork$jscomp$0, lanes, transitions, finishedWork);
            commitDoubleInvokeEffectsInDEV(priority);
            executionContext = startTime;
            var passiveEffectsEndTime = now$1();
            finishedWork$jscomp$0 = passiveEffectStartTime;
            finishedWork = workInProgressUpdateTask;
            null !== commitErrors ? logCommitErrored(finishedWork$jscomp$0, passiveEffectsEndTime, commitErrors, !0, finishedWork) : !supportsUserTiming || passiveEffectsEndTime <= finishedWork$jscomp$0 || (finishedWork ? finishedWork.run(console.timeStamp.bind(console, "Remaining Effects", finishedWork$jscomp$0, passiveEffectsEndTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark")) : console.timeStamp("Remaining Effects", finishedWork$jscomp$0, passiveEffectsEndTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark"));
            finalizeRender(lanes, passiveEffectsEndTime);
            flushSyncWorkAcrossRoots_impl(0, !1);
            didScheduleUpdateDuringPassiveEffects ? priority === rootWithPassiveNestedUpdates ? nestedPassiveUpdateCount++ : (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = priority) : nestedPassiveUpdateCount = 0;
            didScheduleUpdateDuringPassiveEffects = isFlushingPassiveEffects = !1;
            if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
                injectedHook.onPostCommitFiberRoot(rendererID, priority);
            } catch (err) {
                hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
            }
            var stateNode = priority.current.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
            return !0;
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = renderPriority, releaseRootPooledCache(root, remainingLanes);
        }
    }
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
        recordEffectError(sourceFiber);
        sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
        rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
        null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
        isRunningInsertionEffect = !1;
        if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
        else {
            for(; null !== nearestMountedAncestor;){
                if (3 === nearestMountedAncestor.tag) {
                    captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
                    return;
                }
                if (1 === nearestMountedAncestor.tag) {
                    var instance = nearestMountedAncestor.stateNode;
                    if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                        recordEffectError(sourceFiber);
                        error = createClassErrorUpdate(2);
                        instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                        null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                        return;
                    }
                }
                nearestMountedAncestor = nearestMountedAncestor.return;
            }
            console.error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error);
        }
    }
    function attachPingListener(root, wakeable, lanes) {
        var pingCache = root.pingCache;
        if (null === pingCache) {
            pingCache = root.pingCache = new PossiblyWeakMap();
            var threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
        threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), pingCache = pingSuspendedRoot.bind(null, root, wakeable, lanes), isDevToolsPresent && restorePendingUpdaters(root, lanes), wakeable.then(pingCache, pingCache));
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        null !== pingCache && pingCache.delete(wakeable);
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
        root.warmLanes &= ~pingedLanes;
        0 !== (pingedLanes & 127) ? 0 > blockingUpdateTime && (blockingClampTime = blockingUpdateTime = now(), blockingUpdateTask = createTask("Promise Resolved"), blockingUpdateType = PINGED_UPDATE) : 0 !== (pingedLanes & 4194048) && 0 > transitionUpdateTime && (transitionClampTime = transitionUpdateTime = now(), transitionUpdateTask = createTask("Promise Resolved"), transitionUpdateType = PINGED_UPDATE);
        isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && console.error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act");
        workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && now$1() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS ? (executionContext & RenderContext) === NoContext && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
        ensureRootIsScheduled(root);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        0 === retryLane && (retryLane = claimNextRetryLane());
        boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = 0;
        switch(boundaryFiber.tag){
            case 31:
            case 13:
                var retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                null !== suspenseState && (retryLane = suspenseState.retryLane);
                break;
            case 19:
                retryCache = boundaryFiber.stateNode;
                break;
            case 22:
                retryCache = boundaryFiber.stateNode._retryCache;
                break;
            default:
                throw Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        null !== retryCache && retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function recursivelyTraverseAndDoubleInvokeEffectsInDEV(root$jscomp$0, parentFiber, isInStrictMode) {
        if (0 !== (parentFiber.subtreeFlags & 67117056)) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var root = root$jscomp$0, fiber = parentFiber, isStrictModeFiber = fiber.type === REACT_STRICT_MODE_TYPE;
            isStrictModeFiber = isInStrictMode || isStrictModeFiber;
            22 !== fiber.tag ? fiber.flags & 67108864 ? isStrictModeFiber && runWithFiberInDEV(fiber, doubleInvokeEffectsOnFiber, root, fiber) : recursivelyTraverseAndDoubleInvokeEffectsInDEV(root, fiber, isStrictModeFiber) : null === fiber.memoizedState && (isStrictModeFiber && fiber.flags & 8192 ? runWithFiberInDEV(fiber, doubleInvokeEffectsOnFiber, root, fiber) : fiber.subtreeFlags & 67108864 && runWithFiberInDEV(fiber, recursivelyTraverseAndDoubleInvokeEffectsInDEV, root, fiber, isStrictModeFiber));
            parentFiber = parentFiber.sibling;
        }
    }
    function doubleInvokeEffectsOnFiber(root, fiber) {
        setIsStrictModeForDevtools(!0);
        try {
            disappearLayoutEffects(fiber), disconnectPassiveEffect(fiber), reappearLayoutEffects(root, fiber.alternate, fiber, !1), reconnectPassiveEffects(root, fiber, 0, null, !1, 0);
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    function commitDoubleInvokeEffectsInDEV(root) {
        var doubleInvokeEffects = !0;
        root.current.mode & (StrictLegacyMode | StrictEffectsMode) || (doubleInvokeEffects = !1);
        recursivelyTraverseAndDoubleInvokeEffectsInDEV(root, root.current, doubleInvokeEffects);
    }
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) === NoContext) {
            var tag = fiber.tag;
            if (3 === tag || 1 === tag || 0 === tag || 11 === tag || 14 === tag || 15 === tag) {
                tag = getComponentNameFromFiber(fiber) || "ReactComponent";
                if (null !== didWarnStateUpdateForNotYetMountedComponent) {
                    if (didWarnStateUpdateForNotYetMountedComponent.has(tag)) return;
                    didWarnStateUpdateForNotYetMountedComponent.add(tag);
                } else didWarnStateUpdateForNotYetMountedComponent = new Set([
                    tag
                ]);
                runWithFiberInDEV(fiber, function() {
                    console.error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead.");
                });
            }
        }
    }
    function restorePendingUpdaters(root, lanes) {
        isDevToolsPresent && root.memoizedUpdaters.forEach(function(schedulingFiber) {
            addFiberToLanesMap(root, schedulingFiber, lanes);
        });
    }
    function scheduleCallback$1(priorityLevel, callback) {
        var actQueue = ReactSharedInternals.actQueue;
        return null !== actQueue ? (actQueue.push(callback), fakeActCallbackNode$1) : scheduleCallback$3(priorityLevel, callback);
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && runWithFiberInDEV(fiber, function() {
            console.error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
        });
    }
    function ensureRootIsScheduled(root) {
        root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
        mightHavePendingSyncWork = !0;
        null !== ReactSharedInternals.actQueue ? didScheduleMicrotask_act || (didScheduleMicrotask_act = !0, scheduleImmediateRootScheduleTask()) : didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
    }
    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
        if (!isFlushingWork && mightHavePendingSyncWork) {
            isFlushingWork = !0;
            do {
                var didPerformSomeWork = !1;
                for(var root = firstScheduledRoot; null !== root;){
                    if (!onlyLegacy) {
                        if (0 !== syncTransitionLanes) {
                            var pendingLanes = root.pendingLanes;
                            if (0 === pendingLanes) var nextLanes = 0;
                            else {
                                var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
                                nextLanes = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                                nextLanes &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                                nextLanes = nextLanes & 201326741 ? nextLanes & 201326741 | 1 : nextLanes ? nextLanes | 2 : 0;
                            }
                            0 !== nextLanes && (didPerformSomeWork = !0, performSyncWorkOnRoot(root, nextLanes));
                        } else nextLanes = workInProgressRootRenderLanes, nextLanes = getNextLanes(root, root === workInProgressRoot ? nextLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout), 0 === (nextLanes & 3) || checkIfRootIsPrerendering(root, nextLanes) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root, nextLanes));
                    }
                    root = root.next;
                }
            }while (didPerformSomeWork);
            isFlushingWork = !1;
        }
    }
    function processRootScheduleInImmediateTask() {
        schedulerEvent = window.event;
        processRootScheduleInMicrotask();
    }
    function processRootScheduleInMicrotask() {
        mightHavePendingSyncWork = didScheduleMicrotask_act = didScheduleMicrotask = !1;
        var syncTransitionLanes = 0;
        0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
        for(var currentTime = now$1(), prev = null, root = firstScheduledRoot; null !== root;){
            var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
            if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
            else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
            root = next;
        }
        pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
        0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
    }
    function scheduleTaskForRootDuringMicrotask(root, currentTime) {
        for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index, expirationTime = expirationTimes[index];
            if (-1 === expirationTime) {
                if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else expirationTime <= currentTime && (root.expiredLanes |= lane);
            lanes &= ~lane;
        }
        currentTime = workInProgressRoot;
        suspendedLanes = workInProgressRootRenderLanes;
        suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        pingedLanes = root.callbackNode;
        if (0 === suspendedLanes || root === currentTime && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root.cancelPendingCommit) return null !== pingedLanes && cancelCallback(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
        if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
            currentTime = suspendedLanes & -suspendedLanes;
            if (currentTime !== root.callbackPriority || null !== ReactSharedInternals.actQueue && pingedLanes !== fakeActCallbackNode) cancelCallback(pingedLanes);
            else return currentTime;
            switch(lanesToEventPriority(suspendedLanes)){
                case DiscreteEventPriority:
                case ContinuousEventPriority:
                    suspendedLanes = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    suspendedLanes = NormalPriority$1;
                    break;
                case IdleEventPriority:
                    suspendedLanes = IdlePriority;
                    break;
                default:
                    suspendedLanes = NormalPriority$1;
            }
            pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
            null !== ReactSharedInternals.actQueue ? (ReactSharedInternals.actQueue.push(pingedLanes), suspendedLanes = fakeActCallbackNode) : suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
            root.callbackPriority = currentTime;
            root.callbackNode = suspendedLanes;
            return currentTime;
        }
        null !== pingedLanes && cancelCallback(pingedLanes);
        root.callbackPriority = 2;
        root.callbackNode = null;
        return 2;
    }
    function performWorkOnRootViaSchedulerTask(root, didTimeout) {
        nestedUpdateScheduled = currentUpdateIsNested = !1;
        schedulerEvent = window.event;
        if (pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return root.callbackNode = null, root.callbackPriority = 0, null;
        var originalCallbackNode = root.callbackNode;
        pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
        if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
        var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
        workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
        performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
        scheduleTaskForRootDuringMicrotask(root, now$1());
        return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
    }
    function performSyncWorkOnRoot(root, lanes) {
        if (flushPendingEffects()) return null;
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = !1;
        performWorkOnRoot(root, lanes, !0);
    }
    function cancelCallback(callbackNode) {
        callbackNode !== fakeActCallbackNode && null !== callbackNode && cancelCallback$1(callbackNode);
    }
    function scheduleImmediateRootScheduleTask() {
        null !== ReactSharedInternals.actQueue && ReactSharedInternals.actQueue.push(function() {
            processRootScheduleInMicrotask();
            return null;
        });
        scheduleMicrotask(function() {
            (executionContext & (RenderContext | CommitContext)) !== NoContext ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
        });
    }
    function requestTransitionLane() {
        if (0 === currentEventTransitionLane) {
            var actionScopeLane = currentEntangledLane;
            0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
            currentEventTransitionLane = actionScopeLane;
        }
        return currentEventTransitionLane;
    }
    function coerceFormActionProp(actionProp) {
        if (null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp) return null;
        if ("function" === typeof actionProp) return actionProp;
        checkAttributeStringCoercion(actionProp, "action");
        return sanitizeURL("" + actionProp);
    }
    function createFormDataWithSubmitter(form, submitter) {
        var temp = submitter.ownerDocument.createElement("input");
        temp.name = submitter.name;
        temp.value = submitter.value;
        form.id && temp.setAttribute("form", form.id);
        submitter.parentNode.insertBefore(temp, submitter);
        form = new FormData(form);
        temp.parentNode.removeChild(temp);
        return form;
    }
    function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
        if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
            var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
            submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
            var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: [
                    {
                        instance: null,
                        listener: function() {
                            if (nativeEvent.defaultPrevented) {
                                if (0 !== currentEventTransitionLane) {
                                    var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), pendingState = {
                                        pending: !0,
                                        data: formData,
                                        method: nativeEventTarget.method,
                                        action: action
                                    };
                                    Object.freeze(pendingState);
                                    startHostTransition(maybeTargetInst, pendingState, null, formData);
                                }
                            } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), pendingState = {
                                pending: !0,
                                data: formData,
                                method: nativeEventTarget.method,
                                action: action
                            }, Object.freeze(pendingState), startHostTransition(maybeTargetInst, pendingState, action, formData));
                        },
                        currentTarget: nativeEventTarget
                    }
                ]
            });
        }
    }
    function executeDispatch(event, listener, currentTarget) {
        event.currentTarget = currentTarget;
        try {
            listener(event);
        } catch (error) {
            reportGlobalError(error);
        }
        event.currentTarget = null;
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        eventSystemFlags = 0 !== (eventSystemFlags & 4);
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i];
            a: {
                var previousInstance = void 0, event = _dispatchQueue$i.event;
                _dispatchQueue$i = _dispatchQueue$i.listeners;
                if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                    var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                    _dispatchListeners$i = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) break a;
                    null !== instance ? runWithFiberInDEV(instance, executeDispatch, event, _dispatchListeners$i, currentTarget) : executeDispatch(event, _dispatchListeners$i, currentTarget);
                    previousInstance = instance;
                }
                else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                    _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                    instance = _dispatchListeners$i.instance;
                    currentTarget = _dispatchListeners$i.currentTarget;
                    _dispatchListeners$i = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) break a;
                    null !== instance ? runWithFiberInDEV(instance, executeDispatch, event, _dispatchListeners$i, currentTarget) : executeDispatch(event, _dispatchListeners$i, currentTarget);
                    previousInstance = instance;
                }
            }
        }
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        nonDelegatedEvents.has(domEventName) || console.error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var listenerSet = targetElement[internalEventHandlersKey];
        void 0 === listenerSet && (listenerSet = targetElement[internalEventHandlersKey] = new Set());
        var listenerSetKey = domEventName + "__bubble";
        listenerSet.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), listenerSet.add(listenerSetKey));
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener && console.error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        isCapturePhaseListener && (eventSystemFlags |= 4);
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    }
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = !0;
            allNativeEvents.forEach(function(domEventName) {
                "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
            });
            var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
            null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
        switch(getEventPriority(domEventName)){
            case DiscreteEventPriority:
                var listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            default:
                listenerWrapper = dispatchEvent;
        }
        eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
        listenerWrapper = void 0;
        !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
        isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
            capture: !0,
            passive: listenerWrapper
        }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
            passive: listenerWrapper
        }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
        var ancestorInst = targetInst$jscomp$0;
        if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
            if (null === targetInst$jscomp$0) return;
            var nodeTag = targetInst$jscomp$0.tag;
            if (3 === nodeTag || 4 === nodeTag) {
                var container = targetInst$jscomp$0.stateNode.containerInfo;
                if (container === targetContainer) break;
                if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                    var grandTag = nodeTag.tag;
                    if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                    nodeTag = nodeTag.return;
                }
                for(; null !== container;){
                    nodeTag = getClosestInstanceFromNode(container);
                    if (null === nodeTag) return;
                    grandTag = nodeTag.tag;
                    if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                        targetInst$jscomp$0 = ancestorInst = nodeTag;
                        continue a;
                    }
                    container = container.parentNode;
                }
            }
            targetInst$jscomp$0 = targetInst$jscomp$0.return;
        }
        batchedUpdates$1(function() {
            var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
            a: {
                var reactName = topLevelEventsToReactNames.get(domEventName);
                if (void 0 !== reactName) {
                    var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                    switch(domEventName){
                        case "keypress":
                            if (0 === getEventCharCode(nativeEvent)) break a;
                        case "keydown":
                        case "keyup":
                            SyntheticEventCtor = SyntheticKeyboardEvent;
                            break;
                        case "focusin":
                            reactEventType = "focus";
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "focusout":
                            reactEventType = "blur";
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "beforeblur":
                        case "afterblur":
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "click":
                            if (2 === nativeEvent.button) break a;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            SyntheticEventCtor = SyntheticMouseEvent;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            SyntheticEventCtor = SyntheticDragEvent;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            SyntheticEventCtor = SyntheticTouchEvent;
                            break;
                        case ANIMATION_END:
                        case ANIMATION_ITERATION:
                        case ANIMATION_START:
                            SyntheticEventCtor = SyntheticAnimationEvent;
                            break;
                        case TRANSITION_END:
                            SyntheticEventCtor = SyntheticTransitionEvent;
                            break;
                        case "scroll":
                        case "scrollend":
                            SyntheticEventCtor = SyntheticUIEvent;
                            break;
                        case "wheel":
                            SyntheticEventCtor = SyntheticWheelEvent;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            SyntheticEventCtor = SyntheticClipboardEvent;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            SyntheticEventCtor = SyntheticPointerEvent;
                            break;
                        case "toggle":
                        case "beforetoggle":
                            SyntheticEventCtor = SyntheticToggleEvent;
                    }
                    var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                    inCapturePhase = [];
                    for(var instance = targetInst, lastHostComponent; null !== instance;){
                        var _instance2 = instance;
                        lastHostComponent = _instance2.stateNode;
                        _instance2 = _instance2.tag;
                        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === lastHostComponent || null === reactEventName || (_instance2 = getListener(instance, reactEventName), null != _instance2 && inCapturePhase.push(createDispatchListener(instance, _instance2, lastHostComponent)));
                        if (accumulateTargetOnly) break;
                        instance = instance.return;
                    }
                    0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                        event: reactName,
                        listeners: inCapturePhase
                    }));
                }
            }
            if (0 === (eventSystemFlags & 7)) {
                a: {
                    reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                    SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                    if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                    if (SyntheticEventCtor || reactName) {
                        reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                        if (SyntheticEventCtor) {
                            if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                        } else SyntheticEventCtor = null, reactEventType = targetInst;
                        if (SyntheticEventCtor !== reactEventType) {
                            inCapturePhase = SyntheticMouseEvent;
                            _instance2 = "onMouseLeave";
                            reactEventName = "onMouseEnter";
                            instance = "mouse";
                            if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance2 = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                            accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                            lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                            reactName = new inCapturePhase(_instance2, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                            reactName.target = accumulateTargetOnly;
                            reactName.relatedTarget = lastHostComponent;
                            _instance2 = null;
                            getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance2 = inCapturePhase);
                            accumulateTargetOnly = _instance2;
                            if (SyntheticEventCtor && reactEventType) b: {
                                inCapturePhase = getParent;
                                reactEventName = SyntheticEventCtor;
                                instance = reactEventType;
                                lastHostComponent = 0;
                                for(_instance2 = reactEventName; _instance2; _instance2 = inCapturePhase(_instance2))lastHostComponent++;
                                _instance2 = 0;
                                for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance2++;
                                for(; 0 < lastHostComponent - _instance2;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                                for(; 0 < _instance2 - lastHostComponent;)instance = inCapturePhase(instance), _instance2--;
                                for(; lastHostComponent--;){
                                    if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                        inCapturePhase = reactEventName;
                                        break b;
                                    }
                                    reactEventName = inCapturePhase(reactEventName);
                                    instance = inCapturePhase(instance);
                                }
                                inCapturePhase = null;
                            }
                            else inCapturePhase = null;
                            null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                            null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                        }
                    }
                }
                a: {
                    reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                    SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                    if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                    else if (isTextInputElement(reactName)) {
                        if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                        else {
                            getTargetInstFunc = getTargetInstForInputEventPolyfill;
                            var handleEventFunc = handleEventsForInputEventPolyfill;
                        }
                    } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                    if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                        createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                        break a;
                    }
                    handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                    "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
                }
                handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
                switch(domEventName){
                    case "focusin":
                        if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                        break;
                    case "focusout":
                        lastSelection = activeElementInst = activeElement = null;
                        break;
                    case "mousedown":
                        mouseDown = !0;
                        break;
                    case "contextmenu":
                    case "mouseup":
                    case "dragend":
                        mouseDown = !1;
                        constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                        break;
                    case "selectionchange":
                        if (skipSelectionChangeEvent) break;
                    case "keydown":
                    case "keyup":
                        constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                }
                var fallbackData;
                if (canUseCompositionEvent) b: {
                    switch(domEventName){
                        case "compositionstart":
                            var eventType = "onCompositionStart";
                            break b;
                        case "compositionend":
                            eventType = "onCompositionEnd";
                            break b;
                        case "compositionupdate":
                            eventType = "onCompositionUpdate";
                            break b;
                    }
                    eventType = void 0;
                }
                else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && nativeEvent.keyCode === START_KEYCODE && (eventType = "onCompositionStart");
                eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: eventType,
                    listeners: handleEventFunc
                }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
                if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: handleEventFunc,
                    listeners: eventType
                }), handleEventFunc.data = fallbackData);
                extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            }
            processDispatchQueue(dispatchQueue, eventSystemFlags);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
            var _instance3 = targetFiber, stateNode = _instance3.stateNode;
            _instance3 = _instance3.tag;
            5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (_instance3 = getListener(targetFiber, captureName), null != _instance3 && listeners.unshift(createDispatchListener(targetFiber, _instance3, stateNode)), _instance3 = getListener(targetFiber, reactName), null != _instance3 && listeners.push(createDispatchListener(targetFiber, _instance3, stateNode)));
            if (3 === targetFiber.tag) return listeners;
            targetFiber = targetFiber.return;
        }
        return [];
    }
    function getParent(inst) {
        if (null === inst) return null;
        do inst = inst.return;
        while (inst && 5 !== inst.tag && 27 !== inst.tag);
        return inst ? inst : null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
            var _instance4 = target, alternate = _instance4.alternate, stateNode = _instance4.stateNode;
            _instance4 = _instance4.tag;
            if (null !== alternate && alternate === common) break;
            5 !== _instance4 && 26 !== _instance4 && 27 !== _instance4 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
            target = target.return;
        }
        0 !== listeners.length && dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    }
    function validatePropertiesInDevelopment(type, props) {
        validateProperties$2(type, props);
        "input" !== type && "textarea" !== type && "select" !== type || null == props || null !== props.value || didWarnValueNull || (didWarnValueNull = !0, "select" === type && props.multiple ? console.error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type) : console.error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type));
        var eventRegistry = {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        };
        isCustomElement(type) || "string" === typeof props.is || warnUnknownProperties(type, props, eventRegistry);
        props.contentEditable && !props.suppressContentEditableWarning && null != props.children && console.error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
    }
    function warnForPropDifference(propName, serverValue, clientValue, serverDifferences) {
        serverValue !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(serverValue) !== clientValue && (serverDifferences[propName] = serverValue));
    }
    function warnForExtraAttributes(domElement, attributeNames, serverDifferences) {
        attributeNames.forEach(function(attributeName) {
            serverDifferences[getPropNameFromAttributeName(attributeName)] = "style" === attributeName ? getStylesObjectFromElement(domElement) : domElement.getAttribute(attributeName);
        });
    }
    function warnForInvalidEventListener(registrationName, listener) {
        !1 === listener ? console.error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName) : console.error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }
    function normalizeHTML(parent, html) {
        parent = parent.namespaceURI === MATH_NAMESPACE || parent.namespaceURI === SVG_NAMESPACE ? parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName) : parent.ownerDocument.createElement(parent.tagName);
        parent.innerHTML = html;
        return parent.innerHTML;
    }
    function normalizeMarkupForTextOrAttribute(markup) {
        willCoercionThrow(markup) && (console.error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.", typeName(markup)), testStringCoercion(markup));
        return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText) {
        clientText = normalizeMarkupForTextOrAttribute(clientText);
        return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
    }
    function setProp(domElement, tag, key, value, props, prevValue) {
        switch(key){
            case "children":
                if ("string" === typeof value) validateTextNesting(value, tag, !1), "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value);
                else if ("number" === typeof value || "bigint" === typeof value) validateTextNesting("" + value, tag, !1), "body" !== tag && setTextContent(domElement, "" + value);
                break;
            case "className":
                setValueForKnownAttribute(domElement, "class", value);
                break;
            case "tabIndex":
                setValueForKnownAttribute(domElement, "tabindex", value);
                break;
            case "dir":
            case "role":
            case "viewBox":
            case "width":
            case "height":
                setValueForKnownAttribute(domElement, key, value);
                break;
            case "style":
                setValueForStyles(domElement, value, prevValue);
                break;
            case "data":
                if ("object" !== tag) {
                    setValueForKnownAttribute(domElement, "data", value);
                    break;
                }
            case "src":
            case "href":
                if ("" === value && ("a" !== tag || "href" !== key)) {
                    "src" === key ? console.error('An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', key, key) : console.error('An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', key, key);
                    domElement.removeAttribute(key);
                    break;
                }
                if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                    domElement.removeAttribute(key);
                    break;
                }
                checkAttributeStringCoercion(value, key);
                value = sanitizeURL("" + value);
                domElement.setAttribute(key, value);
                break;
            case "action":
            case "formAction":
                null != value && ("form" === tag ? "formAction" === key ? console.error("You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>.") : "function" === typeof value && (null == props.encType && null == props.method || didWarnFormActionMethod || (didWarnFormActionMethod = !0, console.error("Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden.")), null == props.target || didWarnFormActionTarget || (didWarnFormActionTarget = !0, console.error("Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."))) : "input" === tag || "button" === tag ? "action" === key ? console.error("You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>.") : "input" !== tag || "submit" === props.type || "image" === props.type || didWarnFormActionType ? "button" !== tag || null == props.type || "submit" === props.type || didWarnFormActionType ? "function" === typeof value && (null == props.name || didWarnFormActionName || (didWarnFormActionName = !0, console.error('Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.')), null == props.formEncType && null == props.formMethod || didWarnFormActionMethod || (didWarnFormActionMethod = !0, console.error("Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden.")), null == props.formTarget || didWarnFormActionTarget || (didWarnFormActionTarget = !0, console.error("Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."))) : (didWarnFormActionType = !0, console.error('A button can only specify a formAction along with type="submit" or no type.')) : (didWarnFormActionType = !0, console.error('An input can only specify a formAction along with type="submit" or type="image".')) : "action" === key ? console.error("You can only pass the action prop to <form>.") : console.error("You can only pass the formAction prop to <input> or <button>."));
                if ("function" === typeof value) {
                    domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                    break;
                } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
                if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                    domElement.removeAttribute(key);
                    break;
                }
                checkAttributeStringCoercion(value, key);
                value = sanitizeURL("" + value);
                domElement.setAttribute(key, value);
                break;
            case "onClick":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$1);
                break;
            case "onScroll":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
                break;
            case "onScrollEnd":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
                break;
            case "dangerouslySetInnerHTML":
                if (null != value) {
                    if ("object" !== typeof value || !("__html" in value)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
                    key = value.__html;
                    if (null != key) {
                        if (null != props.children) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
                        domElement.innerHTML = key;
                    }
                }
                break;
            case "multiple":
                domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
                break;
            case "muted":
                domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                break;
            case "autoFocus":
                break;
            case "xlinkHref":
                if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                    domElement.removeAttribute("xlink:href");
                    break;
                }
                checkAttributeStringCoercion(value, key);
                key = sanitizeURL("" + value);
                domElement.setAttributeNS(xlinkNamespace, "xlink:href", key);
                break;
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
                null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, "" + value)) : domElement.removeAttribute(key);
                break;
            case "inert":
                "" !== value || didWarnForNewBooleanPropsWithEmptyValue[key] || (didWarnForNewBooleanPropsWithEmptyValue[key] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", key));
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
                value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
                break;
            case "capture":
            case "download":
                !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "cols":
            case "rows":
            case "size":
            case "span":
                null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "rowSpan":
            case "start":
                null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value));
                break;
            case "popover":
                listenToNonDelegatedEvent("beforetoggle", domElement);
                listenToNonDelegatedEvent("toggle", domElement);
                setValueForAttribute(domElement, "popover", value);
                break;
            case "xlinkActuate":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:actuate", value);
                break;
            case "xlinkArcrole":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:arcrole", value);
                break;
            case "xlinkRole":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:role", value);
                break;
            case "xlinkShow":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:show", value);
                break;
            case "xlinkTitle":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:title", value);
                break;
            case "xlinkType":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:type", value);
                break;
            case "xmlBase":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:base", value);
                break;
            case "xmlLang":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:lang", value);
                break;
            case "xmlSpace":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:space", value);
                break;
            case "is":
                null != prevValue && console.error('Cannot update the "is" prop after it has been initialized.');
                setValueForAttribute(domElement, "is", value);
                break;
            case "innerText":
            case "textContent":
                break;
            case "popoverTarget":
                didWarnPopoverTargetObject || null == value || "object" !== typeof value || (didWarnPopoverTargetObject = !0, console.error("The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.", value));
            default:
                !(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1] ? (key = getAttributeAlias(key), setValueForAttribute(domElement, key, value)) : registrationNameDependencies.hasOwnProperty(key) && null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
        }
    }
    function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
        switch(key){
            case "style":
                setValueForStyles(domElement, value, prevValue);
                break;
            case "dangerouslySetInnerHTML":
                if (null != value) {
                    if ("object" !== typeof value || !("__html" in value)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
                    key = value.__html;
                    if (null != key) {
                        if (null != props.children) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
                        domElement.innerHTML = key;
                    }
                }
                break;
            case "children":
                "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
                break;
            case "onScroll":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
                break;
            case "onScrollEnd":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
                break;
            case "onClick":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$1);
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "innerHTML":
            case "ref":
                break;
            case "innerText":
            case "textContent":
                break;
            default:
                if (registrationNameDependencies.hasOwnProperty(key)) null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
                else a: {
                    if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                        "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                        domElement.addEventListener(tag, value, props);
                        break a;
                    }
                    key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
                }
        }
    }
    function setInitialProperties(domElement, tag, props) {
        validatePropertiesInDevelopment(tag, props);
        switch(tag){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "img":
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                var hasSrc = !1, hasSrcSet = !1, propKey;
                for(propKey in props)if (props.hasOwnProperty(propKey)) {
                    var propValue = props[propKey];
                    if (null != propValue) switch(propKey){
                        case "src":
                            hasSrc = !0;
                            break;
                        case "srcSet":
                            hasSrcSet = !0;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                        default:
                            setProp(domElement, tag, propKey, propValue, props, null);
                    }
                }
                hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
                hasSrc && setProp(domElement, tag, "src", props.src, props, null);
                return;
            case "input":
                checkControlledValueProps("input", props);
                listenToNonDelegatedEvent("invalid", domElement);
                var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
                for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                    var _propValue = props[hasSrc];
                    if (null != _propValue) switch(hasSrc){
                        case "name":
                            hasSrcSet = _propValue;
                            break;
                        case "type":
                            propValue = _propValue;
                            break;
                        case "checked":
                            checked = _propValue;
                            break;
                        case "defaultChecked":
                            defaultChecked = _propValue;
                            break;
                        case "value":
                            propKey = _propValue;
                            break;
                        case "defaultValue":
                            defaultValue = _propValue;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != _propValue) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                            break;
                        default:
                            setProp(domElement, tag, hasSrc, _propValue, props, null);
                    }
                }
                validateInputProps(domElement, props);
                initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
                return;
            case "select":
                checkControlledValueProps("select", props);
                listenToNonDelegatedEvent("invalid", domElement);
                hasSrc = propValue = propKey = null;
                for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                    case "value":
                        propKey = defaultValue;
                        break;
                    case "defaultValue":
                        propValue = defaultValue;
                        break;
                    case "multiple":
                        hasSrc = defaultValue;
                    default:
                        setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
                }
                validateSelectProps(domElement, props);
                tag = propKey;
                props = propValue;
                domElement.multiple = !!hasSrc;
                null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
                return;
            case "textarea":
                checkControlledValueProps("textarea", props);
                listenToNonDelegatedEvent("invalid", domElement);
                propKey = hasSrcSet = hasSrc = null;
                for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                    case "value":
                        hasSrc = defaultValue;
                        break;
                    case "defaultValue":
                        hasSrcSet = defaultValue;
                        break;
                    case "children":
                        propKey = defaultValue;
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != defaultValue) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                        break;
                    default:
                        setProp(domElement, tag, propValue, defaultValue, props, null);
                }
                validateTextareaProps(domElement, props);
                initTextarea(domElement, hasSrc, hasSrcSet, propKey);
                return;
            case "option":
                validateOptionProps(domElement, props);
                for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                    case "selected":
                        domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                        break;
                    default:
                        setProp(domElement, tag, checked, hasSrc, props, null);
                }
                return;
            case "dialog":
                listenToNonDelegatedEvent("beforetoggle", domElement);
                listenToNonDelegatedEvent("toggle", domElement);
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
                break;
            case "image":
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "embed":
            case "source":
            case "link":
                listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
            case "area":
            case "base":
            case "br":
            case "col":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "track":
            case "wbr":
            case "menuitem":
                for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                    default:
                        setProp(domElement, tag, defaultChecked, hasSrc, props, null);
                }
                return;
            default:
                if (isCustomElement(tag)) {
                    for(_propValue in props)props.hasOwnProperty(_propValue) && (hasSrc = props[_propValue], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, _propValue, hasSrc, props, void 0));
                    return;
                }
        }
        for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
    }
    function updateProperties(domElement, tag, lastProps, nextProps) {
        validatePropertiesInDevelopment(tag, nextProps);
        switch(tag){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "input":
                var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
                for(propKey in lastProps){
                    var lastProp = lastProps[propKey];
                    if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                        case "checked":
                            break;
                        case "value":
                            break;
                        case "defaultValue":
                            lastDefaultValue = lastProp;
                        default:
                            nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                    }
                }
                for(var _propKey8 in nextProps){
                    var propKey = nextProps[_propKey8];
                    lastProp = lastProps[_propKey8];
                    if (nextProps.hasOwnProperty(_propKey8) && (null != propKey || null != lastProp)) switch(_propKey8){
                        case "type":
                            type = propKey;
                            break;
                        case "name":
                            name = propKey;
                            break;
                        case "checked":
                            checked = propKey;
                            break;
                        case "defaultChecked":
                            defaultChecked = propKey;
                            break;
                        case "value":
                            value = propKey;
                            break;
                        case "defaultValue":
                            defaultValue = propKey;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != propKey) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                            break;
                        default:
                            propKey !== lastProp && setProp(domElement, tag, _propKey8, propKey, nextProps, lastProp);
                    }
                }
                tag = "checkbox" === lastProps.type || "radio" === lastProps.type ? null != lastProps.checked : null != lastProps.value;
                nextProps = "checkbox" === nextProps.type || "radio" === nextProps.type ? null != nextProps.checked : null != nextProps.value;
                tag || !nextProps || didWarnUncontrolledToControlled || (console.error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), didWarnUncontrolledToControlled = !0);
                !tag || nextProps || didWarnControlledToUncontrolled || (console.error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), didWarnControlledToUncontrolled = !0);
                updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
                return;
            case "select":
                propKey = value = defaultValue = _propKey8 = null;
                for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                    case "value":
                        break;
                    case "multiple":
                        propKey = lastDefaultValue;
                    default:
                        nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
                }
                for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                    case "value":
                        _propKey8 = type;
                        break;
                    case "defaultValue":
                        defaultValue = type;
                        break;
                    case "multiple":
                        value = type;
                    default:
                        type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
                }
                nextProps = defaultValue;
                tag = value;
                lastProps = propKey;
                null != _propKey8 ? updateOptions(domElement, !!tag, _propKey8, !1) : !!lastProps !== !!tag && (null != nextProps ? updateOptions(domElement, !!tag, nextProps, !0) : updateOptions(domElement, !!tag, tag ? [] : "", !1));
                return;
            case "textarea":
                propKey = _propKey8 = null;
                for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                    case "value":
                        break;
                    case "children":
                        break;
                    default:
                        setProp(domElement, tag, defaultValue, null, nextProps, name);
                }
                for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                    case "value":
                        _propKey8 = name;
                        break;
                    case "defaultValue":
                        propKey = name;
                        break;
                    case "children":
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != name) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                        break;
                    default:
                        name !== type && setProp(domElement, tag, value, name, nextProps, type);
                }
                updateTextarea(domElement, _propKey8, propKey);
                return;
            case "option":
                for(var _propKey13 in lastProps)if (_propKey8 = lastProps[_propKey13], lastProps.hasOwnProperty(_propKey13) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey13)) switch(_propKey13){
                    case "selected":
                        domElement.selected = !1;
                        break;
                    default:
                        setProp(domElement, tag, _propKey13, null, nextProps, _propKey8);
                }
                for(lastDefaultValue in nextProps)if (_propKey8 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && _propKey8 !== propKey && (null != _propKey8 || null != propKey)) switch(lastDefaultValue){
                    case "selected":
                        domElement.selected = _propKey8 && "function" !== typeof _propKey8 && "symbol" !== typeof _propKey8;
                        break;
                    default:
                        setProp(domElement, tag, lastDefaultValue, _propKey8, nextProps, propKey);
                }
                return;
            case "img":
            case "link":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
            case "menuitem":
                for(var _propKey15 in lastProps)_propKey8 = lastProps[_propKey15], lastProps.hasOwnProperty(_propKey15) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey15) && setProp(domElement, tag, _propKey15, null, nextProps, _propKey8);
                for(checked in nextProps)if (_propKey8 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && _propKey8 !== propKey && (null != _propKey8 || null != propKey)) switch(checked){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != _propKey8) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                        break;
                    default:
                        setProp(domElement, tag, checked, _propKey8, nextProps, propKey);
                }
                return;
            default:
                if (isCustomElement(tag)) {
                    for(var _propKey17 in lastProps)_propKey8 = lastProps[_propKey17], lastProps.hasOwnProperty(_propKey17) && void 0 !== _propKey8 && !nextProps.hasOwnProperty(_propKey17) && setPropOnCustomElement(domElement, tag, _propKey17, void 0, nextProps, _propKey8);
                    for(defaultChecked in nextProps)_propKey8 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || _propKey8 === propKey || void 0 === _propKey8 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, _propKey8, nextProps, propKey);
                    return;
                }
        }
        for(var _propKey19 in lastProps)_propKey8 = lastProps[_propKey19], lastProps.hasOwnProperty(_propKey19) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey19) && setProp(domElement, tag, _propKey19, null, nextProps, _propKey8);
        for(lastProp in nextProps)_propKey8 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || _propKey8 === propKey || null == _propKey8 && null == propKey || setProp(domElement, tag, lastProp, _propKey8, nextProps, propKey);
    }
    function getPropNameFromAttributeName(attrName) {
        switch(attrName){
            case "class":
                return "className";
            case "for":
                return "htmlFor";
            default:
                return attrName;
        }
    }
    function getStylesObjectFromElement(domElement) {
        var serverValueInObjectForm = {};
        domElement = domElement.style;
        for(var i = 0; i < domElement.length; i++){
            var styleName = domElement[i];
            serverValueInObjectForm[styleName] = domElement.getPropertyValue(styleName);
        }
        return serverValueInObjectForm;
    }
    function diffHydratedStyles(domElement, value$jscomp$0, serverDifferences) {
        if (null != value$jscomp$0 && "object" !== typeof value$jscomp$0) console.error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        else {
            var clientValue;
            var delimiter = clientValue = "", styleName;
            for(styleName in value$jscomp$0)if (value$jscomp$0.hasOwnProperty(styleName)) {
                var value = value$jscomp$0[styleName];
                null != value && "boolean" !== typeof value && "" !== value && (0 === styleName.indexOf("--") ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName + ":" + ("" + value).trim()) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + ("" + value).trim()) : clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + value + "px", delimiter = ";");
            }
            clientValue = clientValue || null;
            value$jscomp$0 = domElement.getAttribute("style");
            value$jscomp$0 !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(value$jscomp$0) !== clientValue && (serverDifferences.style = getStylesObjectFromElement(domElement)));
        }
    }
    function hydrateAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (checkAttributeStringCoercion(value, propKey), domElement === "" + value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) {
            switch(typeof value){
                case "function":
                case "symbol":
                    return;
            }
            if (!value) return;
        } else switch(typeof value){
            case "function":
            case "symbol":
                break;
            default:
                if (value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanishAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
                break;
            default:
                if (checkAttributeStringCoercion(value, attributeName), domElement === "" + value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateNumericAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
            default:
                if (isNaN(value)) return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (!isNaN(value) && (checkAttributeStringCoercion(value, propKey), domElement === "" + value)) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateSanitizedAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (checkAttributeStringCoercion(value, propKey), attributeName = sanitizeURL("" + value), domElement === attributeName) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function diffHydratedProperties(domElement, tag, props, hostContext) {
        for(var serverDifferences = {}, extraAttributes = new Set(), attributes = domElement.attributes, i = 0; i < attributes.length; i++)switch(attributes[i].name.toLowerCase()){
            case "value":
                break;
            case "checked":
                break;
            case "selected":
                break;
            default:
                extraAttributes.add(attributes[i].name);
        }
        if (isCustomElement(tag)) {
            for(var propKey in props)if (props.hasOwnProperty(propKey)) {
                var value = props[propKey];
                if (null != value) {
                    if (registrationNameDependencies.hasOwnProperty(propKey)) "function" !== typeof value && warnForInvalidEventListener(propKey, value);
                    else if (!0 !== props.suppressHydrationWarning) switch(propKey){
                        case "children":
                            "string" !== typeof value && "number" !== typeof value || warnForPropDifference("children", domElement.textContent, value, serverDifferences);
                            continue;
                        case "suppressContentEditableWarning":
                        case "suppressHydrationWarning":
                        case "defaultValue":
                        case "defaultChecked":
                        case "innerHTML":
                        case "ref":
                            continue;
                        case "dangerouslySetInnerHTML":
                            attributes = domElement.innerHTML;
                            value = value ? value.__html : void 0;
                            null != value && (value = normalizeHTML(domElement, value), warnForPropDifference(propKey, attributes, value, serverDifferences));
                            continue;
                        case "style":
                            extraAttributes.delete(propKey);
                            diffHydratedStyles(domElement, value, serverDifferences);
                            continue;
                        case "offsetParent":
                        case "offsetTop":
                        case "offsetLeft":
                        case "offsetWidth":
                        case "offsetHeight":
                        case "isContentEditable":
                        case "outerText":
                        case "outerHTML":
                            extraAttributes.delete(propKey.toLowerCase());
                            console.error("Assignment to read-only property will result in a no-op: `%s`", propKey);
                            continue;
                        case "className":
                            extraAttributes.delete("class");
                            attributes = getValueForAttributeOnCustomComponent(domElement, "class", value);
                            warnForPropDifference("className", attributes, value, serverDifferences);
                            continue;
                        default:
                            hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(propKey.toLowerCase()) : extraAttributes.delete(propKey), attributes = getValueForAttributeOnCustomComponent(domElement, propKey, value), warnForPropDifference(propKey, attributes, value, serverDifferences);
                    }
                }
            }
        } else for(value in props)if (props.hasOwnProperty(value) && (propKey = props[value], null != propKey)) {
            if (registrationNameDependencies.hasOwnProperty(value)) "function" !== typeof propKey && warnForInvalidEventListener(value, propKey);
            else if (!0 !== props.suppressHydrationWarning) switch(value){
                case "children":
                    "string" !== typeof propKey && "number" !== typeof propKey || warnForPropDifference("children", domElement.textContent, propKey, serverDifferences);
                    continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                    continue;
                case "dangerouslySetInnerHTML":
                    attributes = domElement.innerHTML;
                    propKey = propKey ? propKey.__html : void 0;
                    null != propKey && (propKey = normalizeHTML(domElement, propKey), attributes !== propKey && (serverDifferences[value] = {
                        __html: attributes
                    }));
                    continue;
                case "className":
                    hydrateAttribute(domElement, value, "class", propKey, extraAttributes, serverDifferences);
                    continue;
                case "tabIndex":
                    hydrateAttribute(domElement, value, "tabindex", propKey, extraAttributes, serverDifferences);
                    continue;
                case "style":
                    extraAttributes.delete(value);
                    diffHydratedStyles(domElement, propKey, serverDifferences);
                    continue;
                case "multiple":
                    extraAttributes.delete(value);
                    warnForPropDifference(value, domElement.multiple, propKey, serverDifferences);
                    continue;
                case "muted":
                    extraAttributes.delete(value);
                    warnForPropDifference(value, domElement.muted, propKey, serverDifferences);
                    continue;
                case "autoFocus":
                    extraAttributes.delete("autofocus");
                    warnForPropDifference(value, domElement.autofocus, propKey, serverDifferences);
                    continue;
                case "data":
                    if ("object" !== tag) {
                        extraAttributes.delete(value);
                        attributes = domElement.getAttribute("data");
                        warnForPropDifference(value, attributes, propKey, serverDifferences);
                        continue;
                    }
                case "src":
                case "href":
                    if (!("" !== propKey || "a" === tag && "href" === value || "object" === tag && "data" === value)) {
                        "src" === value ? console.error('An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', value, value) : console.error('An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', value, value);
                        continue;
                    }
                    hydrateSanitizedAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "action":
                case "formAction":
                    attributes = domElement.getAttribute(value);
                    if ("function" === typeof propKey) {
                        extraAttributes.delete(value.toLowerCase());
                        "formAction" === value ? (extraAttributes.delete("name"), extraAttributes.delete("formenctype"), extraAttributes.delete("formmethod"), extraAttributes.delete("formtarget")) : (extraAttributes.delete("enctype"), extraAttributes.delete("method"), extraAttributes.delete("target"));
                        continue;
                    } else if (attributes === EXPECTED_FORM_ACTION_URL) {
                        extraAttributes.delete(value.toLowerCase());
                        warnForPropDifference(value, "function", propKey, serverDifferences);
                        continue;
                    }
                    hydrateSanitizedAttribute(domElement, value, value.toLowerCase(), propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkHref":
                    hydrateSanitizedAttribute(domElement, value, "xlink:href", propKey, extraAttributes, serverDifferences);
                    continue;
                case "contentEditable":
                    hydrateBooleanishAttribute(domElement, value, "contenteditable", propKey, extraAttributes, serverDifferences);
                    continue;
                case "spellCheck":
                    hydrateBooleanishAttribute(domElement, value, "spellcheck", propKey, extraAttributes, serverDifferences);
                    continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                    hydrateBooleanishAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                    hydrateBooleanAttribute(domElement, value, value.toLowerCase(), propKey, extraAttributes, serverDifferences);
                    continue;
                case "capture":
                case "download":
                    a: {
                        i = domElement;
                        var attributeName = attributes = value, serverDifferences$jscomp$0 = serverDifferences;
                        extraAttributes.delete(attributeName);
                        i = i.getAttribute(attributeName);
                        if (null === i) switch(typeof propKey){
                            case "undefined":
                            case "function":
                            case "symbol":
                                break a;
                            default:
                                if (!1 === propKey) break a;
                        }
                        else if (null != propKey) switch(typeof propKey){
                            case "function":
                            case "symbol":
                                break;
                            case "boolean":
                                if (!0 === propKey && "" === i) break a;
                                break;
                            default:
                                if (checkAttributeStringCoercion(propKey, attributes), i === "" + propKey) break a;
                        }
                        warnForPropDifference(attributes, i, propKey, serverDifferences$jscomp$0);
                    }
                    continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                    a: {
                        i = domElement;
                        attributeName = attributes = value;
                        serverDifferences$jscomp$0 = serverDifferences;
                        extraAttributes.delete(attributeName);
                        i = i.getAttribute(attributeName);
                        if (null === i) switch(typeof propKey){
                            case "undefined":
                            case "function":
                            case "symbol":
                            case "boolean":
                                break a;
                            default:
                                if (isNaN(propKey) || 1 > propKey) break a;
                        }
                        else if (null != propKey) switch(typeof propKey){
                            case "function":
                            case "symbol":
                            case "boolean":
                                break;
                            default:
                                if (!(isNaN(propKey) || 1 > propKey) && (checkAttributeStringCoercion(propKey, attributes), i === "" + propKey)) break a;
                        }
                        warnForPropDifference(attributes, i, propKey, serverDifferences$jscomp$0);
                    }
                    continue;
                case "rowSpan":
                    hydrateNumericAttribute(domElement, value, "rowspan", propKey, extraAttributes, serverDifferences);
                    continue;
                case "start":
                    hydrateNumericAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "xHeight":
                    hydrateAttribute(domElement, value, "x-height", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkActuate":
                    hydrateAttribute(domElement, value, "xlink:actuate", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkArcrole":
                    hydrateAttribute(domElement, value, "xlink:arcrole", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkRole":
                    hydrateAttribute(domElement, value, "xlink:role", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkShow":
                    hydrateAttribute(domElement, value, "xlink:show", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkTitle":
                    hydrateAttribute(domElement, value, "xlink:title", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkType":
                    hydrateAttribute(domElement, value, "xlink:type", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlBase":
                    hydrateAttribute(domElement, value, "xml:base", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlLang":
                    hydrateAttribute(domElement, value, "xml:lang", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlSpace":
                    hydrateAttribute(domElement, value, "xml:space", propKey, extraAttributes, serverDifferences);
                    continue;
                case "inert":
                    "" !== propKey || didWarnForNewBooleanPropsWithEmptyValue[value] || (didWarnForNewBooleanPropsWithEmptyValue[value] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", value));
                    hydrateBooleanAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                default:
                    if (!(2 < value.length) || "o" !== value[0] && "O" !== value[0] || "n" !== value[1] && "N" !== value[1]) {
                        i = getAttributeAlias(value);
                        attributes = !1;
                        hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(i.toLowerCase()) : (attributeName = value.toLowerCase(), attributeName = possibleStandardNames.hasOwnProperty(attributeName) ? possibleStandardNames[attributeName] || null : null, null !== attributeName && attributeName !== value && (attributes = !0, extraAttributes.delete(attributeName)), extraAttributes.delete(i));
                        a: if (attributeName = domElement, serverDifferences$jscomp$0 = i, i = propKey, isAttributeNameSafe(serverDifferences$jscomp$0)) {
                            if (attributeName.hasAttribute(serverDifferences$jscomp$0)) attributeName = attributeName.getAttribute(serverDifferences$jscomp$0), checkAttributeStringCoercion(i, serverDifferences$jscomp$0), i = attributeName === "" + i ? i : attributeName;
                            else {
                                switch(typeof i){
                                    case "function":
                                    case "symbol":
                                        break a;
                                    case "boolean":
                                        if (attributeName = serverDifferences$jscomp$0.toLowerCase().slice(0, 5), "data-" !== attributeName && "aria-" !== attributeName) break a;
                                }
                                i = void 0 === i ? void 0 : null;
                            }
                        } else i = void 0;
                        attributes || warnForPropDifference(value, i, propKey, serverDifferences);
                    }
            }
        }
        0 < extraAttributes.size && !0 !== props.suppressHydrationWarning && warnForExtraAttributes(domElement, extraAttributes, serverDifferences);
        return 0 === Object.keys(serverDifferences).length ? null : serverDifferences;
    }
    function propNamesListJoin(list, combinator) {
        switch(list.length){
            case 0:
                return "";
            case 1:
                return list[0];
            case 2:
                return list[0] + " " + combinator + " " + list[1];
            default:
                return list.slice(0, -1).join(", ") + ", " + combinator + " " + list[list.length - 1];
        }
    }
    function isLikelyStaticResource(initiatorType) {
        switch(initiatorType){
            case "css":
            case "script":
            case "font":
            case "img":
            case "image":
            case "input":
            case "link":
                return !0;
            default:
                return !1;
        }
    }
    function estimateBandwidth() {
        if ("function" === typeof performance.getEntriesByType) {
            for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
                var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
                if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
                    initiatorType = 0;
                    duration = entry.responseEnd;
                    for(i += 1; i < resourceEntries.length; i++){
                        var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                        if (overlapStartTime > duration) break;
                        var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                        overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                    }
                    --i;
                    bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                    count++;
                    if (10 < count) break;
                }
            }
            if (0 < count) return bits / count / 1e6;
        }
        return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function getOwnHostContext(namespaceURI) {
        switch(namespaceURI){
            case SVG_NAMESPACE:
                return HostContextNamespaceSvg;
            case MATH_NAMESPACE:
                return HostContextNamespaceMath;
            default:
                return HostContextNamespaceNone;
        }
    }
    function getChildHostContextProd(parentNamespace, type) {
        if (parentNamespace === HostContextNamespaceNone) switch(type){
            case "svg":
                return HostContextNamespaceSvg;
            case "math":
                return HostContextNamespaceMath;
            default:
                return HostContextNamespaceNone;
        }
        return parentNamespace === HostContextNamespaceSvg && "foreignObject" === type ? HostContextNamespaceNone : parentNamespace;
    }
    function shouldSetTextContent(type, props) {
        return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
    }
    function shouldAttemptEagerTransition() {
        var event = window.event;
        if (event && "popstate" === event.type) {
            if (event === currentPopstateTransitionEvent) return !1;
            currentPopstateTransitionEvent = event;
            return !0;
        }
        currentPopstateTransitionEvent = null;
        return !1;
    }
    function resolveEventType() {
        var event = window.event;
        return event && event !== schedulerEvent ? event.type : null;
    }
    function resolveEventTimeStamp() {
        var event = window.event;
        return event && event !== schedulerEvent ? event.timeStamp : -1.1;
    }
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    }
    function commitMount(domElement, type, newProps) {
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                newProps.autoFocus && domElement.focus();
                break;
            case "img":
                newProps.src ? domElement.src = newProps.src : newProps.srcSet && (domElement.srcset = newProps.srcSet);
        }
    }
    function commitHydratedInstance() {}
    function commitUpdate(domElement, type, oldProps, newProps) {
        updateProperties(domElement, type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function warnForReactChildrenConflict(container) {
        if (!container.__reactWarnedAboutChildrenConflict) {
            var props = container[internalPropsKey] || null;
            if (null !== props) {
                var fiber = getInstanceFromNode(container);
                null !== fiber && ("string" === typeof props.children || "number" === typeof props.children ? (container.__reactWarnedAboutChildrenConflict = !0, runWithFiberInDEV(fiber, function() {
                    console.error('Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.');
                })) : null != props.dangerouslySetInnerHTML && (container.__reactWarnedAboutChildrenConflict = !0, runWithFiberInDEV(fiber, function() {
                    console.error('Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.');
                })));
            }
        }
    }
    function isSingletonScope(type) {
        return "head" === type;
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        (9 === container.nodeType ? container.body : "HTML" === container.nodeName ? container.ownerDocument.body : container).removeChild(child);
    }
    function clearHydrationBoundary(parentInstance, hydrationInstance) {
        var node = hydrationInstance, depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && 8 === nextNode.nodeType) {
                if (node = nextNode.data, node === SUSPENSE_END_DATA || node === ACTIVITY_END_DATA) {
                    if (0 === depth) {
                        parentInstance.removeChild(nextNode);
                        retryIfBlockedOn(hydrationInstance);
                        return;
                    }
                    depth--;
                } else if (node === SUSPENSE_START_DATA || node === SUSPENSE_PENDING_START_DATA || node === SUSPENSE_QUEUED_START_DATA || node === SUSPENSE_FALLBACK_START_DATA || node === ACTIVITY_START_DATA) depth++;
                else if (node === PREAMBLE_CONTRIBUTION_HTML) releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
                else if (node === PREAMBLE_CONTRIBUTION_HEAD) {
                    node = parentInstance.ownerDocument.head;
                    releaseSingletonInstance(node);
                    for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                        var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                        node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                        node$jscomp$0 = nextNode$jscomp$0;
                    }
                } else node === PREAMBLE_CONTRIBUTION_BODY && releaseSingletonInstance(parentInstance.ownerDocument.body);
            }
            node = nextNode;
        }while (node);
        retryIfBlockedOn(hydrationInstance);
    }
    function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
        var node = suspenseInstance;
        suspenseInstance = 0;
        do {
            var nextNode = node.nextSibling;
            1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
            if (nextNode && 8 === nextNode.nodeType) {
                if (node = nextNode.data, node === SUSPENSE_END_DATA) {
                    if (0 === suspenseInstance) break;
                    else suspenseInstance--;
                } else node !== SUSPENSE_START_DATA && node !== SUSPENSE_PENDING_START_DATA && node !== SUSPENSE_QUEUED_START_DATA && node !== SUSPENSE_FALLBACK_START_DATA || suspenseInstance++;
            }
            node = nextNode;
        }while (node);
    }
    function hideDehydratedBoundary(suspenseInstance) {
        hideOrUnhideDehydratedBoundary(suspenseInstance, !0);
    }
    function hideInstance(instance) {
        instance = instance.style;
        "function" === typeof instance.setProperty ? instance.setProperty("display", "none", "important") : instance.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideDehydratedBoundary(dehydratedInstance) {
        hideOrUnhideDehydratedBoundary(dehydratedInstance, !1);
    }
    function unhideInstance(instance, props) {
        props = props[STYLE];
        props = void 0 !== props && null !== props && props.hasOwnProperty("display") ? props.display : null;
        instance.style.display = null == props || "boolean" === typeof props ? "" : ("" + props).trim();
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainerSparingly(container) {
        var nextNode = container.firstChild;
        nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
        for(; nextNode;){
            var node = nextNode;
            nextNode = nextNode.nextSibling;
            switch(node.nodeName){
                case "HTML":
                case "HEAD":
                case "BODY":
                    clearContainerSparingly(node);
                    detachDeletedInstance(node);
                    continue;
                case "SCRIPT":
                case "STYLE":
                    continue;
                case "LINK":
                    if ("stylesheet" === node.rel.toLowerCase()) continue;
            }
            container.removeChild(node);
        }
    }
    function canHydrateInstance(instance, type, props, inRootOrSingleton) {
        for(; 1 === instance.nodeType;){
            var anyProps = props;
            if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
                if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
            } else if (!inRootOrSingleton) {
                if ("input" === type && "hidden" === instance.type) {
                    checkAttributeStringCoercion(anyProps.name, "name");
                    var name = null == anyProps.name ? null : "" + anyProps.name;
                    if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
                } else return instance;
            } else if (!instance[internalHoistableMarker]) switch(type){
                case "meta":
                    if (!instance.hasAttribute("itemprop")) break;
                    return instance;
                case "link":
                    name = instance.getAttribute("rel");
                    if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                    else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                    return instance;
                case "style":
                    if (instance.hasAttribute("data-precedence")) break;
                    return instance;
                case "script":
                    name = instance.getAttribute("src");
                    if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                    return instance;
                default:
                    return instance;
            }
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) break;
        }
        return null;
    }
    function canHydrateTextInstance(instance, text, inRootOrSingleton) {
        if ("" === text) return null;
        for(; 3 !== instance.nodeType;){
            if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) return null;
        }
        return instance;
    }
    function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
        for(; 8 !== instance.nodeType;){
            if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) return null;
        }
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA || instance.data === SUSPENSE_QUEUED_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA || instance.data === SUSPENSE_PENDING_START_DATA && instance.ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        var ownerDocument = instance.ownerDocument;
        if (instance.data === SUSPENSE_QUEUED_START_DATA) instance._reactRetry = callback;
        else if (instance.data !== SUSPENSE_PENDING_START_DATA || ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING) callback();
        else {
            var listener = function() {
                callback();
                ownerDocument.removeEventListener("DOMContentLoaded", listener);
            };
            ownerDocument.addEventListener("DOMContentLoaded", listener);
            instance._reactRetry = listener;
        }
    }
    function getNextHydratable(node) {
        for(; null != node; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (1 === nodeType || 3 === nodeType) break;
            if (8 === nodeType) {
                nodeType = node.data;
                if (nodeType === SUSPENSE_START_DATA || nodeType === SUSPENSE_FALLBACK_START_DATA || nodeType === SUSPENSE_PENDING_START_DATA || nodeType === SUSPENSE_QUEUED_START_DATA || nodeType === ACTIVITY_START_DATA || nodeType === FORM_STATE_IS_MATCHING || nodeType === FORM_STATE_IS_NOT_MATCHING) break;
                if (nodeType === SUSPENSE_END_DATA || nodeType === ACTIVITY_END_DATA) return null;
            }
        }
        return node;
    }
    function describeHydratableInstanceForDevWarnings(instance) {
        if (1 === instance.nodeType) {
            for(var JSCompiler_temp_const = instance.nodeName.toLowerCase(), serverDifferences = {}, attributes = instance.attributes, i = 0; i < attributes.length; i++){
                var attr = attributes[i];
                serverDifferences[getPropNameFromAttributeName(attr.name)] = "style" === attr.name.toLowerCase() ? getStylesObjectFromElement(instance) : attr.value;
            }
            return {
                type: JSCompiler_temp_const,
                props: serverDifferences
            };
        }
        return 8 === instance.nodeType ? instance.data === ACTIVITY_START_DATA ? {
            type: "Activity",
            props: {}
        } : {
            type: "Suspense",
            props: {}
        } : instance.nodeValue;
    }
    function diffHydratedTextForDevWarnings(textInstance, text, parentProps) {
        return null === parentProps || !0 !== parentProps[SUPPRESS_HYDRATION_WARNING] ? (textInstance.nodeValue === text ? textInstance = null : (text = normalizeMarkupForTextOrAttribute(text), textInstance = normalizeMarkupForTextOrAttribute(textInstance.nodeValue) === text ? null : textInstance.nodeValue), textInstance) : null;
    }
    function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
        hydrationInstance = hydrationInstance.nextSibling;
        for(var depth = 0; hydrationInstance;){
            if (8 === hydrationInstance.nodeType) {
                var data = hydrationInstance.data;
                if (data === SUSPENSE_END_DATA || data === ACTIVITY_END_DATA) {
                    if (0 === depth) return getNextHydratable(hydrationInstance.nextSibling);
                    depth--;
                } else data !== SUSPENSE_START_DATA && data !== SUSPENSE_FALLBACK_START_DATA && data !== SUSPENSE_PENDING_START_DATA && data !== SUSPENSE_QUEUED_START_DATA && data !== ACTIVITY_START_DATA || depth++;
            }
            hydrationInstance = hydrationInstance.nextSibling;
        }
        return null;
    }
    function getParentHydrationBoundary(targetInstance) {
        targetInstance = targetInstance.previousSibling;
        for(var depth = 0; targetInstance;){
            if (8 === targetInstance.nodeType) {
                var data = targetInstance.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_QUEUED_START_DATA || data === ACTIVITY_START_DATA) {
                    if (0 === depth) return targetInstance;
                    depth--;
                } else data !== SUSPENSE_END_DATA && data !== ACTIVITY_END_DATA || depth++;
            }
            targetInstance = targetInstance.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        retryIfBlockedOn(container);
    }
    function commitHydratedActivityInstance(activityInstance) {
        retryIfBlockedOn(activityInstance);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        retryIfBlockedOn(suspenseInstance);
    }
    function resolveSingletonInstance(type, props, rootContainerInstance, hostContext, validateDOMNestingDev) {
        validateDOMNestingDev && validateDOMNesting(type, hostContext.ancestorInfo);
        props = getOwnerDocumentFromRootContainer(rootContainerInstance);
        switch(type){
            case "html":
                type = props.documentElement;
                if (!type) throw Error("React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            case "head":
                type = props.head;
                if (!type) throw Error("React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            case "body":
                type = props.body;
                if (!type) throw Error("React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            default:
                throw Error("resolveSingletonInstance was called with an element type that is not supported. This is a bug in React.");
        }
    }
    function acquireSingletonInstance(type, props, instance, internalInstanceHandle) {
        if (!instance[internalContainerInstanceKey] && getInstanceFromNode(instance)) {
            var tagName = instance.tagName.toLowerCase();
            console.error("You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.", tagName, tagName, tagName);
        }
        switch(type){
            case "html":
            case "head":
            case "body":
                break;
            default:
                console.error("acquireSingletonInstance was called with an element type that is not supported. This is a bug in React.");
        }
        for(tagName = instance.attributes; tagName.length;)instance.removeAttributeNode(tagName[0]);
        setInitialProperties(instance, type, props);
        instance[internalInstanceKey] = internalInstanceHandle;
        instance[internalPropsKey] = props;
    }
    function releaseSingletonInstance(instance) {
        for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
        detachDeletedInstance(instance);
    }
    function getHoistableRoot(container) {
        return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
    }
    function preconnectAs(rel, href, crossOrigin) {
        var ownerDocument = globalDocument;
        if (ownerDocument && "string" === typeof href && href) {
            var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
            limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
            "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
            preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
                rel: rel,
                crossOrigin: crossOrigin,
                href: href
            }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
        }
    }
    function getResource(type, currentProps, pendingProps, currentResource) {
        var resourceRoot = (resourceRoot = rootInstanceStackCursor.current) ? getHoistableRoot(resourceRoot) : null;
        if (!resourceRoot) throw Error('"resourceRoot" was expected to exist. This is a bug in React.');
        switch(type){
            case "meta":
            case "title":
                return null;
            case "style":
                return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = getStyleKey(pendingProps.href), currentProps = getResourcesFromRoot(resourceRoot).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                    type: "style",
                    instance: null,
                    count: 0,
                    state: null
                }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            case "link":
                if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                    type = getStyleKey(pendingProps.href);
                    var _styles = getResourcesFromRoot(resourceRoot).hoistableStyles, _resource = _styles.get(type);
                    if (!_resource && (resourceRoot = resourceRoot.ownerDocument || resourceRoot, _resource = {
                        type: "stylesheet",
                        instance: null,
                        count: 0,
                        state: {
                            loading: NotLoaded,
                            preload: null
                        }
                    }, _styles.set(type, _resource), (_styles = resourceRoot.querySelector(getStylesheetSelectorFromKey(type))) && !_styles._p && (_resource.instance = _styles, _resource.state.loading = Loaded | Inserted), !preloadPropsMap.has(type))) {
                        var preloadProps = {
                            rel: "preload",
                            as: "style",
                            href: pendingProps.href,
                            crossOrigin: pendingProps.crossOrigin,
                            integrity: pendingProps.integrity,
                            media: pendingProps.media,
                            hrefLang: pendingProps.hrefLang,
                            referrerPolicy: pendingProps.referrerPolicy
                        };
                        preloadPropsMap.set(type, preloadProps);
                        _styles || preloadStylesheet(resourceRoot, type, preloadProps, _resource.state);
                    }
                    if (currentProps && null === currentResource) throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error("Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps);
                    return _resource;
                }
                if (currentProps && null !== currentResource) throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error("Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps);
                return null;
            case "script":
                return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = getScriptKey(pendingProps), currentProps = getResourcesFromRoot(resourceRoot).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                    type: "script",
                    instance: null,
                    count: 0,
                    state: null
                }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            default:
                throw Error('getResource encountered a type it did not expect: "' + type + '". this is a bug in React.');
        }
    }
    function describeLinkForResourceErrorDEV(props) {
        var describedProps = 0, description = "<link";
        "string" === typeof props.rel ? (describedProps++, description += ' rel="' + props.rel + '"') : hasOwnProperty.call(props, "rel") && (describedProps++, description += ' rel="' + (null === props.rel ? "null" : "invalid type " + typeof props.rel) + '"');
        "string" === typeof props.href ? (describedProps++, description += ' href="' + props.href + '"') : hasOwnProperty.call(props, "href") && (describedProps++, description += ' href="' + (null === props.href ? "null" : "invalid type " + typeof props.href) + '"');
        "string" === typeof props.precedence ? (describedProps++, description += ' precedence="' + props.precedence + '"') : hasOwnProperty.call(props, "precedence") && (describedProps++, description += " precedence={" + (null === props.precedence ? "null" : "invalid type " + typeof props.precedence) + "}");
        Object.getOwnPropertyNames(props).length > describedProps && (description += " ...");
        return description + " />";
    }
    function getStyleKey(href) {
        return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
    }
    function getStylesheetSelectorFromKey(key) {
        return 'link[rel="stylesheet"][' + key + "]";
    }
    function stylesheetPropsFromRawProps(rawProps) {
        return assign({}, rawProps, {
            "data-precedence": rawProps.precedence,
            precedence: null
        });
    }
    function preloadStylesheet(ownerDocument, key, preloadProps, state) {
        ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = Loaded : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
            return state.loading |= Loaded;
        }), key.addEventListener("error", function() {
            return state.loading |= Errored;
        }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
    }
    function getScriptKey(src) {
        return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
    }
    function getScriptSelectorFromKey(key) {
        return "script[async]" + key;
    }
    function acquireResource(hoistableRoot, resource, props) {
        resource.count++;
        if (null === resource.instance) switch(resource.type){
            case "style":
                var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
                if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
                var styleProps = assign({}, props, {
                    "data-href": props.href,
                    "data-precedence": props.precedence,
                    href: null,
                    precedence: null
                });
                instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
                markNodeAsHoistable(instance);
                setInitialProperties(instance, "style", styleProps);
                insertStylesheet(instance, props.precedence, hoistableRoot);
                return resource.instance = instance;
            case "stylesheet":
                styleProps = getStyleKey(props.href);
                var _instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
                if (_instance) return resource.state.loading |= Inserted, resource.instance = _instance, markNodeAsHoistable(_instance), _instance;
                instance = stylesheetPropsFromRawProps(props);
                (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
                _instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
                markNodeAsHoistable(_instance);
                var linkInstance = _instance;
                linkInstance._p = new Promise(function(resolve, reject) {
                    linkInstance.onload = resolve;
                    linkInstance.onerror = reject;
                });
                setInitialProperties(_instance, "link", instance);
                resource.state.loading |= Inserted;
                insertStylesheet(_instance, props.precedence, hoistableRoot);
                return resource.instance = _instance;
            case "script":
                _instance = getScriptKey(props.src);
                if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(_instance))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
                instance = props;
                if (styleProps = preloadPropsMap.get(_instance)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                styleProps = hoistableRoot.createElement("script");
                markNodeAsHoistable(styleProps);
                setInitialProperties(styleProps, "link", instance);
                hoistableRoot.head.appendChild(styleProps);
                return resource.instance = styleProps;
            case "void":
                return null;
            default:
                throw Error('acquireResource encountered a resource type it did not expect: "' + resource.type + '". this is a bug in React.');
        }
        else "stylesheet" === resource.type && (resource.state.loading & Inserted) === NotLoaded && (instance = resource.instance, resource.state.loading |= Inserted, insertStylesheet(instance, props.precedence, hoistableRoot));
        return resource.instance;
    }
    function insertStylesheet(instance, precedence, root) {
        for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
            var node = nodes[i];
            if (node.dataset.precedence === precedence) prior = node;
            else if (prior !== last) break;
        }
        prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
    }
    function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
        null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
        null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
        null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
    }
    function adoptPreloadPropsForScript(scriptProps, preloadProps) {
        null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
        null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
        null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
    }
    function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
        if (null === tagCaches) {
            var cache = new Map();
            var caches = tagCaches = new Map();
            caches.set(ownerDocument, cache);
        } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
        if (cache.has(type)) return cache;
        cache.set(type, null);
        ownerDocument = ownerDocument.getElementsByTagName(type);
        for(caches = 0; caches < ownerDocument.length; caches++){
            var node = ownerDocument[caches];
            if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && node.namespaceURI !== SVG_NAMESPACE) {
                var nodeKey = node.getAttribute(keyAttribute) || "";
                nodeKey = type + nodeKey;
                var existing = cache.get(nodeKey);
                existing ? existing.push(node) : cache.set(nodeKey, [
                    node
                ]);
            }
        }
        return cache;
    }
    function mountHoistable(hoistableRoot, type, instance) {
        hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
        hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
    }
    function isHostHoistableType(type, props, hostContext) {
        var outsideHostContainerContext = !hostContext.ancestorInfo.containerTagInScope;
        if (hostContext.context === HostContextNamespaceSvg || null != props.itemProp) return !outsideHostContainerContext || null == props.itemProp || "meta" !== type && "title" !== type && "style" !== type && "link" !== type && "script" !== type || console.error("Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.", type, type), !1;
        switch(type){
            case "meta":
            case "title":
                return !0;
            case "style":
                if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) {
                    outsideHostContainerContext && console.error('Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.');
                    break;
                }
                return !0;
            case "link":
                if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) {
                    if ("stylesheet" === props.rel && "string" === typeof props.precedence) {
                        type = props.href;
                        var onError = props.onError, disabled = props.disabled;
                        hostContext = [];
                        props.onLoad && hostContext.push("`onLoad`");
                        onError && hostContext.push("`onError`");
                        null != disabled && hostContext.push("`disabled`");
                        onError = propNamesListJoin(hostContext, "and");
                        onError += 1 === hostContext.length ? " prop" : " props";
                        disabled = 1 === hostContext.length ? "an " + onError : "the " + onError;
                        hostContext.length && console.error('React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.', type, disabled, onError);
                    }
                    outsideHostContainerContext && ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href ? console.error("Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag") : (props.onError || props.onLoad) && console.error("Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."));
                    break;
                }
                switch(props.rel){
                    case "stylesheet":
                        return type = props.precedence, props = props.disabled, "string" !== typeof type && outsideHostContainerContext && console.error('Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'), "string" === typeof type && null == props;
                    default:
                        return !0;
                }
            case "script":
                type = props.async && "function" !== typeof props.async && "symbol" !== typeof props.async;
                if (!type || props.onLoad || props.onError || !props.src || "string" !== typeof props.src) {
                    outsideHostContainerContext && (type ? props.onLoad || props.onError ? console.error("Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.") : console.error("Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>.") : console.error('Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'));
                    break;
                }
                return !0;
            case "noscript":
            case "template":
                outsideHostContainerContext && console.error("Cannot render <%s> outside the main document. Try moving it into the root <head> tag.", type);
        }
        return !1;
    }
    function preloadResource(resource) {
        return "stylesheet" === resource.type && (resource.state.loading & Settled) === NotLoaded ? !1 : !0;
    }
    function suspendResource(state, hoistableRoot, resource, props) {
        if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && (resource.state.loading & Inserted) === NotLoaded) {
            if (null === resource.instance) {
                var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
                if (instance) {
                    hoistableRoot = instance._p;
                    null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                    resource.state.loading |= Inserted;
                    resource.instance = instance;
                    markNodeAsHoistable(instance);
                    return;
                }
                instance = hoistableRoot.ownerDocument || hoistableRoot;
                props = stylesheetPropsFromRawProps(props);
                (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
                instance = instance.createElement("link");
                markNodeAsHoistable(instance);
                var linkInstance = instance;
                linkInstance._p = new Promise(function(resolve, reject) {
                    linkInstance.onload = resolve;
                    linkInstance.onerror = reject;
                });
                setInitialProperties(instance, "link", props);
                resource.instance = instance;
            }
            null === state.stylesheets && (state.stylesheets = new Map());
            state.stylesheets.set(resource, hoistableRoot);
            (hoistableRoot = resource.state.preload) && (resource.state.loading & Settled) === NotLoaded && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
        }
    }
    function waitForCommitToBeReady(state, timeoutOffset) {
        state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
        return 0 < state.count || 0 < state.imgCount ? function(commit) {
            var stylesheetTimer = setTimeout(function() {
                state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
                if (state.unsuspend) {
                    var unsuspend = state.unsuspend;
                    state.unsuspend = null;
                    unsuspend();
                }
            }, SUSPENSEY_STYLESHEET_TIMEOUT + timeoutOffset);
            0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 125 * estimateBandwidth() * SUSPENSEY_IMAGE_TIME_ESTIMATE);
            var imgTimer = setTimeout(function() {
                state.waitingForImages = !1;
                if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                    var unsuspend = state.unsuspend;
                    state.unsuspend = null;
                    unsuspend();
                }
            }, (state.imgBytes > estimatedBytesWithinLimit ? 50 : SUSPENSEY_IMAGE_TIMEOUT) + timeoutOffset);
            state.unsuspend = commit;
            return function() {
                state.unsuspend = null;
                clearTimeout(stylesheetTimer);
                clearTimeout(imgTimer);
            };
        } : null;
    }
    function onUnsuspend() {
        this.count--;
        if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
            if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
            else if (this.unsuspend) {
                var unsuspend = this.unsuspend;
                this.unsuspend = null;
                unsuspend();
            }
        }
    }
    function insertSuspendedStylesheets(state, resources) {
        state.stylesheets = null;
        null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
    }
    function insertStylesheetIntoRoot(root, resource) {
        if (!(resource.state.loading & Inserted)) {
            var precedences = precedencesByRoot.get(root);
            if (precedences) var last = precedences.get(LAST_PRECEDENCE);
            else {
                precedences = new Map();
                precedencesByRoot.set(root, precedences);
                for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                    var node = nodes[i];
                    if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
                }
                last && precedences.set(LAST_PRECEDENCE, last);
            }
            nodes = resource.instance;
            node = nodes.getAttribute("data-precedence");
            i = precedences.get(node) || last;
            i === last && precedences.set(LAST_PRECEDENCE, nodes);
            precedences.set(node, nodes);
            this.count++;
            last = onUnsuspend.bind(this);
            nodes.addEventListener("load", last);
            nodes.addEventListener("error", last);
            i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
            resource.state.loading |= Inserted;
        }
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
        this.tag = 1;
        this.containerInfo = containerInfo;
        this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = noTimeout;
        this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
        this.callbackPriority = 0;
        this.expirationTimes = createLaneMap(-1);
        this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = createLaneMap(0);
        this.hiddenUpdates = createLaneMap(null);
        this.identifierPrefix = identifierPrefix;
        this.onUncaughtError = onUncaughtError;
        this.onCaughtError = onCaughtError;
        this.onRecoverableError = onRecoverableError;
        this.pooledCache = null;
        this.pooledCacheLanes = 0;
        this.formState = formState;
        this.incompleteTransitions = new Map();
        this.passiveEffectDuration = this.effectDuration = -0;
        this.memoizedUpdaters = new Set();
        containerInfo = this.pendingUpdatersLaneMap = [];
        for(tag = 0; 31 > tag; tag++)containerInfo.push(new Set());
        this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
        containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
        tag = ConcurrentMode;
        !0 === isStrictMode && (tag |= StrictLegacyMode | StrictEffectsMode);
        tag |= ProfileMode;
        isStrictMode = createFiber(3, null, null, tag);
        containerInfo.current = isStrictMode;
        isStrictMode.stateNode = containerInfo;
        tag = createCache();
        retainCache(tag);
        containerInfo.pooledCache = tag;
        retainCache(tag);
        isStrictMode.memoizedState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: tag
        };
        initializeUpdateQueue(isStrictMode);
        return containerInfo;
    }
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        parentComponent = emptyContextObject;
        return parentComponent;
    }
    function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
        if (injectedHook && "function" === typeof injectedHook.onScheduleFiberRoot) try {
            injectedHook.onScheduleFiberRoot(rendererID, container, element);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
        parentComponent = getContextForSubtree(parentComponent);
        null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
        isRendering && null !== current && !didWarnAboutNestedUpdates && (didWarnAboutNestedUpdates = !0, console.error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown"));
        container = createUpdate(lane);
        container.payload = {
            element: element
        };
        callback = void 0 === callback ? null : callback;
        null !== callback && ("function" !== typeof callback && console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", callback), container.callback = callback);
        element = enqueueUpdate(rootFiber, container, lane);
        null !== element && (startUpdateTimerByLane(lane, "root.render()", null), scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
    }
    function markRetryLaneImpl(fiber, retryLane) {
        fiber = fiber.memoizedState;
        if (null !== fiber && null !== fiber.dehydrated) {
            var a = fiber.retryLane;
            fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
        }
    }
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
    }
    function attemptContinuousHydration(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var root = enqueueConcurrentRenderForLane(fiber, 67108864);
            null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
            markRetryLaneIfNotHydrated(fiber, 67108864);
        }
    }
    function attemptHydrationAtCurrentPriority(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var lane = requestUpdateLane(fiber);
            lane = getBumpedLaneForHydrationByLane(lane);
            var root = enqueueConcurrentRenderForLane(fiber, lane);
            null !== root && scheduleUpdateOnFiber(root, fiber, lane);
            markRetryLaneIfNotHydrated(fiber, lane);
        }
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var prevTransition = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = DiscreteEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var prevTransition = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = ContinuousEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (_enabled) {
            var blockedOn = findInstanceBlockingEvent(nativeEvent);
            if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
            else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
            else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
                for(; null !== blockedOn;){
                    var fiber = getInstanceFromNode(blockedOn);
                    if (null !== fiber) switch(fiber.tag){
                        case 3:
                            fiber = fiber.stateNode;
                            if (fiber.current.memoizedState.isDehydrated) {
                                var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                                if (0 !== lanes) {
                                    var root = fiber;
                                    root.pendingLanes |= 2;
                                    for(root.entangledLanes |= 2; lanes;){
                                        var lane = 1 << 31 - clz32(lanes);
                                        root.entanglements[1] |= lane;
                                        lanes &= ~lane;
                                    }
                                    ensureRootIsScheduled(fiber);
                                    (executionContext & (RenderContext | CommitContext)) === NoContext && (workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS, flushSyncWorkAcrossRoots_impl(0, !1));
                                }
                            }
                            break;
                        case 31:
                        case 13:
                            root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                    }
                    fiber = findInstanceBlockingEvent(nativeEvent);
                    null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                    if (fiber === blockedOn) break;
                    blockedOn = fiber;
                }
                null !== blockedOn && nativeEvent.stopPropagation();
            } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
        }
    }
    function findInstanceBlockingEvent(nativeEvent) {
        nativeEvent = getEventTarget(nativeEvent);
        return findInstanceBlockingTarget(nativeEvent);
    }
    function findInstanceBlockingTarget(targetNode) {
        return_targetInst = null;
        targetNode = getClosestInstanceFromNode(targetNode);
        if (null !== targetNode) {
            var nearestMounted = getNearestMountedFiber(targetNode);
            if (null === nearestMounted) targetNode = null;
            else {
                var tag = nearestMounted.tag;
                if (13 === tag) {
                    targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                    if (null !== targetNode) return targetNode;
                    targetNode = null;
                } else if (31 === tag) {
                    targetNode = getActivityInstanceFromFiber(nearestMounted);
                    if (null !== targetNode) return targetNode;
                    targetNode = null;
                } else if (3 === tag) {
                    if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                    targetNode = null;
                } else nearestMounted !== targetNode && (targetNode = null);
            }
        }
        return_targetInst = targetNode;
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            case "beforetoggle":
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "toggle":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                switch(getCurrentPriorityLevel()){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority$1:
                    case LowPriority:
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                queuedPointers.delete(nativeEvent.pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                queuedPointerCaptures.delete(nativeEvent.pointerId);
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        blockedOn = existingQueuedEvent.targetContainers;
        null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        switch(domEventName){
            case "focusin":
                return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "dragenter":
                return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "mouseover":
                return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "pointerover":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
                return !0;
            case "gotpointercapture":
                return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
        }
        return !1;
    }
    function attemptExplicitHydrationTarget(queuedTarget) {
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (null !== targetInst) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (null !== nearestMounted) {
                if (targetInst = nearestMounted.tag, 13 === targetInst) {
                    if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                        queuedTarget.blockedOn = targetInst;
                        runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (31 === targetInst) {
                    if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                        queuedTarget.blockedOn = targetInst;
                        runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                    queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                    return;
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (null !== queuedEvent.blockedOn) return !1;
        for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
            if (null === nextBlockedOn) {
                nextBlockedOn = queuedEvent.nativeEvent;
                var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn), event = nativeEventClone;
                null !== currentReplayingEvent && console.error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
                currentReplayingEvent = event;
                nextBlockedOn.target.dispatchEvent(nativeEventClone);
                null === currentReplayingEvent && console.error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
                currentReplayingEvent = null;
            } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
            targetContainers.shift();
        }
        return !0;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = !1;
        null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
        null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
        null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
    }
    function scheduleReplayQueueIfNeeded(formReplayingQueue) {
        lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
            lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
            for(var i = 0; i < formReplayingQueue.length; i += 3){
                var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
                if ("function" !== typeof submitterOrAction) {
                    if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                    else break;
                }
                var formInst = getInstanceFromNode(form);
                null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, form = {
                    pending: !0,
                    data: formData,
                    method: form.method,
                    action: submitterOrAction
                }, Object.freeze(form), startHostTransition(formInst, form, submitterOrAction, formData));
            }
        }));
    }
    function retryIfBlockedOn(unblocked) {
        function unblock(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        }
        null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
            var queuedTarget = queuedExplicitHydrationTargets[i];
            queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
        }
        for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
        i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
        if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
            var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
            if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
            else if (formProps) {
                var action = null;
                if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                    if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                    else {
                        if (null !== findInstanceBlockingTarget(form)) continue;
                    }
                } else action = formProps.action;
                "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
                scheduleReplayQueueIfNeeded(i);
            }
        }
    }
    function defaultOnDefaultTransitionIndicator() {
        function handleNavigate(event) {
            event.canIntercept && "react-transition" === event.info && event.intercept({
                handler: function() {
                    return new Promise(function(resolve) {
                        return pendingResolve = resolve;
                    });
                },
                focusReset: "manual",
                scroll: "manual"
            });
        }
        function handleNavigateComplete() {
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
            isCancelled || setTimeout(startFakeNavigation, 20);
        }
        function startFakeNavigation() {
            if (!isCancelled && !navigation.transition) {
                var currentEntry = navigation.currentEntry;
                currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                    state: currentEntry.getState(),
                    info: "react-transition",
                    history: "replace"
                });
            }
        }
        if ("object" === typeof navigation) {
            var isCancelled = !1, pendingResolve = null;
            navigation.addEventListener("navigate", handleNavigate);
            navigation.addEventListener("navigatesuccess", handleNavigateComplete);
            navigation.addEventListener("navigateerror", handleNavigateComplete);
            setTimeout(startFakeNavigation, 100);
            return function() {
                isCancelled = !0;
                navigation.removeEventListener("navigate", handleNavigate);
                navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
                navigation.removeEventListener("navigateerror", handleNavigateComplete);
                null !== pendingResolve && (pendingResolve(), pendingResolve = null);
            };
        }
    }
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function warnIfReactDOMContainerInDEV(container) {
        container[internalContainerInstanceKey] && (container._reactRootContainer ? console.error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : console.error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Scheduler = require("c31f9b99c1e288cf"), React = require("c4c4bc2113e5c77f"), ReactDOM = require("772d609564cfd8f6"), assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.tracing_marker");
    var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
    Symbol.for("react.view_transition");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, NotPending = Object.freeze({
        pending: !1,
        data: null,
        method: null,
        action: null
    }), valueStack = [];
    var fiberStack = [];
    var index$jscomp$0 = -1, contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null), disabledDepth = 0, prevLog, prevInfo, prevWarn, prevError, prevGroup, prevGroupCollapsed, prevGroupEnd;
    disabledLog.__reactDisabledLog = !0;
    var prefix, suffix, reentry = !1;
    var componentFrameCache = new ("function" === typeof WeakMap ? WeakMap : Map)();
    var current = null, isRendering = !1, hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now$1 = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null, hasLoggedError = !1, isDevToolsPresent = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__, clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2, nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304, DiscreteEventPriority = 2, ContinuousEventPriority = 8, DefaultEventPriority = 32, IdleEventPriority = 268435456, randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey, allNativeEvents = new Set(), registrationNameDependencies = {}, possibleRegistrationNames = {}, hasReadOnlyValue = {
        button: !0,
        checkbox: !0,
        image: !0,
        hidden: !0,
        radio: !0,
        reset: !0,
        submit: !0
    }, VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {}, escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g, didWarnValueDefaultValue$1 = !1, didWarnCheckedDefaultChecked = !1, didWarnSelectedSetOnOption = !1, didWarnInvalidChild = !1, didWarnInvalidInnerHTML = !1;
    var didWarnValueDefaultValue = !1;
    var valuePropNames = [
        "value",
        "defaultValue"
    ], didWarnValDefaultVal = !1, needsEscaping = /["'&<>\n\t]|^\s|\s$/, specialTags = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(" "), inScopeTags = "applet caption html table td th marquee object template foreignObject desc title".split(" "), buttonScopeTags = inScopeTags.concat([
        "button"
    ]), impliedEndTags = "dd dt li option optgroup p rp rt".split(" "), emptyAncestorInfoDev = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null,
        containerTagInScope: null,
        implicitRootScope: !1
    }, didWarn = {}, shorthandToLonghand = {
        animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(" "),
        background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(" "),
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(" "),
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(" "),
        fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(" "),
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(" "),
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(" "),
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    }, uppercasePattern = /([A-Z])/g, msPattern$1 = /^ms-/, badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, badStyleValueWithSemicolonPattern = /;\s*$/, warnedStyleNames = {}, warnedStyleValues = {}, warnedForNaNValue = !1, warnedForInfinityValue = !1, unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML", SVG_NAMESPACE = "http://www.w3.org/2000/svg", aliases = new Map([
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ],
        [
            "crossOrigin",
            "crossorigin"
        ],
        [
            "accentHeight",
            "accent-height"
        ],
        [
            "alignmentBaseline",
            "alignment-baseline"
        ],
        [
            "arabicForm",
            "arabic-form"
        ],
        [
            "baselineShift",
            "baseline-shift"
        ],
        [
            "capHeight",
            "cap-height"
        ],
        [
            "clipPath",
            "clip-path"
        ],
        [
            "clipRule",
            "clip-rule"
        ],
        [
            "colorInterpolation",
            "color-interpolation"
        ],
        [
            "colorInterpolationFilters",
            "color-interpolation-filters"
        ],
        [
            "colorProfile",
            "color-profile"
        ],
        [
            "colorRendering",
            "color-rendering"
        ],
        [
            "dominantBaseline",
            "dominant-baseline"
        ],
        [
            "enableBackground",
            "enable-background"
        ],
        [
            "fillOpacity",
            "fill-opacity"
        ],
        [
            "fillRule",
            "fill-rule"
        ],
        [
            "floodColor",
            "flood-color"
        ],
        [
            "floodOpacity",
            "flood-opacity"
        ],
        [
            "fontFamily",
            "font-family"
        ],
        [
            "fontSize",
            "font-size"
        ],
        [
            "fontSizeAdjust",
            "font-size-adjust"
        ],
        [
            "fontStretch",
            "font-stretch"
        ],
        [
            "fontStyle",
            "font-style"
        ],
        [
            "fontVariant",
            "font-variant"
        ],
        [
            "fontWeight",
            "font-weight"
        ],
        [
            "glyphName",
            "glyph-name"
        ],
        [
            "glyphOrientationHorizontal",
            "glyph-orientation-horizontal"
        ],
        [
            "glyphOrientationVertical",
            "glyph-orientation-vertical"
        ],
        [
            "horizAdvX",
            "horiz-adv-x"
        ],
        [
            "horizOriginX",
            "horiz-origin-x"
        ],
        [
            "imageRendering",
            "image-rendering"
        ],
        [
            "letterSpacing",
            "letter-spacing"
        ],
        [
            "lightingColor",
            "lighting-color"
        ],
        [
            "markerEnd",
            "marker-end"
        ],
        [
            "markerMid",
            "marker-mid"
        ],
        [
            "markerStart",
            "marker-start"
        ],
        [
            "overlinePosition",
            "overline-position"
        ],
        [
            "overlineThickness",
            "overline-thickness"
        ],
        [
            "paintOrder",
            "paint-order"
        ],
        [
            "panose-1",
            "panose-1"
        ],
        [
            "pointerEvents",
            "pointer-events"
        ],
        [
            "renderingIntent",
            "rendering-intent"
        ],
        [
            "shapeRendering",
            "shape-rendering"
        ],
        [
            "stopColor",
            "stop-color"
        ],
        [
            "stopOpacity",
            "stop-opacity"
        ],
        [
            "strikethroughPosition",
            "strikethrough-position"
        ],
        [
            "strikethroughThickness",
            "strikethrough-thickness"
        ],
        [
            "strokeDasharray",
            "stroke-dasharray"
        ],
        [
            "strokeDashoffset",
            "stroke-dashoffset"
        ],
        [
            "strokeLinecap",
            "stroke-linecap"
        ],
        [
            "strokeLinejoin",
            "stroke-linejoin"
        ],
        [
            "strokeMiterlimit",
            "stroke-miterlimit"
        ],
        [
            "strokeOpacity",
            "stroke-opacity"
        ],
        [
            "strokeWidth",
            "stroke-width"
        ],
        [
            "textAnchor",
            "text-anchor"
        ],
        [
            "textDecoration",
            "text-decoration"
        ],
        [
            "textRendering",
            "text-rendering"
        ],
        [
            "transformOrigin",
            "transform-origin"
        ],
        [
            "underlinePosition",
            "underline-position"
        ],
        [
            "underlineThickness",
            "underline-thickness"
        ],
        [
            "unicodeBidi",
            "unicode-bidi"
        ],
        [
            "unicodeRange",
            "unicode-range"
        ],
        [
            "unitsPerEm",
            "units-per-em"
        ],
        [
            "vAlphabetic",
            "v-alphabetic"
        ],
        [
            "vHanging",
            "v-hanging"
        ],
        [
            "vIdeographic",
            "v-ideographic"
        ],
        [
            "vMathematical",
            "v-mathematical"
        ],
        [
            "vectorEffect",
            "vector-effect"
        ],
        [
            "vertAdvY",
            "vert-adv-y"
        ],
        [
            "vertOriginX",
            "vert-origin-x"
        ],
        [
            "vertOriginY",
            "vert-origin-y"
        ],
        [
            "wordSpacing",
            "word-spacing"
        ],
        [
            "writingMode",
            "writing-mode"
        ],
        [
            "xmlnsXlink",
            "xmlns:xlink"
        ],
        [
            "xHeight",
            "x-height"
        ]
    ]), possibleStandardNames = {
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        fetchpriority: "fetchPriority",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        inert: "inert",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        popover: "popover",
        popovertarget: "popoverTarget",
        popovertargetaction: "popoverTargetAction",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        transformorigin: "transformOrigin",
        "transform-origin": "transformOrigin",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    }, ariaProperties = {
        "aria-current": 0,
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        "aria-hidden": 0,
        "aria-invalid": 0,
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0,
        "aria-braillelabel": 0,
        "aria-brailleroledescription": 0,
        "aria-colindextext": 0,
        "aria-rowindextext": 0
    }, warnedProperties$1 = {}, rARIA$1 = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), rARIACamel$1 = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), didWarnValueNull = !1, warnedProperties = {}, EVENT_NAME_REGEX = /^on./, INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/, rARIA = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), rARIACamel = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, currentReplayingEvent = null, restoreTarget = null, restoreQueue = null, isInsideEventHandler = !1, canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
    if (canUseDOM) try {
        var options$jscomp$0 = {};
        Object.defineProperty(options$jscomp$0, "passive", {
            get: function() {
                passiveBrowserEventsSupported = !0;
            }
        });
        window.addEventListener("test", options$jscomp$0, options$jscomp$0);
        window.removeEventListener("test", options$jscomp$0, options$jscomp$0);
    } catch (e) {
        passiveBrowserEventsSupported = !1;
    }
    var root = null, startText = null, fallbackText = null, EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
            return lastMovementX;
        },
        movementY: function(event) {
            return "movementY" in event ? event.movementY : lastMovementY;
        }
    }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    }), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), SyntheticInputEvent = SyntheticCompositionEvent, normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    }, translateToKey = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
    }, modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }, KeyboardEventInterface = assign({}, UIEventInterface, {
        key: function(nativeEvent) {
            if (nativeEvent.key) {
                var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
                if ("Unidentified" !== key) return key;
            }
            return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        charCode: function(event) {
            return "keypress" === event.type ? getEventCharCode(event) : 0;
        },
        keyCode: function(event) {
            return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
        },
        which: function(event) {
            return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
        }
    }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
    }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
        newState: 0,
        oldState: 0
    }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
        9,
        13,
        27,
        32
    ], START_KEYCODE = 229, canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
    canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CODE = 32, SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE), hasSpaceKeypress = !1, isComposing = !1, supportedInputTypes = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
    }, activeElement$1 = null, activeElementInst$1 = null, isInputEventSupported = !1;
    canUseDOM && (isInputEventSupported = isEventSupported("input") && (!document.documentMode || 9 < document.documentMode));
    var objectIs = "function" === typeof Object.is ? Object.is : is, skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1, vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionrun: makePrefixMap("Transition", "TransitionRun"),
        transitionstart: makePrefixMap("Transition", "TransitionStart"),
        transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    }, prefixedEventNames = {}, style = {};
    canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
    var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    simpleEventPluginEvents.push("scrollEnd");
    var lastResetTime = 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        var getCurrentTime = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        getCurrentTime = function() {
            return localDate.now();
        };
    }
    var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, OMITTED_PROP_ERROR = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", EMPTY_ARRAY = 0, COMPLEX_ARRAY = 1, PRIMITIVE_ARRAY = 2, ENTRIES_ARRAY = 3, REMOVED = "\u2013\u00a0", ADDED = "+\u00a0", UNCHANGED = "\u2007\u00a0", supportsUserTiming = "undefined" !== typeof console && "function" === typeof console.timeStamp && "undefined" !== typeof performance && "function" === typeof performance.measure, COMPONENTS_TRACK = "Components \u269b", LANES_TRACK_GROUP = "Scheduler \u269b", currentTrack = "Blocking", alreadyWarnedForDeepEquality = !1, reusableComponentDevToolDetails = {
        color: "primary",
        properties: null,
        tooltipText: "",
        track: COMPONENTS_TRACK
    }, reusableComponentOptions = {
        start: -0,
        end: -0,
        detail: {
            devtools: reusableComponentDevToolDetails
        }
    }, resuableChangedPropsEntry = [
        "Changed Props",
        ""
    ], DEEP_EQUALITY_WARNING = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", reusableDeeplyEqualPropsEntry = [
        "Changed Props",
        DEEP_EQUALITY_WARNING
    ], OffscreenVisible = 1, OffscreenPassiveEffectsConnected = 2, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0, emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var resolveFamily = null, failedBoundaries = null, NoMode = 0, ConcurrentMode = 1, ProfileMode = 2, StrictLegacyMode = 8, StrictEffectsMode = 16, SuspenseyImagesMode = 32;
    var hasBadMapPolyfill = !1;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    } catch (e$3) {
        hasBadMapPolyfill = !0;
    }
    var CapturedStacks = new WeakMap(), forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "", hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error("Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), valueCursor = createCursor(null);
    var rendererCursorDEV = createCursor(null);
    var rendererSigil = {};
    var currentlyRenderingFiber$1 = null, lastContextDependency = null, isDisallowedContextReadInDEV = !1, AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
        var listeners = [], signal = this.signal = {
            aborted: !1,
            addEventListener: function(type, listener) {
                listeners.push(listener);
            }
        };
        this.abort = function() {
            signal.aborted = !0;
            listeners.forEach(function(listener) {
                return listener();
            });
        };
    }, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0,
        _currentRenderer: null,
        _currentRenderer2: null
    }, now = Scheduler.unstable_now, createTask = console.createTask ? console.createTask : function() {
        return null;
    }, SPAWNED_UPDATE = 1, PINGED_UPDATE = 2, renderStartTime = -0, commitStartTime = -0, commitEndTime = -0, commitErrors = null, profilerStartTime = -1.1, profilerEffectDuration = -0, componentEffectDuration = -0, componentEffectStartTime = -1.1, componentEffectEndTime = -1.1, componentEffectErrors = null, componentEffectSpawnedUpdate = !1, blockingClampTime = -0, blockingUpdateTime = -1.1, blockingUpdateTask = null, blockingUpdateType = 0, blockingUpdateMethodName = null, blockingUpdateComponentName = null, blockingEventTime = -1.1, blockingEventType = null, blockingEventRepeatTime = -1.1, blockingSuspendedTime = -1.1, transitionClampTime = -0, transitionStartTime = -1.1, transitionUpdateTime = -1.1, transitionUpdateType = 0, transitionUpdateTask = null, transitionUpdateMethodName = null, transitionUpdateComponentName = null, transitionEventTime = -1.1, transitionEventType = null, transitionEventRepeatTime = -1.1, transitionSuspendedTime = -1.1, retryClampTime = -0, idleClampTime = -0, animatingLanes = 0, animatingTask = null, yieldReason = 0, yieldStartTime = -1.1, currentUpdateIsNested = !1, nestedUpdateScheduled = !1, currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null, prevOnStartTransitionFinish = ReactSharedInternals.S;
    ReactSharedInternals.S = function(transition, returnValue) {
        globalMostRecentTransitionTime = now$1();
        if ("object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then) {
            if (0 > transitionStartTime && 0 > transitionUpdateTime) {
                transitionStartTime = now();
                var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
                if (newEventTime !== transitionEventRepeatTime || newEventType !== transitionEventType) transitionEventRepeatTime = -1.1;
                transitionEventTime = newEventTime;
                transitionEventType = newEventType;
            }
            entangleAsyncAction(transition, returnValue);
        }
        null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
    };
    var resumedCache = createCursor(null), ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function() {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function() {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    }, pendingComponentWillMountWarnings = [], pendingUNSAFE_ComponentWillMountWarnings = [], pendingComponentWillReceivePropsWarnings = [], pendingUNSAFE_ComponentWillReceivePropsWarnings = [], pendingComponentWillUpdateWarnings = [], pendingUNSAFE_ComponentWillUpdateWarnings = [], didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        didWarnAboutUnsafeLifecycles.has(fiber.type) || ("function" === typeof instance.componentWillMount && !0 !== instance.componentWillMount.__suppressDeprecationWarning && pendingComponentWillMountWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillMount && pendingUNSAFE_ComponentWillMountWarnings.push(fiber), "function" === typeof instance.componentWillReceiveProps && !0 !== instance.componentWillReceiveProps.__suppressDeprecationWarning && pendingComponentWillReceivePropsWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillReceiveProps && pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber), "function" === typeof instance.componentWillUpdate && !0 !== instance.componentWillUpdate.__suppressDeprecationWarning && pendingComponentWillUpdateWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillUpdate && pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber));
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        var componentWillMountUniqueNames = new Set();
        0 < pendingComponentWillMountWarnings.length && (pendingComponentWillMountWarnings.forEach(function(fiber) {
            componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillMountWarnings = []);
        var UNSAFE_componentWillMountUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillMountWarnings.length && (pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
            UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillMountWarnings = []);
        var componentWillReceivePropsUniqueNames = new Set();
        0 < pendingComponentWillReceivePropsWarnings.length && (pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
            componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillReceivePropsWarnings = []);
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillReceivePropsWarnings.length && (pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
            UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillReceivePropsWarnings = []);
        var componentWillUpdateUniqueNames = new Set();
        0 < pendingComponentWillUpdateWarnings.length && (pendingComponentWillUpdateWarnings.forEach(function(fiber) {
            componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillUpdateWarnings = []);
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillUpdateWarnings.length && (pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
            UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillUpdateWarnings = []);
        if (0 < UNSAFE_componentWillMountUniqueNames.size) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            console.error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        0 < UNSAFE_componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames), console.error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n\nPlease update the following components: %s", sortedNames));
        0 < UNSAFE_componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(UNSAFE_componentWillUpdateUniqueNames), console.error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillMountUniqueNames.size && (sortedNames = setToSortedString(componentWillMountUniqueNames), console.warn("componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(componentWillReceivePropsUniqueNames), console.warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(componentWillUpdateUniqueNames), console.warn("componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
    };
    var pendingLegacyContextWarning = new Map(), didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = null;
        for(var node = fiber; null !== node;)node.mode & StrictLegacyMode && (strictRoot = node), node = node.return;
        null === strictRoot ? console.error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.") : !didWarnAboutLegacyContext.has(fiber.type) && (node = pendingLegacyContextWarning.get(strictRoot), null != fiber.type.contextTypes || null != fiber.type.childContextTypes || null !== instance && "function" === typeof instance.getChildContext) && (void 0 === node && (node = [], pendingLegacyContextWarning.set(strictRoot, node)), node.push(fiber));
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray) {
            if (0 !== fiberArray.length) {
                var firstFiber = fiberArray[0], uniqueNames = new Set();
                fiberArray.forEach(function(fiber) {
                    uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                    didWarnAboutLegacyContext.add(fiber.type);
                });
                var sortedNames = setToSortedString(uniqueNames);
                runWithFiberInDEV(firstFiber, function() {
                    console.error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://react.dev/link/legacy-context", sortedNames);
                });
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var callComponent = {
        react_stack_bottom_frame: function(Component, props, secondArg) {
            var wasRendering = isRendering;
            isRendering = !0;
            try {
                return Component(props, secondArg);
            } finally{
                isRendering = wasRendering;
            }
        }
    }, callComponentInDEV = callComponent.react_stack_bottom_frame.bind(callComponent), callRender = {
        react_stack_bottom_frame: function(instance) {
            var wasRendering = isRendering;
            isRendering = !0;
            try {
                return instance.render();
            } finally{
                isRendering = wasRendering;
            }
        }
    }, callRenderInDEV = callRender.react_stack_bottom_frame.bind(callRender), callComponentDidMount = {
        react_stack_bottom_frame: function(finishedWork, instance) {
            try {
                instance.componentDidMount();
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }, callComponentDidMountInDEV = callComponentDidMount.react_stack_bottom_frame.bind(callComponentDidMount), callComponentDidUpdate = {
        react_stack_bottom_frame: function(finishedWork, instance, prevProps, prevState, snapshot) {
            try {
                instance.componentDidUpdate(prevProps, prevState, snapshot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }, callComponentDidUpdateInDEV = callComponentDidUpdate.react_stack_bottom_frame.bind(callComponentDidUpdate), callComponentDidCatch = {
        react_stack_bottom_frame: function(instance, errorInfo) {
            var stack = errorInfo.stack;
            instance.componentDidCatch(errorInfo.value, {
                componentStack: null !== stack ? stack : ""
            });
        }
    }, callComponentDidCatchInDEV = callComponentDidCatch.react_stack_bottom_frame.bind(callComponentDidCatch), callComponentWillUnmount = {
        react_stack_bottom_frame: function(current, nearestMountedAncestor, instance) {
            try {
                instance.componentWillUnmount();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            }
        }
    }, callComponentWillUnmountInDEV = callComponentWillUnmount.react_stack_bottom_frame.bind(callComponentWillUnmount), callCreate = {
        react_stack_bottom_frame: function(effect) {
            var create = effect.create;
            effect = effect.inst;
            create = create();
            return effect.destroy = create;
        }
    }, callCreateInDEV = callCreate.react_stack_bottom_frame.bind(callCreate), callDestroy = {
        react_stack_bottom_frame: function(current, nearestMountedAncestor, destroy) {
            try {
                destroy();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            }
        }
    }, callDestroyInDEV = callDestroy.react_stack_bottom_frame.bind(callDestroy), callLazyInit = {
        react_stack_bottom_frame: function(lazy) {
            var init = lazy._init;
            return init(lazy._payload);
        }
    }, callLazyInitInDEV = callLazyInit.react_stack_bottom_frame.bind(callLazyInit), SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."), SuspenseyCommitException = Error("Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), SuspenseActionException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."), noopSuspenseyCommitThenable = {
        then: function() {
            console.error('Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.');
        }
    }, suspendedThenable = null, needsToResetSuspendedThenableDEV = !1, thenableState$1 = null, thenableIndexCounter$1 = 0, currentDebugInfo = null, didWarnAboutMaps;
    var didWarnAboutGenerators = didWarnAboutMaps = !1;
    var ownerHasKeyUseWarning = {};
    var ownerHasFunctionTypeWarning = {};
    var ownerHasSymbolTypeWarning = {};
    warnForMissingKey = function(returnFiber, workInProgress, child) {
        if (null !== child && "object" === typeof child && child._store && (!child._store.validated && null == child.key || 2 === child._store.validated)) {
            if ("object" !== typeof child._store) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
            child._store.validated = 1;
            var componentName = getComponentNameFromFiber(returnFiber), componentKey = componentName || "null";
            if (!ownerHasKeyUseWarning[componentKey]) {
                ownerHasKeyUseWarning[componentKey] = !0;
                child = child._owner;
                returnFiber = returnFiber._debugOwner;
                var currentComponentErrorInfo = "";
                returnFiber && "number" === typeof returnFiber.tag && (componentKey = getComponentNameFromFiber(returnFiber)) && (currentComponentErrorInfo = "\n\nCheck the render method of `" + componentKey + "`.");
                currentComponentErrorInfo || componentName && (currentComponentErrorInfo = "\n\nCheck the top-level render call using <" + componentName + ">.");
                var childOwnerAppendix = "";
                null != child && returnFiber !== child && (componentName = null, "number" === typeof child.tag ? componentName = getComponentNameFromFiber(child) : "string" === typeof child.name && (componentName = child.name), componentName && (childOwnerAppendix = " It was passed a child from " + componentName + "."));
                runWithFiberInDEV(workInProgress, function() {
                    console.error('Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.', currentComponentErrorInfo, childOwnerAppendix);
                });
            }
        }
    };
    var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), UpdateState = 0, ReplaceState = 1, ForceUpdate = 2, CaptureUpdate = 3, hasForceUpdate = !1;
    var didWarnUpdateInsideUpdate = !1;
    var currentlyProcessingQueue = null;
    var didReadFromEntangledAsyncAction = !1, currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null, SubtreeSuspenseContextMask = 1, ForceSuspenseFallback = 2, suspenseStackCursor = createCursor(0), NoFlags = 0, HasEffect = 1, Insertion = 2, Layout = 4, Passive = 8, didWarnUncachedGetSnapshot;
    var didWarnAboutMismatchedHooksForComponent = new Set();
    var didWarnAboutUseWrappedInTryCatch = new Set();
    var didWarnAboutAsyncClientComponent = new Set();
    var didWarnAboutUseFormState = new Set();
    var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0, RE_RENDER_LIMIT = 25, currentHookNameInDev = null, hookTypesDev = null, hookTypesUpdateIndexDev = -1, ignorePreviousDependencies = !1, ContextOnlyDispatcher = {
        readContext: readContext,
        use: use,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        useHostTransitionStatus: throwInvalidHookError,
        useFormState: throwInvalidHookError,
        useActionState: throwInvalidHookError,
        useOptimistic: throwInvalidHookError,
        useMemoCache: throwInvalidHookError,
        useCacheRefresh: throwInvalidHookError
    };
    ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
    var HooksDispatcherOnMountInDEV = null, HooksDispatcherOnMountWithHookTypesInDEV = null, HooksDispatcherOnUpdateInDEV = null, HooksDispatcherOnRerenderInDEV = null, InvalidNestedHooksDispatcherOnMountInDEV = null, InvalidNestedHooksDispatcherOnUpdateInDEV = null, InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            mountHookTypesDev();
            warnOnUseFormStateInDev();
            return mountActionState(action, initialState);
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            mountHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            mountHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            mountHookTypesDev();
            return mountEvent(callback);
        }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return mountActionState(action, initialState);
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return mountEvent(callback);
        }
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return updateActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return updateActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return updateOptimistic(passthrough, reducer);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return rerenderActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return rerenderOptimistic(passthrough, reducer);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            mountHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateOptimistic(passthrough, reducer);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderOptimistic(passthrough, reducer);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent = new Set();
    var didWarnAboutUninitializedState = new Set();
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    var didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    var didWarnAboutDirectlyAssigningPropsToState = new Set();
    var didWarnAboutUndefinedDerivedState = new Set();
    var didWarnAboutContextTypes$1 = new Set();
    var didWarnAboutChildContextTypes = new Set();
    var didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    Object.freeze(fakeInternalInstance);
    var classComponentUpdater = {
        enqueueSetState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.payload = payload;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (startUpdateTimerByLane(lane, "this.setState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueReplaceState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.tag = ReplaceState;
            update.payload = payload;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (startUpdateTimerByLane(lane, "this.replaceState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueForceUpdate: function(inst, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.tag = ForceUpdate;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            callback = enqueueUpdate(inst, update, lane);
            null !== callback && (startUpdateTimerByLane(lane, "this.forceUpdate()", inst), scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
        }
    }, componentName = null, errorBoundaryName = null, SelectiveHydrationException = Error("This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."), didReceiveUpdate = !1;
    var didWarnAboutBadClass = {};
    var didWarnAboutContextTypeOnFunctionComponent = {};
    var didWarnAboutContextTypes = {};
    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
    var didWarnAboutReassigningProps = !1;
    var didWarnAboutRevealOrder = {};
    var didWarnAboutTailOptions = {};
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0,
        hydrationErrors: null
    }, hasWarnedAboutUsingNoValuePropOnContextProvider = !1, didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, inProgressLanes = null, inProgressRoot = null, hostParent = null, hostParentIsContainer = !1, currentHoistableRoot = null, inHydratedSubtree = !1, suspenseyCommitFlag = 8192, DefaultAsyncDispatcher = {
        getCacheForType: function(resourceType) {
            var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
            void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
            return cacheForType;
        },
        cacheSignal: function() {
            return readContext(CacheContext).controller.signal;
        },
        getOwner: function() {
            return current;
        }
    };
    if ("function" === typeof Symbol && Symbol.for) {
        var symbolFor = Symbol.for;
        symbolFor("selector.component");
        symbolFor("selector.has_pseudo_class");
        symbolFor("selector.role");
        symbolFor("selector.test_id");
        symbolFor("selector.text");
    }
    var commitHooks = [], PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, NoContext = 0, RenderContext = 2, CommitContext = 4, RootInProgress = 0, RootFatalErrored = 1, RootErrored = 2, RootSuspended = 3, RootSuspendedWithDelay = 4, RootSuspendedAtTheShell = 6, RootCompleted = 5, executionContext = NoContext, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, NotSuspended = 0, SuspendedOnError = 1, SuspendedOnData = 2, SuspendedOnImmediate = 3, SuspendedOnInstance = 4, SuspendedOnInstanceAndReadyToContinue = 5, SuspendedOnDeprecatedThrowPromise = 6, SuspendedAndReadyToContinue = 7, SuspendedOnHydration = 8, SuspendedOnAction = 9, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = RootInProgress, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, FALLBACK_THROTTLE_MS = 300, workInProgressRootRenderTargetTime = Infinity, RENDER_TIMEOUT_MS = 500, workInProgressTransitions = null, workInProgressUpdateTask = null, legacyErrorBoundariesThatAlreadyFailed = null, IMMEDIATE_COMMIT = 0, ABORTED_VIEW_TRANSITION_COMMIT = 1, DELAYED_PASSIVE_COMMIT = 2, ANIMATION_STARTED_COMMIT = 3, NO_PENDING_EFFECTS = 0, PENDING_MUTATION_PHASE = 1, PENDING_LAYOUT_PHASE = 2, PENDING_AFTER_MUTATION_PHASE = 3, PENDING_SPAWNED_WORK = 4, PENDING_PASSIVE_PHASE = 5, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingEffectsRenderEndTime = -0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, pendingSuspendedCommitReason = null, pendingDelayedCommitReason = IMMEDIATE_COMMIT, pendingSuspendedViewTransitionReason = null, NESTED_UPDATE_LIMIT = 50, nestedUpdateCount = 0, rootWithNestedUpdates = null, isFlushingPassiveEffects = !1, didScheduleUpdateDuringPassiveEffects = !1, NESTED_PASSIVE_UPDATE_LIMIT = 50, nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, isRunningInsertionEffect = !1, didWarnStateUpdateForNotYetMountedComponent = null, didWarnAboutUpdateInRender = !1;
    var didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    var fakeActCallbackNode$1 = {}, firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, didScheduleMicrotask_act = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0, fakeActCallbackNode = {};
    (function() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i], domEventName = eventName.toLowerCase();
            eventName = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + eventName);
        }
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
        registerSimpleEvent(TRANSITION_START, "onTransitionStart");
        registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    })();
    registerDirectEvent("onMouseEnter", [
        "mouseout",
        "mouseover"
    ]);
    registerDirectEvent("onMouseLeave", [
        "mouseout",
        "mouseover"
    ]);
    registerDirectEvent("onPointerEnter", [
        "pointerout",
        "pointerover"
    ]);
    registerDirectEvent("onPointerLeave", [
        "pointerout",
        "pointerover"
    ]);
    registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
    registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
    registerTwoPhaseEvent("onBeforeInput", [
        "compositionend",
        "keypress",
        "textInput",
        "paste"
    ]);
    registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
    registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
    registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)), listeningMarker = "_reactListening" + Math.random().toString(36).slice(2), didWarnControlledToUncontrolled = !1, didWarnUncontrolledToControlled = !1, didWarnFormActionType = !1, didWarnFormActionName = !1, didWarnFormActionTarget = !1, didWarnFormActionMethod = !1, didWarnPopoverTargetObject = !1;
    var didWarnForNewBooleanPropsWithEmptyValue = {};
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g, xlinkNamespace = "http://www.w3.org/1999/xlink", xmlNamespace = "http://www.w3.org/XML/1998/namespace", EXPECTED_FORM_ACTION_URL = "javascript:throw new Error('React form unexpectedly submitted.')", SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning", ACTIVITY_START_DATA = "&", ACTIVITY_END_DATA = "/&", SUSPENSE_START_DATA = "$", SUSPENSE_END_DATA = "/$", SUSPENSE_PENDING_START_DATA = "$?", SUSPENSE_QUEUED_START_DATA = "$~", SUSPENSE_FALLBACK_START_DATA = "$!", PREAMBLE_CONTRIBUTION_HTML = "html", PREAMBLE_CONTRIBUTION_BODY = "body", PREAMBLE_CONTRIBUTION_HEAD = "head", FORM_STATE_IS_MATCHING = "F!", FORM_STATE_IS_NOT_MATCHING = "F", DOCUMENT_READY_STATE_LOADING = "loading", STYLE = "style", HostContextNamespaceNone = 0, HostContextNamespaceSvg = 1, HostContextNamespaceMath = 2, eventsEnabled = null, selectionInformation = null, warnedUnknownTags = {
        dialog: !0,
        webview: !0
    }, currentPopstateTransitionEvent = null, schedulerEvent = void 0, scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, noTimeout = -1, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout, previousHydratableOnEnteringScopedSingleton = null, NotLoaded = 0, Loaded = 1, Errored = 2, Settled = 3, Inserted = 4, preloadPropsMap = new Map(), preconnectsSet = new Set(), previousDispatcher = ReactDOMSharedInternals.d;
    ReactDOMSharedInternals.d = {
        f: function() {
            var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
            return previousWasRendering || wasRendering;
        },
        r: function(form) {
            var formInst = getInstanceFromNode(form);
            null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
        },
        D: function(href) {
            previousDispatcher.D(href);
            preconnectAs("dns-prefetch", href, null);
        },
        C: function(href, crossOrigin) {
            previousDispatcher.C(href, crossOrigin);
            preconnectAs("preconnect", href, crossOrigin);
        },
        L: function(href, as, options) {
            previousDispatcher.L(href, as, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href && as) {
                var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
                "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
                var key = preloadSelector;
                switch(as){
                    case "style":
                        key = getStyleKey(href);
                        break;
                    case "script":
                        key = getScriptKey(href);
                }
                preloadPropsMap.has(key) || (href = assign({
                    rel: "preload",
                    href: "image" === as && options && options.imageSrcSet ? void 0 : href,
                    as: as
                }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
            }
        },
        m: function(href, options) {
            previousDispatcher.m(href, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href) {
                var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
                switch(as){
                    case "audioworklet":
                    case "paintworklet":
                    case "serviceworker":
                    case "sharedworker":
                    case "worker":
                    case "script":
                        key = getScriptKey(href);
                }
                if (!preloadPropsMap.has(key) && (href = assign({
                    rel: "modulepreload",
                    href: href
                }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
                    switch(as){
                        case "audioworklet":
                        case "paintworklet":
                        case "serviceworker":
                        case "sharedworker":
                        case "worker":
                        case "script":
                            if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
                    }
                    as = ownerDocument.createElement("link");
                    setInitialProperties(as, "link", href);
                    markNodeAsHoistable(as);
                    ownerDocument.head.appendChild(as);
                }
            }
        },
        X: function(src, options) {
            previousDispatcher.X(src, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && src) {
                var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
                resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
                    src: src,
                    async: !0
                }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
                    type: "script",
                    instance: resource,
                    count: 1,
                    state: null
                }, scripts.set(key, resource));
            }
        },
        S: function(href, precedence, options) {
            previousDispatcher.S(href, precedence, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href) {
                var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
                precedence = precedence || "default";
                var resource = styles.get(key);
                if (!resource) {
                    var state = {
                        loading: NotLoaded,
                        preload: null
                    };
                    if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = Loaded | Inserted;
                    else {
                        href = assign({
                            rel: "stylesheet",
                            href: href,
                            "data-precedence": precedence
                        }, options);
                        (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                        var link = resource = ownerDocument.createElement("link");
                        markNodeAsHoistable(link);
                        setInitialProperties(link, "link", href);
                        link._p = new Promise(function(resolve, reject) {
                            link.onload = resolve;
                            link.onerror = reject;
                        });
                        link.addEventListener("load", function() {
                            state.loading |= Loaded;
                        });
                        link.addEventListener("error", function() {
                            state.loading |= Errored;
                        });
                        state.loading |= Inserted;
                        insertStylesheet(resource, precedence, ownerDocument);
                    }
                    resource = {
                        type: "stylesheet",
                        instance: resource,
                        count: 1,
                        state: state
                    };
                    styles.set(key, resource);
                }
            }
        },
        M: function(src, options) {
            previousDispatcher.M(src, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && src) {
                var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
                resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
                    src: src,
                    async: !0,
                    type: "module"
                }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
                    type: "script",
                    instance: resource,
                    count: 1,
                    state: null
                }, scripts.set(key, resource));
            }
        }
    };
    var globalDocument = "undefined" === typeof document ? null : document, tagCaches = null, SUSPENSEY_STYLESHEET_TIMEOUT = 6e4, SUSPENSEY_IMAGE_TIMEOUT = 800, SUSPENSEY_IMAGE_TIME_ESTIMATE = 500, estimatedBytesWithinLimit = 0, LAST_PRECEDENCE = null, precedencesByRoot = null, NotPendingTransition = NotPending, HostTransitionContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Provider: null,
        Consumer: null,
        _currentValue: NotPendingTransition,
        _currentValue2: NotPendingTransition,
        _threadCount: 0
    }, badgeFormat = "%c%s%c", badgeStyle = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", resetStyle = "", pad = " ", bind = Function.prototype.bind;
    var didWarnAboutNestedUpdates = !1;
    var overrideHookState = null, overrideHookStateDeletePath = null, overrideHookStateRenamePath = null, overrideProps = null, overridePropsDeletePath = null, overridePropsRenamePath = null, scheduleUpdate = null, scheduleRetry = null, setErrorHandler = null, setSuspenseHandler = null;
    overrideHookState = function(fiber, id, path, value) {
        id = findHook(fiber, id);
        null !== id && (path = copyWithSetImpl(id.memoizedState, path, 0, value), id.memoizedState = path, id.baseState = path, fiber.memoizedProps = assign({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        id = findHook(fiber, id);
        null !== id && (path = copyWithDeleteImpl(id.memoizedState, path, 0), id.memoizedState = path, id.baseState = path, fiber.memoizedProps = assign({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        id = findHook(fiber, id);
        null !== id && (oldPath = copyWithRename(id.memoizedState, oldPath, newPath), id.memoizedState = oldPath, id.baseState = oldPath, fiber.memoizedProps = assign({}, fiber.memoizedProps), oldPath = enqueueConcurrentRenderForLane(fiber, 2), null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2));
    };
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSetImpl(fiber.memoizedProps, path, 0, value);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        path = enqueueConcurrentRenderForLane(fiber, 2);
        null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDeleteImpl(fiber.memoizedProps, path, 0);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        path = enqueueConcurrentRenderForLane(fiber, 2);
        null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        oldPath = enqueueConcurrentRenderForLane(fiber, 2);
        null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    };
    scheduleRetry = function(fiber) {
        var lane = claimNextRetryLane(), root = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    var _enabled = !0, return_targetInst = null, hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" "), lastScheduledReplayQueue = null;
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (null === root) throw Error("Cannot update an unmounted root.");
        var args = arguments;
        "function" === typeof args[1] ? console.error("does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : isValidContainer(args[1]) ? console.error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : "undefined" !== typeof args[1] && console.error("You passed a second argument to root.render(...) but it only accepts one argument.");
        args = children;
        var current = root.current, lane = requestUpdateLane(current);
        updateContainerImpl(current, lane, args, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        var args = arguments;
        "function" === typeof args[0] && console.error("does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        args = this._internalRoot;
        if (null !== args) {
            this._internalRoot = null;
            var container = args.containerInfo;
            (executionContext & (RenderContext | CommitContext)) !== NoContext && console.error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            updateContainerImpl(args.current, 2, null, args, null, null);
            flushSyncWork$1();
            container[internalContainerInstanceKey] = null;
        }
    };
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
        if (target) {
            var updatePriority = resolveUpdatePriority();
            target = {
                blockedOn: null,
                target: target,
                priority: updatePriority
            };
            for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
            queuedExplicitHydrationTargets.splice(i, 0, target);
            0 === i && attemptExplicitHydrationTarget(target);
        }
    };
    (function() {
        var isomorphicReactPackageVersion = React.version;
        if ("19.2.6" !== isomorphicReactPackageVersion) throw Error('Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:\n  - react:      ' + (isomorphicReactPackageVersion + "\n  - react-dom:  19.2.6\nLearn more: https://react.dev/warnings/version-mismatch"));
    })();
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills");
    ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
        var fiber = componentOrElement._reactInternals;
        if (void 0 === fiber) {
            if ("function" === typeof componentOrElement.render) throw Error("Unable to find node on an unmounted component.");
            componentOrElement = Object.keys(componentOrElement).join(",");
            throw Error("Argument appears to not be a ReactComponent. Keys: " + componentOrElement);
        }
        componentOrElement = findCurrentFiberUsingSlowPath(fiber);
        componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
        componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
        return componentOrElement;
    };
    if (!function() {
        var internals = {
            bundleType: 1,
            version: "19.2.6",
            rendererPackageName: "react-dom",
            currentDispatcherRef: ReactSharedInternals,
            reconcilerVersion: "19.2.6"
        };
        internals.overrideHookState = overrideHookState;
        internals.overrideHookStateDeletePath = overrideHookStateDeletePath;
        internals.overrideHookStateRenamePath = overrideHookStateRenamePath;
        internals.overrideProps = overrideProps;
        internals.overridePropsDeletePath = overridePropsDeletePath;
        internals.overridePropsRenamePath = overridePropsRenamePath;
        internals.scheduleUpdate = scheduleUpdate;
        internals.scheduleRetry = scheduleRetry;
        internals.setErrorHandler = setErrorHandler;
        internals.setSuspenseHandler = setSuspenseHandler;
        internals.scheduleRefresh = scheduleRefresh;
        internals.scheduleRoot = scheduleRoot;
        internals.setRefreshHandler = setRefreshHandler;
        internals.getCurrentFiber = getCurrentFiberForDevTools;
        return injectInternals(internals);
    }() && canUseDOM && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && -1 === navigator.userAgent.indexOf("Edge") || -1 < navigator.userAgent.indexOf("Firefox"))) {
        var protocol = window.location.protocol;
        /^(https?|file):$/.test(protocol) && console.info("%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + ("file:" === protocol ? "\nYou might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq" : ""), "font-weight:bold");
    }
    exports.createRoot = function(container, options) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
        null !== options && void 0 !== options && (options.hydrate ? console.warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : "object" === typeof options && null !== options && options.$$typeof === REACT_ELEMENT_TYPE && console.error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"), !0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
        options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
        container[internalContainerInstanceKey] = options.current;
        listenToAllSupportedEvents(container);
        return new ReactDOMRoot(options);
    };
    exports.hydrateRoot = function(container, initialChildren, options) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        void 0 === initialChildren && console.error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
        null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
        initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
        initialChildren.context = getContextForSubtree(null);
        options = initialChildren.current;
        isStrictMode = requestUpdateLane(options);
        isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
        identifierPrefix = createUpdate(isStrictMode);
        identifierPrefix.callback = null;
        enqueueUpdate(options, identifierPrefix, isStrictMode);
        startUpdateTimerByLane(isStrictMode, "hydrateRoot()", null);
        options = isStrictMode;
        initialChildren.current.lanes = options;
        markRootUpdated$1(initialChildren, options);
        ensureRootIsScheduled(initialChildren);
        container[internalContainerInstanceKey] = initialChildren.current;
        listenToAllSupportedEvents(container);
        return new ReactDOMHydrationRoot(initialChildren);
    };
    exports.version = "19.2.6";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

},{"c31f9b99c1e288cf":"8TbwE","c4c4bc2113e5c77f":"2o0ib","772d609564cfd8f6":"6WJHP"}],"8TbwE":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("ef03b89c8fe2794e");

},{"ef03b89c8fe2794e":"5Ykmo"}],"5Ykmo":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function performWorkUntilDeadline() {
        needsPaint = !1;
        if (isMessageLoopRunning) {
            var currentTime = exports.unstable_now();
            startTime = currentTime;
            var hasMoreWork = !0;
            try {
                a: {
                    isHostCallbackScheduled = !1;
                    isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                    isPerformingWork = !0;
                    var previousPriorityLevel = currentPriorityLevel;
                    try {
                        b: {
                            advanceTimers(currentTime);
                            for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                                var callback = currentTask.callback;
                                if ("function" === typeof callback) {
                                    currentTask.callback = null;
                                    currentPriorityLevel = currentTask.priorityLevel;
                                    var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                    currentTime = exports.unstable_now();
                                    if ("function" === typeof continuationCallback) {
                                        currentTask.callback = continuationCallback;
                                        advanceTimers(currentTime);
                                        hasMoreWork = !0;
                                        break b;
                                    }
                                    currentTask === peek(taskQueue) && pop(taskQueue);
                                    advanceTimers(currentTime);
                                } else pop(taskQueue);
                                currentTask = peek(taskQueue);
                            }
                            if (null !== currentTask) hasMoreWork = !0;
                            else {
                                var firstTimer = peek(timerQueue);
                                null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                                hasMoreWork = !1;
                            }
                        }
                        break a;
                    } finally{
                        currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                    }
                    hasMoreWork = void 0;
                }
            } finally{
                hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
            }
        }
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        a: for(; 0 < index;){
            var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
            if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
            else break a;
        }
    }
    function peek(heap) {
        return 0 === heap.length ? null : heap[0];
    }
    function pop(heap) {
        if (0 === heap.length) return null;
        var first = heap[0], last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
                var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
                if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
                else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
                else break a;
            }
        }
        return first;
    }
    function compare(a, b) {
        var diff = a.sortIndex - b.sortIndex;
        return 0 !== diff ? diff : a.id - b.id;
    }
    function advanceTimers(currentTime) {
        for(var timer = peek(timerQueue); null !== timer;){
            if (null === timer.callback) pop(timerQueue);
            else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
            else break;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = !1;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
            else {
                var firstTimer = peek(timerQueue);
                null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function shouldYieldToHost() {
        return needsPaint ? !0 : exports.unstable_now() - startTime < frameInterval ? !1 : !0;
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback(exports.unstable_now());
        }, ms);
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    exports.unstable_now = void 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        exports.unstable_now = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date, initialTime = localDate.now();
        exports.unstable_now = function() {
            return localDate.now() - initialTime;
        };
    }
    var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null, isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
    if ("function" === typeof localSetImmediate) var schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if ("undefined" !== typeof MessageChannel) {
        var channel = new MessageChannel(), port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    exports.unstable_IdlePriority = 5;
    exports.unstable_ImmediatePriority = 1;
    exports.unstable_LowPriority = 4;
    exports.unstable_NormalPriority = 3;
    exports.unstable_Profiling = null;
    exports.unstable_UserBlockingPriority = 2;
    exports.unstable_cancelCallback = function(task) {
        task.callback = null;
    };
    exports.unstable_forceFrameRate = function(fps) {
        0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
    };
    exports.unstable_getCurrentPriorityLevel = function() {
        return currentPriorityLevel;
    };
    exports.unstable_next = function(eventHandler) {
        switch(currentPriorityLevel){
            case 1:
            case 2:
            case 3:
                var priorityLevel = 3;
                break;
            default:
                priorityLevel = currentPriorityLevel;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
    exports.unstable_requestPaint = function() {
        needsPaint = !0;
    };
    exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            default:
                priorityLevel = 3;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
    exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
        var currentTime = exports.unstable_now();
        "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
        switch(priorityLevel){
            case 1:
                var timeout = -1;
                break;
            case 2:
                timeout = 250;
                break;
            case 5:
                timeout = 1073741823;
                break;
            case 4:
                timeout = 1e4;
                break;
            default:
                timeout = 5e3;
        }
        timeout = options + timeout;
        priorityLevel = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: options,
            expirationTime: timeout,
            sortIndex: -1
        };
        options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
        return priorityLevel;
    };
    exports.unstable_shouldYield = shouldYieldToHost;
    exports.unstable_wrapCallback = function(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

},{}],"6WJHP":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}
module.exports = require("b0f0e6b9e8349dac");

},{"b0f0e6b9e8349dac":"7jsdf"}],"7jsdf":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function noop() {}
    function testStringCoercion(value) {
        return "" + value;
    }
    function createPortal$1(children, containerInfo, implementation) {
        var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        try {
            testStringCoercion(key);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        JSCompiler_inline_result && (console.error("The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", "function" === typeof Symbol && Symbol.toStringTag && key[Symbol.toStringTag] || key.constructor.name || "Object"), testStringCoercion(key));
        return {
            $$typeof: REACT_PORTAL_TYPE,
            key: null == key ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    function getCrossOriginStringAs(as, input) {
        if ("font" === as) return "";
        if ("string" === typeof input) return "use-credentials" === input ? input : "";
    }
    function getValueDescriptorExpectingObjectForWarning(thing) {
        return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : 'something with type "' + typeof thing + '"';
    }
    function getValueDescriptorExpectingEnumForWarning(thing) {
        return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : "string" === typeof thing ? JSON.stringify(thing) : "number" === typeof thing ? "`" + thing + "`" : 'something with type "' + typeof thing + '"';
    }
    function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = require("6f0162e9ab224cd4"), Internals = {
        d: {
            f: noop,
            r: function() {
                throw Error("Invalid form element. requestFormReset must be passed a form that was rendered by React.");
            },
            D: noop,
            C: noop,
            L: noop,
            m: noop,
            X: noop,
            S: noop,
            M: noop
        },
        p: 0,
        findDOMNode: null
    }, REACT_PORTAL_TYPE = Symbol.for("react.portal"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
    exports.createPortal = function(children, container) {
        var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
        if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error("Target container is not a DOM element.");
        return createPortal$1(children, container, null, key);
    };
    exports.flushSync = function(fn) {
        var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
        try {
            if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
        } finally{
            ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f() && console.error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        }
    };
    exports.preconnect = function(href, options) {
        "string" === typeof href && href ? null != options && "object" !== typeof options ? console.error("ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.", getValueDescriptorExpectingEnumForWarning(options)) : null != options && "string" !== typeof options.crossOrigin && console.error("ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.", getValueDescriptorExpectingObjectForWarning(options.crossOrigin)) : console.error("ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
    };
    exports.prefetchDNS = function(href) {
        if ("string" !== typeof href || !href) console.error("ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        else if (1 < arguments.length) {
            var options = arguments[1];
            "object" === typeof options && options.hasOwnProperty("crossOrigin") ? console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options)) : console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options));
        }
        "string" === typeof href && Internals.d.D(href);
    };
    exports.preinit = function(href, options) {
        "string" === typeof href && href ? null == options || "object" !== typeof options ? console.error("ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.", getValueDescriptorExpectingEnumForWarning(options)) : "style" !== options.as && "script" !== options.as && console.error('ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".', getValueDescriptorExpectingEnumForWarning(options.as)) : console.error("ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        if ("string" === typeof href && options && "string" === typeof options.as) {
            var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
            "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
                crossOrigin: crossOrigin,
                integrity: integrity,
                fetchPriority: fetchPriority
            }) : "script" === as && Internals.d.X(href, {
                crossOrigin: crossOrigin,
                integrity: integrity,
                fetchPriority: fetchPriority,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0
            });
        }
    };
    exports.preinitModule = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "script" !== options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingEnumForWarning(options.as) + ".");
        if (encountered) console.error("ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s", encountered);
        else switch(encountered = options && "string" === typeof options.as ? options.as : "script", encountered){
            case "script":
                break;
            default:
                encountered = getValueDescriptorExpectingEnumForWarning(encountered), console.error('ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)', encountered, href);
        }
        if ("string" === typeof href) {
            if ("object" === typeof options && null !== options) {
                if (null == options.as || "script" === options.as) encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.M(href, {
                    crossOrigin: encountered,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            } else null == options && Internals.d.M(href);
        }
    };
    exports.preload = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        null == options || "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : "string" === typeof options.as && options.as || (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
        encountered && console.error('ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s', encountered);
        if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
            encountered = options.as;
            var crossOrigin = getCrossOriginStringAs(encountered, options.crossOrigin);
            Internals.d.L(href, encountered, {
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                type: "string" === typeof options.type ? options.type : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
                referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
                imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
                imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
                media: "string" === typeof options.media ? options.media : void 0
            });
        }
    };
    exports.preloadModule = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "string" !== typeof options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
        encountered && console.error('ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s', encountered);
        "string" === typeof href && (options ? (encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.m(href, {
            as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
            crossOrigin: encountered,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0
        })) : Internals.d.m(href));
    };
    exports.requestFormReset = function(form) {
        Internals.d.r(form);
    };
    exports.unstable_batchedUpdates = function(fn, a) {
        return fn(a);
    };
    exports.useFormState = function(action, initialState, permalink) {
        return resolveDispatcher().useFormState(action, initialState, permalink);
    };
    exports.useFormStatus = function() {
        return resolveDispatcher().useHostTransitionStatus();
    };
    exports.version = "19.2.6";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

},{"6f0162e9ab224cd4":"2o0ib"}],"8hNco":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHashHistory", ()=>(0, _history.createHashHistory)) // Types
;
parcelHelpers.export(exports, "createBrowserHistory", ()=>(0, _history.createBrowserHistory));
parcelHelpers.export(exports, "createMemoryHistory", ()=>(0, _history.createMemoryHistory));
parcelHelpers.export(exports, "ReactLocation", ()=>ReactLocation);
parcelHelpers.export(exports, "MatchesProvider", ()=>MatchesProvider);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterInstance", ()=>RouterInstance);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "RouteMatch", ()=>RouteMatch);
parcelHelpers.export(exports, "useRouter", ()=>useRouter);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "useLoadRoute", ()=>useLoadRoute);
parcelHelpers.export(exports, "useParentMatches", ()=>useParentMatches);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "useResolvePath", ()=>useResolvePath);
parcelHelpers.export(exports, "useSearch", ()=>useSearch);
parcelHelpers.export(exports, "matchRoute", ()=>matchRoute);
parcelHelpers.export(exports, "useMatchRoute", ()=>useMatchRoute);
parcelHelpers.export(exports, "MatchRoute", ()=>MatchRoute);
parcelHelpers.export(exports, "usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "Prompt", ()=>Prompt);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "cleanPath", ()=>cleanPath);
parcelHelpers.export(exports, "matchByPath", ()=>matchByPath);
parcelHelpers.export(exports, "parsePathname", ()=>parsePathname);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "defaultStringifySearch", ()=>defaultStringifySearch);
parcelHelpers.export(exports, "defaultParseSearch", ()=>defaultParseSearch);
var _react = require("react");
var _history = require("history");
var _excluded = [
    "children",
    "location"
], _excluded2 = [
    "location"
], _excluded3 = [
    "basepath",
    "routes"
], _excluded4 = [
    "to",
    "search",
    "hash",
    "children",
    "target",
    "style",
    "replace",
    "onClick",
    "onMouseEnter",
    "className",
    "getActiveProps",
    "getInactiveProps",
    "activeOptions",
    "preload",
    "disabled",
    "_ref"
], _excluded5 = [
    "style",
    "className"
], _excluded6 = [
    "style",
    "className"
], _excluded7 = [
    "pending"
], _excluded8 = [
    "children"
];
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
// Source
var LocationContext = /*#__PURE__*/ _react.createContext(null);
var MatchesContext = /*#__PURE__*/ _react.createContext(null);
var routerContext = /*#__PURE__*/ _react.createContext(null); // Detect if we're in the DOM
var isDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
var useLayoutEffect = isDOM ? _react.useLayoutEffect : _react.useEffect; // This is the default history object if none is defined
var createDefaultHistory = function createDefaultHistory() {
    return isDOM ? (0, _history.createBrowserHistory)() : (0, _history.createMemoryHistory)();
};
var Subscribable = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        this.listeners.push(listener);
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== listener;
            });
        };
    };
    _proto.notify = function notify() {
        this.listeners.forEach(function(listener) {
            return listener();
        });
    };
    return Subscribable;
}();
var ReactLocation = /*#__PURE__*/ function(_Subscribable) {
    _inheritsLoose(ReactLocation, _Subscribable);
    //
    function ReactLocation(options) {
        var _options$stringifySea, _options$parseSearch;
        var _this2;
        _this2 = _Subscribable.call(this) || this;
        _this2.isTransitioning = false;
        _this2.history = (options == null ? void 0 : options.history) || createDefaultHistory();
        _this2.stringifySearch = (_options$stringifySea = options == null ? void 0 : options.stringifySearch) != null ? _options$stringifySea : defaultStringifySearch;
        _this2.parseSearch = (_options$parseSearch = options == null ? void 0 : options.parseSearch) != null ? _options$parseSearch : defaultParseSearch;
        _this2.current = _this2.parseLocation(_this2.history.location);
        _this2.destroy = _this2.history.listen(function(event) {
            _this2.current = _this2.parseLocation(event.location, _this2.current);
            _this2.notify();
        });
        return _this2;
    }
    var _proto2 = ReactLocation.prototype;
    _proto2.buildNext = function buildNext(basepath, dest) {
        var _dest$to, _ref2, _dest$__searchFilters;
        if (basepath === void 0) basepath = '/';
        if (dest === void 0) dest = {};
        var from = _extends({}, this.current, dest.from);
        var pathname = resolvePath(basepath, from.pathname, "" + ((_dest$to = dest.to) != null ? _dest$to : '.'));
        var updatedSearch = (_ref2 = dest.search === true ? from.search : functionalUpdate(dest.search, from.search)) != null ? _ref2 : {};
        var filteredSearch = (_dest$__searchFilters = dest.__searchFilters) != null && _dest$__searchFilters.length ? dest.__searchFilters.reduce(function(prev, next) {
            return next(prev, updatedSearch);
        }, from.search) : updatedSearch;
        var search = replaceEqualDeep(from.search, filteredSearch);
        var searchStr = this.stringifySearch(search);
        var hash = functionalUpdate(dest.hash, from.hash);
        hash = hash ? "#" + hash : '';
        return {
            pathname: pathname,
            search: search,
            searchStr: searchStr,
            hash: hash,
            href: "" + pathname + searchStr + hash,
            key: dest.key
        };
    };
    _proto2.navigate = function navigate(next, replace) {
        var _this3 = this;
        this.current = next;
        if (this.navigateTimeout) clearTimeout(this.navigateTimeout);
        var nextAction = 'replace';
        if (!this.nextAction) nextAction = replace ? 'replace' : 'push';
        if (!replace) nextAction = 'push';
        this.nextAction = nextAction;
        this.navigateTimeout = setTimeout(function() {
            var nextAction = _this3.nextAction;
            delete _this3.nextAction;
            var isSameUrl = _this3.parseLocation(_this3.history.location).href === _this3.current.href;
            if (isSameUrl && !_this3.current.key) nextAction = 'replace';
            if (nextAction === 'replace') return _this3.history.replace({
                pathname: _this3.current.pathname,
                hash: _this3.current.hash,
                search: _this3.current.searchStr
            });
            return _this3.history.push({
                pathname: _this3.current.pathname,
                hash: _this3.current.hash,
                search: _this3.current.searchStr
            });
        }, 16);
    };
    _proto2.parseLocation = function parseLocation(location, previousLocation) {
        var _location$hash$split$;
        var parsedSearch = this.parseSearch(location.search);
        return {
            pathname: location.pathname,
            searchStr: location.search,
            search: replaceEqualDeep(previousLocation == null ? void 0 : previousLocation.search, parsedSearch),
            hash: (_location$hash$split$ = location.hash.split('#').reverse()[0]) != null ? _location$hash$split$ : '',
            href: "" + location.pathname + location.search + location.hash,
            key: location.key
        };
    };
    return ReactLocation;
}(Subscribable);
function MatchesProvider(props) {
    return /*#__PURE__*/ _react.createElement(MatchesContext.Provider, props);
}
function Router(_ref3) {
    var children = _ref3.children, location = _ref3.location, rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
    var routerRef = _react.useRef(null);
    if (!routerRef.current) routerRef.current = new RouterInstance({
        location: location,
        // snapshot,
        routes: rest.routes
    });
    var router = routerRef.current;
    var _React$useReducer = _react.useReducer(function() {
        return {};
    }, {}), nonce = _React$useReducer[0], rerender = _React$useReducer[1];
    router.update(rest);
    useLayoutEffect(function() {
        return router.subscribe(function() {
            // microtask(() => {
            rerender(); // })
        });
    }, []);
    useLayoutEffect(function() {
        return router.updateLocation(location.current).unsubscribe;
    }, [
        location.current.key
    ]);
    var routerValue = _react.useMemo(function() {
        return {
            router: router
        };
    }, [
        nonce
    ]);
    return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: location
    }, /*#__PURE__*/ _react.createElement(routerContext.Provider, {
        value: routerValue
    }, /*#__PURE__*/ _react.createElement(MatchesProvider, {
        value: [
            router.rootMatch
        ].concat(router.state.matches)
    }, children != null ? children : /*#__PURE__*/ _react.createElement(Outlet, null))));
}
var RouterInstance = /*#__PURE__*/ function(_Subscribable2) {
    _inheritsLoose(RouterInstance, _Subscribable2);
    function RouterInstance(_ref4) {
        var _this4;
        var location = _ref4.location, rest = _objectWithoutPropertiesLoose(_ref4, _excluded2);
        _this4 = _Subscribable2.call(this) || this;
        _this4.routesById = {};
        _this4.update = function(_ref5) {
            var basepath = _ref5.basepath, routes = _ref5.routes, opts = _objectWithoutPropertiesLoose(_ref5, _excluded3);
            Object.assign(_assertThisInitialized(_this4), opts);
            _this4.basepath = cleanPath("/" + (basepath != null ? basepath : ''));
            _this4.routesById = {};
            var recurseRoutes = function recurseRoutes(routes, parent) {
                return routes.map(function(route) {
                    var _route$path, _route$pendingMs, _route$pendingMinMs, _route$children;
                    var path = (_route$path = route.path) != null ? _route$path : '*';
                    var id = joinPaths([
                        (parent == null ? void 0 : parent.id) === 'root' ? '' : parent == null ? void 0 : parent.id,
                        "" + (path == null ? void 0 : path.replace(/(.)\/$/, '$1')) + (route.id ? "-" + route.id : '')
                    ]);
                    route = _extends({}, route, {
                        pendingMs: (_route$pendingMs = route.pendingMs) != null ? _route$pendingMs : opts == null ? void 0 : opts.defaultPendingMs,
                        pendingMinMs: (_route$pendingMinMs = route.pendingMinMs) != null ? _route$pendingMinMs : opts == null ? void 0 : opts.defaultPendingMinMs,
                        id: id
                    });
                    if (_this4.routesById[id]) {
                        console.warn("Duplicate routes found with id: " + id, _this4.routesById, route);
                        throw new Error();
                    }
                    _this4.routesById[id] = route;
                    route.children = (_route$children = route.children) != null && _route$children.length ? recurseRoutes(route.children, route) : undefined;
                    return route;
                });
            };
            _this4.routes = recurseRoutes(routes);
            _this4.rootMatch = {
                id: 'root',
                params: {},
                search: {},
                pathname: _this4.basepath,
                route: null,
                ownData: {},
                data: {},
                isLoading: false,
                status: 'resolved'
            };
        };
        _this4.setState = function(updater) {
            var newState = updater({
                state: _this4.state,
                pending: _this4.pending
            });
            _this4.state = newState.state;
            _this4.pending = newState.pending;
            _this4.cleanMatchCache();
            _this4.notify();
        };
        _this4.matchCache = {};
        _this4.cleanMatchCache = function() {
            var _assertThisInitialize, _assertThisInitialize2, _assertThisInitialize3, _assertThisInitialize4, _assertThisInitialize5;
            var activeMatchIds = [].concat((_assertThisInitialize = (_assertThisInitialize2 = _assertThisInitialized(_this4)) == null ? void 0 : _assertThisInitialize2.state.matches) != null ? _assertThisInitialize : [], (_assertThisInitialize3 = (_assertThisInitialize4 = _assertThisInitialized(_this4)) == null ? void 0 : (_assertThisInitialize5 = _assertThisInitialize4.pending) == null ? void 0 : _assertThisInitialize5.matches) != null ? _assertThisInitialize3 : []).map(function(d) {
                return d.id;
            });
            Object.values(_this4.matchCache).forEach(function(match) {
                var _match$updatedAt;
                if (!match.updatedAt) return;
                if (activeMatchIds.includes(match.id)) return;
                var age = Date.now() - ((_match$updatedAt = match.updatedAt) != null ? _match$updatedAt : 0);
                if (!match.maxAge || age > match.maxAge) {
                    if (match.route.unloader) match.route.unloader(match);
                    delete _this4.matchCache[match.id];
                }
            });
        };
        _this4.updateLocation = function(next) {
            var unsubscribe;
            var promise = new Promise(function(resolve) {
                var matchLoader = new MatchLoader(_assertThisInitialized(_this4), next);
                _this4.setState(function(old) {
                    return _extends({}, old, {
                        pending: {
                            location: matchLoader.location,
                            matches: matchLoader.matches
                        }
                    });
                });
                unsubscribe = matchLoader.subscribe(function() {
                    var currentMatches = _this4.state.matches;
                    currentMatches.filter(function(d) {
                        return !matchLoader.matches.find(function(dd) {
                            return dd.id === d.id;
                        });
                    }).forEach(function(d) {
                        d.onExit == null || d.onExit(d);
                    });
                    currentMatches.filter(function(d) {
                        return matchLoader.matches.find(function(dd) {
                            return dd.id === d.id;
                        });
                    }).forEach(function(d) {
                        d.route.onTransition == null || d.route.onTransition(d);
                    });
                    matchLoader.matches.filter(function(d) {
                        return !currentMatches.find(function(dd) {
                            return dd.id === d.id;
                        });
                    }).forEach(function(d) {
                        d.onExit = d.route.onMatch == null ? void 0 : d.route.onMatch(d);
                    });
                    _this4.setState(function(old) {
                        return _extends({}, old, {
                            state: {
                                location: matchLoader.location,
                                matches: matchLoader.matches
                            },
                            pending: undefined
                        });
                    });
                    resolve();
                });
                matchLoader.loadData();
                matchLoader.startPending();
            });
            return {
                promise: promise,
                unsubscribe: unsubscribe
            };
        };
        _this4.update(rest); // if (snapshot) {
        //   const matchLoader = new MatchLoader(this, location.current)
        //   matchLoader.matches.forEach((match, index) => {
        //     if (match.id !== snapshot.matches[index]?.id) {
        //       throw new Error(
        //         `Router hydration mismatch: ${match.id} !== ${snapshot.matches[index]?.id}`,
        //       )
        //     }
        //     match.ownData = snapshot.matches[index]?.ownData ?? {}
        //   })
        //   cascadeMatchData(matchLoader.matches)
        // }
        _this4.state = {
            // location: snapshot?.location ?? location.current,
            // matches: matchLoader.matches,
            location: location.current,
            matches: []
        };
        location.subscribe(function() {
            return _this4.notify();
        });
        return _this4;
    } // snapshot = (): RouterSnapshot<TGenerics> => {
    //   return {
    //     location: this.state.location,
    //     matches: this.state.matches.map(({ ownData, id }) => {
    //       return {
    //         id,
    //         ownData,
    //       }
    //     }),
    //   }
    // }
    return RouterInstance;
}(Subscribable);
function useLocation() {
    var getIsMounted = useGetIsMounted();
    var _React$useReducer2 = _react.useReducer(function(d) {
        return d + 1;
    }, 0), rerender = _React$useReducer2[1];
    var instance = _react.useContext(LocationContext);
    warning(!!instance, 'useLocation must be used within a <ReactLocation />');
    useLayoutEffect(function() {
        return instance.subscribe(function() {
            // Rerender all subscribers in a microtask
            Promise.resolve().then(function() {
                setTimeout(function renderAllLocationSubscribers() {
                    if (getIsMounted()) rerender();
                }, 0);
            });
        });
    }, [
        instance
    ]);
    return instance;
}
var RouteMatch = function RouteMatch(unloadedMatch) {
    var _this5 = this;
    this.status = 'loading';
    this.ownData = {};
    this.data = {};
    this.isLoading = false;
    this.notify = function(isSoft) {
        var _this5$matchLoader;
        (_this5$matchLoader = _this5.matchLoader) == null || _this5$matchLoader.preNotify(isSoft);
    };
    this.assignMatchLoader = function(matchLoader) {
        _this5.matchLoader = matchLoader;
    };
    this.startPending = function() {
        if (_this5.pendingTimeout) clearTimeout(_this5.pendingTimeout);
        if (_this5.route.pendingMs !== undefined) _this5.pendingTimeout = setTimeout(function() {
            if (_this5.status === 'loading') _this5.status = 'pending';
            _this5.notify == null || _this5.notify();
            if (typeof _this5.route.pendingMinMs !== 'undefined') _this5.pendingMinPromise = new Promise(function(r) {
                return setTimeout(r, _this5.route.pendingMinMs);
            });
        }, _this5.route.pendingMs);
    };
    this.load = function(opts) {
        var _ref6, _opts$maxAge;
        _this5.maxAge = (_ref6 = (_opts$maxAge = opts.maxAge) != null ? _opts$maxAge : _this5.route.loaderMaxAge) != null ? _ref6 : opts.router.defaultLoaderMaxAge;
        if (_this5.loaderPromise) return;
        var importer = _this5.route.import; // First, run any importers
        _this5.loaderPromise = (!importer ? Promise.resolve() : importer({
            params: _this5.params,
            search: _this5.search
        }).then(function(imported) {
            _this5.route = _extends({}, _this5.route, imported);
        }) // then run all element and data loaders in parallel
        ).then(function() {
            var elementPromises = []; // For each element type, potentially load it asynchronously
            var elementTypes = [
                'element',
                'errorElement',
                'pendingElement'
            ];
            elementTypes.forEach(function(type) {
                var routeElement = _this5.route[type];
                if (_this5[type]) return;
                if (typeof routeElement === 'function') elementPromises.push(routeElement(_this5).then(function(res) {
                    _this5[type] = res;
                }));
                else _this5[type] = _this5.route[type];
            });
            var loader = _this5.route.loader;
            var dataPromise = !loader ? Promise.resolve().then(function() {
                _this5.status = 'resolved';
            }) : new Promise(function(resolveLoader) {
                return new Promise(function($return, $error) {
                    var pendingTimeout, resolve, reject, finish;
                    resolve = function resolve(data) {
                        _this5.status = 'resolved';
                        _this5.ownData = data;
                        _this5.error = undefined;
                    };
                    reject = function reject(err) {
                        console.error(err);
                        _this5.status = 'rejected';
                        _this5.error = err;
                    };
                    finish = function finish() {
                        _this5.isLoading = false;
                        _this5.startPending = undefined;
                        clearTimeout(pendingTimeout);
                        resolveLoader(_this5.ownData);
                        _this5.notify == null || _this5.notify(true);
                    };
                    var $Try_1_Post = function() {
                        try {
                            return $return();
                        } catch ($boundEx) {
                            return $error($boundEx);
                        }
                    };
                    var $Try_1_Catch = function(err) {
                        try {
                            reject(err);
                            finish();
                            return $Try_1_Post();
                        } catch ($boundEx) {
                            return $error($boundEx);
                        }
                    };
                    try {
                        _this5.isLoading = true;
                        return Promise.resolve(loader(_this5, {
                            parentMatch: opts.parentMatch,
                            dispatch: function dispatch(event) {
                                return new Promise(function($return, $error) {
                                    if (event.type === 'resolve') resolve(event.data);
                                    else if (event.type === 'reject') reject(event.error);
                                    else if (event.type === 'loading') _this5.isLoading = true;
                                    else if (event.type === 'maxAge') _this5.maxAge = event.maxAge;
                                    _this5.updatedAt = Date.now();
                                    _this5.notify == null || _this5.notify(true);
                                    return $return();
                                });
                            }
                        })).then(function($await_6) {
                            try {
                                resolve($await_6);
                                return Promise.resolve(_this5.pendingMinPromise).then(function($await_7) {
                                    try {
                                        finish();
                                        return $Try_1_Post();
                                    } catch ($boundEx) {
                                        return $Try_1_Catch($boundEx);
                                    }
                                }, $Try_1_Catch);
                            } catch ($boundEx) {
                                return $Try_1_Catch($boundEx);
                            }
                        }, $Try_1_Catch);
                    } catch (err) {
                        $Try_1_Catch(err);
                    }
                });
            });
            return Promise.all([].concat(elementPromises, [
                dataPromise
            ])).then(function() {
                _this5.updatedAt = Date.now();
            });
        }).then(function() {
            return _this5.ownData;
        });
    };
    Object.assign(this, unloadedMatch);
};
var MatchLoader = /*#__PURE__*/ function(_Subscribable3) {
    _inheritsLoose(MatchLoader, _Subscribable3);
    function MatchLoader(router, nextLocation) {
        var _this6;
        _this6 = _Subscribable3.call(this) || this;
        _this6.status = 'pending';
        _this6.preNotify = function(isSoft) {
            if (!isSoft) _this6.status = 'resolved';
            cascadeMatchData(_this6.matches);
            _this6.notify();
        };
        _this6.loadData = function(_temp) {
            return new Promise(function($return, $error) {
                var _this6$matches, _ref7, maxAge;
                _ref7 = _temp === void 0 ? {} : _temp, maxAge = _ref7.maxAge;
                _this6.router.cleanMatchCache();
                if (!((_this6$matches = _this6.matches) != null && _this6$matches.length)) {
                    _this6.preNotify();
                    return $return();
                }
                _this6.firstRenderPromises = [];
                _this6.matches.forEach(function(match, index) {
                    var _this6$matches2, _this6$firstRenderPro;
                    var parentMatch = (_this6$matches2 = _this6.matches) == null ? void 0 : _this6$matches2[index - 1];
                    match.assignMatchLoader == null || match.assignMatchLoader(_assertThisInitialized(_this6));
                    match.load == null || match.load({
                        maxAge: maxAge,
                        parentMatch: parentMatch,
                        router: _this6.router
                    });
                    (_this6$firstRenderPro = _this6.firstRenderPromises) == null || _this6$firstRenderPro.push(match.loaderPromise);
                });
                return Promise.resolve(Promise.all(_this6.firstRenderPromises).then(function() {
                    _this6.preNotify();
                    return _this6.matches;
                })).then($return, $error);
            });
        };
        _this6.load = function(_temp2) {
            return new Promise(function($return, $error) {
                var _ref8, maxAge;
                _ref8 = _temp2 === void 0 ? {} : _temp2, maxAge = _ref8.maxAge;
                return Promise.resolve(_this6.loadData({
                    maxAge: maxAge
                })).then($return, $error);
            });
        };
        _this6.startPending = function() {
            return new Promise(function($return, $error) {
                _this6.matches.forEach(function(match) {
                    return match.startPending == null ? void 0 : match.startPending();
                });
                return $return();
            });
        };
        _this6.router = router;
        _this6.location = nextLocation;
        _this6.matches = [];
        var unloadedMatches = matchRoutes(_this6.router, _this6.location);
        _this6.matches = unloadedMatches == null ? void 0 : unloadedMatches.map(function(unloadedMatch) {
            if (!_this6.router.matchCache[unloadedMatch.id]) _this6.router.matchCache[unloadedMatch.id] = new RouteMatch(unloadedMatch);
            return _this6.router.matchCache[unloadedMatch.id];
        });
        return _this6;
    }
    return MatchLoader;
}(Subscribable);
function cascadeMatchData(matches) {
    matches == null || matches.forEach(function(match, index) {
        var _parentMatch$data;
        var parentMatch = matches == null ? void 0 : matches[index - 1];
        match.data = _extends({}, (_parentMatch$data = parentMatch == null ? void 0 : parentMatch.data) != null ? _parentMatch$data : {}, match.ownData);
    });
}
function useRouter() {
    var value = _react.useContext(routerContext);
    if (!value) {
        warning(true, 'You are trying to use useRouter() outside of ReactLocation!');
        throw new Error();
    }
    return value.router;
}
function matchRoutes(router, currentLocation) {
    if (!router.routes.length) return [];
    var matches = [];
    var recurse = function recurse(routes, parentMatch) {
        return new Promise(function($return, $error) {
            var _route$children3;
            var pathname = parentMatch.pathname, params = parentMatch.params;
            var filteredRoutes = router != null && router.filterRoutes ? router == null ? void 0 : router.filterRoutes(routes) : routes;
            var route = filteredRoutes.find(function(route) {
                var _route$children2, _route$caseSensitive;
                var fullRoutePathName = joinPaths([
                    pathname,
                    route.path
                ]);
                var fuzzy = !!(route.path !== '/' || (_route$children2 = route.children) != null && _route$children2.length);
                var matchParams = matchRoute(currentLocation, {
                    to: fullRoutePathName,
                    search: route.search,
                    fuzzy: fuzzy,
                    caseSensitive: (_route$caseSensitive = route.caseSensitive) != null ? _route$caseSensitive : router.caseSensitive
                });
                if (matchParams) params = _extends({}, params, matchParams);
                return !!matchParams;
            });
            if (!route) return $return();
            var interpolatedPath = interpolatePath(route.path, params);
            pathname = joinPaths([
                pathname,
                interpolatedPath
            ]);
            var interpolatedId = interpolatePath(route.id, params, true);
            var match = {
                id: interpolatedId,
                route: route,
                params: params,
                pathname: pathname,
                search: currentLocation.search
            };
            matches.push(match);
            if ((_route$children3 = route.children) != null && _route$children3.length) recurse(route.children, match);
            return $return();
        });
    };
    recurse(router.routes, router.rootMatch);
    return matches;
}
function interpolatePath(path, params, leaveWildcard) {
    var interpolatedPathSegments = parsePathname(path);
    return joinPaths(interpolatedPathSegments.map(function(segment) {
        if (segment.value === '*' && !leaveWildcard) return '';
        if (segment.type === 'param') {
            var _segment$value$substr;
            return (_segment$value$substr = params[segment.value.substring(1)]) != null ? _segment$value$substr : '';
        }
        return segment.value;
    }));
}
function useLoadRoute() {
    var location = useLocation();
    var match = useMatch();
    var router = useRouter();
    var buildNext = useBuildNext();
    return useLatestCallback(function(navigate, opts) {
        return new Promise(function($return, $error) {
            var _navigate$from, next, matchLoader;
            if (navigate === void 0) navigate = location.current;
            next = buildNext(_extends({}, navigate, {
                from: (_navigate$from = navigate.from) != null ? _navigate$from : {
                    pathname: match.pathname
                }
            }));
            matchLoader = new MatchLoader(router, next);
            return Promise.resolve(matchLoader.load(opts)).then($return, $error);
        });
    });
}
function useParentMatches() {
    var router = useRouter();
    var match = useMatch();
    var matches = router.state.matches;
    return matches.slice(0, matches.findIndex(function(d) {
        return d.id === match.id;
    }) - 1);
}
function useMatches() {
    return _react.useContext(MatchesContext);
}
function useMatch() {
    var _useMatches;
    return (_useMatches = useMatches()) == null ? void 0 : _useMatches[0];
}
function useNavigate() {
    var location = useLocation();
    var match = useMatch();
    var buildNext = useBuildNext();
    function navigate(_ref9) {
        var _fromCurrent;
        var search = _ref9.search, hash = _ref9.hash, replace = _ref9.replace, from = _ref9.from, to = _ref9.to, fromCurrent = _ref9.fromCurrent;
        fromCurrent = (_fromCurrent = fromCurrent) != null ? _fromCurrent : typeof to === 'undefined';
        var next = buildNext({
            to: to,
            search: search,
            hash: hash,
            from: fromCurrent ? location.current : from != null ? from : {
                pathname: match.pathname
            }
        });
        location.navigate(next, replace);
    }
    return useLatestCallback(navigate);
}
function Navigate(options) {
    var navigate = useNavigate();
    useLayoutEffect(function() {
        navigate(options);
    }, [
        navigate
    ]);
    return null;
}
function useBuildNext() {
    var location = useLocation();
    var router = useRouter();
    var buildNext = function buildNext(opts) {
        var next = location.buildNext(router.basepath, opts);
        var matches = matchRoutes(router, next);
        var __searchFilters = matches.map(function(match) {
            var _match$route$searchFi;
            return (_match$route$searchFi = match.route.searchFilters) != null ? _match$route$searchFi : [];
        }).flat().filter(Boolean);
        return location.buildNext(router.basepath, _extends({}, opts, {
            __searchFilters: __searchFilters
        }));
    };
    return useLatestCallback(buildNext);
}
var Link = function Link(_ref10) {
    var _preload;
    var _ref10$to = _ref10.to, to = _ref10$to === void 0 ? '.' : _ref10$to, search = _ref10.search, hash = _ref10.hash, children = _ref10.children, target = _ref10.target, _ref10$style = _ref10.style, style = _ref10$style === void 0 ? {} : _ref10$style, replace = _ref10.replace, onClick = _ref10.onClick, onMouseEnter = _ref10.onMouseEnter, _ref10$className = _ref10.className, className = _ref10$className === void 0 ? '' : _ref10$className, _ref10$getActiveProps = _ref10.getActiveProps, getActiveProps = _ref10$getActiveProps === void 0 ? function() {
        return {};
    } : _ref10$getActiveProps, _ref10$getInactivePro = _ref10.getInactiveProps, getInactiveProps = _ref10$getInactivePro === void 0 ? function() {
        return {};
    } : _ref10$getInactivePro, activeOptions = _ref10.activeOptions, preload = _ref10.preload, disabled = _ref10.disabled, _ref = _ref10._ref, rest = _objectWithoutPropertiesLoose(_ref10, _excluded4);
    var loadRoute = useLoadRoute();
    var match = useMatch();
    var location = useLocation();
    var router = useRouter();
    var navigate = useNavigate();
    var buildNext = useBuildNext();
    preload = (_preload = preload) != null ? _preload : router.defaultLinkPreloadMaxAge; // If this `to` is a valid external URL, log a warning
    try {
        var url = new URL("" + to);
        warning(false, "<Link /> should not be used for external URLs like: " + url.href);
    } catch (e) {}
    var next = buildNext({
        to: to,
        search: search,
        hash: hash,
        from: {
            pathname: match.pathname
        }
    }); // The click handler
    var handleClick = function handleClick(e) {
        if (onClick) onClick(e);
        if (!isCtrlEvent(e) && !e.defaultPrevented && (!target || target === '_self') && e.button === 0) {
            e.preventDefault(); // All is well? Navigate!
            navigate({
                to: to,
                search: search,
                hash: hash,
                replace: replace,
                from: {
                    pathname: match.pathname
                }
            });
        }
    }; // The click handler
    var handleMouseEnter = function handleMouseEnter(e) {
        if (onMouseEnter) onMouseEnter(e);
        if (preload && preload > 0) loadRoute({
            to: to,
            search: search,
            hash: hash
        }, {
            maxAge: preload
        });
    }; // Compare path/hash for matches
    var pathIsEqual = location.current.pathname === next.pathname;
    var currentPathSplit = location.current.pathname.split('/');
    var nextPathSplit = next.pathname.split('/');
    var pathIsFuzzyEqual = nextPathSplit.every(function(d, i) {
        return d === currentPathSplit[i];
    });
    var hashIsEqual = location.current.hash === next.hash; // Combine the matches based on user options
    var pathTest = activeOptions != null && activeOptions.exact ? pathIsEqual : pathIsFuzzyEqual;
    var hashTest = activeOptions != null && activeOptions.includeHash ? hashIsEqual : true; // The final "active" test
    var isActive = pathTest && hashTest; // Get the active props
    var _ref11 = isActive ? getActiveProps() : {}, _ref11$style = _ref11.style, activeStyle = _ref11$style === void 0 ? {} : _ref11$style, _ref11$className = _ref11.className, activeClassName = _ref11$className === void 0 ? '' : _ref11$className, activeRest = _objectWithoutPropertiesLoose(_ref11, _excluded5); // Get the inactive props
    var _ref12 = isActive ? {} : getInactiveProps(), _ref12$style = _ref12.style, inactiveStyle = _ref12$style === void 0 ? {} : _ref12$style, _ref12$className = _ref12.className, inactiveClassName = _ref12$className === void 0 ? '' : _ref12$className, inactiveRest = _objectWithoutPropertiesLoose(_ref12, _excluded6);
    return /*#__PURE__*/ _react.createElement("a", _extends({
        ref: _ref,
        href: disabled ? undefined : next.href,
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        target: target,
        style: _extends({}, style, activeStyle, inactiveStyle),
        className: [
            className,
            activeClassName,
            inactiveClassName
        ].filter(Boolean).join(' ') || undefined
    }, disabled ? {
        role: 'link',
        'aria-disabled': true
    } : undefined, rest, activeRest, inactiveRest, {
        children: typeof children === 'function' ? children({
            isActive: isActive
        }) : children
    }));
};
function Outlet() {
    var _match$errorElement;
    var router = useRouter();
    var _useMatches2 = useMatches(), _ = _useMatches2[0], matches = _useMatches2.slice(1);
    var match = matches[0];
    if (!match) return null;
    var errorElement = (_match$errorElement = match.errorElement) != null ? _match$errorElement : router.defaultErrorElement;
    var element = function() {
        var _match$pendingElement, _match$element;
        if (match.status === 'rejected') {
            if (errorElement) return errorElement;
            if (!router.useErrorBoundary) {
                var preStyle = {
                    whiteSpace: 'normal',
                    display: 'inline-block',
                    background: 'rgba(0,0,0,.1)',
                    padding: '.1rem .2rem',
                    margin: '.1rem',
                    lineHeight: '1',
                    borderRadius: '.25rem'
                };
                return /*#__PURE__*/ _react.createElement("div", {
                    style: {
                        lineHeight: '1.7'
                    }
                }, /*#__PURE__*/ _react.createElement("strong", null, "The following error occured in the loader for you route at:", ' ', /*#__PURE__*/ _react.createElement("pre", {
                    style: preStyle
                }, match.pathname)), ".", /*#__PURE__*/ _react.createElement("br", null), /*#__PURE__*/ _react.createElement("pre", {
                    style: _extends({}, preStyle, {
                        display: 'block',
                        padding: '.5rem',
                        borderRadius: '.5rem'
                    })
                }, match.error.toString()), /*#__PURE__*/ _react.createElement("br", null), "Your users won't see this message in production, but they will see", ' ', /*#__PURE__*/ _react.createElement("strong", null, "\"An unknown error occured!\""), ", which is at least better than breaking your entire app. \uD83D\uDE0A For a better UX, please specify an ", /*#__PURE__*/ _react.createElement("pre", {
                    style: preStyle
                }, "errorElement"), " for all of your routes that contain asynchronous behavior, or at least provide your own", /*#__PURE__*/ _react.createElement("pre", {
                    style: preStyle
                }, "ErrorBoundary"), " wrapper around your renders to both the elements rendered by", ' ', /*#__PURE__*/ _react.createElement("pre", {
                    style: preStyle
                }, 'useRoutes(routes, { useErrorBoundary: true })'), ' ', "and ", /*#__PURE__*/ _react.createElement("pre", {
                    style: preStyle
                }, '<Router useErrorBoundary />'), ".", ' ', /*#__PURE__*/ _react.createElement("br", null), /*#__PURE__*/ _react.createElement("br", null));
                return 'An unknown error occured!';
            }
            throw match.error;
        }
        var pendingElement = (_match$pendingElement = match.pendingElement) != null ? _match$pendingElement : router.defaultPendingElement;
        if (match.status === 'loading') return null;
        if (match.status === 'pending') {
            if (match.route.pendingMs || pendingElement) return pendingElement != null ? pendingElement : null;
        }
        var matchElement = (_match$element = match.element) != null ? _match$element : router.defaultElement;
        return matchElement != null ? matchElement : /*#__PURE__*/ _react.createElement(Outlet, null);
    }();
    return /*#__PURE__*/ _react.createElement(MatchesProvider, {
        value: matches
    }, element);
}
function useResolvePath() {
    var router = useRouter();
    var match = useMatch();
    return useLatestCallback(function(path) {
        return resolvePath(router.basepath, match.pathname, cleanPath(path));
    });
}
function useSearch() {
    var location = useLocation();
    return location.current.search;
}
function matchRoute(currentLocation, matchLocation) {
    var pathParams = matchByPath(currentLocation, matchLocation);
    var searchMatched = matchBySearch(currentLocation, matchLocation);
    if (matchLocation.to && !pathParams) return;
    if (matchLocation.search && !searchMatched) return;
    return pathParams != null ? pathParams : {};
}
function useMatchRoute() {
    var router = useRouter();
    var resolvePath = useResolvePath();
    return useLatestCallback(function(_ref13) {
        var pending = _ref13.pending, matchLocation = _objectWithoutPropertiesLoose(_ref13, _excluded7);
        matchLocation = _extends({}, matchLocation, {
            to: matchLocation.to ? resolvePath("" + matchLocation.to) : undefined
        });
        if (pending) {
            var _router$pending;
            if (!((_router$pending = router.pending) != null && _router$pending.location)) return undefined;
            return matchRoute(router.pending.location, matchLocation);
        }
        return matchRoute(router.state.location, matchLocation);
    });
}
function MatchRoute(_ref14) {
    var children = _ref14.children, rest = _objectWithoutPropertiesLoose(_ref14, _excluded8);
    var matchRoute = useMatchRoute();
    var match = matchRoute(rest);
    if (typeof children === 'function') return children(match);
    return match ? children : null;
}
function usePrompt(message, when) {
    var location = useLocation();
    _react.useEffect(function() {
        if (!when) return;
        var unblock = location.history.block(function(transition) {
            if (window.confirm(message)) {
                unblock();
                transition.retry();
            } else location.current.pathname = window.location.pathname;
        });
        return unblock;
    }, [
        when,
        location,
        message
    ]);
}
function Prompt(_ref15) {
    var message = _ref15.message, when = _ref15.when, children = _ref15.children;
    usePrompt(message, when != null ? when : true);
    return children != null ? children : null;
}
function warning(cond, message) {
    if (!cond) {
        if (typeof console !== 'undefined') console.warn(message);
        try {
            throw new Error(message);
        } catch (_unused) {}
    }
}
function isFunction(d) {
    return typeof d === 'function';
}
function functionalUpdate(updater, previous) {
    if (isFunction(updater)) return updater(previous);
    return updater;
}
function joinPaths(paths) {
    return cleanPath(paths.filter(Boolean).join('/'));
}
function cleanPath(path) {
    // remove double slashes
    return ("" + path).replace(/\/{2,}/g, '/');
}
function matchByPath(currentLocation, matchLocation) {
    var _matchLocation$to;
    var baseSegments = parsePathname(currentLocation.pathname);
    var routeSegments = parsePathname("" + ((_matchLocation$to = matchLocation.to) != null ? _matchLocation$to : '*'));
    var params = {};
    var isMatch = function() {
        for(var i = 0; i < Math.max(baseSegments.length, routeSegments.length); i++){
            var baseSegment = baseSegments[i];
            var routeSegment = routeSegments[i];
            var isLastRouteSegment = i === routeSegments.length - 1;
            var isLastBaseSegment = i === baseSegments.length - 1;
            if (routeSegment) {
                if (routeSegment.type === 'wildcard') {
                    if (baseSegment != null && baseSegment.value) {
                        params['*'] = joinPaths(baseSegments.slice(i).map(function(d) {
                            return d.value;
                        }));
                        return true;
                    }
                    return false;
                }
                if (routeSegment.type === 'pathname') {
                    if (routeSegment.value === '/' && !(baseSegment != null && baseSegment.value)) return true;
                    if (baseSegment) {
                        if (matchLocation.caseSensitive) {
                            if (routeSegment.value !== baseSegment.value) return false;
                        } else if (routeSegment.value.toLowerCase() !== baseSegment.value.toLowerCase()) return false;
                    }
                }
                if (!baseSegment) return false;
                if (routeSegment.type === 'param') params[routeSegment.value.substring(1)] = baseSegment.value;
            }
            if (isLastRouteSegment && !isLastBaseSegment) return !!matchLocation.fuzzy;
        }
        return true;
    }();
    return isMatch ? params : undefined;
}
function matchBySearch(currentLocation, matchLocation) {
    return !!(matchLocation.search && matchLocation.search(currentLocation.search));
}
function parsePathname(pathname) {
    if (!pathname) return [];
    pathname = cleanPath(pathname);
    var segments = [];
    if (pathname.slice(0, 1) === '/') {
        pathname = pathname.substring(1);
        segments.push({
            type: 'pathname',
            value: '/'
        });
    }
    if (!pathname) return segments;
     // Remove empty segments and '.' segments
    var split = pathname.split('/').filter(Boolean);
    segments.push.apply(segments, split.map(function(part) {
        if (part.startsWith('*')) return {
            type: 'wildcard',
            value: part
        };
        if (part.charAt(0) === ':') return {
            type: 'param',
            value: part
        };
        return {
            type: 'pathname',
            value: part
        };
    }));
    if (pathname.slice(-1) === '/') {
        pathname = pathname.substring(1);
        segments.push({
            type: 'pathname',
            value: '/'
        });
    }
    return segments;
}
function resolvePath(basepath, base, to) {
    base = base.replace(new RegExp("^" + basepath), '/');
    to = to.replace(new RegExp("^" + basepath), '/');
    var baseSegments = parsePathname(base);
    var toSegments = parsePathname(to);
    toSegments.forEach(function(toSegment, index) {
        if (toSegment.value === '/') {
            if (!index) // Leading slash
            baseSegments = [
                toSegment
            ];
            else if (index === toSegments.length - 1) // Trailing Slash
            baseSegments.push(toSegment);
        } else if (toSegment.value === '..') baseSegments.pop();
        else if (toSegment.value === '.') return;
        else baseSegments.push(toSegment);
    });
    var joined = joinPaths([
        basepath
    ].concat(baseSegments.map(function(d) {
        return d.value;
    })));
    return cleanPath(joined);
}
function isCtrlEvent(e) {
    return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function useLatestCallback(cb) {
    var stableFnRef = _react.useRef();
    var cbRef = _react.useRef(cb);
    cbRef.current = cb;
    if (!stableFnRef.current) stableFnRef.current = function() {
        return cbRef.current.apply(cbRef, arguments);
    };
    return stableFnRef.current;
}
function useGetIsMounted() {
    var ref = _react.useRef(false);
    _react.useEffect(function() {
        ref.current = true;
        return function() {
            ref.current = false;
        };
    });
    return function() {
        return ref.current;
    };
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function replaceEqualDeep(prev, next) {
    if (prev === next) return prev;
    var array = Array.isArray(prev) && Array.isArray(next);
    if (array || isPlainObject(prev) && isPlainObject(next)) {
        var aSize = array ? prev.length : Object.keys(prev).length;
        var bItems = array ? next : Object.keys(next);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = replaceEqualDeep(prev[key], next[key]);
            if (copy[key] === prev[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? prev : copy;
    }
    return next;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function defaultStringifySearch(search) {
    search = _extends({}, search);
    if (search) Object.keys(search).forEach(function(key) {
        var val = search[key];
        if (typeof val === 'undefined' || val === undefined) delete search[key];
        else if (val && typeof val === 'object' && val !== null) try {
            search[key] = JSON.stringify(val);
        } catch (err) {}
    });
    var searchStr = new URLSearchParams(search).toString();
    return searchStr ? "?" + searchStr : '';
}
function defaultParseSearch(searchStr) {
    if (searchStr.substring(0, 1) === '?') searchStr = searchStr.substring(1);
    var query = Object.fromEntries(new URLSearchParams(searchStr).entries()); // Try to parse query params
    for(var key in query){
        var value = query[key];
        try {
            query[key] = JSON.parse(value);
        } catch (err) {}
    }
    return query;
}

},{"react":"2o0ib","history":"BWYkk","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"BWYkk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var readOnly = function(obj) {
    return Object.freeze(obj);
};
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var BeforeUnloadEventType = 'beforeunload';
var HashChangeEventType = 'hashchange';
var PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = Action.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                } else // Trying to POP to a location with no index. We did not create
                // this location, so we can't effectively block the navigation.
                warning(false, // detail and link to it here so people can understand better what
                // is going on and how to avoid it.
                "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.");
            } else applyTx(nextAction);
        }
    }
    window.addEventListener(PopStateEventType, handlePop);
    var action = Action.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = createEvents();
    var blockers = createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, _extendsDefault.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : createPath(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return readOnly((0, _extendsDefault.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? parsePath(to) : to, {
            state: state,
            key: createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = Action.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = Action.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener(BeforeUnloadEventType, promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = parsePath(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = Action.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                } else // Trying to POP to a location with no index. We did not create
                // this location, so we can't effectively block the navigation.
                warning(false, // detail and link to it here so people can understand better
                // what is going on and how to avoid it.
                "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.");
            } else applyTx(nextAction);
        }
    }
    window.addEventListener(PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener(HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if (createPath(nextLocation) !== createPath(location)) handlePop();
    });
    var action = Action.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = createEvents();
    var blockers = createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, _extendsDefault.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : createPath(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return readOnly((0, _extendsDefault.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? parsePath(to) : to, {
            state: state,
            key: createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = Action.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        warning(nextLocation.pathname.charAt(0) === '/', "Relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = Action.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        warning(nextLocation.pathname.charAt(0) === '/', "Relative pathnames are not supported in hash history.replace(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener(BeforeUnloadEventType, promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = readOnly((0, _extendsDefault.default)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: createKey()
        }, typeof entry === 'string' ? parsePath(entry) : entry));
        warning(location.pathname.charAt(0) === '/', "Relative pathnames are not supported in createMemoryHistory({ initialEntries }) (invalid entry: " + JSON.stringify(entry) + ")");
        return location;
    });
    var index = clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = Action.Pop;
    var location = entries[index];
    var listeners = createEvents();
    var blockers = createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : createPath(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return readOnly((0, _extendsDefault.default)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? parsePath(to) : to, {
            state: state,
            key: createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = Action.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        warning(location.pathname.charAt(0) === '/', "Relative pathnames are not supported in memory history.push(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = Action.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        warning(location.pathname.charAt(0) === '/', "Relative pathnames are not supported in memory history.replace(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = clamp(index + delta, 0, entries.length - 1);
        var nextAction = Action.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function createPath(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}

},{"@babel/runtime/helpers/esm/extends":"8TqnM","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8TqnM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bn6EL":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"dfBtT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rankRoutes", ()=>rankRoutes);
var _reactLocation = require("react-location");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function rankRoutes(routes) {
    return [].concat(routes).map(function(d, i) {
        return _extends({}, d, {
            index: i
        });
    }).sort(function(a, b) {
        if (a.search || b.search) {
            if (!b.search) return -1;
            if (!a.search) return 1;
        }
        var aSegments = (0, _reactLocation.parsePathname)(a.path);
        var bSegments = (0, _reactLocation.parsePathname)(b.path); // Multi-sort by each segment
        var _loop = function _loop(i) {
            var aSegment = aSegments[i];
            var bSegment = bSegments[i];
            if (aSegment && bSegment) {
                var sort = 0;
                [
                    {
                        key: 'value',
                        value: '*'
                    },
                    {
                        key: 'value',
                        value: '/'
                    },
                    {
                        key: 'type',
                        value: 'param'
                    }
                ].some(function(condition) {
                    if ([
                        aSegment[condition.key],
                        bSegment[condition.key]
                    ].includes(condition.value) && aSegment[condition.key] !== bSegment[condition.key]) {
                        sort = aSegment[condition.key] === condition.value ? 1 : -1;
                        return true;
                    }
                    return false;
                });
                if (sort !== 0) return {
                    v: sort
                };
            } else // Then shorter segments last
            return {
                v: aSegment ? -1 : 1
            };
        };
        for(var i = 0; i < aSegments.length; i++){
            var _ret = _loop(i);
            if (typeof _ret === "object") return _ret.v;
        } // Keep things stable by route index
        return a.index - b.index;
    });
}

},{"react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"244ua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTranslation", ()=>useTranslation);
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _context = require("./context");
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var usePrevious = function usePrevious(value, ignore) {
    var ref = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function useTranslation(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, _react.useContext)((0, _context.I18nContext)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, _context.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, _context.ReportNamespaces)();
    if (!i18n) {
        (0, _utils.warnOnce)('You will need to pass in an i18next instance by using initReactI18next');
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, _utils.warnOnce)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, (0, _context.getDefaults)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, _utils.hasLoadedNamespace)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, _react.useState)(getT), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = usePrevious(joinedNS);
    var isMounted = (0, _react.useRef)(true);
    (0, _react.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, _utils.loadNamespaces)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, _react.useRef)(true);
    (0, _react.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, _utils.loadNamespaces)(i18n, namespaces, function() {
            resolve();
        });
    });
}

},{"@babel/runtime/helpers/slicedToArray":"3DFNa","@babel/runtime/helpers/defineProperty":"kbTlt","react":"2o0ib","./context":"5E9U1","./utils":"R6Vgu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3DFNa":[function(require,module,exports,__globalThis) {
var arrayWithHoles = require("a3af206dbd14b1b5");
var iterableToArrayLimit = require("c109e0e3b1a7ef05");
var unsupportedIterableToArray = require("6782568c4383bd49");
var nonIterableRest = require("1e06d43f4bd6e532");
function _slicedToArray(r, e) {
    return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a3af206dbd14b1b5":"fwEvO","c109e0e3b1a7ef05":"gXZCJ","6782568c4383bd49":"1WM4T","1e06d43f4bd6e532":"kdAb3"}],"fwEvO":[function(require,module,exports,__globalThis) {
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"gXZCJ":[function(require,module,exports,__globalThis) {
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"1WM4T":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
    }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"g91MD"}],"g91MD":[function(require,module,exports,__globalThis) {
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"kdAb3":[function(require,module,exports,__globalThis) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"kbTlt":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("29ac19868e7f119");
function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"29ac19868e7f119":"bdFy6"}],"bdFy6":[function(require,module,exports,__globalThis) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"G4w5m","2713647ce51d8c75":"7wlIL"}],"G4w5m":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"7wlIL":[function(require,module,exports,__globalThis) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"G4w5m"}],"5E9U1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18nContext", ()=>I18nContext);
parcelHelpers.export(exports, "setDefaults", ()=>setDefaults);
parcelHelpers.export(exports, "getDefaults", ()=>getDefaults);
parcelHelpers.export(exports, "ReportNamespaces", ()=>ReportNamespaces);
parcelHelpers.export(exports, "setI18n", ()=>setI18n);
parcelHelpers.export(exports, "getI18n", ()=>getI18n);
parcelHelpers.export(exports, "initReactI18next", ()=>initReactI18next);
parcelHelpers.export(exports, "composeInitialProps", ()=>composeInitialProps);
parcelHelpers.export(exports, "getInitialProps", ()=>getInitialProps);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _unescape = require("./unescape");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, _unescape.unescape)
};
var i18nInstance;
var I18nContext = (0, _react.createContext)();
function setDefaults() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
    return defaultOptions;
}
var ReportNamespaces = function() {
    function ReportNamespaces() {
        (0, _classCallCheckDefault.default)(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, _createClassDefault.default)(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function setI18n(instance) {
    i18nInstance = instance;
}
function getI18n() {
    return i18nInstance;
}
var initReactI18next = {
    type: '3rdParty',
    init: function init(instance) {
        setDefaults(instance.options.react);
        setI18n(instance);
    }
};
function composeInitialProps(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = getInitialProps();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function getInitialProps() {
    var i18n = getI18n();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

},{"@babel/runtime/helpers/classCallCheck":"bvGON","@babel/runtime/helpers/createClass":"lx49c","@babel/runtime/helpers/defineProperty":"kbTlt","react":"2o0ib","./unescape":"624ZC","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bvGON":[function(require,module,exports,__globalThis) {
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"lx49c":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"bdFy6"}],"624ZC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unescape", ()=>unescape);
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return htmlEntities[m];
};
var unescape = function unescape(text) {
    return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"R6Vgu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
parcelHelpers.export(exports, "loadNamespaces", ()=>loadNamespaces);
parcelHelpers.export(exports, "hasLoadedNamespace", ()=>hasLoadedNamespace);
parcelHelpers.export(exports, "getDisplayName", ()=>getDisplayName);
function warn() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var alreadyWarned = {};
function warnOnce() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
    warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    });
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function hasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        warnOnce('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function getDisplayName(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ksTpv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("./core");
parcelHelpers.exportAll(_core, exports);
var _react = require("./react");
parcelHelpers.exportAll(_react, exports);

},{"./core":"j1WGg","./react":"61FTl","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"j1WGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>(0, _retryer.CancelledError));
parcelHelpers.export(exports, "QueryCache", ()=>(0, _queryCache.QueryCache));
parcelHelpers.export(exports, "QueryClient", ()=>(0, _queryClient.QueryClient));
parcelHelpers.export(exports, "QueryObserver", ()=>(0, _queryObserver.QueryObserver));
parcelHelpers.export(exports, "QueriesObserver", ()=>(0, _queriesObserver.QueriesObserver));
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>(0, _infiniteQueryObserver.InfiniteQueryObserver));
parcelHelpers.export(exports, "MutationCache", ()=>(0, _mutationCache.MutationCache));
parcelHelpers.export(exports, "MutationObserver", ()=>(0, _mutationObserver.MutationObserver));
parcelHelpers.export(exports, "setLogger", ()=>(0, _logger.setLogger));
parcelHelpers.export(exports, "notifyManager", ()=>(0, _notifyManager.notifyManager));
parcelHelpers.export(exports, "focusManager", ()=>(0, _focusManager.focusManager));
parcelHelpers.export(exports, "onlineManager", ()=>(0, _onlineManager.onlineManager));
parcelHelpers.export(exports, "hashQueryKey", ()=>(0, _utils.hashQueryKey));
parcelHelpers.export(exports, "isError", ()=>(0, _utils.isError));
parcelHelpers.export(exports, "isCancelledError", ()=>(0, _retryer.isCancelledError));
parcelHelpers.export(exports, "dehydrate", ()=>(0, _hydration.dehydrate)) // Types
;
parcelHelpers.export(exports, "hydrate", ()=>(0, _hydration.hydrate));
var _retryer = require("./retryer");
var _queryCache = require("./queryCache");
var _queryClient = require("./queryClient");
var _queryObserver = require("./queryObserver");
var _queriesObserver = require("./queriesObserver");
var _infiniteQueryObserver = require("./infiniteQueryObserver");
var _mutationCache = require("./mutationCache");
var _mutationObserver = require("./mutationObserver");
var _logger = require("./logger");
var _notifyManager = require("./notifyManager");
var _focusManager = require("./focusManager");
var _onlineManager = require("./onlineManager");
var _utils = require("./utils");
var _hydration = require("./hydration");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./retryer":"4tuuA","./queryCache":"abmio","./queryClient":"2PQtD","./queryObserver":"1A6Zx","./queriesObserver":"dQGby","./infiniteQueryObserver":"hgKaA","./mutationCache":"hlK9j","./mutationObserver":"jnFbY","./logger":"h1udr","./notifyManager":"kUQ45","./focusManager":"7wXey","./onlineManager":"haatB","./utils":"bmATy","./hydration":"6YsUD","./types":"5KXpg","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4tuuA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCancelable", ()=>isCancelable);
parcelHelpers.export(exports, "CancelledError", ()=>CancelledError);
parcelHelpers.export(exports, "isCancelledError", ()=>isCancelledError) // CLASS
;
parcelHelpers.export(exports, "Retryer", ()=>Retryer);
var _focusManager = require("./focusManager");
var _onlineManager = require("./onlineManager");
var _utils = require("./utils");
function defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function isCancelable(value) {
    return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
    return value instanceof CancelledError;
}
var Retryer = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new CancelledError(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if (isCancelable(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = isCancelable(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
            var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, _utils.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, _focusManager.focusManager).isFocused() || !(0, _onlineManager.onlineManager).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};

},{"./focusManager":"7wXey","./onlineManager":"haatB","./utils":"bmATy","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7wXey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
parcelHelpers.export(exports, "focusManager", ()=>focusManager);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _subscribable = require("./subscribable");
var _utils = require("./utils");
var FocusManager = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, _utils.isServer) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === 'boolean') _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, _subscribable.Subscribable));
var focusManager = new FocusManager();

},{"@babel/runtime/helpers/esm/inheritsLoose":"j0wxw","./subscribable":"8Yiha","./utils":"bmATy","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"j0wxw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"3Y52A","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3Y52A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8Yiha":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscribable", ()=>Subscribable);
var Subscribable = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bmATy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServer", ()=>isServer);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "isValidTimeout", ()=>isValidTimeout);
parcelHelpers.export(exports, "ensureQueryKeyArray", ()=>ensureQueryKeyArray);
parcelHelpers.export(exports, "difference", ()=>difference);
parcelHelpers.export(exports, "replaceAt", ()=>replaceAt);
parcelHelpers.export(exports, "timeUntilStale", ()=>timeUntilStale);
parcelHelpers.export(exports, "parseQueryArgs", ()=>parseQueryArgs);
parcelHelpers.export(exports, "parseMutationArgs", ()=>parseMutationArgs);
parcelHelpers.export(exports, "parseFilterArgs", ()=>parseFilterArgs);
parcelHelpers.export(exports, "parseMutationFilterArgs", ()=>parseMutationFilterArgs);
parcelHelpers.export(exports, "mapQueryStatusFilter", ()=>mapQueryStatusFilter);
parcelHelpers.export(exports, "matchQuery", ()=>matchQuery);
parcelHelpers.export(exports, "matchMutation", ()=>matchMutation);
parcelHelpers.export(exports, "hashQueryKeyByOptions", ()=>hashQueryKeyByOptions);
/**
 * Default query keys hash function.
 */ parcelHelpers.export(exports, "hashQueryKey", ()=>hashQueryKey);
/**
 * Hashes the value into a stable hash.
 */ parcelHelpers.export(exports, "stableValueHash", ()=>stableValueHash);
/**
 * Checks if key `b` partially matches with key `a`.
 */ parcelHelpers.export(exports, "partialMatchKey", ()=>partialMatchKey);
/**
 * Checks if `b` partially matches with `a`.
 */ parcelHelpers.export(exports, "partialDeepEqual", ()=>partialDeepEqual);
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects) // Copied from: https://github.com/jonschlinkert/is-plain-object
;
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isQueryKey", ()=>isQueryKey);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "sleep", ()=>sleep);
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ parcelHelpers.export(exports, "scheduleMicrotask", ()=>scheduleMicrotask);
parcelHelpers.export(exports, "getAbortController", ()=>getAbortController);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var isServer = typeof window === 'undefined';
function noop() {
    return undefined;
}
function functionalUpdate(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function difference(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function replaceAt(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
    if (!isQueryKey(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, _extendsDefault.default)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, _extendsDefault.default)({}, arg2, {
        queryKey: arg1
    });
}
function parseMutationArgs(arg1, arg2, arg3) {
    if (isQueryKey(arg1)) {
        if (typeof arg2 === 'function') return (0, _extendsDefault.default)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, _extendsDefault.default)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, _extendsDefault.default)({}, arg2, {
        mutationFn: arg1
    });
    return (0, _extendsDefault.default)({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
    return isQueryKey(arg1) ? [
        (0, _extendsDefault.default)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function parseMutationFilterArgs(arg1, arg2) {
    return isQueryKey(arg1) ? (0, _extendsDefault.default)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return 'all';
    else if (active === false && inactive === false) return 'none';
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? 'active' : 'inactive';
    }
}
function matchQuery(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if (isQueryKey(queryKey)) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = mapQueryStatusFilter(active, inactive);
    if (queryStatusFilter === 'none') return false;
    else if (queryStatusFilter !== 'all') {
        var isActive = query.isActive();
        if (queryStatusFilter === 'active' && !isActive) return false;
        if (queryStatusFilter === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetching === 'boolean' && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if (isQueryKey(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
    return hashFn(queryKey);
}
function hashQueryKey(queryKey) {
    var asArray = ensureQueryKeyArray(queryKey);
    return stableValueHash(asArray);
}
function stableValueHash(value) {
    return JSON.stringify(value, function(_, val) {
        return isPlainObject(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function partialMatchKey(a, b) {
    return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
function partialDeepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some(function(key) {
        return !partialDeepEqual(a[key], b[key]);
    });
    return false;
}
function replaceEqualDeep(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || isPlainObject(a) && isPlainObject(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = replaceEqualDeep(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function shallowEqualObjects(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function isQueryKey(value) {
    return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
    return value instanceof Error;
}
function sleep(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function scheduleMicrotask(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function getAbortController() {
    if (typeof AbortController === 'function') return new AbortController();
}

},{"@babel/runtime/helpers/esm/extends":"8TqnM","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"haatB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineManager", ()=>OnlineManager);
parcelHelpers.export(exports, "onlineManager", ()=>onlineManager);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _subscribable = require("./subscribable");
var _utils = require("./utils");
var OnlineManager = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, _utils.isServer) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener('online', listener, false);
                window.addEventListener('offline', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('online', listener);
                    window.removeEventListener('offline', listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === 'boolean') _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, _subscribable.Subscribable));
var onlineManager = new OnlineManager();

},{"@babel/runtime/helpers/esm/inheritsLoose":"j0wxw","./subscribable":"8Yiha","./utils":"bmATy","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"abmio":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryCache", ()=>QueryCache);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _utils = require("./utils");
var _query = require("./query");
var _notifyManager = require("./notifyManager");
var _subscribable = require("./subscribable");
var QueryCache = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, _utils.hashQueryKeyByOptions)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, _query.Query)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'queryAdded',
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'queryRemoved',
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, _utils.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find(function(query) {
            return (0, _utils.matchQuery)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, _utils.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, _utils.matchQuery)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, _subscribable.Subscribable));

},{"@babel/runtime/helpers/esm/inheritsLoose":"j0wxw","./utils":"bmATy","./query":"db0r6","./notifyManager":"kUQ45","./subscribable":"8Yiha","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"db0r6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Query", ()=>Query);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _utils = require("./utils");
var _notifyManager = require("./notifyManager");
var _logger = require("./logger");
var _retryer = require("./retryer"); // TYPES
var Query = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, _extendsDefault.default)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, _utils.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, _utils.functionalUpdate)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, _utils.replaceEqualDeep)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, _utils.noop)).catch((0, _utils.noop)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, _utils.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, _utils.ensureQueryKeyArray)(this.queryKey);
        var abortController = (0, _utils.getAbortController)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, 'signal', {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject('Missing queryFn');
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, _retryer.Retryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, _retryer.isCancelledError)(error) && error.silent)) _this2.dispatch({
                    type: 'error',
                    error: error
                });
                if (!(0, _retryer.isCancelledError)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, _logger.getLogger)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, _notifyManager.notifyManager).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: 'queryUpdated',
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== 'undefined';
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== 'undefined';
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? 'success' : 'idle'
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case 'failed':
                return (0, _extendsDefault.default)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case 'pause':
                return (0, _extendsDefault.default)({}, state, {
                    isPaused: true
                });
            case 'continue':
                return (0, _extendsDefault.default)({}, state, {
                    isPaused: false
                });
            case 'fetch':
                return (0, _extendsDefault.default)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: 'loading'
                });
            case 'success':
                return (0, _extendsDefault.default)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: 'success'
                });
            case 'error':
                var error = action.error;
                if ((0, _retryer.isCancelledError)(error) && error.revert && this.revertState) return (0, _extendsDefault.default)({}, this.revertState);
                return (0, _extendsDefault.default)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: 'error'
                });
            case 'invalidate':
                return (0, _extendsDefault.default)({}, state, {
                    isInvalidated: true
                });
            case 'setState':
                return (0, _extendsDefault.default)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();

},{"@babel/runtime/helpers/esm/extends":"8TqnM","./utils":"bmATy","./notifyManager":"kUQ45","./logger":"h1udr","./retryer":"4tuuA","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kUQ45":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotifyManager", ()=>NotifyManager);
parcelHelpers.export(exports, "notifyManager", ()=>notifyManager);
var _utils = require("./utils"); // TYPES
var NotifyManager = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, _utils.scheduleMicrotask)(function() {
            _this.notifyFn(callback);
        });
    };
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, _utils.scheduleMicrotask)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    };
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    };
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var notifyManager = new NotifyManager();

},{"./utils":"bmATy","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h1udr":[function(require,module,exports,__globalThis) {
// TYPES
// FUNCTIONS
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLogger", ()=>getLogger);
parcelHelpers.export(exports, "setLogger", ()=>setLogger);
var logger = console;
function getLogger() {
    return logger;
}
function setLogger(newLogger) {
    logger = newLogger;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2PQtD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClient", ()=>QueryClient);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _utils = require("./utils");
var _queryCache = require("./queryCache");
var _mutationCache = require("./mutationCache");
var _focusManager = require("./focusManager");
var _onlineManager = require("./onlineManager");
var _notifyManager = require("./notifyManager");
var _infiniteQueryBehavior = require("./infiniteQueryBehavior");
var QueryClient = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, _queryCache.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, _mutationCache.MutationCache)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, _focusManager.focusManager).subscribe(function() {
            if ((0, _focusManager.focusManager).isFocused() && (0, _onlineManager.onlineManager).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, _onlineManager.onlineManager).subscribe(function() {
            if ((0, _focusManager.focusManager).isFocused() && (0, _onlineManager.onlineManager).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, _utils.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, _extendsDefault.default)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, _utils.parseQueryArgs)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, _notifyManager.notifyManager).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, _utils.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, _notifyManager.notifyManager).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, _extendsDefault.default)({}, filters, {
            active: true
        });
        return (0, _notifyManager.notifyManager).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        var promises = (0, _notifyManager.notifyManager).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, _utils.noop)).catch((0, _utils.noop));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, _extendsDefault.default)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, _notifyManager.notifyManager).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, _notifyManager.notifyManager).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, _extendsDefault.default)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, _utils.noop));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, _utils.noop));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, _utils.noop)).catch((0, _utils.noop));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, _infiniteQueryBehavior.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, _utils.noop)).catch((0, _utils.noop));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, _notifyManager.notifyManager).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, _utils.noop)).catch((0, _utils.noop));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, _utils.hashQueryKey)(queryKey) === (0, _utils.hashQueryKey)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, _utils.partialMatchKey)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, _utils.hashQueryKey)(mutationKey) === (0, _utils.hashQueryKey)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, _utils.partialMatchKey)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, _extendsDefault.default)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, _utils.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, _extendsDefault.default)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();

},{"@babel/runtime/helpers/esm/extends":"8TqnM","./utils":"bmATy","./queryCache":"abmio","./mutationCache":"hlK9j","./focusManager":"7wXey","./onlineManager":"haatB","./notifyManager":"kUQ45","./infiniteQueryBehavior":"h6DNz","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hlK9j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationCache", ()=>MutationCache);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _notifyManager = require("./notifyManager");
var _mutation = require("./mutation");
var _utils = require("./utils");
var _subscribable = require("./subscribable"); // TYPES
var MutationCache = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, _mutation.Mutation)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, _utils.matchMutation)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, _utils.matchMutation)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, _notifyManager.notifyManager).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, _utils.noop));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, _subscribable.Subscribable));

},{"@babel/runtime/helpers/esm/inheritsLoose":"j0wxw","./notifyManager":"kUQ45","./mutation":"ip9LY","./utils":"bmATy","./subscribable":"8Yiha","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ip9LY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutation", ()=>Mutation);
parcelHelpers.export(exports, "getDefaultState", ()=>getDefaultState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _logger = require("./logger");
var _notifyManager = require("./notifyManager");
var _retryer = require("./retryer");
var _utils = require("./utils"); // TYPES
var Mutation = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, _extendsDefault.default)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || getDefaultState();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, _utils.noop)).catch((0, _utils.noop));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === 'loading';
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: 'loading',
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, _logger.getLogger)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: 'error',
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, _retryer.Retryer)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject('No mutationFn found');
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = reducer(this.state, action);
        (0, _notifyManager.notifyManager).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function getDefaultState() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}
function reducer(state, action) {
    switch(action.type){
        case 'failed':
            return (0, _extendsDefault.default)({}, state, {
                failureCount: state.failureCount + 1
            });
        case 'pause':
            return (0, _extendsDefault.default)({}, state, {
                isPaused: true
            });
        case 'continue':
            return (0, _extendsDefault.default)({}, state, {
                isPaused: false
            });
        case 'loading':
            return (0, _extendsDefault.default)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: 'loading',
                variables: action.variables
            });
        case 'success':
            return (0, _extendsDefault.default)({}, state, {
                data: action.data,
                error: null,
                status: 'success',
                isPaused: false
            });
        case 'error':
            return (0, _extendsDefault.default)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: 'error'
            });
        case 'setState':
            return (0, _extendsDefault.default)({}, state, action.state);
        default:
            return state;
    }
}

},{"@babel/runtime/helpers/esm/extends":"8TqnM","./logger":"h1udr","./notifyManager":"kUQ45","./retryer":"4tuuA","./utils":"bmATy","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h6DNz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "infiniteQueryBehavior", ()=>infiniteQueryBehavior);
parcelHelpers.export(exports, "getNextPageParam", ()=>getNextPageParam);
parcelHelpers.export(exports, "getPreviousPageParam", ()=>getPreviousPageParam);
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ parcelHelpers.export(exports, "hasNextPage", ()=>hasNextPage);
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ parcelHelpers.export(exports, "hasPreviousPage", ()=>hasPreviousPage);
var _retryer = require("./retryer");
var _utils = require("./utils");
function infiniteQueryBehavior() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, _utils.getAbortController)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject('Missing queryFn');
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, _retryer.isCancelable)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== 'undefined';
                    var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== 'undefined';
                    var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === 'undefined';
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, _retryer.isCancelable)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function getNextPageParam(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function hasNextPage(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = getNextPageParam(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
}
function hasPreviousPage(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = getPreviousPageParam(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
}

},{"./retryer":"4tuuA","./utils":"bmATy","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1A6Zx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryObserver", ()=>QueryObserver);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _utils = require("./utils");
var _notifyManager = require("./notifyManager");
var _focusManager = require("./focusManager");
var _subscribable = require("./subscribable");
var _logger = require("./logger");
var _retryer = require("./retryer");
var QueryObserver = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if (shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp('error');
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, _extendsDefault.default)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, _utils.noop));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, _utils.isServer) || this.currentResult.isStale || !(0, _utils.isValidTimeout)(this.options.staleTime)) return;
        var time = (0, _utils.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, _utils.isServer) || this.options.enabled === false || !(0, _utils.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, _focusManager.focusManager).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = 'loading';
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, _utils.replaceEqualDeep)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, _logger.getLogger)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, _utils.replaceEqualDeep)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, _logger.getLogger)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        var result = {
            status: status,
            isLoading: status === 'loading',
            isSuccess: status === 'success',
            isError: status === 'error',
            isIdle: status === 'idle',
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== 'loading',
            isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
            isStale: isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, _utils.shallowEqualObjects)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, _extendsDefault.default)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error' && !(0, _retryer.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    };
    return QueryObserver;
}((0, _subscribable.Subscribable));
function shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}
function isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}

},{"@babel/runtime/helpers/esm/extends":"8TqnM","@babel/runtime/helpers/esm/inheritsLoose":"j0wxw","./utils":"bmATy","./notifyManager":"kUQ45","./focusManager":"7wXey","./subscribable":"8Yiha","./logger":"h1udr","./retryer":"4tuuA","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dQGby":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueriesObserver", ()=>QueriesObserver);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _utils = require("./utils");
var _notifyManager = require("./notifyManager");
var _queryObserver = require("./queryObserver");
var _subscribable = require("./subscribable");
var QueriesObserver = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(QueriesObserver, _Subscribable);
    function QueriesObserver(client, queries) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.queries = [];
        _this.result = [];
        _this.observers = [];
        _this.observersMap = {};
        if (queries) _this.setQueries(queries);
        return _this;
    }
    var _proto = QueriesObserver.prototype;
    _proto.onSubscribe = function onSubscribe() {
        var _this2 = this;
        if (this.listeners.length === 1) this.observers.forEach(function(observer) {
            observer.subscribe(function(result) {
                _this2.onUpdate(observer, result);
            });
        });
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.observers.forEach(function(observer) {
            observer.destroy();
        });
    };
    _proto.setQueries = function setQueries(queries, notifyOptions) {
        this.queries = queries;
        this.updateObservers(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.result;
    };
    _proto.getOptimisticResult = function getOptimisticResult(queries) {
        return this.findMatchingObservers(queries).map(function(match) {
            return match.observer.getOptimisticResult(match.defaultedQueryOptions);
        });
    };
    _proto.findMatchingObservers = function findMatchingObservers(queries) {
        var _this3 = this;
        var prevObservers = this.observers;
        var defaultedQueryOptions = queries.map(function(options) {
            return _this3.client.defaultQueryObserverOptions(options);
        });
        var matchingObservers = defaultedQueryOptions.flatMap(function(defaultedOptions) {
            var match = prevObservers.find(function(observer) {
                return observer.options.queryHash === defaultedOptions.queryHash;
            });
            if (match != null) return [
                {
                    defaultedQueryOptions: defaultedOptions,
                    observer: match
                }
            ];
            return [];
        });
        var matchedQueryHashes = matchingObservers.map(function(match) {
            return match.defaultedQueryOptions.queryHash;
        });
        var unmatchedQueries = defaultedQueryOptions.filter(function(defaultedOptions) {
            return !matchedQueryHashes.includes(defaultedOptions.queryHash);
        });
        var unmatchedObservers = prevObservers.filter(function(prevObserver) {
            return !matchingObservers.some(function(match) {
                return match.observer === prevObserver;
            });
        });
        var newOrReusedObservers = unmatchedQueries.map(function(options, index) {
            if (options.keepPreviousData) {
                // return previous data from one of the observers that no longer match
                var previouslyUsedObserver = unmatchedObservers[index];
                if (previouslyUsedObserver !== undefined) return {
                    defaultedQueryOptions: options,
                    observer: previouslyUsedObserver
                };
            }
            return {
                defaultedQueryOptions: options,
                observer: _this3.getObserver(options)
            };
        });
        var sortMatchesByOrderOfQueries = function sortMatchesByOrderOfQueries(a, b) {
            return defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
        };
        return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    };
    _proto.getObserver = function getObserver(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var currentObserver = this.observersMap[defaultedOptions.queryHash];
        return currentObserver != null ? currentObserver : new (0, _queryObserver.QueryObserver)(this.client, defaultedOptions);
    };
    _proto.updateObservers = function updateObservers(notifyOptions) {
        var _this4 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            var prevObservers = _this4.observers;
            var newObserverMatches = _this4.findMatchingObservers(_this4.queries); // set options for the new observers to notify of changes
            newObserverMatches.forEach(function(match) {
                return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
            });
            var newObservers = newObserverMatches.map(function(match) {
                return match.observer;
            });
            var newObserversMap = Object.fromEntries(newObservers.map(function(observer) {
                return [
                    observer.options.queryHash,
                    observer
                ];
            }));
            var newResult = newObservers.map(function(observer) {
                return observer.getCurrentResult();
            });
            var hasIndexChange = newObservers.some(function(observer, index) {
                return observer !== prevObservers[index];
            });
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            _this4.observers = newObservers;
            _this4.observersMap = newObserversMap;
            _this4.result = newResult;
            if (!_this4.hasListeners()) return;
            (0, _utils.difference)(prevObservers, newObservers).forEach(function(observer) {
                observer.destroy();
            });
            (0, _utils.difference)(newObservers, prevObservers).forEach(function(observer) {
                observer.subscribe(function(result) {
                    _this4.onUpdate(observer, result);
                });
            });
            _this4.notify();
        });
    };
    _proto.onUpdate = function onUpdate(observer, result) {
        var index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.result = (0, _utils.replaceAt)(this.result, index, result);
            this.notify();
        }
    };
    _proto.notify = function notify() {
        var _this5 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this5.listeners.forEach(function(listener) {
                listener(_this5.result);
            });
        });
    };
    return QueriesObserver;
}((0, _subscribable.Subscribable));

},{"@babel/runtime/helpers/esm/inheritsLoose":"j0wxw","./utils":"bmATy","./notifyManager":"kUQ45","./queryObserver":"1A6Zx","./subscribable":"8Yiha","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hgKaA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>InfiniteQueryObserver);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _queryObserver = require("./queryObserver");
var _infiniteQueryBehavior = require("./infiniteQueryBehavior");
var InfiniteQueryObserver = /*#__PURE__*/ function(_QueryObserver) {
    (0, _inheritsLooseDefault.default)(InfiniteQueryObserver, _QueryObserver);
    // Type override
    // Type override
    // Type override
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function InfiniteQueryObserver(client, options) {
        return _QueryObserver.call(this, client, options) || this;
    }
    var _proto = InfiniteQueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        _QueryObserver.prototype.bindMethods.call(this);
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        _QueryObserver.prototype.setOptions.call(this, (0, _extendsDefault.default)({}, options, {
            behavior: (0, _infiniteQueryBehavior.infiniteQueryBehavior)()
        }), notifyOptions);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        options.behavior = (0, _infiniteQueryBehavior.infiniteQueryBehavior)();
        return _QueryObserver.prototype.getOptimisticResult.call(this, options);
    };
    _proto.fetchNextPage = function fetchNextPage(options) {
        var _options$cancelRefetc;
        return this.fetch({
            // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
            cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
            throwOnError: options == null ? void 0 : options.throwOnError,
            meta: {
                fetchMore: {
                    direction: 'forward',
                    pageParam: options == null ? void 0 : options.pageParam
                }
            }
        });
    };
    _proto.fetchPreviousPage = function fetchPreviousPage(options) {
        var _options$cancelRefetc2;
        return this.fetch({
            // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
            cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
            throwOnError: options == null ? void 0 : options.throwOnError,
            meta: {
                fetchMore: {
                    direction: 'backward',
                    pageParam: options == null ? void 0 : options.pageParam
                }
            }
        });
    };
    _proto.createResult = function createResult(query, options) {
        var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;
        var state = query.state;
        var result = _QueryObserver.prototype.createResult.call(this, query, options);
        return (0, _extendsDefault.default)({}, result, {
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, _infiniteQueryBehavior.hasNextPage)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
            hasPreviousPage: (0, _infiniteQueryBehavior.hasPreviousPage)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
            isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
            isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
        });
    };
    return InfiniteQueryObserver;
}((0, _queryObserver.QueryObserver));

},{"@babel/runtime/helpers/esm/extends":"8TqnM","@babel/runtime/helpers/esm/inheritsLoose":"j0wxw","./queryObserver":"1A6Zx","./infiniteQueryBehavior":"h6DNz","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jnFbY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationObserver", ()=>MutationObserver);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _mutation = require("./mutation");
var _notifyManager = require("./notifyManager");
var _subscribable = require("./subscribable");
var MutationObserver = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, _extendsDefault.default)({}, this.options, {
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, _mutation.getDefaultState)();
        var result = (0, _extendsDefault.default)({}, state, {
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, _subscribable.Subscribable));

},{"@babel/runtime/helpers/esm/extends":"8TqnM","@babel/runtime/helpers/esm/inheritsLoose":"j0wxw","./mutation":"ip9LY","./notifyManager":"kUQ45","./subscribable":"8Yiha","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6YsUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dehydrate", ()=>dehydrate);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
// TYPES
// FUNCTIONS
function dehydrateMutation(mutation) {
    return {
        mutationKey: mutation.options.mutationKey,
        state: mutation.state
    };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.
function dehydrateQuery(query) {
    return {
        state: query.state,
        queryKey: query.queryKey,
        queryHash: query.queryHash
    };
}
function defaultShouldDehydrateMutation(mutation) {
    return mutation.state.isPaused;
}
function defaultShouldDehydrateQuery(query) {
    return query.state.status === 'success';
}
function dehydrate(client, options) {
    var _options, _options2;
    options = options || {};
    var mutations = [];
    var queries = [];
    if (((_options = options) == null ? void 0 : _options.dehydrateMutations) !== false) {
        var shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
        client.getMutationCache().getAll().forEach(function(mutation) {
            if (shouldDehydrateMutation(mutation)) mutations.push(dehydrateMutation(mutation));
        });
    }
    if (((_options2 = options) == null ? void 0 : _options2.dehydrateQueries) !== false) {
        var shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
        client.getQueryCache().getAll().forEach(function(query) {
            if (shouldDehydrateQuery(query)) queries.push(dehydrateQuery(query));
        });
    }
    return {
        mutations: mutations,
        queries: queries
    };
}
function hydrate(client, dehydratedState, options) {
    if (typeof dehydratedState !== 'object' || dehydratedState === null) return;
    var mutationCache = client.getMutationCache();
    var queryCache = client.getQueryCache();
    var mutations = dehydratedState.mutations || [];
    var queries = dehydratedState.queries || [];
    mutations.forEach(function(dehydratedMutation) {
        var _options$defaultOptio;
        mutationCache.build(client, (0, _extendsDefault.default)({}, options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations, {
            mutationKey: dehydratedMutation.mutationKey
        }), dehydratedMutation.state);
    });
    queries.forEach(function(dehydratedQuery) {
        var _options$defaultOptio2;
        var query = queryCache.get(dehydratedQuery.queryHash); // Do not hydrate if an existing query exists with newer data
        if (query) {
            if (query.state.dataUpdatedAt < dehydratedQuery.state.dataUpdatedAt) query.setState(dehydratedQuery.state);
            return;
        } // Restore query
        queryCache.build(client, (0, _extendsDefault.default)({}, options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries, {
            queryKey: dehydratedQuery.queryKey,
            queryHash: dehydratedQuery.queryHash
        }), dehydratedQuery.state);
    });
}

},{"@babel/runtime/helpers/esm/extends":"8TqnM","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5KXpg":[function(require,module,exports,__globalThis) {

},{}],"61FTl":[function(require,module,exports,__globalThis) {
// Side effects
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClientProvider", ()=>(0, _queryClientProvider.QueryClientProvider));
parcelHelpers.export(exports, "useQueryClient", ()=>(0, _queryClientProvider.useQueryClient));
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundary.QueryErrorResetBoundary));
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundary.useQueryErrorResetBoundary));
parcelHelpers.export(exports, "useIsFetching", ()=>(0, _useIsFetching.useIsFetching));
parcelHelpers.export(exports, "useIsMutating", ()=>(0, _useIsMutating.useIsMutating));
parcelHelpers.export(exports, "useMutation", ()=>(0, _useMutation.useMutation));
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQuery.useQuery));
parcelHelpers.export(exports, "useQueries", ()=>(0, _useQueries.useQueries));
parcelHelpers.export(exports, "useInfiniteQuery", ()=>(0, _useInfiniteQuery.useInfiniteQuery));
parcelHelpers.export(exports, "useHydrate", ()=>(0, _hydrate.useHydrate)) // Types
;
parcelHelpers.export(exports, "Hydrate", ()=>(0, _hydrate.Hydrate));
var _setBatchUpdatesFn = require("./setBatchUpdatesFn");
var _setLogger = require("./setLogger");
var _queryClientProvider = require("./QueryClientProvider");
var _queryErrorResetBoundary = require("./QueryErrorResetBoundary");
var _useIsFetching = require("./useIsFetching");
var _useIsMutating = require("./useIsMutating");
var _useMutation = require("./useMutation");
var _useQuery = require("./useQuery");
var _useQueries = require("./useQueries");
var _useInfiniteQuery = require("./useInfiniteQuery");
var _hydrate = require("./Hydrate");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./setBatchUpdatesFn":"cVygn","./setLogger":"7Xklw","./QueryClientProvider":"4moUk","./QueryErrorResetBoundary":"eZ3bd","./useIsFetching":"hzAUo","./useIsMutating":"6Dmxr","./useMutation":"3TkkI","./useQuery":"gr327","./useQueries":"8KuD3","./useInfiniteQuery":"jhr0Y","./Hydrate":"cblXb","./types":"9Qz8V","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cVygn":[function(require,module,exports,__globalThis) {
var _core = require("../core");
var _reactBatchedUpdates = require("./reactBatchedUpdates");
(0, _core.notifyManager).setBatchNotifyFunction((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"../core":"kUQ45","./reactBatchedUpdates":"2wfYi"}],"2wfYi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>unstable_batchedUpdates);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var unstable_batchedUpdates = (0, _reactDomDefault.default).unstable_batchedUpdates;

},{"react-dom":"6WJHP","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7Xklw":[function(require,module,exports,__globalThis) {
var _core = require("../core");
var _logger = require("./logger");
(0, _core.setLogger)((0, _logger.logger));

},{"../core":"h1udr","./logger":"gBAcx"}],"gBAcx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logger", ()=>logger);
var logger = console;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4moUk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueryClient", ()=>useQueryClient);
parcelHelpers.export(exports, "QueryClientProvider", ()=>QueryClientProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var defaultContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = defaultContext;
        return window.ReactQueryClientContext;
    }
    return defaultContext;
}
var useQueryClient = function useQueryClient() {
    var queryClient = (0, _reactDefault.default).useContext(getQueryClientContext((0, _reactDefault.default).useContext(QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, _reactDefault.default).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: client
    }, children));
};

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eZ3bd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>useQueryErrorResetBoundary);
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>QueryErrorResetBoundary);
var _react = require("react"); // CONTEXT
var _reactDefault = parcelHelpers.interopDefault(_react);
function createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(createValue()); // HOOK
var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
    return (0, _reactDefault.default).useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT
var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, _reactDefault.default).useMemo(function() {
        return createValue();
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hzAUo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsFetching", ()=>useIsFetching);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notifyManager = require("../core/notifyManager");
var _utils = require("../core/utils");
var _queryClientProvider = require("./QueryClientProvider");
var checkIsFetching = function checkIsFetching(queryClient, filters, isFetching, setIsFetching) {
    var newIsFetching = queryClient.isFetching(filters);
    if (isFetching !== newIsFetching) setIsFetching(newIsFetching);
};
function useIsFetching(arg1, arg2) {
    var mountedRef = (0, _reactDefault.default).useRef(false);
    var queryClient = (0, _queryClientProvider.useQueryClient)();
    var _parseFilterArgs = (0, _utils.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs[0];
    var _React$useState = (0, _reactDefault.default).useState(queryClient.isFetching(filters)), isFetching = _React$useState[0], setIsFetching = _React$useState[1];
    var filtersRef = (0, _reactDefault.default).useRef(filters);
    filtersRef.current = filters;
    var isFetchingRef = (0, _reactDefault.default).useRef(isFetching);
    isFetchingRef.current = isFetching;
    (0, _reactDefault.default).useEffect(function() {
        mountedRef.current = true;
        checkIsFetching(queryClient, filtersRef.current, isFetchingRef.current, setIsFetching);
        var unsubscribe = queryClient.getQueryCache().subscribe((0, _notifyManager.notifyManager).batchCalls(function() {
            if (mountedRef.current) checkIsFetching(queryClient, filtersRef.current, isFetchingRef.current, setIsFetching);
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        queryClient
    ]);
    return isFetching;
}

},{"react":"2o0ib","../core/notifyManager":"kUQ45","../core/utils":"bmATy","./QueryClientProvider":"4moUk","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6Dmxr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMutating", ()=>useIsMutating);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notifyManager = require("../core/notifyManager");
var _utils = require("../core/utils");
var _queryClientProvider = require("./QueryClientProvider");
function useIsMutating(arg1, arg2) {
    var mountedRef = (0, _reactDefault.default).useRef(false);
    var filters = (0, _utils.parseMutationFilterArgs)(arg1, arg2);
    var queryClient = (0, _queryClientProvider.useQueryClient)();
    var _React$useState = (0, _reactDefault.default).useState(queryClient.isMutating(filters)), isMutating = _React$useState[0], setIsMutating = _React$useState[1];
    var filtersRef = (0, _reactDefault.default).useRef(filters);
    filtersRef.current = filters;
    var isMutatingRef = (0, _reactDefault.default).useRef(isMutating);
    isMutatingRef.current = isMutating;
    (0, _reactDefault.default).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = queryClient.getMutationCache().subscribe((0, _notifyManager.notifyManager).batchCalls(function() {
            if (mountedRef.current) {
                var newIsMutating = queryClient.isMutating(filtersRef.current);
                if (isMutatingRef.current !== newIsMutating) setIsMutating(newIsMutating);
            }
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        queryClient
    ]);
    return isMutating;
}

},{"react":"2o0ib","../core/notifyManager":"kUQ45","../core/utils":"bmATy","./QueryClientProvider":"4moUk","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3TkkI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMutation", ()=>useMutation);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notifyManager = require("../core/notifyManager");
var _utils = require("../core/utils");
var _mutationObserver = require("../core/mutationObserver");
var _queryClientProvider = require("./QueryClientProvider");
var _utils1 = require("./utils"); // HOOK
function useMutation(arg1, arg2, arg3) {
    var mountedRef = (0, _reactDefault.default).useRef(false);
    var _React$useState = (0, _reactDefault.default).useState(0), forceUpdate = _React$useState[1];
    var options = (0, _utils.parseMutationArgs)(arg1, arg2, arg3);
    var queryClient = (0, _queryClientProvider.useQueryClient)();
    var obsRef = (0, _reactDefault.default).useRef();
    if (!obsRef.current) obsRef.current = new (0, _mutationObserver.MutationObserver)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, _reactDefault.default).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, _notifyManager.notifyManager).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, _reactDefault.default).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, _utils.noop));
    }, []);
    if (currentResult.error && (0, _utils1.shouldThrowError)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, _extendsDefault.default)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}

},{"@babel/runtime/helpers/esm/extends":"8TqnM","react":"2o0ib","../core/notifyManager":"kUQ45","../core/utils":"bmATy","../core/mutationObserver":"jnFbY","./QueryClientProvider":"4moUk","./utils":"5P8Xl","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5P8Xl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldThrowError", ()=>shouldThrowError);
function shouldThrowError(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gr327":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>useQuery);
var _core = require("../core");
var _utils = require("../core/utils");
var _useBaseQuery = require("./useBaseQuery"); // HOOK
function useQuery(arg1, arg2, arg3) {
    var parsedOptions = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
    return (0, _useBaseQuery.useBaseQuery)(parsedOptions, (0, _core.QueryObserver));
}

},{"../core":"1A6Zx","../core/utils":"bmATy","./useBaseQuery":"gFaCO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gFaCO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBaseQuery", ()=>useBaseQuery);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notifyManager = require("../core/notifyManager");
var _queryErrorResetBoundary = require("./QueryErrorResetBoundary");
var _queryClientProvider = require("./QueryClientProvider");
var _utils = require("./utils");
function useBaseQuery(options, Observer) {
    var mountedRef = (0, _reactDefault.default).useRef(false);
    var _React$useState = (0, _reactDefault.default).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, _queryClientProvider.useQueryClient)();
    var errorResetBoundary = (0, _queryErrorResetBoundary.useQueryErrorResetBoundary)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, _notifyManager.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, _notifyManager.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, _notifyManager.notifyManager).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, _reactDefault.default).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, _reactDefault.default).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, _notifyManager.notifyManager).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, _reactDefault.default).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, _utils.shouldThrowError)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === 'tracked') result = observer.trackResult(result, defaultedOptions);
    return result;
}

},{"react":"2o0ib","../core/notifyManager":"kUQ45","./QueryErrorResetBoundary":"eZ3bd","./QueryClientProvider":"4moUk","./utils":"5P8Xl","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8KuD3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueries", ()=>useQueries);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notifyManager = require("../core/notifyManager");
var _queriesObserver = require("../core/queriesObserver");
var _queryClientProvider = require("./QueryClientProvider");
function useQueries(queries) {
    var mountedRef = (0, _reactDefault.default).useRef(false);
    var _React$useState = (0, _reactDefault.default).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, _queryClientProvider.useQueryClient)();
    var defaultedQueries = (0, _react.useMemo)(function() {
        return queries.map(function(options) {
            var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure the results are already in fetching state before subscribing or updating options
            defaultedOptions.optimisticResults = true;
            return defaultedOptions;
        });
    }, [
        queries,
        queryClient
    ]);
    var _React$useState2 = (0, _reactDefault.default).useState(function() {
        return new (0, _queriesObserver.QueriesObserver)(queryClient, defaultedQueries);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedQueries);
    (0, _reactDefault.default).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = observer.subscribe((0, _notifyManager.notifyManager).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        observer
    ]);
    (0, _reactDefault.default).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setQueries(defaultedQueries, {
            listeners: false
        });
    }, [
        defaultedQueries,
        observer
    ]);
    return result;
}

},{"react":"2o0ib","../core/notifyManager":"kUQ45","../core/queriesObserver":"dQGby","./QueryClientProvider":"4moUk","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jhr0Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInfiniteQuery", ()=>useInfiniteQuery);
var _infiniteQueryObserver = require("../core/infiniteQueryObserver");
var _utils = require("../core/utils");
var _useBaseQuery = require("./useBaseQuery"); // HOOK
function useInfiniteQuery(arg1, arg2, arg3) {
    var options = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
    return (0, _useBaseQuery.useBaseQuery)(options, (0, _infiniteQueryObserver.InfiniteQueryObserver));
}

},{"../core/infiniteQueryObserver":"hgKaA","../core/utils":"bmATy","./useBaseQuery":"gFaCO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cblXb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHydrate", ()=>useHydrate);
parcelHelpers.export(exports, "Hydrate", ()=>Hydrate);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("../core");
var _queryClientProvider = require("./QueryClientProvider");
function useHydrate(state, options) {
    var queryClient = (0, _queryClientProvider.useQueryClient)();
    var optionsRef = (0, _reactDefault.default).useRef(options);
    optionsRef.current = options; // Running hydrate again with the same queries is safe,
    // it wont overwrite or initialize existing queries,
    // relying on useMemo here is only a performance optimization.
    // hydrate can and should be run *during* render here for SSR to work properly
    (0, _reactDefault.default).useMemo(function() {
        if (state) (0, _core.hydrate)(queryClient, state, optionsRef.current);
    }, [
        queryClient,
        state
    ]);
}
var Hydrate = function Hydrate(_ref) {
    var children = _ref.children, options = _ref.options, state = _ref.state;
    useHydrate(state, options);
    return children;
};

},{"react":"2o0ib","../core":"6YsUD","./QueryClientProvider":"4moUk","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9Qz8V":[function(require,module,exports,__globalThis) {

},{}],"g2bIt":[function(require,module,exports,__globalThis) {
module.exports = {
    ReactQueryDevtools: function() {
        return null;
    },
    ReactQueryDevtoolsPanel: function() {
        return null;
    }
};

},{}],"jEv7X":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports, require("d99b0077bf8bdf43"));
})(this, function(exports1, React) {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
            var info = gen[key](arg);
            var value = info.value;
        } catch (error) {
            reject(error);
            return;
        }
        if (info.done) resolve(value);
        else Promise.resolve(value).then(_next, _throw);
    }
    function _asyncToGenerator(fn) {
        return function() {
            var self = this, args = arguments;
            return new Promise(function(resolve, reject) {
                var gen = fn.apply(self, args);
                function _next(value) {
                    asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                    asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(undefined);
            });
        };
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === 'object';
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === 'function';
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
    };
    var PLAIN_OBJECT_STR = '[object Object]';
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$1;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$1;
        if (isPromise(raw)) return {
            tag: 'async',
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: 'empty'
        };
        return {
            tag: 'sync',
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: 'react-stripe-js',
            version: "5.6.1"
        });
        stripe.registerAppInfo({
            name: 'react-stripe-js',
            version: "5.6.1",
            url: 'https://stripe.com/docs/stripe-js/react'
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = 'ElementsContext';
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://docs.stripe.com/sdks/stripejs-react?ui=elements#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                'clientSecret',
                'fonts'
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var CheckoutContext = /*#__PURE__*/ React.createContext(null);
    CheckoutContext.displayName = 'CheckoutContext';
    PropTypes.any, PropTypes.shape({
        clientSecret: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.instanceOf(Promise)
        ]).isRequired,
        elementsOptions: PropTypes.object
    }).isRequired;
    var useElementsOrCheckoutContextWithUseCase = function useElementsOrCheckoutContextWithUseCase(useCaseString) {
        var checkout = React.useContext(CheckoutContext);
        var elements = React.useContext(ElementsContext);
        if (checkout) {
            if (elements) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CheckoutProvider> and <Elements> providers."));
            else return checkout;
        } else return parseElementsContext(elements, useCaseString);
    };
    var _excluded = [
        "mode"
    ];
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange, onSavedPaymentMethodRemove = _ref.onSavedPaymentMethodRemove, onSavedPaymentMethodUpdate = _ref.onSavedPaymentMethodUpdate;
            var ctx = useElementsOrCheckoutContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = 'elements' in ctx ? ctx.elements : null;
            var checkoutState = 'checkoutState' in ctx ? ctx.checkoutState : null;
            var checkoutSdk = (checkoutState === null || checkoutState === void 0 ? void 0 : checkoutState.type) === 'success' || (checkoutState === null || checkoutState === void 0 ? void 0 : checkoutState.type) === 'loading' ? checkoutState.sdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, 'blur', onBlur);
            useAttachEvent(element, 'focus', onFocus);
            useAttachEvent(element, 'escape', onEscape);
            useAttachEvent(element, 'click', onClick);
            useAttachEvent(element, 'loaderror', onLoadError);
            useAttachEvent(element, 'loaderstart', onLoaderStart);
            useAttachEvent(element, 'networkschange', onNetworksChange);
            useAttachEvent(element, 'confirm', onConfirm);
            useAttachEvent(element, 'cancel', onCancel);
            useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
            useAttachEvent(element, 'shippingratechange', onShippingRateChange);
            useAttachEvent(element, 'savedpaymentmethodremove', onSavedPaymentMethodRemove);
            useAttachEvent(element, 'savedpaymentmethodupdate', onSavedPaymentMethodUpdate);
            useAttachEvent(element, 'change', onChange);
            var readyCallback;
            if (onReady) {
                if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, 'ready', readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || checkoutSdk)) {
                    var newElement = null;
                    if (checkoutSdk) switch(type){
                        case 'paymentForm':
                            newElement = checkoutSdk.createPaymentFormElement(options);
                            break;
                        case 'payment':
                            newElement = checkoutSdk.createPaymentElement(options);
                            break;
                        case 'address':
                            if ('mode' in options) {
                                var mode = options.mode, restOptions = _objectWithoutProperties(options, _excluded);
                                if (mode === 'shipping') newElement = checkoutSdk.createShippingAddressElement(restOptions);
                                else if (mode === 'billing') newElement = checkoutSdk.createBillingAddressElement(restOptions);
                                else throw new Error("Invalid options.mode. mode must be 'billing' or 'shipping'.");
                            } else throw new Error("You must supply options.mode. mode must be 'billing' or 'shipping'.");
                            break;
                        case 'expressCheckout':
                            newElement = checkoutSdk.createExpressCheckoutElement(options);
                            break;
                        case 'currencySelector':
                            newElement = checkoutSdk.createCurrencySelectorElement();
                            break;
                        case 'taxId':
                            newElement = checkoutSdk.createTaxIdElement(options);
                            break;
                        default:
                            throw new Error("Invalid Element type ".concat(displayName, ". You must use either the <PaymentElement />, <AddressElement options={{mode: 'shipping'}} />, <AddressElement options={{mode: 'billing'}} />, or <ExpressCheckoutElement />."));
                    }
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                checkoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    'paymentRequest'
                ]);
                if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCheckoutContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            onSavedPaymentMethodRemove: PropTypes.func,
            onSavedPaymentMethodUpdate: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === 'undefined';
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
        return ctx;
    };
    var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
            if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    var FinancialAccountDisclosure = function FinancialAccountDisclosure(_ref) {
        var rawStripeProp = _ref.stripe, onLoad = _ref.onLoad, onError = _ref.onError, options = _ref.options;
        var businessName = options === null || options === void 0 ? void 0 : options.businessName;
        var learnMoreLink = options === null || options === void 0 ? void 0 : options.learnMoreLink;
        var containerRef = React.useRef(null);
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(parsed.tag === 'sync' ? parsed.stripe : null), _React$useState2 = _slicedToArray(_React$useState, 2), stripeState = _React$useState2[0], setStripeState = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async') parsed.stripePromise.then(function(stripePromise) {
                if (stripePromise && isMounted) setStripeState(stripePromise);
            });
            else if (parsed.tag === 'sync') setStripeState(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on FinancialAccountDisclosure: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(stripeState);
        }, [
            stripeState
        ]);
        React.useEffect(function() {
            var createDisclosure = /*#__PURE__*/ function() {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                    var _yield$stripeState$cr, disclosureContent, error, container;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!stripeState || !containerRef.current)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 2:
                                _context.next = 4;
                                return stripeState.createFinancialAccountDisclosure({
                                    businessName: businessName,
                                    learnMoreLink: learnMoreLink
                                });
                            case 4:
                                _yield$stripeState$cr = _context.sent;
                                disclosureContent = _yield$stripeState$cr.htmlElement;
                                error = _yield$stripeState$cr.error;
                                if (error && onError) onError(error);
                                else if (disclosureContent) {
                                    container = containerRef.current;
                                    container.innerHTML = '';
                                    container.appendChild(disclosureContent);
                                    if (onLoad) onLoad();
                                }
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function createDisclosure() {
                    return _ref2.apply(this, arguments);
                };
            }();
            createDisclosure();
        }, [
            stripeState,
            businessName,
            learnMoreLink,
            onLoad,
            onError
        ]);
        return /*#__PURE__*/ React.createElement('div', {
            ref: containerRef
        });
    };
    var IssuingDisclosure = function IssuingDisclosure(_ref) {
        var rawStripeProp = _ref.stripe, onLoad = _ref.onLoad, onError = _ref.onError, options = _ref.options;
        var issuingProgramID = options === null || options === void 0 ? void 0 : options.issuingProgramID;
        var publicCardProgramName = options === null || options === void 0 ? void 0 : options.publicCardProgramName;
        var learnMoreLink = options === null || options === void 0 ? void 0 : options.learnMoreLink;
        var containerRef = React.useRef(null);
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(parsed.tag === 'sync' ? parsed.stripe : null), _React$useState2 = _slicedToArray(_React$useState, 2), stripeState = _React$useState2[0], setStripeState = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async') parsed.stripePromise.then(function(stripePromise) {
                if (stripePromise && isMounted) setStripeState(stripePromise);
            });
            else if (parsed.tag === 'sync') setStripeState(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on IssuingDisclosure: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(stripeState);
        }, [
            stripeState
        ]);
        React.useEffect(function() {
            var createDisclosure = /*#__PURE__*/ function() {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                    var _yield$stripeState$cr, disclosureContent, error, container;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!stripeState || !containerRef.current)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 2:
                                _context.next = 4;
                                return stripeState.createIssuingDisclosure({
                                    issuingProgramID: issuingProgramID,
                                    publicCardProgramName: publicCardProgramName,
                                    learnMoreLink: learnMoreLink
                                });
                            case 4:
                                _yield$stripeState$cr = _context.sent;
                                disclosureContent = _yield$stripeState$cr.htmlElement;
                                error = _yield$stripeState$cr.error;
                                if (error && onError) onError(error);
                                else if (disclosureContent) {
                                    container = containerRef.current;
                                    container.innerHTML = '';
                                    container.appendChild(disclosureContent);
                                    if (onLoad) onLoad();
                                }
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function createDisclosure() {
                    return _ref2.apply(this, arguments);
                };
            }();
            createDisclosure();
        }, [
            stripeState,
            issuingProgramID,
            publicCardProgramName,
            learnMoreLink,
            onLoad,
            onError
        ]);
        return /*#__PURE__*/ React.createElement('div', {
            ref: containerRef
        });
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCheckou = useElementsOrCheckoutContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCheckou.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent('card', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent('cardNumber', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent('cardExpiry', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent('cardCvc', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent('iban', isServer);
    var PaymentElement = createElementComponent('payment', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent('expressCheckout', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent('linkAuthentication', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent('address', isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent('shippingAddress', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent('paymentMethodMessaging', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var TaxIdElement = createElementComponent('taxId', isServer);
    exports1.AddressElement = AddressElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FinancialAccountDisclosure = FinancialAccountDisclosure;
    exports1.IbanElement = IbanElement;
    exports1.IssuingDisclosure = IssuingDisclosure;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.TaxIdElement = TaxIdElement;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});

},{"d99b0077bf8bdf43":"2o0ib"}],"4tXMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexMjs = require("../dist/index.mjs");
parcelHelpers.exportAll(_indexMjs, exports);

},{"../dist/index.mjs":"85oU9","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"85oU9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadStripe", ()=>loadStripe);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
        return typeof obj;
    };
    else _typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
var RELEASE_TRAIN = 'clover';
var runtimeVersionToUrlVersion = function runtimeVersionToUrlVersion(version) {
    return version === 3 ? 'v3' : version;
};
var ORIGIN = 'https://js.stripe.com';
var STRIPE_JS_URL = "".concat(ORIGIN, "/").concat(RELEASE_TRAIN, "/stripe.js");
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var STRIPE_JS_URL_REGEX = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var isStripeJSURL = function isStripeJSURL(url) {
    return V3_URL_REGEX.test(url) || STRIPE_JS_URL_REGEX.test(url);
};
var findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat(ORIGIN, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!isStripeJSURL(script.src)) continue;
        return script;
    }
    return null;
};
var injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat(STRIPE_JS_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "8.11.0",
        startTime: startTime
    });
};
var stripePromise$1 = null;
var onErrorListener = null;
var onLoadListener = null;
var onError = function onError(reject) {
    return function(cause) {
        reject(new Error('Failed to load Stripe.js', {
            cause: cause
        }));
    };
};
var onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if (stripePromise$1 !== null) return stripePromise$1;
    stripePromise$1 = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn(EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = findScript();
            if (script && params) console.warn(EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = injectScript(params);
            else if (script && onLoadListener !== null && onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', onLoadListener);
                script.removeEventListener('error', onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = injectScript(params);
            }
            onLoadListener = onLoad(resolve, reject);
            onErrorListener = onError(reject);
            script.addEventListener('load', onLoadListener);
            script.addEventListener('error', onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return stripePromise$1["catch"](function(error) {
        stripePromise$1 = null;
        return Promise.reject(error);
    });
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var pk = args[0];
    if (typeof pk !== 'string') throw new Error("Expected publishable key to be of type string, got type ".concat(_typeof(pk), " instead."));
    var isTestKey = pk.match(/^pk_test/); // @ts-expect-error this is not publicly typed
    var version = runtimeVersionToUrlVersion(maybeStripe.version);
    var expectedVersion = RELEASE_TRAIN;
    if (isTestKey && version !== expectedVersion) console.warn("Stripe.js@".concat(version, " was loaded on the page, but @stripe/stripe-js@").concat("8.11.0", " expected Stripe.js@").concat(expectedVersion, ". This may result in unexpected behavior. For more information, see https://docs.stripe.com/sdks/stripejs-versioning"));
    var stripe = maybeStripe.apply(undefined, args);
    registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var stripePromise;
var loadCalled = false;
var getStripePromise = function getStripePromise() {
    if (stripePromise) return stripePromise;
    stripePromise = loadScript(null)["catch"](function(error) {
        // clear cache on error
        stripePromise = null;
        return Promise.reject(error);
    });
    return stripePromise;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return getStripePromise();
})["catch"](function(error) {
    if (!loadCalled) console.warn(error);
});
var loadStripe = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return getStripePromise().then(function(maybeStripe) {
        return initStripe(maybeStripe, args, startTime);
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8eTVO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bounce", ()=>ft);
parcelHelpers.export(exports, "Flip", ()=>To);
parcelHelpers.export(exports, "Icons", ()=>q);
parcelHelpers.export(exports, "Slide", ()=>uo);
parcelHelpers.export(exports, "ToastContainer", ()=>xo);
parcelHelpers.export(exports, "Zoom", ()=>yo);
parcelHelpers.export(exports, "collapseToast", ()=>J);
parcelHelpers.export(exports, "cssTransition", ()=>R);
parcelHelpers.export(exports, "toast", ()=>y);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
"use client";
var L = (t)=>typeof t == "number" && !isNaN(t), N = (t)=>typeof t == "string", P = (t)=>typeof t == "function", ut = (t)=>N(t) || L(t), z = (t)=>N(t) || P(t) ? t : null, yt = (t, o)=>t === !1 || L(t) && t > 0 ? t : o, F = (t)=>(0, _react.isValidElement)(t) || N(t) || P(t) || L(t);
function J(t, o, e = 300) {
    let { scrollHeight: r, style: a } = t;
    requestAnimationFrame(()=>{
        a.minHeight = "initial", a.height = r + "px", a.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            a.height = "0", a.padding = "0", a.margin = "0", setTimeout(o, e);
        });
    });
}
function R({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: a = 300 }) {
    return function({ children: s, position: f, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${f}` : t, S = e ? `${o}--${f}` : o, E = (0, _react.useRef)(0);
        return (0, _react.useLayoutEffect)(()=>{
            let d = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), d.removeEventListener("animationend", b), d.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && d.classList.remove(...p));
            };
            d.classList.add(...p), d.addEventListener("animationend", b), d.addEventListener("animationcancel", b);
        }, []), (0, _react.useEffect)(()=>{
            let d = g.current, p = ()=>{
                d.removeEventListener("animationend", p), r ? J(d, T, a) : T();
            };
            v || (c ? p() : (E.current = 1, d.className += ` ${S}`, d.addEventListener("animationend", p)));
        }, [
            v
        ]), (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, s);
    };
}
function tt(t, o) {
    return {
        content: ot(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function ot(t, o, e = !1) {
    return (0, _react.isValidElement)(t) && !N(t.type) ? (0, _react.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function gt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, _reactDefault.default).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, _reactDefault.default).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function bt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: a, className: l, controlledProgress: s, progress: f, rtl: c, isIn: T, theme: g }) {
    let v = a || s && f === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    s && (x.transform = `scaleX(${f})`);
    let C = (0, _clsxDefault.default)("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, _clsxDefault.default)(C, l), E = {
        [s && f >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: s && f < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, _reactDefault.default).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, _reactDefault.default).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, _reactDefault.default).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        "aria-valuenow": s ? Math.round(f * 100) : void 0,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: S,
        style: x,
        ...E
    }));
}
var Qt = 1, st = ()=>`${Qt++}`;
function vt(t, o, e) {
    let r = 1, a = 0, l = [], s = [], f = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        s = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        i.isActive && ((u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1, e(tt(i, "removed")));
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, d = ()=>{
        a -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e(tt(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: f,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: d,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, D = h == null;
            D && a++;
            let A = {
                ...f,
                style: f.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([M, $])=>$ != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: z(n.className || f.toastClassName),
                progressClassName: z(n.progressClassName || f.progressClassName),
                autoClose: n.isLoading ? !1 : yt(n.autoClose, f.autoClose),
                closeToast (M) {
                    let $ = c.get(u);
                    $ && ($.removalReason = M, E(u));
                },
                deleteToast () {
                    if (c.get(u) != null) {
                        if (c.delete(u), a--, a < 0 && (a = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = f.closeButton, n.closeButton === !1 || F(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = F(f.closeButton) ? f.closeButton : !0);
            let B = {
                content: i,
                props: A,
                staleId: _
            };
            f.limit && f.limit > 0 && a > f.limit && D ? l.push(B) : L(k) ? setTimeout(()=>{
                p(B);
            }, k) : p(B);
        },
        setProps (i) {
            f = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>s
    };
}
var I = new Map, U = [], rt = new Set, Wt = (t)=>rt.forEach((o)=>o(t)), ht = ()=>I.size > 0;
function Gt() {
    U.forEach((t)=>nt(t.content, t.options)), U = [];
}
var Ct = (t, { containerId: o })=>{
    var e;
    return (e = I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function X(t, o) {
    var r;
    if (o) return !!((r = I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return I.forEach((a)=>{
        a.isToastActive(t) && (e = !0);
    }), e;
}
function xt(t) {
    if (!ht()) {
        U = U.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || ut(t)) I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = I.get(t.containerId);
        o ? o.removeToast(t.id) : I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var Et = (t = {})=>{
    I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function nt(t, o) {
    F(t) && (ht() || U.push({
        content: t,
        options: o
    }), I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function Pt(t) {
    var o;
    (o = I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function it(t, o) {
    I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function It(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = vt(o, t, Wt);
            I.set(o, r);
            let a = r.observe(e);
            return Gt(), ()=>{
                a(), I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function St(t) {
    return rt.add(t), ()=>{
        rt.delete(t);
    };
}
function qt(t) {
    return t && (N(t.toastId) || L(t.toastId)) ? t.toastId : st();
}
function H(t, o) {
    return nt(t, o), o.toastId;
}
function Q(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: qt(o)
    };
}
function W(t) {
    return (o, e)=>H(o, Q(t, e));
}
function y(t, o) {
    return H(t, Q("default", o));
}
y.loading = (t, o)=>H(t, Q("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function Kt(t, { pending: o, error: e, success: r }, a) {
    let l;
    o && (l = N(o) ? y.loading(o, a) : y.loading(o.render, {
        ...a,
        ...o
    }));
    let s = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, f = (T, g, v)=>{
        if (g == null) {
            y.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...s,
            ...a,
            data: v
        }, C = N(g) ? {
            render: g
        } : g;
        return l ? y.update(l, {
            ...x,
            ...C
        }) : y(C.render, {
            ...x,
            ...C
        }), v;
    }, c = P(t) ? t() : t;
    return c.then((T)=>f("success", r, T)).catch((T)=>f("error", e, T)), c;
}
y.promise = Kt;
y.success = W("success");
y.info = W("info");
y.error = W("error");
y.warning = W("warning");
y.warn = y.warning;
y.dark = (t, o)=>H(t, Q("default", {
        theme: "dark",
        ...o
    }));
function Yt(t) {
    xt(t);
}
y.dismiss = Yt;
y.clearWaitingQueue = Et;
y.isActive = X;
y.update = (t, o = {})=>{
    let e = Ct(t, o);
    if (e) {
        let { props: r, content: a } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: st()
        };
        l.toastId !== t && (l.staleId = t);
        let s = l.render || a;
        delete l.render, H(s, l);
    }
};
y.done = (t)=>{
    y.update(t, {
        progress: 1
    });
};
y.onChange = St;
y.play = (t)=>it(!0, t);
y.pause = (t)=>it(!1, t);
function kt(t) {
    var s;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, _react.useRef)(It(t)).current;
    r(t);
    let a = (s = (0, _react.useSyncExternalStore)(o, e, e)) == null ? void 0 : s.slice();
    function l(f) {
        if (!a) return [];
        let c = new Map;
        return t.newestOnTop && a.reverse(), a.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>f(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: X,
        count: a == null ? void 0 : a.length
    };
}
function Nt(t) {
    let [o, e] = (0, _react.useState)(!1), [r, a] = (0, _react.useState)(!1), l = (0, _react.useRef)(null), s = (0, _react.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: f, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    Pt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, _react.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", d), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", d), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            s.canCloseOnClick = !0, s.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (s.start = m.clientX, s.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (s.start = m.clientY, s.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: D, right: A } = l.current.getBoundingClientRect();
        m.pointerType === "mouse" && t.pauseOnHover && m.clientX >= D && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : d();
    }
    function d() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        s.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (s.canDrag && _) {
            s.didMove = !0, o && p(), t.draggableDirection === "x" ? s.delta = m.clientX - s.start : s.delta = m.clientY - s.start, s.start !== m.clientX && (s.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(s.delta / s.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (s.canDrag && s.didMove && m) {
            if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
                a(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return f && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = d)), v && (h.onClick = (m)=>{
        g && g(m), s.canCloseOnClick && T(!0);
    }), {
        playToast: d,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var G = typeof window != "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
var K = ({ theme: t, type: o, isLoading: e, ...r })=>(0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function ro(t) {
    return (0, _reactDefault.default).createElement(K, {
        ...t
    }, (0, _reactDefault.default).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function no(t) {
    return (0, _reactDefault.default).createElement(K, {
        ...t
    }, (0, _reactDefault.default).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function io(t) {
    return (0, _reactDefault.default).createElement(K, {
        ...t
    }, (0, _reactDefault.default).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function lo(t) {
    return (0, _reactDefault.default).createElement(K, {
        ...t
    }, (0, _reactDefault.default).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function fo() {
    return (0, _reactDefault.default).createElement("div", {
        className: "Toastify__spinner"
    });
}
var q = {
    info: no,
    warning: ro,
    success: io,
    error: lo,
    spinner: fo
}, co = (t)=>t in q;
function wt({ theme: t, type: o, isLoading: e, icon: r }) {
    let a = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || (P(r) ? a = r({
        ...l,
        isLoading: e
    }) : (0, _react.isValidElement)(r) ? a = (0, _react.cloneElement)(r, l) : e ? a = q.spinner() : co(o) && (a = q[o](l))), a;
}
var Dt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: a, playToast: l } = Nt(t), { closeButton: s, children: f, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: d, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: D, theme: A, ariaLabel: B } = t, M = (0, _clsxDefault.default)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: D
    }), $ = P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: M
    }) : (0, _clsxDefault.default)(M, E), mt = wt(t), pt = !!n || !c, Z = {
        closeToast: x,
        type: g,
        theme: A
    }, V = null;
    return s === !1 || (P(s) ? V = s(Z) : (0, _react.isValidElement)(s) ? V = (0, _react.cloneElement)(s, Z) : V = gt(Z)), (0, _reactDefault.default).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, _reactDefault.default).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: $,
        ...a,
        style: d,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": B
        }
    }, mt != null && (0, _reactDefault.default).createElement("div", {
        className: (0, _clsxDefault.default)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, mt), ot(f, t, !o), V, !t.customProgressBar && (0, _reactDefault.default).createElement(bt, {
        ...b && !pt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: pt,
        progress: n || 0
    })));
};
var j = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), ft = R(j("bounce", !0)), uo = R(j("slide", !0)), yo = R(j("zoom")), To = R(j("flip"));
var vo = {
    position: "top-right",
    transition: ft,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function dt(t) {
    let o = {
        ...vo,
        ...t
    }, e = t.stacked, [r, a] = (0, _react.useState)(!0), l = (0, _react.useRef)(null), { getToastToRender: s, isToastActive: f, count: c } = kt(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(d) {
        let p = (0, _clsxDefault.default)("Toastify__toast-container", `Toastify__toast-container--${d}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return P(T) ? T({
            position: d,
            rtl: v,
            defaultClassName: p
        }) : (0, _clsxDefault.default)(p, z(T));
    }
    function E() {
        e && (a(!0), y.play());
    }
    return G(()=>{
        var d;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (d = o.position) == null ? void 0 : d.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m), D = Math.max(.5, 1 - (r ? u : 0));
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${D}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, _react.useEffect)(()=>{
        function d(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b == null ? void 0 : b.querySelector('[tabIndex="0"]')) == null || i.focus(), a(!1), y.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (a(!0), y.play());
        }
        return document.addEventListener("keydown", d), ()=>{
            document.removeEventListener("keydown", d);
        };
    }, [
        C
    ]), (0, _reactDefault.default).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (a(!1), y.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, s((d, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, _reactDefault.default).createElement("div", {
            tabIndex: -1,
            className: S(d),
            "data-stacked": e,
            style: b,
            key: `c-${d}`
        }, p.map(({ content: i, props: n })=>(0, _reactDefault.default).createElement(Dt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: f(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}
var Mt = `:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: hsl(6, 78%, 57%);
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);

  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);

  --toastify-container-width: fit-content;
  --toastify-toast-width: 320px;
  --toastify-toast-offset: 16px;
  --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
  --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
  --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
  --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));
  --toastify-toast-background: #fff;
  --toastify-toast-padding: 14px;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-toast-bd-radius: 6px;
  --toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;

  /* Used only for colored theme */
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;

  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
  /* used to control the opacity of the progress trail */
  --toastify-color-progress-bgo: 0.2;
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
  position: fixed;
  width: var(--toastify-container-width);
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.Toastify__toast-container--top-left {
  top: var(--toastify-toast-top);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--top-center {
  top: var(--toastify-toast-top);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--top-right {
  top: var(--toastify-toast-top);
  right: var(--toastify-toast-right);
  align-items: end;
}
.Toastify__toast-container--bottom-left {
  bottom: var(--toastify-toast-bottom);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--bottom-center {
  bottom: var(--toastify-toast-bottom);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--bottom-right {
  bottom: var(--toastify-toast-bottom);
  right: var(--toastify-toast-right);
  align-items: end;
}

.Toastify__toast {
  --y: 0px;
  position: relative;
  touch-action: none;
  width: var(--toastify-toast-width);
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: var(--toastify-toast-padding);
  border-radius: var(--toastify-toast-bd-radius);
  box-shadow: var(--toastify-toast-shadow);
  max-height: var(--toastify-toast-max-height);
  font-family: var(--toastify-font-family);
  /* webkit only issue #791 */
  z-index: 0;
  /* inner swag */
  display: flex;
  flex: 1 auto;
  align-items: center;
  word-break: break-word;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    left: env(safe-area-inset-left);
    margin: 0;
  }
  .Toastify__toast-container--top-left,
  .Toastify__toast-container--top-center,
  .Toastify__toast-container--top-right {
    top: env(safe-area-inset-top);
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left,
  .Toastify__toast-container--bottom-center,
  .Toastify__toast-container--bottom-right {
    bottom: env(safe-area-inset-bottom);
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: env(safe-area-inset-right);
    left: initial;
  }
  .Toastify__toast {
    --toastify-toast-width: 100%;
    margin-bottom: 0;
    border-radius: 0;
  }
}

.Toastify__toast-container[data-stacked='true'] {
  width: var(--toastify-toast-width);
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container[data-stacked='true'] {
    width: 100vw;
  }
}

.Toastify__toast--stacked {
  position: absolute;
  width: 100%;
  transform: translate3d(0, var(--y), 0) scale(var(--s));
  transition: transform 0.3s;
}

.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,
.Toastify__toast--stacked[data-collapsed] .Toastify__close-button {
  transition: opacity 0.1s;
}

.Toastify__toast--stacked[data-collapsed='false'] {
  overflow: visible;
}

.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {
  opacity: 0;
}

.Toastify__toast--stacked:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: calc(var(--g) * 1px);
  bottom: 100%;
}

.Toastify__toast--stacked[data-pos='top'] {
  top: 0;
}

.Toastify__toast--stacked[data-pos='bot'] {
  bottom: 0;
}

.Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {
  transform-origin: top;
}

.Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {
  transform-origin: bottom;
}

.Toastify__toast--stacked:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  transform: scaleY(3);
  z-index: -1;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast--close-on-click {
  cursor: pointer;
}

.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 22px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.5s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  color: var(--toastify-text-color-dark);
}

.Toastify__toast-theme--light {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--default {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--info {
  color: var(--toastify-text-color-info);
  background: var(--toastify-color-info);
}

.Toastify__toast-theme--colored.Toastify__toast--success {
  color: var(--toastify-text-color-success);
  background: var(--toastify-color-success);
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
  color: var(--toastify-text-color-warning);
  background: var(--toastify-color-warning);
}

.Toastify__toast-theme--colored.Toastify__toast--error {
  color: var(--toastify-text-color-error);
  background: var(--toastify-color-error);
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}

.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}

.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}

.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}

.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}

.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #fff;
  position: absolute;
  top: 6px;
  right: 6px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  z-index: 1;
}

.Toastify__toast--rtl .Toastify__close-button {
  left: 6px;
  right: unset;
}

.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:hover,
.Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.7;
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
  border-bottom-left-radius: initial;
}

.Toastify__progress-bar--wrp {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  border-bottom-left-radius: var(--toastify-toast-bd-radius);
  border-bottom-right-radius: var(--toastify-toast-bd-radius);
}

.Toastify__progress-bar--wrp[data-hidden='true'] {
  opacity: 0;
}

.Toastify__progress-bar--bg {
  opacity: var(--toastify-color-progress-bgo);
  width: 100%;
  height: 100%;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes Toastify__bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}

.Toastify__bounce-enter--top-left,
.Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--top-right,
.Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left,
.Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--top-right,
.Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}

@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: translate3d(0, var(--y), 0) scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}

.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}

@keyframes Toastify__flipOut {
  from {
    transform: translate3d(0, var(--y), 0) perspective(400px);
  }
  30% {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}

.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}

@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}

.Toastify__slide-enter--top-left,
.Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--top-right,
.Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left,
.Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-right,
.Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;
var $t = new Map, Rt = (t, o)=>{
    G(()=>{
        if (!t || typeof document == "undefined") return;
        let e = document, r = $t.get(e);
        if (r) {
            o && r.setAttribute("nonce", o);
            return;
        }
        let a = e.createElement("style");
        a.textContent = t, o && a.setAttribute("nonce", o), e.head.appendChild(a), $t.set(e, a);
    }, [
        o
    ]);
};
function xo(t) {
    return Rt(Mt, t.nonce), (0, _reactDefault.default).createElement(dt, {
        ...t
    });
}

},{"react":"2o0ib","clsx":"lR3YO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lR3YO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cVa46":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stripePromiseSelector", ()=>stripePromiseSelector);
parcelHelpers.export(exports, "setPaymentStateSelector", ()=>setPaymentStateSelector);
parcelHelpers.export(exports, "selectedOptionSelector", ()=>selectedOptionSelector);
parcelHelpers.export(exports, "paymentOptionSelector", ()=>paymentOptionSelector);
var _zustand = require("zustand");
exports.default = (0, _zustand.create)((set)=>{
    return {
        selectedOption: '',
        paymentStarted: false,
        stripePromise: null,
        setPaymentState: (payment)=>set(payment),
        updateSelectedPaymentOption: (selectedOption)=>set({
                selectedOption
            })
    };
});
const stripePromiseSelector = (state)=>state.stripePromise;
const setPaymentStateSelector = (state)=>state.setPaymentState;
const selectedOptionSelector = (state)=>state.selectedOption;
const paymentOptionSelector = ({ selectedOption, updateSelectedPaymentOption })=>({
        selectedPaymentOption: selectedOption,
        updateSelectedPaymentOption
    });

},{"zustand":"61uwS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"61uwS":[function(require,module,exports,__globalThis) {
'use strict';
var vanilla = require("a19f4edd89926025");
var ReactExports = require("e3cb921f47249eac");
var useSyncExternalStoreExports = require("1e8ad8cf8d3b3c90");
var useDebugValue = ReactExports.useDebugValue;
var useSyncExternalStoreWithSelector = useSyncExternalStoreExports.useSyncExternalStoreWithSelector;
var didWarnAboutEqualityFn = false;
var identity = function identity(arg) {
    return arg;
};
function useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = identity;
    if (equalityFn && !didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        didWarnAboutEqualityFn = true;
    }
    var slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    useDebugValue(slice);
    return slice;
}
var createImpl = function createImpl(createState) {
    if (typeof createState !== 'function') console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    var api = typeof createState === 'function' ? vanilla.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var create = function create(createState) {
    return createState ? createImpl(createState) : createImpl;
};
var react = function(createState) {
    console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return create(createState);
};
exports.create = create;
exports.default = react;
exports.useStore = useStore;
Object.keys(vanilla).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function() {
            return vanilla[k];
        }
    });
});
module.exports = react;
module.exports.create = create;
module.exports.useStore = useStore;
module.exports.createStore = vanilla.createStore;
exports.default = module.exports;

},{"a19f4edd89926025":"ehmhs","e3cb921f47249eac":"2o0ib","1e8ad8cf8d3b3c90":"fY4eP"}],"ehmhs":[function(require,module,exports,__globalThis) {
'use strict';
var createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        console.warn('[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.');
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var createStore = function createStore(createState) {
    return createState ? createStoreImpl(createState) : createStoreImpl;
};
var vanilla = function(createState) {
    console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return createStore(createState);
};
exports.createStore = createStore;
exports.default = vanilla;
module.exports = vanilla;
module.exports.createStore = createStore;
exports.default = module.exports;

},{}],"fY4eP":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("825b2585cf61f03e");

},{"825b2585cf61f03e":"6NOXL"}],"6NOXL":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = require("2f25dc3829c8e76e"), shim = require("c4afd16660885105"), objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
    exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        var instRef = useRef(null);
        if (null === instRef.current) {
            var inst = {
                hasValue: !1,
                value: null
            };
            instRef.current = inst;
        } else inst = instRef.current;
        instRef = useMemo(function() {
            function memoizedSelector(nextSnapshot) {
                if (!hasMemo) {
                    hasMemo = !0;
                    memoizedSnapshot = nextSnapshot;
                    nextSnapshot = selector(nextSnapshot);
                    if (void 0 !== isEqual && inst.hasValue) {
                        var currentSelection = inst.value;
                        if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                    }
                    return memoizedSelection = nextSnapshot;
                }
                currentSelection = memoizedSelection;
                if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
                var nextSelection = selector(nextSnapshot);
                if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
                memoizedSnapshot = nextSnapshot;
                return memoizedSelection = nextSelection;
            }
            var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
            return [
                function() {
                    return memoizedSelector(getSnapshot());
                },
                null === maybeGetServerSnapshot ? void 0 : function() {
                    return memoizedSelector(maybeGetServerSnapshot());
                }
            ];
        }, [
            getSnapshot,
            getServerSnapshot,
            selector,
            isEqual
        ]);
        var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
        useEffect(function() {
            inst.hasValue = !0;
            inst.value = value;
        }, [
            value
        ]);
        useDebugValue(value);
        return value;
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

},{"2f25dc3829c8e76e":"2o0ib","c4afd16660885105":"eKrf3"}],"eKrf3":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("5ab7799a565bbe74");

},{"5ab7799a565bbe74":"hZoFa"}],"hZoFa":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function useSyncExternalStore$2(subscribe, getSnapshot) {
        didWarnOld18Alpha || void 0 === React.startTransition || (didWarnOld18Alpha = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            objectIs(value, cachedValue) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        cachedValue = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        });
        var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot;
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
            return subscribe(function() {
                checkIfSnapshotChanged(inst) && forceUpdate({
                    inst: inst
                });
            });
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot) {
        return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = require("d49206e28a986e9f"), objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue, didWarnOld18Alpha = !1, didWarnUncachedGetSnapshot = !1, shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
    exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

},{"d49206e28a986e9f":"2o0ib"}],"6S7S4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _spinner = require("Core/components/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _layout = require("Core/components/Layout");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const messageStyles = {
    overlay: `mt-4`,
    inline: `ml-2`
};
const loaderWrapperStyles = {
    overlay: `
    flex-col
    bg-white
    border border-solid border-gray-300 rounded
    py-8 px-2 my-10
    [box-shadow:0_4px_4px_1px_#b3b3b3]
    [min-width:50vw]
  `,
    inline: `py-1 px-5`
};
const spinnerStyles = {
    overlay: `w-8 h-8 text-primary`,
    inline: `w-4 h-4`
};
const Loader = ({ message, type = 'overlay', className, ...rest })=>{
    const loaderContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "data-testid": "spinner",
        className: (0, _classnamesDefault.default)('flex items-center justify-center', className),
        ...rest,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)(`flex flex-nowrap items-center justify-center`, loaderWrapperStyles[type]),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                    small: type === 'inline',
                    className: spinnerStyles[type]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _classnamesDefault.default)('text-center', messageStyles[type]),
                    children: message
                })
            ]
        })
    });
    if (type === 'inline') return loaderContent;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Overlay), {
        children: loaderContent
    });
};
exports.default = Loader;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","Core/components/Spinner":"bZo5I","Core/components/Layout":"hweet","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bPwP3":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs = require("96e34ae03f5a2631");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var throwOnDirectAccess = true;
module.exports = require("cb216452e2171041")(ReactIs.isElement, throwOnDirectAccess);

},{"96e34ae03f5a2631":"4jwST","cb216452e2171041":"78hPp"}],"4jwST":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("2255125a8e8b1051");

},{"2255125a8e8b1051":"fv3PA"}],"fv3PA":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
})();

},{}],"78hPp":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactIs = require("c437388b089702c3");
var assign = require("c067a60101d8520c");
var ReactPropTypesSecret = require("74a0f89a70b9f3c2");
var has = require("18441b11647bc78");
var checkPropTypes = require("bec3f6ff89f0b072");
var printWarning = function() {};
printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== ReactPropTypesSecret) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!ReactIs.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if (has(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                if (checkerResult == null) return null;
                if (checkerResult.data && has(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = assign({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if (has(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"c437388b089702c3":"4jwST","c067a60101d8520c":"9Vvcq","74a0f89a70b9f3c2":"3ZnXS","18441b11647bc78":"6S8zQ","bec3f6ff89f0b072":"6Gmt2"}],"9Vvcq":[function(require,module,exports,__globalThis) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"3ZnXS":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"6S8zQ":[function(require,module,exports,__globalThis) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

},{}],"6Gmt2":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var printWarning = function() {};
var ReactPropTypesSecret = require("24ba1e58d167a82c");
var loggedTypeFailures = {};
var has = require("898bc82f39d83f7c");
printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ checkPropTypes.resetWarningCache = function() {
    loggedTypeFailures = {};
};
module.exports = checkPropTypes;

},{"24ba1e58d167a82c":"3ZnXS","898bc82f39d83f7c":"6S8zQ"}],"bZo5I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Spinner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const styles = {
    base: `
    inline-block mr-2
    border-4 border-solid border-current rounded-full border-r-transparent
    align-text-bottom
    animate-spin
  `,
    small: 'border-2 mr-2'
};
function Spinner({ className = 'w-4 h-4', small = false, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _classnamesDefault.default)(styles.base, {
            [styles.small]: small
        }, className),
        children: children
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"f971Y":[function(require,module,exports,__globalThis) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"hweet":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "Overlay", ()=>(0, _overlayDefault.default));
parcelHelpers.export(exports, "Row", ()=>(0, _rowDefault.default));
parcelHelpers.export(exports, "Column", ()=>(0, _columnDefault.default));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
var _container = require("Core/components/Layout/Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _overlay = require("Core/components/Layout/Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _modal = require("Core/components/Layout/Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _column = require("Core/components/Layout/Column");
var _columnDefault = parcelHelpers.interopDefault(_column);

},{"Core/components/Layout/Container":"iymQy","Core/components/Layout/Overlay":"2j4uY","Core/components/Layout/Row":"8YqFQ","Core/components/Layout/Modal":"33p8L","Core/components/Layout/Column":"hnQnj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iymQy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Container);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function Container({ className, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)('mb-4 w-full xl:max-w-screen-xl mx-auto px-4', className),
        children: children
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2j4uY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Overlay);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const styles = `
  bg-gray-500 fixed z-50 inset-0 bg-opacity-50 flex items-center justify-center
  [backdrop-filter:blur(2px)] inset-0
`;
function Overlay({ className, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)(styles, className),
        children: children
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8YqFQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function Row({ className, children }, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)('flex flex-wrap -mx-4', className),
        ref: ref,
        children: children
    });
}
exports.default = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Row);

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"33p8L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _overlay = require("./Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const Modal = ({ isOpen, className, children })=>{
    return isOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overlayDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: (0, _classnamesDefault.default)(className, 'shadow-lg bg-white border rounded p-4 max-h-[90vh] overflow-y-auto'),
            children: children
        })
    }) : null;
};
exports.default = Modal;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","./Overlay":"2j4uY","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hnQnj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Column);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function Column({ className, noFlex, children }) {
    const flexStyles = 'flex-col-12';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)('relative px-4 mb-4', {
            [flexStyles]: !noFlex
        }, className),
        children: children
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4LGjI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DialogContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _confirm = require("./Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _portal = require("Core/components/Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _dialog = require("Core/stores/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
function DialogContainer() {
    const dialog = (0, _dialogDefault.default)();
    const handleConfirm = ()=>{
        dialog.onConfirm();
        if (typeof dialog.confirmCallback === 'function') dialog.confirmCallback();
    };
    const handleCancel = ()=>{
        dialog.onCancel();
        if (typeof dialog.cancelCallback === 'function') dialog.cancelCallback();
    };
    if (dialog.open && dialog.type === 'confirm') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "z-50 inset-0 fixed items-center justify-center flex [background:rgba(155,155,155,0.5)] [backdrop-filter:blur(2px)]",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
                title: dialog.title,
                description: dialog.description,
                confirmButtonLabel: dialog.confirmButtonLabel,
                cancelButtonLabel: dialog.cancelButtonLabel,
                onConfirm: handleConfirm,
                onCancel: handleCancel
            })
        })
    });
    return '';
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","./Confirm":"cYDcF","Core/components/Portal":"3MZth","Core/stores/dialog":"6IfFO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cYDcF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Confirm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("Core/components/Button");
function Confirm({ title, description, confirmButtonLabel, cancelButtonLabel, onConfirm, onCancel }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "bg-white border border-solid border-gray-300 rounded p-4 relative mb-6 w-full max-w-xl shadow-lg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "border-b border-solid border-gray-300 font-bold text-xl pb-2 mb-2",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    minHeight: '80px'
                },
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex justify-end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SecondaryOutlineButton), {
                        className: `!px-8 !mr-2`,
                        onClick: onCancel,
                        "data-testid": "cancel",
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                        className: `!px-8`,
                        onClick: onConfirm,
                        "data-testid": "confirm",
                        children: confirmButtonLabel
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Button":"6YNzH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6YNzH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrimaryButton", ()=>(0, _button.PrimaryButton));
parcelHelpers.export(exports, "SecondaryButton", ()=>(0, _button.SecondaryButton));
parcelHelpers.export(exports, "SecondaryOutlineButton", ()=>(0, _button.SecondaryOutlineButton));
parcelHelpers.export(exports, "OutlineButton", ()=>(0, _button.OutlineButton));
parcelHelpers.export(exports, "DestructiveButton", ()=>(0, _button.DestructiveButton));
parcelHelpers.export(exports, "TextButton", ()=>(0, _button.TextButton));
parcelHelpers.export(exports, "LinkButton", ()=>(0, _button.LinkButton));
parcelHelpers.export(exports, "SuccessButton", ()=>(0, _button.SuccessButton));
var _button = require("./Button");

},{"./Button":"4Zmpz","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4Zmpz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrimaryButton", ()=>PrimaryButton);
parcelHelpers.export(exports, "SecondaryButton", ()=>SecondaryButton);
parcelHelpers.export(exports, "SecondaryOutlineButton", ()=>SecondaryOutlineButton);
parcelHelpers.export(exports, "DestructiveButton", ()=>DestructiveButton);
parcelHelpers.export(exports, "OutlineButton", ()=>OutlineButton);
parcelHelpers.export(exports, "TextButton", ()=>TextButton);
parcelHelpers.export(exports, "LinkButton", ()=>LinkButton);
parcelHelpers.export(exports, "SuccessButton", ()=>SuccessButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const defaultProps = {
    type: 'button',
    size: '',
    block: false
};
const baseStyles = `
  inline-block py-1.5 px-3 h-9
  text-base leading-6 font-normal whitespace-nowrap border-transparent text-center select-none no-underline hover:no-underline
  rounded border border-solid
  transition-colors
  disabled:opacity-60 disabled:cursor-not-allowed
`;
const buttonStyles = {
    primary: `
      bg-primary hover:bg-blue-700
      text-white hover:text-white
      disabled:hover:bg-primary shadow-md
    `,
    secondary: `
      bg-gray-500 hover:bg-gray-600
      text-white
      disabled:hover:bg-gray-500
    `,
    secondaryOutline: `
      bg-transparent
      border-gray-500
      text-gray-500
      hover:text-white hover:bg-gray-600 hover:border-gray-600
      disabled:hover:bg-transparent
    `,
    destructive: `
      bg-white
      border-red-500
      text-red-500
      hover:text-white hover:bg-red-800 hover:border-gray-600
      disabled:hover:bg-transparent disabled:hover:text-red-500
    `,
    outline: `
    bg-transparent
    border-primary
    text-primary
    hover:bg-gray-200 hover:border-gray-600
    disabled:text-gray-300
    disabled:hover:bg-transparent
  `,
    text: `
    bg-transparent
    text-primary
    hover:bg-gray-100
    disabled:pointer-events-none
    text-sm
  `,
    link: `
  !px-1 !pb-0
  bg-transparent
  text-primary
  hover:bg-gray-100
  disabled:pointer-events-none
  text-sm
  rounded-none
  border-b-primary
`,
    success: `
      bg-green-600 hover:bg-green-700
      text-white hover:text-white
      disabled:hover:bg-green-600 shadow-md
    `
};
const blockButtonStyles = `block w-full`;
const roundedButtonStyles = 'rounded-2xl';
const smallButtonStyles = `
  py-1 px-2 h-auto
  text-sm
`;
const tallButtonStyles = `
  py-2 px-2 !h-12 
`;
function Button({ className, design, block, rounded, size, ...props }) {
    const styles = (0, _classnamesDefault.default)(baseStyles, buttonStyles[design], {
        [blockButtonStyles]: !!block,
        [roundedButtonStyles]: !!rounded,
        [smallButtonStyles]: size === 'small',
        [tallButtonStyles]: size === 'tall'
    }, className);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        className: styles,
        ...props
    });
}
const PrimaryButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
        design: "primary",
        ...props
    });
PrimaryButton.defaultProps = defaultProps;
const SecondaryButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
        design: "secondary",
        ...props
    });
SecondaryButton.defaultProps = defaultProps;
const SecondaryOutlineButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
        design: 'secondaryOutline',
        ...props
    });
SecondaryOutlineButton.defaultProps = defaultProps;
const DestructiveButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
        design: 'destructive',
        ...props
    });
DestructiveButton.defaultProps = defaultProps;
const OutlineButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
        design: 'outline',
        ...props
    });
OutlineButton.defaultProps = defaultProps;
const TextButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
        design: 'text',
        ...props
    });
TextButton.defaultProps = defaultProps;
const LinkButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
        design: 'link',
        ...props
    });
LinkButton.defaultProps = defaultProps;
const SuccessButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
        design: "success",
        ...props
    });
SuccessButton.defaultProps = defaultProps;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3MZth":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _portal = require("./Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
exports.default = (0, _portalDefault.default);

},{"./Portal":"5qpFl","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5qpFl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function Portal({ children }) {
    const mount = document.getElementById('portal');
    const element = document.createElement('div');
    (0, _reactDefault.default).useEffect(()=>{
        //mount.innerHTML = '';
        mount.appendChild(element);
        return ()=>mount.removeChild(element);
    }, [
        mount,
        element
    ]);
    return /*#__PURE__*/ (0, _reactDom.createPortal)(children, element);
}
Portal.propTypes = {
    children: (0, _propTypesDefault.default).any.isRequired
};
exports.default = Portal;

},{"react":"2o0ib","react-dom":"6WJHP","prop-types":"bPwP3","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6IfFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "showDialogSelector", ()=>showDialogSelector);
var _zustand = require("zustand");
exports.default = (0, _zustand.create)((set)=>({
        type: '',
        title: '',
        description: '',
        open: false,
        confirmButtonLabel: 'OK',
        cancelButtonLabel: 'Cancel',
        confirmCallback: ()=>{},
        cancelCallback: ()=>{},
        onConfirm: ()=>set({
                open: false
            }),
        onCancel: ()=>set({
                open: false
            }),
        onClose: ()=>set({
                open: false,
                title: '',
                description: ''
            }),
        showDialog: ({ type = 'confirm', title, description, confirmCallback, cancelCallback, confirmButtonLabel = 'OK', cancelButtonLabel = 'Cancel' })=>set({
                type,
                title,
                description,
                confirmButtonLabel,
                cancelButtonLabel,
                open: true,
                confirmCallback,
                cancelCallback
            })
    }));
const showDialogSelector = (state)=>state.showDialog;

},{"zustand":"61uwS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1Lg8U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _teleaudiologyReturnHandlerDefault.default));
var _teleaudiologyReturnHandler = require("./TeleaudiologyReturnHandler");
var _teleaudiologyReturnHandlerDefault = parcelHelpers.interopDefault(_teleaudiologyReturnHandler);

},{"./TeleaudiologyReturnHandler":"fJMzm","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fJMzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _alert = require("Core/components/Alert");
var _button = require("Core/components/Button");
const TeleaudiologyReturnHandler = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [showReturnPrompt, setShowReturnPrompt] = (0, _reactDefault.default).useState(false);
    const [returnUrl, setReturnUrl] = (0, _reactDefault.default).useState('');
    (0, _reactDefault.default).useEffect(()=>{
        // Check if user is returning from Teleaudiology financing flow
        const isTeleaudiologyFlow = sessionStorage.getItem('isTeleaudiologyFlow');
        const storedReturnUrl = sessionStorage.getItem('returnUrl');
        if (isTeleaudiologyFlow === 'true' && storedReturnUrl) {
            setShowReturnPrompt(true);
            setReturnUrl(storedReturnUrl);
        }
    }, []);
    const handleReturnToPayment = ()=>{
        // Clear the session storage
        sessionStorage.removeItem('isTeleaudiologyFlow');
        sessionStorage.removeItem('returnUrl');
        // Navigate back to the payment portal
        window.location.href = returnUrl;
    };
    const handleStayHere = ()=>{
        // Clear the session storage but stay on current page
        sessionStorage.removeItem('isTeleaudiologyFlow');
        sessionStorage.removeItem('returnUrl');
        setShowReturnPrompt(false);
    };
    if (!showReturnPrompt) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "fixed top-0 left-0 right-0 z-50 bg-blue-50 border-b border-blue-200 p-4",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
            type: "infoLight",
            className: "mb-0",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "font-semibold text-blue-800 mb-1",
                                children: t('teleaudiology.returnPrompt.title', 'Return to Payment Portal')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-blue-700 text-sm",
                                children: t('teleaudiology.returnPrompt.message', 'Would you like to return to the payment portal to continue your session?')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex gap-2 flex-shrink-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SecondaryOutlineButton), {
                                onClick: handleStayHere,
                                className: "text-sm px-4 py-2",
                                children: t('teleaudiology.returnPrompt.stay', 'Stay Here')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                onClick: handleReturnToPayment,
                                className: "text-sm px-4 py-2",
                                children: t('teleaudiology.returnPrompt.return', 'Return to Portal')
                            })
                        ]
                    })
                ]
            })
        })
    });
};
exports.default = TeleaudiologyReturnHandler;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/components/Alert":"fmmNR","Core/components/Button":"6YNzH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fmmNR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alert", ()=>(0, _alert.Alert));
parcelHelpers.export(exports, "AlertSuccess", ()=>(0, _alert.AlertSuccess));
parcelHelpers.export(exports, "AlertWarning", ()=>(0, _alert.AlertWarning));
parcelHelpers.export(exports, "AlertError", ()=>(0, _alert.AlertError));
parcelHelpers.export(exports, "AlertInfo", ()=>(0, _alert.AlertInfo));
parcelHelpers.export(exports, "GlobalPageAlert", ()=>(0, _globalPageAlertDefault.default));
var _alert = require("./Alert");
var _globalPageAlert = require("./GlobalPageAlert");
var _globalPageAlertDefault = parcelHelpers.interopDefault(_globalPageAlert);

},{"./Alert":"bZcEn","./GlobalPageAlert":"i7QzD","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bZcEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alert", ()=>Alert);
parcelHelpers.export(exports, "AlertSuccess", ()=>AlertSuccess);
parcelHelpers.export(exports, "AlertWarning", ()=>AlertWarning);
parcelHelpers.export(exports, "AlertError", ()=>AlertError);
parcelHelpers.export(exports, "AlertInfo", ()=>AlertInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _closeIcon = require("Modules/deposit/components/CloseIcon");
var _closeIconDefault = parcelHelpers.interopDefault(_closeIcon);
const styles = {
    base: 'whitespace-pre-line border rounded-md px-4 py-3 mb-4 flex fill-slate-400 relative',
    default: 'bg-white',
    success: 'bg-success text-white ',
    successLight: 'bg-green-100 text-green-800 fill-green-800',
    warning: 'bg-yellow-300',
    warningLight: 'bg-[#FEF9E9] fill-[#F9C12D]',
    error: 'bg-red-100 text-red-800 border-red-400',
    info: 'bg-blue-400 text-white',
    infoLight: 'bg-blue-100 text-blue-800 fill-blue-500',
    shade: 'bg-gray-300'
};
function Alert({ type = 'default', className, showIcon = false, icon, children, dismissable, ...rest }) {
    const [hideAlert, setHideAlert] = (0, _reactDefault.default).useState(false);
    const iconElement = icon || /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "pt-0.5",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            className: "mr-4 h-5 w-5 ",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 64 64",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M31.97,64.02C14.33,64-.04,49.6,0,31.97,.04,14.31,14.44-.05,32.06,0c17.63,.05,31.95,14.4,31.94,32.02,0,17.65-14.4,32.03-32.03,32Zm-.02-23.58c1,0,2,0,3.01,0,.92,0,1.05-.14,1.1-1.03,.05-.86,.11-1.72,.18-2.58,.31-4.2,.63-8.4,.94-12.61,.21-2.83,.42-5.66,.65-8.5,.2-2.46-.61-4.48-2.72-5.81-2-1.26-4.12-1.28-6.14-.05-2.13,1.3-2.99,3.3-2.81,5.76,.26,3.39,.53,6.78,.78,10.17,.34,4.6,.67,9.2,1,13.79,.04,.61,.32,.87,.93,.86,1.02-.02,2.05,0,3.08,0Zm.04,4.96c-2.68,0-4.85,2.17-4.85,4.83,0,2.61,2.2,4.81,4.81,4.83,2.68,.02,4.89-2.21,4.87-4.9-.03-2.65-2.17-4.76-4.83-4.76Z"
            })
        })
    });
    const dismissAlert = ()=>{
        setHideAlert(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)(styles.base, styles[type], className, {
            hidden: hideAlert
        }),
        ...rest,
        children: [
            showIcon && iconElement,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "mb-0 mt-0 w-full",
                children: [
                    " ",
                    children
                ]
            }),
            dismissable && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "absolute right-2 top-2 left-auto",
                onClick: dismissAlert,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeIconDefault.default), {})
            })
        ]
    });
}
const AlertSuccess = ({ children, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Alert, {
        "data-testid": "alert-success",
        type: "success",
        ...rest,
        children: children
    });
const AlertWarning = ({ children, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Alert, {
        "data-testid": "alert-warning",
        type: "warning",
        ...rest,
        children: children
    });
const AlertError = ({ children, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Alert, {
        "data-testid": "alert-error",
        type: "error",
        ...rest,
        children: children
    });
const AlertInfo = ({ children, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Alert, {
        "data-testid": "alert-info",
        type: "info",
        ...rest,
        children: children
    });

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","classnames":"f971Y","Modules/deposit/components/CloseIcon":"3OhUV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3OhUV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CloseIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function CloseIcon({ onClick }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        onClick: onClick,
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-6 w-6 cursor-pointer",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M6 18L18 6M6 6l12 12"
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i7QzD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GlobalPageAlert);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _index = require("Core/components/Alert/index");
var _useScrollTop = require("Core/hooks/useScrollTop");
function GlobalPageAlert() {
    (0, _useScrollTop.useScrollTop)();
    const alert = (0, _alertDefault.default)((0, _alert.alertSelector));
    if (!alert) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Alert), {
        "data-testid": `alert-${alert.type}`,
        type: alert.type,
        children: alert.text
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/stores/alert":"fPz3p","Core/components/Alert/index":"fmmNR","Core/hooks/useScrollTop":"cBwQW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fPz3p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alertSelector", ()=>alertSelector);
parcelHelpers.export(exports, "clearAlertSelector", ()=>clearAlertSelector);
parcelHelpers.export(exports, "setAlertSelector", ()=>setAlertSelector);
parcelHelpers.export(exports, "setSuccessAlertSelector", ()=>setSuccessAlertSelector);
parcelHelpers.export(exports, "setWarningAlertSelector", ()=>setWarningAlertSelector);
parcelHelpers.export(exports, "setErrorAlertSelector", ()=>setErrorAlertSelector);
parcelHelpers.export(exports, "setBlankAlertSelector", ()=>setBlankAlertSelector);
var _zustand = require("zustand");
exports.default = (0, _zustand.create)((set)=>({
        alert: null,
        clearAlert: ()=>set({
                alert: null
            }),
        setAlert: (text)=>set({
                alert: {
                    text,
                    type: ''
                }
            }),
        setSuccessAlert: (text)=>set({
                alert: {
                    text,
                    type: 'success'
                }
            }),
        setWarningAlert: (text)=>set({
                alert: {
                    text,
                    type: 'warning'
                }
            }),
        setErrorAlert: (text)=>set({
                alert: {
                    text,
                    type: 'error'
                }
            }),
        setBlankAlert: (text)=>set({
                alert: {
                    text,
                    type: 'blank'
                }
            })
    }));
const alertSelector = (state)=>state.alert;
const clearAlertSelector = (state)=>state.clearAlert;
const setAlertSelector = (state)=>state.setAlert;
const setSuccessAlertSelector = (state)=>state.setSuccessAlert;
const setWarningAlertSelector = (state)=>state.setWarningAlert;
const setErrorAlertSelector = (state)=>state.setErrorAlert;
const setBlankAlertSelector = (state)=>state.setBlankAlert;

},{"zustand":"61uwS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cBwQW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScrollTop", ()=>useScrollTop);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useScrollTop() {
    const scroll = (x = 0, y = 0)=>{
        window.scrollTo({
            left: x,
            top: y,
            behavior: 'smooth'
        });
    };
    (0, _reactDefault.default).useEffect(()=>{
        scroll();
    }, []);
    return {
        top: scroll
    };
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"23d2B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", ()=>ErrorBoundary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _errorFallback = require("Core/components/ErrorFallback");
var _errorFallbackDefault = parcelHelpers.interopDefault(_errorFallback);
class ErrorBoundary extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    render() {
        return this.state.hasError ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorFallbackDefault.default), {}) : this.props.children;
    }
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/ErrorFallback":"6WpLt","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6WpLt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _storage = require("Core/utils/storage");
const ErrorFallback = ({ error })=>{
    // Handles failed lazy loading of a JS/CSS chunk.
    (0, _reactDefault.default).useEffect(()=>{
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (error?.message && chunkFailedMessage.test(error.message)) {
            if (!(0, _storage.getWithExpiry)('chunk_failed')) {
                (0, _storage.setWithExpiry)('chunk_failed', 'true', 10000);
                window.location.reload();
            }
        }
    }, [
        error
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col items-center justify-center mt-32",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "There is a new version of the application available. Please reload the page to get the latest version."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "bg-primary text-white rounded border py-2 px-4 mt-4",
                onClick: ()=>window.location.reload(),
                children: "Reload Page"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                children: error?.message
            })
        ]
    });
};
exports.default = ErrorFallback;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/utils/storage":"73kH0","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"73kH0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setWithExpiry", ()=>setWithExpiry);
parcelHelpers.export(exports, "getWithExpiry", ()=>getWithExpiry);
function setWithExpiry(key, value, ttl) {
    const item = {
        value,
        expiry: new Date().getTime() + ttl
    };
    localStorage.setItem(key, JSON.stringify(item));
}
function getWithExpiry(key) {
    const itemString = window.localStorage.getItem(key);
    if (!itemString) return null;
    const item = JSON.parse(itemString);
    const isExpired = new Date().getTime() > item.expiry;
    if (isExpired) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7qX5H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAppConfig", ()=>getAppConfig);
var _utils = require("Core/utils/utils");
const configs = [
    {
        azureRedirectUrl: undefined,
        country: 'de',
        currency: 'eur',
        dateFormat: 'dd.MM.yyyy',
        hostnames: [
            'zahlungen.shared-testing.audibene.de',
            'zahlungen.audibene.de'
        ],
        locale: 'de-DE',
        stripeLocale: 'de',
        stripePublicKey: undefined
    },
    {
        azureRedirectUrl: '',
        country: 'us',
        currency: 'usd',
        dateFormat: 'MM/dd/yyyy',
        hostnames: [
            'payments.shared-testing.hear.com',
            'payments.hear.com'
        ],
        locale: 'en-US',
        stripeLocale: 'en',
        stripePublicKey: "pk_test_VmPl67PcRUG3DXS9RpyaTRXq00BDCvoDIk"
    },
    {
        azureRedirectUrl: undefined,
        country: 'ca',
        currency: 'cad',
        dateFormat: 'MM/dd/yyyy',
        hostnames: [
            'payments-ca.shared-testing.hear.com',
            'payments-ca.hear.com'
        ],
        locale: 'en-CA',
        stripeLocale: 'en',
        stripePublicKey: "pk_test_5MRR9uNZH9NdISwIqKn52HLg00ExV7lhrW"
    },
    {
        azureRedirectUrl: undefined,
        country: 'nl',
        currency: 'eur',
        dateFormat: 'dd-MM-yyyy',
        hostnames: [
            'betalingen.shared-testing.audibene.nl',
            'betalingen.audibene.nl'
        ],
        locale: 'nl-NL',
        stripeLocale: 'nl',
        stripePublicKey: undefined
    },
    {
        azureRedirectUrl: undefined,
        country: 'fr',
        currency: 'eur',
        dateFormat: 'dd-MM-yyyy',
        hostnames: [
            'facturation.shared-testing.audibene.fr',
            'facturation.audibene.fr'
        ],
        locale: 'fr-FR',
        stripeLocale: 'fr',
        stripePublicKey: undefined
    }
];
const normalizeLocale = (str)=>str.replace('_', '-');
const getLocaleFromHostname = ()=>{
    const { locale } = configs.find((config)=>config.hostnames.includes(window.location.hostname)) || {};
    return locale;
};
const getAppConfig = ()=>{
    const locale = getLocaleFromHostname() || localStorage.getItem('locale') || (0, _utils.getUrlParam)('locale', '') || 'en-US';
    return configs.find((config)=>config.locale === normalizeLocale(locale));
};

},{"Core/utils/utils":"hwOBZ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hwOBZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUrlParam", ()=>getUrlParam);
parcelHelpers.export(exports, "getUrlParamIgnoreCase", ()=>getUrlParamIgnoreCase);
parcelHelpers.export(exports, "setUrlParam", ()=>setUrlParam);
parcelHelpers.export(exports, "getPaymentPortalUrl", ()=>getPaymentPortalUrl);
parcelHelpers.export(exports, "sortByObjectProp", ()=>sortByObjectProp);
parcelHelpers.export(exports, "multiSortByObjectProp", ()=>multiSortByObjectProp);
parcelHelpers.export(exports, "getPropValue", ()=>getPropValue);
parcelHelpers.export(exports, "filterByPropertyValue", ()=>filterByPropertyValue);
parcelHelpers.export(exports, "findByPropertyValue", ()=>findByPropertyValue);
parcelHelpers.export(exports, "stripTrailingSlash", ()=>stripTrailingSlash);
parcelHelpers.export(exports, "dedupeConsecutiveSlashes", ()=>dedupeConsecutiveSlashes);
parcelHelpers.export(exports, "getPreferredPaymentMethod", ()=>getPreferredPaymentMethod);
parcelHelpers.export(exports, "getFormPrefix", ()=>getFormPrefix);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "getDecimals", ()=>getDecimals);
parcelHelpers.export(exports, "generateURL", ()=>generateURL);
function getUrlParam(name, defaultValue = null) {
    const urlObj = new URL(window.location.href);
    return urlObj.searchParams.get(name) || defaultValue;
}
function getUrlParamIgnoreCase(name, defaultValue = null) {
    const urlObj = new URL(window.location.href);
    const allParams = Object.fromEntries(urlObj.searchParams.entries());
    const lowerToActualMap = Object.keys(allParams).map((item)=>{
        return {
            lowerCaseParam: item.toLowerCase(),
            actualParam: item
        };
    });
    const targetParam = lowerToActualMap.find((item)=>item.lowerCaseParam === name.toLowerCase());
    return targetParam ? allParams[targetParam.actualParam] : defaultValue;
}
function setUrlParam(key, newVal = null) {
    try {
        const urlObj = new URL(window.location.href);
        if (!urlObj.searchParams.get(key)) {
            urlObj.searchParams.append(key, newVal);
            window.history.replaceState(null, '', urlObj.toString());
        }
    } catch (error) {
        console.error('Error in setting URL params', error);
    }
}
function getPaymentPortalUrl() {
    return window.location.href.replace(window.location.pathname, '/');
}
function sortByObjectProp(prop) {
    let sortOrder = 1;
    if (prop[0] === '-') {
        sortOrder = -1;
        prop = prop.substr(1);
    }
    return function(a, b) {
        const result = a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0;
        return result * sortOrder;
    };
}
function multiSortByObjectProp(...props) {
    return function(obj1, obj2) {
        let i = 0, result = 0;
        const propsCount = props.length;
        while(result === 0 && i < propsCount){
            result = sortByObjectProp(props[i])(obj1, obj2);
            i++;
        }
        return result;
    };
}
function getPropValue(obj, key, defaultValue) {
    return key.split('.').reduce((o, k)=>{
        return o ? o[k] : o;
    }, obj) || defaultValue;
}
function filterByPropertyValue(arr, property, value) {
    return arr.filter((item)=>item[property] === value);
}
function findByPropertyValue(arr, property, value) {
    return arr.find((item)=>item[property] === value);
}
function stripTrailingSlash(str) {
    return str.replace(/(.+)(\/$)/, '$1');
}
function dedupeConsecutiveSlashes(str) {
    return str.replace(/\/\/+/, '/');
}
function getPreferredPaymentMethod(paymentMethods) {
    const preferredPaymentMethod = findByPropertyValue(paymentMethods, 'preferred', true);
    return preferredPaymentMethod ? preferredPaymentMethod : paymentMethods.length ? paymentMethods[0] : {
        paymentMethodId: ''
    };
}
function getFormPrefix(prefix, index) {
    return prefix ? `${prefix}[${index}].` : '';
}
function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function getDecimals(num, res = 2) {
    return parseFloat((num % 1).toFixed(res));
}
function generateURL({ url = window.location.origin, params = {} }) {
    const searchParams = new URLSearchParams(window.location.search);
    for (const [key, value] of Object.entries(params))searchParams.append(key, value);
    return `${url}?${searchParams.toString()}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jOoo6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "routes", ()=>routes);
var _routes = require("Core/routes");
var _routes1 = require("Modules/deposit/routes");
var _routes2 = require("Modules/directSales/routes");
var _routes3 = require("Modules/creditDebit/routes");
var _routes4 = require("Modules/cardPayment/routes");
var _routes5 = require("Modules/financing/routes");
var _routes6 = require("Modules/patientfi/routes");
var _routes7 = require("Modules/fortiva/routes");
var _routes8 = require("Modules/lendFlow/routes");
const routes = {
    us: [
        ...(0, _routes.routes),
        ...(0, _routes1.routes),
        ...(0, _routes2.routes),
        ...(0, _routes3.routes),
        ...(0, _routes4.routes),
        ...(0, _routes5.routes),
        ...(0, _routes6.routes),
        ...(0, _routes7.routes),
        ...(0, _routes8.routes)
    ],
    ca: [
        ...(0, _routes.routes),
        ...(0, _routes1.routes)
    ]
};

},{"Core/routes":"iddMu","Modules/deposit/routes":"01vo0","Modules/directSales/routes":"8b3zi","Modules/creditDebit/routes":"yRzgP","Modules/cardPayment/routes":"kPsar","Modules/financing/routes":"5ZPtj","Modules/patientfi/routes":"lyzU7","Modules/fortiva/routes":"6CCT1","Modules/lendFlow/routes":"epDqx","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iddMu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorPath", ()=>errorPath);
parcelHelpers.export(exports, "journeyPath", ()=>journeyPath);
parcelHelpers.export(exports, "teleaudiologyPath", ()=>teleaudiologyPath);
parcelHelpers.export(exports, "collectPath", ()=>collectPath);
parcelHelpers.export(exports, "platformPath", ()=>platformPath);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _error = require("Core/routes/Error");
var _customerJourney = require("Core/routes/CustomerJourney");
var _platform = require("Core/routes/Platform");
var _notFound = require("Core/routes/NotFound");
var _teleaudiology = require("Core/routes/Teleaudiology");
var _teleaudiologyDefault = parcelHelpers.interopDefault(_teleaudiology);
var _collect = require("Core/routes/Collect");
var _collectDefault = parcelHelpers.interopDefault(_collect);
var _orderData = require("Core/components/Data/OrderData");
var _orderDataDefault = parcelHelpers.interopDefault(_orderData);
const errorPath = '/error';
const journeyPath = '/journey';
const teleaudiologyPath = '/teleaudiology';
const collectPath = '/collect';
const platformPath = '/platform';
const routes = [
    {
        path: errorPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _error.Error), {})
    },
    {
        path: journeyPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerJourney.CustomerJourney), {})
    },
    {
        path: teleaudiologyPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _teleaudiologyDefault.default), {})
        })
    },
    {
        path: collectPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectDefault.default), {})
        })
    },
    {
        path: platformPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _platform.Platform), {})
    },
    {
        path: '*',
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
    }
];

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/routes/Error":"dTZad","Core/routes/CustomerJourney":"7oOko","Core/routes/Platform":"7qFMD","Core/routes/NotFound":"4vxt9","Core/routes/Teleaudiology":"jNmG4","Core/routes/Collect":"j9PjZ","Core/components/Data/OrderData":"jg54z","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dTZad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Error", ()=>Error);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _alert = require("Core/components/Alert");
function Error() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const error = (0, _errorDefault.default)((0, _error.errorSelector));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.error.header'),
        withStepProgress: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                className: "text-2xl",
                children: t('common.errorHeadline')
            }),
            error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                children: error
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        t('common.contactRecovery'),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        t('common.feedbackRecovery')
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/stores/error":"38MVH","Core/components/Page":"4xeqH","Core/components/Alert":"fmmNR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"38MVH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorSelector", ()=>errorSelector);
parcelHelpers.export(exports, "setErrorActionSelector", ()=>setErrorActionSelector);
var _zustand = require("zustand");
exports.default = (0, _zustand.create)((set)=>({
        error: '',
        setError: (error)=>set({
                error
            })
    }));
const errorSelector = (state)=>state.error;
const setErrorActionSelector = (state)=>state.setError;

},{"zustand":"61uwS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4xeqH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useShowSidebar = require("Core/hooks/useShowSidebar");
var _header = require("Core/components/Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _main = require("Core/components/Main");
var _mainDefault = parcelHelpers.interopDefault(_main);
var _alert = require("Core/components/Alert");
var _headerBanner = require("Core/components/HeaderBanner");
var _headerBannerDefault = parcelHelpers.interopDefault(_headerBanner);
var _footerBanner = require("Core/components/FooterBanner");
var _footerBannerDefault = parcelHelpers.interopDefault(_footerBanner);
var _stickyFooter = require("Core/components/StickyFooter");
var _stickyFooterDefault = parcelHelpers.interopDefault(_stickyFooter);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _reactLocation = require("react-location");
const ShoppingCart = /*#__PURE__*/ (0, _reactDefault.default).lazy(()=>require("a5ffffb070ea10d3"));
const StepProgress = /*#__PURE__*/ (0, _reactDefault.default).lazy(()=>require("1b285846e79213"));
const Page = ({ children, title, subtitle, stepProgressProps = {}, withStepProgress = true, withSidebar = false, withCardPrefCenterLink = false, stickyFooter = false, branding = '', showStripeLogo = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const shouldShowSidebar = (0, _useShowSidebar.useShowSidebar)();
    const fallback = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.component')
    });
    const { embed: isEmbedded = false } = (0, _reactLocation.useSearch)();
    if (withSidebar && shouldShowSidebar) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Suspense, {
        fallback: fallback,
        children: [
            !isEmbedded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerBannerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {
                title: title,
                withCardPrefCenterLink: withCardPrefCenterLink,
                branding: branding || ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _mainDefault.default), {
                children: [
                    withStepProgress && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepProgress, {
                        ...stepProgressProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid gap-4 [grid-template-columns:1fr_min-content]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grow-[2]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.GlobalPageAlert), {}),
                                    children
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow relative [min-width:380px] [max-width:440px]",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "sticky top-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShoppingCart, {
                                        withElevation: true
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            !isEmbedded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerBannerDefault.default), {})
        ]
    });
    const pageContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !isEmbedded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerBannerDefault.default), {
                hideStripeLogo: showStripeLogo
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {
                title: title,
                subtitle: subtitle,
                withCardPrefCenterLink: withCardPrefCenterLink,
                branding: branding,
                showStripeLogo: showStripeLogo
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _mainDefault.default), {
                className: stickyFooter ? 'flex-1 min-h-0 flex flex-col' : '',
                children: [
                    withStepProgress && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepProgress, {
                        ...stepProgressProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.GlobalPageAlert), {}),
                    children
                ]
            }),
            !isEmbedded && stickyFooter ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stickyFooterDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerBannerDefault.default), {})
        ]
    });
    if (stickyFooter) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "min-h-screen flex flex-col",
        children: pageContent
    });
    return pageContent;
};
exports.default = Page;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useShowSidebar":"as56L","Core/components/Header":"aYwRv","Core/components/Main":"2gir4","Core/components/Alert":"fmmNR","Core/components/HeaderBanner":"f9tIx","Core/components/FooterBanner":"33pLK","Core/components/StickyFooter":"iqmSx","Core/components/Loader":"6S7S4","react-location":"8hNco","a5ffffb070ea10d3":"lOvZn","1b285846e79213":"h17kK","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"as56L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useShowSidebar", ()=>useShowSidebar);
var _useWindowSize = require("Core/hooks/useWindowSize");
function useShowSidebar() {
    const { width } = (0, _useWindowSize.useWindowSize)();
    const breakpoint = 1200;
    return width >= breakpoint;
}

},{"Core/hooks/useWindowSize":"e88AQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"e88AQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWindowSize", ()=>useWindowSize);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useWindowSize() {
    const isClient = typeof window === 'object';
    const getSize = (0, _reactDefault.default).useCallback(()=>{
        return {
            width: isClient ? window.innerWidth : null,
            height: isClient ? window.innerHeight : null
        };
    }, [
        isClient
    ]);
    const [windowSize, setWindowSize] = (0, _reactDefault.default).useState(getSize);
    (0, _reactDefault.default).useEffect(()=>{
        if (!isClient) return false;
        function handleResize() {
            setWindowSize(getSize());
        }
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, [
        isClient,
        getSize
    ]);
    return windowSize;
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aYwRv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
exports.default = (0, _headerDefault.default);

},{"./Header":"7VfD6","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7VfD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Header);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactLocation = require("react-location");
var _layout = require("Core/components/Layout");
var _routes = require("Modules/deposit/routes");
var _poweredByStripeWhiteSvg = require("url:Images/powered_by_stripe_white.svg");
var _poweredByStripeWhiteSvgDefault = parcelHelpers.interopDefault(_poweredByStripeWhiteSvg);
function Header({ title, subtitle, withCardPrefCenterLink, branding = 'default', showStripeLogo = false }) {
    const isPatientfi = branding === 'patientfi';
    const finalBranding = branding || 'default';
    const classes = {
        patientfi: 'bg-patientfi-bg text-patientfi-text',
        fortiva: 'bg-fortiva-bg text-fortiva-text',
        lendflow: 'bg-lendflow-bg text-lendflow-text',
        default: 'bg-primary text-white',
        flexHeight: subtitle ? 'h-full' : '',
        subtitleColor: isPatientfi ? 'text-patientfi-text' : 'text-gray-300'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
        className: `${classes[finalBranding]} px-4 mb-4 h-16`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Container), {
            className: `!mb-0 !h-full !px-4 !flex !items-center !justify-between`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: `${classes.flexHeight} flex flex-col py-2`,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "m-0",
                            "data-testid": "header-headline",
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `${classes.subtitleColor} text-sm`,
                            children: subtitle
                        })
                    ]
                }),
                withCardPrefCenterLink && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Link), {
                    "data-testid": "card-pref-center-link",
                    to: (0, _routes.cardPreferenceCenterPath),
                    search: true,
                    children: "Card Preference Center"
                }),
                showStripeLogo && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "https://stripe.com/",
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: (0, _poweredByStripeWhiteSvgDefault.default),
                        alt: "powered by stripe",
                        style: {
                            height: '28px'
                        }
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-location":"8hNco","Core/components/Layout":"hweet","Modules/deposit/routes":"01vo0","url:Images/powered_by_stripe_white.svg":"iFuS9","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"01vo0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "depositCheckoutPath", ()=>depositCheckoutPath);
parcelHelpers.export(exports, "depositSuccessPath", ()=>depositSuccessPath);
parcelHelpers.export(exports, "cardPreferenceCenterPath", ()=>cardPreferenceCenterPath);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _checkout = require("Modules/deposit/routes/Checkout");
var _checkoutDefault = parcelHelpers.interopDefault(_checkout);
var _success = require("Modules/deposit/routes/Success");
var _successDefault = parcelHelpers.interopDefault(_success);
var _cardPreferenceCenter = require("Modules/deposit/routes/CardPreferenceCenter");
var _cardPreferenceCenterDefault = parcelHelpers.interopDefault(_cardPreferenceCenter);
var _depositData = require("Modules/deposit/components/DepositData");
var _depositDataDefault = parcelHelpers.interopDefault(_depositData);
const depositCheckoutPath = '/office/deposit';
const depositSuccessPath = '/office/deposit/success';
const cardPreferenceCenterPath = '/office/cards';
const routes = [
    {
        path: depositSuccessPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _depositDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _successDefault.default), {})
        })
    },
    {
        path: depositCheckoutPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _depositDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkoutDefault.default), {})
        })
    },
    {
        path: cardPreferenceCenterPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardPreferenceCenterDefault.default), {})
    }
];

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/deposit/routes/Checkout":"fOK8t","Modules/deposit/routes/Success":"3U71W","Modules/deposit/routes/CardPreferenceCenter":"b06ef","Modules/deposit/components/DepositData":"bPJKS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fOK8t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Checkout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactLocation = require("react-location");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _depositCardForm = require("Modules/deposit/components/DepositCardForm");
var _depositCardFormDefault = parcelHelpers.interopDefault(_depositCardForm);
var _useDepositPageData = require("Modules/deposit/hooks/useDepositPageData");
var _useDepositPageDataDefault = parcelHelpers.interopDefault(_useDepositPageData);
var _usePostCreatePaymentMethods = require("Core/hooks/queries/stripe/usePostCreatePaymentMethods");
var _usePostCreatePaymentMethodsDefault = parcelHelpers.interopDefault(_usePostCreatePaymentMethods);
var _usePostChargeDeposit = require("Core/hooks/queries/deposit/usePostChargeDeposit");
var _usePostChargeDepositDefault = parcelHelpers.interopDefault(_usePostChargeDeposit);
var _useScrollTop = require("Core/hooks/useScrollTop");
var _useUpdatePaymentMethod = require("Core/hooks/queries/payment/useUpdatePaymentMethod");
var _useUpdatePaymentMethodDefault = parcelHelpers.interopDefault(_useUpdatePaymentMethod);
var _status = require("Core/components/Status");
var _statusDefault = parcelHelpers.interopDefault(_status);
var _routes = require("Modules/deposit/routes");
function Checkout() {
    const scroll = (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { data, isSuccess } = (0, _useDepositPageDataDefault.default)();
    const [status, setStatus] = (0, _reactDefault.default).useState({
        type: '',
        text: ''
    });
    const [cardErrors, setCardErrors] = (0, _reactDefault.default).useState();
    const { mutateAsync: createPaymentMethods } = (0, _usePostCreatePaymentMethodsDefault.default)();
    const { mutateAsync: chargeDeposit } = (0, _usePostChargeDepositDefault.default)();
    const { mutateAsync: updateCard } = (0, _useUpdatePaymentMethodDefault.default)();
    if (!isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: 'Loading saved cards'
    });
    async function onSubmit(formData) {
        scroll.top();
        let paymentMethods;
        setStatus({
            type: 'loading',
            text: t('status.loading.submitPaymentInformation')
        });
        if (!formData.paymentMethodId) {
            const paymentMethodData = [
                {
                    cardId: 'card0',
                    amount: formData.amount,
                    stripeElement: formData.stripeElement,
                    billingDetails: {
                        name: `${formData.firstName} ${formData.lastName}`,
                        address: {
                            postal_code: formData.postalCode
                        }
                    }
                }
            ];
            if (!formData.stripe) return setStatus({
                type: 'error',
                text: t('status.error.paymentGatewayInitialize')
            });
            try {
                paymentMethods = await createPaymentMethods({
                    stripe: formData.stripe,
                    data: paymentMethodData
                });
            } catch  {
                setStatus({
                    type: 'error',
                    text: t('status.error.failedToCreatePaymentMethods')
                });
                return;
            }
        }
        const paymentMethodId = formData.paymentMethodId || paymentMethods[0].paymentMethodId;
        try {
            await chargeDeposit({
                amount: formData.amount,
                paymentMethodId,
                type: formData.type
            });
            formData.preferred && await updateCard({
                paymentMethodId,
                preferred: true
            });
            navigate({
                to: (0, _routes.depositSuccessPath),
                search: true
            });
        } catch (error) {
            const detailedErrorMessage = error?.response?.data?.message || t('status.error.failedToChargeCard');
            setStatus({
                type: 'error',
                text: detailedErrorMessage
            });
            if (error?.response?.data?.hasOwnProperty('errors')) setCardErrors(error.response.data.errors);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.deposit.checkout.header'),
        stepProgressProps: {
            type: 'deposit'
        },
        withCardPrefCenterLink: true,
        stickyFooter: true,
        showStripeLogo: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusDefault.default), {
                ...status
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _depositCardFormDefault.default), {
                ...data,
                onSubmit: onSubmit,
                cardErrors: cardErrors
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","react-location":"8hNco","Core/components/Loader":"6S7S4","Core/components/Page":"4xeqH","Modules/deposit/components/DepositCardForm":"4nb9k","Modules/deposit/hooks/useDepositPageData":"fJXC6","Core/hooks/queries/stripe/usePostCreatePaymentMethods":"gEPFe","Core/hooks/queries/deposit/usePostChargeDeposit":"2m5lX","Core/hooks/useScrollTop":"cBwQW","Core/hooks/queries/payment/useUpdatePaymentMethod":"4bxss","Core/components/Status":"5UE3N","Modules/deposit/routes":"01vo0","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4nb9k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DepositCardForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("Core/utils/utils");
var _useDepositForm = require("Modules/deposit/hooks/useDepositForm");
var _useDepositFormDefault = parcelHelpers.interopDefault(_useDepositForm);
var _cardSelector = require("Core/components/CardSelector");
var _cardSelectorDefault = parcelHelpers.interopDefault(_cardSelector);
var _styledFormGroup = require("Core/components/FormElements/StyledFormGroup");
var _styledFormGroupDefault = parcelHelpers.interopDefault(_styledFormGroup);
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
var _layout = require("Core/components/Layout");
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _numberFormat = require("Core/utils/numberFormat");
var _alert = require("Core/components/Alert");
var _option = require("Core/components/Option/Option");
var _optionDefault = parcelHelpers.interopDefault(_option);
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _checkbox = require("Core/components/FormElements/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
function StyledOptionItem({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col items-center justify-between bg-white border-2 border-solid border-gray-300 rounded py-6 px-2 mb-4 w-full transition-colors hover:border-primary hover:[background:linear-gradient(165deg,#dedede_50%,#d2d2d2_50%)]",
        children: children
    });
}
const DepositOptions = ({ options, form })=>{
    const optionRef = (0, _reactDefault.default).useRef(null);
    const { t } = (0, _reactI18Next.useTranslation)();
    const { register, getValues, setValue } = form;
    const { type } = form.getValues();
    const [displayedOptions, setDisplayedOptions] = (0, _reactDefault.default).useState((0, _utils.filterByPropertyValue)(options, 'visibility', 'VISIBLE'));
    // Manually set value in case there is only 1 option
    (0, _reactDefault.default).useEffect(()=>{
        if (displayedOptions.length === 1) {
            const [{ amount }] = displayedOptions;
            setValue('amount', String(amount));
        }
        //Need to set manually for initial render to register the field
        setValue('type', type);
    }, [
        type,
        displayedOptions,
        setValue
    ]);
    const onToggleOptions = (0, _reactDefault.default).useCallback(()=>{
        if (options.length === displayedOptions.length) setDisplayedOptions((0, _utils.filterByPropertyValue)(options, 'visibility', 'VISIBLE'));
        else setDisplayedOptions(options);
    }, [
        displayedOptions.length,
        options
    ]);
    //Set first option as selected when toggling options
    (0, _reactDefault.default).useEffect(()=>{
        const [{ type, amount }] = displayedOptions;
        setValue('type', type);
        setValue('amount', String(amount));
        optionRef.current.querySelector('input').click();
        optionRef.current.dispatchEvent(new Event('click', {
            bubbles: true
        }));
    }, [
        displayedOptions,
        displayedOptions.length,
        setValue
    ]);
    if (displayedOptions.length === 1) {
        const [{ type, amount }] = displayedOptions;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
            className: "text-base font-bold",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                i18nKey: `deposit.${type}`,
                values: {
                    amount: (0, _numberFormat.formatCurrency)(amount, {
                        withDecimals: false
                    })
                }
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: t('common:depositAmount')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: "text-lg mb-2 underline",
                onClick: onToggleOptions,
                children: [
                    t('common.optionsToggle'),
                    " ",
                    options.length === displayedOptions.length ? "\u2191" : "\u2193"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
                "data-testid": "deposit-card-option-container",
                ref: optionRef,
                children: displayedOptions.map(({ option, amount, type })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "md:flex-col-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionDefault.default), {
                            register: register,
                            className: "styled-deposit-option !flex",
                            name: "amount",
                            value: amount,
                            defaultChecked: getValues().amount === amount,
                            onChange: ()=>setValue('type', type),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledOptionItem, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-4xl font-bold",
                                        children: (0, _numberFormat.formatCurrency)(amount, {
                                            withDecimals: false
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-xl font-bold",
                                        children: t(`common.${type}`)
                                    })
                                ]
                            })
                        })
                    }, option))
            })
        ]
    });
};
function DepositCardForm({ paymentMethods, depositOptions, onSubmit, cardErrors }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { paymentMethodId } = (0, _utils.getPreferredPaymentMethod)(paymentMethods);
    const [{ type, amount }] = depositOptions;
    const defaultValues = paymentMethodId ? {
        paymentMethodId,
        type,
        amount,
        terms: false
    } : {
        firstName: '',
        lastName: '',
        postalCode: '',
        cardNumber: '',
        cardExpiry: '',
        cardCvc: '',
        preferred: true,
        type,
        amount: 1,
        terms: false
    };
    const form = (0, _useDepositFormDefault.default)(defaultValues);
    const { watch, handleSubmit, register, formState: { errors } } = form;
    const cardError = cardErrors?.[0].message;
    const termsTextId = watch('type') === 'authorize' ? 'terms.card.hold' : 'terms.card.charge';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        name: "depositCardForm",
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledFormGroupDefault.default), {
                error: cardError,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardSelectorDefault.default), {
                    cardError: cardError,
                    form: form,
                    paymentMethods: paymentMethods,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                        label: t('common.markAsPreferredCard'),
                        name: "preferred",
                        register: register
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DepositOptions, {
                options: depositOptions,
                form: form
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _termsInputDefault.default), {
                name: "terms",
                register: register,
                errors: errors,
                label: t('common.termsAndConditions'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: t(termsTextId)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
                className: "!justify-end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                    className: "!flex-col-6 md:!flex-col-4 lg:!flex-col-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                        block: true,
                        type: "submit",
                        "data-testid": "checkout",
                        children: t('common.checkout')
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/utils/utils":"hwOBZ","Modules/deposit/hooks/useDepositForm":"1kIMj","Core/components/CardSelector":"4d8Tr","Core/components/FormElements/StyledFormGroup":"6lnq9","Core/components/Button":"6YNzH","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"Core/components/Layout":"hweet","Core/components/Layout/Row":"8YqFQ","Core/utils/numberFormat":"6T56F","Core/components/Alert":"fmmNR","Core/components/Option/Option":"7niNe","Core/components/FormElements/TermsInput":"2LJBE","Core/components/FormElements/Checkbox":"9nTYl","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1kIMj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDepositForm);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _v3 = require("zod/v3");
var _reactHookForm = require("react-hook-form");
var _zod = require("@hookform/resolvers/zod");
var _reactI18Next = require("react-i18next");
function useDepositForm(defaultValues) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.union([
            _v3.object({
                firstName: _v3.string().nonempty({
                    message: t('common.requiredFieldFirstName')
                }),
                lastName: _v3.string().nonempty({
                    message: t('common.requiredFieldLastName')
                }),
                postalCode: _v3.string().nonempty({
                    message: t('common.requiredFieldPostalCode')
                }),
                cardNumber: _v3.any().refine((value)=>Boolean(value), {
                    message: t('common.requiredFieldCardNumber')
                }),
                cardExpiry: _v3.any().refine((value)=>Boolean(value), {
                    message: t('common.requiredFieldCardExpiry')
                }),
                cardCvc: _v3.any().refine((value)=>Boolean(value), {
                    message: t('common.requiredFieldCardCode')
                }),
                // amount: z.string().nonempty({ message: t('common.requiredFieldAmount') }),
                amount: _v3.string().nonempty({
                    message: t('common.requiredFieldAmount')
                }).refine((val)=>parseInt(val, 10) >= 1, {
                    message: t('common.requiredFieldSplitAmount')
                }),
                type: _v3.string(),
                email: _v3.string().email({
                    message: t('common.invalidFormatEmail')
                }).optional().or(_v3.literal('')),
                terms: _v3.boolean().refine((val)=>val, {
                    message: t('common.requiredFieldTerms')
                }),
                preferred: _v3.boolean(),
                stripeElement: _v3.any(),
                stripe: _v3.any()
            }),
            _v3.object({
                paymentMethodId: _v3.string().nonempty({
                    message: t('common.requiredFieldFirstName')
                }),
                // amount: z.string().nonempty({ message: t('common.requiredFieldAmount') }),
                amount: _v3.string().nonempty({
                    message: t('common.requiredFieldAmount')
                }).refine((val)=>parseInt(val, 10) >= 1, {
                    message: t('common.requiredFieldSplitAmount')
                }),
                type: _v3.string(),
                email: _v3.string().email({
                    message: t('common.invalidFormatEmail')
                }).optional().or(_v3.literal('')),
                terms: _v3.boolean().refine((val)=>val, {
                    message: t('common.requiredFieldTerms')
                })
            })
        ]);
    }, [
        t
    ]);
    return (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        defaultValues,
        shouldUnregister: true
    });
}

},{"react":"2o0ib","zod/v3":"kXNSc","react-hook-form":"53GLT","@hookform/resolvers/zod":"c0M5u","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kXNSc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "z", ()=>_externalJs);
var _externalJs = require("./external.js");
parcelHelpers.exportAll(_externalJs, exports);
exports.default = _externalJs;

},{"./external.js":"8MFp9","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8MFp9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errorsJs = require("./errors.js");
parcelHelpers.exportAll(_errorsJs, exports);
var _parseUtilJs = require("./helpers/parseUtil.js");
parcelHelpers.exportAll(_parseUtilJs, exports);
var _typeAliasesJs = require("./helpers/typeAliases.js");
parcelHelpers.exportAll(_typeAliasesJs, exports);
var _utilJs = require("./helpers/util.js");
parcelHelpers.exportAll(_utilJs, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _zodErrorJs = require("./ZodError.js");
parcelHelpers.exportAll(_zodErrorJs, exports);

},{"./errors.js":"9p8OR","./helpers/parseUtil.js":"88KNc","./helpers/typeAliases.js":"5qj6k","./helpers/util.js":"lc98B","./types.js":"iCFXv","./ZodError.js":"hEQBO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9p8OR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultErrorMap", ()=>(0, _enJsDefault.default));
parcelHelpers.export(exports, "setErrorMap", ()=>setErrorMap);
parcelHelpers.export(exports, "getErrorMap", ()=>getErrorMap);
var _enJs = require("./locales/en.js");
var _enJsDefault = parcelHelpers.interopDefault(_enJs);
let overrideErrorMap = (0, _enJsDefault.default);
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

},{"./locales/en.js":"cTiZt","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cTiZt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _zodErrorJs = require("../ZodError.js");
var _utilJs = require("../helpers/util.js");
const errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, _zodErrorJs.ZodIssueCode).invalid_type:
            if (issue.received === (0, _utilJs.ZodParsedType).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, _utilJs.util).jsonStringifyReplacer)}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, _utilJs.util).joinValues(issue.keys, ", ")}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_union:
            message = `Invalid input`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, _utilJs.util).joinValues(issue.options)}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, _utilJs.util).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_date:
            message = `Invalid date`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, _utilJs.util).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, _zodErrorJs.ZodIssueCode).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, _zodErrorJs.ZodIssueCode).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, _zodErrorJs.ZodIssueCode).custom:
            message = `Invalid input`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, _utilJs.util).assertNever(issue);
    }
    return {
        message
    };
};
exports.default = errorMap;

},{"../ZodError.js":"hEQBO","../helpers/util.js":"lc98B","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hEQBO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZodIssueCode", ()=>ZodIssueCode);
parcelHelpers.export(exports, "quotelessJson", ()=>quotelessJson);
parcelHelpers.export(exports, "ZodError", ()=>ZodError);
var _utilJs = require("./helpers/util.js");
const ZodIssueCode = (0, _utilJs.util).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        // `_errors` is reserved by this legacy format, so merge a matching path segment into the current node instead of treating its array as a child.
                        if (el === "_errors") {
                            if (terminal) curr._errors.push(mapper(issue));
                            i++;
                            continue;
                        }
                        // Create `el` as an own data property. A segment naming an inherited member ("toString", "constructor") would otherwise read through to the prototype, and assigning "__proto__" would hit the setter and walk into Object.prototype.
                        if (!Object.prototype.hasOwnProperty.call(curr, el)) {
                            if (el === "__proto__") Object.defineProperty(curr, el, {
                                value: {
                                    _errors: []
                                },
                                writable: true,
                                enumerable: true,
                                configurable: true
                            });
                            else curr[el] = {
                                _errors: []
                            };
                        }
                        curr = curr[el];
                        if (terminal) curr._errors.push(mapper(issue));
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, _utilJs.util).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = Object.create(null);
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors,
            fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues)=>{
    const error = new ZodError(issues);
    return error;
};

},{"./helpers/util.js":"lc98B","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lc98B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "util", ()=>util);
parcelHelpers.export(exports, "objectUtil", ()=>objectUtil);
parcelHelpers.export(exports, "ZodParsedType", ()=>ZodParsedType);
parcelHelpers.export(exports, "getParsedType", ()=>getParsedType);
var util;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return Number.isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return ZodParsedType.array;
            if (data === null) return ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return ZodParsedType.date;
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"88KNc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeIssue", ()=>makeIssue);
parcelHelpers.export(exports, "EMPTY_PATH", ()=>EMPTY_PATH);
parcelHelpers.export(exports, "addIssueToContext", ()=>addIssueToContext);
parcelHelpers.export(exports, "ParseStatus", ()=>ParseStatus);
parcelHelpers.export(exports, "INVALID", ()=>INVALID);
parcelHelpers.export(exports, "DIRTY", ()=>DIRTY);
parcelHelpers.export(exports, "OK", ()=>OK);
parcelHelpers.export(exports, "isAborted", ()=>isAborted);
parcelHelpers.export(exports, "isDirty", ()=>isDirty);
parcelHelpers.export(exports, "isValid", ()=>isValid);
parcelHelpers.export(exports, "isAsync", ()=>isAsync);
var _errorsJs = require("../errors.js");
var _enJs = require("../locales/en.js");
var _enJsDefault = parcelHelpers.interopDefault(_enJs);
const makeIssue = (params)=>{
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = (0, _errorsJs.getErrorMap)();
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, _enJsDefault.default) ? undefined : (0, _enJsDefault.default)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key, value } = pair;
            if (key.status === "aborted") return INVALID;
            if (value.status === "aborted") return INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const INVALID = Object.freeze({
    status: "aborted"
});
const DIRTY = (value)=>({
        status: "dirty",
        value
    });
const OK = (value)=>({
        status: "valid",
        value
    });
const isAborted = (x)=>x.status === "aborted";
const isDirty = (x)=>x.status === "dirty";
const isValid = (x)=>x.status === "valid";
const isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;

},{"../errors.js":"9p8OR","../locales/en.js":"cTiZt","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5qj6k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iCFXv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZodType", ()=>ZodType);
// Adapted from https://stackoverflow.com/a/3143231
parcelHelpers.export(exports, "datetimeRegex", ()=>datetimeRegex);
parcelHelpers.export(exports, "ZodString", ()=>ZodString);
parcelHelpers.export(exports, "ZodNumber", ()=>ZodNumber);
parcelHelpers.export(exports, "ZodBigInt", ()=>ZodBigInt);
parcelHelpers.export(exports, "ZodBoolean", ()=>ZodBoolean);
parcelHelpers.export(exports, "ZodDate", ()=>ZodDate);
parcelHelpers.export(exports, "ZodSymbol", ()=>ZodSymbol);
parcelHelpers.export(exports, "ZodUndefined", ()=>ZodUndefined);
parcelHelpers.export(exports, "ZodNull", ()=>ZodNull);
parcelHelpers.export(exports, "ZodAny", ()=>ZodAny);
parcelHelpers.export(exports, "ZodUnknown", ()=>ZodUnknown);
parcelHelpers.export(exports, "ZodNever", ()=>ZodNever);
parcelHelpers.export(exports, "ZodVoid", ()=>ZodVoid);
parcelHelpers.export(exports, "ZodArray", ()=>ZodArray);
parcelHelpers.export(exports, "ZodObject", ()=>ZodObject);
parcelHelpers.export(exports, "ZodUnion", ()=>ZodUnion);
parcelHelpers.export(exports, "ZodDiscriminatedUnion", ()=>ZodDiscriminatedUnion);
parcelHelpers.export(exports, "ZodIntersection", ()=>ZodIntersection);
// type ZodTupleItems = [ZodTypeAny, ...ZodTypeAny[]];
parcelHelpers.export(exports, "ZodTuple", ()=>ZodTuple);
parcelHelpers.export(exports, "ZodRecord", ()=>ZodRecord);
parcelHelpers.export(exports, "ZodMap", ()=>ZodMap);
parcelHelpers.export(exports, "ZodSet", ()=>ZodSet);
parcelHelpers.export(exports, "ZodFunction", ()=>ZodFunction);
parcelHelpers.export(exports, "ZodLazy", ()=>ZodLazy);
parcelHelpers.export(exports, "ZodLiteral", ()=>ZodLiteral);
parcelHelpers.export(exports, "ZodEnum", ()=>ZodEnum);
parcelHelpers.export(exports, "ZodNativeEnum", ()=>ZodNativeEnum);
parcelHelpers.export(exports, "ZodPromise", ()=>ZodPromise);
parcelHelpers.export(exports, "ZodEffects", ()=>ZodEffects);
parcelHelpers.export(exports, "ZodTransformer", ()=>ZodEffects);
parcelHelpers.export(exports, "ZodOptional", ()=>ZodOptional);
parcelHelpers.export(exports, "ZodNullable", ()=>ZodNullable);
parcelHelpers.export(exports, "ZodDefault", ()=>ZodDefault);
parcelHelpers.export(exports, "ZodCatch", ()=>ZodCatch);
parcelHelpers.export(exports, "ZodNaN", ()=>ZodNaN);
parcelHelpers.export(exports, "BRAND", ()=>BRAND);
parcelHelpers.export(exports, "ZodBranded", ()=>ZodBranded);
parcelHelpers.export(exports, "ZodPipeline", ()=>ZodPipeline);
parcelHelpers.export(exports, "ZodReadonly", ()=>ZodReadonly);
parcelHelpers.export(exports, "custom", ()=>custom);
parcelHelpers.export(exports, "Schema", ()=>ZodType);
parcelHelpers.export(exports, "ZodSchema", ()=>ZodType);
parcelHelpers.export(exports, "late", ()=>late);
parcelHelpers.export(exports, "ZodFirstPartyTypeKind", ()=>ZodFirstPartyTypeKind);
parcelHelpers.export(exports, "coerce", ()=>coerce);
parcelHelpers.export(exports, "any", ()=>anyType);
parcelHelpers.export(exports, "array", ()=>arrayType);
parcelHelpers.export(exports, "bigint", ()=>bigIntType);
parcelHelpers.export(exports, "boolean", ()=>booleanType);
parcelHelpers.export(exports, "date", ()=>dateType);
parcelHelpers.export(exports, "discriminatedUnion", ()=>discriminatedUnionType);
parcelHelpers.export(exports, "effect", ()=>effectsType);
parcelHelpers.export(exports, "enum", ()=>enumType);
parcelHelpers.export(exports, "function", ()=>functionType);
parcelHelpers.export(exports, "instanceof", ()=>instanceOfType);
parcelHelpers.export(exports, "intersection", ()=>intersectionType);
parcelHelpers.export(exports, "lazy", ()=>lazyType);
parcelHelpers.export(exports, "literal", ()=>literalType);
parcelHelpers.export(exports, "map", ()=>mapType);
parcelHelpers.export(exports, "nan", ()=>nanType);
parcelHelpers.export(exports, "nativeEnum", ()=>nativeEnumType);
parcelHelpers.export(exports, "never", ()=>neverType);
parcelHelpers.export(exports, "null", ()=>nullType);
parcelHelpers.export(exports, "nullable", ()=>nullableType);
parcelHelpers.export(exports, "number", ()=>numberType);
parcelHelpers.export(exports, "object", ()=>objectType);
parcelHelpers.export(exports, "oboolean", ()=>oboolean);
parcelHelpers.export(exports, "onumber", ()=>onumber);
parcelHelpers.export(exports, "optional", ()=>optionalType);
parcelHelpers.export(exports, "ostring", ()=>ostring);
parcelHelpers.export(exports, "pipeline", ()=>pipelineType);
parcelHelpers.export(exports, "preprocess", ()=>preprocessType);
parcelHelpers.export(exports, "promise", ()=>promiseType);
parcelHelpers.export(exports, "record", ()=>recordType);
parcelHelpers.export(exports, "set", ()=>setType);
parcelHelpers.export(exports, "strictObject", ()=>strictObjectType);
parcelHelpers.export(exports, "string", ()=>stringType);
parcelHelpers.export(exports, "symbol", ()=>symbolType);
parcelHelpers.export(exports, "transformer", ()=>effectsType);
parcelHelpers.export(exports, "tuple", ()=>tupleType);
parcelHelpers.export(exports, "undefined", ()=>undefinedType);
parcelHelpers.export(exports, "union", ()=>unionType);
parcelHelpers.export(exports, "unknown", ()=>unknownType);
parcelHelpers.export(exports, "void", ()=>voidType);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
var _zodErrorJs = require("./ZodError.js");
var _errorsJs = require("./errors.js");
var _errorUtilJs = require("./helpers/errorUtil.js");
var _parseUtilJs = require("./helpers/parseUtil.js");
var _utilJs = require("./helpers/util.js");
class ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result)=>{
    if ((0, _parseUtilJs.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, _zodErrorJs.ZodError)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description
    };
    const customMap = (iss, ctx)=>{
        const { message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description
    };
}
class ZodType {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, _utilJs.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, _utilJs.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, _parseUtilJs.ParseStatus)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, _utilJs.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, _parseUtilJs.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, _utilJs.getParsedType)(data)
        };
        const result = this._parseSync({
            data,
            path: ctx.path,
            parent: ctx
        });
        return handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, _utilJs.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data,
                path: [],
                parent: ctx
            });
            return (0, _parseUtilJs.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data,
            path: [],
            parent: ctx
        }).then((result)=>(0, _parseUtilJs.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, _utilJs.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, _parseUtilJs.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, _zodErrorJs.ZodIssueCode).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^[\\p{Extended_Pictographic}\\p{Emoji_Component}]+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
function isValidJWT(jwt, alg) {
    if (!jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        // @ts-ignore
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function isValidCidr(ip, version) {
    if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) return true;
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).string,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const status = new (0, _parseUtilJs.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "email",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                // @ts-ignore
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    validation: "url",
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation,
            code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, _errorUtilJs.errorUtil).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, _errorUtilJs.errorUtil).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, _errorUtilJs.errorUtil).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, _errorUtilJs.errorUtil).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, _errorUtilJs.errorUtil).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, _errorUtilJs.errorUtil).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, _errorUtilJs.errorUtil).errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params)=>{
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class ZodNumber extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).number,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        let ctx = undefined;
        const status = new (0, _parseUtilJs.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, _utilJs.util).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: (0, _errorUtilJs.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, _utilJs.util).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params)=>{
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodBigInt extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, _parseUtilJs.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, _parseUtilJs.addIssueToContext)(ctx, {
            code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
            expected: (0, _utilJs.ZodParsedType).bigint,
            received: ctx.parsedType
        });
        return 0, _parseUtilJs.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: (0, _errorUtilJs.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params)=>{
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).boolean,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodBoolean.create = (params)=>{
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).date,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_date
            });
            return 0, _parseUtilJs.INVALID;
        }
        const status = new (0, _parseUtilJs.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params)=>{
    return new ZodDate({
        checks: [],
        coerce: params?.coerce || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params)
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).symbol,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodSymbol.create = (params)=>{
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params)
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).undefined,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodUndefined.create = (params)=>{
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params)
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).null,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodNull.create = (params)=>{
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params)
    });
};
class ZodAny extends ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodAny.create = (params)=>{
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params)
    });
};
class ZodUnknown extends ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodUnknown.create = (params)=>{
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params)
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, _parseUtilJs.addIssueToContext)(ctx, {
            code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
            expected: (0, _utilJs.ZodParsedType).never,
            received: ctx.parsedType
        });
        return 0, _parseUtilJs.INVALID;
    }
}
ZodNever.create = (params)=>{
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params)
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).void,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodVoid.create = (params)=>{
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params)
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).array) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: tooBig ? (0, _zodErrorJs.ZodIssueCode).too_big : (0, _zodErrorJs.ZodIssueCode).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, _parseUtilJs.ParseStatus).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, _parseUtilJs.ParseStatus).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params)=>{
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params)
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof ZodArray) return new ZodArray({
        ...schema._def,
        type: deepPartialify(schema.element)
    });
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map((item)=>deepPartialify(item)));
    else return schema;
}
class ZodObject extends ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, _utilJs.util).objectKeys(shape);
        this._cached = {
            shape,
            keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key,
                    value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, _parseUtilJs.ParseStatus).mergeObjectSync(status, syncPairs);
        });
        else return (0, _parseUtilJs.ParseStatus).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, _errorUtilJs.errorUtil).errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, _errorUtilJs.errorUtil).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, _utilJs.util).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, _utilJs.util).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, _utilJs.util).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, _utilJs.util).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof ZodOptional)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return createZodEnum((0, _utilJs.util).objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.strictCreate = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.lazycreate = (shape, params)=>{
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, _zodErrorJs.ZodError)(result.ctx.common.issues));
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_union,
                unionErrors
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, _zodErrorJs.ZodError)(issues));
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_union,
                unionErrors
            });
            return 0, _parseUtilJs.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params)=>{
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type)=>{
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return (0, _utilJs.util).objectValues(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else if (type instanceof ZodOptional) return [
        undefined,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodNullable) return [
        null,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodBranded) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodReadonly) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodCatch) return getDiscriminator(type._def.innerType);
    else return [];
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).object) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params)
        });
    }
}
function mergeValues(a, b) {
    const aType = (0, _utilJs.getParsedType)(a);
    const bType = (0, _utilJs.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, _utilJs.ZodParsedType).object && bType === (0, _utilJs.ZodParsedType).object) {
        const bKeys = (0, _utilJs.util).objectKeys(b);
        const sharedKeys = (0, _utilJs.util).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        if (Object.prototype.hasOwnProperty.call(newObj, "__proto__")) delete newObj.__proto__;
        for (const key of sharedKeys){
            if (key === "__proto__") continue;
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, _utilJs.ZodParsedType).array && bType === (0, _utilJs.ZodParsedType).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, _utilJs.ZodParsedType).date && bType === (0, _utilJs.ZodParsedType).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, _parseUtilJs.isAborted)(parsedLeft) || (0, _parseUtilJs.isAborted)(parsedRight)) return 0, _parseUtilJs.INVALID;
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_intersection_types
                });
                return 0, _parseUtilJs.INVALID;
            }
            if ((0, _parseUtilJs.isDirty)(parsedLeft) || (0, _parseUtilJs.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
ZodIntersection.create = (left, right, params)=>{
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params)
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).array) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, _parseUtilJs.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, _parseUtilJs.ParseStatus).mergeArray(status, results);
        });
        else return (0, _parseUtilJs.ParseStatus).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest
        });
    }
}
ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params)
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).object) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, _parseUtilJs.ParseStatus).mergeObjectAsync(status, pairs);
        else return (0, _parseUtilJs.ParseStatus).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) return new ZodRecord({
            keyType: first,
            valueType: second,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(third)
        });
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second)
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).map) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).map,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, _parseUtilJs.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
ZodMap.create = (keyType, valueType, params)=>{
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params)
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).set) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).set,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params)=>{
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params)
    });
};
class ZodFunction extends ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).function) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).function,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, _parseUtilJs.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, _errorsJs.getErrorMap)(),
                    (0, _errorsJs.defaultErrorMap)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, _parseUtilJs.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, _errorsJs.getErrorMap)(),
                    (0, _errorsJs.defaultErrorMap)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, _parseUtilJs.OK)(async function(...args) {
                const error = new (0, _zodErrorJs.ZodError)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, _parseUtilJs.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, _zodErrorJs.ZodError)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, _zodErrorJs.ZodError)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params)
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
ZodLazy.create = (getter, params)=>{
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params)
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_literal,
                expected: this._def.value
            });
            return 0, _parseUtilJs.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params)=>{
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params)
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params)
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                expected: (0, _utilJs.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = (0, _utilJs.util).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).string && ctx.parsedType !== (0, _utilJs.ZodParsedType).number) {
            const expectedValues = (0, _utilJs.util).objectValues(nativeEnumValues);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                expected: (0, _utilJs.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (!this._cache) this._cache = new Set((0, _utilJs.util).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, _utilJs.util).objectValues(nativeEnumValues);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params)=>{
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params)
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).promise && ctx.common.async === false) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).promise,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const promisified = ctx.parsedType === (0, _utilJs.ZodParsedType).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, _parseUtilJs.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
ZodPromise.create = (schema, params)=>{
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params)
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, _parseUtilJs.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, _parseUtilJs.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (result.status === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                if (status.value === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, _parseUtilJs.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (result.status === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                if (status.value === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, _parseUtilJs.isValid)(base)) return 0, _parseUtilJs.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, _parseUtilJs.isValid)(base)) return 0, _parseUtilJs.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, _utilJs.util).assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params)=>{
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params)
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new ZodEffects({
        schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params)
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, _utilJs.ZodParsedType).undefined) return (0, _parseUtilJs.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params)=>{
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params)
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, _utilJs.ZodParsedType).null) return (0, _parseUtilJs.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params)=>{
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params)
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, _utilJs.ZodParsedType).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params)=>{
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...processCreateParams(params)
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, _parseUtilJs.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, _zodErrorJs.ZodError)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, _zodErrorJs.ZodError)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params)=>{
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...processCreateParams(params)
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).nan,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
ZodNaN.create = (params)=>{
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params)
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, _parseUtilJs.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, _parseUtilJs.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, _parseUtilJs.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, _parseUtilJs.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodReadonly.create = (type, params)=>{
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function custom(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return ZodAny.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return ZodAny.create();
}
const late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
// requires TS 4.4+
class Class {
    constructor(..._){}
}
const instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>custom((data)=>data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = ()=>stringType().optional();
const onumber = ()=>numberType().optional();
const oboolean = ()=>booleanType().optional();
const coerce = {
    string: (arg)=>ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>ZodDate.create({
            ...arg,
            coerce: true
        })
};
const NEVER = (0, _parseUtilJs.INVALID);

},{"./ZodError.js":"hEQBO","./errors.js":"9p8OR","./helpers/errorUtil.js":"8amCS","./helpers/parseUtil.js":"88KNc","./helpers/util.js":"lc98B","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8amCS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorUtil", ()=>errorUtil);
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message
        } : message || {};
    // biome-ignore lint/suspicious/noShadowRestrictedNames: renaming churns 31 v3 call sites
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})(errorUtil || (errorUtil = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"53GLT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Controller", ()=>Controller);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "FormProvider", ()=>FormProvider);
parcelHelpers.export(exports, "FormStateSubscribe", ()=>FormStateSubscribe);
parcelHelpers.export(exports, "Watch", ()=>Watch);
parcelHelpers.export(exports, "appendErrors", ()=>appendErrors);
parcelHelpers.export(exports, "createFormControl", ()=>createFormControl);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "useController", ()=>useController);
parcelHelpers.export(exports, "useFieldArray", ()=>useFieldArray);
parcelHelpers.export(exports, "useForm", ()=>useForm);
parcelHelpers.export(exports, "useFormContext", ()=>useFormContext);
parcelHelpers.export(exports, "useFormState", ()=>useFormState);
parcelHelpers.export(exports, "useWatch", ()=>useWatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var isCheckBoxInput = (element)=>element.type === 'checkbox';
var isDateObject = (value1)=>value1 instanceof Date;
var isNullOrUndefined = (value1)=>value1 == null;
const isObjectType = (value1)=>typeof value1 === 'object';
var isObject = (value1)=>!isNullOrUndefined(value1) && !Array.isArray(value1) && isObjectType(value1) && !isDateObject(value1);
var getEventValue = (event)=>isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getFieldArrayParentNames = (names, name)=>{
    const parts = name.split('.');
    const matches = [];
    let prefix = parts[0];
    for(let i = 1; i < parts.length; prefix += '.' + parts[i++])!isNaN(+parts[i]) && names.has(prefix) && matches.push(prefix);
    return matches;
};
var isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function cloneObject(data) {
    if (data instanceof Date) return new Date(data);
    const isFileListInstance = typeof FileList !== 'undefined' && data instanceof FileList;
    if (isWeb && (data instanceof Blob || isFileListInstance)) return data;
    const isArray = Array.isArray(data);
    if (!isArray && !(isObject(data) && isPlainObject(data))) return data;
    const copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) copy[key] = cloneObject(data[key]);
    return copy;
}
var isKey = (value1)=>/^\w*$/.test(value1);
var isUndefined = (val)=>val === undefined;
var compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var stringToPath = (input)=>compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var get = (object, path, defaultValue)=>{
    if (!path || !isObject(object)) return defaultValue;
    const paths = isKey(path) ? [
        path
    ] : stringToPath(path);
    const result = paths.reduce((result, key)=>{
        return isNullOrUndefined(result) ? undefined : result[key];
    }, object);
    return isUndefined(result) || result === object ? isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var isBoolean = (value1)=>typeof value1 === 'boolean';
var isFunction = (value1)=>typeof value1 === 'function';
var set = (object, path, value1)=>{
    let index = -1;
    const tempPath = isKey(path) ? [
        path
    ] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
    SUBMIT: 'submit',
    TRIGGER: 'trigger',
    VALID: 'valid'
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const FORM_ERROR_TYPE = 'form';
const ROOT_ERROR_TYPE = 'root';
/**
 * Separate context for `control` to prevent unnecessary rerenders.
 * Internal hooks that only need control use this instead of full form context.
 */ const HookFormControlContext = (0, _reactDefault.default).createContext(null);
HookFormControlContext.displayName = 'HookFormControlContext';
/**
 * @internal Internal hook to access only control from context.
 */ const useFormControlContext = ()=>(0, _reactDefault.default).useContext(HookFormControlContext);
var getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {};
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, _reactDefault.default).useLayoutEffect : (0, _reactDefault.default).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function useFormState(props) {
    const formControl = useFormControlContext();
    const { control = formControl, disabled, name, exact } = props || {};
    const [formState, updateFormState] = (0, _reactDefault.default).useState(()=>({
            ...control._formState,
            defaultValues: control._defaultValues
        }));
    const _localProxyFormState = (0, _reactDefault.default).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    useIsomorphicLayoutEffect(()=>control._subscribe({
            name,
            formState: _localProxyFormState.current,
            exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState,
                    defaultValues: control._defaultValues
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, _reactDefault.default).useMemo(()=>getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var isString = (value1)=>typeof value1 === 'string';
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var isPrimitive = (value1)=>isNullOrUndefined(value1) || !isObjectType(value1);
function deepEqual(object1, object2, visited = new WeakSet()) {
    if (object1 === object2) return true;
    if (isPrimitive(object1) || isPrimitive(object2)) return Object.is(object1, object2);
    if (isDateObject(object1) && isDateObject(object2)) return Object.is(object1.getTime(), object2.getTime());
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (visited.has(object1) || visited.has(object2)) return true;
    visited.add(object1);
    visited.add(object2);
    for (const key of keys1){
        const val1 = object1[key];
        if (!(key in object2)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if (isDateObject(val1) && isDateObject(val2) || (isObject(val1) || Array.isArray(val1)) && (isObject(val2) || Array.isArray(val2)) ? !deepEqual(val1, val2, visited) : !Object.is(val1, val2)) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function useWatch(props) {
    const formControl = useFormControlContext();
    const { control = formControl, name, defaultValue, disabled, exact, compute } = props || {};
    const _defaultValue = (0, _reactDefault.default).useRef(defaultValue);
    const _compute = (0, _reactDefault.default).useRef(compute);
    const _computeFormValues = (0, _reactDefault.default).useRef(undefined);
    const _prevControl = (0, _reactDefault.default).useRef(control);
    const _prevName = (0, _reactDefault.default).useRef(name);
    _compute.current = compute;
    const [value1, updateValue] = (0, _reactDefault.default).useState(()=>{
        const defaultValue = control._getWatch(name, _defaultValue.current);
        return _compute.current ? _compute.current(defaultValue) : defaultValue;
    });
    const getCurrentOutput = (0, _reactDefault.default).useCallback((values)=>{
        const formValues = generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
        return _compute.current ? _compute.current(formValues) : formValues;
    }, [
        control._formValues,
        control._names,
        name
    ]);
    const refreshValue = (0, _reactDefault.default).useCallback((values)=>{
        if (!disabled) {
            const formValues = generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
            if (_compute.current) {
                const computedFormValues = _compute.current(formValues);
                if (!deepEqual(computedFormValues, _computeFormValues.current)) {
                    updateValue(computedFormValues);
                    _computeFormValues.current = computedFormValues;
                }
            } else updateValue(formValues);
        }
    }, [
        control._formValues,
        control._names,
        disabled,
        name
    ]);
    useIsomorphicLayoutEffect(()=>{
        if (_prevControl.current !== control || !deepEqual(_prevName.current, name)) {
            _prevControl.current = control;
            _prevName.current = name;
            refreshValue();
        }
        return control._subscribe({
            name,
            formState: {
                values: true
            },
            exact,
            callback: (formState)=>{
                refreshValue(formState.values);
            }
        });
    }, [
        control,
        exact,
        name,
        refreshValue
    ]);
    (0, _reactDefault.default).useEffect(()=>control._removeUnmounted());
    // If name or control changed for this render, synchronously reflect the
    // latest value so callers (like useController) see the correct value
    // immediately on the same render.
    // Optimize: Check control reference first before expensive deepEqual
    const controlChanged = _prevControl.current !== control;
    const prevName = _prevName.current;
    // Cache the computed output to avoid duplicate calls within the same render
    // We include shouldReturnImmediate in deps to ensure proper recomputation
    const computedOutput = (0, _reactDefault.default).useMemo(()=>{
        if (disabled) return null;
        const nameChanged = !controlChanged && !deepEqual(prevName, name);
        const shouldReturnImmediate = controlChanged || nameChanged;
        return shouldReturnImmediate ? getCurrentOutput() : null;
    }, [
        disabled,
        controlChanged,
        name,
        prevName,
        getCurrentOutput
    ]);
    return computedOutput !== null ? computedOutput : value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function useController(props) {
    const formControl = useFormControlContext();
    const { name, disabled, control = formControl, shouldUnregister, defaultValue, exact = true } = props;
    const isArrayField = !!getFieldArrayParentNames(control._names.array, name).length;
    const defaultValueMemo = (0, _reactDefault.default).useMemo(()=>get(control._formValues, name, get(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = useWatch({
        control,
        name,
        defaultValue: defaultValueMemo,
        exact
    });
    const formState = useFormState({
        control,
        name,
        exact
    });
    const _props = (0, _reactDefault.default).useRef(props);
    const _registerProps = (0, _reactDefault.default).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    _props.current = props;
    const fieldState = (0, _reactDefault.default).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!get(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!get(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!get(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!get(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>get(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, _reactDefault.default).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: getEventValue(event),
                name: name
            },
            type: EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, _reactDefault.default).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: get(control._formValues, name),
                name: name
            },
            type: EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, _reactDefault.default).useCallback((elm)=>{
        const field = get(control._fields, name);
        if (field && field._f && elm) field._f.ref = {
            focus: ()=>isFunction(elm.focus) && elm.focus(),
            select: ()=>isFunction(elm.select) && elm.select(),
            setCustomValidity: (message)=>isFunction(elm.setCustomValidity) && elm.setCustomValidity(message),
            reportValidity: ()=>isFunction(elm.reportValidity) && elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, _reactDefault.default).useMemo(()=>({
            name,
            value: value1,
            ...isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange,
            onBlur,
            ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        control.register(name, {
            ..._props.current.rules,
            ...isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = get(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = cloneObject(get(control._defaultValues, name, get(control._options.defaultValues, name, _props.current.defaultValue)));
            set(control._defaultValues, name, value1);
            if (isUndefined(get(control._formValues, name))) set(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        control._setDisabledField({
            disabled,
            name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, _reactDefault.default).useMemo(()=>({
            field,
            formState,
            fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const Controller = (props)=>props.render(useController(props));
const flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if (isObjectType(obj[key]) && obj[key] !== null) {
        const nested = flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const HookFormContext = (0, _reactDefault.default).createContext(null);
HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const useFormContext = ()=>(0, _reactDefault.default).useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://react.dev/reference/react/useContext) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const FormProvider = (props)=>{
    const { children, watch, getValues, getFieldState, setError, clearErrors, setValue, setValues, trigger, formState, resetField, reset, handleSubmit, unregister, control, register, setFocus, subscribe } = props;
    const memoizedValue = (0, _reactDefault.default).useMemo(()=>({
            watch,
            getValues,
            getFieldState,
            setError,
            clearErrors,
            setValue,
            setValues,
            trigger,
            formState,
            resetField,
            reset,
            handleSubmit,
            unregister,
            control,
            register,
            setFocus,
            subscribe
        }), [
        clearErrors,
        control,
        formState,
        getFieldState,
        getValues,
        handleSubmit,
        register,
        reset,
        resetField,
        setError,
        setFocus,
        setValue,
        setValues,
        subscribe,
        trigger,
        unregister,
        watch
    ]);
    return (0, _reactDefault.default).createElement(HookFormContext.Provider, {
        value: memoizedValue
    }, (0, _reactDefault.default).createElement(HookFormControlContext.Provider, {
        value: memoizedValue.control
    }, children));
};
const POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function Form(props) {
    const methods = useFormContext();
    const [mounted, setMounted] = (0, _reactDefault.default).useState(false);
    const { control = methods.control, onSubmit, children, action, method = POST_REQUEST, headers, encType, onError, render, onSuccess, validateStatus, ...rest } = props;
    const submit = (0, _reactDefault.default).useCallback(async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = flatten(data);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data,
                event,
                method,
                formData,
                formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method,
                    headers: {
                        ...headers,
                        ...encType && encType !== 'multipart/form-data' ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error
                });
            }
        })(event);
        if (hasError && control) {
            control._subjects.state.next({
                isSubmitSuccessful: false
            });
            control.setError('root.server', {
                type
            });
        }
    }, [
        control,
        onSubmit,
        method,
        action,
        headers,
        encType,
        validateStatus,
        onError,
        onSuccess
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, render({
        submit
    })) : (0, _reactDefault.default).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
const FormStateSubscribe = ({ control, disabled, exact, name, render })=>render(useFormState({
        control,
        name,
        disabled,
        exact
    }));
var appendErrors = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe
    };
};
function extractFormValues(fieldsState, formValues) {
    const values = {};
    for(const key in fieldsState)if (fieldsState.hasOwnProperty(key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && isObject(fieldState) && fieldValue) {
            const nestedFieldsState = extractFormValues(fieldState, fieldValue);
            if (isObject(nestedFieldsState)) values[key] = nestedFieldsState;
        } else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
var isEmptyObject = (value1)=>isObject(value1) && !Object.keys(value1).length;
var isFileInput = (element)=>element.type === 'file';
var isHTMLElement = (value1)=>{
    if (!isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMultipleSelect = (element)=>element.type === `select-multiple`;
var isRadioInput = (element)=>element.type === 'radio';
var isRadioOrCheckbox = (ref)=>isRadioInput(ref) || isCheckBoxInput(ref);
var live = (ref)=>isHTMLElement(ref) && ref.isConnected;
function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length){
        if (isNullOrUndefined(object)) {
            object = undefined;
            break;
        }
        object = object[updatePath[index]];
        index++;
    }
    return object;
}
function isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) return false;
    }
    return true;
}
function unset(object, path) {
    if (isString(path) && Object.prototype.hasOwnProperty.call(object, path)) {
        delete object[path];
        return object;
    }
    const paths = Array.isArray(path) ? path : isKey(path) ? [
        path
    ] : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) unset(object, paths.slice(0, -1));
    return object;
}
var objectHasFunction = (data)=>{
    for(const key in data){
        if (isFunction(data[key])) return true;
    }
    return false;
};
function isTraversable(value1) {
    return Array.isArray(value1) || isObject(value1) && !objectHasFunction(value1);
}
function markFieldsDirty(data, fields = {}) {
    for(const key in data){
        const value1 = data[key];
        if (isTraversable(value1)) {
            fields[key] = Array.isArray(value1) ? [] : {};
            markFieldsDirty(value1, fields[key]);
        } else if (!isUndefined(value1)) fields[key] = true;
    }
    return fields;
}
function pruneDirtyFields(value1) {
    if (value1 === false) return undefined;
    if (value1 === true) return true;
    if (Array.isArray(value1)) {
        const result = value1.map((value1)=>pruneDirtyFields(value1));
        return result.some((value1)=>value1 !== undefined) ? result : undefined;
    }
    if (isObject(value1)) {
        const result = {};
        for(const key in value1){
            const pruned = pruneDirtyFields(value1[key]);
            if (!isUndefined(pruned)) result[key] = pruned;
        }
        return Object.keys(result).length ? result : undefined;
    }
    return undefined;
}
function getDirtyFields(data, formValues, dirtyFieldsFromValues) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = markFieldsDirty(formValues);
    for(const key in data){
        const value1 = data[key];
        if (isTraversable(value1)) {
            if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = markFieldsDirty(value1, Array.isArray(value1) ? [] : {});
            else getDirtyFields(value1, isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else {
            const formValue = formValues[key];
            dirtyFieldsFromValues[key] = !deepEqual(value1, formValue);
        }
    }
    return pruneDirtyFields(dirtyFieldsFromValues) || {};
}
const defaultResult = {
    value: false,
    isValid: false
};
const validResult = {
    value: true,
    isValid: true
};
var getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === '' ? validResult : {
            value: options[0].value,
            isValid: true
        } : validResult : defaultResult;
    }
    return defaultResult;
};
var getFieldValueAs = (value1, { valueAsNumber, valueAsDate, setValueAs })=>isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const defaultReturn = {
    isValid: false,
    value: null
};
var getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, defaultReturn) : defaultReturn;
function getFieldValue(_f) {
    const ref = _f.ref;
    if (isFileInput(ref)) return ref.files;
    if (isRadioInput(ref)) return getRadioValue(_f.refs).value;
    if (isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if (isCheckBoxInput(ref)) return getCheckboxValue(_f.refs).value;
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields,
        shouldUseNativeValidation
    };
};
var isRegex = (value1)=>value1 instanceof RegExp;
var getRuleValue = (rule)=>isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
var getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
        isOnBlur: mode === VALIDATION_MODE.onBlur,
        isOnChange: mode === VALIDATION_MODE.onChange,
        isOnAll: mode === VALIDATION_MODE.all,
        isOnTouch: mode === VALIDATION_MODE.onTouched
    });
const ASYNC_FUNCTION = 'AsyncFunction';
var hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!(isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === ASYNC_FUNCTION || isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === ASYNC_FUNCTION));
var hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if (iterateFieldsByAction(currentField, action)) break;
                }
            } else if (isObject(currentField)) {
                if (iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) return {
        error,
        name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name
    };
}
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return isEmptyObject(formState) || isRoot && Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
};
var shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var unsetEmptyArray = (ref, name)=>!compact(get(ref, name)).length && unset(ref, name);
var updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = convertToArrayPayload(get(errors, name));
    set(fieldArrayErrors, ROOT_ERROR_TYPE, error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};
function getValidateError(result, ref, type = 'validate') {
    if (isString(result) || Array.isArray(result) && result.every(isString) || isBoolean(result) && !result) return {
        type,
        message: isString(result) ? result : '',
        ref
    };
}
var getValueAndMessage = (validationData)=>isObject(validationData) && !isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length || valueAsNumber && typeof inputValue === 'number' && isNaN(inputValue);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
        const { value: value1, message } = isString(required) ? {
            value: !!required,
            message: required
        } : getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if (isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if (isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true
};
const DEFAULT_FORM_STATE = {
    submitCount: 0,
    isDirty: false,
    isReady: false,
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {}
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props
    };
    let _formState = {
        ...cloneObject(DEFAULT_FORM_STATE),
        isLoading: isFunction(_options.defaultValues),
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
        keepIsValid: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
        registerName: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const defaultProxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _proxyFormState = {
        ...defaultProxyFormState
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: createSubject(),
        state: createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (_state.keepIsValid) return;
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            let isValid;
            if (_options.resolver) {
                isValid = isEmptyObject((await _runSchema()).errors);
                _updateIsValidating();
            } else isValid = await executeBuiltInValidation({
                fields: _fields,
                onlyCheckValid: true,
                eventType: EVENTS.VALID
            });
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? set(_formState.validatingFields, name, isValidating) : unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateDirtyFields = ()=>{
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _updateDirtyFields();
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else set(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const hasExplicitNullIntermediate = (name)=>{
        const segments = isKey(name) ? [
            name
        ] : stringToPath(name);
        let formValues = _formValues;
        let defaultValues = _defaultValues;
        for(let i = 0; i < segments.length - 1; i++){
            const key = segments[i];
            formValues = isNullOrUndefined(formValues) ? formValues : formValues[key];
            defaultValues = isNullOrUndefined(defaultValues) ? defaultValues : defaultValues[key];
            if (formValues === null && defaultValues !== null) return true;
        }
        return false;
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = get(_fields, name);
        if (field) {
            if (hasExplicitNullIntermediate(name)) return;
            const wasUnsetInFormValues = isUndefined(get(_formValues, name));
            const defaultValue = get(_formValues, name, isUndefined(value1) ? get(_defaultValues, name) : value1);
            isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            if (_state.mount && !_state.action) {
                _setValid();
                // Re-registering a field after a prior unregister puts its key back
                // into _formValues, which can flip isDirty back to false (#13397).
                // Only run when we are currently dirty, otherwise an initial register
                // for a field with no defaultValue would flip isDirty to true. Reset
                // paths repopulate _formValues before re-register, so the key is
                // present then and this branch is skipped (preserves keepDirty).
                if (wasUnsetInFormValues && _formState.isDirty && (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty)) {
                    const isDirty = _getDirty();
                    if (!isDirty) {
                        _formState.isDirty = false;
                        _subjects.state.next({
                            ..._formState
                        });
                    }
                }
            }
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
                isPreviousDirty = !!get(_formState.dirtyFields, name);
                if (isCurrentFieldPristine !== _formState.isDirty) _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
                else isCurrentFieldPristine ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = get(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    set(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && isBoolean(isValid) ? {
                    isValid
                } : {},
                errors: _formState.errors,
                name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        return await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors } = await _runSchema(names);
        _updateIsValidating(names);
        if (names) for (const name of names){
            const error = get(errors, name);
            error ? _names.array.has(name) && isObject(error) ? updateFieldArrayRootError(_formState.errors, {
                [name]: error
            }, name) : set(_formState.errors, name, error) : unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const validateForm = async ({ name, eventType })=>{
        if (props.validate) {
            const result = await props.validate({
                formValues: _formValues,
                formState: _formState,
                name,
                eventType
            });
            if (isObject(result)) for(const key in result){
                const error = result[key];
                if (error) setError(`${FORM_ERROR_TYPE}.${key}`, {
                    message: isString(error.message) ? error.message : '',
                    type: error.type || INPUT_VALIDATION_RULES.validate
                });
            }
            else if (isString(result) || !result) setError(FORM_ERROR_TYPE, {
                message: result || '',
                type: INPUT_VALIDATION_RULES.validate
            });
            else clearErrors(FORM_ERROR_TYPE);
            return result;
        }
        return true;
    };
    const executeBuiltInValidation = async ({ fields, onlyCheckValid, name, eventType, context = {
        valid: true,
        runRootValidation: false
    } })=>{
        if (props.validate) {
            context.runRootValidation = true;
            const result = await validateForm({
                name,
                eventType
            });
            if (!result) {
                context.valid = false;
                if (onlyCheckValid) return context.valid;
            }
        }
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && hasPromiseValidation(field._f);
                    const shouldTrackIsValidatingState = _proxyFormState.validatingFields || _proxyFormState.isValidating || _proxySubscribeFormState.validatingFields || _proxySubscribeFormState.isValidating;
                    if (isPromiseFunction && shouldTrackIsValidatingState) _updateIsValidating([
                        _f.name
                    ], true);
                    const fieldError = await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !onlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && shouldTrackIsValidatingState) _updateIsValidating([
                        _f.name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (onlyCheckValid) break;
                    }
                    !onlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
                    if (props.shouldUseNativeValidation && fieldError[_f.name]) break;
                }
                !isEmptyObject(fieldValue) && await executeBuiltInValidation({
                    context,
                    onlyCheckValid,
                    fields: fieldValue,
                    name: name,
                    eventType
                });
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = get(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!live(ref)) : !live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>compact(get(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = get(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value1, fieldReference));
                fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value1) ? '' : value1;
                if (isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if (isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name,
                        values: cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setFieldValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = get(_fields, fieldName);
            (_names.array.has(name) || isObject(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setFieldValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value1);
        const previousValue = get(_formValues, name);
        const isValueUnchanged = deepEqual(previousValue, cloneValue);
        if (!isValueUnchanged) set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) {
                _updateDirtyFields();
                _subjects.state.next({
                    name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue)
                });
            }
        } else {
            const isEmpty = Array.isArray(cloneValue) && !cloneValue.length || isEmptyObject(cloneValue);
            if (!field || field._f || isNullOrUndefined(cloneValue) || isEmpty) setFieldValue(name, cloneValue, options);
            else setFieldValues(name, cloneValue, options);
        }
        if (!isValueUnchanged) {
            const watched = isWatched(name, _names);
            const values = cloneObject(_formValues);
            if (!isFieldArray) for (const arrayName of getFieldArrayParentNames(_names.array, name))_subjects.array.next({
                name: arrayName,
                values
            });
            _subjects.state.next({
                ...watched && _formState,
                name: _state.mount || watched ? name : undefined,
                values
            });
        }
    };
    const setValues = (formValues)=>{
        const updatedFormValues = isFunction(formValues) ? formValues(_formValues) : formValues;
        if (!deepEqual(_formValues, updatedFormValues)) {
            _formValues = {
                ..._formValues,
                ...updatedFormValues
            };
            for (const fieldName of _names.mount)setValue(fieldName, get(updatedFormValues, fieldName));
            _subjects.state.next({
                ..._formState,
                values: _formValues
            });
        }
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || deepEqual(fieldValue, get(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = getValidationModes(_options.mode);
        const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? getFieldValue(field._f) : getEventValue(event);
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !hasValidation(field._f) && !props.validate && !_options.resolver && !get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    delayErrorCallback && delayErrorCallback(0);
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name,
                type: event.type,
                values: cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name,
                    ...watched ? {} : fieldState
                });
            }
            if (!_options.resolver && props.validate) await validateForm({
                name: name,
                eventType: event.type
            });
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors } = await _runSchema([
                    name
                ]);
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation({
                        fields: _fields,
                        onlyCheckValid: true,
                        name: name,
                        eventType: event.type
                    });
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>get(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation({
                    fields: field && field._f ? {
                        [fieldName]: field
                    } : field,
                    eventType: EVENTS.TRIGGER
                });
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation({
            fields: _fields,
            name,
            eventType: EVENTS.TRIGGER
        });
        _subjects.state.next({
            ...!isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name
            },
            ..._options.resolver || !name ? {
                isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        if (config) values = extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return isUndefined(fieldNames) ? values : isString(fieldNames) ? get(values, fieldNames) : fieldNames.map((name)=>get(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!get((formState || _formState).errors, name),
            isDirty: !!get((formState || _formState).dirtyFields, name),
            error: get((formState || _formState).errors, name),
            isValidating: !!get(_formState.validatingFields, name),
            isTouched: !!get((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        const names = name ? convertToArrayPayload(name) : undefined;
        names === null || names === void 0 || names.forEach((inputName)=>unset(_formState.errors, inputName));
        if (names) // Emit for each cleared field with the field name so that
        // shouldSubscribeByName can filter and avoid broad re-renders
        names.forEach((inputName)=>{
            _subjects.state.next({
                name: inputName,
                errors: _formState.errors
            });
        });
        else // Clear all errors - emit without name to notify all subscribers
        _subjects.state.next({
            errors: {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = (get(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = get(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message, type, ...restOfErrorTree } = currentError;
        set(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>'values' in payload && name(payload.values || _getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if (shouldSubscribeByName(props.name, formState.name, props.exact) && shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) {
                    const snapshot = {
                        ..._formValues
                    };
                    props.callback({
                        values: snapshot,
                        ..._formState,
                        ...formState,
                        defaultValues: _defaultValues
                    });
                }
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: {
                ...defaultProxyFormState,
                ...props.formState
            }
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled, name })=>{
        if (isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) {
            const wasDisabled = _names.disabled.has(name);
            const isDisabled = !!disabled;
            const disabledStateChanged = wasDisabled !== isDisabled;
            disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
            disabledStateChanged && _state.mount && !_state.action && _setValid();
        }
    };
    const register = (name, options = {})=>{
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled) || isBoolean(_options.disabled);
        const shouldRevalidateRemount = !_names.registerName.has(name) && field && field._f && !field._f.mount;
        set(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name
                    }
                },
                name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field && !shouldRevalidateRemount) _setDisabledField({
            disabled: isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: getRuleValue(options.min),
                max: getRuleValue(options.max),
                minLength: getRuleValue(options.minLength),
                maxLength: getRuleValue(options.maxLength),
                pattern: getRuleValue(options.pattern)
            } : {},
            name,
            onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    _names.registerName.add(name);
                    register(name, options);
                    _names.registerName.delete(name);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter(live),
                                    fieldRef,
                                    ...Array.isArray(get(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = get(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !(getFieldArrayParentNames(_names.array, name).length && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && !_options.shouldUseNativeValidation && iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if (isBoolean(disabled)) {
            _subjects.state.next({
                disabled
            });
            iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = get(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors, values } = await _runSchema();
                _updateIsValidating();
                _formState.errors = errors;
                fieldValues = cloneObject(values);
            } else await executeBuiltInValidation({
                fields: _fields,
                eventType: EVENTS.SUBMIT
            });
            if (_names.disabled.size) for (const name of _names.disabled)unset(fieldValues, name);
            unset(_formState.errors, ROOT_ERROR_TYPE);
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) setValue(name, cloneObject(get(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, cloneObject(get(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const isEmptyResetValues = isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys(getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck)){
                    const isDirty = get(_formState.dirtyFields, fieldName);
                    const existingValue = get(_formValues, fieldName);
                    const newValue = get(values, fieldName);
                    if (isDirty && !isUndefined(existingValue)) set(values, fieldName, existingValue);
                    else if (!isDirty && !isUndefined(newValue)) setValue(fieldName, newValue);
                }
            } else {
                if (isWeb && isUndefined(formValues)) for (const name of _names.mount){
                    const field = get(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if (isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, get(values, fieldName));
                else _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            registerName: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues || !_options.shouldUnregister && !isEmptyObject(values);
        _state.watch = !!_options.shouldUnregister;
        _state.keepIsValid = !!keepStateOptions.keepIsValid;
        _state.action = false;
        // Clear errors synchronously to prevent validation errors on subsequent submissions
        // This fixes the issue where form.reset() causes validation errors on subsequent
        // submissions in Next.js 16 with Server Actions
        if (!keepStateOptions.keepErrors) _formState.errors = {};
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset(isFunction(formValues) ? formValues(_formValues) : formValues, {
            ..._options.resetOptions,
            ...keepStateOptions
        });
    const setFocus = (name, options = {})=>{
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) // Use setTimeout to ensure focus happens after any pending state updates
            // This fixes the issue where setFocus doesn't work immediately after setError
            setTimeout(()=>{
                fieldRef.focus();
                options.shouldSelect && isFunction(fieldRef.select) && fieldRef.select();
            });
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _subscribe,
            _runSchema,
            _updateIsValidating,
            _focusError,
            _getWatch,
            _getDirty,
            _setValid,
            _setFieldArray,
            _setDisabledField,
            _setErrors,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _removeUnmounted,
            _disableForm,
            _subjects,
            _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        subscribe,
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        setValues,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var generateId = ()=>{
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var getFocusFieldName = (name, index, options = {})=>options.shouldFocus || isUndefined(options.shouldFocus) ? options.focusName || `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var appendAt = (data, value1)=>[
        ...data,
        ...convertToArrayPayload(value1)
    ];
var fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if (isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var prependAt = (data, value1)=>[
        ...convertToArrayPayload(value1),
        ...convertToArrayPayload(data)
    ];
function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index)=>isUndefined(index) ? [] : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b)=>a - b));
var swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function useFieldArray(props) {
    const formControl = useFormControlContext();
    const { control = formControl, name, keyName = 'id', shouldUnregister, rules } = props;
    const [fields, setFields] = (0, _reactDefault.default).useState(control._getFieldArray(name));
    const ids = (0, _reactDefault.default).useRef(control._getFieldArray(name).map(generateId));
    const _actioned = (0, _reactDefault.default).useRef(false);
    control._names.array.add(name);
    (0, _reactDefault.default).useMemo(()=>rules && fields.length >= 0 && control.register(name, rules), [
        control,
        name,
        fields.length,
        rules
    ]);
    useIsomorphicLayoutEffect(()=>control._subjects.array.subscribe({
            next: ({ values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = get(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map(generateId);
                    }
                }
            }
        }).unsubscribe, [
        control,
        name
    ]);
    const updateValues = (0, _reactDefault.default).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = appendAt(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, appendAt, {
            argA: fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prependAt(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, prependAt, {
            argA: fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray(get(control._fields, name)) && set(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = cloneObject(value1);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value1));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, _reactDefault.default).useEffect(()=>{
        control._state.action = false;
        isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        const validationModes = getValidationModes(control._options.mode);
        if (_actioned.current && (!validationModes.isOnSubmit || control._formState.isSubmitted) && !getValidationModes(control._options.reValidateMode).isOnSubmit && !validationModes.isOnBlur) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                control._updateIsValidating([
                    name
                ]);
                const error = get(result.errors, name);
                const existingError = get(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? set(control._formState.errors, name, error) : unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = get(control._fields, name);
                if (field && field._f && !(getValidationModes(control._options.reValidateMode).isOnSubmit && getValidationModes(control._options.mode).isOnSubmit)) validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!isEmptyObject(error) && control._subjects.state.next({
                        errors: updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name,
            values: cloneObject(control._formValues)
        });
        control._names.focus && iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        !get(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const shouldKeepFieldArrayValues = !(control._options.shouldUnregister || shouldUnregister);
            const updateMounted = (name, value1)=>{
                const field = get(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            if (_actioned.current && shouldKeepFieldArrayValues) control._subjects.state.next({
                name,
                values: cloneObject(control._formValues)
            });
            shouldKeepFieldArrayValues ? updateMounted(name, false) : control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, _reactDefault.default).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, _reactDefault.default).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, _reactDefault.default).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, _reactDefault.default).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, _reactDefault.default).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, _reactDefault.default).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, _reactDefault.default).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, _reactDefault.default).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, _reactDefault.default).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function useForm(props = {}) {
    const _formControl = (0, _reactDefault.default).useRef(undefined);
    const _values = (0, _reactDefault.default).useRef(undefined);
    const [formState, updateFormState] = (0, _reactDefault.default).useState(()=>({
            ...cloneObject(DEFAULT_FORM_STATE),
            isLoading: isFunction(props.defaultValues),
            errors: props.errors || {},
            disabled: props.disabled || false,
            defaultValues: isFunction(props.defaultValues) ? undefined : props.defaultValues
        }));
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState
            };
            if (props.defaultValues && !isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const { formControl, ...rest } = createFormControl(props);
            _formControl.current = {
                ...rest,
                formState
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState,
                    defaultValues: control._defaultValues
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        var _a;
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions
            });
            if (!((_a = control._options.resetOptions) === null || _a === void 0 ? void 0 : _a.keepIsValid)) control._setValid();
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = (0, _reactDefault.default).useMemo(()=>getProxyFormState(formState, control), [
        control,
        formState
    ]);
    return _formControl.current;
}
/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param name - Can be field name, array of field names, or undefined to watch the entire form
 * @param disabled - Disable subscription
 * @param exact - Whether to watch exact field names or not
 * @param defaultValue - The default value to use if the field is not yet set
 * @param compute - Function to compute derived values from watched fields
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */ const Watch = (props)=>props.render(useWatch({
        name: props.names,
        ...props
    }));

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"c0M5u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zodResolver", ()=>s);
var _reactHookForm = require("react-hook-form");
var _resolvers = require("@hookform/resolvers");
var n = function(e, o) {
    for(var n = {}; e.length;){
        var s = e[0], t = s.code, i = s.message, a = s.path.join(".");
        if (!n[a]) {
            if ("unionErrors" in s) {
                var u = s.unionErrors[0].errors[0];
                n[a] = {
                    message: u.message,
                    type: u.code
                };
            } else n[a] = {
                message: i,
                type: t
            };
        }
        if ("unionErrors" in s && s.unionErrors.forEach(function(r) {
            return r.errors.forEach(function(r) {
                return e.push(r);
            });
        }), o) {
            var c = n[a].types, f = c && c[s.code];
            n[a] = (0, _reactHookForm.appendErrors)(a, o, n, t, f ? [].concat(f, s.message) : s.message);
        }
        e.shift();
    }
    return n;
}, s = function(r, s, t) {
    return void 0 === t && (t = {}), function(i, a, u) {
        try {
            return Promise.resolve(function(o, n) {
                try {
                    var a = Promise.resolve(r["sync" === t.mode ? "parse" : "parseAsync"](i, s)).then(function(r) {
                        return u.shouldUseNativeValidation && (0, _resolvers.validateFieldsNatively)({}, u), {
                            errors: {},
                            values: t.rawValues ? i : r
                        };
                    });
                } catch (r) {
                    return n(r);
                }
                return a && a.then ? a.then(void 0, n) : a;
            }(0, function(r) {
                return {
                    values: {},
                    errors: r.isEmpty ? {} : (0, _resolvers.toNestError)(n(r.errors, !u.shouldUseNativeValidation && "all" === u.criteriaMode), u)
                };
            }));
        } catch (r) {
            return Promise.reject(r);
        }
    };
};

},{"react-hook-form":"53GLT","@hookform/resolvers":"99FnM","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"99FnM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toNestError", ()=>f);
parcelHelpers.export(exports, "validateFieldsNatively", ()=>t);
var _reactHookForm = require("react-hook-form");
var e = function(i, e, t) {
    if (i && "reportValidity" in i) {
        var f = (0, _reactHookForm.get)(t, e);
        i.setCustomValidity(f && f.message || ""), i.reportValidity();
    }
}, t = function(r, i) {
    var t = function(t) {
        var f = i.fields[t];
        f && f.ref && "reportValidity" in f.ref ? e(f.ref, t, r) : f.refs && f.refs.forEach(function(i) {
            return e(i, t, r);
        });
    };
    for(var f in i.fields)t(f);
}, f = function(e, f) {
    f.shouldUseNativeValidation && t(e, f);
    var o = {};
    for(var a in e){
        var n = (0, _reactHookForm.get)(f.fields, a);
        (0, _reactHookForm.set)(o, a, Object.assign(e[a], {
            ref: n && n.ref
        }));
    }
    return o;
};

},{"react-hook-form":"53GLT","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4d8Tr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CardSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _savedCard = require("Core/components/SavedCard");
var _savedCardDefault = parcelHelpers.interopDefault(_savedCard);
var _newCard = require("Core/components/NewCard");
var _newCardDefault = parcelHelpers.interopDefault(_newCard);
var _alert = require("Core/components/Alert");
var _payment = require("Core/stores/payment");
var _paymentDefault = parcelHelpers.interopDefault(_payment);
var _reactStripeJs = require("@stripe/react-stripe-js");
var _layout = require("Core/components/Layout");
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _creditCardLogos = require("Core/components/CreditCardLogos");
var _button = require("Core/components/Button/Button");
var _utils = require("Core/utils/utils");
var _appConfig = require("Core/config/appConfig");
function CardSelector({ defaultValues = {}, cardCount = 1, index = 0, form, paymentMethods = [], onRemove, children, namePrefix = '', cardError, update }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const prefix = (0, _utils.getFormPrefix)(namePrefix, index);
    const selectedPaymentMethodId = form.watch(`${prefix}paymentMethodId`);
    const selectedPaymentMethod = (0, _utils.findByPropertyValue)(paymentMethods, 'paymentMethodId', selectedPaymentMethodId);
    const setCardToNewCard = (e)=>{
        if (form.getValues().cards) {
            const cardIndex = e.currentTarget.dataset.index;
            form.setValue(`cards[${cardIndex}]paymentMethodId`, '');
            const formVals = form.getValues();
            formVals.cards[cardIndex].paymentMethodId = '';
            update(cardIndex, formVals.cards[cardIndex]);
        } else form.setValue(`paymentMethodId`, '');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactStripeJs.Elements), {
        stripe: (0, _paymentDefault.default)((0, _payment.stripePromiseSelector)),
        options: {
            locale: (0, _appConfig.getAppConfig)().language
        },
        children: [
            cardError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                className: "mb-4",
                children: cardError
            }),
            (paymentMethods.length > 0 || cardCount !== 1) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col md:flex-row md:items-center gap-4 mb-4",
                children: [
                    paymentMethods.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormElement), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1.5",
                                    children: t('common.selectExistingCard')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                    defaultValue: defaultValues.paymentMethodId,
                                    ...form.register(`${prefix}paymentMethodId`),
                                    "data-testid": `card-select-${index}`,
                                    children: [
                                        paymentMethods.map(({ paymentMethodId, preferred, card }, i)=>{
                                            const { name } = (0, _creditCardLogos.getCard)(card.brand);
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                                                value: paymentMethodId,
                                                children: [
                                                    name,
                                                    " \u2022\u2022\u2022\u2022 ",
                                                    card.last4,
                                                    preferred ? ` (${t('common.preferred')})` : ''
                                                ]
                                            }, paymentMethodId + i);
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                            value: "",
                                            children: t('common.newCard')
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    cardCount !== 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "md:self-end md:pb-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.DestructiveButton), {
                            "data-testid": "card-remove-btn",
                            onClick: onRemove,
                            disabled: cardCount === 1,
                            children: t('common.removeCard')
                        })
                    })
                ]
            }),
            selectedPaymentMethodId && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                    className: "flex flex-wrap justify-between w-full items-end !mx-0",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "!flex-col-12 sm:!flex-col-12 !mb-2 px-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _savedCardDefault.default), {
                                index: index,
                                form: form,
                                paymentMethod: selectedPaymentMethod,
                                paymentMethodId: selectedPaymentMethodId,
                                namePrefix: namePrefix
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "!flex-col-12 sm:!flex-col-12 !mb-0 !px-0",
                            children: children
                        })
                    ]
                })
            }),
            paymentMethods.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "relative my-6",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "absolute inset-0 flex items-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-full border-t border-gray-200"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "relative flex justify-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "bg-white px-4 text-sm font-medium text-gray-500",
                            children: "OR"
                        })
                    })
                ]
            }),
            selectedPaymentMethodId ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                    onClick: setCardToNewCard,
                    "data-testid": "card-select-new",
                    "data-index": index,
                    className: "!px-6",
                    children: t('common.enterNewCardDetails')
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newCardDefault.default), {
                        defaultValues: defaultValues,
                        index: index,
                        form: form,
                        namePrefix: namePrefix
                    }),
                    children
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/components/SavedCard":"g5ycJ","Core/components/NewCard":"lw5qG","Core/components/Alert":"fmmNR","Core/stores/payment":"cVa46","@stripe/react-stripe-js":"jEv7X","Core/components/Layout":"hweet","Core/components/FormElements/formElements.styled":"45aFS","Core/components/CreditCardLogos":"dnezw","Core/components/Button/Button":"4Zmpz","Core/utils/utils":"hwOBZ","Core/config/appConfig":"7qX5H","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"g5ycJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _creditCardLogos = require("Core/components/CreditCardLogos");
const SavedCard = ({ paymentMethod })=>{
    const { img, name } = (0, _creditCardLogos.getCard)(paymentMethod.card.brand);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex-shrink-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: img,
                    className: "h-8 w-auto",
                    alt: name
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-xs text-gray-500 font-medium",
                        children: name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "text-base font-semibold text-gray-900",
                        children: [
                            "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ",
                            paymentMethod.card.last4
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = SavedCard;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/CreditCardLogos":"dnezw","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dnezw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCard", ()=>(0, _cards.getCard));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _cards = require("./cards");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const imgSizes = {
    small: `h-6`,
    medium: `h-8`,
    large: `h-10`
};
const CreditCardLogos = ({ brand = '', children, size, className })=>{
    const card = (0, _cards.getCard)(brand.toLowerCase());
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)('flex flex-wrap justify-center', className),
        children: [
            children,
            card ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: (0, _classnamesDefault.default)('mx-0.5', imgSizes[size]),
                src: card.img,
                alt: card.name
            }, card.name) : (0, _cards.CARDS).map((item)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: (0, _classnamesDefault.default)('mx-0.5', imgSizes[size]),
                    src: item.img,
                    alt: item.name
                }, item.name);
            })
        ]
    });
};
exports.default = CreditCardLogos;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","./cards":"dI1HH","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dI1HH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CARDS", ()=>CARDS);
parcelHelpers.export(exports, "getCard", ()=>getCard);
var _amexSvg = require("url:Images/credit-cards/amex.svg");
var _amexSvgDefault = parcelHelpers.interopDefault(_amexSvg);
var _dinersSvg = require("url:Images/credit-cards/diners.svg");
var _dinersSvgDefault = parcelHelpers.interopDefault(_dinersSvg);
var _discoverSvg = require("url:Images/credit-cards/discover.svg");
var _discoverSvgDefault = parcelHelpers.interopDefault(_discoverSvg);
var _jcbSvg = require("url:Images/credit-cards/jcb.svg");
var _jcbSvgDefault = parcelHelpers.interopDefault(_jcbSvg);
var _mastercardSvg = require("url:Images/credit-cards/mastercard.svg");
var _mastercardSvgDefault = parcelHelpers.interopDefault(_mastercardSvg);
var _visaSvg = require("url:Images/credit-cards/visa.svg");
var _visaSvgDefault = parcelHelpers.interopDefault(_visaSvg);
const CARDS = [
    {
        name: 'American Express',
        brand: 'amex',
        img: (0, _amexSvgDefault.default)
    },
    {
        name: 'Diners Club',
        brand: 'diners',
        img: (0, _dinersSvgDefault.default)
    },
    {
        name: 'Discover',
        brand: 'discover',
        img: (0, _discoverSvgDefault.default)
    },
    {
        name: 'JCB',
        brand: 'jcb',
        img: (0, _jcbSvgDefault.default)
    },
    {
        name: 'Mastercard',
        brand: 'mastercard',
        img: (0, _mastercardSvgDefault.default)
    },
    {
        name: 'Visa',
        brand: 'visa',
        img: (0, _visaSvgDefault.default)
    }
];
function getCard(brand) {
    return CARDS.find((card)=>card.brand === brand);
}

},{"url:Images/credit-cards/amex.svg":"dx0Ud","url:Images/credit-cards/diners.svg":"3wXjk","url:Images/credit-cards/discover.svg":"ayrSr","url:Images/credit-cards/jcb.svg":"gyeCs","url:Images/credit-cards/mastercard.svg":"dvPab","url:Images/credit-cards/visa.svg":"lMqhG","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dx0Ud":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1Xblb");

},{}],"3wXjk":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("ewRQr");

},{}],"ayrSr":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("gMuLB");

},{}],"gyeCs":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("f9TbO");

},{}],"dvPab":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("60G3e");

},{}],"lMqhG":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("6aFFz");

},{}],"lw5qG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactStripeJs = require("@stripe/react-stripe-js");
var _layout = require("Core/components/Layout");
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _error = require("Core/components/FormElements/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _questionMark = require("Core/components/QuestionMark");
var _questionMarkDefault = parcelHelpers.interopDefault(_questionMark);
var _alert = require("Core/components/Alert");
var _utils = require("Core/utils/utils");
// Modern Stripe element styling
const modernStripeConfig = {
    style: {
        base: {
            color: '#1f2937',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            fontSize: '16px',
            fontWeight: '400',
            '::placeholder': {
                color: '#9ca3af'
            },
            lineHeight: '24px'
        },
        invalid: {
            color: '#dc2626',
            iconColor: '#dc2626'
        }
    }
};
// Modern Stripe input wrapper
const StripeInputWrapper = ({ label, htmlFor, error, children, tooltip })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-1.5 w-full",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                htmlFor: htmlFor,
                className: "text-sm font-medium text-gray-700 flex items-center gap-1 whitespace-nowrap",
                children: [
                    label,
                    tooltip
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `
        h-11 px-3 py-2 rounded-lg border transition-all duration-200 bg-white
        ${error ? 'border-red-300 ring-2 ring-red-100' : 'border-gray-300 hover:border-gray-400 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20'}
      `,
                children: children
            })
        ]
    });
const NewCard = ({ index = 0, form, namePrefix = '', children = null, cardError = '', defaultValues = {}, shouldShowHeader = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const stripeElements = (0, _reactStripeJs.useElements)();
    const stripe = (0, _reactStripeJs.useStripe)();
    const { register, unregister, setError, setValue, clearErrors, formState: { errors } } = form;
    const prefix = (0, _utils.getFormPrefix)(namePrefix, index);
    const { firstName, lastName, postalCode } = defaultValues;
    const validationErrors = namePrefix ? errors?.[namePrefix]?.[index] : errors;
    const handleStripeElementChange = (event, name)=>{
        const { error: stripeError } = event;
        if (stripeError) {
            setError(name, {
                type: 'manual',
                message: t(`stripe.${stripeError.code}`)
            });
            return;
        }
        setValue(name, '1');
        clearErrors(name);
    };
    (0, _reactDefault.default).useEffect(()=>{
        if (stripe && stripeElements) {
            setValue(`${prefix}stripeElement`, stripeElements.getElement((0, _reactStripeJs.CardNumberElement)));
            setValue(`${prefix}stripe`, stripe);
        }
        return ()=>unregister([
                `${prefix}cardNumber`,
                `${prefix}cardExpiry`,
                `${prefix}cardCvc`
            ]);
    }, [
        setValue,
        unregister,
        prefix,
        stripe,
        stripeElements
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-5",
        children: [
            shouldShowHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                "data-testid": `card-information-headline-${index}`,
                className: "text-lg font-semibold text-gray-900",
                children: t('common.cardInformation')
            }),
            cardError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                className: "mb-4",
                children: cardError
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "text-md font-bold text-gray-600 mb-2",
                children: t('common.enterNewCardDetails')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-12 md:!flex-col-6",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                            "data-testid": "firstName",
                            defaultValue: firstName,
                            register: register,
                            label: t('common.cardHolderFirstName'),
                            name: `${prefix}firstName`,
                            error: validationErrors?.firstName?.message
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-12 md:!flex-col-6",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                            "data-testid": "lastName",
                            defaultValue: lastName,
                            register: register,
                            label: t('common.cardHolderLastName'),
                            name: `${prefix}lastName`,
                            error: validationErrors?.lastName?.message
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                        className: "!flex-col-12 md:!flex-col-5 lg:!flex-col-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StripeInputWrapper, {
                                label: t('common.cardNumber'),
                                htmlFor: `cardNumber${index}`,
                                error: validationErrors?.cardNumber?.message,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactStripeJs.CardNumberElement), {
                                    id: `cardNumber${index}`,
                                    options: modernStripeConfig,
                                    onChange: (e)=>handleStripeElementChange(e, `${prefix}cardNumber`)
                                })
                            }),
                            validationErrors?.cardNumber?.message && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                                message: t(validationErrors?.cardNumber?.message),
                                show: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                        className: "!flex-col-6 md:!flex-col-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StripeInputWrapper, {
                                label: t('common.cardExpiry'),
                                htmlFor: `expiryDate${index}`,
                                error: validationErrors?.cardExpiry?.message,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactStripeJs.CardExpiryElement), {
                                    id: `expiryDate${index}`,
                                    options: modernStripeConfig,
                                    onChange: (e)=>handleStripeElementChange(e, `${prefix}cardExpiry`)
                                })
                            }),
                            validationErrors?.cardExpiry?.message && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                                message: t(validationErrors?.cardExpiry?.message),
                                show: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                        className: "!flex-col-6 md:!flex-col-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StripeInputWrapper, {
                                label: t('common.cardCode'),
                                htmlFor: `cvc${index}`,
                                error: validationErrors?.cardCvc?.message,
                                tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionMarkDefault.default), {
                                    text: t('common.cardCodeInfo')
                                }),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactStripeJs.CardCvcElement), {
                                    id: `cvc${index}`,
                                    "data-testid": "cvc",
                                    options: modernStripeConfig,
                                    onChange: (e)=>handleStripeElementChange(e, `${prefix}cardCvc`)
                                })
                            }),
                            validationErrors?.cardCvc?.message && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                                message: t(validationErrors?.cardCvc?.message),
                                show: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-12 md:!flex-col-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                            "data-testid": "postalCode",
                            defaultValue: postalCode,
                            register: register,
                            registerOptions: {
                                setValueAs: (v)=>!v ? '' : String(v)
                            },
                            type: "number",
                            min: "0",
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                            label: t('common.postalCode'),
                            name: `${prefix}postalCode`,
                            error: validationErrors?.postalCode?.message
                        })
                    })
                ]
            }),
            children
        ]
    });
};
exports.default = NewCard;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","@stripe/react-stripe-js":"jEv7X","Core/components/Layout":"hweet","Core/components/FormElements/InputField":"6BJmW","Core/components/FormElements/Error":"dyj9l","Core/components/QuestionMark":"h9sEE","Core/components/Alert":"fmmNR","Core/utils/utils":"hwOBZ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6BJmW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _error = require("Core/components/FormElements/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const InputField = (props)=>{
    const { block, prependText, appendText, onAppendClick = null, className, error = '', errors = {}, register = ()=>{}, registerOptions, name = '', id = name, label, type = 'text', appendTestId = '', maxLength = 64, onPaste, allowDecimals, ...rest } = props;
    const disableScroll = (e)=>{
        if (e.currentTarget.type === 'number') e.target.blur();
    };
    const errorMessage = error || errors[name]?.message;
    const testid = props['data-testid'] || id;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormElement), {
        className: className,
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledInputGroup), {
                block: block,
                children: [
                    prependText ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `-mr-px`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formElementsStyled.StyledInputGroupText), {
                            className: `rounded-r-none`,
                            children: prependText
                        })
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        onWheel: disableScroll,
                        onPaste: onPaste,
                        id: id,
                        name: name,
                        type: type,
                        step: allowDecimals ? 'any' : null,
                        "aria-label": label,
                        "data-testid": testid,
                        maxLength: maxLength,
                        ...register(name, registerOptions),
                        ...rest,
                        className: (0, _classnamesDefault.default)({
                            '!rounded-l-none': Boolean(prependText) === true,
                            '!rounded-l': Boolean(prependText) === false,
                            '!rounded-r-none': Boolean(appendText) === true,
                            '!rounded-r': Boolean(appendText) === false
                        })
                    }),
                    appendText && onAppendClick && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: `-ml-px`,
                        onClick: onAppendClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formElementsStyled.StyledInputGroupText), {
                            className: (0, _classnamesDefault.default)({
                                'rounded-l-none': true,
                                'cursor-pointer': Boolean(onAppendClick)
                            }),
                            "data-testid": appendTestId,
                            children: appendText
                        })
                    }),
                    appendText && !onAppendClick && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `-ml-px`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formElementsStyled.StyledInputGroupText), {
                            className: (0, _classnamesDefault.default)({
                                'rounded-l-none': true,
                                'cursor-pointer': Boolean(onAppendClick)
                            }),
                            "data-testid": appendTestId,
                            children: appendText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                message: errorMessage,
                show: Boolean(errorMessage)
            })
        ]
    });
};
exports.default = InputField;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/Error":"dyj9l","Core/components/FormElements/formElements.styled":"45aFS","prop-types":"bPwP3","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dyj9l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const Error = ({ message, show = false })=>{
    return show ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: 'border-0 border-l-3 border-solid border-error text-error pl-1 mt-1 text-xs',
        "data-testid": "inline-error",
        children: message
    }) : null;
};
exports.default = Error;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"45aFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledInputGroup", ()=>StyledInputGroup);
parcelHelpers.export(exports, "StyledInputGroupText", ()=>StyledInputGroupText);
parcelHelpers.export(exports, "StyledFormSection", ()=>StyledFormSection);
parcelHelpers.export(exports, "StyledFormElement", ()=>StyledFormElement);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const StyledInputGroup = ({ children, block })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `relative flex flex-nowrap ${block ? 'w-full' : ''}`,
        children: children
    });
const StyledInputGroupText = ({ className, children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _classnamesDefault.default)('flex h-9 p-1.5 py-1.5 px-3 items-center mb-0 text-base font-normal text-gray-600 text-center whitespace-nowrap bg-gray-200 border border-solid rounded border-gray-300', className),
        children: children
    });
const StyledFormSection = ({ children, theme = '' })=>{
    let backgrounClass = 'bg-gray-100';
    if (theme === 'cyan') backgrounClass = 'bg-cyan-100';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)(backgrounClass, 'border border-solid border-gray-300 rounded mb-4 p-4 transition-colors'),
        children: children
    });
};
const StyledFormElement = ({ className, children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)('styled-form-element w-full', className),
        children: children
    });

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h9sEE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useWindowSize = require("Core/hooks/useWindowSize");
var _questionCircleSvg = require("url:Images/icons/question-circle.svg");
var _questionCircleSvgDefault = parcelHelpers.interopDefault(_questionCircleSvg);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _questonMarkCss = require("./QuestonMark.css");
function StyledTooltip({ position, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)('styled-tooltip rounded text-white text-xxs text-left p-2 absolute z-50 hidden [min-width:200px] [background:#333]', position),
        children: children
    });
}
function StyledQuestionMark({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: 'styled-tooltip-question-mark inline-block relative',
        children: children
    });
}
const QuestionMark = ({ text, position = 'top' })=>{
    const windowSize = (0, _useWindowSize.useWindowSize)();
    const iconRef = (0, _reactDefault.default).useRef(null);
    const [displayPosition, setDisplayPosition] = (0, _reactDefault.default).useState(position);
    (0, _reactDefault.default).useEffect(()=>{
        const rect = iconRef.current.getBoundingClientRect();
        const elemPos = {
            x: rect.left,
            y: rect.top
        };
        if (elemPos.x + 100 > windowSize.width) setDisplayPosition('left');
        else if (elemPos.x - 100 < 0) setDisplayPosition('right');
        else setDisplayPosition(position);
    }, [
        windowSize.width,
        position
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledQuestionMark, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTooltip, {
                position: displayPosition,
                children: text
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: 'cursor-pointer relative [top:2px] [width:14px]',
                ref: iconRef,
                src: (0, _questionCircleSvgDefault.default),
                alt: "(?)"
            })
        ]
    });
};
exports.default = QuestionMark;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","Core/hooks/useWindowSize":"e88AQ","url:Images/icons/question-circle.svg":"8zF5t","classnames":"f971Y","./QuestonMark.css":"jJvq7","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8zF5t":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("4kkJF");

},{}],"jJvq7":[function() {},{}],"6lnq9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StyledFormGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function StyledFormGroup({ children, error }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)('border border-solid border-gray-200 shadow-md rounded-lg mb-4 md:px-8 px-6 py-6 transition-colors bg-white', {
            'border-error': !!error
        }),
        children: children
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1d4RI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nodesToString", ()=>nodesToString);
parcelHelpers.export(exports, "Trans", ()=>Trans);
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _typeof = require("@babel/runtime/helpers/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _htmlParseStringify = require("html-parse-stringify");
var _htmlParseStringifyDefault = parcelHelpers.interopDefault(_htmlParseStringify);
var _context = require("./context");
var _utils = require("./utils");
var _excluded = [
    "format"
], _excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== '[object Array]') return false;
    return children.every(function(child) {
        return (0, _react.isValidElement)(child);
    });
}
function getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function mergeProps(source, target) {
    var newTarget = _objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function nodesToString(children, i18nOptions) {
    if (!children) return '';
    var stringNode = '';
    var childrenArray = getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === 'string') stringNode += "".concat(child);
        else if ((0, _react.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = nodesToString(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, _utils.warn)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, _typeofDefault.default)(child) === 'object') {
            var format = child.format, clone = (0, _objectWithoutPropertiesDefault.default)(child, _excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, _utils.warn)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, _utils.warn)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === '') return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === 'string') return;
            if (hasChildren(child)) getData(getChildren(child));
            else if ((0, _typeofDefault.default)(child) === 'object' && !(0, _react.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, _htmlParseStringifyDefault.default).parse("<0>".concat(targetString, "</0>"));
    var opts = _objectSpread(_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = getAsArray(reactNode);
        var astNodes = getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, _react.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, _typeofDefault.default)(child) === 'object' && child.dummy && !isElement;
                var isKnownComponent = (0, _typeofDefault.default)(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === 'string') {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if (hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, _react.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, _react.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, _typeofDefault.default)(child) === 'object' && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === 'text') {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, _react.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, getAsArray(children || []));
    return getChildren(result[0]);
}
function Trans(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded2);
    var _ref2 = (0, _react.useContext)((0, _context.I18nContext)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, _context.getI18n)();
    if (!i18n) {
        (0, _utils.warnOnce)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = _objectSpread(_objectSpread({}, (0, _context.getDefaults)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: _objectSpread(_objectSpread({}, tOptions.interpolation), {}, {
            prefix: '#$?',
            suffix: '?$#'
        })
    };
    var combinedTOpts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, _react.createElement)(useAsParent, additionalProps, content) : content;
}

},{"@babel/runtime/helpers/objectWithoutProperties":"i09EC","@babel/runtime/helpers/typeof":"G4w5m","@babel/runtime/helpers/defineProperty":"kbTlt","react":"2o0ib","html-parse-stringify":"fqO9X","./context":"5E9U1","./utils":"R6Vgu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i09EC":[function(require,module,exports,__globalThis) {
var objectWithoutPropertiesLoose = require("424c8dc91f0a14f9");
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"424c8dc91f0a14f9":"24eE3"}],"24eE3":[function(require,module,exports,__globalThis) {
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"fqO9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _voidElements = require("void-elements");
var _voidElementsDefault = parcelHelpers.interopDefault(_voidElements);
var t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, _voidElementsDefault.default)[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp(t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, i = /^\s*$/, s = Object.create(null);
function a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce(a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace(r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + a("", t);
        }, "");
    }
};
exports.default = c;

},{"void-elements":"cGPoC","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cGPoC":[function(require,module,exports,__globalThis) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

},{}],"6T56F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatCurrency", ()=>formatCurrency);
parcelHelpers.export(exports, "toFloat", ()=>toFloat);
var _currencyJs = require("currency.js");
var _currencyJsDefault = parcelHelpers.interopDefault(_currencyJs);
var _appConfig = require("Core/config/appConfig");
const formatCurrency = (value, { currency = (0, _appConfig.getAppConfig)().currency, currencyDisplay = 'symbol', withDecimals = true, roundUp = false } = {})=>{
    const decimalOptions = withDecimals ? {
        minimumFractionDigits: 2
    } : {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    };
    return new Intl.NumberFormat((0, _appConfig.getAppConfig)().locale, {
        style: 'currency',
        currency,
        currencyDisplay,
        ...roundUp && {
            roundingMode: 'ceil'
        },
        ...decimalOptions
    }).format(value);
};
function toFloat(value) {
    return (0, _currencyJsDefault.default)(value).value;
}

},{"currency.js":"7yObY","Core/config/appConfig":"7qX5H","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7yObY":[function(require,module,exports,__globalThis) {
/*
 currency.js - v2.0.4
 http://scurker.github.io/currency.js

 Copyright (c) 2021 Jason Wilson
 Released under MIT license
*/ (function(e, g) {
    module.exports = g();
})(this, function() {
    function e(b, a) {
        if (!(this instanceof e)) return new e(b, a);
        a = Object.assign({}, m, a);
        var d = Math.pow(10, a.precision);
        this.intValue = b = g(b, a);
        this.value = b / d;
        a.increment = a.increment || 1 / d;
        a.groups = a.useVedic ? n : p;
        this.s = a;
        this.p = d;
    }
    function g(b, a) {
        var d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : !0;
        var c = a.decimal;
        var h = a.errorOnInvalid, k = a.fromCents, l = Math.pow(10, a.precision), f = b instanceof e;
        if (f && k) return b.intValue;
        if ("number" === typeof b || f) c = f ? b.value : b;
        else if ("string" === typeof b) h = new RegExp("[^-\\d" + c + "]", "g"), c = new RegExp("\\" + c, "g"), c = (c = b.replace(/\((.*)\)/, "-$1").replace(h, "").replace(c, ".")) || 0;
        else {
            if (h) throw Error("Invalid Input");
            c = 0;
        }
        k || (c = (c * l).toFixed(4));
        return d ? Math.round(c) : c;
    }
    var m = {
        symbol: "$",
        separator: ",",
        decimal: ".",
        errorOnInvalid: !1,
        precision: 2,
        pattern: "!#",
        negativePattern: "-!#",
        format: function(b, a) {
            var d = a.pattern, c = a.negativePattern, h = a.symbol, k = a.separator, l = a.decimal;
            a = a.groups;
            var f = ("" + b).replace(/^-/, "").split("."), q = f[0];
            f = f[1];
            return (0 <= b.value ? d : c).replace("!", h).replace("#", q.replace(a, "$1" + k) + (f ? l + f : ""));
        },
        fromCents: !1
    }, p = /(\d)(?=(\d{3})+\b)/g, n = /(\d)(?=(\d\d)+\d\b)/g;
    e.prototype = {
        add: function(b) {
            var a = this.s, d = this.p;
            return e((this.intValue + g(b, a)) / (a.fromCents ? 1 : d), a);
        },
        subtract: function(b) {
            var a = this.s, d = this.p;
            return e((this.intValue - g(b, a)) / (a.fromCents ? 1 : d), a);
        },
        multiply: function(b) {
            var a = this.s;
            return e(this.intValue * b / (a.fromCents ? 1 : Math.pow(10, a.precision)), a);
        },
        divide: function(b) {
            var a = this.s;
            return e(this.intValue / g(b, a, !1), a);
        },
        distribute: function(b) {
            var a = this.intValue, d = this.p, c = this.s, h = [], k = Math[0 <= a ? "floor" : "ceil"](a / b), l = Math.abs(a - k * b);
            for(d = c.fromCents ? 1 : d; 0 !== b; b--){
                var f = e(k / d, c);
                0 < l-- && (f = f[0 <= a ? "add" : "subtract"](1 / d));
                h.push(f);
            }
            return h;
        },
        dollars: function() {
            return ~~this.value;
        },
        cents: function() {
            return ~~(this.intValue % this.p);
        },
        format: function(b) {
            var a = this.s;
            return "function" === typeof b ? b(this, a) : a.format(this, Object.assign({}, a, b));
        },
        toString: function() {
            var b = this.s, a = b.increment;
            return (Math.round(this.intValue / this.p / a) * a).toFixed(b.precision);
        },
        toJSON: function() {
            return this.value;
        }
    };
    return e;
});

},{}],"7niNe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Option);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Option({ className, name, value, defaultChecked, disabled, testid, onChange, children, register }) {
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
        className: className,
        htmlFor: id,
        "data-testid": testid || id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: 'w-0 h-0',
                type: "radio",
                ...register(name),
                value: value,
                id: id,
                "data-test-id": id,
                defaultChecked: defaultChecked,
                disabled: disabled,
                onChange: onChange
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2LJBE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _error = require("Core/components/FormElements/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactI18Next = require("react-i18next");
const TermsInput = ({ register, errors, errorMessage, name, children, label })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const error = errorMessage || errors?.[name]?.message;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                className: "font-semibold",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "w-4 h-4 pr-2 text-blue-600 bg-gray-100 rounded border-gray-300  dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600",
                                    id: name,
                                    "data-testid": "termsAndConditions",
                                    type: "checkbox",
                                    name: name,
                                    ...register(name)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "text-sm m-0 pl-4 pr-2 text-justify overflow-auto w-full",
                                htmlFor: name,
                                children: children
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                        message: t('requiredAcceptTermsAndConditions'),
                        show: Boolean(error)
                    })
                ]
            })
        ]
    });
};
exports.default = TermsInput;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/Error":"dyj9l","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9nTYl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _error = require("Core/components/FormElements/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactI18Next = require("react-i18next");
const Checkbox = ({ register = ()=>{}, errors = {}, name, label, className })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const error = errors[name]?.message;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `${className} mb-4`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        className: "w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300  dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 mr-2",
                        id: name,
                        type: "checkbox",
                        "data-testid": name,
                        name: name,
                        ...register(name)
                    }),
                    label
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                message: t('requiredAcceptTermsAndConditions'),
                show: Boolean(error)
            })
        ]
    });
};
exports.default = Checkbox;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/Error":"dyj9l","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fJXC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDepositPageData);
var _useGetSavedPaymentMethods = require("Core/hooks/queries/payment/useGetSavedPaymentMethods");
var _useGetSavedPaymentMethodsDefault = parcelHelpers.interopDefault(_useGetSavedPaymentMethods);
var _useGetDepositOptions = require("Core/hooks/queries/deposit/useGetDepositOptions");
function useDepositPageData() {
    const paymentMethodsQuery = (0, _useGetSavedPaymentMethodsDefault.default)();
    const depositOptionsQuery = (0, _useGetDepositOptions.useGetDepositOptions)();
    return {
        data: {
            paymentMethods: paymentMethodsQuery.data,
            depositOptions: depositOptionsQuery.data
        },
        isSuccess: paymentMethodsQuery.isSuccess && depositOptionsQuery.isSuccess
    };
}

},{"Core/hooks/queries/payment/useGetSavedPaymentMethods":"bIUV0","Core/hooks/queries/deposit/useGetDepositOptions":"VBjJx","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bIUV0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryFn", ()=>queryFn);
parcelHelpers.export(exports, "default", ()=>useGetSavedPaymentMethods);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
const queryFn = ()=>(0, _api.get)(`/api/payment-methods`);
function useGetSavedPaymentMethods(enabled = true) {
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).savedPaymentMethods, queryFn, {
        enabled
    });
}

},{"react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i5IL7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    order: 'order',
    orderReceipts: 'orderReceipts',
    financingApplicationDetails: 'financingApplicationDetails',
    paymentOptions: 'paymentOptions',
    savedPaymentMethods: 'savedPaymentMethods',
    paymentSummary: 'paymentSummary',
    paymentReceipts: 'paymentReceipts',
    deposit: 'deposit',
    depositOptions: 'depositOptions',
    financingApplication: 'financingApplication',
    financingUserData: 'financingUserData',
    nextSteps: 'nextSteps',
    tokenInfo: 'tokenInfo',
    paymentHistory: 'paymentHistory',
    directSalesPaymentOptions: 'directSalesPaymentOptions',
    paymentInfo: 'paymentInfo',
    transactionHistory: 'transactionHistory',
    savedCards: 'savedCards',
    latestTransaction: 'latestTransaction',
    financingNextStep: 'financingNextStep',
    financingPlatformApplication: 'financingPlatformApplication',
    financingCustomerInfo: 'financingCustomerInfo',
    patientfiGetApplication: 'patientfiGetApplication',
    fortivaGetApplication: 'fortivaGetApplication',
    lendflowGetApplication: 'lendflowGetApplication'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cC5Cp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "post", ()=>post);
parcelHelpers.export(exports, "put", ()=>put);
parcelHelpers.export(exports, "del", ()=>del);
parcelHelpers.export(exports, "mock", ()=>mock);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _utils = require("Core/utils/utils");
var _appConfig = require("Core/config/appConfig");
const axiosInstance = (0, _axiosDefault.default).create({
    baseURL: "https://coyn-payment-service.shared-testing.audibene.net",
    headers: {
        'Payment-Token': (0, _utils.getUrlParam)('token'),
        'Accept-Language': (0, _appConfig.getAppConfig)().locale
    }
});
function get(url, config) {
    return axiosInstance.get(url, config).then(({ data })=>data);
}
function post(url, payload, config) {
    return axiosInstance.post(url, payload, config).then(({ data })=>data);
}
function put(url, payload, config) {
    return axiosInstance.put(url, payload, config).then(({ data })=>data);
}
function del(url, payload, config) {
    return axiosInstance.delete(url, payload, config).then(({ data })=>data);
}
function mock(url, config) {
    return (0, _axiosDefault.default).get(url, config).then(({ data })=>data);
}

},{"axios":"dma8U","Core/utils/utils":"hwOBZ","Core/config/appConfig":"7qX5H","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dma8U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig, create } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"3Nr0I","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3Nr0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"1KAoV","./helpers/bind.js":"iPlDq","./core/Axios.js":"7siYv","./core/mergeConfig.js":"6449w","./defaults/index.js":"lNKSn","./helpers/formDataToJSON.js":"h8GP5","./cancel/CanceledError.js":"52fAt","./cancel/CancelToken.js":"2kW8W","./cancel/isCancel.js":"gBZDa","./env/data.js":"bPnNb","./helpers/toFormData.js":"kcEDn","./core/AxiosError.js":"2efWd","./helpers/spread.js":"6mKOO","./helpers/isAxiosError.js":"2RUZy","./core/AxiosHeaders.js":"6XfA1","./adapters/adapters.js":"cbC72","./helpers/HttpStatusCode.js":"dO4Zk","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1KAoV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const { iterator, toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if (isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = getPrototypeOf(obj);
        if (isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if (hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const getSafeProp = (obj, prop)=>obj != null && hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = getPrototypeOf(thing);
    if (sourcePrototype === null && isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : getPrototypeOf(current);
        if (isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if (isUnsafeObjectKey(prop)) continue;
            if (!hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (!isObject(val)) return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !hasOwnInPrototypeChain(val, toStringTag) && !hasOwnInPrototypeChain(val, iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!isObject(val) || isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const isFileList = kindOfTest('FileList');
const isSet = kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    return {};
}
const G = getGlobal();
const FormDataCtor = typeof G.FormData !== 'undefined' ? G.FormData : undefined;
const isFormData = (thing)=>{
    if (!thing) return false;
    if (FormDataCtor && thing instanceof FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!isFunction(thing.append)) return false;
    const kind = kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest('URLSearchParams');
const [isReadableStream, isRequest, isResponse, isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map(kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if (isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function findKey(obj, key) {
    if (isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge(...objs) {
    const { caseless, skipUndefined } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if (isPlainObject(existing) && isPlainObject(val)) result[targetKey] = merge(existing, val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || isBuffer(source)) continue;
        forEach(source, assignValue);
        if (typeof source !== 'object' || isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if (propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, _bindJsDefault.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest('HTMLFormElement');
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest('RegExp');
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[toStringTag] === 'FormData' && thing[iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if (isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if (isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if (isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = isArray(source) ? [] : {};
                    forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const isAsyncFn = kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const _setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        _global.addEventListener('message', ({ source, data })=>{
            if (source === _global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            _global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', isFunction(_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : _setImmediate;
// *********************
const isIterable = (thing)=>thing != null && isFunction(thing[iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const isSafeIterable = (thing)=>thing != null && hasOwnInPrototypeChain(thing, iterator) && isIterable(thing);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isEmptyObject,
    isReadableStream,
    isRequest,
    isResponse,
    isHeaders,
    isUndefined,
    isDate,
    isFile,
    isReactNativeBlob,
    isReactNative,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    hasOwnInPrototypeChain,
    getSafeProp,
    toSafeFlatObject,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable,
    setImmediate: _setImmediate,
    asap,
    isIterable,
    isSafeIterable
};

},{"./helpers/bind.js":"iPlDq","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iPlDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
'use strict';
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7siYv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _methodListJs = require("./methodList.js");
var _methodListJsDefault = parcelHelpers.interopDefault(_methodListJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
'use strict';
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean),
            legacyInterceptorReqResOrdering: validators.transitional(validators.boolean),
            advertiseZstdAcceptEncoding: validators.transitional(validators.boolean),
            validateStatusUndefinedResolves: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, _validatorJsDefault.default).assertOptions(config, {
            baseUrl: validators.spelling('baseURL'),
            withXsrfToken: validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, _utilsJsDefault.default).getSafeProp(config, 'method') || (0, _utilsJsDefault.default).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach((0, _methodListJsDefault.default).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, _transitionalJsDefault.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, _utilsJsDefault.default).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, _dispatchRequestJsDefault.default).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: config && (0, _utilsJsDefault.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"../utils.js":"1KAoV","../helpers/buildURL.js":"jf9Mg","./InterceptorManager.js":"eNsNr","./dispatchRequest.js":"5npYO","./mergeConfig.js":"6449w","./buildFullPath.js":"bJT5h","./methodList.js":"3YAYS","../helpers/validator.js":"eOXS8","./AxiosHeaders.js":"6XfA1","../defaults/transitional.js":"3DtWE","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jf9Mg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
 * their plain counterparts (`:`, `$`, `,`, `+`).
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("./AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function buildURL(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, _utilsJsDefault.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, _utilsJsDefault.default).getSafeProp(_options, 'encode') || encode;
    const serializeFn = (0, _utilsJsDefault.default).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

},{"../utils.js":"1KAoV","./AxiosURLSearchParams.js":"3WVob","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3WVob":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, encode) : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"kcEDn","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kcEDn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_FORM_DATA_MAX_DEPTH", ()=>DEFAULT_FORM_DATA_MAX_DEPTH);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _bufferJs = require("../platform/node/classes/Buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
'use strict';
const DEFAULT_FORM_DATA_MAX_DEPTH = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, _utilsJsDefault.default).getSafeProp(options, name);
        return (0, _utilsJsDefault.default).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', DEFAULT_FORM_DATA_MAX_DEPTH);
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if ((0, _utilsJsDefault.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, _bufferJsDefault.default) && (0, _bufferJsDefault.default).isBufferAvailable()) return (0, _bufferJsDefault.default).from(value);
            throw new (0, _axiosErrorJsDefault.default)('Blob is not supported. Use a Buffer instead.', (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, _axiosErrorJsDefault.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, _axiosErrorJsDefault.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, _utilsJsDefault.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, _utilsJsDefault.default).isReactNative(formData) && (0, _utilsJsDefault.default).isReactNativeBlob(value)) {
            formData.append(renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, _utilsJsDefault.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, '[]')) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"../utils.js":"1KAoV","../core/AxiosError.js":"2efWd","../platform/node/classes/FormData.js":"9jAdK","../platform/node/classes/Buffer.js":"9jAdK","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2efWd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REDACTED", ()=>REDACTED);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const REDACTED = '[REDACTED ****]';
function hasOwnOrPrototypeToJSON(source) {
    if ((0, _utilsJsDefault.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, _utilsJsDefault.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, _utilsJsDefault.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, _axiosHeadersJsDefault.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, _utilsJsDefault.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, _utilsJsDefault.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, _utilsJsDefault.default).isPlainObject(source) && hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? REDACTED : visit(value);
                if (!(0, _utilsJsDefault.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? stringifySafely(entry.message) : stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, _utilsJsDefault.default).isArray(error.errors) && error.errors.length) message = aggregateErrorMessage(error);
        const axiosError = new AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, _utilsJsDefault.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, _utilsJsDefault.default).isArray(redactKeys) && redactKeys.length > 0 ? redactConfig(config, redactKeys) : (0, _utilsJsDefault.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
AxiosError.ECONNABORTED = 'ECONNABORTED';
AxiosError.ETIMEDOUT = 'ETIMEDOUT';
AxiosError.ECONNREFUSED = 'ECONNREFUSED';
AxiosError.ERR_NETWORK = 'ERR_NETWORK';
AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
AxiosError.ERR_CANCELED = 'ERR_CANCELED';
AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
exports.default = AxiosError;

},{"../utils.js":"1KAoV","./AxiosHeaders.js":"6XfA1","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6XfA1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
var _sanitizeHeaderValueJs = require("../helpers/sanitizeHeaderValue.js");
'use strict';
const $internals = Symbol('internals');
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : (0, _sanitizeHeaderValueJs.sanitizeHeaderValue)(String(value));
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = trimOWS(part.slice(0, equals));
        if (!parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isObject(header) && (0, _utilsJsDefault.default).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, _utilsJsDefault.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, _utilsJsDefault.default).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, _utilsJsDefault.default).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, _utilsJsDefault.default).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"1KAoV","../helpers/parseHeaders.js":"e3iXM","../helpers/sanitizeHeaderValue.js":"ktgBz","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"e3iXM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, _utilsJsDefault.default).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, _utilsJsDefault.default).hasOwnProp(ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

},{"../utils.js":"1KAoV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ktgBz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizeHeaderValue", ()=>sanitizeHeaderValue);
parcelHelpers.export(exports, "sanitizeByteStringHeaderValue", ()=>sanitizeByteStringHeaderValue);
parcelHelpers.export(exports, "toByteStringHeaderObject", ()=>toByteStringHeaderObject);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
function trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function sanitizeValue(value, invalidChars) {
    if ((0, _utilsJsDefault.default).isArray(value)) return value.map((item)=>sanitizeValue(item, invalidChars));
    return trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const sanitizeHeaderValue = (value)=>sanitizeValue(value, INVALID_UNICODE_HEADER_VALUE_CHARS);
const sanitizeByteStringHeaderValue = (value)=>sanitizeValue(value, INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function toByteStringHeaderObject(headers) {
    const byteStringHeaders = Object.create(null);
    (0, _utilsJsDefault.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = sanitizeByteStringHeaderValue(value);
    });
    return byteStringHeaders;
}

},{"../utils.js":"1KAoV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9jAdK":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eNsNr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
const $internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$internals];
        if (this.handlers == null) this.handlers = [];
        syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$internals];
        syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            syncHandlerEntries(this, this[$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$internals];
        syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                syncHandlerEntries(this, internals);
                trimHandlers(this.handlers);
                internals.handlersLength = countHandlers(this.handlers);
            }
        }
    }
}
exports.default = InterceptorManager;

},{"../utils.js":"1KAoV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5npYO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, _utilsJsDefault.default).toSafeFlatObject(_config);
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from((0, _utilsJsDefault.default).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"36P19","../cancel/isCancel.js":"gBZDa","../defaults/index.js":"lNKSn","../cancel/CanceledError.js":"52fAt","../core/AxiosHeaders.js":"6XfA1","../adapters/adapters.js":"cbC72","../utils.js":"1KAoV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"36P19":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"../utils.js":"1KAoV","../defaults/index.js":"lNKSn","../core/AxiosHeaders.js":"6XfA1","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lNKSn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _methodListJs = require("../core/methodList.js");
var _methodListJsDefault = parcelHelpers.interopDefault(_methodListJs);
'use strict';
const own = (obj, key)=>obj != null && (0, _utilsJsDefault.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, _toURLEncodedFormJsDefault.default)(data, formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = own(this, 'transitional') || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, _utilsJsDefault.default).isResponse(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach((0, _methodListJsDefault.default), (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"1KAoV","../core/AxiosError.js":"2efWd","./transitional.js":"3DtWE","../helpers/toFormData.js":"kcEDn","../helpers/toURLEncodedForm.js":"eAufH","../platform/index.js":"iO8w9","../helpers/formDataToJSON.js":"h8GP5","../core/methodList.js":"3YAYS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3DtWE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eAufH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
'use strict';
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

},{"../utils.js":"1KAoV","./toFormData.js":"kcEDn","../platform/index.js":"iO8w9","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iO8w9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"jfKEm","./common/utils.js":"eVkEx","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jfKEm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

},{"./classes/URLSearchParams.js":"gSWtK","./classes/FormData.js":"kbIZT","./classes/Blob.js":"hxziy","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gSWtK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
exports.default = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"3WVob","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kbIZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof FormData !== 'undefined' ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hxziy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof Blob !== 'undefined' ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eVkEx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
parcelHelpers.export(exports, "navigator", ()=>_navigator);
parcelHelpers.export(exports, "origin", ()=>origin);
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
const _navigator = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf(_navigator.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const origin = hasBrowserEnv && window.location.href || 'http://localhost';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h8GP5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _toFormDataJs = require("./toFormData.js");
'use strict';
const MAX_DEPTH = (0, _toFormDataJs.DEFAULT_FORM_DATA_MAX_DEPTH);
function throwIfDepthExceeded(index) {
    if (index > MAX_DEPTH) throw new (0, _axiosErrorJsDefault.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + MAX_DEPTH, (0, _axiosErrorJsDefault.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = (0, _utilsJsDefault.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, _utilsJsDefault.default).hasOwnProp(target, name) || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"1KAoV","../core/AxiosError.js":"2efWd","./toFormData.js":"kcEDn","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3YAYS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
const methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
exports.default = methodList;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gBZDa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
'use strict';
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"52fAt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
class CanceledError extends (0, _axiosErrorJsDefault.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
exports.default = CanceledError;

},{"../core/AxiosError.js":"2efWd","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cbC72":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _fetchJs = require("./fetch.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default),
    fetch: {
        get: _fetchJs.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function getAdapter(adapters, config) {
    adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!isResolvedHandle(nameOrAdapter)) {
            adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, _utilsJsDefault.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT);
    }
    return adapter;
}
/**
 * Exports Axios adapters and utility to resolve an adapter
 */ exports.default = {
    /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: knownAdapters
};

},{"../utils.js":"1KAoV","./http.js":"9jAdK","./xhr.js":"dfEUS","./fetch.js":"aHR1E","../core/AxiosError.js":"2efWd","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dfEUS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _normalizeURLForProtocolCheckJs = require("../helpers/normalizeURLForProtocolCheck.js");
var _normalizeURLForProtocolCheckJsDefault = parcelHelpers.interopDefault(_normalizeURLForProtocolCheckJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var _sanitizeHeaderValueJs = require("../helpers/sanitizeHeaderValue.js");
const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, _resolveConfigJsDefault.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(_config.headers).normalize();
        let { responseType, onUploadProgress, onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, _parseProtocolJsDefault.default)((0, _normalizeURLForProtocolCheckJsDefault.default)(_config.url)) || (0, _parseProtocolJsDefault.default)((0, _indexJsDefault.default).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, _axiosErrorJsDefault.default)('Request aborted', (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)('Request aborted', (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, _axiosErrorJsDefault.default)(msg, (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, _transitionalJsDefault.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, _utilsJsDefault.default).forEach((0, _sanitizeHeaderValueJs.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, _progressEventReducerJs.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, _progressEventReducerJs.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(_config.url);
        if (protocol && !(0, _indexJsDefault.default).protocols.includes(protocol)) {
            reject(new (0, _axiosErrorJsDefault.default)('Unsupported protocol ' + protocol + ':', (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"../utils.js":"1KAoV","../core/settle.js":"g95bX","../defaults/transitional.js":"3DtWE","../core/AxiosError.js":"2efWd","../cancel/CanceledError.js":"52fAt","../helpers/normalizeURLForProtocolCheck.js":"fSD29","../helpers/parseProtocol.js":"bjZzh","../platform/index.js":"iO8w9","../core/AxiosHeaders.js":"6XfA1","../helpers/progressEventReducer.js":"7hgEW","../helpers/resolveConfig.js":"7aACr","../helpers/sanitizeHeaderValue.js":"ktgBz","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"g95bX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST : (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

},{"./AxiosError.js":"2efWd","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fSD29":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>normalizeURLForProtocolCheck);
'use strict';
const urlParserControlCharacters = /[\t\n\r]/g;
function normalizeURLForProtocolCheck(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace(urlParserControlCharacters, '');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bjZzh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
'use strict';
function parseProtocol(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7hgEW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progressEventReducer", ()=>progressEventReducer);
parcelHelpers.export(exports, "progressEventDecorator", ()=>progressEventDecorator);
parcelHelpers.export(exports, "asyncDecorator", ()=>asyncDecorator);
var _speedometerJs = require("./speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
var _throttleJs = require("./throttle.js");
var _throttleJsDefault = parcelHelpers.interopDefault(_throttleJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const progressEventReducer = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (0, _throttleJsDefault.default)((e)=>{
        if (!e || !(0, _utilsJsDefault.default).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const progressEventDecorator = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable,
                total,
                loaded
            }),
        throttled[1]
    ];
};
const asyncDecorator = (fn, scheduler = (0, _utilsJsDefault.default).asap)=>(...args)=>scheduler(()=>fn(...args));

},{"./speedometer.js":"h6x38","./throttle.js":"5ggl1","../utils.js":"1KAoV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h6x38":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5ggl1":[function(require,module,exports,__globalThis) {
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
exports.default = throttle;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7aACr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _isURLSameOriginJs = require("./isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _cookiesJs = require("./cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _mergeConfigJs = require("../core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _setFormDataHeadersJs = require("../core/setFormDataHeaders.js");
var _setFormDataHeadersJsDefault = parcelHelpers.interopDefault(_setFormDataHeadersJs);
var _buildURLJs = require("./buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function resolveConfig(config) {
    const newConfig = (0, _mergeConfigJsDefault.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, _utilsJsDefault.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, _axiosHeadersJsDefault.default).from(headers);
    newConfig.url = (0, _buildURLJsDefault.default)((0, _buildFullPathJsDefault.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, _utilsJsDefault.default).getSafeProp(auth, 'username') || '';
        const password = (0, _utilsJsDefault.default).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, _utilsJsDefault.default).isFormData(data)) {
        const getHeaders = (0, _utilsJsDefault.default).getSafeProp(data, 'getHeaders');
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv || (0, _utilsJsDefault.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, _utilsJsDefault.default).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, _setFormDataHeadersJsDefault.default)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
        if ((0, _utilsJsDefault.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, _isURLSameOriginJsDefault.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, _cookiesJsDefault.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
exports.default = resolveConfig;

},{"../platform/index.js":"iO8w9","../utils.js":"1KAoV","../core/AxiosError.js":"2efWd","./isURLSameOrigin.js":"bIVmW","./cookies.js":"N1H3a","../core/buildFullPath.js":"bJT5h","../core/mergeConfig.js":"6449w","../core/AxiosHeaders.js":"6XfA1","../core/setFormDataHeaders.js":"bO4g2","./buildURL.js":"jf9Mg","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bIVmW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, _indexJsDefault.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, _indexJsDefault.default).origin), (0, _indexJsDefault.default).navigator && /(msie|trident)/i.test((0, _indexJsDefault.default).navigator.userAgent)) : ()=>true;

},{"../platform/index.js":"iO8w9","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"N1H3a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, _utilsJsDefault.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, _utilsJsDefault.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, _utilsJsDefault.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, _utilsJsDefault.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"../utils.js":"1KAoV","../platform/index.js":"iO8w9","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bJT5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
var _normalizeURLForProtocolCheckJs = require("../helpers/normalizeURLForProtocolCheck.js");
var _normalizeURLForProtocolCheckJsDefault = parcelHelpers.interopDefault(_normalizeURLForProtocolCheckJs);
'use strict';
const malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, _axiosErrorJs.REDACTED}`;
    });
}
function redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, _axiosErrorJs.REDACTED)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, _axiosErrorJs.REDACTED)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, _normalizeURLForProtocolCheckJsDefault.default)(url);
        if (malformedHttpProtocol.test(normalizedURL)) throw new (0, _axiosErrorJsDefault.default)(`Invalid URL ${JSON.stringify(redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, _axiosErrorJsDefault.default).ERR_INVALID_URL, config);
    }
}
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls, config) {
    assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, _isAbsoluteURLJsDefault.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        assertValidHttpProtocolURL(baseURL, config);
        return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

},{"./AxiosError.js":"2efWd","../helpers/isAbsoluteURL.js":"9Nn4f","../helpers/combineURLs.js":"2eQJM","../helpers/normalizeURLForProtocolCheck.js":"fSD29","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9Nn4f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
'use strict';
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2eQJM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
'use strict';
function combineURLs(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6449w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? {
        ...thing
    } : thing;
const ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, _utilsJsDefault.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, _utilsJsDefault.default).isUndefined(transitional2)) {
            if ((0, _utilsJsDefault.default).isPlainObject(transitional2)) {
                if ((0, _utilsJsDefault.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, _utilsJsDefault.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, _utilsJsDefault.default).isPlainObject(transitional1) && (0, _utilsJsDefault.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, _utilsJsDefault.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, _utilsJsDefault.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
    };
    (0, _utilsJsDefault.default).forEach(ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, _utilsJsDefault.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, _utilsJsDefault.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, _utilsJsDefault.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, _utilsJsDefault.default).hasOwnProp(config2, 'validateStatus') && (0, _utilsJsDefault.default).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, _utilsJsDefault.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

},{"../utils.js":"1KAoV","./AxiosHeaders.js":"6XfA1","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bO4g2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setFormDataHeaders);
'use strict';
const FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if (FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aHR1E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFetch", ()=>getFetch);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _composeSignalsJs = require("../helpers/composeSignals.js");
var _composeSignalsJsDefault = parcelHelpers.interopDefault(_composeSignalsJs);
var _trackStreamJs = require("../helpers/trackStream.js");
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var _settleJs = require("../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _estimateDataURLDecodedBytesJs = require("../helpers/estimateDataURLDecodedBytes.js");
var _estimateDataURLDecodedBytesJsDefault = parcelHelpers.interopDefault(_estimateDataURLDecodedBytesJs);
var _dataJs = require("../env/data.js");
var _sanitizeHeaderValueJs = require("../helpers/sanitizeHeaderValue.js");
const DEFAULT_CHUNK_SIZE = 65536;
const DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction } = (0, _utilsJsDefault.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const decodeURIComponentSafe = (value)=>{
    if (!(0, _utilsJsDefault.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const factory = (env)=>{
    const globalObject = (0, _utilsJsDefault.default).global !== undefined && (0, _utilsJsDefault.default).global !== null ? (0, _utilsJsDefault.default).global : globalThis;
    const { ReadableStream, TextEncoder } = globalObject;
    env = (0, _utilsJsDefault.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request, Response } = env;
    const isFetchSupported = envFetch ? isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = isFunction(Request);
    const isResponseSupported = isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, _indexJsDefault.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && test(()=>(0, _utilsJsDefault.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, _axiosErrorJsDefault.default)(`Response type '${type}' is not supported`, (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, _utilsJsDefault.default).isBlob(body)) return body.size;
        if ((0, _utilsJsDefault.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, _indexJsDefault.default).origin, {
                method: 'POST',
                body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, _utilsJsDefault.default).isArrayBufferView(body) || (0, _utilsJsDefault.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, _utilsJsDefault.default).isURLSearchParams(body)) body = body + '';
        if ((0, _utilsJsDefault.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, _utilsJsDefault.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, withCredentials = 'same-origin', fetchOptions, maxContentLength, maxBodyLength, maxRedirects } = (0, _resolveConfigJsDefault.default)(config);
        const hasMaxContentLength = (0, _utilsJsDefault.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, _utilsJsDefault.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, _utilsJsDefault.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, _composeSignalsJsDefault.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, _axiosErrorJsDefault.default)('Request body larger than maxBodyLength limit', (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, _utilsJsDefault.default).getSafeProp(configAuth, 'username') || '';
                const password = (0, _utilsJsDefault.default).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username,
                    password
                };
            }
            if (maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, _indexJsDefault.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa(encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, _estimateDataURLDecodedBytesJsDefault.default)(url);
                if (estimated > maxContentLength) throw new (0, _axiosErrorJsDefault.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, _utilsJsDefault.default).isReadableStream(data) || (0, _utilsJsDefault.default).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, _trackStreamJs.trackStream)(stream, DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, _utilsJsDefault.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, _progressEventReducerJs.progressEventDecorator)(requestContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, _axiosErrorJsDefault.default)('Stream request bodies are not supported by the current fetch implementation', (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT, config, request);
            if (!(0, _utilsJsDefault.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, _utilsJsDefault.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, _dataJs.VERSION), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, _sanitizeHeaderValueJs.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, _utilsJsDefault.default).forEach(DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, _utilsJsDefault.default).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, _axiosErrorJsDefault.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, _utilsJsDefault.default).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, _progressEventReducerJs.progressEventDecorator)(responseContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, _axiosErrorJsDefault.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, _trackStreamJs.trackStream)(response.body, DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, _utilsJsDefault.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, _axiosErrorJsDefault.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, _settleJsDefault.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, _axiosHeadersJsDefault.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config,
                    request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, _axiosErrorJsDefault.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, _axiosErrorJsDefault.default)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, _axiosErrorJsDefault.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const seedCache = new Map();
const getFetch = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request, Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : factory(env));
        map = target;
    }
    return target;
};
const adapter = getFetch();
exports.default = adapter;

},{"../platform/index.js":"iO8w9","../utils.js":"1KAoV","../core/AxiosError.js":"2efWd","../helpers/composeSignals.js":"evOsI","../helpers/trackStream.js":"bjFJh","../core/AxiosHeaders.js":"6XfA1","../helpers/progressEventReducer.js":"7hgEW","../helpers/resolveConfig.js":"7aACr","../core/settle.js":"g95bX","../helpers/estimateDataURLDecodedBytes.js":"elTgx","../env/data.js":"bPnNb","../helpers/sanitizeHeaderValue.js":"ktgBz","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"evOsI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, _axiosErrorJsDefault.default) ? err : new (0, _canceledErrorJsDefault.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, _axiosErrorJsDefault.default)(`timeout of ${timeout}ms exceeded`, (0, _axiosErrorJsDefault.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal } = controller;
    signal.unsubscribe = ()=>(0, _utilsJsDefault.default).asap(unsubscribe);
    return signal;
};
exports.default = composeSignals;

},{"../cancel/CanceledError.js":"52fAt","../core/AxiosError.js":"2efWd","../utils.js":"1KAoV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bjFJh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamChunk", ()=>streamChunk);
parcelHelpers.export(exports, "readBytes", ()=>readBytes);
parcelHelpers.export(exports, "trackStream", ()=>trackStream);
const streamChunk = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const readBytes = async function*(iterable, chunkSize) {
    for await (const chunk of readStream(iterable))yield* streamChunk(chunk, chunkSize);
};
const readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done, value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const trackStream = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = readBytes(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done, value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"elTgx":[function(require,module,exports,__globalThis) {
/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>estimateDataURLDecodedBytes);
/**
 * Estimate the Buffer backing allocation used by Node's raw base64 decoder.
 *
 * @param {string} url
 * @returns {number}
 */ parcelHelpers.export(exports, "estimateDataURLBufferAllocation", ()=>estimateDataURLBufferAllocation);
const isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const isPercentEncodedByte = (str, i, len)=>i + 2 < len && isHexDigit(str.charCodeAt(i + 1)) && isHexDigit(str.charCodeAt(i + 2));
const hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && isPercentEncodedByte(body, i, len)) {
            code = hexValue(body.charCodeAt(i + 1)) * 16 + hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if (isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return estimateBase64BufferAllocation(body);
    return base64Bytes(significant);
};
const estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function estimateDataURLDecodedBytes(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), estimatePercentDecodedBase64Bytes);
}
function estimateDataURLBufferAllocation(url) {
    return estimateDataURLBytes(url, estimateBase64BufferAllocation);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bPnNb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.20.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eOXS8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
const validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, _dataJs.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, _axiosErrorJsDefault.default)('options must be an object', (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)('option ' + opt + ' must be ' + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)('Unknown option ' + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"bPnNb","../core/AxiosError.js":"2efWd","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2kW8W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"52fAt","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6mKOO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
'use strict';
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2RUZy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"../utils.js":"1KAoV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dO4Zk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    if (HttpStatusCode[value] === undefined) HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"VBjJx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetDepositOptions", ()=>useGetDepositOptions);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
var _reactLocation = require("react-location");
var _routes = require("Core/routes");
function useGetDepositOptions() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactLocation.useNavigate)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).depositOptions, ()=>(0, _api.get)('/api/deposit-options'), {
        onError (e) {
            if (e) {
                setError(t('status.error.getDepositOptionsFailed') + e.message);
                navigate({
                    to: (0, _routes.errorPath)
                });
            }
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/stores/error":"38MVH","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","react-location":"8hNco","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gEPFe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePostCreatePaymentMethods);
var _reactQuery = require("react-query");
function usePostCreatePaymentMethods() {
    return (0, _reactQuery.useMutation)(async ({ stripe, data })=>{
        const paymentMethods = data.map(async (card)=>{
            if (card.paymentMethodId) return card;
            const result = await stripe.createPaymentMethod({
                type: 'card',
                card: card.stripeElement,
                billing_details: card.billingDetails
            });
            return {
                amount: card.amount,
                cardId: card.cardId,
                paymentMethodId: result.paymentMethod.id
            };
        });
        return await Promise.all(paymentMethods);
    }, {
        throwOnError: true
    });
}

},{"react-query":"ksTpv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2m5lX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePostChargeDeposit);
var _reactQuery = require("react-query");
var _api = require("Core/utils/api");
var _logger = require("Core/utils/logger");
function usePostChargeDeposit() {
    return (0, _reactQuery.useMutation)((payload)=>(0, _api.post)(`/api/deposit`, payload), {
        throwOnError: true,
        onSuccess: (data, variables)=>{
            (0, _logger.postLogMessage)({
                amount: variables.amount,
                feature: (0, _logger.features).depositCheckout,
                status: 'success'
            });
        }
    });
}

},{"react-query":"ksTpv","Core/utils/api":"cC5Cp","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cWDKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "features", ()=>features);
parcelHelpers.export(exports, "actions", ()=>actions);
parcelHelpers.export(exports, "postLogMessage", ()=>postLogMessage);
const features = {
    depositCheckout: 'depositCheckout',
    creditDebitCheckout: 'creditDebitCheckout',
    financingCheckout: 'financingCheckout',
    mixedPaymentCheckout: 'mixedPaymentCheckout',
    createAllegroApp: 'createAllegroApp',
    sendPaymentLink: 'sendPaymentLink',
    sendContractLink: 'sendContractLink',
    createPaymentRequest: 'createPaymentRequest',
    paymentRequestCardCheckout: 'paymentRequestCardCheckout',
    paymentRequestSepaCheckout: 'paymentRequestSepaCheckout',
    cardPreferenceAddCard: 'cardPreferenceAddCard',
    directSales: 'directSales',
    platformAddCard: 'platformAddCard',
    platformDeposit: 'platformDeposit',
    platformPayment: 'platformPayment',
    financingSignContract: 'financingSignContract'
};
const actions = {
    signContractButtonClicked: 'sign_contract_button_clicked',
    financingSuccessScreenDisplayed: 'financing_success_screen_displayed',
    createApplicationFormError: 'create_application_form_error',
    createApplicationTimeout: 'create_application_timeout'
};
const postLogMessage = ()=>{
//STUB METHOD SINCE NEW RELIC IS NOT USED
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4bxss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdatePaymentMethod);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
function useUpdatePaymentMethod() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(({ paymentMethodId, preferred })=>{
        return (0, _api.put)(`/api/payment-methods/${paymentMethodId}`, {
            preferred
        });
    }, {
        async onMutate ({ paymentMethodId, preferred }) {
            await queryClient.cancelQueries((0, _cacheKeysDefault.default).savedPaymentMethods);
            const previousPaymentMethods = queryClient.getQueryData((0, _cacheKeysDefault.default).savedPaymentMethods);
            queryClient.setQueryData((0, _cacheKeysDefault.default).savedPaymentMethods, (paymentMethods = [])=>paymentMethods.map((pm)=>{
                    if (pm.paymentMethodId === paymentMethodId) return {
                        ...pm,
                        preferred
                    };
                    return {
                        ...pm,
                        preferred: false
                    };
                }));
            return {
                previousPaymentMethods
            };
        },
        onError (e, _variables, context) {
            queryClient.setQueryData((0, _cacheKeysDefault.default).savedPaymentMethods, context.previousPaymentMethods);
            throw e;
        },
        onSettled () {
            return queryClient.invalidateQueries((0, _cacheKeysDefault.default).savedPaymentMethods);
        }
    });
}

},{"react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5UE3N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Status);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _alert = require("Core/components/Alert");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
function Status({ type, text }) {
    if (!text) return null;
    return type === 'error' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
        children: text
    }) : type === 'loading' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: text
    }) : null;
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Alert":"fmmNR","Core/components/Loader":"6S7S4","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3U71W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Success);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _paymentReceipts = require("Core/components/Receipts/PaymentReceipts");
var _paymentReceiptsDefault = parcelHelpers.interopDefault(_paymentReceipts);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
function Success() {
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.deposit.success.header'),
        stepProgressProps: {
            type: 'deposit'
        },
        withCardPrefCenterLink: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertSuccess), {
                children: t('page.deposit.success.infobox')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                className: "!shadow-sm !rounded-xl justify-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-center text-gray-600 mb-0",
                        children: t('page.deposit.success.intro')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentReceiptsDefault.default), {
                        title: t('page.creditDebit.success.clickToViewReceipt')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                        className: "border-gray-100 my-4"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Core/components/FormElements/Card":"23G8S","Core/components/Receipts/PaymentReceipts":"55cCB","Core/components/Page":"4xeqH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"23G8S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Card);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function Card({ children, error, cardPadding, type, ...props }) {
    const paddingX = 'md:px-8 px-6';
    let paddingTop;
    switch(cardPadding){
        case 'sm':
            paddingTop = 'py-2';
            break;
        case 'lg':
            paddingTop = 'py-6';
            break;
        case 'xl':
            paddingTop = 'py-8';
            break;
        case 'md':
        default:
            paddingTop = 'py-4';
            break;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...props,
        className: (0, _classnamesDefault.default)(props.className, `border border-solid border-gray-200 shadow-sm rounded-lg mb-4 ${paddingX} ${paddingTop} transition-colors bg-white`, {
            'border-error': !!error,
            'bg-slate-300 border-slate-400': type === 'slate'
        }),
        children: children
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"55cCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useGetPaymentReceiptUrls = require("Core/hooks/queries/payment/useGetPaymentReceiptUrls");
var _receipt = require("./Receipt");
var _receiptDefault = parcelHelpers.interopDefault(_receipt);
const PaymentReceipts = ({ title = '', paymentRequestId })=>{
    const queryResponse = (0, _useGetPaymentReceiptUrls.useGetPaymentReceiptUrls)(paymentRequestId);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _receiptDefault.default), {
        title: title,
        ...queryResponse
    });
};
exports.default = PaymentReceipts;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","Core/hooks/queries/payment/useGetPaymentReceiptUrls":"4aV8R","./Receipt":"cOsaf","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4aV8R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetPaymentReceiptUrls", ()=>useGetPaymentReceiptUrls);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
function useGetPaymentReceiptUrls(paymentRequestId) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const url = paymentRequestId ? `/api/payments/${paymentRequestId}/receipts` : `/api/payments/receipts`;
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).paymentReceipts,
        {
            paymentRequestId
        }
    ], ()=>(0, _api.get)(url), {
        onError (e) {
            setErrorAlert(t('status.error.getPaymentReceiptUrlQueryFailed'));
            throw e;
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/stores/alert":"fPz3p","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cOsaf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _alert = require("Core/components/Alert");
var _button = require("Core/components/Button");
const showPaymentReceipt = (url, target)=>{
    const width = 660;
    const height = window.innerHeight < 820 ? window.innerHeight - 20 : 820;
    const left = window.innerWidth / 2 - width / 2;
    const top = 40;
    const features = `left=${left},top=${top},width=${width},height=${height}`;
    window.open(url, target, features);
};
const Receipt = ({ title, isLoading, isError, data: paymentReceipts })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.paymentReceiptsUrl'),
        type: "inline"
    });
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
        children: t('status.error.failedToLoadPaymentReceipt')
    });
    if (!paymentReceipts || !paymentReceipts?.receipts.length) return null;
    const { receipts = [] } = paymentReceipts;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "text-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-bold mb-2",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex items-center justify-center",
                children: receipts.map((item)=>{
                    const { card, financing, type, url } = item;
                    let label;
                    let target = '_blank';
                    switch(type){
                        case 'card':
                            label = `${card.brand.toUpperCase()} **** ${card.last4}`;
                            break;
                        case 'financing':
                            label = `${financing.brand} ${t('common.financingContract')}`;
                            target = '_self';
                            break;
                        default:
                            label = t('common.showPaymentReceipt');
                            break;
                    }
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                        className: "!mx-1",
                        size: "small",
                        onClick: ()=>showPaymentReceipt(url, target),
                        disabled: isLoading,
                        "data-testid": `receiptUrlBtn`,
                        children: label
                    }, url);
                })
            })
        ]
    });
};
exports.default = Receipt;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/components/Loader":"6S7S4","Core/components/Alert":"fmmNR","Core/components/Button":"6YNzH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"b06ef":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactStripeJs = require("@stripe/react-stripe-js");
var _reactToastify = require("react-toastify");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _layout = require("Core/components/Layout");
var _button = require("Core/components/Button");
var _paymentMethod = require("Modules/deposit/components/PaymentMethod");
var _paymentMethodDefault = parcelHelpers.interopDefault(_paymentMethod);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _dialog = require("Core/stores/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _useAddPaymentMethod = require("Core/hooks/queries/payment/useAddPaymentMethod");
var _useAddPaymentMethodDefault = parcelHelpers.interopDefault(_useAddPaymentMethod);
var _useUpdatePaymentMethod = require("Core/hooks/queries/payment/useUpdatePaymentMethod");
var _useUpdatePaymentMethodDefault = parcelHelpers.interopDefault(_useUpdatePaymentMethod);
var _useDeletePaymentMethod = require("Core/hooks/queries/payment/useDeletePaymentMethod");
var _useDeletePaymentMethodDefault = parcelHelpers.interopDefault(_useDeletePaymentMethod);
var _useCreatePaymentMethod = require("Core/hooks/queries/stripe/useCreatePaymentMethod");
var _useCreatePaymentMethodDefault = parcelHelpers.interopDefault(_useCreatePaymentMethod);
var _useGetSavedPaymentMethods = require("Core/hooks/queries/payment/useGetSavedPaymentMethods");
var _useGetSavedPaymentMethodsDefault = parcelHelpers.interopDefault(_useGetSavedPaymentMethods);
var _addCardForm = require("Modules/deposit/components/AddCardForm");
var _addCardFormDefault = parcelHelpers.interopDefault(_addCardForm);
var _footer = require("Core/components/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _reactLocation = require("react-location");
var _routes = require("Modules/deposit/routes");
const CardPreferenceCenter = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactLocation.useNavigate)();
    const stripe = (0, _reactStripeJs.useStripe)();
    const stripeElements = (0, _reactStripeJs.useElements)();
    const showDialog = (0, _dialogDefault.default)((0, _dialog.showDialogSelector));
    const { data: savedPaymentMethods = [], isLoading: isLoadingSavedPaymentMethods } = (0, _useGetSavedPaymentMethodsDefault.default)();
    const { mutateAsync: createPaymentMethod, isLoading: isLoadingCreatePaymentMethod } = (0, _useCreatePaymentMethodDefault.default)();
    const { mutateAsync: addCard, isLoading: isLoadingAddCard } = (0, _useAddPaymentMethodDefault.default)(true);
    const { mutateAsync: updateCard } = (0, _useUpdatePaymentMethodDefault.default)();
    const { mutateAsync: deleteCard } = (0, _useDeletePaymentMethodDefault.default)();
    const [modalIsOpen, setIsOpen] = (0, _reactDefault.default).useState(false);
    const [cardError, setCardError] = (0, _reactDefault.default).useState('');
    const isLoading = isLoadingCreatePaymentMethod || isLoadingAddCard;
    const visibilityState = isLoading ? `hidden` : `block`;
    const showAddCardForm = ()=>{
        setCardError('');
        setIsOpen(!modalIsOpen);
    };
    const onSubmit = async ({ firstName, lastName, postalCode, preferred })=>{
        let paymentMethodId;
        try {
            const paymentMethod = await createPaymentMethod({
                stripe,
                stripeCardElement: stripeElements.getElement((0, _reactStripeJs.CardNumberElement)),
                name: firstName + ' ' + lastName,
                postalCode
            });
            paymentMethodId = paymentMethod.id;
        } catch (_err) {
            setCardError(t('status.error.failedToSaveCardOnStripe'));
            return;
        }
        try {
            await addCard({
                paymentMethodId,
                preferred
            });
            (0, _reactToastify.toast).success(t('status.success.cardAdded'));
            setIsOpen(false);
        } catch (_err) {
            setCardError(t('status.error.failedToAddCard'));
        }
    };
    const handleUpdateCard = async (paymentMethodId)=>{
        try {
            await updateCard(paymentMethodId);
            (0, _reactToastify.toast).success(t('status.success.cardUpdated'));
        } catch (_err) {
            (0, _reactToastify.toast).error(t('status.error.failedToUpdateCard'));
        }
    };
    const handleDeleteCard = (paymentMethodId)=>{
        showDialog({
            title: t('common.deleteCard'),
            description: t('common.confirmDeleteCard'),
            confirmButtonLabel: t('common.yes'),
            cancelButtonLabel: t('common.no'),
            confirmCallback: async ()=>{
                try {
                    await deleteCard(paymentMethodId);
                    (0, _reactToastify.toast).success('status.success.cardDeleted');
                } catch (_err) {
                    (0, _reactToastify.toast).error(t('status.error.failedToDeleteCard'));
                }
            }
        });
    };
    if (isLoadingSavedPaymentMethods) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        type: "overlay",
        message: t('status.loading.cardPreferenceCenter')
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
                title: t('common.manageCards'),
                withStepProgress: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "text-lg font-semibold text-gray-900 m-0",
                                children: t('common.savedCards')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                "data-testid": "add-card",
                                onClick: showAddCardForm,
                                className: "!shadow-md hover:!shadow-lg transition-shadow",
                                children: t('common.addCard')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "space-y-4",
                        children: savedPaymentMethods.map((paymentMethod)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentMethodDefault.default), {
                                paymentMethod: paymentMethod,
                                onMarkPreferred: handleUpdateCard,
                                onDelete: handleDeleteCard
                            }, paymentMethod.paymentMethodId);
                        })
                    }),
                    !savedPaymentMethods.length && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bg-white border border-gray-200 rounded-xl shadow-sm p-6 text-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-gray-600 mb-4",
                                children: t('common.cardPreferenceCenter.getStarted')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                "data-testid": "add-card",
                                size: "small",
                                onClick: showAddCardForm,
                                className: "!shadow-md hover:!shadow-lg transition-shadow",
                                children: t('common.addCard')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                        labelPrev: t('common.back'),
                        onPrev: ()=>navigate({
                                to: (0, _routes.depositCheckoutPath),
                                search: true
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
                className: "w-10/12",
                isOpen: modalIsOpen,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addCardFormDefault.default), {
                        onSubmit: onSubmit,
                        className: visibilityState,
                        onCancel: ()=>setIsOpen(false),
                        cardError: cardError
                    }),
                    isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                        "data-testid": "add-card-loader",
                        className: "p-8",
                        message: t('status.loading.savingCard'),
                        type: "inline"
                    })
                ]
            })
        ]
    });
};
exports.default = CardPreferenceCenter;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","@stripe/react-stripe-js":"jEv7X","react-toastify":"8eTVO","Core/components/Page":"4xeqH","Core/components/Layout":"hweet","Core/components/Button":"6YNzH","Modules/deposit/components/PaymentMethod":"5GHcO","Core/components/Loader":"6S7S4","Core/stores/dialog":"6IfFO","Core/hooks/queries/payment/useAddPaymentMethod":"dPWUT","Core/hooks/queries/payment/useUpdatePaymentMethod":"4bxss","Core/hooks/queries/payment/useDeletePaymentMethod":"aJpLd","Core/hooks/queries/stripe/useCreatePaymentMethod":"ewsPp","Core/hooks/queries/payment/useGetSavedPaymentMethods":"bIUV0","Modules/deposit/components/AddCardForm":"gnjys","Core/components/Footer":"ixeAp","react-location":"8hNco","Modules/deposit/routes":"01vo0","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5GHcO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _creditCardLogos = require("Core/components/CreditCardLogos");
var _creditCardLogosDefault = parcelHelpers.interopDefault(_creditCardLogos);
const StarIcon = ({ isActive, onClick })=>{
    const color = isActive ? `text-yellow-400` : `text-gray-300`;
    const fill = isActive ? 'currentColor' : 'none';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        "data-testid": "mark-preferred",
        className: color,
        "data-active": isActive,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            onClick: onClick,
            xmlns: "http://www.w3.org/2000/svg",
            className: "h-6 w-6 cursor-pointer",
            fill: fill,
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
            })
        })
    });
};
/*
const TrashIcon = ({ onClick }) => {
  return (
    <svg
      data-testid="delete-card"
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className="h-6 w-6 cursor-pointer"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
  );
};
*/ const PaymentMethod = ({ paymentMethod, onMarkPreferred })=>{
    const { paymentMethodId, card: { last4, brand }, preferred } = paymentMethod;
    const { name } = (0, _creditCardLogos.getCard)(brand);
    const togglePreferredState = ()=>{
        onMarkPreferred({
            paymentMethodId,
            preferred: !preferred
        });
    };
    /*
  const handleDelete = () => {
    onDelete(paymentMethodId);
  };
  */ return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow p-4 flex items-center",
        "data-testid": "payment-method",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StarIcon, {
                isActive: preferred,
                onClick: togglePreferredState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center flex-1 ml-4 font-semibold text-gray-900",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creditCardLogosDefault.default), {
                        brand: brand,
                        size: "small",
                        className: "mr-2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1",
                        children: name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "text-gray-600",
                        children: [
                            "\u2022\u2022\u2022\u2022 ",
                            last4
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = PaymentMethod;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/CreditCardLogos":"dnezw","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dPWUT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAddPaymentMethod);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
var _logger = require("Core/utils/logger");
function useAddPaymentMethod(shouldLog = false) {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(({ paymentMethodId, preferred })=>{
        return (0, _api.post)(`/api/payment-methods/`, {
            paymentMethodId,
            preferred
        });
    }, {
        onSuccess () {
            //normally used to track card pref center.
            shouldLog && (0, _logger.postLogMessage)({
                feature: (0, _logger.features).cardPreferenceAddCard,
                status: 'success'
            });
            return queryClient.invalidateQueries((0, _cacheKeysDefault.default).savedPaymentMethods);
        }
    });
}

},{"react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aJpLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDeletePaymentMethod);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
function useDeletePaymentMethod() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((paymentMethodId)=>{
        return (0, _api.del)(`/api/payment-methods/${paymentMethodId}`);
    }, {
        async onMutate (paymentMethodId) {
            await queryClient.cancelQueries((0, _cacheKeysDefault.default).savedPaymentMethods);
            const previousPaymentMethods = queryClient.getQueryData((0, _cacheKeysDefault.default).savedPaymentMethods);
            queryClient.setQueryData((0, _cacheKeysDefault.default).savedPaymentMethods, (paymentMethods)=>paymentMethods.filter((pm)=>pm.paymentMethodId !== paymentMethodId));
            return {
                previousPaymentMethods
            };
        },
        onError (e, _variables, context) {
            queryClient.setQueryData((0, _cacheKeysDefault.default).savedPaymentMethods, context.previousPaymentMethods);
            throw e;
        },
        onSettled () {
            return queryClient.invalidateQueries((0, _cacheKeysDefault.default).paymentHistory);
        }
    });
}

},{"react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ewsPp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCreatePaymentMethod);
var _reactQuery = require("react-query");
function useCreatePaymentMethod() {
    return (0, _reactQuery.useMutation)(async ({ stripe, stripeCardElement, name, postalCode })=>{
        const result = await stripe.createPaymentMethod({
            type: 'card',
            card: stripeCardElement,
            billing_details: {
                name,
                address: {
                    postal_code: postalCode
                }
            }
        });
        return result.paymentMethod;
    }, {
        throwOnError: true
    });
}

},{"react-query":"ksTpv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gnjys":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddCardForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
var _closeIcon = require("Modules/deposit/components/CloseIcon");
var _closeIconDefault = parcelHelpers.interopDefault(_closeIcon);
var _useAddCardForm = require("Modules/deposit/hooks/useAddCardForm");
var _useAddCardFormDefault = parcelHelpers.interopDefault(_useAddCardForm);
var _newCard = require("Core/components/NewCard");
var _newCardDefault = parcelHelpers.interopDefault(_newCard);
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _checkbox = require("Core/components/FormElements/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
function AddCardForm({ onSubmit, className, onCancel, cardError }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const form = (0, _useAddCardFormDefault.default)();
    const { handleSubmit, register, formState: { errors } } = form;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        name: "addCardForm",
        onSubmit: handleSubmit(onSubmit),
        className: `${className} space-y-4`,
        "data-testid": "add-card-form",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-900 m-0",
                        children: t('common.addCardDetails')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeIconDefault.default), {
                        onClick: onCancel
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                className: "!shadow-sm",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newCardDefault.default), {
                    form: form,
                    cardError: cardError
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                className: "!shadow-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _termsInputDefault.default), {
                        name: "terms",
                        register: register,
                        errors: errors,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "mb-0 text-gray-600",
                            children: t('terms.card.hold')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                            label: t('common.markAsPreferredCard'),
                            name: "preferred",
                            register: register
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                    type: "submit",
                    "data-testid": "save-card",
                    size: "tall",
                    className: "!shadow-md hover:!shadow-lg transition-shadow",
                    children: t('common.saveCard')
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Button":"6YNzH","react-i18next":"244ua","Modules/deposit/components/CloseIcon":"3OhUV","Modules/deposit/hooks/useAddCardForm":"1Rzg6","Core/components/NewCard":"lw5qG","Core/components/FormElements/TermsInput":"2LJBE","Core/components/FormElements/Checkbox":"9nTYl","Core/components/FormElements/Card":"23G8S","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1Rzg6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAddCardForm);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _v3 = require("zod/v3");
var _reactHookForm = require("react-hook-form");
var _zod = require("@hookform/resolvers/zod");
var _reactI18Next = require("react-i18next");
function useAddCardForm() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            firstName: _v3.string().nonempty({
                message: t('common.requiredFieldFirstName')
            }),
            lastName: _v3.string().nonempty({
                message: t('common.requiredFieldLastName')
            }),
            postalCode: _v3.string().nonempty({
                message: t('common.requiredFieldPostalCode')
            }),
            cardNumber: _v3.any().refine((value)=>Boolean(value), {
                message: t('common.requiredFieldCardNumber')
            }),
            cardExpiry: _v3.any().refine((value)=>Boolean(value), {
                message: t('common.requiredFieldCardExpiry')
            }),
            cardCvc: _v3.any().refine((value)=>Boolean(value), {
                message: t('common.requiredFieldCardCode')
            }),
            terms: _v3.boolean().refine((val)=>val, {
                message: t('common.requiredFieldTerms')
            }),
            preferred: _v3.boolean()
        });
    }, [
        t
    ]);
    return (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        defaultValues: {
            firstName: '',
            lastName: '',
            postalCode: '',
            cardNumber: '',
            cardExpiry: '',
            cardCvc: '',
            preferred: false,
            terms: false
        },
        shouldUnregister: true
    });
}

},{"react":"2o0ib","zod/v3":"kXNSc","react-hook-form":"53GLT","@hookform/resolvers/zod":"c0M5u","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ixeAp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _button = require("Core/components/Button");
var _layout = require("Core/components/Layout");
const Footer = (props)=>{
    const { hasPrev = true, hasNext = true, labelPrev, labelNext, onNext, onPrev } = props;
    const backButton = hasPrev && onPrev ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SecondaryOutlineButton), {
        block: true,
        onClick: onPrev,
        "data-testid": "back",
        children: labelPrev
    }) : '';
    const nextButton = hasNext && onNext ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
        block: true,
        onClick: onNext,
        "data-testid": "continue",
        children: labelNext
    }) : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("footer", {
        className: "pb-4",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
            className: backButton ? `!justify-between` : `!justify-end`,
            children: [
                backButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                    className: "!flex-col-6 md:!flex-col-4 lg:!flex-col-3",
                    children: backButton
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                    className: "!flex-col-6 md:!flex-col-4 lg:!flex-col-3",
                    children: nextButton
                })
            ]
        })
    });
};
exports.default = Footer;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","Core/components/Button":"6YNzH","Core/components/Layout":"hweet","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bPJKS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DepositData);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetDeposit = require("Core/hooks/queries/deposit/useGetDeposit");
var _constants = require("Core/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _reactLocation = require("react-location");
var _routes = require("Modules/deposit/routes");
function DepositData({ children }) {
    const { isLoading, isError, data: deposit, error } = (0, _useGetDeposit.useGetDeposit)();
    const navigate = (0, _reactLocation.useNavigate)();
    const depositStatus = deposit?.status;
    (0, _reactDefault.default).useEffect(()=>{
        if (depositStatus === (0, _constantsDefault.default).depositStatus.SUCCEEDED) return navigate({
            to: (0, _routes.depositSuccessPath),
            search: true
        });
    }, [
        depositStatus,
        navigate
    ]);
    // ugly hack because of API's status code / error handling
    if (isLoading || isError && error) return null;
    return children;
}

},{"react":"2o0ib","Core/hooks/queries/deposit/useGetDeposit":"873BZ","Core/config/constants":"ad5OP","react-location":"8hNco","Modules/deposit/routes":"01vo0","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"873BZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetDeposit", ()=>useGetDeposit);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
var _reactLocation = require("react-location");
var _routes = require("Core/routes");
async function getDeposit() {
    try {
        return await (0, _api.get)(`/api/deposit`);
    } catch (error) {
        if (error?.response?.status === 404) return '';
        const message = error?.response?.data?.message ? ` - ${error.response.data.message}` : '';
        throw new Error(message || 'Deposit fetch failed', {
            cause: error
        });
    }
}
function useGetDeposit() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).deposit, getDeposit, {
        onError (e) {
            if (e) {
                setError(t('status.error.getDepositFailed') + e.message);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/stores/error":"38MVH","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","react-location":"8hNco","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ad5OP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const paymentOptions = {
    CREDIT_DEBIT: 'credit-debit',
    FINANCING: 'financing',
    MIXED: 'mixed',
    SEPA: 'sepa',
    NA: 'N/A'
};
const orderStatus = {
    CLOSED: 'Closed',
    CREATED: 'Created',
    FAILED: 'Failed',
    IN_PROGRESS: 'InProgress',
    PAID: 'Paid'
};
const depositStatus = {
    SUCCEEDED: 'succeeded'
};
const reducerActions = {
    SET_PAYMENT_STATE: 'SET_PAYMENT_STATE'
};
const limit = {
    FAILED_PAYMENT_ATTEMPTS: 3
};
const constants = {
    paymentOptions,
    orderStatus,
    depositStatus,
    reducerActions,
    limit
};
exports.default = constants;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iFuS9":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("70W3O");

},{}],"2gir4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layout = require("Core/components/Layout");
const Main = ({ className = '', children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Container), {
        className: className + ' [min-height: 400px]',
        role: "main",
        children: children
    });
exports.default = Main;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Layout":"hweet","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"f9tIx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _layout = require("Core/components/Layout");
var _appConfig = require("Core/config/appConfig");
var _poweredByStripeSvg = require("url:Images/powered_by_stripe.svg");
var _poweredByStripeSvgDefault = parcelHelpers.interopDefault(_poweredByStripeSvg);
var _logoHearcomPaymentPortalSvg = require("url:Images/logo_hearcom_payment-portal.svg");
var _logoHearcomPaymentPortalSvgDefault = parcelHelpers.interopDefault(_logoHearcomPaymentPortalSvg);
var _logoDeSvg = require("url:Images/logo-de.svg");
var _logoDeSvgDefault = parcelHelpers.interopDefault(_logoDeSvg);
const logos = {
    us: (0, _logoHearcomPaymentPortalSvgDefault.default),
    ca: (0, _logoHearcomPaymentPortalSvgDefault.default),
    de: (0, _logoDeSvgDefault.default),
    nl: (0, _logoDeSvgDefault.default),
    fr: (0, _logoDeSvgDefault.default)
};
const stripeLink = {
    us: 'https://stripe.com/',
    ca: 'https://stripe.com/en-ca',
    de: 'https://stripe.com/de',
    nl: 'https://stripe.com/en-nl',
    fr: 'https://stripe.com/fr'
};
const HeaderBanner = ({ hideStripeLogo = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { country } = (0, _appConfig.getAppConfig)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Container), {
        className: "!mb-0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
            className: "!pt-6 !flex-nowrap justify-between items-end",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                    noFlex: true,
                    className: "!flex-none !grow-0 md:!flex-col-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: logos[country],
                        alt: "Payment Portal Logo",
                        className: "h-7 md:h-[35px] shrink-0"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                    noFlex: true,
                    className: "!flex-1 !min-w-0 md:!flex-col-4 !text-right",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "!text-sm sm:!text-sm md:!text-base lg:!text-xl truncate mb-0",
                        children: t('common.website-claim')
                    })
                }),
                !hideStripeLogo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                    noFlex: true,
                    className: "!flex-none !grow-0 md:!flex-col-4 !pr-4 !flex !justify-end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: stripeLink[country],
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: (0, _poweredByStripeSvgDefault.default),
                            alt: "powered by stripe",
                            className: "h-6 md:h-[28px] shrink-0"
                        })
                    })
                })
            ]
        })
    });
};
exports.default = HeaderBanner;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/components/Layout":"hweet","Core/config/appConfig":"7qX5H","url:Images/powered_by_stripe.svg":"hP6ru","url:Images/logo_hearcom_payment-portal.svg":"4CFlu","url:Images/logo-de.svg":"7KVb1","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hP6ru":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kd7mq");

},{}],"4CFlu":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("aMOPZ");

},{}],"7KVb1":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("2BFe3");

},{}],"33pLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FooterBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
function FooterBanner() {
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "border-t border-gray-300 text-center mx-4 py-8",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "font-bold",
                children: t('common.footer.questions')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-xl",
                children: t('common.footer.phone-number')
            }),
            t('common.footer.availablity-times')
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iqmSx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StickyFooter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
function getTelHref(phoneText) {
    if (!phoneText) return '#';
    const digits = phoneText.replace(/\s/g, '').replace(/[^\d+]/g, '');
    return digits ? `tel:${digits}` : `tel:${phoneText.trim()}`;
}
function StickyFooter() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const phoneNumber = t('common.footer.phone-number');
    const telHref = getTelHref(phoneNumber);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("footer", {
        className: "mt-auto border-t border-gray-200 bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.06)]",
        role: "contentinfo",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "mx-auto max-w-screen-xl px-4 py-4 sm:py-5",
            style: {
                paddingBottom: 'max(1rem, env(safe-area-inset-bottom, 0px))'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col items-center md:gap-10 gap-2 text-center sm:flex-row sm:justify-center sm:gap-8 sm:text-left",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-sm font-medium text-gray-600 sm:text-base",
                        children: t('common.footer.questions')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                        href: telHref,
                        className: "inline-flex items-center gap-1.5 text-base font-bold text-primary underline decoration-2 underline-offset-2 transition-[color,text-decoration-color] hover:text-blue-700 hover:decoration-blue-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded sm:text-lg cursor-pointer",
                        "aria-label": t('common.footer.call') || `Call ${phoneNumber}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                className: "h-5 w-5 shrink-0 text-primary",
                                "aria-hidden": "true",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fillRule: "evenodd",
                                    d: "M2 3.5A1.5 1.5 0 013.5 2h1.148a1.5 1.5 0 011.465 1.175l.716 3.223a1.5 1.5 0 01-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 006.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 011.767-1.052l3.223.716A1.5 1.5 0 0118 15.352V16.5a1.5 1.5 0 01-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 012.43 8.326 13.019 13.019 0 012 5V3.5z",
                                    clipRule: "evenodd"
                                })
                            }),
                            phoneNumber
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-xs font-medium text-gray-600 sm:text-base",
                        children: t('common.footer.availablity-times')
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lOvZn":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("2uMp1"));

},{}],"h17kK":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.load("fTazY").then(()=>module.bundle.root('63YTC'));

},{}],"7oOko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CustomerJourney", ()=>CustomerJourney);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactLocation = require("react-location");
var _reactI18Next = require("react-i18next");
var _useGetTokenInfo = require("Core/hooks/useGetTokenInfo");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _routes = require("Core/routes");
var _journeyConfig = require("Core/config/journeyConfig");
function CustomerJourney() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data: tokenInfo } = (0, _useGetTokenInfo.useGetTokenInfo)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    (0, _react.useEffect)(()=>{
        if (tokenInfo) {
            const { customerJourney } = tokenInfo;
            const path = (0, _journeyConfig.journeyPaths)[customerJourney];
            if (path) return navigate({
                to: path,
                search: true
            });
            setError(t('status.error.invalidCustomerJourney'));
            navigate({
                to: (0, _routes.errorPath),
                search: true
            });
        }
    }, [
        navigate,
        setError,
        t,
        tokenInfo
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading')
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-location":"8hNco","react-i18next":"244ua","Core/hooks/useGetTokenInfo":"l9Smo","Core/stores/error":"38MVH","Core/components/Loader":"6S7S4","Core/routes":"iddMu","Core/config/journeyConfig":"03N5j","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"l9Smo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetTokenInfo", ()=>useGetTokenInfo);
var _reactI18Next = require("react-i18next");
var _reactLocation = require("react-location");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
var _routes = require("Core/routes");
function useGetTokenInfo() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).tokenInfo, ()=>(0, _api.get)('/api/pay-token'), {
        onError (e) {
            if (e) {
                setError(t('status.error.getGetTokenInfoFailed') + e.message);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        }
    });
}

},{"react-i18next":"244ua","react-location":"8hNco","Core/stores/error":"38MVH","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"03N5j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "journeys", ()=>journeys);
parcelHelpers.export(exports, "journeyPaths", ()=>journeyPaths);
var _routes = require("Modules/directSales/routes");
const journeys = {
    directSales: 'USA DS Customer'
};
const journeyPaths = {
    [journeys.directSales]: (0, _routes.directSalesPath)
};

},{"Modules/directSales/routes":"8b3zi","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8b3zi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "directSalesPath", ()=>directSalesPath);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _directSales = require("Modules/directSales/routes/DirectSales");
var _directSalesDefault = parcelHelpers.interopDefault(_directSales);
const directSalesPath = '/journey/direct-sales';
const routes = [
    {
        path: directSalesPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directSalesDefault.default), {})
    }
];

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/directSales/routes/DirectSales":"gD64p","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gD64p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DirectSales);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _paymentHistory = require("Modules/directSales/components/PaymentHistory");
var _directSalesForm = require("Modules/directSales/components/DirectSalesForm");
var _useGetPaymentHistory = require("Core/hooks/queries/payment/useGetPaymentHistory");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _useGetPaymentOptions = require("Modules/directSales/hooks/useGetPaymentOptions");
var _status = require("Core/components/Status");
var _statusDefault = parcelHelpers.interopDefault(_status);
var _usePostCreatePaymentMethods = require("Core/hooks/queries/stripe/usePostCreatePaymentMethods");
var _usePostCreatePaymentMethodsDefault = parcelHelpers.interopDefault(_usePostCreatePaymentMethods);
var _usePostChargeCard = require("Modules/directSales/hooks/usePostChargeCard");
var _usePostChargeCardDefault = parcelHelpers.interopDefault(_usePostChargeCard);
var _useScrollTop = require("Core/hooks/useScrollTop");
var _reactToastify = require("react-toastify");
var _useAddPaymentMethod = require("Core/hooks/queries/payment/useAddPaymentMethod");
var _useAddPaymentMethodDefault = parcelHelpers.interopDefault(_useAddPaymentMethod);
var _useGetSavedPaymentMethods = require("Core/hooks/queries/payment/useGetSavedPaymentMethods");
var _useGetSavedPaymentMethodsDefault = parcelHelpers.interopDefault(_useGetSavedPaymentMethods);
var _logger = require("Core/utils/logger");
var _useGetTokenInfo = require("Core/hooks/useGetTokenInfo");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _journeyConfig = require("Core/config/journeyConfig");
var _reactLocation = require("react-location");
var _routes = require("Core/routes");
function DirectSales() {
    const scroll = (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data: paymentHistory } = (0, _useGetPaymentHistory.useGetPaymentHistory)();
    const { data: savedPaymentMethods } = (0, _useGetSavedPaymentMethodsDefault.default)();
    const { data: paymentOptions } = (0, _useGetPaymentOptions.useGetPaymentOptions)();
    const [cardErrors, setCardErrors] = (0, _reactDefault.default).useState();
    const [status, setStatus] = (0, _reactDefault.default).useState({
        type: '',
        text: ''
    });
    const { mutateAsync: createPaymentMethods } = (0, _usePostCreatePaymentMethodsDefault.default)();
    const { mutateAsync: chargeCard } = (0, _usePostChargeCardDefault.default)();
    const { mutateAsync: addCard } = (0, _useAddPaymentMethodDefault.default)();
    const { data: tokenInfo } = (0, _useGetTokenInfo.useGetTokenInfo)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    (0, _react.useEffect)(()=>{
        if (tokenInfo && (0, _journeyConfig.journeys).directSales !== tokenInfo.customerJourney) {
            setError(t('status.error.invalidCustomerJourney'));
            navigate({
                to: (0, _routes.errorPath),
                search: true
            });
        }
    }, [
        navigate,
        setError,
        t,
        tokenInfo
    ]);
    async function onSubmit(formData, event) {
        scroll.top();
        let paymentMethods;
        setStatus({
            type: 'loading',
            text: t('status.loading.submitPaymentInformation')
        });
        if (!formData.paymentMethodId) {
            const paymentMethodData = [
                {
                    cardId: 'card0',
                    amount: formData.amount,
                    stripeElement: formData.stripeElement,
                    billingDetails: {
                        name: `${formData.firstName} ${formData.lastName}`,
                        address: {
                            postal_code: formData.postalCode
                        }
                    }
                }
            ];
            if (!formData.stripe) return setStatus({
                type: 'error',
                text: t('status.error.paymentGatewayInitialize')
            });
            try {
                paymentMethods = await createPaymentMethods({
                    stripe: formData.stripe,
                    data: paymentMethodData
                });
            } catch  {
                setStatus({
                    type: 'error',
                    text: t('status.error.failedToCreatePaymentMethods')
                });
                return;
            }
        }
        const paymentMethodId = formData.paymentMethodId || paymentMethods[0].paymentMethodId;
        try {
            await chargeCard({
                paymentMethods: [
                    {
                        amount: formData.amount,
                        paymentMethodId,
                        type: formData.type
                    }
                ]
            });
            await addCard({
                paymentMethodId,
                preferred: true
            });
            //sale for this token is complete. lets log it
            const shouldLog = paymentHistory.receipts.length === 0 ? formData.type === 'capture' : true;
            if (shouldLog) (0, _logger.postLogMessage)({
                feature: (0, _logger.features).directSales,
                status: 'success'
            });
            event.target.reset();
            setStatus({
                type: 'success'
            });
            (0, _reactToastify.toast).success(t('status.success.paymentProcessed'));
        } catch (error) {
            const detailedErrorMessage = error?.response?.data?.message || t('status.error.failedToChargeCard');
            setStatus({
                type: 'error',
                text: detailedErrorMessage
            });
            if (error?.response?.data?.hasOwnProperty('errors')) setCardErrors(error.response.data.errors);
        }
    }
    if (!paymentHistory || !savedPaymentMethods || !paymentOptions) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading')
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.directSales.header'),
        withStepProgress: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusDefault.default), {
                ...status
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentHistory.PaymentHistory), {
                history: paymentHistory.receipts
            }),
            paymentOptions.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directSalesForm.DirectSalesForm), {
                paymentMethods: savedPaymentMethods,
                paymentOptions: paymentOptions,
                onSubmit: onSubmit,
                cardErrors: cardErrors
            }) : null
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/components/Page":"4xeqH","Modules/directSales/components/PaymentHistory":"dQQ1M","Modules/directSales/components/DirectSalesForm":"9SXLD","Core/hooks/queries/payment/useGetPaymentHistory":"ei4DZ","Core/components/Loader":"6S7S4","Modules/directSales/hooks/useGetPaymentOptions":"7oC8m","Core/components/Status":"5UE3N","Core/hooks/queries/stripe/usePostCreatePaymentMethods":"gEPFe","Modules/directSales/hooks/usePostChargeCard":"aEYQs","Core/hooks/useScrollTop":"cBwQW","react-toastify":"8eTVO","Core/hooks/queries/payment/useAddPaymentMethod":"dPWUT","Core/hooks/queries/payment/useGetSavedPaymentMethods":"bIUV0","Core/utils/logger":"cWDKQ","Core/hooks/useGetTokenInfo":"l9Smo","Core/stores/error":"38MVH","Core/config/journeyConfig":"03N5j","react-location":"8hNco","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dQQ1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _paymentHistory = require("./PaymentHistory");
parcelHelpers.exportAll(_paymentHistory, exports);

},{"./PaymentHistory":"ivswi","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ivswi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentHistory", ()=>PaymentHistory);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _creditCardLogos = require("Core/components/CreditCardLogos");
var _creditCardLogosDefault = parcelHelpers.interopDefault(_creditCardLogos);
var _reactI18Next = require("react-i18next");
var _numberFormat = require("Core/utils/numberFormat");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function PaymentHistory({ history }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    return history.length === 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mb-12",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: t('directSales.history.header')
            }),
            history.map((transaction)=>{
                const { paymentId, txnType, amount, transactionDate, card: { brand, last4 }, url: receiptUrl } = transaction;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "bg-white border border-solid border-gray-300 rounded mb-2 p-3 shadow gap-y-3 flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center  gap-x-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-32 flex",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _classnamesDefault.default)('border border-solid rounded-xl px-4 py-1 text-white font-bold text-lg', {
                                            'bg-green-300 border-green-300': txnType.toLowerCase() === 'capture',
                                            'bg-yellow-300 border-yellow-300': txnType.toLowerCase() !== 'capture'
                                        }),
                                        children: t(`common.${txnType.toLowerCase()}`)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-2xl",
                                    children: (0, _numberFormat.formatCurrency)(amount, {
                                        withDecimals: false
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center ml-4 font-bold",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creditCardLogosDefault.default), {
                                            brand: brand,
                                            size: "medium",
                                            className: "mr-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                "**** ",
                                                last4
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: transactionDate
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: receiptUrl,
                                    className: "text-lg underline",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: t('common.viewReceipt')
                                })
                            ]
                        })
                    ]
                }, paymentId);
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/CreditCardLogos":"dnezw","react-i18next":"244ua","Core/utils/numberFormat":"6T56F","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9SXLD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectSalesForm", ()=>DirectSalesForm);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _utils = require("Core/utils/utils");
var _styledFormGroup = require("Core/components/FormElements/StyledFormGroup");
var _styledFormGroupDefault = parcelHelpers.interopDefault(_styledFormGroup);
var _cardSelector = require("Core/components/CardSelector");
var _cardSelectorDefault = parcelHelpers.interopDefault(_cardSelector);
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _layout = require("Core/components/Layout");
var _button = require("Core/components/Button");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _alert = require("Core/components/Alert");
var _numberFormat = require("Core/utils/numberFormat");
var _option = require("Core/components/Option/Option");
var _optionDefault = parcelHelpers.interopDefault(_option);
var _useDirectSalesForm = require("Modules/directSales/hooks/useDirectSalesForm");
var _useDirectSalesFormDefault = parcelHelpers.interopDefault(_useDirectSalesForm);
const Options = ({ options, form })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { register, getValues, setValue } = form;
    const { type } = form.getValues();
    // Manually set value in case there is only 1 option
    (0, _reactDefault.default).useEffect(()=>{
        if (options.length === 1) {
            const [{ amount }] = options;
            setValue('amount', amount);
        }
        //Need to set manually for initial render to register the field
        setValue('type', type);
    }, [
        type,
        options,
        setValue
    ]);
    if (options.length === 1) {
        const [{ type, amount }] = options;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
            className: `text-base font-bold`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                i18nKey: `deposit.${type}`,
                values: {
                    amount: (0, _numberFormat.formatCurrency)(amount, {
                        withDecimals: false
                    })
                }
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mt-8",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: t('common:depositAmount')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
                "data-testid": "deposit-card-option-container",
                children: options.map(({ option, amount, type })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "md:flex-col-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionDefault.default), {
                            className: "deposit-option",
                            register: register,
                            name: "amount",
                            value: amount,
                            defaultChecked: getValues().amount === amount,
                            onChange: ()=>setValue('type', type),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-4xl font-bold",
                                        children: (0, _numberFormat.formatCurrency)(amount, {
                                            withDecimals: false
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-xl font-bold",
                                        children: t(`common.${type}`)
                                    })
                                ]
                            })
                        })
                    }, option))
            })
        ]
    });
};
function DirectSalesForm({ paymentMethods, paymentOptions, onSubmit, cardErrors }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { paymentMethodId } = (0, _utils.getPreferredPaymentMethod)(paymentMethods);
    const [{ type, amount }] = paymentOptions;
    const defaultValues = (0, _reactDefault.default).useMemo(()=>paymentMethodId ? {
            paymentMethodId,
            type,
            amount,
            terms: false
        } : {
            firstName: '',
            lastName: '',
            postalCode: '',
            cardNumber: '',
            cardExpiry: '',
            cardCvc: '',
            type,
            amount,
            terms: false
        }, [
        amount,
        paymentMethodId,
        type
    ]);
    const form = (0, _useDirectSalesFormDefault.default)(defaultValues);
    const { watch, handleSubmit, register, reset, formState: { errors, isSubmitSuccessful } } = form;
    (0, _reactDefault.default).useEffect(()=>{
        if (isSubmitSuccessful) reset(defaultValues);
    }, [
        defaultValues,
        isSubmitSuccessful,
        reset
    ]);
    const cardError = cardErrors?.[0].message;
    const termsTextId = watch('type') === 'authorize' ? 'terms.card.hold' : 'terms.card.charge';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        name: "directSales",
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledFormGroupDefault.default), {
                error: cardError,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardSelectorDefault.default), {
                    cardError: cardError,
                    form: form,
                    paymentMethods: paymentMethods
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Options, {
                options: paymentOptions,
                form: form
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _termsInputDefault.default), {
                name: "terms",
                register: register,
                errors: errors,
                label: t('common.termsAndConditions'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: t(termsTextId)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
                className: "justify-end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                    className: "flex-col-6 md:flex-col-4 lg:flex-col-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                        block: true,
                        type: "submit",
                        "data-testid": "checkout",
                        children: t('common.checkout')
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"Core/utils/utils":"hwOBZ","Core/components/FormElements/StyledFormGroup":"6lnq9","Core/components/CardSelector":"4d8Tr","Core/components/FormElements/TermsInput":"2LJBE","Core/components/Layout/Row":"8YqFQ","Core/components/Layout":"hweet","Core/components/Button":"6YNzH","react":"2o0ib","Core/components/Alert":"fmmNR","Core/utils/numberFormat":"6T56F","Core/components/Option/Option":"7niNe","Modules/directSales/hooks/useDirectSalesForm":"3T4IY","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3T4IY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDirectSalesForm);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _v3 = require("zod/v3");
var _reactHookForm = require("react-hook-form");
var _zod = require("@hookform/resolvers/zod");
var _reactI18Next = require("react-i18next");
function useDirectSalesForm(defaultValues) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.union([
            _v3.object({
                firstName: _v3.string().nonempty({
                    message: t('common.requiredFieldFirstName')
                }),
                lastName: _v3.string().nonempty({
                    message: t('common.requiredFieldLastName')
                }),
                postalCode: _v3.string().nonempty({
                    message: t('common.requiredFieldPostalCode')
                }),
                cardNumber: _v3.any().refine((value)=>Boolean(value), {
                    message: t('common.requiredFieldCardNumber')
                }),
                cardExpiry: _v3.any().refine((value)=>Boolean(value), {
                    message: t('common.requiredFieldCardExpiry')
                }),
                cardCvc: _v3.any().refine((value)=>Boolean(value), {
                    message: t('common.requiredFieldCardCode')
                }),
                amount: _v3.string(),
                type: _v3.string(),
                terms: _v3.boolean().refine((val)=>val, {
                    message: t('common.requiredFieldTerms')
                }),
                stripeElement: _v3.any(),
                stripe: _v3.any()
            }),
            _v3.object({
                paymentMethodId: _v3.string().nonempty({
                    message: t('common.requiredFieldFirstName')
                }),
                amount: _v3.string(),
                type: _v3.string(),
                terms: _v3.boolean().refine((val)=>val, {
                    message: t('common.requiredFieldTerms')
                })
            })
        ]);
    }, [
        t
    ]);
    return (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        defaultValues,
        shouldUnregister: true
    });
}

},{"react":"2o0ib","zod/v3":"kXNSc","react-hook-form":"53GLT","@hookform/resolvers/zod":"c0M5u","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ei4DZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetPaymentHistory", ()=>useGetPaymentHistory);
var _reactI18Next = require("react-i18next");
var _reactLocation = require("react-location");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
var _routes = require("Core/routes");
function useGetPaymentHistory() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).paymentHistory, ()=>(0, _api.get)('/api/payments/receipts'), {
        onError (e) {
            if (e) {
                setError(t('status.error.getPaymentHistoryFailed') + e.message);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        }
    });
}

},{"react-i18next":"244ua","react-location":"8hNco","Core/stores/error":"38MVH","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7oC8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetPaymentOptions", ()=>useGetPaymentOptions);
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
var _reactLocation = require("react-location");
var _routes = require("Core/routes");
function useGetPaymentOptions() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).directSalesPaymentOptions, ()=>(0, _api.get)('/api/pay-options'), {
        onError (e) {
            if (e) {
                setError(t('status.error.getPaymentOptionsQueryFailed') + e.message);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        }
    });
}

},{"react-i18next":"244ua","Core/stores/error":"38MVH","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","react-location":"8hNco","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aEYQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePostChargeCard);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
function usePostChargeCard() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>(0, _api.post)(`/api/pay`, payload), {
        throwOnError: true,
        onSuccess: ()=>{
            return Promise.all([
                queryClient.invalidateQueries((0, _cacheKeysDefault.default).directSalesPaymentOptions),
                queryClient.invalidateQueries((0, _cacheKeysDefault.default).paymentHistory)
            ]);
        }
    });
}

},{"react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7qFMD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Platform", ()=>Platform);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _reactI18Next = require("react-i18next");
var _platformConfig = require("Core/config/platformConfig");
var _reactLocation = require("react-location");
function Platform() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { data: { purpose, provider, payment_option } = {} } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    (0, _react.useEffect)(()=>{
        // const to = platformPaths.FINANCING_FORTIVA;
        // navigate({ to, search: true });
        if (purpose) {
            let to = (0, _platformConfig.platformPaths)[purpose];
            if (payment_option && payment_option.toUpperCase() === 'GLOBAL') to = (0, _platformConfig.platformPaths).FINANCING_LENDFLOW;
            else if (provider && provider.toLowerCase() === 'patientfi') to = (0, _platformConfig.platformPaths).FINANCING_PATIENTFI;
            else if (provider && provider.toLowerCase() === 'fortiva') to = (0, _platformConfig.platformPaths).FINANCING_FORTIVA;
            navigate({
                to,
                search: true
            });
        }
    }, [
        navigate,
        purpose,
        provider,
        payment_option
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading')
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Core/components/Loader":"6S7S4","react-i18next":"244ua","Core/config/platformConfig":"990BT","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aXmHV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetPaymentInfo", ()=>useGetPaymentInfo);
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactLocation = require("react-location");
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _platformApi = require("Core/utils/platformApi");
var _routes = require("Core/routes");
function useGetPaymentInfo() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).paymentInfo, async ()=>await (0, _platformApi.get)('/payment/info') ?? {}, {
        onError (e) {
            if (e) {
                setError(t('status.error.getPaymentInfoFailed') + ` - (${e.message})`);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        }
    });
}

},{"react-i18next":"244ua","Core/stores/error":"38MVH","react-location":"8hNco","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/platformApi":"9RrWs","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9RrWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "getWithHeaders", ()=>getWithHeaders);
parcelHelpers.export(exports, "post", ()=>post);
parcelHelpers.export(exports, "postWithHeaders", ()=>postWithHeaders);
parcelHelpers.export(exports, "put", ()=>put);
parcelHelpers.export(exports, "putWithHeaders", ()=>putWithHeaders) //
 // export function del(url, payload, config) {
 //   return axiosInstance.delete(url, payload, config).then(({ data }) => data);
 // }
;
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _utils = require("Core/utils/utils");
const axiosInstance = (0, _axiosDefault.default).create({
    baseURL: "https://payment-api-gateway.shared-testing.audibene.net/api/v1",
    headers: {
        web_code: (0, _utils.getUrlParam)('web-code'),
        payment_id: (0, _utils.getUrlParam)('payment-id')
    }
});
function get(url, config, validatorFunction) {
    return axiosInstance.get(url, config).then(({ data })=>{
        if (!validatorFunction || validatorFunction(data)) return data;
    // throw new Error('empty data');
    }).catch((err)=>{
        console.error('[platformApi.get]', url, err?.message || err);
        return null;
    });
}
function getWithHeaders(url, config) {
    return axiosInstance.get(url, config).then((resp)=>resp);
}
function post(url, payload, config) {
    return axiosInstance.post(url, payload, config).then(({ data })=>data);
}
function postWithHeaders(url, payload, config) {
    return axiosInstance.post(url, payload, config).then((resp)=>resp);
}
function put(url, payload, config) {
    return axiosInstance.put(url, payload, config).then(({ data })=>data);
}
function putWithHeaders(url, payload, config) {
    return axiosInstance.put(url, payload, config).then((resp)=>resp);
}

},{"axios":"dma8U","Core/utils/utils":"hwOBZ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"990BT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "platformPaths", ()=>platformPaths);
var _routes = require("Modules/cardPayment/routes");
var _routes1 = require("Modules/financing/routes");
var _routes2 = require("Modules/patientfi/routes");
var _routes3 = require("Modules/fortiva/routes");
var _routes4 = require("Modules/lendFlow/routes");
const platformPaths = {
    DEPOSIT: (0, _routes.depositPath),
    ADD_CARD: (0, _routes.cardPreferenceCenterPath),
    PAYMENT: (0, _routes.paymentPath),
    FINANCING: (0, _routes1.createFinancingPath),
    FINANCING_PATIENTFI: (0, _routes2.createFinancingPath),
    FINANCING_FORTIVA: (0, _routes3.createFinancingPath),
    FINANCING_LENDFLOW: (0, _routes4.lendFlowHomePath)
};

},{"Modules/cardPayment/routes":"kPsar","Modules/financing/routes":"5ZPtj","Modules/patientfi/routes":"lyzU7","Modules/fortiva/routes":"6CCT1","Modules/lendFlow/routes":"epDqx","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kPsar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "depositPath", ()=>depositPath);
parcelHelpers.export(exports, "cardPreferenceCenterPath", ()=>cardPreferenceCenterPath);
parcelHelpers.export(exports, "paymentPath", ()=>paymentPath);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _deposit = require("Modules/cardPayment/routes/Deposit");
var _cardPreferenceCenter = require("Modules/cardPayment/routes/CardPreferenceCenter");
var _payment = require("Modules/cardPayment/routes/Payment");
const depositPath = '/card-payment/deposit';
const cardPreferenceCenterPath = '/card-payment/cards';
const paymentPath = '/card-payment/payment';
const routes = [
    {
        path: depositPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deposit.Deposit), {})
    },
    {
        path: cardPreferenceCenterPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardPreferenceCenter.CardPreferenceCenter), {})
    },
    {
        path: paymentPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _payment.Payment), {
            paymentType: "payment"
        })
    }
];

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/cardPayment/routes/Deposit":"6yTDM","Modules/cardPayment/routes/CardPreferenceCenter":"52brD","Modules/cardPayment/routes/Payment":"gn9UA","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6yTDM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Deposit", ()=>Deposit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _reactI18Next = require("react-i18next");
var _useGetTransactionHistory = require("Core/hooks/platform/useGetTransactionHistory");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _transactionHistory = require("Modules/cardPayment/components/TransactionHistory");
var _useGetSavedCards = require("Core/hooks/platform/useGetSavedCards");
var _depositCardForm = require("Modules/cardPayment/components/DepositCardForm");
var _depositCardFormDefault = parcelHelpers.interopDefault(_depositCardForm);
var _status = require("Core/components/Status");
var _statusDefault = parcelHelpers.interopDefault(_status);
var _usePostCreatePaymentMethods = require("Core/hooks/queries/stripe/usePostCreatePaymentMethods");
var _usePostCreatePaymentMethodsDefault = parcelHelpers.interopDefault(_usePostCreatePaymentMethods);
var _usePostCharge = require("Core/hooks/platform/usePostCharge");
var _usePostChargeDefault = parcelHelpers.interopDefault(_usePostCharge);
var _reactToastify = require("react-toastify");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _useGetLatestTransaction = require("Core/hooks/platform/useGetLatestTransaction");
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _logger = require("Core/utils/logger");
var _utils = require("Core/utils/utils");
let depositOptions = [
    {
        option: '98usd',
        type: 'HOLD',
        amount: 98
    }
];
function Deposit() {
    const scroll = (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const { data: transactionHistory } = (0, _useGetTransactionHistory.useGetTransactionHistory)();
    const { data: latestTransaction } = (0, _useGetLatestTransaction.useGetLatestTransaction)(requestId);
    const { data: savedCards } = (0, _useGetSavedCards.useGetSavedCards)();
    const { mutateAsync: createPaymentMethods } = (0, _usePostCreatePaymentMethodsDefault.default)();
    const { mutateAsync: chargeCard } = (0, _usePostChargeDefault.default)();
    const [cardErrors, setCardErrors] = (0, _reactDefault.default).useState([]);
    const [status, setStatus] = (0, _reactDefault.default).useState({
        type: '',
        text: ''
    });
    const queryClient = (0, _reactQuery.useQueryClient)();
    const paymentId = (0, _utils.getUrlParam)('payment-id');
    const isJourneyOtc = typeof window !== 'undefined' && (0, _utils.getUrlParam)('journey') === 'otc';
    const isJourneyTaLight = typeof window !== 'undefined' && (0, _utils.getUrlParam)('journey') === 'ta-light';
    if (isJourneyOtc) depositOptions = [
        {
            option: '29usd',
            type: 'HOLD',
            amount: 29
        }
    ];
    if (isJourneyTaLight) depositOptions = [
        {
            option: '59usd',
            type: 'HOLD',
            amount: 59
        }
    ];
    (0, _reactDefault.default).useEffect(()=>{
        if (latestTransaction?.length) {
            const [{ status: txnStatus, error_message, payment_method_id, amount }] = latestTransaction;
            if ([
                'AUTHORIZED',
                'PAID'
            ].includes(txnStatus)) {
                setStatus({
                    type: 'success'
                });
                (0, _reactToastify.toast).success(t('status.success.paymentProcessed'));
                queryClient.invalidateQueries((0, _cacheKeysDefault.default).transactionHistory);
                (0, _logger.postLogMessage)({
                    amount,
                    feature: (0, _logger.features).platformDeposit,
                    status: 'success'
                });
            } else {
                setStatus({
                    type: 'error',
                    text: t('status.error.failedToChargeCard')
                });
                setCardErrors([
                    {
                        message: error_message,
                        paymentMethodId: payment_method_id
                    }
                ]);
            }
            setRequestId('');
        }
    }, [
        latestTransaction,
        queryClient,
        t
    ]);
    async function onSubmit(formData) {
        scroll.top();
        let paymentMethods;
        setStatus({
            type: 'loading',
            text: t('status.loading.submitPaymentInformation')
        });
        setCardErrors([]);
        if (!formData.paymentMethodId) {
            const paymentMethodData = [
                {
                    cardId: 'card0',
                    amount: formData.amount,
                    stripeElement: formData.stripeElement,
                    billingDetails: {
                        name: `${formData.firstName} ${formData.lastName}`,
                        address: {
                            postal_code: formData.postalCode
                        }
                    }
                }
            ];
            if (!formData.stripe) return setStatus({
                type: 'error',
                text: t('status.error.paymentGatewayInitialize')
            });
            try {
                paymentMethods = await createPaymentMethods({
                    stripe: formData.stripe,
                    data: paymentMethodData
                });
            } catch  {
                setStatus({
                    type: 'error',
                    text: t('status.error.failedToCreatePaymentMethods')
                });
                return;
            }
        }
        const paymentMethodId = formData.paymentMethodId || paymentMethods[0].paymentMethodId;
        try {
            const { request_id } = await chargeCard({
                receipt_email: formData.email,
                payments: {
                    card_payment: [
                        {
                            amount: formData.amount,
                            payment_method_id: paymentMethodId,
                            card_action: formData.type
                        }
                    ]
                }
            });
            setRequestId(request_id);
        } catch (error) {
            const detailedErrorMessage = error?.message || t('status.error.failedToChargeCard');
            setStatus({
                type: 'error',
                text: detailedErrorMessage
            });
        }
    }
    if (!transactionHistory || !savedCards) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading')
    });
    const shouldShowForm = !transactionHistory.find(({ payment_id })=>payment_id === paymentId);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.deposit.checkout.header'),
        withStepProgress: false,
        showStripeLogo: true,
        stickyFooter: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusDefault.default), {
                ...status
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionHistory.TransactionHistory), {
                transactions: transactionHistory
            }),
            shouldShowForm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _depositCardFormDefault.default), {
                paymentMethods: savedCards,
                depositOptions: depositOptions,
                onSubmit: onSubmit,
                cardErrors: cardErrors
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Page":"4xeqH","react-i18next":"244ua","Core/hooks/platform/useGetTransactionHistory":"3gwu1","Core/components/Loader":"6S7S4","Modules/cardPayment/components/TransactionHistory":"8szdg","Core/hooks/platform/useGetSavedCards":"cr4b9","Modules/cardPayment/components/DepositCardForm":"6ZSZo","Core/components/Status":"5UE3N","Core/hooks/queries/stripe/usePostCreatePaymentMethods":"gEPFe","Core/hooks/platform/usePostCharge":"3bQTU","react-toastify":"8eTVO","Core/hooks/useScrollTop":"cBwQW","Core/hooks/platform/useGetLatestTransaction":"3NXlw","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/logger":"cWDKQ","Core/utils/utils":"hwOBZ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3gwu1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetTransactionHistory", ()=>useGetTransactionHistory);
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactLocation = require("react-location");
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _platformApi = require("Core/utils/platformApi");
var _routes = require("Core/routes");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function useGetTransactionHistory() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).transactionHistory, ()=>(0, _platformApi.get)('/transaction/history', {
            headers: {
                external_reference_id: paymentInfo.external_reference_id
            }
        }), {
        enabled: Boolean(paymentInfo),
        select (data) {
            return data.filter(({ status })=>[
                    'AUTHORIZED',
                    'PAID'
                ].includes(status));
        },
        onError (e) {
            if (e) {
                setError(t('status.error.getTransactionHistoryFailed') + ` - (${e.message})`);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        }
    });
}

},{"react-i18next":"244ua","Core/stores/error":"38MVH","react-location":"8hNco","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/platformApi":"9RrWs","Core/routes":"iddMu","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8szdg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionHistory", ()=>TransactionHistory);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dateFns = require("date-fns");
var _hi = require("react-icons/hi");
var _fa = require("react-icons/fa");
var _numberFormat = require("Core/utils/numberFormat");
var _creditCardLogos = require("Core/components/CreditCardLogos");
var _creditCardLogosDefault = parcelHelpers.interopDefault(_creditCardLogos);
function formatTransactionDateTime(createdAt) {
    if (createdAt === undefined || createdAt === null) return '';
    // Unix timestamp in seconds (e.g. 1770122250.210639) – convert to milliseconds
    const seconds = typeof createdAt === 'string' ? parseFloat(createdAt, 10) : Number(createdAt);
    const date = new Date(seconds * 1000);
    return (0, _dateFns.isValid)(date) ? (0, _dateFns.format)(date, "MMM d, yyyy 'at' h:mm a") : '';
}
function TransactionHistory({ transactions }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    return transactions.length === 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mb-8",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-3 mb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-2 rounded-lg bg-gray-100",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi.HiOutlineClock), {
                            className: "w-5 h-5 text-gray-600"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "text-lg font-semibold text-gray-900 m-0",
                        children: t('directSales.history.header')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "px-2.5 py-0.5 bg-gray-100 text-gray-600 text-sm font-medium rounded-full",
                        children: transactions.length
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "space-y-3",
                children: transactions.map((transaction)=>{
                    const { created_at, card_action, amount, brand, last4digits, receipt: { url: receiptUrl } } = transaction;
                    const formattedDateTime = formatTransactionDateTime(created_at);
                    const hasDecimals = !Number.isSafeInteger(amount);
                    const isCapture = card_action.toLowerCase() === 'capture';
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "p-4 md:p-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col sm:flex-row sm:items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row items-center gap-3 sm:gap-4 flex-1 min-w-0 md:justify-start justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-shrink-0",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: (0, _classnamesDefault.default)('inline-flex items-center px-3 py-1.5 rounded-full text-sm font-semibold', {
                                                            'bg-green-100 text-green-800 border border-green-200': isCapture,
                                                            'bg-amber-100 text-amber-800 border border-amber-200': !isCapture
                                                        }),
                                                        children: [
                                                            isCapture && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaCheck), {
                                                                className: "w-4 h-4 mr-1.5 flex-shrink-0"
                                                            }),
                                                            t(`common.${card_action.toLowerCase()}`)
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "min-w-0",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-2xl sm:text-3xl font-bold text-gray-900",
                                                        children: (0, _numberFormat.formatCurrency)(amount, {
                                                            withDecimals: hasDecimals
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-3 px-4 py-2.5 bg-gray-50 rounded-lg border border-gray-100",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creditCardLogosDefault.default), {
                                                    brand: brand,
                                                    size: "medium"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "text-xs text-gray-500 font-medium",
                                                            children: "Card ending in"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "font-semibold text-gray-900",
                                                            children: [
                                                                "\u2022\u2022\u2022\u2022 ",
                                                                last4digits
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "px-4 sm:px-5 py-3 bg-gray-50/70 border-t border-gray-100 flex flex-wrap items-center justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2 text-sm text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi.HiOutlineCalendar), {
                                                className: "w-4 h-4 flex-shrink-0"
                                            }),
                                            formattedDateTime
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                        href: receiptUrl,
                                        className: "inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:text-blue-700 transition-colors group",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi.HiOutlineDocumentText), {
                                                className: "w-4 h-4 flex-shrink-0"
                                            }),
                                            t('common.viewReceipt'),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi.HiOutlineChevronRight), {
                                                className: "w-3 h-3 transition-transform group-hover:translate-x-0.5 flex-shrink-0"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, created_at);
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","classnames":"f971Y","date-fns":[["format","7JNRj","default"],["isValid","jCEss","default"]],"react-icons/hi":"3dH5y","react-icons/fa":"9Vrsi","Core/utils/numberFormat":"6T56F","Core/components/CreditCardLogos":"dnezw","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7JNRj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"jCEss","../subMilliseconds/index.js":"gP0hg","../toDate/index.js":"iBeGL","../_lib/format/formatters/index.js":"NoWvu","../_lib/format/longFormatters/index.js":"9x58N","../_lib/getTimezoneOffsetInMilliseconds/index.js":"e12CY","../_lib/protectedTokens/index.js":"66sVP","../_lib/toInteger/index.js":"5Ujd6","../_lib/requiredArgs/index.js":"hVUyW","../_lib/defaultOptions/index.js":"fRx4S","../_lib/defaultLocale/index.js":"c7LK3","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jCEss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isValid);
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"h7Xkm","../toDate/index.js":"iBeGL","../_lib/requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h7Xkm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || (0, _typeofDefault.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

},{"@babel/runtime/helpers/esm/typeof":"h3CKR","../_lib/requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h3CKR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hVUyW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requiredArgs);
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iBeGL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"h3CKR","../_lib/requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gP0hg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMilliseconds);
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"4fFEh","../_lib/requiredArgs/index.js":"hVUyW","../_lib/toInteger/index.js":"5Ujd6","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4fFEh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMilliseconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"5Ujd6","../toDate/index.js":"iBeGL","../_lib/requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5Ujd6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toInteger);
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"NoWvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date);
        // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"5P2uP","../../../_lib/getUTCISOWeek/index.js":"keO4O","../../../_lib/getUTCISOWeekYear/index.js":"97Wkb","../../../_lib/getUTCWeek/index.js":"kc4VQ","../../../_lib/getUTCWeekYear/index.js":"hND6b","../../addLeadingZeros/index.js":"kMemg","../lightFormatters/index.js":"bG5MM","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5P2uP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCDayOfYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"iBeGL","../requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"keO4O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"iBeGL","../startOfUTCISOWeek/index.js":"h0KAw","../startOfUTCISOWeekYear/index.js":"3GYmD","../requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h0KAw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"iBeGL","../requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3GYmD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeekYear);
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"97Wkb","../startOfUTCISOWeek/index.js":"h0KAw","../requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"97Wkb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"iBeGL","../requiredArgs/index.js":"hVUyW","../startOfUTCISOWeek/index.js":"h0KAw","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kc4VQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"iBeGL","../startOfUTCWeek/index.js":"6qgUB","../startOfUTCWeekYear/index.js":"jxTq1","../requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6qgUB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"iBeGL","../requiredArgs/index.js":"hVUyW","../toInteger/index.js":"5Ujd6","../defaultOptions/index.js":"fRx4S","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fRx4S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jxTq1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeekYear);
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"hND6b","../requiredArgs/index.js":"hVUyW","../startOfUTCWeek/index.js":"6qgUB","../toInteger/index.js":"5Ujd6","../defaultOptions/index.js":"fRx4S","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hND6b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"iBeGL","../requiredArgs/index.js":"hVUyW","../startOfUTCWeek/index.js":"6qgUB","../toInteger/index.js":"5Ujd6","../defaultOptions/index.js":"fRx4S","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kMemg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bG5MM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"kMemg","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9x58N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"e12CY":[function(require,module,exports,__globalThis) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"66sVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "throwProtectedError", ()=>throwProtectedError);
var protectedDayOfYearTokens = [
    'D',
    'DD'
];
var protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"c7LK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"3WMbN","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3WMbN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'en-US',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"gf7TP","./_lib/formatLong/index.js":"j8nc8","./_lib/formatRelative/index.js":"ks7nh","./_lib/localize/index.js":"4CH5d","./_lib/match/index.js":"5bqqe","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gf7TP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"j8nc8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"gMlQF","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gMlQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ks7nh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4CH5d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"dDCea","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dDCea":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5bqqe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"ikJg6","../../../_lib/buildMatchPatternFn/index.js":"5v6b5","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ikJg6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchFn);
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5v6b5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3dH5y":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HiZoomOut", ()=>HiZoomOut);
parcelHelpers.export(exports, "HiZoomIn", ()=>HiZoomIn);
parcelHelpers.export(exports, "HiX", ()=>HiX);
parcelHelpers.export(exports, "HiXCircle", ()=>HiXCircle);
parcelHelpers.export(exports, "HiWifi", ()=>HiWifi);
parcelHelpers.export(exports, "HiVolumeUp", ()=>HiVolumeUp);
parcelHelpers.export(exports, "HiVolumeOff", ()=>HiVolumeOff);
parcelHelpers.export(exports, "HiViewList", ()=>HiViewList);
parcelHelpers.export(exports, "HiViewGrid", ()=>HiViewGrid);
parcelHelpers.export(exports, "HiViewGridAdd", ()=>HiViewGridAdd);
parcelHelpers.export(exports, "HiViewBoards", ()=>HiViewBoards);
parcelHelpers.export(exports, "HiVideoCamera", ()=>HiVideoCamera);
parcelHelpers.export(exports, "HiVariable", ()=>HiVariable);
parcelHelpers.export(exports, "HiUsers", ()=>HiUsers);
parcelHelpers.export(exports, "HiUser", ()=>HiUser);
parcelHelpers.export(exports, "HiUserRemove", ()=>HiUserRemove);
parcelHelpers.export(exports, "HiUserGroup", ()=>HiUserGroup);
parcelHelpers.export(exports, "HiUserCircle", ()=>HiUserCircle);
parcelHelpers.export(exports, "HiUserAdd", ()=>HiUserAdd);
parcelHelpers.export(exports, "HiUpload", ()=>HiUpload);
parcelHelpers.export(exports, "HiTruck", ()=>HiTruck);
parcelHelpers.export(exports, "HiTrendingUp", ()=>HiTrendingUp);
parcelHelpers.export(exports, "HiTrendingDown", ()=>HiTrendingDown);
parcelHelpers.export(exports, "HiTrash", ()=>HiTrash);
parcelHelpers.export(exports, "HiTranslate", ()=>HiTranslate);
parcelHelpers.export(exports, "HiTicket", ()=>HiTicket);
parcelHelpers.export(exports, "HiThumbUp", ()=>HiThumbUp);
parcelHelpers.export(exports, "HiThumbDown", ()=>HiThumbDown);
parcelHelpers.export(exports, "HiTerminal", ()=>HiTerminal);
parcelHelpers.export(exports, "HiTemplate", ()=>HiTemplate);
parcelHelpers.export(exports, "HiTag", ()=>HiTag);
parcelHelpers.export(exports, "HiTable", ()=>HiTable);
parcelHelpers.export(exports, "HiSwitchVertical", ()=>HiSwitchVertical);
parcelHelpers.export(exports, "HiSwitchHorizontal", ()=>HiSwitchHorizontal);
parcelHelpers.export(exports, "HiSupport", ()=>HiSupport);
parcelHelpers.export(exports, "HiSun", ()=>HiSun);
parcelHelpers.export(exports, "HiStop", ()=>HiStop);
parcelHelpers.export(exports, "HiStatusOnline", ()=>HiStatusOnline);
parcelHelpers.export(exports, "HiStatusOffline", ()=>HiStatusOffline);
parcelHelpers.export(exports, "HiStar", ()=>HiStar);
parcelHelpers.export(exports, "HiSpeakerphone", ()=>HiSpeakerphone);
parcelHelpers.export(exports, "HiSparkles", ()=>HiSparkles);
parcelHelpers.export(exports, "HiSortDescending", ()=>HiSortDescending);
parcelHelpers.export(exports, "HiSortAscending", ()=>HiSortAscending);
parcelHelpers.export(exports, "HiShoppingCart", ()=>HiShoppingCart);
parcelHelpers.export(exports, "HiShoppingBag", ()=>HiShoppingBag);
parcelHelpers.export(exports, "HiShieldExclamation", ()=>HiShieldExclamation);
parcelHelpers.export(exports, "HiShieldCheck", ()=>HiShieldCheck);
parcelHelpers.export(exports, "HiShare", ()=>HiShare);
parcelHelpers.export(exports, "HiServer", ()=>HiServer);
parcelHelpers.export(exports, "HiSelector", ()=>HiSelector);
parcelHelpers.export(exports, "HiSearch", ()=>HiSearch);
parcelHelpers.export(exports, "HiSearchCircle", ()=>HiSearchCircle);
parcelHelpers.export(exports, "HiScissors", ()=>HiScissors);
parcelHelpers.export(exports, "HiScale", ()=>HiScale);
parcelHelpers.export(exports, "HiSave", ()=>HiSave);
parcelHelpers.export(exports, "HiSaveAs", ()=>HiSaveAs);
parcelHelpers.export(exports, "HiRss", ()=>HiRss);
parcelHelpers.export(exports, "HiRewind", ()=>HiRewind);
parcelHelpers.export(exports, "HiReply", ()=>HiReply);
parcelHelpers.export(exports, "HiRefresh", ()=>HiRefresh);
parcelHelpers.export(exports, "HiReceiptTax", ()=>HiReceiptTax);
parcelHelpers.export(exports, "HiReceiptRefund", ()=>HiReceiptRefund);
parcelHelpers.export(exports, "HiQuestionMarkCircle", ()=>HiQuestionMarkCircle);
parcelHelpers.export(exports, "HiQrcode", ()=>HiQrcode);
parcelHelpers.export(exports, "HiPuzzle", ()=>HiPuzzle);
parcelHelpers.export(exports, "HiPrinter", ()=>HiPrinter);
parcelHelpers.export(exports, "HiPresentationChartLine", ()=>HiPresentationChartLine);
parcelHelpers.export(exports, "HiPresentationChartBar", ()=>HiPresentationChartBar);
parcelHelpers.export(exports, "HiPlus", ()=>HiPlus);
parcelHelpers.export(exports, "HiPlusSm", ()=>HiPlusSm);
parcelHelpers.export(exports, "HiPlusCircle", ()=>HiPlusCircle);
parcelHelpers.export(exports, "HiPlay", ()=>HiPlay);
parcelHelpers.export(exports, "HiPhotograph", ()=>HiPhotograph);
parcelHelpers.export(exports, "HiPhone", ()=>HiPhone);
parcelHelpers.export(exports, "HiPhoneOutgoing", ()=>HiPhoneOutgoing);
parcelHelpers.export(exports, "HiPhoneMissedCall", ()=>HiPhoneMissedCall);
parcelHelpers.export(exports, "HiPhoneIncoming", ()=>HiPhoneIncoming);
parcelHelpers.export(exports, "HiPencil", ()=>HiPencil);
parcelHelpers.export(exports, "HiPencilAlt", ()=>HiPencilAlt);
parcelHelpers.export(exports, "HiPause", ()=>HiPause);
parcelHelpers.export(exports, "HiPaperClip", ()=>HiPaperClip);
parcelHelpers.export(exports, "HiPaperAirplane", ()=>HiPaperAirplane);
parcelHelpers.export(exports, "HiOfficeBuilding", ()=>HiOfficeBuilding);
parcelHelpers.export(exports, "HiNewspaper", ()=>HiNewspaper);
parcelHelpers.export(exports, "HiMusicNote", ()=>HiMusicNote);
parcelHelpers.export(exports, "HiMoon", ()=>HiMoon);
parcelHelpers.export(exports, "HiMinus", ()=>HiMinus);
parcelHelpers.export(exports, "HiMinusSm", ()=>HiMinusSm);
parcelHelpers.export(exports, "HiMinusCircle", ()=>HiMinusCircle);
parcelHelpers.export(exports, "HiMicrophone", ()=>HiMicrophone);
parcelHelpers.export(exports, "HiMenu", ()=>HiMenu);
parcelHelpers.export(exports, "HiMenuAlt4", ()=>HiMenuAlt4);
parcelHelpers.export(exports, "HiMenuAlt3", ()=>HiMenuAlt3);
parcelHelpers.export(exports, "HiMenuAlt2", ()=>HiMenuAlt2);
parcelHelpers.export(exports, "HiMenuAlt1", ()=>HiMenuAlt1);
parcelHelpers.export(exports, "HiMap", ()=>HiMap);
parcelHelpers.export(exports, "HiMail", ()=>HiMail);
parcelHelpers.export(exports, "HiMailOpen", ()=>HiMailOpen);
parcelHelpers.export(exports, "HiLogout", ()=>HiLogout);
parcelHelpers.export(exports, "HiLogin", ()=>HiLogin);
parcelHelpers.export(exports, "HiLockOpen", ()=>HiLockOpen);
parcelHelpers.export(exports, "HiLockClosed", ()=>HiLockClosed);
parcelHelpers.export(exports, "HiLocationMarker", ()=>HiLocationMarker);
parcelHelpers.export(exports, "HiLink", ()=>HiLink);
parcelHelpers.export(exports, "HiLightningBolt", ()=>HiLightningBolt);
parcelHelpers.export(exports, "HiLightBulb", ()=>HiLightBulb);
parcelHelpers.export(exports, "HiLibrary", ()=>HiLibrary);
parcelHelpers.export(exports, "HiKey", ()=>HiKey);
parcelHelpers.export(exports, "HiInformationCircle", ()=>HiInformationCircle);
parcelHelpers.export(exports, "HiInbox", ()=>HiInbox);
parcelHelpers.export(exports, "HiInboxIn", ()=>HiInboxIn);
parcelHelpers.export(exports, "HiIdentification", ()=>HiIdentification);
parcelHelpers.export(exports, "HiHome", ()=>HiHome);
parcelHelpers.export(exports, "HiHeart", ()=>HiHeart);
parcelHelpers.export(exports, "HiHashtag", ()=>HiHashtag);
parcelHelpers.export(exports, "HiHand", ()=>HiHand);
parcelHelpers.export(exports, "HiGlobe", ()=>HiGlobe);
parcelHelpers.export(exports, "HiGlobeAlt", ()=>HiGlobeAlt);
parcelHelpers.export(exports, "HiGift", ()=>HiGift);
parcelHelpers.export(exports, "HiFolder", ()=>HiFolder);
parcelHelpers.export(exports, "HiFolderRemove", ()=>HiFolderRemove);
parcelHelpers.export(exports, "HiFolderOpen", ()=>HiFolderOpen);
parcelHelpers.export(exports, "HiFolderDownload", ()=>HiFolderDownload);
parcelHelpers.export(exports, "HiFolderAdd", ()=>HiFolderAdd);
parcelHelpers.export(exports, "HiFlag", ()=>HiFlag);
parcelHelpers.export(exports, "HiFire", ()=>HiFire);
parcelHelpers.export(exports, "HiFingerPrint", ()=>HiFingerPrint);
parcelHelpers.export(exports, "HiFilter", ()=>HiFilter);
parcelHelpers.export(exports, "HiFilm", ()=>HiFilm);
parcelHelpers.export(exports, "HiFastForward", ()=>HiFastForward);
parcelHelpers.export(exports, "HiEye", ()=>HiEye);
parcelHelpers.export(exports, "HiEyeOff", ()=>HiEyeOff);
parcelHelpers.export(exports, "HiExternalLink", ()=>HiExternalLink);
parcelHelpers.export(exports, "HiExclamation", ()=>HiExclamation);
parcelHelpers.export(exports, "HiExclamationCircle", ()=>HiExclamationCircle);
parcelHelpers.export(exports, "HiEmojiSad", ()=>HiEmojiSad);
parcelHelpers.export(exports, "HiEmojiHappy", ()=>HiEmojiHappy);
parcelHelpers.export(exports, "HiDuplicate", ()=>HiDuplicate);
parcelHelpers.export(exports, "HiDownload", ()=>HiDownload);
parcelHelpers.export(exports, "HiDotsVertical", ()=>HiDotsVertical);
parcelHelpers.export(exports, "HiDotsHorizontal", ()=>HiDotsHorizontal);
parcelHelpers.export(exports, "HiDotsCircleHorizontal", ()=>HiDotsCircleHorizontal);
parcelHelpers.export(exports, "HiDocument", ()=>HiDocument);
parcelHelpers.export(exports, "HiDocumentText", ()=>HiDocumentText);
parcelHelpers.export(exports, "HiDocumentSearch", ()=>HiDocumentSearch);
parcelHelpers.export(exports, "HiDocumentReport", ()=>HiDocumentReport);
parcelHelpers.export(exports, "HiDocumentRemove", ()=>HiDocumentRemove);
parcelHelpers.export(exports, "HiDocumentDuplicate", ()=>HiDocumentDuplicate);
parcelHelpers.export(exports, "HiDocumentDownload", ()=>HiDocumentDownload);
parcelHelpers.export(exports, "HiDocumentAdd", ()=>HiDocumentAdd);
parcelHelpers.export(exports, "HiDeviceTablet", ()=>HiDeviceTablet);
parcelHelpers.export(exports, "HiDeviceMobile", ()=>HiDeviceMobile);
parcelHelpers.export(exports, "HiDesktopComputer", ()=>HiDesktopComputer);
parcelHelpers.export(exports, "HiDatabase", ()=>HiDatabase);
parcelHelpers.export(exports, "HiCursorClick", ()=>HiCursorClick);
parcelHelpers.export(exports, "HiCurrencyYen", ()=>HiCurrencyYen);
parcelHelpers.export(exports, "HiCurrencyRupee", ()=>HiCurrencyRupee);
parcelHelpers.export(exports, "HiCurrencyPound", ()=>HiCurrencyPound);
parcelHelpers.export(exports, "HiCurrencyEuro", ()=>HiCurrencyEuro);
parcelHelpers.export(exports, "HiCurrencyDollar", ()=>HiCurrencyDollar);
parcelHelpers.export(exports, "HiCurrencyBangladeshi", ()=>HiCurrencyBangladeshi);
parcelHelpers.export(exports, "HiCube", ()=>HiCube);
parcelHelpers.export(exports, "HiCubeTransparent", ()=>HiCubeTransparent);
parcelHelpers.export(exports, "HiCreditCard", ()=>HiCreditCard);
parcelHelpers.export(exports, "HiColorSwatch", ()=>HiColorSwatch);
parcelHelpers.export(exports, "HiCollection", ()=>HiCollection);
parcelHelpers.export(exports, "HiCog", ()=>HiCog);
parcelHelpers.export(exports, "HiCode", ()=>HiCode);
parcelHelpers.export(exports, "HiCloud", ()=>HiCloud);
parcelHelpers.export(exports, "HiCloudUpload", ()=>HiCloudUpload);
parcelHelpers.export(exports, "HiCloudDownload", ()=>HiCloudDownload);
parcelHelpers.export(exports, "HiClock", ()=>HiClock);
parcelHelpers.export(exports, "HiClipboard", ()=>HiClipboard);
parcelHelpers.export(exports, "HiClipboardList", ()=>HiClipboardList);
parcelHelpers.export(exports, "HiClipboardCopy", ()=>HiClipboardCopy);
parcelHelpers.export(exports, "HiClipboardCheck", ()=>HiClipboardCheck);
parcelHelpers.export(exports, "HiChip", ()=>HiChip);
parcelHelpers.export(exports, "HiChevronUp", ()=>HiChevronUp);
parcelHelpers.export(exports, "HiChevronRight", ()=>HiChevronRight);
parcelHelpers.export(exports, "HiChevronLeft", ()=>HiChevronLeft);
parcelHelpers.export(exports, "HiChevronDown", ()=>HiChevronDown);
parcelHelpers.export(exports, "HiChevronDoubleUp", ()=>HiChevronDoubleUp);
parcelHelpers.export(exports, "HiChevronDoubleRight", ()=>HiChevronDoubleRight);
parcelHelpers.export(exports, "HiChevronDoubleLeft", ()=>HiChevronDoubleLeft);
parcelHelpers.export(exports, "HiChevronDoubleDown", ()=>HiChevronDoubleDown);
parcelHelpers.export(exports, "HiCheck", ()=>HiCheck);
parcelHelpers.export(exports, "HiCheckCircle", ()=>HiCheckCircle);
parcelHelpers.export(exports, "HiChat", ()=>HiChat);
parcelHelpers.export(exports, "HiChatAlt", ()=>HiChatAlt);
parcelHelpers.export(exports, "HiChatAlt2", ()=>HiChatAlt2);
parcelHelpers.export(exports, "HiChartSquareBar", ()=>HiChartSquareBar);
parcelHelpers.export(exports, "HiChartPie", ()=>HiChartPie);
parcelHelpers.export(exports, "HiChartBar", ()=>HiChartBar);
parcelHelpers.export(exports, "HiCash", ()=>HiCash);
parcelHelpers.export(exports, "HiCamera", ()=>HiCamera);
parcelHelpers.export(exports, "HiCalendar", ()=>HiCalendar);
parcelHelpers.export(exports, "HiCalculator", ()=>HiCalculator);
parcelHelpers.export(exports, "HiCake", ()=>HiCake);
parcelHelpers.export(exports, "HiBriefcase", ()=>HiBriefcase);
parcelHelpers.export(exports, "HiBookmark", ()=>HiBookmark);
parcelHelpers.export(exports, "HiBookmarkAlt", ()=>HiBookmarkAlt);
parcelHelpers.export(exports, "HiBookOpen", ()=>HiBookOpen);
parcelHelpers.export(exports, "HiBell", ()=>HiBell);
parcelHelpers.export(exports, "HiBeaker", ()=>HiBeaker);
parcelHelpers.export(exports, "HiBan", ()=>HiBan);
parcelHelpers.export(exports, "HiBadgeCheck", ()=>HiBadgeCheck);
parcelHelpers.export(exports, "HiBackspace", ()=>HiBackspace);
parcelHelpers.export(exports, "HiAtSymbol", ()=>HiAtSymbol);
parcelHelpers.export(exports, "HiArrowsExpand", ()=>HiArrowsExpand);
parcelHelpers.export(exports, "HiArrowUp", ()=>HiArrowUp);
parcelHelpers.export(exports, "HiArrowSmUp", ()=>HiArrowSmUp);
parcelHelpers.export(exports, "HiArrowSmRight", ()=>HiArrowSmRight);
parcelHelpers.export(exports, "HiArrowSmLeft", ()=>HiArrowSmLeft);
parcelHelpers.export(exports, "HiArrowSmDown", ()=>HiArrowSmDown);
parcelHelpers.export(exports, "HiArrowRight", ()=>HiArrowRight);
parcelHelpers.export(exports, "HiArrowNarrowUp", ()=>HiArrowNarrowUp);
parcelHelpers.export(exports, "HiArrowNarrowRight", ()=>HiArrowNarrowRight);
parcelHelpers.export(exports, "HiArrowNarrowLeft", ()=>HiArrowNarrowLeft);
parcelHelpers.export(exports, "HiArrowNarrowDown", ()=>HiArrowNarrowDown);
parcelHelpers.export(exports, "HiArrowLeft", ()=>HiArrowLeft);
parcelHelpers.export(exports, "HiArrowDown", ()=>HiArrowDown);
parcelHelpers.export(exports, "HiArrowCircleUp", ()=>HiArrowCircleUp);
parcelHelpers.export(exports, "HiArrowCircleRight", ()=>HiArrowCircleRight);
parcelHelpers.export(exports, "HiArrowCircleLeft", ()=>HiArrowCircleLeft);
parcelHelpers.export(exports, "HiArrowCircleDown", ()=>HiArrowCircleDown);
parcelHelpers.export(exports, "HiArchive", ()=>HiArchive);
parcelHelpers.export(exports, "HiAnnotation", ()=>HiAnnotation);
parcelHelpers.export(exports, "HiAdjustments", ()=>HiAdjustments);
parcelHelpers.export(exports, "HiAcademicCap", ()=>HiAcademicCap);
parcelHelpers.export(exports, "HiOutlineZoomOut", ()=>HiOutlineZoomOut);
parcelHelpers.export(exports, "HiOutlineZoomIn", ()=>HiOutlineZoomIn);
parcelHelpers.export(exports, "HiOutlineX", ()=>HiOutlineX);
parcelHelpers.export(exports, "HiOutlineXCircle", ()=>HiOutlineXCircle);
parcelHelpers.export(exports, "HiOutlineWifi", ()=>HiOutlineWifi);
parcelHelpers.export(exports, "HiOutlineVolumeUp", ()=>HiOutlineVolumeUp);
parcelHelpers.export(exports, "HiOutlineVolumeOff", ()=>HiOutlineVolumeOff);
parcelHelpers.export(exports, "HiOutlineViewList", ()=>HiOutlineViewList);
parcelHelpers.export(exports, "HiOutlineViewGrid", ()=>HiOutlineViewGrid);
parcelHelpers.export(exports, "HiOutlineViewGridAdd", ()=>HiOutlineViewGridAdd);
parcelHelpers.export(exports, "HiOutlineViewBoards", ()=>HiOutlineViewBoards);
parcelHelpers.export(exports, "HiOutlineVideoCamera", ()=>HiOutlineVideoCamera);
parcelHelpers.export(exports, "HiOutlineVariable", ()=>HiOutlineVariable);
parcelHelpers.export(exports, "HiOutlineUsers", ()=>HiOutlineUsers);
parcelHelpers.export(exports, "HiOutlineUser", ()=>HiOutlineUser);
parcelHelpers.export(exports, "HiOutlineUserRemove", ()=>HiOutlineUserRemove);
parcelHelpers.export(exports, "HiOutlineUserGroup", ()=>HiOutlineUserGroup);
parcelHelpers.export(exports, "HiOutlineUserCircle", ()=>HiOutlineUserCircle);
parcelHelpers.export(exports, "HiOutlineUserAdd", ()=>HiOutlineUserAdd);
parcelHelpers.export(exports, "HiOutlineUpload", ()=>HiOutlineUpload);
parcelHelpers.export(exports, "HiOutlineTruck", ()=>HiOutlineTruck);
parcelHelpers.export(exports, "HiOutlineTrendingUp", ()=>HiOutlineTrendingUp);
parcelHelpers.export(exports, "HiOutlineTrendingDown", ()=>HiOutlineTrendingDown);
parcelHelpers.export(exports, "HiOutlineTrash", ()=>HiOutlineTrash);
parcelHelpers.export(exports, "HiOutlineTranslate", ()=>HiOutlineTranslate);
parcelHelpers.export(exports, "HiOutlineTicket", ()=>HiOutlineTicket);
parcelHelpers.export(exports, "HiOutlineThumbUp", ()=>HiOutlineThumbUp);
parcelHelpers.export(exports, "HiOutlineThumbDown", ()=>HiOutlineThumbDown);
parcelHelpers.export(exports, "HiOutlineTerminal", ()=>HiOutlineTerminal);
parcelHelpers.export(exports, "HiOutlineTemplate", ()=>HiOutlineTemplate);
parcelHelpers.export(exports, "HiOutlineTag", ()=>HiOutlineTag);
parcelHelpers.export(exports, "HiOutlineTable", ()=>HiOutlineTable);
parcelHelpers.export(exports, "HiOutlineSwitchVertical", ()=>HiOutlineSwitchVertical);
parcelHelpers.export(exports, "HiOutlineSwitchHorizontal", ()=>HiOutlineSwitchHorizontal);
parcelHelpers.export(exports, "HiOutlineSupport", ()=>HiOutlineSupport);
parcelHelpers.export(exports, "HiOutlineSun", ()=>HiOutlineSun);
parcelHelpers.export(exports, "HiOutlineStop", ()=>HiOutlineStop);
parcelHelpers.export(exports, "HiOutlineStatusOnline", ()=>HiOutlineStatusOnline);
parcelHelpers.export(exports, "HiOutlineStatusOffline", ()=>HiOutlineStatusOffline);
parcelHelpers.export(exports, "HiOutlineStar", ()=>HiOutlineStar);
parcelHelpers.export(exports, "HiOutlineSpeakerphone", ()=>HiOutlineSpeakerphone);
parcelHelpers.export(exports, "HiOutlineSparkles", ()=>HiOutlineSparkles);
parcelHelpers.export(exports, "HiOutlineSortDescending", ()=>HiOutlineSortDescending);
parcelHelpers.export(exports, "HiOutlineSortAscending", ()=>HiOutlineSortAscending);
parcelHelpers.export(exports, "HiOutlineShoppingCart", ()=>HiOutlineShoppingCart);
parcelHelpers.export(exports, "HiOutlineShoppingBag", ()=>HiOutlineShoppingBag);
parcelHelpers.export(exports, "HiOutlineShieldExclamation", ()=>HiOutlineShieldExclamation);
parcelHelpers.export(exports, "HiOutlineShieldCheck", ()=>HiOutlineShieldCheck);
parcelHelpers.export(exports, "HiOutlineShare", ()=>HiOutlineShare);
parcelHelpers.export(exports, "HiOutlineServer", ()=>HiOutlineServer);
parcelHelpers.export(exports, "HiOutlineSelector", ()=>HiOutlineSelector);
parcelHelpers.export(exports, "HiOutlineSearch", ()=>HiOutlineSearch);
parcelHelpers.export(exports, "HiOutlineSearchCircle", ()=>HiOutlineSearchCircle);
parcelHelpers.export(exports, "HiOutlineScissors", ()=>HiOutlineScissors);
parcelHelpers.export(exports, "HiOutlineScale", ()=>HiOutlineScale);
parcelHelpers.export(exports, "HiOutlineSave", ()=>HiOutlineSave);
parcelHelpers.export(exports, "HiOutlineSaveAs", ()=>HiOutlineSaveAs);
parcelHelpers.export(exports, "HiOutlineRss", ()=>HiOutlineRss);
parcelHelpers.export(exports, "HiOutlineRewind", ()=>HiOutlineRewind);
parcelHelpers.export(exports, "HiOutlineReply", ()=>HiOutlineReply);
parcelHelpers.export(exports, "HiOutlineRefresh", ()=>HiOutlineRefresh);
parcelHelpers.export(exports, "HiOutlineReceiptTax", ()=>HiOutlineReceiptTax);
parcelHelpers.export(exports, "HiOutlineReceiptRefund", ()=>HiOutlineReceiptRefund);
parcelHelpers.export(exports, "HiOutlineQuestionMarkCircle", ()=>HiOutlineQuestionMarkCircle);
parcelHelpers.export(exports, "HiOutlineQrcode", ()=>HiOutlineQrcode);
parcelHelpers.export(exports, "HiOutlinePuzzle", ()=>HiOutlinePuzzle);
parcelHelpers.export(exports, "HiOutlinePrinter", ()=>HiOutlinePrinter);
parcelHelpers.export(exports, "HiOutlinePresentationChartLine", ()=>HiOutlinePresentationChartLine);
parcelHelpers.export(exports, "HiOutlinePresentationChartBar", ()=>HiOutlinePresentationChartBar);
parcelHelpers.export(exports, "HiOutlinePlus", ()=>HiOutlinePlus);
parcelHelpers.export(exports, "HiOutlinePlusSm", ()=>HiOutlinePlusSm);
parcelHelpers.export(exports, "HiOutlinePlusCircle", ()=>HiOutlinePlusCircle);
parcelHelpers.export(exports, "HiOutlinePlay", ()=>HiOutlinePlay);
parcelHelpers.export(exports, "HiOutlinePhotograph", ()=>HiOutlinePhotograph);
parcelHelpers.export(exports, "HiOutlinePhone", ()=>HiOutlinePhone);
parcelHelpers.export(exports, "HiOutlinePhoneOutgoing", ()=>HiOutlinePhoneOutgoing);
parcelHelpers.export(exports, "HiOutlinePhoneMissedCall", ()=>HiOutlinePhoneMissedCall);
parcelHelpers.export(exports, "HiOutlinePhoneIncoming", ()=>HiOutlinePhoneIncoming);
parcelHelpers.export(exports, "HiOutlinePencil", ()=>HiOutlinePencil);
parcelHelpers.export(exports, "HiOutlinePencilAlt", ()=>HiOutlinePencilAlt);
parcelHelpers.export(exports, "HiOutlinePause", ()=>HiOutlinePause);
parcelHelpers.export(exports, "HiOutlinePaperClip", ()=>HiOutlinePaperClip);
parcelHelpers.export(exports, "HiOutlinePaperAirplane", ()=>HiOutlinePaperAirplane);
parcelHelpers.export(exports, "HiOutlineOfficeBuilding", ()=>HiOutlineOfficeBuilding);
parcelHelpers.export(exports, "HiOutlineNewspaper", ()=>HiOutlineNewspaper);
parcelHelpers.export(exports, "HiOutlineMusicNote", ()=>HiOutlineMusicNote);
parcelHelpers.export(exports, "HiOutlineMoon", ()=>HiOutlineMoon);
parcelHelpers.export(exports, "HiOutlineMinus", ()=>HiOutlineMinus);
parcelHelpers.export(exports, "HiOutlineMinusSm", ()=>HiOutlineMinusSm);
parcelHelpers.export(exports, "HiOutlineMinusCircle", ()=>HiOutlineMinusCircle);
parcelHelpers.export(exports, "HiOutlineMicrophone", ()=>HiOutlineMicrophone);
parcelHelpers.export(exports, "HiOutlineMenu", ()=>HiOutlineMenu);
parcelHelpers.export(exports, "HiOutlineMenuAlt4", ()=>HiOutlineMenuAlt4);
parcelHelpers.export(exports, "HiOutlineMenuAlt3", ()=>HiOutlineMenuAlt3);
parcelHelpers.export(exports, "HiOutlineMenuAlt2", ()=>HiOutlineMenuAlt2);
parcelHelpers.export(exports, "HiOutlineMenuAlt1", ()=>HiOutlineMenuAlt1);
parcelHelpers.export(exports, "HiOutlineMap", ()=>HiOutlineMap);
parcelHelpers.export(exports, "HiOutlineMail", ()=>HiOutlineMail);
parcelHelpers.export(exports, "HiOutlineMailOpen", ()=>HiOutlineMailOpen);
parcelHelpers.export(exports, "HiOutlineLogout", ()=>HiOutlineLogout);
parcelHelpers.export(exports, "HiOutlineLogin", ()=>HiOutlineLogin);
parcelHelpers.export(exports, "HiOutlineLockOpen", ()=>HiOutlineLockOpen);
parcelHelpers.export(exports, "HiOutlineLockClosed", ()=>HiOutlineLockClosed);
parcelHelpers.export(exports, "HiOutlineLocationMarker", ()=>HiOutlineLocationMarker);
parcelHelpers.export(exports, "HiOutlineLink", ()=>HiOutlineLink);
parcelHelpers.export(exports, "HiOutlineLightningBolt", ()=>HiOutlineLightningBolt);
parcelHelpers.export(exports, "HiOutlineLightBulb", ()=>HiOutlineLightBulb);
parcelHelpers.export(exports, "HiOutlineLibrary", ()=>HiOutlineLibrary);
parcelHelpers.export(exports, "HiOutlineKey", ()=>HiOutlineKey);
parcelHelpers.export(exports, "HiOutlineInformationCircle", ()=>HiOutlineInformationCircle);
parcelHelpers.export(exports, "HiOutlineInbox", ()=>HiOutlineInbox);
parcelHelpers.export(exports, "HiOutlineInboxIn", ()=>HiOutlineInboxIn);
parcelHelpers.export(exports, "HiOutlineIdentification", ()=>HiOutlineIdentification);
parcelHelpers.export(exports, "HiOutlineHome", ()=>HiOutlineHome);
parcelHelpers.export(exports, "HiOutlineHeart", ()=>HiOutlineHeart);
parcelHelpers.export(exports, "HiOutlineHashtag", ()=>HiOutlineHashtag);
parcelHelpers.export(exports, "HiOutlineHand", ()=>HiOutlineHand);
parcelHelpers.export(exports, "HiOutlineGlobe", ()=>HiOutlineGlobe);
parcelHelpers.export(exports, "HiOutlineGlobeAlt", ()=>HiOutlineGlobeAlt);
parcelHelpers.export(exports, "HiOutlineGift", ()=>HiOutlineGift);
parcelHelpers.export(exports, "HiOutlineFolder", ()=>HiOutlineFolder);
parcelHelpers.export(exports, "HiOutlineFolderRemove", ()=>HiOutlineFolderRemove);
parcelHelpers.export(exports, "HiOutlineFolderOpen", ()=>HiOutlineFolderOpen);
parcelHelpers.export(exports, "HiOutlineFolderDownload", ()=>HiOutlineFolderDownload);
parcelHelpers.export(exports, "HiOutlineFolderAdd", ()=>HiOutlineFolderAdd);
parcelHelpers.export(exports, "HiOutlineFlag", ()=>HiOutlineFlag);
parcelHelpers.export(exports, "HiOutlineFire", ()=>HiOutlineFire);
parcelHelpers.export(exports, "HiOutlineFingerPrint", ()=>HiOutlineFingerPrint);
parcelHelpers.export(exports, "HiOutlineFilter", ()=>HiOutlineFilter);
parcelHelpers.export(exports, "HiOutlineFilm", ()=>HiOutlineFilm);
parcelHelpers.export(exports, "HiOutlineFastForward", ()=>HiOutlineFastForward);
parcelHelpers.export(exports, "HiOutlineEye", ()=>HiOutlineEye);
parcelHelpers.export(exports, "HiOutlineEyeOff", ()=>HiOutlineEyeOff);
parcelHelpers.export(exports, "HiOutlineExternalLink", ()=>HiOutlineExternalLink);
parcelHelpers.export(exports, "HiOutlineExclamation", ()=>HiOutlineExclamation);
parcelHelpers.export(exports, "HiOutlineExclamationCircle", ()=>HiOutlineExclamationCircle);
parcelHelpers.export(exports, "HiOutlineEmojiSad", ()=>HiOutlineEmojiSad);
parcelHelpers.export(exports, "HiOutlineEmojiHappy", ()=>HiOutlineEmojiHappy);
parcelHelpers.export(exports, "HiOutlineDuplicate", ()=>HiOutlineDuplicate);
parcelHelpers.export(exports, "HiOutlineDownload", ()=>HiOutlineDownload);
parcelHelpers.export(exports, "HiOutlineDotsVertical", ()=>HiOutlineDotsVertical);
parcelHelpers.export(exports, "HiOutlineDotsHorizontal", ()=>HiOutlineDotsHorizontal);
parcelHelpers.export(exports, "HiOutlineDotsCircleHorizontal", ()=>HiOutlineDotsCircleHorizontal);
parcelHelpers.export(exports, "HiOutlineDocument", ()=>HiOutlineDocument);
parcelHelpers.export(exports, "HiOutlineDocumentText", ()=>HiOutlineDocumentText);
parcelHelpers.export(exports, "HiOutlineDocumentSearch", ()=>HiOutlineDocumentSearch);
parcelHelpers.export(exports, "HiOutlineDocumentReport", ()=>HiOutlineDocumentReport);
parcelHelpers.export(exports, "HiOutlineDocumentRemove", ()=>HiOutlineDocumentRemove);
parcelHelpers.export(exports, "HiOutlineDocumentDuplicate", ()=>HiOutlineDocumentDuplicate);
parcelHelpers.export(exports, "HiOutlineDocumentDownload", ()=>HiOutlineDocumentDownload);
parcelHelpers.export(exports, "HiOutlineDocumentAdd", ()=>HiOutlineDocumentAdd);
parcelHelpers.export(exports, "HiOutlineDeviceTablet", ()=>HiOutlineDeviceTablet);
parcelHelpers.export(exports, "HiOutlineDeviceMobile", ()=>HiOutlineDeviceMobile);
parcelHelpers.export(exports, "HiOutlineDesktopComputer", ()=>HiOutlineDesktopComputer);
parcelHelpers.export(exports, "HiOutlineDatabase", ()=>HiOutlineDatabase);
parcelHelpers.export(exports, "HiOutlineCursorClick", ()=>HiOutlineCursorClick);
parcelHelpers.export(exports, "HiOutlineCurrencyYen", ()=>HiOutlineCurrencyYen);
parcelHelpers.export(exports, "HiOutlineCurrencyRupee", ()=>HiOutlineCurrencyRupee);
parcelHelpers.export(exports, "HiOutlineCurrencyPound", ()=>HiOutlineCurrencyPound);
parcelHelpers.export(exports, "HiOutlineCurrencyEuro", ()=>HiOutlineCurrencyEuro);
parcelHelpers.export(exports, "HiOutlineCurrencyDollar", ()=>HiOutlineCurrencyDollar);
parcelHelpers.export(exports, "HiOutlineCurrencyBangladeshi", ()=>HiOutlineCurrencyBangladeshi);
parcelHelpers.export(exports, "HiOutlineCube", ()=>HiOutlineCube);
parcelHelpers.export(exports, "HiOutlineCubeTransparent", ()=>HiOutlineCubeTransparent);
parcelHelpers.export(exports, "HiOutlineCreditCard", ()=>HiOutlineCreditCard);
parcelHelpers.export(exports, "HiOutlineColorSwatch", ()=>HiOutlineColorSwatch);
parcelHelpers.export(exports, "HiOutlineCollection", ()=>HiOutlineCollection);
parcelHelpers.export(exports, "HiOutlineCog", ()=>HiOutlineCog);
parcelHelpers.export(exports, "HiOutlineCode", ()=>HiOutlineCode);
parcelHelpers.export(exports, "HiOutlineCloud", ()=>HiOutlineCloud);
parcelHelpers.export(exports, "HiOutlineCloudUpload", ()=>HiOutlineCloudUpload);
parcelHelpers.export(exports, "HiOutlineCloudDownload", ()=>HiOutlineCloudDownload);
parcelHelpers.export(exports, "HiOutlineClock", ()=>HiOutlineClock);
parcelHelpers.export(exports, "HiOutlineClipboard", ()=>HiOutlineClipboard);
parcelHelpers.export(exports, "HiOutlineClipboardList", ()=>HiOutlineClipboardList);
parcelHelpers.export(exports, "HiOutlineClipboardCopy", ()=>HiOutlineClipboardCopy);
parcelHelpers.export(exports, "HiOutlineClipboardCheck", ()=>HiOutlineClipboardCheck);
parcelHelpers.export(exports, "HiOutlineChip", ()=>HiOutlineChip);
parcelHelpers.export(exports, "HiOutlineChevronUp", ()=>HiOutlineChevronUp);
parcelHelpers.export(exports, "HiOutlineChevronRight", ()=>HiOutlineChevronRight);
parcelHelpers.export(exports, "HiOutlineChevronLeft", ()=>HiOutlineChevronLeft);
parcelHelpers.export(exports, "HiOutlineChevronDown", ()=>HiOutlineChevronDown);
parcelHelpers.export(exports, "HiOutlineChevronDoubleUp", ()=>HiOutlineChevronDoubleUp);
parcelHelpers.export(exports, "HiOutlineChevronDoubleRight", ()=>HiOutlineChevronDoubleRight);
parcelHelpers.export(exports, "HiOutlineChevronDoubleLeft", ()=>HiOutlineChevronDoubleLeft);
parcelHelpers.export(exports, "HiOutlineChevronDoubleDown", ()=>HiOutlineChevronDoubleDown);
parcelHelpers.export(exports, "HiOutlineCheck", ()=>HiOutlineCheck);
parcelHelpers.export(exports, "HiOutlineCheckCircle", ()=>HiOutlineCheckCircle);
parcelHelpers.export(exports, "HiOutlineChat", ()=>HiOutlineChat);
parcelHelpers.export(exports, "HiOutlineChatAlt", ()=>HiOutlineChatAlt);
parcelHelpers.export(exports, "HiOutlineChatAlt2", ()=>HiOutlineChatAlt2);
parcelHelpers.export(exports, "HiOutlineChartSquareBar", ()=>HiOutlineChartSquareBar);
parcelHelpers.export(exports, "HiOutlineChartPie", ()=>HiOutlineChartPie);
parcelHelpers.export(exports, "HiOutlineChartBar", ()=>HiOutlineChartBar);
parcelHelpers.export(exports, "HiOutlineCash", ()=>HiOutlineCash);
parcelHelpers.export(exports, "HiOutlineCamera", ()=>HiOutlineCamera);
parcelHelpers.export(exports, "HiOutlineCalendar", ()=>HiOutlineCalendar);
parcelHelpers.export(exports, "HiOutlineCalculator", ()=>HiOutlineCalculator);
parcelHelpers.export(exports, "HiOutlineCake", ()=>HiOutlineCake);
parcelHelpers.export(exports, "HiOutlineBriefcase", ()=>HiOutlineBriefcase);
parcelHelpers.export(exports, "HiOutlineBookmark", ()=>HiOutlineBookmark);
parcelHelpers.export(exports, "HiOutlineBookmarkAlt", ()=>HiOutlineBookmarkAlt);
parcelHelpers.export(exports, "HiOutlineBookOpen", ()=>HiOutlineBookOpen);
parcelHelpers.export(exports, "HiOutlineBell", ()=>HiOutlineBell);
parcelHelpers.export(exports, "HiOutlineBeaker", ()=>HiOutlineBeaker);
parcelHelpers.export(exports, "HiOutlineBan", ()=>HiOutlineBan);
parcelHelpers.export(exports, "HiOutlineBadgeCheck", ()=>HiOutlineBadgeCheck);
parcelHelpers.export(exports, "HiOutlineBackspace", ()=>HiOutlineBackspace);
parcelHelpers.export(exports, "HiOutlineAtSymbol", ()=>HiOutlineAtSymbol);
parcelHelpers.export(exports, "HiOutlineArrowsExpand", ()=>HiOutlineArrowsExpand);
parcelHelpers.export(exports, "HiOutlineArrowUp", ()=>HiOutlineArrowUp);
parcelHelpers.export(exports, "HiOutlineArrowSmUp", ()=>HiOutlineArrowSmUp);
parcelHelpers.export(exports, "HiOutlineArrowSmRight", ()=>HiOutlineArrowSmRight);
parcelHelpers.export(exports, "HiOutlineArrowSmLeft", ()=>HiOutlineArrowSmLeft);
parcelHelpers.export(exports, "HiOutlineArrowSmDown", ()=>HiOutlineArrowSmDown);
parcelHelpers.export(exports, "HiOutlineArrowRight", ()=>HiOutlineArrowRight);
parcelHelpers.export(exports, "HiOutlineArrowNarrowUp", ()=>HiOutlineArrowNarrowUp);
parcelHelpers.export(exports, "HiOutlineArrowNarrowRight", ()=>HiOutlineArrowNarrowRight);
parcelHelpers.export(exports, "HiOutlineArrowNarrowLeft", ()=>HiOutlineArrowNarrowLeft);
parcelHelpers.export(exports, "HiOutlineArrowNarrowDown", ()=>HiOutlineArrowNarrowDown);
parcelHelpers.export(exports, "HiOutlineArrowLeft", ()=>HiOutlineArrowLeft);
parcelHelpers.export(exports, "HiOutlineArrowDown", ()=>HiOutlineArrowDown);
parcelHelpers.export(exports, "HiOutlineArrowCircleUp", ()=>HiOutlineArrowCircleUp);
parcelHelpers.export(exports, "HiOutlineArrowCircleRight", ()=>HiOutlineArrowCircleRight);
parcelHelpers.export(exports, "HiOutlineArrowCircleLeft", ()=>HiOutlineArrowCircleLeft);
parcelHelpers.export(exports, "HiOutlineArrowCircleDown", ()=>HiOutlineArrowCircleDown);
parcelHelpers.export(exports, "HiOutlineArchive", ()=>HiOutlineArchive);
parcelHelpers.export(exports, "HiOutlineAnnotation", ()=>HiOutlineAnnotation);
parcelHelpers.export(exports, "HiOutlineAdjustments", ()=>HiOutlineAdjustments);
parcelHelpers.export(exports, "HiOutlineAcademicCap", ()=>HiOutlineAcademicCap);
var _indexMjs = require("../lib/index.mjs");
function HiZoomOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 8a1 1 0 011-1h4a1 1 0 110 2H6a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiZoomIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8a1 1 0 011-1h1V6a1 1 0 012 0v1h1a1 1 0 110 2H9v1a1 1 0 11-2 0V9H6a1 1 0 01-1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8zm6-4a4 4 0 100 8 4 4 0 000-8z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiXCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiWifi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 01.808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 01-1.414 1.414zM14.95 11.05a7 7 0 00-9.9 0 1 1 0 01-1.414-1.414 9 9 0 0112.728 0 1 1 0 01-1.414 1.414zM12.12 13.88a3 3 0 00-4.242 0 1 1 0 01-1.415-1.415 5 5 0 017.072 0 1 1 0 01-1.415 1.415zM9 16a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiVolumeUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiVolumeOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiViewList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiViewGrid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiViewGridAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiViewBoards(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V4zM8 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H9a1 1 0 01-1-1V4zM15 3a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiVideoCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiVariable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.649 3.084A1 1 0 015.163 4.4 13.95 13.95 0 004 10c0 1.993.416 3.886 1.164 5.6a1 1 0 01-1.832.8A15.95 15.95 0 012 10c0-2.274.475-4.44 1.332-6.4a1 1 0 011.317-.516zM12.96 7a3 3 0 00-2.342 1.126l-.328.41-.111-.279A2 2 0 008.323 7H8a1 1 0 000 2h.323l.532 1.33-1.035 1.295a1 1 0 01-.781.375H7a1 1 0 100 2h.039a3 3 0 002.342-1.126l.328-.41.111.279A2 2 0 0011.677 14H12a1 1 0 100-2h-.323l-.532-1.33 1.035-1.295A1 1 0 0112.961 9H13a1 1 0 100-2h-.039zm1.874-2.6a1 1 0 011.833-.8A15.95 15.95 0 0118 10c0 2.274-.475 4.44-1.332 6.4a1 1 0 11-1.832-.8A13.949 13.949 0 0016 10c0-1.993-.416-3.886-1.165-5.6z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUsers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUserRemove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6a3 3 0 11-6 0 3 3 0 016 0zM14 17a6 6 0 00-12 0h12zM13 8a1 1 0 100 2h4a1 1 0 100-2h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUserGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUserAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTruck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTrendingUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTrendingDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 13a1 1 0 100 2h5a1 1 0 001-1V9a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586 3.707 5.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTranslate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7 2a1 1 0 011 1v1h3a1 1 0 110 2H9.578a18.87 18.87 0 01-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 11-1.44 1.389c-.188-.196-.373-.396-.554-.6a19.098 19.098 0 01-3.107 3.567 1 1 0 01-1.334-1.49 17.087 17.087 0 003.13-3.733 18.992 18.992 0 01-1.487-2.494 1 1 0 111.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 110-2h3V3a1 1 0 011-1zm6 6a1 1 0 01.894.553l2.991 5.982a.869.869 0 01.02.037l.99 1.98a1 1 0 11-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 11-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0113 8zm-1.382 6h2.764L13 11.236 11.618 14z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTicket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 100 4v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 100-4V6z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiThumbUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiThumbDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9.5a1.5 1.5 0 11-3 0v-6a1.5 1.5 0 013 0v6zM14 9.667v-5.43a2 2 0 00-1.105-1.79l-.05-.025A4 4 0 0011.055 2H5.64a2 2 0 00-1.962 1.608l-1.2 6A2 2 0 004.44 12H8v4a2 2 0 002 2 1 1 0 001-1v-.667a4 4 0 01.8-2.4l1.4-1.866a4 4 0 00.8-2.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTerminal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTemplate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSwitchVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12a1 1 0 102 0V6.414l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L5 6.414V12zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSwitchHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSupport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiStatusOnline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.05 3.636a1 1 0 010 1.414 7 7 0 000 9.9 1 1 0 11-1.414 1.414 9 9 0 010-12.728 1 1 0 011.414 0zm9.9 0a1 1 0 011.414 0 9 9 0 010 12.728 1 1 0 11-1.414-1.414 7 7 0 000-9.9 1 1 0 010-1.414zM7.879 6.464a1 1 0 010 1.414 3 3 0 000 4.243 1 1 0 11-1.415 1.414 5 5 0 010-7.07 1 1 0 011.415 0zm4.242 0a1 1 0 011.415 0 5 5 0 010 7.072 1 1 0 01-1.415-1.415 3 3 0 000-4.242 1 1 0 010-1.415zM10 9a1 1 0 011 1v.01a1 1 0 11-2 0V10a1 1 0 011-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiStatusOffline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.707 2.293a1 1 0 00-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 001.415-1.414l-.675-.675a9.001 9.001 0 00-.668-11.982A1 1 0 1014.95 5.05a7.002 7.002 0 01.657 9.143l-1.435-1.435a5.002 5.002 0 00-.636-6.294A1 1 0 0012.12 7.88c.924.923 1.12 2.3.587 3.415l-1.992-1.992a.922.922 0 00-.018-.018l-6.99-6.991zM3.238 8.187a1 1 0 00-1.933-.516c-.8 3-.025 6.336 2.331 8.693a1 1 0 001.414-1.415 6.997 6.997 0 01-1.812-6.762zM7.4 11.5a1 1 0 10-1.73 1c.214.371.48.72.795 1.035a1 1 0 001.414-1.414c-.191-.191-.35-.4-.478-.622z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSpeakerphone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSortDescending(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSortAscending(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiShoppingCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiShoppingBag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiShieldExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 1.944A11.954 11.954 0 012.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0110 1.944zM11 14a1 1 0 11-2 0 1 1 0 012 0zm0-7a1 1 0 10-2 0v3a1 1 0 102 0V7z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiShieldCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiServer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm14 1a1 1 0 11-2 0 1 1 0 012 0zM2 13a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm14 1a1 1 0 11-2 0 1 1 0 012 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSelector(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSearch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSearchCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9a2 2 0 114 0 2 2 0 01-4 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a4 4 0 00-3.446 6.032l-2.261 2.26a1 1 0 101.414 1.415l2.261-2.261A4 4 0 1011 5z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.5 2a3.5 3.5 0 101.665 6.58L8.585 10l-1.42 1.42a3.5 3.5 0 101.414 1.414l8.128-8.127a1 1 0 00-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 005.5 2zM4 5.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 9a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.828 11.414a1 1 0 00-1.414 1.414l3.879 3.88a1 1 0 001.414-1.415l-3.879-3.879z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiScale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 110 2H7a1 1 0 110-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 01-.285 1.05A3.989 3.989 0 015 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.788l1.599.799L9 4.323V3a1 1 0 011-1zm-5 8.274l-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L5 10.274zm10 0l-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L15 10.274z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSaveAs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 7.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L13 8.586V5h3a2 2 0 012 2v5a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2h3v3.586L9.707 7.293zM11 3a1 1 0 112 0v2h-2V3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9a2 2 0 00-2 2v5a2 2 0 002 2h8a2 2 0 002-2H4V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a1 1 0 000 2c5.523 0 10 4.477 10 10a1 1 0 102 0C17 8.373 11.627 3 5 3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9a1 1 0 011-1 7 7 0 017 7 1 1 0 11-2 0 5 5 0 00-5-5 1 1 0 01-1-1zM3 15a2 2 0 114 0 2 2 0 01-4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiRewind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.445 14.832A1 1 0 0010 14v-2.798l5.445 3.63A1 1 0 0017 14V6a1 1 0 00-1.555-.832L10 8.798V6a1 1 0 00-1.555-.832l-6 4a1 1 0 000 1.664l6 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiReply(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiRefresh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiReceiptTax(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm2.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.207.293a1 1 0 00-1.414 0l-6 6a1 1 0 101.414 1.414l6-6a1 1 0 000-1.414zM12.5 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiReceiptRefund(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 3.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 9H10a3 3 0 013 3v1a1 1 0 102 0v-1a5 5 0 00-5-5H8.414l1.293-1.293z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiQuestionMarkCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiQrcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPuzzle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPrinter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPresentationChartLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 0l-2 2a1 1 0 101.414 1.414L8 10.414l1.293 1.293a1 1 0 001.414 0l4-4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPresentationChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPlusSm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPlusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPhotograph(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPhoneOutgoing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.924 2.617a.997.997 0 00-.215-.322l-.004-.004A.997.997 0 0017 2h-4a1 1 0 100 2h1.586l-3.293 3.293a1 1 0 001.414 1.414L16 5.414V7a1 1 0 102 0V3a.997.997 0 00-.076-.383z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPhoneMissedCall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 3.293a1 1 0 010 1.414L15.414 6l1.293 1.293a1 1 0 01-1.414 1.414L14 7.414l-1.293 1.293a1 1 0 11-1.414-1.414L12.586 6l-1.293-1.293a1 1 0 011.414-1.414L14 4.586l1.293-1.293a1 1 0 011.414 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPhoneIncoming(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.414 7l3.293-3.293a1 1 0 00-1.414-1.414L13 5.586V4a1 1 0 10-2 0v4.003a.996.996 0 00.617.921A.997.997 0 0012 9h4a1 1 0 100-2h-1.586z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPencil(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPencilAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPaperClip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPaperAirplane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOfficeBuilding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 5a2 2 0 012-2h8a2 2 0 012 2v10a2 2 0 002 2H4a2 2 0 01-2-2V5zm3 1h6v4H5V6zm6 6H5v2h6v-2z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h1a2 2 0 012 2v5.5a1.5 1.5 0 01-3 0V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMusicNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMinusSm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMinusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMicrophone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMenu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMenuAlt4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 7a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 13a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMenuAlt3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMenuAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMenuAlt1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMailOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.94 6.412A2 2 0 002 8.108V16a2 2 0 002 2h12a2 2 0 002-2V8.108a2 2 0 00-.94-1.696l-6-3.75a2 2 0 00-2.12 0l-6 3.75zm2.615 2.423a1 1 0 10-1.11 1.664l5 3.333a1 1 0 001.11 0l5-3.333a1 1 0 00-1.11-1.664L10 11.798 5.555 8.835z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLogout(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLogin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLockOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLockClosed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLocationMarker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLightningBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLightBulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLibrary(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.496 2.132a1 1 0 00-.992 0l-7 4A1 1 0 003 8v7a1 1 0 100 2h14a1 1 0 100-2V8a1 1 0 00.496-1.868l-7-4zM6 9a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm3 1a1 1 0 012 0v3a1 1 0 11-2 0v-3zm5-1a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiInformationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiInbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm0 2h10v7h-2l-1 2H8l-1-2H5V5z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiInboxIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiIdentification(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zM4 4h3a3 3 0 006 0h3a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm2.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.45 4a2.5 2.5 0 10-4.9 0h4.9zM12 9a1 1 0 100 2h3a1 1 0 100-2h-3zm-1 4a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHashtag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.243 3.03a1 1 0 01.727 1.213L9.53 6h2.94l.56-2.243a1 1 0 111.94.486L14.53 6H17a1 1 0 110 2h-2.97l-1 4H15a1 1 0 110 2h-2.47l-.56 2.242a1 1 0 11-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 11-1.94-.485L5.47 14H3a1 1 0 110-2h2.97l1-4H5a1 1 0 110-2h2.47l.56-2.243a1 1 0 011.213-.727zM9.03 8l-1 4h2.938l1-4H9.031z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiGlobe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiGlobeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 5a3 3 0 015-2.236A3 3 0 0114.83 6H16a2 2 0 110 4h-5V9a1 1 0 10-2 0v1H4a2 2 0 110-4h1.17C5.06 5.687 5 5.35 5 5zm4 1V5a1 1 0 10-1 1h1zm3 0a1 1 0 10-1-1v1h1z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11H3v5a2 2 0 002 2h4v-7zM11 18h4a2 2 0 002-2v-5h-6v7z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFolderRemove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm4 6a1 1 0 100 2h4a1 1 0 100-2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H2h2a2 2 0 002-2v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFolderDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 10-2 0v1.586l-.293-.293a1 1 0 10-1.414 1.414l2 2 .002.002a.997.997 0 001.41 0l.002-.002 2-2a1 1 0 00-1.414-1.414l-.293.293V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFolderAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 10-2 0v1H8a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFingerPrint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.625 2.655A9 9 0 0119 11a1 1 0 11-2 0 7 7 0 00-9.625-6.492 1 1 0 11-.75-1.853zM4.662 4.959A1 1 0 014.75 6.37 6.97 6.97 0 003 11a1 1 0 11-2 0 8.97 8.97 0 012.25-5.953 1 1 0 011.412-.088z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 11a5 5 0 1110 0 1 1 0 11-2 0 3 3 0 10-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 11-1.838-.789A9.964 9.964 0 005 11zm8.921 2.012a1 1 0 01.831 1.145 19.86 19.86 0 01-.545 2.436 1 1 0 11-1.92-.558c.207-.713.371-1.445.49-2.192a1 1 0 011.144-.83z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 10a1 1 0 011 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 01-1.838-.789A13.952 13.952 0 009 11a1 1 0 011-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFilter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm3 2h6v4H7V5zm8 8v2h1v-2h-1zm-2-2H7v4h6v-4zm2 0h1V9h-1v2zm1-4V5h-1v2h1zM5 5v2H4V5h1zm0 4H4v2h1V9zm-1 4h1v2H4v-2z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFastForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.555 5.168A1 1 0 003 6v8a1 1 0 001.555.832L10 11.202V14a1 1 0 001.555.832l6-4a1 1 0 000-1.664l-6-4A1 1 0 0010 6v2.798l-5.445-3.63z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12a2 2 0 100-4 2 2 0 000 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEyeOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiExternalLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiExclamationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEmojiSad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-7.536 5.879a1 1 0 001.415 0 3 3 0 014.242 0 1 1 0 001.415-1.415 5 5 0 00-7.072 0 1 1 0 000 1.415z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEmojiHappy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDuplicate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDotsVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDotsHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDotsCircleHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentSearch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2h-1.528A6 6 0 004 9.528V4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 10a4 4 0 00-3.446 6.032l-1.261 1.26a1 1 0 101.414 1.415l1.261-1.261A4 4 0 108 10zm-2 4a2 2 0 114 0 2 2 0 01-4 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentReport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm4-1a1 1 0 10-2 0v7a1 1 0 102 0V8z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentRemove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm1 8a1 1 0 100 2h6a1 1 0 100-2H7z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentDuplicate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDeviceTablet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm4 14a1 1 0 100-2 1 1 0 000 2z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDeviceMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDesktopComputer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDatabase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCursorClick(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyYen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7.858 5.485a1 1 0 00-1.715 1.03L7.633 9H7a1 1 0 100 2h1.834l.166.277V12H7a1 1 0 100 2h2v1a1 1 0 102 0v-1h2a1 1 0 100-2h-2v-.723l.166-.277H13a1 1 0 100-2h-.634l1.492-2.486a1 1 0 10-1.716-1.029L10.034 9h-.068L7.858 5.485z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyRupee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 5a1 1 0 100 2h1a2 2 0 011.732 1H7a1 1 0 100 2h2.732A2 2 0 018 11H7a1 1 0 00-.707 1.707l3 3a1 1 0 001.414-1.414l-1.483-1.484A4.008 4.008 0 0011.874 10H13a1 1 0 100-2h-1.126a3.976 3.976 0 00-.41-1H13a1 1 0 100-2H7z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyPound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-14a3 3 0 00-3 3v2H7a1 1 0 000 2h1v1a1 1 0 01-1 1 1 1 0 100 2h6a1 1 0 100-2H9.83c.11-.313.17-.65.17-1v-1h1a1 1 0 100-2h-1V7a1 1 0 112 0 1 1 0 102 0 3 3 0 00-3-3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyEuro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM8.736 6.979C9.208 6.193 9.696 6 10 6c.304 0 .792.193 1.264.979a1 1 0 001.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 000 2h.013a9.358 9.358 0 000 1H6a1 1 0 100 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 10-1.715-1.029c-.472.786-.96.979-1.264.979-.304 0-.792-.193-1.264-.979a4.265 4.265 0 01-.264-.521H10a1 1 0 100-2H8.017a7.36 7.36 0 010-1H10a1 1 0 100-2H8.472c.08-.185.167-.36.264-.521z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyBangladeshi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM7 4a1 1 0 000 2 1 1 0 011 1v1H7a1 1 0 000 2h1v3a3 3 0 106 0v-1a1 1 0 10-2 0v1a1 1 0 11-2 0v-3h3a1 1 0 100-2h-3V7a3 3 0 00-3-3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCubeTransparent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.504 1.132a1 1 0 01.992 0l1.75 1a1 1 0 11-.992 1.736L10 3.152l-1.254.716a1 1 0 11-.992-1.736l1.75-1zM5.618 4.504a1 1 0 01-.372 1.364L5.016 6l.23.132a1 1 0 11-.992 1.736L4 7.723V8a1 1 0 01-2 0V6a.996.996 0 01.52-.878l1.734-.99a1 1 0 011.364.372zm8.764 0a1 1 0 011.364-.372l1.733.99A1.002 1.002 0 0118 6v2a1 1 0 11-2 0v-.277l-.254.145a1 1 0 11-.992-1.736l.23-.132-.23-.132a1 1 0 01-.372-1.364zm-7 4a1 1 0 011.364-.372L10 8.848l1.254-.716a1 1 0 11.992 1.736L11 10.58V12a1 1 0 11-2 0v-1.42l-1.246-.712a1 1 0 01-.372-1.364zM3 11a1 1 0 011 1v1.42l1.246.712a1 1 0 11-.992 1.736l-1.75-1A1 1 0 012 14v-2a1 1 0 011-1zm14 0a1 1 0 011 1v2a1 1 0 01-.504.868l-1.75 1a1 1 0 11-.992-1.736L16 13.42V12a1 1 0 011-1zm-9.618 5.504a1 1 0 011.364-.372l.254.145V16a1 1 0 112 0v.277l.254-.145a1 1 0 11.992 1.736l-1.735.992a.995.995 0 01-1.022 0l-1.735-.992a1 1 0 01-.372-1.364z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiColorSwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCollection(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 16a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 16h-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCloudUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 13a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 13H11V9.413l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13H5.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13h2v5a1 1 0 11-2 0v-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCloudDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 9.5A3.5 3.5 0 005.5 13H9v2.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 10-.616-8.958 4.002 4.002 0 10-7.753 1.977A3.5 3.5 0 002 9.5zm9 3.5H9V8a1 1 0 012 0v5z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiClipboardList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiClipboardCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a1 1 0 000 2h2a1 1 0 100-2H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v6h-4.586l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L10.414 13H15v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5zM15 11h2a1 1 0 110 2h-2v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiClipboardCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7H7v6h6V7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7 2a1 1 0 012 0v1h2V2a1 1 0 112 0v1h2a2 2 0 012 2v2h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v2a2 2 0 01-2 2h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5a2 2 0 01-2-2v-2H2a1 1 0 110-2h1V9H2a1 1 0 010-2h1V5a2 2 0 012-2h2V2zM5 5h10v10H5V5z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronDoubleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.293 15.707a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414 0zm0-6a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 5.414 5.707 9.707a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronDoubleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronDoubleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronDoubleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChatAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChatAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChartSquareBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChartPie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm1 2a1 1 0 000 2h6a1 1 0 100-2H7zm6 7a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-3 3a1 1 0 100 2h.01a1 1 0 100-2H10zm-4 1a1 1 0 011-1h.01a1 1 0 110 2H7a1 1 0 01-1-1zm1-4a1 1 0 100 2h.01a1 1 0 100-2H7zm2 1a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm4-4a1 1 0 100 2h.01a1 1 0 100-2H13zM9 9a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zM7 8a1 1 0 000 2h.01a1 1 0 000-2H7z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3a1 1 0 011-1h.01a1 1 0 010 2H7a1 1 0 01-1-1zm2 3a1 1 0 00-2 0v1a2 2 0 00-2 2v1a2 2 0 00-2 2v.683a3.7 3.7 0 011.055.485 1.704 1.704 0 001.89 0 3.704 3.704 0 014.11 0 1.704 1.704 0 001.89 0 3.704 3.704 0 014.11 0 1.704 1.704 0 001.89 0A3.7 3.7 0 0118 12.683V12a2 2 0 00-2-2V9a2 2 0 00-2-2V6a1 1 0 10-2 0v1h-1V6a1 1 0 10-2 0v1H8V6zm10 8.868a3.704 3.704 0 01-4.055-.036 1.704 1.704 0 00-1.89 0 3.704 3.704 0 01-4.11 0 1.704 1.704 0 00-1.89 0A3.704 3.704 0 012 14.868V17a1 1 0 001 1h14a1 1 0 001-1v-2.132zM9 3a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1zm3 0a1 1 0 011-1h.01a1 1 0 110 2H13a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBookmarkAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm11 1H6v8l4-2 4 2V6z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBookOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBeaker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7 2a1 1 0 00-.707 1.707L7 4.414v3.758a1 1 0 01-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0113 8.172V4.414l.707-.707A1 1 0 0013 2H7zm2 6.172V4h2v4.172a3 3 0 00.879 2.12l1.027 1.028a4 4 0 00-2.171.102l-.47.156a4 4 0 01-2.53 0l-.563-.187a1.993 1.993 0 00-.114-.035l1.063-1.063A3 3 0 009 8.172z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBadgeCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBackspace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.707 4.879A3 3 0 018.828 4H15a3 3 0 013 3v6a3 3 0 01-3 3H8.828a3 3 0 01-2.12-.879l-4.415-4.414a1 1 0 010-1.414l4.414-4.414zm4 2.414a1 1 0 00-1.414 1.414L10.586 10l-1.293 1.293a1 1 0 101.414 1.414L12 11.414l1.293 1.293a1 1 0 001.414-1.414L13.414 10l1.293-1.293a1 1 0 00-1.414-1.414L12 8.586l-1.293-1.293z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiAtSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowsExpand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 01-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 110-2h4a1 1 0 011 1v4a1 1 0 11-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 112 0v1.586l2.293-2.293a1 1 0 011.414 1.414L6.414 15H8a1 1 0 110 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 110-2h1.586l-2.293-2.293a1 1 0 011.414-1.414L15 13.586V12a1 1 0 011-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowSmUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowSmRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowSmLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowSmDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowNarrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowNarrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowNarrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowNarrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l2.293-2.293a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3a2 2 0 100 4h12a2 2 0 100-4H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiAnnotation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiAdjustments(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiAcademicCap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineZoomOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineZoomIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6 18L18 6M6 6l12 12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineXCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineWifi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineVolumeUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineVolumeOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineViewList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6h16M4 10h16M4 14h16M4 18h16"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineViewGrid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineViewGridAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineViewBoards(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineVideoCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineVariable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.871 4A17.926 17.926 0 003 12c0 2.874.673 5.59 1.871 8m14.13 0a17.926 17.926 0 001.87-8c0-2.874-.673-5.59-1.87-8M9 9h1.246a1 1 0 01.961.725l1.586 5.55a1 1 0 00.961.725H15m1-7h-.08a2 2 0 00-1.519.698L9.6 15.302A2 2 0 018.08 16H8"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUsers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUserRemove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUserGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUserAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTruck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTrendingUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTrendingDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTranslate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTicket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineThumbUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineThumbDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTerminal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTemplate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSwitchVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSwitchHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSupport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineStatusOnline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineStatusOffline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSpeakerphone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSortDescending(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSortAscending(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineShoppingCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineShoppingBag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineShieldExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineShieldCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineServer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSelector(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 9l4-4 4 4m0 6l-4 4-4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSearch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSearchCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.121 14.121L19 19m-7-7l7-7m-7 7l-2.879 2.879M12 12L9.121 9.121m0 5.758a3 3 0 10-4.243 4.243 3 3 0 004.243-4.243zm0-5.758a3 3 0 10-4.243-4.243 3 3 0 004.243 4.243z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineScale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSaveAs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 16v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2h2m3-4H9a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-1m-1 4l-3 3m0 0l-3-3m3 3V3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 017 7m-6 0a1 1 0 11-2 0 1 1 0 012 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineRewind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0019 16V8a1 1 0 00-1.6-.8l-5.333 4zM4.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0011 16V8a1 1 0 00-1.6-.8l-5.334 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineReply(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineRefresh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineReceiptTax(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineReceiptRefund(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineQuestionMarkCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineQrcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePuzzle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePrinter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePresentationChartLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePresentationChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 4v16m8-8H4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePlusSm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6v6m0 0v6m0-6h6m-6 0H6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePlusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePhotograph(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePhoneOutgoing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePhoneMissedCall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePhoneIncoming(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePencil(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePencilAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePaperClip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePaperAirplane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineOfficeBuilding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMusicNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20 12H4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMinusSm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18 12H6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMinusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMicrophone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMenu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6h16M4 12h16M4 18h16"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMenuAlt4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 8h16M4 16h16"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMenuAlt3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6h16M4 12h16m-7 6h7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMenuAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6h16M4 12h16M4 18h7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMenuAlt1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 6h16M4 12h8m-8 6h16"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMailOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLogout(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLogin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLockOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLockClosed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLocationMarker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLightningBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 10V3L4 14h7v7l9-11h-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLightBulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLibrary(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineInformationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineInbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineInboxIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineIdentification(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHashtag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineGlobe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineGlobeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFolderRemove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFolderDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFolderAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFingerPrint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFilter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFastForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11.933 12.8a1 1 0 000-1.6L6.6 7.2A1 1 0 005 8v8a1 1 0 001.6.8l5.333-4zM19.933 12.8a1 1 0 000-1.6l-5.333-4A1 1 0 0013 8v8a1 1 0 001.6.8l5.333-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEyeOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineExternalLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineExclamationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEmojiSad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEmojiHappy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDuplicate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDotsVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDotsHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDotsCircleHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentSearch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentReport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentRemove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentDuplicate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDeviceTablet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDeviceMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDesktopComputer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDatabase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCursorClick(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyYen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 8l3 5m0 0l3-5m-3 5v4m-3-5h6m-6 3h6m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyRupee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyPound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyEuro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyBangladeshi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 11V9a2 2 0 00-2-2m2 4v4a2 2 0 104 0v-1m-4-3H9m2 0h4m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCubeTransparent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineColorSwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCollection(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCloudUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCloudDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineClipboardList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineClipboardCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineClipboardCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 15l7-7 7 7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 5l7 7-7 7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 19l-7-7 7-7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 9l-7 7-7-7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronDoubleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 11l7-7 7 7M5 19l7-7 7 7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronDoubleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 5l7 7-7 7M5 5l7 7-7 7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronDoubleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 19l-7-7 7-7m8 14l-7-7 7-7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronDoubleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 13l-7 7-7-7m14-8l-7 7-7-7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 13l4 4L19 7"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChatAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChatAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChartSquareBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChartPie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.701 2.701 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBookmarkAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBookOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBeaker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBadgeCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBackspace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineAtSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowsExpand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 10l7-7m0 0l7 7m-7-7v18"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowSmUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 11l5-5m0 0l5 5m-5-5v12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowSmRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 7l5 5m0 0l-5 5m5-5H6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowSmLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 17l-5-5m0 0l5-5m-5 5h12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowSmDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 13l-5 5m0 0l-5-5m5 5V6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14 5l7 7m0 0l-7 7m7-7H3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowNarrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8 7l4-4m0 0l4 4m-4-4v18"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowNarrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17 8l4 4m0 0l-4 4m4-4H3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowNarrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 16l-4-4m0 0l4-4m-4 4h18"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowNarrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16 17l-4 4m0 0l-4-4m4 4V3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10 19l-7-7m0 0l7-7m-7 7h18"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19 14l-7 7m0 0l-7-7m7 7V3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineAnnotation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineAdjustments(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineAcademicCap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "2",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14l9-5-9-5-9 5 9 5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
                },
                "child": []
            }
        ]
    })(props);
}

},{"../lib/index.mjs":"c1xBV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"c1xBV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iconsManifestMjs = require("./iconsManifest.mjs");
parcelHelpers.exportAll(_iconsManifestMjs, exports);
var _iconBaseMjs = require("./iconBase.mjs");
parcelHelpers.exportAll(_iconBaseMjs, exports);
var _iconContextMjs = require("./iconContext.mjs");
parcelHelpers.exportAll(_iconContextMjs, exports);

},{"./iconsManifest.mjs":"5A185","./iconBase.mjs":"l9fYH","./iconContext.mjs":"fo5nJ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5A185":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsManifest", ()=>IconsManifest);
var IconsManifest = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "MIT",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"l9fYH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenIcon", ()=>GenIcon);
parcelHelpers.export(exports, "IconBase", ()=>IconBase);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconContextMjs = require("./iconContext.mjs");
var _excluded = [
    "attr",
    "size",
    "title"
];
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function Tree2Element(tree) {
    return tree && tree.map((node, i)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(node.tag, _objectSpread({
            key: i
        }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
    return (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(IconBase, _extends({
            attr: _objectSpread({}, data.attr)
        }, props), Tree2Element(data.child));
}
function IconBase(props) {
    var elem = (conf)=>{
        var { attr, size, title } = props, svgProps = _objectWithoutProperties(props, _excluded);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: _objectSpread(_objectSpread({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title), props.children);
    };
    return (0, _iconContextMjs.IconContext) !== undefined ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconContextMjs.IconContext).Consumer, null, (conf)=>elem(conf)) : elem((0, _iconContextMjs.DefaultContext));
}

},{"react":"2o0ib","./iconContext.mjs":"fo5nJ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fo5nJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultContext", ()=>DefaultContext);
parcelHelpers.export(exports, "IconContext", ()=>IconContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DefaultContext = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var IconContext = (0, _reactDefault.default).createContext && /*#__PURE__*/ (0, _reactDefault.default).createContext(DefaultContext);

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9Vrsi":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FaZhihu", ()=>FaZhihu);
parcelHelpers.export(exports, "FaYoutube", ()=>FaYoutube);
parcelHelpers.export(exports, "FaYoutubeSquare", ()=>FaYoutubeSquare);
parcelHelpers.export(exports, "FaYoast", ()=>FaYoast);
parcelHelpers.export(exports, "FaYelp", ()=>FaYelp);
parcelHelpers.export(exports, "FaYarn", ()=>FaYarn);
parcelHelpers.export(exports, "FaYandex", ()=>FaYandex);
parcelHelpers.export(exports, "FaYandexInternational", ()=>FaYandexInternational);
parcelHelpers.export(exports, "FaYammer", ()=>FaYammer);
parcelHelpers.export(exports, "FaYahoo", ()=>FaYahoo);
parcelHelpers.export(exports, "FaYCombinator", ()=>FaYCombinator);
parcelHelpers.export(exports, "FaXing", ()=>FaXing);
parcelHelpers.export(exports, "FaXingSquare", ()=>FaXingSquare);
parcelHelpers.export(exports, "FaXbox", ()=>FaXbox);
parcelHelpers.export(exports, "FaWpressr", ()=>FaWpressr);
parcelHelpers.export(exports, "FaWpforms", ()=>FaWpforms);
parcelHelpers.export(exports, "FaWpexplorer", ()=>FaWpexplorer);
parcelHelpers.export(exports, "FaWpbeginner", ()=>FaWpbeginner);
parcelHelpers.export(exports, "FaWordpress", ()=>FaWordpress);
parcelHelpers.export(exports, "FaWordpressSimple", ()=>FaWordpressSimple);
parcelHelpers.export(exports, "FaWolfPackBattalion", ()=>FaWolfPackBattalion);
parcelHelpers.export(exports, "FaWodu", ()=>FaWodu);
parcelHelpers.export(exports, "FaWizardsOfTheCoast", ()=>FaWizardsOfTheCoast);
parcelHelpers.export(exports, "FaWix", ()=>FaWix);
parcelHelpers.export(exports, "FaWindows", ()=>FaWindows);
parcelHelpers.export(exports, "FaWikipediaW", ()=>FaWikipediaW);
parcelHelpers.export(exports, "FaWhmcs", ()=>FaWhmcs);
parcelHelpers.export(exports, "FaWhatsapp", ()=>FaWhatsapp);
parcelHelpers.export(exports, "FaWhatsappSquare", ()=>FaWhatsappSquare);
parcelHelpers.export(exports, "FaWeixin", ()=>FaWeixin);
parcelHelpers.export(exports, "FaWeibo", ()=>FaWeibo);
parcelHelpers.export(exports, "FaWeebly", ()=>FaWeebly);
parcelHelpers.export(exports, "FaWaze", ()=>FaWaze);
parcelHelpers.export(exports, "FaWatchmanMonitoring", ()=>FaWatchmanMonitoring);
parcelHelpers.export(exports, "FaVuejs", ()=>FaVuejs);
parcelHelpers.export(exports, "FaVnv", ()=>FaVnv);
parcelHelpers.export(exports, "FaVk", ()=>FaVk);
parcelHelpers.export(exports, "FaVine", ()=>FaVine);
parcelHelpers.export(exports, "FaVimeo", ()=>FaVimeo);
parcelHelpers.export(exports, "FaVimeoV", ()=>FaVimeoV);
parcelHelpers.export(exports, "FaVimeoSquare", ()=>FaVimeoSquare);
parcelHelpers.export(exports, "FaViber", ()=>FaViber);
parcelHelpers.export(exports, "FaViadeo", ()=>FaViadeo);
parcelHelpers.export(exports, "FaViadeoSquare", ()=>FaViadeoSquare);
parcelHelpers.export(exports, "FaViacoin", ()=>FaViacoin);
parcelHelpers.export(exports, "FaVaadin", ()=>FaVaadin);
parcelHelpers.export(exports, "FaUssunnah", ()=>FaUssunnah);
parcelHelpers.export(exports, "FaUsps", ()=>FaUsps);
parcelHelpers.export(exports, "FaUsb", ()=>FaUsb);
parcelHelpers.export(exports, "FaUps", ()=>FaUps);
parcelHelpers.export(exports, "FaUntappd", ()=>FaUntappd);
parcelHelpers.export(exports, "FaUnsplash", ()=>FaUnsplash);
parcelHelpers.export(exports, "FaUnity", ()=>FaUnity);
parcelHelpers.export(exports, "FaUniregistry", ()=>FaUniregistry);
parcelHelpers.export(exports, "FaUncharted", ()=>FaUncharted);
parcelHelpers.export(exports, "FaUmbraco", ()=>FaUmbraco);
parcelHelpers.export(exports, "FaUikit", ()=>FaUikit);
parcelHelpers.export(exports, "FaUbuntu", ()=>FaUbuntu);
parcelHelpers.export(exports, "FaUber", ()=>FaUber);
parcelHelpers.export(exports, "FaTypo3", ()=>FaTypo3);
parcelHelpers.export(exports, "FaTwitter", ()=>FaTwitter);
parcelHelpers.export(exports, "FaTwitterSquare", ()=>FaTwitterSquare);
parcelHelpers.export(exports, "FaTwitch", ()=>FaTwitch);
parcelHelpers.export(exports, "FaTumblr", ()=>FaTumblr);
parcelHelpers.export(exports, "FaTumblrSquare", ()=>FaTumblrSquare);
parcelHelpers.export(exports, "FaTripadvisor", ()=>FaTripadvisor);
parcelHelpers.export(exports, "FaTrello", ()=>FaTrello);
parcelHelpers.export(exports, "FaTradeFederation", ()=>FaTradeFederation);
parcelHelpers.export(exports, "FaTiktok", ()=>FaTiktok);
parcelHelpers.export(exports, "FaThinkPeaks", ()=>FaThinkPeaks);
parcelHelpers.export(exports, "FaThemeisle", ()=>FaThemeisle);
parcelHelpers.export(exports, "FaThemeco", ()=>FaThemeco);
parcelHelpers.export(exports, "FaTheRedYeti", ()=>FaTheRedYeti);
parcelHelpers.export(exports, "FaTencentWeibo", ()=>FaTencentWeibo);
parcelHelpers.export(exports, "FaTelegram", ()=>FaTelegram);
parcelHelpers.export(exports, "FaTelegramPlane", ()=>FaTelegramPlane);
parcelHelpers.export(exports, "FaTeamspeak", ()=>FaTeamspeak);
parcelHelpers.export(exports, "FaSymfony", ()=>FaSymfony);
parcelHelpers.export(exports, "FaSwift", ()=>FaSwift);
parcelHelpers.export(exports, "FaSuse", ()=>FaSuse);
parcelHelpers.export(exports, "FaSupple", ()=>FaSupple);
parcelHelpers.export(exports, "FaSuperpowers", ()=>FaSuperpowers);
parcelHelpers.export(exports, "FaStumbleupon", ()=>FaStumbleupon);
parcelHelpers.export(exports, "FaStumbleuponCircle", ()=>FaStumbleuponCircle);
parcelHelpers.export(exports, "FaStudiovinari", ()=>FaStudiovinari);
parcelHelpers.export(exports, "FaStripe", ()=>FaStripe);
parcelHelpers.export(exports, "FaStripeS", ()=>FaStripeS);
parcelHelpers.export(exports, "FaStrava", ()=>FaStrava);
parcelHelpers.export(exports, "FaStickerMule", ()=>FaStickerMule);
parcelHelpers.export(exports, "FaSteam", ()=>FaSteam);
parcelHelpers.export(exports, "FaSteamSymbol", ()=>FaSteamSymbol);
parcelHelpers.export(exports, "FaSteamSquare", ()=>FaSteamSquare);
parcelHelpers.export(exports, "FaStaylinked", ()=>FaStaylinked);
parcelHelpers.export(exports, "FaStackpath", ()=>FaStackpath);
parcelHelpers.export(exports, "FaStackOverflow", ()=>FaStackOverflow);
parcelHelpers.export(exports, "FaStackExchange", ()=>FaStackExchange);
parcelHelpers.export(exports, "FaSquarespace", ()=>FaSquarespace);
parcelHelpers.export(exports, "FaSpotify", ()=>FaSpotify);
parcelHelpers.export(exports, "FaSpeakerDeck", ()=>FaSpeakerDeck);
parcelHelpers.export(exports, "FaSpeakap", ()=>FaSpeakap);
parcelHelpers.export(exports, "FaSourcetree", ()=>FaSourcetree);
parcelHelpers.export(exports, "FaSoundcloud", ()=>FaSoundcloud);
parcelHelpers.export(exports, "FaSnapchat", ()=>FaSnapchat);
parcelHelpers.export(exports, "FaSnapchatSquare", ()=>FaSnapchatSquare);
parcelHelpers.export(exports, "FaSnapchatGhost", ()=>FaSnapchatGhost);
parcelHelpers.export(exports, "FaSlideshare", ()=>FaSlideshare);
parcelHelpers.export(exports, "FaSlack", ()=>FaSlack);
parcelHelpers.export(exports, "FaSlackHash", ()=>FaSlackHash);
parcelHelpers.export(exports, "FaSkype", ()=>FaSkype);
parcelHelpers.export(exports, "FaSkyatlas", ()=>FaSkyatlas);
parcelHelpers.export(exports, "FaSketch", ()=>FaSketch);
parcelHelpers.export(exports, "FaSith", ()=>FaSith);
parcelHelpers.export(exports, "FaSistrix", ()=>FaSistrix);
parcelHelpers.export(exports, "FaSimplybuilt", ()=>FaSimplybuilt);
parcelHelpers.export(exports, "FaShopware", ()=>FaShopware);
parcelHelpers.export(exports, "FaShopify", ()=>FaShopify);
parcelHelpers.export(exports, "FaShirtsinbulk", ()=>FaShirtsinbulk);
parcelHelpers.export(exports, "FaServicestack", ()=>FaServicestack);
parcelHelpers.export(exports, "FaSellsy", ()=>FaSellsy);
parcelHelpers.export(exports, "FaSellcast", ()=>FaSellcast);
parcelHelpers.export(exports, "FaSearchengin", ()=>FaSearchengin);
parcelHelpers.export(exports, "FaScribd", ()=>FaScribd);
parcelHelpers.export(exports, "FaSchlix", ()=>FaSchlix);
parcelHelpers.export(exports, "FaSass", ()=>FaSass);
parcelHelpers.export(exports, "FaSalesforce", ()=>FaSalesforce);
parcelHelpers.export(exports, "FaSafari", ()=>FaSafari);
parcelHelpers.export(exports, "FaRust", ()=>FaRust);
parcelHelpers.export(exports, "FaRockrms", ()=>FaRockrms);
parcelHelpers.export(exports, "FaRocketchat", ()=>FaRocketchat);
parcelHelpers.export(exports, "FaRev", ()=>FaRev);
parcelHelpers.export(exports, "FaResolving", ()=>FaResolving);
parcelHelpers.export(exports, "FaResearchgate", ()=>FaResearchgate);
parcelHelpers.export(exports, "FaReplyd", ()=>FaReplyd);
parcelHelpers.export(exports, "FaRenren", ()=>FaRenren);
parcelHelpers.export(exports, "FaRedhat", ()=>FaRedhat);
parcelHelpers.export(exports, "FaReddit", ()=>FaReddit);
parcelHelpers.export(exports, "FaRedditSquare", ()=>FaRedditSquare);
parcelHelpers.export(exports, "FaRedditAlien", ()=>FaRedditAlien);
parcelHelpers.export(exports, "FaRedRiver", ()=>FaRedRiver);
parcelHelpers.export(exports, "FaRebel", ()=>FaRebel);
parcelHelpers.export(exports, "FaReadme", ()=>FaReadme);
parcelHelpers.export(exports, "FaReacteurope", ()=>FaReacteurope);
parcelHelpers.export(exports, "FaReact", ()=>FaReact);
parcelHelpers.export(exports, "FaRavelry", ()=>FaRavelry);
parcelHelpers.export(exports, "FaRaspberryPi", ()=>FaRaspberryPi);
parcelHelpers.export(exports, "FaRProject", ()=>FaRProject);
parcelHelpers.export(exports, "FaQuora", ()=>FaQuora);
parcelHelpers.export(exports, "FaQuinscape", ()=>FaQuinscape);
parcelHelpers.export(exports, "FaQq", ()=>FaQq);
parcelHelpers.export(exports, "FaPython", ()=>FaPython);
parcelHelpers.export(exports, "FaPushed", ()=>FaPushed);
parcelHelpers.export(exports, "FaProductHunt", ()=>FaProductHunt);
parcelHelpers.export(exports, "FaPlaystation", ()=>FaPlaystation);
parcelHelpers.export(exports, "FaPinterest", ()=>FaPinterest);
parcelHelpers.export(exports, "FaPinterestSquare", ()=>FaPinterestSquare);
parcelHelpers.export(exports, "FaPinterestP", ()=>FaPinterestP);
parcelHelpers.export(exports, "FaPiedPiper", ()=>FaPiedPiper);
parcelHelpers.export(exports, "FaPiedPiperSquare", ()=>FaPiedPiperSquare);
parcelHelpers.export(exports, "FaPiedPiperPp", ()=>FaPiedPiperPp);
parcelHelpers.export(exports, "FaPiedPiperHat", ()=>FaPiedPiperHat);
parcelHelpers.export(exports, "FaPiedPiperAlt", ()=>FaPiedPiperAlt);
parcelHelpers.export(exports, "FaPhp", ()=>FaPhp);
parcelHelpers.export(exports, "FaPhoenixSquadron", ()=>FaPhoenixSquadron);
parcelHelpers.export(exports, "FaPhoenixFramework", ()=>FaPhoenixFramework);
parcelHelpers.export(exports, "FaPhabricator", ()=>FaPhabricator);
parcelHelpers.export(exports, "FaPeriscope", ()=>FaPeriscope);
parcelHelpers.export(exports, "FaPerbyte", ()=>FaPerbyte);
parcelHelpers.export(exports, "FaPennyArcade", ()=>FaPennyArcade);
parcelHelpers.export(exports, "FaPaypal", ()=>FaPaypal);
parcelHelpers.export(exports, "FaPatreon", ()=>FaPatreon);
parcelHelpers.export(exports, "FaPalfed", ()=>FaPalfed);
parcelHelpers.export(exports, "FaPagelines", ()=>FaPagelines);
parcelHelpers.export(exports, "FaPage4", ()=>FaPage4);
parcelHelpers.export(exports, "FaOsi", ()=>FaOsi);
parcelHelpers.export(exports, "FaOrcid", ()=>FaOrcid);
parcelHelpers.export(exports, "FaOptinMonster", ()=>FaOptinMonster);
parcelHelpers.export(exports, "FaOpera", ()=>FaOpera);
parcelHelpers.export(exports, "FaOpenid", ()=>FaOpenid);
parcelHelpers.export(exports, "FaOpencart", ()=>FaOpencart);
parcelHelpers.export(exports, "FaOldRepublic", ()=>FaOldRepublic);
parcelHelpers.export(exports, "FaOdnoklassniki", ()=>FaOdnoklassniki);
parcelHelpers.export(exports, "FaOdnoklassnikiSquare", ()=>FaOdnoklassnikiSquare);
parcelHelpers.export(exports, "FaOctopusDeploy", ()=>FaOctopusDeploy);
parcelHelpers.export(exports, "FaNutritionix", ()=>FaNutritionix);
parcelHelpers.export(exports, "FaNs8", ()=>FaNs8);
parcelHelpers.export(exports, "FaNpm", ()=>FaNpm);
parcelHelpers.export(exports, "FaNode", ()=>FaNode);
parcelHelpers.export(exports, "FaNodeJs", ()=>FaNodeJs);
parcelHelpers.export(exports, "FaNimblr", ()=>FaNimblr);
parcelHelpers.export(exports, "FaNeos", ()=>FaNeos);
parcelHelpers.export(exports, "FaNapster", ()=>FaNapster);
parcelHelpers.export(exports, "FaMonero", ()=>FaMonero);
parcelHelpers.export(exports, "FaModx", ()=>FaModx);
parcelHelpers.export(exports, "FaMizuni", ()=>FaMizuni);
parcelHelpers.export(exports, "FaMixer", ()=>FaMixer);
parcelHelpers.export(exports, "FaMixcloud", ()=>FaMixcloud);
parcelHelpers.export(exports, "FaMix", ()=>FaMix);
parcelHelpers.export(exports, "FaMicrosoft", ()=>FaMicrosoft);
parcelHelpers.export(exports, "FaMicroblog", ()=>FaMicroblog);
parcelHelpers.export(exports, "FaMendeley", ()=>FaMendeley);
parcelHelpers.export(exports, "FaMegaport", ()=>FaMegaport);
parcelHelpers.export(exports, "FaMeetup", ()=>FaMeetup);
parcelHelpers.export(exports, "FaMedrt", ()=>FaMedrt);
parcelHelpers.export(exports, "FaMedium", ()=>FaMedium);
parcelHelpers.export(exports, "FaMediumM", ()=>FaMediumM);
parcelHelpers.export(exports, "FaMedapps", ()=>FaMedapps);
parcelHelpers.export(exports, "FaMdb", ()=>FaMdb);
parcelHelpers.export(exports, "FaMaxcdn", ()=>FaMaxcdn);
parcelHelpers.export(exports, "FaMastodon", ()=>FaMastodon);
parcelHelpers.export(exports, "FaMarkdown", ()=>FaMarkdown);
parcelHelpers.export(exports, "FaMandalorian", ()=>FaMandalorian);
parcelHelpers.export(exports, "FaMailchimp", ()=>FaMailchimp);
parcelHelpers.export(exports, "FaMagento", ()=>FaMagento);
parcelHelpers.export(exports, "FaLyft", ()=>FaLyft);
parcelHelpers.export(exports, "FaLinux", ()=>FaLinux);
parcelHelpers.export(exports, "FaLinode", ()=>FaLinode);
parcelHelpers.export(exports, "FaLinkedin", ()=>FaLinkedin);
parcelHelpers.export(exports, "FaLinkedinIn", ()=>FaLinkedinIn);
parcelHelpers.export(exports, "FaLine", ()=>FaLine);
parcelHelpers.export(exports, "FaLess", ()=>FaLess);
parcelHelpers.export(exports, "FaLeanpub", ()=>FaLeanpub);
parcelHelpers.export(exports, "FaLastfm", ()=>FaLastfm);
parcelHelpers.export(exports, "FaLastfmSquare", ()=>FaLastfmSquare);
parcelHelpers.export(exports, "FaLaravel", ()=>FaLaravel);
parcelHelpers.export(exports, "FaKorvue", ()=>FaKorvue);
parcelHelpers.export(exports, "FaKickstarter", ()=>FaKickstarter);
parcelHelpers.export(exports, "FaKickstarterK", ()=>FaKickstarterK);
parcelHelpers.export(exports, "FaKeycdn", ()=>FaKeycdn);
parcelHelpers.export(exports, "FaKeybase", ()=>FaKeybase);
parcelHelpers.export(exports, "FaKaggle", ()=>FaKaggle);
parcelHelpers.export(exports, "FaJsfiddle", ()=>FaJsfiddle);
parcelHelpers.export(exports, "FaJs", ()=>FaJs);
parcelHelpers.export(exports, "FaJsSquare", ()=>FaJsSquare);
parcelHelpers.export(exports, "FaJoomla", ()=>FaJoomla);
parcelHelpers.export(exports, "FaJoget", ()=>FaJoget);
parcelHelpers.export(exports, "FaJira", ()=>FaJira);
parcelHelpers.export(exports, "FaJenkins", ()=>FaJenkins);
parcelHelpers.export(exports, "FaJediOrder", ()=>FaJediOrder);
parcelHelpers.export(exports, "FaJava", ()=>FaJava);
parcelHelpers.export(exports, "FaItunes", ()=>FaItunes);
parcelHelpers.export(exports, "FaItunesNote", ()=>FaItunesNote);
parcelHelpers.export(exports, "FaItchIo", ()=>FaItchIo);
parcelHelpers.export(exports, "FaIoxhost", ()=>FaIoxhost);
parcelHelpers.export(exports, "FaInvision", ()=>FaInvision);
parcelHelpers.export(exports, "FaInternetExplorer", ()=>FaInternetExplorer);
parcelHelpers.export(exports, "FaIntercom", ()=>FaIntercom);
parcelHelpers.export(exports, "FaInstalod", ()=>FaInstalod);
parcelHelpers.export(exports, "FaInstagram", ()=>FaInstagram);
parcelHelpers.export(exports, "FaInstagramSquare", ()=>FaInstagramSquare);
parcelHelpers.export(exports, "FaInnosoft", ()=>FaInnosoft);
parcelHelpers.export(exports, "FaImdb", ()=>FaImdb);
parcelHelpers.export(exports, "FaIdeal", ()=>FaIdeal);
parcelHelpers.export(exports, "FaHubspot", ()=>FaHubspot);
parcelHelpers.export(exports, "FaHtml5", ()=>FaHtml5);
parcelHelpers.export(exports, "FaHouzz", ()=>FaHouzz);
parcelHelpers.export(exports, "FaHotjar", ()=>FaHotjar);
parcelHelpers.export(exports, "FaHornbill", ()=>FaHornbill);
parcelHelpers.export(exports, "FaHooli", ()=>FaHooli);
parcelHelpers.export(exports, "FaHive", ()=>FaHive);
parcelHelpers.export(exports, "FaHireAHelper", ()=>FaHireAHelper);
parcelHelpers.export(exports, "FaHips", ()=>FaHips);
parcelHelpers.export(exports, "FaHackerrank", ()=>FaHackerrank);
parcelHelpers.export(exports, "FaHackerNews", ()=>FaHackerNews);
parcelHelpers.export(exports, "FaHackerNewsSquare", ()=>FaHackerNewsSquare);
parcelHelpers.export(exports, "FaGulp", ()=>FaGulp);
parcelHelpers.export(exports, "FaGuilded", ()=>FaGuilded);
parcelHelpers.export(exports, "FaGrunt", ()=>FaGrunt);
parcelHelpers.export(exports, "FaGripfire", ()=>FaGripfire);
parcelHelpers.export(exports, "FaGrav", ()=>FaGrav);
parcelHelpers.export(exports, "FaGratipay", ()=>FaGratipay);
parcelHelpers.export(exports, "FaGoogle", ()=>FaGoogle);
parcelHelpers.export(exports, "FaGoogleWallet", ()=>FaGoogleWallet);
parcelHelpers.export(exports, "FaGooglePlus", ()=>FaGooglePlus);
parcelHelpers.export(exports, "FaGooglePlusSquare", ()=>FaGooglePlusSquare);
parcelHelpers.export(exports, "FaGooglePlusG", ()=>FaGooglePlusG);
parcelHelpers.export(exports, "FaGooglePlay", ()=>FaGooglePlay);
parcelHelpers.export(exports, "FaGooglePay", ()=>FaGooglePay);
parcelHelpers.export(exports, "FaGoogleDrive", ()=>FaGoogleDrive);
parcelHelpers.export(exports, "FaGoodreads", ()=>FaGoodreads);
parcelHelpers.export(exports, "FaGoodreadsG", ()=>FaGoodreadsG);
parcelHelpers.export(exports, "FaGofore", ()=>FaGofore);
parcelHelpers.export(exports, "FaGlide", ()=>FaGlide);
parcelHelpers.export(exports, "FaGlideG", ()=>FaGlideG);
parcelHelpers.export(exports, "FaGitter", ()=>FaGitter);
parcelHelpers.export(exports, "FaGitlab", ()=>FaGitlab);
parcelHelpers.export(exports, "FaGitkraken", ()=>FaGitkraken);
parcelHelpers.export(exports, "FaGithub", ()=>FaGithub);
parcelHelpers.export(exports, "FaGithubSquare", ()=>FaGithubSquare);
parcelHelpers.export(exports, "FaGithubAlt", ()=>FaGithubAlt);
parcelHelpers.export(exports, "FaGit", ()=>FaGit);
parcelHelpers.export(exports, "FaGitSquare", ()=>FaGitSquare);
parcelHelpers.export(exports, "FaGitAlt", ()=>FaGitAlt);
parcelHelpers.export(exports, "FaGg", ()=>FaGg);
parcelHelpers.export(exports, "FaGgCircle", ()=>FaGgCircle);
parcelHelpers.export(exports, "FaGetPocket", ()=>FaGetPocket);
parcelHelpers.export(exports, "FaGalacticSenate", ()=>FaGalacticSenate);
parcelHelpers.export(exports, "FaGalacticRepublic", ()=>FaGalacticRepublic);
parcelHelpers.export(exports, "FaFulcrum", ()=>FaFulcrum);
parcelHelpers.export(exports, "FaFreebsd", ()=>FaFreebsd);
parcelHelpers.export(exports, "FaFreeCodeCamp", ()=>FaFreeCodeCamp);
parcelHelpers.export(exports, "FaFoursquare", ()=>FaFoursquare);
parcelHelpers.export(exports, "FaForumbee", ()=>FaForumbee);
parcelHelpers.export(exports, "FaFortAwesome", ()=>FaFortAwesome);
parcelHelpers.export(exports, "FaFortAwesomeAlt", ()=>FaFortAwesomeAlt);
parcelHelpers.export(exports, "FaFonticons", ()=>FaFonticons);
parcelHelpers.export(exports, "FaFonticonsFi", ()=>FaFonticonsFi);
parcelHelpers.export(exports, "FaFontAwesome", ()=>FaFontAwesome);
parcelHelpers.export(exports, "FaFontAwesomeLogoFull", ()=>FaFontAwesomeLogoFull);
parcelHelpers.export(exports, "FaFontAwesomeFlag", ()=>FaFontAwesomeFlag);
parcelHelpers.export(exports, "FaFontAwesomeAlt", ()=>FaFontAwesomeAlt);
parcelHelpers.export(exports, "FaFly", ()=>FaFly);
parcelHelpers.export(exports, "FaFlipboard", ()=>FaFlipboard);
parcelHelpers.export(exports, "FaFlickr", ()=>FaFlickr);
parcelHelpers.export(exports, "FaFirstdraft", ()=>FaFirstdraft);
parcelHelpers.export(exports, "FaFirstOrder", ()=>FaFirstOrder);
parcelHelpers.export(exports, "FaFirstOrderAlt", ()=>FaFirstOrderAlt);
parcelHelpers.export(exports, "FaFirefox", ()=>FaFirefox);
parcelHelpers.export(exports, "FaFirefoxBrowser", ()=>FaFirefoxBrowser);
parcelHelpers.export(exports, "FaFigma", ()=>FaFigma);
parcelHelpers.export(exports, "FaFedora", ()=>FaFedora);
parcelHelpers.export(exports, "FaFedex", ()=>FaFedex);
parcelHelpers.export(exports, "FaFantasyFlightGames", ()=>FaFantasyFlightGames);
parcelHelpers.export(exports, "FaFacebook", ()=>FaFacebook);
parcelHelpers.export(exports, "FaFacebookSquare", ()=>FaFacebookSquare);
parcelHelpers.export(exports, "FaFacebookMessenger", ()=>FaFacebookMessenger);
parcelHelpers.export(exports, "FaFacebookF", ()=>FaFacebookF);
parcelHelpers.export(exports, "FaExpeditedssl", ()=>FaExpeditedssl);
parcelHelpers.export(exports, "FaEvernote", ()=>FaEvernote);
parcelHelpers.export(exports, "FaEtsy", ()=>FaEtsy);
parcelHelpers.export(exports, "FaEthereum", ()=>FaEthereum);
parcelHelpers.export(exports, "FaErlang", ()=>FaErlang);
parcelHelpers.export(exports, "FaEnvira", ()=>FaEnvira);
parcelHelpers.export(exports, "FaEmpire", ()=>FaEmpire);
parcelHelpers.export(exports, "FaEmber", ()=>FaEmber);
parcelHelpers.export(exports, "FaEllo", ()=>FaEllo);
parcelHelpers.export(exports, "FaElementor", ()=>FaElementor);
parcelHelpers.export(exports, "FaEdge", ()=>FaEdge);
parcelHelpers.export(exports, "FaEdgeLegacy", ()=>FaEdgeLegacy);
parcelHelpers.export(exports, "FaEbay", ()=>FaEbay);
parcelHelpers.export(exports, "FaEarlybirds", ()=>FaEarlybirds);
parcelHelpers.export(exports, "FaDyalog", ()=>FaDyalog);
parcelHelpers.export(exports, "FaDrupal", ()=>FaDrupal);
parcelHelpers.export(exports, "FaDropbox", ()=>FaDropbox);
parcelHelpers.export(exports, "FaDribbble", ()=>FaDribbble);
parcelHelpers.export(exports, "FaDribbbleSquare", ()=>FaDribbbleSquare);
parcelHelpers.export(exports, "FaDraft2Digital", ()=>FaDraft2Digital);
parcelHelpers.export(exports, "FaDocker", ()=>FaDocker);
parcelHelpers.export(exports, "FaDochub", ()=>FaDochub);
parcelHelpers.export(exports, "FaDiscourse", ()=>FaDiscourse);
parcelHelpers.export(exports, "FaDiscord", ()=>FaDiscord);
parcelHelpers.export(exports, "FaDigitalOcean", ()=>FaDigitalOcean);
parcelHelpers.export(exports, "FaDigg", ()=>FaDigg);
parcelHelpers.export(exports, "FaDiaspora", ()=>FaDiaspora);
parcelHelpers.export(exports, "FaDhl", ()=>FaDhl);
parcelHelpers.export(exports, "FaDeviantart", ()=>FaDeviantart);
parcelHelpers.export(exports, "FaDev", ()=>FaDev);
parcelHelpers.export(exports, "FaDeskpro", ()=>FaDeskpro);
parcelHelpers.export(exports, "FaDeploydog", ()=>FaDeploydog);
parcelHelpers.export(exports, "FaDelicious", ()=>FaDelicious);
parcelHelpers.export(exports, "FaDeezer", ()=>FaDeezer);
parcelHelpers.export(exports, "FaDashcube", ()=>FaDashcube);
parcelHelpers.export(exports, "FaDailymotion", ()=>FaDailymotion);
parcelHelpers.export(exports, "FaDAndD", ()=>FaDAndD);
parcelHelpers.export(exports, "FaDAndDBeyond", ()=>FaDAndDBeyond);
parcelHelpers.export(exports, "FaCuttlefish", ()=>FaCuttlefish);
parcelHelpers.export(exports, "FaCss3", ()=>FaCss3);
parcelHelpers.export(exports, "FaCss3Alt", ()=>FaCss3Alt);
parcelHelpers.export(exports, "FaCriticalRole", ()=>FaCriticalRole);
parcelHelpers.export(exports, "FaCreativeCommons", ()=>FaCreativeCommons);
parcelHelpers.export(exports, "FaCreativeCommonsZero", ()=>FaCreativeCommonsZero);
parcelHelpers.export(exports, "FaCreativeCommonsShare", ()=>FaCreativeCommonsShare);
parcelHelpers.export(exports, "FaCreativeCommonsSampling", ()=>FaCreativeCommonsSampling);
parcelHelpers.export(exports, "FaCreativeCommonsSamplingPlus", ()=>FaCreativeCommonsSamplingPlus);
parcelHelpers.export(exports, "FaCreativeCommonsSa", ()=>FaCreativeCommonsSa);
parcelHelpers.export(exports, "FaCreativeCommonsRemix", ()=>FaCreativeCommonsRemix);
parcelHelpers.export(exports, "FaCreativeCommonsPd", ()=>FaCreativeCommonsPd);
parcelHelpers.export(exports, "FaCreativeCommonsPdAlt", ()=>FaCreativeCommonsPdAlt);
parcelHelpers.export(exports, "FaCreativeCommonsNd", ()=>FaCreativeCommonsNd);
parcelHelpers.export(exports, "FaCreativeCommonsNc", ()=>FaCreativeCommonsNc);
parcelHelpers.export(exports, "FaCreativeCommonsNcJp", ()=>FaCreativeCommonsNcJp);
parcelHelpers.export(exports, "FaCreativeCommonsNcEu", ()=>FaCreativeCommonsNcEu);
parcelHelpers.export(exports, "FaCreativeCommonsBy", ()=>FaCreativeCommonsBy);
parcelHelpers.export(exports, "FaCpanel", ()=>FaCpanel);
parcelHelpers.export(exports, "FaCottonBureau", ()=>FaCottonBureau);
parcelHelpers.export(exports, "FaContao", ()=>FaContao);
parcelHelpers.export(exports, "FaConnectdevelop", ()=>FaConnectdevelop);
parcelHelpers.export(exports, "FaConfluence", ()=>FaConfluence);
parcelHelpers.export(exports, "FaCodiepie", ()=>FaCodiepie);
parcelHelpers.export(exports, "FaCodepen", ()=>FaCodepen);
parcelHelpers.export(exports, "FaCloudversify", ()=>FaCloudversify);
parcelHelpers.export(exports, "FaCloudsmith", ()=>FaCloudsmith);
parcelHelpers.export(exports, "FaCloudscale", ()=>FaCloudscale);
parcelHelpers.export(exports, "FaCloudflare", ()=>FaCloudflare);
parcelHelpers.export(exports, "FaChromecast", ()=>FaChromecast);
parcelHelpers.export(exports, "FaChrome", ()=>FaChrome);
parcelHelpers.export(exports, "FaCentos", ()=>FaCentos);
parcelHelpers.export(exports, "FaCentercode", ()=>FaCentercode);
parcelHelpers.export(exports, "FaCcVisa", ()=>FaCcVisa);
parcelHelpers.export(exports, "FaCcStripe", ()=>FaCcStripe);
parcelHelpers.export(exports, "FaCcPaypal", ()=>FaCcPaypal);
parcelHelpers.export(exports, "FaCcMastercard", ()=>FaCcMastercard);
parcelHelpers.export(exports, "FaCcJcb", ()=>FaCcJcb);
parcelHelpers.export(exports, "FaCcDiscover", ()=>FaCcDiscover);
parcelHelpers.export(exports, "FaCcDinersClub", ()=>FaCcDinersClub);
parcelHelpers.export(exports, "FaCcApplePay", ()=>FaCcApplePay);
parcelHelpers.export(exports, "FaCcAmex", ()=>FaCcAmex);
parcelHelpers.export(exports, "FaCcAmazonPay", ()=>FaCcAmazonPay);
parcelHelpers.export(exports, "FaCanadianMapleLeaf", ()=>FaCanadianMapleLeaf);
parcelHelpers.export(exports, "FaBuysellads", ()=>FaBuysellads);
parcelHelpers.export(exports, "FaBuyNLarge", ()=>FaBuyNLarge);
parcelHelpers.export(exports, "FaBuromobelexperte", ()=>FaBuromobelexperte);
parcelHelpers.export(exports, "FaBuffer", ()=>FaBuffer);
parcelHelpers.export(exports, "FaBtc", ()=>FaBtc);
parcelHelpers.export(exports, "FaBootstrap", ()=>FaBootstrap);
parcelHelpers.export(exports, "FaBluetooth", ()=>FaBluetooth);
parcelHelpers.export(exports, "FaBluetoothB", ()=>FaBluetoothB);
parcelHelpers.export(exports, "FaBlogger", ()=>FaBlogger);
parcelHelpers.export(exports, "FaBloggerB", ()=>FaBloggerB);
parcelHelpers.export(exports, "FaBlackberry", ()=>FaBlackberry);
parcelHelpers.export(exports, "FaBlackTie", ()=>FaBlackTie);
parcelHelpers.export(exports, "FaBity", ()=>FaBity);
parcelHelpers.export(exports, "FaBitcoin", ()=>FaBitcoin);
parcelHelpers.export(exports, "FaBitbucket", ()=>FaBitbucket);
parcelHelpers.export(exports, "FaBimobject", ()=>FaBimobject);
parcelHelpers.export(exports, "FaBehance", ()=>FaBehance);
parcelHelpers.export(exports, "FaBehanceSquare", ()=>FaBehanceSquare);
parcelHelpers.export(exports, "FaBattleNet", ()=>FaBattleNet);
parcelHelpers.export(exports, "FaBandcamp", ()=>FaBandcamp);
parcelHelpers.export(exports, "FaAws", ()=>FaAws);
parcelHelpers.export(exports, "FaAviato", ()=>FaAviato);
parcelHelpers.export(exports, "FaAvianex", ()=>FaAvianex);
parcelHelpers.export(exports, "FaAutoprefixer", ()=>FaAutoprefixer);
parcelHelpers.export(exports, "FaAudible", ()=>FaAudible);
parcelHelpers.export(exports, "FaAtlassian", ()=>FaAtlassian);
parcelHelpers.export(exports, "FaAsymmetrik", ()=>FaAsymmetrik);
parcelHelpers.export(exports, "FaArtstation", ()=>FaArtstation);
parcelHelpers.export(exports, "FaApple", ()=>FaApple);
parcelHelpers.export(exports, "FaApplePay", ()=>FaApplePay);
parcelHelpers.export(exports, "FaApper", ()=>FaApper);
parcelHelpers.export(exports, "FaAppStore", ()=>FaAppStore);
parcelHelpers.export(exports, "FaAppStoreIos", ()=>FaAppStoreIos);
parcelHelpers.export(exports, "FaAngular", ()=>FaAngular);
parcelHelpers.export(exports, "FaAngrycreative", ()=>FaAngrycreative);
parcelHelpers.export(exports, "FaAngellist", ()=>FaAngellist);
parcelHelpers.export(exports, "FaAndroid", ()=>FaAndroid);
parcelHelpers.export(exports, "FaAmilia", ()=>FaAmilia);
parcelHelpers.export(exports, "FaAmazon", ()=>FaAmazon);
parcelHelpers.export(exports, "FaAmazonPay", ()=>FaAmazonPay);
parcelHelpers.export(exports, "FaAlipay", ()=>FaAlipay);
parcelHelpers.export(exports, "FaAlgolia", ()=>FaAlgolia);
parcelHelpers.export(exports, "FaAirbnb", ()=>FaAirbnb);
parcelHelpers.export(exports, "FaAffiliatetheme", ()=>FaAffiliatetheme);
parcelHelpers.export(exports, "FaAdversal", ()=>FaAdversal);
parcelHelpers.export(exports, "FaAdn", ()=>FaAdn);
parcelHelpers.export(exports, "FaAcquisitionsIncorporated", ()=>FaAcquisitionsIncorporated);
parcelHelpers.export(exports, "FaAccusoft", ()=>FaAccusoft);
parcelHelpers.export(exports, "FaAccessibleIcon", ()=>FaAccessibleIcon);
parcelHelpers.export(exports, "Fa500Px", ()=>Fa500Px);
parcelHelpers.export(exports, "FaYinYang", ()=>FaYinYang);
parcelHelpers.export(exports, "FaYenSign", ()=>FaYenSign);
parcelHelpers.export(exports, "FaXRay", ()=>FaXRay);
parcelHelpers.export(exports, "FaWrench", ()=>FaWrench);
parcelHelpers.export(exports, "FaWonSign", ()=>FaWonSign);
parcelHelpers.export(exports, "FaWineGlass", ()=>FaWineGlass);
parcelHelpers.export(exports, "FaWineGlassAlt", ()=>FaWineGlassAlt);
parcelHelpers.export(exports, "FaWineBottle", ()=>FaWineBottle);
parcelHelpers.export(exports, "FaWindowRestore", ()=>FaWindowRestore);
parcelHelpers.export(exports, "FaWindowMinimize", ()=>FaWindowMinimize);
parcelHelpers.export(exports, "FaWindowMaximize", ()=>FaWindowMaximize);
parcelHelpers.export(exports, "FaWindowClose", ()=>FaWindowClose);
parcelHelpers.export(exports, "FaWind", ()=>FaWind);
parcelHelpers.export(exports, "FaWifi", ()=>FaWifi);
parcelHelpers.export(exports, "FaWheelchair", ()=>FaWheelchair);
parcelHelpers.export(exports, "FaWeight", ()=>FaWeight);
parcelHelpers.export(exports, "FaWeightHanging", ()=>FaWeightHanging);
parcelHelpers.export(exports, "FaWaveSquare", ()=>FaWaveSquare);
parcelHelpers.export(exports, "FaWater", ()=>FaWater);
parcelHelpers.export(exports, "FaWarehouse", ()=>FaWarehouse);
parcelHelpers.export(exports, "FaWallet", ()=>FaWallet);
parcelHelpers.export(exports, "FaWalking", ()=>FaWalking);
parcelHelpers.export(exports, "FaVrCardboard", ()=>FaVrCardboard);
parcelHelpers.export(exports, "FaVoteYea", ()=>FaVoteYea);
parcelHelpers.export(exports, "FaVolumeUp", ()=>FaVolumeUp);
parcelHelpers.export(exports, "FaVolumeOff", ()=>FaVolumeOff);
parcelHelpers.export(exports, "FaVolumeMute", ()=>FaVolumeMute);
parcelHelpers.export(exports, "FaVolumeDown", ()=>FaVolumeDown);
parcelHelpers.export(exports, "FaVolleyballBall", ()=>FaVolleyballBall);
parcelHelpers.export(exports, "FaVoicemail", ()=>FaVoicemail);
parcelHelpers.export(exports, "FaViruses", ()=>FaViruses);
parcelHelpers.export(exports, "FaVirus", ()=>FaVirus);
parcelHelpers.export(exports, "FaVirusSlash", ()=>FaVirusSlash);
parcelHelpers.export(exports, "FaVihara", ()=>FaVihara);
parcelHelpers.export(exports, "FaVideo", ()=>FaVideo);
parcelHelpers.export(exports, "FaVideoSlash", ()=>FaVideoSlash);
parcelHelpers.export(exports, "FaVials", ()=>FaVials);
parcelHelpers.export(exports, "FaVial", ()=>FaVial);
parcelHelpers.export(exports, "FaVest", ()=>FaVest);
parcelHelpers.export(exports, "FaVestPatches", ()=>FaVestPatches);
parcelHelpers.export(exports, "FaVenus", ()=>FaVenus);
parcelHelpers.export(exports, "FaVenusMars", ()=>FaVenusMars);
parcelHelpers.export(exports, "FaVenusDouble", ()=>FaVenusDouble);
parcelHelpers.export(exports, "FaVectorSquare", ()=>FaVectorSquare);
parcelHelpers.export(exports, "FaUtensils", ()=>FaUtensils);
parcelHelpers.export(exports, "FaUtensilSpoon", ()=>FaUtensilSpoon);
parcelHelpers.export(exports, "FaUsers", ()=>FaUsers);
parcelHelpers.export(exports, "FaUsersSlash", ()=>FaUsersSlash);
parcelHelpers.export(exports, "FaUsersCog", ()=>FaUsersCog);
parcelHelpers.export(exports, "FaUser", ()=>FaUser);
parcelHelpers.export(exports, "FaUserTimes", ()=>FaUserTimes);
parcelHelpers.export(exports, "FaUserTie", ()=>FaUserTie);
parcelHelpers.export(exports, "FaUserTag", ()=>FaUserTag);
parcelHelpers.export(exports, "FaUserSlash", ()=>FaUserSlash);
parcelHelpers.export(exports, "FaUserShield", ()=>FaUserShield);
parcelHelpers.export(exports, "FaUserSecret", ()=>FaUserSecret);
parcelHelpers.export(exports, "FaUserPlus", ()=>FaUserPlus);
parcelHelpers.export(exports, "FaUserNurse", ()=>FaUserNurse);
parcelHelpers.export(exports, "FaUserNinja", ()=>FaUserNinja);
parcelHelpers.export(exports, "FaUserMinus", ()=>FaUserMinus);
parcelHelpers.export(exports, "FaUserMd", ()=>FaUserMd);
parcelHelpers.export(exports, "FaUserLock", ()=>FaUserLock);
parcelHelpers.export(exports, "FaUserInjured", ()=>FaUserInjured);
parcelHelpers.export(exports, "FaUserGraduate", ()=>FaUserGraduate);
parcelHelpers.export(exports, "FaUserFriends", ()=>FaUserFriends);
parcelHelpers.export(exports, "FaUserEdit", ()=>FaUserEdit);
parcelHelpers.export(exports, "FaUserCog", ()=>FaUserCog);
parcelHelpers.export(exports, "FaUserClock", ()=>FaUserClock);
parcelHelpers.export(exports, "FaUserCircle", ()=>FaUserCircle);
parcelHelpers.export(exports, "FaUserCheck", ()=>FaUserCheck);
parcelHelpers.export(exports, "FaUserAstronaut", ()=>FaUserAstronaut);
parcelHelpers.export(exports, "FaUserAlt", ()=>FaUserAlt);
parcelHelpers.export(exports, "FaUserAltSlash", ()=>FaUserAltSlash);
parcelHelpers.export(exports, "FaUpload", ()=>FaUpload);
parcelHelpers.export(exports, "FaUnlock", ()=>FaUnlock);
parcelHelpers.export(exports, "FaUnlockAlt", ()=>FaUnlockAlt);
parcelHelpers.export(exports, "FaUnlink", ()=>FaUnlink);
parcelHelpers.export(exports, "FaUniversity", ()=>FaUniversity);
parcelHelpers.export(exports, "FaUniversalAccess", ()=>FaUniversalAccess);
parcelHelpers.export(exports, "FaUndo", ()=>FaUndo);
parcelHelpers.export(exports, "FaUndoAlt", ()=>FaUndoAlt);
parcelHelpers.export(exports, "FaUnderline", ()=>FaUnderline);
parcelHelpers.export(exports, "FaUmbrella", ()=>FaUmbrella);
parcelHelpers.export(exports, "FaUmbrellaBeach", ()=>FaUmbrellaBeach);
parcelHelpers.export(exports, "FaTv", ()=>FaTv);
parcelHelpers.export(exports, "FaTty", ()=>FaTty);
parcelHelpers.export(exports, "FaTshirt", ()=>FaTshirt);
parcelHelpers.export(exports, "FaTruck", ()=>FaTruck);
parcelHelpers.export(exports, "FaTruckPickup", ()=>FaTruckPickup);
parcelHelpers.export(exports, "FaTruckMoving", ()=>FaTruckMoving);
parcelHelpers.export(exports, "FaTruckMonster", ()=>FaTruckMonster);
parcelHelpers.export(exports, "FaTruckLoading", ()=>FaTruckLoading);
parcelHelpers.export(exports, "FaTrophy", ()=>FaTrophy);
parcelHelpers.export(exports, "FaTree", ()=>FaTree);
parcelHelpers.export(exports, "FaTrash", ()=>FaTrash);
parcelHelpers.export(exports, "FaTrashRestore", ()=>FaTrashRestore);
parcelHelpers.export(exports, "FaTrashRestoreAlt", ()=>FaTrashRestoreAlt);
parcelHelpers.export(exports, "FaTrashAlt", ()=>FaTrashAlt);
parcelHelpers.export(exports, "FaTransgender", ()=>FaTransgender);
parcelHelpers.export(exports, "FaTransgenderAlt", ()=>FaTransgenderAlt);
parcelHelpers.export(exports, "FaTram", ()=>FaTram);
parcelHelpers.export(exports, "FaTrain", ()=>FaTrain);
parcelHelpers.export(exports, "FaTrailer", ()=>FaTrailer);
parcelHelpers.export(exports, "FaTrafficLight", ()=>FaTrafficLight);
parcelHelpers.export(exports, "FaTrademark", ()=>FaTrademark);
parcelHelpers.export(exports, "FaTractor", ()=>FaTractor);
parcelHelpers.export(exports, "FaToriiGate", ()=>FaToriiGate);
parcelHelpers.export(exports, "FaTorah", ()=>FaTorah);
parcelHelpers.export(exports, "FaTooth", ()=>FaTooth);
parcelHelpers.export(exports, "FaTools", ()=>FaTools);
parcelHelpers.export(exports, "FaToolbox", ()=>FaToolbox);
parcelHelpers.export(exports, "FaToilet", ()=>FaToilet);
parcelHelpers.export(exports, "FaToiletPaper", ()=>FaToiletPaper);
parcelHelpers.export(exports, "FaToiletPaperSlash", ()=>FaToiletPaperSlash);
parcelHelpers.export(exports, "FaToggleOn", ()=>FaToggleOn);
parcelHelpers.export(exports, "FaToggleOff", ()=>FaToggleOff);
parcelHelpers.export(exports, "FaTired", ()=>FaTired);
parcelHelpers.export(exports, "FaTint", ()=>FaTint);
parcelHelpers.export(exports, "FaTintSlash", ()=>FaTintSlash);
parcelHelpers.export(exports, "FaTimes", ()=>FaTimes);
parcelHelpers.export(exports, "FaTimesCircle", ()=>FaTimesCircle);
parcelHelpers.export(exports, "FaTicketAlt", ()=>FaTicketAlt);
parcelHelpers.export(exports, "FaThumbtack", ()=>FaThumbtack);
parcelHelpers.export(exports, "FaThumbsUp", ()=>FaThumbsUp);
parcelHelpers.export(exports, "FaThumbsDown", ()=>FaThumbsDown);
parcelHelpers.export(exports, "FaThermometer", ()=>FaThermometer);
parcelHelpers.export(exports, "FaThermometerThreeQuarters", ()=>FaThermometerThreeQuarters);
parcelHelpers.export(exports, "FaThermometerQuarter", ()=>FaThermometerQuarter);
parcelHelpers.export(exports, "FaThermometerHalf", ()=>FaThermometerHalf);
parcelHelpers.export(exports, "FaThermometerFull", ()=>FaThermometerFull);
parcelHelpers.export(exports, "FaThermometerEmpty", ()=>FaThermometerEmpty);
parcelHelpers.export(exports, "FaTheaterMasks", ()=>FaTheaterMasks);
parcelHelpers.export(exports, "FaTh", ()=>FaTh);
parcelHelpers.export(exports, "FaThList", ()=>FaThList);
parcelHelpers.export(exports, "FaThLarge", ()=>FaThLarge);
parcelHelpers.export(exports, "FaTextWidth", ()=>FaTextWidth);
parcelHelpers.export(exports, "FaTextHeight", ()=>FaTextHeight);
parcelHelpers.export(exports, "FaTerminal", ()=>FaTerminal);
parcelHelpers.export(exports, "FaTenge", ()=>FaTenge);
parcelHelpers.export(exports, "FaTemperatureLow", ()=>FaTemperatureLow);
parcelHelpers.export(exports, "FaTemperatureHigh", ()=>FaTemperatureHigh);
parcelHelpers.export(exports, "FaTeeth", ()=>FaTeeth);
parcelHelpers.export(exports, "FaTeethOpen", ()=>FaTeethOpen);
parcelHelpers.export(exports, "FaTaxi", ()=>FaTaxi);
parcelHelpers.export(exports, "FaTasks", ()=>FaTasks);
parcelHelpers.export(exports, "FaTape", ()=>FaTape);
parcelHelpers.export(exports, "FaTags", ()=>FaTags);
parcelHelpers.export(exports, "FaTag", ()=>FaTag);
parcelHelpers.export(exports, "FaTachometerAlt", ()=>FaTachometerAlt);
parcelHelpers.export(exports, "FaTablets", ()=>FaTablets);
parcelHelpers.export(exports, "FaTablet", ()=>FaTablet);
parcelHelpers.export(exports, "FaTabletAlt", ()=>FaTabletAlt);
parcelHelpers.export(exports, "FaTable", ()=>FaTable);
parcelHelpers.export(exports, "FaTableTennis", ()=>FaTableTennis);
parcelHelpers.export(exports, "FaSyringe", ()=>FaSyringe);
parcelHelpers.export(exports, "FaSync", ()=>FaSync);
parcelHelpers.export(exports, "FaSyncAlt", ()=>FaSyncAlt);
parcelHelpers.export(exports, "FaSynagogue", ()=>FaSynagogue);
parcelHelpers.export(exports, "FaSwimmingPool", ()=>FaSwimmingPool);
parcelHelpers.export(exports, "FaSwimmer", ()=>FaSwimmer);
parcelHelpers.export(exports, "FaSwatchbook", ()=>FaSwatchbook);
parcelHelpers.export(exports, "FaSurprise", ()=>FaSurprise);
parcelHelpers.export(exports, "FaSuperscript", ()=>FaSuperscript);
parcelHelpers.export(exports, "FaSun", ()=>FaSun);
parcelHelpers.export(exports, "FaSuitcase", ()=>FaSuitcase);
parcelHelpers.export(exports, "FaSuitcaseRolling", ()=>FaSuitcaseRolling);
parcelHelpers.export(exports, "FaSubway", ()=>FaSubway);
parcelHelpers.export(exports, "FaSubscript", ()=>FaSubscript);
parcelHelpers.export(exports, "FaStroopwafel", ()=>FaStroopwafel);
parcelHelpers.export(exports, "FaStrikethrough", ()=>FaStrikethrough);
parcelHelpers.export(exports, "FaStreetView", ()=>FaStreetView);
parcelHelpers.export(exports, "FaStream", ()=>FaStream);
parcelHelpers.export(exports, "FaStore", ()=>FaStore);
parcelHelpers.export(exports, "FaStoreSlash", ()=>FaStoreSlash);
parcelHelpers.export(exports, "FaStoreAlt", ()=>FaStoreAlt);
parcelHelpers.export(exports, "FaStoreAltSlash", ()=>FaStoreAltSlash);
parcelHelpers.export(exports, "FaStopwatch", ()=>FaStopwatch);
parcelHelpers.export(exports, "FaStopwatch20", ()=>FaStopwatch20);
parcelHelpers.export(exports, "FaStop", ()=>FaStop);
parcelHelpers.export(exports, "FaStopCircle", ()=>FaStopCircle);
parcelHelpers.export(exports, "FaStickyNote", ()=>FaStickyNote);
parcelHelpers.export(exports, "FaStethoscope", ()=>FaStethoscope);
parcelHelpers.export(exports, "FaStepForward", ()=>FaStepForward);
parcelHelpers.export(exports, "FaStepBackward", ()=>FaStepBackward);
parcelHelpers.export(exports, "FaStar", ()=>FaStar);
parcelHelpers.export(exports, "FaStarOfLife", ()=>FaStarOfLife);
parcelHelpers.export(exports, "FaStarOfDavid", ()=>FaStarOfDavid);
parcelHelpers.export(exports, "FaStarHalf", ()=>FaStarHalf);
parcelHelpers.export(exports, "FaStarHalfAlt", ()=>FaStarHalfAlt);
parcelHelpers.export(exports, "FaStarAndCrescent", ()=>FaStarAndCrescent);
parcelHelpers.export(exports, "FaStamp", ()=>FaStamp);
parcelHelpers.export(exports, "FaSquare", ()=>FaSquare);
parcelHelpers.export(exports, "FaSquareRootAlt", ()=>FaSquareRootAlt);
parcelHelpers.export(exports, "FaSquareFull", ()=>FaSquareFull);
parcelHelpers.export(exports, "FaSprayCan", ()=>FaSprayCan);
parcelHelpers.export(exports, "FaSplotch", ()=>FaSplotch);
parcelHelpers.export(exports, "FaSpinner", ()=>FaSpinner);
parcelHelpers.export(exports, "FaSpider", ()=>FaSpider);
parcelHelpers.export(exports, "FaSpellCheck", ()=>FaSpellCheck);
parcelHelpers.export(exports, "FaSpaceShuttle", ()=>FaSpaceShuttle);
parcelHelpers.export(exports, "FaSpa", ()=>FaSpa);
parcelHelpers.export(exports, "FaSort", ()=>FaSort);
parcelHelpers.export(exports, "FaSortUp", ()=>FaSortUp);
parcelHelpers.export(exports, "FaSortNumericUp", ()=>FaSortNumericUp);
parcelHelpers.export(exports, "FaSortNumericUpAlt", ()=>FaSortNumericUpAlt);
parcelHelpers.export(exports, "FaSortNumericDown", ()=>FaSortNumericDown);
parcelHelpers.export(exports, "FaSortNumericDownAlt", ()=>FaSortNumericDownAlt);
parcelHelpers.export(exports, "FaSortDown", ()=>FaSortDown);
parcelHelpers.export(exports, "FaSortAmountUp", ()=>FaSortAmountUp);
parcelHelpers.export(exports, "FaSortAmountUpAlt", ()=>FaSortAmountUpAlt);
parcelHelpers.export(exports, "FaSortAmountDown", ()=>FaSortAmountDown);
parcelHelpers.export(exports, "FaSortAmountDownAlt", ()=>FaSortAmountDownAlt);
parcelHelpers.export(exports, "FaSortAlphaUp", ()=>FaSortAlphaUp);
parcelHelpers.export(exports, "FaSortAlphaUpAlt", ()=>FaSortAlphaUpAlt);
parcelHelpers.export(exports, "FaSortAlphaDown", ()=>FaSortAlphaDown);
parcelHelpers.export(exports, "FaSortAlphaDownAlt", ()=>FaSortAlphaDownAlt);
parcelHelpers.export(exports, "FaSolarPanel", ()=>FaSolarPanel);
parcelHelpers.export(exports, "FaSocks", ()=>FaSocks);
parcelHelpers.export(exports, "FaSoap", ()=>FaSoap);
parcelHelpers.export(exports, "FaSnowplow", ()=>FaSnowplow);
parcelHelpers.export(exports, "FaSnowman", ()=>FaSnowman);
parcelHelpers.export(exports, "FaSnowflake", ()=>FaSnowflake);
parcelHelpers.export(exports, "FaSnowboarding", ()=>FaSnowboarding);
parcelHelpers.export(exports, "FaSms", ()=>FaSms);
parcelHelpers.export(exports, "FaSmoking", ()=>FaSmoking);
parcelHelpers.export(exports, "FaSmokingBan", ()=>FaSmokingBan);
parcelHelpers.export(exports, "FaSmog", ()=>FaSmog);
parcelHelpers.export(exports, "FaSmile", ()=>FaSmile);
parcelHelpers.export(exports, "FaSmileWink", ()=>FaSmileWink);
parcelHelpers.export(exports, "FaSmileBeam", ()=>FaSmileBeam);
parcelHelpers.export(exports, "FaSlidersH", ()=>FaSlidersH);
parcelHelpers.export(exports, "FaSleigh", ()=>FaSleigh);
parcelHelpers.export(exports, "FaSlash", ()=>FaSlash);
parcelHelpers.export(exports, "FaSkull", ()=>FaSkull);
parcelHelpers.export(exports, "FaSkullCrossbones", ()=>FaSkullCrossbones);
parcelHelpers.export(exports, "FaSkiing", ()=>FaSkiing);
parcelHelpers.export(exports, "FaSkiingNordic", ()=>FaSkiingNordic);
parcelHelpers.export(exports, "FaSkating", ()=>FaSkating);
parcelHelpers.export(exports, "FaSitemap", ()=>FaSitemap);
parcelHelpers.export(exports, "FaSink", ()=>FaSink);
parcelHelpers.export(exports, "FaSimCard", ()=>FaSimCard);
parcelHelpers.export(exports, "FaSignature", ()=>FaSignature);
parcelHelpers.export(exports, "FaSignal", ()=>FaSignal);
parcelHelpers.export(exports, "FaSign", ()=>FaSign);
parcelHelpers.export(exports, "FaSignOutAlt", ()=>FaSignOutAlt);
parcelHelpers.export(exports, "FaSignLanguage", ()=>FaSignLanguage);
parcelHelpers.export(exports, "FaSignInAlt", ()=>FaSignInAlt);
parcelHelpers.export(exports, "FaShuttleVan", ()=>FaShuttleVan);
parcelHelpers.export(exports, "FaShower", ()=>FaShower);
parcelHelpers.export(exports, "FaShoppingCart", ()=>FaShoppingCart);
parcelHelpers.export(exports, "FaShoppingBasket", ()=>FaShoppingBasket);
parcelHelpers.export(exports, "FaShoppingBag", ()=>FaShoppingBag);
parcelHelpers.export(exports, "FaShoePrints", ()=>FaShoePrints);
parcelHelpers.export(exports, "FaShippingFast", ()=>FaShippingFast);
parcelHelpers.export(exports, "FaShip", ()=>FaShip);
parcelHelpers.export(exports, "FaShieldVirus", ()=>FaShieldVirus);
parcelHelpers.export(exports, "FaShieldAlt", ()=>FaShieldAlt);
parcelHelpers.export(exports, "FaShekelSign", ()=>FaShekelSign);
parcelHelpers.export(exports, "FaShare", ()=>FaShare);
parcelHelpers.export(exports, "FaShareSquare", ()=>FaShareSquare);
parcelHelpers.export(exports, "FaShareAlt", ()=>FaShareAlt);
parcelHelpers.export(exports, "FaShareAltSquare", ()=>FaShareAltSquare);
parcelHelpers.export(exports, "FaShapes", ()=>FaShapes);
parcelHelpers.export(exports, "FaServer", ()=>FaServer);
parcelHelpers.export(exports, "FaSeedling", ()=>FaSeedling);
parcelHelpers.export(exports, "FaSearch", ()=>FaSearch);
parcelHelpers.export(exports, "FaSearchPlus", ()=>FaSearchPlus);
parcelHelpers.export(exports, "FaSearchMinus", ()=>FaSearchMinus);
parcelHelpers.export(exports, "FaSearchLocation", ()=>FaSearchLocation);
parcelHelpers.export(exports, "FaSearchDollar", ()=>FaSearchDollar);
parcelHelpers.export(exports, "FaSdCard", ()=>FaSdCard);
parcelHelpers.export(exports, "FaScroll", ()=>FaScroll);
parcelHelpers.export(exports, "FaScrewdriver", ()=>FaScrewdriver);
parcelHelpers.export(exports, "FaSchool", ()=>FaSchool);
parcelHelpers.export(exports, "FaSave", ()=>FaSave);
parcelHelpers.export(exports, "FaSatellite", ()=>FaSatellite);
parcelHelpers.export(exports, "FaSatelliteDish", ()=>FaSatelliteDish);
parcelHelpers.export(exports, "FaSadTear", ()=>FaSadTear);
parcelHelpers.export(exports, "FaSadCry", ()=>FaSadCry);
parcelHelpers.export(exports, "FaRupeeSign", ()=>FaRupeeSign);
parcelHelpers.export(exports, "FaRunning", ()=>FaRunning);
parcelHelpers.export(exports, "FaRuler", ()=>FaRuler);
parcelHelpers.export(exports, "FaRulerVertical", ()=>FaRulerVertical);
parcelHelpers.export(exports, "FaRulerHorizontal", ()=>FaRulerHorizontal);
parcelHelpers.export(exports, "FaRulerCombined", ()=>FaRulerCombined);
parcelHelpers.export(exports, "FaRubleSign", ()=>FaRubleSign);
parcelHelpers.export(exports, "FaRss", ()=>FaRss);
parcelHelpers.export(exports, "FaRssSquare", ()=>FaRssSquare);
parcelHelpers.export(exports, "FaRoute", ()=>FaRoute);
parcelHelpers.export(exports, "FaRocket", ()=>FaRocket);
parcelHelpers.export(exports, "FaRobot", ()=>FaRobot);
parcelHelpers.export(exports, "FaRoad", ()=>FaRoad);
parcelHelpers.export(exports, "FaRing", ()=>FaRing);
parcelHelpers.export(exports, "FaRibbon", ()=>FaRibbon);
parcelHelpers.export(exports, "FaRetweet", ()=>FaRetweet);
parcelHelpers.export(exports, "FaRestroom", ()=>FaRestroom);
parcelHelpers.export(exports, "FaRepublican", ()=>FaRepublican);
parcelHelpers.export(exports, "FaReply", ()=>FaReply);
parcelHelpers.export(exports, "FaReplyAll", ()=>FaReplyAll);
parcelHelpers.export(exports, "FaRemoveFormat", ()=>FaRemoveFormat);
parcelHelpers.export(exports, "FaRegistered", ()=>FaRegistered);
parcelHelpers.export(exports, "FaRedo", ()=>FaRedo);
parcelHelpers.export(exports, "FaRedoAlt", ()=>FaRedoAlt);
parcelHelpers.export(exports, "FaRecycle", ()=>FaRecycle);
parcelHelpers.export(exports, "FaRecordVinyl", ()=>FaRecordVinyl);
parcelHelpers.export(exports, "FaReceipt", ()=>FaReceipt);
parcelHelpers.export(exports, "FaRandom", ()=>FaRandom);
parcelHelpers.export(exports, "FaRainbow", ()=>FaRainbow);
parcelHelpers.export(exports, "FaRadiation", ()=>FaRadiation);
parcelHelpers.export(exports, "FaRadiationAlt", ()=>FaRadiationAlt);
parcelHelpers.export(exports, "FaQuran", ()=>FaQuran);
parcelHelpers.export(exports, "FaQuoteRight", ()=>FaQuoteRight);
parcelHelpers.export(exports, "FaQuoteLeft", ()=>FaQuoteLeft);
parcelHelpers.export(exports, "FaQuidditch", ()=>FaQuidditch);
parcelHelpers.export(exports, "FaQuestion", ()=>FaQuestion);
parcelHelpers.export(exports, "FaQuestionCircle", ()=>FaQuestionCircle);
parcelHelpers.export(exports, "FaQrcode", ()=>FaQrcode);
parcelHelpers.export(exports, "FaPuzzlePiece", ()=>FaPuzzlePiece);
parcelHelpers.export(exports, "FaPumpSoap", ()=>FaPumpSoap);
parcelHelpers.export(exports, "FaPumpMedical", ()=>FaPumpMedical);
parcelHelpers.export(exports, "FaProjectDiagram", ()=>FaProjectDiagram);
parcelHelpers.export(exports, "FaProcedures", ()=>FaProcedures);
parcelHelpers.export(exports, "FaPrint", ()=>FaPrint);
parcelHelpers.export(exports, "FaPrescription", ()=>FaPrescription);
parcelHelpers.export(exports, "FaPrescriptionBottle", ()=>FaPrescriptionBottle);
parcelHelpers.export(exports, "FaPrescriptionBottleAlt", ()=>FaPrescriptionBottleAlt);
parcelHelpers.export(exports, "FaPrayingHands", ()=>FaPrayingHands);
parcelHelpers.export(exports, "FaPray", ()=>FaPray);
parcelHelpers.export(exports, "FaPowerOff", ()=>FaPowerOff);
parcelHelpers.export(exports, "FaPoundSign", ()=>FaPoundSign);
parcelHelpers.export(exports, "FaPortrait", ()=>FaPortrait);
parcelHelpers.export(exports, "FaPoop", ()=>FaPoop);
parcelHelpers.export(exports, "FaPoo", ()=>FaPoo);
parcelHelpers.export(exports, "FaPooStorm", ()=>FaPooStorm);
parcelHelpers.export(exports, "FaPoll", ()=>FaPoll);
parcelHelpers.export(exports, "FaPollH", ()=>FaPollH);
parcelHelpers.export(exports, "FaPodcast", ()=>FaPodcast);
parcelHelpers.export(exports, "FaPlus", ()=>FaPlus);
parcelHelpers.export(exports, "FaPlusSquare", ()=>FaPlusSquare);
parcelHelpers.export(exports, "FaPlusCircle", ()=>FaPlusCircle);
parcelHelpers.export(exports, "FaPlug", ()=>FaPlug);
parcelHelpers.export(exports, "FaPlay", ()=>FaPlay);
parcelHelpers.export(exports, "FaPlayCircle", ()=>FaPlayCircle);
parcelHelpers.export(exports, "FaPlane", ()=>FaPlane);
parcelHelpers.export(exports, "FaPlaneSlash", ()=>FaPlaneSlash);
parcelHelpers.export(exports, "FaPlaneDeparture", ()=>FaPlaneDeparture);
parcelHelpers.export(exports, "FaPlaneArrival", ()=>FaPlaneArrival);
parcelHelpers.export(exports, "FaPlaceOfWorship", ()=>FaPlaceOfWorship);
parcelHelpers.export(exports, "FaPizzaSlice", ()=>FaPizzaSlice);
parcelHelpers.export(exports, "FaPills", ()=>FaPills);
parcelHelpers.export(exports, "FaPiggyBank", ()=>FaPiggyBank);
parcelHelpers.export(exports, "FaPhotoVideo", ()=>FaPhotoVideo);
parcelHelpers.export(exports, "FaPhone", ()=>FaPhone);
parcelHelpers.export(exports, "FaPhoneVolume", ()=>FaPhoneVolume);
parcelHelpers.export(exports, "FaPhoneSquare", ()=>FaPhoneSquare);
parcelHelpers.export(exports, "FaPhoneSquareAlt", ()=>FaPhoneSquareAlt);
parcelHelpers.export(exports, "FaPhoneSlash", ()=>FaPhoneSlash);
parcelHelpers.export(exports, "FaPhoneAlt", ()=>FaPhoneAlt);
parcelHelpers.export(exports, "FaPersonBooth", ()=>FaPersonBooth);
parcelHelpers.export(exports, "FaPercentage", ()=>FaPercentage);
parcelHelpers.export(exports, "FaPercent", ()=>FaPercent);
parcelHelpers.export(exports, "FaPepperHot", ()=>FaPepperHot);
parcelHelpers.export(exports, "FaPeopleCarry", ()=>FaPeopleCarry);
parcelHelpers.export(exports, "FaPeopleArrows", ()=>FaPeopleArrows);
parcelHelpers.export(exports, "FaPencilRuler", ()=>FaPencilRuler);
parcelHelpers.export(exports, "FaPencilAlt", ()=>FaPencilAlt);
parcelHelpers.export(exports, "FaPen", ()=>FaPen);
parcelHelpers.export(exports, "FaPenSquare", ()=>FaPenSquare);
parcelHelpers.export(exports, "FaPenNib", ()=>FaPenNib);
parcelHelpers.export(exports, "FaPenFancy", ()=>FaPenFancy);
parcelHelpers.export(exports, "FaPenAlt", ()=>FaPenAlt);
parcelHelpers.export(exports, "FaPeace", ()=>FaPeace);
parcelHelpers.export(exports, "FaPaw", ()=>FaPaw);
parcelHelpers.export(exports, "FaPause", ()=>FaPause);
parcelHelpers.export(exports, "FaPauseCircle", ()=>FaPauseCircle);
parcelHelpers.export(exports, "FaPaste", ()=>FaPaste);
parcelHelpers.export(exports, "FaPastafarianism", ()=>FaPastafarianism);
parcelHelpers.export(exports, "FaPassport", ()=>FaPassport);
parcelHelpers.export(exports, "FaParking", ()=>FaParking);
parcelHelpers.export(exports, "FaParagraph", ()=>FaParagraph);
parcelHelpers.export(exports, "FaParachuteBox", ()=>FaParachuteBox);
parcelHelpers.export(exports, "FaPaperclip", ()=>FaPaperclip);
parcelHelpers.export(exports, "FaPaperPlane", ()=>FaPaperPlane);
parcelHelpers.export(exports, "FaPallet", ()=>FaPallet);
parcelHelpers.export(exports, "FaPalette", ()=>FaPalette);
parcelHelpers.export(exports, "FaPaintRoller", ()=>FaPaintRoller);
parcelHelpers.export(exports, "FaPaintBrush", ()=>FaPaintBrush);
parcelHelpers.export(exports, "FaPager", ()=>FaPager);
parcelHelpers.export(exports, "FaOutdent", ()=>FaOutdent);
parcelHelpers.export(exports, "FaOtter", ()=>FaOtter);
parcelHelpers.export(exports, "FaOm", ()=>FaOm);
parcelHelpers.export(exports, "FaOilCan", ()=>FaOilCan);
parcelHelpers.export(exports, "FaObjectUngroup", ()=>FaObjectUngroup);
parcelHelpers.export(exports, "FaObjectGroup", ()=>FaObjectGroup);
parcelHelpers.export(exports, "FaNotesMedical", ()=>FaNotesMedical);
parcelHelpers.export(exports, "FaNotEqual", ()=>FaNotEqual);
parcelHelpers.export(exports, "FaNewspaper", ()=>FaNewspaper);
parcelHelpers.export(exports, "FaNeuter", ()=>FaNeuter);
parcelHelpers.export(exports, "FaNetworkWired", ()=>FaNetworkWired);
parcelHelpers.export(exports, "FaMusic", ()=>FaMusic);
parcelHelpers.export(exports, "FaMugHot", ()=>FaMugHot);
parcelHelpers.export(exports, "FaMouse", ()=>FaMouse);
parcelHelpers.export(exports, "FaMousePointer", ()=>FaMousePointer);
parcelHelpers.export(exports, "FaMountain", ()=>FaMountain);
parcelHelpers.export(exports, "FaMotorcycle", ()=>FaMotorcycle);
parcelHelpers.export(exports, "FaMosque", ()=>FaMosque);
parcelHelpers.export(exports, "FaMortarPestle", ()=>FaMortarPestle);
parcelHelpers.export(exports, "FaMoon", ()=>FaMoon);
parcelHelpers.export(exports, "FaMonument", ()=>FaMonument);
parcelHelpers.export(exports, "FaMoneyCheck", ()=>FaMoneyCheck);
parcelHelpers.export(exports, "FaMoneyCheckAlt", ()=>FaMoneyCheckAlt);
parcelHelpers.export(exports, "FaMoneyBill", ()=>FaMoneyBill);
parcelHelpers.export(exports, "FaMoneyBillWave", ()=>FaMoneyBillWave);
parcelHelpers.export(exports, "FaMoneyBillWaveAlt", ()=>FaMoneyBillWaveAlt);
parcelHelpers.export(exports, "FaMoneyBillAlt", ()=>FaMoneyBillAlt);
parcelHelpers.export(exports, "FaMobile", ()=>FaMobile);
parcelHelpers.export(exports, "FaMobileAlt", ()=>FaMobileAlt);
parcelHelpers.export(exports, "FaMitten", ()=>FaMitten);
parcelHelpers.export(exports, "FaMinus", ()=>FaMinus);
parcelHelpers.export(exports, "FaMinusSquare", ()=>FaMinusSquare);
parcelHelpers.export(exports, "FaMinusCircle", ()=>FaMinusCircle);
parcelHelpers.export(exports, "FaMicroscope", ()=>FaMicroscope);
parcelHelpers.export(exports, "FaMicrophone", ()=>FaMicrophone);
parcelHelpers.export(exports, "FaMicrophoneSlash", ()=>FaMicrophoneSlash);
parcelHelpers.export(exports, "FaMicrophoneAlt", ()=>FaMicrophoneAlt);
parcelHelpers.export(exports, "FaMicrophoneAltSlash", ()=>FaMicrophoneAltSlash);
parcelHelpers.export(exports, "FaMicrochip", ()=>FaMicrochip);
parcelHelpers.export(exports, "FaMeteor", ()=>FaMeteor);
parcelHelpers.export(exports, "FaMercury", ()=>FaMercury);
parcelHelpers.export(exports, "FaMenorah", ()=>FaMenorah);
parcelHelpers.export(exports, "FaMemory", ()=>FaMemory);
parcelHelpers.export(exports, "FaMeh", ()=>FaMeh);
parcelHelpers.export(exports, "FaMehRollingEyes", ()=>FaMehRollingEyes);
parcelHelpers.export(exports, "FaMehBlank", ()=>FaMehBlank);
parcelHelpers.export(exports, "FaMedkit", ()=>FaMedkit);
parcelHelpers.export(exports, "FaMedal", ()=>FaMedal);
parcelHelpers.export(exports, "FaMask", ()=>FaMask);
parcelHelpers.export(exports, "FaMars", ()=>FaMars);
parcelHelpers.export(exports, "FaMarsStroke", ()=>FaMarsStroke);
parcelHelpers.export(exports, "FaMarsStrokeV", ()=>FaMarsStrokeV);
parcelHelpers.export(exports, "FaMarsStrokeH", ()=>FaMarsStrokeH);
parcelHelpers.export(exports, "FaMarsDouble", ()=>FaMarsDouble);
parcelHelpers.export(exports, "FaMarker", ()=>FaMarker);
parcelHelpers.export(exports, "FaMap", ()=>FaMap);
parcelHelpers.export(exports, "FaMapSigns", ()=>FaMapSigns);
parcelHelpers.export(exports, "FaMapPin", ()=>FaMapPin);
parcelHelpers.export(exports, "FaMapMarker", ()=>FaMapMarker);
parcelHelpers.export(exports, "FaMapMarkerAlt", ()=>FaMapMarkerAlt);
parcelHelpers.export(exports, "FaMapMarked", ()=>FaMapMarked);
parcelHelpers.export(exports, "FaMapMarkedAlt", ()=>FaMapMarkedAlt);
parcelHelpers.export(exports, "FaMale", ()=>FaMale);
parcelHelpers.export(exports, "FaMailBulk", ()=>FaMailBulk);
parcelHelpers.export(exports, "FaMagnet", ()=>FaMagnet);
parcelHelpers.export(exports, "FaMagic", ()=>FaMagic);
parcelHelpers.export(exports, "FaLungs", ()=>FaLungs);
parcelHelpers.export(exports, "FaLungsVirus", ()=>FaLungsVirus);
parcelHelpers.export(exports, "FaLuggageCart", ()=>FaLuggageCart);
parcelHelpers.export(exports, "FaLowVision", ()=>FaLowVision);
parcelHelpers.export(exports, "FaLongArrowAltUp", ()=>FaLongArrowAltUp);
parcelHelpers.export(exports, "FaLongArrowAltRight", ()=>FaLongArrowAltRight);
parcelHelpers.export(exports, "FaLongArrowAltLeft", ()=>FaLongArrowAltLeft);
parcelHelpers.export(exports, "FaLongArrowAltDown", ()=>FaLongArrowAltDown);
parcelHelpers.export(exports, "FaLock", ()=>FaLock);
parcelHelpers.export(exports, "FaLockOpen", ()=>FaLockOpen);
parcelHelpers.export(exports, "FaLocationArrow", ()=>FaLocationArrow);
parcelHelpers.export(exports, "FaList", ()=>FaList);
parcelHelpers.export(exports, "FaListUl", ()=>FaListUl);
parcelHelpers.export(exports, "FaListOl", ()=>FaListOl);
parcelHelpers.export(exports, "FaListAlt", ()=>FaListAlt);
parcelHelpers.export(exports, "FaLiraSign", ()=>FaLiraSign);
parcelHelpers.export(exports, "FaLink", ()=>FaLink);
parcelHelpers.export(exports, "FaLightbulb", ()=>FaLightbulb);
parcelHelpers.export(exports, "FaLifeRing", ()=>FaLifeRing);
parcelHelpers.export(exports, "FaLevelUpAlt", ()=>FaLevelUpAlt);
parcelHelpers.export(exports, "FaLevelDownAlt", ()=>FaLevelDownAlt);
parcelHelpers.export(exports, "FaLessThan", ()=>FaLessThan);
parcelHelpers.export(exports, "FaLessThanEqual", ()=>FaLessThanEqual);
parcelHelpers.export(exports, "FaLemon", ()=>FaLemon);
parcelHelpers.export(exports, "FaLeaf", ()=>FaLeaf);
parcelHelpers.export(exports, "FaLayerGroup", ()=>FaLayerGroup);
parcelHelpers.export(exports, "FaLaugh", ()=>FaLaugh);
parcelHelpers.export(exports, "FaLaughWink", ()=>FaLaughWink);
parcelHelpers.export(exports, "FaLaughSquint", ()=>FaLaughSquint);
parcelHelpers.export(exports, "FaLaughBeam", ()=>FaLaughBeam);
parcelHelpers.export(exports, "FaLaptop", ()=>FaLaptop);
parcelHelpers.export(exports, "FaLaptopMedical", ()=>FaLaptopMedical);
parcelHelpers.export(exports, "FaLaptopHouse", ()=>FaLaptopHouse);
parcelHelpers.export(exports, "FaLaptopCode", ()=>FaLaptopCode);
parcelHelpers.export(exports, "FaLanguage", ()=>FaLanguage);
parcelHelpers.export(exports, "FaLandmark", ()=>FaLandmark);
parcelHelpers.export(exports, "FaKiwiBird", ()=>FaKiwiBird);
parcelHelpers.export(exports, "FaKiss", ()=>FaKiss);
parcelHelpers.export(exports, "FaKissWinkHeart", ()=>FaKissWinkHeart);
parcelHelpers.export(exports, "FaKissBeam", ()=>FaKissBeam);
parcelHelpers.export(exports, "FaKhanda", ()=>FaKhanda);
parcelHelpers.export(exports, "FaKeyboard", ()=>FaKeyboard);
parcelHelpers.export(exports, "FaKey", ()=>FaKey);
parcelHelpers.export(exports, "FaKaaba", ()=>FaKaaba);
parcelHelpers.export(exports, "FaJournalWhills", ()=>FaJournalWhills);
parcelHelpers.export(exports, "FaJoint", ()=>FaJoint);
parcelHelpers.export(exports, "FaJedi", ()=>FaJedi);
parcelHelpers.export(exports, "FaItalic", ()=>FaItalic);
parcelHelpers.export(exports, "FaInfo", ()=>FaInfo);
parcelHelpers.export(exports, "FaInfoCircle", ()=>FaInfoCircle);
parcelHelpers.export(exports, "FaInfinity", ()=>FaInfinity);
parcelHelpers.export(exports, "FaIndustry", ()=>FaIndustry);
parcelHelpers.export(exports, "FaIndent", ()=>FaIndent);
parcelHelpers.export(exports, "FaInbox", ()=>FaInbox);
parcelHelpers.export(exports, "FaImages", ()=>FaImages);
parcelHelpers.export(exports, "FaImage", ()=>FaImage);
parcelHelpers.export(exports, "FaIgloo", ()=>FaIgloo);
parcelHelpers.export(exports, "FaIdCard", ()=>FaIdCard);
parcelHelpers.export(exports, "FaIdCardAlt", ()=>FaIdCardAlt);
parcelHelpers.export(exports, "FaIdBadge", ()=>FaIdBadge);
parcelHelpers.export(exports, "FaIcons", ()=>FaIcons);
parcelHelpers.export(exports, "FaIcicles", ()=>FaIcicles);
parcelHelpers.export(exports, "FaIceCream", ()=>FaIceCream);
parcelHelpers.export(exports, "FaICursor", ()=>FaICursor);
parcelHelpers.export(exports, "FaHryvnia", ()=>FaHryvnia);
parcelHelpers.export(exports, "FaHouseUser", ()=>FaHouseUser);
parcelHelpers.export(exports, "FaHouseDamage", ()=>FaHouseDamage);
parcelHelpers.export(exports, "FaHourglass", ()=>FaHourglass);
parcelHelpers.export(exports, "FaHourglassStart", ()=>FaHourglassStart);
parcelHelpers.export(exports, "FaHourglassHalf", ()=>FaHourglassHalf);
parcelHelpers.export(exports, "FaHourglassEnd", ()=>FaHourglassEnd);
parcelHelpers.export(exports, "FaHotel", ()=>FaHotel);
parcelHelpers.export(exports, "FaHotdog", ()=>FaHotdog);
parcelHelpers.export(exports, "FaHotTub", ()=>FaHotTub);
parcelHelpers.export(exports, "FaHospital", ()=>FaHospital);
parcelHelpers.export(exports, "FaHospitalUser", ()=>FaHospitalUser);
parcelHelpers.export(exports, "FaHospitalSymbol", ()=>FaHospitalSymbol);
parcelHelpers.export(exports, "FaHospitalAlt", ()=>FaHospitalAlt);
parcelHelpers.export(exports, "FaHorse", ()=>FaHorse);
parcelHelpers.export(exports, "FaHorseHead", ()=>FaHorseHead);
parcelHelpers.export(exports, "FaHome", ()=>FaHome);
parcelHelpers.export(exports, "FaHollyBerry", ()=>FaHollyBerry);
parcelHelpers.export(exports, "FaHockeyPuck", ()=>FaHockeyPuck);
parcelHelpers.export(exports, "FaHistory", ()=>FaHistory);
parcelHelpers.export(exports, "FaHippo", ()=>FaHippo);
parcelHelpers.export(exports, "FaHiking", ()=>FaHiking);
parcelHelpers.export(exports, "FaHighlighter", ()=>FaHighlighter);
parcelHelpers.export(exports, "FaHelicopter", ()=>FaHelicopter);
parcelHelpers.export(exports, "FaHeartbeat", ()=>FaHeartbeat);
parcelHelpers.export(exports, "FaHeart", ()=>FaHeart);
parcelHelpers.export(exports, "FaHeartBroken", ()=>FaHeartBroken);
parcelHelpers.export(exports, "FaHeadset", ()=>FaHeadset);
parcelHelpers.export(exports, "FaHeadphones", ()=>FaHeadphones);
parcelHelpers.export(exports, "FaHeadphonesAlt", ()=>FaHeadphonesAlt);
parcelHelpers.export(exports, "FaHeading", ()=>FaHeading);
parcelHelpers.export(exports, "FaHeadSideVirus", ()=>FaHeadSideVirus);
parcelHelpers.export(exports, "FaHeadSideMask", ()=>FaHeadSideMask);
parcelHelpers.export(exports, "FaHeadSideCough", ()=>FaHeadSideCough);
parcelHelpers.export(exports, "FaHeadSideCoughSlash", ()=>FaHeadSideCoughSlash);
parcelHelpers.export(exports, "FaHdd", ()=>FaHdd);
parcelHelpers.export(exports, "FaHatWizard", ()=>FaHatWizard);
parcelHelpers.export(exports, "FaHatCowboy", ()=>FaHatCowboy);
parcelHelpers.export(exports, "FaHatCowboySide", ()=>FaHatCowboySide);
parcelHelpers.export(exports, "FaHashtag", ()=>FaHashtag);
parcelHelpers.export(exports, "FaHardHat", ()=>FaHardHat);
parcelHelpers.export(exports, "FaHanukiah", ()=>FaHanukiah);
parcelHelpers.export(exports, "FaHandshake", ()=>FaHandshake);
parcelHelpers.export(exports, "FaHandshakeSlash", ()=>FaHandshakeSlash);
parcelHelpers.export(exports, "FaHandshakeAltSlash", ()=>FaHandshakeAltSlash);
parcelHelpers.export(exports, "FaHands", ()=>FaHands);
parcelHelpers.export(exports, "FaHandsWash", ()=>FaHandsWash);
parcelHelpers.export(exports, "FaHandsHelping", ()=>FaHandsHelping);
parcelHelpers.export(exports, "FaHandSpock", ()=>FaHandSpock);
parcelHelpers.export(exports, "FaHandSparkles", ()=>FaHandSparkles);
parcelHelpers.export(exports, "FaHandScissors", ()=>FaHandScissors);
parcelHelpers.export(exports, "FaHandRock", ()=>FaHandRock);
parcelHelpers.export(exports, "FaHandPointer", ()=>FaHandPointer);
parcelHelpers.export(exports, "FaHandPointUp", ()=>FaHandPointUp);
parcelHelpers.export(exports, "FaHandPointRight", ()=>FaHandPointRight);
parcelHelpers.export(exports, "FaHandPointLeft", ()=>FaHandPointLeft);
parcelHelpers.export(exports, "FaHandPointDown", ()=>FaHandPointDown);
parcelHelpers.export(exports, "FaHandPeace", ()=>FaHandPeace);
parcelHelpers.export(exports, "FaHandPaper", ()=>FaHandPaper);
parcelHelpers.export(exports, "FaHandMiddleFinger", ()=>FaHandMiddleFinger);
parcelHelpers.export(exports, "FaHandLizard", ()=>FaHandLizard);
parcelHelpers.export(exports, "FaHandHolding", ()=>FaHandHolding);
parcelHelpers.export(exports, "FaHandHoldingWater", ()=>FaHandHoldingWater);
parcelHelpers.export(exports, "FaHandHoldingUsd", ()=>FaHandHoldingUsd);
parcelHelpers.export(exports, "FaHandHoldingMedical", ()=>FaHandHoldingMedical);
parcelHelpers.export(exports, "FaHandHoldingHeart", ()=>FaHandHoldingHeart);
parcelHelpers.export(exports, "FaHamsa", ()=>FaHamsa);
parcelHelpers.export(exports, "FaHammer", ()=>FaHammer);
parcelHelpers.export(exports, "FaHamburger", ()=>FaHamburger);
parcelHelpers.export(exports, "FaHSquare", ()=>FaHSquare);
parcelHelpers.export(exports, "FaGuitar", ()=>FaGuitar);
parcelHelpers.export(exports, "FaGripVertical", ()=>FaGripVertical);
parcelHelpers.export(exports, "FaGripLines", ()=>FaGripLines);
parcelHelpers.export(exports, "FaGripLinesVertical", ()=>FaGripLinesVertical);
parcelHelpers.export(exports, "FaGripHorizontal", ()=>FaGripHorizontal);
parcelHelpers.export(exports, "FaGrin", ()=>FaGrin);
parcelHelpers.export(exports, "FaGrinWink", ()=>FaGrinWink);
parcelHelpers.export(exports, "FaGrinTongue", ()=>FaGrinTongue);
parcelHelpers.export(exports, "FaGrinTongueWink", ()=>FaGrinTongueWink);
parcelHelpers.export(exports, "FaGrinTongueSquint", ()=>FaGrinTongueSquint);
parcelHelpers.export(exports, "FaGrinTears", ()=>FaGrinTears);
parcelHelpers.export(exports, "FaGrinStars", ()=>FaGrinStars);
parcelHelpers.export(exports, "FaGrinSquint", ()=>FaGrinSquint);
parcelHelpers.export(exports, "FaGrinSquintTears", ()=>FaGrinSquintTears);
parcelHelpers.export(exports, "FaGrinHearts", ()=>FaGrinHearts);
parcelHelpers.export(exports, "FaGrinBeam", ()=>FaGrinBeam);
parcelHelpers.export(exports, "FaGrinBeamSweat", ()=>FaGrinBeamSweat);
parcelHelpers.export(exports, "FaGrinAlt", ()=>FaGrinAlt);
parcelHelpers.export(exports, "FaGrimace", ()=>FaGrimace);
parcelHelpers.export(exports, "FaGreaterThan", ()=>FaGreaterThan);
parcelHelpers.export(exports, "FaGreaterThanEqual", ()=>FaGreaterThanEqual);
parcelHelpers.export(exports, "FaGraduationCap", ()=>FaGraduationCap);
parcelHelpers.export(exports, "FaGopuram", ()=>FaGopuram);
parcelHelpers.export(exports, "FaGolfBall", ()=>FaGolfBall);
parcelHelpers.export(exports, "FaGlobe", ()=>FaGlobe);
parcelHelpers.export(exports, "FaGlobeEurope", ()=>FaGlobeEurope);
parcelHelpers.export(exports, "FaGlobeAsia", ()=>FaGlobeAsia);
parcelHelpers.export(exports, "FaGlobeAmericas", ()=>FaGlobeAmericas);
parcelHelpers.export(exports, "FaGlobeAfrica", ()=>FaGlobeAfrica);
parcelHelpers.export(exports, "FaGlasses", ()=>FaGlasses);
parcelHelpers.export(exports, "FaGlassWhiskey", ()=>FaGlassWhiskey);
parcelHelpers.export(exports, "FaGlassMartini", ()=>FaGlassMartini);
parcelHelpers.export(exports, "FaGlassMartiniAlt", ()=>FaGlassMartiniAlt);
parcelHelpers.export(exports, "FaGlassCheers", ()=>FaGlassCheers);
parcelHelpers.export(exports, "FaGifts", ()=>FaGifts);
parcelHelpers.export(exports, "FaGift", ()=>FaGift);
parcelHelpers.export(exports, "FaGhost", ()=>FaGhost);
parcelHelpers.export(exports, "FaGenderless", ()=>FaGenderless);
parcelHelpers.export(exports, "FaGem", ()=>FaGem);
parcelHelpers.export(exports, "FaGavel", ()=>FaGavel);
parcelHelpers.export(exports, "FaGasPump", ()=>FaGasPump);
parcelHelpers.export(exports, "FaGamepad", ()=>FaGamepad);
parcelHelpers.export(exports, "FaFutbol", ()=>FaFutbol);
parcelHelpers.export(exports, "FaFunnelDollar", ()=>FaFunnelDollar);
parcelHelpers.export(exports, "FaFrown", ()=>FaFrown);
parcelHelpers.export(exports, "FaFrownOpen", ()=>FaFrownOpen);
parcelHelpers.export(exports, "FaFrog", ()=>FaFrog);
parcelHelpers.export(exports, "FaForward", ()=>FaForward);
parcelHelpers.export(exports, "FaFootballBall", ()=>FaFootballBall);
parcelHelpers.export(exports, "FaFont", ()=>FaFont);
parcelHelpers.export(exports, "FaFolder", ()=>FaFolder);
parcelHelpers.export(exports, "FaFolderPlus", ()=>FaFolderPlus);
parcelHelpers.export(exports, "FaFolderOpen", ()=>FaFolderOpen);
parcelHelpers.export(exports, "FaFolderMinus", ()=>FaFolderMinus);
parcelHelpers.export(exports, "FaFlushed", ()=>FaFlushed);
parcelHelpers.export(exports, "FaFlask", ()=>FaFlask);
parcelHelpers.export(exports, "FaFlag", ()=>FaFlag);
parcelHelpers.export(exports, "FaFlagUsa", ()=>FaFlagUsa);
parcelHelpers.export(exports, "FaFlagCheckered", ()=>FaFlagCheckered);
parcelHelpers.export(exports, "FaFistRaised", ()=>FaFistRaised);
parcelHelpers.export(exports, "FaFish", ()=>FaFish);
parcelHelpers.export(exports, "FaFirstAid", ()=>FaFirstAid);
parcelHelpers.export(exports, "FaFire", ()=>FaFire);
parcelHelpers.export(exports, "FaFireExtinguisher", ()=>FaFireExtinguisher);
parcelHelpers.export(exports, "FaFireAlt", ()=>FaFireAlt);
parcelHelpers.export(exports, "FaFingerprint", ()=>FaFingerprint);
parcelHelpers.export(exports, "FaFilter", ()=>FaFilter);
parcelHelpers.export(exports, "FaFilm", ()=>FaFilm);
parcelHelpers.export(exports, "FaFill", ()=>FaFill);
parcelHelpers.export(exports, "FaFillDrip", ()=>FaFillDrip);
parcelHelpers.export(exports, "FaFile", ()=>FaFile);
parcelHelpers.export(exports, "FaFileWord", ()=>FaFileWord);
parcelHelpers.export(exports, "FaFileVideo", ()=>FaFileVideo);
parcelHelpers.export(exports, "FaFileUpload", ()=>FaFileUpload);
parcelHelpers.export(exports, "FaFileSignature", ()=>FaFileSignature);
parcelHelpers.export(exports, "FaFilePrescription", ()=>FaFilePrescription);
parcelHelpers.export(exports, "FaFilePowerpoint", ()=>FaFilePowerpoint);
parcelHelpers.export(exports, "FaFilePdf", ()=>FaFilePdf);
parcelHelpers.export(exports, "FaFileMedical", ()=>FaFileMedical);
parcelHelpers.export(exports, "FaFileMedicalAlt", ()=>FaFileMedicalAlt);
parcelHelpers.export(exports, "FaFileInvoice", ()=>FaFileInvoice);
parcelHelpers.export(exports, "FaFileInvoiceDollar", ()=>FaFileInvoiceDollar);
parcelHelpers.export(exports, "FaFileImport", ()=>FaFileImport);
parcelHelpers.export(exports, "FaFileImage", ()=>FaFileImage);
parcelHelpers.export(exports, "FaFileExport", ()=>FaFileExport);
parcelHelpers.export(exports, "FaFileExcel", ()=>FaFileExcel);
parcelHelpers.export(exports, "FaFileDownload", ()=>FaFileDownload);
parcelHelpers.export(exports, "FaFileCsv", ()=>FaFileCsv);
parcelHelpers.export(exports, "FaFileContract", ()=>FaFileContract);
parcelHelpers.export(exports, "FaFileCode", ()=>FaFileCode);
parcelHelpers.export(exports, "FaFileAudio", ()=>FaFileAudio);
parcelHelpers.export(exports, "FaFileArchive", ()=>FaFileArchive);
parcelHelpers.export(exports, "FaFileAlt", ()=>FaFileAlt);
parcelHelpers.export(exports, "FaFighterJet", ()=>FaFighterJet);
parcelHelpers.export(exports, "FaFemale", ()=>FaFemale);
parcelHelpers.export(exports, "FaFeather", ()=>FaFeather);
parcelHelpers.export(exports, "FaFeatherAlt", ()=>FaFeatherAlt);
parcelHelpers.export(exports, "FaFax", ()=>FaFax);
parcelHelpers.export(exports, "FaFaucet", ()=>FaFaucet);
parcelHelpers.export(exports, "FaFastForward", ()=>FaFastForward);
parcelHelpers.export(exports, "FaFastBackward", ()=>FaFastBackward);
parcelHelpers.export(exports, "FaFan", ()=>FaFan);
parcelHelpers.export(exports, "FaEye", ()=>FaEye);
parcelHelpers.export(exports, "FaEyeSlash", ()=>FaEyeSlash);
parcelHelpers.export(exports, "FaEyeDropper", ()=>FaEyeDropper);
parcelHelpers.export(exports, "FaExternalLinkSquareAlt", ()=>FaExternalLinkSquareAlt);
parcelHelpers.export(exports, "FaExternalLinkAlt", ()=>FaExternalLinkAlt);
parcelHelpers.export(exports, "FaExpand", ()=>FaExpand);
parcelHelpers.export(exports, "FaExpandArrowsAlt", ()=>FaExpandArrowsAlt);
parcelHelpers.export(exports, "FaExpandAlt", ()=>FaExpandAlt);
parcelHelpers.export(exports, "FaExclamation", ()=>FaExclamation);
parcelHelpers.export(exports, "FaExclamationTriangle", ()=>FaExclamationTriangle);
parcelHelpers.export(exports, "FaExclamationCircle", ()=>FaExclamationCircle);
parcelHelpers.export(exports, "FaExchangeAlt", ()=>FaExchangeAlt);
parcelHelpers.export(exports, "FaEuroSign", ()=>FaEuroSign);
parcelHelpers.export(exports, "FaEthernet", ()=>FaEthernet);
parcelHelpers.export(exports, "FaEraser", ()=>FaEraser);
parcelHelpers.export(exports, "FaEquals", ()=>FaEquals);
parcelHelpers.export(exports, "FaEnvelope", ()=>FaEnvelope);
parcelHelpers.export(exports, "FaEnvelopeSquare", ()=>FaEnvelopeSquare);
parcelHelpers.export(exports, "FaEnvelopeOpen", ()=>FaEnvelopeOpen);
parcelHelpers.export(exports, "FaEnvelopeOpenText", ()=>FaEnvelopeOpenText);
parcelHelpers.export(exports, "FaEllipsisV", ()=>FaEllipsisV);
parcelHelpers.export(exports, "FaEllipsisH", ()=>FaEllipsisH);
parcelHelpers.export(exports, "FaEject", ()=>FaEject);
parcelHelpers.export(exports, "FaEgg", ()=>FaEgg);
parcelHelpers.export(exports, "FaEdit", ()=>FaEdit);
parcelHelpers.export(exports, "FaDungeon", ()=>FaDungeon);
parcelHelpers.export(exports, "FaDumpster", ()=>FaDumpster);
parcelHelpers.export(exports, "FaDumpsterFire", ()=>FaDumpsterFire);
parcelHelpers.export(exports, "FaDumbbell", ()=>FaDumbbell);
parcelHelpers.export(exports, "FaDrumstickBite", ()=>FaDrumstickBite);
parcelHelpers.export(exports, "FaDrum", ()=>FaDrum);
parcelHelpers.export(exports, "FaDrumSteelpan", ()=>FaDrumSteelpan);
parcelHelpers.export(exports, "FaDrawPolygon", ()=>FaDrawPolygon);
parcelHelpers.export(exports, "FaDragon", ()=>FaDragon);
parcelHelpers.export(exports, "FaDraftingCompass", ()=>FaDraftingCompass);
parcelHelpers.export(exports, "FaDownload", ()=>FaDownload);
parcelHelpers.export(exports, "FaDove", ()=>FaDove);
parcelHelpers.export(exports, "FaDotCircle", ()=>FaDotCircle);
parcelHelpers.export(exports, "FaDoorOpen", ()=>FaDoorOpen);
parcelHelpers.export(exports, "FaDoorClosed", ()=>FaDoorClosed);
parcelHelpers.export(exports, "FaDonate", ()=>FaDonate);
parcelHelpers.export(exports, "FaDolly", ()=>FaDolly);
parcelHelpers.export(exports, "FaDollyFlatbed", ()=>FaDollyFlatbed);
parcelHelpers.export(exports, "FaDollarSign", ()=>FaDollarSign);
parcelHelpers.export(exports, "FaDog", ()=>FaDog);
parcelHelpers.export(exports, "FaDna", ()=>FaDna);
parcelHelpers.export(exports, "FaDizzy", ()=>FaDizzy);
parcelHelpers.export(exports, "FaDivide", ()=>FaDivide);
parcelHelpers.export(exports, "FaDisease", ()=>FaDisease);
parcelHelpers.export(exports, "FaDirections", ()=>FaDirections);
parcelHelpers.export(exports, "FaDigitalTachograph", ()=>FaDigitalTachograph);
parcelHelpers.export(exports, "FaDice", ()=>FaDice);
parcelHelpers.export(exports, "FaDiceTwo", ()=>FaDiceTwo);
parcelHelpers.export(exports, "FaDiceThree", ()=>FaDiceThree);
parcelHelpers.export(exports, "FaDiceSix", ()=>FaDiceSix);
parcelHelpers.export(exports, "FaDiceOne", ()=>FaDiceOne);
parcelHelpers.export(exports, "FaDiceFour", ()=>FaDiceFour);
parcelHelpers.export(exports, "FaDiceFive", ()=>FaDiceFive);
parcelHelpers.export(exports, "FaDiceD6", ()=>FaDiceD6);
parcelHelpers.export(exports, "FaDiceD20", ()=>FaDiceD20);
parcelHelpers.export(exports, "FaDiagnoses", ()=>FaDiagnoses);
parcelHelpers.export(exports, "FaDharmachakra", ()=>FaDharmachakra);
parcelHelpers.export(exports, "FaDesktop", ()=>FaDesktop);
parcelHelpers.export(exports, "FaDemocrat", ()=>FaDemocrat);
parcelHelpers.export(exports, "FaDeaf", ()=>FaDeaf);
parcelHelpers.export(exports, "FaDatabase", ()=>FaDatabase);
parcelHelpers.export(exports, "FaCut", ()=>FaCut);
parcelHelpers.export(exports, "FaCubes", ()=>FaCubes);
parcelHelpers.export(exports, "FaCube", ()=>FaCube);
parcelHelpers.export(exports, "FaCrutch", ()=>FaCrutch);
parcelHelpers.export(exports, "FaCrown", ()=>FaCrown);
parcelHelpers.export(exports, "FaCrow", ()=>FaCrow);
parcelHelpers.export(exports, "FaCrosshairs", ()=>FaCrosshairs);
parcelHelpers.export(exports, "FaCross", ()=>FaCross);
parcelHelpers.export(exports, "FaCrop", ()=>FaCrop);
parcelHelpers.export(exports, "FaCropAlt", ()=>FaCropAlt);
parcelHelpers.export(exports, "FaCreditCard", ()=>FaCreditCard);
parcelHelpers.export(exports, "FaCouch", ()=>FaCouch);
parcelHelpers.export(exports, "FaCopyright", ()=>FaCopyright);
parcelHelpers.export(exports, "FaCopy", ()=>FaCopy);
parcelHelpers.export(exports, "FaCookie", ()=>FaCookie);
parcelHelpers.export(exports, "FaCookieBite", ()=>FaCookieBite);
parcelHelpers.export(exports, "FaConciergeBell", ()=>FaConciergeBell);
parcelHelpers.export(exports, "FaCompress", ()=>FaCompress);
parcelHelpers.export(exports, "FaCompressArrowsAlt", ()=>FaCompressArrowsAlt);
parcelHelpers.export(exports, "FaCompressAlt", ()=>FaCompressAlt);
parcelHelpers.export(exports, "FaCompass", ()=>FaCompass);
parcelHelpers.export(exports, "FaCompactDisc", ()=>FaCompactDisc);
parcelHelpers.export(exports, "FaComments", ()=>FaComments);
parcelHelpers.export(exports, "FaCommentsDollar", ()=>FaCommentsDollar);
parcelHelpers.export(exports, "FaComment", ()=>FaComment);
parcelHelpers.export(exports, "FaCommentSlash", ()=>FaCommentSlash);
parcelHelpers.export(exports, "FaCommentMedical", ()=>FaCommentMedical);
parcelHelpers.export(exports, "FaCommentDots", ()=>FaCommentDots);
parcelHelpers.export(exports, "FaCommentDollar", ()=>FaCommentDollar);
parcelHelpers.export(exports, "FaCommentAlt", ()=>FaCommentAlt);
parcelHelpers.export(exports, "FaColumns", ()=>FaColumns);
parcelHelpers.export(exports, "FaCoins", ()=>FaCoins);
parcelHelpers.export(exports, "FaCogs", ()=>FaCogs);
parcelHelpers.export(exports, "FaCog", ()=>FaCog);
parcelHelpers.export(exports, "FaCoffee", ()=>FaCoffee);
parcelHelpers.export(exports, "FaCode", ()=>FaCode);
parcelHelpers.export(exports, "FaCodeBranch", ()=>FaCodeBranch);
parcelHelpers.export(exports, "FaCocktail", ()=>FaCocktail);
parcelHelpers.export(exports, "FaCloud", ()=>FaCloud);
parcelHelpers.export(exports, "FaCloudUploadAlt", ()=>FaCloudUploadAlt);
parcelHelpers.export(exports, "FaCloudSun", ()=>FaCloudSun);
parcelHelpers.export(exports, "FaCloudSunRain", ()=>FaCloudSunRain);
parcelHelpers.export(exports, "FaCloudShowersHeavy", ()=>FaCloudShowersHeavy);
parcelHelpers.export(exports, "FaCloudRain", ()=>FaCloudRain);
parcelHelpers.export(exports, "FaCloudMoon", ()=>FaCloudMoon);
parcelHelpers.export(exports, "FaCloudMoonRain", ()=>FaCloudMoonRain);
parcelHelpers.export(exports, "FaCloudMeatball", ()=>FaCloudMeatball);
parcelHelpers.export(exports, "FaCloudDownloadAlt", ()=>FaCloudDownloadAlt);
parcelHelpers.export(exports, "FaClosedCaptioning", ()=>FaClosedCaptioning);
parcelHelpers.export(exports, "FaClone", ()=>FaClone);
parcelHelpers.export(exports, "FaClock", ()=>FaClock);
parcelHelpers.export(exports, "FaClipboard", ()=>FaClipboard);
parcelHelpers.export(exports, "FaClipboardList", ()=>FaClipboardList);
parcelHelpers.export(exports, "FaClipboardCheck", ()=>FaClipboardCheck);
parcelHelpers.export(exports, "FaClinicMedical", ()=>FaClinicMedical);
parcelHelpers.export(exports, "FaCity", ()=>FaCity);
parcelHelpers.export(exports, "FaCircle", ()=>FaCircle);
parcelHelpers.export(exports, "FaCircleNotch", ()=>FaCircleNotch);
parcelHelpers.export(exports, "FaChurch", ()=>FaChurch);
parcelHelpers.export(exports, "FaChild", ()=>FaChild);
parcelHelpers.export(exports, "FaChevronUp", ()=>FaChevronUp);
parcelHelpers.export(exports, "FaChevronRight", ()=>FaChevronRight);
parcelHelpers.export(exports, "FaChevronLeft", ()=>FaChevronLeft);
parcelHelpers.export(exports, "FaChevronDown", ()=>FaChevronDown);
parcelHelpers.export(exports, "FaChevronCircleUp", ()=>FaChevronCircleUp);
parcelHelpers.export(exports, "FaChevronCircleRight", ()=>FaChevronCircleRight);
parcelHelpers.export(exports, "FaChevronCircleLeft", ()=>FaChevronCircleLeft);
parcelHelpers.export(exports, "FaChevronCircleDown", ()=>FaChevronCircleDown);
parcelHelpers.export(exports, "FaChess", ()=>FaChess);
parcelHelpers.export(exports, "FaChessRook", ()=>FaChessRook);
parcelHelpers.export(exports, "FaChessQueen", ()=>FaChessQueen);
parcelHelpers.export(exports, "FaChessPawn", ()=>FaChessPawn);
parcelHelpers.export(exports, "FaChessKnight", ()=>FaChessKnight);
parcelHelpers.export(exports, "FaChessKing", ()=>FaChessKing);
parcelHelpers.export(exports, "FaChessBoard", ()=>FaChessBoard);
parcelHelpers.export(exports, "FaChessBishop", ()=>FaChessBishop);
parcelHelpers.export(exports, "FaCheese", ()=>FaCheese);
parcelHelpers.export(exports, "FaCheck", ()=>FaCheck);
parcelHelpers.export(exports, "FaCheckSquare", ()=>FaCheckSquare);
parcelHelpers.export(exports, "FaCheckDouble", ()=>FaCheckDouble);
parcelHelpers.export(exports, "FaCheckCircle", ()=>FaCheckCircle);
parcelHelpers.export(exports, "FaChartPie", ()=>FaChartPie);
parcelHelpers.export(exports, "FaChartLine", ()=>FaChartLine);
parcelHelpers.export(exports, "FaChartBar", ()=>FaChartBar);
parcelHelpers.export(exports, "FaChartArea", ()=>FaChartArea);
parcelHelpers.export(exports, "FaChargingStation", ()=>FaChargingStation);
parcelHelpers.export(exports, "FaChalkboard", ()=>FaChalkboard);
parcelHelpers.export(exports, "FaChalkboardTeacher", ()=>FaChalkboardTeacher);
parcelHelpers.export(exports, "FaChair", ()=>FaChair);
parcelHelpers.export(exports, "FaCertificate", ()=>FaCertificate);
parcelHelpers.export(exports, "FaCat", ()=>FaCat);
parcelHelpers.export(exports, "FaCashRegister", ()=>FaCashRegister);
parcelHelpers.export(exports, "FaCartPlus", ()=>FaCartPlus);
parcelHelpers.export(exports, "FaCartArrowDown", ()=>FaCartArrowDown);
parcelHelpers.export(exports, "FaCarrot", ()=>FaCarrot);
parcelHelpers.export(exports, "FaCaretUp", ()=>FaCaretUp);
parcelHelpers.export(exports, "FaCaretSquareUp", ()=>FaCaretSquareUp);
parcelHelpers.export(exports, "FaCaretSquareRight", ()=>FaCaretSquareRight);
parcelHelpers.export(exports, "FaCaretSquareLeft", ()=>FaCaretSquareLeft);
parcelHelpers.export(exports, "FaCaretSquareDown", ()=>FaCaretSquareDown);
parcelHelpers.export(exports, "FaCaretRight", ()=>FaCaretRight);
parcelHelpers.export(exports, "FaCaretLeft", ()=>FaCaretLeft);
parcelHelpers.export(exports, "FaCaretDown", ()=>FaCaretDown);
parcelHelpers.export(exports, "FaCaravan", ()=>FaCaravan);
parcelHelpers.export(exports, "FaCar", ()=>FaCar);
parcelHelpers.export(exports, "FaCarSide", ()=>FaCarSide);
parcelHelpers.export(exports, "FaCarCrash", ()=>FaCarCrash);
parcelHelpers.export(exports, "FaCarBattery", ()=>FaCarBattery);
parcelHelpers.export(exports, "FaCarAlt", ()=>FaCarAlt);
parcelHelpers.export(exports, "FaCapsules", ()=>FaCapsules);
parcelHelpers.export(exports, "FaCannabis", ()=>FaCannabis);
parcelHelpers.export(exports, "FaCandyCane", ()=>FaCandyCane);
parcelHelpers.export(exports, "FaCampground", ()=>FaCampground);
parcelHelpers.export(exports, "FaCamera", ()=>FaCamera);
parcelHelpers.export(exports, "FaCameraRetro", ()=>FaCameraRetro);
parcelHelpers.export(exports, "FaCalendar", ()=>FaCalendar);
parcelHelpers.export(exports, "FaCalendarWeek", ()=>FaCalendarWeek);
parcelHelpers.export(exports, "FaCalendarTimes", ()=>FaCalendarTimes);
parcelHelpers.export(exports, "FaCalendarPlus", ()=>FaCalendarPlus);
parcelHelpers.export(exports, "FaCalendarMinus", ()=>FaCalendarMinus);
parcelHelpers.export(exports, "FaCalendarDay", ()=>FaCalendarDay);
parcelHelpers.export(exports, "FaCalendarCheck", ()=>FaCalendarCheck);
parcelHelpers.export(exports, "FaCalendarAlt", ()=>FaCalendarAlt);
parcelHelpers.export(exports, "FaCalculator", ()=>FaCalculator);
parcelHelpers.export(exports, "FaBusinessTime", ()=>FaBusinessTime);
parcelHelpers.export(exports, "FaBus", ()=>FaBus);
parcelHelpers.export(exports, "FaBusAlt", ()=>FaBusAlt);
parcelHelpers.export(exports, "FaBurn", ()=>FaBurn);
parcelHelpers.export(exports, "FaBullseye", ()=>FaBullseye);
parcelHelpers.export(exports, "FaBullhorn", ()=>FaBullhorn);
parcelHelpers.export(exports, "FaBuilding", ()=>FaBuilding);
parcelHelpers.export(exports, "FaBug", ()=>FaBug);
parcelHelpers.export(exports, "FaBrush", ()=>FaBrush);
parcelHelpers.export(exports, "FaBroom", ()=>FaBroom);
parcelHelpers.export(exports, "FaBroadcastTower", ()=>FaBroadcastTower);
parcelHelpers.export(exports, "FaBriefcase", ()=>FaBriefcase);
parcelHelpers.export(exports, "FaBriefcaseMedical", ()=>FaBriefcaseMedical);
parcelHelpers.export(exports, "FaBreadSlice", ()=>FaBreadSlice);
parcelHelpers.export(exports, "FaBrain", ()=>FaBrain);
parcelHelpers.export(exports, "FaBraille", ()=>FaBraille);
parcelHelpers.export(exports, "FaBoxes", ()=>FaBoxes);
parcelHelpers.export(exports, "FaBox", ()=>FaBox);
parcelHelpers.export(exports, "FaBoxTissue", ()=>FaBoxTissue);
parcelHelpers.export(exports, "FaBoxOpen", ()=>FaBoxOpen);
parcelHelpers.export(exports, "FaBowlingBall", ()=>FaBowlingBall);
parcelHelpers.export(exports, "FaBorderStyle", ()=>FaBorderStyle);
parcelHelpers.export(exports, "FaBorderNone", ()=>FaBorderNone);
parcelHelpers.export(exports, "FaBorderAll", ()=>FaBorderAll);
parcelHelpers.export(exports, "FaBookmark", ()=>FaBookmark);
parcelHelpers.export(exports, "FaBook", ()=>FaBook);
parcelHelpers.export(exports, "FaBookReader", ()=>FaBookReader);
parcelHelpers.export(exports, "FaBookOpen", ()=>FaBookOpen);
parcelHelpers.export(exports, "FaBookMedical", ()=>FaBookMedical);
parcelHelpers.export(exports, "FaBookDead", ()=>FaBookDead);
parcelHelpers.export(exports, "FaBong", ()=>FaBong);
parcelHelpers.export(exports, "FaBone", ()=>FaBone);
parcelHelpers.export(exports, "FaBomb", ()=>FaBomb);
parcelHelpers.export(exports, "FaBolt", ()=>FaBolt);
parcelHelpers.export(exports, "FaBold", ()=>FaBold);
parcelHelpers.export(exports, "FaBlog", ()=>FaBlog);
parcelHelpers.export(exports, "FaBlind", ()=>FaBlind);
parcelHelpers.export(exports, "FaBlender", ()=>FaBlender);
parcelHelpers.export(exports, "FaBlenderPhone", ()=>FaBlenderPhone);
parcelHelpers.export(exports, "FaBirthdayCake", ()=>FaBirthdayCake);
parcelHelpers.export(exports, "FaBiohazard", ()=>FaBiohazard);
parcelHelpers.export(exports, "FaBinoculars", ()=>FaBinoculars);
parcelHelpers.export(exports, "FaBiking", ()=>FaBiking);
parcelHelpers.export(exports, "FaBicycle", ()=>FaBicycle);
parcelHelpers.export(exports, "FaBible", ()=>FaBible);
parcelHelpers.export(exports, "FaBezierCurve", ()=>FaBezierCurve);
parcelHelpers.export(exports, "FaBell", ()=>FaBell);
parcelHelpers.export(exports, "FaBellSlash", ()=>FaBellSlash);
parcelHelpers.export(exports, "FaBeer", ()=>FaBeer);
parcelHelpers.export(exports, "FaBed", ()=>FaBed);
parcelHelpers.export(exports, "FaBatteryThreeQuarters", ()=>FaBatteryThreeQuarters);
parcelHelpers.export(exports, "FaBatteryQuarter", ()=>FaBatteryQuarter);
parcelHelpers.export(exports, "FaBatteryHalf", ()=>FaBatteryHalf);
parcelHelpers.export(exports, "FaBatteryFull", ()=>FaBatteryFull);
parcelHelpers.export(exports, "FaBatteryEmpty", ()=>FaBatteryEmpty);
parcelHelpers.export(exports, "FaBath", ()=>FaBath);
parcelHelpers.export(exports, "FaBasketballBall", ()=>FaBasketballBall);
parcelHelpers.export(exports, "FaBaseballBall", ()=>FaBaseballBall);
parcelHelpers.export(exports, "FaBars", ()=>FaBars);
parcelHelpers.export(exports, "FaBarcode", ()=>FaBarcode);
parcelHelpers.export(exports, "FaBandAid", ()=>FaBandAid);
parcelHelpers.export(exports, "FaBan", ()=>FaBan);
parcelHelpers.export(exports, "FaBalanceScale", ()=>FaBalanceScale);
parcelHelpers.export(exports, "FaBalanceScaleRight", ()=>FaBalanceScaleRight);
parcelHelpers.export(exports, "FaBalanceScaleLeft", ()=>FaBalanceScaleLeft);
parcelHelpers.export(exports, "FaBahai", ()=>FaBahai);
parcelHelpers.export(exports, "FaBacterium", ()=>FaBacterium);
parcelHelpers.export(exports, "FaBacteria", ()=>FaBacteria);
parcelHelpers.export(exports, "FaBacon", ()=>FaBacon);
parcelHelpers.export(exports, "FaBackward", ()=>FaBackward);
parcelHelpers.export(exports, "FaBackspace", ()=>FaBackspace);
parcelHelpers.export(exports, "FaBaby", ()=>FaBaby);
parcelHelpers.export(exports, "FaBabyCarriage", ()=>FaBabyCarriage);
parcelHelpers.export(exports, "FaAward", ()=>FaAward);
parcelHelpers.export(exports, "FaAudioDescription", ()=>FaAudioDescription);
parcelHelpers.export(exports, "FaAtom", ()=>FaAtom);
parcelHelpers.export(exports, "FaAtlas", ()=>FaAtlas);
parcelHelpers.export(exports, "FaAt", ()=>FaAt);
parcelHelpers.export(exports, "FaAsterisk", ()=>FaAsterisk);
parcelHelpers.export(exports, "FaAssistiveListeningSystems", ()=>FaAssistiveListeningSystems);
parcelHelpers.export(exports, "FaArrowsAlt", ()=>FaArrowsAlt);
parcelHelpers.export(exports, "FaArrowsAltV", ()=>FaArrowsAltV);
parcelHelpers.export(exports, "FaArrowsAltH", ()=>FaArrowsAltH);
parcelHelpers.export(exports, "FaArrowUp", ()=>FaArrowUp);
parcelHelpers.export(exports, "FaArrowRight", ()=>FaArrowRight);
parcelHelpers.export(exports, "FaArrowLeft", ()=>FaArrowLeft);
parcelHelpers.export(exports, "FaArrowDown", ()=>FaArrowDown);
parcelHelpers.export(exports, "FaArrowCircleUp", ()=>FaArrowCircleUp);
parcelHelpers.export(exports, "FaArrowCircleRight", ()=>FaArrowCircleRight);
parcelHelpers.export(exports, "FaArrowCircleLeft", ()=>FaArrowCircleLeft);
parcelHelpers.export(exports, "FaArrowCircleDown", ()=>FaArrowCircleDown);
parcelHelpers.export(exports, "FaArrowAltCircleUp", ()=>FaArrowAltCircleUp);
parcelHelpers.export(exports, "FaArrowAltCircleRight", ()=>FaArrowAltCircleRight);
parcelHelpers.export(exports, "FaArrowAltCircleLeft", ()=>FaArrowAltCircleLeft);
parcelHelpers.export(exports, "FaArrowAltCircleDown", ()=>FaArrowAltCircleDown);
parcelHelpers.export(exports, "FaArchway", ()=>FaArchway);
parcelHelpers.export(exports, "FaArchive", ()=>FaArchive);
parcelHelpers.export(exports, "FaAppleAlt", ()=>FaAppleAlt);
parcelHelpers.export(exports, "FaAnkh", ()=>FaAnkh);
parcelHelpers.export(exports, "FaAngry", ()=>FaAngry);
parcelHelpers.export(exports, "FaAngleUp", ()=>FaAngleUp);
parcelHelpers.export(exports, "FaAngleRight", ()=>FaAngleRight);
parcelHelpers.export(exports, "FaAngleLeft", ()=>FaAngleLeft);
parcelHelpers.export(exports, "FaAngleDown", ()=>FaAngleDown);
parcelHelpers.export(exports, "FaAngleDoubleUp", ()=>FaAngleDoubleUp);
parcelHelpers.export(exports, "FaAngleDoubleRight", ()=>FaAngleDoubleRight);
parcelHelpers.export(exports, "FaAngleDoubleLeft", ()=>FaAngleDoubleLeft);
parcelHelpers.export(exports, "FaAngleDoubleDown", ()=>FaAngleDoubleDown);
parcelHelpers.export(exports, "FaAnchor", ()=>FaAnchor);
parcelHelpers.export(exports, "FaAmericanSignLanguageInterpreting", ()=>FaAmericanSignLanguageInterpreting);
parcelHelpers.export(exports, "FaAmbulance", ()=>FaAmbulance);
parcelHelpers.export(exports, "FaAllergies", ()=>FaAllergies);
parcelHelpers.export(exports, "FaAlignRight", ()=>FaAlignRight);
parcelHelpers.export(exports, "FaAlignLeft", ()=>FaAlignLeft);
parcelHelpers.export(exports, "FaAlignJustify", ()=>FaAlignJustify);
parcelHelpers.export(exports, "FaAlignCenter", ()=>FaAlignCenter);
parcelHelpers.export(exports, "FaAirFreshener", ()=>FaAirFreshener);
parcelHelpers.export(exports, "FaAdjust", ()=>FaAdjust);
parcelHelpers.export(exports, "FaAddressCard", ()=>FaAddressCard);
parcelHelpers.export(exports, "FaAddressBook", ()=>FaAddressBook);
parcelHelpers.export(exports, "FaAd", ()=>FaAd);
parcelHelpers.export(exports, "FaRegWindowRestore", ()=>FaRegWindowRestore);
parcelHelpers.export(exports, "FaRegWindowMinimize", ()=>FaRegWindowMinimize);
parcelHelpers.export(exports, "FaRegWindowMaximize", ()=>FaRegWindowMaximize);
parcelHelpers.export(exports, "FaRegWindowClose", ()=>FaRegWindowClose);
parcelHelpers.export(exports, "FaRegUser", ()=>FaRegUser);
parcelHelpers.export(exports, "FaRegUserCircle", ()=>FaRegUserCircle);
parcelHelpers.export(exports, "FaRegTrashAlt", ()=>FaRegTrashAlt);
parcelHelpers.export(exports, "FaRegTired", ()=>FaRegTired);
parcelHelpers.export(exports, "FaRegTimesCircle", ()=>FaRegTimesCircle);
parcelHelpers.export(exports, "FaRegThumbsUp", ()=>FaRegThumbsUp);
parcelHelpers.export(exports, "FaRegThumbsDown", ()=>FaRegThumbsDown);
parcelHelpers.export(exports, "FaRegSurprise", ()=>FaRegSurprise);
parcelHelpers.export(exports, "FaRegSun", ()=>FaRegSun);
parcelHelpers.export(exports, "FaRegStopCircle", ()=>FaRegStopCircle);
parcelHelpers.export(exports, "FaRegStickyNote", ()=>FaRegStickyNote);
parcelHelpers.export(exports, "FaRegStar", ()=>FaRegStar);
parcelHelpers.export(exports, "FaRegStarHalf", ()=>FaRegStarHalf);
parcelHelpers.export(exports, "FaRegSquare", ()=>FaRegSquare);
parcelHelpers.export(exports, "FaRegSnowflake", ()=>FaRegSnowflake);
parcelHelpers.export(exports, "FaRegSmile", ()=>FaRegSmile);
parcelHelpers.export(exports, "FaRegSmileWink", ()=>FaRegSmileWink);
parcelHelpers.export(exports, "FaRegSmileBeam", ()=>FaRegSmileBeam);
parcelHelpers.export(exports, "FaRegShareSquare", ()=>FaRegShareSquare);
parcelHelpers.export(exports, "FaRegSave", ()=>FaRegSave);
parcelHelpers.export(exports, "FaRegSadTear", ()=>FaRegSadTear);
parcelHelpers.export(exports, "FaRegSadCry", ()=>FaRegSadCry);
parcelHelpers.export(exports, "FaRegRegistered", ()=>FaRegRegistered);
parcelHelpers.export(exports, "FaRegQuestionCircle", ()=>FaRegQuestionCircle);
parcelHelpers.export(exports, "FaRegPlusSquare", ()=>FaRegPlusSquare);
parcelHelpers.export(exports, "FaRegPlayCircle", ()=>FaRegPlayCircle);
parcelHelpers.export(exports, "FaRegPauseCircle", ()=>FaRegPauseCircle);
parcelHelpers.export(exports, "FaRegPaperPlane", ()=>FaRegPaperPlane);
parcelHelpers.export(exports, "FaRegObjectUngroup", ()=>FaRegObjectUngroup);
parcelHelpers.export(exports, "FaRegObjectGroup", ()=>FaRegObjectGroup);
parcelHelpers.export(exports, "FaRegNewspaper", ()=>FaRegNewspaper);
parcelHelpers.export(exports, "FaRegMoon", ()=>FaRegMoon);
parcelHelpers.export(exports, "FaRegMoneyBillAlt", ()=>FaRegMoneyBillAlt);
parcelHelpers.export(exports, "FaRegMinusSquare", ()=>FaRegMinusSquare);
parcelHelpers.export(exports, "FaRegMeh", ()=>FaRegMeh);
parcelHelpers.export(exports, "FaRegMehRollingEyes", ()=>FaRegMehRollingEyes);
parcelHelpers.export(exports, "FaRegMehBlank", ()=>FaRegMehBlank);
parcelHelpers.export(exports, "FaRegMap", ()=>FaRegMap);
parcelHelpers.export(exports, "FaRegListAlt", ()=>FaRegListAlt);
parcelHelpers.export(exports, "FaRegLightbulb", ()=>FaRegLightbulb);
parcelHelpers.export(exports, "FaRegLifeRing", ()=>FaRegLifeRing);
parcelHelpers.export(exports, "FaRegLemon", ()=>FaRegLemon);
parcelHelpers.export(exports, "FaRegLaugh", ()=>FaRegLaugh);
parcelHelpers.export(exports, "FaRegLaughWink", ()=>FaRegLaughWink);
parcelHelpers.export(exports, "FaRegLaughSquint", ()=>FaRegLaughSquint);
parcelHelpers.export(exports, "FaRegLaughBeam", ()=>FaRegLaughBeam);
parcelHelpers.export(exports, "FaRegKiss", ()=>FaRegKiss);
parcelHelpers.export(exports, "FaRegKissWinkHeart", ()=>FaRegKissWinkHeart);
parcelHelpers.export(exports, "FaRegKissBeam", ()=>FaRegKissBeam);
parcelHelpers.export(exports, "FaRegKeyboard", ()=>FaRegKeyboard);
parcelHelpers.export(exports, "FaRegImages", ()=>FaRegImages);
parcelHelpers.export(exports, "FaRegImage", ()=>FaRegImage);
parcelHelpers.export(exports, "FaRegIdCard", ()=>FaRegIdCard);
parcelHelpers.export(exports, "FaRegIdBadge", ()=>FaRegIdBadge);
parcelHelpers.export(exports, "FaRegHourglass", ()=>FaRegHourglass);
parcelHelpers.export(exports, "FaRegHospital", ()=>FaRegHospital);
parcelHelpers.export(exports, "FaRegHeart", ()=>FaRegHeart);
parcelHelpers.export(exports, "FaRegHdd", ()=>FaRegHdd);
parcelHelpers.export(exports, "FaRegHandshake", ()=>FaRegHandshake);
parcelHelpers.export(exports, "FaRegHandSpock", ()=>FaRegHandSpock);
parcelHelpers.export(exports, "FaRegHandScissors", ()=>FaRegHandScissors);
parcelHelpers.export(exports, "FaRegHandRock", ()=>FaRegHandRock);
parcelHelpers.export(exports, "FaRegHandPointer", ()=>FaRegHandPointer);
parcelHelpers.export(exports, "FaRegHandPointUp", ()=>FaRegHandPointUp);
parcelHelpers.export(exports, "FaRegHandPointRight", ()=>FaRegHandPointRight);
parcelHelpers.export(exports, "FaRegHandPointLeft", ()=>FaRegHandPointLeft);
parcelHelpers.export(exports, "FaRegHandPointDown", ()=>FaRegHandPointDown);
parcelHelpers.export(exports, "FaRegHandPeace", ()=>FaRegHandPeace);
parcelHelpers.export(exports, "FaRegHandPaper", ()=>FaRegHandPaper);
parcelHelpers.export(exports, "FaRegHandLizard", ()=>FaRegHandLizard);
parcelHelpers.export(exports, "FaRegGrin", ()=>FaRegGrin);
parcelHelpers.export(exports, "FaRegGrinWink", ()=>FaRegGrinWink);
parcelHelpers.export(exports, "FaRegGrinTongue", ()=>FaRegGrinTongue);
parcelHelpers.export(exports, "FaRegGrinTongueWink", ()=>FaRegGrinTongueWink);
parcelHelpers.export(exports, "FaRegGrinTongueSquint", ()=>FaRegGrinTongueSquint);
parcelHelpers.export(exports, "FaRegGrinTears", ()=>FaRegGrinTears);
parcelHelpers.export(exports, "FaRegGrinStars", ()=>FaRegGrinStars);
parcelHelpers.export(exports, "FaRegGrinSquint", ()=>FaRegGrinSquint);
parcelHelpers.export(exports, "FaRegGrinSquintTears", ()=>FaRegGrinSquintTears);
parcelHelpers.export(exports, "FaRegGrinHearts", ()=>FaRegGrinHearts);
parcelHelpers.export(exports, "FaRegGrinBeam", ()=>FaRegGrinBeam);
parcelHelpers.export(exports, "FaRegGrinBeamSweat", ()=>FaRegGrinBeamSweat);
parcelHelpers.export(exports, "FaRegGrinAlt", ()=>FaRegGrinAlt);
parcelHelpers.export(exports, "FaRegGrimace", ()=>FaRegGrimace);
parcelHelpers.export(exports, "FaRegGem", ()=>FaRegGem);
parcelHelpers.export(exports, "FaRegFutbol", ()=>FaRegFutbol);
parcelHelpers.export(exports, "FaRegFrown", ()=>FaRegFrown);
parcelHelpers.export(exports, "FaRegFrownOpen", ()=>FaRegFrownOpen);
parcelHelpers.export(exports, "FaRegFontAwesomeLogoFull", ()=>FaRegFontAwesomeLogoFull);
parcelHelpers.export(exports, "FaRegFolder", ()=>FaRegFolder);
parcelHelpers.export(exports, "FaRegFolderOpen", ()=>FaRegFolderOpen);
parcelHelpers.export(exports, "FaRegFlushed", ()=>FaRegFlushed);
parcelHelpers.export(exports, "FaRegFlag", ()=>FaRegFlag);
parcelHelpers.export(exports, "FaRegFile", ()=>FaRegFile);
parcelHelpers.export(exports, "FaRegFileWord", ()=>FaRegFileWord);
parcelHelpers.export(exports, "FaRegFileVideo", ()=>FaRegFileVideo);
parcelHelpers.export(exports, "FaRegFilePowerpoint", ()=>FaRegFilePowerpoint);
parcelHelpers.export(exports, "FaRegFilePdf", ()=>FaRegFilePdf);
parcelHelpers.export(exports, "FaRegFileImage", ()=>FaRegFileImage);
parcelHelpers.export(exports, "FaRegFileExcel", ()=>FaRegFileExcel);
parcelHelpers.export(exports, "FaRegFileCode", ()=>FaRegFileCode);
parcelHelpers.export(exports, "FaRegFileAudio", ()=>FaRegFileAudio);
parcelHelpers.export(exports, "FaRegFileArchive", ()=>FaRegFileArchive);
parcelHelpers.export(exports, "FaRegFileAlt", ()=>FaRegFileAlt);
parcelHelpers.export(exports, "FaRegEye", ()=>FaRegEye);
parcelHelpers.export(exports, "FaRegEyeSlash", ()=>FaRegEyeSlash);
parcelHelpers.export(exports, "FaRegEnvelope", ()=>FaRegEnvelope);
parcelHelpers.export(exports, "FaRegEnvelopeOpen", ()=>FaRegEnvelopeOpen);
parcelHelpers.export(exports, "FaRegEdit", ()=>FaRegEdit);
parcelHelpers.export(exports, "FaRegDotCircle", ()=>FaRegDotCircle);
parcelHelpers.export(exports, "FaRegDizzy", ()=>FaRegDizzy);
parcelHelpers.export(exports, "FaRegCreditCard", ()=>FaRegCreditCard);
parcelHelpers.export(exports, "FaRegCopyright", ()=>FaRegCopyright);
parcelHelpers.export(exports, "FaRegCopy", ()=>FaRegCopy);
parcelHelpers.export(exports, "FaRegCompass", ()=>FaRegCompass);
parcelHelpers.export(exports, "FaRegComments", ()=>FaRegComments);
parcelHelpers.export(exports, "FaRegComment", ()=>FaRegComment);
parcelHelpers.export(exports, "FaRegCommentDots", ()=>FaRegCommentDots);
parcelHelpers.export(exports, "FaRegCommentAlt", ()=>FaRegCommentAlt);
parcelHelpers.export(exports, "FaRegClosedCaptioning", ()=>FaRegClosedCaptioning);
parcelHelpers.export(exports, "FaRegClone", ()=>FaRegClone);
parcelHelpers.export(exports, "FaRegClock", ()=>FaRegClock);
parcelHelpers.export(exports, "FaRegClipboard", ()=>FaRegClipboard);
parcelHelpers.export(exports, "FaRegCircle", ()=>FaRegCircle);
parcelHelpers.export(exports, "FaRegCheckSquare", ()=>FaRegCheckSquare);
parcelHelpers.export(exports, "FaRegCheckCircle", ()=>FaRegCheckCircle);
parcelHelpers.export(exports, "FaRegChartBar", ()=>FaRegChartBar);
parcelHelpers.export(exports, "FaRegCaretSquareUp", ()=>FaRegCaretSquareUp);
parcelHelpers.export(exports, "FaRegCaretSquareRight", ()=>FaRegCaretSquareRight);
parcelHelpers.export(exports, "FaRegCaretSquareLeft", ()=>FaRegCaretSquareLeft);
parcelHelpers.export(exports, "FaRegCaretSquareDown", ()=>FaRegCaretSquareDown);
parcelHelpers.export(exports, "FaRegCalendar", ()=>FaRegCalendar);
parcelHelpers.export(exports, "FaRegCalendarTimes", ()=>FaRegCalendarTimes);
parcelHelpers.export(exports, "FaRegCalendarPlus", ()=>FaRegCalendarPlus);
parcelHelpers.export(exports, "FaRegCalendarMinus", ()=>FaRegCalendarMinus);
parcelHelpers.export(exports, "FaRegCalendarCheck", ()=>FaRegCalendarCheck);
parcelHelpers.export(exports, "FaRegCalendarAlt", ()=>FaRegCalendarAlt);
parcelHelpers.export(exports, "FaRegBuilding", ()=>FaRegBuilding);
parcelHelpers.export(exports, "FaRegBookmark", ()=>FaRegBookmark);
parcelHelpers.export(exports, "FaRegBell", ()=>FaRegBell);
parcelHelpers.export(exports, "FaRegBellSlash", ()=>FaRegBellSlash);
parcelHelpers.export(exports, "FaRegArrowAltCircleUp", ()=>FaRegArrowAltCircleUp);
parcelHelpers.export(exports, "FaRegArrowAltCircleRight", ()=>FaRegArrowAltCircleRight);
parcelHelpers.export(exports, "FaRegArrowAltCircleLeft", ()=>FaRegArrowAltCircleLeft);
parcelHelpers.export(exports, "FaRegArrowAltCircleDown", ()=>FaRegArrowAltCircleDown);
parcelHelpers.export(exports, "FaRegAngry", ()=>FaRegAngry);
parcelHelpers.export(exports, "FaRegAddressCard", ()=>FaRegAddressCard);
parcelHelpers.export(exports, "FaRegAddressBook", ()=>FaRegAddressBook);
var _indexMjs = require("../lib/index.mjs");
function FaZhihu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYoutube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYoutubeSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYoast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYelp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYarn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYandex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYandexInternational(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYammer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.78 152.17A23.06 23.06 0 0 0 400.9 112c-.83.43-1.71.9-2.63 1.4-15.25 8.4-118.33 80.62-106.69 88.77s82.04-23.61 130.2-50zm0 217.17c-48.16-26.38-118.64-58.1-130.2-50s91.42 80.35 106.69 88.74c.92.51 1.8 1 2.63 1.41a23.07 23.07 0 0 0 20.88-40.15zM464.21 237c-.95 0-1.95-.06-3-.06-17.4 0-142.52 13.76-136.24 26.51s83.3 18.74 138.21 18.76a23 23 0 0 0 1-45.21zM31 96.65a24.88 24.88 0 0 1 46.14-18.4l81 205.06h1.21l77-203.53a23.52 23.52 0 0 1 44.45 15.27L171.2 368.44C152.65 415.66 134.08 448 77.91 448a139.67 139.67 0 0 1-23.81-1.95 21.31 21.31 0 0 1 6.9-41.77c.66.06 10.91.66 13.86.66 30.47 0 43.74-18.94 58.07-59.41z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYahoo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYCombinator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXingSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpressr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpforms(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpexplorer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpbeginner(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWordpress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWordpressSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWolfPackBattalion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWodu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWizardsOfTheCoast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindows(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWikipediaW(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWhmcs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWhatsapp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWhatsappSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeixin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeibo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeebly(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWaze(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWatchmanMonitoring(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVuejs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVnv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7 0 0-30 73.1-72.4 120.5-13.7 13.7-20 18.1-27.5 18.1-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5 0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5-20 0-68.6-73.4-97.4-157.4-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7 0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9 0-66.8-3.4-73.1 15.4-73.1 8.7 0 23.7 4.4 58.7 38.1 40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25-11.2-34.9-86.9-106.7-90.3-111.5-8.7-11.2-6.2-16.2 0-26.2.1-.1 72-101.3 79.4-135.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVimeo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVimeoV(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVimeoSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViber(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViadeo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViadeoSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViacoin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVaadin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUssunnah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 285.1l5.7 14.4h-8.2c-1.3-3.2-3.1-7.7-3.8-9.5-2.5-6.3-1.1-8.4 0-10 1.9-2.7 3.2-4.4 3.6-5.2 0 2.2.8 5.7 2.7 10.3zm297.3 18.8c-2.1 13.8-5.7 27.1-10.5 39.7l43 23.4-44.8-18.8c-5.3 13.2-12 25.6-19.9 37.2l34.2 30.2-36.8-26.4c-8.4 11.8-18 22.6-28.7 32.3l24.9 34.7-28.1-31.8c-11 9.6-23.1 18-36.1 25.1l15.7 37.2-19.3-35.3c-13.1 6.8-27 12.1-41.6 15.9l6.7 38.4-10.5-37.4c-14.3 3.4-29.2 5.3-44.5 5.4L256 512l-1.9-38.4c-15.3-.1-30.2-2-44.5-5.3L199 505.6l6.7-38.2c-14.6-3.7-28.6-9.1-41.7-15.8l-19.2 35.1 15.6-37c-13-7-25.2-15.4-36.2-25.1l-27.9 31.6 24.7-34.4c-10.7-9.7-20.4-20.5-28.8-32.3l-36.5 26.2 33.9-29.9c-7.9-11.6-14.6-24.1-20-37.3l-44.4 18.7L67.8 344c-4.8-12.7-8.4-26.1-10.5-39.9l-51 9 50.3-14.2c-1.1-8.5-1.7-17.1-1.7-25.9 0-4.7.2-9.4.5-14.1L0 256l56-2.8c1.3-13.1 3.8-25.8 7.5-38.1L6.4 199l58.9 10.4c4-12 9.1-23.5 15.2-34.4l-55.1-30 58.3 24.6C90 159 97.2 149.2 105.3 140L55.8 96.4l53.9 38.7c8.1-8.6 17-16.5 26.6-23.6l-40-55.6 45.6 51.6c9.5-6.6 19.7-12.3 30.3-17.2l-27.3-64.9 33.8 62.1c10.5-4.4 21.4-7.9 32.7-10.4L199 6.4l19.5 69.2c11-2.1 22.3-3.2 33.8-3.4L256 0l3.6 72.2c11.5.2 22.8 1.4 33.8 3.5L313 6.4l-12.4 70.7c11.3 2.6 22.2 6.1 32.6 10.5l33.9-62.2-27.4 65.1c10.6 4.9 20.7 10.7 30.2 17.2l45.8-51.8-40.1 55.9c9.5 7.1 18.4 15 26.5 23.6l54.2-38.9-49.7 43.9c8 9.1 15.2 18.9 21.5 29.4l58.7-24.7-55.5 30.2c6.1 10.9 11.1 22.3 15.1 34.3l59.3-10.4-57.5 16.2c3.7 12.2 6.2 24.9 7.5 37.9L512 256l-56 2.8c.3 4.6.5 9.3.5 14.1 0 8.7-.6 17.3-1.6 25.8l50.7 14.3-51.5-9.1zm-21.8-31c0-97.5-79-176.5-176.5-176.5s-176.5 79-176.5 176.5 79 176.5 176.5 176.5 176.5-79 176.5-176.5zm-24 0c0 84.3-68.3 152.6-152.6 152.6s-152.6-68.3-152.6-152.6 68.3-152.6 152.6-152.6 152.6 68.3 152.6 152.6zM195 241c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-40.7-19c0 2.1 1.3 3.8 3.6 5.1 3.5 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-19 0c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.4 6.8-9.6 10.9-9.6 12.6zm204.9 87.9c-8.4-3-8.7-6.8-8.7-15.6V182c-8.2 12.5-14.2 18.6-18 18.6 6.3 14.4 9.5 23.9 9.5 28.3v64.3c0 2.2-2.2 6.5-4.7 6.5h-18c-2.8-7.5-10.2-26.9-15.3-40.3-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3 2.6 6.7 6.4 16.5 7.9 20.2h-9.2c-3.9-10.4-9.6-25.4-11.8-31.1-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3.8 2 2.8 7.3 4.3 10.9H256c-1.5-4.1-5.6-14.6-8.4-22-2 2.5-7.2 9.2-10.7 13.7 2.5 1.6 4.3 3.6 5.2 6.3.2.6.5 1.4.6 1.7H225c-4.6-13.9-11.4-27.7-11.4-34.1 0-2.2.3-5.1 1.1-8.2-8.8 10.8-14 15.9-14 25 0 7.5 10.4 28.3 10.4 33.3 0 1.7-.5 3.3-1.4 4.9-9.6-12.7-15.5-20.7-18.8-20.7h-12l-11.2-28c-3.8-9.6-5.7-16-5.7-18.8 0-3.8.5-7.7 1.7-12.2-1 1.3-3.7 4.7-5.5 7.1-.8-2.1-3.1-7.7-4.6-11.5-2.1 2.5-7.5 9.1-11.2 13.6.9 2.3 3.3 8.1 4.9 12.2-2.5 3.3-9.1 11.8-13.6 17.7-4 5.3-5.8 13.3-2.7 21.8 2.5 6.7 2 7.9-1.7 14.1H191c5.5 0 14.3 14 15.5 22 13.2-16 15.4-19.6 16.8-21.6h107c3.9 0 7.2-1.9 9.9-5.8zm20.1-26.6V181.7c-9 12.5-15.9 18.6-20.7 18.6 7.1 14.4 10.7 23.9 10.7 28.3v66.3c0 17.5 8.6 20.4 24 20.4 8.1 0 12.5-.8 13.7-2.7-4.3-1.6-7.6-2.5-9.9-3.3-8.1-3.2-17.8-7.4-17.8-26z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsps(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUps(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUntappd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnsplash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.11,206.4,445.31,14.72,248.2,66.08,219,116.14l-59.2-.43L15.54,256,159.82,396.32l59.17-.43,29.24,50,197.08,51.36,52.8-191.62-30-49.63ZM223.77,124.2,374.55,86.51,288,232.33H114.87Zm0,263.63L114.87,279.71H288l86.55,145.81Zm193,14L330.17,256l86.58-145.84L458.56,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUniregistry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUncharted(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUmbraco(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 510 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUikit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUbuntu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUber(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTypo3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTwitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTwitterSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTwitch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTumblr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTumblrSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTripadvisor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.91,178.82,576,127.58H471.66a326.11,326.11,0,0,0-367,0H0l47.09,51.24A143.911,143.911,0,0,0,241.86,390.73L288,440.93l46.11-50.17A143.94,143.94,0,0,0,575.88,285.18h-.03A143.56,143.56,0,0,0,528.91,178.82ZM144.06,382.57a97.39,97.39,0,1,1,97.39-97.39A97.39,97.39,0,0,1,144.06,382.57ZM288,282.37c0-64.09-46.62-119.08-108.09-142.59a281,281,0,0,1,216.17,0C334.61,163.3,288,218.29,288,282.37Zm143.88,100.2h-.01a97.405,97.405,0,1,1,.01,0ZM144.06,234.12h-.01a51.06,51.06,0,1,0,51.06,51.06v-.11A51,51,0,0,0,144.06,234.12Zm287.82,0a51.06,51.06,0,1,0,51.06,51.06A51.06,51.06,0,0,0,431.88,234.12Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrello(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTradeFederation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTiktok(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThinkPeaks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThemeisle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThemeco(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTheRedYeti(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTencentWeibo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTelegram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTelegramPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTeamspeak(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.2 346.79c2.4-12.3-12-30-32.4-48.7-20.9-19.2-48.2-39.1-63.4-46.6-21.7-12-41.7-1.8-46.3 22.7-5 26.2 0 51.4 14.5 73.9 10.2 15.5 25.4 22.7 43.4 24 11.6.6 52.5 2.2 61.7-1 11.9-4.3 20.1-11.8 22.5-24.3zm205 20.8a5.22 5.22 0 0 0-8.3 2.4c-8 25.4-44.7 112.5-172.1 121.5-149.7 10.5 80.3 43.6 145.4-6.4 22.7-17.4 47.6-35 46.6-85.4-.4-10.1-4.9-26.69-11.6-32.1zm62-122.4c-.3-18.9-8.6-33.4-26-42.2-2.9-1.3-5-2.7-5.9-6.4A222.64 222.64 0 0 0 438.9 103c-1.1-1.5-3.5-3.2-2.2-5 8.5-11.5-.3-18-7-24.4Q321.4-31.11 177.4 13.09c-40.1 12.3-73.9 35.6-102 67.4-4 4.3-6.7 9.1-3 14.5 3 4 1.3 6.2-1 9.3C51.6 132 38.2 162.59 32.1 196c-.7 4.3-2.9 6-6.4 7.8-14.2 7-22.5 18.5-24.9 34L0 264.29v20.9c0 30.8 21 50.4 51.8 49 7.7-.3 11.7-4.3 12-11.5 2-77.5-2.4-95.4 3.7-125.8C92.1 72.39 234.3 5 345.3 65.39 411.4 102 445.7 159 447.6 234.79c.8 28.2 0 56.5 0 84.6 0 7 2.2 12.5 9.4 14.2 24.1 5 49.2-12 53.2-36.7 2.9-17.1 1-34.5 1-51.7zm-159.6 131.5c36.5 2.8 59.3-28.5 58.4-60.5-2.1-45.2-66.2-16.5-87.8-8-73.2 28.1-45 54.9-22.2 60.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSymfony(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSwift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSupple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuperpowers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStumbleupon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStumbleuponCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStudiovinari(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStripe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStripeS(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStrava(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStickerMule(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSteam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSteamSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSteamSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStaylinked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStackpath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStackOverflow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStackExchange(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarespace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpotify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpeakerDeck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpeakap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSourcetree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSoundcloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnapchat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm169.5 338.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C183.1 100 230.7 96 244.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnapchatSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6.5 314.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C159.1 100 206.7 96 220.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnapchatGhost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.846 392.673c-5.211 12.157-27.239 21.089-67.36 27.318-2.064 2.786-3.775 14.686-6.507 23.956-1.625 5.566-5.623 8.869-12.128 8.869l-.297-.005c-9.395 0-19.203-4.323-38.852-4.323-26.521 0-35.662 6.043-56.254 20.588-21.832 15.438-42.771 28.764-74.027 27.399-31.646 2.334-58.025-16.908-72.871-27.404-20.714-14.643-29.828-20.582-56.241-20.582-18.864 0-30.736 4.72-38.852 4.72-8.073 0-11.213-4.922-12.422-9.04-2.703-9.189-4.404-21.263-6.523-24.13-20.679-3.209-67.31-11.344-68.498-32.15a10.627 10.627 0 0 1 8.877-11.069c69.583-11.455 100.924-82.901 102.227-85.934.074-.176.155-.344.237-.515 3.713-7.537 4.544-13.849 2.463-18.753-5.05-11.896-26.872-16.164-36.053-19.796-23.715-9.366-27.015-20.128-25.612-27.504 2.437-12.836 21.725-20.735 33.002-15.453 8.919 4.181 16.843 6.297 23.547 6.297 5.022 0 8.212-1.204 9.96-2.171-2.043-35.936-7.101-87.29 5.687-115.969C158.122 21.304 229.705 15.42 250.826 15.42c.944 0 9.141-.089 10.11-.089 52.148 0 102.254 26.78 126.723 81.643 12.777 28.65 7.749 79.792 5.695 116.009 1.582.872 4.357 1.942 8.599 2.139 6.397-.286 13.815-2.389 22.069-6.257 6.085-2.846 14.406-2.461 20.48.058l.029.01c9.476 3.385 15.439 10.215 15.589 17.87.184 9.747-8.522 18.165-25.878 25.018-2.118.835-4.694 1.655-7.434 2.525-9.797 3.106-24.6 7.805-28.616 17.271-2.079 4.904-1.256 11.211 2.46 18.748.087.168.166.342.239.515 1.301 3.03 32.615 74.46 102.23 85.934 6.427 1.058 11.163 7.877 7.725 15.859z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlideshare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlackHash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.2 270.4c-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-30.3-90 45.4-15.1c19.1-6.2 29.1-26.8 23-45.9-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-93.4 31.2-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-45.3 15c-19.1 6.2-29.1 26.8-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l30.3 90L78 354.8c-19 6.2-29.1 26.9-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 93.6-31.3 15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 45.4-15.1c19-6 29.1-26.7 22.9-45.7zm-254.1 47.2l-30.3-90.2 93.5-31.3 30.3 90.2-93.5 31.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkype(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkyatlas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSketch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSith(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSistrix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSimplybuilt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShopware(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShopify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShirtsinbulk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaServicestack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSellsy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSellcast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchengin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 460 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScribd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchlix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSalesforce(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSafari(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRust(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRockrms(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRocketchat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRev(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaResolving(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaResearchgate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReplyd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRenren(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedhat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReddit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedditSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedditAlien(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedRiver(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRebel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReadme(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReacteurope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReact(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRavelry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRaspberryPi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 407 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRProject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 581 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuora(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuinscape(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQq(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPython(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPushed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 432 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaProductHunt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaystation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPinterest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPinterestSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPinterestP(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperPp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperHat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoenixSquadron(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoenixFramework(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhabricator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeriscope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPerbyte(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPennyArcade(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.91 164.27c-4.49 19.45-1.4 6.06-15.1 65.29l39.73-10.61c-22.34-49.61-17.29-38.41-24.63-54.68zm-206.09 51.11c-20.19 5.4-11.31 3.03-39.63 10.58l4.46 46.19c28.17-7.59 20.62-5.57 34.82-9.34 42.3-9.79 32.85-56.42.35-47.43zm326.16-26.19l-45.47-99.2c-5.69-12.37-19.46-18.84-32.62-15.33-70.27 18.75-38.72 10.32-135.59 36.23a27.618 27.618 0 0 0-18.89 17.41C144.26 113.27 0 153.75 0 226.67c0 33.5 30.67 67.11 80.9 95.37l1.74 17.88a27.891 27.891 0 0 0-17.77 28.67l4.3 44.48c1.39 14.31 13.43 25.21 27.8 25.2 5.18-.01-3.01 1.78 122.53-31.76 12.57-3.37 21.12-15.02 20.58-28.02 216.59 45.5 401.99-5.98 399.89-84.83.01-28.15-22.19-66.56-97.99-104.47zM255.14 298.3l-21.91 5.88-48.44 12.91 2.46 23.55 20.53-5.51 4.51 44.51-115.31 30.78-4.3-44.52 20.02-5.35-11.11-114.64-20.12 5.39-4.35-44.5c178.15-47.54 170.18-46.42 186.22-46.65 56.66-1.13 64.15 71.84 42.55 104.43a86.7 86.7 0 0 1-50.75 33.72zm199.18 16.62l-3.89-39.49 14.9-3.98-6.61-14.68-57.76 15.42-4.1 17.54 19.2-5.12 4.05 39.54-112.85 30.07-4.46-44.43 20.99-5.59 33.08-126.47-17.15 4.56-4.2-44.48c93.36-24.99 65.01-17.41 135.59-36.24l66.67 145.47 20.79-5.56 4.3 44.48-108.55 28.96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaypal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPatreon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPalfed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPagelines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPage4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOsi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOrcid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOptinMonster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOpera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOpenid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOpencart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOldRepublic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOdnoklassniki(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOdnoklassnikiSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOctopusDeploy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNutritionix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNs8(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNpm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNodeJs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNimblr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNeos(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNapster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMonero(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaModx(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMizuni(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMixer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMixcloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.43 219.729C416.124 134.727 344.135 68 256.919 68c-72.266 0-136.224 46.516-159.205 114.074-54.545 8.029-96.63 54.822-96.63 111.582 0 62.298 50.668 112.966 113.243 112.966h289.614c52.329 0 94.969-42.362 94.969-94.693 0-45.131-32.118-83.063-74.48-92.2zm-20.489 144.53H114.327c-39.04 0-70.881-31.564-70.881-70.604s31.841-70.604 70.881-70.604c18.827 0 36.548 7.475 49.838 20.766 19.963 19.963 50.133-10.227 30.18-30.18-14.675-14.398-32.672-24.365-52.053-29.349 19.935-44.3 64.79-73.926 114.628-73.926 69.496 0 125.979 56.483 125.979 125.702 0 13.568-2.215 26.857-6.369 39.594-8.943 27.517 32.133 38.939 40.147 13.29 2.769-8.306 4.984-16.889 6.369-25.472 19.381 7.476 33.502 26.303 33.502 48.453 0 28.795-23.535 52.33-52.607 52.33zm235.069-52.33c0 44.024-12.737 86.386-37.102 122.657-4.153 6.092-10.798 9.414-17.72 9.414-16.317 0-27.127-18.826-17.443-32.949 19.381-29.349 29.903-63.682 29.903-99.122s-10.521-69.773-29.903-98.845c-15.655-22.831 19.361-47.24 35.163-23.534 24.366 35.993 37.102 78.356 37.102 122.379zm-70.88 0c0 31.565-9.137 62.021-26.857 88.325-4.153 6.091-10.798 9.136-17.72 9.136-17.201 0-27.022-18.979-17.443-32.948 13.013-19.104 19.658-41.255 19.658-64.513 0-22.981-6.645-45.408-19.658-64.512-15.761-22.986 19.008-47.095 35.163-23.535 17.719 26.026 26.857 56.483 26.857 88.047z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrosoft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicroblog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMendeley(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMegaport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMeetup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedrt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedium(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMediumM(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.5 142.3c.6-5.9-1.7-11.8-6.1-15.8L20.3 72.1V64h140.2l108.4 237.7L364.2 64h133.7v8.1l-38.6 37c-3.3 2.5-5 6.7-4.3 10.8v272c-.7 4.1 1 8.3 4.3 10.8l37.7 37v8.1H307.3v-8.1l39.1-37.9c3.8-3.8 3.8-5 3.8-10.8V171.2L241.5 447.1h-14.7L100.4 171.2v184.9c-1.1 7.8 1.5 15.6 7 21.2l50.8 61.6v8.1h-144v-8L65 377.3c5.4-5.6 7.9-13.5 6.5-21.2V142.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedapps(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMdb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMaxcdn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMastodon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarkdown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMandalorian(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMailchimp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagento(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLyft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinux(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.4 226.3c-.3-.9-.9-1.4-1.4-2l-70-38.6c-.9-.6-2-.6-3.1 0l-58.9 36c-.9.6-1.4 1.7-1.4 2.6l-.9 31.4-24-16c-.9-.6-2.3-.6-3.1 0L240 260.9l-1.4-35.1c0-.9-.6-2-1.4-2.3l-36-24.3 33.7-17.4c1.1-.6 1.7-1.7 1.7-2.9l-5.7-132.3c0-.9-.9-2-1.7-2.6L138.6.3c-.9-.3-1.7-.3-2.3-.3L12.6 38.6c-1.4.6-2.3 2-2 3.7L38 175.4c.9 3.4 34 27.4 38.6 30.9l-26.9 12.9c-1.4.9-2 2.3-1.7 3.4l20.6 100.3c.6 2.9 23.7 23.1 27.1 26.3l-17.4 10.6c-.9.6-1.7 2-1.4 3.1 1.4 7.1 15.4 77.7 16.9 79.1l65.1 69.1c.6.6 1.4.6 2.3.9.6 0 1.1-.3 1.7-.6l83.7-66.9c.9-.6 1.1-1.4 1.1-2.3l-2-46 28 23.7c1.1.9 2.9.9 4 0l66.9-53.4c.9-.6 1.1-1.4 1.1-2.3l2.3-33.4 20.3 14c1.1.9 2.6.9 3.7 0l54.6-43.7c.6-.3 1.1-1.1 1.1-2 .9-6.5 10.3-70.8 9.7-72.8zm-204.8 4.8l4 92.6-90.6 61.2-14-96.6 100.6-57.2zm-7.7-180l5.4 126-106.6 55.4L104 97.7l120.9-46.6zM44 173.1L18 48l79.7 49.4 19.4 132.9L44 173.1zm30.6 147.8L55.7 230l70 58.3 13.7 93.4-64.8-60.8zm24.3 117.7l-13.7-67.1 61.7 60.9 9.7 67.4-57.7-61.2zm64.5 64.5l-10.6-70.9 85.7-61.4 3.1 70-78.2 62.3zm82-115.1c0-3.4.9-22.9-2-25.1l-24.3-20 22.3-14.9c2.3-1.7 1.1-5.7 1.1-8l29.4 22.6.6 68.3-27.1-22.9zm94.3-25.4l-60.9 48.6-.6-68.6 65.7-46.9-4.2 66.9zm27.7-25.7l-19.1-13.4 2-34c.3-.9-.3-2-1.1-2.6L308 259.7l.6-30 64.6 40.6-5.8 66.6zm54.6-39.8l-48.3 38.3 5.7-65.1 51.1-36.6-8.5 63.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinkedin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinkedinIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1zm-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2zm-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2zM332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2zM448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7zm-61.6 122.6c0-73-73.2-132.4-163.1-132.4-89.9 0-163.1 59.4-163.1 132.4 0 65.4 58 120.2 136.4 130.6 19.1 4.1 16.9 11.1 12.6 36.8-.7 4.1-3.3 16.1 14.1 8.8 17.4-7.3 93.9-55.3 128.2-94.7 23.6-26 34.9-52.3 34.9-81.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLeanpub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLastfm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLastfmSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaravel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKorvue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 446 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKickstarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKickstarterK(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKeycdn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKeybase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKaggle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJsfiddle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJsSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJoomla(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJoget(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJira(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJenkins(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJediOrder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJava(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItunes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItunesNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItchIo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIoxhost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInvision(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInternetExplorer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIntercom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInstalod(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInstagram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInstagramSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInnosoft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.559,159.71a27.379,27.379,0,0,0-13.866-23.337,26.42,26.42,0,0,0-26.211.133L73.943,314.647V176.261a11.955,11.955,0,0,1,6.047-10.34L218.066,86.208a12.153,12.153,0,0,1,11.922.025l32.656,18.853L112.581,191.723v56L359.642,105.086,241.129,36.679c-10.992-6.129-22.3-6.255-33.8-.27l-164.6,95.026c-10.634,6.12-16.771,16.39-17.29,29.124l0,191.5c.17,10.135,5.08,18.672,13.474,23.428a27.037,27.037,0,0,0,26.736-.045L374.057,197.376V335.657a11.976,11.976,0,0,1-5.92,10.368L230.025,425.77a12.175,12.175,0,0,1-11.937.062l-32.723-18.9,150.051-86.627v-56L88.367,406.932l118.794,68.583a33.88,33.88,0,0,0,34.25-.327l164.527-94.995c10.746-6.631,16.649-17.118,16.624-29.528Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaImdb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.3 229.2H21c.1-.1.2-.3.3-.4zM97 319.8H64V192h33zm113.2 0h-28.7v-86.4l-11.6 86.4h-20.6l-12.2-84.5v84.5h-29V192h42.8c3.3 19.8 6 39.9 8.7 59.9l7.6-59.9h43zm11.4 0V192h24.6c17.6 0 44.7-1.6 49 20.9 1.7 7.6 1.4 16.3 1.4 24.4 0 88.5 11.1 82.6-75 82.5zm160.9-29.2c0 15.7-2.4 30.9-22.2 30.9-9 0-15.2-3-20.9-9.8l-1.9 8.1h-29.8V192h31.7v41.7c6-6.5 12-9.2 20.9-9.2 21.4 0 22.2 12.8 22.2 30.1zM265 229.9c0-9.7 1.6-16-10.3-16v83.7c12.2.3 10.3-8.7 10.3-18.4zm85.5 26.1c0-5.4 1.1-12.7-6.2-12.7-6 0-4.9 8.9-4.9 12.7 0 .6-1.1 39.6 1.1 44.7.8 1.6 2.2 2.4 3.8 2.4 7.8 0 6.2-9 6.2-14.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdeal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHubspot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHtml5(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouzz(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotjar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.9 161.5C340.2 29 121.1 0 121.1 0S222.2 110.4 93 197.7C11.3 252.8-21 324.4 14 402.6c26.8 59.9 83.5 84.3 144.6 93.4-29.2-55.1-6.6-122.4-4.1-129.6 57.1 86.4 165 0 110.8-93.9 71 15.4 81.6 138.6 27.1 215.5 80.5-25.3 134.1-88.9 148.8-145.6 15.5-59.3 3.7-127.9-26.3-180.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHornbill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHooli(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHireAHelper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHips(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHackerrank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHackerNews(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHackerNewsSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGulp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGuilded(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrunt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripfire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrav(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGratipay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoogle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 488 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoogleWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlusG(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoogleDrive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoodreads(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoodreadsG(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGofore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlideG(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitlab(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.2 24.9c-3.1-8.9-15.7-8.9-18.9 0L29.8 199.7h132c-.1 0-56.6-174.8-56.6-174.8zM.9 287.7c-2.6 8 .3 16.9 7.1 22l247.9 184-226.2-294zm160.8-88l94.3 294 94.3-294zm349.4 88l-28.8-88-226.3 294 247.9-184c6.9-5.1 9.7-14 7.2-22zM425.7 24.9c-3.1-8.9-15.7-8.9-18.9 0l-56.6 174.8h132z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitkraken(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 592 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGithub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGithubSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGithubAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGgCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGetPocket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGalacticSenate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGalacticRepublic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFulcrum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFreebsd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFreeCodeCamp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFoursquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 368 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaForumbee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFortAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFortAwesomeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFonticons(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFonticonsFi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFontAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32ZM336 312c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.2-16-74.6-16a80 80 0 0 0-25.6 4V284a85.9 85.9 0 0 1 25.6-4c31.2 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v-96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.2-16-74.6-16-25.4 0-37.4 10.4-57.6 14.4V352a16 16 0 0 1-32 0V160a16 16 0 0 1 32 0v6.4c20.2-4 32.2-14.4 57.6-14.4 31.2 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFontAwesomeLogoFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 3992 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1209.7 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C1311.7 200.4 1267.5 156.5 1209.7 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C1261.1 281.8 1244.8 309.2 1209.7 309.2Zm962.1-136.1c-4.4-10.9-12.3-16.5-23.5-16.5s-19.1 5.6-23.5 16.5l-59.4 145.8c-7.2 17.7 2.8 27.4 4.4 29a24.6 24.6 0 0 0 17.5 6.8c10.8 0 18.7-6 23.1-18.1l4-10.1h67.7l4 10.1c4.8 12.1 12.3 18.1 23.1 18.1a24.6 24.6 0 0 0 17.5-6.8c10-10.1 6.8-22.6 4.4-29Zm-43 113.6 19.1-56 19.1 56Zm-574.5-130.1c-14.3 0-24.7 10.9-24.7 25.4v76.5l-68.5-85.8c-4.4-5.6-11.6-16.1-25.5-16.1-19.1 0-24.3 17.7-24.3 25.4V329.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V252.8l68.9 86.2c4.8 5.6 11.6 16.1 25.5 16.1 19.1 0 23.9-17.3 23.9-25.4V181.9C1579 167.4 1568.6 156.5 1554.3 156.5Zm-554.1 1.6H916.5c-19.9 0-25.1 17.3-25.1 25.4V328.1c0 19.7 16.7 25.4 24.7 25.4 8 0 24.7-5.2 24.7-25.4V285h44.6c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.1-22.7-22.1H940.8V203.6h59.4c12.8 0 22.7-9.3 22.7-22.6C1022.9 163 1007.3 158.1 1000.2 158.1Zm815.1 0H1691.7c-7.2 0-22.7 4.4-22.7 22.2 0 13.3 10 22.6 22.7 22.6h37V327.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V202.8h37c12.7 0 22.7-9.3 22.7-22.6C1837.9 163 1822.4 158.1 1815.2 158.1Zm1789.5-1.6c-9.6 0-17.5 6-25.1 18.1l-46.6 76.1L3486.4 174.6q-10.8-18.1-25.1-18.1c-19.5 0-24.7 18.1-24.7 25.8V329.7c0 14.1 10.4 25.4 24.7 25.4s24.7-10.9 24.7-25.4V262.8L3510.7 302.7c6.4 10.1 13.9 15.3 22.3 15.3 8.8 0 15.9-5.2 22.3-15.3l24.7-39.9v66.9c0 14.1 10.3 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V182.3C3629.4 174.2 3624.6 156.5 3604.7 156.5Zm248.6 149.8h-65.7V272.9h39.4c11.9 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.6-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.8 0 22.7-9.3 22.7-22.6C3876 311.2 3860.5 306.3 3853.3 306.3ZM3235 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C3337 200.4 3292.8 156.5 3235 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C3286.8 281.8 3270.1 309.2 3235 309.2ZM2550.2 156.5c-11.2 0-19.1 5.6-23.1 16.5l-34.3 94.7-31.5-92.2c-4.4-12.5-12.3-18.9-24.3-18.9-11.9 0-19.9 6.4-24.3 18.9l-31.5 92.2-34.3-95.5q-5.4-15.7-22.7-15.7c-6.8 0-12.3 2.4-17.5 7.3-5.2 5.2-10.8 14.5-4.8 28.6l55.8 145.8c4 11.3 11.6 16.9 23.1 16.9q16.7 0 22.7-16.9l33.5-91.8 33.5 91.8q6 16.9 22.7 16.9c11.2 0 19.1-5.6 23.1-16.9l55.8-145.8c3.6-9.3 4.4-19.3-4.8-28.6A23 23 0 0 0 2550.2 156.5Zm444.2 81-21.9-9.3c-11.9-4.8-16.3-8.5-16.3-15.7q0-12.1 16.7-12.1c12.7 0 19.5 7.7 24.3 10.9 7.2 5.2 18.3 6.8 27.9-2 10.8-10.5 6.8-23.8 1.2-30.6-12.3-14.9-30.3-22.2-53.8-22.2-19.1 0-35.1 5.2-47.4 15.7-12.3 10.5-18.7 24.2-18.7 41.1 0 24.2 15.9 43.5 47.8 57.6l19.5 8.9c15.9 6.8 19.1 9.7 19.1 17.7 0 9.3-6.4 14.1-19.5 14.1-19.1 0-34.7-14.9-36.3-16.1-10.8-7.3-21.5-2-26.3 2.8-6.8 6.4-12.7 20.9 3.2 36.2 6.8 6.4 15.5 11.7 26.7 15.3a94.6 94.6 0 0 0 32.7 5.6c19.9 0 36.7-5.2 49.8-16.1 13.1-10.9 19.5-25.4 19.5-43.5q0-20.5-12-33.8C3022.7 253.2 3010.7 244.3 2994.4 237.5Zm-206.4 68.9h-65.7V272.9h39.4c12 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.7 0 22.7-9.3 22.7-22.6C2810.8 311.2 2795.2 306.3 2788 306.3ZM178.3 49.1c-50.5 0-74.4 20.7-114.6 28.7V65A31.8 31.8 0 1 0 0 65V447a31.8 31.8 0 0 0 63.7 0V141.4c40.2-8 64.1-28.7 114.6-28.7 62.5 0 86 31.8 148.4 31.8 20.3 0 35.4-2.8 55.3-9.2v191c-19.9 6.4-35 9.2-55.3 9.2-62.5 0-86.4-31.8-148.4-31.8-20.3 0-36.2 3.6-50.9 8V375.4a159.1 159.1 0 0 1 50.9-8c62.5 0 86 31.8 148.4 31.8 37 0 56.1-9.6 119-31.8V49.1C382.8 71.4 363.7 80.9 326.7 80.9 264.2 80.9 240.4 49.1 178.3 49.1Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFontAwesomeFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48V384c-63 23-82 32-119 32-63 0-87-32-150-32-20 0-36 4-51 8V328c15-4 31-8 51-8 63 0 87 32 150 32 20 0 35-3 55-9V135c-20 6-35 9-55 9-63 0-87-32-150-32-51 0-75 21-115 29V448a31.6 31.6 0 0 1-32 32A31.6 31.6 0 0 1 0 448V64A31.6 31.6 0 0 1 32 32 31.6 31.6 0 0 1 64 64V77c40-8 64-29 115-29 63 0 87 32 150 32C366 80 385 71 448 48Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFontAwesomeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32Zm16 400a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V80A16 16 0 0 1 48 64H400a16 16 0 0 1 16 16ZM201.6 152c-25.4 0-37.4 10.4-57.6 14.4V160a16 16 0 0 0-32 0V352a16 16 0 0 0 32 0V198.4c20.2-4 32.2-14.4 57.6-14.4 31.4 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.4-16-74.6-16a85.9 85.9 0 0 0-25.6 4v32a80 80 0 0 1 25.6-4c31.4 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16V152c-31.6 11.2-41.2 16-59.8 16C244.8 168 232.8 152 201.6 152Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFly(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlickr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstdraft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstOrder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstOrderAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirefox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirefoxBrowser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189.37,152.86Zm-58.74-29.37C130.79,123.5,130.71,123.5,130.63,123.49Zm351.42,45.35c-10.61-25.5-32.08-53-48.94-61.73,13.72,26.89,21.67,53.88,24.7,74,0,0,0,.14.05.41-27.58-68.75-74.35-96.47-112.55-156.83-1.93-3.05-3.86-6.11-5.74-9.33-1-1.65-1.86-3.34-2.69-5.05A44.88,44.88,0,0,1,333.24.69a.63.63,0,0,0-.55-.66.9.9,0,0,0-.46,0l-.12.07-.18.1.1-.14c-54.23,31.77-76.72,87.38-82.5,122.78a130,130,0,0,0-48.33,12.33,6.25,6.25,0,0,0-3.09,7.75,6.13,6.13,0,0,0,7.79,3.79l.52-.21a117.84,117.84,0,0,1,42.11-11l1.42-.1c2-.12,4-.2,6-.22A122.61,122.61,0,0,1,291,140c.67.2,1.32.42,2,.63,1.89.57,3.76,1.2,5.62,1.87,1.36.5,2.71,1,4.05,1.58,1.09.44,2.18.88,3.25,1.35q2.52,1.13,5,2.35c.75.37,1.5.74,2.25,1.13q2.4,1.26,4.74,2.63,1.51.87,3,1.8a124.89,124.89,0,0,1,42.66,44.13c-13-9.15-36.35-18.19-58.82-14.28,87.74,43.86,64.18,194.9-57.39,189.2a108.43,108.43,0,0,1-31.74-6.12c-2.42-.91-4.8-1.89-7.16-2.93-1.38-.63-2.76-1.27-4.12-2C174.5,346,149.9,316.92,146.83,281.59c0,0,11.25-41.95,80.62-41.95,7.5,0,28.93-20.92,29.33-27-.09-2-42.54-18.87-59.09-35.18-8.85-8.71-13.05-12.91-16.77-16.06a69.58,69.58,0,0,0-6.31-4.77A113.05,113.05,0,0,1,173.92,97c-25.06,11.41-44.55,29.45-58.71,45.37h-.12c-9.67-12.25-9-52.65-8.43-61.08-.12-.53-7.22,3.68-8.15,4.31a178.54,178.54,0,0,0-23.84,20.43A214,214,0,0,0,51.9,133.36l0,0a.08.08,0,0,1,0,0,205.84,205.84,0,0,0-32.73,73.9c-.06.27-2.33,10.21-4,22.48q-.42,2.87-.78,5.74c-.57,3.69-1,7.71-1.44,14,0,.24,0,.48-.05.72-.18,2.71-.34,5.41-.49,8.12,0,.41,0,.82,0,1.24,0,134.7,109.21,243.89,243.92,243.89,120.64,0,220.82-87.58,240.43-202.62.41-3.12.74-6.26,1.11-9.41,4.85-41.83-.54-85.79-15.82-122.55Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFigma(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFedora(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225 32C101.3 31.7.8 131.7.4 255.4L0 425.7a53.6 53.6 0 0 0 53.6 53.9l170.2.4c123.7.3 224.3-99.7 224.6-223.4S348.7 32.3 225 32zm169.8 157.2L333 126.6c2.3-4.7 3.8-9.2 3.8-14.3v-1.6l55.2 56.1a101 101 0 0 1 2.8 22.4zM331 94.3a106.06 106.06 0 0 1 58.5 63.8l-54.3-54.6a26.48 26.48 0 0 0-4.2-9.2zM118.1 247.2a49.66 49.66 0 0 0-7.7 11.4l-8.5-8.5a85.78 85.78 0 0 1 16.2-2.9zM97 251.4l11.8 11.9-.9 8a34.74 34.74 0 0 0 2.4 12.5l-27-27.2a80.6 80.6 0 0 1 13.7-5.2zm-18.2 7.4l38.2 38.4a53.17 53.17 0 0 0-14.1 4.7L67.6 266a107 107 0 0 1 11.2-7.2zm-15.2 9.8l35.3 35.5a67.25 67.25 0 0 0-10.5 8.5L53.5 278a64.33 64.33 0 0 1 10.1-9.4zm-13.3 12.3l34.9 35a56.84 56.84 0 0 0-7.7 11.4l-35.8-35.9c2.8-3.8 5.7-7.2 8.6-10.5zm-11 14.3l36.4 36.6a48.29 48.29 0 0 0-3.6 15.2l-39.5-39.8a99.81 99.81 0 0 1 6.7-12zm-8.8 16.3l41.3 41.8a63.47 63.47 0 0 0 6.7 26.2L25.8 326c1.4-4.9 2.9-9.6 4.7-14.5zm-7.9 43l61.9 62.2a31.24 31.24 0 0 0-3.6 14.3v1.1l-55.4-55.7a88.27 88.27 0 0 1-2.9-21.9zm5.3 30.7l54.3 54.6a28.44 28.44 0 0 0 4.2 9.2 106.32 106.32 0 0 1-58.5-63.8zm-5.3-37a80.69 80.69 0 0 1 2.1-17l72.2 72.5a37.59 37.59 0 0 0-9.9 8.7zm253.3-51.8l-42.6-.1-.1 56c-.2 69.3-64.4 115.8-125.7 102.9-5.7 0-19.9-8.7-19.9-24.2a24.89 24.89 0 0 1 24.5-24.6c6.3 0 6.3 1.6 15.7 1.6a55.91 55.91 0 0 0 56.1-55.9l.1-47c0-4.5-4.5-9-8.9-9l-33.6-.1c-32.6-.1-32.5-49.4.1-49.3l42.6.1.1-56a105.18 105.18 0 0 1 105.6-105 86.35 86.35 0 0 1 20.2 2.3c11.2 1.8 19.9 11.9 19.9 24 0 15.5-14.9 27.8-30.3 23.9-27.4-5.9-65.9 14.4-66 54.9l-.1 47a8.94 8.94 0 0 0 8.9 9l33.6.1c32.5.2 32.4 49.5-.2 49.4zm23.5-.3a35.58 35.58 0 0 0 7.6-11.4l8.5 8.5a102 102 0 0 1-16.1 2.9zm21-4.2L308.6 280l.9-8.1a34.74 34.74 0 0 0-2.4-12.5l27 27.2a74.89 74.89 0 0 1-13.7 5.3zm18-7.4l-38-38.4c4.9-1.1 9.6-2.4 13.7-4.7l36.2 35.9c-3.8 2.5-7.9 5-11.9 7.2zm15.5-9.8l-35.3-35.5a61.06 61.06 0 0 0 10.5-8.5l34.9 35a124.56 124.56 0 0 1-10.1 9zm13.2-12.3l-34.9-35a63.18 63.18 0 0 0 7.7-11.4l35.8 35.9a130.28 130.28 0 0 1-8.6 10.5zm11-14.3l-36.4-36.6a48.29 48.29 0 0 0 3.6-15.2l39.5 39.8a87.72 87.72 0 0 1-6.7 12zm13.5-30.9a140.63 140.63 0 0 1-4.7 14.3L345.6 190a58.19 58.19 0 0 0-7.1-26.2zm1-5.6l-71.9-72.1a32 32 0 0 0 9.9-9.2l64.3 64.7a90.93 90.93 0 0 1-2.3 16.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFedex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFantasyFlightGames(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99a42569.01 42569.01 0 0 1-41.13-40.72zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebookSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebookMessenger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebookF(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExpeditedssl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEvernote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEtsy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEthereum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaErlang(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvira(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEmpire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEmber(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEllo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaElementor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.6 32H22.4C10 32 0 42 0 54.4v403.2C0 470 10 480 22.4 480h403.2c12.4 0 22.4-10 22.4-22.4V54.4C448 42 438 32 425.6 32M164.3 355.5h-39.8v-199h39.8v199zm159.3 0H204.1v-39.8h119.5v39.8zm0-79.6H204.1v-39.8h119.5v39.8zm0-79.7H204.1v-39.8h119.5v39.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEdge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.92,134.48C440.87,54.18,352.26,8,255.91,8,137.05,8,37.51,91.68,13.47,203.66c26-46.49,86.22-79.14,149.46-79.14,79.27,0,121.09,48.93,122.25,50.18,22,23.8,33,50.39,33,83.1,0,10.4-5.31,25.82-15.11,38.57-1.57,2-6.39,4.84-6.39,11,0,5.06,3.29,9.92,9.14,14,27.86,19.37,80.37,16.81,80.51,16.81A115.39,115.39,0,0,0,444.94,322a118.92,118.92,0,0,0,58.95-102.44C504.39,176.13,488.39,147.26,481.92,134.48ZM212.77,475.67a154.88,154.88,0,0,1-46.64-45c-32.94-47.42-34.24-95.6-20.1-136A155.5,155.5,0,0,1,203,215.75c59-45.2,94.84-5.65,99.06-1a80,80,0,0,0-4.89-10.14c-9.24-15.93-24-36.41-56.56-53.51-33.72-17.69-70.59-18.59-77.64-18.59-38.71,0-77.9,13-107.53,35.69C35.68,183.3,12.77,208.72,8.6,243c-1.08,12.31-2.75,62.8,23,118.27a248,248,0,0,0,248.3,141.61C241.78,496.26,214.05,476.24,212.77,475.67Zm250.72-98.33a7.76,7.76,0,0,0-7.92-.23,181.66,181.66,0,0,1-20.41,9.12,197.54,197.54,0,0,1-69.55,12.52c-91.67,0-171.52-63.06-171.52-144A61.12,61.12,0,0,1,200.61,228,168.72,168.72,0,0,0,161.85,278c-14.92,29.37-33,88.13,13.33,151.66,6.51,8.91,23,30,56,47.67,23.57,12.65,49,19.61,71.7,19.61,35.14,0,115.43-33.44,163-108.87A7.75,7.75,0,0,0,463.49,377.34Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEdgeLegacy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEbay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEarlybirds(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDyalog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrupal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.5 114.7c-22.2-14-43.5-19.5-64.7-33.5-13-8.8-31.3-30-46.5-48.3-2.7 29.3-11.5 41.2-22 49.5-21.3 17-34.8 22.2-53.5 32.3C117 123 32 181.5 32 290.5 32 399.7 123.8 480 225.8 480 327.5 480 416 406 416 294c0-112.3-83-171-96.5-179.3zm2.5 325.6c-20.1 20.1-90.1 28.7-116.7 4.2-4.8-4.8.3-12 6.5-12 0 0 17 13.3 51.5 13.3 27 0 46-7.7 54.5-14 6.1-4.6 8.4 4.3 4.2 8.5zm-54.5-52.6c8.7-3.6 29-3.8 36.8 1.3 4.1 2.8 16.1 18.8 6.2 23.7-8.4 4.2-1.2-15.7-26.5-15.7-14.7 0-19.5 5.2-26.7 11-7 6-9.8 8-12.2 4.7-6-8.2 15.9-22.3 22.4-25zM360 405c-15.2-1-45.5-48.8-65-49.5-30.9-.9-104.1 80.7-161.3 42-38.8-26.6-14.6-104.8 51.8-105.2 49.5-.5 83.8 49 108.5 48.5 21.3-.3 61.8-41.8 81.8-41.8 48.7 0 23.3 109.3-15.8 106z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDropbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 528 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDribbble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDribbbleSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDraft2Digital(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDocker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDochub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiscourse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiscord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDigitalOcean(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDigg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiaspora(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDhl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeviantart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDev(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeskpro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeploydog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDelicious(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeezer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDashcube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDailymotion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDAndD(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDAndDBeyond(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCuttlefish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCss3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCss3Alt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCriticalRole(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommons(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsZero(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsSampling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsSamplingPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsSa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsRemix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsPd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsPdAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNcJp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNcEu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsBy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCpanel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCottonBureau(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaContao(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaConnectdevelop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaConfluence(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodiepie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 472 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodepen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudversify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudsmith(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 332 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.5 419.9c0 46.4-37.6 84.1-84 84.1s-84-37.7-84-84.1 37.6-84 84-84 84 37.6 84 84zm-84-243.9c46.4 0 80-37.6 80-84s-33.6-84-80-84-88 37.6-88 84-29.6 76-76 76-84 41.6-84 88 37.6 80 84 80 84-33.6 84-80 33.6-80 80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudscale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudflare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChromecast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChrome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M131.5 217.5L55.1 100.1c47.6-59.2 119-91.8 192-92.1 42.3-.3 85.5 10.5 124.8 33.2 43.4 25.2 76.4 61.4 97.4 103L264 133.4c-58.1-3.4-113.4 29.3-132.5 84.1zm32.9 38.5c0 46.2 37.4 83.6 83.6 83.6s83.6-37.4 83.6-83.6-37.4-83.6-83.6-83.6-83.6 37.3-83.6 83.6zm314.9-89.2L339.6 174c37.9 44.3 38.5 108.2 6.6 157.2L234.1 503.6c46.5 2.5 94.4-7.7 137.8-32.9 107.4-62 150.9-192 107.4-303.9zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256c0 124 90.8 226.7 209.5 244.9l63.7-124.8c-57.6 10.8-113.2-20.8-139.5-72.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCentos(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCentercode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcVisa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcStripe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcPaypal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcMastercard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcJcb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcDiscover(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcDinersClub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcApplePay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcAmex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2zm65.8 8.2l-25.3-28.1L241 276zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5zM576 255.4h-.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2zM31.2 188.8l11.2-27.6 11.5 27.6zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2zm42.1 12.1l11.2 27.6h-22.8zm-101.1-12v69.3h16.9v-69.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcAmazonPay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCanadianMapleLeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuysellads(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuyNLarge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuromobelexperte(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuffer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBtc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBootstrap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBluetooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBluetoothB(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlogger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBloggerB(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlackberry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlackTie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBitcoin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBitbucket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBimobject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBehance(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBehanceSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBattleNet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBandcamp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAws(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAviato(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAvianex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAutoprefixer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAudible(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAtlassian(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAsymmetrik(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArtstation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaApple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaApplePay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaApper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAppStore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAppStoreIos(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngular(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngrycreative(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngellist(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAndroid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmilia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmazon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmazonPay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlipay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlgolia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M229.3 182.6c-49.3 0-89.2 39.9-89.2 89.2 0 49.3 39.9 89.2 89.2 89.2s89.2-39.9 89.2-89.2c0-49.3-40-89.2-89.2-89.2zm62.7 56.6l-58.9 30.6c-1.8.9-3.8-.4-3.8-2.3V201c0-1.5 1.3-2.7 2.7-2.6 26.2 1 48.9 15.7 61.1 37.1.7 1.3.2 3-1.1 3.7zM389.1 32H58.9C26.4 32 0 58.4 0 90.9V421c0 32.6 26.4 59 58.9 59H389c32.6 0 58.9-26.4 58.9-58.9V90.9C448 58.4 421.6 32 389.1 32zm-202.6 84.7c0-10.8 8.7-19.5 19.5-19.5h45.3c10.8 0 19.5 8.7 19.5 19.5v15.4c0 1.8-1.7 3-3.3 2.5-12.3-3.4-25.1-5.1-38.1-5.1-13.5 0-26.7 1.8-39.4 5.5-1.7.5-3.4-.8-3.4-2.5v-15.8zm-84.4 37l9.2-9.2c7.6-7.6 19.9-7.6 27.5 0l7.7 7.7c1.1 1.1 1 3-.3 4-6.2 4.5-12.1 9.4-17.6 14.9-5.4 5.4-10.4 11.3-14.8 17.4-1 1.3-2.9 1.5-4 .3l-7.7-7.7c-7.6-7.5-7.6-19.8 0-27.4zm127.2 244.8c-70 0-126.6-56.7-126.6-126.6s56.7-126.6 126.6-126.6c70 0 126.6 56.6 126.6 126.6 0 69.8-56.7 126.6-126.6 126.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAirbnb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAffiliatetheme(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAdversal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAdn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAcquisitionsIncorporated(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M357.45 468.2c-1.2-7.7-1.3-7.6-9.6-7.6-99.8.2-111.8-2.4-112.7-2.6-12.3-1.7-20.6-10.5-21-23.1-.1-1.6-.2-71.6-1-129.1-.1-4.7 1.6-6.4 5.9-7.5 12.5-3 24.9-6.1 37.3-9.7 4.3-1.3 6.8-.2 8.4 3.5 4.5 10.3 8.8 20.6 13.2 30.9 1.6 3.7.1 4.4-3.4 4.4-10-.2-20-.1-30.4-.1v27h116c-1.4-9.5-2.7-18.1-4-27.5-7 0-13.8.4-20.4-.1-22.6-1.6-18.3-4.4-84-158.6-8.8-20.1-27.9-62.1-36.5-89.2-4.4-14 5.5-25.4 18.9-26.6 18.6-1.7 37.5-1.6 56.2-2 20.6-.4 41.2-.4 61.8-.5 3.1 0 4-1.4 4.3-4.3 1.2-9.8 2.7-19.5 4-29.2.8-5.3 1.6-10.7 2.4-16.1L23.75 0c-3.6 0-5.3 1.1-4.6 5.3 2.2 13.2-.8.8 6.4 45.3 63.4 0 71.8.9 101.8.5 12.3-.2 37 3.5 37.7 22.1.4 11.4-1.1 11.3-32.6 87.4-53.8 129.8-50.7 120.3-67.3 161-1.7 4.1-3.6 5.2-7.6 5.2-8.5-.2-17-.3-25.4.1-1.9.1-5.2 1.8-5.5 3.2-1.5 8.1-2.2 16.3-3.2 24.9h114.3v-27.6c-6.9 0-33.5.4-35.3-2.9 5.3-12.3 10.4-24.4 15.7-36.7 16.3 4 31.9 7.8 47.6 11.7 3.4.9 4.6 3 4.6 6.8-.1 42.9.1 85.9.2 128.8 0 10.2-5.5 19.1-14.9 23.1-6.5 2.7-3.3 3.4-121.4 2.4-5.3 0-7.1 2-7.6 6.8-1.5 12.9-2.9 25.9-5 38.8-.8 5 1.3 5.7 5.3 5.7 183.2.6-30.7 0 337.1 0-2.5-15-4.4-29.4-6.6-43.7zm-174.9-205.7c-13.3-4.2-26.6-8.2-39.9-12.5a44.53 44.53 0 0 1-5.8-2.9c17.2-44.3 34.2-88.1 51.3-132.1 7.5 2.4 7.9-.8 9.4 0 9.3 22.5 18.1 60.1 27 82.8 6.6 16.7 13 33.5 19.7 50.9a35.78 35.78 0 0 1-3.9 2.1c-13.1 3.9-26.4 7.5-39.4 11.7a27.66 27.66 0 0 1-18.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAccusoft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAccessibleIcon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa500Px(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYinYang(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYenSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXRay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWrench(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWonSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWineGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWineGlassAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWineBottle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowRestore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowMinimize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowMaximize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowClose(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWifi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWheelchair(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeightHanging(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWaveSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWarehouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWalking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVrCardboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVoteYea(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeMute(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolleyballBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVoicemail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViruses(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVirusSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVihara(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVideoSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVials(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVial(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVestPatches(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVenus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVenusMars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVenusDouble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVectorSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUtensils(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUtensilSpoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserTimes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserTie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserSecret(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserNurse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserNinja(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserMd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserInjured(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserGraduate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserFriends(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserAstronaut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserAltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnlock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnlockAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnlink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUniversity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUniversalAccess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUndo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUndoAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnderline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUmbrella(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUmbrellaBeach(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTshirt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckPickup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckMoving(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckMonster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckLoading(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrophy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrashRestore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrashRestoreAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrashAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTransgender(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTransgenderAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrailer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrafficLight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrademark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTractor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToriiGate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTorah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTools(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToolbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToilet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToiletPaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToiletPaperSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToggleOn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToggleOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTintSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTimes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTimesCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTicketAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThumbtack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThumbsUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThumbsDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometerThreeQuarters(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometerQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometerHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometerFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometerEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTheaterMasks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThLarge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTextWidth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTextHeight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTerminal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTenge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureLow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureHigh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTeeth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTeethOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTaxi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTasks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTape(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTags(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTachometerAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTablets(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTablet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTabletAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTableTennis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSyringe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSync(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSyncAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSynagogue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSwimmingPool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSwimmer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSwatchbook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSurprise(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuperscript(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuitcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuitcaseRolling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSubway(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSubscript(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStroopwafel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStrikethrough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStreetView(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStream(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStoreSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStoreAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStoreAltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStopwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStopwatch20(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStopCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStickyNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStethoscope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStepForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStepBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarOfLife(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarOfDavid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 464 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarHalfAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 536 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarAndCrescent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStamp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareRootAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 512H0V0h512v512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSprayCan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSplotch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpinner(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpider(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpellCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpaceShuttle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSort(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortNumericUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortNumericUpAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortNumericDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortNumericDownAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAmountUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAmountUpAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAmountDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAmountDownAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAlphaUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAlphaUpAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAlphaDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAlphaDownAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSolarPanel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSocks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSoap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowplow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowman(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowflake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowboarding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSms(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmoking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmokingBan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmileWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmileBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlidersH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSleigh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkullCrossbones(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkiing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkiingNordic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkating(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSitemap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSimCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignature(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignOutAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignLanguage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignInAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShuttleVan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShoppingCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShoppingBasket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShoppingBag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShoePrints(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShippingFast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShieldVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShieldAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShekelSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShareSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShareAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShareAltSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShapes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaServer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSeedling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchLocation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScroll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScrewdriver(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSatellite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSatelliteDish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSadTear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSadCry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRupeeSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRunning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRuler(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRulerVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRulerHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRulerCombined(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRubleSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRssSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoute(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRocket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRobot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRibbon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRetweet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRestroom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRepublican(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReply(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReplyAll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRemoveFormat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegistered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedoAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRecycle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRecordVinyl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReceipt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRandom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRainbow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRadiation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRadiationAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuran(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuoteRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuoteLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuidditch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuestion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuestionCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQrcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPuzzlePiece(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPumpSoap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPumpMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaProjectDiagram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaProcedures(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrescription(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrescriptionBottle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrescriptionBottleAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrayingHands(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPray(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPowerOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPoundSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPortrait(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPoop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPoo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPooStorm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPoll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPollH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPodcast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlayCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneDeparture(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneArrival(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaceOfWorship(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPizzaSlice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPills(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiggyBank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhotoVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneVolume(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneSquareAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonBooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPercentage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPercent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPepperHot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeopleCarry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeopleArrows(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPencilRuler(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPencilAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenNib(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenFancy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaw(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPauseCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaste(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPastafarianism(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPassport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaParking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaParagraph(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaParachuteBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaperclip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaperPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPalette(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaintRoller(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaintBrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPager(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOutdent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOtter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOilCan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaObjectUngroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaObjectGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNotesMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNotEqual(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNeuter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNetworkWired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMusic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMugHot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMousePointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMountain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMotorcycle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMosque(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMortarPestle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMonument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyCheckAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBillWave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBillWaveAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBillAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMobileAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMitten(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMinusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMinusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicroscope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophoneSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophoneAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophoneAltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrochip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMeteor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMercury(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMenorah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMemory(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMeh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMehRollingEyes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMehBlank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedkit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsStroke(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsStrokeV(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsStrokeH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsDouble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapSigns(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapMarker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapMarkerAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapMarked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapMarkedAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMailBulk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagnet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLungs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLungsVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLuggageCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLowVision(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLongArrowAltUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLongArrowAltRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLongArrowAltLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLongArrowAltDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLockOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLocationArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaListUl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaListOl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaListAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLiraSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLightbulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLifeRing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLevelUpAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLevelDownAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLessThan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLessThanEqual(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLemon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLayerGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaugh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaughWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaughSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaughBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptopMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptopHouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptopCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLanguage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLandmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKiwiBird(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKiss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKissWinkHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKissBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKhanda(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKeyboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKaaba(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJournalWhills(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJoint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJedi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItalic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInfo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInfoCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInfinity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIndustry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIndent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaImages(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIgloo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdCardAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIcons(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIcicles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIceCream(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaICursor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHryvnia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseDamage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglassStart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglassHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglassEnd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotdog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotTub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHospital(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHospitalUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHospitalSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHospitalAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHorse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHorseHead(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHollyBerry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHockeyPuck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHistory(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHippo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHiking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHighlighter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHelicopter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartbeat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartBroken(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadset(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadphones(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadphonesAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeading(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideMask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideCough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideCoughSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHatWizard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHatCowboy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHatCowboySide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHashtag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHardHat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHanukiah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshakeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshakeAltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHands(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsWash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsHelping(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandSpock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandRock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPeace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandMiddleFinger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandLizard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHolding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingUsd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHamsa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHammer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHamburger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGuitar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripLines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripLinesVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinTongue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinTongueWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinTongueSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinStars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinSquintTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinHearts(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinBeamSweat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrimace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGreaterThan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGreaterThanEqual(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGraduationCap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGopuram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGolfBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobeEurope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobeAsia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobeAmericas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobeAfrica(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlasses(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlassWhiskey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlassMartini(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlassMartiniAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlassCheers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGifts(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGhost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGenderless(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGem(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGavel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGasPump(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGamepad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFutbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFunnelDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFrownOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFrog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFootballBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFont(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlushed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlagUsa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlagCheckered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFistRaised(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstAid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFireExtinguisher(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFireAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFingerprint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFillDrip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileWord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileSignature(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilePrescription(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilePowerpoint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilePdf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileMedicalAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileInvoice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileInvoiceDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileImport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileExport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileExcel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCsv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileContract(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileAudio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFighterJet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFemale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFeather(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFeatherAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFax(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaucet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFastForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFastBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEyeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEyeDropper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExternalLinkSquareAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExternalLinkAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExpand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExpandArrowsAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExpandAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExclamationTriangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExclamationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExchangeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEuroSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEthernet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEraser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEquals(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelopeSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelopeOpenText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEllipsisV(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEllipsisH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEgg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDungeon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDumpster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDumpsterFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDumbbell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrumstickBite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrumSteelpan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrawPolygon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDragon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDraftingCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDotCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDoorOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDoorClosed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDonate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDolly(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDollyFlatbed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDollarSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDna(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDizzy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDivide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDisease(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDirections(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDigitalTachograph(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceTwo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceThree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceSix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceOne(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceFour(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceFive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceD6(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceD20(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiagnoses(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDharmachakra(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDesktop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDemocrat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDatabase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCubes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrutch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrosshairs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCross(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCropAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCouch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCopyright(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCookie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCookieBite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaConciergeBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompressArrowsAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompressAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompactDisc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaComments(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentsDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaComment(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaColumns(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCoins(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCogs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCoffee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodeBranch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCocktail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudUploadAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudSunRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudShowersHeavy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudMoonRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudMeatball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudDownloadAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClosedCaptioning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboardList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboardCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClinicMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleNotch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChurch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChild(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessRook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessQueen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessPawn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessKnight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessKing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessBoard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessBishop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheese(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheckSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheckDouble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartPie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartArea(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChargingStation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChalkboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChalkboardTeacher(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChair(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCertificate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCashRegister(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCartPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCartArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarrot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretSquareUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretSquareRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretSquareLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretSquareDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaravan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarSide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarCrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarBattery(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCapsules(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCannabis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCandyCane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCampground(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCameraRetro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarWeek(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarTimes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarDay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBusinessTime(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBusAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBurn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBullseye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBullhorn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuilding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBroom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBroadcastTower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBriefcaseMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBreadSlice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBrain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBraille(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxTissue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBowlingBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBorderStyle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBorderNone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBorderAll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookReader(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookDead(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBomb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBold(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlender(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlenderPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBirthdayCake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBiohazard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBinoculars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBiking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBicycle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBible(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBezierCurve(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBellSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBeer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryThreeQuarters(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBasketballBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBaseballBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBarcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBandAid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBalanceScale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBalanceScaleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBalanceScaleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBahai(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBacterium(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBacteria(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBacon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBackspace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBaby(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBabyCarriage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAudioDescription(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAtom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAtlas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAsterisk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAssistiveListeningSystems(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsAltV(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsAltH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowAltCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowAltCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowAltCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowAltCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArchway(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAppleAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnkh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDoubleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDoubleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDoubleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDoubleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnchor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmericanSignLanguageInterpreting(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmbulance(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAllergies(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignJustify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAirFreshener(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAdjust(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAddressCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAddressBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowRestore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowMinimize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowMaximize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowClose(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegTrashAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegTired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegTimesCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegThumbsUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegThumbsDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSurprise(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStopCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStickyNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStarHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSnowflake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSmileWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSmileBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegShareSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSadTear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSadCry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegRegistered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegQuestionCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPlusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPlayCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPauseCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPaperPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegObjectUngroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegObjectGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMoneyBillAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMinusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMeh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMehRollingEyes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMehBlank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegListAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLightbulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLifeRing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLemon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLaugh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLaughWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLaughSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLaughBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegKiss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegKissWinkHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegKissBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegKeyboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegImages(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegIdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegIdBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHourglass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHospital(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandshake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandSpock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandRock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPeace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandLizard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinTongue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinTongueWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinTongueSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinStars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinSquintTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinHearts(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinBeamSweat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrimace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGem(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFutbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFrownOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFontAwesomeLogoFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 3992 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFlushed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileWord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFilePowerpoint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFilePdf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileExcel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileAudio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEyeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegDotCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegDizzy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCopyright(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegComments(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegComment(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCommentDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCommentAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClosedCaptioning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCheckSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCaretSquareUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCaretSquareRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCaretSquareLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCaretSquareDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarTimes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBuilding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBellSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegArrowAltCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegArrowAltCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegArrowAltCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegArrowAltCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegAngry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegAddressCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegAddressBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
                },
                "child": []
            }
        ]
    })(props);
}

},{"../lib/index.mjs":"c1xBV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cr4b9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetSavedCards", ()=>useGetSavedCards);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _platformApi = require("Core/utils/platformApi");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _utils = require("Core/utils/utils");
async function getCpsCardsSilently(customerId, externalReferenceId) {
    try {
        const { data } = await (0, _axiosDefault.default).get(`${"https://payment-api-gateway.shared-testing.audibene.net/api/v1"}/cards/cps_profile_gid/${customerId}`, {
            headers: {
                web_code: (0, _utils.getUrlParam)('web-code'),
                payment_id: (0, _utils.getUrlParam)('payment-id'),
                external_reference_id: externalReferenceId
            }
        });
        return data;
    } catch  {
        return null;
    }
}
function mapCards(data) {
    return data.map((method)=>({
            card: {
                brand: method.brand.toLowerCase(),
                last4: method.last4digit
            },
            paymentMethodId: method.payment_method_id,
            preferred: method.preferred,
            type: 'card'
        }));
}
function useGetSavedCardsDefault(enabled) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).savedCards, ()=>(0, _platformApi.get)('/cards', {
            headers: {
                external_reference_id: paymentInfo.external_reference_id
            }
        }), {
        onError (e) {
            if (e) setError(t('status.error.getSavedCardsFailed') + ` - (${e.message})`);
        },
        enabled: enabled && Boolean(paymentInfo),
        select: mapCards
    });
}
function useGetSavedCardsCps(enabled) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).savedCards,
        'cps',
        paymentInfo?.customer_id
    ], async ()=>{
        const cpsData = await getCpsCardsSilently(paymentInfo.customer_id, paymentInfo.external_reference_id);
        if (!cpsData || cpsData.length === 0) return (0, _platformApi.get)('/cards', {
            headers: {
                external_reference_id: paymentInfo.external_reference_id
            }
        });
        return cpsData;
    }, {
        onError (e) {
            if (e) setError(t('status.error.getSavedCardsFailed') + ` - (${e.message})`);
        },
        enabled: enabled && Boolean(paymentInfo?.customer_id),
        select: mapCards
    });
}
function useGetSavedCards() {
    const useCps = (0, _utils.getUrlParam)('cps_search') !== 'false';
    const cpsQuery = useGetSavedCardsCps(useCps);
    const defaultQuery = useGetSavedCardsDefault(!useCps);
    return useCps ? cpsQuery : defaultQuery;
}

},{"axios":"dma8U","react-i18next":"244ua","Core/stores/error":"38MVH","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/platformApi":"9RrWs","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Core/utils/utils":"hwOBZ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6ZSZo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DepositCardForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("Core/utils/utils");
var _useDepositForm = require("Modules/deposit/hooks/useDepositForm");
var _useDepositFormDefault = parcelHelpers.interopDefault(_useDepositForm);
var _cardSelector = require("Core/components/CardSelector");
var _cardSelectorDefault = parcelHelpers.interopDefault(_cardSelector);
var _styledFormGroup = require("Core/components/FormElements/StyledFormGroup");
var _styledFormGroupDefault = parcelHelpers.interopDefault(_styledFormGroup);
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
var _layout = require("Core/components/Layout");
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _numberFormat = require("Core/utils/numberFormat");
var _option = require("Core/components/Option/Option");
var _optionDefault = parcelHelpers.interopDefault(_option);
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _checkbox = require("Core/components/FormElements/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
function LockIcon({ className = 'w-3.5 h-3.5' }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm2-2v2h6V7a3 3 0 00-6 0z",
            clipRule: "evenodd"
        })
    });
}
function SecurePaymentNote() {
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: "flex items-center justify-center gap-1.5 text-xs text-gray-500 mt-3 md:mt-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LockIcon, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: t('payment.securePaymentStripe', 'Secure payment method powered by Stripe')
            })
        ]
    });
}
function CheckoutButton({ disabled = false, depositType, amount }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const parsedAmount = amount ? Number(amount) : NaN;
    const formattedAmount = !Number.isNaN(parsedAmount) && parsedAmount >= 0 ? (0, _numberFormat.formatCurrency)(parsedAmount, {
        currency: 'USD',
        withDecimals: true
    }) : null;
    const label = formattedAmount && (depositType === 'HOLD' ? `Collect Hold - ${formattedAmount}` : `Complete Payment - ${formattedAmount}`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SuccessButton), {
        block: true,
        type: "submit",
        "data-testid": "checkout",
        size: "tall",
        className: "!shadow-md hover:!shadow-lg transition-shadow",
        disabled: disabled,
        children: label ?? t('common.checkout')
    });
}
function StyledOptionItem({ children, isFirst, isLast }) {
    let borderRadiusClasses = 'border rounded-lg';
    if (isFirst) borderRadiusClasses = 'rounded-l-lg rounded-r-lg border-y border-l';
    if (isLast) borderRadiusClasses = 'rounded-l-lg rounded-r-lg border-y border-r';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `shadow-md flex flex-col items-center justify-between bg-white border-gray-300 ${borderRadiusClasses} p-2 mt-2 mx-4 md:mx-0 w-full transition-colors hover:bg-gray-100 hover:text-primary hover:cursor-pointer`,
        children: children
    });
}
function AuthorizeOptions({ options, form, isExternalAccess = false }) {
    const { register, unregister, getValues, setValue } = form;
    const singleOption = options.length === 1;
    const [singleOptionData] = options;
    (0, _reactDefault.default).useEffect(()=>{
        if (singleOption && singleOptionData) setValue('amount', String(singleOptionData.amount));
        else setValue('amount', '98');
        return ()=>unregister('amount');
    }, [
        setValue,
        unregister,
        singleOption,
        singleOptionData?.amount
    ]);
    if (singleOption && singleOptionData) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        "data-testid": "deposit-card-option-container",
        className: "flex flex-col gap-2 mt-2",
        children: [
            isExternalAccess && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "text-md font-bold text-gray-700",
                children: "Processing a credit card hold of:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "rounded-lg border-2 border-primary/30 bg-primary/5 px-4 py-3 w-full max-w-xs",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-2xl font-bold text-primary",
                        children: (0, _numberFormat.formatCurrency)(singleOptionData.amount, {
                            withDecimals: false
                        })
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
        "data-testid": "deposit-card-option-container",
        children: options.map(({ option, amount }, idx, arr)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "md:flex-col-4 flex-col-12",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionDefault.default), {
                    register: register,
                    className: "styled-deposit-option !flex",
                    name: "amount",
                    value: amount,
                    defaultChecked: getValues().amount === amount && getValues().type === 'authorize',
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledOptionItem, {
                        isFirst: idx === 0,
                        isLast: idx === arr.length - 1,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-2xl font-bold",
                            children: (0, _numberFormat.formatCurrency)(amount, {
                                withDecimals: false
                            })
                        })
                    })
                })
            }, option))
    });
}
function CaptureOption({ form }) {
    const { register, unregister, setValue } = form;
    (0, _reactDefault.default).useEffect(()=>{
        setValue('amount', '');
        return ()=>unregister('amount');
    }, [
        setValue,
        unregister
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
            className: "md:flex-col-8",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                register: register,
                type: "number",
                name: `amount`,
                error: form.formState.errors?.amount?.message,
                allowDecimals: true,
                prependText: '$'
            })
        })
    });
}
const DepositOptions = ({ options, form, isExternalAccess = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { register, watch } = form;
    const type = watch('type');
    const cardMethods = [
        {
            id: 'HOLD',
            title: t('common.hold')
        },
        {
            id: 'CAPTURE',
            title: t('common.capture')
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledFormGroupDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
            className: "",
            children: [
                !isExternalAccess && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                    className: "md:!flex-col-2 mr-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            className: "font-semibold",
                            children: t('common:depositAmount')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "space-x-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10 flex",
                            children: cardMethods.map((notificationMethod)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            id: notificationMethod.id,
                                            type: "radio",
                                            ...register('type'),
                                            value: notificationMethod.id,
                                            defaultChecked: type === notificationMethod.id,
                                            className: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: notificationMethod.id,
                                            className: "ml-3 block text-base font-medium text-gray-700",
                                            children: notificationMethod.title
                                        })
                                    ]
                                }, notificationMethod.id))
                        })
                    ]
                }),
                isExternalAccess && /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "hidden",
                    ...register('type'),
                    defaultValue: "HOLD"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                    className: "md:!flex-col-6 mb-0",
                    children: isExternalAccess ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AuthorizeOptions, {
                        options: options,
                        form: form,
                        isExternalAccess: isExternalAccess
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            type === 'HOLD' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AuthorizeOptions, {
                                options: options,
                                form: form,
                                isExternalAccess: false
                            }) : null,
                            type === 'CAPTURE' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(CaptureOption, {
                                form: form
                            }) : null
                        ]
                    })
                })
            ]
        })
    });
};
function DepositCardForm({ paymentMethods, depositOptions, onSubmit, cardErrors }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { paymentMethodId } = (0, _utils.getPreferredPaymentMethod)(paymentMethods);
    const [{ type, amount }] = depositOptions;
    const isExternalAccess = typeof window !== 'undefined' && (0, _utils.getUrlParam)('userAccess') === 'external';
    const defaultValues = paymentMethodId ? {
        paymentMethodId,
        type: isExternalAccess ? 'HOLD' : type,
        amount,
        terms: false
    } : {
        firstName: '',
        lastName: '',
        postalCode: '',
        cardNumber: '',
        cardExpiry: '',
        cardCvc: '',
        preferred: true,
        type: isExternalAccess ? 'HOLD' : type,
        amount: 1,
        terms: false
    };
    const form = (0, _useDepositFormDefault.default)(defaultValues);
    const { watch, handleSubmit, register, setValue, formState: { errors } } = form;
    const cardError = cardErrors?.[0]?.message;
    const termsAccepted = watch('terms');
    const selectedPaymentMethodId = watch('paymentMethodId');
    const firstName = watch('firstName')?.trim();
    const lastName = watch('lastName')?.trim();
    const postalCode = watch('postalCode')?.trim();
    const cardNumber = watch('cardNumber');
    const cardExpiry = watch('cardExpiry');
    const cardCvc = watch('cardCvc');
    const depositType = watch('type');
    const depositAmount = watch('amount');
    const [isCheckoutDisabled, setIsCheckoutDisabled] = (0, _reactDefault.default).useState(true);
    (0, _reactDefault.default).useEffect(()=>{
        const isNewCardComplete = Boolean(firstName && lastName && postalCode && cardNumber && cardExpiry && cardCvc);
        const hasValidAmount = depositAmount !== null && depositAmount !== '' && !Number.isNaN(Number(depositAmount)) && Number(depositAmount) >= 0;
        setIsCheckoutDisabled(!termsAccepted || !selectedPaymentMethodId && !isNewCardComplete || !hasValidAmount);
    }, [
        termsAccepted,
        selectedPaymentMethodId,
        firstName,
        lastName,
        postalCode,
        cardNumber,
        cardExpiry,
        cardCvc,
        depositAmount
    ]);
    const termsTextId = watch('type') === 'authorize' ? 'terms.card.hold' : 'terms.card.charge';
    const showPreferredCheckbox = (paymentMethods?.length ?? 0) > 0 && !selectedPaymentMethodId;
    (0, _reactDefault.default).useEffect(()=>{
        if (!showPreferredCheckbox) setValue('preferred', true);
    }, [
        showPreferredCheckbox,
        setValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        name: "depositCardForm",
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledFormGroupDefault.default), {
                error: cardError,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardSelectorDefault.default), {
                    cardError: cardError,
                    form: form,
                    paymentMethods: paymentMethods,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex mb-2 mt-2 justify-end",
                        children: showPreferredCheckbox ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                            className: "!mb-0",
                            label: t('common.markAsPreferredCard'),
                            name: "preferred",
                            register: register
                        }) : null
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: isExternalAccess ? 'hidden' : undefined,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DepositOptions, {
                    options: depositOptions,
                    form: form,
                    isExternalAccess: isExternalAccess
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _termsInputDefault.default), {
                    name: "terms",
                    register: register,
                    errors: errors,
                    label: t('common.termsAndConditions'),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t(termsTextId)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-wrap justify-between items-end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "md:pr-4 pr-0 w-full flex-col-12 md:!flex-col-6",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                            className: "w-full",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "md:mt-0 flex-col-12 md:!flex-col-6 md:pt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                    register: register,
                                    label: t('common.receiptEmailOptional'),
                                    name: `email`,
                                    error: form.formState.errors?.email?.message
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-full flex-col-12 md:!flex-col-6 hidden md:block",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SecurePaymentNote, {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckoutButton, {
                                    disabled: isCheckoutDisabled,
                                    depositType: depositType,
                                    amount: depositAmount
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "md:hidden sticky bottom-0 z-10 -mx-4 -mb-4 mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "px-4 pb-4 pt-4 bg-white/90 backdrop-blur-sm border-t border-gray-200/80 shadow-[0_-2px_10px_rgba(0,0,0,0.06)]",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckoutButton, {
                            disabled: isCheckoutDisabled,
                            depositType: depositType,
                            amount: depositAmount
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SecurePaymentNote, {})
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/utils/utils":"hwOBZ","Modules/deposit/hooks/useDepositForm":"1kIMj","Core/components/CardSelector":"4d8Tr","Core/components/FormElements/StyledFormGroup":"6lnq9","Core/components/Button":"6YNzH","react-i18next":"244ua","Core/components/Layout":"hweet","Core/components/Layout/Row":"8YqFQ","Core/components/FormElements/Card":"23G8S","Core/utils/numberFormat":"6T56F","Core/components/Option/Option":"7niNe","Core/components/FormElements/TermsInput":"2LJBE","Core/components/FormElements/Checkbox":"9nTYl","Core/components/FormElements/InputField":"6BJmW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3bQTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePostCharge);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
function usePostCharge() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        const { external_reference_id } = queryClient.getQueryData((0, _cacheKeysDefault.default).paymentInfo);
        return (0, _platformApi.post)(`/payment/charge`, data, {
            headers: {
                external_reference_id
            }
        });
    }, {
        throwOnError: true,
        onMutate () {
            queryClient.setQueryData((0, _cacheKeysDefault.default).latestTransaction, []);
        },
        onSuccess () {
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).latestTransaction);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3NXlw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetLatestTransaction", ()=>useGetLatestTransaction);
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _platformApi = require("Core/utils/platformApi");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function useGetLatestTransaction(requestId) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).latestTransaction, ()=>(0, _platformApi.get)('/transaction/latest', {
            headers: {
                request_id: requestId,
                external_reference_id: paymentInfo.external_reference_id
            }
        }), {
        enabled: Boolean(requestId),
        refetchInterval: (data)=>data ? data.length ? false : 500 : false,
        onError (e) {
            if (e) setError(t('status.error.getTransactionHistoryFailed') + ` - (${e.message})`);
        }
    });
}

},{"react-i18next":"244ua","Core/stores/error":"38MVH","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/platformApi":"9RrWs","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"52brD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardPreferenceCenter", ()=>CardPreferenceCenter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactStripeJs = require("@stripe/react-stripe-js");
var _reactToastify = require("react-toastify");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _layout = require("Core/components/Layout");
var _button = require("Core/components/Button");
var _paymentMethod = require("Modules/deposit/components/PaymentMethod");
var _paymentMethodDefault = parcelHelpers.interopDefault(_paymentMethod);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _useCreatePaymentMethod = require("Core/hooks/queries/stripe/useCreatePaymentMethod");
var _useCreatePaymentMethodDefault = parcelHelpers.interopDefault(_useCreatePaymentMethod);
var _addCardForm = require("Modules/deposit/components/AddCardForm");
var _addCardFormDefault = parcelHelpers.interopDefault(_addCardForm);
var _useGetSavedCards = require("Core/hooks/platform/useGetSavedCards");
var _usePostAddCard = require("Core/hooks/platform/usePostAddCard");
var _usePostAddCardDefault = parcelHelpers.interopDefault(_usePostAddCard);
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _usePutUpdateCard = require("Core/hooks/platform/usePutUpdateCard");
var _usePutUpdateCardDefault = parcelHelpers.interopDefault(_usePutUpdateCard);
const CardPreferenceCenter = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const stripe = (0, _reactStripeJs.useStripe)();
    const stripeElements = (0, _reactStripeJs.useElements)();
    const { data: paymentInfo, isLoading: isPaymentInfoLoading } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const { data: savedCards, isSuccess: isSavedCardsLoaded } = (0, _useGetSavedCards.useGetSavedCards)();
    const { mutateAsync: createPaymentMethod, isLoading: isLoadingCreatePaymentMethod } = (0, _useCreatePaymentMethodDefault.default)();
    const { mutateAsync: addCard, isLoading: isLoadingAddCard } = (0, _usePostAddCardDefault.default)();
    const { mutateAsync: updateCard } = (0, _usePutUpdateCardDefault.default)();
    const [modalIsOpen, setIsOpen] = (0, _reactDefault.default).useState(false);
    const [cardError, setCardError] = (0, _reactDefault.default).useState('');
    const isLoading = isLoadingCreatePaymentMethod || isLoadingAddCard;
    const visibilityState = isLoading ? `hidden` : `block`;
    const showAddCardForm = ()=>{
        setCardError('');
        setIsOpen(!modalIsOpen);
    };
    const onSubmit = async ({ firstName, lastName, postalCode, preferred })=>{
        let paymentMethod;
        try {
            paymentMethod = await createPaymentMethod({
                stripe,
                stripeCardElement: stripeElements.getElement((0, _reactStripeJs.CardNumberElement)),
                name: firstName + ' ' + lastName,
                postalCode
            });
        } catch (_) {
            setCardError(t('status.error.failedToSaveCardOnStripe'));
            return;
        }
        try {
            await addCard({
                customerId: paymentInfo.customer_id,
                externalReferenceId: paymentInfo.external_reference_id,
                paymentMethodId: paymentMethod.id,
                preferred,
                brand: paymentMethod.card.brand,
                last4: paymentMethod.card.last4
            });
            (0, _reactToastify.toast).success(t('status.success.cardAdded'));
            setIsOpen(false);
        } catch (_err) {
            setCardError(t('status.error.failedToAddCard'));
        }
    };
    const handleUpdateCard = async ({ paymentMethodId, preferred })=>{
        try {
            await updateCard({
                externalReferenceId: paymentInfo.external_reference_id,
                paymentMethodId,
                preferred
            });
            (0, _reactToastify.toast).success(t('status.success.cardUpdated'));
        } catch (_err) {
            (0, _reactToastify.toast).error(t('status.error.failedToUpdateCard'));
        }
    };
    if (!isSavedCardsLoaded || isPaymentInfoLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        type: "overlay",
        message: t('status.loading.cardPreferenceCenter')
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
                title: t('common.manageCards'),
                withStepProgress: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                className: "md:flex-col-9 flex items-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "mb-0",
                                    children: t('common.savedCards')
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                className: "md:flex-col-3 flex  justify-end",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                    "data-testid": "add-card",
                                    onClick: showAddCardForm,
                                    children: t('common.addCard')
                                })
                            })
                        ]
                    }),
                    savedCards.map((paymentMethod)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentMethodDefault.default), {
                                paymentMethod: paymentMethod,
                                onMarkPreferred: handleUpdateCard
                            }, paymentMethod.paymentMethodId)
                        }, paymentMethod.paymentMethodId);
                    }),
                    !savedCards.length && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bg-white shadow rounded mb-4 p-3 items-center text-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: t('common.cardPreferenceCenter.getStarted')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                "data-testid": "add-card",
                                size: "small",
                                onClick: showAddCardForm,
                                children: t('common.addCard')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
                className: "w-10/12",
                isOpen: modalIsOpen,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addCardFormDefault.default), {
                        onSubmit: onSubmit,
                        className: visibilityState,
                        onCancel: ()=>setIsOpen(false),
                        cardError: cardError
                    }),
                    isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                        "data-testid": "add-card-loader",
                        className: "p-8",
                        message: t('status.loading.savingCard'),
                        type: "inline"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","@stripe/react-stripe-js":"jEv7X","react-toastify":"8eTVO","Core/components/Page":"4xeqH","Core/components/Layout":"hweet","Core/components/Button":"6YNzH","Modules/deposit/components/PaymentMethod":"5GHcO","Core/components/Loader":"6S7S4","Core/hooks/queries/stripe/useCreatePaymentMethod":"ewsPp","Modules/deposit/components/AddCardForm":"gnjys","Core/hooks/platform/useGetSavedCards":"cr4b9","Core/hooks/platform/usePostAddCard":"3FX0p","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Core/hooks/platform/usePutUpdateCard":"6fBnU","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3FX0p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePostAddCard);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _logger = require("Core/utils/logger");
var _platformApi = require("Core/utils/platformApi");
function usePostAddCard() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(({ customerId, externalReferenceId, paymentMethodId, preferred, brand, last4 })=>{
        return (0, _platformApi.post)(`/cards`, {
            customer_id: customerId,
            card: {
                payment_method_id: paymentMethodId,
                preferred,
                last4digit: last4,
                brand
            }
        }, {
            headers: {
                external_reference_id: externalReferenceId
            }
        });
    }, {
        onSuccess () {
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).platformAddCard,
                status: 'success'
            });
            return queryClient.invalidateQueries((0, _cacheKeysDefault.default).savedCards);
        }
    });
}

},{"react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/logger":"cWDKQ","Core/utils/platformApi":"9RrWs","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6fBnU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePutUpdateCard);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _platformApi = require("Core/utils/platformApi");
function usePutUpdateCard() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(({ externalReferenceId, paymentMethodId, preferred })=>{
        return (0, _platformApi.put)(`/cards/${paymentMethodId}`, {
            preferred
        }, {
            headers: {
                external_reference_id: externalReferenceId
            }
        });
    }, {
        onSettled () {
            return queryClient.invalidateQueries((0, _cacheKeysDefault.default).savedCards);
        }
    });
}

},{"react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/platformApi":"9RrWs","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gn9UA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Payment", ()=>Payment);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _reactI18Next = require("react-i18next");
var _useGetTransactionHistory = require("Core/hooks/platform/useGetTransactionHistory");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _transactionHistory = require("Modules/cardPayment/components/TransactionHistory");
var _useGetSavedCards = require("Core/hooks/platform/useGetSavedCards");
var _status = require("Core/components/Status");
var _statusDefault = parcelHelpers.interopDefault(_status);
var _usePostCreatePaymentMethods = require("Core/hooks/queries/stripe/usePostCreatePaymentMethods");
var _usePostCreatePaymentMethodsDefault = parcelHelpers.interopDefault(_usePostCreatePaymentMethods);
var _usePostCharge = require("Core/hooks/platform/usePostCharge");
var _usePostChargeDefault = parcelHelpers.interopDefault(_usePostCharge);
var _reactToastify = require("react-toastify");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _useGetLatestTransaction = require("Core/hooks/platform/useGetLatestTransaction");
var _useGetNextStep = require("Modules/financing/hooks/useGetNextStep");
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _paymentCardForm = require("Modules/cardPayment/components/PaymentCardForm");
var _paymentCardFormDefault = parcelHelpers.interopDefault(_paymentCardForm);
var _reactStripeJs = require("@stripe/react-stripe-js");
var _logger = require("Core/utils/logger");
var _utils = require("Core/utils/utils");
var _autoCloseNotifier = require("Modules/financing/components/AutoCloseNotifier");
var _autoCloseNotifierDefault = parcelHelpers.interopDefault(_autoCloseNotifier);
function Payment({ paymentType, autoCloseOnlyAfterPayment = false }) {
    document.title = 'Payment Portal - Payment';
    const AUTO_CLOSE_TIME_MS = 8000;
    const scroll = (0, _useScrollTop.useScrollTop)();
    const stripe = (0, _reactStripeJs.useStripe)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const { data: transactionHistory } = (0, _useGetTransactionHistory.useGetTransactionHistory)();
    const { data: latestTransaction } = (0, _useGetLatestTransaction.useGetLatestTransaction)(requestId);
    const { data: savedCards } = (0, _useGetSavedCards.useGetSavedCards)();
    const { mutateAsync: createPaymentMethods } = (0, _usePostCreatePaymentMethodsDefault.default)();
    const { mutateAsync: chargeCard } = (0, _usePostChargeDefault.default)();
    const [cardErrors, setCardErrors] = (0, _reactDefault.default).useState([]);
    const [status, setStatus] = (0, _reactDefault.default).useState({
        type: '',
        text: ''
    });
    const queryClient = (0, _reactQuery.useQueryClient)();
    const paymentId = (0, _utils.getUrlParam)('payment-id');
    const [cardIds, setCardIds] = (0, _reactDefault.default).useState([]);
    const { data: nextStepData } = (0, _useGetNextStep.useGetNextStep)();
    const financing_down_payment = nextStepData?.payload?.financing_down_payment ?? null;
    const [isDownPaymentSuccess, setIsDownPaymentSuccess] = (0, _reactDefault.default).useState(false);
    // Whether a charge succeeded within this page session (as opposed to the
    // down payment already being covered when the page was opened).
    const hasPaidInSessionRef = (0, _reactDefault.default).useRef(false);
    const [isAutoCloseScheduled, setIsAutoCloseScheduled] = (0, _reactDefault.default).useState(false);
    (0, _reactDefault.default).useEffect(()=>{
        if (latestTransaction?.length) {
            let totalAmount = 0;
            const errors = [];
            //loop through card ids, as latest transactions doesn't maintain the same order of cards in the UI.
            cardIds.forEach((id)=>{
                const { status: txnStatus, error_message, payment_method_id, amount } = latestTransaction.find((txn)=>txn.payment_method_id === id);
                totalAmount += amount;
                if ([
                    'AUTHORIZED',
                    'PAID'
                ].includes(txnStatus)) errors.push({});
                errors.push({
                    message: error_message,
                    paymentMethodId: payment_method_id
                });
            });
            const isSuccess = latestTransaction.every(({ status: txnStatus })=>[
                    'AUTHORIZED',
                    'PAID'
                ].includes(txnStatus));
            if (isSuccess) {
                hasPaidInSessionRef.current = true;
                if (paymentType === 'downPayment') {
                    // setIsDownPaymentSuccess(true);
                    setTimeout(()=>{
                        window.close();
                    }, AUTO_CLOSE_TIME_MS);
                    setIsAutoCloseScheduled(true);
                }
                (0, _reactToastify.toast).success(t('status.success.paymentProcessed'));
                setStatus({
                    type: 'success'
                });
                (0, _logger.postLogMessage)({
                    amount: totalAmount,
                    feature: (0, _logger.features).platformPayment,
                    status: 'success'
                });
            } else {
                setStatus({
                    type: 'error',
                    text: t('status.error.failedToChargeCard')
                });
                setCardErrors(errors);
            }
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).transactionHistory);
            setRequestId('');
        }
    }, [
        cardIds,
        latestTransaction,
        queryClient,
        t,
        paymentType
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (paymentInfo?.purpose === 'FINANCING') {
            // financing_down_payment is null until next-step has loaded; without this
            // guard `total >= null` is true and the page closes while still loading.
            if (autoCloseOnlyAfterPayment && financing_down_payment === null) return;
            if (transactionHistory && transactionHistory.length) {
                const totalTransactionAmount = transactionHistory.reduce((acc, { amount })=>acc + amount, 0);
                if (totalTransactionAmount >= financing_down_payment) {
                    setIsDownPaymentSuccess(true);
                    // Only auto-close when the payment happened in this session — not
                    // when the down payment was already covered on page load.
                    if (autoCloseOnlyAfterPayment && !hasPaidInSessionRef.current) return;
                    setTimeout(()=>{
                        window.close();
                    }, AUTO_CLOSE_TIME_MS);
                    setIsAutoCloseScheduled(true);
                }
            }
        }
    }, [
        financing_down_payment,
        paymentType,
        transactionHistory,
        paymentInfo?.purpose,
        autoCloseOnlyAfterPayment
    ]);
    async function onSubmit(formData) {
        scroll.top();
        let paymentMethods;
        setStatus({
            type: 'loading',
            text: t('status.loading.submitPaymentInformation')
        });
        setCardErrors([]);
        const paymentMethodData = formData.cards.map((card, index)=>{
            const amount = index === 0 ? +card.amount + formData.decimals : +card.amount;
            if (card.paymentMethodId) return {
                amount,
                paymentMethodId: card.paymentMethodId
            };
            return {
                amount,
                stripeElement: card.stripeElement,
                billingDetails: {
                    name: `${card.firstName} ${card.lastName}`,
                    address: {
                        postal_code: card.postalCode
                    }
                }
            };
        });
        try {
            paymentMethods = await createPaymentMethods({
                stripe,
                data: paymentMethodData
            });
        } catch  {
            return setStatus({
                type: 'error',
                text: t('status.error.failedToCreatePaymentMethods')
            });
        }
        setCardIds(paymentMethods.map(({ paymentMethodId })=>paymentMethodId));
        try {
            const { request_id } = await chargeCard({
                receipt_email: formData.email,
                payments: {
                    card_payment: paymentMethods.map((method)=>({
                            amount: method.amount,
                            payment_method_id: method.paymentMethodId,
                            card_action: 'CAPTURE'
                        }))
                }
            });
            setRequestId(request_id);
        } catch (error) {
            const detailedErrorMessage = error?.message || t('status.error.failedToChargeCard');
            setStatus({
                type: 'error',
                text: detailedErrorMessage
            });
        }
    }
    if (!transactionHistory || !savedCards || !paymentInfo) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading')
    });
    const isPaymentAlreadyMade = !transactionHistory.find(({ payment_id })=>payment_id === paymentId);
    let amountToPay = paymentInfo.amount_to_pay - paymentInfo.already_paid_amount;
    const isFinalAmountToPayZero = amountToPay === 0;
    const shouldShowForm = isPaymentAlreadyMade && !isFinalAmountToPayZero;
    if (paymentType === 'downPayment') amountToPay = financing_down_payment;
    const transactionHistoryWithoutHolds = transactionHistory.filter((item)=>item.card_action !== 'HOLD');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t(`common.${paymentType}`),
        withStepProgress: false,
        stickyFooter: true,
        showStripeLogo: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusDefault.default), {
                ...status
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionHistory.TransactionHistory), {
                transactions: transactionHistoryWithoutHolds
            }),
            paymentType === 'downPayment' && isDownPaymentSuccess && (!autoCloseOnlyAfterPayment || isAutoCloseScheduled) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoCloseNotifierDefault.default), {
                duration: AUTO_CLOSE_TIME_MS,
                children: t('downpayment.redirecting')
            }),
            (paymentType === 'downPayment' && !isDownPaymentSuccess || paymentInfo?.purpose !== 'FINANCING' && shouldShowForm || paymentInfo?.purpose === 'FINANCING' && !isDownPaymentSuccess) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentCardFormDefault.default), {
                paymentMethods: savedCards,
                onSubmit: onSubmit,
                cardErrors: cardErrors,
                totalAmount: amountToPay
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Page":"4xeqH","react-i18next":"244ua","Core/hooks/platform/useGetTransactionHistory":"3gwu1","Core/components/Loader":"6S7S4","Modules/cardPayment/components/TransactionHistory":"8szdg","Core/hooks/platform/useGetSavedCards":"cr4b9","Core/components/Status":"5UE3N","Core/hooks/queries/stripe/usePostCreatePaymentMethods":"gEPFe","Core/hooks/platform/usePostCharge":"3bQTU","react-toastify":"8eTVO","Core/hooks/useScrollTop":"cBwQW","Core/hooks/platform/useGetLatestTransaction":"3NXlw","Modules/financing/hooks/useGetNextStep":"fWBFC","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/cardPayment/components/PaymentCardForm":"f6jeD","@stripe/react-stripe-js":"jEv7X","Core/utils/logger":"cWDKQ","Core/utils/utils":"hwOBZ","Modules/financing/components/AutoCloseNotifier":"b2eKe","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fWBFC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetNextStep", ()=>useGetNextStep);
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _platformApi = require("Core/utils/platformApi");
function useGetNextStep(refetchInterval, enabled = true) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const validator = (data)=>Boolean(data) && Boolean(data?.next_action);
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).financingNextStep, ()=>(0, _platformApi.get)('/application/next-step', {}, validator), {
        refetchInterval,
        enabled: Boolean(enabled),
        onError (e) {
            if (e) setError(t('status.error.getPaymentInfoFailed') + ` - (${e})`);
        }
    });
}

},{"react-i18next":"244ua","Core/stores/error":"38MVH","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/platformApi":"9RrWs","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"f6jeD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMultiCardForm = require("Modules/creditDebit/hooks/useMultiCardForm");
var _useMultiCardFormDefault = parcelHelpers.interopDefault(_useMultiCardForm);
var _button = require("Core/components/Button/Button");
var _reactHookForm = require("react-hook-form");
var _utils = require("Core/utils/utils");
var _cardSelector = require("Core/components/CardSelector");
var _cardSelectorDefault = parcelHelpers.interopDefault(_cardSelector);
var _amountSplitter = require("Modules/creditDebit/components/AmountSplitter");
var _amountSplitterDefault = parcelHelpers.interopDefault(_amountSplitter);
var _styledFormGroup = require("Core/components/FormElements/StyledFormGroup");
var _styledFormGroupDefault = parcelHelpers.interopDefault(_styledFormGroup);
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _reactI18Next = require("react-i18next");
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _numberFormat = require("Core/utils/numberFormat");
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _alert = require("Core/components/Alert");
function LockIcon({ className = 'w-3.5 h-3.5' }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm2-2v2h6V7a3 3 0 00-6 0z",
            clipRule: "evenodd"
        })
    });
}
function SecurePaymentNote() {
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: "flex items-center justify-center gap-1.5 text-xs text-gray-500 md:mt-0 mt-3",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LockIcon, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: t('payment.securePaymentStripe', 'Secure payment method powered by Stripe')
            })
        ]
    });
}
function CheckoutButton({ disabled = false, amount }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const label = amount ? `Complete Payment - ${(0, _numberFormat.formatCurrency)(Number(amount), {
        currency: 'USD',
        withDecimals: true
    })}` : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SuccessButton), {
        block: true,
        type: "submit",
        "data-testid": "checkout",
        size: "tall",
        className: "!shadow-md hover:!shadow-lg transition-shadow",
        disabled: disabled,
        children: label ?? t('common.checkout')
    });
}
const PaymentCardForm = ({ paymentMethods, onSubmit, cardErrors, totalAmount })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    //We do this to manage decimals separately in the onSubmit handler
    const totalAmountInteger = Math.floor(totalAmount);
    const { paymentMethodId } = (0, _utils.getPreferredPaymentMethod)(paymentMethods);
    const defaultCardValues = paymentMethodId ? {
        paymentMethodId,
        amount: totalAmountInteger.toString()
    } : {
        firstName: '',
        lastName: '',
        postalCode: '',
        cardNumber: '',
        cardExpiry: '',
        cardCvc: '',
        amount: totalAmountInteger.toString()
    };
    const form = (0, _useMultiCardFormDefault.default)(defaultCardValues, {
        decimals: (0, _utils.getDecimals)(totalAmount, 6)
    });
    const { register, handleSubmit, control, setValue, watch } = form;
    const { fields, append, remove, update } = (0, _reactHookForm.useFieldArray)({
        control,
        name: 'cards'
    });
    const cards = watch('cards') ?? [];
    const termsAccepted = watch('terms');
    const [isCheckoutDisabled, setIsCheckoutDisabled] = (0, _reactDefault.default).useState(true);
    (0, _reactDefault.default).useEffect(()=>{
        const isCardComplete = (card)=>card?.paymentMethodId || card?.firstName?.trim() && card?.lastName?.trim() && card?.postalCode?.trim() && card?.cardNumber && card?.cardExpiry && card?.cardCvc;
        const allCardsComplete = cards.length > 0 && cards.every(isCardComplete);
        setIsCheckoutDisabled(!termsAccepted || !allCardsComplete);
    }, [
        termsAccepted,
        cards
    ]);
    const remainingToCharge = totalAmountInteger - form.watch('cards').reduce((acc, curr)=>acc + (curr.amount ? parseInt(curr.amount, 10) : 0), 0);
    //This is necessary to update the form state when you remove a card.
    //You cannot call 2 actions together and need to wait for a rerender
    (0, _reactDefault.default).useEffect(()=>{
        if (fields.length === 1) setValue('cards[0].amount', totalAmountInteger.toString());
    }, [
        fields.length,
        setValue,
        totalAmountInteger
    ]);
    //Set remaining to form
    (0, _reactDefault.default).useEffect(()=>{
        setValue('remaining', remainingToCharge, {
            shouldValidate: true
        });
    }, [
        remainingToCharge,
        setValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        name: "multiCardForm",
        onSubmit: handleSubmit(onSubmit),
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bg-gradient-to-r from-primary/5 via-blue-50 to-primary/5 rounded-xl border border-primary/20 p-6 mb-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-sm font-medium text-gray-600 mb-1",
                                    children: t('payment.totalAmountLabel')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-3xl sm:text-4xl font-bold text-gray-900",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                        i18nKey: `{{amount}}`,
                                        values: {
                                            amount: (0, _numberFormat.formatCurrency)(totalAmount, {
                                                withDecimals: true
                                            })
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "hidden sm:flex items-center justify-center w-14 h-14 rounded-full bg-primary/10",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                className: "w-7 h-7 text-primary",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 1.5,
                                    d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                                })
                            })
                        })
                    ]
                })
            }),
            fields.map(({ id, ...field }, i)=>{
                const cardError = cardErrors?.[i]?.message;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "relative",
                    children: [
                        fields.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "absolute -top-3 left-6 z-10",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "inline-flex items-center justify-center w-7 h-7 rounded-full bg-primary text-white text-sm font-semibold shadow-md",
                                children: i + 1
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledFormGroupDefault.default), {
                            error: cardError,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardSelectorDefault.default), {
                                    update: update,
                                    cardError: cardError,
                                    defaultValues: field,
                                    namePrefix: `cards`,
                                    cardCount: fields.length,
                                    index: i,
                                    form: form,
                                    paymentMethods: paymentMethods,
                                    onRemove: ()=>remove(i),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountSplitterDefault.default), {
                                            decimals: form.getValues('decimals'),
                                            totalAmount: totalAmountInteger,
                                            form: form,
                                            index: i,
                                            cardCount: fields.length
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "hidden",
                                            ...register('decimals')
                                        })
                                    ]
                                }),
                                (fields.length === 1 || i === fields.length - 1) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "md:hidden flex mt-6 justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.LinkButton), {
                                            "data-testid": "add-card",
                                            onClick: ()=>{
                                                append({
                                                    paymentMethodId: '',
                                                    firstName: '',
                                                    lastName: '',
                                                    postalCode: '',
                                                    cardNumber: '',
                                                    cardExpiry: '',
                                                    cardCvc: '',
                                                    amount: ''
                                                });
                                            },
                                            className: "!flex !items-center !gap-2",
                                            children: fields.length === 1 ? t('common.splitAmountIntoMultipleCards') : t('common.addCard')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, id);
            }),
            form.formState?.errors?.remaining && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                    i18nKey: `payment.remainingAmountToCharge`,
                    values: {
                        amount: (0, _numberFormat.formatCurrency)(remainingToCharge, {
                            withDecimals: false
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "md:block hidden bg-gradient-to-r from-primary/5 via-blue-50 to-primary/5 rounded-xl border border-primary/20 py-6 md:px-8 px-6 mb-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-base font-regular text-gray-900 mb-1",
                                    children: t('common.splitAmount')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-sm font-regular text-gray-600 text-justify mb-0",
                                    children: t('common.addCardControlLabel')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex items-end justify-end gap-3 flex-grow",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.OutlineButton), {
                                "data-testid": "add-card",
                                onClick: ()=>{
                                    append({
                                        paymentMethodId: '',
                                        firstName: '',
                                        lastName: '',
                                        postalCode: '',
                                        cardNumber: '',
                                        cardExpiry: '',
                                        cardCvc: '',
                                        amount: ''
                                    });
                                },
                                className: "!flex !items-center !gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        className: "w-4 h-4",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M12 4v16m8-8H4"
                                        })
                                    }),
                                    t('common.addCard')
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                className: "!shadow-sm",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _termsInputDefault.default), {
                    name: "terms",
                    register: register,
                    errors: form.formState.errors,
                    label: t('common.termsAndConditions'),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-0 text-gray-600",
                        children: t('terms.card.charge')
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-wrap justify-between items-end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "md:pr-4 pr-0 w-full flex-col-12 md:!flex-col-6",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                            className: " w-full ",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "md:mt-0 flex-col-12 md:!flex-col-6 md:pt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                    register: register,
                                    label: t('common.receiptEmailOptional'),
                                    name: `email`,
                                    error: form.formState.errors?.email?.message
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-full flex-col-12 md:!flex-col-6 hidden md:block",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SecurePaymentNote, {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckoutButton, {
                                    disabled: isCheckoutDisabled,
                                    amount: totalAmount
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "md:hidden sticky bottom-0 z-10 -mx-4 -mb-4 mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "px-4 pb-4 pt-4 bg-white/70 backdrop-blur-sm border-t border-gray-200/80 shadow-[0_-2px_10px_rgba(0,0,0,0.06)]",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckoutButton, {
                            disabled: isCheckoutDisabled,
                            amount: totalAmount
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SecurePaymentNote, {})
                    ]
                })
            })
        ]
    });
};
exports.default = PaymentCardForm;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/creditDebit/hooks/useMultiCardForm":"jgeag","Core/components/Button/Button":"4Zmpz","react-hook-form":"53GLT","Core/utils/utils":"hwOBZ","Core/components/CardSelector":"4d8Tr","Modules/creditDebit/components/AmountSplitter":"6ZAWy","Core/components/FormElements/StyledFormGroup":"6lnq9","Core/components/FormElements/InputField":"6BJmW","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"Core/components/FormElements/TermsInput":"2LJBE","Core/utils/numberFormat":"6T56F","Core/components/FormElements/Card":"23G8S","Core/components/Alert":"fmmNR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jgeag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMultiCardForm);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _v3 = require("zod/v3");
var _reactHookForm = require("react-hook-form");
var _zod = require("@hookform/resolvers/zod");
var _reactI18Next = require("react-i18next");
function useMultiCardForm(initialCard, defaultValues = {}) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            cards: _v3.array(_v3.union([
                _v3.object({
                    firstName: _v3.string().nonempty({
                        message: t('common.requiredFieldFirstName')
                    }),
                    lastName: _v3.string().nonempty({
                        message: t('common.requiredFieldLastName')
                    }),
                    postalCode: _v3.string().nonempty({
                        message: t('common.requiredFieldPostalCode')
                    }),
                    cardNumber: _v3.any().refine((value)=>Boolean(value), {
                        message: t('common.requiredFieldCardNumber')
                    }),
                    cardExpiry: _v3.any().refine((value)=>Boolean(value), {
                        message: t('common.requiredFieldCardExpiry')
                    }),
                    cardCvc: _v3.any().refine((value)=>Boolean(value), {
                        message: t('common.requiredFieldCardCode')
                    }),
                    amount: _v3.string().nonempty({
                        message: t('common.requiredFieldAmount')
                    }).refine((val)=>parseInt(val, 10) >= 1, {
                        message: t('common.requiredFieldSplitAmount')
                    }),
                    stripeElement: _v3.any(),
                    stripe: _v3.any()
                }),
                _v3.object({
                    paymentMethodId: _v3.string().nonempty({
                        message: t('common.requiredFieldFirstName')
                    }),
                    amount: _v3.string().nonempty({
                        message: t('common.requiredFieldAmount')
                    }).refine((val)=>parseInt(val, 10) >= 1, {
                        message: t('common.requiredFieldSplitAmount')
                    })
                })
            ])),
            decimals: _v3.number(),
            terms: _v3.boolean().refine((val)=>val, {
                message: t('common.requiredFieldTerms')
            }),
            email: _v3.string().email({
                message: t('common.invalidFormatEmail')
            }).optional().or(_v3.literal('')),
            remaining: _v3.literal(0)
        });
    }, [
        t
    ]);
    return (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        defaultValues: {
            ...defaultValues,
            cards: [
                initialCard
            ] //forces to render at least 1 CardSelector
        },
        shouldUnregister: true
    });
}

},{"react":"2o0ib","zod/v3":"kXNSc","react-hook-form":"53GLT","@hookform/resolvers/zod":"c0M5u","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6ZAWy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _numberFormat = require("Core/utils/numberFormat");
var _utils = require("Core/utils/utils");
const AmountSplitter = ({ decimals, form, cardCount, index })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { register, watch, formState: { errors } } = form;
    const amount = watch(`cards[${index}].amount`);
    const paymentMethodId = watch(`cards[${index}].paymentMethodId`);
    if (cardCount > 1) {
        const decimalsInteger = decimals * 100;
        const hasDecimal = decimalsInteger * 100 > 0;
        let splitAmountDecimal = '.00';
        if (hasDecimal && index === 0) splitAmountDecimal = decimalsInteger < 10 ? `.0${decimalsInteger}` : `.${decimalsInteger}`;
        const errorMessage = errors?.cards?.[index]?.amount?.message;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `${!paymentMethodId ? 'pt-4 border-t border-gray-200 mt-4' : 'mt-2'}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `
          flex items-center gap-4
          ${paymentMethodId ? 'flex-col items-end' : 'flex-col md:flex-row md:justify-between'}
        `,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: `splitAmount-card${index}`,
                        className: "text-md font-semibold text-left font-medium text-gray-700 whitespace-nowrap",
                        children: t('common.amountToPayWithCard')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "w-full md:w-auto",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `
                inline-flex w-full items-stretch rounded-lg overflow-hidden border
                ${errorMessage ? 'border-red-400 ring-2 ring-red-100' : 'border-gray-300 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20'}
              `,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "flex items-center px-3 bg-gray-100 text-gray-600 font-medium border-r border-gray-300",
                                        children: "$"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        id: `splitAmount-card${index}`,
                                        "data-testid": `splitAmount-card${index}`,
                                        type: "number",
                                        ...register(`cards[${index}].amount`),
                                        value: amount,
                                        maxLength: 6,
                                        className: " h-10 w-full px-3 text-right text-gray-900 font-medium focus:outline-none bg-white [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none "
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "flex items-center px-3 bg-gray-100 text-gray-600 font-medium border-l border-gray-300",
                                        children: splitAmountDecimal
                                    })
                                ]
                            }),
                            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-sm text-red-600 mt-1",
                                children: errorMessage
                            })
                        ]
                    })
                ]
            })
        });
    }
    // Single card - display amount prominently (hidden for external user)
    const isExternalAccess = typeof window !== 'undefined' && (0, _utils.getUrlParam)('userAccess') === 'external';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: isExternalAccess ? 'hidden' : null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center justify-between py-3 mt-3 border-t border-gray-100",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-md font-semibold text-gray-600",
                    children: !paymentMethodId && t('common.amountToPayWithCard')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-xl font-bold text-gray-900",
                    "data-testid": "split-amount",
                    children: (0, _numberFormat.formatCurrency)(+amount + decimals)
                })
            ]
        })
    });
};
exports.default = AmountSplitter;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/utils/numberFormat":"6T56F","Core/utils/utils":"hwOBZ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"b2eKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AutoCloseNotifier);
var _jsxRuntime = require("react/jsx-runtime");
var _alert = require("Core/components/Alert");
var _indicatorCheckmark = require("Modules/creditDebit/components/Checklist/IndicatorCheckmark");
var _indicatorCheckmarkDefault = parcelHelpers.interopDefault(_indicatorCheckmark);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
function AutoCloseNotifier({ duration, children, className }) {
    const [secondsLeft, setSecondsLeft] = (0, _reactDefault.default).useState(duration / 1000);
    const { t } = (0, _reactI18Next.useTranslation)();
    (0, _reactDefault.default).useEffect(()=>{
        const interval = setInterval(()=>{
            if (secondsLeft > 0) setSecondsLeft((seconds)=>seconds - 1);
        }, 1000);
        return ()=>{
            clearInterval(interval);
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
            type: "successLight",
            "data-testid": "auto-close-notification",
            className: className ? className : '',
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "m-auto p-2 flex items-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicatorCheckmarkDefault.default), {
                        color: "green",
                        className: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "ml-4",
                        children: [
                            children,
                            duration && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    "\xa0",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-extrabold text-green-800",
                                        "data-testid": "seconds-left",
                                        children: secondsLeft
                                    }),
                                    "\xa0",
                                    t('common.seconds')
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"9x2lT","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist/IndicatorCheckmark":"37q82","react":"2o0ib","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"37q82":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _checklistStyled = require("Modules/creditDebit/components/Checklist/Checklist.styled");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const backgroundStyles = (color)=>{
    if (color === 'green') return `bg-success`;
    if (color === 'gray') return `bg-gray-300`;
    return `bg-primary`;
};
const IndicatorCheckmark = ({ color, className = '' })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistStyled.StyledIndicator), {
        color: color,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: className + ' h-7 w-7 inline-block origin-center relative [transform:rotate(45deg)] [top:5px] [left:-4px]',
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _classnamesDefault.default)('absolute [height:14px] [width:2px] [top:0] [left:11px]', backgroundStyles(color))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _classnamesDefault.default)('absolute [height:2px] [width:5px] [top:12px] [left:6px]', backgroundStyles(color))
                })
            ]
        })
    });
};
exports.default = IndicatorCheckmark;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","Modules/creditDebit/components/Checklist/Checklist.styled":"40i0q","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"40i0q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledIndicator", ()=>StyledIndicator);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const borderStyles = {
    green: `border-success`,
    orange: `border-yellow-500`,
    red: `border-error`,
    gray: `border-gray-300`
};
function StyledIndicator({ color, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)('border-2 border-solid rounded-full h-7 w-7 my-2', {
            [borderStyles[color]]: Boolean(color),
            'border-transparent': !color
        }),
        children: children
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5ZPtj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFinancingPath", ()=>createFinancingPath);
parcelHelpers.export(exports, "financingPath", ()=>financingPath);
parcelHelpers.export(exports, "financingSuccessPath", ()=>financingSuccessPath);
parcelHelpers.export(exports, "financingErrorPath", ()=>financingErrorPath);
parcelHelpers.export(exports, "createSecondaryFinancingPath", ()=>createSecondaryFinancingPath);
parcelHelpers.export(exports, "mixedAvailableCreditPath", ()=>mixedAvailableCreditPath);
parcelHelpers.export(exports, "mixedDownPaymentCheckoutPath", ()=>mixedDownPaymentCheckoutPath);
parcelHelpers.export(exports, "mixedFinancingPath", ()=>mixedFinancingPath);
parcelHelpers.export(exports, "mixedSuccessPath", ()=>mixedSuccessPath);
parcelHelpers.export(exports, "mixedErrorPath", ()=>mixedErrorPath);
parcelHelpers.export(exports, "paymentOptionsPath", ()=>paymentOptionsPath);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _financingRedirect = require("Modules/financing/routes/FinancingRedirect");
var _financingRedirectDefault = parcelHelpers.interopDefault(_financingRedirect);
var _financingSuccess = require("Modules/financing/routes/FinancingSuccess");
var _financingSuccessDefault = parcelHelpers.interopDefault(_financingSuccess);
var _financingDeclined = require("Modules/financing/routes/FinancingDeclined");
var _financingDeclinedDefault = parcelHelpers.interopDefault(_financingDeclined);
var _financing = require("Modules/financing/routes/Financing");
var _financingDefault = parcelHelpers.interopDefault(_financing);
var _createApplication = require("./routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _payment = require("Modules/cardPayment/routes/Payment");
var _mixedSuccess = require("Modules/financing/routes/MixedSuccess");
var _mixedSuccessDefault = parcelHelpers.interopDefault(_mixedSuccess);
var _mixedError = require("Modules/financing/routes/MixedError");
var _mixedErrorDefault = parcelHelpers.interopDefault(_mixedError);
const createFinancingPath = '/financing-nextgen/financing';
const financingPath = '/financing-nextgen/office/finance';
const financingSuccessPath = '/financing-nextgen/funded';
const financingErrorPath = '/financing-nextgen/declined';
const createSecondaryFinancingPath = '/financing-nextgen/financing/secondary';
const mixedAvailableCreditPath = '/financing-nextgen/mixed/available-credit';
const mixedDownPaymentCheckoutPath = '/financing-nextgen/mixed/down-payment/checkout';
const mixedFinancingPath = '/financing-nextgen/mixed/financing';
const mixedSuccessPath = '/financing-nextgen/mixed/success';
const mixedErrorPath = '/financing-nextgen/mixed/error';
const paymentOptionsPath = '/card-payment/cards';
const routes = [
    {
        path: createFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingRedirectDefault.default), {})
    },
    {
        path: createSecondaryFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
            type: "secondary"
        })
    },
    {
        path: financingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDefault.default), {
            nextRoutes: {
                success: financingSuccessPath,
                error: financingErrorPath
            }
        })
    },
    {
        path: financingSuccessPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSuccessDefault.default), {})
    },
    {
        path: financingErrorPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {})
    },
    {
        path: mixedDownPaymentCheckoutPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _payment.Payment), {
            paymentType: "downPayment",
            nextRoutes: {
                success: mixedFinancingPath,
                error: mixedErrorPath
            }
        })
    },
    {
        path: mixedFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDefault.default), {
            nextRoutes: {
                success: mixedSuccessPath,
                error: mixedErrorPath
            }
        })
    },
    {
        path: mixedSuccessPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mixedSuccessDefault.default), {})
    },
    {
        path: mixedErrorPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mixedErrorDefault.default), {})
    }
];

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/financing/routes/FinancingRedirect":"9CYtL","Modules/financing/routes/FinancingSuccess":"5xTtk","Modules/financing/routes/FinancingDeclined":"iIWvO","Modules/financing/routes/Financing":"ghX2G","./routes/CreateApplication":"42rnR","Modules/cardPayment/routes/Payment":"gn9UA","Modules/financing/routes/MixedSuccess":"kfLWb","Modules/financing/routes/MixedError":"34O6k","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9CYtL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingRedirect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _createApplication = require("Modules/financing/routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _financingPreparation = require("Modules/financing/components/FinancingPreparation");
var _financingPreparationDefault = parcelHelpers.interopDefault(_financingPreparation);
var _useGetNextStep = require("Modules/financing/hooks/useGetNextStep");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _useProviderSync = require("Modules/financing/hooks/useProviderSync");
var _useProviderSyncDefault = parcelHelpers.interopDefault(_useProviderSync);
var _providerSyncConfig = require("Modules/financing/config/providerSyncConfig");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _financingSuccess = require("Modules/financing/routes/FinancingSuccess");
var _financingSuccessDefault = parcelHelpers.interopDefault(_financingSuccess);
var _financingApproved = require("Modules/financing/routes/FinancingApproved");
var _financingApprovedDefault = parcelHelpers.interopDefault(_financingApproved);
var _returnTracking = require("Modules/financing/components/ReturnTracking");
var _returnTrackingDefault = parcelHelpers.interopDefault(_returnTracking);
var _financingStatusMessage = require("Modules/financing/components/FinancingStatusMessage");
var _financingStatusMessageDefault = parcelHelpers.interopDefault(_financingStatusMessage);
var _financingDeclined = require("Modules/financing/routes/FinancingDeclined");
var _financingDeclinedDefault = parcelHelpers.interopDefault(_financingDeclined);
var _finaningCorrectionRequired = require("Modules/financing/components/FinaningCorrectionRequired");
var _finaningCorrectionRequiredDefault = parcelHelpers.interopDefault(_finaningCorrectionRequired);
var _routes = require("Modules/cardPayment/routes");
var _routes1 = require("Modules/financing/routes");
var _routes2 = require("Core/routes");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactLocation = require("react-location");
var _routes3 = require("Modules/patientfi/routes");
function FinancingRedirect() {
    const routes = {
        paymentOptions: (0, _routes.cardPreferenceCenterPath),
        financing: (0, _routes1.financingPath),
        mixed: (0, _routes1.mixedDownPaymentCheckoutPath),
        financingSuccessPath: (0, _routes1.financingSuccessPath),
        financingErrorPath: (0, _routes1.financingErrorPath),
        payment: (0, _routes.paymentPath),
        patientfiFinancing: (0, _routes3.createFinancingPath)
    };
    const navigate = (0, _reactLocation.useNavigate)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const { t } = (0, _reactI18Next.useTranslation)();
    const cachedApp = JSON.parse(sessionStorage.getItem('application'));
    const { data: newApp, isLoading, isError, error } = (0, _useGetNextStep.useGetNextStep)(false, !cachedApp);
    const application = cachedApp || newApp;
    sessionStorage.removeItem('application');
    const { next_action = 'CREATE_APPLICATION' } = application || {};
    const { data: { amount_to_pay, customer_id = '', provider = '' } = {}, isLoading: isPaymentInfoLoading, isError: isPaymentInfoError } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    // Refresh an approved Allegro / All Well application from the provider before showing it.
    // The refreshed application replaces the next-step cache; on timeout the current one is kept.
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { mutateAsync: syncProvider } = (0, _useProviderSyncDefault.default)();
    const hasStartedProviderSync = (0, _reactDefault.default).useRef(false);
    const [isProviderSyncDone, setIsProviderSyncDone] = (0, _reactDefault.default).useState(false);
    const shouldSyncProvider = (0, _providerSyncConfig.PROVIDER_SYNC_PROVIDERS).includes(provider) && (0, _providerSyncConfig.PROVIDER_SYNC_NEXT_ACTIONS).includes(next_action) && application?.payload?.application_status === 'Approved';
    (0, _reactDefault.default).useEffect(()=>{
        if (!shouldSyncProvider || hasStartedProviderSync.current) return;
        hasStartedProviderSync.current = true;
        syncProvider().then((syncedApp)=>{
            if (syncedApp) queryClient.setQueryData((0, _cacheKeysDefault.default).financingNextStep, syncedApp);
            setIsProviderSyncDone(true);
        });
    }, [
        shouldSyncProvider,
        syncProvider,
        queryClient
    ]);
    if (isLoading || isPaymentInfoLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
    else if (shouldSyncProvider && !isProviderSyncDone) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('financing.nextgen.signContract.syncLoadingText')
    });
    else if (provider && provider === 'PATIENTFI') navigate({
        to: routes.patientfiFinancing,
        search: true
    });
    else if (isError || error?.response?.status === 404 || !application?.next_action) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
        customer_id: customer_id
    });
    else if (application?.next_action) switch(next_action){
        case 'CREATE_APPLICATION':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
                type: "primary",
                customer_id: customer_id
            });
        case 'SELECT_OFFER':
        case 'UPDATE_OFFER':
        case 'SIGN_CONTRACT':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingPreparationDefault.default), {
                application: application,
                routes: routes
            });
        case 'CORRECTION_REQUIRED':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _finaningCorrectionRequiredDefault.default), {
                application: application
            });
        case 'UPDATE_AMOUNT':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingApprovedDefault.default), {});
        case 'CANCELLED':
        case 'DECLINED':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {
                allowCreateApplication: true,
                application: application
            });
        case 'DONE':
        case 'FUND_APPLICATION':
        case 'PENDING_DOWN_PAYMENT':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSuccessDefault.default), {});
        case 'RETURN_APPROVED':
        case 'RETURN_REQUESTED':
        case 'RETURN_PROCESSING':
        case 'RETURN_COMPLETE':
        case 'RETURN_CANCELED':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _returnTrackingDefault.default), {
                nextAction: next_action
            });
        case 'DECISION_PENDING':
        case 'NO_DECISION':
        case 'APPLICATION_CLOSED':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingStatusMessageDefault.default), {
                nextAction: next_action,
                application: application
            });
        default:
            setError(t('status.error.getFinancingApplicationFailed'));
            navigate({
                to: (0, _routes2.errorPath),
                search: true
            });
    }
    if (!isPaymentInfoError && !isPaymentInfoLoading && !amount_to_pay) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingApprovedDefault.default), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Modules/financing/routes/CreateApplication":"42rnR","Modules/financing/components/FinancingPreparation":"4vtQJ","Modules/financing/hooks/useGetNextStep":"fWBFC","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/financing/hooks/useProviderSync":"4YW9r","Modules/financing/config/providerSyncConfig":"gNLYY","Core/components/Loader":"6S7S4","Modules/financing/routes/FinancingSuccess":"5xTtk","Modules/financing/routes/FinancingApproved":"kCOgk","Modules/financing/components/ReturnTracking":"jq6MM","Modules/financing/components/FinancingStatusMessage":"535sN","Modules/financing/routes/FinancingDeclined":"iIWvO","Modules/financing/components/FinaningCorrectionRequired":"1dUjC","Modules/cardPayment/routes":"kPsar","Modules/financing/routes":"5ZPtj","Core/routes":"iddMu","Core/stores/error":"38MVH","react-location":"8hNco","Modules/patientfi/routes":"lyzU7","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"42rnR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _reactI18Next = require("react-i18next");
var _selectMenu = require("Core/components/FormElements/SelectMenu");
var _selectMenuDefault = parcelHelpers.interopDefault(_selectMenu);
var _alert = require("Core/components/Alert");
var _infoBox = require("Core/components/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _button = require("Core/components/Button");
var _usStates = require("Modules/creditDebit/config/usStates");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _birthDateInput = require("Core/components/FormElements/BirthDateInput");
var _birthDateInputDefault = parcelHelpers.interopDefault(_birthDateInput);
var _layout = require("Core/components/Layout");
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _reactLocation = require("react-location");
var _routes = require("Modules/financing/routes");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _reactQuery = require("react-query");
var _useCreateApplicationForm = require("Modules/financing/hooks/useCreateApplicationForm");
var _useCreateApplicationFormDefault = parcelHelpers.interopDefault(_useCreateApplicationForm);
var _useCreateApplication = require("Modules/financing/hooks/useCreateApplication");
var _useCreateApplicationDefault = parcelHelpers.interopDefault(_useCreateApplication);
var _useGetCustomerInfo = require("Modules/financing/hooks/useGetCustomerInfo");
var _useGetCustomerInfoDefault = parcelHelpers.interopDefault(_useGetCustomerInfo);
var _useGetApplication = require("Modules/financing/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _fa6 = require("react-icons/fa6");
var _quote = require("Core/components/Quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
var _useScrollTop = require("Core/hooks/useScrollTop");
var _relationTypes = require("../config/relationTypes");
var _im = require("react-icons/im");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _getStateAbbreviation = require("Modules/financing/hooks/getStateAbbreviation");
var _getStateAbbreviationDefault = parcelHelpers.interopDefault(_getStateAbbreviation);
var _logger = require("Core/utils/logger");
const dateFormat = 'yyyy-MM-dd';
const mapCustomerData = (customerData)=>{
    return {
        ...customerData,
        firstName: customerData.first_name ?? '',
        lastName: customerData.last_name ?? '',
        address: customerData.address_line ?? '',
        city: customerData.city ?? '',
        state: (0, _getStateAbbreviationDefault.default)(customerData.state) ?? '',
        zip: customerData.zip ?? '',
        country: customerData.country ?? '',
        email: customerData.email ?? '',
        socialSecurityNumber: customerData.customer_identity_number ?? '',
        phone: (customerData.phone_number ?? '').replace(/^\+1/, ''),
        annualIncome: (customerData.monthly_income ? customerData.monthly_income * 12 : '').toString(),
        relationship: customerData.relationship ?? 'SELF'
    };
};
const parseDateOfBirth = (dateOfBirth)=>{
    let year, month, day;
    if (Array.isArray(dateOfBirth)) {
        [year, month, day] = dateOfBirth;
        if (month > 0 && month < 10) month = '0' + month;
        if (day > 0 && day < 10) day = '0' + day;
    } else if (typeof dateOfBirth === 'string') [year, month, day] = dateOfBirth.split('-');
    return {
        day,
        month,
        year
    };
};
const CreateApplication = ({ type = 'primary', customer_id = '' })=>{
    document.title = 'Payment Portal - Create Application';
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const scroll = (0, _useScrollTop.useScrollTop)();
    const { mutateAsync: createApplication, isLoading: isCreateAppLoading } = (0, _useCreateApplicationDefault.default)();
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const [showSsn, setShowSsn] = (0, _reactDefault.default).useState(false);
    const [showRelationField, setshowRelationField] = (0, _reactDefault.default).useState(type !== 'primary'); // false
    const [createApplicationPolling, setCreateApplicationPolling] = (0, _reactDefault.default).useState(false);
    const [initialAppStatus, setInitialAppStatus] = (0, _reactDefault.default).useState({
        nextAction: null,
        message: null,
        status: null
    });
    const { isSuccess: isGetAppSuccess, isLoading: isGetAppLoading, data: getAppData } = (0, _useGetApplicationDefault.default)(requestId, createApplicationPolling ? 3000 : false);
    const { data: customerInfo } = (0, _useGetCustomerInfoDefault.default)();
    const [dobDefaults, setDobDefaults] = (0, _reactDefault.default).useState({
        day: '01',
        month: '01',
        year: ''
    });
    const [isFinanceAppLoading, setIsFinanceAppLoading] = (0, _reactDefault.default).useState(false);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { register, handleSubmit, setValue, watch, reset, formState: { errors, isSubmitted } } = (0, _useCreateApplicationFormDefault.default)();
    const selectedRelationship = watch('relationship');
    const relationshipSessionStorageString = sessionStorage.getItem('relationship');
    const previousRelationship = JSON.parse(relationshipSessionStorageString)?.relationship || '';
    const sessionStorageCustomerId = JSON.parse(relationshipSessionStorageString)?.customer_id || '';
    const filteredRelationTypes = (0, _relationTypes.relationTypes).filter((item)=>!previousRelationship || type === 'primary' ? true : item.value !== previousRelationship);
    const initializeAppStatus = (appData)=>{
        const { correction_required: { status = '', message = '' } = {} } = appData?.payload || {};
        setInitialAppStatus({
            nextAction: appData?.next_action,
            message,
            status
        });
    };
    (0, _reactDefault.default).useEffect(()=>{
        const isAppStatusChanged = ()=>getAppData?.next_action !== initialAppStatus.nextAction || getAppData?.message !== initialAppStatus.message || getAppData?.status !== initialAppStatus.status;
        if (isGetAppSuccess && createApplicationPolling && isAppStatusChanged()) {
            sessionStorage.setItem('application', JSON.stringify(getAppData));
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
            navigate({
                to: (0, _routes.financingPath),
                search: true,
                replace: true
            });
            setRequestId('');
            setCreateApplicationPolling(false);
            setIsFinanceAppLoading(false);
        }
    }, [
        isGetAppSuccess,
        getAppData,
        navigate,
        createApplicationPolling,
        requestId,
        initialAppStatus,
        queryClient
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetAppLoading) setIsFinanceAppLoading(true);
    }, [
        isGetAppLoading
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        return ()=>{
            setRequestId('');
            queryClient.removeQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
        };
    }, [
        queryClient
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (customerInfo) {
            const customerData = mapCustomerData(customerInfo);
            if (customerData.relationship === previousRelationship && sessionStorageCustomerId === customer_id && type !== 'primary') customerData.relationship = null;
            Object.keys(customerData).forEach((field)=>setValue(field, customerData[field]));
            if (customerData.date_of_birth) setDobDefaults(parseDateOfBirth(customerData.date_of_birth));
        } else {
            setDobDefaults({
                day: '01',
                month: '01',
                year: ''
            });
            reset(mapCustomerData({}));
        }
    }, [
        customerInfo,
        reset,
        setValue,
        customer_id,
        previousRelationship,
        sessionStorageCustomerId,
        type
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        const errorFields = Object.keys(errors);
        if (errorFields?.length) {
            const errorMap = errorFields.map((field)=>{
                return {
                    field,
                    message: errors[field].message
                };
            });
            console.log('form errors!', errorMap);
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                action: (0, _logger.actions).createApplicationFormError,
                errors: errorMap
            });
        }
    }, [
        errors
    ]);
    const handleRelationshipChange = ()=>{
        if (customerInfo && customerInfo.relationship === selectedRelationship) {
            const customerData = mapCustomerData(customerInfo);
            Object.keys(customerData).forEach((field)=>setValue(field, customerData[field]));
            if (customerData.date_of_birth) setDobDefaults(parseDateOfBirth(customerData.date_of_birth));
        } else {
            setDobDefaults({
                day: '01',
                month: '01',
                year: ''
            });
            reset(mapCustomerData({}));
        }
    };
    const ssn = watch('socialSecurityNumber');
    (0, _reactDefault.default).useEffect(()=>{
        setValue('socialSecurityNumber', ssn?.replace(/\D+/g, ''));
    }, [
        setValue,
        ssn
    ]);
    const phone = watch('phone');
    (0, _reactDefault.default).useEffect(()=>{
        if (phone?.startsWith('+1')) setValue('phone', phone.replace(/^\+1/, ''));
    }, [
        setValue,
        phone
    ]);
    const hasFormErrors = Object.keys(errors).length > 0;
    const onSubmit = async (formData)=>{
        setRequestId('');
        initializeAppStatus();
        setCreateApplicationPolling(true);
        scroll.top();
        const { headers: { request_id } } = await createApplication(formData);
        setRequestId(request_id);
    };
    const toggleSsnDisplay = ()=>{
        setShowSsn(!showSsn);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.createFinancingApplication.header'),
        subtitle: t('page.createFinancingApplication.subtitle'),
        withStepProgress: false,
        stickyFooter: true,
        children: [
            isCreateAppLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('synchrony.createApplication.loaderText')
            }),
            isFinanceAppLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('status.loading.financingApplication')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                name: "allegroCreateApplication",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    hasFormErrors && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                        type: "error",
                        children: t('status.error.checkErrors')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    !showRelationField && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "text-gray-500",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center my-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "inline-block pr-2",
                                                    children: [
                                                        ' ',
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _im.ImInfo), {})
                                                    ]
                                                }),
                                                "Filling the application for someone else?",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "text-blue-500 hover:underline mx-1",
                                                    type: "button",
                                                    onClick: ()=>setshowRelationField(true),
                                                    children: "Click here"
                                                }),
                                                ' ',
                                                "to change relationship"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!mb-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                            type: "infoLight",
                                            children: t('allegro.createApplication.enterLegalNames')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: (0, _classnamesDefault.default)('md:!flex-col-6', {
                                            hidden: !showRelationField
                                        }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                                            register: register,
                                            label: t('common.relationship'),
                                            name: "relationship",
                                            items: filteredRelationTypes,
                                            onChange: handleRelationshipChange,
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!mb-2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.firstName'),
                                            name: "firstName",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.lastName'),
                                            name: "lastName",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.street'),
                                            name: "address",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.city'),
                                            name: "city",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                                            register: register,
                                            label: t('common.state'),
                                            name: "state",
                                            items: (0, _usStates.usStates),
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.postalCode'),
                                            name: "zip",
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.email'),
                                            name: "email",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                                register: register,
                                                label: t('common.phone'),
                                                name: "phone",
                                                errors: errors
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteDefault.default), {
                                                className: "mt-4",
                                                children: t('allegro.createApplication.readToCustomer.phonenote')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6 flex items-end",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            className: "!rounded-r-none",
                                            register: register,
                                            label: t('common.ssn'),
                                            name: "socialSecurityNumber",
                                            errors: errors,
                                            onAppendClick: toggleSsnDisplay,
                                            appendText: showSsn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa6.FaEyeSlash), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa6.FaEye), {}),
                                            type: showSsn ? 'text' : 'password'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _birthDateInputDefault.default), {
                                            format: dateFormat,
                                            register: register,
                                            name: "dateOfBirth",
                                            padZeros: true,
                                            onChange: (value)=>{
                                                setValue('dateOfBirth', value, {
                                                    shouldValidate: isSubmitted
                                                });
                                            },
                                            defaultValues: dobDefaults,
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.annualIncome'),
                                            name: "annualIncome",
                                            type: "number",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-12",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteDefault.default), {
                                            children: t('synchrony.createApplication.readToCustomer.note2')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: t('common.noticeToApplicants')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                        type: "warning",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-semibold text-sm text-black",
                                            children: t('common.readToCustomer.doubleTitle')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                            showBorder: true,
                                            children: t('synchrony.nextgen.createApplication.terms.note1')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                            showBorder: true,
                                            children: t('financing.nextgen.createApplication.terms.note2')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _termsInputDefault.default), {
                                name: "terms",
                                register: register,
                                errors: errors,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        children: t('financing.nextgen.createApplication.terms')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ol", {
                                        className: "list-decimal ml-4 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: t('allegro.createApplication.terms.note1')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: t('allegro.createApplication.terms.note2')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "md:!flex-col-12 !flex gap-1 !justify-end",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                type: "submit",
                                "data-testid": "submit-application",
                                children: t('common.submitPrequalificationApplication')
                            })
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = CreateApplication;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/InputField":"6BJmW","react-i18next":"244ua","Core/components/FormElements/SelectMenu":"hsUsp","Core/components/Alert":"fmmNR","Core/components/InfoBox":"4Lj47","Core/components/Button":"6YNzH","Modules/creditDebit/config/usStates":"2i8MO","Core/components/Page":"4xeqH","Core/components/FormElements/BirthDateInput":"36m4y","Core/components/Layout":"hweet","Core/components/FormElements/formElements.styled":"45aFS","Core/components/FormElements/TermsInput":"2LJBE","Core/components/Loader":"6S7S4","react-location":"8hNco","Modules/financing/routes":"5ZPtj","Core/hooks/queries/cacheKeys":"i5IL7","react-query":"ksTpv","Modules/financing/hooks/useCreateApplicationForm":"cbJ0I","Modules/financing/hooks/useCreateApplication":"b3AYG","Modules/financing/hooks/useGetCustomerInfo":"iLVvV","Modules/financing/hooks/useGetApplication":"bc0DL","react-icons/fa6":"1emil","Core/components/Quote":"aL5Js","Core/hooks/useScrollTop":"cBwQW","../config/relationTypes":"aeCnv","react-icons/im":"ek0E7","classnames":"f971Y","Modules/financing/hooks/getStateAbbreviation":"eldfg","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hsUsp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _error = require("Core/components/FormElements/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
const SelectMenu = (props)=>{
    const { className, name, id = name, register, errors = {}, error = '', label, testid = id, items = [], onChange, ...rest } = props;
    const errorMessage = error || errors[name]?.message;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormElement), {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                id: id,
                name: name,
                "aria-label": label,
                "data-testid": testid,
                onChange: onChange,
                ...register(name),
                ...rest,
                children: items.map(({ label: itemLabel, value: itemValue, disabled: disabledValue })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                        value: itemValue,
                        disabled: disabledValue,
                        children: itemLabel
                    }, itemValue))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                message: errorMessage,
                show: Boolean(errorMessage)
            })
        ]
    });
};
exports.default = SelectMenu;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/formElements.styled":"45aFS","Core/components/FormElements/Error":"dyj9l","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4Lj47":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const styles = {
    warning: {
        base: 'p-2 bg-yellow-100 text-sm rounded-b',
        header: 'bg-yellow-300',
        paragraph: 'bg-yellow-100',
        border: 'border-l-4 border-l-amber-300 pl-4'
    },
    message: {
        base: 'p-2 bg-gray-100 text-sm rounded-b',
        header: 'bg-gray-300',
        paragraph: 'bg-gray-100',
        border: 'border-l-4 border-l-amber-300 pl-4'
    },
    warningLite: {
        base: 'p-2 bg-yellow-50 text-md rounded-b py-3 font-light shadow-md',
        header: '',
        paragraph: 'inline-block pr-16',
        border: 'border-l-4 border-l-yellow-600 pl-4'
    }
};
const InfoBox = ({ showBorder = false, title, children, type = 'warning' })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "my-2",
        children: [
            title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                className: (0, _classnamesDefault.default)('p-2 -mb-1 text-gray-800 text-sm font-bold rounded-t', styles[type].header),
                children: title
            }),
            children && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _classnamesDefault.default)(styles[type].base, styles[type].paragraph, {
                    [styles[type].border]: showBorder
                }),
                children: children
            })
        ]
    });
};
exports.default = InfoBox;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2i8MO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usStates", ()=>usStates);
const usStates = [
    {
        value: '',
        label: 'Select a state'
    },
    {
        value: 'AL',
        label: 'Alabama'
    },
    {
        value: 'AK',
        label: 'Alaska'
    },
    {
        value: 'AZ',
        label: 'Arizona'
    },
    {
        value: 'AR',
        label: 'Arkansas'
    },
    {
        value: 'CA',
        label: 'California'
    },
    {
        value: 'CO',
        label: 'Colorado'
    },
    {
        value: 'CT',
        label: 'Connecticut'
    },
    {
        value: 'DE',
        label: 'Delaware'
    },
    {
        value: 'DC',
        label: 'District of Columbia'
    },
    {
        value: 'FL',
        label: 'Florida'
    },
    {
        value: 'GA',
        label: 'Georgia'
    },
    {
        value: 'HI',
        label: 'Hawaii'
    },
    {
        value: 'ID',
        label: 'Idaho'
    },
    {
        value: 'IL',
        label: 'Illinois'
    },
    {
        value: 'IN',
        label: 'Indiana'
    },
    {
        value: 'IA',
        label: 'Iowa'
    },
    {
        value: 'KS',
        label: 'Kansas'
    },
    {
        value: 'KY',
        label: 'Kentucky'
    },
    {
        value: 'LA',
        label: 'Louisiana'
    },
    {
        value: 'ME',
        label: 'Maine'
    },
    {
        value: 'MD',
        label: 'Maryland'
    },
    {
        value: 'MA',
        label: 'Massachusetts'
    },
    {
        value: 'MI',
        label: 'Michigan'
    },
    {
        value: 'MN',
        label: 'Minnesota'
    },
    {
        value: 'MS',
        label: 'Mississippi'
    },
    {
        value: 'MO',
        label: 'Missouri'
    },
    {
        value: 'MT',
        label: 'Montana'
    },
    {
        value: 'NE',
        label: 'Nebraska'
    },
    {
        value: 'NV',
        label: 'Nevada'
    },
    {
        value: 'NH',
        label: 'New Hampshire'
    },
    {
        value: 'NJ',
        label: 'New Jersey'
    },
    {
        value: 'NM',
        label: 'New Mexico'
    },
    {
        value: 'NY',
        label: 'New York'
    },
    {
        value: 'NC',
        label: 'North Carolina'
    },
    {
        value: 'ND',
        label: 'North Dakota'
    },
    {
        value: 'OH',
        label: 'Ohio'
    },
    {
        value: 'OK',
        label: 'Oklahoma'
    },
    {
        value: 'OR',
        label: 'Oregon'
    },
    {
        value: 'PA',
        label: 'Pennsylvania'
    },
    {
        value: 'RI',
        label: 'Rhode Island'
    },
    {
        value: 'SC',
        label: 'South Carolina'
    },
    {
        value: 'SD',
        label: 'South Dakota'
    },
    {
        value: 'TN',
        label: 'Tennessee'
    },
    {
        value: 'TX',
        label: 'Texas'
    },
    {
        value: 'UT',
        label: 'Utah'
    },
    {
        value: 'VT',
        label: 'Vermont'
    },
    {
        value: 'VA',
        label: 'Virginia'
    },
    {
        value: 'WA',
        label: 'Washington'
    },
    {
        value: 'WV',
        label: 'West Virginia'
    },
    {
        value: 'WI',
        label: 'Wisconsin'
    },
    {
        value: 'WY',
        label: 'Wyoming'
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"36m4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
var _appConfig = require("Core/config/appConfig");
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _error = require("Core/components/FormElements/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
const BirthDateInput = ({ className, register: parentRegister, name, format, errors, onChange = ()=>{}, padZeros, defaultValues = {} })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { register, watch, setValue } = (0, _reactHookForm.useForm)({
        defaultValues
    });
    const { dateFormat } = (0, _appConfig.getAppConfig)();
    const formatter = format || dateFormat;
    const { day, month, year } = watch();
    const error = errors[name]?.message;
    (0, _reactDefault.default).useEffect(()=>{
        parentRegister(name);
    }, [
        parentRegister,
        name
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (padZeros && !isNaN(day) && day !== '') {
            if (Number(day) > 0 && Number(day) < 10) {
                if (day.length === 1) {
                    const modNum = Number(day).toString();
                    setValue('day', '0' + modNum);
                }
            } else {
                const modNum = Number(day).toString();
                setValue('day', modNum);
            }
        }
        const dateObj = (0, _dateFns.parseISO)(`${year}-${month}-${day}`);
        try {
            onChange((0, _dateFns.formatISO)(dateObj, {
                representation: 'date'
            }));
        } catch  {
            onChange(dateObj);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        day,
        month,
        year,
        formatter
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (defaultValues) Object.keys(defaultValues).forEach((field)=>setValue(field, defaultValues[field]));
    }, [
        defaultValues,
        setValue
    ]);
    const items = [
        {
            label: 'January',
            value: '01'
        },
        {
            label: 'February',
            value: '02'
        },
        {
            label: 'March',
            value: '03'
        },
        {
            label: 'April',
            value: '04'
        },
        {
            label: 'May',
            value: '05'
        },
        {
            label: 'June',
            value: '06'
        },
        {
            label: 'July',
            value: '07'
        },
        {
            label: 'August',
            value: '08'
        },
        {
            label: 'September',
            value: '09'
        },
        {
            label: 'October',
            value: '10'
        },
        {
            label: 'November',
            value: '11'
        },
        {
            label: 'December',
            value: '12'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormElement), {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: t('common.dob')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-wrap gap-x-2 content-start",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        className: '[width:55%_!important]',
                        name: "month",
                        "data-testid": `${name}-month`,
                        ...register('month'),
                        children: items.map(({ label: itemLabel, value: itemValue })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: itemValue,
                                children: itemLabel
                            }, itemValue))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        className: 'flex-1 text-right',
                        name: "day",
                        type: "number",
                        min: "1",
                        max: "31",
                        placeholder: "DD",
                        "data-testid": `${name}-day`,
                        ...register('day')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        className: 'flex-1 text-right',
                        name: "year",
                        type: "number",
                        placeholder: "YYYY",
                        "data-testid": `${name}-year`,
                        ...register('year')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                message: error,
                show: Boolean(error)
            })
        ]
    });
};
exports.default = BirthDateInput;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","react-hook-form":"53GLT","date-fns":[["formatISO","5S5YG","default"],["parseISO","3xgI2","default"]],"Core/config/appConfig":"7qX5H","Core/components/FormElements/formElements.styled":"45aFS","Core/components/FormElements/Error":"dyj9l","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5S5YG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatISO);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/addLeadingZeros/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function formatISO(date, options) {
    var _options$format, _options$representati;
    (0, _indexJsDefault2.default)(1, arguments);
    var originalDate = (0, _indexJsDefault.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, _indexJsDefault1.default)(originalDate.getDate(), 2);
        var month = (0, _indexJsDefault1.default)(originalDate.getMonth() + 1, 2);
        var year = (0, _indexJsDefault1.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, _indexJsDefault1.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, _indexJsDefault1.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, _indexJsDefault1.default)(originalDate.getHours(), 2);
        var minute = (0, _indexJsDefault1.default)(originalDate.getMinutes(), 2);
        var second = (0, _indexJsDefault1.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

},{"../toDate/index.js":"iBeGL","../_lib/addLeadingZeros/index.js":"kMemg","../_lib/requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3xgI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseISO);
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
function parseISO(argument, options) {
    var _options$additionalDi;
    (0, _indexJsDefault.default)(1, arguments);
    var additionalDigits = (0, _indexJsDefault1.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

},{"../constants/index.js":"27Rmt","../_lib/requiredArgs/index.js":"hVUyW","../_lib/toInteger/index.js":"5Ujd6","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"27Rmt":[function(require,module,exports,__globalThis) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cbJ0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSocialSecurityNumberRegex", ()=>getSocialSecurityNumberRegex);
parcelHelpers.export(exports, "validateISODateFormat", ()=>validateISODateFormat);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _dateFns = require("date-fns");
var _reactHookForm = require("react-hook-form");
var _relationTypes = require("Modules/financing/config/relationTypes");
const getSocialSecurityNumberRegex = ()=>/^\d{3}-?\d{2}-?\d{4}$/;
const validateISODateFormat = (val)=>{
    return val ? (0, _dateFns.isValid)((0, _dateFns.parseISO)(val)) : true;
};
const relationValues = (0, _relationTypes.relationTypes).map((item)=>item.value);
const useCreateApplicationForm = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            // salutation: z.string().min(1,{ message: t('common.requiredSalutation') }),
            firstName: _v3.string().min(1, {
                message: t('common.requiredFieldFirstName')
            }),
            lastName: _v3.string().min(1, {
                message: t('common.requiredFieldLastName')
            }),
            address: _v3.string().min(1, {
                message: t('common.requiredFieldStreet')
            }).max(35, {
                message: 'Address must be 35 characters or less'
            }),
            city: _v3.string().min(1, {
                message: t('common.requiredFieldCity')
            }),
            state: _v3.string().min(1, {
                message: t('common.requiredFieldState')
            }),
            zip: _v3.string().min(1, {
                message: t('common.requiredFieldPostalCode')
            }).regex(/^\d{5}(-?\d{4})?$/, {
                message: 'Please provide a valid US ZIP code'
            }),
            relationship: _v3.enum(relationValues, {
                errorMap: ()=>{
                    return {
                        message: 'relationship is required'
                    };
                }
            }),
            // country: z.string().min(1,{ message: t('common.requiredFieldCountry') }),
            email: _v3.string().min(1, {
                message: t('common.requiredFieldEmail')
            }).email({
                message: t('common.invalidFormatEmail')
            }).refine((val)=>!val.endsWith('@hear.com'), {
                // Custom domain validation
                message: t('common.invalidEmailDomain') // Custom error message
            }),
            socialSecurityNumber: _v3.string().min(1, {
                message: t('common.requiredFieldSSN')
            }).refine((val)=>{
                const regex = getSocialSecurityNumberRegex();
                return regex.test(val);
            }, {
                message: t('common.invalidFormatSSN')
            }),
            phone: _v3.string().min(1, {
                message: t('common.requiredFieldPhone')
            }).regex(/^\d{10}$/, {
                message: 'Please provide a valid phone number with 10 digits'
            }),
            dateOfBirth: _v3.any().refine(validateISODateFormat, {
                message: t('common.invalidDateFormat')
            }),
            annualIncome: _v3.string().transform(parseInt).refine((val)=>val >= 1, {
                message: t('common.requiredFieldAnnualIncome')
            }),
            terms: _v3.boolean().refine((val)=>val, {
                message: t('common.requiredFieldTerms')
            })
        });
    }, [
        t
    ]);
    const form = (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema)
    });
    // Validate the address field as the user types (other fields validate on submit)
    (0, _reactDefault.default).useEffect(()=>{
        const subscription = form.watch((_value, { name })=>{
            if (name === 'address') form.trigger('address');
        });
        return ()=>subscription.unsubscribe();
    }, [
        form
    ]);
    return form;
};
exports.default = useCreateApplicationForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","date-fns":[["isValid","jCEss","default"],["parseISO","3xgI2","default"]],"react-hook-form":"53GLT","Modules/financing/config/relationTypes":"aeCnv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aeCnv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "relationTypes", ()=>relationTypes);
const relationTypes = [
    {
        value: '',
        label: '--',
        disabled: true
    },
    {
        value: 'SELF',
        label: 'Self'
    },
    {
        value: 'SPOUSE',
        label: 'Spouse'
    },
    {
        value: 'PARENT',
        label: 'Parent'
    },
    {
        value: 'SIBLING',
        label: 'Sibling'
    },
    {
        value: 'CHILD',
        label: 'Child'
    },
    {
        value: 'OTHER',
        label: 'Other'
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"b3AYG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCreateApplication);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _reactI18Next = require("react-i18next");
var _logger = require("Core/utils/logger");
var _utils = require("Core/utils/utils");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function transformPayload({ firstName, lastName, address, city, state, zip, email, phone: number, socialSecurityNumber, dateOfBirth, annualIncome, customer_id, external_reference_id, purpose, provider, payment_option, relationship }) {
    return {
        payment_id: (0, _utils.getUrlParam)('payment-id'),
        external_reference_id,
        purpose,
        payment_option,
        provider,
        payload: {
            customer_id,
            first_name: firstName,
            middle_name: '',
            last_name: lastName,
            email,
            date_of_birth: dateOfBirth,
            customer_identity_number: socialSecurityNumber,
            monthly_income: Math.floor(annualIncome / 12),
            relationship,
            address_line: address,
            city,
            state,
            zip,
            phone_number: number,
            phone_type: 'mobile',
            agree_to_terms: true,
            authorized_representative: ''
        }
    };
}
function useCreateApplication() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>(0, _platformApi.postWithHeaders)(`/financing/application`, transformPayload({
            ...payload,
            customer_id: paymentInfo.customer_id,
            external_reference_id: paymentInfo.external_reference_id,
            purpose: paymentInfo.purpose,
            provider: paymentInfo.provider,
            payment_option: paymentInfo.payment_option
        })), {
        throwOnError: true,
        retry: 2,
        enabled: Boolean(paymentInfo),
        onSuccess (data) {
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                status: 'success'
            });
            clearAlert();
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            return data;
        },
        onError (error) {
            setErrorAlert(t('status.error.createApplicationRequestFailed') + `(${error?.response?.data?.message})`);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","react-i18next":"244ua","Core/utils/logger":"cWDKQ","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iLVvV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetCustomerInfo);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _routes = require("Core/routes");
var _reactLocation = require("react-location");
function useGetCustomerInfo() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).financingCustomerInfo
    ], ()=>(0, _platformApi.get)(`/customer/search`), {
        onError (e) {
            if (e?.response?.status !== 404) {
                const message = e?.response?.data?.message ? ` - ${e?.response?.data?.message}` : '';
                setError(t('status.error.getFinancingApplicationFailed') + message);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        },
        retry: 1
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/error":"38MVH","Core/routes":"iddMu","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bc0DL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetApplication);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _routes = require("Core/routes");
var _reactLocation = require("react-location");
var _logger = require("Core/utils/logger");
const DATA_NOT_READY = 'Data not ready';
function useGetApplication(requestId, refetchInterval = false) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).financingPlatformApplication,
        requestId
    ], async ()=>{
        const data = await (0, _platformApi.get)(`/application`, {
            headers: {
                request_id: requestId
            }
        });
        if (!data?.next_action) throw new Error(DATA_NOT_READY);
        return data;
    }, {
        enabled: Boolean(requestId),
        retry: (failureCount, error)=>{
            if (error.message === DATA_NOT_READY) return failureCount < 30;
            return false;
        },
        retryDelay: 3000,
        refetchInterval,
        staleTime: 0,
        cacheTime: 300000,
        onError (e) {
            if (e.message === DATA_NOT_READY) {
                setErrorAlert(t('status.error.getFinancingApplicationFailed'));
                return;
            }
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                action: (0, _logger.actions).createApplicationTimeout
            });
            const message = e?.message ? ` - ${e?.message}` : '';
            setError(t('status.error.getFinancingApplicationFailed') + message);
            navigate({
                to: (0, _routes.errorPath),
                search: true
            });
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","Core/stores/error":"38MVH","Core/routes":"iddMu","react-location":"8hNco","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1emil":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FaZhihu", ()=>FaZhihu);
parcelHelpers.export(exports, "FaYoutube", ()=>FaYoutube);
parcelHelpers.export(exports, "FaYoast", ()=>FaYoast);
parcelHelpers.export(exports, "FaYelp", ()=>FaYelp);
parcelHelpers.export(exports, "FaYarn", ()=>FaYarn);
parcelHelpers.export(exports, "FaYandex", ()=>FaYandex);
parcelHelpers.export(exports, "FaYandexInternational", ()=>FaYandexInternational);
parcelHelpers.export(exports, "FaYammer", ()=>FaYammer);
parcelHelpers.export(exports, "FaYahoo", ()=>FaYahoo);
parcelHelpers.export(exports, "FaYCombinator", ()=>FaYCombinator);
parcelHelpers.export(exports, "FaXing", ()=>FaXing);
parcelHelpers.export(exports, "FaXbox", ()=>FaXbox);
parcelHelpers.export(exports, "FaXTwitter", ()=>FaXTwitter);
parcelHelpers.export(exports, "FaWpressr", ()=>FaWpressr);
parcelHelpers.export(exports, "FaWpforms", ()=>FaWpforms);
parcelHelpers.export(exports, "FaWpexplorer", ()=>FaWpexplorer);
parcelHelpers.export(exports, "FaWpbeginner", ()=>FaWpbeginner);
parcelHelpers.export(exports, "FaWordpress", ()=>FaWordpress);
parcelHelpers.export(exports, "FaWordpressSimple", ()=>FaWordpressSimple);
parcelHelpers.export(exports, "FaWolfPackBattalion", ()=>FaWolfPackBattalion);
parcelHelpers.export(exports, "FaWodu", ()=>FaWodu);
parcelHelpers.export(exports, "FaWizardsOfTheCoast", ()=>FaWizardsOfTheCoast);
parcelHelpers.export(exports, "FaWix", ()=>FaWix);
parcelHelpers.export(exports, "FaWirsindhandwerk", ()=>FaWirsindhandwerk);
parcelHelpers.export(exports, "FaWindows", ()=>FaWindows);
parcelHelpers.export(exports, "FaWikipediaW", ()=>FaWikipediaW);
parcelHelpers.export(exports, "FaWhmcs", ()=>FaWhmcs);
parcelHelpers.export(exports, "FaWhatsapp", ()=>FaWhatsapp);
parcelHelpers.export(exports, "FaWeixin", ()=>FaWeixin);
parcelHelpers.export(exports, "FaWeibo", ()=>FaWeibo);
parcelHelpers.export(exports, "FaWeebly", ()=>FaWeebly);
parcelHelpers.export(exports, "FaWebflow", ()=>FaWebflow);
parcelHelpers.export(exports, "FaWebAwesome", ()=>FaWebAwesome);
parcelHelpers.export(exports, "FaWaze", ()=>FaWaze);
parcelHelpers.export(exports, "FaWatchmanMonitoring", ()=>FaWatchmanMonitoring);
parcelHelpers.export(exports, "FaVuejs", ()=>FaVuejs);
parcelHelpers.export(exports, "FaVnv", ()=>FaVnv);
parcelHelpers.export(exports, "FaVk", ()=>FaVk);
parcelHelpers.export(exports, "FaVine", ()=>FaVine);
parcelHelpers.export(exports, "FaVimeo", ()=>FaVimeo);
parcelHelpers.export(exports, "FaVimeoV", ()=>FaVimeoV);
parcelHelpers.export(exports, "FaViber", ()=>FaViber);
parcelHelpers.export(exports, "FaViadeo", ()=>FaViadeo);
parcelHelpers.export(exports, "FaViacoin", ()=>FaViacoin);
parcelHelpers.export(exports, "FaVaadin", ()=>FaVaadin);
parcelHelpers.export(exports, "FaUssunnah", ()=>FaUssunnah);
parcelHelpers.export(exports, "FaUsps", ()=>FaUsps);
parcelHelpers.export(exports, "FaUsb", ()=>FaUsb);
parcelHelpers.export(exports, "FaUpwork", ()=>FaUpwork);
parcelHelpers.export(exports, "FaUps", ()=>FaUps);
parcelHelpers.export(exports, "FaUntappd", ()=>FaUntappd);
parcelHelpers.export(exports, "FaUnsplash", ()=>FaUnsplash);
parcelHelpers.export(exports, "FaUnity", ()=>FaUnity);
parcelHelpers.export(exports, "FaUniregistry", ()=>FaUniregistry);
parcelHelpers.export(exports, "FaUncharted", ()=>FaUncharted);
parcelHelpers.export(exports, "FaUmbraco", ()=>FaUmbraco);
parcelHelpers.export(exports, "FaUikit", ()=>FaUikit);
parcelHelpers.export(exports, "FaUbuntu", ()=>FaUbuntu);
parcelHelpers.export(exports, "FaUber", ()=>FaUber);
parcelHelpers.export(exports, "FaTypo3", ()=>FaTypo3);
parcelHelpers.export(exports, "FaTwitter", ()=>FaTwitter);
parcelHelpers.export(exports, "FaTwitch", ()=>FaTwitch);
parcelHelpers.export(exports, "FaTumblr", ()=>FaTumblr);
parcelHelpers.export(exports, "FaTrello", ()=>FaTrello);
parcelHelpers.export(exports, "FaTradeFederation", ()=>FaTradeFederation);
parcelHelpers.export(exports, "FaTiktok", ()=>FaTiktok);
parcelHelpers.export(exports, "FaThreads", ()=>FaThreads);
parcelHelpers.export(exports, "FaThinkPeaks", ()=>FaThinkPeaks);
parcelHelpers.export(exports, "FaThemeisle", ()=>FaThemeisle);
parcelHelpers.export(exports, "FaThemeco", ()=>FaThemeco);
parcelHelpers.export(exports, "FaTheRedYeti", ()=>FaTheRedYeti);
parcelHelpers.export(exports, "FaTencentWeibo", ()=>FaTencentWeibo);
parcelHelpers.export(exports, "FaTelegram", ()=>FaTelegram);
parcelHelpers.export(exports, "FaTeamspeak", ()=>FaTeamspeak);
parcelHelpers.export(exports, "FaSymfony", ()=>FaSymfony);
parcelHelpers.export(exports, "FaSwift", ()=>FaSwift);
parcelHelpers.export(exports, "FaSuse", ()=>FaSuse);
parcelHelpers.export(exports, "FaSupple", ()=>FaSupple);
parcelHelpers.export(exports, "FaSuperpowers", ()=>FaSuperpowers);
parcelHelpers.export(exports, "FaStumbleupon", ()=>FaStumbleupon);
parcelHelpers.export(exports, "FaStumbleuponCircle", ()=>FaStumbleuponCircle);
parcelHelpers.export(exports, "FaStudiovinari", ()=>FaStudiovinari);
parcelHelpers.export(exports, "FaStubber", ()=>FaStubber);
parcelHelpers.export(exports, "FaStripe", ()=>FaStripe);
parcelHelpers.export(exports, "FaStripeS", ()=>FaStripeS);
parcelHelpers.export(exports, "FaStrava", ()=>FaStrava);
parcelHelpers.export(exports, "FaStickerMule", ()=>FaStickerMule);
parcelHelpers.export(exports, "FaSteam", ()=>FaSteam);
parcelHelpers.export(exports, "FaSteamSymbol", ()=>FaSteamSymbol);
parcelHelpers.export(exports, "FaStaylinked", ()=>FaStaylinked);
parcelHelpers.export(exports, "FaStackpath", ()=>FaStackpath);
parcelHelpers.export(exports, "FaStackOverflow", ()=>FaStackOverflow);
parcelHelpers.export(exports, "FaStackExchange", ()=>FaStackExchange);
parcelHelpers.export(exports, "FaSquarespace", ()=>FaSquarespace);
parcelHelpers.export(exports, "FaSquareYoutube", ()=>FaSquareYoutube);
parcelHelpers.export(exports, "FaSquareXing", ()=>FaSquareXing);
parcelHelpers.export(exports, "FaSquareXTwitter", ()=>FaSquareXTwitter);
parcelHelpers.export(exports, "FaSquareWhatsapp", ()=>FaSquareWhatsapp);
parcelHelpers.export(exports, "FaSquareWebAwesome", ()=>FaSquareWebAwesome);
parcelHelpers.export(exports, "FaSquareWebAwesomeStroke", ()=>FaSquareWebAwesomeStroke);
parcelHelpers.export(exports, "FaSquareVimeo", ()=>FaSquareVimeo);
parcelHelpers.export(exports, "FaSquareViadeo", ()=>FaSquareViadeo);
parcelHelpers.export(exports, "FaSquareUpwork", ()=>FaSquareUpwork);
parcelHelpers.export(exports, "FaSquareTwitter", ()=>FaSquareTwitter);
parcelHelpers.export(exports, "FaSquareTumblr", ()=>FaSquareTumblr);
parcelHelpers.export(exports, "FaSquareThreads", ()=>FaSquareThreads);
parcelHelpers.export(exports, "FaSquareSteam", ()=>FaSquareSteam);
parcelHelpers.export(exports, "FaSquareSnapchat", ()=>FaSquareSnapchat);
parcelHelpers.export(exports, "FaSquareReddit", ()=>FaSquareReddit);
parcelHelpers.export(exports, "FaSquarePinterest", ()=>FaSquarePinterest);
parcelHelpers.export(exports, "FaSquarePiedPiper", ()=>FaSquarePiedPiper);
parcelHelpers.export(exports, "FaSquareOdnoklassniki", ()=>FaSquareOdnoklassniki);
parcelHelpers.export(exports, "FaSquareLetterboxd", ()=>FaSquareLetterboxd);
parcelHelpers.export(exports, "FaSquareLastfm", ()=>FaSquareLastfm);
parcelHelpers.export(exports, "FaSquareJs", ()=>FaSquareJs);
parcelHelpers.export(exports, "FaSquareInstagram", ()=>FaSquareInstagram);
parcelHelpers.export(exports, "FaSquareHackerNews", ()=>FaSquareHackerNews);
parcelHelpers.export(exports, "FaSquareGooglePlus", ()=>FaSquareGooglePlus);
parcelHelpers.export(exports, "FaSquareGitlab", ()=>FaSquareGitlab);
parcelHelpers.export(exports, "FaSquareGithub", ()=>FaSquareGithub);
parcelHelpers.export(exports, "FaSquareGit", ()=>FaSquareGit);
parcelHelpers.export(exports, "FaSquareFontAwesome", ()=>FaSquareFontAwesome);
parcelHelpers.export(exports, "FaSquareFontAwesomeStroke", ()=>FaSquareFontAwesomeStroke);
parcelHelpers.export(exports, "FaSquareFacebook", ()=>FaSquareFacebook);
parcelHelpers.export(exports, "FaSquareDribbble", ()=>FaSquareDribbble);
parcelHelpers.export(exports, "FaSquareBluesky", ()=>FaSquareBluesky);
parcelHelpers.export(exports, "FaSquareBehance", ()=>FaSquareBehance);
parcelHelpers.export(exports, "FaSpotify", ()=>FaSpotify);
parcelHelpers.export(exports, "FaSpeakerDeck", ()=>FaSpeakerDeck);
parcelHelpers.export(exports, "FaSpeakap", ()=>FaSpeakap);
parcelHelpers.export(exports, "FaSpaceAwesome", ()=>FaSpaceAwesome);
parcelHelpers.export(exports, "FaSourcetree", ()=>FaSourcetree);
parcelHelpers.export(exports, "FaSoundcloud", ()=>FaSoundcloud);
parcelHelpers.export(exports, "FaSnapchat", ()=>FaSnapchat);
parcelHelpers.export(exports, "FaSlideshare", ()=>FaSlideshare);
parcelHelpers.export(exports, "FaSlack", ()=>FaSlack);
parcelHelpers.export(exports, "FaSkype", ()=>FaSkype);
parcelHelpers.export(exports, "FaSkyatlas", ()=>FaSkyatlas);
parcelHelpers.export(exports, "FaSketch", ()=>FaSketch);
parcelHelpers.export(exports, "FaSitrox", ()=>FaSitrox);
parcelHelpers.export(exports, "FaSith", ()=>FaSith);
parcelHelpers.export(exports, "FaSistrix", ()=>FaSistrix);
parcelHelpers.export(exports, "FaSimplybuilt", ()=>FaSimplybuilt);
parcelHelpers.export(exports, "FaSignalMessenger", ()=>FaSignalMessenger);
parcelHelpers.export(exports, "FaShopware", ()=>FaShopware);
parcelHelpers.export(exports, "FaShopify", ()=>FaShopify);
parcelHelpers.export(exports, "FaShoelace", ()=>FaShoelace);
parcelHelpers.export(exports, "FaShirtsinbulk", ()=>FaShirtsinbulk);
parcelHelpers.export(exports, "FaServicestack", ()=>FaServicestack);
parcelHelpers.export(exports, "FaSellsy", ()=>FaSellsy);
parcelHelpers.export(exports, "FaSellcast", ()=>FaSellcast);
parcelHelpers.export(exports, "FaSearchengin", ()=>FaSearchengin);
parcelHelpers.export(exports, "FaScribd", ()=>FaScribd);
parcelHelpers.export(exports, "FaScreenpal", ()=>FaScreenpal);
parcelHelpers.export(exports, "FaSchlix", ()=>FaSchlix);
parcelHelpers.export(exports, "FaSass", ()=>FaSass);
parcelHelpers.export(exports, "FaSalesforce", ()=>FaSalesforce);
parcelHelpers.export(exports, "FaSafari", ()=>FaSafari);
parcelHelpers.export(exports, "FaRust", ()=>FaRust);
parcelHelpers.export(exports, "FaRockrms", ()=>FaRockrms);
parcelHelpers.export(exports, "FaRocketchat", ()=>FaRocketchat);
parcelHelpers.export(exports, "FaRev", ()=>FaRev);
parcelHelpers.export(exports, "FaResolving", ()=>FaResolving);
parcelHelpers.export(exports, "FaResearchgate", ()=>FaResearchgate);
parcelHelpers.export(exports, "FaReplyd", ()=>FaReplyd);
parcelHelpers.export(exports, "FaRenren", ()=>FaRenren);
parcelHelpers.export(exports, "FaRedhat", ()=>FaRedhat);
parcelHelpers.export(exports, "FaReddit", ()=>FaReddit);
parcelHelpers.export(exports, "FaRedditAlien", ()=>FaRedditAlien);
parcelHelpers.export(exports, "FaRedRiver", ()=>FaRedRiver);
parcelHelpers.export(exports, "FaRebel", ()=>FaRebel);
parcelHelpers.export(exports, "FaReadme", ()=>FaReadme);
parcelHelpers.export(exports, "FaReacteurope", ()=>FaReacteurope);
parcelHelpers.export(exports, "FaReact", ()=>FaReact);
parcelHelpers.export(exports, "FaRavelry", ()=>FaRavelry);
parcelHelpers.export(exports, "FaRaspberryPi", ()=>FaRaspberryPi);
parcelHelpers.export(exports, "FaRProject", ()=>FaRProject);
parcelHelpers.export(exports, "FaQuora", ()=>FaQuora);
parcelHelpers.export(exports, "FaQuinscape", ()=>FaQuinscape);
parcelHelpers.export(exports, "FaQq", ()=>FaQq);
parcelHelpers.export(exports, "FaPython", ()=>FaPython);
parcelHelpers.export(exports, "FaPushed", ()=>FaPushed);
parcelHelpers.export(exports, "FaProductHunt", ()=>FaProductHunt);
parcelHelpers.export(exports, "FaPlaystation", ()=>FaPlaystation);
parcelHelpers.export(exports, "FaPixiv", ()=>FaPixiv);
parcelHelpers.export(exports, "FaPix", ()=>FaPix);
parcelHelpers.export(exports, "FaPinterest", ()=>FaPinterest);
parcelHelpers.export(exports, "FaPinterestP", ()=>FaPinterestP);
parcelHelpers.export(exports, "FaPiedPiper", ()=>FaPiedPiper);
parcelHelpers.export(exports, "FaPiedPiperPp", ()=>FaPiedPiperPp);
parcelHelpers.export(exports, "FaPiedPiperHat", ()=>FaPiedPiperHat);
parcelHelpers.export(exports, "FaPiedPiperAlt", ()=>FaPiedPiperAlt);
parcelHelpers.export(exports, "FaPhp", ()=>FaPhp);
parcelHelpers.export(exports, "FaPhoenixSquadron", ()=>FaPhoenixSquadron);
parcelHelpers.export(exports, "FaPhoenixFramework", ()=>FaPhoenixFramework);
parcelHelpers.export(exports, "FaPhabricator", ()=>FaPhabricator);
parcelHelpers.export(exports, "FaPeriscope", ()=>FaPeriscope);
parcelHelpers.export(exports, "FaPerbyte", ()=>FaPerbyte);
parcelHelpers.export(exports, "FaPaypal", ()=>FaPaypal);
parcelHelpers.export(exports, "FaPatreon", ()=>FaPatreon);
parcelHelpers.export(exports, "FaPalfed", ()=>FaPalfed);
parcelHelpers.export(exports, "FaPagelines", ()=>FaPagelines);
parcelHelpers.export(exports, "FaPage4", ()=>FaPage4);
parcelHelpers.export(exports, "FaPadlet", ()=>FaPadlet);
parcelHelpers.export(exports, "FaOsi", ()=>FaOsi);
parcelHelpers.export(exports, "FaOrcid", ()=>FaOrcid);
parcelHelpers.export(exports, "FaOptinMonster", ()=>FaOptinMonster);
parcelHelpers.export(exports, "FaOpera", ()=>FaOpera);
parcelHelpers.export(exports, "FaOpensuse", ()=>FaOpensuse);
parcelHelpers.export(exports, "FaOpenid", ()=>FaOpenid);
parcelHelpers.export(exports, "FaOpencart", ()=>FaOpencart);
parcelHelpers.export(exports, "FaOldRepublic", ()=>FaOldRepublic);
parcelHelpers.export(exports, "FaOdysee", ()=>FaOdysee);
parcelHelpers.export(exports, "FaOdnoklassniki", ()=>FaOdnoklassniki);
parcelHelpers.export(exports, "FaOctopusDeploy", ()=>FaOctopusDeploy);
parcelHelpers.export(exports, "FaNutritionix", ()=>FaNutritionix);
parcelHelpers.export(exports, "FaNs8", ()=>FaNs8);
parcelHelpers.export(exports, "FaNpm", ()=>FaNpm);
parcelHelpers.export(exports, "FaNode", ()=>FaNode);
parcelHelpers.export(exports, "FaNodeJs", ()=>FaNodeJs);
parcelHelpers.export(exports, "FaNimblr", ()=>FaNimblr);
parcelHelpers.export(exports, "FaNfcSymbol", ()=>FaNfcSymbol);
parcelHelpers.export(exports, "FaNfcDirectional", ()=>FaNfcDirectional);
parcelHelpers.export(exports, "FaNeos", ()=>FaNeos);
parcelHelpers.export(exports, "FaNapster", ()=>FaNapster);
parcelHelpers.export(exports, "FaMonero", ()=>FaMonero);
parcelHelpers.export(exports, "FaModx", ()=>FaModx);
parcelHelpers.export(exports, "FaMizuni", ()=>FaMizuni);
parcelHelpers.export(exports, "FaMixer", ()=>FaMixer);
parcelHelpers.export(exports, "FaMixcloud", ()=>FaMixcloud);
parcelHelpers.export(exports, "FaMix", ()=>FaMix);
parcelHelpers.export(exports, "FaMintbit", ()=>FaMintbit);
parcelHelpers.export(exports, "FaMicrosoft", ()=>FaMicrosoft);
parcelHelpers.export(exports, "FaMicroblog", ()=>FaMicroblog);
parcelHelpers.export(exports, "FaMeta", ()=>FaMeta);
parcelHelpers.export(exports, "FaMendeley", ()=>FaMendeley);
parcelHelpers.export(exports, "FaMegaport", ()=>FaMegaport);
parcelHelpers.export(exports, "FaMeetup", ()=>FaMeetup);
parcelHelpers.export(exports, "FaMedrt", ()=>FaMedrt);
parcelHelpers.export(exports, "FaMedium", ()=>FaMedium);
parcelHelpers.export(exports, "FaMedapps", ()=>FaMedapps);
parcelHelpers.export(exports, "FaMdb", ()=>FaMdb);
parcelHelpers.export(exports, "FaMaxcdn", ()=>FaMaxcdn);
parcelHelpers.export(exports, "FaMastodon", ()=>FaMastodon);
parcelHelpers.export(exports, "FaMarkdown", ()=>FaMarkdown);
parcelHelpers.export(exports, "FaMandalorian", ()=>FaMandalorian);
parcelHelpers.export(exports, "FaMailchimp", ()=>FaMailchimp);
parcelHelpers.export(exports, "FaMagento", ()=>FaMagento);
parcelHelpers.export(exports, "FaLyft", ()=>FaLyft);
parcelHelpers.export(exports, "FaLinux", ()=>FaLinux);
parcelHelpers.export(exports, "FaLinode", ()=>FaLinode);
parcelHelpers.export(exports, "FaLinkedin", ()=>FaLinkedin);
parcelHelpers.export(exports, "FaLinkedinIn", ()=>FaLinkedinIn);
parcelHelpers.export(exports, "FaLine", ()=>FaLine);
parcelHelpers.export(exports, "FaLetterboxd", ()=>FaLetterboxd);
parcelHelpers.export(exports, "FaLess", ()=>FaLess);
parcelHelpers.export(exports, "FaLeanpub", ()=>FaLeanpub);
parcelHelpers.export(exports, "FaLastfm", ()=>FaLastfm);
parcelHelpers.export(exports, "FaLaravel", ()=>FaLaravel);
parcelHelpers.export(exports, "FaKorvue", ()=>FaKorvue);
parcelHelpers.export(exports, "FaKickstarter", ()=>FaKickstarter);
parcelHelpers.export(exports, "FaKickstarterK", ()=>FaKickstarterK);
parcelHelpers.export(exports, "FaKeycdn", ()=>FaKeycdn);
parcelHelpers.export(exports, "FaKeybase", ()=>FaKeybase);
parcelHelpers.export(exports, "FaKaggle", ()=>FaKaggle);
parcelHelpers.export(exports, "FaJxl", ()=>FaJxl);
parcelHelpers.export(exports, "FaJsfiddle", ()=>FaJsfiddle);
parcelHelpers.export(exports, "FaJs", ()=>FaJs);
parcelHelpers.export(exports, "FaJoomla", ()=>FaJoomla);
parcelHelpers.export(exports, "FaJoget", ()=>FaJoget);
parcelHelpers.export(exports, "FaJira", ()=>FaJira);
parcelHelpers.export(exports, "FaJenkins", ()=>FaJenkins);
parcelHelpers.export(exports, "FaJediOrder", ()=>FaJediOrder);
parcelHelpers.export(exports, "FaJava", ()=>FaJava);
parcelHelpers.export(exports, "FaItunes", ()=>FaItunes);
parcelHelpers.export(exports, "FaItunesNote", ()=>FaItunesNote);
parcelHelpers.export(exports, "FaItchIo", ()=>FaItchIo);
parcelHelpers.export(exports, "FaIoxhost", ()=>FaIoxhost);
parcelHelpers.export(exports, "FaInvision", ()=>FaInvision);
parcelHelpers.export(exports, "FaInternetExplorer", ()=>FaInternetExplorer);
parcelHelpers.export(exports, "FaIntercom", ()=>FaIntercom);
parcelHelpers.export(exports, "FaInstalod", ()=>FaInstalod);
parcelHelpers.export(exports, "FaInstagram", ()=>FaInstagram);
parcelHelpers.export(exports, "FaImdb", ()=>FaImdb);
parcelHelpers.export(exports, "FaIdeal", ()=>FaIdeal);
parcelHelpers.export(exports, "FaHubspot", ()=>FaHubspot);
parcelHelpers.export(exports, "FaHtml5", ()=>FaHtml5);
parcelHelpers.export(exports, "FaHouzz", ()=>FaHouzz);
parcelHelpers.export(exports, "FaHotjar", ()=>FaHotjar);
parcelHelpers.export(exports, "FaHornbill", ()=>FaHornbill);
parcelHelpers.export(exports, "FaHooli", ()=>FaHooli);
parcelHelpers.export(exports, "FaHive", ()=>FaHive);
parcelHelpers.export(exports, "FaHireAHelper", ()=>FaHireAHelper);
parcelHelpers.export(exports, "FaHips", ()=>FaHips);
parcelHelpers.export(exports, "FaHashnode", ()=>FaHashnode);
parcelHelpers.export(exports, "FaHackerrank", ()=>FaHackerrank);
parcelHelpers.export(exports, "FaHackerNews", ()=>FaHackerNews);
parcelHelpers.export(exports, "FaGulp", ()=>FaGulp);
parcelHelpers.export(exports, "FaGuilded", ()=>FaGuilded);
parcelHelpers.export(exports, "FaGrunt", ()=>FaGrunt);
parcelHelpers.export(exports, "FaGripfire", ()=>FaGripfire);
parcelHelpers.export(exports, "FaGrav", ()=>FaGrav);
parcelHelpers.export(exports, "FaGratipay", ()=>FaGratipay);
parcelHelpers.export(exports, "FaGoogle", ()=>FaGoogle);
parcelHelpers.export(exports, "FaGoogleWallet", ()=>FaGoogleWallet);
parcelHelpers.export(exports, "FaGoogleScholar", ()=>FaGoogleScholar);
parcelHelpers.export(exports, "FaGooglePlus", ()=>FaGooglePlus);
parcelHelpers.export(exports, "FaGooglePlusG", ()=>FaGooglePlusG);
parcelHelpers.export(exports, "FaGooglePlay", ()=>FaGooglePlay);
parcelHelpers.export(exports, "FaGooglePay", ()=>FaGooglePay);
parcelHelpers.export(exports, "FaGoogleDrive", ()=>FaGoogleDrive);
parcelHelpers.export(exports, "FaGoodreads", ()=>FaGoodreads);
parcelHelpers.export(exports, "FaGoodreadsG", ()=>FaGoodreadsG);
parcelHelpers.export(exports, "FaGolang", ()=>FaGolang);
parcelHelpers.export(exports, "FaGofore", ()=>FaGofore);
parcelHelpers.export(exports, "FaGlide", ()=>FaGlide);
parcelHelpers.export(exports, "FaGlideG", ()=>FaGlideG);
parcelHelpers.export(exports, "FaGitter", ()=>FaGitter);
parcelHelpers.export(exports, "FaGitlab", ()=>FaGitlab);
parcelHelpers.export(exports, "FaGitkraken", ()=>FaGitkraken);
parcelHelpers.export(exports, "FaGithub", ()=>FaGithub);
parcelHelpers.export(exports, "FaGithubAlt", ()=>FaGithubAlt);
parcelHelpers.export(exports, "FaGit", ()=>FaGit);
parcelHelpers.export(exports, "FaGitAlt", ()=>FaGitAlt);
parcelHelpers.export(exports, "FaGg", ()=>FaGg);
parcelHelpers.export(exports, "FaGgCircle", ()=>FaGgCircle);
parcelHelpers.export(exports, "FaGetPocket", ()=>FaGetPocket);
parcelHelpers.export(exports, "FaGalacticSenate", ()=>FaGalacticSenate);
parcelHelpers.export(exports, "FaGalacticRepublic", ()=>FaGalacticRepublic);
parcelHelpers.export(exports, "FaFulcrum", ()=>FaFulcrum);
parcelHelpers.export(exports, "FaFreebsd", ()=>FaFreebsd);
parcelHelpers.export(exports, "FaFreeCodeCamp", ()=>FaFreeCodeCamp);
parcelHelpers.export(exports, "FaFoursquare", ()=>FaFoursquare);
parcelHelpers.export(exports, "FaForumbee", ()=>FaForumbee);
parcelHelpers.export(exports, "FaFortAwesome", ()=>FaFortAwesome);
parcelHelpers.export(exports, "FaFortAwesomeAlt", ()=>FaFortAwesomeAlt);
parcelHelpers.export(exports, "FaFonticons", ()=>FaFonticons);
parcelHelpers.export(exports, "FaFonticonsFi", ()=>FaFonticonsFi);
parcelHelpers.export(exports, "FaFontAwesome", ()=>FaFontAwesome);
parcelHelpers.export(exports, "FaFly", ()=>FaFly);
parcelHelpers.export(exports, "FaFlutter", ()=>FaFlutter);
parcelHelpers.export(exports, "FaFlipboard", ()=>FaFlipboard);
parcelHelpers.export(exports, "FaFlickr", ()=>FaFlickr);
parcelHelpers.export(exports, "FaFirstdraft", ()=>FaFirstdraft);
parcelHelpers.export(exports, "FaFirstOrder", ()=>FaFirstOrder);
parcelHelpers.export(exports, "FaFirstOrderAlt", ()=>FaFirstOrderAlt);
parcelHelpers.export(exports, "FaFirefox", ()=>FaFirefox);
parcelHelpers.export(exports, "FaFirefoxBrowser", ()=>FaFirefoxBrowser);
parcelHelpers.export(exports, "FaFilesPinwheel", ()=>FaFilesPinwheel);
parcelHelpers.export(exports, "FaFigma", ()=>FaFigma);
parcelHelpers.export(exports, "FaFedora", ()=>FaFedora);
parcelHelpers.export(exports, "FaFedex", ()=>FaFedex);
parcelHelpers.export(exports, "FaFantasyFlightGames", ()=>FaFantasyFlightGames);
parcelHelpers.export(exports, "FaFacebook", ()=>FaFacebook);
parcelHelpers.export(exports, "FaFacebookMessenger", ()=>FaFacebookMessenger);
parcelHelpers.export(exports, "FaFacebookF", ()=>FaFacebookF);
parcelHelpers.export(exports, "FaExpeditedssl", ()=>FaExpeditedssl);
parcelHelpers.export(exports, "FaEvernote", ()=>FaEvernote);
parcelHelpers.export(exports, "FaEtsy", ()=>FaEtsy);
parcelHelpers.export(exports, "FaEthereum", ()=>FaEthereum);
parcelHelpers.export(exports, "FaErlang", ()=>FaErlang);
parcelHelpers.export(exports, "FaEnvira", ()=>FaEnvira);
parcelHelpers.export(exports, "FaEmpire", ()=>FaEmpire);
parcelHelpers.export(exports, "FaEmber", ()=>FaEmber);
parcelHelpers.export(exports, "FaEllo", ()=>FaEllo);
parcelHelpers.export(exports, "FaElementor", ()=>FaElementor);
parcelHelpers.export(exports, "FaEdge", ()=>FaEdge);
parcelHelpers.export(exports, "FaEdgeLegacy", ()=>FaEdgeLegacy);
parcelHelpers.export(exports, "FaEbay", ()=>FaEbay);
parcelHelpers.export(exports, "FaEarlybirds", ()=>FaEarlybirds);
parcelHelpers.export(exports, "FaDyalog", ()=>FaDyalog);
parcelHelpers.export(exports, "FaDrupal", ()=>FaDrupal);
parcelHelpers.export(exports, "FaDropbox", ()=>FaDropbox);
parcelHelpers.export(exports, "FaDribbble", ()=>FaDribbble);
parcelHelpers.export(exports, "FaDraft2Digital", ()=>FaDraft2Digital);
parcelHelpers.export(exports, "FaDocker", ()=>FaDocker);
parcelHelpers.export(exports, "FaDochub", ()=>FaDochub);
parcelHelpers.export(exports, "FaDiscourse", ()=>FaDiscourse);
parcelHelpers.export(exports, "FaDiscord", ()=>FaDiscord);
parcelHelpers.export(exports, "FaDigitalOcean", ()=>FaDigitalOcean);
parcelHelpers.export(exports, "FaDigg", ()=>FaDigg);
parcelHelpers.export(exports, "FaDiaspora", ()=>FaDiaspora);
parcelHelpers.export(exports, "FaDhl", ()=>FaDhl);
parcelHelpers.export(exports, "FaDeviantart", ()=>FaDeviantart);
parcelHelpers.export(exports, "FaDev", ()=>FaDev);
parcelHelpers.export(exports, "FaDeskpro", ()=>FaDeskpro);
parcelHelpers.export(exports, "FaDeploydog", ()=>FaDeploydog);
parcelHelpers.export(exports, "FaDelicious", ()=>FaDelicious);
parcelHelpers.export(exports, "FaDeezer", ()=>FaDeezer);
parcelHelpers.export(exports, "FaDebian", ()=>FaDebian);
parcelHelpers.export(exports, "FaDashcube", ()=>FaDashcube);
parcelHelpers.export(exports, "FaDartLang", ()=>FaDartLang);
parcelHelpers.export(exports, "FaDailymotion", ()=>FaDailymotion);
parcelHelpers.export(exports, "FaDAndD", ()=>FaDAndD);
parcelHelpers.export(exports, "FaDAndDBeyond", ()=>FaDAndDBeyond);
parcelHelpers.export(exports, "FaCuttlefish", ()=>FaCuttlefish);
parcelHelpers.export(exports, "FaCss3", ()=>FaCss3);
parcelHelpers.export(exports, "FaCss3Alt", ()=>FaCss3Alt);
parcelHelpers.export(exports, "FaCss", ()=>FaCss);
parcelHelpers.export(exports, "FaCriticalRole", ()=>FaCriticalRole);
parcelHelpers.export(exports, "FaCreativeCommons", ()=>FaCreativeCommons);
parcelHelpers.export(exports, "FaCreativeCommonsZero", ()=>FaCreativeCommonsZero);
parcelHelpers.export(exports, "FaCreativeCommonsShare", ()=>FaCreativeCommonsShare);
parcelHelpers.export(exports, "FaCreativeCommonsSampling", ()=>FaCreativeCommonsSampling);
parcelHelpers.export(exports, "FaCreativeCommonsSamplingPlus", ()=>FaCreativeCommonsSamplingPlus);
parcelHelpers.export(exports, "FaCreativeCommonsSa", ()=>FaCreativeCommonsSa);
parcelHelpers.export(exports, "FaCreativeCommonsRemix", ()=>FaCreativeCommonsRemix);
parcelHelpers.export(exports, "FaCreativeCommonsPd", ()=>FaCreativeCommonsPd);
parcelHelpers.export(exports, "FaCreativeCommonsPdAlt", ()=>FaCreativeCommonsPdAlt);
parcelHelpers.export(exports, "FaCreativeCommonsNd", ()=>FaCreativeCommonsNd);
parcelHelpers.export(exports, "FaCreativeCommonsNc", ()=>FaCreativeCommonsNc);
parcelHelpers.export(exports, "FaCreativeCommonsNcJp", ()=>FaCreativeCommonsNcJp);
parcelHelpers.export(exports, "FaCreativeCommonsNcEu", ()=>FaCreativeCommonsNcEu);
parcelHelpers.export(exports, "FaCreativeCommonsBy", ()=>FaCreativeCommonsBy);
parcelHelpers.export(exports, "FaCpanel", ()=>FaCpanel);
parcelHelpers.export(exports, "FaCottonBureau", ()=>FaCottonBureau);
parcelHelpers.export(exports, "FaContao", ()=>FaContao);
parcelHelpers.export(exports, "FaConnectdevelop", ()=>FaConnectdevelop);
parcelHelpers.export(exports, "FaConfluence", ()=>FaConfluence);
parcelHelpers.export(exports, "FaCodiepie", ()=>FaCodiepie);
parcelHelpers.export(exports, "FaCodepen", ()=>FaCodepen);
parcelHelpers.export(exports, "FaCmplid", ()=>FaCmplid);
parcelHelpers.export(exports, "FaCloudversify", ()=>FaCloudversify);
parcelHelpers.export(exports, "FaCloudsmith", ()=>FaCloudsmith);
parcelHelpers.export(exports, "FaCloudscale", ()=>FaCloudscale);
parcelHelpers.export(exports, "FaCloudflare", ()=>FaCloudflare);
parcelHelpers.export(exports, "FaChromecast", ()=>FaChromecast);
parcelHelpers.export(exports, "FaChrome", ()=>FaChrome);
parcelHelpers.export(exports, "FaCentos", ()=>FaCentos);
parcelHelpers.export(exports, "FaCentercode", ()=>FaCentercode);
parcelHelpers.export(exports, "FaCcVisa", ()=>FaCcVisa);
parcelHelpers.export(exports, "FaCcStripe", ()=>FaCcStripe);
parcelHelpers.export(exports, "FaCcPaypal", ()=>FaCcPaypal);
parcelHelpers.export(exports, "FaCcMastercard", ()=>FaCcMastercard);
parcelHelpers.export(exports, "FaCcJcb", ()=>FaCcJcb);
parcelHelpers.export(exports, "FaCcDiscover", ()=>FaCcDiscover);
parcelHelpers.export(exports, "FaCcDinersClub", ()=>FaCcDinersClub);
parcelHelpers.export(exports, "FaCcApplePay", ()=>FaCcApplePay);
parcelHelpers.export(exports, "FaCcAmex", ()=>FaCcAmex);
parcelHelpers.export(exports, "FaCcAmazonPay", ()=>FaCcAmazonPay);
parcelHelpers.export(exports, "FaCanadianMapleLeaf", ()=>FaCanadianMapleLeaf);
parcelHelpers.export(exports, "FaBuysellads", ()=>FaBuysellads);
parcelHelpers.export(exports, "FaBuyNLarge", ()=>FaBuyNLarge);
parcelHelpers.export(exports, "FaBuromobelexperte", ()=>FaBuromobelexperte);
parcelHelpers.export(exports, "FaBuffer", ()=>FaBuffer);
parcelHelpers.export(exports, "FaBtc", ()=>FaBtc);
parcelHelpers.export(exports, "FaBrave", ()=>FaBrave);
parcelHelpers.export(exports, "FaBraveReverse", ()=>FaBraveReverse);
parcelHelpers.export(exports, "FaBots", ()=>FaBots);
parcelHelpers.export(exports, "FaBootstrap", ()=>FaBootstrap);
parcelHelpers.export(exports, "FaBluetooth", ()=>FaBluetooth);
parcelHelpers.export(exports, "FaBluetoothB", ()=>FaBluetoothB);
parcelHelpers.export(exports, "FaBluesky", ()=>FaBluesky);
parcelHelpers.export(exports, "FaBlogger", ()=>FaBlogger);
parcelHelpers.export(exports, "FaBloggerB", ()=>FaBloggerB);
parcelHelpers.export(exports, "FaBlackberry", ()=>FaBlackberry);
parcelHelpers.export(exports, "FaBlackTie", ()=>FaBlackTie);
parcelHelpers.export(exports, "FaBity", ()=>FaBity);
parcelHelpers.export(exports, "FaBitcoin", ()=>FaBitcoin);
parcelHelpers.export(exports, "FaBitbucket", ()=>FaBitbucket);
parcelHelpers.export(exports, "FaBimobject", ()=>FaBimobject);
parcelHelpers.export(exports, "FaBilibili", ()=>FaBilibili);
parcelHelpers.export(exports, "FaBehance", ()=>FaBehance);
parcelHelpers.export(exports, "FaBattleNet", ()=>FaBattleNet);
parcelHelpers.export(exports, "FaBandcamp", ()=>FaBandcamp);
parcelHelpers.export(exports, "FaAws", ()=>FaAws);
parcelHelpers.export(exports, "FaAviato", ()=>FaAviato);
parcelHelpers.export(exports, "FaAvianex", ()=>FaAvianex);
parcelHelpers.export(exports, "FaAutoprefixer", ()=>FaAutoprefixer);
parcelHelpers.export(exports, "FaAudible", ()=>FaAudible);
parcelHelpers.export(exports, "FaAtlassian", ()=>FaAtlassian);
parcelHelpers.export(exports, "FaAsymmetrik", ()=>FaAsymmetrik);
parcelHelpers.export(exports, "FaArtstation", ()=>FaArtstation);
parcelHelpers.export(exports, "FaApple", ()=>FaApple);
parcelHelpers.export(exports, "FaApplePay", ()=>FaApplePay);
parcelHelpers.export(exports, "FaApper", ()=>FaApper);
parcelHelpers.export(exports, "FaAppStore", ()=>FaAppStore);
parcelHelpers.export(exports, "FaAppStoreIos", ()=>FaAppStoreIos);
parcelHelpers.export(exports, "FaAngular", ()=>FaAngular);
parcelHelpers.export(exports, "FaAngrycreative", ()=>FaAngrycreative);
parcelHelpers.export(exports, "FaAngellist", ()=>FaAngellist);
parcelHelpers.export(exports, "FaAndroid", ()=>FaAndroid);
parcelHelpers.export(exports, "FaAmilia", ()=>FaAmilia);
parcelHelpers.export(exports, "FaAmazon", ()=>FaAmazon);
parcelHelpers.export(exports, "FaAmazonPay", ()=>FaAmazonPay);
parcelHelpers.export(exports, "FaAlipay", ()=>FaAlipay);
parcelHelpers.export(exports, "FaAlgolia", ()=>FaAlgolia);
parcelHelpers.export(exports, "FaAirbnb", ()=>FaAirbnb);
parcelHelpers.export(exports, "FaAffiliatetheme", ()=>FaAffiliatetheme);
parcelHelpers.export(exports, "FaAdversal", ()=>FaAdversal);
parcelHelpers.export(exports, "FaAdn", ()=>FaAdn);
parcelHelpers.export(exports, "FaAccusoft", ()=>FaAccusoft);
parcelHelpers.export(exports, "FaAccessibleIcon", ()=>FaAccessibleIcon);
parcelHelpers.export(exports, "Fa500Px", ()=>Fa500Px);
parcelHelpers.export(exports, "Fa42Group", ()=>Fa42Group);
parcelHelpers.export(exports, "FaZ", ()=>FaZ);
parcelHelpers.export(exports, "FaYinYang", ()=>FaYinYang);
parcelHelpers.export(exports, "FaYenSign", ()=>FaYenSign);
parcelHelpers.export(exports, "FaY", ()=>FaY);
parcelHelpers.export(exports, "FaXmarksLines", ()=>FaXmarksLines);
parcelHelpers.export(exports, "FaXmark", ()=>FaXmark);
parcelHelpers.export(exports, "FaX", ()=>FaX);
parcelHelpers.export(exports, "FaXRay", ()=>FaXRay);
parcelHelpers.export(exports, "FaWrench", ()=>FaWrench);
parcelHelpers.export(exports, "FaWorm", ()=>FaWorm);
parcelHelpers.export(exports, "FaWonSign", ()=>FaWonSign);
parcelHelpers.export(exports, "FaWineGlass", ()=>FaWineGlass);
parcelHelpers.export(exports, "FaWineGlassEmpty", ()=>FaWineGlassEmpty);
parcelHelpers.export(exports, "FaWineBottle", ()=>FaWineBottle);
parcelHelpers.export(exports, "FaWindowRestore", ()=>FaWindowRestore);
parcelHelpers.export(exports, "FaWindowMinimize", ()=>FaWindowMinimize);
parcelHelpers.export(exports, "FaWindowMaximize", ()=>FaWindowMaximize);
parcelHelpers.export(exports, "FaWind", ()=>FaWind);
parcelHelpers.export(exports, "FaWifi", ()=>FaWifi);
parcelHelpers.export(exports, "FaWhiskeyGlass", ()=>FaWhiskeyGlass);
parcelHelpers.export(exports, "FaWheelchair", ()=>FaWheelchair);
parcelHelpers.export(exports, "FaWheelchairMove", ()=>FaWheelchairMove);
parcelHelpers.export(exports, "FaWheatAwn", ()=>FaWheatAwn);
parcelHelpers.export(exports, "FaWheatAwnCircleExclamation", ()=>FaWheatAwnCircleExclamation);
parcelHelpers.export(exports, "FaWeightScale", ()=>FaWeightScale);
parcelHelpers.export(exports, "FaWeightHanging", ()=>FaWeightHanging);
parcelHelpers.export(exports, "FaWaveSquare", ()=>FaWaveSquare);
parcelHelpers.export(exports, "FaWater", ()=>FaWater);
parcelHelpers.export(exports, "FaWaterLadder", ()=>FaWaterLadder);
parcelHelpers.export(exports, "FaWarehouse", ()=>FaWarehouse);
parcelHelpers.export(exports, "FaWandSparkles", ()=>FaWandSparkles);
parcelHelpers.export(exports, "FaWandMagic", ()=>FaWandMagic);
parcelHelpers.export(exports, "FaWandMagicSparkles", ()=>FaWandMagicSparkles);
parcelHelpers.export(exports, "FaWallet", ()=>FaWallet);
parcelHelpers.export(exports, "FaWalkieTalkie", ()=>FaWalkieTalkie);
parcelHelpers.export(exports, "FaW", ()=>FaW);
parcelHelpers.export(exports, "FaVrCardboard", ()=>FaVrCardboard);
parcelHelpers.export(exports, "FaVolumeXmark", ()=>FaVolumeXmark);
parcelHelpers.export(exports, "FaVolumeOff", ()=>FaVolumeOff);
parcelHelpers.export(exports, "FaVolumeLow", ()=>FaVolumeLow);
parcelHelpers.export(exports, "FaVolumeHigh", ()=>FaVolumeHigh);
parcelHelpers.export(exports, "FaVolleyball", ()=>FaVolleyball);
parcelHelpers.export(exports, "FaVolcano", ()=>FaVolcano);
parcelHelpers.export(exports, "FaVoicemail", ()=>FaVoicemail);
parcelHelpers.export(exports, "FaViruses", ()=>FaViruses);
parcelHelpers.export(exports, "FaVirus", ()=>FaVirus);
parcelHelpers.export(exports, "FaVirusSlash", ()=>FaVirusSlash);
parcelHelpers.export(exports, "FaVirusCovid", ()=>FaVirusCovid);
parcelHelpers.export(exports, "FaVirusCovidSlash", ()=>FaVirusCovidSlash);
parcelHelpers.export(exports, "FaVihara", ()=>FaVihara);
parcelHelpers.export(exports, "FaVideo", ()=>FaVideo);
parcelHelpers.export(exports, "FaVideoSlash", ()=>FaVideoSlash);
parcelHelpers.export(exports, "FaVials", ()=>FaVials);
parcelHelpers.export(exports, "FaVial", ()=>FaVial);
parcelHelpers.export(exports, "FaVialVirus", ()=>FaVialVirus);
parcelHelpers.export(exports, "FaVialCircleCheck", ()=>FaVialCircleCheck);
parcelHelpers.export(exports, "FaVest", ()=>FaVest);
parcelHelpers.export(exports, "FaVestPatches", ()=>FaVestPatches);
parcelHelpers.export(exports, "FaVenus", ()=>FaVenus);
parcelHelpers.export(exports, "FaVenusMars", ()=>FaVenusMars);
parcelHelpers.export(exports, "FaVenusDouble", ()=>FaVenusDouble);
parcelHelpers.export(exports, "FaVectorSquare", ()=>FaVectorSquare);
parcelHelpers.export(exports, "FaVault", ()=>FaVault);
parcelHelpers.export(exports, "FaVanShuttle", ()=>FaVanShuttle);
parcelHelpers.export(exports, "FaV", ()=>FaV);
parcelHelpers.export(exports, "FaUtensils", ()=>FaUtensils);
parcelHelpers.export(exports, "FaUsers", ()=>FaUsers);
parcelHelpers.export(exports, "FaUsersViewfinder", ()=>FaUsersViewfinder);
parcelHelpers.export(exports, "FaUsersSlash", ()=>FaUsersSlash);
parcelHelpers.export(exports, "FaUsersRectangle", ()=>FaUsersRectangle);
parcelHelpers.export(exports, "FaUsersRays", ()=>FaUsersRays);
parcelHelpers.export(exports, "FaUsersLine", ()=>FaUsersLine);
parcelHelpers.export(exports, "FaUsersGear", ()=>FaUsersGear);
parcelHelpers.export(exports, "FaUsersBetweenLines", ()=>FaUsersBetweenLines);
parcelHelpers.export(exports, "FaUser", ()=>FaUser);
parcelHelpers.export(exports, "FaUserXmark", ()=>FaUserXmark);
parcelHelpers.export(exports, "FaUserTie", ()=>FaUserTie);
parcelHelpers.export(exports, "FaUserTag", ()=>FaUserTag);
parcelHelpers.export(exports, "FaUserSlash", ()=>FaUserSlash);
parcelHelpers.export(exports, "FaUserShield", ()=>FaUserShield);
parcelHelpers.export(exports, "FaUserSecret", ()=>FaUserSecret);
parcelHelpers.export(exports, "FaUserPlus", ()=>FaUserPlus);
parcelHelpers.export(exports, "FaUserPen", ()=>FaUserPen);
parcelHelpers.export(exports, "FaUserNurse", ()=>FaUserNurse);
parcelHelpers.export(exports, "FaUserNinja", ()=>FaUserNinja);
parcelHelpers.export(exports, "FaUserMinus", ()=>FaUserMinus);
parcelHelpers.export(exports, "FaUserLock", ()=>FaUserLock);
parcelHelpers.export(exports, "FaUserLarge", ()=>FaUserLarge);
parcelHelpers.export(exports, "FaUserLargeSlash", ()=>FaUserLargeSlash);
parcelHelpers.export(exports, "FaUserInjured", ()=>FaUserInjured);
parcelHelpers.export(exports, "FaUserGroup", ()=>FaUserGroup);
parcelHelpers.export(exports, "FaUserGraduate", ()=>FaUserGraduate);
parcelHelpers.export(exports, "FaUserGear", ()=>FaUserGear);
parcelHelpers.export(exports, "FaUserDoctor", ()=>FaUserDoctor);
parcelHelpers.export(exports, "FaUserClock", ()=>FaUserClock);
parcelHelpers.export(exports, "FaUserCheck", ()=>FaUserCheck);
parcelHelpers.export(exports, "FaUserAstronaut", ()=>FaUserAstronaut);
parcelHelpers.export(exports, "FaUpload", ()=>FaUpload);
parcelHelpers.export(exports, "FaUpRightFromSquare", ()=>FaUpRightFromSquare);
parcelHelpers.export(exports, "FaUpRightAndDownLeftFromCenter", ()=>FaUpRightAndDownLeftFromCenter);
parcelHelpers.export(exports, "FaUpLong", ()=>FaUpLong);
parcelHelpers.export(exports, "FaUpDown", ()=>FaUpDown);
parcelHelpers.export(exports, "FaUpDownLeftRight", ()=>FaUpDownLeftRight);
parcelHelpers.export(exports, "FaUnlock", ()=>FaUnlock);
parcelHelpers.export(exports, "FaUnlockKeyhole", ()=>FaUnlockKeyhole);
parcelHelpers.export(exports, "FaUniversalAccess", ()=>FaUniversalAccess);
parcelHelpers.export(exports, "FaUnderline", ()=>FaUnderline);
parcelHelpers.export(exports, "FaUmbrella", ()=>FaUmbrella);
parcelHelpers.export(exports, "FaUmbrellaBeach", ()=>FaUmbrellaBeach);
parcelHelpers.export(exports, "FaU", ()=>FaU);
parcelHelpers.export(exports, "FaTv", ()=>FaTv);
parcelHelpers.export(exports, "FaTurnUp", ()=>FaTurnUp);
parcelHelpers.export(exports, "FaTurnDown", ()=>FaTurnDown);
parcelHelpers.export(exports, "FaTurkishLiraSign", ()=>FaTurkishLiraSign);
parcelHelpers.export(exports, "FaTty", ()=>FaTty);
parcelHelpers.export(exports, "FaTruck", ()=>FaTruck);
parcelHelpers.export(exports, "FaTruckRampBox", ()=>FaTruckRampBox);
parcelHelpers.export(exports, "FaTruckPlane", ()=>FaTruckPlane);
parcelHelpers.export(exports, "FaTruckPickup", ()=>FaTruckPickup);
parcelHelpers.export(exports, "FaTruckMoving", ()=>FaTruckMoving);
parcelHelpers.export(exports, "FaTruckMonster", ()=>FaTruckMonster);
parcelHelpers.export(exports, "FaTruckMedical", ()=>FaTruckMedical);
parcelHelpers.export(exports, "FaTruckFront", ()=>FaTruckFront);
parcelHelpers.export(exports, "FaTruckField", ()=>FaTruckField);
parcelHelpers.export(exports, "FaTruckFieldUn", ()=>FaTruckFieldUn);
parcelHelpers.export(exports, "FaTruckFast", ()=>FaTruckFast);
parcelHelpers.export(exports, "FaTruckDroplet", ()=>FaTruckDroplet);
parcelHelpers.export(exports, "FaTruckArrowRight", ()=>FaTruckArrowRight);
parcelHelpers.export(exports, "FaTrowel", ()=>FaTrowel);
parcelHelpers.export(exports, "FaTrowelBricks", ()=>FaTrowelBricks);
parcelHelpers.export(exports, "FaTrophy", ()=>FaTrophy);
parcelHelpers.export(exports, "FaTriangleExclamation", ()=>FaTriangleExclamation);
parcelHelpers.export(exports, "FaTree", ()=>FaTree);
parcelHelpers.export(exports, "FaTreeCity", ()=>FaTreeCity);
parcelHelpers.export(exports, "FaTrash", ()=>FaTrash);
parcelHelpers.export(exports, "FaTrashCan", ()=>FaTrashCan);
parcelHelpers.export(exports, "FaTrashCanArrowUp", ()=>FaTrashCanArrowUp);
parcelHelpers.export(exports, "FaTrashArrowUp", ()=>FaTrashArrowUp);
parcelHelpers.export(exports, "FaTransgender", ()=>FaTransgender);
parcelHelpers.export(exports, "FaTrain", ()=>FaTrain);
parcelHelpers.export(exports, "FaTrainTram", ()=>FaTrainTram);
parcelHelpers.export(exports, "FaTrainSubway", ()=>FaTrainSubway);
parcelHelpers.export(exports, "FaTrailer", ()=>FaTrailer);
parcelHelpers.export(exports, "FaTrafficLight", ()=>FaTrafficLight);
parcelHelpers.export(exports, "FaTrademark", ()=>FaTrademark);
parcelHelpers.export(exports, "FaTractor", ()=>FaTractor);
parcelHelpers.export(exports, "FaTowerObservation", ()=>FaTowerObservation);
parcelHelpers.export(exports, "FaTowerCell", ()=>FaTowerCell);
parcelHelpers.export(exports, "FaTowerBroadcast", ()=>FaTowerBroadcast);
parcelHelpers.export(exports, "FaTornado", ()=>FaTornado);
parcelHelpers.export(exports, "FaToriiGate", ()=>FaToriiGate);
parcelHelpers.export(exports, "FaTooth", ()=>FaTooth);
parcelHelpers.export(exports, "FaToolbox", ()=>FaToolbox);
parcelHelpers.export(exports, "FaToiletsPortable", ()=>FaToiletsPortable);
parcelHelpers.export(exports, "FaToilet", ()=>FaToilet);
parcelHelpers.export(exports, "FaToiletPortable", ()=>FaToiletPortable);
parcelHelpers.export(exports, "FaToiletPaper", ()=>FaToiletPaper);
parcelHelpers.export(exports, "FaToiletPaperSlash", ()=>FaToiletPaperSlash);
parcelHelpers.export(exports, "FaToggleOn", ()=>FaToggleOn);
parcelHelpers.export(exports, "FaToggleOff", ()=>FaToggleOff);
parcelHelpers.export(exports, "FaTimeline", ()=>FaTimeline);
parcelHelpers.export(exports, "FaTicket", ()=>FaTicket);
parcelHelpers.export(exports, "FaTicketSimple", ()=>FaTicketSimple);
parcelHelpers.export(exports, "FaThumbtack", ()=>FaThumbtack);
parcelHelpers.export(exports, "FaThumbtackSlash", ()=>FaThumbtackSlash);
parcelHelpers.export(exports, "FaThumbsUp", ()=>FaThumbsUp);
parcelHelpers.export(exports, "FaThumbsDown", ()=>FaThumbsDown);
parcelHelpers.export(exports, "FaThermometer", ()=>FaThermometer);
parcelHelpers.export(exports, "FaTextWidth", ()=>FaTextWidth);
parcelHelpers.export(exports, "FaTextSlash", ()=>FaTextSlash);
parcelHelpers.export(exports, "FaTextHeight", ()=>FaTextHeight);
parcelHelpers.export(exports, "FaTerminal", ()=>FaTerminal);
parcelHelpers.export(exports, "FaTents", ()=>FaTents);
parcelHelpers.export(exports, "FaTent", ()=>FaTent);
parcelHelpers.export(exports, "FaTentArrowsDown", ()=>FaTentArrowsDown);
parcelHelpers.export(exports, "FaTentArrowTurnLeft", ()=>FaTentArrowTurnLeft);
parcelHelpers.export(exports, "FaTentArrowLeftRight", ()=>FaTentArrowLeftRight);
parcelHelpers.export(exports, "FaTentArrowDownToLine", ()=>FaTentArrowDownToLine);
parcelHelpers.export(exports, "FaTengeSign", ()=>FaTengeSign);
parcelHelpers.export(exports, "FaTemperatureThreeQuarters", ()=>FaTemperatureThreeQuarters);
parcelHelpers.export(exports, "FaTemperatureQuarter", ()=>FaTemperatureQuarter);
parcelHelpers.export(exports, "FaTemperatureLow", ()=>FaTemperatureLow);
parcelHelpers.export(exports, "FaTemperatureHigh", ()=>FaTemperatureHigh);
parcelHelpers.export(exports, "FaTemperatureHalf", ()=>FaTemperatureHalf);
parcelHelpers.export(exports, "FaTemperatureFull", ()=>FaTemperatureFull);
parcelHelpers.export(exports, "FaTemperatureEmpty", ()=>FaTemperatureEmpty);
parcelHelpers.export(exports, "FaTemperatureArrowUp", ()=>FaTemperatureArrowUp);
parcelHelpers.export(exports, "FaTemperatureArrowDown", ()=>FaTemperatureArrowDown);
parcelHelpers.export(exports, "FaTeeth", ()=>FaTeeth);
parcelHelpers.export(exports, "FaTeethOpen", ()=>FaTeethOpen);
parcelHelpers.export(exports, "FaTaxi", ()=>FaTaxi);
parcelHelpers.export(exports, "FaTarp", ()=>FaTarp);
parcelHelpers.export(exports, "FaTarpDroplet", ()=>FaTarpDroplet);
parcelHelpers.export(exports, "FaTape", ()=>FaTape);
parcelHelpers.export(exports, "FaTags", ()=>FaTags);
parcelHelpers.export(exports, "FaTag", ()=>FaTag);
parcelHelpers.export(exports, "FaTachographDigital", ()=>FaTachographDigital);
parcelHelpers.export(exports, "FaTablets", ()=>FaTablets);
parcelHelpers.export(exports, "FaTablet", ()=>FaTablet);
parcelHelpers.export(exports, "FaTabletScreenButton", ()=>FaTabletScreenButton);
parcelHelpers.export(exports, "FaTabletButton", ()=>FaTabletButton);
parcelHelpers.export(exports, "FaTable", ()=>FaTable);
parcelHelpers.export(exports, "FaTableTennisPaddleBall", ()=>FaTableTennisPaddleBall);
parcelHelpers.export(exports, "FaTableList", ()=>FaTableList);
parcelHelpers.export(exports, "FaTableColumns", ()=>FaTableColumns);
parcelHelpers.export(exports, "FaTableCells", ()=>FaTableCells);
parcelHelpers.export(exports, "FaTableCellsRowUnlock", ()=>FaTableCellsRowUnlock);
parcelHelpers.export(exports, "FaTableCellsRowLock", ()=>FaTableCellsRowLock);
parcelHelpers.export(exports, "FaTableCellsLarge", ()=>FaTableCellsLarge);
parcelHelpers.export(exports, "FaTableCellsColumnLock", ()=>FaTableCellsColumnLock);
parcelHelpers.export(exports, "FaT", ()=>FaT);
parcelHelpers.export(exports, "FaSyringe", ()=>FaSyringe);
parcelHelpers.export(exports, "FaSynagogue", ()=>FaSynagogue);
parcelHelpers.export(exports, "FaSwatchbook", ()=>FaSwatchbook);
parcelHelpers.export(exports, "FaSuperscript", ()=>FaSuperscript);
parcelHelpers.export(exports, "FaSun", ()=>FaSun);
parcelHelpers.export(exports, "FaSunPlantWilt", ()=>FaSunPlantWilt);
parcelHelpers.export(exports, "FaSuitcase", ()=>FaSuitcase);
parcelHelpers.export(exports, "FaSuitcaseRolling", ()=>FaSuitcaseRolling);
parcelHelpers.export(exports, "FaSuitcaseMedical", ()=>FaSuitcaseMedical);
parcelHelpers.export(exports, "FaSubscript", ()=>FaSubscript);
parcelHelpers.export(exports, "FaStroopwafel", ()=>FaStroopwafel);
parcelHelpers.export(exports, "FaStrikethrough", ()=>FaStrikethrough);
parcelHelpers.export(exports, "FaStreetView", ()=>FaStreetView);
parcelHelpers.export(exports, "FaStore", ()=>FaStore);
parcelHelpers.export(exports, "FaStoreSlash", ()=>FaStoreSlash);
parcelHelpers.export(exports, "FaStopwatch", ()=>FaStopwatch);
parcelHelpers.export(exports, "FaStopwatch20", ()=>FaStopwatch20);
parcelHelpers.export(exports, "FaStop", ()=>FaStop);
parcelHelpers.export(exports, "FaStethoscope", ()=>FaStethoscope);
parcelHelpers.export(exports, "FaSterlingSign", ()=>FaSterlingSign);
parcelHelpers.export(exports, "FaStar", ()=>FaStar);
parcelHelpers.export(exports, "FaStarOfLife", ()=>FaStarOfLife);
parcelHelpers.export(exports, "FaStarOfDavid", ()=>FaStarOfDavid);
parcelHelpers.export(exports, "FaStarHalf", ()=>FaStarHalf);
parcelHelpers.export(exports, "FaStarHalfStroke", ()=>FaStarHalfStroke);
parcelHelpers.export(exports, "FaStarAndCrescent", ()=>FaStarAndCrescent);
parcelHelpers.export(exports, "FaStapler", ()=>FaStapler);
parcelHelpers.export(exports, "FaStamp", ()=>FaStamp);
parcelHelpers.export(exports, "FaStairs", ()=>FaStairs);
parcelHelpers.export(exports, "FaStaffSnake", ()=>FaStaffSnake);
parcelHelpers.export(exports, "FaSquare", ()=>FaSquare);
parcelHelpers.export(exports, "FaSquareXmark", ()=>FaSquareXmark);
parcelHelpers.export(exports, "FaSquareVirus", ()=>FaSquareVirus);
parcelHelpers.export(exports, "FaSquareUpRight", ()=>FaSquareUpRight);
parcelHelpers.export(exports, "FaSquareShareNodes", ()=>FaSquareShareNodes);
parcelHelpers.export(exports, "FaSquareRss", ()=>FaSquareRss);
parcelHelpers.export(exports, "FaSquareRootVariable", ()=>FaSquareRootVariable);
parcelHelpers.export(exports, "FaSquarePollVertical", ()=>FaSquarePollVertical);
parcelHelpers.export(exports, "FaSquarePollHorizontal", ()=>FaSquarePollHorizontal);
parcelHelpers.export(exports, "FaSquarePlus", ()=>FaSquarePlus);
parcelHelpers.export(exports, "FaSquarePhone", ()=>FaSquarePhone);
parcelHelpers.export(exports, "FaSquarePhoneFlip", ()=>FaSquarePhoneFlip);
parcelHelpers.export(exports, "FaSquarePersonConfined", ()=>FaSquarePersonConfined);
parcelHelpers.export(exports, "FaSquarePen", ()=>FaSquarePen);
parcelHelpers.export(exports, "FaSquareParking", ()=>FaSquareParking);
parcelHelpers.export(exports, "FaSquareNfi", ()=>FaSquareNfi);
parcelHelpers.export(exports, "FaSquareMinus", ()=>FaSquareMinus);
parcelHelpers.export(exports, "FaSquareH", ()=>FaSquareH);
parcelHelpers.export(exports, "FaSquareFull", ()=>FaSquareFull);
parcelHelpers.export(exports, "FaSquareEnvelope", ()=>FaSquareEnvelope);
parcelHelpers.export(exports, "FaSquareCheck", ()=>FaSquareCheck);
parcelHelpers.export(exports, "FaSquareCaretUp", ()=>FaSquareCaretUp);
parcelHelpers.export(exports, "FaSquareCaretRight", ()=>FaSquareCaretRight);
parcelHelpers.export(exports, "FaSquareCaretLeft", ()=>FaSquareCaretLeft);
parcelHelpers.export(exports, "FaSquareCaretDown", ()=>FaSquareCaretDown);
parcelHelpers.export(exports, "FaSquareBinary", ()=>FaSquareBinary);
parcelHelpers.export(exports, "FaSquareArrowUpRight", ()=>FaSquareArrowUpRight);
parcelHelpers.export(exports, "FaSprayCan", ()=>FaSprayCan);
parcelHelpers.export(exports, "FaSprayCanSparkles", ()=>FaSprayCanSparkles);
parcelHelpers.export(exports, "FaSpoon", ()=>FaSpoon);
parcelHelpers.export(exports, "FaSplotch", ()=>FaSplotch);
parcelHelpers.export(exports, "FaSpinner", ()=>FaSpinner);
parcelHelpers.export(exports, "FaSpider", ()=>FaSpider);
parcelHelpers.export(exports, "FaSpellCheck", ()=>FaSpellCheck);
parcelHelpers.export(exports, "FaSpaghettiMonsterFlying", ()=>FaSpaghettiMonsterFlying);
parcelHelpers.export(exports, "FaSpa", ()=>FaSpa);
parcelHelpers.export(exports, "FaSort", ()=>FaSort);
parcelHelpers.export(exports, "FaSortUp", ()=>FaSortUp);
parcelHelpers.export(exports, "FaSortDown", ()=>FaSortDown);
parcelHelpers.export(exports, "FaSolarPanel", ()=>FaSolarPanel);
parcelHelpers.export(exports, "FaSocks", ()=>FaSocks);
parcelHelpers.export(exports, "FaSoap", ()=>FaSoap);
parcelHelpers.export(exports, "FaSnowplow", ()=>FaSnowplow);
parcelHelpers.export(exports, "FaSnowman", ()=>FaSnowman);
parcelHelpers.export(exports, "FaSnowflake", ()=>FaSnowflake);
parcelHelpers.export(exports, "FaSmoking", ()=>FaSmoking);
parcelHelpers.export(exports, "FaSmog", ()=>FaSmog);
parcelHelpers.export(exports, "FaSliders", ()=>FaSliders);
parcelHelpers.export(exports, "FaSleigh", ()=>FaSleigh);
parcelHelpers.export(exports, "FaSlash", ()=>FaSlash);
parcelHelpers.export(exports, "FaSkull", ()=>FaSkull);
parcelHelpers.export(exports, "FaSkullCrossbones", ()=>FaSkullCrossbones);
parcelHelpers.export(exports, "FaSitemap", ()=>FaSitemap);
parcelHelpers.export(exports, "FaSink", ()=>FaSink);
parcelHelpers.export(exports, "FaSimCard", ()=>FaSimCard);
parcelHelpers.export(exports, "FaSignsPost", ()=>FaSignsPost);
parcelHelpers.export(exports, "FaSignature", ()=>FaSignature);
parcelHelpers.export(exports, "FaSignal", ()=>FaSignal);
parcelHelpers.export(exports, "FaSignHanging", ()=>FaSignHanging);
parcelHelpers.export(exports, "FaShuttleSpace", ()=>FaShuttleSpace);
parcelHelpers.export(exports, "FaShuffle", ()=>FaShuffle);
parcelHelpers.export(exports, "FaShrimp", ()=>FaShrimp);
parcelHelpers.export(exports, "FaShower", ()=>FaShower);
parcelHelpers.export(exports, "FaShop", ()=>FaShop);
parcelHelpers.export(exports, "FaShopSlash", ()=>FaShopSlash);
parcelHelpers.export(exports, "FaShopLock", ()=>FaShopLock);
parcelHelpers.export(exports, "FaShoePrints", ()=>FaShoePrints);
parcelHelpers.export(exports, "FaShirt", ()=>FaShirt);
parcelHelpers.export(exports, "FaShip", ()=>FaShip);
parcelHelpers.export(exports, "FaShield", ()=>FaShield);
parcelHelpers.export(exports, "FaShieldVirus", ()=>FaShieldVirus);
parcelHelpers.export(exports, "FaShieldHeart", ()=>FaShieldHeart);
parcelHelpers.export(exports, "FaShieldHalved", ()=>FaShieldHalved);
parcelHelpers.export(exports, "FaShieldDog", ()=>FaShieldDog);
parcelHelpers.export(exports, "FaShieldCat", ()=>FaShieldCat);
parcelHelpers.export(exports, "FaShekelSign", ()=>FaShekelSign);
parcelHelpers.export(exports, "FaSheetPlastic", ()=>FaSheetPlastic);
parcelHelpers.export(exports, "FaShare", ()=>FaShare);
parcelHelpers.export(exports, "FaShareNodes", ()=>FaShareNodes);
parcelHelpers.export(exports, "FaShareFromSquare", ()=>FaShareFromSquare);
parcelHelpers.export(exports, "FaShapes", ()=>FaShapes);
parcelHelpers.export(exports, "FaServer", ()=>FaServer);
parcelHelpers.export(exports, "FaSeedling", ()=>FaSeedling);
parcelHelpers.export(exports, "FaSection", ()=>FaSection);
parcelHelpers.export(exports, "FaSdCard", ()=>FaSdCard);
parcelHelpers.export(exports, "FaScroll", ()=>FaScroll);
parcelHelpers.export(exports, "FaScrollTorah", ()=>FaScrollTorah);
parcelHelpers.export(exports, "FaScrewdriver", ()=>FaScrewdriver);
parcelHelpers.export(exports, "FaScrewdriverWrench", ()=>FaScrewdriverWrench);
parcelHelpers.export(exports, "FaScissors", ()=>FaScissors);
parcelHelpers.export(exports, "FaSchool", ()=>FaSchool);
parcelHelpers.export(exports, "FaSchoolLock", ()=>FaSchoolLock);
parcelHelpers.export(exports, "FaSchoolFlag", ()=>FaSchoolFlag);
parcelHelpers.export(exports, "FaSchoolCircleXmark", ()=>FaSchoolCircleXmark);
parcelHelpers.export(exports, "FaSchoolCircleExclamation", ()=>FaSchoolCircleExclamation);
parcelHelpers.export(exports, "FaSchoolCircleCheck", ()=>FaSchoolCircleCheck);
parcelHelpers.export(exports, "FaScaleUnbalanced", ()=>FaScaleUnbalanced);
parcelHelpers.export(exports, "FaScaleUnbalancedFlip", ()=>FaScaleUnbalancedFlip);
parcelHelpers.export(exports, "FaScaleBalanced", ()=>FaScaleBalanced);
parcelHelpers.export(exports, "FaSatellite", ()=>FaSatellite);
parcelHelpers.export(exports, "FaSatelliteDish", ()=>FaSatelliteDish);
parcelHelpers.export(exports, "FaSailboat", ()=>FaSailboat);
parcelHelpers.export(exports, "FaSackXmark", ()=>FaSackXmark);
parcelHelpers.export(exports, "FaSackDollar", ()=>FaSackDollar);
parcelHelpers.export(exports, "FaS", ()=>FaS);
parcelHelpers.export(exports, "FaRupiahSign", ()=>FaRupiahSign);
parcelHelpers.export(exports, "FaRupeeSign", ()=>FaRupeeSign);
parcelHelpers.export(exports, "FaRuler", ()=>FaRuler);
parcelHelpers.export(exports, "FaRulerVertical", ()=>FaRulerVertical);
parcelHelpers.export(exports, "FaRulerHorizontal", ()=>FaRulerHorizontal);
parcelHelpers.export(exports, "FaRulerCombined", ()=>FaRulerCombined);
parcelHelpers.export(exports, "FaRug", ()=>FaRug);
parcelHelpers.export(exports, "FaRubleSign", ()=>FaRubleSign);
parcelHelpers.export(exports, "FaRss", ()=>FaRss);
parcelHelpers.export(exports, "FaRoute", ()=>FaRoute);
parcelHelpers.export(exports, "FaRotate", ()=>FaRotate);
parcelHelpers.export(exports, "FaRotateRight", ()=>FaRotateRight);
parcelHelpers.export(exports, "FaRotateLeft", ()=>FaRotateLeft);
parcelHelpers.export(exports, "FaRocket", ()=>FaRocket);
parcelHelpers.export(exports, "FaRobot", ()=>FaRobot);
parcelHelpers.export(exports, "FaRoad", ()=>FaRoad);
parcelHelpers.export(exports, "FaRoadSpikes", ()=>FaRoadSpikes);
parcelHelpers.export(exports, "FaRoadLock", ()=>FaRoadLock);
parcelHelpers.export(exports, "FaRoadCircleXmark", ()=>FaRoadCircleXmark);
parcelHelpers.export(exports, "FaRoadCircleExclamation", ()=>FaRoadCircleExclamation);
parcelHelpers.export(exports, "FaRoadCircleCheck", ()=>FaRoadCircleCheck);
parcelHelpers.export(exports, "FaRoadBridge", ()=>FaRoadBridge);
parcelHelpers.export(exports, "FaRoadBarrier", ()=>FaRoadBarrier);
parcelHelpers.export(exports, "FaRing", ()=>FaRing);
parcelHelpers.export(exports, "FaRightToBracket", ()=>FaRightToBracket);
parcelHelpers.export(exports, "FaRightLong", ()=>FaRightLong);
parcelHelpers.export(exports, "FaRightLeft", ()=>FaRightLeft);
parcelHelpers.export(exports, "FaRightFromBracket", ()=>FaRightFromBracket);
parcelHelpers.export(exports, "FaRibbon", ()=>FaRibbon);
parcelHelpers.export(exports, "FaRetweet", ()=>FaRetweet);
parcelHelpers.export(exports, "FaRestroom", ()=>FaRestroom);
parcelHelpers.export(exports, "FaRepublican", ()=>FaRepublican);
parcelHelpers.export(exports, "FaReply", ()=>FaReply);
parcelHelpers.export(exports, "FaReplyAll", ()=>FaReplyAll);
parcelHelpers.export(exports, "FaRepeat", ()=>FaRepeat);
parcelHelpers.export(exports, "FaRegistered", ()=>FaRegistered);
parcelHelpers.export(exports, "FaRecycle", ()=>FaRecycle);
parcelHelpers.export(exports, "FaRectangleXmark", ()=>FaRectangleXmark);
parcelHelpers.export(exports, "FaRectangleList", ()=>FaRectangleList);
parcelHelpers.export(exports, "FaRectangleAd", ()=>FaRectangleAd);
parcelHelpers.export(exports, "FaRecordVinyl", ()=>FaRecordVinyl);
parcelHelpers.export(exports, "FaReceipt", ()=>FaReceipt);
parcelHelpers.export(exports, "FaRankingStar", ()=>FaRankingStar);
parcelHelpers.export(exports, "FaRainbow", ()=>FaRainbow);
parcelHelpers.export(exports, "FaRadio", ()=>FaRadio);
parcelHelpers.export(exports, "FaRadiation", ()=>FaRadiation);
parcelHelpers.export(exports, "FaR", ()=>FaR);
parcelHelpers.export(exports, "FaQuoteRight", ()=>FaQuoteRight);
parcelHelpers.export(exports, "FaQuoteLeft", ()=>FaQuoteLeft);
parcelHelpers.export(exports, "FaQuestion", ()=>FaQuestion);
parcelHelpers.export(exports, "FaQrcode", ()=>FaQrcode);
parcelHelpers.export(exports, "FaQ", ()=>FaQ);
parcelHelpers.export(exports, "FaPuzzlePiece", ()=>FaPuzzlePiece);
parcelHelpers.export(exports, "FaPumpSoap", ()=>FaPumpSoap);
parcelHelpers.export(exports, "FaPumpMedical", ()=>FaPumpMedical);
parcelHelpers.export(exports, "FaPrint", ()=>FaPrint);
parcelHelpers.export(exports, "FaPrescription", ()=>FaPrescription);
parcelHelpers.export(exports, "FaPrescriptionBottle", ()=>FaPrescriptionBottle);
parcelHelpers.export(exports, "FaPrescriptionBottleMedical", ()=>FaPrescriptionBottleMedical);
parcelHelpers.export(exports, "FaPowerOff", ()=>FaPowerOff);
parcelHelpers.export(exports, "FaPoop", ()=>FaPoop);
parcelHelpers.export(exports, "FaPoo", ()=>FaPoo);
parcelHelpers.export(exports, "FaPooStorm", ()=>FaPooStorm);
parcelHelpers.export(exports, "FaPodcast", ()=>FaPodcast);
parcelHelpers.export(exports, "FaPlus", ()=>FaPlus);
parcelHelpers.export(exports, "FaPlusMinus", ()=>FaPlusMinus);
parcelHelpers.export(exports, "FaPlug", ()=>FaPlug);
parcelHelpers.export(exports, "FaPlugCircleXmark", ()=>FaPlugCircleXmark);
parcelHelpers.export(exports, "FaPlugCirclePlus", ()=>FaPlugCirclePlus);
parcelHelpers.export(exports, "FaPlugCircleMinus", ()=>FaPlugCircleMinus);
parcelHelpers.export(exports, "FaPlugCircleExclamation", ()=>FaPlugCircleExclamation);
parcelHelpers.export(exports, "FaPlugCircleCheck", ()=>FaPlugCircleCheck);
parcelHelpers.export(exports, "FaPlugCircleBolt", ()=>FaPlugCircleBolt);
parcelHelpers.export(exports, "FaPlay", ()=>FaPlay);
parcelHelpers.export(exports, "FaPlateWheat", ()=>FaPlateWheat);
parcelHelpers.export(exports, "FaPlantWilt", ()=>FaPlantWilt);
parcelHelpers.export(exports, "FaPlane", ()=>FaPlane);
parcelHelpers.export(exports, "FaPlaneUp", ()=>FaPlaneUp);
parcelHelpers.export(exports, "FaPlaneSlash", ()=>FaPlaneSlash);
parcelHelpers.export(exports, "FaPlaneLock", ()=>FaPlaneLock);
parcelHelpers.export(exports, "FaPlaneDeparture", ()=>FaPlaneDeparture);
parcelHelpers.export(exports, "FaPlaneCircleXmark", ()=>FaPlaneCircleXmark);
parcelHelpers.export(exports, "FaPlaneCircleExclamation", ()=>FaPlaneCircleExclamation);
parcelHelpers.export(exports, "FaPlaneCircleCheck", ()=>FaPlaneCircleCheck);
parcelHelpers.export(exports, "FaPlaneArrival", ()=>FaPlaneArrival);
parcelHelpers.export(exports, "FaPlaceOfWorship", ()=>FaPlaceOfWorship);
parcelHelpers.export(exports, "FaPizzaSlice", ()=>FaPizzaSlice);
parcelHelpers.export(exports, "FaPills", ()=>FaPills);
parcelHelpers.export(exports, "FaPiggyBank", ()=>FaPiggyBank);
parcelHelpers.export(exports, "FaPhotoFilm", ()=>FaPhotoFilm);
parcelHelpers.export(exports, "FaPhone", ()=>FaPhone);
parcelHelpers.export(exports, "FaPhoneVolume", ()=>FaPhoneVolume);
parcelHelpers.export(exports, "FaPhoneSlash", ()=>FaPhoneSlash);
parcelHelpers.export(exports, "FaPhoneFlip", ()=>FaPhoneFlip);
parcelHelpers.export(exports, "FaPesoSign", ()=>FaPesoSign);
parcelHelpers.export(exports, "FaPesetaSign", ()=>FaPesetaSign);
parcelHelpers.export(exports, "FaPerson", ()=>FaPerson);
parcelHelpers.export(exports, "FaPersonWalking", ()=>FaPersonWalking);
parcelHelpers.export(exports, "FaPersonWalkingWithCane", ()=>FaPersonWalkingWithCane);
parcelHelpers.export(exports, "FaPersonWalkingLuggage", ()=>FaPersonWalkingLuggage);
parcelHelpers.export(exports, "FaPersonWalkingDashedLineArrowRight", ()=>FaPersonWalkingDashedLineArrowRight);
parcelHelpers.export(exports, "FaPersonWalkingArrowRight", ()=>FaPersonWalkingArrowRight);
parcelHelpers.export(exports, "FaPersonWalkingArrowLoopLeft", ()=>FaPersonWalkingArrowLoopLeft);
parcelHelpers.export(exports, "FaPersonThroughWindow", ()=>FaPersonThroughWindow);
parcelHelpers.export(exports, "FaPersonSwimming", ()=>FaPersonSwimming);
parcelHelpers.export(exports, "FaPersonSnowboarding", ()=>FaPersonSnowboarding);
parcelHelpers.export(exports, "FaPersonSkiing", ()=>FaPersonSkiing);
parcelHelpers.export(exports, "FaPersonSkiingNordic", ()=>FaPersonSkiingNordic);
parcelHelpers.export(exports, "FaPersonSkating", ()=>FaPersonSkating);
parcelHelpers.export(exports, "FaPersonShelter", ()=>FaPersonShelter);
parcelHelpers.export(exports, "FaPersonRunning", ()=>FaPersonRunning);
parcelHelpers.export(exports, "FaPersonRifle", ()=>FaPersonRifle);
parcelHelpers.export(exports, "FaPersonRays", ()=>FaPersonRays);
parcelHelpers.export(exports, "FaPersonPregnant", ()=>FaPersonPregnant);
parcelHelpers.export(exports, "FaPersonPraying", ()=>FaPersonPraying);
parcelHelpers.export(exports, "FaPersonMilitaryToPerson", ()=>FaPersonMilitaryToPerson);
parcelHelpers.export(exports, "FaPersonMilitaryRifle", ()=>FaPersonMilitaryRifle);
parcelHelpers.export(exports, "FaPersonMilitaryPointing", ()=>FaPersonMilitaryPointing);
parcelHelpers.export(exports, "FaPersonHiking", ()=>FaPersonHiking);
parcelHelpers.export(exports, "FaPersonHarassing", ()=>FaPersonHarassing);
parcelHelpers.export(exports, "FaPersonHalfDress", ()=>FaPersonHalfDress);
parcelHelpers.export(exports, "FaPersonFalling", ()=>FaPersonFalling);
parcelHelpers.export(exports, "FaPersonFallingBurst", ()=>FaPersonFallingBurst);
parcelHelpers.export(exports, "FaPersonDrowning", ()=>FaPersonDrowning);
parcelHelpers.export(exports, "FaPersonDress", ()=>FaPersonDress);
parcelHelpers.export(exports, "FaPersonDressBurst", ()=>FaPersonDressBurst);
parcelHelpers.export(exports, "FaPersonDotsFromLine", ()=>FaPersonDotsFromLine);
parcelHelpers.export(exports, "FaPersonDigging", ()=>FaPersonDigging);
parcelHelpers.export(exports, "FaPersonCircleXmark", ()=>FaPersonCircleXmark);
parcelHelpers.export(exports, "FaPersonCircleQuestion", ()=>FaPersonCircleQuestion);
parcelHelpers.export(exports, "FaPersonCirclePlus", ()=>FaPersonCirclePlus);
parcelHelpers.export(exports, "FaPersonCircleMinus", ()=>FaPersonCircleMinus);
parcelHelpers.export(exports, "FaPersonCircleExclamation", ()=>FaPersonCircleExclamation);
parcelHelpers.export(exports, "FaPersonCircleCheck", ()=>FaPersonCircleCheck);
parcelHelpers.export(exports, "FaPersonChalkboard", ()=>FaPersonChalkboard);
parcelHelpers.export(exports, "FaPersonCane", ()=>FaPersonCane);
parcelHelpers.export(exports, "FaPersonBurst", ()=>FaPersonBurst);
parcelHelpers.export(exports, "FaPersonBreastfeeding", ()=>FaPersonBreastfeeding);
parcelHelpers.export(exports, "FaPersonBooth", ()=>FaPersonBooth);
parcelHelpers.export(exports, "FaPersonBiking", ()=>FaPersonBiking);
parcelHelpers.export(exports, "FaPersonArrowUpFromLine", ()=>FaPersonArrowUpFromLine);
parcelHelpers.export(exports, "FaPersonArrowDownToLine", ()=>FaPersonArrowDownToLine);
parcelHelpers.export(exports, "FaPercent", ()=>FaPercent);
parcelHelpers.export(exports, "FaPepperHot", ()=>FaPepperHot);
parcelHelpers.export(exports, "FaPeopleRoof", ()=>FaPeopleRoof);
parcelHelpers.export(exports, "FaPeopleRobbery", ()=>FaPeopleRobbery);
parcelHelpers.export(exports, "FaPeoplePulling", ()=>FaPeoplePulling);
parcelHelpers.export(exports, "FaPeopleLine", ()=>FaPeopleLine);
parcelHelpers.export(exports, "FaPeopleGroup", ()=>FaPeopleGroup);
parcelHelpers.export(exports, "FaPeopleCarryBox", ()=>FaPeopleCarryBox);
parcelHelpers.export(exports, "FaPeopleArrows", ()=>FaPeopleArrows);
parcelHelpers.export(exports, "FaPencil", ()=>FaPencil);
parcelHelpers.export(exports, "FaPen", ()=>FaPen);
parcelHelpers.export(exports, "FaPenToSquare", ()=>FaPenToSquare);
parcelHelpers.export(exports, "FaPenRuler", ()=>FaPenRuler);
parcelHelpers.export(exports, "FaPenNib", ()=>FaPenNib);
parcelHelpers.export(exports, "FaPenFancy", ()=>FaPenFancy);
parcelHelpers.export(exports, "FaPenClip", ()=>FaPenClip);
parcelHelpers.export(exports, "FaPeace", ()=>FaPeace);
parcelHelpers.export(exports, "FaPaw", ()=>FaPaw);
parcelHelpers.export(exports, "FaPause", ()=>FaPause);
parcelHelpers.export(exports, "FaPaste", ()=>FaPaste);
parcelHelpers.export(exports, "FaPassport", ()=>FaPassport);
parcelHelpers.export(exports, "FaParagraph", ()=>FaParagraph);
parcelHelpers.export(exports, "FaParachuteBox", ()=>FaParachuteBox);
parcelHelpers.export(exports, "FaPaperclip", ()=>FaPaperclip);
parcelHelpers.export(exports, "FaPaperPlane", ()=>FaPaperPlane);
parcelHelpers.export(exports, "FaPanorama", ()=>FaPanorama);
parcelHelpers.export(exports, "FaPallet", ()=>FaPallet);
parcelHelpers.export(exports, "FaPalette", ()=>FaPalette);
parcelHelpers.export(exports, "FaPaintbrush", ()=>FaPaintbrush);
parcelHelpers.export(exports, "FaPaintRoller", ()=>FaPaintRoller);
parcelHelpers.export(exports, "FaPager", ()=>FaPager);
parcelHelpers.export(exports, "FaP", ()=>FaP);
parcelHelpers.export(exports, "FaOutdent", ()=>FaOutdent);
parcelHelpers.export(exports, "FaOtter", ()=>FaOtter);
parcelHelpers.export(exports, "FaOm", ()=>FaOm);
parcelHelpers.export(exports, "FaOilWell", ()=>FaOilWell);
parcelHelpers.export(exports, "FaOilCan", ()=>FaOilCan);
parcelHelpers.export(exports, "FaObjectUngroup", ()=>FaObjectUngroup);
parcelHelpers.export(exports, "FaObjectGroup", ()=>FaObjectGroup);
parcelHelpers.export(exports, "FaO", ()=>FaO);
parcelHelpers.export(exports, "FaNotesMedical", ()=>FaNotesMedical);
parcelHelpers.export(exports, "FaNoteSticky", ()=>FaNoteSticky);
parcelHelpers.export(exports, "FaNotdef", ()=>FaNotdef);
parcelHelpers.export(exports, "FaNotEqual", ()=>FaNotEqual);
parcelHelpers.export(exports, "FaNewspaper", ()=>FaNewspaper);
parcelHelpers.export(exports, "FaNeuter", ()=>FaNeuter);
parcelHelpers.export(exports, "FaNetworkWired", ()=>FaNetworkWired);
parcelHelpers.export(exports, "FaNairaSign", ()=>FaNairaSign);
parcelHelpers.export(exports, "FaN", ()=>FaN);
parcelHelpers.export(exports, "FaMusic", ()=>FaMusic);
parcelHelpers.export(exports, "FaMugSaucer", ()=>FaMugSaucer);
parcelHelpers.export(exports, "FaMugHot", ()=>FaMugHot);
parcelHelpers.export(exports, "FaMountain", ()=>FaMountain);
parcelHelpers.export(exports, "FaMountainSun", ()=>FaMountainSun);
parcelHelpers.export(exports, "FaMountainCity", ()=>FaMountainCity);
parcelHelpers.export(exports, "FaMound", ()=>FaMound);
parcelHelpers.export(exports, "FaMotorcycle", ()=>FaMotorcycle);
parcelHelpers.export(exports, "FaMosquito", ()=>FaMosquito);
parcelHelpers.export(exports, "FaMosquitoNet", ()=>FaMosquitoNet);
parcelHelpers.export(exports, "FaMosque", ()=>FaMosque);
parcelHelpers.export(exports, "FaMortarPestle", ()=>FaMortarPestle);
parcelHelpers.export(exports, "FaMoon", ()=>FaMoon);
parcelHelpers.export(exports, "FaMonument", ()=>FaMonument);
parcelHelpers.export(exports, "FaMoneyCheck", ()=>FaMoneyCheck);
parcelHelpers.export(exports, "FaMoneyCheckDollar", ()=>FaMoneyCheckDollar);
parcelHelpers.export(exports, "FaMoneyBills", ()=>FaMoneyBills);
parcelHelpers.export(exports, "FaMoneyBill", ()=>FaMoneyBill);
parcelHelpers.export(exports, "FaMoneyBillWheat", ()=>FaMoneyBillWheat);
parcelHelpers.export(exports, "FaMoneyBillWave", ()=>FaMoneyBillWave);
parcelHelpers.export(exports, "FaMoneyBillTrendUp", ()=>FaMoneyBillTrendUp);
parcelHelpers.export(exports, "FaMoneyBillTransfer", ()=>FaMoneyBillTransfer);
parcelHelpers.export(exports, "FaMoneyBill1", ()=>FaMoneyBill1);
parcelHelpers.export(exports, "FaMoneyBill1Wave", ()=>FaMoneyBill1Wave);
parcelHelpers.export(exports, "FaMobile", ()=>FaMobile);
parcelHelpers.export(exports, "FaMobileScreen", ()=>FaMobileScreen);
parcelHelpers.export(exports, "FaMobileScreenButton", ()=>FaMobileScreenButton);
parcelHelpers.export(exports, "FaMobileRetro", ()=>FaMobileRetro);
parcelHelpers.export(exports, "FaMobileButton", ()=>FaMobileButton);
parcelHelpers.export(exports, "FaMitten", ()=>FaMitten);
parcelHelpers.export(exports, "FaMinus", ()=>FaMinus);
parcelHelpers.export(exports, "FaMinimize", ()=>FaMinimize);
parcelHelpers.export(exports, "FaMillSign", ()=>FaMillSign);
parcelHelpers.export(exports, "FaMicroscope", ()=>FaMicroscope);
parcelHelpers.export(exports, "FaMicrophone", ()=>FaMicrophone);
parcelHelpers.export(exports, "FaMicrophoneSlash", ()=>FaMicrophoneSlash);
parcelHelpers.export(exports, "FaMicrophoneLines", ()=>FaMicrophoneLines);
parcelHelpers.export(exports, "FaMicrophoneLinesSlash", ()=>FaMicrophoneLinesSlash);
parcelHelpers.export(exports, "FaMicrochip", ()=>FaMicrochip);
parcelHelpers.export(exports, "FaMeteor", ()=>FaMeteor);
parcelHelpers.export(exports, "FaMessage", ()=>FaMessage);
parcelHelpers.export(exports, "FaMercury", ()=>FaMercury);
parcelHelpers.export(exports, "FaMenorah", ()=>FaMenorah);
parcelHelpers.export(exports, "FaMemory", ()=>FaMemory);
parcelHelpers.export(exports, "FaMedal", ()=>FaMedal);
parcelHelpers.export(exports, "FaMaximize", ()=>FaMaximize);
parcelHelpers.export(exports, "FaMattressPillow", ()=>FaMattressPillow);
parcelHelpers.export(exports, "FaMasksTheater", ()=>FaMasksTheater);
parcelHelpers.export(exports, "FaMask", ()=>FaMask);
parcelHelpers.export(exports, "FaMaskVentilator", ()=>FaMaskVentilator);
parcelHelpers.export(exports, "FaMaskFace", ()=>FaMaskFace);
parcelHelpers.export(exports, "FaMartiniGlass", ()=>FaMartiniGlass);
parcelHelpers.export(exports, "FaMartiniGlassEmpty", ()=>FaMartiniGlassEmpty);
parcelHelpers.export(exports, "FaMartiniGlassCitrus", ()=>FaMartiniGlassCitrus);
parcelHelpers.export(exports, "FaMars", ()=>FaMars);
parcelHelpers.export(exports, "FaMarsStroke", ()=>FaMarsStroke);
parcelHelpers.export(exports, "FaMarsStrokeUp", ()=>FaMarsStrokeUp);
parcelHelpers.export(exports, "FaMarsStrokeRight", ()=>FaMarsStrokeRight);
parcelHelpers.export(exports, "FaMarsDouble", ()=>FaMarsDouble);
parcelHelpers.export(exports, "FaMarsAndVenus", ()=>FaMarsAndVenus);
parcelHelpers.export(exports, "FaMarsAndVenusBurst", ()=>FaMarsAndVenusBurst);
parcelHelpers.export(exports, "FaMarker", ()=>FaMarker);
parcelHelpers.export(exports, "FaMap", ()=>FaMap);
parcelHelpers.export(exports, "FaMapPin", ()=>FaMapPin);
parcelHelpers.export(exports, "FaMapLocation", ()=>FaMapLocation);
parcelHelpers.export(exports, "FaMapLocationDot", ()=>FaMapLocationDot);
parcelHelpers.export(exports, "FaManatSign", ()=>FaManatSign);
parcelHelpers.export(exports, "FaMagnifyingGlass", ()=>FaMagnifyingGlass);
parcelHelpers.export(exports, "FaMagnifyingGlassPlus", ()=>FaMagnifyingGlassPlus);
parcelHelpers.export(exports, "FaMagnifyingGlassMinus", ()=>FaMagnifyingGlassMinus);
parcelHelpers.export(exports, "FaMagnifyingGlassLocation", ()=>FaMagnifyingGlassLocation);
parcelHelpers.export(exports, "FaMagnifyingGlassDollar", ()=>FaMagnifyingGlassDollar);
parcelHelpers.export(exports, "FaMagnifyingGlassChart", ()=>FaMagnifyingGlassChart);
parcelHelpers.export(exports, "FaMagnifyingGlassArrowRight", ()=>FaMagnifyingGlassArrowRight);
parcelHelpers.export(exports, "FaMagnet", ()=>FaMagnet);
parcelHelpers.export(exports, "FaM", ()=>FaM);
parcelHelpers.export(exports, "FaLungs", ()=>FaLungs);
parcelHelpers.export(exports, "FaLungsVirus", ()=>FaLungsVirus);
parcelHelpers.export(exports, "FaLocust", ()=>FaLocust);
parcelHelpers.export(exports, "FaLock", ()=>FaLock);
parcelHelpers.export(exports, "FaLockOpen", ()=>FaLockOpen);
parcelHelpers.export(exports, "FaLocationPin", ()=>FaLocationPin);
parcelHelpers.export(exports, "FaLocationPinLock", ()=>FaLocationPinLock);
parcelHelpers.export(exports, "FaLocationDot", ()=>FaLocationDot);
parcelHelpers.export(exports, "FaLocationCrosshairs", ()=>FaLocationCrosshairs);
parcelHelpers.export(exports, "FaLocationArrow", ()=>FaLocationArrow);
parcelHelpers.export(exports, "FaLitecoinSign", ()=>FaLitecoinSign);
parcelHelpers.export(exports, "FaList", ()=>FaList);
parcelHelpers.export(exports, "FaListUl", ()=>FaListUl);
parcelHelpers.export(exports, "FaListOl", ()=>FaListOl);
parcelHelpers.export(exports, "FaListCheck", ()=>FaListCheck);
parcelHelpers.export(exports, "FaLiraSign", ()=>FaLiraSign);
parcelHelpers.export(exports, "FaLink", ()=>FaLink);
parcelHelpers.export(exports, "FaLinkSlash", ()=>FaLinkSlash);
parcelHelpers.export(exports, "FaLinesLeaning", ()=>FaLinesLeaning);
parcelHelpers.export(exports, "FaLightbulb", ()=>FaLightbulb);
parcelHelpers.export(exports, "FaLifeRing", ()=>FaLifeRing);
parcelHelpers.export(exports, "FaLessThan", ()=>FaLessThan);
parcelHelpers.export(exports, "FaLessThanEqual", ()=>FaLessThanEqual);
parcelHelpers.export(exports, "FaLemon", ()=>FaLemon);
parcelHelpers.export(exports, "FaLeftRight", ()=>FaLeftRight);
parcelHelpers.export(exports, "FaLeftLong", ()=>FaLeftLong);
parcelHelpers.export(exports, "FaLeaf", ()=>FaLeaf);
parcelHelpers.export(exports, "FaLayerGroup", ()=>FaLayerGroup);
parcelHelpers.export(exports, "FaLariSign", ()=>FaLariSign);
parcelHelpers.export(exports, "FaLaptop", ()=>FaLaptop);
parcelHelpers.export(exports, "FaLaptopMedical", ()=>FaLaptopMedical);
parcelHelpers.export(exports, "FaLaptopFile", ()=>FaLaptopFile);
parcelHelpers.export(exports, "FaLaptopCode", ()=>FaLaptopCode);
parcelHelpers.export(exports, "FaLanguage", ()=>FaLanguage);
parcelHelpers.export(exports, "FaLandmark", ()=>FaLandmark);
parcelHelpers.export(exports, "FaLandmarkFlag", ()=>FaLandmarkFlag);
parcelHelpers.export(exports, "FaLandmarkDome", ()=>FaLandmarkDome);
parcelHelpers.export(exports, "FaLandMineOn", ()=>FaLandMineOn);
parcelHelpers.export(exports, "FaL", ()=>FaL);
parcelHelpers.export(exports, "FaKiwiBird", ()=>FaKiwiBird);
parcelHelpers.export(exports, "FaKitchenSet", ()=>FaKitchenSet);
parcelHelpers.export(exports, "FaKitMedical", ()=>FaKitMedical);
parcelHelpers.export(exports, "FaKipSign", ()=>FaKipSign);
parcelHelpers.export(exports, "FaKhanda", ()=>FaKhanda);
parcelHelpers.export(exports, "FaKeyboard", ()=>FaKeyboard);
parcelHelpers.export(exports, "FaKey", ()=>FaKey);
parcelHelpers.export(exports, "FaKaaba", ()=>FaKaaba);
parcelHelpers.export(exports, "FaK", ()=>FaK);
parcelHelpers.export(exports, "FaJugDetergent", ()=>FaJugDetergent);
parcelHelpers.export(exports, "FaJoint", ()=>FaJoint);
parcelHelpers.export(exports, "FaJetFighter", ()=>FaJetFighter);
parcelHelpers.export(exports, "FaJetFighterUp", ()=>FaJetFighterUp);
parcelHelpers.export(exports, "FaJedi", ()=>FaJedi);
parcelHelpers.export(exports, "FaJar", ()=>FaJar);
parcelHelpers.export(exports, "FaJarWheat", ()=>FaJarWheat);
parcelHelpers.export(exports, "FaJ", ()=>FaJ);
parcelHelpers.export(exports, "FaItalic", ()=>FaItalic);
parcelHelpers.export(exports, "FaInfo", ()=>FaInfo);
parcelHelpers.export(exports, "FaInfinity", ()=>FaInfinity);
parcelHelpers.export(exports, "FaIndustry", ()=>FaIndustry);
parcelHelpers.export(exports, "FaIndianRupeeSign", ()=>FaIndianRupeeSign);
parcelHelpers.export(exports, "FaIndent", ()=>FaIndent);
parcelHelpers.export(exports, "FaInbox", ()=>FaInbox);
parcelHelpers.export(exports, "FaImages", ()=>FaImages);
parcelHelpers.export(exports, "FaImage", ()=>FaImage);
parcelHelpers.export(exports, "FaImagePortrait", ()=>FaImagePortrait);
parcelHelpers.export(exports, "FaIgloo", ()=>FaIgloo);
parcelHelpers.export(exports, "FaIdCard", ()=>FaIdCard);
parcelHelpers.export(exports, "FaIdCardClip", ()=>FaIdCardClip);
parcelHelpers.export(exports, "FaIdBadge", ()=>FaIdBadge);
parcelHelpers.export(exports, "FaIcons", ()=>FaIcons);
parcelHelpers.export(exports, "FaIcicles", ()=>FaIcicles);
parcelHelpers.export(exports, "FaIceCream", ()=>FaIceCream);
parcelHelpers.export(exports, "FaI", ()=>FaI);
parcelHelpers.export(exports, "FaICursor", ()=>FaICursor);
parcelHelpers.export(exports, "FaHurricane", ()=>FaHurricane);
parcelHelpers.export(exports, "FaHryvniaSign", ()=>FaHryvniaSign);
parcelHelpers.export(exports, "FaHouse", ()=>FaHouse);
parcelHelpers.export(exports, "FaHouseUser", ()=>FaHouseUser);
parcelHelpers.export(exports, "FaHouseTsunami", ()=>FaHouseTsunami);
parcelHelpers.export(exports, "FaHouseSignal", ()=>FaHouseSignal);
parcelHelpers.export(exports, "FaHouseMedical", ()=>FaHouseMedical);
parcelHelpers.export(exports, "FaHouseMedicalFlag", ()=>FaHouseMedicalFlag);
parcelHelpers.export(exports, "FaHouseMedicalCircleXmark", ()=>FaHouseMedicalCircleXmark);
parcelHelpers.export(exports, "FaHouseMedicalCircleExclamation", ()=>FaHouseMedicalCircleExclamation);
parcelHelpers.export(exports, "FaHouseMedicalCircleCheck", ()=>FaHouseMedicalCircleCheck);
parcelHelpers.export(exports, "FaHouseLock", ()=>FaHouseLock);
parcelHelpers.export(exports, "FaHouseLaptop", ()=>FaHouseLaptop);
parcelHelpers.export(exports, "FaHouseFloodWater", ()=>FaHouseFloodWater);
parcelHelpers.export(exports, "FaHouseFloodWaterCircleArrowRight", ()=>FaHouseFloodWaterCircleArrowRight);
parcelHelpers.export(exports, "FaHouseFlag", ()=>FaHouseFlag);
parcelHelpers.export(exports, "FaHouseFire", ()=>FaHouseFire);
parcelHelpers.export(exports, "FaHouseCrack", ()=>FaHouseCrack);
parcelHelpers.export(exports, "FaHouseCircleXmark", ()=>FaHouseCircleXmark);
parcelHelpers.export(exports, "FaHouseCircleExclamation", ()=>FaHouseCircleExclamation);
parcelHelpers.export(exports, "FaHouseCircleCheck", ()=>FaHouseCircleCheck);
parcelHelpers.export(exports, "FaHouseChimney", ()=>FaHouseChimney);
parcelHelpers.export(exports, "FaHouseChimneyWindow", ()=>FaHouseChimneyWindow);
parcelHelpers.export(exports, "FaHouseChimneyUser", ()=>FaHouseChimneyUser);
parcelHelpers.export(exports, "FaHouseChimneyMedical", ()=>FaHouseChimneyMedical);
parcelHelpers.export(exports, "FaHouseChimneyCrack", ()=>FaHouseChimneyCrack);
parcelHelpers.export(exports, "FaHourglass", ()=>FaHourglass);
parcelHelpers.export(exports, "FaHourglassStart", ()=>FaHourglassStart);
parcelHelpers.export(exports, "FaHourglassHalf", ()=>FaHourglassHalf);
parcelHelpers.export(exports, "FaHourglassEnd", ()=>FaHourglassEnd);
parcelHelpers.export(exports, "FaHotel", ()=>FaHotel);
parcelHelpers.export(exports, "FaHotdog", ()=>FaHotdog);
parcelHelpers.export(exports, "FaHotTubPerson", ()=>FaHotTubPerson);
parcelHelpers.export(exports, "FaHospital", ()=>FaHospital);
parcelHelpers.export(exports, "FaHospitalUser", ()=>FaHospitalUser);
parcelHelpers.export(exports, "FaHorse", ()=>FaHorse);
parcelHelpers.export(exports, "FaHorseHead", ()=>FaHorseHead);
parcelHelpers.export(exports, "FaHollyBerry", ()=>FaHollyBerry);
parcelHelpers.export(exports, "FaHockeyPuck", ()=>FaHockeyPuck);
parcelHelpers.export(exports, "FaHippo", ()=>FaHippo);
parcelHelpers.export(exports, "FaHillRockslide", ()=>FaHillRockslide);
parcelHelpers.export(exports, "FaHillAvalanche", ()=>FaHillAvalanche);
parcelHelpers.export(exports, "FaHighlighter", ()=>FaHighlighter);
parcelHelpers.export(exports, "FaHexagonNodes", ()=>FaHexagonNodes);
parcelHelpers.export(exports, "FaHexagonNodesBolt", ()=>FaHexagonNodesBolt);
parcelHelpers.export(exports, "FaHelmetUn", ()=>FaHelmetUn);
parcelHelpers.export(exports, "FaHelmetSafety", ()=>FaHelmetSafety);
parcelHelpers.export(exports, "FaHelicopter", ()=>FaHelicopter);
parcelHelpers.export(exports, "FaHelicopterSymbol", ()=>FaHelicopterSymbol);
parcelHelpers.export(exports, "FaHeart", ()=>FaHeart);
parcelHelpers.export(exports, "FaHeartPulse", ()=>FaHeartPulse);
parcelHelpers.export(exports, "FaHeartCrack", ()=>FaHeartCrack);
parcelHelpers.export(exports, "FaHeartCircleXmark", ()=>FaHeartCircleXmark);
parcelHelpers.export(exports, "FaHeartCirclePlus", ()=>FaHeartCirclePlus);
parcelHelpers.export(exports, "FaHeartCircleMinus", ()=>FaHeartCircleMinus);
parcelHelpers.export(exports, "FaHeartCircleExclamation", ()=>FaHeartCircleExclamation);
parcelHelpers.export(exports, "FaHeartCircleCheck", ()=>FaHeartCircleCheck);
parcelHelpers.export(exports, "FaHeartCircleBolt", ()=>FaHeartCircleBolt);
parcelHelpers.export(exports, "FaHeadset", ()=>FaHeadset);
parcelHelpers.export(exports, "FaHeadphones", ()=>FaHeadphones);
parcelHelpers.export(exports, "FaHeadphonesSimple", ()=>FaHeadphonesSimple);
parcelHelpers.export(exports, "FaHeading", ()=>FaHeading);
parcelHelpers.export(exports, "FaHeadSideVirus", ()=>FaHeadSideVirus);
parcelHelpers.export(exports, "FaHeadSideMask", ()=>FaHeadSideMask);
parcelHelpers.export(exports, "FaHeadSideCough", ()=>FaHeadSideCough);
parcelHelpers.export(exports, "FaHeadSideCoughSlash", ()=>FaHeadSideCoughSlash);
parcelHelpers.export(exports, "FaHatWizard", ()=>FaHatWizard);
parcelHelpers.export(exports, "FaHatCowboy", ()=>FaHatCowboy);
parcelHelpers.export(exports, "FaHatCowboySide", ()=>FaHatCowboySide);
parcelHelpers.export(exports, "FaHashtag", ()=>FaHashtag);
parcelHelpers.export(exports, "FaHardDrive", ()=>FaHardDrive);
parcelHelpers.export(exports, "FaHanukiah", ()=>FaHanukiah);
parcelHelpers.export(exports, "FaHandshake", ()=>FaHandshake);
parcelHelpers.export(exports, "FaHandshakeSlash", ()=>FaHandshakeSlash);
parcelHelpers.export(exports, "FaHandshakeSimple", ()=>FaHandshakeSimple);
parcelHelpers.export(exports, "FaHandshakeSimpleSlash", ()=>FaHandshakeSimpleSlash);
parcelHelpers.export(exports, "FaHandshakeAngle", ()=>FaHandshakeAngle);
parcelHelpers.export(exports, "FaHands", ()=>FaHands);
parcelHelpers.export(exports, "FaHandsPraying", ()=>FaHandsPraying);
parcelHelpers.export(exports, "FaHandsHolding", ()=>FaHandsHolding);
parcelHelpers.export(exports, "FaHandsHoldingCircle", ()=>FaHandsHoldingCircle);
parcelHelpers.export(exports, "FaHandsHoldingChild", ()=>FaHandsHoldingChild);
parcelHelpers.export(exports, "FaHandsClapping", ()=>FaHandsClapping);
parcelHelpers.export(exports, "FaHandsBubbles", ()=>FaHandsBubbles);
parcelHelpers.export(exports, "FaHandsBound", ()=>FaHandsBound);
parcelHelpers.export(exports, "FaHandsAslInterpreting", ()=>FaHandsAslInterpreting);
parcelHelpers.export(exports, "FaHandcuffs", ()=>FaHandcuffs);
parcelHelpers.export(exports, "FaHand", ()=>FaHand);
parcelHelpers.export(exports, "FaHandSpock", ()=>FaHandSpock);
parcelHelpers.export(exports, "FaHandSparkles", ()=>FaHandSparkles);
parcelHelpers.export(exports, "FaHandScissors", ()=>FaHandScissors);
parcelHelpers.export(exports, "FaHandPointer", ()=>FaHandPointer);
parcelHelpers.export(exports, "FaHandPointUp", ()=>FaHandPointUp);
parcelHelpers.export(exports, "FaHandPointRight", ()=>FaHandPointRight);
parcelHelpers.export(exports, "FaHandPointLeft", ()=>FaHandPointLeft);
parcelHelpers.export(exports, "FaHandPointDown", ()=>FaHandPointDown);
parcelHelpers.export(exports, "FaHandPeace", ()=>FaHandPeace);
parcelHelpers.export(exports, "FaHandMiddleFinger", ()=>FaHandMiddleFinger);
parcelHelpers.export(exports, "FaHandLizard", ()=>FaHandLizard);
parcelHelpers.export(exports, "FaHandHolding", ()=>FaHandHolding);
parcelHelpers.export(exports, "FaHandHoldingMedical", ()=>FaHandHoldingMedical);
parcelHelpers.export(exports, "FaHandHoldingHeart", ()=>FaHandHoldingHeart);
parcelHelpers.export(exports, "FaHandHoldingHand", ()=>FaHandHoldingHand);
parcelHelpers.export(exports, "FaHandHoldingDroplet", ()=>FaHandHoldingDroplet);
parcelHelpers.export(exports, "FaHandHoldingDollar", ()=>FaHandHoldingDollar);
parcelHelpers.export(exports, "FaHandFist", ()=>FaHandFist);
parcelHelpers.export(exports, "FaHandDots", ()=>FaHandDots);
parcelHelpers.export(exports, "FaHandBackFist", ()=>FaHandBackFist);
parcelHelpers.export(exports, "FaHamsa", ()=>FaHamsa);
parcelHelpers.export(exports, "FaHammer", ()=>FaHammer);
parcelHelpers.export(exports, "FaH", ()=>FaH);
parcelHelpers.export(exports, "FaGun", ()=>FaGun);
parcelHelpers.export(exports, "FaGuitar", ()=>FaGuitar);
parcelHelpers.export(exports, "FaGuaraniSign", ()=>FaGuaraniSign);
parcelHelpers.export(exports, "FaGroupArrowsRotate", ()=>FaGroupArrowsRotate);
parcelHelpers.export(exports, "FaGrip", ()=>FaGrip);
parcelHelpers.export(exports, "FaGripVertical", ()=>FaGripVertical);
parcelHelpers.export(exports, "FaGripLines", ()=>FaGripLines);
parcelHelpers.export(exports, "FaGripLinesVertical", ()=>FaGripLinesVertical);
parcelHelpers.export(exports, "FaGreaterThan", ()=>FaGreaterThan);
parcelHelpers.export(exports, "FaGreaterThanEqual", ()=>FaGreaterThanEqual);
parcelHelpers.export(exports, "FaGraduationCap", ()=>FaGraduationCap);
parcelHelpers.export(exports, "FaGopuram", ()=>FaGopuram);
parcelHelpers.export(exports, "FaGolfBallTee", ()=>FaGolfBallTee);
parcelHelpers.export(exports, "FaGlobe", ()=>FaGlobe);
parcelHelpers.export(exports, "FaGlasses", ()=>FaGlasses);
parcelHelpers.export(exports, "FaGlassWater", ()=>FaGlassWater);
parcelHelpers.export(exports, "FaGlassWaterDroplet", ()=>FaGlassWaterDroplet);
parcelHelpers.export(exports, "FaGifts", ()=>FaGifts);
parcelHelpers.export(exports, "FaGift", ()=>FaGift);
parcelHelpers.export(exports, "FaGhost", ()=>FaGhost);
parcelHelpers.export(exports, "FaGenderless", ()=>FaGenderless);
parcelHelpers.export(exports, "FaGem", ()=>FaGem);
parcelHelpers.export(exports, "FaGears", ()=>FaGears);
parcelHelpers.export(exports, "FaGear", ()=>FaGear);
parcelHelpers.export(exports, "FaGavel", ()=>FaGavel);
parcelHelpers.export(exports, "FaGauge", ()=>FaGauge);
parcelHelpers.export(exports, "FaGaugeSimple", ()=>FaGaugeSimple);
parcelHelpers.export(exports, "FaGaugeSimpleHigh", ()=>FaGaugeSimpleHigh);
parcelHelpers.export(exports, "FaGaugeHigh", ()=>FaGaugeHigh);
parcelHelpers.export(exports, "FaGasPump", ()=>FaGasPump);
parcelHelpers.export(exports, "FaGamepad", ()=>FaGamepad);
parcelHelpers.export(exports, "FaG", ()=>FaG);
parcelHelpers.export(exports, "FaFutbol", ()=>FaFutbol);
parcelHelpers.export(exports, "FaFrog", ()=>FaFrog);
parcelHelpers.export(exports, "FaFrancSign", ()=>FaFrancSign);
parcelHelpers.export(exports, "FaForward", ()=>FaForward);
parcelHelpers.export(exports, "FaForwardStep", ()=>FaForwardStep);
parcelHelpers.export(exports, "FaForwardFast", ()=>FaForwardFast);
parcelHelpers.export(exports, "FaFootball", ()=>FaFootball);
parcelHelpers.export(exports, "FaFont", ()=>FaFont);
parcelHelpers.export(exports, "FaFolder", ()=>FaFolder);
parcelHelpers.export(exports, "FaFolderTree", ()=>FaFolderTree);
parcelHelpers.export(exports, "FaFolderPlus", ()=>FaFolderPlus);
parcelHelpers.export(exports, "FaFolderOpen", ()=>FaFolderOpen);
parcelHelpers.export(exports, "FaFolderMinus", ()=>FaFolderMinus);
parcelHelpers.export(exports, "FaFolderClosed", ()=>FaFolderClosed);
parcelHelpers.export(exports, "FaFlorinSign", ()=>FaFlorinSign);
parcelHelpers.export(exports, "FaFloppyDisk", ()=>FaFloppyDisk);
parcelHelpers.export(exports, "FaFlask", ()=>FaFlask);
parcelHelpers.export(exports, "FaFlaskVial", ()=>FaFlaskVial);
parcelHelpers.export(exports, "FaFlag", ()=>FaFlag);
parcelHelpers.export(exports, "FaFlagUsa", ()=>FaFlagUsa);
parcelHelpers.export(exports, "FaFlagCheckered", ()=>FaFlagCheckered);
parcelHelpers.export(exports, "FaFish", ()=>FaFish);
parcelHelpers.export(exports, "FaFishFins", ()=>FaFishFins);
parcelHelpers.export(exports, "FaFire", ()=>FaFire);
parcelHelpers.export(exports, "FaFireFlameSimple", ()=>FaFireFlameSimple);
parcelHelpers.export(exports, "FaFireFlameCurved", ()=>FaFireFlameCurved);
parcelHelpers.export(exports, "FaFireExtinguisher", ()=>FaFireExtinguisher);
parcelHelpers.export(exports, "FaFireBurner", ()=>FaFireBurner);
parcelHelpers.export(exports, "FaFingerprint", ()=>FaFingerprint);
parcelHelpers.export(exports, "FaFilter", ()=>FaFilter);
parcelHelpers.export(exports, "FaFilterCircleXmark", ()=>FaFilterCircleXmark);
parcelHelpers.export(exports, "FaFilterCircleDollar", ()=>FaFilterCircleDollar);
parcelHelpers.export(exports, "FaFilm", ()=>FaFilm);
parcelHelpers.export(exports, "FaFill", ()=>FaFill);
parcelHelpers.export(exports, "FaFillDrip", ()=>FaFillDrip);
parcelHelpers.export(exports, "FaFile", ()=>FaFile);
parcelHelpers.export(exports, "FaFileZipper", ()=>FaFileZipper);
parcelHelpers.export(exports, "FaFileWord", ()=>FaFileWord);
parcelHelpers.export(exports, "FaFileWaveform", ()=>FaFileWaveform);
parcelHelpers.export(exports, "FaFileVideo", ()=>FaFileVideo);
parcelHelpers.export(exports, "FaFileSignature", ()=>FaFileSignature);
parcelHelpers.export(exports, "FaFileShield", ()=>FaFileShield);
parcelHelpers.export(exports, "FaFilePrescription", ()=>FaFilePrescription);
parcelHelpers.export(exports, "FaFilePowerpoint", ()=>FaFilePowerpoint);
parcelHelpers.export(exports, "FaFilePen", ()=>FaFilePen);
parcelHelpers.export(exports, "FaFilePdf", ()=>FaFilePdf);
parcelHelpers.export(exports, "FaFileMedical", ()=>FaFileMedical);
parcelHelpers.export(exports, "FaFileLines", ()=>FaFileLines);
parcelHelpers.export(exports, "FaFileInvoice", ()=>FaFileInvoice);
parcelHelpers.export(exports, "FaFileInvoiceDollar", ()=>FaFileInvoiceDollar);
parcelHelpers.export(exports, "FaFileImport", ()=>FaFileImport);
parcelHelpers.export(exports, "FaFileImage", ()=>FaFileImage);
parcelHelpers.export(exports, "FaFileHalfDashed", ()=>FaFileHalfDashed);
parcelHelpers.export(exports, "FaFileFragment", ()=>FaFileFragment);
parcelHelpers.export(exports, "FaFileExport", ()=>FaFileExport);
parcelHelpers.export(exports, "FaFileExcel", ()=>FaFileExcel);
parcelHelpers.export(exports, "FaFileCsv", ()=>FaFileCsv);
parcelHelpers.export(exports, "FaFileContract", ()=>FaFileContract);
parcelHelpers.export(exports, "FaFileCode", ()=>FaFileCode);
parcelHelpers.export(exports, "FaFileCircleXmark", ()=>FaFileCircleXmark);
parcelHelpers.export(exports, "FaFileCircleQuestion", ()=>FaFileCircleQuestion);
parcelHelpers.export(exports, "FaFileCirclePlus", ()=>FaFileCirclePlus);
parcelHelpers.export(exports, "FaFileCircleMinus", ()=>FaFileCircleMinus);
parcelHelpers.export(exports, "FaFileCircleExclamation", ()=>FaFileCircleExclamation);
parcelHelpers.export(exports, "FaFileCircleCheck", ()=>FaFileCircleCheck);
parcelHelpers.export(exports, "FaFileAudio", ()=>FaFileAudio);
parcelHelpers.export(exports, "FaFileArrowUp", ()=>FaFileArrowUp);
parcelHelpers.export(exports, "FaFileArrowDown", ()=>FaFileArrowDown);
parcelHelpers.export(exports, "FaFerry", ()=>FaFerry);
parcelHelpers.export(exports, "FaFeather", ()=>FaFeather);
parcelHelpers.export(exports, "FaFeatherPointed", ()=>FaFeatherPointed);
parcelHelpers.export(exports, "FaFax", ()=>FaFax);
parcelHelpers.export(exports, "FaFaucet", ()=>FaFaucet);
parcelHelpers.export(exports, "FaFaucetDrip", ()=>FaFaucetDrip);
parcelHelpers.export(exports, "FaFan", ()=>FaFan);
parcelHelpers.export(exports, "FaFaceTired", ()=>FaFaceTired);
parcelHelpers.export(exports, "FaFaceSurprise", ()=>FaFaceSurprise);
parcelHelpers.export(exports, "FaFaceSmile", ()=>FaFaceSmile);
parcelHelpers.export(exports, "FaFaceSmileWink", ()=>FaFaceSmileWink);
parcelHelpers.export(exports, "FaFaceSmileBeam", ()=>FaFaceSmileBeam);
parcelHelpers.export(exports, "FaFaceSadTear", ()=>FaFaceSadTear);
parcelHelpers.export(exports, "FaFaceSadCry", ()=>FaFaceSadCry);
parcelHelpers.export(exports, "FaFaceRollingEyes", ()=>FaFaceRollingEyes);
parcelHelpers.export(exports, "FaFaceMeh", ()=>FaFaceMeh);
parcelHelpers.export(exports, "FaFaceMehBlank", ()=>FaFaceMehBlank);
parcelHelpers.export(exports, "FaFaceLaugh", ()=>FaFaceLaugh);
parcelHelpers.export(exports, "FaFaceLaughWink", ()=>FaFaceLaughWink);
parcelHelpers.export(exports, "FaFaceLaughSquint", ()=>FaFaceLaughSquint);
parcelHelpers.export(exports, "FaFaceLaughBeam", ()=>FaFaceLaughBeam);
parcelHelpers.export(exports, "FaFaceKiss", ()=>FaFaceKiss);
parcelHelpers.export(exports, "FaFaceKissWinkHeart", ()=>FaFaceKissWinkHeart);
parcelHelpers.export(exports, "FaFaceKissBeam", ()=>FaFaceKissBeam);
parcelHelpers.export(exports, "FaFaceGrin", ()=>FaFaceGrin);
parcelHelpers.export(exports, "FaFaceGrinWink", ()=>FaFaceGrinWink);
parcelHelpers.export(exports, "FaFaceGrinWide", ()=>FaFaceGrinWide);
parcelHelpers.export(exports, "FaFaceGrinTongue", ()=>FaFaceGrinTongue);
parcelHelpers.export(exports, "FaFaceGrinTongueWink", ()=>FaFaceGrinTongueWink);
parcelHelpers.export(exports, "FaFaceGrinTongueSquint", ()=>FaFaceGrinTongueSquint);
parcelHelpers.export(exports, "FaFaceGrinTears", ()=>FaFaceGrinTears);
parcelHelpers.export(exports, "FaFaceGrinStars", ()=>FaFaceGrinStars);
parcelHelpers.export(exports, "FaFaceGrinSquint", ()=>FaFaceGrinSquint);
parcelHelpers.export(exports, "FaFaceGrinSquintTears", ()=>FaFaceGrinSquintTears);
parcelHelpers.export(exports, "FaFaceGrinHearts", ()=>FaFaceGrinHearts);
parcelHelpers.export(exports, "FaFaceGrinBeam", ()=>FaFaceGrinBeam);
parcelHelpers.export(exports, "FaFaceGrinBeamSweat", ()=>FaFaceGrinBeamSweat);
parcelHelpers.export(exports, "FaFaceGrimace", ()=>FaFaceGrimace);
parcelHelpers.export(exports, "FaFaceFrown", ()=>FaFaceFrown);
parcelHelpers.export(exports, "FaFaceFrownOpen", ()=>FaFaceFrownOpen);
parcelHelpers.export(exports, "FaFaceFlushed", ()=>FaFaceFlushed);
parcelHelpers.export(exports, "FaFaceDizzy", ()=>FaFaceDizzy);
parcelHelpers.export(exports, "FaFaceAngry", ()=>FaFaceAngry);
parcelHelpers.export(exports, "FaF", ()=>FaF);
parcelHelpers.export(exports, "FaEye", ()=>FaEye);
parcelHelpers.export(exports, "FaEyeSlash", ()=>FaEyeSlash);
parcelHelpers.export(exports, "FaEyeLowVision", ()=>FaEyeLowVision);
parcelHelpers.export(exports, "FaEyeDropper", ()=>FaEyeDropper);
parcelHelpers.export(exports, "FaExplosion", ()=>FaExplosion);
parcelHelpers.export(exports, "FaExpand", ()=>FaExpand);
parcelHelpers.export(exports, "FaExclamation", ()=>FaExclamation);
parcelHelpers.export(exports, "FaEuroSign", ()=>FaEuroSign);
parcelHelpers.export(exports, "FaEthernet", ()=>FaEthernet);
parcelHelpers.export(exports, "FaEraser", ()=>FaEraser);
parcelHelpers.export(exports, "FaEquals", ()=>FaEquals);
parcelHelpers.export(exports, "FaEnvelopesBulk", ()=>FaEnvelopesBulk);
parcelHelpers.export(exports, "FaEnvelope", ()=>FaEnvelope);
parcelHelpers.export(exports, "FaEnvelopeOpen", ()=>FaEnvelopeOpen);
parcelHelpers.export(exports, "FaEnvelopeOpenText", ()=>FaEnvelopeOpenText);
parcelHelpers.export(exports, "FaEnvelopeCircleCheck", ()=>FaEnvelopeCircleCheck);
parcelHelpers.export(exports, "FaEllipsis", ()=>FaEllipsis);
parcelHelpers.export(exports, "FaEllipsisVertical", ()=>FaEllipsisVertical);
parcelHelpers.export(exports, "FaElevator", ()=>FaElevator);
parcelHelpers.export(exports, "FaEject", ()=>FaEject);
parcelHelpers.export(exports, "FaEgg", ()=>FaEgg);
parcelHelpers.export(exports, "FaEarthOceania", ()=>FaEarthOceania);
parcelHelpers.export(exports, "FaEarthEurope", ()=>FaEarthEurope);
parcelHelpers.export(exports, "FaEarthAsia", ()=>FaEarthAsia);
parcelHelpers.export(exports, "FaEarthAmericas", ()=>FaEarthAmericas);
parcelHelpers.export(exports, "FaEarthAfrica", ()=>FaEarthAfrica);
parcelHelpers.export(exports, "FaEarListen", ()=>FaEarListen);
parcelHelpers.export(exports, "FaEarDeaf", ()=>FaEarDeaf);
parcelHelpers.export(exports, "FaE", ()=>FaE);
parcelHelpers.export(exports, "FaDungeon", ()=>FaDungeon);
parcelHelpers.export(exports, "FaDumpster", ()=>FaDumpster);
parcelHelpers.export(exports, "FaDumpsterFire", ()=>FaDumpsterFire);
parcelHelpers.export(exports, "FaDumbbell", ()=>FaDumbbell);
parcelHelpers.export(exports, "FaDrumstickBite", ()=>FaDrumstickBite);
parcelHelpers.export(exports, "FaDrum", ()=>FaDrum);
parcelHelpers.export(exports, "FaDrumSteelpan", ()=>FaDrumSteelpan);
parcelHelpers.export(exports, "FaDroplet", ()=>FaDroplet);
parcelHelpers.export(exports, "FaDropletSlash", ()=>FaDropletSlash);
parcelHelpers.export(exports, "FaDrawPolygon", ()=>FaDrawPolygon);
parcelHelpers.export(exports, "FaDragon", ()=>FaDragon);
parcelHelpers.export(exports, "FaDownload", ()=>FaDownload);
parcelHelpers.export(exports, "FaDownLong", ()=>FaDownLong);
parcelHelpers.export(exports, "FaDownLeftAndUpRightToCenter", ()=>FaDownLeftAndUpRightToCenter);
parcelHelpers.export(exports, "FaDove", ()=>FaDove);
parcelHelpers.export(exports, "FaDoorOpen", ()=>FaDoorOpen);
parcelHelpers.export(exports, "FaDoorClosed", ()=>FaDoorClosed);
parcelHelpers.export(exports, "FaDongSign", ()=>FaDongSign);
parcelHelpers.export(exports, "FaDolly", ()=>FaDolly);
parcelHelpers.export(exports, "FaDollarSign", ()=>FaDollarSign);
parcelHelpers.export(exports, "FaDog", ()=>FaDog);
parcelHelpers.export(exports, "FaDna", ()=>FaDna);
parcelHelpers.export(exports, "FaDivide", ()=>FaDivide);
parcelHelpers.export(exports, "FaDisplay", ()=>FaDisplay);
parcelHelpers.export(exports, "FaDisease", ()=>FaDisease);
parcelHelpers.export(exports, "FaDice", ()=>FaDice);
parcelHelpers.export(exports, "FaDiceTwo", ()=>FaDiceTwo);
parcelHelpers.export(exports, "FaDiceThree", ()=>FaDiceThree);
parcelHelpers.export(exports, "FaDiceSix", ()=>FaDiceSix);
parcelHelpers.export(exports, "FaDiceOne", ()=>FaDiceOne);
parcelHelpers.export(exports, "FaDiceFour", ()=>FaDiceFour);
parcelHelpers.export(exports, "FaDiceFive", ()=>FaDiceFive);
parcelHelpers.export(exports, "FaDiceD6", ()=>FaDiceD6);
parcelHelpers.export(exports, "FaDiceD20", ()=>FaDiceD20);
parcelHelpers.export(exports, "FaDiamond", ()=>FaDiamond);
parcelHelpers.export(exports, "FaDiamondTurnRight", ()=>FaDiamondTurnRight);
parcelHelpers.export(exports, "FaDiagramSuccessor", ()=>FaDiagramSuccessor);
parcelHelpers.export(exports, "FaDiagramProject", ()=>FaDiagramProject);
parcelHelpers.export(exports, "FaDiagramPredecessor", ()=>FaDiagramPredecessor);
parcelHelpers.export(exports, "FaDiagramNext", ()=>FaDiagramNext);
parcelHelpers.export(exports, "FaDharmachakra", ()=>FaDharmachakra);
parcelHelpers.export(exports, "FaDesktop", ()=>FaDesktop);
parcelHelpers.export(exports, "FaDemocrat", ()=>FaDemocrat);
parcelHelpers.export(exports, "FaDeleteLeft", ()=>FaDeleteLeft);
parcelHelpers.export(exports, "FaDatabase", ()=>FaDatabase);
parcelHelpers.export(exports, "FaD", ()=>FaD);
parcelHelpers.export(exports, "FaCubes", ()=>FaCubes);
parcelHelpers.export(exports, "FaCubesStacked", ()=>FaCubesStacked);
parcelHelpers.export(exports, "FaCube", ()=>FaCube);
parcelHelpers.export(exports, "FaCruzeiroSign", ()=>FaCruzeiroSign);
parcelHelpers.export(exports, "FaCrutch", ()=>FaCrutch);
parcelHelpers.export(exports, "FaCrown", ()=>FaCrown);
parcelHelpers.export(exports, "FaCrow", ()=>FaCrow);
parcelHelpers.export(exports, "FaCrosshairs", ()=>FaCrosshairs);
parcelHelpers.export(exports, "FaCross", ()=>FaCross);
parcelHelpers.export(exports, "FaCrop", ()=>FaCrop);
parcelHelpers.export(exports, "FaCropSimple", ()=>FaCropSimple);
parcelHelpers.export(exports, "FaCreditCard", ()=>FaCreditCard);
parcelHelpers.export(exports, "FaCow", ()=>FaCow);
parcelHelpers.export(exports, "FaCouch", ()=>FaCouch);
parcelHelpers.export(exports, "FaCopyright", ()=>FaCopyright);
parcelHelpers.export(exports, "FaCopy", ()=>FaCopy);
parcelHelpers.export(exports, "FaCookie", ()=>FaCookie);
parcelHelpers.export(exports, "FaCookieBite", ()=>FaCookieBite);
parcelHelpers.export(exports, "FaComputer", ()=>FaComputer);
parcelHelpers.export(exports, "FaComputerMouse", ()=>FaComputerMouse);
parcelHelpers.export(exports, "FaCompress", ()=>FaCompress);
parcelHelpers.export(exports, "FaCompass", ()=>FaCompass);
parcelHelpers.export(exports, "FaCompassDrafting", ()=>FaCompassDrafting);
parcelHelpers.export(exports, "FaCompactDisc", ()=>FaCompactDisc);
parcelHelpers.export(exports, "FaComments", ()=>FaComments);
parcelHelpers.export(exports, "FaCommentsDollar", ()=>FaCommentsDollar);
parcelHelpers.export(exports, "FaComment", ()=>FaComment);
parcelHelpers.export(exports, "FaCommentSms", ()=>FaCommentSms);
parcelHelpers.export(exports, "FaCommentSlash", ()=>FaCommentSlash);
parcelHelpers.export(exports, "FaCommentNodes", ()=>FaCommentNodes);
parcelHelpers.export(exports, "FaCommentMedical", ()=>FaCommentMedical);
parcelHelpers.export(exports, "FaCommentDots", ()=>FaCommentDots);
parcelHelpers.export(exports, "FaCommentDollar", ()=>FaCommentDollar);
parcelHelpers.export(exports, "FaColonSign", ()=>FaColonSign);
parcelHelpers.export(exports, "FaCoins", ()=>FaCoins);
parcelHelpers.export(exports, "FaCode", ()=>FaCode);
parcelHelpers.export(exports, "FaCodePullRequest", ()=>FaCodePullRequest);
parcelHelpers.export(exports, "FaCodeMerge", ()=>FaCodeMerge);
parcelHelpers.export(exports, "FaCodeFork", ()=>FaCodeFork);
parcelHelpers.export(exports, "FaCodeCompare", ()=>FaCodeCompare);
parcelHelpers.export(exports, "FaCodeCommit", ()=>FaCodeCommit);
parcelHelpers.export(exports, "FaCodeBranch", ()=>FaCodeBranch);
parcelHelpers.export(exports, "FaClover", ()=>FaClover);
parcelHelpers.export(exports, "FaCloud", ()=>FaCloud);
parcelHelpers.export(exports, "FaCloudSun", ()=>FaCloudSun);
parcelHelpers.export(exports, "FaCloudSunRain", ()=>FaCloudSunRain);
parcelHelpers.export(exports, "FaCloudShowersWater", ()=>FaCloudShowersWater);
parcelHelpers.export(exports, "FaCloudShowersHeavy", ()=>FaCloudShowersHeavy);
parcelHelpers.export(exports, "FaCloudRain", ()=>FaCloudRain);
parcelHelpers.export(exports, "FaCloudMoon", ()=>FaCloudMoon);
parcelHelpers.export(exports, "FaCloudMoonRain", ()=>FaCloudMoonRain);
parcelHelpers.export(exports, "FaCloudMeatball", ()=>FaCloudMeatball);
parcelHelpers.export(exports, "FaCloudBolt", ()=>FaCloudBolt);
parcelHelpers.export(exports, "FaCloudArrowUp", ()=>FaCloudArrowUp);
parcelHelpers.export(exports, "FaCloudArrowDown", ()=>FaCloudArrowDown);
parcelHelpers.export(exports, "FaClosedCaptioning", ()=>FaClosedCaptioning);
parcelHelpers.export(exports, "FaClone", ()=>FaClone);
parcelHelpers.export(exports, "FaClock", ()=>FaClock);
parcelHelpers.export(exports, "FaClockRotateLeft", ()=>FaClockRotateLeft);
parcelHelpers.export(exports, "FaClipboard", ()=>FaClipboard);
parcelHelpers.export(exports, "FaClipboardUser", ()=>FaClipboardUser);
parcelHelpers.export(exports, "FaClipboardQuestion", ()=>FaClipboardQuestion);
parcelHelpers.export(exports, "FaClipboardList", ()=>FaClipboardList);
parcelHelpers.export(exports, "FaClipboardCheck", ()=>FaClipboardCheck);
parcelHelpers.export(exports, "FaClapperboard", ()=>FaClapperboard);
parcelHelpers.export(exports, "FaCity", ()=>FaCity);
parcelHelpers.export(exports, "FaCircle", ()=>FaCircle);
parcelHelpers.export(exports, "FaCircleXmark", ()=>FaCircleXmark);
parcelHelpers.export(exports, "FaCircleUser", ()=>FaCircleUser);
parcelHelpers.export(exports, "FaCircleUp", ()=>FaCircleUp);
parcelHelpers.export(exports, "FaCircleStop", ()=>FaCircleStop);
parcelHelpers.export(exports, "FaCircleRight", ()=>FaCircleRight);
parcelHelpers.export(exports, "FaCircleRadiation", ()=>FaCircleRadiation);
parcelHelpers.export(exports, "FaCircleQuestion", ()=>FaCircleQuestion);
parcelHelpers.export(exports, "FaCirclePlus", ()=>FaCirclePlus);
parcelHelpers.export(exports, "FaCirclePlay", ()=>FaCirclePlay);
parcelHelpers.export(exports, "FaCirclePause", ()=>FaCirclePause);
parcelHelpers.export(exports, "FaCircleNotch", ()=>FaCircleNotch);
parcelHelpers.export(exports, "FaCircleNodes", ()=>FaCircleNodes);
parcelHelpers.export(exports, "FaCircleMinus", ()=>FaCircleMinus);
parcelHelpers.export(exports, "FaCircleLeft", ()=>FaCircleLeft);
parcelHelpers.export(exports, "FaCircleInfo", ()=>FaCircleInfo);
parcelHelpers.export(exports, "FaCircleHalfStroke", ()=>FaCircleHalfStroke);
parcelHelpers.export(exports, "FaCircleH", ()=>FaCircleH);
parcelHelpers.export(exports, "FaCircleExclamation", ()=>FaCircleExclamation);
parcelHelpers.export(exports, "FaCircleDown", ()=>FaCircleDown);
parcelHelpers.export(exports, "FaCircleDot", ()=>FaCircleDot);
parcelHelpers.export(exports, "FaCircleDollarToSlot", ()=>FaCircleDollarToSlot);
parcelHelpers.export(exports, "FaCircleChevronUp", ()=>FaCircleChevronUp);
parcelHelpers.export(exports, "FaCircleChevronRight", ()=>FaCircleChevronRight);
parcelHelpers.export(exports, "FaCircleChevronLeft", ()=>FaCircleChevronLeft);
parcelHelpers.export(exports, "FaCircleChevronDown", ()=>FaCircleChevronDown);
parcelHelpers.export(exports, "FaCircleCheck", ()=>FaCircleCheck);
parcelHelpers.export(exports, "FaCircleArrowUp", ()=>FaCircleArrowUp);
parcelHelpers.export(exports, "FaCircleArrowRight", ()=>FaCircleArrowRight);
parcelHelpers.export(exports, "FaCircleArrowLeft", ()=>FaCircleArrowLeft);
parcelHelpers.export(exports, "FaCircleArrowDown", ()=>FaCircleArrowDown);
parcelHelpers.export(exports, "FaChurch", ()=>FaChurch);
parcelHelpers.export(exports, "FaChildren", ()=>FaChildren);
parcelHelpers.export(exports, "FaChild", ()=>FaChild);
parcelHelpers.export(exports, "FaChildReaching", ()=>FaChildReaching);
parcelHelpers.export(exports, "FaChildDress", ()=>FaChildDress);
parcelHelpers.export(exports, "FaChildCombatant", ()=>FaChildCombatant);
parcelHelpers.export(exports, "FaChevronUp", ()=>FaChevronUp);
parcelHelpers.export(exports, "FaChevronRight", ()=>FaChevronRight);
parcelHelpers.export(exports, "FaChevronLeft", ()=>FaChevronLeft);
parcelHelpers.export(exports, "FaChevronDown", ()=>FaChevronDown);
parcelHelpers.export(exports, "FaChess", ()=>FaChess);
parcelHelpers.export(exports, "FaChessRook", ()=>FaChessRook);
parcelHelpers.export(exports, "FaChessQueen", ()=>FaChessQueen);
parcelHelpers.export(exports, "FaChessPawn", ()=>FaChessPawn);
parcelHelpers.export(exports, "FaChessKnight", ()=>FaChessKnight);
parcelHelpers.export(exports, "FaChessKing", ()=>FaChessKing);
parcelHelpers.export(exports, "FaChessBoard", ()=>FaChessBoard);
parcelHelpers.export(exports, "FaChessBishop", ()=>FaChessBishop);
parcelHelpers.export(exports, "FaCheese", ()=>FaCheese);
parcelHelpers.export(exports, "FaCheck", ()=>FaCheck);
parcelHelpers.export(exports, "FaCheckToSlot", ()=>FaCheckToSlot);
parcelHelpers.export(exports, "FaCheckDouble", ()=>FaCheckDouble);
parcelHelpers.export(exports, "FaChartSimple", ()=>FaChartSimple);
parcelHelpers.export(exports, "FaChartPie", ()=>FaChartPie);
parcelHelpers.export(exports, "FaChartLine", ()=>FaChartLine);
parcelHelpers.export(exports, "FaChartGantt", ()=>FaChartGantt);
parcelHelpers.export(exports, "FaChartDiagram", ()=>FaChartDiagram);
parcelHelpers.export(exports, "FaChartColumn", ()=>FaChartColumn);
parcelHelpers.export(exports, "FaChartBar", ()=>FaChartBar);
parcelHelpers.export(exports, "FaChartArea", ()=>FaChartArea);
parcelHelpers.export(exports, "FaChargingStation", ()=>FaChargingStation);
parcelHelpers.export(exports, "FaChampagneGlasses", ()=>FaChampagneGlasses);
parcelHelpers.export(exports, "FaChalkboard", ()=>FaChalkboard);
parcelHelpers.export(exports, "FaChalkboardUser", ()=>FaChalkboardUser);
parcelHelpers.export(exports, "FaChair", ()=>FaChair);
parcelHelpers.export(exports, "FaCertificate", ()=>FaCertificate);
parcelHelpers.export(exports, "FaCentSign", ()=>FaCentSign);
parcelHelpers.export(exports, "FaCediSign", ()=>FaCediSign);
parcelHelpers.export(exports, "FaCat", ()=>FaCat);
parcelHelpers.export(exports, "FaCashRegister", ()=>FaCashRegister);
parcelHelpers.export(exports, "FaCartShopping", ()=>FaCartShopping);
parcelHelpers.export(exports, "FaCartPlus", ()=>FaCartPlus);
parcelHelpers.export(exports, "FaCartFlatbed", ()=>FaCartFlatbed);
parcelHelpers.export(exports, "FaCartFlatbedSuitcase", ()=>FaCartFlatbedSuitcase);
parcelHelpers.export(exports, "FaCartArrowDown", ()=>FaCartArrowDown);
parcelHelpers.export(exports, "FaCarrot", ()=>FaCarrot);
parcelHelpers.export(exports, "FaCaretUp", ()=>FaCaretUp);
parcelHelpers.export(exports, "FaCaretRight", ()=>FaCaretRight);
parcelHelpers.export(exports, "FaCaretLeft", ()=>FaCaretLeft);
parcelHelpers.export(exports, "FaCaretDown", ()=>FaCaretDown);
parcelHelpers.export(exports, "FaCaravan", ()=>FaCaravan);
parcelHelpers.export(exports, "FaCar", ()=>FaCar);
parcelHelpers.export(exports, "FaCarTunnel", ()=>FaCarTunnel);
parcelHelpers.export(exports, "FaCarSide", ()=>FaCarSide);
parcelHelpers.export(exports, "FaCarRear", ()=>FaCarRear);
parcelHelpers.export(exports, "FaCarOn", ()=>FaCarOn);
parcelHelpers.export(exports, "FaCarBurst", ()=>FaCarBurst);
parcelHelpers.export(exports, "FaCarBattery", ()=>FaCarBattery);
parcelHelpers.export(exports, "FaCapsules", ()=>FaCapsules);
parcelHelpers.export(exports, "FaCannabis", ()=>FaCannabis);
parcelHelpers.export(exports, "FaCandyCane", ()=>FaCandyCane);
parcelHelpers.export(exports, "FaCampground", ()=>FaCampground);
parcelHelpers.export(exports, "FaCamera", ()=>FaCamera);
parcelHelpers.export(exports, "FaCameraRotate", ()=>FaCameraRotate);
parcelHelpers.export(exports, "FaCameraRetro", ()=>FaCameraRetro);
parcelHelpers.export(exports, "FaCalendar", ()=>FaCalendar);
parcelHelpers.export(exports, "FaCalendarXmark", ()=>FaCalendarXmark);
parcelHelpers.export(exports, "FaCalendarWeek", ()=>FaCalendarWeek);
parcelHelpers.export(exports, "FaCalendarPlus", ()=>FaCalendarPlus);
parcelHelpers.export(exports, "FaCalendarMinus", ()=>FaCalendarMinus);
parcelHelpers.export(exports, "FaCalendarDays", ()=>FaCalendarDays);
parcelHelpers.export(exports, "FaCalendarDay", ()=>FaCalendarDay);
parcelHelpers.export(exports, "FaCalendarCheck", ()=>FaCalendarCheck);
parcelHelpers.export(exports, "FaCalculator", ()=>FaCalculator);
parcelHelpers.export(exports, "FaCakeCandles", ()=>FaCakeCandles);
parcelHelpers.export(exports, "FaCableCar", ()=>FaCableCar);
parcelHelpers.export(exports, "FaC", ()=>FaC);
parcelHelpers.export(exports, "FaBusinessTime", ()=>FaBusinessTime);
parcelHelpers.export(exports, "FaBus", ()=>FaBus);
parcelHelpers.export(exports, "FaBusSimple", ()=>FaBusSimple);
parcelHelpers.export(exports, "FaBurst", ()=>FaBurst);
parcelHelpers.export(exports, "FaBurger", ()=>FaBurger);
parcelHelpers.export(exports, "FaBullseye", ()=>FaBullseye);
parcelHelpers.export(exports, "FaBullhorn", ()=>FaBullhorn);
parcelHelpers.export(exports, "FaBuilding", ()=>FaBuilding);
parcelHelpers.export(exports, "FaBuildingWheat", ()=>FaBuildingWheat);
parcelHelpers.export(exports, "FaBuildingUser", ()=>FaBuildingUser);
parcelHelpers.export(exports, "FaBuildingUn", ()=>FaBuildingUn);
parcelHelpers.export(exports, "FaBuildingShield", ()=>FaBuildingShield);
parcelHelpers.export(exports, "FaBuildingNgo", ()=>FaBuildingNgo);
parcelHelpers.export(exports, "FaBuildingLock", ()=>FaBuildingLock);
parcelHelpers.export(exports, "FaBuildingFlag", ()=>FaBuildingFlag);
parcelHelpers.export(exports, "FaBuildingColumns", ()=>FaBuildingColumns);
parcelHelpers.export(exports, "FaBuildingCircleXmark", ()=>FaBuildingCircleXmark);
parcelHelpers.export(exports, "FaBuildingCircleExclamation", ()=>FaBuildingCircleExclamation);
parcelHelpers.export(exports, "FaBuildingCircleCheck", ()=>FaBuildingCircleCheck);
parcelHelpers.export(exports, "FaBuildingCircleArrowRight", ()=>FaBuildingCircleArrowRight);
parcelHelpers.export(exports, "FaBugs", ()=>FaBugs);
parcelHelpers.export(exports, "FaBug", ()=>FaBug);
parcelHelpers.export(exports, "FaBugSlash", ()=>FaBugSlash);
parcelHelpers.export(exports, "FaBucket", ()=>FaBucket);
parcelHelpers.export(exports, "FaBrush", ()=>FaBrush);
parcelHelpers.export(exports, "FaBroom", ()=>FaBroom);
parcelHelpers.export(exports, "FaBroomBall", ()=>FaBroomBall);
parcelHelpers.export(exports, "FaBriefcase", ()=>FaBriefcase);
parcelHelpers.export(exports, "FaBriefcaseMedical", ()=>FaBriefcaseMedical);
parcelHelpers.export(exports, "FaBridge", ()=>FaBridge);
parcelHelpers.export(exports, "FaBridgeWater", ()=>FaBridgeWater);
parcelHelpers.export(exports, "FaBridgeLock", ()=>FaBridgeLock);
parcelHelpers.export(exports, "FaBridgeCircleXmark", ()=>FaBridgeCircleXmark);
parcelHelpers.export(exports, "FaBridgeCircleExclamation", ()=>FaBridgeCircleExclamation);
parcelHelpers.export(exports, "FaBridgeCircleCheck", ()=>FaBridgeCircleCheck);
parcelHelpers.export(exports, "FaBreadSlice", ()=>FaBreadSlice);
parcelHelpers.export(exports, "FaBrazilianRealSign", ()=>FaBrazilianRealSign);
parcelHelpers.export(exports, "FaBrain", ()=>FaBrain);
parcelHelpers.export(exports, "FaBraille", ()=>FaBraille);
parcelHelpers.export(exports, "FaBoxesStacked", ()=>FaBoxesStacked);
parcelHelpers.export(exports, "FaBoxesPacking", ()=>FaBoxesPacking);
parcelHelpers.export(exports, "FaBox", ()=>FaBox);
parcelHelpers.export(exports, "FaBoxTissue", ()=>FaBoxTissue);
parcelHelpers.export(exports, "FaBoxOpen", ()=>FaBoxOpen);
parcelHelpers.export(exports, "FaBoxArchive", ()=>FaBoxArchive);
parcelHelpers.export(exports, "FaBowlingBall", ()=>FaBowlingBall);
parcelHelpers.export(exports, "FaBowlRice", ()=>FaBowlRice);
parcelHelpers.export(exports, "FaBowlFood", ()=>FaBowlFood);
parcelHelpers.export(exports, "FaBottleWater", ()=>FaBottleWater);
parcelHelpers.export(exports, "FaBottleDroplet", ()=>FaBottleDroplet);
parcelHelpers.export(exports, "FaBoreHole", ()=>FaBoreHole);
parcelHelpers.export(exports, "FaBorderTopLeft", ()=>FaBorderTopLeft);
parcelHelpers.export(exports, "FaBorderNone", ()=>FaBorderNone);
parcelHelpers.export(exports, "FaBorderAll", ()=>FaBorderAll);
parcelHelpers.export(exports, "FaBookmark", ()=>FaBookmark);
parcelHelpers.export(exports, "FaBook", ()=>FaBook);
parcelHelpers.export(exports, "FaBookTanakh", ()=>FaBookTanakh);
parcelHelpers.export(exports, "FaBookSkull", ()=>FaBookSkull);
parcelHelpers.export(exports, "FaBookQuran", ()=>FaBookQuran);
parcelHelpers.export(exports, "FaBookOpen", ()=>FaBookOpen);
parcelHelpers.export(exports, "FaBookOpenReader", ()=>FaBookOpenReader);
parcelHelpers.export(exports, "FaBookMedical", ()=>FaBookMedical);
parcelHelpers.export(exports, "FaBookJournalWhills", ()=>FaBookJournalWhills);
parcelHelpers.export(exports, "FaBookBookmark", ()=>FaBookBookmark);
parcelHelpers.export(exports, "FaBookBible", ()=>FaBookBible);
parcelHelpers.export(exports, "FaBookAtlas", ()=>FaBookAtlas);
parcelHelpers.export(exports, "FaBong", ()=>FaBong);
parcelHelpers.export(exports, "FaBone", ()=>FaBone);
parcelHelpers.export(exports, "FaBomb", ()=>FaBomb);
parcelHelpers.export(exports, "FaBolt", ()=>FaBolt);
parcelHelpers.export(exports, "FaBoltLightning", ()=>FaBoltLightning);
parcelHelpers.export(exports, "FaBold", ()=>FaBold);
parcelHelpers.export(exports, "FaBlog", ()=>FaBlog);
parcelHelpers.export(exports, "FaBlender", ()=>FaBlender);
parcelHelpers.export(exports, "FaBlenderPhone", ()=>FaBlenderPhone);
parcelHelpers.export(exports, "FaBitcoinSign", ()=>FaBitcoinSign);
parcelHelpers.export(exports, "FaBiohazard", ()=>FaBiohazard);
parcelHelpers.export(exports, "FaBinoculars", ()=>FaBinoculars);
parcelHelpers.export(exports, "FaBicycle", ()=>FaBicycle);
parcelHelpers.export(exports, "FaBezierCurve", ()=>FaBezierCurve);
parcelHelpers.export(exports, "FaBell", ()=>FaBell);
parcelHelpers.export(exports, "FaBellSlash", ()=>FaBellSlash);
parcelHelpers.export(exports, "FaBellConcierge", ()=>FaBellConcierge);
parcelHelpers.export(exports, "FaBeerMugEmpty", ()=>FaBeerMugEmpty);
parcelHelpers.export(exports, "FaBed", ()=>FaBed);
parcelHelpers.export(exports, "FaBedPulse", ()=>FaBedPulse);
parcelHelpers.export(exports, "FaBatteryThreeQuarters", ()=>FaBatteryThreeQuarters);
parcelHelpers.export(exports, "FaBatteryQuarter", ()=>FaBatteryQuarter);
parcelHelpers.export(exports, "FaBatteryHalf", ()=>FaBatteryHalf);
parcelHelpers.export(exports, "FaBatteryFull", ()=>FaBatteryFull);
parcelHelpers.export(exports, "FaBatteryEmpty", ()=>FaBatteryEmpty);
parcelHelpers.export(exports, "FaBath", ()=>FaBath);
parcelHelpers.export(exports, "FaBasketball", ()=>FaBasketball);
parcelHelpers.export(exports, "FaBasketShopping", ()=>FaBasketShopping);
parcelHelpers.export(exports, "FaBaseball", ()=>FaBaseball);
parcelHelpers.export(exports, "FaBaseballBatBall", ()=>FaBaseballBatBall);
parcelHelpers.export(exports, "FaBars", ()=>FaBars);
parcelHelpers.export(exports, "FaBarsStaggered", ()=>FaBarsStaggered);
parcelHelpers.export(exports, "FaBarsProgress", ()=>FaBarsProgress);
parcelHelpers.export(exports, "FaBarcode", ()=>FaBarcode);
parcelHelpers.export(exports, "FaBangladeshiTakaSign", ()=>FaBangladeshiTakaSign);
parcelHelpers.export(exports, "FaBandage", ()=>FaBandage);
parcelHelpers.export(exports, "FaBan", ()=>FaBan);
parcelHelpers.export(exports, "FaBanSmoking", ()=>FaBanSmoking);
parcelHelpers.export(exports, "FaBahtSign", ()=>FaBahtSign);
parcelHelpers.export(exports, "FaBahai", ()=>FaBahai);
parcelHelpers.export(exports, "FaBagShopping", ()=>FaBagShopping);
parcelHelpers.export(exports, "FaBacterium", ()=>FaBacterium);
parcelHelpers.export(exports, "FaBacteria", ()=>FaBacteria);
parcelHelpers.export(exports, "FaBacon", ()=>FaBacon);
parcelHelpers.export(exports, "FaBackward", ()=>FaBackward);
parcelHelpers.export(exports, "FaBackwardStep", ()=>FaBackwardStep);
parcelHelpers.export(exports, "FaBackwardFast", ()=>FaBackwardFast);
parcelHelpers.export(exports, "FaBaby", ()=>FaBaby);
parcelHelpers.export(exports, "FaBabyCarriage", ()=>FaBabyCarriage);
parcelHelpers.export(exports, "FaB", ()=>FaB);
parcelHelpers.export(exports, "FaAward", ()=>FaAward);
parcelHelpers.export(exports, "FaAustralSign", ()=>FaAustralSign);
parcelHelpers.export(exports, "FaAudioDescription", ()=>FaAudioDescription);
parcelHelpers.export(exports, "FaAtom", ()=>FaAtom);
parcelHelpers.export(exports, "FaAt", ()=>FaAt);
parcelHelpers.export(exports, "FaAsterisk", ()=>FaAsterisk);
parcelHelpers.export(exports, "FaArrowsUpToLine", ()=>FaArrowsUpToLine);
parcelHelpers.export(exports, "FaArrowsUpDown", ()=>FaArrowsUpDown);
parcelHelpers.export(exports, "FaArrowsUpDownLeftRight", ()=>FaArrowsUpDownLeftRight);
parcelHelpers.export(exports, "FaArrowsTurnToDots", ()=>FaArrowsTurnToDots);
parcelHelpers.export(exports, "FaArrowsTurnRight", ()=>FaArrowsTurnRight);
parcelHelpers.export(exports, "FaArrowsToEye", ()=>FaArrowsToEye);
parcelHelpers.export(exports, "FaArrowsToDot", ()=>FaArrowsToDot);
parcelHelpers.export(exports, "FaArrowsToCircle", ()=>FaArrowsToCircle);
parcelHelpers.export(exports, "FaArrowsSplitUpAndLeft", ()=>FaArrowsSplitUpAndLeft);
parcelHelpers.export(exports, "FaArrowsSpin", ()=>FaArrowsSpin);
parcelHelpers.export(exports, "FaArrowsRotate", ()=>FaArrowsRotate);
parcelHelpers.export(exports, "FaArrowsLeftRight", ()=>FaArrowsLeftRight);
parcelHelpers.export(exports, "FaArrowsLeftRightToLine", ()=>FaArrowsLeftRightToLine);
parcelHelpers.export(exports, "FaArrowsDownToPeople", ()=>FaArrowsDownToPeople);
parcelHelpers.export(exports, "FaArrowsDownToLine", ()=>FaArrowsDownToLine);
parcelHelpers.export(exports, "FaArrowUp", ()=>FaArrowUp);
parcelHelpers.export(exports, "FaArrowUpZA", ()=>FaArrowUpZA);
parcelHelpers.export(exports, "FaArrowUpWideShort", ()=>FaArrowUpWideShort);
parcelHelpers.export(exports, "FaArrowUpShortWide", ()=>FaArrowUpShortWide);
parcelHelpers.export(exports, "FaArrowUpRightFromSquare", ()=>FaArrowUpRightFromSquare);
parcelHelpers.export(exports, "FaArrowUpRightDots", ()=>FaArrowUpRightDots);
parcelHelpers.export(exports, "FaArrowUpLong", ()=>FaArrowUpLong);
parcelHelpers.export(exports, "FaArrowUpFromWaterPump", ()=>FaArrowUpFromWaterPump);
parcelHelpers.export(exports, "FaArrowUpFromGroundWater", ()=>FaArrowUpFromGroundWater);
parcelHelpers.export(exports, "FaArrowUpFromBracket", ()=>FaArrowUpFromBracket);
parcelHelpers.export(exports, "FaArrowUpAZ", ()=>FaArrowUpAZ);
parcelHelpers.export(exports, "FaArrowUp91", ()=>FaArrowUp91);
parcelHelpers.export(exports, "FaArrowUp19", ()=>FaArrowUp19);
parcelHelpers.export(exports, "FaArrowTurnUp", ()=>FaArrowTurnUp);
parcelHelpers.export(exports, "FaArrowTurnDown", ()=>FaArrowTurnDown);
parcelHelpers.export(exports, "FaArrowTrendUp", ()=>FaArrowTrendUp);
parcelHelpers.export(exports, "FaArrowTrendDown", ()=>FaArrowTrendDown);
parcelHelpers.export(exports, "FaArrowRotateRight", ()=>FaArrowRotateRight);
parcelHelpers.export(exports, "FaArrowRotateLeft", ()=>FaArrowRotateLeft);
parcelHelpers.export(exports, "FaArrowRight", ()=>FaArrowRight);
parcelHelpers.export(exports, "FaArrowRightToCity", ()=>FaArrowRightToCity);
parcelHelpers.export(exports, "FaArrowRightToBracket", ()=>FaArrowRightToBracket);
parcelHelpers.export(exports, "FaArrowRightLong", ()=>FaArrowRightLong);
parcelHelpers.export(exports, "FaArrowRightFromBracket", ()=>FaArrowRightFromBracket);
parcelHelpers.export(exports, "FaArrowRightArrowLeft", ()=>FaArrowRightArrowLeft);
parcelHelpers.export(exports, "FaArrowPointer", ()=>FaArrowPointer);
parcelHelpers.export(exports, "FaArrowLeft", ()=>FaArrowLeft);
parcelHelpers.export(exports, "FaArrowLeftLong", ()=>FaArrowLeftLong);
parcelHelpers.export(exports, "FaArrowDown", ()=>FaArrowDown);
parcelHelpers.export(exports, "FaArrowDownZA", ()=>FaArrowDownZA);
parcelHelpers.export(exports, "FaArrowDownWideShort", ()=>FaArrowDownWideShort);
parcelHelpers.export(exports, "FaArrowDownUpLock", ()=>FaArrowDownUpLock);
parcelHelpers.export(exports, "FaArrowDownUpAcrossLine", ()=>FaArrowDownUpAcrossLine);
parcelHelpers.export(exports, "FaArrowDownShortWide", ()=>FaArrowDownShortWide);
parcelHelpers.export(exports, "FaArrowDownLong", ()=>FaArrowDownLong);
parcelHelpers.export(exports, "FaArrowDownAZ", ()=>FaArrowDownAZ);
parcelHelpers.export(exports, "FaArrowDown91", ()=>FaArrowDown91);
parcelHelpers.export(exports, "FaArrowDown19", ()=>FaArrowDown19);
parcelHelpers.export(exports, "FaArchway", ()=>FaArchway);
parcelHelpers.export(exports, "FaAppleWhole", ()=>FaAppleWhole);
parcelHelpers.export(exports, "FaAnkh", ()=>FaAnkh);
parcelHelpers.export(exports, "FaAnglesUp", ()=>FaAnglesUp);
parcelHelpers.export(exports, "FaAnglesRight", ()=>FaAnglesRight);
parcelHelpers.export(exports, "FaAnglesLeft", ()=>FaAnglesLeft);
parcelHelpers.export(exports, "FaAnglesDown", ()=>FaAnglesDown);
parcelHelpers.export(exports, "FaAngleUp", ()=>FaAngleUp);
parcelHelpers.export(exports, "FaAngleRight", ()=>FaAngleRight);
parcelHelpers.export(exports, "FaAngleLeft", ()=>FaAngleLeft);
parcelHelpers.export(exports, "FaAngleDown", ()=>FaAngleDown);
parcelHelpers.export(exports, "FaAnchor", ()=>FaAnchor);
parcelHelpers.export(exports, "FaAnchorLock", ()=>FaAnchorLock);
parcelHelpers.export(exports, "FaAnchorCircleXmark", ()=>FaAnchorCircleXmark);
parcelHelpers.export(exports, "FaAnchorCircleExclamation", ()=>FaAnchorCircleExclamation);
parcelHelpers.export(exports, "FaAnchorCircleCheck", ()=>FaAnchorCircleCheck);
parcelHelpers.export(exports, "FaAlignRight", ()=>FaAlignRight);
parcelHelpers.export(exports, "FaAlignLeft", ()=>FaAlignLeft);
parcelHelpers.export(exports, "FaAlignJustify", ()=>FaAlignJustify);
parcelHelpers.export(exports, "FaAlignCenter", ()=>FaAlignCenter);
parcelHelpers.export(exports, "FaAddressCard", ()=>FaAddressCard);
parcelHelpers.export(exports, "FaAddressBook", ()=>FaAddressBook);
parcelHelpers.export(exports, "FaA", ()=>FaA);
parcelHelpers.export(exports, "Fa9", ()=>Fa9);
parcelHelpers.export(exports, "Fa8", ()=>Fa8);
parcelHelpers.export(exports, "Fa7", ()=>Fa7);
parcelHelpers.export(exports, "Fa6", ()=>Fa6);
parcelHelpers.export(exports, "Fa5", ()=>Fa5);
parcelHelpers.export(exports, "Fa4", ()=>Fa4);
parcelHelpers.export(exports, "Fa3", ()=>Fa3);
parcelHelpers.export(exports, "Fa2", ()=>Fa2);
parcelHelpers.export(exports, "Fa1", ()=>Fa1);
parcelHelpers.export(exports, "Fa0", ()=>Fa0);
parcelHelpers.export(exports, "FaRegWindowRestore", ()=>FaRegWindowRestore);
parcelHelpers.export(exports, "FaRegWindowMinimize", ()=>FaRegWindowMinimize);
parcelHelpers.export(exports, "FaRegWindowMaximize", ()=>FaRegWindowMaximize);
parcelHelpers.export(exports, "FaRegUser", ()=>FaRegUser);
parcelHelpers.export(exports, "FaRegTrashCan", ()=>FaRegTrashCan);
parcelHelpers.export(exports, "FaRegThumbsUp", ()=>FaRegThumbsUp);
parcelHelpers.export(exports, "FaRegThumbsDown", ()=>FaRegThumbsDown);
parcelHelpers.export(exports, "FaRegSun", ()=>FaRegSun);
parcelHelpers.export(exports, "FaRegStar", ()=>FaRegStar);
parcelHelpers.export(exports, "FaRegStarHalf", ()=>FaRegStarHalf);
parcelHelpers.export(exports, "FaRegStarHalfStroke", ()=>FaRegStarHalfStroke);
parcelHelpers.export(exports, "FaRegSquare", ()=>FaRegSquare);
parcelHelpers.export(exports, "FaRegSquarePlus", ()=>FaRegSquarePlus);
parcelHelpers.export(exports, "FaRegSquareMinus", ()=>FaRegSquareMinus);
parcelHelpers.export(exports, "FaRegSquareFull", ()=>FaRegSquareFull);
parcelHelpers.export(exports, "FaRegSquareCheck", ()=>FaRegSquareCheck);
parcelHelpers.export(exports, "FaRegSquareCaretUp", ()=>FaRegSquareCaretUp);
parcelHelpers.export(exports, "FaRegSquareCaretRight", ()=>FaRegSquareCaretRight);
parcelHelpers.export(exports, "FaRegSquareCaretLeft", ()=>FaRegSquareCaretLeft);
parcelHelpers.export(exports, "FaRegSquareCaretDown", ()=>FaRegSquareCaretDown);
parcelHelpers.export(exports, "FaRegSnowflake", ()=>FaRegSnowflake);
parcelHelpers.export(exports, "FaRegShareFromSquare", ()=>FaRegShareFromSquare);
parcelHelpers.export(exports, "FaRegRegistered", ()=>FaRegRegistered);
parcelHelpers.export(exports, "FaRegRectangleXmark", ()=>FaRegRectangleXmark);
parcelHelpers.export(exports, "FaRegRectangleList", ()=>FaRegRectangleList);
parcelHelpers.export(exports, "FaRegPenToSquare", ()=>FaRegPenToSquare);
parcelHelpers.export(exports, "FaRegPaste", ()=>FaRegPaste);
parcelHelpers.export(exports, "FaRegPaperPlane", ()=>FaRegPaperPlane);
parcelHelpers.export(exports, "FaRegObjectUngroup", ()=>FaRegObjectUngroup);
parcelHelpers.export(exports, "FaRegObjectGroup", ()=>FaRegObjectGroup);
parcelHelpers.export(exports, "FaRegNoteSticky", ()=>FaRegNoteSticky);
parcelHelpers.export(exports, "FaRegNewspaper", ()=>FaRegNewspaper);
parcelHelpers.export(exports, "FaRegMoon", ()=>FaRegMoon);
parcelHelpers.export(exports, "FaRegMoneyBill1", ()=>FaRegMoneyBill1);
parcelHelpers.export(exports, "FaRegMessage", ()=>FaRegMessage);
parcelHelpers.export(exports, "FaRegMap", ()=>FaRegMap);
parcelHelpers.export(exports, "FaRegLightbulb", ()=>FaRegLightbulb);
parcelHelpers.export(exports, "FaRegLifeRing", ()=>FaRegLifeRing);
parcelHelpers.export(exports, "FaRegLemon", ()=>FaRegLemon);
parcelHelpers.export(exports, "FaRegKeyboard", ()=>FaRegKeyboard);
parcelHelpers.export(exports, "FaRegImages", ()=>FaRegImages);
parcelHelpers.export(exports, "FaRegImage", ()=>FaRegImage);
parcelHelpers.export(exports, "FaRegIdCard", ()=>FaRegIdCard);
parcelHelpers.export(exports, "FaRegIdBadge", ()=>FaRegIdBadge);
parcelHelpers.export(exports, "FaRegHourglass", ()=>FaRegHourglass);
parcelHelpers.export(exports, "FaRegHourglassHalf", ()=>FaRegHourglassHalf);
parcelHelpers.export(exports, "FaRegHospital", ()=>FaRegHospital);
parcelHelpers.export(exports, "FaRegHeart", ()=>FaRegHeart);
parcelHelpers.export(exports, "FaRegHardDrive", ()=>FaRegHardDrive);
parcelHelpers.export(exports, "FaRegHandshake", ()=>FaRegHandshake);
parcelHelpers.export(exports, "FaRegHand", ()=>FaRegHand);
parcelHelpers.export(exports, "FaRegHandSpock", ()=>FaRegHandSpock);
parcelHelpers.export(exports, "FaRegHandScissors", ()=>FaRegHandScissors);
parcelHelpers.export(exports, "FaRegHandPointer", ()=>FaRegHandPointer);
parcelHelpers.export(exports, "FaRegHandPointUp", ()=>FaRegHandPointUp);
parcelHelpers.export(exports, "FaRegHandPointRight", ()=>FaRegHandPointRight);
parcelHelpers.export(exports, "FaRegHandPointLeft", ()=>FaRegHandPointLeft);
parcelHelpers.export(exports, "FaRegHandPointDown", ()=>FaRegHandPointDown);
parcelHelpers.export(exports, "FaRegHandPeace", ()=>FaRegHandPeace);
parcelHelpers.export(exports, "FaRegHandLizard", ()=>FaRegHandLizard);
parcelHelpers.export(exports, "FaRegHandBackFist", ()=>FaRegHandBackFist);
parcelHelpers.export(exports, "FaRegGem", ()=>FaRegGem);
parcelHelpers.export(exports, "FaRegFutbol", ()=>FaRegFutbol);
parcelHelpers.export(exports, "FaRegFontAwesome", ()=>FaRegFontAwesome);
parcelHelpers.export(exports, "FaRegFolder", ()=>FaRegFolder);
parcelHelpers.export(exports, "FaRegFolderOpen", ()=>FaRegFolderOpen);
parcelHelpers.export(exports, "FaRegFolderClosed", ()=>FaRegFolderClosed);
parcelHelpers.export(exports, "FaRegFloppyDisk", ()=>FaRegFloppyDisk);
parcelHelpers.export(exports, "FaRegFlag", ()=>FaRegFlag);
parcelHelpers.export(exports, "FaRegFile", ()=>FaRegFile);
parcelHelpers.export(exports, "FaRegFileZipper", ()=>FaRegFileZipper);
parcelHelpers.export(exports, "FaRegFileWord", ()=>FaRegFileWord);
parcelHelpers.export(exports, "FaRegFileVideo", ()=>FaRegFileVideo);
parcelHelpers.export(exports, "FaRegFilePowerpoint", ()=>FaRegFilePowerpoint);
parcelHelpers.export(exports, "FaRegFilePdf", ()=>FaRegFilePdf);
parcelHelpers.export(exports, "FaRegFileLines", ()=>FaRegFileLines);
parcelHelpers.export(exports, "FaRegFileImage", ()=>FaRegFileImage);
parcelHelpers.export(exports, "FaRegFileExcel", ()=>FaRegFileExcel);
parcelHelpers.export(exports, "FaRegFileCode", ()=>FaRegFileCode);
parcelHelpers.export(exports, "FaRegFileAudio", ()=>FaRegFileAudio);
parcelHelpers.export(exports, "FaRegFaceTired", ()=>FaRegFaceTired);
parcelHelpers.export(exports, "FaRegFaceSurprise", ()=>FaRegFaceSurprise);
parcelHelpers.export(exports, "FaRegFaceSmile", ()=>FaRegFaceSmile);
parcelHelpers.export(exports, "FaRegFaceSmileWink", ()=>FaRegFaceSmileWink);
parcelHelpers.export(exports, "FaRegFaceSmileBeam", ()=>FaRegFaceSmileBeam);
parcelHelpers.export(exports, "FaRegFaceSadTear", ()=>FaRegFaceSadTear);
parcelHelpers.export(exports, "FaRegFaceSadCry", ()=>FaRegFaceSadCry);
parcelHelpers.export(exports, "FaRegFaceRollingEyes", ()=>FaRegFaceRollingEyes);
parcelHelpers.export(exports, "FaRegFaceMeh", ()=>FaRegFaceMeh);
parcelHelpers.export(exports, "FaRegFaceMehBlank", ()=>FaRegFaceMehBlank);
parcelHelpers.export(exports, "FaRegFaceLaugh", ()=>FaRegFaceLaugh);
parcelHelpers.export(exports, "FaRegFaceLaughWink", ()=>FaRegFaceLaughWink);
parcelHelpers.export(exports, "FaRegFaceLaughSquint", ()=>FaRegFaceLaughSquint);
parcelHelpers.export(exports, "FaRegFaceLaughBeam", ()=>FaRegFaceLaughBeam);
parcelHelpers.export(exports, "FaRegFaceKiss", ()=>FaRegFaceKiss);
parcelHelpers.export(exports, "FaRegFaceKissWinkHeart", ()=>FaRegFaceKissWinkHeart);
parcelHelpers.export(exports, "FaRegFaceKissBeam", ()=>FaRegFaceKissBeam);
parcelHelpers.export(exports, "FaRegFaceGrin", ()=>FaRegFaceGrin);
parcelHelpers.export(exports, "FaRegFaceGrinWink", ()=>FaRegFaceGrinWink);
parcelHelpers.export(exports, "FaRegFaceGrinWide", ()=>FaRegFaceGrinWide);
parcelHelpers.export(exports, "FaRegFaceGrinTongue", ()=>FaRegFaceGrinTongue);
parcelHelpers.export(exports, "FaRegFaceGrinTongueWink", ()=>FaRegFaceGrinTongueWink);
parcelHelpers.export(exports, "FaRegFaceGrinTongueSquint", ()=>FaRegFaceGrinTongueSquint);
parcelHelpers.export(exports, "FaRegFaceGrinTears", ()=>FaRegFaceGrinTears);
parcelHelpers.export(exports, "FaRegFaceGrinStars", ()=>FaRegFaceGrinStars);
parcelHelpers.export(exports, "FaRegFaceGrinSquint", ()=>FaRegFaceGrinSquint);
parcelHelpers.export(exports, "FaRegFaceGrinSquintTears", ()=>FaRegFaceGrinSquintTears);
parcelHelpers.export(exports, "FaRegFaceGrinHearts", ()=>FaRegFaceGrinHearts);
parcelHelpers.export(exports, "FaRegFaceGrinBeam", ()=>FaRegFaceGrinBeam);
parcelHelpers.export(exports, "FaRegFaceGrinBeamSweat", ()=>FaRegFaceGrinBeamSweat);
parcelHelpers.export(exports, "FaRegFaceGrimace", ()=>FaRegFaceGrimace);
parcelHelpers.export(exports, "FaRegFaceFrown", ()=>FaRegFaceFrown);
parcelHelpers.export(exports, "FaRegFaceFrownOpen", ()=>FaRegFaceFrownOpen);
parcelHelpers.export(exports, "FaRegFaceFlushed", ()=>FaRegFaceFlushed);
parcelHelpers.export(exports, "FaRegFaceDizzy", ()=>FaRegFaceDizzy);
parcelHelpers.export(exports, "FaRegFaceAngry", ()=>FaRegFaceAngry);
parcelHelpers.export(exports, "FaRegEye", ()=>FaRegEye);
parcelHelpers.export(exports, "FaRegEyeSlash", ()=>FaRegEyeSlash);
parcelHelpers.export(exports, "FaRegEnvelope", ()=>FaRegEnvelope);
parcelHelpers.export(exports, "FaRegEnvelopeOpen", ()=>FaRegEnvelopeOpen);
parcelHelpers.export(exports, "FaRegCreditCard", ()=>FaRegCreditCard);
parcelHelpers.export(exports, "FaRegCopyright", ()=>FaRegCopyright);
parcelHelpers.export(exports, "FaRegCopy", ()=>FaRegCopy);
parcelHelpers.export(exports, "FaRegCompass", ()=>FaRegCompass);
parcelHelpers.export(exports, "FaRegComments", ()=>FaRegComments);
parcelHelpers.export(exports, "FaRegComment", ()=>FaRegComment);
parcelHelpers.export(exports, "FaRegCommentDots", ()=>FaRegCommentDots);
parcelHelpers.export(exports, "FaRegClosedCaptioning", ()=>FaRegClosedCaptioning);
parcelHelpers.export(exports, "FaRegClone", ()=>FaRegClone);
parcelHelpers.export(exports, "FaRegClock", ()=>FaRegClock);
parcelHelpers.export(exports, "FaRegClipboard", ()=>FaRegClipboard);
parcelHelpers.export(exports, "FaRegCircle", ()=>FaRegCircle);
parcelHelpers.export(exports, "FaRegCircleXmark", ()=>FaRegCircleXmark);
parcelHelpers.export(exports, "FaRegCircleUser", ()=>FaRegCircleUser);
parcelHelpers.export(exports, "FaRegCircleUp", ()=>FaRegCircleUp);
parcelHelpers.export(exports, "FaRegCircleStop", ()=>FaRegCircleStop);
parcelHelpers.export(exports, "FaRegCircleRight", ()=>FaRegCircleRight);
parcelHelpers.export(exports, "FaRegCircleQuestion", ()=>FaRegCircleQuestion);
parcelHelpers.export(exports, "FaRegCirclePlay", ()=>FaRegCirclePlay);
parcelHelpers.export(exports, "FaRegCirclePause", ()=>FaRegCirclePause);
parcelHelpers.export(exports, "FaRegCircleLeft", ()=>FaRegCircleLeft);
parcelHelpers.export(exports, "FaRegCircleDown", ()=>FaRegCircleDown);
parcelHelpers.export(exports, "FaRegCircleDot", ()=>FaRegCircleDot);
parcelHelpers.export(exports, "FaRegCircleCheck", ()=>FaRegCircleCheck);
parcelHelpers.export(exports, "FaRegChessRook", ()=>FaRegChessRook);
parcelHelpers.export(exports, "FaRegChessQueen", ()=>FaRegChessQueen);
parcelHelpers.export(exports, "FaRegChessPawn", ()=>FaRegChessPawn);
parcelHelpers.export(exports, "FaRegChessKnight", ()=>FaRegChessKnight);
parcelHelpers.export(exports, "FaRegChessKing", ()=>FaRegChessKing);
parcelHelpers.export(exports, "FaRegChessBishop", ()=>FaRegChessBishop);
parcelHelpers.export(exports, "FaRegChartBar", ()=>FaRegChartBar);
parcelHelpers.export(exports, "FaRegCalendar", ()=>FaRegCalendar);
parcelHelpers.export(exports, "FaRegCalendarXmark", ()=>FaRegCalendarXmark);
parcelHelpers.export(exports, "FaRegCalendarPlus", ()=>FaRegCalendarPlus);
parcelHelpers.export(exports, "FaRegCalendarMinus", ()=>FaRegCalendarMinus);
parcelHelpers.export(exports, "FaRegCalendarDays", ()=>FaRegCalendarDays);
parcelHelpers.export(exports, "FaRegCalendarCheck", ()=>FaRegCalendarCheck);
parcelHelpers.export(exports, "FaRegBuilding", ()=>FaRegBuilding);
parcelHelpers.export(exports, "FaRegBookmark", ()=>FaRegBookmark);
parcelHelpers.export(exports, "FaRegBell", ()=>FaRegBell);
parcelHelpers.export(exports, "FaRegBellSlash", ()=>FaRegBellSlash);
parcelHelpers.export(exports, "FaRegAddressCard", ()=>FaRegAddressCard);
parcelHelpers.export(exports, "FaRegAddressBook", ()=>FaRegAddressBook);
var _indexMjs = require("../lib/index.mjs");
function FaZhihu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYoutube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYoast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYelp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYarn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYandex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYandexInternational(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYammer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.676,159.486a12.779,12.779,0,0,0-6.4-8.282,13.954,13.954,0,0,0-10.078-1.125L457.8,156.7l-.043-.2-22.3,5.785-1.243.333-.608-2.17A369.037,369.037,0,0,0,347.538,4.289a14.1,14.1,0,0,0-19.784-.463l-102.9,102.747H24.947A24.9,24.9,0,0,0,0,131.417V380.38a24.963,24.963,0,0,0,24.918,24.9H224.986L328.072,508a13.667,13.667,0,0,0,19.327,0c.126-.126.249-.255.37-.385a368.025,368.025,0,0,0,69.577-107.374,403.45,403.45,0,0,0,17.3-50.8v-.028l20.406,5.336.029-.073L483.345,362a20.253,20.253,0,0,0,2.619.5,13.359,13.359,0,0,0,4.139-.072,13.5,13.5,0,0,0,10.515-9.924,415.855,415.855,0,0,0,.058-193.013ZM337.125,24.65l.013.014h-.013Zm-110.2,165.161L174.311,281.1a11.338,11.338,0,0,0-1.489,5.655v46.189a22.04,22.04,0,0,1-22.041,22h-3.4A22.068,22.068,0,0,1,125.3,332.962V287.294a11.532,11.532,0,0,0-1.388-5.51l-51.6-92.2a21.988,21.988,0,0,1,19.264-32.726h3.268a22.059,22.059,0,0,1,19.611,11.916l36.357,70.281,37.515-70.512a22.066,22.066,0,0,1,38.556-.695,21.7,21.7,0,0,1,0,21.967ZM337.145,24.673a348.147,348.147,0,0,1,75.8,141.335l.564,1.952-114.134,29.6V131.417a25.006,25.006,0,0,0-24.947-24.9H255.067Zm60.5,367.305v-.043l-.014.014a347.19,347.19,0,0,1-60.177,95.227l-82.2-81.893h19.177a24.978,24.978,0,0,0,24.947-24.9v-66.2l114.6,29.862A385.191,385.191,0,0,1,397.648,391.978Zm84-52.45.015.014-50.618-13.131L299.379,292.1V219.572l119.746-30.99,4.468-1.157,39.54-10.253,18.511-4.816A393,393,0,0,1,481.644,339.528Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYahoo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYCombinator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXTwitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpressr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpforms(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpexplorer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpbeginner(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWordpress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWordpressSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWolfPackBattalion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWodu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWizardsOfTheCoast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWirsindhandwerk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.77161,479.81213h83.36071V367.84741l-83.36071,47.009Zm329.04675,0h82.35022V414.85645l-82.35022-47.009Zm.00568-448V251.568L256.1759,179.1861,134.50378,251.568V31.81213H50.77161V392.60565L256.1759,270.31909,462.16858,392.60565V31.81213Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindows(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWikipediaW(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWhmcs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWhatsapp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeixin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeibo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeebly(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWebflow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 64L435.8 463.2H244l85.5-165.5h-3.8C255.1 389.3 149.9 449.5 0 463.2V300.1s95.9-5.7 152.3-64.9H0V64H171.1V204.8l3.8 0L244.9 64H374.3V203.9l3.8 0L450.7 64H640z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWebAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372.2 52c0 20.9-12.4 39-30.2 47.2L448 192l104.4-20.9c-5.3-7.7-8.4-17.1-8.4-27.1c0-26.5 21.5-48 48-48s48 21.5 48 48c0 26-20.6 47.1-46.4 48L481 442.3c-10.3 23-33.2 37.7-58.4 37.7l-205.2 0c-25.2 0-48-14.8-58.4-37.7L46.4 192C20.6 191.1 0 170 0 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.1-3.1 19.4-8.4 27.1L192 192 298.1 99.1c-17.7-8.3-30-26.3-30-47.1c0-28.7 23.3-52 52-52s52 23.3 52 52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWaze(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWatchmanMonitoring(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVuejs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVnv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.4907 63.4907C0 94.9813 0 145.671 0 247.04V264.96C0 366.329 0 417.019 31.4907 448.509C62.9813 480 113.671 480 215.04 480H232.96C334.329 480 385.019 480 416.509 448.509C448 417.019 448 366.329 448 264.96V247.04C448 145.671 448 94.9813 416.509 63.4907C385.019 32 334.329 32 232.96 32H215.04C113.671 32 62.9813 32 31.4907 63.4907ZM75.6 168.267H126.747C128.427 253.76 166.133 289.973 196 297.44V168.267H244.16V242C273.653 238.827 304.64 205.227 315.093 168.267H363.253C359.313 187.435 351.46 205.583 340.186 221.579C328.913 237.574 314.461 251.071 297.733 261.227C316.41 270.499 332.907 283.63 346.132 299.751C359.357 315.873 369.01 334.618 374.453 354.747H321.44C316.555 337.262 306.614 321.61 292.865 309.754C279.117 297.899 262.173 290.368 244.16 288.107V354.747H238.373C136.267 354.747 78.0267 284.747 75.6 168.267Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVimeo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVimeoV(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViber(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViadeo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViacoin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVaadin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUssunnah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 482 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.9 268.1A240.9 240.9 0 1 1 .1 268a240.9 240.9 0 1 1 481.9 0zM24.5 268a216.5 216.5 0 1 0 432.9 0A216.5 216.5 0 1 0 24.5 268zm385.9 63.3c-12.7 0-21.6-1.9-26.7-5.9c-5.5-4.3-8.2-12.3-8.2-23.8V205.1c0-6.5-5.2-20.2-15.7-41.2c7 0 17-9.1 30-27.2V284.5c0 11 2.4 19.4 7 25.3c3.7 4.7 10.1 8.9 19 12.6c1.2 .4 2.6 .9 4.1 1.4c2.9 .9 6.3 2.1 10.3 3.5c-1.8 2.7-8.3 4-19.9 4zm-219 0c-1.3 2.4-3.6 5.5-6.8 9.4l-18.5 22.5c-1-6.1-4-13-9.3-20.6s-9.7-11.4-13.4-11.4h-8.3H53.6c3.3-5.3 4.9-8.8 4.9-10.8c0-2-.8-5.3-2.4-9.7c-1.5-4.4-2.4-8.5-2.4-12.4c0-7.4 2.1-13.9 6.3-19.3L80 253.4l-7.1-17.7L89 215.9l6.7 16.8 8-10.3c-1.8 6.4-2.6 12.3-2.6 17.7c0 4.2 2.8 13.3 8.3 27.3l16.2 40.7H135h8 .3c2.8 .4 7.7 5 14.6 13.9c1.8 2.4 4.3 5.8 7.7 10.2c1.4 1.9 2.9 3.9 4.6 6.1c1.3-2.3 2-4.6 2-7.1c0-2-1.3-6.6-4-13.4L163 304.1c-4-10.6-6.1-17.7-6.1-21.3c0-6.3 1.9-12.3 5.8-17.9c.5-.6 1-1.3 1.5-1.9c4.4-5.6 8.8-11.1 13.3-16.5c-1.1 4.6-1.7 8.7-1.7 12c0 3.7 1.7 9.9 5.1 18.8l7.9 20.4c1.9 4.7 3 8.2 3.7 10.3h17.6 8.3l-.9-2.6c-1.4-3.9-4-7-7.7-9.3l15.6-20.1 12.3 32h13.4L245 292.2c-1.5-3.9-4-7-7.7-9.3L253 262.8 270.3 308h13.4l-11.4-29.4c-1.5-3.9-4-7-7.7-9.3l15.6-20L302.6 308h10.3 8.3 7.6c1.5 0 3-1.1 4.5-3.1s2.2-4.1 2.2-6.3V205.1c0-6.5-4.5-20.3-13.7-41.2c5.4 0 14.1-9.1 26.2-27.2V300.2c0 7.2 .6 12 1.7 14.6c1.6 3.4 5.3 6.2 11.1 8.2c-3.9 5.6-8.7 8.5-14.5 8.5H321.1h-8.3H210.5h-19zM93.4 287.3c-2.7-6.7-4-11.7-4-15c-.6 1.2-2.4 3.7-5.4 7.6c-1.4 1.9-2.2 3.7-2.2 5.3c0 2.6 .8 5.7 2.2 9.3l5.6 13.9h0c5 0 9 0 11.9-.1l-8.2-20.9zm13.5-72.4c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm-27.6 0c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm87 27.5c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsps(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUpwork(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 641 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.7 295.6c-50.3 0-83.5-38.9-92.8-53.9c11.9-95.3 46.8-125.4 92.8-125.4c45.5 0 80.9 36.4 80.9 89.7s-35.4 89.7-80.9 89.7zm0-237.8c-81.9 0-127.8 53.4-141 108.4c-14.9-28-25.9-65.5-34.5-100.3H206v141c0 51.1-23.3 89-68.8 89s-71.6-37.8-71.6-89l.5-141H.8v141c0 41.1 13.3 78.4 37.6 105.1c25 27.5 59.2 41.8 98.8 41.8c78.8 0 133.8-60.4 133.8-146.9V112.1c8.2 31.2 27.8 91.1 65.3 143.6l-35 199.4h66.4l23.1-141.3c7.6 6.3 15.7 12 24.2 17c22.2 14 47.7 21.9 73.9 22.8c0 0 4 .2 6.1 .2c81.2 0 145.9-62.9 145.9-147.8s-64.8-148.1-146-148.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUps(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUntappd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnsplash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M243.583 91.6027L323.695 138.384C326.575 140.026 326.68 144.583 323.695 146.225L228.503 201.854C225.623 203.55 222.22 203.444 219.549 201.854L124.357 146.225C121.425 144.636 121.373 139.973 124.357 138.384L204.417 91.6027V0L0 119.417V358.252L78.3843 312.477V218.914C78.3319 215.576 82.2066 213.192 85.0865 214.993L180.279 270.622C183.159 272.318 184.782 275.338 184.782 278.464V389.669C184.834 393.007 180.959 395.391 178.079 393.589L97.9673 346.808L19.583 392.583L224 512L428.417 392.583L350.033 346.808L269.921 393.589C267.093 395.338 263.114 393.06 263.218 389.669V278.464C263.218 275.126 265.051 272.159 267.721 270.622L362.914 214.993C365.741 213.245 369.72 215.47 369.616 218.914V312.477L448 358.252V119.417L243.583 0V91.6027Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUniregistry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUncharted(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUmbraco(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 510 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUikit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUbuntu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M469.2 75A75.6 75.6 0 1 0 317.9 75a75.6 75.6 0 1 0 151.2 0zM154.2 240.7A75.6 75.6 0 1 0 3 240.7a75.6 75.6 0 1 0 151.2 0zM57 346C75.6 392.9 108 433 150 461.1s91.5 42.6 142 41.7c-14.7-18.6-22.9-41.5-23.2-65.2c-6.8-.9-13.3-2.1-19.5-3.4c-26.8-5.7-51.9-17.3-73.6-34s-39.3-38.1-51.7-62.5c-20.9 9.9-44.5 12.8-67.1 8.2zm395.1 89.8a75.6 75.6 0 1 0 -151.2 0 75.6 75.6 0 1 0 151.2 0zM444 351.6c18.5 14.8 31.6 35.2 37.2 58.2c33.3-41.3 52.6-92.2 54.8-145.2s-12.5-105.4-42.2-149.4c-8.6 21.5-24 39.6-43.8 51.6c15.4 28.6 22.9 60.8 21.9 93.2s-10.7 64-28 91.6zM101.1 135.4c12.4 2.7 24.3 7.5 35.1 14.3c16.6-24.2 38.9-44.1 64.8-58S255.8 70.4 285.2 70c.2-5.9 .9-11.9 2-17.7c3.6-16.7 11.1-32.3 21.8-45.5c-47.7-3.8-95.4 6-137.6 28.5S94.3 91.7 70.8 133.4c2.7-.2 5.3-.3 8-.3c7.5 0 15 .8 22.4 2.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUber(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTypo3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTwitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTwitch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTumblr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrello(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTradeFederation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTiktok(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThreads(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThinkPeaks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThemeisle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThemeco(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTheRedYeti(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTencentWeibo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTelegram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTeamspeak(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.8 37.2c-32.2 38.1-56.1 82.6-69.9 130.5c0 .2-.1 .3-.1 .5C43.5 184.4 16 223 16 268c0 59.6 48.4 108 108 108s108-48.4 108-108c0-53.5-38.9-97.9-90-106.5c15.7-41.8 40.4-79.6 72.3-110.7c1.8-1.6 4-2.6 6.3-3.1c37.2-11.5 76.7-13.3 114.8-5.2C454.7 67.6 534 180.7 517.1 301.3c-8.4 62.6-38.6 112.7-87.7 151.4c-50.1 39.7-107.5 54.3-170.2 52.2l-24-1c12.4 2.8 25 4.9 37.6 6.3c40.7 4.2 81.4 2.1 120.1-12.5c94-35.5 149.3-102.3 162.9-202.5c4.8-52.6-5.8-105.4-30.8-152C454.6 11.3 290.8-38.4 159 32c-2.4 1.4-4.5 3.1-6.3 5.2zM309.4 433.9c-2.1 11.5-4.2 21.9-14.6 31.3c53.2-1 123.2-29.2 161.8-97.1c39.7-69.9 37.6-139.9-6.3-207.8C413.8 105 360.5 77.9 293.7 73.7c1.5 2.3 3.2 4.4 5.2 6.3l5.2 6.3c25.1 31.3 37.6 67.9 42.8 107.5c2.1 15.7-1 30.3-13.6 41.8c-4.2 3.1-5.2 6.3-4.2 10.4l7.3 17.7L365.7 318c5.2 11.5 4.2 19.8-6.3 28.2c-3.2 2.5-6.7 4.6-10.4 6.3l-18.8 8.4 3.1 13.6c3.1 6.3 1 12.5-3.1 17.7c-2.5 2.4-3.8 5.9-3.1 9.4c2.1 11.5-2.1 19.8-12.5 25.1c-2.1 1-4.2 5.2-5.2 7.3zm-133.6-3.1c16.7 11.5 34.5 20.9 53.2 26.1c24 5.2 41.8-6.3 44.9-30.3c1-8.4 5.2-14.6 12.5-17.7c7.3-4.2 8.4-7.3 2.1-13.6l-9.4-8.4 13.6-4.2c6.3-2.1 7.3-5.2 5.2-11.5c-1.4-3-2.4-6.2-3.1-9.4c-3.1-14.6-2.1-15.7 11.5-18.8c8.4-3.1 15.7-6.3 21.9-12.5c3.1-2.1 3.1-4.2 1-8.4l-16.7-30.3c-1-1.9-2.1-3.8-3.1-5.7c-6.4-11.7-13-23.6-15.7-37.1c-2.1-9.4-1-17.7 8.4-24c5.2-4.2 8.4-9.4 8.4-16.7c-.4-10.1-1.5-20.3-3.1-30.3c-6.3-37.6-23-68.9-51.2-95c-5.2-4.2-9.4-6.3-16.7-4.2L203.9 91.5c2 1.2 4 2.4 6 3.6l0 0c6.3 3.7 12.2 7.3 17 12.1c30.3 26.1 41.8 61.6 45.9 100.2c1 8.4 0 16.7-7.3 21.9c-8.4 5.2-10.4 12.5-7.3 20.9c4.9 13.2 10.4 26 16.7 38.6L291.6 318c-6.3 8.4-13.6 11.5-21.9 14.6c-12.5 3.1-14.6 7.3-10.4 20.9c.6 1.5 1.4 2.8 2.1 4.2c2.1 5.2 1 8.4-4.2 10.4l-12.5 3.1 5.2 4.2 4.2 4.2c4.2 5.2 4.2 8.4-2.1 10.4c-7.3 4.2-11.5 9.4-11.5 17.7c0 12.5-7.3 19.8-18.8 24c-3.8 1-7.6 1.5-11.5 1l-34.5-2.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSymfony(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSwift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M593.1 192.6A10.4 10.4 0 1 1 604.5 210a10.4 10.4 0 1 1 -11.4-17.4zm-47.1 12.2a38.5 38.5 0 1 1 75-17.6 38.5 38.5 0 1 1 -75 17.6zM433.7 336.7c3.2 4.6 5.8 9 7.3 13.4c1 3.1 2.4 7.3 5.5 8.9c.2 .1 .3 .2 .5 .2c5.7 2.1 20.3 1.7 20.3 1.7h26.8c2.3 0 22.4 0 21.9-2.3c-2.4-10.8-14.9-12.7-24.4-18.3c-8.7-5.2-17-11.1-20.8-21.3c-2-5.2-.8-17.4 2.6-21.8c2.5-3.2 6.1-5.3 10-6.2c4.3-.9 8.8-.1 13.1 .3c5.3 .5 10.6 1.5 15.9 2.2c10.3 1.3 20.6 1.9 31 1.6c17.1-.5 34.2-3.2 50.4-8.7c11.3-3.8 22.4-8.9 32-16.1c10.9-8.1 8.1-7.4-3-6.2c-13.3 1.4-26.6 1.6-39.9 .8c-12.4-.7-24.7-2.2-35.9-7.9c-8.8-4.6-16.4-9.1-23.4-16.2c-1-1.1-1.7-4.2 .2-6.2c1.9-1.9 5.8-.8 7 .2c12.2 10.2 30.5 18.6 49.3 19.5c10.2 .5 20.1 .7 30.4 .3c5.1-.2 12.8-.2 17.9-.3c2.6 0 9.8 .7 11.2-2.1c.4-.8 .4-1.8 .3-2.7c-1.5-40.9-4.5-86.9-47.3-106.5c-31.9-14.6-79.7-37.2-99.9-46.6c-4.7-2.2-10.2 1.3-10.2 6.5c0 13.6 .7 33.3 .7 51.1c-9.7-9.9-26-16.1-38.4-21.8c-14.1-6.5-28.7-12-43.5-16.6c-29.8-9.2-60.7-14.9-91.7-18c-35.2-3.5-71-1.8-105.7 5.3C147 115.1 90.8 142.6 48.2 182.7C22.1 207.3 1.6 242.4 .2 277.9c-2 50.3 12.1 77.3 38 105.2c41.3 44.4 130.2 50.6 166.2-2c16.2-23.7 19.7-55.8 8-82c-11.8-26.2-38.8-45.1-67.4-46c-22.2-.7-45.9 10.6-54.5 31.1c-6.5 15.7-2.8 35.1 9 47.3c4.6 4.8 10.9 8.7 17.7 7.1c4-.9 7.4-3.9 8-8c.9-6-4.4-9.9-7.6-14.5c-5.8-8.3-4.7-20.9 2.7-27.9c6.2-6 15.3-7.8 23.9-7.7c8 0 16.2 1.4 23.1 5.5c9.7 5.7 16.2 16.2 18.4 27.2c6.7 33-20.2 59.9-56.6 62c-18.6 1.1-37.6-3.8-52.1-15.5C40.1 329.9 31.1 269.4 73.2 237c40-30.7 90.4-22.8 120.2-6.8c23.8 12.8 41.5 33.6 55 56.7c6.7 11.6 12.5 23.7 17.8 36.1c5.1 11.8 9.9 23.8 20.2 32.5c6.8 5.8 15.2 5.6 24.1 5.6h50.8c6.9 0 5.2-4.6 2.2-7.7c-6.7-6.9-16.4-8.4-25.4-10.9c-20.5-5.6-18.4-32.8-12.7-32.8c18.3 0 18.9 .6 34.9 .3c23.2-.3 30.2-1.7 48.3 5c9.7 3.6 19 13.1 25.1 21.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSupple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuperpowers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStumbleupon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStumbleuponCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStudiovinari(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStubber(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.5 294.2l58.8 22.9c9.1-36.8 25.4-61.1 55-61.1c49.4 0 71.4 63.6 142.4 63.6c15.6 0 35.9-2.8 55.3-13.3V368c0 61.8-50.4 112-112.3 112H0l41.8-56L0 368l41.7-56L0 256.1l41.8-56L0 144.1 41.8 88 0 32H335.7C397.6 32 448 82.3 448 144.1v51.3c-9.2 36.3-25.9 60.6-55 60.6c-49.6 0-71.6-63.5-142.4-63.5c-35.9 0-95.2 14.6-114.1 101.6h0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStripe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStripeS(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStrava(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStickerMule(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSteam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSteamSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStaylinked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStackpath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStackOverflow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStackExchange(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarespace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareYoutube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M282 256.2l-95.2-54.1V310.3L282 256.2zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm14.4 136.1c7.6 28.6 7.6 88.2 7.6 88.2s0 59.6-7.6 88.1c-4.2 15.8-16.5 27.7-32.2 31.9C337.9 384 224 384 224 384s-113.9 0-142.2-7.6c-15.7-4.2-28-16.1-32.2-31.9C42 315.9 42 256.3 42 256.3s0-59.7 7.6-88.2c4.2-15.8 16.5-28.2 32.2-32.4C110.1 128 224 128 224 128s113.9 0 142.2 7.7c15.7 4.2 28 16.6 32.2 32.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareXing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM93.8 320.2c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6 .2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2c-3.5 6.2-7.7 9.1-12.6 9.1H93.8zm163.5-33.4v.2l65.5 119c2.8 5.1 .1 10.1-6 10.1H270.2c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c1.8-3.2 22.9-40.4 63.3-111.6c11.7-20.7 25.1-44.3 40.1-70.8c3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10L257.3 286.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareXTwitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareWhatsapp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareWebAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM235 177.6L288 224l52.2-10.4c-2.6-3.9-4.2-8.5-4.2-13.6c0-13.3 10.7-24 24-24s24 10.7 24 24c0 13-10.3 23.6-23.2 24L304.5 349.1c-5.2 11.5-16.6 18.9-29.2 18.9l-102.6 0c-12.6 0-24-7.4-29.2-18.9L87.2 224C74.3 223.6 64 213 64 200c0-13.3 10.7-24 24-24s24 10.7 24 24c0 5-1.5 9.7-4.2 13.6L160 224l53.1-46.4c-8.9-4.1-15-13.1-15-23.6c0-14.4 11.6-26 26-26s26 11.6 26 26c0 10.5-6.2 19.5-15.1 23.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareWebAwesomeStroke(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm235 81.6L288 224l52.2-10.4c-2.6-3.9-4.2-8.5-4.2-13.6c0-13.3 10.7-24 24-24s24 10.7 24 24c0 13-10.3 23.6-23.2 24L304.5 349.1c-5.2 11.5-16.6 18.9-29.2 18.9l-102.6 0c-12.6 0-24-7.4-29.2-18.9L87.2 224C74.3 223.6 64 213 64 200c0-13.3 10.7-24 24-24s24 10.7 24 24c0 5-1.5 9.7-4.2 13.6L160 224l53.1-46.4c-8.9-4.1-15-13.1-15-23.6c0-14.4 11.6-26 26-26s26 11.6 26 26c0 10.5-6.2 19.5-15.1 23.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareVimeo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM318.5 309.5C275 366 238.2 394.3 208.1 394.3c-18.7 0-34.4-17.2-47.3-51.6c-3.8-13.9-7.3-26.9-10.5-39c-18.2-68.3-28.6-107.4-46.2-107.4c-2.4 0-10.8 5-25.1 15.1L64 192c7-6.1 13.9-12.4 20.6-18.5c29.1-26.3 55.6-50.3 73.5-51.9c24.9-2.4 40.2 14.6 46 51.1c20.5 129.6 29.6 149.2 66.8 90.5c13.4-21.2 20.6-37.2 21.5-48.3c3.4-32.8-25.6-30.6-45.2-22.2c15.7-51.5 45.8-76.5 90.1-75.1c32.9 1 48.4 22.4 46.5 64c-1.4 31.1-23.2 73.8-65.3 127.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareViadeo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM118.3 381.2c-68-73.6-19.8-196.1 81.2-196.1c13.3 0 26.6 2.1 39.1 6.7c-4.3 8.4-7.3 17.6-8.4 27.1c-9.7-4.1-20.2-6-30.7-6c-48.8 0-84.6 41.7-84.6 88.9c0 43 28.5 78.7 69.5 85.9c61.5-24 72.9-117.6 72.9-175v0c0-7.3 0-14.8-.6-22.1c-11.2-32.9-26.6-64.6-44.2-94.5c27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70c0 54.1-21.9 99-68.3 128.2l-2.4 .2c50 1 86.2-38.6 86.2-87.2c0-12.2-2.1-24.3-6.9-35.7c9.5-1.9 18.5-5.6 26.4-10.5c15.3 36.6 12.6 87.3-22.8 125.6c-42.4 46.2-120 46.6-162.4 0zM274.6 217.6c21.9-12 49.6-30.7 62.3-53c1.5-3 4.1-8.6 4.5-12c-12.5 27.9-44.2 49.8-73.9 56.7c-4.7-7.3-7.5-15.5-7.5-24.3c0-10.3 5.2-24.1 12.9-31.6c8.3-7.9 18-10.9 27.9-14.1c16-5.1 32.5-10.3 44.5-35.9c32.5 46.2 13.1 130.3-36.3 130.3c-13.3 0-25.1-7.1-34.4-16.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareUpwork(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M56 32l336 0c30.9 0 56 25.1 56 56l0 336c0 30.9-25.1 56-56 56L56 480c-30.9 0-56-25.1-56-56L0 88C0 57.1 25.1 32 56 32zM270.9 274.2c6.6-52.9 25.9-69.5 51.4-69.5c25.3 0 44.9 20.2 44.9 49.7s-19.7 49.7-44.9 49.7c-27.9 0-46.3-21.5-51.4-29.9zm-26.7-41.8c-8.2-15.5-14.3-36.3-19.2-55.6l-29.7 0-33.2 0 0 78.1c0 28.4-12.9 49.4-38.2 49.4s-39.8-20.9-39.8-49.3l.3-78.1-36.2 0 0 78.1c0 22.8 7.4 43.5 20.9 58.2c13.9 15.2 32.8 23.2 54.8 23.2c43.7 0 74.2-33.5 74.2-81.5l0-52.5c4.6 17.3 15.4 50.5 36.2 79.7L215 392.6l36.8 0 12.8-78.4c4.2 3.5 8.7 6.6 13.4 9.4c12.3 7.8 26.4 12.2 40.9 12.6l.1 0c.5 0 1.1 0 1.6 0c.6 0 1.1 0 1.7 0c45.1 0 80.9-34.9 80.9-81.9s-35.9-82.2-80.9-82.2c-45.4 0-70.9 29.7-78.1 60.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareTwitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM351.3 199.3v0c0 86.7-66 186.6-186.6 186.6c-37.2 0-71.7-10.8-100.7-29.4c5.3 .6 10.4 .8 15.8 .8c30.7 0 58.9-10.4 81.4-28c-28.8-.6-53-19.5-61.3-45.5c10.1 1.5 19.2 1.5 29.6-1.2c-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3c-9-6-16.4-14.1-21.5-23.6s-7.8-20.2-7.7-31c0-12.2 3.2-23.4 8.9-33.1c32.3 39.8 80.8 65.8 135.2 68.6c-9.3-44.5 24-80.6 64-80.6c18.9 0 35.9 7.9 47.9 20.7c14.8-2.8 29-8.3 41.6-15.8c-4.9 15.2-15.2 28-28.8 36.1c13.2-1.4 26-5.1 37.8-10.2c-8.9 13.1-20.1 24.7-32.9 34c.2 2.8 .2 5.7 .2 8.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareTumblr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM256.8 416c-75.5 0-91.9-55.5-91.9-87.9v-90H135.2c-3.4 0-6.2-2.8-6.2-6.2V189.4c0-4.5 2.8-8.5 7.1-10c38.8-13.7 50.9-47.5 52.7-73.2c.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2H249.1V321c0 21.4 14.8 33.5 42.5 22.4c3-1.2 5.6-2 8-1.4c2.2 .5 3.6 2.1 4.6 4.9L318 387.1c1 3.2 2 6.7-.3 9.1c-8.5 9.1-31.2 19.8-60.9 19.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareThreads(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM294.2 244.3c19.5 9.3 33.7 23.5 41.2 40.9c10.4 24.3 11.4 63.9-20.2 95.4c-24.2 24.1-53.5 35-95.1 35.3h-.2c-46.8-.3-82.8-16.1-106.9-46.8C91.5 341.8 80.4 303.7 80 256v-.1-.1c.4-47.7 11.5-85.7 33-113.1c24.2-30.7 60.2-46.5 106.9-46.8h.2c46.9 .3 83.3 16 108.2 46.6c12.3 15.1 21.3 33.3 27 54.4l-26.9 7.2c-4.7-17.2-11.9-31.9-21.4-43.6c-19.4-23.9-48.7-36.1-87-36.4c-38 .3-66.8 12.5-85.5 36.2c-17.5 22.3-26.6 54.4-26.9 95.5c.3 41.1 9.4 73.3 26.9 95.5c18.7 23.8 47.4 36 85.5 36.2c34.3-.3 56.9-8.4 75.8-27.3c21.5-21.5 21.1-47.9 14.2-64c-4-9.4-11.4-17.3-21.3-23.3c-2.4 18-7.9 32.2-16.5 43.2c-11.4 14.5-27.7 22.4-48.4 23.5c-15.7 .9-30.8-2.9-42.6-10.7c-13.9-9.2-22-23.2-22.9-39.5c-1.7-32.2 23.8-55.3 63.5-57.6c14.1-.8 27.3-.2 39.5 1.9c-1.6-9.9-4.9-17.7-9.8-23.4c-6.7-7.8-17.1-11.8-30.8-11.9h-.4c-11 0-26 3.1-35.6 17.6l-23-15.8c12.8-19.4 33.6-30.1 58.5-30.1h.6c41.8 .3 66.6 26.3 69.1 71.8c1.4 .6 2.8 1.2 4.2 1.9l.1 .5zm-71.8 67.5c17-.9 36.4-7.6 39.7-48.8c-8.8-1.9-18.6-2.9-29-2.9c-3.2 0-6.4 .1-9.6 .3c-28.6 1.6-38.1 15.5-37.4 27.9c.9 16.7 19 24.5 36.4 23.6l-.1-.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareSteam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.6 309.1c18.6 7.7 27.3 28.9 19.6 47.4s-29 27.2-47.6 19.4l-28.5-11.8c5 10.6 13.8 19.4 25.4 24.2c25.2 10.5 54.1-1.4 64.6-26.5c5.1-12.1 5.1-25.5 .1-37.7c-5.1-12.1-14.5-21.6-26.7-26.7c-12.1-5-25-4.8-36.4-.5l29.5 12.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V240.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8c-31.8 0-58.5-22.7-64.5-52.7L0 319.2V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM241.9 196.2a58.4 58.4 0 1 0 116.8 0 58.4 58.4 0 1 0 -116.8 0zm14.6-.1a43.9 43.9 0 1 1 87.8 0 43.9 43.9 0 1 1 -87.8 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareSnapchat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm-3.907,319.309-.083.1a32.364,32.364,0,0,1-8.717,6.823,90.26,90.26,0,0,1-20.586,8.2,12.694,12.694,0,0,0-3.852,1.76c-2.158,1.909-2.1,4.64-4.4,8.55a23.137,23.137,0,0,1-6.84,7.471c-6.707,4.632-14.244,4.923-22.23,5.23-7.214.274-15.39.581-24.729,3.669-3.761,1.245-7.753,3.694-12.377,6.533-11.265,6.9-26.68,16.353-52.3,16.353s-40.925-9.4-52.106-16.279c-4.657-2.888-8.675-5.362-12.543-6.64-9.339-3.08-17.516-3.4-24.729-3.67-7.986-.307-15.523-.6-22.231-5.229a23.085,23.085,0,0,1-6.01-6.11c-3.2-4.632-2.855-7.8-5.254-9.895a13.428,13.428,0,0,0-4.1-1.834,89.986,89.986,0,0,1-20.313-8.127,32.905,32.905,0,0,1-8.3-6.284c-6.583-6.757-8.276-14.776-5.686-21.824,3.436-9.338,11.571-12.111,19.4-16.262,14.776-8.027,26.348-18.055,34.433-29.884a68.236,68.236,0,0,0,5.985-10.567c.789-2.158.772-3.329.241-4.416a7.386,7.386,0,0,0-2.208-2.217c-2.532-1.676-5.113-3.353-6.882-4.5-3.27-2.141-5.868-3.818-7.529-4.98-6.267-4.383-10.65-9.04-13.4-14.245a28.4,28.4,0,0,1-1.369-23.584c4.134-10.924,14.469-17.706,26.978-17.706a37.141,37.141,0,0,1,7.845.83c.689.15,1.37.307,2.042.482-.108-7.43.058-15.357.722-23.119,2.358-27.261,11.912-41.589,21.874-52.994a86.836,86.836,0,0,1,22.28-17.931C188.254,100.383,205.312,96,224,96s35.828,4.383,50.944,13.016a87.169,87.169,0,0,1,22.239,17.9c9.961,11.406,19.516,25.709,21.874,52.995a231.194,231.194,0,0,1,.713,23.118c.673-.174,1.362-.332,2.051-.481a37.131,37.131,0,0,1,7.844-.83c12.5,0,22.82,6.782,26.971,17.706a28.37,28.37,0,0,1-1.4,23.559c-2.74,5.2-7.123,9.861-13.39,14.244-1.668,1.187-4.258,2.864-7.529,4.981-1.835,1.187-4.541,2.947-7.164,4.682a6.856,6.856,0,0,0-1.951,2.034c-.506,1.046-.539,2.191.166,4.208a69.015,69.015,0,0,0,6.085,10.792c8.268,12.1,20.188,22.313,35.454,30.407,1.486.772,2.98,1.5,4.441,2.258.722.332,1.569.763,2.491,1.3,4.9,2.723,9.2,6.01,11.455,12.153C387.821,336.915,386.269,344.7,380.093,351.309Zm-16.719-18.461c-50.313-24.314-58.332-61.918-58.689-64.749-.431-3.379-.921-6.035,2.806-9.472,3.594-3.328,19.541-13.19,23.965-16.278,7.33-5.114,10.534-10.219,8.16-16.495-1.66-4.316-5.686-5.976-9.961-5.976a18.5,18.5,0,0,0-3.993.448c-8.035,1.743-15.838,5.769-20.354,6.857a7.1,7.1,0,0,1-1.66.224c-2.408,0-3.279-1.071-3.088-3.968.564-8.783,1.759-25.925.373-41.937-1.884-22.032-8.99-32.948-17.432-42.6-4.051-4.624-23.135-24.654-59.536-24.654S168.53,134.359,164.479,139c-8.434,9.654-15.531,20.57-17.432,42.6-1.386,16.013-.141,33.147.373,41.937.166,2.756-.68,3.968-3.088,3.968a7.1,7.1,0,0,1-1.66-.224c-4.507-1.087-12.31-5.113-20.346-6.856a18.494,18.494,0,0,0-3.993-.449c-4.25,0-8.3,1.636-9.961,5.977-2.374,6.276.847,11.381,8.168,16.494,4.425,3.088,20.371,12.958,23.966,16.279,3.719,3.437,3.237,6.093,2.805,9.471-.356,2.79-8.384,40.394-58.689,64.749-2.946,1.428-7.96,4.45.88,9.331,13.88,7.628,23.111,6.807,30.3,11.43,6.093,3.927,2.5,12.394,6.923,15.449,5.454,3.76,21.583-.266,42.335,6.6,17.433,5.744,28.116,22.015,58.963,22.015s41.788-16.3,58.938-21.973c20.795-6.865,36.89-2.839,42.336-6.6,4.433-3.055.822-11.522,6.923-15.448,7.181-4.624,16.411-3.8,30.3-11.472C371.36,337.355,366.346,334.333,363.374,332.848Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareReddit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM305.9 166.4c20.6 0 37.3-16.7 37.3-37.3s-16.7-37.3-37.3-37.3c-18 0-33.1 12.8-36.6 29.8c-30.2 3.2-53.8 28.8-53.8 59.9l0 .2c-32.8 1.4-62.8 10.7-86.6 25.5c-8.8-6.8-19.9-10.9-32-10.9c-28.9 0-52.3 23.4-52.3 52.3c0 21 12.3 39 30.1 47.4c1.7 60.7 67.9 109.6 149.3 109.6s147.6-48.9 149.3-109.7c17.7-8.4 29.9-26.4 29.9-47.3c0-28.9-23.4-52.3-52.3-52.3c-12 0-23 4-31.9 10.8c-24-14.9-54.3-24.2-87.5-25.4l0-.1c0-22.2 16.5-40.7 37.9-43.7l0 0c3.9 16.5 18.7 28.7 36.3 28.7zM155 248.1c14.6 0 25.8 15.4 25 34.4s-11.8 25.9-26.5 25.9s-27.5-7.7-26.6-26.7s13.5-33.5 28.1-33.5zm166.4 33.5c.9 19-12 26.7-26.6 26.7s-25.6-6.9-26.5-25.9c-.9-19 10.3-34.4 25-34.4s27.3 14.6 28.1 33.5zm-42.1 49.6c-9 21.5-30.3 36.7-55.1 36.7s-46.1-15.1-55.1-36.7c-1.1-2.6 .7-5.4 3.4-5.7c16.1-1.6 33.5-2.5 51.7-2.5s35.6 .9 51.7 2.5c2.7 .3 4.5 3.1 3.4 5.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarePinterest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h72.6l-2.2-.8c-5.4-48.1-3.1-57.5 15.7-134.7c3.9-16 8.5-35 13.9-57.9c0 0-7.3-14.8-7.3-36.5c0-70.7 75.5-78 75.5-25c0 13.5-5.4 31.1-11.2 49.8c-3.3 10.6-6.6 21.5-9.1 32c-5.7 24.5 12.3 44.4 36.4 44.4c43.7 0 77.2-46 77.2-112.4c0-58.8-42.3-99.9-102.6-99.9C153 139 112 191.4 112 245.6c0 21.1 8.2 43.7 18.3 56c2 2.4 2.3 4.5 1.7 7c-1.1 4.7-3.1 12.9-4.7 19.2c-1 4-1.8 7.3-2.1 8.6c-1.1 4.5-3.5 5.5-8.2 3.3c-30.6-14.3-49.8-59.1-49.8-95.1C67.2 167.1 123.4 96 229.4 96c85.2 0 151.4 60.7 151.4 141.8c0 84.6-53.3 152.7-127.4 152.7c-24.9 0-48.3-12.9-56.3-28.2c0 0-12.3 46.9-15.3 58.4c-5 19.3-17.6 42.9-27.4 59.3H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarePiedPiper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareOdnoklassniki(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 137.1a39.9 39.9 0 1 0 0 79.7 39.9 39.9 0 1 0 0-79.7zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM224 95.9A81 81 0 1 1 224 258a81 81 0 1 1 0-162.1zm59.3 168.3c16.8-13.2 29.5-5.5 34.1 3.6c7.8 16-1.1 23.7-21.5 37c-17.1 10.9-40.7 15.2-56.2 16.8l13 12.9 47.7 47.7c17.4 17.9-11 45.8-28.6 28.6c-12-12.2-29.5-29.7-47.7-47.9l0 0-47.7 47.9c-17.7 17.2-46-11-28.4-28.6c3.7-3.7 7.9-7.9 12.5-12.5c10.4-10.4 22.6-22.7 35.2-35.2l12.9-12.9c-15.4-1.6-39.3-5.7-56.6-16.8c-20.3-13.3-29.3-20.9-21.4-37c4.6-9.1 17.3-16.8 34.1-3.6c0 0 22.7 18 59.3 18s59.3-18 59.3-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareLetterboxd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM105.1 187C66.4 187 35 218.3 35 257s31.4 70 70.1 70c24.8 0 46.5-12.8 59-32.2l.5-.7-.4-.6c-6.5-10.6-10.2-23.1-10.2-36.5c0-13.6 3.9-26.3 10.6-37.1c-12.4-19.8-34.4-32.9-59.5-32.9zM224 187c-24.8 0-46.5 12.8-59 32.2l-.5 .7 .4 .6c6.5 10.6 10.2 23.1 10.2 36.5c0 13.6-3.9 26.3-10.6 37.1C176.9 313.8 198.9 327 224 327c24.8 0 46.5-12.8 59-32.2l.5-.7-.4-.6c-6.5-10.6-10.2-23.1-10.2-36.5c0-13.6 3.9-26.3 10.6-37.1C271.1 200.2 249.1 187 224 187zm118.9 0c-24.8 0-46.5 12.8-59 32.2l-.5 .7 .4 .6c6.5 10.6 10.2 23.1 10.2 36.5c0 13.6-3.9 26.3-10.6 37.1c12.4 19.8 34.4 32.9 59.5 32.9c38.7 0 70.1-31.3 70.1-70s-31.4-70-70.1-70z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareLastfm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM210.7 280.8c-1.8-5.5-3.4-10.8-5-15.9c-12.9-41.9-21-68.4-58-68.4c-22.4 0-45.1 16.1-45.1 61.2c0 35.2 18 57.2 43.3 57.2c28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8c0-57.9 28.6-92 82.5-92c67.9 0 79.3 35.3 96.4 88.4c1.4 4.4 2.9 8.9 4.4 13.5c8.8 26.8 24.2 46.2 61.2 46.2c24.9 0 38.1-5.5 38.1-19.1c0-17.5-16.9-21.2-40-26.4c-3.2-.7-6.5-1.4-9.9-2.2c-30.4-7.3-42.5-23.1-42.5-48c0-40 32.3-52.4 65.2-52.4c37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4c-16.1 0-26 7.3-26 19.8c0 11 4.8 17.6 20.9 21.3c2.2 .5 4.5 1 6.7 1.4c31.1 6.5 65.1 13.7 65.1 56.1c.1 36.7-30.7 50.6-76.1 50.6c-63.4 0-85.4-28.6-97.1-64.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareJs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM180.9 444.9c-33.7 0-53.2-17.4-63.2-38.5L152 385.7c6.6 11.7 12.6 21.6 27.1 21.6c13.8 0 22.6-5.4 22.6-26.5V237.7h42.1V381.4c0 43.6-25.6 63.5-62.9 63.5zm85.8-43L301 382.1c9 14.7 20.8 25.6 41.5 25.6c17.4 0 28.6-8.7 28.6-20.8c0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5c0-31.6 24.1-55.6 61.6-55.6c26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18c-12.3 0-20.1 7.8-20.1 18c0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2c0 37.8-29.8 58.6-69.7 58.6c-39.1 0-64.4-18.6-76.7-43z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareInstagram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareHackerNews(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM21 229.2c0 0 .1-.1 .1-.2s.1-.2 .2-.2c0 .1 0 .3-.1 .4H21zM239.2 384H207.8V281.3L128 128h37.3c41.5 77.7 48.1 95.8 54.1 112c1.6 4.3 3.1 8.5 5.2 13.6c3.2-7 5.1-11.9 7.1-17.3c5.9-15.3 12.8-33.2 53.5-108.3H320L239.2 283.1V384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareGooglePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM64 256c0-55.3 44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4c-34.1 0-61.9 28.2-61.9 63.2c0 34.9 27.8 63.2 61.9 63.2c39.6 0 54.4-28.5 56.8-43.1H164V241.8h94.4c1 5 1.6 10.1 1.6 16.6c0 57.1-38.3 97.6-96 97.6c-55.3 0-100-44.7-100-100zm291 18.2v29H325.8v-29h-29V245h29V216H355v29h29v29.2H355z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareGitlab(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm337.5 12.5l44.6 116.4 .4 1.2c5.6 16.8 7.2 35.2 2.3 52.5c-5 17.2-15.4 32.4-29.8 43.3l-.2 .1-68.4 51.2-54.1 40.9c-.5 .2-1.1 .5-1.7 .8c-2 1-4.4 2-6.7 2c-3 0-6.8-1.8-8.3-2.8l-54.2-40.9L93.5 322.3l-.4-.3-.2-.1c-14.3-10.8-24.8-26-29.7-43.3s-4.2-35.7 2.2-52.5l.5-1.2 44.7-116.4c.9-2.3 2.5-4.3 4.5-5.6c1.6-1 3.4-1.6 5.2-1.8c1.3-.7 2.1-.4 3.4 .1c.6 .2 1.2 .5 2 .7c1 .4 1.6 .9 2.4 1.5c.6 .4 1.2 1 2.1 1.5c1.2 1.4 2.2 3 2.7 4.8l29.2 92.2H285l30.2-92.2c.5-1.8 1.4-3.4 2.6-4.8s2.8-2.4 4.5-3.1c1.7-.6 3.6-.9 5.4-.7s3.6 .8 5.2 1.8c2 1.3 3.7 3.3 4.6 5.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareGithub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM265.8 407.7c0-1.8 0-6 .1-11.6c.1-11.4 .1-28.8 .1-43.7c0-15.6-5.2-25.5-11.3-30.7c37-4.1 76-9.2 76-73.1c0-18.2-6.5-27.3-17.1-39c1.7-4.3 7.4-22-1.7-45c-13.9-4.3-45.7 17.9-45.7 17.9c-13.2-3.7-27.5-5.6-41.6-5.6s-28.4 1.9-41.6 5.6c0 0-31.8-22.2-45.7-17.9c-9.1 22.9-3.5 40.6-1.7 45c-10.6 11.7-15.6 20.8-15.6 39c0 63.6 37.3 69 74.3 73.1c-4.8 4.3-9.1 11.7-10.6 22.3c-9.5 4.3-33.8 11.7-48.3-13.9c-9.1-15.8-25.5-17.1-25.5-17.1c-16.2-.2-1.1 10.2-1.1 10.2c10.8 5 18.4 24.2 18.4 24.2c9.7 29.7 56.1 19.7 56.1 19.7c0 9 .1 21.7 .1 30.6c0 4.8 .1 8.6 .1 10c0 4.3-3 9.5-11.5 8C106 393.6 59.8 330.8 59.8 257.4c0-91.8 70.2-161.5 162-161.5s166.2 69.7 166.2 161.5c.1 73.4-44.7 136.3-110.7 158.3c-8.4 1.5-11.5-3.7-11.5-8zm-90.5-54.8c-.2-1.5 1.1-2.8 3-3.2c1.9-.2 3.7 .6 3.9 1.9c.3 1.3-1 2.6-3 3c-1.9 .4-3.7-.4-3.9-1.7zm-9.1 3.2c-2.2 .2-3.7-.9-3.7-2.4c0-1.3 1.5-2.4 3.5-2.4c1.9-.2 3.7 .9 3.7 2.4c0 1.3-1.5 2.4-3.5 2.4zm-14.3-2.2c-1.9-.4-3.2-1.9-2.8-3.2s2.4-1.9 4.1-1.5c2 .6 3.3 2.1 2.8 3.4c-.4 1.3-2.4 1.9-4.1 1.3zm-12.5-7.3c-1.5-1.3-1.9-3.2-.9-4.1c.9-1.1 2.8-.9 4.3 .6c1.3 1.3 1.8 3.3 .9 4.1c-.9 1.1-2.8 .9-4.3-.6zm-8.5-10c-1.1-1.5-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3c1.1 1.5 1.1 3.3 0 4.1c-.9 .6-2.6 0-3.7-1.5zm-6.3-8.8c-1.1-1.3-1.3-2.8-.4-3.5c.9-.9 2.4-.4 3.5 .6c1.1 1.3 1.3 2.8 .4 3.5c-.9 .9-2.4 .4-3.5-.6zm-6-6.4c-1.3-.6-1.9-1.7-1.5-2.6c.4-.6 1.5-.9 2.8-.4c1.3 .7 1.9 1.8 1.5 2.6c-.4 .9-1.7 1.1-2.8 .4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareGit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.8 335.5c-5.9-.4-12.6-.8-20.2-1.3c-3.3 4.1-6.6 8.4-6.6 13.5c0 18.5 65.5 18.5 65.5-1.5c0-8.3-7.4-8.7-38.8-10.7zm7.8-117.9c-32.3 0-33.7 44.5-.7 44.5c32.5 0 31.7-44.5 .7-44.5zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM243.9 172.2c-14.5 0-22.9-8.4-22.9-22.9c0-14.5 8.4-22.3 22.9-22.3c14.7 0 23.1 7.8 23.1 22.3s-8.4 22.9-23.1 22.9zM149.6 195h49.5l0 21.6-23.4 1.8c4.6 5.8 9.4 14 9.4 25.7c0 48.7-57.2 47.2-74.2 42.4l-8.4 13.4c5 .3 9.8 .6 14.3 .8c56.3 3.2 80.5 4.6 80.5 38.5c0 29.2-25.7 45.7-69.9 45.7c-46 0-63.5-11.6-63.5-31.7c0-11.4 5.1-17.5 14-25.9c-8.4-3.5-11.2-9.9-11.2-16.8c0-9.6 7.4-16.3 23-30.6l.2-.2c-12.4-6.1-21.8-19.3-21.8-38.1c0-51.6 56.6-53.3 81.6-46.8zM270.5 303.1l13 1.8 0 20.1H211.1V304.9c2.7-.4 5-.7 6.9-.9c9.9-1.2 10.1-1.3 10.1-6V223.3c0-4.4-.9-4.7-10.1-7.8c-1.9-.7-4.2-1.4-6.9-2.4l2.8-20.6h52.6V298c0 4.1 .2 4.6 4.1 5.1zm106.6-10.4L384 315c-10.9 5.4-26.9 10.2-41.4 10.2c-30.2 0-41.7-12.2-41.7-40.9V217.7c0-.8 0-1.4-.2-1.8c-.8-1.2-4.2-.7-19.6-.7V192.6c22.3-2.5 31.2-13.7 34-41.4h24.2c0 33.3-.6 38 .7 38.6c.3 .1 .7 0 1.3 0h35.8v25.4H339.3v60.7c0 .2 0 .5 0 .9c-.2 6.3-.9 30.4 37.9 15.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareFontAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm90 122c0 9.3-4.8 17.4-12.1 22l188.9 0c7.3 0 13.2 5.9 13.2 13.2c0 1.8-.4 3.7-1.1 5.4L312 264l30.9 69.4c.7 1.7 1.1 3.5 1.1 5.4c0 7.3-5.9 13.2-13.2 13.2L144 352l0 32-32 0 0-32 0-176 0-1.5c-6.1-4.8-10-12.2-10-20.5c0-14.4 11.6-26 26-26s26 11.6 26 26z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareFontAwesomeStroke(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm154 58c0 9.3-4.8 17.4-12.1 22l188.9 0c7.3 0 13.2 5.9 13.2 13.2c0 1.8-.4 3.7-1.1 5.4L312 264l30.9 69.4c.8 1.7 1.1 3.5 1.1 5.4c0 7.3-5.9 13.2-13.2 13.2L144 352l0 32-32 0 0-32 0-176 0-1.5c-6.1-4.8-10-12.2-10-20.5c0-14.4 11.6-26 26-26s26 11.6 26 26z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareFacebook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareDribbble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.9 132.5c-38.3 18-66.8 53.3-75.7 95.7c6.1 .1 62.4 .3 126.4-16.7c-22.7-40.2-47.1-74.1-50.7-79zm26.1-9.1c3.8 5.1 28.6 38.9 51 80c48.6-18.3 69.1-45.9 71.6-49.4C281 124.2 235.3 112.9 192 123.4zM277.4 382c-2-12-10-53.8-29.2-103.6c-55.1 18.8-93.8 56.4-108.1 85.6c40.5 31.6 93.3 36.7 137.3 18zM227.8 232.6C159.6 253 93.4 252.2 87.4 252c0 .7 0 1.4 0 2.1s0 1.4 0 2.1c0 35.1 13.3 67.1 35.1 91.4c22.2-37.9 67.1-77.9 116.5-91.8c-3.4-7.8-7.2-15.5-11.1-23.2zm72.5 136.9c30.7-20.7 52.5-53.6 58.6-91.6c-4.6-1.5-42.3-12.7-85.1-5.8c17.9 49.1 25.1 89.1 26.5 97.4zm-34.8-119c45.5-5.7 90.7 3.4 95.2 4.4c-.3-32.3-11.8-61.9-30.9-85.1c-2.9 3.9-25.8 33.2-76.3 53.9c4.8 9.8 8.3 17.8 12 26.8zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM224 416a160 160 0 1 1 0-320 160 160 0 1 1 0 320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareBluesky(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 247.4c14.5-30 54-85.8 90.7-113.3c26.5-19.9 69.3-35.2 69.3 13.7c0 9.8-5.6 82.1-8.9 93.8c-11.4 40.8-53 51.2-90 44.9c64.7 11 81.2 47.5 45.6 84c-67.5 69.3-97-17.4-104.6-39.6c0 0 0 0 0 0l-.3-.9c-.9-2.6-1.4-4.1-1.8-4.1s-.9 1.5-1.8 4.1c-.1 .3-.2 .6-.3 .9c0 0 0 0 0 0c-7.6 22.2-37.1 108.8-104.6 39.6c-35.5-36.5-19.1-73 45.6-84c-37 6.3-78.6-4.1-90-44.9c-3.3-11.7-8.9-84-8.9-93.8c0-48.9 42.9-33.5 69.3-13.7c36.7 27.5 76.2 83.4 90.7 113.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareBehance(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M155.3 318.4c17.2 0 31.2-6.1 31.2-25.4c0-19.7-11.7-27.4-30.3-27.5h-46v52.9h45.1zm-5.4-129.6H110.3v44.8H153c15.1 0 25.8-6.6 25.8-22.9c0-17.7-13.7-21.9-28.9-21.9zm129.5 74.8h62.2c-1.7-18.5-11.3-29.7-30.5-29.7c-18.3 0-30.5 11.4-31.7 29.7zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM349.5 185H271.7V166.1h77.8V185zM193.7 243.7c23.6 6.7 35 27.5 35 51.6c0 39-32.7 55.7-67.6 55.9H68v-192h90.5c32.9 0 61.4 9.3 61.4 47.5c0 19.3-9 28.8-26.2 37zm118.7-38.6c43.5 0 67.6 34.3 67.6 75.4c0 1.6-.1 3.3-.2 5c0 .8-.1 1.5-.1 2.2H279.5c0 22.2 11.7 35.3 34.1 35.3c11.6 0 26.5-6.2 30.2-18.1h33.7c-10.4 31.9-31.9 46.8-65.1 46.8c-43.8 0-71.1-29.7-71.1-73c0-41.8 28.7-73.6 71.1-73.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpotify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpeakerDeck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpeakap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpaceAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 256H128V512H0V352H32V320H64V288H96V256zM512 352V512H384V256H416V288H448V320H480V352H512zM320 64H352V448H320V416H192V448H160V64H192V32H224V0H288V32H320V64zM288 128H224V192H288V128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSourcetree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSoundcloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.8 298.6c-1.3 23.1-11.5 44.8-28.4 60.5s-39.2 24.4-62.3 24.1h-218c-4.8 0-9.4-2-12.8-5.4s-5.3-8-5.3-12.8V130.2c-.2-4 .9-8 3.1-11.4s5.3-6.1 9-7.7c0 0 20.1-13.9 62.3-13.9c25.8 0 51.1 6.9 73.3 20.1c17.3 10.2 32.3 23.8 44.1 40.1s20 34.8 24.2 54.4c7.5-2.1 15.3-3.2 23.1-3.2c11.7-.1 23.3 2.2 34.2 6.7S606.8 226.6 615 235s14.6 18.3 18.9 29.3s6.3 22.6 5.9 34.3zm-354-153.5c.1-1 0-2-.3-2.9s-.8-1.8-1.5-2.6s-1.5-1.3-2.4-1.7s-1.9-.6-2.9-.6s-2 .2-2.9 .6s-1.7 1-2.4 1.7s-1.2 1.6-1.5 2.6s-.4 1.9-.3 2.9c-6 78.9-10.6 152.9 0 231.6c.2 1.7 1 3.3 2.3 4.5s3 1.8 4.7 1.8s3.4-.6 4.7-1.8s2.1-2.8 2.3-4.5c11.3-79.4 6.6-152 0-231.6zm-44 27.3c-.2-1.8-1.1-3.5-2.4-4.7s-3.1-1.9-5-1.9s-3.6 .7-5 1.9s-2.2 2.9-2.4 4.7c-7.9 67.9-7.9 136.5 0 204.4c.3 1.8 1.2 3.4 2.5 4.5s3.1 1.8 4.8 1.8s3.5-.6 4.8-1.8s2.2-2.8 2.5-4.5c8.8-67.8 8.8-136.5 .1-204.4zm-44.3-6.9c-.2-1.8-1-3.4-2.3-4.6s-3-1.8-4.8-1.8s-3.5 .7-4.8 1.8s-2.1 2.8-2.3 4.6c-6.7 72-10.2 139.3 0 211.1c0 1.9 .7 3.7 2.1 5s3.1 2.1 5 2.1s3.7-.7 5-2.1s2.1-3.1 2.1-5c10.5-72.8 7.3-138.2 .1-211.1zm-44 20.6c0-1.9-.8-3.8-2.1-5.2s-3.2-2.1-5.2-2.1s-3.8 .8-5.2 2.1s-2.1 3.2-2.1 5.2c-8.1 63.3-8.1 127.5 0 190.8c.2 1.8 1 3.4 2.4 4.6s3.1 1.9 4.8 1.9s3.5-.7 4.8-1.9s2.2-2.8 2.4-4.6c8.8-63.3 8.9-127.5 .3-190.8zM109 233.7c0-1.9-.8-3.8-2.1-5.1s-3.2-2.1-5.1-2.1s-3.8 .8-5.1 2.1s-2.1 3.2-2.1 5.1c-10.5 49.2-5.5 93.9 .4 143.6c.3 1.6 1.1 3.1 2.3 4.2s2.8 1.7 4.5 1.7s3.2-.6 4.5-1.7s2.1-2.5 2.3-4.2c6.6-50.4 11.6-94.1 .4-143.6zm-44.1-7.5c-.2-1.8-1.1-3.5-2.4-4.8s-3.2-1.9-5-1.9s-3.6 .7-5 1.9s-2.2 2.9-2.4 4.8c-9.3 50.2-6.2 94.4 .3 144.5c.7 7.6 13.6 7.5 14.4 0c7.2-50.9 10.5-93.8 .3-144.5zM20.3 250.8c-.2-1.8-1.1-3.5-2.4-4.8s-3.2-1.9-5-1.9s-3.6 .7-5 1.9s-2.3 2.9-2.4 4.8c-8.5 33.7-5.9 61.6 .6 95.4c.2 1.7 1 3.3 2.3 4.4s2.9 1.8 4.7 1.8s3.4-.6 4.7-1.8s2.1-2.7 2.3-4.4c7.5-34.5 11.2-61.8 .4-95.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnapchat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlideshare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkype(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkyatlas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSketch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSitrox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.439 0.00846128V0H448V128H64C64 57.6008 141.755 0.475338 212.439 0.00846128ZM237.256 192V192.007C307.135 192.475 384 249.6 384 320H210.809V319.995C140.915 319.563 64 262.424 64 192H237.256ZM235.565 511.993C306.251 511.521 384 454.399 384 384H0V512H235.565V511.993Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSith(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSistrix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSimplybuilt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignalMessenger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c13.3 0 26.3 1 39.1 3l-3.7 23.7C279.9 24.9 268 24 256 24s-23.9 .9-35.4 2.7L216.9 3C229.7 1 242.7 0 256 0zm60.8 7.3l-5.7 23.3c23.4 5.7 45.4 14.9 65.4 27.1l12.5-20.5c-22.1-13.4-46.4-23.6-72.2-29.9zm90.5 42.2L393.1 68.8c19.1 14 36 30.9 50.1 50.1l19.4-14.2C447 83.6 428.4 65 407.3 49.5zm67.5 73.6l-20.5 12.5c12.2 20 21.4 42 27.1 65.4l23.3-5.7c-6.3-25.8-16.5-50.1-29.9-72.2zM509 216.9l-23.7 3.7c1.8 11.5 2.7 23.4 2.7 35.4s-.9 23.9-2.7 35.4l23.7 3.7c1.9-12.7 3-25.8 3-39.1s-1-26.3-3-39.1zM454.3 376.5c12.2-20 21.4-42 27.1-65.4l23.3 5.7c-6.3 25.8-16.5 50.1-29.9 72.2l-20.5-12.5zm-11.1 16.6l19.4 14.2c-15.5 21.1-34.1 39.8-55.2 55.2l-14.2-19.4c19.1-14 36-30.9 50.1-50.1zm-66.7 61.2l12.5 20.5c-22.1 13.4-46.4 23.6-72.2 29.9l-5.7-23.3c23.4-5.7 45.4-14.9 65.4-27.1zm-85.1 31l3.7 23.7c-12.7 1.9-25.8 3-39.1 3s-26.3-1-39.1-3l3.7-23.7c11.5 1.8 23.4 2.7 35.4 2.7s23.9-.9 35.4-2.7zm-90.5-3.9l-5.7 23.3c-19.4-4.7-37.9-11.6-55.3-20.5l-24.3 5.7-5.5-23.4 32.8-7.7 7.8 4c15.7 8 32.5 14.3 50.1 18.6zM90 471.3l5.5 23.4-41.6 9.7C26 510.8 1.2 486 7.6 458.2l9.7-41.6L40.7 422 31 463.7c-2.4 10.4 6.9 19.7 17.3 17.3L90 471.3zM45.5 401.8l-23.4-5.5L27.8 372C18.9 354.7 12 336.1 7.3 316.7l23.3-5.7c4.3 17.6 10.6 34.4 18.6 50.1l4 7.8-7.7 32.8zM26.7 291.4L3 295.1C1 282.3 0 269.3 0 256s1-26.3 3-39.1l23.7 3.7C24.9 232.1 24 244 24 256s.9 23.9 2.7 35.4zm3.9-90.5L7.3 195.2c6.3-25.8 16.5-50.1 29.9-72.2l20.5 12.5c-12.2 20-21.4 42-27.1 65.4zm38.3-82.1L49.5 104.7C65 83.6 83.6 65 104.7 49.5l14.2 19.4c-19.1 14-36 30.9-50.1 50.1zm66.7-61.2L123.1 37.2c22.1-13.4 46.4-23.6 72.2-29.9l5.7 23.3c-23.4 5.7-45.4 14.9-65.4 27.1zM464 256c0 114.9-93.1 208-208 208c-36.4 0-70.7-9.4-100.5-25.8c-2.9-1.6-6.2-2.1-9.4-1.4L53.6 458.4l21.6-92.5c.7-3.2 .2-6.5-1.4-9.4C57.4 326.7 48 292.4 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShopware(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShopify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShoelace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M404.9 331c2.2-1.1 4.4-2.3 6.5-3.7l8.3-4.8c1.5-1.1 4.4-3.4 8.7-6.7l.5-.5c3.4-3.4 7.2-5 11.3-4.9c1.8 0 3.9 .5 6.4 1.5l31-27.5c.9-.7 1.7-1.3 2.6-1.8h.2c3.3-1.9 6-1.8 8.2 .4c3.9 2.1 4.2 5.6 .9 10.6L456.9 322c.2 .5 .4 1 .4 1.5c.5 2.2 .3 4.4-.5 6.6c-.7 1.5-1.8 2.9-3.1 4.2c-1.4 1.4-2.7 2.8-4.2 4.2l-18.8 13.7c-1.7 1.2-3.4 2.3-5.1 3.3c-2.1 1.3-4.3 2.5-6.6 3.6c-1 .4-1.9 .9-2.9 1.3c-5.9 2.5-11.9 4.2-18.2 5c-2.9 24.5-11.3 47.1-25.1 67.8c-17.5 25.7-41.4 45.4-71.8 58.8c-30.2 13.5-63 20.2-98.2 20.2c-48.6-.5-88-11.4-118.2-32.8C49.5 454.4 32 421.5 32 380.3v-5.6c1.2-28.1 9.5-54.6 24.8-79.8c15.1-24.9 37.1-41.7 66.1-50.5c14.9-4.4 29.9-6.6 45-6.6c15.5 0 31.6 2.9 48.1 8.6s35.2 15.5 55.9 29.5L326 312.2c15.1 9.8 28.8 16.5 41.2 20c-2.6-25.1-11.7-46.6-27.3-64.5c-15.7-18.1-35.6-31.3-59.9-39.7l-23.3-8c-21.4-7.5-37.3-14.9-47.7-22.2c-28.2-19.1-43.8-45.2-47-78.5l-.5-9.8c0-32.1 13-58.9 39-80.5C223.5 9.7 251.1 0 283 0c24 0 45.6 6.9 64.7 20.8c19.2 14 30.1 33.8 32.6 59.4l.5 10c0 18.6-4.8 34.5-14.4 47.7c-9.8 13.2-18.5 19.9-26 19.9c-1.6-.1-3.1-.3-4.5-.6l-34 32c-5.5 3-9.2 2.5-11.1-1.6c-1.9-2.2-1.8-4.9 .5-8.2l.2-.2c.5-.7 1.2-1.5 2-2.4l31.6-30c-.4-1.5-.6-3.1-.6-4.8c0-4.1 1.6-7.6 4.9-10.4c13.8-12.4 20.8-26.7 20.8-42.8c0-16-6.1-29.5-18.2-40.4s-28.7-16.5-49.7-16.8c-26.2 0-47.8 7.9-64.7 23.7S192.3 89.9 192.3 112c0 17.8 6.9 33.9 20.6 48.3c13.6 14.2 34.6 25.4 63 33.5c39.8 11.5 70.2 31 91.3 58.3c18.7 24.2 29.1 51.3 31.3 81.4c2.2-.7 4.3-1.5 6.5-2.6zM294.1 178.7c0 1.1 .6 1.6 1.8 1.6c.1 0 9.7-8.9 28.8-26.6c0-2.4-5.1 .9-15.3 10c-10.2 9.2-15.3 14.2-15.3 14.9zm8 6.4c0-1-.5-1.5-1.5-1.5c-1.1 0-2.1 .5-2.9 1.6c-1.9-.1-3.3 .1-4.2 .7c-.4 .2-.5 .5-.5 .7c0 .7 .5 1.3 1.5 1.6h3.3c2.9-1.1 4.4-2.2 4.4-3.3zm22.6-19.9c0-2.8-1.6-2.8-4.9 0c-1.6 1.5-3.6 3.5-6 6.2c-.8 .6-2.6 2.2-5.3 4.9c-2.8 2.9-4.2 4.7-4.2 5.3l.2 1.3c.7 .2 1.2 .4 1.5 .4c.1 0 3.3-2.9 9.5-8.7s9.3-8.9 9.3-9.3zm159.7 120l-30.6 27c1.8 1 3.2 2.4 4 4.2l30.2-27c.2-1.2 .1-2.2-.5-2.9c-.6-.5-1.6-.9-3.1-1.3zm-1.6-.9l-.7-.7-27 21.9 1.6 2 26-23.1zM366.6 363.9c-8-2.1-15.4-4.6-22.2-7.5c-15.3-6.2-34.3-17-57-32.4L250 298.7c-15.8-10.1-30.2-17.6-43.2-22.6c-13.1-4.9-26-7.3-38.6-7.3h-5.5c-32.2 1.7-57.2 13.8-75 36.2c-16.6 20.8-25 45.3-25 73.6c0 31.8 12.8 56.7 38.2 74.7c25.4 18.1 60.2 27.1 104.4 27.1c34.7 0 64-6.2 87.8-18.6c23.7-12.4 42.1-28.8 55.2-49.2c9.8-15.5 15.9-31.8 18.2-48.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShirtsinbulk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaServicestack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSellsy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSellcast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchengin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 460 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScribd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScreenpal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M233.5 22.49C233.5 10.07 243.6 0 256 0C268.4 0 278.5 10.07 278.5 22.49C278.5 34.91 268.4 44.98 256 44.98C243.6 44.98 233.5 34.91 233.5 22.49zM313.4 259C313.4 290.7 287.7 316.4 256 316.4C224.3 316.4 198.6 290.7 198.6 259C198.6 227.3 224.3 201.6 256 201.6C287.7 201.6 313.4 227.3 313.4 259zM337.2 350C359.5 330.1 373.7 302.7 377.1 273H496.6C493.1 334.4 466.2 392.2 421.4 434.4C376.7 476.6 317.5 500.2 256 500.2C194.5 500.2 135.3 476.6 90.56 434.4C45.83 392.2 18.94 334.4 15.39 273H135.1C138.5 302.7 152.7 330.1 175 350C197.3 369.9 226.2 380.9 256.1 380.9C285.1 380.9 314.8 369.9 337.2 350zM73.14 140.3C73.54 152.7 63.81 163.1 51.39 163.5C38.97 163.9 28.59 154.2 28.18 141.8C27.78 129.3 37.52 118.9 49.94 118.5C62.35 118.1 72.74 127.9 73.14 140.3zM438.9 141C438.9 128.6 448.9 118.5 461.4 118.5C473.8 118.5 483.8 128.6 483.8 141C483.8 153.5 473.8 163.5 461.4 163.5C448.9 163.5 438.9 153.5 438.9 141zM317.9 95.27C300.6 109.1 278.7 118.1 256 118.1C233.3 118.1 211.4 109.1 194.1 95.27C176.8 80.55 165.3 60.18 161.7 37.78C176.8 31.37 192.5 26.52 208.6 23.31C208.6 35.88 213.6 47.93 222.5 56.82C231.4 65.7 243.4 70.7 256 70.7C268.6 70.7 280.6 65.7 289.5 56.82C298.4 47.93 303.4 35.88 303.4 23.31C319.5 26.52 335.2 31.37 350.3 37.78C346.7 60.18 335.2 80.55 317.9 95.27H317.9zM82.78 231C61.42 238.6 38.06 238.4 16.86 230.4C18.82 214.1 22.46 198.1 27.71 182.5C33.1 185.6 39.05 187.6 45.22 188.5C51.39 189.3 57.67 188.9 63.68 187.3C69.69 185.6 75.33 182.9 80.27 179.1C85.21 175.3 89.36 170.6 92.47 165.2C95.58 159.8 97.61 153.8 98.42 147.7C99.23 141.5 98.83 135.2 97.22 129.2C95.61 123.2 92.83 117.6 89.04 112.6C85.25 107.7 80.53 103.5 75.14 100.4C85.96 88.11 98.01 76.94 111.1 67.07C128.7 81.42 140.6 101.6 144.7 123.9C148.8 146.2 144.8 169.3 133.5 188.9C122.1 208.5 104.1 223.4 82.78 231V231zM429.2 231.1C407.9 223.5 389.9 208.5 378.5 188.9C367.2 169.3 363.3 146.2 367.4 123.9C371.5 101.7 383.4 81.54 400.9 67.19C414 77.04 426.1 88.21 436.9 100.5C426.2 106.9 418.5 117.2 415.4 129.3C412.2 141.3 413.1 154.1 420.2 164.9C426.4 175.7 436.6 183.6 448.6 186.9C460.6 190.2 473.5 188.6 484.3 182.6C489.6 198.1 493.2 214.2 495.2 230.4C473.1 238.5 450.6 238.7 429.2 231.1L429.2 231.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchlix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSalesforce(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSafari(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRust(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRockrms(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRocketchat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRev(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaResolving(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaResearchgate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReplyd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRenren(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedhat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReddit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256L37.1 512c-13.7 0-20.5-16.5-10.9-26.2L75 437C28.7 390.7 0 326.7 0 256zM349.6 153.6c23.6 0 42.7-19.1 42.7-42.7s-19.1-42.7-42.7-42.7c-20.6 0-37.8 14.6-41.8 34c-34.5 3.7-61.4 33-61.4 68.4l0 .2c-37.5 1.6-71.8 12.3-99 29.1c-10.1-7.8-22.8-12.5-36.5-12.5c-33 0-59.8 26.8-59.8 59.8c0 24 14.1 44.6 34.4 54.1c2 69.4 77.6 125.2 170.6 125.2s168.7-55.9 170.6-125.3c20.2-9.6 34.1-30.2 34.1-54c0-33-26.8-59.8-59.8-59.8c-13.7 0-26.3 4.6-36.4 12.4c-27.4-17-62.1-27.7-100-29.1l0-.2c0-25.4 18.9-46.5 43.4-49.9l0 0c4.4 18.8 21.3 32.8 41.5 32.8zM177.1 246.9c16.7 0 29.5 17.6 28.5 39.3s-13.5 29.6-30.3 29.6s-31.4-8.8-30.4-30.5s15.4-38.3 32.1-38.3zm190.1 38.3c1 21.7-13.7 30.5-30.4 30.5s-29.3-7.9-30.3-29.6c-1-21.7 11.8-39.3 28.5-39.3s31.2 16.6 32.1 38.3zm-48.1 56.7c-10.3 24.6-34.6 41.9-63 41.9s-52.7-17.3-63-41.9c-1.2-2.9 .8-6.2 3.9-6.5c18.4-1.9 38.3-2.9 59.1-2.9s40.7 1 59.1 2.9c3.1 .3 5.1 3.6 3.9 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedditAlien(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M373 138.6c-25.2 0-46.3-17.5-51.9-41l0 0c-30.6 4.3-54.2 30.7-54.2 62.4l0 .2c47.4 1.8 90.6 15.1 124.9 36.3c12.6-9.7 28.4-15.5 45.5-15.5c41.3 0 74.7 33.4 74.7 74.7c0 29.8-17.4 55.5-42.7 67.5c-2.4 86.8-97 156.6-213.2 156.6S45.5 410.1 43 323.4C17.6 311.5 0 285.7 0 255.7c0-41.3 33.4-74.7 74.7-74.7c17.2 0 33 5.8 45.7 15.6c34-21.1 76.8-34.4 123.7-36.4l0-.3c0-44.3 33.7-80.9 76.8-85.5C325.8 50.2 347.2 32 373 32c29.4 0 53.3 23.9 53.3 53.3s-23.9 53.3-53.3 53.3zM157.5 255.3c-20.9 0-38.9 20.8-40.2 47.9s17.1 38.1 38 38.1s36.6-9.8 37.8-36.9s-14.7-49.1-35.7-49.1zM395 303.1c-1.2-27.1-19.2-47.9-40.2-47.9s-36.9 22-35.7 49.1c1.2 27.1 16.9 36.9 37.8 36.9s39.3-11 38-38.1zm-60.1 70.8c1.5-3.6-1-7.7-4.9-8.1c-23-2.3-47.9-3.6-73.8-3.6s-50.8 1.3-73.8 3.6c-3.9 .4-6.4 4.5-4.9 8.1c12.9 30.8 43.3 52.4 78.7 52.4s65.8-21.6 78.7-52.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedRiver(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRebel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReadme(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReacteurope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReact(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRavelry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRaspberryPi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 407 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRProject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 581 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuora(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuinscape(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQq(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPython(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPushed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 432 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaProductHunt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaystation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPixiv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm171.5 84c41 0 76.3 12.9 101.4 35.2l0 0c25.2 22.2 39.8 54.1 39.8 88.8c.1 35.3-16.6 66.3-42.4 87c-25.9 20.8-60.6 32.4-98.8 32.4c-43.5 0-83.8-16.1-83.8-16.1v51.8c7.4 2.2 19.7 7 11.9 14.8H104.8c-7.7-7.8 3.6-12.4 12.1-14.8V175.5C97.1 190.9 87 204.3 81.8 214.2c6 19.4-5.3 18.5-5.3 18.5L56 199.7s72.7-83.7 179.5-83.7zm-3.6 222.9c30 0 56-11.3 73.9-29.2c17.9-18.1 27.9-41.6 28-70.2c-.1-29.3-9.5-54.6-26.7-73.6c-17.2-18.9-42.7-31.3-75.2-31.4c-26.7-.1-59.8 9-80.2 23.7V323.1c18.6 9.3 46.8 15.9 80.2 15.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPinterest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPinterestP(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperPp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperHat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoenixSquadron(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoenixFramework(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhabricator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeriscope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPerbyte(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaypal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPatreon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.7 153.8c-.1-65.4-51-119-110.7-138.3C304.8-8.5 207-5 136.1 28.4C50.3 68.9 23.3 157.7 22.3 246.2C21.5 319 28.7 510.6 136.9 512c80.3 1 92.3-102.5 129.5-152.3c26.4-35.5 60.5-45.5 102.4-55.9c72-17.8 121.1-74.7 121-150z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPalfed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPagelines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPage4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPadlet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M297.9 0L298 .001C305.6 .1078 312.4 4.72 315.5 11.78L447.5 320.3L447.8 320.2L448 320.6L445.2 330.6L402.3 488.6C398.6 504.8 382.6 514.9 366.5 511.2L298.1 495.6L229.6 511.2C213.5 514.9 197.5 504.8 193.8 488.6L150.9 330.6L148.2 320.6L148.3 320.2L280.4 11.78C283.4 4.797 290.3 .1837 297.9 .0006L297.9 0zM160.1 322.1L291.1 361.2L298 483.7L305.9 362.2L436.5 322.9L436.7 322.8L305.7 347.9L297.1 27.72L291.9 347.9L160.1 322.1zM426 222.6L520.4 181.6H594.2L437.2 429.2L468.8 320.2L426 222.6zM597.5 181.4L638.9 257.6C642.9 265.1 635 273.5 627.3 269.8L579.7 247.1L597.5 181.4zM127.3 318.5L158.7 430L1.61 154.5C-4.292 144.1 7.128 132.5 17.55 138.3L169.4 222.5L127.3 318.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOsi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOrcid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOptinMonster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOpera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOpensuse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.1 102.7s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3c-51.9-1.8-122.8-4.3-223 57.3c-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.1 307 7 335.1c3.3 12.8 8.9 24.9 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4c44.4 3.9 78.1-16 90-53.3c8.2-25.8 0-63.6-31.5-82.9c-25.6-15.7-53.3-12.1-69.2-1.6c-13.9 9.2-21.8 23.5-21.6 39.2c.3 27.8 24.3 42.6 41.5 42.6c5.4 0 10.7-.9 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9c0-12.1-11.6-14.8-16.8-13.9c-2.9 .5-4.5 2-11.8 2.4c-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9c32.3 2.8 47.7 40.7 28.5 65.7C135 388.5 76.7 388 53.6 344.4c-26-49.2 12.7-111.2 87-98.4c33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3c56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8c5.6-33.8 39.7-18.4 82.4-17.4c66.5 .4 102.1-27 103.1-28c3.7-3.1 6.5-15.8 7-17.7c1.3-5.1-3.2-2.4-3.2-2.4c-8.7 5.2-30.5 15.2-50.9 15.6c-25.3 .5-76.2-25.4-81.6-28.2c-.3-.4 .1 1.2-11-25.5c88.4 58.3 118.3 40.5 145.2 21.7c.8-.6 4.3-2.9 3.6-5.7c-13.8-48.1-22.4-62.7-34.5-69.6c-37-21.6-125-34.7-129.2-35.3c.1-.1-.9-.3-.9 .7l0 0zm135.6 75.4a37.6 37.6 0 1 1 -75.2-2.6 37.6 37.6 0 1 1 75.2 2.6zm-36.6-27.9a26.3 26.3 0 1 0 -1.7 52.5 26.3 26.3 0 1 0 1.7-52.5zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.6 0 15.6v0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOpenid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOpencart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOldRepublic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOdysee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M406.7 463c-42.3 30.8-94.4 49-150.7 49C144.9 512 50.3 441.2 14.9 342.2c2.4 1.7 5.9 3.6 7.9 4.4c16.3 7.4 40.1-5.4 62.9-28.7c6.9-6.9 14.4-12.4 22.8-17.3c18.3-11.9 37.6-20.8 58.4-27.2c0 0 22.3 34.2 43.1 74.8s-22.3 54-27.2 54c-.3 0-.8 0-1.5-.1c-11-.5-70-3-56 51.1c14.9 57.4 97.5 36.6 139.6 8.9s31.7-118.3 31.7-118.3c41.1-6.4 54 37.1 57.9 59.4c.8 4.6 1.1 9.9 1.4 15.5c1.1 21.2 2.3 45.6 35.3 46.4c5.3 0 10.6-.8 15.5-2zm-95.3-23.7c-2-.5-3.5-2.5-3-5c1-2.5 3-3.5 5-3s3.5 3 3 5s-2.5 3.5-5 3zm-207-95.6c1.5-.5 3.5 1 4 3c0 2-1 4-3 4c-1.5 .5-3.5-1-4-3c-.5-1.5 1-3.5 3-4zM451.8 421C489.3 376.4 512 318.8 512 256c0-67.5-26.1-128.9-68.8-174.7c-.1 23.5-6.1 48.2-16.8 69.2c-11.9 20.3-49 58.9-69.8 78.7c-.7 .3-1.1 .9-1.5 1.4c-.2 .2-.3 .4-.5 .6c-5 6.9-4 16.8 3 21.8c21.3 15.8 56.4 45.6 59.4 72.8c3.5 34.9 27.9 75.6 34.2 86.2l0 0c.8 1.3 1.3 2.1 1.4 2.4c0 2.2-.4 4.3-.8 6.5zM390.7 251c-.5 3 1 5.9 4 6.4s5.9-1 6.4-4s-1-5.9-4-6.4c-3-1-5.9 1-6.4 4zm61.4-60.9l-11.4 5.4-3 12.9-5.4-11.4-12.9-3 11.4-5.4 3-12.9 5.4 11.4 12.9 3zM395.5 41.3c-16.2 8.2-22.1 32.8-29 61.4l0 0c-.3 1.4-.7 2.8-1 4.2c-9.5 38.5-30.6 37.6-41.7 37.2c-1.1 0-2-.1-2.9-.1c-5.1 0-6-4-8.9-17.1c-2.6-12.1-6.9-32-17.9-63.6C271.4-2.5 211.4 13.9 165.9 41.1C110.6 74.2 131.5 143 146.1 190.5c.7 2.2 1.4 4.4 2 6.6c-4 4-13.8 7.5-26 11.9c-12.1 4.3-26.6 9.5-40.3 16.9C47.9 243.9 11.5 274.9 2 288.5C.7 277.8 0 267 0 256C0 114.6 114.6 0 256 0c51.4 0 99.4 15.2 139.5 41.3zM58.9 189.6c-1.5-2-4.5-3-6.4-1.5s-3 4.5-1.5 6.4s4.5 3 6.4 1.5c2.5-1.5 3-4.5 1.5-6.4zM327.3 64.9c2-1.5 5-.5 6.4 1.5c1.5 2.5 1 5.4-1.5 6.4c-2 1.5-5 .5-6.4-1.5s-.5-5 1.5-6.4zM95.1 105c-.5 1.5 .5 3 2 3c1.5 .5 3-.5 3-2c.5-1.5-.5-3-2-3s-3 .5-3 2zm84.7-.5c-3.5-43.1 37.1-54 37.1-54c44.1-15.4 56 5.9 66.4 37.6s3 42.6-38.6 58.9s-61.9-4.5-64.9-42.6zm89.6 14.9h1c2.5 0 5-2 5-5c2-6.9 1-14.4-2-20.8c-1.5-2-4-3.5-6.4-2.5c-3 1-4.5 4-3.5 6.9c2 4.5 3 9.9 1.5 14.9c-.5 3 1.5 5.9 4.5 6.4zm-9.9-41.6c-2 0-4-1-5-3s-2-3.5-3-5c-2-2-2-5.4 0-7.4s5.4-2 7.4 0c2 2.5 3.5 5 5 7.4s.5 5.9-2.5 7.4c-.6 0-1 .2-1.3 .3c-.2 .1-.4 .2-.6 .2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOdnoklassniki(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOctopusDeploy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNutritionix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNs8(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNpm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNodeJs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNimblr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNfcSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.9 32.43C400.6 31.1 408.6 32.89 414.1 37.41C498.2 96.14 544 173.7 544 255.1C544 338.2 498.2 415.9 414.1 474.6C409.3 478.6 402.4 480.5 395.5 479.9C388.5 479.3 382 476.3 377.1 471.4L193.7 288.7C188.1 283.2 185 275.7 184.1 267.8C184.1 260 188.1 252.5 193.6 246.9C199.2 241.4 206.7 238.2 214.5 238.2C222.4 238.2 229.9 241.3 235.4 246.8L400.5 411.2C455.1 366.5 484.8 312 484.8 255.1C484.8 193.5 447.9 132.9 380.9 85.76C374.5 81.24 370.1 74.35 368.8 66.62C367.4 58.89 369.2 50.94 373.8 44.53C378.3 38.12 385.2 33.77 392.9 32.43V32.43zM186.9 479.6C179.2 480.9 171.3 479.1 164.8 474.6C81.67 415.9 35.84 338.2 35.84 255.1C35.84 173.7 81.67 96.14 164.8 37.41C170.5 33.4 177.4 31.53 184.4 32.12C191.3 32.71 197.8 35.72 202.7 40.63L386.1 223.3C391.7 228.8 394.8 236.3 394.8 244.2C394.9 251.1 391.8 259.5 386.2 265.1C380.7 270.6 373.2 273.8 365.3 273.8C357.5 273.8 349.1 270.7 344.4 265.2L179.3 100.7C124.7 145.9 95.03 199.9 95.03 255.1C95.03 318.5 131.9 379.1 198.1 426.2C205.4 430.8 209.7 437.6 211.1 445.4C212.4 453.1 210.6 461.1 206.1 467.5C201.6 473.9 194.7 478.2 186.9 479.6V479.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNfcDirectional(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M211.8 488.6C213.4 491.1 213.9 494.2 213.2 497.1C212.6 500 210.8 502.6 208.3 504.2C205.7 505.8 202.7 506.3 199.7 505.7C138.3 491.8 84.1 455.8 47.53 404.5C10.97 353.2-5.395 290.3 1.57 227.7C8.536 165 38.34 107.2 85.29 65.21C132.2 23.2 193-.0131 256 0C257.5 0 258.1 .2931 260.3 .8627C261.7 1.432 262.1 2.267 264 3.319C265.1 4.371 265.9 5.619 266.5 6.993C267 8.367 267.3 9.839 267.3 11.32V112.3L291.8 86.39C292.8 85.31 294 84.44 295.4 83.84C296.7 83.23 298.2 82.9 299.7 82.86C301.2 82.81 302.6 83.06 304 83.59C305.4 84.12 306.7 84.92 307.8 85.94C308.8 86.96 309.7 88.18 310.3 89.54C310.9 90.89 311.3 92.35 311.3 93.84C311.3 95.32 311.1 96.8 310.6 98.18C310 99.57 309.2 100.8 308.2 101.9L264.2 148.5C263.1 149.6 261.9 150.5 260.5 151.1C259 151.7 257.5 152 255.1 152C254.5 152 252.9 151.7 251.5 151.1C250.1 150.5 248.8 149.6 247.8 148.5L203.7 101.9C201.7 99.74 200.6 96.83 200.7 93.84C200.7 90.84 202 87.1 204.2 85.94C206.4 83.88 209.3 82.77 212.3 82.86C215.3 82.94 218.1 84.21 220.2 86.39L244.7 112.4V22.89C188.3 25.64 134.9 48.73 94.23 87.87C53.58 127 28.49 179.6 23.61 235.8C18.73 292 34.38 348.1 67.68 393.7C100.1 439.2 149.7 471.2 204.7 483.6C207.6 484.3 210.2 486.1 211.8 488.6L211.8 488.6zM171.4 126.1C170.6 127.4 169.5 128.5 168.3 129.3C147.8 143.2 131.1 161.9 119.5 183.8C107.9 205.7 101.8 230.1 101.8 254.9C101.8 279.7 107.9 304.1 119.5 325.1C131.1 347.9 147.8 366.6 168.3 380.5C170.8 382.2 172.5 384.8 173 387.8C173.6 390.7 172.1 393.8 171.3 396.2C169.6 398.7 166.1 400.4 164 400.1C161.1 401.5 158 400.9 155.6 399.2C132 383.2 112.8 361.7 99.46 336.5C86.15 311.4 79.19 283.4 79.19 254.9C79.19 226.5 86.15 198.4 99.46 173.3C112.8 148.1 132 126.6 155.6 110.6C156.8 109.8 158.2 109.2 159.6 108.8C161.1 108.5 162.6 108.5 164.1 108.8C165.5 109 166.9 109.6 168.2 110.4C169.5 111.2 170.5 112.3 171.4 113.5C172.2 114.7 172.8 116.1 173.1 117.6C173.4 119.1 173.4 120.6 173.1 122C172.8 123.5 172.3 124.9 171.4 126.1H171.4zM340.9 383.5C341.7 382.3 342.8 381.2 343.1 380.4V380.3C364.4 366.3 381.1 347.6 392.7 325.7C404.2 303.9 410.2 279.5 410.2 254.8C410.2 230.1 404.2 205.7 392.7 183.8C381.1 161.1 364.4 143.3 343.1 129.3C342.8 128.5 341.7 127.4 340.9 126.2C340.1 124.9 339.5 123.5 339.3 122.1C338.1 120.6 339 119.1 339.3 117.7C339.6 116.2 340.2 114.8 341 113.6C341.9 112.4 342.1 111.3 344.2 110.5C345.4 109.7 346.8 109.2 348.3 108.9C349.8 108.6 351.2 108.6 352.7 108.9C354.2 109.2 355.5 109.8 356.8 110.7C380.2 126.7 399.5 148.2 412.7 173.3C426 198.4 432.1 226.4 432.1 254.8C432.1 283.3 426 311.3 412.7 336.4C399.5 361.5 380.2 383 356.8 399C355.5 399.9 354.2 400.5 352.7 400.8C351.2 401.1 349.8 401.1 348.3 400.8C346.8 400.5 345.4 399.1 344.2 399.2C342.1 398.4 341.9 397.3 341 396.1C340.2 394.9 339.6 393.5 339.3 392C339 390.6 338.1 389.1 339.3 387.6C339.5 386.2 340.1 384.8 340.9 383.5V383.5zM312.3 6.307C368.5 19.04 418.7 50.28 455 95.01C485.4 132.6 504.6 178 510.3 226C515.9 274 507.9 322.7 487.1 366.3C466.2 409.9 433.5 446.8 392.6 472.6C351.7 498.3 304.4 512 256 512C254.5 512 253.1 511.7 251.7 511.1C250.3 510.6 249.1 509.7 248 508.7C246.1 507.6 246.1 506.4 245.6 505C245 503.6 244.7 502.2 244.7 500.7V401.5L220.2 427.5C218.1 429.7 215.3 430.1 212.3 431.1C209.3 431.2 206.4 430 204.2 427.1C202 425.9 200.7 423.1 200.7 420.1C200.6 417.1 201.7 414.2 203.7 412L247.8 365.4C249.1 363.2 252.9 362 255.1 362C259.1 362 262 363.2 264.2 365.4L308.2 412C310.3 414.2 311.4 417.1 311.3 420.1C311.2 423.1 309.9 425.9 307.8 427.1C305.6 430 302.7 431.2 299.7 431.1C296.7 430.1 293.8 429.7 291.8 427.5L267.3 401.6V489.1C323.7 486.3 377.1 463.3 417.8 424.1C458.5 384.1 483.6 332.4 488.5 276.2C493.3 219.1 477.7 163.9 444.4 118.3C411.1 72.75 362.4 40.79 307.4 28.36C305.9 28.03 304.6 27.42 303.3 26.57C302.1 25.71 301.1 24.63 300.3 23.37C299.5 22.12 298.1 20.72 298.7 19.26C298.5 17.8 298.5 16.3 298.8 14.85C299.2 13.41 299.8 12.04 300.6 10.82C301.5 9.61 302.6 8.577 303.8 7.784C305.1 6.99 306.5 6.451 307.9 6.198C309.4 5.945 310.9 5.982 312.3 6.307L312.3 6.307zM353.1 256.1C353.1 287.5 335.6 317.2 303.8 339.6C301.7 341.1 299 341.9 296.4 341.6C293.7 341.4 291.2 340.3 289.4 338.4L219.3 268.6C217.1 266.5 215.1 263.6 215.9 260.6C215.9 257.6 217.1 254.7 219.2 252.6C221.4 250.5 224.2 249.3 227.2 249.3C230.2 249.3 233.1 250.5 235.2 252.6L298.3 315.4C319.1 298.3 330.5 277.5 330.5 256.1C330.5 232.2 316.4 209.1 290.8 191C288.3 189.3 286.7 186.7 286.2 183.7C285.7 180.8 286.3 177.7 288.1 175.3C289.8 172.8 292.4 171.2 295.4 170.7C298.3 170.2 301.4 170.8 303.8 172.6C335.6 195 353.1 224.7 353.1 256.1V256.1zM216.7 341.5C213.7 342 210.7 341.3 208.2 339.6C176.5 317.2 158.1 287.5 158.1 256.1C158.1 224.7 176.5 195 208.2 172.6C210.4 171 213.1 170.3 215.7 170.5C218.4 170.8 220.8 171.9 222.7 173.8L292.8 243.6C294.9 245.7 296.1 248.6 296.1 251.6C296.1 254.6 294.1 257.4 292.8 259.6C290.7 261.7 287.8 262.9 284.9 262.9C281.9 262.9 278.1 261.7 276.9 259.6L213.8 196.7C192.9 214 181.6 234.7 181.6 256.1C181.6 279.1 195.7 303.1 221.3 321.1C223.7 322.9 225.4 325.5 225.9 328.5C226.4 331.4 225.7 334.4 224 336.9C222.3 339.3 219.6 341 216.7 341.5L216.7 341.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNeos(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNapster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMonero(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaModx(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMizuni(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMixer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMixcloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.98 346.566H179.789V195.114L185.973 173.47H175.262L137.127 346.566H76.1069L37.7323 173.47H27.276L33.1913 195.114V346.566H0V165H65.6506L102.248 338.096H110.747L147.329 165H212.98L212.98 346.566ZM544.459 283.589L458.434 345.655V307.534L531.329 255.776L458.434 204.017V165.896L544.459 228.231H553.721L640 165.896V204.017L566.866 255.776L640 307.549V345.655L553.721 283.589H544.459ZM430.157 272.311H248.113V239.255H430.157V272.311Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMintbit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M73.2 512V438.9H365.7V365.7h73.2V219.4H512V0H292.6V73.1H146.3v73.2H73.2V438.9H0V512H73.2zm73.1-219.4h73.2v73.1H146.3V292.6zm73.2-73.1h73.1v73.1H219.4V219.4zm73.1 0V146.3h73.2v73.1H292.6zM365.7 73.1h73.2v73.2H365.7V73.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrosoft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicroblog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMeta(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 317.9C640 409.2 600.6 466.4 529.7 466.4C467.1 466.4 433.9 431.8 372.8 329.8L341.4 277.2C333.1 264.7 326.9 253 320.2 242.2C300.1 276 273.1 325.2 273.1 325.2C206.1 441.8 168.5 466.4 116.2 466.4C43.42 466.4 0 409.1 0 320.5C0 177.5 79.78 42.4 183.9 42.4C234.1 42.4 277.7 67.08 328.7 131.9C365.8 81.8 406.8 42.4 459.3 42.4C558.4 42.4 640 168.1 640 317.9H640zM287.4 192.2C244.5 130.1 216.5 111.7 183 111.7C121.1 111.7 69.22 217.8 69.22 321.7C69.22 370.2 87.7 397.4 118.8 397.4C149 397.4 167.8 378.4 222 293.6C222 293.6 246.7 254.5 287.4 192.2V192.2zM531.2 397.4C563.4 397.4 578.1 369.9 578.1 322.5C578.1 198.3 523.8 97.08 454.9 97.08C421.7 97.08 393.8 123 360 175.1C369.4 188.9 379.1 204.1 389.3 220.5L426.8 282.9C485.5 377 500.3 397.4 531.2 397.4L531.2 397.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMendeley(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMegaport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMeetup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedrt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedium(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedapps(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMdb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMaxcdn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMastodon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarkdown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMandalorian(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMailchimp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagento(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLyft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinux(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M366.036,186.867l-59.5,36.871-.838,36.871-29.329-19.273-39.384,24.3c2.238,55.211,2.483,59.271,2.51,59.5l-97.2,65.359L127.214,285.748l108.1-62.01L195.09,197.761l-75.417,38.547L98.723,93.015,227.771,43.574,136.432,0,10.737,39.385,38.39,174.3l41.9,32.681L48.445,222.062,69.394,323.457,98.723,351.11,77.774,363.679l16.76,78.769L160.733,512c-10.8-74.842-11.658-78.641-11.725-78.773l77.925-55.3c16.759-12.57,15.083-10.894,15.083-10.894l.838,24.3,33.519,28.491-.838-77.093,46.927-33.519,26.815-18.435-2.514,36.033,25.139,17.6,6.7-74.579,58.657-43.575Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinkedin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinkedinIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311 196.8v81.3c0 2.1-1.6 3.7-3.7 3.7h-13c-1.3 0-2.4-.7-3-1.5l-37.3-50.3v48.2c0 2.1-1.6 3.7-3.7 3.7h-13c-2.1 0-3.7-1.6-3.7-3.7V196.9c0-2.1 1.6-3.7 3.7-3.7h12.9c1.1 0 2.4 .6 3 1.6l37.3 50.3V196.9c0-2.1 1.6-3.7 3.7-3.7h13c2.1-.1 3.8 1.6 3.8 3.5zm-93.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 2.1 1.6 3.7 3.7 3.7h13c2.1 0 3.7-1.6 3.7-3.7V196.8c0-1.9-1.6-3.7-3.7-3.7zm-31.4 68.1H150.3V196.8c0-2.1-1.6-3.7-3.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 1 .3 1.8 1 2.5c.7 .6 1.5 1 2.5 1h52.2c2.1 0 3.7-1.6 3.7-3.7v-13c0-1.9-1.6-3.7-3.5-3.7zm193.7-68.1H327.3c-1.9 0-3.7 1.6-3.7 3.7v81.3c0 1.9 1.6 3.7 3.7 3.7h52.2c2.1 0 3.7-1.6 3.7-3.7V265c0-2.1-1.6-3.7-3.7-3.7H344V247.7h35.5c2.1 0 3.7-1.6 3.7-3.7V230.9c0-2.1-1.6-3.7-3.7-3.7H344V213.5h35.5c2.1 0 3.7-1.6 3.7-3.7v-13c-.1-1.9-1.7-3.7-3.7-3.7zM512 93.4V419.4c-.1 51.2-42.1 92.7-93.4 92.6H92.6C41.4 511.9-.1 469.8 0 418.6V92.6C.1 41.4 42.2-.1 93.4 0H419.4c51.2 .1 92.7 42.1 92.6 93.4zM441.6 233.5c0-83.4-83.7-151.3-186.4-151.3s-186.4 67.9-186.4 151.3c0 74.7 66.3 137.4 155.9 149.3c21.8 4.7 19.3 12.7 14.4 42.1c-.8 4.7-3.8 18.4 16.1 10.1s107.3-63.2 146.5-108.2c27-29.7 39.9-59.8 39.9-93.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLetterboxd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M521.3 128C586.9 128 640 181.1 640 246.6s-53.1 118.6-118.7 118.6c-42.5 0-79.7-22.3-100.7-55.8c11.4-18.2 18-39.7 18-62.8s-6.6-44.6-18-62.8l0 0 .8-1.2c20.8-32.3 56.8-53.9 97.9-54.6l2 0zM320 128c42.5 0 79.7 22.3 100.7 55.8c-11.4 18.2-18 39.7-18 62.8s6.6 44.6 18 62.8l0 0-.8 1.2c-20.8 32.3-56.8 53.9-97.9 54.6l-2 0c-42.5 0-79.7-22.3-100.7-55.8c11.4-18.2 18-39.7 18-62.8s-6.6-44.6-18-62.8l0 0 .8-1.2c20.8-32.3 56.8-53.9 97.9-54.6l2 0zm-201.3 0c42.5 0 79.7 22.3 100.7 55.8c-11.4 18.2-18 39.7-18 62.8s6.6 44.6 18 62.8l0 0-.8 1.2c-20.8 32.3-56.8 53.9-97.9 54.6l-2 0C53.1 365.1 0 312.1 0 246.6S53.1 128 118.7 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLeanpub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLastfm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaravel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.2 0c2.5 0 4.7 .8 6.7 2l94.3 54.1c2.7 1.5 4.5 3.5 5.4 5.9c.9 2.2 .9 4.3 .9 5.6l0 193.4 69.2-39.7 0-100.3c0-2.6 .6-5 2.2-7.2c1.5-2.1 3.5-3.6 5.7-4.8c0 0 0 0 0 0l94-54c1.6-.9 3.4-1.6 5.5-1.6s4 .7 5.6 1.6l95.8 55.1c2.3 1.3 3.9 3 4.9 5.3c.9 2.1 .9 4.2 .9 5.8l0 107.2c0 2-.2 4.3-1.4 6.4c-1.2 2.2-3 3.7-5.1 4.9l-.1 .1-88 50.5 0 100c0 2.3-.3 4.8-1.6 7c-1.3 2.2-3.3 3.7-5.3 4.9c0 0 0 0-.1 0L208.7 510c-2.2 1.2-4.5 2-7.1 2s-4.9-.9-7.1-2l-.1-.1L7.1 402l-.5-.3c-1.1-.7-2.6-1.7-3.8-2.9C.9 396.9 0 394.6 0 391.6L0 65.9c0-4.8 3-7.9 5.5-9.3L100.5 2c2-1.2 4.3-2 6.8-2zM38.1 67.1l69 39.9 69.2-39.9L107.1 27.4l-69 39.7zm353 93.2l69-39.7-69-39.7-69.1 39.7 69.1 39.7zM189.2 89L120 128.8l0 186.4 69.2-39.9 0-186.4zM94.5 128.9L25.2 89.1l0 294.2 164 94.2 0-79.4-87.3-49.3-.2-.1c-1.3-.8-3.2-1.9-4.6-3.7c-1.7-2.1-2.5-4.7-2.5-7.7l0-208.5zm214.7 92.4l69.3 39.6 0-78.5-69.3-39.9 0 78.8zm94.5 39.6L473 221.2l0-78.8-69.3 39.9 0 78.5zM201.6 376.1l163.8-93.2-69-39.9L133 337.1l68.6 38.9zm12.9 101.5l164-94.2 0-78.8-164 93.6 0 79.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKorvue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 446 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKickstarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM320.8 233l-23.3 23.1L320.8 279c24.1 23.9 24.1 63 0 86.9s-63.4 23.9-87.6 0l-8.5-8.4c-11.3 16-29.7 26.5-50.9 26.5c-34.1 0-61.9-27.5-61.9-61.4l0-133.2c0-33.8 27.7-61.4 61.9-61.4c21.1 0 39.6 10.5 50.9 26.5l8.5-8.4c24.1-23.9 63.4-23.9 87.6 0s24.1 63 0 86.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKickstarterK(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356.6 256.2l40.8-40.5c42.2-41.9 42.2-110.3 0-152.1s-111-41.9-153.2 0L229.3 78.4C209.6 50.3 177.1 32 140.2 32C80.5 32 32 80.2 32 139.5V372.5C32 431.9 80.5 480 140.2 480c37.1 0 69.3-18.3 89-46.4l14.9 14.7c42.2 41.9 111 41.9 153.2 0s42.2-110.3 0-152.1l-40.8-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKeycdn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKeybase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKaggle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJxl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M412.2 32H35.8C16 32 0 48 0 67.8V444.2C0 464 16 480 35.8 480H412.2c19.8 0 35.8-16 35.8-35.8V67.8C448 48 432 32 412.2 32zM378.6 333.7c0 40.2-32.6 72.8-72.8 72.8H70.2c0-40.2 32.6-72.8 72.8-72.8H378.6zm0-113.9c0 40.2-32.6 72.8-72.8 72.8H70.2c0-40.2 32.6-72.8 72.8-72.8H378.6zm0-113.9c0 40.2-32.6 72.8-72.8 72.8H70.2c0-40.2 32.6-72.8 72.8-72.8H378.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJsfiddle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJoomla(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJoget(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJira(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJenkins(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJediOrder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJava(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItunes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItunesNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItchIo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIoxhost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInvision(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInternetExplorer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIntercom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInstalod(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInstagram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaImdb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M89.5 323.6H53.93V186.2H89.5V323.6zM156.1 250.5L165.2 186.2H211.5V323.6H180.5V230.9L167.1 323.6H145.8L132.8 232.9L132.7 323.6H101.5V186.2H147.6C148.1 194.5 150.4 204.3 151.9 215.6L156.1 250.5zM223.7 323.6V186.2H250.3C267.3 186.2 277.3 187.1 283.3 188.6C289.4 190.3 294 192.8 297.2 196.5C300.3 199.8 302.3 203.1 303 208.5C303.9 212.9 304.4 221.6 304.4 234.7V282.9C304.4 295.2 303.7 303.4 302.5 307.6C301.4 311.7 299.4 315 296.5 317.3C293.7 319.7 290.1 321.4 285.8 322.3C281.6 323.1 275.2 323.6 266.7 323.6H223.7zM259.2 209.7V299.1C264.3 299.1 267.5 298.1 268.6 296.8C269.7 294.8 270.4 289.2 270.4 280.1V226.8C270.4 220.6 270.3 216.6 269.7 214.8C269.4 213 268.5 211.8 267.1 210.1C265.7 210.1 263 209.7 259.2 209.7V209.7zM316.5 323.6V186.2H350.6V230.1C353.5 227.7 356.7 225.2 360.1 223.5C363.7 222 368.9 221.1 372.9 221.1C377.7 221.1 381.8 221.9 385.2 223.3C388.6 224.8 391.2 226.8 393.2 229.5C394.9 232.1 395.9 234.8 396.3 237.3C396.7 239.9 396.1 245.3 396.1 253.5V292.1C396.1 300.3 396.3 306.4 395.3 310.5C394.2 314.5 391.5 318.1 387.5 320.1C383.4 324 378.6 325.4 372.9 325.4C368.9 325.4 363.7 324.5 360.2 322.9C356.7 321.1 353.5 318.4 350.6 314.9L348.5 323.6L316.5 323.6zM361.6 302.9C362.3 301.1 362.6 296.9 362.6 290.4V255C362.6 249.4 362.3 245.5 361.5 243.8C360.8 241.9 357.8 241.1 355.7 241.1C353.7 241.1 352.3 241.9 351.6 243.4C351 244.9 350.6 248.8 350.6 255V291.4C350.6 297.5 351 301.4 351.8 303C352.4 304.7 353.9 305.5 355.9 305.5C358.1 305.5 360.1 304.7 361.6 302.9L361.6 302.9zM418.4 32.04C434.1 33.27 447.1 47.28 447.1 63.92V448.1C447.1 464.5 435.2 478.5 418.9 479.1C418.6 479.1 418.4 480 418.1 480H29.88C29.6 480 29.32 479.1 29.04 479.9C13.31 478.5 1.093 466.1 0 449.7L.0186 61.78C1.081 45.88 13.82 33.09 30.26 31.1H417.7C417.9 31.1 418.2 32.01 418.4 32.04L418.4 32.04zM30.27 41.26C19 42.01 10.02 51.01 9.257 62.4V449.7C9.63 455.1 11.91 460.2 15.7 464C19.48 467.9 24.51 470.3 29.89 470.7H418.1C429.6 469.7 438.7 459.1 438.7 448.1V63.91C438.7 58.17 436.6 52.65 432.7 48.45C428.8 44.24 423.4 41.67 417.7 41.26L30.27 41.26z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdeal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHubspot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHtml5(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouzz(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotjar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M361.5 0c0 131.6-80.7 176.8-140.2 209.4c-.6 .3-1.1 .6-1.6 .9c-53.8 30.2-88.7 49.8-89.6 122H32C32 200.8 112.7 155.6 172.2 123C227 93.2 262.5 73 262.5 0h98.9zM301 302.6c54.8-29.8 90.3-50 90.3-123h98c0 131.6-80.7 176.7-140.2 209.4c-54.8 29.8-90.3 50-90.3 123h-98c0-131.6 80.7-176.8 140.2-209.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHornbill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHooli(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHireAHelper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHips(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHashnode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M35.19 171.1C-11.72 217.1-11.72 294 35.19 340.9L171.1 476.8C217.1 523.7 294 523.7 340.9 476.8L476.8 340.9C523.7 294 523.7 217.1 476.8 171.1L340.9 35.19C294-11.72 217.1-11.72 171.1 35.19L35.19 171.1zM315.5 315.5C282.6 348.3 229.4 348.3 196.6 315.5C163.7 282.6 163.7 229.4 196.6 196.6C229.4 163.7 282.6 163.7 315.5 196.6C348.3 229.4 348.3 282.6 315.5 315.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHackerrank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHackerNews(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGulp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGuilded(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrunt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripfire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrav(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGratipay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoogle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 488 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoogleWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoogleScholar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M390.9 298.5c0 0 0 .1 .1 .1c9.2 19.4 14.4 41.1 14.4 64C405.3 445.1 338.5 512 256 512s-149.3-66.9-149.3-149.3c0-22.9 5.2-44.6 14.4-64h0c1.7-3.6 3.6-7.2 5.6-10.7c4.4-7.6 9.4-14.7 15-21.3c27.4-32.6 68.5-53.3 114.4-53.3c33.6 0 64.6 11.1 89.6 29.9c9.1 6.9 17.4 14.7 24.8 23.5c5.6 6.6 10.6 13.8 15 21.3c2 3.4 3.8 7 5.5 10.5zm26.4-18.8c-30.1-58.4-91-98.4-161.3-98.4s-131.2 40-161.3 98.4L0 202.7 256 0 512 202.7l-94.7 77.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlusG(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoogleDrive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoodreads(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoodreadsG(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGolang(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400.1 194.8C389.2 197.6 380.2 199.1 371 202.4C363.7 204.3 356.3 206.3 347.8 208.5L347.2 208.6C343 209.8 342.6 209.9 338.7 205.4C334 200.1 330.6 196.7 324.1 193.5C304.4 183.9 285.4 186.7 267.7 198.2C246.5 211.9 235.6 232.2 235.9 257.4C236.2 282.4 253.3 302.9 277.1 306.3C299.1 309.1 316.9 301.7 330.9 285.8C333 283.2 334.9 280.5 337 277.5V277.5L337 277.5C337.8 276.5 338.5 275.4 339.3 274.2H279.2C272.7 274.2 271.1 270.2 273.3 264.9C277.3 255.2 284.8 239 289.2 230.9C290.1 229.1 292.3 225.1 296.1 225.1H397.2C401.7 211.7 409 198.2 418.8 185.4C441.5 155.5 468.1 139.9 506 133.4C537.8 127.8 567.7 130.9 594.9 149.3C619.5 166.1 634.7 188.9 638.8 218.8C644.1 260.9 631.9 295.1 602.1 324.4C582.4 345.3 557.2 358.4 528.2 364.3C522.6 365.3 517.1 365.8 511.7 366.3C508.8 366.5 506 366.8 503.2 367.1C474.9 366.5 449 358.4 427.2 339.7C411.9 326.4 401.3 310.1 396.1 291.2C392.4 298.5 388.1 305.6 382.1 312.3C360.5 341.9 331.2 360.3 294.2 365.2C263.6 369.3 235.3 363.4 210.3 344.7C187.3 327.2 174.2 304.2 170.8 275.5C166.7 241.5 176.7 210.1 197.2 184.2C219.4 155.2 248.7 136.8 284.5 130.3C313.8 124.1 341.8 128.4 367.1 145.6C383.6 156.5 395.4 171.4 403.2 189.5C405.1 192.3 403.8 193.9 400.1 194.8zM48.3 200.4C47.05 200.4 46.74 199.8 47.36 198.8L53.91 190.4C54.53 189.5 56.09 188.9 57.34 188.9H168.6C169.8 188.9 170.1 189.8 169.5 190.7L164.2 198.8C163.6 199.8 162 200.7 161.1 200.7L48.3 200.4zM1.246 229.1C0 229.1-.3116 228.4 .3116 227.5L6.855 219.1C7.479 218.2 9.037 217.5 10.28 217.5H152.4C153.6 217.5 154.2 218.5 153.9 219.4L151.4 226.9C151.1 228.1 149.9 228.8 148.6 228.8L1.246 229.1zM75.72 255.9C75.1 256.8 75.41 257.7 76.65 257.7L144.6 258C145.5 258 146.8 257.1 146.8 255.9L147.4 248.4C147.4 247.1 146.8 246.2 145.5 246.2H83.2C81.95 246.2 80.71 247.1 80.08 248.1L75.72 255.9zM577.2 237.9C577 235.3 576.9 233.1 576.5 230.9C570.9 200.1 542.5 182.6 512.9 189.5C483.9 196 465.2 214.4 458.4 243.7C452.8 268 464.6 292.6 487 302.6C504.2 310.1 521.3 309.2 537.8 300.7C562.4 287.1 575.8 268 577.4 241.2C577.3 240 577.3 238.9 577.2 237.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGofore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlideG(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitlab(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.5 204.6L502.8 202.8L433.1 21.02C431.7 17.45 429.2 14.43 425.9 12.38C423.5 10.83 420.8 9.865 417.9 9.57C415 9.275 412.2 9.653 409.5 10.68C406.8 11.7 404.4 13.34 402.4 15.46C400.5 17.58 399.1 20.13 398.3 22.9L351.3 166.9H160.8L113.7 22.9C112.9 20.13 111.5 17.59 109.6 15.47C107.6 13.35 105.2 11.72 102.5 10.7C99.86 9.675 96.98 9.295 94.12 9.587C91.26 9.878 88.51 10.83 86.08 12.38C82.84 14.43 80.33 17.45 78.92 21.02L9.267 202.8L8.543 204.6C-1.484 230.8-2.72 259.6 5.023 286.6C12.77 313.5 29.07 337.3 51.47 354.2L51.74 354.4L52.33 354.8L158.3 434.3L210.9 474L242.9 498.2C246.6 500.1 251.2 502.5 255.9 502.5C260.6 502.5 265.2 500.1 268.9 498.2L300.9 474L353.5 434.3L460.2 354.4L460.5 354.1C482.9 337.2 499.2 313.5 506.1 286.6C514.7 259.6 513.5 230.8 503.5 204.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitkraken(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 592 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGithub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGithubAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGgCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGetPocket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGalacticSenate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGalacticRepublic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFulcrum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFreebsd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFreeCodeCamp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFoursquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 368 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaForumbee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFortAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFortAwesomeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFonticons(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFonticonsFi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFontAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.7 96C106.3 86.8 116 70.5 116 52C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 3 0 352 0 64 64 0 0-64 373.6 0c14.6 0 26.4-11.8 26.4-26.4c0-3.7-.8-7.3-2.3-10.7L432 272l61.7-138.9c1.5-3.4 2.3-7 2.3-10.7c0-14.6-11.8-26.4-26.4-26.4L91.7 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFly(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlutter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.5 236.3L291.7 374.1 429.5 512H272l-59.1-59.1-78.8-78.8L272 236.3H429.5zM272 0L16 256l78.8 78.8L429.5 0H272z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlickr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstdraft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstOrder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstOrderAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirefox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirefoxBrowser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M130.22 127.548C130.38 127.558 130.3 127.558 130.22 127.548V127.548ZM481.64 172.898C471.03 147.398 449.56 119.898 432.7 111.168C446.42 138.058 454.37 165.048 457.4 185.168C457.405 185.306 457.422 185.443 457.45 185.578C429.87 116.828 383.098 89.1089 344.9 28.7479C329.908 5.05792 333.976 3.51792 331.82 4.08792L331.7 4.15792C284.99 30.1109 256.365 82.5289 249.12 126.898C232.503 127.771 216.219 131.895 201.19 139.035C199.838 139.649 198.736 140.706 198.066 142.031C197.396 143.356 197.199 144.87 197.506 146.323C197.7 147.162 198.068 147.951 198.586 148.639C199.103 149.327 199.76 149.899 200.512 150.318C201.264 150.737 202.096 150.993 202.954 151.071C203.811 151.148 204.676 151.045 205.491 150.768L206.011 150.558C221.511 143.255 238.408 139.393 255.541 139.238C318.369 138.669 352.698 183.262 363.161 201.528C350.161 192.378 326.811 183.338 304.341 187.248C392.081 231.108 368.541 381.784 246.951 376.448C187.487 373.838 149.881 325.467 146.421 285.648C146.421 285.648 157.671 243.698 227.041 243.698C234.541 243.698 255.971 222.778 256.371 216.698C256.281 214.698 213.836 197.822 197.281 181.518C188.434 172.805 184.229 168.611 180.511 165.458C178.499 163.75 176.392 162.158 174.201 160.688C168.638 141.231 168.399 120.638 173.51 101.058C148.45 112.468 128.96 130.508 114.8 146.428H114.68C105.01 134.178 105.68 93.7779 106.25 85.3479C106.13 84.8179 99.022 89.0159 98.1 89.6579C89.5342 95.7103 81.5528 102.55 74.26 110.088C57.969 126.688 30.128 160.242 18.76 211.318C14.224 231.701 12 255.739 12 263.618C12 398.318 121.21 507.508 255.92 507.508C376.56 507.508 478.939 420.281 496.35 304.888C507.922 228.192 481.64 173.82 481.64 172.898Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilesPinwheel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M253.2 246.4L136.9 130.2c-.6-.6-1-1.3-1.4-2s-.5-1.6-.5-2.4s.2-1.6 .5-2.4s.8-1.4 1.4-2L253.3 5.1c.9-.9 2-1.5 3.2-1.7s2.5-.1 3.6 .3s2.1 1.3 2.8 2.3s1.1 2.2 1.1 3.5L264 242c0 1.3-.3 2.5-1 3.6s-1.7 1.9-2.9 2.4s-2.5 .6-3.7 .3s-2.4-.9-3.2-1.9zm40.3-4.4l0-134.4c0-.8 .1-1.6 .5-2.4s.8-1.5 1.3-2.1s1.3-1.1 2-1.4s1.6-.5 2.4-.5l134.4 0c1.2 0 2.5 .4 3.5 1.1s1.8 1.7 2.3 2.8s.6 2.4 .3 3.6s-.9 2.3-1.7 3.2L304 246.4c-.9 .8-2 1.4-3.2 1.6s-2.4 .1-3.5-.4s-2.1-1.3-2.8-2.3s-1.1-2.2-1.1-3.4zm30.6 35c-1.2 0-2.5-.3-3.5-1s-1.9-1.6-2.4-2.8s-.6-2.4-.4-3.6s.8-2.3 1.7-3.2l84.2-84.2c.6-.6 1.3-1 2-1.4s1.6-.5 2.4-.5s1.6 .2 2.4 .5s1.4 .8 2 1.4l84.4 84.2c.9 .9 1.5 2 1.7 3.2s.1 2.5-.3 3.6s-1.3 2.1-2.3 2.8s-2.2 1.1-3.5 1.1l-168.5 0zM414.8 408l-95.3-95.2c-.9-.9-1.5-2-1.7-3.2s-.1-2.5 .4-3.7s1.3-2.1 2.4-2.8s2.3-1 3.5-1l95.2 0c1.7 0 3.2 .7 4.4 1.8s1.8 2.8 1.8 4.4l0 95.3c0 1.2-.4 2.5-1.1 3.5s-1.7 1.8-2.8 2.3s-2.4 .6-3.6 .3s-2.3-.9-3.2-1.7zM16.5 302.1l216.9 0c1.2 0 2.5 .4 3.5 1.1s1.8 1.7 2.3 2.8s.6 2.4 .3 3.6s-.8 2.3-1.7 3.2L129.4 421.2c-.6 .6-1.3 1-2 1.4s-1.6 .5-2.4 .5s-1.6-.2-2.4-.5s-1.4-.8-2-1.4L12 312.8c-.9-.9-1.5-2-1.7-3.2s-.1-2.5 .4-3.6s1.3-2.1 2.3-2.8s2.3-1 3.5-1zM264 465.3c0 .8-.2 1.6-.5 2.4s-.8 1.5-1.4 2s-1.3 1-2 1.4s-1.6 .5-2.4 .5l-128 0c-1.2 0-2.5-.4-3.5-1.1s-1.8-1.7-2.3-2.8s-.6-2.4-.3-3.6s.8-2.3 1.7-3.2l128-128c.9-.9 2-1.5 3.2-1.7s2.5-.1 3.6 .3s2.1 1.3 2.8 2.3s1.1 2.2 1.1 3.5l0 128zm40-132.5l82.8 82.7c.6 .6 1 1.3 1.4 2s.5 1.6 .5 2.4s-.2 1.6-.5 2.4s-.8 1.4-1.4 2L304 507c-.9 .9-2 1.5-3.2 1.7s-2.5 .1-3.6-.3s-2.1-1.3-2.8-2.3s-1.1-2.2-1.1-3.5l0-165.4c0-1.2 .4-2.5 1.1-3.5s1.7-1.8 2.8-2.3s2.4-.6 3.6-.3s2.3 .8 3.2 1.7zM78.7 122.4c0-1.2 .3-2.5 1-3.5s1.7-1.8 2.8-2.3s2.4-.6 3.6-.4s2.3 .8 3.2 1.7L237.8 266.4c.9 .9 1.5 2 1.7 3.2s.1 2.5-.3 3.6s-1.3 2.1-2.3 2.8s-2.2 1.1-3.5 1.1L85 277.1c-1.7 0-3.2-.7-4.4-1.8s-1.8-2.8-1.8-4.4l0-148.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFigma(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFedora(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.0413 255.8C.1219 132.2 100.3 32 224 32C347.7 32 448 132.3 448 256C448 379.7 347.8 479.9 224.1 480H50.93C22.84 480 .0832 457.3 .0416 429.2H0V255.8H.0413zM342.6 192.7C342.6 153 307 124.2 269.4 124.2C234.5 124.2 203.6 150.5 199.3 184.1C199.1 187.9 198.9 189.1 198.9 192.6C198.8 213.7 198.9 235.4 198.1 257C199 283.1 199.1 309.1 198.1 333.6C198.1 360.7 178.7 379.1 153.4 379.1C128.1 379.1 107.6 358.9 107.6 333.6C108.1 305.9 130.2 288.3 156.1 287.5H156.3L182.6 287.3V250L156.3 250.2C109.2 249.8 71.72 286.7 70.36 333.6C70.36 379.2 107.9 416.5 153.4 416.5C196.4 416.5 232.1 382.9 236 340.9L236.2 287.4L268.8 287.1C294.1 287.3 293.8 249.3 268.6 249.8L236.2 250.1C236.2 243.7 236.3 237.3 236.3 230.9C236.4 218.2 236.4 205.5 236.2 192.7C236.3 176.2 252 161.5 269.4 161.5C286.9 161.5 305.3 170.2 305.3 192.7C305.3 195.9 305.2 197.8 305 199C303.1 209.5 310.2 219.4 320.7 220.9C331.3 222.4 340.9 214.8 341.9 204.3C342.5 200.1 342.6 196.4 342.6 192.7H342.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFedex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFantasyFlightGames(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebookMessenger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebookF(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExpeditedssl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEvernote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEtsy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEthereum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaErlang(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvira(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEmpire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEmber(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEllo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaElementor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.361 256C.361 397 114 511 255 511C397 511 511 397 511 256C511 116 397 2.05 255 2.05C114 2.05 .361 116 .361 256zM192 150V363H149V150H192zM234 150H362V193H234V150zM362 235V278H234V235H362zM234 320H362V363H234V320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEdge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.1 37.44C161.1 12.23 207.7-.7753 255 .0016C423 .0016 512 123.8 512 219.5C511.9 252.2 499 283.4 476.1 306.7C453.2 329.9 422.1 343.2 389.4 343.7C314.2 343.7 297.9 320.6 297.9 311.7C297.9 307.9 299.1 305.5 302.7 302.3L303.7 301.1L304.1 299.5C314.6 288 320 273.3 320 257.9C320 179.2 237.8 115.2 136 115.2C98.46 114.9 61.46 124.1 28.48 142.1C55.48 84.58 111.2 44.5 119.8 38.28C120.6 37.73 120.1 37.44 120.1 37.44V37.44zM135.7 355.5C134.3 385.5 140.3 415.5 152.1 442.7C165.7 469.1 184.8 493.7 208.6 512C149.1 500.5 97.11 468.1 59.2 422.7C21.12 376.3 0 318.4 0 257.9C0 206.7 62.4 163.5 136 163.5C172.6 162.9 208.4 174.4 237.8 196.2L234.2 197.4C182.7 215 135.7 288.1 135.7 355.5V355.5zM469.8 400L469.1 400.1C457.3 418.9 443.2 435.2 426.9 449.6C396.1 477.6 358.8 495.1 318.1 499.5C299.5 499.8 281.3 496.3 264.3 488.1C238.7 477.8 217.2 458.1 202.7 435.1C188.3 411.2 181.6 383.4 183.7 355.5C183.1 335.4 189.1 315.2 198.7 297.3C212.6 330.4 236.2 358.6 266.3 378.1C296.4 397.6 331.8 407.6 367.7 406.7C398.7 407 429.8 400 457.9 386.2L459.8 385.3C463.7 383 467.5 381.4 471.4 385.3C475.9 390.2 473.2 394.5 470.2 399.3C470 399.5 469.9 399.8 469.8 400V400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEdgeLegacy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEbay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEarlybirds(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDyalog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrupal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M303.973,108.136C268.2,72.459,234.187,38.35,224.047,0c-9.957,38.35-44.25,72.459-80.019,108.136C90.467,161.7,29.716,222.356,29.716,313.436c-2.337,107.3,82.752,196.18,190.053,198.517S415.948,429.2,418.285,321.9q.091-4.231,0-8.464C418.285,222.356,357.534,161.7,303.973,108.136Zm-174.326,223a130.282,130.282,0,0,0-15.211,24.153,4.978,4.978,0,0,1-3.319,2.766h-1.659c-4.333,0-9.219-8.481-9.219-8.481h0c-1.29-2.028-2.489-4.149-3.687-6.361l-.83-1.752c-11.247-25.72-1.475-62.318-1.475-62.318h0a160.585,160.585,0,0,1,23.231-49.873A290.8,290.8,0,0,1,138.5,201.613l9.219,9.219,43.512,44.434a4.979,4.979,0,0,1,0,6.638L145.78,312.33h0Zm96.612,127.311a67.2,67.2,0,0,1-49.781-111.915c14.2-16.871,31.528-33.464,50.334-55.313,22.309,23.785,36.875,40.1,51.164,57.986a28.413,28.413,0,0,1,2.95,4.425,65.905,65.905,0,0,1,11.984,37.981,66.651,66.651,0,0,1-66.466,66.836ZM352.371,351.6h0a7.743,7.743,0,0,1-6.176,5.347H344.9a11.249,11.249,0,0,1-6.269-5.07h0a348.21,348.21,0,0,0-39.456-48.952L281.387,284.49,222.3,223.185a497.888,497.888,0,0,1-35.4-36.322,12.033,12.033,0,0,0-.922-1.382,35.4,35.4,0,0,1-4.7-9.219V174.51a31.346,31.346,0,0,1,9.218-27.656c11.432-11.431,22.955-22.954,33.833-34.939,11.984,13.275,24.8,26,37.428,38.627h0a530.991,530.991,0,0,1,69.6,79.1,147.494,147.494,0,0,1,27.011,83.8A134.109,134.109,0,0,1,352.371,351.6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDropbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 528 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDribbble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDraft2Digital(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDocker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDochub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiscourse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiscord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDigitalOcean(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDigg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiaspora(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDhl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeviantart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDev(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeskpro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeploydog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDelicious(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeezer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDebian(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.2 245.6c3-7.6 5.5-14 5.2-24.4l-4.3 9c4.4-13.2 4-27.1 3.6-40.4c-.2-6-.3-11.8 0-17.4l-1.8-.5c-1.5-45.2-40.6-93.1-75.3-109.4c-30-13.8-76.1-16.2-97.3-5.8c1.3-1.1 4.2-2 6.8-2.7l.3-.1c3.3-1 6-1.7 4-2.9c-19.2 1.9-24.9 5.5-31.1 9.4l-.1 0c-4.6 2.9-9.5 6-20.3 8.7c-3.5 3.4 1.7 2 5.8 .9l0 0c4.1-1.1 7.2-1.9-.1 2.4c-3.5 1-6.6 1.3-9.6 1.6l-.1 0c-8.3 .8-15.8 1.6-30.7 17c.8 1.3 3.4-.2 5.3-1.3l.1-.1c2.3-1.4 3.4-2-1.7 4.4c-19.1-2.4-60.3 43.7-69.1 59l4.6 .8c-3.2 8-6.8 14.8-10 20.8c-4.3 8.1-7.9 14.9-8.7 21.3c-.3 5.1-1 11-1.7 17.3l0 0c-.1 1-.2 2-.3 3l-.1 .6c-3 27.3-6.7 60.8 3.9 73l-1.3 13c.6 1.2 1.1 2.3 1.6 3.5c.2 .4 .4 .8 .5 1.1l0 0 0 0 0 0 0 0 0 0 0 0 0 0c1 2.1 2 4.2 3.3 6.2l-3 .2c7 22.1 10.8 22.5 15.1 22.9l0 0c4.4 .4 9.3 .9 18.7 24.2c-2.7-.9-5.5-1.9-9.4-7.2c-.5 4.1 5.8 16.3 13.1 25.8l-3.1 3.6c2.1 3.7 4.8 6.2 7.6 8.8l0 0 0 0c1 .9 2.1 1.9 3.1 2.9c-11.9-6.5 3.2 13.7 11.9 25.2c.8 1.1 1.5 2 2.2 2.9l0 0 0 0 0 0 0 0 0 0c1.4 1.9 2.5 3.4 2.9 4.1l2.4-4.2c-.3 6.1 4.3 13.9 13.1 24.7l7.3-.3c3 6 14 16.7 20.7 17.2l-4.4 5.8c8.1 2.6 10.3 4.3 12.7 6.2c2.6 2.1 5.4 4.3 16.1 8.1l-4.2-7.4c3.5 3 6.2 5.9 8.8 8.7l.1 .1c5.2 5.6 9.9 10.6 19.7 15.3c10.7 3.7 16.6 4.7 22.7 5.8c.3 0 .6 .1 .9 .1c5.4 .8 11.2 1.8 20.8 4.5c-1.1-.1-2.2-.1-3.3-.1h0c-2.3-.1-4.7-.1-7-.1l0 0 0 0 0 0 0 0 0 0 0 0 0 0c-14.4-.2-29.2-.4-42.7-5.2C107.8 480.5 19.5 367.2 26 250.6c-.6-9.9-.3-20.9 0-30.7c.4-13.5 .7-24.8-1.6-28.3l1-3.1c5.3-17.4 11.7-38.2 23.8-62.8l-.1-.2v-.1c.4 .4 3.4 3.4 8.8-5.8c.8-1.8 1.6-3.7 2.4-5.6c.5-1.1 .9-2.2 1.4-3.2c2.5-6.1 5.1-12.3 8.4-17.9l2.6-.6c1.7-10.1 17-23.8 29.8-35.2l1.1-1c5.7-5.1 10.7-9.7 13.6-13.1l.7 4.4c17-15.9 44.6-27.5 65.6-36.4l.5-.2c4.8-2 9.3-3.9 13.3-5.7c-3.4 3.8 2.2 2.7 10 1c4.8-1 10.4-2.1 15.3-2.4l-3.9 2.1c-2.7 1.4-5.4 2.8-8 4.6c8.1-2 11.7-1.4 15.7-.8l.3 0c3.5 .6 7.3 1.2 14.6 .2c-5.6 .8-12.3 3-11.2 3.8c7.9 .9 12.8-.1 17.2-1l.2 0c5.5-1.1 10.3-2 19.3 .9l-1-4.8c7.3 2.6 12.7 4.3 17.5 5.8l.5 .1c10 3 17.6 5.3 34.2 14.1c3.2 .2 5.3-.5 7.4-1.2l.1 0c3.6-1.1 7-2.1 15.2 1.2c.3 .5 .5 1 .7 1.4c.1 .2 .2 .5 .3 .7l0 .1c1 2.6 1.8 4.6 14.6 12.1c1.7-.7-2.7-4.7-6.4-8.2c0 0 0 0-.1-.1c-.2-.1-.3-.3-.5-.4c32.2 17.3 67.3 54.1 78 93.5c-6-11.1-5.2-5.5-4.3 .5c.6 4 1.2 8.1-.2 7.5c4.5 12.1 8.1 24.5 10.4 37.4l-.8-2.9-.1-.3c-3.3-11.9-9.6-34.3-19.9-49.3c-.4 4.3-2.8 3.9-5.2 3.5l-.1 0 0 0c-3.3-.6-6.2-1.1-1.9 12.6c2.6 3.8 3.1 2.4 3.5 1.1l0 0c.5-1.5 .9-2.7 4.7 5.2c.1 4.1 1 8.2 2.1 12.7l0 0 0 0 .1 .6c.1 .3 .1 .5 .2 .8l.1 .6c.6 2.6 1.3 5.4 1.8 8.4c-1.1-.2-2.3-2.2-3.4-4.2c-1.4-2.4-2.8-4.7-3.7-3.2c2.4 11.5 6.5 17.4 8 18.3c-.3 .6-.6 .7-1.1 .7c-.8 0-1.8 .1-1.9 5.3c.7 13.7 3.3 12.5 5.3 11.6l0 0c.6-.3 1.2-.6 1.7-.4c-.6 2.5-1.6 5.1-2.7 7.9c-2.8 7.1-6 15.4-3.4 26.1c-.8-3-2-6-3.1-8.9l-.1-.4c-.2-.5-.4-1-.6-1.5l0 0c-.3-.8-.6-1.6-.9-2.3c-.6 4.4-.3 7.7-.1 10.6c0 .2 0 .5 0 .7c.4 5.3 .7 10-3 19.9c4.3-14.2 3.8-26.9-.2-20.8c1 10.9-3.7 20.4-8 28.9l-.1 .2c-3.6 7.1-6.8 13.5-5.9 19.3l-5.2-7.1c-7.5 10.9-7 13.3-6.5 15.5l0 .1c.5 1.9 1 3.8-3.4 10.8c1.7-2.9 1.3-3.6 1-4.2l0 0c-.4-.8-.7-1.5 1.7-5.1c-1.6 .1-5.5 3.9-10.1 8.5c-3.9 3.9-8.5 8.4-12.8 11.8c-37.5 30.1-82.3 34-125.6 17.8c.2-1-.2-2.1-3.1-4.1c-36.8-28.2-58.5-52.1-50.9-107.5c2.1-1.6 3.6-5.8 5.3-10.8l0 0 0 0 .2-.4 .1-.3 0-.1c2.9-8.4 6.5-18.8 14.3-23.8c7.8-17.3 31.3-33.3 56.4-33.7c25.6-1.4 47.2 13.7 58.1 27.9c-19.8-18.4-52.1-24-79.7-10.4c-28.2 12.7-45 43.8-42.5 74.7c.3-.4 .6-.6 .9-.8l0 0s0 0 0 0c0 0 .1-.1 .1-.1l.1-.1c.6-.5 1.1-.9 1.4-3.3c-.9 60.2 64.8 104.3 112.1 82l.6 1.3c12.7-3.5 15.9-6.5 20.3-10.7l.1-.1 0 0c2.2-2.1 4.7-4.5 8.9-7.3c-.3 .7-1.3 1.7-2.4 2.7c-2.2 2.1-4.6 4.5-1.6 4.6c5-1.3 18.5-13.4 28.5-22.3l0 0 0 0c.6-.5 1.2-1 1.7-1.5c1.5-1.3 2.8-2.5 4-3.6l0 0 .3-.3c1.9-4.2 1.6-5.6 1.3-7l0-.1c-.4-1.6-.8-3.3 2.4-9.6l7.3-3.7c.8-2.1 1.5-4.1 2.2-6c.2-.6 .5-1.2 .7-1.8l-.4-.2zM349.3 34.3l-.2-.1 .2 .1 0 0zM247.8 334.1c-6-3-13.7-8.9-14.8-11.4l-.4 .3c-.3 .6-.5 1.3-.2 2.2c-12.2-5.7-23.4-14.3-32.6-24.9c4.9 7.1 10.1 14.1 17 19.5c-6.9-2.3-15.1-11.8-21.6-19.3l-.1-.1c-4.3-5-7.9-9.1-9.7-9.5c19.8 35.5 80.5 62.3 112.3 49c-14.7 .5-33.4 .3-49.9-5.8zm79.3-119.7l-.1-.2c-.5-1.5-1.1-3.1-1.7-3.4c1.4-5.8 5.4-10.7 4.4 4.6c-1 3.8-1.8 1.5-2.6-1zm-4.2 22.2c-1.3 7.9-5 15.5-10.1 22.5c.2-2-1.2-2.4-2.6-2.8l0 0c-2.9-.8-5.9-1.6 5.6-16.1c-.5 1.9-2.1 4.6-3.7 7.3l0 0 0 0-.3 .4c-3.6 5.9-6.7 11 4 4.3l1-1.8c2.6-4.5 5-8.8 6-13.8h.1zm-55.6 33.9c7.1 .6 14.1 .6 21-1.1c-2.5 2.4-5.2 4.8-8.3 7.2c-11.1-1.7-21.2-6-12.7-6.1zm-92.6 11.6c3.6 7.1 6.4 11.5 9 15.7l.1 .2c2.3 3.7 4.4 7.1 6.8 11.7c-5.1-4.2-8.7-9.5-12.5-15l-.3-.5c-1.4-2.1-2.8-4.2-4.4-6.2l1.2-5.9h.1zm7.5-9.6c1.6 3.3 3.2 6.4 5.7 9.1l2.6 7.7-1.3-2.1c-3.2-5.3-6.3-10.6-8-16.7l.8 1.6 .2 .4zm238.9-41.6c-2.3 17.4-7.7 34.6-16 50.3c7.6-14.9 12.5-30.9 14.8-47.2l1.2-3.1zM35.6 110.6c.4 .8 1.4 .5 2.3 .3c1.9-.5 3.6-.9-.1 7.6c-.5 .3-1 .7-1.5 1l0 0 0 0c-1.4 .9-2.8 1.9-3.9 3c1.9-3.8 3.5-7.4 3.2-11.9zM25.3 152.3c-.7 3.7-1.5 7.9-3.4 13.9c.2-1.9 0-3.5-.2-4.9l0-.1c-.4-3.4-.7-6.3 4.3-12.8c-.3 1.2-.5 2.5-.7 3.8v.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDashcube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDartLang(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.6 78.9c-2.8-.1-5.6-.2-8.5-.2l-264.1 0 143.2-72C256.6 2.3 268 0 279.6 0c13.5 0 29.4 9.2 37 16.8l62 62zM107.3 96.5l262.8 0c16 0 25.4 1.4 35.4 9.3L512 212.2 512 421l-79.3 .7L107.3 96.5zM96.5 373l0-262.2L420.3 434.6l.7 77.4-212.2 0-98.1-98.2 0 0C99.4 402.5 96.5 398.5 96.5 373zM78.7 105.3l0 267.7c0 3.3 .1 6.3 .2 9.1l-62-62C6.5 309.3 0 294.3 0 279.6c0-6.8 3.9-17.5 6.7-23.6l72-150.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDailymotion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDAndD(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDAndDBeyond(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCuttlefish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCss3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCss3Alt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376.3 32L0 32 0 408.3c0 19 7.6 37.2 21 50.7s31.7 21 50.7 21l304.6 0c19 0 37.2-7.6 50.7-21s21-31.7 21-50.7l0-304.6c0-19-7.6-37.2-21-50.7s-31.7-21-50.7-21zM332.4 431.4c-7.7-8.5-11.7-20.7-12-36.6l31.3 0c.2 14.1 5.1 21.1 14.8 21.1c4.9 0 8.4-1.6 10.5-4.7c2-3.1 3-8 3-14.8c0-5.4-1.3-9.9-4-13.4c-3.5-4.2-8.1-7.5-13.2-9.5L351.2 368c-10.3-4.9-17.8-10.8-22.5-17.6c-4.5-6.8-6.7-16.3-6.7-28.4c0-13.6 4-24.6 11.8-33.1c8.1-8.5 19.1-12.7 33.2-12.7c13.6 0 24.1 4.2 31.5 12.5c7.5 8.4 11.5 20.3 11.8 35.9l-30.1 0c.2-5.1-.9-10.2-3-14.8c-1.7-3.4-5-5.1-10-5.1c-8.8 0-13.2 5.2-13.2 15.7c0 5.3 1.1 9.4 3.2 12.6c3.1 3.5 7 6.2 11.4 7.8l11.1 4.9c11.5 5.3 19.7 11.7 24.8 19.4c5.1 7.7 7.6 18 7.6 31c0 15.5-4 27.4-12.3 35.7c-8.2 8.3-19.5 12.5-34.1 12.5s-25.6-4.2-33.4-12.7zm-101 0c-7.7-8.5-11.7-20.7-12-36.6l31.3 0c.2 14.1 5.1 21.1 14.8 21.1c4.9 0 8.4-1.6 10.4-4.7c2-3.1 3-8 3-14.8c0-5.4-1.3-9.9-3.9-13.4c-3.5-4.2-8.1-7.5-13.2-9.5L250.2 368c-10.3-4.9-17.8-10.8-22.5-17.6c-4.5-6.8-6.7-16.3-6.7-28.4c0-13.6 4-24.6 11.8-33.1c8.1-8.5 19.1-12.7 33.2-12.7c13.6 0 24.1 4.2 31.4 12.5c7.6 8.4 11.5 20.3 11.9 35.9l-30.1 0c.2-5.1-.9-10.2-3-14.8c-1.7-3.4-5-5.1-10-5.1c-8.8 0-13.2 5.2-13.2 15.7c0 5.3 1.1 9.4 3.2 12.6c3.1 3.5 7 6.2 11.4 7.8l11.1 4.9c11.5 5.3 19.7 11.7 24.8 19.4c5.1 7.7 7.6 18 7.6 31c0 15.5-4.1 27.4-12.3 35.7s-19.5 12.5-34.1 12.5s-25.6-4.2-33.4-12.7zm-105.6 1.1c-8.4-7.7-12.5-19.2-12.5-34.5l0-75.4c0-15.2 4.4-26.7 13.2-34.6c8.9-7.8 20.7-11.8 35.2-11.8c14.1 0 25.2 4 33.4 12c8.3 8 12.5 20 12.5 35.9l0 6-33.1 0 0-5.8c0-6.1-1.3-10.7-4-13.6c-1.1-1.5-2.6-2.7-4.3-3.5s-3.5-1.2-5.4-1.1c-5.4 0-9.2 1.8-11.4 5.6c-2.3 5.2-3.3 10.8-3 16.4l0 65.5c0 13.7 4.8 20.6 14.4 20.8c4.5 0 7.9-1.6 10.2-4.8c2.5-4.1 3.7-8.8 3.5-13.6l0-4.9 33.1 0 0 5.1c0 10.6-2.1 19.5-6.2 26.6c-4 6.9-9.9 12.5-17.1 16c-7.7 3.7-16.1 5.5-24.6 5.3c-14.2 0-25.5-3.9-33.8-11.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCriticalRole(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommons(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsZero(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsSampling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsSamplingPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsSa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsRemix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsPd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsPdAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNcJp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNcEu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsBy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCpanel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCottonBureau(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaContao(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaConnectdevelop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaConfluence(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodiepie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 472 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodepen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCmplid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M226.119,388.165a3.816,3.816,0,0,0-2.294-3.5,3.946,3.946,0,0,0-1.629-.385L72.6,384.3a19.243,19.243,0,0,1-17.924-26.025L81.585,255.692a35.72,35.72,0,0,1,32.373-26H262.525a7.07,7.07,0,0,0,6.392-5.194l10.769-41.131a3.849,3.849,0,0,0-2.237-4.937,3.755,3.755,0,0,0-1.377-.261c-.063,0-.126,0-.189.005H127.38a106.8,106.8,0,0,0-96.99,77.1L3.483,358.824A57.469,57.469,0,0,0,57.314,436q1.43,0,2.86-.072H208.742a7.131,7.131,0,0,0,6.391-5.193L225.839,389.6A3.82,3.82,0,0,0,226.119,388.165ZM306.658,81.2a3.861,3.861,0,0,0,.251-1.367A3.813,3.813,0,0,0,303.079,76c-.064,0-.128,0-.192,0h-41A7.034,7.034,0,0,0,255.5,81.2l-21.347,80.915h51.131ZM180.364,368.249H231.5L263.452,245.69H212.321ZM511.853,79.723a3.809,3.809,0,0,0-3.8-3.661c-.058,0-.137,0-.23.007h-41a7.1,7.1,0,0,0-6.584,5.129L368.91,430.634a3.54,3.54,0,0,0-.262,1.335,3.873,3.873,0,0,0,3.864,3.863c.056,0,.112,0,.169,0h41a7.068,7.068,0,0,0,6.392-5.193L511.533,81.2A3.624,3.624,0,0,0,511.853,79.723ZM324.649,384.47h-41a7.2,7.2,0,0,0-6.392,5.194L266.52,430.8a3.662,3.662,0,0,0-.268,1.374A3.783,3.783,0,0,0,270.023,436c.06,0,.166,0,.3-.012h40.905a7.036,7.036,0,0,0,6.391-5.193l10.769-41.131a3.75,3.75,0,0,0-3.445-5.208c-.108,0-.217,0-.326.014Zm311.324-308.4h-41a7.066,7.066,0,0,0-6.392,5.129l-91.46,349.436a4.073,4.073,0,0,0-.229,1.347,3.872,3.872,0,0,0,3.863,3.851c.056,0,.112,0,.169,0h40.968a7.1,7.1,0,0,0,6.392-5.193L639.68,81.2a3.624,3.624,0,0,0,.32-1.475,3.841,3.841,0,0,0-3.821-3.564c-.068,0-.137,0-.206.006ZM371.562,225.236l10.8-41.1a4.369,4.369,0,0,0,.227-1.388,3.869,3.869,0,0,0-3.861-3.842c-.057,0-.113,0-.169,0h-41.1a7.292,7.292,0,0,0-6.391,5.226l-10.834,41.1a4.417,4.417,0,0,0-.26,1.493c0,.069,0,.138,0,.206a3.776,3.776,0,0,0,3.757,3.507c.076,0,.18,0,.3-.012h41.129A7.034,7.034,0,0,0,371.562,225.236Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudversify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudsmith(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 227.6v56.9L284.4 512H227.6L0 284.4V227.6L227.6 0h56.9L512 227.6zm-256 162a133.6 133.6 0 1 0 0-267.1 133.6 133.6 0 1 0 0 267.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudscale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudflare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChromecast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChrome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256C0 209.4 12.47 165.6 34.27 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.19 98.47C101 38.53 174 0 256 0C350.8 0 433.5 51.48 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCentos(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCentercode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcVisa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcStripe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcPaypal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcMastercard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcJcb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcDiscover(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcDinersClub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcApplePay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcAmex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48v-1.1H514.3l-31.9-35.1-31.9 35.1H246.8V267.1H181L262.7 82.4h78.6l28.1 63.2V82.4h97.2L483.5 130l17-47.6H576V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80V432zm440.4-21.7L482.6 364l42 46.3H576l-68-72.1 68-72.1H525.4l-42 46.7-41.5-46.7H390.5L458 338.6l-67.4 71.6V377.1h-83V354.9h80.9V322.6H307.6V300.2h83V267.1h-122V410.3H440.4zm96.3-72L576 380.2V296.9l-39.3 41.4zm-36.3-92l36.9-100.6V246.3H576V103H515.8l-32.2 89.3L451.7 103H390.5V246.1L327.3 103H276.1L213.7 246.3h43l11.9-28.7h65.9l12 28.7h82.7V146L466 246.3h34.4zM282 185.4l19.5-46.9 19.4 46.9H282z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcAmazonPay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCanadianMapleLeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuysellads(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuyNLarge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuromobelexperte(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuffer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBtc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBrave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M145.5 0H224h78.5l44.7 50.8s39.3-10.9 57.8 7.6s33.8 34.9 33.8 34.9l-12 29.5 15.3 43.7s-44.9 170.2-50.1 191c-10.4 40.9-17.4 56.8-46.9 77.5s-82.9 56.8-91.6 62.2c-1.9 1.2-3.9 2.5-5.9 3.9c-7.5 5.1-15.8 10.8-23.5 10.8l0 0 0 0c-7.7 0-16.1-5.7-23.5-10.8c-2-1.4-4-2.8-5.9-3.9c-8.7-5.5-62.1-41.5-91.6-62.2s-36.5-36.6-46.9-77.5c-5.3-20.8-50.1-191-50.1-191l15.3-43.7L9.2 93.3s15.3-16.4 33.8-34.9s57.8-7.6 57.8-7.6L145.5 0zM224 407.6l0 0c3.7 0 8.9-4.7 13-8.4c.6-.5 1.2-1.1 1.7-1.5c4.2-3.7 47.8-37.5 51-39.8s5.4-6.5 1.9-8.7c-2.8-1.7-10-5.5-20.3-10.8c-3-1.6-6.3-3.2-9.7-5c-15.4-8-34.5-14.7-37.5-14.7l0 0 0 0c-3 0-22.1 6.8-37.5 14.7c-3.5 1.8-6.7 3.5-9.7 5c-10.3 5.3-17.6 9.1-20.3 10.8c-3.6 2.2-1.4 6.4 1.9 8.7s46.8 36.1 51 39.8c.5 .5 1.1 1 1.7 1.5c4.1 3.7 9.3 8.4 13 8.4l0 0zm0-165.7l0 0c4.7 0 17.6-3 26.4-5l0 0 2-.5c7.8-1.8 7.3-6.3 6.4-13c-.1-.8-.2-1.6-.3-2.4c-.6-6.1-5.8-33.1-9.1-50.3c-1.1-5.8-2-10.5-2.4-12.9c-1.5-8.1-.6-9.4 .7-11.3c.2-.3 .5-.7 .7-1.1c1.4-2.3 16-6.2 27.9-9.5l0 0c2.5-.7 4.8-1.3 6.9-1.9c10.6-3 32.4-.6 44.2 .6c1.8 .2 3.4 .4 4.7 .5c9.6 .9 10.4 2.3 7.2 3.8c-2.3 1.1-16.2 6.3-28.7 10.9l0 0 0 0c-4.7 1.8-9.2 3.5-12.8 4.8c-1.5 .5-3 1.1-4.5 1.7c-12.5 4.6-27.2 10-28.9 19.4c-1.5 8.3 5.2 19.9 11.3 30.3l0 0c1.6 2.8 3.2 5.5 4.6 8.1c6.3 11.9 6.5 13.3 6.1 18.1c-.4 3.9-14.5 12.7-22.4 17.6l0 0c-1.8 1.1-3.3 2.1-4.2 2.7c-.8 .5-2.1 1.4-3.8 2.4c-8.6 5.2-26.3 16-26.3 22.5c0 7.8 24.6 28.1 32.4 33.2s28.9 16.1 37.9 17.8s23-8.5 31.2-23.8c7.7-14.4 1.7-28.5-3.2-40l-.9-2.2c-4.5-10.6 1.9-17 6.2-21.3l0 0c.5-.5 1-1 1.4-1.4L377.7 194c1.3-1.3 2.5-2.6 3.7-3.8l0 0c5.8-5.7 10.8-10.5 10.8-22.8c0-14.9-57.5-84.5-57.5-84.5s-48.5 9.3-55.1 9.3c-5.2 0-15.3-3.5-25.8-7.1l0 0c-2.7-.9-5.4-1.9-8-2.7C232.8 78.1 224 78 224 78l0 0 0 0s-8.7 0-21.8 4.4c-2.7 .9-5.4 1.8-8 2.7l0 0c-10.5 3.6-20.6 7.1-25.8 7.1c-6.5 0-55.1-9.3-55.1-9.3s-57.5 69.6-57.5 84.5c0 12.3 4.9 17.1 10.8 22.8l0 0c1.2 1.2 2.5 2.4 3.7 3.8l43.1 45.8c.4 .5 .9 .9 1.4 1.4l0 0c4.3 4.3 10.6 10.7 6.2 21.3l-.9 2.2c-4.9 11.5-11 25.6-3.2 40c8.2 15.3 22.2 25.5 31.2 23.8s30.1-12.7 37.9-17.8s32.4-25.4 32.4-33.2c0-6.5-17.7-17.3-26.3-22.5c-1.7-1-3.1-1.9-3.8-2.4c-.9-.6-2.4-1.5-4.2-2.7c-7.9-4.9-22-13.7-22.4-17.6c-.4-4.8-.3-6.2 6.1-18.1c1.3-2.5 2.9-5.3 4.6-8.1c6-10.4 12.8-22 11.3-30.3c-1.7-9.4-16.4-14.8-28.9-19.4c-1.6-.6-3.1-1.1-4.5-1.7c-3.6-1.4-8.1-3.1-12.8-4.8l-.1 0c-12.5-4.7-26.4-9.9-28.7-10.9c-3.2-1.5-2.3-2.8 7.2-3.8c1.3-.1 2.9-.3 4.7-.5c11.8-1.3 33.6-3.6 44.2-.6c2.1 .6 4.4 1.2 6.9 1.9c11.9 3.2 26.5 7.2 27.9 9.5c.2 .4 .5 .7 .7 1.1c1.3 1.9 2.2 3.2 .7 11.3c-.4 2.4-1.3 7.1-2.4 12.9c-3.3 17.2-8.5 44.2-9.1 50.3c-.1 .8-.2 1.7-.3 2.4c-.8 6.7-1.4 11.2 6.4 13l2 .5 0 0c8.8 2 21.8 5 26.4 5l0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBraveReverse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298 0c3 0 5.8 1.3 7.8 3.6l38.1 44c.5-.1 1-.2 1.5-.3c9.2-1.6 18.6-2.2 27.7-1.2c11.6 1.4 21.5 5.4 28.9 12.9c7.7 7.8 15.4 15.8 22.6 23.6c2.5 2.7 4.9 5.2 6.9 7.4c.7 .8 1.4 1.5 1.9 2c3.4 3.7 4.2 8.1 2.7 11.9l-9.8 24.6 13.1 38.1c.7 2 .8 4.1 .2 6.2c-.1 .4-.1 .4-.5 2.1c-.6 2.3-.6 2.3-1.5 5.8c-1.6 6.3-3.5 13.3-5.4 20.9c-5.6 21.6-11.2 43.2-16.4 63.4c-12.9 49.9-21.4 82.7-23.4 90.9c-11.1 44.5-19.9 60-48.3 80.3c-24.9 17.8-76.8 53.6-86.8 60c-1 .6-2 1.3-3.4 2.3c-.5 .4-3.2 2.2-3.9 2.7c-4.9 3.3-8.3 5.5-12.1 7.3c-4.7 2.2-9.3 3.5-13.9 3.5s-9.1-1.2-13.9-3.5c-3.7-1.8-7.2-3.9-12.1-7.3c-.8-.5-3.4-2.4-3.9-2.7c-1.4-1-2.5-1.7-3.4-2.3c-10-6.4-61.9-42.1-86.8-60c-28.4-20.4-37.2-35.8-48.3-80.3c-2-8.2-10.5-41-23.3-90.5c-5.3-20.6-10.9-42.2-16.5-63.8c-2-7.6-3.8-14.6-5.4-20.9c-.9-3.5-.9-3.5-1.5-5.8c-.4-1.7-.4-1.7-.5-2.1c-.5-2-.4-4.2 .2-6.2l13.1-38.1L11.8 104c-1.5-3.8-.7-8.2 2-11.2c1.2-1.3 1.8-2 2.6-2.8c2-2.2 4.4-4.7 6.9-7.4C30.6 74.9 38.3 66.9 46 59.1c7.4-7.5 17.3-11.6 28.9-12.9c9.1-1.1 18.5-.5 27.7 1.2c.5 .1 1 .2 1.5 .3l38.1-44C144.2 1.3 147 0 150 0H298zm-4.7 21.1H154.7L115.6 66.2c-2.6 3-6.7 4.3-10.6 3.2c-.2-.1-.7-.2-1.5-.4c-1.3-.3-2.9-.6-4.5-.9c-7.4-1.3-14.9-1.8-21.7-1C70 68 64.3 70.3 60.7 74c-7.6 7.7-15.2 15.6-22.3 23.3c-1.7 1.8-3.3 3.5-4.8 5.1l8.8 22c1 2.4 1 5 .2 7.5L29.2 170.6c.4 1.4 .5 1.9 1.2 4.8c1.6 6.3 3.5 13.3 5.4 20.9c5.6 21.6 11.2 43.2 16.4 63.4c12.9 50 21.4 82.8 23.4 91C85.7 390.8 92 402 115.8 419c24.6 17.6 76.3 53.2 85.9 59.3c1.2 .8 2.5 1.6 4 2.7c.6 .4 3.2 2.2 3.9 2.7c4 2.8 6.7 4.4 9.2 5.6c2.2 1 3.9 1.5 5.1 1.5s2.9-.5 5.1-1.5c2.5-1.2 5.2-2.8 9.2-5.6c.7-.5 3.3-2.3 3.9-2.7c1.6-1.1 2.8-1.9 4-2.7c9.6-6.1 61.3-41.7 85.9-59.3c23.8-17.1 30.2-28.2 40.1-68.3c2.1-8.3 10.5-41.1 23.3-90.7c5.3-20.6 10.9-42.2 16.5-63.8c2-7.6 3.8-14.6 5.4-20.9c.7-2.9 .9-3.4 1.2-4.8l-13.3-38.8c-.8-2.4-.8-5.1 .2-7.5l8.8-22c-1.5-1.6-3.1-3.3-4.8-5.1c-7.2-7.6-14.7-15.5-22.3-23.3c-3.7-3.7-9.3-6-16.6-6.9c-6.8-.8-14.4-.3-21.7 1c-1.7 .3-3.2 .6-4.5 .9c-.8 .2-1.3 .3-1.5 .4c-3.8 1.1-7.9-.2-10.6-3.2L293.3 21.1zM224 316c2.8 0 20.9 6.5 35.4 14.1s25 13 28.3 15.2s1.3 6.2-1.7 8.4s-44.1 34.6-48.1 38.2s-9.8 9.5-13.8 9.5s-9.8-5.9-13.8-9.5s-45.1-36-48.1-38.2s-5.1-6.2-1.7-8.4s13.9-7.5 28.3-15.2s32.5-14.1 35.4-14.1zm.1-230.7c.7 0 8.8 .2 20.5 4.2c12.3 4.2 25.7 9.4 31.9 9.4s51.9-8.9 51.9-8.9s54.2 66.7 54.2 81s-6.8 18-13.7 25.4s-36.8 39.8-40.7 43.9s-11.9 10.5-7.1 21.8s11.7 25.8 3.9 40.4s-21 24.4-29.4 22.8s-28.4-12.2-35.7-17.1s-30.5-24.3-30.5-31.8s24-20.8 28.4-23.9s24.7-14.8 25.1-19.4s.3-6-5.7-17.4s-16.7-26.7-14.9-36.8s19.1-15.4 31.5-20.2s36.2-13.7 39.2-15.1s2.2-2.7-6.8-3.6s-34.6-4.3-46.1-1.1s-31.2 8.2-32.8 10.9s-3 2.7-1.4 11.8s10.1 52.8 10.9 60.6s2.4 12.9-5.8 14.8s-22.1 5.2-26.8 5.2s-18.6-3.3-26.8-5.2s-6.6-7-5.8-14.8s9.3-51.5 10.9-60.6s.2-9.2-1.4-11.8s-21.3-7.6-32.8-10.9s-37.1 .2-46.1 1.1s-9.8 2.2-6.8 3.6s26.8 10.4 39.2 15.1s29.7 10 31.5 20.2s-9 25.4-14.9 36.8s-6.1 12.8-5.7 17.4s20.6 16.4 25.1 19.4s28.4 16.4 28.4 23.9s-23.2 27-30.5 31.8s-27.2 15.4-35.7 17.1s-21.7-8.2-29.4-22.8s-.8-29.1 3.9-40.4s-3.3-17.7-7.1-21.8s-33.8-36.5-40.7-43.9s-13.7-11.2-13.7-25.4s54.2-81 54.2-81s45.8 8.9 51.9 8.9s19.5-5.2 31.9-9.4s20.6-4.2 20.6-4.2l.1 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.344,197.834a51.767,51.767,0,0,0-41.57,20.058V156.018a8.19,8.19,0,0,0-8.19-8.19H8.19A8.19,8.19,0,0,0,0,156.018V333.551a8.189,8.189,0,0,0,8.19,8.189H36.584a8.189,8.189,0,0,0,8.19-8.189v-8.088c11.628,13.373,25.874,19.769,41.573,19.769,34.6,0,61.922-26.164,61.922-73.843C148.266,225.452,121.229,197.834,86.344,197.834ZM71.516,305.691c-9.593,0-21.221-4.942-26.745-12.5V250.164c5.528-7.558,17.152-12.791,26.745-12.791,17.734,0,31.107,13.082,31.107,34.013C102.623,292.609,89.25,305.691,71.516,305.691Zm156.372-59.032a17.4,17.4,0,1,0,17.4,17.4A17.4,17.4,0,0,0,227.888,246.659ZM273.956,156.7V112.039a13.308,13.308,0,1,0-10.237,0V156.7a107.49,107.49,0,1,0,10.237,0Zm85.993,107.367c0,30.531-40.792,55.281-91.112,55.281s-91.111-24.75-91.111-55.281,40.792-55.281,91.111-55.281S359.949,233.532,359.949,264.062Zm-50.163,17.4a17.4,17.4,0,1,0-17.4-17.4h0A17.4,17.4,0,0,0,309.786,281.466ZM580.7,250.455c-14.828-2.617-22.387-3.78-22.387-9.885,0-5.523,7.268-9.884,17.735-9.884a65.56,65.56,0,0,1,34.484,10.1,8.171,8.171,0,0,0,11.288-2.468c.07-.11.138-.221.2-.333l8.611-14.886a8.2,8.2,0,0,0-2.867-11.123,99.863,99.863,0,0,0-52.014-14.138c-38.956,0-60.179,21.514-60.179,46.225,0,36.342,33.725,41.864,57.563,45.642,13.373,2.326,24.13,4.361,24.13,11.048,0,6.4-5.523,10.757-18.9,10.757-13.552,0-30.994-6.222-42.623-13.579a8.206,8.206,0,0,0-11.335,2.491c-.035.054-.069.108-.1.164l-10.2,16.891a8.222,8.222,0,0,0,2.491,11.066c15.224,10.3,37.663,16.692,59.441,16.692,40.409,0,63.957-19.769,63.957-46.515C640,260.63,604.537,254.816,580.7,250.455Zm-95.928,60.787a8.211,8.211,0,0,0-9.521-5.938,23.168,23.168,0,0,1-4.155.387c-7.849,0-12.5-6.106-12.5-14.245V240.28h20.349a8.143,8.143,0,0,0,8.141-8.143V209.466a8.143,8.143,0,0,0-8.141-8.143H458.594V171.091a8.143,8.143,0,0,0-8.143-8.143H422.257a8.143,8.143,0,0,0-8.143,8.143h0v30.232H399a8.143,8.143,0,0,0-8.143,8.143h0v22.671A8.143,8.143,0,0,0,399,240.28h15.115v63.667c0,27.037,15.408,41.282,43.9,41.282,12.183,0,21.383-2.2,27.6-5.446a8.161,8.161,0,0,0,4.145-9.278Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBootstrap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBluetooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBluetoothB(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBluesky(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.8 62.2C170.2 105.9 233 194.7 256 242.4c23-47.6 85.8-136.4 144.2-180.2c42.1-31.6 110.3-56 110.3 21.8c0 15.5-8.9 130.5-14.1 149.2C478.2 298 412 314.6 353.1 304.5c102.9 17.5 129.1 75.5 72.5 133.5c-107.4 110.2-154.3-27.6-166.3-62.9l0 0c-1.7-4.9-2.6-7.8-3.3-7.8s-1.6 3-3.3 7.8l0 0c-12 35.3-59 173.1-166.3 62.9c-56.5-58-30.4-116 72.5-133.5C100 314.6 33.8 298 15.7 233.1C10.4 214.4 1.5 99.4 1.5 83.9c0-77.8 68.2-53.4 110.3-21.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlogger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBloggerB(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlackberry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlackTie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBitcoin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBitbucket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBimobject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBilibili(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.6 104.1C505.3 122.2 513 143.8 511.9 169.8V372.2C511.5 398.6 502.7 420.3 485.4 437.3C468.2 454.3 446.3 463.2 419.9 464H92.02C65.57 463.2 43.81 454.2 26.74 436.8C9.682 419.4 .7667 396.5 0 368.2V169.8C.7667 143.8 9.682 122.2 26.74 104.1C43.81 87.75 65.57 78.77 92.02 78H121.4L96.05 52.19C90.3 46.46 87.42 39.19 87.42 30.4C87.42 21.6 90.3 14.34 96.05 8.603C101.8 2.868 109.1 0 117.9 0C126.7 0 134 2.868 139.8 8.603L213.1 78H301.1L375.6 8.603C381.7 2.868 389.2 0 398 0C406.8 0 414.1 2.868 419.9 8.603C425.6 14.34 428.5 21.6 428.5 30.4C428.5 39.19 425.6 46.46 419.9 52.19L394.6 78L423.9 78C450.3 78.77 471.9 87.75 488.6 104.1H488.6zM449.8 173.8C449.4 164.2 446.1 156.4 439.1 150.3C433.9 144.2 425.1 140.9 416.4 140.5H96.05C86.46 140.9 78.6 144.2 72.47 150.3C66.33 156.4 63.07 164.2 62.69 173.8V368.2C62.69 377.4 65.95 385.2 72.47 391.7C78.99 398.2 86.85 401.5 96.05 401.5H416.4C425.6 401.5 433.4 398.2 439.7 391.7C446 385.2 449.4 377.4 449.8 368.2L449.8 173.8zM185.5 216.5C191.8 222.8 195.2 230.6 195.6 239.7V273C195.2 282.2 191.9 289.9 185.8 296.2C179.6 302.5 171.8 305.7 162.2 305.7C152.6 305.7 144.7 302.5 138.6 296.2C132.5 289.9 129.2 282.2 128.8 273V239.7C129.2 230.6 132.6 222.8 138.9 216.5C145.2 210.2 152.1 206.9 162.2 206.5C171.4 206.9 179.2 210.2 185.5 216.5H185.5zM377 216.5C383.3 222.8 386.7 230.6 387.1 239.7V273C386.7 282.2 383.4 289.9 377.3 296.2C371.2 302.5 363.3 305.7 353.7 305.7C344.1 305.7 336.3 302.5 330.1 296.2C323.1 289.9 320.7 282.2 320.4 273V239.7C320.7 230.6 324.1 222.8 330.4 216.5C336.7 210.2 344.5 206.9 353.7 206.5C362.9 206.9 370.7 210.2 377 216.5H377z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBehance(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBattleNet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBandcamp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAws(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAviato(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAvianex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAutoprefixer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAudible(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAtlassian(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAsymmetrik(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArtstation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaApple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaApplePay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaApper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAppStore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAppStoreIos(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngular(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngrycreative(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngellist(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAndroid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmilia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmazon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmazonPay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlipay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlgolia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C116.1 0 2 112.7 0 252.1C-2 393.6 112.9 510.8 254.5 511.6c43.7 .3 85.9-10.4 123.3-30.7c3.6-2 4.2-7 1.1-9.7l-24-21.2c-4.9-4.3-11.8-5.5-17.8-3c-26.1 11.1-54.5 16.8-83.7 16.4C139 461.9 46.5 366.8 48.3 252.4C50.1 139.5 142.6 48.2 256 48.2H463.7V417.2L345.9 312.5c-3.8-3.4-9.7-2.7-12.7 1.3c-18.9 25-49.7 40.6-83.9 38.2c-47.5-3.3-85.9-41.5-89.5-88.9c-4.2-56.6 40.6-103.9 96.3-103.9c50.4 0 91.9 38.8 96.2 88c.4 4.4 2.4 8.5 5.7 11.4l30.7 27.2c3.5 3.1 9 1.2 9.9-3.4c2.2-11.8 3-24.2 2.1-36.8c-4.9-72-63.3-130-135.4-134.4c-82.7-5.1-151.8 59.5-154 140.6c-2.1 78.9 62.6 147 141.6 148.7c33 .7 63.6-9.6 88.3-27.6L495 509.4c6.6 5.8 17 1.2 17-7.7V9.7c0-5.4-4.4-9.7-9.7-9.7H256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAirbnb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAffiliatetheme(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAdversal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAdn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAccusoft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAccessibleIcon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa500Px(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa42Group(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96V416C341.011 416 361.818 411.861 381.23 403.821C400.641 395.78 418.28 383.995 433.138 369.138C447.995 354.28 459.78 336.641 467.821 317.23C475.861 297.818 480 277.011 480 256C480 234.989 475.861 214.182 467.821 194.771C459.78 175.359 447.995 157.72 433.138 142.863C418.28 128.005 400.641 116.22 381.23 108.179C361.818 100.139 341.011 96 320 96ZM0 256L160.002 416L320.003 256L160.002 96L0 256ZM480 256C480 277.011 484.138 297.818 492.179 317.23C500.219 336.643 512.005 354.28 526.862 369.138C541.72 383.995 559.357 395.781 578.77 403.821C598.182 411.862 618.989 416 640 416V96C597.565 96 556.869 112.858 526.862 142.863C496.857 172.869 480 213.565 480 256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaZ(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l320 0c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416 352 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96 32 96C14.3 96 0 81.7 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYinYang(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYenSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M58.6 46.3C48.8 31.5 29 27.6 14.2 37.4S-4.4 67 5.4 81.8L100.2 224 48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 0 32-80 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0-32 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.2 0L314.6 81.8c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaY(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-149.7L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXmarksLines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXRay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 320c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16l0 32-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 48-112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 0 70.6L189.1 307c-5.2-2-10.6-3-16.2-3l-2.1 0c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6l120.8 0c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8l-2.2 0c-5.5 0-11 1-16.2 3L272 326.6l0-70.6 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-48 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-32c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWrench(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7L336 192c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWorm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 96c0-53 43-96 96-96l38.4 0C439.9 0 480 40.1 480 89.6l0 86.4 0 16 0 184c0 75.1-60.9 136-136 136s-136-60.9-136-136l0-80c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 168c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-168c0-75.1 60.9-136 136-136s136 60.9 136 136l0 80c0 22.1 17.9 40 40 40s40-17.9 40-40l0-184-32 0c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWonSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l40.9 0 56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288l46 0L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288l40.9 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-19.6 0 50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224l-64 0L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224l-64 0L62.4 53.9zm78 234.1l26.6 0-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1-14 0zm96 64l26.6 0-15.2 45.6L345 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWineGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32.1 29.3C33.5 12.8 47.4 0 64 0L256 0c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6l0 99.6 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-80 0-80 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0 0-99.6C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7l143.8 0-5.3-64L93.4 64l-5.3 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWineGlassEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6l0 99.6-48 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0-99.6c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0L64 0zM81.9 203.1L93.4 64l133.1 0 11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWineBottle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowRestore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 64L208 64c-8.8 0-16 7.2-16 16l0 16-64 0 0-16c0-44.2 35.8-80 80-80L432 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-16 0 0-64 16 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192zm64 32c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 192c-17.7 0-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowMinimize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowMaximize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 96l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c53 0 96-43 96-96s-43-96-96-96L320 0c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32l32 0c53 0 96-43 96-96s-43-96-96-96L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32zM128 512l32 0c53 0 96-43 96-96s-43-96-96-96L32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWifi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWhiskeyGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5l253 0c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32L32 32zM87.7 224L69 96l374 0L424.3 224 87.7 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWheelchair(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4l5.1 0c.4 0 .8 0 1.3 0l94.1 0c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9l-68.5 0-9.6-48 63.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-76.2 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWheelchairMove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224l97.4 0c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288l-70.3 0c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWheatAwn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWheatAwnCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeightScale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-56.2 0zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeightHanging(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32L120 128c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512l416 0c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128l-45.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWaveSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 352 96 0 0-160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 160c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-352-96 0 0 160c0 17.7-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWaterLadder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7l0 96.3 192 0 0-96.3C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7L448 361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3c0 0 0 0 0 0l0-96.5-192 0 0 96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1l0-233.3zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWarehouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 488L0 171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4L640 488c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-264c0-17.7-14.3-32-32-32l-384 0c-17.7 0-32 14.3-32 32l0 264c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24l0-56 384 0 0 56c0 13.3-10.7 24-24 24zM128 400l0-64 384 0 0 64-384 0zm0-96l0-80 384 0 0 80-384 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWandSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7l0 21.4c0 8.8-7.2 16-16 16l-15.8 0c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9l0-27.6c0-8.8 7.2-16 16-16l34.6 0c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWandMagic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWandMagicSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L80 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l368 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWalkieTalkie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24l0 72L48 96C21.5 96 0 117.5 0 144L0 300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9L32 464c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-92.1c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9L384 144c0-26.5-21.5-48-48-48l-16 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-48 0 0-72zm0 136l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaW(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVrCardboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l120.4 0c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4L576 448c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160 64 160c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l67.8 0L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448l0-384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeLow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeHigh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolleyball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolcano(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1l-41.8 0c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2l41.8 0c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2L52.2 512C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVoicemail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144l352 0c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80l-112.5 0zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViruses(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c13.3 0 24 10.7 24 24l0 13.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168l13.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-13.5 0c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5l0 13.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-13.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216L24 216c-13.3 0-24-10.7-24-24s10.7-24 24-24l13.5 0c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5L168 24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l11.5 0c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6l11.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5L288 32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVirusSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1l11.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14L96 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l11.5 0c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11.5c0-31.2 23.6-52.7 50-55.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVirusCovid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 33.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3l33.6 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-33.6 0c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1l0 33.6 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-33.6c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280L48 280l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 33.6 0c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1L232 48l-16 0c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVirusCovidSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7l33.6 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-33.6 0c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6L344 48l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zM149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5L112 232l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 33.6 0c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1l0 33.6-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2L149.2 213.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVihara(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9l-7.5 0 0 56.1 6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4L544 288l0 65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24l-40 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-160 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-160 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-40 0c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7L96 288l-39.4 0c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1 0-8.1 0-48-7.5 0c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128l-96 0-96 0 0 64 72 0 48 0 72 0 0-64zM160 288l0 64 136 0 24 0 24 0 136 0 0-64-136 0-24 0s0 0 0 0l-24 0-136 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVideoSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2l0-256c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9l0 17.1 0 128 0 5.8-32-25.1L416 128c0-35.3-28.7-64-64-64L113.9 64 38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5l0 256c0 35.3 28.7 64 64 64l256 0c23.4 0 43.9-12.6 55-31.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVials(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l56 0 48 0 56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 304c0 44.2-35.8 80-80 80s-80-35.8-80-80L32 96C14.3 96 0 81.7 0 64zM136 96L88 96l0 160 48 0 0-160zM288 64c0-17.7 14.3-32 32-32l56 0 48 0 56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 304c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-304c-17.7 0-32-14.3-32-32zM424 96l-48 0 0 160 48 0 0-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVial(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5L0 416c0 53 43 96 96 96l5.5 0c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96-101.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVialVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l0 288c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5L224 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0L96 32 32 32zM96 192l0-96 64 0 0 96-64 0zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVialCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l64 0 64 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 170.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96L32 96C14.3 96 0 81.7 0 64zM96 96l0 96 64 0 0-96L96 96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2L224 464c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-193.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6l0-17.5 0-73.7 0-6.3c0-26.5-21.5-48-48-48l-4.5 0c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0L112 0C85.5 0 64 21.5 64 48l0 6.3L64 128l0 17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5L0 464c0 26.5 21.5 48 48 48l128 0c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464l0-168.2c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVestPatches(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3L192 464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512L48 512c-26.5 0-48-21.5-48-48L0 270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6L64 128l0-73.7L64 48C64 21.5 85.5 0 112 0l4.5 0c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0L336 0c26.5 0 48 21.5 48 48l0 6.3 0 73.7 0 17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6L448 464c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-168.2c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280l0 8 0 32c0 8.8 7.2 16 16 16l32 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVenus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1l0 34.9-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-34.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVenusMars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0L616 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVenusDouble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9c-26.6-4.9-51.1-15.7-72-31.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVectorSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 80l32 0 0 32-32 0 0-32zM352 32c-17.7 0-32 14.3-32 32L128 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l0 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l192 0c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-192c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM96 160c17.7 0 32-14.3 32-32l192 0c0 17.7 14.3 32 32 32l0 192c-17.7 0-32 14.3-32 32l-192 0c0-17.7-14.3-32-32-32l0-192zM48 400l32 0 0 32-32 0 0-32zm320 32l0-32 32 0 0 32-32 0zM48 112l0-32 32 0 0 32-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVault(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 416c0 35.3 28.7 64 64 64l16 0 16 32 64 0 16-32 224 0 16 32 64 0 16-32 16 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64L64 0zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3L480 336c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-114.7c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVanShuttle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 104l0 88 96 0 0-96L72 96c-4.4 0-8 3.6-8 8zm482 88L465.1 96 384 96l0 96 162 0zm-226 0l0-96-96 0 0 96 96 0zM592 384l-16 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 104C0 64.2 32.2 32 72 32l120 0 160 0 113.1 0c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2L640 336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaV(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUtensils(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0C400 0 288 32 288 176l0 112c0 35.3 28.7 64 64 64l32 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 0-112 0-208c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7L80 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224.4c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16l0 134.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8L64 16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersViewfinder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 0C14.3 0 0 14.3 0 32L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-17.7-14.3-32-32-32L504 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 480c0 17.7 14.3 32 32 32l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c17.7 0 32-14.3 32-32l0-104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320l178.1 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192l-15.2 0zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c10.5 0 19.5-6 23.9-14.8L324.9 352l-63.6 0zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l448 0c53 0 96-43 96-96l0-320c0-53-43-96-96-96L96 0zM64 96c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32L64 96zm159.8 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0C119.9 256 96 279.9 96 309.3zM461.2 336l56.1 0c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersRays(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32l85.6 0c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4l-96 0c-35.3 0-64 28.7-64 64zm461.6 32l82.4 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4l-96 0c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersGear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2l-103.2 0C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l300.6 0c-2.1-5.2-3.2-10.9-3.2-16.4l0-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3l0-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6l0 3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1l0-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9l0 3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1l0 3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9l0-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersBetweenLines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 24C0 10.7 10.7 0 24 0L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 48C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64l96 0c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6L64 352c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6l96 0c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32l-82.4 0zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1l96 0c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserTie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7l131.7 0c0 0 0 0 .1 0l5.5 0 112 0 5.5 0c0 0 0 0 .1 0l131.7 0c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2L224 304l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1l0-33c-15.9-4.7-32.8-7.2-50.3-7.2l-91.4 0zM384 224c-17.7 0-32 14.3-32 32l0 82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7L384 224zm24 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7l388.6 0c3.9 0 7.6-.7 11-2.1l-261-205.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3l-91.4 0zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7l0-187.8L591.4 312z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserSecret(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48l-59.9 0C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4l-59.9 0c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208l-12.4 0c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2L168 224c-22.1 0-40-17.9-40-40l0-14.4c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4l0 14.4c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM504 312l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserPen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l293.1 0c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1l-91.4 0zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserNurse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128l0-57.8c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30l0 57.8-.3 0c.2 2.6 .3 5.3 .3 8l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-2.7 .1-5.4 .3-8l-.3 0zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16-160 0 0 16zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserNinja(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L160 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM472 200l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l362.8 0c-5.4-9.4-8.6-20.3-8.6-32l0-128c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7l-91.4 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserLarge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7l450.6 0c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320l-189.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserLargeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM545.5 512L528 512 284.3 320l-59 0C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7l450.6 0 .3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserInjured(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 80l102.7 0c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80l81.4 0 91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16L97 112c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7L96 512l147.7 0L181.5 408.2 124 312.4zm33-7.2L204.3 384l67.7 0c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48l82.3 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512L64 512l0-166.6C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48l-48.5 0 57.1 95.2C303 507.2 320 487.6 320 464z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM609.3 512l-137.8 0c5.4-9.4 8.6-20.3 8.6-32l0-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserGraduate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9l0 57.1c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-57.1L48 93.3l0 65.1 15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9l-32 0c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4l0-71.8C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserGear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserDoctor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1l0 50.8c27.6 7.1 48 32.2 48 62l0 40c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-40c0-29.8 20.4-54.9 48-62l0-57.1c-6-.6-12.1-.9-18.3-.9l-91.4 0c-6.2 0-12.3 .3-18.3 .9l0 65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-59.1zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserAstronaut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128l0 64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9l0-64c0-16.8-12.9-30.5-29.3-31.9zM336 144l0 16c0 53-43 96-96 96l-32 0c-53 0-96-43-96-96l0-16c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512l98.3 0 0-64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64 98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16l0 48 32 0 0-48c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 109.3L288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-242.7-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352l128 0c0 35.3 28.7 64 64 64s64-28.7 64-64l128 0c35.3 0 64 28.7 64 64l0 32c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-32c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUpRightFromSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-128c0-17.7-14.3-32-32-32L352 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUpRightAndDownLeftFromCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 0L488 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512L24 512c-13.3 0-24-10.7-24-24L0 344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUpLong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192l72 0 0 288c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-288 72 0c9.6 0 18.2-5.7 22-14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUpDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160l56 0 0 192-56 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-56 0 0-192 56 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUpDownLeftRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 96-96 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 96 0 0 96-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-96 96 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 32-96 0 0-96 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnlock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144l0 48-16 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-240 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnlockKeyhole(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 64c-44.2 0-80 35.8-80 80l0 48 240 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l16 0 0-48C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUniversalAccess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3l0 50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6l0-50.1c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnderline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 64c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 128c0 53 43 96 96 96s96-43 96-96l0-128-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 128c0 88.4-71.6 160-160 160s-160-71.6-160-160L64 96 48 96C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUmbrella(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c17.7 0 32 14.3 32 32l0 17.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7L256 32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2l0 114.3c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4l0-114.3c8.5-7.6 19.7-12.2 32-12.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUmbrellaBeach(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M346.3 271.8l-60.1-21.9L214 448 32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-261.9 0 64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaU(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c17.7 0 32 14.3 32 32l0 224c0 70.7 57.3 128 128 128s128-57.3 128-128l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224c0 106-86 192-192 192S0 394 0 288L0 64C0 46.3 14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64l0 288 512 0 0-288L64 64zM0 64C0 28.7 28.7 0 64 0L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 416c-35.3 0-64-28.7-64-64L0 64zM128 448l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTurnUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5l88 0 0 192c0 17.7-14.3 32-32 32l-80 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192 88 0c9.6 0 18.2-5.7 22-14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTurnDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5l88 0 0-192c0-17.7-14.3-32-32-32L32 96C14.3 96 0 81.7 0 64L0 32C0 14.3 14.3 0 32 0l80 0c70.7 0 128 57.3 128 128l0 192 88 0c9.6 0 18.2 5.7 22 14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTurkishLiraSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32c17.7 0 32 14.3 32 32l0 35.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9l0 29.4 119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9 128 416l63.8 0c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480L96 480c-17.7 0-32-14.3-32-32l0-167.9-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6l0-29.4-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6 64 64c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.3 241.3L15.1 200.6c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4l0-54.8c-49.6-18.1-104-18.1-153.6 0l0 54.8c0 13.8-8.9 26.1-22 30.4L76.1 255.8c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM144 320l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L48 0zM416 160l50.7 0L544 237.3l0 18.7-128 0 0-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckRampBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 0l0 400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8 352 64c0-35.3 28.7-64 64-64L640 0zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200 0c-30.6 0-56 54.7-56 86.1l0 106.5L7.8 274.3C2.9 277.2 0 282.4 0 288l0 64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37 0 81.2-50 40c-3.8 3-6 7.6-6 12.5l0 32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15l0-32.6c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1 0-3.5 0-82.5L256 184l0-1.1s0 0 0 0l0-96.9C256 54.7 231.5 0 200 0zm88 176l0 224c0 20.9 13.4 38.7 32 45.3l0 42.7c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-40 160 0 0 40c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-42.7c18.6-6.6 32-24.4 32-45.3l0-224c0-26.5-21.5-48-48-48l-256 0c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7l151.4 0c9.2 0 17.2 6 20.5 14.7L576 304l-224 0 15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM336 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckPickup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.6 96l76.8 96L288 192l0-96 80.6 0zM224 80l0 112L64 192c-17.7 0-32 14.3-32 32l0 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l33.1 0c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16l66.3 0c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16l33.1 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c0-17.7-14.3-32-32-32l-48.6 0L418.6 56c-12.1-15.2-30.5-24-50-24L272 32c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckMoving(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 304l0 80 0 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16L416 384l33.6 0c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16l1.6 0c17.7 0 32-14.3 32-32l0-64 0-16 0-10.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5L480 144l0-48c0-35.3-28.7-64-64-64L64 32zM585 256l-105 0 0-64 48.8 0c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckMonster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64l0 64 128 0L368 64l-80 0zM419.2 25.6L496 128l80 0c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64l-64 0c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l160 0 0-80c0-26.5 21.5-48 48-48l96 0c20.1 0 39.1 9.5 51.2 25.6zM152 256l16 0c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8l0 16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512l-16 0c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392l0-16c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6l16 0c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8l0 16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512l-16 0c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392l0-16c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckFront(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80C0 35.8 35.8 0 80 0L432 0c44.2 0 80 35.8 80 80l0 288c0 26.2-12.6 49.4-32 64l0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-256 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48C12.6 417.4 0 394.2 0 368L0 80zm129.9 72.2L112 224l288 0-17.9-71.8C378.5 138 365.7 128 351 128l-190 0c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckField(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 96c0-35.3 28.7-64 64-64l224 0c23.7 0 44.4 12.9 55.4 32l51.8 0c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2l4.2 0c35.3 0 64 28.7 64 64l0 32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-32c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l0-32zM384 224l85.9 0-42.7-96L384 128l0 96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckFieldUn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32C60.7 32 32 60.7 32 96l0 32c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-32c0-35.3-28.7-64-64-64l-4.2 0c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38l-51.8 0C364.4 44.9 343.7 32 320 32L96 32zm288 96l43.2 0 42.7 96L384 224l0-96zM112 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52 0-43.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckFast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 0C85.5 0 64 21.5 64 48l0 48L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 208 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 160l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 176 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 224l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 288l0 128c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L112 0zM544 237.3l0 18.7-128 0 0-96 50.7 0L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckDroplet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L96 168c-13.3 0-24 10.7-24 24s10.7 24 24 24l166.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrowel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrowelBricks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.8 4.8C250.3 10.6 256 20.9 256 32l0 72 89 0c3.6-13.8 16.1-24 31-24l88 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-88 0c-14.9 0-27.4-10.2-31-24l-89 0 0 72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64zM32 384l96 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm192 0l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrophy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTriangleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208l24.9 0L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320L80 320 5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5L192 448l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 168.5 0c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320l33.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208l24.9 0c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTreeCity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 144 40 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 24 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-160 0-96 0c-26.5 0-48-21.5-48-48l0-416zm64 32l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM352 272l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM512 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80l-16 0 0 160c0 18-15 32-32 32c-18 0-32-14-32-32l0-160-16 0c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrashCan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrashCanArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 408c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrashArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0L394.8 467c-1.6 25.3-22.6 45-47.9 45l-245.8 0c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 408c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTransgender(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l96 0c8.8 0 16 7.2 16 16l0 96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2l0 17.8 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-17.8C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112L0 16C0 7.2 7.2 0 16 0l96 0zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C43 0 0 43 0 96L0 352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512l39.7 0c8.5 0 16.6-3.4 22.6-9.4L160 448l128 0 54.6 54.6c6 6 14.1 9.4 22.6 9.4l39.7 0c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9l0-256c0-53-43-96-96-96L96 0zM64 96c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-96zM224 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrainTram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0L361.2 0c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15L248 48l0 48 40 0c53 0 96 43 96 96l0 160c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1l-39.7 0c-8.5 0-16.6-3.4-22.6-9.4L288 448l-128 0-54.6 54.6c-6 6-14.1 9.4-22.6 9.4L43 512c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352l0-160c0-53 43-96 96-96l40 0 0-48L86.8 48zM160 160c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-128 0zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrainSubway(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C43 0 0 43 0 96L0 352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512l39.7 0c8.5 0 16.6-3.4 22.6-9.4L160 448l128 0 54.6 54.6c6 6 14.1 9.4 22.6 9.4l39.7 0c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9l0-256c0-53-43-96-96-96L96 0zM64 128c0-17.7 14.3-32 32-32l80 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-80 0c-17.7 0-32-14.3-32-32l0-96zM272 96l80 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-80 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrailer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32C21.5 32 0 53.5 0 80L0 336c0 26.5 21.5 48 48 48l17.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96L488 384l8 0 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-240c0-26.5-21.5-48-48-48L48 32zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21L64 112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrafficLight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l0-288c0-35.3-28.7-64-64-64L64 0zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrademark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32l64 0 0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 96C14.3 96 0 110.3 0 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTractor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64c0-35.3 28.7-64 64-64L266.3 0c26.2 0 49.7 15.9 59.4 40.2L373.7 160 480 160l0-33.8c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9l0 33.8 56 0c22.1 0 40 17.9 40 40l0 45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48l-80 0c0 17.7-14.3 32-32 32l-8.2 0c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8l0 8.2c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1L32 384c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l8.2 0c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6l0-.6 0-32 0-96zm170.3 0L160 64l0 96 32 0 112.7 0L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTowerObservation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144l0 80c0 17.7-14.3 32-32 32l-4.9 0 32 192 68.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-95.5 0c-.4 0-.8 0-1.1 0l-254.8 0c-.4 0-.8 0-1.1 0L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 32-192-4.9 0c-17.7 0-32-14.3-32-32l0-80c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448l117 0zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256l-116.5 0zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTowerCell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448l220.6 0 20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384l-162.4 0 14.5-32 133.3 0 14.5 32zM288 205.3L325.6 288l-75.2 0L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTowerBroadcast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4L320 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-296.6c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTornado(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32L0 45.6C0 62.7 1.7 79.6 5 96l352.8 0c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0L32 0C14.3 0 0 14.3 0 32zm352.2 96L13.6 128c12.2 35.9 32.3 68.7 58.8 96L412 224l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3L445 352c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9l-322.5 0c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9L288 384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToriiGate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80c0 26.5 21.5 48 48 48l16 0 0 64 64 0 0-64 96 0 0 64 64 0 0-64 96 0 0 64 64 0 0-64 16 0c26.5 0 48-21.5 48-48l0-66.6C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32L126.8 32c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4L0 80zM64 288l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0 0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5l0 6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5l0-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToolbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 88l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 80c-4.4 0-8 3.6-8 8zm-48 40l0-40c0-30.9 25.1-56 56-56l144 0c30.9 0 56 25.1 56 56l0 40 28.1 0c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9l0 92.1-128 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-128 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L0 320l0-92.1c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1l28.1 0zM0 416l0-64 128 0c0 17.7 14.3 32 32 32s32-14.3 32-32l128 0c0 17.7 14.3 32 32 32s32-14.3 32-32l128 0 0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToiletsPortable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0L224 0c17.7 0 32 14.3 32 32l0 32L0 64 0 32C0 14.3 14.3 0 32 0zM0 96l24 0 208 0 24 0 0 24 0 368c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L48 480l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 120 0 96zM192 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM352 0L544 0c17.7 0 32 14.3 32 32l0 32L320 64l0-32c0-17.7 14.3-32 32-32zM320 96l24 0 208 0 24 0 0 24 0 368c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-160 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-368 0-24zM512 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToilet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 148.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3l256 0c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4L416 48l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3c0 0 0-.1 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8c0 0 0 .1 0 .1l0 .3zM328.2 384l-.2 .5 0-.5 .2 0zM112 64l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToiletPortable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32L0 64l320 0 0-32c0-17.7-14.3-32-32-32L32 0C14.3 0 0 14.3 0 32zM24 96L0 96l0 24L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 224 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-368 0-24-24 0L24 96zM256 240l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToiletPaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0L444.2 0zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToiletPaperSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192L160 0c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512l237.9 0c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToggleOn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192s-86-192-192-192L192 64zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToggleOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128l-192 0c-70.7 0-128-57.3-128-128s57.3-128 128-128l192 0zM576 256c0-106-86-192-192-192L192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTimeline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3L96 224l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0 0 54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-54.7 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-54.7c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3l0 54.7-320 0 0-54.7zM488 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTicket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128l0 64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-64c0-35.3-28.7-64-64-64L64 64zm64 112l0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-320 0c-17.7 0-32-14.3-32-32l0-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTicketSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6l0 64c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64l0-64c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192l0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThumbtack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C32 14.3 46.3 0 64 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.5 0 11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3L32 352c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64 64 64C46.3 64 32 49.7 32 32zM160 384l64 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThumbtackSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352c9.8-.4 18.9-5.3 24.6-13.3c6-8.3 7.7-19.1 4.4-28.8l-1-3c-13.8-41.5-42.8-74.8-79.5-94.7L418.5 64 448 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l29.5 0-6.1 79.5L38.8 5.1zM324.9 352L177.1 235.6c-20.9 18.9-37.2 43.3-46.5 71.3l-1 3c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3l164.9 0zM288 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThumbsUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2l144 0c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48l-97.5 0c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3l0-38.3 0-48 0-24.9c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32L0 224c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThumbsDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2l144 0c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48l-97.5 0c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7l0 38.3 0 48 0 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L32 96C14.3 96 0 110.3 0 128L0 352c0 17.7 14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 382.1l0-88.8c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4l-88.8 0L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTextWidth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 128l0-32 128 0 0 128-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128 128 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5-21.5-48-48-48L224 32 48 32C21.5 32 0 53.5 0 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 192 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 32-192 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTextSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96 503 96 497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32L376.1 32l-.3 0L204.5 32c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96l116.7 0L301.3 210.8l-94.5-74.1zM243.3 416L192 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-42.2 0 17.6-62.1L272.9 311 243.3 416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTextHeight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 128l0-32 64 0 0 320-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320 64 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5-21.5-48-48-48L160 32 48 32C21.5 32 0 53.5 0 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32zM502.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 192-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-192 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTerminal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTents(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5L608 352c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7l-80 0-28.2 0c-12.1 0-23.2-6.8-28.6-17.7L306.7 293.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9L288 480c0 17.7-14.3 32-32 32l-16 0L32 512c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTentArrowsDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L488 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTentArrowTurnLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTentArrowLeftRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTentArrowDownToLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l127.6 0 .7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448l80 0L402.7 325.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9L384 448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTengeSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32l160 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0 0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224L32 224c-17.7 0-32-14.3-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureThreeQuarters(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c-26.5 0-48 21.5-48 48l0 164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5L208 112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 164.4c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 178.7c18.6 6.6 32 24.4 32 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c-26.5 0-48 21.5-48 48l0 164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5L208 112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 164.4c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 50.7c18.6 6.6 32 24.4 32 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureLow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM144 64c-26.5 0-48 21.5-48 48l0 164.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5L192 112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112l0 164.4c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6L32 112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 50.7c18.6 6.6 32 24.4 32 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureHigh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5L96 112zM144 0C82.1 0 32 50.2 32 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L256 112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c-26.5 0-48 21.5-48 48l0 164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5L208 112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 164.4c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 114.7c18.6 6.6 32 24.4 32 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c-26.5 0-48 21.5-48 48l0 164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5L208 112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 164.4c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 210.7c18.6 6.6 32 24.4 32 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L112 112zM160 0C98.1 0 48 50.2 48 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L272 112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L128 112zM176 0C114.1 0 64 50.1 64 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L288 112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L192 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160l32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 288c0 17.7 14.3 32 32 32s32-14.3 32-32l0-288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L128 112zM176 0C114.1 0 64 50.1 64 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L288 112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64l-32 0 0-288c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 288-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTeeth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 75 43 32 96 32l384 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 128zm176 48l0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48l0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56c0-26.5-21.5-48-48-48zM48 208l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24zm176 48c26.5 0 48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24c0 26.5 21.5 48 48 48zm80-176l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24c0 26.5 21.5 48 48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTeethOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32C43 32 0 75 0 128l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-53-43-96-96-96L96 32zM224 96c26.5 0 48 21.5 48 48l0 56c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-56c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 56c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-56zM96 128c26.5 0 48 21.5 48 48l0 24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-24c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-24zM96 480l384 0c53 0 96-43 96-96l0-32c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48zm80-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48zm80-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTaxi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-17.7 0-32 14.3-32 32l0 32 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288L0 432l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 320 0 0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 0-144c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1l0-.2 0-32c0-17.7-14.3-32-32-32L192 0zM165.4 128l181.2 0c13.6 0 25.7 8.6 30.2 21.4L402.9 224l-293.8 0 26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTarp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 128c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32l128 0 0-160zM448 448L576 320l-128 0 0 128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTarpDroplet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128l133.5 0c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64L512 128c35.3 0 64 28.7 64 64l0 160-128 0c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64zM448 512l0-128 128 0L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTape(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-163.2 0zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTags(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5L0 80C0 53.5 21.5 32 48 32l149.5 0c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTachographDigital(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm32 64l224 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTablets(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M614.3 247c-5.2 7.9-16.2 8.5-22.9 1.8L391.2 48.6c-6.7-6.7-6.2-17.8 1.8-22.9C418.1 9.4 447.9 0 480 0c88.4 0 160 71.6 160 160c0 32.1-9.4 61.9-25.7 87zM567 294.3c-25 16.3-54.9 25.7-87 25.7c-88.4 0-160-71.6-160-160c0-32.1 9.4-61.9 25.7-87c5.2-7.9 16.2-8.5 22.9-1.8L568.8 271.4c6.7 6.7 6.2 17.8-1.8 22.9zM301.5 368c9.5 0 16.9 8.2 15 17.5C301.1 457.8 236.9 512 160 512S18.9 457.8 3.5 385.5c-2-9.3 5.5-17.5 15-17.5l283.1 0zm0-32L18.5 336c-9.5 0-16.9-8.2-15-17.5C18.9 246.2 83.1 192 160 192s141.1 54.2 156.5 126.5c2 9.3-5.5 17.5-15 17.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTablet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM176 432l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTabletScreenButton(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64L64 64l0 320 320 0 0-320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTabletButton(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 256l0-96 160 0 0 96L64 256zm0 64l160 0 0 96L64 416l0-96zm224 96l0-96 160 0 0 96-160 0zM448 256l-160 0 0-96 160 0 0 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTableTennisPaddleBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 288c-50.1 0-93.6 28.8-114.6 70.8L68.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C471.8 297.6 445 288 416 288zM49.3 151.9L290.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3l-2.7 0c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L88.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32C3.1 464.3-.3 455.7 0 446.9s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8C45.5 285.5 32 252.9 32 219l0-2.7c0-22.8 6.1-44.9 17.3-64.3zM416 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTableList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 0l0 64 64 0 0-64L64 96zm384 0L192 96l0 64 256 0 0-64zM64 224l0 64 64 0 0-64-64 0zm384 0l-256 0 0 64 256 0 0-64zM64 352l0 64 64 0 0-64-64 0zm384 0l-256 0 0 64 256 0 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTableColumns(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 64l0 256 160 0 0-256L64 160zm384 0l-160 0 0 256 160 0 0-256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTableCells(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 64l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm240 0l0 64-88 0 0-64 88 0zM64 224l88 0 0 64-88 0 0-64zm232 0l0 64-88 0 0-64 88 0zm64 0l88 0 0 64-88 0 0-64zM152 352l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm240 0l0 64-88 0 0-64 88 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTableCellsRowUnlock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 224l0 64 88 0 0-64-88 0zm232 0l-88 0 0 64 88 0 0-64zM152 352l-88 0 0 64 88 0 0-64zm56 0l0 64 88 0 0-64-88 0zm288-80l0 48 32 0 32 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTableCellsRowLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 224l0 64 88 0 0-64-88 0zm232 0l-88 0 0 64 88 0 0-64zM152 352l-88 0 0 64 88 0 0-64zm56 0l0 64 88 0 0-64-88 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTableCellsLarge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96l0 128-160 0 0-128 160 0zm0 192l0 128-160 0 0-128 160 0zM224 224L64 224 64 96l160 0 0 128zM64 288l160 0 0 128L64 416l0-128zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTableCellsColumnLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zm208 0l0 64 88 0 0-64-88 0zm240 0l-88 0 0 64 88 0 0-64zM208 224l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaT(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l128 0 0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSyringe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4l-88.8 0L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-88.8c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSynagogue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166l0 114.1L480 512l-16 0-112 0 0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96-112 0-16 0 0-231.9L160 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512l0-267.5 28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1L640 448c0 35.3-28.7 64-64 64l-64 0zM128 244.5L128 512l-64 0c-35.3 0-64-28.7-64-64L0 316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSwatchbook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0L160 0c17.7 0 32 14.3 32 32l0 384c0 53-43 96-96 96s-96-43-96-96L0 32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9l0-262 75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192L480 320c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-297.2 0zM128 64L64 64l0 64 64 0 0-64zM64 192l0 64 64 0 0-64-64 0zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuperscript(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80l0 80c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-128zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l15.3 0 89.6 128L47.3 384 32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-15.3 0L215.1 256l89.6-128 15.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64L32 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSunPlantWilt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6l0-53.4c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80l0 21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6l0-21.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 8 0 168L32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-104 0 0-168 0-8 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuitcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 0 32 0 352-256 0 0-352 0-32zM64 96l32 0 0 384-32 0c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64zM448 480l-32 0 0-384 32 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuitcaseRolling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 56c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8l0 72-96 0 0-72zm176 72l-32 0 0-72c0-30.9-25.1-56-56-56L152 0C121.1 0 96 25.1 96 56l0 72-32 0c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32l128 0c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64zM112 224l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuitcaseMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40 0 32 0 352 256 0 0-352 0-32 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zM96 96L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l32 0L96 96zM416 480l32 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-32 0 0 384zM224 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSubscript(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l15.3 0 89.6 128L47.3 384 32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-15.3 0L215.1 256l89.6-128 15.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64L32 64zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368l0 80c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStroopwafel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStrikethrough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-209.9 0-.4-.1-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3c0 0 0 0 0 0s0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6c0 0 0 0 0 0l.2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1l-75.7 0c7 5.6 11.4 11.2 13.9 17.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStreetView(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64l0 48c0 17.7 14.3 32 32 32l1.8 0 11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5l38.7 0c16.3 0 30-12.3 31.8-28.5L318.2 304l1.8 0c17.7 0 32-14.3 32-32l0-48c0-35.3-28.7-64-64-64l-64 0zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0L109.6 0C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9c0 0 0 0-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3L448 384l-320 0 0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L64 384l0 64c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-64 0-131.4c-4 1-8 1.8-12.3 2.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStoreSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68 0-17.1 0-131.4c-4 1-8 1.8-12.3 2.3c0 0 0 0-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3l0 100.3L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0L141.6 0c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm73.4 218.1c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384l0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L96 384l0 64c0 35.3 28.7 64 64 64l320 0c12.9 0 24.8-3.8 34.9-10.3L365.5 384 160 384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStopwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 34.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6L256 64l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L224 0 176 0zm72 192l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStopwatch20(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 34.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6L256 64l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L176 0zM288 204c28.7 0 52 23.3 52 52l0 96c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-96c0-28.7 23.3-52 52-52zm-12 52l0 96c0 6.6 5.4 12 12 12s12-5.4 12-12l0-96c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5l0 2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9l43.8 0c11 0 20 9 20 20s-9 20-20 20l-64 0c-11 0-20-9-20-20l0-15.7c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8l0-2.2c0-6.9-5.6-12.5-12.5-12.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStethoscope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1 96 192c0 53 43 96 96 96s96-43 96-96l0-120.9-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1L352 192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112l0-70.7c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3l0 70.7c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192L32 71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSterlingSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4L48 224l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L88.5 416l.7-1.1C104.1 390 112 361.5 112 332.5l0-44.5 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0 0-63.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarOfLife(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 140.9 122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.6 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1 304 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-140.9L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4L208 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarOfDavid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M404.2 309.5L383.1 344l42.3 0-21.1-34.5zM371.4 256l-54-88-122.8 0-54 88 54 88 122.8 0 54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4l-109.8 0-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400 53.4 400C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112l109.8 0 56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112l109.8 0c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168l-42.3 0zM283 112L256 68l-27 44 54 0zM128.9 168l-42.3 0 21.1 34.5L128.9 168zM107.8 309.5L86.6 344l42.3 0-21.1-34.5zM229 400l27 44 27-44-54 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8 288 0zM429.9 512c1.1 .1 2.1 .1 3.2 0l-3.2 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarHalfStroke(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L288.1 86.9l-.1 .3 0 289.2zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarAndCrescent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStapler(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 299.3l0 4.7 0 128c0 26.5-21.5 48-48 48l-80 0-64 0L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0 0-48L96 368c-17.7 0-32-14.3-32-32l0-116.6L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304l0-16L128 230.9l0 73.1 320 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStamp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2L112 256C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3L32 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-50.7c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112l-33.8 0c-29.9 0-54.2-24.3-54.2-54.2zM416 416l0 32L96 448l0-32 320 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStairs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32l96 0 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStaffSnake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M222.6 43.2l-.1 4.8L288 48c53 0 96 43 96 96s-43 96-96 96l-40 0 0-80 40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0-28 0-4.5 144 40.5 0c53 0 96 43 96 96s-43 96-96 96l-16 0 0-80 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-43 0-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31L136 464c-22.1 0-40-17.9-40-40s17.9-40 40-40l36 0-1-32-19 0c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7l0 94.7c0 8.8 7.2 16 16 16l16.5 0L164 128l-28 0-13.4 0c-9 18.9-28.3 32-50.6 32l-16 0c-30.9 0-56-25.1-56-56S25.1 48 56 48l8 0 8 0 89.5 0-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM160 160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l40 40-71 71C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l71-71 40 40c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-144c0-8.8-7.2-16-16-16l-144 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareShareNodes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareRootVariable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M282.6 78.1c8-27.3 33-46.1 61.4-46.1l200 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L344 96 238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l45.6 0c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarePollVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 192c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192zM320 288c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarePollHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarePhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarePhoneFlip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarePersonConfined(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56l0 102.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7l0-58.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarePen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareParking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM192 256l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0 64zm48 64l-48 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-120c0-22.1 17.9-40 40-40l72 0c53 0 96 43 96 96s-43 96-96 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareNfi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm75.7 64.6C68.8 162.5 64 168.8 64 176l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-102.2 66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 102.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176l0 64 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-32 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 200l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM336 152l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0H512V512H0V0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144l256 0c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4 384 336c0 17.7-14.3 32-32 32L96 368c-17.7 0-32-14.3-32-32l0-125.6 136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareCaretUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareCaretRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareCaretLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareCaretDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareBinary(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 4c-24.3 0-44 19.7-44 44l0 48c0 24.3 19.7 44 44 44l32 0c24.3 0 44-19.7 44-44l0-48c0-24.3-19.7-44-44-44l-32 0zm-4 44c0-2.2 1.8-4 4-4l32 0c2.2 0 4 1.8 4 4l0 48c0 2.2-1.8 4-4 4l-32 0c-2.2 0-4-1.8-4-4l0-48zm140-44c-11 0-20 9-20 20c0 9.7 6.9 17.7 16 19.6l0 76.4c0 11 9 20 20 20s20-9 20-20l0-96c0-11-9-20-20-20l-16 0zM132 296c0 9.7 6.9 17.7 16 19.6l0 76.4c0 11 9 20 20 20s20-9 20-20l0-96c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20zm96 24l0 48c0 24.3 19.7 44 44 44l32 0c24.3 0 44-19.7 44-44l0-48c0-24.3-19.7-44-44-44l-32 0c-24.3 0-44 19.7-44 44zm44-4l32 0c2.2 0 4 1.8 4 4l0 48c0 2.2-1.8 4-4 4l-32 0c-2.2 0-4-1.8-4-4l0-48c0-2.2 1.8-4 4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareArrowUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l94.1 0L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135L288 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24l-152 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSprayCan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0l64 0c17.7 0 32 14.3 32 32l0 96L96 128l0-96c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96l128 0c53 0 96 43 96 96l0 208c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSprayCanSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32l0 96 128 0 0-96c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96L0 464c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-208c0-53-43-96-96-96L96 160zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSplotch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpinner(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpider(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1l0-14.1c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.8c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160l0 14.1-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpellCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224l90.7 0 5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160l-37.3 0L112 115.2 130.7 160zM256 32l0 96 0 96c0 17.7 14.3 32 32 32l80 0c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80L288 0c-17.7 0-32 14.3-32 32zm96 64l-32 0 0-32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0-32zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpaghettiMonsterFlying(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1c0 0 0 0 0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192l9.9 0c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480L288 480l-20.1 0C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192l9.9 0c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSort(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSolarPanel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384l217 0 0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64 217 0c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0L122.2 0zM260.9 64l118.2 0 10.4 104-139 0L260.9 64zM202.3 168l-100.8 0L122.2 64l90.4 0L202.3 168zM91.8 216l105.6 0L187.1 320 71 320 91.8 216zm153.9 0l148.6 0 10.4 104-169.4 0 10.4-104zm196.8 0l105.6 0L569 320l-116 0L442.5 216zm96-48l-100.8 0L427.3 64l90.4 0 31.4-6.3L517.8 64l20.8 104z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSocks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6l0-144L128 96l0 144c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64l160 0 0-16c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0L176 0c-26.5 0-48 21.5-48 48l0 16zM320 96l0 144c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304l0-208L320 96zM512 64l0-16c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 16 192 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSoap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96s43-96 96-96l88.4 0c-15.2-17-24.4-39.4-24.4-64L96 192c-53 0-96 43-96 96L0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96l0-128c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64l192 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0-160 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowplow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.9 64l68.6 160L256 224l-64-64 0-96 106.9 0zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0L176 0c-26.5 0-48 21.5-48 48l0 112-32 0c-17.7 0-32 14.3-32 32l0 106.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112l256 0c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48l42.8 0 0 50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7l0-82.7 0-84.8L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40l0 52.8-64 0 0-31.3c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l256 0zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowman(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L408 160.2l0-40.2c0-13.3 10.7-24 24-24s24 10.7 24 24l0 19.6 22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9l-149.3 0c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6 56 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40.2L152.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C164 127.2 160 112.1 160 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24l0 3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9l0-3.2c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowflake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c17.7 0 32 14.3 32 32l0 30.1 15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49 0 70.3 61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7l0 70.3 49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15 0 30.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-30.1-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49 0-70.3-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3l0-70.3L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15L192 32c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmoking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32l0 11c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2l0 11c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-11c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43l0-11c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256l0-11c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2l0-11c0-17.7 14.3-32 32-32s32 14.3 32 32l0 11c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1l0 11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64l352 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32L64 512c-35.3 0-64-28.7-64-64l0-32zm224 0l0 32 160 0 0-32-160 0zm288-64c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 144c0 79.5 64.5 144 144 144l123.3 0c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32l27.3 0c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368l-336 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24L96 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c13.3 0 24-10.7 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSliders(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSleigh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l0 160c0 53 43 96 96 96l0 32 64 0 0-32 192 0 0 32 64 0 0-32c53 0 96-43 96-96l0-96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0-32 0c-17.7 0-32 14.3-32 32l0 41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7l-9 0L32 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 8c0 13.3-10.7 24-24 24L64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l488 0c48.6 0 88-39.4 88-88l0-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1l0 64c0 26.5 21.5 48 48 48l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 48 0c26.5 0 48-21.5 48-48l0-64c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkullCrossbones(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 128c0 44.4-25.4 83.5-64 106.4l0 21.6c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-21.6c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6C1.9 308.7-4.5 289.5 3.4 273.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSitemap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-8 0 0 40 152 0c30.9 0 56 25.1 56 56l0 32 8 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l8 0 0-32c0-4.4-3.6-8-8-8l-152 0 0 40 8 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l8 0 0-40-152 0c-4.4 0-8 3.6-8 8l0 32 8 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l8 0 0-32c0-30.9 25.1-56 56-56l152 0 0-40-8 0c-26.5 0-48-21.5-48-48l0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96l0 192-64 0 0-24c0-30.9-25.1-56-56-56l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c4.4 0 8 3.6 8 8l0 24-80 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0 224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0-24c0-4.4 3.6-8 8-8l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0c-30.9 0-56 25.1-56 56l0 24-64 0 0-192zM480 416l0-32L32 384l0 32c0 53 43 96 96 96l256 0c53 0 96-43 96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSimCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0L242.7 0c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32l0 32 64 0 0-64-32 0zM64 352l80 0 96 0 80 0 0-64-80 0-96 0-80 0 0 64zM320 224c0-17.7-14.3-32-32-32l-32 0 0 64 64 0 0-32zM160 192l0 64 64 0 0-64-64 0zM288 448c17.7 0 32-14.3 32-32l0-32-64 0 0 64 32 0zM160 384l0 64 64 0 0-64-64 0zM64 416c0 17.7 14.3 32 32 32l32 0 0-64-64 0 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignsPost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32L64 32C46.3 32 32 46.3 32 64l0 64c0 17.7 14.3 32 32 32l377.4 0c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7L288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32l-160 0 0-32-64 0 0 32L70.6 224c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7L448 352c17.7 0 32-14.3 32-32l0-64zM288 480l0-96-64 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignature(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92l0 71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-83.6 0 18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96s-96 43-96 96l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5l0-71.9c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l40.3 0c-.2-2.8-.3-5.6-.3-8.5L64 368l-40 0zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24l-310.1 0c-6.7 16.3-14.2 32.3-22.3 48L616 416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 0c17.7 0 32 14.3 32 32l0 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352c0-17.7 14.3-32 32-32zM352 224l0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32zM96 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignHanging(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0c17.7 0 32 14.3 32 32l0 32 352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0 0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352-32 0C14.3 128 0 113.7 0 96S14.3 64 32 64l32 0 0-32C64 14.3 78.3 0 96 0zm96 160l256 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShuttleSpace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96 2 0zM352 128L245.2 63.9C210.4 43 170.6 32 130 32l-2 0 0 96 224 0zM96 128l0-96L80 32C53.5 32 32 53.5 32 80l0 48 8 0c-22.1 0-40 17.9-40 40l0 16L0 328l0 16c0 22.1 17.9 40 40 40l-8 0 0 48c0 26.5 21.5 48 48 48l16 0 0-96 8 0c26.2 0 49.4-12.6 64-32l288 0c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160l-288 0c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6l0 24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4l0-87.1c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShuffle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-32 0c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-32 0c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShrimp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64l1 0c3.7 88.9 77 160 167 160l56 0 0-192-24 0L88.8 128 64 128c-17.7 0-32-14.3-32-32s14.3-32 32-32l400 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32zM224 456c0 13.3 10.7 24 24 24l72 0 0-72.2-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3l0 69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128l-16 0 0 192 18.3 0c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-316.1zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M36.8 192l566.3 0c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0L121.7 0c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224l0 160 0 80c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-80 0-160-64 0 0 160-192 0 0-160-64 0zm448 0l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShopSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43L576 224l-64 0 0 152L384 275.7l0-51.7-64 0 0 1.5L277.2 192l325.9 0c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0L121.7 0c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192l85 0L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384l-192 0 0-160-64 0 0 160 0 80c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-65.5-64-50.4 0 35.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShopLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M36.8 192l412.8 0c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0L121.7 0c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224l-64 0 0 160-192 0 0-160-64 0 0 160 0 80c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-80 0-32 0-128zm144 16c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShoePrints(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0C352.3 0 256 32 256 32l0 128c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32l0 128s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShirt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0l12.6 0c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7 480 448c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-250.3-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0l12.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32c0-17.7 14.3-32 32-32L352 0c17.7 0 32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 128 44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240l0-128c0-26.5 21.5-48 48-48l48 0 0-32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7l0-90.7-256 0 0 90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShieldVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShieldHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShieldHalved(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8l0 378.1C394 378 431.1 230.1 432 141.4L256 66.8s0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShieldDog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64l0-64 44.2 0c12.1 0 23.2 6.8 28.6 17.7L320 192l64 0c8.8 0 16 7.2 16 16l0 32c0 44.2-35.8 80-80 80l-48 0 0 50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160l40 0 8 0 0 32 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShieldCat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4l.2 0c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4l48 0c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3l.2 0c5.8 0 10.4 4.7 10.4 10.4L352 272c0 53-43 96-96 96s-96-43-96-96l0-117.6zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShekelSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96l128 0c35.3 0 64 28.7 64 64l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-70.7-57.3-128-128-128L32 32zM320 480c70.7 0 128-57.3 128-128l0-288c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 288c0 35.3-28.7 64-64 64l-128 0 0-224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l160 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSheetPlastic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448c0 35.3 28.7 64 64 64l160 0 0-128c0-17.7 14.3-32 32-32l128 0 0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384l-128 0 0 128L384 384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M307 34.8c-11.5 5.1-19 16.6-19 29.2l0 64-112 0C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l96 0 0 64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShareNodes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShareFromSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 224l-46.5 0c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8l-2.5 0c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144l80 0 0-61.3C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2l-3.7 0c-17.7 0-32-14.3-32-32l0-64zM80 96c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShapes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2l192 0c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312l0 144c0 22.1 17.9 40 40 40l144 0c22.1 0 40-17.9 40-40l0-144c0-22.1-17.9-40-40-40l-144 0c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaServer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSeedling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0l32 0c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64l32 0c123.7 0 224 100.3 224 224l0 32 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160C100.3 320 0 219.7 0 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSection(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C22.3 194.2 6.5 215.1 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31c0 0 0 0 0 0l3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2c0 0 0 0 0 0c-4.3-1.5-8.5-2.9-12.3-4.2C25.3 420 7.2 429.1 1.6 445.8s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6c0 0 0 0 0 0l.2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5l-.6-.2-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0L141.3 0C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64zM160 88l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScroll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80l0 48c0 17.7 14.3 32 32 32l16 0 48 0 0-80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48l0 304c0 35.3 28.7 64 64 64s64-28.7 64-64l0-5.3c0-32.4 26.3-58.7 58.7-58.7L480 320l0-192c0-53-43-96-96-96L112 32zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16l-245.3 0c-14.7 0-26.7 11.9-26.7 26.7l0 5.3c0 53-43 96-96 96l176 0 96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScrollTorah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 480L96 32C96 14.3 74.5 0 48 0S0 14.3 0 32L0 480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32L128 32l0 448 384 0 0-448zM592 0c-26.5 0-48 14.3-48 32l0 448c0 17.7 21.5 32 48 32s48-14.3 48-32l0-448c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3l56.7 0 31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180l56.7 0c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3L369 332l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332l-56.7 0c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332l-42.4 0L320 368.4zM254.5 256l30.3 52 70.4 0 30.3-52-30.3-52-70.4 0-30.3 52zm144.9 23.8L383 308l32.8 0-16.4-28.2zM415.8 204L383 204l16.4 28.2L415.8 204zM320 143.6L298.8 180l42.4 0L320 143.6zM224.2 204l16.4 28.2L257 204l-32.8 0zM257 308l-16.4-28.2L224.2 308l32.8 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScrewdriver(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19l0 54.1-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192l54.1 0c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScrewdriverWrench(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4l54.1 0 109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109 0-54.1c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7L352 176c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l208 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 208 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4zM96 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM96 320l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchoolLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96 592 96c26.5 0 48 21.5 48 48l0 128c0-61.9-50.1-112-112-112s-112 50.1-112 112l0 24.6c-19.1 11.1-32 31.7-32 55.4l-63.7 0-.3 0c-35.3 0-64 28.7-64 64l0 96 64 0s0 0 0 0L48 512c-26.5 0-48-21.5-48-48L0 144c0-26.5 21.5-48 48-48l118.3 0L302.2 5.4zM80 208l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchoolFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0L400 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-79.3 0 89.6 64L512 160c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-176 0 0-112c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 112L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l101.7 0L256 95.5 256 32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zm368 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zm384 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchoolCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l272 0s0 0 0 0l-64 0 0-96c0-35.3 28.7-64 64-64l.3 0 .5 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 144c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4zM96 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0 128l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchoolCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l272 0s0 0 0 0l-64 0 0-96c0-35.3 28.7-64 64-64l.3 0 .5 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 144c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4zM96 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0 128l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchoolCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l272 0s0 0 0 0l-64 0 0-96c0-35.3 28.7-64 64-64l.3 0 .5 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 144c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4zM96 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0 128l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScaleUnbalanced(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2L288 480c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-294.7c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288l-144.9 0zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416 56.7 416l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScaleUnbalancedFlip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2L352 480c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288L128 163.8 55.6 288l144.9 0zM128 384C65.1 384 12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416l144.9 0L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScaleBalanced(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L398.4 96c-5.2 25.8-22.9 47.1-46.4 57.3L352 448l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-23.5-10.3-41.2-31.6-46.4-57.3L128 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288l144.9 0L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320l144.9 0L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSatellite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSatelliteDish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSailboat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6l-224 0c-8.8 0-16-7.2-16-16l0-320zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5l0 224c0 8.8-7.2 16-16 16L80 352c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384l533.8 0c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512L133 512C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSackXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96l128 0 47.4-71.1C374.5 14.2 366.9 0 354.1 0L157.9 0c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32l-128 0c-3.8 2.5-8.1 5.3-13 8.4c0 0 0 0 0 0s0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSackDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96L192 96 144.6 24.9C137.5 14.2 145.1 0 157.9 0L354.1 0c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128l128 0c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96L96 512c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4c0 0 0 0 0 0s0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15c0 0 0 0 0 0l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaS(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0s0 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRupiahSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l80 0c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320 64 320l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 288 0 64zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L64 96l0 160zm256-96l80 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-48 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128 0-160c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48l-48 0 0 96 48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRupeeSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l80 0c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320 64 320l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 288 0 64zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L64 96l0 160zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0s0 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9c0 0 0 0 0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1c0 0 0 0 0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRuler(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRulerVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0L208 0c26.5 0 48 21.5 48 48l0 48-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRulerHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRulerCombined(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 64l32 0 24 0 0 24 0 88 0 80 0 80 0 88 0 24-24 0-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-40-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-32-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-32-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-40-8 0C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0l416 0 0 384-416 0 0-384zM640 88c0 13.3-10.7 24-24 24l-8 0 0 40 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 32 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 32 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 40 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0-24 0 0-24 0-88 0-80 0-80 0-88 0-24 24 0 32 0c13.3 0 24 10.7 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRubleSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32C78.3 32 64 46.3 64 64l0 192-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-32 112 0c79.5 0 144-64.5 144-144s-64.5-144-144-144L96 32zM240 256l-112 0 0-160 112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoute(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5L320 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96 43 96 96s-43 96-96 96l-276.4 0c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2L416 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-53 0-96-43-96-96s43-96 96-96l39.8 0c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRotate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8c-5.9 16.7-24.2 25.4-40.8 19.5s-25.4-24.2-19.5-40.8C55.6 150.7 73.2 122 97.6 97.6c87.2-87.2 228.3-87.5 315.8-1L455 55c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 128c0 13.3-10.7 24-24 24l-8.4 0c0 0 0 0 0 0L344 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l41.1-41.1c-62.6-61.5-163.1-61.2-225.3 1zM16 312c0-13.3 10.7-24 24-24l7.6 0 .7 0L168 288c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-41.1 41.1c62.6 61.5 163.1 61.2 225.3-1c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.2 87.2-228.3 87.5-315.8 1L57 457c-6.9 6.9-17.2 8.9-26.2 5.2S16 449.7 16 440l0-119.6 0-.7 0-7.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRotateRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRotateLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.5 224L40 224c-13.3 0-24-10.7-24-24L16 72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8L48.5 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRocket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2l0 82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-107.2c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRobot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0c17.7 0 32 14.3 32 32l0 64 120 0c39.8 0 72 32.2 72 72l0 272c0 39.8-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72l0-272c0-39.8 32.2-72 72-72l120 0 0-64c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224l16 0 0 192-16 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-16 0 0-192 16 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32l-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480L256 480l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 201.4 0c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32L320 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm64 192l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoadSpikes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256l0-139.2c0-15.8 20.5-22 29.3-8.9L320 256l0-139.2c0-15.8 20.5-22 29.3-8.9L448 256l0-139.2c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7L512 352l-64 0-64 0-64 0-64 0-64 0L64 352l0-235.2zM32 384l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoadLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32l-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480L288 480l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 32 0 0-128c0-23.7 12.9-44.4 32-55.4l0-24.6c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32L352 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm64 192l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoadCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.2 32L288 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 74.8 0c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8l0-42.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32l0 64L86.6 480C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoadCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.2 32L288 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 74.8 0c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8l0-42.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32l0 64L86.6 480C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoadCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.2 32L288 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 74.8 0c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8l0-42.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32l0 64L86.6 480C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoadBridge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0L608 0c17.7 0 32 14.3 32 32l0 448c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64zM480 40c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24zM32 96l256 0 0 64-40 0 0 64 40 0 0 96c-53 0-96 43-96 96l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-53-43-96-96-96l0-96 72 0 0-64-40 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64l-80 0 0 64 80 0 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoadBarrier(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-181.7L149.2 96 64 96l0-32c0-17.7-14.3-32-32-32zM405.2 96l-74.3 0-5.4 10.7L234.8 288l74.3 0 5.4-10.7L405.2 96zM362.8 288l74.3 0 5.4-10.7L533.2 96l-74.3 0-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288l74.3 0 5.4-10.7L277.2 96l-74.3 0zm288 192l85.2 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 53.7L490.8 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8l0 96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304l0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRightToBracket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRightLong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRightLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 96l320 0 0-64c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-64L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32l-320 0 0 64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64 320 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRightFromBracket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRibbon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.2 322.8s0 0 0 0l-133.9-146s0 0 0 0L146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65l0-29.5c0-19-5.6-37.5-16.1-53.3L327.8 35.6C312.9 13.4 287.9 0 261.2 0l-76 0c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8L64 164c0 23.2 8.4 45.6 23.6 63.1l56 64.2s0 0 0 0l83.3 95.6s0 0 0 0l91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zM205.2 410.6l-83.3-95.6L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRetweet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0c-17.7 0-32-14.3-32-32l0-128 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96l112 0zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-128c0-53-43-96-96-96L304 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRestroom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-154.8c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128l8 0c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4L200 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM320 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480l0-96-17.8 0c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1L584 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-16 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRepublican(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 192C0 103.6 71.6 32 160 32l224 0c88.4 0 160 71.6 160 160l0 64L0 256l0-64zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160l192 0 96 0 32 0 64 0 32 0 0 32 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48-32 0 0 32 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64-192 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64 0-96 128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReply(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205 34.8c11.5 5.1 19 16.6 19 29.2l0 64 112 0c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96l-96 0 0 64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReplyAll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-64 32 0c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176l-48 0 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRepeat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96l160 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32l0 32L160 64C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96l-160 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 160 0c88.4 0 160-71.6 160-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegistered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24l88 0c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288 208 288l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112zm48 88l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRecycle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448l0 32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 32 96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L182 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRectangleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRectangleList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRectangleAd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328l-90.3 0-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280l42.3 0L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9l0-28.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96 0 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRecordVinyl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReceipt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8l0 464c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488L0 24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 144zM80 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 336c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 240z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRankingStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-128 0zM32 320c-17.7 0-32 14.3-32 32L0 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L32 320zm416 96l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRainbow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96C178.6 96 64 210.6 64 352l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96C0 175.3 143.3 32 320 32s320 143.3 320 320l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-70.7 57.3-128 128-128s128 57.3 128 128l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-35.3-28.7-64-64-64zM160 352l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-123.7 100.3-224 224-224s224 100.3 224 224l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRadio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192l0 4L0 304 0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-229.5 0L494.8 47zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 336c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRadiation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaR(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 288 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 95.3 0L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144L64 32zM176 256L64 256 64 96l112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuoteRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 296c0 66.3-53.7 120-120 120l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72zm-256 0c0 66.3-53.7 120-120 120l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuoteLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuestion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQrcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 96l0 64 64 0 0-64L64 96zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm64 16l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm80 64l-64 0 0 64 64 0 0-64zM256 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-160zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQ(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPuzzlePiece(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8c0 12.8 10.4 23.2 23.2 23.2l56.8 0c26.5 0 48 21.5 48 48l0 56.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2L384 464c0 26.5-21.5 48-48 48l-56.8 0c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2L48 512c-26.5 0-48-21.5-48-48L0 343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256C10.4 256 0 245.6 0 232.8L0 176c0-26.5 21.5-48 48-48l120.8 0c12.8 0 23.2-10.4 23.2-23.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPumpSoap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32l0 96 128 0 0-32 60.1 0c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4L256 32c0-17.7-14.3-32-32-32L160 0c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512l186.4 0c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7l-149.1 0zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPumpMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32l0 96 128 0 0-32 60.1 0c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4L256 32c0-17.7-14.3-32-32-32L160 0c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512l186.4 0c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7l-149.1 0zM216 280l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C92.7 0 64 28.7 64 64l0 96 64 0 0-96 226.7 0L384 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0L128 0zM384 352l0 32 0 64-256 0 0-64 0-16 0-16 256 0zm64 32l32 0c17.7 0 32-14.3 32-32l0-96c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64l0 96c0 17.7 14.3 32 32 32l32 0 0 64c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-64zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrescription(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32L0 192l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 50.7 0 128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0L32 0zM176 160L64 160l0-96 112 0c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrescriptionBottle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64L0 32zm32 96l320 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-32 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 384l0-64 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 288l0-64 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 192l0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrescriptionBottleMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64L0 32zm32 96l320 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zM160 240l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPowerOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPoop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32l5.5 0c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48l13.7 0c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72L72 512c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72l13.7 0C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64l16.2 0c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPoo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80L160 128c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48L104 240c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72l-13.7 0c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64l-5.5 0c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3l167.4 0c6.8 0 12.3 5.5 12.3 12.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPooStorm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 21.7-8.5 37.2-21.9 47.6c-13.8 10.8-34 17-57.8 17L128 112c-35.3 0-64 28.7-64 64c0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 40.9 28 75.4 65.8 85.2c-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L285.7 320l18.3 0c20.4 0 38.5 12.9 45.3 32.1c3.7 10.6 3.5 21.8 0 31.9l10.7 0c48.6 0 88-39.4 88-88c0-43.6-31.7-79.8-73.3-86.8c5.9-9.7 9.3-21.1 9.3-33.2c0-35.3-28.7-64-64-64l-1.4 0c.9-5.4 1.4-10.9 1.4-16.6c0-48.7-36.1-88.9-83.1-95.2zm45.1 227.4c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPodcast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlusMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112L48 144c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0 0 112c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0 0-112zM0 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448c-17.7 0-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2C297 398 352 333.4 352 256l0-32c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlugCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlugCirclePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlugCircleMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlugCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlugCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlugCircleBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380 376 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlateWheat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 32c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80l0-16c0-8.8 7.2-16 16-16zM56 64l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80l0-16zM400 32c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80l0-16c0-8.8 7.2-16 16-16zm80 160l0 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80zm-96 16l0 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320l456.4 0c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446l0 2c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-2c-48.2-9-86.3-48.2-92.5-98.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlantWilt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56l0 13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1l0-13C464 53.7 410.3 0 344 0S224 53.7 224 120l0 21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120l0 13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1l0-13c0-30.9 25.1-56 56-56s56 25.1 56 56l0 32 0 200c0 17.7 14.3 32 32 32s32-14.3 32-32l0-200 0-32 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6l0 56.7c0 10.9-10.7 18.6-21.1 15.2L320 320l0 80 57.6 43.2c4 3 6.4 7.8 6.4 12.8l0 42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14l0-42c0-5 2.4-9.8 6.4-12.8L192 400l0-80L21.1 377C10.7 380.4 0 372.7 0 361.8l0-56.7c0-10.7 5.3-20.7 14.2-26.6L192 160l0-66.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M514.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-73.8 0L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L238.1 161.3 197.8 20.4C194.9 10.2 202.6 0 213.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L397.7 192l116.6 0zM41.5 128.7l321 252.9L297.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L144 320l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L64 256 32.5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-6.2 4-11.4 9.5-13.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 84.6 101.8 58.2C418 247.6 416 259.6 416 272l0 24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1l0 70.9 57.6 43.2c4 3 6.4 7.8 6.4 12.8l0 24 0 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14l0-42c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8l0-65.5c0-5.7 3.1-11 8.1-13.9L192 178.3l0-84.6zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneDeparture(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2l137.7 0c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48l-57.4 0c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448c-17.7 0-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c-35 0-64 59.5-64 93.7l0 84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9l0 65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3l0-84.6C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c-35 0-64 59.5-64 93.7l0 84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9l0 65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3l0-84.6C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c-35 0-64 59.5-64 93.7l0 84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9l0 65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3l0-84.6C320 59.5 292 0 256 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneArrival(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0l40.1 0c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14.1-9.3-22.5zM32 448l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaceOfWorship(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 109.3l0 108.3L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2L160 512l96 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 96 0 0-228.8c0-16.9-8.8-32.5-23.3-41.2L416 217.6l0-108.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4L0 464c0 26.5 21.5 48 48 48l80 0 0-238.4L24.9 330.3zM592 512c26.5 0 48-21.5 48-48l0-91.6c0-17.5-9.5-33.6-24.9-42.1L512 273.6 512 512l80 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPizzaSlice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPills(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 96c-26.5 0-48 21.5-48 48l0 112 96 0 0-112c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112l0 224c0 61.9-50.1 112-112 112S0 429.9 0 368L0 144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiggyBank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7L256 96c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96l11.5 0c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9l13.3 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-32 0c-9.1 12.1-19.9 22.9-32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-128 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c-34.9-26.2-58.7-66.3-63.2-112L68 304c-37.6 0-68-30.4-68-68s30.4-68 68-68l4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-4 0c-11 0-20 9-20 20s9 20 20 20l31.2 0c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2l128 0zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhotoFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0L576 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64l0-224c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128l96 0 0 256 0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32 160 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm0 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm0 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm336 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneVolume(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 107.4 37.8 206 100.8 283.1L9.2 469.1c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7s-23.3-12.3-33.7-4.1L253 278c-17.8-21.5-32.9-45.2-45-70.7L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96zm96.8 319l-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneFlip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPesoSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64l0 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 80 0c68.4 0 127.7-39 156.8-96l19.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-.7 0c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16l.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-19.2 0C303.7 71 244.4 32 176 32L64 32zm190.4 96L96 128l0-32 80 0c30.5 0 58.2 12.2 78.4 32zM96 192l190.9 0c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16L96 224l0-32zm158.4 96c-20.2 19.8-47.9 32-78.4 32l-80 0 0-32 158.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPesetaSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64l0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 96 0c77.4 0 142-55 156.8-128l3.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-3.2 0C334 87 269.4 32 192 32L64 32zM282.5 160L96 160l0-64 96 0c41.8 0 77.4 26.7 90.5 64zM96 224l186.5 0c-13.2 37.3-48.7 64-90.5 64l-96 0 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPerson(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonWalking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonWalkingWithCane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6l0 43.2c0 17 6.7 33.3 18.7 45.3L224 397.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-89.4c0-12.7-5.1-24.9-14.1-33.9L224 306.7l0-93.4 70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128l-24.4 0zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonWalkingLuggage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonWalkingDashedLineArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224 384 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l146.7 0-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16zM392 320c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonWalkingArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224 384 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l146.7 0-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonWalkingArrowLoopLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384l18.7 0c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96l-18.7 0 25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonThroughWindow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0l-64 0L64 64zm288 0l224 0 0 320-67.7 0-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320l-45.8 0 42.7 64L592 448c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 400c0 26.5 21.5 48 48 48l260.2 0 33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0L192 384s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonSwimming(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonSnowboarding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6l28.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-28.2 0c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonSkiing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonSkiingNordic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464l-88.5 0 41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464l-32.4 0 54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464l-43 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l135.3 0c.5 0 .9 0 1.4 0l158.6 0c.5 0 1 0 1.4 0L504 512c39.8 0 72-32.2 72-72l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 13.3-10.7 24-24 24l-69.4 0 27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32l-21.3 0c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464l-44.4 0 21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288l2.7 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonSkating(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32l159.4 0c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9l0 73.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17L160 160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4L272 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l88.8 0c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonShelter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.4L256 68.9 448 178.6 448 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280l0-88 16 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-174.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5 200 488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonRunning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288l21.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-21.3 0c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352L32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l69.6 0c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonRifle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M265.2 192c25.4 0 49.8 7.1 70.8 19.9L336 512l-192 0 0-174.3L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8l50.4 0zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM448 0c8.8 0 16 7.2 16 16l0 116.3c9.6 5.5 16 15.9 16 27.7l0 109.3 16-5.3 0-56c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 84.5c0 6.9-4.4 13-10.9 15.2L480 325.3l0 26.7 48 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-44 0 23 92.1c2.5 10.1-5.1 19.9-15.5 19.9L432 512c-8.8 0-16-7.2-16-16l0-96-16 0c-17.7 0-32-14.3-32-32l0-144c0-17.7 14.3-32 32-32l0-32c0-11.8 6.4-22.2 16-27.7L416 32c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 16 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonRays(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9 328 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonPregnant(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 383c-13.8-3.6-24-16.1-24-31l0-55.1-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1l1.1 0 12.5 0 2.4 0c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3l0 32c0 17.7-14.3 32-32 32l-16 0-40 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-8 0-8 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonPraying(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432 72 432c-22.1 0-40 17.9-40 40s17.9 40 40 40l208 0c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonMilitaryToPerson(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9l111.4 0c8.8-.1 15.9-7.2 15.9-16L200 16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1l-122.9 0C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256l0 32c0 17.7 14.3 32 32 32l128 0c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5l0-32c0-35.3-28.7-64-64-64l-64 0c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-35.3-28.7-64-64-64l-64 0zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376l0 32-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 0 32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonMilitaryRifle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4L352 48c0 8.8-7.2 16-16 16L185 64c-13.8 0-25-11.2-25-25zm17.6 57l156.8 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7 352 480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9l50.4 0c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512l-128 0c-17.7 0-32-14.3-32-32l0-110.3-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonMilitaryPointing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25l151 0c8.8 0 16-7.2 16-16l0-30.6C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16L241.6 96c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40l152 0 0 89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5L240 224 72 224zm345.7 20.9L246.6 416 416 416l0-46.3 53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32-192 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonHiking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9l0 89.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208l30.9 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 55.8c0 .1 0 .2 0 .2s0 .2 0 .2L384 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-216-39.4 0c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59l4.2 0c15.6 0 27.1 14.7 23.3 29.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonHarassing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-244.7 47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7l-35.9 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344l0 58.7-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9L576 344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16l56 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-56 0c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonHalfDress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352l0-224 6.9 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128s0 0 0 0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3l0 256s0 0 0 0l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-17.8 0c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonFalling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0-1.4 0 92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-73.8c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonFallingBurst(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2L32 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320l1.4 0 80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonDrowning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3L192 64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonDress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384l-17.8 0c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3l11.6 0c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1L232 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-16 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonDressBurst(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM390.2 384l17.8 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 16 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 17.8 0c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3l-11.6 0c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonDotsFromLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1L176 432l224 0 0-109.3c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonDigging(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2l-256 0c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7l32 0 22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-74.9-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonCircleQuestion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2l0 14.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-5.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0c-23 0-41.6 18.6-41.6 41.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonCirclePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonCircleMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonChalkboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-288 56 0 64 0 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-64 192 0 0 192-192 0 0-32-64 0 0 48c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 80-76.9 0-65.9 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9 120 480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonCane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7l-35.9 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9 120 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-244.7zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonBurst(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9 408 480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.3-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonBreastfeeding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8l0-36.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1l75.2 0c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonBooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160 64 0 0-160zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448zM224 512c17.7 0 32-14.3 32-32l0-160-64 0 0 160c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L320 0zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3l0-72.1 4.7 4.7c9 9 21.2 14.1 33.9 14.1l73.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-66.7 0-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6l0 55.7 0 .9L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 32 42.7L96 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-58.7c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonBiking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.8 0zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonArrowUpFromLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352l0-96 16 0 0 96-16 0zm-64 0l-88 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l120 0 80 0 376 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-344 0 0-191.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9 120 448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-242.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonArrowDownToLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352l0-96 16 0 0 96-16 0zm-64 0l-88 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l120 0 80 0 376 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-344 0 0-191.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9 120 448zM464 64l0 242.7-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7 528 64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPercent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPepperHot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3L360 256c-13.3 0-24-10.7-24-24l0-80c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0 0 80c0 26.5 21.5 48 48 48l76.2 0 23.9 47.8C372.3 443.9 244.3 512 103.2 512l-58.8 0C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeopleRoof(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM226.9 491.4L200 441.5l0 38.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-38.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6l19.5 0c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5l0 38.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-38.5-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5l0 54.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-54.5-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeopleRobbery(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6L328 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-305.7c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64l0 96 0 .6L8 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-227.3 13 20.5c5.9 9.2 16.1 14.9 27 14.9l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-30.4 0-37.4-58.9C157.6 142 132.1 128 104.7 128L72 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeoplePulling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64L0 320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352l15.7 0 30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128l-53 0zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeopleLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5l0 54.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-54.5 26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5l0 38.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5 88 352c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeopleGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3l0-84.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5l0 21.5c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-26.8C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112l32 0c24 0 46.2 7.5 64.4 20.3zM448 416l0-21.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176l32 0c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2l0 26.8c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7l0 84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3l0-84.7c-10 11.3-16 26.1-16 42.3zm144-42.3l0 84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2l0 42.8c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-42.8c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112l32 0c61.9 0 112 50.1 112 112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeopleCarryBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm64 193.7l0 65.1 51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7l0-88.1c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5 0-76.2c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 76.2 10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6l0 88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51 0-65.1-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8l-126.7 0c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeopleArrows(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160l44.8 0c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2l0 72.8c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L576 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-72.8 47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240l0 32 96 0 0-32c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2l0-32-96 0 0 32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPencil(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenToSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenRuler(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenNib(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.7-9.2L288 94.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenFancy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.3 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenClip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1s0 0 0 0l-1-1s0 0 0 0l-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 445.3l0-121.8-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8l0-174.2C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5l0 121.8c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3l0 174.2L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaw(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5l0 1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3l0-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaste(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c-23.7 0-44.4 12.9-55.4 32L48 32C21.5 32 0 53.5 0 80L0 400c0 26.5 21.5 48 48 48l144 0 0-272c0-44.2 35.8-80 80-80l48 0 0-16c0-26.5-21.5-48-48-48l-56.6 0C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48l0 272 0 16c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-220.1c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L320 128l-48 0zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPassport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8l-39.1 0zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaParagraph(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32l64 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352-32 0 0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-32 0c-88.4 0-160-71.6-160-160s71.6-160 160-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaParachuteBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16L240 192l0 128-32 0c-7 0-13.7 1.5-19.7 4.2L68.2 192l28.3 0c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192l6 0L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-7.8-1.9-15.2-5.2-21.7L487.1 192l6 0c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16l28.3 0L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2l-32 0 0-128 111.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaperclip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaperPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPanorama(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M45.6 32C20.4 32 0 52.4 0 77.6L0 434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6l0-356.7C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 224 0 224 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-224 0L96 320l-64 0zm96 64l160 0 0 64-160 0 0-64zm224 0l160 0 0 64-160 0 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPalette(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3L344 320c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaintbrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaintRoller(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 192c-35.3 0-64-28.7-64-64L0 64zM160 352c0-17.7 14.3-32 32-32l0-16c0-44.2 35.8-80 80-80l144 0c17.7 0 32-14.3 32-32l0-32 0-90.5c37.3 13.2 64 48.7 64 90.5l0 32c0 53-43 96-96 96l-144 0c-8.8 0-16 7.2-16 16l0 16c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPager(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm64 32l0 64c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaP(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l96 0c88.4 0 160 71.6 160 160s-71.6 160-160 160l-96 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 320 0 96zM64 288l96 0c53 0 96-43 96-96s-43-96-96-96L64 96l0 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOutdent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 96l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6l0 158.6c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOtter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6l0-21.4c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3l0-3.7c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6l0 .6c0 35.3 28.7 64 64 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l160 0 0-48 0-16c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6l0-16c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16l0 32 0 16 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-99.7c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1s0 0 0 0c0 123.7-100.3 224-224 224l-1.1 0L256 480l-.6 0C132 480 32 380 32 256.6l0-.6 0-39.2c-10.1-14.6-16-32.3-16-51.4L16 144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24l2.8 0C44.8 58.2 83.3 32 128 32l64 0c44.7 0 83.2 26.2 101.2 64l2.8 0c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4 0 21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-13.3 0-24 10.7-24 24l0 8 56.4 0c-15.2 17-24.4 39.4-24.4 64l-32 0c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM281 66.7c-2.2-1.5-4.9-2.5-7.7-2.7c-.6 0-1.3-.1-1.9 0c-3.9 .2-7.4 1.7-10.1 4.2c-.9 .8-1.6 1.7-2.3 2.6c-1.7 2.4-2.7 5.3-2.9 8.5c0 .7 0 1.4 0 2.1c.2 2.2 .9 4.3 1.9 6.2l.3 .6c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .1-.1 .1-.1s0 0 0 0s0 0 0 0c5.9-5.8 9.5-13.9 9.5-22.8c0-17.7-14.3-32-32-32c-8.7 0-16.7 3.5-22.4 9.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48l-34.2 0c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9l8.9 0 16 0c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5c-.3-.9-.7-1.8-1.1-2.6c-1.2-2.2-2.8-4-4.7-5.4c-1.9-1.4-4.1-2.3-6.5-2.8c-1.4-.3-2.9-.3-4.4-.2c-2.5 .2-4.8 1-6.8 2.3c-1.1 .7-2.2 1.5-3.1 2.5c-2.4 2.5-4.1 5.8-4.5 9.5c-.1 .6-.1 1.1-.1 1.7c0 0 0 0 0 0c0 .8 .1 1.7 .2 2.5l0 .1c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64l22.6 0c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4l5.5 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.2c-.3-1.3-.8-2.6-1.5-3.8c-1.1-2-2.6-3.8-4.4-5.1c-2.7-2-6-3.2-9.6-3.2l-.2 0c-8 .1-14.6 6.1-15.6 13.9c0 0 0 0 0 0c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96l0-96c0-53-43-96-96-96l-5.5 0c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4l-48.3 0c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOilWell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6 96 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 264-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-137.3 0L340 257.5l-62.2 16.1L305.3 352l-66.6 0L265 277l-74.6 19.3L137.3 448 96 448l0-159.2 337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32 111.4 0 11.2 32-133.8 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOilCan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32-80 0-48 0-48 0c-26.5 0-48 21.5-48 48l0 64.8c0 19 11.2 36.2 28.5 43.9l67.5 30L96 368c0 26.5 21.5 48 48 48l259.1 0c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8L288 160l0-32 32 0zM96 208l0 86.1L48 272.8 48 208l48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaObjectUngroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32l209.1 0C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4l0 113.1c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-209.1 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-113.1zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4l0 113.1c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-113.1c-9.7-5.6-17.8-13.7-23.4-23.4L119.4 96zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-40.6 64 0 0 40.6c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-113.1c-9.7-5.6-17.8-13.7-23.4-23.4l-46 0c-5.4-15.4-14.6-28.9-26.5-39.6l0-24.4 72.6 0c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4l0 113.1c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-209.1 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaObjectGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32l337.1 0C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4l0 273.1c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-337.1 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-273.1zM456.6 96L119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4l0 273.1c9.7 5.6 17.8 13.7 23.4 23.4l337.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-273.1c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-96zM256 320l32 0c35.3 0 64-28.7 64-64l0-32 64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaO(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNotesMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 352L96 96c0-35.3 28.7-64 64-64l256 0c35.3 0 64 28.7 64 64l0 197.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7L160 416c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0C60.9 512 0 451.1 0 376L0 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88l160 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNoteSticky(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l224 0 0-112c0-26.5 21.5-48 48-48l112 0 0-224c0-35.3-28.7-64-64-64L64 32zM448 352l-45.3 0L336 352c-8.8 0-16 7.2-16 16l0 66.7 0 45.3 32-32 64-64 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNotdef(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 390.3L153.5 256 64 121.7l0 268.6zM102.5 448l179.1 0L192 313.7 102.5 448zm128-192L320 390.3l0-268.6L230.5 256zM281.5 64L102.5 64 192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNotEqual(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144l62.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-105.5 0-64 96L400 304c17.7 0 32 14.3 32 32s-14.3 32-32 32l-212.2 0-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368 48 368c-17.7 0-32-14.3-32-32s14.3-32 32-32l105.5 0 64-96L48 208c-17.7 0-32-14.3-32-32s14.3-32 32-32l212.2 0 65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L80 480c-44.2 0-80-35.8-80-80L0 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16L96 96zm64 24l0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L184 96c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNeuter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1L160 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-130.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNetworkWired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64l128 0 0 64-128 0 0-64zM240 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l48 0 0 32L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 0 32-48 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0-32 256 0 0 32-48 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0-32 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0 0-32 48 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L240 0zM96 448l0-64 128 0 0 64L96 448zm320-64l128 0 0 64-128 0 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNairaSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64l0 192-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 100.2 0 97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6l0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192-57.5 0L122.6 46.3zM305.1 320l14.9 0 0 22.3L305.1 320zM185.5 256L128 256l0-86.3L185.5 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaN(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6 320 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4 64 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 50.5 8.4 38.5 21.1 33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMusic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7l0 72 0 264c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6L448 147 192 223.8 192 432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6L128 200l0-72c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMugSaucer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64c0-17.7 14.3-32 32-32l320 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L96 64zM480 224l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128zM32 416l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMugHot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32L0 416c0 53 43 96 96 96l192 0c53 0 96-43 96-96l16 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-48 0L32 192zm352 64l16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0-96zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMountain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c12.5 0 24.1 6.4 30.8 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9L55.9 480C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5l18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8l49 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMountainSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512l325.2 0 75 0 122.8 0c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMountainCity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0c-26.5 0-48 21.5-48 48l0 92.1 71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-3.5 0 73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3L592 512c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-24 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-40 0 0-144c0-26.5-21.5-48-48-48L336 0zm32 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm160 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM224 188.9L283.8 288 223 288l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512l379.1 0c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMotorcycle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l57.7 0 16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7L64 128c-17.7 0-32 14.3-32 32l0 32 96 0c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32l70.4 0c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128l61.8 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-20.4 0c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21L280 32zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40l66.4 0C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104l-66.4 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMosquito(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMosquitoNet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4l0-23.1L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5l0-22.6c0-14.9 10.1-27.3 23.8-31l0-43.3c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2l0 43.3c13.7 3.6 23.8 16.1 23.8 31l0 22.6 45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35 0 23.1 32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6l0 50c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16l0 16 48 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 48 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 48 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-48-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-48-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 48 0 0-16c0-8.8 7.2-16 16-16zm16 112l48 0 0-48-48 0 0 48zm0 80l48 0 0-48-48 0 0 48zM448 320l0 48 48 0 0-48-48 0zm0 80l0 48 48 0 0-48-48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMosque(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5c0 0 0 0 0 0s0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4l-356.4 0c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6c0 0 0 0 0 0s0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512l0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-48 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l416 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-64 0 0-58c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454l0 58-64 0zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126l0 2L0 128l0-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160l160 0 0 136.6c-19.1 11.1-32 31.7-32 55.4l0 128c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2l-64 0c-26.5 0-48-21.5-48-48L0 176l0-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMortarPestle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160l144.9 0L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512l192 0c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMonument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322L55.9 416 96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zM32 448l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm48 160l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16zM376 160l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyCheckDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM272 192l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zM164 152l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBills(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 96l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64l-64 0 0-64zM224 96c0 35.3-28.7 64-64 64l0-64 64 0zM576 256l0 64-64 0c0-35.3 28.7-64 64-64zM512 96l64 0 0 64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm64 320l-64 0 0-64c35.3 0 64 28.7 64 64zM64 192l0-64 64 0c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64l0 64-64 0zm64-192c-35.3 0-64-28.7-64-64l64 0 0 64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBillWheat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 64C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 136c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 304zM48 416l0 48 48 0c0-26.5-21.5-48-48-48zM96 304l-48 0 0 48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48l48 0 0-48zM416 304c0 26.5 21.5 48 48 48l0-48-48 0zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBillWave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 112.5L0 422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4l0-309.9c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64l-64 0 0-64zm64-208c0 35.3-28.7 64-64 64l0-64 64 0zM512 304l0 64-64 0c0-35.3 28.7-64 64-64zM448 96l64 0 0 64c-35.3 0-64-28.7-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBillTrendUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2c0 0 0 .1 0 .1c0 0 0 0 0 0l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-18.7L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64 352 64c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0s0 0 0 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 304zM48 416l0 48 48 0c0-26.5-21.5-48-48-48zM96 304l-48 0 0 48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48l48 0 0-48zM416 304c0 26.5 21.5 48 48 48l0-48-48 0zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBillTransfer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64l241.9 0c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5 608 384c0 35.3-28.7 64-64 64l-241.9 0c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5 32 128c0-35.3 28.7-64 64-64zm64 64l-64 0 0 64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64l64 0 0-64zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBill1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm64 320l-64 0 0-64c35.3 0 64 28.7 64 64zM64 192l0-64 64 0c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64l0 64-64 0zm64-192c-35.3 0-64-28.7-64-64l64 0 0 64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-48c0 9.7 6.9 17.7 16 19.6l0 48.4-4 0c-11 0-20 9-20 20s9 20 20 20l24 0 24 0c11 0 20-9 20-20s-9-20-20-20l-4 0 0-68c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBill1Wave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 112.5L0 422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4l0-309.9c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416l-64 0 0-64c35.3 0 64 28.7 64 64zM64 224l0-64 64 0c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64l0 64-64 0zm64-192c-35.3 0-64-28.7-64-64l64 0 0 64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6l0 48.4-4 0c-11 0-20 9-20 20s9 20 20 20l24 0 24 0c11 0 20-9 20-20s-9-20-20-20l-4 0 0-68c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 0C44.7 0 16 28.7 16 64l0 384c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L80 0zm80 432l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMobileScreen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM144 448c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM304 64L80 64l0 320 224 0 0-320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMobileScreenButton(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64L80 64l0 320 224 0 0-320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMobileRetro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm64 96l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMobileButton(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 0C44.7 0 16 28.7 16 64l0 384c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L80 0zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMitten(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 384L64 384 5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0l3.4 0c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192l2.8 0c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMinimize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 224l-144 0c-13.3 0-24-10.7-24-24l0-144c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2l0-144c0-13.3 10.7-24 24-24l144 0zm-256 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8l144 0zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 144c0 13.3-10.7 24-24 24L56 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMillSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128l0 80L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-208c0-26.5 21.5-48 48-48s48 21.5 48 48l0 42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32l0-154.5 35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48l0 208c0 17.7 14.3 32 32 32s32-14.3 32-32l0-208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicroscope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32zM32 448l288 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l0-64c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128l16.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C139 0 96 43 96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophoneSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 21.2-5.1 41.1-14.2 58.7L416 300.8 416 96c0-53-43-96-96-96s-96 43-96 96l0 54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophoneLines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 96l0 160c0 53 43 96 96 96s96-43 96-96l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c0-53-43-96-96-96S96 43 96 96zM320 240l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophoneLinesSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24 0 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8l0-44.8-57.1 0-34.5-27c2.9-3.1 7-5 11.6-5l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c0-53-43-96-96-96s-96 43-96 96l0 54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrochip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c-35.3 0-64 28.7-64 64l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c0 35.3 28.7 64 64 64l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c35.3 0 64-28.7 64-64l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0c0-35.3-28.7-64-64-64l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40zM160 128l192 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32zm192 32l-192 0 0 192 192 0 0-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMeteor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMessage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l96 0 0 80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMercury(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4l0 25.6 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-25.6C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMenorah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1L64 64c0 17.7-14.3 32-32 32S0 81.7 0 64l0-1.2c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32l0 128c0 17.7 14.3 32 32 32l192 0 0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 192 0c17.7 0 32-14.3 32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 53-43 96-96 96l-192 0 0 64 128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0-160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0 0-64L96 384c-53 0-96-43-96-96L0 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 96 0 32-64 0 0-32 0-96c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 96 0 32-64 0 0-32 0-96c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32l0 96 0 32-64 0 0-32 0-96c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 96 0 32-64 0 0-32 0-96c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMemory(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128l0 7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6L0 320l576 0 0-71.4c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3l0-7.4c0-35.3-28.7-64-64-64L64 64zM576 352L0 352l0 64c0 17.7 14.3 32 32 32l48 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 96 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 96 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 96 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 48 0c17.7 0 32-14.3 32-32l0-64zM192 160l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0L133.9 0c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0L487.4 0C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMaximize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200 32L56 32C42.7 32 32 42.7 32 56l0 144c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312l0 144c0 13.3 10.7 24 24 24l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l144 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-144c0-13.3-10.7-24-24-24L312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMattressPillow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l192 0 0-384zm32 384l288 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 64l0 384zM64 160c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMasksTheater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64C64 64 0 160 0 272S80 448 176 448l8.4 0c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4l8.4 0c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMaskVentilator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269l0-85c0-4.4 3.6-8 8-8l103.1 0zm26-48L56 128c-30.9 0-56 25.1-56 56l0 85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6l0-76.6c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8l0 76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269l0-85c0-30.9-25.1-56-56-56l-129.5 0C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48L584 176c4.4 0 8 3.6 8 8l0 85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320l0 192 64 0 0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMaskFace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1l-9.2 0-16 0-72 0c-30.9 0-56 25.1-56 56l0 85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269l0-85c0-30.9-25.1-56-56-56l-72 0-16 0-9.2 0c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269l0-85c0-4.4 3.6-8 8-8l40 0 0 48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3l0-48 40 0c4.4 0 8 3.6 8 8l0 85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm16 48l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMartiniGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3 224 448l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-178.7L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0L32 0zM173.3 128l-64-64 293.5 0-64 64-165.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMartiniGlassEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3 224 448l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-178.7L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0L32 0zM256 210.7L109.3 64l293.5 0L256 210.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMartiniGlassCitrus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48l-52.6 0C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128l368 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177L232 464l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-118.1L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8l112 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80s0 0 0 0s0 0 0 0s0 0 0 0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsStroke(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L376 0zm88 48s0 0 0 0s0 0 0 0s0 0 0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsStrokeUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-40 0 0 24 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8l0-24-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-24L96 96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsStrokeRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152l33.6 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 32 0 0-56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2l0-56-32 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-33.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsDouble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L312 32zm88 48s0 0 0 0s0 0 0 0s0 0 0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zM368 480c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L504 32c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2 0 .2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7l0 21.3c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsAndVenus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 14.8C341.5 5.8 350.3 0 360 0L472 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59 146.6-136 158.2l0 25.8 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-25.8C155 370.6 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48s0 0 0 0s0 0 0 0s0 0 0 0zM352 224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsAndVenusBurst(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59.1 146.7 136.1 158.2c0 .6-.1 1.2-.1 1.8l0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1c0 0 0 .1 0 .1s0 .1 0 .1l0 .1c0 0 0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l24 0-24 0c0 13.3 10.7 24 24 24s24-10.7 24-24l-24 0 24 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1l0-.1c0 0 0-.1 0-.1s0-.1 0-.1l0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.4 0-.3 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4c0-.6 0-1.2-.1-1.8c77-11.6 136.1-78 136.1-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L504 0zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 476.1L192 421.2l0-385.3L384 90.8l0 385.3zm32-1.2l0-386.5L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2l0 386.5L32.9 474.5C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480l0-162.9c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9L192 480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapLocation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3L576 152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6L416 503zM15.1 187.3C6 191 0 199.8 0 209.6L0 480.4c0 17 17.1 28.6 32.9 22.3L160 451.8l0-251.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77l0 194.4 192 54.9L384 255z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapLocationDot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152l0 270.8c0 9.8-6 18.6-15.1 22.3L416 503l0-302.6zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6l0 251.4L32.9 502.7C17.1 509 0 497.4 0 480.4L0 209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77l0 249.3L192 449.4 192 255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaManatSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32c-17.7 0-32 14.3-32 32l0 34.7C69.2 113.9 0 192.9 0 288L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-59.6 40.8-109.8 96-124l0 284c0 17.7 14.3 32 32 32s32-14.3 32-32l0-284c55.2 14.2 96 64.3 96 124l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-95.1-69.2-174.1-160-189.3L224 64c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagnifyingGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagnifyingGlassPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagnifyingGlassMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagnifyingGlassLocation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagnifyingGlassDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagnifyingGlassChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagnifyingGlassArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31L120 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l118.1 0-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagnet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160l0 96C0 379.7 100.3 480 224 480s224-100.3 224-224l0-96-128 0 0 96c0 53-43 96-96 96s-96-43-96-96l0-96L0 160zm0-32l128 0 0-64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64zm320 0l128 0 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaM(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.3c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-278.3L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7 64 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 49.9 9.2 37.5 22.7 33.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLungs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0c17.7 0 32 14.3 32 32l0 132.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2 0-45.5C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4l0 7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398l0-73 90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1l0-.4-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58 0 73.4c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89l0-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3l0 45.5 9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5L288 32c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLungsVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0c17.7 0 32 14.3 32 32l0 124.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2L288 32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1l0-24.1C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4l0 7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89l0-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3l0 24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLocust(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4l-64.2 0-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400l74.5 0-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400l80.4 0 38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400l12.4 0c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3l0-40C576 143 465 32 328 32l-16 0zm50.5 168l17.1 40L333 240l29.5-40zm-87.7 38.1l-1.4 1.9-48.2 0 32.7-41.5 16.9 39.5zM88.8 240C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240l-37.9 0zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 16 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l16 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLockOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48C576 64.5 511.5 0 432 0S288 64.5 288 144l0 48L64 192c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-32 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLocationPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLocationPinLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3l0-94.8c0-23.7 12.9-44.4 32-55.4l0-24.6c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLocationDot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLocationCrosshairs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c17.7 0 32 14.3 32 32l0 34.7C368.4 80.1 431.9 143.6 445.3 224l34.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-34.7 0C431.9 368.4 368.4 431.9 288 445.3l0 34.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.7C143.6 431.9 80.1 368.4 66.7 288L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l34.7 0C80.1 143.6 143.6 80.1 224 66.7L224 32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLocationArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8l176 0 0 176c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLitecoinSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64l0 149.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1 64 448c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0 0-154.1 136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3 128 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaListUl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaListOl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 56c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 120 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-96-8 0C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432l33.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaListCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLiraSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4L48 192l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 32-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l14 0c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L88.5 416l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9L224 352c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0 0-32 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0 0-31.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinkSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinesLeaning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLightbulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLifeRing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLessThan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLessThanEqual(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLemon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLeftRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLeftLong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5l88 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-72 0s0 0 0 0c-16.6 0-32.7 1.9-48.3 5.4c-25.9 5.9-49.9 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLayerGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLariSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 32c17.7 0 32 14.3 32 32l0 32.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7L208 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3l0 67.9c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-95c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1l0 95c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-67.9C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l16.9 0C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6L112 64c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32C92.7 32 64 60.7 64 96l0 256 64 0 0-256 384 0 0 256 64 0 0-256c0-35.3-28.7-64-64-64L128 32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptopMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256-64 0 0-256L128 96l0 256-64 0L64 96zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptopFile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C92.7 0 64 28.7 64 64l0 224-44.8 0C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384L320 384l0-96-192 0 0-224 320 0 0 32 64 0 0-32c0-35.3-28.7-64-64-64L128 0zM512 128l-112 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-208-96 0c-17.7 0-32-14.3-32-32l0-96zm32 0l0 96 96 0-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptopCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256-64 0 0-256L128 96l0 256-64 0L64 96zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLanguage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 92.7 28.7 64 64 64l192 0 48 0 16 0 256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-256 0-16 0-48 0L64 448c-35.3 0-64-28.7-64-64L0 128zm320 0l0 256 256 0 0-256-256 0zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1 73.6 0 8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276l-38 0 19-42.8zM448 164c11 0 20 9 20 20l0 4 44 0 16 0c11 0 20 9 20 20s-9 20-20 20l-2 0-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45L448 228l-72 0c-11 0-20-9-20-20s9-20 20-20l52 0 0-4c0-11 9-20 20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLandmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8L32 192c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9l0-.9 4.4-1.6L240.1 4.2zM64 224l64 0 0 192 40 0 0-192 64 0 0 192 48 0 0-192 64 0 0 192 40 0 0-192 64 0 0 196.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512L32 512c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1L64 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLandmarkFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0l80 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-80 0 0 32 192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0 0-112c0-8.8 7.2-16 16-16l16 0zM64 224l64 0 0 192 40 0 0-192 64 0 0 192 48 0 0-192 64 0 0 192 40 0 0-192 64 0 0 196.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512L32 512c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1L64 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLandmarkDome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 0l16 0c13.3 0 24 10.7 24 24l0 10.7C368.4 48.1 431.9 111.6 445.3 192l2.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 256c-17.7 0-32-14.3-32-32s14.3-32 32-32l2.7 0C80.1 111.6 143.6 48.1 224 34.7L224 24c0-13.3 10.7-24 24-24zM64 288l64 0 0 128 40 0 0-128 64 0 0 128 48 0 0-128 64 0 0 128 40 0 0-128 64 0 0 132.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512L32 512c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1L64 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLandMineOn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 32-256 0 0-32zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5l324.7 0c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512l-408.4 0c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaL(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32c17.7 0 32 14.3 32 32l0 352 192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKiwiBird(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4l55.7 0c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3l0-240c0-70.7-57.3-128-128-128l-55.7 0c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3L96 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-46c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7l0 40.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-50.9c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKitchenSet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112l71.8 0c8.8-9.8 21.6-16 35.8-16l104 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-104 0c-14.2 0-27-6.2-35.8-16l-71.8 0zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24l0 8 96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-240 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l96 0 0-8c0-13.3 10.7-24 24-24zM288 464l0-112 224 0 0 112c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48zM48 320l80 0 16 0 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-80c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32 16 0zM24 464l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKitMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l32 0L96 32 64 32zm64 0l0 448 320 0 0-448L128 32zM512 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-32 0 0 448 32 0zM256 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKipSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4 128 64c0-17.7-14.3-32-32-32S64 46.3 64 64l0 160-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-122.4L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288 352 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-169.5 0L340.8 88.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKhanda(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1s0 0 0 0s0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5l0 19.8 35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3s0 0 0 0s0 0 0 0l.1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1c0 0 0 0 0 0s0 0 0 0L401.1 400l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4l0 28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7l0-28.1-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3s0 0 0 0s0 0 0 0l-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0c0 0 0 0 0 0s0 0 0 0L112 80l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L240 362.6l0-19.1-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0l.1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1s0 0 0 0s0 0 0 0s0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKeyboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm16 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-32zM272 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM368 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM464 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKaaba(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112l0 16s0 0 0 0l0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2 0 128l0-16C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8l0 46.5-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8 576 400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400L0 262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2l0-46.5 273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaK(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 328 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-107 64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJugDetergent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 24 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 96C74.7 96 64 85.3 64 72s10.7-24 24-24l8 0 0-24zM0 256c0-70.7 57.3-128 128-128l128 0c70.7 0 128 57.3 128 128l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256zm256 0l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJoint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9l0 11c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43l0-11zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9l0-11c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8l0 11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512l67.3 0c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512l19 0 51.3 0c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352l-19 0-48 0c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9l0-80c0-22.1-17.9-40-40-40l-155.3 0c-4.1 0-6.3 5.1-3.6 8.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJetFighter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 24c0-13.3 10.7-24 24-24L296 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0L384 192l116.4 0c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1L384 320 280 464l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-144-32 0-54.6 54.6c-6 6-14.1 9.4-22.6 9.4L64 384c-17.7 0-32-14.3-32-32l0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l18.7 0c8.5 0 16.6 3.4 22.6 9.4L160 192l32 0 0-144-8 0c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJetFighterUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2l0 77-144 84L48 280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56 0 32 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 144 0 0 32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12l0 16c0 8.8 7.2 16 16 16l96 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 96 0c8.8 0 16-7.2 16-16l0-16c0-4.6-2-9-5.5-12L320 416.7l0-32.7 144 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 0-32 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 18.8-144-84 0-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJedi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9l26 0c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9l14.6 0c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9l14.6 0c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6l26 0c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C32 14.3 46.3 0 64 0L256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 160zm96 64c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L96 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJarWheat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C32 14.3 46.3 0 64 0L256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 160zm112 0l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224l21.8 0 32 0 21.8 0c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8L208 160c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320l21.8 0 32 0 21.8 0c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8L208 256c-19.1 0-36.3 8.4-48 21.7zM112 352l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416l21.8 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 21.8 0c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8L208 352c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJ(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c17.7 0 32 14.3 32 32l0 256c0 88.4-71.6 160-160 160S0 408.4 0 320l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 53 43 96 96 96s96-43 96-96l0-256c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItalic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-58.7 0L160 416l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l58.7 0L224 96l-64 0c-17.7 0-32-14.3-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInfo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInfinity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1l0 29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9l0-29.7zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1l0 29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1l0-29.7c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIndustry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64l0 240 0 48 0 80c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-128 0-151.8c0-18.2-19.4-29.7-35.4-21.1L352 215.4l0-63.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4 160 64c0-17.7-14.3-32-32-32L64 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIndianRupeeSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l64 0 16 0 176 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-56.2 0c9.6 14.4 16.7 30.6 20.7 48l35.6 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-35.6 0c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256l80 0c32.8 0 61-19.7 73.3-48L32 208c-17.7 0-32-14.3-32-32s14.3-32 32-32l153.3 0C173 115.7 144.8 96 112 96L96 96 32 96C14.3 96 0 81.7 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIndent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 96l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3L0 176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-92.1c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32L121 32zm0 64l270 0 48 192-51.2 0c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7l-120.4 0c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7L73 288 121 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaImages(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaImagePortrait(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6l86.9 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0C92.3 384 80 371.7 80 356.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIgloo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 33.8L320 160 48.5 160C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160l0-120.9C424.9 55.7 487.2 99.8 527.5 160L352 160zM29.9 192L96 192l0 128L0 320c0-46 10.8-89.4 29.9-128zM192 320l-64 0 0-128 320 0 0 128-64 0 0 32 192 0 0 80c0 26.5-21.5 48-48 48l-176 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128L48 480c-26.5 0-48-21.5-48-48l0-80 192 0 0-32zm288 0l0-128 66.1 0c19.2 38.6 29.9 82 29.9 128l-96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96l576 0c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 32L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdCardClip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM64 64l128 0 0 48c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-48 128 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7l202.7 0c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3l-117.3 0c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm96 320l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 416c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIcons(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.3 7.3C507.7 13.3 512 22.4 512 32l0 144c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-57L352 90.2 352 208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-96c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2l61.7 0c10.7 0 20.7 5.3 26.6 14.2L213.3 304l26.7 0c26.5 0 48 21.5 48 48l0 112c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 352c0-26.5 21.5-48 48-48l26.7 0zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368l55.7 0c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400 336 400c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIcicles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIceCream(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16l-.9 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l53.5 0 181 0 53.5 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-.9 0zM96 288L200.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288 96 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaI(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l96 0 0 320-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0 0-320 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaICursor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3L96 224l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7l0-95.7 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-95.7c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHurricane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9l0 63.3c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2l0-63.3c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHryvniaSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121.9 116.2C138.3 103.1 158.7 96 179.6 96L223 96c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31L32 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l123.5 0-50.6 28.9c-1.7 1-3.4 2-5.1 3.1L32 272c-17.7 0-32 14.3-32 32s14.3 32 32 32l20.3 0c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113l43.4 0c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2L161 416c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31L352 336c17.7 0 32-14.3 32-32s-14.3-32-32-32l-123.5 0 50.6-28.9c1.7-1 3.4-2 5.1-3.1l67.8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-20.3 0c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113l-43.4 0c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c.2 35.5-28.5 64.3-64 64.3l-320.4 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseTsunami(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1c0 0 0 0 0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6l0 121c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseSignal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c87.1 25.3 155.6 94.2 180.3 181.6L464 416c26.5 0 48-21.5 48-48l0-112 32 0c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseMedicalFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 0c17.7 0 32 14.3 32 32l112 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-112 0 0 320-64 0 0-320 0-160c0-17.7 14.3-32 32-32zM276.8 39.7L416 159l0 353 1 0-.2 0L96 512c-17.7 0-32-14.3-32-32l0-192-32 0c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseMedicalCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 368c0 59.5 29.5 112.1 74.8 144l-266.7 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64L320 256l0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseMedicalCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 368c0 59.5 29.5 112.1 74.8 144l-266.7 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64L320 256l0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseMedicalCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 368c0 59.5 29.5 112.1 74.8 144l-266.7 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64L320 256l0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480c0 11.7 3.1 22.6 8.6 32l-.6 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272l0 24.6c-19.1 11.1-32 31.7-32 55.4l0 128zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseLaptop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5l-144 0c-19.1 0-36.3 8.4-48 21.7l0-37.7c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0 0 128-160 0c-26.5 0-48-21.5-48-48l0-112-32 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304l0 144 192 0 0-144-192 0zm-48-16c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 160 32 0c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48l-48 0-192 0-48 0c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16l32 0 0-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseFloodWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192l16 0 0 73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2 16.6 0c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseFloodWaterCircleArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160 80 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4 16.6 0c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7c0 0 0 0 0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 0c-17.7 0-32 14.3-32 32l0 160 0 320 64 0 0-320 112 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L512 32c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288l32 0 0 192c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-96c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 96c0 17.7 14.3 32 32 32l64.7 0 .2 0-1 0 0-353z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 350.1l0 1.9-32 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM480 512c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C624.5 268 640 320.2 640 352c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseCrack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l102.3 0-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64 122.1 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseChimney(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185l0-121c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64 0 24c0 22.1 17.9 40 40 40l24 0 32.5 0c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1l16 0c22.1 0 40-17.9 40-40l0-16.2c.3-2.6 .5-5.3 .5-8.1l-.7-160.2 32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseChimneyWindow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c.2 35.5-28.5 64.3-64 64.3l-320.4 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7 416 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 121 52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-80 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseChimneyUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185l0-121c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseChimneyMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c.2 35.5-28.5 64.3-64 64.3l-320.4 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7 416 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 121 52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseChimneyCrack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c.2 35.5-28.5 64.3-64 64.3l-122.1 0L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512l-102.3 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7 416 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 121 52.8 46.4c8 7 12 15 11 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0L64 0 320 0l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 11c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1l0 11c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L64 512l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-11c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75l0-11C14.3 64 0 49.7 0 32zM96 64l0 11c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9l0-11L96 64zm0 384l192 0 0-11c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9l0 11z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglassStart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0zM288 437l0 11L96 448l0-11c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglassHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0zM96 75l0-11 192 0 0 11c0 19-5.6 37.4-16 53L112 128c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9L112 384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglassEnd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0zM96 75l0-11 192 0 0 11c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0L480 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-176 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 48L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 64C14.3 64 0 49.7 0 32zm96 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM240 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8l144 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotdog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9c0 0 0 0 0 0s0 0 0 0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4c0 0 0 0 0 0l-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotTubPerson(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5l0 13.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-13.2c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2l0-5.2zM0 320l0 16L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-170.7 0c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96l0 64zm128 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm112 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24l0 5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5l0 13.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-13.2c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2l0-5.2c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHospital(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 48c0-26.5 21.5-48 48-48L400 0c26.5 0 48 21.5 48 48l0 464-80 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-80 0 0-464zM48 96l112 0 0 416L48 512c-26.5 0-48-21.5-48-48L0 320l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 288l0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 192l0-48c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48l0 48-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 144c0 26.5-21.5 48-48 48l-112 0 0-416 112 0zM312 64c-8.8 0-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHospitalUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 256l144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 288l0 64 144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 384l0 80c0 26.5 21.5 48 48 48l217.9 0c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2l0-95.9L320 48c0-26.5-21.5-48-48-48L48 0zM152 64l16 0c8.8 0 16 7.2 16 16l0 24 24 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-24 0 0 24c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-24-24 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l24 0 0-24c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0c-51.4 0-93.1 41.7-93.1 93.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHorse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 238.1l0-78.1 16 0 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1L576 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L480 0 448 0C377.3 0 320 57.3 320 128l-96 0-20.8 0-54.4 0c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHorseHead(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464l0-147.1c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1l-3.4 0c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4c0 0 0 0-.1 0c0 0 0 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3c0 0 0 0 0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8L112 512c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHollyBerry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72l0 22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7l0-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8l0 32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8l0-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHockeyPuck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6L512 352c0 53-114.6 96-256 96S0 405 0 352L0 222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHippo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2l32 0c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-16-64 0 0 16c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-17.6c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2l0 10.8c0 17.7 14.3 32 32 32l32 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-76c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12l0 76c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-118.9L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1 7.2 0L256 64l32 0c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHillRockslide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2l-53.3 0c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3L0 432c0 44.2 35.8 80 80 80l316.7 0c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9l0-53.3c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9l0 53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHillAvalanche(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3L0 432c0 44.2 35.8 80 80 80l316.7 0c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHighlighter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5s0 0 0 0l0-71.7c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5L224 416l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7L24 512c-13.3 0-24-10.7-24-24l0-4.7c0-6.4 2.5-12.5 7-17z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHexagonNodes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 106.6c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 98.8c-2.8 1.3-5.5 2.9-8 4.7l-80.1-45.8c1.6-20.8-8.6-41.6-27.9-52.8C57.2 96 23 105.2 7.5 132S1.2 193 28 208.5c1.3 .8 2.6 1.5 4 2.1l0 90.8c-1.3 .6-2.7 1.3-4 2.1C1.2 319-8 353.2 7.5 380S57.2 416 84 400.5c19.3-11.1 29.4-32 27.8-52.8l50.5-28.9c-11.5-11.2-19.9-25.6-23.8-41.7L88 306.1c-2.6-1.8-5.2-3.3-8-4.7l0-90.8c2.8-1.3 5.5-2.9 8-4.7l80.1 45.8c-.1 1.4-.2 2.8-.2 4.3c0 22.3 13.1 41.6 32 50.6l0 98.8c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56c0-22.3-13.1-41.6-32-50.6l0-98.8c2.8-1.3 5.5-2.9 8-4.7l80.1 45.8c-1.6 20.8 8.6 41.6 27.8 52.8c26.8 15.5 61 6.3 76.5-20.5s6.3-61-20.5-76.5c-1.3-.8-2.7-1.5-4-2.1l0-90.8c1.4-.6 2.7-1.3 4-2.1c26.8-15.5 36-49.7 20.5-76.5S390.8 96 364 111.5c-19.3 11.1-29.4 32-27.8 52.8l-50.6 28.9c11.5 11.2 19.9 25.6 23.8 41.7L360 205.9c2.6 1.8 5.2 3.3 8 4.7l0 90.8c-2.8 1.3-5.5 2.9-8 4.6l-80.1-45.8c.1-1.4 .2-2.8 .2-4.3c0-22.3-13.1-41.6-32-50.6l0-98.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHexagonNodesBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 106.6c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 98.8c-2.8 1.3-5.5 2.9-8 4.7l-80.1-45.8c1.6-20.8-8.6-41.6-27.9-52.8C57.2 96 23 105.2 7.5 132S1.2 193 28 208.5c1.3 .8 2.6 1.5 4 2.1l0 90.8c-1.3 .6-2.7 1.3-4 2.1C1.2 319-8 353.2 7.5 380S57.2 416 84 400.5c19.3-11.1 29.4-32 27.8-52.8l50.5-28.9c-11.5-11.2-19.9-25.6-23.8-41.7L88 306.1c-2.6-1.8-5.2-3.3-8-4.7l0-90.8c2.8-1.3 5.5-2.9 8-4.7l80.1 45.8c-.1 1.4-.2 2.8-.2 4.3c0 22.3 13.1 41.6 32 50.6l0 98.8c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56c30.7 0 55.6-24.7 56-55.2c-7.5-12.9-13.5-26.8-17.6-41.5c-4.2-4-9.1-7.3-14.4-9.9l0-98.8c2.8-1.3 5.5-2.9 8-4.7l10.5 6c5.5-15.3 13.1-29.5 22.4-42.5l-9.1-5.2c.1-1.4 .2-2.8 .2-4.3c0-22.3-13.1-41.6-32-50.6l0-98.8zM440.5 132C425 105.2 390.8 96 364 111.5c-19.3 11.1-29.4 32-27.8 52.8l-50.6 28.9c11.5 11.2 19.9 25.6 23.8 41.7L360 205.9c.4 .3 .8 .6 1.3 .9c21.7-9.5 45.6-14.8 70.8-14.8c2 0 4 0 5.9 .1c12.1-17.3 13.8-40.6 2.6-60.1zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380 376 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHelmetUn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240l0 56.3C0 344.8 39.2 384 87.7 384L200 384l14.9 0L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.5 0-1.5-1.5L368 288l80 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-.5 0zM320 417.2l-78-73.7L274.4 288l45.6 0 0 129.2zM285.3 103.1l34.7 52 0-43.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHelmetSafety(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c-17.7 0-32 14.3-32 32l0 2.3 0 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288l0 64 512 0 0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1l0-99.6 0-2.3c0-17.7-14.3-32-32-32l-64 0zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6L16.6 384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHelicopter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32c0-17.7 14.3-32 32-32L544 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L384 64l0 64 32 0c88.4 0 160 71.6 160 160l0 64c0 17.7-14.3 32-32 32l-160 0-64 0c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64L48 64c10.1 0 19.6 4.7 25.6 12.8L112 128l208 0 0-64L160 64c-17.7 0-32-14.3-32-32zM384 320l128 0 0-32c0-53-43-96-96-96l-32 0 0 128zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5L256 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l280.2 0c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHelicopterSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M445.3 224l64.7 0C495.6 108.2 403.8 16.4 288 2l0 64.7C368.4 80.1 431.9 143.6 445.3 224zM510 288l-64.7 0C431.9 368.4 368.4 431.9 288 445.3l0 64.7c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510l0-64.7C143.6 431.9 80.1 368.4 66.7 288L2 288zm0-64l64.7 0C80.1 143.6 143.6 80.1 224 66.7L224 2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 96 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-96 0 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartPulse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4l87 0c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31l104.5 0c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240l-132 0c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9L16 240c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9l0-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1l0 5.8c0 16.9-2.8 33.5-8.3 49.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartCrack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1l0 5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9l0-5.8c0-69.9 50.5-129.5 119.4-141z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartCirclePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartCircleMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartCircleBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380 376 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadset(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.1 48 48 141.1 48 256l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40C0 114.6 114.6 0 256 0S512 114.6 512 256l0 144.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24l-32 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40L464 256c0-114.9-93.1-208-208-208zM144 208l16 0c17.7 0 32 14.3 32 32l0 112c0 17.7-14.3 32-32 32l-16 0c-35.3 0-64-28.7-64-64l0-48c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64l0 48c0 35.3-28.7 64-64 64l-16 0c-17.7 0-32-14.3-32-32l0-112c0-17.7 14.3-32 32-32l16 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadphones(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80l0-16 0-48 0-48C0 146.6 114.6 32 256 32s256 114.6 256 256l0 48 0 48 0 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadphonesSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 80C141.1 80 48 173.1 48 288l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 288C0 146.6 114.6 32 256 32s256 114.6 256 256l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64l16 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-16 0c-35.3 0-64-28.7-64-64l0-64zm288-64c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-16 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l16 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeading(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l48 0 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 112 224 0 0-112-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 144 0 176 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-144-224 0 0 144 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-176L48 96 32 96C14.3 96 0 81.7 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideMask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 224.2c0-22.2 3.2-43.6 9.2-63.9L262.2 321c-4 9.5-6.2 20-6.2 31l0 160-128 0c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2L336 272c-21.7 0-41.3 8.6-55.7 22.6zM336 304l198 0s0 0 0 0l10 0-19.7 64L368 368c-8.8 0-16 7.2-16 16s7.2 16 16 16l146.5 0-9.8 32L368 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l126.8 0-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2L288 512l0-160c0-14 6-26.7 15.6-35.4c0 0 0 0 0 0c8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideCough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320s0 0 0 0l0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416l0 16c0 26.5-21.5 48-48 48l-80 0 0 8c0 13.3-10.7 24-24 24l-40 0s0 0 0 0L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideCoughSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 325.8l44 34.5c8.1 1.4 14.8 6.8 18 14.1L552.9 408c10.6 .4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1c11.1 0 20.4 7.5 23.2 17.8l-3.9 0c6.2 8.5 6.4 20.4-.4 29c-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L89.6 44.9C127 16.7 173.5 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320s0 0 0 0l0 5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480l-80 0 0 8c0 13.3-10.7 24-24 24l-40 0s0 0 0 0L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHatWizard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6l0 1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416l-207.1 0 11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416 64 416zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHatCowboy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHatCowboySide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.7 135.9l-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1l10.7 0c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32l-2.7 0c-5.6 0-11.1 .7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64l480 0L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9l-10.7 0c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2L0 384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHashtag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128l95.1 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0L325.8 320l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7-95.1 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384 32 384c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 21.3-128L64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320l95.1 0 21.3-128-95.1 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHardDrive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 184.4c-17-15.2-39.4-24.4-64-24.4L64 256c-24.6 0-47 9.2-64 24.4L0 96zM64 288l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHanukiah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176L96 320c-17.7 0-32-14.3-32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 53 43 96 96 96l192 0 0 64-128 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0 0-64 192 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32l-192 0 0-176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8 512 128l-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48 0 224 28.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16L0 352c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-224-80 0zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128l0 224c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-208c0-8.8-7.2-16-16-16l-80 0zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshakeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.4-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8 512 128l-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM96 171.6L40.6 128 0 128 0 352c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-180.4zM413.6 421.9L128 196.9 128 352l28.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128l0 224c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-224-96 0zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshakeSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352l41.8 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-76 0-4 0-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48-80 0c-26.5 0-48 21.5-48 48L0 304c0 26.5 21.5 48 48 48l108.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshakeSimpleSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.4-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352l41.8 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-76 0-4 0-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM0 176L0 304c0 26.5 21.5 48 48 48l108.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6L41.2 128.5C17.9 131.8 0 151.8 0 176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshakeAngle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 248l0 3.3 69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5L296 64c-37.1 0-67.6 28-71.6 64l-.4 0 0 120c0 22.1 17.9 40 40 40s40-17.9 40-40l0-72c0 0 0-.1 0-.1l0-15.9 16 0 136 0c0 0 0 0 .1 0l7.9 0c44.2 0 80 35.8 80 80l0 8zM336 192l0 56c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-118.6c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1l160 0c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16l2.7 0c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8l0-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHands(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160l-.1 72.6c-.1 52.2-24 101-64 133.1c.1-1.9 .1-3.8 .1-5.7l0-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4L248.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8s0 0 0 0s0 0 0 0l43.3 75L480 160c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5L268.5 131c-13.9 4.5-26.4 13.7-34.7 27c-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l26.8 46.4c.6 6 2.1 11.8 4.3 17.4l-4.7 0-13.3 0s0 0 0 0L179 216l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM260.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352l0 8c0 83.9-68.1 152-152 152l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l92 0c6.6 0 12-5.4 12-12s-5.4-12-12-12L88 440c-13.3 0-24-10.7-24-24s10.7-24 24-24l124 0c6.6 0 12-5.4 12-12s-5.4-12-12-12L56 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l156 0c6.6 0 12-5.4 12-12s-5.4-12-12-12L88 296c-13.3 0-24-10.7-24-24s10.7-24 24-24l136 0s0 0 0 0s0 0 0 0l93.2 0L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsPraying(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4l0 73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384l0 96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7L336 224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-84.9c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8l0 84.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 118.2c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480l0-96c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2l0-73.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsHolding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c0 0 0 0 0 0l-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40zm480 0l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c0 0 0 0 0 0l-25.3 25.3c-21 21-32.8 49.5-32.8 79.2l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsHoldingCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM40 64c22.1 0 40 17.9 40 40l0 40 0 80 0 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2c0 0 0 0 0 0l25.3 25.3c21 21 32.8 49.5 32.8 79.2l0 78.9c0 26.5-21.5 48-48 48l-66.7 0c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5L0 224l0-64 0-56C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40l0 56 0 64 0 101.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7L400 512c-26.5 0-48-21.5-48-48l0-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3c0 0 0 0 0 0l15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3l0-40.2 0-80 0-40c0-22.1 17.9-40 40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsHoldingChild(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35-7.6 0-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40l0 40 0 80 0 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2c0 0 0 0 0 0l25.3 25.3c21 21 32.8 49.5 32.8 79.2l0 78.9c0 26.5-21.5 48-48 48l-66.7 0c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5L0 224l0-64 0-56C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40l0 56 0 64 0 101.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7L400 512c-26.5 0-48-21.5-48-48l0-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3c0 0 0 0 0 0l15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3l0-40.2 0-80 0-40c0-22.1 17.9-40 40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsClapping(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3l0-39.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 153.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16l0-39.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 153.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsBubbles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7l0-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8s0 0 0 0s0 0 0 0l-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM332.1 88.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.5 1.8 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4l4.7 0 13.3 0s0 0 0 0l31.8 0 23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352l0 8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-92 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l124 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-124 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l156 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-156 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l124 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-136 0s0 0 0 0s0 0 0 0l-93.2 0L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsBound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32l0 64 0 59.1 0 .7L32 192l0 21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352l-3.6 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 128 0 64 0 128 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-3.6 0 85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7l0-21.9 0-36.2 0-.7L608 96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 0 48.8-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1l0 61.9 0 32-64 0 0-32 0-61.9c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8 96 96l0-64zm64 448l0 32 128 0 0-32 64 0 0 32 128 0 0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0-128 0-64 0-128 0-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsAslInterpreting(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7L0 256c0 70.7 57.3 128 128 128l72 0 8 0 0-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2l0-9.3c0-70.7-57.3-128-128-128l-72 0-8 0 0 .3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandcuffs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32l8 0c13.3 0 24 10.7 24 24l0 16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1l0-16c0-13.3 10.7-24 24-24l8 0c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1l0-16c0-13.3 10.7-24 24-24l8 0c0-17.7 14.3-32 32-32s32 14.3 32 32l8 0c13.3 0 24 10.7 24 24l0 16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandSpock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64l10.9 0 8.2 0c.1 0 .1-.1 .1-.1s.1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0c17.7 0 32 14.3 32 32l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 195.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512l-19.2 0c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6l0-272c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9c0 0 0 .1 0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40l0 148.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48l0 48 0 16 0 48c0 70.7-57.3 128-128 128l-16 0-64 0-.1 0-5.2 0c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7L128 40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm48-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32l0 208-64 0L32 32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-64-64c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6l0 8.6c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363l0-27c0-35.3 28.7-64 64-64l88 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0 0-64L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm-64-64c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-208-64 0 0 208zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64zm-64 64c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6l0-8.6C384 71.6 312.4 0 224 0L162.3 0C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149l0 27c0 35.3 28.7 64 64 64l88 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c39.8 0 72 32.2 72 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPeace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c17.7 0 32 14.3 32 32l0 208-64 0 0-208c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zM93.3 51.2L175.9 240l-69.9 0L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5 69.9 0 26.1 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6l0 8.6c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363l0-27c0-32.7 24.6-59.7 56.3-63.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandMiddleFinger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 0c-22.1 0-40 17.9-40 40l0 164.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48l0 7 0 73c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-55.7c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334L32 372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L304 512c70.7 0 128-57.3 128-128l0-64 0-32c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2L272 40c0-22.1-17.9-40-40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandLizard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 112C0 85.5 21.5 64 48 64l112 0 80 0 46.5 0c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8l0 12 0 16 0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-13.8L273.9 352 240 352l-80 0-48 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l48 0 80 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-80 0L48 160c-26.5 0-48-21.5-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHolding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2c.3 0 .6 0 .9 0c0 0 0 0 0 0c-.3 0-.6 0-.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 24l0 56-56 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l56 0 0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-56 0 0-56c0-13.3-10.7-24-24-24L248 0c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0c0 0 0 0 0 0c-.3 0-.6 0-.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingHand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32L384 32l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-36.8 0-44.9 36c-22.7 18.2-50.9 28-80 28L304 224l-16 0-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-120.6 0L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160c0 0 0 0 0 0l.9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 480 32 480c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingDroplet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3l0 1.7c0 53-43 96-96 96s-96-43-96-96l0-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3s0 0 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandFist(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c17.7 0 32 14.3 32 32l0 112-64 0 0-112c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 80-64 0 0-80zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6l0 8.6c0 52.3-25.1 98.8-64 128l0 96c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-78.4c-17.3-7.9-33.2-18.8-46.9-32.5L69.5 357.5C45.5 333.5 32 300.9 32 267l0-27c0-35.3 28.7-64 64-64l88 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandBackFist(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 0C117.5 0 96 21.5 96 48l0 48 0 28.5L96 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-26.7-9 7.5C40.4 169 32 187 32 206L32 244c0 38 16.9 74 46.1 98.3L128 384l0 96c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-105.3c46.9-19 80-65 80-118.7l0-80 0-16 0-16c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHamsa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.6 288L80 288c8.8 0 16-7.2 16-16L96 72c0-22.1 17.9-40 40-40s40 17.9 40 40l0 132c0 11 9 20 20 20s20-9 20-20l0-164c0-22.1 17.9-40 40-40s40 17.9 40 40l0 164c0 11 9 20 20 20s20-9 20-20l0-132c0-22.1 17.9-40 40-40s40 17.9 40 40l0 200c0 8.8 7.2 16 16 16l45.4 0c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHammer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6l0-12.1L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0l18.1 0c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L32 64C14.3 64 0 78.3 0 96L0 208c0 17.7 14.3 32 32 32l10 0c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480l96 0c14.7 0 27.5-10 31-24.2L217 352l104.5 0c23.7 0 44.8-14.9 52.7-37.2L400.9 240l31.1 0c8.5 0 16.6-3.4 22.6-9.4L477.3 208l66.7 0c17.7 0 32-14.3 32-32l0-80c0-17.7-14.3-32-32-32l-16 0 0-8zM321.4 304L229 304l16-64 105 0-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128l384 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGuitar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGuaraniSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-17.7 0-32 14.3-32 32l0 34.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3l0 34.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-34.7c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32l-128 0 0-92c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7L224 32c0-17.7-14.3-32-32-32zM160 132L160 380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380l0-92 92 0c-11.6 45-47 80.4-92 92z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGroupArrowsRotate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4l0-60.5c0-5.7-4.7-10.4-10.4-10.4l-60.5 0c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4l0 60.5c0 5.7 4.7 10.4 10.4 10.4l60.5 0c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-192l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-192l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripLines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripLinesVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32L64 64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGreaterThan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGreaterThanEqual(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGraduationCap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9l0 28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5l0-24.6c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGopuram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 0c13.3 0 24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 0 32 0 64c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32l0 96c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-64 0 0-160-32 0 0-128-32 0 0-96-32 0 0 96 32 0 0 128 32 0 0 160-80 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 48-80 0 0-160 32 0 0-128 32 0 0-96-32 0 0 96-32 0 0 128-32 0 0 160-64 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l0-96c0-17.7 14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l0-64 0-32 0-8c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-32-80l0 32 64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGolfBallTee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192c0 66.8-34.1 125.6-85.8 160L85.8 352C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32l64 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0c-8.8 0-16 7.2-16 16l0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16c0-8.8-7.2-16-16-16l-16 0c-17.7 0-32-14.3-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 256c0 22.2-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm28.8-64l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0l-176.6 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6l176.6 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlasses(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1c0 0 .1 0 .1 0c0 0 0 0 0 0s0 0 0 0L247.9 288s0 0 0 0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7l40.6 0c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7s0 0 0 0c-6.3-12.7-6.3-12.7-6.3-12.7s0 0 0 0s0 0 0 0c0 0 .1 0 .1 0l.2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7l0 6.7 0 41.3 0 16c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L306.6 352l-37.2 0-1.2 22.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-41.3L0 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4L64 368c0 26.5 21.5 48 48 48l44.3 0c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368l0-42.6c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3l44.3 0c26.5 0 48-21.5 48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlassWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0L32 0zM73 156.5L66.4 64l251.3 0L311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlassWaterDroplet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0L32 0zM83 297.5L66.4 64l251.3 0L301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGifts(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96 48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l152.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-224c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96l-22.2 0 28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224 344 224c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24l-4.1 0c-26.5 0-48 21.5-48 48l0 80 192 0 0-96 32 0 0 96 192 0 0-80c0-26.5-21.5-48-48-48l-4.1 0c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48l144 0 0-128-192 0 0 80zm224 48l144 0c26.5 0 48-21.5 48-48l0-80-192 0 0 128zm96-312c0 13.3-10.7 24-24 24l-49.1 0 29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 176c0 26.5 21.5 48 48 48l144 0 0-224L32 288zM288 512l144 0c26.5 0 48-21.5 48-48l0-176-192 0 0 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGhost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2L0 192C0 86 86 0 192 0S384 86 384 192l0 270.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGenderless(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGem(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8l-.7 0c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGavel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGauge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3L280 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGaugeSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3L280 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGaugeSimpleHigh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGaugeHigh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGasPump(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64C32 28.7 60.7 0 96 0L256 0c35.3 0 64 28.7 64 64l0 192 8 0c48.6 0 88 39.4 88 88l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-154c-27.6-7.1-48-32.2-48-62l0-64L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3l0 13.5 0 24 0 32 0 152c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-32c0-22.1-17.9-40-40-40l-8 0 0 144c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 64zM96 80l0 96c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L112 64c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGamepad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 64C86 64 0 150 0 256S86 448 192 448l256 0c106 0 192-86 192-192s-86-192-192-192L192 64zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaG(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128L256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l144 0c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFutbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6l59.2 0c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFrog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416l50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416l90.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 480c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFrancSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 32C62.3 32 48 46.3 48 64l0 160 0 96-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0-64 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-96 176 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416L0 96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3l0 41.7 0 41.7L52.5 440.6zM256 352l0-96 0-128 0-32c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29l0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaForwardStep(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416L0 96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241l0-145c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-145-11.5 9.6-192 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaForwardFast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7 224 416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7 448 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 118.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96l0 118.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96L0 416c0 12.4 7.2 23.7 18.4 29z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFootball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6C47.8 183.4 35.1 215.9 26.9 249L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFont(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416 32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-1.8 0 18-48 159.6 0 18 48-1.8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-25.8 0L254 52.8zM279.8 304l-111.6 0L224 155.1 279.8 304z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderTree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32l0 96L0 384c0 35.3 28.7 64 64 64l192 0 0-64L64 384l0-224 192 0 0-64L64 96l0-64zM288 192c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-98.7 0c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4L320 0c-17.7 0-32 14.3-32 32l0 160zm0 288c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-98.7 0c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4L320 288c-17.7 0-32 14.3-32 32l0 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88.7 223.8L0 375.8 0 96C0 60.7 28.7 32 64 32l117.5 0c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7L416 96c35.3 0 64 28.7 64 64l0 32-336 0c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224l400 0c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480L32 480c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderClosed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 480L64 480c-35.3 0-64-28.7-64-64L0 192l512 0 0 224c0 35.3-28.7 64-64 64zm64-320L0 160 0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlorinSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224 64 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l37.3 0c38.8 0 73.7-23.3 88.6-59.1L213.3 288 320 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 45.1-108.3c5-11.9 16.6-19.7 29.5-19.7L352 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-37.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFloppyDisk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0L160 0 128 0C110.3 0 96 14.3 96 32s14.3 32 32 32l0 132.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512l309.2 0c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5L320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 0zM192 196.8L192 64l64 0 0 132.8c0 23.7 6.6 46.9 19 67.1L309.5 320l-171 0L173 263.9c12.4-20.2 19-43.4 19-67.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlaskVial(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96L32 64C14.3 64 0 49.7 0 32S14.3 0 32 0L96 0l64 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 245.9-49 79.6zM96 64l0 96 64 0 0-96L96 64zM352 0L480 0l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 150.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4l-309.2 0c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9 320 64c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0zm32 64l0 160c0 5.9-1.6 11.7-4.7 16.8L330.5 320l171 0-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8l0-160-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 64 0 368 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-247.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48l0-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlagUsa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C49.7 0 64 14.3 64 32l0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 36.1-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9l0 32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3l0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1l0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3l0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1l0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3l0 33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400l0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-70.5 0-32.7 0-63.3 0-32.7 0-63.3 0-32.7L0 64 0 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlagCheckered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C49.7 0 64 14.3 64 32l0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 279.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80 0-66L0 64 0 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9 0 65.5L64 252.6 64 318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3l0-63.9 38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9 0 66.7-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8l0 71.4c21.8 1.9 43.3 6.7 64 14.4l0-69.8 22.7 6.7c13.5 4 27.3 6.4 41.3 7.4l0-64.2c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12 0-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8l0 72.4c-13-.4-26 .8-38.7 3.6L128 173.2 128 98 64 114l0 73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2 0-71.7-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5l0 77.4zm64-149.4l0-70.8c-20.9 6.1-42.4 9.1-64 9.1l0 69.4c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFishFins(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.6 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.6 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFireFlameSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFireFlameCurved(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFireExtinguisher(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.3 7.3C507.7 13.3 512 22.4 512 32l0 96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104l-65 0 0 34.8c37.8 18 64 56.5 64 101.2l0 144L64 384l0-144c0-44.7 26.2-83.2 64-101.2l0-28.8c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4L128 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 24 65 0c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416l0 32c0 35.3-28.7 64-64 64l-96 0c-35.3 0-64-28.7-64-64l0-32 224 0zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFireBurner(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M345.7 48.3L358 34.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C469 131.2 480 162.2 480 192.2C480 280.8 408.7 352 320 352c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2C273.4 2.3 280.7-.2 288 0c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM384 240.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C293 167.1 256 203.6 256 240.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM32 288c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 64 448 0 0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l0-96zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFingerprint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128l0 24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7l0-24.9c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256l0 24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8l0-24.9c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96l0 24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1l0-24.9c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9l0-24.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilterCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 22.9C10.5 8.9 24.5 0 40 0L472 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilterCircleDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 22.9C10.5 8.9 24.5 0 40 0L472 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM48 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM48 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM48 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L64 96c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM160 128l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L192 96c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L386.7 288 67.5 288c1.4-5.4 4.2-10.4 8.4-14.6L168 181.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFillDrip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6l319.2 0 42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileZipper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM96 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8l14.8 0c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileWord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileWaveform(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C60.7 0 32 28.7 32 64l0 224 112 0c6.1 0 11.6 3.4 14.3 8.8L176 332.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L281.9 288l70.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320 32 320l0 128c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L256 0 96 0zM288 0l0 128 128 0L288 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM64 288c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96zM300.9 397.9L256 368l0-64 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileSignature(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-19.3c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2l-64 0c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2L80 448c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 8.9 0c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6l0-43.6-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 47-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilePrescription(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM104 196l72 0c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6l-20 0 0 44c0 11-9 20-20 20s-20-9-20-20l0-64 0-80c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20l-52 0 0 40 52 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilePowerpoint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM136 240l68 0c42 0 76 34 76 76s-34 76-76 76l-44 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-104c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28l-44 0 0 56 44 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilePen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 125.7-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilePdf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM160 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileLines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM112 256l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileInvoice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 192 0 0-64L96 256zM240 416l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileInvoiceDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM64 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16l0 17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1s0 0 0 0s0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1l0 17.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17.8c-11.2-2.1-21.7-5.7-30.9-8.9c0 0 0 0 0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5s0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7l0-17.3c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileImport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64c0-35.3 28.7-64 64-64L352 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-112 174.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L128 288l0-224zm0 224l0 48L24 336c-13.3 0-24-10.7-24-24s10.7-24 24-24l104 0zM512 128l-128 0L384 0 512 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6l-88 0-40 0-48 0-48 0c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileHalfDashed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 320l384 0 0-160-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM0 416l64 0 0-64L0 352l0 64zm288 32l-80 0 0 64 80 0 0-64zm-112 0l-80 0 0 64 80 0 0-64zM64 448L0 448c0 35.3 28.7 64 64 64l0-64zm256 0l0 64c35.3 0 64-28.7 64-64l-64 0zm64-32l0-64-64 0 0 64 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileFragment(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64l-128 0 0-128c0-35.3-28.7-64-64-64L0 320 0 64zm384 64l-128 0L256 0 384 128zM32 352l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileExport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 128-168 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l168 0 0 112c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM384 336l0-48 110.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L384 336zm0-208l-128 0L256 0 384 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileExcel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCsv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm133.1 0l34.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-34.9 0c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1L304 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l42.9 0c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileContract(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2L80 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 54.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCircleQuestion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2l0 14.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-5.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0c-23 0-41.6 18.6-41.6 41.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCirclePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCircleMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileAudio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8l0 128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376 80 376c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l33.4 0 35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31L216 408z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 232l0 102.1 31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L168 232c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFerry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0L352 0c17.7 0 32 14.3 32 32l75.1 0c20.6 0 31.6 24.3 18.1 39.8L456 96 120 96 98.8 71.8C85.3 56.3 96.3 32 116.9 32L192 32c0-17.7 14.3-32 32-32zM96 128l384 0c17.7 0 32 14.3 32 32l0 123.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9l-16.5 0c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9l-16.6 0c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5L64 160c0-17.7 14.3-32 32-32zm32 64l0 96 320 0 0-96-320 0zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFeather(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 68 0c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330l0 55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFeatherPointed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFax(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64l0 96 64 0 0-96 194.7 0L416 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0L192 0c-35.3 0-64 28.7-64 64zM0 160L0 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm480 32l-352 0 0 288c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaucet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96l0 12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12 0-12c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l100.1 0c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48l36.1 0c17.7 0 32 14.3 32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160l-32 0-22.6-22.6c-6-6-14.1-9.4-22.6-9.4L256 224l0-43.8-32-4-32 4 0 43.8-18.7 0c-8.5 0-16.6 3.4-22.6 9.4L128 256l-96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaucetDrip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c17.7 0 32 14.3 32 32l0 12 96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12 0-12c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32l96 0 22.6-22.6c6-6 14.1-9.4 22.6-9.4l18.7 0 0-43.8 32-4 32 4 0 43.8 18.7 0c8.5 0 16.6 3.4 22.6 9.4L320 192l32 0c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s-14.3-32-32-32l-36.1 0c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48L32 320c-17.7 0-32-14.3-32-32l0-64zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224l-2.6 0C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480l0 2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288l2.6 0c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32l0-2.6C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceTired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3l-3.2 0c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceSurprise(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceSmileWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceSmileBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceSadTear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceSadCry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6L160 288c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 189.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8L384 288c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 205.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceRollingEyes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceMeh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceMehBlank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceLaugh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceLaughWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceLaughSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceLaughBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceKiss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceKissWinkHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceKissBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinWide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinTongue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448l0-45.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 45.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinTongueWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448l0-46.9c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2l0 47.3c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6l0 45.4c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-45.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinTongueSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448l0-45.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 45.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinStars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinSquintTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-16.3 4.4-34.1 7.5-46.3 9.3c-1.6 .2-3.1 .5-4.6 .6c-4.9 .8-9.1-2.8-9.5-7.4c-.1-.7 0-1.4 .1-2.1c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c.4-.1 .7-.1 1-.1c5.1-.2 9.2 4.3 8.4 9.6c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8 .3c-19 35.5-45 70.8-77.5 103.3S244.8 371.1 209.3 390c-11.3 6-12.2 22.1-.3 26.8c57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinHearts(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrinBeamSweat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM383.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7zm-166.2-89s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceGrimace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112l-8 0 0-40 55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344l0-40 8 0c23.8 0 43.5 17.3 47.3 40zM328 344l-64 0 0-40 64 0 0 40zm0 56l-64 0 0-40 64 0 0 40zm-80-96l0 40-64 0 0-40 64 0zm0 56l0 40-64 0 0-40 64 0zm-80-16l-55.3 0c3.8-22.7 23.6-40 47.3-40l8 0 0 40zm0 56l-8 0c-23.8 0-43.5-17.3-47.3-40l55.3 0 0 40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceFrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceFrownOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceFlushed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 384c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceDizzy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaceAngry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaF(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 256 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 224 64 96l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEyeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEyeLowVision(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7c60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3L223 149.5zm223.1 298L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEyeDropper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6l0 42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480l42.4 0c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7L96 416l0-36.1c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExplosion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87-71.4 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64l-79.6 0L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448s0 0 0 0l448 0s0 0 0 0l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0zM288 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExpand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 128 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64c0-17.7-14.3-32-32-32S32 46.3 32 64l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32L96 64zM64 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEuroSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.1 240c-.1 2.7-.1 5.3-.1 8l0 16c0 2.7 0 5.3 .1 8L32 272c-17.7 0-32 14.3-32 32s14.3 32 32 32l28.3 0C89.9 419.9 170 480 264 480l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0c-57.9 0-108.2-32.4-133.9-80L256 336c17.7 0 32-14.3 32-32s-14.3-32-32-32l-143.8 0c-.1-2.6-.2-5.3-.2-8l0-16c0-2.7 .1-5.4 .2-8L256 240c17.7 0 32-14.3 32-32s-14.3-32-32-32l-125.9 0c25.7-47.6 76-80 133.9-80l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0C170 32 89.9 92.1 60.3 176L32 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l16.1 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEthernet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224L0 416c0 17.7 14.3 32 32 32l64 0 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 64 0 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 64 0 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 64 0 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 64 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32L160 64c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEraser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7L288 480l9.4 0L512 480c17.7 0 32-14.3 32-32s-14.3-32-32-32l-124.1 0L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416l-9.4 0-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEquals(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 128zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelopesBulk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C110.3 0 96 14.3 96 32l0 192 96 0 0-32c0-35.3 28.7-64 64-64l224 0 0-96c0-17.7-14.3-32-32-32L128 0zM256 160c-17.7 0-32 14.3-32 32l0 32 96 0c35.3 0 64 28.7 64 64l0 128 192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-320 0zm240 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32l0 13L187.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301l0-13c0-17.7-14.3-32-32-32L64 256zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8 32 480c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-139.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 208.1L256 65.9 448 208.1l0 47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5l0-47.4zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-239.9c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelopeOpenText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.4 96L144 96l-36.2 0L96 96l0 8.8L96 144l0 40.4 0 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3 48 96c0-26.5 21.5-48 48-48l76.6 0 49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48 416 48c26.5 0 48 21.5 48 48l0 44.3 22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4l0-89 0-40.4 0-39.2 0-8.8-11.8 0L368 96l-71.4 0-81.3 0zM0 448L0 242.1 217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1 512 448s0 0 0 0c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0zM176 160l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelopeCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176 0 384c0 35.3 28.7 64 64 64l296.2 0C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEllipsis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEllipsisVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 128 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaElevator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l128 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 128zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-16zm192 0c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-16zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0L304 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320L48 320c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEgg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEarthOceania(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3l-29.9 0c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEarthEurope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1l0 9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1l1 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24l0 4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6l29.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-20.7 0c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3l11.3 0c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16l7.3 0c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4l-20.9 0c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3l0 3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3l21.3 0c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEarthAsia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9l2.3 0c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEarthAmericas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEarthAfrica(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9l0 41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32l0 28c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16l0 48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4l0-12.1c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEarListen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1c0 0 0 0-.1 0c0 0 0 0 0 0L384 32 398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78l0 6.1c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112l0-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEarDeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7l0 6.1c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48l0-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaE(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 256 0 416c0 35.3 28.7 64 64 64l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 416l0-128 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 224 64 96l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDungeon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9l80 0c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24l80 0c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288l-80 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-80 0zM24 416c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-80 0zm384 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-80 0zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16l0-272zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDumpster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160l94 0L140.5 32 49.7 32zM272 160l0-128-98.9 0L147.5 160 272 160zm32 0l124.5 0L402.9 32 304 32l0 128zm157.1 0l94 0c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32l-90.8 0 25.6 128zM32 192l4 32-4 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l12 0L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32l320 0c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160 12 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-4 0 4-32L32 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDumpsterFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M49.7 32l90.8 0L114.9 160l-94 0C9.3 160 0 150.7 0 139.1c0-2.1 .3-4.1 .9-6.1L26.8 48.9C29.9 38.9 39.2 32 49.7 32zM272 160l-124.5 0L173.1 32 272 32l0 128zm32 0l0-128 98.9 0 14.4 72.1c-1.7 1.1-3.3 2.4-4.8 3.8c-18.4 16.4-35.4 34-50.5 52.1l-58 0zm209.9-23.7c-1.7 1.6-3.4 3.2-5 4.8C498 129.6 486.7 118.6 475 108c-7.6-6.9-17-10.8-26.6-11.8L435.5 32l90.8 0c10.5 0 19.8 6.9 22.9 16.9L575.1 133c.2 .7 .4 1.4 .5 2.1c-17.8-15-44.3-14.6-61.7 1.2zM325.2 210.7C304.3 244.5 288 282.9 288 318.1c0 49.3 18.6 95.2 49.6 129.9L128 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L44 288l-12 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l4 0-4-32 305.5 0c-4.4 6.2-8.5 12.5-12.3 18.7zm180.6-34.5L518 162.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 259.2 640 290.2 640 320.2C640 408.8 568.7 480 480 480c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 368.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 295.1 416 331.6 416 368.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDumbbell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 160 0 64 0 160c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64-32 0c-17.7 0-32-14.3-32-32l0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l32 0 0-64zm448 0l0 64 32 0c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 64c0 17.7-14.3 32-32 32l-32 0 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-160 0-64 0-160c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32zM416 224l0 64-192 0 0-64 192 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrumstickBite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4l89.2 0c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176l0 89.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208L0 368c0 31.3 27.4 58.8 72 78.7L72 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 119.4c33 8.9 71.1 14.5 112 16.1L232 376c0-13.3 10.7-24 24-24s24 10.7 24 24l0 103.5c40.9-1.6 79-7.2 112-16.1L392 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 102.7c44.6-19.9 72-47.4 72-78.7l0-160c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrumSteelpan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c159.1 0 288 48 288 128l0 192c0 80-128.9 128-288 128S0 432 0 352L0 160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDroplet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0l1.8 0c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDropletSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.2 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrawPolygon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 151.4l0 209.1c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56s0 0 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1c0 0 0 0 0 0l32-56 4.5-7.9-.1-.3-209.1 0c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-209.1 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-209.1C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32l209.1 0c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDragon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0L416 0l32 0 16 0c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48l-21.5 0c-17 0-33.3-6.7-45.3-18.7L480 160l-32 0 0 21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512L496 512l-64 0L32.3 512c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1l0-45.5 0-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3l0 .6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87 0 27.5c0 32.8 8.4 64.8 24 93l-232 0c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDownLong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDownLeftAndUpRightToCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8l-144 0c-13.3 0-24-10.7-24-24l0-144c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272l144 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6l0-31.5C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144l0 30.6s0 0 0 0l0 1.3s0 0 0 0l0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448l74.4 0c88.4 0 160-71.6 160-160l0-160 29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3L400 64c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDoorOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5L64 448l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 192 0 32 0 0-32 0-448zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128l96 0 0 352c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320c0-35.3-28.7-64-64-64l-96 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDoorClosed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64c0-35.3 28.7-64 64-64L416 0c35.3 0 64 28.7 64 64l0 384 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-112 0-288 0L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0L96 64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDongSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32l0-96 0-160c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDolly(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0l72.9 0c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64 32 64C14.3 64 0 49.7 0 32zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDollarSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c17.7 0 32 14.3 32 32l0 35.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11l0 33.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.9c-.4-.1-.9-.1-1.3-.2l-.2 0s0 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7s0 0 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11L128 32c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32l52.1 0c12.7 0 24.9 5.1 33.9 14.1L496 64l56 0c13.3 0 24 10.7 24 24l0 24c0 44.2-35.8 80-80 80l-32 0-16 0-21.3 0-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-115.2c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2L160 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-230.2c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192l30 0 16 0 159.8 0L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDna(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0l-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5l118.5 0c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32L64 480c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32l320 0c0-17.7 14.3-32 32-32zM338.6 384l-229.2 0c-10.1 10.6-18.6 21.3-25.5 32l280.2 0c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128l229.2 0c10.1-10.7 18.6-21.3 25.5-32L83.9 96c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5l-118.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDivide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDisplay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l176 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-69.3 0L336 416l176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM512 64l0 288L64 352 64 64l448 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDisease(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6l10 0c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-114.3 0c11.6 36 3.1 77-25.4 105.5L320 413.8l0 34.2zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceTwo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceThree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceSix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceOne(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceFour(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceFive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceD6(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14l0 216c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381L0 184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8l0 197c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8l0-216c0-5.9 3.2-11.2 8.3-14l176-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceD20(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM16 171.7l0 123.5c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158C29.6 151.6 16 159.3 16 171.7zM310.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4l0-123.5zm-49.3 246L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9l0 52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8l0-52.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM41.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9l-145.7 0c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM174.4 176l163.2 0c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2l-3.2 0c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiamond(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiamondTurnRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 56-64 0c-35.3 0-64 28.7-64 64l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-8.8 7.2-16 16-16l64 0 0 56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiagramSuccessor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiagramProject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 16 192 0 0-16c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-16-192 0 0 16c0 1.7-.1 3.4-.3 5L272 288l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-1.7 .1-3.4 .3-5L144 224l-96 0c-26.5 0-48-21.5-48-48L0 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiagramPredecessor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiagramNext(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 160c0 35.3-28.7 64-64 64l-168 0 0 64 46.1 0c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41l46.1 0 0-64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64zM448 416l0-64-82.7 0 .4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4L64 352l0 64 146.7 0 5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7L448 416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDharmachakra(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDesktop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l176 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-69.3 0L336 416l176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM512 64l0 224L64 288 64 64l448 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDemocrat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8L480 160l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17l0 87.4-352 0-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3l-2 0C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352l96 0 0 64 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64-160 0 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64 0-64 96 0 160 0zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeleteLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 128c0-35.3-28.7-64-64-64L205.3 64c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7L512 448c35.3 0 64-28.7 64-64l0-256zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDatabase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80l0 48c0 44.2-100.3 80-224 80S0 172.2 0 128L0 80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6L448 288c0 44.2-100.3 80-224 80S0 332.2 0 288L0 186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6l0 85.9c0 44.2-100.3 80-224 80S0 476.2 0 432l0-85.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaD(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l96 0c123.7 0 224 100.3 224 224s-100.3 224-224 224l-96 0c-35.3 0-64-28.7-64-64L0 96zm160 0L64 96l0 320 96 0c88.4 0 160-71.6 160-160s-71.6-160-160-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCubes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5l0 112.2c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7L0 413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3l0-119.1c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3l0-112.2c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2 0-89.2L392 121l0 89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4l0-100.5L256 323.2l0 95.9-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1 0-100.5L528 323.2l0 90.7c0 3.2-1.9 6-4.8 7.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCubesStacked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 64l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zm64 160c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM160 384l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6l0 242.9c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4L0 134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1 0-188L288 246.6l0 188z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCruzeiroSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416l0-96 0-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32l0 55.3 0 8.7 0 82.7C135.5 378 96 321.6 96 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrutch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 0c-48.6 0-88 39.4-88 88l0 29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384l133.1 0 46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384l40.9 0c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192l0-64 0-8 80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32l-50.1 0C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrosshairs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c17.7 0 32 14.3 32 32l0 10.4c93.7 13.9 167.7 88 181.6 181.6l10.4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-10.4 0c-13.9 93.7-88 167.7-181.6 181.6l0 10.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-10.4C130.3 455.7 56.3 381.7 42.4 288L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l10.4 0C56.3 130.3 130.3 56.3 224 42.4L224 32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6l0-20.6c0-17.7 14.3-32 32-32s32 14.3 32 32l0 20.6c58.3-12.5 104.1-58.4 116.6-116.6L384 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l20.6 0C392.1 165.7 346.3 119.9 288 107.4l0 20.6c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-20.6C165.7 119.9 119.9 165.7 107.4 224l20.6 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-20.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCross(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 0c-26.5 0-48 21.5-48 48l0 80-80 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l80 0 0 208c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-208 80 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-80 0 0-80c0-26.5-21.5-48-48-48L176 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64l0 64 178.7 0L128 338.7 128 32c0-17.7-14.3-32-32-32S64 14.3 64 32l0 32L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l32 0 0 256c0 35.3 28.7 64 64 64l224 0 0-64-178.7 0L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-274.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCropSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32l0 32L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l32 0 0 256c0 35.3 28.7 64 64 64l224 0 0-64-224 0 0-352zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-256c0-35.3-28.7-64-64-64L160 64l0 64 224 0 0 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96l0 32 576 0 0-32c0-35.3-28.7-64-64-64L64 32zM576 224L0 224 0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-192zM112 352l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 224l0 32 0 160c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-88.2c9.9 6.6 20.6 12 32 16.1l0 24.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16.9c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9l0 16.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24.2c11.4-4 22.1-9.4 32-16.1l0 88.2c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-160 32 32 0 49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5 0-81.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 14.4-52.9-74.1C496 86.5 452.4 64 405.9 64L272 64l-16 0-64 0-48 0C77.7 64 24 117.7 24 184l0 54C9.4 249.8 0 267.8 0 288l0 17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4l0-6.4 0-32 0-40c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160l0 64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6l178.7 0c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCouch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 160C64 89.3 121.3 32 192 32l256 0c70.7 0 128 57.3 128 128l0 33.6c-36.5 7.4-64 39.7-64 78.4l0 48-384 0 0-48c0-38.7-27.5-71-64-78.4L64 160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48l0 176c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L96 448c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L0 272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3l0 48 0 32 32 0 384 0 32 0 0-32 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCopyright(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCookie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCookieBite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaComputer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 96l0 224L64 320 64 96l320 0zM64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64l117.3 0-10.7 32L96 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-74.7 0-10.7-32L384 384c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 32zm464 0c-26.5 0-48 21.5-48 48l0 352c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-64 0zm16 64l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaComputerMouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 192l176 0L176 0 160 0C71.6 0 0 71.6 0 160l0 32zm0 32L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-128-192 0L0 224zm384-32l0-32C384 71.6 312.4 0 224 0L208 0l0 192 176 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompassDrafting(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192c0 0 0 0 0 0s0 0 0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496l0-55.4c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1l0 55.4c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompactDisc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaComments(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2s0 0 0 0s0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9c0 0 0 0 0 0s0 0 0 0l-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentsDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9c0 0 0 0 0 0s0 0 0 0l.2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2s0 0 0 0s0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7L228 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaComment(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentSms(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM96 212.8c0-20.3 16.5-36.8 36.8-36.8l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.3 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L112 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 236.7 96 225.2 96 212.8zM372.8 176l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L352 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7c0-20.3 16.5-36.8 36.8-36.8zm-152 6.4L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-6.9 4.4-13 10.9-15.2s13.7 .1 17.9 5.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zm385.2 425L82.9 161.3C70.7 185.6 64 212.2 64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104.1-17.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentNodes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448c10.8 0 21.5-.5 32-1.6c.3-15.8 4.4-31.7 12.9-46.4c16-27.7 43.7-44.4 73.2-47.5l16.7-29.2c-4.3-11-6.7-22.9-6.7-35.4c0-53 43-96 96-96c9.1 0 17.8 1.3 26.2 3.6C481.1 102.1 378.6 32 256 32C114.6 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.2 .3-.4 .5-.6 .7c-.3 .3-.5 .5-.6 .7l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm72.6-32c-17.7 30.6-7.2 69.7 23.4 87.4s69.7 7.2 87.4-23.4c1.5-2.6 2.8-5.3 3.9-8l73.3 0c1.1 2.7 2.4 5.4 3.9 8c17.7 30.6 56.8 41.1 87.4 23.4s41.1-56.8 23.4-87.4c-13.4-23.2-39.1-34.8-64-31.4l-17.6-30.7c-11 11.7-25 20.6-40.6 25.6l16.5 28.9c-3.8 4.8-6.8 10-9 15.6l-73.4 0c-2.2-5.6-5.3-10.8-9-15.6l33-57.7c4.1 .8 8.4 1.3 12.8 1.3c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 13.4 4.1 25.8 11.2 36.1l-34.6 60.5c-25-3.4-50.6 8.3-64 31.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c0 0 0 0 0 0c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaColonSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.2 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCoins(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2c0 0 0 0 0 0s0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4l0 3.4 0 5.7 0 26.3zm32 0l0-32 0-25.9c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodePullRequest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.8 2.1C314.4 5.9 320 14.5 320 24l0 40 16 0c70.7 0 128 57.3 128 128l0 166.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3L400 192c0-35.3-28.7-64-64-64l-16 0 0 40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3l0 205.3c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-205.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodeMerge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3l0 205.3C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-86.6c26.7 20.1 60 32 96 32l86.7 0c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48L208 240c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodeFork(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3l0 38.7c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-38.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3l0 38.7c0 53-43 96-96 96l-48 0 0 70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-70.7-48 0c-53 0-96-43-96-96l0-38.7C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodeCompare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9l0 40 16 0c35.3 0 64-28.7 64-64l0-166.7C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3L464 320c0 70.7-57.3 128-128 128l-16 0 0 40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9l0-40-16 0c-35.3 0-64 28.7-64 64l0 166.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3L48 192c0-70.7 57.3-128 128-128l16 0 0-40zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodeCommit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l131.2 0C178 151 242.6 96 320 96s142 55 156.8 128L608 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-131.2 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodeBranch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3l0 87.8c18.8-10.9 40.7-17.1 64-17.1l96 0c35.3 0 64-28.7 64-64l0-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3l0 6.7c0 70.7-57.3 128-128 128l-96 0c-35.3 0-64 28.7-64 64l0 6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-6.7 0-198.7C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClover(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216.6 49.9C205.1 38.5 189.5 32 173.3 32C139.4 32 112 59.4 112 93.3l0 4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4l-4.9 0C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368l4.9 0c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34l0 4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3l0-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4l4.9 0c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3l-4.9 0c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34l0-4.9C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM639.9 431.9c0 44.2-35.8 80-80 80l-271.9 0c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudSunRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80l-271.9 0c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudShowersWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64l1.6 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudShowersHeavy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 320zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM313.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 320zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3l0 3c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3l0 3c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3l0 3c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-3c0-8.5 2.1-16.9 6.2-24.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80L96 511.9c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudMoonRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96l271.9 0zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudMeatball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224c0 53 43 96 96 96l44.7 0c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40l44.7 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224c0 53 43 96 96 96l47.2 0L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320l18.3 0 64 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 134.1-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClosedCaptioning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 448L64 448l0-224 64 0 0-64-64 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-64-64 0 0 64zm-64-96l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClockRotateLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M75 75L41 41C25.9 25.9 0 36.6 0 57.9L0 168c0 13.3 10.7 24 24 24l110.1 0c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1c0-13.3-10.7-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboardUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 448c-8.8 0-16-7.2-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboardQuestion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboardList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboardCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClapperboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32l-86.1 0-1 1-127 127 92.1 0 1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128l0-64c0-15.1-5.3-29.1-14-40l-104 104L512 160zM294.1 32l-92.1 0-1 1L73.9 160l92.1 0 1-1 127-127zM64 32C28.7 32 0 60.7 0 96l0 64 6.1 0 1-1 127-127L64 32zM512 192L0 192 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 48c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48l0 48-64 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-64 0 0-72c0-13.3-10.7-24-24-24S64 10.7 64 24l0 72L48 96C21.5 96 0 117.5 0 144l0 96L0 464c0 26.5 21.5 48 48 48l256 0 32 0 96 0 160 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-112 0 0-144zm96 320l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM240 416l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM560 256c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM256 176l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM256 304c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM112 320l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zm304-48l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zm16 112l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm11.3-395.3l112 112c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-64 0 0 96c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96-64 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm395.3 11.3l-112 112c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-64-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-64c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l112 112c6.2 6.2 6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleRadiation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleQuestion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCirclePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCirclePlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCirclePause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleNotch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleNodes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM116.7 244.7l112-112c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8l0 64 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 64c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-112-112c-6.2-6.2-6.2-16.4 0-22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleInfo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleHalfStroke(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 256c0-106-86-192-192-192l0 384c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM244.7 395.3l-112-112c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l64 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 64 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-112 112c-6.2 6.2-16.4 6.2-22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleDot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleDollarToSlot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3l-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1l0 6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1l0 6.4c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1l0-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4l0-6.3c0-11.1-9-20.1-20.1-20.1zM48 352l16 0c19.5 25.9 44 47.7 72.2 64L64 416l0 32 192 0 192 0 0-32-72.2 0c28.2-16.3 52.8-38.1 72.2-64l16 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 215c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71L280 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-214.1-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 103c9.4-9.4 24.6-9.4 33.9 0L385 215z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM297 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l214.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L409 239c9.4 9.4 9.4 24.6 0 33.9L297 385z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM215 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L392 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-214.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L215 127z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM127 297c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 214.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 409c-9.4 9.4-24.6 9.4-33.9 0L127 297z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChurch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2L160 512l96 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 96 0 0-260.8c0-16.9-8.8-32.5-23.3-41.2L344 142.4 344 96l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4L0 464c0 26.5 21.5 48 48 48l80 0 0-238.4L24.9 330.3zM592 512c26.5 0 48-21.5 48-48l0-91.6c0-17.5-9.5-33.6-24.9-42.1L512 273.6 512 512l80 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChildren(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM88 480l0-80-17.8 0c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1L232 400l0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80-16 0 0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128A64 64 0 1 1 480 0zm-8 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-179.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9l12.3 0c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5 552 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-16 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChild(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm48 320l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192.2L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8 240 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChildReaching(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64A64 64 0 1 0 128 64a64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4L112 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 32 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-258.4c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChildDress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400l0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 16 0 0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 17.8 0c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400L88 400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChildCombatant(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-8 352l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-179.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9l-12.3 0c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5 104 480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0L432 0 416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 100.3c-9.6 5.5-16 15.9-16 27.7l0 32c-17.7 0-32 14.3-32 32l0 144c0 17.7 14.3 32 32 32l16 0 0 96c0 8.8 7.2 16 16 16l59.5 0c10.4 0 18-9.8 15.5-19.9L484 400l44 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0 0-26.7 53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2l0-84.5c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 56-16 5.3L480 160c0-11.8-6.4-22.2-16-27.7L464 16c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32L60.2 96C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208 72 208c-13.3 0-24 10.7-24 24s10.7 24 24 24l4 0L60 384l136 0L180 256l4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-1.8 0 32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2L144 96l0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416 48 416zm288 0l-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416l-128 0zM304 208l0 51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384l125.5 0-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7l0-51.5c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 16-24 0 0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 16-24 0 0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32-32 0 0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessRook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 192L32 48c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 40c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-40c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 40c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-40c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 144c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144L80 400 96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96l32 0c8.8 0 16-7.2 16-16l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432l320 0 41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L38.6 512C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessQueen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400 384 400l-40.4 0-175.1 0L128 400l-15.7 0L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224s0 0 0 0s0 0 0 0s0 0 0 0zM112 432l288 0 41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L86.6 512C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessPawn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88L96 224c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400l160 0L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32l-8.5 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512l242.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432 64 432 22.6 473.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessKnight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5l0 132.4c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400l320 0 28.9-159c2.1-11.3 3.1-22.8 3.1-34.3l0-14.7C416 86 330 0 224 0L83.8 0C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512l370.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432 64 432 22.6 473.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessKing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c17.7 0 32 14.3 32 32l0 16 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 48 152 0c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400 80 400 3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40l152 0 0-48-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-16c0-17.7 14.3-32 32-32zM38.6 473.4L80 432l288 0 41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L54.6 512C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessBoard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 64l0 64 64 0 0-64 64 0 0 64 64 0 0-64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64 64 0zm64 128l64 0 0-64-64 0 0 64zm0 64l0-64-64 0 0 64 64 0zm64 0l-64 0 0 64 64 0 0-64zm0 0l64 0 0-64-64 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessBishop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7L64 400l192 0 0-27.3c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32L128 0zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512l274.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432 48 432z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheese(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 240.2l0 15.8L0 256c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8l0 128c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 288l512 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheckToSlot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 80c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 304L96 384 96 80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48l16 0 0 128 448 0 0-128 16 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheckDouble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-352zM0 272c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 272zM368 96l32 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartPie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 240l0-223.4c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16L304 240zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4L256 288 412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288l238.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartGantt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zm96 64l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartDiagram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 32C53.5 32 32 53.5 32 80s21.5 48 48 48l152 0 0 40-48 48-56 0c-48.6 0-88 39.4-88 88l0 48-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-48c0-22.1 17.9-40 40-40l56 0 48 48 0 40-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-40 48-48 56 0c22.1 0 40 17.9 40 40l0 48-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-48c0-48.6-39.4-88-88-88l-56 0-48-48 0-40 152 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L80 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartColumn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm128-64l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zM480 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartArea(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm96 288l288 0c17.7 0 32-14.3 32-32l0-68.2c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1l0 84c0 17.7 14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChargingStation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C60.7 0 32 28.7 32 64l0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-144 16 0c22.1 0 40 17.9 40 40l0 32c0 39.8 32.2 72 72 72s72-32.2 72-72l0-123.7c32.5-10.2 56-40.5 56-76.3l0-32c0-8.8-7.2-16-16-16l-16 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-16 0c-8.8 0-16 7.2-16 16l0 32c0 35.8 23.5 66.1 56 76.3L472 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-48.6-39.4-88-88-88l-16 0 0-192c0-35.3-28.7-64-64-64L96 0zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9 57.8 0c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9L96 208c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChampagneGlasses(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChalkboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32C60.7 32 32 60.7 32 96l0 288 64 0L96 96l384 0 0 288 64 0 0-288c0-35.3-28.7-64-64-64L96 32zM224 384l0 32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0 0-32c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChalkboardUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-239.2 0c-11.8-25.5-29.9-47.5-52.4-64l99.6 0 0-32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 32 64 0 0-288L224 64l0 49.1C205.2 102.2 183.3 96 160 96l0-32zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChair(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 48l0 208 48 0 0-197.3c23.9 13.8 40 39.7 40 69.3l0 128 48 0 0-128C384 57.3 326.7 0 256 0L192 0C121.3 0 64 57.3 64 128l0 128 48 0 0-128c0-29.6 16.1-55.5 40-69.3L152 256l48 0 0-208 48 0zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 256 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288L48 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCertificate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCentSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c17.7 0 32 14.3 32 32l0 34.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8l0 34.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.7C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3L192 32c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCediSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 34.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3l0 34.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-34.7c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6L256 132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8L256 32zM192 132L192 380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 192l17.1 0c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4l0 4 0 32 0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-140.8L280 448l56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-144 0c-53 0-96-43-96-96l0-223.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3l0 85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5s0 0 0 0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32c0 0 0 0 0 0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128c0 0 0 0 0 0l0-96 0-20 0-1.3C352 4.8 356.7 .1 362.6 0l.2 0c3.3 0 6.4 1.6 8.4 4.2c0 0 0 0 0 .1L384 21.3l27.2 36.3L416 64l64 0 4.8-6.4L512 21.3 524.8 4.3c0 0 0 0 0-.1c2-2.6 5.1-4.2 8.4-4.2l.2 0C539.3 .1 544 4.8 544 10.7l0 1.3 0 20 0 96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCashRegister(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C46.3 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l80 0 0 32-57 0c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-69.6c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160l-217 0 0-32 80 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 0zM96 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCartShopping(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCartPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20l44 0 0 44c0 11 9 20 20 20s20-9 20-20l0-44 44 0c11 0 20-9 20-20s-9-20-20-20l-44 0 0-44c0-11-9-20-20-20s-20 9-20 20l0 44-44 0c-11 0-20 9-20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCartFlatbed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l16 0c8.8 0 16 7.2 16 16l0 288c0 44.2 35.8 80 80 80l18.7 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l197.5 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l66.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-464 0c-8.8 0-16-7.2-16-16l0-288C128 35.8 92.2 0 48 0L32 0zM192 80l0 192c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-96 0 0 144c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1l0-144-96 0c-26.5 0-48 21.5-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCartFlatbedSuitcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0L48 0c44.2 0 80 35.8 80 80l0 288c0 8.8 7.2 16 16 16l464 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-66.7 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16l-197.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16L144 448c-44.2 0-80-35.8-80-80L64 80c0-8.8-7.2-16-16-16L32 64C14.3 64 0 49.7 0 32zM432 96l0-40c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 40 96 0zM288 96l0-40c0-30.9 25.1-56 56-56l80 0c30.9 0 56 25.1 56 56l0 40 0 224-192 0 0-224zM512 320l0-224 16 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-16 0zM240 96l16 0 0 224-16 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCartArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32L360 32l0 102.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L312 32 120.1 32C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarrot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaravan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 112C0 67.8 35.8 32 80 32l336 0c88.4 0 160 71.6 160 160l0 160 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-288 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-44.2 0-80-35.8-80-80L0 112zM320 352l128 0 0-96-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 192zM96 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.2 117.4L109.1 192l293.8 0-26.1-74.6C372.3 104.6 360.2 96 346.6 96L165.4 96c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32l181.2 0c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2l0 144 0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48L96 400l0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48L0 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarTunnel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 114.6 0 256L0 448c0 35.3 28.7 64 64 64l42.8 0c-6.6-5.9-10.8-14.4-10.8-24l0-112c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7l115.2 0c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6l0 112c0 9.6-4.2 18.1-10.8 24l42.8 0c35.3 0 64-28.7 64-64l0-192C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24l0-40-192 0 0 40c0 9.6-4.2 18.1-10.8 24l213.7 0zM190.8 277.5L177 320l158 0-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5l-115.2 0c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarSide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M171.3 96L224 96l0 96-112.7 0 30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192l0-96 81.2 0c9.7 0 18.9 4.4 25 12l67.2 84L272 192zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36L171.3 32c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256L0 368c0 17.7 14.3 32 32 32l33.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l130.7 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l33.3 0c17.7 0 32-14.3 32-32l0-48c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarRear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.4 96l181.2 0c13.6 0 25.7 8.6 30.2 21.4L402.9 192l-293.8 0 26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256l0 80c0 23.7 12.9 44.4 32 55.4L32 448c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 256 0 0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-56.6c19.1-11.1 32-31.7 32-55.4l0-80c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32L165.4 32c-40.8 0-77.1 25.8-90.6 64.3zM208 272l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm360-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarOn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM185.8 224l140.3 0c6.8 0 12.8 4.3 15.1 10.6L360.3 288l-208.6 0 19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344l0 40 0 64 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 0-64 0-40c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160l-140.3 0c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarBurst(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarBattery(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 96c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l16 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32zM80 240c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCapsules(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112-96 0 0-112zM0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-178.4c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83l0-24.2c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCannabis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2l0 70.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-70.8-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCandyCane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23l0 5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8l0-5.6C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCampground(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4L0 464c0 26.5 21.5 48 48 48l240 0 240 0c26.5 0 48-21.5 48-48l0-23.6c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448l-119.5 0L288 291.7 407.5 448 288 448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCameraRotate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.1 64.8L202.7 96 128 96c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L426.9 64.8C420.4 45.2 402.1 32 381.4 32L258.6 32c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16l-76.7 0c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3l0 76.7zM192 320c0-8.8 7.2-16 16-16l76.7 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3l0-76.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCameraRetro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.6 121.2L271.1 96 448 96l0 96-114.8 0c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24L64 192l0-64 128 0c9.9 0 19.7-2.3 28.6-6.8zM0 128L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L271.1 32c-9.9 0-19.7 2.3-28.6 6.8L192 64l-32 0 0-16c0-8.8-7.2-16-16-16L80 32c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarWeek(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm80 64c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L80 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272zM224 248c13.3 0 24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-56c0-13.3 10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM312 376c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarDays(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 400l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarDay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm80 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM96 64l192 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L96 160c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCakeCandles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2L56 72c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6l0 2.8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6l0 2.8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c-35.3 0-64 28.7-64 64l0 71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4c0 0 0 0 0 0s0 0 0 0l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0l.1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9l0-71c0-35.3-28.7-64-64-64l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48-64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48-64 0 0-48zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4L0 480c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-85.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCableCar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64l136 0 0-66.5-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5l0 76.5 136 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-160zm64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0zm112 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaC(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBusinessTime(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160l0 96 192 0 160 0 8.2 0c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7l0-32.7c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zM320 352l-96 0c-17.7 0-32-14.3-32-32l0-32L0 288 0 416c0 35.3 28.7 64 64 64l296.2 0C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0C422.4 0 512 35.2 512 80l0 16 0 32c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-192 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32c0 0 0 0 0 0l0-32s0 0 0 0l0-16C64 35.2 153.6 0 288 0zM128 160l0 96c0 17.7 14.3 32 32 32l112 0 0-160-112 0c-17.7 0-32 14.3-32 32zM304 288l112 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-112 0 0 160zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16L208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBusSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0C348.8 0 448 35.2 448 80l0 16 0 320c0 17.7-14.3 32-32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-192 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32L0 96 0 80C0 35.2 99.2 0 224 0zM64 128l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBurst(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBurger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1L61.1 224zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L64 352c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16l0 16c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBullseye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBullhorn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75l-8.7 0-32 0-96 0c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-147.6c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4L480 32zm-64 76.7L416 240l0 131.3C357.2 317.8 280.5 288 200.7 288l-8.7 0 0-96 8.7 0c79.8 0 156.5-29.8 215.3-83.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuilding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingWheat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zM80 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm384 80l0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0zm0 128c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0 0 16zm0 112c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0 0 16zM512 496l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0c44.2 0 80 35.8 80 80zm0-96l-16 0c-44.2 0-80-35.8-80-80l0-16 16 0c44.2 0 80 35.8 80 80l0 16zm0-128l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-13.3 10.7-24 24-24zm96 64l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 89.9 0c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2l0-95.9L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0c-51.4 0-93.1 41.7-93.1 93.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingUn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM237.3 71.1l34.7 52L272 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 159-42.4 17L304 224l-32 0c-8.8 0-16 7.2-16 16l0 32 0 24.2 0 7.8c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zM80 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM64 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingNgo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM168 64l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-88c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zM61.3 71.1l34.7 52L96 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8 64 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 88.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-128c0-23.7 12.9-44.4 32-55.4l0-24.6c0-30.5 12.2-58.2 32-78.4L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32l0 480 64 0 0-320 144 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L480 32c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingColumns(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160l0 8c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24l0-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224l-64 0 0 196.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512l448 0c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1L448 224l-64 0 0 192-40 0 0-192-64 0 0 192-48 0 0-192-64 0 0 192-40 0 0-192zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuildingCircleArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 184.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zM80 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352 432 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBugs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6l-17 0-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184l32 0 0 23.3-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3l0-23.3 32 0c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136l-17 0c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c53 0 96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4l0-3.6c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4l112 0c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5l64.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6L272 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 239.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64.3 0c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBugSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64.3 0c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160l-112 0c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96l0 3.6c0 15.7 12.7 28.4 28.4 28.4l135.1 0c15.7 0 28.4-12.7 28.4-28.4l0-3.6c0-53-43-96-96-96zM160.3 256L96 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6l0-143.7L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7l0 118.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBucket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 152l0 8-48 0 0-8C48 68.1 116.1 0 200 0l48 0c83.9 0 152 68.1 152 152l0 8-48 0 0-8c0-57.4-46.6-104-104-104l-48 0C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-5.1 0L388.5 469c-2.6 24.4-23.2 43-47.7 43l-233.6 0c-24.6 0-45.2-18.5-47.7-43L37.1 256 32 256c-17.7 0-32-14.3-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.4 6c-1.5-3.6-5-6-8.9-6l-19 0c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6L48 0C21.5 0 0 21.5 0 48L0 224l0 22.4L0 256l9.6 0 364.8 0 9.6 0 0-9.6 0-22.4 0-176c0-26.5-21.5-48-48-48L230.5 0c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288l0 32c0 35.3 28.7 64 64 64l64 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 64 0c35.3 0 64-28.7 64-64l0-32L0 288zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBroom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6l0 29.1L364.3 320l29.1 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBroomBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6l-29.1 0L256 211.7l0-29.1c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L22.1 512C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2c0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160l0 96 192 0 128 0 192 0 0-96c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zM512 288l-192 0 0 32c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-32L0 288 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBriefcaseMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBridge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l40 0 0 64L0 160 0 288c53 0 96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96s96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96l0-128-72 0 0-64 40 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM456 96l0 64-80 0 0-64 80 0zM328 96l0 64-80 0 0-64 80 0zM200 96l0 64-80 0 0-64 80 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBridgeWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 78.3 14.3 64 32 64l512 0c17.7 0 32 14.3 32 32l0 35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6l0 124.9c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3c0 0 0 0 0 0l0-.5 0-128c0-53-43-96-96-96s-96 43-96 96l0 128 0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7l0-124.9C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6L0 96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBridgeLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64c0-17.7 14.3-32 32-32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-40 0 0 64-8 0c-61.9 0-112 50.1-112 112l0 24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-53-43-96-96-96l0-128 72 0 0-64L64 96C46.3 96 32 81.7 32 64zM408 96l0 64 80 0 0-64-80 0zm-48 64l0-64-80 0 0 64 80 0zM152 96l0 64 80 0 0-64-80 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBridgeCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32l40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2l0-72.2-72 0 0-64 40 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM488 96l0 64-80 0 0-64 80 0zM360 96l0 64-80 0 0-64 80 0zM232 96l0 64-80 0 0-64 80 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBridgeCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32l40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2l0-72.2-72 0 0-64 40 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM488 96l0 64-80 0 0-64 80 0zM360 96l0 64-80 0 0-64 80 0zM232 96l0 64-80 0 0-64 80 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBridgeCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32l40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2l0-72.2-72 0 0-64 40 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM488 96l0 64-80 0 0-64 80 0zM360 96l0 64-80 0 0-64 80 0zM232 96l0 64-80 0 0-64 80 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBreadSlice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBrazilianRealSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0c17.7 0 32 14.3 32 32l0 18.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5l-1.7 0c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4l0 3.4c0 51.2-33.6 94.6-80 109.2l0 21.3c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-19.4c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5l0-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2L368 32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32l80 0c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320 64 320l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 288 0 64zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L64 96l0 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBrain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 0c30.9 0 56 25.1 56 56l0 400c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56l0-400c0-30.9 25.1-56 56-56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBraille(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxesStacked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 0L208 0c-26.5 0-48 21.5-48 48l0 112c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-112c0-26.5-21.5-48-48-48L328 0l0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80zM64 256c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-40 0 0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80-40 0zM352 512l160 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-40 0 0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80-40 0c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2l0 160c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxesPacking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-210.7 0c1.8-5 2.7-10.4 2.7-16l0-242.7c18.6-6.6 32-24.4 32-45.3l0-32c0-26.5-21.5-48-48-48l-112 0 0-80zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6 480 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L16 224c-8.8 0-16-7.2-16-16l0-32zm352 80l0 224c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-224 320 0zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.7 58.5L0 160l208 0 0-128L93.7 32C75.5 32 58.9 42.3 50.7 58.5zM240 160l208 0L397.3 58.5C389.1 42.3 372.5 32 354.3 32L240 32l0 128zm208 32L0 192 0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxTissue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M92.5 0L208 0c40 0 52 24 64 48s24 48 64 48l85.2 0C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288l-256 0-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64-15 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 256 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-13.5 0 25.6-64 19.9 0c26.5 0 48 21.5 48 48l0 112L0 384 0 272c0-26.5 21.5-48 48-48l31 0zM0 416l512 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6l0 167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5l0-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128l2.2 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64C0 46.3 14.3 32 32 32zm0 128l448 0 0 256c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-256zm128 80c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBowlingBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBowlRice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 56c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm24 48l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256l457.1 0c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28l-231.5 0c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm-24-96l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm-24-96l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm-24-96l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBowlFood(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32L8.6 224C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256l457.1 0c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28l-231.5 0c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBottleWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 0l80 0c13.3 0 24 10.7 24 24l0 40L96 64l0-40c0-13.3 10.7-24 24-24zM32 167.5c0-19.5 10-37.6 26.6-47.9l15.8-9.9C88.7 100.7 105.2 96 122.1 96l75.8 0c16.9 0 33.4 4.7 47.7 13.7l15.8 9.9C278 129.9 288 148 288 167.5c0 17-7.5 32.3-19.4 42.6C280.6 221.7 288 238 288 256c0 19.1-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48s-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64c0-19.1 8.4-36.3 21.7-48C40.4 388.3 32 371.1 32 352s8.4-36.3 21.7-48C40.4 292.3 32 275.1 32 256c0-18 7.4-34.3 19.4-45.9C39.5 199.7 32 184.5 32 167.5zM96 240c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBottleDroplet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8l0 64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256l0 192c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-192c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1L216 56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0s0 0 0 0s0 0 0 0L104 0s0 0 0 0s0 0 0 0L96 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C185.9 288.9 208 320.2 208 337c0 24.9-21.5 45-48 45z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoreHole(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c-17.7 0-32 14.3-32 32l0 264.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4L288 32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-80 0c-17.7 0-32 14.3-32 32l0 192c0 53-43 96-96 96s-96-43-96-96l0-192c0-17.7-14.3-32-32-32l-80 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBorderTopLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBorderNone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBorderAll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 96l0 128-128 0 0-128 128 0zm0 192l0 128-128 0 0-128 128 0zM192 224L64 224 64 96l128 0 0 128zM64 288l128 0 0 128L64 416l0-128zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookTanakh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0c53 0 96 43 96 96l0 320c0 53-43 96-96 96L64 512l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c-17.7 0-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0L64 0 352 0zm0 384L96 384l0 64 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24-27.7 0 13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24l55.4 0 27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48 55.4 0c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24l-55.4 0L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48L111 112c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48 55.4 0 27.7 48-27.7 48-55.4 0-27.7-48zm0-48l-13.9 24-13.9-24 27.7 0zm41.6-24L208 88l13.9 24-27.7 0zm69.3 24l27.7 0-13.9 24-13.9-24zm13.9 72l13.9 24-27.7 0 13.9-24zm-55.4 48L208 280l-13.9-24 27.7 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookSkull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2l0 12.8c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-12.8c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookQuran(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0c53 0 96 43 96 96l0 320c0 53-43 96-96 96L64 512l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c-17.7 0-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0L64 0 352 0zm0 384L96 384l0 64 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5l0-377.4c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8L0 454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5l0-370.3c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11L304 456c0 11.4 11.7 19.3 22.4 15.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookOpenReader(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152l0 264-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427L0 224c0-17.7 14.3-32 32-32l30.3 0c63.6 0 125.6 19.6 177.7 56zm32 264l0-264c52.1-36.4 114.1-56 177.7-56l30.3 0c17.7 0 32 14.3 32 32l0 203c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM208 112l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookJournalWhills(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.2-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6c-2.7-1.9-6.2 1.4-5 4.5c8.5 22.4 3.6 48-13 65.6c-3.2 3.4-3.6 8.9-.9 12.7c9.8 14 12.7 31.9 7.5 48.5c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-5.1-16.6-2.2-34.4 7.6-48.5c2.7-3.9 2.3-9.3-.9-12.7c-16.6-17.5-21.6-43.1-13.1-65.5c1.2-3.1-2.3-6.4-5-4.5c-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 43 43 0 96 0l96 0 0 190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5L352 0l32 0 32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookBible(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookAtlas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9l63 0c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9l31.1 0c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9l-31.1 0c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208l31.1 0c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32l-31.1 0c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9l-63 0c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7l221.8 0c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8L224 64l-64 0 0 144.5zM288 64l0 144.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5L76.1 512c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14L96 64C78.3 64 64 49.7 64 32S78.3 0 96 0l16 0L272 0l16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2l192 0c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336l-192 0c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBomb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-75.1 60.9-136 136-136l8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288l111.5 0L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L349.4 44.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoltLightning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBold(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l48 0 16 0 128 0c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128L96 480l-16 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-160L48 96 32 96C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64L112 96l0 128 112 0zM112 288l0 128 144 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0-112 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144L0 368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144l-16 0 0 96 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48l0-224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlender(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0l64 0 32 0L470.1 0c21.1 0 36.4 20.1 30.9 40.4L494.5 64 336 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l149.8 0-17.5 64L336 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l123.6 0-17.5 64L336 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l97.5 0L416 352l-256 0-8.7-96L64 256c-35.3 0-64-28.7-64-64L0 64zM145.5 192L133.8 64 64 64l0 128 81.5 0zM144 384l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlenderPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 352L196.8 52.3C194.2 24.2 216.3 0 244.6 0L534.1 0c21.1 0 36.4 20.1 30.9 40.4L558.5 64 400 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l149.8 0-17.5 64L400 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l123.6 0-17.5 64L400 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l97.5 0L480 352l-256 0zm-16 32l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBitcoinSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32l0 32 32 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-6.3 0C18.7 448 0 429.3 0 406.3L0 288l0-22.3L0 224 0 101.6C0 80.8 16.8 64 37.6 64L48 64l0-32zM64 224l112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L64 128l0 96zm112 64L64 288l0 96 144 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBiohazard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBinoculars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32l32 0c17.7 0 32 14.3 32 32l0 32L96 96l0-32c0-17.7 14.3-32 32-32zm64 96l0 320c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32l0-59.1c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28l99.8 0zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3l0 59.1c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-320 99.8 0zM320 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32-96 0 0-32zm-32 64l0 160-64 0 0-160 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBicycle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l25.7 0 34.6 64-149.4 0-27.4-38C191 99.7 183.7 96 176 96l-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l43.7 0 22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112l49 0c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32L312 32zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368l65 0c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1-123.5 0zm90.6-128l108.5 0L317 274.8 257.4 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBezierCurve(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 136l0-48 48 0 0 48-48 0zM288 32c-26.5 0-48 21.5-48 48l0 4L121.6 84C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36l66.9 0c-58.9 39.6-98.9 105-104 180L80 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-3.3 0c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1l64 0c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1l-3.3 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-4.5 0c-5-75-45.1-140.4-104-180l66.9 0c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36L400 84l0-4c0-26.5-21.5-48-48-48l-64 0zM88 376l48 0 0 48-48 0 0-48zm416 48l0-48 48 0 0 48-48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBellSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-90.2-70.7c.2-.4 .4-.9 .6-1.3c5.2-11.5 3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8l0-18.8c0-77.4-55-142-128-156.8L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 19.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM406.2 416L160 222.1l0 4.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416l278.2 0zm-40.9 77.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBellConcierge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.3C119.6 157.2 32 252.4 32 368l448 0c0-115.6-87.6-210.8-200-222.7l0-33.3 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0-40 0zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBeerMugEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32 51.2 0c42.4 0 76.8 34.4 76.8 76.8l0 102.1c0 30.4-17.9 57.9-45.6 70.2L384 381.7l0 34.3c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64L32 64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7l0-102.1c0-7.1-5.7-12.8-12.8-12.8L384 160l0 151.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c17.7 0 32 14.3 32 32l0 256 224 0 0-160c0-17.7 14.3-32 32-32l224 0c53 0 96 43 96 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-224 0-32 0L64 416l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBedPulse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.2 9.6L524 64l92 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112 216 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l136 0c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160l12.7 0 20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160l82.1 0c53 0 96 43 96 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-224 0-32 0L64 448l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32l0 256 224 0 0-160c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryThreeQuarters(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm272 96L96 192l0 128 256 0 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm112 96l-96 0 0 128 96 0 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm208 96L96 192l0 128 192 0 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm368 96L96 192l0 128 352 0 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 160c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L80 160zM0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3L32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 256 96 77.3zM32 352l0 16c0 28.4 12.4 54 32 71.6L64 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 256 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-40.4c19.6-17.6 32-43.1 32-71.6l0-16L32 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBasketball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBasketShopping(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192 32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512L430 512c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-85.6 0L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192l-232.6 0L253.3 35.1zM192 304l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm128 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBaseball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBaseballBatBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBarsStaggered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBarsProgress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 160l-128 0 0-32 128 0 0 32zM48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 64zM448 352l0 32-256 0 0-32 256 0zM48 288c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBarcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 32C10.7 32 0 42.7 0 56L0 456c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24L64 56c0-13.3-10.7-24-24-24L24 32zm88 0c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0zm96 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0zM448 56l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-64-8l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBangladeshiTakaSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M36 32.3C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8L64 160l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 160c0 53 43 96 96 96l32 0c106 0 192-86 192-192l0-32c0-53-43-96-96-96l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0c17.7 0 32 14.3 32 32l0 32c0 70.7-57.3 128-128 128l-32 0c-17.7 0-32-14.3-32-32l0-160 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-31.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBandage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416l96 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-96 0 0 320zM448 96L192 96l0 320 256 0 0-320zM64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l96 0 0-320L64 96zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBanSmoking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32 82.7 0 0 32-50.7 0zm32 32l34.7 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-130.7 0L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96L112 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l117.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBahtSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 0c-17.7 0-32 14.3-32 32l0 32L37.6 64C16.8 64 0 80.8 0 101.6L0 224l0 41.7L0 288 0 406.3c0 23 18.7 41.7 41.7 41.7l70.3 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112l0-32c0-17.7-14.3-32-32-32zM112 128l0 96-48 0 0-96 48 0zm64 96l0-96c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64l0 96-48 0 0-96 48 0zm64 96l0-96 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBahai(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBagShopping(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 48-128 0 0-48zm-48 48l-64 0c-26.5 0-48 21.5-48 48L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-208c0-26.5-21.5-48-48-48l-64 0 0-48C336 50.1 285.9 0 224 0S112 50.1 112 112l0 48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBacterium(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7c0 0 0 0 0 0l-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3s0 0 0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBacteria(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.1 1c0 0 0 0-.1 0L28 269.3c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5c0 0 0 0 0 0c11.7 .4 27.3 .9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1c0 0 0 0 .1 0l29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5c0 0 0 0 0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBacon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6c0 0 0 0 0 0l.2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3l0 41.7 0 41.7L459.5 440.6zM256 352l0-96 0-128 0-32c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBackwardStep(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241 64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-145 11.5 9.6 192 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBackwardFast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7 288 416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7 64 416c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32l0 118.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96l0 118.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96l0 320c0 12.4-7.2 23.7-18.4 29z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBaby(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25l0 36.3-192 0 0-36.3c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBabyCarriage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 192L.1 192C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0 0-64zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaB(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 256 0 416c0 35.3 28.7 64 64 64l128 0c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128L64 32zm96 192l-96 0L64 96l96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288l96 0 32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64L64 416l0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAustralSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0L82.7 320 32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l24 0L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384l197.3 0 31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0L352 288l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-90.7 0L253.5 51.7zM256 224l-64 0 32-76.8L256 224zm-90.7 64l117.3 0L296 320l-144 0 13.3-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAudioDescription(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9-82.2 0-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2 42.2 0zM304 184c0-13.3 10.7-24 24-24l56 0c53 0 96 43 96 96s-43 96-96 96l-56 0c-13.3 0-24-10.7-24-24l0-144zm48 24l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAtom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32l0 80 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAsterisk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32c17.7 0 32 14.3 32 32l0 135.5 111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5 224 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-135.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5 160 64c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsUpToLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L416 237.3 416 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsUpDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3l0 293.5L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7l0-293.5 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsUpDownLeftRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4L224 224l-114.7 0 9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L224 288l0 114.7-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4L288 288l114.7 0-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L288 224l0-114.7 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsTurnToDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsTurnRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160 128 160c-35.3 0-64 28.7-64 64l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32C0 153.3 57.3 96 128 96l210.7 0L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-53 43-96 96-96l146.7 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsToEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15C24.4 5.7 39.6 5.7 49 15l63 63L112 40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l38.1 0L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63 38.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 38.1 63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63L40 400c-13.3 0-24-10.7-24-24s10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-38.1L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63 0 38.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-38.1 0 63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsToDot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c17.7 0 32 14.3 32 32l0 32 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0 0-32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 32 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsToCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7 160 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l18.7 0L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352L96 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0s0 0 0 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-18.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160l18.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1s0 0 0 0l0-96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3l0 18.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96s0 0 0 0l0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4l.1 0s0 0 0 0l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-18.7 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsSplitUpAndLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3 352 384c0 35.3 28.7 64 64 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64l-114.7 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 224 256c23.3 0 45.2 6.2 64 17.1l0-163.9-41.4 41.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsSpin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l112 0c8.8 0 16-7.2 16-16l0-112c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5 .8-32 2.3l0 64.9c10.3-2.1 21-3.2 32-3.2zM132.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-112c0-8.8-7.2-16-16-16L64 48c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9 .8 21.5 2.3 32l64.9 0c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM477.7 224l-64.9 0c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 112c0 8.8 7.2 16 16 16l112 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9L64 320c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3l0-64.9c-10.3 2.1-21 3.2-32 3.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsRotate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160 352 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l111.5 0c0 0 0 0 0 0l.4 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1L16 432c0 17.7 14.3 32 32 32s32-14.3 32-32l0-35.1 17.6 17.5c0 0 0 0 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.8c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352l34.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48.4 288c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsLeftRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsLeftRightToLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsDownToPeople(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 0c-13.3 0-24 10.7-24 24l0 118.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23L168 24c0-13.3-10.7-24-24-24zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5l0 54.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-54.5 26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5l0 38.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5 88 480c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23L520 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsDownToLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 416L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7 480 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L54.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUpZA(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.7 32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32l50.7 0-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L352 32c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400l-40.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUpWideShort(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.7 32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUpShortWide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.7 32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUpRightFromSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUpRightDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l50.7 0L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3l0 50.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L160 0zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUpLong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-370.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUpFromWaterPump(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 0C85.5 0 64 21.5 64 48l0 208-16 0c-26.5 0-48 21.5-48 48l0 96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400l0-96c0-26.5-21.5-48-48-48l-48 0 0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256l-128 0 0-208c0-26.5-21.5-48-48-48L112 0zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUpFromGroundWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 352c17.7 0 32-14.3 32-32l0-210.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3 256 320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192L48 192c-26.5 0-48 21.5-48 48L0 425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3L192 192zm384 48c0-26.5-21.5-48-48-48l-144 0 0 224.5s0 0 0 0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9l0-185z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUpFromBracket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3 192 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUpAZ(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.7 32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32l50.7 0-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-128 0c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176l-40.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUp91(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM450.7 294c8.3 6 13.3 15.7 13.3 26l0 96 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-51.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUp19(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M450.7 38c8.3 6 13.3 15.7 13.3 26l0 96 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-51.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowTurnUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowTurnDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowTrendUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowTrendDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352 384 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowRotateRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.3 160L336 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowRotateLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.7 160l50.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 224c-17.7 0-32-14.3-32-32L16 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowRightToCity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 144 40 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 24 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-160 0-96 0c-26.5 0-48-21.5-48-48l0-416zm64 32l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM352 272l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM512 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l114.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowRightToBracket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowRightLong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowRightFromBracket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowRightArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowPointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 55.2L0 426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320l118.1 0c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowLeftLong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDownZA(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7 128 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 301.7 32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32l128 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160l50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96 352 96c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448l-88.4 0-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400l40.4 0L416 359.6 395.8 400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDownWideShort(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 301.7 32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L320 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDownUpLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 160 288l256 0 0-16c0-17.2 3.9-33.5 10.8-48L352 224l0-114.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3 288 224l-128 0-64 0-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 114.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128 64 0zM288 320l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128-64 0zm240-80c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDownUpAcrossLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7 192 288l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0 0-114.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3 384 224l-192 0-64 0-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 0 114.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192l64 0 0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128zM448 320l-64 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDownShortWide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 301.7 32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDownLong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDownAZ(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7 128 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 301.7 32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32l128 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416l50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352 352 352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224l-88.4 0-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176l40.4 0L416 135.6 395.8 176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDown91(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM450.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zM405.1 203.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDown19(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM418.3 307a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 307zM405.1 419.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArchway(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 64 0 0-128c0-53 43-96 96-96s96 43 96 96l0 128 64 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-288L32 128l0 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAppleWhole(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 112c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80l16 0c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80l-16 0zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnkh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128L32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-46.8 0c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnglesUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnglesRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnglesLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnglesDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnchor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c88.4 0 160-71.6 160-160l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 53-43 96-96 96l-48 0 0-208 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnchorLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3l0-33.3c-5.2 .9-10.5 1.3-16 1.3l-48 0 0-208 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnchorCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2L320 448l0-80 0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnchorCircleExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2L320 448l0-80 0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnchorCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2L320 448l0-80 0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64c0 17.7-14.3 32-32 32L192 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32L32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignJustify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32L32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 64c0-17.7-14.3-32-32-32L128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAddressCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 256l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAddressBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM208 288l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaA(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384l197.3 0 31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320l-144 0 72-172.8L264 320z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa9(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa8(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 160c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128l64 0c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288l15.9 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l15.9 0c0 0 .1 0 .1 0l32 0c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0l-32 0c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa7(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l256 0c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96 32 96C14.3 96 0 81.7 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa6(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3l0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa5(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32.5 58.3C35.3 43.1 48.5 32 64 32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L90.7 96 70.3 208 184 208c75.1 0 136 60.9 136 136s-60.9 136-136 136l-83.5 0c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1l83.5 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L32 272c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368l224 0 0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-144c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L82.4 304 189 77.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32l240 0c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208l21.7 0c75.1 0 136 60.9 136 136s-60.9 136-136 136l-78.6 0C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5l78.6 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L80 272c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96 32 96C14.3 96 0 81.7 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416 288 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8 96 416l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-352z"
                },
                "child": []
            }
        ]
    })(props);
}
function Fa0(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160l0 128c0 88.4-71.6 160-160 160S0 408.4 0 320L0 192zM160 96c-53 0-96 43-96 96l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-53-43-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowRestore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 48L208 48c-17.7 0-32 14.3-32 32l0 16-48 0 0-16c0-44.2 35.8-80 80-80L432 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-16 0 0-48 16 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-192L48 256l0 192zM64 128l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowMinimize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowMaximize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.3 89.5C.1 91.6 0 93.8 0 96L0 224 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192 0-128c0-35.3-28.7-64-64-64L64 32c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224l416 0 0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegTrashCan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegThumbsUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16l-97.5 0c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8l97.5 0c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegThumbsDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16l-97.5 0c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8L384 32c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32L0 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStarHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4l0 384.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4 0-265.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStarHalfStroke(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM288 384.7l0-305.6 52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquarePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquareMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM152 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquareFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 48l0 416L48 464 48 48l416 0zM48 0L0 0 0 48 0 464l0 48 48 0 416 0 48 0 0-48 0-416 0-48L464 0 48 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquareCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquareCaretUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquareCaretRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquareCaretLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquareCaretDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSnowflake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c13.3 0 24 10.7 24 24l0 46.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57 0 76.5 66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6l0 76.5 57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 46.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-76.5-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4l0-76.5L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L200 24c0-13.3 10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegShareFromSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 255.4l0-15.4 0-32c0-8.8-7.2-16-16-16l-32 0-16 0-46.5 0c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112l48 0 16 0 32 0c8.8 0 16-7.2 16-16l0-32 0-15.4L506 160 400 255.4zM336 240l16 0 0 48c0 17.7 14.3 32 32 32l3.7 0c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7L352 80l-16 0-32 0-16 0c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4l2.5 0c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5c0 0 0 0 0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5l14.5 0 32 0zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegRegistered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152l0 112 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 60.9 0 37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80l-88 0c-13.3 0-24 10.7-24 24zm48 88l0-64 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegRectangleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegRectangleList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPenToSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPaste(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.6 48L64 48C28.7 48 0 76.7 0 112L0 384c0 35.3 28.7 64 64 64l96 0 0-48-96 0c-8.8 0-16-7.2-16-16l0-272c0-8.8 7.2-16 16-16l16 0c0 17.7 14.3 32 32 32l72.4 0C202 108.4 227.6 96 256 96l62 0c-7.1-27.6-32.2-48-62-48l-40.6 0C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48zM144 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 464l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L464 243.9 464 448c0 8.8-7.2 16-16 16zM256 512l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L256 128c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPaperPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegObjectUngroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.2 66.8c-.1-.8-.2-1.7-.2-2.5l0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3l0 105.3C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l201.3 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3l0-105.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L123.3 40C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3l0 105.3c-16 6.5-28.9 19.3-35.3 35.3l-201.3 0c-6.5-16-19.3-28.9-35.3-35.3l0-105.3c16-6.5 28.9-19.3 35.3-35.3l201.3 0zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40l45.4 0c6.5 16 19.3 28.9 35.3 35.3l0 105.3c-16 6.5-28.9 19.3-35.3 35.3l-201.3 0c-6.5-16-19.3-28.9-35.3-35.3l0-36.7-48 0 0 36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l201.3 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3l0-105.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L448 200l0 16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm307-18.5a16 16 0 1 1 -5.5 31.5 16 16 0 1 1 5.5-31.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegObjectGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16l344.4 0c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8l0 280.4c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16l-344.4 0c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8l0-280.4zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3l0 261.5c13.6 4.8 24.4 15.6 29.3 29.3l325.5 0c4.8-13.6 15.6-24.4 29.3-29.3l0-261.5c-13.6-4.8-24.4-15.6-29.3-29.3L125.3 96zm2.7 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-96zM256 320l32 0c35.3 0 64-28.7 64-64l0-32 64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegNoteSticky(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l224 0 0-80c0-17.7 14.3-32 32-32l80 0 0-224c0-8.8-7.2-16-16-16L64 80zM288 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 224 0 5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7l-5.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 80c-13.3 0-24 10.7-24 24l0 304c0 8.4-1.4 16.5-4.1 24L440 432c13.3 0 24-10.7 24-24l0-304c0-13.3-10.7-24-24-24L168 80zM72 480c-39.8 0-72-32.2-72-72L0 112C0 98.7 10.7 88 24 88s24 10.7 24 24l0 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304c0-39.8 32.2-72 72-72l272 0c39.8 0 72 32.2 72 72l0 304c0 39.8-32.2 72-72 72L72 480zM176 136c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-80zm200-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0l-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMoneyBill1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 112c0 35.3-28.7 64-64 64l0 160c35.3 0 64 28.7 64 64l352 0c0-35.3 28.7-64 64-64l0-160c-35.3 0-64-28.7-64-64l-352 0zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16l0 64-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMessage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.6 36.2C572.1 40.7 576 48.1 576 56l0 336c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456L0 120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5l0 284.6 120-45.7 0-284.6L48 136.5zM360 422.7l0-285.4-144-48 0 285.4 144 48zm48-1.5l120-45.7 0-284.6L408 136.5l0 284.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLightbulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-48.6 0c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80l0-16 160 0 0 16c0 44.2-35.8 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLifeRing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLemon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegKeyboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM176 320l224 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegImages(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 80l352 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-21.2 0L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336 160 336c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM96 96l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegIdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 160l0 256c0 8.8-7.2 16-16 16l-192 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-32 0c-8.8 0-16-7.2-16-16l0-256 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegIdBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48l0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16l-64 0zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM160 320l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 416c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHourglass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 19c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445l0 19-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-19c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67l0-19 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM192 289.9l81.5 81.5C293 391 304 417.4 304 445l0 19L80 464l0-19c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67l0-19 224 0 0 19c0 27.6-11 54-30.5 73.5L192 222.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHourglassHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 24C0 10.7 10.7 0 24 0L360 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 19c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445l0 19 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-19c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67l0-19-8 0C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5l184.4 0c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67l0-19L80 48l0 19c0 22.1 7 43.4 19.8 61l184.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHospital(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 0c-39.8 0-72 32.2-72 72l0 8L72 80C32.2 80 0 112.2 0 152L0 440c0 39.8 32.2 72 72 72l.2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0s0 0 0 0l272 0 8 0s0 0 0 0l104 0c39.8 0 72-32.2 72-72l0-288c0-39.8-32.2-72-72-72l-88 0 0-8c0-39.8-32.2-72-72-72L232 0zM480 128l88 0c13.3 0 24 10.7 24 24l0 40-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 48-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 104c0 13.3-10.7 24-24 24l-88 0 0-128 0-208zM72 128l88 0 0 336c0 0 0 0-.1 0l-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0c-13.2 0-24-10.7-24-24l0-104 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-40c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 264 0 128-64 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-64 0 0-392zm88 24l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHardDrive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16l0 162c5.1-1.3 10.5-2 16-2l384 0c5.5 0 10.9 .7 16 2l0-162c0-8.8-7.2-16-16-16L64 80zM48 320l0 96c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L64 304c-8.8 0-16 7.2-16 16zM0 320L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 224 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-96zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandshake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176L96 176l0 128c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7c0 0 0 0 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128l38.9 0 40 0 40 0c8.8 0 16 7.2 16 16l0 208c0 17.7-14.3 32-32 32l-32 0c-11.8 0-22.2-6.4-27.7-16l-84.9 0c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384l-32 0c-17.7 0-32-14.3-32-32L0 144c0-8.8 7.2-16 16-16l40 0 40 0 19.8 0c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64L259 64c4.4 0 8.9 .2 13.2 .6zM544 320l0-144-48 0c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1l74.8 0zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64l0 165.5-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75l8.5 0 8 0c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5l0-176c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2l0-2c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1l0-.1 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.9 0 .1 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 55.9c0 0 0 .1 0 .1l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-71.9c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 172.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2l-4.9 0-8.5 0c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2L160 96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9L192 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-135.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandSpock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512l-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8l33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16 0 104c0 39.8-32.2 72-72 72l-56 0-59.8 0-.9 0c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-19.9 0-256zM176 0c-35.3 0-64 28.7-64 64l0 197.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2l.9 0 59.8 0 56 0c66.3 0 120-53.7 120-120l0-104 0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5L240 64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm48-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64l0 177.6c5.2-1 10.5-1.6 16-1.6l16 0 0-32L96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0l0 24c0 66.3 53.7 120 120 120l48 0c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0-40 0zM0 320s0 0 0 0c0-18 6-34.6 16-48L16 64C16 28.7 44.7 0 80 0s64 28.7 64 64l0 82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64l0 64 0 24c0 92.8-75.2 168-168 168l-48 0C75.2 512 0 436.8 0 344l0-24zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM160 240c5.5 0 10.9 .7 16 2l0-2 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 16 0zm64 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPeace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-72 0-16 0-32c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192l0 48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2l-7.4 0-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240 144 240c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2l0 10c0 66.3-53.7 120-120 120l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandLizard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l168 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l152 0c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4l0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-10.7L281.1 384 136 384c-39.8 0-72-32.2-72-72s32.2-72 72-72l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L72 208c-39.8 0-72-32.2-72-72S32.2 64 72 64l209.6 0c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7L512 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-107.9c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9L72 112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandBackFist(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16l0 104c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6L304 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-117.8c38-20.1 64-60.1 64-106.2l0-104c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64l0 64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6l0 12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3L128 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128.1c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4l0-12.8c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6l0 32.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-65.7 0-14.3 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGem(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168.5 72L256 165l87.5-93-175 0zM383.9 99.1L311.5 176l129 0L383.9 99.1zm50 124.9L256 224 78.1 224 256 420.3 433.9 224zM71.5 176l129 0L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFutbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M435.4 361.4l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.2zM256 48l.9 0-1.8 0 .9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.6 2-4 2.9l4-2.9zm75.2-226.7l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6l59.2 0c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFontAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.7 96C106.3 86.8 116 70.5 116 52C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 3 0 48 0 256 0 48 0 64 48 0 0-64 389.6 0c14.6 0 26.4-11.8 26.4-26.4c0-3.7-.8-7.3-2.3-10.7L432 272l61.7-138.9c1.5-3.4 2.3-7 2.3-10.7c0-14.6-11.8-26.4-26.4-26.4L91.7 96zM80 400l0-256 356.4 0L388.1 252.5c-5.5 12.4-5.5 26.6 0 39L436.4 400 80 400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32l132.1 0c19.1 0 37.4 7.6 50.9 21.1L289.9 96 448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-161.4 0c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7L64 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480l48 0c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224l-400 0c-11.4 0-21.9 6-27.6 15.9L48 357.1 48 96c0-8.8 7.2-16 16-16l117.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8L416 144c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L298.5 96c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l23.7 0L384 480z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFolderClosed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 32L48 192l0-96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zM48 240l416 0 0 176c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-176zM285.7 93.7L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFloppyDisk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 96l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-245.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm80-16l0 80 144 0 0-80L128 80zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 64 0 350.5 0 400l0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-100 80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-279.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52l0-28zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8l0 241.8-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5l0-237z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileZipper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l48 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l48 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm48 112c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8l-14.8 0c-14.5 0-27.2 9.7-30.9 23.8zM128 336l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileWord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 288c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 16 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFilePowerpoint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm72 208c-13.3 0-24 10.7-24 24l0 104 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 44 0c42 0 76-34 76-76s-34-76-76-76l-68 0zm68 104l-44 0 0-56 44 0c15.5 0 28 12.5 28 28s-12.5 28-28 28z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFilePdf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileLines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2l48 0 32 0 40 0 72 0c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileExcel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileAudio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464l256 0c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 272l0 128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376 112 376c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l17.4 0 35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceTired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceSurprise(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceSmileWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceSmileBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceSadTear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceSadCry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 406.1L400 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4L160 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceRollingEyes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceMeh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceMehBlank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceLaugh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceLaughWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceLaughSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceLaughBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceKiss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceKissWinkHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceKissBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinWide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinTongue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4l0-52.4c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27l0 52.5c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinTongueWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4l0-52.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1l0 52.4c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-37.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6l0 37.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinTongueSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4l0-23.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 22.9c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0zm160 0s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinStars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinSquintTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinHearts(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrinBeamSweat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceGrimace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0-48-8 0zm40 48l32 0 0-48-32 0 0 48zm96 0l0-48-32 0 0 48 32 0zm32 0l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48zM168 288l176 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-176 0c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceFrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceFrownOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceFlushed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceDizzy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFaceAngry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEyeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5l0 13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1l0-13.6c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2 464 456c0 4.4-3.6 8-8 8L56 464c-4.4 0-8-3.6-8-8l0-179.8zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5L0 456c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-255.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 80c8.8 0 16 7.2 16 16l0 32L48 128l0-32c0-8.8 7.2-16 16-16l448 0zm16 144l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCopyright(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegComments(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.8 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegComment(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCommentDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClosedCaptioning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464l224 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM224 304l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L224 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zm-64-16l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 64l40 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l40 0 9.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64l9.6 0zM64 112c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-16 0 0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24-16 0zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircleXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircleUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M406.5 399.6C387.4 352.9 341.5 320 288 320l-64 0c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3l64 0c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM151.2 217.4c-4.6 4.2-7.2 10.1-7.2 16.4c0 12.3 10 22.3 22.3 22.3l41.7 0 0 96c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-96 41.7 0c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.2-16.4l-91-84c-3.8-3.5-8.7-5.4-13.9-5.4s-10.1 1.9-13.9 5.4l-91 84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircleStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 151.2c-4.2-4.6-10.1-7.2-16.4-7.2C266 144 256 154 256 166.3l0 41.7-96 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l96 0 0 41.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.4-7.2l84-91c3.5-3.8 5.4-8.7 5.4-13.9s-1.9-10.1-5.4-13.9l-84-91z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircleQuestion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCirclePlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCirclePause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3L304 256l0-96c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 96-57.7 0C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircleDot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircleCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegChessRook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 80l0 112c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352l-48.3 0 9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192L32 72c0-22.1 17.9-40 40-40l304 0c22.1 0 40 17.9 40 40l0 120c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85-48.3 0-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4l0-112-64 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-64 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24L80 80zm4.7 384l278.7 0-16.6-32-245.6 0L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L72.8 512C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384l265 0zM208 288c-8.8 0-16-7.2-16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 8.8-7.2 16-16 16l-32 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegChessQueen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352l55.4 0-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352l55.4 0 93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432l245.6 0 16.6 32-278.7 0 16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3l-265 0c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8l302.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegChessPawn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120l-12.6 0 10.7 80-48.4 0L195 272l-35 0-35 0-10.7 80-48.4 0 10.7-80L64 272c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464l214.7 0-16.6-32L69.2 432 52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384l201 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegChessKnight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M226.6 48L117.3 48l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1l-50.7 0c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0L226.6 0C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352l-48.8 0 24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464l310.7 0-16.6-32L85.2 432zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L56.8 512C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384l297 0c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegChessKing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 40L59.6 144C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352l52.3 0L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6L224 192l164.4 0c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352l52.3 0 54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6L248 144l0-40 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32zM101.2 432l245.6 0 16.6 32L84.7 464l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3l-265 0c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512l302.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegChessBishop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8L48 352l48 0 0-27c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3l0 27 48 0 0-13.3c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24L160 0 104 0zM52.7 464l16.6-32 181.6 0 16.6 32L52.7 464zm207.9-80l-201 0c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l238.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarXmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm176 40c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM296 352l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarDays(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBuilding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0l0 48 0 393.4 130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4 336 48 48 48 48 0 336 0c26.5 0 48 21.5 48 48l0 440c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488L0 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-25.4c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBellSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 17.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zM221.7 148.4C239.6 117.1 273.3 96 312 96l8 0 8 0c57.4 0 104 46.6 104 104l0 33.4c0 32.7 6.4 64.8 18.7 94.5L221.7 148.4zM406.2 416l-60.9-48-176.9 0c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1l0 11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l286.2 0zM384 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegAddressCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegAddressBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l288 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"
                },
                "child": []
            }
        ]
    })(props);
}

},{"../lib/index.mjs":"c1xBV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aL5Js":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Quote);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Quote({ className, children, showWhitespace = false }) {
    return showWhitespace ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: (0, _classnamesDefault.default)('text-sm text-justify italic text-gray-500 border-l-4 pl-3 border-l-amber-300', className),
        children: children
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)('text-sm text-justify italic text-gray-500 border-l-4 pl-3 border-l-amber-300', className),
        children: children
    });
}

},{"react/jsx-runtime":"9x2lT","classnames":"f971Y","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ek0E7":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImIcoMoon", ()=>ImIcoMoon);
parcelHelpers.export(exports, "ImSvg", ()=>ImSvg);
parcelHelpers.export(exports, "ImCodepen", ()=>ImCodepen);
parcelHelpers.export(exports, "ImGit", ()=>ImGit);
parcelHelpers.export(exports, "ImCss3", ()=>ImCss3);
parcelHelpers.export(exports, "ImHtmlFive2", ()=>ImHtmlFive2);
parcelHelpers.export(exports, "ImHtmlFive", ()=>ImHtmlFive);
parcelHelpers.export(exports, "ImLibreoffice", ()=>ImLibreoffice);
parcelHelpers.export(exports, "ImFileExcel", ()=>ImFileExcel);
parcelHelpers.export(exports, "ImFileWord", ()=>ImFileWord);
parcelHelpers.export(exports, "ImFileOpenoffice", ()=>ImFileOpenoffice);
parcelHelpers.export(exports, "ImFilePdf", ()=>ImFilePdf);
parcelHelpers.export(exports, "ImOpera", ()=>ImOpera);
parcelHelpers.export(exports, "ImSafari", ()=>ImSafari);
parcelHelpers.export(exports, "ImEdge", ()=>ImEdge);
parcelHelpers.export(exports, "ImIe", ()=>ImIe);
parcelHelpers.export(exports, "ImFirefox", ()=>ImFirefox);
parcelHelpers.export(exports, "ImChrome", ()=>ImChrome);
parcelHelpers.export(exports, "ImPaypal", ()=>ImPaypal);
parcelHelpers.export(exports, "ImYelp", ()=>ImYelp);
parcelHelpers.export(exports, "ImFoursquare", ()=>ImFoursquare);
parcelHelpers.export(exports, "ImFlattr", ()=>ImFlattr);
parcelHelpers.export(exports, "ImXing2", ()=>ImXing2);
parcelHelpers.export(exports, "ImXing", ()=>ImXing);
parcelHelpers.export(exports, "ImPinterest2", ()=>ImPinterest2);
parcelHelpers.export(exports, "ImPinterest", ()=>ImPinterest);
parcelHelpers.export(exports, "ImStackoverflow", ()=>ImStackoverflow);
parcelHelpers.export(exports, "ImStumbleupon2", ()=>ImStumbleupon2);
parcelHelpers.export(exports, "ImStumbleupon", ()=>ImStumbleupon);
parcelHelpers.export(exports, "ImDelicious", ()=>ImDelicious);
parcelHelpers.export(exports, "ImLastfm2", ()=>ImLastfm2);
parcelHelpers.export(exports, "ImLastfm", ()=>ImLastfm);
parcelHelpers.export(exports, "ImLinkedin2", ()=>ImLinkedin2);
parcelHelpers.export(exports, "ImLinkedin", ()=>ImLinkedin);
parcelHelpers.export(exports, "ImWikipedia", ()=>ImWikipedia);
parcelHelpers.export(exports, "ImHackernews", ()=>ImHackernews);
parcelHelpers.export(exports, "ImReddit", ()=>ImReddit);
parcelHelpers.export(exports, "ImSkype", ()=>ImSkype);
parcelHelpers.export(exports, "ImSoundcloud2", ()=>ImSoundcloud2);
parcelHelpers.export(exports, "ImSoundcloud", ()=>ImSoundcloud);
parcelHelpers.export(exports, "ImWindows8", ()=>ImWindows8);
parcelHelpers.export(exports, "ImWindows", ()=>ImWindows);
parcelHelpers.export(exports, "ImAndroid", ()=>ImAndroid);
parcelHelpers.export(exports, "ImFinder", ()=>ImFinder);
parcelHelpers.export(exports, "ImAppleinc", ()=>ImAppleinc);
parcelHelpers.export(exports, "ImTux", ()=>ImTux);
parcelHelpers.export(exports, "ImYahoo2", ()=>ImYahoo2);
parcelHelpers.export(exports, "ImYahoo", ()=>ImYahoo);
parcelHelpers.export(exports, "ImTumblr2", ()=>ImTumblr2);
parcelHelpers.export(exports, "ImTumblr", ()=>ImTumblr);
parcelHelpers.export(exports, "ImBlogger2", ()=>ImBlogger2);
parcelHelpers.export(exports, "ImBlogger", ()=>ImBlogger);
parcelHelpers.export(exports, "ImEllo", ()=>ImEllo);
parcelHelpers.export(exports, "ImJoomla", ()=>ImJoomla);
parcelHelpers.export(exports, "ImWordpress", ()=>ImWordpress);
parcelHelpers.export(exports, "ImTrello", ()=>ImTrello);
parcelHelpers.export(exports, "ImBasecamp", ()=>ImBasecamp);
parcelHelpers.export(exports, "ImNpm", ()=>ImNpm);
parcelHelpers.export(exports, "ImGithub", ()=>ImGithub);
parcelHelpers.export(exports, "ImOnedrive", ()=>ImOnedrive);
parcelHelpers.export(exports, "ImDropbox", ()=>ImDropbox);
parcelHelpers.export(exports, "ImSteam2", ()=>ImSteam2);
parcelHelpers.export(exports, "ImSteam", ()=>ImSteam);
parcelHelpers.export(exports, "Im500Px", ()=>Im500Px);
parcelHelpers.export(exports, "ImDeviantart", ()=>ImDeviantart);
parcelHelpers.export(exports, "ImBehance2", ()=>ImBehance2);
parcelHelpers.export(exports, "ImBehance", ()=>ImBehance);
parcelHelpers.export(exports, "ImDribbble", ()=>ImDribbble);
parcelHelpers.export(exports, "ImFlickr4", ()=>ImFlickr4);
parcelHelpers.export(exports, "ImFlickr3", ()=>ImFlickr3);
parcelHelpers.export(exports, "ImFlickr2", ()=>ImFlickr2);
parcelHelpers.export(exports, "ImFlickr", ()=>ImFlickr);
parcelHelpers.export(exports, "ImLanyrd", ()=>ImLanyrd);
parcelHelpers.export(exports, "ImVimeo2", ()=>ImVimeo2);
parcelHelpers.export(exports, "ImVimeo", ()=>ImVimeo);
parcelHelpers.export(exports, "ImTwitch", ()=>ImTwitch);
parcelHelpers.export(exports, "ImYoutube2", ()=>ImYoutube2);
parcelHelpers.export(exports, "ImYoutube", ()=>ImYoutube);
parcelHelpers.export(exports, "ImRss2", ()=>ImRss2);
parcelHelpers.export(exports, "ImRss", ()=>ImRss);
parcelHelpers.export(exports, "ImSinaWeibo", ()=>ImSinaWeibo);
parcelHelpers.export(exports, "ImRenren", ()=>ImRenren);
parcelHelpers.export(exports, "ImVk", ()=>ImVk);
parcelHelpers.export(exports, "ImVine", ()=>ImVine);
parcelHelpers.export(exports, "ImTwitter", ()=>ImTwitter);
parcelHelpers.export(exports, "ImTelegram", ()=>ImTelegram);
parcelHelpers.export(exports, "ImSpotify", ()=>ImSpotify);
parcelHelpers.export(exports, "ImWhatsapp", ()=>ImWhatsapp);
parcelHelpers.export(exports, "ImInstagram", ()=>ImInstagram);
parcelHelpers.export(exports, "ImFacebook2", ()=>ImFacebook2);
parcelHelpers.export(exports, "ImFacebook", ()=>ImFacebook);
parcelHelpers.export(exports, "ImGoogleDrive", ()=>ImGoogleDrive);
parcelHelpers.export(exports, "ImHangouts", ()=>ImHangouts);
parcelHelpers.export(exports, "ImGooglePlus3", ()=>ImGooglePlus3);
parcelHelpers.export(exports, "ImGooglePlus2", ()=>ImGooglePlus2);
parcelHelpers.export(exports, "ImGooglePlus", ()=>ImGooglePlus);
parcelHelpers.export(exports, "ImGoogle3", ()=>ImGoogle3);
parcelHelpers.export(exports, "ImGoogle2", ()=>ImGoogle2);
parcelHelpers.export(exports, "ImGoogle", ()=>ImGoogle);
parcelHelpers.export(exports, "ImAmazon", ()=>ImAmazon);
parcelHelpers.export(exports, "ImMail4", ()=>ImMail4);
parcelHelpers.export(exports, "ImMail3", ()=>ImMail3);
parcelHelpers.export(exports, "ImMail2", ()=>ImMail2);
parcelHelpers.export(exports, "ImMail", ()=>ImMail);
parcelHelpers.export(exports, "ImShare2", ()=>ImShare2);
parcelHelpers.export(exports, "ImTerminal", ()=>ImTerminal);
parcelHelpers.export(exports, "ImEmbed2", ()=>ImEmbed2);
parcelHelpers.export(exports, "ImEmbed", ()=>ImEmbed);
parcelHelpers.export(exports, "ImNewTab", ()=>ImNewTab);
parcelHelpers.export(exports, "ImShare", ()=>ImShare);
parcelHelpers.export(exports, "ImIndentDecrease", ()=>ImIndentDecrease);
parcelHelpers.export(exports, "ImIndentIncrease", ()=>ImIndentIncrease);
parcelHelpers.export(exports, "ImParagraphJustify", ()=>ImParagraphJustify);
parcelHelpers.export(exports, "ImParagraphRight", ()=>ImParagraphRight);
parcelHelpers.export(exports, "ImParagraphCenter", ()=>ImParagraphCenter);
parcelHelpers.export(exports, "ImParagraphLeft", ()=>ImParagraphLeft);
parcelHelpers.export(exports, "ImSection", ()=>ImSection);
parcelHelpers.export(exports, "ImRtl", ()=>ImRtl);
parcelHelpers.export(exports, "ImLtr", ()=>ImLtr);
parcelHelpers.export(exports, "ImPilcrow", ()=>ImPilcrow);
parcelHelpers.export(exports, "ImInsertTemplate", ()=>ImInsertTemplate);
parcelHelpers.export(exports, "ImTable2", ()=>ImTable2);
parcelHelpers.export(exports, "ImTable", ()=>ImTable);
parcelHelpers.export(exports, "ImClearFormatting", ()=>ImClearFormatting);
parcelHelpers.export(exports, "ImPagebreak", ()=>ImPagebreak);
parcelHelpers.export(exports, "ImTextColor", ()=>ImTextColor);
parcelHelpers.export(exports, "ImSubscript2", ()=>ImSubscript2);
parcelHelpers.export(exports, "ImSuperscript2", ()=>ImSuperscript2);
parcelHelpers.export(exports, "ImSubscript", ()=>ImSubscript);
parcelHelpers.export(exports, "ImSuperscript", ()=>ImSuperscript);
parcelHelpers.export(exports, "ImPageBreak", ()=>ImPageBreak);
parcelHelpers.export(exports, "ImSigma", ()=>ImSigma);
parcelHelpers.export(exports, "ImOmega", ()=>ImOmega);
parcelHelpers.export(exports, "ImStrikethrough", ()=>ImStrikethrough);
parcelHelpers.export(exports, "ImItalic", ()=>ImItalic);
parcelHelpers.export(exports, "ImUnderline", ()=>ImUnderline);
parcelHelpers.export(exports, "ImBold", ()=>ImBold);
parcelHelpers.export(exports, "ImFontSize", ()=>ImFontSize);
parcelHelpers.export(exports, "ImTextWidth", ()=>ImTextWidth);
parcelHelpers.export(exports, "ImTextHeight", ()=>ImTextHeight);
parcelHelpers.export(exports, "ImLigature2", ()=>ImLigature2);
parcelHelpers.export(exports, "ImLigature", ()=>ImLigature);
parcelHelpers.export(exports, "ImFont", ()=>ImFont);
parcelHelpers.export(exports, "ImFilter", ()=>ImFilter);
parcelHelpers.export(exports, "ImScissors", ()=>ImScissors);
parcelHelpers.export(exports, "ImUngroup", ()=>ImUngroup);
parcelHelpers.export(exports, "ImMakeGroup", ()=>ImMakeGroup);
parcelHelpers.export(exports, "ImCrop", ()=>ImCrop);
parcelHelpers.export(exports, "ImRadioUnchecked", ()=>ImRadioUnchecked);
parcelHelpers.export(exports, "ImRadioChecked2", ()=>ImRadioChecked2);
parcelHelpers.export(exports, "ImRadioChecked", ()=>ImRadioChecked);
parcelHelpers.export(exports, "ImCheckboxUnchecked", ()=>ImCheckboxUnchecked);
parcelHelpers.export(exports, "ImCheckboxChecked", ()=>ImCheckboxChecked);
parcelHelpers.export(exports, "ImOpt", ()=>ImOpt);
parcelHelpers.export(exports, "ImCtrl", ()=>ImCtrl);
parcelHelpers.export(exports, "ImShift", ()=>ImShift);
parcelHelpers.export(exports, "ImCommand", ()=>ImCommand);
parcelHelpers.export(exports, "ImSortAmountDesc", ()=>ImSortAmountDesc);
parcelHelpers.export(exports, "ImSortAmountAsc", ()=>ImSortAmountAsc);
parcelHelpers.export(exports, "ImSortNumbericDesc", ()=>ImSortNumbericDesc);
parcelHelpers.export(exports, "ImSortNumericAsc", ()=>ImSortNumericAsc);
parcelHelpers.export(exports, "ImSortAlphaDesc", ()=>ImSortAlphaDesc);
parcelHelpers.export(exports, "ImSortAlphaAsc", ()=>ImSortAlphaAsc);
parcelHelpers.export(exports, "ImMoveDown", ()=>ImMoveDown);
parcelHelpers.export(exports, "ImMoveUp", ()=>ImMoveUp);
parcelHelpers.export(exports, "ImTab", ()=>ImTab);
parcelHelpers.export(exports, "ImCircleLeft", ()=>ImCircleLeft);
parcelHelpers.export(exports, "ImCircleDown", ()=>ImCircleDown);
parcelHelpers.export(exports, "ImCircleRight", ()=>ImCircleRight);
parcelHelpers.export(exports, "ImCircleUp", ()=>ImCircleUp);
parcelHelpers.export(exports, "ImArrowLeft2", ()=>ImArrowLeft2);
parcelHelpers.export(exports, "ImArrowDownLeft2", ()=>ImArrowDownLeft2);
parcelHelpers.export(exports, "ImArrowDown2", ()=>ImArrowDown2);
parcelHelpers.export(exports, "ImArrowDownRight2", ()=>ImArrowDownRight2);
parcelHelpers.export(exports, "ImArrowRight2", ()=>ImArrowRight2);
parcelHelpers.export(exports, "ImArrowUpRight2", ()=>ImArrowUpRight2);
parcelHelpers.export(exports, "ImArrowUp2", ()=>ImArrowUp2);
parcelHelpers.export(exports, "ImArrowUpLeft2", ()=>ImArrowUpLeft2);
parcelHelpers.export(exports, "ImArrowLeft", ()=>ImArrowLeft);
parcelHelpers.export(exports, "ImArrowDownLeft", ()=>ImArrowDownLeft);
parcelHelpers.export(exports, "ImArrowDown", ()=>ImArrowDown);
parcelHelpers.export(exports, "ImArrowDownRight", ()=>ImArrowDownRight);
parcelHelpers.export(exports, "ImArrowRight", ()=>ImArrowRight);
parcelHelpers.export(exports, "ImArrowUpRight", ()=>ImArrowUpRight);
parcelHelpers.export(exports, "ImArrowUp", ()=>ImArrowUp);
parcelHelpers.export(exports, "ImArrowUpLeft", ()=>ImArrowUpLeft);
parcelHelpers.export(exports, "ImShuffle", ()=>ImShuffle);
parcelHelpers.export(exports, "ImInfinite", ()=>ImInfinite);
parcelHelpers.export(exports, "ImLoop2", ()=>ImLoop2);
parcelHelpers.export(exports, "ImLoop", ()=>ImLoop);
parcelHelpers.export(exports, "ImVolumeDecrease", ()=>ImVolumeDecrease);
parcelHelpers.export(exports, "ImVolumeIncrease", ()=>ImVolumeIncrease);
parcelHelpers.export(exports, "ImVolumeMute2", ()=>ImVolumeMute2);
parcelHelpers.export(exports, "ImVolumeMute", ()=>ImVolumeMute);
parcelHelpers.export(exports, "ImVolumeLow", ()=>ImVolumeLow);
parcelHelpers.export(exports, "ImVolumeMedium", ()=>ImVolumeMedium);
parcelHelpers.export(exports, "ImVolumeHigh", ()=>ImVolumeHigh);
parcelHelpers.export(exports, "ImEject", ()=>ImEject);
parcelHelpers.export(exports, "ImNext2", ()=>ImNext2);
parcelHelpers.export(exports, "ImPrevious2", ()=>ImPrevious2);
parcelHelpers.export(exports, "ImLast", ()=>ImLast);
parcelHelpers.export(exports, "ImFirst", ()=>ImFirst);
parcelHelpers.export(exports, "ImForward3", ()=>ImForward3);
parcelHelpers.export(exports, "ImBackward2", ()=>ImBackward2);
parcelHelpers.export(exports, "ImStop2", ()=>ImStop2);
parcelHelpers.export(exports, "ImPause2", ()=>ImPause2);
parcelHelpers.export(exports, "ImPlay3", ()=>ImPlay3);
parcelHelpers.export(exports, "ImForward2", ()=>ImForward2);
parcelHelpers.export(exports, "ImBackward", ()=>ImBackward);
parcelHelpers.export(exports, "ImNext", ()=>ImNext);
parcelHelpers.export(exports, "ImPrevious", ()=>ImPrevious);
parcelHelpers.export(exports, "ImStop", ()=>ImStop);
parcelHelpers.export(exports, "ImPause", ()=>ImPause);
parcelHelpers.export(exports, "ImPlay2", ()=>ImPlay2);
parcelHelpers.export(exports, "ImExit", ()=>ImExit);
parcelHelpers.export(exports, "ImEnter", ()=>ImEnter);
parcelHelpers.export(exports, "ImSpellCheck", ()=>ImSpellCheck);
parcelHelpers.export(exports, "ImCheckmark2", ()=>ImCheckmark2);
parcelHelpers.export(exports, "ImCheckmark", ()=>ImCheckmark);
parcelHelpers.export(exports, "ImCross", ()=>ImCross);
parcelHelpers.export(exports, "ImBlocked", ()=>ImBlocked);
parcelHelpers.export(exports, "ImCancelCircle", ()=>ImCancelCircle);
parcelHelpers.export(exports, "ImInfo", ()=>ImInfo);
parcelHelpers.export(exports, "ImMinus", ()=>ImMinus);
parcelHelpers.export(exports, "ImPlus", ()=>ImPlus);
parcelHelpers.export(exports, "ImQuestion", ()=>ImQuestion);
parcelHelpers.export(exports, "ImNotification", ()=>ImNotification);
parcelHelpers.export(exports, "ImWarning", ()=>ImWarning);
parcelHelpers.export(exports, "ImPointLeft", ()=>ImPointLeft);
parcelHelpers.export(exports, "ImPointDown", ()=>ImPointDown);
parcelHelpers.export(exports, "ImPointRight", ()=>ImPointRight);
parcelHelpers.export(exports, "ImPointUp", ()=>ImPointUp);
parcelHelpers.export(exports, "ImCrying2", ()=>ImCrying2);
parcelHelpers.export(exports, "ImCrying", ()=>ImCrying);
parcelHelpers.export(exports, "ImFrustrated2", ()=>ImFrustrated2);
parcelHelpers.export(exports, "ImFrustrated", ()=>ImFrustrated);
parcelHelpers.export(exports, "ImSleepy2", ()=>ImSleepy2);
parcelHelpers.export(exports, "ImSleepy", ()=>ImSleepy);
parcelHelpers.export(exports, "ImWondering2", ()=>ImWondering2);
parcelHelpers.export(exports, "ImWondering", ()=>ImWondering);
parcelHelpers.export(exports, "ImHipster2", ()=>ImHipster2);
parcelHelpers.export(exports, "ImHipster", ()=>ImHipster);
parcelHelpers.export(exports, "ImNeutral2", ()=>ImNeutral2);
parcelHelpers.export(exports, "ImNeutral", ()=>ImNeutral);
parcelHelpers.export(exports, "ImConfused2", ()=>ImConfused2);
parcelHelpers.export(exports, "ImConfused", ()=>ImConfused);
parcelHelpers.export(exports, "ImBaffled2", ()=>ImBaffled2);
parcelHelpers.export(exports, "ImBaffled", ()=>ImBaffled);
parcelHelpers.export(exports, "ImShocked2", ()=>ImShocked2);
parcelHelpers.export(exports, "ImShocked", ()=>ImShocked);
parcelHelpers.export(exports, "ImEvil2", ()=>ImEvil2);
parcelHelpers.export(exports, "ImEvil", ()=>ImEvil);
parcelHelpers.export(exports, "ImAngry2", ()=>ImAngry2);
parcelHelpers.export(exports, "ImAngry", ()=>ImAngry);
parcelHelpers.export(exports, "ImCool2", ()=>ImCool2);
parcelHelpers.export(exports, "ImCool", ()=>ImCool);
parcelHelpers.export(exports, "ImGrin2", ()=>ImGrin2);
parcelHelpers.export(exports, "ImGrin", ()=>ImGrin);
parcelHelpers.export(exports, "ImWink2", ()=>ImWink2);
parcelHelpers.export(exports, "ImWink", ()=>ImWink);
parcelHelpers.export(exports, "ImSad2", ()=>ImSad2);
parcelHelpers.export(exports, "ImSad", ()=>ImSad);
parcelHelpers.export(exports, "ImTongue2", ()=>ImTongue2);
parcelHelpers.export(exports, "ImTongue", ()=>ImTongue);
parcelHelpers.export(exports, "ImSmile2", ()=>ImSmile2);
parcelHelpers.export(exports, "ImSmile", ()=>ImSmile);
parcelHelpers.export(exports, "ImHappy2", ()=>ImHappy2);
parcelHelpers.export(exports, "ImHappy", ()=>ImHappy);
parcelHelpers.export(exports, "ImManWoman", ()=>ImManWoman);
parcelHelpers.export(exports, "ImWoman", ()=>ImWoman);
parcelHelpers.export(exports, "ImMan", ()=>ImMan);
parcelHelpers.export(exports, "ImHeartBroken", ()=>ImHeartBroken);
parcelHelpers.export(exports, "ImHeart", ()=>ImHeart);
parcelHelpers.export(exports, "ImStarFull", ()=>ImStarFull);
parcelHelpers.export(exports, "ImStarHalf", ()=>ImStarHalf);
parcelHelpers.export(exports, "ImStarEmpty", ()=>ImStarEmpty);
parcelHelpers.export(exports, "ImBrightnessContrast", ()=>ImBrightnessContrast);
parcelHelpers.export(exports, "ImContrast", ()=>ImContrast);
parcelHelpers.export(exports, "ImSun", ()=>ImSun);
parcelHelpers.export(exports, "ImBookmarks", ()=>ImBookmarks);
parcelHelpers.export(exports, "ImBookmark", ()=>ImBookmark);
parcelHelpers.export(exports, "ImEyeBlocked", ()=>ImEyeBlocked);
parcelHelpers.export(exports, "ImEyeMinus", ()=>ImEyeMinus);
parcelHelpers.export(exports, "ImEyePlus", ()=>ImEyePlus);
parcelHelpers.export(exports, "ImEye", ()=>ImEye);
parcelHelpers.export(exports, "ImAttachment", ()=>ImAttachment);
parcelHelpers.export(exports, "ImFlag", ()=>ImFlag);
parcelHelpers.export(exports, "ImLink", ()=>ImLink);
parcelHelpers.export(exports, "ImEarth", ()=>ImEarth);
parcelHelpers.export(exports, "ImSphere", ()=>ImSphere);
parcelHelpers.export(exports, "ImUpload3", ()=>ImUpload3);
parcelHelpers.export(exports, "ImDownload3", ()=>ImDownload3);
parcelHelpers.export(exports, "ImUpload2", ()=>ImUpload2);
parcelHelpers.export(exports, "ImDownload2", ()=>ImDownload2);
parcelHelpers.export(exports, "ImCloudCheck", ()=>ImCloudCheck);
parcelHelpers.export(exports, "ImCloudUpload", ()=>ImCloudUpload);
parcelHelpers.export(exports, "ImCloudDownload", ()=>ImCloudDownload);
parcelHelpers.export(exports, "ImCloud", ()=>ImCloud);
parcelHelpers.export(exports, "ImMenu4", ()=>ImMenu4);
parcelHelpers.export(exports, "ImMenu3", ()=>ImMenu3);
parcelHelpers.export(exports, "ImMenu2", ()=>ImMenu2);
parcelHelpers.export(exports, "ImMenu", ()=>ImMenu);
parcelHelpers.export(exports, "ImTree", ()=>ImTree);
parcelHelpers.export(exports, "ImList2", ()=>ImList2);
parcelHelpers.export(exports, "ImList", ()=>ImList);
parcelHelpers.export(exports, "ImListNumbered", ()=>ImListNumbered);
parcelHelpers.export(exports, "ImClipboard", ()=>ImClipboard);
parcelHelpers.export(exports, "ImPowerCord", ()=>ImPowerCord);
parcelHelpers.export(exports, "ImSwitch", ()=>ImSwitch);
parcelHelpers.export(exports, "ImPower", ()=>ImPower);
parcelHelpers.export(exports, "ImShield", ()=>ImShield);
parcelHelpers.export(exports, "ImTarget", ()=>ImTarget);
parcelHelpers.export(exports, "ImAccessibility", ()=>ImAccessibility);
parcelHelpers.export(exports, "ImRoad", ()=>ImRoad);
parcelHelpers.export(exports, "ImTruck", ()=>ImTruck);
parcelHelpers.export(exports, "ImAirplane", ()=>ImAirplane);
parcelHelpers.export(exports, "ImBriefcase", ()=>ImBriefcase);
parcelHelpers.export(exports, "ImBin2", ()=>ImBin2);
parcelHelpers.export(exports, "ImBin", ()=>ImBin);
parcelHelpers.export(exports, "ImMagnet", ()=>ImMagnet);
parcelHelpers.export(exports, "ImLab", ()=>ImLab);
parcelHelpers.export(exports, "ImFire", ()=>ImFire);
parcelHelpers.export(exports, "ImHammer2", ()=>ImHammer2);
parcelHelpers.export(exports, "ImMeter2", ()=>ImMeter2);
parcelHelpers.export(exports, "ImMeter", ()=>ImMeter);
parcelHelpers.export(exports, "ImRocket", ()=>ImRocket);
parcelHelpers.export(exports, "ImLeaf", ()=>ImLeaf);
parcelHelpers.export(exports, "ImSpoonKnife", ()=>ImSpoonKnife);
parcelHelpers.export(exports, "ImMug", ()=>ImMug);
parcelHelpers.export(exports, "ImGlass2", ()=>ImGlass2);
parcelHelpers.export(exports, "ImGlass", ()=>ImGlass);
parcelHelpers.export(exports, "ImGift", ()=>ImGift);
parcelHelpers.export(exports, "ImTrophy", ()=>ImTrophy);
parcelHelpers.export(exports, "ImStatsBars2", ()=>ImStatsBars2);
parcelHelpers.export(exports, "ImStatsBars", ()=>ImStatsBars);
parcelHelpers.export(exports, "ImStatsDots", ()=>ImStatsDots);
parcelHelpers.export(exports, "ImPieChart", ()=>ImPieChart);
parcelHelpers.export(exports, "ImBug", ()=>ImBug);
parcelHelpers.export(exports, "ImAidKit", ()=>ImAidKit);
parcelHelpers.export(exports, "ImMagicWand", ()=>ImMagicWand);
parcelHelpers.export(exports, "ImHammer", ()=>ImHammer);
parcelHelpers.export(exports, "ImCogs", ()=>ImCogs);
parcelHelpers.export(exports, "ImCog", ()=>ImCog);
parcelHelpers.export(exports, "ImEqualizer2", ()=>ImEqualizer2);
parcelHelpers.export(exports, "ImEqualizer", ()=>ImEqualizer);
parcelHelpers.export(exports, "ImWrench", ()=>ImWrench);
parcelHelpers.export(exports, "ImUnlocked", ()=>ImUnlocked);
parcelHelpers.export(exports, "ImLock", ()=>ImLock);
parcelHelpers.export(exports, "ImKey2", ()=>ImKey2);
parcelHelpers.export(exports, "ImKey", ()=>ImKey);
parcelHelpers.export(exports, "ImShrink2", ()=>ImShrink2);
parcelHelpers.export(exports, "ImEnlarge2", ()=>ImEnlarge2);
parcelHelpers.export(exports, "ImShrink", ()=>ImShrink);
parcelHelpers.export(exports, "ImEnlarge", ()=>ImEnlarge);
parcelHelpers.export(exports, "ImZoomOut", ()=>ImZoomOut);
parcelHelpers.export(exports, "ImZoomIn", ()=>ImZoomIn);
parcelHelpers.export(exports, "ImSearch", ()=>ImSearch);
parcelHelpers.export(exports, "ImBinoculars", ()=>ImBinoculars);
parcelHelpers.export(exports, "ImSpinner11", ()=>ImSpinner11);
parcelHelpers.export(exports, "ImSpinner10", ()=>ImSpinner10);
parcelHelpers.export(exports, "ImSpinner9", ()=>ImSpinner9);
parcelHelpers.export(exports, "ImSpinner8", ()=>ImSpinner8);
parcelHelpers.export(exports, "ImSpinner7", ()=>ImSpinner7);
parcelHelpers.export(exports, "ImSpinner6", ()=>ImSpinner6);
parcelHelpers.export(exports, "ImSpinner5", ()=>ImSpinner5);
parcelHelpers.export(exports, "ImSpinner4", ()=>ImSpinner4);
parcelHelpers.export(exports, "ImSpinner3", ()=>ImSpinner3);
parcelHelpers.export(exports, "ImSpinner2", ()=>ImSpinner2);
parcelHelpers.export(exports, "ImSpinner", ()=>ImSpinner);
parcelHelpers.export(exports, "ImHourGlass", ()=>ImHourGlass);
parcelHelpers.export(exports, "ImQuotesRight", ()=>ImQuotesRight);
parcelHelpers.export(exports, "ImQuotesLeft", ()=>ImQuotesLeft);
parcelHelpers.export(exports, "ImUserTie", ()=>ImUserTie);
parcelHelpers.export(exports, "ImUserCheck", ()=>ImUserCheck);
parcelHelpers.export(exports, "ImUserMinus", ()=>ImUserMinus);
parcelHelpers.export(exports, "ImUserPlus", ()=>ImUserPlus);
parcelHelpers.export(exports, "ImUsers", ()=>ImUsers);
parcelHelpers.export(exports, "ImUser", ()=>ImUser);
parcelHelpers.export(exports, "ImBubbles4", ()=>ImBubbles4);
parcelHelpers.export(exports, "ImBubbles3", ()=>ImBubbles3);
parcelHelpers.export(exports, "ImBubble2", ()=>ImBubble2);
parcelHelpers.export(exports, "ImBubbles2", ()=>ImBubbles2);
parcelHelpers.export(exports, "ImBubbles", ()=>ImBubbles);
parcelHelpers.export(exports, "ImBubble", ()=>ImBubble);
parcelHelpers.export(exports, "ImReply", ()=>ImReply);
parcelHelpers.export(exports, "ImForward", ()=>ImForward);
parcelHelpers.export(exports, "ImRedo2", ()=>ImRedo2);
parcelHelpers.export(exports, "ImUndo2", ()=>ImUndo2);
parcelHelpers.export(exports, "ImRedo", ()=>ImRedo);
parcelHelpers.export(exports, "ImUndo", ()=>ImUndo);
parcelHelpers.export(exports, "ImDatabase", ()=>ImDatabase);
parcelHelpers.export(exports, "ImDrive", ()=>ImDrive);
parcelHelpers.export(exports, "ImFloppyDisk", ()=>ImFloppyDisk);
parcelHelpers.export(exports, "ImUpload", ()=>ImUpload);
parcelHelpers.export(exports, "ImDownload", ()=>ImDownload);
parcelHelpers.export(exports, "ImBoxRemove", ()=>ImBoxRemove);
parcelHelpers.export(exports, "ImBoxAdd", ()=>ImBoxAdd);
parcelHelpers.export(exports, "ImDrawer2", ()=>ImDrawer2);
parcelHelpers.export(exports, "ImDrawer", ()=>ImDrawer);
parcelHelpers.export(exports, "ImTv", ()=>ImTv);
parcelHelpers.export(exports, "ImTablet", ()=>ImTablet);
parcelHelpers.export(exports, "ImMobile2", ()=>ImMobile2);
parcelHelpers.export(exports, "ImMobile", ()=>ImMobile);
parcelHelpers.export(exports, "ImLaptop", ()=>ImLaptop);
parcelHelpers.export(exports, "ImDisplay", ()=>ImDisplay);
parcelHelpers.export(exports, "ImKeyboard", ()=>ImKeyboard);
parcelHelpers.export(exports, "ImPrinter", ()=>ImPrinter);
parcelHelpers.export(exports, "ImCalendar", ()=>ImCalendar);
parcelHelpers.export(exports, "ImStopwatch", ()=>ImStopwatch);
parcelHelpers.export(exports, "ImBell", ()=>ImBell);
parcelHelpers.export(exports, "ImAlarm", ()=>ImAlarm);
parcelHelpers.export(exports, "ImClock2", ()=>ImClock2);
parcelHelpers.export(exports, "ImClock", ()=>ImClock);
parcelHelpers.export(exports, "ImHistory", ()=>ImHistory);
parcelHelpers.export(exports, "ImMap2", ()=>ImMap2);
parcelHelpers.export(exports, "ImMap", ()=>ImMap);
parcelHelpers.export(exports, "ImCompass2", ()=>ImCompass2);
parcelHelpers.export(exports, "ImCompass", ()=>ImCompass);
parcelHelpers.export(exports, "ImLocation2", ()=>ImLocation2);
parcelHelpers.export(exports, "ImLocation", ()=>ImLocation);
parcelHelpers.export(exports, "ImPushpin", ()=>ImPushpin);
parcelHelpers.export(exports, "ImEnvelop", ()=>ImEnvelop);
parcelHelpers.export(exports, "ImAddressBook", ()=>ImAddressBook);
parcelHelpers.export(exports, "ImPhoneHangUp", ()=>ImPhoneHangUp);
parcelHelpers.export(exports, "ImPhone", ()=>ImPhone);
parcelHelpers.export(exports, "ImLifebuoy", ()=>ImLifebuoy);
parcelHelpers.export(exports, "ImCalculator", ()=>ImCalculator);
parcelHelpers.export(exports, "ImCreditCard", ()=>ImCreditCard);
parcelHelpers.export(exports, "ImCoinYen", ()=>ImCoinYen);
parcelHelpers.export(exports, "ImCoinPound", ()=>ImCoinPound);
parcelHelpers.export(exports, "ImCoinEuro", ()=>ImCoinEuro);
parcelHelpers.export(exports, "ImCoinDollar", ()=>ImCoinDollar);
parcelHelpers.export(exports, "ImCart", ()=>ImCart);
parcelHelpers.export(exports, "ImTicket", ()=>ImTicket);
parcelHelpers.export(exports, "ImQrcode", ()=>ImQrcode);
parcelHelpers.export(exports, "ImBarcode", ()=>ImBarcode);
parcelHelpers.export(exports, "ImPriceTags", ()=>ImPriceTags);
parcelHelpers.export(exports, "ImPriceTag", ()=>ImPriceTag);
parcelHelpers.export(exports, "ImFolderUpload", ()=>ImFolderUpload);
parcelHelpers.export(exports, "ImFolderDownload", ()=>ImFolderDownload);
parcelHelpers.export(exports, "ImFolderMinus", ()=>ImFolderMinus);
parcelHelpers.export(exports, "ImFolderPlus", ()=>ImFolderPlus);
parcelHelpers.export(exports, "ImFolderOpen", ()=>ImFolderOpen);
parcelHelpers.export(exports, "ImFolder", ()=>ImFolder);
parcelHelpers.export(exports, "ImStack", ()=>ImStack);
parcelHelpers.export(exports, "ImPaste", ()=>ImPaste);
parcelHelpers.export(exports, "ImCopy", ()=>ImCopy);
parcelHelpers.export(exports, "ImFileZip", ()=>ImFileZip);
parcelHelpers.export(exports, "ImFileVideo", ()=>ImFileVideo);
parcelHelpers.export(exports, "ImFilePlay", ()=>ImFilePlay);
parcelHelpers.export(exports, "ImFileMusic", ()=>ImFileMusic);
parcelHelpers.export(exports, "ImFilePicture", ()=>ImFilePicture);
parcelHelpers.export(exports, "ImFileText2", ()=>ImFileText2);
parcelHelpers.export(exports, "ImFilesEmpty", ()=>ImFilesEmpty);
parcelHelpers.export(exports, "ImFileEmpty", ()=>ImFileEmpty);
parcelHelpers.export(exports, "ImProfile", ()=>ImProfile);
parcelHelpers.export(exports, "ImFileText", ()=>ImFileText);
parcelHelpers.export(exports, "ImLibrary", ()=>ImLibrary);
parcelHelpers.export(exports, "ImBooks", ()=>ImBooks);
parcelHelpers.export(exports, "ImBook", ()=>ImBook);
parcelHelpers.export(exports, "ImMic", ()=>ImMic);
parcelHelpers.export(exports, "ImFeed", ()=>ImFeed);
parcelHelpers.export(exports, "ImPodcast", ()=>ImPodcast);
parcelHelpers.export(exports, "ImConnection", ()=>ImConnection);
parcelHelpers.export(exports, "ImBullhorn", ()=>ImBullhorn);
parcelHelpers.export(exports, "ImDiamonds", ()=>ImDiamonds);
parcelHelpers.export(exports, "ImClubs", ()=>ImClubs);
parcelHelpers.export(exports, "ImSpades", ()=>ImSpades);
parcelHelpers.export(exports, "ImPacman", ()=>ImPacman);
parcelHelpers.export(exports, "ImDice", ()=>ImDice);
parcelHelpers.export(exports, "ImVideoCamera", ()=>ImVideoCamera);
parcelHelpers.export(exports, "ImFilm", ()=>ImFilm);
parcelHelpers.export(exports, "ImPlay", ()=>ImPlay);
parcelHelpers.export(exports, "ImMusic", ()=>ImMusic);
parcelHelpers.export(exports, "ImHeadphones", ()=>ImHeadphones);
parcelHelpers.export(exports, "ImCamera", ()=>ImCamera);
parcelHelpers.export(exports, "ImImages", ()=>ImImages);
parcelHelpers.export(exports, "ImImage", ()=>ImImage);
parcelHelpers.export(exports, "ImPaintFormat", ()=>ImPaintFormat);
parcelHelpers.export(exports, "ImDroplet", ()=>ImDroplet);
parcelHelpers.export(exports, "ImEyedropper", ()=>ImEyedropper);
parcelHelpers.export(exports, "ImBlog", ()=>ImBlog);
parcelHelpers.export(exports, "ImPen", ()=>ImPen);
parcelHelpers.export(exports, "ImQuill", ()=>ImQuill);
parcelHelpers.export(exports, "ImPencil2", ()=>ImPencil2);
parcelHelpers.export(exports, "ImPencil", ()=>ImPencil);
parcelHelpers.export(exports, "ImNewspaper", ()=>ImNewspaper);
parcelHelpers.export(exports, "ImOffice", ()=>ImOffice);
parcelHelpers.export(exports, "ImHome3", ()=>ImHome3);
parcelHelpers.export(exports, "ImHome2", ()=>ImHome2);
parcelHelpers.export(exports, "ImHome", ()=>ImHome);
var _indexMjs = require("../lib/index.mjs");
function ImIcoMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.055 8c0-1.022 0.829-1.851 1.851-1.851s1.851 0.829 1.851 1.851c0 1.022-0.829 1.851-1.851 1.851s-1.851-0.829-1.851-1.851zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM5.928 14.989c-2.406-1.4-4.023-4.005-4.023-6.989s1.617-5.589 4.023-6.989c2.406 1.399 4.025 4.005 4.025 6.989s-1.618 5.589-4.025 6.989z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSvg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 6.5c-0.444 0-0.843 0.193-1.118 0.5h-2.968l2.099-2.099c0.411 0.023 0.83-0.123 1.144-0.437 0.586-0.586 0.586-1.536 0-2.121s-1.536-0.586-2.121 0c-0.314 0.314-0.46 0.733-0.437 1.144l-2.099 2.099v-2.968c0.307-0.275 0.5-0.674 0.5-1.118 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.444 0.193 0.843 0.5 1.118v2.968l-2.099-2.099c0.023-0.411-0.123-0.83-0.437-1.144-0.586-0.586-1.536-0.586-2.121 0s-0.586 1.536 0 2.121c0.314 0.314 0.733 0.46 1.144 0.437l2.099 2.099h-2.968c-0.275-0.307-0.674-0.5-1.118-0.5-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.444 0 0.843-0.193 1.118-0.5h2.968l-2.099 2.099c-0.411-0.023-0.83 0.123-1.144 0.437-0.586 0.586-0.586 1.536 0 2.121s1.536 0.586 2.121 0c0.314-0.314 0.46-0.733 0.437-1.144l2.099-2.099v2.968c-0.307 0.275-0.5 0.674-0.5 1.118 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.444-0.193-0.843-0.5-1.118v-2.968l2.099 2.099c-0.023 0.411 0.123 0.83 0.437 1.144 0.586 0.586 1.536 0.586 2.121 0s0.586-1.536 0-2.121c-0.314-0.314-0.733-0.46-1.144-0.437l-2.099-2.099h2.968c0.275 0.307 0.674 0.5 1.118 0.5 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCodepen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.777 5.751l-7-4.667c-0.168-0.112-0.387-0.112-0.555 0l-7 4.667c-0.139 0.093-0.223 0.249-0.223 0.416v4.667c0 0.167 0.084 0.323 0.223 0.416l7 4.667c0.084 0.056 0.181 0.084 0.277 0.084s0.193-0.028 0.277-0.084l7-4.667c0.139-0.093 0.223-0.249 0.223-0.416v-4.667c0-0.167-0.084-0.323-0.223-0.416zM7.5 10.232l-2.599-1.732 2.599-1.732 2.599 1.732-2.599 1.732zM8 5.899v-3.465l5.599 3.732-2.599 1.732-3-2zM7 5.899l-3 2-2.599-1.732 5.599-3.732v3.465zM3.099 8.5l-2.099 1.399v-2.798l2.099 1.399zM4 9.101l3 2v3.465l-5.599-3.732 2.599-1.732zM8 11.101l3-2 2.599 1.732-5.599 3.732v-3.465zM11.901 8.5l2.099-1.399v2.798l-2.099-1.399z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.698 7.287l-6.986-6.986c-0.402-0.402-1.055-0.402-1.457 0l-1.623 1.623 1.221 1.221c0.196-0.094 0.415-0.146 0.647-0.146 0.828 0 1.5 0.672 1.5 1.5 0 0.232-0.053 0.451-0.146 0.647l2 2c0.196-0.094 0.415-0.146 0.647-0.146 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5c0-0.232 0.053-0.451 0.146-0.647l-2-2c-0.048 0.023-0.097 0.043-0.147 0.061v4.171c0.583 0.206 1 0.761 1 1.414 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.653 0.417-1.208 1-1.414v-4.171c-0.583-0.206-1-0.761-1-1.414 0-0.232 0.053-0.451 0.146-0.647l-1.221-1.221-4.623 4.623c-0.402 0.403-0.402 1.055 0 1.458l6.986 6.986c0.402 0.402 1.054 0.402 1.457 0l6.953-6.953c0.402-0.403 0.402-1.055-0-1.458z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCss3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.381 0.758l-0.537 2.686h10.934l-0.342 1.735h-10.94l-0.53 2.686h10.933l-0.61 3.063-4.406 1.46-3.819-1.46 0.261-1.329h-2.686l-0.639 3.224 6.316 2.417 7.281-2.417 2.403-12.066z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHtmlFive2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.946 0l1.284 14.4 5.762 1.6 5.777-1.602 1.286-14.398h-14.108zM12.668 13.482l-4.644 1.287v0.007l-0.012-0.004-0.012 0.004v-0.007l-4.644-1.287-1.098-12.304h11.508l-1.098 12.304zM10.168 8.284l-0.204 2.29-1.972 0.532-1.967-0.53-0.126-1.41h-1.773l0.247 2.774 3.626 1.003 3.615-1.003 0.485-5.422h-6.437l-0.161-1.809h6.758l0.158-1.766h-8.847l0.477 5.341z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHtmlFive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.946 0l1.284 14.4 5.762 1.6 5.777-1.602 1.286-14.398h-14.108zM12.26 4.71h-6.758l0.161 1.809h6.437l-0.485 5.422-3.623 1.004-3.618-1.004-0.247-2.774h1.773l0.126 1.41 1.967 0.53 0.004-0.001 1.968-0.531 0.204-2.29h-6.121l-0.476-5.341h8.847l-0.158 1.766z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLibreoffice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.354 0.354c-0.194-0.194-0.579-0.354-0.854-0.354h-6c-0.275 0-0.5 0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.159-0.659-0.354-0.854l-5.293-5.293zM13 15h-11v-14h5.487c0.046 0.008 0.131 0.043 0.169 0.070l5.274 5.274c0.027 0.038 0.062 0.123 0.070 0.169v8.487zM13.5 0h-3c-0.275 0-0.341 0.159-0.146 0.354l3.293 3.293c0.194 0.194 0.354 0.129 0.354-0.146v-3c0-0.275-0.225-0.5-0.5-0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFileExcel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.61 6h-2.114l-1.496 2.204-1.496-2.204h-2.114l2.534 3.788-2.859 4.212h3.935v-1.431h-0.784l0.784-1.172 1.741 2.603h2.194l-2.859-4.212 2.534-3.788z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFileWord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.997 7.436h0.691l-0.797 3.534-1.036-4.969h-1.665l-1.205 4.969-0.903-4.969h-1.741l1.767 7.998h1.701l1.192-4.73 1.066 4.73h1.568l2.025-7.998h-2.663v1.435z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFileOpenoffice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.785 7.37c-0.948-0.448-2.156-0.538-3.044 0.095 1.080-0.103 2.265 0.076 3.049 0.893 0.75-0.861 1.939-1.022 3.015-0.933-0.898-0.596-2.082-0.516-3.019-0.054v0zM10.401 9.465c-1.068-0.025-2.101 0.362-2.986 0.939-1.675-0.712-3.793-0.58-5.219 0.609 0.411-0.015 0.813-0.116 1.22-0.169 1.487-0.148 3.072 0.221 4.196 1.247 0.465-0.68 1.119-1.223 1.87-1.561 0.986-0.477 2.096-0.526 3.169-0.539-0.651-0.448-1.478-0.531-2.249-0.526z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFilePdf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.156 9.211c-0.213-0.21-0.686-0.321-1.406-0.331-0.487-0.005-1.073 0.038-1.69 0.124-0.276-0.159-0.561-0.333-0.784-0.542-0.601-0.561-1.103-1.34-1.415-2.197 0.020-0.080 0.038-0.15 0.054-0.222 0 0 0.339-1.923 0.249-2.573-0.012-0.089-0.020-0.115-0.044-0.184l-0.029-0.076c-0.092-0.212-0.273-0.437-0.556-0.425l-0.171-0.005c-0.316 0-0.573 0.161-0.64 0.403-0.205 0.757 0.007 1.889 0.39 3.355l-0.098 0.239c-0.275 0.67-0.619 1.345-0.923 1.94l-0.040 0.077c-0.32 0.626-0.61 1.157-0.873 1.607l-0.271 0.144c-0.020 0.010-0.485 0.257-0.594 0.323-0.926 0.553-1.539 1.18-1.641 1.678-0.032 0.159-0.008 0.362 0.156 0.456l0.263 0.132c0.114 0.057 0.234 0.086 0.357 0.086 0.659 0 1.425-0.821 2.48-2.662 1.218-0.396 2.604-0.726 3.819-0.908 0.926 0.521 2.065 0.883 2.783 0.883 0.128 0 0.238-0.012 0.327-0.036 0.138-0.037 0.254-0.115 0.325-0.222 0.139-0.21 0.168-0.499 0.13-0.795-0.011-0.088-0.081-0.196-0.157-0.271zM3.307 12.72c0.12-0.329 0.596-0.979 1.3-1.556 0.044-0.036 0.153-0.138 0.253-0.233-0.736 1.174-1.229 1.642-1.553 1.788zM7.476 3.12c0.212 0 0.333 0.534 0.343 1.035s-0.107 0.853-0.252 1.113c-0.12-0.385-0.179-0.992-0.179-1.389 0 0-0.009-0.759 0.088-0.759v0zM6.232 9.961c0.148-0.264 0.301-0.543 0.458-0.839 0.383-0.724 0.624-1.29 0.804-1.755 0.358 0.651 0.804 1.205 1.328 1.649 0.065 0.055 0.135 0.111 0.207 0.166-1.066 0.211-1.987 0.467-2.798 0.779v0zM12.952 9.901c-0.065 0.041-0.251 0.064-0.37 0.064-0.386 0-0.864-0.176-1.533-0.464 0.257-0.019 0.493-0.029 0.705-0.029 0.387 0 0.502-0.002 0.88 0.095s0.383 0.293 0.318 0.333v0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImOpera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v0 0c0 2.369-1.031 4.5-2.669 5.963-2.053 1-3.966 0.3-4.597-0.137 2.016-0.441 3.537-2.878 3.537-5.825s-1.522-5.384-3.537-5.828c0.634-0.438 2.547-1.137 4.597-0.138 1.637 1.466 2.669 3.597 2.669 5.966v0 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.366 3.491c-0.884 1.044-1.456 2.587-1.494 4.322 0 0.003 0 0.372 0 0.378 0.038 1.731 0.613 3.275 1.497 4.319 1.147 1.491 2.853 2.434 4.759 2.434 1.172 0 2.269-0.356 3.206-0.978-1.419 1.266-3.287 2.034-5.334 2.034-0.128 0-0.256-0.003-0.381-0.009-4.241-0.2-7.619-3.7-7.619-7.991 0-4.419 3.581-8 8-8 0.009 0 0.019 0 0.031 0 2.037 0.006 3.894 0.775 5.303 2.038-0.938-0.622-2.034-0.981-3.206-0.981-1.906 0-3.612 0.944-4.763 2.434z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSafari(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM14.975 7.388l-0.016-0.166c0.003 0.056 0.009 0.109 0.016 0.166zM13.881 4.2l-0.113-0.169c0.037 0.056 0.075 0.112 0.113 0.169zM13.447 3.603l-0.069-0.084c0.025 0.028 0.047 0.056 0.069 0.084zM12.478 2.619l-0.084-0.069c0.031 0.025 0.056 0.047 0.084 0.069zM11.969 2.231l-0.169-0.112c0.056 0.038 0.113 0.075 0.169 0.112zM8.778 1.044l-0.169-0.016c0.056 0.003 0.113 0.009 0.169 0.016zM7.388 1.025l-0.169 0.016c0.056-0.003 0.112-0.009 0.169-0.016zM4.2 2.119l-0.169 0.112c0.056-0.038 0.112-0.075 0.169-0.112zM3.603 2.553l-0.081 0.066c0.028-0.022 0.053-0.044 0.081-0.066zM2.619 3.522l-0.069 0.084c0.025-0.028 0.047-0.056 0.069-0.084zM2.231 4.031l-0.112 0.169c0.038-0.056 0.075-0.112 0.112-0.169zM1.044 7.222l-0.016 0.169c0.003-0.056 0.009-0.112 0.016-0.169zM1.025 8.613l0.016 0.169c-0.003-0.056-0.009-0.113-0.016-0.169zM2.119 11.797l0.112 0.169c-0.038-0.053-0.075-0.109-0.112-0.169zM2.25 11.994l1.247-0.834-0.138-0.209-1.247 0.834c-0.566-0.878-0.938-1.887-1.063-2.975l0.747-0.075-0.025-0.25-0.747 0.075c-0.012-0.144-0.019-0.291-0.022-0.438h1.5v-0.25h-1.5c0.003-0.147 0.009-0.291 0.022-0.438l0.747 0.072 0.025-0.25-0.747-0.072c0.125-1.088 0.5-2.097 1.066-2.975l1.247 0.834 0.138-0.209-1.25-0.828c0.084-0.119 0.169-0.237 0.259-0.35l0.578 0.475 0.159-0.194-0.578-0.475c0.094-0.112 0.194-0.219 0.294-0.325l1.059 1.059 0.178-0.178-1.059-1.059c0.106-0.1 0.212-0.2 0.322-0.294l0.475 0.581 0.194-0.159-0.475-0.578c0.116-0.091 0.231-0.178 0.35-0.263l0.834 1.247 0.209-0.138-0.834-1.247c0.878-0.566 1.888-0.938 2.975-1.063l0.075 0.747 0.25-0.025-0.075-0.747c0.144-0.012 0.291-0.019 0.438-0.022v1.5h0.25v-1.5c0.147 0.003 0.291 0.009 0.438 0.022l-0.072 0.747 0.25 0.025 0.072-0.747c1.088 0.125 2.097 0.5 2.975 1.066l-0.834 1.247 0.209 0.138 0.834-1.247c0.119 0.084 0.238 0.169 0.35 0.259l-0.475 0.578 0.194 0.159 0.475-0.578c0.113 0.094 0.219 0.194 0.325 0.294l-0.4 0.391-5.469 3.647-3.647 5.469-0.391 0.391c-0.1-0.106-0.2-0.213-0.294-0.322l0.578-0.475-0.159-0.194-0.578 0.475c-0.091-0.113-0.175-0.231-0.259-0.35zM2.619 12.478c-0.022-0.028-0.044-0.053-0.066-0.081l0.066 0.081zM3.522 13.381l0.081 0.066c-0.028-0.022-0.053-0.044-0.081-0.066zM4.031 13.766l0.169 0.113c-0.056-0.034-0.112-0.072-0.169-0.113zM7.222 14.956l0.169 0.016c-0.056-0.003-0.112-0.009-0.169-0.016zM8.613 14.975l0.166-0.016c-0.056 0.003-0.109 0.009-0.166 0.016zM11.8 13.881l0.169-0.113c-0.056 0.037-0.113 0.075-0.169 0.113zM12.397 13.447l0.084-0.069c-0.028 0.025-0.056 0.047-0.084 0.069zM12.944 12.956l0.012-0.012c-0.003 0.003-0.009 0.009-0.012 0.012zM13.381 12.478l0.069-0.084c-0.025 0.028-0.047 0.056-0.069 0.084zM13.491 12.344l-0.578-0.475-0.159 0.194 0.578 0.475c-0.094 0.113-0.194 0.219-0.294 0.325l-1.059-1.059-0.178 0.178 1.059 1.059c-0.106 0.1-0.213 0.2-0.322 0.294l-0.475-0.581-0.194 0.159 0.475 0.578c-0.116 0.091-0.231 0.178-0.35 0.262l-0.834-1.247-0.209 0.137 0.834 1.247c-0.878 0.566-1.887 0.938-2.975 1.063l-0.075-0.747-0.25 0.025 0.075 0.747c-0.144 0.012-0.291 0.019-0.438 0.022v-1.5h-0.25v1.5c-0.147-0.003-0.291-0.009-0.438-0.022l0.072-0.747-0.25-0.025-0.072 0.747c-1.088-0.125-2.097-0.5-2.975-1.066l0.834-1.247-0.209-0.137-0.828 1.247c-0.119-0.084-0.237-0.169-0.35-0.259l0.475-0.578-0.194-0.159-0.475 0.578c-0.112-0.094-0.219-0.194-0.325-0.294l0.394-0.391 5.469-3.647 3.647-5.469 0.391-0.391c0.1 0.106 0.2 0.212 0.294 0.322l-0.578 0.475 0.159 0.194 0.578-0.475c0.091 0.116 0.178 0.231 0.262 0.35l-1.247 0.834 0.137 0.209 1.247-0.834c0.566 0.878 0.938 1.888 1.063 2.975l-0.747 0.075 0.025 0.25 0.747-0.075c0.012 0.144 0.019 0.291 0.022 0.438h-1.5v0.25h1.5c-0.003 0.147-0.009 0.291-0.022 0.438l-0.747-0.072-0.025 0.25 0.747 0.072c-0.125 1.088-0.5 2.097-1.066 2.975l-1.247-0.834-0.137 0.209 1.247 0.834c-0.081 0.113-0.169 0.228-0.259 0.344zM14.975 8.609c-0.006 0.056-0.009 0.113-0.016 0.169l0.016-0.169zM13.881 11.8c-0.037 0.056-0.075 0.113-0.113 0.169l0.113-0.169z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.758 1.111l0.293 1.471-0.245 0.049-0.293-1.471 0.245-0.049z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.245 14.89l-0.293-1.471 0.245-0.049 0.293 1.471-0.245 0.049z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.088 1.264l0.218 0.718-0.239 0.073-0.218-0.718 0.239-0.073z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.913 14.733l-0.218-0.718 0.239-0.073 0.218 0.718-0.239 0.073z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.438 1.486l0.574 1.386-0.231 0.096-0.574-1.386 0.231-0.096z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.564 14.515l-0.574-1.386 0.231-0.096 0.574 1.386-0.231 0.096z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.588 1.885l0.22-0.118 0.354 0.661-0.22 0.118-0.354-0.661z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.408 14.114l-0.22 0.118-0.354-0.661 0.22-0.118 0.354 0.661z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.884 4.591l0.662 0.353-0.118 0.221-0.661-0.353 0.118-0.221z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.113 11.409l-0.662-0.353 0.118-0.22 0.662 0.353-0.118 0.22z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.872 6.010l-1.386-0.574 0.096-0.231 1.386 0.574-0.096 0.231z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.13 9.989l1.386 0.574-0.096 0.231-1.386-0.574 0.096-0.231z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.337 5.85l0.718 0.218-0.073 0.239-0.718-0.218 0.073-0.239z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.661 10.151l-0.718-0.218 0.073-0.239 0.718 0.218-0.073 0.239z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.157 6.512l1.471 0.293-0.049 0.245-1.471-0.293 0.049-0.245z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.84 9.488l-1.471-0.293 0.049-0.245 1.471 0.293-0.049 0.245z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.109 9.243l1.471-0.293 0.049 0.245-1.471 0.293-0.049-0.245z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.888 6.757l-1.471 0.293-0.049-0.245 1.471-0.293 0.049 0.245z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.265 9.914l0.718-0.218 0.073 0.239-0.718 0.218-0.073-0.239z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.734 6.089l-0.718 0.218-0.073-0.239 0.718-0.218 0.073 0.239z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.58 10.796l-0.096-0.231 1.386-0.574 0.096 0.231-1.386 0.574z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.419 5.207l0.096 0.231-1.386 0.574-0.096-0.231 1.386-0.574z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.888 11.41l-0.118-0.22 0.661-0.354 0.118 0.22-0.661 0.354z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.116 4.59l0.118 0.22-0.661 0.354-0.118-0.22 0.661-0.354z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.811 14.232l-0.22-0.118 0.354-0.661 0.22 0.118-0.354 0.661z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.189 1.767l0.22 0.118-0.353 0.661-0.22-0.118 0.353-0.661z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.207 14.419l0.574-1.386 0.231 0.096-0.574 1.386-0.231-0.096z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.795 1.58l-0.574 1.386-0.231-0.096 0.574-1.386 0.231 0.096z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.088 14.735l-0.239-0.073 0.218-0.718 0.239 0.073-0.218 0.718z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.912 1.264l0.239 0.073-0.218 0.718-0.239-0.073 0.218-0.718z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.757 14.888l-0.245-0.049 0.293-1.471 0.245 0.049-0.293 1.471z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.243 1.109l0.245 0.049-0.293 1.471-0.245-0.049 0.293-1.471z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEdge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.241 7.103c0.469-3.7 2.994-7.056 7.519-7.103 2.731 0.053 4.978 1.291 6.316 3.65 0.672 1.231 0.881 2.525 0.925 3.953v1.678h-10.041c0.047 4.141 6.094 4 8.697 2.175v3.372c-1.525 0.916-4.984 1.734-7.662 0.681-2.281-0.856-3.906-3.244-3.897-5.541-0.075-2.978 1.481-4.95 3.897-6.072-0.513 0.634-0.903 1.334-1.106 2.547h5.669c0 0 0.331-3.388-3.209-3.388-3.338 0.116-5.744 2.056-7.106 4.047v0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImIe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.472 9.825h3.688c0.028-0.256 0.040-0.517 0.040-0.784 0-1.253-0.336-2.429-0.924-3.442 0.607-1.614 0.586-2.984-0.227-3.803-0.773-0.77-2.848-0.645-5.194 0.394-0.174-0.013-0.349-0.020-0.526-0.020-3.22 0-5.921 2.216-6.667 5.201 1.010-1.293 2.072-2.231 3.492-2.913-0.129 0.121-0.882 0.87-1.009 0.996-3.743 3.742-4.923 8.63-3.653 9.9 0.965 0.965 2.715 0.802 4.725-0.182 0.934 0.476 1.992 0.744 3.113 0.744 3.018 0 5.575-1.942 6.501-4.648h-3.717c-0.511 0.943-1.512 1.586-2.66 1.586s-2.148-0.642-2.66-1.586c-0.227-0.426-0.358-0.915-0.358-1.432v-0.011h6.035zM5.442 8.013c0.085-1.517 1.347-2.728 2.887-2.728s2.802 1.21 2.887 2.728h-5.774zM14.015 2.559c0.524 0.529 0.511 1.503 0.063 2.719-0.768-1.17-1.883-2.093-3.2-2.619 1.408-0.604 2.553-0.684 3.137-0.1zM1.461 15.113c-0.668-0.669-0.467-2.072 0.394-3.763 0.536 1.504 1.581 2.767 2.927 3.581-1.491 0.677-2.712 0.792-3.321 0.182z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFirefox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.977 5.221l-0.185 1.189c0 0-0.265-2.201-0.59-3.024-0.498-1.261-0.719-1.251-0.72-1.249 0.333 0.847 0.273 1.302 0.273 1.302s-0.591-1.609-2.152-2.121c-1.729-0.567-2.665-0.412-2.773-0.383-0.016-0-0.032-0-0.047-0 0.013 0.001 0.025 0.002 0.038 0.003-0.001 0-0.001 0.001-0.001 0.001 0.007 0.009 1.911 0.333 2.249 0.797 0 0-0.809 0-1.614 0.232-0.036 0.010 2.961 0.374 3.574 3.37 0 0-0.329-0.686-0.735-0.802 0.267 0.813 0.199 2.356-0.056 3.123-0.033 0.099-0.066-0.426-0.568-0.652 0.161 1.151-0.010 2.976-0.808 3.479-0.062 0.039 0.5-1.802 0.113-1.090-2.23 3.419-4.866 1.578-6.051 0.767 0.607 0.132 1.76-0.021 2.271-0.4 0.001-0 0.001-0.001 0.002-0.001 0.554-0.379 0.882-0.656 1.177-0.59s0.491-0.23 0.262-0.493c-0.229-0.263-0.786-0.625-1.539-0.428-0.531 0.139-1.19 0.727-2.194 0.132-0.771-0.457-0.844-0.837-0.851-1.1 0.019-0.093 0.043-0.18 0.072-0.26 0.089-0.248 0.358-0.323 0.508-0.382 0.254 0.044 0.473 0.123 0.703 0.241 0.003-0.076 0.004-0.178-0-0.293 0.022-0.044 0.008-0.176-0.027-0.337-0.020-0.161-0.053-0.328-0.106-0.48 0-0 0-0 0-0s0.002-0.001 0.002-0.001c0.001-0.001 0.002-0.002 0.003-0.003s0-0.001 0.001-0.001c0.001-0.002 0.002-0.004 0.003-0.007 0.016-0.072 0.188-0.211 0.402-0.361 0.192-0.134 0.417-0.277 0.595-0.387 0.157-0.098 0.277-0.17 0.302-0.189 0.010-0.007 0.021-0.016 0.034-0.026 0.002-0.002 0.005-0.004 0.007-0.006s0.003-0.002 0.004-0.004c0.085-0.067 0.211-0.194 0.237-0.462 0-0.001 0-0.001 0-0.002 0.001-0.008 0.001-0.016 0.002-0.024 0-0.006 0.001-0.011 0.001-0.017 0-0.004 0-0.009 0.001-0.013 0-0.011 0.001-0.021 0.001-0.032 0-0.001 0-0.001 0-0.002 0-0.026-0-0.053-0.002-0.081-0.001-0.016-0.002-0.030-0.005-0.043-0-0.001-0-0.001-0-0.002s-0.001-0.003-0.001-0.004-0.001-0.005-0.002-0.007c-0-0-0-0-0-0.001-0.001-0.003-0.002-0.005-0.003-0.007-0-0-0-0-0-0-0.027-0.064-0.13-0.088-0.554-0.096-0-0-0.001-0-0.001-0v0c-0.173-0.003-0.399-0.003-0.695-0.002-0.52 0.002-0.807-0.508-0.898-0.705 0.126-0.695 0.489-1.19 1.085-1.525 0.011-0.006 0.009-0.012-0.004-0.015 0.117-0.071-1.41-0.002-2.112 0.891-0.623-0.155-1.166-0.144-1.635-0.035-0.090-0.003-0.202-0.014-0.335-0.041-0.311-0.282-0.757-0.803-0.781-1.425 0 0-0.001 0.001-0.004 0.003-0-0.006-0.001-0.012-0.001-0.018 0 0-0.949 0.729-0.807 2.717-0 0.032-0.001 0.062-0.002 0.092-0.257 0.348-0.384 0.641-0.394 0.706-0.228 0.463-0.458 1.16-0.646 2.218 0 0 0.131-0.417 0.395-0.889-0.194 0.594-0.346 1.518-0.257 2.904 0 0 0.024-0.307 0.107-0.75 0.065 0.86 0.352 1.921 1.076 3.169 1.39 2.396 3.526 3.605 5.887 3.791 0.419 0.035 0.845 0.035 1.272 0.003 0.039-0.003 0.079-0.006 0.118-0.009 0.484-0.034 0.971-0.107 1.457-0.224 6.643-1.606 5.921-9.628 5.921-9.628z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImChrome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.036 6.977l-2.29-3.966c1.466-1.835 3.722-3.012 6.254-3.012 2.929 0 5.489 1.574 6.883 3.922h-6.528c-0.117-0.010-0.236-0.016-0.356-0.016-1.904 0-3.509 1.307-3.964 3.071zM10.864 5.078h4.585c0.355 0.905 0.551 1.891 0.551 2.922 0 4.388-3.533 7.95-7.909 7.999l3.272-5.667c0.461-0.662 0.731-1.466 0.731-2.332 0-1.143-0.471-2.178-1.23-2.922zM5.094 8c0-1.603 1.304-2.906 2.906-2.906s2.906 1.304 2.906 2.906c0 1.602-1.304 2.906-2.906 2.906s-2.906-1.304-2.906-2.906zM9.097 11.944l-2.29 3.967c-3.852-0.576-6.806-3.899-6.806-7.911 0-1.425 0.373-2.763 1.026-3.922l3.266 5.657c0.654 1.392 2.070 2.359 3.707 2.359 0.38 0 0.747-0.052 1.097-0.149z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPaypal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.531 4.822c-0.747 3.316-3.053 5.066-6.688 5.066h-1.209l-0.841 5.338h-1.013l-0.053 0.344c-0.034 0.228 0.141 0.431 0.369 0.431h2.588c0.306 0 0.566-0.222 0.616-0.525l0.025-0.131 0.488-3.091 0.031-0.169c0.047-0.303 0.309-0.525 0.616-0.525h0.384c2.506 0 4.469-1.019 5.044-3.963 0.216-1.119 0.134-2.069-0.356-2.775z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.984 1.206c-0.741-0.844-2.081-1.206-3.794-1.206h-4.972c-0.35 0-0.65 0.253-0.703 0.6l-2.072 13.131c-0.041 0.259 0.159 0.494 0.422 0.494h3.072l0.772-4.891-0.025 0.153c0.053-0.347 0.35-0.6 0.7-0.6h1.459c2.866 0 5.109-1.162 5.766-4.531 0.019-0.1 0.037-0.197 0.050-0.291 0.194-1.244 0-2.094-0.675-2.859z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImYelp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.514 10.21c-0.27 0.272-0.042 0.768-0.042 0.768l2.033 3.394c0 0 0.334 0.447 0.623 0.447 0.29 0 0.577-0.239 0.577-0.239l1.607-2.297c0 0 0.162-0.29 0.166-0.544 0.006-0.361-0.538-0.46-0.538-0.46l-3.805-1.222c-0 0-0.373-0.099-0.621 0.152zM9.321 8.5c0.195 0.33 0.732 0.234 0.732 0.234l3.796-1.109c0 0 0.517-0.21 0.591-0.491 0.072-0.281-0.085-0.619-0.085-0.619l-1.814-2.137c0 0-0.157-0.27-0.483-0.297-0.36-0.031-0.581 0.405-0.581 0.405l-2.145 3.375c0 0-0.19 0.336-0.010 0.64zM7.527 7.184c0.447-0.11 0.518-0.759 0.518-0.759l-0.030-5.404c0 0-0.067-0.667-0.367-0.847-0.47-0.285-0.609-0.136-0.744-0.116l-3.151 1.171c0 0-0.309 0.102-0.469 0.36-0.23 0.365 0.233 0.899 0.233 0.899l3.276 4.465c0 0 0.323 0.334 0.735 0.233zM6.749 9.371c0.011-0.417-0.5-0.667-0.5-0.667l-3.387-1.711c0 0-0.502-0.207-0.746-0.063-0.187 0.11-0.352 0.31-0.368 0.486l-0.221 2.716c0 0-0.033 0.471 0.089 0.685 0.173 0.304 0.741 0.092 0.741 0.092l3.955-0.874c0.154-0.103 0.423-0.113 0.438-0.664zM7.732 10.837c-0.339-0.174-0.746 0.187-0.746 0.187l-2.648 2.915c0 0-0.33 0.446-0.246 0.72 0.079 0.257 0.21 0.384 0.396 0.474l2.659 0.839c0 0 0.322 0.067 0.567-0.004 0.347-0.1 0.283-0.643 0.283-0.643l0.060-3.947c-0 0-0.014-0.38-0.324-0.541z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFoursquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.306 1.408c-0.188-0.256-0.488-0.408-0.806-0.408h-9.5c-0.552 0-1 0.448-1 1v12c0 0.404 0.244 0.769 0.617 0.924 0.124 0.051 0.254 0.076 0.382 0.076 0.26 0 0.516-0.102 0.707-0.293l3.707-3.707h2.586c0.437 0 0.824-0.284 0.954-0.702l2.5-8c0.095-0.304 0.040-0.634-0.149-0.891zM10.515 5h-3.515c-0.552 0-1 0.448-1 1s0.448 1 1 1h2.89l-0.625 2h-2.265c-0.265 0-0.52 0.105-0.707 0.293l-2.293 2.293v-8.586h7.14l-0.625 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFlattr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.743 0c-3.802 0-5.743 2.19-5.743 6.279v0 8.579l3.725-3.729v-4.358c0-1.694 0.449-2.772 1.955-3.014v0c0.526-0.103 1.621-0.067 2.317-0.067v0 2.587c0 0.024 0.003 0.066 0.009 0.087v0c0.029 0.105 0.124 0.181 0.236 0.182v0c0.063 0 0.123-0.033 0.184-0.093v0l6.455-6.453-9.139-0.001zM12.275 4.871v4.358c0 1.694-0.449 2.772-1.955 3.014v0c-0.526 0.103-1.621 0.067-2.317 0.067v0-2.587c0-0.023-0.003-0.066-0.009-0.087v0c-0.029-0.105-0.124-0.182-0.236-0.182v0c-0.064-0-0.123 0.033-0.184 0.093v0l-6.455 6.453 9.139 0.001c3.802 0 5.743-2.19 5.743-6.279v0-8.579l-3.725 3.729z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImXing2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.431 3.159c-0.138 0-0.256 0.050-0.316 0.144-0.059 0.1-0.050 0.225 0.013 0.353l1.559 2.7c0.003 0.006 0.003 0.009 0 0.013l-2.45 4.331c-0.063 0.128-0.059 0.256 0 0.353 0.059 0.094 0.163 0.156 0.3 0.156h2.306c0.344 0 0.513-0.234 0.628-0.447 0 0 2.397-4.241 2.491-4.406-0.009-0.016-1.588-2.766-1.588-2.766-0.116-0.203-0.287-0.431-0.644-0.431h-2.3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.125 0c-0.344 0-0.494 0.216-0.619 0.441 0 0-4.972 8.816-5.134 9.106 0.009 0.016 3.278 6.016 3.278 6.016 0.116 0.203 0.291 0.441 0.644 0.441h2.306c0.137 0 0.247-0.053 0.306-0.147 0.063-0.1 0.059-0.228-0.006-0.356l-3.25-5.947c-0.003-0.006-0.003-0.009 0-0.016l5.109-9.034c0.063-0.128 0.066-0.256 0.006-0.356-0.059-0.094-0.169-0.147-0.306-0.147h-2.334z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImXing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.884 10.406h-1.728c-0.103 0-0.181-0.047-0.225-0.119-0.047-0.075-0.047-0.169 0-0.266l1.838-3.244c0.003-0.003 0.003-0.006 0-0.009l-1.169-2.025c-0.047-0.097-0.056-0.191-0.009-0.266 0.044-0.072 0.131-0.109 0.237-0.109h1.731c0.266 0 0.397 0.172 0.481 0.325 0 0 1.181 2.063 1.191 2.075-0.069 0.125-1.869 3.303-1.869 3.303-0.094 0.162-0.219 0.334-0.478 0.334zM13.069 2.378l-3.831 6.775c-0.003 0.003-0.003 0.009 0 0.012l2.441 4.456c0.047 0.097 0.050 0.194 0.003 0.269-0.044 0.072-0.125 0.109-0.231 0.109h-1.728c-0.266 0-0.397-0.175-0.484-0.328 0 0-2.453-4.5-2.459-4.512 0.122-0.216 3.85-6.828 3.85-6.828 0.094-0.166 0.206-0.328 0.463-0.328h1.753c0.103 0 0.188 0.041 0.231 0.109 0.044 0.072 0.044 0.169-0.006 0.266z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPinterest2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.412 0-8 3.587-8 8s3.587 8 8 8 8-3.588 8-8-3.588-8-8-8zM8 14.931c-0.716 0-1.403-0.109-2.053-0.309 0.281-0.459 0.706-1.216 0.862-1.816 0.084-0.325 0.431-1.647 0.431-1.647 0.225 0.431 0.888 0.797 1.587 0.797 2.091 0 3.597-1.922 3.597-4.313 0-2.291-1.869-4.003-4.272-4.003-2.991 0-4.578 2.009-4.578 4.194 0 1.016 0.541 2.281 1.406 2.684 0.131 0.063 0.2 0.034 0.231-0.094 0.022-0.097 0.141-0.566 0.194-0.787 0.016-0.069 0.009-0.131-0.047-0.2-0.287-0.347-0.516-0.988-0.516-1.581 0-1.528 1.156-3.009 3.128-3.009 1.703 0 2.894 1.159 2.894 2.819 0 1.875-0.947 3.175-2.178 3.175-0.681 0-1.191-0.563-1.025-1.253 0.197-0.825 0.575-1.713 0.575-2.306 0-0.531-0.284-0.975-0.878-0.975-0.697 0-1.253 0.719-1.253 1.684 0 0.612 0.206 1.028 0.206 1.028s-0.688 2.903-0.813 3.444c-0.141 0.6-0.084 1.441-0.025 1.988-2.578-1.006-4.406-3.512-4.406-6.45 0-3.828 3.103-6.931 6.931-6.931s6.931 3.103 6.931 6.931c0 3.828-3.103 6.931-6.931 6.931z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPinterest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.069c-3.828 0-6.931 3.103-6.931 6.931 0 2.938 1.828 5.444 4.406 6.453-0.059-0.547-0.116-1.391 0.025-1.988 0.125-0.541 0.813-3.444 0.813-3.444s-0.206-0.416-0.206-1.028c0-0.963 0.559-1.684 1.253-1.684 0.591 0 0.878 0.444 0.878 0.975 0 0.594-0.378 1.484-0.575 2.306-0.166 0.691 0.344 1.253 1.025 1.253 1.231 0 2.178-1.3 2.178-3.175 0-1.659-1.194-2.819-2.894-2.819-1.972 0-3.128 1.478-3.128 3.009 0 0.597 0.228 1.234 0.516 1.581 0.056 0.069 0.066 0.128 0.047 0.2-0.053 0.219-0.169 0.691-0.194 0.787-0.031 0.128-0.1 0.153-0.231 0.094-0.866-0.403-1.406-1.669-1.406-2.684 0-2.188 1.587-4.194 4.578-4.194 2.403 0 4.272 1.712 4.272 4.003 0 2.388-1.506 4.313-3.597 4.313-0.703 0-1.362-0.366-1.588-0.797 0 0-0.347 1.322-0.431 1.647-0.156 0.603-0.578 1.356-0.862 1.816 0.65 0.2 1.337 0.309 2.053 0.309 3.828 0 6.931-3.103 6.931-6.931 0-3.831-3.103-6.934-6.931-6.934z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStackoverflow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10v6h-16v-6h2v4h12v-4zM3 11h10v2h-10zM3.237 8.835l0.433-1.953 9.763 2.164-0.433 1.953zM4.37 4.821l0.845-1.813 9.063 4.226-0.845 1.813zM15.496 5.648l-1.218 1.587-7.934-6.088 0.88-1.147h0.91z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStumbleupon2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.313 0h-10.625c-1.478 0-2.688 1.209-2.688 2.688v10.625c0 1.478 1.209 2.688 2.688 2.688h10.625c1.478 0 2.688-1.209 2.688-2.688v-10.625c0-1.478-1.209-2.688-2.688-2.688zM8 5c-0.551 0-1 0.449-1 1v4c0 1.654-1.346 3-3 3s-3-1.346-3-3v-2h2v2c0 0.551 0.449 1 1 1s1-0.449 1-1v-4c0-1.654 1.346-3 3-3s3 1.346 3 2.781v0.969l-1.281 0.375-0.719-0.375v-0.969c0-0.333-0.449-0.781-1-0.781zM15 10c0 1.654-1.346 3-3 3s-3-1.346-3-3.219v-1.938l0.719 0.375 1.281-0.375v1.938c0 0.77 0.449 1.219 1 1.219s1-0.449 1-1v-2h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStumbleupon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5c-0.55 0-1 0.45-1 1v4c0 1.653-1.347 3-3 3s-3-1.347-3-3v-2h2v2c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-1.653 1.347-3 3-3s3 1.347 3 2.781v0.969l-1.281 0.375-0.719-0.375v-0.969c0-0.331-0.45-0.781-1-0.781z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10c0 1.653-1.347 3-3 3s-3-1.347-3-3.219v-1.938l0.719 0.375 1.281-0.375v1.938c0 0.769 0.45 1.219 1 1.219s1-0.45 1-1v-2h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDelicious(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h16v-16h-16zM8 15v-7h-7v-7h7v7h7v7h-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLastfm2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11.666 11.887c-2.775 0-3.737-1.25-4.25-2.806l-0.513-1.603c-0.384-1.172-0.834-2.084-2.244-2.084-0.978 0-1.972 0.706-1.972 2.678 0 1.541 0.784 2.503 1.894 2.503 1.25 0 2.084-0.931 2.084-0.931l0.513 1.394c0 0-0.866 0.85-2.678 0.85-2.25 0-3.5-1.313-3.5-3.75 0-2.534 1.25-4.025 3.609-4.025 2.134 0 3.206 0.769 3.881 2.853l0.528 1.603c0.384 1.172 1.059 2.022 2.678 2.022 1.091 0 1.669-0.241 1.669-0.834 0-0.466-0.272-0.803-1.091-0.994l-1.091-0.256c-1.331-0.322-1.859-1.009-1.859-2.1 0-1.747 1.412-2.294 2.853-2.294 1.634 0 2.631 0.594 2.759 2.038l-1.603 0.194c-0.066-0.691-0.481-0.978-1.25-0.978-0.706 0-1.137 0.322-1.137 0.866 0 0.481 0.209 0.769 0.912 0.931l1.025 0.225c1.378 0.322 2.116 0.994 2.116 2.294 0 1.597-1.347 2.206-3.334 2.206z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLastfm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.056 11.972l-0.588-1.594c0 0-0.953 1.063-2.381 1.063-1.266 0-2.163-1.1-2.163-2.859 0-2.253 1.137-3.059 2.253-3.059 1.612 0 2.125 1.044 2.566 2.381l0.588 1.831c0.588 1.778 1.688 3.206 4.856 3.206 2.272 0 3.813-0.697 3.813-2.528 0-1.484-0.844-2.253-2.419-2.622l-1.172-0.256c-0.806-0.184-1.044-0.513-1.044-1.063 0-0.622 0.494-0.991 1.3-0.991 0.881 0 1.356 0.331 1.428 1.119l1.831-0.219c-0.147-1.65-1.284-2.328-3.153-2.328-1.65 0-3.262 0.622-3.262 2.622 0 1.247 0.606 2.034 2.125 2.4l1.247 0.294c0.934 0.219 1.247 0.606 1.247 1.137 0 0.678-0.659 0.953-1.906 0.953-1.85 0-2.622-0.972-3.059-2.309l-0.606-1.831c-0.766-2.384-1.994-3.263-4.431-3.263-2.694 0-4.125 1.703-4.125 4.6 0 2.784 1.428 4.287 3.997 4.287 2.069 0 3.059-0.972 3.059-0.972v0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLinkedin2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h2.767v1.418h0.040c0.385-0.691 1.327-1.418 2.732-1.418 2.921 0 3.461 1.818 3.461 4.183v4.817h-2.885v-4.27c0-1.018-0.021-2.329-1.5-2.329-1.502 0-1.732 1.109-1.732 2.255v4.344h-2.883v-9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6h3v9h-3v-9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLinkedin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 13h-2v-7h2v7zM5 5c-0.553 0-1-0.447-1-1s0.447-1 1-1c0.553 0 1 0.447 1 1s-0.447 1-1 1zM13 13h-2v-4c0-0.553-0.447-1-1-1s-1 0.447-1 1v4h-2v-7h2v1.241c0.412-0.566 1.044-1.241 1.75-1.241 1.244 0 2.25 1.119 2.25 2.5v4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWikipedia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.106 3.65c0 0.050-0.016 0.097-0.047 0.141-0.031 0.041-0.066 0.063-0.106 0.063-0.313 0.031-0.569 0.131-0.766 0.3-0.2 0.169-0.403 0.497-0.613 0.975l-3.225 7.272c-0.022 0.069-0.081 0.1-0.178 0.1-0.075 0-0.134-0.034-0.178-0.1l-1.809-3.781-2.081 3.781c-0.044 0.069-0.1 0.1-0.178 0.1-0.094 0-0.153-0.034-0.184-0.1l-3.166-7.269c-0.197-0.45-0.406-0.766-0.625-0.944s-0.525-0.291-0.916-0.331c-0.034 0-0.066-0.019-0.094-0.053-0.031-0.034-0.044-0.075-0.044-0.122 0-0.119 0.034-0.178 0.1-0.178 0.281 0 0.578 0.013 0.888 0.038 0.288 0.025 0.556 0.038 0.809 0.038 0.256 0 0.563-0.013 0.913-0.038 0.366-0.025 0.691-0.038 0.975-0.038 0.069 0 0.1 0.059 0.1 0.178s-0.022 0.175-0.063 0.175c-0.281 0.022-0.506 0.094-0.669 0.216s-0.244 0.281-0.244 0.481c0 0.1 0.034 0.228 0.1 0.378l2.616 5.912 1.487-2.806-1.384-2.903c-0.25-0.519-0.453-0.853-0.612-1.003s-0.403-0.241-0.728-0.275c-0.031 0-0.056-0.019-0.084-0.053s-0.041-0.075-0.041-0.122c0-0.119 0.028-0.178 0.088-0.178 0.281 0 0.541 0.013 0.778 0.038 0.228 0.025 0.469 0.038 0.728 0.038 0.253 0 0.519-0.013 0.803-0.038 0.291-0.025 0.578-0.038 0.859-0.038 0.069 0 0.1 0.059 0.1 0.178s-0.019 0.175-0.063 0.175c-0.566 0.038-0.847 0.2-0.847 0.481 0 0.125 0.066 0.322 0.197 0.588l0.916 1.859 0.912-1.7c0.125-0.241 0.191-0.444 0.191-0.606 0-0.388-0.281-0.594-0.847-0.619-0.050 0-0.075-0.059-0.075-0.175 0-0.044 0.012-0.081 0.037-0.119s0.050-0.056 0.075-0.056c0.203 0 0.45 0.013 0.747 0.038 0.281 0.025 0.516 0.038 0.697 0.038 0.131 0 0.322-0.013 0.575-0.031 0.319-0.028 0.588-0.044 0.803-0.044 0.050 0 0.075 0.050 0.075 0.15 0 0.134-0.047 0.203-0.137 0.203-0.328 0.034-0.594 0.125-0.794 0.272s-0.45 0.481-0.75 1.006l-1.222 2.237 1.644 3.35 2.428-5.647c0.084-0.206 0.125-0.397 0.125-0.569 0-0.412-0.281-0.631-0.847-0.659-0.050 0-0.075-0.059-0.075-0.175 0-0.119 0.037-0.178 0.113-0.178 0.206 0 0.45 0.013 0.734 0.038 0.262 0.025 0.481 0.038 0.656 0.038 0.188 0 0.4-0.013 0.644-0.038 0.253-0.025 0.481-0.038 0.684-0.038 0.063 0 0.094 0.050 0.094 0.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHackernews(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h16v-16h-16zM8.5 9.125v3.375h-1v-3.375l-2.734-5.125h1.134l2.1 3.938 2.1-3.938h1.134l-2.734 5.125z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImReddit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 10c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10.049 12.137c0.258-0.203 0.631-0.159 0.834 0.099s0.159 0.631-0.099 0.834c-0.717 0.565-1.81 0.93-2.783 0.93s-2.066-0.365-2.784-0.93c-0.258-0.203-0.302-0.576-0.099-0.834s0.576-0.302 0.834-0.099c0.413 0.325 1.23 0.675 2.049 0.675s1.636-0.35 2.049-0.675zM16 8c0-1.105-0.895-2-2-2-0.752 0-1.406 0.415-1.748 1.028-1.028-0.562-2.28-0.926-3.645-1.010l1.193-2.68 2.284 0.659c0.206 0.583 0.761 1.002 1.415 1.002 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.571 0-1.068 0.319-1.321 0.789l-2.545-0.735c-0.285-0.082-0.587 0.058-0.707 0.329l-1.621 3.641c-1.33 0.094-2.551 0.453-3.557 1.004-0.342-0.613-0.996-1.028-1.748-1.028-1.105 0-2 0.895-2 2 0 0.817 0.491 1.52 1.193 1.83-0.126 0.375-0.193 0.767-0.193 1.17 0 2.761 3.134 5 7 5s7-2.239 7-5c0-0.403-0.067-0.795-0.193-1.17 0.703-0.31 1.193-1.013 1.193-1.83zM13.5 2.938c0.311 0 0.563 0.252 0.563 0.563s-0.252 0.563-0.563 0.563-0.563-0.252-0.563-0.563 0.252-0.563 0.563-0.563zM1 8c0-0.551 0.449-1 1-1 0.399 0 0.743 0.234 0.904 0.573-0.523 0.396-0.956 0.854-1.276 1.355-0.368-0.148-0.628-0.508-0.628-0.928zM8 14.813c-3.21 0-5.813-1.707-5.813-3.813s2.602-3.813 5.813-3.813c3.21 0 5.813 1.707 5.813 3.813s-2.602 3.813-5.813 3.813zM14.372 8.928c-0.32-0.502-0.753-0.959-1.276-1.355 0.161-0.338 0.505-0.573 0.904-0.573 0.551 0 1 0.449 1 1 0 0.42-0.26 0.78-0.628 0.928z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSkype(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.65 0.584c-0.025-0.016-0.053-0.028-0.078-0.041-0.028 0.006-0.053 0.009-0.081 0.016l0.159 0.025z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0.575 6.578c-0.006 0.028-0.009 0.056-0.012 0.081 0.016 0.025 0.025 0.050 0.041 0.075l-0.028-0.156z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.419 9.416c0.006-0.028 0.009-0.056 0.016-0.084-0.016-0.025-0.025-0.050-0.041-0.075l0.025 0.159z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.25 15.359c0.025 0.016 0.053 0.028 0.078 0.041 0.028-0.006 0.056-0.009 0.084-0.012l-0.162-0.028z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.434 9.331c-0.006 0.028-0.009 0.056-0.016 0.084l-0.028-0.162c0.016 0.028 0.028 0.053 0.044 0.078 0.081-0.45 0.125-0.909 0.125-1.369 0-1.019-0.2-2.009-0.594-2.941-0.381-0.9-0.925-1.709-1.619-2.403s-1.503-1.238-2.4-1.619c-0.931-0.394-1.922-0.594-2.941-0.594-0.481 0-0.963 0.044-1.431 0.134 0 0-0.003 0-0.003 0 0.025 0.012 0.053 0.025 0.078 0.041l-0.159-0.025c0.028-0.006 0.053-0.009 0.081-0.016-0.644-0.341-1.366-0.525-2.097-0.525-1.194 0-2.319 0.466-3.163 1.309s-1.309 1.969-1.309 3.163c0 0.759 0.197 1.509 0.563 2.169 0.006-0.028 0.009-0.056 0.012-0.081l0.028 0.159c-0.016-0.025-0.028-0.050-0.041-0.075-0.075 0.428-0.112 0.866-0.112 1.303 0 1.019 0.2 2.009 0.594 2.941 0.381 0.9 0.925 1.706 1.619 2.4s1.503 1.238 2.403 1.619c0.931 0.394 1.922 0.594 2.941 0.594 0.444 0 0.887-0.041 1.322-0.119-0.025-0.016-0.050-0.028-0.078-0.041l0.162 0.028c-0.028 0.006-0.056 0.009-0.084 0.012 0.669 0.378 1.428 0.581 2.2 0.581 1.194 0 2.319-0.466 3.162-1.309s1.309-1.969 1.309-3.162c-0.003-0.759-0.2-1.509-0.569-2.175zM8.034 12.591c-2.684 0-3.884-1.319-3.884-2.309 0-0.506 0.375-0.863 0.891-0.863 1.15 0 0.85 1.65 2.994 1.65 1.097 0 1.703-0.597 1.703-1.206 0-0.366-0.181-0.772-0.903-0.95l-2.388-0.597c-1.922-0.481-2.272-1.522-2.272-2.5 0-2.028 1.909-2.791 3.703-2.791 1.653 0 3.6 0.913 3.6 2.131 0 0.522-0.453 0.825-0.969 0.825-0.981 0-0.8-1.356-2.775-1.356-0.981 0-1.522 0.444-1.522 1.078s0.775 0.838 1.447 0.991l1.769 0.394c1.934 0.431 2.425 1.563 2.425 2.625 0 1.647-1.266 2.878-3.819 2.878z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSoundcloud2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM2.75 11h-0.5l-0.25-1.5 0.25-1.5h0.5l0.25 1.5-0.25 1.5zM4.75 11h-0.5l-0.25-2 0.25-2h0.5l0.25 2-0.25 2zM6.75 11h-0.5l-0.25-3 0.25-3h0.5l0.25 3-0.25 3zM12.894 11c-0.031 0-4.706-0.003-4.709-0.003-0.1-0.009-0.181-0.097-0.184-0.2v-5.394c0-0.1 0.034-0.15 0.162-0.2 0.331-0.128 0.703-0.203 1.088-0.203 1.566 0 2.85 1.2 2.987 2.734 0.203-0.084 0.425-0.131 0.656-0.131 0.938 0 1.7 0.762 1.7 1.7s-0.762 1.697-1.7 1.697z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSoundcloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.937 8.034c-0.283 0-0.552 0.055-0.798 0.154-0.164-1.787-1.723-3.188-3.625-3.188-0.465 0-0.917 0.088-1.317 0.237-0.156 0.058-0.197 0.117-0.197 0.233v6.292c0 0.121 0.098 0.222 0.221 0.234 0.005 0.001 5.68 0.003 5.717 0.003 1.139 0 2.062-0.888 2.062-1.983s-0.924-1.983-2.063-1.983zM6.25 12h0.5l0.25-3.503-0.25-3.497h-0.5l-0.25 3.497zM4.75 12h-0.5l-0.25-2.543 0.25-2.457h0.5l0.25 2.5zM2.25 12h0.5l0.25-2-0.25-2h-0.5l-0.25 2zM0.25 11h0.5l0.25-1-0.25-1h-0.5l-0.25 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWindows8(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.005 8l-0.005-4.876 6-0.815v5.691zM7 2.164l7.998-1.164v7h-7.998zM15 9l-0.002 7-7.998-1.125v-5.875zM6 14.747l-5.995-0.822-0-4.926h5.995z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWindows(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.441 7.999c-0.745-0.383-1.47-0.577-2.154-0.577-0.093 0-0.187 0.003-0.28 0.011-0.873 0.072-1.671 0.303-2.184 0.482-0.136 0.050-0.276 0.103-0.419 0.161l-1.403 4.866c0.964-0.357 1.817-0.53 2.598-0.53 1.263 0 2.18 0.472 2.937 0.958 0.359-1.217 1.219-4.158 1.476-5.036-0.187-0.114-0.376-0.228-0.571-0.333zM8.255 9.235l-1.413 4.909c0.419 0.24 1.83 1.001 2.91 1.001 0.872 0 1.848-0.223 2.982-0.684l1.349-4.718c-0.916 0.296-1.795 0.446-2.617 0.446-1.499 0-2.549-0.486-3.211-0.952zM4.575 5.762c1.205 0.012 2.096 0.472 2.835 0.945l1.449-4.958c-0.305-0.175-1.106-0.611-1.685-0.759-0.381-0.089-0.782-0.135-1.206-0.135-0.809 0.015-1.694 0.218-2.701 0.622l-1.382 4.853c1.013-0.382 1.885-0.568 2.689-0.568 0.001 0 0.002 0 0.002 0zM16 3.096c-0.919 0.357-1.816 0.539-2.672 0.539-1.433 0-2.489-0.497-3.173-0.974l-1.437 4.972c0.965 0.62 2.005 0.936 3.096 0.936 0.89 0 1.812-0.214 2.742-0.636l-0.003-0.035 0.058-0.014 1.39-4.788z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAndroid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-0.55-0.45-1-1-1zM2 6c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-0.55-0.45-1-1-1zM3.5 11.5c0 0.828 0.672 1.5 1.5 1.5v0 2c0 0.55 0.45 1 1 1s1-0.45 1-1v-2h2v2c0 0.55 0.45 1 1 1s1-0.45 1-1v-2c0.828 0 1.5-0.672 1.5-1.5v-5.5h-9v5.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.472 5c-0.152-1.373-0.922-2.559-2.025-3.276l0.5-1.001c0.123-0.247 0.023-0.547-0.224-0.671s-0.547-0.023-0.671 0.224l-0.502 1.004-0.13-0.052c-0.446-0.148-0.924-0.229-1.42-0.229s-0.974 0.081-1.42 0.229l-0.13 0.052-0.502-1.004c-0.123-0.247-0.424-0.347-0.671-0.224s-0.347 0.424-0.224 0.671l0.5 1.001c-1.103 0.716-1.873 1.903-2.025 3.276v0.5h8.972v-0.5h-0.028zM6.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.223-0.499 0.499-0.5c0 0 0.001 0 0.001 0s0.001-0 0.001-0c0.276 0.001 0.499 0.224 0.499 0.5s-0.224 0.5-0.5 0.5zM9.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.223-0.499 0.499-0.5c0 0 0.001 0 0.001 0s0.001-0 0.002-0c0.276 0.001 0.499 0.224 0.499 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFinder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.894 12.16c-0-0.001-0-0.001-0-0.002 0 0.001 0 0.001 0 0.002z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.916 12.727c-0-0.004-0-0.007-0.001-0.011 0 0.004 0 0.007 0.001 0.011z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.903 12.442c-0-0.003-0-0.006-0-0.008 0 0.003 0 0.006 0 0.008z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0h-14c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h7.716c0.001 0 0.001 0 0.002 0s0.001-0 0.002-0h6.28c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM3 3.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1zM15 15h-5.86c-0.105-0.658-0.17-1.336-0.209-1.994 0 0.002 0 0.004 0 0.005-0.308 0.034-0.618 0.051-0.931 0.051-2.088 0-4.1-0.76-5.664-2.141-0.233-0.206-0.255-0.561-0.050-0.794s0.561-0.255 0.794-0.050c1.358 1.199 3.105 1.859 4.919 1.859 0.298 0 0.595-0.018 0.888-0.053-0.034-1.847 0.107-3.311 0.11-3.334 0.014-0.141-0.032-0.28-0.127-0.385s-0.229-0.164-0.371-0.164h-1.487c0.022-0.541 0.079-1.466 0.234-2.503 0.295-1.981 0.812-3.528 1.502-4.497h6.251v14z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 5c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.445 13.050c-0.057 0.003-0.114 0.005-0.171 0.007 0.057-0.002 0.114-0.004 0.171-0.007z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13.063c0.073 0 0.146-0.001 0.22-0.003-0.073 0.002-0.146 0.003-0.22 0.003z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.423 11.925c0.012-0.001 0.024-0.001 0.037-0.002-0.012 0.001-0.024 0.001-0.037 0.002z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.204 11.934c0.017-0 0.034-0.001 0.050-0.002-0.017 0.001-0.034 0.001-0.050 0.002z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.713 10.128c-0.206-0.233-0.561-0.255-0.794-0.050-1.135 1.002-2.542 1.627-4.032 1.806 0.007 0.364 0.020 0.742 0.043 1.127 1.749-0.191 3.403-0.916 4.733-2.090 0.233-0.206 0.255-0.561 0.050-0.794z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.93 13.012c-0.072 0.008-0.144 0.015-0.216 0.021 0.072-0.006 0.144-0.013 0.216-0.021z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.68 13.035c-0.061 0.005-0.122 0.009-0.183 0.013 0.061-0.004 0.122-0.008 0.183-0.013z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAppleinc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.367 8.501c-0.020-2.026 1.652-2.998 1.727-3.046-0.94-1.375-2.404-1.564-2.926-1.585-1.246-0.126-2.431 0.734-3.064 0.734-0.631 0-1.607-0.715-2.64-0.696-1.358 0.020-2.61 0.79-3.31 2.006-1.411 2.448-0.361 6.076 1.014 8.061 0.672 0.972 1.473 2.064 2.525 2.025 1.013-0.040 1.396-0.656 2.621-0.656s1.569 0.656 2.641 0.635c1.090-0.020 1.781-0.991 2.448-1.966 0.772-1.128 1.089-2.219 1.108-2.275-0.024-0.011-2.126-0.816-2.147-3.236zM10.353 2.555c0.558-0.677 0.935-1.617 0.832-2.555-0.804 0.033-1.779 0.536-2.356 1.212-0.518 0.6-0.971 1.557-0.85 2.476 0.898 0.070 1.815-0.456 2.373-1.132z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTux(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.87 11.514c-1.28 0.596-2.471 0.589-3.271 0.532-0.954-0.069-1.721-0.33-2.058-0.558-0.208-0.141-0.49-0.086-0.631 0.122s-0.086 0.49 0.122 0.631c0.542 0.367 1.501 0.64 2.503 0.712 0.17 0.012 0.356 0.020 0.557 0.020 0.872 0 1.979-0.083 3.163-0.634 0.228-0.106 0.326-0.376 0.22-0.604s-0.376-0.326-0.604-0.22zM13.921 10.841c0.044-3.948 0.449-11.409-7.109-10.806-7.463 0.601-5.484 8.484-5.595 11.124-0.099 1.397-0.562 3.104-1.217 4.841h2.017c0.207-0.736 0.36-1.464 0.425-2.159 0.122 0.085 0.252 0.167 0.391 0.245 0.226 0.133 0.42 0.31 0.626 0.497 0.48 0.438 1.025 0.934 2.089 0.996 0.071 0.004 0.143 0.006 0.214 0.006 1.077 0 1.813-0.471 2.404-0.85 0.283-0.181 0.528-0.338 0.759-0.413 0.655-0.205 1.227-0.536 1.655-0.957 0.067-0.066 0.129-0.133 0.187-0.202 0.238 0.873 0.564 1.856 0.926 2.836h4.307c-1.034-1.597-2.101-3.162-2.079-5.159zM1.939 8.693c0-0 0-0-0-0.001-0.074-1.288 0.542-2.372 1.377-2.421s1.571 0.957 1.645 2.245c0 0 0 0 0 0.001 0.004 0.069 0.006 0.138 0.006 0.206-0.264 0.066-0.503 0.163-0.717 0.275-0.001-0.010-0.001-0.019-0.002-0.029 0-0 0-0 0-0-0.071-0.731-0.462-1.284-0.873-1.234s-0.686 0.684-0.614 1.415c0 0 0 0 0 0 0.031 0.319 0.123 0.604 0.251 0.819-0.032 0.025-0.122 0.091-0.225 0.166-0.078 0.057-0.172 0.126-0.286 0.21-0.311-0.408-0.524-0.993-0.562-1.655zM10.395 11.878c-0.030 0.681-0.92 1.322-1.743 1.579l-0.005 0.002c-0.342 0.111-0.647 0.306-0.97 0.513-0.543 0.347-1.104 0.706-1.914 0.706-0.053 0-0.108-0.002-0.161-0.005-0.742-0.043-1.090-0.36-1.529-0.761-0.232-0.211-0.472-0.43-0.781-0.611l-0.007-0.004c-0.667-0.377-1.081-0.845-1.108-1.253-0.013-0.203 0.077-0.378 0.268-0.522 0.416-0.312 0.695-0.516 0.879-0.651 0.205-0.15 0.267-0.195 0.313-0.239 0.033-0.031 0.068-0.065 0.106-0.103 0.382-0.371 1.021-0.993 2.002-0.993 0.6 0 1.264 0.231 1.971 0.686 0.333 0.217 0.623 0.317 0.99 0.444 0.252 0.087 0.539 0.186 0.922 0.35l0.006 0.003c0.357 0.147 0.78 0.415 0.76 0.858zM10.198 10.278c-0.069-0.035-0.14-0.068-0.215-0.098-0.345-0.148-0.622-0.248-0.852-0.328 0.127-0.248 0.206-0.558 0.213-0.894 0-0 0-0 0-0 0.018-0.818-0.395-1.483-0.922-1.484s-0.968 0.661-0.986 1.479c0 0 0 0 0 0-0.001 0.027-0.001 0.053-0 0.080-0.324-0.149-0.643-0.258-0.956-0.324-0.001-0.031-0.003-0.061-0.004-0.092 0-0 0-0.001 0-0.001-0.030-1.491 0.884-2.725 2.043-2.756s2.122 1.152 2.153 2.642c0 0 0 0.001 0 0.001 0.014 0.674-0.167 1.295-0.475 1.776z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImYahoo2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.019 1.087c-2.828 0-5.5-0.372-8.019-1.087 0 5.653 0 14.581 0 16 2.522-0.716 5.194-1.088 8.019-1.088 2.794 0 5.459 0.363 7.981 1.088 0-5.444 0-10.153 0-16-2.522 0.725-5.184 1.087-7.981 1.087zM12.45 2.453l-0.097 0.153c-0.091 0.144-0.172 0.266-0.284 0.438-0.15 0.225-0.431 0.672-0.769 1.247-0.094 0.159-0.209 0.35-0.328 0.556-0.228 0.384-0.484 0.819-0.688 1.162-0.084 0.147-0.169 0.297-0.256 0.447-0.225 0.391-0.456 0.794-0.678 1.181-0.228 0.403-0.453 0.8-0.678 1.194v0.397c0 0.55 0.012 1.15 0.031 1.684 0.009 0.244 0.019 0.678 0.031 1.137 0.012 0.547 0.025 1.113 0.041 1.4l0.003 0.088v0.009l-0.094-0.025c-0.037-0.009-0.072-0.019-0.109-0.028-0.113-0.025-0.234-0.044-0.353-0.056-0.072-0.006-0.147-0.009-0.222-0.009 0 0 0 0 0 0s0 0 0 0c-0.075 0-0.15 0.003-0.222 0.009-0.119 0.012-0.241 0.031-0.353 0.056-0.037 0.009-0.075 0.019-0.109 0.028l-0.094 0.025v-0.009l0.003-0.088c0.013-0.284 0.028-0.853 0.041-1.4 0.009-0.459 0.022-0.894 0.031-1.137 0.022-0.537 0.031-1.134 0.031-1.684v-0.397c-0.225-0.397-0.45-0.791-0.678-1.194-0.222-0.391-0.453-0.791-0.675-1.181-0.088-0.15-0.172-0.3-0.256-0.447-0.2-0.347-0.459-0.781-0.688-1.162-0.122-0.203-0.237-0.397-0.328-0.556-0.338-0.575-0.619-1.019-0.769-1.247-0.112-0.172-0.194-0.294-0.284-0.438l-0.097-0.153 0.175 0.050c0.222 0.063 0.45 0.094 0.694 0.094s0.478-0.031 0.697-0.094l0.053-0.016 0.028 0.047c0.431 0.778 1.591 2.684 2.284 3.825 0.237 0.394 0.428 0.703 0.522 0.862 0 0 0 0 0-0.003 0 0 0 0 0 0.003 0.094-0.156 0.284-0.469 0.522-0.862 0.694-1.138 1.853-3.044 2.284-3.825l0.028-0.047 0.053 0.016c0.219 0.063 0.453 0.094 0.697 0.094s0.472-0.031 0.694-0.094l0.166-0.050z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImYahoo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.878 9.203v0c1.759-3.088 4.666-8.125 5.463-9.203-0.35 0.234-0.887 0.353-1.381 0.466l-0.747-0.466c-0.6 1.119-2.813 4.734-4.222 7.050-1.428-2.366-3.119-5.097-4.222-7.050-0.875 0.188-1.237 0.197-2.109 0v0 0c0 0 0 0 0 0v0c1.731 2.606 4.503 7.572 5.447 9.203v0l-0.128 6.797 1.013-0.466v-0.012l1.012 0.478-0.125-6.797z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTumblr2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11.434 12.884c-0.472 0.222-0.9 0.378-1.281 0.469-0.381 0.088-0.797 0.134-1.241 0.134-0.506 0-0.803-0.063-1.191-0.191s-0.719-0.309-0.994-0.544c-0.275-0.238-0.463-0.488-0.569-0.753s-0.159-0.65-0.159-1.156v-3.872h-1.5v-1.563c0.434-0.141 0.938-0.344 1.244-0.606 0.309-0.263 0.559-0.578 0.744-0.947 0.188-0.369 0.316-0.837 0.388-1.406h1.569v2.55h2.556v1.972h-2.553v2.831c0 0.641-0.009 1.009 0.059 1.191s0.238 0.369 0.422 0.475c0.244 0.147 0.525 0.219 0.838 0.219 0.559 0 1.116-0.181 1.669-0.544v1.741z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTumblr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.001 7l-0 3.659c0 0.928-0.012 1.463 0.086 1.727 0.098 0.262 0.342 0.534 0.609 0.691 0.354 0.212 0.758 0.318 1.214 0.318 0.81 0 1.289-0.107 2.090-0.633v2.405c-0.683 0.321-1.279 0.509-1.833 0.639-0.555 0.129-1.154 0.194-1.798 0.194-0.732 0-1.163-0.092-1.725-0.276-0.562-0.185-1.042-0.45-1.438-0.79-0.398-0.343-0.672-0.706-0.826-1.091s-0.23-0.944-0.23-1.676v-5.611h-2.147v-2.266c0.628-0.204 1.331-0.497 1.778-0.877 0.449-0.382 0.809-0.839 1.080-1.374 0.272-0.534 0.459-1.214 0.561-2.039h2.579l-0 4h3.999v3h-3.999z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBlogger2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM14 10.125c0 2.141-1.741 3.875-3.897 3.875h-4.2c-2.156 0-3.903-1.734-3.903-3.875v-4.25c0-2.141 1.747-3.875 3.903-3.875h1.966c2.156 0 3.881 1.609 3.881 3.75 0.028 0.4 0.391 0.75 0.8 0.75h0.672c0.431 0 0.775 0.453 0.775 0.881v2.744z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10c0 0.55-0.45 1-1 1h-4c-0.55 0-1-0.45-1-1v0c0-0.55 0.45-1 1-1h4c0.55 0 1 0.45 1 1v0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v0c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBlogger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.966 6h-0.897c-0.549 0-1.031-0.465-1.069-1v0c0-2.854-2.301-5-5.175-5h-2.622c-2.872 0-5.201 2.313-5.203 5.167v5.669c0 2.854 2.331 5.165 5.203 5.165h5.6c2.874 0 5.197-2.311 5.197-5.165v-3.662c0-0.57-0.46-1.173-1.034-1.173zM5 4h3c0.55 0 1 0.45 1 1s-0.45 1-1 1h-3c-0.55 0-1-0.45-1-1s0.45-1 1-1zM11 12h-6c-0.55 0-1-0.45-1-1s0.45-1 1-1h6c0.55 0 1 0.45 1 1s-0.45 1-1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEllo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12.885 9.212c-0.575 2.23-2.584 3.788-4.885 3.788s-4.31-1.558-4.885-3.788c-0.097-0.377 0.131-0.764 0.508-0.861 0.058-0.015 0.118-0.023 0.177-0.023 0.322 0 0.604 0.218 0.684 0.531 0.414 1.605 1.86 2.727 3.516 2.727s3.102-1.121 3.516-2.727c0.081-0.313 0.362-0.531 0.684-0.531 0.060 0 0.12 0.008 0.178 0.023 0.183 0.047 0.336 0.163 0.432 0.326s0.123 0.353 0.075 0.536z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImJoomla(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.156 4.323c0.513-0.513 1.344-0.513 1.856-0l0.122 0.123 1.58-1.581-0.123-0.123c-0.9-0.902-2.164-1.217-3.319-0.946-0.166-1.018-1.048-1.796-2.112-1.796-1.182 0-2.14 0.96-2.14 2.143 0 1.021 0.712 1.875 1.667 2.091-0.362 1.21-0.066 2.576 0.888 3.531l3.56 3.561 1.578-1.581-3.56-3.561c-0.511-0.511-0.512-1.346 0.003-1.861zM15.98 2.143c0-1.184-0.958-2.143-2.14-2.143-1.082 0-1.976 0.804-2.12 1.847-1.204-0.354-2.559-0.055-3.51 0.897l-3.56 3.561 1.58 1.581 3.559-3.56c0.515-0.515 1.344-0.514 1.854-0.003 0.512 0.513 0.512 1.346-0.001 1.859l-0.122 0.122 1.578 1.582 0.123-0.124c0.945-0.946 1.245-2.293 0.9-3.494 1.049-0.138 1.858-1.037 1.858-2.125zM14.16 11.735c0.283-1.163-0.031-2.443-0.939-3.352l-3.555-3.562-1.58 1.58 3.555 3.563c0.515 0.516 0.514 1.345 0.003 1.857-0.513 0.513-1.344 0.513-1.857-0l-0.121-0.122-1.578 1.582 0.121 0.121c0.961 0.962 2.338 1.257 3.553 0.883 0.197 0.979 1.061 1.716 2.098 1.716 1.181 0 2.14-0.959 2.14-2.143 0-1.081-0.8-1.976-1.84-2.122zM9.568 8.261l-3.555 3.562c-0.511 0.512-1.344 0.513-1.859-0.002-0.513-0.514-0.513-1.345-0.001-1.859l0.122-0.121-1.579-1.58-0.121 0.12c-0.918 0.919-1.228 2.216-0.929 3.39-0.944 0.223-1.646 1.072-1.646 2.086-0 1.184 0.958 2.143 2.14 2.143 1.017-0.001 1.869-0.71 2.087-1.662 1.167 0.29 2.453-0.020 3.365-0.934l3.555-3.562-1.578-1.582z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWordpress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8c0 2.313 1.38 4.312 3.382 5.259l-2.862-7.637c-0.333 0.727-0.52 1.531-0.52 2.378zM12.050 7.705c0-0.722-0.266-1.222-0.495-1.612-0.304-0.482-0.589-0.889-0.589-1.371 0-0.537 0.418-1.037 1.008-1.037 0.027 0 0.052 0.003 0.078 0.005-1.067-0.953-2.49-1.534-4.052-1.534-2.096 0-3.94 1.048-5.013 2.634 0.141 0.004 0.274 0.007 0.386 0.007 0.627 0 1.599-0.074 1.599-0.074 0.323-0.018 0.361 0.444 0.038 0.482 0 0-0.325 0.037-0.687 0.055l2.185 6.33 1.313-3.835-0.935-2.495c-0.323-0.019-0.629-0.055-0.629-0.055-0.323-0.019-0.285-0.5 0.038-0.482 0 0 0.991 0.074 1.58 0.074 0.627 0 1.599-0.074 1.599-0.074 0.323-0.018 0.362 0.444 0.038 0.482 0 0-0.326 0.037-0.687 0.055l2.168 6.282 0.599-1.947c0.259-0.809 0.457-1.389 0.457-1.889zM8.105 8.511l-1.8 5.095c0.538 0.154 1.106 0.238 1.695 0.238 0.699 0 1.369-0.117 1.992-0.331-0.016-0.025-0.031-0.052-0.043-0.081l-1.844-4.921zM13.265 5.196c0.026 0.186 0.040 0.386 0.040 0.601 0 0.593-0.114 1.259-0.456 2.093l-1.833 5.16c1.784-1.013 2.983-2.895 2.983-5.051 0-1.016-0.267-1.971-0.735-2.803zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTrello(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM7 12c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-8c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v8zM13 9c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-5c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBasecamp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.666c-2.919 0-5.169 2.444-6.444 4.838-0.719 1.347-1.222 2.822-1.453 4.331-0.025 0.172-0.050 0.344-0.069 0.519-0.009 0.094-0.019 0.188-0.025 0.281-0.009 0.119-0.003 0.156 0.059 0.256 0.187 0.303 0.409 0.584 0.659 0.838 0.512 0.525 1.134 0.928 1.794 1.241 1.503 0.709 3.2 0.966 4.85 1.022 1.703 0.056 3.453-0.084 5.081-0.616 1.391-0.453 2.731-1.244 3.503-2.522 0.084-0.137 0.025-0.341 0.009-0.5-0.019-0.191-0.044-0.378-0.075-0.566-0.056-0.369-0.131-0.731-0.222-1.094-0.181-0.738-0.428-1.463-0.728-2.159-1.088-2.525-3.1-5.219-5.963-5.775-0.322-0.063-0.65-0.094-0.978-0.094zM8.1 13.909c-1.784 0-3.728-0.159-5.334-1.019-0.625-0.334-1.262-0.819-1.563-1.484-0.087-0.194-0.056-0.269-0.016-0.497 0.028-0.147 0.041-0.291 0.106-0.428 0.091-0.191 0.184-0.378 0.281-0.566 0.328-0.634 0.681-1.262 1.091-1.853 0.203-0.291 0.419-0.578 0.669-0.828 0.175-0.175 0.388-0.362 0.634-0.422 0.756-0.181 1.334 0.694 1.794 1.134 0.222 0.213 0.519 0.453 0.85 0.412 0.228-0.028 0.431-0.206 0.594-0.353 0.553-0.497 0.997-1.112 1.456-1.691 0.228-0.284 0.453-0.572 0.7-0.844 0.166-0.184 0.347-0.394 0.569-0.513 0.397-0.216 0.903 0.228 1.178 0.456 0.469 0.391 0.884 0.847 1.281 1.309 0.378 0.441 0.744 0.888 1.066 1.372 0.497 0.75 0.928 1.55 1.322 2.359 0.084 0.175 0.113 0.294 0.144 0.488 0.019 0.106 0.059 0.228 0.044 0.338-0.022 0.153-0.128 0.319-0.206 0.444-0.188 0.297-0.441 0.553-0.719 0.769-1.166 0.903-2.744 1.203-4.178 1.338-0.588 0.056-1.175 0.078-1.762 0.078z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImNpm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h16v-16h-16zM13 13h-2v-8h-3v8h-5v-10h10v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGithub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0.198c-4.418 0-8 3.582-8 8 0 3.535 2.292 6.533 5.471 7.591 0.4 0.074 0.547-0.174 0.547-0.385 0-0.191-0.008-0.821-0.011-1.489-2.226 0.484-2.695-0.944-2.695-0.944-0.364-0.925-0.888-1.171-0.888-1.171-0.726-0.497 0.055-0.486 0.055-0.486 0.803 0.056 1.226 0.824 1.226 0.824 0.714 1.223 1.872 0.869 2.328 0.665 0.072-0.517 0.279-0.87 0.508-1.070-1.777-0.202-3.645-0.888-3.645-3.954 0-0.873 0.313-1.587 0.824-2.147-0.083-0.202-0.357-1.015 0.077-2.117 0 0 0.672-0.215 2.201 0.82 0.638-0.177 1.322-0.266 2.002-0.269 0.68 0.003 1.365 0.092 2.004 0.269 1.527-1.035 2.198-0.82 2.198-0.82 0.435 1.102 0.162 1.916 0.079 2.117 0.513 0.56 0.823 1.274 0.823 2.147 0 3.073-1.872 3.749-3.653 3.947 0.287 0.248 0.543 0.735 0.543 1.481 0 1.070-0.009 1.932-0.009 2.195 0 0.213 0.144 0.462 0.55 0.384 3.177-1.059 5.466-4.057 5.466-7.59 0-4.418-3.582-8-8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImOnedrive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.482 12.944c-0.942-0.235-1.466-0.984-1.468-2.095-0-0.355 0.025-0.525 0.114-0.754 0.217-0.56 0.793-0.982 1.55-1.138 0.377-0.077 0.493-0.16 0.493-0.353 0-0.060 0.045-0.24 0.1-0.399 0.249-0.724 0.71-1.327 1.202-1.573 0.515-0.258 0.776-0.316 1.399-0.313 0.886 0.005 1.327 0.197 1.945 0.846l0.34 0.357 0.304-0.105c1.473-0.51 2.942 0.358 3.061 1.809l0.032 0.397 0.29 0.104c0.829 0.297 1.218 0.92 1.148 1.837-0.046 0.599-0.326 1.078-0.77 1.315l-0.209 0.112-4.638 0.009c-3.564 0.007-4.697-0.006-4.893-0.055v0zM1.613 12.281c-0.565-0.142-1.164-0.67-1.445-1.273-0.159-0.342-0.168-0.393-0.168-0.998 0-0.576 0.014-0.668 0.14-0.954 0.267-0.603 0.78-1.038 1.422-1.21 0.136-0.036 0.263-0.094 0.283-0.128s0.043-0.221 0.050-0.415c0.045-1.206 0.794-2.269 1.839-2.61 0.565-0.184 1.306-0.202 1.92 0.058 0.195 0.082 0.173 0.1 0.585-0.471 0.244-0.338 0.705-0.695 1.108-0.909 0.435-0.231 0.887-0.337 1.428-0.336 1.512 0.004 2.815 1.003 3.297 2.529 0.154 0.487 0.146 0.624-0.035 0.628-0.079 0.002-0.306 0.048-0.505 0.102l-0.361 0.099-0.329-0.348c-0.928-0.98-2.441-1.192-3.728-0.522-0.514 0.268-0.927 0.652-1.239 1.153-0.222 0.357-0.506 1.024-0.506 1.189 0 0.117-0.090 0.176-0.474 0.309-1.189 0.412-1.883 1.364-1.882 2.582 0 0.443 0.108 0.986 0.258 1.296 0.057 0.117 0.088 0.228 0.070 0.247-0.046 0.049-1.525 0.032-1.73-0.019v0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDropbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 0.5l-3.5 3 4.5 3 3.5-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.5l-3.5-3-4.5 3 3.5 3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.5l3.5 3-4.5 2.5-3.5-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9l-4.5-2.5-3.5 3 4.5 2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.377 13.212l-3.377-2.895-3.377 2.895-2.123-1.179v1.467l5.5 2.5 5.5-2.5v-1.467z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSteam2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.749 13.063c0.424 0 0.84-0.205 1.093-0.585 0.402-0.603 0.239-1.418-0.364-1.82l-1.032-0.688c0.177-0.048 0.362-0.074 0.554-0.074 1.162 0 2.105 0.942 2.105 2.105s-0.942 2.105-2.105 2.105c-1.131 0-2.054-0.893-2.102-2.012l1.124 0.749c0.224 0.149 0.477 0.221 0.727 0.221zM13.333 0c1.467 0 2.667 1.2 2.667 2.667v10.666c0 1.468-1.2 2.667-2.667 2.667h-10.666c-1.467 0-2.667-1.199-2.667-2.667v-3.172l1.896 1.264c-0.182 0.987 0.108 2.044 0.872 2.808 1.233 1.233 3.232 1.233 4.465 0 0.757-0.757 1.049-1.804 0.876-2.784l3.892-3.484c0.723-0.104 1.419-0.433 1.975-0.989 1.367-1.367 1.367-3.583 0-4.95s-3.583-1.367-4.95 0c-0.556 0.556-0.886 1.252-0.989 1.975v0l-3.198 4.847c-0.498 0.025-0.99 0.168-1.433 0.428l-3.404-2.269v-4.339c0-1.467 1.2-2.667 2.667-2.667h10.666zM14 4.5c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5 1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5zM10 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSteam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM14.975 2.025c-1.367-1.367-3.583-1.367-4.95 0-0.556 0.556-0.886 1.252-0.989 1.975v0l-3.198 4.847c-0.43 0.022-0.856 0.132-1.249 0.328l-2.467-1.928c-0.571-0.446-1.396-0.345-1.842 0.226s-0.345 1.396 0.226 1.842l2.436 1.905c-0.265 1.043 0.010 2.196 0.827 3.012 1.233 1.233 3.232 1.233 4.465 0 0.757-0.757 1.049-1.804 0.876-2.784l3.891-3.484c0.723-0.104 1.419-0.434 1.975-0.989 1.367-1.367 1.367-3.583 0-4.95zM6 14.105c-1.162 0-2.105-0.942-2.105-2.105 0-0.011 0.001-0.022 0.001-0.033l1.046 0.817c0.24 0.188 0.525 0.278 0.807 0.278 0.39 0 0.776-0.173 1.035-0.504 0.446-0.571 0.345-1.396-0.226-1.842l-0.992-0.776c0.14-0.029 0.285-0.045 0.434-0.045 1.162 0 2.105 0.942 2.105 2.105s-0.942 2.105-2.105 2.105zM12.5 7c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function Im500Px(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.953 10.512c0.003 0.009 0.088 0.238 0.134 0.353 0.263 0.622 0.641 1.184 1.122 1.666s1.041 0.859 1.666 1.122c0.647 0.272 1.331 0.412 2.037 0.412s1.394-0.137 2.037-0.412c0.625-0.262 1.184-0.641 1.666-1.122s0.859-1.041 1.122-1.666c0.272-0.647 0.412-1.331 0.412-2.037s-0.137-1.394-0.412-2.037c-0.262-0.625-0.641-1.184-1.122-1.666s-1.041-0.859-1.666-1.122c-0.647-0.272-1.331-0.413-2.037-0.413-0.716 0-1.431 0.144-2.066 0.413-0.509 0.216-1.372 0.769-1.875 1.291l-0.003 0.003v-4.313h7.241c0.262-0.003 0.262-0.372 0.262-0.491 0-0.122 0-0.487-0.266-0.491h-7.828c-0.213 0-0.344 0.178-0.344 0.341v6.066c0 0.197 0.244 0.338 0.472 0.384 0.444 0.094 0.544-0.047 0.653-0.197l0.016-0.019c0.166-0.247 0.681-0.766 0.688-0.772 0.806-0.806 1.884-1.25 3.037-1.25 1.147 0 2.222 0.444 3.028 1.25 0.809 0.809 1.256 1.881 1.256 3.019 0 1.141-0.444 2.216-1.25 3.019-0.794 0.794-1.906 1.25-3.047 1.25-0.772 0-1.519-0.206-2.159-0.597l0.003-3.688c0-0.491 0.213-1.028 0.572-1.431 0.409-0.463 0.972-0.716 1.588-0.716 0.594 0 1.15 0.225 1.566 0.634 0.409 0.406 0.637 0.95 0.637 1.528 0 1.231-0.969 2.197-2.206 2.197-0.238 0-0.672-0.106-0.691-0.109-0.25-0.075-0.356 0.272-0.391 0.387-0.134 0.441 0.069 0.528 0.109 0.541 0.397 0.125 0.659 0.147 1.003 0.147 1.747 0 3.169-1.422 3.169-3.169 0-1.734-1.422-3.144-3.166-3.144-0.856 0-1.659 0.328-2.263 0.919-0.575 0.566-0.903 1.319-0.903 2.069v0.019c-0.003 0.094-0.003 2.306-0.006 3.031l-0.003-0.003c-0.328-0.363-0.653-0.919-0.869-1.488-0.084-0.222-0.275-0.184-0.534-0.103-0.125 0.034-0.469 0.141-0.391 0.394v0zM7.675 9.647c0 0.106 0.097 0.2 0.156 0.253l0.019 0.019c0.1 0.097 0.194 0.147 0.281 0.147 0.072 0 0.116-0.034 0.131-0.050 0.044-0.041 0.537-0.544 0.588-0.591l0.553 0.55c0.050 0.056 0.106 0.088 0.172 0.088 0.088 0 0.184-0.053 0.284-0.156 0.238-0.244 0.119-0.375 0.063-0.438l-0.559-0.559 0.584-0.588c0.128-0.137 0.016-0.284-0.097-0.397-0.162-0.162-0.322-0.206-0.422-0.112l-0.581 0.581-0.588-0.588c-0.031-0.031-0.072-0.047-0.113-0.047-0.078 0-0.172 0.053-0.275 0.156-0.181 0.181-0.219 0.306-0.125 0.406l0.588 0.584-0.584 0.584c-0.053 0.050-0.078 0.103-0.075 0.156zM8.953 1.716c-0.938 0-1.938 0.191-2.669 0.506-0.078 0.031-0.125 0.094-0.134 0.181-0.009 0.084 0.013 0.194 0.069 0.337 0.047 0.116 0.166 0.425 0.4 0.334 0.75-0.288 1.581-0.444 2.334-0.444 0.856 0 1.688 0.169 2.469 0.497 0.622 0.263 1.206 0.644 1.844 1.194 0.047 0.041 0.097 0.059 0.147 0.059 0.125 0 0.244-0.122 0.347-0.237 0.169-0.191 0.287-0.35 0.119-0.509-0.609-0.575-1.275-1.006-2.1-1.356-0.894-0.372-1.847-0.563-2.825-0.563zM14.006 13.3v0c-0.113-0.113-0.209-0.178-0.294-0.203s-0.162-0.006-0.222 0.053l-0.056 0.056c-0.581 0.581-1.259 1.037-2.012 1.356-0.781 0.331-1.609 0.497-2.463 0.497-0.856 0-1.684-0.169-2.463-0.497-0.753-0.319-1.431-0.775-2.013-1.356-0.606-0.606-1.063-1.284-1.356-2.012-0.288-0.713-0.381-1.247-0.413-1.422-0.003-0.016-0.006-0.028-0.006-0.037-0.041-0.206-0.231-0.222-0.503-0.178-0.112 0.019-0.459 0.072-0.428 0.319v0.006c0.091 0.578 0.253 1.144 0.481 1.681 0.366 0.866 0.891 1.644 1.559 2.313s1.447 1.191 2.313 1.559c0.897 0.378 1.85 0.572 2.831 0.572s1.934-0.194 2.831-0.572c0.866-0.366 1.644-0.891 2.313-1.559 0 0 0.037-0.037 0.059-0.059 0.069-0.084 0.134-0.225-0.159-0.516z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDeviantart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.953 2.909v-2.909h-2.909l-0.291 0.294-1.375 2.616-0.431 0.291h-4.9v3.994h2.694l0.241 0.291-2.934 5.606v2.909h2.909l0.291-0.294 1.375-2.616 0.431-0.291h4.9v-3.994h-2.694l-0.241-0.294z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBehance2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.316 7.009c0.203-0.147 0.3-0.391 0.3-0.728 0-0.188-0.031-0.341-0.097-0.459-0.069-0.119-0.156-0.213-0.272-0.278-0.112-0.069-0.241-0.116-0.388-0.141-0.144-0.028-0.297-0.041-0.453-0.041h-1.647v1.869h1.781c0.313 0.003 0.572-0.072 0.775-0.222z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.594 8.697c-0.231-0.175-0.537-0.262-0.919-0.262h-1.916v2.203h1.878c0.175 0 0.338-0.016 0.494-0.050s0.297-0.088 0.416-0.169c0.119-0.078 0.216-0.184 0.287-0.319s0.106-0.309 0.106-0.519c0-0.412-0.116-0.706-0.347-0.884z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM10.488 4.209h3.241v0.791h-3.241v-0.791zM8.463 10.725c-0.156 0.297-0.369 0.537-0.631 0.725-0.266 0.188-0.569 0.325-0.909 0.416-0.338 0.091-0.688 0.134-1.044 0.134h-3.878v-7.997h3.769c0.381 0 0.728 0.034 1.044 0.1 0.313 0.066 0.581 0.178 0.806 0.331 0.222 0.153 0.397 0.356 0.522 0.609 0.122 0.25 0.184 0.566 0.184 0.938 0 0.403-0.091 0.737-0.275 1.006s-0.453 0.487-0.816 0.659c0.494 0.141 0.856 0.391 1.097 0.744 0.244 0.356 0.363 0.784 0.363 1.284 0.003 0.409-0.075 0.759-0.231 1.050zM14.991 9.488h-4.178c0 0.456 0.156 0.891 0.394 1.125 0.238 0.231 0.581 0.35 1.028 0.35 0.322 0 0.597-0.081 0.831-0.244 0.231-0.162 0.372-0.334 0.425-0.512h1.4c-0.225 0.697-0.566 1.194-1.031 1.494-0.459 0.3-1.022 0.45-1.675 0.45-0.456 0-0.866-0.075-1.234-0.219-0.369-0.147-0.675-0.353-0.934-0.622-0.253-0.269-0.447-0.591-0.588-0.966-0.137-0.372-0.209-0.787-0.209-1.234 0-0.434 0.072-0.838 0.213-1.213 0.144-0.375 0.344-0.7 0.606-0.969 0.262-0.272 0.575-0.487 0.938-0.647 0.363-0.156 0.762-0.234 1.206-0.234 0.491 0 0.919 0.094 1.287 0.287 0.366 0.191 0.666 0.447 0.903 0.769s0.403 0.688 0.509 1.1c0.103 0.406 0.137 0.834 0.109 1.284z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.134 7.247c-0.253 0-0.466 0.044-0.631 0.131s-0.3 0.194-0.403 0.319c-0.103 0.128-0.172 0.263-0.213 0.409-0.041 0.141-0.066 0.269-0.072 0.381h2.588c-0.037-0.406-0.178-0.706-0.366-0.916-0.194-0.213-0.512-0.325-0.903-0.325z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBehance(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.641 3.206c0.472 0 0.897 0.041 1.284 0.125 0.388 0.081 0.716 0.219 0.994 0.406 0.275 0.188 0.487 0.438 0.644 0.75 0.15 0.309 0.225 0.697 0.225 1.156 0 0.497-0.112 0.909-0.338 1.241-0.228 0.331-0.559 0.6-1.003 0.813 0.606 0.175 1.053 0.481 1.353 0.916 0.3 0.438 0.444 0.963 0.444 1.581 0 0.5-0.097 0.928-0.287 1.291-0.194 0.366-0.456 0.662-0.778 0.891-0.325 0.231-0.7 0.4-1.119 0.509-0.416 0.109-0.844 0.166-1.287 0.166h-4.772v-9.844h4.641zM4.359 7.181c0.384 0 0.703-0.091 0.953-0.275 0.25-0.181 0.369-0.481 0.369-0.894 0-0.228-0.041-0.419-0.122-0.566-0.084-0.147-0.194-0.263-0.334-0.344-0.138-0.084-0.294-0.141-0.478-0.172-0.178-0.034-0.366-0.050-0.556-0.050h-2.025v2.3h2.194zM4.478 11.372c0.213 0 0.416-0.019 0.606-0.063 0.194-0.044 0.366-0.109 0.509-0.209 0.144-0.097 0.266-0.225 0.353-0.394 0.088-0.166 0.128-0.378 0.128-0.637 0-0.506-0.144-0.869-0.428-1.088-0.284-0.216-0.662-0.322-1.131-0.322h-2.35v2.709h2.313z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.331 11.338c0.294 0.287 0.716 0.431 1.266 0.431 0.394 0 0.738-0.1 1.022-0.3s0.456-0.412 0.522-0.631h1.725c-0.278 0.859-0.697 1.469-1.272 1.838-0.566 0.369-1.259 0.556-2.063 0.556-0.563 0-1.066-0.091-1.519-0.269-0.453-0.181-0.831-0.434-1.15-0.766-0.309-0.331-0.553-0.725-0.725-1.188-0.169-0.459-0.256-0.969-0.256-1.519 0-0.534 0.088-1.031 0.262-1.491 0.178-0.463 0.422-0.859 0.747-1.194s0.706-0.6 1.156-0.794c0.447-0.194 0.941-0.291 1.488-0.291 0.603 0 1.131 0.116 1.584 0.353 0.45 0.234 0.822 0.55 1.113 0.944s0.497 0.847 0.625 1.353c0.128 0.506 0.172 1.034 0.137 1.588h-5.147c0 0.559 0.188 1.094 0.484 1.378zM13.578 7.594c-0.231-0.256-0.628-0.397-1.106-0.397-0.313 0-0.572 0.053-0.778 0.159-0.203 0.106-0.369 0.237-0.497 0.394-0.125 0.156-0.213 0.325-0.262 0.503-0.050 0.172-0.081 0.331-0.091 0.469h3.188c-0.047-0.5-0.219-0.869-0.453-1.128z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.444 4h3.991v0.972h-3.991v-0.972z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDribbble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c-4.412 0-8-3.588-8-8s3.587-8 8-8c4.412 0 8 3.587 8 8s-3.588 8-8 8v0zM14.747 9.094c-0.234-0.075-2.116-0.634-4.256-0.291 0.894 2.456 1.256 4.456 1.328 4.872 1.531-1.037 2.625-2.678 2.928-4.581v0zM10.669 14.3c-0.103-0.6-0.497-2.688-1.456-5.181-0.016 0.006-0.031 0.009-0.044 0.016-3.856 1.344-5.241 4.016-5.362 4.266 1.159 0.903 2.616 1.444 4.194 1.444 0.947 0 1.85-0.194 2.669-0.544v0zM2.922 12.578c0.156-0.266 2.031-3.369 5.553-4.509 0.088-0.028 0.178-0.056 0.269-0.081-0.172-0.388-0.359-0.778-0.553-1.159-3.409 1.022-6.722 0.978-7.022 0.975-0.003 0.069-0.003 0.138-0.003 0.209 0 1.753 0.666 3.356 1.756 4.566v0zM1.313 6.609c0.306 0.003 3.122 0.016 6.319-0.831-1.131-2.013-2.353-3.706-2.534-3.953-1.913 0.903-3.344 2.666-3.784 4.784v0zM6.4 1.366c0.188 0.253 1.431 1.944 2.55 4 2.431-0.909 3.459-2.294 3.581-2.469-1.206-1.072-2.794-1.722-4.531-1.722-0.55 0.003-1.088 0.069-1.6 0.191v0zM13.291 3.691c-0.144 0.194-1.291 1.663-3.816 2.694 0.159 0.325 0.313 0.656 0.453 0.991 0.050 0.119 0.1 0.234 0.147 0.353 2.275-0.284 4.534 0.172 4.759 0.219-0.016-1.612-0.594-3.094-1.544-4.256v0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFlickr4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.606-8 8.055s3.582 8.055 8 8.055 8-3.606 8-8.055-3.582-8.055-8-8.055zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFlickr3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFlickr2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.5c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12.5 5v0c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5c0-1.933 1.567-3.5 3.5-3.5zM0 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFlickr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5zM9 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLanyrd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM12.85 12.012l-5.444 1.781c-1.244 0.406-1.369 0.341-1.931-1.4l-1.375-4.259c-0.328-1.009-1.328-3.728-1.497-4.25-0.313-0.969-0.313-1.022 1.516-1.616 1.431-0.469 1.491-0.453 2.009 1.163 0.419 1.3 0.688 2.35 1.119 3.678l1.172 3.625 3.744-1.225c0.738-0.244 0.984-0.231 1.194 0.678l0.15 0.688c0.175 0.797-0.228 1-0.656 1.137z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVimeo2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13.463 5.313c-0.050 1.125-0.838 2.666-2.359 4.622-1.572 2.044-2.903 3.066-3.991 3.066-0.675 0-1.244-0.622-1.709-1.866-0.313-1.141-0.622-2.281-0.934-3.422-0.344-1.244-0.716-1.866-1.112-1.866-0.087 0-0.391 0.181-0.906 0.544l-0.544-0.7c0.572-0.5 1.134-1.003 1.687-1.503 0.763-0.656 1.331-1.003 1.712-1.038 0.9-0.087 1.453 0.528 1.662 1.844 0.225 1.422 0.381 2.303 0.469 2.65 0.259 1.178 0.544 1.766 0.856 1.766 0.241 0 0.606-0.381 1.091-1.147s0.744-1.347 0.778-1.747c0.069-0.659-0.191-0.991-0.778-0.991-0.278 0-0.563 0.063-0.856 0.191 0.569-1.859 1.653-2.766 3.256-2.712 1.188 0.034 1.747 0.803 1.678 2.309z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVimeo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.994 4.281c-0.072 1.556-1.159 3.691-3.263 6.397-2.175 2.825-4.016 4.241-5.522 4.241-0.931 0-1.722-0.859-2.366-2.581-0.431-1.578-0.859-3.156-1.291-4.734-0.478-1.722-0.991-2.581-1.541-2.581-0.119 0-0.538 0.253-1.256 0.753l-0.753-0.969c0.791-0.694 1.569-1.388 2.334-2.081 1.053-0.909 1.844-1.387 2.372-1.438 1.244-0.119 2.013 0.731 2.3 2.553 0.309 1.966 0.525 3.188 0.647 3.666 0.359 1.631 0.753 2.447 1.184 2.447 0.334 0 0.838-0.528 1.509-1.588 0.669-1.056 1.028-1.862 1.078-2.416 0.097-0.912-0.262-1.372-1.078-1.372-0.384 0-0.778 0.088-1.184 0.263 0.787-2.575 2.287-3.825 4.506-3.753 1.641 0.044 2.416 1.109 2.322 3.194z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTwitch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0l-1.5 2.5v11.5h4v2h2l2-2h2.5l4.5-4.5v-9.5h-13.5zM13 8.5l-2.5 2.5h-2.5l-2 2v-2h-3v-9h10v6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 4h1.5v4h-1.5v-4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 4h1.5v4h-1.5v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImYoutube2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 40 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.375 2.647c0.003-0.014 0.005-0.023 0.006-0.028l0.016-0.118-0.74-0.004c-0.668-0.004-0.873 0-0.891 0.017-0.009 0.008-0.24 0.885-0.651 2.473-0.196 0.758-0.361 1.363-0.367 1.345s-0.24-0.883-0.522-1.922c-0.281-1.039-0.517-1.894-0.524-1.901-0.010-0.010-0.906-0.014-1.632-0.008-0.105 0.001-0.164-0.205 0.938 3.299 0.152 0.485 0.381 1.172 0.507 1.526 0.146 0.408 0.25 0.724 0.321 0.987 0.126 0.501 0.13 0.815 0.103 1.182-0.032 0.423-0.036 3.413-0.005 3.463 0.024 0.038 1.425 0.056 1.558 0.020 0.021-0.006 0.035-0.026 0.045-0.139 0.033-0.097 0.036-0.484 0.036-2.090v-2.051l0.090-0.283c0.059-0.185 0.206-0.672 0.328-1.082s0.269-0.9 0.327-1.090c0.529-1.724 1.033-3.419 1.047-3.516l0.011-0.079z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.221 5.135l-0 0.107-0.017 0-0.009 2.953-0.009 2.863-0.229 0.233c-0.257 0.261-0.462 0.361-0.648 0.314-0.203-0.051-0.197 0.028-0.214-3.356l-0.016-3.115h-1.474v0.107h-0.017v3.38c0 3.621-0 3.619 0.184 3.982 0.146 0.29 0.36 0.431 0.725 0.479h0c0.481 0.064 1-0.154 1.481-0.622l0.209-0.203v0.351c0 0.303 0.009 0.353 0.064 0.368 0.090 0.025 1.206 0.027 1.326 0.002l0.1-0.021v-0.104l0.017-0.003v-7.736l-1.472 0.020z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.483 6.661c-0.14-0.599-0.401-1.002-0.832-1.28-0.676-0.437-1.449-0.484-2.165-0.13-0.522 0.258-0.859 0.686-1.032 1.314-0.021 0.075-0.036 0.138-0.047 0.231-0.044 0.222-0.049 0.552-0.061 2.093-0.018 2.374 0.010 2.656 0.307 3.195 0.292 0.529 0.897 0.917 1.556 0.997 0.198 0.024 0.6-0.013 0.832-0.078 0.525-0.146 1.029-0.561 1.252-1.032 0.096-0.204 0.154-0.345 0.189-0.604 0.065-0.353 0.070-0.925 0.070-2.381-0-1.857-0.006-2.060-0.068-2.326zM7.802 11.5c-0.124 0.094-0.34 0.135-0.515 0.098-0.135-0.029-0.318-0.241-0.374-0.434-0.070-0.241-0.075-3.594-0.015-4.251 0.1-0.329 0.378-0.501 0.682-0.419 0.237 0.064 0.358 0.212 0.427 0.523 0.051 0.231 0.057 0.518 0.046 2.207-0.007 1.12-0.011 1.668-0.048 1.962-0.037 0.185-0.099 0.235-0.203 0.315z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M35.944 8.346h0.712l-0.011-0.645c-0.011-0.592-0.020-0.659-0.099-0.82-0.125-0.253-0.309-0.366-0.601-0.366-0.351 0-0.573 0.17-0.678 0.518-0.045 0.148-0.092 1.167-0.058 1.255 0.019 0.049 0.121 0.058 0.735 0.058z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M31.184 6.879c-0.095-0.191-0.272-0.286-0.477-0.278-0.16 0.006-0.337 0.073-0.508 0.203l-0.127 0.097v4.634l0.127 0.097c0.288 0.22 0.604 0.266 0.822 0.12 0.086-0.058 0.142-0.137 0.186-0.263 0.057-0.164 0.062-0.375 0.055-2.325-0.008-2.032-0.012-2.152-0.078-2.285z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M40.014 4.791c-0.142-1.701-0.255-2.253-0.605-2.962-0.465-0.939-1.136-1.434-2.092-1.543-0.739-0.084-3.521-0.203-6.094-0.26-4.456-0.099-11.782 0.092-12.718 0.331-0.432 0.111-0.757 0.299-1.094 0.634-0.591 0.588-0.944 1.432-1.085 2.6-0.323 2.666-0.33 5.886-0.019 8.649 0.134 1.188 0.41 1.96 0.928 2.596 0.323 0.397 0.881 0.734 1.379 0.835 0.35 0.071 2.1 0.169 4.65 0.26 0.38 0.014 1.385 0.037 2.235 0.052 1.77 0.031 5.025 0.013 6.886-0.039 1.252-0.035 3.534-0.128 3.961-0.161 0.12-0.009 0.398-0.027 0.618-0.039 0.739-0.042 1.209-0.196 1.65-0.543 0.571-0.449 1.013-1.278 1.2-2.251 0.177-0.92 0.295-2.559 0.319-4.42 0.020-1.555-0.007-2.393-0.119-3.741zM22.27 4.175l-0.828 0.010-0.036 8.83-0.718 0.009c-0.555 0.008-0.724-0.001-0.737-0.036-0.010-0.025-0.021-2.016-0.026-4.424l-0.009-4.379-1.617-0.020v-1.38l4.779 0.019 0.020 1.36-0.828 0.010zM27.347 9.236v3.797h-1.308v-0.4c0-0.301-0.011-0.4-0.047-0.4-0.026 0-0.144 0.099-0.263 0.22-0.259 0.263-0.565 0.474-0.827 0.572-0.542 0.203-1.056 0.084-1.275-0.293-0.201-0.345-0.204-0.423-0.204-4.005v-3.29h1.307l0.010 3.098c0.010 3.044 0.011 3.1 0.084 3.224 0.097 0.164 0.244 0.209 0.478 0.144 0.138-0.038 0.232-0.105 0.455-0.327l0.282-0.28v-5.859h1.308v3.797zM32.449 12.491c-0.115 0.257-0.372 0.508-0.583 0.57-0.549 0.162-0.99 0.030-1.499-0.449-0.158-0.149-0.305-0.269-0.327-0.269-0.027 0-0.041 0.116-0.041 0.345v0.345h-1.308v-10.248h1.308v1.672c0 0.919 0.012 1.672 0.027 1.672s0.153-0.122 0.307-0.27c0.354-0.341 0.649-0.491 1.024-0.519 0.669-0.051 1.068 0.294 1.25 1.080 0.057 0.245 0.062 0.525 0.062 2.798-0 2.768-0 2.78-0.221 3.273zM37.984 10.971c-0.012 0.285-0.046 0.612-0.077 0.727-0.182 0.674-0.666 1.152-1.366 1.348-0.942 0.264-1.98-0.168-2.394-0.997-0.232-0.465-0.241-0.558-0.241-2.831 0-1.853 0.007-2.081 0.066-2.334 0.168-0.715 0.584-1.178 1.289-1.435 0.204-0.074 0.417-0.113 0.63-0.117 0.761-0.016 1.515 0.393 1.832 1.059 0.213 0.449 0.24 0.642 0.261 1.908l0.019 1.136-2.789 0.019-0.010 0.763c-0.015 1.077 0.058 1.408 0.349 1.603 0.244 0.165 0.62 0.152 0.824-0.027 0.192-0.168 0.246-0.349 0.265-0.877l0.017-0.463h1.347l-0.022 0.518z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImYoutube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.841 4.8c0 0-0.156-1.103-0.637-1.587-0.609-0.637-1.291-0.641-1.603-0.678-2.237-0.163-5.597-0.163-5.597-0.163h-0.006c0 0-3.359 0-5.597 0.163-0.313 0.038-0.994 0.041-1.603 0.678-0.481 0.484-0.634 1.587-0.634 1.587s-0.159 1.294-0.159 2.591v1.213c0 1.294 0.159 2.591 0.159 2.591s0.156 1.103 0.634 1.588c0.609 0.637 1.409 0.616 1.766 0.684 1.281 0.122 5.441 0.159 5.441 0.159s3.363-0.006 5.6-0.166c0.313-0.037 0.994-0.041 1.603-0.678 0.481-0.484 0.637-1.588 0.637-1.588s0.159-1.294 0.159-2.591v-1.213c-0.003-1.294-0.162-2.591-0.162-2.591zM6.347 10.075v-4.497l4.322 2.256-4.322 2.241z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRss2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.359 12.988c-0.75 0-1.359-0.603-1.359-1.353 0-0.744 0.609-1.356 1.359-1.356 0.753 0 1.359 0.613 1.359 1.356 0 0.75-0.609 1.353-1.359 1.353zM7.772 13c0-1.278-0.497-2.481-1.397-3.381-0.903-0.903-2.1-1.4-3.375-1.4v-1.956c3.713 0 6.738 3.022 6.738 6.737h-1.966zM11.244 13c0-4.547-3.697-8.25-8.241-8.25v-1.956c5.625 0 10.203 4.581 10.203 10.206h-1.963z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.13 11.733c-1.175 0-2.13 0.958-2.13 2.126 0 1.174 0.955 2.122 2.13 2.122 1.179 0 2.133-0.948 2.133-2.122-0-1.168-0.954-2.126-2.133-2.126zM0.002 5.436v3.067c1.997 0 3.874 0.781 5.288 2.196 1.412 1.411 2.192 3.297 2.192 5.302h3.080c-0-5.825-4.739-10.564-10.56-10.564zM0.006 0v3.068c7.122 0 12.918 5.802 12.918 12.932h3.076c0-8.82-7.176-16-15.994-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSinaWeibo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.722 14.031c-2.65 0.262-4.938-0.938-5.109-2.675-0.172-1.741 1.837-3.359 4.484-3.622 2.65-0.263 4.938 0.938 5.106 2.675 0.175 1.741-1.834 3.362-4.481 3.622zM12.019 8.259c-0.225-0.069-0.381-0.113-0.262-0.409 0.256-0.644 0.281-1.197 0.003-1.594-0.519-0.741-1.941-0.703-3.569-0.019 0 0-0.513 0.222-0.381-0.181 0.25-0.806 0.213-1.478-0.178-1.869-0.884-0.884-3.234 0.034-5.25 2.050-1.506 1.503-2.381 3.106-2.381 4.491 0 2.644 3.394 4.253 6.713 4.253 4.35 0 7.247-2.528 7.247-4.534 0-1.216-1.022-1.903-1.941-2.188z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.909 3.416c-1.050-1.166-2.6-1.609-4.031-1.306v0c-0.331 0.072-0.541 0.397-0.469 0.725 0.072 0.331 0.394 0.541 0.725 0.469 1.019-0.216 2.119 0.1 2.866 0.928s0.95 1.956 0.628 2.944v0c-0.103 0.322 0.072 0.666 0.394 0.772 0.322 0.103 0.666-0.072 0.772-0.394v-0.003c0.45-1.381 0.166-2.969-0.884-4.134z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.294 4.875c-0.512-0.569-1.269-0.784-1.963-0.634-0.284 0.059-0.466 0.344-0.406 0.628 0.063 0.284 0.344 0.466 0.625 0.403v0c0.341-0.072 0.709 0.034 0.959 0.309 0.25 0.278 0.319 0.656 0.209 0.987v0c-0.088 0.275 0.063 0.575 0.341 0.666 0.278 0.088 0.575-0.063 0.666-0.341 0.219-0.678 0.081-1.453-0.431-2.019z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.869 10.884c-0.094 0.159-0.297 0.234-0.456 0.169-0.159-0.063-0.206-0.244-0.116-0.397 0.094-0.153 0.291-0.228 0.447-0.169 0.156 0.056 0.213 0.234 0.125 0.397zM6.022 11.966c-0.256 0.409-0.806 0.588-1.219 0.4-0.406-0.184-0.528-0.659-0.272-1.059 0.253-0.397 0.784-0.575 1.194-0.403 0.416 0.178 0.55 0.65 0.297 1.063zM6.984 9.072c-1.259-0.328-2.684 0.3-3.231 1.409-0.559 1.131-0.019 2.391 1.253 2.803 1.319 0.425 2.875-0.228 3.416-1.447 0.534-1.197-0.131-2.425-1.438-2.766z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRenren(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.644 0.166c-3.769 0.634-6.644 3.913-6.644 7.862 0 1.963 0.713 3.759 1.887 5.15 2.791-1.35 4.744-4.406 4.756-7.966v-5.047z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.356 0.166c3.769 0.634 6.644 3.913 6.644 7.862 0 1.963-0.713 3.759-1.887 5.15-2.791-1.35-4.744-4.406-4.756-7.966v-5.047z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.972 10.041c-0.497 2.056-1.981 3.813-3.828 4.981 1.138 0.622 2.441 0.978 3.828 0.978s2.691-0.356 3.828-0.978c-1.847-1.169-3.331-2.925-3.828-4.981z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM12.959 11.2l-1.463 0.022c0 0-0.316 0.063-0.728-0.222-0.547-0.375-1.063-1.353-1.466-1.225-0.406 0.128-0.394 1.006-0.394 1.006s0.003 0.188-0.091 0.287c-0.1 0.109-0.3 0.131-0.3 0.131h-0.653c0 0-1.444 0.088-2.716-1.238-1.388-1.444-2.612-4.309-2.612-4.309s-0.072-0.188 0.006-0.278c0.087-0.103 0.322-0.109 0.322-0.109l1.566-0.009c0 0 0.147 0.025 0.253 0.103 0.088 0.063 0.134 0.184 0.134 0.184s0.253 0.641 0.588 1.219c0.653 1.128 0.959 1.375 1.181 1.256 0.322-0.175 0.225-1.597 0.225-1.597s0.006-0.516-0.162-0.744c-0.131-0.178-0.378-0.231-0.484-0.244-0.088-0.013 0.056-0.216 0.244-0.309 0.281-0.138 0.778-0.147 1.366-0.141 0.456 0.003 0.591 0.034 0.769 0.075 0.541 0.131 0.356 0.634 0.356 1.841 0 0.388-0.069 0.931 0.209 1.109 0.119 0.078 0.412 0.012 1.147-1.234 0.347-0.591 0.609-1.284 0.609-1.284s0.056-0.125 0.144-0.178c0.091-0.053 0.213-0.037 0.213-0.037l1.647-0.009c0 0 0.494-0.059 0.575 0.166 0.084 0.234-0.184 0.781-0.856 1.678-1.103 1.472-1.228 1.334-0.309 2.184 0.875 0.813 1.056 1.209 1.088 1.259 0.356 0.6-0.406 0.647-0.406 0.647z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.012 7.953c-0.412 0.094-0.809 0.137-1.169 0.137-2.019 0-3.572-1.409-3.572-3.862 0-1.203 0.466-1.825 1.122-1.825 0.625 0 1.041 0.559 1.041 1.697 0 0.647-0.172 1.356-0.3 1.775 0 0 0.622 1.084 2.322 0.753 0.363-0.803 0.556-1.841 0.556-2.75 0-2.45-1.25-3.878-3.541-3.878-2.356 0-3.734 1.809-3.734 4.197 0 2.366 1.106 4.394 2.928 5.319-0.766 1.534-1.741 2.884-2.759 3.903-1.844-2.231-3.513-5.206-4.197-11.016h-2.722c1.259 9.675 5.006 12.756 6 13.347 0.559 0.337 1.044 0.322 1.556 0.031 0.806-0.456 3.222-2.875 4.563-5.703 0.563 0 1.238-0.066 1.909-0.219v-1.906z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTwitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3.538c-0.588 0.263-1.222 0.438-1.884 0.516 0.678-0.406 1.197-1.050 1.444-1.816-0.634 0.375-1.338 0.65-2.084 0.797-0.6-0.638-1.453-1.034-2.397-1.034-1.813 0-3.281 1.469-3.281 3.281 0 0.256 0.028 0.506 0.084 0.747-2.728-0.138-5.147-1.444-6.766-3.431-0.281 0.484-0.444 1.050-0.444 1.65 0 1.138 0.578 2.144 1.459 2.731-0.538-0.016-1.044-0.166-1.488-0.409 0 0.013 0 0.028 0 0.041 0 1.591 1.131 2.919 2.634 3.219-0.275 0.075-0.566 0.116-0.866 0.116-0.212 0-0.416-0.022-0.619-0.059 0.419 1.303 1.631 2.253 3.066 2.281-1.125 0.881-2.538 1.406-4.078 1.406-0.266 0-0.525-0.016-0.784-0.047 1.456 0.934 3.181 1.475 5.034 1.475 6.037 0 9.341-5.003 9.341-9.341 0-0.144-0.003-0.284-0.009-0.425 0.641-0.459 1.197-1.038 1.637-1.697z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTelegram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM11.931 5.484l-1.313 6.184c-0.091 0.441-0.356 0.544-0.725 0.341l-2-1.478-0.959 0.934c-0.112 0.109-0.2 0.2-0.4 0.2-0.259 0-0.216-0.097-0.303-0.344l-0.681-2.237-1.978-0.616c-0.428-0.131-0.431-0.425 0.097-0.634l7.706-2.975c0.35-0.159 0.691 0.084 0.556 0.625z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpotify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.559-8-8-8zM11.681 11.559c-0.159 0.241-0.441 0.319-0.681 0.159-1.881-1.159-4.241-1.4-7.041-0.759-0.281 0.081-0.519-0.119-0.6-0.359-0.081-0.281 0.119-0.519 0.359-0.6 3.041-0.681 5.681-0.4 7.759 0.881 0.281 0.119 0.322 0.438 0.203 0.678zM12.641 9.359c-0.2 0.281-0.559 0.4-0.841 0.2-2.159-1.319-5.441-1.719-7.959-0.919-0.319 0.081-0.681-0.081-0.759-0.4-0.081-0.319 0.081-0.681 0.4-0.759 2.919-0.881 6.519-0.441 9 1.081 0.238 0.119 0.359 0.519 0.159 0.797zM12.719 7.119c-2.559-1.519-6.841-1.681-9.281-0.919-0.4 0.119-0.8-0.119-0.919-0.481-0.119-0.4 0.119-0.8 0.481-0.919 2.841-0.841 7.519-0.681 10.481 1.081 0.359 0.2 0.481 0.681 0.281 1.041-0.203 0.278-0.681 0.397-1.044 0.197z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWhatsapp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.641 2.325c-1.497-1.5-3.488-2.325-5.609-2.325-4.369 0-7.925 3.556-7.925 7.928 0 1.397 0.366 2.763 1.059 3.963l-1.125 4.109 4.203-1.103c1.159 0.631 2.463 0.966 3.787 0.966h0.003c0 0 0 0 0 0 4.369 0 7.928-3.556 7.928-7.928 0-2.119-0.825-4.109-2.322-5.609zM8.034 14.525v0c-1.184 0-2.344-0.319-3.356-0.919l-0.241-0.144-2.494 0.653 0.666-2.431-0.156-0.25c-0.663-1.047-1.009-2.259-1.009-3.506 0-3.634 2.956-6.591 6.594-6.591 1.759 0 3.416 0.688 4.659 1.931 1.244 1.247 1.928 2.9 1.928 4.662-0.003 3.637-2.959 6.594-6.591 6.594zM11.647 9.588c-0.197-0.1-1.172-0.578-1.353-0.644s-0.313-0.1-0.447 0.1c-0.131 0.197-0.512 0.644-0.628 0.778-0.116 0.131-0.231 0.15-0.428 0.050s-0.838-0.309-1.594-0.984c-0.588-0.525-0.987-1.175-1.103-1.372s-0.013-0.306 0.088-0.403c0.091-0.088 0.197-0.231 0.297-0.347s0.131-0.197 0.197-0.331c0.066-0.131 0.034-0.247-0.016-0.347s-0.447-1.075-0.609-1.472c-0.159-0.388-0.325-0.334-0.447-0.341-0.116-0.006-0.247-0.006-0.378-0.006s-0.347 0.050-0.528 0.247c-0.181 0.197-0.694 0.678-0.694 1.653s0.709 1.916 0.809 2.050c0.1 0.131 1.397 2.134 3.384 2.991 0.472 0.203 0.841 0.325 1.128 0.419 0.475 0.15 0.906 0.128 1.247 0.078 0.381-0.056 1.172-0.478 1.338-0.941s0.166-0.859 0.116-0.941c-0.047-0.088-0.178-0.137-0.378-0.238z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImInstagram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11 2.5c0-0.275 0.225-0.5 0.5-0.5h2c0.275 0 0.5 0.225 0.5 0.5v2c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-2zM8 5c1.656 0 3 1.344 3 3s-1.344 3-3 3c-1.656 0-3-1.344-3-3s1.344-3 3-3zM14 13.5v0c0 0.275-0.225 0.5-0.5 0.5h-11c-0.275 0-0.5-0.225-0.5-0.5v0-6.5h1.1c-0.066 0.322-0.1 0.656-0.1 1 0 2.762 2.237 5 5 5s5-2.238 5-5c0-0.344-0.034-0.678-0.1-1h1.1v6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFacebook2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h6.5v-7h-2v-2h2v-1c0-1.653 1.347-3 3-3h2v2h-2c-0.55 0-1 0.45-1 1v1h3l-0.5 2h-2.5v7h4.5c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFacebook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 3h2.5v-3h-2.5c-1.93 0-3.5 1.57-3.5 3.5v1.5h-2v3h2v8h3v-8h2.5l0.5-3h-3v-1.5c0-0.271 0.229-0.5 0.5-0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGoogleDrive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.844 10l-2.884 5h9.072l2.884-5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.506 9l-4.619-8h-5.775l4.619 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.534 2l-4.534 7.856 2.888 5 4.534-7.856z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHangouts(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.997 0c-3.816 0-6.909 3.094-6.909 6.909 0 3.616 3.294 6.547 6.909 6.547v2.544c4.197-2.128 6.916-5.556 6.916-9.091 0-3.816-3.1-6.909-6.916-6.909zM7 8c0 0.828-0.447 1.5-1 1.5v-1.5h-2v-3h3v3zM12 8c0 0.828-0.447 1.5-1 1.5v-1.5h-2v-3h3v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGooglePlus3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984 0.394 2.681 1.047l-1.088 1.044c-0.297-0.284-0.816-0.616-1.594-0.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725h-2.269v-1.372h3.778c0.034 0.2 0.063 0.4 0.063 0.663 0 2.287-1.531 3.909-3.841 3.909zM13 8v1h-1v-1h-1v-1h1v-1h1v1h1v1h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGooglePlus2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984 0.394 2.681 1.047l-1.088 1.044c-0.297-0.284-0.816-0.616-1.594-0.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725h-2.269v-1.372h3.778c0.034 0.2 0.063 0.4 0.063 0.663 0 2.287-1.531 3.909-3.841 3.909zM14 8h-1v1h-1v-1h-1v-1h1v-1h1v1h1v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGooglePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.091 7.147v1.747h2.888c-0.116 0.75-0.872 2.197-2.888 2.197-1.737 0-3.156-1.441-3.156-3.216s1.419-3.216 3.156-3.216c0.991 0 1.65 0.422 2.028 0.784l1.381-1.331c-0.888-0.828-2.037-1.331-3.409-1.331-2.816 0.003-5.091 2.278-5.091 5.094s2.275 5.091 5.091 5.091c2.937 0 4.888-2.066 4.888-4.975 0-0.334-0.037-0.591-0.081-0.844h-4.806z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h-1.5v-1.5h-1.5v1.5h-1.5v1.5h1.5v1.5h1.5v-1.5h1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGoogle3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975 0.591 4.019 1.569l-1.628 1.569c-0.447-0.428-1.225-0.925-2.391-0.925-2.050 0-3.719 1.697-3.719 3.787s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588h-3.403v-2.056h5.666c0.050 0.3 0.094 0.6 0.094 0.994 0.003 3.428-2.294 5.863-5.759 5.863z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGoogle2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975 0.591 4.019 1.569l-1.628 1.569c-0.447-0.428-1.225-0.925-2.391-0.925-2.050 0-3.719 1.697-3.719 3.787s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588h-3.403v-2.056h5.666c0.050 0.3 0.094 0.6 0.094 0.994 0.003 3.428-2.294 5.863-5.759 5.863z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGoogle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.159 6.856v2.744h4.537c-0.184 1.178-1.372 3.45-4.537 3.45-2.731 0-4.959-2.262-4.959-5.050s2.228-5.050 4.959-5.050c1.553 0 2.594 0.663 3.188 1.234l2.172-2.091c-1.394-1.306-3.2-2.094-5.359-2.094-4.422 0-8 3.578-8 8s3.578 8 8 8c4.616 0 7.681-3.247 7.681-7.816 0-0.525-0.056-0.925-0.125-1.325l-7.556-0.003z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAmazon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.463 13.831c-1.753 1.294-4.291 1.981-6.478 1.981-3.066 0-5.825-1.131-7.912-3.019-0.163-0.147-0.019-0.35 0.178-0.234 2.253 1.313 5.041 2.1 7.919 2.1 1.941 0 4.075-0.403 6.041-1.238 0.294-0.125 0.544 0.197 0.253 0.409z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.191 13c-0.225-0.287-1.481-0.137-2.047-0.069-0.172 0.019-0.197-0.128-0.044-0.238 1.003-0.703 2.647-0.5 2.838-0.266 0.194 0.238-0.050 1.884-0.991 2.672-0.144 0.122-0.281 0.056-0.219-0.103 0.216-0.528 0.688-1.709 0.463-1.997z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.053 11.838l0.003 0.003c0.387-0.341 1.084-0.95 1.478-1.278 0.156-0.125 0.128-0.334 0.006-0.509-0.353-0.488-0.728-0.884-0.728-1.784v-3c0-1.272 0.088-2.438-0.847-3.313-0.738-0.706-1.963-0.956-2.9-0.956-1.831 0-3.875 0.684-4.303 2.947-0.047 0.241 0.131 0.369 0.287 0.403l1.866 0.203c0.175-0.009 0.3-0.181 0.334-0.356 0.159-0.778 0.813-1.156 1.547-1.156 0.397 0 0.847 0.144 1.081 0.5 0.269 0.397 0.234 0.938 0.234 1.397v0.25c-1.116 0.125-2.575 0.206-3.619 0.666-1.206 0.522-2.053 1.584-2.053 3.147 0 2 1.259 3 2.881 3 1.369 0 2.116-0.322 3.172-1.403 0.35 0.506 0.463 0.753 1.103 1.284 0.147 0.078 0.328 0.072 0.456-0.044zM9.113 7.144c0 0.75 0.019 1.375-0.359 2.041-0.306 0.544-0.791 0.875-1.331 0.875-0.737 0-1.169-0.563-1.169-1.394 0-1.641 1.472-1.938 2.863-1.938v0.416z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMail4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 4h8c0.143 0 0.281 0.031 0.409 0.088l-4.409 5.143-4.409-5.143c0.127-0.058 0.266-0.088 0.409-0.088zM3 11v-6c0-0.021 0.001-0.042 0.002-0.063l2.932 3.421-2.9 2.9c-0.023-0.083-0.034-0.17-0.034-0.258zM12 12h-8c-0.088 0-0.175-0.012-0.258-0.034l2.846-2.846 1.413 1.648 1.413-1.648 2.846 2.846c-0.083 0.023-0.17 0.034-0.258 0.034zM13 11c0 0.088-0.012 0.175-0.034 0.258l-2.9-2.9 2.932-3.421c0.001 0.021 0.002 0.042 0.002 0.063v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMail3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.468 1.2 2.667 2.667 2.667h10.666c1.467 0 2.667-1.199 2.667-2.667v-10.666c0-1.467-1.2-2.667-2.667-2.667zM2.854 13.854l-1.207-1.207 4-4 0.457 0.457-3.25 4.75zM2.396 3.104l0.457-0.457 5.146 4.146 5.146-4.146 0.457 0.457-5.604 6.604-5.604-6.604zM13.146 13.854l-3.25-4.75 0.457-0.457 4 4-1.207 1.207z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMail2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.468 1.2 2.667 2.667 2.667h10.666c1.467 0 2.667-1.199 2.667-2.667v-10.666c0-1.467-1.2-2.667-2.667-2.667zM13.333 2c0.125 0 0.243 0.036 0.344 0.099l-5.678 4.694-5.677-4.694c0.101-0.063 0.219-0.099 0.344-0.099h10.666zM2.667 14c-0.030 0-0.060-0.002-0.089-0.006l3.525-4.89-0.457-0.457-3.646 3.646v-9.549l6 7.256 6-7.256v9.549l-3.646-3.646-0.457 0.457 3.525 4.89c-0.029 0.004-0.059 0.006-0.088 0.006h-10.666z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.467 1.2 2.667 2.667 2.667h10.666c1.468 0 2.667-1.2 2.667-2.667v-10.666c0-1.467-1.199-2.667-2.667-2.667zM4 4h8c0.143 0 0.281 0.031 0.409 0.088l-4.409 5.143-4.409-5.143c0.127-0.058 0.266-0.088 0.409-0.088zM3 11v-6c0-0.021 0.001-0.042 0.002-0.063l2.932 3.421-2.9 2.9c-0.023-0.083-0.034-0.17-0.034-0.258zM12 12h-8c-0.088 0-0.175-0.012-0.258-0.034l2.846-2.846 1.413 1.648 1.413-1.648 2.846 2.846c-0.083 0.023-0.17 0.034-0.258 0.034zM13 11c0 0.088-0.012 0.175-0.034 0.258l-2.9-2.9 2.932-3.421c0.001 0.021 0.002 0.042 0.002 0.063v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImShare2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 11c-0.706 0-1.342 0.293-1.797 0.763l-6.734-3.367c0.021-0.129 0.032-0.261 0.032-0.396s-0.011-0.267-0.032-0.396l6.734-3.367c0.455 0.47 1.091 0.763 1.797 0.763 1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5-2.5 1.119-2.5 2.5c0 0.135 0.011 0.267 0.031 0.396l-6.734 3.367c-0.455-0.47-1.091-0.763-1.797-0.763-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5c0.706 0 1.343-0.293 1.797-0.763l6.734 3.367c-0.021 0.129-0.031 0.261-0.031 0.396 0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5c0-1.381-1.119-2.5-2.5-2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTerminal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1v14h16v-14h-16zM15 14h-14v-12h14v12zM14 3h-12v10h12v-10zM7 8h-1v1h-1v1h-1v-1h1v-1h1v-1h-1v-1h-1v-1h1v1h1v1h1v1zM11 10h-3v-1h3v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEmbed2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 20 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.958 2.352l1.085 0.296-3 11-1.085-0.296 3-11z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEmbed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImNewTab(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 1v12h12v-12h-12zM14 12h-10v-10h10v10zM2 14v-10.5l-1-1v12.5h12.5l-1-1h-10.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5v-6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c0 0 0.919-3 6-3v3l6-4-6-4v3c-4 0-6 2.495-6 5zM11 12h-9v-6h1.967c0.158-0.186 0.327-0.365 0.508-0.534 0.687-0.644 1.509-1.135 2.439-1.466h-6.914v10h13v-4.197l-2 1.333v0.864z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImIndentDecrease(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 7h10v2h-10zM6 10h10v2h-10zM0 13h16v2h-16zM4 5v6l-4-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImIndentIncrease(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 7h10v2h-10zM6 10h10v2h-10zM0 13h16v2h-16zM0 11v-6l4 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImParagraphJustify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM0 4h16v2h-16zM0 7h16v2h-16zM0 10h16v2h-16zM0 13h16v2h-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImParagraphRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImParagraphCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM3 4h10v2h-10zM3 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImParagraphLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM0 4h10v2h-10zM0 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSection(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.749 16c-0.771 0-1.424-0.225-1.939-0.669-0.519-0.447-0.782-0.969-0.782-1.552 0-0.283 0.103-0.527 0.307-0.726 0.207-0.202 0.465-0.309 0.748-0.309 0.281 0 0.534 0.1 0.732 0.29 0.195 0.187 0.294 0.435 0.294 0.736 0 0.177-0.029 0.372-0.086 0.58-0.056 0.206-0.068 0.312-0.068 0.364 0 0.058 0.014 0.126 0.121 0.199 0.199 0.138 0.439 0.204 0.732 0.204 0.353 0 0.667-0.123 0.962-0.375 0.29-0.249 0.431-0.505 0.431-0.782 0-0.308-0.082-0.575-0.252-0.816-0.287-0.402-0.826-0.874-1.603-1.401-1.248-0.835-2.079-1.559-2.54-2.211-0.358-0.511-0.539-1.061-0.539-1.636 0-0.579 0.19-1.155 0.564-1.713 0.32-0.477 0.794-0.908 1.41-1.283-0.33-0.355-0.577-0.689-0.736-0.995-0.201-0.387-0.303-0.787-0.303-1.189 0-0.747 0.295-1.393 0.878-1.92s1.31-0.795 2.161-0.795c0.783 0 1.441 0.22 1.956 0.654 0.521 0.439 0.785 0.952 0.785 1.524 0 0.292-0.109 0.553-0.324 0.776l-0.004 0.004c-0.125 0.124-0.353 0.271-0.735 0.271-0.299 0-0.561-0.098-0.758-0.283-0.196-0.184-0.296-0.405-0.296-0.656 0-0.108 0.027-0.272 0.084-0.515 0.028-0.115 0.042-0.221 0.042-0.316 0-0.162-0.058-0.285-0.183-0.39-0.129-0.108-0.314-0.161-0.565-0.161-0.389 0-0.708 0.118-0.975 0.361s-0.399 0.533-0.399 0.883c0 0.315 0.071 0.574 0.212 0.771 0.267 0.374 0.731 0.778 1.378 1.201 1.315 0.853 2.233 1.636 2.727 2.325 0.365 0.518 0.549 1.068 0.549 1.637 0 0.572-0.186 1.148-0.552 1.714-0.316 0.487-0.793 0.926-1.42 1.308 0.347 0.367 0.591 0.688 0.743 0.977 0.189 0.359 0.284 0.751 0.284 1.165 0 0.776-0.296 1.435-0.879 1.96s-1.31 0.79-2.161 0.79zM6.975 5.568c-0.753 0.452-1.12 0.972-1.12 1.583 0 0.356 0.102 0.674 0.31 0.973 0.311 0.436 0.926 0.97 1.825 1.583 0.381 0.259 0.724 0.511 1.025 0.751 0.767-0.461 1.14-0.974 1.14-1.565 0-0.322-0.127-0.668-0.378-1.030-0.263-0.378-0.826-0.872-1.674-1.467-0.443-0.306-0.821-0.583-1.128-0.827z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRtl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0c-2.209 0-4 1.791-4 4s1.791 4 4 4v8h2v-14h2v14h2v-14h2v-2h-8zM16 3l-4 4 4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLtr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-2.209 0-4 1.791-4 4s1.791 4 4 4v8h2v-14h2v14h2v-14h2v-2h-8zM0 11l4-4-4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPilcrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0h8v2h-2v14h-2v-14h-2v14h-2v-8c-2.209 0-4-1.791-4-4s1.791-4 4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImInsertTemplate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3h2v1h-2zM9 3h2v1h-2zM14 3v4h-3v-1h2v-2h-1v-1zM5 6h2v1h-2zM8 6h2v1h-2zM3 4v2h1v1h-2v-4h3v1zM6 9h2v1h-2zM9 9h2v1h-2zM14 9v4h-3v-1h2v-2h-1v-1zM5 12h2v1h-2zM8 12h2v1h-2zM3 10v2h1v1h-2v-4h3v1zM15 1h-14v14h14v-14zM16 0v0 16h-16v-16h16z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTable2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1v14h16v-14h-16zM6 10v-3h4v3h-4zM10 11v3h-4v-3h4zM10 3v3h-4v-3h4zM5 3v3h-4v-3h4zM1 7h4v3h-4v-3zM11 7h4v3h-4v-3zM11 6v-3h4v3h-4zM1 11h4v3h-4v-3zM11 14v-3h4v3h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3v11h16v-11h-16zM6 10v-2h4v2h-4zM10 11v2h-4v-2h4zM10 5v2h-4v-2h4zM5 5v2h-4v-2h4zM1 8h4v2h-4v-2zM11 8h4v2h-4v-2zM11 7v-2h4v2h-4zM1 11h4v2h-4v-2zM11 13v-2h4v2h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImClearFormatting(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 14h9v2h-9zM14 2h-4.727l-2.871 11h-2.067l2.871-11h-4.205v-2h11zM14.528 16l-2.028-2.028-2.028 2.028-0.972-0.972 2.028-2.028-2.028-2.028 0.972-0.972 2.028 2.028 2.028-2.028 0.972 0.972-2.028 2.028 2.028 2.028z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPagebreak(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6v-6h12v6h-1v-5h-10v5zM16 9v7h-12v-7h1v6h10v-6zM8 7h2v1h-2zM5 7h2v1h-2zM11 7h2v1h-2zM14 7h2v1h-2zM0 4.5l3 3-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTextColor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM7.432 5h1.137l0.9 3h-2.937l0.9-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSubscript2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM5.432 5h1.137l0.9 3h-2.937l0.9-3zM16 3l-2.5 4-2.5-4h5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 13h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.827 0-1.5 0.673-1.5 1.5 0 0.384 0.145 0.734 0.383 1 0.275 0.307 0.674 0.5 1.117 0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.827 0 1.5-0.673 1.5-1.5 0-0.384-0.145-0.734-0.383-1-0.275-0.307-0.674-0.5-1.117-0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSuperscript2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM5.432 5h1.137l0.9 3h-2.937l0.9-3zM11 13l2.5-4 2.5 4h-5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 2h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.827 0-1.5 0.673-1.5 1.5 0 0.384 0.145 0.734 0.383 1 0.275 0.307 0.674 0.5 1.117 0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.827 0 1.5-0.673 1.5-1.5 0-0.384-0.145-0.734-0.383-1-0.275-0.307-0.674-0.5-1.117-0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSubscript(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM10.563 4h-2.125l-2.938 2.938-2.938-2.938h-2.125l4 4-4 4h2.125l2.938-2.938 2.938 2.938h2.125l-4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSuperscript(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM10.563 4h-2.125l-2.938 2.938-2.938-2.938h-2.125l4 4-4 4h2.125l2.938-2.938 2.938 2.938h2.125l-4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPageBreak(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8h2v1h-2zM3 8h3v1h-3zM7 8h2v1h-2zM10 8h3v1h-3zM14 8h2v1h-2zM13.75 0l0.25 7h-12l0.25-7h0.5l0.25 6h10l0.25-6zM2.25 16l-0.25-6h12l-0.25 6h-0.5l-0.25-5h-10l-0.25 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSigma(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.713 11.48l0.694-1.48h0.594l-1 6h-15v-1.16l5.18-6.113-5.18-5.18v-3.547h15.313l0.688 4h-0.537l-0.293-0.607c-0.552-1.146-0.967-1.393-2.17-1.393h-10.344l5.517 5.516-4.647 5.483h8.474c1.813 0 2.291-0.65 2.713-1.52z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImOmega(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h4l1-2v4h-6v-3.347c2.049-0.883 3.5-3.081 3.5-5.653 0-3.35-2.462-5.973-5.5-5.973s-5.5 2.622-5.5 5.973c0 2.572 1.451 4.77 3.5 5.653v3.347h-6v-4l1 2h4v-0.509c-2.932-1.038-5-3.553-5-6.491 0-3.866 3.582-7 8-7s8 3.134 8 7c0 2.938-2.068 5.452-5 6.491v0.509z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStrikethrough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v1h-3.664c0.43 0.602 0.664 1.292 0.664 2 0 1.107-0.573 2.172-1.572 2.921-0.927 0.696-2.145 1.079-3.428 1.079s-2.501-0.383-3.428-1.079c-0.999-0.749-1.572-1.814-1.572-2.921h2c0 1.084 1.374 2 3 2s3-0.916 3-2c0-1.084-1.374-2-3-2h-8v-1h4.68c-0.037-0.026-0.073-0.052-0.108-0.079-0.999-0.749-1.572-1.814-1.572-2.921s0.573-2.172 1.572-2.921c0.927-0.696 2.145-1.079 3.428-1.079s2.501 0.383 3.428 1.079c0.999 0.749 1.572 1.814 1.572 2.921h-2c0-1.084-1.374-2-3-2s-3 0.916-3 2c0 1.084 1.374 2 3 2 1.234 0 2.407 0.354 3.32 1h4.68z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImItalic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1v1h-2l-5 12h2v1h-7v-1h2l5-12h-2v-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUnderline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1h2v6.5c0 2.485-2.239 4.5-5 4.5s-5-2.015-5-4.5v-6.5h2v6.5c0 0.628 0.285 1.23 0.802 1.695 0.577 0.519 1.357 0.805 2.198 0.805s1.621-0.286 2.198-0.805c0.517-0.466 0.802-1.068 0.802-1.695v-6.5zM3 13h10v2h-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBold(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.061 7.573c0.586-0.696 0.939-1.594 0.939-2.573 0-2.206-1.794-4-4-4h-5v14h6c2.206 0 4-1.794 4-4 0-1.452-0.778-2.726-1.939-3.427zM6 3h1.586c0.874 0 1.586 0.897 1.586 2s-0.711 2-1.586 2h-1.586v-4zM8.484 13h-2.484v-4h2.484c0.913 0 1.656 0.897 1.656 2s-0.743 2-1.656 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFontSize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8h6v2h-2v6h-2v-6h-2zM15 4h-3.934v12h-2.133v-12h-3.934v-2h10z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTextWidth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14v2l-3-2.5 3-2.5v2h8v-2l3 2.5-3 2.5v-2zM13 1v4l-1-2h-3v7h2v1h-6v-1h2v-7h-3l-1 2v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTextHeight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12h2l-2.5 3-2.5-3h2v-8h-2l2.5-3 2.5 3h-2zM10 1v4l-1-2h-3v11h2v1h-6v-1h2v-11h-3l-1 2v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLigature2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.364 14.335c-0.183 0-1.307-0.206-1.375-0.458-0.161-0.619-0.183-1.284-0.183-2.040v-8.453c0-1.261 0.252-1.994 0.252-1.994-0.023-0.115-0.138-0.367-0.275-0.367h-0.069c-0.069 0-0.871 0.504-1.605 0.504-0.596-0-0.967-0.527-1.655-0.527-2.892 0-4.249 2.349-4.249 5.672v0.173c0 0.069-0.046 0.138-0.115 0.138h-0.94c-0.115 0-0.344 0.642-0.344 0.94 0 0.092 0.023 0.137 0.069 0.137h1.215c0.069 0 0.115 0.092 0.115 0.16 0 2.040-0.023 4.052-0.023 4.052 0 0.321-0.023 1.031-0.16 1.605-0.069 0.252-1.123 0.458-1.398 0.458-0.115 0-0.115 0.55 0 0.665 0.94-0.046 1.559-0.115 2.499-0.115 0.871 0 1.536 0.069 2.453 0.115 0.046-0.138 0.046-0.665-0.069-0.665-0.183 0-1.307-0.206-1.375-0.458-0.16-0.619-0.16-1.284-0.183-2.040v-3.639c0-0.069 0.069-0.138 0.138-0.138h2.361c0.16-0.321 0.275-0.711 0.275-0.917 0-0.138 0-0.16-0.115-0.16h-2.544c-0.046 0-0.115-0.069-0.115-0.115v-0.825c0-2.040 0.836-3.837 2.234-3.837 0.99 0 1.854 0.642 1.854 3.093 0 0 0 0 0 0 0.003 0.063 0.005 0.114 0.005 0.148v6.825c0 0.321-0.023 1.031-0.16 1.605-0.069 0.252-1.123 0.458-1.398 0.458-0.115 0-0.115 0.55 0 0.665 0.94-0.046 1.559-0.115 2.499-0.115 0.871 0 1.536 0.069 2.453 0.115 0.046-0.137 0.046-0.665-0.069-0.665z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLigature(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.622c0-0.001 0-0.001 0-0.002l-0.005-6.821-1.992 0.097h-3.936v-0.336c0-1.274 0.091-2.546 0.269-3.042 0.123-0.343 0.353-0.652 0.683-0.919 0.322-0.261 0.643-0.393 0.955-0.393 0.262 0 0.48 0.045 0.647 0.134 0.235 0.134 0.464 0.359 0.682 0.669 0.577 0.82 0.812 1.038 0.939 1.131 0.216 0.158 0.477 0.238 0.776 0.238 0.292 0 0.546-0.109 0.757-0.324 0.209-0.213 0.315-0.479 0.315-0.792 0-0.335-0.139-0.691-0.414-1.057-0.268-0.358-0.683-0.652-1.232-0.875-0.536-0.218-1.14-0.329-1.793-0.329-0.949 0-1.813 0.228-2.568 0.678-0.757 0.451-1.337 1.077-1.725 1.863-0.359 0.728-0.333 2.105-0.355 3.355h-1.965v1.116h1.962v5.073c0 1.12-0.342 1.422-0.472 1.583-0.179 0.222-0.509 0.455-0.944 0.455h-0.604v0.878h6.021v-0.878h-0.105c-1.424 0-1.828-0.154-1.828-1.888 0-0 0-0.001 0-0.001l-0.001-5.222h2.191c1.163 0 1.43 0.054 1.491 0.077 0.074 0.028 0.169 0.075 0.204 0.143 0.014 0.026 0.081 0.391 0.081 1.296v3.917c0 0.913-0.111 1.217-0.179 1.319-0.145 0.222-0.319 0.345-0.854 0.358v0.879h4.588v-0.873c-1.431 0-1.588-0.153-1.588-1.505z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFont(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.494 0.253c-1.414 0-2.322-0.253-3.779-0.253-4.708 0-6.903 2.681-6.903 5.404 0 1.604 0.76 2.132 2.259 2.132-0.106-0.232-0.296-0.486-0.296-1.626 0-3.188 1.203-4.117 2.744-4.18 0 0-1.264 12.396-4.934 13.883v0.385h4.947l1.688-8h3.091l0.689-2h-3.358l0.812-3.847c0.929 0.19 1.837 0.38 2.618 0.38 0.971 0 1.858-0.296 2.343-2.533-0.591 0.19-1.224 0.253-1.921 0.253z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFilter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 1.119-8 2.5v1.5l6 6v5c0 0.552 0.895 1 2 1s2-0.448 2-1v-5l6-6v-1.5c0-1.381-3.582-2.5-8-2.5zM1.475 2.169c0.374-0.213 0.9-0.416 1.52-0.586 1.374-0.376 3.152-0.583 5.005-0.583s3.631 0.207 5.005 0.583c0.62 0.17 1.146 0.372 1.52 0.586 0.247 0.141 0.38 0.26 0.442 0.331-0.062 0.071-0.195 0.19-0.442 0.331-0.374 0.213-0.9 0.416-1.52 0.586-1.374 0.376-3.152 0.583-5.005 0.583s-3.631-0.207-5.005-0.583c-0.62-0.17-1.146-0.372-1.52-0.586-0.247-0.141-0.38-0.26-0.442-0.331 0.062-0.071 0.195-0.19 0.442-0.331z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.279 10.62c-1.042-1.628-2.829-2.345-3.992-1.601-0.1 0.064-0.193 0.138-0.277 0.218l-1.241-1.942 2.867-4.5c0.235-0.433 0.321-0.949 0.207-1.468-0.109-0.496-0.383-0.913-0.752-1.207l-0.192-0.122-3.398 5.314-3.398-5.314-0.192 0.122c-0.369 0.294-0.643 0.711-0.752 1.207-0.114 0.519-0.027 1.035 0.207 1.468l2.867 4.5-1.241 1.942c-0.085-0.081-0.177-0.154-0.277-0.218-1.163-0.744-2.95-0.028-3.992 1.601s-0.944 3.551 0.219 4.296c1.163 0.744 2.95 0.028 3.992-1.601l2.567-4.029 2.567 4.029c1.042 1.628 2.829 2.345 3.992 1.601s1.261-2.667 0.219-4.296zM3.67 12.507c-0.469 0.733-1.071 1.089-1.478 1.179-0 0-0 0-0 0-0.133 0.029-0.317 0.047-0.443-0.033-0.139-0.089-0.231-0.324-0.247-0.629-0.025-0.494 0.151-1.076 0.483-1.594 0.469-0.733 1.071-1.089 1.478-1.179 0.133-0.029 0.317-0.047 0.443 0.033 0.139 0.089 0.231 0.324 0.247 0.629 0.025 0.495-0.151 1.076-0.483 1.594zM7.5 8c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM13.498 13.023c-0.016 0.305-0.108 0.54-0.247 0.629-0.125 0.080-0.31 0.062-0.443 0.033 0 0 0 0-0 0-0.407-0.089-1.009-0.446-1.478-1.179-0.332-0.519-0.508-1.1-0.483-1.594 0.016-0.305 0.108-0.54 0.247-0.629 0.125-0.080 0.31-0.062 0.443-0.033 0.407 0.089 1.009 0.446 1.478 1.179 0.332 0.519 0.508 1.1 0.483 1.594z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUngroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.413 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.337-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.412 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.338-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.413 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.337-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.412 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.338-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.251 2.5l1.749-1.749v-0.751h-0.751l-1.749 1.749-1.749-1.749h-0.751v0.751l1.749 1.749-1.749 1.749v0.751h0.751l1.749-1.749 1.749 1.749h0.751v-0.751z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12h1v2h-1v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 9h1v2h-1v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h1v2h-1v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13h1v2h-1v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h1v2h-1v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6h1v2h-1v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h1v2h-1v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 15h2v1h-2v-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMakeGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1zM11 3h2v2h-2v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM5 13h-2v-2h2v2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h-1c-1.336 0-2.591-0.52-3.536-1.464s-1.464-2.2-1.464-3.536v-1c0-1.1-0.9-2-2-2h-4c-1.1 0-2 0.9-2 2v4c0 1.1 0.9 2 2 2h1c1.336 0 2.591 0.52 3.536 1.464s1.464 2.2 1.464 3.536v1c0 1.1 0.9 2 2 2h4c1.1 0 2-0.9 2-2v-4c0-1.1-0.9-2-2-2zM15 14c0 0.265-0.105 0.515-0.295 0.705s-0.44 0.295-0.705 0.295h-4c-0.265 0-0.515-0.105-0.705-0.295s-0.295-0.44-0.295-0.705v-1c0-3.314-2.686-6-6-6h-1c-0.265 0-0.515-0.105-0.705-0.295s-0.295-0.441-0.295-0.705v-4c0-0.265 0.105-0.515 0.295-0.705s0.44-0.295 0.705-0.295h4c0.265 0 0.515 0.105 0.705 0.295s0.295 0.44 0.295 0.705v1c0 3.314 2.686 6 6 6h1c0.265 0 0.515 0.105 0.705 0.295s0.295 0.44 0.295 0.705v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCrop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4l3-3-1-1-3 3h-7v-3h-2v3h-3v2h3v8h8v3h2v-3h3v-2h-3v-7zM5 5h5l-5 5v-5zM6 11l5-5v5h-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRadioUnchecked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRadioChecked2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 10c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRadioChecked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM5 8c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCheckboxUnchecked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM14 14h-12v-12h12v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCheckboxChecked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM7 12.414l-3.707-3.707 1.414-1.414 2.293 2.293 4.793-4.793 1.414 1.414-6.207 6.207z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImOpt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 13h-4c-0.198 0-0.377-0.116-0.457-0.297l-3.868-8.703h-4.675c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.198 0 0.377 0.116 0.457 0.297l3.868 8.703h3.675c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 4h-5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCtrl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7c-0.139 0-0.278-0.058-0.377-0.171l-3.124-3.57-3.124 3.57c-0.182 0.208-0.498 0.229-0.706 0.047s-0.229-0.498-0.047-0.706l3.5-4c0.095-0.108 0.232-0.171 0.376-0.171s0.281 0.062 0.376 0.171l3.5 4c0.182 0.208 0.161 0.524-0.047 0.706-0.095 0.083-0.212 0.124-0.329 0.124z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImShift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 14h-5c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-2c-0.202 0-0.385-0.122-0.462-0.309s-0.035-0.402 0.108-0.545l5-5c0.195-0.195 0.512-0.195 0.707 0l5 5c0.143 0.143 0.186 0.358 0.108 0.545s-0.26 0.309-0.462 0.309h-2v5.5c0 0.276-0.224 0.5-0.5 0.5zM6 13h4v-5.5c0-0.276 0.224-0.5 0.5-0.5h1.293l-3.793-3.793-3.793 3.793h1.293c0.276 0 0.5 0.224 0.5 0.5v5.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCommand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 14c-1.379 0-2.5-1.121-2.5-2.5v-1.5h-2v1.5c0 1.379-1.122 2.5-2.5 2.5s-2.5-1.121-2.5-2.5 1.122-2.5 2.5-2.5h1.5v-2h-1.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5v1.5h2v-1.5c0-1.378 1.121-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5h-1.5v2h1.5c1.379 0 2.5 1.121 2.5 2.5s-1.121 2.5-2.5 2.5zM10 10v1.5c0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5-0.673-1.5-1.5-1.5h-1.5zM4.5 10c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5v-1.5h-1.5zM7 9h2v-2h-2v2zM10 6h1.5c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5-1.5 0.673-1.5 1.5v1.5zM4.5 3c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5h1.5v-1.5c0-0.827-0.673-1.5-1.5-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSortAmountDesc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0h9v2h-9v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3h7v2h-7v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h5v2h-5v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h3v2h-3v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSortAmountAsc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h9v2h-9v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h7v2h-7v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3h5v2h-5v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0h3v2h-3v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSortNumbericDesc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 16c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v6c0 0.276-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2.5v2h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM12 1h2v2h-2v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSortNumericAsc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 7c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v6c0 0.276-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 9h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2.5v2h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM12 10h2v2h-2v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSortAlphaDesc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 7h-4c-0.184 0-0.354-0.101-0.441-0.264s-0.077-0.36 0.025-0.513l3.482-5.223h-3.066c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.184 0 0.354 0.102 0.441 0.264s0.077 0.36-0.025 0.513l-3.482 5.223h3.066c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.947 15.276l-3-6c-0.085-0.169-0.258-0.276-0.447-0.276s-0.363 0.107-0.447 0.276l-3 6c-0.123 0.247-0.023 0.547 0.224 0.671 0.072 0.036 0.148 0.053 0.223 0.053 0.183 0 0.36-0.101 0.448-0.277l0.862-1.724h3.382l0.862 1.724c0.123 0.247 0.424 0.347 0.671 0.224s0.347-0.424 0.224-0.671zM11.309 13l1.191-2.382 1.191 2.382h-2.382z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSortAlphaAsc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 16h-4c-0.184 0-0.354-0.101-0.441-0.264s-0.077-0.36 0.025-0.513l3.482-5.223h-3.066c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.184 0 0.354 0.101 0.441 0.264s0.077 0.36-0.025 0.513l-3.482 5.223h3.066c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.947 6.276l-3-6c-0.085-0.169-0.258-0.276-0.447-0.276s-0.363 0.107-0.447 0.276l-3 6c-0.123 0.247-0.023 0.547 0.224 0.671 0.072 0.036 0.148 0.053 0.223 0.053 0.183 0 0.36-0.101 0.448-0.277l0.862-1.724h3.382l0.862 1.724c0.123 0.247 0.424 0.347 0.671 0.224s0.347-0.424 0.224-0.671zM11.309 4l1.191-2.382 1.191 2.382h-2.382z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMoveDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11v-6h-1v6h-2.5l3 3 3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4v3h-3v-3h3zM6 3h-5v5h5v-5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 10h1.5v1h-1.5v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h1.5v1h-1.5v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h1v1.5h-1v-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13.5h1v1.5h-1v-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 14h1.5v1h-1.5v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 14h1.5v1h-1.5v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11.5h1v1.5h-1v-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12h1v1.5h-1v-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMoveUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8v6h1v-6h2.5l-3-3-3 3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3h1.5v1h-1.5v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h1.5v1h-1.5v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3h1v1.5h-1v-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6.5h1v1.5h-1v-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 7h1.5v1h-1.5v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 7h1.5v1h-1.5v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 4.5h1v1.5h-1v-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h1v1.5h-1v-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11v3h-3v-3h3zM6 10h-5v5h5v-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTab(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0h1v8h-1v-8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8h1v8h-1v-8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h11v2h-11v2.5l-3.5-3.5 3.5-3.5v2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5h-11v-2h11v-2.5l3.5 3.5-3.5 3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.457 4.957l-1.414-1.414-4.457 4.457 4.457 4.457 1.414-1.414-3.043-3.043z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8 3.582 8 8 8 8-3.582 8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.957 5.543l-1.414 1.414 4.457 4.457 4.457-4.457-1.414-1.414-3.043 3.043z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.543 11.043l1.414 1.414 4.457-4.457-4.457-4.457-1.414 1.414 3.043 3.043z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM14.5 8c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.043 10.457l1.414-1.414-4.457-4.457-4.457 4.457 1.414 1.414 3.043-3.043z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowLeft2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.293 13.707l-5-5c-0.391-0.39-0.391-1.024 0-1.414l5-5c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-3.293 3.293h9.586c0.552 0 1 0.448 1 1s-0.448 1-1 1h-9.586l3.293 3.293c0.195 0.195 0.293 0.451 0.293 0.707s-0.098 0.512-0.293 0.707c-0.391 0.391-1.024 0.391-1.414 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowDownLeft2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.293 2.293l-8.293 8.293v-3.586c0-0.552-0.448-1-1-1s-1 0.448-1 1v6c0 0.404 0.244 0.769 0.617 0.924 0.124 0.051 0.254 0.076 0.383 0.076v0.001l6-0c0.552 0 1-0.448 1-1s-0.448-1-1-1h-3.586l8.293-8.293c0.195-0.195 0.293-0.451 0.293-0.707s-0.098-0.512-0.293-0.707c-0.39-0.391-1.024-0.391-1.414 0v0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowDown2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 9.707l-5 5c-0.39 0.391-1.024 0.391-1.414 0l-5-5c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l3.293 3.293v-9.586c0-0.552 0.448-1 1-1s1 0.448 1 1v9.586l3.293-3.293c0.195-0.195 0.451-0.293 0.707-0.293s0.512 0.098 0.707 0.293c0.391 0.391 0.391 1.024 0 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowDownRight2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.293 3.707l8.293 8.293h-3.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h6c0.404 0 0.769-0.244 0.924-0.617 0.051-0.124 0.076-0.254 0.076-0.383h0.001v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v3.586l-8.293-8.293c-0.195-0.195-0.451-0.293-0.707-0.293s-0.512 0.098-0.707 0.293c-0.391 0.39-0.391 1.024 0 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowRight2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707l5-5c0.391-0.39 0.391-1.024 0-1.414l-5-5c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l3.293 3.293h-9.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h9.586l-3.293 3.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.391 0.391 1.024 0.391 1.414 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowUpRight2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.707 13.707l8.293-8.293v3.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.404-0.244-0.769-0.617-0.924-0.124-0.051-0.254-0.076-0.383-0.076v-0.001h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h3.586l-8.293 8.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.39 0.391 1.024 0.391 1.414 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowUp2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 6.293l-5-5c-0.39-0.391-1.024-0.391-1.414 0l-5 5c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l3.293-3.293v9.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-9.586l3.293 3.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.024 0-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowUpLeft2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 12.293l-8.293-8.293h3.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-6c-0.404 0-0.769 0.244-0.924 0.617-0.051 0.124-0.076 0.254-0.076 0.383h-0.001v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-3.586l8.293 8.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.39 0.391-1.024 0-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.5 8l7.5 7.5v-4.5h8v-6h-8v-4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowDownLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 16l-4-4 8.5-8.5-3.5-3.5-8.5 8.5-4-4v11.5h11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15.5l7.5-7.5h-4.5v-8h-6v8h-4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowDownRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4.5l-4 4-8.5-8.5-3.5 3.5 8.5 8.5-4 4h11.5v-11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 8l-7.5-7.5v4.5h-8v6h8v4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 0l4 4-8.5 8.5 3.5 3.5 8.5-8.5 4 4v-11.5h-11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0.5l-7.5 7.5h4.5v8h6v-8h4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImArrowUpLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 11.5l4-4 8.5 8.5 3.5-3.5-8.5-8.5 4-4h-11.5v11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImShuffle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11h-1.586l-2.5-2.5 2.5-2.5h1.586v2.5l3.5-3.5-3.5-3.5v2.5h-2c-0.265 0-0.52 0.105-0.707 0.293l-2.793 2.793-2.793-2.793c-0.188-0.188-0.442-0.293-0.707-0.293h-3v2h2.586l2.5 2.5-2.5 2.5h-2.586v2h3c0.265 0 0.52-0.105 0.707-0.293l2.793-2.793 2.793 2.793c0.188 0.188 0.442 0.293 0.707 0.293h2v2.5l3.5-3.5-3.5-3.5v2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImInfinite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.25 11.75c-1.002 0-1.943-0.39-2.652-1.098l-1.598-1.598-1.598 1.598c-0.708 0.708-1.65 1.098-2.652 1.098s-1.944-0.39-2.652-1.098c-0.708-0.708-1.098-1.65-1.098-2.652s0.39-1.943 1.098-2.652c0.708-0.708 1.65-1.098 2.652-1.098s1.943 0.39 2.652 1.098l1.598 1.598 1.598-1.598c0.708-0.708 1.65-1.098 2.652-1.098s1.944 0.39 2.652 1.098c0.708 0.708 1.098 1.65 1.098 2.652s-0.39 1.943-1.098 2.652c-0.708 0.708-1.65 1.098-2.652 1.098zM10.652 9.598c0.427 0.427 0.994 0.662 1.598 0.662s1.171-0.235 1.598-0.662c0.427-0.427 0.662-0.994 0.662-1.598s-0.235-1.171-0.662-1.598c-0.427-0.427-0.994-0.662-1.598-0.662s-1.171 0.235-1.598 0.662l-1.598 1.598 1.598 1.598zM3.75 5.74c-0.604 0-1.171 0.235-1.598 0.662s-0.662 0.994-0.662 1.598c0 0.604 0.235 1.171 0.662 1.598s0.994 0.662 1.598 0.662c0.604 0 1.171-0.235 1.598-0.662l1.598-1.598-1.598-1.598c-0.427-0.427-0.994-0.662-1.598-0.662v0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLoop2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.901 2.599c-1.463-1.597-3.565-2.599-5.901-2.599-4.418 0-8 3.582-8 8h1.5c0-3.59 2.91-6.5 6.5-6.5 1.922 0 3.649 0.835 4.839 2.161l-2.339 2.339h5.5v-5.5l-2.099 2.099z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 8c0 3.59-2.91 6.5-6.5 6.5-1.922 0-3.649-0.835-4.839-2.161l2.339-2.339h-5.5v5.5l2.099-2.099c1.463 1.597 3.565 2.599 5.901 2.599 4.418 0 8-3.582 8-8h-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLoop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5h10v3l4-4-4-4v3h-12v6h2zM14 11h-10v-3l-4 4 4 4v-3h12v-6h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVolumeDecrease(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h8v2h-8v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVolumeIncrease(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVolumeMute2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.674v1.326h-1.326l-1.674-1.674-1.674 1.674h-1.326v-1.326l1.674-1.674-1.674-1.674v-1.326h1.326l1.674 1.674 1.674-1.674h1.326v1.326l-1.674 1.674 1.674 1.674z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVolumeMute(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVolumeLow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVolumeMedium(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.243 12.993c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.047-2.047 2.047-5.378 0-7.425-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773c-0.146 0.146-0.338 0.22-0.53 0.22v0zM8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVolumeHigh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 17 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.907 14.407c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.369-1.369 2.123-3.19 2.123-5.127s-0.754-3.757-2.123-5.127c-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.653 1.653 2.563 3.85 2.563 6.187s-0.91 4.534-2.563 6.187c-0.146 0.146-0.338 0.22-0.53 0.22zM11.243 12.993c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.047-2.047 2.047-5.378 0-7.425-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773c-0.146 0.146-0.338 0.22-0.53 0.22v0zM8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12h16v2h-16zM8 2l8 8h-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImNext2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v12h-2v-5.5l-5 5v-11l5 5v-5.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPrevious2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14v-12h2v5.5l5-5v11l-5-5v5.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v12h-2v-5.5l-5 5v-5l-5 5v-11l5 5v-5l5 5v-5.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFirst(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14v-12h2v5.5l5-5v5l5-5v11l-5-5v5l-5-5v5.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImForward3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13.5v-5l-5 5v-11l5 5v-5l5.5 5.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBackward2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2.5v5l5-5v11l-5-5v5l-5.5-5.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStop2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h12v12h-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPause2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h5v12h-5zM9 2h5v12h-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPlay3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2l10 6-10 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImForward2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5.5l3.5 2.5-3.5 2.5zM9 5.5l3.5 2.5-3.5 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11 10.5l-3.5-2.5 3.5-2.5zM7 10.5l-3.5-2.5 3.5-2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImNext(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zM8 14.5c3.59 0 6.5-2.91 6.5-6.5s-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5 2.91 6.5 6.5 6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8l-4-3v6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5h-2v6h2v-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPrevious(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8l4-3v6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v6h-2v-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h6v6h-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h2v6h-2zM9 5h2v6h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPlay2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM6 4.5l6 3.5-6 3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImExit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v-2h-5v-2h5v-2l3 3zM11 9v4h-5v3l-6-3v-13h11v5h-1v-4h-8l4 2v9h4v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEnter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h-5v-2h5v-2l3 3-3 3zM16 0v13l-6 3v-3h-6v-4h1v3h5v-9l4-2h-9v4h-1v-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpellCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4h2v3h1v-6c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v6h1v-3zM2 1h2v2h-2v-2zM15 1v-1h-3c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v-1h-3v-5h3zM10 2.5v-1.5c0-0.55-0.45-1-1-1h-3v7h3c0.55 0 1-0.45 1-1v-1.5c0-0.55-0.137-1-0.688-1 0.55 0 0.688-0.45 0.688-1zM9 6h-2v-2h2v2zM9 3h-2v-2h2v2zM13 9l-6.5 7-3.5-4.5 1.281-1.094 2.219 2.313 5.5-4.719z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCheckmark2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.21 14.339l-6.217-6.119 3.084-3.035 3.133 3.083 6.713-6.607 3.084 3.035-9.797 9.643zM1.686 8.22l4.524 4.453 8.104-7.976-1.391-1.369-6.713 6.607-3.133-3.083-1.391 1.369z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCheckmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 2l-7.5 7.5-3.5-3.5-2.5 2.5 6 6 10-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCross(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.854 12.854c-0-0-0-0-0-0l-4.854-4.854 4.854-4.854c0-0 0-0 0-0 0.052-0.052 0.090-0.113 0.114-0.178 0.066-0.178 0.028-0.386-0.114-0.529l-2.293-2.293c-0.143-0.143-0.351-0.181-0.529-0.114-0.065 0.024-0.126 0.062-0.178 0.114 0 0-0 0-0 0l-4.854 4.854-4.854-4.854c-0-0-0-0-0-0-0.052-0.052-0.113-0.090-0.178-0.114-0.178-0.066-0.386-0.029-0.529 0.114l-2.293 2.293c-0.143 0.143-0.181 0.351-0.114 0.529 0.024 0.065 0.062 0.126 0.114 0.178 0 0 0 0 0 0l4.854 4.854-4.854 4.854c-0 0-0 0-0 0-0.052 0.052-0.090 0.113-0.114 0.178-0.066 0.178-0.029 0.386 0.114 0.529l2.293 2.293c0.143 0.143 0.351 0.181 0.529 0.114 0.065-0.024 0.126-0.062 0.178-0.114 0-0 0-0 0-0l4.854-4.854 4.854 4.854c0 0 0 0 0 0 0.052 0.052 0.113 0.090 0.178 0.114 0.178 0.066 0.386 0.029 0.529-0.114l2.293-2.293c0.143-0.143 0.181-0.351 0.114-0.529-0.024-0.065-0.062-0.126-0.114-0.178z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBlocked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.657 2.343c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343c-1.511 1.511-2.343 3.52-2.343 5.657s0.832 4.146 2.343 5.657c1.511 1.511 3.52 2.343 5.657 2.343s4.146-0.832 5.657-2.343c1.511-1.511 2.343-3.52 2.343-5.657s-0.832-4.146-2.343-5.657zM14 8c0 1.294-0.412 2.494-1.111 3.475l-8.364-8.364c0.981-0.699 2.181-1.111 3.475-1.111 3.308 0 6 2.692 6 6zM2 8c0-1.294 0.412-2.494 1.111-3.475l8.364 8.364c-0.981 0.699-2.181 1.111-3.475 1.111-3.308 0-6-2.692-6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCancelCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 4l-2.5 2.5-2.5-2.5-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 2.5-2.5 2.5 2.5 1.5-1.5-2.5-2.5 2.5-2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImInfo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12h-4v-1h1v-3h-1v-1h3v4h1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6.5v3c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-15c-0.276 0-0.5 0.224-0.5 0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 6h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImQuestion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h2v2h-2zM11 4c0.552 0 1 0.448 1 1v3l-3 2h-2v-1l3-2v-1h-5v-2h6zM8 1.5c-1.736 0-3.369 0.676-4.596 1.904s-1.904 2.86-1.904 4.596c0 1.736 0.676 3.369 1.904 4.596s2.86 1.904 4.596 1.904c1.736 0 3.369-0.676 4.596-1.904s1.904-2.86 1.904-4.596c0-1.736-0.676-3.369-1.904-4.596s-2.86-1.904-4.596-1.904zM8 0v0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.418 0-8-3.582-8-8s3.582-8 8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImNotification(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.5c-1.736 0-3.369 0.676-4.596 1.904s-1.904 2.86-1.904 4.596c0 1.736 0.676 3.369 1.904 4.596s2.86 1.904 4.596 1.904c1.736 0 3.369-0.676 4.596-1.904s1.904-2.86 1.904-4.596c0-1.736-0.676-3.369-1.904-4.596s-2.86-1.904-4.596-1.904zM8 0v0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.418 0-8-3.582-8-8s3.582-8 8-8zM7 11h2v2h-2zM7 3h2v6h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWarning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.45l6.705 13.363h-13.409l6.705-13.363zM8 0c-0.345 0-0.69 0.233-0.951 0.698l-6.829 13.611c-0.523 0.93-0.078 1.691 0.989 1.691h13.583c1.067 0 1.512-0.761 0.989-1.691h0l-6.829-13.611c-0.262-0.465-0.606-0.698-0.951-0.698v0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11c-0.552 0-1-0.448-1-1v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3c0 0.552-0.448 1-1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPointLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 15h-2.5c-0.827 0-1.5-0.673-1.5-1.5 0-0.267 0.070-0.518 0.193-0.736-0.417-0.267-0.693-0.734-0.693-1.264 0-0.384 0.145-0.734 0.383-1-0.238-0.266-0.383-0.616-0.383-1 0-0.175 0.030-0.344 0.086-0.5h-3.586c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h6.167l-1.466-2.75c-0.131-0.227-0.201-0.486-0.201-0.75 0-0.827 0.673-1.5 1.5-1.5 0.412 0 0.796 0.164 1.082 0.461 0.004 0.004 0.007 0.008 0.011 0.012l3.407 3.737v-0.71c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v10c0 0.276-0.224 0.5-0.5 0.5h-3c-0.276 0-0.5-0.224-0.5-0.5v-0.691l-2.276 1.138c-0.069 0.035-0.146 0.053-0.224 0.053zM13.5 14c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5zM9.382 14l2.618-1.309v-5.997l-4.143-4.544c-0.095-0.097-0.221-0.15-0.357-0.15-0.276 0-0.5 0.224-0.5 0.5 0 0.085 0.020 0.166 0.061 0.239 0.005 0.008 0.010 0.017 0.014 0.025l1.866 3.5c0.083 0.155 0.078 0.342-0.012 0.492s-0.253 0.243-0.429 0.243h-7c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.382z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPointDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6.5v2.5c0 0.827-0.673 1.5-1.5 1.5-0.267 0-0.518-0.070-0.736-0.193-0.267 0.417-0.734 0.693-1.264 0.693-0.384 0-0.734-0.145-1-0.383-0.266 0.238-0.616 0.383-1 0.383-0.175 0-0.344-0.030-0.5-0.086v3.586c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5v-6.167l-2.75 1.466c-0.227 0.131-0.486 0.201-0.75 0.201-0.827 0-1.5-0.673-1.5-1.5 0-0.412 0.164-0.796 0.461-1.082 0.004-0.004 0.008-0.007 0.012-0.011l3.737-3.407h-0.71c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5h10c0.276 0 0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5h-0.691l1.138 2.276c0.035 0.069 0.053 0.146 0.053 0.224zM14 2.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5 0.5-0.224 0.5-0.5zM14 6.618l-1.309-2.618h-5.997l-4.544 4.143c-0.097 0.095-0.15 0.221-0.15 0.357 0 0.276 0.224 0.5 0.5 0.5 0.085 0 0.166-0.020 0.239-0.061 0.008-0.005 0.017-0.010 0.025-0.014l3.5-1.866c0.155-0.083 0.342-0.078 0.492 0.013s0.243 0.253 0.243 0.429v7c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.382z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPointRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15h2.5c0.827 0 1.5-0.673 1.5-1.5 0-0.267-0.070-0.518-0.193-0.736 0.417-0.267 0.693-0.734 0.693-1.264 0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1 0-0.175-0.030-0.344-0.086-0.5h3.586c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5h-6.167l1.466-2.75c0.131-0.227 0.201-0.486 0.201-0.75 0-0.827-0.673-1.5-1.5-1.5-0.412 0-0.796 0.164-1.082 0.461-0.004 0.004-0.007 0.008-0.011 0.012l-3.407 3.737v-0.71c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-0.691l2.276 1.138c0.069 0.035 0.146 0.053 0.224 0.053zM2.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM6.618 14l-2.618-1.309v-5.997l4.143-4.544c0.095-0.097 0.221-0.15 0.357-0.15 0.276 0 0.5 0.224 0.5 0.5 0 0.085-0.020 0.166-0.061 0.239-0.005 0.008-0.010 0.017-0.014 0.025l-1.866 3.5c-0.083 0.155-0.078 0.342 0.013 0.492s0.253 0.243 0.429 0.243h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2.382z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPointUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.5v-2.5c0-0.827-0.673-1.5-1.5-1.5-0.267 0-0.518 0.070-0.736 0.193-0.267-0.417-0.734-0.693-1.264-0.693-0.384 0-0.734 0.145-1 0.383-0.266-0.238-0.616-0.383-1-0.383-0.175 0-0.344 0.030-0.5 0.086v-3.586c0-0.827-0.673-1.5-1.5-1.5s-1.5 0.673-1.5 1.5v6.167l-2.75-1.466c-0.227-0.131-0.486-0.201-0.75-0.201-0.827 0-1.5 0.673-1.5 1.5 0 0.412 0.164 0.796 0.461 1.082 0.004 0.004 0.008 0.007 0.012 0.011l3.737 3.407h-0.71c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h10c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-0.691l1.138-2.276c0.035-0.069 0.053-0.146 0.053-0.224zM14 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM14 9.382l-1.309 2.618h-5.997l-4.544-4.143c-0.097-0.095-0.15-0.221-0.15-0.357 0-0.276 0.224-0.5 0.5-0.5 0.085 0 0.166 0.020 0.239 0.061 0.008 0.005 0.017 0.010 0.025 0.014l3.5 1.866c0.155 0.083 0.342 0.078 0.492-0.012s0.243-0.253 0.243-0.429v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2.382z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCrying2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM5 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM5.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM9.854 13.229c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.072-0.072-0.46-0.229-1.146-0.229s-1.075 0.157-1.146 0.229c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.471-0.471 1.453-0.521 1.854-0.521s1.383 0.051 1.854 0.521c0.195 0.195 0.195 0.512 0 0.707zM12 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM12 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM12.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCrying(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 13.375c-0.128 0-0.256-0.049-0.354-0.146-0.072-0.072-0.46-0.229-1.146-0.229s-1.075 0.157-1.146 0.229c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.471-0.471 1.453-0.521 1.854-0.521s1.383 0.051 1.854 0.521c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 9c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFrustrated2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.25v1.5c0 0.136 0.114 0.25 0.25 0.25h1.75v-2h-1.75c-0.136 0-0.25 0.114-0.25 0.25z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h2v2h-2v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.75 10h-1.75v2h1.75c0.136 0 0.25-0.114 0.25-0.25v-1.5c0-0.136-0.114-0.25-0.25-0.25z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9.002 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM13 11.75c0 0.689-0.561 1.25-1.25 1.25h-7.5c-0.689 0-1.25-0.561-1.25-1.25v-1.5c0-0.689 0.561-1.25 1.25-1.25h7.5c0.689 0 1.25 0.561 1.25 1.25v1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFrustrated(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.724 4.428c-0.543-0.271-1.080-0.407-1.102-0.413-0.268-0.067-0.539 0.096-0.606 0.364s0.096 0.539 0.364 0.606c0.275 0.070 0.602 0.189 0.89 0.334-0.166 0.179-0.268 0.418-0.268 0.681 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.018-0.001-0.036-0.002-0.054-0.032-0.741-0.706-1.234-1.275-1.518z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM3.695 12.87c0.167 0.083 0.356 0.13 0.555 0.13h7.5c0.199 0 0.387-0.047 0.555-0.13-1.147 1.014-2.654 1.63-4.305 1.63s-3.158-0.616-4.305-1.63zM4 11.75v-1.5c0-0.136 0.114-0.25 0.25-0.25h1.75v2h-1.75c-0.136 0-0.25-0.114-0.25-0.25zM7 12v-2h2v2h-2zM10 12v-2h1.75c0.136 0 0.25 0.114 0.25 0.25v1.5c0 0.136-0.114 0.25-0.25 0.25h-1.75zM12.87 12.305c0.083-0.167 0.13-0.356 0.13-0.555v-1.5c0-0.689-0.561-1.25-1.25-1.25h-7.5c-0.689 0-1.25 0.561-1.25 1.25v1.5c0 0.199 0.047 0.387 0.13 0.555-1.014-1.147-1.63-2.654-1.63-4.305 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 1.651-0.616 3.158-1.63 4.305z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.379 4.015c-0.023 0.006-0.559 0.141-1.102 0.413-0.568 0.284-1.243 0.776-1.275 1.518-0.001 0.018-0.002 0.036-0.002 0.054 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.263-0.102-0.503-0.268-0.681 0.288-0.144 0.614-0.264 0.89-0.334 0.268-0.067 0.431-0.338 0.364-0.606s-0.338-0.431-0.606-0.364z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSleepy2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.854 5.166c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.302-0.302-0.991-0.302-1.293 0zM8 13c-1.105 0-2-1.119-2-2.5s0.895-2.5 2-2.5 2 1.119 2 2.5-0.895 2.5-2 2.5zM11.854 5.166c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSleepy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.5c0 1.381-0.895 2.5-2 2.5s-2-1.119-2-2.5c0-1.381 0.895-2.5 2-2.5s2 1.119 2 2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 5.313c-0.128 0-0.256-0.049-0.354-0.146-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 5.313c-0.128 0-0.256-0.049-0.354-0.146-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWondering2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM5.176 12.6l-0.351-1.2 6.828-2 0.351 1.2-6.828 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWondering(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11.652 9.4l0.351 1.2-6.828 2-0.351-1.2zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHipster2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8.497 10.615c-0.020-0.018-0.039-0.036-0.058-0.055-0.293-0.293-0.439-0.677-0.439-1.060-0 0.384-0.146 0.768-0.439 1.060-0.019 0.019-0.038 0.037-0.058 0.055-1.352 1.227-4.503-0.029-4.503-1.615 0.969 0.625 1.726 0.153 2.439-0.561 0.586-0.586 1.536-0.586 2.121 0 0.293 0.293 0.439 0.677 0.439 1.060 0-0.384 0.146-0.768 0.439-1.060 0.586-0.586 1.536-0.586 2.121 0 0.713 0.714 1.471 1.186 2.439 0.561 0 1.586-3.151 2.842-4.503 1.615z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHipster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.561 8.439c-0.586-0.586-1.536-0.586-2.121 0s-0.586 1.536 0 2.121c0.019 0.019 0.038 0.037 0.058 0.055 1.352 1.227 4.503-0.029 4.503-1.615-0.969 0.625-1.726 0.153-2.439-0.561z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.439 8.439c0.586-0.586 1.536-0.586 2.121 0s0.586 1.536 0 2.121c-0.019 0.019-0.038 0.037-0.058 0.055-1.352 1.227-4.503-0.029-4.503-1.615 0.969 0.625 1.726 0.153 2.439-0.561z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImNeutral2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM10 12h-4v-1h4v1zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImNeutral(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1-1 0.448-1 1zM10 5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1-1 0.448-1 1zM6 11h4v1h-4v-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImConfused2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM10.735 12.665c-1.295 0.472-2.733-0.199-3.204-1.494-0.283-0.777-1.145-1.179-1.923-0.896-0.712 0.259-1.109 1.005-0.953 1.725h-1.013c-0.144-1.133 0.507-2.258 1.624-2.665 1.295-0.472 2.733 0.199 3.204 1.494 0.283 0.777 1.145 1.179 1.923 0.896 0.712-0.259 1.109-1.005 0.953-1.725h1.014c0.144 1.133-0.507 2.258-1.624 2.665z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImConfused(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.345 10h1.014c0.144 1.133-0.507 2.258-1.624 2.665-1.295 0.472-2.733-0.199-3.204-1.494-0.283-0.777-1.145-1.179-1.923-0.896-0.712 0.259-1.109 1.005-0.953 1.725h-1.013c-0.144-1.133 0.507-2.258 1.624-2.665 1.295-0.472 2.733 0.199 3.204 1.494 0.283 0.777 1.145 1.179 1.923 0.896 0.712-0.259 1.109-1.005 0.953-1.725z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBaffled2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 6.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5zM10 12h-4v-1h4v1zM10.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBaffled(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM5.5 4c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5v0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM10.5 4c-1.379 0-2.5 1.122-2.5 2.5s1.121 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.121-2.5-2.5-2.5v0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11h4v1h-4v-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImShocked2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 7c-0.552 0-1-0.672-1-1.5s0.448-1.5 1-1.5 1 0.672 1 1.5-0.448 1.5-1 1.5zM8 13c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2zM11 7c-0.552 0-1-0.672-1-1.5s0.448-1.5 1-1.5 1 0.672 1 1.5-0.448 1.5-1 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImShocked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM6 11c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM4 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEvil2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1c0-0.711-0.149-1.387-0.416-2-0.525 1.201-1.507 2.155-2.726 2.643-1.347-1.031-3.030-1.643-4.857-1.643s-3.51 0.613-4.857 1.643c-1.22-0.488-2.202-1.443-2.726-2.643-0.268 0.613-0.416 1.289-0.416 2 0 1.15 0.388 2.208 1.040 3.053-0.662 1.165-1.040 2.512-1.040 3.947 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.436-0.378-2.783-1.040-3.947 0.652-0.845 1.040-1.903 1.040-3.053zM9.001 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM8 13c-1.82 0-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEvil(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7c-0.552 0-1-0.448-1-1 0-0.018 0.001-0.036 0.002-0.054 0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1zM4.379 4.985c-0.268-0.067-0.431-0.338-0.364-0.606s0.338-0.431 0.606-0.364c0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334zM8 11.5c1.274 0 2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427s-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699zM16 1c0-0.711-0.149-1.387-0.416-2-0.525 1.201-1.507 2.155-2.726 2.643-1.347-1.031-3.030-1.643-4.857-1.643s-3.51 0.613-4.857 1.643c-1.22-0.488-2.202-1.443-2.726-2.643-0.268 0.613-0.416 1.289-0.416 2 0 1.15 0.388 2.208 1.040 3.053-0.662 1.165-1.040 2.512-1.040 3.947 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.436-0.378-2.783-1.040-3.947 0.652-0.845 1.040-1.903 1.040-3.053zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAngry2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9.001 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAngry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772zM11.985 4.379c0.067 0.268-0.096 0.539-0.364 0.606-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054 0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCool2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM8 13c-0.757 0-1.475-0.169-2.118-0.47l0.518-0.864c0.49 0.214 1.031 0.334 1.6 0.334 1.456 0 2.731-0.778 3.43-1.942l0.858 0.515c-0.874 1.454-2.467 2.427-4.288 2.427zM13 6c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1h-2c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h2v-0.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM12.5 4c0.275 0 0.5 0.225 0.5 0.5v1.5c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1h-2c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h2v-0.5c0-0.275 0.225-0.5 0.5-0.5h3zM8 12c1.456 0 2.731-0.778 3.43-1.942l0.857 0.515c-0.874 1.454-2.467 2.427-4.288 2.427-0.757 0-1.475-0.169-2.118-0.47l0.518-0.864c0.49 0.214 1.031 0.334 1.6 0.334z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGrin2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 3.688c0.999 0 1.813 0.813 1.813 1.813 0 0.1-0.009 0.201-0.025 0.302-0.025 0.151-0.156 0.261-0.308 0.261s-0.283-0.11-0.308-0.261c-0.096-0.573-0.589-0.833-1.171-0.833s-1.074 0.26-1.171 0.833c-0.025 0.151-0.156 0.261-0.308 0.261-0 0 0 0-0 0-0.153 0-0.283-0.11-0.308-0.261-0.017-0.101-0.025-0.202-0.025-0.302 0-0.999 0.813-1.813 1.813-1.813zM5 3.688c0.999 0 1.813 0.813 1.813 1.813 0 0.1-0.009 0.201-0.025 0.302-0.025 0.151-0.156 0.261-0.308 0.261s-0.283-0.11-0.308-0.261c-0.096-0.573-0.589-0.833-1.171-0.833s-1.074 0.26-1.171 0.833c-0.025 0.151-0.156 0.261-0.308 0.261 0 0 0 0 0 0-0.153 0-0.283-0.11-0.308-0.261-0.017-0.101-0.025-0.202-0.025-0.302 0-0.999 0.813-1.813 1.813-1.813zM3 9h3v3.873c-1.72-0.447-3-2.018-3-3.873zM7 13v-4h2v4h-2zM10 12.873v-3.873h3c0 1.855-1.28 3.426-3 3.873z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGrin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM3 8v1c0 2.2 1.8 4 4 4h2c2.2 0 4-1.8 4-4v-1h-10zM6 11.828c-0.415-0.148-0.796-0.388-1.118-0.71-0.569-0.569-0.882-1.321-0.882-2.118h2v2.828zM9 12h-2v-3h2v3zM11.118 11.118c-0.322 0.322-0.703 0.562-1.118 0.71v-2.828h2c0 0.797-0.313 1.549-0.882 2.118zM3.521 6c0 0 0 0 0 0 0.153 0 0.283-0.11 0.308-0.261 0.096-0.573 0.589-0.989 1.171-0.989s1.074 0.416 1.171 0.989c0.025 0.151 0.156 0.261 0.308 0.261s0.283-0.11 0.308-0.261c0.017-0.101 0.025-0.202 0.025-0.302 0-0.999-0.813-1.813-1.813-1.813s-1.813 0.813-1.813 1.813c0 0.1 0.009 0.201 0.025 0.302 0.025 0.151 0.156 0.261 0.308 0.261zM9.521 6c0 0 0 0 0 0 0.153 0 0.283-0.11 0.308-0.261 0.096-0.573 0.589-0.989 1.171-0.989s1.074 0.416 1.171 0.989c0.025 0.151 0.156 0.261 0.308 0.261s0.283-0.11 0.308-0.261c0.017-0.101 0.025-0.202 0.025-0.302 0-0.999-0.813-1.813-1.813-1.813s-1.813 0.813-1.813 1.813c0 0.1 0.008 0.201 0.025 0.302 0.025 0.151 0.156 0.261 0.308 0.261z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWink2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM5.5 4.876c0.932 0 1.594 0.349 1.594 0.895 0 0.116 0.060 0.672-0.003 0.775-0.232-0.384-0.856-0.659-1.591-0.659s-1.359 0.275-1.591 0.659c-0.062-0.103-0.003-0.659-0.003-0.775 0-0.546 0.662-0.895 1.594-0.895zM7.818 13c-1.863 0-3.498-1.004-4.42-2.515 1.1 0.86 3.040 1.028 5.083 0.625 2.191-0.433 3.892-1.43 4.507-2.759-0.338 2.624-2.524 4.649-5.17 4.649z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM8.48 11.11c2.191-0.433 3.892-1.43 4.507-2.759-0.338 2.624-2.524 4.649-5.17 4.649-1.863 0-3.498-1.004-4.42-2.515 1.1 0.86 3.040 1.028 5.083 0.625zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM5.5 5.805c-0.653 0-1.208 0.245-1.414 0.586-0.055-0.092-0.086-0.503-0.086-0.605 0-0.485 0.672-0.879 1.5-0.879s1.5 0.394 1.5 0.879c0 0.103-0.030 0.514-0.086 0.605-0.206-0.341-0.761-0.586-1.414-0.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSad2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM4.998 12.199l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.413 0.973 4.288 2.427l-1.286 0.772c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTongue2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM12 10h-1v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h-4v-1h8v1zM11 6c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTongue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM12 9v1h-1v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h-4v-1h8z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSmile2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8 13c-1.82 0-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.002 9.801l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427s-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHappy2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM5 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM8 14c-2.607 0-4.772-2.186-5-4.973 1.465 0.846 3.188 1.329 5 1.329s3.535-0.481 5-1.327c-0.228 2.788-2.393 4.971-5 4.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHappy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM8 9.356c1.812 0 3.535-0.481 5-1.327-0.228 2.788-2.393 4.971-5 4.971s-4.772-2.186-5-4.973c1.465 0.845 3.188 1.329 5 1.329zM4 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImManWoman(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.234 8l0.766-0.555-2.083-3.221c-0.092-0.14-0.249-0.225-0.417-0.225h-4c-0.168 0-0.325 0.084-0.417 0.225l-2.083 3.221 0.766 0.555 1.729-2.244 0.601 1.402-2.095 3.841h1.917l0.333 5h1v-5h0.5v5h1l0.333-5h1.917l-2.095-3.842 0.601-1.402 1.729 2.244z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWoman(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.234 8l0.766-0.555-2.083-3.221c-0.092-0.14-0.249-0.225-0.417-0.225h-4c-0.168 0-0.325 0.084-0.417 0.225l-2.083 3.221 0.766 0.555 1.729-2.244 0.601 1.402-2.095 3.841h1.917l0.333 5h1v-5h0.5v5h1l0.333-5h1.917l-2.095-3.842 0.601-1.402 1.729 2.244z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHeartBroken(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8 1c2.318 0 4.2 1.882 4.2 4.2 0 4.566-4.935 5.982-8 10.616-3.243-4.663-8-5.9-8-10.616 0-2.319 1.882-4.2 4.2-4.2 0.943 0 1.812 0.43 2.512 1.060l-1.213 1.94 3.5 2-2 5 5.5-6-3.5-2 0.967-1.451c0.553-0.34 1.175-0.549 1.833-0.549z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8 1c-1.682 0-3.129 1.368-3.799 2.797-0.671-1.429-2.118-2.797-3.8-2.797-2.318 0-4.2 1.882-4.2 4.2 0 4.716 4.758 5.953 8 10.616 3.065-4.634 8-6.050 8-10.616 0-2.319-1.882-4.2-4.2-4.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStarFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStarHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-0.015 0.008 0.015-8.918 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStarEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-3.492 1.836 0.667-3.888-2.825-2.753 3.904-0.567 1.746-3.537 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBrightnessContrast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4zM8 10.5v-5c1.379 0 2.5 1.122 2.5 2.5s-1.121 2.5-2.5 2.5zM8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImContrast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM2 8c0-3.314 2.686-6 6-6v12c-3.314 0-6-2.686-6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM8 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBookmarks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v14l5-5 5 5v-14zM12 0h-10v14l1-1v-12h9z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0v16l5-5 5 5v-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEyeBlocked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.78 0.22c-0.293-0.293-0.768-0.293-1.061 0l-3.159 3.159c-0.812-0.246-1.671-0.378-2.561-0.378-3.489 0-6.514 2.032-8 5 0.643 1.283 1.573 2.391 2.703 3.236l-2.484 2.484c-0.293 0.293-0.293 0.768 0 1.061 0.146 0.146 0.338 0.22 0.53 0.22s0.384-0.073 0.53-0.22l13.5-13.5c0.293-0.293 0.293-0.768 0-1.061zM6.5 5c0.66 0 1.22 0.426 1.421 1.019l-1.902 1.902c-0.592-0.201-1.019-0.761-1.019-1.421 0-0.828 0.672-1.5 1.5-1.5zM1.721 8c0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 0.858 0.27 1.652 0.73 2.303l-0.952 0.952c-0.819-0.576-1.519-1.311-2.057-2.162z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.906c0-0.424-0.066-0.833-0.189-1.217l-5.028 5.028c0.384 0.123 0.793 0.189 1.217 0.189 2.209 0 4-1.791 4-4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.969 4.531l-1.084 1.084c0.020 0.012 0.040 0.024 0.059 0.037 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152-0.604 0-1.202-0.074-1.781-0.219l-1.201 1.201c0.933 0.335 1.937 0.518 2.982 0.518 3.489 0 6.514-2.032 8-5-0.703-1.405-1.752-2.6-3.031-3.469z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEyeMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2h6v2h-6v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.599 5h-4.599v-1.944c-0.328-0.037-0.662-0.056-1-0.056-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-0.584-1.167-1.407-2.189-2.401-3zM6.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM11.944 10.348c-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.736-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEyePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2h-2v-2h-2v2h-2v2h2v2h2v-2h2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.498 6.969c0.288 0.32 0.55 0.665 0.782 1.031-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.736-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.011-0-0.022-0-0.032-1.708-0.44-2.973-1.979-2.999-3.817-0.329-0.037-0.662-0.057-1.001-0.057-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-0.276-0.55-0.604-1.069-0.979-1.548-0.457 0.268-0.973 0.449-1.523 0.517zM6.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3c-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-1.486-2.968-4.511-5-8-5zM11.945 5.652c0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.737-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114v0zM8 6.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAttachment(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.404 5.11l-1.015-1.014-5.075 5.074c-0.841 0.841-0.841 2.204 0 3.044s2.204 0.841 3.045 0l6.090-6.089c1.402-1.401 1.402-3.673 0-5.074s-3.674-1.402-5.075 0l-6.394 6.393c-0.005 0.005-0.010 0.009-0.014 0.013-1.955 1.955-1.955 5.123 0 7.077s5.123 1.954 7.078 0c0.004-0.004 0.008-0.009 0.013-0.014l0.001 0.001 4.365-4.364-1.015-1.014-4.365 4.363c-0.005 0.004-0.009 0.009-0.013 0.013-1.392 1.392-3.656 1.392-5.048 0s-1.392-3.655 0-5.047c0.005-0.005 0.009-0.009 0.014-0.013l-0.001-0.001 6.395-6.393c0.839-0.84 2.205-0.84 3.045 0s0.839 2.205 0 3.044l-6.090 6.089c-0.28 0.28-0.735 0.28-1.015 0s-0.28-0.735 0-1.014l5.075-5.075z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0h2v16h-2v-16z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10.047c1.291 0 2.415-0.312 3-0.773v-8c-0.585 0.461-1.709 0.773-3 0.773s-2.415-0.312-3-0.773v8c0.585 0.461 1.709 0.773 3 0.773z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0.508c-0.733-0.312-1.805-0.508-3-0.508-1.506 0-2.818 0.312-3.5 0.773v8c0.682-0.461 1.994-0.773 3.5-0.773 1.195 0 2.267 0.197 3 0.508v-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.879 9.934c-0.208 0-0.416-0.079-0.575-0.238-1.486-1.486-1.486-3.905 0-5.392l3-3c0.72-0.72 1.678-1.117 2.696-1.117s1.976 0.397 2.696 1.117c1.486 1.487 1.486 3.905 0 5.392l-1.371 1.371c-0.317 0.317-0.832 0.317-1.149 0s-0.317-0.832 0-1.149l1.371-1.371c0.853-0.853 0.853-2.241 0-3.094-0.413-0.413-0.963-0.641-1.547-0.641s-1.134 0.228-1.547 0.641l-3 3c-0.853 0.853-0.853 2.241 0 3.094 0.317 0.317 0.317 0.832 0 1.149-0.159 0.159-0.367 0.238-0.575 0.238z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15.813c-1.018 0-1.976-0.397-2.696-1.117-1.486-1.486-1.486-3.905 0-5.392l1.371-1.371c0.317-0.317 0.832-0.317 1.149 0s0.317 0.832 0 1.149l-1.371 1.371c-0.853 0.853-0.853 2.241 0 3.094 0.413 0.413 0.962 0.641 1.547 0.641s1.134-0.228 1.547-0.641l3-3c0.853-0.853 0.853-2.241 0-3.094-0.317-0.317-0.317-0.832 0-1.149s0.832-0.317 1.149 0c1.486 1.486 1.486 3.905 0 5.392l-3 3c-0.72 0.72-1.678 1.117-2.696 1.117z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEarth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-0.984 0-1.92-0.203-2.769-0.57l3.643-4.098c0.081-0.092 0.126-0.21 0.126-0.332v-1.5c0-0.276-0.224-0.5-0.5-0.5-1.765 0-3.628-1.835-3.646-1.854-0.094-0.094-0.221-0.146-0.354-0.146h-2c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.189 0.107 0.363 0.276 0.447l1.724 0.862v2.936c-1.813-1.265-3-3.366-3-5.745 0-1.074 0.242-2.091 0.674-3h1.826c0.133 0 0.26-0.053 0.354-0.146l2-2c0.094-0.094 0.146-0.221 0.146-0.354v-1.21c0.634-0.189 1.305-0.29 2-0.29 1.1 0 2.141 0.254 3.067 0.706-0.065 0.055-0.128 0.112-0.188 0.172-0.567 0.567-0.879 1.32-0.879 2.121s0.312 1.555 0.879 2.121c0.569 0.569 1.332 0.879 2.119 0.879 0.049 0 0.099-0.001 0.149-0.004 0.216 0.809 0.605 2.917-0.131 5.818-0.007 0.027-0.011 0.055-0.013 0.082-1.271 1.298-3.042 2.104-5.002 2.104z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSphere(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM11.744 11c0.134-0.632 0.219-1.303 0.246-2h1.991c-0.052 0.691-0.213 1.361-0.479 2h-1.758zM3.256 6c-0.134 0.632-0.219 1.303-0.246 2h-1.991c0.052-0.691 0.213-1.361 0.479-2h1.758zM10.719 6c0.15 0.64 0.241 1.31 0.27 2h-2.989v-2h2.719zM8 5v-2.927c0.228 0.066 0.454 0.178 0.675 0.334 0.415 0.293 0.813 0.744 1.149 1.304 0.233 0.388 0.434 0.819 0.601 1.289h-2.426zM5.176 3.711c0.336-0.561 0.734-1.012 1.149-1.304 0.222-0.156 0.447-0.268 0.675-0.334v2.927h-2.426c0.168-0.47 0.369-0.901 0.601-1.289zM7 6v2h-2.989c0.029-0.69 0.12-1.36 0.27-2h2.719zM1.498 11c-0.266-0.639-0.427-1.309-0.479-2h1.991c0.028 0.697 0.112 1.368 0.246 2h-1.758zM4.011 9h2.989v2h-2.719c-0.15-0.64-0.241-1.31-0.27-2zM7 12v2.927c-0.228-0.066-0.454-0.178-0.675-0.334-0.415-0.293-0.813-0.744-1.149-1.304-0.233-0.388-0.434-0.819-0.602-1.289h2.426zM9.825 13.289c-0.336 0.561-0.734 1.012-1.149 1.304-0.222 0.156-0.447 0.268-0.675 0.334v-2.927h2.426c-0.168 0.47-0.369 0.901-0.602 1.289zM8 11v-2h2.989c-0.029 0.69-0.12 1.36-0.27 2h-2.719zM11.99 8c-0.028-0.697-0.112-1.368-0.246-2h1.758c0.267 0.639 0.427 1.309 0.479 2h-1.991zM12.979 5h-1.498c-0.291-0.918-0.693-1.723-1.177-2.366 0.665 0.318 1.267 0.744 1.792 1.27 0.336 0.336 0.631 0.702 0.883 1.096zM2.904 3.904c0.526-0.526 1.128-0.952 1.792-1.27-0.483 0.643-0.886 1.448-1.177 2.366h-1.498c0.252-0.394 0.547-0.761 0.883-1.096zM2.021 12h1.498c0.291 0.918 0.693 1.723 1.177 2.366-0.665-0.318-1.267-0.744-1.792-1.27-0.336-0.336-0.631-0.702-0.883-1.096zM12.096 13.096c-0.526 0.526-1.128 0.952-1.792 1.27 0.483-0.643 0.886-1.448 1.177-2.366h1.498c-0.252 0.394-0.547 0.761-0.883 1.096z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUpload3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 11h-7.5v4h15v-4h-7.5zM14 13h-2v-1h2v1zM3.5 5l4-4 4 4h-2.5v5h-3v-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDownload3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7l-4 4-4-4h2.5v-6h3v6zM7.5 11h-7.5v4h15v-4h-7.5zM14 13h-2v-1h2v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUpload2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 14h16v1h-16zM16 12v1h-16v-1l2-4h4v2h4v-2h4zM3.5 5l4.5-4.5 4.5 4.5h-3.5v4h-2v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDownload2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h-2.5l-3.5 3.5-3.5-3.5h-2.5l-2 4v1h16v-1l-2-4zM0 14h16v1h-16v-1zM9 5v-4h-2v4h-3.5l4.5 4.5 4.5-4.5h-3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCloudCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.942 8.039c0.038-0.174 0.058-0.354 0.058-0.539 0-1.381-1.119-2.5-2.5-2.5-0.222 0-0.438 0.029-0.643 0.084-0.387-1.209-1.52-2.084-2.857-2.084-1.365 0-2.516 0.911-2.88 2.159-0.355-0.103-0.731-0.159-1.12-0.159-2.209 0-4 1.791-4 4s1.791 4 4 4h9.5c1.381 0 2.5-1.119 2.5-2.5 0-1.23-0.888-2.252-2.058-2.461zM6.5 12l-2.5-2.5 1-1 1.5 1.5 3.5-3.5 1 1-4.5 4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCloudUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.942 6.039c0.038-0.174 0.058-0.354 0.058-0.539 0-1.381-1.119-2.5-2.5-2.5-0.222 0-0.438 0.029-0.643 0.084-0.387-1.209-1.52-2.084-2.857-2.084-1.365 0-2.516 0.911-2.88 2.159-0.355-0.103-0.731-0.159-1.12-0.159-2.209 0-4 1.791-4 4s1.791 4 4 4h2v3h4v-3h3.5c1.381 0 2.5-1.119 2.5-2.5 0-1.23-0.888-2.253-2.058-2.461zM9 10v3h-2v-3h-2.5l3.5-3.5 3.5 3.5h-2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCloudDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.922 5.626c-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029h1.434l3.539 3.664 3.539-3.664 1.742-0c1.502-0.003 2.719-1.222 2.719-2.726 0-1.283-0.886-2.358-2.078-2.648zM8 13l-3-3h2v-3h2v3h2l-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10.274c0-1.283-0.886-2.358-2.078-2.648-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029l10.254-0c1.502-0.003 2.719-1.222 2.719-2.726z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMenu4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 22 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 10l3-3 3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMenu3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 22 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 7l3 3 3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMenu2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 22 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 9l3 3 3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 8l-3-3-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMenu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3h14v3h-14zM1 7h14v3h-14zM1 11h14v3h-14z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.25 12h-0.25v-3.25c0-0.965-0.785-1.75-1.75-1.75h-4.25v-2h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v2h-4.25c-0.965 0-1.75 0.785-1.75 1.75v3.25h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.413 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.337-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75zM3 15h-2v-2h2v2zM9 15h-2v-2h2v2zM7 4v-2h2v2h-2zM15 15h-2v-2h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImList2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1h10v2h-10v-2zM6 7h10v2h-10v-2zM6 13h10v2h-10v-2zM0 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 14c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0h4v4h-4zM6 1h10v2h-10zM0 6h4v4h-4zM6 7h10v2h-10zM0 12h4v4h-4zM6 13h10v2h-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImListNumbered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13h10v2h-10zM6 7h10v2h-10zM6 1h10v2h-10zM3 0v4h-1v-3h-1v-1zM2 8.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM4 11v5h-3v-1h2v-1h-2v-1h2v-1h-2v-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2h-4.5c0-1.105-0.895-2-2-2s-2 0.895-2 2h-4.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5zM8 1c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1zM14 15h-12v-12h2v1.5c0 0.276 0.224 0.5 0.5 0.5h7c0.276 0 0.5-0.224 0.5-0.5v-1.5h2v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13.414l-3.207-3.707 0.914-0.914 2.293 1.793 4.293-3.793 0.914 0.914z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPowerCord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4.414l-1.414-1.414-2.793 2.793-1.586-1.586 2.793-2.793-1.414-1.414-2.793 2.793-1.793-1.793-1.354 1.353 8 8 1.354-1.353-1.793-1.793 2.793-2.793z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.407 10.528l-6.935-6.935c-1.497 1.795-3.196 4.57-2.022 6.957l-2.066 2.066c-0.486 0.486-0.486 1.282 0 1.768l0.232 0.232c0.486 0.486 1.282 0.486 1.768 0l2.066-2.066c2.387 1.174 5.161-0.524 6.957-2.022z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSwitch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2.29v2.124c0.566 0.247 1.086 0.6 1.536 1.050 0.944 0.944 1.464 2.2 1.464 3.536s-0.52 2.591-1.464 3.536c-0.944 0.944-2.2 1.464-3.536 1.464s-2.591-0.52-3.536-1.464c-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536c0.45-0.45 0.97-0.803 1.536-1.050v-2.124c-2.891 0.861-5 3.539-5 6.71 0 3.866 3.134 7 7 7s7-3.134 7-7c0-3.171-2.109-5.849-5-6.71zM7 0h2v8h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0l-6 8h6l-4 8 14-10h-8l6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0l-7 2-7-2c0 0-0.070 0.808 0 2l7 2.189 7-2.189c0.070-1.192 0-2 0-2zM1.128 3.049c0.375 3.917 1.773 10.504 6.872 12.951 5.099-2.448 6.497-9.034 6.872-12.951l-6.872 2.584-6.872-2.584z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTarget(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h-1.577c-0.432-2.785-2.638-4.991-5.423-5.423v-1.577h-2v1.577c-2.785 0.432-4.991 2.638-5.423 5.423h-1.577v2h1.577c0.432 2.785 2.638 4.991 5.423 5.423v1.577h2v-1.577c2.785-0.432 4.991-2.638 5.423-5.423h1.577v-2zM12.388 7h-1.559c-0.301-0.852-0.977-1.528-1.829-1.829v-1.559c1.68 0.383 3.005 1.708 3.388 3.388zM8 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM7 3.612v1.559c-0.852 0.301-1.528 0.977-1.829 1.829h-1.559c0.383-1.68 1.708-3.005 3.388-3.388zM3.612 9h1.559c0.301 0.852 0.977 1.528 1.829 1.829v1.559c-1.68-0.383-3.005-1.708-3.388-3.388zM9 12.388v-1.559c0.852-0.301 1.528-0.977 1.829-1.829h1.559c-0.383 1.68-1.708 3.005-3.388 3.388z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAccessibility(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5l5.15-2.221-0.371-0.929-6.279 2.15h-1l-6.279-2.15-0.371 0.929 5.15 2.221v4l-2.051 6.634 0.935 0.355 2.902-6.489h0.429l2.902 6.489 0.935-0.355-2.051-6.634z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRoad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h5l-4-16h-3l0.5 4h-3l0.5-4h-3l-4 16h5l0.5-4h5l0.5 4zM5.75 10l0.5-4h3.5l0.5 4h-4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTruck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9l-2-4h-3v-2c0-0.55-0.45-1-1-1h-9c-0.55 0-1 0.45-1 1v8l1 1h1.268c-0.17 0.294-0.268 0.636-0.268 1 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.364-0.098-0.706-0.268-1h5.536c-0.17 0.294-0.268 0.636-0.268 1 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.364-0.098-0.706-0.268-1h1.268v-3zM11 9v-3h2.073l1.5 3h-3.573z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAirplane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9.999l-2.857-2.857 6.857-5.143-2-2-8.571 3.429-2.698-2.699c-0.778-0.778-1.864-0.964-2.414-0.414s-0.364 1.636 0.414 2.414l2.698 2.698-3.429 8.572 2 2 5.144-6.857 2.857 2.857v4h2l1-3 3-1v-2l-4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h-4v-1c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v1h-4c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM6 3.002c0.001-0.001 0.001-0.001 0.002-0.002h3.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-4v-0.998zM15 8h-2v1.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h-6v1.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h-2v-1h14v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBin2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h10l1-11h-12zM10 2v-2h-4v2h-5v3l1-1h12l1 1v-3h-5zM9 2h-2v-1h2v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5v10c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-10h-11zM5 14h-1v-7h1v7zM7 14h-1v-7h1v7zM9 14h-1v-7h1v7zM11 14h-1v-7h1v7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.25 2h-3.25v-1.25c0-0.412-0.338-0.75-0.75-0.75h-3.5c-0.412 0-0.75 0.338-0.75 0.75v1.25h-3.25c-0.413 0-0.75 0.337-0.75 0.75v1.25h13v-1.25c0-0.413-0.338-0.75-0.75-0.75zM9 2h-3v-0.987h3v0.987z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMagnet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-4l1 9c0 1.657-1.343 3-3 3s-3-1.343-3-3l1-9h-4l-1 9c0 3.866 3.134 7 7 7s7-3.134 7-7l-1-9zM12.154 13.154c-1.11 1.11-2.585 1.721-4.154 1.721s-3.045-0.611-4.154-1.721c-1.096-1.096-1.705-2.548-1.72-4.095l0.564-5.075h1.736l-0.55 4.953v0.062c0 1.102 0.429 2.138 1.208 2.917s1.815 1.208 2.917 1.208 2.138-0.429 2.917-1.208c0.779-0.779 1.208-1.815 1.208-2.917v-0.062l-0.007-0.062-0.543-4.891h1.736l0.564 5.075c-0.015 1.547-0.625 2.999-1.72 4.095z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLab(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.942 12.57l-4.942-8.235v-3.335h0.5c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5h0.5v3.335l-4.942 8.235c-1.132 1.886-0.258 3.43 1.942 3.43h10c2.2 0 3.074-1.543 1.942-3.43zM3.766 10l3.234-5.39v-3.61h2v3.61l3.234 5.39h-8.468z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.016 16c-1.066-2.219-0.498-3.49 0.321-4.688 0.897-1.312 1.129-2.61 1.129-2.61s0.706 0.917 0.423 2.352c1.246-1.387 1.482-3.598 1.293-4.445 2.817 1.969 4.021 6.232 2.399 9.392 8.631-4.883 2.147-12.19 1.018-13.013 0.376 0.823 0.448 2.216-0.313 2.893-1.287-4.879-4.468-5.879-4.468-5.879 0.376 2.516-1.364 5.268-3.042 7.324-0.059-1.003-0.122-1.696-0.649-2.656-0.118 1.823-1.511 3.309-1.889 5.135-0.511 2.473 0.383 4.284 3.777 6.197z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHammer2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.784 14.309l-8.572-7.804 0.399-0.4c0.326-0.327 0.503-0.75 0.53-1.181 0.016-0.007 0.031-0.014 0.046-0.023l1.609-1.006c0.218-0.256 0.202-0.66-0.036-0.898l-2.799-2.806c-0.237-0.238-0.641-0.254-0.896-0.036l-1.004 1.614c-0.008 0.015-0.015 0.031-0.022 0.046-0.43 0.027-0.852 0.204-1.178 0.531l-1.522 1.527c-0.327 0.327-0.503 0.75-0.53 1.181-0.016 0.007-0.031 0.014-0.046 0.023l-1.609 1.006c-0.218 0.256-0.202 0.66 0.036 0.898l2.799 2.806c0.237 0.238 0.641 0.254 0.896 0.036l1.004-1.614c0.008-0.015 0.015-0.031 0.023-0.046 0.43-0.027 0.852-0.204 1.178-0.531l0.442-0.443 7.783 8.596c0.226 0.249 0.573 0.289 0.773 0.089l0.787-0.789c0.199-0.2 0.159-0.549-0.089-0.775z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMeter2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.732 13.034c0.174-0.479 0.268-0.995 0.268-1.534 0-1.943-1.231-3.598-2.956-4.228 0.16-1.327 0.754-2.555 1.714-3.514 1.133-1.133 2.64-1.757 4.243-1.757s3.109 0.624 4.243 1.757c0.96 0.96 1.554 2.188 1.714 3.514-1.725 0.63-2.956 2.285-2.956 4.228 0 0.539 0.095 1.055 0.268 1.534-0.964 0.629-2.090 0.966-3.268 0.966s-2.304-0.338-3.268-0.966zM8.621 10.016c0.217 0.055 0.379 0.251 0.379 0.484v1c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1c0-0.233 0.162-0.43 0.379-0.484l0.371-7.016h0.5l0.371 7.016z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMeter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c4.418 0 8 3.582 8 8 0 3.012-1.665 5.635-4.125 7h-7.75c-2.46-1.365-4.125-3.988-4.125-7 0-4.418 3.582-8 8-8zM12.53 13.53c1.21-1.21 1.876-2.819 1.876-4.53h-1.406v-1h1.329c-0.11-0.703-0.334-1.377-0.665-2h-1.664v-1h1.004c-0.147-0.184-0.306-0.361-0.475-0.53-0.722-0.722-1.587-1.251-2.53-1.559v1.089h-1v-1.329c-0.328-0.051-0.662-0.078-1-0.078s-0.672 0.026-1 0.078v1.329h-1v-1.089c-0.943 0.309-1.808 0.837-2.53 1.559-0.169 0.169-0.327 0.346-0.475 0.53h1.004v1h-1.664c-0.331 0.623-0.555 1.297-0.665 2h1.329v1h-1.406c0 1.711 0.666 3.32 1.876 4.53 0.167 0.167 0.343 0.324 0.524 0.47h3.006l0.571-8h0.857l0.571 8h3.006c0.182-0.146 0.357-0.303 0.524-0.47z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRocket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1l-5 5h-3l-3 4c0 0 3.178-0.885 5.032-0.47l-5.032 6.47 6.592-5.127c0.919 2.104-0.592 5.127-0.592 5.127l4-3v-3l5-5 1-5-5 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.802 2.102c-1.73-1.311-4.393-2.094-7.124-2.094-3.377 0-6.129 1.179-7.549 3.235-0.667 0.965-1.036 2.109-1.097 3.398-0.054 1.148 0.139 2.418 0.573 3.784 1.482-4.444 5.622-7.923 10.395-7.923 0 0-4.466 1.175-7.274 4.816-0.002 0.002-0.039 0.048-0.103 0.136-0.564 0.754-1.055 1.612-1.423 2.583-0.623 1.482-1.2 3.515-1.2 5.965h2c0 0-0.304-1.91 0.224-4.106 0.873 0.118 1.654 0.177 2.357 0.177 1.839 0 3.146-0.398 4.115-1.252 0.868-0.765 1.347-1.794 1.854-2.882 0.774-1.663 1.651-3.547 4.198-5.002 0.146-0.083 0.24-0.234 0.251-0.402s-0.063-0.329-0.197-0.431z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpoonKnife(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0c-1.657 0-3 1.567-3 3.5 0 1.655 0.985 3.042 2.308 3.406l-0.497 8.096c-0.034 0.549 0.389 0.998 0.939 0.998h0.5c0.55 0 0.972-0.449 0.939-0.998l-0.497-8.096c1.323-0.365 2.308-1.751 2.308-3.406 0-1.933-1.343-3.5-3-3.5zM13.583 0l-0.833 5h-0.625l-0.417-5h-0.417l-0.417 5h-0.625l-0.833-5h-0.417v6.5c0 0.276 0.224 0.5 0.5 0.5h1.302l-0.491 8.002c-0.034 0.549 0.389 0.998 0.939 0.998h0.5c0.55 0 0.972-0.449 0.939-0.998l-0.491-8.002h1.302c0.276 0 0.5-0.224 0.5-0.5v-6.5h-0.417z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5h-3v-1.5c0-1.381-2.686-2.5-6-2.5s-6 1.119-6 2.5v10c0 1.381 2.686 2.5 6 2.5s6-1.119 6-2.5v-1.5h3c0.552 0 1-0.448 1-1v-5c0-0.552-0.448-1-1-1zM2.751 4.037c-0.578-0.19-0.928-0.394-1.116-0.537 0.188-0.143 0.538-0.347 1.116-0.537 0.905-0.298 2.059-0.463 3.249-0.463s2.344 0.164 3.249 0.463c0.578 0.19 0.928 0.394 1.116 0.537-0.188 0.143-0.538 0.347-1.116 0.537-0.905 0.298-2.059 0.463-3.249 0.463s-2.344-0.164-3.249-0.463zM14 10h-2v-3h2v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGlass2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.893 2.809c0.118-0.151 0.14-0.355 0.057-0.527s-0.258-0.281-0.45-0.281h-11c-0.191 0-0.366 0.109-0.45 0.281s-0.062 0.377 0.057 0.527l4.893 6.228v5.963h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.963l4.893-6.228zM12.471 3l-1.571 2h-5.8l-1.571-2h8.943z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.153 0.263c-0.087-0.162-0.256-0.263-0.44-0.263h-7.425c-0.184 0-0.353 0.101-0.44 0.263-0.554 1.032-0.847 2.237-0.847 3.487 0 1.647 0.506 3.2 1.424 4.374 0.71 0.907 1.601 1.508 2.576 1.753v5.123h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.123c0.975-0.244 1.866-0.846 2.576-1.753 0.918-1.174 1.424-2.727 1.424-4.374 0-1.249-0.293-2.455-0.847-3.487zM4.595 1h6.809c0.39 0.827 0.595 1.771 0.595 2.75 0 0.084-0.002 0.167-0.005 0.25h-7.991c-0.003-0.083-0.005-0.166-0.005-0.25-0-0.979 0.205-1.923 0.595-2.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.055 5c0.283-0.201 0.555-0.425 0.804-0.674 0.522-0.522 0.871-1.164 0.983-1.808 0.123-0.706-0.057-1.362-0.494-1.798-0.348-0.348-0.82-0.533-1.365-0.533-0.775 0-1.593 0.372-2.242 1.021-1.039 1.039-1.644 2.472-1.97 3.496-0.241-1.028-0.722-2.416-1.657-3.351-0.501-0.501-1.142-0.759-1.748-0.759-0.495 0-0.965 0.172-1.317 0.523-0.781 0.781-0.675 2.153 0.236 3.064 0.325 0.325 0.705 0.595 1.105 0.819h-3.391v4h1v7h12v-7h1v-4h-2.945zM10.536 2.003c0.433-0.433 0.974-0.692 1.446-0.692 0.167 0 0.402 0.035 0.57 0.203 0.407 0.407 0.178 1.349-0.489 2.016-0.687 0.687-1.61 1.159-2.413 1.47h-0.792c0.29-0.899 0.813-2.132 1.678-2.997zM3.655 2.514c-0.011-0.143-0.001-0.41 0.191-0.601 0.16-0.16 0.372-0.194 0.521-0.194v0c0.332 0 0.679 0.157 0.952 0.429 0.529 0.529 0.965 1.371 1.26 2.436 0.008 0.029 0.016 0.057 0.023 0.086-0.028-0.008-0.057-0.015-0.086-0.023-1.064-0.295-1.906-0.731-2.436-1.26-0.247-0.247-0.403-0.565-0.426-0.872zM7 15h-4v-6.5h4v6.5zM7 8h-5v-2h5v2zM13 15h-4v-6.5h4v6.5zM14 8h-5v-2h5v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTrophy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3v-2h-10v2h-3v2c0 1.657 1.343 3 3 3 0.314 0 0.616-0.048 0.9-0.138 0.721 1.031 1.822 1.778 3.1 2.037v3.1h-1c-1.105 0-2 0.895-2 2h8c0-1.105-0.895-2-2-2h-1v-3.1c1.278-0.259 2.378-1.006 3.1-2.037 0.284 0.089 0.587 0.138 0.9 0.138 1.657 0 3-1.343 3-3v-2h-3zM3 6.813c-0.999 0-1.813-0.813-1.813-1.813v-1h1.813v1c0 0.628 0.116 1.229 0.327 1.782-0.106 0.019-0.216 0.030-0.327 0.030zM14.813 5c0 0.999-0.813 1.813-1.813 1.813-0.112 0-0.221-0.011-0.327-0.030 0.211-0.554 0.327-1.154 0.327-1.782v-1h1.813v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStatsBars2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 6h-3c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM4.5 15h-3v-4h3v4zM9.5 4h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM9.5 15h-3v-5h3v5zM14.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5zM14.5 15h-3v-6h3v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStatsBars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 13h16v2h-16zM2 9h2v3h-2zM5 5h2v7h-2zM8 8h2v4h-2zM11 2h2v10h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStatsDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h14v2h-16v-16h2zM4.5 13c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.044 0 0.088 0.002 0.131 0.006l1.612-2.687c-0.154-0.235-0.243-0.517-0.243-0.819 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.302-0.090 0.583-0.243 0.819l1.612 2.687c0.043-0.004 0.087-0.006 0.131-0.006 0.033 0 0.066 0.001 0.099 0.004l2.662-4.658c-0.165-0.241-0.261-0.532-0.261-0.845 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5-0.033 0-0.066-0.001-0.099-0.004l-2.662 4.658c0.165 0.241 0.261 0.532 0.261 0.845 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.302 0.090-0.583 0.243-0.819l-1.612-2.687c-0.043 0.004-0.087 0.006-0.131 0.006s-0.088-0.002-0.131-0.006l-1.612 2.687c0.154 0.235 0.243 0.517 0.243 0.819 0 0.828-0.672 1.5-1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPieChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9v-7c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7c0-1.126-0.266-2.189-0.738-3.131l-6.262 3.131zM14.262 3.869c-1.149-2.294-3.521-3.869-6.262-3.869v7l6.262-3.131z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9v-1h-3.020c-0.092-1.136-0.497-2.172-1.12-3.004h2.53l1.095-4.379-0.97-0.243-0.905 3.621h-2.729c-0.014-0.011-0.028-0.021-0.042-0.032 0.105-0.305 0.162-0.632 0.162-0.972 0-1.653-1.343-2.992-3-2.992s-3 1.34-3 2.992c0 0.34 0.057 0.667 0.162 0.972-0.014 0.011-0.028 0.021-0.042 0.032h-2.729l-0.905-3.621-0.97 0.243 1.095 4.379h2.53c-0.623 0.832-1.028 1.868-1.12 3.004h-3.020v1h3.021c0.059 0.713 0.242 1.388 0.526 1.996h-1.937l-1.095 4.379 0.97 0.243 0.905-3.621h1.756c0.917 1.219 2.303 1.996 3.854 1.996s2.937-0.777 3.854-1.996h1.756l0.905 3.621 0.97-0.243-1.095-4.379h-1.937c0.283-0.608 0.466-1.283 0.526-1.996h3.021z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAidKit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4h-3v-2c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v2h-3c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-8c0-1.1-0.9-2-2-2zM6 2h4v2h-4v-2zM12 11h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMagicWand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3l-2-2h-1v1l2 2zM5 0h1v2h-1zM9 5h2v1h-2zM10 2v-1h-1l-2 2 1 1zM0 5h2v1h-2zM5 9h1v2h-1zM1 9v1h1l2-2-1-1zM15.781 13.781l-9.939-9.939c-0.292-0.292-0.769-0.292-1.061 0l-0.939 0.939c-0.292 0.292-0.292 0.769 0 1.061l9.939 9.939c0.292 0.292 0.769 0.292 1.061 0l0.939-0.939c0.292-0.292 0.292-0.769 0-1.061zM7.5 8.5l-3-3 1-1 3 3-1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHammer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.781 12.953l-4.712-4.712c-0.292-0.292-0.769-0.292-1.061 0l-0.354 0.354-2.875-2.875 4.72-4.72h-5l-2.22 2.22-0.22-0.22h-1.061v1.061l0.22 0.22-3.22 3.22 2.5 2.5 3.22-3.22 2.875 2.875-0.354 0.354c-0.292 0.292-0.292 0.769 0 1.061l4.712 4.712c0.292 0.292 0.769 0.292 1.061 0l1.768-1.768c0.292-0.292 0.292-0.769 0-1.061z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCogs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.683 11.282l0.645-0.903-0.707-0.707-0.903 0.645c-0.168-0.094-0.347-0.168-0.535-0.222l-0.183-1.095h-1l-0.183 1.095c-0.188 0.053-0.368 0.128-0.535 0.222l-0.903-0.645-0.707 0.707 0.645 0.903c-0.094 0.168-0.168 0.347-0.222 0.535l-1.095 0.183v1l1.095 0.183c0.053 0.188 0.128 0.368 0.222 0.535l-0.645 0.903 0.707 0.707 0.903-0.645c0.168 0.094 0.347 0.168 0.535 0.222l0.183 1.095h1l0.183-1.095c0.188-0.053 0.368-0.128 0.535-0.222l0.903 0.645 0.707-0.707-0.645-0.903c0.094-0.168 0.168-0.347 0.222-0.535l1.095-0.182v-1l-1.095-0.183c-0.053-0.188-0.128-0.368-0.222-0.535zM3.5 13.5c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM16 6v-1l-1.053-0.191c-0.019-0.126-0.044-0.25-0.074-0.372l0.899-0.58-0.383-0.924-1.046 0.226c-0.066-0.108-0.136-0.213-0.211-0.315l0.609-0.88-0.707-0.707-0.88 0.609c-0.102-0.074-0.207-0.145-0.315-0.211l0.226-1.046-0.924-0.383-0.58 0.899c-0.122-0.030-0.246-0.054-0.372-0.074l-0.191-1.053h-1l-0.191 1.053c-0.126 0.019-0.25 0.044-0.372 0.074l-0.58-0.899-0.924 0.383 0.226 1.046c-0.108 0.066-0.213 0.136-0.315 0.211l-0.88-0.609-0.707 0.707 0.609 0.88c-0.074 0.102-0.145 0.207-0.211 0.315l-1.046-0.226-0.383 0.924 0.899 0.58c-0.030 0.122-0.054 0.246-0.074 0.372l-1.053 0.191v1l1.053 0.191c0.019 0.126 0.044 0.25 0.074 0.372l-0.899 0.58 0.383 0.924 1.046-0.226c0.066 0.108 0.136 0.213 0.211 0.315l-0.609 0.88 0.707 0.707 0.88-0.609c0.102 0.074 0.207 0.145 0.315 0.211l-0.226 1.046 0.924 0.383 0.58-0.899c0.122 0.030 0.246 0.054 0.372 0.074l0.191 1.053h1l0.191-1.053c0.126-0.019 0.25-0.044 0.372-0.074l0.58 0.899 0.924-0.383-0.226-1.046c0.108-0.066 0.213-0.136 0.315-0.211l0.88 0.609 0.707-0.707-0.609-0.88c0.074-0.102 0.145-0.207 0.211-0.315l1.046 0.226 0.383-0.924-0.899-0.58c0.030-0.122 0.054-0.246 0.074-0.372l1.053-0.191zM10.5 7.675c-1.201 0-2.175-0.974-2.175-2.175s0.974-2.175 2.175-2.175 2.175 0.974 2.175 2.175c0 1.201-0.974 2.175-2.175 2.175z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 9.535c-0.839-1.454-0.335-3.317 1.127-4.164l-1.572-2.723c-0.449 0.263-0.972 0.414-1.529 0.414-1.68 0-3.042-1.371-3.042-3.062h-3.145c0.004 0.522-0.126 1.051-0.406 1.535-0.839 1.454-2.706 1.948-4.17 1.106l-1.572 2.723c0.453 0.257 0.845 0.634 1.123 1.117 0.838 1.452 0.336 3.311-1.12 4.16l1.572 2.723c0.448-0.261 0.967-0.41 1.522-0.41 1.675 0 3.033 1.362 3.042 3.046h3.145c-0.001-0.517 0.129-1.040 0.406-1.519 0.838-1.452 2.7-1.947 4.163-1.11l1.572-2.723c-0.45-0.257-0.839-0.633-1.116-1.113zM8 11.24c-1.789 0-3.24-1.45-3.24-3.24s1.45-3.24 3.24-3.24c1.789 0 3.24 1.45 3.24 3.24s-1.45 3.24-3.24 3.24z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEqualizer2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v9h2v-9zM12 4h2v2h-2v-2zM9.25 13c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-9h-2v9h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v3h2v-3h0.25zM7 10h2v2h-2v-2zM4.25 7c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.413 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.337 0.75 0.75 0.75h0.25v9h2v-9h0.25zM2 4h2v2h-2v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEqualizer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2v-0.25c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.413 0-0.75 0.337-0.75 0.75v0.25h-3v2h3v0.25c0 0.412 0.337 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h9v-2h-9zM4 4v-2h2v2h-2zM13 6.75c0-0.412-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.338-0.75 0.75v0.25h-9v2h9v0.25c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h3v-2h-3v-0.25zM10 9v-2h2v2h-2zM7 11.75c0-0.412-0.338-0.75-0.75-0.75h-2.5c-0.413 0-0.75 0.338-0.75 0.75v0.25h-3v2h3v0.25c0 0.412 0.337 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h9v-2h-9v-0.25zM4 14v-2h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImWrench(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.671 12.779l-7.196-6.168c0.335-0.63 0.525-1.348 0.525-2.111 0-2.485-2.015-4.5-4.5-4.5-0.455 0-0.893 0.068-1.307 0.193l2.6 2.6c0.389 0.389 0.389 1.025 0 1.414l-1.586 1.586c-0.389 0.389-1.025 0.389-1.414 0l-2.6-2.6c-0.125 0.414-0.193 0.852-0.193 1.307 0 2.485 2.015 4.5 4.5 4.5 0.763 0 1.482-0.19 2.111-0.525l6.168 7.196c0.358 0.418 0.969 0.441 1.358 0.052l1.586-1.586c0.389-0.389 0.365-1-0.052-1.358z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUnlocked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1c1.654 0 3 1.346 3 3v3h-2v-3c0-0.551-0.449-1-1-1h-2c-0.551 0-1 0.449-1 1v3h0.25c0.412 0 0.75 0.338 0.75 0.75v7.5c0 0.412-0.338 0.75-0.75 0.75h-8.5c-0.412 0-0.75-0.338-0.75-0.75v-7.5c0-0.412 0.338-0.75 0.75-0.75h6.25v-3c0-1.654 1.346-3 3-3h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.25 7h-0.25v-3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v7.5c0 0.412 0.338 0.75 0.75 0.75h8.5c0.412 0 0.75-0.338 0.75-0.75v-7.5c0-0.412-0.338-0.75-0.75-0.75zM3 4c0-0.551 0.449-1 1-1h2c0.551 0 1 0.449 1 1v3h-4v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImKey2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.658 4.91l-1.58-1.58c-0.387-0.387-1.021-1.021-1.409-1.409l-1.58-1.58c-0.387-0.387-1.077-0.456-1.533-0.152l-4.319 2.88c-0.456 0.304-0.628 0.954-0.383 1.444l1.101 2.203c0.034 0.067 0.073 0.139 0.115 0.213l-5.571 5.571-0.5 3.5h3v-1h2v-2h2v-2h2v-1.112c0.1 0.060 0.196 0.113 0.284 0.157l2.203 1.101c0.49 0.245 1.14 0.072 1.444-0.383l2.88-4.319c0.304-0.456 0.236-1.146-0.152-1.533zM2.354 13.354l-0.707-0.707 4.868-4.868 0.707 0.707-4.868 4.868zM14.328 6.621l-0.707 0.707c-0.194 0.194-0.513 0.194-0.707 0l-4.243-4.243c-0.194-0.194-0.194-0.513 0-0.707l0.707-0.707c0.194-0.194 0.513-0.194 0.707 0l4.243 4.243c0.194 0.194 0.194 0.513 0 0.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 0c-2.761 0-5 2.239-5 5 0 0.313 0.029 0.619 0.084 0.916l-6.084 6.084v3c0 0.552 0.448 1 1 1h1v-1h2v-2h2v-2h2l1.298-1.298c0.531 0.192 1.105 0.298 1.702 0.298 2.761 0 5-2.239 5-5s-2.239-5-5-5zM12.498 5.002c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImShrink2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9v6.5l-2.5-2.5-3 3-1.5-1.5 3-3-2.5-2.5zM16 1.5l-3 3 2.5 2.5h-6.5v-6.5l2.5 2.5 3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEnlarge2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 0v6.5l-2.5-2.5-3 3-1.5-1.5 3-3-2.5-2.5zM7 10.5l-3 3 2.5 2.5h-6.5v-6.5l2.5 2.5 3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImShrink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEnlarge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 0h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 16h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImZoomOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM3 5h6v2h-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImZoomIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM7 3h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSearch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBinoculars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 0h6v1h-6zM9 0h6v1h-6zM14.875 5h-0.875v-4h-4v4h-4v-4h-4v4h-0.875c-0.619 0-1.125 0.506-1.125 1.125v8.75c0 0.619 0.506 1.125 1.125 1.125h4.75c0.619 0 1.125-0.506 1.125-1.125v-5.875h2v5.875c0 0.619 0.506 1.125 1.125 1.125h4.75c0.619 0 1.125-0.506 1.125-1.125v-8.75c0-0.619-0.506-1.125-1.125-1.125zM5.438 15h-3.875c-0.309 0-0.563-0.225-0.563-0.5s0.253-0.5 0.563-0.5h3.875c0.309 0 0.563 0.225 0.563 0.5s-0.253 0.5-0.563 0.5zM8.5 8h-1c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h1c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5zM14.438 15h-3.875c-0.309 0-0.563-0.225-0.563-0.5s0.253-0.5 0.563-0.5h3.875c0.309 0 0.563 0.225 0.563 0.5s-0.253 0.5-0.563 0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner11(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6h-6l2.243-2.243c-1.133-1.133-2.64-1.757-4.243-1.757s-3.109 0.624-4.243 1.757c-1.133 1.133-1.757 2.64-1.757 4.243s0.624 3.109 1.757 4.243c1.133 1.133 2.64 1.757 4.243 1.757s3.109-0.624 4.243-1.757c0.095-0.095 0.185-0.192 0.273-0.292l1.505 1.317c-1.466 1.674-3.62 2.732-6.020 2.732-4.418 0-8-3.582-8-8s3.582-8 8-8c2.209 0 4.209 0.896 5.656 2.344l2.343-2.344v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner10(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.001 8.025l-0 0c0 0 0 0.001 0 0.003 0.002 0.061 0.009 0.12 0.021 0.177 0.003 0.027 0.007 0.057 0.011 0.090 0.003 0.029 0.007 0.061 0.011 0.095 0.006 0.040 0.012 0.083 0.019 0.128 0.013 0.090 0.028 0.189 0.045 0.296 0.021 0.101 0.044 0.21 0.068 0.326 0.011 0.058 0.028 0.117 0.044 0.178s0.032 0.123 0.049 0.188c0.009 0.032 0.016 0.065 0.027 0.097s0.021 0.065 0.031 0.098 0.043 0.134 0.065 0.203c0.006 0.017 0.011 0.035 0.017 0.052s0.013 0.034 0.019 0.052 0.026 0.070 0.039 0.105c0.027 0.070 0.053 0.142 0.081 0.215 0.031 0.071 0.062 0.144 0.094 0.218 0.016 0.037 0.032 0.074 0.048 0.111s0.035 0.073 0.053 0.111 0.073 0.148 0.11 0.224c0.039 0.075 0.081 0.149 0.123 0.224 0.021 0.037 0.042 0.075 0.063 0.113s0.045 0.074 0.068 0.112 0.093 0.149 0.14 0.224c0.198 0.295 0.417 0.587 0.66 0.864 0.245 0.275 0.511 0.535 0.792 0.775 0.284 0.236 0.582 0.452 0.886 0.642 0.306 0.188 0.619 0.349 0.928 0.487 0.078 0.032 0.156 0.063 0.232 0.095 0.038 0.015 0.076 0.032 0.115 0.046s0.077 0.027 0.115 0.041 0.151 0.054 0.226 0.078c0.075 0.022 0.15 0.044 0.224 0.066 0.037 0.011 0.073 0.022 0.109 0.031s0.073 0.018 0.109 0.027 0.143 0.035 0.213 0.052c0.070 0.014 0.139 0.027 0.207 0.040 0.034 0.006 0.067 0.013 0.101 0.019 0.017 0.003 0.033 0.006 0.049 0.009s0.033 0.005 0.049 0.007c0.066 0.009 0.13 0.018 0.192 0.027 0.031 0.004 0.062 0.009 0.093 0.013s0.061 0.006 0.091 0.009 0.118 0.010 0.174 0.015c0.056 0.005 0.111 0.011 0.164 0.012 0.004 0 0.007 0 0.011 0 0.010 0.544 0.453 0.982 1 0.982 0.008 0 0.017-0 0.025-0.001v0c0 0 0.001-0 0.004-0 0.061-0.002 0.12-0.009 0.177-0.021 0.027-0.003 0.057-0.007 0.090-0.011 0.029-0.003 0.061-0.007 0.095-0.011 0.040-0.006 0.083-0.012 0.128-0.019 0.090-0.013 0.189-0.028 0.296-0.045 0.101-0.021 0.21-0.044 0.326-0.068 0.058-0.011 0.117-0.028 0.178-0.044s0.123-0.033 0.188-0.049c0.032-0.009 0.065-0.016 0.097-0.027s0.065-0.021 0.098-0.031 0.134-0.043 0.203-0.065c0.017-0.006 0.035-0.011 0.052-0.017s0.034-0.013 0.052-0.019 0.070-0.026 0.105-0.039c0.070-0.027 0.142-0.053 0.215-0.081 0.071-0.031 0.144-0.062 0.218-0.094 0.037-0.016 0.074-0.032 0.111-0.048s0.073-0.035 0.111-0.053 0.148-0.073 0.224-0.11c0.075-0.039 0.149-0.081 0.224-0.123 0.037-0.021 0.075-0.042 0.113-0.063s0.074-0.045 0.112-0.068 0.149-0.093 0.224-0.14c0.295-0.197 0.587-0.417 0.864-0.66 0.275-0.245 0.535-0.511 0.775-0.792 0.236-0.284 0.452-0.582 0.642-0.886 0.188-0.306 0.349-0.619 0.487-0.928 0.032-0.078 0.063-0.156 0.095-0.232 0.015-0.038 0.032-0.076 0.046-0.115s0.027-0.077 0.040-0.115 0.054-0.151 0.078-0.226c0.022-0.075 0.044-0.15 0.066-0.224 0.011-0.037 0.022-0.073 0.031-0.109s0.018-0.073 0.027-0.109 0.035-0.143 0.052-0.213c0.014-0.070 0.027-0.139 0.040-0.207 0.006-0.034 0.013-0.067 0.019-0.101 0.003-0.017 0.006-0.033 0.009-0.049s0.005-0.033 0.007-0.050c0.009-0.065 0.018-0.13 0.027-0.192 0.004-0.031 0.009-0.062 0.013-0.093s0.006-0.061 0.009-0.091 0.010-0.118 0.015-0.174c0.005-0.056 0.011-0.111 0.012-0.165 0-0.008 0.001-0.016 0.001-0.025 0.55-0.002 0.996-0.449 0.996-1 0-0.008-0-0.017-0.001-0.025h0c0 0-0-0.001-0-0.003-0.002-0.061-0.009-0.12-0.021-0.177-0.003-0.027-0.007-0.057-0.011-0.090-0.003-0.029-0.007-0.061-0.011-0.095-0.006-0.040-0.012-0.083-0.019-0.128-0.013-0.090-0.028-0.189-0.045-0.296-0.021-0.101-0.044-0.21-0.068-0.326-0.011-0.058-0.028-0.117-0.044-0.178s-0.032-0.123-0.049-0.188c-0.009-0.032-0.016-0.065-0.027-0.097s-0.021-0.065-0.031-0.098-0.043-0.134-0.065-0.203c-0.005-0.017-0.011-0.035-0.017-0.052s-0.013-0.034-0.019-0.052-0.026-0.070-0.039-0.105c-0.027-0.070-0.053-0.142-0.081-0.215-0.031-0.071-0.062-0.144-0.094-0.218-0.016-0.037-0.032-0.074-0.048-0.111s-0.035-0.073-0.053-0.111-0.073-0.148-0.11-0.224c-0.039-0.075-0.081-0.149-0.123-0.224-0.021-0.037-0.042-0.075-0.063-0.113s-0.045-0.074-0.068-0.112-0.093-0.149-0.14-0.224c-0.197-0.295-0.417-0.587-0.66-0.864-0.245-0.275-0.511-0.535-0.792-0.775-0.284-0.236-0.582-0.452-0.886-0.642-0.306-0.188-0.619-0.349-0.928-0.487-0.078-0.032-0.156-0.063-0.232-0.095-0.038-0.015-0.076-0.032-0.115-0.046s-0.077-0.027-0.115-0.040-0.151-0.054-0.226-0.078c-0.075-0.022-0.15-0.044-0.224-0.066-0.037-0.010-0.073-0.022-0.109-0.031s-0.073-0.018-0.109-0.027-0.143-0.035-0.213-0.052c-0.070-0.014-0.139-0.027-0.207-0.040-0.034-0.006-0.067-0.013-0.101-0.019-0.017-0.003-0.033-0.006-0.049-0.009s-0.033-0.005-0.049-0.007c-0.066-0.009-0.13-0.018-0.192-0.027-0.031-0.004-0.062-0.009-0.093-0.013s-0.061-0.006-0.091-0.009-0.118-0.010-0.174-0.015c-0.056-0.005-0.111-0.011-0.164-0.012-0.013-0-0.026-0.001-0.039-0.001-0.010-0.543-0.454-0.981-0.999-0.981-0.008 0-0.017 0-0.025 0.001l-0-0c0 0-0.001 0-0.003 0-0.061 0.002-0.12 0.009-0.177 0.021-0.027 0.003-0.057 0.007-0.090 0.011-0.029 0.003-0.061 0.007-0.095 0.011-0.040 0.006-0.083 0.012-0.128 0.019-0.090 0.013-0.189 0.028-0.296 0.045-0.101 0.021-0.21 0.044-0.326 0.068-0.058 0.011-0.117 0.028-0.178 0.044s-0.123 0.033-0.188 0.049c-0.032 0.009-0.065 0.016-0.097 0.027s-0.065 0.021-0.098 0.031-0.134 0.043-0.203 0.065c-0.017 0.006-0.035 0.011-0.052 0.017s-0.034 0.013-0.052 0.019-0.070 0.026-0.105 0.039c-0.070 0.027-0.142 0.053-0.215 0.081-0.071 0.031-0.144 0.062-0.218 0.094-0.037 0.016-0.074 0.032-0.111 0.048s-0.073 0.035-0.111 0.053-0.148 0.073-0.224 0.11c-0.075 0.039-0.149 0.081-0.224 0.123-0.037 0.021-0.075 0.042-0.113 0.063s-0.074 0.045-0.112 0.068-0.149 0.093-0.224 0.14c-0.295 0.198-0.587 0.417-0.864 0.66-0.275 0.245-0.535 0.511-0.775 0.792-0.236 0.284-0.452 0.582-0.642 0.886-0.188 0.306-0.349 0.619-0.487 0.928-0.032 0.078-0.063 0.156-0.095 0.232-0.015 0.038-0.032 0.076-0.046 0.115s-0.027 0.077-0.040 0.115-0.054 0.151-0.078 0.226c-0.022 0.075-0.044 0.15-0.066 0.224-0.011 0.037-0.022 0.073-0.032 0.109s-0.018 0.073-0.027 0.109-0.035 0.143-0.052 0.213c-0.014 0.070-0.027 0.139-0.040 0.207-0.006 0.034-0.013 0.067-0.019 0.101-0.003 0.017-0.006 0.033-0.009 0.049s-0.005 0.033-0.007 0.050c-0.009 0.065-0.018 0.13-0.027 0.192-0.004 0.031-0.009 0.062-0.013 0.093s-0.006 0.061-0.009 0.091-0.010 0.118-0.015 0.174c-0.005 0.056-0.011 0.111-0.012 0.165-0 0.009-0.001 0.017-0.001 0.025-0.537 0.017-0.967 0.458-0.967 0.999 0 0.008 0 0.017 0.001 0.025zM1.149 7.011c0.001-0.003 0.001-0.006 0.002-0.009 0.010-0.051 0.026-0.102 0.040-0.155s0.030-0.107 0.045-0.163c0.008-0.028 0.015-0.056 0.024-0.084s0.019-0.057 0.028-0.086 0.038-0.116 0.058-0.176c0.005-0.015 0.010-0.030 0.015-0.045s0.012-0.030 0.017-0.045 0.023-0.060 0.035-0.091 0.048-0.123 0.073-0.186c0.028-0.062 0.056-0.125 0.084-0.189 0.014-0.032 0.028-0.064 0.043-0.096s0.032-0.064 0.048-0.096 0.065-0.128 0.098-0.194c0.034-0.065 0.073-0.128 0.109-0.194 0.018-0.032 0.037-0.065 0.056-0.098s0.040-0.064 0.061-0.096c0.041-0.064 0.082-0.129 0.124-0.194 0.176-0.255 0.369-0.506 0.583-0.744 0.217-0.236 0.451-0.459 0.697-0.665 0.25-0.202 0.511-0.385 0.776-0.547 0.268-0.159 0.541-0.294 0.808-0.41 0.068-0.027 0.135-0.053 0.202-0.079 0.033-0.013 0.066-0.027 0.099-0.038s0.067-0.022 0.1-0.033 0.131-0.045 0.196-0.065c0.065-0.018 0.13-0.036 0.194-0.054 0.032-0.009 0.063-0.019 0.095-0.026s0.063-0.014 0.094-0.021 0.123-0.028 0.184-0.042c0.061-0.011 0.12-0.021 0.179-0.032 0.029-0.005 0.058-0.010 0.087-0.015 0.014-0.003 0.029-0.005 0.043-0.008s0.029-0.003 0.043-0.005c0.056-0.007 0.112-0.014 0.166-0.020 0.027-0.003 0.053-0.007 0.080-0.010s0.053-0.004 0.078-0.006 0.102-0.007 0.15-0.011c0.049-0.003 0.095-0.008 0.142-0.008 0.091-0.002 0.177-0.004 0.256-0.006 0.073 0.003 0.14 0.005 0.2 0.007 0.030 0.001 0.058 0.002 0.085 0.002 0.033 0.002 0.064 0.004 0.093 0.006 0.033 0.002 0.063 0.004 0.091 0.006 0.051 0.008 0.103 0.012 0.156 0.012 0.007 0 0.015-0 0.022-0.001 0.002 0 0.004 0 0.004 0v-0c0.487-0.012 0.887-0.372 0.962-0.84 0.008 0.002 0.017 0.004 0.025 0.006 0.051 0.010 0.102 0.026 0.155 0.040s0.107 0.030 0.163 0.045c0.028 0.008 0.056 0.015 0.084 0.024s0.057 0.019 0.086 0.028 0.116 0.038 0.176 0.058c0.015 0.005 0.030 0.010 0.045 0.015s0.030 0.012 0.045 0.017 0.060 0.023 0.091 0.035 0.123 0.048 0.186 0.073c0.062 0.028 0.125 0.056 0.189 0.084 0.032 0.014 0.064 0.028 0.096 0.043s0.064 0.032 0.096 0.048 0.128 0.065 0.194 0.098c0.065 0.034 0.129 0.073 0.194 0.109 0.032 0.018 0.065 0.037 0.098 0.056s0.064 0.040 0.096 0.061 0.129 0.082 0.194 0.124c0.255 0.176 0.506 0.369 0.744 0.583 0.236 0.217 0.459 0.451 0.665 0.697 0.202 0.25 0.385 0.511 0.547 0.776 0.159 0.268 0.294 0.541 0.41 0.808 0.027 0.068 0.053 0.135 0.079 0.202 0.013 0.033 0.027 0.066 0.038 0.099s0.022 0.067 0.033 0.1 0.045 0.131 0.065 0.196c0.018 0.065 0.036 0.13 0.054 0.194 0.009 0.032 0.019 0.063 0.026 0.095s0.014 0.063 0.021 0.094 0.028 0.123 0.042 0.184c0.011 0.061 0.021 0.12 0.032 0.179 0.005 0.029 0.010 0.058 0.015 0.087 0.003 0.014 0.005 0.029 0.008 0.043s0.003 0.029 0.005 0.043c0.007 0.056 0.014 0.112 0.020 0.166 0.003 0.027 0.007 0.053 0.010 0.080s0.004 0.053 0.006 0.078 0.007 0.102 0.011 0.15c0.003 0.049 0.008 0.095 0.008 0.142 0.002 0.091 0.004 0.177 0.006 0.256-0.003 0.073-0.005 0.14-0.007 0.2-0.001 0.030-0.002 0.058-0.002 0.085-0.002 0.033-0.004 0.064-0.006 0.093-0.002 0.033-0.004 0.063-0.006 0.091-0.008 0.051-0.012 0.103-0.012 0.156 0 0.007 0 0.015 0.001 0.022-0 0.002-0 0.004-0 0.004h0c0.012 0.481 0.363 0.877 0.823 0.959-0.001 0.005-0.002 0.009-0.003 0.014-0.010 0.051-0.025 0.102-0.040 0.155s-0.030 0.107-0.045 0.163c-0.008 0.028-0.015 0.056-0.024 0.084s-0.019 0.057-0.028 0.086-0.039 0.116-0.058 0.176c-0.005 0.015-0.010 0.030-0.015 0.045s-0.012 0.030-0.017 0.045-0.023 0.060-0.035 0.091-0.048 0.123-0.073 0.186c-0.028 0.062-0.056 0.125-0.084 0.189-0.014 0.032-0.028 0.064-0.043 0.096s-0.032 0.064-0.048 0.096-0.065 0.128-0.098 0.194c-0.034 0.065-0.073 0.129-0.109 0.194-0.018 0.032-0.037 0.065-0.056 0.098s-0.040 0.064-0.061 0.096-0.082 0.129-0.124 0.194c-0.176 0.255-0.369 0.506-0.583 0.744-0.217 0.236-0.451 0.459-0.697 0.665-0.25 0.202-0.511 0.385-0.776 0.547-0.268 0.159-0.541 0.294-0.808 0.41-0.068 0.027-0.135 0.053-0.202 0.079-0.033 0.013-0.066 0.027-0.099 0.038s-0.067 0.022-0.1 0.033-0.131 0.045-0.196 0.065c-0.065 0.018-0.13 0.036-0.194 0.054-0.032 0.009-0.063 0.019-0.095 0.026s-0.063 0.014-0.094 0.021-0.123 0.028-0.184 0.042c-0.061 0.011-0.12 0.021-0.179 0.032-0.029 0.005-0.058 0.010-0.087 0.015-0.014 0.003-0.028 0.005-0.043 0.008s-0.029 0.003-0.043 0.005c-0.056 0.007-0.112 0.014-0.166 0.020-0.027 0.003-0.053 0.007-0.080 0.010s-0.053 0.004-0.078 0.006-0.102 0.007-0.15 0.011c-0.049 0.003-0.095 0.008-0.142 0.008-0.091 0.002-0.177 0.004-0.256 0.006-0.073-0.003-0.14-0.005-0.2-0.007-0.030-0.001-0.058-0.002-0.085-0.002-0.033-0.002-0.064-0.004-0.093-0.006-0.033-0.002-0.063-0.004-0.091-0.006-0.051-0.008-0.103-0.012-0.156-0.012-0.007 0-0.015 0-0.022 0.001-0.002-0-0.003-0-0.003-0v0c-0.484 0.012-0.883 0.369-0.961 0.834-0.050-0.010-0.101-0.025-0.153-0.039s-0.107-0.030-0.163-0.045c-0.028-0.008-0.056-0.015-0.084-0.024s-0.057-0.019-0.086-0.028-0.116-0.039-0.176-0.058c-0.015-0.005-0.030-0.010-0.045-0.015s-0.030-0.012-0.045-0.017-0.060-0.023-0.091-0.035-0.123-0.048-0.186-0.073c-0.062-0.028-0.125-0.056-0.189-0.084-0.032-0.014-0.064-0.028-0.096-0.043s-0.064-0.032-0.096-0.048-0.128-0.065-0.194-0.098c-0.065-0.034-0.129-0.073-0.194-0.109-0.032-0.018-0.065-0.037-0.098-0.056s-0.064-0.040-0.096-0.061c-0.064-0.041-0.129-0.082-0.194-0.124-0.255-0.175-0.506-0.369-0.744-0.583-0.236-0.217-0.459-0.451-0.665-0.697-0.202-0.25-0.385-0.511-0.547-0.776-0.159-0.268-0.294-0.541-0.41-0.808-0.027-0.068-0.053-0.135-0.079-0.202-0.013-0.033-0.027-0.066-0.038-0.099s-0.022-0.067-0.033-0.1-0.045-0.131-0.065-0.196c-0.018-0.065-0.036-0.13-0.054-0.194-0.009-0.032-0.019-0.063-0.026-0.095s-0.014-0.063-0.021-0.094-0.028-0.123-0.042-0.184c-0.011-0.061-0.021-0.12-0.032-0.179-0.005-0.029-0.010-0.058-0.015-0.087-0.003-0.014-0.005-0.028-0.008-0.043s-0.003-0.029-0.005-0.043c-0.007-0.056-0.014-0.112-0.020-0.166-0.003-0.027-0.007-0.053-0.010-0.080s-0.004-0.053-0.006-0.078-0.007-0.101-0.011-0.15c-0.003-0.049-0.008-0.095-0.008-0.142-0.002-0.091-0.004-0.177-0.006-0.256 0.003-0.073 0.005-0.14 0.007-0.2 0.001-0.030 0.002-0.058 0.002-0.085 0.002-0.033 0.004-0.064 0.006-0.093 0.002-0.033 0.004-0.063 0.006-0.091 0.008-0.051 0.012-0.103 0.012-0.156 0-0.007-0-0.015-0.001-0.022 0-0.002 0-0.003 0-0.003h-0c-0.012-0.49-0.377-0.893-0.851-0.964z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner9(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.355 0-7.898 3.481-7.998 7.812 0.092-3.779 2.966-6.812 6.498-6.812 3.59 0 6.5 3.134 6.5 7 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-4.418-3.582-8-8-8zM8 16c4.355 0 7.898-3.481 7.998-7.812-0.092 3.779-2.966 6.812-6.498 6.812-3.59 0-6.5-3.134-6.5-7 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 4.418 3.582 8 8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner8(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c-2.137 0-4.146-0.832-5.657-2.343s-2.343-3.52-2.343-5.657c0-1.513 0.425-2.986 1.228-4.261 0.781-1.239 1.885-2.24 3.193-2.895l0.672 1.341c-1.063 0.533-1.961 1.347-2.596 2.354-0.652 1.034-0.997 2.231-0.997 3.461 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-1.23-0.345-2.426-0.997-3.461-0.635-1.008-1.533-1.822-2.596-2.354l0.672-1.341c1.308 0.655 2.412 1.656 3.193 2.895 0.803 1.274 1.228 2.748 1.228 4.261 0 2.137-0.832 4.146-2.343 5.657s-3.52 2.343-5.657 2.343z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner7(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM0 8c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM13 8c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM1.904 3.404c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11.096 12.596c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM1.904 12.596c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11.096 3.404c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner6(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM12.359 8c0 0 0 0 0 0 0-0.906 0.735-1.641 1.641-1.641s1.641 0.735 1.641 1.641c0 0 0 0 0 0 0 0.906-0.735 1.641-1.641 1.641s-1.641-0.735-1.641-1.641zM10.757 12.243c0-0.821 0.665-1.486 1.486-1.486s1.486 0.665 1.486 1.486c0 0.821-0.665 1.486-1.486 1.486s-1.486-0.665-1.486-1.486zM6.654 14c0-0.743 0.603-1.346 1.346-1.346s1.346 0.603 1.346 1.346c0 0.743-0.603 1.346-1.346 1.346s-1.346-0.603-1.346-1.346zM2.538 12.243c0-0.673 0.546-1.219 1.219-1.219s1.219 0.546 1.219 1.219c0 0.673-0.546 1.219-1.219 1.219s-1.219-0.546-1.219-1.219zM0.896 8c0-0.61 0.494-1.104 1.104-1.104s1.104 0.494 1.104 1.104c0 0.61-0.494 1.104-1.104 1.104s-1.104-0.494-1.104-1.104zM2.757 3.757c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM14.054 3.757c0 1-0.811 1.811-1.812 1.811s-1.812-0.811-1.812-1.811c0-1.001 0.811-1.811 1.812-1.811s1.812 0.811 1.812 1.811z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner5(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 4c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4zM12.773 12.773c-1.275 1.275-2.97 1.977-4.773 1.977s-3.498-0.702-4.773-1.977-1.977-2.97-1.977-4.773c0-1.803 0.702-3.498 1.977-4.773l1.061 1.061c0 0 0 0 0 0-2.047 2.047-2.047 5.378 0 7.425 0.992 0.992 2.31 1.538 3.712 1.538s2.721-0.546 3.712-1.538c2.047-2.047 2.047-5.378 0-7.425l1.061-1.061c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8c0-0.19 0.011-0.378 0.032-0.563l-2.89-0.939c-0.092 0.487-0.141 0.989-0.141 1.502 0 2.3 0.971 4.374 2.526 5.833l1.786-2.458c-0.814-0.889-1.312-2.074-1.312-3.375zM13 8c0 1.301-0.497 2.486-1.312 3.375l1.786 2.458c1.555-1.459 2.526-3.533 2.526-5.833 0-0.513-0.049-1.015-0.141-1.502l-2.89 0.939c0.021 0.185 0.032 0.373 0.032 0.563zM9 3.1c1.436 0.292 2.649 1.199 3.351 2.435l2.89-0.939c-1.144-2.428-3.473-4.188-6.241-4.534v3.038zM3.649 5.535c0.702-1.236 1.914-2.143 3.351-2.435v-3.038c-2.769 0.345-5.097 2.105-6.241 4.534l2.89 0.939zM10.071 12.552c-0.631 0.288-1.332 0.448-2.071 0.448s-1.44-0.16-2.071-0.448l-1.786 2.458c1.144 0.631 2.458 0.99 3.857 0.99s2.713-0.359 3.857-0.99l-1.786-2.458z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.736c-0.515 0-0.933-0.418-0.933-0.933v-2.798c0-0.515 0.418-0.933 0.933-0.933s0.933 0.418 0.933 0.933v2.798c0 0.515-0.418 0.933-0.933 0.933z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15.577c-0.322 0-0.583-0.261-0.583-0.583v-2.798c0-0.322 0.261-0.583 0.583-0.583s0.583 0.261 0.583 0.583v2.798c0 0.322-0.261 0.583-0.583 0.583z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.902 5.24c-0.302 0-0.596-0.157-0.758-0.437l-1.399-2.423c-0.241-0.418-0.098-0.953 0.32-1.194s0.953-0.098 1.194 0.32l1.399 2.423c0.241 0.418 0.098 0.953-0.32 1.194-0.138 0.079-0.288 0.117-0.436 0.117z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.498 14.582c-0.181 0-0.358-0.094-0.455-0.262l-1.399-2.423c-0.145-0.251-0.059-0.572 0.192-0.717s0.572-0.059 0.717 0.192l1.399 2.423c0.145 0.251 0.059 0.572-0.192 0.717-0.083 0.048-0.173 0.070-0.262 0.070z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.365 6.718c-0.138 0-0.279-0.035-0.407-0.109l-2.423-1.399c-0.39-0.225-0.524-0.724-0.299-1.115s0.724-0.524 1.115-0.299l2.423 1.399c0.39 0.225 0.524 0.724 0.299 1.115-0.151 0.262-0.425 0.408-0.707 0.408z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.057 11.964c-0.079 0-0.159-0.020-0.233-0.063l-2.423-1.399c-0.223-0.129-0.299-0.414-0.171-0.637s0.414-0.299 0.637-0.171l2.423 1.399c0.223 0.129 0.299 0.414 0.171 0.637-0.086 0.15-0.243 0.233-0.404 0.233z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.803 8.758h-2.798c-0.418 0-0.758-0.339-0.758-0.758s0.339-0.758 0.758-0.758h2.798c0.419 0 0.758 0.339 0.758 0.758s-0.339 0.758-0.758 0.758z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.995 8.466c-0 0 0 0 0 0h-2.798c-0.258-0-0.466-0.209-0.466-0.466s0.209-0.466 0.466-0.466c0 0 0 0 0 0h2.798c0.258 0 0.466 0.209 0.466 0.466s-0.209 0.466-0.466 0.466z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.943 12.197c-0.242 0-0.477-0.125-0.606-0.35-0.193-0.335-0.079-0.762 0.256-0.955l2.423-1.399c0.335-0.193 0.762-0.079 0.955 0.256s0.079 0.762-0.256 0.955l-2.423 1.399c-0.11 0.064-0.23 0.094-0.349 0.094z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.635 6.368c-0.161 0-0.318-0.084-0.404-0.233-0.129-0.223-0.052-0.508 0.171-0.637l2.423-1.399c0.223-0.129 0.508-0.052 0.637 0.171s0.052 0.508-0.171 0.637l-2.423 1.399c-0.073 0.042-0.154 0.063-0.233 0.063z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.502 14.699c-0.109 0-0.219-0.028-0.32-0.086-0.307-0.177-0.412-0.569-0.235-0.876l1.399-2.423c0.177-0.307 0.569-0.412 0.876-0.235s0.412 0.569 0.235 0.876l-1.399 2.423c-0.119 0.206-0.334 0.321-0.556 0.321z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.098 4.832c-0.079 0-0.159-0.020-0.233-0.063-0.223-0.129-0.299-0.414-0.171-0.637l1.399-2.423c0.129-0.223 0.414-0.299 0.637-0.171s0.299 0.414 0.171 0.637l-1.399 2.423c-0.086 0.15-0.243 0.233-0.404 0.233z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c-0.020-1.045-0.247-2.086-0.665-3.038-0.417-0.953-1.023-1.817-1.766-2.53s-1.624-1.278-2.578-1.651c-0.953-0.374-1.978-0.552-2.991-0.531-1.013 0.020-2.021 0.24-2.943 0.646-0.923 0.405-1.758 0.992-2.449 1.712s-1.237 1.574-1.597 2.497c-0.361 0.923-0.533 1.914-0.512 2.895 0.020 0.981 0.234 1.955 0.627 2.847 0.392 0.892 0.961 1.7 1.658 2.368s1.523 1.195 2.416 1.543c0.892 0.348 1.851 0.514 2.799 0.493 0.949-0.020 1.89-0.227 2.751-0.608 0.862-0.379 1.642-0.929 2.287-1.604s1.154-1.472 1.488-2.335c0.204-0.523 0.342-1.069 0.415-1.622 0.019 0.001 0.039 0.002 0.059 0.002 0.552 0 1-0.448 1-1 0-0.028-0.001-0.056-0.004-0.083h0.004zM14.411 10.655c-0.367 0.831-0.898 1.584-1.55 2.206s-1.422 1.112-2.254 1.434c-0.832 0.323-1.723 0.476-2.608 0.454-0.884-0.020-1.759-0.215-2.56-0.57-0.801-0.354-1.526-0.867-2.125-1.495s-1.071-1.371-1.38-2.173c-0.31-0.801-0.457-1.66-0.435-2.512s0.208-1.694 0.551-2.464c0.342-0.77 0.836-1.468 1.441-2.044s1.321-1.029 2.092-1.326c0.771-0.298 1.596-0.438 2.416-0.416s1.629 0.202 2.368 0.532c0.74 0.329 1.41 0.805 1.963 1.387s0.988 1.27 1.272 2.011c0.285 0.74 0.418 1.532 0.397 2.32h0.004c-0.002 0.027-0.004 0.055-0.004 0.083 0 0.516 0.39 0.94 0.892 0.994-0.097 0.544-0.258 1.075-0.481 1.578z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpinner(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10.243 3.757c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM13 8c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.243 12.243c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM7 14c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM2.757 12.243c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM2.257 3.757c0 0 0 0 0 0 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM0.875 8c0-0.621 0.504-1.125 1.125-1.125s1.125 0.504 1.125 1.125c0 0.621-0.504 1.125-1.125 1.125s-1.125-0.504-1.125-1.125z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHourGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.39 8c2.152-1.365 3.61-3.988 3.61-7 0-0.339-0.019-0.672-0.054-1h-13.891c-0.036 0.328-0.054 0.661-0.054 1 0 3.012 1.457 5.635 3.609 7-2.152 1.365-3.609 3.988-3.609 7 0 0.339 0.019 0.672 0.054 1h13.891c0.036-0.328 0.054-0.661 0.054-1 0-3.012-1.457-5.635-3.609-7zM2.5 15c0-2.921 1.253-5.397 3.5-6.214v-1.572c-2.247-0.817-3.5-3.294-3.5-6.214v0h11c0 2.921-1.253 5.397-3.5 6.214v1.572c2.247 0.817 3.5 3.294 3.5 6.214h-11zM9.682 10.462c-1.12-0.635-1.181-1.459-1.182-1.959v-1.004c0-0.5 0.059-1.327 1.184-1.963 0.602-0.349 1.122-0.88 1.516-1.537h-6.4c0.395 0.657 0.916 1.188 1.518 1.538 1.12 0.635 1.181 1.459 1.182 1.959v1.004c0 0.5-0.059 1.327-1.184 1.963-1.135 0.659-1.98 1.964-2.236 3.537h7.839c-0.256-1.574-1.102-2.879-2.238-3.538z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImQuotesRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 10c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5l0.016 0.5c0 3.866-3.134 7-7 7v-2c1.336 0 2.591-0.52 3.536-1.464 0.182-0.182 0.348-0.375 0.497-0.578-0.179 0.028-0.362 0.043-0.549 0.043zM3.5 10c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5l0.016 0.5c0 3.866-3.134 7-7 7v-2c1.336 0 2.591-0.52 3.536-1.464 0.182-0.182 0.348-0.375 0.497-0.578-0.179 0.028-0.362 0.043-0.549 0.043z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImQuotesLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.548-0.043zM12.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.549-0.043z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUserTie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3zM12.001 7h-0.553l-3.111 6.316 1.163-5.816-1.5-1.5-1.5 1.5 1.163 5.816-3.111-6.316h-0.554c-1.999 0-1.999 1.344-1.999 3v5h12v-5c0-1.656 0-3-1.999-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUserCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.5l-4.5 4.5-1.5-1.5-1 1 2.5 2.5 5.5-5.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h5v-1.799c-1.050-0.613-2.442-1.033-4-1.16v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h7v-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUserMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM14 12h-5v-1h5v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUserPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM14 12h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUsers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.112 12.427c0.864-0.565 1.939-0.994 3.122-1.256-0.235-0.278-0.449-0.588-0.633-0.922-0.475-0.863-0.726-1.813-0.726-2.748 0-1.344 0-2.614 0.478-3.653 0.464-1.008 1.299-1.633 2.488-1.867-0.264-1.195-0.968-1.98-2.841-1.98-3 0-3 2.015-3 4.5 0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h4.359c0.227-0.202 0.478-0.393 0.753-0.573z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBubbles4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 2c-0.792 0-1.556 0.124-2.272 0.369-0.671 0.23-1.267 0.554-1.773 0.963-0.938 0.759-1.455 1.731-1.455 2.737 0 0.562 0.157 1.109 0.467 1.623 0.323 0.537 0.811 1.028 1.41 1.421 0.476 0.312 0.796 0.812 0.881 1.374 0.014 0.094 0.025 0.188 0.034 0.282 0.043-0.039 0.085-0.080 0.127-0.122 0.377-0.376 0.886-0.583 1.411-0.583 0.084 0 0.167 0.005 0.251 0.016 0.303 0.038 0.611 0.058 0.918 0.058 0.792 0 1.556-0.124 2.272-0.369 0.671-0.23 1.267-0.554 1.774-0.963 0.938-0.759 1.455-1.731 1.455-2.737s-0.517-1.978-1.455-2.737c-0.506-0.41-1.103-0.734-1.774-0.963-0.716-0.245-1.48-0.369-2.272-0.369zM7.5 0v0c4.142 0 7.5 2.717 7.5 6.069s-3.358 6.069-7.5 6.069c-0.398 0-0.788-0.025-1.169-0.074-1.611 1.605-3.471 1.892-5.331 1.935v-0.393c1.004-0.49 1.813-1.382 1.813-2.402 0-0.142-0.011-0.282-0.032-0.419-1.696-1.113-2.781-2.812-2.781-4.717 0-3.352 3.358-6.069 7.5-6.069zM15.563 13.604c0 0.874 0.567 1.639 1.438 2.059v0.337c-1.611-0.036-3.090-0.283-4.487-1.658-0.33 0.041-0.669 0.063-1.013 0.063-1.492 0-2.866-0.402-3.963-1.079 2.261-0.008 4.395-0.732 6.013-2.042 0.816-0.66 1.459-1.435 1.913-2.302 0.481-0.92 0.724-1.9 0.724-2.913 0-0.163-0.007-0.326-0.020-0.487 1.134 0.936 1.832 2.213 1.832 3.62 0 1.633-0.94 3.089-2.41 4.043-0.018 0.117-0.027 0.237-0.027 0.359z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBubbles3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14.081c0 0.711 0.407 1.327 1 1.628v0.249c-0.166 0.023-0.335 0.035-0.508 0.035-1.063 0-2.021-0.446-2.699-1.16-0.41 0.109-0.844 0.168-1.293 0.168-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4c2.485 0 4.5 1.791 4.5 4 0 0.865-0.309 1.665-0.834 2.32-0.107 0.232-0.166 0.489-0.166 0.761zM3.604 3.456c-1.035 0.841-1.604 1.922-1.604 3.044 0 0.63 0.175 1.24 0.52 1.815 0.356 0.592 0.89 1.134 1.547 1.566 0.474 0.312 0.793 0.812 0.878 1.373 0.028 0.187 0.046 0.376 0.053 0.564 0.117-0.097 0.23-0.201 0.342-0.312 0.377-0.377 0.887-0.586 1.414-0.586 0.084 0 0.168 0.005 0.252 0.016 0.327 0.042 0.662 0.063 0.994 0.063v2c-0.424-0-0.84-0.027-1.246-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5 4.351 0 7.89 2.822 7.997 6.336-0.642-0.286-1.341-0.46-2.067-0.509-0.18-0.876-0.709-1.7-1.535-2.371-0.552-0.448-1.202-0.803-1.932-1.054-0.777-0.267-1.606-0.402-2.464-0.402s-1.687 0.135-2.464 0.402c-0.73 0.251-1.38 0.605-1.932 1.054z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBubble2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3c-0.858 0-1.687 0.135-2.464 0.402-0.73 0.251-1.38 0.605-1.932 1.054-1.035 0.841-1.604 1.922-1.604 3.044 0 0.63 0.175 1.24 0.52 1.815 0.356 0.592 0.89 1.134 1.547 1.566 0.474 0.312 0.793 0.812 0.878 1.373 0.028 0.187 0.046 0.376 0.053 0.564 0.117-0.097 0.23-0.201 0.342-0.312 0.377-0.377 0.887-0.586 1.414-0.586 0.084 0 0.168 0.005 0.252 0.016 0.328 0.042 0.662 0.063 0.995 0.063 0.858 0 1.687-0.135 2.464-0.402 0.73-0.251 1.38-0.605 1.932-1.054 1.035-0.841 1.604-1.922 1.604-3.044s-0.57-2.203-1.604-3.044c-0.552-0.448-1.202-0.803-1.932-1.054-0.777-0.267-1.606-0.402-2.464-0.402zM8 1v0c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBubbles2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 0v0c4.142 0 7.5 2.717 7.5 6.069s-3.358 6.069-7.5 6.069c-0.398 0-0.788-0.025-1.169-0.074-1.611 1.605-3.471 1.892-5.331 1.935v-0.393c1.004-0.49 1.813-1.382 1.813-2.402 0-0.142-0.011-0.282-0.032-0.419-1.696-1.113-2.781-2.812-2.781-4.717 0-3.352 3.358-6.069 7.5-6.069zM15.563 13.604c0 0.874 0.567 1.639 1.438 2.059v0.337c-1.611-0.036-3.090-0.283-4.487-1.658-0.33 0.041-0.669 0.063-1.013 0.063-1.492 0-2.866-0.402-3.963-1.079 2.261-0.008 4.395-0.732 6.013-2.042 0.816-0.66 1.459-1.435 1.913-2.302 0.481-0.92 0.724-1.9 0.724-2.913 0-0.163-0.007-0.326-0.020-0.487 1.134 0.936 1.832 2.213 1.832 3.62 0 1.633-0.94 3.089-2.41 4.043-0.018 0.117-0.027 0.237-0.027 0.359z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBubbles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14.081c0 0.711 0.407 1.327 1 1.628v0.249c-0.166 0.023-0.335 0.035-0.508 0.035-1.063 0-2.021-0.446-2.699-1.16-0.41 0.109-0.844 0.168-1.293 0.168-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4c2.485 0 4.5 1.791 4.5 4 0 0.865-0.309 1.665-0.834 2.32-0.107 0.232-0.166 0.489-0.166 0.761zM8 0c4.351 0 7.89 2.822 7.997 6.336-0.768-0.343-1.619-0.524-2.497-0.524-1.493 0-2.903 0.523-3.971 1.472-1.107 0.984-1.717 2.304-1.717 3.716 0 0.698 0.149 1.373 0.433 1.997-0.082 0.002-0.164 0.003-0.246 0.003-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBubble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImReply(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12.119v3.881l-6-6 6-6v3.966c6.98 0.164 6.681-4.747 4.904-7.966 4.386 4.741 3.455 12.337-4.904 12.119z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.096 0c-1.777 3.219-2.076 8.13 4.904 7.966v-3.966l6 6-6 6v-3.881c-8.359 0.218-9.29-7.378-4.904-12.119z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRedo2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3.881v-3.881l6 6-6 6v-3.966c-6.98-0.164-6.681 4.747-4.904 7.966-4.386-4.741-3.455-12.337 4.904-12.119z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUndo2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.904 16c1.777-3.219 2.076-8.13-4.904-7.966v3.966l-6-6 6-6v3.881c8.359-0.218 9.29 7.378 4.904 12.119z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImRedo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 9c0 2.389 1.048 4.534 2.709 6l1.323-1.5c-1.246-1.099-2.031-2.708-2.031-4.5 0-3.314 2.686-6 6-6 1.657 0 3.157 0.672 4.243 1.757l-2.243 2.243h6v-6l-2.343 2.343c-1.448-1.448-3.448-2.343-5.657-2.343-4.418 0-8 3.582-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUndo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c-2.209 0-4.209 0.896-5.657 2.343l-2.343-2.343v6h6l-2.243-2.243c1.086-1.086 2.586-1.757 4.243-1.757 3.314 0 6 2.686 6 6 0 1.792-0.786 3.401-2.032 4.5l1.323 1.5c1.661-1.466 2.709-3.611 2.709-6 0-4.418-3.582-8-8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDatabase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 1.119-8 2.5v2c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-2c0-1.381-3.582-2.5-8-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8.5c-4.418 0-8-1.119-8-2.5v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13c-4.418 0-8-1.119-8-2.5v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDrive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h10c1.657 0 3-1.343 3-3h-16c0 1.657 1.343 3 3 3zM13 12h1v1h-1v-1zM15 2h-14l-1 8h16z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFloppyDisk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-14v16h16v-14l-2-2zM8 2h2v4h-2v-4zM14 14h-12v-12h1v5h9v-5h1.172l0.828 0.828v11.172z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h2v-4h3l-4-4-4 4h3zM10 6.75v1.542l4.579 1.708-6.579 2.453-6.579-2.453 4.579-1.708v-1.542l-6 2.25v4l8 3 8-3v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9l4-4h-3v-4h-2v4h-3zM11.636 7.364l-1.121 1.121 4.064 1.515-6.579 2.453-6.579-2.453 4.064-1.515-1.121-1.121-4.364 1.636v4l8 3 8-3v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBoxRemove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1h-10l-3 3v10.5c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10.5l-3-3zM10 10v3h-4v-3h-3l5-4 5 4h-3zM2.414 3l1-1h9.171l1 1h-11.171z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBoxAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1h-10l-3 3v10.5c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10.5l-3-3zM8 13l-5-4h3v-3h4v3h3l-5 4zM2.414 3l1-1h9.172l1 1h-11.172z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDrawer2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.89 10.188l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188h-7c-0.152 0-0.296 0.069-0.39 0.188l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312zM15 11h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.74-4.675h6.519l3.74 4.675v0.325z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDrawer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.89 10.188l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188h-7c-0.152 0-0.296 0.069-0.39 0.188l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312zM15 11h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.74-4.675h6.519l3.74 4.675v0.325z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 8h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 10h-9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h9c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.331 4.502c-1.388-0.199-2.865-0.344-4.407-0.425l2.576-2.576-1-1-3.509 3.509c-0.328-0.006-0.659-0.009-0.991-0.009v0l-4-4-1 1 3.034 3.034c-1.889 0.066-3.693 0.227-5.365 0.467-0.43 1.683-0.669 3.543-0.669 5.498s0.239 3.815 0.669 5.498c2.244 0.323 4.724 0.502 7.331 0.502s5.087-0.179 7.331-0.502c0.43-1.683 0.669-3.543 0.669-5.498s-0.239-3.815-0.669-5.498zM13.498 13.666c-1.683 0.215-3.543 0.334-5.498 0.334s-3.815-0.119-5.498-0.334c-0.323-1.122-0.502-2.362-0.502-3.666s0.179-2.543 0.502-3.666c1.683-0.215 3.543-0.334 5.498-0.334s3.815 0.119 5.498 0.334c0.323 1.122 0.502 2.362 0.502 3.666s-0.179 2.543-0.502 3.666z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTablet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 0h-10c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h10c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM7.5 15.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM12 14h-9v-12h9v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMobile2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0h-9c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM7.5 15.278c-0.43 0-0.778-0.348-0.778-0.778s0.348-0.778 0.778-0.778 0.778 0.348 0.778 0.778-0.348 0.778-0.778 0.778zM12 13h-9v-11h9v11z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 0h-7c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h7c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 0.75h4v0.5h-4v-0.5zM8 15c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM12 12h-8v-10h8v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLaptop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11v-8c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v8h-2v3h16v-3h-2zM10 13h-4v-1h4v1zM13 11h-10v-7.998c0.001-0.001 0.001-0.001 0.002-0.002h9.996c0.001 0.001 0.001 0.001 0.002 0.002v7.998z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDisplay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1v10h16v-10h-16zM15 10h-14v-8h14v8zM10.5 12h-5l-0.5 2-1 1h8l-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImKeyboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2h-16c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h16c0.55 0 1-0.45 1-1v-10c0-0.55-0.45-1-1-1zM10 4h2v2h-2v-2zM13 7v2h-2v-2h2zM7 4h2v2h-2v-2zM10 7v2h-2v-2h2zM4 4h2v2h-2v-2zM7 7v2h-2v-2h2zM2 4h1v2h-1v-2zM2 7h2v2h-2v-2zM3 12h-1v-2h1v2zM12 12h-8v-2h8v2zM16 12h-3v-2h3v2zM16 9h-2v-2h2v2zM16 6h-3v-2h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPrinter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1h8v2h-8v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h-14c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v4h8v-4h3c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM2 7c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM11 14h-6v-5h6v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h2v2h-2zM8 6h2v2h-2zM11 6h2v2h-2zM2 12h2v2h-2zM5 12h2v2h-2zM8 12h2v2h-2zM5 9h2v2h-2zM8 9h2v2h-2zM11 9h2v2h-2zM2 9h2v2h-2zM13 0v1h-2v-1h-7v1h-2v-1h-2v16h15v-16h-2zM14 15h-13v-11h13v11z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStopwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.019v-1.019h2v-1c0-0.552-0.448-1-1-1h-3c-0.552 0-1 0.448-1 1v1h2v1.019c-3.356 0.255-6 3.059-6 6.481 0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5c0-3.422-2.644-6.226-6-6.481zM11.036 13.036c-0.944 0.944-2.2 1.464-3.536 1.464s-2.591-0.52-3.536-1.464c-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536c0.907-0.907 2.101-1.422 3.377-1.462l-0.339 4.907c-0.029 0.411 0.195 0.591 0.497 0.591s0.527-0.18 0.497-0.591l-0.339-4.907c1.276 0.040 2.47 0.555 3.377 1.462 0.944 0.944 1.464 2.2 1.464 3.536s-0.52 2.591-1.464 3.536z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.023 12.5c0-4.5-4-3.5-4-7 0-0.29-0.028-0.538-0.079-0.749-0.263-1.766-1.44-3.183-2.965-3.615 0.014-0.062 0.021-0.125 0.021-0.191 0-0.52-0.45-0.945-1-0.945s-1 0.425-1 0.945c0 0.065 0.007 0.129 0.021 0.191-1.71 0.484-2.983 2.208-3.020 4.273-0.001 0.030-0.001 0.060-0.001 0.091 0 3.5-4 2.5-4 7 0 1.191 2.665 2.187 6.234 2.439 0.336 0.631 1.001 1.061 1.766 1.061s1.43-0.43 1.766-1.061c3.568-0.251 6.234-1.248 6.234-2.439 0-0.004-0-0.007-0-0.011l0.024 0.011zM12.91 13.345c-0.847 0.226-1.846 0.389-2.918 0.479-0.089-1.022-0.947-1.824-1.992-1.824s-1.903 0.802-1.992 1.824c-1.072-0.090-2.071-0.253-2.918-0.479-1.166-0.311-1.724-0.659-1.928-0.845 0.204-0.186 0.762-0.534 1.928-0.845 1.356-0.362 3.1-0.561 4.91-0.561s3.554 0.199 4.91 0.561c1.166 0.311 1.724 0.659 1.928 0.845-0.204 0.186-0.762 0.534-1.928 0.845z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAlarm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM8 14.625c-3.107 0-5.625-2.518-5.625-5.625s2.518-5.625 5.625-5.625c3.107 0 5.625 2.518 5.625 5.625s-2.518 5.625-5.625 5.625zM14.606 4.487c0.251-0.438 0.394-0.946 0.394-1.487 0-1.657-1.343-3-3-3-0.966 0-1.825 0.457-2.374 1.166 2.061 0.426 3.831 1.644 4.98 3.322v0zM6.374 1.166c-0.549-0.709-1.408-1.166-2.374-1.166-1.657 0-3 1.343-3 3 0 0.541 0.143 1.049 0.394 1.487 1.148-1.678 2.919-2.896 4.98-3.322z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9v-4h-1v5h4v-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImClock2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM10.293 11.707l-3.293-3.293v-4.414h2v3.586l2.707 2.707-1.414 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.293 11.707l-3.293-3.293v-4.414h2v3.586l2.707 2.707zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHistory(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 17 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 1c3.866 0 7 3.134 7 7s-3.134 7-7 7v-1.5c1.469 0 2.85-0.572 3.889-1.611s1.611-2.42 1.611-3.889c0-1.469-0.572-2.85-1.611-3.889s-2.42-1.611-3.889-1.611c-1.469 0-2.85 0.572-3.889 1.611-0.799 0.799-1.322 1.801-1.52 2.889h2.909l-3.5 4-3.5-4h2.571c0.485-3.392 3.402-6 6.929-6zM13 7v2h-4v-5h2v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMap2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 3l-5-2-5.5 2v12l5.5-2 5 2 5.5-2v-12l-5.5 2zM6 2.277l4 1.6v9.846l-4-1.6v-9.846zM1 3.7l4-1.455v9.872l-4 1.454v-9.872zM15 12.3l-4 1.455v-9.872l4-1.455v9.872z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3l5-2v12l-5 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0.5l5 3v11.5l-5-2.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.5l4-3v12l-4 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCompass2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5 1.712 0 3.269 0.662 4.43 1.744l-6.43 2.756-2.756 6.43c-1.082-1.161-1.744-2.718-1.744-4.43zM9.143 9.143l-4.001 1.715 1.715-4.001 2.286 2.286zM8 14.5c-1.712 0-3.269-0.662-4.43-1.744l6.43-2.756 2.756-6.43c1.082 1.161 1.744 2.718 1.744 4.43 0 3.59-2.91 6.5-6.5 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 16c-0.036 0-0.072-0.004-0.108-0.012-0.229-0.051-0.392-0.254-0.392-0.488v-7.5h-7.5c-0.234 0-0.437-0.163-0.488-0.392s0.064-0.462 0.277-0.561l15-7c0.191-0.089 0.416-0.049 0.565 0.1s0.188 0.374 0.1 0.565l-7 15c-0.083 0.179-0.262 0.289-0.453 0.289zM2.754 7h5.746c0.276 0 0.5 0.224 0.5 0.5v5.746l5.465-11.712-11.712 5.465z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLocation2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8.063c-1.691 0-3.063-1.371-3.063-3.063s1.371-3.063 3.063-3.063 3.063 1.371 3.063 3.063-1.371 3.063-3.063 3.063zM6.063 5c0-1.070 0.867-1.938 1.938-1.938s1.938 0.867 1.938 1.938c0 1.070-0.867 1.938-1.938 1.938s-1.938-0.867-1.938-1.938z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLocation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPushpin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 0l-1.5 1.5 1.5 1.5-3.5 4h-3.5l2.75 2.75-4.25 5.635v0.615h0.615l5.635-4.25 2.75 2.75v-3.5l4-3.5 1.5 1.5 1.5-1.5-7.5-7.5zM7 8.5l-1-1 3.5-3.5 1 1-3.5 3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEnvelop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v10c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-10c0-0.825-0.675-1.5-1.5-1.5zM6.23 8.6l-4.23 3.295v-7.838l4.23 4.543zM2.756 4h10.488l-5.244 3.938-5.244-3.938zM6.395 8.777l1.605 1.723 1.605-1.723 3.29 4.223h-9.79l3.29-4.223zM9.77 8.6l4.23-4.543v7.838l-4.23-3.295z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImAddressBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0v16h12v-16h-12zM9 4.005c1.102 0 1.995 0.893 1.995 1.995s-0.893 1.995-1.995 1.995-1.995-0.893-1.995-1.995 0.893-1.995 1.995-1.995v0zM12 12h-6v-1c0-1.105 0.895-2 2-2v0h2c1.105 0 2 0.895 2 2v1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 1h1.5v3h-1.5v-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h1.5v3h-1.5v-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9h1.5v3h-1.5v-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13h1.5v3h-1.5v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPhoneHangUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.897 9c0.125 0.867 0.207 2.053-0.182 2.507-0.643 0.751-4.714 0.751-4.714-0.751 0-0.756 0.67-1.252 0.027-2.003-0.632-0.738-1.766-0.75-3.027-0.751s-2.394 0.012-3.027 0.751c-0.643 0.751 0.027 1.247 0.027 2.003 0 1.501-4.071 1.501-4.714 0.751-0.389-0.454-0.307-1.64-0.182-2.507 0.096-0.579 0.339-1.203 1.118-2 0-0 0-0 0-0 1.168-1.090 2.935-1.98 6.716-2v-0c0.021 0 0.042 0 0.063 0s0.041-0 0.063-0v0c3.781 0.019 5.548 0.91 6.716 2 0 0 0 0 0 0 0.778 0.797 1.022 1.421 1.118 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLifebuoy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 8c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3-3-1.343-3-3zM14.468 10.679v0l-2.772-1.148c0.196-0.472 0.304-0.989 0.304-1.531s-0.108-1.059-0.304-1.531l2.772-1.148c0.342 0.825 0.532 1.73 0.532 2.679s-0.189 1.854-0.532 2.679v0zM10.679 1.532v0 0l-1.148 2.772c-0.472-0.196-0.989-0.304-1.531-0.304s-1.059 0.108-1.531 0.304l-1.148-2.772c0.825-0.342 1.73-0.532 2.679-0.532s1.854 0.189 2.679 0.532zM1.532 5.321l2.772 1.148c-0.196 0.472-0.304 0.989-0.304 1.531s0.108 1.059 0.304 1.531l-2.772 1.148c-0.342-0.825-0.532-1.73-0.532-2.679s0.189-1.854 0.532-2.679zM5.321 14.468l1.148-2.772c0.472 0.196 0.989 0.304 1.531 0.304s1.059-0.108 1.531-0.304l1.148 2.772c-0.825 0.342-1.73 0.532-2.679 0.532s-1.854-0.189-2.679-0.532z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1h-5c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM6 5h-5v-1h5v1zM14 1h-5c-0.55 0-1 0.45-1 1v13c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-13c0-0.55-0.45-1-1-1zM14 10h-5v-1h5v1zM14 7h-5v-1h5v1zM6 9h-5c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM6 13h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM1.5 3h13c0.271 0 0.5 0.229 0.5 0.5v1.5h-14v-1.5c0-0.271 0.229-0.5 0.5-0.5zM14.5 13h-13c-0.271 0-0.5-0.229-0.5-0.5v-4.5h14v4.5c0 0.271-0.229 0.5-0.5 0.5zM2 10h1v2h-1zM4 10h1v2h-1zM6 10h1v2h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCoinYen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 9c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.066l1.482-2.223c0.153-0.23 0.091-0.54-0.139-0.693s-0.54-0.091-0.693 0.139l-1.584 2.376-1.584-2.376c-0.153-0.23-0.464-0.292-0.693-0.139s-0.292 0.464-0.139 0.693l1.482 2.223h-1.066c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-1h1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCoinPound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 11h-3.5v-2h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-0.5c0-0.827 0.673-1.5 1.5-1.5 0.534 0 1.032 0.288 1.3 0.75 0.138 0.239 0.444 0.321 0.683 0.182s0.321-0.444 0.182-0.683c-0.446-0.771-1.276-1.25-2.165-1.25-1.378 0-2.5 1.122-2.5 2.5v0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v3h4.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCoinEuro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.482 10.068c-0.239-0.139-0.545-0.058-0.684 0.181-0.27 0.463-0.767 0.751-1.298 0.751h-2c-0.652 0-1.208-0.418-1.414-1h2.414c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5v-1h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.414c0.206-0.582 0.762-1 1.414-1h2c0.531 0 1.028 0.288 1.298 0.751 0.139 0.239 0.445 0.32 0.684 0.181s0.32-0.445 0.181-0.684c-0.448-0.77-1.277-1.249-2.162-1.249h-2c-1.207 0-2.217 0.86-2.45 2h-0.55c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v1h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.55c0.232 1.14 1.242 2 2.45 2h2c0.886 0 1.714-0.478 2.162-1.249 0.139-0.239 0.058-0.545-0.181-0.684z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCoinDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM8 8v-2h2v-1h-2v-1h-1v1h-2v4h2v2h-2v1h2v1h1v-1h2l-0-4h-2zM7 8h-1v-2h1v2zM9 11h-1v-2h1v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v-6h-12c0-0.552-0.448-1-1-1h-3v1h2l0.751 6.438c-0.458 0.367-0.751 0.93-0.751 1.562 0 1.105 0.895 2 2 2h12v-1h-12c-0.552 0-1-0.448-1-1 0-0.003 0-0.007 0-0.010l13-1.99z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImTicket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5l2 2-4 4-2-2zM15.649 4.649l-1.149-1.149-0.5 0.5c-0.256 0.256-0.61 0.414-1 0.414-0.781 0-1.414-0.633-1.414-1.414 0-0.391 0.158-0.744 0.415-1l0.5-0.5-1.149-1.149c-0.468-0.468-1.235-0.468-1.703 0l-9.297 9.297c-0.468 0.468-0.468 1.235 0 1.703l1.149 1.149 0.499-0.499c0.256-0.256 0.61-0.415 1.001-0.415 0.781 0 1.414 0.633 1.414 1.414 0 0.391-0.158 0.744-0.415 1l-0.5 0.5 1.149 1.149c0.468 0.468 1.234 0.468 1.703 0l9.297-9.297c0.468-0.468 0.468-1.235 0-1.703zM7 13l-4-4 6-6 4 4-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImQrcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 1h-4v4h4v-4zM6 0v0 6h-6v-6h6zM2 2h2v2h-2zM15 1h-4v4h4v-4zM16 0v0 6h-6v-6h6zM12 2h2v2h-2zM5 11h-4v4h4v-4zM6 10v0 6h-6v-6h6zM2 12h2v2h-2zM7 0h1v1h-1zM8 1h1v1h-1zM7 2h1v1h-1zM8 3h1v1h-1zM7 4h1v1h-1zM8 5h1v1h-1zM7 6h1v1h-1zM7 8h1v1h-1zM8 9h1v1h-1zM7 10h1v1h-1zM8 11h1v1h-1zM7 12h1v1h-1zM8 13h1v1h-1zM7 14h1v1h-1zM8 15h1v1h-1zM15 8h1v1h-1zM1 8h1v1h-1zM2 7h1v1h-1zM0 7h1v1h-1zM4 7h1v1h-1zM5 8h1v1h-1zM6 7h1v1h-1zM9 8h1v1h-1zM10 7h1v1h-1zM11 8h1v1h-1zM12 7h1v1h-1zM13 8h1v1h-1zM14 7h1v1h-1zM15 10h1v1h-1zM9 10h1v1h-1zM10 9h1v1h-1zM11 10h1v1h-1zM13 10h1v1h-1zM14 9h1v1h-1zM15 12h1v1h-1zM9 12h1v1h-1zM10 11h1v1h-1zM12 11h1v1h-1zM13 12h1v1h-1zM14 11h1v1h-1zM15 14h1v1h-1zM10 13h1v1h-1zM11 14h1v1h-1zM12 13h1v1h-1zM13 14h1v1h-1zM10 15h1v1h-1zM12 15h1v1h-1zM14 15h1v1h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBarcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2h2v10h-2zM3 2h1v10h-1zM5 2h1v10h-1zM8 2h1v10h-1zM12 2h1v10h-1zM15 2h1v10h-1zM10 2h0.5v10h-0.5zM7 2h0.5v10h-0.5zM13.5 2h0.5v10h-0.5zM0 13h1v1h-1zM3 13h1v1h-1zM5 13h1v1h-1zM10 13h1v1h-1zM15 13h1v1h-1zM12 13h2v1h-2zM7 13h2v1h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPriceTags(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 20 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.337-0.75-0.75-0.75zM15.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8.5l8.5-8.5h-1.25c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l0.47-0.47-6.5-6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPriceTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.338-0.75-0.75-0.75zM11.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFolderUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM8 7.5l3.5 3.5h-2.5v4h-2v-4h-2.5l3.5-3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFolderDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM8 13.5l-3.5-3.5h2.5v-4h2v4h2.5l-3.5 3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFolderMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM11 11h-6v-2h6v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFolderPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM11 11h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15l3-8h-13l-3 8zM2 6l-2 9v-13h4.5l2 2h6.5v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2l2 2h7v11h-16v-13z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5l-8-4-8 4 8 4 8-4zM8 2.328l5.345 2.672-5.345 2.672-5.345-2.672 5.345-2.672zM14.398 7.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199zM14.398 10.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPaste(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h-2v-1c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v1h-2v2h8v-2zM8 2h-2v-0.998c0.001-0.001 0.001-0.001 0.002-0.002h1.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998zM13 5v-2.5c0-0.275-0.225-0.5-0.5-0.5h-1v1h0.5v2h-3l-3 3v4h-4v-9h0.5v-1h-1c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5h4.5v3h10v-11h-3zM9 6.414v1.586h-1.586l1.586-1.586zM15 15h-8v-6h3v-3h5v9z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4v-4h-7l-3 3v9h6v4h10v-12h-6zM3 1.414v1.586h-1.586l1.586-1.586zM1 11v-7h3v-3h5v3l-3 3v4h-5zM9 5.414v1.586h-1.586l1.586-1.586zM15 15h-8v-7h3v-3h5v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFileZip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h2v1h-2v-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13.25c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-1.25v-1h-2v4.25zM7 12v1h-2v-1h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFileVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h5v5h-5v-5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10l3-2v5l-3-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFilePlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6l5 3.5-5 3.5v-7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFileMusic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.817 6.113c-0.116-0.095-0.268-0.133-0.415-0.104l-5 1c-0.234 0.047-0.402 0.252-0.402 0.49v3.701c-0.294-0.128-0.636-0.201-1-0.201-1.105 0-2 0.672-2 1.5s0.895 1.5 2 1.5 2-0.672 2-1.5v-3.59l4-0.8v2.091c-0.294-0.128-0.636-0.201-1-0.201-1.105 0-2 0.672-2 1.5s0.895 1.5 2 1.5 2-0.672 2-1.5v-5c0-0.15-0.067-0.292-0.183-0.387z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFilePicture(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14h-10v-2l3-5 4.109 5 2.891-2v4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFileText2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFilesEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 5.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.689 0.561 1.25 1.25 1.25h9.5c0.689 0 1.25-0.561 1.25-1.25v-7.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 4.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-9.5c-0.136 0-0.25-0.114-0.25-0.25v-11.5c0-0.135 0.114-0.25 0.25-0.25 0 0 5.749-0 5.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v7.75z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.421 0.659c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.604 0.43 1.109 1 1.225v-12.725c0-0.135 0.115-0.25 0.25-0.25h7.607c-0.151-0.124-0.297-0.238-0.437-0.341z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFileEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImProfile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 9h7v1h-7zM4 11h7v1h-7zM5 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM7.5 6h-2c-0.825 0-1.5 0.45-1.5 1v1h5v-1c0-0.55-0.675-1-1.5-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFileText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 7h7v1h-7zM4 9h7v1h-7zM4 11h7v1h-7zM4 5h7v1h-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImLibrary(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 17 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15v-1h-1v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-1v1h-1v1h17v-1h-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0h1l8 5v1h-17v-1l8-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBooks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM3 5h-2v-1h2v1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM8 5h-2v-1h2v1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.954 2.773l-2.679 1.35c-0.246 0.124-0.345 0.426-0.222 0.671l4.5 8.93c0.124 0.246 0.426 0.345 0.671 0.222l2.679-1.35c0.246-0.124 0.345-0.426 0.222-0.671l-4.5-8.93c-0.124-0.246-0.426-0.345-0.671-0.222z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v13h-10.5c-0.829 0-1.5-0.672-1.5-1.5s0.671-1.5 1.5-1.5h9.5v-12h-10c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12v-14h-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.501 13v0c-0 0-0.001 0-0.001 0-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0 0 0.001-0 0.001-0v0h9.498v-1h-9.498z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 11c1.381 0 2.5-1.119 2.5-2.5v-6c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v6c0 1.381 1.119 2.5 2.5 2.5zM11 7v1.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5v-1.5h-1v1.5c0 2.316 1.75 4.223 4 4.472v2.028h-2v1h5v-1h-2v-2.028c2.25-0.249 4-2.156 4-4.472v-1.5h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFeed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10.38 3.602c1.56 0.846 2.62 2.498 2.62 4.398s-1.059 3.552-2.62 4.398c0.689-1.096 1.12-2.66 1.12-4.398s-0.431-3.302-1.12-4.398zM4.5 8c0 1.738 0.431 3.302 1.12 4.398-1.56-0.846-2.62-2.498-2.62-4.398s1.059-3.552 2.62-4.398c-0.689 1.096-1.12 2.66-1.12 4.398zM1.5 8c0 2.686 0.85 5.097 2.198 6.746-2.223-1.421-3.698-3.911-3.698-6.746s1.474-5.325 3.698-6.746c-1.348 1.649-2.198 4.060-2.198 6.746zM12.302 1.254c2.223 1.421 3.698 3.911 3.698 6.746s-1.474 5.325-3.698 6.746c1.348-1.649 2.198-4.060 2.198-6.746s-0.85-5.097-2.198-6.746z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPodcast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 3.438 2.169 6.37 5.214 7.501l-0.214 0.499h6l-0.214-0.499c3.045-1.131 5.214-4.063 5.214-7.501zM7.606 9.919c-0.356-0.153-0.606-0.507-0.606-0.919 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.412-0.25 0.766-0.606 0.919l-0.394-0.919-0.394 0.919zM8.41 9.958c0.908-0.189 1.59-0.994 1.59-1.958 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.964 0.682 1.768 1.59 1.957l-1.166 2.721c-1.425-0.612-2.424-2.028-2.424-3.677 0-2.209 1.791-4.188 4-4.188s4 1.978 4 4.188c0 1.649-0.999 3.066-2.424 3.677l-1.166-2.72zM10.757 15.433l-1.155-2.695c1.976-0.668 3.398-2.537 3.398-4.738 0-2.761-2.239-5-5-5s-5 2.239-5 5c0 2.201 1.422 4.070 3.398 4.738l-1.155 2.695c-2.494-1.070-4.24-3.547-4.24-6.433 0-3.865 3.133-7.185 6.997-7.185s6.997 3.32 6.997 7.185c0 2.886-1.747 5.363-4.24 6.433z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImConnection(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 20 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9c1.654 0 3.154 0.673 4.241 1.759l-1.414 1.414c-0.724-0.724-1.724-1.173-2.827-1.173s-2.103 0.449-2.827 1.173l-1.414-1.414c1.086-1.086 2.586-1.759 4.241-1.759zM2.929 7.929c1.889-1.889 4.4-2.929 7.071-2.929s5.182 1.040 7.071 2.929l-1.414 1.414c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343l-1.414-1.414zM15.45 2.101c1.667 0.705 3.164 1.715 4.45 3v0l-1.414 1.414c-2.267-2.266-5.28-3.515-8.485-3.515s-6.219 1.248-8.485 3.515l-1.414-1.414c1.285-1.285 2.783-2.295 4.45-3 1.727-0.73 3.56-1.101 5.45-1.101s3.723 0.37 5.45 1.101zM9 14c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBullhorn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.707c0-3.139-0.919-5.687-2.054-5.707 0.005-0 0.009-0 0.014-0h-1.296c0 0-3.044 2.287-7.425 3.184-0.134 0.708-0.219 1.551-0.219 2.523s0.085 1.816 0.219 2.523c4.382 0.897 7.425 3.184 7.425 3.184h1.296c-0.005 0-0.009-0-0.014-0.001 1.136-0.020 2.054-2.567 2.054-5.707zM13.513 11.551c-0.147 0-0.305-0.152-0.387-0.243-0.197-0.22-0.387-0.562-0.55-0.989-0.363-0.957-0.564-2.239-0.564-3.611s0.2-2.655 0.564-3.611c0.162-0.428 0.353-0.77 0.55-0.99 0.081-0.091 0.24-0.243 0.387-0.243s0.305 0.152 0.387 0.243c0.197 0.22 0.387 0.562 0.55 0.99 0.363 0.957 0.564 2.239 0.564 3.611s-0.2 2.655-0.564 3.611c-0.162 0.428-0.353 0.77-0.55 0.989-0.081 0.091-0.24 0.243-0.387 0.243zM3.935 6.707c0-0.812 0.060-1.6 0.173-2.33-0.74 0.102-1.39 0.161-2.193 0.161-1.048 0-1.048 0-1.048 0l-0.867 1.479v1.378l0.867 1.479c0 0 0 0 1.048 0 0.803 0 1.453 0.059 2.193 0.161-0.113-0.729-0.173-1.518-0.173-2.33zM5.752 10.034l-2-0.383 1.279 5.024c0.066 0.26 0.324 0.391 0.573 0.291l1.852-0.741c0.249-0.1 0.349-0.374 0.222-0.611l-1.926-3.581zM13.513 8.574c-0.057 0-0.118-0.059-0.149-0.094-0.076-0.085-0.149-0.217-0.212-0.381-0.14-0.369-0.217-0.863-0.217-1.392s0.077-1.023 0.217-1.392c0.063-0.165 0.136-0.297 0.212-0.381 0.031-0.035 0.092-0.094 0.149-0.094s0.118 0.059 0.149 0.094c0.076 0.085 0.149 0.217 0.212 0.381 0.14 0.369 0.217 0.863 0.217 1.392s-0.077 1.023-0.217 1.392c-0.063 0.165-0.136 0.297-0.212 0.381-0.031 0.035-0.092 0.094-0.149 0.094z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDiamonds(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0l-5 8 5 8 5-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImClubs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.294 6.137c-0.922 0-1.751 0.384-2.341 1.011-0.25 0.265-0.684 0.58-1.153 0.856 0.22-0.842 0.917-1.902 1.4-2.367 0.619-0.596 1-1.435 1-2.367 0-1.795-1.429-3.252-3.2-3.271-1.771 0.019-3.2 1.475-3.2 3.271 0 0.932 0.38 1.771 1 2.367 0.484 0.465 1.18 1.525 1.4 2.367-0.469-0.277-0.903-0.591-1.153-0.856-0.59-0.627-1.419-1.011-2.341-1.011-1.787 0-3.236 1.463-3.236 3.271s1.448 3.271 3.236 3.271c0.923 0 1.751-0.396 2.341-1.023 0.263-0.279 0.726-0.627 1.223-0.916-0.047 2.308-1.149 4.003-2.271 4.67v0.59h6v-0.59c-1.122-0.668-2.224-2.363-2.271-4.67 0.498 0.289 0.961 0.637 1.223 0.916 0.59 0.626 1.419 1.023 2.341 1.023 1.787 0 3.236-1.464 3.236-3.271s-1.448-3.271-3.236-3.271z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImSpades(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.775 5.44c-3.024-2.248-4.067-4.047-4.774-5.44v0c-0 0-0-0-0-0v0c-0.708 1.393-1.75 3.192-4.774 5.44-5.157 3.833-0.303 9.182 3.965 6.238-0.278 1.827-1.227 3.159-2.191 3.733v0.59h6v-0.59c-0.964-0.574-1.913-1.906-2.191-3.733 4.268 2.944 9.122-2.405 3.965-6.238z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPacman(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.074 2.794c-1.467-1.71-3.644-2.794-6.074-2.794-4.418 0-8 3.582-8 8s3.582 8 8 8c2.43 0 4.607-1.084 6.074-2.794l-5.074-5.206 5.074-5.206zM11 1.884c0.616 0 1.116 0.499 1.116 1.116s-0.499 1.116-1.116 1.116-1.116-0.499-1.116-1.116c0-0.616 0.499-1.116 1.116-1.116z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3h-8c-1.375 0-2.5 1.125-2.5 2.5v8c0 1.375 1.125 2.5 2.5 2.5h8c1.375 0 2.5-1.125 2.5-2.5v-8c0-1.375-1.125-2.5-2.5-2.5zM6.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM6.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM9.5 11c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.949 2c-0.233-1.138-1.245-2-2.449-2h-8c-1.375 0-2.5 1.125-2.5 2.5v8c0 1.204 0.862 2.216 2 2.449v-9.949c0-0.55 0.45-1 1-1h9.949z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImVideoCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM0 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM12 9.5v-1.5c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h10c0.55 0 1-0.45 1-1v-1.5l4 2.5v-7l-4 2.5zM10 12h-8v-3h8v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2v12h16v-12h-16zM3 13h-2v-2h2v2zM3 9h-2v-2h2v2zM3 5h-2v-2h2v2zM12 13h-8v-10h8v10zM15 13h-2v-2h2v2zM15 9h-2v-2h2v2zM15 5h-2v-2h2v2zM6 5v6l4-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.331 2.502c-2.244-0.323-4.724-0.502-7.331-0.502s-5.087 0.179-7.331 0.502c-0.43 1.683-0.669 3.543-0.669 5.498s0.239 3.815 0.669 5.498c2.244 0.323 4.724 0.502 7.331 0.502s5.087-0.179 7.331-0.502c0.43-1.683 0.669-3.543 0.669-5.498s-0.239-3.815-0.669-5.498zM6 11v-6l5 3-5 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImMusic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0h1v11.5c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-5.751l-8 1.778v7.722c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-9.751l9-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHeadphones(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 9h-1v7h1c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h1v-7h-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 0.96 0.169 1.88 0.479 2.732-0.304 0.519-0.479 1.123-0.479 1.768 0 1.763 1.304 3.222 3 3.464v-6.928c-0.499 0.071-0.963 0.248-1.371 0.506-0.084-0.417-0.129-0.849-0.129-1.292 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 0.442-0.044 0.874-0.128 1.292-0.408-0.259-0.873-0.435-1.372-0.507v6.929c1.696-0.243 3-1.701 3-3.464 0-0.645-0.175-1.249-0.479-1.768 0.31-0.853 0.479-1.773 0.479-2.732z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.75 9.5c0 1.795 1.455 3.25 3.25 3.25s3.25-1.455 3.25-3.25-1.455-3.25-3.25-3.25-3.25 1.455-3.25 3.25zM15 4h-3.5c-0.25-1-0.5-2-1.5-2h-4c-1 0-1.25 1-1.5 2h-3.5c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM8 13.938c-2.451 0-4.438-1.987-4.438-4.438s1.987-4.438 4.438-4.438c2.451 0 4.438 1.987 4.438 4.438s-1.987 4.438-4.438 4.438zM15 7h-2v-1h2v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImImages(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2h-1v-1c0-0.55-0.45-1-1-1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h1v1c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM2 3v10h-0.998c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-12c-0.55 0-1 0.45-1 1v0zM17 14.998c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002v11.996z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14h-12v-2l3.5-6 4 5h1l3.5-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.998 2c0.001 0.001 0.001 0.001 0.002 0.002v11.996c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996zM15 1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1v0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13h-12v-2l3.5-6 4 5h1l3.5-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPaintFormat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImDroplet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.51 7.393c-1.027-2.866-3.205-5.44-5.51-7.393-2.305 1.953-4.482 4.527-5.51 7.393-0.635 1.772-0.698 3.696 0.197 5.397 1.029 1.955 3.104 3.21 5.313 3.21s4.284-1.255 5.313-3.21c0.895-1.701 0.832-3.624 0.197-5.397zM11.543 11.859c-0.684 1.301-2.075 2.141-3.543 2.141-0.861 0-1.696-0.29-2.377-0.791 0.207 0.027 0.416 0.041 0.627 0.041 1.835 0 3.573-1.050 4.428-2.676 0.701-1.333 0.64-2.716 0.373-3.818 0.227 0.44 0.42 0.878 0.576 1.311 0.353 0.985 0.625 2.443-0.084 3.791z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImEyedropper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.414 0.586c-0.781-0.781-2.047-0.781-2.828 0l-2.689 2.689-1.896-1.896-2.121 2.121 1.663 1.663-7.377 7.377c-0.126 0.126-0.179 0.296-0.161 0.46h-0.004v2.5c0 0.276 0.224 0.5 0.5 0.5h2.5c0 0 0.042 0 0.063 0 0.144 0 0.288-0.055 0.398-0.165l7.377-7.377 1.663 1.663 2.121-2.121-1.896-1.896 2.689-2.689c0.781-0.781 0.781-2.047 0-2.828zM2.705 15h-1.705v-1.705l7.337-7.337 1.704 1.704-7.337 7.337z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImBlog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0v1.5c1.148 0 2.261 0.225 3.308 0.667 1.012 0.428 1.921 1.041 2.702 1.822s1.394 1.69 1.822 2.702c0.443 1.047 0.667 2.16 0.667 3.308h1.5c0-5.523-4.477-10-10-10z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v1.5c1.469 0 2.85 0.572 3.889 1.611s1.611 2.42 1.611 3.889h1.5c0-3.866-3.134-7-7-7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 6l-1 1-3.5 1-3 6.5 0.396 0.396 3.638-3.638c-0.022-0.083-0.034-0.169-0.034-0.259 0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1c-0.090 0-0.176-0.012-0.259-0.034l-3.638 3.638 0.396 0.396 6.5-3 1-3.5 1-1-2.5-2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.909 4.561l-4.47-4.47c-0.146-0.146-0.338-0.113-0.427 0.073l-0.599 1.248 4.175 4.175 1.248-0.599c0.186-0.089 0.219-0.282 0.073-0.427z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.615 2.115l-4.115 0.343c-0.273 0.034-0.501 0.092-0.58 0.449-0 0-0 0.001-0 0.001-1.116 5.36-4.92 10.591-4.92 10.591l0.896 0.896 4.25-4.25c-0.094-0.196-0.146-0.415-0.146-0.647 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5c-0.232 0-0.451-0.053-0.647-0.146l-4.25 4.25 0.896 0.896c0 0 5.231-3.804 10.591-4.92 0-0 0.001-0 0.001-0 0.357-0.078 0.415-0.306 0.449-0.58l0.343-4.115-4.269-4.269z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImQuill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 16c2-6 7.234-16 16-16-4.109 3.297-6 11-9 11s-3 0-3 0l-3 5h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPencil2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10l2-1 7-7-1-1-7 7-1 2zM4.52 13.548c-0.494-1.043-1.026-1.574-2.069-2.069l1.548-4.262 2-1.217 6-6h-3l-6 6-3 10 10-3 6-6v-3l-6 6-1.217 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImPencil(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 0c1.381 0 2.5 1.119 2.5 2.5 0 0.563-0.186 1.082-0.5 1.5l-1 1-3.5-3.5 1-1c0.418-0.314 0.937-0.5 1.5-0.5zM1 11.5l-1 4.5 4.5-1 9.25-9.25-3.5-3.5-9.25 9.25zM11.181 5.681l-7 7-0.862-0.862 7-7 0.862 0.862z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4v-2h-14v11c0 0.552 0.448 1 1 1h13.5c0.828 0 1.5-0.672 1.5-1.5v-8.5h-2zM13 13h-12v-10h12v10zM2 5h10v1h-10zM8 7h4v1h-4zM8 9h4v1h-4zM8 11h3v1h-3zM2 7h5v5h-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImOffice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 16h8v-16h-8v16zM5 2h2v2h-2v-2zM5 6h2v2h-2v-2zM5 10h2v2h-2v-2zM1 2h2v2h-2v-2zM1 6h2v2h-2v-2zM1 10h2v2h-2v-2zM9 5h7v1h-7zM9 16h2v-4h3v4h2v-9h-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHome3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9.5l-3-3v-4.5h-2v2.5l-3-3-8 8v0.5h2v5h5v-3h2v3h5v-5h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHome2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0.5l-8 8 1.5 1.5 1.5-1.5v6.5h4v-3h2v3h4v-6.5l1.5 1.5 1.5-1.5-8-8zM8 7c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function ImHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9.226l-8-6.21-8 6.21v-2.532l8-6.21 8 6.21zM14 9v6h-4v-4h-4v4h-4v-6l6-4.5z"
                },
                "child": []
            }
        ]
    })(props);
}

},{"../lib/index.mjs":"c1xBV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eldfg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getStateAbbreviation);
var _usStates = require("Modules/creditDebit/config/usStates");
function getStateAbbreviation(input) {
    if (!input || !input.toLowerCase()) return input;
    const stateByLabel = (0, _usStates.usStates).find((state)=>input.toLowerCase() === state.label.toLowerCase());
    const stateByValue = (0, _usStates.usStates).find((state)=>input.toLowerCase() === state.value.toLowerCase());
    if (stateByValue) return input;
    else if (stateByLabel) return stateByLabel.value;
    return input;
}

},{"Modules/creditDebit/config/usStates":"2i8MO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4vtQJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _layout = require("Core/components/Layout");
var _tabset = require("Core/components/Tabset/Tabset");
var _tabsetDefault = parcelHelpers.interopDefault(_tabset);
var _tooltip = require("Core/components/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _useScrollBottom = require("Core/hooks/useScrollBottom");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _numberFormat = require("Core/utils/numberFormat");
var _appConfig = require("Core/config/appConfig");
var _financingTabNames = require("Modules/financing/config/financingTabNames");
var _useSelectOfferForm = require("Modules/financing/hooks/useSelectOfferForm");
var _useSelectOfferFormDefault = parcelHelpers.interopDefault(_useSelectOfferForm);
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _useUpdateOffer = require("Modules/financing/hooks/useUpdateOffer");
var _useUpdateOfferDefault = parcelHelpers.interopDefault(_useUpdateOffer);
var _useGetApplication = require("Modules/financing/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _useGetNextStep = require("Modules/financing/hooks/useGetNextStep");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _reactQuery = require("react-query");
var _finalizeOffer = require("Modules/financing/FinalizeOffer");
var _finalizeOfferDefault = parcelHelpers.interopDefault(_finalizeOffer);
var _updateAchModal = require("Modules/financing/components/UpdateAchModal");
var _updateAchModalDefault = parcelHelpers.interopDefault(_updateAchModal);
var _postExchangeBanner = require("Modules/financing/components/PostExchangeBanner");
var _postExchangeBannerDefault = parcelHelpers.interopDefault(_postExchangeBanner);
var _deliveryDateField = require("Modules/financing/components/DeliveryDateField");
var _deliveryDateFieldDefault = parcelHelpers.interopDefault(_deliveryDateField);
var _tabs = require("Core/stores/tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _selectOffer = require("Modules/financing/SelectOffer");
var _selectOfferDefault = parcelHelpers.interopDefault(_selectOffer);
const FinancingPreparation = ({ application, routes })=>{
    document.title = 'Payment Portal - Prepare Application';
    const { dateFormat } = (0, _appConfig.getAppConfig)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const scroll = (0, _useScrollBottom.useScrollBottom)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const DEFAULT_TAB_CONFIG = [
        {
            id: (0, _financingTabNames.financingTabNames).SELECT_OFFER,
            label: t('financing.nextgen.setOffer.headline-1'),
            pageHeader: t('page.selectFinancingOffer.header'),
            isActive: true,
            isDisabled: false
        },
        {
            id: (0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY,
            label: t('financing.nextgen.setOffer.headline-2'),
            pageHeader: t('page.selectFinancingOffer.header'),
            isActive: false,
            isDisabled: true
        },
        {
            id: (0, _financingTabNames.financingTabNames).FINALIZE_OFFER,
            label: t('financing.nextgen.setOffer.headline-3'),
            pageHeader: t('page.completeFinancing.header'),
            isActive: false,
            isDisabled: false
        }
    ];
    const [tabConfig, setTabConfig] = (0, _reactDefault.default).useState(DEFAULT_TAB_CONFIG);
    const [isLoading, setIsLoading] = (0, _reactDefault.default).useState(false);
    const [selectedOffer, setSelectedOffer] = (0, _reactDefault.default).useState({
        id: '',
        amount_min: 0,
        require_downpayment_percent: 0,
        type: ''
    });
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const [enableSignContract, setEnableSignContract] = (0, _reactDefault.default).useState(false);
    const activeTab = (0, _tabsDefault.default)((state)=>state.activeTab);
    const setActiveTab = (0, _tabsDefault.default)((state)=>state.setActiveTab);
    const [activeTabId, setActiveTabId] = (0, _reactDefault.default).useState(activeTab || (0, _financingTabNames.financingTabNames).SELECT_OFFER);
    const [refetchInterval, setRefetchInterval] = (0, _reactDefault.default).useState(false);
    const [isUpdateButtonDisabled, setIsUpdateButtonDisabled] = (0, _reactDefault.default).useState(false);
    const [isUpdateAchModalOpen, setIsUpdateAchModalOpen] = (0, _reactDefault.default).useState(false);
    const [isUpdateButtonPressed, setIsUpdateButtonPressed] = (0, _reactDefault.default).useState(false);
    const { mutateAsync: updateOffer, isFetching: isLoadingUpdateOffer } = (0, _useUpdateOfferDefault.default)();
    const { data: { amount_to_pay = 0 } = {} } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const { data: getAppData, isLoading: isGetAppLoading, isFetching: isGetAppFetching } = (0, _useGetApplicationDefault.default)(requestId);
    const { data: getNextStepData } = (0, _useGetNextStep.useGetNextStep)(refetchInterval, refetchInterval);
    const latestApp = getNextStepData || getAppData || application || {};
    const { next_action, payload: { offers, selected_offer_id, already_paid_amount = 0, additional_payment = 0, minimum_additional_payment = 0, links: { app: appLink } = {} } = {} } = latestApp;
    const priceInfo = latestApp?.payload?.offer_term?.price;
    const today = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    });
    const [{ delivery_date: offerTermDeliveryDate } = {}] = priceInfo?.products ? JSON.parse(priceInfo?.products) : [];
    const delivery_date = latestApp?.payload?.delivery_date || offerTermDeliveryDate || today;
    const minimumDownPayment = Math.max(amount_to_pay * selectedOffer.require_downpayment_percent, minimum_additional_payment, already_paid_amount);
    const maximumDownPayment = amount_to_pay - selectedOffer.amount_min;
    const { register, handleSubmit, formState: { errors, isDirty }, watch, setValue, control, reset } = (0, _useSelectOfferFormDefault.default)({
        minimumDownPayment,
        maximumDownPayment,
        dateFormat
    });
    const setDownPaymentLabel = (minAmount, maxAmount)=>{
        const downPaymentMinLabel = (0, _numberFormat.formatCurrency)(minAmount, {
            withDecimals: false
        });
        const downPaymentMaxLabel = (0, _numberFormat.formatCurrency)(maxAmount, {
            withDecimals: false
        });
        return selectedOffer.id ? `Down Payment (${downPaymentMinLabel} - ${downPaymentMaxLabel})` : '';
    };
    const downPaymentLabel = setDownPaymentLabel(minimumDownPayment, maximumDownPayment);
    const inputDownPayment = watch('downPayment') || 0;
    const calculatedAmountToCollect = Math.round((inputDownPayment - already_paid_amount) * 100) / 100;
    const openAchWindow = ()=>{
        if (appLink) window.open(appLink, '_target');
    };
    const navigateToFinalizeTab = ()=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>{
                tab.isActive = tab.id === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER;
                setActiveTabId((0, _financingTabNames.financingTabNames).FINALIZE_OFFER);
                setEnableSignContract(true);
                return tab;
            });
        });
    };
    const handleAchConfirm = ()=>{
        navigateToFinalizeTab();
        setIsUpdateAchModalOpen(false);
        openAchWindow();
    };
    const handleAchSkipped = ()=>{
        navigateToFinalizeTab();
        setIsUpdateAchModalOpen(false);
    };
    (0, _reactDefault.default).useEffect(()=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>{
                if (tab.id === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER) tab.isDisabled = isDirty || next_action === (0, _financingTabNames.financingTabNames).SELECT_OFFER;
                return tab;
            });
        });
        if (next_action === 'SIGN_CONTRACT') {
            setRefetchInterval(false);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).transactionHistory);
        }
    }, [
        isDirty,
        next_action,
        queryClient
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>{
                if (tab.id === (0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY) {
                    tab.isDisabled = !enableSignContract && !selectedOffer.id || next_action === 'SIGN_CONTRACT';
                    if (!enableSignContract && !selectedOffer.id || next_action === 'SIGN_CONTRACT') setIsUpdateButtonDisabled(true);
                    else setIsUpdateButtonDisabled(false);
                }
                return tab;
            });
        });
    }, [
        enableSignContract,
        selectedOffer.id,
        next_action
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setValue('deliveryDate', delivery_date);
        setValue('downPayment', Math.max(additional_payment, minimumDownPayment));
    }, [
        additional_payment,
        delivery_date,
        minimumDownPayment,
        setValue,
        selectedOffer.id
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (!isGetAppFetching) switch(next_action){
            case (0, _financingTabNames.financingTabNames).SELECT_OFFER:
                break;
            case 'UPDATE_OFFER':
                setEnableSignContract(true);
                if (isUpdateButtonPressed) {
                    navigateToFinalizeTab();
                    setIsUpdateAchModalOpen(false);
                    setIsUpdateButtonPressed(false);
                } else {
                    navigateToFinalizeTab();
                    setIsUpdateAchModalOpen(false);
                }
                break;
            case 'SIGN_CONTRACT':
                setTabConfig((currentTabConfig)=>{
                    return currentTabConfig.map((tab)=>{
                        tab.isDisabled = tab.id !== (0, _financingTabNames.financingTabNames).FINALIZE_OFFER;
                        tab.isActive = tab.id === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER;
                        setActiveTabId((0, _financingTabNames.financingTabNames).FINALIZE_OFFER);
                        setEnableSignContract(true);
                        return tab;
                    });
                });
                break;
            default:
                break;
        }
    }, [
        next_action,
        isGetAppFetching,
        priceInfo?.payment_method
    ]);
    const handleTabChange = (tabId)=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>({
                    ...tab,
                    isActive: tabId === tab.id
                }));
        });
        setActiveTabId(tabId);
    };
    const onFocus = (event)=>event.target.select();
    const onSubmit = async (values)=>{
        scroll.bottom();
        setIsUpdateButtonPressed(true);
        setIsUpdateButtonDisabled(true);
        setActiveTab(activeTabId);
        setRequestId('');
        try {
            const result = await updateOffer({
                offer_id: selectedOffer.id,
                auto_pay: 'false',
                default_waived_interest: 'false',
                payment_date: 22,
                additional_payment: Number(watch('downPayment')) || 0,
                financing_down_payment: calculatedAmountToCollect,
                products: [
                    {
                        delivery_date: (0, _dateFns.formatISO)((0, _dateFns.parse)(values.deliveryDate, dateFormat, new Date()), {
                            representation: 'date'
                        }),
                        type: 'Medical Product',
                        description: 'Hearing Aids',
                        serial_number: null
                    }
                ]
            });
            setIsUpdateButtonDisabled(false);
            setRequestId(result.headers.request_id);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            reset(values);
            clearAlert();
        } catch (err) {
            setErrorAlert(err.message);
            setIsUpdateButtonDisabled(false);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.initializingFinancing')
    });
    const finalizeProps = {
        application: latestApp,
        routes,
        enableSignContract,
        watch,
        setIsLoading,
        setRefetchInterval
    };
    const selectOfferProps = {
        offers,
        selectedOffer,
        setSelectedOffer,
        enableSignContract,
        handleTabChange,
        amount_to_pay,
        already_paid_amount,
        routes,
        selected_offer_id
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: tabConfig.find((tab)=>tab.id === activeTabId)?.pageHeader || t('page.completeFinancing.header'),
        withStepProgress: false,
        stickyFooter: true,
        children: [
            (isLoadingUpdateOffer || isGetAppLoading || isGetAppFetching) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('synchrony.updateApplication.loaderText')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _postExchangeBannerDefault.default), {
                application: latestApp
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                className: "bg-slate-300",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                    className: "flex-wrap content-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "md:!flex-col-8 mb-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "!mb-0",
                                children: t('payment.totalAmountLabel')
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "md:!flex-col-4 text-right mb-0 pr-5 font-bold text-md",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                i18nKey: `{{amount}}`,
                                values: {
                                    amount: (0, _numberFormat.formatCurrency)(amount_to_pay, {
                                        withDecimals: true
                                    })
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                className: "bg-stone-100 !pt-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsetDefault.default), {
                        tabConfig: tabConfig,
                        onTabChange: handleTabChange
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            activeTabId === (0, _financingTabNames.financingTabNames).SELECT_OFFER && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectOfferDefault.default), {
                                ...selectOfferProps
                            }),
                            activeTabId === (0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                name: "selectOfferForm",
                                onSubmit: handleSubmit(onSubmit),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "!mt-4",
                                        children: t('common.updateDownPayment')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                                                    className: "md:!flex-col-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "mr-2",
                                                                    "data-testid": "value-available-credit",
                                                                    children: t('common.availableCredit')
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                                    content: t('common.availableCreditTooltip'),
                                                                    "data-testid": "tooltip-available-credit"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mt-1 text-lg font-semibold",
                                                            children: (0, _numberFormat.formatCurrency)(already_paid_amount)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                                    className: "md:!flex-col-6 lg:!flex-col-4",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                                        register: register,
                                                        label: downPaymentLabel,
                                                        "data-testid": "input-down-payment",
                                                        prependText: "$",
                                                        name: "downPayment",
                                                        type: "number",
                                                        disabled: !selectedOffer.id,
                                                        errors: errors,
                                                        allowDecimals: true,
                                                        onFocus: onFocus
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "!mt-4",
                                        children: t('common.updateDeliveryDate')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                                            className: "justify-between items-end",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                                className: "md:!flex-col-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deliveryDateFieldDefault.default), {
                                                    control: control,
                                                    errors: errors
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateAchModalDefault.default), {
                                        isModalOpen: isUpdateAchModalOpen,
                                        onModalConfirm: handleAchConfirm,
                                        onModalClose: handleAchSkipped
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                                        className: "flex justify-end mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                            className: "md:!flex-col-4 !flex !items-end",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                                block: true,
                                                type: "submit",
                                                "data-testid": "update-offer",
                                                disabled: !selectedOffer.id || isUpdateButtonDisabled,
                                                children: t('common.updateOffer')
                                            })
                                        })
                                    })
                                ]
                            }),
                            activeTabId === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _finalizeOfferDefault.default), {
                                ...finalizeProps
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = FinancingPreparation;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","date-fns":[["formatISO","5S5YG","default"],["parse","jBRYJ","default"]],"Core/components/FormElements/InputField":"6BJmW","Core/components/Page":"4xeqH","Core/components/Button":"6YNzH","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"Core/components/FormElements/Card":"23G8S","Core/components/Layout":"hweet","Core/components/Tabset/Tabset":"2cELS","Core/components/Tooltip":"ew5TJ","Core/hooks/useScrollBottom":"4561s","Core/components/Loader":"6S7S4","Core/stores/alert":"fPz3p","Core/utils/numberFormat":"6T56F","Core/config/appConfig":"7qX5H","Modules/financing/config/financingTabNames":"do2dN","Modules/financing/hooks/useSelectOfferForm":"8IYGg","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/financing/hooks/useUpdateOffer":"ftem6","Modules/financing/hooks/useGetApplication":"bc0DL","Modules/financing/hooks/useGetNextStep":"fWBFC","Core/hooks/queries/cacheKeys":"i5IL7","react-query":"ksTpv","Modules/financing/FinalizeOffer":"fl3xL","Modules/financing/components/UpdateAchModal":"8xEt1","Modules/financing/components/PostExchangeBanner":"eth8c","Modules/financing/components/DeliveryDateField":"jyEud","Core/stores/tabs":"gZ09A","Modules/financing/SelectOffer":"f6HuX","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jBRYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parse);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createForOfIteratorHelper = require("@babel/runtime/helpers/esm/createForOfIteratorHelper");
var _createForOfIteratorHelperDefault = parcelHelpers.interopDefault(_createForOfIteratorHelper);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, _createForOfIteratorHelperDefault.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, _typeofDefault.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = (0, _createForOfIteratorHelperDefault.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@babel/runtime/helpers/esm/typeof":"h3CKR","@babel/runtime/helpers/esm/createForOfIteratorHelper":"5UeMv","../_lib/defaultLocale/index.js":"c7LK3","../subMilliseconds/index.js":"gP0hg","../toDate/index.js":"iBeGL","../_lib/assign/index.js":"b4L3P","../_lib/format/longFormatters/index.js":"9x58N","../_lib/getTimezoneOffsetInMilliseconds/index.js":"e12CY","../_lib/protectedTokens/index.js":"66sVP","../_lib/toInteger/index.js":"5Ujd6","../_lib/requiredArgs/index.js":"hVUyW","./_lib/Setter.js":"3vBc9","./_lib/parsers/index.js":"c8KvZ","../_lib/defaultOptions/index.js":"fRx4S","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5UeMv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createForOfIteratorHelper);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, _unsupportedIterableToArrayJsDefault.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

},{"./unsupportedIterableToArray.js":"i7TZP","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i7TZP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"ehAb9","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ehAb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"b4L3P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assign);
function assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3vBc9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", ()=>Setter);
parcelHelpers.export(exports, "ValueSetter", ()=>ValueSetter);
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", ()=>DateToSystemTimezoneSetter);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheckDefault.default)(this, Setter);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", 0);
    }
    (0, _createClassDefault.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    (0, _inheritsDefault.default)(ValueSetter, _Setter);
    var _super = (0, _createSuperDefault.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, _classCallCheckDefault.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClassDefault.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    (0, _inheritsDefault.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, _createSuperDefault.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, _createClassDefault.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/defineProperty":"le3Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iiPVd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"g1vjz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"3Y52A","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cUolf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(t) {
    var r = (0, _isNativeReflectConstructJsDefault.default)();
    return function() {
        var e, o = (0, _getPrototypeOfJsDefault.default)(t);
        if (r) {
            var s = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, e);
    };
}

},{"./getPrototypeOf.js":"hl5B9","./isNativeReflectConstruct.js":"1rDrk","./possibleConstructorReturn.js":"43WJR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hl5B9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1rDrk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"43WJR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (0, _typeofJsDefault.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(t);
}

},{"./typeof.js":"h3CKR","./assertThisInitialized.js":"iiPVd","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lY0Dw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"25kt1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"h4jal","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h4jal":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"h3CKR","./toPrimitive.js":"awKjc","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"awKjc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"h3CKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"le3Cp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"h4jal","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"c8KvZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", ()=>parsers);
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"lxQsK","./YearParser.js":"5IM8p","./LocalWeekYearParser.js":"drqkO","./ISOWeekYearParser.js":"lYzkR","./ExtendedYearParser.js":"9SHAD","./QuarterParser.js":"aAkaI","./StandAloneQuarterParser.js":"i9GC1","./MonthParser.js":"4VVb2","./StandAloneMonthParser.js":"aIVXz","./LocalWeekParser.js":"dKbLH","./ISOWeekParser.js":"ar8rK","./DateParser.js":"3JGUv","./DayOfYearParser.js":"3SWfF","./DayParser.js":"du99s","./LocalDayParser.js":"80xWY","./StandAloneLocalDayParser.js":"kqzOF","./ISODayParser.js":"5CsDC","./AMPMParser.js":"iQ1LT","./AMPMMidnightParser.js":"zqyFb","./DayPeriodParser.js":"kI4OY","./Hour1to12Parser.js":"77lSw","./Hour0to23Parser.js":"aRpIC","./Hour0To11Parser.js":"7lSIP","./Hour1To24Parser.js":"hQWc9","./MinuteParser.js":"2AtSA","./SecondParser.js":"gSTIl","./FractionOfSecondParser.js":"2dJkz","./ISOTimezoneWithZParser.js":"5vvPw","./ISOTimezoneParser.js":"7tVOw","./TimestampSecondsParser.js":"k6If3","./TimestampMillisecondsParser.js":"8CkGo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lxQsK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", ()=>EraParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var EraParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(EraParser, _Parser);
    var _super = (0, _createSuperDefault.default)(EraParser);
    function EraParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 140);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cWCUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _setterJs = require("./Setter.js");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheckDefault.default)(this, Parser);
        (0, _definePropertyDefault.default)(this, "incompatibleTokens", void 0);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", void 0);
    }
    (0, _createClassDefault.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/defineProperty":"le3Cp","./Setter.js":"3vBc9","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5IM8p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", ()=>YearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var YearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(YearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(YearParser);
    function YearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8JeKR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", ()=>mapValue);
parcelHelpers.export(exports, "parseNumericPattern", ()=>parseNumericPattern);
parcelHelpers.export(exports, "parseTimezonePattern", ()=>parseTimezonePattern);
parcelHelpers.export(exports, "parseAnyDigitsSigned", ()=>parseAnyDigitsSigned);
parcelHelpers.export(exports, "parseNDigits", ()=>parseNDigits);
parcelHelpers.export(exports, "parseNDigitsSigned", ()=>parseNDigitsSigned);
parcelHelpers.export(exports, "dayPeriodEnumToHours", ()=>dayPeriodEnumToHours);
parcelHelpers.export(exports, "normalizeTwoDigitYear", ()=>normalizeTwoDigitYear);
parcelHelpers.export(exports, "isLeapYearIndex", ()=>isLeapYearIndex);
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"27Rmt","./constants.js":"l4wuv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"l4wuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", ()=>numericPatterns);
parcelHelpers.export(exports, "timezonePatterns", ()=>timezonePatterns);
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"drqkO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", ()=>LocalWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","../../../_lib/getUTCWeekYear/index.js":"hND6b","../../../_lib/startOfUTCWeek/index.js":"6qgUB","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lYzkR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", ()=>ISOWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","../../../_lib/startOfUTCISOWeek/index.js":"h0KAw","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9SHAD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", ()=>ExtendedYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ExtendedYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aAkaI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", ()=>QuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(QuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i9GC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", ()=>StandAloneQuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4VVb2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", ()=>MonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var MonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        return _this;
    }
    (0, _createClassDefault.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../utils.js":"8JeKR","../Parser.js":"cWCUf","../constants.js":"l4wuv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aIVXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", ()=>StandAloneMonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneMonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dKbLH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", ()=>LocalWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","../../../_lib/setUTCWeek/index.js":"gq2lH","../../../_lib/startOfUTCWeek/index.js":"6qgUB","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gq2lH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"5Ujd6","../../toDate/index.js":"iBeGL","../getUTCWeek/index.js":"kc4VQ","../requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ar8rK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", ()=>ISOWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","../../../_lib/setUTCISOWeek/index.js":"1rsal","../../../_lib/startOfUTCISOWeek/index.js":"h0KAw","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1rsal":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISOWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"5Ujd6","../../toDate/index.js":"iBeGL","../getUTCISOWeek/index.js":"keO4O","../requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3JGUv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", ()=>DateParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DateParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DateParser);
    function DateParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subPriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../utils.js":"8JeKR","../Parser.js":"cWCUf","../constants.js":"l4wuv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3SWfF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", ()=>DayOfYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayOfYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subpriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"du99s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", ()=>DayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var DayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayParser);
    function DayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../../../_lib/setUTCDay/index.js":"lWBJC","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lWBJC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCDay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"iBeGL","../requiredArgs/index.js":"hVUyW","../toInteger/index.js":"5Ujd6","../defaultOptions/index.js":"fRx4S","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"80xWY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", ()=>LocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","../../../_lib/setUTCDay/index.js":"lWBJC","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kqzOF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", ()=>StandAloneLocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","../../../_lib/setUTCDay/index.js":"lWBJC","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5CsDC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", ()=>ISODayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISODayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","../../../_lib/setUTCISODay/index.js":"ekV2u","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ekV2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISODay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"iBeGL","../requiredArgs/index.js":"hVUyW","../toInteger/index.js":"5Ujd6","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iQ1LT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", ()=>AMPMParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"zqyFb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", ()=>AMPMMidnightParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMMidnightParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kI4OY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", ()=>DayPeriodParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayPeriodParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"77lSw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", ()=>Hour1to12Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1to12Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aRpIC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", ()=>Hour0to23Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0to23Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7lSIP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", ()=>Hour0To11Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0To11Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hQWc9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", ()=>Hour1To24Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1To24Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2AtSA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", ()=>MinuteParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MinuteParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 60);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gSTIl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", ()=>SecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var SecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(SecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 50);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2dJkz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", ()=>FractionOfSecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(FractionOfSecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 30);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5vvPw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", ()=>ISOTimezoneWithZParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7tVOw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", ()=>ISOTimezoneParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../constants.js":"l4wuv","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"k6If3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", ()=>TimestampSecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampSecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 40);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, _createClassDefault.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8CkGo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", ()=>TimestampMillisecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 20);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, _createClassDefault.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/createSuper":"cUolf","@babel/runtime/helpers/esm/defineProperty":"le3Cp","../Parser.js":"cWCUf","../utils.js":"8JeKR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2cELS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Tabset);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tabItem = require("Core/components/Tabset/TabItem");
var _tabItemDefault = parcelHelpers.interopDefault(_tabItem);
function Tabset({ tabConfig, onTabChange, interactive = true }) {
    const [tabs, setTabs] = (0, _reactDefault.default).useState([]);
    (0, _reactDefault.default).useEffect(()=>{
        setTabs(!tabConfig ? [] : [
            ...tabConfig
        ]);
    }, [
        tabConfig
    ]);
    const toggleTab = (e)=>{
        const tabId = e.currentTarget.dataset.id;
        onTabChange(tabId);
    };
    if (!tabConfig) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        className: "flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4",
        id: "tabs-tabFill",
        children: tabs.map((tab)=>{
            return /*#__PURE__*/ (0, _react.createElement)((0, _tabItemDefault.default), {
                ...tab,
                "data-id": tab.id,
                key: tab.id,
                interactive: interactive,
                onClick: interactive ? toggleTab : undefined
            });
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Tabset/TabItem":"bWqGp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bWqGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function TabItem({ label, isActive, isDisabled, pageHeader, interactive = true, ...props }) {
    let tabStyle = 'transition-all duration-500 w-full block font-medium leading-tight border-b-3 px-6 py-3 my-2 pointer-events-cursor rounded-t-lg ';
    if (isActive) tabStyle += 'text-blue-600 border-blue-600 ';
    else tabStyle += 'border-slate-00 ';
    if (interactive && !isDisabled) tabStyle += 'hover:bg-gray-200 ';
    if (isDisabled) tabStyle += 'pointer-events-none  text-gray-300 ';
    else if (!interactive) tabStyle += 'pointer-events-none cursor-default ';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        className: "nav-item flex-auto text-center",
        role: "presentation",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            type: "button",
            disabled: isDisabled || !interactive,
            ...props,
            "data-page-header": pageHeader,
            className: tabStyle,
            id: "tabs-home-tabFill",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: label
            })
        })
    }, "tab.label");
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ew5TJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Tooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _icon = require("Core/components/Icon/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function Tooltip({ content }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "inline-block",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "relative flex items-center group fill-red",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    type: "question"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "absolute left-0 items-center hidden ml-6 group-hover:flex",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-3 h-3 -mr-2 rotate-45 bg-blue-700"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-blue-700 shadow-lg rounded-sm w-48",
                            children: content
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Icon/Icon":"cAPHo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cAPHo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Icon({ type, className = '' }) {
    switch(type){
        case 'warning':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                className: className + ' h-4 w-4 fill-orange-600',
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 64 64",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M31.97,64.02C14.33,64-.04,49.6,0,31.97,.04,14.31,14.44-.05,32.06,0c17.63,.05,31.95,14.4,31.94,32.02,0,17.65-14.4,32.03-32.03,32Zm-.02-23.58c1,0,2,0,3.01,0,.92,0,1.05-.14,1.1-1.03,.05-.86,.11-1.72,.18-2.58,.31-4.2,.63-8.4,.94-12.61,.21-2.83,.42-5.66,.65-8.5,.2-2.46-.61-4.48-2.72-5.81-2-1.26-4.12-1.28-6.14-.05-2.13,1.3-2.99,3.3-2.81,5.76,.26,3.39,.53,6.78,.78,10.17,.34,4.6,.67,9.2,1,13.79,.04,.61,.32,.87,.93,.86,1.02-.02,2.05,0,3.08,0Zm.04,4.96c-2.68,0-4.85,2.17-4.85,4.83,0,2.61,2.2,4.81,4.81,4.83,2.68,.02,4.89-2.21,4.87-4.9-.03-2.65-2.17-4.76-4.83-4.76Z"
                })
            });
        case 'success':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 64 64",
                className: className + ' h-4 w-4 mr-6',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#4bba7a",
                            d: "M.01,34.39v-4.74c.26-.9,.24-1.83,.4-2.74,1.24-7.21,4.42-13.43,9.89-18.31C19.46,.4,30.1-1.98,41.83,1.65c9.14,2.83,15.6,8.93,19.52,17.65,1.67,3.72,2.52,7.65,2.62,11.73-.87-.59-1.55-1.38-2.32-2.08-2.47-2.23-4.87-4.53-7.33-6.76-.36-.33-.64-.82-1.21-.87-.28-.75-.75-1.37-1.33-1.93-.76-.74-1.5-1.5-2.26-2.25-.31-.31-.63-.6-1.02-.82-1.59-.88-3.33-.57-4.77,.85-5.34,5.31-10.69,10.62-16.02,15.95-.35,.35-.54,.4-.91,.02-2.18-2.23-4.38-4.44-6.59-6.65-1.7-1.7-3.93-1.71-5.65-.03-.86,.84-1.72,1.7-2.56,2.56-.27,.28-.53,.59-.73,.93-.9,1.57-.6,3.31,.78,4.71,3.97,4,7.95,8,11.92,12.01,.54,.55,1.09,1.08,1.78,1.45-.04,.31,.24,.42,.4,.58,4.48,4.49,8.97,8.97,13.45,13.45,.22,.22,.48,.41,.55,.74-1.08,.37-2.22,.53-3.34,.73-.85,.15-1.72,.12-2.56,.36h-4.62c-.07-.14-.21-.11-.33-.12-1.39-.11-2.77-.31-4.13-.62C12.03,60.3,2.34,49.89,.34,36.58c-.11-.73-.09-1.48-.33-2.18Z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#32a16c",
                            d: "M63.97,31.03c.17,3.73-.31,7.39-1.54,10.91-3.71,10.63-11,17.58-21.78,20.87-.16,.05-.33,.06-.49,.09-.08-.33-.33-.52-.55-.74-4.48-4.48-8.97-8.96-13.45-13.45-.16-.16-.44-.27-.4-.58,1.82,.61,3.32,.16,4.62-1.24,1.29-1.39,2.63-2.72,3.97-4.06,5.79-5.77,11.58-11.55,17.4-17.29,1.21-1.2,1.78-2.52,1.36-4.21,.57,.05,.85,.54,1.21,.87,2.46,2.24,4.87,4.53,7.33,6.76,.77,.7,1.45,1.49,2.32,2.08Z"
                        })
                    ]
                })
            });
        case 'spinner':
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                className: className + ' inline-block animate-spin h-5 w-5 text-gray-400',
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        className: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                ]
            });
        case 'receipt':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 88.16 102.86",
                className: className + ' h-6 w-6 fill-gray-600',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    id: "c",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M43.41,83v4h-1.41c-.51-1.28-.9-2.62-1.16-4h2.57Z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            x: "11.21",
                            y: "13.78",
                            width: "43.24",
                            height: "8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            x: "11.21",
                            y: "30.52",
                            width: "43.24",
                            height: "8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            x: "11.21",
                            y: "47.27",
                            width: "43.24",
                            height: "8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M44.8,64.82c-1.72,2.37-2.99,5.08-3.72,8H11.21v-8H44.8Z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                            points: "78.22 71.79 60.15 88.12 58.77 86.59 57.51 85.11 50.64 77.01 53.69 74.42 60.48 82.43 75.53 68.82 78.22 71.79"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                            points: "58.77 86.59 57.47 85.15 57.51 85.11 58.77 86.59"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M40.84,83c.26,1.38,.65,2.72,1.16,4h1.41v-4h-2.57Z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M67,55.31V1H1V87H42c3.41,8.69,11.89,14.86,21.78,14.86,12.89,0,23.38-10.49,23.38-23.39,0-11.8-8.79-21.59-20.16-23.16ZM5,83V5H63V55.1c-7.49,.24-14.1,4.03-18.2,9.72-1.72,2.37-2.99,5.08-3.72,8-.45,1.81-.69,3.7-.69,5.65,0,1.55,.15,3.06,.45,4.53H5Zm58.78,14.86c-10.69,0-19.39-8.7-19.39-19.39,0-1.96,.29-3.86,.84-5.65,.94-3.05,2.61-5.79,4.8-8,3.51-3.54,8.38-5.74,13.75-5.74,10.69,0,19.38,8.7,19.38,19.39s-8.69,19.39-19.38,19.39Z"
                        })
                    ]
                })
            });
        case 'question':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                className: className + ' w-4 h-4 fill-slate-600 cursor-pointer inline-block',
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1000 1000",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    id: "path",
                    d: "M 500 0C 224 0 0 224 0 500C 0 776 224 1000 500 1000C 776 1000 1000 776 1000 500C 1000 224 776 0 500 0C 500 0 500 0 500 0 M 501 191C 626 191 690 275 690 375C 690 475 639 483 595 513C 573 525 558 553 559 575C 559 591 554 602 541 601C 541 601 460 601 460 601C 446 601 436 581 436 570C 436 503 441 488 476 454C 512 421 566 408 567 373C 566 344 549 308 495 306C 463 303 445 314 411 361C 400 373 384 382 372 373C 372 373 318 333 318 333C 309 323 303 307 312 293C 362 218 401 191 501 191C 501 191 501 191 501 191M 500 625C 541 625 575 659 575 700C 576 742 540 776 500 775C 457 775 426 739 425 700C 425 659 459 625 500 625C 500 625 500 625 500 625"
                })
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    }
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4561s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScrollBottom", ()=>useScrollBottom);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useScrollBottom() {
    const scrollBottom = (x = 0)=>{
        window.scrollTo({
            left: x,
            top: document.body.scrollHeight,
            behavior: 'smooth'
        });
    };
    (0, _reactDefault.default).useEffect(()=>{
        scrollBottom();
    }, []);
    return {
        bottom: scrollBottom
    };
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"do2dN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "financingTabNames", ()=>financingTabNames);
const financingTabNames = {
    SELECT_OFFER: 'SELECT_OFFER',
    DOWN_PAYMENT_AND_DELIVERY: 'DOWN_PAYMENT_AND_DELIVERY',
    FINALIZE_OFFER: 'FINALIZE_OFFER',
    CONTRACT_STATUS: 'CONTRACT_STATUS'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8IYGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateDownPaymentAmount", ()=>validateDownPaymentAmount);
parcelHelpers.export(exports, "validateCustomDateFormat", ()=>validateCustomDateFormat);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
const validateDownPaymentAmount = (minimumDownPayment, maximumDownPayment)=>(value)=>{
        return value !== '' && value >= minimumDownPayment && value <= maximumDownPayment;
    };
const validateCustomDateFormat = (dateFormat)=>(val)=>{
        return val ? (0, _dateFns.isValid)((0, _dateFns.parse)(val, dateFormat, new Date())) : true;
    };
const useSelectOfferForm = ({ minimumDownPayment, maximumDownPayment, dateFormat })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            deliveryDate: _v3.any().refine((val)=>!!val, {
                message: 'Delivery date is required'
            }).refine(validateCustomDateFormat(dateFormat), {
                message: t('common.invalidDateFormat')
            }),
            downPayment: _v3.any().transform(parseFloat).refine(validateDownPaymentAmount(minimumDownPayment, maximumDownPayment), {
                message: t('common.invalidValueRange', {
                    min: minimumDownPayment,
                    max: maximumDownPayment
                })
            })
        });
    }, [
        t,
        minimumDownPayment,
        maximumDownPayment,
        dateFormat
    ]);
    return (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        defaultValues: {
            downPayment: minimumDownPayment,
            deliveryDate: (0, _dateFns.format)(new Date(), dateFormat)
        }
    });
};
exports.default = useSelectOfferForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","react-hook-form":"53GLT","date-fns":[["format","7JNRj","default"],["isValid","jCEss","default"],["parse","jBRYJ","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ftem6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdateOffer);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
function useUpdateOffer() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>(0, _platformApi.putWithHeaders)(`/financing/update-offer`, payload), {
        throwOnError: true,
        retry: 3,
        onSuccess: ()=>{
            queryClient.removeQueries((0, _cacheKeysDefault.default).financingNextStep);
            return queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fl3xL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinalizerOffer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layout = require("Core/components/Layout");
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
var _alert = require("Core/components/Alert");
var _useGetNextStep = require("Modules/financing/hooks/useGetNextStep");
var _spinner = require("Core/components/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _financingSummary = require("./FinancingSummary");
var _financingSummaryDefault = parcelHelpers.interopDefault(_financingSummary);
var _sendLink = require("Modules/financing/FinalizeOffer/SendLink");
var _sendLinkDefault = parcelHelpers.interopDefault(_sendLink);
var _logger = require("Core/utils/logger");
var _utils = require("Core/utils/utils");
var _financingModal = require("Core/components/FinancingModal/FinancingModal");
var _financingModalDefault = parcelHelpers.interopDefault(_financingModal);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
function FinalizerOffer({ application, enableSignContract, watch, setRefetchInterval, routes }) {
    const [state, setState] = (0, _reactDefault.default).useState({
        refetchInterval: false,
        financingWindow: null,
        isSignContractLoading: false,
        isError: false,
        isModalOpen: false
    });
    const { t } = (0, _reactI18Next.useTranslation)();
    const [isTeleaudiology, setIsTeleaudiology] = (0, _reactDefault.default).useState(false);
    const blockFinalizeOfferForFinalQuote = (0, _utils.getUrlParamIgnoreCase)('blockFinalizeOfferForFinalQuote') === 'true';
    const { data: nextStepApp } = (0, _useGetNextStep.useGetNextStep)(state.refetchInterval);
    const finalApp = nextStepApp || application || {};
    const { external_reference_id = '', payload: { links: { cart: redirection_link }, application_id = '', payment_id = '' } } = finalApp;
    (0, _reactDefault.default).useEffect(()=>{
        const isSamePageFlow = (0, _utils.getUrlParamIgnoreCase)('samePageFlow') === 'true';
        setIsTeleaudiology(!!isSamePageFlow);
    }, []);
    const openFinancingWindow = (e)=>{
        (0, _logger.postLogMessage)({
            feature: (0, _logger.features).financingSignContract,
            action: (0, _logger.actions).signContractButtonClicked,
            status: 'success',
            payment_id,
            external_reference_id,
            application_id
        });
        e.preventDefault();
        if (redirection_link) {
            if (isTeleaudiology) {
                const financingWindow = window.open(redirection_link, '_self');
                setState({
                    ...state,
                    refetchInterval: 5000,
                    financingWindow,
                    isSignContractLoading: true
                });
            } else {
                // Original behavior - open in new tab
                const financingWindow = window.open(redirection_link, '_blank');
                setState({
                    ...state,
                    refetchInterval: 5000,
                    financingWindow,
                    isSignContractLoading: true
                });
            }
        }
    };
    const closeModal = ()=>{
        setState({
            ...state,
            isModalOpen: false
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full m-auto",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                            type: "shade",
                            "data-testid": "notification-financing-intro",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-sm w-full",
                                children: t('synchrony.financingApproved.intro')
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSummaryDefault.default), {
                            watch: watch,
                            setRefetchInterval: setRefetchInterval,
                            routes: routes,
                            application: application
                        }),
                        state.isSignContractLoading && isTeleaudiology && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                            type: "overlay",
                            message: "Redirecting to Contract page..."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                            className: "px-2 mt-4 items-center justify-center",
                            children: state.isSignContractLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                className: "flex justify-center items-center w-full mx-0",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                                        className: "!flex-col-12 text-center mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                                                small: true,
                                                className: "!w-6 !h-6 !text-primary"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "pl-4 text-lg font-semibold",
                                                children: t('financing.nextgen.signContract.loadingText')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!flex-col-12",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.TextButton), {
                                            block: true,
                                            "data-testid": "set-offer",
                                            onClick: openFinancingWindow,
                                            disabled: !enableSignContract,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-sm",
                                                children: isTeleaudiology ? t('financing.openLinkAgain') : t('financing.openLinkAgain')
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "lg:!flex-col-6 px-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendLinkDefault.default), {
                                            className: "m-auto"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                className: "flex justify-center items-center w-full px-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!flex-col-1 lg:!flex-col-3 px-0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "lg:!flex-col-6 px-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                            block: true,
                                            "data-testid": "set-offer",
                                            onClick: openFinancingWindow,
                                            disabled: !enableSignContract || blockFinalizeOfferForFinalQuote,
                                            children: t('common.signContract')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!flex-col-3 text-right mb-2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "lg:!flex-col-6 px-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendLinkDefault.default), {
                                            className: "m-auto"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingModalDefault.default), {
                isOpen: state.isModalOpen,
                onClose: closeModal,
                url: redirection_link
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Layout":"hweet","Core/components/Button":"6YNzH","react-i18next":"244ua","Core/components/Alert":"fmmNR","Modules/financing/hooks/useGetNextStep":"fWBFC","Core/components/Spinner":"bZo5I","./FinancingSummary":"2VHyc","Modules/financing/FinalizeOffer/SendLink":"l5A5K","Core/utils/logger":"cWDKQ","Core/utils/utils":"hwOBZ","Core/components/FinancingModal/FinancingModal":"koo6T","Core/components/Loader":"6S7S4","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2VHyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layout = require("Core/components/Layout");
var _dropdown = require("Core/components/Dropdown/Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _icon = require("Core/components/Icon/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _numberFormat = require("Core/utils/numberFormat");
var _utils = require("Core/utils/utils");
var _useGetTransactionHistory = require("Core/hooks/platform/useGetTransactionHistory");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _reactQuery = require("react-query");
var _reactLocation = require("react-location");
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
function FinancingSummary({ routes, watch, application, setRefetchInterval }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const navigate = (0, _reactLocation.useNavigate)();
    const [isCollectPaymentLoading, setIsCollectPaymentLoading] = (0, _reactDefault.default).useState(false);
    const { data: transactions } = (0, _useGetTransactionHistory.useGetTransactionHistory)();
    const [receiptList, setReceiptList] = (0, _reactDefault.default).useState([]);
    const { next_action, payload: { already_paid_amount = 0 } = {} } = application ?? {};
    const priceInfo = application?.payload?.offer_term?.price;
    const { financed, monthly_payment = '' } = priceInfo || {};
    const availableCredit = watch('downPayment') - already_paid_amount;
    const handleUnload = (e)=>{
        const message = '';
        (e || window.event).returnValue = message;
        return message;
    };
    (0, _reactDefault.default).useEffect(()=>{
        if (transactions && transactions.length > 0) setReceiptList(transactions.map((item, idx, arr)=>{
            const receiptNum = arr.length === 1 ? '' : idx + 1;
            return {
                label: 'Receipt ' + receiptNum,
                key: item?.payment_id,
                url: item?.receipt?.url
            };
        }));
    }, [
        transactions
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (next_action === 'SIGN_CONTRACT') setIsCollectPaymentLoading(false);
        else if (next_action === 'DONE' || next_action === 'PENDING_DOWN_PAYMENT') navigate({
            to: routes.financing,
            search: true
        });
        return ()=>{
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, [
        next_action,
        navigate,
        routes.financing
    ]);
    const onCollectPayment = ()=>{
        const url = (0, _utils.generateURL)({
            url: routes.mixed
        });
        setIsCollectPaymentLoading(true);
        setRefetchInterval(5000);
        queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
        setTimeout(()=>setIsCollectPaymentLoading(false), 300000);
        window.open(url, '_blank')?.focus();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "text-center mb-4",
                children: t('common.summary')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-1 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-funding-by-allegro",
                        children: t('synchrony.fundingBy')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2",
                        "data-testid": "value-funding-by-allegro",
                        children: isNaN(financed) ? '-' : (0, _numberFormat.formatCurrency)(financed % 1 > 0 ? financed.toFixed(2) : financed)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-1 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-monthly-payment",
                        children: t('financing.monthlyPayment')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2 ",
                        "data-testid": "value-monthly-payment",
                        children: (0, _numberFormat.formatCurrency)(monthly_payment, {
                            withDecimals: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-1 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-available-credit",
                        children: t('common.availableCredit')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2 ",
                        "data-testid": "value-available-credit",
                        children: (0, _numberFormat.formatCurrency)(already_paid_amount)
                    })
                ]
            }),
            next_action === 'SIGN_CONTRACT' && availableCredit > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "items-center mx-0 flex-nowrap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-additional-collected-amount",
                        children: t('financing.additionalCollectedAmount')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                        className: "!flex-col-2 flex justify-end items-center px-2",
                        "data-testid": "value-additional-collected-amount",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                type: "success"
                            }),
                            (0, _numberFormat.formatCurrency)(availableCredit)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-3 text-left",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                transactions && transactions.length === 1 && receiptList.map(({ url, key })=>{
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "bg-transparent text-primary hover:bg-gray-100 p-2 rounded text-sm",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "data-testid": "receipt-item",
                                        href: url,
                                        children: t('common.viewReceipt')
                                    }, key);
                                }),
                                receiptList && receiptList.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default), {
                                    label: t('common.viewReceipt'),
                                    list: receiptList
                                })
                            ]
                        })
                    })
                ]
            }),
            next_action !== 'SIGN_CONTRACT' && availableCredit > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "items-center mx-0  flex-nowrap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left text-amber-700",
                        "data-testid": "label-amount-to-collect",
                        children: t('financing.amountToBeCollected')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                        className: "!flex-col-2 text-right flex justify-end items-center px-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "!hidden lg:!block",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                    type: "warning",
                                    className: "mr-3"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-amber-700",
                                "data-testid": "value-amount-to-collect",
                                children: (0, _numberFormat.formatCurrency)(availableCredit)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-3 text-left",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.TextButton), {
                            disabled: isCollectPaymentLoading,
                            onClick: onCollectPayment,
                            "data-testid": "btn-collect-payment",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex",
                                children: [
                                    isCollectPaymentLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "inline-block mr-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                            type: "spinner"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "!hidden lg:!block",
                                        children: t('financing.collectPayment')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "!block lg:!hidden",
                                        children: 'Collect'
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-4 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-total-down-payment",
                        children: t('financing.totalDownPayment')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2",
                        "data-testid": "value-total-down-payment",
                        children: (0, _numberFormat.formatCurrency)(watch('downPayment') || 0)
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Layout":"hweet","Core/components/Dropdown/Dropdown":"g18oR","Core/components/Icon/Icon":"cAPHo","Core/utils/numberFormat":"6T56F","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetTransactionHistory":"3gwu1","Core/hooks/queries/cacheKeys":"i5IL7","react-query":"ksTpv","react-location":"8hNco","Core/components/Button":"6YNzH","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"g18oR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Dropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _useOutsideAlerter = require("Modules/core/hooks/useOutsideAlerter");
var _useOutsideAlerterDefault = parcelHelpers.interopDefault(_useOutsideAlerter);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Dropdown({ label, list }) {
    const [isDropdownVisible, setIsDropdownVisible] = (0, _reactDefault.default).useState(false);
    const callback = ()=>{
        setIsDropdownVisible(false);
    };
    const wrapperRef = (0, _reactDefault.default).useRef(null);
    (0, _useOutsideAlerterDefault.default)(wrapperRef, callback);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "relative inline-block text-left",
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    onClick: ()=>setIsDropdownVisible((val)=>!val),
                    type: "button",
                    className: "text-primary inline-flex w-full justify-center rounded-md px-4 py-2 text-sm font-medium hover:bg-gray-50 focus:outline-none",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "hidden md:inline-block",
                            children: label
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            className: "-mr-1 ml-2 h-5 w-5",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z",
                                clipRule: "evenodd"
                            })
                        })
                    ]
                })
            }),
            isDropdownVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "absolute right-0 z-10 mt-2 w-full min-w-[128px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                role: "menu",
                "aria-orientation": "vertical",
                "aria-labelledby": "menu-button",
                tabIndex: "-1",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "py-1",
                    role: "none",
                    children: list.map((item)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: item.url,
                            target: "_blank",
                            rel: "noreferrer",
                            className: "text-blue-700 block px-4 py-2 text-sm hover:bg-gray-100 underline underline-offset-4",
                            role: "menuitem",
                            tabIndex: "-1",
                            id: "menu-item-0",
                            children: item.label
                        }, item.url);
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","Modules/core/hooks/useOutsideAlerter":"eYtTi","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eYtTi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOutsideAlerter);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useOutsideAlerter(ref, callback) {
    (0, _reactDefault.default).useEffect(()=>{
        const handleClickOutside = (event)=>{
            if (ref.current && !ref.current.contains(event.target)) callback();
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref,
        callback
    ]);
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"l5A5K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SendLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _sendLinkModal = require("Modules/financing/FinalizeOffer/SendLink/components/SendLinkModal");
var _sendLinkModalDefault = parcelHelpers.interopDefault(_sendLinkModal);
var _sendLinkButton = require("Modules/financing/FinalizeOffer/SendLink/components/SendLinkButton");
var _sendLinkButtonDefault = parcelHelpers.interopDefault(_sendLinkButton);
var _reactI18Next = require("react-i18next");
function SendLink({ className }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const AUTO_CLOSE_TIME_MS = 45000;
    const [isModalOpen, setIsModalOpen] = (0, _reactDefault.default).useState(false);
    const [showSendLinkMessage, setShowSendLinkMessage] = (0, _reactDefault.default).useState(false);
    const [showButtonSpinner, setShowButtonSpinner] = (0, _reactDefault.default).useState(false);
    const [method, setMethod] = (0, _reactDefault.default).useState('');
    const openSendLinkModal = ()=>{
        setIsModalOpen(true);
        setShowSendLinkMessage(false);
    };
    const handleLinkSent = ({ method: argMethod })=>{
        setMethod(argMethod);
        setShowSendLinkMessage(true);
        setShowButtonSpinner(true);
    };
    const onTimerFinished = ()=>{
        setShowButtonSpinner(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)(className, 'w-full'),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendLinkButtonDefault.default), {
                    openSendLinkModal: openSendLinkModal,
                    showButtonSpinner: showButtonSpinner,
                    spinnerTime: AUTO_CLOSE_TIME_MS,
                    onTimerFinished: onTimerFinished
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendLinkModalDefault.default), {
                    isModalOpen: isModalOpen,
                    setIsModalOpen: setIsModalOpen,
                    onLinkSent: handleLinkSent
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        showSendLinkMessage && method === 'SMS' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-slate-400 text-justify border-slate-300 border-l-4 pl-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-semibold",
                                    children: "Note: "
                                }),
                                t('financing.nextgen.sendlink.sentInfo.sms')
                            ]
                        }),
                        showSendLinkMessage && method === 'EMAIL' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-slate-400 text-justify border-slate-300 border-l-4 pl-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-semibold",
                                    children: "Note: "
                                }),
                                t('financing.nextgen.sendlink.sentInfo.email')
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","Modules/financing/FinalizeOffer/SendLink/components/SendLinkModal":"aXLum","Modules/financing/FinalizeOffer/SendLink/components/SendLinkButton":"brQgG","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aXLum":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SendLinkModal);
var _jsxRuntime = require("react/jsx-runtime");
var _layout = require("Core/components/Layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sendContractLinkForm = require("Modules/financing/FinalizeOffer/SendLink/components/SendContractLinkForm");
var _sendContractLinkFormDefault = parcelHelpers.interopDefault(_sendContractLinkForm);
var _reactI18Next = require("react-i18next");
function SendLinkModal({ isModalOpen, setIsModalOpen, onLinkSent }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
        isOpen: isModalOpen,
        className: "w-[50em]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "font-bold text-center",
                children: t('financing.nextgen.sendLink.modal.title')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendContractLinkFormDefault.default), {
                setIsModalOpen: setIsModalOpen,
                onLinkSent: onLinkSent
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","Core/components/Layout":"hweet","react":"2o0ib","Modules/financing/FinalizeOffer/SendLink/components/SendContractLinkForm":"fa3uE","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fa3uE":[function(require,module,exports,__globalThis) {
// import StyledFormGroup from 'Core/components/FormElements/StyledFormGroup';
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SendLinkForm);
var _jsxRuntime = require("react/jsx-runtime");
var _layout = require("Core/components/Layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useSendLink = require("Modules/financing/FinalizeOffer/SendLink/hooks/useSendLink");
var _useSendLinkDefault = parcelHelpers.interopDefault(_useSendLink);
var _useSendLinkForm = require("Modules/financing/FinalizeOffer/SendLink/hooks/useSendLinkForm");
var _useSendLinkFormDefault = parcelHelpers.interopDefault(_useSendLinkForm);
var _emailOption = require("./EmailOption");
var _emailOptionDefault = parcelHelpers.interopDefault(_emailOption);
var _smsOption = require("./SmsOption");
var _smsOptionDefault = parcelHelpers.interopDefault(_smsOption);
var _button = require("Core/components/Button");
var _hi = require("react-icons/hi");
var _fa = require("react-icons/fa");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _reactI18Next = require("react-i18next");
var _alert = require("Core/components/Alert");
var _error = require("Core/components/FormElements/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactToastify = require("react-toastify");
var _radioTile = require("./RadioTile");
var _radioTileDefault = parcelHelpers.interopDefault(_radioTile);
function SendLinkForm({ setIsModalOpen, onLinkSent }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const Methods = [
        {
            id: 'EMAIL',
            title: t('financing.nextgen.sendlink.radioTitle.email'),
            description: t('financing.nextgen.sendlink.radioDescription.email'),
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi.HiOutlineMail), {
                size: 40
            })
        },
        {
            id: 'SMS',
            title: t('financing.nextgen.sendlink.radioTitle.sms'),
            description: t('financing.nextgen.sendlink.radioDescription.sms'),
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaSms), {
                size: 40
            })
        }
    ];
    const { mutateAsync: sendLinkQuery, isLoading } = (0, _useSendLinkDefault.default)();
    const defVals = {
        method: '',
        email: '',
        phone: ''
    };
    const form = (0, _useSendLinkFormDefault.default)(defVals);
    const { watch, register, handleSubmit, formState: { errors } } = form;
    const method = watch('method');
    const onModalClose = ()=>{
        setIsModalOpen(false);
    };
    const onModalConfirm = async (formData)=>{
        const { method: formMethod, email, phone } = formData;
        if (formMethod === 'EMAIL' && email || formMethod === 'SMS' || phone) {
            const resp = await sendLinkQuery({
                method: formMethod,
                email,
                phone
            });
            if (resp.status === 201) {
                const toastString = t('financing.nextgen.sendlink.toast.description');
                (0, _reactToastify.toast).success(toastString);
                setIsModalOpen(false);
            }
            onLinkSent(formData);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading')
    });
    const hasFormErrors = Object.keys(errors).length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleSubmit(onModalConfirm),
        "data-testid": "sendlink-popup",
        children: [
            hasFormErrors && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                type: "error",
                children: t('status.error.checkErrors')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "flex my-8 justify-between !mx-auto w-2/3",
                children: [
                    Methods.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioTileDefault.default), {
                            item: item,
                            register: register,
                            defaultValue: method
                        }, item.id)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "md:!flex-col-12",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                            message: errors?.method?.message,
                            show: Boolean(errors?.method?.message)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                        className: "md:!flex-col-12 mb-0 items-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _classnamesDefault.default)({
                                    hidden: method !== 'EMAIL'
                                }),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailOptionDefault.default), {
                                    form: form,
                                    errors: errors
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _classnamesDefault.default)({
                                    hidden: method !== 'SMS'
                                }),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smsOptionDefault.default), {
                                    form: form,
                                    errors: errors
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center justify-center gap-8 w-2/3 !mx-auto px-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                        type: "reset",
                        onClick: onModalClose,
                        "data-testid": "btn-cancel-sendlink",
                        block: true,
                        children: t('common.cancel')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                        type: "submit",
                        "data-testid": "btn-confirm-sendlink",
                        block: true,
                        children: t('common.sendLinkButtonLabel')
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","Core/components/Layout":"hweet","react":"2o0ib","Modules/financing/FinalizeOffer/SendLink/hooks/useSendLink":"9XTNP","Modules/financing/FinalizeOffer/SendLink/hooks/useSendLinkForm":"i4xqm","./EmailOption":"2muqr","./SmsOption":"9LGSu","Core/components/Button":"6YNzH","react-icons/hi":"3dH5y","react-icons/fa":"9Vrsi","classnames":"f971Y","Core/components/Loader":"6S7S4","react-i18next":"244ua","Core/components/Alert":"fmmNR","Core/components/FormElements/Error":"dyj9l","react-toastify":"8eTVO","./RadioTile":"jjijh","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9XTNP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSendLink);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _reactI18Next = require("react-i18next");
var _logger = require("Core/utils/logger");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function transformPayload({ source, method, email, phone }) {
    return {
        event_id: window.crypto.randomUUID(),
        event_type: 'create',
        object_type: 'platform-link',
        country: 'US',
        event_dispatched_at: Date.now(),
        source,
        payload: {
            method,
            email,
            phone
        }
    };
}
function useSendLink() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    return (0, _reactQuery.useMutation)((payload)=>(0, _platformApi.postWithHeaders)(`/send-link`, transformPayload({
            ...payload,
            source: paymentInfo.source
        }), {
            headers: {
                external_reference_id: paymentInfo?.external_reference_id
            }
        }), {
        throwOnError: true,
        enabled: false,
        onSuccess (data) {
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).sendContractLink,
                status: 'success'
            });
            clearAlert();
            return data;
        },
        onError (error) {
            setErrorAlert(t('status.error.sendLinkRequestFailed') + `(${error?.response?.data?.message})`);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/stores/alert":"fPz3p","react-i18next":"244ua","Core/utils/logger":"cWDKQ","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i4xqm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSendLinkForm);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _v3 = require("zod/v3");
var _reactHookForm = require("react-hook-form");
var _zod = require("@hookform/resolvers/zod");
var _reactI18Next = require("react-i18next");
function useSendLinkForm(defaultValues) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            method: _v3.string().min(1, {
                message: t('common.requiredFieldSendLinkMethod')
            }),
            email: _v3.string().email({
                message: t('common.invalidFormatEmail')
            }).optional().or(_v3.literal('')),
            phone: _v3.string().min(10, {
                message: t('common.requiredFieldPhone')
            }).optional().or(_v3.literal(''))
        }).refine((data)=>data.method !== 'SMS' || data.phone, {
            message: t('common.requiredFieldPhone'),
            path: [
                'phone'
            ]
        }).refine((data)=>data.method !== 'EMAIL' || data.email, {
            message: t('common.requiredFieldEmail'),
            path: [
                'email'
            ]
        });
    }, [
        t
    ]);
    return (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        defaultValues,
        shouldUnregister: true
    });
}

},{"react":"2o0ib","zod/v3":"kXNSc","react-hook-form":"53GLT","@hookform/resolvers/zod":"c0M5u","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2muqr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EmailOption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _reactI18Next = require("react-i18next");
function EmailOption({ form, errors }) {
    const { register } = form;
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
        block: true,
        register: register,
        label: t('common.email'),
        name: "email",
        errors: errors
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/InputField":"6BJmW","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9LGSu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SMSOption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _reactI18Next = require("react-i18next");
function SMSOption({ form, errors }) {
    const { register } = form;
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
        block: true,
        register: register,
        errors: errors,
        label: t('common.phone'),
        name: "phone"
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/InputField":"6BJmW","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jjijh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RadioTile);
var _jsxRuntime = require("react/jsx-runtime");
var _layout = require("Core/components/Layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function RadioTile({ item, register, defaultValue }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
        className: "!flex-col-6 h-full",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "items-center h-full",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    ...register('method'),
                    id: item.id,
                    type: "radio",
                    value: item.id,
                    defaultChecked: defaultValue === item.id,
                    className: "hidden peer"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: item.id,
                    "aria-label": item.title,
                    className: "inline-flex items-center justify-between w-full h-full p-5 text-gray-500 bg-white border border-gray-200 rounded cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col items-center text-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "m-auto",
                                children: item.icon
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-full text-lg font-semibold",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-full text-xs",
                                children: item.description
                            })
                        ]
                    })
                })
            ]
        })
    }, item.id);
}

},{"react/jsx-runtime":"9x2lT","Core/components/Layout":"hweet","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"brQgG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SendLinkButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("Core/components/Button");
var _layout = require("Core/components/Layout");
var _spinner = require("Core/components/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _reactI18Next = require("react-i18next");
var _sendLinkTimer = require("Modules/financing/FinalizeOffer/SendLink/components/SendLinkTimer");
var _sendLinkTimerDefault = parcelHelpers.interopDefault(_sendLinkTimer);
function SendLinkButton({ openSendLinkModal, showButtonSpinner, onTimerFinished, spinnerTime }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    if (showButtonSpinner) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
        "data-testid": "sendlink-spinner",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
            className: "!flex-col-12 text-center mb-2 mt-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                    small: true,
                    className: "!w-6 !h-6 !text-primary"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "pl-4 text-success",
                    children: [
                        t('financing.nextgen.sendLink.loadingText'),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendLinkTimerDefault.default), {
                            duration: spinnerTime,
                            onTimerFinished: onTimerFinished,
                            className: "font-semibold"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
        block: true,
        onClick: openSendLinkModal,
        "data-testid": "btn-sendlink-open-popup",
        children: t('common.sendLinkButtonLabel')
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Button":"6YNzH","Core/components/Layout":"hweet","Core/components/Spinner":"bZo5I","react-i18next":"244ua","Modules/financing/FinalizeOffer/SendLink/components/SendLinkTimer":"faVeP","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"faVeP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SendLinkTimer);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
function SendLinkTimer({ duration, onTimerFinished, className }) {
    const [secondsLeft, setSecondsLeft] = (0, _reactDefault.default).useState(duration / 1000);
    const { t } = (0, _reactI18Next.useTranslation)();
    (0, _reactDefault.default).useEffect(()=>{
        const interval = setInterval(()=>{
            if (secondsLeft >= 0) setSecondsLeft((seconds)=>seconds - 1);
        }, 1000);
        return ()=>{
            clearInterval(interval);
            if (onTimerFinished && secondsLeft <= 0) onTimerFinished();
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: (0, _classnamesDefault.default)(className),
        "data-testid": "seconds-left",
        children: [
            secondsLeft,
            "\xa0",
            t('common.seconds')
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","classnames":"f971Y","react":"2o0ib","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"koo6T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _layout = require("Core/components/Layout");
var _button = require("Core/components/Button");
const FinancingModal = ({ isOpen, onClose, url, children })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [showIframe, setShowIframe] = (0, _reactDefault.default).useState(true);
    const [iframeError, setIframeError] = (0, _reactDefault.default).useState(false);
    if (!isOpen) return null;
    const handleIframeError = ()=>{
        setIframeError(true);
        setShowIframe(false);
    };
    const navigateToFinancing = ()=>{
        // Store current URL to return to later
        sessionStorage.setItem('returnUrl', window.location.href);
        sessionStorage.setItem('isTeleaudiologyFlow', 'true');
        // Navigate to financing URL in same tab
        window.location.href = url;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Overlay), {
        className: "z-50",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "bg-white w-[95vw] h-[95vh] max-w-[95vw] max-h-[95vh] rounded-lg shadow-2xl flex flex-col relative",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex justify-between items-center p-4 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "text-xl font-semibold text-gray-800",
                            children: t('financing.modal.title', 'Financing Application')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: onClose,
                            className: "p-2 hover:bg-gray-100 rounded-full transition-colors duration-200 text-2xl font-bold text-gray-600 hover:text-gray-800",
                            "data-testid": "modal-close-x",
                            "aria-label": "Close modal",
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-1 p-4",
                    children: [
                        url ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: showIframe && !iframeError ? // onError is for load failures, not user interaction; iframe has no interactive role
                            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                                src: url,
                                className: "w-full h-full border-0 rounded",
                                title: "Financing Application",
                                onError: handleIframeError,
                                sandbox: "allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col items-center justify-center h-full text-center space-y-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-lg text-gray-700",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: t('financing.modal.navigateMessage', 'You will be redirected to the financing application. You can return to this page when finished.')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: navigateToFinancing,
                                        className: "bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200",
                                        children: t('financing.modal.continueToApplication', 'Continue to Financing Application')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-gray-500",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: t('financing.modal.navigationNote', 'This page will be replaced with the financing application. Your progress will be saved.')
                                        })
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex items-center justify-center h-full",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-center text-gray-500",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: t('financing.modal.noUrl', 'No financing URL available')
                                })
                            })
                        }),
                        children
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex justify-end p-4 border-t border-gray-200",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SecondaryOutlineButton), {
                        onClick: onClose,
                        "data-testid": "modal-close-button",
                        className: "px-6 py-2",
                        children: t('common.close', 'Close')
                    })
                })
            ]
        })
    });
};
exports.default = FinancingModal;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/components/Layout":"hweet","Core/components/Button":"6YNzH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8xEt1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateAchModal);
var _jsxRuntime = require("react/jsx-runtime");
var _alert = require("Core/components/Alert");
var _button = require("Core/components/Button");
var _layout = require("Core/components/Layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
function UpdateAchModal({ isModalOpen, onModalClose, onModalConfirm }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const handleConfirm = (e)=>{
        if (onModalConfirm) onModalConfirm(e);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
        isOpen: isModalOpen,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "font-bold text-center",
                children: t('synchrony.updateAch.title')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "p-6 text-center",
                "data-testid": "title-autopay-redirect",
                children: t('synchrony.updateAch.intro')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                    type: "shade",
                    "data-testid": "note-autopay-redirect",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                            children: [
                                t('synchrony.updateAch.noteLabel'),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                i18nKey: "synchrony.updateAch.note",
                                components: {
                                    addAutopay: /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                        className: "font-bold"
                                    })
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-end justify-end gap-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                        type: "button",
                        onClick: onModalClose,
                        "data-testid": "btn-skip-autopay",
                        children: t('synchrony.updateAch.skipButton')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                        type: "button",
                        onClick: handleConfirm,
                        "data-testid": "btn-add-autopay",
                        children: t('synchrony.updateAch.addButton')
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","Core/components/Alert":"fmmNR","Core/components/Button":"6YNzH","Core/components/Layout":"hweet","react":"2o0ib","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eth8c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PostExchangeBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("react-query");
var _hi2 = require("react-icons/hi2");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _numberFormat = require("Core/utils/numberFormat");
var _button = require("Core/components/Button");
var _exchangeStatus = require("Modules/financing/utils/exchangeStatus");
var _previousApplicationModal = require("Modules/financing/components/PreviousApplicationModal");
var _previousApplicationModalDefault = parcelHelpers.interopDefault(_previousApplicationModal);
const Pill = ({ label, value, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "inline-flex items-center gap-1.5 rounded-md border border-solid border-slate-200 bg-white px-2 py-1 text-xs leading-none",
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-bold uppercase tracking-wide text-slate-400",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-semibold tabular-nums text-slate-900",
                "data-testid": dataTestId,
                children: value
            })
        ]
    });
const isPresent = (value)=>value !== null && typeof value !== 'undefined' && value !== '';
// Past this many previous applications the banner stops listing them one by one.
const MAX_PILLS = 3;
const pillLabel = (previousApplication)=>{
    const ref = (0, _exchangeStatus.getApplicationRef)(previousApplication);
    return isPresent(ref) ? `#${ref}` : '';
};
const pillValue = (previousApplication)=>{
    const { amount_to_pay: amountToPay, financed } = previousApplication || {};
    const amount = amountToPay ?? financed;
    return isPresent(amount) ? (0, _numberFormat.formatCurrency)(Number(amount) || 0, {
        withDecimals: true
    }) : "\u2014";
};
function PostExchangeBanner({ application }) {
    const [isModalOpen, setIsModalOpen] = (0, _reactDefault.default).useState(false);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const cachedApplication = queryClient.getQueryData((0, _cacheKeysDefault.default).financingNextStep);
    // Screens reached by a direct route get no application prop (or an empty default).
    const source = application && Object.keys(application).length > 0 ? application : cachedApplication;
    const { isPostExchange, requestedAt, previousApplications } = (0, _exchangeStatus.getExchangeState)(source);
    if (!isPostExchange) return null;
    const isPlural = previousApplications.length > 1;
    const visible = previousApplications.slice(0, MAX_PILLS);
    const hiddenCount = previousApplications.length - visible.length;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mb-4 flex flex-wrap items-center gap-x-4 gap-y-3 rounded-xl border border-solid border-green-200 bg-gradient-to-r from-green-50 to-emerald-50 px-4 py-3.5",
        "data-testid": "post-exchange-banner",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                "aria-hidden": "true",
                className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600 ring-4 ring-white/70",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineArrowPathRoundedSquare), {
                    className: "h-5 w-5"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-x-2 gap-y-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "rounded-full bg-green-600 px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider text-white",
                                children: "Exchange request"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-sm leading-relaxed text-slate-600",
                                children: isPlural ? 'The previous applications stay funded and active until this one is funded.' : 'The initial application stays funded and active until this one is funded.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-2 flex flex-wrap items-center gap-2",
                        children: [
                            visible.map((previousApplication, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Pill, {
                                    label: pillLabel(previousApplication),
                                    value: pillValue(previousApplication),
                                    "data-testid": `post-exchange-previous-${index}`
                                }, (0, _exchangeStatus.getApplicationRef)(previousApplication) ?? index)),
                            hiddenCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pill, {
                                value: `+${hiddenCount} more`,
                                "data-testid": "post-exchange-previous-more"
                            }),
                            requestedAt && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pill, {
                                label: "Requested",
                                value: requestedAt,
                                "data-testid": "post-exchange-requested-at"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                type: "button",
                size: "small",
                className: "!border-green-600 !bg-white !font-semibold !text-green-700 hover:!border-green-700 hover:!bg-green-50",
                onClick: ()=>setIsModalOpen(true),
                "data-testid": "btn-view-previous-application",
                children: isPlural ? 'View Previous Applications' : 'View Initial Application'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previousApplicationModalDefault.default), {
                isOpen: isModalOpen,
                onClose: ()=>setIsModalOpen(false),
                previousApplications: previousApplications,
                requestedAt: requestedAt
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-query":"ksTpv","react-icons/hi2":"krCLn","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/numberFormat":"6T56F","Core/components/Button":"6YNzH","Modules/financing/utils/exchangeStatus":"foB3b","Modules/financing/components/PreviousApplicationModal":"2do1Z","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"krCLn":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HiXMark", ()=>HiXMark);
parcelHelpers.export(exports, "HiXCircle", ()=>HiXCircle);
parcelHelpers.export(exports, "HiWrench", ()=>HiWrench);
parcelHelpers.export(exports, "HiWrenchScrewdriver", ()=>HiWrenchScrewdriver);
parcelHelpers.export(exports, "HiWindow", ()=>HiWindow);
parcelHelpers.export(exports, "HiWifi", ()=>HiWifi);
parcelHelpers.export(exports, "HiWallet", ()=>HiWallet);
parcelHelpers.export(exports, "HiViewfinderCircle", ()=>HiViewfinderCircle);
parcelHelpers.export(exports, "HiViewColumns", ()=>HiViewColumns);
parcelHelpers.export(exports, "HiVideoCamera", ()=>HiVideoCamera);
parcelHelpers.export(exports, "HiVideoCameraSlash", ()=>HiVideoCameraSlash);
parcelHelpers.export(exports, "HiVariable", ()=>HiVariable);
parcelHelpers.export(exports, "HiUsers", ()=>HiUsers);
parcelHelpers.export(exports, "HiUser", ()=>HiUser);
parcelHelpers.export(exports, "HiUserPlus", ()=>HiUserPlus);
parcelHelpers.export(exports, "HiUserMinus", ()=>HiUserMinus);
parcelHelpers.export(exports, "HiUserGroup", ()=>HiUserGroup);
parcelHelpers.export(exports, "HiUserCircle", ()=>HiUserCircle);
parcelHelpers.export(exports, "HiUnderline", ()=>HiUnderline);
parcelHelpers.export(exports, "HiTv", ()=>HiTv);
parcelHelpers.export(exports, "HiTruck", ()=>HiTruck);
parcelHelpers.export(exports, "HiTrophy", ()=>HiTrophy);
parcelHelpers.export(exports, "HiTrash", ()=>HiTrash);
parcelHelpers.export(exports, "HiTicket", ()=>HiTicket);
parcelHelpers.export(exports, "HiTag", ()=>HiTag);
parcelHelpers.export(exports, "HiTableCells", ()=>HiTableCells);
parcelHelpers.export(exports, "HiSwatch", ()=>HiSwatch);
parcelHelpers.export(exports, "HiSun", ()=>HiSun);
parcelHelpers.export(exports, "HiStrikethrough", ()=>HiStrikethrough);
parcelHelpers.export(exports, "HiStop", ()=>HiStop);
parcelHelpers.export(exports, "HiStopCircle", ()=>HiStopCircle);
parcelHelpers.export(exports, "HiStar", ()=>HiStar);
parcelHelpers.export(exports, "HiSquaresPlus", ()=>HiSquaresPlus);
parcelHelpers.export(exports, "HiSquares2X2", ()=>HiSquares2X2);
parcelHelpers.export(exports, "HiSquare3Stack3D", ()=>HiSquare3Stack3D);
parcelHelpers.export(exports, "HiSquare2Stack", ()=>HiSquare2Stack);
parcelHelpers.export(exports, "HiSpeakerXMark", ()=>HiSpeakerXMark);
parcelHelpers.export(exports, "HiSpeakerWave", ()=>HiSpeakerWave);
parcelHelpers.export(exports, "HiSparkles", ()=>HiSparkles);
parcelHelpers.export(exports, "HiSlash", ()=>HiSlash);
parcelHelpers.export(exports, "HiSignal", ()=>HiSignal);
parcelHelpers.export(exports, "HiSignalSlash", ()=>HiSignalSlash);
parcelHelpers.export(exports, "HiShoppingCart", ()=>HiShoppingCart);
parcelHelpers.export(exports, "HiShoppingBag", ()=>HiShoppingBag);
parcelHelpers.export(exports, "HiShieldExclamation", ()=>HiShieldExclamation);
parcelHelpers.export(exports, "HiShieldCheck", ()=>HiShieldCheck);
parcelHelpers.export(exports, "HiShare", ()=>HiShare);
parcelHelpers.export(exports, "HiServer", ()=>HiServer);
parcelHelpers.export(exports, "HiServerStack", ()=>HiServerStack);
parcelHelpers.export(exports, "HiScissors", ()=>HiScissors);
parcelHelpers.export(exports, "HiScale", ()=>HiScale);
parcelHelpers.export(exports, "HiRss", ()=>HiRss);
parcelHelpers.export(exports, "HiRocketLaunch", ()=>HiRocketLaunch);
parcelHelpers.export(exports, "HiRectangleStack", ()=>HiRectangleStack);
parcelHelpers.export(exports, "HiRectangleGroup", ()=>HiRectangleGroup);
parcelHelpers.export(exports, "HiReceiptRefund", ()=>HiReceiptRefund);
parcelHelpers.export(exports, "HiReceiptPercent", ()=>HiReceiptPercent);
parcelHelpers.export(exports, "HiRadio", ()=>HiRadio);
parcelHelpers.export(exports, "HiQueueList", ()=>HiQueueList);
parcelHelpers.export(exports, "HiQuestionMarkCircle", ()=>HiQuestionMarkCircle);
parcelHelpers.export(exports, "HiQrCode", ()=>HiQrCode);
parcelHelpers.export(exports, "HiPuzzlePiece", ()=>HiPuzzlePiece);
parcelHelpers.export(exports, "HiPrinter", ()=>HiPrinter);
parcelHelpers.export(exports, "HiPresentationChartLine", ()=>HiPresentationChartLine);
parcelHelpers.export(exports, "HiPresentationChartBar", ()=>HiPresentationChartBar);
parcelHelpers.export(exports, "HiPower", ()=>HiPower);
parcelHelpers.export(exports, "HiPlus", ()=>HiPlus);
parcelHelpers.export(exports, "HiPlusSmall", ()=>HiPlusSmall);
parcelHelpers.export(exports, "HiPlusCircle", ()=>HiPlusCircle);
parcelHelpers.export(exports, "HiPlay", ()=>HiPlay);
parcelHelpers.export(exports, "HiPlayPause", ()=>HiPlayPause);
parcelHelpers.export(exports, "HiPlayCircle", ()=>HiPlayCircle);
parcelHelpers.export(exports, "HiPhoto", ()=>HiPhoto);
parcelHelpers.export(exports, "HiPhone", ()=>HiPhone);
parcelHelpers.export(exports, "HiPhoneXMark", ()=>HiPhoneXMark);
parcelHelpers.export(exports, "HiPhoneArrowUpRight", ()=>HiPhoneArrowUpRight);
parcelHelpers.export(exports, "HiPhoneArrowDownLeft", ()=>HiPhoneArrowDownLeft);
parcelHelpers.export(exports, "HiPercentBadge", ()=>HiPercentBadge);
parcelHelpers.export(exports, "HiPencil", ()=>HiPencil);
parcelHelpers.export(exports, "HiPencilSquare", ()=>HiPencilSquare);
parcelHelpers.export(exports, "HiPause", ()=>HiPause);
parcelHelpers.export(exports, "HiPauseCircle", ()=>HiPauseCircle);
parcelHelpers.export(exports, "HiPaperClip", ()=>HiPaperClip);
parcelHelpers.export(exports, "HiPaperAirplane", ()=>HiPaperAirplane);
parcelHelpers.export(exports, "HiPaintBrush", ()=>HiPaintBrush);
parcelHelpers.export(exports, "HiNumberedList", ()=>HiNumberedList);
parcelHelpers.export(exports, "HiNoSymbol", ()=>HiNoSymbol);
parcelHelpers.export(exports, "HiNewspaper", ()=>HiNewspaper);
parcelHelpers.export(exports, "HiMusicalNote", ()=>HiMusicalNote);
parcelHelpers.export(exports, "HiMoon", ()=>HiMoon);
parcelHelpers.export(exports, "HiMinus", ()=>HiMinus);
parcelHelpers.export(exports, "HiMinusSmall", ()=>HiMinusSmall);
parcelHelpers.export(exports, "HiMinusCircle", ()=>HiMinusCircle);
parcelHelpers.export(exports, "HiMicrophone", ()=>HiMicrophone);
parcelHelpers.export(exports, "HiMegaphone", ()=>HiMegaphone);
parcelHelpers.export(exports, "HiMap", ()=>HiMap);
parcelHelpers.export(exports, "HiMapPin", ()=>HiMapPin);
parcelHelpers.export(exports, "HiMagnifyingGlass", ()=>HiMagnifyingGlass);
parcelHelpers.export(exports, "HiMagnifyingGlassPlus", ()=>HiMagnifyingGlassPlus);
parcelHelpers.export(exports, "HiMagnifyingGlassMinus", ()=>HiMagnifyingGlassMinus);
parcelHelpers.export(exports, "HiMagnifyingGlassCircle", ()=>HiMagnifyingGlassCircle);
parcelHelpers.export(exports, "HiLockOpen", ()=>HiLockOpen);
parcelHelpers.export(exports, "HiLockClosed", ()=>HiLockClosed);
parcelHelpers.export(exports, "HiListBullet", ()=>HiListBullet);
parcelHelpers.export(exports, "HiLink", ()=>HiLink);
parcelHelpers.export(exports, "HiLinkSlash", ()=>HiLinkSlash);
parcelHelpers.export(exports, "HiLightBulb", ()=>HiLightBulb);
parcelHelpers.export(exports, "HiLifebuoy", ()=>HiLifebuoy);
parcelHelpers.export(exports, "HiLanguage", ()=>HiLanguage);
parcelHelpers.export(exports, "HiKey", ()=>HiKey);
parcelHelpers.export(exports, "HiItalic", ()=>HiItalic);
parcelHelpers.export(exports, "HiInformationCircle", ()=>HiInformationCircle);
parcelHelpers.export(exports, "HiInbox", ()=>HiInbox);
parcelHelpers.export(exports, "HiInboxStack", ()=>HiInboxStack);
parcelHelpers.export(exports, "HiInboxArrowDown", ()=>HiInboxArrowDown);
parcelHelpers.export(exports, "HiIdentification", ()=>HiIdentification);
parcelHelpers.export(exports, "HiHome", ()=>HiHome);
parcelHelpers.export(exports, "HiHomeModern", ()=>HiHomeModern);
parcelHelpers.export(exports, "HiHeart", ()=>HiHeart);
parcelHelpers.export(exports, "HiHashtag", ()=>HiHashtag);
parcelHelpers.export(exports, "HiHandThumbUp", ()=>HiHandThumbUp);
parcelHelpers.export(exports, "HiHandThumbDown", ()=>HiHandThumbDown);
parcelHelpers.export(exports, "HiHandRaised", ()=>HiHandRaised);
parcelHelpers.export(exports, "HiH3", ()=>HiH3);
parcelHelpers.export(exports, "HiH2", ()=>HiH2);
parcelHelpers.export(exports, "HiH1", ()=>HiH1);
parcelHelpers.export(exports, "HiGlobeEuropeAfrica", ()=>HiGlobeEuropeAfrica);
parcelHelpers.export(exports, "HiGlobeAsiaAustralia", ()=>HiGlobeAsiaAustralia);
parcelHelpers.export(exports, "HiGlobeAmericas", ()=>HiGlobeAmericas);
parcelHelpers.export(exports, "HiGlobeAlt", ()=>HiGlobeAlt);
parcelHelpers.export(exports, "HiGift", ()=>HiGift);
parcelHelpers.export(exports, "HiGiftTop", ()=>HiGiftTop);
parcelHelpers.export(exports, "HiGif", ()=>HiGif);
parcelHelpers.export(exports, "HiFunnel", ()=>HiFunnel);
parcelHelpers.export(exports, "HiForward", ()=>HiForward);
parcelHelpers.export(exports, "HiFolder", ()=>HiFolder);
parcelHelpers.export(exports, "HiFolderPlus", ()=>HiFolderPlus);
parcelHelpers.export(exports, "HiFolderOpen", ()=>HiFolderOpen);
parcelHelpers.export(exports, "HiFolderMinus", ()=>HiFolderMinus);
parcelHelpers.export(exports, "HiFolderArrowDown", ()=>HiFolderArrowDown);
parcelHelpers.export(exports, "HiFlag", ()=>HiFlag);
parcelHelpers.export(exports, "HiFire", ()=>HiFire);
parcelHelpers.export(exports, "HiFingerPrint", ()=>HiFingerPrint);
parcelHelpers.export(exports, "HiFilm", ()=>HiFilm);
parcelHelpers.export(exports, "HiFaceSmile", ()=>HiFaceSmile);
parcelHelpers.export(exports, "HiFaceFrown", ()=>HiFaceFrown);
parcelHelpers.export(exports, "HiEye", ()=>HiEye);
parcelHelpers.export(exports, "HiEyeSlash", ()=>HiEyeSlash);
parcelHelpers.export(exports, "HiEyeDropper", ()=>HiEyeDropper);
parcelHelpers.export(exports, "HiExclamationTriangle", ()=>HiExclamationTriangle);
parcelHelpers.export(exports, "HiExclamationCircle", ()=>HiExclamationCircle);
parcelHelpers.export(exports, "HiEquals", ()=>HiEquals);
parcelHelpers.export(exports, "HiEnvelope", ()=>HiEnvelope);
parcelHelpers.export(exports, "HiEnvelopeOpen", ()=>HiEnvelopeOpen);
parcelHelpers.export(exports, "HiEllipsisVertical", ()=>HiEllipsisVertical);
parcelHelpers.export(exports, "HiEllipsisHorizontal", ()=>HiEllipsisHorizontal);
parcelHelpers.export(exports, "HiEllipsisHorizontalCircle", ()=>HiEllipsisHorizontalCircle);
parcelHelpers.export(exports, "HiDocument", ()=>HiDocument);
parcelHelpers.export(exports, "HiDocumentText", ()=>HiDocumentText);
parcelHelpers.export(exports, "HiDocumentPlus", ()=>HiDocumentPlus);
parcelHelpers.export(exports, "HiDocumentMinus", ()=>HiDocumentMinus);
parcelHelpers.export(exports, "HiDocumentMagnifyingGlass", ()=>HiDocumentMagnifyingGlass);
parcelHelpers.export(exports, "HiDocumentDuplicate", ()=>HiDocumentDuplicate);
parcelHelpers.export(exports, "HiDocumentCurrencyYen", ()=>HiDocumentCurrencyYen);
parcelHelpers.export(exports, "HiDocumentCurrencyRupee", ()=>HiDocumentCurrencyRupee);
parcelHelpers.export(exports, "HiDocumentCurrencyPound", ()=>HiDocumentCurrencyPound);
parcelHelpers.export(exports, "HiDocumentCurrencyEuro", ()=>HiDocumentCurrencyEuro);
parcelHelpers.export(exports, "HiDocumentCurrencyDollar", ()=>HiDocumentCurrencyDollar);
parcelHelpers.export(exports, "HiDocumentCurrencyBangladeshi", ()=>HiDocumentCurrencyBangladeshi);
parcelHelpers.export(exports, "HiDocumentCheck", ()=>HiDocumentCheck);
parcelHelpers.export(exports, "HiDocumentChartBar", ()=>HiDocumentChartBar);
parcelHelpers.export(exports, "HiDocumentArrowUp", ()=>HiDocumentArrowUp);
parcelHelpers.export(exports, "HiDocumentArrowDown", ()=>HiDocumentArrowDown);
parcelHelpers.export(exports, "HiDivide", ()=>HiDivide);
parcelHelpers.export(exports, "HiDeviceTablet", ()=>HiDeviceTablet);
parcelHelpers.export(exports, "HiDevicePhoneMobile", ()=>HiDevicePhoneMobile);
parcelHelpers.export(exports, "HiCursorArrowRipple", ()=>HiCursorArrowRipple);
parcelHelpers.export(exports, "HiCursorArrowRays", ()=>HiCursorArrowRays);
parcelHelpers.export(exports, "HiCurrencyYen", ()=>HiCurrencyYen);
parcelHelpers.export(exports, "HiCurrencyRupee", ()=>HiCurrencyRupee);
parcelHelpers.export(exports, "HiCurrencyPound", ()=>HiCurrencyPound);
parcelHelpers.export(exports, "HiCurrencyEuro", ()=>HiCurrencyEuro);
parcelHelpers.export(exports, "HiCurrencyDollar", ()=>HiCurrencyDollar);
parcelHelpers.export(exports, "HiCurrencyBangladeshi", ()=>HiCurrencyBangladeshi);
parcelHelpers.export(exports, "HiCube", ()=>HiCube);
parcelHelpers.export(exports, "HiCubeTransparent", ()=>HiCubeTransparent);
parcelHelpers.export(exports, "HiCreditCard", ()=>HiCreditCard);
parcelHelpers.export(exports, "HiCpuChip", ()=>HiCpuChip);
parcelHelpers.export(exports, "HiComputerDesktop", ()=>HiComputerDesktop);
parcelHelpers.export(exports, "HiCommandLine", ()=>HiCommandLine);
parcelHelpers.export(exports, "HiCog", ()=>HiCog);
parcelHelpers.export(exports, "HiCog8Tooth", ()=>HiCog8Tooth);
parcelHelpers.export(exports, "HiCog6Tooth", ()=>HiCog6Tooth);
parcelHelpers.export(exports, "HiCodeBracket", ()=>HiCodeBracket);
parcelHelpers.export(exports, "HiCodeBracketSquare", ()=>HiCodeBracketSquare);
parcelHelpers.export(exports, "HiCloud", ()=>HiCloud);
parcelHelpers.export(exports, "HiCloudArrowUp", ()=>HiCloudArrowUp);
parcelHelpers.export(exports, "HiCloudArrowDown", ()=>HiCloudArrowDown);
parcelHelpers.export(exports, "HiClock", ()=>HiClock);
parcelHelpers.export(exports, "HiClipboard", ()=>HiClipboard);
parcelHelpers.export(exports, "HiClipboardDocument", ()=>HiClipboardDocument);
parcelHelpers.export(exports, "HiClipboardDocumentList", ()=>HiClipboardDocumentList);
parcelHelpers.export(exports, "HiClipboardDocumentCheck", ()=>HiClipboardDocumentCheck);
parcelHelpers.export(exports, "HiCircleStack", ()=>HiCircleStack);
parcelHelpers.export(exports, "HiChevronUp", ()=>HiChevronUp);
parcelHelpers.export(exports, "HiChevronUpDown", ()=>HiChevronUpDown);
parcelHelpers.export(exports, "HiChevronRight", ()=>HiChevronRight);
parcelHelpers.export(exports, "HiChevronLeft", ()=>HiChevronLeft);
parcelHelpers.export(exports, "HiChevronDown", ()=>HiChevronDown);
parcelHelpers.export(exports, "HiChevronDoubleUp", ()=>HiChevronDoubleUp);
parcelHelpers.export(exports, "HiChevronDoubleRight", ()=>HiChevronDoubleRight);
parcelHelpers.export(exports, "HiChevronDoubleLeft", ()=>HiChevronDoubleLeft);
parcelHelpers.export(exports, "HiChevronDoubleDown", ()=>HiChevronDoubleDown);
parcelHelpers.export(exports, "HiCheck", ()=>HiCheck);
parcelHelpers.export(exports, "HiCheckCircle", ()=>HiCheckCircle);
parcelHelpers.export(exports, "HiCheckBadge", ()=>HiCheckBadge);
parcelHelpers.export(exports, "HiChatBubbleOvalLeft", ()=>HiChatBubbleOvalLeft);
parcelHelpers.export(exports, "HiChatBubbleOvalLeftEllipsis", ()=>HiChatBubbleOvalLeftEllipsis);
parcelHelpers.export(exports, "HiChatBubbleLeft", ()=>HiChatBubbleLeft);
parcelHelpers.export(exports, "HiChatBubbleLeftRight", ()=>HiChatBubbleLeftRight);
parcelHelpers.export(exports, "HiChatBubbleLeftEllipsis", ()=>HiChatBubbleLeftEllipsis);
parcelHelpers.export(exports, "HiChatBubbleBottomCenter", ()=>HiChatBubbleBottomCenter);
parcelHelpers.export(exports, "HiChatBubbleBottomCenterText", ()=>HiChatBubbleBottomCenterText);
parcelHelpers.export(exports, "HiChartPie", ()=>HiChartPie);
parcelHelpers.export(exports, "HiChartBar", ()=>HiChartBar);
parcelHelpers.export(exports, "HiChartBarSquare", ()=>HiChartBarSquare);
parcelHelpers.export(exports, "HiCamera", ()=>HiCamera);
parcelHelpers.export(exports, "HiCalendar", ()=>HiCalendar);
parcelHelpers.export(exports, "HiCalendarDays", ()=>HiCalendarDays);
parcelHelpers.export(exports, "HiCalendarDateRange", ()=>HiCalendarDateRange);
parcelHelpers.export(exports, "HiCalculator", ()=>HiCalculator);
parcelHelpers.export(exports, "HiCake", ()=>HiCake);
parcelHelpers.export(exports, "HiBuildingStorefront", ()=>HiBuildingStorefront);
parcelHelpers.export(exports, "HiBuildingOffice", ()=>HiBuildingOffice);
parcelHelpers.export(exports, "HiBuildingOffice2", ()=>HiBuildingOffice2);
parcelHelpers.export(exports, "HiBuildingLibrary", ()=>HiBuildingLibrary);
parcelHelpers.export(exports, "HiBugAnt", ()=>HiBugAnt);
parcelHelpers.export(exports, "HiBriefcase", ()=>HiBriefcase);
parcelHelpers.export(exports, "HiBookmark", ()=>HiBookmark);
parcelHelpers.export(exports, "HiBookmarkSquare", ()=>HiBookmarkSquare);
parcelHelpers.export(exports, "HiBookmarkSlash", ()=>HiBookmarkSlash);
parcelHelpers.export(exports, "HiBookOpen", ()=>HiBookOpen);
parcelHelpers.export(exports, "HiBolt", ()=>HiBolt);
parcelHelpers.export(exports, "HiBoltSlash", ()=>HiBoltSlash);
parcelHelpers.export(exports, "HiBold", ()=>HiBold);
parcelHelpers.export(exports, "HiBell", ()=>HiBell);
parcelHelpers.export(exports, "HiBellSnooze", ()=>HiBellSnooze);
parcelHelpers.export(exports, "HiBellSlash", ()=>HiBellSlash);
parcelHelpers.export(exports, "HiBellAlert", ()=>HiBellAlert);
parcelHelpers.export(exports, "HiBeaker", ()=>HiBeaker);
parcelHelpers.export(exports, "HiBattery50", ()=>HiBattery50);
parcelHelpers.export(exports, "HiBattery100", ()=>HiBattery100);
parcelHelpers.export(exports, "HiBattery0", ()=>HiBattery0);
parcelHelpers.export(exports, "HiBarsArrowUp", ()=>HiBarsArrowUp);
parcelHelpers.export(exports, "HiBarsArrowDown", ()=>HiBarsArrowDown);
parcelHelpers.export(exports, "HiBars4", ()=>HiBars4);
parcelHelpers.export(exports, "HiBars3", ()=>HiBars3);
parcelHelpers.export(exports, "HiBars3CenterLeft", ()=>HiBars3CenterLeft);
parcelHelpers.export(exports, "HiBars3BottomRight", ()=>HiBars3BottomRight);
parcelHelpers.export(exports, "HiBars3BottomLeft", ()=>HiBars3BottomLeft);
parcelHelpers.export(exports, "HiBars2", ()=>HiBars2);
parcelHelpers.export(exports, "HiBanknotes", ()=>HiBanknotes);
parcelHelpers.export(exports, "HiBackward", ()=>HiBackward);
parcelHelpers.export(exports, "HiBackspace", ()=>HiBackspace);
parcelHelpers.export(exports, "HiAtSymbol", ()=>HiAtSymbol);
parcelHelpers.export(exports, "HiArrowsUpDown", ()=>HiArrowsUpDown);
parcelHelpers.export(exports, "HiArrowsRightLeft", ()=>HiArrowsRightLeft);
parcelHelpers.export(exports, "HiArrowsPointingOut", ()=>HiArrowsPointingOut);
parcelHelpers.export(exports, "HiArrowsPointingIn", ()=>HiArrowsPointingIn);
parcelHelpers.export(exports, "HiArrowUturnUp", ()=>HiArrowUturnUp);
parcelHelpers.export(exports, "HiArrowUturnRight", ()=>HiArrowUturnRight);
parcelHelpers.export(exports, "HiArrowUturnLeft", ()=>HiArrowUturnLeft);
parcelHelpers.export(exports, "HiArrowUturnDown", ()=>HiArrowUturnDown);
parcelHelpers.export(exports, "HiArrowUp", ()=>HiArrowUp);
parcelHelpers.export(exports, "HiArrowUpTray", ()=>HiArrowUpTray);
parcelHelpers.export(exports, "HiArrowUpRight", ()=>HiArrowUpRight);
parcelHelpers.export(exports, "HiArrowUpOnSquare", ()=>HiArrowUpOnSquare);
parcelHelpers.export(exports, "HiArrowUpOnSquareStack", ()=>HiArrowUpOnSquareStack);
parcelHelpers.export(exports, "HiArrowUpLeft", ()=>HiArrowUpLeft);
parcelHelpers.export(exports, "HiArrowUpCircle", ()=>HiArrowUpCircle);
parcelHelpers.export(exports, "HiArrowTurnUpRight", ()=>HiArrowTurnUpRight);
parcelHelpers.export(exports, "HiArrowTurnUpLeft", ()=>HiArrowTurnUpLeft);
parcelHelpers.export(exports, "HiArrowTurnRightUp", ()=>HiArrowTurnRightUp);
parcelHelpers.export(exports, "HiArrowTurnRightDown", ()=>HiArrowTurnRightDown);
parcelHelpers.export(exports, "HiArrowTurnLeftUp", ()=>HiArrowTurnLeftUp);
parcelHelpers.export(exports, "HiArrowTurnLeftDown", ()=>HiArrowTurnLeftDown);
parcelHelpers.export(exports, "HiArrowTurnDownRight", ()=>HiArrowTurnDownRight);
parcelHelpers.export(exports, "HiArrowTurnDownLeft", ()=>HiArrowTurnDownLeft);
parcelHelpers.export(exports, "HiArrowTrendingUp", ()=>HiArrowTrendingUp);
parcelHelpers.export(exports, "HiArrowTrendingDown", ()=>HiArrowTrendingDown);
parcelHelpers.export(exports, "HiArrowTopRightOnSquare", ()=>HiArrowTopRightOnSquare);
parcelHelpers.export(exports, "HiArrowSmallUp", ()=>HiArrowSmallUp);
parcelHelpers.export(exports, "HiArrowSmallRight", ()=>HiArrowSmallRight);
parcelHelpers.export(exports, "HiArrowSmallLeft", ()=>HiArrowSmallLeft);
parcelHelpers.export(exports, "HiArrowSmallDown", ()=>HiArrowSmallDown);
parcelHelpers.export(exports, "HiArrowRight", ()=>HiArrowRight);
parcelHelpers.export(exports, "HiArrowRightStartOnRectangle", ()=>HiArrowRightStartOnRectangle);
parcelHelpers.export(exports, "HiArrowRightOnRectangle", ()=>HiArrowRightOnRectangle);
parcelHelpers.export(exports, "HiArrowRightEndOnRectangle", ()=>HiArrowRightEndOnRectangle);
parcelHelpers.export(exports, "HiArrowRightCircle", ()=>HiArrowRightCircle);
parcelHelpers.export(exports, "HiArrowPath", ()=>HiArrowPath);
parcelHelpers.export(exports, "HiArrowPathRoundedSquare", ()=>HiArrowPathRoundedSquare);
parcelHelpers.export(exports, "HiArrowLongUp", ()=>HiArrowLongUp);
parcelHelpers.export(exports, "HiArrowLongRight", ()=>HiArrowLongRight);
parcelHelpers.export(exports, "HiArrowLongLeft", ()=>HiArrowLongLeft);
parcelHelpers.export(exports, "HiArrowLongDown", ()=>HiArrowLongDown);
parcelHelpers.export(exports, "HiArrowLeft", ()=>HiArrowLeft);
parcelHelpers.export(exports, "HiArrowLeftStartOnRectangle", ()=>HiArrowLeftStartOnRectangle);
parcelHelpers.export(exports, "HiArrowLeftOnRectangle", ()=>HiArrowLeftOnRectangle);
parcelHelpers.export(exports, "HiArrowLeftEndOnRectangle", ()=>HiArrowLeftEndOnRectangle);
parcelHelpers.export(exports, "HiArrowLeftCircle", ()=>HiArrowLeftCircle);
parcelHelpers.export(exports, "HiArrowDown", ()=>HiArrowDown);
parcelHelpers.export(exports, "HiArrowDownTray", ()=>HiArrowDownTray);
parcelHelpers.export(exports, "HiArrowDownRight", ()=>HiArrowDownRight);
parcelHelpers.export(exports, "HiArrowDownOnSquare", ()=>HiArrowDownOnSquare);
parcelHelpers.export(exports, "HiArrowDownOnSquareStack", ()=>HiArrowDownOnSquareStack);
parcelHelpers.export(exports, "HiArrowDownLeft", ()=>HiArrowDownLeft);
parcelHelpers.export(exports, "HiArrowDownCircle", ()=>HiArrowDownCircle);
parcelHelpers.export(exports, "HiArchiveBox", ()=>HiArchiveBox);
parcelHelpers.export(exports, "HiArchiveBoxXMark", ()=>HiArchiveBoxXMark);
parcelHelpers.export(exports, "HiArchiveBoxArrowDown", ()=>HiArchiveBoxArrowDown);
parcelHelpers.export(exports, "HiAdjustmentsVertical", ()=>HiAdjustmentsVertical);
parcelHelpers.export(exports, "HiAdjustmentsHorizontal", ()=>HiAdjustmentsHorizontal);
parcelHelpers.export(exports, "HiAcademicCap", ()=>HiAcademicCap);
parcelHelpers.export(exports, "HiOutlineXMark", ()=>HiOutlineXMark);
parcelHelpers.export(exports, "HiOutlineXCircle", ()=>HiOutlineXCircle);
parcelHelpers.export(exports, "HiOutlineWrench", ()=>HiOutlineWrench);
parcelHelpers.export(exports, "HiOutlineWrenchScrewdriver", ()=>HiOutlineWrenchScrewdriver);
parcelHelpers.export(exports, "HiOutlineWindow", ()=>HiOutlineWindow);
parcelHelpers.export(exports, "HiOutlineWifi", ()=>HiOutlineWifi);
parcelHelpers.export(exports, "HiOutlineWallet", ()=>HiOutlineWallet);
parcelHelpers.export(exports, "HiOutlineViewfinderCircle", ()=>HiOutlineViewfinderCircle);
parcelHelpers.export(exports, "HiOutlineViewColumns", ()=>HiOutlineViewColumns);
parcelHelpers.export(exports, "HiOutlineVideoCamera", ()=>HiOutlineVideoCamera);
parcelHelpers.export(exports, "HiOutlineVideoCameraSlash", ()=>HiOutlineVideoCameraSlash);
parcelHelpers.export(exports, "HiOutlineVariable", ()=>HiOutlineVariable);
parcelHelpers.export(exports, "HiOutlineUsers", ()=>HiOutlineUsers);
parcelHelpers.export(exports, "HiOutlineUser", ()=>HiOutlineUser);
parcelHelpers.export(exports, "HiOutlineUserPlus", ()=>HiOutlineUserPlus);
parcelHelpers.export(exports, "HiOutlineUserMinus", ()=>HiOutlineUserMinus);
parcelHelpers.export(exports, "HiOutlineUserGroup", ()=>HiOutlineUserGroup);
parcelHelpers.export(exports, "HiOutlineUserCircle", ()=>HiOutlineUserCircle);
parcelHelpers.export(exports, "HiOutlineUnderline", ()=>HiOutlineUnderline);
parcelHelpers.export(exports, "HiOutlineTv", ()=>HiOutlineTv);
parcelHelpers.export(exports, "HiOutlineTruck", ()=>HiOutlineTruck);
parcelHelpers.export(exports, "HiOutlineTrophy", ()=>HiOutlineTrophy);
parcelHelpers.export(exports, "HiOutlineTrash", ()=>HiOutlineTrash);
parcelHelpers.export(exports, "HiOutlineTicket", ()=>HiOutlineTicket);
parcelHelpers.export(exports, "HiOutlineTag", ()=>HiOutlineTag);
parcelHelpers.export(exports, "HiOutlineTableCells", ()=>HiOutlineTableCells);
parcelHelpers.export(exports, "HiOutlineSwatch", ()=>HiOutlineSwatch);
parcelHelpers.export(exports, "HiOutlineSun", ()=>HiOutlineSun);
parcelHelpers.export(exports, "HiOutlineStrikethrough", ()=>HiOutlineStrikethrough);
parcelHelpers.export(exports, "HiOutlineStop", ()=>HiOutlineStop);
parcelHelpers.export(exports, "HiOutlineStopCircle", ()=>HiOutlineStopCircle);
parcelHelpers.export(exports, "HiOutlineStar", ()=>HiOutlineStar);
parcelHelpers.export(exports, "HiOutlineSquaresPlus", ()=>HiOutlineSquaresPlus);
parcelHelpers.export(exports, "HiOutlineSquares2X2", ()=>HiOutlineSquares2X2);
parcelHelpers.export(exports, "HiOutlineSquare3Stack3D", ()=>HiOutlineSquare3Stack3D);
parcelHelpers.export(exports, "HiOutlineSquare2Stack", ()=>HiOutlineSquare2Stack);
parcelHelpers.export(exports, "HiOutlineSpeakerXMark", ()=>HiOutlineSpeakerXMark);
parcelHelpers.export(exports, "HiOutlineSpeakerWave", ()=>HiOutlineSpeakerWave);
parcelHelpers.export(exports, "HiOutlineSparkles", ()=>HiOutlineSparkles);
parcelHelpers.export(exports, "HiOutlineSlash", ()=>HiOutlineSlash);
parcelHelpers.export(exports, "HiOutlineSignal", ()=>HiOutlineSignal);
parcelHelpers.export(exports, "HiOutlineSignalSlash", ()=>HiOutlineSignalSlash);
parcelHelpers.export(exports, "HiOutlineShoppingCart", ()=>HiOutlineShoppingCart);
parcelHelpers.export(exports, "HiOutlineShoppingBag", ()=>HiOutlineShoppingBag);
parcelHelpers.export(exports, "HiOutlineShieldExclamation", ()=>HiOutlineShieldExclamation);
parcelHelpers.export(exports, "HiOutlineShieldCheck", ()=>HiOutlineShieldCheck);
parcelHelpers.export(exports, "HiOutlineShare", ()=>HiOutlineShare);
parcelHelpers.export(exports, "HiOutlineServer", ()=>HiOutlineServer);
parcelHelpers.export(exports, "HiOutlineServerStack", ()=>HiOutlineServerStack);
parcelHelpers.export(exports, "HiOutlineScissors", ()=>HiOutlineScissors);
parcelHelpers.export(exports, "HiOutlineScale", ()=>HiOutlineScale);
parcelHelpers.export(exports, "HiOutlineRss", ()=>HiOutlineRss);
parcelHelpers.export(exports, "HiOutlineRocketLaunch", ()=>HiOutlineRocketLaunch);
parcelHelpers.export(exports, "HiOutlineRectangleStack", ()=>HiOutlineRectangleStack);
parcelHelpers.export(exports, "HiOutlineRectangleGroup", ()=>HiOutlineRectangleGroup);
parcelHelpers.export(exports, "HiOutlineReceiptRefund", ()=>HiOutlineReceiptRefund);
parcelHelpers.export(exports, "HiOutlineReceiptPercent", ()=>HiOutlineReceiptPercent);
parcelHelpers.export(exports, "HiOutlineRadio", ()=>HiOutlineRadio);
parcelHelpers.export(exports, "HiOutlineQueueList", ()=>HiOutlineQueueList);
parcelHelpers.export(exports, "HiOutlineQuestionMarkCircle", ()=>HiOutlineQuestionMarkCircle);
parcelHelpers.export(exports, "HiOutlineQrCode", ()=>HiOutlineQrCode);
parcelHelpers.export(exports, "HiOutlinePuzzlePiece", ()=>HiOutlinePuzzlePiece);
parcelHelpers.export(exports, "HiOutlinePrinter", ()=>HiOutlinePrinter);
parcelHelpers.export(exports, "HiOutlinePresentationChartLine", ()=>HiOutlinePresentationChartLine);
parcelHelpers.export(exports, "HiOutlinePresentationChartBar", ()=>HiOutlinePresentationChartBar);
parcelHelpers.export(exports, "HiOutlinePower", ()=>HiOutlinePower);
parcelHelpers.export(exports, "HiOutlinePlus", ()=>HiOutlinePlus);
parcelHelpers.export(exports, "HiOutlinePlusSmall", ()=>HiOutlinePlusSmall);
parcelHelpers.export(exports, "HiOutlinePlusCircle", ()=>HiOutlinePlusCircle);
parcelHelpers.export(exports, "HiOutlinePlay", ()=>HiOutlinePlay);
parcelHelpers.export(exports, "HiOutlinePlayPause", ()=>HiOutlinePlayPause);
parcelHelpers.export(exports, "HiOutlinePlayCircle", ()=>HiOutlinePlayCircle);
parcelHelpers.export(exports, "HiOutlinePhoto", ()=>HiOutlinePhoto);
parcelHelpers.export(exports, "HiOutlinePhone", ()=>HiOutlinePhone);
parcelHelpers.export(exports, "HiOutlinePhoneXMark", ()=>HiOutlinePhoneXMark);
parcelHelpers.export(exports, "HiOutlinePhoneArrowUpRight", ()=>HiOutlinePhoneArrowUpRight);
parcelHelpers.export(exports, "HiOutlinePhoneArrowDownLeft", ()=>HiOutlinePhoneArrowDownLeft);
parcelHelpers.export(exports, "HiOutlinePercentBadge", ()=>HiOutlinePercentBadge);
parcelHelpers.export(exports, "HiOutlinePencil", ()=>HiOutlinePencil);
parcelHelpers.export(exports, "HiOutlinePencilSquare", ()=>HiOutlinePencilSquare);
parcelHelpers.export(exports, "HiOutlinePause", ()=>HiOutlinePause);
parcelHelpers.export(exports, "HiOutlinePauseCircle", ()=>HiOutlinePauseCircle);
parcelHelpers.export(exports, "HiOutlinePaperClip", ()=>HiOutlinePaperClip);
parcelHelpers.export(exports, "HiOutlinePaperAirplane", ()=>HiOutlinePaperAirplane);
parcelHelpers.export(exports, "HiOutlinePaintBrush", ()=>HiOutlinePaintBrush);
parcelHelpers.export(exports, "HiOutlineNumberedList", ()=>HiOutlineNumberedList);
parcelHelpers.export(exports, "HiOutlineNoSymbol", ()=>HiOutlineNoSymbol);
parcelHelpers.export(exports, "HiOutlineNewspaper", ()=>HiOutlineNewspaper);
parcelHelpers.export(exports, "HiOutlineMusicalNote", ()=>HiOutlineMusicalNote);
parcelHelpers.export(exports, "HiOutlineMoon", ()=>HiOutlineMoon);
parcelHelpers.export(exports, "HiOutlineMinus", ()=>HiOutlineMinus);
parcelHelpers.export(exports, "HiOutlineMinusSmall", ()=>HiOutlineMinusSmall);
parcelHelpers.export(exports, "HiOutlineMinusCircle", ()=>HiOutlineMinusCircle);
parcelHelpers.export(exports, "HiOutlineMicrophone", ()=>HiOutlineMicrophone);
parcelHelpers.export(exports, "HiOutlineMegaphone", ()=>HiOutlineMegaphone);
parcelHelpers.export(exports, "HiOutlineMap", ()=>HiOutlineMap);
parcelHelpers.export(exports, "HiOutlineMapPin", ()=>HiOutlineMapPin);
parcelHelpers.export(exports, "HiOutlineMagnifyingGlass", ()=>HiOutlineMagnifyingGlass);
parcelHelpers.export(exports, "HiOutlineMagnifyingGlassPlus", ()=>HiOutlineMagnifyingGlassPlus);
parcelHelpers.export(exports, "HiOutlineMagnifyingGlassMinus", ()=>HiOutlineMagnifyingGlassMinus);
parcelHelpers.export(exports, "HiOutlineMagnifyingGlassCircle", ()=>HiOutlineMagnifyingGlassCircle);
parcelHelpers.export(exports, "HiOutlineLockOpen", ()=>HiOutlineLockOpen);
parcelHelpers.export(exports, "HiOutlineLockClosed", ()=>HiOutlineLockClosed);
parcelHelpers.export(exports, "HiOutlineListBullet", ()=>HiOutlineListBullet);
parcelHelpers.export(exports, "HiOutlineLink", ()=>HiOutlineLink);
parcelHelpers.export(exports, "HiOutlineLinkSlash", ()=>HiOutlineLinkSlash);
parcelHelpers.export(exports, "HiOutlineLightBulb", ()=>HiOutlineLightBulb);
parcelHelpers.export(exports, "HiOutlineLifebuoy", ()=>HiOutlineLifebuoy);
parcelHelpers.export(exports, "HiOutlineLanguage", ()=>HiOutlineLanguage);
parcelHelpers.export(exports, "HiOutlineKey", ()=>HiOutlineKey);
parcelHelpers.export(exports, "HiOutlineItalic", ()=>HiOutlineItalic);
parcelHelpers.export(exports, "HiOutlineInformationCircle", ()=>HiOutlineInformationCircle);
parcelHelpers.export(exports, "HiOutlineInbox", ()=>HiOutlineInbox);
parcelHelpers.export(exports, "HiOutlineInboxStack", ()=>HiOutlineInboxStack);
parcelHelpers.export(exports, "HiOutlineInboxArrowDown", ()=>HiOutlineInboxArrowDown);
parcelHelpers.export(exports, "HiOutlineIdentification", ()=>HiOutlineIdentification);
parcelHelpers.export(exports, "HiOutlineHome", ()=>HiOutlineHome);
parcelHelpers.export(exports, "HiOutlineHomeModern", ()=>HiOutlineHomeModern);
parcelHelpers.export(exports, "HiOutlineHeart", ()=>HiOutlineHeart);
parcelHelpers.export(exports, "HiOutlineHashtag", ()=>HiOutlineHashtag);
parcelHelpers.export(exports, "HiOutlineHandThumbUp", ()=>HiOutlineHandThumbUp);
parcelHelpers.export(exports, "HiOutlineHandThumbDown", ()=>HiOutlineHandThumbDown);
parcelHelpers.export(exports, "HiOutlineHandRaised", ()=>HiOutlineHandRaised);
parcelHelpers.export(exports, "HiOutlineH3", ()=>HiOutlineH3);
parcelHelpers.export(exports, "HiOutlineH2", ()=>HiOutlineH2);
parcelHelpers.export(exports, "HiOutlineH1", ()=>HiOutlineH1);
parcelHelpers.export(exports, "HiOutlineGlobeEuropeAfrica", ()=>HiOutlineGlobeEuropeAfrica);
parcelHelpers.export(exports, "HiOutlineGlobeAsiaAustralia", ()=>HiOutlineGlobeAsiaAustralia);
parcelHelpers.export(exports, "HiOutlineGlobeAmericas", ()=>HiOutlineGlobeAmericas);
parcelHelpers.export(exports, "HiOutlineGlobeAlt", ()=>HiOutlineGlobeAlt);
parcelHelpers.export(exports, "HiOutlineGift", ()=>HiOutlineGift);
parcelHelpers.export(exports, "HiOutlineGiftTop", ()=>HiOutlineGiftTop);
parcelHelpers.export(exports, "HiOutlineGif", ()=>HiOutlineGif);
parcelHelpers.export(exports, "HiOutlineFunnel", ()=>HiOutlineFunnel);
parcelHelpers.export(exports, "HiOutlineForward", ()=>HiOutlineForward);
parcelHelpers.export(exports, "HiOutlineFolder", ()=>HiOutlineFolder);
parcelHelpers.export(exports, "HiOutlineFolderPlus", ()=>HiOutlineFolderPlus);
parcelHelpers.export(exports, "HiOutlineFolderOpen", ()=>HiOutlineFolderOpen);
parcelHelpers.export(exports, "HiOutlineFolderMinus", ()=>HiOutlineFolderMinus);
parcelHelpers.export(exports, "HiOutlineFolderArrowDown", ()=>HiOutlineFolderArrowDown);
parcelHelpers.export(exports, "HiOutlineFlag", ()=>HiOutlineFlag);
parcelHelpers.export(exports, "HiOutlineFire", ()=>HiOutlineFire);
parcelHelpers.export(exports, "HiOutlineFingerPrint", ()=>HiOutlineFingerPrint);
parcelHelpers.export(exports, "HiOutlineFilm", ()=>HiOutlineFilm);
parcelHelpers.export(exports, "HiOutlineFaceSmile", ()=>HiOutlineFaceSmile);
parcelHelpers.export(exports, "HiOutlineFaceFrown", ()=>HiOutlineFaceFrown);
parcelHelpers.export(exports, "HiOutlineEye", ()=>HiOutlineEye);
parcelHelpers.export(exports, "HiOutlineEyeSlash", ()=>HiOutlineEyeSlash);
parcelHelpers.export(exports, "HiOutlineEyeDropper", ()=>HiOutlineEyeDropper);
parcelHelpers.export(exports, "HiOutlineExclamationTriangle", ()=>HiOutlineExclamationTriangle);
parcelHelpers.export(exports, "HiOutlineExclamationCircle", ()=>HiOutlineExclamationCircle);
parcelHelpers.export(exports, "HiOutlineEquals", ()=>HiOutlineEquals);
parcelHelpers.export(exports, "HiOutlineEnvelope", ()=>HiOutlineEnvelope);
parcelHelpers.export(exports, "HiOutlineEnvelopeOpen", ()=>HiOutlineEnvelopeOpen);
parcelHelpers.export(exports, "HiOutlineEllipsisVertical", ()=>HiOutlineEllipsisVertical);
parcelHelpers.export(exports, "HiOutlineEllipsisHorizontal", ()=>HiOutlineEllipsisHorizontal);
parcelHelpers.export(exports, "HiOutlineEllipsisHorizontalCircle", ()=>HiOutlineEllipsisHorizontalCircle);
parcelHelpers.export(exports, "HiOutlineDocument", ()=>HiOutlineDocument);
parcelHelpers.export(exports, "HiOutlineDocumentText", ()=>HiOutlineDocumentText);
parcelHelpers.export(exports, "HiOutlineDocumentPlus", ()=>HiOutlineDocumentPlus);
parcelHelpers.export(exports, "HiOutlineDocumentMinus", ()=>HiOutlineDocumentMinus);
parcelHelpers.export(exports, "HiOutlineDocumentMagnifyingGlass", ()=>HiOutlineDocumentMagnifyingGlass);
parcelHelpers.export(exports, "HiOutlineDocumentDuplicate", ()=>HiOutlineDocumentDuplicate);
parcelHelpers.export(exports, "HiOutlineDocumentCurrencyYen", ()=>HiOutlineDocumentCurrencyYen);
parcelHelpers.export(exports, "HiOutlineDocumentCurrencyRupee", ()=>HiOutlineDocumentCurrencyRupee);
parcelHelpers.export(exports, "HiOutlineDocumentCurrencyPound", ()=>HiOutlineDocumentCurrencyPound);
parcelHelpers.export(exports, "HiOutlineDocumentCurrencyEuro", ()=>HiOutlineDocumentCurrencyEuro);
parcelHelpers.export(exports, "HiOutlineDocumentCurrencyDollar", ()=>HiOutlineDocumentCurrencyDollar);
parcelHelpers.export(exports, "HiOutlineDocumentCurrencyBangladeshi", ()=>HiOutlineDocumentCurrencyBangladeshi);
parcelHelpers.export(exports, "HiOutlineDocumentCheck", ()=>HiOutlineDocumentCheck);
parcelHelpers.export(exports, "HiOutlineDocumentChartBar", ()=>HiOutlineDocumentChartBar);
parcelHelpers.export(exports, "HiOutlineDocumentArrowUp", ()=>HiOutlineDocumentArrowUp);
parcelHelpers.export(exports, "HiOutlineDocumentArrowDown", ()=>HiOutlineDocumentArrowDown);
parcelHelpers.export(exports, "HiOutlineDivide", ()=>HiOutlineDivide);
parcelHelpers.export(exports, "HiOutlineDeviceTablet", ()=>HiOutlineDeviceTablet);
parcelHelpers.export(exports, "HiOutlineDevicePhoneMobile", ()=>HiOutlineDevicePhoneMobile);
parcelHelpers.export(exports, "HiOutlineCursorArrowRipple", ()=>HiOutlineCursorArrowRipple);
parcelHelpers.export(exports, "HiOutlineCursorArrowRays", ()=>HiOutlineCursorArrowRays);
parcelHelpers.export(exports, "HiOutlineCurrencyYen", ()=>HiOutlineCurrencyYen);
parcelHelpers.export(exports, "HiOutlineCurrencyRupee", ()=>HiOutlineCurrencyRupee);
parcelHelpers.export(exports, "HiOutlineCurrencyPound", ()=>HiOutlineCurrencyPound);
parcelHelpers.export(exports, "HiOutlineCurrencyEuro", ()=>HiOutlineCurrencyEuro);
parcelHelpers.export(exports, "HiOutlineCurrencyDollar", ()=>HiOutlineCurrencyDollar);
parcelHelpers.export(exports, "HiOutlineCurrencyBangladeshi", ()=>HiOutlineCurrencyBangladeshi);
parcelHelpers.export(exports, "HiOutlineCube", ()=>HiOutlineCube);
parcelHelpers.export(exports, "HiOutlineCubeTransparent", ()=>HiOutlineCubeTransparent);
parcelHelpers.export(exports, "HiOutlineCreditCard", ()=>HiOutlineCreditCard);
parcelHelpers.export(exports, "HiOutlineCpuChip", ()=>HiOutlineCpuChip);
parcelHelpers.export(exports, "HiOutlineComputerDesktop", ()=>HiOutlineComputerDesktop);
parcelHelpers.export(exports, "HiOutlineCommandLine", ()=>HiOutlineCommandLine);
parcelHelpers.export(exports, "HiOutlineCog", ()=>HiOutlineCog);
parcelHelpers.export(exports, "HiOutlineCog8Tooth", ()=>HiOutlineCog8Tooth);
parcelHelpers.export(exports, "HiOutlineCog6Tooth", ()=>HiOutlineCog6Tooth);
parcelHelpers.export(exports, "HiOutlineCodeBracket", ()=>HiOutlineCodeBracket);
parcelHelpers.export(exports, "HiOutlineCodeBracketSquare", ()=>HiOutlineCodeBracketSquare);
parcelHelpers.export(exports, "HiOutlineCloud", ()=>HiOutlineCloud);
parcelHelpers.export(exports, "HiOutlineCloudArrowUp", ()=>HiOutlineCloudArrowUp);
parcelHelpers.export(exports, "HiOutlineCloudArrowDown", ()=>HiOutlineCloudArrowDown);
parcelHelpers.export(exports, "HiOutlineClock", ()=>HiOutlineClock);
parcelHelpers.export(exports, "HiOutlineClipboard", ()=>HiOutlineClipboard);
parcelHelpers.export(exports, "HiOutlineClipboardDocument", ()=>HiOutlineClipboardDocument);
parcelHelpers.export(exports, "HiOutlineClipboardDocumentList", ()=>HiOutlineClipboardDocumentList);
parcelHelpers.export(exports, "HiOutlineClipboardDocumentCheck", ()=>HiOutlineClipboardDocumentCheck);
parcelHelpers.export(exports, "HiOutlineCircleStack", ()=>HiOutlineCircleStack);
parcelHelpers.export(exports, "HiOutlineChevronUp", ()=>HiOutlineChevronUp);
parcelHelpers.export(exports, "HiOutlineChevronUpDown", ()=>HiOutlineChevronUpDown);
parcelHelpers.export(exports, "HiOutlineChevronRight", ()=>HiOutlineChevronRight);
parcelHelpers.export(exports, "HiOutlineChevronLeft", ()=>HiOutlineChevronLeft);
parcelHelpers.export(exports, "HiOutlineChevronDown", ()=>HiOutlineChevronDown);
parcelHelpers.export(exports, "HiOutlineChevronDoubleUp", ()=>HiOutlineChevronDoubleUp);
parcelHelpers.export(exports, "HiOutlineChevronDoubleRight", ()=>HiOutlineChevronDoubleRight);
parcelHelpers.export(exports, "HiOutlineChevronDoubleLeft", ()=>HiOutlineChevronDoubleLeft);
parcelHelpers.export(exports, "HiOutlineChevronDoubleDown", ()=>HiOutlineChevronDoubleDown);
parcelHelpers.export(exports, "HiOutlineCheck", ()=>HiOutlineCheck);
parcelHelpers.export(exports, "HiOutlineCheckCircle", ()=>HiOutlineCheckCircle);
parcelHelpers.export(exports, "HiOutlineCheckBadge", ()=>HiOutlineCheckBadge);
parcelHelpers.export(exports, "HiOutlineChatBubbleOvalLeft", ()=>HiOutlineChatBubbleOvalLeft);
parcelHelpers.export(exports, "HiOutlineChatBubbleOvalLeftEllipsis", ()=>HiOutlineChatBubbleOvalLeftEllipsis);
parcelHelpers.export(exports, "HiOutlineChatBubbleLeft", ()=>HiOutlineChatBubbleLeft);
parcelHelpers.export(exports, "HiOutlineChatBubbleLeftRight", ()=>HiOutlineChatBubbleLeftRight);
parcelHelpers.export(exports, "HiOutlineChatBubbleLeftEllipsis", ()=>HiOutlineChatBubbleLeftEllipsis);
parcelHelpers.export(exports, "HiOutlineChatBubbleBottomCenter", ()=>HiOutlineChatBubbleBottomCenter);
parcelHelpers.export(exports, "HiOutlineChatBubbleBottomCenterText", ()=>HiOutlineChatBubbleBottomCenterText);
parcelHelpers.export(exports, "HiOutlineChartPie", ()=>HiOutlineChartPie);
parcelHelpers.export(exports, "HiOutlineChartBar", ()=>HiOutlineChartBar);
parcelHelpers.export(exports, "HiOutlineChartBarSquare", ()=>HiOutlineChartBarSquare);
parcelHelpers.export(exports, "HiOutlineCamera", ()=>HiOutlineCamera);
parcelHelpers.export(exports, "HiOutlineCalendar", ()=>HiOutlineCalendar);
parcelHelpers.export(exports, "HiOutlineCalendarDays", ()=>HiOutlineCalendarDays);
parcelHelpers.export(exports, "HiOutlineCalendarDateRange", ()=>HiOutlineCalendarDateRange);
parcelHelpers.export(exports, "HiOutlineCalculator", ()=>HiOutlineCalculator);
parcelHelpers.export(exports, "HiOutlineCake", ()=>HiOutlineCake);
parcelHelpers.export(exports, "HiOutlineBuildingStorefront", ()=>HiOutlineBuildingStorefront);
parcelHelpers.export(exports, "HiOutlineBuildingOffice", ()=>HiOutlineBuildingOffice);
parcelHelpers.export(exports, "HiOutlineBuildingOffice2", ()=>HiOutlineBuildingOffice2);
parcelHelpers.export(exports, "HiOutlineBuildingLibrary", ()=>HiOutlineBuildingLibrary);
parcelHelpers.export(exports, "HiOutlineBugAnt", ()=>HiOutlineBugAnt);
parcelHelpers.export(exports, "HiOutlineBriefcase", ()=>HiOutlineBriefcase);
parcelHelpers.export(exports, "HiOutlineBookmark", ()=>HiOutlineBookmark);
parcelHelpers.export(exports, "HiOutlineBookmarkSquare", ()=>HiOutlineBookmarkSquare);
parcelHelpers.export(exports, "HiOutlineBookmarkSlash", ()=>HiOutlineBookmarkSlash);
parcelHelpers.export(exports, "HiOutlineBookOpen", ()=>HiOutlineBookOpen);
parcelHelpers.export(exports, "HiOutlineBolt", ()=>HiOutlineBolt);
parcelHelpers.export(exports, "HiOutlineBoltSlash", ()=>HiOutlineBoltSlash);
parcelHelpers.export(exports, "HiOutlineBold", ()=>HiOutlineBold);
parcelHelpers.export(exports, "HiOutlineBell", ()=>HiOutlineBell);
parcelHelpers.export(exports, "HiOutlineBellSnooze", ()=>HiOutlineBellSnooze);
parcelHelpers.export(exports, "HiOutlineBellSlash", ()=>HiOutlineBellSlash);
parcelHelpers.export(exports, "HiOutlineBellAlert", ()=>HiOutlineBellAlert);
parcelHelpers.export(exports, "HiOutlineBeaker", ()=>HiOutlineBeaker);
parcelHelpers.export(exports, "HiOutlineBattery50", ()=>HiOutlineBattery50);
parcelHelpers.export(exports, "HiOutlineBattery100", ()=>HiOutlineBattery100);
parcelHelpers.export(exports, "HiOutlineBattery0", ()=>HiOutlineBattery0);
parcelHelpers.export(exports, "HiOutlineBarsArrowUp", ()=>HiOutlineBarsArrowUp);
parcelHelpers.export(exports, "HiOutlineBarsArrowDown", ()=>HiOutlineBarsArrowDown);
parcelHelpers.export(exports, "HiOutlineBars4", ()=>HiOutlineBars4);
parcelHelpers.export(exports, "HiOutlineBars3", ()=>HiOutlineBars3);
parcelHelpers.export(exports, "HiOutlineBars3CenterLeft", ()=>HiOutlineBars3CenterLeft);
parcelHelpers.export(exports, "HiOutlineBars3BottomRight", ()=>HiOutlineBars3BottomRight);
parcelHelpers.export(exports, "HiOutlineBars3BottomLeft", ()=>HiOutlineBars3BottomLeft);
parcelHelpers.export(exports, "HiOutlineBars2", ()=>HiOutlineBars2);
parcelHelpers.export(exports, "HiOutlineBanknotes", ()=>HiOutlineBanknotes);
parcelHelpers.export(exports, "HiOutlineBackward", ()=>HiOutlineBackward);
parcelHelpers.export(exports, "HiOutlineBackspace", ()=>HiOutlineBackspace);
parcelHelpers.export(exports, "HiOutlineAtSymbol", ()=>HiOutlineAtSymbol);
parcelHelpers.export(exports, "HiOutlineArrowsUpDown", ()=>HiOutlineArrowsUpDown);
parcelHelpers.export(exports, "HiOutlineArrowsRightLeft", ()=>HiOutlineArrowsRightLeft);
parcelHelpers.export(exports, "HiOutlineArrowsPointingOut", ()=>HiOutlineArrowsPointingOut);
parcelHelpers.export(exports, "HiOutlineArrowsPointingIn", ()=>HiOutlineArrowsPointingIn);
parcelHelpers.export(exports, "HiOutlineArrowUturnUp", ()=>HiOutlineArrowUturnUp);
parcelHelpers.export(exports, "HiOutlineArrowUturnRight", ()=>HiOutlineArrowUturnRight);
parcelHelpers.export(exports, "HiOutlineArrowUturnLeft", ()=>HiOutlineArrowUturnLeft);
parcelHelpers.export(exports, "HiOutlineArrowUturnDown", ()=>HiOutlineArrowUturnDown);
parcelHelpers.export(exports, "HiOutlineArrowUp", ()=>HiOutlineArrowUp);
parcelHelpers.export(exports, "HiOutlineArrowUpTray", ()=>HiOutlineArrowUpTray);
parcelHelpers.export(exports, "HiOutlineArrowUpRight", ()=>HiOutlineArrowUpRight);
parcelHelpers.export(exports, "HiOutlineArrowUpOnSquare", ()=>HiOutlineArrowUpOnSquare);
parcelHelpers.export(exports, "HiOutlineArrowUpOnSquareStack", ()=>HiOutlineArrowUpOnSquareStack);
parcelHelpers.export(exports, "HiOutlineArrowUpLeft", ()=>HiOutlineArrowUpLeft);
parcelHelpers.export(exports, "HiOutlineArrowUpCircle", ()=>HiOutlineArrowUpCircle);
parcelHelpers.export(exports, "HiOutlineArrowTurnUpRight", ()=>HiOutlineArrowTurnUpRight);
parcelHelpers.export(exports, "HiOutlineArrowTurnUpLeft", ()=>HiOutlineArrowTurnUpLeft);
parcelHelpers.export(exports, "HiOutlineArrowTurnRightUp", ()=>HiOutlineArrowTurnRightUp);
parcelHelpers.export(exports, "HiOutlineArrowTurnRightDown", ()=>HiOutlineArrowTurnRightDown);
parcelHelpers.export(exports, "HiOutlineArrowTurnLeftUp", ()=>HiOutlineArrowTurnLeftUp);
parcelHelpers.export(exports, "HiOutlineArrowTurnLeftDown", ()=>HiOutlineArrowTurnLeftDown);
parcelHelpers.export(exports, "HiOutlineArrowTurnDownRight", ()=>HiOutlineArrowTurnDownRight);
parcelHelpers.export(exports, "HiOutlineArrowTurnDownLeft", ()=>HiOutlineArrowTurnDownLeft);
parcelHelpers.export(exports, "HiOutlineArrowTrendingUp", ()=>HiOutlineArrowTrendingUp);
parcelHelpers.export(exports, "HiOutlineArrowTrendingDown", ()=>HiOutlineArrowTrendingDown);
parcelHelpers.export(exports, "HiOutlineArrowTopRightOnSquare", ()=>HiOutlineArrowTopRightOnSquare);
parcelHelpers.export(exports, "HiOutlineArrowSmallUp", ()=>HiOutlineArrowSmallUp);
parcelHelpers.export(exports, "HiOutlineArrowSmallRight", ()=>HiOutlineArrowSmallRight);
parcelHelpers.export(exports, "HiOutlineArrowSmallLeft", ()=>HiOutlineArrowSmallLeft);
parcelHelpers.export(exports, "HiOutlineArrowSmallDown", ()=>HiOutlineArrowSmallDown);
parcelHelpers.export(exports, "HiOutlineArrowRight", ()=>HiOutlineArrowRight);
parcelHelpers.export(exports, "HiOutlineArrowRightStartOnRectangle", ()=>HiOutlineArrowRightStartOnRectangle);
parcelHelpers.export(exports, "HiOutlineArrowRightOnRectangle", ()=>HiOutlineArrowRightOnRectangle);
parcelHelpers.export(exports, "HiOutlineArrowRightEndOnRectangle", ()=>HiOutlineArrowRightEndOnRectangle);
parcelHelpers.export(exports, "HiOutlineArrowRightCircle", ()=>HiOutlineArrowRightCircle);
parcelHelpers.export(exports, "HiOutlineArrowPath", ()=>HiOutlineArrowPath);
parcelHelpers.export(exports, "HiOutlineArrowPathRoundedSquare", ()=>HiOutlineArrowPathRoundedSquare);
parcelHelpers.export(exports, "HiOutlineArrowLongUp", ()=>HiOutlineArrowLongUp);
parcelHelpers.export(exports, "HiOutlineArrowLongRight", ()=>HiOutlineArrowLongRight);
parcelHelpers.export(exports, "HiOutlineArrowLongLeft", ()=>HiOutlineArrowLongLeft);
parcelHelpers.export(exports, "HiOutlineArrowLongDown", ()=>HiOutlineArrowLongDown);
parcelHelpers.export(exports, "HiOutlineArrowLeft", ()=>HiOutlineArrowLeft);
parcelHelpers.export(exports, "HiOutlineArrowLeftStartOnRectangle", ()=>HiOutlineArrowLeftStartOnRectangle);
parcelHelpers.export(exports, "HiOutlineArrowLeftOnRectangle", ()=>HiOutlineArrowLeftOnRectangle);
parcelHelpers.export(exports, "HiOutlineArrowLeftEndOnRectangle", ()=>HiOutlineArrowLeftEndOnRectangle);
parcelHelpers.export(exports, "HiOutlineArrowLeftCircle", ()=>HiOutlineArrowLeftCircle);
parcelHelpers.export(exports, "HiOutlineArrowDown", ()=>HiOutlineArrowDown);
parcelHelpers.export(exports, "HiOutlineArrowDownTray", ()=>HiOutlineArrowDownTray);
parcelHelpers.export(exports, "HiOutlineArrowDownRight", ()=>HiOutlineArrowDownRight);
parcelHelpers.export(exports, "HiOutlineArrowDownOnSquare", ()=>HiOutlineArrowDownOnSquare);
parcelHelpers.export(exports, "HiOutlineArrowDownOnSquareStack", ()=>HiOutlineArrowDownOnSquareStack);
parcelHelpers.export(exports, "HiOutlineArrowDownLeft", ()=>HiOutlineArrowDownLeft);
parcelHelpers.export(exports, "HiOutlineArrowDownCircle", ()=>HiOutlineArrowDownCircle);
parcelHelpers.export(exports, "HiOutlineArchiveBox", ()=>HiOutlineArchiveBox);
parcelHelpers.export(exports, "HiOutlineArchiveBoxXMark", ()=>HiOutlineArchiveBoxXMark);
parcelHelpers.export(exports, "HiOutlineArchiveBoxArrowDown", ()=>HiOutlineArchiveBoxArrowDown);
parcelHelpers.export(exports, "HiOutlineAdjustmentsVertical", ()=>HiOutlineAdjustmentsVertical);
parcelHelpers.export(exports, "HiOutlineAdjustmentsHorizontal", ()=>HiOutlineAdjustmentsHorizontal);
parcelHelpers.export(exports, "HiOutlineAcademicCap", ()=>HiOutlineAcademicCap);
parcelHelpers.export(exports, "HiMiniXMark", ()=>HiMiniXMark);
parcelHelpers.export(exports, "HiMiniXCircle", ()=>HiMiniXCircle);
parcelHelpers.export(exports, "HiMiniWrench", ()=>HiMiniWrench);
parcelHelpers.export(exports, "HiMiniWrenchScrewdriver", ()=>HiMiniWrenchScrewdriver);
parcelHelpers.export(exports, "HiMiniWindow", ()=>HiMiniWindow);
parcelHelpers.export(exports, "HiMiniWifi", ()=>HiMiniWifi);
parcelHelpers.export(exports, "HiMiniWallet", ()=>HiMiniWallet);
parcelHelpers.export(exports, "HiMiniViewfinderCircle", ()=>HiMiniViewfinderCircle);
parcelHelpers.export(exports, "HiMiniViewColumns", ()=>HiMiniViewColumns);
parcelHelpers.export(exports, "HiMiniVideoCamera", ()=>HiMiniVideoCamera);
parcelHelpers.export(exports, "HiMiniVideoCameraSlash", ()=>HiMiniVideoCameraSlash);
parcelHelpers.export(exports, "HiMiniVariable", ()=>HiMiniVariable);
parcelHelpers.export(exports, "HiMiniUsers", ()=>HiMiniUsers);
parcelHelpers.export(exports, "HiMiniUser", ()=>HiMiniUser);
parcelHelpers.export(exports, "HiMiniUserPlus", ()=>HiMiniUserPlus);
parcelHelpers.export(exports, "HiMiniUserMinus", ()=>HiMiniUserMinus);
parcelHelpers.export(exports, "HiMiniUserGroup", ()=>HiMiniUserGroup);
parcelHelpers.export(exports, "HiMiniUserCircle", ()=>HiMiniUserCircle);
parcelHelpers.export(exports, "HiMiniUnderline", ()=>HiMiniUnderline);
parcelHelpers.export(exports, "HiMiniTv", ()=>HiMiniTv);
parcelHelpers.export(exports, "HiMiniTruck", ()=>HiMiniTruck);
parcelHelpers.export(exports, "HiMiniTrophy", ()=>HiMiniTrophy);
parcelHelpers.export(exports, "HiMiniTrash", ()=>HiMiniTrash);
parcelHelpers.export(exports, "HiMiniTicket", ()=>HiMiniTicket);
parcelHelpers.export(exports, "HiMiniTag", ()=>HiMiniTag);
parcelHelpers.export(exports, "HiMiniTableCells", ()=>HiMiniTableCells);
parcelHelpers.export(exports, "HiMiniSwatch", ()=>HiMiniSwatch);
parcelHelpers.export(exports, "HiMiniSun", ()=>HiMiniSun);
parcelHelpers.export(exports, "HiMiniStrikethrough", ()=>HiMiniStrikethrough);
parcelHelpers.export(exports, "HiMiniStop", ()=>HiMiniStop);
parcelHelpers.export(exports, "HiMiniStopCircle", ()=>HiMiniStopCircle);
parcelHelpers.export(exports, "HiMiniStar", ()=>HiMiniStar);
parcelHelpers.export(exports, "HiMiniSquaresPlus", ()=>HiMiniSquaresPlus);
parcelHelpers.export(exports, "HiMiniSquares2X2", ()=>HiMiniSquares2X2);
parcelHelpers.export(exports, "HiMiniSquare3Stack3D", ()=>HiMiniSquare3Stack3D);
parcelHelpers.export(exports, "HiMiniSquare2Stack", ()=>HiMiniSquare2Stack);
parcelHelpers.export(exports, "HiMiniSpeakerXMark", ()=>HiMiniSpeakerXMark);
parcelHelpers.export(exports, "HiMiniSpeakerWave", ()=>HiMiniSpeakerWave);
parcelHelpers.export(exports, "HiMiniSparkles", ()=>HiMiniSparkles);
parcelHelpers.export(exports, "HiMiniSlash", ()=>HiMiniSlash);
parcelHelpers.export(exports, "HiMiniSignal", ()=>HiMiniSignal);
parcelHelpers.export(exports, "HiMiniSignalSlash", ()=>HiMiniSignalSlash);
parcelHelpers.export(exports, "HiMiniShoppingCart", ()=>HiMiniShoppingCart);
parcelHelpers.export(exports, "HiMiniShoppingBag", ()=>HiMiniShoppingBag);
parcelHelpers.export(exports, "HiMiniShieldExclamation", ()=>HiMiniShieldExclamation);
parcelHelpers.export(exports, "HiMiniShieldCheck", ()=>HiMiniShieldCheck);
parcelHelpers.export(exports, "HiMiniShare", ()=>HiMiniShare);
parcelHelpers.export(exports, "HiMiniServer", ()=>HiMiniServer);
parcelHelpers.export(exports, "HiMiniServerStack", ()=>HiMiniServerStack);
parcelHelpers.export(exports, "HiMiniScissors", ()=>HiMiniScissors);
parcelHelpers.export(exports, "HiMiniScale", ()=>HiMiniScale);
parcelHelpers.export(exports, "HiMiniRss", ()=>HiMiniRss);
parcelHelpers.export(exports, "HiMiniRocketLaunch", ()=>HiMiniRocketLaunch);
parcelHelpers.export(exports, "HiMiniRectangleStack", ()=>HiMiniRectangleStack);
parcelHelpers.export(exports, "HiMiniRectangleGroup", ()=>HiMiniRectangleGroup);
parcelHelpers.export(exports, "HiMiniReceiptRefund", ()=>HiMiniReceiptRefund);
parcelHelpers.export(exports, "HiMiniReceiptPercent", ()=>HiMiniReceiptPercent);
parcelHelpers.export(exports, "HiMiniRadio", ()=>HiMiniRadio);
parcelHelpers.export(exports, "HiMiniQueueList", ()=>HiMiniQueueList);
parcelHelpers.export(exports, "HiMiniQuestionMarkCircle", ()=>HiMiniQuestionMarkCircle);
parcelHelpers.export(exports, "HiMiniQrCode", ()=>HiMiniQrCode);
parcelHelpers.export(exports, "HiMiniPuzzlePiece", ()=>HiMiniPuzzlePiece);
parcelHelpers.export(exports, "HiMiniPrinter", ()=>HiMiniPrinter);
parcelHelpers.export(exports, "HiMiniPresentationChartLine", ()=>HiMiniPresentationChartLine);
parcelHelpers.export(exports, "HiMiniPresentationChartBar", ()=>HiMiniPresentationChartBar);
parcelHelpers.export(exports, "HiMiniPower", ()=>HiMiniPower);
parcelHelpers.export(exports, "HiMiniPlus", ()=>HiMiniPlus);
parcelHelpers.export(exports, "HiMiniPlusSmall", ()=>HiMiniPlusSmall);
parcelHelpers.export(exports, "HiMiniPlusCircle", ()=>HiMiniPlusCircle);
parcelHelpers.export(exports, "HiMiniPlay", ()=>HiMiniPlay);
parcelHelpers.export(exports, "HiMiniPlayPause", ()=>HiMiniPlayPause);
parcelHelpers.export(exports, "HiMiniPlayCircle", ()=>HiMiniPlayCircle);
parcelHelpers.export(exports, "HiMiniPhoto", ()=>HiMiniPhoto);
parcelHelpers.export(exports, "HiMiniPhone", ()=>HiMiniPhone);
parcelHelpers.export(exports, "HiMiniPhoneXMark", ()=>HiMiniPhoneXMark);
parcelHelpers.export(exports, "HiMiniPhoneArrowUpRight", ()=>HiMiniPhoneArrowUpRight);
parcelHelpers.export(exports, "HiMiniPhoneArrowDownLeft", ()=>HiMiniPhoneArrowDownLeft);
parcelHelpers.export(exports, "HiMiniPercentBadge", ()=>HiMiniPercentBadge);
parcelHelpers.export(exports, "HiMiniPencil", ()=>HiMiniPencil);
parcelHelpers.export(exports, "HiMiniPencilSquare", ()=>HiMiniPencilSquare);
parcelHelpers.export(exports, "HiMiniPause", ()=>HiMiniPause);
parcelHelpers.export(exports, "HiMiniPauseCircle", ()=>HiMiniPauseCircle);
parcelHelpers.export(exports, "HiMiniPaperClip", ()=>HiMiniPaperClip);
parcelHelpers.export(exports, "HiMiniPaperAirplane", ()=>HiMiniPaperAirplane);
parcelHelpers.export(exports, "HiMiniPaintBrush", ()=>HiMiniPaintBrush);
parcelHelpers.export(exports, "HiMiniNumberedList", ()=>HiMiniNumberedList);
parcelHelpers.export(exports, "HiMiniNoSymbol", ()=>HiMiniNoSymbol);
parcelHelpers.export(exports, "HiMiniNewspaper", ()=>HiMiniNewspaper);
parcelHelpers.export(exports, "HiMiniMusicalNote", ()=>HiMiniMusicalNote);
parcelHelpers.export(exports, "HiMiniMoon", ()=>HiMiniMoon);
parcelHelpers.export(exports, "HiMiniMinus", ()=>HiMiniMinus);
parcelHelpers.export(exports, "HiMiniMinusSmall", ()=>HiMiniMinusSmall);
parcelHelpers.export(exports, "HiMiniMinusCircle", ()=>HiMiniMinusCircle);
parcelHelpers.export(exports, "HiMiniMicrophone", ()=>HiMiniMicrophone);
parcelHelpers.export(exports, "HiMiniMegaphone", ()=>HiMiniMegaphone);
parcelHelpers.export(exports, "HiMiniMap", ()=>HiMiniMap);
parcelHelpers.export(exports, "HiMiniMapPin", ()=>HiMiniMapPin);
parcelHelpers.export(exports, "HiMiniMagnifyingGlass", ()=>HiMiniMagnifyingGlass);
parcelHelpers.export(exports, "HiMiniMagnifyingGlassPlus", ()=>HiMiniMagnifyingGlassPlus);
parcelHelpers.export(exports, "HiMiniMagnifyingGlassMinus", ()=>HiMiniMagnifyingGlassMinus);
parcelHelpers.export(exports, "HiMiniMagnifyingGlassCircle", ()=>HiMiniMagnifyingGlassCircle);
parcelHelpers.export(exports, "HiMiniLockOpen", ()=>HiMiniLockOpen);
parcelHelpers.export(exports, "HiMiniLockClosed", ()=>HiMiniLockClosed);
parcelHelpers.export(exports, "HiMiniListBullet", ()=>HiMiniListBullet);
parcelHelpers.export(exports, "HiMiniLink", ()=>HiMiniLink);
parcelHelpers.export(exports, "HiMiniLinkSlash", ()=>HiMiniLinkSlash);
parcelHelpers.export(exports, "HiMiniLightBulb", ()=>HiMiniLightBulb);
parcelHelpers.export(exports, "HiMiniLifebuoy", ()=>HiMiniLifebuoy);
parcelHelpers.export(exports, "HiMiniLanguage", ()=>HiMiniLanguage);
parcelHelpers.export(exports, "HiMiniKey", ()=>HiMiniKey);
parcelHelpers.export(exports, "HiMiniItalic", ()=>HiMiniItalic);
parcelHelpers.export(exports, "HiMiniInformationCircle", ()=>HiMiniInformationCircle);
parcelHelpers.export(exports, "HiMiniInbox", ()=>HiMiniInbox);
parcelHelpers.export(exports, "HiMiniInboxStack", ()=>HiMiniInboxStack);
parcelHelpers.export(exports, "HiMiniInboxArrowDown", ()=>HiMiniInboxArrowDown);
parcelHelpers.export(exports, "HiMiniIdentification", ()=>HiMiniIdentification);
parcelHelpers.export(exports, "HiMiniHome", ()=>HiMiniHome);
parcelHelpers.export(exports, "HiMiniHomeModern", ()=>HiMiniHomeModern);
parcelHelpers.export(exports, "HiMiniHeart", ()=>HiMiniHeart);
parcelHelpers.export(exports, "HiMiniHashtag", ()=>HiMiniHashtag);
parcelHelpers.export(exports, "HiMiniHandThumbUp", ()=>HiMiniHandThumbUp);
parcelHelpers.export(exports, "HiMiniHandThumbDown", ()=>HiMiniHandThumbDown);
parcelHelpers.export(exports, "HiMiniHandRaised", ()=>HiMiniHandRaised);
parcelHelpers.export(exports, "HiMiniH3", ()=>HiMiniH3);
parcelHelpers.export(exports, "HiMiniH2", ()=>HiMiniH2);
parcelHelpers.export(exports, "HiMiniH1", ()=>HiMiniH1);
parcelHelpers.export(exports, "HiMiniGlobeEuropeAfrica", ()=>HiMiniGlobeEuropeAfrica);
parcelHelpers.export(exports, "HiMiniGlobeAsiaAustralia", ()=>HiMiniGlobeAsiaAustralia);
parcelHelpers.export(exports, "HiMiniGlobeAmericas", ()=>HiMiniGlobeAmericas);
parcelHelpers.export(exports, "HiMiniGlobeAlt", ()=>HiMiniGlobeAlt);
parcelHelpers.export(exports, "HiMiniGift", ()=>HiMiniGift);
parcelHelpers.export(exports, "HiMiniGiftTop", ()=>HiMiniGiftTop);
parcelHelpers.export(exports, "HiMiniGif", ()=>HiMiniGif);
parcelHelpers.export(exports, "HiMiniFunnel", ()=>HiMiniFunnel);
parcelHelpers.export(exports, "HiMiniForward", ()=>HiMiniForward);
parcelHelpers.export(exports, "HiMiniFolder", ()=>HiMiniFolder);
parcelHelpers.export(exports, "HiMiniFolderPlus", ()=>HiMiniFolderPlus);
parcelHelpers.export(exports, "HiMiniFolderOpen", ()=>HiMiniFolderOpen);
parcelHelpers.export(exports, "HiMiniFolderMinus", ()=>HiMiniFolderMinus);
parcelHelpers.export(exports, "HiMiniFolderArrowDown", ()=>HiMiniFolderArrowDown);
parcelHelpers.export(exports, "HiMiniFlag", ()=>HiMiniFlag);
parcelHelpers.export(exports, "HiMiniFire", ()=>HiMiniFire);
parcelHelpers.export(exports, "HiMiniFingerPrint", ()=>HiMiniFingerPrint);
parcelHelpers.export(exports, "HiMiniFilm", ()=>HiMiniFilm);
parcelHelpers.export(exports, "HiMiniFaceSmile", ()=>HiMiniFaceSmile);
parcelHelpers.export(exports, "HiMiniFaceFrown", ()=>HiMiniFaceFrown);
parcelHelpers.export(exports, "HiMiniEye", ()=>HiMiniEye);
parcelHelpers.export(exports, "HiMiniEyeSlash", ()=>HiMiniEyeSlash);
parcelHelpers.export(exports, "HiMiniEyeDropper", ()=>HiMiniEyeDropper);
parcelHelpers.export(exports, "HiMiniExclamationTriangle", ()=>HiMiniExclamationTriangle);
parcelHelpers.export(exports, "HiMiniExclamationCircle", ()=>HiMiniExclamationCircle);
parcelHelpers.export(exports, "HiMiniEquals", ()=>HiMiniEquals);
parcelHelpers.export(exports, "HiMiniEnvelope", ()=>HiMiniEnvelope);
parcelHelpers.export(exports, "HiMiniEnvelopeOpen", ()=>HiMiniEnvelopeOpen);
parcelHelpers.export(exports, "HiMiniEllipsisVertical", ()=>HiMiniEllipsisVertical);
parcelHelpers.export(exports, "HiMiniEllipsisHorizontal", ()=>HiMiniEllipsisHorizontal);
parcelHelpers.export(exports, "HiMiniEllipsisHorizontalCircle", ()=>HiMiniEllipsisHorizontalCircle);
parcelHelpers.export(exports, "HiMiniDocument", ()=>HiMiniDocument);
parcelHelpers.export(exports, "HiMiniDocumentText", ()=>HiMiniDocumentText);
parcelHelpers.export(exports, "HiMiniDocumentPlus", ()=>HiMiniDocumentPlus);
parcelHelpers.export(exports, "HiMiniDocumentMinus", ()=>HiMiniDocumentMinus);
parcelHelpers.export(exports, "HiMiniDocumentMagnifyingGlass", ()=>HiMiniDocumentMagnifyingGlass);
parcelHelpers.export(exports, "HiMiniDocumentDuplicate", ()=>HiMiniDocumentDuplicate);
parcelHelpers.export(exports, "HiMiniDocumentCurrencyYen", ()=>HiMiniDocumentCurrencyYen);
parcelHelpers.export(exports, "HiMiniDocumentCurrencyRupee", ()=>HiMiniDocumentCurrencyRupee);
parcelHelpers.export(exports, "HiMiniDocumentCurrencyPound", ()=>HiMiniDocumentCurrencyPound);
parcelHelpers.export(exports, "HiMiniDocumentCurrencyEuro", ()=>HiMiniDocumentCurrencyEuro);
parcelHelpers.export(exports, "HiMiniDocumentCurrencyDollar", ()=>HiMiniDocumentCurrencyDollar);
parcelHelpers.export(exports, "HiMiniDocumentCurrencyBangladeshi", ()=>HiMiniDocumentCurrencyBangladeshi);
parcelHelpers.export(exports, "HiMiniDocumentCheck", ()=>HiMiniDocumentCheck);
parcelHelpers.export(exports, "HiMiniDocumentChartBar", ()=>HiMiniDocumentChartBar);
parcelHelpers.export(exports, "HiMiniDocumentArrowUp", ()=>HiMiniDocumentArrowUp);
parcelHelpers.export(exports, "HiMiniDocumentArrowDown", ()=>HiMiniDocumentArrowDown);
parcelHelpers.export(exports, "HiMiniDivide", ()=>HiMiniDivide);
parcelHelpers.export(exports, "HiMiniDeviceTablet", ()=>HiMiniDeviceTablet);
parcelHelpers.export(exports, "HiMiniDevicePhoneMobile", ()=>HiMiniDevicePhoneMobile);
parcelHelpers.export(exports, "HiMiniCursorArrowRipple", ()=>HiMiniCursorArrowRipple);
parcelHelpers.export(exports, "HiMiniCursorArrowRays", ()=>HiMiniCursorArrowRays);
parcelHelpers.export(exports, "HiMiniCurrencyYen", ()=>HiMiniCurrencyYen);
parcelHelpers.export(exports, "HiMiniCurrencyRupee", ()=>HiMiniCurrencyRupee);
parcelHelpers.export(exports, "HiMiniCurrencyPound", ()=>HiMiniCurrencyPound);
parcelHelpers.export(exports, "HiMiniCurrencyEuro", ()=>HiMiniCurrencyEuro);
parcelHelpers.export(exports, "HiMiniCurrencyDollar", ()=>HiMiniCurrencyDollar);
parcelHelpers.export(exports, "HiMiniCurrencyBangladeshi", ()=>HiMiniCurrencyBangladeshi);
parcelHelpers.export(exports, "HiMiniCube", ()=>HiMiniCube);
parcelHelpers.export(exports, "HiMiniCubeTransparent", ()=>HiMiniCubeTransparent);
parcelHelpers.export(exports, "HiMiniCreditCard", ()=>HiMiniCreditCard);
parcelHelpers.export(exports, "HiMiniCpuChip", ()=>HiMiniCpuChip);
parcelHelpers.export(exports, "HiMiniComputerDesktop", ()=>HiMiniComputerDesktop);
parcelHelpers.export(exports, "HiMiniCommandLine", ()=>HiMiniCommandLine);
parcelHelpers.export(exports, "HiMiniCog", ()=>HiMiniCog);
parcelHelpers.export(exports, "HiMiniCog8Tooth", ()=>HiMiniCog8Tooth);
parcelHelpers.export(exports, "HiMiniCog6Tooth", ()=>HiMiniCog6Tooth);
parcelHelpers.export(exports, "HiMiniCodeBracket", ()=>HiMiniCodeBracket);
parcelHelpers.export(exports, "HiMiniCodeBracketSquare", ()=>HiMiniCodeBracketSquare);
parcelHelpers.export(exports, "HiMiniCloud", ()=>HiMiniCloud);
parcelHelpers.export(exports, "HiMiniCloudArrowUp", ()=>HiMiniCloudArrowUp);
parcelHelpers.export(exports, "HiMiniCloudArrowDown", ()=>HiMiniCloudArrowDown);
parcelHelpers.export(exports, "HiMiniClock", ()=>HiMiniClock);
parcelHelpers.export(exports, "HiMiniClipboard", ()=>HiMiniClipboard);
parcelHelpers.export(exports, "HiMiniClipboardDocument", ()=>HiMiniClipboardDocument);
parcelHelpers.export(exports, "HiMiniClipboardDocumentList", ()=>HiMiniClipboardDocumentList);
parcelHelpers.export(exports, "HiMiniClipboardDocumentCheck", ()=>HiMiniClipboardDocumentCheck);
parcelHelpers.export(exports, "HiMiniCircleStack", ()=>HiMiniCircleStack);
parcelHelpers.export(exports, "HiMiniChevronUp", ()=>HiMiniChevronUp);
parcelHelpers.export(exports, "HiMiniChevronUpDown", ()=>HiMiniChevronUpDown);
parcelHelpers.export(exports, "HiMiniChevronRight", ()=>HiMiniChevronRight);
parcelHelpers.export(exports, "HiMiniChevronLeft", ()=>HiMiniChevronLeft);
parcelHelpers.export(exports, "HiMiniChevronDown", ()=>HiMiniChevronDown);
parcelHelpers.export(exports, "HiMiniChevronDoubleUp", ()=>HiMiniChevronDoubleUp);
parcelHelpers.export(exports, "HiMiniChevronDoubleRight", ()=>HiMiniChevronDoubleRight);
parcelHelpers.export(exports, "HiMiniChevronDoubleLeft", ()=>HiMiniChevronDoubleLeft);
parcelHelpers.export(exports, "HiMiniChevronDoubleDown", ()=>HiMiniChevronDoubleDown);
parcelHelpers.export(exports, "HiMiniCheck", ()=>HiMiniCheck);
parcelHelpers.export(exports, "HiMiniCheckCircle", ()=>HiMiniCheckCircle);
parcelHelpers.export(exports, "HiMiniCheckBadge", ()=>HiMiniCheckBadge);
parcelHelpers.export(exports, "HiMiniChatBubbleOvalLeft", ()=>HiMiniChatBubbleOvalLeft);
parcelHelpers.export(exports, "HiMiniChatBubbleOvalLeftEllipsis", ()=>HiMiniChatBubbleOvalLeftEllipsis);
parcelHelpers.export(exports, "HiMiniChatBubbleLeft", ()=>HiMiniChatBubbleLeft);
parcelHelpers.export(exports, "HiMiniChatBubbleLeftRight", ()=>HiMiniChatBubbleLeftRight);
parcelHelpers.export(exports, "HiMiniChatBubbleLeftEllipsis", ()=>HiMiniChatBubbleLeftEllipsis);
parcelHelpers.export(exports, "HiMiniChatBubbleBottomCenter", ()=>HiMiniChatBubbleBottomCenter);
parcelHelpers.export(exports, "HiMiniChatBubbleBottomCenterText", ()=>HiMiniChatBubbleBottomCenterText);
parcelHelpers.export(exports, "HiMiniChartPie", ()=>HiMiniChartPie);
parcelHelpers.export(exports, "HiMiniChartBar", ()=>HiMiniChartBar);
parcelHelpers.export(exports, "HiMiniChartBarSquare", ()=>HiMiniChartBarSquare);
parcelHelpers.export(exports, "HiMiniCamera", ()=>HiMiniCamera);
parcelHelpers.export(exports, "HiMiniCalendar", ()=>HiMiniCalendar);
parcelHelpers.export(exports, "HiMiniCalendarDays", ()=>HiMiniCalendarDays);
parcelHelpers.export(exports, "HiMiniCalendarDateRange", ()=>HiMiniCalendarDateRange);
parcelHelpers.export(exports, "HiMiniCalculator", ()=>HiMiniCalculator);
parcelHelpers.export(exports, "HiMiniCake", ()=>HiMiniCake);
parcelHelpers.export(exports, "HiMiniBuildingStorefront", ()=>HiMiniBuildingStorefront);
parcelHelpers.export(exports, "HiMiniBuildingOffice", ()=>HiMiniBuildingOffice);
parcelHelpers.export(exports, "HiMiniBuildingOffice2", ()=>HiMiniBuildingOffice2);
parcelHelpers.export(exports, "HiMiniBuildingLibrary", ()=>HiMiniBuildingLibrary);
parcelHelpers.export(exports, "HiMiniBugAnt", ()=>HiMiniBugAnt);
parcelHelpers.export(exports, "HiMiniBriefcase", ()=>HiMiniBriefcase);
parcelHelpers.export(exports, "HiMiniBookmark", ()=>HiMiniBookmark);
parcelHelpers.export(exports, "HiMiniBookmarkSquare", ()=>HiMiniBookmarkSquare);
parcelHelpers.export(exports, "HiMiniBookmarkSlash", ()=>HiMiniBookmarkSlash);
parcelHelpers.export(exports, "HiMiniBookOpen", ()=>HiMiniBookOpen);
parcelHelpers.export(exports, "HiMiniBolt", ()=>HiMiniBolt);
parcelHelpers.export(exports, "HiMiniBoltSlash", ()=>HiMiniBoltSlash);
parcelHelpers.export(exports, "HiMiniBold", ()=>HiMiniBold);
parcelHelpers.export(exports, "HiMiniBell", ()=>HiMiniBell);
parcelHelpers.export(exports, "HiMiniBellSnooze", ()=>HiMiniBellSnooze);
parcelHelpers.export(exports, "HiMiniBellSlash", ()=>HiMiniBellSlash);
parcelHelpers.export(exports, "HiMiniBellAlert", ()=>HiMiniBellAlert);
parcelHelpers.export(exports, "HiMiniBeaker", ()=>HiMiniBeaker);
parcelHelpers.export(exports, "HiMiniBattery50", ()=>HiMiniBattery50);
parcelHelpers.export(exports, "HiMiniBattery100", ()=>HiMiniBattery100);
parcelHelpers.export(exports, "HiMiniBattery0", ()=>HiMiniBattery0);
parcelHelpers.export(exports, "HiMiniBarsArrowUp", ()=>HiMiniBarsArrowUp);
parcelHelpers.export(exports, "HiMiniBarsArrowDown", ()=>HiMiniBarsArrowDown);
parcelHelpers.export(exports, "HiMiniBars4", ()=>HiMiniBars4);
parcelHelpers.export(exports, "HiMiniBars3", ()=>HiMiniBars3);
parcelHelpers.export(exports, "HiMiniBars3CenterLeft", ()=>HiMiniBars3CenterLeft);
parcelHelpers.export(exports, "HiMiniBars3BottomRight", ()=>HiMiniBars3BottomRight);
parcelHelpers.export(exports, "HiMiniBars3BottomLeft", ()=>HiMiniBars3BottomLeft);
parcelHelpers.export(exports, "HiMiniBars2", ()=>HiMiniBars2);
parcelHelpers.export(exports, "HiMiniBanknotes", ()=>HiMiniBanknotes);
parcelHelpers.export(exports, "HiMiniBackward", ()=>HiMiniBackward);
parcelHelpers.export(exports, "HiMiniBackspace", ()=>HiMiniBackspace);
parcelHelpers.export(exports, "HiMiniAtSymbol", ()=>HiMiniAtSymbol);
parcelHelpers.export(exports, "HiMiniArrowsUpDown", ()=>HiMiniArrowsUpDown);
parcelHelpers.export(exports, "HiMiniArrowsRightLeft", ()=>HiMiniArrowsRightLeft);
parcelHelpers.export(exports, "HiMiniArrowsPointingOut", ()=>HiMiniArrowsPointingOut);
parcelHelpers.export(exports, "HiMiniArrowsPointingIn", ()=>HiMiniArrowsPointingIn);
parcelHelpers.export(exports, "HiMiniArrowUturnUp", ()=>HiMiniArrowUturnUp);
parcelHelpers.export(exports, "HiMiniArrowUturnRight", ()=>HiMiniArrowUturnRight);
parcelHelpers.export(exports, "HiMiniArrowUturnLeft", ()=>HiMiniArrowUturnLeft);
parcelHelpers.export(exports, "HiMiniArrowUturnDown", ()=>HiMiniArrowUturnDown);
parcelHelpers.export(exports, "HiMiniArrowUp", ()=>HiMiniArrowUp);
parcelHelpers.export(exports, "HiMiniArrowUpTray", ()=>HiMiniArrowUpTray);
parcelHelpers.export(exports, "HiMiniArrowUpRight", ()=>HiMiniArrowUpRight);
parcelHelpers.export(exports, "HiMiniArrowUpOnSquare", ()=>HiMiniArrowUpOnSquare);
parcelHelpers.export(exports, "HiMiniArrowUpOnSquareStack", ()=>HiMiniArrowUpOnSquareStack);
parcelHelpers.export(exports, "HiMiniArrowUpLeft", ()=>HiMiniArrowUpLeft);
parcelHelpers.export(exports, "HiMiniArrowUpCircle", ()=>HiMiniArrowUpCircle);
parcelHelpers.export(exports, "HiMiniArrowTurnUpRight", ()=>HiMiniArrowTurnUpRight);
parcelHelpers.export(exports, "HiMiniArrowTurnUpLeft", ()=>HiMiniArrowTurnUpLeft);
parcelHelpers.export(exports, "HiMiniArrowTurnRightUp", ()=>HiMiniArrowTurnRightUp);
parcelHelpers.export(exports, "HiMiniArrowTurnRightDown", ()=>HiMiniArrowTurnRightDown);
parcelHelpers.export(exports, "HiMiniArrowTurnLeftUp", ()=>HiMiniArrowTurnLeftUp);
parcelHelpers.export(exports, "HiMiniArrowTurnLeftDown", ()=>HiMiniArrowTurnLeftDown);
parcelHelpers.export(exports, "HiMiniArrowTurnDownRight", ()=>HiMiniArrowTurnDownRight);
parcelHelpers.export(exports, "HiMiniArrowTurnDownLeft", ()=>HiMiniArrowTurnDownLeft);
parcelHelpers.export(exports, "HiMiniArrowTrendingUp", ()=>HiMiniArrowTrendingUp);
parcelHelpers.export(exports, "HiMiniArrowTrendingDown", ()=>HiMiniArrowTrendingDown);
parcelHelpers.export(exports, "HiMiniArrowTopRightOnSquare", ()=>HiMiniArrowTopRightOnSquare);
parcelHelpers.export(exports, "HiMiniArrowSmallUp", ()=>HiMiniArrowSmallUp);
parcelHelpers.export(exports, "HiMiniArrowSmallRight", ()=>HiMiniArrowSmallRight);
parcelHelpers.export(exports, "HiMiniArrowSmallLeft", ()=>HiMiniArrowSmallLeft);
parcelHelpers.export(exports, "HiMiniArrowSmallDown", ()=>HiMiniArrowSmallDown);
parcelHelpers.export(exports, "HiMiniArrowRight", ()=>HiMiniArrowRight);
parcelHelpers.export(exports, "HiMiniArrowRightStartOnRectangle", ()=>HiMiniArrowRightStartOnRectangle);
parcelHelpers.export(exports, "HiMiniArrowRightOnRectangle", ()=>HiMiniArrowRightOnRectangle);
parcelHelpers.export(exports, "HiMiniArrowRightEndOnRectangle", ()=>HiMiniArrowRightEndOnRectangle);
parcelHelpers.export(exports, "HiMiniArrowRightCircle", ()=>HiMiniArrowRightCircle);
parcelHelpers.export(exports, "HiMiniArrowPath", ()=>HiMiniArrowPath);
parcelHelpers.export(exports, "HiMiniArrowPathRoundedSquare", ()=>HiMiniArrowPathRoundedSquare);
parcelHelpers.export(exports, "HiMiniArrowLongUp", ()=>HiMiniArrowLongUp);
parcelHelpers.export(exports, "HiMiniArrowLongRight", ()=>HiMiniArrowLongRight);
parcelHelpers.export(exports, "HiMiniArrowLongLeft", ()=>HiMiniArrowLongLeft);
parcelHelpers.export(exports, "HiMiniArrowLongDown", ()=>HiMiniArrowLongDown);
parcelHelpers.export(exports, "HiMiniArrowLeft", ()=>HiMiniArrowLeft);
parcelHelpers.export(exports, "HiMiniArrowLeftStartOnRectangle", ()=>HiMiniArrowLeftStartOnRectangle);
parcelHelpers.export(exports, "HiMiniArrowLeftOnRectangle", ()=>HiMiniArrowLeftOnRectangle);
parcelHelpers.export(exports, "HiMiniArrowLeftEndOnRectangle", ()=>HiMiniArrowLeftEndOnRectangle);
parcelHelpers.export(exports, "HiMiniArrowLeftCircle", ()=>HiMiniArrowLeftCircle);
parcelHelpers.export(exports, "HiMiniArrowDown", ()=>HiMiniArrowDown);
parcelHelpers.export(exports, "HiMiniArrowDownTray", ()=>HiMiniArrowDownTray);
parcelHelpers.export(exports, "HiMiniArrowDownRight", ()=>HiMiniArrowDownRight);
parcelHelpers.export(exports, "HiMiniArrowDownOnSquare", ()=>HiMiniArrowDownOnSquare);
parcelHelpers.export(exports, "HiMiniArrowDownOnSquareStack", ()=>HiMiniArrowDownOnSquareStack);
parcelHelpers.export(exports, "HiMiniArrowDownLeft", ()=>HiMiniArrowDownLeft);
parcelHelpers.export(exports, "HiMiniArrowDownCircle", ()=>HiMiniArrowDownCircle);
parcelHelpers.export(exports, "HiMiniArchiveBox", ()=>HiMiniArchiveBox);
parcelHelpers.export(exports, "HiMiniArchiveBoxXMark", ()=>HiMiniArchiveBoxXMark);
parcelHelpers.export(exports, "HiMiniArchiveBoxArrowDown", ()=>HiMiniArchiveBoxArrowDown);
parcelHelpers.export(exports, "HiMiniAdjustmentsVertical", ()=>HiMiniAdjustmentsVertical);
parcelHelpers.export(exports, "HiMiniAdjustmentsHorizontal", ()=>HiMiniAdjustmentsHorizontal);
parcelHelpers.export(exports, "HiMiniAcademicCap", ()=>HiMiniAcademicCap);
var _indexMjs = require("../lib/index.mjs");
function HiXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiXCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiWrench(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 6.75a5.25 5.25 0 0 1 6.775-5.025.75.75 0 0 1 .313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 0 1 1.248.313 5.25 5.25 0 0 1-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 1 1 2.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0 1 12 6.75ZM4.117 19.125a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiWrenchScrewdriver(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 6.75a5.25 5.25 0 0 1 6.775-5.025.75.75 0 0 1 .313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 0 1 1.248.313 5.25 5.25 0 0 1-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 1 1 2.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0 1 12 6.75ZM4.117 19.125a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.076 8.64-2.201-2.2V4.874a.75.75 0 0 0-.364-.643l-3.75-2.25a.75.75 0 0 0-.916.113l-.75.75a.75.75 0 0 0-.113.916l2.25 3.75a.75.75 0 0 0 .643.364h1.564l2.062 2.062 1.575-1.297Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m12.556 17.329 4.183 4.182a3.375 3.375 0 0 0 4.773-4.773l-3.306-3.305a6.803 6.803 0 0 1-1.53.043c-.394-.034-.682-.006-.867.042a.589.589 0 0 0-.167.063l-3.086 3.748Zm3.414-1.36a.75.75 0 0 1 1.06 0l1.875 1.876a.75.75 0 1 1-1.06 1.06L15.97 17.03a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiWindow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 6a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V6Zm18 3H3.75v9a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V9Zm-15-3.75A.75.75 0 0 0 4.5 6v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H5.25Zm1.5.75a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V6Zm3-.75A.75.75 0 0 0 9 6v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H9.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiWifi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.371 8.143c5.858-5.857 15.356-5.857 21.213 0a.75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.06 0c-4.98-4.979-13.053-4.979-18.032 0a.75.75 0 0 1-1.06 0l-.53-.53a.75.75 0 0 1 0-1.06Zm3.182 3.182c4.1-4.1 10.749-4.1 14.85 0a.75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.062 0 8.25 8.25 0 0 0-11.667 0 .75.75 0 0 1-1.06 0l-.53-.53a.75.75 0 0 1 0-1.06Zm3.204 3.182a6 6 0 0 1 8.486 0 .75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.061 0 3.75 3.75 0 0 0-5.304 0 .75.75 0 0 1-1.06 0l-.53-.53a.75.75 0 0 1 0-1.06Zm3.182 3.182a1.5 1.5 0 0 1 2.122 0 .75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.061 0l-.53-.53a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.273 5.625A4.483 4.483 0 0 1 5.25 4.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0 0 18.75 3H5.25a3 3 0 0 0-2.977 2.625ZM2.273 8.625A4.483 4.483 0 0 1 5.25 7.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0 0 18.75 6H5.25a3 3 0 0 0-2.977 2.625ZM5.25 9a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3H15a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0A.75.75 0 0 0 9 9H5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiViewfinderCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3a3 3 0 0 0-3 3v1.5a.75.75 0 0 0 1.5 0V6A1.5 1.5 0 0 1 6 4.5h1.5a.75.75 0 0 0 0-1.5H6ZM16.5 3a.75.75 0 0 0 0 1.5H18A1.5 1.5 0 0 1 19.5 6v1.5a.75.75 0 0 0 1.5 0V6a3 3 0 0 0-3-3h-1.5ZM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM4.5 16.5a.75.75 0 0 0-1.5 0V18a3 3 0 0 0 3 3h1.5a.75.75 0 0 0 0-1.5H6A1.5 1.5 0 0 1 4.5 18v-1.5ZM21 16.5a.75.75 0 0 0-1.5 0V18a1.5 1.5 0 0 1-1.5 1.5h-1.5a.75.75 0 0 0 0 1.5H18a3 3 0 0 0 3-3v-1.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiViewColumns(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3.75H9v16.5h6V3.75ZM16.5 20.25h3.375c1.035 0 1.875-.84 1.875-1.875V5.625c0-1.036-.84-1.875-1.875-1.875H16.5v16.5ZM4.125 3.75H7.5v16.5H4.125a1.875 1.875 0 0 1-1.875-1.875V5.625c0-1.036.84-1.875 1.875-1.875Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiVideoCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 4.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3H4.5ZM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiVideoCameraSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.97 3.97a.75.75 0 0 1 1.06 0l15 15a.75.75 0 1 1-1.06 1.06l-15-15a.75.75 0 0 1 0-1.06ZM17.25 16.06l2.69 2.69c.944.945 2.56.276 2.56-1.06V6.31c0-1.336-1.616-2.005-2.56-1.06l-2.69 2.69v8.12ZM15.75 7.5v8.068L4.682 4.5h8.068a3 3 0 0 1 3 3ZM1.5 16.5V7.682l11.773 11.773c-.17.03-.345.045-.523.045H4.5a3 3 0 0 1-3-3Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiVariable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.253 2.292a.75.75 0 0 1 .955.461A28.123 28.123 0 0 1 21.75 12c0 3.266-.547 6.388-1.542 9.247a.75.75 0 1 1-1.416-.494c.94-2.7 1.458-5.654 1.458-8.753s-.519-6.054-1.458-8.754a.75.75 0 0 1 .461-.954Zm-14.227.013a.75.75 0 0 1 .414.976A23.183 23.183 0 0 0 3.75 12c0 3.085.6 6.027 1.69 8.718a.75.75 0 0 1-1.39.563c-1.161-2.867-1.8-6-1.8-9.281 0-3.28.639-6.414 1.8-9.281a.75.75 0 0 1 .976-.414Zm4.275 5.052a1.5 1.5 0 0 1 2.21.803l.716 2.148L13.6 8.246a2.438 2.438 0 0 1 2.978-.892l.213.09a.75.75 0 1 1-.584 1.381l-.214-.09a.937.937 0 0 0-1.145.343l-2.021 3.033 1.084 3.255 1.445-.89a.75.75 0 1 1 .786 1.278l-1.444.889a1.5 1.5 0 0 1-2.21-.803l-.716-2.148-1.374 2.062a2.437 2.437 0 0 1-2.978.892l-.213-.09a.75.75 0 0 1 .584-1.381l.214.09a.938.938 0 0 0 1.145-.344l2.021-3.032-1.084-3.255-1.445.89a.75.75 0 1 1-.786-1.278l1.444-.89Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUsers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM14.25 8.625a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM17.25 19.128l-.001.144a2.25 2.25 0 0 1-.233.96 10.088 10.088 0 0 0 5.06-1.01.75.75 0 0 0 .42-.643 4.875 4.875 0 0 0-6.957-4.611 8.586 8.586 0 0 1 1.71 5.157v.003Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUserPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.25 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM2.25 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM18.75 7.5a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H21a.75.75 0 0 0 0-1.5h-2.25V7.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUserMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.375 2.25a4.125 4.125 0 1 0 0 8.25 4.125 4.125 0 0 0 0-8.25ZM10.375 12a7.125 7.125 0 0 0-7.124 7.247.75.75 0 0 0 .363.63 13.067 13.067 0 0 0 6.761 1.873c2.472 0 4.786-.684 6.76-1.873a.75.75 0 0 0 .364-.63l.001-.12v-.002A7.125 7.125 0 0 0 10.375 12ZM16 9.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUserGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiUnderline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.995 2.994a.75.75 0 0 1 .75.75v7.5a5.25 5.25 0 1 0 10.5 0v-7.5a.75.75 0 0 1 1.5 0v7.5a6.75 6.75 0 1 1-13.5 0v-7.5a.75.75 0 0 1 .75-.75Zm-3 17.252a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5h-16.5a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 6h-15v9h15V6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v11.25C1.5 17.16 2.34 18 3.375 18H9.75v1.5H6A.75.75 0 0 0 6 21h12a.75.75 0 0 0 0-1.5h-3.75V18h6.375c1.035 0 1.875-.84 1.875-1.875V4.875C22.5 3.839 21.66 3 20.625 3H3.375Zm0 13.5h17.25a.375.375 0 0 0 .375-.375V4.875a.375.375 0 0 0-.375-.375H3.375A.375.375 0 0 0 3 4.875v11.25c0 .207.168.375.375.375Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTruck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 1 1 6 0h3a.75.75 0 0 0 .75-.75V15Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.25 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM15.75 6.75a.75.75 0 0 0-.75.75v11.25c0 .087.015.17.042.248a3 3 0 0 1 5.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 0 0-3.732-10.104 1.837 1.837 0 0 0-1.47-.725H15.75Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTrophy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.166 2.621v.858c-1.035.148-2.059.33-3.071.543a.75.75 0 0 0-.584.859 6.753 6.753 0 0 0 6.138 5.6 6.73 6.73 0 0 0 2.743 1.346A6.707 6.707 0 0 1 9.279 15H8.54c-1.036 0-1.875.84-1.875 1.875V19.5h-.75a2.25 2.25 0 0 0-2.25 2.25c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-2.25-2.25h-.75v-2.625c0-1.036-.84-1.875-1.875-1.875h-.739a6.706 6.706 0 0 1-1.112-3.173 6.73 6.73 0 0 0 2.743-1.347 6.753 6.753 0 0 0 6.139-5.6.75.75 0 0 0-.585-.858 47.077 47.077 0 0 0-3.07-.543V2.62a.75.75 0 0 0-.658-.744 49.22 49.22 0 0 0-6.093-.377c-2.063 0-4.096.128-6.093.377a.75.75 0 0 0-.657.744Zm0 2.629c0 1.196.312 2.32.857 3.294A5.266 5.266 0 0 1 3.16 5.337a45.6 45.6 0 0 1 2.006-.343v.256Zm13.5 0v-.256c.674.1 1.343.214 2.006.343a5.265 5.265 0 0 1-2.863 3.207 6.72 6.72 0 0 0 .857-3.294Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTicket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 6.375c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v3.026a.75.75 0 0 1-.375.65 2.249 2.249 0 0 0 0 3.898.75.75 0 0 1 .375.65v3.026c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 17.625v-3.026a.75.75 0 0 1 .374-.65 2.249 2.249 0 0 0 0-3.898.75.75 0 0 1-.374-.65V6.375Zm15-1.125a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Zm.75 4.5a.75.75 0 0 0-1.5 0v.75a.75.75 0 0 0 1.5 0v-.75Zm-.75 3a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-1.5 0v-.75a.75.75 0 0 1 .75-.75Zm.75 4.5a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-.75ZM6 12a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 12Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.25 2.25a3 3 0 0 0-3 3v4.318a3 3 0 0 0 .879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 0 0 5.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 0 0-2.122-.879H5.25ZM6.375 7.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiTableCells(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625ZM21 9.375A.375.375 0 0 0 20.625 9h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5ZM10.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5ZM3.375 15h7.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h7.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 10.875 9h-7.5A.375.375 0 0 0 3 9.375v1.5c0 .207.168.375.375.375Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 4.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875V17.25a4.5 4.5 0 1 1-9 0V4.125Zm4.5 14.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.719 21.75h9.156c1.036 0 1.875-.84 1.875-1.875v-5.25c0-1.036-.84-1.875-1.875-1.875h-.14l-8.742 8.743c-.09.089-.18.175-.274.257ZM12.738 17.625l6.474-6.474a1.875 1.875 0 0 0 0-2.651L15.5 4.787a1.875 1.875 0 0 0-2.651 0l-.1.099V17.25c0 .126-.003.251-.01.375Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.25a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM18.894 6.166a.75.75 0 0 0-1.06-1.06l-1.591 1.59a.75.75 0 1 0 1.06 1.061l1.591-1.59ZM21.75 12a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1 0-1.5H21a.75.75 0 0 1 .75.75ZM17.834 18.894a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 1 0-1.061 1.06l1.59 1.591ZM12 18a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-2.25A.75.75 0 0 1 12 18ZM7.758 17.303a.75.75 0 0 0-1.061-1.06l-1.591 1.59a.75.75 0 0 0 1.06 1.061l1.591-1.59ZM6 12a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2.25A.75.75 0 0 1 6 12ZM6.697 7.757a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 0 0-1.061 1.06l1.59 1.591Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiStrikethrough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.657 4.728c-1.086.385-1.766 1.057-1.979 1.85-.214.8.046 1.733.81 2.616.746.862 1.93 1.612 3.388 2.003.07.019.14.037.21.053h8.163a.75.75 0 0 1 0 1.5h-8.24a.66.66 0 0 1-.02 0H3.75a.75.75 0 0 1 0-1.5h4.78a7.108 7.108 0 0 1-1.175-1.074C6.372 9.042 5.849 7.61 6.229 6.19c.377-1.408 1.528-2.38 2.927-2.876 1.402-.497 3.127-.55 4.855-.086A8.937 8.937 0 0 1 16.94 4.6a.75.75 0 0 1-.881 1.215 7.437 7.437 0 0 0-2.436-1.14c-1.473-.394-2.885-.331-3.966.052Zm6.533 9.632a.75.75 0 0 1 1.03.25c.592.974.846 2.094.55 3.2-.378 1.408-1.529 2.38-2.927 2.876-1.402.497-3.127.55-4.855.087-1.712-.46-3.168-1.354-4.134-2.47a.75.75 0 0 1 1.134-.982c.746.862 1.93 1.612 3.388 2.003 1.473.394 2.884.331 3.966-.052 1.085-.384 1.766-1.056 1.978-1.85.169-.628.046-1.33-.381-2.032a.75.75 0 0 1 .25-1.03Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 7.5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiStopCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm6-2.438c0-.724.588-1.312 1.313-1.312h4.874c.725 0 1.313.588 1.313 1.313v4.874c0 .725-.588 1.313-1.313 1.313H9.564a1.312 1.312 0 0 1-1.313-1.313V9.564Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSquaresPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM15.75 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3H18a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2.25ZM6 12.75a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3v-2.25a3 3 0 0 0-3-3H6ZM17.625 13.5a.75.75 0 0 0-1.5 0v2.625H13.5a.75.75 0 0 0 0 1.5h2.625v2.625a.75.75 0 0 0 1.5 0v-2.625h2.625a.75.75 0 0 0 0-1.5h-2.625V13.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSquares2X2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3V6ZM3 15.75a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2.25Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3v-2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSquare3Stack3D(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.644 1.59a.75.75 0 0 1 .712 0l9.75 5.25a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.712 0l-9.75-5.25a.75.75 0 0 1 0-1.32l9.75-5.25Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.265 10.602 7.668 4.129a2.25 2.25 0 0 0 2.134 0l7.668-4.13 1.37.739a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.71 0l-9.75-5.25a.75.75 0 0 1 0-1.32l1.37-.738Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.933 19.231-7.668-4.13-1.37.739a.75.75 0 0 0 0 1.32l9.75 5.25c.221.12.489.12.71 0l9.75-5.25a.75.75 0 0 0 0-1.32l-1.37-.738-7.668 4.13a2.25 2.25 0 0 1-2.134-.001Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSquare2Stack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3v-6A4.5 4.5 0 0 1 10.5 6h6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7.5a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-7.5a3 3 0 0 1-3-3v-7.5a3 3 0 0 1 3-3H18Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSpeakerXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L20.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSpeakerWave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM18.584 5.106a.75.75 0 0 1 1.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 0 1-1.06-1.06 8.25 8.25 0 0 0 0-11.668.75.75 0 0 1 0-1.06Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.932 7.757a.75.75 0 0 1 1.061 0 6 6 0 0 1 0 8.486.75.75 0 0 1-1.06-1.061 4.5 4.5 0 0 0 0-6.364.75.75 0 0 1 0-1.06Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.256 3.042a.75.75 0 0 1 .449.962l-6 16.5a.75.75 0 1 1-1.41-.513l6-16.5a.75.75 0 0 1 .961-.449Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSignal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.636 4.575a.75.75 0 0 1 0 1.061 9 9 0 0 0 0 12.728.75.75 0 1 1-1.06 1.06c-4.101-4.1-4.101-10.748 0-14.849a.75.75 0 0 1 1.06 0Zm12.728 0a.75.75 0 0 1 1.06 0c4.101 4.1 4.101 10.75 0 14.85a.75.75 0 1 1-1.06-1.061 9 9 0 0 0 0-12.728.75.75 0 0 1 0-1.06ZM7.757 6.697a.75.75 0 0 1 0 1.06 6 6 0 0 0 0 8.486.75.75 0 0 1-1.06 1.06 7.5 7.5 0 0 1 0-10.606.75.75 0 0 1 1.06 0Zm8.486 0a.75.75 0 0 1 1.06 0 7.5 7.5 0 0 1 0 10.606.75.75 0 0 1-1.06-1.06 6 6 0 0 0 0-8.486.75.75 0 0 1 0-1.06ZM9.879 8.818a.75.75 0 0 1 0 1.06 3 3 0 0 0 0 4.243.75.75 0 1 1-1.061 1.061 4.5 4.5 0 0 1 0-6.364.75.75 0 0 1 1.06 0Zm4.242 0a.75.75 0 0 1 1.061 0 4.5 4.5 0 0 1 0 6.364.75.75 0 0 1-1.06-1.06 3 3 0 0 0 0-4.243.75.75 0 0 1 0-1.061ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiSignalSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.47 2.47a.75.75 0 0 1 1.06 0l8.407 8.407a1.125 1.125 0 0 1 1.186 1.186l1.462 1.461a3.001 3.001 0 0 0-.464-3.645.75.75 0 1 1 1.061-1.061 4.501 4.501 0 0 1 .486 5.79l1.072 1.072a6.001 6.001 0 0 0-.497-7.923.75.75 0 0 1 1.06-1.06 7.501 7.501 0 0 1 .505 10.05l1.064 1.065a9 9 0 0 0-.508-12.176.75.75 0 0 1 1.06-1.06c3.923 3.922 4.093 10.175.512 14.3l1.594 1.594a.75.75 0 1 1-1.06 1.06l-2.106-2.105-2.121-2.122h-.001l-4.705-4.706a.747.747 0 0 1-.127-.126L2.47 3.53a.75.75 0 0 1 0-1.061Zm1.189 4.422a.75.75 0 0 1 .326 1.01 9.004 9.004 0 0 0 1.651 10.462.75.75 0 1 1-1.06 1.06C1.27 16.12.63 11.165 2.648 7.219a.75.75 0 0 1 1.01-.326ZM5.84 9.134a.75.75 0 0 1 .472.95 6 6 0 0 0 1.444 6.159.75.75 0 0 1-1.06 1.06A7.5 7.5 0 0 1 4.89 9.606a.75.75 0 0 1 .95-.472Zm2.341 2.653a.75.75 0 0 1 .848.638c.088.62.37 1.218.849 1.696a.75.75 0 0 1-1.061 1.061 4.483 4.483 0 0 1-1.273-2.546.75.75 0 0 1 .637-.848Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiShoppingCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.25 2.25a.75.75 0 0 0 0 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 0 0-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 0 0 0-1.5H5.378A2.25 2.25 0 0 1 7.5 15h11.218a.75.75 0 0 0 .674-.421 60.358 60.358 0 0 0 2.96-7.228.75.75 0 0 0-.525-.965A60.864 60.864 0 0 0 5.68 4.509l-.232-.867A1.875 1.875 0 0 0 3.636 2.25H2.25ZM3.75 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16.5 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiShoppingBag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 0 0 4.25 22.5h15.5a1.875 1.875 0 0 0 1.865-2.071l-1.263-12a1.875 1.875 0 0 0-1.865-1.679H16.5V6a4.5 4.5 0 1 0-9 0ZM12 3a3 3 0 0 0-3 3v.75h6V6a3 3 0 0 0-3-3Zm-3 8.25a3 3 0 1 0 6 0v-.75a.75.75 0 0 1 1.5 0v.75a4.5 4.5 0 1 1-9 0v-.75a.75.75 0 0 1 1.5 0v.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiShieldExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.484 2.17a.75.75 0 0 1 1.032 0 11.209 11.209 0 0 0 7.877 3.08.75.75 0 0 1 .722.515 12.74 12.74 0 0 1 .635 3.985c0 5.942-4.064 10.933-9.563 12.348a.749.749 0 0 1-.374 0C6.314 20.683 2.25 15.692 2.25 9.75c0-1.39.223-2.73.635-3.985a.75.75 0 0 1 .722-.516l.143.001c2.996 0 5.718-1.17 7.734-3.08ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75ZM12 15a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75H12Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiShieldCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.75 4.5a3 3 0 1 1 .825 2.066l-8.421 4.679a3.002 3.002 0 0 1 0 1.51l8.421 4.679a3 3 0 1 1-.729 1.31l-8.421-4.678a3 3 0 1 1 0-4.132l8.421-4.679a3 3 0 0 1-.096-.755Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiServer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.08 5.227A3 3 0 0 1 6.979 3H17.02a3 3 0 0 1 2.9 2.227l2.113 7.926A5.228 5.228 0 0 0 18.75 12H5.25a5.228 5.228 0 0 0-3.284 1.153L4.08 5.227Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.25 13.5a3.75 3.75 0 1 0 0 7.5h13.5a3.75 3.75 0 1 0 0-7.5H5.25Zm10.5 4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiServerStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.507 4.048A3 3 0 0 1 7.785 3h8.43a3 3 0 0 1 2.278 1.048l1.722 2.008A4.533 4.533 0 0 0 19.5 6h-15c-.243 0-.482.02-.715.056l1.722-2.008Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 10.5a3 3 0 0 1 3-3h15a3 3 0 1 1 0 6h-15a3 3 0 0 1-3-3Zm15 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM4.5 15a3 3 0 1 0 0 6h15a3 3 0 1 0 0-6h-15Zm11.25 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM19.5 18a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.128 9.155a3.751 3.751 0 1 1 .713-1.321l1.136.656a.75.75 0 0 1 .222 1.104l-.006.007a.75.75 0 0 1-1.032.157 1.421 1.421 0 0 0-.113-.072l-.92-.531Zm-4.827-3.53a2.25 2.25 0 0 1 3.994 2.063.756.756 0 0 0-.122.23 2.25 2.25 0 0 1-3.872-2.293ZM13.348 8.272a5.073 5.073 0 0 0-3.428 3.57 5.08 5.08 0 0 0-.165 1.202 1.415 1.415 0 0 1-.707 1.201l-.96.554a3.751 3.751 0 1 0 .734 1.309l13.729-7.926a.75.75 0 0 0-.181-1.374l-.803-.215a5.25 5.25 0 0 0-2.894.05l-5.325 1.629Zm-9.223 7.03a2.25 2.25 0 1 0 2.25 3.897 2.25 2.25 0 0 0-2.25-3.897ZM12 12.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.372 12.615a.75.75 0 0 1 .75 0l5.43 3.135a.75.75 0 0 1-.182 1.374l-.802.215a5.25 5.25 0 0 1-2.894-.051l-5.147-1.574a.75.75 0 0 1-.156-1.367l3-1.732Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiScale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25a.75.75 0 0 1 .75.75v.756a49.106 49.106 0 0 1 9.152 1 .75.75 0 0 1-.152 1.485h-1.918l2.474 10.124a.75.75 0 0 1-.375.84A6.723 6.723 0 0 1 18.75 18a6.723 6.723 0 0 1-3.181-.795.75.75 0 0 1-.375-.84l2.474-10.124H12.75v13.28c1.293.076 2.534.343 3.697.776a.75.75 0 0 1-.262 1.453h-8.37a.75.75 0 0 1-.262-1.453c1.162-.433 2.404-.7 3.697-.775V6.24H6.332l2.474 10.124a.75.75 0 0 1-.375.84A6.723 6.723 0 0 1 5.25 18a6.723 6.723 0 0 1-3.181-.795.75.75 0 0 1-.375-.84L4.168 6.241H2.25a.75.75 0 0 1-.152-1.485 49.105 49.105 0 0 1 9.152-1V3a.75.75 0 0 1 .75-.75Zm4.878 13.543 1.872-7.662 1.872 7.662h-3.744Zm-9.756 0L5.25 8.131l-1.872 7.662h3.744Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 4.5a.75.75 0 0 1 .75-.75h.75c8.284 0 15 6.716 15 15v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75C18 11.708 12.292 6 5.25 6H4.5a.75.75 0 0 1-.75-.75V4.5Zm0 6.75a.75.75 0 0 1 .75-.75h.75a8.25 8.25 0 0 1 8.25 8.25v.75a.75.75 0 0 1-.75.75H12a.75.75 0 0 1-.75-.75v-.75a6 6 0 0 0-6-6H4.5a.75.75 0 0 1-.75-.75v-.75Zm0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiRocketLaunch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.315 7.584C12.195 3.883 16.695 1.5 21.75 1.5a.75.75 0 0 1 .75.75c0 5.056-2.383 9.555-6.084 12.436A6.75 6.75 0 0 1 9.75 22.5a.75.75 0 0 1-.75-.75v-4.131A15.838 15.838 0 0 1 6.382 15H2.25a.75.75 0 0 1-.75-.75 6.75 6.75 0 0 1 7.815-6.666ZM15 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.26 17.242a.75.75 0 1 0-.897-1.203 5.243 5.243 0 0 0-2.05 5.022.75.75 0 0 0 .625.627 5.243 5.243 0 0 0 5.022-2.051.75.75 0 1 0-1.202-.897 3.744 3.744 0 0 1-3.008 1.51c0-1.23.592-2.323 1.51-3.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiRectangleStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.566 4.657A4.505 4.505 0 0 1 6.75 4.5h10.5c.41 0 .806.055 1.183.157A3 3 0 0 0 15.75 3h-7.5a3 3 0 0 0-2.684 1.657ZM2.25 12a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3v-6ZM5.25 7.5c-.41 0-.806.055-1.184.157A3 3 0 0 1 6.75 6h10.5a3 3 0 0 1 2.683 1.657A4.505 4.505 0 0 0 18.75 7.5H5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiRectangleGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 0 1 1.5 10.875v-3.75Zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 0 1-1.875-1.875v-8.25ZM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 0 1 3 18.375v-2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiReceiptRefund(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 0 0 1.029.696l3.471-1.388 3.472 1.388a.75.75 0 0 0 .556 0l3.472-1.388 3.471 1.388a.75.75 0 0 0 1.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0 0 12 1.5Zm-.97 6.53a.75.75 0 1 0-1.06-1.06L7.72 9.22a.75.75 0 0 0 0 1.06l2.25 2.25a.75.75 0 1 0 1.06-1.06l-.97-.97h3.065a1.875 1.875 0 0 1 0 3.75H12a.75.75 0 0 0 0 1.5h1.125a3.375 3.375 0 1 0 0-6.75h-3.064l.97-.97Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiReceiptPercent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 0 0 1.029.696l3.471-1.388 3.472 1.388a.75.75 0 0 0 .556 0l3.472-1.388 3.471 1.388a.75.75 0 0 0 1.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0 0 12 1.5Zm3.53 7.28a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6ZM8.625 9a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm5.625 3.375a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiRadio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.432 4.103a.75.75 0 0 0-.364-1.456L4.128 6.632l-.2.033C2.498 6.904 1.5 8.158 1.5 9.574v9.176a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V9.574c0-1.416-.997-2.67-2.429-2.909a49.017 49.017 0 0 0-7.255-.658l7.616-1.904Zm-9.585 8.56a.75.75 0 0 1 0 1.06l-.005.006a.75.75 0 0 1-1.06 0l-.006-.006a.75.75 0 0 1 0-1.06l.005-.005a.75.75 0 0 1 1.06 0l.006.005ZM9.781 15.85a.75.75 0 0 0 1.061 0l.005-.005a.75.75 0 0 0 0-1.061l-.005-.005a.75.75 0 0 0-1.06 0l-.006.005a.75.75 0 0 0 0 1.06l.005.006Zm-1.055-1.066a.75.75 0 0 1 0 1.06l-.005.006a.75.75 0 0 1-1.061 0l-.005-.005a.75.75 0 0 1 0-1.06l.005-.006a.75.75 0 0 1 1.06 0l.006.005ZM7.66 13.73a.75.75 0 0 0 1.061 0l.005-.006a.75.75 0 0 0 0-1.06l-.005-.006a.75.75 0 0 0-1.06 0l-.006.006a.75.75 0 0 0 0 1.06l.005.006ZM9.255 9.75a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75V10.5a.75.75 0 0 1 .75-.75h.008Zm3.624 3.28a.75.75 0 0 0 .275-1.025L13.15 12a.75.75 0 0 0-1.025-.275l-.006.004a.75.75 0 0 0-.275 1.024l.004.007a.75.75 0 0 0 1.025.274l.006-.003Zm-1.38 5.126a.75.75 0 0 1-1.024-.275l-.004-.006a.75.75 0 0 1 .275-1.025l.006-.004a.75.75 0 0 1 1.025.275l.004.007a.75.75 0 0 1-.275 1.024l-.006.004Zm.282-6.776a.75.75 0 0 0-.274-1.025l-.007-.003a.75.75 0 0 0-1.024.274l-.004.007a.75.75 0 0 0 .274 1.024l.007.004a.75.75 0 0 0 1.024-.275l.004-.006Zm1.369 5.129a.75.75 0 0 1-1.025.274l-.006-.004a.75.75 0 0 1-.275-1.024l.004-.007a.75.75 0 0 1 1.025-.274l.006.004a.75.75 0 0 1 .275 1.024l-.004.007Zm-.145-1.502a.75.75 0 0 0 .75-.75v-.007a.75.75 0 0 0-.75-.75h-.008a.75.75 0 0 0-.75.75v.007c0 .415.336.75.75.75h.008Zm-3.75 2.243a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75V18a.75.75 0 0 1 .75-.75h.008Zm-2.871-.47a.75.75 0 0 0 .274-1.025l-.003-.006a.75.75 0 0 0-1.025-.275l-.006.004a.75.75 0 0 0-.275 1.024l.004.007a.75.75 0 0 0 1.024.274l.007-.003Zm1.366-5.12a.75.75 0 0 1-1.025-.274l-.004-.006a.75.75 0 0 1 .275-1.025l.006-.004a.75.75 0 0 1 1.025.275l.004.006a.75.75 0 0 1-.275 1.025l-.006.004Zm.281 6.215a.75.75 0 0 0-.275-1.024l-.006-.004a.75.75 0 0 0-1.025.274l-.003.007a.75.75 0 0 0 .274 1.024l.007.004a.75.75 0 0 0 1.024-.274l.004-.007Zm-1.376-5.116a.75.75 0 0 1-1.025.274l-.006-.003a.75.75 0 0 1-.275-1.025l.004-.007a.75.75 0 0 1 1.025-.274l.006.004a.75.75 0 0 1 .275 1.024l-.004.007Zm-1.15 2.248a.75.75 0 0 0 .75-.75v-.007a.75.75 0 0 0-.75-.75h-.008a.75.75 0 0 0-.75.75v.007c0 .415.336.75.75.75h.008ZM17.25 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm1.5 6a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiQueueList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.625 3.75a2.625 2.625 0 1 0 0 5.25h12.75a2.625 2.625 0 0 0 0-5.25H5.625ZM3.75 11.25a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75ZM3 15.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75ZM3.75 18.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiQuestionMarkCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiQrCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4.875C3 3.839 3.84 3 4.875 3h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 0 1 3 9.375v-4.5ZM4.875 4.5a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5Zm7.875.375c0-1.036.84-1.875 1.875-1.875h4.5C20.16 3 21 3.84 21 4.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5a1.875 1.875 0 0 1-1.875-1.875v-4.5Zm1.875-.375a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5ZM6 6.75A.75.75 0 0 1 6.75 6h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75A.75.75 0 0 1 6 7.5v-.75Zm9.75 0A.75.75 0 0 1 16.5 6h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75ZM3 14.625c0-1.036.84-1.875 1.875-1.875h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.035-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 0 1 3 19.125v-4.5Zm1.875-.375a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5Zm7.875-.75a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm6 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75ZM6 16.5a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm9.75 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm-3 3a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm6 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPuzzlePiece(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 5.337c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.036 1.007-1.875 2.25-1.875S15 2.34 15 3.375c0 .369-.128.713-.349 1.003-.215.283-.401.604-.401.959 0 .332.278.598.61.578 1.91-.114 3.79-.342 5.632-.676a.75.75 0 0 1 .878.645 49.17 49.17 0 0 1 .376 5.452.657.657 0 0 1-.66.664c-.354 0-.675-.186-.958-.401a1.647 1.647 0 0 0-1.003-.349c-1.035 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401.31 0 .557.262.534.571a48.774 48.774 0 0 1-.595 4.845.75.75 0 0 1-.61.61c-1.82.317-3.673.533-5.555.642a.58.58 0 0 1-.611-.581c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.035-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959a.641.641 0 0 1-.658.643 49.118 49.118 0 0 1-4.708-.36.75.75 0 0 1-.645-.878c.293-1.614.504-3.257.629-4.924A.53.53 0 0 0 5.337 15c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.036 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.369 0 .713.128 1.003.349.283.215.604.401.959.401a.656.656 0 0 0 .659-.663 47.703 47.703 0 0 0-.31-4.82.75.75 0 0 1 .83-.832c1.343.155 2.703.254 4.077.294a.64.64 0 0 0 .657-.642Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPrinter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPresentationChartLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.54 15h6.42l.5 1.5H8.29l.5-1.5Zm8.085-8.995a.75.75 0 1 0-.75-1.299 12.81 12.81 0 0 0-3.558 3.05L11.03 8.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l2.47-2.47 1.617 1.618a.75.75 0 0 0 1.146-.102 11.312 11.312 0 0 1 3.612-3.321Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPresentationChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.04 16.5.5-1.5h6.42l.5 1.5H8.29Zm7.46-12a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Zm-3 2.25a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V9Zm-3 2.25a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM6.166 5.106a.75.75 0 0 1 0 1.06 8.25 8.25 0 1 0 11.668 0 .75.75 0 1 1 1.06-1.06c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPlusSmall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 5.25a.75.75 0 0 1 .75.75v5.25H18a.75.75 0 0 1 0 1.5h-5.25V18a.75.75 0 0 1-1.5 0v-5.25H6a.75.75 0 0 1 0-1.5h5.25V6a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPlusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPlayPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6.75a.75.75 0 0 0-.75.75V18a.75.75 0 0 0 .75.75h.75a.75.75 0 0 0 .75-.75V7.5a.75.75 0 0 0-.75-.75H15ZM20.25 6.75a.75.75 0 0 0-.75.75V18c0 .414.336.75.75.75H21a.75.75 0 0 0 .75-.75V7.5a.75.75 0 0 0-.75-.75h-.75ZM5.055 7.06C3.805 6.347 2.25 7.25 2.25 8.69v8.122c0 1.44 1.555 2.343 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256L5.055 7.061Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPlayCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPhoto(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPhoneXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.22 3.22a.75.75 0 0 1 1.06 0L18 4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L19.06 6l1.72 1.72a.75.75 0 0 1-1.06 1.06L18 7.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L16.94 6l-1.72-1.72a.75.75 0 0 1 0-1.06ZM1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPhoneArrowUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-4.72 4.72a.75.75 0 1 1-1.06-1.06l4.72-4.72h-2.69a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPhoneArrowDownLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.5 9.75a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l4.72-4.72a.75.75 0 1 1 1.06 1.06L16.06 9h2.69a.75.75 0 0 1 .75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPercentBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.99 2.243a4.49 4.49 0 0 0-3.398 1.55 4.49 4.49 0 0 0-3.497 1.306 4.491 4.491 0 0 0-1.307 3.498 4.491 4.491 0 0 0-1.548 3.397c0 1.357.6 2.573 1.548 3.397a4.491 4.491 0 0 0 1.307 3.498 4.49 4.49 0 0 0 3.498 1.307 4.49 4.49 0 0 0 3.397 1.549 4.49 4.49 0 0 0 3.397-1.549 4.49 4.49 0 0 0 3.497-1.307 4.491 4.491 0 0 0 1.306-3.497 4.491 4.491 0 0 0 1.55-3.398c0-1.357-.601-2.573-1.549-3.397a4.491 4.491 0 0 0-1.307-3.498 4.49 4.49 0 0 0-3.498-1.307 4.49 4.49 0 0 0-3.396-1.549Zm3.53 7.28a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6Zm-5.78-.905a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm4.5 4.5a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPencil(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPencilSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPauseCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM9 8.25a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75h.75a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75H9Zm5.25 0a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75H15a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75h-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPaperClip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18.97 3.659a2.25 2.25 0 0 0-3.182 0l-10.94 10.94a3.75 3.75 0 1 0 5.304 5.303l7.693-7.693a.75.75 0 0 1 1.06 1.06l-7.693 7.693a5.25 5.25 0 1 1-7.424-7.424l10.939-10.94a3.75 3.75 0 1 1 5.303 5.304L9.097 18.835l-.008.008-.007.007-.002.002-.003.002A2.25 2.25 0 0 1 5.91 15.66l7.81-7.81a.75.75 0 0 1 1.061 1.06l-7.81 7.81a.75.75 0 0 0 1.054 1.068L18.97 6.84a2.25 2.25 0 0 0 0-3.182Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPaperAirplane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiPaintBrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.599 1.5c-.376 0-.743.111-1.055.32l-5.08 3.385a18.747 18.747 0 0 0-3.471 2.987 10.04 10.04 0 0 1 4.815 4.815 18.748 18.748 0 0 0 2.987-3.472l3.386-5.079A1.902 1.902 0 0 0 20.599 1.5Zm-8.3 14.025a18.76 18.76 0 0 0 1.896-1.207 8.026 8.026 0 0 0-4.513-4.513A18.75 18.75 0 0 0 8.475 11.7l-.278.5a5.26 5.26 0 0 1 3.601 3.602l.502-.278ZM6.75 13.5A3.75 3.75 0 0 0 3 17.25a1.5 1.5 0 0 1-1.601 1.497.75.75 0 0 0-.7 1.123 5.25 5.25 0 0 0 9.8-2.62 3.75 3.75 0 0 0-3.75-3.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiNumberedList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.491 5.992a.75.75 0 0 1 .75-.75h12a.75.75 0 1 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM7.49 11.995a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM7.491 17.994a.75.75 0 0 1 .75-.75h12a.75.75 0 1 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM2.24 3.745a.75.75 0 0 1 .75-.75h1.125a.75.75 0 0 1 .75.75v3h.375a.75.75 0 0 1 0 1.5H2.99a.75.75 0 0 1 0-1.5h.375v-2.25H2.99a.75.75 0 0 1-.75-.75ZM2.79 10.602a.75.75 0 0 1 0-1.06 1.875 1.875 0 1 1 2.652 2.651l-.55.55h.35a.75.75 0 0 1 0 1.5h-2.16a.75.75 0 0 1-.53-1.281l1.83-1.83a.375.375 0 0 0-.53-.53.75.75 0 0 1-1.062 0ZM2.24 15.745a.75.75 0 0 1 .75-.75h1.125a1.875 1.875 0 0 1 1.501 2.999 1.875 1.875 0 0 1-1.501 3H2.99a.75.75 0 0 1 0-1.501h1.125a.375.375 0 0 0 .036-.748H3.74a.75.75 0 0 1-.75-.75v-.002a.75.75 0 0 1 .75-.75h.411a.375.375 0 0 0-.036-.748H2.99a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiNoSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m6.72 5.66 11.62 11.62A8.25 8.25 0 0 0 6.72 5.66Zm10.56 12.68L5.66 6.72a8.25 8.25 0 0 0 11.62 11.62ZM5.105 5.106c3.807-3.808 9.98-3.808 13.788 0 3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.125 3C3.089 3 2.25 3.84 2.25 4.875V18a3 3 0 0 0 3 3h15a3 3 0 0 1-3-3V4.875C17.25 3.839 16.41 3 15.375 3H4.125ZM12 9.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H12Zm-.75-2.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75ZM6 12.75a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5H6Zm-.75 3.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75ZM6 6.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3A.75.75 0 0 0 9 6.75H6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.75 6.75h1.875c.621 0 1.125.504 1.125 1.125V18a1.5 1.5 0 0 1-3 0V6.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMusicalNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.952 1.651a.75.75 0 0 1 .298.599V16.303a3 3 0 0 1-2.176 2.884l-1.32.377a2.553 2.553 0 1 1-1.403-4.909l2.311-.66a1.5 1.5 0 0 0 1.088-1.442V6.994l-9 2.572v9.737a3 3 0 0 1-2.176 2.884l-1.32.377a2.553 2.553 0 1 1-1.402-4.909l2.31-.66a1.5 1.5 0 0 0 1.088-1.442V5.25a.75.75 0 0 1 .544-.721l10.5-3a.75.75 0 0 1 .658.122Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMinusSmall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMinusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3 10.5a.75.75 0 0 0 0-1.5H9a.75.75 0 0 0 0 1.5h6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMicrophone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.25 4.5a3.75 3.75 0 1 1 7.5 0v8.25a3.75 3.75 0 1 1-7.5 0V4.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10.5a.75.75 0 0 1 .75.75v1.5a5.25 5.25 0 1 0 10.5 0v-1.5a.75.75 0 0 1 1.5 0v1.5a6.751 6.751 0 0 1-6 6.709v2.291h3a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h3v-2.291a6.751 6.751 0 0 1-6-6.709v-1.5A.75.75 0 0 1 6 10.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMegaphone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.881 4.345A23.112 23.112 0 0 1 8.25 6H7.5a5.25 5.25 0 0 0-.88 10.427 21.593 21.593 0 0 0 1.378 3.94c.464 1.004 1.674 1.32 2.582.796l.657-.379c.88-.508 1.165-1.593.772-2.468a17.116 17.116 0 0 1-.628-1.607c1.918.258 3.76.75 5.5 1.446A21.727 21.727 0 0 0 18 11.25c0-2.414-.393-4.735-1.119-6.905ZM18.26 3.74a23.22 23.22 0 0 1 1.24 7.51 23.22 23.22 0 0 1-1.41 7.992.75.75 0 1 0 1.409.516 24.555 24.555 0 0 0 1.415-6.43 2.992 2.992 0 0 0 .836-2.078c0-.807-.319-1.54-.836-2.078a24.65 24.65 0 0 0-1.415-6.43.75.75 0 1 0-1.409.516c.059.16.116.321.17.483Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.161 2.58a1.875 1.875 0 0 1 1.678 0l4.993 2.498c.106.052.23.052.336 0l3.869-1.935A1.875 1.875 0 0 1 21.75 4.82v12.485c0 .71-.401 1.36-1.037 1.677l-4.875 2.437a1.875 1.875 0 0 1-1.676 0l-4.994-2.497a.375.375 0 0 0-.336 0l-3.868 1.935A1.875 1.875 0 0 1 2.25 19.18V6.695c0-.71.401-1.36 1.036-1.677l4.875-2.437ZM9 6a.75.75 0 0 1 .75.75V15a.75.75 0 0 1-1.5 0V6.75A.75.75 0 0 1 9 6Zm6.75 3a.75.75 0 0 0-1.5 0v8.25a.75.75 0 0 0 1.5 0V9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMapPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMagnifyingGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMagnifyingGlassPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Zm8.25-3.75a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25v2.25a.75.75 0 0 1-1.5 0v-2.25H7.5a.75.75 0 0 1 0-1.5h2.25V7.5a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMagnifyingGlassMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Zm4.5 0a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMagnifyingGlassCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.25 10.875a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.125 4.5a4.125 4.125 0 1 0 2.338 7.524l2.007 2.006a.75.75 0 1 0 1.06-1.06l-2.006-2.007a4.125 4.125 0 0 0-3.399-6.463Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLockOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLockClosed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiListBullet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.625 6.75a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0A.75.75 0 0 1 8.25 6h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM2.625 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.5 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 12Zm-4.875 5.25a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.902 4.098a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.037.75.75 0 0 1-.646 1.353 5.25 5.25 0 0 1-1.449-8.45l4.5-4.5a5.25 5.25 0 1 1 7.424 7.424l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.757-1.757a3.75 3.75 0 0 0 0-5.304Zm-7.389 4.267a.75.75 0 0 1 1-.353 5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 1 1-7.424-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.757a3.75 3.75 0 1 0 5.304 5.304l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037.75.75 0 0 1-.354-1Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLinkSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.892 4.09a3.75 3.75 0 0 0-5.303 0l-4.5 4.5c-.074.074-.144.15-.21.229l4.965 4.966a3.75 3.75 0 0 0-1.986-4.428.75.75 0 0 1 .646-1.353 5.253 5.253 0 0 1 2.502 6.944l5.515 5.515a.75.75 0 0 1-1.061 1.06l-18-18.001A.75.75 0 0 1 3.521 2.46l5.294 5.295a5.31 5.31 0 0 1 .213-.227l4.5-4.5a5.25 5.25 0 1 1 7.425 7.425l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.756-1.757a3.75 3.75 0 0 0 0-5.304ZM5.846 11.773a.75.75 0 0 1 0 1.06l-1.757 1.758a3.75 3.75 0 0 0 5.303 5.304l3.129-3.13a.75.75 0 1 1 1.06 1.061l-3.128 3.13a5.25 5.25 0 1 1-7.425-7.426l1.757-1.757a.75.75 0 0 1 1.061 0Zm2.401.26a.75.75 0 0 1 .957.458c.18.512.474.992.885 1.403.31.311.661.555 1.035.733a.75.75 0 0 1-.647 1.354 5.244 5.244 0 0 1-1.449-1.026 5.232 5.232 0 0 1-1.24-1.965.75.75 0 0 1 .46-.957Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLightBulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 .75a8.25 8.25 0 0 0-4.135 15.39c.686.398 1.115 1.008 1.134 1.623a.75.75 0 0 0 .577.706c.352.083.71.148 1.074.195.323.041.6-.218.6-.544v-4.661a6.714 6.714 0 0 1-.937-.171.75.75 0 1 1 .374-1.453 5.261 5.261 0 0 0 2.626 0 .75.75 0 1 1 .374 1.452 6.712 6.712 0 0 1-.937.172v4.66c0 .327.277.586.6.545.364-.047.722-.112 1.074-.195a.75.75 0 0 0 .577-.706c.02-.615.448-1.225 1.134-1.623A8.25 8.25 0 0 0 12 .75Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.013 19.9a.75.75 0 0 1 .877-.597 11.319 11.319 0 0 0 4.22 0 .75.75 0 1 1 .28 1.473 12.819 12.819 0 0 1-4.78 0 .75.75 0 0 1-.597-.876ZM9.754 22.344a.75.75 0 0 1 .824-.668 13.682 13.682 0 0 0 2.844 0 .75.75 0 1 1 .156 1.492 15.156 15.156 0 0 1-3.156 0 .75.75 0 0 1-.668-.824Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLifebuoy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.449 8.448 16.388 11a4.52 4.52 0 0 1 0 2.002l3.061 2.55a8.275 8.275 0 0 0 0-7.103ZM15.552 19.45 13 16.388a4.52 4.52 0 0 1-2.002 0l-2.55 3.061a8.275 8.275 0 0 0 7.103 0ZM4.55 15.552 7.612 13a4.52 4.52 0 0 1 0-2.002L4.551 8.45a8.275 8.275 0 0 0 0 7.103ZM8.448 4.55 11 7.612a4.52 4.52 0 0 1 2.002 0l2.55-3.061a8.275 8.275 0 0 0-7.103 0Zm8.657-.86a9.776 9.776 0 0 1 1.79 1.415 9.776 9.776 0 0 1 1.414 1.788 9.764 9.764 0 0 1 0 10.211 9.777 9.777 0 0 1-1.415 1.79 9.777 9.777 0 0 1-1.788 1.414 9.764 9.764 0 0 1-10.212 0 9.776 9.776 0 0 1-1.788-1.415 9.776 9.776 0 0 1-1.415-1.788 9.764 9.764 0 0 1 0-10.212 9.774 9.774 0 0 1 1.415-1.788A9.774 9.774 0 0 1 6.894 3.69a9.764 9.764 0 0 1 10.211 0ZM14.121 9.88a2.985 2.985 0 0 0-1.11-.704 3.015 3.015 0 0 0-2.022 0 2.985 2.985 0 0 0-1.11.704c-.326.325-.56.705-.704 1.11a3.015 3.015 0 0 0 0 2.022c.144.405.378.785.704 1.11.325.326.705.56 1.11.704.652.233 1.37.233 2.022 0a2.985 2.985 0 0 0 1.11-.704c.326-.325.56-.705.704-1.11a3.016 3.016 0 0 0 0-2.022 2.985 2.985 0 0 0-.704-1.11Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiLanguage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 2.25a.75.75 0 0 1 .75.75v1.506a49.384 49.384 0 0 1 5.343.371.75.75 0 1 1-.186 1.489c-.66-.083-1.323-.151-1.99-.206a18.67 18.67 0 0 1-2.97 6.323c.318.384.65.753 1 1.107a.75.75 0 0 1-1.07 1.052A18.902 18.902 0 0 1 9 13.687a18.823 18.823 0 0 1-5.656 4.482.75.75 0 0 1-.688-1.333 17.323 17.323 0 0 0 5.396-4.353A18.72 18.72 0 0 1 5.89 8.598a.75.75 0 0 1 1.388-.568A17.21 17.21 0 0 0 9 11.224a17.168 17.168 0 0 0 2.391-5.165 48.04 48.04 0 0 0-8.298.307.75.75 0 0 1-.186-1.489 49.159 49.159 0 0 1 5.343-.371V3A.75.75 0 0 1 9 2.25ZM15.75 9a.75.75 0 0 1 .68.433l5.25 11.25a.75.75 0 1 1-1.36.634l-1.198-2.567h-6.744l-1.198 2.567a.75.75 0 0 1-1.36-.634l5.25-11.25A.75.75 0 0 1 15.75 9Zm-2.672 8.25h5.344l-2.672-5.726-2.672 5.726Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.75 1.5a6.75 6.75 0 0 0-6.651 7.906c.067.39-.032.717-.221.906l-6.5 6.499a3 3 0 0 0-.878 2.121v2.818c0 .414.336.75.75.75H6a.75.75 0 0 0 .75-.75v-1.5h1.5A.75.75 0 0 0 9 19.5V18h1.5a.75.75 0 0 0 .53-.22l2.658-2.658c.19-.189.517-.288.906-.22A6.75 6.75 0 1 0 15.75 1.5Zm0 3a.75.75 0 0 0 0 1.5A2.25 2.25 0 0 1 18 8.25a.75.75 0 0 0 1.5 0 3.75 3.75 0 0 0-3.75-3.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiItalic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.497 3.744a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-3.275l-5.357 15.002h2.632a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 1 1 0-1.5h3.275l5.357-15.002h-2.632a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiInformationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiInbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.912 3a3 3 0 0 0-2.868 2.118l-2.411 7.838a3 3 0 0 0-.133.882V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-4.162c0-.299-.045-.596-.133-.882l-2.412-7.838A3 3 0 0 0 17.088 3H6.912Zm13.823 9.75-2.213-7.191A1.5 1.5 0 0 0 17.088 4.5H6.912a1.5 1.5 0 0 0-1.434 1.059L3.265 12.75H6.11a3 3 0 0 1 2.684 1.658l.256.513a1.5 1.5 0 0 0 1.342.829h3.218a1.5 1.5 0 0 0 1.342-.83l.256-.512a3 3 0 0 1 2.684-1.658h2.844Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiInboxStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 9.832v1.793c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875V9.832a3 3 0 0 0-.722-1.952l-3.285-3.832A3 3 0 0 0 16.215 3h-8.43a3 3 0 0 0-2.278 1.048L2.222 7.88A3 3 0 0 0 1.5 9.832ZM7.785 4.5a1.5 1.5 0 0 0-1.139.524L3.881 8.25h3.165a3 3 0 0 1 2.496 1.336l.164.246a1.5 1.5 0 0 0 1.248.668h2.092a1.5 1.5 0 0 0 1.248-.668l.164-.246a3 3 0 0 1 2.496-1.336h3.165l-2.765-3.226a1.5 1.5 0 0 0-1.139-.524h-8.43Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.813 15c-.725 0-1.313.588-1.313 1.313V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-1.688c0-.724-.588-1.312-1.313-1.312h-4.233a3 3 0 0 0-2.496 1.336l-.164.246a1.5 1.5 0 0 1-1.248.668h-2.092a1.5 1.5 0 0 1-1.248-.668l-.164-.246A3 3 0 0 0 7.046 15H2.812Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiInboxArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.478 5.559A1.5 1.5 0 0 1 6.912 4.5H9A.75.75 0 0 0 9 3H6.912a3 3 0 0 0-2.868 2.118l-2.411 7.838a3 3 0 0 0-.133.882V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-4.162c0-.299-.045-.596-.133-.882l-2.412-7.838A3 3 0 0 0 17.088 3H15a.75.75 0 0 0 0 1.5h2.088a1.5 1.5 0 0 1 1.434 1.059l2.213 7.191H17.89a3 3 0 0 0-2.684 1.658l-.256.513a1.5 1.5 0 0 1-1.342.829h-3.218a1.5 1.5 0 0 1-1.342-.83l-.256-.512a3 3 0 0 0-2.684-1.658H3.265l2.213-7.191Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25a.75.75 0 0 1 .75.75v6.44l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l1.72 1.72V3a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiIdentification(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 3.75a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-15Zm4.125 3a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm-3.873 8.703a4.126 4.126 0 0 1 7.746 0 .75.75 0 0 1-.351.92 7.47 7.47 0 0 1-3.522.877 7.47 7.47 0 0 1-3.522-.877.75.75 0 0 1-.351-.92ZM15 8.25a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5H15ZM14.25 12a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5H15Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHomeModern(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.006 3.705a.75.75 0 1 0-.512-1.41L6 6.838V3a.75.75 0 0 0-.75-.75h-1.5A.75.75 0 0 0 3 3v4.93l-1.006.365a.75.75 0 0 0 .512 1.41l16.5-6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.019 11.114 18 5.667v3.421l4.006 1.457a.75.75 0 1 1-.512 1.41l-.494-.18v8.475h.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5H3v-9.129l.019-.007ZM18 20.25v-9.566l1.5.546v9.02H18Zm-9-6a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75V15a.75.75 0 0 0-.75-.75H9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHashtag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.097 1.515a.75.75 0 0 1 .589.882L10.666 7.5h4.47l1.079-5.397a.75.75 0 1 1 1.47.294L16.665 7.5h3.585a.75.75 0 0 1 0 1.5h-3.885l-1.2 6h3.585a.75.75 0 0 1 0 1.5h-3.885l-1.08 5.397a.75.75 0 1 1-1.47-.294l1.02-5.103h-4.47l-1.08 5.397a.75.75 0 1 1-1.47-.294l1.02-5.103H3.75a.75.75 0 0 1 0-1.5h3.885l1.2-6H5.25a.75.75 0 0 1 0-1.5h3.885l1.08-5.397a.75.75 0 0 1 .882-.588ZM10.365 9l-1.2 6h4.47l1.2-6h-4.47Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHandThumbUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.493 18.5c-.425 0-.82-.236-.975-.632A7.48 7.48 0 0 1 6 15.125c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75A.75.75 0 0 1 15 2a2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23h-.777ZM2.331 10.727a11.969 11.969 0 0 0-.831 4.398 12 12 0 0 0 .52 3.507C2.28 19.482 3.105 20 3.994 20H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 0 1-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHandThumbDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 5.5h1.035A7.465 7.465 0 0 1 18 9.625a7.465 7.465 0 0 1-1.235 4.125h-.148c-.806 0-1.534.446-2.031 1.08a9.04 9.04 0 0 1-2.861 2.4c-.723.384-1.35.956-1.653 1.715a4.499 4.499 0 0 0-.322 1.672v.633A.75.75 0 0 1 9 22a2.25 2.25 0 0 1-2.25-2.25c0-1.152.26-2.243.723-3.218.266-.558-.107-1.282-.725-1.282H3.622c-1.026 0-1.945-.694-2.054-1.715A12.137 12.137 0 0 1 1.5 12.25c0-2.848.992-5.464 2.649-7.521C4.537 4.247 5.136 4 5.754 4H9.77a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23ZM21.669 14.023c.536-1.362.831-2.845.831-4.398 0-1.22-.182-2.398-.52-3.507-.26-.85-1.084-1.368-1.973-1.368H19.1c-.445 0-.72.498-.523.898.591 1.2.924 2.55.924 3.977a8.958 8.958 0 0 1-1.302 4.666c-.245.403.028.959.5.959h1.053c.832 0 1.612-.453 1.918-1.227Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiHandRaised(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 1.875a1.125 1.125 0 0 1 2.25 0v8.219c.517.162 1.02.382 1.5.659V3.375a1.125 1.125 0 0 1 2.25 0v10.937a4.505 4.505 0 0 0-3.25 2.373 8.963 8.963 0 0 1 4-.935A.75.75 0 0 0 18 15v-2.266a3.368 3.368 0 0 1 .988-2.37 1.125 1.125 0 0 1 1.591 1.59 1.118 1.118 0 0 0-.329.79v3.006h-.005a6 6 0 0 1-1.752 4.007l-1.736 1.736a6 6 0 0 1-4.242 1.757H10.5a7.5 7.5 0 0 1-7.5-7.5V6.375a1.125 1.125 0 0 1 2.25 0v5.519c.46-.452.965-.832 1.5-1.141V3.375a1.125 1.125 0 0 1 2.25 0v6.526c.495-.1.997-.151 1.5-.151V1.875Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiH3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.749 3.743a.75.75 0 0 1 .75.75v15.002a.75.75 0 1 1-1.5 0v-6.75H2.997v6.75a.75.75 0 0 1-1.5 0V4.494a.75.75 0 1 1 1.5 0v6.75H12v-6.75a.75.75 0 0 1 .75-.75ZM18.75 10.5c-.727 0-1.441.055-2.139.16a.75.75 0 1 1-.223-1.483 15.87 15.87 0 0 1 3.82-.11c.95.088 1.926.705 2.168 1.794a5.265 5.265 0 0 1-.579 3.765 5.265 5.265 0 0 1 .578 3.765c-.24 1.088-1.216 1.706-2.167 1.793a15.942 15.942 0 0 1-3.82-.109.75.75 0 0 1 .223-1.483 14.366 14.366 0 0 0 3.46.099c.467-.043.773-.322.84-.624a3.768 3.768 0 0 0-.413-2.691H18a.75.75 0 0 1 0-1.5h2.498a3.768 3.768 0 0 0 .413-2.69c-.067-.303-.373-.582-.84-.625-.435-.04-.876-.06-1.321-.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiH2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.246 3.743a.75.75 0 0 1 .75.75v6.75h9v-6.75a.75.75 0 0 1 1.5 0v15.002a.75.75 0 1 1-1.5 0v-6.751h-9v6.75a.75.75 0 1 1-1.5 0v-15a.75.75 0 0 1 .75-.75ZM18.75 10.5c-.727 0-1.441.054-2.138.16a.75.75 0 1 1-.223-1.484 15.867 15.867 0 0 1 3.635-.125c1.149.092 2.153.923 2.348 2.115.084.516.128 1.045.128 1.584 0 1.065-.676 1.927-1.531 2.354l-2.89 1.445a1.5 1.5 0 0 0-.829 1.342v.86h4.5a.75.75 0 1 1 0 1.5H16.5a.75.75 0 0 1-.75-.75v-1.61a3 3 0 0 1 1.659-2.684l2.89-1.445c.447-.223.701-.62.701-1.012a8.32 8.32 0 0 0-.108-1.342c-.075-.457-.47-.82-.987-.862a14.45 14.45 0 0 0-1.155-.046Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiH1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.243 3.743a.75.75 0 0 1 .75.75v6.75h9v-6.75a.75.75 0 1 1 1.5 0v15.002a.75.75 0 1 1-1.5 0v-6.751h-9v6.75a.75.75 0 1 1-1.5 0v-15a.75.75 0 0 1 .75-.75Zm17.605 4.964a.75.75 0 0 1 .396.661v9.376h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5V10.77l-1.084.722a.75.75 0 1 1-.832-1.248l2.25-1.5a.75.75 0 0 1 .77-.037Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiGlobeEuropeAfrica(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM8.547 4.505a8.25 8.25 0 1 0 11.672 8.214l-.46-.46a2.252 2.252 0 0 1-.422-.586l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.211.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.654-.261a2.25 2.25 0 0 1-1.384-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.279-2.132Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiGlobeAsiaAustralia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.75 8.25a.75.75 0 0 1 .75.75c0 1.12-.492 2.126-1.27 2.812a.75.75 0 1 1-.992-1.124A2.243 2.243 0 0 0 15 9a.75.75 0 0 1 .75-.75Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM4.575 15.6a8.25 8.25 0 0 0 9.348 4.425 1.966 1.966 0 0 0-1.84-1.275.983.983 0 0 1-.97-.822l-.073-.437c-.094-.565.25-1.11.8-1.267l.99-.282c.427-.123.783-.418.982-.816l.036-.073a1.453 1.453 0 0 1 2.328-.377L16.5 15h.628a2.25 2.25 0 0 1 1.983 1.186 8.25 8.25 0 0 0-6.345-12.4c.044.262.18.503.389.676l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.575 15.6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiGlobeAmericas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM6.262 6.072a8.25 8.25 0 1 0 10.562-.766 4.5 4.5 0 0 1-1.318 1.357L14.25 7.5l.165.33a.809.809 0 0 1-1.086 1.085l-.604-.302a1.125 1.125 0 0 0-1.298.21l-.132.131c-.439.44-.439 1.152 0 1.591l.296.296c.256.257.622.374.98.314l1.17-.195c.323-.054.654.036.905.245l1.33 1.108c.32.267.46.694.358 1.1a8.7 8.7 0 0 1-2.288 4.04l-.723.724a1.125 1.125 0 0 1-1.298.21l-.153-.076a1.125 1.125 0 0 1-.622-1.006v-1.089c0-.298-.119-.585-.33-.796l-1.347-1.347a1.125 1.125 0 0 1-.21-1.298L9.75 12l-1.64-1.64a6 6 0 0 1-1.676-3.257l-.172-1.03Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiGlobeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.721 12.752a9.711 9.711 0 0 0-.945-5.003 12.754 12.754 0 0 1-4.339 2.708 18.991 18.991 0 0 1-.214 4.772 17.165 17.165 0 0 0 5.498-2.477ZM14.634 15.55a17.324 17.324 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 0 0 .332 4.647 17.385 17.385 0 0 0 5.268 0ZM9.772 17.119a18.963 18.963 0 0 0 4.456 0A17.182 17.182 0 0 1 12 21.724a17.18 17.18 0 0 1-2.228-4.605ZM7.777 15.23a18.87 18.87 0 0 1-.214-4.774 12.753 12.753 0 0 1-4.34-2.708 9.711 9.711 0 0 0-.944 5.004 17.165 17.165 0 0 0 5.498 2.477ZM21.356 14.752a9.765 9.765 0 0 1-7.478 6.817 18.64 18.64 0 0 0 1.988-4.718 18.627 18.627 0 0 0 5.49-2.098ZM2.644 14.752c1.682.971 3.53 1.688 5.49 2.099a18.64 18.64 0 0 0 1.988 4.718 9.765 9.765 0 0 1-7.478-6.816ZM13.878 2.43a9.755 9.755 0 0 1 6.116 3.986 11.267 11.267 0 0 1-3.746 2.504 18.63 18.63 0 0 0-2.37-6.49ZM12 2.276a17.152 17.152 0 0 1 2.805 7.121c-.897.23-1.837.353-2.805.353-.968 0-1.908-.122-2.805-.353A17.151 17.151 0 0 1 12 2.276ZM10.122 2.43a18.629 18.629 0 0 0-2.37 6.49 11.266 11.266 0 0 1-3.746-2.504 9.754 9.754 0 0 1 6.116-3.985Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3.255a1.875 1.875 0 1 0 0 3.75h1.875v4.5H3A1.875 1.875 0 0 1 1.125 9.63v-.75c0-1.036.84-1.875 1.875-1.875h3.193a3.375 3.375 0 0 1 5.432-3.997 3.375 3.375 0 0 1 5.432 3.997H21c1.035 0 1.875.84 1.875 1.875v.75c0 1.035-.84 1.875-1.875 1.875h-8.625v-4.5h1.875a1.875 1.875 0 1 0-1.875-1.875v1.875h-1.5V5.13c0-1.036-.84-1.875-1.875-1.875ZM10.875 13.005h-8.25v6.75a2.25 2.25 0 0 0 2.25 2.25h6v-9ZM12.375 13.005v9h6.75a2.25 2.25 0 0 0 2.25-2.25v-6.75h-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiGiftTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 3v4.046a3 3 0 0 0-4.277 4.204H1.5v-6A2.25 2.25 0 0 1 3.75 3h7.5ZM12.75 3v4.011a3 3 0 0 1 4.239 4.239H22.5v-6A2.25 2.25 0 0 0 20.25 3h-7.5ZM22.5 12.75h-8.983a4.125 4.125 0 0 0 4.108 3.75.75.75 0 0 1 0 1.5 5.623 5.623 0 0 1-4.875-2.817V21h7.5a2.25 2.25 0 0 0 2.25-2.25v-6ZM11.25 21v-5.817A5.623 5.623 0 0 1 6.375 18a.75.75 0 0 1 0-1.5 4.126 4.126 0 0 0 4.108-3.75H1.5v6A2.25 2.25 0 0 0 3.75 21h7.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.085 10.354c.03.297.038.575.036.805a7.484 7.484 0 0 1-.805-.036c-.833-.084-1.677-.325-2.195-.843a1.5 1.5 0 0 1 2.122-2.12c.517.517.759 1.36.842 2.194ZM12.877 10.354c-.03.297-.038.575-.036.805.23.002.508-.006.805-.036.833-.084 1.677-.325 2.195-.843A1.5 1.5 0 0 0 13.72 8.16c-.518.518-.76 1.362-.843 2.194Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiGif(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 3.75a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-15Zm9 4.5a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0v-7.5Zm1.5 0a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H16.5v2.25H18a.75.75 0 0 1 0 1.5h-1.5v3a.75.75 0 0 1-1.5 0v-7.5ZM6.636 9.78c.404-.575.867-.78 1.25-.78s.846.205 1.25.78a.75.75 0 0 0 1.228-.863C9.738 8.027 8.853 7.5 7.886 7.5c-.966 0-1.852.527-2.478 1.417-.62.882-.908 2-.908 3.083 0 1.083.288 2.201.909 3.083.625.89 1.51 1.417 2.477 1.417.967 0 1.852-.527 2.478-1.417a.75.75 0 0 0 .136-.431V12a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0 0 1.5H9v1.648c-.37.44-.774.602-1.114.602-.383 0-.846-.205-1.25-.78C6.226 13.638 6 12.837 6 12c0-.837.226-1.638.636-2.22Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFunnel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.792 2.938A49.069 49.069 0 0 1 12 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 0 1 1.541 1.836v1.044a3 3 0 0 1-.879 2.121l-6.182 6.182a1.5 1.5 0 0 0-.439 1.061v2.927a3 3 0 0 1-1.658 2.684l-1.757.878A.75.75 0 0 1 9.75 21v-5.818a1.5 1.5 0 0 0-.44-1.06L3.13 7.938a3 3 0 0 1-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.055 7.06C3.805 6.347 2.25 7.25 2.25 8.69v8.122c0 1.44 1.555 2.343 2.805 1.628L12 14.471v2.34c0 1.44 1.555 2.343 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256l-7.108-4.061C13.555 6.346 12 7.249 12 8.689v2.34L5.055 7.061Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 21a3 3 0 0 0 3-3v-4.5a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h15ZM1.5 10.146V6a3 3 0 0 1 3-3h5.379a2.25 2.25 0 0 1 1.59.659l2.122 2.121c.14.141.331.22.53.22H19.5a3 3 0 0 1 3 3v1.146A4.483 4.483 0 0 0 19.5 9h-15a4.483 4.483 0 0 0-3 1.146Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFolderPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15Zm-6.75-10.5a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V10.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.906 9c.382 0 .749.057 1.094.162V9a3 3 0 0 0-3-3h-3.879a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H6a3 3 0 0 0-3 3v3.162A3.756 3.756 0 0 1 4.094 9h15.812ZM4.094 10.5a2.25 2.25 0 0 0-2.227 2.568l.857 6A2.25 2.25 0 0 0 4.951 21H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-2.227-2.568H4.094Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFolderMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15ZM9 12.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFolderArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15Zm-6.75-10.5a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V10.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 2.25a.75.75 0 0 1 .75.75v.54l1.838-.46a9.75 9.75 0 0 1 6.725.738l.108.054A8.25 8.25 0 0 0 18 4.524l3.11-.732a.75.75 0 0 1 .917.81 47.784 47.784 0 0 0 .005 10.337.75.75 0 0 1-.574.812l-3.114.733a9.75 9.75 0 0 1-6.594-.77l-.108-.054a8.25 8.25 0 0 0-5.69-.625l-2.202.55V21a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 3 2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.963 2.286a.75.75 0 0 0-1.071-.136 9.742 9.742 0 0 0-3.539 6.176 7.547 7.547 0 0 1-1.705-1.715.75.75 0 0 0-1.152-.082A9 9 0 1 0 15.68 4.534a7.46 7.46 0 0 1-2.717-2.248ZM15.75 14.25a3.75 3.75 0 1 1-7.313-1.172c.628.465 1.35.81 2.133 1a5.99 5.99 0 0 1 1.925-3.546 3.75 3.75 0 0 1 3.255 3.718Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFingerPrint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 3.75a6.715 6.715 0 0 0-3.722 1.118.75.75 0 1 1-.828-1.25 8.25 8.25 0 0 1 12.8 6.883c0 3.014-.574 5.897-1.62 8.543a.75.75 0 0 1-1.395-.551A21.69 21.69 0 0 0 18.75 10.5 6.75 6.75 0 0 0 12 3.75ZM6.157 5.739a.75.75 0 0 1 .21 1.04A6.715 6.715 0 0 0 5.25 10.5c0 1.613-.463 3.12-1.265 4.393a.75.75 0 0 1-1.27-.8A6.715 6.715 0 0 0 3.75 10.5c0-1.68.503-3.246 1.367-4.55a.75.75 0 0 1 1.04-.211ZM12 7.5a3 3 0 0 0-3 3c0 3.1-1.176 5.927-3.105 8.056a.75.75 0 1 1-1.112-1.008A10.459 10.459 0 0 0 7.5 10.5a4.5 4.5 0 1 1 9 0c0 .547-.022 1.09-.067 1.626a.75.75 0 0 1-1.495-.123c.041-.495.062-.996.062-1.503a3 3 0 0 0-3-3Zm0 2.25a.75.75 0 0 1 .75.75c0 3.908-1.424 7.485-3.781 10.238a.75.75 0 0 1-1.14-.975A14.19 14.19 0 0 0 11.25 10.5a.75.75 0 0 1 .75-.75Zm3.239 5.183a.75.75 0 0 1 .515.927 19.417 19.417 0 0 1-2.585 5.544.75.75 0 0 1-1.243-.84 17.915 17.915 0 0 0 2.386-5.116.75.75 0 0 1 .927-.515Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625Zm1.5 0v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5A.375.375 0 0 0 3 5.625Zm16.125-.375a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5A.375.375 0 0 0 21 7.125v-1.5a.375.375 0 0 0-.375-.375h-1.5ZM21 9.375A.375.375 0 0 0 20.625 9h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5ZM4.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5ZM3.375 15h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h1.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 4.875 9h-1.5A.375.375 0 0 0 3 9.375v1.5c0 .207.168.375.375.375Zm4.125 0a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFaceSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 0 0-.189.866c0 .298.059.605.189.866.108.215.395.634.936.634.54 0 .828-.419.936-.634.13-.26.189-.568.189-.866 0-.298-.059-.605-.189-.866-.108-.215-.395-.634-.936-.634Zm4.314.634c.108-.215.395-.634.936-.634.54 0 .828.419.936.634.13.26.189.568.189.866 0 .298-.059.605-.189.866-.108.215-.395.634-.936.634-.54 0-.828-.419-.936-.634a1.96 1.96 0 0 1-.189-.866c0-.298.059-.605.189-.866Zm2.023 6.828a.75.75 0 1 0-1.06-1.06 3.75 3.75 0 0 1-5.304 0 .75.75 0 0 0-1.06 1.06 5.25 5.25 0 0 0 7.424 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiFaceFrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 0 0-.189.866c0 .298.059.605.189.866.108.215.395.634.936.634.54 0 .828-.419.936-.634.13-.26.189-.568.189-.866 0-.298-.059-.605-.189-.866-.108-.215-.395-.634-.936-.634Zm4.314.634c.108-.215.395-.634.936-.634.54 0 .828.419.936.634.13.26.189.568.189.866 0 .298-.059.605-.189.866-.108.215-.395.634-.936.634-.54 0-.828-.419-.936-.634a1.96 1.96 0 0 1-.189-.866c0-.298.059-.605.189-.866Zm-4.34 7.964a.75.75 0 0 1-1.061-1.06 5.236 5.236 0 0 1 3.73-1.538 5.236 5.236 0 0 1 3.695 1.538.75.75 0 1 1-1.061 1.06 3.736 3.736 0 0 0-2.639-1.098 3.736 3.736 0 0 0-2.664 1.098Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEyeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEyeDropper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.098 2.598a3.75 3.75 0 1 1 3.622 6.275l-1.72.46V12a.75.75 0 0 1-.22.53l-.75.75a.75.75 0 0 1-1.06 0l-.97-.97-7.94 7.94a2.56 2.56 0 0 1-1.81.75 1.06 1.06 0 0 0-.75.31l-.97.97a.75.75 0 0 1-1.06 0l-.75-.75a.75.75 0 0 1 0-1.06l.97-.97a1.06 1.06 0 0 0 .31-.75c0-.68.27-1.33.75-1.81L11.69 9l-.97-.97a.75.75 0 0 1 0-1.06l.75-.75A.75.75 0 0 1 12 6h2.666l.461-1.72c.165-.617.49-1.2.971-1.682Zm-3.348 7.463L4.81 18a1.06 1.06 0 0 0-.31.75c0 .318-.06.63-.172.922a2.56 2.56 0 0 1 .922-.172c.281 0 .551-.112.75-.31l7.94-7.94-1.19-1.19Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiExclamationTriangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiExclamationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEquals(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.748 8.248a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75ZM3.748 15.75a.75.75 0 0 1 .75-.751h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 22.5a3 3 0 0 0 3-3v-8.174l-6.879 4.022 3.485 1.876a.75.75 0 1 1-.712 1.321l-5.683-3.06a1.5 1.5 0 0 0-1.422 0l-5.683 3.06a.75.75 0 0 1-.712-1.32l3.485-1.877L1.5 11.326V19.5a3 3 0 0 0 3 3h15Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 9.589v-.745a3 3 0 0 1 1.578-2.642l7.5-4.038a3 3 0 0 1 2.844 0l7.5 4.038A3 3 0 0 1 22.5 8.844v.745l-8.426 4.926-.652-.351a3 3 0 0 0-2.844 0l-.652.351L1.5 9.589Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEllipsisVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEllipsisHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiEllipsisHorizontalCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm0 8.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM15.375 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.5 10.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625ZM7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM9.75 14.25a.75.75 0 0 0 0 1.5H15a.75.75 0 0 0 0-1.5H9.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentMagnifyingGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentDuplicate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 0 1 3.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0 1 21 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 0 1 7.5 16.125V3.375Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 17.25 7.5h-1.875A.375.375 0 0 1 15 7.125V5.25ZM4.875 6H6v10.125A3.375 3.375 0 0 0 9.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V7.875C3 6.839 3.84 6 4.875 6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentCurrencyYen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-3.9 5.55a.75.75 0 0 0-1.2.9l1.912 2.55H9.75a.75.75 0 0 0 0 1.5h1.5v.75h-1.5a.75.75 0 0 0 0 1.5h1.5v.75a.75.75 0 1 0 1.5 0V18h1.5a.75.75 0 1 0 0-1.5h-1.5v-.75h1.5a.75.75 0 1 0 0-1.5h-1.313l1.913-2.55a.75.75 0 1 0-1.2-.9L12 13l-1.65-2.2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentCurrencyRupee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-4.5 5.25a.75.75 0 0 0 0 1.5h.375c.769 0 1.43.463 1.719 1.125H9.75a.75.75 0 0 0 0 1.5h2.094a1.875 1.875 0 0 1-1.719 1.125H9.75a.75.75 0 0 0-.53 1.28l2.25 2.25a.75.75 0 0 0 1.06-1.06l-1.193-1.194a3.382 3.382 0 0 0 2.08-2.401h.833a.75.75 0 0 0 0-1.5h-.834A3.357 3.357 0 0 0 12.932 12h1.318a.75.75 0 0 0 0-1.5H10.5c-.04 0-.08.003-.12.01a3.425 3.425 0 0 0-.255-.01H9.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentCurrencyPound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-3.674 9.583a2.249 2.249 0 0 1 3.765-2.174.75.75 0 0 0 1.06-1.06A3.75 3.75 0 0 0 9.076 15H8.25a.75.75 0 0 0 0 1.5h1.156a3.75 3.75 0 0 1-.206 1.559l-.156.439a.75.75 0 0 0 1.042.923l.439-.22a2.113 2.113 0 0 1 1.613-.115 3.613 3.613 0 0 0 2.758-.196l.44-.22a.75.75 0 1 0-.671-1.341l-.44.22a2.113 2.113 0 0 1-1.613.114 3.612 3.612 0 0 0-1.745-.134c.048-.341.062-.686.042-1.029H12a.75.75 0 0 0 0-1.5h-1.379l-.045-.167Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentCurrencyEuro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm7.464 9.442c.459-.573 1.019-.817 1.536-.817.517 0 1.077.244 1.536.817a.75.75 0 1 0 1.171-.937c-.713-.892-1.689-1.38-2.707-1.38-1.018 0-1.994.488-2.707 1.38a4.61 4.61 0 0 0-.705 1.245H8.25a.75.75 0 0 0 0 1.5h.763c-.017.25-.017.5 0 .75H8.25a.75.75 0 0 0 0 1.5h1.088c.17.449.406.87.705 1.245.713.892 1.689 1.38 2.707 1.38 1.018 0 1.994-.488 2.707-1.38a.75.75 0 0 0-1.171-.937c-.459.573-1.019.817-1.536.817-.517 0-1.077-.244-1.536-.817-.078-.098-.15-.2-.215-.308h1.751a.75.75 0 0 0 0-1.5h-2.232a3.965 3.965 0 0 1 0-.75h2.232a.75.75 0 0 0 0-1.5H11c.065-.107.136-.21.214-.308Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentCurrencyDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25ZM12 10.5a.75.75 0 0 1 .75.75v.028a9.727 9.727 0 0 1 1.687.28.75.75 0 1 1-.374 1.452 8.207 8.207 0 0 0-1.313-.226v1.68l.969.332c.67.23 1.281.85 1.281 1.704 0 .158-.007.314-.02.468-.083.931-.83 1.582-1.669 1.695a9.776 9.776 0 0 1-.561.059v.028a.75.75 0 0 1-1.5 0v-.029a9.724 9.724 0 0 1-1.687-.278.75.75 0 0 1 .374-1.453c.425.11.864.186 1.313.226v-1.68l-.968-.332C9.612 14.974 9 14.354 9 13.5c0-.158.007-.314.02-.468.083-.931.831-1.582 1.67-1.694.185-.025.372-.045.56-.06v-.028a.75.75 0 0 1 .75-.75Zm-1.11 2.324c.119-.016.239-.03.36-.04v1.166l-.482-.165c-.208-.072-.268-.211-.268-.285 0-.113.005-.225.015-.336.013-.146.14-.309.374-.34Zm1.86 4.392V16.05l.482.165c.208.072.268.211.268.285 0 .113-.005.225-.015.336-.012.146-.14.309-.374.34-.12.016-.24.03-.361.04Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentCurrencyBangladeshi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-3.75 5.56c0-1.336-1.616-2.005-2.56-1.06l-.22.22a.75.75 0 0 0 1.06 1.06l.22-.22v1.94h-.75a.75.75 0 0 0 0 1.5H9v3c0 .671.307 1.453 1.068 1.815a4.5 4.5 0 0 0 5.993-2.123c.233-.487.14-1-.136-1.37A1.459 1.459 0 0 0 14.757 15h-.507a.75.75 0 0 0 0 1.5h.349a2.999 2.999 0 0 1-3.887 1.21c-.091-.043-.212-.186-.212-.46v-3h5.25a.75.75 0 1 0 0-1.5H10.5v-1.94Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM9.75 17.25a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-.75Zm2.25-3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Zm3.75-1.5a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-5.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6.905 9.97a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72V18a.75.75 0 0 0 1.5 0v-4.19l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDocumentArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm5.845 17.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V12a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDivide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.874 5.248a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm-7.125 6.75a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Zm7.125 6.753a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDeviceTablet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 18a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.125 1.5A3.375 3.375 0 0 0 3.75 4.875v14.25A3.375 3.375 0 0 0 7.125 22.5h9.75a3.375 3.375 0 0 0 3.375-3.375V4.875A3.375 3.375 0 0 0 16.875 1.5h-9.75ZM6 4.875c0-.621.504-1.125 1.125-1.125h9.75c.621 0 1.125.504 1.125 1.125v14.25c0 .621-.504 1.125-1.125 1.125h-9.75A1.125 1.125 0 0 1 6 19.125V4.875Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiDevicePhoneMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 18.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.625.75A3.375 3.375 0 0 0 5.25 4.125v15.75a3.375 3.375 0 0 0 3.375 3.375h6.75a3.375 3.375 0 0 0 3.375-3.375V4.125A3.375 3.375 0 0 0 15.375.75h-6.75ZM7.5 4.125C7.5 3.504 8.004 3 8.625 3H9.75v.375c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125V3h1.125c.621 0 1.125.504 1.125 1.125v15.75c0 .621-.504 1.125-1.125 1.125h-6.75A1.125 1.125 0 0 1 7.5 19.875V4.125Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCursorArrowRipple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.303 5.197A7.5 7.5 0 0 0 6.697 15.803a.75.75 0 0 1-1.061 1.061A9 9 0 1 1 21 10.5a.75.75 0 0 1-1.5 0c0-1.92-.732-3.839-2.197-5.303Zm-2.121 2.121a4.5 4.5 0 0 0-6.364 6.364.75.75 0 1 1-1.06 1.06A6 6 0 1 1 18 10.5a.75.75 0 0 1-1.5 0c0-1.153-.44-2.303-1.318-3.182Zm-3.634 1.314a.75.75 0 0 1 .82.311l5.228 7.917a.75.75 0 0 1-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 0 1-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 0 1-1.247-.606l.569-9.47a.75.75 0 0 1 .554-.68Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCursorArrowRays(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 1.5a.75.75 0 0 1 .75.75V4.5a.75.75 0 0 1-1.5 0V2.25A.75.75 0 0 1 12 1.5ZM5.636 4.136a.75.75 0 0 1 1.06 0l1.592 1.591a.75.75 0 0 1-1.061 1.06l-1.591-1.59a.75.75 0 0 1 0-1.061Zm12.728 0a.75.75 0 0 1 0 1.06l-1.591 1.592a.75.75 0 0 1-1.06-1.061l1.59-1.591a.75.75 0 0 1 1.061 0Zm-6.816 4.496a.75.75 0 0 1 .82.311l5.228 7.917a.75.75 0 0 1-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 0 1-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 0 1-1.247-.606l.569-9.47a.75.75 0 0 1 .554-.68ZM3 10.5a.75.75 0 0 1 .75-.75H6a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 10.5Zm14.25 0a.75.75 0 0 1 .75-.75h2.25a.75.75 0 0 1 0 1.5H18a.75.75 0 0 1-.75-.75Zm-8.962 3.712a.75.75 0 0 1 0 1.061l-1.591 1.591a.75.75 0 1 1-1.061-1.06l1.591-1.592a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyYen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM9.624 7.084a.75.75 0 0 0-1.248.832l2.223 3.334H9a.75.75 0 0 0 0 1.5h2.25v1.5H9a.75.75 0 0 0 0 1.5h2.25v1.5a.75.75 0 0 0 1.5 0v-1.5H15a.75.75 0 0 0 0-1.5h-2.25v-1.5H15a.75.75 0 0 0 0-1.5h-1.599l2.223-3.334a.75.75 0 1 0-1.248-.832L12 10.648 9.624 7.084Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyRupee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM9 7.5A.75.75 0 0 0 9 9h1.5c.98 0 1.813.626 2.122 1.5H9A.75.75 0 0 0 9 12h3.622a2.251 2.251 0 0 1-2.122 1.5H9a.75.75 0 0 0-.53 1.28l3 3a.75.75 0 1 0 1.06-1.06L10.8 14.988A3.752 3.752 0 0 0 14.175 12H15a.75.75 0 0 0 0-1.5h-.825A3.733 3.733 0 0 0 13.5 9H15a.75.75 0 0 0 0-1.5H9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyPound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM9.763 9.51a2.25 2.25 0 0 1 3.828-1.351.75.75 0 0 0 1.06-1.06 3.75 3.75 0 0 0-6.38 2.252c-.033.307 0 .595.032.822l.154 1.077H8.25a.75.75 0 0 0 0 1.5h.421l.138.964a3.75 3.75 0 0 1-.358 2.208l-.122.242a.75.75 0 0 0 .908 1.047l1.539-.512a1.5 1.5 0 0 1 .948 0l.655.218a3 3 0 0 0 2.29-.163l.666-.333a.75.75 0 1 0-.67-1.342l-.667.333a1.5 1.5 0 0 1-1.145.082l-.654-.218a3 3 0 0 0-1.898 0l-.06.02a5.25 5.25 0 0 0 .053-1.794l-.108-.752H12a.75.75 0 0 0 0-1.5H9.972l-.184-1.29a1.863 1.863 0 0 1-.025-.45Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyEuro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.902 7.098a3.75 3.75 0 0 1 3.903-.884.75.75 0 1 0 .498-1.415A5.25 5.25 0 0 0 8.005 9.75H7.5a.75.75 0 0 0 0 1.5h.054a5.281 5.281 0 0 0 0 1.5H7.5a.75.75 0 0 0 0 1.5h.505a5.25 5.25 0 0 0 6.494 2.701.75.75 0 1 0-.498-1.415 3.75 3.75 0 0 1-4.252-1.286h3.001a.75.75 0 0 0 0-1.5H9.075a3.77 3.77 0 0 1 0-1.5h3.675a.75.75 0 0 0 0-1.5h-3c.105-.14.221-.274.348-.402Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 0 1-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004ZM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 0 1-.921.42Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v.816a3.836 3.836 0 0 0-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 0 1-.921-.421l-.879-.66a.75.75 0 0 0-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 0 0 1.5 0v-.81a4.124 4.124 0 0 0 1.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 0 0-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 0 0 .933-1.175l-.415-.33a3.836 3.836 0 0 0-1.719-.755V6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCurrencyBangladeshi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75ZM10.5 7.963a1.5 1.5 0 0 0-2.17-1.341l-.415.207a.75.75 0 0 0 .67 1.342L9 7.963V9.75h-.75a.75.75 0 1 0 0 1.5H9v4.688c0 .563.26 1.198.867 1.525A4.501 4.501 0 0 0 16.41 14.4c.199-.977-.636-1.649-1.415-1.649h-.745a.75.75 0 1 0 0 1.5h.656a3.002 3.002 0 0 1-4.327 1.893.113.113 0 0 1-.045-.051.336.336 0 0 1-.034-.154V11.25h5.25a.75.75 0 0 0 0-1.5H10.5V7.963Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.378 1.602a.75.75 0 0 0-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03ZM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 0 0 .372-.648V7.93ZM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 0 0 .372.648l8.628 5.033Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCubeTransparent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.622 1.602a.75.75 0 0 1 .756 0l2.25 1.313a.75.75 0 0 1-.756 1.295L12 3.118 10.128 4.21a.75.75 0 1 1-.756-1.295l2.25-1.313ZM5.898 5.81a.75.75 0 0 1-.27 1.025l-1.14.665 1.14.665a.75.75 0 1 1-.756 1.295L3.75 8.806v.944a.75.75 0 0 1-1.5 0V7.5a.75.75 0 0 1 .372-.648l2.25-1.312a.75.75 0 0 1 1.026.27Zm12.204 0a.75.75 0 0 1 1.026-.27l2.25 1.312a.75.75 0 0 1 .372.648v2.25a.75.75 0 0 1-1.5 0v-.944l-1.122.654a.75.75 0 1 1-.756-1.295l1.14-.665-1.14-.665a.75.75 0 0 1-.27-1.025Zm-9 5.25a.75.75 0 0 1 1.026-.27L12 11.882l1.872-1.092a.75.75 0 1 1 .756 1.295l-1.878 1.096V15a.75.75 0 0 1-1.5 0v-1.82l-1.878-1.095a.75.75 0 0 1-.27-1.025ZM3 13.5a.75.75 0 0 1 .75.75v1.82l1.878 1.095a.75.75 0 1 1-.756 1.295l-2.25-1.312a.75.75 0 0 1-.372-.648v-2.25A.75.75 0 0 1 3 13.5Zm18 0a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.372.648l-2.25 1.312a.75.75 0 1 1-.756-1.295l1.878-1.096V14.25a.75.75 0 0 1 .75-.75Zm-9 5.25a.75.75 0 0 1 .75.75v.944l1.122-.654a.75.75 0 1 1 .756 1.295l-2.25 1.313a.75.75 0 0 1-.756 0l-2.25-1.313a.75.75 0 1 1 .756-1.295l1.122.654V19.5a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 3.75a3 3 0 0 0-3 3v.75h21v-.75a3 3 0 0 0-3-3h-15Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M22.5 9.75h-21v7.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-7.5Zm-18 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCpuChip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 7.5h-9v9h9v-9Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.25 2.25A.75.75 0 0 1 9 3v.75h2.25V3a.75.75 0 0 1 1.5 0v.75H15V3a.75.75 0 0 1 1.5 0v.75h.75a3 3 0 0 1 3 3v.75H21A.75.75 0 0 1 21 9h-.75v2.25H21a.75.75 0 0 1 0 1.5h-.75V15H21a.75.75 0 0 1 0 1.5h-.75v.75a3 3 0 0 1-3 3h-.75V21a.75.75 0 0 1-1.5 0v-.75h-2.25V21a.75.75 0 0 1-1.5 0v-.75H9V21a.75.75 0 0 1-1.5 0v-.75h-.75a3 3 0 0 1-3-3v-.75H3A.75.75 0 0 1 3 15h.75v-2.25H3a.75.75 0 0 1 0-1.5h.75V9H3a.75.75 0 0 1 0-1.5h.75v-.75a3 3 0 0 1 3-3h.75V3a.75.75 0 0 1 .75-.75ZM6 6.75A.75.75 0 0 1 6.75 6h10.5a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V6.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiComputerDesktop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 5.25a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3V15a3 3 0 0 1-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 0 1-.53 1.28h-9a.75.75 0 0 1-.53-1.28l.621-.622a2.25 2.25 0 0 0 .659-1.59V18h-3a3 3 0 0 1-3-3V5.25Zm1.5 0v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCommandLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 6a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V6Zm3.97.97a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 0 1-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 0 1 0-1.06Zm4.28 4.28a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.004 10.407c.138.435-.216.842-.672.842h-3.465a.75.75 0 0 1-.65-.375l-1.732-3c-.229-.396-.053-.907.393-1.004a5.252 5.252 0 0 1 6.126 3.537ZM8.12 8.464c.307-.338.838-.235 1.066.16l1.732 3a.75.75 0 0 1 0 .75l-1.732 3c-.229.397-.76.5-1.067.161A5.23 5.23 0 0 1 6.75 12a5.23 5.23 0 0 1 1.37-3.536ZM10.878 17.13c-.447-.098-.623-.608-.394-1.004l1.733-3.002a.75.75 0 0 1 .65-.375h3.465c.457 0 .81.407.672.842a5.252 5.252 0 0 1-6.126 3.539Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21 12.75a.75.75 0 1 0 0-1.5h-.783a8.22 8.22 0 0 0-.237-1.357l.734-.267a.75.75 0 1 0-.513-1.41l-.735.268a8.24 8.24 0 0 0-.689-1.192l.6-.503a.75.75 0 1 0-.964-1.149l-.6.504a8.3 8.3 0 0 0-1.054-.885l.391-.678a.75.75 0 1 0-1.299-.75l-.39.676a8.188 8.188 0 0 0-1.295-.47l.136-.77a.75.75 0 0 0-1.477-.26l-.136.77a8.36 8.36 0 0 0-1.377 0l-.136-.77a.75.75 0 1 0-1.477.26l.136.77c-.448.121-.88.28-1.294.47l-.39-.676a.75.75 0 0 0-1.3.75l.392.678a8.29 8.29 0 0 0-1.054.885l-.6-.504a.75.75 0 1 0-.965 1.149l.6.503a8.243 8.243 0 0 0-.689 1.192L3.8 8.216a.75.75 0 1 0-.513 1.41l.735.267a8.222 8.222 0 0 0-.238 1.356h-.783a.75.75 0 0 0 0 1.5h.783c.042.464.122.917.238 1.356l-.735.268a.75.75 0 0 0 .513 1.41l.735-.268c.197.417.428.816.69 1.191l-.6.504a.75.75 0 0 0 .963 1.15l.601-.505c.326.323.679.62 1.054.885l-.392.68a.75.75 0 0 0 1.3.75l.39-.679c.414.192.847.35 1.294.471l-.136.77a.75.75 0 0 0 1.477.261l.137-.772a8.332 8.332 0 0 0 1.376 0l.136.772a.75.75 0 1 0 1.477-.26l-.136-.771a8.19 8.19 0 0 0 1.294-.47l.391.677a.75.75 0 0 0 1.3-.75l-.393-.679a8.29 8.29 0 0 0 1.054-.885l.601.504a.75.75 0 0 0 .964-1.15l-.6-.503c.261-.375.492-.774.69-1.191l.735.267a.75.75 0 1 0 .512-1.41l-.734-.267c.115-.439.195-.892.237-1.356h.784Zm-2.657-3.06a6.744 6.744 0 0 0-1.19-2.053 6.784 6.784 0 0 0-1.82-1.51A6.705 6.705 0 0 0 12 5.25a6.8 6.8 0 0 0-1.225.11 6.7 6.7 0 0 0-2.15.793 6.784 6.784 0 0 0-2.952 3.489.76.76 0 0 1-.036.098A6.74 6.74 0 0 0 5.251 12a6.74 6.74 0 0 0 3.366 5.842l.009.005a6.704 6.704 0 0 0 2.18.798l.022.003a6.792 6.792 0 0 0 2.368-.004 6.704 6.704 0 0 0 2.205-.811 6.785 6.785 0 0 0 1.762-1.484l.009-.01.009-.01a6.743 6.743 0 0 0 1.18-2.066c.253-.707.39-1.469.39-2.263a6.74 6.74 0 0 0-.408-2.309Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCog8Tooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.828 2.25c-.916 0-1.699.663-1.85 1.567l-.091.549a.798.798 0 0 1-.517.608 7.45 7.45 0 0 0-.478.198.798.798 0 0 1-.796-.064l-.453-.324a1.875 1.875 0 0 0-2.416.2l-.243.243a1.875 1.875 0 0 0-.2 2.416l.324.453a.798.798 0 0 1 .064.796 7.448 7.448 0 0 0-.198.478.798.798 0 0 1-.608.517l-.55.092a1.875 1.875 0 0 0-1.566 1.849v.344c0 .916.663 1.699 1.567 1.85l.549.091c.281.047.508.25.608.517.06.162.127.321.198.478a.798.798 0 0 1-.064.796l-.324.453a1.875 1.875 0 0 0 .2 2.416l.243.243c.648.648 1.67.733 2.416.2l.453-.324a.798.798 0 0 1 .796-.064c.157.071.316.137.478.198.267.1.47.327.517.608l.092.55c.15.903.932 1.566 1.849 1.566h.344c.916 0 1.699-.663 1.85-1.567l.091-.549a.798.798 0 0 1 .517-.608 7.52 7.52 0 0 0 .478-.198.798.798 0 0 1 .796.064l.453.324a1.875 1.875 0 0 0 2.416-.2l.243-.243c.648-.648.733-1.67.2-2.416l-.324-.453a.798.798 0 0 1-.064-.796c.071-.157.137-.316.198-.478.1-.267.327-.47.608-.517l.55-.091a1.875 1.875 0 0 0 1.566-1.85v-.344c0-.916-.663-1.699-1.567-1.85l-.549-.091a.798.798 0 0 1-.608-.517 7.507 7.507 0 0 0-.198-.478.798.798 0 0 1 .064-.796l.324-.453a1.875 1.875 0 0 0-.2-2.416l-.243-.243a1.875 1.875 0 0 0-2.416-.2l-.453.324a.798.798 0 0 1-.796.064 7.462 7.462 0 0 0-.478-.198.798.798 0 0 1-.517-.608l-.091-.55a1.875 1.875 0 0 0-1.85-1.566h-.344ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCog6Tooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCodeBracket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.447 3.026a.75.75 0 0 1 .527.921l-4.5 16.5a.75.75 0 0 1-1.448-.394l4.5-16.5a.75.75 0 0 1 .921-.527ZM16.72 6.22a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 1 1-1.06-1.06L21.44 12l-4.72-4.72a.75.75 0 0 1 0-1.06Zm-9.44 0a.75.75 0 0 1 0 1.06L2.56 12l4.72 4.72a.75.75 0 0 1-1.06 1.06L.97 12.53a.75.75 0 0 1 0-1.06l5.25-5.25a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCodeBracketSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm14.25 6a.75.75 0 0 1-.22.53l-2.25 2.25a.75.75 0 1 1-1.06-1.06L15.44 12l-1.72-1.72a.75.75 0 1 1 1.06-1.06l2.25 2.25c.141.14.22.331.22.53Zm-10.28-.53a.75.75 0 0 0 0 1.06l2.25 2.25a.75.75 0 1 0 1.06-1.06L8.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-2.25 2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 9.75a6 6 0 0 1 11.573-2.226 3.75 3.75 0 0 1 4.133 4.303A4.5 4.5 0 0 1 18 20.25H6.75a5.25 5.25 0 0 1-2.23-10.004 6.072 6.072 0 0 1-.02-.496Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCloudArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.75a6 6 0 0 0-5.98 6.496A5.25 5.25 0 0 0 6.75 20.25H18a4.5 4.5 0 0 0 2.206-8.423 3.75 3.75 0 0 0-4.133-4.303A6.001 6.001 0 0 0 10.5 3.75Zm2.03 5.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72v4.94a.75.75 0 0 0 1.5 0v-4.94l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCloudArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.75a6 6 0 0 0-5.98 6.496A5.25 5.25 0 0 0 6.75 20.25H18a4.5 4.5 0 0 0 2.206-8.423 3.75 3.75 0 0 0-4.133-4.303A6.001 6.001 0 0 0 10.5 3.75Zm2.25 6a.75.75 0 0 0-1.5 0v4.94l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V9.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3A1.501 1.501 0 0 0 9 4.5h6A1.5 1.5 0 0 0 13.5 3h-3Zm-2.693.178A3 3 0 0 1 10.5 1.5h3a3 3 0 0 1 2.694 1.678c.497.042.992.092 1.486.15 1.497.173 2.57 1.46 2.57 2.929V19.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3V6.257c0-1.47 1.073-2.756 2.57-2.93.493-.057.989-.107 1.487-.15Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiClipboardDocument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.663 3.118c.225.015.45.032.673.05C19.876 3.298 21 4.604 21 6.109v9.642a3 3 0 0 1-3 3V16.5c0-5.922-4.576-10.775-10.384-11.217.324-1.132 1.3-2.01 2.548-2.114.224-.019.448-.036.673-.051A3 3 0 0 1 13.5 1.5H15a3 3 0 0 1 2.663 1.618ZM12 4.5A1.5 1.5 0 0 1 13.5 3H15a1.5 1.5 0 0 1 1.5 1.5H12Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8.625c0-1.036.84-1.875 1.875-1.875h.375A3.75 3.75 0 0 1 9 10.5v1.875c0 1.036.84 1.875 1.875 1.875h1.875A3.75 3.75 0 0 1 16.5 18v2.625c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625v-12Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 10.5a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963 5.23 5.23 0 0 0-3.434-1.279h-1.875a.375.375 0 0 1-.375-.375V10.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiClipboardDocumentList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.502 6h7.128A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 0 0-.673-.05A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6ZM13.5 3A1.5 1.5 0 0 0 12 4.5h4.5A1.5 1.5 0 0 0 15 3h-1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V9.375ZM6 12a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V12Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 15a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V15Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 18a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V18Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiClipboardDocumentCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.502 6h7.128A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 0 0-.673-.05A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6ZM13.5 3A1.5 1.5 0 0 0 12 4.5h4.5A1.5 1.5 0 0 0 15 3h-1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V9.375Zm9.586 4.594a.75.75 0 0 0-1.172-.938l-2.476 3.096-.908-.907a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.116-.062l3-3.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCircleStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.375c0 2.692-4.03 4.875-9 4.875S3 9.067 3 6.375 7.03 1.5 12 1.5s9 2.183 9 4.875Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.75c2.685 0 5.19-.586 7.078-1.609a8.283 8.283 0 0 0 1.897-1.384c.016.121.025.244.025.368C21 12.817 16.97 15 12 15s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.285 8.285 0 0 0 1.897 1.384C6.809 12.164 9.315 12.75 12 12.75Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16.5c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 0 0 1.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 0 0 1.897 1.384C6.809 15.914 9.315 16.5 12 16.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20.25c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 0 0 1.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 0 0 1.897 1.384C6.809 19.664 9.315 20.25 12 20.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronUpDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.47 4.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 0 1-1.06-1.06l3.75-3.75Zm-3.75 9.75a.75.75 0 0 1 1.06 0L12 17.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronDoubleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.47 10.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 12.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.47 4.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 6.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronDoubleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L11.69 12 4.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06L17.69 12l-6.97-6.97a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronDoubleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L12.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L6.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChevronDoubleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.47 13.28a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 0 0-1.06-1.06L12 11.69 5.03 4.72a.75.75 0 0 0-1.06 1.06l7.5 7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.47 19.28a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 1 0-1.06-1.06L12 17.69l-6.97-6.97a.75.75 0 0 0-1.06 1.06l7.5 7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCheckBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChatBubbleOvalLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.337 21.718a6.707 6.707 0 0 1-.533-.074.75.75 0 0 1-.44-1.223 3.73 3.73 0 0 0 .814-1.686c.023-.115-.022-.317-.254-.543C3.274 16.587 2.25 14.41 2.25 12c0-5.03 4.428-9 9.75-9s9.75 3.97 9.75 9c0 5.03-4.428 9-9.75 9-.833 0-1.643-.097-2.417-.279a6.721 6.721 0 0 1-4.246.997Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChatBubbleOvalLeftEllipsis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.804 21.644A6.707 6.707 0 0 0 6 21.75a6.721 6.721 0 0 0 3.583-1.029c.774.182 1.584.279 2.417.279 5.322 0 9.75-3.97 9.75-9 0-5.03-4.428-9-9.75-9s-9.75 3.97-9.75 9c0 2.409 1.025 4.587 2.674 6.192.232.226.277.428.254.543a3.73 3.73 0 0 1-.814 1.686.75.75 0 0 0 .44 1.223ZM8.25 10.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChatBubbleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97-1.94.284-3.916.455-5.922.505a.39.39 0 0 0-.266.112L8.78 21.53A.75.75 0 0 1 7.5 21v-3.955a48.842 48.842 0 0 1-2.652-.316c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChatBubbleLeftRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 0 0-1.032-.211 50.89 50.89 0 0 0-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 0 0 2.433 3.984L7.28 21.53A.75.75 0 0 1 6 21v-4.03a48.527 48.527 0 0 1-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 0 0 1.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0 0 15.75 7.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChatBubbleLeftEllipsis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-2.429 0-4.817.178-7.152.521C2.87 3.061 1.5 4.795 1.5 6.741v6.018c0 1.946 1.37 3.68 3.348 3.97.877.129 1.761.234 2.652.316V21a.75.75 0 0 0 1.28.53l4.184-4.183a.39.39 0 0 1 .266-.112c2.006-.05 3.982-.22 5.922-.506 1.978-.29 3.348-2.023 3.348-3.97V6.741c0-1.947-1.37-3.68-3.348-3.97A49.145 49.145 0 0 0 12 2.25ZM8.25 8.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm2.625 1.125a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChatBubbleBottomCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChatBubbleBottomCenterText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97ZM6.75 8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChartPie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 13.5a8.25 8.25 0 0 1 8.25-8.25.75.75 0 0 1 .75.75v6.75H18a.75.75 0 0 1 .75.75 8.25 8.25 0 0 1-16.5 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.75 3a.75.75 0 0 1 .75-.75 8.25 8.25 0 0 1 8.25 8.25.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75V3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75ZM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 0 1-1.875-1.875V8.625ZM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 0 1 3 19.875v-6.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiChartBarSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm4.5 7.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0v-2.25a.75.75 0 0 1 .75-.75Zm3.75-1.5a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0V12Zm2.25-3a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0V9.75A.75.75 0 0 1 13.5 9Zm3.75-1.5a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0v-9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 9Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.344 3.071a49.52 49.52 0 0 1 5.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 0 0 1.11-.71l.822-1.315a2.942 2.942 0 0 1 2.332-1.39ZM6.75 12.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Zm12-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCalendarDays(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCalendarDateRange(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.993a.75.75 0 0 0-.75.75v.006c0 .414.336.75.75.75h.006a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75H12ZM12 16.494a.75.75 0 0 0-.75.75v.005c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H12ZM8.999 17.244a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.006ZM7.499 16.494a.75.75 0 0 0-.75.75v.005c0 .414.336.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H7.5ZM13.499 14.997a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.005a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.005ZM14.25 16.494a.75.75 0 0 0-.75.75v.006c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75h-.005ZM15.75 14.995a.75.75 0 0 1 .75-.75h.005a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75H16.5a.75.75 0 0 1-.75-.75v-.006ZM13.498 12.743a.75.75 0 0 1 .75-.75h2.25a.75.75 0 1 1 0 1.5h-2.25a.75.75 0 0 1-.75-.75ZM6.748 14.993a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 2.993a.75.75 0 0 0-1.5 0v1.5h-9V2.994a.75.75 0 1 0-1.5 0v1.497h-.752a3 3 0 0 0-3 3v11.252a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3V7.492a3 3 0 0 0-3-3H18V2.993ZM3.748 18.743v-7.5a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-13.5a1.5 1.5 0 0 1-1.5-1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.32 1.827a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V19.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3V4.757c0-1.47 1.073-2.756 2.57-2.93ZM7.5 11.25a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H8.25Zm-.75 3a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75H8.25Zm1.748-6a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.007a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.335.75.75.75h.007a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.007Zm-.75 3a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.007a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.335.75.75.75h.007a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75h-.007Zm1.754-6a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.008Zm-.75 3a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75h-.008Zm1.748-6a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.008Zm-8.25-6A.75.75 0 0 1 8.25 6h7.5a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-.75Zm9 9a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiCake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 1.784-.796.795a1.125 1.125 0 1 0 1.591 0L15 1.784ZM12 1.784l-.796.795a1.125 1.125 0 1 0 1.591 0L12 1.784ZM9 1.784l-.796.795a1.125 1.125 0 1 0 1.591 0L9 1.784ZM9.75 7.547c.498-.021.998-.035 1.5-.042V6.75a.75.75 0 0 1 1.5 0v.755c.502.007 1.002.021 1.5.042V6.75a.75.75 0 0 1 1.5 0v.88l.307.022c1.55.117 2.693 1.427 2.693 2.946v1.018a62.182 62.182 0 0 0-13.5 0v-1.018c0-1.519 1.143-2.829 2.693-2.946l.307-.022v-.88a.75.75 0 0 1 1.5 0v.797ZM12 12.75c-2.472 0-4.9.184-7.274.54-1.454.217-2.476 1.482-2.476 2.916v.384a4.104 4.104 0 0 1 2.585.364 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 3.67 0 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 3.67 0 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 2.585-.364v-.384c0-1.434-1.022-2.7-2.476-2.917A49.138 49.138 0 0 0 12 12.75ZM21.75 18.131a2.604 2.604 0 0 0-1.915.165 4.104 4.104 0 0 1-3.67 0 2.605 2.605 0 0 0-2.33 0 4.104 4.104 0 0 1-3.67 0 2.605 2.605 0 0 0-2.33 0 4.104 4.104 0 0 1-3.67 0 2.604 2.604 0 0 0-1.915-.165v2.494c0 1.035.84 1.875 1.875 1.875h15.75c1.035 0 1.875-.84 1.875-1.875v-2.494Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBuildingStorefront(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.223 2.25c-.497 0-.974.198-1.325.55l-1.3 1.298A3.75 3.75 0 0 0 7.5 9.75c.627.47 1.406.75 2.25.75.844 0 1.624-.28 2.25-.75.626.47 1.406.75 2.25.75.844 0 1.623-.28 2.25-.75a3.75 3.75 0 0 0 4.902-5.652l-1.3-1.299a1.875 1.875 0 0 0-1.325-.549H5.223Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 20.25v-8.755c1.42.674 3.08.673 4.5 0A5.234 5.234 0 0 0 9.75 12c.804 0 1.568-.182 2.25-.506a5.234 5.234 0 0 0 2.25.506c.804 0 1.567-.182 2.25-.506 1.42.674 3.08.675 4.5.001v8.755h.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5H3Zm3-6a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3Zm8.25-.75a.75.75 0 0 0-.75.75v5.25c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-5.25a.75.75 0 0 0-.75-.75h-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBuildingOffice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5h-.75V3.75a.75.75 0 0 0 0-1.5h-15ZM9 6a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm-.75 3.75A.75.75 0 0 1 9 9h1.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM9 12a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm3.75-5.25A.75.75 0 0 1 13.5 6H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM13.5 9a.75.75 0 0 0 0 1.5H15A.75.75 0 0 0 15 9h-1.5Zm-.75 3.75a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM9 19.5v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 9 19.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBuildingOffice2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5H15v-18a.75.75 0 0 0 0-1.5H3ZM6.75 19.5v-2.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75ZM6 6.75A.75.75 0 0 1 6.75 6h.75a.75.75 0 0 1 0 1.5h-.75A.75.75 0 0 1 6 6.75ZM6.75 9a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75ZM6 12.75a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75ZM10.5 6a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75Zm-.75 3.75A.75.75 0 0 1 10.5 9h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75ZM10.5 12a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75ZM16.5 6.75v15h5.25a.75.75 0 0 0 0-1.5H21v-12a.75.75 0 0 0 0-1.5h-4.5Zm1.5 4.5a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 2.25a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75h-.008ZM18 17.25a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBuildingLibrary(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.584 2.376a.75.75 0 0 1 .832 0l9 6a.75.75 0 1 1-.832 1.248L12 3.901 3.416 9.624a.75.75 0 0 1-.832-1.248l9-6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.25 10.332v9.918H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h.75v-9.918a.75.75 0 0 1 .634-.74A49.109 49.109 0 0 1 12 9c2.59 0 5.134.202 7.616.592a.75.75 0 0 1 .634.74Zm-7.5 2.418a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Zm3-.75a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0v-6.75a.75.75 0 0 1 .75-.75ZM9 12.75a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.875a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBugAnt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.478 1.6a.75.75 0 0 1 .273 1.026 3.72 3.72 0 0 0-.425 1.121c.058.058.118.114.18.168A4.491 4.491 0 0 1 12 2.25c1.413 0 2.673.651 3.497 1.668.06-.054.12-.11.178-.167a3.717 3.717 0 0 0-.426-1.125.75.75 0 1 1 1.298-.752 5.22 5.22 0 0 1 .671 2.046.75.75 0 0 1-.187.582c-.241.27-.505.52-.787.749a4.494 4.494 0 0 1 .216 2.1c-.106.792-.753 1.295-1.417 1.403-.182.03-.364.057-.547.081.152.227.273.476.359.742a23.122 23.122 0 0 0 3.832-.803 23.241 23.241 0 0 0-.345-2.634.75.75 0 0 1 1.474-.28c.21 1.115.348 2.256.404 3.418a.75.75 0 0 1-.516.75c-1.527.499-3.119.854-4.76 1.049-.074.38-.22.735-.423 1.05 2.066.209 4.058.672 5.943 1.358a.75.75 0 0 1 .492.75 24.665 24.665 0 0 1-1.189 6.25.75.75 0 0 1-1.425-.47 23.14 23.14 0 0 0 1.077-5.306c-.5-.169-1.009-.32-1.524-.455.068.234.104.484.104.746 0 3.956-2.521 7.5-6 7.5-3.478 0-6-3.544-6-7.5 0-.262.037-.511.104-.746-.514.135-1.022.286-1.522.455.154 1.838.52 3.616 1.077 5.307a.75.75 0 1 1-1.425.468 24.662 24.662 0 0 1-1.19-6.25.75.75 0 0 1 .493-.749 24.586 24.586 0 0 1 4.964-1.24h.01c.321-.046.644-.085.969-.118a2.983 2.983 0 0 1-.424-1.05 24.614 24.614 0 0 1-4.76-1.05.75.75 0 0 1-.516-.75c.057-1.16.194-2.302.405-3.417a.75.75 0 0 1 1.474.28c-.164.862-.28 1.74-.345 2.634 1.237.371 2.517.642 3.832.803.085-.266.207-.515.359-.742a18.698 18.698 0 0 1-.547-.08c-.664-.11-1.311-.612-1.417-1.404a4.535 4.535 0 0 1 .217-2.103 6.788 6.788 0 0 1-.788-.751.75.75 0 0 1-.187-.583 5.22 5.22 0 0 1 .67-2.04.75.75 0 0 1 1.026-.273Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.5 5.25a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0 1 12 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 0 1 7.5 5.455V5.25Zm7.5 0v.09a49.488 49.488 0 0 0-6 0v-.09a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5Zm-3 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18.4v-2.796a4.3 4.3 0 0 0 .713.31A26.226 26.226 0 0 0 12 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 0 1-6.477-.427C4.047 21.128 3 19.852 3 18.4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBookmarkSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm1.5 1.5a.75.75 0 0 0-.75.75V16.5a.75.75 0 0 0 1.085.67L12 15.089l4.165 2.083a.75.75 0 0 0 1.085-.671V5.25a.75.75 0 0 0-.75-.75h-9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBookmarkSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM20.25 5.507v11.561L5.853 2.671c.15-.043.306-.075.467-.094a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93ZM3.75 21V6.932l14.063 14.063L12 18.088l-7.165 3.583A.75.75 0 0 1 3.75 21Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBookOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 4.533A9.707 9.707 0 0 0 6 3a9.735 9.735 0 0 0-3.25.555.75.75 0 0 0-.5.707v14.25a.75.75 0 0 0 1 .707A8.237 8.237 0 0 1 6 18.75c1.995 0 3.823.707 5.25 1.886V4.533ZM12.75 20.636A8.214 8.214 0 0 1 18 18.75c.966 0 1.89.166 2.75.47a.75.75 0 0 0 1-.708V4.262a.75.75 0 0 0-.5-.707A9.735 9.735 0 0 0 18 3a9.707 9.707 0 0 0-5.25 1.533v16.103Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.615 1.595a.75.75 0 0 1 .359.852L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262l10.5-11.25a.75.75 0 0 1 .913-.143Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBoltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.798 11.012-3.188 3.416L9.462 6.28l4.24-4.542a.75.75 0 0 1 1.272.71L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262ZM3.202 12.988 6.39 9.572l8.148 8.148-4.24 4.542a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262ZM3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBold(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.246 3.744a.75.75 0 0 1 .75-.75h7.125a4.875 4.875 0 0 1 3.346 8.422 5.25 5.25 0 0 1-2.97 9.58h-7.5a.75.75 0 0 1-.75-.75V3.744Zm7.125 6.75a2.625 2.625 0 0 0 0-5.25H8.246v5.25h4.125Zm-4.125 2.251v6h4.5a3 3 0 0 0 0-6h-4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBellSnooze(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25A6.75 6.75 0 0 0 5.25 9v.75a8.217 8.217 0 0 1-2.119 5.52.75.75 0 0 0 .298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 1 0 7.48 0 24.583 24.583 0 0 0 4.83-1.244.75.75 0 0 0 .298-1.205 8.217 8.217 0 0 1-2.118-5.52V9A6.75 6.75 0 0 0 12 2.25ZM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 0 0 4.496 0l.002.1a2.25 2.25 0 1 1-4.5 0Zm.75-10.5a.75.75 0 0 0 0 1.5h1.599l-2.223 3.334A.75.75 0 0 0 10.5 13.5h3a.75.75 0 0 0 0-1.5h-1.599l2.223-3.334A.75.75 0 0 0 13.5 7.5h-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBellSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM20.57 16.476c-.223.082-.448.161-.674.238L7.319 4.137A6.75 6.75 0 0 1 18.75 9v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.25 9c0-.184.007-.366.022-.546l10.384 10.384a3.751 3.751 0 0 1-7.396-1.119 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBellAlert(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.85 3.5a.75.75 0 0 0-1.117-1 9.719 9.719 0 0 0-2.348 4.876.75.75 0 0 0 1.479.248A8.219 8.219 0 0 1 5.85 3.5ZM19.267 2.5a.75.75 0 1 0-1.118 1 8.22 8.22 0 0 1 1.987 4.124.75.75 0 0 0 1.48-.248A9.72 9.72 0 0 0 19.266 2.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25A6.75 6.75 0 0 0 5.25 9v.75a8.217 8.217 0 0 1-2.119 5.52.75.75 0 0 0 .298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 1 0 7.48 0 24.583 24.583 0 0 0 4.83-1.244.75.75 0 0 0 .298-1.205 8.217 8.217 0 0 1-2.118-5.52V9A6.75 6.75 0 0 0 12 2.25ZM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 0 0 4.496 0l.002.1a2.25 2.25 0 1 1-4.5 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBeaker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.798v5.02a3 3 0 0 1-.879 2.121l-2.377 2.377a9.845 9.845 0 0 1 5.091 1.013 8.315 8.315 0 0 0 5.713.636l.285-.071-3.954-3.955a3 3 0 0 1-.879-2.121v-5.02a23.614 23.614 0 0 0-3 0Zm4.5.138a.75.75 0 0 0 .093-1.495A24.837 24.837 0 0 0 12 2.25a25.048 25.048 0 0 0-3.093.191A.75.75 0 0 0 9 3.936v4.882a1.5 1.5 0 0 1-.44 1.06l-6.293 6.294c-1.62 1.621-.903 4.475 1.471 4.88 2.686.46 5.447.698 8.262.698 2.816 0 5.576-.239 8.262-.697 2.373-.406 3.092-3.26 1.47-4.881L15.44 9.879A1.5 1.5 0 0 1 15 8.818V3.936Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBattery50(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 9.75a.75.75 0 0 0-.75.75V15c0 .414.336.75.75.75h6.75A.75.75 0 0 0 12 15v-4.5a.75.75 0 0 0-.75-.75H4.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 6.75a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-.037c.856-.174 1.5-.93 1.5-1.838v-2.25c0-.907-.644-1.664-1.5-1.837V9.75a3 3 0 0 0-3-3h-15Zm15 1.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h15Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBattery100(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 6.75a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-.037c.856-.174 1.5-.93 1.5-1.838v-2.25c0-.907-.644-1.664-1.5-1.837V9.75a3 3 0 0 0-3-3h-15Zm15 1.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h15ZM4.5 9.75a.75.75 0 0 0-.75.75V15c0 .414.336.75.75.75H18a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75H4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBattery0(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.75 9.75a3 3 0 0 1 3-3h15a3 3 0 0 1 3 3v.038c.856.173 1.5.93 1.5 1.837v2.25c0 .907-.644 1.664-1.5 1.838v.037a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3v-6Zm19.5 0a1.5 1.5 0 0 0-1.5-1.5h-15a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBarsArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 4.5A.75.75 0 0 1 3 3.75h14.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Zm14.47 3.97a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 1 1-1.06 1.06L18 10.81V21a.75.75 0 0 1-1.5 0V10.81l-2.47 2.47a.75.75 0 1 1-1.06-1.06l3.75-3.75ZM2.25 9A.75.75 0 0 1 3 8.25h9.75a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 9Zm0 4.5a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBarsArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.25 4.5A.75.75 0 0 1 3 3.75h14.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Zm0 4.5A.75.75 0 0 1 3 8.25h9.75a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 9Zm15-.75A.75.75 0 0 1 18 9v10.19l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 1 1 1.06-1.06l2.47 2.47V9a.75.75 0 0 1 .75-.75Zm-15 5.25a.75.75 0 0 1 .75-.75h9.75a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBars4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 5.25Zm0 4.5A.75.75 0 0 1 3.75 9h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 9.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBars3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBars3CenterLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBars3BottomRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm8.25 5.25a.75.75 0 0 1 .75-.75h8.25a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBars3BottomLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBars2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 9a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 9Zm0 6.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBanknotes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 14.625v-9.75ZM8.25 9.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM18.75 9a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V9.75a.75.75 0 0 0-.75-.75h-.008ZM4.5 9.75A.75.75 0 0 1 5.25 9h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V9.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.25 18a.75.75 0 0 0 0 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 0 0-.75-.75H2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.195 18.44c1.25.714 2.805-.189 2.805-1.629v-2.34l6.945 3.968c1.25.715 2.805-.188 2.805-1.628V8.69c0-1.44-1.555-2.343-2.805-1.628L12 11.029v-2.34c0-1.44-1.555-2.343-2.805-1.628l-7.108 4.061c-1.26.72-1.26 2.536 0 3.256l7.108 4.061Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiBackspace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.515 10.674a1.875 1.875 0 0 0 0 2.652L8.89 19.7c.352.351.829.549 1.326.549H19.5a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-9.284c-.497 0-.974.198-1.326.55l-6.375 6.374ZM12.53 9.22a.75.75 0 1 0-1.06 1.06L13.19 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L15.31 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiAtSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.834 6.166a8.25 8.25 0 1 0 0 11.668.75.75 0 0 1 1.06 1.06c-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788 3.807-3.808 9.98-3.808 13.788 0A9.722 9.722 0 0 1 21.75 12c0 .975-.296 1.887-.809 2.571-.514.685-1.28 1.179-2.191 1.179-.904 0-1.666-.487-2.18-1.164a5.25 5.25 0 1 1-.82-6.26V8.25a.75.75 0 0 1 1.5 0V12c0 .682.208 1.27.509 1.671.3.401.659.579.991.579.332 0 .69-.178.991-.579.3-.4.509-.99.509-1.671a8.222 8.222 0 0 0-2.416-5.834ZM15.75 12a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowsUpDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.25 4.81V16.5a.75.75 0 0 1-1.5 0V4.81L3.53 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5Zm9.53 4.28a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V7.5a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowsRightLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l3.22-3.22H7.5a.75.75 0 0 1 0-1.5h11.69l-3.22-3.22a.75.75 0 0 1 0-1.06Zm-7.94 9a.75.75 0 0 1 0 1.06l-3.22 3.22H16.5a.75.75 0 0 1 0 1.5H4.81l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowsPointingOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-3.97 3.97a.75.75 0 1 1-1.06-1.06l3.97-3.97h-2.69a.75.75 0 0 1-.75-.75Zm-12 0A.75.75 0 0 1 3.75 3h4.5a.75.75 0 0 1 0 1.5H5.56l3.97 3.97a.75.75 0 0 1-1.06 1.06L4.5 5.56v2.69a.75.75 0 0 1-1.5 0v-4.5Zm11.47 11.78a.75.75 0 1 1 1.06-1.06l3.97 3.97v-2.69a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-3.97-3.97Zm-4.94-1.06a.75.75 0 0 1 0 1.06L5.56 19.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowsPointingIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.22 3.22a.75.75 0 0 1 1.06 0l3.97 3.97V4.5a.75.75 0 0 1 1.5 0V9a.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1 0-1.5h2.69L3.22 4.28a.75.75 0 0 1 0-1.06Zm17.56 0a.75.75 0 0 1 0 1.06l-3.97 3.97h2.69a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0ZM3.75 15a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-2.69l-3.97 3.97a.75.75 0 0 1-1.06-1.06l3.97-3.97H4.5a.75.75 0 0 1-.75-.75Zm10.5 0a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-2.69l3.97 3.97a.75.75 0 1 1-1.06 1.06l-3.97-3.97v2.69a.75.75 0 0 1-1.5 0V15Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUturnUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21.53 9.53a.75.75 0 0 1-1.06 0l-4.72-4.72V15a6.75 6.75 0 0 1-13.5 0v-3a.75.75 0 0 1 1.5 0v3a5.25 5.25 0 1 0 10.5 0V4.81L9.53 9.53a.75.75 0 0 1-1.06-1.06l6-6a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUturnRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.47 2.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 1 1-1.06-1.06l4.72-4.72H9a5.25 5.25 0 1 0 0 10.5h3a.75.75 0 0 1 0 1.5H9a6.75 6.75 0 0 1 0-13.5h10.19l-4.72-4.72a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUturnLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.53 2.47a.75.75 0 0 1 0 1.06L4.81 8.25H15a6.75 6.75 0 0 1 0 13.5h-3a.75.75 0 0 1 0-1.5h3a5.25 5.25 0 1 0 0-10.5H4.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUturnDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 3.75A5.25 5.25 0 0 0 9.75 9v10.19l4.72-4.72a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 1 1 1.06-1.06l4.72 4.72V9a6.75 6.75 0 0 1 13.5 0v3a.75.75 0 0 1-1.5 0V9c0-2.9-2.35-5.25-5.25-5.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.47 2.47a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06l-6.22-6.22V21a.75.75 0 0 1-1.5 0V4.81l-6.22 6.22a.75.75 0 1 1-1.06-1.06l7.5-7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUpTray(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.47 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06l-3.22-3.22V16.5a.75.75 0 0 1-1.5 0V4.81L8.03 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5ZM3 15.75a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.25 3.75H19.5a.75.75 0 0 1 .75.75v11.25a.75.75 0 0 1-1.5 0V6.31L5.03 20.03a.75.75 0 0 1-1.06-1.06L17.69 5.25H8.25a.75.75 0 0 1 0-1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUpOnSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.47 1.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V7.5h-1.5V4.06L9.53 5.78a.75.75 0 0 1-1.06-1.06l3-3ZM11.25 7.5V15a.75.75 0 0 0 1.5 0V7.5h3.75a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUpOnSquareStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.97.97a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72v3.44h-1.5V3.31L8.03 5.03a.75.75 0 0 1-1.06-1.06l3-3ZM9.75 6.75v6a.75.75 0 0 0 1.5 0v-6h3a3 3 0 0 1 3 3v7.5a3 3 0 0 1-3 3h-7.5a3 3 0 0 1-3-3v-7.5a3 3 0 0 1 3-3h3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.151 21.75a2.999 2.999 0 0 0 2.599 1.5h7.5a3 3 0 0 0 3-3v-7.5c0-1.11-.603-2.08-1.5-2.599v7.099a4.5 4.5 0 0 1-4.5 4.5H7.151Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUpLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.25 6.31v9.44a.75.75 0 0 1-1.5 0V4.5a.75.75 0 0 1 .75-.75h11.25a.75.75 0 0 1 0 1.5H6.31l13.72 13.72a.75.75 0 1 1-1.06 1.06L5.25 6.31Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowUpCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm.53 5.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72v5.69a.75.75 0 0 0 1.5 0v-5.69l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTurnUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.74 20.25a.75.75 0 0 0 .75-.75V8.999h13.938l-2.47 2.47a.75.75 0 0 0 1.061 1.06l3.75-3.75a.75.75 0 0 0 0-1.06l-3.75-3.75a.75.75 0 0 0-1.06 1.06l2.47 2.47H3.738a.75.75 0 0 0-.75.75V19.5c0 .414.336.75.75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTurnUpLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.239 20.25a.75.75 0 0 1-.75-.75V8.999H5.549l2.47 2.47a.75.75 0 0 1-1.06 1.06l-3.75-3.75a.75.75 0 0 1 0-1.06l3.75-3.75a.75.75 0 1 1 1.06 1.06l-2.47 2.47h14.69a.75.75 0 0 1 .75.75V19.5a.75.75 0 0 1-.75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTurnRightUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.738 20.249a.75.75 0 0 1 .75-.75H14.99V5.56l-2.47 2.47a.75.75 0 0 1-1.06-1.061l3.75-3.75a.75.75 0 0 1 1.06 0l3.751 3.75a.75.75 0 0 1-1.06 1.06L16.49 5.56V20.25a.75.75 0 0 1-.75.75H4.487a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTurnRightDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.738 3.75c0 .414.336.75.75.75H14.99v13.939l-2.47-2.47a.75.75 0 0 0-1.06 1.061l3.75 3.75a.75.75 0 0 0 1.06 0l3.751-3.75a.75.75 0 0 0-1.06-1.06l-2.47 2.469V3.75a.75.75 0 0 0-.75-.75H4.487a.75.75 0 0 0-.75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTurnLeftUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.24 20.249a.75.75 0 0 0-.75-.75H8.989V5.56l2.47 2.47a.75.75 0 0 0 1.06-1.061l-3.75-3.75a.75.75 0 0 0-1.06 0l-3.75 3.75a.75.75 0 1 0 1.06 1.06l2.47-2.469V20.25c0 .414.335.75.75.75h11.25a.75.75 0 0 0 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTurnLeftDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.24 3.75a.75.75 0 0 1-.75.75H8.989v13.939l2.47-2.47a.75.75 0 1 1 1.06 1.061l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.751-3.75a.75.75 0 1 1 1.06-1.06l2.47 2.469V3.75a.75.75 0 0 1 .75-.75H19.49a.75.75 0 0 1 .75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTurnDownRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.74 3.749a.75.75 0 0 1 .75.75V15h13.938l-2.47-2.47a.75.75 0 0 1 1.061-1.06l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 0 1-1.06-1.06l2.47-2.47H3.738a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 .75-.751Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTurnDownLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.239 3.749a.75.75 0 0 0-.75.75V15H5.549l2.47-2.47a.75.75 0 0 0-1.06-1.06l-3.75 3.75a.75.75 0 0 0 0 1.06l3.75 3.75a.75.75 0 1 0 1.06-1.06L5.55 16.5h14.69a.75.75 0 0 0 .75-.75V4.5a.75.75 0 0 0-.75-.751Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTrendingUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.22 6.268a.75.75 0 0 1 .968-.431l5.942 2.28a.75.75 0 0 1 .431.97l-2.28 5.94a.75.75 0 1 1-1.4-.537l1.63-4.251-1.086.484a11.2 11.2 0 0 0-5.45 5.173.75.75 0 0 1-1.199.19L9 12.312l-6.22 6.22a.75.75 0 0 1-1.06-1.061l6.75-6.75a.75.75 0 0 1 1.06 0l3.606 3.606a12.695 12.695 0 0 1 5.68-4.974l1.086-.483-4.251-1.632a.75.75 0 0 1-.432-.97Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTrendingDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.72 5.47a.75.75 0 0 1 1.06 0L9 11.69l3.756-3.756a.75.75 0 0 1 .985-.066 12.698 12.698 0 0 1 4.575 6.832l.308 1.149 2.277-3.943a.75.75 0 1 1 1.299.75l-3.182 5.51a.75.75 0 0 1-1.025.275l-5.511-3.181a.75.75 0 0 1 .75-1.3l3.943 2.277-.308-1.149a11.194 11.194 0 0 0-3.528-5.617l-3.809 3.81a.75.75 0 0 1-1.06 0L1.72 6.53a.75.75 0 0 1 0-1.061Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowTopRightOnSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.75 2.25H21a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V4.81L8.03 17.03a.75.75 0 0 1-1.06-1.06L19.19 3.75h-3.44a.75.75 0 0 1 0-1.5Zm-10.5 4.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V10.5a.75.75 0 0 1 1.5 0v8.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h8.25a.75.75 0 0 1 0 1.5H5.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowSmallUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 20.25a.75.75 0 0 1-.75-.75V6.31l-5.47 5.47a.75.75 0 0 1-1.06-1.06l6.75-6.75a.75.75 0 0 1 1.06 0l6.75 6.75a.75.75 0 1 1-1.06 1.06l-5.47-5.47V19.5a.75.75 0 0 1-.75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowSmallRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 12a.75.75 0 0 1 .75-.75h13.19l-5.47-5.47a.75.75 0 0 1 1.06-1.06l6.75 6.75a.75.75 0 0 1 0 1.06l-6.75 6.75a.75.75 0 1 1-1.06-1.06l5.47-5.47H4.5a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowSmallLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.25 12a.75.75 0 0 1-.75.75H6.31l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6.75-6.75a.75.75 0 0 1 0-1.06l6.75-6.75a.75.75 0 1 1 1.06 1.06l-5.47 5.47H19.5a.75.75 0 0 1 .75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowSmallDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 3.75a.75.75 0 0 1 .75.75v13.19l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6.75 6.75a.75.75 0 0 1-1.06 0l-6.75-6.75a.75.75 0 1 1 1.06-1.06l5.47 5.47V4.5a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowRightStartOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowRightOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowRightEndOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V15a.75.75 0 0 0-1.5 0v3.75a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3V9A.75.75 0 1 0 9 9V5.25a1.5 1.5 0 0 1 1.5-1.5h6Zm-5.03 4.72a.75.75 0 0 0 0 1.06l1.72 1.72H2.25a.75.75 0 0 0 0 1.5h10.94l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowRightCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm4.28 10.28a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H8.25a.75.75 0 0 0 0 1.5h5.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowPath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowPathRoundedSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 5.25c1.213 0 2.415.046 3.605.135a3.256 3.256 0 0 1 3.01 3.01c.044.583.077 1.17.1 1.759L17.03 8.47a.75.75 0 1 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06l-1.752 1.751c-.023-.65-.06-1.296-.108-1.939a4.756 4.756 0 0 0-4.392-4.392 49.422 49.422 0 0 0-7.436 0A4.756 4.756 0 0 0 3.89 8.282c-.017.224-.033.447-.046.672a.75.75 0 1 0 1.497.092c.013-.217.028-.434.044-.651a3.256 3.256 0 0 1 3.01-3.01c1.19-.09 2.392-.135 3.605-.135Zm-6.97 6.22a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.752-1.751c.023.65.06 1.296.108 1.939a4.756 4.756 0 0 0 4.392 4.392 49.413 49.413 0 0 0 7.436 0 4.756 4.756 0 0 0 4.392-4.392c.017-.223.032-.447.046-.672a.75.75 0 0 0-1.497-.092c-.013.217-.028.434-.044.651a3.256 3.256 0 0 1-3.01 3.01 47.953 47.953 0 0 1-7.21 0 3.256 3.256 0 0 1-3.01-3.01 47.759 47.759 0 0 1-.1-1.759L6.97 15.53a.75.75 0 0 0 1.06-1.06l-3-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowLongUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.47 2.47a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06l-2.47-2.47V21a.75.75 0 0 1-1.5 0V4.81L8.78 7.28a.75.75 0 0 1-1.06-1.06l3.75-3.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowLongRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.72 7.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 1 1-1.06-1.06l2.47-2.47H3a.75.75 0 0 1 0-1.5h16.19l-2.47-2.47a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowLongLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.28 7.72a.75.75 0 0 1 0 1.06l-2.47 2.47H21a.75.75 0 0 1 0 1.5H4.81l2.47 2.47a.75.75 0 1 1-1.06 1.06l-3.75-3.75a.75.75 0 0 1 0-1.06l3.75-3.75a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowLongDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25a.75.75 0 0 1 .75.75v16.19l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 1 1 1.06-1.06l2.47 2.47V3a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H21a.75.75 0 0 1 0 1.5H4.81l6.22 6.22a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowLeftStartOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V15a.75.75 0 0 0-1.5 0v3.75a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3V9A.75.75 0 1 0 9 9V5.25a1.5 1.5 0 0 1 1.5-1.5h6ZM5.78 8.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06l-1.72-1.72H15a.75.75 0 0 0 0-1.5H4.06l1.72-1.72a.75.75 0 0 0 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowLeftOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm5.03 4.72a.75.75 0 0 1 0 1.06l-1.72 1.72h10.94a.75.75 0 0 1 0 1.5H10.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowLeftEndOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm5.03 4.72a.75.75 0 0 1 0 1.06l-1.72 1.72h10.94a.75.75 0 0 1 0 1.5H10.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowLeftCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-4.28 9.22a.75.75 0 0 0 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h5.69a.75.75 0 0 0 0-1.5h-5.69l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25a.75.75 0 0 1 .75.75v16.19l6.22-6.22a.75.75 0 1 1 1.06 1.06l-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06l6.22 6.22V3a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowDownTray(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V3a.75.75 0 0 1 .75-.75Zm-9 13.5a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowDownRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.97 3.97a.75.75 0 0 1 1.06 0l13.72 13.72V8.25a.75.75 0 0 1 1.5 0V19.5a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1 0-1.5h9.44L3.97 5.03a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowDownOnSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1.5a.75.75 0 0 1 .75.75V7.5h-1.5V2.25A.75.75 0 0 1 12 1.5ZM11.25 7.5v5.69l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V7.5h3.75a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowDownOnSquareStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.75 6.75h-3a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3v-7.5a3 3 0 0 0-3-3h-3V1.5a.75.75 0 0 0-1.5 0v5.25Zm0 0h1.5v5.69l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72V6.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.151 21.75a2.999 2.999 0 0 0 2.599 1.5h7.5a3 3 0 0 0 3-3v-7.5c0-1.11-.603-2.08-1.5-2.599v7.099a4.5 4.5 0 0 1-4.5 4.5H7.151Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowDownLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.03 3.97a.75.75 0 0 1 0 1.06L6.31 18.75h9.44a.75.75 0 0 1 0 1.5H4.5a.75.75 0 0 1-.75-.75V8.25a.75.75 0 0 1 1.5 0v9.44L18.97 3.97a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArrowDownCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-.53 14.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V8.25a.75.75 0 0 0-1.5 0v5.69l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArchiveBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087Zm6.163 3.75A.75.75 0 0 1 10 12h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArchiveBoxXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087Zm6.133 2.845a.75.75 0 0 1 1.06 0l1.72 1.72 1.72-1.72a.75.75 0 1 1 1.06 1.06l-1.72 1.72 1.72 1.72a.75.75 0 1 1-1.06 1.06L12 15.685l-1.72 1.72a.75.75 0 1 1-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiArchiveBoxArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087ZM12 10.5a.75.75 0 0 1 .75.75v4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72v-4.94a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiAdjustmentsVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 1 1 1.5 0v7.5A.75.75 0 0 1 6 12ZM18 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 18 12ZM6.75 20.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM18.75 18.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0ZM12.75 5.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM12 21a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 12 21ZM3.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0ZM12 11.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5ZM15.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiAdjustmentsHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6ZM12 18a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18ZM3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM5.25 18.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5ZM3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12ZM9 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM9 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiAcademicCap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6 18 18 6M6 6l12 12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineXCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineWrench(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21.75 6.75a4.5 4.5 0 0 1-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 1 1-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 0 1 6.336-4.486l-3.276 3.276a3.004 3.004 0 0 0 2.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.867 19.125h.008v.008h-.008v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineWrenchScrewdriver(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineWindow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 8.25V18a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 21 18V8.25m-18 0V6a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6ZM7.5 6h.008v.008H7.5V6Zm2.25 0h.008v.008H9.75V6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineWifi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.288 15.038a5.25 5.25 0 0 1 7.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 0 1 1.06 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineViewfinderCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7.5 3.75H6A2.25 2.25 0 0 0 3.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0 1 20.25 6v1.5m0 9V18A2.25 2.25 0 0 1 18 20.25h-1.5m-9 0H6A2.25 2.25 0 0 1 3.75 18v-1.5M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineViewColumns(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineVideoCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineVideoCameraSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 0 1-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 0 0-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineVariable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.745 3A23.933 23.933 0 0 0 3 12c0 3.183.62 6.22 1.745 9M19.5 3c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.885l1.444-.89a.75.75 0 0 1 1.105.402l2.402 7.206a.75.75 0 0 0 1.104.401l1.445-.889m-8.25.75.213.09a1.687 1.687 0 0 0 2.062-.617l4.45-6.676a1.688 1.688 0 0 1 2.062-.618l.213.09"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUsers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUserPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUserMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M22 10.5h-6m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 10.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUserGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineUnderline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17.995 3.744v7.5a6 6 0 1 1-12 0v-7.5m-2.25 16.502h16.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTruck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTrophy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16.5 18.75h-9m9 0a3 3 0 0 1 3 3h-15a3 3 0 0 1 3-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 0 1-.982-3.172M9.497 14.25a7.454 7.454 0 0 0 .981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 0 0 7.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 0 0 2.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 0 1 2.916.52 6.003 6.003 0 0 1-5.395 4.972m0 0a6.726 6.726 0 0 1-2.749 1.35m0 0a6.772 6.772 0 0 1-3.044 0"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTicket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6 6h.008v.008H6V6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineTableCells(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineStrikethrough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 12a8.912 8.912 0 0 1-.318-.079c-1.585-.424-2.904-1.247-3.76-2.236-.873-1.009-1.265-2.19-.968-3.301.59-2.2 3.663-3.29 6.863-2.432A8.186 8.186 0 0 1 16.5 5.21M6.42 17.81c.857.99 2.176 1.812 3.761 2.237 3.2.858 6.274-.23 6.863-2.431.233-.868.044-1.779-.465-2.617M3.75 12h16.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineStopCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 0 1 9 14.437V9.564Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSquaresPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSquares2X2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSquare3Stack3D(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSquare2Stack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSpeakerXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17.25 9.75 19.5 12m0 0 2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6 4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSpeakerWave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m9 20.247 6-16.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSignal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.348 14.652a3.75 3.75 0 0 1 0-5.304m5.304 0a3.75 3.75 0 0 1 0 5.304m-7.425 2.121a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788M12 12h.008v.008H12V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineSignalSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m3 3 8.735 8.735m0 0a.374.374 0 1 1 .53.53m-.53-.53.53.53m0 0L21 21M14.652 9.348a3.75 3.75 0 0 1 0 5.304m2.121-7.425a6.75 6.75 0 0 1 0 9.546m2.121-11.667c3.808 3.807 3.808 9.98 0 13.788m-9.546-4.242a3.733 3.733 0 0 1-1.06-2.122m-1.061 4.243a6.75 6.75 0 0 1-1.625-6.929m-.496 9.05c-3.068-3.067-3.664-7.67-1.79-11.334M12 12h.008v.008H12V12Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineShoppingCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineShoppingBag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineShieldExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 9v3.75m0-10.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.25-8.25-3.286Zm0 13.036h.008v.008H12v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineShieldCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineServer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21.75 17.25v-.228a4.5 4.5 0 0 0-.12-1.03l-2.268-9.64a3.375 3.375 0 0 0-3.285-2.602H7.923a3.375 3.375 0 0 0-3.285 2.602l-2.268 9.64a4.5 4.5 0 0 0-.12 1.03v.228m19.5 0a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3m19.5 0a3 3 0 0 0-3-3H5.25a3 3 0 0 0-3 3m16.5 0h.008v.008h-.008v-.008Zm-3 0h.008v.008h-.008v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineServerStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.25 14.25h13.5m-13.5 0a3 3 0 0 1-3-3m3 3a3 3 0 1 0 0 6h13.5a3 3 0 1 0 0-6m-16.5-3a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3m-19.5 0a4.5 4.5 0 0 1 .9-2.7L5.737 5.1a3.375 3.375 0 0 1 2.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 0 1 .9 2.7m0 0a3 3 0 0 1-3 3m0 3h.008v.008h-.008v-.008Zm0-6h.008v.008h-.008v-.008Zm-3 6h.008v.008h-.008v-.008Zm0-6h.008v.008h-.008v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m7.848 8.25 1.536.887M7.848 8.25a3 3 0 1 1-5.196-3 3 3 0 0 1 5.196 3Zm1.536.887a2.165 2.165 0 0 1 1.083 1.839c.005.351.054.695.14 1.024M9.384 9.137l2.077 1.199M7.848 15.75l1.536-.887m-1.536.887a3 3 0 1 1-5.196 3 3 3 0 0 1 5.196-3Zm1.536-.887a2.165 2.165 0 0 0 1.083-1.838c.005-.352.054-.695.14-1.025m-1.223 2.863 2.077-1.199m0-3.328a4.323 4.323 0 0 1 2.068-1.379l5.325-1.628a4.5 4.5 0 0 1 2.48-.044l.803.215-7.794 4.5m-2.882-1.664A4.33 4.33 0 0 0 10.607 12m3.736 0 7.794 4.5-.802.215a4.5 4.5 0 0 1-2.48-.043l-5.326-1.629a4.324 4.324 0 0 1-2.068-1.379M14.343 12l-2.882 1.664"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineScale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12.75 19.5v-.75a7.5 7.5 0 0 0-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineRocketLaunch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineRectangleStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.246 2.246 0 0 0-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineRectangleGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineReceiptRefund(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.25 9.75h4.875a2.625 2.625 0 0 1 0 5.25H12M8.25 9.75 10.5 7.5M8.25 9.75 10.5 12m9-7.243V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineReceiptPercent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m9 14.25 6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185ZM9.75 9h.008v.008H9.75V9Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008V13.5Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineRadio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m3.75 7.5 16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 0 0 4.5 21h15a2.25 2.25 0 0 0 2.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0 0 12 6.75Zm-1.683 6.443-.005.005-.006-.005.006-.005.005.005Zm-.005 2.127-.005-.006.005-.005.005.005-.005.005Zm-2.116-.006-.005.006-.006-.006.005-.005.006.005Zm-.005-2.116-.006-.005.006-.005.005.005-.005.005ZM9.255 10.5v.008h-.008V10.5h.008Zm3.249 1.88-.007.004-.003-.007.006-.003.004.006Zm-1.38 5.126-.003-.006.006-.004.004.007-.006.003Zm.007-6.501-.003.006-.007-.003.004-.007.006.004Zm1.37 5.129-.007-.004.004-.006.006.003-.004.007Zm.504-1.877h-.008v-.007h.008v.007ZM9.255 18v.008h-.008V18h.008Zm-3.246-1.87-.007.004L6 16.127l.006-.003.004.006Zm1.366-5.119-.004-.006.006-.004.004.007-.006.003ZM7.38 17.5l-.003.006-.007-.003.004-.007.006.004Zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007Zm-.5 1.873h-.008v-.007h.008v.007ZM17.25 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm0 4.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineQueueList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineQuestionMarkCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineQrCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePuzzlePiece(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePrinter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePresentationChartLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePresentationChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 4.5v15m7.5-7.5h-15"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePlusSmall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6v12m6-6H6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePlusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePlayPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 7.5V18M15 7.5V18M3 16.811V8.69c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePlayCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePhoto(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePhoneXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 3.75 18 6m0 0 2.25 2.25M18 6l2.25-2.25M18 6l-2.25 2.25m1.5 13.5c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePhoneArrowUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.25 3.75v4.5m0-4.5h-4.5m4.5 0-6 6m3 12c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePhoneArrowDownLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0 6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePercentBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m8.99 14.993 6-6m6 3.001c0 1.268-.63 2.39-1.593 3.069a3.746 3.746 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043 3.745 3.745 0 0 1-3.068 1.593c-1.268 0-2.39-.63-3.068-1.593a3.745 3.745 0 0 1-3.296-1.043 3.746 3.746 0 0 1-1.043-3.297 3.746 3.746 0 0 1-1.593-3.068c0-1.268.63-2.39 1.593-3.068a3.746 3.746 0 0 1 1.043-3.297 3.745 3.745 0 0 1 3.296-1.042 3.745 3.745 0 0 1 3.068-1.594c1.268 0 2.39.63 3.068 1.593a3.745 3.745 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.297 3.746 3.746 0 0 1 1.593 3.068ZM9.74 9.743h.008v.007H9.74v-.007Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePencil(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePencilSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 5.25v13.5m-7.5-13.5v13.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePauseCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.25 9v6m-4.5 0V9M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePaperClip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePaperAirplane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlinePaintBrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.53 16.122a3 3 0 0 0-5.78 1.128 2.25 2.25 0 0 1-2.4 2.245 4.5 4.5 0 0 0 8.4-2.245c0-.399-.078-.78-.22-1.128Zm0 0a15.998 15.998 0 0 0 3.388-1.62m-5.043-.025a15.994 15.994 0 0 1 1.622-3.395m3.42 3.42a15.995 15.995 0 0 0 4.764-4.648l3.876-5.814a1.151 1.151 0 0 0-1.597-1.597L14.146 6.32a15.996 15.996 0 0 0-4.649 4.763m3.42 3.42a6.776 6.776 0 0 0-3.42-3.42"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineNumberedList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.242 5.992h12m-12 6.003H20.24m-12 5.999h12M4.117 7.495v-3.75H2.99m1.125 3.75H2.99m1.125 0H5.24m-1.92 2.577a1.125 1.125 0 1 1 1.591 1.59l-1.83 1.83h2.16M2.99 15.745h1.125a1.125 1.125 0 0 1 0 2.25H3.74m0-.002h.375a1.125 1.125 0 0 1 0 2.25H2.99"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineNoSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMusicalNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m9 9 10.5-3m0 6.553v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 1 1-.99-3.467l2.31-.66a2.25 2.25 0 0 0 1.632-2.163Zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 0 1-.99-3.467l2.31-.66A2.25 2.25 0 0 0 9 15.553Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5 12h14"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMinusSmall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M18 12H6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMinusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMicrophone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMegaphone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMapPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMagnifyingGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMagnifyingGlassPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMagnifyingGlassMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM13.5 10.5h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineMagnifyingGlassCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m15.75 15.75-2.489-2.489m0 0a3.375 3.375 0 1 0-4.773-4.773 3.375 3.375 0 0 0 4.774 4.774ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLockOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.5 10.5V6.75a4.5 4.5 0 1 1 9 0v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLockClosed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineListBullet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLinkSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.181 8.68a4.503 4.503 0 0 1 1.903 6.405m-9.768-2.782L3.56 14.06a4.5 4.5 0 0 0 6.364 6.365l3.129-3.129m5.614-5.615 1.757-1.757a4.5 4.5 0 0 0-6.364-6.365l-4.5 4.5c-.258.26-.479.541-.661.84m1.903 6.405a4.495 4.495 0 0 1-1.242-.88 4.483 4.483 0 0 1-1.062-1.683m6.587 2.345 5.907 5.907m-5.907-5.907L8.898 8.898M2.991 2.99 8.898 8.9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLightBulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLifebuoy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16.712 4.33a9.027 9.027 0 0 1 1.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 0 0-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 0 1 0 9.424m-4.138-5.976a3.736 3.736 0 0 0-.88-1.388 3.737 3.737 0 0 0-1.388-.88m2.268 2.268a3.765 3.765 0 0 1 0 2.528m-2.268-4.796a3.765 3.765 0 0 0-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 0 1-1.388.88m2.268-2.268 4.138 3.448m0 0a9.027 9.027 0 0 1-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.014 9.014 0 0 1-9.424 0m5.976-4.138a3.765 3.765 0 0 1-2.528 0m0 0a3.736 3.736 0 0 1-1.388-.88 3.737 3.737 0 0 1-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 0 1-1.652-1.306 9.027 9.027 0 0 1-1.306-1.652m0 0 4.138-3.448M4.33 16.712a9.014 9.014 0 0 1 0-9.424m4.138 5.976a3.765 3.765 0 0 1 0-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 0 1 1.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 0 0-1.652 1.306A9.025 9.025 0 0 0 4.33 7.288"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineLanguage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineItalic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.248 20.246H9.05m0 0h3.696m-3.696 0 5.893-16.502m0 0h-3.697m3.697 0h3.803"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineInformationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineInbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineInboxStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m7.875 14.25 1.214 1.942a2.25 2.25 0 0 0 1.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 0 1 1.872 1.002l.164.246a2.25 2.25 0 0 0 1.872 1.002h2.092a2.25 2.25 0 0 0 1.872-1.002l.164-.246A2.25 2.25 0 0 1 16.954 9h4.636M2.41 9a2.25 2.25 0 0 0-.16.832V12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 0 1 .382-.632l3.285-3.832a2.25 2.25 0 0 1 1.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0 0 21.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 0 0 2.25 2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineInboxArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineIdentification(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHomeModern(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205 3 1m1.5.5-1.5-.5M6.75 7.364V3h-3v18m3-13.636 10.5-3.819"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHashtag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHandThumbUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHandThumbDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12.137 12.137 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.498 15.25c.618 0 .991.724.725 1.282A7.471 7.471 0 0 0 7.5 19.75 2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75c.01.05.027.1.05.148.593 1.2.925 2.55.925 3.977 0 1.487-.36 2.89-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 0 0 .303-.54"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineHandRaised(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.05 4.575a1.575 1.575 0 1 0-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 0 1 3.15 0v1.5m-3.15 0 .075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 0 1 3.15 0V15M6.9 7.575a1.575 1.575 0 1 0-3.15 0v8.175a6.75 6.75 0 0 0 6.75 6.75h2.018a5.25 5.25 0 0 0 3.712-1.538l1.732-1.732a5.25 5.25 0 0 0 1.538-3.712l.003-2.024a.668.668 0 0 1 .198-.471 1.575 1.575 0 1 0-2.228-2.228 3.818 3.818 0 0 0-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0 1 16.35 15m.002 0h-.002"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineH3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.905 14.626a4.52 4.52 0 0 1 .738 3.603c-.154.695-.794 1.143-1.504 1.208a15.194 15.194 0 0 1-3.639-.104m4.405-4.707a4.52 4.52 0 0 0 .738-3.603c-.154-.696-.794-1.144-1.504-1.209a15.19 15.19 0 0 0-3.639.104m4.405 4.708H18M2.243 4.493v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineH2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21.75 19.5H16.5v-1.609a2.25 2.25 0 0 1 1.244-2.012l2.89-1.445c.651-.326 1.116-.955 1.116-1.683 0-.498-.04-.987-.118-1.463-.135-.825-.835-1.422-1.668-1.489a15.202 15.202 0 0 0-3.464.12M2.243 4.492v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineH1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.243 4.493v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501m4.501-8.627 2.25-1.5v10.126m0 0h-2.25m2.25 0h2.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineGlobeEuropeAfrica(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m20.893 13.393-1.135-1.135a2.252 2.252 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.411-2.353a2.25 2.25 0 0 0 .286-.76m11.928 9.869A9 9 0 0 0 8.965 3.525m11.928 9.868A9 9 0 1 1 8.965 3.525"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineGlobeAsiaAustralia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 0 0-8.862 12.872M12.75 3.031a9 9 0 0 1 6.69 14.036m0 0-.177-.529A2.25 2.25 0 0 0 17.128 15H16.5l-.324-.324a1.453 1.453 0 0 0-2.328.377l-.036.073a1.586 1.586 0 0 1-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 0 1-5.276 3.67m0 0a9 9 0 0 1-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineGlobeAmericas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m6.115 5.19.319 1.913A6 6 0 0 0 8.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 0 0 2.288-4.042 1.087 1.087 0 0 0-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 0 1-.98-.314l-.295-.295a1.125 1.125 0 0 1 0-1.591l.13-.132a1.125 1.125 0 0 1 1.3-.21l.603.302a.809.809 0 0 0 1.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 0 0 1.528-1.732l.146-.292M6.115 5.19A9 9 0 1 0 17.18 4.64M6.115 5.19A8.965 8.965 0 0 1 12 3c1.929 0 3.716.607 5.18 1.64"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineGlobeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.625 11.505v8.25a1.5 1.5 0 0 1-1.5 1.5H4.875a1.5 1.5 0 0 1-1.5-1.5v-8.25m8.25-6.375A2.625 2.625 0 1 0 9 7.755h2.625m0-2.625v2.625m0-2.625a2.625 2.625 0 1 1 2.625 2.625h-2.625m0 0v13.5M3 11.505h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.622-.504-1.125-1.125-1.125H3c-.621 0-1.125.503-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineGiftTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 3.75v16.5M2.25 12h19.5M6.375 17.25a4.875 4.875 0 0 0 4.875-4.875V12m6.375 5.25a4.875 4.875 0 0 1-4.875-4.875V12m-9 8.25h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5Zm12.621-9.44c-1.409 1.41-4.242 1.061-4.242 1.061s-.349-2.833 1.06-4.242a2.25 2.25 0 0 1 3.182 3.182ZM10.773 7.63c1.409 1.409 1.06 4.242 1.06 4.242S9 12.22 7.592 10.811a2.25 2.25 0 1 1 3.182-3.182Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineGif(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12.75 8.25v7.5m6-7.5h-3V12m0 0v3.75m0-3.75H18M9.75 9.348c-1.03-1.464-2.698-1.464-3.728 0-1.03 1.465-1.03 3.84 0 5.304 1.03 1.464 2.699 1.464 3.728 0V12h-1.5M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFunnel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811V8.69ZM12.75 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061a1.125 1.125 0 0 1-1.683-.977V8.69Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFolderPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 10.5v6m3-3H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFolderMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 13.5H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFolderArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m9 13.5 3 3m0 0 3-3m-3 3v-6m1.06-4.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.047 8.287 8.287 0 0 0 9 9.601a8.983 8.983 0 0 1 3.361-6.867 8.21 8.21 0 0 0 3 2.48Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 18a3.75 3.75 0 0 0 .495-7.468 5.99 5.99 0 0 0-1.925 3.547 5.975 5.975 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFingerPrint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0 1 18 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0 1 18 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 0 1 6 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFaceSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineFaceFrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.182 16.318A4.486 4.486 0 0 0 12.016 15a4.486 4.486 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEyeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEyeDropper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m15 11.25 1.5 1.5.75-.75V8.758l2.276-.61a3 3 0 1 0-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5M15 11.25l-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.19-1.28.53l-.97.97-.75-.75.97-.97c.34-.34.53-.8.53-1.28s.19-.94.53-1.28L12.75 9M15 11.25 12.75 9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineExclamationTriangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineExclamationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEquals(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.499 8.248h15m-15 7.501h15"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEllipsisVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEllipsisHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineEllipsisHorizontalCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentMagnifyingGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentDuplicate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentCurrencyYen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m1.5 9 2.25 3m0 0 2.25-3m-2.25 3v4.5M9.75 15h4.5m-4.5 2.25h4.5m-3.75-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentCurrencyRupee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 9h3.75m-4.5 2.625h4.5M12 18.75 9.75 16.5h.375a2.625 2.625 0 0 0 0-5.25H9.75m.75-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentCurrencyPound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.621 9.879a3 3 0 0 0-5.02 2.897l.164.609a4.5 4.5 0 0 1-.108 2.676l-.157.439.44-.22a2.863 2.863 0 0 1 2.185-.155c.72.24 1.507.184 2.186-.155L15 18M8.25 15.75H12m-1.5-13.5H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentCurrencyEuro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 11.625h4.5m-4.5 2.25h4.5m2.121 1.527c-1.171 1.464-3.07 1.464-4.242 0-1.172-1.465-1.172-3.84 0-5.304 1.171-1.464 3.07-1.464 4.242 0M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentCurrencyDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v7.5m2.25-6.466a9.016 9.016 0 0 0-3.461-.203c-.536.072-.974.478-1.021 1.017a4.559 4.559 0 0 0-.018.402c0 .464.336.844.775.994l2.95 1.012c.44.15.775.53.775.994 0 .136-.006.27-.018.402-.047.539-.485.945-1.021 1.017a9.077 9.077 0 0 1-3.461-.203M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentCurrencyBangladeshi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 8.25.22-.22a.75.75 0 0 1 1.28.53v6.441c0 .472.214.934.64 1.137a3.75 3.75 0 0 0 4.994-1.77c.205-.428-.152-.868-.627-.868h-.507m-6-2.25h7.5M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12-3-3m0 0-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDocumentArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDivide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.499 11.998h15m-7.5-6.75h.008v.008h-.008v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM12 18.751h.007v.007H12v-.007Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDeviceTablet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-15a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 4.5v15a2.25 2.25 0 0 0 2.25 2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineDevicePhoneMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCursorArrowRipple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672Zm-7.518-.267A8.25 8.25 0 1 1 20.25 10.5M8.288 14.212A5.25 5.25 0 1 1 17.25 10.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCursorArrowRays(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyYen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m9 7.5 3 4.5m0 0 3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyRupee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 8.25H9m6 3H9m3 6-3-3h1.5a3 3 0 1 0 0-6M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyPound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.121 7.629A3 3 0 0 0 9.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 0 1-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 0 1 1.422 0l.655.218a2.25 2.25 0 0 0 1.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyEuro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCurrencyBangladeshi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m8.25 7.5.415-.207a.75.75 0 0 1 1.085.67V10.5m0 0h6m-6 0h-1.5m1.5 0v5.438c0 .354.161.697.473.865a3.751 3.751 0 0 0 5.452-2.553c.083-.409-.263-.75-.68-.75h-.745M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCubeTransparent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCpuChip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25Zm.75-12h9v9h-9v-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineComputerDesktop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCommandLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m6.75 7.5 3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0 0 21 18V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v12a2.25 2.25 0 0 0 2.25 2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m6.894 5.785-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCog8Tooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCog6Tooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCodeBracket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCodeBracketSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.25 9.75 16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCloudArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCloudArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 9.75v6.75m0 0-3-3m3 3 3-3m-8.25 6a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineClipboardDocument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineClipboardDocumentList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineClipboardDocumentCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCircleStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m4.5 15.75 7.5-7.5 7.5 7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronUpDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m8.25 4.5 7.5 7.5-7.5 7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 19.5 8.25 12l7.5-7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m19.5 8.25-7.5 7.5-7.5-7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronDoubleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m4.5 18.75 7.5-7.5 7.5 7.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m4.5 12.75 7.5-7.5 7.5 7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronDoubleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronDoubleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChevronDoubleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m4.5 12.75 6 6 9-13.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCheckBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChatBubbleOvalLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChatBubbleOvalLeftEllipsis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChatBubbleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChatBubbleLeftRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChatBubbleLeftEllipsis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChatBubbleBottomCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChatBubbleBottomCenterText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChartPie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineChartBarSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCalendarDays(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCalendarDateRange(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6.75 2.994v2.25m10.5-2.25v2.25m-14.252 13.5V7.491a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v11.251m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-6.75-6h2.25m-9 2.25h4.5m.002-2.25h.005v.006H12v-.006Zm-.001 4.5h.006v.006h-.006v-.005Zm-2.25.001h.005v.006H9.75v-.006Zm-2.25 0h.005v.005h-.006v-.005Zm6.75-2.247h.005v.005h-.005v-.005Zm0 2.247h.006v.006h-.006v-.006Zm2.25-2.248h.006V15H16.5v-.005Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineCake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.871c1.355 0 2.697.056 4.024.166C17.155 8.51 18 9.473 18 10.608v2.513M15 8.25v-1.5m-6 1.5v-1.5m12 9.75-1.5.75a3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0L3 16.5m15-3.379a48.474 48.474 0 0 0-6-.371c-2.032 0-4.034.126-6 .371m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.169c0 .621-.504 1.125-1.125 1.125H4.125A1.125 1.125 0 0 1 3 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 0 1 6 13.12M12.265 3.11a.375.375 0 1 1-.53 0L12 2.845l.265.265Zm-3 0a.375.375 0 1 1-.53 0L9 2.845l.265.265Zm6 0a.375.375 0 1 1-.53 0L15 2.845l.265.265Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBuildingStorefront(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBuildingOffice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBuildingOffice2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBuildingLibrary(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBugAnt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBookmarkSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0 1 20.25 6v12A2.25 2.25 0 0 1 18 20.25H6A2.25 2.25 0 0 1 3.75 18V6A2.25 2.25 0 0 1 6 3.75h1.5m9 0h-9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBookmarkSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m3 3 1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17.25 4.5 21V8.742m.164-4.078a2.15 2.15 0 0 1 1.743-1.342 48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185V19.5M4.664 4.664 19.5 19.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBookOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBoltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11.412 15.655 9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043M8.457 8.457 3 3m5.457 5.457 7.086 7.086m0 0L21 21"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBold(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinejoin": "round",
                    "d": "M6.75 3.744h-.753v8.25h7.125a4.125 4.125 0 0 0 0-8.25H6.75Zm0 0v.38m0 16.122h6.747a4.5 4.5 0 0 0 0-9.001h-7.5v9h.753Zm0 0v-.37m0-15.751h6a3.75 3.75 0 1 1 0 7.5h-6m0-7.5v7.5m0 0v8.25m0-8.25h6.375a4.125 4.125 0 0 1 0 8.25H6.75m.747-15.38h4.875a3.375 3.375 0 0 1 0 6.75H7.497v-6.75Zm0 7.5h5.25a3.75 3.75 0 0 1 0 7.5h-5.25v-7.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBellSnooze(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M10.5 8.25h3l-3 4.5h3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBellSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.143 17.082a24.248 24.248 0 0 0 3.844.148m-3.844-.148a23.856 23.856 0 0 1-5.455-1.31 8.964 8.964 0 0 0 2.3-5.542m3.155 6.852a3 3 0 0 0 5.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 0 0 3.536-1.003A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBellAlert(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBeaker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBattery50(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5h6.75V15H4.5v-4.5ZM3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBattery100(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5H18V15H4.5v-4.5ZM3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBattery0(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBarsArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBarsArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBars4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBars3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBars3CenterLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBars3BottomRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBars3BottomLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBars2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 9h16.5m-16.5 6.75h16.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBanknotes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M21 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061A1.125 1.125 0 0 1 21 8.689v8.122ZM11.25 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061a1.125 1.125 0 0 1 1.683.977v8.122Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineBackspace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25m-2.58 4.92-6.374-6.375a1.125 1.125 0 0 1 0-1.59L9.42 4.83c.21-.211.497-.33.795-.33H19.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25h-9.284c-.298 0-.585-.119-.795-.33Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineAtSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowsUpDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowsRightLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowsPointingOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowsPointingIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUturnUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m9 9 6-6m0 0 6 6m-6-6v12a6 6 0 0 1-12 0v-3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUturnRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m15 15 6-6m0 0-6-6m6 6H9a6 6 0 0 0 0 12h3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUturnLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUturnDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m15 15-6 6m0 0-6-6m6 6V9a6 6 0 0 1 12 0v3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUpTray(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUpOnSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUpOnSquareStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m0-3-3-3m0 0-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUpLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m19.5 19.5-15-15m0 0v11.25m0-11.25h11.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowUpCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTurnUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m16.49 12 3.75-3.751m0 0-3.75-3.75m3.75 3.75H3.74V19.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTurnUpLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7.49 12 3.74 8.248m0 0 3.75-3.75m-3.75 3.75h16.5V19.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTurnRightUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m11.99 7.5 3.75-3.75m0 0 3.75 3.75m-3.75-3.75v16.499H4.49"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTurnRightDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m11.99 16.5 3.75 3.75m0 0 3.75-3.75m-3.75 3.75V3.75H4.49"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTurnLeftUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M11.99 7.5 8.24 3.75m0 0L4.49 7.5m3.75-3.75v16.499h11.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTurnLeftDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m11.99 16.5-3.75 3.75m0 0L4.49 16.5m3.75 3.75V3.75h11.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTurnDownRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m16.49 12 3.75 3.75m0 0-3.75 3.75m3.75-3.75H3.74V4.499"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTurnDownLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m7.49 12-3.75 3.75m0 0 3.75 3.75m-3.75-3.75h16.5V4.499"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTrendingUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTrendingDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowTopRightOnSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowSmallUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 19.5v-15m0 0-6.75 6.75M12 4.5l6.75 6.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowSmallRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.5 12h15m0 0-6.75-6.75M19.5 12l-6.75 6.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowSmallLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 12h-15m0 0 6.75 6.75M4.5 12l6.75-6.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowSmallDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M12 4.5v15m0 0 6.75-6.75M12 19.5l-6.75-6.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowRightStartOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowRightOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowRightEndOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowRightCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowPath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowPathRoundedSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowLongUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.25 6.75 12 3m0 0 3.75 3.75M12 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowLongRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowLongLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowLongDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 17.25 12 21m0 0-3.75-3.75M12 21V3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowLeftStartOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowLeftOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowLeftEndOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowLeftCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowDownTray(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowDownRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m4.5 4.5 15 15m0 0V8.25m0 11.25H8.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowDownOnSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowDownOnSquareStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m-6 3.75 3 3m0 0 3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowDownLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m19.5 4.5-15 15m0 0h11.25m-11.25 0V8.25"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArrowDownCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArchiveBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArchiveBoxXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineArchiveBoxArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0-3-3m3 3 3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineAdjustmentsVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineAdjustmentsHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
                },
                "child": []
            }
        ]
    })(props);
}
function HiOutlineAcademicCap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24",
            "strokeWidth": "1.5",
            "stroke": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "d": "M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniXCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniWrench(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19 5.5a4.5 4.5 0 0 1-4.791 4.49c-.873-.055-1.808.128-2.368.8l-6.024 7.23a2.724 2.724 0 1 1-3.837-3.837L9.21 8.16c.672-.56.855-1.495.8-2.368a4.5 4.5 0 0 1 5.873-4.575c.324.105.39.51.15.752L13.34 4.66a.455.455 0 0 0-.11.494 3.01 3.01 0 0 0 1.617 1.617c.17.07.363.02.493-.111l2.692-2.692c.241-.241.647-.174.752.15.14.435.216.9.216 1.382ZM4 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniWrenchScrewdriver(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.5 10a4.5 4.5 0 0 0 4.284-5.882c-.105-.324-.51-.391-.752-.15L15.34 6.66a.454.454 0 0 1-.493.11 3.01 3.01 0 0 1-1.618-1.616.455.455 0 0 1 .11-.494l2.694-2.692c.24-.241.174-.647-.15-.752a4.5 4.5 0 0 0-5.873 4.575c.055.873-.128 1.808-.8 2.368l-7.23 6.024a2.724 2.724 0 1 0 3.837 3.837l6.024-7.23c.56-.672 1.495-.855 2.368-.8.096.007.193.01.291.01ZM5 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 11.5c.173 0 .345-.007.514-.022l3.754 3.754a2.5 2.5 0 0 1-3.536 3.536l-4.41-4.41 2.172-2.607c.052-.063.147-.138.342-.196.202-.06.469-.087.777-.067.128.008.257.012.387.012ZM6 4.586l2.33 2.33a.452.452 0 0 1-.08.09L6.8 8.214 4.586 6H3.309a.5.5 0 0 1-.447-.276l-1.7-3.402a.5.5 0 0 1 .093-.577l.49-.49a.5.5 0 0 1 .577-.094l3.402 1.7A.5.5 0 0 1 6 3.31v1.277Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniWindow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.25 2A2.25 2.25 0 0 0 2 4.25v11.5A2.25 2.25 0 0 0 4.25 18h11.5A2.25 2.25 0 0 0 18 15.75V4.25A2.25 2.25 0 0 0 15.75 2H4.25ZM3.5 8v7.75c0 .414.336.75.75.75h11.5a.75.75 0 0 0 .75-.75V8h-13ZM5 4.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V5a.75.75 0 0 0-.75-.75H5ZM7.25 5A.75.75 0 0 1 8 4.25h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H8a.75.75 0 0 1-.75-.75V5ZM11 4.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V5a.75.75 0 0 0-.75-.75H11Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniWifi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.676 6.941A12.964 12.964 0 0 1 10 3c3.657 0 6.963 1.511 9.324 3.941a.75.75 0 0 1-.008 1.053l-.353.354a.75.75 0 0 1-1.069-.008C15.894 6.28 13.097 5 10 5 6.903 5 4.106 6.28 2.106 8.34a.75.75 0 0 1-1.069.008l-.353-.354a.75.75 0 0 1-.008-1.053Zm2.825 2.833A8.976 8.976 0 0 1 10 7a8.976 8.976 0 0 1 6.499 2.774.75.75 0 0 1-.011 1.049l-.354.354a.75.75 0 0 1-1.072-.012A6.978 6.978 0 0 0 10 9c-1.99 0-3.786.83-5.061 2.165a.75.75 0 0 1-1.073.012l-.354-.354a.75.75 0 0 1-.01-1.05Zm2.82 2.84A4.989 4.989 0 0 1 10 11c1.456 0 2.767.623 3.68 1.614a.75.75 0 0 1-.022 1.039l-.354.354a.75.75 0 0 1-1.085-.026A2.99 2.99 0 0 0 10 13c-.88 0-1.67.377-2.22.981a.75.75 0 0 1-1.084.026l-.354-.354a.75.75 0 0 1-.021-1.039Zm2.795 2.752a1.248 1.248 0 0 1 1.768 0 .75.75 0 0 1 0 1.06l-.354.354a.75.75 0 0 1-1.06 0l-.354-.353a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 4.25a3.733 3.733 0 0 1 2.25-.75h13.5c.844 0 1.623.279 2.25.75A2.25 2.25 0 0 0 16.75 2H3.25A2.25 2.25 0 0 0 1 4.25ZM1 7.25a3.733 3.733 0 0 1 2.25-.75h13.5c.844 0 1.623.279 2.25.75A2.25 2.25 0 0 0 16.75 5H3.25A2.25 2.25 0 0 0 1 7.25ZM7 8a1 1 0 0 1 1 1 2 2 0 1 0 4 0 1 1 0 0 1 1-1h3.75A2.25 2.25 0 0 1 19 10.25v5.5A2.25 2.25 0 0 1 16.75 18H3.25A2.25 2.25 0 0 1 1 15.75v-5.5A2.25 2.25 0 0 1 3.25 8H7Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniViewfinderCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.25 2A2.25 2.25 0 0 0 2 4.25v2a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 1 .75-.75h2a.75.75 0 0 0 0-1.5h-2ZM13.75 2a.75.75 0 0 0 0 1.5h2a.75.75 0 0 1 .75.75v2a.75.75 0 0 0 1.5 0v-2A2.25 2.25 0 0 0 15.75 2h-2ZM3.5 13.75a.75.75 0 0 0-1.5 0v2A2.25 2.25 0 0 0 4.25 18h2a.75.75 0 0 0 0-1.5h-2a.75.75 0 0 1-.75-.75v-2ZM18 13.75a.75.75 0 0 0-1.5 0v2a.75.75 0 0 1-.75.75h-2a.75.75 0 0 0 0 1.5h2A2.25 2.25 0 0 0 18 15.75v-2ZM7 10a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniViewColumns(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17h2.75A2.25 2.25 0 0 0 19 14.75v-9.5A2.25 2.25 0 0 0 16.75 3H14v14ZM12.5 3h-5v14h5V3ZM3.25 3H6v14H3.25A2.25 2.25 0 0 1 1 14.75v-9.5A2.25 2.25 0 0 1 3.25 3Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniVideoCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.25 4A2.25 2.25 0 0 0 1 6.25v7.5A2.25 2.25 0 0 0 3.25 16h7.5A2.25 2.25 0 0 0 13 13.75v-7.5A2.25 2.25 0 0 0 10.75 4h-7.5ZM19 4.75a.75.75 0 0 0-1.28-.53l-3 3a.75.75 0 0 0-.22.53v4.5c0 .199.079.39.22.53l3 3a.75.75 0 0 0 1.28-.53V4.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniVideoCameraSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13.75V7.182L9.818 16H3.25A2.25 2.25 0 0 1 1 13.75ZM13 6.25v6.568L4.182 4h6.568A2.25 2.25 0 0 1 13 6.25ZM19 4.75a.75.75 0 0 0-1.28-.53l-3 3a.75.75 0 0 0-.22.53v4.5c0 .199.079.39.22.53l3 3a.75.75 0 0 0 1.28-.53V4.75ZM2.28 4.22a.75.75 0 0 0-1.06 1.06l10.5 10.5a.75.75 0 1 0 1.06-1.06L2.28 4.22Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniVariable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.212 2.079a.75.75 0 0 1 1.006.336A16.932 16.932 0 0 1 18 10c0 2.724-.641 5.3-1.782 7.585a.75.75 0 1 1-1.342-.67A15.432 15.432 0 0 0 16.5 10c0-2.486-.585-4.834-1.624-6.915a.75.75 0 0 1 .336-1.006Zm-10.424 0a.75.75 0 0 1 .336 1.006A15.433 15.433 0 0 0 3.5 10c0 2.486.585 4.834 1.624 6.915a.75.75 0 1 1-1.342.67A16.933 16.933 0 0 1 2 10c0-2.724.641-5.3 1.782-7.585a.75.75 0 0 1 1.006-.336Zm2.285 3.554a1.5 1.5 0 0 1 2.219.677l.856 2.08 1.146-1.77a2.25 2.25 0 0 1 3.137-.65l.235.156a.75.75 0 1 1-.832 1.248l-.235-.156a.75.75 0 0 0-1.045.216l-1.71 2.644 1.251 3.04.739-.492a.75.75 0 1 1 .832 1.248l-.739.493a1.5 1.5 0 0 1-2.219-.677l-.856-2.08-1.146 1.77a2.25 2.25 0 0 1-3.137.65l-.235-.156a.75.75 0 0 1 .832-1.248l.235.157a.75.75 0 0 0 1.045-.217l1.71-2.644-1.251-3.04-.739.492a.75.75 0 0 1-.832-1.248l.739-.493Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniUsers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM1.615 16.428a1.224 1.224 0 0 1-.569-1.175 6.002 6.002 0 0 1 11.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 0 1 7 18a9.953 9.953 0 0 1-5.385-1.572ZM14.5 16h-.106c.07-.297.088-.611.048-.933a7.47 7.47 0 0 0-1.588-3.755 4.502 4.502 0 0 1 5.874 2.636.818.818 0 0 1-.36.98A7.465 7.465 0 0 1 14.5 16Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniUserPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM1.615 16.428a1.224 1.224 0 0 1-.569-1.175 6.002 6.002 0 0 1 11.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 0 1 7 18a9.953 9.953 0 0 1-5.385-1.572ZM16.25 5.75a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2v-2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniUserMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM2.046 15.253c-.058.468.172.92.57 1.175A9.953 9.953 0 0 0 8 18c1.982 0 3.83-.578 5.384-1.573.398-.254.628-.707.57-1.175a6.001 6.001 0 0 0-11.908 0ZM12.75 7.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniUserGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM1.49 15.326a.78.78 0 0 1-.358-.442 3 3 0 0 1 4.308-3.516 6.484 6.484 0 0 0-1.905 3.959c-.023.222-.014.442.025.654a4.97 4.97 0 0 1-2.07-.655ZM16.44 15.98a4.97 4.97 0 0 0 2.07-.654.78.78 0 0 0 .357-.442 3 3 0 0 0-4.308-3.517 6.484 6.484 0 0 1 1.907 3.96 2.32 2.32 0 0 1-.026.654ZM18 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM5.304 16.19a.844.844 0 0 1-.277-.71 5 5 0 0 1 9.947 0 .843.843 0 0 1-.277.71A6.975 6.975 0 0 1 10 18a6.974 6.974 0 0 1-4.696-1.81Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-5.5-2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM10 12a5.99 5.99 0 0 0-4.793 2.39A6.483 6.483 0 0 0 10 16.5a6.483 6.483 0 0 0 4.793-2.11A5.99 5.99 0 0 0 10 12Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniUnderline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.75 2a.75.75 0 0 1 .75.75V9a4.5 4.5 0 1 0 9 0V2.75a.75.75 0 0 1 1.5 0V9A6 6 0 0 1 4 9V2.75A.75.75 0 0 1 4.75 2ZM2 17.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniTv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5h12v7H4V5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 3.5A1.5 1.5 0 0 1 2.5 2h15A1.5 1.5 0 0 1 19 3.5v10a1.5 1.5 0 0 1-1.5 1.5H12v1.5h3.25a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5H8V15H2.5A1.5 1.5 0 0 1 1 13.5v-10Zm16.5 0h-15v10h15v-10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniTruck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 3c-1.051 0-2.093.04-3.125.117A1.49 1.49 0 0 0 2 4.607V10.5h9V4.606c0-.771-.59-1.43-1.375-1.489A41.568 41.568 0 0 0 6.5 3ZM2 12v2.5A1.5 1.5 0 0 0 3.5 16h.041a3 3 0 0 1 5.918 0h.791a.75.75 0 0 0 .75-.75V12H2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM13.25 5a.75.75 0 0 0-.75.75v8.514a3.001 3.001 0 0 1 4.893 1.44c.37-.275.61-.719.595-1.227a24.905 24.905 0 0 0-1.784-8.549A1.486 1.486 0 0 0 14.823 5H13.25ZM14.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniTrophy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 1c-1.828 0-3.623.149-5.371.435a.75.75 0 0 0-.629.74v.387c-.827.157-1.642.345-2.445.564a.75.75 0 0 0-.552.698 5 5 0 0 0 4.503 5.152 6 6 0 0 0 2.946 1.822A6.451 6.451 0 0 1 7.768 13H7.5A1.5 1.5 0 0 0 6 14.5V17h-.75C4.56 17 4 17.56 4 18.25c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75c0-.69-.56-1.25-1.25-1.25H14v-2.5a1.5 1.5 0 0 0-1.5-1.5h-.268a6.453 6.453 0 0 1-.684-2.202 6 6 0 0 0 2.946-1.822 5 5 0 0 0 4.503-5.152.75.75 0 0 0-.552-.698A31.804 31.804 0 0 0 16 2.562v-.387a.75.75 0 0 0-.629-.74A33.227 33.227 0 0 0 10 1ZM2.525 4.422C3.012 4.3 3.504 4.19 4 4.09V5c0 .74.134 1.448.38 2.103a3.503 3.503 0 0 1-1.855-2.68Zm14.95 0a3.503 3.503 0 0 1-1.854 2.68C15.866 6.449 16 5.74 16 5v-.91c.496.099.988.21 1.475.332Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniTrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniTicket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.75 3A2.25 2.25 0 0 1 18 5.25v1.214c0 .423-.277.788-.633 1.019A2.997 2.997 0 0 0 16 10c0 1.055.544 1.982 1.367 2.517.356.231.633.596.633 1.02v1.213A2.25 2.25 0 0 1 15.75 17H4.25A2.25 2.25 0 0 1 2 14.75v-1.213c0-.424.277-.789.633-1.02A2.998 2.998 0 0 0 4 10a2.997 2.997 0 0 0-1.367-2.517C2.277 7.252 2 6.887 2 6.463V5.25A2.25 2.25 0 0 1 4.25 3h11.5ZM13.5 7.396a.75.75 0 0 0-1.5 0v1.042a.75.75 0 0 0 1.5 0V7.396Zm0 4.167a.75.75 0 0 0-1.5 0v1.041a.75.75 0 0 0 1.5 0v-1.041Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v3.879a2.5 2.5 0 0 0 .732 1.767l7.5 7.5a2.5 2.5 0 0 0 3.536 0l3.878-3.878a2.5 2.5 0 0 0 0-3.536l-7.5-7.5A2.5 2.5 0 0 0 8.38 2H4.5ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniTableCells(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.99 5.24A2.25 2.25 0 0 1 3.25 3h13.5A2.25 2.25 0 0 1 19 5.25l.01 9.5A2.25 2.25 0 0 1 16.76 17H3.26A2.267 2.267 0 0 1 1 14.74l-.01-9.5Zm8.26 9.52v-.625a.75.75 0 0 0-.75-.75H3.25a.75.75 0 0 0-.75.75v.615c0 .414.336.75.75.75h5.373a.75.75 0 0 0 .627-.74Zm1.5 0a.75.75 0 0 0 .627.74h5.373a.75.75 0 0 0 .75-.75v-.615a.75.75 0 0 0-.75-.75H11.5a.75.75 0 0 0-.75.75v.625Zm6.75-3.63v-.625a.75.75 0 0 0-.75-.75H11.5a.75.75 0 0 0-.75.75v.625c0 .414.336.75.75.75h5.25a.75.75 0 0 0 .75-.75Zm-8.25 0v-.625a.75.75 0 0 0-.75-.75H3.25a.75.75 0 0 0-.75.75v.625c0 .414.336.75.75.75H8.5a.75.75 0 0 0 .75-.75ZM17.5 7.5v-.625a.75.75 0 0 0-.75-.75H11.5a.75.75 0 0 0-.75.75V7.5c0 .414.336.75.75.75h5.25a.75.75 0 0 0 .75-.75Zm-8.25 0v-.625a.75.75 0 0 0-.75-.75H3.25a.75.75 0 0 0-.75.75V7.5c0 .414.336.75.75.75H8.5a.75.75 0 0 0 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.5 2A1.5 1.5 0 0 0 2 3.5V15a3 3 0 1 0 6 0V3.5A1.5 1.5 0 0 0 6.5 2h-3Zm11.753 6.99L9.5 14.743V6.257l1.51-1.51a1.5 1.5 0 0 1 2.122 0l2.121 2.121a1.5 1.5 0 0 1 0 2.122ZM8.364 18H16.5a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5h-2.136l-6 6ZM5 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 2ZM10 15a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 15ZM10 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM15.657 5.404a.75.75 0 1 0-1.06-1.06l-1.061 1.06a.75.75 0 0 0 1.06 1.06l1.06-1.06ZM6.464 14.596a.75.75 0 1 0-1.06-1.06l-1.06 1.06a.75.75 0 0 0 1.06 1.06l1.06-1.06ZM18 10a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 18 10ZM5 10a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 5 10ZM14.596 15.657a.75.75 0 0 0 1.06-1.06l-1.06-1.061a.75.75 0 1 0-1.06 1.06l1.06 1.06ZM5.404 6.464a.75.75 0 0 0 1.06-1.06l-1.06-1.06a.75.75 0 1 0-1.061 1.06l1.06 1.06Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniStrikethrough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.617 3.963c-1.186-.318-2.418-.323-3.416.015-.992.336-1.49.91-1.642 1.476-.152.566-.007 1.313.684 2.1.528.6 1.273 1.1 2.128 1.446h7.879a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h3.813a5.976 5.976 0 0 1-.447-.456C5.18 7.479 4.798 6.231 5.11 5.066c.312-1.164 1.268-2.055 2.61-2.509 1.336-.451 2.877-.42 4.286-.043.856.23 1.684.592 2.409 1.074a.75.75 0 1 1-.83 1.25 6.723 6.723 0 0 0-1.968-.875Zm1.909 8.123a.75.75 0 0 1 1.015.309c.53.99.607 2.062.18 3.01-.421.94-1.289 1.648-2.441 2.038-1.336.452-2.877.42-4.286.043-1.409-.377-2.759-1.121-3.69-2.18a.75.75 0 1 1 1.127-.99c.696.791 1.765 1.403 2.952 1.721 1.186.318 2.418.323 3.416-.015.853-.288 1.34-.756 1.555-1.232.21-.467.205-1.049-.136-1.69a.75.75 0 0 1 .308-1.014Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.25 3A2.25 2.25 0 0 0 3 5.25v9.5A2.25 2.25 0 0 0 5.25 17h9.5A2.25 2.25 0 0 0 17 14.75v-9.5A2.25 2.25 0 0 0 14.75 3h-9.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniStopCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm5-2.25A.75.75 0 0 1 7.75 7h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSquaresPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4.25A2.25 2.25 0 0 1 4.25 2h2.5A2.25 2.25 0 0 1 9 4.25v2.5A2.25 2.25 0 0 1 6.75 9h-2.5A2.25 2.25 0 0 1 2 6.75v-2.5ZM2 13.25A2.25 2.25 0 0 1 4.25 11h2.5A2.25 2.25 0 0 1 9 13.25v2.5A2.25 2.25 0 0 1 6.75 18h-2.5A2.25 2.25 0 0 1 2 15.75v-2.5ZM11 4.25A2.25 2.25 0 0 1 13.25 2h2.5A2.25 2.25 0 0 1 18 4.25v2.5A2.25 2.25 0 0 1 15.75 9h-2.5A2.25 2.25 0 0 1 11 6.75v-2.5ZM15.25 11.75a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2v-2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSquares2X2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.25 2A2.25 2.25 0 0 0 2 4.25v2.5A2.25 2.25 0 0 0 4.25 9h2.5A2.25 2.25 0 0 0 9 6.75v-2.5A2.25 2.25 0 0 0 6.75 2h-2.5Zm0 9A2.25 2.25 0 0 0 2 13.25v2.5A2.25 2.25 0 0 0 4.25 18h2.5A2.25 2.25 0 0 0 9 15.75v-2.5A2.25 2.25 0 0 0 6.75 11h-2.5Zm9-9A2.25 2.25 0 0 0 11 4.25v2.5A2.25 2.25 0 0 0 13.25 9h2.5A2.25 2.25 0 0 0 18 6.75v-2.5A2.25 2.25 0 0 0 15.75 2h-2.5Zm0 9A2.25 2.25 0 0 0 11 13.25v2.5A2.25 2.25 0 0 0 13.25 18h2.5A2.25 2.25 0 0 0 18 15.75v-2.5A2.25 2.25 0 0 0 15.75 11h-2.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSquare3Stack3D(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.196 12.87-.825.483a.75.75 0 0 0 0 1.294l7.25 4.25a.75.75 0 0 0 .758 0l7.25-4.25a.75.75 0 0 0 0-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 0 1-2.276 0L3.196 12.87Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.196 8.87-.825.483a.75.75 0 0 0 0 1.294l7.25 4.25a.75.75 0 0 0 .758 0l7.25-4.25a.75.75 0 0 0 0-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 0 1-2.276 0L3.196 8.87Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.38 1.103a.75.75 0 0 0-.76 0l-7.25 4.25a.75.75 0 0 0 0 1.294l7.25 4.25a.75.75 0 0 0 .76 0l7.25-4.25a.75.75 0 0 0 0-1.294l-7.25-4.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSquare2Stack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4.25A2.25 2.25 0 0 1 4.25 2h6.5A2.25 2.25 0 0 1 13 4.25V5.5H9.25A3.75 3.75 0 0 0 5.5 9.25V13H4.25A2.25 2.25 0 0 1 2 10.75v-6.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.25 7A2.25 2.25 0 0 0 7 9.25v6.5A2.25 2.25 0 0 0 9.25 18h6.5A2.25 2.25 0 0 0 18 15.75v-6.5A2.25 2.25 0 0 0 15.75 7h-6.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSpeakerXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.047 3.062a.75.75 0 0 1 .453.688v12.5a.75.75 0 0 1-1.264.546L5.203 13H2.667a.75.75 0 0 1-.7-.48A6.985 6.985 0 0 1 1.5 10c0-.887.165-1.737.468-2.52a.75.75 0 0 1 .7-.48h2.535l4.033-3.796a.75.75 0 0 1 .811-.142ZM13.78 7.22a.75.75 0 1 0-1.06 1.06L14.44 10l-1.72 1.72a.75.75 0 0 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L16.56 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L15.5 8.94l-1.72-1.72Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSpeakerWave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 3.75a.75.75 0 0 0-1.264-.546L5.203 7H2.667a.75.75 0 0 0-.7.48A6.985 6.985 0 0 0 1.5 10c0 .887.165 1.737.468 2.52.111.29.39.48.7.48h2.535l4.033 3.796a.75.75 0 0 0 1.264-.546V3.75ZM16.45 5.05a.75.75 0 0 0-1.06 1.061 5.5 5.5 0 0 1 0 7.778.75.75 0 0 0 1.06 1.06 7 7 0 0 0 0-9.899Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.329 7.172a.75.75 0 0 0-1.061 1.06 2.5 2.5 0 0 1 0 3.536.75.75 0 0 0 1.06 1.06 4 4 0 0 0 0-5.656Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.98 1.804a1 1 0 0 0-1.96 0l-.24 1.192a1 1 0 0 1-.784.785l-1.192.238a1 1 0 0 0 0 1.962l1.192.238a1 1 0 0 1 .785.785l.238 1.192a1 1 0 0 0 1.962 0l.238-1.192a1 1 0 0 1 .785-.785l1.192-.238a1 1 0 0 0 0-1.962l-1.192-.238a1 1 0 0 1-.785-.785l-.238-1.192ZM6.949 5.684a1 1 0 0 0-1.898 0l-.683 2.051a1 1 0 0 1-.633.633l-2.051.683a1 1 0 0 0 0 1.898l2.051.684a1 1 0 0 1 .633.632l.683 2.051a1 1 0 0 0 1.898 0l.683-2.051a1 1 0 0 1 .633-.633l2.051-.683a1 1 0 0 0 0-1.898l-2.051-.683a1 1 0 0 1-.633-.633L6.95 5.684ZM13.949 13.684a1 1 0 0 0-1.898 0l-.184.551a1 1 0 0 1-.632.633l-.551.183a1 1 0 0 0 0 1.898l.551.183a1 1 0 0 1 .633.633l.183.551a1 1 0 0 0 1.898 0l.184-.551a1 1 0 0 1 .632-.633l.551-.183a1 1 0 0 0 0-1.898l-.551-.184a1 1 0 0 1-.633-.632l-.183-.551Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.528 3.047a.75.75 0 0 1 .449.961L8.433 16.504a.75.75 0 1 1-1.41-.512l4.544-12.496a.75.75 0 0 1 .961-.449Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSignal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.364 3.636a.75.75 0 0 0-1.06 1.06 7.5 7.5 0 0 1 0 10.607.75.75 0 0 0 1.06 1.061 9 9 0 0 0 0-12.728ZM4.697 4.697a.75.75 0 0 0-1.061-1.061 9 9 0 0 0 0 12.728.75.75 0 1 0 1.06-1.06 7.5 7.5 0 0 1 0-10.607Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.475 6.464a.75.75 0 0 1 1.06 0 5 5 0 0 1 0 7.072.75.75 0 0 1-1.06-1.061 3.5 3.5 0 0 0 0-4.95.75.75 0 0 1 0-1.06ZM7.525 6.464a.75.75 0 0 1 0 1.061 3.5 3.5 0 0 0 0 4.95.75.75 0 0 1-1.06 1.06 5 5 0 0 1 0-7.07.75.75 0 0 1 1.06 0ZM11 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniSignalSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.22 2.22a.75.75 0 0 1 1.06 0l6.783 6.782a1 1 0 0 1 .935.935l6.782 6.783a.75.75 0 1 1-1.06 1.06l-6.783-6.782a1 1 0 0 1-.935-.935L2.22 3.28a.75.75 0 0 1 0-1.06ZM3.636 16.364a9.004 9.004 0 0 1-1.39-10.936L3.349 6.53a7.503 7.503 0 0 0 1.348 8.773.75.75 0 0 1-1.061 1.061ZM6.464 13.536a5 5 0 0 1-1.213-5.103l1.262 1.262a3.493 3.493 0 0 0 1.012 2.78.75.75 0 0 1-1.06 1.06ZM16.364 3.636a9.004 9.004 0 0 1 1.39 10.937l-1.103-1.104a7.503 7.503 0 0 0-1.348-8.772.75.75 0 1 1 1.061-1.061ZM13.536 6.464a5 5 0 0 1 1.213 5.103l-1.262-1.262a3.493 3.493 0 0 0-1.012-2.78.75.75 0 0 1 1.06-1.06Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniShoppingCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 1.75A.75.75 0 0 1 1.75 1h1.628a1.75 1.75 0 0 1 1.734 1.51L5.18 3a65.25 65.25 0 0 1 13.36 1.412.75.75 0 0 1 .58.875 48.645 48.645 0 0 1-1.618 6.2.75.75 0 0 1-.712.513H6a2.503 2.503 0 0 0-2.292 1.5H17.25a.75.75 0 0 1 0 1.5H2.76a.75.75 0 0 1-.748-.807 4.002 4.002 0 0 1 2.716-3.486L3.626 2.716a.25.25 0 0 0-.248-.216H1.75A.75.75 0 0 1 1 1.75ZM6 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM15.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniShoppingBag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 5v1H4.667a1.75 1.75 0 0 0-1.743 1.598l-.826 9.5A1.75 1.75 0 0 0 3.84 19H16.16a1.75 1.75 0 0 0 1.743-1.902l-.826-9.5A1.75 1.75 0 0 0 15.333 6H14V5a4 4 0 0 0-8 0Zm4-2.5A2.5 2.5 0 0 0 7.5 5v1h5V5A2.5 2.5 0 0 0 10 2.5ZM7.5 10a2.5 2.5 0 0 0 5 0V8.75a.75.75 0 0 1 1.5 0V10a4 4 0 0 1-8 0V8.75a.75.75 0 0 1 1.5 0V10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniShieldExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.339 2.237a.531.531 0 0 0-.678 0 11.947 11.947 0 0 1-7.078 2.75.5.5 0 0 0-.479.425A12.11 12.11 0 0 0 2 7c0 5.163 3.26 9.564 7.834 11.257a.48.48 0 0 0 .332 0C14.74 16.564 18 12.163 18 7c0-.538-.035-1.069-.104-1.589a.5.5 0 0 0-.48-.425 11.947 11.947 0 0 1-7.077-2.75ZM10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 6Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniShieldCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.661 2.237a.531.531 0 0 1 .678 0 11.947 11.947 0 0 0 7.078 2.749.5.5 0 0 1 .479.425c.069.52.104 1.05.104 1.59 0 5.162-3.26 9.563-7.834 11.256a.48.48 0 0 1-.332 0C5.26 16.564 2 12.163 2 7c0-.538.035-1.069.104-1.589a.5.5 0 0 1 .48-.425 11.947 11.947 0 0 0 7.077-2.75Zm4.196 5.954a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.5a2.5 2.5 0 1 1 .702 1.737L6.97 9.604a2.518 2.518 0 0 1 0 .792l6.733 3.367a2.5 2.5 0 1 1-.671 1.341l-6.733-3.367a2.5 2.5 0 1 1 0-3.475l6.733-3.366A2.52 2.52 0 0 1 13 4.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniServer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.632 3.533A2 2 0 0 1 6.577 2h6.846a2 2 0 0 1 1.945 1.533l1.976 8.234A3.489 3.489 0 0 0 16 11.5H4c-.476 0-.93.095-1.344.267l1.976-8.234Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 13a2 2 0 1 0 0 4h12a2 2 0 1 0 0-4H4Zm11.24 2a.75.75 0 0 1 .75-.75H16a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75V15Zm-2.25-.75a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75H13a.75.75 0 0 0 .75-.75V15a.75.75 0 0 0-.75-.75h-.01Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniServerStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.464 3.162A2 2 0 0 1 6.28 2h7.44a2 2 0 0 1 1.816 1.162l1.154 2.5c.067.145.115.291.145.438A3.508 3.508 0 0 0 16 6H4c-.288 0-.568.035-.835.1.03-.147.078-.293.145-.438l1.154-2.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 9.5a2 2 0 0 1 2-2h12a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2Zm13.24 0a.75.75 0 0 1 .75-.75H16a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75V9.5Zm-2.25-.75a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75H13a.75.75 0 0 0 .75-.75V9.5a.75.75 0 0 0-.75-.75h-.01ZM2 15a2 2 0 0 1 2-2h12a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2Zm13.24 0a.75.75 0 0 1 .75-.75H16a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75V15Zm-2.25-.75a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75H13a.75.75 0 0 0 .75-.75V15a.75.75 0 0 0-.75-.75h-.01Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.469 3.75a3.5 3.5 0 0 0 5.617 4.11l.883.51c.025.092.147.116.21.043.15-.176.318-.338.5-.484.286-.23.3-.709-.018-.892l-.825-.477A3.501 3.501 0 0 0 1.47 3.75Zm2.03 3.482a2 2 0 1 1 2-3.464 2 2 0 0 1-2 3.464ZM9.956 8.322a2.75 2.75 0 0 0-1.588 1.822L7.97 11.63l-.884.51A3.501 3.501 0 0 0 1.47 16.25a3.5 3.5 0 0 0 6.367-2.81l10.68-6.166a.75.75 0 0 0-.182-1.373l-.703-.189a2.75 2.75 0 0 0-1.78.123L9.955 8.322ZM2.768 15.5a2 2 0 1 1 3.464-2 2 2 0 0 1-3.464 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.52 11.89a.5.5 0 0 0 .056.894l3.274 1.381a2.75 2.75 0 0 0 1.78.123l.704-.189a.75.75 0 0 0 .18-1.373l-3.47-2.004a.5.5 0 0 0-.5 0L12.52 11.89Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniScale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a.75.75 0 0 1 .75.75v.258a33.186 33.186 0 0 1 6.668.83.75.75 0 0 1-.336 1.461 31.28 31.28 0 0 0-1.103-.232l1.702 7.545a.75.75 0 0 1-.387.832A4.981 4.981 0 0 1 15 14c-.825 0-1.606-.2-2.294-.556a.75.75 0 0 1-.387-.832l1.77-7.849a31.743 31.743 0 0 0-3.339-.254v11.505a20.01 20.01 0 0 1 3.78.501.75.75 0 1 1-.339 1.462A18.558 18.558 0 0 0 10 17.5c-1.442 0-2.845.165-4.191.477a.75.75 0 0 1-.338-1.462 20.01 20.01 0 0 1 3.779-.501V4.509c-1.129.026-2.243.112-3.34.254l1.771 7.85a.75.75 0 0 1-.387.83A4.98 4.98 0 0 1 5 14a4.98 4.98 0 0 1-2.294-.556.75.75 0 0 1-.387-.832L4.02 5.067c-.37.07-.738.148-1.103.232a.75.75 0 0 1-.336-1.462 32.845 32.845 0 0 1 6.668-.829V2.75A.75.75 0 0 1 10 2ZM5 7.543 3.92 12.33a3.499 3.499 0 0 0 2.16 0L5 7.543Zm10 0-1.08 4.787a3.498 3.498 0 0 0 2.16 0L15 7.543Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.75 3a.75.75 0 0 0-.75.75v.5c0 .414.336.75.75.75H4c6.075 0 11 4.925 11 11v.25c0 .414.336.75.75.75h.5a.75.75 0 0 0 .75-.75V16C17 8.82 11.18 3 4 3h-.25Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8.75A.75.75 0 0 1 3.75 8H4a8 8 0 0 1 8 8v.25a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75V16a6 6 0 0 0-6-6h-.25A.75.75 0 0 1 3 9.25v-.5ZM7 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniRocketLaunch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.606 12.97a.75.75 0 0 1-.134 1.051 2.494 2.494 0 0 0-.93 2.437 2.494 2.494 0 0 0 2.437-.93.75.75 0 1 1 1.186.918 3.995 3.995 0 0 1-4.482 1.332.75.75 0 0 1-.461-.461 3.994 3.994 0 0 1 1.332-4.482.75.75 0 0 1 1.052.134Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.752 12A13.07 13.07 0 0 0 8 14.248v4.002c0 .414.336.75.75.75a5 5 0 0 0 4.797-6.414 12.984 12.984 0 0 0 5.45-10.848.75.75 0 0 0-.735-.735 12.984 12.984 0 0 0-10.849 5.45A5 5 0 0 0 1 11.25c.001.414.337.75.751.75h4.002ZM13 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniRectangleStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.127 3.502 5.25 3.5h9.5c.041 0 .082 0 .123.002A2.251 2.251 0 0 0 12.75 2h-5.5a2.25 2.25 0 0 0-2.123 1.502ZM1 10.25A2.25 2.25 0 0 1 3.25 8h13.5A2.25 2.25 0 0 1 19 10.25v5.5A2.25 2.25 0 0 1 16.75 18H3.25A2.25 2.25 0 0 1 1 15.75v-5.5ZM3.25 6.5c-.04 0-.082 0-.123.002A2.25 2.25 0 0 1 5.25 5h9.5c.98 0 1.814.627 2.123 1.502a3.819 3.819 0 0 0-.123-.002H3.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniRectangleGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.5 3A1.5 1.5 0 0 0 1 4.5v4A1.5 1.5 0 0 0 2.5 10h6A1.5 1.5 0 0 0 10 8.5v-4A1.5 1.5 0 0 0 8.5 3h-6Zm11 2A1.5 1.5 0 0 0 12 6.5v7a1.5 1.5 0 0 0 1.5 1.5h4a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 17.5 5h-4Zm-10 7A1.5 1.5 0 0 0 2 13.5v2A1.5 1.5 0 0 0 3.5 17h6a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 9.5 12h-6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniReceiptRefund(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.93 2.31a41.401 41.401 0 0 1 10.14 0C16.194 2.45 17 3.414 17 4.517V17.25a.75.75 0 0 1-1.075.676l-2.8-1.344-2.8 1.344a.75.75 0 0 1-.65 0l-2.8-1.344-2.8 1.344A.75.75 0 0 1 3 17.25V4.517c0-1.103.806-2.068 1.93-2.207Zm4.822 3.997a.75.75 0 1 0-1.004-1.114l-2.5 2.25a.75.75 0 0 0 0 1.114l2.5 2.25a.75.75 0 0 0 1.004-1.114L8.704 8.75h1.921a1.875 1.875 0 0 1 0 3.75.75.75 0 0 0 0 1.5 3.375 3.375 0 1 0 0-6.75h-1.92l1.047-.943Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniReceiptPercent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.93 2.31a41.401 41.401 0 0 1 10.14 0C16.194 2.45 17 3.414 17 4.517V17.25a.75.75 0 0 1-1.075.676l-2.8-1.344-2.8 1.344a.75.75 0 0 1-.65 0l-2.8-1.344-2.8 1.344A.75.75 0 0 1 3 17.25V4.517c0-1.103.806-2.068 1.93-2.207Zm8.85 4.97a.75.75 0 0 0-1.06-1.06l-6.5 6.5a.75.75 0 1 0 1.06 1.06l6.5-6.5ZM9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniRadio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.45 3.473a.75.75 0 1 0-.4-1.446L5.313 5.265c-.84.096-1.671.217-2.495.362A2.212 2.212 0 0 0 1 7.816v7.934A2.25 2.25 0 0 0 3.25 18h13.5A2.25 2.25 0 0 0 19 15.75V7.816c0-1.06-.745-2-1.817-2.189a41.12 41.12 0 0 0-5.406-.59l5.673-1.564ZM16 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM14.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-9.26-5a.75.75 0 0 1 .75-.75H6a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75V11Zm2.75-.75a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75H8a.75.75 0 0 0 .75-.75V11a.75.75 0 0 0-.75-.75h-.01Zm-1.75-1.5A.75.75 0 0 1 6.99 8H7a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm3.583.42a.75.75 0 0 0-1.06 0l-.007.007a.75.75 0 0 0 0 1.06l.007.007a.75.75 0 0 0 1.06 0l.007-.007a.75.75 0 0 0 0-1.06l-.007-.008Zm.427 2.08A.75.75 0 0 1 11 12v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75V12a.75.75 0 0 1 .75-.75h.01Zm-.42 3.583a.75.75 0 0 0 0-1.06l-.007-.007a.75.75 0 0 0-1.06 0l-.007.007a.75.75 0 0 0 0 1.06l.007.008a.75.75 0 0 0 1.06 0l.008-.008Zm-3.59.417a.75.75 0 0 1 .75-.75H7a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm-1.013-1.484a.75.75 0 0 0-1.06 0l-.008.007a.75.75 0 0 0 0 1.06l.007.008a.75.75 0 0 0 1.061 0l.007-.008a.75.75 0 0 0 0-1.06l-.007-.007ZM3.75 11.25a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75V12a.75.75 0 0 1 .75-.75h.01Zm1.484-1.013a.75.75 0 0 0 0-1.06l-.007-.007a.75.75 0 0 0-1.06 0l-.007.007a.75.75 0 0 0 0 1.06l.007.007a.75.75 0 0 0 1.06 0l.007-.007ZM7.24 13a.75.75 0 0 1 .75-.75H8a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75V13Zm-1.25-.75a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75H6a.75.75 0 0 0 .75-.75V13a.75.75 0 0 0-.75-.75h-.01Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniQueueList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4.5A2.5 2.5 0 0 1 4.5 2h11a2.5 2.5 0 0 1 0 5h-11A2.5 2.5 0 0 1 2 4.5ZM2.75 9.083a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75ZM2.75 12.663a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75ZM2.75 16.25a.75.75 0 0 0 0 1.5h14.5a.75.75 0 1 0 0-1.5H2.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniQuestionMarkCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM8.94 6.94a.75.75 0 1 1-1.061-1.061 3 3 0 1 1 2.871 5.026v.345a.75.75 0 0 1-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 1 0 8.94 6.94ZM10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniQrCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 2A1.75 1.75 0 0 0 2 3.75v3.5C2 8.216 2.784 9 3.75 9h3.5A1.75 1.75 0 0 0 9 7.25v-3.5A1.75 1.75 0 0 0 7.25 2h-3.5ZM3.5 3.75a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.5a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-3.5ZM3.75 11A1.75 1.75 0 0 0 2 12.75v3.5c0 .966.784 1.75 1.75 1.75h3.5A1.75 1.75 0 0 0 9 16.25v-3.5A1.75 1.75 0 0 0 7.25 11h-3.5Zm-.25 1.75a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.5a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-3.5Zm7.5-9c0-.966.784-1.75 1.75-1.75h3.5c.966 0 1.75.784 1.75 1.75v3.5A1.75 1.75 0 0 1 16.25 9h-3.5A1.75 1.75 0 0 1 11 7.25v-3.5Zm1.75-.25a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25h-3.5Zm-7.26 1a1 1 0 0 0-1 1v.01a1 1 0 0 0 1 1h.01a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1h-.01Zm9 0a1 1 0 0 0-1 1v.01a1 1 0 0 0 1 1h.01a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1h-.01Zm-9 9a1 1 0 0 0-1 1v.01a1 1 0 0 0 1 1h.01a1 1 0 0 0 1-1v-.01a1 1 0 0 0-1-1h-.01Zm9 0a1 1 0 0 0-1 1v.01a1 1 0 0 0 1 1h.01a1 1 0 0 0 1-1v-.01a1 1 0 0 0-1-1h-.01Zm-3.5-1.5a1 1 0 0 1 1-1H12a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1V12Zm6-1a1 1 0 0 0-1 1v.01a1 1 0 0 0 1 1H17a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1h-.01Zm-1 6a1 1 0 0 1 1-1H17a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1V17Zm-4-1a1 1 0 0 0-1 1v.01a1 1 0 0 0 1 1H12a1 1 0 0 0 1-1V17a1 1 0 0 0-1-1h-.01Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPuzzlePiece(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.467c0-.405.262-.75.559-1.027.276-.257.441-.584.441-.94 0-.828-.895-1.5-2-1.5s-2 .672-2 1.5c0 .362.171.694.456.953.29.265.544.6.544.994a.968.968 0 0 1-1.024.974 39.655 39.655 0 0 1-3.014-.306.75.75 0 0 0-.847.847c.14.993.242 1.999.306 3.014A.968.968 0 0 1 4.447 10c-.393 0-.729-.253-.994-.544C3.194 9.17 2.862 9 2.5 9 1.672 9 1 9.895 1 11s.672 2 1.5 2c.356 0 .683-.165.94-.441.276-.297.622-.559 1.027-.559a.997.997 0 0 1 1.004 1.03 39.747 39.747 0 0 1-.319 3.734.75.75 0 0 0 .64.842c1.05.146 2.111.252 3.184.318A.97.97 0 0 0 10 16.948c0-.394-.254-.73-.545-.995C9.171 15.693 9 15.362 9 15c0-.828.895-1.5 2-1.5s2 .672 2 1.5c0 .356-.165.683-.441.94-.297.276-.559.622-.559 1.027a.998.998 0 0 0 1.03 1.005c1.337-.05 2.659-.162 3.961-.337a.75.75 0 0 0 .644-.644c.175-1.302.288-2.624.337-3.961A.998.998 0 0 0 16.967 12c-.405 0-.75.262-1.027.559-.257.276-.584.441-.94.441-.828 0-1.5-.895-1.5-2s.672-2 1.5-2c.362 0 .694.17.953.455.265.291.601.545.995.545a.97.97 0 0 0 .976-1.024 41.159 41.159 0 0 0-.318-3.184.75.75 0 0 0-.842-.64c-1.228.164-2.473.271-3.734.319A.997.997 0 0 1 12 4.467Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPrinter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 2.75C5 1.784 5.784 1 6.75 1h6.5c.966 0 1.75.784 1.75 1.75v3.552c.377.046.752.097 1.126.153A2.212 2.212 0 0 1 18 8.653v4.097A2.25 2.25 0 0 1 15.75 15h-.241l.305 1.984A1.75 1.75 0 0 1 14.084 19H5.915a1.75 1.75 0 0 1-1.73-2.016L4.492 15H4.25A2.25 2.25 0 0 1 2 12.75V8.653c0-1.082.775-2.034 1.874-2.198.374-.056.75-.107 1.127-.153L5 6.25v-3.5Zm8.5 3.397a41.533 41.533 0 0 0-7 0V2.75a.25.25 0 0 1 .25-.25h6.5a.25.25 0 0 1 .25.25v3.397ZM6.608 12.5a.25.25 0 0 0-.247.212l-.693 4.5a.25.25 0 0 0 .247.288h8.17a.25.25 0 0 0 .246-.288l-.692-4.5a.25.25 0 0 0-.247-.212H6.608Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPresentationChartLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 2.75A.75.75 0 0 1 1.75 2h16.5a.75.75 0 0 1 0 1.5H18v8.75A2.75 2.75 0 0 1 15.25 15h-1.072l.798 3.06a.75.75 0 0 1-1.452.38L13.41 18H6.59l-.114.44a.75.75 0 0 1-1.452-.38L5.823 15H4.75A2.75 2.75 0 0 1 2 12.25V3.5h-.25A.75.75 0 0 1 1 2.75ZM7.373 15l-.391 1.5h6.037l-.392-1.5H7.373Zm7.49-8.931a.75.75 0 0 1-.175 1.046 19.326 19.326 0 0 0-3.398 3.098.75.75 0 0 1-1.097.04L8.5 8.561l-2.22 2.22A.75.75 0 1 1 5.22 9.72l2.75-2.75a.75.75 0 0 1 1.06 0l1.664 1.663a20.786 20.786 0 0 1 3.122-2.74.75.75 0 0 1 1.046.176Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPresentationChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 2.75A.75.75 0 0 1 1.75 2h16.5a.75.75 0 0 1 0 1.5H18v8.75A2.75 2.75 0 0 1 15.25 15h-1.072l.798 3.06a.75.75 0 0 1-1.452.38L13.41 18H6.59l-.114.44a.75.75 0 0 1-1.452-.38L5.823 15H4.75A2.75 2.75 0 0 1 2 12.25V3.5h-.25A.75.75 0 0 1 1 2.75ZM7.373 15l-.391 1.5h6.037l-.392-1.5H7.373ZM13.25 5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5a.75.75 0 0 1 .75-.75Zm-6.5 4a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 6.75 9Zm4-1.25a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0v-3.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0v-7.5A.75.75 0 0 1 10 2ZM5.404 4.343a.75.75 0 0 1 0 1.06 6.5 6.5 0 1 0 9.192 0 .75.75 0 1 1 1.06-1.06 8 8 0 1 1-11.313 0 .75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPlusSmall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.75 6.75a.75.75 0 0 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5v2.5a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5v-2.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPlusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-11.25a.75.75 0 0 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5v2.5a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5v-2.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.3 2.84A1.5 1.5 0 0 0 4 4.11v11.78a1.5 1.5 0 0 0 2.3 1.27l9.344-5.891a1.5 1.5 0 0 0 0-2.538L6.3 2.841Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPlayPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.75 4a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75h.5a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-.75-.75h-.5ZM17.75 4a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75h.5a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-.75-.75h-.5ZM3.288 4.819A1.5 1.5 0 0 0 1 6.095v7.81a1.5 1.5 0 0 0 2.288 1.277l6.323-3.906a1.5 1.5 0 0 0 0-2.552L3.288 4.819Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPlayCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm6.39-2.908a.75.75 0 0 1 .766.027l3.5 2.25a.75.75 0 0 1 0 1.262l-3.5 2.25A.75.75 0 0 1 8 12.25v-4.5a.75.75 0 0 1 .39-.658Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPhoto(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 5.25A2.25 2.25 0 0 1 3.25 3h13.5A2.25 2.25 0 0 1 19 5.25v9.5A2.25 2.25 0 0 1 16.75 17H3.25A2.25 2.25 0 0 1 1 14.75v-9.5Zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-2.69l-2.22-2.219a.75.75 0 0 0-1.06 0l-1.91 1.909.47.47a.75.75 0 1 1-1.06 1.06L6.53 8.091a.75.75 0 0 0-1.06 0l-2.97 2.97ZM12 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 3.5A1.5 1.5 0 0 1 3.5 2h1.148a1.5 1.5 0 0 1 1.465 1.175l.716 3.223a1.5 1.5 0 0 1-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 0 0 6.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 0 1 1.767-1.052l3.223.716A1.5 1.5 0 0 1 18 15.352V16.5a1.5 1.5 0 0 1-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 0 1 2.43 8.326 13.019 13.019 0 0 1 2 5V3.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPhoneXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.5 2A1.5 1.5 0 0 0 2 3.5V5c0 1.149.15 2.263.43 3.326a13.022 13.022 0 0 0 9.244 9.244c1.063.28 2.177.43 3.326.43h1.5a1.5 1.5 0 0 0 1.5-1.5v-1.148a1.5 1.5 0 0 0-1.175-1.465l-3.223-.716a1.5 1.5 0 0 0-1.767 1.052l-.267.933c-.117.41-.555.643-.95.48a11.542 11.542 0 0 1-6.254-6.254c-.163-.395.07-.833.48-.95l.933-.267a1.5 1.5 0 0 0 1.052-1.767l-.716-3.223A1.5 1.5 0 0 0 4.648 2H3.5Zm9.78.22a.75.75 0 1 0-1.06 1.06L13.94 5l-1.72 1.72a.75.75 0 0 0 1.06 1.06L15 6.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L16.06 5l1.72-1.72a.75.75 0 0 0-1.06-1.06L15 3.94l-1.72-1.72Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPhoneArrowUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2A1.5 1.5 0 0 0 2 3.5V5c0 1.149.15 2.263.43 3.326a13.022 13.022 0 0 0 9.244 9.244c1.063.28 2.177.43 3.326.43h1.5a1.5 1.5 0 0 0 1.5-1.5v-1.148a1.5 1.5 0 0 0-1.175-1.465l-3.223-.716a1.5 1.5 0 0 0-1.767 1.052l-.267.933c-.117.41-.555.643-.95.48a11.542 11.542 0 0 1-6.254-6.254c-.163-.395.07-.833.48-.95l.933-.267a1.5 1.5 0 0 0 1.052-1.767l-.716-3.223A1.5 1.5 0 0 0 4.648 2H3.5ZM16.5 4.56l-3.22 3.22a.75.75 0 1 1-1.06-1.06l3.22-3.22h-2.69a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V4.56Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPhoneArrowDownLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2A1.5 1.5 0 0 0 2 3.5V5c0 1.149.15 2.263.43 3.326a13.022 13.022 0 0 0 9.244 9.244c1.063.28 2.177.43 3.326.43h1.5a1.5 1.5 0 0 0 1.5-1.5v-1.148a1.5 1.5 0 0 0-1.175-1.465l-3.223-.716a1.5 1.5 0 0 0-1.767 1.052l-.267.933c-.117.41-.555.643-.95.48a11.542 11.542 0 0 1-6.254-6.254c-.163-.395.07-.833.48-.95l.933-.267a1.5 1.5 0 0 0 1.052-1.767l-.716-3.223A1.5 1.5 0 0 0 4.648 2H3.5ZM16.72 2.22a.75.75 0 1 1 1.06 1.06L14.56 6.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.22-3.22Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPercentBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.597 7.348a3 3 0 0 0 0 5.304 3 3 0 0 0 3.75 3.751 3 3 0 0 0 5.305 0 3 3 0 0 0 3.751-3.75 3 3 0 0 0 0-5.305 3 3 0 0 0-3.75-3.751 3 3 0 0 0-5.305 0 3 3 0 0 0-3.751 3.75Zm9.933.182a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6Zm.47 5.22a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM7.25 8.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPencil(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.695 14.762-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPencilSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.433 13.917 1.262-3.155A4 4 0 0 1 7.58 9.42l6.92-6.918a2.121 2.121 0 0 1 3 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 0 1-.65-.65Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0 0 10 3H4.75A2.75 2.75 0 0 0 2 5.75v9.5A2.75 2.75 0 0 0 4.75 18h9.5A2.75 2.75 0 0 0 17 15.25V10a.75.75 0 0 0-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.75 3a.75.75 0 0 0-.75.75v12.5c0 .414.336.75.75.75h1.5a.75.75 0 0 0 .75-.75V3.75A.75.75 0 0 0 7.25 3h-1.5ZM12.75 3a.75.75 0 0 0-.75.75v12.5c0 .414.336.75.75.75h1.5a.75.75 0 0 0 .75-.75V3.75a.75.75 0 0 0-.75-.75h-1.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPauseCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm5-2.25A.75.75 0 0 1 7.75 7h.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75v-4.5Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75v-4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPaperClip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.621 4.379a3 3 0 0 0-4.242 0l-7 7a3 3 0 0 0 4.241 4.243h.001l.497-.5a.75.75 0 0 1 1.064 1.057l-.498.501-.002.002a4.5 4.5 0 0 1-6.364-6.364l7-7a4.5 4.5 0 0 1 6.368 6.36l-3.455 3.553A2.625 2.625 0 1 1 9.52 9.52l3.45-3.451a.75.75 0 1 1 1.061 1.06l-3.45 3.451a1.125 1.125 0 0 0 1.587 1.595l3.454-3.553a3 3 0 0 0 0-4.242Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPaperAirplane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.105 2.288a.75.75 0 0 0-.826.95l1.414 4.926A1.5 1.5 0 0 0 5.135 9.25h6.115a.75.75 0 0 1 0 1.5H5.135a1.5 1.5 0 0 0-1.442 1.086l-1.414 4.926a.75.75 0 0 0 .826.95 28.897 28.897 0 0 0 15.293-7.155.75.75 0 0 0 0-1.114A28.897 28.897 0 0 0 3.105 2.288Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniPaintBrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.993 1.385a1.87 1.87 0 0 1 2.623 2.622l-4.03 5.27a12.749 12.749 0 0 1-4.237 3.562 4.508 4.508 0 0 0-3.188-3.188 12.75 12.75 0 0 1 3.562-4.236l5.27-4.03ZM6 11a3 3 0 0 0-3 3 .5.5 0 0 1-.72.45.75.75 0 0 0-1.035.931A4.001 4.001 0 0 0 9 14.004V14a3.01 3.01 0 0 0-1.66-2.685A2.99 2.99 0 0 0 6 11Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniNumberedList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 1.25a.75.75 0 0 0 0 1.5h.25v2.5a.75.75 0 0 0 1.5 0V2A.75.75 0 0 0 4 1.25H3ZM2.97 8.654a3.5 3.5 0 0 1 1.524-.12.034.034 0 0 1-.012.012L2.415 9.579A.75.75 0 0 0 2 10.25v1c0 .414.336.75.75.75h2.5a.75.75 0 0 0 0-1.5H3.927l1.225-.613c.52-.26.848-.79.848-1.371 0-.647-.429-1.327-1.193-1.451a5.03 5.03 0 0 0-2.277.155.75.75 0 0 0 .44 1.434ZM7.75 3a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5h-9.5ZM7.75 9.25a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5h-9.5ZM7.75 15.5a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5h-9.5ZM2.625 13.875a.75.75 0 0 0 0 1.5h1.5a.125.125 0 0 1 0 .25H3.5a.75.75 0 0 0 0 1.5h.625a.125.125 0 0 1 0 .25h-1.5a.75.75 0 0 0 0 1.5h1.5a1.625 1.625 0 0 0 1.37-2.5 1.625 1.625 0 0 0-1.37-2.5h-1.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniNoSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m5.965 4.904 9.131 9.131a6.5 6.5 0 0 0-9.131-9.131Zm8.07 10.192L4.904 5.965a6.5 6.5 0 0 0 9.131 9.131ZM4.343 4.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 4.343 4.343Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 3.5A1.5 1.5 0 0 1 3.5 2h9A1.5 1.5 0 0 1 14 3.5v11.75A2.75 2.75 0 0 0 16.75 18h-12A2.75 2.75 0 0 1 2 15.25V3.5Zm3.75 7a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm0 3a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5ZM5 5.75A.75.75 0 0 1 5.75 5h4.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 5 8.25v-2.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 6.5h-1v8.75a1.25 1.25 0 1 0 2.5 0V8a1.5 1.5 0 0 0-1.5-1.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMusicalNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.721 1.599a.75.75 0 0 1 .279.583v11.29a2.25 2.25 0 0 1-1.774 2.2l-2.041.44a2.216 2.216 0 0 1-.938-4.332l2.662-.577a.75.75 0 0 0 .591-.733V6.112l-8 1.73v7.684a2.25 2.25 0 0 1-1.774 2.2l-2.042.44a2.216 2.216 0 1 1-.935-4.331l2.659-.573A.75.75 0 0 0 7 12.529V4.236a.75.75 0 0 1 .591-.733l9.5-2.054a.75.75 0 0 1 .63.15Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.455 2.004a.75.75 0 0 1 .26.77 7 7 0 0 0 9.958 7.967.75.75 0 0 1 1.067.853A8.5 8.5 0 1 1 6.647 1.921a.75.75 0 0 1 .808.083Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMinusSmall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.75 9.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMinusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM6.75 9.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMicrophone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4a3 3 0 0 1 6 0v6a3 3 0 1 1-6 0V4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 9.643a.75.75 0 0 0-1.5 0V10c0 3.06 2.29 5.585 5.25 5.954V17.5h-1.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-1.5v-1.546A6.001 6.001 0 0 0 16 10v-.357a.75.75 0 0 0-1.5 0V10a4.5 4.5 0 0 1-9 0v-.357Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMegaphone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.92 3.845a19.362 19.362 0 0 1-6.3 1.98C6.765 5.942 5.89 6 5 6a4 4 0 0 0-.504 7.969 15.97 15.97 0 0 0 1.271 3.34c.397.771 1.342 1 2.05.59l.867-.5c.726-.419.94-1.32.588-2.02-.166-.331-.315-.666-.448-1.004 1.8.357 3.511.963 5.096 1.78A17.964 17.964 0 0 0 15 10c0-2.162-.381-4.235-1.08-6.155ZM15.243 3.097A19.456 19.456 0 0 1 16.5 10c0 2.43-.445 4.758-1.257 6.904l-.03.077a.75.75 0 0 0 1.401.537 20.903 20.903 0 0 0 1.312-5.745 2 2 0 0 0 0-3.546 20.902 20.902 0 0 0-1.312-5.745.75.75 0 0 0-1.4.537l.029.078Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.157 2.176a1.5 1.5 0 0 0-1.147 0l-4.084 1.69A1.5 1.5 0 0 0 2 5.25v10.877a1.5 1.5 0 0 0 2.074 1.386l3.51-1.452 4.26 1.762a1.5 1.5 0 0 0 1.146 0l4.083-1.69A1.5 1.5 0 0 0 18 14.75V3.872a1.5 1.5 0 0 0-2.073-1.386l-3.51 1.452-4.26-1.762ZM7.58 5a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5A.75.75 0 0 1 7.58 5Zm5.59 2.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0v-6.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMapPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m9.69 18.933.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 0 0 .281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 1 0 3 9c0 3.492 1.698 5.988 3.355 7.584a13.731 13.731 0 0 0 2.273 1.765 11.842 11.842 0 0 0 .976.544l.062.029.018.008.006.003ZM10 11.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMagnifyingGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMagnifyingGlassPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5A.75.75 0 0 1 9 6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Zm7-5.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMagnifyingGlassMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.75 8.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 2a7 7 0 1 0 4.391 12.452l3.329 3.328a.75.75 0 1 0 1.06-1.06l-3.328-3.329A7 7 0 0 0 9 2ZM3.5 9a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniMagnifyingGlassCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 9a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM9 5a4 4 0 1 0 2.248 7.309l1.472 1.471a.75.75 0 1 0 1.06-1.06l-1.471-1.472A4 4 0 0 0 9 5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniLockOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.5 1A4.5 4.5 0 0 0 10 5.5V9H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1.5V5.5a3 3 0 1 1 6 0v2.75a.75.75 0 0 0 1.5 0V5.5A4.5 4.5 0 0 0 14.5 1Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniLockClosed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniListBullet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 4.75A.75.75 0 0 1 6.75 4h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 4.75ZM6 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 10Zm0 5.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75ZM1.99 4.75a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1v-.01ZM1.99 15.25a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1v-.01ZM1.99 10a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1V10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.232 4.232a2.5 2.5 0 0 1 3.536 3.536l-1.225 1.224a.75.75 0 0 0 1.061 1.06l1.224-1.224a4 4 0 0 0-5.656-5.656l-3 3a4 4 0 0 0 .225 5.865.75.75 0 0 0 .977-1.138 2.5 2.5 0 0 1-.142-3.667l3-3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.603 7.963a.75.75 0 0 0-.977 1.138 2.5 2.5 0 0 1 .142 3.667l-3 3a2.5 2.5 0 0 1-3.536-3.536l1.225-1.224a.75.75 0 0 0-1.061-1.06l-1.224 1.224a4 4 0 1 0 5.656 5.656l3-3a4 4 0 0 0-.225-5.865Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniLinkSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.22 2.22a.75.75 0 0 1 1.06 0l4.46 4.46c.128-.178.272-.349.432-.508l3-3a4 4 0 0 1 5.657 5.656l-1.225 1.225a.75.75 0 1 1-1.06-1.06l1.224-1.225a2.5 2.5 0 0 0-3.536-3.536l-3 3a2.504 2.504 0 0 0-.406.533l2.59 2.59a2.49 2.49 0 0 0-.79-1.254.75.75 0 1 1 .977-1.138 3.997 3.997 0 0 1 1.306 3.886l4.871 4.87a.75.75 0 1 1-1.06 1.061l-5.177-5.177-.006-.005-4.134-4.134a.65.65 0 0 1-.005-.006L2.22 3.28a.75.75 0 0 1 0-1.06Zm3.237 7.727a.75.75 0 0 1 0 1.06l-1.225 1.225a2.5 2.5 0 0 0 3.536 3.536l1.879-1.879a.75.75 0 1 1 1.06 1.06L8.83 16.83a4 4 0 0 1-5.657-5.657l1.224-1.225a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniLightBulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 1a6 6 0 0 0-3.815 10.631C7.237 12.5 8 13.443 8 14.456v.644a.75.75 0 0 0 .572.729 6.016 6.016 0 0 0 2.856 0A.75.75 0 0 0 12 15.1v-.644c0-1.013.762-1.957 1.815-2.825A6 6 0 0 0 10 1ZM8.863 17.414a.75.75 0 0 0-.226 1.483 9.066 9.066 0 0 0 2.726 0 .75.75 0 0 0-.226-1.483 7.553 7.553 0 0 1-2.274 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniLifebuoy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m7.171 4.146 1.947 2.466a3.514 3.514 0 0 1 1.764 0l1.947-2.466a6.52 6.52 0 0 0-5.658 0Zm8.683 3.025-2.466 1.947c.15.578.15 1.186 0 1.764l2.466 1.947a6.52 6.52 0 0 0 0-5.658Zm-3.025 8.683-1.947-2.466c-.578.15-1.186.15-1.764 0l-1.947 2.466a6.52 6.52 0 0 0 5.658 0ZM4.146 12.83l2.466-1.947a3.514 3.514 0 0 1 0-1.764L4.146 7.171a6.52 6.52 0 0 0 0 5.658ZM5.63 3.297a8.01 8.01 0 0 1 8.738 0 8.031 8.031 0 0 1 2.334 2.334 8.01 8.01 0 0 1 0 8.738 8.033 8.033 0 0 1-2.334 2.334 8.01 8.01 0 0 1-8.738 0 8.032 8.032 0 0 1-2.334-2.334 8.01 8.01 0 0 1 0-8.738A8.03 8.03 0 0 1 5.63 3.297Zm5.198 4.882a2.008 2.008 0 0 0-2.243.407 1.994 1.994 0 0 0-.407 2.243 1.993 1.993 0 0 0 .992.992 2.008 2.008 0 0 0 2.243-.407c.176-.175.31-.374.407-.585a2.008 2.008 0 0 0-.407-2.243 1.993 1.993 0 0 0-.585-.407Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniLanguage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75 2.75a.75.75 0 0 0-1.5 0v1.258a32.987 32.987 0 0 0-3.599.278.75.75 0 1 0 .198 1.487A31.545 31.545 0 0 1 8.7 5.545 19.381 19.381 0 0 1 7 9.56a19.418 19.418 0 0 1-1.002-2.05.75.75 0 0 0-1.384.577 20.935 20.935 0 0 0 1.492 2.91 19.613 19.613 0 0 1-3.828 4.154.75.75 0 1 0 .945 1.164A21.116 21.116 0 0 0 7 12.331c.095.132.192.262.29.391a.75.75 0 0 0 1.194-.91c-.204-.266-.4-.538-.59-.815a20.888 20.888 0 0 0 2.333-5.332c.31.031.618.068.924.108a.75.75 0 0 0 .198-1.487 32.832 32.832 0 0 0-3.599-.278V2.75Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13 8a.75.75 0 0 1 .671.415l4.25 8.5a.75.75 0 1 1-1.342.67L15.787 16h-5.573l-.793 1.585a.75.75 0 1 1-1.342-.67l4.25-8.5A.75.75 0 0 1 13 8Zm2.037 6.5L13 10.427 10.964 14.5h4.073Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 7a5 5 0 1 1 3.61 4.804l-1.903 1.903A1 1 0 0 1 9 14H8v1a1 1 0 0 1-1 1H6v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 .293-.707L8.196 8.39A5.002 5.002 0 0 1 8 7Zm5-3a.75.75 0 0 0 0 1.5A1.5 1.5 0 0 1 14.5 7 .75.75 0 0 0 16 7a3 3 0 0 0-3-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniItalic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 2.75A.75.75 0 0 1 8.75 2h7.5a.75.75 0 0 1 0 1.5h-3.215l-4.483 13h2.698a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h3.215l4.483-13H8.75A.75.75 0 0 1 8 2.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniInformationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniInbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 11.27c0-.246.033-.492.099-.73l1.523-5.521A2.75 2.75 0 0 1 5.273 3h9.454a2.75 2.75 0 0 1 2.651 2.019l1.523 5.52c.066.239.099.485.099.732V15a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3.73Zm3.068-5.852A1.25 1.25 0 0 1 5.273 4.5h9.454a1.25 1.25 0 0 1 1.205.918l1.523 5.52c.006.02.01.041.015.062H14a1 1 0 0 0-.86.49l-.606 1.02a1 1 0 0 1-.86.49H8.236a1 1 0 0 1-.894-.553l-.448-.894A1 1 0 0 0 6 11H2.53l.015-.062 1.523-5.52Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniInboxStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.045 6.954a2.75 2.75 0 0 1 .217-.678L2.53 3.58A2.75 2.75 0 0 1 5.019 2h9.962a2.75 2.75 0 0 1 2.488 1.58l1.27 2.696c.101.216.174.444.216.678A1 1 0 0 1 19 7.25v1.5a2.75 2.75 0 0 1-2.75 2.75H3.75A2.75 2.75 0 0 1 1 8.75v-1.5a1 1 0 0 1 .045-.296Zm2.843-2.736A1.25 1.25 0 0 1 5.02 3.5h9.962c.484 0 .925.28 1.13.718l.957 2.032H14a1 1 0 0 0-.86.49l-.606 1.02a1 1 0 0 1-.86.49H8.236a1 1 0 0 1-.894-.553l-.448-.894A1 1 0 0 0 6 6.25H2.932l.956-2.032Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 14a1 1 0 0 1 1-1h4a1 1 0 0 1 .894.553l.448.894a1 1 0 0 0 .894.553h3.438a1 1 0 0 0 .86-.49l.606-1.02A1 1 0 0 1 14 13h4a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniInboxArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2a.75.75 0 0 1 .75.75v5.59l1.95-2.1a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0L6.2 7.26a.75.75 0 1 1 1.1-1.02l1.95 2.1V2.75A.75.75 0 0 1 10 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.273 4.5a1.25 1.25 0 0 0-1.205.918l-1.523 5.52c-.006.02-.01.041-.015.062H6a1 1 0 0 1 .894.553l.448.894a1 1 0 0 0 .894.553h3.438a1 1 0 0 0 .86-.49l.606-1.02A1 1 0 0 1 14 11h3.47a1.318 1.318 0 0 0-.015-.062l-1.523-5.52a1.25 1.25 0 0 0-1.205-.918h-.977a.75.75 0 0 1 0-1.5h.977a2.75 2.75 0 0 1 2.651 2.019l1.523 5.52c.066.239.099.485.099.732V15a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3.73c0-.246.033-.492.099-.73l1.523-5.521A2.75 2.75 0 0 1 5.273 3h.977a.75.75 0 0 1 0 1.5h-.977Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniIdentification(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V6Zm4 1.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2 3a4 4 0 0 0-3.665 2.395.75.75 0 0 0 .416 1A8.98 8.98 0 0 0 7 14.5a8.98 8.98 0 0 0 3.249-.604.75.75 0 0 0 .416-1.001A4.001 4.001 0 0 0 7 10.5Zm5-3.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm0 6.5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm.75-4a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.293 2.293a1 1 0 0 1 1.414 0l7 7A1 1 0 0 1 17 11h-1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6H3a1 1 0 0 1-.707-1.707l7-7Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniHomeModern(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.916 2.404a.75.75 0 0 1-.32 1.011l-.596.31V17a1 1 0 0 1-1 1h-2.26a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1 0-1.5H2V9.957a.75.75 0 0 1-.596-1.372L2 8.275V5.75a.75.75 0 0 1 1.5 0v1.745l10.404-5.41a.75.75 0 0 1 1.012.319ZM15.861 8.57a.75.75 0 0 1 .736-.025l1.999 1.04A.75.75 0 0 1 18 10.957V16.5h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75V9.21a.75.75 0 0 1 .361-.64Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9.653 16.915-.005-.003-.019-.01a20.759 20.759 0 0 1-1.162-.682 22.045 22.045 0 0 1-2.582-1.9C4.045 12.733 2 10.352 2 7.5a4.5 4.5 0 0 1 8-2.828A4.5 4.5 0 0 1 18 7.5c0 2.852-2.044 5.233-3.885 6.82a22.049 22.049 0 0 1-3.744 2.582l-.019.01-.005.003h-.002a.739.739 0 0 1-.69.001l-.002-.001Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniHashtag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.493 2.852a.75.75 0 0 0-1.486-.204L7.545 6H4.198a.75.75 0 0 0 0 1.5h3.14l-.69 5H3.302a.75.75 0 0 0 0 1.5h3.14l-.435 3.148a.75.75 0 0 0 1.486.204L7.955 14h2.986l-.434 3.148a.75.75 0 0 0 1.486.204L12.456 14h3.346a.75.75 0 0 0 0-1.5h-3.14l.69-5h3.346a.75.75 0 0 0 0-1.5h-3.14l.435-3.148a.75.75 0 0 0-1.486-.204L12.045 6H9.059l.434-3.148ZM8.852 7.5l-.69 5h2.986l.69-5H8.852Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniHandThumbUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8.25a1.25 1.25 0 1 1 2.5 0v7.5a1.25 1.25 0 1 1-2.5 0v-7.5ZM11 3V1.7c0-.268.14-.526.395-.607A2 2 0 0 1 14 3c0 .995-.182 1.948-.514 2.826-.204.54.166 1.174.744 1.174h2.52c1.243 0 2.261 1.01 2.146 2.247a23.864 23.864 0 0 1-1.341 5.974C17.153 16.323 16.072 17 14.9 17h-3.192a3 3 0 0 1-1.341-.317l-2.734-1.366A3 3 0 0 0 6.292 15H5V8h.963c.685 0 1.258-.483 1.612-1.068a4.011 4.011 0 0 1 2.166-1.73c.432-.143.853-.386 1.011-.814.16-.432.248-.9.248-1.388Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniHandThumbDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.905 12.75a1.25 1.25 0 1 1-2.5 0v-7.5a1.25 1.25 0 0 1 2.5 0v7.5ZM8.905 17v1.3c0 .268-.14.526-.395.607A2 2 0 0 1 5.905 17c0-.995.182-1.948.514-2.826.204-.54-.166-1.174-.744-1.174h-2.52c-1.243 0-2.261-1.01-2.146-2.247.193-2.08.651-4.082 1.341-5.974C2.752 3.678 3.833 3 5.005 3h3.192a3 3 0 0 1 1.341.317l2.734 1.366A3 3 0 0 0 13.613 5h1.292v7h-.963c-.685 0-1.258.482-1.612 1.068a4.01 4.01 0 0 1-2.166 1.73c-.432.143-.853.386-1.011.814-.16.432-.248.9-.248 1.388Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniHandRaised(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11 2a1 1 0 1 0-2 0v6.5a.5.5 0 0 1-1 0V3a1 1 0 1 0-2 0v5.5a.5.5 0 0 1-1 0V5a1 1 0 1 0-2 0v7a7 7 0 1 0 14 0V8a1 1 0 1 0-2 0v3.5a.5.5 0 0 1-1 0V3a1 1 0 1 0-2 0v5.5a.5.5 0 0 1-1 0V2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniH3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.75 4a.75.75 0 0 1 .75.75v4.5h5v-4.5a.75.75 0 0 1 1.5 0v10.5a.75.75 0 0 1-1.5 0v-4.5h-5v4.5a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 2.75 4ZM15 9.5c-.73 0-1.448.051-2.15.15a.75.75 0 1 1-.209-1.485 16.886 16.886 0 0 1 3.476-.128c.985.065 1.878.837 1.883 1.932V10a6.75 6.75 0 0 1-.301 2A6.75 6.75 0 0 1 18 14v.031c-.005 1.095-.898 1.867-1.883 1.932a17.018 17.018 0 0 1-3.467-.127.75.75 0 0 1 .209-1.485 15.377 15.377 0 0 0 3.16.115c.308-.02.48-.24.48-.441L16.5 14c0-.431-.052-.85-.15-1.25h-2.6a.75.75 0 0 1 0-1.5h2.6c.098-.4.15-.818.15-1.25v-.024c-.001-.201-.173-.422-.481-.443A15.485 15.485 0 0 0 15 9.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniH2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.75 4a.75.75 0 0 1 .75.75v4.5h5v-4.5a.75.75 0 0 1 1.5 0v10.5a.75.75 0 0 1-1.5 0v-4.5h-5v4.5a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 2.75 4ZM15 9.5c-.729 0-1.445.051-2.146.15a.75.75 0 0 1-.208-1.486 16.887 16.887 0 0 1 3.824-.1c.855.074 1.512.78 1.527 1.637a17.476 17.476 0 0 1-.009.931 1.713 1.713 0 0 1-1.18 1.556l-2.453.818a1.25 1.25 0 0 0-.855 1.185v.309h3.75a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-1.059a2.75 2.75 0 0 1 1.88-2.608l2.454-.818c.102-.034.153-.117.155-.188a15.556 15.556 0 0 0 .009-.85.171.171 0 0 0-.158-.169A15.458 15.458 0 0 0 15 9.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniH1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.75 4a.75.75 0 0 1 .75.75v4.5h5v-4.5a.75.75 0 0 1 1.5 0v10.5a.75.75 0 0 1-1.5 0v-4.5h-5v4.5a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 2.75 4ZM13 8.75a.75.75 0 0 1 .75-.75h1.75a.75.75 0 0 1 .75.75v5.75h1a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5h1v-5h-1a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniGlobeEuropeAfrica(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-1.503.204A6.5 6.5 0 1 1 7.95 3.83L6.927 5.62a1.453 1.453 0 0 0 1.91 2.02l.175-.087a.5.5 0 0 1 .224-.053h.146a.5.5 0 0 1 .447.724l-.028.055a.4.4 0 0 1-.357.221h-.502a2.26 2.26 0 0 0-1.88 1.006l-.044.066a2.099 2.099 0 0 0 1.085 3.156.58.58 0 0 1 .397.547v1.05a1.175 1.175 0 0 0 2.093.734l1.611-2.014c.192-.24.296-.536.296-.842 0-.316.128-.624.353-.85a1.363 1.363 0 0 0 .173-1.716l-.464-.696a.369.369 0 0 1 .527-.499l.343.257c.316.237.738.275 1.091.098a.586.586 0 0 1 .677.11l1.297 1.297Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniGlobeAsiaAustralia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-6.5 6.326a6.52 6.52 0 0 1-1.5.174 6.487 6.487 0 0 1-5.011-2.36l.49-.98a.423.423 0 0 1 .614-.164l.294.196a.992.992 0 0 0 1.491-1.139l-.197-.593a.252.252 0 0 1 .126-.304l1.973-.987a.938.938 0 0 0 .361-1.359.375.375 0 0 1 .239-.576l.125-.025A2.421 2.421 0 0 0 12.327 6.6l.05-.149a1 1 0 0 0-.242-1.023l-1.489-1.489a.5.5 0 0 1-.146-.353v-.067a6.5 6.5 0 0 1 5.392 9.23 1.398 1.398 0 0 0-.68-.244l-.566-.566a1.5 1.5 0 0 0-1.06-.439h-.172a1.5 1.5 0 0 0-1.06.44l-.593.592a.501.501 0 0 1-.13.093l-1.578.79a1 1 0 0 0-.553.894v.191a1 1 0 0 0 1 1h.5a.5.5 0 0 1 .5.5v.326Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniGlobeAmericas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 1-11-4.69v.447a3.5 3.5 0 0 0 1.025 2.475L8.293 10 8 10.293a1 1 0 0 0 0 1.414l1.06 1.06a1.5 1.5 0 0 1 .44 1.061v.363a1 1 0 0 0 .553.894l.276.139a1 1 0 0 0 1.342-.448l1.454-2.908a1.5 1.5 0 0 0-.281-1.731l-.772-.772a1 1 0 0 0-1.023-.242l-.384.128a.5.5 0 0 1-.606-.25l-.296-.592a.481.481 0 0 1 .646-.646l.262.131a1 1 0 0 0 .447.106h.188a1 1 0 0 0 .949-1.316l-.068-.204a.5.5 0 0 1 .149-.538l1.44-1.234A6.492 6.492 0 0 1 16.5 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniGlobeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.555 5.412a8.028 8.028 0 0 0-3.503-2.81 14.899 14.899 0 0 1 1.663 4.472 8.547 8.547 0 0 0 1.84-1.662ZM13.326 7.825a13.43 13.43 0 0 0-2.413-5.773 8.087 8.087 0 0 0-1.826 0 13.43 13.43 0 0 0-2.413 5.773A8.473 8.473 0 0 0 10 8.5c1.18 0 2.304-.24 3.326-.675ZM6.514 9.376A9.98 9.98 0 0 0 10 10c1.226 0 2.4-.22 3.486-.624a13.54 13.54 0 0 1-.351 3.759A13.54 13.54 0 0 1 10 13.5c-1.079 0-2.128-.127-3.134-.366a13.538 13.538 0 0 1-.352-3.758ZM5.285 7.074a14.9 14.9 0 0 1 1.663-4.471 8.028 8.028 0 0 0-3.503 2.81c.529.638 1.149 1.199 1.84 1.66ZM17.334 6.798a7.973 7.973 0 0 1 .614 4.115 13.47 13.47 0 0 1-3.178 1.72 15.093 15.093 0 0 0 .174-3.939 10.043 10.043 0 0 0 2.39-1.896ZM2.666 6.798a10.042 10.042 0 0 0 2.39 1.896 15.196 15.196 0 0 0 .174 3.94 13.472 13.472 0 0 1-3.178-1.72 7.973 7.973 0 0 1 .615-4.115ZM10 15c.898 0 1.778-.079 2.633-.23a13.473 13.473 0 0 1-1.72 3.178 8.099 8.099 0 0 1-1.826 0 13.47 13.47 0 0 1-1.72-3.178c.855.151 1.735.23 2.633.23ZM14.357 14.357a14.912 14.912 0 0 1-1.305 3.04 8.027 8.027 0 0 0 4.345-4.345c-.953.542-1.971.981-3.04 1.305ZM6.948 17.397a8.027 8.027 0 0 1-4.345-4.345c.953.542 1.971.981 3.04 1.305a14.912 14.912 0 0 0 1.305 3.04Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 6.005a2.5 2.5 0 0 0-4-3 2.5 2.5 0 0 0-4 3H3.25c-.69 0-1.25.56-1.25 1.25v.5c0 .69.56 1.25 1.25 1.25h6v-3h1.5v3h6c.69 0 1.25-.56 1.25-1.25v-.5c0-.69-.56-1.25-1.25-1.25H14Zm-1-1.5a1 1 0 0 1-1 1h-1v-1a1 1 0 1 1 2 0Zm-6 0a1 1 0 0 0 1 1h1v-1a1 1 0 1 0-2 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.25 10.505H3v4.75a2.75 2.75 0 0 0 2.75 2.75h3.5v-7.5ZM10.75 18.005v-7.5H17v4.75a2.75 2.75 0 0 1-2.75 2.75h-3.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniGiftTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.25 3H3.5A1.5 1.5 0 0 0 2 4.5v4.75h3.365A2.75 2.75 0 0 1 9.25 5.362V3ZM2 10.75v4.75A1.5 1.5 0 0 0 3.5 17h5.75v-4.876A4.75 4.75 0 0 1 5 14.75a.75.75 0 0 1 0-1.5 3.251 3.251 0 0 0 3.163-2.5H2ZM10.75 17h5.75a1.5 1.5 0 0 0 1.5-1.5v-4.75h-6.163A3.251 3.251 0 0 0 15 13.25a.75.75 0 0 1 0 1.5 4.75 4.75 0 0 1-4.25-2.626V17ZM18 9.25V4.5A1.5 1.5 0 0 0 16.5 3h-5.75v2.362a2.75 2.75 0 0 1 3.885 3.888H18Zm-4.496-2.755a1.25 1.25 0 0 0-1.768 0c-.36.359-.526.999-.559 1.697-.01.228-.006.443.004.626.183.01.398.014.626.003.698-.033 1.338-.2 1.697-.559a1.25 1.25 0 0 0 0-1.767Zm-5.24 0a1.25 1.25 0 0 0-1.768 1.767c.36.36 1 .526 1.697.56.228.01.443.006.626-.004.01-.183.015-.398.004-.626-.033-.698-.2-1.338-.56-1.697Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniGif(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 5.25A2.25 2.25 0 0 1 3.25 3h13.5A2.25 2.25 0 0 1 19 5.25v9.5A2.25 2.25 0 0 1 16.75 17H3.25A2.25 2.25 0 0 1 1 14.75v-9.5Zm4.026 2.879C5.356 7.65 5.72 7.5 6 7.5s.643.15.974.629a.75.75 0 0 0 1.234-.854C7.66 6.484 6.873 6 6 6c-.873 0-1.66.484-2.208 1.275C3.25 8.059 3 9.048 3 10c0 .952.25 1.941.792 2.725C4.34 13.516 5.127 14 6 14c.873 0 1.66-.484 2.208-1.275a.75.75 0 0 0 .133-.427V10a.75.75 0 0 0-.75-.75H6.25a.75.75 0 0 0 0 1.5h.591v1.295c-.293.342-.6.455-.841.455-.279 0-.643-.15-.974-.629C4.69 11.386 4.5 10.711 4.5 10c0-.711.19-1.386.526-1.871ZM10.75 6a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 .75-.75Zm3 0h2.5a.75.75 0 0 1 0 1.5H14.5v1.75h.75a.75.75 0 0 1 0 1.5h-.75v2.5a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFunnel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 0 1 .628.74v2.288a2.25 2.25 0 0 1-.659 1.59l-4.682 4.683a2.25 2.25 0 0 0-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 0 1 8 18.25v-5.757a2.25 2.25 0 0 0-.659-1.591L2.659 6.22A2.25 2.25 0 0 1 2 4.629V2.34a.75.75 0 0 1 .628-.74Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.288 4.818A1.5 1.5 0 0 0 1 6.095v7.81a1.5 1.5 0 0 0 2.288 1.276l6.323-3.905c.155-.096.285-.213.389-.344v2.973a1.5 1.5 0 0 0 2.288 1.276l6.323-3.905a1.5 1.5 0 0 0 0-2.552l-6.323-3.906A1.5 1.5 0 0 0 10 6.095v2.972a1.506 1.506 0 0 0-.389-.343L3.288 4.818Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.75 3A1.75 1.75 0 0 0 2 4.75v3.26a3.235 3.235 0 0 1 1.75-.51h12.5c.644 0 1.245.188 1.75.51V6.75A1.75 1.75 0 0 0 16.25 5h-4.836a.25.25 0 0 1-.177-.073L9.823 3.513A1.75 1.75 0 0 0 8.586 3H3.75ZM3.75 9A1.75 1.75 0 0 0 2 10.75v4.5c0 .966.784 1.75 1.75 1.75h12.5A1.75 1.75 0 0 0 18 15.25v-4.5A1.75 1.75 0 0 0 16.25 9H3.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFolderPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 3A1.75 1.75 0 0 0 2 4.75v10.5c0 .966.784 1.75 1.75 1.75h12.5A1.75 1.75 0 0 0 18 15.25v-8.5A1.75 1.75 0 0 0 16.25 5h-4.836a.25.25 0 0 1-.177-.073L9.823 3.513A1.75 1.75 0 0 0 8.586 3H3.75ZM10 8a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5A.75.75 0 0 1 10 8Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.75 3A1.75 1.75 0 0 0 3 4.75v2.752l.104-.002h13.792c.035 0 .07 0 .104.002V6.75A1.75 1.75 0 0 0 15.25 5h-3.836a.25.25 0 0 1-.177-.073L9.823 3.513A1.75 1.75 0 0 0 8.586 3H4.75ZM3.104 9a1.75 1.75 0 0 0-1.673 2.265l1.385 4.5A1.75 1.75 0 0 0 4.488 17h11.023a1.75 1.75 0 0 0 1.673-1.235l1.384-4.5A1.75 1.75 0 0 0 16.896 9H3.104Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFolderMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 4.75C2 3.784 2.784 3 3.75 3h4.836c.464 0 .909.184 1.237.513l1.414 1.414a.25.25 0 0 0 .177.073h4.836c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 16.25 17H3.75A1.75 1.75 0 0 1 2 15.25V4.75Zm10.25 7a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0 0 1.5h4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFolderArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 4.75C2 3.784 2.784 3 3.75 3h4.836c.464 0 .909.184 1.237.513l1.414 1.414a.25.25 0 0 0 .177.073h4.836c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 16.25 17H3.75A1.75 1.75 0 0 1 2 15.25V4.75Zm8.75 4a.75.75 0 0 0-1.5 0v2.546l-.943-1.048a.75.75 0 1 0-1.114 1.004l2.25 2.5a.75.75 0 0 0 1.114 0l2.25-2.5a.75.75 0 1 0-1.114-1.004l-.943 1.048V8.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2.75a.75.75 0 0 0-1.5 0v14.5a.75.75 0 0 0 1.5 0v-4.392l1.657-.348a6.449 6.449 0 0 1 4.271.572 7.948 7.948 0 0 0 5.965.524l2.078-.64A.75.75 0 0 0 18 12.25v-8.5a.75.75 0 0 0-.904-.734l-2.38.501a7.25 7.25 0 0 1-4.186-.363l-.502-.2a8.75 8.75 0 0 0-5.053-.439l-1.475.31V2.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.5 4.938a7 7 0 1 1-9.006 1.737c.202-.257.59-.218.793.039.278.352.594.672.943.954.332.269.786-.049.773-.476a5.977 5.977 0 0 1 .572-2.759 6.026 6.026 0 0 1 2.486-2.665c.247-.14.55-.016.677.238A6.967 6.967 0 0 0 13.5 4.938ZM14 12a4 4 0 0 1-4 4c-1.913 0-3.52-1.398-3.91-3.182-.093-.429.44-.643.814-.413a4.043 4.043 0 0 0 1.601.564c.303.038.531-.24.51-.544a5.975 5.975 0 0 1 1.315-4.192.447.447 0 0 1 .431-.16A4.001 4.001 0 0 1 14 12Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFingerPrint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2.5c-1.31 0-2.526.386-3.546 1.051a.75.75 0 0 1-.82-1.256A8 8 0 0 1 18 9a22.47 22.47 0 0 1-1.228 7.351.75.75 0 1 1-1.417-.49A20.97 20.97 0 0 0 16.5 9 6.5 6.5 0 0 0 10 2.5ZM4.333 4.416a.75.75 0 0 1 .218 1.038A6.466 6.466 0 0 0 3.5 9a7.966 7.966 0 0 1-1.293 4.362.75.75 0 0 1-1.257-.819A6.466 6.466 0 0 0 2 9c0-1.61.476-3.11 1.295-4.365a.75.75 0 0 1 1.038-.219ZM10 6.12a3 3 0 0 0-3.001 3.041 11.455 11.455 0 0 1-2.697 7.24.75.75 0 0 1-1.148-.965A9.957 9.957 0 0 0 5.5 9c0-.028.002-.055.004-.082a4.5 4.5 0 0 1 8.996.084V9.15l-.005.297a.75.75 0 1 1-1.5-.034c.003-.11.004-.219.005-.328a3 3 0 0 0-3-2.965Zm0 2.13a.75.75 0 0 1 .75.75c0 3.51-1.187 6.745-3.181 9.323a.75.75 0 1 1-1.186-.918A13.687 13.687 0 0 0 9.25 9a.75.75 0 0 1 .75-.75Zm3.529 3.698a.75.75 0 0 1 .584.885 18.883 18.883 0 0 1-2.257 5.84.75.75 0 1 1-1.29-.764 17.386 17.386 0 0 0 2.078-5.377.75.75 0 0 1 .885-.584Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 4.75C1 3.784 1.784 3 2.75 3h14.5c.966 0 1.75.784 1.75 1.75v10.515a1.75 1.75 0 0 1-1.75 1.75h-1.5c-.078 0-.155-.005-.23-.015H4.48c-.075.01-.152.015-.23.015h-1.5A1.75 1.75 0 0 1 1 15.265V4.75Zm16.5 7.385V11.01a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25v1.125c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25Zm0 2.005a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25v1.125c0 .108.069.2.165.235h1.585a.25.25 0 0 0 .25-.25v-1.11Zm-15 1.11v-1.11a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.125a.25.25 0 0 1-.164.235H2.75a.25.25 0 0 1-.25-.25Zm2-4.24v1.125a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25V11.01a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25Zm13-2.005V7.88a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25v1.125c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25ZM4.25 7.63a.25.25 0 0 1 .25.25v1.125a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25V7.88a.25.25 0 0 1 .25-.25h1.5Zm0-3.13a.25.25 0 0 1 .25.25v1.125a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25V4.75a.25.25 0 0 1 .25-.25h1.5Zm11.5 1.625a.25.25 0 0 1-.25-.25V4.75a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.125a.25.25 0 0 1-.25.25h-1.5Zm-9 3.125a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFaceSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.536-4.464a.75.75 0 1 0-1.061-1.061 3.5 3.5 0 0 1-4.95 0 .75.75 0 0 0-1.06 1.06 5 5 0 0 0 7.07 0ZM9 8.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S7.448 7 8 7s1 .672 1 1.5Zm3 1.5c.552 0 1-.672 1-1.5S12.552 7 12 7s-1 .672-1 1.5.448 1.5 1 1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniFaceFrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-3.536-3.475a.75.75 0 0 0 1.061 0 3.5 3.5 0 0 1 4.95 0 .75.75 0 1 0 1.06-1.06 5 5 0 0 0-7.07 0 .75.75 0 0 0 0 1.06ZM9 8.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S7.448 7 8 7s1 .672 1 1.5Zm3 1.5c.552 0 1-.672 1-1.5S12.552 7 12 7s-1 .672-1 1.5.448 1.5 1 1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.664 10.59a1.651 1.651 0 0 1 0-1.186A10.004 10.004 0 0 1 10 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0 1 10 17c-4.257 0-7.893-2.66-9.336-6.41ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniEyeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06l-1.745-1.745a10.029 10.029 0 0 0 3.3-4.38 1.651 1.651 0 0 0 0-1.185A10.004 10.004 0 0 0 9.999 3a9.956 9.956 0 0 0-4.744 1.194L3.28 2.22ZM7.752 6.69l1.092 1.092a2.5 2.5 0 0 1 3.374 3.373l1.091 1.092a4 4 0 0 0-5.557-5.557Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.748 13.93 2.523 2.523a9.987 9.987 0 0 1-3.27.547c-4.258 0-7.894-2.66-9.337-6.41a1.651 1.651 0 0 1 0-1.186A10.007 10.007 0 0 1 2.839 6.02L6.07 9.252a4 4 0 0 0 4.678 4.678Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniEyeDropper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.1 3.667a3.502 3.502 0 1 1 6.782 1.738 3.487 3.487 0 0 1-.907 1.57 3.495 3.495 0 0 1-1.617.919L16 7.99V10a.75.75 0 0 1-.22.53l-.25.25a.75.75 0 0 1-1.06 0l-.845-.844L7.22 16.34A2.25 2.25 0 0 1 5.629 17H5.12a.75.75 0 0 0-.53.22l-1.56 1.56a.75.75 0 0 1-1.061 0l-.75-.75a.75.75 0 0 1 0-1.06l1.56-1.561a.75.75 0 0 0 .22-.53v-.508c0-.596.237-1.169.659-1.59l6.405-6.406-.844-.845a.75.75 0 0 1 0-1.06l.25-.25A.75.75 0 0 1 10 4h2.01l.09-.333ZM4.72 13.84l6.405-6.405 1.44 1.439-6.406 6.405a.75.75 0 0 1-.53.22H5.12c-.258 0-.511.044-.75.129a2.25 2.25 0 0 0 .129-.75v-.508a.75.75 0 0 1 .22-.53Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniExclamationTriangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniExclamationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 5Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniEquals(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.75 6a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5H3.75ZM3.75 13.5a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5H3.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4a2 2 0 0 0-2 2v1.161l8.441 4.221a1.25 1.25 0 0 0 1.118 0L19 7.162V6a2 2 0 0 0-2-2H3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 8.839-7.77 3.885a2.75 2.75 0 0 1-2.46 0L1 8.839V14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.839Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.106 6.447A2 2 0 0 0 1 8.237V16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.236a2 2 0 0 0-1.106-1.789l-7-3.5a2 2 0 0 0-1.788 0l-7 3.5Zm1.48 4.007a.75.75 0 0 0-.671 1.342l5.855 2.928a2.75 2.75 0 0 0 2.46 0l5.852-2.927a.75.75 0 1 0-.67-1.341l-5.853 2.926a1.25 1.25 0 0 1-1.118 0l-5.856-2.928Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniEllipsisVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM10 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM11.5 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniEllipsisHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8.5 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM15.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniEllipsisHorizontalCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3.5A1.5 1.5 0 0 1 4.5 2h6.879a1.5 1.5 0 0 1 1.06.44l4.122 4.12A1.5 1.5 0 0 1 17 7.622V16.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 3 16.5v-13Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm2.25 8.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm0 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5ZM10 8a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5A.75.75 0 0 1 10 8Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm7.75 9.75a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0 0 1.5h4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentMagnifyingGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm5 5a3 3 0 1 0 1.524 5.585l1.196 1.195a.75.75 0 1 0 1.06-1.06l-1.195-1.196A3 3 0 0 0 9.5 7Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentDuplicate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3.5A1.5 1.5 0 0 1 8.5 2h3.879a1.5 1.5 0 0 1 1.06.44l3.122 3.12A1.5 1.5 0 0 1 17 6.622V12.5a1.5 1.5 0 0 1-1.5 1.5h-1v-3.379a3 3 0 0 0-.879-2.121L10.5 5.379A3 3 0 0 0 8.379 4.5H7v-1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 6A1.5 1.5 0 0 0 3 7.5v9A1.5 1.5 0 0 0 4.5 18h7a1.5 1.5 0 0 0 1.5-1.5v-5.879a1.5 1.5 0 0 0-.44-1.06L9.44 6.439A1.5 1.5 0 0 0 8.378 6H4.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentCurrencyYen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm3.846 4.294a.75.75 0 0 0-1.192.912L9.056 10H6.75a.75.75 0 0 0 0 1.5h2.5v1h-2.5a.75.75 0 0 0 0 1.5h2.5v1.25a.75.75 0 1 0 1.5 0V14h2.5a.75.75 0 1 0 0-1.5h-2.5v-1h2.5a.75.75 0 1 0 0-1.5h-2.306l1.902-2.794a.75.75 0 0 0-1.192-.912L10 8.765l-1.654-2.47Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentCurrencyRupee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5ZM6 5.75A.75.75 0 0 1 6.75 5h6.5a.75.75 0 0 1 0 1.5h-2.127c.4.5.683 1.096.807 1.75h1.32a.75.75 0 0 1 0 1.5h-1.32a4.003 4.003 0 0 1-3.404 3.216l1.754 1.754a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 .53-1.28H8c1.12 0 2.067-.736 2.386-1.75H6.75a.75.75 0 0 1 0-1.5h3.636A2.501 2.501 0 0 0 8 6.5H6.75A.75.75 0 0 1 6 5.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentCurrencyPound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm5 7a1.5 1.5 0 0 1 2.56-1.06.75.75 0 1 0 1.062-1.061A3 3 0 0 0 8 9v1.25H6.75a.75.75 0 0 0 0 1.5H8v1a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 1 0 0-1.5H9.372c.083-.235.128-.487.128-.75v-1h1.25a.75.75 0 0 0 0-1.5H9.5V9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentCurrencyEuro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm4.298 6.45c.512-.67 1.135-.95 1.702-.95s1.19.28 1.702.95a.75.75 0 0 0 1.192-.91C12.637 6.55 11.596 6 10.5 6s-2.137.55-2.894 1.54A5.205 5.205 0 0 0 6.83 9H5.75a.75.75 0 0 0 0 1.5h.77a6.333 6.333 0 0 0 0 1h-.77a.75.75 0 0 0 0 1.5h1.08c.183.528.442 1.023.776 1.46.757.99 1.798 1.54 2.894 1.54s2.137-.55 2.894-1.54a.75.75 0 0 0-1.192-.91c-.512.67-1.135.95-1.702.95s-1.19-.28-1.702-.95a3.505 3.505 0 0 1-.343-.55h1.795a.75.75 0 0 0 0-1.5H8.026a4.835 4.835 0 0 1 0-1h2.224a.75.75 0 0 0 0-1.5H8.455c.098-.195.212-.38.343-.55Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentCurrencyDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm6.25 3.75a.75.75 0 0 0-1.5 0v.272c-.418.024-.831.069-1.238.132-.962.15-1.807.882-1.95 1.928-.04.3-.062.607-.062.918 0 1.044.83 1.759 1.708 1.898l1.542.243v2.334a11.214 11.214 0 0 1-2.297-.392.75.75 0 0 0-.405 1.444c.867.243 1.772.397 2.702.451v.272a.75.75 0 0 0 1.5 0v-.272c.419-.024.832-.069 1.239-.132.961-.15 1.807-.882 1.95-1.928.04-.3.061-.607.061-.918 0-1.044-.83-1.759-1.708-1.898L10.75 9.86V7.525c.792.052 1.56.185 2.297.392a.75.75 0 0 0 .406-1.444 12.723 12.723 0 0 0-2.703-.451V5.75ZM8.244 7.636c.33-.052.666-.09 1.006-.111v2.097l-1.308-.206C7.635 9.367 7.5 9.156 7.5 9c0-.243.017-.482.049-.716.042-.309.305-.587.695-.648Zm2.506 5.84v-2.098l1.308.206c.307.049.442.26.442.416 0 .243-.016.482-.048.716-.042.309-.306.587-.695.648-.331.052-.667.09-1.007.111Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentCurrencyBangladeshi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm1.97 4.53a.75.75 0 0 0 .78.178V8h-1.5a.75.75 0 1 0 0 1.5h1.5v3.098c0 .98.571 2.18 1.837 2.356a4.751 4.751 0 0 0 5.066-2.92.75.75 0 0 0-.695-1.031H11.75a.75.75 0 0 0 0 1.5h.343a3.241 3.241 0 0 1-2.798.966c-.25-.035-.545-.322-.545-.87V9.5h5.5a.75.75 0 0 0 0-1.5h-5.5V6.415c0-1.19-1.439-1.786-2.28-.945a.75.75 0 0 0 0 1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3.5A1.5 1.5 0 0 1 4.5 2h6.879a1.5 1.5 0 0 1 1.06.44l4.122 4.12A1.5 1.5 0 0 1 17 7.622V16.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 3 16.5v-13Zm10.857 5.691a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 0 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3.5A1.5 1.5 0 0 1 4.5 2h6.879a1.5 1.5 0 0 1 1.06.44l4.122 4.12A1.5 1.5 0 0 1 17 7.622V16.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 3 16.5v-13ZM13.25 9a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75Zm-6.5 4a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 .75-.75Zm4-1.25a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm4.75 11.25a.75.75 0 0 0 1.5 0v-2.546l.943 1.048a.75.75 0 1 0 1.114-1.004l-2.25-2.5a.75.75 0 0 0-1.114 0l-2.25 2.5a.75.75 0 1 0 1.114 1.004l.943-1.048v2.546Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDocumentArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm4.75 6.75a.75.75 0 0 1 1.5 0v2.546l.943-1.048a.75.75 0 0 1 1.114 1.004l-2.25 2.5a.75.75 0 0 1-1.114 0l-2.25-2.5a.75.75 0 1 1 1.114-1.004l.943 1.048V8.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDivide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 4a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM3 10a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 10ZM10 17.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDeviceTablet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 1a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H5ZM3.5 4A1.5 1.5 0 0 1 5 2.5h10A1.5 1.5 0 0 1 16.5 4v12a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 16V4Zm5.25 11.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniDevicePhoneMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V4Zm4-1.5v.75c0 .414.336.75.75.75h2.5a.75.75 0 0 0 .75-.75V2.5h1A1.5 1.5 0 0 1 14.5 4v12a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 16V4A1.5 1.5 0 0 1 7 2.5h1Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCursorArrowRipple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.111 11.89A5.5 5.5 0 1 1 15.501 8 .75.75 0 0 0 17 8a7 7 0 1 0-11.95 4.95.75.75 0 0 0 1.06-1.06Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.232 6.232a2.5 2.5 0 0 0 0 3.536.75.75 0 1 1-1.06 1.06A4 4 0 1 1 14 8a.75.75 0 0 1-1.5 0 2.5 2.5 0 0 0-4.268-1.768Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.766 7.51a.75.75 0 0 0-1.37.365l-.492 6.861a.75.75 0 0 0 1.204.65l1.043-.799.985 3.678a.75.75 0 0 0 1.45-.388l-.978-3.646 1.292.204a.75.75 0 0 0 .74-1.16l-3.874-5.764Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCursorArrowRays(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 1a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 1ZM5.05 3.05a.75.75 0 0 1 1.06 0l1.062 1.06A.75.75 0 1 1 6.11 5.173L5.05 4.11a.75.75 0 0 1 0-1.06ZM14.95 3.05a.75.75 0 0 1 0 1.06l-1.06 1.062a.75.75 0 0 1-1.062-1.061l1.061-1.06a.75.75 0 0 1 1.06 0ZM3 8a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 3 8ZM14 8a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 14 8ZM7.172 10.828a.75.75 0 0 1 0 1.061L6.11 12.95a.75.75 0 0 1-1.06-1.06l1.06-1.06a.75.75 0 0 1 1.06 0ZM10.766 7.51a.75.75 0 0 0-1.37.365l-.492 6.861a.75.75 0 0 0 1.204.65l1.043-.799.985 3.678a.75.75 0 0 0 1.45-.388l-.978-3.646 1.292.204a.75.75 0 0 0 .74-1.16l-3.874-5.764Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCurrencyYen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7.346 5.294a.75.75 0 0 0-1.192.912L9.056 10H6.75a.75.75 0 0 0 0 1.5h2.5v1h-2.5a.75.75 0 0 0 0 1.5h2.5v1.25a.75.75 0 0 0 1.5 0V14h2.5a.75.75 0 1 0 0-1.5h-2.5v-1h2.5a.75.75 0 1 0 0-1.5h-2.306l2.902-3.794a.75.75 0 1 0-1.192-.912L10 8.765l-2.654-3.47Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCurrencyRupee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM6 5.75A.75.75 0 0 1 6.75 5h6.5a.75.75 0 0 1 0 1.5h-2.127c.4.5.683 1.096.807 1.75h1.32a.75.75 0 0 1 0 1.5h-1.32a4.003 4.003 0 0 1-3.404 3.216l1.754 1.754a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 .53-1.28H8c1.12 0 2.067-.736 2.386-1.75H6.75a.75.75 0 0 1 0-1.5h3.636A2.501 2.501 0 0 0 8 6.5H6.75A.75.75 0 0 1 6 5.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCurrencyPound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.732 6.232a2.5 2.5 0 0 1 3.536 0 .75.75 0 1 0 1.06-1.06A4 4 0 0 0 6.5 8v.165c0 .364.034.728.1 1.085h-.35a.75.75 0 0 0 0 1.5h.737a5.25 5.25 0 0 1-.367 3.072l-.055.123a.75.75 0 0 0 .848 1.037l1.272-.283a3.493 3.493 0 0 1 1.604.021 4.992 4.992 0 0 0 2.422 0l.97-.242a.75.75 0 0 0-.363-1.456l-.971.243a3.491 3.491 0 0 1-1.694 0 4.992 4.992 0 0 0-2.258-.038c.19-.811.227-1.651.111-2.477H9.75a.75.75 0 0 0 0-1.5H8.136A4.397 4.397 0 0 1 8 8.165V8c0-.641.244-1.28.732-1.768Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCurrencyEuro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.798 7.45c.512-.67 1.135-.95 1.702-.95s1.19.28 1.702.95a.75.75 0 0 0 1.192-.91C12.637 5.55 11.596 5 10.5 5s-2.137.55-2.894 1.54A5.205 5.205 0 0 0 6.83 8H5.75a.75.75 0 0 0 0 1.5h.77a6.333 6.333 0 0 0 0 1h-.77a.75.75 0 0 0 0 1.5h1.08c.183.528.442 1.023.776 1.46.757.99 1.798 1.54 2.894 1.54s2.137-.55 2.894-1.54a.75.75 0 0 0-1.192-.91c-.512.67-1.135.95-1.702.95s-1.19-.28-1.702-.95a3.505 3.505 0 0 1-.343-.55h1.795a.75.75 0 0 0 0-1.5H8.026a4.835 4.835 0 0 1 0-1h2.224a.75.75 0 0 0 0-1.5H8.455c.098-.195.212-.38.343-.55Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCurrencyDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.75 10.818v2.614A3.13 3.13 0 0 0 11.888 13c.482-.315.612-.648.612-.875 0-.227-.13-.56-.612-.875a3.13 3.13 0 0 0-1.138-.432ZM8.33 8.62c.053.055.115.11.184.164.208.16.46.284.736.363V6.603a2.45 2.45 0 0 0-.35.13c-.14.065-.27.143-.386.233-.377.292-.514.627-.514.909 0 .184.058.39.202.592.037.051.08.102.128.152Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-6a.75.75 0 0 1 .75.75v.316a3.78 3.78 0 0 1 1.653.713c.426.33.744.74.925 1.2a.75.75 0 0 1-1.395.55 1.35 1.35 0 0 0-.447-.563 2.187 2.187 0 0 0-.736-.363V9.3c.698.093 1.383.32 1.959.696.787.514 1.29 1.27 1.29 2.13 0 .86-.504 1.616-1.29 2.13-.576.377-1.261.603-1.96.696v.299a.75.75 0 1 1-1.5 0v-.3c-.697-.092-1.382-.318-1.958-.695-.482-.315-.857-.717-1.078-1.188a.75.75 0 1 1 1.359-.636c.08.173.245.376.54.569.313.205.706.353 1.138.432v-2.748a3.782 3.782 0 0 1-1.653-.713C6.9 9.433 6.5 8.681 6.5 7.875c0-.805.4-1.558 1.097-2.096a3.78 3.78 0 0 1 1.653-.713V4.75A.75.75 0 0 1 10 4Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCurrencyBangladeshi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM5.94 5.5c.944-.945 2.56-.276 2.56 1.06V8h5.75a.75.75 0 0 1 0 1.5H8.5v4.275c0 .296.144.455.26.499a3.5 3.5 0 0 0 4.402-1.77h-.412a.75.75 0 0 1 0-1.5h.537c.462 0 .887.21 1.156.556.278.355.383.852.184 1.337a5.001 5.001 0 0 1-6.4 2.78C7.376 15.353 7 14.512 7 13.774V9.5H5.75a.75.75 0 0 1 0-1.5H7V6.56l-.22.22a.75.75 0 1 1-1.06-1.06l.22-.22Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.362 1.093a.75.75 0 0 0-.724 0L2.523 5.018 10 9.143l7.477-4.125-7.115-3.925ZM18 6.443l-7.25 4v8.25l6.862-3.786A.75.75 0 0 0 18 14.25V6.443ZM9.25 18.693v-8.25l-7.25-4v7.807a.75.75 0 0 0 .388.657l6.862 3.786Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCubeTransparent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.638 1.093a.75.75 0 0 1 .724 0l2 1.104a.75.75 0 1 1-.724 1.313L10 2.607l-1.638.903a.75.75 0 1 1-.724-1.313l2-1.104ZM5.403 4.287a.75.75 0 0 1-.295 1.019l-.805.444.805.444a.75.75 0 0 1-.724 1.314L3.5 7.02v.73a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .388-.657l1.996-1.1a.75.75 0 0 1 1.019.294Zm9.194 0a.75.75 0 0 1 1.02-.295l1.995 1.101A.75.75 0 0 1 18 5.75v2a.75.75 0 0 1-1.5 0v-.73l-.884.488a.75.75 0 1 1-.724-1.314l.806-.444-.806-.444a.75.75 0 0 1-.295-1.02ZM7.343 8.284a.75.75 0 0 1 1.02-.294L10 8.893l1.638-.903a.75.75 0 1 1 .724 1.313l-1.612.89v1.557a.75.75 0 0 1-1.5 0v-1.557l-1.612-.89a.75.75 0 0 1-.295-1.019ZM2.75 11.5a.75.75 0 0 1 .75.75v1.557l1.608.887a.75.75 0 0 1-.724 1.314l-1.996-1.101A.75.75 0 0 1 2 14.25v-2a.75.75 0 0 1 .75-.75Zm14.5 0a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-.388.657l-1.996 1.1a.75.75 0 1 1-.724-1.313l1.608-.887V12.25a.75.75 0 0 1 .75-.75Zm-7.25 4a.75.75 0 0 1 .75.75v.73l.888-.49a.75.75 0 0 1 .724 1.313l-2 1.104a.75.75 0 0 1-.724 0l-2-1.104a.75.75 0 1 1 .724-1.313l.888.49v-.73a.75.75 0 0 1 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.5 4A1.5 1.5 0 0 0 1 5.5V6h18v-.5A1.5 1.5 0 0 0 17.5 4h-15ZM19 8.5H1v6A1.5 1.5 0 0 0 2.5 16h15a1.5 1.5 0 0 0 1.5-1.5v-6ZM3 13.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm4.75-.75a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCpuChip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6H6v8h8V6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.25 3V1.75a.75.75 0 0 1 1.5 0V3h1.5V1.75a.75.75 0 0 1 1.5 0V3h.5A2.75 2.75 0 0 1 17 5.75v.5h1.25a.75.75 0 0 1 0 1.5H17v1.5h1.25a.75.75 0 0 1 0 1.5H17v1.5h1.25a.75.75 0 0 1 0 1.5H17v.5A2.75 2.75 0 0 1 14.25 17h-.5v1.25a.75.75 0 0 1-1.5 0V17h-1.5v1.25a.75.75 0 0 1-1.5 0V17h-1.5v1.25a.75.75 0 0 1-1.5 0V17h-.5A2.75 2.75 0 0 1 3 14.25v-.5H1.75a.75.75 0 0 1 0-1.5H3v-1.5H1.75a.75.75 0 0 1 0-1.5H3v-1.5H1.75a.75.75 0 0 1 0-1.5H3v-.5A2.75 2.75 0 0 1 5.75 3h.5V1.75a.75.75 0 0 1 1.5 0V3h1.5ZM4.5 5.75c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25v-8.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniComputerDesktop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 4.25A2.25 2.25 0 0 1 4.25 2h11.5A2.25 2.25 0 0 1 18 4.25v8.5A2.25 2.25 0 0 1 15.75 15h-3.105a3.501 3.501 0 0 0 1.1 1.677A.75.75 0 0 1 13.26 18H6.74a.75.75 0 0 1-.484-1.323A3.501 3.501 0 0 0 7.355 15H4.25A2.25 2.25 0 0 1 2 12.75v-8.5Zm1.5 0a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-.75.75H4.25a.75.75 0 0 1-.75-.75v-7.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCommandLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.25 3A2.25 2.25 0 0 0 1 5.25v9.5A2.25 2.25 0 0 0 3.25 17h13.5A2.25 2.25 0 0 0 19 14.75v-9.5A2.25 2.25 0 0 0 16.75 3H3.25Zm.943 8.752a.75.75 0 0 1 .055-1.06L6.128 9l-1.88-1.693a.75.75 0 1 1 1.004-1.114l2.5 2.25a.75.75 0 0 1 0 1.114l-2.5 2.25a.75.75 0 0 1-1.06-.055ZM9.75 10.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.024 9.25c.47 0 .827-.433.637-.863a4 4 0 0 0-4.094-2.364c-.468.05-.665.576-.43.984l1.08 1.868a.75.75 0 0 0 .649.375h2.158ZM7.84 7.758c-.236-.408-.79-.5-1.068-.12A3.982 3.982 0 0 0 6 10c0 .884.287 1.7.772 2.363.278.38.832.287 1.068-.12l1.078-1.868a.75.75 0 0 0 0-.75L7.839 7.758ZM9.138 12.993c-.235.408-.039.934.43.984a4 4 0 0 0 4.094-2.364c.19-.43-.168-.863-.638-.863h-2.158a.75.75 0 0 0-.65.375l-1.078 1.868Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m14.13 4.347.644-1.117a.75.75 0 0 0-1.299-.75l-.644 1.116a6.954 6.954 0 0 0-2.081-.556V1.75a.75.75 0 0 0-1.5 0v1.29a6.954 6.954 0 0 0-2.081.556L6.525 2.48a.75.75 0 1 0-1.3.75l.645 1.117A7.04 7.04 0 0 0 4.347 5.87L3.23 5.225a.75.75 0 1 0-.75 1.3l1.116.644A6.954 6.954 0 0 0 3.04 9.25H1.75a.75.75 0 0 0 0 1.5h1.29c.078.733.27 1.433.556 2.081l-1.116.645a.75.75 0 1 0 .75 1.298l1.117-.644a7.04 7.04 0 0 0 1.523 1.523l-.645 1.117a.75.75 0 1 0 1.3.75l.644-1.116a6.954 6.954 0 0 0 2.081.556v1.29a.75.75 0 0 0 1.5 0v-1.29a6.954 6.954 0 0 0 2.081-.556l.645 1.116a.75.75 0 0 0 1.299-.75l-.645-1.117a7.042 7.042 0 0 0 1.523-1.523l1.117.644a.75.75 0 0 0 .75-1.298l-1.116-.645a6.954 6.954 0 0 0 .556-2.081h1.29a.75.75 0 0 0 0-1.5h-1.29a6.954 6.954 0 0 0-.556-2.081l1.116-.644a.75.75 0 0 0-.75-1.3l-1.117.645a7.04 7.04 0 0 0-1.524-1.523ZM10 4.5a5.475 5.475 0 0 0-2.781.754A5.527 5.527 0 0 0 5.22 7.277 5.475 5.475 0 0 0 4.5 10a5.475 5.475 0 0 0 .752 2.777 5.527 5.527 0 0 0 2.028 2.004c.802.458 1.73.719 2.72.719a5.474 5.474 0 0 0 2.78-.753 5.527 5.527 0 0 0 2.001-2.027c.458-.802.719-1.73.719-2.72a5.475 5.475 0 0 0-.753-2.78 5.528 5.528 0 0 0-2.028-2.002A5.475 5.475 0 0 0 10 4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCog8Tooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.34 1.804A1 1 0 0 1 9.32 1h1.36a1 1 0 0 1 .98.804l.295 1.473c.497.144.971.342 1.416.587l1.25-.834a1 1 0 0 1 1.262.125l.962.962a1 1 0 0 1 .125 1.262l-.834 1.25c.245.445.443.919.587 1.416l1.473.294a1 1 0 0 1 .804.98v1.361a1 1 0 0 1-.804.98l-1.473.295a6.95 6.95 0 0 1-.587 1.416l.834 1.25a1 1 0 0 1-.125 1.262l-.962.962a1 1 0 0 1-1.262.125l-1.25-.834a6.953 6.953 0 0 1-1.416.587l-.294 1.473a1 1 0 0 1-.98.804H9.32a1 1 0 0 1-.98-.804l-.295-1.473a6.957 6.957 0 0 1-1.416-.587l-1.25.834a1 1 0 0 1-1.262-.125l-.962-.962a1 1 0 0 1-.125-1.262l.834-1.25a6.957 6.957 0 0 1-.587-1.416l-1.473-.294A1 1 0 0 1 1 10.68V9.32a1 1 0 0 1 .804-.98l1.473-.295c.144-.497.342-.971.587-1.416l-.834-1.25a1 1 0 0 1 .125-1.262l.962-.962A1 1 0 0 1 5.38 3.03l1.25.834a6.957 6.957 0 0 1 1.416-.587l.294-1.473ZM13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCog6Tooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.84 1.804A1 1 0 0 1 8.82 1h2.36a1 1 0 0 1 .98.804l.331 1.652a6.993 6.993 0 0 1 1.929 1.115l1.598-.54a1 1 0 0 1 1.186.447l1.18 2.044a1 1 0 0 1-.205 1.251l-1.267 1.113a7.047 7.047 0 0 1 0 2.228l1.267 1.113a1 1 0 0 1 .206 1.25l-1.18 2.045a1 1 0 0 1-1.187.447l-1.598-.54a6.993 6.993 0 0 1-1.929 1.115l-.33 1.652a1 1 0 0 1-.98.804H8.82a1 1 0 0 1-.98-.804l-.331-1.652a6.993 6.993 0 0 1-1.929-1.115l-1.598.54a1 1 0 0 1-1.186-.447l-1.18-2.044a1 1 0 0 1 .205-1.251l1.267-1.114a7.05 7.05 0 0 1 0-2.227L1.821 7.773a1 1 0 0 1-.206-1.25l1.18-2.045a1 1 0 0 1 1.187-.447l1.598.54A6.992 6.992 0 0 1 7.51 3.456l.33-1.652ZM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCodeBracket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.28 5.22a.75.75 0 0 1 0 1.06L2.56 10l3.72 3.72a.75.75 0 0 1-1.06 1.06L.97 10.53a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Zm7.44 0a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L17.44 10l-3.72-3.72a.75.75 0 0 1 0-1.06ZM11.377 2.011a.75.75 0 0 1 .612.867l-2.5 14.5a.75.75 0 0 1-1.478-.255l2.5-14.5a.75.75 0 0 1 .866-.612Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCodeBracketSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.25 2A2.25 2.25 0 0 0 2 4.25v11.5A2.25 2.25 0 0 0 4.25 18h11.5A2.25 2.25 0 0 0 18 15.75V4.25A2.25 2.25 0 0 0 15.75 2H4.25Zm4.03 6.28a.75.75 0 0 0-1.06-1.06L4.97 9.47a.75.75 0 0 0 0 1.06l2.25 2.25a.75.75 0 0 0 1.06-1.06L6.56 10l1.72-1.72Zm4.5-1.06a.75.75 0 1 0-1.06 1.06L13.44 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06l2.25-2.25a.75.75 0 0 0 0-1.06l-2.25-2.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 12.5A4.5 4.5 0 0 0 5.5 17H15a4 4 0 0 0 1.866-7.539 3.504 3.504 0 0 0-4.504-4.272A4.5 4.5 0 0 0 4.06 8.235 4.502 4.502 0 0 0 1 12.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCloudArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.5 17a4.5 4.5 0 0 1-1.44-8.765 4.5 4.5 0 0 1 8.302-3.046 3.5 3.5 0 0 1 4.504 4.272A4 4 0 0 1 15 17H5.5Zm3.75-2.75a.75.75 0 0 0 1.5 0V9.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0l-3.25 3.5a.75.75 0 1 0 1.1 1.02l1.95-2.1v4.59Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCloudArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.5 17a4.5 4.5 0 0 1-1.44-8.765 4.5 4.5 0 0 1 8.302-3.046 3.5 3.5 0 0 1 4.504 4.272A4 4 0 0 1 15 17H5.5Zm5.25-9.25a.75.75 0 0 0-1.5 0v4.59l-1.95-2.1a.75.75 0 1 0-1.1 1.02l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 1 0-1.1-1.02l-1.95 2.1V7.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-13a.75.75 0 0 0-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5h-3.25V5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.887 3.182c.396.037.79.08 1.183.128C16.194 3.45 17 4.414 17 5.517V16.75A2.25 2.25 0 0 1 14.75 19h-9.5A2.25 2.25 0 0 1 3 16.75V5.517c0-1.103.806-2.068 1.93-2.207.393-.048.787-.09 1.183-.128A3.001 3.001 0 0 1 9 1h2c1.373 0 2.531.923 2.887 2.182ZM7.5 4A1.5 1.5 0 0 1 9 2.5h2A1.5 1.5 0 0 1 12.5 4v.5h-5V4Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniClipboardDocument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.988 3.012A2.25 2.25 0 0 1 18 5.25v6.5A2.25 2.25 0 0 1 15.75 14H13.5v-3.379a3 3 0 0 0-.879-2.121l-3.12-3.121a3 3 0 0 0-1.402-.791 2.252 2.252 0 0 1 1.913-1.576A2.25 2.25 0 0 1 12.25 1h1.5a2.25 2.25 0 0 1 2.238 2.012ZM11.5 3.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v.25h-3v-.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 6A1.5 1.5 0 0 0 2 7.5v9A1.5 1.5 0 0 0 3.5 18h7a1.5 1.5 0 0 0 1.5-1.5v-5.879a1.5 1.5 0 0 0-.44-1.06L8.44 6.439A1.5 1.5 0 0 0 7.378 6H3.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniClipboardDocumentList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.988 3.012A2.25 2.25 0 0 1 18 5.25v6.5A2.25 2.25 0 0 1 15.75 14H13.5V7A2.5 2.5 0 0 0 11 4.5H8.128a2.252 2.252 0 0 1 1.884-1.488A2.25 2.25 0 0 1 12.25 1h1.5a2.25 2.25 0 0 1 2.238 2.012ZM11.5 3.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v.25h-3v-.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7Zm2 3.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniClipboardDocumentCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 5.25a2.25 2.25 0 0 0-2.012-2.238A2.25 2.25 0 0 0 13.75 1h-1.5a2.25 2.25 0 0 0-2.238 2.012c-.875.092-1.6.686-1.884 1.488H11A2.5 2.5 0 0 1 13.5 7v7h2.25A2.25 2.25 0 0 0 18 11.75v-6.5ZM12.25 2.5a.75.75 0 0 0-.75.75v.25h3v-.25a.75.75 0 0 0-.75-.75h-1.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3Zm6.874 4.166a.75.75 0 1 0-1.248-.832l-2.493 3.739-.853-.853a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.154-.114l3-4.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCircleStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 1c3.866 0 7 1.79 7 4s-3.134 4-7 4-7-1.79-7-4 3.134-4 7-4Zm5.694 8.13c.464-.264.91-.583 1.306-.952V10c0 2.21-3.134 4-7 4s-7-1.79-7-4V8.178c.396.37.842.688 1.306.953C5.838 10.006 7.854 10.5 10 10.5s4.162-.494 5.694-1.37ZM3 13.179V15c0 2.21 3.134 4 7 4s7-1.79 7-4v-1.822c-.396.37-.842.688-1.306.953-1.532.875-3.548 1.369-5.694 1.369s-4.162-.494-5.694-1.37A7.009 7.009 0 0 1 3 13.179Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.47 6.47a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 8.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06l4.25-4.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChevronUpDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.53 3.47a.75.75 0 0 0-1.06 0L6.22 6.72a.75.75 0 0 0 1.06 1.06L10 5.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-3.25-3.25Zm-4.31 9.81 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06L10 14.94l-2.72-2.72a.75.75 0 0 0-1.06 1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChevronDoubleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.47 4.72a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 6.31l-3.72 3.72a.75.75 0 1 1-1.06-1.06l4.25-4.25Zm-4.25 9.25 4.25-4.25a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 11.31l-3.72 3.72a.75.75 0 0 1-1.06-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChevronDoubleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.28 9.47a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 1 1-1.06-1.06L13.69 10 9.97 6.28a.75.75 0 0 1 1.06-1.06l4.25 4.25ZM6.03 5.22l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L8.69 10 4.97 6.28a.75.75 0 0 1 1.06-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChevronDoubleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.72 9.47a.75.75 0 0 0 0 1.06l4.25 4.25a.75.75 0 1 0 1.06-1.06L6.31 10l3.72-3.72a.75.75 0 1 0-1.06-1.06L4.72 9.47Zm9.25-4.25L9.72 9.47a.75.75 0 0 0 0 1.06l4.25 4.25a.75.75 0 1 0 1.06-1.06L11.31 10l3.72-3.72a.75.75 0 0 0-1.06-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChevronDoubleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.47 15.28a.75.75 0 0 0 1.06 0l4.25-4.25a.75.75 0 1 0-1.06-1.06L10 13.69 6.28 9.97a.75.75 0 0 0-1.06 1.06l4.25 4.25ZM5.22 6.03l4.25 4.25a.75.75 0 0 0 1.06 0l4.25-4.25a.75.75 0 0 0-1.06-1.06L10 8.69 6.28 4.97a.75.75 0 0 0-1.06 1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCheckBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.403 12.652a3 3 0 0 0 0-5.304 3 3 0 0 0-3.75-3.751 3 3 0 0 0-5.305 0 3 3 0 0 0-3.751 3.75 3 3 0 0 0 0 5.305 3 3 0 0 0 3.75 3.751 3 3 0 0 0 5.305 0 3 3 0 0 0 3.751-3.75Zm-2.546-4.46a.75.75 0 0 0-1.214-.883l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChatBubbleOvalLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 10c0-3.967 3.69-7 8-7 4.31 0 8 3.033 8 7s-3.69 7-8 7a9.165 9.165 0 0 1-1.504-.123 5.976 5.976 0 0 1-3.935 1.107.75.75 0 0 1-.584-1.143 3.478 3.478 0 0 0 .522-1.756C2.979 13.825 2 12.025 2 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChatBubbleOvalLeftEllipsis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 3c-4.31 0-8 3.033-8 7 0 2.024.978 3.825 2.499 5.085a3.478 3.478 0 0 1-.522 1.756.75.75 0 0 0 .584 1.143 5.976 5.976 0 0 0 3.936-1.108c.487.082.99.124 1.503.124 4.31 0 8-3.033 8-7s-3.69-7-8-7Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-2-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChatBubbleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.43 2.524A41.29 41.29 0 0 1 10 2c2.236 0 4.43.18 6.57.524 1.437.231 2.43 1.49 2.43 2.902v5.148c0 1.413-.993 2.67-2.43 2.902a41.202 41.202 0 0 1-5.183.501.78.78 0 0 0-.528.224l-3.579 3.58A.75.75 0 0 1 6 17.25v-3.443a41.033 41.033 0 0 1-2.57-.33C1.993 13.244 1 11.986 1 10.573V5.426c0-1.413.993-2.67 2.43-2.902Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChatBubbleLeftRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.505 2.365A41.369 41.369 0 0 1 9 2c1.863 0 3.697.124 5.495.365 1.247.167 2.18 1.108 2.435 2.268a4.45 4.45 0 0 0-.577-.069 43.141 43.141 0 0 0-4.706 0C9.229 4.696 7.5 6.727 7.5 8.998v2.24c0 1.413.67 2.735 1.76 3.562l-2.98 2.98A.75.75 0 0 1 5 17.25v-3.443c-.501-.048-1-.106-1.495-.172C2.033 13.438 1 12.162 1 10.72V5.28c0-1.441 1.033-2.717 2.505-2.914Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6c-.762 0-1.52.02-2.271.062C10.157 6.148 9 7.472 9 8.998v2.24c0 1.519 1.147 2.839 2.71 2.935.214.013.428.024.642.034.2.009.385.09.518.224l2.35 2.35a.75.75 0 0 0 1.28-.531v-2.07c1.453-.195 2.5-1.463 2.5-2.915V8.998c0-1.526-1.157-2.85-2.729-2.936A41.645 41.645 0 0 0 14 6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChatBubbleLeftEllipsis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2c-2.236 0-4.43.18-6.57.524C1.993 2.755 1 4.014 1 5.426v5.148c0 1.413.993 2.67 2.43 2.902.848.137 1.705.248 2.57.331v3.443a.75.75 0 0 0 1.28.53l3.58-3.579a.78.78 0 0 1 .527-.224 41.202 41.202 0 0 0 5.183-.5c1.437-.232 2.43-1.49 2.43-2.903V5.426c0-1.413-.993-2.67-2.43-2.902A41.289 41.289 0 0 0 10 2Zm0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChatBubbleBottomCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.43 2.524A41.29 41.29 0 0 1 10 2c2.236 0 4.43.18 6.57.524 1.437.231 2.43 1.49 2.43 2.902v5.148c0 1.413-.993 2.67-2.43 2.902a41.102 41.102 0 0 1-3.55.414c-.28.02-.521.18-.643.413l-1.712 3.293a.75.75 0 0 1-1.33 0l-1.713-3.293a.783.783 0 0 0-.642-.413 41.108 41.108 0 0 1-3.55-.414C1.993 13.245 1 11.986 1 10.574V5.426c0-1.413.993-2.67 2.43-2.902Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChatBubbleBottomCenterText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2c-2.236 0-4.43.18-6.57.524C1.993 2.755 1 4.014 1 5.426v5.148c0 1.413.993 2.67 2.43 2.902 1.168.188 2.352.327 3.55.414.28.02.521.18.642.413l1.713 3.293a.75.75 0 0 0 1.33 0l1.713-3.293a.783.783 0 0 1 .642-.413 41.102 41.102 0 0 0 3.55-.414c1.437-.231 2.43-1.49 2.43-2.902V5.426c0-1.413-.993-2.67-2.43-2.902A41.289 41.289 0 0 0 10 2ZM6.75 6a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm0 2.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChartPie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9a1 1 0 0 1-1-1V3c0-.552.45-1.007.997-.93a7.004 7.004 0 0 1 5.933 5.933c.078.547-.378.997-.93.997h-5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.003 4.07C8.55 3.994 9 4.449 9 5v5a1 1 0 0 0 1 1h5c.552 0 1.008.45.93.997A7.001 7.001 0 0 1 2 11a7.002 7.002 0 0 1 6.003-6.93Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 2A1.5 1.5 0 0 0 14 3.5v13a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 16.5 2h-1ZM9.5 6A1.5 1.5 0 0 0 8 7.5v9A1.5 1.5 0 0 0 9.5 18h1a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 10.5 6h-1ZM3.5 10A1.5 1.5 0 0 0 2 11.5v5A1.5 1.5 0 0 0 3.5 18h1A1.5 1.5 0 0 0 6 16.5v-5A1.5 1.5 0 0 0 4.5 10h-1Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniChartBarSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.25 2A2.25 2.25 0 0 0 2 4.25v11.5A2.25 2.25 0 0 0 4.25 18h11.5A2.25 2.25 0 0 0 18 15.75V4.25A2.25 2.25 0 0 0 15.75 2H4.25ZM15 5.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5Zm-8.5 6a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5ZM8.584 9a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75Zm3.58-1.25a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0v-6.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a2 2 0 0 1 2-2h.93a2 2 0 0 0 1.664-.89l.812-1.22A2 2 0 0 1 8.07 3h3.86a2 2 0 0 1 1.664.89l.812 1.22A2 2 0 0 0 16.07 6H17a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8Zm13.5 3a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM10 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.75 2a.75.75 0 0 1 .75.75V4h7V2.75a.75.75 0 0 1 1.5 0V4h.25A2.75 2.75 0 0 1 18 6.75v8.5A2.75 2.75 0 0 1 15.25 18H4.75A2.75 2.75 0 0 1 2 15.25v-8.5A2.75 2.75 0 0 1 4.75 4H5V2.75A.75.75 0 0 1 5.75 2Zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCalendarDays(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.25 12a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75V12ZM6 13.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-.75-.75H6ZM7.25 12a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H8a.75.75 0 0 1-.75-.75V12ZM8 13.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-.75-.75H8ZM9.25 10a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H10a.75.75 0 0 1-.75-.75V10ZM10 11.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V12a.75.75 0 0 0-.75-.75H10ZM9.25 14a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H10a.75.75 0 0 1-.75-.75V14ZM12 9.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V10a.75.75 0 0 0-.75-.75H12ZM11.25 12a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H12a.75.75 0 0 1-.75-.75V12ZM12 13.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-.75-.75H12ZM13.25 10a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H14a.75.75 0 0 1-.75-.75V10ZM14 11.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V12a.75.75 0 0 0-.75-.75H14Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.75 2a.75.75 0 0 1 .75.75V4h7V2.75a.75.75 0 0 1 1.5 0V4h.25A2.75 2.75 0 0 1 18 6.75v8.5A2.75 2.75 0 0 1 15.25 18H4.75A2.75 2.75 0 0 1 2 15.25v-8.5A2.75 2.75 0 0 1 4.75 4H5V2.75A.75.75 0 0 1 5.75 2Zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCalendarDateRange(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V10a.75.75 0 0 0-.75-.75H10ZM6 13.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-.75-.75H6ZM8 13.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-.75-.75H8ZM9.25 14a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H10a.75.75 0 0 1-.75-.75V14ZM12 11.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V12a.75.75 0 0 0-.75-.75H12ZM12 13.25a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-.75-.75H12ZM13.25 12a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75H14a.75.75 0 0 1-.75-.75V12ZM11.25 10.005c0-.417.338-.755.755-.755h2a.755.755 0 1 1 0 1.51h-2a.755.755 0 0 1-.755-.755ZM6.005 11.25a.755.755 0 1 0 0 1.51h4a.755.755 0 1 0 0-1.51h-4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.75 2a.75.75 0 0 1 .75.75V4h7V2.75a.75.75 0 0 1 1.5 0V4h.25A2.75 2.75 0 0 1 18 6.75v8.5A2.75 2.75 0 0 1 15.25 18H4.75A2.75 2.75 0 0 1 2 15.25v-8.5A2.75 2.75 0 0 1 4.75 4H5V2.75A.75.75 0 0 1 5.75 2Zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 1c-1.716 0-3.408.106-5.07.31C3.806 1.45 3 2.414 3 3.517V16.75A2.25 2.25 0 0 0 5.25 19h9.5A2.25 2.25 0 0 0 17 16.75V3.517c0-1.103-.806-2.068-1.93-2.207A41.403 41.403 0 0 0 10 1ZM5.99 8.75A.75.75 0 0 1 6.74 8h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm-.75 2.916a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm1.417-5.75a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm-.75 2.916a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm1.42-5.75a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm-.75 2.916a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01ZM12.5 8.75a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm0 2.166a.75.75 0 0 1 .75.75v2.167a.75.75 0 1 1-1.5 0v-2.167a.75.75 0 0 1 .75-.75ZM6.75 4a.75.75 0 0 0-.75.75v.5c0 .414.336.75.75.75h6.5a.75.75 0 0 0 .75-.75v-.5a.75.75 0 0 0-.75-.75h-6.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniCake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.75.98-.884.883a1.25 1.25 0 1 0 1.768 0L6.75.98ZM13.25.98l-.884.883a1.25 1.25 0 1 0 1.768 0L13.25.98ZM10 .98l.884.883a1.25 1.25 0 1 1-1.768 0L10 .98ZM7.5 5.75a.75.75 0 0 0-1.5 0v.464c-1.179.304-2 1.39-2 2.622v.094c.1-.02.202-.038.306-.052A42.867 42.867 0 0 1 10 8.5c1.93 0 3.83.129 5.694.378.104.014.206.032.306.052v-.094c0-1.232-.821-2.317-2-2.622V5.75a.75.75 0 0 0-1.5 0v.318a45.645 45.645 0 0 0-1.75-.062V5.75a.75.75 0 0 0-1.5 0v.256c-.586.01-1.17.03-1.75.062V5.75ZM4.505 10.365A41.36 41.36 0 0 1 10 10c1.863 0 3.697.124 5.495.365C16.967 10.562 18 11.838 18 13.28v.693a3.72 3.72 0 0 1-1.665-.393 5.222 5.222 0 0 0-4.67 0 3.722 3.722 0 0 1-3.33 0 5.222 5.222 0 0 0-4.67 0A3.72 3.72 0 0 1 2 13.972v-.693c0-1.441 1.033-2.717 2.505-2.914ZM15.665 14.92a5.22 5.22 0 0 0 2.335.552V16.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 2 16.5v-1.028c.8 0 1.6-.184 2.335-.551a3.722 3.722 0 0 1 3.33 0c1.47.735 3.2.735 4.67 0a3.722 3.722 0 0 1 3.33 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBuildingStorefront(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.879 7.121A3 3 0 0 0 7.5 6.66a2.997 2.997 0 0 0 2.5 1.34 2.997 2.997 0 0 0 2.5-1.34 3 3 0 1 0 4.622-3.78l-.293-.293A2 2 0 0 0 15.415 2H4.585a2 2 0 0 0-1.414.586l-.292.292a3 3 0 0 0 0 4.243ZM3 9.032a4.507 4.507 0 0 0 4.5-.29A4.48 4.48 0 0 0 10 9.5a4.48 4.48 0 0 0 2.5-.758 4.507 4.507 0 0 0 4.5.29V16.5h.25a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5H3V9.032Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBuildingOffice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 16.5v-13h-.25a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5H16v13h.25a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1 0-1.5H4Zm3-11a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM11 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBuildingOffice2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 2.75A.75.75 0 0 1 1.75 2h10.5a.75.75 0 0 1 0 1.5H12v13.75a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5H2v-13h-.25A.75.75 0 0 1 1 2.75ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM8 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM8.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM14.25 6a.75.75 0 0 0-.75.75V17a1 1 0 0 0 1 1h3.75a.75.75 0 0 0 0-1.5H18v-9h.25a.75.75 0 0 0 0-1.5h-4Zm.5 3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBuildingLibrary(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.674 2.075a.75.75 0 0 1 .652 0l7.25 3.5A.75.75 0 0 1 17 6.957V16.5h.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H3V6.957a.75.75 0 0 1-.576-1.382l7.25-3.5ZM11 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7.5 9.75a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5Zm3.25 0a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5Zm3.25 0a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBugAnt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.56 1.14a.75.75 0 0 1 .177 1.045 3.989 3.989 0 0 0-.464.86c.185.17.382.329.59.473A3.993 3.993 0 0 1 10 2c1.272 0 2.405.594 3.137 1.518.208-.144.405-.302.59-.473a3.989 3.989 0 0 0-.464-.86.75.75 0 0 1 1.222-.869c.369.519.65 1.105.822 1.736a.75.75 0 0 1-.174.707 7.03 7.03 0 0 1-1.299 1.098A4 4 0 0 1 14 6c0 .52-.301.963-.723 1.187a6.961 6.961 0 0 1-1.158.486c.13.208.231.436.296.679 1.413-.174 2.779-.5 4.081-.96a19.655 19.655 0 0 0-.09-2.319.75.75 0 1 1 1.493-.146 21.239 21.239 0 0 1 .08 3.028.75.75 0 0 1-.482.667 20.873 20.873 0 0 1-5.153 1.249 2.521 2.521 0 0 1-.107.247 20.945 20.945 0 0 1 5.252 1.257.75.75 0 0 1 .482.74 20.945 20.945 0 0 1-.908 5.107.75.75 0 0 1-1.433-.444c.415-1.34.69-2.743.806-4.191-.495-.173-1-.327-1.512-.46.05.284.076.575.076.873 0 1.814-.517 3.312-1.426 4.37A4.639 4.639 0 0 1 10 19a4.639 4.639 0 0 1-3.574-1.63C5.516 16.311 5 14.813 5 13c0-.298.026-.59.076-.873-.513.133-1.017.287-1.512.46.116 1.448.39 2.85.806 4.191a.75.75 0 1 1-1.433.444 20.94 20.94 0 0 1-.908-5.107.75.75 0 0 1 .482-.74 20.838 20.838 0 0 1 5.252-1.257 2.493 2.493 0 0 1-.107-.247 20.874 20.874 0 0 1-5.153-1.249.75.75 0 0 1-.482-.667 21.342 21.342 0 0 1 .08-3.028.75.75 0 1 1 1.493.146 19.745 19.745 0 0 0-.09 2.319c1.302.46 2.668.786 4.08.96.066-.243.166-.471.297-.679a6.962 6.962 0 0 1-1.158-.486A1.348 1.348 0 0 1 6 6a4 4 0 0 1 .166-1.143 7.032 7.032 0 0 1-1.3-1.098.75.75 0 0 1-.173-.707 5.48 5.48 0 0 1 .822-1.736.75.75 0 0 1 1.046-.177Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3.75A2.75 2.75 0 0 1 8.75 1h2.5A2.75 2.75 0 0 1 14 3.75v.443c.572.055 1.14.122 1.706.2C17.053 4.582 18 5.75 18 7.07v3.469c0 1.126-.694 2.191-1.83 2.54-1.952.599-4.024.921-6.17.921s-4.219-.322-6.17-.921C2.694 12.73 2 11.665 2 10.539V7.07c0-1.321.947-2.489 2.294-2.676A41.047 41.047 0 0 1 6 4.193V3.75Zm6.5 0v.325a41.622 41.622 0 0 0-5 0V3.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25ZM10 10a1 1 0 0 0-1 1v.01a1 1 0 0 0 1 1h.01a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1H10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15.055v-.684c.126.053.255.1.39.142 2.092.642 4.313.987 6.61.987 2.297 0 4.518-.345 6.61-.987.135-.041.264-.089.39-.142v.684c0 1.347-.985 2.53-2.363 2.686a41.454 41.454 0 0 1-9.274 0C3.985 17.585 3 16.402 3 15.055Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2c-1.716 0-3.408.106-5.07.31C3.806 2.45 3 3.414 3 4.517V17.25a.75.75 0 0 0 1.075.676L10 15.082l5.925 2.844A.75.75 0 0 0 17 17.25V4.517c0-1.103-.806-2.068-1.93-2.207A41.403 41.403 0 0 0 10 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBookmarkSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.25 2A2.25 2.25 0 0 0 2 4.25v11.5A2.25 2.25 0 0 0 4.25 18h11.5A2.25 2.25 0 0 0 18 15.75V4.25A2.25 2.25 0 0 0 15.75 2H4.25ZM6 13.25V3.5h8v9.75a.75.75 0 0 1-1.064.681L10 12.576l-2.936 1.355A.75.75 0 0 1 6 13.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBookmarkSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4.517v9.301L5.433 2.252a41.44 41.44 0 0 1 9.637.058C16.194 2.45 17 3.414 17 4.517ZM3 17.25V6.182l10.654 10.654L10 15.082l-5.925 2.844A.75.75 0 0 1 3 17.25ZM3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06L3.28 2.22Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBookOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.75 16.82A7.462 7.462 0 0 1 15 15.5c.71 0 1.396.098 2.046.282A.75.75 0 0 0 18 15.06v-11a.75.75 0 0 0-.546-.721A9.006 9.006 0 0 0 15 3a8.963 8.963 0 0 0-4.25 1.065V16.82ZM9.25 4.065A8.963 8.963 0 0 0 5 3c-.85 0-1.673.118-2.454.339A.75.75 0 0 0 2 4.06v11a.75.75 0 0 0 .954.721A7.506 7.506 0 0 1 5 15.5c1.579 0 3.042.487 4.25 1.32V4.065Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.983 1.907a.75.75 0 0 0-1.292-.657l-8.5 9.5A.75.75 0 0 0 2.75 12h6.572l-1.305 6.093a.75.75 0 0 0 1.292.657l8.5-9.5A.75.75 0 0 0 17.25 8h-6.572l1.305-6.093Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBoltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.22 2.22a.75.75 0 0 1 1.06 0l14.5 14.5a.75.75 0 1 1-1.06 1.06L2.22 3.28a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.73 7.912 2.191 10.75A.75.75 0 0 0 2.75 12h6.068L4.73 7.912ZM9.233 12.415l-1.216 5.678a.75.75 0 0 0 1.292.657l2.956-3.303-3.032-3.032ZM15.27 12.088l2.539-2.838A.75.75 0 0 0 17.25 8h-6.068l4.088 4.088ZM10.767 7.585l1.216-5.678a.75.75 0 0 0-1.292-.657L7.735 4.553l3.032 3.032Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBold(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 3a1 1 0 0 1 1-1h6a4.5 4.5 0 0 1 3.274 7.587A4.75 4.75 0 0 1 11.25 18H5a1 1 0 0 1-1-1V3Zm2.5 5.5v-4H11a2 2 0 1 1 0 4H6.5Zm0 2.5v4.5h4.75a2.25 2.25 0 0 0 0-4.5H6.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a6 6 0 0 0-6 6c0 1.887-.454 3.665-1.257 5.234a.75.75 0 0 0 .515 1.076 32.91 32.91 0 0 0 3.256.508 3.5 3.5 0 0 0 6.972 0 32.903 32.903 0 0 0 3.256-.508.75.75 0 0 0 .515-1.076A11.448 11.448 0 0 1 16 8a6 6 0 0 0-6-6ZM8.05 14.943a33.54 33.54 0 0 0 3.9 0 2 2 0 0 1-3.9 0Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBellSnooze(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 8a6 6 0 1 1 12 0c0 1.887.454 3.665 1.257 5.234a.75.75 0 0 1-.515 1.076 32.903 32.903 0 0 1-3.256.508 3.5 3.5 0 0 1-6.972 0 32.91 32.91 0 0 1-3.256-.508.75.75 0 0 1-.515-1.076A11.448 11.448 0 0 0 4 8Zm6 7c-.655 0-1.305-.02-1.95-.057a2 2 0 0 0 3.9 0c-.645.038-1.295.057-1.95.057ZM8.75 6a.75.75 0 0 0 0 1.5h1.043L8.14 9.814A.75.75 0 0 0 8.75 11h2.5a.75.75 0 0 0 0-1.5h-1.043l1.653-2.314A.75.75 0 0 0 11.25 6h-2.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBellSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8c0-.26.017-.517.049-.77l7.722 7.723a33.56 33.56 0 0 1-3.722-.01 2 2 0 0 0 3.862.15l1.134 1.134a3.5 3.5 0 0 1-6.53-1.409 32.91 32.91 0 0 1-3.257-.508.75.75 0 0 1-.515-1.076A11.448 11.448 0 0 0 4 8ZM17.266 13.9a.756.756 0 0 1-.068.116L6.389 3.207A6 6 0 0 1 16 8c.001 1.887.455 3.665 1.258 5.234a.75.75 0 0 1 .01.666ZM3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06L3.28 2.22Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBellAlert(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.214 3.227a.75.75 0 0 0-1.156-.955 8.97 8.97 0 0 0-1.856 3.825.75.75 0 0 0 1.466.316 7.47 7.47 0 0 1 1.546-3.186ZM16.942 2.272a.75.75 0 0 0-1.157.955 7.47 7.47 0 0 1 1.547 3.186.75.75 0 0 0 1.466-.316 8.971 8.971 0 0 0-1.856-3.825Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a6 6 0 0 0-6 6c0 1.887-.454 3.665-1.257 5.234a.75.75 0 0 0 .515 1.076 32.91 32.91 0 0 0 3.256.508 3.5 3.5 0 0 0 6.972 0 32.903 32.903 0 0 0 3.256-.508.75.75 0 0 0 .515-1.076A11.448 11.448 0 0 1 16 8a6 6 0 0 0-6-6Zm0 14.5a2 2 0 0 1-1.95-1.557 33.54 33.54 0 0 0 3.9 0A2 2 0 0 1 10 16.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBeaker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.5 3.528v4.644c0 .729-.29 1.428-.805 1.944l-1.217 1.216a8.75 8.75 0 0 1 3.55.621l.502.201a7.25 7.25 0 0 0 4.178.365l-2.403-2.403a2.75 2.75 0 0 1-.805-1.944V3.528a40.205 40.205 0 0 0-3 0Zm4.5.084.19.015a.75.75 0 1 0 .12-1.495 41.364 41.364 0 0 0-6.62 0 .75.75 0 0 0 .12 1.495L7 3.612v4.56c0 .331-.132.649-.366.883L2.6 13.09c-1.496 1.496-.817 4.15 1.403 4.475C5.961 17.852 7.963 18 10 18s4.039-.148 5.997-.436c2.22-.325 2.9-2.979 1.403-4.475l-4.034-4.034A1.25 1.25 0 0 1 13 8.172v-4.56Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBattery50(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.75 8a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75H9.5a.75.75 0 0 0 .75-.75v-2.5A.75.75 0 0 0 9.5 8H4.75Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.25 5A2.25 2.25 0 0 0 1 7.25v5.5A2.25 2.25 0 0 0 3.25 15h12.5A2.25 2.25 0 0 0 18 12.75v-1.085a1.5 1.5 0 0 0 1-1.415v-.5a1.5 1.5 0 0 0-1-1.415V7.25A2.25 2.25 0 0 0 15.75 5H3.25ZM2.5 7.25a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-.75.75H3.25a.75.75 0 0 1-.75-.75v-5.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBattery100(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.75 8a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75h9.5a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-9.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 7.25A2.25 2.25 0 0 1 3.25 5h12.5A2.25 2.25 0 0 1 18 7.25v1.085a1.5 1.5 0 0 1 1 1.415v.5a1.5 1.5 0 0 1-1 1.415v1.085A2.25 2.25 0 0 1 15.75 15H3.25A2.25 2.25 0 0 1 1 12.75v-5.5Zm2.25-.75a.75.75 0 0 0-.75.75v5.5c0 .414.336.75.75.75h12.5a.75.75 0 0 0 .75-.75v-5.5a.75.75 0 0 0-.75-.75H3.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBattery0(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 7.25A2.25 2.25 0 0 1 3.25 5h12.5A2.25 2.25 0 0 1 18 7.25v1.085a1.5 1.5 0 0 1 1 1.415v.5a1.5 1.5 0 0 1-1 1.415v1.085A2.25 2.25 0 0 1 15.75 15H3.25A2.25 2.25 0 0 1 1 12.75v-5.5Zm2.25-.75a.75.75 0 0 0-.75.75v5.5c0 .414.336.75.75.75h12.5a.75.75 0 0 0 .75-.75v-5.5a.75.75 0 0 0-.75-.75H3.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBarsArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 3.75A.75.75 0 0 1 2.75 3h11.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75ZM2 7.5a.75.75 0 0 1 .75-.75h6.365a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 7.5ZM14 7a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02l-1.95-2.1v6.59a.75.75 0 0 1-1.5 0V9.66l-1.95 2.1a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 14 7ZM2 11.25a.75.75 0 0 1 .75-.75H7A.75.75 0 0 1 7 12H2.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBarsArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 3.75A.75.75 0 0 1 2.75 3h11.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75ZM2 7.5a.75.75 0 0 1 .75-.75h7.508a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 7.5ZM14 7a.75.75 0 0 1 .75.75v6.59l1.95-2.1a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0l-3.25-3.5a.75.75 0 1 1 1.1-1.02l1.95 2.1V7.75A.75.75 0 0 1 14 7ZM2 11.25a.75.75 0 0 1 .75-.75h4.562a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBars4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 3.75A.75.75 0 0 1 2.75 3h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75Zm0 4.167a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Zm0 4.166a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Zm0 4.167a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBars3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Zm0 5.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBars3CenterLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75Zm0 10.5a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75ZM2 10a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 2 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBars3BottomRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75Zm7 10.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBars3BottomLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75Zm0 10.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBars2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 6.75A.75.75 0 0 1 2.75 6h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 6.75Zm0 6.5a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBanknotes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4Zm12 4a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM4 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm13-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM1.75 14.5a.75.75 0 0 0 0 1.5c4.417 0 8.693.603 12.749 1.73 1.111.309 2.251-.512 2.251-1.696v-.784a.75.75 0 0 0-1.5 0v.784a.272.272 0 0 1-.35.25A49.043 49.043 0 0 0 1.75 14.5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.712 4.818A1.5 1.5 0 0 1 10 6.095v2.972c.104-.13.234-.248.389-.343l6.323-3.906A1.5 1.5 0 0 1 19 6.095v7.81a1.5 1.5 0 0 1-2.288 1.276l-6.323-3.905a1.505 1.505 0 0 1-.389-.344v2.973a1.5 1.5 0 0 1-2.288 1.276l-6.323-3.905a1.5 1.5 0 0 1 0-2.552l6.323-3.906Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniBackspace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.22 3.22A.75.75 0 0 1 7.75 3h9A2.25 2.25 0 0 1 19 5.25v9.5A2.25 2.25 0 0 1 16.75 17h-9a.75.75 0 0 1-.53-.22L.97 10.53a.75.75 0 0 1 0-1.06l6.25-6.25Zm3.06 4a.75.75 0 1 0-1.06 1.06L10.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L12 8.94l-1.72-1.72Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniAtSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.404 14.596A6.5 6.5 0 1 1 16.5 10a1.25 1.25 0 0 1-2.5 0 4 4 0 1 0-.571 2.06A2.75 2.75 0 0 0 18 10a8 8 0 1 0-2.343 5.657.75.75 0 0 0-1.06-1.06 6.5 6.5 0 0 1-9.193 0ZM10 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowsUpDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.24 6.8a.75.75 0 0 0 1.06-.04l1.95-2.1v8.59a.75.75 0 0 0 1.5 0V4.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0L2.2 5.74a.75.75 0 0 0 .04 1.06Zm8 6.4a.75.75 0 0 0-.04 1.06l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 1 0-1.1-1.02l-1.95 2.1V6.75a.75.75 0 0 0-1.5 0v8.59l-1.95-2.1a.75.75 0 0 0-1.06-.04Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowsRightLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.2 2.24a.75.75 0 0 0 .04 1.06l2.1 1.95H6.75a.75.75 0 0 0 0 1.5h8.59l-2.1 1.95a.75.75 0 1 0 1.02 1.1l3.5-3.25a.75.75 0 0 0 0-1.1l-3.5-3.25a.75.75 0 0 0-1.06.04Zm-6.4 8a.75.75 0 0 0-1.06-.04l-3.5 3.25a.75.75 0 0 0 0 1.1l3.5 3.25a.75.75 0 1 0 1.02-1.1l-2.1-1.95h8.59a.75.75 0 0 0 0-1.5H4.66l2.1-1.95a.75.75 0 0 0 .04-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowsPointingOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.28 7.78 3.22-3.22v2.69a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h2.69l-3.22 3.22a.75.75 0 0 0 1.06 1.06ZM2 17.25v-4.5a.75.75 0 0 1 1.5 0v2.69l3.22-3.22a.75.75 0 0 1 1.06 1.06L4.56 16.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.747.747 0 0 1-.75-.75ZM12.22 13.28l3.22 3.22h-2.69a.75.75 0 0 0 0 1.5h4.5a.747.747 0 0 0 .75-.75v-4.5a.75.75 0 0 0-1.5 0v2.69l-3.22-3.22a.75.75 0 1 0-1.06 1.06ZM3.5 4.56l3.22 3.22a.75.75 0 0 0 1.06-1.06L4.56 3.5h2.69a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0V4.56Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowsPointingIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.28 2.22a.75.75 0 0 0-1.06 1.06L5.44 6.5H2.75a.75.75 0 0 0 0 1.5h4.5A.75.75 0 0 0 8 7.25v-4.5a.75.75 0 0 0-1.5 0v2.69L3.28 2.22ZM13.5 2.75a.75.75 0 0 0-1.5 0v4.5c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-2.69l3.22-3.22a.75.75 0 0 0-1.06-1.06L13.5 5.44V2.75ZM3.28 17.78l3.22-3.22v2.69a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h2.69l-3.22 3.22a.75.75 0 1 0 1.06 1.06ZM13.5 14.56l3.22 3.22a.75.75 0 1 0 1.06-1.06l-3.22-3.22h2.69a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-2.69Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUturnUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.768 7.793a.75.75 0 0 1-1.06-.025L12.75 3.622v10.003a5.375 5.375 0 0 1-10.75 0V10.75a.75.75 0 0 1 1.5 0v2.875a3.875 3.875 0 0 0 7.75 0V3.622L7.293 7.768a.75.75 0 0 1-1.086-1.036l5.25-5.5a.75.75 0 0 1 1.085 0l5.25 5.5a.75.75 0 0 1-.024 1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUturnRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.207 2.232a.75.75 0 0 0 .025 1.06l4.146 3.958H6.375a5.375 5.375 0 0 0 0 10.75H9.25a.75.75 0 0 0 0-1.5H6.375a3.875 3.875 0 0 1 0-7.75h10.003l-4.146 3.957a.75.75 0 0 0 1.036 1.085l5.5-5.25a.75.75 0 0 0 0-1.085l-5.5-5.25a.75.75 0 0 0-1.06.025Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUturnLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.793 2.232a.75.75 0 0 1-.025 1.06L3.622 7.25h10.003a5.375 5.375 0 0 1 0 10.75H10.75a.75.75 0 0 1 0-1.5h2.875a3.875 3.875 0 0 0 0-7.75H3.622l4.146 3.957a.75.75 0 0 1-1.036 1.085l-5.5-5.25a.75.75 0 0 1 0-1.085l5.5-5.25a.75.75 0 0 1 1.06.025Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUturnDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.232 12.207a.75.75 0 0 1 1.06.025l3.958 4.146V6.375a5.375 5.375 0 0 1 10.75 0V9.25a.75.75 0 0 1-1.5 0V6.375a3.875 3.875 0 0 0-7.75 0v10.003l3.957-4.146a.75.75 0 0 1 1.085 1.036l-5.25 5.5a.75.75 0 0 1-1.085 0l-5.25-5.5a.75.75 0 0 1 .025-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 17a.75.75 0 0 1-.75-.75V5.612L5.29 9.77a.75.75 0 0 1-1.08-1.04l5.25-5.5a.75.75 0 0 1 1.08 0l5.25 5.5a.75.75 0 1 1-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0 1 10 17Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUpTray(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.25 13.25a.75.75 0 0 0 1.5 0V4.636l2.955 3.129a.75.75 0 0 0 1.09-1.03l-4.25-4.5a.75.75 0 0 0-1.09 0l-4.25 4.5a.75.75 0 1 0 1.09 1.03L9.25 4.636v8.614Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.22 14.78a.75.75 0 0 0 1.06 0l7.22-7.22v5.69a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0 0 1.5h5.69l-7.22 7.22a.75.75 0 0 0 0 1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUpOnSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.75 7h-3V3.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0L6.2 4.74a.75.75 0 0 0 1.1 1.02l1.95-2.1V7h-3A2.25 2.25 0 0 0 4 9.25v7.5A2.25 2.25 0 0 0 6.25 19h7.5A2.25 2.25 0 0 0 16 16.75v-7.5A2.25 2.25 0 0 0 13.75 7Zm-3 0h-1.5v5.25a.75.75 0 0 0 1.5 0V7Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUpOnSquareStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.75 6h-2v4.25a.75.75 0 0 1-1.5 0V6h1.5V3.704l.943 1.048a.75.75 0 0 0 1.114-1.004l-2.25-2.5a.75.75 0 0 0-1.114 0l-2.25 2.5a.75.75 0 0 0 1.114 1.004l.943-1.048V6h-2A2.25 2.25 0 0 0 3 8.25v4.5A2.25 2.25 0 0 0 5.25 15h5.5A2.25 2.25 0 0 0 13 12.75v-4.5A2.25 2.25 0 0 0 10.75 6ZM7 16.75v-.25h3.75a3.75 3.75 0 0 0 3.75-3.75V10h.25A2.25 2.25 0 0 1 17 12.25v4.5A2.25 2.25 0 0 1 14.75 19h-5.5A2.25 2.25 0 0 1 7 16.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUpLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.78 14.78a.75.75 0 0 1-1.06 0L6.5 7.56v5.69a.75.75 0 0 1-1.5 0v-7.5A.75.75 0 0 1 5.75 5h7.5a.75.75 0 0 1 0 1.5H7.56l7.22 7.22a.75.75 0 0 1 0 1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowUpCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-.75-4.75a.75.75 0 0 0 1.5 0V8.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0L6.2 9.74a.75.75 0 1 0 1.1 1.02l1.95-2.1v4.59Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTurnUpRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 17a.75.75 0 0 0 .75-.75v-7.5h10.94l-1.97 1.97a.75.75 0 1 0 1.06 1.06l3.25-3.25a.75.75 0 0 0 0-1.06l-3.25-3.25a.75.75 0 1 0-1.06 1.06l1.97 1.97H3.75A.75.75 0 0 0 3 8v8.25c0 .414.336.75.75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTurnUpLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.25 17a.75.75 0 0 1-.75-.75v-7.5H4.56l1.97 1.97a.75.75 0 1 1-1.06 1.06L2.22 8.53a.75.75 0 0 1 0-1.06l3.25-3.25a.75.75 0 0 1 1.06 1.06L4.56 7.25h11.69A.75.75 0 0 1 17 8v8.25a.75.75 0 0 1-.75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTurnRightUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 16.25a.75.75 0 0 1 .75-.75h7.5V4.56L9.28 6.53a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1-1.06 1.06l-1.97-1.97v11.69A.75.75 0 0 1 12 17H3.75a.75.75 0 0 1-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTurnRightDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 3.75c0 .414.336.75.75.75h7.5v10.94l-1.97-1.97a.75.75 0 0 0-1.06 1.06l3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06l-1.97 1.97V3.75A.75.75 0 0 0 12 3H3.75a.75.75 0 0 0-.75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTurnLeftUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 16.25a.75.75 0 0 0-.75-.75h-7.5V4.56l1.97 1.97a.75.75 0 1 0 1.06-1.06L7.53 2.22a.75.75 0 0 0-1.06 0L3.22 5.47a.75.75 0 0 0 1.06 1.06l1.97-1.97v11.69c0 .414.336.75.75.75h8.25a.75.75 0 0 0 .75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTurnLeftDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 3.75a.75.75 0 0 1-.75.75h-7.5v10.94l1.97-1.97a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06l1.97 1.97V3.75A.75.75 0 0 1 7 3h8.25a.75.75 0 0 1 .75.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTurnDownRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.75 3a.75.75 0 0 1 .75.75v7.5h10.94l-1.97-1.97a.75.75 0 0 1 1.06-1.06l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 1 1-1.06-1.06l1.97-1.97H3.75A.75.75 0 0 1 3 12V3.75A.75.75 0 0 1 3.75 3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTurnDownLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.25 3a.75.75 0 0 0-.75.75v7.5H4.56l1.97-1.97a.75.75 0 0 0-1.06-1.06l-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25a.75.75 0 0 0 1.06-1.06l-1.97-1.97h11.69A.75.75 0 0 0 17 12V3.75a.75.75 0 0 0-.75-.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTrendingUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.577 4.878a.75.75 0 0 1 .919-.53l4.78 1.281a.75.75 0 0 1 .531.919l-1.281 4.78a.75.75 0 0 1-1.449-.387l.81-3.022a19.407 19.407 0 0 0-5.594 5.203.75.75 0 0 1-1.139.093L7 10.06l-4.72 4.72a.75.75 0 0 1-1.06-1.061l5.25-5.25a.75.75 0 0 1 1.06 0l3.074 3.073a20.923 20.923 0 0 1 5.545-4.931l-3.042-.815a.75.75 0 0 1-.53-.919Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTrendingDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.22 5.222a.75.75 0 0 1 1.06 0L7 9.942l3.768-3.769a.75.75 0 0 1 1.113.058 20.908 20.908 0 0 1 3.813 7.254l1.574-2.727a.75.75 0 0 1 1.3.75l-2.475 4.286a.75.75 0 0 1-1.025.275l-4.287-2.475a.75.75 0 0 1 .75-1.3l2.71 1.565a19.422 19.422 0 0 0-3.013-6.024L7.53 11.533a.75.75 0 0 1-1.06 0l-5.25-5.25a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowTopRightOnSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.25 5.5a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 1 1.5 0v4A2.25 2.25 0 0 1 12.75 17h-8.5A2.25 2.25 0 0 1 2 14.75v-8.5A2.25 2.25 0 0 1 4.25 4h5a.75.75 0 0 1 0 1.5h-5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.194 12.753a.75.75 0 0 0 1.06.053L16.5 4.44v2.81a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h2.553l-9.056 8.194a.75.75 0 0 0-.053 1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowSmallUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 15a.75.75 0 0 1-.75-.75V7.612L7.29 9.77a.75.75 0 0 1-1.08-1.04l3.25-3.5a.75.75 0 0 1 1.08 0l3.25 3.5a.75.75 0 1 1-1.08 1.04l-1.96-2.158v6.638A.75.75 0 0 1 10 15Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowSmallRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 10a.75.75 0 0 1 .75-.75h6.638L10.23 7.29a.75.75 0 1 1 1.04-1.08l3.5 3.25a.75.75 0 0 1 0 1.08l-3.5 3.25a.75.75 0 1 1-1.04-1.08l2.158-1.96H5.75A.75.75 0 0 1 5 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowSmallLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 10a.75.75 0 0 1-.75.75H7.612l2.158 1.96a.75.75 0 1 1-1.04 1.08l-3.5-3.25a.75.75 0 0 1 0-1.08l3.5-3.25a.75.75 0 1 1 1.04 1.08L7.612 9.25h6.638A.75.75 0 0 1 15 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowSmallDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 5a.75.75 0 0 1 .75.75v6.638l1.96-2.158a.75.75 0 1 1 1.08 1.04l-3.25 3.5a.75.75 0 0 1-1.08 0l-3.25-3.5a.75.75 0 1 1 1.08-1.04l1.96 2.158V5.75A.75.75 0 0 1 10 5Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 10a.75.75 0 0 1 .75-.75h10.638L10.23 5.29a.75.75 0 1 1 1.04-1.08l5.5 5.25a.75.75 0 0 1 0 1.08l-5.5 5.25a.75.75 0 1 1-1.04-1.08l4.158-3.96H3.75A.75.75 0 0 1 3 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowRightStartOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4.25A2.25 2.25 0 0 1 5.25 2h5.5A2.25 2.25 0 0 1 13 4.25v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 1 1.5 0v2A2.25 2.25 0 0 1 10.75 18h-5.5A2.25 2.25 0 0 1 3 15.75V4.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 10a.75.75 0 0 1 .75-.75h9.546l-1.048-.943a.75.75 0 1 1 1.004-1.114l2.5 2.25a.75.75 0 0 1 0 1.114l-2.5 2.25a.75.75 0 1 1-1.004-1.114l1.048-.943H6.75A.75.75 0 0 1 6 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowRightOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4.25A2.25 2.25 0 0 1 5.25 2h5.5A2.25 2.25 0 0 1 13 4.25v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 1 1.5 0v2A2.25 2.25 0 0 1 10.75 18h-5.5A2.25 2.25 0 0 1 3 15.75V4.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 10a.75.75 0 0 1 .75-.75h9.546l-1.048-.943a.75.75 0 1 1 1.004-1.114l2.5 2.25a.75.75 0 0 1 0 1.114l-2.5 2.25a.75.75 0 1 1-1.004-1.114l1.048-.943H6.75A.75.75 0 0 1 6 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowRightEndOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17 4.25A2.25 2.25 0 0 0 14.75 2h-5.5A2.25 2.25 0 0 0 7 4.25v2a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v11.5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 0-1.5 0v2A2.25 2.25 0 0 0 9.25 18h5.5A2.25 2.25 0 0 0 17 15.75V4.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 10a.75.75 0 0 1 .75-.75h9.546l-1.048-.943a.75.75 0 1 1 1.004-1.114l2.5 2.25a.75.75 0 0 1 0 1.114l-2.5 2.25a.75.75 0 1 1-1.004-1.114l1.048-.943H1.75A.75.75 0 0 1 1 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowRightCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM6.75 9.25a.75.75 0 0 0 0 1.5h4.59l-2.1 1.95a.75.75 0 0 0 1.02 1.1l3.5-3.25a.75.75 0 0 0 0-1.1l-3.5-3.25a.75.75 0 1 0-1.02 1.1l2.1 1.95H6.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowPath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.312 11.424a5.5 5.5 0 0 1-9.201 2.466l-.312-.311h2.433a.75.75 0 0 0 0-1.5H3.989a.75.75 0 0 0-.75.75v4.242a.75.75 0 0 0 1.5 0v-2.43l.31.31a7 7 0 0 0 11.712-3.138.75.75 0 0 0-1.449-.39Zm1.23-3.723a.75.75 0 0 0 .219-.53V2.929a.75.75 0 0 0-1.5 0V5.36l-.31-.31A7 7 0 0 0 3.239 8.188a.75.75 0 1 0 1.448.389A5.5 5.5 0 0 1 13.89 6.11l.311.31h-2.432a.75.75 0 0 0 0 1.5h4.243a.75.75 0 0 0 .53-.219Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowPathRoundedSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 4.5c1.215 0 2.417.055 3.604.162a.68.68 0 0 1 .615.597c.124 1.038.208 2.088.25 3.15l-1.689-1.69a.75.75 0 0 0-1.06 1.061l2.999 3a.75.75 0 0 0 1.06 0l3.001-3a.75.75 0 1 0-1.06-1.06l-1.748 1.747a41.31 41.31 0 0 0-.264-3.386 2.18 2.18 0 0 0-1.97-1.913 41.512 41.512 0 0 0-7.477 0 2.18 2.18 0 0 0-1.969 1.913 41.16 41.16 0 0 0-.16 1.61.75.75 0 1 0 1.495.12c.041-.52.093-1.038.154-1.552a.68.68 0 0 1 .615-.597A40.012 40.012 0 0 1 10 4.5ZM5.281 9.22a.75.75 0 0 0-1.06 0l-3.001 3a.75.75 0 1 0 1.06 1.06l1.748-1.747c.042 1.141.13 2.27.264 3.386a2.18 2.18 0 0 0 1.97 1.913 41.533 41.533 0 0 0 7.477 0 2.18 2.18 0 0 0 1.969-1.913c.064-.534.117-1.071.16-1.61a.75.75 0 1 0-1.495-.12c-.041.52-.093 1.037-.154 1.552a.68.68 0 0 1-.615.597 40.013 40.013 0 0 1-7.208 0 .68.68 0 0 1-.615-.597 39.785 39.785 0 0 1-.25-3.15l1.689 1.69a.75.75 0 0 0 1.06-1.061l-2.999-3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowLongUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a.75.75 0 0 1-.75-.75V4.66L7.3 6.76a.75.75 0 0 1-1.1-1.02l3.25-3.5a.75.75 0 0 1 1.1 0l3.25 3.5a.75.75 0 1 1-1.1 1.02l-1.95-2.1v12.59A.75.75 0 0 1 10 18Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowLongRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 10a.75.75 0 0 1 .75-.75h12.59l-2.1-1.95a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.1-1.95H2.75A.75.75 0 0 1 2 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowLongLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 10a.75.75 0 0 1-.75.75H4.66l2.1 1.95a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 1 1 1.02 1.1l-2.1 1.95h12.59A.75.75 0 0 1 18 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowLongDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 2a.75.75 0 0 1 .75.75v12.59l1.95-2.1a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0l-3.25-3.5a.75.75 0 1 1 1.1-1.02l1.95 2.1V2.75A.75.75 0 0 1 10 2Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17 10a.75.75 0 0 1-.75.75H5.612l4.158 3.96a.75.75 0 1 1-1.04 1.08l-5.5-5.25a.75.75 0 0 1 0-1.08l5.5-5.25a.75.75 0 1 1 1.04 1.08L5.612 9.25H16.25A.75.75 0 0 1 17 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowLeftStartOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17 4.25A2.25 2.25 0 0 0 14.75 2h-5.5A2.25 2.25 0 0 0 7 4.25v2a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v11.5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 0-1.5 0v2A2.25 2.25 0 0 0 9.25 18h5.5A2.25 2.25 0 0 0 17 15.75V4.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 10a.75.75 0 0 0-.75-.75H3.704l1.048-.943a.75.75 0 1 0-1.004-1.114l-2.5 2.25a.75.75 0 0 0 0 1.114l2.5 2.25a.75.75 0 1 0 1.004-1.114l-1.048-.943h9.546A.75.75 0 0 0 14 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowLeftOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4.25A2.25 2.25 0 0 1 5.25 2h5.5A2.25 2.25 0 0 1 13 4.25v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 1 1.5 0v2A2.25 2.25 0 0 1 10.75 18h-5.5A2.25 2.25 0 0 1 3 15.75V4.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19 10a.75.75 0 0 0-.75-.75H8.704l1.048-.943a.75.75 0 1 0-1.004-1.114l-2.5 2.25a.75.75 0 0 0 0 1.114l2.5 2.25a.75.75 0 1 0 1.004-1.114l-1.048-.943h9.546A.75.75 0 0 0 19 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowLeftEndOnRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 4.25A2.25 2.25 0 0 1 5.25 2h5.5A2.25 2.25 0 0 1 13 4.25v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 1 1.5 0v2A2.25 2.25 0 0 1 10.75 18h-5.5A2.25 2.25 0 0 1 3 15.75V4.25Z",
                    "clipRule": "evenodd"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19 10a.75.75 0 0 0-.75-.75H8.704l1.048-.943a.75.75 0 1 0-1.004-1.114l-2.5 2.25a.75.75 0 0 0 0 1.114l2.5 2.25a.75.75 0 1 0 1.004-1.114l-1.048-.943h9.546A.75.75 0 0 0 19 10Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowLeftCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.25-7.25a.75.75 0 0 0 0-1.5H8.66l2.1-1.95a.75.75 0 1 0-1.02-1.1l-3.5 3.25a.75.75 0 0 0 0 1.1l3.5 3.25a.75.75 0 0 0 1.02-1.1l-2.1-1.95h4.59Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 3a.75.75 0 0 1 .75.75v10.638l3.96-4.158a.75.75 0 1 1 1.08 1.04l-5.25 5.5a.75.75 0 0 1-1.08 0l-5.25-5.5a.75.75 0 1 1 1.08-1.04l3.96 4.158V3.75A.75.75 0 0 1 10 3Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowDownTray(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowDownRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.28 5.22a.75.75 0 0 0-1.06 1.06l7.22 7.22H6.75a.75.75 0 0 0 0 1.5h7.5a.747.747 0 0 0 .75-.75v-7.5a.75.75 0 0 0-1.5 0v5.69L6.28 5.22Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowDownOnSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.75 7h-3v5.296l1.943-2.048a.75.75 0 0 1 1.114 1.004l-3.25 3.5a.75.75 0 0 1-1.114 0l-3.25-3.5a.75.75 0 1 1 1.114-1.004l1.943 2.048V7h1.5V1.75a.75.75 0 0 0-1.5 0V7h-3A2.25 2.25 0 0 0 4 9.25v7.5A2.25 2.25 0 0 0 6.25 19h7.5A2.25 2.25 0 0 0 16 16.75v-7.5A2.25 2.25 0 0 0 13.75 7Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowDownOnSquareStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 1a.75.75 0 0 1 .75.75V6h-1.5V1.75A.75.75 0 0 1 8 1Zm-.75 5v3.296l-.943-1.048a.75.75 0 1 0-1.114 1.004l2.25 2.5a.75.75 0 0 0 1.114 0l2.25-2.5a.75.75 0 0 0-1.114-1.004L8.75 9.296V6h2A2.25 2.25 0 0 1 13 8.25v4.5A2.25 2.25 0 0 1 10.75 15h-5.5A2.25 2.25 0 0 1 3 12.75v-4.5A2.25 2.25 0 0 1 5.25 6h2ZM7 16.75v-.25h3.75a3.75 3.75 0 0 0 3.75-3.75V10h.25A2.25 2.25 0 0 1 17 12.25v4.5A2.25 2.25 0 0 1 14.75 19h-5.5A2.25 2.25 0 0 1 7 16.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowDownLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.78 5.22a.75.75 0 0 0-1.06 0L6.5 12.44V6.75a.75.75 0 0 0-1.5 0v7.5c0 .414.336.75.75.75h7.5a.75.75 0 0 0 0-1.5H7.56l7.22-7.22a.75.75 0 0 0 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArrowDownCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-11.25a.75.75 0 0 0-1.5 0v4.59L7.3 9.24a.75.75 0 0 0-1.1 1.02l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 1 0-1.1-1.02l-1.95 2.1V6.75Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArchiveBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 7.5h16l-.811 7.71a2 2 0 0 1-1.99 1.79H4.802a2 2 0 0 1-1.99-1.79L2 7.5ZM7 11a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArchiveBoxXMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 7.5h16l-.811 7.71a2 2 0 0 1-1.99 1.79H4.802a2 2 0 0 1-1.99-1.79L2 7.5Zm5.22 1.72a.75.75 0 0 1 1.06 0L10 10.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L11.06 12l1.72 1.72a.75.75 0 1 1-1.06 1.06L10 13.06l-1.72 1.72a.75.75 0 0 1-1.06-1.06L8.94 12l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniArchiveBoxArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2Zm0 4.5h16l-.811 7.71a2 2 0 0 1-1.99 1.79H4.802a2 2 0 0 1-1.99-1.79L2 7.5ZM10 9a.75.75 0 0 1 .75.75v2.546l.943-1.048a.75.75 0 1 1 1.114 1.004l-2.25 2.5a.75.75 0 0 1-1.114 0l-2.25-2.5a.75.75 0 1 1 1.114-1.004l.943 1.048V9.75A.75.75 0 0 1 10 9Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniAdjustmentsVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2.75a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5ZM17 15.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5ZM3.75 15a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75ZM4.5 2.75a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5ZM10 11a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 10 11ZM10.75 2.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5ZM10 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM3.75 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM16.25 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniAdjustmentsHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3.75a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM17.25 4.5a.75.75 0 0 0 0-1.5h-5.5a.75.75 0 0 0 0 1.5h5.5ZM5 3.75a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 .75.75ZM4.25 17a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5h1.5ZM17.25 17a.75.75 0 0 0 0-1.5h-5.5a.75.75 0 0 0 0 1.5h5.5ZM9 10a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1 0-1.5h5.5A.75.75 0 0 1 9 10ZM17.25 10.75a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5h1.5ZM14 10a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM10 16.25a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function HiMiniAcademicCap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor",
            "aria-hidden": "true"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.664 1.319a.75.75 0 0 1 .672 0 41.059 41.059 0 0 1 8.198 5.424.75.75 0 0 1-.254 1.285 31.372 31.372 0 0 0-7.86 3.83.75.75 0 0 1-.84 0 31.508 31.508 0 0 0-2.08-1.287V9.394c0-.244.116-.463.302-.592a35.504 35.504 0 0 1 3.305-2.033.75.75 0 0 0-.714-1.319 37 37 0 0 0-3.446 2.12A2.216 2.216 0 0 0 6 9.393v.38a31.293 31.293 0 0 0-4.28-1.746.75.75 0 0 1-.254-1.285 41.059 41.059 0 0 1 8.198-5.424ZM6 11.459a29.848 29.848 0 0 0-2.455-1.158 41.029 41.029 0 0 0-.39 3.114.75.75 0 0 0 .419.74c.528.256 1.046.53 1.554.82-.21.324-.455.63-.739.914a.75.75 0 1 0 1.06 1.06c.37-.369.69-.77.96-1.193a26.61 26.61 0 0 1 3.095 2.348.75.75 0 0 0 .992 0 26.547 26.547 0 0 1 5.93-3.95.75.75 0 0 0 .42-.739 41.053 41.053 0 0 0-.39-3.114 29.925 29.925 0 0 0-5.199 2.801 2.25 2.25 0 0 1-2.514 0c-.41-.275-.826-.541-1.25-.797a6.985 6.985 0 0 1-1.084 3.45 26.503 26.503 0 0 0-1.281-.78A5.487 5.487 0 0 0 6 12v-.54Z",
                    "clipRule": "evenodd"
                },
                "child": []
            }
        ]
    })(props);
}

},{"../lib/index.mjs":"c1xBV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"foB3b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the epoch-seconds timestamps the platform sends (e.g. 1788251565.880518669).
 * Mirrors the transaction-history formatting so dates read the same across the app.
 */ parcelHelpers.export(exports, "formatEpochDateTime", ()=>formatEpochDateTime);
/**
 * Derives the post-exchange state from a next-step / GET /application response.
 *
 * `process_application` and `previous_applications` both arrive as arrays — one entry per
 * exchange the customer has been through. The leading `process_application` entry is the
 * request the screens talk about, and every `previous_applications` entry gets its own card.
 *
 * The presence of a previous application is the only signal that matters: whenever the
 * platform sends one, that application stays funded and active until this new one is funded.
 * The exchange trigger status and any provider error are deliberately ignored — an exchange
 * the provider rejected leaves the previous applications in exactly the same place, so it is
 * surfaced the same way rather than as a failure.
 */ parcelHelpers.export(exports, "getExchangeState", ()=>getExchangeState);
parcelHelpers.export(exports, "getApplicationRef", ()=>getApplicationRef);
var _dateFns = require("date-fns");
function formatEpochDateTime(epochSeconds) {
    if (epochSeconds === null || typeof epochSeconds === 'undefined' || epochSeconds === '') return '';
    const seconds = typeof epochSeconds === 'string' ? parseFloat(epochSeconds) : Number(epochSeconds);
    if (!Number.isFinite(seconds)) return '';
    const date = new Date(seconds * 1000);
    return (0, _dateFns.isValid)(date) ? (0, _dateFns.format)(date, "MMM d, yyyy 'at' h:mm a") : '';
}
const hasFields = (entry)=>Boolean(entry) && Object.keys(entry).length > 0;
const toList = (value)=>Array.isArray(value) ? value.filter(hasFields) : [];
function getExchangeState(application) {
    const { process_application: processApplications, previous_applications: previousApplicationList } = application || {};
    const [latestRequest] = toList(processApplications);
    const previousApplications = toList(previousApplicationList);
    const isPostExchange = previousApplications.length > 0;
    return {
        isPostExchange,
        requestedAt: isPostExchange ? formatEpochDateTime(latestRequest?.date_time_requested) : '',
        previousApplications
    };
}
const getApplicationRef = (application)=>application?.request_no;

},{"date-fns":[["format","7JNRj","default"],["isValid","jCEss","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2do1Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviousApplicationModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hi2 = require("react-icons/hi2");
var _layout = require("Core/components/Layout");
var _button = require("Core/components/Button");
var _numberFormat = require("Core/utils/numberFormat");
var _exchangeStatus = require("Modules/financing/utils/exchangeStatus");
const humanizeStatus = (value)=>String(value).toLowerCase().split('_').filter(Boolean).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
const asCurrency = (value)=>(0, _numberFormat.formatCurrency)(Number(value) || 0, {
        withDecimals: true
    });
const isPresent = (value)=>value !== null && typeof value !== 'undefined' && value !== '';
// The two figures that carry the story — surfaced as tiles above the detail list.
const HIGHLIGHTS = [
    {
        key: 'financed',
        label: 'Financed',
        Icon: (0, _hi2.HiOutlineBanknotes),
        format: asCurrency
    },
    {
        key: 'monthly_payment',
        label: 'Monthly Payment',
        Icon: (0, _hi2.HiOutlineCalendarDays),
        format: asCurrency
    }
];
// Everything else the platform sends back per previous application, in display order.
// Fields the response omits are skipped instead of rendering an empty row.
const FIELDS = [
    {
        key: 'application_status',
        label: 'Application Status',
        format: humanizeStatus,
        emphasis: true
    },
    {
        key: 'amount_to_pay',
        label: 'Amount to Pay',
        format: asCurrency
    },
    {
        key: 'already_paid_amount',
        label: 'Already Paid',
        format: asCurrency
    },
    {
        key: 'financing_down_payment',
        label: 'Down Payment',
        format: asCurrency
    },
    {
        key: 'down_payment_status',
        label: 'Down Payment Status',
        format: humanizeStatus
    },
    {
        key: 'created_at',
        label: 'Created',
        format: (0, _exchangeStatus.formatEpochDateTime)
    }
];
const cardTitle = (application)=>{
    const ref = (0, _exchangeStatus.getApplicationRef)(application);
    return isPresent(ref) ? `Request #${ref}` : 'Application';
};
function PreviousApplicationCard({ application, index }) {
    const highlights = HIGHLIGHTS.filter(({ key })=>isPresent(application?.[key]));
    const rows = FIELDS.filter(({ key })=>isPresent(application?.[key]));
    const testId = (key)=>`previous-application-${index}-${key}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
        className: "rounded-xl border border-solid border-slate-200 bg-white p-3.5",
        "data-testid": `previous-application-card-${index}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        className: "!mb-0 text-sm font-bold text-slate-900",
                        "data-testid": `previous-application-card-title-${index}`,
                        children: cardTitle(application)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "inline-flex items-center gap-1.5 rounded-full bg-green-600 px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider text-white shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "h-1.5 w-1.5 rounded-full bg-white",
                                "aria-hidden": "true"
                            }),
                            "Funded & Active"
                        ]
                    })
                ]
            }),
            highlights.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-3 flex flex-wrap gap-3",
                children: highlights.map(({ key, label, Icon: TileIcon, format })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex min-w-0 flex-1 items-center gap-3 rounded-xl border border-solid border-slate-200 bg-gradient-to-b from-slate-50 to-white px-3.5 py-3 [flex-basis:180px]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                "aria-hidden": "true",
                                className: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TileIcon, {
                                    className: "h-[18px] w-[18px]"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-[11px] font-bold uppercase tracking-wider text-slate-400",
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-lg font-extrabold tabular-nums leading-tight text-slate-900",
                                        "data-testid": testId(key),
                                        children: format(application[key])
                                    })
                                ]
                            })
                        ]
                    }, key))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dl", {
                className: "!mb-0 mt-3",
                children: rows.map(({ key, label, format, emphasis }, rowIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `flex items-center justify-between gap-4 py-2.5 ${rowIndex === 0 ? '' : 'border-0 border-t border-solid border-slate-100'}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                className: "text-sm text-slate-500",
                                children: label
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                className: `!mb-0 text-right text-sm font-semibold tabular-nums ${emphasis ? 'text-green-700' : 'text-slate-900'}`,
                                "data-testid": testId(key),
                                children: format(application[key])
                            })
                        ]
                    }, key))
            })
        ]
    });
}
function PreviousApplicationModal({ isOpen, onClose, previousApplications = [], requestedAt }) {
    const applications = previousApplications.filter(Boolean);
    const isPlural = applications.length > 1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
        isOpen: isOpen,
        className: "w-full max-w-lg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-xl border border-solid border-green-200 bg-gradient-to-r from-green-50 to-emerald-50 px-4 py-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-start gap-3.5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                "aria-hidden": "true",
                                className: "flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600 ring-4 ring-white/70",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineCheckBadge), {
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "min-w-0 flex-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "!mb-0 font-bold text-slate-900",
                                    "data-testid": "previous-application-modal-title",
                                    children: isPlural ? 'Previous Applications' : 'Previous Application'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "!mb-0 mt-3.5 text-sm leading-relaxed text-slate-600",
                        children: isPlural ? 'These applications are funded and remain in effect. Nothing has been refunded or cancelled, and they stay active until the exchange is funded.' : 'This application is funded and remains in effect. Nothing has been refunded or cancelled, and it stays active until the exchange is funded.'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4 flex flex-col gap-3",
                "data-testid": "previous-application-details",
                children: applications.map((application, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PreviousApplicationCard, {
                        application: application,
                        index: index
                    }, (0, _exchangeStatus.getApplicationRef)(application) ?? index))
            }),
            requestedAt && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "mt-3 !mb-0 text-xs text-slate-400",
                "data-testid": "previous-application-requested",
                children: [
                    "Exchange last requested on ",
                    requestedAt,
                    "."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                className: "my-4 border-0 border-t border-solid border-slate-200"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                    type: "button",
                    onClick: onClose,
                    "data-testid": "btn-close-previous-application",
                    children: "Close"
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-icons/hi2":"krCLn","Core/components/Layout":"hweet","Core/components/Button":"6YNzH","Core/utils/numberFormat":"6T56F","Modules/financing/utils/exchangeStatus":"foB3b","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jyEud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeliveryDateField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _reactI18Next = require("react-i18next");
var _dateFns = require("date-fns");
var _hi2 = require("react-icons/hi2");
var _calendarInputField = require("Core/components/FormElements/CalendarInputField");
var _calendarInputFieldDefault = parcelHelpers.interopDefault(_calendarInputField);
var _button = require("Core/components/Button");
var _layout = require("Core/components/Layout");
const EditDeliveryDateWarningModal = ({ isOpen, onCancel, onConfirm })=>{
    const [isAcknowledged, setIsAcknowledged] = (0, _reactDefault.default).useState(false);
    (0, _reactDefault.default).useEffect(()=>{
        if (!isOpen) setIsAcknowledged(false);
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
        isOpen: isOpen,
        className: "w-full max-w-lg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-xl border border-solid border-amber-300 bg-gradient-to-r from-amber-50 to-yellow-50 px-4 py-4",
                "data-testid": "edit-delivery-date-warning",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-start gap-3.5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                "aria-hidden": "true",
                                className: "flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-600 ring-4 ring-white/70",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineExclamationTriangle), {
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "!mb-0 self-center font-bold text-slate-900",
                                children: "Change the delivery date?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "!mb-0 mt-3.5 text-sm leading-relaxed text-slate-700",
                        children: "The delivery date comes from the financing application and should normally not be changed here."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "!mb-0 mt-2 text-sm leading-relaxed text-slate-700",
                        children: [
                            "Changing it also moves the customer's ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: "first payment date"
                            }),
                            ". Only continue if you need to correct a wrong date."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                className: "mt-4 flex items-center text-sm text-slate-700",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        className: "mr-2 h-4 w-4",
                        checked: isAcknowledged,
                        onChange: (event)=>setIsAcknowledged(event.target.checked),
                        "data-testid": "checkbox-acknowledge-edit-delivery-date"
                    }),
                    "I understand"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                className: "my-4 border-0 border-t border-solid border-slate-200"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex justify-end gap-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.DestructiveButton), {
                        type: "button",
                        onClick: onConfirm,
                        disabled: !isAcknowledged,
                        "data-testid": "btn-confirm-edit-delivery-date",
                        children: "Change date"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                        type: "button",
                        onClick: onCancel,
                        "data-testid": "btn-cancel-edit-delivery-date",
                        children: "Keep current date"
                    })
                ]
            })
        ]
    });
};
function DeliveryDateField({ control, errors }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const [isEditable, setIsEditable] = (0, _reactDefault.default).useState(false);
    const [isWarningOpen, setIsWarningOpen] = (0, _reactDefault.default).useState(false);
    const confirmEdit = ()=>{
        setIsWarningOpen(false);
        setIsEditable(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
                name: "deliveryDate",
                control: control,
                rules: {
                    required: t('common.requiredFieldDeliveryDate')
                },
                render: ({ field: { onChange, onBlur, name, value } })=>isEditable ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarInputFieldDefault.default), {
                        label: t('common.deliveryDate'),
                        name: name,
                        value: value,
                        onBlur: onBlur,
                        "data-testid": "input-delivery-date",
                        onChange: onChange,
                        emitRawValue: true,
                        required: true,
                        dayPickerProps: {
                            disabledDays: {
                                after: (0, _dateFns.add)(new Date(), {
                                    days: 60
                                })
                            }
                        },
                        errors: errors
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "value-delivery-date",
                                children: t('common.deliveryDate')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-1 flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        id: "value-delivery-date",
                                        className: "text-lg font-semibold",
                                        "data-testid": "value-delivery-date",
                                        children: value
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                                        type: "button",
                                        onClick: ()=>setIsWarningOpen(true),
                                        "data-testid": "btn-edit-delivery-date",
                                        "aria-label": "Edit delivery date",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "inline-flex items-center gap-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlinePencilSquare), {
                                                    className: "h-4 w-4",
                                                    "aria-hidden": "true"
                                                }),
                                                "Edit"
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(EditDeliveryDateWarningModal, {
                isOpen: isWarningOpen,
                onCancel: ()=>setIsWarningOpen(false),
                onConfirm: confirmEdit
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-hook-form":"53GLT","react-i18next":"244ua","date-fns":[["add","1Oe4T","default"]],"react-icons/hi2":"krCLn","Core/components/FormElements/CalendarInputField":"50zwN","Core/components/Button":"6YNzH","Core/components/Layout":"hweet","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1Oe4T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>add);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/toInteger/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function add(dirtyDate, duration) {
    (0, _indexJsDefault3.default)(2, arguments);
    if (!duration || (0, _typeofDefault.default)(duration) !== 'object') return new Date(NaN);
    var years = duration.years ? (0, _indexJsDefault4.default)(duration.years) : 0;
    var months = duration.months ? (0, _indexJsDefault4.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, _indexJsDefault4.default)(duration.weeks) : 0;
    var days = duration.days ? (0, _indexJsDefault4.default)(duration.days) : 0;
    var hours = duration.hours ? (0, _indexJsDefault4.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, _indexJsDefault4.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, _indexJsDefault4.default)(duration.seconds) : 0;
    // Add years and months
    var date = (0, _indexJsDefault2.default)(dirtyDate);
    var dateWithMonths = months || years ? (0, _indexJsDefault1.default)(date, months + years * 12) : date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, _indexJsDefault.default)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}

},{"@babel/runtime/helpers/esm/typeof":"h3CKR","../addDays/index.js":"13PMn","../addMonths/index.js":"32EhL","../toDate/index.js":"iBeGL","../_lib/requiredArgs/index.js":"hVUyW","../_lib/toInteger/index.js":"5Ujd6","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"13PMn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addDays);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"5Ujd6","../toDate/index.js":"iBeGL","../_lib/requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"32EhL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

},{"../_lib/toInteger/index.js":"5Ujd6","../toDate/index.js":"iBeGL","../_lib/requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"50zwN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDayPicker = require("react-day-picker");
var _dateFns = require("date-fns");
var _appConfig = require("Core/config/appConfig");
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _styleCss = require("react-day-picker/src/style.css");
var _calendarInputCss = require("./CalendarInput.css");
var _error = require("Core/components/FormElements/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
const CalendarInputField = (props)=>{
    const { dateFormat } = (0, _appConfig.getAppConfig)();
    const { errors = null, className = 'form-control', name, id = name, testid = id, label, format = dateFormat, onChange, onBlur, value: controlledValue, dayPickerProps, // When true, every keystroke (including clearing the input) is reported to the
    // form, so schema validation sees exactly what the user typed. When false,
    // invalid/empty input keeps the last valid value in form state.
    emitRawValue = false, // Marks the label with an asterisk; enforcement stays in the form schema
    required = false } = props;
    const [selected, setSelected] = (0, _react.useState)();
    const [inputValue, setInputValue] = (0, _react.useState)(controlledValue || '');
    const [isPickerOpen, setIsPickerOpen] = (0, _react.useState)(false);
    const inputRef = (0, _react.useRef)(null);
    const containerRef = (0, _react.useRef)(null);
    const error = errors[name]?.message;
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (containerRef.current && !containerRef.current.contains(event.target)) setIsPickerOpen(false);
        };
        if (isPickerOpen) document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, [
        isPickerOpen
    ]);
    const handleDaySelect = (date)=>{
        setSelected(date);
        if (date) {
            const formatted = (0, _dateFns.format)(date, format);
            setInputValue(formatted);
            onChange(formatted);
        }
        setIsPickerOpen(false);
    };
    const handleInputChange = (e)=>{
        setInputValue(e.target.value);
        const parsed = (0, _dateFns.parse)(e.target.value, format, new Date());
        if (!isNaN(parsed)) setSelected(parsed);
        if (emitRawValue || !isNaN(parsed)) onChange(e.target.value);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormElement), {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                htmlFor: id,
                children: [
                    label,
                    required && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-red-500",
                        children: " *"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: containerRef,
                className: className,
                style: {
                    position: 'relative'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        ref: inputRef,
                        type: "text",
                        id: id,
                        "data-testid": testid,
                        value: inputValue,
                        onChange: handleInputChange,
                        onBlur: onBlur,
                        "aria-required": required,
                        onFocus: ()=>setIsPickerOpen(true),
                        placeholder: format
                    }),
                    isPickerOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: 'absolute',
                            zIndex: 1000,
                            background: 'white',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDayPicker.DayPicker), {
                            mode: "single",
                            selected: selected,
                            onSelect: handleDaySelect,
                            "data-testid": "day-picker",
                            "data-date-picker-props": dayPickerProps
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                message: error,
                show: Boolean(error)
            })
        ]
    });
};
exports.default = CalendarInputField;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-day-picker":"fu4kb","date-fns":[["format","7JNRj","default"],["parse","jBRYJ","default"]],"Core/config/appConfig":"7qX5H","Core/components/FormElements/formElements.styled":"45aFS","react-day-picker/src/style.css":"WDvlF","./CalendarInput.css":"4upf9","Core/components/FormElements/Error":"dyj9l","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fu4kb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Renders the DayPicker calendar component.
 *
 * @param initialProps - The props for the DayPicker component.
 * @returns The rendered DayPicker component.
 * @group DayPicker
 * @see https://daypicker.dev
 */ parcelHelpers.export(exports, "DayPicker", ()=>DayPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateLibJs = require("./classes/DateLib.js");
var _createGetModifiersJs = require("./helpers/createGetModifiers.js");
var _getClassNamesForModifiersJs = require("./helpers/getClassNamesForModifiers.js");
var _getComponentsJs = require("./helpers/getComponents.js");
var _getDataAttributesJs = require("./helpers/getDataAttributes.js");
var _getDefaultClassNamesJs = require("./helpers/getDefaultClassNames.js");
var _getFormattersJs = require("./helpers/getFormatters.js");
var _getLabelsJs = require("./helpers/getLabels.js");
var _getMonthOptionsJs = require("./helpers/getMonthOptions.js");
var _getStyleForModifiersJs = require("./helpers/getStyleForModifiers.js");
var _getWeekdaysJs = require("./helpers/getWeekdays.js");
var _getYearOptionsJs = require("./helpers/getYearOptions.js");
var _noonDateLibJs = require("./noonDateLib.js");
var _uiJs = require("./UI.js");
var _useAnimationJs = require("./useAnimation.js");
var _useCalendarJs = require("./useCalendar.js");
var _useDayPickerJs = require("./useDayPicker.js");
var _useFocusJs = require("./useFocus.js");
var _useSelectionJs = require("./useSelection.js");
var _convertMatchersToTimeZoneJs = require("./utils/convertMatchersToTimeZone.js");
var _rangeIncludesDateJs = require("./utils/rangeIncludesDate.js");
var _toTimeZoneJs = require("./utils/toTimeZone.js");
var _typeguardsJs = require("./utils/typeguards.js");
function DayPicker(initialProps) {
    let props = initialProps;
    const timeZone = props.timeZone;
    if (timeZone) {
        props = {
            ...initialProps,
            timeZone
        };
        if (props.today) props.today = (0, _toTimeZoneJs.toTimeZone)(props.today, timeZone);
        if (props.month) props.month = (0, _toTimeZoneJs.toTimeZone)(props.month, timeZone);
        if (props.defaultMonth) props.defaultMonth = (0, _toTimeZoneJs.toTimeZone)(props.defaultMonth, timeZone);
        if (props.startMonth) props.startMonth = (0, _toTimeZoneJs.toTimeZone)(props.startMonth, timeZone);
        if (props.endMonth) props.endMonth = (0, _toTimeZoneJs.toTimeZone)(props.endMonth, timeZone);
        if (props.mode === "single" && props.selected) props.selected = (0, _toTimeZoneJs.toTimeZone)(props.selected, timeZone);
        else if (props.mode === "multiple" && props.selected) props.selected = props.selected?.map((date)=>(0, _toTimeZoneJs.toTimeZone)(date, timeZone));
        else if (props.mode === "range" && props.selected) props.selected = {
            from: props.selected.from ? (0, _toTimeZoneJs.toTimeZone)(props.selected.from, timeZone) : props.selected.from,
            to: props.selected.to ? (0, _toTimeZoneJs.toTimeZone)(props.selected.to, timeZone) : props.selected.to
        };
        if (props.disabled !== undefined) props.disabled = (0, _convertMatchersToTimeZoneJs.convertMatchersToTimeZone)(props.disabled, timeZone);
        if (props.hidden !== undefined) props.hidden = (0, _convertMatchersToTimeZoneJs.convertMatchersToTimeZone)(props.hidden, timeZone);
        if (props.modifiers) {
            const nextModifiers = {};
            Object.keys(props.modifiers).forEach((key)=>{
                nextModifiers[key] = (0, _convertMatchersToTimeZoneJs.convertMatchersToTimeZone)(props.modifiers?.[key], timeZone);
            });
            props.modifiers = nextModifiers;
        }
    }
    const { components, formatters, labels, dateLib, locale, classNames } = (0, _react.useMemo)(()=>{
        const locale = {
            ...(0, _dateLibJs.defaultLocale),
            ...props.locale
        };
        const weekStartsOn = props.broadcastCalendar ? 1 : props.weekStartsOn;
        const noonOverrides = props.noonSafe && props.timeZone ? (0, _noonDateLibJs.createNoonOverrides)(props.timeZone, {
            weekStartsOn,
            locale
        }) : undefined;
        const overrides = props.dateLib && noonOverrides ? {
            ...noonOverrides,
            ...props.dateLib
        } : props.dateLib ?? noonOverrides;
        const dateLib = new (0, _dateLibJs.DateLib)({
            locale,
            weekStartsOn,
            firstWeekContainsDate: props.firstWeekContainsDate,
            useAdditionalWeekYearTokens: props.useAdditionalWeekYearTokens,
            useAdditionalDayOfYearTokens: props.useAdditionalDayOfYearTokens,
            timeZone: props.timeZone,
            numerals: props.numerals
        }, overrides);
        return {
            dateLib,
            components: (0, _getComponentsJs.getComponents)(props.components),
            formatters: (0, _getFormattersJs.getFormatters)(props.formatters),
            labels: (0, _getLabelsJs.getLabels)(props.labels, dateLib.options),
            locale,
            classNames: {
                ...(0, _getDefaultClassNamesJs.getDefaultClassNames)(),
                ...props.classNames
            }
        };
    }, [
        props.locale,
        props.broadcastCalendar,
        props.weekStartsOn,
        props.firstWeekContainsDate,
        props.useAdditionalWeekYearTokens,
        props.useAdditionalDayOfYearTokens,
        props.timeZone,
        props.numerals,
        props.dateLib,
        props.noonSafe,
        props.components,
        props.formatters,
        props.labels,
        props.classNames
    ]);
    if (!props.today) props = {
        ...props,
        today: dateLib.today()
    };
    const { captionLayout, mode, navLayout, numberOfMonths = 1, onDayBlur, onDayClick, onDayFocus, onDayKeyDown, onDayMouseEnter, onDayMouseLeave, onNextClick, onPrevClick, showWeekNumber, styles } = props;
    const { formatCaption, formatDay, formatMonthDropdown, formatWeekNumber, formatWeekNumberHeader, formatWeekdayName, formatYearDropdown } = formatters;
    const calendar = (0, _useCalendarJs.useCalendar)(props, dateLib);
    const { days, months, navStart, navEnd, previousMonth, nextMonth, goToMonth } = calendar;
    const getModifiers = (0, _createGetModifiersJs.createGetModifiers)(days, props, navStart, navEnd, dateLib);
    const { isSelected, select, selected: selectedValue } = (0, _useSelectionJs.useSelection)(props, dateLib) ?? {};
    const { blur, focused, isFocusTarget, moveFocus, setFocused } = (0, _useFocusJs.useFocus)(props, calendar, getModifiers, isSelected ?? (()=>false), dateLib);
    const { labelDayButton, labelGridcell, labelGrid, labelMonthDropdown, labelNav, labelPrevious, labelNext, labelWeekday, labelWeekNumber, labelWeekNumberHeader, labelYearDropdown } = labels;
    const weekdays = (0, _react.useMemo)(()=>(0, _getWeekdaysJs.getWeekdays)(dateLib, props.ISOWeek, props.broadcastCalendar, props.today), [
        dateLib,
        props.ISOWeek,
        props.broadcastCalendar,
        props.today
    ]);
    const isInteractive = mode !== undefined || onDayClick !== undefined;
    const handlePreviousClick = (0, _react.useCallback)(()=>{
        if (!previousMonth) return;
        goToMonth(previousMonth);
        onPrevClick?.(previousMonth);
    }, [
        previousMonth,
        goToMonth,
        onPrevClick
    ]);
    const handleNextClick = (0, _react.useCallback)(()=>{
        if (!nextMonth) return;
        goToMonth(nextMonth);
        onNextClick?.(nextMonth);
    }, [
        goToMonth,
        nextMonth,
        onNextClick
    ]);
    const handleDayClick = (0, _react.useCallback)((day, m)=>(e)=>{
            e.preventDefault();
            e.stopPropagation();
            setFocused(day);
            if (m.disabled) return;
            select?.(day.date, m, e);
            onDayClick?.(day.date, m, e);
        }, [
        select,
        onDayClick,
        setFocused
    ]);
    const handleDayFocus = (0, _react.useCallback)((day, m)=>(e)=>{
            setFocused(day);
            onDayFocus?.(day.date, m, e);
        }, [
        onDayFocus,
        setFocused
    ]);
    const handleDayBlur = (0, _react.useCallback)((day, m)=>(e)=>{
            blur();
            onDayBlur?.(day.date, m, e);
        }, [
        blur,
        onDayBlur
    ]);
    const handleDayKeyDown = (0, _react.useCallback)((day, modifiers)=>(e)=>{
            const keyMap = {
                ArrowLeft: [
                    e.shiftKey ? "month" : "day",
                    props.dir === "rtl" ? "after" : "before"
                ],
                ArrowRight: [
                    e.shiftKey ? "month" : "day",
                    props.dir === "rtl" ? "before" : "after"
                ],
                ArrowDown: [
                    e.shiftKey ? "year" : "week",
                    "after"
                ],
                ArrowUp: [
                    e.shiftKey ? "year" : "week",
                    "before"
                ],
                PageUp: [
                    e.shiftKey ? "year" : "month",
                    "before"
                ],
                PageDown: [
                    e.shiftKey ? "year" : "month",
                    "after"
                ],
                Home: [
                    "startOfWeek",
                    "before"
                ],
                End: [
                    "endOfWeek",
                    "after"
                ]
            };
            if (keyMap[e.key]) {
                e.preventDefault();
                e.stopPropagation();
                const [moveBy, moveDir] = keyMap[e.key];
                moveFocus(moveBy, moveDir);
            }
            onDayKeyDown?.(day.date, modifiers, e);
        }, [
        moveFocus,
        onDayKeyDown,
        props.dir
    ]);
    const handleDayMouseEnter = (0, _react.useCallback)((day, modifiers)=>(e)=>{
            onDayMouseEnter?.(day.date, modifiers, e);
        }, [
        onDayMouseEnter
    ]);
    const handleDayMouseLeave = (0, _react.useCallback)((day, modifiers)=>(e)=>{
            onDayMouseLeave?.(day.date, modifiers, e);
        }, [
        onDayMouseLeave
    ]);
    const handleMonthChange = (0, _react.useCallback)((date)=>(e)=>{
            const selectedMonth = Number(e.target.value);
            const month = dateLib.setMonth(dateLib.startOfMonth(date), selectedMonth);
            goToMonth(month);
        }, [
        dateLib,
        goToMonth
    ]);
    const handleYearChange = (0, _react.useCallback)((date)=>(e)=>{
            const selectedYear = Number(e.target.value);
            const month = dateLib.setYear(dateLib.startOfMonth(date), selectedYear);
            goToMonth(month);
        }, [
        dateLib,
        goToMonth
    ]);
    const { className, style } = (0, _react.useMemo)(()=>({
            className: [
                classNames[(0, _uiJs.UI).Root],
                props.className
            ].filter(Boolean).join(" "),
            style: {
                ...styles?.[(0, _uiJs.UI).Root],
                ...props.style
            }
        }), [
        classNames,
        props.className,
        props.style,
        styles
    ]);
    const dataAttributes = (0, _getDataAttributesJs.getDataAttributes)(props);
    const rootElRef = (0, _react.useRef)(null);
    (0, _useAnimationJs.useAnimation)(rootElRef, Boolean(props.animate), {
        classNames,
        months,
        focused,
        dateLib
    });
    const contextValue = {
        dayPickerProps: props,
        selected: selectedValue,
        select: select,
        isSelected,
        months,
        nextMonth,
        previousMonth,
        goToMonth,
        getModifiers,
        components,
        classNames,
        styles,
        labels,
        formatters
    };
    return (0, _reactDefault.default).createElement((0, _useDayPickerJs.dayPickerContext).Provider, {
        value: contextValue
    }, (0, _reactDefault.default).createElement(components.Root, {
        rootRef: props.animate ? rootElRef : undefined,
        className: className,
        style: style,
        dir: props.dir,
        id: props.id,
        lang: props.lang ?? locale.code,
        nonce: props.nonce,
        title: props.title,
        role: props.role,
        "aria-label": props["aria-label"],
        "aria-labelledby": props["aria-labelledby"],
        ...dataAttributes
    }, (0, _reactDefault.default).createElement(components.Months, {
        className: classNames[(0, _uiJs.UI).Months],
        style: styles?.[(0, _uiJs.UI).Months]
    }, !props.hideNavigation && !navLayout && (0, _reactDefault.default).createElement(components.Nav, {
        "data-animated-nav": props.animate ? "true" : undefined,
        className: classNames[(0, _uiJs.UI).Nav],
        style: styles?.[(0, _uiJs.UI).Nav],
        "aria-label": labelNav(),
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick,
        previousMonth: previousMonth,
        nextMonth: nextMonth
    }), months.map((calendarMonth, displayIndex)=>{
        return (0, _reactDefault.default).createElement(components.Month, {
            "data-animated-month": props.animate ? "true" : undefined,
            className: classNames[(0, _uiJs.UI).Month],
            style: styles?.[(0, _uiJs.UI).Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: displayIndex,
            displayIndex: displayIndex,
            calendarMonth: calendarMonth
        }, navLayout === "around" && !props.hideNavigation && displayIndex === 0 && (0, _reactDefault.default).createElement(components.PreviousMonthButton, {
            type: "button",
            className: classNames[(0, _uiJs.UI).PreviousMonthButton],
            tabIndex: previousMonth ? undefined : -1,
            "aria-disabled": previousMonth ? undefined : true,
            "aria-label": labelPrevious(previousMonth),
            onClick: handlePreviousClick,
            "data-animated-button": props.animate ? "true" : undefined
        }, (0, _reactDefault.default).createElement(components.Chevron, {
            disabled: previousMonth ? undefined : true,
            className: classNames[(0, _uiJs.UI).Chevron],
            orientation: props.dir === "rtl" ? "right" : "left"
        })), (0, _reactDefault.default).createElement(components.MonthCaption, {
            "data-animated-caption": props.animate ? "true" : undefined,
            className: classNames[(0, _uiJs.UI).MonthCaption],
            style: styles?.[(0, _uiJs.UI).MonthCaption],
            calendarMonth: calendarMonth,
            displayIndex: displayIndex
        }, captionLayout?.startsWith("dropdown") ? (0, _reactDefault.default).createElement(components.DropdownNav, {
            className: classNames[(0, _uiJs.UI).Dropdowns],
            style: styles?.[(0, _uiJs.UI).Dropdowns]
        }, (()=>{
            const monthControl = captionLayout === "dropdown" || captionLayout === "dropdown-months" ? (0, _reactDefault.default).createElement(components.MonthsDropdown, {
                key: "month",
                className: classNames[(0, _uiJs.UI).MonthsDropdown],
                "aria-label": labelMonthDropdown(),
                classNames: classNames,
                components: components,
                disabled: Boolean(props.disableNavigation),
                onChange: handleMonthChange(calendarMonth.date),
                options: (0, _getMonthOptionsJs.getMonthOptions)(calendarMonth.date, navStart, navEnd, formatters, dateLib),
                style: styles?.[(0, _uiJs.UI).Dropdown],
                value: dateLib.getMonth(calendarMonth.date)
            }) : (0, _reactDefault.default).createElement("span", {
                key: "month"
            }, formatMonthDropdown(calendarMonth.date, dateLib));
            const yearControl = captionLayout === "dropdown" || captionLayout === "dropdown-years" ? (0, _reactDefault.default).createElement(components.YearsDropdown, {
                key: "year",
                className: classNames[(0, _uiJs.UI).YearsDropdown],
                "aria-label": labelYearDropdown(dateLib.options),
                classNames: classNames,
                components: components,
                disabled: Boolean(props.disableNavigation),
                onChange: handleYearChange(calendarMonth.date),
                options: (0, _getYearOptionsJs.getYearOptions)(navStart, navEnd, formatters, dateLib, Boolean(props.reverseYears)),
                style: styles?.[(0, _uiJs.UI).Dropdown],
                value: dateLib.getYear(calendarMonth.date)
            }) : (0, _reactDefault.default).createElement("span", {
                key: "year"
            }, formatYearDropdown(calendarMonth.date, dateLib));
            const controls = dateLib.getMonthYearOrder() === "year-first" ? [
                yearControl,
                monthControl
            ] : [
                monthControl,
                yearControl
            ];
            return controls;
        })(), (0, _reactDefault.default).createElement("span", {
            role: "status",
            "aria-live": "polite",
            style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
            }
        }, formatCaption(calendarMonth.date, dateLib.options, dateLib))) : (0, _reactDefault.default).createElement(components.CaptionLabel, {
            className: classNames[(0, _uiJs.UI).CaptionLabel],
            role: "status",
            "aria-live": "polite"
        }, formatCaption(calendarMonth.date, dateLib.options, dateLib))), navLayout === "around" && !props.hideNavigation && displayIndex === numberOfMonths - 1 && (0, _reactDefault.default).createElement(components.NextMonthButton, {
            type: "button",
            className: classNames[(0, _uiJs.UI).NextMonthButton],
            tabIndex: nextMonth ? undefined : -1,
            "aria-disabled": nextMonth ? undefined : true,
            "aria-label": labelNext(nextMonth),
            onClick: handleNextClick,
            "data-animated-button": props.animate ? "true" : undefined
        }, (0, _reactDefault.default).createElement(components.Chevron, {
            disabled: nextMonth ? undefined : true,
            className: classNames[(0, _uiJs.UI).Chevron],
            orientation: props.dir === "rtl" ? "left" : "right"
        })), displayIndex === numberOfMonths - 1 && navLayout === "after" && !props.hideNavigation && (0, _reactDefault.default).createElement(components.Nav, {
            "data-animated-nav": props.animate ? "true" : undefined,
            className: classNames[(0, _uiJs.UI).Nav],
            style: styles?.[(0, _uiJs.UI).Nav],
            "aria-label": labelNav(),
            onPreviousClick: handlePreviousClick,
            onNextClick: handleNextClick,
            previousMonth: previousMonth,
            nextMonth: nextMonth
        }), (0, _reactDefault.default).createElement(components.MonthGrid, {
            role: "grid",
            "aria-multiselectable": mode === "multiple" || mode === "range",
            "aria-label": labelGrid(calendarMonth.date, dateLib.options, dateLib) || undefined,
            className: classNames[(0, _uiJs.UI).MonthGrid],
            style: styles?.[(0, _uiJs.UI).MonthGrid]
        }, !props.hideWeekdays && (0, _reactDefault.default).createElement(components.Weekdays, {
            "data-animated-weekdays": props.animate ? "true" : undefined,
            className: classNames[(0, _uiJs.UI).Weekdays],
            style: styles?.[(0, _uiJs.UI).Weekdays]
        }, showWeekNumber && (0, _reactDefault.default).createElement(components.WeekNumberHeader, {
            "aria-label": labelWeekNumberHeader(dateLib.options),
            className: classNames[(0, _uiJs.UI).WeekNumberHeader],
            style: styles?.[(0, _uiJs.UI).WeekNumberHeader],
            scope: "col"
        }, formatWeekNumberHeader()), weekdays.map((weekday)=>(0, _reactDefault.default).createElement(components.Weekday, {
                "aria-label": labelWeekday(weekday, dateLib.options, dateLib),
                className: classNames[(0, _uiJs.UI).Weekday],
                key: String(weekday),
                style: styles?.[(0, _uiJs.UI).Weekday],
                scope: "col"
            }, formatWeekdayName(weekday, dateLib.options, dateLib)))), (0, _reactDefault.default).createElement(components.Weeks, {
            "data-animated-weeks": props.animate ? "true" : undefined,
            className: classNames[(0, _uiJs.UI).Weeks],
            style: styles?.[(0, _uiJs.UI).Weeks]
        }, calendarMonth.weeks.map((week)=>{
            return (0, _reactDefault.default).createElement(components.Week, {
                className: classNames[(0, _uiJs.UI).Week],
                key: week.weekNumber,
                style: styles?.[(0, _uiJs.UI).Week],
                week: week
            }, showWeekNumber && (0, _reactDefault.default).createElement(components.WeekNumber, {
                week: week,
                style: styles?.[(0, _uiJs.UI).WeekNumber],
                "aria-label": labelWeekNumber(week.weekNumber, {
                    locale
                }),
                className: classNames[(0, _uiJs.UI).WeekNumber],
                scope: "row",
                role: "rowheader"
            }, formatWeekNumber(week.weekNumber, dateLib)), week.days.map((day)=>{
                const { date } = day;
                const modifiers = getModifiers(day);
                modifiers[(0, _uiJs.DayFlag).focused] = !modifiers.hidden && Boolean(focused?.isEqualTo(day));
                modifiers[(0, _uiJs.SelectionState).selected] = isSelected?.(date) || modifiers.selected;
                if ((0, _typeguardsJs.isDateRange)(selectedValue)) {
                    // add range modifiers
                    const { from, to } = selectedValue;
                    modifiers[(0, _uiJs.SelectionState).range_start] = Boolean(from && to && dateLib.isSameDay(date, from));
                    modifiers[(0, _uiJs.SelectionState).range_end] = Boolean(from && to && dateLib.isSameDay(date, to));
                    modifiers[(0, _uiJs.SelectionState).range_middle] = (0, _rangeIncludesDateJs.rangeIncludesDate)(selectedValue, date, true, dateLib);
                }
                const style = (0, _getStyleForModifiersJs.getStyleForModifiers)(modifiers, styles, props.modifiersStyles);
                const className = (0, _getClassNamesForModifiersJs.getClassNamesForModifiers)(modifiers, classNames, props.modifiersClassNames);
                const ariaLabel = !isInteractive && !modifiers.hidden ? labelGridcell(date, modifiers, dateLib.options, dateLib) : undefined;
                return (0, _reactDefault.default).createElement(components.Day, {
                    key: `${day.isoDate}_${day.displayMonthId}`,
                    day: day,
                    modifiers: modifiers,
                    className: className.join(" "),
                    style: style,
                    role: "gridcell",
                    "aria-selected": modifiers.selected || undefined,
                    "aria-label": ariaLabel,
                    "data-day": day.isoDate,
                    "data-month": day.outside ? day.dateMonthId : undefined,
                    "data-selected": modifiers.selected || undefined,
                    "data-disabled": modifiers.disabled || undefined,
                    "data-hidden": modifiers.hidden || undefined,
                    "data-outside": day.outside || undefined,
                    "data-focused": modifiers.focused || undefined,
                    "data-today": modifiers.today || undefined
                }, !modifiers.hidden && isInteractive ? (0, _reactDefault.default).createElement(components.DayButton, {
                    className: classNames[(0, _uiJs.UI).DayButton],
                    style: styles?.[(0, _uiJs.UI).DayButton],
                    type: "button",
                    day: day,
                    modifiers: modifiers,
                    disabled: !modifiers.focused && modifiers.disabled || undefined,
                    "aria-disabled": modifiers.focused && modifiers.disabled || undefined,
                    tabIndex: isFocusTarget(day) ? 0 : -1,
                    "aria-label": labelDayButton(date, modifiers, dateLib.options, dateLib),
                    onClick: handleDayClick(day, modifiers),
                    onBlur: handleDayBlur(day, modifiers),
                    onFocus: handleDayFocus(day, modifiers),
                    onKeyDown: handleDayKeyDown(day, modifiers),
                    onMouseEnter: handleDayMouseEnter(day, modifiers),
                    onMouseLeave: handleDayMouseLeave(day, modifiers)
                }, formatDay(date, dateLib.options, dateLib)) : !modifiers.hidden && formatDay(day.date, dateLib.options, dateLib));
            }));
        }))));
    })), props.footer && (0, _reactDefault.default).createElement(components.Footer, {
        className: classNames[(0, _uiJs.UI).Footer],
        style: styles?.[(0, _uiJs.UI).Footer],
        role: "status",
        "aria-live": "polite"
    }, props.footer)));
}

},{"react":"2o0ib","./classes/DateLib.js":"6ev8G","./helpers/createGetModifiers.js":"l0SZt","./helpers/getClassNamesForModifiers.js":"frZeA","./helpers/getComponents.js":"mDDs9","./helpers/getDataAttributes.js":"aduvW","./helpers/getDefaultClassNames.js":"5otA2","./helpers/getFormatters.js":"iUy8r","./helpers/getLabels.js":"6swYz","./helpers/getMonthOptions.js":"cGOii","./helpers/getStyleForModifiers.js":"l4ZpQ","./helpers/getWeekdays.js":"8RGAX","./helpers/getYearOptions.js":"gEZRh","./noonDateLib.js":"fAVNs","./UI.js":"22uOo","./useAnimation.js":"ggcRD","./useCalendar.js":"cLv18","./useDayPicker.js":"22BNj","./useFocus.js":"2ZgMJ","./useSelection.js":"9D8vB","./utils/convertMatchersToTimeZone.js":"3B52M","./utils/rangeIncludesDate.js":"3Wo9X","./utils/toTimeZone.js":"7IESI","./utils/typeguards.js":"keGkS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6ev8G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** The default locale (English). */ parcelHelpers.export(exports, "defaultLocale", ()=>(0, _enUSJs.enUS));
/**
 * A wrapper class around [date-fns](http://date-fns.org) that provides utility
 * methods for date manipulation and formatting.
 *
 * @since 9.2.0
 * @example
 *   const dateLib = new DateLib({ locale: es });
 *   const newDate = dateLib.addDays(new Date(), 5);
 */ parcelHelpers.export(exports, "DateLib", ()=>DateLib);
parcelHelpers.export(exports, "defaultDateLib", ()=>defaultDateLib);
parcelHelpers.export(exports, "dateLib", ()=>dateLib);
var _tz = require("@date-fns/tz");
var _dateFns = require("date-fns");
var _endOfBroadcastWeekJs = require("../helpers/endOfBroadcastWeek.js");
var _startOfBroadcastWeekJs = require("../helpers/startOfBroadcastWeek.js");
var _enUSJs = require("../locale/en-US.js");
class DateLib {
    /**
     * Creates an instance of `DateLib`.
     *
     * @param options Configuration options for the date library.
     * @param overrides Custom overrides for the date library functions.
     */ constructor(options, overrides){
        /**
         * Reference to the built-in Date constructor.
         *
         * @deprecated Use `newDate()` or `today()`.
         */ this.Date = Date;
        /**
         * Creates a new `Date` object representing today's date.
         *
         * @since 9.5.0
         * @returns A `Date` object for today's date.
         */ this.today = ()=>{
            if (this.overrides?.today) return this.overrides.today();
            if (this.options.timeZone) return (0, _tz.TZDate).tz(this.options.timeZone);
            return new this.Date();
        };
        /**
         * Creates a new `Date` object with the specified year, month, and day.
         *
         * @since 9.5.0
         * @param year The year.
         * @param monthIndex The month (0-11).
         * @param date The day of the month.
         * @returns A new `Date` object.
         */ this.newDate = (year, monthIndex, date)=>{
            if (this.overrides?.newDate) return this.overrides.newDate(year, monthIndex, date);
            if (this.options.timeZone) return new (0, _tz.TZDate)(year, monthIndex, date, this.options.timeZone);
            return new Date(year, monthIndex, date);
        };
        /**
         * Adds the specified number of days to the given date.
         *
         * @param date The date to add days to.
         * @param amount The number of days to add.
         * @returns The new date with the days added.
         */ this.addDays = (date, amount)=>{
            return this.overrides?.addDays ? this.overrides.addDays(date, amount) : (0, _dateFns.addDays)(date, amount);
        };
        /**
         * Adds the specified number of months to the given date.
         *
         * @param date The date to add months to.
         * @param amount The number of months to add.
         * @returns The new date with the months added.
         */ this.addMonths = (date, amount)=>{
            return this.overrides?.addMonths ? this.overrides.addMonths(date, amount) : (0, _dateFns.addMonths)(date, amount);
        };
        /**
         * Adds the specified number of weeks to the given date.
         *
         * @param date The date to add weeks to.
         * @param amount The number of weeks to add.
         * @returns The new date with the weeks added.
         */ this.addWeeks = (date, amount)=>{
            return this.overrides?.addWeeks ? this.overrides.addWeeks(date, amount) : (0, _dateFns.addWeeks)(date, amount);
        };
        /**
         * Adds the specified number of years to the given date.
         *
         * @param date The date to add years to.
         * @param amount The number of years to add.
         * @returns The new date with the years added.
         */ this.addYears = (date, amount)=>{
            return this.overrides?.addYears ? this.overrides.addYears(date, amount) : (0, _dateFns.addYears)(date, amount);
        };
        /**
         * Returns the number of calendar days between the given dates.
         *
         * @param dateLeft The later date.
         * @param dateRight The earlier date.
         * @returns The number of calendar days between the dates.
         */ this.differenceInCalendarDays = (dateLeft, dateRight)=>{
            return this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(dateLeft, dateRight) : (0, _dateFns.differenceInCalendarDays)(dateLeft, dateRight);
        };
        /**
         * Returns the number of calendar months between the given dates.
         *
         * @param dateLeft The later date.
         * @param dateRight The earlier date.
         * @returns The number of calendar months between the dates.
         */ this.differenceInCalendarMonths = (dateLeft, dateRight)=>{
            return this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(dateLeft, dateRight) : (0, _dateFns.differenceInCalendarMonths)(dateLeft, dateRight);
        };
        /**
         * Returns the months between the given dates.
         *
         * @param interval The interval to get the months for.
         */ this.eachMonthOfInterval = (interval)=>{
            return this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(interval) : (0, _dateFns.eachMonthOfInterval)(interval);
        };
        /**
         * Returns the years between the given dates.
         *
         * @since 9.11.1
         * @param interval The interval to get the years for.
         * @returns The array of years in the interval.
         */ this.eachYearOfInterval = (interval)=>{
            const years = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(interval) : (0, _dateFns.eachYearOfInterval)(interval);
            // Remove duplicates that may happen across DST transitions (e.g., "America/Sao_Paulo")
            // See https://github.com/date-fns/tz/issues/72
            const uniqueYears = new Set(years.map((d)=>this.getYear(d)));
            if (uniqueYears.size === years.length) // No duplicates, return as is
            return years;
            // Rebuild the array to ensure one date per year
            const yearsArray = [];
            uniqueYears.forEach((y)=>{
                yearsArray.push(new Date(y, 0, 1));
            });
            return yearsArray;
        };
        /**
         * Returns the end of the broadcast week for the given date.
         *
         * @param date The original date.
         * @returns The end of the broadcast week.
         */ this.endOfBroadcastWeek = (date)=>{
            return this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(date) : (0, _endOfBroadcastWeekJs.endOfBroadcastWeek)(date, this);
        };
        /**
         * Returns the end of the ISO week for the given date.
         *
         * @param date The original date.
         * @returns The end of the ISO week.
         */ this.endOfISOWeek = (date)=>{
            return this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(date) : (0, _dateFns.endOfISOWeek)(date);
        };
        /**
         * Returns the end of the month for the given date.
         *
         * @param date The original date.
         * @returns The end of the month.
         */ this.endOfMonth = (date)=>{
            return this.overrides?.endOfMonth ? this.overrides.endOfMonth(date) : (0, _dateFns.endOfMonth)(date);
        };
        /**
         * Returns the end of the week for the given date.
         *
         * @param date The original date.
         * @returns The end of the week.
         */ this.endOfWeek = (date, options)=>{
            return this.overrides?.endOfWeek ? this.overrides.endOfWeek(date, options) : (0, _dateFns.endOfWeek)(date, this.options);
        };
        /**
         * Returns the end of the year for the given date.
         *
         * @param date The original date.
         * @returns The end of the year.
         */ this.endOfYear = (date)=>{
            return this.overrides?.endOfYear ? this.overrides.endOfYear(date) : (0, _dateFns.endOfYear)(date);
        };
        /**
         * Formats the given date using the specified format string.
         *
         * @param date The date to format.
         * @param formatStr The format string.
         * @returns The formatted date string.
         */ this.format = (date, formatStr, _options)=>{
            const formatted = this.overrides?.format ? this.overrides.format(date, formatStr, this.options) : (0, _dateFns.format)(date, formatStr, this.options);
            if (this.options.numerals && this.options.numerals !== "latn") return this.replaceDigits(formatted);
            return formatted;
        };
        /**
         * Returns the ISO week number for the given date.
         *
         * @param date The date to get the ISO week number for.
         * @returns The ISO week number.
         */ this.getISOWeek = (date)=>{
            return this.overrides?.getISOWeek ? this.overrides.getISOWeek(date) : (0, _dateFns.getISOWeek)(date);
        };
        /**
         * Returns the month of the given date.
         *
         * @param date The date to get the month for.
         * @returns The month.
         */ this.getMonth = (date, _options)=>{
            return this.overrides?.getMonth ? this.overrides.getMonth(date, this.options) : (0, _dateFns.getMonth)(date, this.options);
        };
        /**
         * Returns the year of the given date.
         *
         * @param date The date to get the year for.
         * @returns The year.
         */ this.getYear = (date, _options)=>{
            return this.overrides?.getYear ? this.overrides.getYear(date, this.options) : (0, _dateFns.getYear)(date, this.options);
        };
        /**
         * Returns the local week number for the given date.
         *
         * @param date The date to get the week number for.
         * @returns The week number.
         */ this.getWeek = (date, _options)=>{
            return this.overrides?.getWeek ? this.overrides.getWeek(date, this.options) : (0, _dateFns.getWeek)(date, this.options);
        };
        /**
         * Checks if the first date is after the second date.
         *
         * @param date The date to compare.
         * @param dateToCompare The date to compare with.
         * @returns True if the first date is after the second date.
         */ this.isAfter = (date, dateToCompare)=>{
            return this.overrides?.isAfter ? this.overrides.isAfter(date, dateToCompare) : (0, _dateFns.isAfter)(date, dateToCompare);
        };
        /**
         * Checks if the first date is before the second date.
         *
         * @param date The date to compare.
         * @param dateToCompare The date to compare with.
         * @returns True if the first date is before the second date.
         */ this.isBefore = (date, dateToCompare)=>{
            return this.overrides?.isBefore ? this.overrides.isBefore(date, dateToCompare) : (0, _dateFns.isBefore)(date, dateToCompare);
        };
        /**
         * Checks if the given value is a Date object.
         *
         * @param value The value to check.
         * @returns True if the value is a Date object.
         */ this.isDate = (value)=>{
            return this.overrides?.isDate ? this.overrides.isDate(value) : (0, _dateFns.isDate)(value);
        };
        /**
         * Checks if the given dates are on the same day.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are on the same day.
         */ this.isSameDay = (dateLeft, dateRight)=>{
            return this.overrides?.isSameDay ? this.overrides.isSameDay(dateLeft, dateRight) : (0, _dateFns.isSameDay)(dateLeft, dateRight);
        };
        /**
         * Checks if the given dates are in the same month.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are in the same month.
         */ this.isSameMonth = (dateLeft, dateRight)=>{
            return this.overrides?.isSameMonth ? this.overrides.isSameMonth(dateLeft, dateRight) : (0, _dateFns.isSameMonth)(dateLeft, dateRight);
        };
        /**
         * Checks if the given dates are in the same year.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are in the same year.
         */ this.isSameYear = (dateLeft, dateRight)=>{
            return this.overrides?.isSameYear ? this.overrides.isSameYear(dateLeft, dateRight) : (0, _dateFns.isSameYear)(dateLeft, dateRight);
        };
        /**
         * Returns the latest date in the given array of dates.
         *
         * @param dates The array of dates to compare.
         * @returns The latest date.
         */ this.max = (dates)=>{
            return this.overrides?.max ? this.overrides.max(dates) : (0, _dateFns.max)(dates);
        };
        /**
         * Returns the earliest date in the given array of dates.
         *
         * @param dates The array of dates to compare.
         * @returns The earliest date.
         */ this.min = (dates)=>{
            return this.overrides?.min ? this.overrides.min(dates) : (0, _dateFns.min)(dates);
        };
        /**
         * Sets the month of the given date.
         *
         * @param date The date to set the month on.
         * @param month The month to set (0-11).
         * @returns The new date with the month set.
         */ this.setMonth = (date, month)=>{
            return this.overrides?.setMonth ? this.overrides.setMonth(date, month) : (0, _dateFns.setMonth)(date, month);
        };
        /**
         * Sets the year of the given date.
         *
         * @param date The date to set the year on.
         * @param year The year to set.
         * @returns The new date with the year set.
         */ this.setYear = (date, year)=>{
            return this.overrides?.setYear ? this.overrides.setYear(date, year) : (0, _dateFns.setYear)(date, year);
        };
        /**
         * Returns the start of the broadcast week for the given date.
         *
         * @param date The original date.
         * @returns The start of the broadcast week.
         */ this.startOfBroadcastWeek = (date, _dateLib)=>{
            return this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(date, this) : (0, _startOfBroadcastWeekJs.startOfBroadcastWeek)(date, this);
        };
        /**
         * Returns the start of the day for the given date.
         *
         * @param date The original date.
         * @returns The start of the day.
         */ this.startOfDay = (date)=>{
            return this.overrides?.startOfDay ? this.overrides.startOfDay(date) : (0, _dateFns.startOfDay)(date);
        };
        /**
         * Returns the start of the ISO week for the given date.
         *
         * @param date The original date.
         * @returns The start of the ISO week.
         */ this.startOfISOWeek = (date)=>{
            return this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(date) : (0, _dateFns.startOfISOWeek)(date);
        };
        /**
         * Returns the start of the month for the given date.
         *
         * @param date The original date.
         * @returns The start of the month.
         */ this.startOfMonth = (date)=>{
            return this.overrides?.startOfMonth ? this.overrides.startOfMonth(date) : (0, _dateFns.startOfMonth)(date);
        };
        /**
         * Returns the start of the week for the given date.
         *
         * @param date The original date.
         * @returns The start of the week.
         */ this.startOfWeek = (date, _options)=>{
            return this.overrides?.startOfWeek ? this.overrides.startOfWeek(date, this.options) : (0, _dateFns.startOfWeek)(date, this.options);
        };
        /**
         * Returns the start of the year for the given date.
         *
         * @param date The original date.
         * @returns The start of the year.
         */ this.startOfYear = (date)=>{
            return this.overrides?.startOfYear ? this.overrides.startOfYear(date) : (0, _dateFns.startOfYear)(date);
        };
        this.options = {
            locale: (0, _enUSJs.enUS),
            ...options
        };
        this.overrides = overrides;
    }
    /**
     * Generates a mapping of Arabic digits (0-9) to the target numbering system
     * digits.
     *
     * @since 9.5.0
     * @returns A record mapping Arabic digits to the target numerals.
     */ getDigitMap() {
        const { numerals = "latn" } = this.options;
        // Use Intl.NumberFormat to create a formatter with the specified numbering system
        const formatter = new Intl.NumberFormat("en-US", {
            numberingSystem: numerals
        });
        // Map Arabic digits (0-9) to the target numerals
        const digitMap = {};
        for(let i = 0; i < 10; i++)digitMap[i.toString()] = formatter.format(i);
        return digitMap;
    }
    /**
     * Replaces Arabic digits in a string with the target numbering system digits.
     *
     * @since 9.5.0
     * @param input The string containing Arabic digits.
     * @returns The string with digits replaced.
     */ replaceDigits(input) {
        const digitMap = this.getDigitMap();
        return input.replace(/\d/g, (digit)=>digitMap[digit] || digit);
    }
    /**
     * Formats a number using the configured numbering system.
     *
     * @since 9.5.0
     * @param value The number to format.
     * @returns The formatted number as a string.
     */ formatNumber(value) {
        return this.replaceDigits(value.toString());
    }
    /**
     * Returns the preferred ordering for month and year labels for the current
     * locale.
     */ getMonthYearOrder() {
        const code = this.options.locale?.code;
        if (!code) return "month-first";
        return DateLib.yearFirstLocales.has(code) ? "year-first" : "month-first";
    }
    /**
     * Formats the month/year pair respecting locale conventions.
     *
     * @since 9.11.0
     */ formatMonthYear(date) {
        const { locale, timeZone, numerals } = this.options;
        const localeCode = locale?.code;
        if (localeCode && DateLib.yearFirstLocales.has(localeCode)) try {
            const intl = new Intl.DateTimeFormat(localeCode, {
                month: "long",
                year: "numeric",
                timeZone,
                numberingSystem: numerals
            });
            const formatted = intl.format(date);
            return formatted;
        } catch  {
        // Fallback to date-fns formatting below.
        }
        const pattern = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
        return this.format(date, pattern);
    }
}
DateLib.yearFirstLocales = new Set([
    "eu",
    "hu",
    "ja",
    "ja-Hira",
    "ja-JP",
    "ko",
    "ko-KR",
    "lt",
    "lt-LT",
    "lv",
    "lv-LV",
    "mn",
    "mn-MN",
    "zh",
    "zh-CN",
    "zh-HK",
    "zh-TW"
]);
const defaultDateLib = new DateLib();
const dateLib = defaultDateLib;

},{"@date-fns/tz":"74xQL","date-fns":[["addDays","32Fge"],["addMonths","iYya5"],["addWeeks","9Slq0"],["addYears","1NNPq"],["differenceInCalendarDays","ivKYP"],["differenceInCalendarMonths","4Ch2a"],["eachMonthOfInterval","5NOo0"],["eachYearOfInterval","hnuit"],["endOfISOWeek","kJedt"],["endOfMonth","fQKZN"],["endOfWeek","8VWkH"],["endOfYear","dk8vr"],["format","fRJCX"],["getISOWeek","7Oeg9"],["getMonth","cAphq"],["getWeek","2yF1t"],["getYear","i4zhB"],["isAfter","78t5J"],["isBefore","5O4PX"],["isDate","czy6j"],["isSameDay","MK3lI"],["isSameMonth","a8Swu"],["isSameYear","eRLmx"],["max","i6SaV"],["min","a9Ajs"],["setMonth","lS6bl"],["setYear","fm7Dk"],["startOfDay","kzSFO"],["startOfISOWeek","ax265"],["startOfMonth","ka2Bu"],["startOfWeek","4YNXK"],["startOfYear","9tVUl"]],"../helpers/endOfBroadcastWeek.js":"2TQSC","../helpers/startOfBroadcastWeek.js":"aQUMK","../locale/en-US.js":"gL8NH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"74xQL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./constants/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var _indexJs1 = require("./date/index.js");
parcelHelpers.exportAll(_indexJs1, exports);
var _miniJs = require("./date/mini.js");
parcelHelpers.exportAll(_miniJs, exports);
var _indexJs2 = require("./tz/index.js");
parcelHelpers.exportAll(_indexJs2, exports);
var _indexJs3 = require("./tzOffset/index.js");
parcelHelpers.exportAll(_indexJs3, exports);
var _indexJs4 = require("./tzScan/index.js");
parcelHelpers.exportAll(_indexJs4, exports);
var _indexJs5 = require("./tzName/index.js");
parcelHelpers.exportAll(_indexJs5, exports);

},{"./constants/index.js":"k5jnK","./date/index.js":"jwEpF","./date/mini.js":"1UFJY","./tz/index.js":"6eqq0","./tzOffset/index.js":"jzbVA","./tzScan/index.js":"gknCn","./tzName/index.js":"9POVs","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"k5jnK":[function(require,module,exports,__globalThis) {
/**
 * The symbol to access the `TZDate`'s function to construct a new instance from
 * the provided value. It helps date-fns to inherit the time zone.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructFromSymbol", ()=>constructFromSymbol);
const constructFromSymbol = Symbol.for("constructDateFrom");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jwEpF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TZDate", ()=>TZDate);
var _indexJs = require("../tzName/index.js");
var _miniJs = require("./mini.js");
class TZDate extends (0, _miniJs.TZDateMini) {
    //#region static
    static tz(tz, ...args) {
        return args.length ? new TZDate(...args, tz) : new TZDate(Date.now(), tz);
    }
    //#endregion
    //#region representation
    toISOString() {
        const [sign, hours, minutes] = this.tzComponents();
        const tz = `${sign}${hours}:${minutes}`;
        return this.internal.toISOString().slice(0, -1) + tz;
    }
    toString() {
        // "Tue Aug 13 2024 07:50:19 GMT+0800 (Singapore Standard Time)";
        return `${this.toDateString()} ${this.toTimeString()}`;
    }
    toDateString() {
        // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
        const [day, date, month, year] = this.internal.toUTCString().split(" ");
        // "Tue Aug 13 2024"
        return `${day?.slice(0, -1)} ${month} ${date} ${year}`;
    }
    toTimeString() {
        // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
        const time = this.internal.toUTCString().split(" ")[4];
        const [sign, hours, minutes] = this.tzComponents();
        // "07:42:23 GMT+0800 (Singapore Standard Time)"
        return `${time} GMT${sign}${hours}${minutes} (${(0, _indexJs.tzName)(this.timeZone, this)})`;
    }
    toLocaleString(locales, options) {
        return Date.prototype.toLocaleString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    toLocaleDateString(locales, options) {
        return Date.prototype.toLocaleDateString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    toLocaleTimeString(locales, options) {
        return Date.prototype.toLocaleTimeString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    //#endregion
    //#region private
    tzComponents() {
        const offset = this.getTimezoneOffset();
        const sign = offset > 0 ? "-" : "+";
        const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
        const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
        return [
            sign,
            hours,
            minutes
        ];
    }
    //#endregion
    withTimeZone(timeZone) {
        return new TZDate(+this, timeZone);
    }
    //#region date-fns integration
    [Symbol.for("constructDateFrom")](date) {
        return new TZDate(+new Date(date), this.timeZone);
    }
}

},{"../tzName/index.js":"9POVs","./mini.js":"1UFJY","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9POVs":[function(require,module,exports,__globalThis) {
/**
 * Time zone name format.
 */ /**
 * The function returns the time zone name for the given date in the specified
 * time zone.
 *
 * It uses the `Intl.DateTimeFormat` API and by default outputs the time zone
 * name in a long format, e.g. "Pacific Standard Time" or
 * "Singapore Standard Time".
 *
 * It is possible to specify the format as the third argument using one of the following options
 *
 * - "short": e.g. "EDT" or "GMT+8".
 * - "long": e.g. "Eastern Daylight Time".
 * - "shortGeneric": e.g. "ET" or "Singapore Time".
 * - "longGeneric": e.g. "Eastern Time" or "Singapore Standard Time".
 *
 * These options correspond to TR35 tokens `z..zzz`, `zzzz`, `v`, and `vvvv` respectively: https://www.unicode.org/reports/tr35/tr35-dates.html#dfst-zone
 *
 * @param timeZone - Time zone name (IANA or UTC offset)
 * @param date - Date object to get the time zone name for
 * @param format - Optional format of the time zone name. Defaults to "long". Can be "short", "long", "shortGeneric", or "longGeneric".
 *
 * @returns Time zone name (e.g. "Singapore Standard Time")
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tzName", ()=>tzName);
function tzName(timeZone, date, format = "long") {
    return new Intl.DateTimeFormat("en-US", {
        // Enforces engine to render the time. Without the option JavaScriptCore omits it.
        hour: "numeric",
        timeZone: timeZone,
        timeZoneName: format
    }).format(date).split(/\s/g) // Format.JS uses non-breaking spaces
    .slice(2) // Skip the hour and AM/PM parts
    .join(" ");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1UFJY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TZDateMini", ()=>TZDateMini);
var _indexJs = require("../tzOffset/index.js");
class TZDateMini extends Date {
    //#region static
    constructor(...args){
        super();
        if (args.length > 1 && typeof args[args.length - 1] === "string") this.timeZone = args.pop();
        this.internal = new Date();
        if (isNaN((0, _indexJs.tzOffset)(this.timeZone, this))) this.setTime(NaN);
        else {
            if (!args.length) this.setTime(Date.now());
            else if (typeof args[0] === "number" && (args.length === 1 || args.length === 2 && typeof args[1] !== "number")) this.setTime(args[0]);
            else if (typeof args[0] === "string") this.setTime(+new Date(args[0]));
            else if (args[0] instanceof Date) this.setTime(+args[0]);
            else {
                this.setTime(+new Date(...args));
                adjustToSystemTZ(this, NaN);
                syncToInternal(this);
            }
        }
    }
    static tz(tz, ...args) {
        return args.length ? new TZDateMini(...args, tz) : new TZDateMini(Date.now(), tz);
    }
    //#endregion
    //#region time zone
    withTimeZone(timeZone) {
        return new TZDateMini(+this, timeZone);
    }
    getTimezoneOffset() {
        const offset = -(0, _indexJs.tzOffset)(this.timeZone, this);
        // Remove the seconds offset
        // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
        return offset > 0 ? Math.floor(offset) : Math.ceil(offset);
    }
    //#endregion
    //#region time
    setTime(time) {
        Date.prototype.setTime.apply(this, arguments);
        syncToInternal(this);
        return +this;
    }
    //#endregion
    //#region date-fns integration
    [Symbol.for("constructDateFrom")](date) {
        return new TZDateMini(+new Date(date), this.timeZone);
    }
}
// Assign getters and setters
const re = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((method)=>{
    if (!re.test(method)) return;
    const utcMethod = method.replace(re, "$1UTC");
    // Filter out methods without UTC counterparts
    if (!TZDateMini.prototype[utcMethod]) return;
    if (method.startsWith("get")) // Delegate to internal date's UTC method
    TZDateMini.prototype[method] = function() {
        return this.internal[utcMethod]();
    };
    else {
        // Assign regular setter
        TZDateMini.prototype[method] = function() {
            Date.prototype[utcMethod].apply(this.internal, arguments);
            syncFromInternal(this);
            return +this;
        };
        // Assign UTC setter
        TZDateMini.prototype[utcMethod] = function() {
            Date.prototype[utcMethod].apply(this, arguments);
            syncToInternal(this);
            return +this;
        };
    }
});
/**
 * Function syncs time to internal date, applying the time zone offset.
 *
 * @param {Date} date - Date to sync
 */ function syncToInternal(date) {
    date.internal.setTime(+date);
    date.internal.setUTCSeconds(date.internal.getUTCSeconds() - Math.round(-(0, _indexJs.tzOffset)(date.timeZone, date) * 60));
}
/**
 * Function syncs the internal date UTC values to the date. It allows to get
 * accurate timestamp value.
 *
 * @param {Date} date - The date to sync
 */ function syncFromInternal(date) {
    // First we transpose the internal values
    Date.prototype.setFullYear.call(date, date.internal.getUTCFullYear(), date.internal.getUTCMonth(), date.internal.getUTCDate());
    Date.prototype.setHours.call(date, date.internal.getUTCHours(), date.internal.getUTCMinutes(), date.internal.getUTCSeconds(), date.internal.getUTCMilliseconds());
    // Now we have to adjust the date to the system time zone
    adjustToSystemTZ(date);
}
/**
 * Function adjusts the date to the system time zone. It uses the time zone
 * differences to calculate the offset and adjust the date.
 *
 * @param {Date} date - Date to adjust
 */ function adjustToSystemTZ(date) {
    // Save the time zone offset before all the adjustments
    const baseOffset = (0, _indexJs.tzOffset)(date.timeZone, date);
    // Remove the seconds offset
    // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
    const offset = baseOffset > 0 ? Math.floor(baseOffset) : Math.ceil(baseOffset);
    //#region System DST adjustment
    // The biggest problem with using the system time zone is that when we create
    // a date from internal values stored in UTC, the system time zone might end
    // up on the DST hour:
    //
    //   $ TZ=America/New_York node
    //   > new Date(2020, 2, 8, 1).toString()
    //   'Sun Mar 08 2020 01:00:00 GMT-0500 (Eastern Standard Time)'
    //   > new Date(2020, 2, 8, 2).toString()
    //   'Sun Mar 08 2020 03:00:00 GMT-0400 (Eastern Daylight Time)'
    //   > new Date(2020, 2, 8, 3).toString()
    //   'Sun Mar 08 2020 03:00:00 GMT-0400 (Eastern Daylight Time)'
    //   > new Date(2020, 2, 8, 4).toString()
    //   'Sun Mar 08 2020 04:00:00 GMT-0400 (Eastern Daylight Time)'
    //
    // Here we get the same hour for both 2 and 3, because the system time zone
    // has DST beginning at 8 March 2020, 2 a.m. and jumps to 3 a.m. So we have
    // to adjust the internal date to reflect that.
    //
    // However we want to adjust only if that's the DST hour the change happenes,
    // not the hour where DST moves to.
    // We calculate the previous hour to see if the time zone offset has changed
    // and we have landed on the DST hour.
    const prevHour = new Date(+date);
    // We use UTC methods here as we don't want to land on the same hour again
    // in case of DST.
    prevHour.setUTCHours(prevHour.getUTCHours() - 1);
    // Calculate if we are on the system DST hour.
    const systemOffset = -new Date(+date).getTimezoneOffset();
    const prevHourSystemOffset = -new Date(+prevHour).getTimezoneOffset();
    const systemDSTChange = systemOffset - prevHourSystemOffset;
    // Detect the DST shift. System DST change will occur both on
    const dstShift = Date.prototype.getHours.apply(date) !== date.internal.getUTCHours();
    // Move the internal date when we are on the system DST hour.
    if (systemDSTChange && dstShift) date.internal.setUTCMinutes(date.internal.getUTCMinutes() + systemDSTChange);
    //#endregion
    //#region System diff adjustment
    // Now we need to adjust the date, since we just applied internal values.
    // We need to calculate the difference between the system and date time zones
    // and apply it to the date.
    const offsetDiff = systemOffset - offset;
    if (offsetDiff) Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetDiff);
    //#endregion
    //#region Seconds System diff adjustment
    const systemDate = new Date(+date);
    // Set the UTC seconds to 0 to isolate the timezone offset in seconds.
    systemDate.setUTCSeconds(0);
    // For negative systemOffset, invert the seconds.
    const systemSecondsOffset = systemOffset > 0 ? systemDate.getSeconds() : (systemDate.getSeconds() - 60) % 60;
    // Calculate the seconds offset based on the timezone offset.
    const secondsOffset = Math.round(-((0, _indexJs.tzOffset)(date.timeZone, date) * 60)) % 60;
    if (secondsOffset || systemSecondsOffset) {
        date.internal.setUTCSeconds(date.internal.getUTCSeconds() + secondsOffset);
        Date.prototype.setUTCSeconds.call(date, Date.prototype.getUTCSeconds.call(date) + secondsOffset + systemSecondsOffset);
    }
    //#endregion
    //#region Post-adjustment DST fix
    const postBaseOffset = (0, _indexJs.tzOffset)(date.timeZone, date);
    // Remove the seconds offset
    // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
    const postOffset = postBaseOffset > 0 ? Math.floor(postBaseOffset) : Math.ceil(postBaseOffset);
    const postSystemOffset = -new Date(+date).getTimezoneOffset();
    const postOffsetDiff = postSystemOffset - postOffset;
    const offsetChanged = postOffset !== offset;
    const postDiff = postOffsetDiff - offsetDiff;
    if (offsetChanged && postDiff) {
        Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + postDiff);
        // Now we need to check if got offset change during the post-adjustment.
        // If so, we also need both dates to reflect that.
        const newBaseOffset = (0, _indexJs.tzOffset)(date.timeZone, date);
        // Remove the seconds offset
        // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
        const newOffset = newBaseOffset > 0 ? Math.floor(newBaseOffset) : Math.ceil(newBaseOffset);
        const offsetChange = postOffset - newOffset;
        if (offsetChange) {
            date.internal.setUTCMinutes(date.internal.getUTCMinutes() + offsetChange);
            Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetChange);
        }
    }
//#endregion
}

},{"../tzOffset/index.js":"jzbVA","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jzbVA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The function extracts UTC offset in minutes from the given date in specified
 * time zone.
 *
 * Unlike `Date.prototype.getTimezoneOffset`, this function returns the value
 * mirrored to the sign of the offset in the time zone. For Asia/Singapore
 * (UTC+8), `tzOffset` returns 480, while `getTimezoneOffset` returns -480.
 *
 * @param timeZone - Time zone name (IANA or UTC offset)
 * @param date - Date to check the offset for
 *
 * @returns UTC offset in minutes
 */ parcelHelpers.export(exports, "tzOffset", ()=>tzOffset);
const offsetFormatCache = {};
const offsetCache = {};
function tzOffset(timeZone, date) {
    try {
        const format = offsetFormatCache[timeZone] ||= new Intl.DateTimeFormat("en-US", {
            timeZone,
            timeZoneName: "longOffset"
        }).format;
        const offsetStr = format(date).split("GMT")[1];
        if (offsetStr in offsetCache) return offsetCache[offsetStr];
        return calcOffset(offsetStr, offsetStr.split(":"));
    } catch  {
        // Fallback to manual parsing if the runtime doesn't support ±HH:MM/±HHMM/±HH
        // See: https://github.com/nodejs/node/issues/53419
        if (timeZone in offsetCache) return offsetCache[timeZone];
        const captures = timeZone?.match(offsetRe);
        if (captures) return calcOffset(timeZone, captures.slice(1));
        return NaN;
    }
}
const offsetRe = /([+-]\d\d):?(\d\d)?/;
function calcOffset(cacheStr, values) {
    const hours = +(values[0] || 0);
    const minutes = +(values[1] || 0);
    // Convert seconds to minutes by dividing by 60 to keep the function return in minutes.
    const seconds = +(values[2] || 0) / 60;
    return offsetCache[cacheStr] = hours * 60 + minutes > 0 ? hours * 60 + minutes + seconds : hours * 60 - minutes - seconds;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6eqq0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tz", ()=>tz);
var _indexJs = require("../date/index.js");
const tz = (timeZone)=>(value)=>(0, _indexJs.TZDate).tz(timeZone, +new Date(value));

},{"../date/index.js":"jwEpF","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gknCn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Time interval.
 */ /**
 * Time zone change record.
 */ /**
 * The function scans the time zone for changes in the given interval.
 *
 * @param timeZone - Time zone name (IANA or UTC offset)
 * @param interval - Time interval to scan for changes
 *
 * @returns Array of time zone changes
 */ parcelHelpers.export(exports, "tzScan", ()=>tzScan);
var _indexJs = require("../tzOffset/index.js");
function tzScan(timeZone, interval) {
    const changes = [];
    const monthDate = new Date(interval.start);
    monthDate.setUTCSeconds(0, 0);
    const endDate = new Date(interval.end);
    endDate.setUTCSeconds(0, 0);
    const endMonthTime = +endDate;
    let lastOffset = (0, _indexJs.tzOffset)(timeZone, monthDate);
    while(+monthDate < endMonthTime){
        // Month forward
        monthDate.setUTCMonth(monthDate.getUTCMonth() + 1);
        // Find the month where the offset changes
        const offset = (0, _indexJs.tzOffset)(timeZone, monthDate);
        if (offset != lastOffset) {
            // Rewind a month back to find the day where the offset changes
            const dayDate = new Date(monthDate);
            dayDate.setUTCMonth(dayDate.getUTCMonth() - 1);
            const endDayTime = +monthDate;
            lastOffset = (0, _indexJs.tzOffset)(timeZone, dayDate);
            while(+dayDate < endDayTime){
                // Day forward
                dayDate.setUTCDate(dayDate.getUTCDate() + 1);
                // Find the day where the offset changes
                const offset = (0, _indexJs.tzOffset)(timeZone, dayDate);
                if (offset != lastOffset) {
                    // Rewind a day back to find the time where the offset changes
                    const hourDate = new Date(dayDate);
                    hourDate.setUTCDate(hourDate.getUTCDate() - 1);
                    const endHourTime = +dayDate;
                    lastOffset = (0, _indexJs.tzOffset)(timeZone, hourDate);
                    while(+hourDate < endHourTime){
                        // Hour forward
                        hourDate.setUTCHours(hourDate.getUTCHours() + 1);
                        // Find the hour where the offset changes
                        const hourOffset = (0, _indexJs.tzOffset)(timeZone, hourDate);
                        if (hourOffset !== lastOffset) changes.push({
                            date: new Date(hourDate),
                            change: hourOffset - lastOffset,
                            offset: hourOffset
                        });
                        lastOffset = hourOffset;
                    }
                }
                lastOffset = offset;
            }
        }
        lastOffset = offset;
    }
    return changes;
}

},{"../tzOffset/index.js":"jzbVA","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"32Fge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addDays} function options.
 */ /**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * **You don't need date-fns\***:
 *
 * Temporal has a built-in `add` method on all its classes:
 *
 * - [`Temporal.Instant.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/Instant/add)
 * - [`Temporal.PlainDate.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainDate/add)
 * - [`Temporal.PlainDateTime.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainDateTime/add)
 * - [`Temporal.PlainTime.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainTime/add)
 * - [`Temporal.PlainYearMonth.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainYearMonth/add)
 * - [`Temporal.ZonedDateTime.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/ZonedDateTime/add)
 *
 * \* **Not really**, see: https://date-fns.org/you-dont-need-date-fns
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 * @param options - An object with options
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 *
 * @example
 * // Using Temporal:
 * // Add 10 days to 1 September 2014:
 * Temporal.PlainDate.from("2014-09-01").add({ days: 10 }).toString();
 * //=> "2014-09-11"
 */ parcelHelpers.export(exports, "addDays", ()=>addDays);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function addDays(date, amount, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    if (isNaN(amount)) return (0, _constructFromJs.constructFrom)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

},{"./constructFrom.js":"cqn5W","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cqn5W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * Starting from v3.7.0, it allows to construct a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from "./constructFrom/date-fns";
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date>(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use constructor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   );
 * }
 */ parcelHelpers.export(exports, "constructFrom", ()=>constructFrom);
var _constantsJs = require("./constants.js");
function constructFrom(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, _constantsJs.constructFromSymbol) in date) return date[0, _constantsJs.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}

},{"./constants.js":"8HlEe","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8HlEe":[function(require,module,exports,__globalThis) {
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "millisecondsInWeek", ()=>millisecondsInWeek);
parcelHelpers.export(exports, "millisecondsInDay", ()=>millisecondsInDay);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minutesInYear", ()=>minutesInYear);
parcelHelpers.export(exports, "minutesInMonth", ()=>minutesInMonth);
parcelHelpers.export(exports, "minutesInDay", ()=>minutesInDay);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
parcelHelpers.export(exports, "constructFromSymbol", ()=>constructFromSymbol);
const daysInWeek = 7;
const daysInYear = 365.2425;
const maxTime = Math.pow(10, 8) * 86400000;
const minTime = -maxTime;
const millisecondsInWeek = 604800000;
const millisecondsInDay = 86400000;
const millisecondsInMinute = 60000;
const millisecondsInHour = 3600000;
const millisecondsInSecond = 1000;
const minutesInYear = 525600;
const minutesInMonth = 43200;
const minutesInDay = 1440;
const minutesInHour = 60;
const monthsInQuarter = 3;
const monthsInYear = 12;
const quartersInYear = 4;
const secondsInHour = 3600;
const secondsInMinute = 60;
const secondsInDay = secondsInHour * 24;
const secondsInWeek = secondsInDay * 7;
const secondsInYear = secondsInDay * daysInYear;
const secondsInMonth = secondsInYear / 12;
const secondsInQuarter = secondsInMonth * 3;
const constructFromSymbol = Symbol.for("constructDateFrom");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"XfO4L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * Starting from v3.7.0, it clones a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ parcelHelpers.export(exports, "toDate", ()=>toDate);
var _constructFromJs = require("./constructFrom.js");
function toDate(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, _constructFromJs.constructFrom)(context || argument, argument);
}

},{"./constructFrom.js":"cqn5W","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iYya5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addMonths} function options.
 */ /**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * **You don't need date-fns\***:
 *
 * Temporal has a built-in `add` method on all its classes:
 *
 * - [`Temporal.Instant.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/Instant/add)
 * - [`Temporal.PlainDate.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainDate/add)
 * - [`Temporal.PlainDateTime.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainDateTime/add)
 * - [`Temporal.PlainTime.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainTime/add)
 * - [`Temporal.PlainYearMonth.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainYearMonth/add)
 * - [`Temporal.ZonedDateTime.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/ZonedDateTime/add)
 *
 * \* **Not really**, see: https://date-fns.org/you-dont-need-date-fns
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 * @param options - The options object
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 *
 * @example
 * // Using Temporal:
 * // Add 5 months to 1 September 2014:
 * Temporal.PlainDate.from("2014-09-01")
 *   .add({ months: 5 })
 *   .toString();
 * //=> "2015-02-01"
 */ parcelHelpers.export(exports, "addMonths", ()=>addMonths);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function addMonths(date, amount, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    if (isNaN(amount)) return (0, _constructFromJs.constructFrom)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, _constructFromJs.constructFrom)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

},{"./constructFrom.js":"cqn5W","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9Slq0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addWeeks} function options.
 */ /**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of weeks to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 * @param options - An object with options
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ parcelHelpers.export(exports, "addWeeks", ()=>addWeeks);
var _addDaysJs = require("./addDays.js");
function addWeeks(date, amount, options) {
    return (0, _addDaysJs.addDays)(date, amount * 7, options);
}

},{"./addDays.js":"32Fge","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1NNPq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addYears} function options.
 */ /**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type.
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 * @param options - The options
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ parcelHelpers.export(exports, "addYears", ()=>addYears);
var _addMonthsJs = require("./addMonths.js");
function addYears(date, amount, options) {
    return (0, _addMonthsJs.addMonths)(date, amount * 12, options);
}

},{"./addMonths.js":"iYya5","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ivKYP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInCalendarDays} function options.
 */ /**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - The options object
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ parcelHelpers.export(exports, "differenceInCalendarDays", ()=>differenceInCalendarDays);
var _getTimezoneOffsetInMillisecondsJs = require("./_lib/getTimezoneOffsetInMilliseconds.js");
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
var _constantsJs = require("./constants.js");
var _startOfDayJs = require("./startOfDay.js");
function differenceInCalendarDays(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, _startOfDayJs.startOfDay)(laterDate_);
    const earlierStartOfDay = (0, _startOfDayJs.startOfDay)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, _constantsJs.millisecondsInDay));
}

},{"./_lib/getTimezoneOffsetInMilliseconds.js":"c3Ogi","./_lib/normalizeDates.js":"dmbhG","./constants.js":"8HlEe","./startOfDay.js":"kzSFO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"c3Ogi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ parcelHelpers.export(exports, "getTimezoneOffsetInMilliseconds", ()=>getTimezoneOffsetInMilliseconds);
var _toDateJs = require("../toDate.js");
function getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, _toDateJs.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

},{"../toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dmbhG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeDates", ()=>normalizeDates);
var _constructFromJs = require("../constructFrom.js");
function normalizeDates(context, ...dates) {
    const normalize = (0, _constructFromJs.constructFrom).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}

},{"../constructFrom.js":"cqn5W","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kzSFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfDay} function options.
 */ /**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfDay", ()=>startOfDay);
var _toDateJs = require("./toDate.js");
function startOfDay(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4Ch2a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInCalendarMonths} function options.
 */ /**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - An object with options
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ parcelHelpers.export(exports, "differenceInCalendarMonths", ()=>differenceInCalendarMonths);
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
function differenceInCalendarMonths(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}

},{"./_lib/normalizeDates.js":"dmbhG","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5NOo0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * The {@link eachMonthOfInterval} function result type. It resolves the proper data type.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam IntervalType - Interval type.
 * @typeParam Options - Options type.
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachMonthOfInterval", ()=>eachMonthOfInterval);
var _normalizeIntervalJs = require("./_lib/normalizeInterval.js");
var _constructFromJs = require("./constructFrom.js");
function eachMonthOfInterval(interval, options) {
    const { start, end } = (0, _normalizeIntervalJs.normalizeInterval)(options?.in, interval);
    let reversed = +start > +end;
    const endTime = reversed ? +start : +end;
    const date = reversed ? end : start;
    date.setHours(0, 0, 0, 0);
    date.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+date <= endTime){
        dates.push((0, _constructFromJs.constructFrom)(start, date));
        date.setMonth(date.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}

},{"./_lib/normalizeInterval.js":"2ezTb","./constructFrom.js":"cqn5W","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2ezTb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeInterval", ()=>normalizeInterval);
var _normalizeDatesJs = require("./normalizeDates.js");
function normalizeInterval(context, interval) {
    const [start, end] = (0, _normalizeDatesJs.normalizeDates)(context, interval.start, interval.end);
    return {
        start,
        end
    };
}

},{"./normalizeDates.js":"dmbhG","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hnuit":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * The {@link eachYearOfInterval} function result type. It resolves the proper data type.
 * It uses the first argument date object type, starting from the date argument,
 * then the start interval date, and finally the end interval date. If
 * a context function is passed, it uses the context function return type.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam IntervalType - Interval type.
 * @typeParam Options - Options type.
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachYearOfInterval", ()=>eachYearOfInterval);
var _normalizeIntervalJs = require("./_lib/normalizeInterval.js");
var _constructFromJs = require("./constructFrom.js");
function eachYearOfInterval(interval, options) {
    const { start, end } = (0, _normalizeIntervalJs.normalizeInterval)(options?.in, interval);
    let reversed = +start > +end;
    const endTime = reversed ? +start : +end;
    const date = reversed ? end : start;
    date.setHours(0, 0, 0, 0);
    date.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+date <= endTime){
        dates.push((0, _constructFromJs.constructFrom)(start, date));
        date.setFullYear(date.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}

},{"./_lib/normalizeInterval.js":"2ezTb","./constructFrom.js":"cqn5W","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kJedt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfISOWeek} function options.
 */ /**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfISOWeek", ()=>endOfISOWeek);
var _endOfWeekJs = require("./endOfWeek.js");
function endOfISOWeek(date, options) {
    return (0, _endOfWeekJs.endOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}

},{"./endOfWeek.js":"8VWkH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8VWkH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfWeek", ()=>endOfWeek);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _toDateJs = require("./toDate.js");
function endOfWeek(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"./_lib/defaultOptions.js":"iO9fT","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iO9fT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
let defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fQKZN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfMonth} function options.
 */ /**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfMonth", ()=>endOfMonth);
var _toDateJs = require("./toDate.js");
function endOfMonth(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dk8vr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfYear} function options.
 */ /**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfYear", ()=>endOfYear);
var _toDateJs = require("./toDate.js");
function endOfYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fRJCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
parcelHelpers.export(exports, "formatters", ()=>(0, _formattersJs.formatters));
parcelHelpers.export(exports, "longFormatters", ()=>(0, _longFormattersJs.longFormatters));
parcelHelpers.export(exports, "formatDate", ()=>format);
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ parcelHelpers.export(exports, "format", ()=>format);
var _defaultLocaleJs = require("./_lib/defaultLocale.js");
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _formattersJs = require("./_lib/format/formatters.js");
var _longFormattersJs = require("./_lib/format/longFormatters.js");
var _protectedTokensJs = require("./_lib/protectedTokens.js");
var _isValidJs = require("./isValid.js");
var _toDateJs = require("./toDate.js");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleJs.defaultLocale);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, _toDateJs.toDate)(date, options?.in);
    if (!(0, _isValidJs.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match(longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, _longFormattersJs.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: cleanEscapedString(substring)
        };
        if ((0, _formattersJs.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate,
        weekStartsOn,
        locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, _protectedTokensJs.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, _protectedTokensJs.isProtectedDayOfYearToken)(token)) (0, _protectedTokensJs.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, _formattersJs.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function cleanEscapedString(input) {
    const matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"./_lib/defaultLocale.js":[["defaultLocale","lB9VR","enUS"]],"./_lib/defaultOptions.js":"iO9fT","./_lib/format/formatters.js":"igdi4","./_lib/format/longFormatters.js":"9ByIC","./_lib/protectedTokens.js":"iNkFV","./isValid.js":"jJbBG","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lB9VR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enUS", ()=>enUS);
var _formatDistanceJs = require("./en-US/_lib/formatDistance.js");
var _formatLongJs = require("./en-US/_lib/formatLong.js");
var _formatRelativeJs = require("./en-US/_lib/formatRelative.js");
var _localizeJs = require("./en-US/_lib/localize.js");
var _matchJs = require("./en-US/_lib/match.js");
const enUS = {
    code: "en-US",
    formatDistance: (0, _formatDistanceJs.formatDistance),
    formatLong: (0, _formatLongJs.formatLong),
    formatRelative: (0, _formatRelativeJs.formatRelative),
    localize: (0, _localizeJs.localize),
    match: (0, _matchJs.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

},{"./en-US/_lib/formatDistance.js":"8ODgb","./en-US/_lib/formatLong.js":"ekidZ","./en-US/_lib/formatRelative.js":"2tOqE","./en-US/_lib/localize.js":"kMLUM","./en-US/_lib/match.js":"cbHtq","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8ODgb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDistance", ()=>formatDistance);
const formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ekidZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatLong", ()=>formatLong);
var _buildFormatLongFnJs = require("../../_lib/buildFormatLongFn.js");
const dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const formatLong = {
    date: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};

},{"../../_lib/buildFormatLongFn.js":"ahsfl","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ahsfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildFormatLongFn", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2tOqE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelative", ()=>formatRelative);
const formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const formatRelative = (token, _date, _baseDate, _options)=>formatRelativeLocale[token];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kMLUM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localize", ()=>localize);
var _buildLocalizeFnJs = require("../../_lib/buildLocalizeFn.js");
const eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const localize = {
    ordinalNumber,
    era: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

},{"../../_lib/buildLocalizeFn.js":"8JEwm","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8JEwm":[function(require,module,exports,__globalThis) {
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildLocalizeFn", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cbHtq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "match", ()=>match);
var _buildMatchFnJs = require("../../_lib/buildMatchFn.js");
var _buildMatchPatternFnJs = require("../../_lib/buildMatchPatternFn.js");
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const match = {
    ordinalNumber: (0, _buildMatchPatternFnJs.buildMatchPatternFn)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

},{"../../_lib/buildMatchFn.js":"5pEA8","../../_lib/buildMatchPatternFn.js":"jWvnk","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5pEA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchFn", ()=>buildMatchFn);
function buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}
function findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jWvnk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchPatternFn", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"igdi4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatters", ()=>formatters);
var _getDayOfYearJs = require("../../getDayOfYear.js");
var _getISOWeekJs = require("../../getISOWeek.js");
var _getISOWeekYearJs = require("../../getISOWeekYear.js");
var _getWeekJs = require("../../getWeek.js");
var _getWeekYearJs = require("../../getWeekYear.js");
var _addLeadingZerosJs = require("../addLeadingZeros.js");
var _lightFormattersJs = require("./lightFormatters.js");
const dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const formatters = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _lightFormattersJs.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, _getWeekYearJs.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, _addLeadingZerosJs.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _addLeadingZerosJs.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, _getISOWeekYearJs.getISOWeekYear)(date);
        // Padding
        return (0, _addLeadingZerosJs.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, _addLeadingZerosJs.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _addLeadingZerosJs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _addLeadingZerosJs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _lightFormattersJs.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _addLeadingZerosJs.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, _getWeekJs.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, _getISOWeekJs.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, _lightFormattersJs.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, _getDayOfYearJs.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _addLeadingZerosJs.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _addLeadingZerosJs.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _addLeadingZerosJs.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _lightFormattersJs.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, _lightFormattersJs.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, _lightFormattersJs.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, _lightFormattersJs.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, _lightFormattersJs.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, _addLeadingZerosJs.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(+date, token.length);
    }
};
function formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, _addLeadingZerosJs.addLeadingZeros)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, _addLeadingZerosJs.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, _addLeadingZerosJs.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, _addLeadingZerosJs.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

},{"../../getDayOfYear.js":"kNSrj","../../getISOWeek.js":"7Oeg9","../../getISOWeekYear.js":"8pO6H","../../getWeek.js":"2yF1t","../../getWeekYear.js":"jnG0R","../addLeadingZeros.js":"gfWoA","./lightFormatters.js":"8AKzW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kNSrj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getDayOfYear} function options.
 */ /**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ parcelHelpers.export(exports, "getDayOfYear", ()=>getDayOfYear);
var _differenceInCalendarDaysJs = require("./differenceInCalendarDays.js");
var _startOfYearJs = require("./startOfYear.js");
var _toDateJs = require("./toDate.js");
function getDayOfYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = (0, _differenceInCalendarDaysJs.differenceInCalendarDays)(_date, (0, _startOfYearJs.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

},{"./differenceInCalendarDays.js":"ivKYP","./startOfYear.js":"9tVUl","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9tVUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfYear} function options.
 */ /**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfYear", ()=>startOfYear);
var _toDateJs = require("./toDate.js");
function startOfYear(date, options) {
    const date_ = (0, _toDateJs.toDate)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}

},{"./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7Oeg9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getISOWeek} function options.
 */ /**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ parcelHelpers.export(exports, "getISOWeek", ()=>getISOWeek);
var _constantsJs = require("./constants.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
var _startOfISOWeekYearJs = require("./startOfISOWeekYear.js");
var _toDateJs = require("./toDate.js");
function getISOWeek(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = +(0, _startOfISOWeekJs.startOfISOWeek)(_date) - +(0, _startOfISOWeekYearJs.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsJs.millisecondsInWeek)) + 1;
}

},{"./constants.js":"8HlEe","./startOfISOWeek.js":"ax265","./startOfISOWeekYear.js":"9vAgO","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ax265":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfISOWeek} function options.
 */ /**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeek", ()=>startOfISOWeek);
var _startOfWeekJs = require("./startOfWeek.js");
function startOfISOWeek(date, options) {
    return (0, _startOfWeekJs.startOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}

},{"./startOfWeek.js":"4YNXK","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4YNXK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfWeek", ()=>startOfWeek);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _toDateJs = require("./toDate.js");
function startOfWeek(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"./_lib/defaultOptions.js":"iO9fT","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9vAgO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfISOWeekYear} function options.
 */ /**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeekYear", ()=>startOfISOWeekYear);
var _constructFromJs = require("./constructFrom.js");
var _getISOWeekYearJs = require("./getISOWeekYear.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
function startOfISOWeekYear(date, options) {
    const year = (0, _getISOWeekYearJs.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuary);
}

},{"./constructFrom.js":"cqn5W","./getISOWeekYear.js":"8pO6H","./startOfISOWeek.js":"ax265","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8pO6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getISOWeekYear} function options.
 */ /**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ parcelHelpers.export(exports, "getISOWeekYear", ()=>getISOWeekYear);
var _constructFromJs = require("./constructFrom.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
var _toDateJs = require("./toDate.js");
function getISOWeekYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, _constructFromJs.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, _constructFromJs.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"./constructFrom.js":"cqn5W","./startOfISOWeek.js":"ax265","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2yF1t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ parcelHelpers.export(exports, "getWeek", ()=>getWeek);
var _constantsJs = require("./constants.js");
var _startOfWeekJs = require("./startOfWeek.js");
var _startOfWeekYearJs = require("./startOfWeekYear.js");
var _toDateJs = require("./toDate.js");
function getWeek(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = +(0, _startOfWeekJs.startOfWeek)(_date, options) - +(0, _startOfWeekYearJs.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsJs.millisecondsInWeek)) + 1;
}

},{"./constants.js":"8HlEe","./startOfWeek.js":"4YNXK","./startOfWeekYear.js":"aGI2V","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aGI2V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfWeekYear", ()=>startOfWeekYear);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _constructFromJs = require("./constructFrom.js");
var _getWeekYearJs = require("./getWeekYear.js");
var _startOfWeekJs = require("./startOfWeek.js");
function startOfWeekYear(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, _getWeekYearJs.getWeekYear)(date, options);
    const firstWeek = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, _startOfWeekJs.startOfWeek)(firstWeek, options);
    return _date;
}

},{"./_lib/defaultOptions.js":"iO9fT","./constructFrom.js":"cqn5W","./getWeekYear.js":"jnG0R","./startOfWeek.js":"4YNXK","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jnG0R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ parcelHelpers.export(exports, "getWeekYear", ()=>getWeekYear);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _constructFromJs = require("./constructFrom.js");
var _startOfWeekJs = require("./startOfWeek.js");
var _toDateJs = require("./toDate.js");
function getWeekYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _startOfWeekJs.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _startOfWeekJs.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}

},{"./_lib/defaultOptions.js":"iO9fT","./constructFrom.js":"cqn5W","./startOfWeek.js":"4YNXK","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gfWoA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLeadingZeros", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8AKzW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lightFormatters", ()=>lightFormatters);
var _addLeadingZerosJs = require("../addLeadingZeros.js");
const lightFormatters = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _addLeadingZerosJs.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, _addLeadingZerosJs.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _addLeadingZerosJs.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

},{"../addLeadingZeros.js":"gfWoA","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9ByIC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "longFormatters", ()=>longFormatters);
const dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
const longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iNkFV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "warnOrThrowProtectedError", ()=>warnOrThrowProtectedError);
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
    return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
    const _message = message(token, format, input);
    console.warn(_message);
    if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jJbBG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertible into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ parcelHelpers.export(exports, "isValid", ()=>isValid);
var _isDateJs = require("./isDate.js");
var _toDateJs = require("./toDate.js");
function isValid(date) {
    return !(!(0, _isDateJs.isDate)(date) && typeof date !== "number" || isNaN(+(0, _toDateJs.toDate)(date)));
}

},{"./isDate.js":"czy6j","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"czy6j":[function(require,module,exports,__globalThis) {
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDate", ()=>isDate);
function isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cAphq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getMonth} function options.
 */ /**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ parcelHelpers.export(exports, "getMonth", ()=>getMonth);
var _toDateJs = require("./toDate.js");
function getMonth(date, options) {
    return (0, _toDateJs.toDate)(date, options?.in).getMonth();
}

},{"./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i4zhB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getYear} function options.
 */ /**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ parcelHelpers.export(exports, "getYear", ()=>getYear);
var _toDateJs = require("./toDate.js");
function getYear(date, options) {
    return (0, _toDateJs.toDate)(date, options?.in).getFullYear();
}

},{"./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"78t5J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ parcelHelpers.export(exports, "isAfter", ()=>isAfter);
var _toDateJs = require("./toDate.js");
function isAfter(date, dateToCompare) {
    return +(0, _toDateJs.toDate)(date) > +(0, _toDateJs.toDate)(dateToCompare);
}

},{"./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5O4PX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ parcelHelpers.export(exports, "isBefore", ()=>isBefore);
var _toDateJs = require("./toDate.js");
function isBefore(date, dateToCompare) {
    return +(0, _toDateJs.toDate)(date) < +(0, _toDateJs.toDate)(dateToCompare);
}

},{"./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"MK3lI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isSameDay} function options.
 */ /**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param laterDate - The first date to check
 * @param earlierDate - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ parcelHelpers.export(exports, "isSameDay", ()=>isSameDay);
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
var _startOfDayJs = require("./startOfDay.js");
function isSameDay(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    return +(0, _startOfDayJs.startOfDay)(dateLeft_) === +(0, _startOfDayJs.startOfDay)(dateRight_);
}

},{"./_lib/normalizeDates.js":"dmbhG","./startOfDay.js":"kzSFO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"a8Swu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isSameMonth} function options.
 */ /**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param laterDate - The first date to check
 * @param earlierDate - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ parcelHelpers.export(exports, "isSameMonth", ()=>isSameMonth);
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
function isSameMonth(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}

},{"./_lib/normalizeDates.js":"dmbhG","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eRLmx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isSameYear} function options.
 */ /**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param laterDate - The first date to check
 * @param earlierDate - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ parcelHelpers.export(exports, "isSameYear", ()=>isSameYear);
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
function isSameYear(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}

},{"./_lib/normalizeDates.js":"dmbhG","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i6SaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link max} function options.
 */ /**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ parcelHelpers.export(exports, "max", ()=>max);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function max(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, _constructFromJs.constructFrom).bind(null, date);
        const date_ = (0, _toDateJs.toDate)(date, context);
        if (!result || result < date_ || isNaN(+date_)) result = date_;
    });
    return (0, _constructFromJs.constructFrom)(context, result || NaN);
}

},{"./constructFrom.js":"cqn5W","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"a9Ajs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link min} function options.
 */ /**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ parcelHelpers.export(exports, "min", ()=>min);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function min(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, _constructFromJs.constructFrom).bind(null, date);
        const date_ = (0, _toDateJs.toDate)(date, context);
        if (!result || result > date_ || isNaN(+date_)) result = date_;
    });
    return (0, _constructFromJs.constructFrom)(context, result || NaN);
}

},{"./constructFrom.js":"cqn5W","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lS6bl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setMonth} function options.
 */ /**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 * @param options - The options
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ parcelHelpers.export(exports, "setMonth", ()=>setMonth);
var _constructFromJs = require("./constructFrom.js");
var _getDaysInMonthJs = require("./getDaysInMonth.js");
var _toDateJs = require("./toDate.js");
function setMonth(date, month, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const midMonth = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    midMonth.setFullYear(year, month, 15);
    midMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, _getDaysInMonthJs.getDaysInMonth)(midMonth);
    // Set the earlier date, allows to wrap Jan 31 to Feb 28
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

},{"./constructFrom.js":"cqn5W","./getDaysInMonth.js":"cFlni","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cFlni":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getDaysInMonth} function options.
 */ /**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date, considering the context if provided.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ parcelHelpers.export(exports, "getDaysInMonth", ()=>getDaysInMonth);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function getDaysInMonth(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, _constructFromJs.constructFrom)(_date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"./constructFrom.js":"cqn5W","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fm7Dk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setYear} function options.
 */ /**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ parcelHelpers.export(exports, "setYear", ()=>setYear);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function setYear(date, year, options) {
    const date_ = (0, _toDateJs.toDate)(date, options?.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+date_)) return (0, _constructFromJs.constructFrom)(options?.in || date, NaN);
    date_.setFullYear(year);
    return date_;
}

},{"./constructFrom.js":"cqn5W","./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ka2Bu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfMonth} function options.
 */ /**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date. The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments.
 * Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed,
 * or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfMonth", ()=>startOfMonth);
var _toDateJs = require("./toDate.js");
function startOfMonth(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"./toDate.js":"XfO4L","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2TQSC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the end date of the week in the broadcast calendar.
 *
 * The broadcast week ends on the last day of the last broadcast week for the
 * given date.
 *
 * @since 9.4.0
 * @param date The date for which to calculate the end of the broadcast week.
 * @param dateLib The date library to use for date manipulation.
 * @returns The end date of the broadcast week.
 */ parcelHelpers.export(exports, "endOfBroadcastWeek", ()=>endOfBroadcastWeek);
var _getBroadcastWeeksInMonthJs = require("./getBroadcastWeeksInMonth.js");
var _startOfBroadcastWeekJs = require("./startOfBroadcastWeek.js");
function endOfBroadcastWeek(date, dateLib) {
    const startDate = (0, _startOfBroadcastWeekJs.startOfBroadcastWeek)(date, dateLib);
    const numberOfWeeks = (0, _getBroadcastWeeksInMonthJs.getBroadcastWeeksInMonth)(date, dateLib);
    const endDate = dateLib.addDays(startDate, numberOfWeeks * 7 - 1);
    return endDate;
}

},{"./getBroadcastWeeksInMonth.js":"lvLgC","./startOfBroadcastWeek.js":"aQUMK","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lvLgC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the number of weeks to display in the broadcast calendar for a given
 * month.
 *
 * The broadcast calendar may have either 4 or 5 weeks in a month, depending on
 * the start and end dates of the broadcast weeks.
 *
 * @since 9.4.0
 * @param month The month for which to calculate the number of weeks.
 * @param dateLib The date library to use for date manipulation.
 * @returns The number of weeks in the broadcast calendar (4 or 5).
 */ parcelHelpers.export(exports, "getBroadcastWeeksInMonth", ()=>getBroadcastWeeksInMonth);
const FIVE_WEEKS = 5;
const FOUR_WEEKS = 4;
function getBroadcastWeeksInMonth(month, dateLib) {
    // Get the first day of the month
    const firstDayOfMonth = dateLib.startOfMonth(month);
    // Get the day of the week for the first day of the month (1-7, where 1 is Monday)
    const firstDayOfWeek = firstDayOfMonth.getDay() > 0 ? firstDayOfMonth.getDay() : 7;
    const broadcastStartDate = dateLib.addDays(month, -firstDayOfWeek + 1);
    const lastDateOfLastWeek = dateLib.addDays(broadcastStartDate, FIVE_WEEKS * 7 - 1);
    const numberOfWeeks = dateLib.getMonth(month) === dateLib.getMonth(lastDateOfLastWeek) ? FIVE_WEEKS : FOUR_WEEKS;
    return numberOfWeeks;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aQUMK":[function(require,module,exports,__globalThis) {
/**
 * Returns the start date of the week in the broadcast calendar.
 *
 * The broadcast week starts on Monday. If the first day of the month is not a
 * Monday, this function calculates the previous Monday as the start of the
 * broadcast week.
 *
 * @since 9.4.0
 * @param date The date for which to calculate the start of the broadcast week.
 * @param dateLib The date library to use for date manipulation.
 * @returns The start date of the broadcast week.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startOfBroadcastWeek", ()=>startOfBroadcastWeek);
function startOfBroadcastWeek(date, dateLib) {
    const firstOfMonth = dateLib.startOfMonth(date);
    const dayOfWeek = firstOfMonth.getDay();
    if (dayOfWeek === 1) return firstOfMonth;
    else if (dayOfWeek === 0) return dateLib.addDays(firstOfMonth, -6);
    else return dateLib.addDays(firstOfMonth, -1 * (dayOfWeek - 1));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gL8NH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enUS", ()=>enUS);
var _dateFns = require("date-fns");
var _locale = require("date-fns/locale");
const enUS = {
    ...(0, _locale.enUS),
    labels: {
        labelDayButton: (date, modifiers, options, dateLib)=>{
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") formatDate = dateLib.format.bind(dateLib);
            else formatDate = (d, pattern)=>(0, _dateFns.format)(d, pattern, {
                    locale: (0, _locale.enUS),
                    ...options
                });
            let label = formatDate(date, "PPPP");
            if (modifiers.today) label = `Today, ${label}`;
            if (modifiers.selected) label = `${label}, selected`;
            return label;
        },
        labelMonthDropdown: "Choose the Month",
        labelNext: "Go to the Next Month",
        labelPrevious: "Go to the Previous Month",
        labelWeekNumber: (weekNumber)=>`Week ${weekNumber}`,
        labelYearDropdown: "Choose the Year",
        labelGrid: (date, options, dateLib)=>{
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") formatDate = dateLib.format.bind(dateLib);
            else formatDate = (d, pattern)=>(0, _dateFns.format)(d, pattern, {
                    locale: (0, _locale.enUS),
                    ...options
                });
            return formatDate(date, "LLLL yyyy");
        },
        labelGridcell: (date, modifiers, options, dateLib)=>{
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") formatDate = dateLib.format.bind(dateLib);
            else formatDate = (d, pattern)=>(0, _dateFns.format)(d, pattern, {
                    locale: (0, _locale.enUS),
                    ...options
                });
            let label = formatDate(date, "PPPP");
            if (modifiers?.today) label = `Today, ${label}`;
            return label;
        },
        labelNav: "Navigation bar",
        labelWeekNumberHeader: "Week Number",
        labelWeekday: (date, options, dateLib)=>{
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") formatDate = dateLib.format.bind(dateLib);
            else formatDate = (d, pattern)=>(0, _dateFns.format)(d, pattern, {
                    locale: (0, _locale.enUS),
                    ...options
                });
            return formatDate(date, "cccc");
        }
    }
};

},{"date-fns":"fRJCX","date-fns/locale":"lB9VR","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"l0SZt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a function to retrieve the modifiers for a given day.
 *
 * This function calculates both internal and custom modifiers for each day
 * based on the provided calendar days and DayPicker props.
 *
 * @private
 * @param days The array of `CalendarDay` objects to process.
 * @param props The DayPicker props, including modifiers and configuration
 *   options.
 * @param dateLib The date library to use for date manipulation.
 * @returns A function that retrieves the modifiers for a given `CalendarDay`.
 */ parcelHelpers.export(exports, "createGetModifiers", ()=>createGetModifiers);
var _uiJs = require("../UI.js");
var _dateMatchModifiersJs = require("../utils/dateMatchModifiers.js");
function createGetModifiers(days, props, navStart, navEnd, dateLib) {
    const { disabled, hidden, modifiers, showOutsideDays, broadcastCalendar, today = dateLib.today() } = props;
    const { isSameDay, isSameMonth, startOfMonth, isBefore, endOfMonth, isAfter } = dateLib;
    const computedNavStart = navStart && startOfMonth(navStart);
    const computedNavEnd = navEnd && endOfMonth(navEnd);
    const internalModifiersMap = {
        [(0, _uiJs.DayFlag).focused]: [],
        [(0, _uiJs.DayFlag).outside]: [],
        [(0, _uiJs.DayFlag).disabled]: [],
        [(0, _uiJs.DayFlag).hidden]: [],
        [(0, _uiJs.DayFlag).today]: []
    };
    const customModifiersMap = {};
    for (const day of days){
        const { date, displayMonth } = day;
        const isOutside = Boolean(displayMonth && !isSameMonth(date, displayMonth));
        const isBeforeNavStart = Boolean(computedNavStart && isBefore(date, computedNavStart));
        const isAfterNavEnd = Boolean(computedNavEnd && isAfter(date, computedNavEnd));
        const isDisabled = Boolean(disabled && (0, _dateMatchModifiersJs.dateMatchModifiers)(date, disabled, dateLib));
        const isHidden = Boolean(hidden && (0, _dateMatchModifiersJs.dateMatchModifiers)(date, hidden, dateLib)) || isBeforeNavStart || isAfterNavEnd || // Broadcast calendar will show outside days as default
        !broadcastCalendar && !showOutsideDays && isOutside || broadcastCalendar && showOutsideDays === false && isOutside;
        const isToday = isSameDay(date, today);
        if (isOutside) internalModifiersMap.outside.push(day);
        if (isDisabled) internalModifiersMap.disabled.push(day);
        if (isHidden) internalModifiersMap.hidden.push(day);
        if (isToday) internalModifiersMap.today.push(day);
        // Add custom modifiers
        if (modifiers) Object.keys(modifiers).forEach((name)=>{
            const modifierValue = modifiers?.[name];
            const isMatch = modifierValue ? (0, _dateMatchModifiersJs.dateMatchModifiers)(date, modifierValue, dateLib) : false;
            if (!isMatch) return;
            if (customModifiersMap[name]) customModifiersMap[name].push(day);
            else customModifiersMap[name] = [
                day
            ];
        });
    }
    return (day)=>{
        // Initialize all the modifiers to false
        const dayFlags = {
            [(0, _uiJs.DayFlag).focused]: false,
            [(0, _uiJs.DayFlag).disabled]: false,
            [(0, _uiJs.DayFlag).hidden]: false,
            [(0, _uiJs.DayFlag).outside]: false,
            [(0, _uiJs.DayFlag).today]: false
        };
        const customModifiers = {};
        // Find the modifiers for the given day
        for(const name in internalModifiersMap){
            const days = internalModifiersMap[name];
            dayFlags[name] = days.some((d)=>d === day);
        }
        for(const name in customModifiersMap)customModifiers[name] = customModifiersMap[name].some((d)=>d === day);
        return {
            ...dayFlags,
            // custom modifiers should override all the previous ones
            ...customModifiers
        };
    };
}

},{"../UI.js":"22uOo","../utils/dateMatchModifiers.js":"9bx0J","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"22uOo":[function(require,module,exports,__globalThis) {
/**
 * Enum representing the UI elements composing DayPicker. These elements are
 * mapped to {@link CustomComponents}, {@link ClassNames}, and {@link Styles}.
 *
 * Some elements are extended by flags and modifiers.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UI", ()=>UI);
parcelHelpers.export(exports, "DayFlag", ()=>DayFlag);
parcelHelpers.export(exports, "SelectionState", ()=>SelectionState);
parcelHelpers.export(exports, "Animation", ()=>Animation);
var UI;
(function(UI) {
    /** The root component displaying the months and the navigation bar. */ UI["Root"] = "root";
    /** The Chevron SVG element used by navigation buttons and dropdowns. */ UI["Chevron"] = "chevron";
    /**
     * The grid cell with the day's date. Extended by {@link DayFlag} and
     * {@link SelectionState}.
     */ UI["Day"] = "day";
    /** The button containing the formatted day's date, inside the grid cell. */ UI["DayButton"] = "day_button";
    /** The caption label of the month (when not showing the dropdown navigation). */ UI["CaptionLabel"] = "caption_label";
    /** The container of the dropdown navigation (when enabled). */ UI["Dropdowns"] = "dropdowns";
    /** The dropdown element to select for years and months. */ UI["Dropdown"] = "dropdown";
    /** The container element of the dropdown. */ UI["DropdownRoot"] = "dropdown_root";
    /** The root element of the footer. */ UI["Footer"] = "footer";
    /** The month grid. */ UI["MonthGrid"] = "month_grid";
    /** Contains the dropdown navigation or the caption label. */ UI["MonthCaption"] = "month_caption";
    /** The dropdown with the months. */ UI["MonthsDropdown"] = "months_dropdown";
    /** Wrapper of the month grid. */ UI["Month"] = "month";
    /** The container of the displayed months. */ UI["Months"] = "months";
    /** The navigation bar with the previous and next buttons. */ UI["Nav"] = "nav";
    /**
     * The next month button in the navigation. *
     *
     * @since 9.1.0
     */ UI["NextMonthButton"] = "button_next";
    /**
     * The previous month button in the navigation.
     *
     * @since 9.1.0
     */ UI["PreviousMonthButton"] = "button_previous";
    /** The row containing the week. */ UI["Week"] = "week";
    /** The group of row weeks in a month (`tbody`). */ UI["Weeks"] = "weeks";
    /** The column header with the weekday. */ UI["Weekday"] = "weekday";
    /** The row grouping the weekdays in the column headers. */ UI["Weekdays"] = "weekdays";
    /** The cell containing the week number. */ UI["WeekNumber"] = "week_number";
    /** The cell header of the week numbers column. */ UI["WeekNumberHeader"] = "week_number_header";
    /** The dropdown with the years. */ UI["YearsDropdown"] = "years_dropdown";
})(UI || (UI = {}));
var DayFlag;
(function(DayFlag) {
    /** The day is disabled. */ DayFlag["disabled"] = "disabled";
    /** The day is hidden. */ DayFlag["hidden"] = "hidden";
    /** The day is outside the current month. */ DayFlag["outside"] = "outside";
    /** The day is focused. */ DayFlag["focused"] = "focused";
    /** The day is today. */ DayFlag["today"] = "today";
})(DayFlag || (DayFlag = {}));
var SelectionState;
(function(SelectionState) {
    /** The day is at the end of a selected range. */ SelectionState["range_end"] = "range_end";
    /** The day is at the middle of a selected range. */ SelectionState["range_middle"] = "range_middle";
    /** The day is at the start of a selected range. */ SelectionState["range_start"] = "range_start";
    /** The day is selected. */ SelectionState["selected"] = "selected";
})(SelectionState || (SelectionState = {}));
var Animation;
(function(Animation) {
    /** The entering weeks when they appear before the exiting month. */ Animation["weeks_before_enter"] = "weeks_before_enter";
    /** The exiting weeks when they disappear before the entering month. */ Animation["weeks_before_exit"] = "weeks_before_exit";
    /** The entering weeks when they appear after the exiting month. */ Animation["weeks_after_enter"] = "weeks_after_enter";
    /** The exiting weeks when they disappear after the entering month. */ Animation["weeks_after_exit"] = "weeks_after_exit";
    /** The entering caption when it appears after the exiting month. */ Animation["caption_after_enter"] = "caption_after_enter";
    /** The exiting caption when it disappears after the entering month. */ Animation["caption_after_exit"] = "caption_after_exit";
    /** The entering caption when it appears before the exiting month. */ Animation["caption_before_enter"] = "caption_before_enter";
    /** The exiting caption when it disappears before the entering month. */ Animation["caption_before_exit"] = "caption_before_exit";
})(Animation || (Animation = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9bx0J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a given date matches at least one of the specified {@link Matcher}.
 *
 * @param date - The date to check.
 * @param matchers - The matchers to check against.
 * @param dateLib - The date utility library instance.
 * @returns `true` if the date matches any of the matchers, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "dateMatchModifiers", ()=>dateMatchModifiers);
parcelHelpers.export(exports, "isMatch", ()=>isMatch);
var _dateLibJs = require("../classes/DateLib.js");
var _rangeIncludesDateJs = require("./rangeIncludesDate.js");
var _typeguardsJs = require("./typeguards.js");
function dateMatchModifiers(date, matchers, dateLib = (0, _dateLibJs.defaultDateLib)) {
    const matchersArr = !Array.isArray(matchers) ? [
        matchers
    ] : matchers;
    const { isSameDay, differenceInCalendarDays, isAfter } = dateLib;
    return matchersArr.some((matcher)=>{
        if (typeof matcher === "boolean") return matcher;
        if (dateLib.isDate(matcher)) return isSameDay(date, matcher);
        if ((0, _typeguardsJs.isDatesArray)(matcher, dateLib)) return matcher.some((matcherDate)=>isSameDay(date, matcherDate));
        if ((0, _typeguardsJs.isDateRange)(matcher)) return (0, _rangeIncludesDateJs.rangeIncludesDate)(matcher, date, false, dateLib);
        if ((0, _typeguardsJs.isDayOfWeekType)(matcher)) {
            if (!Array.isArray(matcher.dayOfWeek)) return matcher.dayOfWeek === date.getDay();
            return matcher.dayOfWeek.includes(date.getDay());
        }
        if ((0, _typeguardsJs.isDateInterval)(matcher)) {
            const diffBefore = differenceInCalendarDays(matcher.before, date);
            const diffAfter = differenceInCalendarDays(matcher.after, date);
            const isDayBefore = diffBefore > 0;
            const isDayAfter = diffAfter < 0;
            const isClosedInterval = isAfter(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if ((0, _typeguardsJs.isDateAfterType)(matcher)) return differenceInCalendarDays(date, matcher.after) > 0;
        if ((0, _typeguardsJs.isDateBeforeType)(matcher)) return differenceInCalendarDays(matcher.before, date) > 0;
        if (typeof matcher === "function") return matcher(date);
        return false;
    });
}
const isMatch = dateMatchModifiers;

},{"../classes/DateLib.js":"6ev8G","./rangeIncludesDate.js":"3Wo9X","./typeguards.js":"keGkS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3Wo9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a given date is within a specified date range.
 *
 * @since 9.0.0
 * @param range - The date range to check against.
 * @param date - The date to check.
 * @param excludeEnds - If `true`, the range's start and end dates are excluded.
 * @param dateLib - The date utility library instance.
 * @returns `true` if the date is within the range, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "rangeIncludesDate", ()=>rangeIncludesDate);
parcelHelpers.export(exports, "isDateInRange", ()=>isDateInRange);
var _indexJs = require("../classes/index.js");
function rangeIncludesDate(range, date, excludeEnds = false, dateLib = (0, _indexJs.defaultDateLib)) {
    let { from, to } = range;
    const { differenceInCalendarDays, isSameDay } = dateLib;
    if (from && to) {
        const isRangeInverted = differenceInCalendarDays(to, from) < 0;
        if (isRangeInverted) [from, to] = [
            to,
            from
        ];
        const isInRange = differenceInCalendarDays(date, from) >= (excludeEnds ? 1 : 0) && differenceInCalendarDays(to, date) >= (excludeEnds ? 1 : 0);
        return isInRange;
    }
    if (!excludeEnds && to) return isSameDay(to, date);
    if (!excludeEnds && from) return isSameDay(from, date);
    return false;
}
const isDateInRange = (range, date)=>rangeIncludesDate(range, date, false, (0, _indexJs.defaultDateLib));

},{"../classes/index.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"keGkS":[function(require,module,exports,__globalThis) {
/**
 * Checks if the given value is of type {@link DateInterval}.
 *
 * @param matcher - The value to check.
 * @returns `true` if the value is a {@link DateInterval}, otherwise `false`.
 * @group Utilities
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDateInterval", ()=>isDateInterval);
/**
 * Checks if the given value is of type {@link DateRange}.
 *
 * @param value - The value to check.
 * @returns `true` if the value is a {@link DateRange}, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "isDateRange", ()=>isDateRange);
/**
 * Checks if the given value is of type {@link DateAfter}.
 *
 * @param value - The value to check.
 * @returns `true` if the value is a {@link DateAfter}, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "isDateAfterType", ()=>isDateAfterType);
/**
 * Checks if the given value is of type {@link DateBefore}.
 *
 * @param value - The value to check.
 * @returns `true` if the value is a {@link DateBefore}, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "isDateBeforeType", ()=>isDateBeforeType);
/**
 * Checks if the given value is of type {@link DayOfWeek}.
 *
 * @param value - The value to check.
 * @returns `true` if the value is a {@link DayOfWeek}, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "isDayOfWeekType", ()=>isDayOfWeekType);
/**
 * Checks if the given value is an array of valid dates.
 *
 * @private
 * @param value - The value to check.
 * @param dateLib - The date utility library instance.
 * @returns `true` if the value is an array of valid dates, otherwise `false`.
 */ parcelHelpers.export(exports, "isDatesArray", ()=>isDatesArray);
function isDateInterval(matcher) {
    return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
function isDateRange(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
function isDateAfterType(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
function isDateBeforeType(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
function isDayOfWeekType(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
function isDatesArray(value, dateLib) {
    return Array.isArray(value) && value.every(dateLib.isDate);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"frZeA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the class names for a day based on its modifiers.
 *
 * This function combines the base class name for the day with any class names
 * associated with active modifiers.
 *
 * @param modifiers The modifiers applied to the day.
 * @param classNames The base class names for the calendar elements.
 * @param modifiersClassNames The class names associated with specific
 *   modifiers.
 * @returns An array of class names for the day.
 */ parcelHelpers.export(exports, "getClassNamesForModifiers", ()=>getClassNamesForModifiers);
var _uiJs = require("../UI.js");
function getClassNamesForModifiers(modifiers, classNames, modifiersClassNames = {}) {
    const modifierClassNames = Object.entries(modifiers).filter(([, active])=>active === true).reduce((previousValue, [key])=>{
        if (modifiersClassNames[key]) previousValue.push(modifiersClassNames[key]);
        else if (classNames[(0, _uiJs.DayFlag)[key]]) previousValue.push(classNames[(0, _uiJs.DayFlag)[key]]);
        else if (classNames[(0, _uiJs.SelectionState)[key]]) previousValue.push(classNames[(0, _uiJs.SelectionState)[key]]);
        return previousValue;
    }, [
        classNames[(0, _uiJs.UI).Day]
    ]);
    return modifierClassNames;
}

},{"../UI.js":"22uOo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"mDDs9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges custom components from the props with the default components.
 *
 * This function ensures that any custom components provided in the props
 * override the default components.
 *
 * @param customComponents The custom components provided in the DayPicker
 *   props.
 * @returns An object containing the merged components.
 */ parcelHelpers.export(exports, "getComponents", ()=>getComponents);
var _customComponentsJs = require("../components/custom-components.js");
function getComponents(customComponents) {
    return {
        ..._customComponentsJs,
        ...customComponents
    };
}

},{"../components/custom-components.js":"3sARl","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3sARl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buttonJs = require("./Button.js");
parcelHelpers.exportAll(_buttonJs, exports);
var _captionLabelJs = require("./CaptionLabel.js");
parcelHelpers.exportAll(_captionLabelJs, exports);
var _chevronJs = require("./Chevron.js");
parcelHelpers.exportAll(_chevronJs, exports);
var _dayJs = require("./Day.js");
parcelHelpers.exportAll(_dayJs, exports);
var _dayButtonJs = require("./DayButton.js");
parcelHelpers.exportAll(_dayButtonJs, exports);
var _dropdownJs = require("./Dropdown.js");
parcelHelpers.exportAll(_dropdownJs, exports);
var _dropdownNavJs = require("./DropdownNav.js");
parcelHelpers.exportAll(_dropdownNavJs, exports);
var _footerJs = require("./Footer.js");
parcelHelpers.exportAll(_footerJs, exports);
var _monthJs = require("./Month.js");
parcelHelpers.exportAll(_monthJs, exports);
var _monthCaptionJs = require("./MonthCaption.js");
parcelHelpers.exportAll(_monthCaptionJs, exports);
var _monthGridJs = require("./MonthGrid.js");
parcelHelpers.exportAll(_monthGridJs, exports);
var _monthsJs = require("./Months.js");
parcelHelpers.exportAll(_monthsJs, exports);
var _monthsDropdownJs = require("./MonthsDropdown.js");
parcelHelpers.exportAll(_monthsDropdownJs, exports);
var _navJs = require("./Nav.js");
parcelHelpers.exportAll(_navJs, exports);
var _nextMonthButtonJs = require("./NextMonthButton.js");
parcelHelpers.exportAll(_nextMonthButtonJs, exports);
var _optionJs = require("./Option.js");
parcelHelpers.exportAll(_optionJs, exports);
var _previousMonthButtonJs = require("./PreviousMonthButton.js");
parcelHelpers.exportAll(_previousMonthButtonJs, exports);
var _rootJs = require("./Root.js");
parcelHelpers.exportAll(_rootJs, exports);
var _selectJs = require("./Select.js");
parcelHelpers.exportAll(_selectJs, exports);
var _weekJs = require("./Week.js");
parcelHelpers.exportAll(_weekJs, exports);
var _weekdayJs = require("./Weekday.js");
parcelHelpers.exportAll(_weekdayJs, exports);
var _weekdaysJs = require("./Weekdays.js");
parcelHelpers.exportAll(_weekdaysJs, exports);
var _weekNumberJs = require("./WeekNumber.js");
parcelHelpers.exportAll(_weekNumberJs, exports);
var _weekNumberHeaderJs = require("./WeekNumberHeader.js");
parcelHelpers.exportAll(_weekNumberHeaderJs, exports);
var _weeksJs = require("./Weeks.js");
parcelHelpers.exportAll(_weeksJs, exports);
var _yearsDropdownJs = require("./YearsDropdown.js");
parcelHelpers.exportAll(_yearsDropdownJs, exports);

},{"./Button.js":"hQnNA","./CaptionLabel.js":"jnnuZ","./Chevron.js":"dDAKA","./Day.js":"6CvCi","./DayButton.js":"2CMDR","./Dropdown.js":"eCKIG","./DropdownNav.js":"3xZls","./Footer.js":"ezaUn","./Month.js":"l6L7X","./MonthCaption.js":"kphuV","./MonthGrid.js":"5UD1z","./Months.js":"6MWl3","./MonthsDropdown.js":"dpx05","./Nav.js":"eFPbr","./NextMonthButton.js":"d322H","./Option.js":"2hMOL","./PreviousMonthButton.js":"4LgR9","./Root.js":"jNDl3","./Select.js":"dXhyj","./Week.js":"lpinh","./Weekday.js":"1APUe","./Weekdays.js":"72h7B","./WeekNumber.js":"4R13H","./WeekNumberHeader.js":"bZJTk","./Weeks.js":"cs87L","./YearsDropdown.js":"6IzWu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hQnNA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the button elements in the calendar.
 *
 * @private
 * @deprecated Use `PreviousMonthButton` or `@link NextMonthButton` instead.
 */ parcelHelpers.export(exports, "Button", ()=>Button);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Button(props) {
    return (0, _reactDefault.default).createElement("button", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jnnuZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the label in the month caption.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "CaptionLabel", ()=>CaptionLabel);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function CaptionLabel(props) {
    return (0, _reactDefault.default).createElement("span", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dDAKA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the chevron icon used in the navigation buttons and dropdowns.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Chevron", ()=>Chevron);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Chevron(props) {
    const { size = 24, orientation = "left", className } = props;
    return(// biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    (0, _reactDefault.default).createElement("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24"
    }, orientation === "up" && (0, _reactDefault.default).createElement("polygon", {
        points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28"
    }), orientation === "down" && (0, _reactDefault.default).createElement("polygon", {
        points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72"
    }), orientation === "left" && (0, _reactDefault.default).createElement("polygon", {
        points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20"
    }), orientation === "right" && (0, _reactDefault.default).createElement("polygon", {
        points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20"
    })));
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6CvCi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a grid cell for a specific day in the calendar.
 *
 * Handles interaction and focus for the day. If you only need to change the
 * content of the day cell, consider swapping the `DayButton` component
 * instead.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Day", ()=>Day);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Day(props) {
    const { day, modifiers, ...tdProps } = props;
    return (0, _reactDefault.default).createElement("td", {
        ...tdProps
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2CMDR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a button for a specific day in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "DayButton", ()=>DayButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function DayButton(props) {
    const { day, modifiers, ...buttonProps } = props;
    const ref = (0, _reactDefault.default).useRef(null);
    (0, _reactDefault.default).useEffect(()=>{
        if (modifiers.focused) ref.current?.focus();
    }, [
        modifiers.focused
    ]);
    return (0, _reactDefault.default).createElement("button", {
        ref: ref,
        ...buttonProps
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eCKIG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a dropdown component for navigation in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Dropdown", ()=>Dropdown);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uiJs = require("../UI.js");
function Dropdown(props) {
    const { options, className, components, classNames, ...selectProps } = props;
    const cssClassSelect = [
        classNames[(0, _uiJs.UI).Dropdown],
        className
    ].join(" ");
    const selectedOption = options?.find(({ value })=>value === selectProps.value);
    return (0, _reactDefault.default).createElement("span", {
        "data-disabled": selectProps.disabled,
        className: classNames[(0, _uiJs.UI).DropdownRoot]
    }, (0, _reactDefault.default).createElement(components.Select, {
        className: cssClassSelect,
        ...selectProps
    }, options?.map(({ value, label, disabled })=>(0, _reactDefault.default).createElement(components.Option, {
            key: value,
            value: value,
            disabled: disabled
        }, label))), (0, _reactDefault.default).createElement("span", {
        className: classNames[(0, _uiJs.UI).CaptionLabel],
        "aria-hidden": true
    }, selectedOption?.label, (0, _reactDefault.default).createElement(components.Chevron, {
        orientation: "down",
        size: 18,
        className: classNames[(0, _uiJs.UI).Chevron]
    })));
}

},{"react":"2o0ib","../UI.js":"22uOo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3xZls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the navigation dropdowns for the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "DropdownNav", ()=>DropdownNav);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function DropdownNav(props) {
    return (0, _reactDefault.default).createElement("div", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ezaUn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the footer of the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Footer", ()=>Footer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Footer(props) {
    return (0, _reactDefault.default).createElement("div", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"l6L7X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the grid with the weekday header row and the weeks for a specific
 * month.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Month", ()=>Month);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Month(props) {
    const { calendarMonth, displayIndex, ...divProps } = props;
    return (0, _reactDefault.default).createElement("div", {
        ...divProps
    }, props.children);
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kphuV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the caption for a month in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "MonthCaption", ()=>MonthCaption);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function MonthCaption(props) {
    const { calendarMonth, displayIndex, ...divProps } = props;
    return (0, _reactDefault.default).createElement("div", {
        ...divProps
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5UD1z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the grid of days for a specific month.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "MonthGrid", ()=>MonthGrid);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function MonthGrid(props) {
    return (0, _reactDefault.default).createElement("table", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6MWl3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a container wrapping the month grids.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Months", ()=>Months);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Months(props) {
    return (0, _reactDefault.default).createElement("div", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dpx05":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a dropdown to navigate between months in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "MonthsDropdown", ()=>MonthsDropdown);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useDayPickerJs = require("../useDayPicker.js");
function MonthsDropdown(props) {
    const { components } = (0, _useDayPickerJs.useDayPicker)();
    return (0, _reactDefault.default).createElement(components.Dropdown, {
        ...props
    });
}

},{"react":"2o0ib","../useDayPicker.js":"22BNj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"22BNj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dayPickerContext", ()=>dayPickerContext);
/**
 * Provides access to the DayPicker context, which includes properties and
 * methods to interact with the DayPicker component. This hook must be used
 * within a custom component.
 *
 * @template T - Use this type to refine the returned context type with a
 *   specific selection mode.
 * @returns The context to work with DayPicker.
 * @throws {Error} If the hook is used outside of a DayPicker provider.
 * @group Hooks
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "useDayPicker", ()=>useDayPicker);
var _react = require("react");
const dayPickerContext = (0, _react.createContext)(undefined);
function useDayPicker() {
    const context = (0, _react.useContext)(dayPickerContext);
    if (context === undefined) throw new Error("useDayPicker() must be used within a custom component.");
    return context;
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eFPbr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the navigation toolbar with buttons to navigate between months.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Nav", ()=>Nav);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uiJs = require("../UI.js");
var _useDayPickerJs = require("../useDayPicker.js");
function Nav(props) {
    const { onPreviousClick, onNextClick, previousMonth, nextMonth, ...navProps } = props;
    const { components, classNames, labels: { labelPrevious, labelNext } } = (0, _useDayPickerJs.useDayPicker)();
    const handleNextClick = (0, _react.useCallback)((e)=>{
        if (nextMonth) onNextClick?.(e);
    }, [
        nextMonth,
        onNextClick
    ]);
    const handlePreviousClick = (0, _react.useCallback)((e)=>{
        if (previousMonth) onPreviousClick?.(e);
    }, [
        previousMonth,
        onPreviousClick
    ]);
    return (0, _reactDefault.default).createElement("nav", {
        ...navProps
    }, (0, _reactDefault.default).createElement(components.PreviousMonthButton, {
        type: "button",
        className: classNames[(0, _uiJs.UI).PreviousMonthButton],
        tabIndex: previousMonth ? undefined : -1,
        "aria-disabled": previousMonth ? undefined : true,
        "aria-label": labelPrevious(previousMonth),
        onClick: handlePreviousClick
    }, (0, _reactDefault.default).createElement(components.Chevron, {
        disabled: previousMonth ? undefined : true,
        className: classNames[(0, _uiJs.UI).Chevron],
        orientation: "left"
    })), (0, _reactDefault.default).createElement(components.NextMonthButton, {
        type: "button",
        className: classNames[(0, _uiJs.UI).NextMonthButton],
        tabIndex: nextMonth ? undefined : -1,
        "aria-disabled": nextMonth ? undefined : true,
        "aria-label": labelNext(nextMonth),
        onClick: handleNextClick
    }, (0, _reactDefault.default).createElement(components.Chevron, {
        disabled: nextMonth ? undefined : true,
        orientation: "right",
        className: classNames[(0, _uiJs.UI).Chevron]
    })));
}

},{"react":"2o0ib","../UI.js":"22uOo","../useDayPicker.js":"22BNj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"d322H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the button to navigate to the next month in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "NextMonthButton", ()=>NextMonthButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useDayPickerJs = require("../useDayPicker.js");
function NextMonthButton(props) {
    const { components } = (0, _useDayPickerJs.useDayPicker)();
    return (0, _reactDefault.default).createElement(components.Button, {
        ...props
    });
}

},{"react":"2o0ib","../useDayPicker.js":"22BNj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2hMOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render an `option` element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Option", ()=>Option);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Option(props) {
    return (0, _reactDefault.default).createElement("option", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4LgR9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the button to navigate to the previous month in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "PreviousMonthButton", ()=>PreviousMonthButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useDayPickerJs = require("../useDayPicker.js");
function PreviousMonthButton(props) {
    const { components } = (0, _useDayPickerJs.useDayPicker)();
    return (0, _reactDefault.default).createElement(components.Button, {
        ...props
    });
}

},{"react":"2o0ib","../useDayPicker.js":"22BNj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jNDl3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the root element of the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Root", ()=>Root);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Root(props) {
    const { rootRef, ...rest } = props;
    return (0, _reactDefault.default).createElement("div", {
        ...rest,
        ref: rootRef
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dXhyj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a `select` element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Select", ()=>Select);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Select(props) {
    return (0, _reactDefault.default).createElement("select", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lpinh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a table row representing a week in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Week", ()=>Week);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Week(props) {
    const { week, ...trProps } = props;
    return (0, _reactDefault.default).createElement("tr", {
        ...trProps
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1APUe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a table header cell with the name of a weekday (e.g., "Mo", "Tu").
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Weekday", ()=>Weekday);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Weekday(props) {
    return (0, _reactDefault.default).createElement("th", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"72h7B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the table row containing the weekday names.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Weekdays", ()=>Weekdays);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Weekdays(props) {
    return (0, _reactDefault.default).createElement("thead", {
        "aria-hidden": true
    }, (0, _reactDefault.default).createElement("tr", {
        ...props
    }));
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4R13H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a table cell displaying the number of the week.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "WeekNumber", ()=>WeekNumber);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function WeekNumber(props) {
    const { week, ...thProps } = props;
    return (0, _reactDefault.default).createElement("th", {
        ...thProps
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bZJTk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the header cell for the week numbers column.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "WeekNumberHeader", ()=>WeekNumberHeader);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function WeekNumberHeader(props) {
    return (0, _reactDefault.default).createElement("th", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cs87L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the container for the weeks in the month grid.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Weeks", ()=>Weeks);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Weeks(props) {
    return (0, _reactDefault.default).createElement("tbody", {
        ...props
    });
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6IzWu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a dropdown to navigate between years in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "YearsDropdown", ()=>YearsDropdown);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useDayPickerJs = require("../useDayPicker.js");
function YearsDropdown(props) {
    const { components } = (0, _useDayPickerJs.useDayPicker)();
    return (0, _reactDefault.default).createElement(components.Dropdown, {
        ...props
    });
}

},{"react":"2o0ib","../useDayPicker.js":"22BNj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aduvW":[function(require,module,exports,__globalThis) {
/**
 * Extracts `data-` attributes from the DayPicker props.
 *
 * This function collects all `data-` attributes from the props and adds
 * additional attributes based on the DayPicker configuration.
 *
 * @param props The DayPicker props.
 * @returns An object containing the `data-` attributes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDataAttributes", ()=>getDataAttributes);
function getDataAttributes(props) {
    const dataAttributes = {
        "data-mode": props.mode ?? undefined,
        "data-required": "required" in props ? props.required : undefined,
        "data-multiple-months": props.numberOfMonths && props.numberOfMonths > 1 || undefined,
        "data-week-numbers": props.showWeekNumber || undefined,
        "data-broadcast-calendar": props.broadcastCalendar || undefined,
        "data-nav-layout": props.navLayout || undefined
    };
    Object.entries(props).forEach(([key, val])=>{
        if (key.startsWith("data-")) dataAttributes[key] = val;
    });
    return dataAttributes;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5otA2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the default class names for the UI elements.
 *
 * This function generates a mapping of default class names for various UI
 * elements, day flags, selection states, and animations.
 *
 * @returns An object containing the default class names.
 * @group Utilities
 */ parcelHelpers.export(exports, "getDefaultClassNames", ()=>getDefaultClassNames);
var _uiJs = require("../UI.js");
function getDefaultClassNames() {
    const classNames = {};
    for(const key in 0, _uiJs.UI)classNames[(0, _uiJs.UI)[key]] = `rdp-${(0, _uiJs.UI)[key]}`;
    for(const key in 0, _uiJs.DayFlag)classNames[(0, _uiJs.DayFlag)[key]] = `rdp-${(0, _uiJs.DayFlag)[key]}`;
    for(const key in 0, _uiJs.SelectionState)classNames[(0, _uiJs.SelectionState)[key]] = `rdp-${(0, _uiJs.SelectionState)[key]}`;
    for(const key in 0, _uiJs.Animation)classNames[(0, _uiJs.Animation)[key]] = `rdp-${(0, _uiJs.Animation)[key]}`;
    return classNames;
}

},{"../UI.js":"22uOo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iUy8r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges custom formatters from the props with the default formatters.
 *
 * @param customFormatters The custom formatters provided in the DayPicker
 *   props.
 * @returns The merged formatters object.
 */ parcelHelpers.export(exports, "getFormatters", ()=>getFormatters);
var _indexJs = require("../formatters/index.js");
function getFormatters(customFormatters) {
    if (customFormatters?.formatMonthCaption && !customFormatters.formatCaption) customFormatters.formatCaption = customFormatters.formatMonthCaption;
    if (customFormatters?.formatYearCaption && !customFormatters.formatYearDropdown) customFormatters.formatYearDropdown = customFormatters.formatYearCaption;
    return {
        ..._indexJs,
        ...customFormatters
    };
}

},{"../formatters/index.js":"d53ND","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"d53ND":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatCaptionJs = require("./formatCaption.js");
parcelHelpers.exportAll(_formatCaptionJs, exports);
var _formatDayJs = require("./formatDay.js");
parcelHelpers.exportAll(_formatDayJs, exports);
var _formatMonthDropdownJs = require("./formatMonthDropdown.js");
parcelHelpers.exportAll(_formatMonthDropdownJs, exports);
var _formatWeekdayNameJs = require("./formatWeekdayName.js");
parcelHelpers.exportAll(_formatWeekdayNameJs, exports);
var _formatWeekNumberJs = require("./formatWeekNumber.js");
parcelHelpers.exportAll(_formatWeekNumberJs, exports);
var _formatWeekNumberHeaderJs = require("./formatWeekNumberHeader.js");
parcelHelpers.exportAll(_formatWeekNumberHeaderJs, exports);
var _formatYearDropdownJs = require("./formatYearDropdown.js");
parcelHelpers.exportAll(_formatYearDropdownJs, exports);

},{"./formatCaption.js":"wCyIE","./formatDay.js":"cUxpc","./formatMonthDropdown.js":"j5ezo","./formatWeekdayName.js":"91CpO","./formatWeekNumber.js":"lgl2X","./formatWeekNumberHeader.js":"2UMOl","./formatYearDropdown.js":"4PC9X","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"wCyIE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the caption of the month.
 *
 * @defaultValue Locale-specific month/year order (e.g., "November 2022").
 * @param month The date representing the month.
 * @param options Configuration options for the date library.
 * @param dateLib The date library to use for formatting. If not provided, a new
 *   instance is created.
 * @returns The formatted caption as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatCaption", ()=>formatCaption);
parcelHelpers.export(exports, "formatMonthCaption", ()=>formatMonthCaption);
var _dateLibJs = require("../classes/DateLib.js");
function formatCaption(month, options, dateLib) {
    const lib = dateLib ?? new (0, _dateLibJs.DateLib)(options);
    return lib.formatMonthYear(month);
}
const formatMonthCaption = formatCaption;

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cUxpc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the day date shown in the day cell.
 *
 * @defaultValue `d` (e.g., "1").
 * @param date The date to format.
 * @param options Configuration options for the date library.
 * @param dateLib The date library to use for formatting. If not provided, a new
 *   instance is created.
 * @returns The formatted day as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatDay", ()=>formatDay);
var _dateLibJs = require("../classes/DateLib.js");
function formatDay(date, options, dateLib) {
    return (dateLib ?? new (0, _dateLibJs.DateLib)(options)).format(date, "d");
}

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"j5ezo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the month for the dropdown option label.
 *
 * @defaultValue The localized full month name.
 * @param month The date representing the month.
 * @param dateLib The date library to use for formatting. Defaults to
 *   `defaultDateLib`.
 * @returns The formatted month name as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatMonthDropdown", ()=>formatMonthDropdown);
var _dateLibJs = require("../classes/DateLib.js");
function formatMonthDropdown(month, dateLib = (0, _dateLibJs.defaultDateLib)) {
    return dateLib.format(month, "LLLL");
}

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"91CpO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the name of a weekday to be displayed in the weekdays header.
 *
 * @defaultValue `cccccc` (e.g., "Mo" for Monday).
 * @param weekday The date representing the weekday.
 * @param options Configuration options for the date library.
 * @param dateLib The date library to use for formatting. If not provided, a new
 *   instance is created.
 * @returns The formatted weekday name as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatWeekdayName", ()=>formatWeekdayName);
var _dateLibJs = require("../classes/DateLib.js");
function formatWeekdayName(weekday, options, dateLib) {
    return (dateLib ?? new (0, _dateLibJs.DateLib)(options)).format(weekday, "cccccc");
}

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lgl2X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the week number.
 *
 * @defaultValue The week number as a string, with a leading zero for single-digit numbers.
 * @param weekNumber The week number to format.
 * @param dateLib The date library to use for formatting. Defaults to
 *   `defaultDateLib`.
 * @returns The formatted week number as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatWeekNumber", ()=>formatWeekNumber);
var _dateLibJs = require("../classes/DateLib.js");
function formatWeekNumber(weekNumber, dateLib = (0, _dateLibJs.defaultDateLib)) {
    if (weekNumber < 10) return dateLib.formatNumber(`0${weekNumber.toLocaleString()}`);
    return dateLib.formatNumber(`${weekNumber.toLocaleString()}`);
}

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2UMOl":[function(require,module,exports,__globalThis) {
/**
 * Formats the header for the week number column.
 *
 * @defaultValue An empty string `""`.
 * @returns The formatted week number header as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatWeekNumberHeader", ()=>formatWeekNumberHeader);
function formatWeekNumberHeader() {
    return ``;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4PC9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the year for the dropdown option label.
 *
 * @param year The year to format.
 * @param dateLib The date library to use for formatting. Defaults to
 *   `defaultDateLib`.
 * @returns The formatted year as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatYearDropdown", ()=>formatYearDropdown);
parcelHelpers.export(exports, "formatYearCaption", ()=>formatYearCaption);
var _dateLibJs = require("../classes/DateLib.js");
function formatYearDropdown(year, dateLib = (0, _dateLibJs.defaultDateLib)) {
    return dateLib.format(year, "yyyy");
}
const formatYearCaption = formatYearDropdown;

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6swYz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges custom labels from the props with the default labels.
 *
 * When available, uses the locale-provided translation for `labelNext`.
 *
 * @param customLabels The custom labels provided in the DayPicker props.
 * @param options Options from the date library, used to resolve locale
 *   translations.
 * @returns The merged labels object with locale-aware defaults.
 */ parcelHelpers.export(exports, "getLabels", ()=>getLabels);
var _indexJs = require("../labels/index.js");
const resolveLabel = (defaultLabel, customLabel, localeLabel)=>{
    if (customLabel) return customLabel;
    if (localeLabel) return typeof localeLabel === "function" ? localeLabel : (..._args)=>localeLabel;
    return defaultLabel;
};
function getLabels(customLabels, options) {
    const localeLabels = options.locale?.labels ?? {};
    return {
        ..._indexJs,
        ...customLabels ?? {},
        labelDayButton: resolveLabel(_indexJs.labelDayButton, customLabels?.labelDayButton, localeLabels.labelDayButton),
        labelMonthDropdown: resolveLabel(_indexJs.labelMonthDropdown, customLabels?.labelMonthDropdown, localeLabels.labelMonthDropdown),
        labelNext: resolveLabel(_indexJs.labelNext, customLabels?.labelNext, localeLabels.labelNext),
        labelPrevious: resolveLabel(_indexJs.labelPrevious, customLabels?.labelPrevious, localeLabels.labelPrevious),
        labelWeekNumber: resolveLabel(_indexJs.labelWeekNumber, customLabels?.labelWeekNumber, localeLabels.labelWeekNumber),
        labelYearDropdown: resolveLabel(_indexJs.labelYearDropdown, customLabels?.labelYearDropdown, localeLabels.labelYearDropdown),
        labelGrid: resolveLabel(_indexJs.labelGrid, customLabels?.labelGrid, localeLabels.labelGrid),
        labelGridcell: resolveLabel(_indexJs.labelGridcell, customLabels?.labelGridcell, localeLabels.labelGridcell),
        labelNav: resolveLabel(_indexJs.labelNav, customLabels?.labelNav, localeLabels.labelNav),
        labelWeekNumberHeader: resolveLabel(_indexJs.labelWeekNumberHeader, customLabels?.labelWeekNumberHeader, localeLabels.labelWeekNumberHeader),
        labelWeekday: resolveLabel(_indexJs.labelWeekday, customLabels?.labelWeekday, localeLabels.labelWeekday)
    };
}

},{"../labels/index.js":"gOGGe","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gOGGe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _labelDayButtonJs = require("./labelDayButton.js");
parcelHelpers.exportAll(_labelDayButtonJs, exports);
var _labelGridJs = require("./labelGrid.js");
parcelHelpers.exportAll(_labelGridJs, exports);
parcelHelpers.exportAll(_labelGridJs, exports);
var _labelGridcellJs = require("./labelGridcell.js");
parcelHelpers.exportAll(_labelGridcellJs, exports);
var _labelMonthDropdownJs = require("./labelMonthDropdown.js");
parcelHelpers.exportAll(_labelMonthDropdownJs, exports);
var _labelNavJs = require("./labelNav.js");
parcelHelpers.exportAll(_labelNavJs, exports);
var _labelNextJs = require("./labelNext.js");
parcelHelpers.exportAll(_labelNextJs, exports);
var _labelPreviousJs = require("./labelPrevious.js");
parcelHelpers.exportAll(_labelPreviousJs, exports);
var _labelWeekdayJs = require("./labelWeekday.js");
parcelHelpers.exportAll(_labelWeekdayJs, exports);
var _labelWeekNumberJs = require("./labelWeekNumber.js");
parcelHelpers.exportAll(_labelWeekNumberJs, exports);
var _labelWeekNumberHeaderJs = require("./labelWeekNumberHeader.js");
parcelHelpers.exportAll(_labelWeekNumberHeaderJs, exports);
var _labelYearDropdownJs = require("./labelYearDropdown.js");
parcelHelpers.exportAll(_labelYearDropdownJs, exports);

},{"./labelDayButton.js":"7eq8l","./labelGrid.js":"4ONe6","./labelGridcell.js":"aDmUQ","./labelMonthDropdown.js":"6IVja","./labelNav.js":"a66sh","./labelNext.js":"2r0W6","./labelPrevious.js":"fltzd","./labelWeekday.js":"aCkfP","./labelWeekNumber.js":"k6R3t","./labelWeekNumberHeader.js":"diu1p","./labelYearDropdown.js":"gERcg","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7eq8l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates the ARIA label for a day button.
 *
 * Use the `modifiers` argument to provide additional context for the label,
 * such as indicating if the day is "today" or "selected."
 *
 * @defaultValue The formatted date.
 * @param date - The date to format.
 * @param modifiers - The modifiers providing context for the day.
 * @param options - Optional configuration for the date formatting library.
 * @param dateLib - An optional instance of the date formatting library.
 * @returns The ARIA label for the day button.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ parcelHelpers.export(exports, "labelDayButton", ()=>labelDayButton);
parcelHelpers.export(exports, "labelDay", ()=>labelDay);
var _dateLibJs = require("../classes/DateLib.js");
function labelDayButton(date, modifiers, options, dateLib) {
    let label = (dateLib ?? new (0, _dateLibJs.DateLib)(options)).format(date, "PPPP");
    if (modifiers.today) label = `Today, ${label}`;
    if (modifiers.selected) label = `${label}, selected`;
    return label;
}
const labelDay = labelDayButton;

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4ONe6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates the ARIA label for the month grid, which is announced when entering
 * the grid.
 *
 * @defaultValue Locale-specific month/year order (e.g., "November 2022").
 * @param date - The date representing the month.
 * @param options - Optional configuration for the date formatting library.
 * @param dateLib - An optional instance of the date formatting library.
 * @returns The ARIA label for the month grid.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ parcelHelpers.export(exports, "labelGrid", ()=>labelGrid);
parcelHelpers.export(exports, "labelCaption", ()=>labelCaption);
var _dateLibJs = require("../classes/DateLib.js");
function labelGrid(date, options, dateLib) {
    const lib = dateLib ?? new (0, _dateLibJs.DateLib)(options);
    return lib.formatMonthYear(date);
}
const labelCaption = labelGrid;

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aDmUQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates the label for a day grid cell when the calendar is not interactive.
 *
 * @param date - The date to format.
 * @param modifiers - Optional modifiers providing context for the day.
 * @param options - Optional configuration for the date formatting library.
 * @param dateLib - An optional instance of the date formatting library.
 * @returns The label for the day grid cell.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ parcelHelpers.export(exports, "labelGridcell", ()=>labelGridcell);
var _dateLibJs = require("../classes/DateLib.js");
function labelGridcell(date, modifiers, options, dateLib) {
    let label = (dateLib ?? new (0, _dateLibJs.DateLib)(options)).format(date, "PPPP");
    if (modifiers?.today) label = `Today, ${label}`;
    return label;
}

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6IVja":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the months dropdown.
 *
 * @defaultValue `"Choose the Month"`
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the months dropdown.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelMonthDropdown", ()=>labelMonthDropdown);
function labelMonthDropdown(_options) {
    return "Choose the Month";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"a66sh":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the navigation toolbar.
 *
 * @defaultValue `""`
 * @returns The ARIA label for the navigation toolbar.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelNav", ()=>labelNav);
function labelNav() {
    return "";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2r0W6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates the ARIA label for the "next month" button.
 *
 * @defaultValue `"Go to the Next Month"`
 * @param month - The date representing the next month, or `undefined` if there
 *   is no next month.
 * @returns The ARIA label for the "next month" button.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ parcelHelpers.export(exports, "labelNext", ()=>labelNext);
const defaultLabel = "Go to the Next Month";
function labelNext(_month, _options) {
    return defaultLabel;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fltzd":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the "previous month" button.
 *
 * @defaultValue `"Go to the Previous Month"`
 * @param month - The date representing the previous month, or `undefined` if
 *   there is no previous month.
 * @returns The ARIA label for the "previous month" button.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelPrevious", ()=>labelPrevious);
function labelPrevious(_month) {
    return "Go to the Previous Month";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aCkfP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates the ARIA label for a weekday column header.
 *
 * @defaultValue `"Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"`
 * @param date - The date representing the weekday.
 * @param options - Optional configuration for the date formatting library.
 * @param dateLib - An optional instance of the date formatting library.
 * @returns The ARIA label for the weekday column header.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ parcelHelpers.export(exports, "labelWeekday", ()=>labelWeekday);
var _dateLibJs = require("../classes/DateLib.js");
function labelWeekday(date, options, dateLib) {
    return (dateLib ?? new (0, _dateLibJs.DateLib)(options)).format(date, "cccc");
}

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"k6R3t":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the week number cell (the first cell in a row).
 *
 * @defaultValue `Week ${weekNumber}`
 * @param weekNumber - The number of the week.
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the week number cell.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelWeekNumber", ()=>labelWeekNumber);
function labelWeekNumber(weekNumber, _options) {
    return `Week ${weekNumber}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"diu1p":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the week number header element.
 *
 * @defaultValue `"Week Number"`
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the week number header.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelWeekNumberHeader", ()=>labelWeekNumberHeader);
function labelWeekNumberHeader(_options) {
    return "Week Number";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gERcg":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the years dropdown.
 *
 * @defaultValue `"Choose the Year"`
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the years dropdown.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelYearDropdown", ()=>labelYearDropdown);
function labelYearDropdown(_options) {
    return "Choose the Year";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cGOii":[function(require,module,exports,__globalThis) {
/**
 * Returns the months to show in the dropdown.
 *
 * This function generates a list of months for the current year, formatted
 * using the provided formatter, and determines whether each month should be
 * disabled based on the navigation range.
 *
 * @param displayMonth The currently displayed month.
 * @param navStart The start date for navigation.
 * @param navEnd The end date for navigation.
 * @param formatters The formatters to use for formatting the month labels.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of dropdown options representing the months, or `undefined`
 *   if no months are available.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMonthOptions", ()=>getMonthOptions);
function getMonthOptions(displayMonth, navStart, navEnd, formatters, dateLib) {
    const { startOfMonth, startOfYear, endOfYear, eachMonthOfInterval, getMonth } = dateLib;
    const months = eachMonthOfInterval({
        start: startOfYear(displayMonth),
        end: endOfYear(displayMonth)
    });
    const options = months.map((month)=>{
        const label = formatters.formatMonthDropdown(month, dateLib);
        const value = getMonth(month);
        const disabled = navStart && month < startOfMonth(navStart) || navEnd && month > startOfMonth(navEnd) || false;
        return {
            value,
            label,
            disabled
        };
    });
    return options;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"l4ZpQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the computed style for a day based on its modifiers.
 *
 * This function merges the base styles for the day with any styles associated
 * with active modifiers.
 *
 * @param dayModifiers The modifiers applied to the day.
 * @param styles The base styles for the calendar elements.
 * @param modifiersStyles The styles associated with specific modifiers.
 * @returns The computed style for the day.
 */ parcelHelpers.export(exports, "getStyleForModifiers", ()=>getStyleForModifiers);
var _uiJs = require("../UI.js");
function getStyleForModifiers(dayModifiers, styles = {}, modifiersStyles = {}) {
    let style = {
        ...styles?.[(0, _uiJs.UI).Day]
    };
    Object.entries(dayModifiers).filter(([, active])=>active === true).forEach(([modifier])=>{
        style = {
            ...style,
            ...modifiersStyles?.[modifier]
        };
    });
    return style;
}

},{"../UI.js":"22uOo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8RGAX":[function(require,module,exports,__globalThis) {
/**
 * Generates a series of 7 days, starting from the beginning of the week, to use
 * for formatting weekday names (e.g., Monday, Tuesday, etc.).
 *
 * @param dateLib The date library to use for date manipulation.
 * @param ISOWeek Whether to use ISO week numbering (weeks start on Monday).
 * @param broadcastCalendar Whether to use the broadcast calendar (weeks start
 *   on Monday, but may include adjustments for broadcast-specific rules).
 * @returns An array of 7 dates representing the weekdays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWeekdays", ()=>getWeekdays);
function getWeekdays(dateLib, ISOWeek, broadcastCalendar, today) {
    const referenceToday = today ?? dateLib.today();
    const start = broadcastCalendar ? dateLib.startOfBroadcastWeek(referenceToday, dateLib) : ISOWeek ? dateLib.startOfISOWeek(referenceToday) : dateLib.startOfWeek(referenceToday);
    const days = [];
    for(let i = 0; i < 7; i++){
        const day = dateLib.addDays(start, i);
        days.push(day);
    }
    return days;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gEZRh":[function(require,module,exports,__globalThis) {
/**
 * Returns the years to display in the dropdown.
 *
 * This function generates a list of years between the navigation start and end
 * dates, formatted using the provided formatter.
 *
 * @param navStart The start date for navigation.
 * @param navEnd The end date for navigation.
 * @param formatters The formatters to use for formatting the year labels.
 * @param dateLib The date library to use for date manipulation.
 * @param reverse If true, reverses the order of the years (descending).
 * @returns An array of dropdown options representing the years, or `undefined`
 *   if `navStart` or `navEnd` is not provided.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getYearOptions", ()=>getYearOptions);
function getYearOptions(navStart, navEnd, formatters, dateLib, reverse = false) {
    if (!navStart) return undefined;
    if (!navEnd) return undefined;
    const { startOfYear, endOfYear, eachYearOfInterval, getYear } = dateLib;
    const firstNavYear = startOfYear(navStart);
    const lastNavYear = endOfYear(navEnd);
    const years = eachYearOfInterval({
        start: firstNavYear,
        end: lastNavYear
    });
    if (reverse) years.reverse();
    return years.map((year)=>{
        const label = formatters.formatYearDropdown(year, dateLib);
        return {
            value: getYear(year),
            label,
            disabled: false
        };
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fAVNs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates `dateLib` overrides that keep all calendar math at noon in the target
 * time zone. This avoids second-level offset changes (e.g., historical zones
 * with +03:41:12) from pushing dates backward across midnight.
 */ parcelHelpers.export(exports, "createNoonOverrides", ()=>createNoonOverrides);
var _tz = require("@date-fns/tz");
var _dateFns = require("date-fns");
function createNoonOverrides(timeZone, options = {}) {
    const { weekStartsOn, locale } = options;
    const fallbackWeekStartsOn = weekStartsOn ?? locale?.options?.weekStartsOn ?? 0;
    // Keep all internal math anchored at noon in the target zone to avoid
    // historical second-level offsets from crossing midnight.
    const toNoonTZDate = (date)=>{
        const normalizedDate = typeof date === "number" || typeof date === "string" ? new Date(date) : date;
        return new (0, _tz.TZDate)(normalizedDate.getFullYear(), normalizedDate.getMonth(), normalizedDate.getDate(), 12, 0, 0, timeZone);
    };
    // Convert a value into a host `Date` that represents the same calendar day
    // as the target-zone noon. This is useful for helpers (e.g., date-fns week
    // utilities) that expect local `Date` instances rather than `TZDate`s.
    const toCalendarDate = (date)=>{
        const zoned = toNoonTZDate(date);
        return new Date(zoned.getFullYear(), zoned.getMonth(), zoned.getDate(), 0, 0, 0, 0);
    };
    return {
        today: ()=>{
            return toNoonTZDate((0, _tz.TZDate).tz(timeZone));
        },
        newDate: (year, monthIndex, date)=>{
            return new (0, _tz.TZDate)(year, monthIndex, date, 12, 0, 0, timeZone);
        },
        startOfDay: (date)=>{
            return toNoonTZDate(date);
        },
        startOfWeek: (date, options)=>{
            const base = toNoonTZDate(date);
            const weekStartsOnValue = options?.weekStartsOn ?? fallbackWeekStartsOn;
            const diff = (base.getDay() - weekStartsOnValue + 7) % 7;
            base.setDate(base.getDate() - diff);
            return base;
        },
        startOfISOWeek: (date)=>{
            const base = toNoonTZDate(date);
            const diff = (base.getDay() - 1 + 7) % 7;
            base.setDate(base.getDate() - diff);
            return base;
        },
        startOfMonth: (date)=>{
            const base = toNoonTZDate(date);
            base.setDate(1);
            return base;
        },
        startOfYear: (date)=>{
            const base = toNoonTZDate(date);
            base.setMonth(0, 1);
            return base;
        },
        endOfWeek: (date, options)=>{
            const base = toNoonTZDate(date);
            const weekStartsOnValue = options?.weekStartsOn ?? fallbackWeekStartsOn;
            const endDow = (weekStartsOnValue + 6) % 7;
            const diff = (endDow - base.getDay() + 7) % 7;
            base.setDate(base.getDate() + diff);
            return base;
        },
        endOfISOWeek: (date)=>{
            const base = toNoonTZDate(date);
            const diff = (7 - base.getDay()) % 7;
            base.setDate(base.getDate() + diff);
            return base;
        },
        endOfMonth: (date)=>{
            const base = toNoonTZDate(date);
            base.setMonth(base.getMonth() + 1, 0);
            return base;
        },
        endOfYear: (date)=>{
            const base = toNoonTZDate(date);
            base.setMonth(11, 31);
            return base;
        },
        eachMonthOfInterval: (interval)=>{
            const start = toNoonTZDate(interval.start);
            const end = toNoonTZDate(interval.end);
            const result = [];
            const cursor = new (0, _tz.TZDate)(start.getFullYear(), start.getMonth(), 1, 12, 0, 0, timeZone);
            const endKey = end.getFullYear() * 12 + end.getMonth();
            while(cursor.getFullYear() * 12 + cursor.getMonth() <= endKey){
                result.push(new (0, _tz.TZDate)(cursor, timeZone));
                cursor.setMonth(cursor.getMonth() + 1, 1);
            }
            return result;
        },
        // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
        // mutate the same TZDate, and return it.
        addDays: (date, amount)=>{
            const base = toNoonTZDate(date);
            base.setDate(base.getDate() + amount);
            return base;
        },
        addWeeks: (date, amount)=>{
            const base = toNoonTZDate(date);
            base.setDate(base.getDate() + amount * 7);
            return base;
        },
        addMonths: (date, amount)=>{
            const base = toNoonTZDate(date);
            base.setMonth(base.getMonth() + amount);
            return base;
        },
        addYears: (date, amount)=>{
            const base = toNoonTZDate(date);
            base.setFullYear(base.getFullYear() + amount);
            return base;
        },
        eachYearOfInterval: (interval)=>{
            const start = toNoonTZDate(interval.start);
            const end = toNoonTZDate(interval.end);
            const years = [];
            const cursor = new (0, _tz.TZDate)(start.getFullYear(), 0, 1, 12, 0, 0, timeZone);
            while(cursor.getFullYear() <= end.getFullYear()){
                years.push(new (0, _tz.TZDate)(cursor, timeZone));
                cursor.setFullYear(cursor.getFullYear() + 1, 0, 1);
            }
            return years;
        },
        getWeek: (date, options)=>{
            const base = toCalendarDate(date);
            return (0, _dateFns.getWeek)(base, {
                weekStartsOn: options?.weekStartsOn ?? fallbackWeekStartsOn,
                firstWeekContainsDate: options?.firstWeekContainsDate ?? locale?.options?.firstWeekContainsDate ?? 1
            });
        },
        getISOWeek: (date)=>{
            const base = toCalendarDate(date);
            return (0, _dateFns.getISOWeek)(base);
        },
        differenceInCalendarDays: (dateLeft, dateRight)=>{
            const left = toCalendarDate(dateLeft);
            const right = toCalendarDate(dateRight);
            return (0, _dateFns.differenceInCalendarDays)(left, right);
        },
        differenceInCalendarMonths: (dateLeft, dateRight)=>{
            const left = toCalendarDate(dateLeft);
            const right = toCalendarDate(dateRight);
            return (0, _dateFns.differenceInCalendarMonths)(left, right);
        }
    };
}

},{"@date-fns/tz":"74xQL","date-fns":[["differenceInCalendarDays","ivKYP"],["differenceInCalendarMonths","4Ch2a"],["getISOWeek","7Oeg9"],["getWeek","2yF1t"]],"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ggcRD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles animations for transitioning between months in the DayPicker
 * component.
 *
 * @private
 * @param rootElRef - A reference to the root element of the DayPicker
 *   component.
 * @param enabled - Whether animations are enabled.
 * @param options - Configuration options for the animation, including class
 *   names, months, focused day, and the date utility library.
 */ parcelHelpers.export(exports, "useAnimation", ()=>useAnimation);
var _react = require("react");
var _uiJs = require("./UI.js");
const asHtmlElement = (element)=>{
    if (element instanceof HTMLElement) return element;
    return null;
};
const queryMonthEls = (element)=>[
        ...element.querySelectorAll("[data-animated-month]") ?? []
    ];
const queryMonthEl = (element)=>asHtmlElement(element.querySelector("[data-animated-month]"));
const queryCaptionEl = (element)=>asHtmlElement(element.querySelector("[data-animated-caption]"));
const queryWeeksEl = (element)=>asHtmlElement(element.querySelector("[data-animated-weeks]"));
const queryNavEl = (element)=>asHtmlElement(element.querySelector("[data-animated-nav]"));
const queryWeekdaysEl = (element)=>asHtmlElement(element.querySelector("[data-animated-weekdays]"));
function useAnimation(rootElRef, enabled, { classNames, months, focused, dateLib }) {
    const previousRootElSnapshotRef = (0, _react.useRef)(null);
    const previousMonthsRef = (0, _react.useRef)(months);
    const animatingRef = (0, _react.useRef)(false);
    (0, _react.useLayoutEffect)(()=>{
        // get previous months before updating the previous months ref
        const previousMonths = previousMonthsRef.current;
        // update previous months ref for next effect trigger
        previousMonthsRef.current = months;
        if (!enabled || !rootElRef.current || // safety check because the ref can be set to anything by consumers
        !(rootElRef.current instanceof HTMLElement) || // validation required for the animation to work as expected
        months.length === 0 || previousMonths.length === 0 || months.length !== previousMonths.length) return;
        const isSameMonth = dateLib.isSameMonth(months[0].date, previousMonths[0].date);
        const isAfterPreviousMonth = dateLib.isAfter(months[0].date, previousMonths[0].date);
        const captionAnimationClass = isAfterPreviousMonth ? classNames[(0, _uiJs.Animation).caption_after_enter] : classNames[(0, _uiJs.Animation).caption_before_enter];
        const weeksAnimationClass = isAfterPreviousMonth ? classNames[(0, _uiJs.Animation).weeks_after_enter] : classNames[(0, _uiJs.Animation).weeks_before_enter];
        // get previous root element snapshot before updating the snapshot ref
        const previousRootElSnapshot = previousRootElSnapshotRef.current;
        // update snapshot for next effect trigger
        const rootElSnapshot = rootElRef.current.cloneNode(true);
        if (rootElSnapshot instanceof HTMLElement) {
            // if this effect is triggered while animating, we need to clean up the new root snapshot
            // to put it in the same state as when not animating, to correctly animate the next month change
            const currentMonthElsSnapshot = queryMonthEls(rootElSnapshot);
            currentMonthElsSnapshot.forEach((currentMonthElSnapshot)=>{
                if (!(currentMonthElSnapshot instanceof HTMLElement)) return;
                // remove the old month snapshots from the new root snapshot
                const previousMonthElSnapshot = queryMonthEl(currentMonthElSnapshot);
                if (previousMonthElSnapshot && currentMonthElSnapshot.contains(previousMonthElSnapshot)) currentMonthElSnapshot.removeChild(previousMonthElSnapshot);
                // remove animation classes from the new month snapshots
                const captionEl = queryCaptionEl(currentMonthElSnapshot);
                if (captionEl) captionEl.classList.remove(captionAnimationClass);
                const weeksEl = queryWeeksEl(currentMonthElSnapshot);
                if (weeksEl) weeksEl.classList.remove(weeksAnimationClass);
            });
            previousRootElSnapshotRef.current = rootElSnapshot;
        } else previousRootElSnapshotRef.current = null;
        if (animatingRef.current || isSameMonth || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
        focused) return;
        const previousMonthEls = previousRootElSnapshot instanceof HTMLElement ? queryMonthEls(previousRootElSnapshot) : [];
        const currentMonthEls = queryMonthEls(rootElRef.current);
        if (currentMonthEls?.every((el)=>el instanceof HTMLElement) && previousMonthEls && previousMonthEls.every((el)=>el instanceof HTMLElement)) {
            animatingRef.current = true;
            const cleanUpFunctions = [];
            // set isolation to isolate to isolate the stacking context during animation
            rootElRef.current.style.isolation = "isolate";
            // set z-index to 1 to ensure the nav is clickable over the other elements being animated
            const navEl = queryNavEl(rootElRef.current);
            if (navEl) navEl.style.zIndex = "1";
            currentMonthEls.forEach((currentMonthEl, index)=>{
                const previousMonthEl = previousMonthEls[index];
                if (!previousMonthEl) return;
                // animate new displayed month
                currentMonthEl.style.position = "relative";
                currentMonthEl.style.overflow = "hidden";
                const captionEl = queryCaptionEl(currentMonthEl);
                if (captionEl) captionEl.classList.add(captionAnimationClass);
                const weeksEl = queryWeeksEl(currentMonthEl);
                if (weeksEl) weeksEl.classList.add(weeksAnimationClass);
                // animate new displayed month end
                const cleanUp = ()=>{
                    animatingRef.current = false;
                    if (rootElRef.current) rootElRef.current.style.isolation = "";
                    if (navEl) navEl.style.zIndex = "";
                    if (captionEl) captionEl.classList.remove(captionAnimationClass);
                    if (weeksEl) weeksEl.classList.remove(weeksAnimationClass);
                    currentMonthEl.style.position = "";
                    currentMonthEl.style.overflow = "";
                    if (currentMonthEl.contains(previousMonthEl)) currentMonthEl.removeChild(previousMonthEl);
                };
                cleanUpFunctions.push(cleanUp);
                // animate old displayed month
                previousMonthEl.style.pointerEvents = "none";
                previousMonthEl.style.position = "absolute";
                previousMonthEl.style.overflow = "hidden";
                previousMonthEl.setAttribute("aria-hidden", "true");
                // hide the weekdays container of the old month and only the new one
                const previousWeekdaysEl = queryWeekdaysEl(previousMonthEl);
                if (previousWeekdaysEl) previousWeekdaysEl.style.opacity = "0";
                const previousCaptionEl = queryCaptionEl(previousMonthEl);
                if (previousCaptionEl) {
                    previousCaptionEl.classList.add(isAfterPreviousMonth ? classNames[(0, _uiJs.Animation).caption_before_exit] : classNames[(0, _uiJs.Animation).caption_after_exit]);
                    previousCaptionEl.addEventListener("animationend", cleanUp);
                }
                const previousWeeksEl = queryWeeksEl(previousMonthEl);
                if (previousWeeksEl) previousWeeksEl.classList.add(isAfterPreviousMonth ? classNames[(0, _uiJs.Animation).weeks_before_exit] : classNames[(0, _uiJs.Animation).weeks_after_exit]);
                currentMonthEl.insertBefore(previousMonthEl, currentMonthEl.firstChild);
            });
        }
    });
}

},{"react":"2o0ib","./UI.js":"22uOo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cLv18":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the calendar object to work with the calendar in custom components.
 *
 * @private
 * @param props - The DayPicker props related to calendar configuration.
 * @param dateLib - The date utility library instance.
 * @returns The calendar object containing displayed days, weeks, months, and
 *   navigation methods.
 */ parcelHelpers.export(exports, "useCalendar", ()=>useCalendar);
var _react = require("react");
var _getDatesJs = require("./helpers/getDates.js");
var _getDaysJs = require("./helpers/getDays.js");
var _getDisplayMonthsJs = require("./helpers/getDisplayMonths.js");
var _getInitialMonthJs = require("./helpers/getInitialMonth.js");
var _getMonthsJs = require("./helpers/getMonths.js");
var _getNavMonthJs = require("./helpers/getNavMonth.js");
var _getNextMonthJs = require("./helpers/getNextMonth.js");
var _getPreviousMonthJs = require("./helpers/getPreviousMonth.js");
var _getWeeksJs = require("./helpers/getWeeks.js");
var _useControlledValueJs = require("./helpers/useControlledValue.js");
function useCalendar(props, dateLib) {
    const [navStart, navEnd] = (0, _getNavMonthJs.getNavMonths)(props, dateLib);
    const { startOfMonth, endOfMonth } = dateLib;
    const initialMonth = (0, _getInitialMonthJs.getInitialMonth)(props, navStart, navEnd, dateLib);
    const [firstMonth, setFirstMonth] = (0, _useControlledValueJs.useControlledValue)(initialMonth, // initialMonth is always computed from props.month if provided
    props.month ? initialMonth : undefined);
    // biome-ignore lint/correctness/useExhaustiveDependencies: change the initial month when the time zone changes.
    (0, _react.useEffect)(()=>{
        const newInitialMonth = (0, _getInitialMonthJs.getInitialMonth)(props, navStart, navEnd, dateLib);
        setFirstMonth(newInitialMonth);
    }, [
        props.timeZone
    ]);
    /** The months displayed in the calendar. */ // biome-ignore lint/correctness/useExhaustiveDependencies: We want to recompute only when specific props change.
    const { months, weeks, days, previousMonth, nextMonth } = (0, _react.useMemo)(()=>{
        const displayMonths = (0, _getDisplayMonthsJs.getDisplayMonths)(firstMonth, navEnd, {
            numberOfMonths: props.numberOfMonths
        }, dateLib);
        const dates = (0, _getDatesJs.getDates)(displayMonths, props.endMonth ? endOfMonth(props.endMonth) : undefined, {
            ISOWeek: props.ISOWeek,
            fixedWeeks: props.fixedWeeks,
            broadcastCalendar: props.broadcastCalendar
        }, dateLib);
        const months = (0, _getMonthsJs.getMonths)(displayMonths, dates, {
            broadcastCalendar: props.broadcastCalendar,
            fixedWeeks: props.fixedWeeks,
            ISOWeek: props.ISOWeek,
            reverseMonths: props.reverseMonths
        }, dateLib);
        const weeks = (0, _getWeeksJs.getWeeks)(months);
        const days = (0, _getDaysJs.getDays)(months);
        const previousMonth = (0, _getPreviousMonthJs.getPreviousMonth)(firstMonth, navStart, props, dateLib);
        const nextMonth = (0, _getNextMonthJs.getNextMonth)(firstMonth, navEnd, props, dateLib);
        return {
            months,
            weeks,
            days,
            previousMonth,
            nextMonth
        };
    }, [
        dateLib,
        firstMonth.getTime(),
        navEnd?.getTime(),
        navStart?.getTime(),
        props.disableNavigation,
        props.broadcastCalendar,
        props.endMonth?.getTime(),
        props.fixedWeeks,
        props.ISOWeek,
        props.numberOfMonths,
        props.pagedNavigation,
        props.reverseMonths
    ]);
    const { disableNavigation, onMonthChange } = props;
    const isDayInCalendar = (day)=>weeks.some((week)=>week.days.some((d)=>d.isEqualTo(day)));
    const goToMonth = (date)=>{
        if (disableNavigation) return;
        let newMonth = startOfMonth(date);
        // if month is before start, use the first month instead
        if (navStart && newMonth < startOfMonth(navStart)) newMonth = startOfMonth(navStart);
        // if month is after endMonth, use the last month instead
        if (navEnd && newMonth > startOfMonth(navEnd)) newMonth = startOfMonth(navEnd);
        setFirstMonth(newMonth);
        onMonthChange?.(newMonth);
    };
    const goToDay = (day)=>{
        // is this check necessary?
        if (isDayInCalendar(day)) return;
        goToMonth(day.date);
    };
    const calendar = {
        months,
        weeks,
        days,
        navStart,
        navEnd,
        previousMonth,
        nextMonth,
        goToMonth,
        goToDay
    };
    return calendar;
}

},{"react":"2o0ib","./helpers/getDates.js":"4TdDl","./helpers/getDays.js":"b4m4k","./helpers/getDisplayMonths.js":"7CCMz","./helpers/getInitialMonth.js":"eP2JB","./helpers/getMonths.js":"lFa6e","./helpers/getNavMonth.js":"lPSZT","./helpers/getNextMonth.js":"FwvtJ","./helpers/getPreviousMonth.js":"ctEgw","./helpers/getWeeks.js":"gUQ8C","./helpers/useControlledValue.js":"dVNGG","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4TdDl":[function(require,module,exports,__globalThis) {
/**
 * Returns all the dates to display in the calendar.
 *
 * This function calculates the range of dates to display based on the provided
 * display months, constraints, and calendar configuration.
 *
 * @param displayMonths The months to display in the calendar.
 * @param maxDate The maximum date to include in the range.
 * @param props The DayPicker props, including calendar configuration options.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of dates to display in the calendar.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDates", ()=>getDates);
function getDates(displayMonths, maxDate, props, dateLib) {
    const firstMonth = displayMonths[0];
    const lastMonth = displayMonths[displayMonths.length - 1];
    const { ISOWeek, fixedWeeks, broadcastCalendar } = props ?? {};
    const { addDays, differenceInCalendarDays, differenceInCalendarMonths, endOfBroadcastWeek, endOfISOWeek, endOfMonth, endOfWeek, isAfter, startOfBroadcastWeek, startOfISOWeek, startOfWeek } = dateLib;
    const startWeekFirstDate = broadcastCalendar ? startOfBroadcastWeek(firstMonth, dateLib) : ISOWeek ? startOfISOWeek(firstMonth) : startOfWeek(firstMonth);
    const displayMonthsWeekEnd = broadcastCalendar ? endOfBroadcastWeek(lastMonth) : ISOWeek ? endOfISOWeek(endOfMonth(lastMonth)) : endOfWeek(endOfMonth(lastMonth));
    // If maxDate is set, clamp the grid to the end of that week.
    const constraintWeekEnd = maxDate && (broadcastCalendar ? endOfBroadcastWeek(maxDate) : ISOWeek ? endOfISOWeek(maxDate) : endOfWeek(maxDate));
    // Pick the earliest week end between the displayed months and the constraint.
    const gridEndDate = constraintWeekEnd && isAfter(displayMonthsWeekEnd, constraintWeekEnd) ? constraintWeekEnd : displayMonthsWeekEnd;
    const nOfDays = differenceInCalendarDays(gridEndDate, startWeekFirstDate);
    const nOfMonths = differenceInCalendarMonths(lastMonth, firstMonth) + 1;
    const dates = [];
    for(let i = 0; i <= nOfDays; i++){
        const date = addDays(startWeekFirstDate, i);
        dates.push(date);
    }
    // If fixed weeks is enabled, add the extra dates to the array
    const nrOfDaysWithFixedWeeks = broadcastCalendar ? 35 : 42;
    const extraDates = nrOfDaysWithFixedWeeks * nOfMonths;
    if (fixedWeeks && dates.length < extraDates) {
        const daysToAdd = extraDates - dates.length;
        for(let i = 0; i < daysToAdd; i++){
            const date = addDays(dates[dates.length - 1], 1);
            dates.push(date);
        }
    }
    return dates;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"b4m4k":[function(require,module,exports,__globalThis) {
/**
 * Returns all the days belonging to the calendar by merging the days in the
 * weeks for each month.
 *
 * @param calendarMonths The array of calendar months.
 * @returns An array of `CalendarDay` objects representing all the days in the
 *   calendar.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDays", ()=>getDays);
function getDays(calendarMonths) {
    const initialDays = [];
    return calendarMonths.reduce((days, month)=>{
        const weekDays = month.weeks.reduce((weekDays, week)=>{
            return weekDays.concat(week.days.slice());
        }, initialDays.slice());
        return days.concat(weekDays.slice());
    }, initialDays.slice());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7CCMz":[function(require,module,exports,__globalThis) {
/**
 * Returns the months to display in the calendar.
 *
 * @param firstDisplayedMonth The first month currently displayed in the
 *   calendar.
 * @param calendarEndMonth The latest month the user can navigate to.
 * @param props The DayPicker props, including `numberOfMonths`.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of dates representing the months to display.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDisplayMonths", ()=>getDisplayMonths);
function getDisplayMonths(firstDisplayedMonth, calendarEndMonth, props, dateLib) {
    const { numberOfMonths = 1 } = props;
    const months = [];
    for(let i = 0; i < numberOfMonths; i++){
        const month = dateLib.addMonths(firstDisplayedMonth, i);
        if (calendarEndMonth && month > calendarEndMonth) break;
        months.push(month);
    }
    return months;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eP2JB":[function(require,module,exports,__globalThis) {
/**
 * Determines the initial month to display in the calendar based on the provided
 * props.
 *
 * This function calculates the starting month, considering constraints such as
 * `startMonth`, `endMonth`, and the number of months to display.
 *
 * @param props The DayPicker props, including navigation and date constraints.
 * @param dateLib The date library to use for date manipulation.
 * @returns The initial month to display.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInitialMonth", ()=>getInitialMonth);
function getInitialMonth(props, navStart, navEnd, dateLib) {
    const { month, defaultMonth, today = dateLib.today(), numberOfMonths = 1 } = props;
    let initialMonth = month || defaultMonth || today;
    const { differenceInCalendarMonths, addMonths, startOfMonth } = dateLib;
    if (navEnd && differenceInCalendarMonths(navEnd, initialMonth) < numberOfMonths - 1) {
        const offset = -1 * (numberOfMonths - 1);
        initialMonth = addMonths(navEnd, offset);
    }
    if (navStart && differenceInCalendarMonths(initialMonth, navStart) < 0) initialMonth = navStart;
    return startOfMonth(initialMonth);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lFa6e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the months to display in the calendar.
 *
 * This function generates `CalendarMonth` objects for each month to be
 * displayed, including their weeks and days, based on the provided display
 * months and dates.
 *
 * @param displayMonths The months (as dates) to display in the calendar.
 * @param dates The dates to display in the calendar.
 * @param props Options from the DayPicker props context.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of `CalendarMonth` objects representing the months to
 *   display.
 */ parcelHelpers.export(exports, "getMonths", ()=>getMonths);
var _indexJs = require("../classes/index.js");
function getMonths(displayMonths, dates, props, dateLib) {
    const { addDays, endOfBroadcastWeek, endOfISOWeek, endOfMonth, endOfWeek, getISOWeek, getWeek, startOfBroadcastWeek, startOfISOWeek, startOfWeek } = dateLib;
    const dayPickerMonths = displayMonths.reduce((months, month)=>{
        const firstDateOfFirstWeek = props.broadcastCalendar ? startOfBroadcastWeek(month, dateLib) : props.ISOWeek ? startOfISOWeek(month) : startOfWeek(month);
        const lastDateOfLastWeek = props.broadcastCalendar ? endOfBroadcastWeek(month) : props.ISOWeek ? endOfISOWeek(endOfMonth(month)) : endOfWeek(endOfMonth(month));
        /** The dates to display in the month. */ const monthDates = dates.filter((date)=>{
            return date >= firstDateOfFirstWeek && date <= lastDateOfLastWeek;
        });
        const nrOfDaysWithFixedWeeks = props.broadcastCalendar ? 35 : 42;
        if (props.fixedWeeks && monthDates.length < nrOfDaysWithFixedWeeks) {
            const extraDates = dates.filter((date)=>{
                const daysToAdd = nrOfDaysWithFixedWeeks - monthDates.length;
                return date > lastDateOfLastWeek && date <= addDays(lastDateOfLastWeek, daysToAdd);
            });
            monthDates.push(...extraDates);
        }
        const weeks = monthDates.reduce((weeks, date)=>{
            const weekNumber = props.ISOWeek ? getISOWeek(date) : getWeek(date);
            const week = weeks.find((week)=>week.weekNumber === weekNumber);
            const day = new (0, _indexJs.CalendarDay)(date, month, dateLib);
            if (!week) weeks.push(new (0, _indexJs.CalendarWeek)(weekNumber, [
                day
            ]));
            else week.days.push(day);
            return weeks;
        }, []);
        const dayPickerMonth = new (0, _indexJs.CalendarMonth)(month, weeks);
        months.push(dayPickerMonth);
        return months;
    }, []);
    if (!props.reverseMonths) return dayPickerMonths;
    else return dayPickerMonths.reverse();
}

},{"../classes/index.js":[["CalendarDay","dgHSe"],["CalendarMonth","7fJkT"],["CalendarWeek","eiFeW"]],"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dgHSe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a day displayed in the calendar.
 *
 * In DayPicker, a `CalendarDay` is a wrapper around a `Date` object that
 * provides additional information about the day, such as whether it belongs to
 * the displayed month.
 */ parcelHelpers.export(exports, "CalendarDay", ()=>CalendarDay);
var _dateLibJs = require("./DateLib.js");
class CalendarDay {
    constructor(date, displayMonth, dateLib = (0, _dateLibJs.defaultDateLib)){
        this.date = date;
        this.displayMonth = displayMonth;
        this.outside = Boolean(displayMonth && !dateLib.isSameMonth(date, displayMonth));
        this.dateLib = dateLib;
        this.isoDate = dateLib.format(date, "yyyy-MM-dd");
        this.displayMonthId = dateLib.format(displayMonth, "yyyy-MM");
        this.dateMonthId = dateLib.format(date, "yyyy-MM");
    }
    /**
     * Checks if this day is equal to another `CalendarDay`, considering both the
     * date and the displayed month.
     *
     * @param day The `CalendarDay` to compare with.
     * @returns `true` if the days are equal, otherwise `false`.
     */ isEqualTo(day) {
        return this.dateLib.isSameDay(day.date, this.date) && this.dateLib.isSameMonth(day.displayMonth, this.displayMonth);
    }
}

},{"./DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7fJkT":[function(require,module,exports,__globalThis) {
/**
 * Represents a month in a calendar year.
 *
 * A `CalendarMonth` contains the weeks within the month and the date of the
 * month.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarMonth", ()=>CalendarMonth);
class CalendarMonth {
    constructor(month, weeks){
        this.date = month;
        this.weeks = weeks;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eiFeW":[function(require,module,exports,__globalThis) {
/**
 * Represents a week in a calendar month.
 *
 * A `CalendarWeek` contains the days within the week and the week number.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarWeek", ()=>CalendarWeek);
class CalendarWeek {
    constructor(weekNumber, days){
        this.days = days;
        this.weekNumber = weekNumber;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lPSZT":[function(require,module,exports,__globalThis) {
/**
 * Returns the start and end months for calendar navigation.
 *
 * @param props The DayPicker props, including navigation and layout options.
 * @param dateLib The date library to use for date manipulation.
 * @returns A tuple containing the start and end months for navigation.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNavMonths", ()=>getNavMonths);
function getNavMonths(props, dateLib) {
    let { startMonth, endMonth } = props;
    const { startOfYear, startOfDay, startOfMonth, endOfMonth, addYears, endOfYear, newDate, today } = dateLib;
    // Handle deprecated code
    const { fromYear, toYear, fromMonth, toMonth } = props;
    if (!startMonth && fromMonth) startMonth = fromMonth;
    if (!startMonth && fromYear) startMonth = dateLib.newDate(fromYear, 0, 1);
    if (!endMonth && toMonth) endMonth = toMonth;
    if (!endMonth && toYear) endMonth = newDate(toYear, 11, 31);
    const hasYearDropdown = props.captionLayout === "dropdown" || props.captionLayout === "dropdown-years";
    if (startMonth) startMonth = startOfMonth(startMonth);
    else if (fromYear) startMonth = newDate(fromYear, 0, 1);
    else if (!startMonth && hasYearDropdown) startMonth = startOfYear(addYears(props.today ?? today(), -100));
    if (endMonth) endMonth = endOfMonth(endMonth);
    else if (toYear) endMonth = newDate(toYear, 11, 31);
    else if (!endMonth && hasYearDropdown) endMonth = endOfYear(props.today ?? today());
    return [
        startMonth ? startOfDay(startMonth) : startMonth,
        endMonth ? startOfDay(endMonth) : endMonth
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"FwvtJ":[function(require,module,exports,__globalThis) {
/**
 * Returns the next month the user can navigate to, based on the given options.
 *
 * The next month is not always the next calendar month:
 *
 * - If it is after the `calendarEndMonth`, it returns `undefined`.
 * - If paged navigation is enabled, it skips forward by the number of displayed
 *   months.
 *
 * @param firstDisplayedMonth The first month currently displayed in the
 *   calendar.
 * @param calendarEndMonth The latest month the user can navigate to.
 * @param options Navigation options, including `numberOfMonths` and
 *   `pagedNavigation`.
 * @param dateLib The date library to use for date manipulation.
 * @returns The next month, or `undefined` if navigation is not possible.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNextMonth", ()=>getNextMonth);
function getNextMonth(firstDisplayedMonth, calendarEndMonth, options, dateLib) {
    if (options.disableNavigation) return undefined;
    const { pagedNavigation, numberOfMonths = 1 } = options;
    const { startOfMonth, addMonths, differenceInCalendarMonths } = dateLib;
    const offset = pagedNavigation ? numberOfMonths : 1;
    const month = startOfMonth(firstDisplayedMonth);
    if (!calendarEndMonth) return addMonths(month, offset);
    const monthsDiff = differenceInCalendarMonths(calendarEndMonth, firstDisplayedMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    return addMonths(month, offset);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ctEgw":[function(require,module,exports,__globalThis) {
/**
 * Returns the previous month the user can navigate to, based on the given
 * options.
 *
 * The previous month is not always the previous calendar month:
 *
 * - If it is before the `calendarStartMonth`, it returns `undefined`.
 * - If paged navigation is enabled, it skips back by the number of displayed
 *   months.
 *
 * @param firstDisplayedMonth The first month currently displayed in the
 *   calendar.
 * @param calendarStartMonth The earliest month the user can navigate to.
 * @param options Navigation options, including `numberOfMonths` and
 *   `pagedNavigation`.
 * @param dateLib The date library to use for date manipulation.
 * @returns The previous month, or `undefined` if navigation is not possible.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPreviousMonth", ()=>getPreviousMonth);
function getPreviousMonth(firstDisplayedMonth, calendarStartMonth, options, dateLib) {
    if (options.disableNavigation) return undefined;
    const { pagedNavigation, numberOfMonths } = options;
    const { startOfMonth, addMonths, differenceInCalendarMonths } = dateLib;
    const offset = pagedNavigation ? numberOfMonths ?? 1 : 1;
    const month = startOfMonth(firstDisplayedMonth);
    if (!calendarStartMonth) return addMonths(month, -offset);
    const monthsDiff = differenceInCalendarMonths(month, calendarStartMonth);
    if (monthsDiff <= 0) return undefined;
    return addMonths(month, -offset);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gUQ8C":[function(require,module,exports,__globalThis) {
/**
 * Returns an array of calendar weeks from an array of calendar months.
 *
 * @param months The array of calendar months.
 * @returns An array of calendar weeks.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWeeks", ()=>getWeeks);
function getWeeks(months) {
    const initialWeeks = [];
    return months.reduce((weeks, month)=>{
        return weeks.concat(month.weeks.slice());
    }, initialWeeks.slice());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dVNGG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A custom hook for managing both controlled and uncontrolled component states.
 *
 * This hook allows a component to support both controlled and uncontrolled
 * states by determining whether the `controlledValue` is provided. If it is
 * undefined, the hook falls back to using the internal state.
 *
 * @example
 *   // Uncontrolled usage
 *   const [value, setValue] = useControlledValue(0, undefined);
 *
 *   // Controlled usage
 *   const [value, setValue] = useControlledValue(0, props.value);
 *
 * @template T - The type of the value.
 * @param defaultValue The initial value for the uncontrolled state.
 * @param controlledValue The value for the controlled state. If undefined, the
 *   component will use the uncontrolled state.
 * @returns A tuple where the first element is the current value (either
 *   controlled or uncontrolled) and the second element is a setter function to
 *   update the value.
 */ parcelHelpers.export(exports, "useControlledValue", ()=>useControlledValue);
var _react = require("react");
function useControlledValue(defaultValue, controlledValue) {
    const [uncontrolledValue, setValue] = (0, _react.useState)(defaultValue);
    const value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}

},{"react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2ZgMJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages focus behavior for the DayPicker component, including setting,
 * moving, and blurring focus on calendar days.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param calendar - The calendar object containing the displayed days and
 *   months.
 * @param getModifiers - A function to retrieve modifiers for a given day.
 * @param isSelected - A function to check if a date is selected.
 * @param dateLib - The date utility library instance.
 * @returns An object containing focus-related methods and the currently focused
 *   day.
 */ parcelHelpers.export(exports, "useFocus", ()=>useFocus);
var _react = require("react");
var _calculateFocusTargetJs = require("./helpers/calculateFocusTarget.js");
var _getNextFocusJs = require("./helpers/getNextFocus.js");
function useFocus(props, calendar, getModifiers, isSelected, dateLib) {
    const { autoFocus } = props;
    const [lastFocused, setLastFocused] = (0, _react.useState)();
    const focusTarget = (0, _calculateFocusTargetJs.calculateFocusTarget)(calendar.days, getModifiers, isSelected || (()=>false), lastFocused);
    const [focusedDay, setFocused] = (0, _react.useState)(autoFocus ? focusTarget : undefined);
    const blur = ()=>{
        setLastFocused(focusedDay);
        setFocused(undefined);
    };
    const moveFocus = (moveBy, moveDir)=>{
        if (!focusedDay) return;
        const nextFocus = (0, _getNextFocusJs.getNextFocus)(moveBy, moveDir, focusedDay, calendar.navStart, calendar.navEnd, props, dateLib);
        if (!nextFocus) return;
        if (props.disableNavigation) {
            const isNextInCalendar = calendar.days.some((day)=>day.isEqualTo(nextFocus));
            if (!isNextInCalendar) return;
        }
        calendar.goToDay(nextFocus);
        setFocused(nextFocus);
    };
    const isFocusTarget = (day)=>{
        return Boolean(focusTarget?.isEqualTo(day));
    };
    const useFocus = {
        isFocusTarget,
        setFocused,
        focused: focusedDay,
        blur,
        moveFocus
    };
    return useFocus;
}

},{"react":"2o0ib","./helpers/calculateFocusTarget.js":"h2aS4","./helpers/getNextFocus.js":"2Mhc6","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h2aS4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Calculates the focus target day based on priority.
 *
 * This function determines the day that should receive focus in the calendar,
 * prioritizing days with specific modifiers (e.g., "focused", "today") or
 * selection states.
 *
 * @param days The array of `CalendarDay` objects to evaluate.
 * @param getModifiers A function to retrieve the modifiers for a given day.
 * @param isSelected A function to determine if a day is selected.
 * @param lastFocused The last focused day, if any.
 * @returns The `CalendarDay` that should receive focus, or `undefined` if no
 *   focusable day is found.
 */ parcelHelpers.export(exports, "calculateFocusTarget", ()=>calculateFocusTarget);
var _uiJs = require("../UI.js");
var FocusTargetPriority;
(function(FocusTargetPriority) {
    FocusTargetPriority[FocusTargetPriority["Today"] = 0] = "Today";
    FocusTargetPriority[FocusTargetPriority["Selected"] = 1] = "Selected";
    FocusTargetPriority[FocusTargetPriority["LastFocused"] = 2] = "LastFocused";
    FocusTargetPriority[FocusTargetPriority["FocusedModifier"] = 3] = "FocusedModifier";
})(FocusTargetPriority || (FocusTargetPriority = {}));
/**
 * Determines if a day is focusable based on its modifiers.
 *
 * A day is considered focusable if it is not disabled, hidden, or outside the
 * displayed month.
 *
 * @param modifiers The modifiers applied to the day.
 * @returns `true` if the day is focusable, otherwise `false`.
 */ function isFocusableDay(modifiers) {
    return !modifiers[(0, _uiJs.DayFlag).disabled] && !modifiers[(0, _uiJs.DayFlag).hidden] && !modifiers[(0, _uiJs.DayFlag).outside];
}
function calculateFocusTarget(days, getModifiers, isSelected, lastFocused) {
    let focusTarget;
    let foundFocusTargetPriority = -1;
    for (const day of days){
        const modifiers = getModifiers(day);
        if (isFocusableDay(modifiers)) {
            if (modifiers[(0, _uiJs.DayFlag).focused] && foundFocusTargetPriority < FocusTargetPriority.FocusedModifier) {
                focusTarget = day;
                foundFocusTargetPriority = FocusTargetPriority.FocusedModifier;
            } else if (lastFocused?.isEqualTo(day) && foundFocusTargetPriority < FocusTargetPriority.LastFocused) {
                focusTarget = day;
                foundFocusTargetPriority = FocusTargetPriority.LastFocused;
            } else if (isSelected(day.date) && foundFocusTargetPriority < FocusTargetPriority.Selected) {
                focusTarget = day;
                foundFocusTargetPriority = FocusTargetPriority.Selected;
            } else if (modifiers[(0, _uiJs.DayFlag).today] && foundFocusTargetPriority < FocusTargetPriority.Today) {
                focusTarget = day;
                foundFocusTargetPriority = FocusTargetPriority.Today;
            }
        }
    }
    if (!focusTarget) // Return the first day that is focusable
    focusTarget = days.find((day)=>isFocusableDay(getModifiers(day)));
    return focusTarget;
}

},{"../UI.js":"22uOo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2Mhc6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines the next focusable day in the calendar.
 *
 * This function recursively calculates the next focusable day based on the
 * movement direction and modifiers applied to the days.
 *
 * @param moveBy The unit of movement (e.g., "day", "week").
 * @param moveDir The direction of movement ("before" or "after").
 * @param refDay The currently focused day.
 * @param calendarStartMonth The earliest month the user can navigate to.
 * @param calendarEndMonth The latest month the user can navigate to.
 * @param props The DayPicker props, including modifiers and configuration
 *   options.
 * @param dateLib The date library to use for date manipulation.
 * @param attempt The current recursion attempt (used to limit recursion depth).
 * @returns The next focusable day, or `undefined` if no focusable day is found.
 */ parcelHelpers.export(exports, "getNextFocus", ()=>getNextFocus);
var _indexJs = require("../classes/index.js");
var _dateMatchModifiersJs = require("../utils/dateMatchModifiers.js");
var _getFocusableDateJs = require("./getFocusableDate.js");
function getNextFocus(moveBy, moveDir, refDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt = 0) {
    if (attempt > 365) // Limit the recursion to 365 attempts
    return undefined;
    const focusableDate = (0, _getFocusableDateJs.getFocusableDate)(moveBy, moveDir, refDay.date, calendarStartMonth, calendarEndMonth, props, dateLib);
    const isDisabled = Boolean(props.disabled && (0, _dateMatchModifiersJs.dateMatchModifiers)(focusableDate, props.disabled, dateLib));
    const isHidden = Boolean(props.hidden && (0, _dateMatchModifiersJs.dateMatchModifiers)(focusableDate, props.hidden, dateLib));
    const targetMonth = focusableDate;
    const focusDay = new (0, _indexJs.CalendarDay)(focusableDate, targetMonth, dateLib);
    if (!isDisabled && !isHidden) return focusDay;
    // Recursively attempt to find the next focusable date
    return getNextFocus(moveBy, moveDir, focusDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt + 1);
}

},{"../classes/index.js":"dgHSe","../utils/dateMatchModifiers.js":"9bx0J","./getFocusableDate.js":"28VVG","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"28VVG":[function(require,module,exports,__globalThis) {
/**
 * Calculates the next date that should be focused in the calendar.
 *
 * This function determines the next focusable date based on the movement
 * direction, constraints, and calendar configuration.
 *
 * @param moveBy The unit of movement (e.g., "day", "week").
 * @param moveDir The direction of movement ("before" or "after").
 * @param refDate The reference date from which to calculate the next focusable
 *   date.
 * @param navStart The earliest date the user can navigate to.
 * @param navEnd The latest date the user can navigate to.
 * @param props The DayPicker props, including calendar configuration options.
 * @param dateLib The date library to use for date manipulation.
 * @returns The next focusable date.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFocusableDate", ()=>getFocusableDate);
function getFocusableDate(moveBy, moveDir, refDate, navStart, navEnd, props, dateLib) {
    const { ISOWeek, broadcastCalendar } = props;
    const { addDays, addMonths, addWeeks, addYears, endOfBroadcastWeek, endOfISOWeek, endOfWeek, max, min, startOfBroadcastWeek, startOfISOWeek, startOfWeek } = dateLib;
    const moveFns = {
        day: addDays,
        week: addWeeks,
        month: addMonths,
        year: addYears,
        startOfWeek: (date)=>broadcastCalendar ? startOfBroadcastWeek(date, dateLib) : ISOWeek ? startOfISOWeek(date) : startOfWeek(date),
        endOfWeek: (date)=>broadcastCalendar ? endOfBroadcastWeek(date) : ISOWeek ? endOfISOWeek(date) : endOfWeek(date)
    };
    let focusableDate = moveFns[moveBy](refDate, moveDir === "after" ? 1 : -1);
    if (moveDir === "before" && navStart) focusableDate = max([
        navStart,
        focusableDate
    ]);
    else if (moveDir === "after" && navEnd) focusableDate = min([
        navEnd,
        focusableDate
    ]);
    return focusableDate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9D8vB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines the appropriate selection hook to use based on the selection mode
 * and returns the corresponding selection object.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param dateLib - The date utility library instance.
 * @returns The selection object for the specified mode, or `undefined` if no
 *   mode is set.
 */ parcelHelpers.export(exports, "useSelection", ()=>useSelection);
var _useMultiJs = require("./selection/useMulti.js");
var _useRangeJs = require("./selection/useRange.js");
var _useSingleJs = require("./selection/useSingle.js");
function useSelection(props, dateLib) {
    const single = (0, _useSingleJs.useSingle)(props, dateLib);
    const multi = (0, _useMultiJs.useMulti)(props, dateLib);
    const range = (0, _useRangeJs.useRange)(props, dateLib);
    switch(props.mode){
        case "single":
            return single;
        case "multiple":
            return multi;
        case "range":
            return range;
        default:
            return undefined;
    }
}

},{"./selection/useMulti.js":"fIsba","./selection/useRange.js":"6fHR1","./selection/useSingle.js":"i35Pr","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fIsba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook to manage multiple-date selection in the DayPicker component.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param dateLib - The date utility library instance.
 * @returns An object containing the selected dates, a function to select dates,
 *   and a function to check if a date is selected.
 */ parcelHelpers.export(exports, "useMulti", ()=>useMulti);
var _useControlledValueJs = require("../helpers/useControlledValue.js");
function useMulti(props, dateLib) {
    const { selected: initiallySelected, required, onSelect } = props;
    const [internallySelected, setSelected] = (0, _useControlledValueJs.useControlledValue)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const { isSameDay } = dateLib;
    const isSelected = (date)=>{
        return selected?.some((d)=>isSameDay(d, date)) ?? false;
    };
    const { min, max } = props;
    const select = (triggerDate, modifiers, e)=>{
        let newDates = [
            ...selected ?? []
        ];
        if (isSelected(triggerDate)) {
            if (selected?.length === min) // Min value reached, do nothing
            return;
            if (required && selected?.length === 1) // Required value already selected do nothing
            return;
            newDates = selected?.filter((d)=>!isSameDay(d, triggerDate));
        } else if (selected?.length === max) // Max value reached, reset the selection to date
        newDates = [
            triggerDate
        ];
        else // Add the date to the selection
        newDates = [
            ...newDates,
            triggerDate
        ];
        if (!onSelect) setSelected(newDates);
        onSelect?.(newDates, triggerDate, modifiers, e);
        return newDates;
    };
    return {
        selected,
        select,
        isSelected
    };
}

},{"../helpers/useControlledValue.js":"dVNGG","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6fHR1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook to manage range selection in the DayPicker component.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param dateLib - The date utility library instance.
 * @returns An object containing the selected range, a function to select a
 *   range, and a function to check if a date is within the range.
 */ parcelHelpers.export(exports, "useRange", ()=>useRange);
var _useControlledValueJs = require("../helpers/useControlledValue.js");
var _indexJs = require("../utils/index.js");
var _rangeIncludesDateJs = require("../utils/rangeIncludesDate.js");
function useRange(props, dateLib) {
    const { disabled, excludeDisabled, resetOnSelect, selected: initiallySelected, required, onSelect } = props;
    const [internallySelected, setSelected] = (0, _useControlledValueJs.useControlledValue)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const isSelected = (date)=>selected && (0, _rangeIncludesDateJs.rangeIncludesDate)(selected, date, false, dateLib);
    const select = (triggerDate, modifiers, e)=>{
        const { min, max } = props;
        let newRange;
        if (triggerDate) {
            const selectedFrom = selected?.from;
            const selectedTo = selected?.to;
            const hasFullRange = !!selectedFrom && !!selectedTo;
            const isClickingSingleDayRange = !!selectedFrom && !!selectedTo && dateLib.isSameDay(selectedFrom, selectedTo) && dateLib.isSameDay(triggerDate, selectedFrom);
            if (resetOnSelect && (hasFullRange || !selected?.from)) {
                if (!required && isClickingSingleDayRange) newRange = undefined;
                else newRange = {
                    from: triggerDate,
                    to: undefined
                };
            } else newRange = (0, _indexJs.addToRange)(triggerDate, selected, min, max, required, dateLib);
        }
        if (excludeDisabled && disabled && newRange?.from && newRange.to) {
            if ((0, _indexJs.rangeContainsModifiers)({
                from: newRange.from,
                to: newRange.to
            }, disabled, dateLib)) {
                // if a disabled days is found, the range is reset
                newRange.from = triggerDate;
                newRange.to = undefined;
            }
        }
        if (!onSelect) setSelected(newRange);
        onSelect?.(newRange, triggerDate, modifiers, e);
        return newRange;
    };
    return {
        selected,
        select,
        isSelected
    };
}

},{"../helpers/useControlledValue.js":"dVNGG","../utils/index.js":[["addToRange","iM9A4"],["rangeContainsModifiers","cmscm"]],"../utils/rangeIncludesDate.js":"3Wo9X","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iM9A4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Adds a date to an existing range, considering constraints like minimum and
 * maximum range size.
 *
 * @param date - The date to add to the range.
 * @param initialRange - The initial range to which the date will be added.
 * @param min - The minimum number of days in the range.
 * @param max - The maximum number of days in the range.
 * @param required - Whether the range must always include at least one date.
 * @param dateLib - The date utility library instance.
 * @returns The updated date range, or `undefined` if the range is cleared.
 * @group Utilities
 */ parcelHelpers.export(exports, "addToRange", ()=>addToRange);
var _dateLibJs = require("../classes/DateLib.js");
function addToRange(date, initialRange, min = 0, max = 0, required = false, dateLib = (0, _dateLibJs.defaultDateLib)) {
    const { from, to } = initialRange || {};
    const { isSameDay, isAfter, isBefore } = dateLib;
    let range;
    if (!from && !to) // the range is empty, add the date
    range = {
        from: date,
        to: min > 0 ? undefined : date
    };
    else if (from && !to) {
        // adding date to an incomplete range
        if (isSameDay(from, date)) {
            // adding a date equal to the start of the range
            if (min === 0) range = {
                from,
                to: date
            };
            else if (required) range = {
                from,
                to: undefined
            };
            else range = undefined;
        } else if (isBefore(date, from)) // adding a date before the start of the range
        range = {
            from: date,
            to: from
        };
        else // adding a date after the start of the range
        range = {
            from,
            to: date
        };
    } else if (from && to) {
        // adding date to a complete range
        if (isSameDay(from, date) && isSameDay(to, date)) {
            // adding a date that is equal to both start and end of the range
            if (required) range = {
                from,
                to
            };
            else range = undefined;
        } else if (isSameDay(from, date)) // adding a date equal to the the start of the range
        range = {
            from,
            to: min > 0 ? undefined : date
        };
        else if (isSameDay(to, date)) // adding a dare equal to the end of the range
        range = {
            from: date,
            to: min > 0 ? undefined : date
        };
        else if (isBefore(date, from)) // adding a date before the start of the range
        range = {
            from: date,
            to: to
        };
        else if (isAfter(date, from)) // adding a date after the start of the range
        range = {
            from,
            to: date
        };
        else if (isAfter(date, to)) // adding a date after the end of the range
        range = {
            from,
            to: date
        };
        else throw new Error("Invalid range");
    }
    // check for min / max
    if (range?.from && range?.to) {
        const diff = dateLib.differenceInCalendarDays(range.to, range.from);
        if (max > 0 && diff > max) range = {
            from: date,
            to: undefined
        };
        else if (min > 1 && diff < min) range = {
            from: date,
            to: undefined
        };
    }
    return range;
}

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cmscm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a date range contains dates that match the given modifiers.
 *
 * @since 9.2.2
 * @param range - The date range to check.
 * @param modifiers - The modifiers to match against.
 * @param dateLib - The date utility library instance.
 * @returns `true` if the range contains matching dates, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "rangeContainsModifiers", ()=>rangeContainsModifiers);
var _dateLibJs = require("../classes/DateLib.js");
var _dateMatchModifiersJs = require("./dateMatchModifiers.js");
var _rangeContainsDayOfWeekJs = require("./rangeContainsDayOfWeek.js");
var _rangeIncludesDateJs = require("./rangeIncludesDate.js");
var _rangeOverlapsJs = require("./rangeOverlaps.js");
var _typeguardsJs = require("./typeguards.js");
function rangeContainsModifiers(range, modifiers, dateLib = (0, _dateLibJs.defaultDateLib)) {
    const matchers = Array.isArray(modifiers) ? modifiers : [
        modifiers
    ];
    // Defer function matchers evaluation as they are the least performant.
    const nonFunctionMatchers = matchers.filter((matcher)=>typeof matcher !== "function");
    const nonFunctionMatchersResult = nonFunctionMatchers.some((matcher)=>{
        if (typeof matcher === "boolean") return matcher;
        if (dateLib.isDate(matcher)) return (0, _rangeIncludesDateJs.rangeIncludesDate)(range, matcher, false, dateLib);
        if ((0, _typeguardsJs.isDatesArray)(matcher, dateLib)) return matcher.some((date)=>(0, _rangeIncludesDateJs.rangeIncludesDate)(range, date, false, dateLib));
        if ((0, _typeguardsJs.isDateRange)(matcher)) {
            if (matcher.from && matcher.to) return (0, _rangeOverlapsJs.rangeOverlaps)(range, {
                from: matcher.from,
                to: matcher.to
            }, dateLib);
            return false;
        }
        if ((0, _typeguardsJs.isDayOfWeekType)(matcher)) return (0, _rangeContainsDayOfWeekJs.rangeContainsDayOfWeek)(range, matcher.dayOfWeek, dateLib);
        if ((0, _typeguardsJs.isDateInterval)(matcher)) {
            const isClosedInterval = dateLib.isAfter(matcher.before, matcher.after);
            if (isClosedInterval) return (0, _rangeOverlapsJs.rangeOverlaps)(range, {
                from: dateLib.addDays(matcher.after, 1),
                to: dateLib.addDays(matcher.before, -1)
            }, dateLib);
            return (0, _dateMatchModifiersJs.dateMatchModifiers)(range.from, matcher, dateLib) || (0, _dateMatchModifiersJs.dateMatchModifiers)(range.to, matcher, dateLib);
        }
        if ((0, _typeguardsJs.isDateAfterType)(matcher) || (0, _typeguardsJs.isDateBeforeType)(matcher)) return (0, _dateMatchModifiersJs.dateMatchModifiers)(range.from, matcher, dateLib) || (0, _dateMatchModifiersJs.dateMatchModifiers)(range.to, matcher, dateLib);
        return false;
    });
    if (nonFunctionMatchersResult) return true;
    const functionMatchers = matchers.filter((matcher)=>typeof matcher === "function");
    if (functionMatchers.length) {
        let date = range.from;
        const totalDays = dateLib.differenceInCalendarDays(range.to, range.from);
        for(let i = 0; i <= totalDays; i++){
            if (functionMatchers.some((matcher)=>matcher(date))) return true;
            date = dateLib.addDays(date, 1);
        }
    }
    return false;
}

},{"../classes/DateLib.js":"6ev8G","./dateMatchModifiers.js":"9bx0J","./rangeContainsDayOfWeek.js":"8rvgp","./rangeIncludesDate.js":"3Wo9X","./rangeOverlaps.js":"b3hgg","./typeguards.js":"keGkS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8rvgp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a date range contains one or more specified days of the week.
 *
 * @since 9.2.2
 * @param range - The date range to check.
 * @param dayOfWeek - The day(s) of the week to check for (`0-6`, where `0` is
 *   Sunday).
 * @param dateLib - The date utility library instance.
 * @returns `true` if the range contains the specified day(s) of the week,
 *   otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "rangeContainsDayOfWeek", ()=>rangeContainsDayOfWeek);
var _dateLibJs = require("../classes/DateLib.js");
function rangeContainsDayOfWeek(range, dayOfWeek, dateLib = (0, _dateLibJs.defaultDateLib)) {
    const dayOfWeekArr = !Array.isArray(dayOfWeek) ? [
        dayOfWeek
    ] : dayOfWeek;
    let date = range.from;
    const totalDays = dateLib.differenceInCalendarDays(range.to, range.from);
    // iterate at maximum one week or the total days if the range is shorter than one week
    const totalDaysLimit = Math.min(totalDays, 6);
    for(let i = 0; i <= totalDaysLimit; i++){
        if (dayOfWeekArr.includes(date.getDay())) return true;
        date = dateLib.addDays(date, 1);
    }
    return false;
}

},{"../classes/DateLib.js":"6ev8G","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"b3hgg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines if two date ranges overlap.
 *
 * @since 9.2.2
 * @param rangeLeft - The first date range.
 * @param rangeRight - The second date range.
 * @param dateLib - The date utility library instance.
 * @returns `true` if the ranges overlap, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "rangeOverlaps", ()=>rangeOverlaps);
var _indexJs = require("../classes/index.js");
var _rangeIncludesDateJs = require("./rangeIncludesDate.js");
function rangeOverlaps(rangeLeft, rangeRight, dateLib = (0, _indexJs.defaultDateLib)) {
    return (0, _rangeIncludesDateJs.rangeIncludesDate)(rangeLeft, rangeRight.from, false, dateLib) || (0, _rangeIncludesDateJs.rangeIncludesDate)(rangeLeft, rangeRight.to, false, dateLib) || (0, _rangeIncludesDateJs.rangeIncludesDate)(rangeRight, rangeLeft.from, false, dateLib) || (0, _rangeIncludesDateJs.rangeIncludesDate)(rangeRight, rangeLeft.to, false, dateLib);
}

},{"../classes/index.js":"6ev8G","./rangeIncludesDate.js":"3Wo9X","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i35Pr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook to manage single-date selection in the DayPicker component.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param dateLib - The date utility library instance.
 * @returns An object containing the selected date, a function to select a date,
 *   and a function to check if a date is selected.
 */ parcelHelpers.export(exports, "useSingle", ()=>useSingle);
var _useControlledValueJs = require("../helpers/useControlledValue.js");
function useSingle(props, dateLib) {
    const { selected: initiallySelected, required, onSelect } = props;
    const [internallySelected, setSelected] = (0, _useControlledValueJs.useControlledValue)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const { isSameDay } = dateLib;
    const isSelected = (compareDate)=>{
        return selected ? isSameDay(selected, compareDate) : false;
    };
    const select = (triggerDate, modifiers, e)=>{
        let newDate = triggerDate;
        if (!required && selected && selected && isSameDay(triggerDate, selected)) // If the date is the same, clear the selection.
        newDate = undefined;
        if (!onSelect) setSelected(newDate);
        if (required) onSelect?.(newDate, triggerDate, modifiers, e);
        else onSelect?.(newDate, triggerDate, modifiers, e);
        return newDate;
    };
    return {
        selected,
        select,
        isSelected
    };
}

},{"../helpers/useControlledValue.js":"dVNGG","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3B52M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert any {@link Matcher} or array of matchers to the specified time zone.
 *
 * @param matchers - The matcher or matchers to convert.
 * @param timeZone - The target IANA time zone.
 * @returns The converted matcher(s).
 * @group Utilities
 */ parcelHelpers.export(exports, "convertMatchersToTimeZone", ()=>convertMatchersToTimeZone);
var _tz = require("@date-fns/tz");
var _toTimeZoneJs = require("./toTimeZone.js");
var _typeguardsJs = require("./typeguards.js");
function toZoneNoon(date, timeZone, noonSafe) {
    if (!noonSafe) return (0, _toTimeZoneJs.toTimeZone)(date, timeZone);
    const zoned = (0, _toTimeZoneJs.toTimeZone)(date, timeZone);
    const noonZoned = new (0, _tz.TZDate)(zoned.getFullYear(), zoned.getMonth(), zoned.getDate(), 12, 0, 0, timeZone);
    return new Date(noonZoned.getTime());
}
function convertMatcher(matcher, timeZone, noonSafe) {
    if (typeof matcher === "boolean" || typeof matcher === "function") return matcher;
    if (matcher instanceof Date) return toZoneNoon(matcher, timeZone, noonSafe);
    if (Array.isArray(matcher)) return matcher.map((value)=>value instanceof Date ? toZoneNoon(value, timeZone, noonSafe) : value);
    if ((0, _typeguardsJs.isDateRange)(matcher)) return {
        ...matcher,
        from: matcher.from ? (0, _toTimeZoneJs.toTimeZone)(matcher.from, timeZone) : matcher.from,
        to: matcher.to ? (0, _toTimeZoneJs.toTimeZone)(matcher.to, timeZone) : matcher.to
    };
    if ((0, _typeguardsJs.isDateInterval)(matcher)) return {
        before: toZoneNoon(matcher.before, timeZone, noonSafe),
        after: toZoneNoon(matcher.after, timeZone, noonSafe)
    };
    if ((0, _typeguardsJs.isDateAfterType)(matcher)) return {
        after: toZoneNoon(matcher.after, timeZone, noonSafe)
    };
    if ((0, _typeguardsJs.isDateBeforeType)(matcher)) return {
        before: toZoneNoon(matcher.before, timeZone, noonSafe)
    };
    return matcher;
}
function convertMatchersToTimeZone(matchers, timeZone, noonSafe) {
    if (!matchers) return matchers;
    if (Array.isArray(matchers)) return matchers.map((matcher)=>convertMatcher(matcher, timeZone, noonSafe));
    return convertMatcher(matchers, timeZone, noonSafe);
}

},{"@date-fns/tz":"74xQL","./toTimeZone.js":"7IESI","./typeguards.js":"keGkS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7IESI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert a {@link Date} or {@link TZDate} instance to the given time zone.
 * Reuses the same instance when it is already a {@link TZDate} using the target
 * time zone to avoid extra allocations.
 */ parcelHelpers.export(exports, "toTimeZone", ()=>toTimeZone);
var _tz = require("@date-fns/tz");
function toTimeZone(date, timeZone) {
    if (date instanceof (0, _tz.TZDate) && date.timeZone === timeZone) return date;
    return new (0, _tz.TZDate)(date, timeZone);
}

},{"@date-fns/tz":"74xQL","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"WDvlF":[function() {},{}],"4upf9":[function() {},{}],"gZ09A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _zustand = require("zustand");
exports.default = (0, _zustand.create)((set)=>({
        activeTab: false,
        setActiveTab: (activeTab)=>set({
                activeTab
            })
    }));

},{"zustand":"61uwS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"f6HuX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectOffer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// import RadioOption from 'Core/components/Option/RadioOption';
var _financingNotEligible = require("Modules/financing/components/FinancingNotEligible");
var _financingNotEligibleDefault = parcelHelpers.interopDefault(_financingNotEligible);
var _orfferOptions = require("Modules/financing/components/OrfferOptions");
var _orfferOptionsDefault = parcelHelpers.interopDefault(_orfferOptions);
var _button = require("Core/components/Button");
var _financingTabNames = require("../config/financingTabNames");
var _fa = require("react-icons/fa");
var _sortInstallmentOffers = require("Modules/financing/SelectOffer/sortInstallmentOffers");
var _sortInstallmentOffersDefault = parcelHelpers.interopDefault(_sortInstallmentOffers);
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function SelectOffer({ offers, selectedOffer, setSelectedOffer, enableSignContract, handleTabChange, amount_to_pay, already_paid_amount, routes, selected_offer_id }) {
    const [isAnyOfferValid, setIsAnyOfferValid] = (0, _reactDefault.default).useState(true);
    const [showOfferDetails, setShowOfferDetails] = (0, _reactDefault.default).useState(false);
    const [sortedOffers, setSortedOffers] = (0, _reactDefault.default).useState(null);
    const { data: { provider = '' } = {} } = (0, _useGetPaymentInfo.useGetPaymentInfo)() || {};
    (0, _reactDefault.default).useEffect(()=>{
        if (offers?.installment) {
            if (selected_offer_id) {
                const { type = '', terms = [] } = offers.installment.find((item)=>item.terms[0].id === selected_offer_id) || {};
                setSelectedOffer({
                    id: selected_offer_id,
                    amount_min: terms[0]?.amount_min,
                    require_downpayment_percent: terms[0]?.require_downpayment_percent,
                    type
                });
            } else if (offers.installment.length > 0) {
                const anyValid = offers.installment.some(({ terms })=>{
                    const [{ amount_min, require_downpayment_percent }] = terms;
                    const finalAmountMin = Math.max(amount_min, amount_to_pay * require_downpayment_percent);
                    return amount_to_pay - already_paid_amount > finalAmountMin;
                });
                setIsAnyOfferValid(anyValid);
            }
        }
    }, [
        already_paid_amount,
        amount_to_pay,
        offers.installment,
        sortedOffers,
        selected_offer_id,
        setSelectedOffer
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (offers?.installment && provider === 'ALLEGRO_CASH') {
            const sortedOfrs = (0, _sortInstallmentOffersDefault.default)(offers.installment);
            setSortedOffers({
                installment: sortedOfrs
            });
        } else setSortedOffers(offers);
    }, [
        offers,
        provider
    ]);
    const toggleOfferDetails = ()=>{
        setShowOfferDetails((prev)=>!prev);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex justify-center",
                children: isAnyOfferValid ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orfferOptionsDefault.default), {
                    offers: sortedOffers ? sortedOffers : offers,
                    selectedOffer: selectedOffer,
                    setSelectedOffer: setSelectedOffer,
                    amount_to_pay: amount_to_pay,
                    already_paid_amount: already_paid_amount,
                    showOfferDetails: showOfferDetails
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingNotEligibleDefault.default), {
                    already_paid_amount: already_paid_amount,
                    amount_to_pay: amount_to_pay,
                    routes: routes
                })
            }),
            isAnyOfferValid && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex justify-center pt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.LinkButton), {
                            onClick: toggleOfferDetails,
                            children: showOfferDetails ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaChevronUp), {}),
                                    " Hide Offer Details"
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaChevronDown), {}),
                                    " Show Offer Details"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            "data-testid": "btn-next",
                            disabled: !enableSignContract && !selectedOffer.id,
                            className: "w-48 mt-4",
                            onClick: ()=>handleTabChange((0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY),
                            children: "Next"
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/financing/components/FinancingNotEligible":"l7dkO","Modules/financing/components/OrfferOptions":"30Lcw","Core/components/Button":"6YNzH","../config/financingTabNames":"do2dN","react-icons/fa":"9Vrsi","Modules/financing/SelectOffer/sortInstallmentOffers":"gc5N9","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"l7dkO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingNotEligible);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _numberFormat = require("Core/utils/numberFormat");
var _layout = require("Core/components/Layout");
var _utils = require("Core/utils/utils");
var _alert = require("Core/components/Alert");
var _button = require("Core/components/Button");
function FinancingNotEligible({ already_paid_amount, amount_to_pay, routes }) {
    const [isModalOpen, setIsModalOpen] = (0, _reactDefault.default).useState(false);
    const onOpenConfirmationPopup = ()=>{
        setIsModalOpen(true);
    };
    const onCollectPayment = ()=>{
        const url = (0, _utils.generateURL)({
            url: routes?.payment
        });
        window.open(url, '_self');
    };
    const onModalClose = ()=>{
        setIsModalOpen(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "justify-center flex-col items-center w-full",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "font-regular text-large w-full",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                            showIcon: true,
                            type: "warningLight",
                            title: "correction required",
                            "data-testid": "message-not-eligible",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "font-bold",
                                    children: "Financing amount too low!"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Your application is approved. However, you have an available credit of\xa0"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "font-bold",
                                    children: [
                                        "(",
                                        (0, _numberFormat.formatCurrency)(already_paid_amount),
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "\xa0so the amount to be financed\xa0"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "font-bold",
                                    children: [
                                        "(",
                                        (0, _numberFormat.formatCurrency)(amount_to_pay - already_paid_amount),
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "\xa0is lower than the minimum eligible amount that can be financed. You can click on the button below to complete the remaining amount instead of financing it."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "text-center text-gray-400 w-1/3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            "data-testid": "btn-collect-payment",
                            block: true,
                            onClick: onOpenConfirmationPopup,
                            children: "Collect Payment"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
                isOpen: isModalOpen,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "font-bold text-center",
                        children: "Are you sure you want to proceed to Payment Collection?"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-6 text-center",
                        "data-testid": "title-autopay-redirect",
                        children: "You will leave the financing application and be redirected to the payment collection portal"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-end justify-end gap-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                                type: "button",
                                onClick: onModalClose,
                                "data-testid": "btn-modal-cancel",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                type: "button",
                                onClick: onCollectPayment,
                                "data-testid": "btn-modal-confirm",
                                children: "Confirm"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/utils/numberFormat":"6T56F","Core/components/Layout":"hweet","Core/utils/utils":"hwOBZ","Core/components/Alert":"fmmNR","Core/components/Button":"6YNzH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"30Lcw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OfferOptions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _numberFormat = require("Core/utils/numberFormat");
var _verticalRadioOption = require("Core/components/VerticalOption/VerticalRadioOption");
var _verticalRadioOptionDefault = parcelHelpers.interopDefault(_verticalRadioOption);
var _im = require("react-icons/im");
var _offerTagConfig = require("Modules/financing/config/offerTagConfig");
var _offerTagConfigDefault = parcelHelpers.interopDefault(_offerTagConfig);
var _reactI18Next = require("react-i18next");
var _offerOptionsHeader = require("./OfferOptionsHeader");
var _offerOptionsHeaderDefault = parcelHelpers.interopDefault(_offerOptionsHeader);
const USE_DERIVED_TITLE = true;
function OfferOptions({ offers, selectedOffer, setSelectedOffer, amount_to_pay, already_paid_amount, showOfferDetails }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    // List of abbreviations to exclude from sentence splitting
    const abbreviationExclusions = [
        'Mo'
    ];
    const splitSentences = (text)=>{
        if (!text) return [];
        // Create a regex pattern that matches periods NOT preceded by abbreviations
        // This uses a negative lookbehind to exclude our abbreviations
        const abbreviationsPattern = abbreviationExclusions.join('|');
        const regex = new RegExp(`(?<!\\b(?:${abbreviationsPattern}))\\.\\s+`, 'g');
        const sentences = text.split(regex).map((sentence)=>sentence.trim()).filter((sentence)=>sentence.length > 0);
        // Add back the period to each sentence (except if it already ends with one)
        return sentences.map((sentence)=>{
            if (sentence.endsWith('.')) return sentence;
            return sentence + '.';
        });
    };
    const getEstimatedMonthlyPayment = (principle, num_of_months, rate, promoDays)=>{
        // Legacy applications are quoted as a flat split of the full amount, with no interest.
        if (promoDays) {
            if (!amount_to_pay) return '';
            return (0, _numberFormat.formatCurrency)(amount_to_pay / (0, _offerOptionsHeader.LEGACY_MONTHS_TO_PAY), {
                withDecimals: true
            });
        }
        if (rate && principle && num_of_months) {
            const monthly_rate = rate / 100 / 12;
            const monthly_rate_inc = monthly_rate + 1;
            const est_monthly_payment_min = principle * monthly_rate * Math.pow(monthly_rate_inc, num_of_months) / (Math.pow(monthly_rate_inc, num_of_months) - 1);
            return (0, _numberFormat.formatCurrency)(est_monthly_payment_min, {
                withDecimals: true
            });
        }
        return '';
    };
    return offers.installment.map(({ program, terms, description, type }, idx)=>{
        const [{ id, amount_min, require_downpayment_percent, apr, term, waived_interest: { days: promoTermDays } = {} }] = terms;
        const checked = selectedOffer.id === id;
        const isDisabled = amount_to_pay - already_paid_amount < amount_min;
        const emp_min = getEstimatedMonthlyPayment(amount_to_pay, term, apr, promoTermDays);
        const promoTerm = (promoTermDays / 365 * 12).toFixed(0);
        const isPromo = promoTermDays > 0;
        const getDerivedTitle = ()=>{
            if (isPromo) return `${term} mo. \u{2014} no interest for ${promoTerm} mo.`;
            return `${term} mo. at ${apr.toFixed(2)}% APR`;
        };
        const title = USE_DERIVED_TITLE ? getDerivedTitle() : program;
        const getTag = ()=>{
            if ((0, _offerTagConfigDefault.default)?.length > 0) {
                const tagObject = (0, _offerTagConfigDefault.default).find((tagObj)=>{
                    return tagObj.offerIds.some((itemId)=>id === itemId);
                });
                return tagObject?.tagLabel ? t(tagObject.tagLabel) : null;
            }
            return null;
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `!flex-col-4 min-h-[15em] first:pl-0 last:pr-0 px-2 transition-all duration-300 ${checked ? 'scale-105 z-10' : 'scale-100'}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _verticalRadioOptionDefault.default), {
                className: `mb-3 justify-between transition-all duration-300 ${checked ? 'ring-4 ring-blue-500 shadow-2xl shadow-blue-500/50 border-blue-500' : 'shadow-md hover:shadow-lg'}`,
                name: "offer",
                value: id,
                checked: checked,
                disabled: isDisabled,
                "data-testid": 'select-offer-radio-' + idx,
                tag: getTag(),
                onChange: (e)=>{
                    setSelectedOffer({
                        id: e.target.value,
                        amount_min,
                        require_downpayment_percent,
                        type
                    });
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "text-center flex flex-col pb-2 justify-around radio-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                className: "text-center font-semibold text-sm px-1",
                                children: title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "font-extrabold text-2xl mb-2 py-2",
                                children: emp_min
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "font-light text-sm mb-2",
                                children: "Estimated Monthly Payment"
                            }),
                            !checked && isDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-4 mt-6 text-gray-400 flex items-center justify-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "inline-block",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _im.ImBlocked), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "ml-2",
                                        children: "Not Eligible"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offerOptionsHeaderDefault.default), {
                        isPromo: isPromo,
                        checked: checked,
                        promoTerm: promoTerm,
                        amountToPay: amount_to_pay
                    }),
                    showOfferDetails && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "h-full px-4 radio-description text-sm flex flex-col justify-start",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                            className: "list-none space-y-3 mt-4",
                            children: splitSentences(description?.replaceAll('<br />', ' ')).map((item, ind)=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    className: "flex items-start text-justify text-xs",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "inline-block mr-2 mt-0.5 text-blue-500",
                                            children: "\u2022"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: item
                                        })
                                    ]
                                }, ind);
                            })
                        })
                    })
                ]
            }, id)
        }, id);
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/utils/numberFormat":"6T56F","Core/components/VerticalOption/VerticalRadioOption":"422lU","react-icons/im":"ek0E7","Modules/financing/config/offerTagConfig":"a01eN","react-i18next":"244ua","./OfferOptionsHeader":"5ZwLv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"422lU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>VerticalRadioOption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _verticalRadioOptionStyled = require("./VerticalRadioOption.styled");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ribbon = require("Modules/core/components/Ribbon/Ribbon");
var _ribbonDefault = parcelHelpers.interopDefault(_ribbon);
function VerticalRadioOption({ name, value, checked, disabled, testid, onChange, children, tag }) {
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _verticalRadioOptionStyled.StyledLabel), {
        htmlFor: id,
        "data-testid": testid || id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _verticalRadioOptionStyled.StyledInput), {
                type: "radio",
                name: name,
                value: value,
                id: id,
                checked: checked,
                disabled: disabled,
                onChange: onChange,
                role: "radio"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _verticalRadioOptionStyled.StyledBody), {
                children: [
                    Boolean(tag) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ribbonDefault.default), {
                        label: tag
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _classnamesDefault.default)('w-full flex flex-col h-full justify-between', {
                            'pt-8': !tag
                        }),
                        children: children
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","./VerticalRadioOption.styled":"jVYCm","classnames":"f971Y","Modules/core/components/Ribbon/Ribbon":"e0gb7","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jVYCm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLabel", ()=>StyledLabel);
parcelHelpers.export(exports, "StyledCheckbox", ()=>StyledCheckbox);
parcelHelpers.export(exports, "StyledBody", ()=>StyledBody);
parcelHelpers.export(exports, "StyledButton", ()=>StyledButton);
parcelHelpers.export(exports, "StyledInput", ()=>StyledInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const StyledLabel = ({ children, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
        className: "radio-option radio-vertical h-full !rounded-lg",
        ...rest,
        children: children
    });
const StyledCheckbox = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "radio-option-checkbox",
        children: children
    });
const StyledBody = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: 'radio-option-body h-full !p-0 flex-col rounded-lg',
        children: children
    });
const StyledButton = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "rounded-full border-primary bg-none",
        children: children
    });
const StyledInput = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        ...props,
        className: 'radio-option-input'
    });

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"e0gb7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Ribbon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ribbonCss = require("./Ribbon.css");
function Ribbon({ label }) {
    if (label) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "c_ribbon",
        children: [
            label,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "flair-top-left"
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","./Ribbon.css":"29saG","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"29saG":[function() {},{}],"a01eN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const offerTags = {
    testing: [
        {
            tagLabel: 'common.offers.tags.mostPopular',
            offerIds: [
                'A7C3BF93151598A812CC2637588F806C'
            ]
        }
    ],
    staging: [
        {
            tagLabel: 'common.offers.tags.mostPopular',
            offerIds: [
                'A7C3BF93151598A812CC2637588F806C'
            ]
        }
    ],
    production: [
        {
            tagLabel: 'Most Popular',
            offerIds: [
                '7E11457D690BB8C220C3E73EBD556B33'
            ]
        },
        {
            tagLabel: 'Require Down Payment & Auto Pay',
            offerIds: [
                'FD4335F897B9E77528E05556D64E7F1C',
                '1953DCCC54F3865A0E73DB5A587551A5',
                '91E55B12BB27CA08EC71F0EBC65BC954',
                '9F131E08DFBB2BCC43D2C04311C90AE5',
                'E015FAE5B70DF95FED5F9A275139CDE4'
            ]
        }
    ]
};
exports.default = offerTags["testing"] || [];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5ZwLv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LEGACY_MONTHS_TO_PAY", ()=>LEGACY_MONTHS_TO_PAY);
parcelHelpers.export(exports, "default", ()=>OfferOptionsHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _numberFormat = require("Core/utils/numberFormat");
const LEGACY_MONTHS_TO_PAY = 12;
function OfferOptionsHeader({ isPromo, checked, promoTerm, amountToPay }) {
    if (!isPromo) return null;
    const promoMonthsToPay = LEGACY_MONTHS_TO_PAY;
    const adjustedMonthlyPayment = amountToPay / promoMonthsToPay;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        className: (0, _classnamesDefault.default)('flex justify-between  px-2 py-4 items-center flex-wrap transition-colors duration-300', {
            'bg-gray-300': !isPromo && !checked,
            'bg-blue-200': !isPromo && checked,
            'bg-teal-200': isPromo && !checked,
            'bg-blue-600': isPromo && checked
        }),
        children: isPromo ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)('text-sm px-2 flex-col-12 mt-3', {
                'text-teal-700': !checked,
                'text-white': checked
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Waived interest if paid within ",
                        promoTerm,
                        " months"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: (0, _numberFormat.formatCurrency)(adjustedMonthlyPayment, {
                                withDecimals: true
                            })
                        }),
                        " per month for ",
                        promoMonthsToPay,
                        " months",
                        ' '
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "text-sm text-gray-700 px-4 flex-col-12 mt-8"
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","Core/utils/numberFormat":"6T56F","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gc5N9":[function(require,module,exports,__globalThis) {
/**
 * Sorts installment offers by term (highest first) and then by APR (lowest first)
 * Also renumbers the program field based on the new sorted order
 * @param {Array} offers - Array of installment offers
 * @returns {Array} - Sorted array of installment offers with renumbered programs
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function sortInstallmentOffers(offers) {
    const sortedOffers = offers.sort((a, b)=>{
        // Get the first term from each offer (assuming each offer has at least one term)
        const termA = a.terms[0]?.term || 0;
        const termB = b.terms[0]?.term || 0;
        const aprA = a.terms[0]?.apr || 0;
        const aprB = b.terms[0]?.apr || 0;
        // First sort by term (highest first)
        if (termA !== termB) return termB - termA;
        // If terms are the same, sort by APR (lowest first)
        return aprA - aprB;
    });
    // Renumber the program field based on the new sorted order
    return sortedOffers.map((offer, index)=>{
        // Remove the original numbering from the program field
        const programWithoutNumber = offer.program.replace(/^\d+\.\s*/, '');
        return {
            ...offer,
            program: `${index + 1}. ${programWithoutNumber}`
        };
    });
}
exports.default = sortInstallmentOffers;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4YW9r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useProviderSync);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _providerSyncConfig = require("Modules/financing/config/providerSyncConfig");
const wait = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const hasCartLink = (data)=>Boolean(data?.next_action && data?.payload?.links?.cart);
// Refreshes the application from the provider and polls GET /application for the result.
// Resolves with the refreshed application, or null if it is not ready before the timeout.
// isReady decides which GET /application response counts as the refreshed application.
async function syncApplication(isReady) {
    const { timeoutMs, intervalMs } = (0, _providerSyncConfig.PROVIDER_SYNC_CONFIG);
    const { headers: { request_id } } = await (0, _platformApi.getWithHeaders)('/financing/provider-sync');
    if (!request_id) return null;
    const attempts = Math.floor(timeoutMs / intervalMs);
    for(let attempt = 1; attempt <= attempts; attempt++){
        await wait(intervalMs);
        const data = await (0, _platformApi.get)('/application', {
            headers: {
                request_id
            }
        });
        if (isReady(data)) return data;
    }
    return null;
}
function useProviderSync({ isReady = hasCartLink } = {}) {
    return (0, _reactQuery.useMutation)(()=>syncApplication(isReady).catch(()=>null));
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Modules/financing/config/providerSyncConfig":"gNLYY","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gNLYY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROVIDER_SYNC_CONFIG", ()=>PROVIDER_SYNC_CONFIG);
parcelHelpers.export(exports, "PROVIDER_SYNC_PROVIDERS", ()=>PROVIDER_SYNC_PROVIDERS);
parcelHelpers.export(exports, "PROVIDER_SYNC_NEXT_ACTIONS", ()=>PROVIDER_SYNC_NEXT_ACTIONS);
const PROVIDER_SYNC_CONFIG = {
    timeoutMs: 15000,
    intervalMs: 3000
};
const PROVIDER_SYNC_PROVIDERS = [
    'ALLEGRO',
    'ALLEGRO_CASH',
    'ALL_WELL'
];
const PROVIDER_SYNC_NEXT_ACTIONS = [
    'UPDATE_OFFER',
    'SIGN_CONTRACT'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5xTtk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _canvasConfetti = require("canvas-confetti");
var _canvasConfettiDefault = parcelHelpers.interopDefault(_canvasConfetti);
var _hi2 = require("react-icons/hi2");
var _useGetTransactionHistory = require("Core/hooks/platform/useGetTransactionHistory");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _useGetNextStep = require("../hooks/useGetNextStep");
var _button = require("Core/components/Button");
var _utils = require("Core/utils/utils");
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _routes = require("Modules/financing/routes");
var _icon = require("Core/components/Icon/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _numberFormat = require("Core/utils/numberFormat");
var _logger = require("Core/utils/logger");
var _postExchangeBanner = require("Modules/financing/components/PostExchangeBanner");
var _postExchangeBannerDefault = parcelHelpers.interopDefault(_postExchangeBanner);
const fireConfetti = ()=>{
    const colors = [
        '#10b981',
        '#34d399',
        '#6ee7b7',
        '#fde68a',
        '#ffffff'
    ];
    (0, _canvasConfettiDefault.default)({
        particleCount: 120,
        spread: 80,
        startVelocity: 45,
        origin: {
            x: 0.5,
            y: 0.1
        },
        colors
    });
    setTimeout(()=>{
        (0, _canvasConfettiDefault.default)({
            particleCount: 60,
            angle: 60,
            spread: 55,
            origin: {
                x: 0,
                y: 0.3
            },
            colors
        });
        (0, _canvasConfettiDefault.default)({
            particleCount: 60,
            angle: 120,
            spread: 55,
            origin: {
                x: 1,
                y: 0.3
            },
            colors
        });
    }, 250);
};
const FinancingSuccess = ()=>{
    document.title = 'Payment Portal - Success';
    const { t } = (0, _reactI18Next.useTranslation)();
    const routes = {
        mixed: (0, _routes.mixedDownPaymentCheckoutPath)
    };
    const { data: transactions } = (0, _useGetTransactionHistory.useGetTransactionHistory)();
    const checklistItems = [
        {
            label: t('page.financing.checklist.approved'),
            Icon: (0, _hi2.HiOutlineShieldCheck)
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            Icon: (0, _hi2.HiOutlinePencilSquare)
        },
        {
            label: t('page.financing.checklist.funded'),
            Icon: (0, _hi2.HiOutlineCheckBadge)
        }
    ];
    const [isCollectPaymentLoading, setIsCollectPaymentLoading] = (0, _reactDefault.default).useState(false);
    const [refetchInterval, setRefetchInterval] = (0, _reactDefault.default).useState(false);
    const { data: application, isSuccess: isGetNextStepSuccess, refetch, isFetching } = (0, _useGetNextStep.useGetNextStep)(refetchInterval);
    const { next_action, external_reference_id = '', payload: { financing_down_payment = 0, payment_id = '', application_id = '' } = {} } = application;
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetNextStepSuccess && payment_id && application_id && external_reference_id) (0, _logger.postLogMessage)({
            feature: (0, _logger.features).financingSignContract,
            action: (0, _logger.actions).financingSuccessScreenDisplayed,
            payment_id,
            application_id,
            external_reference_id
        });
    }, [
        isGetNextStepSuccess
    ]);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const confettiFiredRef = (0, _reactDefault.default).useRef(false);
    const onCollectPayment = ()=>{
        const payId = (0, _utils.getUrlParam)('payment-id');
        const web_code = (0, _utils.getUrlParam)('web-code');
        const url = (0, _utils.generateURL)({
            url: routes.mixed,
            params: {
                'payment-id': payId,
                'web-code': web_code
            }
        });
        setIsCollectPaymentLoading(true);
        setRefetchInterval(5000);
        queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
        setTimeout(()=>setIsCollectPaymentLoading(false), 300000);
        window.open(url, '_blank')?.focus();
    };
    (0, _reactDefault.default).useEffect(()=>{
        if (next_action === 'DONE') {
            setRefetchInterval(false);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).transactionHistory);
        }
    }, [
        next_action,
        queryClient
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (confettiFiredRef.current) return;
        if (typeof window === 'undefined') return;
        confettiFiredRef.current = true;
        const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        if (reduced) return;
        fireConfetti();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "mx-auto flex max-w-4xl flex-col gap-5 px-4 pb-10 pt-5 text-slate-900",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _postExchangeBannerDefault.default), {
                    application: application
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "rounded-2xl border border-slate-200 bg-white px-5 py-3 shadow-sm sm:px-7",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-start justify-between gap-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "relative flex h-16 w-16 shrink-0 items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "absolute inset-0 rounded-full bg-green-400/20 blur-md",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "absolute inset-1.5 rounded-full border-2 border-green-500/50 animate-ping motion-reduce:animate-none",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-green-100 text-green-600",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineCheckCircle), {
                                                className: "h-7 w-7"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>refetch(),
                                    disabled: isFetching,
                                    title: "Refresh status",
                                    "data-testid": "refresh-status-button",
                                    className: "inline-flex items-center gap-2 rounded-lg border border-solid border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-600 shadow-sm transition-colors hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900 focus:outline-none focus:ring-2 focus:ring-slate-300 disabled:opacity-50",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineArrowPath), {
                                            className: `h-4 w-4 ${isFetching ? 'animate-spin' : ''}`
                                        }),
                                        "Refresh"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col items-center gap-2 pb-3 pt-2 text-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "m-0 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl",
                                    children: t('page.financing.financingFunded.infobox')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "mx-auto mb-0 max-w-xl text-sm leading-relaxed text-slate-500",
                                    children: t('page.financing.financingFunded.intro')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "rounded-2xl border border-slate-200 bg-white px-6 py-6 shadow-sm sm:px-7",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mx-auto flex w-fit flex-col gap-1",
                            children: checklistItems.map(({ label, Icon: StepIcon })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    "data-testid": "checklist-item-done",
                                    className: "flex items-center gap-3.5 py-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepIcon, {
                                                className: "h-[18px] w-[18px]"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-base text-slate-900",
                                            children: label
                                        })
                                    ]
                                }, label))
                        }),
                        transactions && transactions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                    className: "my-5 border-0 border-t border-slate-200"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "m-0 mb-3.5 text-base font-bold tracking-tight text-slate-900",
                                    children: "Documents"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-wrap gap-3.5",
                                    children: transactions.map(({ payment_id: paymentId, receipt: { url = '' } = {} }, idx, arr)=>{
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                            href: url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            "data-testid": 'receipt-download-' + idx,
                                            className: "group flex max-w-sm flex-1 items-center gap-3.5 rounded-xl border border-slate-200 bg-gradient-to-b from-slate-50 to-slate-100/60 px-4 py-3.5 text-slate-900 no-underline transition [flex-basis:260px] hover:-translate-y-px hover:border-green-400 hover:from-green-50 hover:to-green-100/60 hover:shadow-md",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] bg-green-100 text-green-600",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineDocumentText), {
                                                        className: "h-5 w-5"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "flex-1 text-sm font-semibold text-slate-900",
                                                    children: [
                                                        "Down Payment Receipt ",
                                                        arr.length > 1 ? idx + 1 : ''
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "shrink-0 text-slate-400 transition-colors group-hover:text-green-600",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineArrowDownTray), {
                                                        className: "h-[18px] w-[18px]"
                                                    })
                                                })
                                            ]
                                        }, paymentId);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                next_action === 'PENDING_DOWN_PAYMENT' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    "data-testid": "correction-required-message",
                    className: "rounded-xl border border-amber-300 bg-amber-50 px-5 py-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-2.5 flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineClock), {
                                        className: "h-[18px] w-[18px]"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-xs font-bold uppercase tracking-wider text-amber-700",
                                    children: "correction required"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-wrap items-center justify-between gap-4 text-[0.95rem] leading-snug text-amber-900",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "flex-1 [flex-basis:280px]",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                        i18nKey: "financing.downPayment.outstandingMessage",
                                        values: {
                                            amount: (0, _numberFormat.formatCurrency)(financing_down_payment, {
                                                withDecimals: false
                                            })
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "min-w-[160px] shrink-0",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.PrimaryButton), {
                                        "data-testid": "btn-verify",
                                        block: true,
                                        onClick: onCollectPayment,
                                        disabled: isCollectPaymentLoading,
                                        children: [
                                            isCollectPaymentLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                type: "spinner",
                                                className: "mr-4"
                                            }),
                                            "Collect Payment"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = FinancingSuccess;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"canvas-confetti":"gv1mE","react-icons/hi2":"krCLn","Core/hooks/platform/useGetTransactionHistory":"3gwu1","Core/components/Page":"4xeqH","../hooks/useGetNextStep":"fWBFC","Core/components/Button":"6YNzH","Core/utils/utils":"hwOBZ","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Modules/financing/routes":"5ZPtj","Core/components/Icon/Icon":"cAPHo","Core/utils/numberFormat":"6T56F","Core/utils/logger":"cWDKQ","Modules/financing/components/PostExchangeBanner":"eth8c","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gv1mE":[function(require,module,exports,__globalThis) {
// canvas-confetti v1.9.4 built on 2025-10-25T05:14:56.640Z
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
var module = {};
// source content
/* globals Map */ (function main(global, module, isWorker, workerSize) {
    var canUseWorker = !!(global.Worker && global.Blob && global.Promise && global.OffscreenCanvas && global.OffscreenCanvasRenderingContext2D && global.HTMLCanvasElement && global.HTMLCanvasElement.prototype.transferControlToOffscreen && global.URL && global.URL.createObjectURL);
    var canUsePaths = typeof Path2D === 'function' && typeof DOMMatrix === 'function';
    var canDrawBitmap = function() {
        // this mostly supports ssr
        if (!global.OffscreenCanvas) return false;
        try {
            var canvas = new OffscreenCanvas(1, 1);
            var ctx = canvas.getContext('2d');
            ctx.fillRect(0, 0, 1, 1);
            var bitmap = canvas.transferToImageBitmap();
            ctx.createPattern(bitmap, 'no-repeat');
        } catch (e) {
            return false;
        }
        return true;
    }();
    function noop() {}
    // create a promise if it exists, otherwise, just
    // call the function directly
    function promise(func) {
        var ModulePromise = module.exports.Promise;
        var Prom = ModulePromise !== void 0 ? ModulePromise : global.Promise;
        if (typeof Prom === 'function') return new Prom(func);
        func(noop, noop);
        return null;
    }
    var bitmapMapper = function(skipTransform, map) {
        // see https://github.com/catdad/canvas-confetti/issues/209
        // creating canvases is actually pretty expensive, so we should create a
        // 1:1 map for bitmap:canvas, so that we can animate the confetti in
        // a performant manner, but also not store them forever so that we don't
        // have a memory leak
        return {
            transform: function(bitmap) {
                if (skipTransform) return bitmap;
                if (map.has(bitmap)) return map.get(bitmap);
                var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
                var ctx = canvas.getContext('2d');
                ctx.drawImage(bitmap, 0, 0);
                map.set(bitmap, canvas);
                return canvas;
            },
            clear: function() {
                map.clear();
            }
        };
    }(canDrawBitmap, new Map());
    var raf = function() {
        var TIME = Math.floor(1000 / 60);
        var frame, cancel;
        var frames = {};
        var lastFrameTime = 0;
        if (typeof requestAnimationFrame === 'function' && typeof cancelAnimationFrame === 'function') {
            frame = function(cb) {
                var id = Math.random();
                frames[id] = requestAnimationFrame(function onFrame(time) {
                    if (lastFrameTime === time || lastFrameTime + TIME - 1 < time) {
                        lastFrameTime = time;
                        delete frames[id];
                        cb();
                    } else frames[id] = requestAnimationFrame(onFrame);
                });
                return id;
            };
            cancel = function(id) {
                if (frames[id]) cancelAnimationFrame(frames[id]);
            };
        } else {
            frame = function(cb) {
                return setTimeout(cb, TIME);
            };
            cancel = function(timer) {
                return clearTimeout(timer);
            };
        }
        return {
            frame: frame,
            cancel: cancel
        };
    }();
    var getWorker = function() {
        var worker;
        var prom;
        var resolves = {};
        function decorate(worker) {
            function execute(options, callback) {
                worker.postMessage({
                    options: options || {},
                    callback: callback
                });
            }
            worker.init = function initWorker(canvas) {
                var offscreen = canvas.transferControlToOffscreen();
                worker.postMessage({
                    canvas: offscreen
                }, [
                    offscreen
                ]);
            };
            worker.fire = function fireWorker(options, size, done) {
                if (prom) {
                    execute(options, null);
                    return prom;
                }
                var id = Math.random().toString(36).slice(2);
                prom = promise(function(resolve) {
                    function workerDone(msg) {
                        if (msg.data.callback !== id) return;
                        delete resolves[id];
                        worker.removeEventListener('message', workerDone);
                        prom = null;
                        bitmapMapper.clear();
                        done();
                        resolve();
                    }
                    worker.addEventListener('message', workerDone);
                    execute(options, id);
                    resolves[id] = workerDone.bind(null, {
                        data: {
                            callback: id
                        }
                    });
                });
                return prom;
            };
            worker.reset = function resetWorker() {
                worker.postMessage({
                    reset: true
                });
                for(var id in resolves){
                    resolves[id]();
                    delete resolves[id];
                }
            };
        }
        return function() {
            if (worker) return worker;
            if (!isWorker && canUseWorker) {
                var code = [
                    'var CONFETTI, SIZE = {}, module = {};',
                    '(' + main.toString() + ')(this, module, true, SIZE);',
                    'onmessage = function(msg) {',
                    '  if (msg.data.options) {',
                    '    CONFETTI(msg.data.options).then(function () {',
                    '      if (msg.data.callback) {',
                    '        postMessage({ callback: msg.data.callback });',
                    '      }',
                    '    });',
                    '  } else if (msg.data.reset) {',
                    '    CONFETTI && CONFETTI.reset();',
                    '  } else if (msg.data.resize) {',
                    '    SIZE.width = msg.data.resize.width;',
                    '    SIZE.height = msg.data.resize.height;',
                    '  } else if (msg.data.canvas) {',
                    '    SIZE.width = msg.data.canvas.width;',
                    '    SIZE.height = msg.data.canvas.height;',
                    '    CONFETTI = module.exports.create(msg.data.canvas);',
                    '  }',
                    '}'
                ].join('\n');
                try {
                    worker = new Worker(URL.createObjectURL(new Blob([
                        code
                    ])));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    typeof console !== 'undefined' && typeof console.warn === 'function' && console.warn("\uD83C\uDF8A Could not load worker", e);
                    return null;
                }
                decorate(worker);
            }
            return worker;
        };
    }();
    var defaults = {
        particleCount: 50,
        angle: 90,
        spread: 45,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        drift: 0,
        ticks: 200,
        x: 0.5,
        y: 0.5,
        shapes: [
            'square',
            'circle'
        ],
        zIndex: 100,
        colors: [
            '#26ccff',
            '#a25afd',
            '#ff5e7e',
            '#88ff5a',
            '#fcff42',
            '#ffa62d',
            '#ff36ff'
        ],
        // probably should be true, but back-compat
        disableForReducedMotion: false,
        scalar: 1
    };
    function convert(val, transform) {
        return transform ? transform(val) : val;
    }
    function isOk(val) {
        return !(val === null || val === undefined);
    }
    function prop(options, name, transform) {
        return convert(options && isOk(options[name]) ? options[name] : defaults[name], transform);
    }
    function onlyPositiveInt(number) {
        return number < 0 ? 0 : Math.floor(number);
    }
    function randomInt(min, max) {
        // [min, max)
        return Math.floor(Math.random() * (max - min)) + min;
    }
    function toDecimal(str) {
        return parseInt(str, 16);
    }
    function colorsToRgb(colors) {
        return colors.map(hexToRgb);
    }
    function hexToRgb(str) {
        var val = String(str).replace(/[^0-9a-f]/gi, '');
        if (val.length < 6) val = val[0] + val[0] + val[1] + val[1] + val[2] + val[2];
        return {
            r: toDecimal(val.substring(0, 2)),
            g: toDecimal(val.substring(2, 4)),
            b: toDecimal(val.substring(4, 6))
        };
    }
    function getOrigin(options) {
        var origin = prop(options, 'origin', Object);
        origin.x = prop(origin, 'x', Number);
        origin.y = prop(origin, 'y', Number);
        return origin;
    }
    function setCanvasWindowSize(canvas) {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = document.documentElement.clientHeight;
    }
    function setCanvasRectSize(canvas) {
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
    }
    function getCanvas(zIndex) {
        var canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.top = '0px';
        canvas.style.left = '0px';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = zIndex;
        return canvas;
    }
    function ellipse(context, x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
        context.save();
        context.translate(x, y);
        context.rotate(rotation);
        context.scale(radiusX, radiusY);
        context.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
        context.restore();
    }
    function randomPhysics(opts) {
        var radAngle = opts.angle * (Math.PI / 180);
        var radSpread = opts.spread * (Math.PI / 180);
        return {
            x: opts.x,
            y: opts.y,
            wobble: Math.random() * 10,
            wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
            velocity: opts.startVelocity * 0.5 + Math.random() * opts.startVelocity,
            angle2D: -radAngle + (0.5 * radSpread - Math.random() * radSpread),
            tiltAngle: (Math.random() * 0.5 + 0.25) * Math.PI,
            color: opts.color,
            shape: opts.shape,
            tick: 0,
            totalTicks: opts.ticks,
            decay: opts.decay,
            drift: opts.drift,
            random: Math.random() + 2,
            tiltSin: 0,
            tiltCos: 0,
            wobbleX: 0,
            wobbleY: 0,
            gravity: opts.gravity * 3,
            ovalScalar: 0.6,
            scalar: opts.scalar,
            flat: opts.flat
        };
    }
    function updateFetti(context, fetti) {
        fetti.x += Math.cos(fetti.angle2D) * fetti.velocity + fetti.drift;
        fetti.y += Math.sin(fetti.angle2D) * fetti.velocity + fetti.gravity;
        fetti.velocity *= fetti.decay;
        if (fetti.flat) {
            fetti.wobble = 0;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar;
            fetti.wobbleY = fetti.y + 10 * fetti.scalar;
            fetti.tiltSin = 0;
            fetti.tiltCos = 0;
            fetti.random = 1;
        } else {
            fetti.wobble += fetti.wobbleSpeed;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar * Math.cos(fetti.wobble);
            fetti.wobbleY = fetti.y + 10 * fetti.scalar * Math.sin(fetti.wobble);
            fetti.tiltAngle += 0.1;
            fetti.tiltSin = Math.sin(fetti.tiltAngle);
            fetti.tiltCos = Math.cos(fetti.tiltAngle);
            fetti.random = Math.random() + 2;
        }
        var progress = fetti.tick++ / fetti.totalTicks;
        var x1 = fetti.x + fetti.random * fetti.tiltCos;
        var y1 = fetti.y + fetti.random * fetti.tiltSin;
        var x2 = fetti.wobbleX + fetti.random * fetti.tiltCos;
        var y2 = fetti.wobbleY + fetti.random * fetti.tiltSin;
        context.fillStyle = 'rgba(' + fetti.color.r + ', ' + fetti.color.g + ', ' + fetti.color.b + ', ' + (1 - progress) + ')';
        context.beginPath();
        if (canUsePaths && fetti.shape.type === 'path' && typeof fetti.shape.path === 'string' && Array.isArray(fetti.shape.matrix)) context.fill(transformPath2D(fetti.shape.path, fetti.shape.matrix, fetti.x, fetti.y, Math.abs(x2 - x1) * 0.1, Math.abs(y2 - y1) * 0.1, Math.PI / 10 * fetti.wobble));
        else if (fetti.shape.type === 'bitmap') {
            var rotation = Math.PI / 10 * fetti.wobble;
            var scaleX = Math.abs(x2 - x1) * 0.1;
            var scaleY = Math.abs(y2 - y1) * 0.1;
            var width = fetti.shape.bitmap.width * fetti.scalar;
            var height = fetti.shape.bitmap.height * fetti.scalar;
            var matrix = new DOMMatrix([
                Math.cos(rotation) * scaleX,
                Math.sin(rotation) * scaleX,
                -Math.sin(rotation) * scaleY,
                Math.cos(rotation) * scaleY,
                fetti.x,
                fetti.y
            ]);
            // apply the transform matrix from the confetti shape
            matrix.multiplySelf(new DOMMatrix(fetti.shape.matrix));
            var pattern = context.createPattern(bitmapMapper.transform(fetti.shape.bitmap), 'no-repeat');
            pattern.setTransform(matrix);
            context.globalAlpha = 1 - progress;
            context.fillStyle = pattern;
            context.fillRect(fetti.x - width / 2, fetti.y - height / 2, width, height);
            context.globalAlpha = 1;
        } else if (fetti.shape === 'circle') context.ellipse ? context.ellipse(fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI) : ellipse(context, fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI);
        else if (fetti.shape === 'star') {
            var rot = Math.PI / 2 * 3;
            var innerRadius = 4 * fetti.scalar;
            var outerRadius = 8 * fetti.scalar;
            var x = fetti.x;
            var y = fetti.y;
            var spikes = 5;
            var step = Math.PI / spikes;
            while(spikes--){
                x = fetti.x + Math.cos(rot) * outerRadius;
                y = fetti.y + Math.sin(rot) * outerRadius;
                context.lineTo(x, y);
                rot += step;
                x = fetti.x + Math.cos(rot) * innerRadius;
                y = fetti.y + Math.sin(rot) * innerRadius;
                context.lineTo(x, y);
                rot += step;
            }
        } else {
            context.moveTo(Math.floor(fetti.x), Math.floor(fetti.y));
            context.lineTo(Math.floor(fetti.wobbleX), Math.floor(y1));
            context.lineTo(Math.floor(x2), Math.floor(y2));
            context.lineTo(Math.floor(x1), Math.floor(fetti.wobbleY));
        }
        context.closePath();
        context.fill();
        return fetti.tick < fetti.totalTicks;
    }
    function animate(canvas, fettis, resizer, size, done) {
        var animatingFettis = fettis.slice();
        var context = canvas.getContext('2d');
        var animationFrame;
        var destroy;
        var prom = promise(function(resolve) {
            function onDone() {
                animationFrame = destroy = null;
                context.clearRect(0, 0, size.width, size.height);
                bitmapMapper.clear();
                done();
                resolve();
            }
            function update() {
                if (isWorker && !(size.width === workerSize.width && size.height === workerSize.height)) {
                    size.width = canvas.width = workerSize.width;
                    size.height = canvas.height = workerSize.height;
                }
                if (!size.width && !size.height) {
                    resizer(canvas);
                    size.width = canvas.width;
                    size.height = canvas.height;
                }
                context.clearRect(0, 0, size.width, size.height);
                animatingFettis = animatingFettis.filter(function(fetti) {
                    return updateFetti(context, fetti);
                });
                if (animatingFettis.length) animationFrame = raf.frame(update);
                else onDone();
            }
            animationFrame = raf.frame(update);
            destroy = onDone;
        });
        return {
            addFettis: function(fettis) {
                animatingFettis = animatingFettis.concat(fettis);
                return prom;
            },
            canvas: canvas,
            promise: prom,
            reset: function() {
                if (animationFrame) raf.cancel(animationFrame);
                if (destroy) destroy();
            }
        };
    }
    function confettiCannon(canvas, globalOpts) {
        var isLibCanvas = !canvas;
        var allowResize = !!prop(globalOpts || {}, 'resize');
        var hasResizeEventRegistered = false;
        var globalDisableForReducedMotion = prop(globalOpts, 'disableForReducedMotion', Boolean);
        var shouldUseWorker = canUseWorker && !!prop(globalOpts || {}, 'useWorker');
        var worker = shouldUseWorker ? getWorker() : null;
        var resizer = isLibCanvas ? setCanvasWindowSize : setCanvasRectSize;
        var initialized = canvas && worker ? !!canvas.__confetti_initialized : false;
        var preferLessMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion)').matches;
        var animationObj;
        function fireLocal(options, size, done) {
            var particleCount = prop(options, 'particleCount', onlyPositiveInt);
            var angle = prop(options, 'angle', Number);
            var spread = prop(options, 'spread', Number);
            var startVelocity = prop(options, 'startVelocity', Number);
            var decay = prop(options, 'decay', Number);
            var gravity = prop(options, 'gravity', Number);
            var drift = prop(options, 'drift', Number);
            var colors = prop(options, 'colors', colorsToRgb);
            var ticks = prop(options, 'ticks', Number);
            var shapes = prop(options, 'shapes');
            var scalar = prop(options, 'scalar');
            var flat = !!prop(options, 'flat');
            var origin = getOrigin(options);
            var temp = particleCount;
            var fettis = [];
            var startX = canvas.width * origin.x;
            var startY = canvas.height * origin.y;
            while(temp--)fettis.push(randomPhysics({
                x: startX,
                y: startY,
                angle: angle,
                spread: spread,
                startVelocity: startVelocity,
                color: colors[temp % colors.length],
                shape: shapes[randomInt(0, shapes.length)],
                ticks: ticks,
                decay: decay,
                gravity: gravity,
                drift: drift,
                scalar: scalar,
                flat: flat
            }));
            // if we have a previous canvas already animating,
            // add to it
            if (animationObj) return animationObj.addFettis(fettis);
            animationObj = animate(canvas, fettis, resizer, size, done);
            return animationObj.promise;
        }
        function fire(options) {
            var disableForReducedMotion = globalDisableForReducedMotion || prop(options, 'disableForReducedMotion', Boolean);
            var zIndex = prop(options, 'zIndex', Number);
            if (disableForReducedMotion && preferLessMotion) return promise(function(resolve) {
                resolve();
            });
            if (isLibCanvas && animationObj) // use existing canvas from in-progress animation
            canvas = animationObj.canvas;
            else if (isLibCanvas && !canvas) {
                // create and initialize a new canvas
                canvas = getCanvas(zIndex);
                document.body.appendChild(canvas);
            }
            if (allowResize && !initialized) // initialize the size of a user-supplied canvas
            resizer(canvas);
            var size = {
                width: canvas.width,
                height: canvas.height
            };
            if (worker && !initialized) worker.init(canvas);
            initialized = true;
            if (worker) canvas.__confetti_initialized = true;
            function onResize() {
                if (worker) {
                    // TODO this really shouldn't be immediate, because it is expensive
                    var obj = {
                        getBoundingClientRect: function() {
                            if (!isLibCanvas) return canvas.getBoundingClientRect();
                        }
                    };
                    resizer(obj);
                    worker.postMessage({
                        resize: {
                            width: obj.width,
                            height: obj.height
                        }
                    });
                    return;
                }
                // don't actually query the size here, since this
                // can execute frequently and rapidly
                size.width = size.height = null;
            }
            function done() {
                animationObj = null;
                if (allowResize) {
                    hasResizeEventRegistered = false;
                    global.removeEventListener('resize', onResize);
                }
                if (isLibCanvas && canvas) {
                    if (document.body.contains(canvas)) document.body.removeChild(canvas);
                    canvas = null;
                    initialized = false;
                }
            }
            if (allowResize && !hasResizeEventRegistered) {
                hasResizeEventRegistered = true;
                global.addEventListener('resize', onResize, false);
            }
            if (worker) return worker.fire(options, size, done);
            return fireLocal(options, size, done);
        }
        fire.reset = function() {
            if (worker) worker.reset();
            if (animationObj) animationObj.reset();
        };
        return fire;
    }
    // Make default export lazy to defer worker creation until called.
    var defaultFire;
    function getDefaultFire() {
        if (!defaultFire) defaultFire = confettiCannon(null, {
            useWorker: true,
            resize: true
        });
        return defaultFire;
    }
    function transformPath2D(pathString, pathMatrix, x, y, scaleX, scaleY, rotation) {
        var path2d = new Path2D(pathString);
        var t1 = new Path2D();
        t1.addPath(path2d, new DOMMatrix(pathMatrix));
        var t2 = new Path2D();
        // see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix/DOMMatrix
        t2.addPath(t1, new DOMMatrix([
            Math.cos(rotation) * scaleX,
            Math.sin(rotation) * scaleX,
            -Math.sin(rotation) * scaleY,
            Math.cos(rotation) * scaleY,
            x,
            y
        ]));
        return t2;
    }
    function shapeFromPath(pathData) {
        if (!canUsePaths) throw new Error('path confetti are not supported in this browser');
        var path, matrix;
        if (typeof pathData === 'string') path = pathData;
        else {
            path = pathData.path;
            matrix = pathData.matrix;
        }
        var path2d = new Path2D(path);
        var tempCanvas = document.createElement('canvas');
        var tempCtx = tempCanvas.getContext('2d');
        if (!matrix) {
            // attempt to figure out the width of the path, up to 1000x1000
            var maxSize = 1000;
            var minX = maxSize;
            var minY = maxSize;
            var maxX = 0;
            var maxY = 0;
            var width, height;
            // do some line skipping... this is faster than checking
            // every pixel and will be mostly still correct
            for(var x = 0; x < maxSize; x += 2){
                for(var y = 0; y < maxSize; y += 2)if (tempCtx.isPointInPath(path2d, x, y, 'nonzero')) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
            width = maxX - minX;
            height = maxY - minY;
            var maxDesiredSize = 10;
            var scale = Math.min(maxDesiredSize / width, maxDesiredSize / height);
            matrix = [
                scale,
                0,
                0,
                scale,
                -Math.round(width / 2 + minX) * scale,
                -Math.round(height / 2 + minY) * scale
            ];
        }
        return {
            type: 'path',
            path: path,
            matrix: matrix
        };
    }
    function shapeFromText(textData) {
        var text, scalar = 1, color = '#000000', // see https://nolanlawson.com/2022/04/08/the-struggle-of-using-native-emoji-on-the-web/
        fontFamily = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
        if (typeof textData === 'string') text = textData;
        else {
            text = textData.text;
            scalar = 'scalar' in textData ? textData.scalar : scalar;
            fontFamily = 'fontFamily' in textData ? textData.fontFamily : fontFamily;
            color = 'color' in textData ? textData.color : color;
        }
        // all other confetti are 10 pixels,
        // so this pixel size is the de-facto 100% scale confetti
        var fontSize = 10 * scalar;
        var font = '' + fontSize + 'px ' + fontFamily;
        var canvas = new OffscreenCanvas(fontSize, fontSize);
        var ctx = canvas.getContext('2d');
        ctx.font = font;
        var size = ctx.measureText(text);
        var width = Math.ceil(size.actualBoundingBoxRight + size.actualBoundingBoxLeft);
        var height = Math.ceil(size.actualBoundingBoxAscent + size.actualBoundingBoxDescent);
        var padding = 2;
        var x = size.actualBoundingBoxLeft + padding;
        var y = size.actualBoundingBoxAscent + padding;
        width += padding + padding;
        height += padding + padding;
        canvas = new OffscreenCanvas(width, height);
        ctx = canvas.getContext('2d');
        ctx.font = font;
        ctx.fillStyle = color;
        ctx.fillText(text, x, y);
        var scale = 1 / scalar;
        return {
            type: 'bitmap',
            // TODO these probably need to be transfered for workers
            bitmap: canvas.transferToImageBitmap(),
            matrix: [
                scale,
                0,
                0,
                scale,
                -width * scale / 2,
                -height * scale / 2
            ]
        };
    }
    module.exports = function() {
        return getDefaultFire().apply(this, arguments);
    };
    module.exports.reset = function() {
        getDefaultFire().reset();
    };
    module.exports.create = confettiCannon;
    module.exports.shapeFromPath = shapeFromPath;
    module.exports.shapeFromText = shapeFromText;
})(function() {
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    return this || {};
}(), module, false);
// end source content
exports.default = module.exports;
var create = module.exports.create;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kCOgk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingApproved);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
// import { PrimaryButton } from 'Core/components/Button';
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _column = require("Core/components/Layout/Column");
var _columnDefault = parcelHelpers.interopDefault(_column);
function FinancingApproved() {
    document.title = 'Payment Portal - Application Approved';
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
            className: "justify-center text-center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
                    className: "justify-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "font-regular",
                        "data-testid": "title-finance-approved",
                        children: t('common.newApplication')
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
                    className: "justify-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _columnDefault.default), {
                            className: "text-center p-7 font-extralight text-2xl",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "mr-4",
                                    children: "\u2705"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    "data-testid": "message-finance-approved",
                                    children: t('financing.applicationApproved')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "md:!flex-col-4 text-center text-gray-400",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: t('common.closeWindow')
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react":"2o0ib","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Layout/Row":"8YqFQ","Core/components/Layout/Column":"hnQnj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jq6MM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReturnTracking);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _paperworkSvg = require("url:Images/illustrations/paperwork.svg");
var _paperworkSvgDefault = parcelHelpers.interopDefault(_paperworkSvg);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _fa = require("react-icons/fa");
function ReturnTracking({ nextAction }) {
    document.title = 'Payment Portal - Financing';
    const { t } = (0, _reactI18Next.useTranslation)();
    (0, _useScrollTop.useScrollTop)();
    const [steps, setSteps] = (0, _reactDefault.default).useState([
        {
            id: 'RETURN_REQUESTED',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_PROCESSING',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_APPROVED',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_COMPLETE',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_CANCELED',
            isHidden: true,
            isActive: false,
            isComplete: false
        }
    ]);
    const [activeStep, setActiveStep] = (0, _reactDefault.default).useState({});
    (0, _reactDefault.default).useEffect(()=>{
        setSteps((currentSteps)=>{
            const tempSteps = [
                ...currentSteps
            ];
            const activeStepIndex = tempSteps.findIndex((step)=>step.id === nextAction);
            tempSteps.forEach((step, idx)=>{
                if (step.id === 'RETURN_COMPLETE' || step.id === 'RETURN_APPROVED') step.isHidden = nextAction === 'RETURN_CANCELED';
                if (step.id === 'RETURN_CANCELED') step.isHidden = nextAction !== 'RETURN_CANCELED';
                if (idx === activeStepIndex) {
                    step.isActive = true;
                    step.isHidden = false;
                    step.isComplete = false;
                } else if (idx < activeStepIndex) {
                    step.isActive = false;
                    step.isComplete = true;
                } else {
                    step.isActive = false;
                    step.isComplete = false;
                }
            });
            return tempSteps;
        });
    }, [
        nextAction,
        setActiveStep
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setActiveStep(steps.find((step)=>step.isActive));
    }, [
        steps
    ]);
    function StepIcon({ id, isActive, isComplete }) {
        if (isComplete) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaCheck), {
            color: "white"
        });
        else if (isActive) {
            if (id === 'RETURN_CANCELED') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaExclamation), {
                color: "white"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaCheck), {
                color: "white"
            });
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: "Financing",
        withStepProgress: false,
        stickyFooter: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
            className: "justify-center mt-8",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "p-8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        "data-testid": "step-progress-container",
                        className: "flex flex-nowrap justify-between mb-4 p-0",
                        children: steps.filter((s)=>!s.isHidden).map(({ id, isActive, isComplete })=>{
                            const testid = isActive ? `step-progress-active` : `step-progress`;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _classnamesDefault.default)("flex flex-col items-center justify-center relative w-full text-sm whitespace-nowrap before:content-[''] before:border-t-2 before:border-gray-300 before:absolute before:[right:calc(50%_+_15px)] before:[top:15px] before:[width:calc(100%_-_30px)] first-of-type:before:border-0 before:border-solid"),
                                "data-testid": `return-step-${id}`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _classnamesDefault.default)('border-2 border-solid border-gray-300 rounded-full flex justify-center items-center font-bold [height:30px] [width:30px] [line-height:26px]', {
                                            'bg-green-700 text-white': id !== 'RETURN_CANCELED' && isActive,
                                            'bg-gray-200': !isActive && !isComplete,
                                            'bg-green-400': isComplete,
                                            'bg-red-500': id === 'RETURN_CANCELED'
                                        }),
                                        "data-testid": testid,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepIcon, {
                                            id: id,
                                            isActive: isActive,
                                            isComplete: isComplete
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        "data-testid": "step-label",
                                        className: (0, _classnamesDefault.default)('hidden sm:flex mt-4 text-sm md:text-lg', {
                                            'font-semibold': isActive,
                                            ' font-extralight': !isActive
                                        }),
                                        children: t(`page.financing.${id}.title`)
                                    })
                                ]
                            }, id);
                        })
                    }),
                    activeStep && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col items-center w-100",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "mt-6",
                                alt: "application-declined",
                                width: "150em",
                                src: (0, _paperworkSvgDefault.default)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "mt-8 text-2xl",
                                children: t(`page.financing.${nextAction}.title`)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mt-4 text-regular text-gray-500",
                                children: t(`page.financing.${nextAction}.description`)
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"9x2lT","classnames":"f971Y","react":"2o0ib","url:Images/illustrations/paperwork.svg":"9Iyib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","react-icons/fa":"9Vrsi","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9Iyib":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1T57B");

},{}],"535sN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingStatusMessage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _column = require("Core/components/Layout/Column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _paperworkSvg = require("url:Images/illustrations/paperwork.svg");
var _paperworkSvgDefault = parcelHelpers.interopDefault(_paperworkSvg);
var _postExchangeBanner = require("Modules/financing/components/PostExchangeBanner");
var _postExchangeBannerDefault = parcelHelpers.interopDefault(_postExchangeBanner);
function FinancingStatusMessage({ nextAction, application }) {
    document.title = 'Payment Portal - Financing';
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const text_pageHeader = 'Financing';
    const text_title = t(`page.financing.${nextAction}.title`);
    const text_description = t(`page.financing.${nextAction}.description`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: text_pageHeader,
        withStepProgress: false,
        stickyFooter: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _postExchangeBannerDefault.default), {
                application: application
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                className: "justify-center mt-8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
                        className: "justify-center items-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "font-regular",
                            "data-testid": "title-finance-approved",
                            children: text_title
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
                        className: "justify-center items-center my-8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                                className: "!flex-col-2 flex justify-end",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "relative top-2",
                                    alt: "application-declined",
                                    width: "150em",
                                    src: (0, _paperworkSvgDefault.default)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                                className: "!flex-col-8 !mb-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mb-0 w-full whitespace-pre-line text-xl leading-loose",
                                    children: text_description
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react":"2o0ib","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Layout/Row":"8YqFQ","Core/components/Layout/Column":"hnQnj","url:Images/illustrations/paperwork.svg":"9Iyib","Modules/financing/components/PostExchangeBanner":"eth8c","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iIWvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingDeclined);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _routes = require("Modules/financing/routes");
var _bi = require("react-icons/bi");
var _button = require("Core/components/Button");
var _reactLocation = require("react-location");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _postExchangeBanner = require("Modules/financing/components/PostExchangeBanner");
var _postExchangeBannerDefault = parcelHelpers.interopDefault(_postExchangeBanner);
function FinancingDeclined({ allowCreateApplication = false, application = {} }) {
    document.title = 'Payment Portal - Application Declined';
    const { t } = (0, _reactI18Next.useTranslation)();
    (0, _useScrollTop.useScrollTop)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { customer_id = '', payload: { relationship = '' } = {} } = application;
    const handleCreateApplication = ()=>{
        const relationshipObj = JSON.stringify({
            relationship,
            customer_id
        });
        sessionStorage.setItem('relationship', relationshipObj);
        navigate({
            to: (0, _routes.createSecondaryFinancingPath),
            search: true
        });
    };
    const descriptionLabel = allowCreateApplication ? 'synchrony.nextgen.declined.introWithNewApp' : 'synchrony.nextgen.declined.intro';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "mx-auto max-w-4xl px-4 mt-10",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _postExchangeBannerDefault.default), {
                    application: application
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                    className: "relative overflow-hidden !px-0 !py-0",
                    cardPadding: "sm",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "h-1 bg-red-500"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "px-8 md:px-14 pt-12 pb-12",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex justify-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        "aria-hidden": "true",
                                        className: "flex items-center justify-center h-14 w-14 rounded-full bg-red-50 ring-1 ring-red-100",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bi.BiError), {
                                            className: "h-7 w-7 text-red-600"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "mt-6 text-center text-3xl md:text-[2rem] font-semibold tracking-tight text-slate-900 leading-tight",
                                    "data-testid": "title-finance-declined",
                                    children: t('common.nextgen.financingDeclined.title')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: "mt-7 h-[3px] w-full rounded-full bg-red-300"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _classnamesDefault.default)('mt-7 mx-auto max-w-2xl text-center whitespace-pre-line text-base md:text-lg leading-relaxed text-slate-600'),
                                    children: t(descriptionLabel)
                                }),
                                allowCreateApplication && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mt-10 flex justify-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                        "data-testid": "btn-create-secondary-application",
                                        size: "tall",
                                        rounded: true,
                                        className: "!px-12",
                                        onClick: handleCreateApplication,
                                        children: t('common.reapply')
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Modules/financing/routes":"5ZPtj","react-icons/bi":"bqckM","Core/components/Button":"6YNzH","react-location":"8hNco","classnames":"f971Y","Modules/financing/components/PostExchangeBanner":"eth8c","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bqckM":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BiZoomOut", ()=>BiZoomOut);
parcelHelpers.export(exports, "BiZoomIn", ()=>BiZoomIn);
parcelHelpers.export(exports, "BiYen", ()=>BiYen);
parcelHelpers.export(exports, "BiX", ()=>BiX);
parcelHelpers.export(exports, "BiXCircle", ()=>BiXCircle);
parcelHelpers.export(exports, "BiWrench", ()=>BiWrench);
parcelHelpers.export(exports, "BiWorld", ()=>BiWorld);
parcelHelpers.export(exports, "BiWon", ()=>BiWon);
parcelHelpers.export(exports, "BiWinkTongue", ()=>BiWinkTongue);
parcelHelpers.export(exports, "BiWinkSmile", ()=>BiWinkSmile);
parcelHelpers.export(exports, "BiWine", ()=>BiWine);
parcelHelpers.export(exports, "BiWindows", ()=>BiWindows);
parcelHelpers.export(exports, "BiWindow", ()=>BiWindow);
parcelHelpers.export(exports, "BiWindowOpen", ()=>BiWindowOpen);
parcelHelpers.export(exports, "BiWindowClose", ()=>BiWindowClose);
parcelHelpers.export(exports, "BiWindowAlt", ()=>BiWindowAlt);
parcelHelpers.export(exports, "BiWind", ()=>BiWind);
parcelHelpers.export(exports, "BiWifi", ()=>BiWifi);
parcelHelpers.export(exports, "BiWifiOff", ()=>BiWifiOff);
parcelHelpers.export(exports, "BiWifi2", ()=>BiWifi2);
parcelHelpers.export(exports, "BiWifi1", ()=>BiWifi1);
parcelHelpers.export(exports, "BiWifi0", ()=>BiWifi0);
parcelHelpers.export(exports, "BiWebcam", ()=>BiWebcam);
parcelHelpers.export(exports, "BiWater", ()=>BiWater);
parcelHelpers.export(exports, "BiWallet", ()=>BiWallet);
parcelHelpers.export(exports, "BiWalletAlt", ()=>BiWalletAlt);
parcelHelpers.export(exports, "BiWalk", ()=>BiWalk);
parcelHelpers.export(exports, "BiVolume", ()=>BiVolume);
parcelHelpers.export(exports, "BiVolumeMute", ()=>BiVolumeMute);
parcelHelpers.export(exports, "BiVolumeLow", ()=>BiVolumeLow);
parcelHelpers.export(exports, "BiVolumeFull", ()=>BiVolumeFull);
parcelHelpers.export(exports, "BiVoicemail", ()=>BiVoicemail);
parcelHelpers.export(exports, "BiVideo", ()=>BiVideo);
parcelHelpers.export(exports, "BiVideoRecording", ()=>BiVideoRecording);
parcelHelpers.export(exports, "BiVideoPlus", ()=>BiVideoPlus);
parcelHelpers.export(exports, "BiVideoOff", ()=>BiVideoOff);
parcelHelpers.export(exports, "BiVial", ()=>BiVial);
parcelHelpers.export(exports, "BiVerticalTop", ()=>BiVerticalTop);
parcelHelpers.export(exports, "BiVerticalCenter", ()=>BiVerticalCenter);
parcelHelpers.export(exports, "BiVerticalBottom", ()=>BiVerticalBottom);
parcelHelpers.export(exports, "BiVector", ()=>BiVector);
parcelHelpers.export(exports, "BiUser", ()=>BiUser);
parcelHelpers.export(exports, "BiUserX", ()=>BiUserX);
parcelHelpers.export(exports, "BiUserVoice", ()=>BiUserVoice);
parcelHelpers.export(exports, "BiUserPlus", ()=>BiUserPlus);
parcelHelpers.export(exports, "BiUserPin", ()=>BiUserPin);
parcelHelpers.export(exports, "BiUserMinus", ()=>BiUserMinus);
parcelHelpers.export(exports, "BiUserCircle", ()=>BiUserCircle);
parcelHelpers.export(exports, "BiUserCheck", ()=>BiUserCheck);
parcelHelpers.export(exports, "BiUsb", ()=>BiUsb);
parcelHelpers.export(exports, "BiUpvote", ()=>BiUpvote);
parcelHelpers.export(exports, "BiUpsideDown", ()=>BiUpsideDown);
parcelHelpers.export(exports, "BiUpload", ()=>BiUpload);
parcelHelpers.export(exports, "BiUpArrow", ()=>BiUpArrow);
parcelHelpers.export(exports, "BiUpArrowCircle", ()=>BiUpArrowCircle);
parcelHelpers.export(exports, "BiUpArrowAlt", ()=>BiUpArrowAlt);
parcelHelpers.export(exports, "BiUnlink", ()=>BiUnlink);
parcelHelpers.export(exports, "BiUniversalAccess", ()=>BiUniversalAccess);
parcelHelpers.export(exports, "BiUnite", ()=>BiUnite);
parcelHelpers.export(exports, "BiUndo", ()=>BiUndo);
parcelHelpers.export(exports, "BiUnderline", ()=>BiUnderline);
parcelHelpers.export(exports, "BiTv", ()=>BiTv);
parcelHelpers.export(exports, "BiTrophy", ()=>BiTrophy);
parcelHelpers.export(exports, "BiTrip", ()=>BiTrip);
parcelHelpers.export(exports, "BiTrim", ()=>BiTrim);
parcelHelpers.export(exports, "BiTrendingUp", ()=>BiTrendingUp);
parcelHelpers.export(exports, "BiTrendingDown", ()=>BiTrendingDown);
parcelHelpers.export(exports, "BiTrash", ()=>BiTrash);
parcelHelpers.export(exports, "BiTrashAlt", ()=>BiTrashAlt);
parcelHelpers.export(exports, "BiTransfer", ()=>BiTransfer);
parcelHelpers.export(exports, "BiTransferAlt", ()=>BiTransferAlt);
parcelHelpers.export(exports, "BiTrain", ()=>BiTrain);
parcelHelpers.export(exports, "BiTrafficCone", ()=>BiTrafficCone);
parcelHelpers.export(exports, "BiTone", ()=>BiTone);
parcelHelpers.export(exports, "BiToggleRight", ()=>BiToggleRight);
parcelHelpers.export(exports, "BiToggleLeft", ()=>BiToggleLeft);
parcelHelpers.export(exports, "BiTired", ()=>BiTired);
parcelHelpers.export(exports, "BiTimer", ()=>BiTimer);
parcelHelpers.export(exports, "BiTime", ()=>BiTime);
parcelHelpers.export(exports, "BiTimeFive", ()=>BiTimeFive);
parcelHelpers.export(exports, "BiText", ()=>BiText);
parcelHelpers.export(exports, "BiTestTube", ()=>BiTestTube);
parcelHelpers.export(exports, "BiTerminal", ()=>BiTerminal);
parcelHelpers.export(exports, "BiTennisBall", ()=>BiTennisBall);
parcelHelpers.export(exports, "BiTaxi", ()=>BiTaxi);
parcelHelpers.export(exports, "BiTask", ()=>BiTask);
parcelHelpers.export(exports, "BiTaskX", ()=>BiTaskX);
parcelHelpers.export(exports, "BiTargetLock", ()=>BiTargetLock);
parcelHelpers.export(exports, "BiTag", ()=>BiTag);
parcelHelpers.export(exports, "BiTagAlt", ()=>BiTagAlt);
parcelHelpers.export(exports, "BiTachometer", ()=>BiTachometer);
parcelHelpers.export(exports, "BiTable", ()=>BiTable);
parcelHelpers.export(exports, "BiTab", ()=>BiTab);
parcelHelpers.export(exports, "BiSync", ()=>BiSync);
parcelHelpers.export(exports, "BiSwim", ()=>BiSwim);
parcelHelpers.export(exports, "BiSushi", ()=>BiSushi);
parcelHelpers.export(exports, "BiSupport", ()=>BiSupport);
parcelHelpers.export(exports, "BiSun", ()=>BiSun);
parcelHelpers.export(exports, "BiSubdirectoryRight", ()=>BiSubdirectoryRight);
parcelHelpers.export(exports, "BiSubdirectoryLeft", ()=>BiSubdirectoryLeft);
parcelHelpers.export(exports, "BiStrikethrough", ()=>BiStrikethrough);
parcelHelpers.export(exports, "BiStreetView", ()=>BiStreetView);
parcelHelpers.export(exports, "BiStore", ()=>BiStore);
parcelHelpers.export(exports, "BiStoreAlt", ()=>BiStoreAlt);
parcelHelpers.export(exports, "BiStopwatch", ()=>BiStopwatch);
parcelHelpers.export(exports, "BiStop", ()=>BiStop);
parcelHelpers.export(exports, "BiStopCircle", ()=>BiStopCircle);
parcelHelpers.export(exports, "BiSticker", ()=>BiSticker);
parcelHelpers.export(exports, "BiStats", ()=>BiStats);
parcelHelpers.export(exports, "BiStation", ()=>BiStation);
parcelHelpers.export(exports, "BiStar", ()=>BiStar);
parcelHelpers.export(exports, "BiSquare", ()=>BiSquare);
parcelHelpers.export(exports, "BiSquareRounded", ()=>BiSquareRounded);
parcelHelpers.export(exports, "BiSpreadsheet", ()=>BiSpreadsheet);
parcelHelpers.export(exports, "BiSprayCan", ()=>BiSprayCan);
parcelHelpers.export(exports, "BiSpeaker", ()=>BiSpeaker);
parcelHelpers.export(exports, "BiSpaceBar", ()=>BiSpaceBar);
parcelHelpers.export(exports, "BiSpa", ()=>BiSpa);
parcelHelpers.export(exports, "BiSort", ()=>BiSort);
parcelHelpers.export(exports, "BiSortZA", ()=>BiSortZA);
parcelHelpers.export(exports, "BiSortUp", ()=>BiSortUp);
parcelHelpers.export(exports, "BiSortDown", ()=>BiSortDown);
parcelHelpers.export(exports, "BiSortAlt2", ()=>BiSortAlt2);
parcelHelpers.export(exports, "BiSortAZ", ()=>BiSortAZ);
parcelHelpers.export(exports, "BiSmile", ()=>BiSmile);
parcelHelpers.export(exports, "BiSlideshow", ()=>BiSlideshow);
parcelHelpers.export(exports, "BiSlider", ()=>BiSlider);
parcelHelpers.export(exports, "BiSliderAlt", ()=>BiSliderAlt);
parcelHelpers.export(exports, "BiSleepy", ()=>BiSleepy);
parcelHelpers.export(exports, "BiSkipPrevious", ()=>BiSkipPrevious);
parcelHelpers.export(exports, "BiSkipPreviousCircle", ()=>BiSkipPreviousCircle);
parcelHelpers.export(exports, "BiSkipNext", ()=>BiSkipNext);
parcelHelpers.export(exports, "BiSkipNextCircle", ()=>BiSkipNextCircle);
parcelHelpers.export(exports, "BiSitemap", ()=>BiSitemap);
parcelHelpers.export(exports, "BiSignal5", ()=>BiSignal5);
parcelHelpers.export(exports, "BiSignal4", ()=>BiSignal4);
parcelHelpers.export(exports, "BiSignal3", ()=>BiSignal3);
parcelHelpers.export(exports, "BiSignal2", ()=>BiSignal2);
parcelHelpers.export(exports, "BiSignal1", ()=>BiSignal1);
parcelHelpers.export(exports, "BiSidebar", ()=>BiSidebar);
parcelHelpers.export(exports, "BiShuffle", ()=>BiShuffle);
parcelHelpers.export(exports, "BiShower", ()=>BiShower);
parcelHelpers.export(exports, "BiShow", ()=>BiShow);
parcelHelpers.export(exports, "BiShowAlt", ()=>BiShowAlt);
parcelHelpers.export(exports, "BiShoppingBag", ()=>BiShoppingBag);
parcelHelpers.export(exports, "BiShocked", ()=>BiShocked);
parcelHelpers.export(exports, "BiShield", ()=>BiShield);
parcelHelpers.export(exports, "BiShieldX", ()=>BiShieldX);
parcelHelpers.export(exports, "BiShieldQuarter", ()=>BiShieldQuarter);
parcelHelpers.export(exports, "BiShieldPlus", ()=>BiShieldPlus);
parcelHelpers.export(exports, "BiShieldMinus", ()=>BiShieldMinus);
parcelHelpers.export(exports, "BiShieldAlt", ()=>BiShieldAlt);
parcelHelpers.export(exports, "BiShieldAlt2", ()=>BiShieldAlt2);
parcelHelpers.export(exports, "BiShekel", ()=>BiShekel);
parcelHelpers.export(exports, "BiShare", ()=>BiShare);
parcelHelpers.export(exports, "BiShareAlt", ()=>BiShareAlt);
parcelHelpers.export(exports, "BiShapeTriangle", ()=>BiShapeTriangle);
parcelHelpers.export(exports, "BiShapeSquare", ()=>BiShapeSquare);
parcelHelpers.export(exports, "BiShapePolygon", ()=>BiShapePolygon);
parcelHelpers.export(exports, "BiShapeCircle", ()=>BiShapeCircle);
parcelHelpers.export(exports, "BiServer", ()=>BiServer);
parcelHelpers.export(exports, "BiSend", ()=>BiSend);
parcelHelpers.export(exports, "BiSelection", ()=>BiSelection);
parcelHelpers.export(exports, "BiSelectMultiple", ()=>BiSelectMultiple);
parcelHelpers.export(exports, "BiSearch", ()=>BiSearch);
parcelHelpers.export(exports, "BiSearchAlt", ()=>BiSearchAlt);
parcelHelpers.export(exports, "BiSearchAlt2", ()=>BiSearchAlt2);
parcelHelpers.export(exports, "BiScreenshot", ()=>BiScreenshot);
parcelHelpers.export(exports, "BiScatterChart", ()=>BiScatterChart);
parcelHelpers.export(exports, "BiScan", ()=>BiScan);
parcelHelpers.export(exports, "BiSave", ()=>BiSave);
parcelHelpers.export(exports, "BiSad", ()=>BiSad);
parcelHelpers.export(exports, "BiRupee", ()=>BiRupee);
parcelHelpers.export(exports, "BiRun", ()=>BiRun);
parcelHelpers.export(exports, "BiRuler", ()=>BiRuler);
parcelHelpers.export(exports, "BiRuble", ()=>BiRuble);
parcelHelpers.export(exports, "BiRss", ()=>BiRss);
parcelHelpers.export(exports, "BiRotateRight", ()=>BiRotateRight);
parcelHelpers.export(exports, "BiRotateLeft", ()=>BiRotateLeft);
parcelHelpers.export(exports, "BiRocket", ()=>BiRocket);
parcelHelpers.export(exports, "BiRightTopArrowCircle", ()=>BiRightTopArrowCircle);
parcelHelpers.export(exports, "BiRightIndent", ()=>BiRightIndent);
parcelHelpers.export(exports, "BiRightDownArrowCircle", ()=>BiRightDownArrowCircle);
parcelHelpers.export(exports, "BiRightArrow", ()=>BiRightArrow);
parcelHelpers.export(exports, "BiRightArrowCircle", ()=>BiRightArrowCircle);
parcelHelpers.export(exports, "BiRightArrowAlt", ()=>BiRightArrowAlt);
parcelHelpers.export(exports, "BiRfid", ()=>BiRfid);
parcelHelpers.export(exports, "BiRewind", ()=>BiRewind);
parcelHelpers.export(exports, "BiRewindCircle", ()=>BiRewindCircle);
parcelHelpers.export(exports, "BiRevision", ()=>BiRevision);
parcelHelpers.export(exports, "BiRestaurant", ()=>BiRestaurant);
parcelHelpers.export(exports, "BiReset", ()=>BiReset);
parcelHelpers.export(exports, "BiRepost", ()=>BiRepost);
parcelHelpers.export(exports, "BiReply", ()=>BiReply);
parcelHelpers.export(exports, "BiReplyAll", ()=>BiReplyAll);
parcelHelpers.export(exports, "BiRepeat", ()=>BiRepeat);
parcelHelpers.export(exports, "BiRename", ()=>BiRename);
parcelHelpers.export(exports, "BiRegistered", ()=>BiRegistered);
parcelHelpers.export(exports, "BiRefresh", ()=>BiRefresh);
parcelHelpers.export(exports, "BiReflectVertical", ()=>BiReflectVertical);
parcelHelpers.export(exports, "BiReflectHorizontal", ()=>BiReflectHorizontal);
parcelHelpers.export(exports, "BiRedo", ()=>BiRedo);
parcelHelpers.export(exports, "BiRecycle", ()=>BiRecycle);
parcelHelpers.export(exports, "BiRectangle", ()=>BiRectangle);
parcelHelpers.export(exports, "BiReceipt", ()=>BiReceipt);
parcelHelpers.export(exports, "BiRadio", ()=>BiRadio);
parcelHelpers.export(exports, "BiRadioCircle", ()=>BiRadioCircle);
parcelHelpers.export(exports, "BiRadioCircleMarked", ()=>BiRadioCircleMarked);
parcelHelpers.export(exports, "BiRadar", ()=>BiRadar);
parcelHelpers.export(exports, "BiQuestionMark", ()=>BiQuestionMark);
parcelHelpers.export(exports, "BiQr", ()=>BiQr);
parcelHelpers.export(exports, "BiQrScan", ()=>BiQrScan);
parcelHelpers.export(exports, "BiPyramid", ()=>BiPyramid);
parcelHelpers.export(exports, "BiPurchaseTag", ()=>BiPurchaseTag);
parcelHelpers.export(exports, "BiPurchaseTagAlt", ()=>BiPurchaseTagAlt);
parcelHelpers.export(exports, "BiPulse", ()=>BiPulse);
parcelHelpers.export(exports, "BiPrinter", ()=>BiPrinter);
parcelHelpers.export(exports, "BiPowerOff", ()=>BiPowerOff);
parcelHelpers.export(exports, "BiPound", ()=>BiPound);
parcelHelpers.export(exports, "BiPopsicle", ()=>BiPopsicle);
parcelHelpers.export(exports, "BiPolygon", ()=>BiPolygon);
parcelHelpers.export(exports, "BiPoll", ()=>BiPoll);
parcelHelpers.export(exports, "BiPointer", ()=>BiPointer);
parcelHelpers.export(exports, "BiPodcast", ()=>BiPodcast);
parcelHelpers.export(exports, "BiPlus", ()=>BiPlus);
parcelHelpers.export(exports, "BiPlusMedical", ()=>BiPlusMedical);
parcelHelpers.export(exports, "BiPlusCircle", ()=>BiPlusCircle);
parcelHelpers.export(exports, "BiPlug", ()=>BiPlug);
parcelHelpers.export(exports, "BiPlay", ()=>BiPlay);
parcelHelpers.export(exports, "BiPlayCircle", ()=>BiPlayCircle);
parcelHelpers.export(exports, "BiPlanet", ()=>BiPlanet);
parcelHelpers.export(exports, "BiPin", ()=>BiPin);
parcelHelpers.export(exports, "BiPieChart", ()=>BiPieChart);
parcelHelpers.export(exports, "BiPieChartAlt", ()=>BiPieChartAlt);
parcelHelpers.export(exports, "BiPieChartAlt2", ()=>BiPieChartAlt2);
parcelHelpers.export(exports, "BiPhotoAlbum", ()=>BiPhotoAlbum);
parcelHelpers.export(exports, "BiPhone", ()=>BiPhone);
parcelHelpers.export(exports, "BiPhoneOutgoing", ()=>BiPhoneOutgoing);
parcelHelpers.export(exports, "BiPhoneOff", ()=>BiPhoneOff);
parcelHelpers.export(exports, "BiPhoneIncoming", ()=>BiPhoneIncoming);
parcelHelpers.export(exports, "BiPhoneCall", ()=>BiPhoneCall);
parcelHelpers.export(exports, "BiPencil", ()=>BiPencil);
parcelHelpers.export(exports, "BiPen", ()=>BiPen);
parcelHelpers.export(exports, "BiPause", ()=>BiPause);
parcelHelpers.export(exports, "BiPauseCircle", ()=>BiPauseCircle);
parcelHelpers.export(exports, "BiPaste", ()=>BiPaste);
parcelHelpers.export(exports, "BiParty", ()=>BiParty);
parcelHelpers.export(exports, "BiParagraph", ()=>BiParagraph);
parcelHelpers.export(exports, "BiPaperclip", ()=>BiPaperclip);
parcelHelpers.export(exports, "BiPaperPlane", ()=>BiPaperPlane);
parcelHelpers.export(exports, "BiPalette", ()=>BiPalette);
parcelHelpers.export(exports, "BiPaint", ()=>BiPaint);
parcelHelpers.export(exports, "BiPaintRoll", ()=>BiPaintRoll);
parcelHelpers.export(exports, "BiPackage", ()=>BiPackage);
parcelHelpers.export(exports, "BiOutline", ()=>BiOutline);
parcelHelpers.export(exports, "BiObjectsVerticalTop", ()=>BiObjectsVerticalTop);
parcelHelpers.export(exports, "BiObjectsVerticalCenter", ()=>BiObjectsVerticalCenter);
parcelHelpers.export(exports, "BiObjectsVerticalBottom", ()=>BiObjectsVerticalBottom);
parcelHelpers.export(exports, "BiObjectsHorizontalRight", ()=>BiObjectsHorizontalRight);
parcelHelpers.export(exports, "BiObjectsHorizontalLeft", ()=>BiObjectsHorizontalLeft);
parcelHelpers.export(exports, "BiObjectsHorizontalCenter", ()=>BiObjectsHorizontalCenter);
parcelHelpers.export(exports, "BiNotification", ()=>BiNotification);
parcelHelpers.export(exports, "BiNotificationOff", ()=>BiNotificationOff);
parcelHelpers.export(exports, "BiNotepad", ()=>BiNotepad);
parcelHelpers.export(exports, "BiNote", ()=>BiNote);
parcelHelpers.export(exports, "BiNoSignal", ()=>BiNoSignal);
parcelHelpers.export(exports, "BiNoEntry", ()=>BiNoEntry);
parcelHelpers.export(exports, "BiNews", ()=>BiNews);
parcelHelpers.export(exports, "BiNetworkChart", ()=>BiNetworkChart);
parcelHelpers.export(exports, "BiNavigation", ()=>BiNavigation);
parcelHelpers.export(exports, "BiMusic", ()=>BiMusic);
parcelHelpers.export(exports, "BiMovie", ()=>BiMovie);
parcelHelpers.export(exports, "BiMoviePlay", ()=>BiMoviePlay);
parcelHelpers.export(exports, "BiMove", ()=>BiMove);
parcelHelpers.export(exports, "BiMoveVertical", ()=>BiMoveVertical);
parcelHelpers.export(exports, "BiMoveHorizontal", ()=>BiMoveHorizontal);
parcelHelpers.export(exports, "BiMouse", ()=>BiMouse);
parcelHelpers.export(exports, "BiMouseAlt", ()=>BiMouseAlt);
parcelHelpers.export(exports, "BiMoon", ()=>BiMoon);
parcelHelpers.export(exports, "BiMoney", ()=>BiMoney);
parcelHelpers.export(exports, "BiMoneyWithdraw", ()=>BiMoneyWithdraw);
parcelHelpers.export(exports, "BiMobile", ()=>BiMobile);
parcelHelpers.export(exports, "BiMobileVibration", ()=>BiMobileVibration);
parcelHelpers.export(exports, "BiMobileLandscape", ()=>BiMobileLandscape);
parcelHelpers.export(exports, "BiMobileAlt", ()=>BiMobileAlt);
parcelHelpers.export(exports, "BiMinus", ()=>BiMinus);
parcelHelpers.export(exports, "BiMinusFront", ()=>BiMinusFront);
parcelHelpers.export(exports, "BiMinusCircle", ()=>BiMinusCircle);
parcelHelpers.export(exports, "BiMinusBack", ()=>BiMinusBack);
parcelHelpers.export(exports, "BiMicrophone", ()=>BiMicrophone);
parcelHelpers.export(exports, "BiMicrophoneOff", ()=>BiMicrophoneOff);
parcelHelpers.export(exports, "BiMicrochip", ()=>BiMicrochip);
parcelHelpers.export(exports, "BiMeteor", ()=>BiMeteor);
parcelHelpers.export(exports, "BiMessage", ()=>BiMessage);
parcelHelpers.export(exports, "BiMessageX", ()=>BiMessageX);
parcelHelpers.export(exports, "BiMessageSquare", ()=>BiMessageSquare);
parcelHelpers.export(exports, "BiMessageSquareX", ()=>BiMessageSquareX);
parcelHelpers.export(exports, "BiMessageSquareMinus", ()=>BiMessageSquareMinus);
parcelHelpers.export(exports, "BiMessageSquareError", ()=>BiMessageSquareError);
parcelHelpers.export(exports, "BiMessageSquareEdit", ()=>BiMessageSquareEdit);
parcelHelpers.export(exports, "BiMessageSquareDots", ()=>BiMessageSquareDots);
parcelHelpers.export(exports, "BiMessageSquareDetail", ()=>BiMessageSquareDetail);
parcelHelpers.export(exports, "BiMessageSquareCheck", ()=>BiMessageSquareCheck);
parcelHelpers.export(exports, "BiMessageSquareAdd", ()=>BiMessageSquareAdd);
parcelHelpers.export(exports, "BiMessageRounded", ()=>BiMessageRounded);
parcelHelpers.export(exports, "BiMessageRoundedX", ()=>BiMessageRoundedX);
parcelHelpers.export(exports, "BiMessageRoundedMinus", ()=>BiMessageRoundedMinus);
parcelHelpers.export(exports, "BiMessageRoundedError", ()=>BiMessageRoundedError);
parcelHelpers.export(exports, "BiMessageRoundedEdit", ()=>BiMessageRoundedEdit);
parcelHelpers.export(exports, "BiMessageRoundedDots", ()=>BiMessageRoundedDots);
parcelHelpers.export(exports, "BiMessageRoundedDetail", ()=>BiMessageRoundedDetail);
parcelHelpers.export(exports, "BiMessageRoundedCheck", ()=>BiMessageRoundedCheck);
parcelHelpers.export(exports, "BiMessageRoundedAdd", ()=>BiMessageRoundedAdd);
parcelHelpers.export(exports, "BiMessageMinus", ()=>BiMessageMinus);
parcelHelpers.export(exports, "BiMessageError", ()=>BiMessageError);
parcelHelpers.export(exports, "BiMessageEdit", ()=>BiMessageEdit);
parcelHelpers.export(exports, "BiMessageDots", ()=>BiMessageDots);
parcelHelpers.export(exports, "BiMessageDetail", ()=>BiMessageDetail);
parcelHelpers.export(exports, "BiMessageCheck", ()=>BiMessageCheck);
parcelHelpers.export(exports, "BiMessageAlt", ()=>BiMessageAlt);
parcelHelpers.export(exports, "BiMessageAltX", ()=>BiMessageAltX);
parcelHelpers.export(exports, "BiMessageAltMinus", ()=>BiMessageAltMinus);
parcelHelpers.export(exports, "BiMessageAltError", ()=>BiMessageAltError);
parcelHelpers.export(exports, "BiMessageAltEdit", ()=>BiMessageAltEdit);
parcelHelpers.export(exports, "BiMessageAltDots", ()=>BiMessageAltDots);
parcelHelpers.export(exports, "BiMessageAltDetail", ()=>BiMessageAltDetail);
parcelHelpers.export(exports, "BiMessageAltCheck", ()=>BiMessageAltCheck);
parcelHelpers.export(exports, "BiMessageAltAdd", ()=>BiMessageAltAdd);
parcelHelpers.export(exports, "BiMessageAdd", ()=>BiMessageAdd);
parcelHelpers.export(exports, "BiMerge", ()=>BiMerge);
parcelHelpers.export(exports, "BiMenu", ()=>BiMenu);
parcelHelpers.export(exports, "BiMenuAltRight", ()=>BiMenuAltRight);
parcelHelpers.export(exports, "BiMenuAltLeft", ()=>BiMenuAltLeft);
parcelHelpers.export(exports, "BiMemoryCard", ()=>BiMemoryCard);
parcelHelpers.export(exports, "BiMeh", ()=>BiMeh);
parcelHelpers.export(exports, "BiMehBlank", ()=>BiMehBlank);
parcelHelpers.export(exports, "BiMehAlt", ()=>BiMehAlt);
parcelHelpers.export(exports, "BiMedal", ()=>BiMedal);
parcelHelpers.export(exports, "BiMath", ()=>BiMath);
parcelHelpers.export(exports, "BiMask", ()=>BiMask);
parcelHelpers.export(exports, "BiMap", ()=>BiMap);
parcelHelpers.export(exports, "BiMapPin", ()=>BiMapPin);
parcelHelpers.export(exports, "BiMapAlt", ()=>BiMapAlt);
parcelHelpers.export(exports, "BiMale", ()=>BiMale);
parcelHelpers.export(exports, "BiMaleSign", ()=>BiMaleSign);
parcelHelpers.export(exports, "BiMaleFemale", ()=>BiMaleFemale);
parcelHelpers.export(exports, "BiMailSend", ()=>BiMailSend);
parcelHelpers.export(exports, "BiMagnet", ()=>BiMagnet);
parcelHelpers.export(exports, "BiLowVision", ()=>BiLowVision);
parcelHelpers.export(exports, "BiLogOut", ()=>BiLogOut);
parcelHelpers.export(exports, "BiLogOutCircle", ()=>BiLogOutCircle);
parcelHelpers.export(exports, "BiLogIn", ()=>BiLogIn);
parcelHelpers.export(exports, "BiLogInCircle", ()=>BiLogInCircle);
parcelHelpers.export(exports, "BiLock", ()=>BiLock);
parcelHelpers.export(exports, "BiLockOpen", ()=>BiLockOpen);
parcelHelpers.export(exports, "BiLockOpenAlt", ()=>BiLockOpenAlt);
parcelHelpers.export(exports, "BiLockAlt", ()=>BiLockAlt);
parcelHelpers.export(exports, "BiLocationPlus", ()=>BiLocationPlus);
parcelHelpers.export(exports, "BiLoader", ()=>BiLoader);
parcelHelpers.export(exports, "BiLoaderCircle", ()=>BiLoaderCircle);
parcelHelpers.export(exports, "BiLoaderAlt", ()=>BiLoaderAlt);
parcelHelpers.export(exports, "BiListUl", ()=>BiListUl);
parcelHelpers.export(exports, "BiListPlus", ()=>BiListPlus);
parcelHelpers.export(exports, "BiListOl", ()=>BiListOl);
parcelHelpers.export(exports, "BiListMinus", ()=>BiListMinus);
parcelHelpers.export(exports, "BiListCheck", ()=>BiListCheck);
parcelHelpers.export(exports, "BiLira", ()=>BiLira);
parcelHelpers.export(exports, "BiLink", ()=>BiLink);
parcelHelpers.export(exports, "BiLinkExternal", ()=>BiLinkExternal);
parcelHelpers.export(exports, "BiLinkAlt", ()=>BiLinkAlt);
parcelHelpers.export(exports, "BiLineChart", ()=>BiLineChart);
parcelHelpers.export(exports, "BiLineChartDown", ()=>BiLineChartDown);
parcelHelpers.export(exports, "BiLike", ()=>BiLike);
parcelHelpers.export(exports, "BiLibrary", ()=>BiLibrary);
parcelHelpers.export(exports, "BiLemon", ()=>BiLemon);
parcelHelpers.export(exports, "BiLeftTopArrowCircle", ()=>BiLeftTopArrowCircle);
parcelHelpers.export(exports, "BiLeftIndent", ()=>BiLeftIndent);
parcelHelpers.export(exports, "BiLeftDownArrowCircle", ()=>BiLeftDownArrowCircle);
parcelHelpers.export(exports, "BiLeftArrow", ()=>BiLeftArrow);
parcelHelpers.export(exports, "BiLeftArrowCircle", ()=>BiLeftArrowCircle);
parcelHelpers.export(exports, "BiLeftArrowAlt", ()=>BiLeftArrowAlt);
parcelHelpers.export(exports, "BiLeaf", ()=>BiLeaf);
parcelHelpers.export(exports, "BiLayout", ()=>BiLayout);
parcelHelpers.export(exports, "BiLayer", ()=>BiLayer);
parcelHelpers.export(exports, "BiLayerPlus", ()=>BiLayerPlus);
parcelHelpers.export(exports, "BiLayerMinus", ()=>BiLayerMinus);
parcelHelpers.export(exports, "BiLaugh", ()=>BiLaugh);
parcelHelpers.export(exports, "BiLastPage", ()=>BiLastPage);
parcelHelpers.export(exports, "BiLaptop", ()=>BiLaptop);
parcelHelpers.export(exports, "BiLandscape", ()=>BiLandscape);
parcelHelpers.export(exports, "BiLabel", ()=>BiLabel);
parcelHelpers.export(exports, "BiKnife", ()=>BiKnife);
parcelHelpers.export(exports, "BiKey", ()=>BiKey);
parcelHelpers.export(exports, "BiJoystick", ()=>BiJoystick);
parcelHelpers.export(exports, "BiJoystickButton", ()=>BiJoystickButton);
parcelHelpers.export(exports, "BiJoystickAlt", ()=>BiJoystickAlt);
parcelHelpers.export(exports, "BiItalic", ()=>BiItalic);
parcelHelpers.export(exports, "BiIntersect", ()=>BiIntersect);
parcelHelpers.export(exports, "BiInjection", ()=>BiInjection);
parcelHelpers.export(exports, "BiInfoSquare", ()=>BiInfoSquare);
parcelHelpers.export(exports, "BiInfoCircle", ()=>BiInfoCircle);
parcelHelpers.export(exports, "BiInfinite", ()=>BiInfinite);
parcelHelpers.export(exports, "BiImport", ()=>BiImport);
parcelHelpers.export(exports, "BiImages", ()=>BiImages);
parcelHelpers.export(exports, "BiImage", ()=>BiImage);
parcelHelpers.export(exports, "BiImageAlt", ()=>BiImageAlt);
parcelHelpers.export(exports, "BiImageAdd", ()=>BiImageAdd);
parcelHelpers.export(exports, "BiIdCard", ()=>BiIdCard);
parcelHelpers.export(exports, "BiHourglass", ()=>BiHourglass);
parcelHelpers.export(exports, "BiHotel", ()=>BiHotel);
parcelHelpers.export(exports, "BiHorizontalRight", ()=>BiHorizontalRight);
parcelHelpers.export(exports, "BiHorizontalLeft", ()=>BiHorizontalLeft);
parcelHelpers.export(exports, "BiHorizontalCenter", ()=>BiHorizontalCenter);
parcelHelpers.export(exports, "BiHome", ()=>BiHome);
parcelHelpers.export(exports, "BiHomeSmile", ()=>BiHomeSmile);
parcelHelpers.export(exports, "BiHomeHeart", ()=>BiHomeHeart);
parcelHelpers.export(exports, "BiHomeCircle", ()=>BiHomeCircle);
parcelHelpers.export(exports, "BiHomeAlt", ()=>BiHomeAlt);
parcelHelpers.export(exports, "BiHomeAlt2", ()=>BiHomeAlt2);
parcelHelpers.export(exports, "BiHive", ()=>BiHive);
parcelHelpers.export(exports, "BiHistory", ()=>BiHistory);
parcelHelpers.export(exports, "BiHighlight", ()=>BiHighlight);
parcelHelpers.export(exports, "BiHide", ()=>BiHide);
parcelHelpers.export(exports, "BiHelpCircle", ()=>BiHelpCircle);
parcelHelpers.export(exports, "BiHeart", ()=>BiHeart);
parcelHelpers.export(exports, "BiHeartSquare", ()=>BiHeartSquare);
parcelHelpers.export(exports, "BiHeartCircle", ()=>BiHeartCircle);
parcelHelpers.export(exports, "BiHealth", ()=>BiHealth);
parcelHelpers.export(exports, "BiHeadphone", ()=>BiHeadphone);
parcelHelpers.export(exports, "BiHeading", ()=>BiHeading);
parcelHelpers.export(exports, "BiHdd", ()=>BiHdd);
parcelHelpers.export(exports, "BiHash", ()=>BiHash);
parcelHelpers.export(exports, "BiHardHat", ()=>BiHardHat);
parcelHelpers.export(exports, "BiHappy", ()=>BiHappy);
parcelHelpers.export(exports, "BiHappyHeartEyes", ()=>BiHappyHeartEyes);
parcelHelpers.export(exports, "BiHappyBeaming", ()=>BiHappyBeaming);
parcelHelpers.export(exports, "BiHappyAlt", ()=>BiHappyAlt);
parcelHelpers.export(exports, "BiHandicap", ()=>BiHandicap);
parcelHelpers.export(exports, "BiGroup", ()=>BiGroup);
parcelHelpers.export(exports, "BiGrid", ()=>BiGrid);
parcelHelpers.export(exports, "BiGridVertical", ()=>BiGridVertical);
parcelHelpers.export(exports, "BiGridSmall", ()=>BiGridSmall);
parcelHelpers.export(exports, "BiGridHorizontal", ()=>BiGridHorizontal);
parcelHelpers.export(exports, "BiGridAlt", ()=>BiGridAlt);
parcelHelpers.export(exports, "BiGlobe", ()=>BiGlobe);
parcelHelpers.export(exports, "BiGlobeAlt", ()=>BiGlobeAlt);
parcelHelpers.export(exports, "BiGlasses", ()=>BiGlasses);
parcelHelpers.export(exports, "BiGlassesAlt", ()=>BiGlassesAlt);
parcelHelpers.export(exports, "BiGitRepoForked", ()=>BiGitRepoForked);
parcelHelpers.export(exports, "BiGitPullRequest", ()=>BiGitPullRequest);
parcelHelpers.export(exports, "BiGitMerge", ()=>BiGitMerge);
parcelHelpers.export(exports, "BiGitCompare", ()=>BiGitCompare);
parcelHelpers.export(exports, "BiGitCommit", ()=>BiGitCommit);
parcelHelpers.export(exports, "BiGitBranch", ()=>BiGitBranch);
parcelHelpers.export(exports, "BiGift", ()=>BiGift);
parcelHelpers.export(exports, "BiGhost", ()=>BiGhost);
parcelHelpers.export(exports, "BiGasPump", ()=>BiGasPump);
parcelHelpers.export(exports, "BiGame", ()=>BiGame);
parcelHelpers.export(exports, "BiFullscreen", ()=>BiFullscreen);
parcelHelpers.export(exports, "BiFridge", ()=>BiFridge);
parcelHelpers.export(exports, "BiFork", ()=>BiFork);
parcelHelpers.export(exports, "BiFootball", ()=>BiFootball);
parcelHelpers.export(exports, "BiFoodTag", ()=>BiFoodTag);
parcelHelpers.export(exports, "BiFoodMenu", ()=>BiFoodMenu);
parcelHelpers.export(exports, "BiFont", ()=>BiFont);
parcelHelpers.export(exports, "BiFontSize", ()=>BiFontSize);
parcelHelpers.export(exports, "BiFontFamily", ()=>BiFontFamily);
parcelHelpers.export(exports, "BiFontColor", ()=>BiFontColor);
parcelHelpers.export(exports, "BiFolder", ()=>BiFolder);
parcelHelpers.export(exports, "BiFolderPlus", ()=>BiFolderPlus);
parcelHelpers.export(exports, "BiFolderOpen", ()=>BiFolderOpen);
parcelHelpers.export(exports, "BiFolderMinus", ()=>BiFolderMinus);
parcelHelpers.export(exports, "BiFlag", ()=>BiFlag);
parcelHelpers.export(exports, "BiFirstPage", ()=>BiFirstPage);
parcelHelpers.export(exports, "BiFirstAid", ()=>BiFirstAid);
parcelHelpers.export(exports, "BiFingerprint", ()=>BiFingerprint);
parcelHelpers.export(exports, "BiFilter", ()=>BiFilter);
parcelHelpers.export(exports, "BiFilterAlt", ()=>BiFilterAlt);
parcelHelpers.export(exports, "BiFilm", ()=>BiFilm);
parcelHelpers.export(exports, "BiFile", ()=>BiFile);
parcelHelpers.export(exports, "BiFileFind", ()=>BiFileFind);
parcelHelpers.export(exports, "BiFileBlank", ()=>BiFileBlank);
parcelHelpers.export(exports, "BiFemale", ()=>BiFemale);
parcelHelpers.export(exports, "BiFemaleSign", ()=>BiFemaleSign);
parcelHelpers.export(exports, "BiFastForward", ()=>BiFastForward);
parcelHelpers.export(exports, "BiFastForwardCircle", ()=>BiFastForwardCircle);
parcelHelpers.export(exports, "BiFace", ()=>BiFace);
parcelHelpers.export(exports, "BiExtension", ()=>BiExtension);
parcelHelpers.export(exports, "BiExport", ()=>BiExport);
parcelHelpers.export(exports, "BiExpand", ()=>BiExpand);
parcelHelpers.export(exports, "BiExpandVertical", ()=>BiExpandVertical);
parcelHelpers.export(exports, "BiExpandHorizontal", ()=>BiExpandHorizontal);
parcelHelpers.export(exports, "BiExpandAlt", ()=>BiExpandAlt);
parcelHelpers.export(exports, "BiExit", ()=>BiExit);
parcelHelpers.export(exports, "BiExitFullscreen", ()=>BiExitFullscreen);
parcelHelpers.export(exports, "BiExclude", ()=>BiExclude);
parcelHelpers.export(exports, "BiEuro", ()=>BiEuro);
parcelHelpers.export(exports, "BiError", ()=>BiError);
parcelHelpers.export(exports, "BiErrorCircle", ()=>BiErrorCircle);
parcelHelpers.export(exports, "BiErrorAlt", ()=>BiErrorAlt);
parcelHelpers.export(exports, "BiEraser", ()=>BiEraser);
parcelHelpers.export(exports, "BiEqualizer", ()=>BiEqualizer);
parcelHelpers.export(exports, "BiEnvelope", ()=>BiEnvelope);
parcelHelpers.export(exports, "BiEnvelopeOpen", ()=>BiEnvelopeOpen);
parcelHelpers.export(exports, "BiEdit", ()=>BiEdit);
parcelHelpers.export(exports, "BiEditAlt", ()=>BiEditAlt);
parcelHelpers.export(exports, "BiDuplicate", ()=>BiDuplicate);
parcelHelpers.export(exports, "BiDumbbell", ()=>BiDumbbell);
parcelHelpers.export(exports, "BiDroplet", ()=>BiDroplet);
parcelHelpers.export(exports, "BiDrink", ()=>BiDrink);
parcelHelpers.export(exports, "BiDownvote", ()=>BiDownvote);
parcelHelpers.export(exports, "BiDownload", ()=>BiDownload);
parcelHelpers.export(exports, "BiDownArrow", ()=>BiDownArrow);
parcelHelpers.export(exports, "BiDownArrowCircle", ()=>BiDownArrowCircle);
parcelHelpers.export(exports, "BiDownArrowAlt", ()=>BiDownArrowAlt);
parcelHelpers.export(exports, "BiDoughnutChart", ()=>BiDoughnutChart);
parcelHelpers.export(exports, "BiDotsVertical", ()=>BiDotsVertical);
parcelHelpers.export(exports, "BiDotsVerticalRounded", ()=>BiDotsVerticalRounded);
parcelHelpers.export(exports, "BiDotsHorizontal", ()=>BiDotsHorizontal);
parcelHelpers.export(exports, "BiDotsHorizontalRounded", ()=>BiDotsHorizontalRounded);
parcelHelpers.export(exports, "BiDoorOpen", ()=>BiDoorOpen);
parcelHelpers.export(exports, "BiDonateHeart", ()=>BiDonateHeart);
parcelHelpers.export(exports, "BiDonateBlood", ()=>BiDonateBlood);
parcelHelpers.export(exports, "BiDollar", ()=>BiDollar);
parcelHelpers.export(exports, "BiDollarCircle", ()=>BiDollarCircle);
parcelHelpers.export(exports, "BiDockTop", ()=>BiDockTop);
parcelHelpers.export(exports, "BiDockRight", ()=>BiDockRight);
parcelHelpers.export(exports, "BiDockLeft", ()=>BiDockLeft);
parcelHelpers.export(exports, "BiDockBottom", ()=>BiDockBottom);
parcelHelpers.export(exports, "BiDna", ()=>BiDna);
parcelHelpers.export(exports, "BiDizzy", ()=>BiDizzy);
parcelHelpers.export(exports, "BiDislike", ()=>BiDislike);
parcelHelpers.export(exports, "BiDish", ()=>BiDish);
parcelHelpers.export(exports, "BiDisc", ()=>BiDisc);
parcelHelpers.export(exports, "BiDirections", ()=>BiDirections);
parcelHelpers.export(exports, "BiDice6", ()=>BiDice6);
parcelHelpers.export(exports, "BiDice5", ()=>BiDice5);
parcelHelpers.export(exports, "BiDice4", ()=>BiDice4);
parcelHelpers.export(exports, "BiDice3", ()=>BiDice3);
parcelHelpers.export(exports, "BiDice2", ()=>BiDice2);
parcelHelpers.export(exports, "BiDice1", ()=>BiDice1);
parcelHelpers.export(exports, "BiDiamond", ()=>BiDiamond);
parcelHelpers.export(exports, "BiDialpad", ()=>BiDialpad);
parcelHelpers.export(exports, "BiDialpadAlt", ()=>BiDialpadAlt);
parcelHelpers.export(exports, "BiDevices", ()=>BiDevices);
parcelHelpers.export(exports, "BiDetail", ()=>BiDetail);
parcelHelpers.export(exports, "BiDesktop", ()=>BiDesktop);
parcelHelpers.export(exports, "BiData", ()=>BiData);
parcelHelpers.export(exports, "BiCylinder", ()=>BiCylinder);
parcelHelpers.export(exports, "BiCycling", ()=>BiCycling);
parcelHelpers.export(exports, "BiCut", ()=>BiCut);
parcelHelpers.export(exports, "BiCustomize", ()=>BiCustomize);
parcelHelpers.export(exports, "BiCurrentLocation", ()=>BiCurrentLocation);
parcelHelpers.export(exports, "BiCuboid", ()=>BiCuboid);
parcelHelpers.export(exports, "BiCube", ()=>BiCube);
parcelHelpers.export(exports, "BiCubeAlt", ()=>BiCubeAlt);
parcelHelpers.export(exports, "BiCrown", ()=>BiCrown);
parcelHelpers.export(exports, "BiCrosshair", ()=>BiCrosshair);
parcelHelpers.export(exports, "BiCross", ()=>BiCross);
parcelHelpers.export(exports, "BiCrop", ()=>BiCrop);
parcelHelpers.export(exports, "BiCricketBall", ()=>BiCricketBall);
parcelHelpers.export(exports, "BiCreditCard", ()=>BiCreditCard);
parcelHelpers.export(exports, "BiCreditCardFront", ()=>BiCreditCardFront);
parcelHelpers.export(exports, "BiCreditCardAlt", ()=>BiCreditCardAlt);
parcelHelpers.export(exports, "BiCopyright", ()=>BiCopyright);
parcelHelpers.export(exports, "BiCopy", ()=>BiCopy);
parcelHelpers.export(exports, "BiCopyAlt", ()=>BiCopyAlt);
parcelHelpers.export(exports, "BiCool", ()=>BiCool);
parcelHelpers.export(exports, "BiCookie", ()=>BiCookie);
parcelHelpers.export(exports, "BiConversation", ()=>BiConversation);
parcelHelpers.export(exports, "BiConfused", ()=>BiConfused);
parcelHelpers.export(exports, "BiCompass", ()=>BiCompass);
parcelHelpers.export(exports, "BiComment", ()=>BiComment);
parcelHelpers.export(exports, "BiCommentX", ()=>BiCommentX);
parcelHelpers.export(exports, "BiCommentMinus", ()=>BiCommentMinus);
parcelHelpers.export(exports, "BiCommentError", ()=>BiCommentError);
parcelHelpers.export(exports, "BiCommentEdit", ()=>BiCommentEdit);
parcelHelpers.export(exports, "BiCommentDots", ()=>BiCommentDots);
parcelHelpers.export(exports, "BiCommentDetail", ()=>BiCommentDetail);
parcelHelpers.export(exports, "BiCommentCheck", ()=>BiCommentCheck);
parcelHelpers.export(exports, "BiCommentAdd", ()=>BiCommentAdd);
parcelHelpers.export(exports, "BiCommand", ()=>BiCommand);
parcelHelpers.export(exports, "BiColumns", ()=>BiColumns);
parcelHelpers.export(exports, "BiColor", ()=>BiColor);
parcelHelpers.export(exports, "BiColorFill", ()=>BiColorFill);
parcelHelpers.export(exports, "BiCollection", ()=>BiCollection);
parcelHelpers.export(exports, "BiCollapse", ()=>BiCollapse);
parcelHelpers.export(exports, "BiCollapseVertical", ()=>BiCollapseVertical);
parcelHelpers.export(exports, "BiCollapseHorizontal", ()=>BiCollapseHorizontal);
parcelHelpers.export(exports, "BiCollapseAlt", ()=>BiCollapseAlt);
parcelHelpers.export(exports, "BiCoin", ()=>BiCoin);
parcelHelpers.export(exports, "BiCoinStack", ()=>BiCoinStack);
parcelHelpers.export(exports, "BiCog", ()=>BiCog);
parcelHelpers.export(exports, "BiCoffee", ()=>BiCoffee);
parcelHelpers.export(exports, "BiCoffeeTogo", ()=>BiCoffeeTogo);
parcelHelpers.export(exports, "BiCode", ()=>BiCode);
parcelHelpers.export(exports, "BiCodeCurly", ()=>BiCodeCurly);
parcelHelpers.export(exports, "BiCodeBlock", ()=>BiCodeBlock);
parcelHelpers.export(exports, "BiCodeAlt", ()=>BiCodeAlt);
parcelHelpers.export(exports, "BiCloud", ()=>BiCloud);
parcelHelpers.export(exports, "BiCloudUpload", ()=>BiCloudUpload);
parcelHelpers.export(exports, "BiCloudSnow", ()=>BiCloudSnow);
parcelHelpers.export(exports, "BiCloudRain", ()=>BiCloudRain);
parcelHelpers.export(exports, "BiCloudLightning", ()=>BiCloudLightning);
parcelHelpers.export(exports, "BiCloudLightRain", ()=>BiCloudLightRain);
parcelHelpers.export(exports, "BiCloudDrizzle", ()=>BiCloudDrizzle);
parcelHelpers.export(exports, "BiCloudDownload", ()=>BiCloudDownload);
parcelHelpers.export(exports, "BiCloset", ()=>BiCloset);
parcelHelpers.export(exports, "BiClipboard", ()=>BiClipboard);
parcelHelpers.export(exports, "BiClinic", ()=>BiClinic);
parcelHelpers.export(exports, "BiCircle", ()=>BiCircle);
parcelHelpers.export(exports, "BiCircleThreeQuarter", ()=>BiCircleThreeQuarter);
parcelHelpers.export(exports, "BiCircleQuarter", ()=>BiCircleQuarter);
parcelHelpers.export(exports, "BiCircleHalf", ()=>BiCircleHalf);
parcelHelpers.export(exports, "BiChurch", ()=>BiChurch);
parcelHelpers.export(exports, "BiChip", ()=>BiChip);
parcelHelpers.export(exports, "BiChild", ()=>BiChild);
parcelHelpers.export(exports, "BiChevronsUp", ()=>BiChevronsUp);
parcelHelpers.export(exports, "BiChevronsRight", ()=>BiChevronsRight);
parcelHelpers.export(exports, "BiChevronsLeft", ()=>BiChevronsLeft);
parcelHelpers.export(exports, "BiChevronsDown", ()=>BiChevronsDown);
parcelHelpers.export(exports, "BiChevronUp", ()=>BiChevronUp);
parcelHelpers.export(exports, "BiChevronUpSquare", ()=>BiChevronUpSquare);
parcelHelpers.export(exports, "BiChevronUpCircle", ()=>BiChevronUpCircle);
parcelHelpers.export(exports, "BiChevronRight", ()=>BiChevronRight);
parcelHelpers.export(exports, "BiChevronRightSquare", ()=>BiChevronRightSquare);
parcelHelpers.export(exports, "BiChevronRightCircle", ()=>BiChevronRightCircle);
parcelHelpers.export(exports, "BiChevronLeft", ()=>BiChevronLeft);
parcelHelpers.export(exports, "BiChevronLeftSquare", ()=>BiChevronLeftSquare);
parcelHelpers.export(exports, "BiChevronLeftCircle", ()=>BiChevronLeftCircle);
parcelHelpers.export(exports, "BiChevronDown", ()=>BiChevronDown);
parcelHelpers.export(exports, "BiChevronDownSquare", ()=>BiChevronDownSquare);
parcelHelpers.export(exports, "BiChevronDownCircle", ()=>BiChevronDownCircle);
parcelHelpers.export(exports, "BiCheese", ()=>BiCheese);
parcelHelpers.export(exports, "BiCheckbox", ()=>BiCheckbox);
parcelHelpers.export(exports, "BiCheckboxSquare", ()=>BiCheckboxSquare);
parcelHelpers.export(exports, "BiCheckboxMinus", ()=>BiCheckboxMinus);
parcelHelpers.export(exports, "BiCheckboxChecked", ()=>BiCheckboxChecked);
parcelHelpers.export(exports, "BiCheck", ()=>BiCheck);
parcelHelpers.export(exports, "BiCheckSquare", ()=>BiCheckSquare);
parcelHelpers.export(exports, "BiCheckShield", ()=>BiCheckShield);
parcelHelpers.export(exports, "BiCheckDouble", ()=>BiCheckDouble);
parcelHelpers.export(exports, "BiCheckCircle", ()=>BiCheckCircle);
parcelHelpers.export(exports, "BiChat", ()=>BiChat);
parcelHelpers.export(exports, "BiChart", ()=>BiChart);
parcelHelpers.export(exports, "BiChalkboard", ()=>BiChalkboard);
parcelHelpers.export(exports, "BiChair", ()=>BiChair);
parcelHelpers.export(exports, "BiCertification", ()=>BiCertification);
parcelHelpers.export(exports, "BiCctv", ()=>BiCctv);
parcelHelpers.export(exports, "BiCategory", ()=>BiCategory);
parcelHelpers.export(exports, "BiCategoryAlt", ()=>BiCategoryAlt);
parcelHelpers.export(exports, "BiCast", ()=>BiCast);
parcelHelpers.export(exports, "BiCart", ()=>BiCart);
parcelHelpers.export(exports, "BiCartDownload", ()=>BiCartDownload);
parcelHelpers.export(exports, "BiCartAlt", ()=>BiCartAlt);
parcelHelpers.export(exports, "BiCartAdd", ()=>BiCartAdd);
parcelHelpers.export(exports, "BiCarousel", ()=>BiCarousel);
parcelHelpers.export(exports, "BiCaretUp", ()=>BiCaretUp);
parcelHelpers.export(exports, "BiCaretUpSquare", ()=>BiCaretUpSquare);
parcelHelpers.export(exports, "BiCaretUpCircle", ()=>BiCaretUpCircle);
parcelHelpers.export(exports, "BiCaretRight", ()=>BiCaretRight);
parcelHelpers.export(exports, "BiCaretRightSquare", ()=>BiCaretRightSquare);
parcelHelpers.export(exports, "BiCaretRightCircle", ()=>BiCaretRightCircle);
parcelHelpers.export(exports, "BiCaretLeft", ()=>BiCaretLeft);
parcelHelpers.export(exports, "BiCaretLeftSquare", ()=>BiCaretLeftSquare);
parcelHelpers.export(exports, "BiCaretLeftCircle", ()=>BiCaretLeftCircle);
parcelHelpers.export(exports, "BiCaretDown", ()=>BiCaretDown);
parcelHelpers.export(exports, "BiCaretDownSquare", ()=>BiCaretDownSquare);
parcelHelpers.export(exports, "BiCaretDownCircle", ()=>BiCaretDownCircle);
parcelHelpers.export(exports, "BiCard", ()=>BiCard);
parcelHelpers.export(exports, "BiCar", ()=>BiCar);
parcelHelpers.export(exports, "BiCaptions", ()=>BiCaptions);
parcelHelpers.export(exports, "BiCapsule", ()=>BiCapsule);
parcelHelpers.export(exports, "BiCandles", ()=>BiCandles);
parcelHelpers.export(exports, "BiCamera", ()=>BiCamera);
parcelHelpers.export(exports, "BiCameraOff", ()=>BiCameraOff);
parcelHelpers.export(exports, "BiCameraMovie", ()=>BiCameraMovie);
parcelHelpers.export(exports, "BiCameraHome", ()=>BiCameraHome);
parcelHelpers.export(exports, "BiCalendar", ()=>BiCalendar);
parcelHelpers.export(exports, "BiCalendarX", ()=>BiCalendarX);
parcelHelpers.export(exports, "BiCalendarWeek", ()=>BiCalendarWeek);
parcelHelpers.export(exports, "BiCalendarStar", ()=>BiCalendarStar);
parcelHelpers.export(exports, "BiCalendarPlus", ()=>BiCalendarPlus);
parcelHelpers.export(exports, "BiCalendarMinus", ()=>BiCalendarMinus);
parcelHelpers.export(exports, "BiCalendarHeart", ()=>BiCalendarHeart);
parcelHelpers.export(exports, "BiCalendarExclamation", ()=>BiCalendarExclamation);
parcelHelpers.export(exports, "BiCalendarEvent", ()=>BiCalendarEvent);
parcelHelpers.export(exports, "BiCalendarEdit", ()=>BiCalendarEdit);
parcelHelpers.export(exports, "BiCalendarCheck", ()=>BiCalendarCheck);
parcelHelpers.export(exports, "BiCalendarAlt", ()=>BiCalendarAlt);
parcelHelpers.export(exports, "BiCalculator", ()=>BiCalculator);
parcelHelpers.export(exports, "BiCake", ()=>BiCake);
parcelHelpers.export(exports, "BiCableCar", ()=>BiCableCar);
parcelHelpers.export(exports, "BiCabinet", ()=>BiCabinet);
parcelHelpers.export(exports, "BiBus", ()=>BiBus);
parcelHelpers.export(exports, "BiBusSchool", ()=>BiBusSchool);
parcelHelpers.export(exports, "BiBuoy", ()=>BiBuoy);
parcelHelpers.export(exports, "BiBullseye", ()=>BiBullseye);
parcelHelpers.export(exports, "BiBulb", ()=>BiBulb);
parcelHelpers.export(exports, "BiBuildings", ()=>BiBuildings);
parcelHelpers.export(exports, "BiBuilding", ()=>BiBuilding);
parcelHelpers.export(exports, "BiBuildingHouse", ()=>BiBuildingHouse);
parcelHelpers.export(exports, "BiBug", ()=>BiBug);
parcelHelpers.export(exports, "BiBugAlt", ()=>BiBugAlt);
parcelHelpers.export(exports, "BiBrush", ()=>BiBrush);
parcelHelpers.export(exports, "BiBrushAlt", ()=>BiBrushAlt);
parcelHelpers.export(exports, "BiBroadcast", ()=>BiBroadcast);
parcelHelpers.export(exports, "BiBrightness", ()=>BiBrightness);
parcelHelpers.export(exports, "BiBrightnessHalf", ()=>BiBrightnessHalf);
parcelHelpers.export(exports, "BiBriefcase", ()=>BiBriefcase);
parcelHelpers.export(exports, "BiBriefcaseAlt", ()=>BiBriefcaseAlt);
parcelHelpers.export(exports, "BiBriefcaseAlt2", ()=>BiBriefcaseAlt2);
parcelHelpers.export(exports, "BiBrain", ()=>BiBrain);
parcelHelpers.export(exports, "BiBraille", ()=>BiBraille);
parcelHelpers.export(exports, "BiBracket", ()=>BiBracket);
parcelHelpers.export(exports, "BiBox", ()=>BiBox);
parcelHelpers.export(exports, "BiBowlingBall", ()=>BiBowlingBall);
parcelHelpers.export(exports, "BiBowlRice", ()=>BiBowlRice);
parcelHelpers.export(exports, "BiBowlHot", ()=>BiBowlHot);
parcelHelpers.export(exports, "BiBot", ()=>BiBot);
parcelHelpers.export(exports, "BiBorderTop", ()=>BiBorderTop);
parcelHelpers.export(exports, "BiBorderRight", ()=>BiBorderRight);
parcelHelpers.export(exports, "BiBorderRadius", ()=>BiBorderRadius);
parcelHelpers.export(exports, "BiBorderOuter", ()=>BiBorderOuter);
parcelHelpers.export(exports, "BiBorderNone", ()=>BiBorderNone);
parcelHelpers.export(exports, "BiBorderLeft", ()=>BiBorderLeft);
parcelHelpers.export(exports, "BiBorderInner", ()=>BiBorderInner);
parcelHelpers.export(exports, "BiBorderBottom", ()=>BiBorderBottom);
parcelHelpers.export(exports, "BiBorderAll", ()=>BiBorderAll);
parcelHelpers.export(exports, "BiBookmarks", ()=>BiBookmarks);
parcelHelpers.export(exports, "BiBookmark", ()=>BiBookmark);
parcelHelpers.export(exports, "BiBookmarkPlus", ()=>BiBookmarkPlus);
parcelHelpers.export(exports, "BiBookmarkMinus", ()=>BiBookmarkMinus);
parcelHelpers.export(exports, "BiBookmarkHeart", ()=>BiBookmarkHeart);
parcelHelpers.export(exports, "BiBookmarkAlt", ()=>BiBookmarkAlt);
parcelHelpers.export(exports, "BiBookmarkAltPlus", ()=>BiBookmarkAltPlus);
parcelHelpers.export(exports, "BiBookmarkAltMinus", ()=>BiBookmarkAltMinus);
parcelHelpers.export(exports, "BiBook", ()=>BiBook);
parcelHelpers.export(exports, "BiBookReader", ()=>BiBookReader);
parcelHelpers.export(exports, "BiBookOpen", ()=>BiBookOpen);
parcelHelpers.export(exports, "BiBookHeart", ()=>BiBookHeart);
parcelHelpers.export(exports, "BiBookContent", ()=>BiBookContent);
parcelHelpers.export(exports, "BiBookBookmark", ()=>BiBookBookmark);
parcelHelpers.export(exports, "BiBookAlt", ()=>BiBookAlt);
parcelHelpers.export(exports, "BiBookAdd", ()=>BiBookAdd);
parcelHelpers.export(exports, "BiBong", ()=>BiBong);
parcelHelpers.export(exports, "BiBone", ()=>BiBone);
parcelHelpers.export(exports, "BiBomb", ()=>BiBomb);
parcelHelpers.export(exports, "BiBoltCircle", ()=>BiBoltCircle);
parcelHelpers.export(exports, "BiBold", ()=>BiBold);
parcelHelpers.export(exports, "BiBody", ()=>BiBody);
parcelHelpers.export(exports, "BiBluetooth", ()=>BiBluetooth);
parcelHelpers.export(exports, "BiBlock", ()=>BiBlock);
parcelHelpers.export(exports, "BiBlanket", ()=>BiBlanket);
parcelHelpers.export(exports, "BiBitcoin", ()=>BiBitcoin);
parcelHelpers.export(exports, "BiBible", ()=>BiBible);
parcelHelpers.export(exports, "BiBell", ()=>BiBell);
parcelHelpers.export(exports, "BiBellPlus", ()=>BiBellPlus);
parcelHelpers.export(exports, "BiBellOff", ()=>BiBellOff);
parcelHelpers.export(exports, "BiBellMinus", ()=>BiBellMinus);
parcelHelpers.export(exports, "BiBeer", ()=>BiBeer);
parcelHelpers.export(exports, "BiBeenHere", ()=>BiBeenHere);
parcelHelpers.export(exports, "BiBed", ()=>BiBed);
parcelHelpers.export(exports, "BiBattery", ()=>BiBattery);
parcelHelpers.export(exports, "BiBath", ()=>BiBath);
parcelHelpers.export(exports, "BiBasketball", ()=>BiBasketball);
parcelHelpers.export(exports, "BiBasket", ()=>BiBasket);
parcelHelpers.export(exports, "BiBaseball", ()=>BiBaseball);
parcelHelpers.export(exports, "BiBarcode", ()=>BiBarcode);
parcelHelpers.export(exports, "BiBarcodeReader", ()=>BiBarcodeReader);
parcelHelpers.export(exports, "BiBarChart", ()=>BiBarChart);
parcelHelpers.export(exports, "BiBarChartSquare", ()=>BiBarChartSquare);
parcelHelpers.export(exports, "BiBarChartAlt", ()=>BiBarChartAlt);
parcelHelpers.export(exports, "BiBarChartAlt2", ()=>BiBarChartAlt2);
parcelHelpers.export(exports, "BiBandAid", ()=>BiBandAid);
parcelHelpers.export(exports, "BiBall", ()=>BiBall);
parcelHelpers.export(exports, "BiBaguette", ()=>BiBaguette);
parcelHelpers.export(exports, "BiBadge", ()=>BiBadge);
parcelHelpers.export(exports, "BiBadgeCheck", ()=>BiBadgeCheck);
parcelHelpers.export(exports, "BiAward", ()=>BiAward);
parcelHelpers.export(exports, "BiAtom", ()=>BiAtom);
parcelHelpers.export(exports, "BiAt", ()=>BiAt);
parcelHelpers.export(exports, "BiArrowToTop", ()=>BiArrowToTop);
parcelHelpers.export(exports, "BiArrowToRight", ()=>BiArrowToRight);
parcelHelpers.export(exports, "BiArrowToLeft", ()=>BiArrowToLeft);
parcelHelpers.export(exports, "BiArrowToBottom", ()=>BiArrowToBottom);
parcelHelpers.export(exports, "BiArrowFromTop", ()=>BiArrowFromTop);
parcelHelpers.export(exports, "BiArrowFromRight", ()=>BiArrowFromRight);
parcelHelpers.export(exports, "BiArrowFromLeft", ()=>BiArrowFromLeft);
parcelHelpers.export(exports, "BiArrowFromBottom", ()=>BiArrowFromBottom);
parcelHelpers.export(exports, "BiArrowBack", ()=>BiArrowBack);
parcelHelpers.export(exports, "BiArea", ()=>BiArea);
parcelHelpers.export(exports, "BiArchive", ()=>BiArchive);
parcelHelpers.export(exports, "BiArchiveOut", ()=>BiArchiveOut);
parcelHelpers.export(exports, "BiArchiveIn", ()=>BiArchiveIn);
parcelHelpers.export(exports, "BiArch", ()=>BiArch);
parcelHelpers.export(exports, "BiAperture", ()=>BiAperture);
parcelHelpers.export(exports, "BiAngry", ()=>BiAngry);
parcelHelpers.export(exports, "BiAnchor", ()=>BiAnchor);
parcelHelpers.export(exports, "BiAnalyse", ()=>BiAnalyse);
parcelHelpers.export(exports, "BiAlignRight", ()=>BiAlignRight);
parcelHelpers.export(exports, "BiAlignMiddle", ()=>BiAlignMiddle);
parcelHelpers.export(exports, "BiAlignLeft", ()=>BiAlignLeft);
parcelHelpers.export(exports, "BiAlignJustify", ()=>BiAlignJustify);
parcelHelpers.export(exports, "BiAlbum", ()=>BiAlbum);
parcelHelpers.export(exports, "BiAlarm", ()=>BiAlarm);
parcelHelpers.export(exports, "BiAlarmSnooze", ()=>BiAlarmSnooze);
parcelHelpers.export(exports, "BiAlarmOff", ()=>BiAlarmOff);
parcelHelpers.export(exports, "BiAlarmExclamation", ()=>BiAlarmExclamation);
parcelHelpers.export(exports, "BiAlarmAdd", ()=>BiAlarmAdd);
parcelHelpers.export(exports, "BiAdjust", ()=>BiAdjust);
parcelHelpers.export(exports, "BiAddToQueue", ()=>BiAddToQueue);
parcelHelpers.export(exports, "BiAccessibility", ()=>BiAccessibility);
parcelHelpers.export(exports, "BiAbacus", ()=>BiAbacus);
parcelHelpers.export(exports, "BiSolidZoomOut", ()=>BiSolidZoomOut);
parcelHelpers.export(exports, "BiSolidZoomIn", ()=>BiSolidZoomIn);
parcelHelpers.export(exports, "BiSolidZap", ()=>BiSolidZap);
parcelHelpers.export(exports, "BiSolidYinYang", ()=>BiSolidYinYang);
parcelHelpers.export(exports, "BiSolidXSquare", ()=>BiSolidXSquare);
parcelHelpers.export(exports, "BiSolidXCircle", ()=>BiSolidXCircle);
parcelHelpers.export(exports, "BiSolidWrench", ()=>BiSolidWrench);
parcelHelpers.export(exports, "BiSolidWinkTongue", ()=>BiSolidWinkTongue);
parcelHelpers.export(exports, "BiSolidWinkSmile", ()=>BiSolidWinkSmile);
parcelHelpers.export(exports, "BiSolidWine", ()=>BiSolidWine);
parcelHelpers.export(exports, "BiSolidWindowAlt", ()=>BiSolidWindowAlt);
parcelHelpers.export(exports, "BiSolidWidget", ()=>BiSolidWidget);
parcelHelpers.export(exports, "BiSolidWebcam", ()=>BiSolidWebcam);
parcelHelpers.export(exports, "BiSolidWatch", ()=>BiSolidWatch);
parcelHelpers.export(exports, "BiSolidWatchAlt", ()=>BiSolidWatchAlt);
parcelHelpers.export(exports, "BiSolidWasher", ()=>BiSolidWasher);
parcelHelpers.export(exports, "BiSolidWallet", ()=>BiSolidWallet);
parcelHelpers.export(exports, "BiSolidWalletAlt", ()=>BiSolidWalletAlt);
parcelHelpers.export(exports, "BiSolidVolume", ()=>BiSolidVolume);
parcelHelpers.export(exports, "BiSolidVolumeMute", ()=>BiSolidVolumeMute);
parcelHelpers.export(exports, "BiSolidVolumeLow", ()=>BiSolidVolumeLow);
parcelHelpers.export(exports, "BiSolidVolumeFull", ()=>BiSolidVolumeFull);
parcelHelpers.export(exports, "BiSolidVirus", ()=>BiSolidVirus);
parcelHelpers.export(exports, "BiSolidVirusBlock", ()=>BiSolidVirusBlock);
parcelHelpers.export(exports, "BiSolidVideos", ()=>BiSolidVideos);
parcelHelpers.export(exports, "BiSolidVideo", ()=>BiSolidVideo);
parcelHelpers.export(exports, "BiSolidVideoRecording", ()=>BiSolidVideoRecording);
parcelHelpers.export(exports, "BiSolidVideoPlus", ()=>BiSolidVideoPlus);
parcelHelpers.export(exports, "BiSolidVideoOff", ()=>BiSolidVideoOff);
parcelHelpers.export(exports, "BiSolidVial", ()=>BiSolidVial);
parcelHelpers.export(exports, "BiSolidVector", ()=>BiSolidVector);
parcelHelpers.export(exports, "BiSolidUser", ()=>BiSolidUser);
parcelHelpers.export(exports, "BiSolidUserX", ()=>BiSolidUserX);
parcelHelpers.export(exports, "BiSolidUserVoice", ()=>BiSolidUserVoice);
parcelHelpers.export(exports, "BiSolidUserRectangle", ()=>BiSolidUserRectangle);
parcelHelpers.export(exports, "BiSolidUserPlus", ()=>BiSolidUserPlus);
parcelHelpers.export(exports, "BiSolidUserPin", ()=>BiSolidUserPin);
parcelHelpers.export(exports, "BiSolidUserMinus", ()=>BiSolidUserMinus);
parcelHelpers.export(exports, "BiSolidUserDetail", ()=>BiSolidUserDetail);
parcelHelpers.export(exports, "BiSolidUserCircle", ()=>BiSolidUserCircle);
parcelHelpers.export(exports, "BiSolidUserCheck", ()=>BiSolidUserCheck);
parcelHelpers.export(exports, "BiSolidUserBadge", ()=>BiSolidUserBadge);
parcelHelpers.export(exports, "BiSolidUserAccount", ()=>BiSolidUserAccount);
parcelHelpers.export(exports, "BiSolidUpvote", ()=>BiSolidUpvote);
parcelHelpers.export(exports, "BiSolidUpsideDown", ()=>BiSolidUpsideDown);
parcelHelpers.export(exports, "BiSolidUpArrow", ()=>BiSolidUpArrow);
parcelHelpers.export(exports, "BiSolidUpArrowSquare", ()=>BiSolidUpArrowSquare);
parcelHelpers.export(exports, "BiSolidUpArrowCircle", ()=>BiSolidUpArrowCircle);
parcelHelpers.export(exports, "BiSolidUpArrowAlt", ()=>BiSolidUpArrowAlt);
parcelHelpers.export(exports, "BiSolidUniversalAccess", ()=>BiSolidUniversalAccess);
parcelHelpers.export(exports, "BiSolidTv", ()=>BiSolidTv);
parcelHelpers.export(exports, "BiSolidTruck", ()=>BiSolidTruck);
parcelHelpers.export(exports, "BiSolidTrophy", ()=>BiSolidTrophy);
parcelHelpers.export(exports, "BiSolidTree", ()=>BiSolidTree);
parcelHelpers.export(exports, "BiSolidTreeAlt", ()=>BiSolidTreeAlt);
parcelHelpers.export(exports, "BiSolidTrash", ()=>BiSolidTrash);
parcelHelpers.export(exports, "BiSolidTrashAlt", ()=>BiSolidTrashAlt);
parcelHelpers.export(exports, "BiSolidTrain", ()=>BiSolidTrain);
parcelHelpers.export(exports, "BiSolidTraffic", ()=>BiSolidTraffic);
parcelHelpers.export(exports, "BiSolidTrafficCone", ()=>BiSolidTrafficCone);
parcelHelpers.export(exports, "BiSolidTrafficBarrier", ()=>BiSolidTrafficBarrier);
parcelHelpers.export(exports, "BiSolidTorch", ()=>BiSolidTorch);
parcelHelpers.export(exports, "BiSolidTone", ()=>BiSolidTone);
parcelHelpers.export(exports, "BiSolidToggleRight", ()=>BiSolidToggleRight);
parcelHelpers.export(exports, "BiSolidToggleLeft", ()=>BiSolidToggleLeft);
parcelHelpers.export(exports, "BiSolidToTop", ()=>BiSolidToTop);
parcelHelpers.export(exports, "BiSolidTired", ()=>BiSolidTired);
parcelHelpers.export(exports, "BiSolidTimer", ()=>BiSolidTimer);
parcelHelpers.export(exports, "BiSolidTime", ()=>BiSolidTime);
parcelHelpers.export(exports, "BiSolidTimeFive", ()=>BiSolidTimeFive);
parcelHelpers.export(exports, "BiSolidThermometer", ()=>BiSolidThermometer);
parcelHelpers.export(exports, "BiSolidTerminal", ()=>BiSolidTerminal);
parcelHelpers.export(exports, "BiSolidTennisBall", ()=>BiSolidTennisBall);
parcelHelpers.export(exports, "BiSolidTaxi", ()=>BiSolidTaxi);
parcelHelpers.export(exports, "BiSolidTag", ()=>BiSolidTag);
parcelHelpers.export(exports, "BiSolidTagX", ()=>BiSolidTagX);
parcelHelpers.export(exports, "BiSolidTagAlt", ()=>BiSolidTagAlt);
parcelHelpers.export(exports, "BiSolidTachometer", ()=>BiSolidTachometer);
parcelHelpers.export(exports, "BiSolidTShirt", ()=>BiSolidTShirt);
parcelHelpers.export(exports, "BiSolidSushi", ()=>BiSolidSushi);
parcelHelpers.export(exports, "BiSolidSun", ()=>BiSolidSun);
parcelHelpers.export(exports, "BiSolidStore", ()=>BiSolidStore);
parcelHelpers.export(exports, "BiSolidStoreAlt", ()=>BiSolidStoreAlt);
parcelHelpers.export(exports, "BiSolidStopwatch", ()=>BiSolidStopwatch);
parcelHelpers.export(exports, "BiSolidSticker", ()=>BiSolidSticker);
parcelHelpers.export(exports, "BiSolidStar", ()=>BiSolidStar);
parcelHelpers.export(exports, "BiSolidStarHalf", ()=>BiSolidStarHalf);
parcelHelpers.export(exports, "BiSolidSquare", ()=>BiSolidSquare);
parcelHelpers.export(exports, "BiSolidSquareRounded", ()=>BiSolidSquareRounded);
parcelHelpers.export(exports, "BiSolidSpreadsheet", ()=>BiSolidSpreadsheet);
parcelHelpers.export(exports, "BiSolidSprayCan", ()=>BiSolidSprayCan);
parcelHelpers.export(exports, "BiSolidSpeaker", ()=>BiSolidSpeaker);
parcelHelpers.export(exports, "BiSolidSpa", ()=>BiSolidSpa);
parcelHelpers.export(exports, "BiSolidSortAlt", ()=>BiSolidSortAlt);
parcelHelpers.export(exports, "BiSolidSmile", ()=>BiSolidSmile);
parcelHelpers.export(exports, "BiSolidSlideshow", ()=>BiSolidSlideshow);
parcelHelpers.export(exports, "BiSolidSleepy", ()=>BiSolidSleepy);
parcelHelpers.export(exports, "BiSolidSkull", ()=>BiSolidSkull);
parcelHelpers.export(exports, "BiSolidSkipPreviousCircle", ()=>BiSolidSkipPreviousCircle);
parcelHelpers.export(exports, "BiSolidSkipNextCircle", ()=>BiSolidSkipNextCircle);
parcelHelpers.export(exports, "BiSolidShower", ()=>BiSolidShower);
parcelHelpers.export(exports, "BiSolidShow", ()=>BiSolidShow);
parcelHelpers.export(exports, "BiSolidShoppingBags", ()=>BiSolidShoppingBags);
parcelHelpers.export(exports, "BiSolidShoppingBag", ()=>BiSolidShoppingBag);
parcelHelpers.export(exports, "BiSolidShoppingBagAlt", ()=>BiSolidShoppingBagAlt);
parcelHelpers.export(exports, "BiSolidShocked", ()=>BiSolidShocked);
parcelHelpers.export(exports, "BiSolidShip", ()=>BiSolidShip);
parcelHelpers.export(exports, "BiSolidShield", ()=>BiSolidShield);
parcelHelpers.export(exports, "BiSolidShieldX", ()=>BiSolidShieldX);
parcelHelpers.export(exports, "BiSolidShieldPlus", ()=>BiSolidShieldPlus);
parcelHelpers.export(exports, "BiSolidShieldMinus", ()=>BiSolidShieldMinus);
parcelHelpers.export(exports, "BiSolidShieldAlt2", ()=>BiSolidShieldAlt2);
parcelHelpers.export(exports, "BiSolidShare", ()=>BiSolidShare);
parcelHelpers.export(exports, "BiSolidShareAlt", ()=>BiSolidShareAlt);
parcelHelpers.export(exports, "BiSolidShapes", ()=>BiSolidShapes);
parcelHelpers.export(exports, "BiSolidServer", ()=>BiSolidServer);
parcelHelpers.export(exports, "BiSolidSend", ()=>BiSolidSend);
parcelHelpers.export(exports, "BiSolidSelectMultiple", ()=>BiSolidSelectMultiple);
parcelHelpers.export(exports, "BiSolidSearch", ()=>BiSolidSearch);
parcelHelpers.export(exports, "BiSolidSearchAlt2", ()=>BiSolidSearchAlt2);
parcelHelpers.export(exports, "BiSolidSchool", ()=>BiSolidSchool);
parcelHelpers.export(exports, "BiSolidSave", ()=>BiSolidSave);
parcelHelpers.export(exports, "BiSolidSad", ()=>BiSolidSad);
parcelHelpers.export(exports, "BiSolidRuler", ()=>BiSolidRuler);
parcelHelpers.export(exports, "BiSolidRocket", ()=>BiSolidRocket);
parcelHelpers.export(exports, "BiSolidRightTopArrowCircle", ()=>BiSolidRightTopArrowCircle);
parcelHelpers.export(exports, "BiSolidRightDownArrowCircle", ()=>BiSolidRightDownArrowCircle);
parcelHelpers.export(exports, "BiSolidRightArrow", ()=>BiSolidRightArrow);
parcelHelpers.export(exports, "BiSolidRightArrowSquare", ()=>BiSolidRightArrowSquare);
parcelHelpers.export(exports, "BiSolidRightArrowCircle", ()=>BiSolidRightArrowCircle);
parcelHelpers.export(exports, "BiSolidRightArrowAlt", ()=>BiSolidRightArrowAlt);
parcelHelpers.export(exports, "BiSolidRewindCircle", ()=>BiSolidRewindCircle);
parcelHelpers.export(exports, "BiSolidReport", ()=>BiSolidReport);
parcelHelpers.export(exports, "BiSolidRename", ()=>BiSolidRename);
parcelHelpers.export(exports, "BiSolidRegistered", ()=>BiSolidRegistered);
parcelHelpers.export(exports, "BiSolidRectangle", ()=>BiSolidRectangle);
parcelHelpers.export(exports, "BiSolidReceipt", ()=>BiSolidReceipt);
parcelHelpers.export(exports, "BiSolidRadio", ()=>BiSolidRadio);
parcelHelpers.export(exports, "BiSolidRadiation", ()=>BiSolidRadiation);
parcelHelpers.export(exports, "BiSolidQuoteSingleRight", ()=>BiSolidQuoteSingleRight);
parcelHelpers.export(exports, "BiSolidQuoteSingleLeft", ()=>BiSolidQuoteSingleLeft);
parcelHelpers.export(exports, "BiSolidQuoteRight", ()=>BiSolidQuoteRight);
parcelHelpers.export(exports, "BiSolidQuoteLeft", ()=>BiSolidQuoteLeft);
parcelHelpers.export(exports, "BiSolidQuoteAltRight", ()=>BiSolidQuoteAltRight);
parcelHelpers.export(exports, "BiSolidQuoteAltLeft", ()=>BiSolidQuoteAltLeft);
parcelHelpers.export(exports, "BiSolidPyramid", ()=>BiSolidPyramid);
parcelHelpers.export(exports, "BiSolidPurchaseTag", ()=>BiSolidPurchaseTag);
parcelHelpers.export(exports, "BiSolidPurchaseTagAlt", ()=>BiSolidPurchaseTagAlt);
parcelHelpers.export(exports, "BiSolidPrinter", ()=>BiSolidPrinter);
parcelHelpers.export(exports, "BiSolidPopsicle", ()=>BiSolidPopsicle);
parcelHelpers.export(exports, "BiSolidPolygon", ()=>BiSolidPolygon);
parcelHelpers.export(exports, "BiSolidPointer", ()=>BiSolidPointer);
parcelHelpers.export(exports, "BiSolidPlusSquare", ()=>BiSolidPlusSquare);
parcelHelpers.export(exports, "BiSolidPlusCircle", ()=>BiSolidPlusCircle);
parcelHelpers.export(exports, "BiSolidPlug", ()=>BiSolidPlug);
parcelHelpers.export(exports, "BiSolidPlaylist", ()=>BiSolidPlaylist);
parcelHelpers.export(exports, "BiSolidPlanet", ()=>BiSolidPlanet);
parcelHelpers.export(exports, "BiSolidPlane", ()=>BiSolidPlane);
parcelHelpers.export(exports, "BiSolidPlaneTakeOff", ()=>BiSolidPlaneTakeOff);
parcelHelpers.export(exports, "BiSolidPlaneLand", ()=>BiSolidPlaneLand);
parcelHelpers.export(exports, "BiSolidPlaneAlt", ()=>BiSolidPlaneAlt);
parcelHelpers.export(exports, "BiSolidPizza", ()=>BiSolidPizza);
parcelHelpers.export(exports, "BiSolidPin", ()=>BiSolidPin);
parcelHelpers.export(exports, "BiSolidPieChart", ()=>BiSolidPieChart);
parcelHelpers.export(exports, "BiSolidPieChartAlt", ()=>BiSolidPieChartAlt);
parcelHelpers.export(exports, "BiSolidPieChartAlt2", ()=>BiSolidPieChartAlt2);
parcelHelpers.export(exports, "BiSolidPiano", ()=>BiSolidPiano);
parcelHelpers.export(exports, "BiSolidPhotoAlbum", ()=>BiSolidPhotoAlbum);
parcelHelpers.export(exports, "BiSolidPhone", ()=>BiSolidPhone);
parcelHelpers.export(exports, "BiSolidPhoneOutgoing", ()=>BiSolidPhoneOutgoing);
parcelHelpers.export(exports, "BiSolidPhoneOff", ()=>BiSolidPhoneOff);
parcelHelpers.export(exports, "BiSolidPhoneIncoming", ()=>BiSolidPhoneIncoming);
parcelHelpers.export(exports, "BiSolidPhoneCall", ()=>BiSolidPhoneCall);
parcelHelpers.export(exports, "BiSolidPencil", ()=>BiSolidPencil);
parcelHelpers.export(exports, "BiSolidPen", ()=>BiSolidPen);
parcelHelpers.export(exports, "BiSolidPear", ()=>BiSolidPear);
parcelHelpers.export(exports, "BiSolidPaste", ()=>BiSolidPaste);
parcelHelpers.export(exports, "BiSolidParty", ()=>BiSolidParty);
parcelHelpers.export(exports, "BiSolidParking", ()=>BiSolidParking);
parcelHelpers.export(exports, "BiSolidPaperPlane", ()=>BiSolidPaperPlane);
parcelHelpers.export(exports, "BiSolidPalette", ()=>BiSolidPalette);
parcelHelpers.export(exports, "BiSolidPaint", ()=>BiSolidPaint);
parcelHelpers.export(exports, "BiSolidPaintRoll", ()=>BiSolidPaintRoll);
parcelHelpers.export(exports, "BiSolidPackage", ()=>BiSolidPackage);
parcelHelpers.export(exports, "BiSolidOffer", ()=>BiSolidOffer);
parcelHelpers.export(exports, "BiSolidObjectsVerticalTop", ()=>BiSolidObjectsVerticalTop);
parcelHelpers.export(exports, "BiSolidObjectsVerticalCenter", ()=>BiSolidObjectsVerticalCenter);
parcelHelpers.export(exports, "BiSolidObjectsVerticalBottom", ()=>BiSolidObjectsVerticalBottom);
parcelHelpers.export(exports, "BiSolidObjectsHorizontalRight", ()=>BiSolidObjectsHorizontalRight);
parcelHelpers.export(exports, "BiSolidObjectsHorizontalLeft", ()=>BiSolidObjectsHorizontalLeft);
parcelHelpers.export(exports, "BiSolidObjectsHorizontalCenter", ()=>BiSolidObjectsHorizontalCenter);
parcelHelpers.export(exports, "BiSolidNotification", ()=>BiSolidNotification);
parcelHelpers.export(exports, "BiSolidNotificationOff", ()=>BiSolidNotificationOff);
parcelHelpers.export(exports, "BiSolidNotepad", ()=>BiSolidNotepad);
parcelHelpers.export(exports, "BiSolidNote", ()=>BiSolidNote);
parcelHelpers.export(exports, "BiSolidNoEntry", ()=>BiSolidNoEntry);
parcelHelpers.export(exports, "BiSolidNews", ()=>BiSolidNews);
parcelHelpers.export(exports, "BiSolidNetworkChart", ()=>BiSolidNetworkChart);
parcelHelpers.export(exports, "BiSolidNavigation", ()=>BiSolidNavigation);
parcelHelpers.export(exports, "BiSolidMusic", ()=>BiSolidMusic);
parcelHelpers.export(exports, "BiSolidMovie", ()=>BiSolidMovie);
parcelHelpers.export(exports, "BiSolidMoviePlay", ()=>BiSolidMoviePlay);
parcelHelpers.export(exports, "BiSolidMouse", ()=>BiSolidMouse);
parcelHelpers.export(exports, "BiSolidMouseAlt", ()=>BiSolidMouseAlt);
parcelHelpers.export(exports, "BiSolidMoon", ()=>BiSolidMoon);
parcelHelpers.export(exports, "BiSolidMobile", ()=>BiSolidMobile);
parcelHelpers.export(exports, "BiSolidMobileVibration", ()=>BiSolidMobileVibration);
parcelHelpers.export(exports, "BiSolidMinusSquare", ()=>BiSolidMinusSquare);
parcelHelpers.export(exports, "BiSolidMinusCircle", ()=>BiSolidMinusCircle);
parcelHelpers.export(exports, "BiSolidMicrophone", ()=>BiSolidMicrophone);
parcelHelpers.export(exports, "BiSolidMicrophoneOff", ()=>BiSolidMicrophoneOff);
parcelHelpers.export(exports, "BiSolidMicrophoneAlt", ()=>BiSolidMicrophoneAlt);
parcelHelpers.export(exports, "BiSolidMicrochip", ()=>BiSolidMicrochip);
parcelHelpers.export(exports, "BiSolidMeteor", ()=>BiSolidMeteor);
parcelHelpers.export(exports, "BiSolidMessage", ()=>BiSolidMessage);
parcelHelpers.export(exports, "BiSolidMessageX", ()=>BiSolidMessageX);
parcelHelpers.export(exports, "BiSolidMessageSquare", ()=>BiSolidMessageSquare);
parcelHelpers.export(exports, "BiSolidMessageSquareX", ()=>BiSolidMessageSquareX);
parcelHelpers.export(exports, "BiSolidMessageSquareMinus", ()=>BiSolidMessageSquareMinus);
parcelHelpers.export(exports, "BiSolidMessageSquareError", ()=>BiSolidMessageSquareError);
parcelHelpers.export(exports, "BiSolidMessageSquareEdit", ()=>BiSolidMessageSquareEdit);
parcelHelpers.export(exports, "BiSolidMessageSquareDots", ()=>BiSolidMessageSquareDots);
parcelHelpers.export(exports, "BiSolidMessageSquareDetail", ()=>BiSolidMessageSquareDetail);
parcelHelpers.export(exports, "BiSolidMessageSquareCheck", ()=>BiSolidMessageSquareCheck);
parcelHelpers.export(exports, "BiSolidMessageSquareAdd", ()=>BiSolidMessageSquareAdd);
parcelHelpers.export(exports, "BiSolidMessageRounded", ()=>BiSolidMessageRounded);
parcelHelpers.export(exports, "BiSolidMessageRoundedX", ()=>BiSolidMessageRoundedX);
parcelHelpers.export(exports, "BiSolidMessageRoundedMinus", ()=>BiSolidMessageRoundedMinus);
parcelHelpers.export(exports, "BiSolidMessageRoundedError", ()=>BiSolidMessageRoundedError);
parcelHelpers.export(exports, "BiSolidMessageRoundedEdit", ()=>BiSolidMessageRoundedEdit);
parcelHelpers.export(exports, "BiSolidMessageRoundedDots", ()=>BiSolidMessageRoundedDots);
parcelHelpers.export(exports, "BiSolidMessageRoundedDetail", ()=>BiSolidMessageRoundedDetail);
parcelHelpers.export(exports, "BiSolidMessageRoundedCheck", ()=>BiSolidMessageRoundedCheck);
parcelHelpers.export(exports, "BiSolidMessageRoundedAdd", ()=>BiSolidMessageRoundedAdd);
parcelHelpers.export(exports, "BiSolidMessageMinus", ()=>BiSolidMessageMinus);
parcelHelpers.export(exports, "BiSolidMessageError", ()=>BiSolidMessageError);
parcelHelpers.export(exports, "BiSolidMessageEdit", ()=>BiSolidMessageEdit);
parcelHelpers.export(exports, "BiSolidMessageDots", ()=>BiSolidMessageDots);
parcelHelpers.export(exports, "BiSolidMessageDetail", ()=>BiSolidMessageDetail);
parcelHelpers.export(exports, "BiSolidMessageCheck", ()=>BiSolidMessageCheck);
parcelHelpers.export(exports, "BiSolidMessageAlt", ()=>BiSolidMessageAlt);
parcelHelpers.export(exports, "BiSolidMessageAltX", ()=>BiSolidMessageAltX);
parcelHelpers.export(exports, "BiSolidMessageAltMinus", ()=>BiSolidMessageAltMinus);
parcelHelpers.export(exports, "BiSolidMessageAltError", ()=>BiSolidMessageAltError);
parcelHelpers.export(exports, "BiSolidMessageAltEdit", ()=>BiSolidMessageAltEdit);
parcelHelpers.export(exports, "BiSolidMessageAltDots", ()=>BiSolidMessageAltDots);
parcelHelpers.export(exports, "BiSolidMessageAltDetail", ()=>BiSolidMessageAltDetail);
parcelHelpers.export(exports, "BiSolidMessageAltCheck", ()=>BiSolidMessageAltCheck);
parcelHelpers.export(exports, "BiSolidMessageAltAdd", ()=>BiSolidMessageAltAdd);
parcelHelpers.export(exports, "BiSolidMessageAdd", ()=>BiSolidMessageAdd);
parcelHelpers.export(exports, "BiSolidMemoryCard", ()=>BiSolidMemoryCard);
parcelHelpers.export(exports, "BiSolidMeh", ()=>BiSolidMeh);
parcelHelpers.export(exports, "BiSolidMehBlank", ()=>BiSolidMehBlank);
parcelHelpers.export(exports, "BiSolidMehAlt", ()=>BiSolidMehAlt);
parcelHelpers.export(exports, "BiSolidMegaphone", ()=>BiSolidMegaphone);
parcelHelpers.export(exports, "BiSolidMedal", ()=>BiSolidMedal);
parcelHelpers.export(exports, "BiSolidMask", ()=>BiSolidMask);
parcelHelpers.export(exports, "BiSolidMap", ()=>BiSolidMap);
parcelHelpers.export(exports, "BiSolidMapPin", ()=>BiSolidMapPin);
parcelHelpers.export(exports, "BiSolidMapAlt", ()=>BiSolidMapAlt);
parcelHelpers.export(exports, "BiSolidMagnet", ()=>BiSolidMagnet);
parcelHelpers.export(exports, "BiSolidMagicWand", ()=>BiSolidMagicWand);
parcelHelpers.export(exports, "BiSolidLowVision", ()=>BiSolidLowVision);
parcelHelpers.export(exports, "BiSolidLogOut", ()=>BiSolidLogOut);
parcelHelpers.export(exports, "BiSolidLogOutCircle", ()=>BiSolidLogOutCircle);
parcelHelpers.export(exports, "BiSolidLogIn", ()=>BiSolidLogIn);
parcelHelpers.export(exports, "BiSolidLogInCircle", ()=>BiSolidLogInCircle);
parcelHelpers.export(exports, "BiSolidLock", ()=>BiSolidLock);
parcelHelpers.export(exports, "BiSolidLockOpen", ()=>BiSolidLockOpen);
parcelHelpers.export(exports, "BiSolidLockOpenAlt", ()=>BiSolidLockOpenAlt);
parcelHelpers.export(exports, "BiSolidLockAlt", ()=>BiSolidLockAlt);
parcelHelpers.export(exports, "BiSolidLocationPlus", ()=>BiSolidLocationPlus);
parcelHelpers.export(exports, "BiSolidLike", ()=>BiSolidLike);
parcelHelpers.export(exports, "BiSolidLemon", ()=>BiSolidLemon);
parcelHelpers.export(exports, "BiSolidLeftTopArrowCircle", ()=>BiSolidLeftTopArrowCircle);
parcelHelpers.export(exports, "BiSolidLeftDownArrowCircle", ()=>BiSolidLeftDownArrowCircle);
parcelHelpers.export(exports, "BiSolidLeftArrow", ()=>BiSolidLeftArrow);
parcelHelpers.export(exports, "BiSolidLeftArrowSquare", ()=>BiSolidLeftArrowSquare);
parcelHelpers.export(exports, "BiSolidLeftArrowCircle", ()=>BiSolidLeftArrowCircle);
parcelHelpers.export(exports, "BiSolidLeftArrowAlt", ()=>BiSolidLeftArrowAlt);
parcelHelpers.export(exports, "BiSolidLeaf", ()=>BiSolidLeaf);
parcelHelpers.export(exports, "BiSolidLayout", ()=>BiSolidLayout);
parcelHelpers.export(exports, "BiSolidLayer", ()=>BiSolidLayer);
parcelHelpers.export(exports, "BiSolidLayerPlus", ()=>BiSolidLayerPlus);
parcelHelpers.export(exports, "BiSolidLayerMinus", ()=>BiSolidLayerMinus);
parcelHelpers.export(exports, "BiSolidLaugh", ()=>BiSolidLaugh);
parcelHelpers.export(exports, "BiSolidLandscape", ()=>BiSolidLandscape);
parcelHelpers.export(exports, "BiSolidLandmark", ()=>BiSolidLandmark);
parcelHelpers.export(exports, "BiSolidLabel", ()=>BiSolidLabel);
parcelHelpers.export(exports, "BiSolidKeyboard", ()=>BiSolidKeyboard);
parcelHelpers.export(exports, "BiSolidKey", ()=>BiSolidKey);
parcelHelpers.export(exports, "BiSolidJoystick", ()=>BiSolidJoystick);
parcelHelpers.export(exports, "BiSolidJoystickButton", ()=>BiSolidJoystickButton);
parcelHelpers.export(exports, "BiSolidJoystickAlt", ()=>BiSolidJoystickAlt);
parcelHelpers.export(exports, "BiSolidInvader", ()=>BiSolidInvader);
parcelHelpers.export(exports, "BiSolidInstitution", ()=>BiSolidInstitution);
parcelHelpers.export(exports, "BiSolidInjection", ()=>BiSolidInjection);
parcelHelpers.export(exports, "BiSolidInfoSquare", ()=>BiSolidInfoSquare);
parcelHelpers.export(exports, "BiSolidInfoCircle", ()=>BiSolidInfoCircle);
parcelHelpers.export(exports, "BiSolidInbox", ()=>BiSolidInbox);
parcelHelpers.export(exports, "BiSolidImage", ()=>BiSolidImage);
parcelHelpers.export(exports, "BiSolidImageAlt", ()=>BiSolidImageAlt);
parcelHelpers.export(exports, "BiSolidImageAdd", ()=>BiSolidImageAdd);
parcelHelpers.export(exports, "BiSolidIdCard", ()=>BiSolidIdCard);
parcelHelpers.export(exports, "BiSolidHourglass", ()=>BiSolidHourglass);
parcelHelpers.export(exports, "BiSolidHourglassTop", ()=>BiSolidHourglassTop);
parcelHelpers.export(exports, "BiSolidHourglassBottom", ()=>BiSolidHourglassBottom);
parcelHelpers.export(exports, "BiSolidHotel", ()=>BiSolidHotel);
parcelHelpers.export(exports, "BiSolidHot", ()=>BiSolidHot);
parcelHelpers.export(exports, "BiSolidHome", ()=>BiSolidHome);
parcelHelpers.export(exports, "BiSolidHomeSmile", ()=>BiSolidHomeSmile);
parcelHelpers.export(exports, "BiSolidHomeHeart", ()=>BiSolidHomeHeart);
parcelHelpers.export(exports, "BiSolidHomeCircle", ()=>BiSolidHomeCircle);
parcelHelpers.export(exports, "BiSolidHomeAlt2", ()=>BiSolidHomeAlt2);
parcelHelpers.export(exports, "BiSolidHide", ()=>BiSolidHide);
parcelHelpers.export(exports, "BiSolidHelpCircle", ()=>BiSolidHelpCircle);
parcelHelpers.export(exports, "BiSolidHeart", ()=>BiSolidHeart);
parcelHelpers.export(exports, "BiSolidHeartSquare", ()=>BiSolidHeartSquare);
parcelHelpers.export(exports, "BiSolidHeartCircle", ()=>BiSolidHeartCircle);
parcelHelpers.export(exports, "BiSolidHdd", ()=>BiSolidHdd);
parcelHelpers.export(exports, "BiSolidHardHat", ()=>BiSolidHardHat);
parcelHelpers.export(exports, "BiSolidHappy", ()=>BiSolidHappy);
parcelHelpers.export(exports, "BiSolidHappyHeartEyes", ()=>BiSolidHappyHeartEyes);
parcelHelpers.export(exports, "BiSolidHappyBeaming", ()=>BiSolidHappyBeaming);
parcelHelpers.export(exports, "BiSolidHappyAlt", ()=>BiSolidHappyAlt);
parcelHelpers.export(exports, "BiSolidHand", ()=>BiSolidHand);
parcelHelpers.export(exports, "BiSolidHandUp", ()=>BiSolidHandUp);
parcelHelpers.export(exports, "BiSolidHandRight", ()=>BiSolidHandRight);
parcelHelpers.export(exports, "BiSolidHandLeft", ()=>BiSolidHandLeft);
parcelHelpers.export(exports, "BiSolidHandDown", ()=>BiSolidHandDown);
parcelHelpers.export(exports, "BiSolidGuitarAmp", ()=>BiSolidGuitarAmp);
parcelHelpers.export(exports, "BiSolidGroup", ()=>BiSolidGroup);
parcelHelpers.export(exports, "BiSolidGrid", ()=>BiSolidGrid);
parcelHelpers.export(exports, "BiSolidGridAlt", ()=>BiSolidGridAlt);
parcelHelpers.export(exports, "BiSolidGraduation", ()=>BiSolidGraduation);
parcelHelpers.export(exports, "BiSolidGift", ()=>BiSolidGift);
parcelHelpers.export(exports, "BiSolidGhost", ()=>BiSolidGhost);
parcelHelpers.export(exports, "BiSolidGasPump", ()=>BiSolidGasPump);
parcelHelpers.export(exports, "BiSolidGame", ()=>BiSolidGame);
parcelHelpers.export(exports, "BiSolidFridge", ()=>BiSolidFridge);
parcelHelpers.export(exports, "BiSolidFoodMenu", ()=>BiSolidFoodMenu);
parcelHelpers.export(exports, "BiSolidFolder", ()=>BiSolidFolder);
parcelHelpers.export(exports, "BiSolidFolderPlus", ()=>BiSolidFolderPlus);
parcelHelpers.export(exports, "BiSolidFolderOpen", ()=>BiSolidFolderOpen);
parcelHelpers.export(exports, "BiSolidFolderMinus", ()=>BiSolidFolderMinus);
parcelHelpers.export(exports, "BiSolidFlorist", ()=>BiSolidFlorist);
parcelHelpers.export(exports, "BiSolidFlask", ()=>BiSolidFlask);
parcelHelpers.export(exports, "BiSolidFlame", ()=>BiSolidFlame);
parcelHelpers.export(exports, "BiSolidFlag", ()=>BiSolidFlag);
parcelHelpers.export(exports, "BiSolidFlagCheckered", ()=>BiSolidFlagCheckered);
parcelHelpers.export(exports, "BiSolidFlagAlt", ()=>BiSolidFlagAlt);
parcelHelpers.export(exports, "BiSolidFirstAid", ()=>BiSolidFirstAid);
parcelHelpers.export(exports, "BiSolidFilterAlt", ()=>BiSolidFilterAlt);
parcelHelpers.export(exports, "BiSolidFilm", ()=>BiSolidFilm);
parcelHelpers.export(exports, "BiSolidFile", ()=>BiSolidFile);
parcelHelpers.export(exports, "BiSolidFileTxt", ()=>BiSolidFileTxt);
parcelHelpers.export(exports, "BiSolidFilePng", ()=>BiSolidFilePng);
parcelHelpers.export(exports, "BiSolidFilePlus", ()=>BiSolidFilePlus);
parcelHelpers.export(exports, "BiSolidFilePdf", ()=>BiSolidFilePdf);
parcelHelpers.export(exports, "BiSolidFileMd", ()=>BiSolidFileMd);
parcelHelpers.export(exports, "BiSolidFileJson", ()=>BiSolidFileJson);
parcelHelpers.export(exports, "BiSolidFileJs", ()=>BiSolidFileJs);
parcelHelpers.export(exports, "BiSolidFileJpg", ()=>BiSolidFileJpg);
parcelHelpers.export(exports, "BiSolidFileImport", ()=>BiSolidFileImport);
parcelHelpers.export(exports, "BiSolidFileImage", ()=>BiSolidFileImage);
parcelHelpers.export(exports, "BiSolidFileHtml", ()=>BiSolidFileHtml);
parcelHelpers.export(exports, "BiSolidFileGif", ()=>BiSolidFileGif);
parcelHelpers.export(exports, "BiSolidFileFind", ()=>BiSolidFileFind);
parcelHelpers.export(exports, "BiSolidFileExport", ()=>BiSolidFileExport);
parcelHelpers.export(exports, "BiSolidFileDoc", ()=>BiSolidFileDoc);
parcelHelpers.export(exports, "BiSolidFileCss", ()=>BiSolidFileCss);
parcelHelpers.export(exports, "BiSolidFileBlank", ()=>BiSolidFileBlank);
parcelHelpers.export(exports, "BiSolidFileArchive", ()=>BiSolidFileArchive);
parcelHelpers.export(exports, "BiSolidFastForwardCircle", ()=>BiSolidFastForwardCircle);
parcelHelpers.export(exports, "BiSolidFactory", ()=>BiSolidFactory);
parcelHelpers.export(exports, "BiSolidFace", ()=>BiSolidFace);
parcelHelpers.export(exports, "BiSolidFaceMask", ()=>BiSolidFaceMask);
parcelHelpers.export(exports, "BiSolidEyedropper", ()=>BiSolidEyedropper);
parcelHelpers.export(exports, "BiSolidExtension", ()=>BiSolidExtension);
parcelHelpers.export(exports, "BiSolidExit", ()=>BiSolidExit);
parcelHelpers.export(exports, "BiSolidEvStation", ()=>BiSolidEvStation);
parcelHelpers.export(exports, "BiSolidError", ()=>BiSolidError);
parcelHelpers.export(exports, "BiSolidErrorCircle", ()=>BiSolidErrorCircle);
parcelHelpers.export(exports, "BiSolidErrorAlt", ()=>BiSolidErrorAlt);
parcelHelpers.export(exports, "BiSolidEraser", ()=>BiSolidEraser);
parcelHelpers.export(exports, "BiSolidEnvelope", ()=>BiSolidEnvelope);
parcelHelpers.export(exports, "BiSolidEnvelopeOpen", ()=>BiSolidEnvelopeOpen);
parcelHelpers.export(exports, "BiSolidEject", ()=>BiSolidEject);
parcelHelpers.export(exports, "BiSolidEdit", ()=>BiSolidEdit);
parcelHelpers.export(exports, "BiSolidEditLocation", ()=>BiSolidEditLocation);
parcelHelpers.export(exports, "BiSolidEditAlt", ()=>BiSolidEditAlt);
parcelHelpers.export(exports, "BiSolidDuplicate", ()=>BiSolidDuplicate);
parcelHelpers.export(exports, "BiSolidDryer", ()=>BiSolidDryer);
parcelHelpers.export(exports, "BiSolidDroplet", ()=>BiSolidDroplet);
parcelHelpers.export(exports, "BiSolidDropletHalf", ()=>BiSolidDropletHalf);
parcelHelpers.export(exports, "BiSolidDrink", ()=>BiSolidDrink);
parcelHelpers.export(exports, "BiSolidDownvote", ()=>BiSolidDownvote);
parcelHelpers.export(exports, "BiSolidDownload", ()=>BiSolidDownload);
parcelHelpers.export(exports, "BiSolidDownArrow", ()=>BiSolidDownArrow);
parcelHelpers.export(exports, "BiSolidDownArrowSquare", ()=>BiSolidDownArrowSquare);
parcelHelpers.export(exports, "BiSolidDownArrowCircle", ()=>BiSolidDownArrowCircle);
parcelHelpers.export(exports, "BiSolidDownArrowAlt", ()=>BiSolidDownArrowAlt);
parcelHelpers.export(exports, "BiSolidDoughnutChart", ()=>BiSolidDoughnutChart);
parcelHelpers.export(exports, "BiSolidDoorOpen", ()=>BiSolidDoorOpen);
parcelHelpers.export(exports, "BiSolidDonateHeart", ()=>BiSolidDonateHeart);
parcelHelpers.export(exports, "BiSolidDonateBlood", ()=>BiSolidDonateBlood);
parcelHelpers.export(exports, "BiSolidDollarCircle", ()=>BiSolidDollarCircle);
parcelHelpers.export(exports, "BiSolidDog", ()=>BiSolidDog);
parcelHelpers.export(exports, "BiSolidDockTop", ()=>BiSolidDockTop);
parcelHelpers.export(exports, "BiSolidDockRight", ()=>BiSolidDockRight);
parcelHelpers.export(exports, "BiSolidDockLeft", ()=>BiSolidDockLeft);
parcelHelpers.export(exports, "BiSolidDockBottom", ()=>BiSolidDockBottom);
parcelHelpers.export(exports, "BiSolidDizzy", ()=>BiSolidDizzy);
parcelHelpers.export(exports, "BiSolidDislike", ()=>BiSolidDislike);
parcelHelpers.export(exports, "BiSolidDish", ()=>BiSolidDish);
parcelHelpers.export(exports, "BiSolidDiscount", ()=>BiSolidDiscount);
parcelHelpers.export(exports, "BiSolidDisc", ()=>BiSolidDisc);
parcelHelpers.export(exports, "BiSolidDirections", ()=>BiSolidDirections);
parcelHelpers.export(exports, "BiSolidDirectionRight", ()=>BiSolidDirectionRight);
parcelHelpers.export(exports, "BiSolidDirectionLeft", ()=>BiSolidDirectionLeft);
parcelHelpers.export(exports, "BiSolidDice6", ()=>BiSolidDice6);
parcelHelpers.export(exports, "BiSolidDice5", ()=>BiSolidDice5);
parcelHelpers.export(exports, "BiSolidDice4", ()=>BiSolidDice4);
parcelHelpers.export(exports, "BiSolidDice3", ()=>BiSolidDice3);
parcelHelpers.export(exports, "BiSolidDice2", ()=>BiSolidDice2);
parcelHelpers.export(exports, "BiSolidDice1", ()=>BiSolidDice1);
parcelHelpers.export(exports, "BiSolidDiamond", ()=>BiSolidDiamond);
parcelHelpers.export(exports, "BiSolidDevices", ()=>BiSolidDevices);
parcelHelpers.export(exports, "BiSolidDetail", ()=>BiSolidDetail);
parcelHelpers.export(exports, "BiSolidData", ()=>BiSolidData);
parcelHelpers.export(exports, "BiSolidDashboard", ()=>BiSolidDashboard);
parcelHelpers.export(exports, "BiSolidCylinder", ()=>BiSolidCylinder);
parcelHelpers.export(exports, "BiSolidCustomize", ()=>BiSolidCustomize);
parcelHelpers.export(exports, "BiSolidCuboid", ()=>BiSolidCuboid);
parcelHelpers.export(exports, "BiSolidCube", ()=>BiSolidCube);
parcelHelpers.export(exports, "BiSolidCubeAlt", ()=>BiSolidCubeAlt);
parcelHelpers.export(exports, "BiSolidCrown", ()=>BiSolidCrown);
parcelHelpers.export(exports, "BiSolidCrop", ()=>BiSolidCrop);
parcelHelpers.export(exports, "BiSolidCricketBall", ()=>BiSolidCricketBall);
parcelHelpers.export(exports, "BiSolidCreditCard", ()=>BiSolidCreditCard);
parcelHelpers.export(exports, "BiSolidCreditCardFront", ()=>BiSolidCreditCardFront);
parcelHelpers.export(exports, "BiSolidCreditCardAlt", ()=>BiSolidCreditCardAlt);
parcelHelpers.export(exports, "BiSolidCoupon", ()=>BiSolidCoupon);
parcelHelpers.export(exports, "BiSolidCopyright", ()=>BiSolidCopyright);
parcelHelpers.export(exports, "BiSolidCopy", ()=>BiSolidCopy);
parcelHelpers.export(exports, "BiSolidCopyAlt", ()=>BiSolidCopyAlt);
parcelHelpers.export(exports, "BiSolidCool", ()=>BiSolidCool);
parcelHelpers.export(exports, "BiSolidCookie", ()=>BiSolidCookie);
parcelHelpers.export(exports, "BiSolidConversation", ()=>BiSolidConversation);
parcelHelpers.export(exports, "BiSolidContact", ()=>BiSolidContact);
parcelHelpers.export(exports, "BiSolidConfused", ()=>BiSolidConfused);
parcelHelpers.export(exports, "BiSolidComponent", ()=>BiSolidComponent);
parcelHelpers.export(exports, "BiSolidCompass", ()=>BiSolidCompass);
parcelHelpers.export(exports, "BiSolidComment", ()=>BiSolidComment);
parcelHelpers.export(exports, "BiSolidCommentX", ()=>BiSolidCommentX);
parcelHelpers.export(exports, "BiSolidCommentMinus", ()=>BiSolidCommentMinus);
parcelHelpers.export(exports, "BiSolidCommentError", ()=>BiSolidCommentError);
parcelHelpers.export(exports, "BiSolidCommentEdit", ()=>BiSolidCommentEdit);
parcelHelpers.export(exports, "BiSolidCommentDots", ()=>BiSolidCommentDots);
parcelHelpers.export(exports, "BiSolidCommentDetail", ()=>BiSolidCommentDetail);
parcelHelpers.export(exports, "BiSolidCommentCheck", ()=>BiSolidCommentCheck);
parcelHelpers.export(exports, "BiSolidCommentAdd", ()=>BiSolidCommentAdd);
parcelHelpers.export(exports, "BiSolidColor", ()=>BiSolidColor);
parcelHelpers.export(exports, "BiSolidColorFill", ()=>BiSolidColorFill);
parcelHelpers.export(exports, "BiSolidCollection", ()=>BiSolidCollection);
parcelHelpers.export(exports, "BiSolidCoin", ()=>BiSolidCoin);
parcelHelpers.export(exports, "BiSolidCoinStack", ()=>BiSolidCoinStack);
parcelHelpers.export(exports, "BiSolidCog", ()=>BiSolidCog);
parcelHelpers.export(exports, "BiSolidCoffee", ()=>BiSolidCoffee);
parcelHelpers.export(exports, "BiSolidCoffeeTogo", ()=>BiSolidCoffeeTogo);
parcelHelpers.export(exports, "BiSolidCoffeeBean", ()=>BiSolidCoffeeBean);
parcelHelpers.export(exports, "BiSolidCoffeeAlt", ()=>BiSolidCoffeeAlt);
parcelHelpers.export(exports, "BiSolidCloud", ()=>BiSolidCloud);
parcelHelpers.export(exports, "BiSolidCloudUpload", ()=>BiSolidCloudUpload);
parcelHelpers.export(exports, "BiSolidCloudRain", ()=>BiSolidCloudRain);
parcelHelpers.export(exports, "BiSolidCloudLightning", ()=>BiSolidCloudLightning);
parcelHelpers.export(exports, "BiSolidCloudDownload", ()=>BiSolidCloudDownload);
parcelHelpers.export(exports, "BiSolidClinic", ()=>BiSolidClinic);
parcelHelpers.export(exports, "BiSolidCity", ()=>BiSolidCity);
parcelHelpers.export(exports, "BiSolidCircle", ()=>BiSolidCircle);
parcelHelpers.export(exports, "BiSolidCircleThreeQuarter", ()=>BiSolidCircleThreeQuarter);
parcelHelpers.export(exports, "BiSolidCircleQuarter", ()=>BiSolidCircleQuarter);
parcelHelpers.export(exports, "BiSolidCircleHalf", ()=>BiSolidCircleHalf);
parcelHelpers.export(exports, "BiSolidChurch", ()=>BiSolidChurch);
parcelHelpers.export(exports, "BiSolidChip", ()=>BiSolidChip);
parcelHelpers.export(exports, "BiSolidChevronsUp", ()=>BiSolidChevronsUp);
parcelHelpers.export(exports, "BiSolidChevronsRight", ()=>BiSolidChevronsRight);
parcelHelpers.export(exports, "BiSolidChevronsLeft", ()=>BiSolidChevronsLeft);
parcelHelpers.export(exports, "BiSolidChevronsDown", ()=>BiSolidChevronsDown);
parcelHelpers.export(exports, "BiSolidChevronUp", ()=>BiSolidChevronUp);
parcelHelpers.export(exports, "BiSolidChevronUpSquare", ()=>BiSolidChevronUpSquare);
parcelHelpers.export(exports, "BiSolidChevronUpCircle", ()=>BiSolidChevronUpCircle);
parcelHelpers.export(exports, "BiSolidChevronRight", ()=>BiSolidChevronRight);
parcelHelpers.export(exports, "BiSolidChevronRightSquare", ()=>BiSolidChevronRightSquare);
parcelHelpers.export(exports, "BiSolidChevronRightCircle", ()=>BiSolidChevronRightCircle);
parcelHelpers.export(exports, "BiSolidChevronLeft", ()=>BiSolidChevronLeft);
parcelHelpers.export(exports, "BiSolidChevronLeftSquare", ()=>BiSolidChevronLeftSquare);
parcelHelpers.export(exports, "BiSolidChevronLeftCircle", ()=>BiSolidChevronLeftCircle);
parcelHelpers.export(exports, "BiSolidChevronDown", ()=>BiSolidChevronDown);
parcelHelpers.export(exports, "BiSolidChevronDownSquare", ()=>BiSolidChevronDownSquare);
parcelHelpers.export(exports, "BiSolidChevronDownCircle", ()=>BiSolidChevronDownCircle);
parcelHelpers.export(exports, "BiSolidChess", ()=>BiSolidChess);
parcelHelpers.export(exports, "BiSolidCheese", ()=>BiSolidCheese);
parcelHelpers.export(exports, "BiSolidCheckbox", ()=>BiSolidCheckbox);
parcelHelpers.export(exports, "BiSolidCheckboxMinus", ()=>BiSolidCheckboxMinus);
parcelHelpers.export(exports, "BiSolidCheckboxChecked", ()=>BiSolidCheckboxChecked);
parcelHelpers.export(exports, "BiSolidCheckSquare", ()=>BiSolidCheckSquare);
parcelHelpers.export(exports, "BiSolidCheckShield", ()=>BiSolidCheckShield);
parcelHelpers.export(exports, "BiSolidCheckCircle", ()=>BiSolidCheckCircle);
parcelHelpers.export(exports, "BiSolidChat", ()=>BiSolidChat);
parcelHelpers.export(exports, "BiSolidChart", ()=>BiSolidChart);
parcelHelpers.export(exports, "BiSolidChalkboard", ()=>BiSolidChalkboard);
parcelHelpers.export(exports, "BiSolidCertification", ()=>BiSolidCertification);
parcelHelpers.export(exports, "BiSolidCctv", ()=>BiSolidCctv);
parcelHelpers.export(exports, "BiSolidCategory", ()=>BiSolidCategory);
parcelHelpers.export(exports, "BiSolidCategoryAlt", ()=>BiSolidCategoryAlt);
parcelHelpers.export(exports, "BiSolidCat", ()=>BiSolidCat);
parcelHelpers.export(exports, "BiSolidCastle", ()=>BiSolidCastle);
parcelHelpers.export(exports, "BiSolidCart", ()=>BiSolidCart);
parcelHelpers.export(exports, "BiSolidCartDownload", ()=>BiSolidCartDownload);
parcelHelpers.export(exports, "BiSolidCartAlt", ()=>BiSolidCartAlt);
parcelHelpers.export(exports, "BiSolidCartAdd", ()=>BiSolidCartAdd);
parcelHelpers.export(exports, "BiSolidCarousel", ()=>BiSolidCarousel);
parcelHelpers.export(exports, "BiSolidCaretUpSquare", ()=>BiSolidCaretUpSquare);
parcelHelpers.export(exports, "BiSolidCaretUpCircle", ()=>BiSolidCaretUpCircle);
parcelHelpers.export(exports, "BiSolidCaretRightSquare", ()=>BiSolidCaretRightSquare);
parcelHelpers.export(exports, "BiSolidCaretRightCircle", ()=>BiSolidCaretRightCircle);
parcelHelpers.export(exports, "BiSolidCaretLeftSquare", ()=>BiSolidCaretLeftSquare);
parcelHelpers.export(exports, "BiSolidCaretLeftCircle", ()=>BiSolidCaretLeftCircle);
parcelHelpers.export(exports, "BiSolidCaretDownSquare", ()=>BiSolidCaretDownSquare);
parcelHelpers.export(exports, "BiSolidCaretDownCircle", ()=>BiSolidCaretDownCircle);
parcelHelpers.export(exports, "BiSolidCard", ()=>BiSolidCard);
parcelHelpers.export(exports, "BiSolidCar", ()=>BiSolidCar);
parcelHelpers.export(exports, "BiSolidCarWash", ()=>BiSolidCarWash);
parcelHelpers.export(exports, "BiSolidCarMechanic", ()=>BiSolidCarMechanic);
parcelHelpers.export(exports, "BiSolidCarGarage", ()=>BiSolidCarGarage);
parcelHelpers.export(exports, "BiSolidCarCrash", ()=>BiSolidCarCrash);
parcelHelpers.export(exports, "BiSolidCarBattery", ()=>BiSolidCarBattery);
parcelHelpers.export(exports, "BiSolidCaptions", ()=>BiSolidCaptions);
parcelHelpers.export(exports, "BiSolidCapsule", ()=>BiSolidCapsule);
parcelHelpers.export(exports, "BiSolidCamera", ()=>BiSolidCamera);
parcelHelpers.export(exports, "BiSolidCameraPlus", ()=>BiSolidCameraPlus);
parcelHelpers.export(exports, "BiSolidCameraOff", ()=>BiSolidCameraOff);
parcelHelpers.export(exports, "BiSolidCameraMovie", ()=>BiSolidCameraMovie);
parcelHelpers.export(exports, "BiSolidCameraHome", ()=>BiSolidCameraHome);
parcelHelpers.export(exports, "BiSolidCalendar", ()=>BiSolidCalendar);
parcelHelpers.export(exports, "BiSolidCalendarX", ()=>BiSolidCalendarX);
parcelHelpers.export(exports, "BiSolidCalendarWeek", ()=>BiSolidCalendarWeek);
parcelHelpers.export(exports, "BiSolidCalendarStar", ()=>BiSolidCalendarStar);
parcelHelpers.export(exports, "BiSolidCalendarPlus", ()=>BiSolidCalendarPlus);
parcelHelpers.export(exports, "BiSolidCalendarMinus", ()=>BiSolidCalendarMinus);
parcelHelpers.export(exports, "BiSolidCalendarHeart", ()=>BiSolidCalendarHeart);
parcelHelpers.export(exports, "BiSolidCalendarExclamation", ()=>BiSolidCalendarExclamation);
parcelHelpers.export(exports, "BiSolidCalendarEvent", ()=>BiSolidCalendarEvent);
parcelHelpers.export(exports, "BiSolidCalendarEdit", ()=>BiSolidCalendarEdit);
parcelHelpers.export(exports, "BiSolidCalendarCheck", ()=>BiSolidCalendarCheck);
parcelHelpers.export(exports, "BiSolidCalendarAlt", ()=>BiSolidCalendarAlt);
parcelHelpers.export(exports, "BiSolidCalculator", ()=>BiSolidCalculator);
parcelHelpers.export(exports, "BiSolidCake", ()=>BiSolidCake);
parcelHelpers.export(exports, "BiSolidCableCar", ()=>BiSolidCableCar);
parcelHelpers.export(exports, "BiSolidCabinet", ()=>BiSolidCabinet);
parcelHelpers.export(exports, "BiSolidBusiness", ()=>BiSolidBusiness);
parcelHelpers.export(exports, "BiSolidBus", ()=>BiSolidBus);
parcelHelpers.export(exports, "BiSolidBusSchool", ()=>BiSolidBusSchool);
parcelHelpers.export(exports, "BiSolidBuoy", ()=>BiSolidBuoy);
parcelHelpers.export(exports, "BiSolidBullseye", ()=>BiSolidBullseye);
parcelHelpers.export(exports, "BiSolidBulb", ()=>BiSolidBulb);
parcelHelpers.export(exports, "BiSolidBuildings", ()=>BiSolidBuildings);
parcelHelpers.export(exports, "BiSolidBuilding", ()=>BiSolidBuilding);
parcelHelpers.export(exports, "BiSolidBuildingHouse", ()=>BiSolidBuildingHouse);
parcelHelpers.export(exports, "BiSolidBug", ()=>BiSolidBug);
parcelHelpers.export(exports, "BiSolidBugAlt", ()=>BiSolidBugAlt);
parcelHelpers.export(exports, "BiSolidBrush", ()=>BiSolidBrush);
parcelHelpers.export(exports, "BiSolidBrushAlt", ()=>BiSolidBrushAlt);
parcelHelpers.export(exports, "BiSolidBrightness", ()=>BiSolidBrightness);
parcelHelpers.export(exports, "BiSolidBrightnessHalf", ()=>BiSolidBrightnessHalf);
parcelHelpers.export(exports, "BiSolidBriefcase", ()=>BiSolidBriefcase);
parcelHelpers.export(exports, "BiSolidBriefcaseAlt", ()=>BiSolidBriefcaseAlt);
parcelHelpers.export(exports, "BiSolidBriefcaseAlt2", ()=>BiSolidBriefcaseAlt2);
parcelHelpers.export(exports, "BiSolidBrain", ()=>BiSolidBrain);
parcelHelpers.export(exports, "BiSolidBox", ()=>BiSolidBox);
parcelHelpers.export(exports, "BiSolidBowlingBall", ()=>BiSolidBowlingBall);
parcelHelpers.export(exports, "BiSolidBowlRice", ()=>BiSolidBowlRice);
parcelHelpers.export(exports, "BiSolidBowlHot", ()=>BiSolidBowlHot);
parcelHelpers.export(exports, "BiSolidBot", ()=>BiSolidBot);
parcelHelpers.export(exports, "BiSolidBookmarks", ()=>BiSolidBookmarks);
parcelHelpers.export(exports, "BiSolidBookmark", ()=>BiSolidBookmark);
parcelHelpers.export(exports, "BiSolidBookmarkStar", ()=>BiSolidBookmarkStar);
parcelHelpers.export(exports, "BiSolidBookmarkPlus", ()=>BiSolidBookmarkPlus);
parcelHelpers.export(exports, "BiSolidBookmarkMinus", ()=>BiSolidBookmarkMinus);
parcelHelpers.export(exports, "BiSolidBookmarkHeart", ()=>BiSolidBookmarkHeart);
parcelHelpers.export(exports, "BiSolidBookmarkAlt", ()=>BiSolidBookmarkAlt);
parcelHelpers.export(exports, "BiSolidBookmarkAltPlus", ()=>BiSolidBookmarkAltPlus);
parcelHelpers.export(exports, "BiSolidBookmarkAltMinus", ()=>BiSolidBookmarkAltMinus);
parcelHelpers.export(exports, "BiSolidBook", ()=>BiSolidBook);
parcelHelpers.export(exports, "BiSolidBookReader", ()=>BiSolidBookReader);
parcelHelpers.export(exports, "BiSolidBookOpen", ()=>BiSolidBookOpen);
parcelHelpers.export(exports, "BiSolidBookHeart", ()=>BiSolidBookHeart);
parcelHelpers.export(exports, "BiSolidBookContent", ()=>BiSolidBookContent);
parcelHelpers.export(exports, "BiSolidBookBookmark", ()=>BiSolidBookBookmark);
parcelHelpers.export(exports, "BiSolidBookAlt", ()=>BiSolidBookAlt);
parcelHelpers.export(exports, "BiSolidBookAdd", ()=>BiSolidBookAdd);
parcelHelpers.export(exports, "BiSolidBong", ()=>BiSolidBong);
parcelHelpers.export(exports, "BiSolidBone", ()=>BiSolidBone);
parcelHelpers.export(exports, "BiSolidBomb", ()=>BiSolidBomb);
parcelHelpers.export(exports, "BiSolidBolt", ()=>BiSolidBolt);
parcelHelpers.export(exports, "BiSolidBoltCircle", ()=>BiSolidBoltCircle);
parcelHelpers.export(exports, "BiSolidBlanket", ()=>BiSolidBlanket);
parcelHelpers.export(exports, "BiSolidBinoculars", ()=>BiSolidBinoculars);
parcelHelpers.export(exports, "BiSolidBible", ()=>BiSolidBible);
parcelHelpers.export(exports, "BiSolidBell", ()=>BiSolidBell);
parcelHelpers.export(exports, "BiSolidBellRing", ()=>BiSolidBellRing);
parcelHelpers.export(exports, "BiSolidBellPlus", ()=>BiSolidBellPlus);
parcelHelpers.export(exports, "BiSolidBellOff", ()=>BiSolidBellOff);
parcelHelpers.export(exports, "BiSolidBellMinus", ()=>BiSolidBellMinus);
parcelHelpers.export(exports, "BiSolidBeer", ()=>BiSolidBeer);
parcelHelpers.export(exports, "BiSolidBeenHere", ()=>BiSolidBeenHere);
parcelHelpers.export(exports, "BiSolidBed", ()=>BiSolidBed);
parcelHelpers.export(exports, "BiSolidBattery", ()=>BiSolidBattery);
parcelHelpers.export(exports, "BiSolidBatteryLow", ()=>BiSolidBatteryLow);
parcelHelpers.export(exports, "BiSolidBatteryFull", ()=>BiSolidBatteryFull);
parcelHelpers.export(exports, "BiSolidBatteryCharging", ()=>BiSolidBatteryCharging);
parcelHelpers.export(exports, "BiSolidBath", ()=>BiSolidBath);
parcelHelpers.export(exports, "BiSolidBasketball", ()=>BiSolidBasketball);
parcelHelpers.export(exports, "BiSolidBasket", ()=>BiSolidBasket);
parcelHelpers.export(exports, "BiSolidBaseball", ()=>BiSolidBaseball);
parcelHelpers.export(exports, "BiSolidBarcode", ()=>BiSolidBarcode);
parcelHelpers.export(exports, "BiSolidBarChartSquare", ()=>BiSolidBarChartSquare);
parcelHelpers.export(exports, "BiSolidBarChartAlt2", ()=>BiSolidBarChartAlt2);
parcelHelpers.export(exports, "BiSolidBank", ()=>BiSolidBank);
parcelHelpers.export(exports, "BiSolidBandAid", ()=>BiSolidBandAid);
parcelHelpers.export(exports, "BiSolidBalloon", ()=>BiSolidBalloon);
parcelHelpers.export(exports, "BiSolidBall", ()=>BiSolidBall);
parcelHelpers.export(exports, "BiSolidBaguette", ()=>BiSolidBaguette);
parcelHelpers.export(exports, "BiSolidBadge", ()=>BiSolidBadge);
parcelHelpers.export(exports, "BiSolidBadgeDollar", ()=>BiSolidBadgeDollar);
parcelHelpers.export(exports, "BiSolidBadgeCheck", ()=>BiSolidBadgeCheck);
parcelHelpers.export(exports, "BiSolidBackpack", ()=>BiSolidBackpack);
parcelHelpers.export(exports, "BiSolidBabyCarriage", ()=>BiSolidBabyCarriage);
parcelHelpers.export(exports, "BiSolidAward", ()=>BiSolidAward);
parcelHelpers.export(exports, "BiSolidArrowToTop", ()=>BiSolidArrowToTop);
parcelHelpers.export(exports, "BiSolidArrowToRight", ()=>BiSolidArrowToRight);
parcelHelpers.export(exports, "BiSolidArrowToLeft", ()=>BiSolidArrowToLeft);
parcelHelpers.export(exports, "BiSolidArrowToBottom", ()=>BiSolidArrowToBottom);
parcelHelpers.export(exports, "BiSolidArrowFromTop", ()=>BiSolidArrowFromTop);
parcelHelpers.export(exports, "BiSolidArrowFromRight", ()=>BiSolidArrowFromRight);
parcelHelpers.export(exports, "BiSolidArrowFromLeft", ()=>BiSolidArrowFromLeft);
parcelHelpers.export(exports, "BiSolidArrowFromBottom", ()=>BiSolidArrowFromBottom);
parcelHelpers.export(exports, "BiSolidArea", ()=>BiSolidArea);
parcelHelpers.export(exports, "BiSolidArchive", ()=>BiSolidArchive);
parcelHelpers.export(exports, "BiSolidArchiveOut", ()=>BiSolidArchiveOut);
parcelHelpers.export(exports, "BiSolidArchiveIn", ()=>BiSolidArchiveIn);
parcelHelpers.export(exports, "BiSolidArch", ()=>BiSolidArch);
parcelHelpers.export(exports, "BiSolidAngry", ()=>BiSolidAngry);
parcelHelpers.export(exports, "BiSolidAnalyse", ()=>BiSolidAnalyse);
parcelHelpers.export(exports, "BiSolidAmbulance", ()=>BiSolidAmbulance);
parcelHelpers.export(exports, "BiSolidAlbum", ()=>BiSolidAlbum);
parcelHelpers.export(exports, "BiSolidAlarm", ()=>BiSolidAlarm);
parcelHelpers.export(exports, "BiSolidAlarmSnooze", ()=>BiSolidAlarmSnooze);
parcelHelpers.export(exports, "BiSolidAlarmOff", ()=>BiSolidAlarmOff);
parcelHelpers.export(exports, "BiSolidAlarmExclamation", ()=>BiSolidAlarmExclamation);
parcelHelpers.export(exports, "BiSolidAlarmAdd", ()=>BiSolidAlarmAdd);
parcelHelpers.export(exports, "BiSolidAdjust", ()=>BiSolidAdjust);
parcelHelpers.export(exports, "BiSolidAdjustAlt", ()=>BiSolidAdjustAlt);
parcelHelpers.export(exports, "BiSolidAddToQueue", ()=>BiSolidAddToQueue);
parcelHelpers.export(exports, "BiLogoZoom", ()=>BiLogoZoom);
parcelHelpers.export(exports, "BiLogoYoutube", ()=>BiLogoYoutube);
parcelHelpers.export(exports, "BiLogoYelp", ()=>BiLogoYelp);
parcelHelpers.export(exports, "BiLogoYahoo", ()=>BiLogoYahoo);
parcelHelpers.export(exports, "BiLogoXing", ()=>BiLogoXing);
parcelHelpers.export(exports, "BiLogoWordpress", ()=>BiLogoWordpress);
parcelHelpers.export(exports, "BiLogoWix", ()=>BiLogoWix);
parcelHelpers.export(exports, "BiLogoWindows", ()=>BiLogoWindows);
parcelHelpers.export(exports, "BiLogoWikipedia", ()=>BiLogoWikipedia);
parcelHelpers.export(exports, "BiLogoWhatsapp", ()=>BiLogoWhatsapp);
parcelHelpers.export(exports, "BiLogoWhatsappSquare", ()=>BiLogoWhatsappSquare);
parcelHelpers.export(exports, "BiLogoVuejs", ()=>BiLogoVuejs);
parcelHelpers.export(exports, "BiLogoVk", ()=>BiLogoVk);
parcelHelpers.export(exports, "BiLogoVisualStudio", ()=>BiLogoVisualStudio);
parcelHelpers.export(exports, "BiLogoVisa", ()=>BiLogoVisa);
parcelHelpers.export(exports, "BiLogoVimeo", ()=>BiLogoVimeo);
parcelHelpers.export(exports, "BiLogoVenmo", ()=>BiLogoVenmo);
parcelHelpers.export(exports, "BiLogoUpwork", ()=>BiLogoUpwork);
parcelHelpers.export(exports, "BiLogoUnsplash", ()=>BiLogoUnsplash);
parcelHelpers.export(exports, "BiLogoUnity", ()=>BiLogoUnity);
parcelHelpers.export(exports, "BiLogoTypescript", ()=>BiLogoTypescript);
parcelHelpers.export(exports, "BiLogoTwitter", ()=>BiLogoTwitter);
parcelHelpers.export(exports, "BiLogoTwitch", ()=>BiLogoTwitch);
parcelHelpers.export(exports, "BiLogoTux", ()=>BiLogoTux);
parcelHelpers.export(exports, "BiLogoTumblr", ()=>BiLogoTumblr);
parcelHelpers.export(exports, "BiLogoTripAdvisor", ()=>BiLogoTripAdvisor);
parcelHelpers.export(exports, "BiLogoTrello", ()=>BiLogoTrello);
parcelHelpers.export(exports, "BiLogoTiktok", ()=>BiLogoTiktok);
parcelHelpers.export(exports, "BiLogoTelegram", ()=>BiLogoTelegram);
parcelHelpers.export(exports, "BiLogoTailwindCss", ()=>BiLogoTailwindCss);
parcelHelpers.export(exports, "BiLogoStripe", ()=>BiLogoStripe);
parcelHelpers.export(exports, "BiLogoSteam", ()=>BiLogoSteam);
parcelHelpers.export(exports, "BiLogoStackOverflow", ()=>BiLogoStackOverflow);
parcelHelpers.export(exports, "BiLogoSquarespace", ()=>BiLogoSquarespace);
parcelHelpers.export(exports, "BiLogoSpringBoot", ()=>BiLogoSpringBoot);
parcelHelpers.export(exports, "BiLogoSpotify", ()=>BiLogoSpotify);
parcelHelpers.export(exports, "BiLogoSoundcloud", ()=>BiLogoSoundcloud);
parcelHelpers.export(exports, "BiLogoSnapchat", ()=>BiLogoSnapchat);
parcelHelpers.export(exports, "BiLogoSlack", ()=>BiLogoSlack);
parcelHelpers.export(exports, "BiLogoSlackOld", ()=>BiLogoSlackOld);
parcelHelpers.export(exports, "BiLogoSkype", ()=>BiLogoSkype);
parcelHelpers.export(exports, "BiLogoSketch", ()=>BiLogoSketch);
parcelHelpers.export(exports, "BiLogoShopify", ()=>BiLogoShopify);
parcelHelpers.export(exports, "BiLogoSass", ()=>BiLogoSass);
parcelHelpers.export(exports, "BiLogoRedux", ()=>BiLogoRedux);
parcelHelpers.export(exports, "BiLogoReddit", ()=>BiLogoReddit);
parcelHelpers.export(exports, "BiLogoRedbubble", ()=>BiLogoRedbubble);
parcelHelpers.export(exports, "BiLogoReact", ()=>BiLogoReact);
parcelHelpers.export(exports, "BiLogoQuora", ()=>BiLogoQuora);
parcelHelpers.export(exports, "BiLogoPython", ()=>BiLogoPython);
parcelHelpers.export(exports, "BiLogoProductHunt", ()=>BiLogoProductHunt);
parcelHelpers.export(exports, "BiLogoPostgresql", ()=>BiLogoPostgresql);
parcelHelpers.export(exports, "BiLogoPocket", ()=>BiLogoPocket);
parcelHelpers.export(exports, "BiLogoPlayStore", ()=>BiLogoPlayStore);
parcelHelpers.export(exports, "BiLogoPinterest", ()=>BiLogoPinterest);
parcelHelpers.export(exports, "BiLogoPinterestAlt", ()=>BiLogoPinterestAlt);
parcelHelpers.export(exports, "BiLogoPhp", ()=>BiLogoPhp);
parcelHelpers.export(exports, "BiLogoPeriscope", ()=>BiLogoPeriscope);
parcelHelpers.export(exports, "BiLogoPaypal", ()=>BiLogoPaypal);
parcelHelpers.export(exports, "BiLogoPatreon", ()=>BiLogoPatreon);
parcelHelpers.export(exports, "BiLogoOpera", ()=>BiLogoOpera);
parcelHelpers.export(exports, "BiLogoOkRu", ()=>BiLogoOkRu);
parcelHelpers.export(exports, "BiLogoNodejs", ()=>BiLogoNodejs);
parcelHelpers.export(exports, "BiLogoNetlify", ()=>BiLogoNetlify);
parcelHelpers.export(exports, "BiLogoMongodb", ()=>BiLogoMongodb);
parcelHelpers.export(exports, "BiLogoMicrosoft", ()=>BiLogoMicrosoft);
parcelHelpers.export(exports, "BiLogoMicrosoftTeams", ()=>BiLogoMicrosoftTeams);
parcelHelpers.export(exports, "BiLogoMeta", ()=>BiLogoMeta);
parcelHelpers.export(exports, "BiLogoMessenger", ()=>BiLogoMessenger);
parcelHelpers.export(exports, "BiLogoMedium", ()=>BiLogoMedium);
parcelHelpers.export(exports, "BiLogoMediumSquare", ()=>BiLogoMediumSquare);
parcelHelpers.export(exports, "BiLogoMediumOld", ()=>BiLogoMediumOld);
parcelHelpers.export(exports, "BiLogoMastodon", ()=>BiLogoMastodon);
parcelHelpers.export(exports, "BiLogoMastercard", ()=>BiLogoMastercard);
parcelHelpers.export(exports, "BiLogoMarkdown", ()=>BiLogoMarkdown);
parcelHelpers.export(exports, "BiLogoMailchimp", ()=>BiLogoMailchimp);
parcelHelpers.export(exports, "BiLogoMagento", ()=>BiLogoMagento);
parcelHelpers.export(exports, "BiLogoLinkedin", ()=>BiLogoLinkedin);
parcelHelpers.export(exports, "BiLogoLinkedinSquare", ()=>BiLogoLinkedinSquare);
parcelHelpers.export(exports, "BiLogoLess", ()=>BiLogoLess);
parcelHelpers.export(exports, "BiLogoKubernetes", ()=>BiLogoKubernetes);
parcelHelpers.export(exports, "BiLogoKickstarter", ()=>BiLogoKickstarter);
parcelHelpers.export(exports, "BiLogoJsfiddle", ()=>BiLogoJsfiddle);
parcelHelpers.export(exports, "BiLogoJquery", ()=>BiLogoJquery);
parcelHelpers.export(exports, "BiLogoJoomla", ()=>BiLogoJoomla);
parcelHelpers.export(exports, "BiLogoJavascript", ()=>BiLogoJavascript);
parcelHelpers.export(exports, "BiLogoJava", ()=>BiLogoJava);
parcelHelpers.export(exports, "BiLogoInvision", ()=>BiLogoInvision);
parcelHelpers.export(exports, "BiLogoInternetExplorer", ()=>BiLogoInternetExplorer);
parcelHelpers.export(exports, "BiLogoInstagram", ()=>BiLogoInstagram);
parcelHelpers.export(exports, "BiLogoInstagramAlt", ()=>BiLogoInstagramAlt);
parcelHelpers.export(exports, "BiLogoImdb", ()=>BiLogoImdb);
parcelHelpers.export(exports, "BiLogoHtml5", ()=>BiLogoHtml5);
parcelHelpers.export(exports, "BiLogoHeroku", ()=>BiLogoHeroku);
parcelHelpers.export(exports, "BiLogoGraphql", ()=>BiLogoGraphql);
parcelHelpers.export(exports, "BiLogoGoogle", ()=>BiLogoGoogle);
parcelHelpers.export(exports, "BiLogoGooglePlus", ()=>BiLogoGooglePlus);
parcelHelpers.export(exports, "BiLogoGooglePlusCircle", ()=>BiLogoGooglePlusCircle);
parcelHelpers.export(exports, "BiLogoGoogleCloud", ()=>BiLogoGoogleCloud);
parcelHelpers.export(exports, "BiLogoGoLang", ()=>BiLogoGoLang);
parcelHelpers.export(exports, "BiLogoGmail", ()=>BiLogoGmail);
parcelHelpers.export(exports, "BiLogoGitlab", ()=>BiLogoGitlab);
parcelHelpers.export(exports, "BiLogoGithub", ()=>BiLogoGithub);
parcelHelpers.export(exports, "BiLogoGit", ()=>BiLogoGit);
parcelHelpers.export(exports, "BiLogoFoursquare", ()=>BiLogoFoursquare);
parcelHelpers.export(exports, "BiLogoFlutter", ()=>BiLogoFlutter);
parcelHelpers.export(exports, "BiLogoFlickr", ()=>BiLogoFlickr);
parcelHelpers.export(exports, "BiLogoFlickrSquare", ()=>BiLogoFlickrSquare);
parcelHelpers.export(exports, "BiLogoFlask", ()=>BiLogoFlask);
parcelHelpers.export(exports, "BiLogoFirefox", ()=>BiLogoFirefox);
parcelHelpers.export(exports, "BiLogoFirebase", ()=>BiLogoFirebase);
parcelHelpers.export(exports, "BiLogoFigma", ()=>BiLogoFigma);
parcelHelpers.export(exports, "BiLogoFacebook", ()=>BiLogoFacebook);
parcelHelpers.export(exports, "BiLogoFacebookSquare", ()=>BiLogoFacebookSquare);
parcelHelpers.export(exports, "BiLogoFacebookCircle", ()=>BiLogoFacebookCircle);
parcelHelpers.export(exports, "BiLogoEtsy", ()=>BiLogoEtsy);
parcelHelpers.export(exports, "BiLogoEdge", ()=>BiLogoEdge);
parcelHelpers.export(exports, "BiLogoEbay", ()=>BiLogoEbay);
parcelHelpers.export(exports, "BiLogoDrupal", ()=>BiLogoDrupal);
parcelHelpers.export(exports, "BiLogoDropbox", ()=>BiLogoDropbox);
parcelHelpers.export(exports, "BiLogoDribbble", ()=>BiLogoDribbble);
parcelHelpers.export(exports, "BiLogoDocker", ()=>BiLogoDocker);
parcelHelpers.export(exports, "BiLogoDjango", ()=>BiLogoDjango);
parcelHelpers.export(exports, "BiLogoDiscourse", ()=>BiLogoDiscourse);
parcelHelpers.export(exports, "BiLogoDiscord", ()=>BiLogoDiscord);
parcelHelpers.export(exports, "BiLogoDiscordAlt", ()=>BiLogoDiscordAlt);
parcelHelpers.export(exports, "BiLogoDigitalocean", ()=>BiLogoDigitalocean);
parcelHelpers.export(exports, "BiLogoDigg", ()=>BiLogoDigg);
parcelHelpers.export(exports, "BiLogoDeviantart", ()=>BiLogoDeviantart);
parcelHelpers.export(exports, "BiLogoDevTo", ()=>BiLogoDevTo);
parcelHelpers.export(exports, "BiLogoDeezer", ()=>BiLogoDeezer);
parcelHelpers.export(exports, "BiLogoDailymotion", ()=>BiLogoDailymotion);
parcelHelpers.export(exports, "BiLogoCss3", ()=>BiLogoCss3);
parcelHelpers.export(exports, "BiLogoCreativeCommons", ()=>BiLogoCreativeCommons);
parcelHelpers.export(exports, "BiLogoCodepen", ()=>BiLogoCodepen);
parcelHelpers.export(exports, "BiLogoChrome", ()=>BiLogoChrome);
parcelHelpers.export(exports, "BiLogoCPlusPlus", ()=>BiLogoCPlusPlus);
parcelHelpers.export(exports, "BiLogoBootstrap", ()=>BiLogoBootstrap);
parcelHelpers.export(exports, "BiLogoBlogger", ()=>BiLogoBlogger);
parcelHelpers.export(exports, "BiLogoBlender", ()=>BiLogoBlender);
parcelHelpers.export(exports, "BiLogoBitcoin", ()=>BiLogoBitcoin);
parcelHelpers.export(exports, "BiLogoBing", ()=>BiLogoBing);
parcelHelpers.export(exports, "BiLogoBehance", ()=>BiLogoBehance);
parcelHelpers.export(exports, "BiLogoBaidu", ()=>BiLogoBaidu);
parcelHelpers.export(exports, "BiLogoAws", ()=>BiLogoAws);
parcelHelpers.export(exports, "BiLogoAudible", ()=>BiLogoAudible);
parcelHelpers.export(exports, "BiLogoApple", ()=>BiLogoApple);
parcelHelpers.export(exports, "BiLogoAngular", ()=>BiLogoAngular);
parcelHelpers.export(exports, "BiLogoAndroid", ()=>BiLogoAndroid);
parcelHelpers.export(exports, "BiLogoAmazon", ()=>BiLogoAmazon);
parcelHelpers.export(exports, "BiLogoAlgolia", ()=>BiLogoAlgolia);
parcelHelpers.export(exports, "BiLogoAirbnb", ()=>BiLogoAirbnb);
parcelHelpers.export(exports, "BiLogoAdobe", ()=>BiLogoAdobe);
parcelHelpers.export(exports, "BiLogo99Designs", ()=>BiLogo99Designs);
parcelHelpers.export(exports, "BiLogo500Px", ()=>BiLogo500Px);
var _indexMjs = require("../lib/index.mjs");
function BiZoomOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9h8v2H6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiZoomIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6H9v3H6v2h3v3h2v-3h3V9h-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiYen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 3.4 12 10.333 6.8 3.4 5.2 4.6 10 11H7v2h4v2H7v2h4v4h2v-4h4v-2h-4v-2h4v-2h-3l4.8-6.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiXCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.172 16.242 12 13.414l2.828 2.828 1.414-1.414L13.414 12l2.828-2.828-1.414-1.414L12 10.586 9.172 7.758 7.758 9.172 10.586 12l-2.828 2.828z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWrench(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.122 21c.378.378.88.586 1.414.586S7.572 21.378 7.95 21l4.336-4.336a7.495 7.495 0 0 0 2.217.333 7.446 7.446 0 0 0 5.302-2.195 7.484 7.484 0 0 0 1.632-8.158l-.57-1.388-4.244 4.243-2.121-2.122 4.243-4.243-1.389-.571A7.478 7.478 0 0 0 14.499 2c-2.003 0-3.886.78-5.301 2.196a7.479 7.479 0 0 0-1.862 7.518L3 16.05a2.001 2.001 0 0 0 0 2.828L5.122 21zm4.548-8.791-.254-.616a5.486 5.486 0 0 1 1.196-5.983 5.46 5.46 0 0 1 4.413-1.585l-3.353 3.353 4.949 4.95 3.355-3.355a5.49 5.49 0 0 1-1.587 4.416c-1.55 1.55-3.964 2.027-5.984 1.196l-.615-.255-5.254 5.256h.001l-.001 1v-1l-2.122-2.122 5.256-5.255z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWorld(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM4 12c0-.899.156-1.762.431-2.569L6 11l2 2v2l2 2 1 1v1.931C7.061 19.436 4 16.072 4 12zm14.33 4.873C17.677 16.347 16.687 16 16 16v-1a2 2 0 0 0-2-2h-4v-3a2 2 0 0 0 2-2V7h1a2 2 0 0 0 2-2v-.411C17.928 5.778 20 8.65 20 12a7.947 7.947 0 0 1-1.67 4.873z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.758 5H19.68l-.844 3h-4.893l-.899-3h-2.088l-.899 3H5.164L4.32 5H2.242l.844 3H2v2h1.648l.563 2H2v2h2.773l1.688 6h2.083l1.8-6h3.313l1.8 6h2.083l1.688-6H22v-2h-2.211l.563-2H22V8h-1.086l.844-3zM5.727 10h3.729l-.6 2H6.289l-.562-2zm1.804 6.417L6.852 14h1.404l-.725 2.417zM10.944 12l.6-2h.912l.6 2h-2.112zm5.525 4.417L15.744 14h1.404l-.679 2.417zM17.711 12h-2.567l-.6-2h3.729l-.562 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWinkTongue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 9c-2 0-2.5 2-2.5 2h5s-.501-2-2.5-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-2 16v-3h4v3c0 1.103-.897 2-2 2s-2-.897-2-2zm5.856 1.005c.085-.323.144-.656.144-1.005v-1.499C17.589 15.028 18 13 18 13H6s.412 2.028 2 3.501V18c0 .349.059.682.144 1.005A8.005 8.005 0 0 1 4 12c0-4.411 3.589-8 8-8s8 3.589 8 8a8.005 8.005 0 0 1-4.144 7.005z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWinkSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.828 14.828a3.988 3.988 0 0 1-2.02 1.09 4.108 4.108 0 0 1-1.616 0 4.103 4.103 0 0 1-.749-.232 4.161 4.161 0 0 1-.679-.368 4.115 4.115 0 0 1-1.082-1.082l-1.658 1.117c.215.319.462.619.733.889a5.991 5.991 0 0 0 8.485.002c.272-.271.52-.571.734-.891l-1.658-1.117c-.143.211-.307.41-.49.592z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 10c-2 0-2.5 2-2.5 2h5s-.501-2-2.5-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.713 12.123c.264-.952.312-2.03.143-3.206l-.866-6.059A1 1 0 0 0 18 2H6a1 1 0 0 0-.99.858l-.865 6.058c-.169 1.177-.121 2.255.142 3.206.864 3.134 3.551 5.392 6.713 5.794V20H9v2h6v-2h-2v-2.084c3.162-.402 5.849-2.66 6.713-5.793zM17.133 4l.57 4H6.296l.571-4h10.266zM6.215 11.59c-.132-.474-.181-1.009-.159-1.59h11.889c.021.581-.028 1.116-.159 1.591A6.021 6.021 0 0 1 12 16a6.019 6.019 0 0 1-5.785-4.41z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWindows(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM4 19v-8h12V9l.002 10H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2h13.001c1.101 0 1.996.895 1.999 1.994L20.002 15H20v2c1.103 0 2-.897 2-2V8.007L22.001 8V6L22 5.99V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWindow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm0-2V7h16l.001 12H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWindowOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h5v-2H4V7h16v12h-5v2h5c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21v-5h3l-4-5-4 5h3v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWindowClose(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V7h16l.001 12H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.707 10.707-1.414-1.414L12 11.586 9.707 9.293l-1.414 1.414L10.586 13l-2.293 2.293 1.414 1.414L12 14.414l2.293 2.293 1.414-1.414L13.414 13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWindowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 2 .001 4H4V5h16zM4 19v-8h16.001l.001 8H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6h2v2h-2zm3 0h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.5C13 3.57 11.43 2 9.5 2 7.466 2 6.25 3.525 6.25 5h2c0-.415.388-1 1.25-1 .827 0 1.5.673 1.5 1.5S10.327 7 9.5 7H2v2h7.5C11.43 9 13 7.43 13 5.5zm2.5 9.5H8v2h7.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5c-.862 0-1.25-.585-1.25-1h-2c0 1.475 1.216 3 3.25 3 1.93 0 3.5-1.57 3.5-3.5S17.43 15 15.5 15z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5c-2.206 0-4 1.794-4 4h2c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2H2v2h16c2.206 0 4-1.794 4-4s-1.794-4-4-4zM2 15h4v2H2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWifi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c3.537 0 6.837 1.353 9.293 3.809l1.414-1.414C19.874 5.561 16.071 4 12 4c-4.071.001-7.874 1.561-10.707 4.395l1.414 1.414C5.163 7.353 8.463 6 12 6zm5.671 8.307c-3.074-3.074-8.268-3.074-11.342 0l1.414 1.414c2.307-2.307 6.207-2.307 8.514 0l1.414-1.414z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.437 11.293c-4.572-4.574-12.301-4.574-16.873 0l1.414 1.414c3.807-3.807 10.238-3.807 14.045 0l1.414-1.414z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWifiOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m1.293 8.395 1.414 1.414c.504-.504 1.052-.95 1.622-1.359L2.9 7.021c-.56.422-1.104.87-1.607 1.374zM6.474 5.06 3.707 2.293 2.293 3.707l18 18 1.414-1.414-5.012-5.012.976-.975a7.86 7.86 0 0 0-4.099-2.148L11.294 9.88c2.789-.191 5.649.748 7.729 2.827l1.414-1.414c-2.898-2.899-7.061-3.936-10.888-3.158L8.024 6.61A13.366 13.366 0 0 1 12 6c3.537 0 6.837 1.353 9.293 3.809l1.414-1.414C19.874 5.561 16.071 4 12 4a15.198 15.198 0 0 0-5.526 1.06zm-2.911 6.233 1.414 1.414a9.563 9.563 0 0 1 2.058-1.551L5.576 9.697c-.717.451-1.395.979-2.013 1.596zm2.766 3.014 1.414 1.414c.692-.692 1.535-1.151 2.429-1.428l-1.557-1.557a7.76 7.76 0 0 0-2.286 1.571zm7.66 3.803-2.1-2.1a1.996 1.996 0 1 0 2.1 2.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWifi2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.671 14.307C16.184 12.819 14.17 12 12 12s-4.184.819-5.671 2.307l1.414 1.414c1.11-1.11 2.621-1.722 4.257-1.722 1.636.001 3.147.612 4.257 1.722l1.414-1.414z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.437 11.292c-4.572-4.573-12.301-4.573-16.873 0l1.414 1.414c3.807-3.807 10.238-3.807 14.045 0l1.414-1.414z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWifi1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.671 14.307C16.184 12.819 14.17 12 12 12s-4.184.819-5.671 2.307l1.414 1.414c1.11-1.11 2.621-1.722 4.257-1.722 1.636.001 3.147.612 4.257 1.722l1.414-1.414z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWifi0(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWebcam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.963 0-9 4.038-9 9 0 3.328 1.82 6.232 4.513 7.79l-2.067 1.378A1 1 0 0 0 6 22h12a1 1 0 0 0 .555-1.832l-2.067-1.378C19.18 17.232 21 14.328 21 11c0-4.962-4.037-9-9-9zm0 16c-3.859 0-7-3.141-7-7 0-3.86 3.141-7 7-7s7 3.14 7 7c0 3.859-3.141 7-7 7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.996 9c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707C11.83 8.253 12.577 9 13.991 9c1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 8.253 20.585 9 22 9V7c-.563 0-.804-.217-1.295-.707C20.159 5.747 19.411 5 17.996 5s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 5.747 11.407 5 9.993 5s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 5.747 3.413 5 2 5v2c.561 0 .801.217 1.291.707C3.836 8.253 4.583 9 5.996 9zm0 5c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707c.545.546 1.292 1.293 2.706 1.293 1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 13.253 20.585 14 22 14v-2c-.563 0-.804-.217-1.295-.707-.546-.546-1.294-1.293-2.709-1.293s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 10.747 11.407 10 9.993 10s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 10.747 3.413 10 2 10v2c.561 0 .801.217 1.291.707C3.836 13.253 4.583 14 5.996 14zm0 5c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707c.545.546 1.292 1.293 2.706 1.293 1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 18.253 20.585 19 22 19v-2c-.563 0-.804-.217-1.295-.707-.546-.546-1.294-1.293-2.709-1.293s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 15.747 11.407 15 9.993 15s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 15.747 3.413 15 2 15v2c.561 0 .801.217 1.291.707C3.836 18.253 4.583 19 5.996 19z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h2v4h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM5 5h13v2H5a1.001 1.001 0 0 1 0-2zm15 14H5.012C4.55 18.988 4 18.805 4 18V8.815c.314.113.647.185 1 .185h15v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWalletAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h15c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h15v3h-6c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h6.001v3H5zm15-9v4h-6v-4h6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiWalk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.978 12.27c.245.368.611.647 1.031.787l2.675.892.633-1.896-2.675-.892-1.663-2.495a2.016 2.016 0 0 0-.769-.679l-1.434-.717a1.989 1.989 0 0 0-1.378-.149l-3.193.797a2.002 2.002 0 0 0-1.306 1.046l-1.794 3.589 1.789.895 1.794-3.589 2.223-.556-1.804 8.346-3.674 2.527 1.133 1.648 3.675-2.528c.421-.29.713-.725.82-1.225l.517-2.388 2.517 1.888.925 4.625 1.961-.393-.925-4.627a2 2 0 0 0-.762-1.206l-2.171-1.628.647-3.885 1.208 1.813z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVolume(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20V4a1 1 0 0 0-1.554-.832L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h3c.033 0 .061-.016.093-.019a1.027 1.027 0 0 0 .379-.116c.026-.014.057-.017.082-.033L12 5.868v12.264l-4.445-2.964c-.025-.018-.056-.02-.082-.033a.977.977 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVolumeMute(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 20.293-2.023-2.023A9.566 9.566 0 0 0 21.999 12c0-4.091-2.472-7.453-5.999-9v2c2.387 1.386 3.999 4.047 3.999 7a8.113 8.113 0 0 1-1.672 4.913l-1.285-1.285C17.644 14.536 18 13.19 18 12c0-1.771-.775-3.9-2-5v7.586l-2-2V4a1 1 0 0 0-1.554-.832L7.727 6.313l-4.02-4.02-1.414 1.414 18 18 1.414-1.414zM12 5.868v4.718L9.169 7.755 12 5.868zM4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20v-1.879l-2-2v2.011l-4.445-2.964c-.025-.017-.056-.02-.082-.033a.986.986 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9h.879L3.102 7.223A1.995 1.995 0 0 0 2 9v6c0 1.103.897 2 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVolumeLow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20V4a1 1 0 0 0-1.554-.832L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h3c.033 0 .061-.016.093-.019a1.027 1.027 0 0 0 .379-.116c.026-.014.057-.017.082-.033L12 5.868v12.264l-4.445-2.964c-.025-.018-.056-.02-.082-.033a.977.977 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9zm12-2v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVolumeFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21c3.527-1.547 5.999-4.909 5.999-9S19.527 4.547 16 3v2c2.387 1.386 3.999 4.047 3.999 7S18.387 17.614 16 19v2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5zM4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20V4a1 1 0 0 0-1.554-.832L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h3c.033 0 .061-.016.093-.019a1.027 1.027 0 0 0 .38-.116c.026-.015.057-.017.082-.033L12 5.868v12.264l-4.445-2.964c-.025-.017-.056-.02-.082-.033a.986.986 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVoicemail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 8a4.505 4.505 0 0 0-4.5 4.5c0 .925.281 1.784.762 2.5h-3.523c.48-.716.761-1.575.761-2.5C11 10.019 8.981 8 6.5 8S2 10.019 2 12.5 4.019 17 6.5 17c.171 0 .334-.032.5-.051V17h11v-.051c2.244-.252 4-2.139 4-4.449 0-2.481-2.019-4.5-4.5-4.5zM4 12.5C4 11.121 5.121 10 6.5 10S9 11.121 9 12.5 7.879 15 6.5 15 4 13.879 4 12.5zM17.5 15c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7zm-1.998 10H4V7h12l.001 4.999L16 12l.001.001.001 4.999z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVideoRecording(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9c0-1.103-.897-2-2-2h-1.434l-2.418-4.029A2.008 2.008 0 0 0 10.434 2H5v2h5.434l1.8 3H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3l4 2v-7l-4 2V9zm-1.998 9H4V9h12l.001 4H16v1l.001.001.001 3.999z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h6v2H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVideoPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8H9v3H6v2h3v3h2v-3h3v-2h-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7zm-1.999 10H4V7h12v5l.001 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVideoOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H6.414L3.707 2.293 2.293 3.707l18 18 1.414-1.414L18 16.586v-2.919L22 17V7l-4 3.333V7zm-2 7.586L8.414 7H16v7.586zM4 19h10.879l-2-2H4V8.121L2.145 6.265A1.977 1.977 0 0 0 2 7v10c0 1.103.897 2 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVial(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.95 3.564.708.707-9.193 9.193C2.521 14.408 2 15.664 2 17s.521 2.592 1.465 3.535C4.408 21.479 5.664 22 7 22s2.592-.521 3.535-1.465l9.193-9.193.707.708 1.414-1.414-8.485-8.486-1.414 1.414zM9.121 19.121c-1.133 1.133-3.109 1.133-4.242 0C4.313 18.555 4 17.802 4 17s.313-1.555.879-2.121L5.758 14h8.484l-5.121 5.121zM16.242 12H7.758l6.314-6.314 4.242 4.242L16.242 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVerticalTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 7-4 4h3v8h2v-8h3l-4-4zM3 3h3v2H3zM8 3h3v2H8zM13 3h3v2h-3zM18 3h3v2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVerticalCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5V2h-2v3H8l4 4 4-4zm0 17v-3h3l-4-4-4 4h3v3zM3 11h3v2H3zm5 0h3v2H8zm5 0h3v2h-3zm5 0h3v2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVerticalBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19h3v2h-3zM13 19h3v2h-3zM8 19h3v2H8zM3 19h3v2H3zM13 5h-2v8H8l4 4 4-4h-3V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiVector(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.277 8c.347.596.985 1 1.723 1a2 2 0 0 0 0-4c-.738 0-1.376.404-1.723 1H16V4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H5.723C5.376 5.404 4.738 5 4 5a2 2 0 0 0 0 4c.738 0 1.376-.404 1.723-1H8v.369C5.133 9.84 4.318 12.534 4.091 14H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.877c.197-.959.718-2.406 2.085-3.418A.984.984 0 0 0 9 11h6a.98.98 0 0 0 .792-.419c1.373 1.013 1.895 2.458 2.089 3.419H17a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.092c-.227-1.466-1.042-4.161-3.908-5.632V8h2.277zM6 18H4v-2h2v2zm14 0h-2v-2h2v2zm-6-9h-4V5h4v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm9 11v-1a7 7 0 0 0-7-7h-4a7 7 0 0 0-7 7v1h2v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUserX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.71 15.71 2.29-2.3 2.29 2.3 1.42-1.42-2.3-2.29 2.3-2.29-1.42-1.42-2.29 2.3-2.29-2.3-1.42 1.42L16.58 12l-2.29 2.29zM12 8a3.91 3.91 0 0 0-4-4 3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4zM6 8a1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2 1.91 1.91 0 0 1-2 2 1.91 1.91 0 0 1-2-2zM4 18a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUserVoice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12c2.28 0 4-1.72 4-4s-1.72-4-4-4-4 1.72-4 4 1.72 4 4 4zm0-6c1.178 0 2 .822 2 2s-.822 2-2 2-2-.822-2-2 .822-2 2-2zm1 7H7c-2.757 0-5 2.243-5 5v1h2v-1c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v1h2v-1c0-2.757-2.243-5-5-5zm9.364-10.364L16.95 4.05C18.271 5.373 19 7.131 19 9s-.729 3.627-2.05 4.95l1.414 1.414C20.064 13.663 21 11.403 21 9s-.936-4.663-2.636-6.364z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 5.464 14.121 6.88C14.688 7.445 15 8.198 15 9s-.312 1.555-.879 2.12l1.414 1.416C16.479 11.592 17 10.337 17 9s-.521-2.592-1.465-3.536z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUserPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 8a3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4 3.91 3.91 0 0 0-4 4zm6 0a1.91 1.91 0 0 1-2 2 1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2zM4 18a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUserPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c1.151 0 2-.848 2-2s-.849-2-2-2c-1.15 0-2 .848-2 2s.85 2 2 2zm0 1c-2.209 0-4 1.612-4 3.6v.386h8V14.6c0-1.988-1.791-3.6-4-3.6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h4l3 3 3-3h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-5 15-2 2-2-2H5V4h14l.002 13H14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUserMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11h8v2h-8zM8 4a3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4zm0 6a1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2 1.91 1.91 0 0 1-2 2zm-4 8a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2A10.13 10.13 0 0 0 2 12a10 10 0 0 0 4 7.92V20h.1a9.7 9.7 0 0 0 11.8 0h.1v-.08A10 10 0 0 0 22 12 10.13 10.13 0 0 0 12 2zM8.07 18.93A3 3 0 0 1 11 16.57h2a3 3 0 0 1 2.93 2.36 7.75 7.75 0 0 1-7.86 0zm9.54-1.29A5 5 0 0 0 13 14.57h-2a5 5 0 0 0-4.61 3.07A8 8 0 0 1 4 12a8.1 8.1 0 0 1 8-8 8.1 8.1 0 0 1 8 8 8 8 0 0 1-2.39 5.64z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4zm0 6a1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2 1.91 1.91 0 0 1-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUserCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.29 8.29 16 12.58l-1.3-1.29-1.41 1.42 2.7 2.7 5.72-5.7zM4 8a3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4 3.91 3.91 0 0 0-4 4zm6 0a1.91 1.91 0 0 1-2 2 1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2zM4 18a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUsb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h1v2h-4V6h2l-3-4-3 4h2v8H7v-2.277c.596-.347 1-.985 1-1.723a2 2 0 0 0-4 0c0 .738.404 1.376 1 1.723V14c0 1.103.897 2 2 2h4v2.277A1.99 1.99 0 0 0 10 20a2 2 0 0 0 4 0c0-.738-.404-1.376-1-1.723V14h4c1.103 0 2-.897 2-2v-2h1V6h-4v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUpvote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.781 2.375c-.381-.475-1.181-.475-1.562 0l-8 10A1.001 1.001 0 0 0 4 14h4v7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7h4a1.001 1.001 0 0 0 .781-1.625l-8-10zM15 12h-1v8h-4v-8H6.081L12 4.601 17.919 12H15z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUpsideDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.829 9.172c.181.181.346.38.488.592l1.658-1.119a6.063 6.063 0 0 0-1.621-1.62 5.963 5.963 0 0 0-2.148-.903 5.985 5.985 0 0 0-5.448 1.634 5.993 5.993 0 0 0-.733.889l1.657 1.119a4.017 4.017 0 0 1 2.51-1.683 3.989 3.989 0 0 1 3.637 1.091z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "13.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.507",
                    "cy": "13.507",
                    "r": "1.493"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2V9h3l-4-5-4 5h3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUpArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19zm9-12.243L19.092 17H4.908L12 6.757z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUpArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 1.993C6.486 1.994 2 6.48 2 11.994c.001 5.514 4.487 10 10 10 5.515 0 10.001-4.486 10.001-10s-4.486-10-10-10.001zM12 19.994c-4.41 0-7.999-3.589-8-8 0-4.411 3.589-8 8.001-8.001 4.411.001 8 3.59 8 8.001s-3.589 8-8.001 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.001 8.001-4.005 4.005h3.005V16h2v-3.994h3.004z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUpArrowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.414V18h2V8.414l4.293 4.293 1.414-1.414L12 4.586l-6.707 6.707 1.414 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUnlink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.949 14.121 19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0l-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121a2.723 2.723 0 0 1-.844.57L13.414 12l1.414-1.414-.707-.707a4.965 4.965 0 0 0-3.535-1.465c-.235 0-.464.032-.691.066L3.707 2.293 2.293 3.707l18 18 1.414-1.414-5.536-5.536c.277-.184.538-.396.778-.636zm-6.363 3.536a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l1.476-1.475-1.414-1.414L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUniversalAccess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 10.5 16 9l-3 1h-2L8 9l-.5 1.5 3 1V13L9 17.25l1.5.75 1.25-3.5h.5L13.5 18l1.5-.75L13.5 13v-1.5l3-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUnite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h1V8a2 2 0 0 1 2-2h8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2zm3 3a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1v8a2 2 0 0 1-2 2H8v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUndo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6c1.654 0 3 1.346 3 3s-1.346 3-3 3h-3v2h3c2.757 0 5-2.243 5-5s-2.243-5-5-5H9V5L4 9l5 4v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiUnderline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18h14v2H5zM6 4v6c0 3.309 2.691 6 6 6s6-2.691 6-6V4h-2v6c0 2.206-1.794 4-4 4s-4-1.794-4-4V4H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-5.586l2.293-2.293-1.414-1.414L12 5.586 8.707 2.293 7.293 3.707 9.586 6H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM4 19V8h16l.002 11H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTrophy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v3c0 4.31 1.799 6.91 4.819 7.012A6.001 6.001 0 0 0 11 17.91V20H9v2h6v-2h-2v-2.09a6.01 6.01 0 0 0 4.181-2.898C20.201 14.91 22 12.31 22 8V5a1 1 0 0 0-1-1zM4 8V6h2v6.83C4.216 12.078 4 9.299 4 8zm8 8c-2.206 0-4-1.794-4-4V4h8v8c0 2.206-1.794 4-4 4zm6-3.17V6h2v2c0 1.299-.216 4.078-2 4.83z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTrip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.844 20H6.5C5.121 20 4 18.879 4 17.5S5.121 15 6.5 15h7c1.93 0 3.5-1.57 3.5-3.5S15.43 8 13.5 8H8.639a9.812 9.812 0 0 1-1.354 2H13.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-7C4.019 13 2 15.019 2 17.5S4.019 22 6.5 22h9.593a10.415 10.415 0 0 1-1.249-2zM5 2C3.346 2 2 3.346 2 5c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5 6.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14c-1.654 0-3 1.346-3 3 0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 19 18.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTrim(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2zm14-6-.003 9H10v-3h4c1.103 0 2-.897 2-2v-4h3zM5 10h5V5h4l-.003 9H5v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTrendingUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 10.414 4 4 5.707-5.707L22 11V5h-6l2.293 2.293L14 11.586l-4-4-7.707 7.707 1.414 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTrendingDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14 9.586-4 4-6.293-6.293-1.414 1.414L10 16.414l4-4 4.293 4.293L16 19h6v-6l-2.293 2.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h2v8H9zm4 0h2v8h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTrashAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H9c-1.103 0-2 .897-2 2v2H3v2h2v12c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V8h2V6h-4V4c0-1.103-.897-2-2-2zM9 4h6v2H9V4zm8 16H7V8h10v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTransfer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 12 5-4-5-4v2.999H2v2h13zm7 3H9v-3l-5 4 5 4v-3h13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTransferAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.924 10.383a1 1 0 0 0-.217-1.09l-5-5-1.414 1.414L16.586 9H4v2h15a1 1 0 0 0 .924-.617zM4.076 13.617a1 1 0 0 0 .217 1.09l5 5 1.414-1.414L7.414 15H20v-2H5a.999.999 0 0 0-.924.617z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTrain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.87 3.34A3.55 3.55 0 0 0 16.38 2H7.62a3.47 3.47 0 0 0-2.5 1.35A4.32 4.32 0 0 0 4 6v12a1 1 0 0 0 1 1h2l-2 3h2.32L8 21h8l.68 1H19l-2-3h2a1 1 0 0 0 1-1V6a4.15 4.15 0 0 0-1.13-2.66zM7.62 4h8.72a1.77 1.77 0 0 1 1 .66 3.25 3.25 0 0 1 .25.34H6.39a2.3 2.3 0 0 1 .25-.35A1.65 1.65 0 0 1 7.62 4zM6 8V7h12v3H6zm12 9H6v-5h12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTrafficCone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.943 2.667A1 1 0 0 0 13 2h-2a1 1 0 0 0-.943.667L4.292 19H2v2h20v-2h-2.292L13.943 2.667zM15.47 13H8.53l1.06-3h4.82l1.06 3zm-3.763-9h.586l1.412 4h-3.41l1.412-4zM7.825 15h8.35l1.412 4H6.413l1.412-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1 9H4.069a7.965 7.965 0 0 1 .52-2H11v2zm0 4H4.589a7.965 7.965 0 0 1-.52-2H11v2zm0-10.931V7H5.765A7.996 7.996 0 0 1 11 4.069zM5.765 17H11v2.931A7.996 7.996 0 0 1 5.765 17zM13 19.931V4.069c3.939.495 7 3.858 7 7.931s-3.061 7.436-7 7.931z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiToggleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9c-1.628 0-3 1.372-3 3s1.372 3 3 3 3-1.372 3-3-1.372-3-3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.296 0-5.982 2.682-6 5.986v.042A6.01 6.01 0 0 0 8 18h8c3.309 0 6-2.691 6-6s-2.691-6-6-6zm0 10H8a4.006 4.006 0 0 1-4-3.99C4.004 9.799 5.798 8 8 8h8c2.206 0 4 1.794 4 4s-1.794 4-4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiToggleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9c-1.628 0-3 1.372-3 3s1.372 3 3 3 3-1.372 3-3-1.372-3-3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.3 0-5.989 2.689-6 6v.016A6.01 6.01 0 0 0 8 18h8a6.01 6.01 0 0 0 6-5.994V12c-.009-3.309-2.699-6-6-6zm0 10H8a4.006 4.006 0 0 1-4-3.99C4.004 9.799 5.798 8 8 8h8c2.202 0 3.996 1.799 4 4.006A4.007 4.007 0 0 1 16 16zm4-3.984.443-.004.557.004h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-3 0-4 3-4 3h8s-1-3-4-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.555 8.832-1.109-1.664-3 2a1.001 1.001 0 0 0 .108 1.727l4 2 .895-1.789-2.459-1.229 1.565-1.045zm-6.557 1.23a1 1 0 0 0-.443-.894l-3-2-1.11 1.664 1.566 1.044-2.459 1.229.895 1.789 4-2a.998.998 0 0 0 .551-.832z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTimer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.145 8.27 1.563-1.563-1.414-1.414L18.586 7c-1.05-.63-2.274-1-3.586-1-3.859 0-7 3.14-7 7s3.141 7 7 7 7-3.14 7-7a6.966 6.966 0 0 0-1.855-4.73zM15 18c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h2v4h-2zm-1-7h4v2h-4zM3 8h4v2H3zm0 8h4v2H3zm-1-4h3.99v2H2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTime(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v6h6v-2h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTimeFive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v5.414l3.293 3.293 1.414-1.414L13 11.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8h2V6h3.252L7.68 18H5v2h8v-2h-2.252L13.32 6H17v2h2V4H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTestTube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.293 2.707.818.818L3.318 14.318C2.468 15.168 2 16.298 2 17.5s.468 2.332 1.318 3.183C4.169 21.532 5.299 22 6.5 22s2.331-.468 3.182-1.318L20.475 9.889l.818.818 1.414-1.414-8-8-1.414 1.414zm3.182 8.354-2.403-2.404-1.414 1.414 2.403 2.404-1.414 1.415-.99-.99-1.414 1.414.99.99-1.415 1.415-2.403-2.404L7 15.728l2.403 2.404-1.136 1.136c-.945.944-2.59.944-3.535 0C4.26 18.795 4 18.168 4 17.5s.26-1.295.732-1.768L15.525 4.939l3.535 3.535-2.585 2.587z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTerminal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14h6v2h-6zM6.293 9.707 8.586 12l-2.293 2.293 1.414 1.414L11.414 12 7.707 8.293z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTennisBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 19.081c1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.899-3.899 3.899-10.243 0-14.143C17.177 3.044 14.665 2 12 2S6.823 3.044 4.929 4.938c-3.899 3.899-3.899 10.244 0 14.143zm12.728-1.414a7.969 7.969 0 0 1-3.813 2.129c-.009-1.602.586-3.146 1.691-4.251 1.163-1.163 2.732-1.828 4.277-1.851a7.945 7.945 0 0 1-2.155 3.973zm2.325-5.965c-2.124-.021-4.284.853-5.861 2.429-1.532 1.532-2.327 3.68-2.263 5.881a7.946 7.946 0 0 1-5.516-2.345 7.97 7.97 0 0 1-2.332-5.512c.077.002.154.014.231.014 2.115 0 4.16-.804 5.637-2.28 1.58-1.58 2.457-3.739 2.43-5.873a7.948 7.948 0 0 1 5.349 2.337 7.96 7.96 0 0 1 2.325 5.349zM6.343 6.353a7.968 7.968 0 0 1 3.973-2.169c-.018 1.555-.685 3.124-1.851 4.291-1.104 1.103-2.642 1.696-4.238 1.691a7.929 7.929 0 0 1 2.116-3.813z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTaxi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.156-1.368-4.105A2.995 2.995 0 0 0 16.559 4H14V2h-4v2H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.105A2.003 2.003 0 0 0 2 12v5c0 .753.423 1.402 1.039 1.743-.013.066-.039.126-.039.195V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.062c0-.069-.026-.13-.039-.195A1.993 1.993 0 0 0 22 17v-5c0-.829-.508-1.541-1.228-1.844zM4 17v-5h16l.002 5H4zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "14.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "14.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H5c-1.103 0-2 .897-2 2v15c0 1.103.897 2 2 2zM5 5h2v2h10V5h2v15H5V5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 13.586-1.793-1.793-1.414 1.414L11 16.414l5.207-5.207-1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTaskX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H5c-1.103 0-2 .897-2 2v15zM5 5h2v2h10V5h2v15H5V5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.292 10.295 12 12.587l-2.292-2.292-1.414 1.414 2.292 2.292-2.292 2.292 1.414 1.414L12 15.415l2.292 2.292 1.414-1.414-2.292-2.292 2.292-2.292z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTargetLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.069V2h-2v2.069A8.008 8.008 0 0 0 4.069 11H2v2h2.069A8.007 8.007 0 0 0 11 19.931V22h2v-2.069A8.007 8.007 0 0 0 19.931 13H22v-2h-2.069A8.008 8.008 0 0 0 13 4.069zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H8.515a2 2 0 0 0-1.627.838l-4.701 6.581a.997.997 0 0 0 0 1.162l4.701 6.581A2 2 0 0 0 8.515 20H20c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 14H8.515l-4.286-6 4.286-6H20v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTagAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.868 4.504A1 1 0 0 0 17 4H3a1 1 0 0 0-.868 1.496L5.849 12l-3.717 6.504A1 1 0 0 0 3 20h14a1 1 0 0 0 .868-.504l4-7a.998.998 0 0 0 0-.992l-4-7zM16.42 18H4.724l3.145-5.504a.998.998 0 0 0 0-.992L4.724 6H16.42l3.429 6-3.429 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTachometer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C6.486 4 2 8.486 2 14a9.89 9.89 0 0 0 1.051 4.445c.17.34.516.555.895.555h16.107c.379 0 .726-.215.896-.555A9.89 9.89 0 0 0 22 14c0-5.514-4.486-10-10-10zm7.41 13H4.59A7.875 7.875 0 0 1 4 14c0-4.411 3.589-8 8-8s8 3.589 8 8a7.875 7.875 0 0 1-.59 3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.939 12.939a1.53 1.53 0 0 0 0 2.561 1.53 1.53 0 0 0 2.121-.44l3.962-6.038a.034.034 0 0 0 0-.035.033.033 0 0 0-.045-.01l-6.038 3.962z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h15.893c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm0-2v-5h4v5H4zM14 7v5h-4V7h4zM8 7v5H4V7h4zm2 12v-5h4v5h-4zm6 0v-5h3.894v5H16zm3.893-7H16V7h3.893v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiTab(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H6zm0 15V5h12l.002 12H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSync(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13 7.101.01.001a4.978 4.978 0 0 1 2.526 1.362 5.005 5.005 0 0 1 1.363 2.528 5.061 5.061 0 0 1-.001 2.016 4.976 4.976 0 0 1-1.363 2.527l1.414 1.414a7.014 7.014 0 0 0 1.908-3.54 6.98 6.98 0 0 0 0-2.819 6.957 6.957 0 0 0-1.907-3.539 6.97 6.97 0 0 0-2.223-1.5 6.921 6.921 0 0 0-1.315-.408c-.137-.028-.275-.043-.412-.063V2L9 6l4 4V7.101zm-7.45 7.623c.174.412.392.812.646 1.19.249.37.537.718.854 1.034a7.036 7.036 0 0 0 2.224 1.501c.425.18.868.317 1.315.408.167.034.338.056.508.078v2.944l4-4-4-4v3.03c-.035-.006-.072-.003-.107-.011a4.978 4.978 0 0 1-2.526-1.362 4.994 4.994 0 0 1 .001-7.071L7.051 7.05a7.01 7.01 0 0 0-1.5 2.224A6.974 6.974 0 0 0 5 12a6.997 6.997 0 0 0 .55 2.724z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSwim(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.003",
                    "cy": "6.002",
                    "r": "2.002"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.875 13.219c-.567.453-.978.781-1.878.781-.899 0-1.288-.311-1.876-.781-.68-.543-1.525-1.219-3.127-1.219-1.601 0-2.445.676-3.124 1.219-.588.47-.975.781-1.875.781-.898 0-1.286-.311-1.873-.78C4.443 12.676 3.6 12 2 12v2c.897 0 1.285.311 1.872.78.679.544 1.523 1.22 3.123 1.22s2.446-.676 3.125-1.22c.587-.47.976-.78 1.874-.78.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219 1.602 0 2.447-.676 3.127-1.219.588-.47.977-.781 1.876-.781v-2c-1.601 0-2.446.676-3.125 1.219zM16.997 19c-.899 0-1.288-.311-1.876-.781-.68-.543-1.525-1.219-3.127-1.219-1.601 0-2.445.676-3.124 1.219-.588.47-.975.781-1.875.781-.898 0-1.286-.311-1.873-.78C4.443 17.676 3.6 17 2 17v2c.897 0 1.285.311 1.872.78.679.544 1.523 1.22 3.123 1.22s2.446-.676 3.125-1.22c.587-.47.976-.78 1.874-.78.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219 1.602 0 2.447-.676 3.127-1.219.588-.47.977-.781 1.876-.781v-2c-1.601 0-2.446.676-3.125 1.219-.567.453-.978.781-1.878.781zM11 5.419l2.104 2.104-2.057 2.57c.286-.056.596-.093.947-.093 1.602 0 2.447.676 3.127 1.219.588.47.977.781 1.876.781.9 0 1.311-.328 1.878-.781.132-.105.274-.217.423-.326l-2.096-2.09.005-.005-5.5-5.5a.999.999 0 0 0-1.414 0l-4 4 1.414 1.414L11 5.419z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSushi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.51 2 4 4.2 4 7v10c0 2.8 3.51 5 8 5s8-2.2 8-5V7c0-2.8-3.51-5-8-5zm0 18c-3.54 0-6-1.58-6-3v-6.67A10.52 10.52 0 0 0 12 12a10.52 10.52 0 0 0 6-1.67V17c0 1.42-2.46 3-6 3zm0-10c-3.54 0-6-1.58-6-3s2.46-3 6-3 6 1.58 6 3-2.46 3-6 3z"
                },
                "child": []
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "7",
                    "rx": "3",
                    "ry": "1.71"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSupport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4 1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.993 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007S14.761 6.993 12 6.993 6.993 9.239 6.993 12zM12 8.993c1.658 0 3.007 1.349 3.007 3.007S13.658 15.007 12 15.007 8.993 13.658 8.993 12 10.342 8.993 12 8.993zM10.998 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2h-3zm17 0h3v2h-3zM4.219 18.363l2.12-2.122 1.415 1.414-2.12 2.122zM16.24 6.344l2.122-2.122 1.414 1.414-2.122 2.122zM6.342 7.759 4.22 5.637l1.415-1.414 2.12 2.122zm13.434 10.605-1.414 1.414-2.122-2.122 1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSubdirectoryRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13H8V5H6v9a1 1 0 0 0 1 1h7v3l5-4-5-4v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSubdirectoryLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13h-6v-3l-5 4 5 4v-3h7a1 1 0 0 0 1-1V5h-2v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiStrikethrough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11h-8c-4 0-4-1.816-4-2.5C8 7.882 8 6 12 6c2.8 0 2.99 1.678 3 2.014L16 8h1c0-1.384-1.045-4-5-4-5.416 0-6 3.147-6 4.5 0 .728.148 1.667.736 2.5H4v2h16v-2zm-8 7c-3.793 0-3.99-1.815-4-2H6c0 .04.069 4 6 4 5.221 0 6-2.819 6-4.5 0-.146-.009-.317-.028-.5h-2.006c.032.2.034.376.034.5 0 .684 0 2.5-4 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiStreetView(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h2v-5h2V9c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v4h2v5h2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18.446 11.386-.893 1.789C19.108 13.95 20 14.98 20 16c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.02.892-2.05 2.446-2.825l-.893-1.789C3.295 12.512 2 14.193 2 16c0 3.364 4.393 6 10 6s10-2.636 10-6c0-1.807-1.295-3.488-3.554-4.614z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiStore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.148 2.971A2.008 2.008 0 0 0 17.434 2H6.566c-.698 0-1.355.372-1.714.971L2.143 7.485A.995.995 0 0 0 2 8a3.97 3.97 0 0 0 1 2.618V19c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8.382A3.97 3.97 0 0 0 22 8a.995.995 0 0 0-.143-.515l-2.709-4.514zm.836 5.28A2.003 2.003 0 0 1 18 10c-1.103 0-2-.897-2-2 0-.068-.025-.128-.039-.192l.02-.004L15.22 4h2.214l2.55 4.251zM10.819 4h2.361l.813 4.065C13.958 9.137 13.08 10 12 10s-1.958-.863-1.993-1.935L10.819 4zM6.566 4H8.78l-.76 3.804.02.004C8.025 7.872 8 7.932 8 8c0 1.103-.897 2-2 2a2.003 2.003 0 0 1-1.984-1.749L6.566 4zM10 19v-3h4v3h-4zm6 0v-3c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v3H5v-7.142c.321.083.652.142 1 .142a3.99 3.99 0 0 0 3-1.357c.733.832 1.807 1.357 3 1.357s2.267-.525 3-1.357A3.99 3.99 0 0 0 18 12c.348 0 .679-.059 1-.142V19h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiStoreAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v2.831c0 1.053.382 2.01 1 2.746V19c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8.424c.618-.735 1-1.692 1-2.746V5zm-2 0v2.831c0 1.14-.849 2.112-1.891 2.167L18 10c-1.103 0-2-.897-2-2V4h3c.552 0 1 .449 1 1zM10 4h4v4c0 1.103-.897 2-2 2s-2-.897-2-2V4zM4 5c0-.551.448-1 1-1h3v4c0 1.103-.897 2-2 2l-.109-.003C4.849 9.943 4 8.971 4 7.831V5zm6 14v-3h4v3h-4zm6 0v-3c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v3H5v-7.131c.254.067.517.111.787.125A3.988 3.988 0 0 0 9 10.643c.733.832 1.807 1.357 3 1.357s2.267-.525 3-1.357a3.988 3.988 0 0 0 3.213 1.351c.271-.014.533-.058.787-.125V19h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiStopwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v5h-2zM9 2h6v2H9zm10.293 5.707-2-2 1.414-1.414 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v10H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiStopCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v6H9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSticker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.796 9.982C20.849 5.357 16.729 2 12 2 6.486 2 2 6.486 2 12c0 4.729 3.357 8.849 7.982 9.796a.988.988 0 0 0 .908-.272l10.633-10.633c.238-.238.34-.578.273-.909zM11 18a7.93 7.93 0 0 1 1.365-4.471 8.18 8.18 0 0 1 .978-1.186 8.211 8.211 0 0 1 1.184-.977 8.128 8.128 0 0 1 1.36-.738c.481-.203.986-.36 1.501-.466a8.112 8.112 0 0 1 2.17-.134l-8.529 8.529c-.013-.185-.029-.37-.029-.557zm-7-6c0-4.411 3.589-8 8-8 2.909 0 5.528 1.589 6.929 4.005a9.99 9.99 0 0 0-1.943.198c-.643.132-1.274.328-1.879.583a10.15 10.15 0 0 0-1.699.923c-.533.361-1.03.771-1.479 1.22s-.858.945-1.221 1.48c-.359.533-.67 1.104-.922 1.698A10.013 10.013 0 0 0 9 18c0 .491.048.979.119 1.461C6.089 18.288 4 15.336 4 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiStats(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12a2 2 0 0 0-.703.133l-2.398-1.963c.059-.214.101-.436.101-.67C17 8.114 15.886 7 14.5 7S12 8.114 12 9.5c0 .396.1.765.262 1.097l-2.909 3.438A2.06 2.06 0 0 0 9 14c-.179 0-.348.03-.512.074l-2.563-2.563C5.97 11.348 6 11.179 6 11c0-1.108-.892-2-2-2s-2 .892-2 2 .892 2 2 2c.179 0 .348-.03.512-.074l2.563 2.563A1.906 1.906 0 0 0 7 16c0 1.108.892 2 2 2s2-.892 2-2c0-.237-.048-.46-.123-.671l2.913-3.442c.227.066.462.113.71.113a2.48 2.48 0 0 0 1.133-.281l2.399 1.963A2.077 2.077 0 0 0 18 14c0 1.108.892 2 2 2s2-.892 2-2-.892-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiStation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.758 16.243 1.414-1.415a3.97 3.97 0 0 1-1.173-2.831c0-1.068.417-2.071 1.173-2.825L7.758 7.756a5.957 5.957 0 0 0-1.76 4.24c0 1.604.625 3.112 1.76 4.247zm8.484 0A5.96 5.96 0 0 0 18 12a5.96 5.96 0 0 0-1.758-4.243l-1.414 1.414C15.584 9.927 16 10.932 16 12s-.416 2.073-1.172 2.829l1.414 1.414z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.344 17.657a7.953 7.953 0 0 1-2.345-5.659c0-2.137.833-4.145 2.345-5.654L4.93 4.929c-1.89 1.886-2.931 4.397-2.931 7.069s1.041 5.183 2.931 7.073l1.414-1.414zM17.657 6.343A7.948 7.948 0 0 1 20 12a7.948 7.948 0 0 1-2.343 5.657l1.414 1.414A9.932 9.932 0 0 0 22 12a9.934 9.934 0 0 0-2.929-7.071l-1.414 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.516 14.323-1.49 6.452a.998.998 0 0 0 1.529 1.057L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082a1 1 0 0 0-.59-1.74l-5.701-.454-2.467-5.461a.998.998 0 0 0-1.822 0L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.214 4.107zm2.853-4.326a.998.998 0 0 0 .832-.586L12 5.43l1.799 3.981a.998.998 0 0 0 .832.586l3.972.315-3.271 2.944c-.284.256-.397.65-.293 1.018l1.253 4.385-3.736-2.491a.995.995 0 0 0-1.109 0l-3.904 2.603 1.05-4.546a1 1 0 0 0-.276-.94l-3.038-2.962 4.09-.326z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H5V5h14v14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSquareRounded(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5zm3 15c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSpreadsheet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5zM5 19V5h14l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h1.998v2H7zm4 0h6v2h-6zm-4 4h1.998v2H7zm4 0h6v2h-6zm-4 4h1.998v2H7zm4 0h6v2h-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSprayCan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.002 2h-4a1 1 0 0 0-1 1v3.812a5.998 5.998 0 0 0-3 5.188v.988L3 13l.002.072V21a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9a5.999 5.999 0 0 0-3-5.188V3a1 1 0 0 0-1-1zm-3 4V4h2v2h-2zm5.001 14h-8v-6h8v6zm-8.001-8c0-2.206 1.794-4 4-4s4 1.794 4 4h-8zm8.001-9h2v2h-2zM16 3h2v2h-2zm0 3h2v2h-2zm3-3h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSpeaker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 18H6V4h12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.01",
                    "cy": "7",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSpaceBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13H7V9H5v6h14V9h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSpa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.787 9.023c-.125.027-1.803.418-3.953 1.774-.323-1.567-1.279-4.501-4.108-7.485L12 2.546l-.726.767C8.435 6.308 7.483 9.25 7.163 10.827 5.005 9.448 3.34 9.052 3.218 9.024L2 8.752V10c0 7.29 3.925 12 10 12 5.981 0 10-4.822 10-12V8.758l-1.213.265zM8.999 12.038c.002-.033.152-3.1 3.001-6.532C14.814 8.906 14.999 12 15 12v.125a18.933 18.933 0 0 0-3.01 3.154 19.877 19.877 0 0 0-2.991-3.113v-.128zM12 20c-5.316 0-7.549-4.196-7.937-8.564 1.655.718 4.616 2.426 7.107 6.123l.841 1.249.825-1.26c2.426-3.708 5.425-5.411 7.096-6.122C19.534 15.654 17.304 20 12 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSort(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16H4l6 6V2H8zm6-11v17h2V8h4l-6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSortZA(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.707 14.707A1 1 0 0 0 19 13h-7v2h4.586l-4.293 4.293A1 1 0 0 0 13 21h7v-2h-4.586l4.293-4.293zM6 3.99l-4 4h3v12h2v-12h3zM17 3h-2c-.417 0-.79.259-.937.649l-2.75 7.333h2.137L14.193 9h3.613l.743 1.981h2.137l-2.75-7.333A1 1 0 0 0 17 3zm-2.057 4 .75-2h.613l.75 2h-2.113z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSortUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h9v2h-9zm0 4h7v2h-7zm0-8h11v2H11zm0 12h5v2h-5zm-6 3h2V8h3L6 4 2 8h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSortDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 20 4-4H7V4H5v12H2zm5-12h9v2h-9zm0 4h7v2h-7zm0-8h11v2H11zm0 12h5v2h-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSortAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20h2V8h3L8 4 4 8h3zm13-4h-3V4h-2v12h-3l4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSortAZ(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.707 14.707A1 1 0 0 0 19 13h-7v2h4.586l-4.293 4.293A1 1 0 0 0 13 21h7v-2h-4.586l4.293-4.293zM7 3.99H5v12H2l4 4 4-4H7zM17 3h-2c-.417 0-.79.259-.937.649l-2.75 7.333h2.137L14.193 9h3.613l.743 1.981h2.137l-2.75-7.333A1 1 0 0 0 17 3zm-2.057 4 .75-2h.613l.75 2h-2.113z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.829 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.042 6.042 0 0 0 2.415 0 5.972 5.972 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.889l-1.658-1.119a4.017 4.017 0 0 1-.489.592z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSlideshow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h7v3H8v2h8v-2h-3v-3h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 15V5h16l.001 10H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 13 5-3-5-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSlider(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5h9v2h-9zM2 7h7v2h2V3H9v2H2zm7 10h13v2H9zm10-6h3v2h-3zm-2 4V9.012h-2V11H2v2h13v2zM7 21v-6H5v2H2v2h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSliderAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14.5c-1.58 0-2.903 1.06-3.337 2.5H2v2h2.163c.434 1.44 1.757 2.5 3.337 2.5s2.903-1.06 3.337-2.5H22v-2H10.837c-.434-1.44-1.757-2.5-3.337-2.5zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5S9 17.173 9 18s-.673 1.5-1.5 1.5zm9-11c-1.58 0-2.903 1.06-3.337 2.5H2v2h11.163c.434 1.44 1.757 2.5 3.337 2.5s2.903-1.06 3.337-2.5H22v-2h-2.163c-.434-1.44-1.757-2.5-3.337-2.5zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.837 5C12.403 3.56 11.08 2.5 9.5 2.5S6.597 3.56 6.163 5H2v2h4.163C6.597 8.44 7.92 9.5 9.5 9.5s2.903-1.06 3.337-2.5h9.288V5h-9.288zM9.5 7.5C8.673 7.5 8 6.827 8 6s.673-1.5 1.5-1.5S11 5.173 11 6s-.673 1.5-1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSleepy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "15.5",
                    "rx": "3",
                    "ry": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7c-2.905 0-3.983 2.386-4 3.99l2 .021C8.002 10.804 8.076 9 10 9V7zm4 0v2c1.826 0 1.992 1.537 2 2.007L17 11h1c0-1.608-1.065-4-4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSkipPrevious(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 7-7 5 7 5zm-7 5V7H7v10h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSkipPreviousCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16V8l-5 4zM9 8v8h2V8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSkipNext(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7v10l7-5zm9 10V7h-2v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSkipNextCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 16 5-4-5-4zm5-4v4h2V8h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSitemap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13.01h-7V10h1c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h1v3.01H4V18H3v4h4v-4H6v-2.99h5V18h-1v4h4v-4h-1v-2.99h5V18h-1v4h4v-4h-1v-4.99zM10 8V4h4l.002 4H10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSignal5(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zm4-3h2v11h-2zm4-3h2v14h-2zm4-3h2v17h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSignal4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zm4-3h2v11h-2zm4-3h2v14h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSignal3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zm4-3h2v11h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSignal2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSignal1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSidebar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V7h6v12H4zm8 0V7h8V5l.002 14H12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10h2v2H6zm0 4h2v2H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShuffle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17h-1.559l-9.7-10.673A1 1 0 0 0 5.001 6H2v2h2.559l4.09 4.5-4.09 4.501H2v2h3.001a1 1 0 0 0 .74-.327L10 13.987l4.259 4.686a1 1 0 0 0 .74.327H17v3l5-4-5-4v3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.441 8H17v3l5-3.938L17 3v3h-2.001a1 1 0 0 0-.74.327l-3.368 3.707 1.48 1.346L15.441 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18.33A6.78 6.78 0 0 0 19.5 15a6.73 6.73 0 0 0-1.5 3.33 1.51 1.51 0 1 0 3 0zM11 20.33A6.78 6.78 0 0 0 9.5 17 6.73 6.73 0 0 0 8 20.33 1.59 1.59 0 0 0 9.5 22a1.59 1.59 0 0 0 1.5-1.67zM14.5 22a1.59 1.59 0 0 0 1.5-1.67A6.78 6.78 0 0 0 14.5 17a6.73 6.73 0 0 0-1.5 3.33A1.59 1.59 0 0 0 14.5 22zM3 18.33A1.59 1.59 0 0 0 4.5 20 1.59 1.59 0 0 0 6 18.33 6.78 6.78 0 0 0 4.5 15 6.73 6.73 0 0 0 3 18.33zM13 4.07V2h-2v2.07A8 8 0 0 0 4 12H2v2h20v-2h-2a8 8 0 0 0-7-7.93zM6 12a6 6 0 0 1 12 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-1.641-1.359-3-3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c-1.095 0-2-.905-2-2 0-.354.103-.683.268-.973C12.178 9.02 12.092 9 12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-.092-.02-.178-.027-.268-.29.165-.619.268-.973.268z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShoppingBag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V9a1 1 0 0 0-1-1h-3V7c0-2.757-2.243-5-5-5S7 4.243 7 7v1H4a1 1 0 0 0-1 1v11c0 1.103.897 2 2 2zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v1H9V7zm-4 3h2v2h2v-2h6v2h2v-2h2l.002 10H5V10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShocked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                },
                "child": []
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "15.5",
                    "rx": "3",
                    "ry": "2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.995 6.903a.997.997 0 0 0-.547-.797l-7.973-4a.997.997 0 0 0-.895-.002l-8.027 4c-.297.15-.502.437-.544.767-.013.097-1.145 9.741 8.541 15.008a.995.995 0 0 0 .969-.009c9.307-5.259 8.514-14.573 8.476-14.967zm-8.977 12.944c-6.86-4.01-7.14-10.352-7.063-12.205l7.071-3.523 6.998 3.511c.005 1.87-.481 8.243-7.006 12.217z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShieldX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.48 6.105-8-4a1 1 0 0 0-.895 0l-8 4a1.002 1.002 0 0 0-.547.795c-.011.107-.961 10.767 8.589 15.014a.99.99 0 0 0 .812 0c9.55-4.247 8.6-14.906 8.589-15.014a1.001 1.001 0 0 0-.548-.795zm-8.447 13.792C5.265 16.625 4.944 9.642 4.999 7.635l7.034-3.517 7.029 3.515c.038 1.989-.328 9.018-7.029 12.264z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.293 8.293 12 10.586 9.707 8.293 8.293 9.707 10.586 12l-2.293 2.293 1.414 1.414L12 13.414l2.293 2.293 1.414-1.414L13.414 12l2.293-2.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShieldQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.995 6.9a.998.998 0 0 0-.548-.795l-8-4a1 1 0 0 0-.895 0l-8 4a1.002 1.002 0 0 0-.547.795c-.011.107-.961 10.767 8.589 15.014a.987.987 0 0 0 .812 0c9.55-4.247 8.6-14.906 8.589-15.014zM12 19.897V12H5.51a15.473 15.473 0 0 1-.544-4.365L12 4.118V12h6.46c-.759 2.74-2.498 5.979-6.46 7.897z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShieldPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.63 21.91A.9.9 0 0 0 12 22a1 1 0 0 0 .41-.09C22 17.67 21 7 21 6.9a1 1 0 0 0-.55-.79l-8-4a1 1 0 0 0-.9 0l-8 4A1 1 0 0 0 3 6.9c0 .1-.92 10.77 8.63 15.01zM5 7.63l7-3.51 7 3.51c.05 2-.27 9-7 12.27C5.26 16.63 4.94 9.64 5 7.63z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.06 16h2v-3h3.01v-2h-3.01V8h-2v3h-3v2h3v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShieldMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.41 6.11-8-4a.94.94 0 0 0-.89 0l-8 4A1 1 0 0 0 3 6.9c0 .11-1 10.77 8.59 15a1 1 0 0 0 .41.1.93.93 0 0 0 .4-.09C21.92 17.67 21 7 21 6.9a1 1 0 0 0-.59-.79zM12 19.9C5.2 16.63 4.88 9.64 4.93 7.63l7-3.51 7 3.51c.13 2.01-.19 9-6.93 12.27z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShieldAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.342 8.447 1.105-.553A.998.998 0 0 0 21.8 6.4l-3-4A1 1 0 0 0 18 2H6a1 1 0 0 0-.8.4l-3 4a1 1 0 0 0 .352 1.494l1.105.553-1.131 2.262A5.052 5.052 0 0 0 2 12.944v.591a6.028 6.028 0 0 0 3.894 5.618l3.431 1.286a5.488 5.488 0 0 1 1.969 1.268.997.997 0 0 0 1.413 0 5.486 5.486 0 0 1 1.969-1.267l3.432-1.287A6.03 6.03 0 0 0 22 13.535v-.591c0-.771-.183-1.545-.527-2.236l-1.131-2.261zM20 13.535a4.019 4.019 0 0 1-2.596 3.745l-3.431 1.287a7.5 7.5 0 0 0-1.974 1.101 7.515 7.515 0 0 0-1.974-1.102L6.596 17.28A4.019 4.019 0 0 1 4 13.535v-.591c0-.463.109-.928.316-1.342l1.131-2.261a2.003 2.003 0 0 0-.895-2.684l-.033-.015L6.5 4h11l1.981 2.642-.034.017a2.004 2.004 0 0 0-.895 2.684l1.131 2.26c.208.414.317.878.317 1.341v.591z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShieldAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.438 5.089a1.002 1.002 0 0 0-.959.015c-.684.389-1.355.577-2.053.577-2.035 0-3.952-1.629-5.722-3.39-.375-.373-1.063-.373-1.438 0C9.592 3.959 7.598 5.663 5.51 5.663c-.69 0-1.351-.184-2.018-.561-.298-.166-.658-.171-.96-.012s-.501.461-.528.801c-.011.129-.944 12.872 9.683 16.041a.99.99 0 0 0 .286.042H12c.097 0 .192-.014.285-.041 10.657-3.17 9.695-15.916 9.684-16.044a1 1 0 0 0-.531-.8zm-9.452 14.842c-6.979-2.255-7.934-9.412-8.014-12.477.505.14 1.019.209 1.537.209 2.492 0 4.65-1.567 6.476-3.283 1.893 1.788 3.983 3.301 6.442 3.301.53 0 1.057-.074 1.575-.22-.074 3.065-1.021 10.217-8.016 12.47z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShekel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8v8h2V8c0-2.206-1.794-4-4-4H5v16h2V6h4c1.103 0 2 .897 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16c0 1.103-.897 2-2 2h-4V8H9v12h6c2.206 0 4-1.794 4-4V4h-2v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7.05V4a1 1 0 0 0-1-1 1 1 0 0 0-.7.29l-7 7a1 1 0 0 0 0 1.42l7 7A1 1 0 0 0 11 18v-3.1h.85a10.89 10.89 0 0 1 8.36 3.72 1 1 0 0 0 1.11.35A1 1 0 0 0 22 18c0-9.12-8.08-10.68-11-10.95zm.85 5.83a14.74 14.74 0 0 0-2 .13A1 1 0 0 0 9 14v1.59L4.42 11 9 6.41V8a1 1 0 0 0 1 1c.91 0 8.11.2 9.67 6.43a13.07 13.07 0 0 0-7.82-2.55z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShareAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 15a3.51 3.51 0 0 0 2.36-.93l6.26 3.58a3.06 3.06 0 0 0-.12.85 3.53 3.53 0 1 0 1.14-2.57l-6.26-3.58a2.74 2.74 0 0 0 .12-.76l6.15-3.52A3.49 3.49 0 1 0 14 5.5a3.35 3.35 0 0 0 .12.85L8.43 9.6A3.5 3.5 0 1 0 5.5 15zm12 2a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm0-13A1.5 1.5 0 1 1 16 5.5 1.5 1.5 0 0 1 17.5 4zm-12 6A1.5 1.5 0 1 1 4 11.5 1.5 1.5 0 0 1 5.5 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShapeTriangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15c-.183 0-.358.022-.532.054L8.946 6.532C8.978 6.359 9 6.182 9 6c0-1.654-1.346-3-3-3S3 4.346 3 6c0 1.302.839 2.401 2 2.815v6.369A2.997 2.997 0 0 0 3 18c0 1.654 1.346 3 3 3a2.993 2.993 0 0 0 2.815-2h6.369a2.994 2.994 0 0 0 2.815 2c1.654 0 3-1.346 3-3S19.654 15 18 15zm-11 .184V8.816c.329-.118.629-.291.894-.508l7.799 7.799a2.961 2.961 0 0 0-.508.894h-6.37A2.99 2.99 0 0 0 7 15.184zM6 5a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm0 14a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm12 0a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShapeSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6c0-1.654-1.346-3-3-3a2.993 2.993 0 0 0-2.815 2h-6.37A2.993 2.993 0 0 0 6 3C4.346 3 3 4.346 3 6c0 1.302.839 2.401 2 2.815v6.369A2.997 2.997 0 0 0 3 18c0 1.654 1.346 3 3 3a2.993 2.993 0 0 0 2.815-2h6.369a2.994 2.994 0 0 0 2.815 2c1.654 0 3-1.346 3-3a2.997 2.997 0 0 0-2-2.816V8.816A2.996 2.996 0 0 0 21 6zm-3-1a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm-2.815 12h-6.37A2.99 2.99 0 0 0 7 15.184V8.816A2.99 2.99 0 0 0 8.815 7h6.369A2.99 2.99 0 0 0 17 8.815v6.369A2.99 2.99 0 0 0 15.185 17zM6 5a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm0 14a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm12 0a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShapePolygon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14.185v-2.369A2.997 2.997 0 0 0 22 9c0-1.654-1.346-3-3-3a2.99 2.99 0 0 0-2.116.876L12.969 5.31c.01-.103.031-.204.031-.31 0-1.654-1.346-3-3-3S7 3.346 7 5c0 .762.295 1.451.765 1.981L6.091 9.212A2.977 2.977 0 0 0 5 9c-1.654 0-3 1.346-3 3s1.346 3 3 3c.159 0 .313-.023.465-.047L7.4 17.532c-.248.436-.4.932-.4 1.468 0 1.654 1.346 3 3 3a2.994 2.994 0 0 0 2.863-2.153l3.962-.792A2.987 2.987 0 0 0 19 20c1.654 0 3-1.346 3-3a2.995 2.995 0 0 0-2-2.815zM19 8a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm-9-4a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm-6 8a1.001 1.001 0 1 1 1 1c-.552 0-1-.449-1-1zm6 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2.761-2.172A3.005 3.005 0 0 0 10 16c-.386 0-.752.079-1.091.213l-1.674-2.231C7.705 13.451 8 12.762 8 12c0-.536-.152-1.032-.399-1.467l1.935-2.58c.152.024.305.047.464.047a2.99 2.99 0 0 0 2.116-.876l3.915 1.566c-.01.103-.031.204-.031.31 0 1.302.839 2.401 2 2.815v2.369a2.996 2.996 0 0 0-2 2.815c0 .061.015.117.018.177l-3.257.652zM19 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiShapeCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.494 9.05a8.14 8.14 0 0 0-4.544-4.544C14.713 3.088 13.485 2 12 2S9.287 3.088 9.05 4.506A8.136 8.136 0 0 0 4.506 9.05C3.088 9.287 2 10.515 2 12s1.088 2.713 2.506 2.95a8.14 8.14 0 0 0 4.544 4.544C9.287 20.912 10.515 22 12 22s2.713-1.088 2.95-2.506a8.14 8.14 0 0 0 4.544-4.544C20.912 14.713 22 13.485 22 12s-1.088-2.713-2.506-2.95zM12 4a1 1 0 0 1 1 1c0 .06-.023.11-.034.167a1.015 1.015 0 0 1-.083.279c-.014.027-.034.049-.051.075a1.062 1.062 0 0 1-.16.209c-.04.037-.09.062-.136.092-.054.036-.104.078-.165.103-.115.047-.239.075-.371.075s-.256-.028-.371-.075c-.061-.024-.111-.066-.165-.103-.046-.03-.096-.055-.136-.092a1.062 1.062 0 0 1-.16-.209c-.017-.026-.037-.048-.051-.075a1.026 1.026 0 0 1-.083-.279C11.023 5.11 11 5.06 11 5a1 1 0 0 1 1-1zm-7 7c.06 0 .11.023.167.034.099.017.194.041.279.083.027.014.049.034.075.051.075.047.149.097.209.16.037.04.062.09.092.136.036.054.078.104.103.165.047.115.075.239.075.371s-.028.256-.075.371c-.024.061-.066.111-.103.165-.03.046-.055.096-.092.136-.06.063-.134.113-.209.16-.026.017-.048.037-.075.051a1.026 1.026 0 0 1-.279.083C5.11 12.977 5.06 13 5 13a1 1 0 0 1 0-2zm7 9a1 1 0 0 1-1-1c0-.06.023-.11.034-.167.017-.099.041-.194.083-.279.014-.027.034-.049.051-.075.047-.075.097-.149.16-.209.04-.037.09-.062.136-.092.054-.036.104-.078.165-.103.115-.047.239-.075.371-.075s.256.028.371.075c.061.024.111.066.165.103.046.03.096.055.136.092.063.06.113.134.16.209.017.026.037.048.051.075.042.085.066.181.083.279.011.057.034.107.034.167a1 1 0 0 1-1 1zm2.583-2.512c-.006-.011-.017-.019-.022-.029a3.007 3.007 0 0 0-.996-1.007c-.054-.033-.109-.06-.166-.09a2.902 2.902 0 0 0-.486-.205c-.064-.021-.128-.044-.194-.061-.233-.057-.471-.096-.719-.096s-.486.039-.718.097c-.066.017-.13.039-.195.061a2.928 2.928 0 0 0-.485.205c-.056.029-.112.057-.166.09a3.007 3.007 0 0 0-.996 1.007c-.006.011-.017.019-.022.029a6.15 6.15 0 0 1-2.905-2.905c.011-.006.019-.017.029-.022a3.007 3.007 0 0 0 1.007-.996c.033-.054.061-.11.09-.166.083-.154.15-.316.205-.485.021-.065.044-.129.061-.195.056-.234.095-.472.095-.72s-.039-.486-.097-.718a2.568 2.568 0 0 0-.061-.194 2.902 2.902 0 0 0-.205-.486c-.03-.057-.057-.112-.09-.166A3.007 3.007 0 0 0 6.54 9.44c-.01-.006-.018-.017-.028-.023a6.15 6.15 0 0 1 2.905-2.905c.006.01.017.018.022.029.248.411.588.755.996 1.007.054.033.11.061.166.09.155.083.316.15.486.205.064.021.128.044.194.061.233.057.47.096.719.096a2.94 2.94 0 0 0 .912-.158c.17-.055.331-.122.486-.205.056-.029.112-.057.166-.09.408-.252.748-.596.996-1.007.006-.011.017-.019.022-.029a6.15 6.15 0 0 1 2.905 2.905c-.011.006-.019.017-.029.022a3.007 3.007 0 0 0-1.007.996c-.033.054-.061.11-.09.166-.083.155-.15.316-.205.486-.021.064-.044.128-.061.194A3.07 3.07 0 0 0 16 12a2.94 2.94 0 0 0 .158.912c.055.17.122.331.205.486.029.056.057.112.09.166.252.408.596.748 1.007.996.011.006.019.017.029.022a6.145 6.145 0 0 1-2.906 2.906zM19 13c-.06 0-.11-.023-.167-.034a1.015 1.015 0 0 1-.279-.083c-.027-.014-.049-.034-.075-.051a1.062 1.062 0 0 1-.209-.16c-.037-.04-.062-.09-.092-.136-.036-.054-.078-.104-.103-.165-.047-.115-.075-.239-.075-.371s.028-.256.075-.371c.024-.061.066-.111.103-.165.03-.046.055-.096.092-.136.06-.063.134-.113.209-.16.026-.017.048-.037.075-.051.085-.042.181-.066.279-.083.057-.011.107-.034.167-.034a1 1 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiServer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM4 9V5h16v4zm16 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM4 19v-4h16v4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6h2v2h-2zm-3 0h2v2h-2zm3 10h2v2h-2zm-3 0h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSend(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.426 11.095-17-8A.999.999 0 0 0 3.03 4.242L4.969 12 3.03 19.758a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81zM5.481 18.197l.839-3.357L12 12 6.32 9.16l-.839-3.357L18.651 12l-13.17 6.197z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSelection(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H9V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v6H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1h6v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1V9h1zm-3-4h2v2h-2V5zM5 5h2v2H5V5zm2 14H5v-2h2v2zm12 0h-2v-2h2v2zm-2-4h-1a1 1 0 0 0-1 1v1H9v-1a1 1 0 0 0-1-1H7V9h1a1 1 0 0 0 1-1V7h6v1a1 1 0 0 0 1 1h1v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSelectMultiple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm8.933 3.519-1.726-1.726-1.414 1.414 3.274 3.274 5.702-6.84-1.538-1.282z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSearch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSearchAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.412 8.586c.379.38.588.882.588 1.414h2a3.977 3.977 0 0 0-1.174-2.828c-1.514-1.512-4.139-1.512-5.652 0l1.412 1.416c.76-.758 2.07-.756 2.826-.002z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSearchAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.023 16.977a35.13 35.13 0 0 1-1.367-1.384c-.372-.378-.596-.653-.596-.653l-2.8-1.337A6.962 6.962 0 0 0 16 9c0-3.859-3.14-7-7-7S2 5.141 2 9s3.14 7 7 7c1.763 0 3.37-.66 4.603-1.739l1.337 2.8s.275.224.653.596c.387.363.896.854 1.384 1.367l1.358 1.392.604.646 2.121-2.121-.646-.604c-.379-.372-.885-.866-1.391-1.36zM9 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiScreenshot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 19h3v-2H5v-2H3v3a1 1 0 0 0 1 1zM19 4a1 1 0 0 0-1-1h-3v2h2v2h2V4zM5 5h2V3H4a1 1 0 0 0-1 1v3h2V5zM3 9h2v4H3zm14 0h2v3h-2zM9 3h4v2H9zm0 14h3v2H9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiScatterChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h17v-2H5V3H3v17a1 1 0 0 0 1 1z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "13.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "6.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiScan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v5h2V5h4V3H4a1 1 0 0 0-1 1zm18 5V4a1 1 0 0 0-1-1h-5v2h4v4h2zm-2 10h-4v2h5a1 1 0 0 0 1-1v-5h-2v4zM9 21v-2H5v-4H3v5a1 1 0 0 0 1 1h5zM2 11h20v2H2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V8a1 1 0 0 0-.29-.71l-4-4A1 1 0 0 0 16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm10-2H9v-5h6zM13 7h-2V5h2zM5 5h2v4h8V5h.59L19 8.41V19h-2v-5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v5H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-3 0-4 3-4 3h8s-1-3-4-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRupee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6V4H6v2h3.5c1.302 0 2.401.838 2.815 2H6v2h6.315A2.994 2.994 0 0 1 9.5 12H6v2.414L11.586 20h2.828l-6-6H9.5a5.007 5.007 0 0 0 4.898-4H17V8h-2.602a4.933 4.933 0 0 0-.924-2H17z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.777 10.969a2.007 2.007 0 0 0 2.148.83l3.316-.829-.483-1.94-3.316.829-1.379-2.067a2.01 2.01 0 0 0-1.272-.854l-3.846-.77a1.998 1.998 0 0 0-2.181 1.067l-1.658 3.316 1.789.895 1.658-3.317 1.967.394L7.434 17H3v2h4.434c.698 0 1.355-.372 1.715-.971l1.918-3.196 5.169 1.034 1.816 5.449 1.896-.633-1.815-5.448a2.007 2.007 0 0 0-1.506-1.33l-3.039-.607 1.772-2.954.417.625z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRuler(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.875 7H3.125C1.953 7 1 7.897 1 9v6c0 1.103.953 2 2.125 2h17.75C22.047 17 23 16.103 23 15V9c0-1.103-.953-2-2.125-2zm0 8H3.125c-.057 0-.096-.016-.113-.016-.007 0-.011.002-.012.008l-.012-5.946c.007-.01.052-.046.137-.046H5v3h2V9h2v4h2V9h2v3h2V9h2v4h2V9h1.875c.079.001.122.028.125.008l.012 5.946c-.007.01-.052.046-.137.046z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRuble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h2v-3h6v-2h-6v-2h4.5c2.757 0 5-2.243 5-5s-2.243-5-5-5H9a1 1 0 0 0-1 1v7H5v2h3v2H5v2h3v3zm2-15h4.5c1.654 0 3 1.346 3 3s-1.346 3-3 3H10V6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 20.001C19 11.729 12.271 5 4 5v2c7.168 0 13 5.832 13 13.001h2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20.001h2C14 14.486 9.514 10 4 10v2c4.411 0 8 3.589 8 8.001z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRotateRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.242 17.242a6.04 6.04 0 0 1-1.37 1.027l.961 1.754a8.068 8.068 0 0 0 2.569-2.225l-1.6-1.201a5.938 5.938 0 0 1-.56.645zm1.743-4.671a5.975 5.975 0 0 1-.362 2.528l1.873.701a7.977 7.977 0 0 0 .483-3.371l-1.994.142zm1.512-2.368a8.048 8.048 0 0 0-1.841-2.859l-1.414 1.414a6.071 6.071 0 0 1 1.382 2.146l1.873-.701zm-8.128 8.763c-.047-.005-.094-.015-.141-.021a6.701 6.701 0 0 1-.468-.075 5.923 5.923 0 0 1-2.421-1.122 5.954 5.954 0 0 1-.583-.506 6.138 6.138 0 0 1-.516-.597 5.91 5.91 0 0 1-.891-1.634 6.086 6.086 0 0 1-.247-.902c-.008-.043-.012-.088-.019-.131A6.332 6.332 0 0 1 6 13.002V13c0-1.603.624-3.109 1.758-4.242A5.944 5.944 0 0 1 11 7.089V10l5-4-5-4v3.069a7.917 7.917 0 0 0-4.656 2.275A7.936 7.936 0 0 0 4 12.999v.009c0 .253.014.504.037.753.007.076.021.15.03.227.021.172.044.345.076.516.019.1.044.196.066.295.032.142.065.283.105.423.032.112.07.223.107.333.026.079.047.159.076.237l.008-.003A7.948 7.948 0 0 0 5.6 17.785l-.007.005c.021.028.049.053.07.081.211.272.433.538.681.785a8.236 8.236 0 0 0 .966.816c.265.192.537.372.821.529l.028.019.001-.001a7.877 7.877 0 0 0 2.136.795l-.001.005.053.009c.201.042.405.071.61.098.069.009.138.023.207.03a8.038 8.038 0 0 0 2.532-.137l-.424-1.955a6.11 6.11 0 0 1-1.904.102z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRotateLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.758 8.758 5.344 7.344a8.048 8.048 0 0 0-1.841 2.859l1.873.701a6.048 6.048 0 0 1 1.382-2.146zM19 12.999a7.935 7.935 0 0 0-2.344-5.655A7.917 7.917 0 0 0 12 5.069V2L7 6l5 4V7.089a5.944 5.944 0 0 1 3.242 1.669A5.956 5.956 0 0 1 17 13v.002c0 .33-.033.655-.086.977-.007.043-.011.088-.019.131a6.053 6.053 0 0 1-1.138 2.536c-.16.209-.331.412-.516.597a5.954 5.954 0 0 1-.728.613 5.906 5.906 0 0 1-2.277 1.015c-.142.03-.285.05-.43.069-.062.009-.122.021-.184.027a6.104 6.104 0 0 1-1.898-.103L9.3 20.819a8.087 8.087 0 0 0 2.534.136c.069-.007.138-.021.207-.03.205-.026.409-.056.61-.098l.053-.009-.001-.005a7.877 7.877 0 0 0 2.136-.795l.001.001.028-.019a7.906 7.906 0 0 0 1.01-.67c.27-.209.532-.43.777-.675.248-.247.47-.513.681-.785.021-.028.049-.053.07-.081l-.006-.004a7.899 7.899 0 0 0 1.093-1.997l.008.003c.029-.078.05-.158.076-.237.037-.11.075-.221.107-.333.04-.14.073-.281.105-.423.022-.099.048-.195.066-.295.032-.171.056-.344.076-.516.01-.076.023-.15.03-.227.023-.249.037-.5.037-.753.002-.002.002-.004.002-.008zM6.197 16.597l-1.6 1.201a8.045 8.045 0 0 0 2.569 2.225l.961-1.754a6.018 6.018 0 0 1-1.93-1.672zM5 13c0-.145.005-.287.015-.429l-1.994-.143a7.977 7.977 0 0 0 .483 3.372l1.873-.701A5.975 5.975 0 0 1 5 13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRocket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.92 2.38A15.72 15.72 0 0 0 17.5 2a8.26 8.26 0 0 0-6 2.06Q9.89 5.67 8.31 7.27c-1.21-.13-4.08-.2-6 1.74a1 1 0 0 0 0 1.41l11.3 11.32a1 1 0 0 0 1.41 0c1.95-2 1.89-4.82 1.77-6l3.21-3.2c3.19-3.19 1.74-9.18 1.68-9.43a1 1 0 0 0-.76-.73zm-2.36 8.75L15 14.67a1 1 0 0 0-.27.9 6.81 6.81 0 0 1-.54 3.94L4.52 9.82a6.67 6.67 0 0 1 4-.5A1 1 0 0 0 9.39 9s1.4-1.45 3.51-3.56A6.61 6.61 0 0 1 17.5 4a14.51 14.51 0 0 1 2.33.2c.24 1.43.62 5.04-1.27 6.93z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.73",
                    "cy": "8.3",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16c-2 1-2 5-2 5a7.81 7.81 0 0 0 5-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRightTopArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.006 2.007a9.927 9.927 0 0 0-7.071 2.922c-3.898 3.899-3.898 10.243 0 14.142 1.885 1.885 4.396 2.923 7.071 2.923s5.187-1.038 7.071-2.923c3.898-3.898 3.898-10.242 0-14.142a9.928 9.928 0 0 0-7.071-2.922zm5.657 15.649c-1.507 1.507-3.517 2.337-5.657 2.337s-4.15-.83-5.657-2.337c-3.118-3.119-3.118-8.194 0-11.313 1.507-1.507 3.516-2.336 5.657-2.336s4.15.829 5.657 2.336c3.118 3.119 3.118 8.194 0 11.313z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.467 11.125-3.214 3.214 1.414 1.414 3.214-3.214 2.125 2.124V9H9.343z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRightIndent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h10v2H10zm-6 4h16v2H4zm6-8h10v2H10zm0-4h10v2H10zM4 3h16v2H4zm0 5v8l4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRightDownArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.007a9.928 9.928 0 0 0-7.071 2.922c-3.899 3.899-3.899 10.243 0 14.143A9.93 9.93 0 0 0 12 21.995a9.93 9.93 0 0 0 7.071-2.923c3.899-3.899 3.899-10.243 0-14.143A9.928 9.928 0 0 0 12 2.007zm5.657 15.65A7.946 7.946 0 0 1 12 19.994c-2.141 0-4.15-.83-5.657-2.337-3.119-3.119-3.119-8.195 0-11.314A7.944 7.944 0 0 1 12 4.007c2.141 0 4.15.829 5.657 2.336 3.119 3.119 3.119 8.195 0 11.314z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.661 8.247 8.247 9.661l3.214 3.214L9.336 15H15V9.337l-2.125 2.124z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRightArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A.998.998 0 0 0 5 3v18a1 1 0 0 0 .536.886zM7 4.909 17.243 12 7 19.091V4.909z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRightArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.999 1.993c-5.514.001-10 4.487-10 10.001s4.486 10 10.001 10c5.513 0 9.999-4.486 10-10 0-5.514-4.486-10-10.001-10.001zM12 19.994c-4.412 0-8.001-3.589-8.001-8s3.589-8 8-8.001C16.411 3.994 20 7.583 20 11.994c-.001 4.411-3.59 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.994H8v2h4V16l4.005-4.005L12 7.991z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRightArrowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.293 17.293 1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRfid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16a1 1 0 0 0 1-1v-8h-2v7H5V4h5V2H4a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11h2a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h2a9 9 0 0 0-9-9v2a7 7 0 0 1 7 7zM9.65 15.67a1 1 0 0 0-.14-.51.76.76 0 0 0-.38-.31 2.3 2.3 0 0 0-.75-.09H7V18h.65v-1.35h.14a1.31 1.31 0 0 1 .33 0 .58.58 0 0 1 .19.14 4.72 4.72 0 0 1 .35.48l.47.7h.78l-.39-.63a3.56 3.56 0 0 0-.38-.53 1.25 1.25 0 0 0-.35-.27 1 1 0 0 0 .64-.3.84.84 0 0 0 .22-.57zm-.74.33a.4.4 0 0 1-.18.14 2.36 2.36 0 0 1-.59 0h-.49v-.82h1a.4.4 0 0 1 .25.13.36.36 0 0 1 .09.26.43.43 0 0 1-.08.29zM10.92 16.62h1.36v-.54h-1.36v-.77h1.57v-.55h-2.22V18h.65v-1.38zM13.01 14.76h.65V18h-.65zM16.1 14.82a2.48 2.48 0 0 0-.62-.06h-1.2V18h1.24a1.76 1.76 0 0 0 .57-.07 1.07 1.07 0 0 0 .46-.26 1.35 1.35 0 0 0 .35-.57 2 2 0 0 0 .1-.69 2.35 2.35 0 0 0-.11-.76 1.33 1.33 0 0 0-.31-.53 1.09 1.09 0 0 0-.48-.3zm.16 2.18a.74.74 0 0 1-.17.31.57.57 0 0 1-.27.13 1.79 1.79 0 0 1-.39 0h-.49v-2.13h.29a3.06 3.06 0 0 1 .54 0 .71.71 0 0 1 .3.15.82.82 0 0 1 .19.32 2.05 2.05 0 0 1 .06.57 2.41 2.41 0 0 1-.06.65z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRewind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12V7l-7 5 7 5zm7-5-7 5 7 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRewindCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16V8l-5 4zm6 0V8l-5 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRevision(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.89 10.105a8.696 8.696 0 0 0-.789-1.456l-1.658 1.119a6.606 6.606 0 0 1 .987 2.345 6.659 6.659 0 0 1 0 2.648 6.495 6.495 0 0 1-.384 1.231 6.404 6.404 0 0 1-.603 1.112 6.654 6.654 0 0 1-1.776 1.775 6.606 6.606 0 0 1-2.343.987 6.734 6.734 0 0 1-2.646 0 6.55 6.55 0 0 1-3.317-1.788 6.605 6.605 0 0 1-1.408-2.088 6.613 6.613 0 0 1-.382-1.23 6.627 6.627 0 0 1 .382-3.877A6.551 6.551 0 0 1 7.36 8.797 6.628 6.628 0 0 1 9.446 7.39c.395-.167.81-.296 1.23-.382.107-.022.216-.032.324-.049V10l5-4-5-4v2.938a8.805 8.805 0 0 0-.725.111 8.512 8.512 0 0 0-3.063 1.29A8.566 8.566 0 0 0 4.11 16.77a8.535 8.535 0 0 0 1.835 2.724 8.614 8.614 0 0 0 2.721 1.833 8.55 8.55 0 0 0 5.061.499 8.576 8.576 0 0 0 6.162-5.056c.22-.52.389-1.061.5-1.608a8.643 8.643 0 0 0 0-3.45 8.684 8.684 0 0 0-.499-1.607z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRestaurant(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10h-2V3H8v7H6V3H4v8c0 1.654 1.346 3 3 3h1v7h2v-7h1c1.654 0 3-1.346 3-3V3h-2v7zm7-7h-1c-1.159 0-2 1.262-2 3v8h2v7h2V4a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiReset(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3-3 1.331-3 3 1.329 3 3 3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219 9.053 9.053 0 0 0-2.43-2.43 8.95 8.95 0 0 0-3.219-1.355 9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053 7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725 7.11 7.11 0 0 1-.644 1.188 7.2 7.2 0 0 1-.858 1.039 7.028 7.028 0 0 1-3.536 1.907 7.13 7.13 0 0 1-2.822 0 6.961 6.961 0 0 1-2.503-1.054 7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034 9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183 9.014 9.014 0 0 0 3.218-1.355 8.886 8.886 0 0 0 1.331-1.099 9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRepost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7a1 1 0 0 0-1-1h-8v2h7v5h-3l3.969 5L22 13h-3V7zM5 17a1 1 0 0 0 1 1h8v-2H7v-5h3L6 6l-4 5h3v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiReply(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11h6v7h2v-8a1 1 0 0 0-1-1h-7V6l-5 4 5 4v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiReplyAll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-8a1 1 0 0 0-1-1h-6V6l-5 4 5 4v-3h5v7h2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12.4 6 10l3-2.4V6l-5 4 5 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRepeat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-5v2h4v9H4V8h5v3l5-4-5-4v3H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRename(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.005 5.995h-1v2h1v8h-1v2h1c1.103 0 2-.897 2-2v-8c0-1.102-.898-2-2-2zm-14 4H15v4H6.005z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.005 17.995V4H20V2h-8v2h3.005v1.995h-11c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h11V20H12v2h8v-2h-2.995v-2.005zm-13-2v-8h11v8h-11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRegistered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.14 2a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.14 10a3 3 0 0 0-3-3h-5v10h2v-4h1.46l2.67 4h2.4l-2.75-4.12A3 3 0 0 0 16.14 10zm-3 1h-3V9h3a1 1 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRefresh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11H7.101l.001-.009a4.956 4.956 0 0 1 .752-1.787 5.054 5.054 0 0 1 2.2-1.811c.302-.128.617-.226.938-.291a5.078 5.078 0 0 1 2.018 0 4.978 4.978 0 0 1 2.525 1.361l1.416-1.412a7.036 7.036 0 0 0-2.224-1.501 6.921 6.921 0 0 0-1.315-.408 7.079 7.079 0 0 0-2.819 0 6.94 6.94 0 0 0-1.316.409 7.04 7.04 0 0 0-3.08 2.534 6.978 6.978 0 0 0-1.054 2.505c-.028.135-.043.273-.063.41H2l4 4 4-4zm4 2h2.899l-.001.008a4.976 4.976 0 0 1-2.103 3.138 4.943 4.943 0 0 1-1.787.752 5.073 5.073 0 0 1-2.017 0 4.956 4.956 0 0 1-1.787-.752 5.072 5.072 0 0 1-.74-.61L7.05 16.95a7.032 7.032 0 0 0 2.225 1.5c.424.18.867.317 1.315.408a7.07 7.07 0 0 0 2.818 0 7.031 7.031 0 0 0 4.395-2.945 6.974 6.974 0 0 0 1.053-2.503c.027-.135.043-.273.063-.41H22l-4-4-4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiReflectVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 18 6-6-6-6v12zm12-6 6 6V6l-6 6zm-4-9h2v3h-2zm0 5h2v3h-2zm0 5h2v3h-2zm0 5h2v3h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiReflectHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21h12l-6-6-6 6zM18 3H6l6 6 6-6zM3 11h3v2H3zm5 0h3v2H8zm5 0h3v2h-3zm5 0h3v2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRedo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h3v-2H9c-1.654 0-3-1.346-3-3s1.346-3 3-3h6v3l5-4-5-4v3H9c-2.757 0-5 2.243-5 5s2.243 5 5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRecycle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.224 15.543-.813-1.464-1.748.972.812 1.461c.048.085.082.173.104.264a1.024 1.024 0 0 1-.014.5.988.988 0 0 1-.104.235 1 1 0 0 1-.347.352.978.978 0 0 1-.513.137H14v-2l-4 3 4 3v-2h4.601c.278 0 .552-.037.811-.109a2.948 2.948 0 0 0 1.319-.776c.178-.179.332-.38.456-.593a2.992 2.992 0 0 0 .336-2.215 3.163 3.163 0 0 0-.299-.764zM5.862 11.039l-2.31 4.62a3.06 3.06 0 0 0-.261.755 2.997 2.997 0 0 0 .851 2.735c.178.174.376.326.595.453A3.022 3.022 0 0 0 6.236 20H8v-2H6.236a1.016 1.016 0 0 1-.5-.13.974.974 0 0 1-.353-.349 1 1 0 0 1-.149-.468.933.933 0 0 1 .018-.245c.018-.087.048-.173.089-.256l2.256-4.512 1.599.923L8.598 8 4 9.964l1.862 1.075zm12.736 1.925L19.196 8l-1.638.945-2.843-5.117a2.95 2.95 0 0 0-1.913-1.459 3.227 3.227 0 0 0-.772-.083 3.003 3.003 0 0 0-1.498.433A2.967 2.967 0 0 0 9.41 3.944l-.732 1.464 1.789.895.732-1.465c.045-.09.101-.171.166-.242a.933.933 0 0 1 .443-.27 1.053 1.053 0 0 1 .53-.011.963.963 0 0 1 .63.485l2.858 5.146L14 11l4.598 1.964z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V5h16l.001 14H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiReceipt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11h-3V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-6a1 1 0 0 0-1-1zM5 19a1 1 0 0 1-1-1V5h12v13c0 .351.061.688.171 1H5zm15-1a1 1 0 0 1-2 0v-5h2v5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h8v2H6zm0 4h8v2H6zm5 4h3v2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRadio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.25 5.025-7.898-2.962-.703 1.873L14.484 5H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.018-.767-1.85-1.75-1.975zM4 19v-7h16v-2H4V7h16l.001 12H4z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "15.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15h4.999v2H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRadioCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12c0 3.859 3.14 7 7 7 3.859 0 7-3.141 7-7s-3.141-7-7-7c-3.86 0-7 3.141-7 7zm12 0c0 2.757-2.243 5-5 5s-5-2.243-5-5 2.243-5 5-5 5 2.243 5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRadioCircleMarked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-1.627 0-3 1.373-3 3s1.373 3 3 3 3-1.373 3-3-1.373-3-3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiRadar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.58 2 12s4.579 10 10 10 10-4.58 10-10S17.421 2 12 2zm0 18c-4.337 0-8-3.664-8-8 0-3.998 3.115-7.417 7-7.927V6.09C8.167 6.569 6 9.033 6 12c0 3.309 2.691 6 6 6 1.595 0 3.1-.626 4.237-1.763l-1.414-1.415A3.97 3.97 0 0 1 12 16c-2.206 0-4-1.794-4-4 0-1.858 1.279-3.411 3-3.858v2.146c-.59.353-1 .993-1 1.712 0 1.081.919 2 2 2s2-.919 2-2c0-.719-.41-1.359-1-1.712V4.073c3.885.51 7 3.929 7 7.927 0 4.336-3.663 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiQuestionMark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C9.243 4 7 6.243 7 9h2c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.069-.454 1.465-1.481 2.255-.382.294-.813.626-1.226 1.038C10.981 13.604 10.995 14.897 11 15v2h2v-2.009c0-.024.023-.601.707-1.284.32-.32.682-.598 1.031-.867C15.798 12.024 17 11.1 17 9c0-2.757-2.243-5-5-5zm-1 14h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiQr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h8V3H3zm2-6h4v4H5zM3 21h8v-8H3zm2-6h4v4H5zm8-12v8h8V3zm6 6h-4V5h4zm-5.99 4h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2zm4 0h2v2h-2zm2 2h2v2h-2zm-4 0h2v2h-2zm2-6h2v2h-2zm2 2h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiQrScan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h4.01V2H2v6h2V4zm0 12H2v6h6.01v-2H4v-4zm16 4h-4v2h6v-6h-2v4zM16 4h4v4h2V2h-6v2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h6V5H5zm2-4h2v2H7zM5 19h6v-6H5zm2-4h2v2H7zM19 5h-6v6h6zm-2 4h-2V7h2zm-3.99 4h2v2h-2zm2 2h2v2h-2zm2 2h2v2h-2zm0-4h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPyramid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.445 21.832a1 1 0 0 0 1.11 0l9-6A.998.998 0 0 0 21.8 14.4l-9-12c-.377-.504-1.223-.504-1.6 0l-9 12a1 1 0 0 0 .245 1.432l9 6zM13 19.131V6l6.565 8.754L13 19.131zM11 6v13.131l-6.565-4.377L11 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPurchaseTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 3.293A.996.996 0 0 0 13 3H4a1 1 0 0 0-1 1v9c0 .266.105.52.293.707l8 8a.997.997 0 0 0 1.414 0l9-9a.999.999 0 0 0 0-1.414l-8-8zM12 19.586l-7-7V5h7.586l7 7L12 19.586z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.496",
                    "cy": "8.495",
                    "r": "1.505"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPurchaseTagAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.707 2.293A.997.997 0 0 0 11 2H6a.997.997 0 0 0-.707.293l-3 3A.996.996 0 0 0 2 6v5c0 .266.105.52.293.707l10 10a.997.997 0 0 0 1.414 0l8-8a.999.999 0 0 0 0-1.414l-10-10zM13 19.586l-9-9V6.414L6.414 4h4.172l9 9L13 19.586z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.353",
                    "cy": "8.353",
                    "r": "1.647"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPulse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.97 4.757a.999.999 0 0 0-1.918-.073l-3.186 9.554-2.952-6.644a1.002 1.002 0 0 0-1.843.034L5.323 12H2v2h3.323c.823 0 1.552-.494 1.856-1.257l.869-2.172 3.037 6.835c.162.363.521.594.915.594l.048-.001a.998.998 0 0 0 .9-.683l2.914-8.742.979 3.911A1.995 1.995 0 0 0 18.781 14H22v-2h-3.22l-1.81-7.243z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPrinter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-1V2H6v5H5c-1.654 0-3 1.346-3 3v7c0 1.103.897 2 2 2h2v3h12v-3h2c1.103 0 2-.897 2-2v-7c0-1.654-1.346-3-3-3zM8 4h8v3H8V4zm8 16H8v-4h8v4zm4-3h-2v-3H6v3H4v-7c0-.551.449-1 1-1h14c.552 0 1 .449 1 1v7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h4v2h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPowerOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21c4.411 0 8-3.589 8-8 0-3.35-2.072-6.221-5-7.411v2.223A6 6 0 0 1 18 13c0 3.309-2.691 6-6 6s-6-2.691-6-6a5.999 5.999 0 0 1 3-5.188V5.589C6.072 6.779 4 9.65 4 13c0 4.411 3.589 8 8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h2v10h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPound(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.553 19.105.764 1.843C7.498 20.555 9.422 20 10 20c.838 0 1.462.208 2.184.448.775.259 1.654.552 2.816.552 1.177 0 3.078-.921 3.447-1.105l-.895-1.789c-.721.36-2.031.894-2.552.894-.838 0-1.462-.208-2.184-.448C12.041 18.293 11.162 18 10 18c-.229 0-.526.037-.857.099C9.702 16.95 10 15.561 10 14h3v-2H9.626c-.042-.107-.084-.216-.125-.317C9.243 11.052 9 10.455 9 9c0-1.369.521-3 3-3 2.224 0 3.021 2.227 3.052 2.316l1.896-.633C16.898 7.533 15.679 4 12 4 8.313 4 7 6.583 7 9c0 1.491.234 2.35.478 3H5v2h3c0 2.467-.892 4.328-2.447 5.105z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPopsicle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2a7 7 0 0 0-4.94 2l-7.78 7.82a1 1 0 0 0 0 1.41l3.54 3.54-3.54 3.53 1.42 1.42 3.53-3.54 3.54 3.54a1 1 0 0 0 1.41 0L20 13.94A7 7 0 0 0 15 2zm3.54 10.54-7.07 7.06-2.82-2.83-1.42-1.42-2.83-2.83 7.07-7.07a5 5 0 0 1 7.08 7.08z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPolygon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707l-5-5zM20 15.586 15.586 20H8.414L4 15.586V8.414L8.414 4h7.172L20 8.414v7.172z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPoll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h7v2H7zm0-4h10.97v2H7zm0 8h13v2H7zM4 4h2v16H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.978 13.21a1 1 0 0 0-.396-1.024l-14-10a.999.999 0 0 0-1.575.931l2 17a1 1 0 0 0 1.767.516l3.612-4.416 3.377 5.46 1.701-1.052-3.357-5.428 6.089-1.218a.995.995 0 0 0 .782-.769zm-8.674.31a1 1 0 0 0-.578.347l-3.008 3.677L7.257 5.127l10.283 7.345-5.236 1.048z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPodcast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.01",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.01 22h2l.5-7h-3l.5 7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 0 0-2.45 19.68l-.15-2.12a8 8 0 1 1 5.21 0l-.15 2.12A10 10 0 0 0 12 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.32 9.61a3.44 3.44 0 0 1 .37.68 3.83 3.83 0 0 1 .23.75 3.57 3.57 0 0 1 .09.8 3.66 3.66 0 0 1-.09.81 3.83 3.83 0 0 1-.23.75 3.44 3.44 0 0 1-.37.68 4.7 4.7 0 0 1-.35.43l-.19 2.62a5.33 5.33 0 0 0 .58-.31A5.86 5.86 0 0 0 17 15.2a5.57 5.57 0 0 0 .55-1 5.89 5.89 0 0 0 .35-1.13 6.06 6.06 0 0 0 .1-1.23 6.22 6.22 0 0 0-.13-1.21A6.09 6.09 0 0 0 17 8.49a6.29 6.29 0 0 0-.73-.89 5.67 5.67 0 0 0-.89-.73 6.3 6.3 0 0 0-1-.56A6.17 6.17 0 0 0 13.21 6a6.11 6.11 0 0 0-2.41 0 5.51 5.51 0 0 0-1.13.36 5.57 5.57 0 0 0-1 .55 5.67 5.67 0 0 0-.89.73 6.29 6.29 0 0 0-.78.85 6.09 6.09 0 0 0-.9 2.14 6.21 6.21 0 0 0-.1 1.21 6.06 6.06 0 0 0 .12 1.21 5.89 5.89 0 0 0 .35 1.13 5.57 5.57 0 0 0 .55 1 6.24 6.24 0 0 0 1.62 1.62 5.33 5.33 0 0 0 .58.31L9 14.51a4.7 4.7 0 0 1-.35-.43 3.44 3.44 0 0 1-.37-.68 3.83 3.83 0 0 1-.23-.75 3.65 3.65 0 0 1-.05-.81 3.56 3.56 0 0 1 .08-.8 3.83 3.83 0 0 1 .23-.75 3.44 3.44 0 0 1 .37-.68 4 4 0 0 1 .5-.61 3.87 3.87 0 0 1 .59-.48 3.44 3.44 0 0 1 .68-.37 3.86 3.86 0 0 1 .75-.24 4.36 4.36 0 0 1 1.61 0 3.86 3.86 0 0 1 .75.24 3.58 3.58 0 0 1 1.27.85 3.49 3.49 0 0 1 .49.61z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPlusMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPlusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPlug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8h2v5c0 2.206 1.794 4 4 4h2v5h2v-5h2c2.206 0 4-1.794 4-4V8h2V6H3v2zm4 0h10v5c0 1.103-.897 2-2 2H9c-1.103 0-2-.897-2-2V8zm0-6h2v3H7zm8 0h2v3h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6v12l10-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPlayCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 17 8-5-8-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPlanet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.76 20.2a2.73 2.73 0 0 0 2.15.85 8.86 8.86 0 0 0 3.37-.86 9 9 0 0 0 12.27-10.9c1.31-2.23 1.75-4.26.67-5.48a2.94 2.94 0 0 0-2.57-1A5 5 0 0 0 16.1 4 9 9 0 0 0 3.58 15.14c-1.06 1.21-2.05 3.68-.82 5.06zm1.5-1.32c-.22-.25 0-1.07.37-1.76a9.26 9.26 0 0 0 1.57 1.74c-1.03.3-1.71.28-1.94.02zm14.51-5.17A7 7 0 0 1 15.58 18 7.12 7.12 0 0 1 12 19a6.44 6.44 0 0 1-1.24-.13 30.73 30.73 0 0 0 4.42-3.29 31.5 31.5 0 0 0 3.8-4 6.88 6.88 0 0 1-.21 2.13zm.09-8.89a.94.94 0 0 1 .87.32c.23.26.16.94-.26 1.93a9.2 9.2 0 0 0-1.61-1.86 2.48 2.48 0 0 1 1-.39zM5.22 10.31A6.94 6.94 0 0 1 8.41 6 7 7 0 0 1 12 5a6.9 6.9 0 0 1 6 3.41 5.19 5.19 0 0 1 .35.66 27.43 27.43 0 0 1-4.49 5A27.35 27.35 0 0 1 8.35 18a7 7 0 0 1-3.13-7.65z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 22 1-2v-3h5a1 1 0 0 0 1-1v-1.586c0-.526-.214-1.042-.586-1.414L17 11.586V8a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v3a1 1 0 0 0 1 1v3.586L5.586 13A2.01 2.01 0 0 0 5 14.414V16a1 1 0 0 0 1 1h5v3l1 2zM8 4h8v2H8V4zM7 14.414l1.707-1.707A.996.996 0 0 0 9 12V8h6v4c0 .266.105.52.293.707L17 14.414V15H7v-.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPieChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.166V12h6.834A6.817 6.817 0 0 0 12 5.166z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPieChartAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a9.936 9.936 0 0 0-7.071 2.929C3.04 6.818 2 9.33 2 12s1.04 5.182 2.929 7.071C6.818 20.96 9.33 22 12 22s5.182-1.04 7.071-2.929C20.96 17.182 22 14.67 22 12s-1.04-5.182-2.929-7.071A9.936 9.936 0 0 0 12 2zm5.657 15.657C16.146 19.168 14.137 20 12 20s-4.146-.832-5.657-2.343C4.832 16.146 4 14.137 4 12s.832-4.146 2.343-5.657A7.927 7.927 0 0 1 11 4.069V12a1 1 0 0 0 1 1h7.931a7.927 7.927 0 0 1-2.274 4.657zM13 11V4.062a7.945 7.945 0 0 1 4.657 2.281A7.934 7.934 0 0 1 19.938 11H13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPieChartAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9H13V4.069A8.008 8.008 0 0 1 19.931 11zM4 12c0-4.072 3.061-7.436 7-7.931V12a.996.996 0 0 0 .111.438c.015.03.022.063.041.093l4.202 6.723A7.949 7.949 0 0 1 12 20c-4.411 0-8-3.589-8-8zm13.052 6.196L13.805 13h6.126a7.992 7.992 0 0 1-2.879 5.196z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPhotoAlbum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.024 11.536 10 10l-2 3h9l-3.5-5z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.503",
                    "cy": "7.497",
                    "r": "1.503"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2zm0 14H5V5c0-.806.55-.988 1-1h13v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.707 12.293a.999.999 0 0 0-1.414 0l-1.594 1.594c-.739-.22-2.118-.72-2.992-1.594s-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a.999.999 0 0 0-1.414 0L3.581 5.005c-.38.38-.594.902-.586 1.435.023 1.424.4 6.37 4.298 10.268s8.844 4.274 10.269 4.298h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-4-4.001zm-.127 6.712c-1.248-.021-5.518-.356-8.873-3.712-3.366-3.366-3.692-7.651-3.712-8.874L7 4.414 9.586 7 8.293 8.293a1 1 0 0 0-.272.912c.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.991.991 0 0 0 .912-.271L17 14.414 19.586 17l-2.006 2.005z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPhoneOutgoing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.712 13.288a.999.999 0 0 0-1.414 0l-1.594 1.594c-.739-.22-2.118-.72-2.992-1.594s-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a.999.999 0 0 0-1.414 0L2.586 6c-.38.38-.594.902-.586 1.435.023 1.424.4 6.37 4.298 10.268S15.142 21.977 16.566 22h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-3.999-4zM16.585 20c-1.248-.021-5.518-.356-8.873-3.712C4.346 12.922 4.02 8.637 4 7.414l2.005-2.005 2.586 2.586-1.293 1.293a1 1 0 0 0-.272.912c.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.993.993 0 0 0 .912-.271l1.293-1.293 2.586 2.586L16.585 20z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.795 5.791-4.497 4.497 1.414 1.414 4.497-4.497L21.005 10V2.995H14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPhoneOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.09 12.5a8.92 8.92 0 0 1-1-2.2l1.59-1.59a1 1 0 0 0 0-1.42l-4-4a1 1 0 0 0-1.41 0L2.59 6A2 2 0 0 0 2 7.44 15.44 15.44 0 0 0 5.62 17L2.3 20.29l1.41 1.42 18-18-1.41-1.42zM7 15.55a13.36 13.36 0 0 1-3-8.13l2-2L8.59 8 7.3 9.29a1 1 0 0 0-.27.92 11 11 0 0 0 1.62 3.73zm9.71-2.26a1 1 0 0 0-1.41 0l-1.6 1.6-.34-.12-1.56 1.55a12.06 12.06 0 0 0 2 .66 1 1 0 0 0 .91-.27l1.3-1.3L18.59 18l-2 2A13.61 13.61 0 0 1 10 18.1l-1.43 1.45a15.63 15.63 0 0 0 8 2.45 2 2 0 0 0 1.43-.58l2.71-2.71a1 1 0 0 0 0-1.42z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPhoneIncoming(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.712 13.288a.999.999 0 0 0-1.414 0l-1.597 1.596c-.824-.245-2.166-.771-2.99-1.596-.874-.874-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a1.03 1.03 0 0 0-1.414 0l-2.709 2.71c-.382.38-.597.904-.588 1.437.022 1.423.396 6.367 4.297 10.268C10.195 21.6 15.142 21.977 16.566 22h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-3.999-4zM16.585 20c-1.248-.021-5.518-.356-8.874-3.712C4.343 12.92 4.019 8.636 4 7.414l2.004-2.005L8.59 7.995 7.297 9.288c-.238.238-.34.582-.271.912.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.994.994 0 0 0 .912-.271l1.293-1.293 2.586 2.586L16.585 20z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.795 6.791 13.005 4v6.995H20l-2.791-2.79 4.503-4.503-1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPhoneCall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.57 22a2 2 0 0 0 1.43-.59l2.71-2.71a1 1 0 0 0 0-1.41l-4-4a1 1 0 0 0-1.41 0l-1.6 1.59a7.55 7.55 0 0 1-3-1.59 7.62 7.62 0 0 1-1.59-3l1.59-1.6a1 1 0 0 0 0-1.41l-4-4a1 1 0 0 0-1.41 0L2.59 6A2 2 0 0 0 2 7.43 15.28 15.28 0 0 0 6.3 17.7 15.28 15.28 0 0 0 16.57 22zM6 5.41 8.59 8 7.3 9.29a1 1 0 0 0-.3.91 10.12 10.12 0 0 0 2.3 4.5 10.08 10.08 0 0 0 4.5 2.3 1 1 0 0 0 .91-.27L16 15.41 18.59 18l-2 2a13.28 13.28 0 0 1-8.87-3.71A13.28 13.28 0 0 1 4 7.41zM20 11h2a8.81 8.81 0 0 0-9-9v2a6.77 6.77 0 0 1 7 7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c2.1 0 3 .9 3 3h2c0-3.22-1.78-5-5-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPencil(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.404 2.998c-.757-.754-2.077-.751-2.828.005l-1.784 1.791L11.586 7H7a.998.998 0 0 0-.939.658l-4 11c-.133.365-.042.774.232 1.049l2 2a.997.997 0 0 0 1.049.232l11-4A.998.998 0 0 0 17 17v-4.586l2.207-2.207v-.001h.001L21 8.409c.378-.378.586-.881.585-1.415 0-.535-.209-1.038-.588-1.415l-2.593-2.581zm-3.111 8.295A.996.996 0 0 0 15 12v4.3l-9.249 3.363 4.671-4.671c.026.001.052.008.078.008A1.5 1.5 0 1 0 9 13.5c0 .026.007.052.008.078l-4.671 4.671L7.7 9H12c.266 0 .52-.105.707-.293L14.5 6.914 17.086 9.5l-1.793 1.793zm3.206-3.208-2.586-2.586 1.079-1.084 2.593 2.581-1.086 1.089z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h3v10H8zm5 0h3v10h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPauseCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h2v6h-2zM9 9h2v6H9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPaste(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11V5c0-1.103-.897-2-2-2h-3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H4c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h7c0 1.103.897 2 2 2h7c1.103 0 2-.897 2-2v-7c0-1.103-.897-2-2-2zm-9 2v5H4V5h3v2h8V5h3v6h-5c-1.103 0-2 .897-2 2zm2 7v-7h7l.001 7H13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiParty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8.31c-.36-.41-.73-.82-1.12-1.21l-.29-.27.14-.12a3.15 3.15 0 0 0 .9-3.49A3.91 3.91 0 0 0 14 1v2a2 2 0 0 1 1.76 1c.17.4 0 .84-.47 1.31-.07.08-.15.13-.22.2-3-2.41-6.29-3.77-7.9-2.16a2.16 2.16 0 0 0-.41.59v.1l-.18.53-4.41 13.1A3.28 3.28 0 0 0 5.28 22a3.21 3.21 0 0 0 1-.17L20 17.28a1 1 0 0 0 .43-.31l.21-.18c1.43-1.44.51-4.21-1.41-6.9A6.63 6.63 0 0 1 23 9V7a8.44 8.44 0 0 0-5 1.31zM5.7 19.93a1.29 1.29 0 0 1-1.63-1.63l1.36-4.1a10.7 10.7 0 0 0 4.29 4.39zm7-2.33a8.87 8.87 0 0 1-6.3-6.29l1-3 .06.09c.11.22.25.45.39.68s.16.29.26.44.33.48.51.73.19.28.3.42.43.55.66.82l.29.35c.34.39.7.77 1.08 1.16s.68.64 1 1l.33.28.78.63.37.28c.28.2.55.4.83.58l.31.2c.36.22.72.43 1.07.61h.05zm6.51-2.23h-.06c-.69.38-3.56-.57-6.79-3.81-.34-.34-.66-.67-.95-1l-.29-.35-.53-.64-.29-.4c-.13-.19-.27-.37-.39-.55l-.26-.42-.29-.47c-.08-.14-.14-.27-.21-.4s-.15-.26-.21-.4a3.31 3.31 0 0 1-.14-.36c-.05-.13-.11-.26-.15-.38S8.6 6 8.57 5.88s-.05-.22-.07-.32a2.26 2.26 0 0 1 0-.26 1 1 0 0 1 0-.24l.11-.31c.36-.36 2.23 0 4.73 1.9A4.13 4.13 0 0 1 12 7v2a6.45 6.45 0 0 0 3-.94l.48.46c.42.42.81.85 1.18 1.28a5.32 5.32 0 0 0-.6 3.4l2-.39a3.57 3.57 0 0 1 0-1.12 11.3 11.3 0 0 1 .81 1.45c.56 1.32.52 2.06.34 2.23z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiParagraph(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h2v4h2V6h2v14h2V6h3V4H9c-3.309 0-6 2.691-6 6s2.691 6 6 6zM9 6h2v8H9c-2.206 0-4-1.794-4-4s1.794-4 4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPaperclip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.004 5H9c-1.838 0-3.586.737-4.924 2.076C2.737 8.415 2 10.163 2 12c0 1.838.737 3.586 2.076 4.924C5.414 18.263 7.162 19 9 19h8v-2H9c-1.303 0-2.55-.529-3.51-1.49C4.529 14.55 4 13.303 4 12c0-1.302.529-2.549 1.49-3.51C6.45 7.529 7.697 7 9 7h8V6l.001 1h.003c.79 0 1.539.314 2.109.886.571.571.886 1.322.887 2.116a2.966 2.966 0 0 1-.884 2.11A2.988 2.988 0 0 1 17 13H9a.99.99 0 0 1-.698-.3A.991.991 0 0 1 8 12c0-.252.11-.507.301-.698A.987.987 0 0 1 9 11h8V9H9c-.79 0-1.541.315-2.114.889C6.314 10.461 6 11.211 6 12s.314 1.54.888 2.114A2.974 2.974 0 0 0 9 15h8.001a4.97 4.97 0 0 0 3.528-1.473 4.967 4.967 0 0 0-.001-7.055A4.95 4.95 0 0 0 17.004 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPaperPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.56,3.34a1,1,0,0,0-1-.08l-17,8a1,1,0,0,0-.57.92,1,1,0,0,0,.6.9L8,15.45v6.72L13.84,18l4.76,2.08a.93.93,0,0,0,.4.09,1,1,0,0,0,.52-.15,1,1,0,0,0,.48-.79l1-15A1,1,0,0,0,20.56,3.34ZM18.1,17.68l-5.27-2.31L16,9.17,8.35,13.42,5.42,12.13,18.89,5.79Z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPalette(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4 2.096a10.08 10.08 0 0 0-8.937 3.331A10.054 10.054 0 0 0 2.096 13.4c.53 3.894 3.458 7.207 7.285 8.246a9.982 9.982 0 0 0 2.618.354l.142-.001a3.001 3.001 0 0 0 2.516-1.426 2.989 2.989 0 0 0 .153-2.879l-.199-.416a1.919 1.919 0 0 1 .094-1.912 2.004 2.004 0 0 1 2.576-.755l.412.197c.412.198.85.299 1.301.299A3.022 3.022 0 0 0 22 12.14a9.935 9.935 0 0 0-.353-2.76c-1.04-3.826-4.353-6.754-8.247-7.284zm5.158 10.909-.412-.197c-1.828-.878-4.07-.198-5.135 1.494-.738 1.176-.813 2.576-.204 3.842l.199.416a.983.983 0 0 1-.051.961.992.992 0 0 1-.844.479h-.112a8.061 8.061 0 0 1-2.095-.283c-3.063-.831-5.403-3.479-5.826-6.586-.321-2.355.352-4.623 1.893-6.389a8.002 8.002 0 0 1 7.16-2.664c3.107.423 5.755 2.764 6.586 5.826.198.73.293 1.474.282 2.207-.012.807-.845 1.183-1.441.894z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "14.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "10.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "7.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "7.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPaint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.061 22c1.523 0 2.84-.543 3.91-1.613 1.123-1.123 1.707-2.854 1.551-4.494l8.564-8.564a3.123 3.123 0 0 0-.002-4.414c-1.178-1.18-3.234-1.18-4.412 0l-8.884 8.884c-1.913.169-3.807 1.521-3.807 3.919 0 .303.021.588.042.86.08 1.031.109 1.418-1.471 2.208a1.001 1.001 0 0 0-.122 1.717C2.52 20.563 4.623 22 7.061 22c-.001 0-.001 0 0 0zM18.086 4.328a1.144 1.144 0 0 1 1.586.002 1.12 1.12 0 0 1 0 1.584L12 13.586 10.414 12l7.672-7.672zM6.018 16.423c-.018-.224-.037-.458-.037-.706 0-1.545 1.445-1.953 2.21-1.953.356 0 .699.073.964.206.945.475 1.26 1.293 1.357 1.896.177 1.09-.217 2.368-.956 3.107C8.865 19.664 8.049 20 7.061 20H7.06c-.75 0-1.479-.196-2.074-.427 1.082-.973 1.121-1.989 1.032-3.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPaintRoll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H7c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h11c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM7 7V4h11l.002 3H7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15v-2c0-1.103-.897-2-2-2H4V5c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h7v2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiPackage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8a.76.76 0 0 0 0-.21v-.08a.77.77 0 0 0-.07-.16.35.35 0 0 0-.05-.08l-.1-.13-.08-.06-.12-.09-9-5a1 1 0 0 0-1 0l-9 5-.09.07-.11.08a.41.41 0 0 0-.07.11.39.39 0 0 0-.08.1.59.59 0 0 0-.06.14.3.3 0 0 0 0 .1A.76.76 0 0 0 2 8v8a1 1 0 0 0 .52.87l9 5a.75.75 0 0 0 .13.06h.1a1.06 1.06 0 0 0 .5 0h.1l.14-.06 9-5A1 1 0 0 0 22 16V8zm-10 3.87L5.06 8l2.76-1.52 6.83 3.9zm0-7.72L18.94 8 16.7 9.25 9.87 5.34zM4 9.7l7 3.92v5.68l-7-3.89zm9 9.6v-5.68l3-1.68V15l2-1v-3.18l2-1.11v5.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiOutline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2zM5 14V5h9v3h-4c-1.103 0-2 .897-2 2v4H5zm9.001 0H10v-4h4.001v4zM10 16h4c1.103 0 2-.897 2-2v-4h3l.001 9H10v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiObjectsVerticalTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h20v2H2zM11 21V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1zm-2-1H6V8h3zM19 6h-5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-1 10h-3V8h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiObjectsVerticalCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v4h-2V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6H2v2h2v6a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-6h2v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4h2v-2h-2zM9 18H6V6h3zm9-2h-3V8h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiObjectsVerticalBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v2H2zM4 3v14a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zm2 1h3v12H6zM13 17a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1zm2-9h3v8h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiObjectsHorizontalRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v20h-2zM18 14a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zm-2 4H4v-3h12zM7 11h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zm1-5h8v3H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiObjectsHorizontalLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h2v20H2zM21 13H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm-1 5H8v-3h12zM7 11h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zm1-5h8v3H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiObjectsHorizontalCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20h6v2h2v-2h6a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-6v-2h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4V2h-2v2H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4v2H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zM8 6h8v3H8zm-2 9h12v3H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiNotification(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19H5V6h8c0-.712.153-1.387.422-2H5c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h13c1.103 0 2-.897 2-2v-8.422A4.962 4.962 0 0 1 18 11v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiNotificationOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.71 20.296-1.786-1.786c.045-.163.076-.332.076-.51v-7h-2v5.586L7.414 6H13V4H6c-.178 0-.347.031-.51.076l-1.78-1.78L2.296 3.71l18 18 1.414-1.414zM4 8.121V18c0 1.103.897 2 2 2h9.879l-2-2H6v-7.879l-2-2z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function BiNotepad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 20V7h14V6l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h10v2H7zm0 4h5v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h8a.996.996 0 0 0 .707-.293l7-7a.997.997 0 0 0 .196-.293c.014-.03.022-.061.033-.093a.991.991 0 0 0 .051-.259c.002-.021.013-.041.013-.062V5c0-1.103-.897-2-2-2zM5 5h14v7h-6a1 1 0 0 0-1 1v6H5V5zm9 12.586V14h3.586L14 17.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiNoSignal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zM21 3h-2v14.59l-2-2V7h-2v6.59l-2-2V10h-1.59l-7.7-7.71-1.42 1.42 18 18 1.42-1.42-.71-.7V3zm-6 18h1.88L15 19.12V21zm-4 0h2v-3.88l-2-2V21z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiNoEntry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h10v4H7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiNews(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.875 3H4.125C2.953 3 2 3.897 2 5v14c0 1.103.953 2 2.125 2h15.75C21.047 21 22 20.103 22 19V5c0-1.103-.953-2-2.125-2zm0 16H4.125c-.057 0-.096-.016-.113-.016-.007 0-.011.002-.012.008L3.988 5.046c.007-.01.052-.046.137-.046h15.75c.079.001.122.028.125.008l.012 13.946c-.007.01-.052.046-.137.046z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h6v6H6zm7 8H6v2h12v-2h-4zm1-4h4v2h-4zm0-4h4v2h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiNetworkChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3c-1.654 0-3 1.346-3 3 0 .502.136.968.354 1.385l-1.116 1.302A3.976 3.976 0 0 0 13 8c-.739 0-1.425.216-2.02.566L9.566 7.152A3.449 3.449 0 0 0 10 5.5C10 3.57 8.43 2 6.5 2S3 3.57 3 5.5 4.57 9 6.5 9c.601 0 1.158-.166 1.652-.434L9.566 9.98A3.972 3.972 0 0 0 9 12c0 .997.38 1.899.985 2.601l-1.692 1.692.025.025A2.962 2.962 0 0 0 7 16c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-.476-.121-.919-.318-1.318l.025.025 1.954-1.954c.421.15.867.247 1.339.247 2.206 0 4-1.794 4-4a3.96 3.96 0 0 0-.439-1.785l1.253-1.462c.364.158.764.247 1.186.247 1.654 0 3-1.346 3-3s-1.346-3-3-3zM7 20a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM5 5.5C5 4.673 5.673 4 6.5 4S8 4.673 8 5.5 7.327 7 6.5 7 5 6.327 5 5.5zm8 8.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm6-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiNavigation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.002 9.63c-.023.411.207.794.581.966l7.504 3.442 3.442 7.503c.164.356.52.583.909.583l.057-.002a1 1 0 0 0 .894-.686l5.595-17.032c.117-.358.023-.753-.243-1.02s-.66-.358-1.02-.243L2.688 8.736a1 1 0 0 0-.686.894zm16.464-3.971-4.182 12.73-2.534-5.522a.998.998 0 0 0-.492-.492L5.734 9.841l12.732-4.182z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMusic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.684 5.821-9-3.272A1.998 1.998 0 0 0 8 4.428v6.129A3.953 3.953 0 0 0 6 10c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4V4.428L19 7.7v6.856A3.962 3.962 0 0 0 17 14c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4V7.7c0-.838-.529-1.594-1.316-1.879zM6 16c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm11 4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMovie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.466l-2.667-4H20l.001 4zM9.535 9 6.868 5h2.597l2.667 4H9.535zm5 0-2.667-4h2.597l2.667 4h-2.597zM4 5h.465l2.667 4H4V5zm0 14v-8h16l.002 8H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMoviePlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.465l-2.667-4H20l.001 4zM9.536 9 6.869 5h2.596l2.667 4H9.536zm5 0-2.667-4h2.596l2.667 4h-2.596zM4 5h.465l2.667 4H4V5zm0 14v-8h16l.002 8H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 18 5.5-3-5.5-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11h-5V6h3l-4-4-4 4h3v5H6V8l-4 4 4 4v-3h5v5H8l4 4 4-4h-3v-5h5v3l4-4-4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMoveVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 17 5 5 5-5h-4V7h4l-5-5-5 5h4v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMoveHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11H7V7l-5 5 5 5v-4h10v4l5-5-5-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.975 22H12c3.859 0 7-3.14 7-7V9c0-3.841-3.127-6.974-6.981-7h-.06C8.119 2.022 5 5.157 5 9v6c0 3.86 3.129 7 6.975 7zM7 9a5.007 5.007 0 0 1 4.985-5C14.75 4.006 17 6.249 17 9v6c0 2.757-2.243 5-5 5h-.025C9.186 20 7 17.804 7 15V9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v6h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMouseAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2h-2C7.691 2 5 4.691 5 8v8c0 3.309 2.691 6 6 6h2c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-2 2v6H7V8c0-2.206 1.794-4 4-4zm6 12c0 2.206-1.794 4-4 4h-2c-2.206 0-4-1.794-4-4v-4h10v4zm-4-6V4c2.206 0 4 1.794 4 4v2h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.742 13.045a8.088 8.088 0 0 1-2.077.271c-2.135 0-4.14-.83-5.646-2.336a8.025 8.025 0 0 1-2.064-7.723A1 1 0 0 0 9.73 2.034a10.014 10.014 0 0 0-4.489 2.582c-3.898 3.898-3.898 10.243 0 14.143a9.937 9.937 0 0 0 7.072 2.93 9.93 9.93 0 0 0 7.07-2.929 10.007 10.007 0 0 0 2.583-4.491 1.001 1.001 0 0 0-1.224-1.224zm-2.772 4.301a7.947 7.947 0 0 1-5.656 2.343 7.953 7.953 0 0 1-5.658-2.344c-3.118-3.119-3.118-8.195 0-11.314a7.923 7.923 0 0 1 2.06-1.483 10.027 10.027 0 0 0 2.89 7.848 9.972 9.972 0 0 0 7.848 2.891 8.036 8.036 0 0 1-1.484 2.059z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMoney(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 11a3 3 0 0 0-3 3H7a3 3 0 0 0-3-3V9a3 3 0 0 0 3-3h10a3 3 0 0 0 3 3v6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMoneyWithdraw(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H2v2h2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4h2V2H5zm13 18H6V4h12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM7 16.999V5h10l.002 11.999H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMobileVibration(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 2.808c-.756-.756-2.072-.756-2.828 0l-9.899 9.899a2.001 2.001 0 0 0 0 2.828l5.657 5.657c.378.378.88.586 1.414.586s1.036-.208 1.414-.586l9.899-9.899c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-5.657-5.657zm-5.656 16.97v1-1l-5.657-5.657 9.899-9.899 5.657 5.657-9.899 9.899z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "15",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.707 21.707-1.414-1.414 6-6 1.414 1.415zM8.293 2.293l1.414 1.414-6 6-1.414-1.415z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMobileLandscape(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM7.001 7H19v10H7.001V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMobileAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.75 2h-10c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-10 18V4h10l.002 16H6.75z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.75",
                    "cy": "18",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h14v2H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMinusFront(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2zm13.997 3H10v-9h9l-.003 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMinusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h10v2H7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMinusBack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2zM5 5h9l-.003 9H5V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMicrophone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12V6c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6v6c0 2.206 1.794 4 4 4s4-1.794 4-4zm-6 0V6c0-1.103.897-2 2-2a.89.89 0 0 0 .163-.015C13.188 4.06 14 4.935 14 6v6c0 1.103-.897 2-2 2s-2-.897-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12H4c0 4.072 3.061 7.436 7 7.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMicrophoneOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 20.293-3.388-3.388A7.942 7.942 0 0 0 20 12.021h-2a5.95 5.95 0 0 1-1.109 3.456l-1.452-1.452c.348-.591.561-1.27.561-2.004v-6C16 3.804 14.215 2 12.021 2c-.07 0-.14.009-.209.025A4.005 4.005 0 0 0 8 6.021v.565L3.707 2.293 2.293 3.707l18 18 1.414-1.414zM10 6.021c0-1.103.897-2 2-2a.918.918 0 0 0 .164-.015C13.188 4.08 14 4.956 14 6.021v6c0 .172-.029.335-.071.494L10 8.586V6.021zm-4 6H4c0 4.072 3.06 7.436 7 7.931v2.069h2v-2.07a7.993 7.993 0 0 0 2.218-.611l-1.558-1.558a5.979 5.979 0 0 1-1.66.239c-3.309 0-6-2.692-6-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.011 12.132a3.993 3.993 0 0 0 3.877 3.877l-3.877-3.877z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMicrochip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 20V4h8l.001 16H8zM3 7h2V5H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1zM3 11h2V9H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1zM3 15h2v-2H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1zM3 19h2v-2H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMeteor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 22c2.003 0 3.887-.78 5.313-2.207l6.904-7.096A1 1 0 0 0 21 11h-3.301l4.175-7.514a1.001 1.001 0 0 0-1.359-1.36l-7.11 3.95.576-2.879a1 1 0 0 0-1.629-.957L4.196 9.197c-2.924 2.924-2.924 7.682 0 10.606A7.452 7.452 0 0 0 9.5 22zM5.552 10.665l5.902-5.031-.248 1.24-.186.93v.001l-.424 2.119 7.83-4.35-3.3 5.94-.001.001L14.301 13h4.331l-5.243 5.389C12.35 19.428 10.969 20 9.5 20s-2.851-.572-3.89-1.611c-2.143-2.144-2.143-5.634-.058-7.724z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 18a3.492 3.492 0 0 0 1.484-6.659c.005.053.016.105.016.159a1.5 1.5 0 1 1-3 0c0-.054.011-.106.016-.159A3.492 3.492 0 0 0 9.5 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707 12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293-1.414-1.414L12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v12a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 13c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageSquareX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.292 7.295 12 10.587 8.708 7.295 7.294 8.709l3.292 3.292-3.292 3.292 1.414 1.414L12 13.415l3.292 3.292 1.414-1.414-3.292-3.292 3.292-3.292z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageSquareMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageSquareError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v8h-2zm0 10h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageSquareEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14.987v1.999h1.999l5.529-5.522-1.998-1.998zm8.47-4.465-1.998-2L14.995 7l2 1.999z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageSquareDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v12a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 13c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v7z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "11.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "11.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageSquareDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h10v2H7zm0 4h7v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageSquareCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 13.586-2.293-2.293-1.414 1.414L11 16.414l6.207-6.207-1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageSquareAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageRounded(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.516 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageRoundedX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.293 6.293 12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293 1.414 1.414L12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageRoundedMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageRoundedError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zm0 6h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageRoundedEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.503 11.589v1.398h1.398l3.87-3.864-1.399-1.398zm5.927-3.125-1.398-1.398 1.067-1.067 1.398 1.398z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageRoundedDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "9.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "9.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.897 5.515 5 6.934V22l5.34-4.004C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.671 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageRoundedDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageRoundedCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.339-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.586 8.707 9.293l-1.414 1.414L11 14.414l6.207-6.207-1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageRoundedAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h-2v3H8v2h3v3h2v-3h3V9h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zm0 6h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.803 9.189-1.399-1.398-3.869 3.864v1.399h1.399zm.327-3.123 1.398 1.399-1.066 1.066-1.399-1.398z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.766L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.234V16H4V4h16v12z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.207 7.207-1.414-1.414L11 10.586 8.707 8.293 7.293 9.707 11 13.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageAltX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.586 18 12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707 12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293-1.414-1.414L12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageAltMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.586 18 12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageAltError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm14 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v6h-2zm0 7h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageAltEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.586 18 12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.479 7.219-4.977 4.969v1.799h1.8l4.975-4.969zm2.219-2.22 1.8 1.8-1.37 1.37-1.8-1.799z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageAltDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageAltDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm14 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageAltCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm2 0h14v12h-4.414L12 18.586 9.414 16H5V4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.207 7.207-1.414-1.414L11 10.586 8.707 8.293 7.293 9.707 11 13.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageAltAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMessageAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMerge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19v-9a2 2 0 0 0-2-2h-1v8a2 2 0 0 1-2 2H8v1a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMenu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMenuAltRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h16v2H4zm4 5h12v2H8zm5 5h7v2h-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMenuAltLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h12v2H4zm0-5h16v2H4zm0 12h7.235v-2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMemoryCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V8a.997.997 0 0 0-.293-.707l-5-5A.996.996 0 0 0 14 2H6c-1.103 0-2 .897-2 2zm14 4.414L18.001 20H6V4h7.586L18 8.414z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h2v4H8zm4 0h2v4h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMeh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.974 15H16v2H7.974z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMehBlank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMehAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h4v2h-4zm-6.026 5H16v2H7.974zM6 10h4v2H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMedal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c3.859 0 7-3.141 7-7s-3.141-7-7-7c-3.86 0-7 3.141-7 7s3.14 7 7 7zm0-12c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm-1-8H7v5.518a8.957 8.957 0 0 1 4-1.459V2zm6 0h-4v4.059a8.957 8.957 0 0 1 4 1.459V2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.019 15.811-.468 2.726L12 17.25l2.449 1.287-.468-2.726 1.982-1.932-2.738-.398L12 11l-1.225 2.481-2.738.398z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2H5v3H2v2h3v3h2V7h3V5H7V2zm7 3h8v2h-8zm0 10h8v2h-8zm0 4h8v2h-8zm-5.71-4.71L6 16.59l-2.29-2.3-1.42 1.42L4.59 18l-2.3 2.29 1.42 1.42L6 19.41l2.29 2.3 1.42-1.42L7.41 18l2.3-2.29-1.42-1.42z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H5C3.346 6 2 7.346 2 9v5c0 2.206 1.794 4 4 4h1.637c1.166 0 2.28-.557 2.981-1.491.66-.879 2.104-.88 2.764.001A3.744 3.744 0 0 0 16.363 18H18c2.206 0 4-1.794 4-4V9c0-1.654-1.346-3-3-3zm1 8c0 1.103-.897 2-2 2h-1.637c-.54 0-1.057-.259-1.382-.69-.71-.948-1.797-1.492-2.981-1.492s-2.271.544-2.981 1.491A1.741 1.741 0 0 1 7.637 16H6c-1.103 0-2-.897-2-2V9c0-.551.448-1 1-1h14c.552 0 1 .449 1 1v5z"
                },
                "child": []
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "7.5",
                    "cy": "11.5",
                    "rx": "2.5",
                    "ry": "1.5"
                },
                "child": []
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "16.5",
                    "cy": "11.5",
                    "rx": "2.5",
                    "ry": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.42 21.814a.998.998 0 0 0 1.16 0C12.884 21.599 20.029 16.44 20 10c0-4.411-3.589-8-8-8S4 5.589 4 9.995c-.029 6.445 7.116 11.604 7.42 11.819zM12 4c3.309 0 6 2.691 6 6.005.021 4.438-4.388 8.423-6 9.73-1.611-1.308-6.021-5.294-6-9.735 0-3.309 2.691-6 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMapPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 17 1-2V9.858c1.721-.447 3-2 3-3.858 0-2.206-1.794-4-4-4S8 3.794 8 6c0 1.858 1.279 3.411 3 3.858V15l1 2zM10 6c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.267 10.563-.533 1.928C18.325 13.207 20 14.584 20 16c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.416 1.675-2.793 4.267-3.51l-.533-1.928C4.197 11.54 2 13.623 2 16c0 3.364 4.393 6 10 6s10-2.636 10-6c0-2.377-2.197-4.46-5.733-5.437z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMapAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.447 6.105-6-3a1 1 0 0 0-.895 0L9 5.882 3.447 3.105A1 1 0 0 0 2 4v13c0 .379.214.725.553.895l6 3a1 1 0 0 0 .895 0L15 18.118l5.553 2.776a.992.992 0 0 0 .972-.043c.295-.183.475-.504.475-.851V7c0-.379-.214-.725-.553-.895zM10 7.618l4-2v10.764l-4 2V7.618zm-6-2 4 2v10.764l-4-2V5.618zm16 12.764-4-2V5.618l4 2v10.764z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7H9a1 1 0 0 0-1 1v7h2v7h4v-7h2V8a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMaleSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11V4h-7l2.793 2.793-4.322 4.322A5.961 5.961 0 0 0 8 10c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6c0-1.294-.416-2.49-1.115-3.471l4.322-4.322L20 11zM8 20c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMaleFemale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H3a1 1 0 0 0-1 1v7h2v7h4v-7h2V8a1 1 0 0 0-1-1z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.21 7.73a1 1 0 0 0-1-.73h-4.5a1 1 0 0 0-1 .73L12 14h2l-1 4h2v4h4v-4h2l-1-4h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMailSend(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H6c-1.103 0-2 .897-2 2v5h2V8l6.4 4.8a1.001 1.001 0 0 0 1.2 0L20 8v9h-8v2h8c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-7 6.75L6.666 6h12.668L13 10.75z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h7v2H2zm2 3h6v2H4zm3 3h4v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiMagnet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-3c-1.103 0-2 .897-2 2v8c0 1.103-.897 2-2 2s-2-.897-2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v8c0 4.963 4.037 9 9 9s9-4.037 9-9V5c0-1.103-.897-2-2-2zm-3 2h3v3h-3V5zM5 5h3v3H5V5zm7 15c-3.859 0-7-3.141-7-7v-3h3v3c0 2.206 1.794 4 4 4s4-1.794 4-4v-3h3v3c0 3.859-3.141 7-7 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLowVision(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.998c-1.836 0-3.356.389-4.617.971L3.707 2.293 2.293 3.707l3.315 3.316c-2.613 1.952-3.543 4.618-3.557 4.66l-.105.316.105.316C2.073 12.382 4.367 19 12 19c1.835 0 3.354-.389 4.615-.971l3.678 3.678 1.414-1.414-3.317-3.317c2.614-1.952 3.545-4.618 3.559-4.66l.105-.316-.105-.316c-.022-.068-2.316-6.686-9.949-6.686zM4.074 12c.103-.236.274-.586.521-.989l5.867 5.867C6.249 16.23 4.523 13.035 4.074 12zm9.247 4.907-7.48-7.481a8.138 8.138 0 0 1 1.188-.982l8.055 8.054a8.835 8.835 0 0 1-1.763.409zm3.648-1.352-1.541-1.541c.354-.596.572-1.28.572-2.015 0-.474-.099-.924-.255-1.349A.983.983 0 0 1 15 11a1 1 0 0 1-1-1c0-.439.288-.802.682-.936A3.97 3.97 0 0 0 12 7.999c-.735 0-1.419.218-2.015.572l-1.07-1.07A9.292 9.292 0 0 1 12 6.998c5.351 0 7.425 3.847 7.926 5a8.573 8.573 0 0 1-2.957 3.557z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13v-2H7V8l-5 4 5 4v-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-9c-1.103 0-2 .897-2 2v4h2V5h9v14h-9v-4H9v4c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogOutCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 12 5 4v-3h9v-2H7V8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.001 2.999a8.938 8.938 0 0 0-6.364 2.637L8.051 7.05c1.322-1.322 3.08-2.051 4.95-2.051s3.628.729 4.95 2.051 2.051 3.08 2.051 4.95-.729 3.628-2.051 4.95-3.08 2.051-4.95 2.051-3.628-.729-4.95-2.051l-1.414 1.414c1.699 1.7 3.959 2.637 6.364 2.637s4.665-.937 6.364-2.637c1.7-1.699 2.637-3.959 2.637-6.364s-.937-4.665-2.637-6.364a8.938 8.938 0 0 0-6.364-2.637z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13 16 5-4-5-4v3H4v2h9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-9c-1.103 0-2 .897-2 2v4h2V5h9v14h-9v-4H9v4c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogInCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.998 16 5-4-5-4v3h-9v2h9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.999 2.999a8.938 8.938 0 0 0-6.364 2.637L8.049 7.05c1.322-1.322 3.08-2.051 4.95-2.051s3.628.729 4.95 2.051S20 10.13 20 12s-.729 3.628-2.051 4.95-3.08 2.051-4.95 2.051-3.628-.729-4.95-2.051l-1.414 1.414c1.699 1.7 3.959 2.637 6.364 2.637s4.665-.937 6.364-2.637C21.063 16.665 22 14.405 22 12s-.937-4.665-2.637-6.364a8.938 8.938 0 0 0-6.364-2.637z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C9.243 2 7 4.243 7 7v2H6c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v2H9V7zm9.002 13H13v-2.278c.595-.347 1-.985 1-1.722 0-1.103-.897-2-2-2s-2 .897-2 2c0 .736.405 1.375 1 1.722V20H6v-9h12l.002 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLockOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.654 0 3 1.346 3 3h2c0-2.757-2.243-5-5-5S7 4.243 7 7v2H6c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2H9V7c0-1.654 1.346-3 3-3zm6.002 16H13v-2.278c.595-.347 1-.985 1-1.722 0-1.103-.897-2-2-2s-2 .897-2 2c0 .736.405 1.375 1 1.722V20H6v-9h12l.002 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLockOpenAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8V7c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3v1h2zm1 4 .002 8H6v-8h12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLockAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C9.243 2 7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zm6 10 .002 8H6v-8h12zm-9-2V7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLocationPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.42 21.815a1.004 1.004 0 0 0 1.16 0C12.884 21.598 20.029 16.44 20 10c0-4.411-3.589-8-8-8S4 5.589 4 9.996c-.029 6.444 7.116 11.602 7.42 11.819zM12 4c3.309 0 6 2.691 6 6.004.021 4.438-4.388 8.423-6 9.731-1.611-1.308-6.021-5.293-6-9.735 0-3.309 2.691-6 6-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLoader(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11h5v2H2zm15 0h5v2h-5zm-6 6h2v5h-2zm0-15h2v5h-2zM4.222 5.636l1.414-1.414 3.536 3.536-1.414 1.414zm15.556 12.728-1.414 1.414-3.536-3.536 1.414-1.414zm-12.02-3.536 1.414 1.414-3.536 3.536-1.414-1.414zm7.07-7.071 3.536-3.535 1.414 1.415-3.536 3.535z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLoaderCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "20",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.343",
                    "cy": "17.657",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.657",
                    "cy": "6.343",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "12",
                    "r": "2.001"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.343",
                    "cy": "6.344",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.657",
                    "cy": "17.658",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLoaderAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiListUl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v2H4zm0 5h2v2H4zm0 5h2v2H4zm16-8V6H8.023v2H18.8zM8 11h12v2H8zm0 5h12v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiListPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15v-3h-2v3h-3v2h3v3h2v-3h3v-2h-.937zM4 7h11v2H4zm0 4h11v2H4zm0 4h8v2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiListOl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.282 12.064c-.428.328-.72.609-.875.851-.155.24-.249.498-.279.768h2.679v-.748H5.413c.081-.081.152-.151.212-.201.062-.05.182-.142.361-.27.303-.218.511-.42.626-.604.116-.186.173-.375.173-.578a.898.898 0 0 0-.151-.512.892.892 0 0 0-.412-.341c-.174-.076-.419-.111-.733-.111-.3 0-.537.038-.706.114a.889.889 0 0 0-.396.338c-.094.143-.159.346-.194.604l.894.076c.025-.188.074-.317.147-.394a.375.375 0 0 1 .279-.108c.11 0 .2.035.272.108a.344.344 0 0 1 .108.258.55.55 0 0 1-.108.297c-.074.102-.241.254-.503.453zm.055 6.386a.398.398 0 0 1-.282-.105c-.074-.07-.128-.195-.162-.378L4 18.085c.059.204.142.372.251.506.109.133.248.235.417.306.168.069.399.103.692.103.3 0 .541-.047.725-.14a1 1 0 0 0 .424-.403c.098-.175.146-.354.146-.544a.823.823 0 0 0-.088-.393.708.708 0 0 0-.249-.261 1.015 1.015 0 0 0-.286-.11.943.943 0 0 0 .345-.299.673.673 0 0 0 .113-.383.747.747 0 0 0-.281-.596c-.187-.159-.49-.238-.909-.238-.365 0-.648.072-.847.219-.2.143-.334.353-.404.626l.844.151c.023-.162.067-.274.133-.338s.151-.098.257-.098a.33.33 0 0 1 .241.089c.059.06.087.139.087.238 0 .104-.038.193-.117.27s-.177.112-.293.112a.907.907 0 0 1-.116-.011l-.045.649a1.13 1.13 0 0 1 .289-.056c.132 0 .237.041.313.126.077.082.115.199.115.352 0 .146-.04.266-.119.354a.394.394 0 0 1-.301.134zm.948-10.083V5h-.739a1.47 1.47 0 0 1-.394.523c-.168.142-.404.262-.708.365v.754a2.595 2.595 0 0 0 .937-.48v2.206h.904zM9 6h11v2H9zm0 5h11v2H9zm0 5h11v2H9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiListMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.063 15H13v2h9v-2zM4 7h11v2H4zm0 4h11v2H4zm0 4h7v2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiListCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h11v2H4zm0 4h11v2H4zm0 4h7v2H4zm15.299-2.708-4.3 4.291-1.292-1.291-1.414 1.415 2.706 2.704 5.712-5.703z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLira(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h2c4.411 0 8-4.038 8-9h-2c0 3.86-2.691 7-6 7v-7.358l6-1.385V8.204l-6 1.385V7.642l6-1.385V4.204l-6 1.385V3H9v3.05l-3 .693v2.053l3-.692v1.947l-3 .692v2.053l3-.692V21z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLinkExternal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLinkAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.222 19.778a4.983 4.983 0 0 0 3.535 1.462 4.986 4.986 0 0 0 3.536-1.462l2.828-2.829-1.414-1.414-2.828 2.829a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.829-2.828-1.414-1.414-2.829 2.828a5.006 5.006 0 0 0 0 7.071zm15.556-8.485a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0L9.879 7.051l1.414 1.414 2.828-2.829a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.829 2.828 1.414 1.414 2.829-2.828z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.464 16.95-1.415-1.414 8.487-8.486 1.414 1.415z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLineChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v17a1 1 0 0 0 1 1h17v-2H5V3H3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.293 14.707a.999.999 0 0 0 1.414 0l5-5-1.414-1.414L16 12.586l-2.293-2.293a.999.999 0 0 0-1.414 0l-5 5 1.414 1.414L13 12.414l2.293 2.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLineChartDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3H3v18h18v-2H5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.586 8.707 8.293 7.293 9.707 13 15.414l3-3 4.293 4.293 1.414-1.414L16 9.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLike(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-5.612l1.123-3.367c.202-.608.1-1.282-.275-1.802S14.253 2 13.612 2H12c-.297 0-.578.132-.769.36L6.531 8H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h13.307a2.01 2.01 0 0 0 1.873-1.298l2.757-7.351A1 1 0 0 0 22 12v-2c0-1.103-.897-2-2-2zM4 10h2v9H4v-9zm16 1.819L17.307 19H8V9.362L12.468 4h1.146l-1.562 4.683A.998.998 0 0 0 13 10h7v1.819z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLibrary(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3h2v18H7zM4 3h2v18H4zm6 0h2v18h-2zm9.062 17.792-6.223-16.89 1.877-.692 6.223 16.89z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLemon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a9.83 9.83 0 0 1-3.26-.55 2.23 2.23 0 0 0-1.7.19 3.51 3.51 0 0 1-2.47.24 3.55 3.55 0 0 1-2.45-2.45A3.51 3.51 0 0 1 2.36 17a2.23 2.23 0 0 0 .19-1.7 10.07 10.07 0 0 1 0-6.53 9.87 9.87 0 0 1 6.18-6.23 10.07 10.07 0 0 1 6.53 0A2.23 2.23 0 0 0 17 2.36a3.51 3.51 0 0 1 2.47-.24 3.55 3.55 0 0 1 2.45 2.45A3.51 3.51 0 0 1 21.64 7a2.23 2.23 0 0 0-.19 1.7 10.07 10.07 0 0 1 0 6.53 9.87 9.87 0 0 1-6.19 6.19A10.33 10.33 0 0 1 12 22zm-3.84-2.64a3.91 3.91 0 0 1 1.23.2 8 8 0 0 0 5.24 0 7.84 7.84 0 0 0 4.94-4.93 8 8 0 0 0 0-5.24 4.19 4.19 0 0 1 .29-3.23 1.53 1.53 0 0 0 .09-1.08 1.49 1.49 0 0 0-1-1 1.53 1.53 0 0 0-1.08.09 4.19 4.19 0 0 1-3.23.29 8 8 0 0 0-5.24 0 7.84 7.84 0 0 0-4.97 4.91 8 8 0 0 0 0 5.24 4.19 4.19 0 0 1-.29 3.23 1.53 1.53 0 0 0-.09 1.08 1.49 1.49 0 0 0 1 1 1.53 1.53 0 0 0 1.08-.09 4.47 4.47 0 0 1 2.03-.47z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12H6a6 6 0 0 1 6-6v2a4 4 0 0 0-4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLeftTopArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.993 2.007a9.928 9.928 0 0 0-7.071 2.922c-3.899 3.899-3.899 10.243 0 14.143a9.931 9.931 0 0 0 7.071 2.923 9.928 9.928 0 0 0 7.071-2.923c3.899-3.899 3.899-10.243 0-14.143a9.927 9.927 0 0 0-7.071-2.922zm5.657 15.65a7.945 7.945 0 0 1-5.657 2.337c-2.141 0-4.15-.83-5.657-2.337-3.119-3.119-3.119-8.195 0-11.314a7.946 7.946 0 0 1 5.657-2.336c2.142 0 4.15.829 5.657 2.336 3.12 3.119 3.12 8.195 0 11.314z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.657 9H8.993v5.663l2.125-2.124 3.215 3.214 1.414-1.414-3.215-3.214z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLeftIndent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h10v2H4zm0-4h16v2H4zm0 8h10v2H4zm0 4h10v2H4zm0 4h16v2H4zm16-3V8l-4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLeftDownArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.006 2.007A9.93 9.93 0 0 0 4.935 4.93c-3.898 3.898-3.898 10.242 0 14.142 1.885 1.885 4.396 2.923 7.071 2.923s5.187-1.038 7.071-2.923c3.898-3.899 3.898-10.243 0-14.142a9.931 9.931 0 0 0-7.071-2.923zm5.657 15.65c-1.507 1.507-3.516 2.337-5.657 2.337s-4.15-.83-5.657-2.337c-3.118-3.119-3.118-8.194 0-11.313 1.507-1.507 3.517-2.337 5.657-2.337s4.15.83 5.657 2.337c3.118 3.119 3.118 8.194 0 11.313z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.346 8.247-3.215 3.215-2.125-2.125V15h5.663l-2.124-2.124 3.215-3.215z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLeftArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.464 2.114a.998.998 0 0 0-1.033.063l-13 9a1.003 1.003 0 0 0 0 1.645l13 9A1 1 0 0 0 19 21V3a1 1 0 0 0-.536-.886zM17 19.091 6.757 12 17 4.909v14.182z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLeftArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.999 1.993C6.486 1.994 2 6.48 1.999 11.994c0 5.514 4.486 10 10.001 10 5.514-.001 10-4.487 10-10 0-5.514-4.486-10-10.001-10.001zM12 19.994c-4.412 0-8.001-3.589-8.001-8 .001-4.411 3.59-8 8-8.001C16.411 3.994 20 7.583 20 11.994c0 4.41-3.589 7.999-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.012 7.989-4.005 4.005 4.005 4.004v-3.004h3.994v-2h-3.994z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLeftArrowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.707 17.293 8.414 13H18v-2H8.414l4.293-4.293-1.414-1.414L4.586 12l6.707 6.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.88 2.15-1.2.4a13.84 13.84 0 0 1-6.41.64 11.87 11.87 0 0 0-6.68.9A7.23 7.23 0 0 0 3.3 9.5a8.65 8.65 0 0 0 1.47 6.6c-.06.21-.12.42-.17.63A22.6 22.6 0 0 0 4 22h2a30.69 30.69 0 0 1 .59-4.32 9.25 9.25 0 0 0 4.52 1.11 11 11 0 0 0 4.28-.87C23 14.67 22 3.86 22 3.41zm-7.27 13.93c-2.61 1.11-5.73.92-7.48-.45a13.79 13.79 0 0 1 1.21-2.84A10.17 10.17 0 0 1 9.73 11a9 9 0 0 1 1.81-1.42A12 12 0 0 1 16 8V7a11.43 11.43 0 0 0-5.26 1.08 10.28 10.28 0 0 0-4.12 3.65 15.07 15.07 0 0 0-1 1.87 7 7 0 0 1-.38-3.73 5.24 5.24 0 0 1 3.14-4 8.93 8.93 0 0 1 3.82-.84c.62 0 1.23.06 1.87.11a16.2 16.2 0 0 0 6-.35C20 7.55 19.5 14 14.61 16.08z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLayout(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 2 .001 4H5V5h14zM5 11h8v8H5v-8zm10 8v-8h4.001l.001 8H15z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLayer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.999a1 1 0 0 0-.516-.874l-9.022-5a1.003 1.003 0 0 0-.968 0l-8.978 4.96a1 1 0 0 0-.003 1.748l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5A1 1 0 0 0 22 7.999zm-9.977 3.855L5.06 7.965l6.917-3.822 6.964 3.859-6.918 3.852z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.515 11.126 12 15.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.515 15.126 12 19.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLayerPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.484 11.125-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749zm-9.461 4.73-6.964-3.89 6.917-3.822 6.964 3.859-6.917 3.853z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a.994.994 0 0 0 .485-.126l9-5-.971-1.748L12 19.856l-8.515-4.73-.971 1.748 9 5A1 1 0 0 0 12 22zm8-20h-2v2h-2v2h2v2h2V6h2V4h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLayerMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.513 12.833 9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749l-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749zm9.464-4.69 6.964 3.859-6.917 3.853-6.964-3.89 6.917-3.822z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.485 15.126-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856l-8.515-4.73zM16 4h6v2h-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLaugh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4zm5.555-9.168-1.109-1.664-3 2a1.001 1.001 0 0 0 .108 1.727l4 2 .895-1.789-2.459-1.229 1.565-1.045zm-6.557 1.23a1 1 0 0 0-.443-.894l-3-2-1.11 1.664 1.566 1.044-2.459 1.229.895 1.789 4-2a.998.998 0 0 0 .551-.832z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLastPage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.707 17.707 13.414 12 7.707 6.293 6.293 7.707 10.586 12l-4.293 4.293zM15 6h2v12h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLaptop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.722c.595-.347 1-.985 1-1.722V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v11c0 .736.405 1.375 1 1.722V18H2v2h20v-2h-2v-.278zM5 16V5h14l.002 11H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLandscape(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20h18a1 1 0 0 0 .864-1.504l-7-12c-.359-.615-1.369-.613-1.729 0L9.866 12.1l-1.02-1.632A.998.998 0 0 0 8 10h-.001a1 1 0 0 0-.847.47l-5 8A1 1 0 0 0 3 20zM14 8.985 19.259 18h-5.704l-2.486-3.987L14 8.985zm-5.999 3.9L11.197 18H4.805l3.196-5.115zM6 8c1.654 0 3-1.346 3-3S7.654 2 6 2 3 3.346 3 5s1.346 3 3 3zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLabel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.813 4.419A.997.997 0 0 0 16 4H3a1 1 0 0 0-.813 1.581L6.771 12l-4.585 6.419A1 1 0 0 0 3 20h13a.997.997 0 0 0 .813-.419l5-7a.997.997 0 0 0 0-1.162l-5-7zM15.485 18H4.943l3.87-5.419a.997.997 0 0 0 0-1.162L4.943 6h10.542l4.286 6-4.286 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiKnife(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.66 3.6a3 3 0 0 0-4.24 0l-.71.71-7.07 7.07 2.12 2.12-6.36 6.36 1.41 1.42L19.66 6.43c1.1-1.1 1.1-1.73.71-2.12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17a5.007 5.007 0 0 0 4.898-4H14v2h2v-2h2v3h2v-3h1v-2h-9.102A5.007 5.007 0 0 0 7 7c-2.757 0-5 2.243-5 5s2.243 5 5 5zm0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiJoystick(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8.65A5 5 0 0 0 17 4H7a5 5 0 0 0-5 4.74A2 2 0 0 0 2 9v7.5A3.48 3.48 0 0 0 5.5 20c1.43 0 2.32-1.06 3.19-2.09.32-.37.65-.76 1-1.1a4.81 4.81 0 0 1 1.54-.75 6.61 6.61 0 0 1 1.54 0 4.81 4.81 0 0 1 1.54.75c.35.34.68.73 1 1.1.87 1 1.76 2.09 3.19 2.09a3.48 3.48 0 0 0 3.5-3.5V9a2.09 2.09 0 0 0 0-.26zm-2 7.85a1.5 1.5 0 0 1-1.5 1.5c-.5 0-1-.64-1.66-1.38-.34-.39-.72-.85-1.15-1.26a6.68 6.68 0 0 0-2.46-1.25 6.93 6.93 0 0 0-2.46 0 6.68 6.68 0 0 0-2.46 1.25c-.43.41-.81.87-1.15 1.26C6.54 17.36 6 18 5.5 18A1.5 1.5 0 0 1 4 16.5V9a.77.77 0 0 0 0-.15A3 3 0 0 1 7 6h10a3 3 0 0 1 3 2.72v.12A.86.86 0 0 0 20 9z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "10",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "10",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiJoystickButton(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v3H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-3h3c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm0 8h-5v4h.001v1H9v-5H4V9h5V4h6v5h5v6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14v-4l-3 2zm8 0 3-2-3-2zm-6-6h4l-2-3zm2 11 2-3h-4z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiJoystickAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "11",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9H8v2H6v2h2v2h2v-2h2v-2h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5H9a7 7 0 0 0-7 7 7 7 0 0 0 7 7h6a7 7 0 0 0 7-7 7 7 0 0 0-7-7zm0 12H9A5 5 0 1 1 9 7h6a5 5 0 1 1 0 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiItalic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7V4H9v3h2.868L9.012 17H5v3h10v-3h-2.868l2.856-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiIntersect(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2zm9.001-2L14 10h.001v4zM19 10l.001 9H10v-3h4c1.103 0 2-.897 2-2v-4h3zM5 5h9v3h-4c-1.103 0-2 .897-2 2v4H5V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiInjection(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 7.4 22.25 6 18 1.75l-1.4 1.41L18 4.58 16.6 6l-2.13-2.13-1.41-1.42-1.41 1.42.7.71L3 13.92a2 2 0 0 0-.3 2.45L4 18.56l-2.25 2.28 1.41 1.41L5.44 20l2.19 1.31a2 2 0 0 0 1 .28 2 2 0 0 0 1.45-.59l9.34-9.34.71.7 1.42-1.41-1.42-1.42L18 7.4 19.42 6zM18 10.23l-9.34 9.35L6 18l-1.58-2.66.86-.87 2.83 2.83 1.42-1.41-2.83-2.83 1.41-1.41 2.83 2.82 1.41-1.41-2.83-2.83 1.42-1.41 2.83 2.83 1.41-1.42-2.83-2.83L13.77 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiInfoSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H5V5h14v14z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2zm0 4h2v6h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiInfoCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h2v6h-2zm0-4h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiInfinite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7c-2.094 0-3.611 1.567-5.001 3.346C10.609 8.567 9.093 7 7 7c-2.757 0-5 2.243-5 5a4.98 4.98 0 0 0 1.459 3.534A4.956 4.956 0 0 0 6.99 17h.012c2.089-.005 3.605-1.572 4.996-3.351C13.389 15.431 14.906 17 17 17c2.757 0 5-2.243 5-5s-2.243-5-5-5zM6.998 15l-.008 1v-1c-.799 0-1.55-.312-2.114-.878A3.004 3.004 0 0 1 7 9c1.33 0 2.56 1.438 3.746 2.998C9.558 13.557 8.328 14.997 6.998 15zM17 15c-1.33 0-2.561-1.44-3.749-3.002C14.438 10.438 15.668 9 17 9c1.654 0 3 1.346 3 3s-1.346 3-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiImport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 18 4-5h-3V2h-2v11H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4v2h4v9H5v-9h4V9H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiImages(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 12-1-1-2 3h10l-4-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.499",
                    "cy": "9.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.499 14-1.5-2-3 4h12l-4.5-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.999 4h-16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-16 14V6h16l.002 12H3.999z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiImageAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 14-1-1-3 4h12l-5-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiImageAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5h13v7h2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8v-2H4V5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 11-3 4h11l-4-6-3 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiIdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.715 12c1.151 0 2-.849 2-2s-.849-2-2-2-2 .849-2 2 .848 2 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .841-2 1.875v12.25C2 19.159 2.897 20 4 20h16c1.103 0 2-.841 2-1.875V5.875C22 4.841 21.103 4 20 4zm0 14-16-.011V6l16 .011V18z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h4v2h-4zm1 4h3v2h-3zm-1.57 2.536c0-1.374-1.676-2.786-3.715-2.786S6 14.162 6 15.536V16h7.43v-.464z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHourglass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.566 11.021A7.016 7.016 0 0 0 19 5V4h1V2H4v2h1v1a7.016 7.016 0 0 0 3.434 6.021c.354.208.566.545.566.9v.158c0 .354-.212.69-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h16v-2h-1v-1a7.014 7.014 0 0 0-3.433-6.02c-.355-.21-.567-.547-.567-.901v-.158c0-.355.212-.692.566-.9zm-1.015 3.681A5.008 5.008 0 0 1 17 19v1H7v-1a5.01 5.01 0 0 1 2.45-4.299c.971-.573 1.55-1.554 1.55-2.622v-.158c0-1.069-.58-2.051-1.551-2.623A5.008 5.008 0 0 1 7 5V4h10v1c0 1.76-.938 3.406-2.449 4.298C13.58 9.87 13 10.852 13 11.921v.158c0 1.068.579 2.049 1.551 2.623z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHotel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "11.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.205 7H12a1 1 0 0 0-1 1v7H4V6H2v14h2v-3h16v3h2v-8.205A4.8 4.8 0 0 0 17.205 7zM13 15V9h4.205A2.798 2.798 0 0 1 20 11.795V15h-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHorizontalRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11H5v2h8v3l4-4-4-4v3zM19 3h2v3h-2zM19 8h2v3h-2zM19 13h2v3h-2zM19 18h2v3h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHorizontalLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11 8-4 4 4 4v-3h8v-2h-8V8zM3 18h2v3H3zM3 13h2v3H3zM3 8h2v3H3zM3 3h2v3H3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHorizontalCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.005 15.995 4-4-4-4v3h-3v2h3zm14-5v-3l-4 4 4 4v-3h3v-2h-2.072zm-8 7h2v3h-2zm0-5h2v3h-2zm0-5h2v3h-2zm0-5h2v3h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm7 7v-5h4v5h-4zm2-15.586 6 6V15l.001 5H16v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H6v-9.586l6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHomeSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm9-8.586 6 6V15l.001 5H6v-9.586l6-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c3.703 0 4.901-3.539 4.95-3.689l-1.9-.621c-.008.023-.781 2.31-3.05 2.31-2.238 0-3.02-2.221-3.051-2.316l-1.899.627C7.099 14.461 8.297 18 12 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHomeHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.223 11.641-.223.22-.224-.22a2.224 2.224 0 0 0-3.125 0 2.13 2.13 0 0 0 0 3.07L12 18l3.349-3.289a2.13 2.13 0 0 0 0-3.07 2.225 2.225 0 0 0-3.126 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 11.293-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707zM18.001 20H6v-9.585l6-6 6 6V15l.001 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHomeCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm9-8.586 6 6V15l.001 5H6v-9.585l6-6.001z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHomeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHomeAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.71 2.29a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 0 1.42A1 1 0 0 0 3 13h1v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7h1a1 1 0 0 0 1-1 1 1 0 0 0-.29-.71zM6 20v-9.59l6-6 6 6V20z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.895 7.553-2-4A1.001 1.001 0 0 0 18 3h-5c-.379 0-.725.214-.895.553L10.382 7H6c-.379 0-.725.214-.895.553l-2 4a1 1 0 0 0 0 .895l2 4c.17.338.516.552.895.552h4.382l1.724 3.447A.998.998 0 0 0 13 21h5c.379 0 .725-.214.895-.553l2-4a1 1 0 0 0 0-.895L19.118 12l1.776-3.553a1 1 0 0 0 .001-.894zM13.618 5h3.764l1.5 3-1.5 3h-3.764l-1.5-3 1.5-3zm-8.5 7 1.5-3h3.764l1.5 3-1.5 3H6.618l-1.5-3zm12.264 7h-3.764l-1.5-3 1.5-3h3.764l1.5 3-1.5 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHistory(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v5h5v-2h-3V8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.292 8.497a8.957 8.957 0 0 0-1.928-2.862 9.004 9.004 0 0 0-4.55-2.452 9.09 9.09 0 0 0-3.626 0 8.965 8.965 0 0 0-4.552 2.453 9.048 9.048 0 0 0-1.928 2.86A8.963 8.963 0 0 0 4 12l.001.025H2L5 16l3-3.975H6.001L6 12a6.957 6.957 0 0 1 1.195-3.913 7.066 7.066 0 0 1 1.891-1.892 7.034 7.034 0 0 1 2.503-1.054 7.003 7.003 0 0 1 8.269 5.445 7.117 7.117 0 0 1 0 2.824 6.936 6.936 0 0 1-1.054 2.503c-.25.371-.537.72-.854 1.036a7.058 7.058 0 0 1-2.225 1.501 6.98 6.98 0 0 1-1.313.408 7.117 7.117 0 0 1-2.823 0 6.957 6.957 0 0 1-2.501-1.053 7.066 7.066 0 0 1-1.037-.855l-1.414 1.414A8.985 8.985 0 0 0 13 21a9.05 9.05 0 0 0 3.503-.707 9.009 9.009 0 0 0 3.959-3.26A8.968 8.968 0 0 0 22 12a8.928 8.928 0 0 0-.708-3.503z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHighlight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.707 5.826-3.535-3.533a.999.999 0 0 0-1.408-.006L7.096 10.82a1.01 1.01 0 0 0-.273.488l-1.024 4.437L4 18h2.828l1.142-1.129 3.588-.828c.18-.042.345-.133.477-.262l8.667-8.535a1 1 0 0 0 .005-1.42zm-9.369 7.833-2.121-2.12 7.243-7.131 2.12 2.12-7.242 7.131zM4 20h16v2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c.946 0 1.81-.103 2.598-.281l-1.757-1.757c-.273.021-.55.038-.841.038-5.351 0-7.424-3.846-7.926-5a8.642 8.642 0 0 1 1.508-2.297L4.184 8.305c-1.538 1.667-2.121 3.346-2.132 3.379a.994.994 0 0 0 0 .633C2.073 12.383 4.367 19 12 19zm0-14c-1.837 0-3.346.396-4.604.981L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.319-3.319c2.614-1.951 3.547-4.615 3.561-4.657a.994.994 0 0 0 0-.633C21.927 11.617 19.633 5 12 5zm4.972 10.558-2.28-2.28c.19-.39.308-.819.308-1.278 0-1.641-1.359-3-3-3-.459 0-.888.118-1.277.309L8.915 7.501A9.26 9.26 0 0 1 12 7c5.351 0 7.424 3.846 7.926 5-.302.692-1.166 2.342-2.954 3.558z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHelpCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a3.939 3.939 0 0 0-3.934 3.934h2C10.066 8.867 10.934 8 12 8s1.934.867 1.934 1.934c0 .598-.481 1.032-1.216 1.626a9.208 9.208 0 0 0-.691.599c-.998.997-1.027 2.056-1.027 2.174V15h2l-.001-.633c.001-.016.033-.386.441-.793.15-.15.339-.3.535-.458.779-.631 1.958-1.584 1.958-3.182A3.937 3.937 0 0 0 12 6zm-1 10h2v2h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.595a5.904 5.904 0 0 0-3.996-1.558 5.942 5.942 0 0 0-4.213 1.758c-2.353 2.363-2.352 6.059.002 8.412l7.332 7.332c.17.299.498.492.875.492a.99.99 0 0 0 .792-.409l7.415-7.415c2.354-2.354 2.354-6.049-.002-8.416a5.938 5.938 0 0 0-4.209-1.754A5.906 5.906 0 0 0 12 4.595zm6.791 1.61c1.563 1.571 1.564 4.025.002 5.588L12 18.586l-6.793-6.793c-1.562-1.563-1.561-4.017-.002-5.584.76-.756 1.754-1.172 2.799-1.172s2.035.416 2.789 1.17l.5.5a.999.999 0 0 0 1.414 0l.5-.5c1.512-1.509 4.074-1.505 5.584-.002z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHeartSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.998 17 4.186-4.186a2.745 2.745 0 0 0 0-3.907 2.746 2.746 0 0 0-3.907 0l-.278.279-.279-.279a2.746 2.746 0 0 0-3.907 0 2.746 2.746 0 0 0 0 3.907L11.998 17z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4zm-2 15H5V5h14v14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHeartCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.279 8.833 12 9.112l-.279-.279a2.745 2.745 0 0 0-3.906 0 2.745 2.745 0 0 0 0 3.907L12 16.926l4.186-4.186a2.745 2.745 0 0 0 0-3.907 2.746 2.746 0 0 0-3.907 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHealth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.649 5.286 14 8.548V2.025h-4v6.523L4.351 5.286l-2 3.465 5.648 3.261-5.648 3.261 2 3.465L10 15.477V22h4v-6.523l5.649 3.261 2-3.465-5.648-3.261 5.648-3.261z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHeadphone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12v-1.707c0-4.442-3.479-8.161-7.755-8.29-2.204-.051-4.251.736-5.816 2.256A7.933 7.933 0 0 0 4 10v2c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h2V10a5.95 5.95 0 0 1 1.821-4.306 5.977 5.977 0 0 1 4.363-1.691C15.392 4.099 18 6.921 18 10.293V20h2c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h2v8H7zm8 0h2v8h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHeading(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20V4h-3v6H9V4H6v16h3v-7h6v7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.983 13.821-1.851-10.18A1.998 1.998 0 0 0 18.165 2H5.835a2 2 0 0 0-1.968 1.643l-1.85 10.178.019.003c-.012.06-.036.114-.036.176v5c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-5c0-.063-.024-.116-.035-.176l.018-.003zM5.835 4h12.331l1.637 9H4.198l1.637-9zM4 19v-4h16l.002 4H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16h2v2h-2zm-3 0h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.018 3.815 15.232 8h-4.966l.716-3.815-1.964-.37L8.232 8H4v2h3.857l-.751 4H3v2h3.731l-.714 3.805 1.965.369L8.766 16h4.966l-.714 3.805 1.965.369.783-4.174H20v-2h-3.859l.751-4H21V8h-3.733l.716-3.815-1.965-.37zM14.106 14H9.141l.751-4h4.966l-.752 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHardHat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a9.11 9.11 0 0 0-.18-1.81 8.53 8.53 0 0 0-.53-1.69 8.08 8.08 0 0 0-.83-1.5 8.73 8.73 0 0 0-1.1-1.33A8.27 8.27 0 0 0 17 7.54a8.08 8.08 0 0 0-1.53-.83L15 6.52V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1.52l-.5.19a8.08 8.08 0 0 0-1.5.83 8.27 8.27 0 0 0-1.33 1.1A8.27 8.27 0 0 0 4.54 10a8.08 8.08 0 0 0-.83 1.53 9 9 0 0 0-.53 1.69A9.11 9.11 0 0 0 3 15v3H2v2h20v-2h-1zM5 15a7.33 7.33 0 0 1 .14-1.41 6.64 6.64 0 0 1 .41-1.31 7.15 7.15 0 0 1 .64-1.19 7.15 7.15 0 0 1 1.9-1.9A7.33 7.33 0 0 1 9 8.68V15h2V6h2v9h2V8.68a8.13 8.13 0 0 1 .91.51 7.09 7.09 0 0 1 1 .86 6.44 6.44 0 0 1 .85 1 6 6 0 0 1 .65 1.19 7.13 7.13 0 0 1 .41 1.31A7.33 7.33 0 0 1 19 15v3H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHappy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHappyHeartEyes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.535 12.634 2.05-2.083a1.485 1.485 0 0 0-.018-2.118 1.49 1.49 0 0 0-2.065-.034 1.488 1.488 0 0 0-2.067.068c-.586.6-.579 1.53.019 2.117l2.081 2.05zm7 0 2.05-2.083a1.485 1.485 0 0 0-.018-2.118 1.49 1.49 0 0 0-2.065-.034 1.488 1.488 0 0 0-2.068.067c-.586.6-.579 1.53.019 2.117l2.082 2.051z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHappyBeaming(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 12 2 .012c.012-.462.194-1.012 1-1.012s.988.55 1 1h2c0-1.206-.799-3-3-3s-3 1.794-3 3zm-5-1c.806 0 .988.55 1 1h2c0-1.206-.799-3-3-3s-3 1.794-3 3l2 .012C7.012 11.55 7.194 11 8 11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHappyAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "9.493",
                    "r": "1.493"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c5 0 6-5 6-5H6s1 5 6 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiHandicap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.98 14.804A1 1 0 0 0 16 14h-4.133l-.429-3H16V9h-4.847l-.163-1.142A1 1 0 0 0 10 7H9a1.003 1.003 0 0 0-.99 1.142l.877 6.142A2.009 2.009 0 0 0 10.867 16h4.313l.839 4.196c.094.467.504.804.981.804h3v-2h-2.181l-.839-4.196z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.51 17.5c-.739 1.476-2.25 2.5-4.01 2.5A4.505 4.505 0 0 1 4 15.5a4.503 4.503 0 0 1 2.817-4.167l-.289-2.025C3.905 10.145 2 12.604 2 15.5 2 19.084 4.916 22 8.5 22a6.497 6.497 0 0 0 5.545-3.126l-.274-1.374H12.51z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.604 11.048a5.67 5.67 0 0 0 .751-3.44c-.179-1.784-1.175-3.361-2.803-4.44l-1.105 1.666c1.119.742 1.8 1.799 1.918 2.974a3.693 3.693 0 0 1-1.072 2.986l-1.192 1.192 1.618.475C18.951 13.701 19 17.957 19 18h2c0-1.789-.956-5.285-4.396-6.952z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm1.5 7H8c-3.309 0-6 2.691-6 6v1h2v-1c0-2.206 1.794-4 4-4h3c2.206 0 4 1.794 4 4v1h2v-1c0-3.309-2.691-6-6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGrid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H4.984c-1.103 0-2 .897-2 2v14.016c0 1.103.897 2 2 2H19c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-4zm4 5h-3V5h3v3zM4.984 10h3v4.016h-3V10zm5 0H14v4.016H9.984V10zM16 10h3v4.016h-3V10zm-2-5v3H9.984V5H14zM7.984 5v3h-3V5h3zm-3 11.016h3v3h-3v-3zm5 3v-3H14v3H9.984zm6.016 0v-3h3.001v3H16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGridVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h4v4H7zm0-6h4v4H7zm0 12h4v4H7zm6-6h4v4h-4zm0-6h4v4h-4zm0 12h4v4h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGridSmall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h4v4H7zm0 6h4v4H7zm6-6h4v4h-4zm0 6h4v4h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGridHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7h4v4h-4zm6 0h4v4h-4zM4 7h4v4H4zm6 6h4v4h-4zm6 0h4v4h-4zM4 13h4v4H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGridAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm5 2h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4h-4V5zM3 20a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6zm2-5h4v4H5v-4zm8 5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6zm2-5h4v4h-4v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGlobe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9h-2.764a14.67 14.67 0 0 0-1.792-6.243A8.013 8.013 0 0 1 19.931 11zM12.53 4.027c1.035 1.364 2.427 3.78 2.627 6.973H9.03c.139-2.596.994-5.028 2.451-6.974.172-.01.344-.026.519-.026.179 0 .354.016.53.027zm-3.842.7C7.704 6.618 7.136 8.762 7.03 11H4.069a8.013 8.013 0 0 1 4.619-6.273zM4.069 13h2.974c.136 2.379.665 4.478 1.556 6.23A8.01 8.01 0 0 1 4.069 13zm7.381 6.973C10.049 18.275 9.222 15.896 9.041 13h6.113c-.208 2.773-1.117 5.196-2.603 6.972-.182.012-.364.028-.551.028-.186 0-.367-.016-.55-.027zm4.011-.772c.955-1.794 1.538-3.901 1.691-6.201h2.778a8.005 8.005 0 0 1-4.469 6.201z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGlobeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18.791V20H9v2h6v-2h-2v-1.845a9.934 9.934 0 0 0 3.071-2.084c3.898-3.898 3.898-10.243 0-14.143l-1.414 1.414c3.119 3.12 3.119 8.195 0 11.314-3.119 3.118-8.195 3.12-11.314 0L1.929 16.07A9.971 9.971 0 0 0 9 18.994a9.98 9.98 0 0 0 2-.203z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9c0 3.309 2.691 6 6 6s6-2.691 6-6-2.691-6-6-6-6 2.691-6 6zm10 0c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGlasses(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.977 13.783-2-9A1.002 1.002 0 0 0 19 4h-3v2h2.198l.961 4.326A4.467 4.467 0 0 0 17.5 10c-1.953 0-3.603 1.258-4.224 3h-2.553c-.621-1.742-2.271-3-4.224-3-.587 0-1.145.121-1.659.326L5.802 6H8V4H5a1 1 0 0 0-.976.783l-2 9 .047.011A4.552 4.552 0 0 0 2 14.5C2 16.981 4.019 19 6.5 19c2.31 0 4.197-1.756 4.449-4h2.102c.252 2.244 2.139 4 4.449 4 2.481 0 4.5-2.019 4.5-4.5 0-.242-.034-.475-.071-.706l.048-.011zM6.5 17C5.122 17 4 15.878 4 14.5S5.122 12 6.5 12 9 13.122 9 14.5 7.878 17 6.5 17zm11 0c-1.379 0-2.5-1.122-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGlassesAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.948 11.684-2-6A.997.997 0 0 0 19 5h-3v2h2.279l1.334 4H15c-1.103 0-2 .897-2 2h-2c0-1.103-.897-2-2-2H4.387l1.334-4H8V5H5a.998.998 0 0 0-.948.684l-2 6 .012.004A.928.928 0 0 0 2 12v4c0 1.654 1.346 3 3 3h3c1.654 0 3-1.346 3-3v-1h2v1c0 1.654 1.346 3 3 3h3c1.654 0 3-1.346 3-3v-4a.964.964 0 0 0-.063-.313l.011-.003zM9 16c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1v-3h5v3zm11 0c0 .551-.448 1-1 1h-3c-.552 0-1-.449-1-1v-3h5v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGitRepoForked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.559 8.855c.166 1.183.789 3.207 3.087 4.079C11 13.829 11 14.534 11 15v.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337V15c0-.466 0-1.171 2.354-2.065 2.298-.872 2.921-2.896 3.087-4.079C19.912 8.441 21 7.102 21 5.5 21 3.57 19.43 2 17.5 2S14 3.57 14 5.5c0 1.552 1.022 2.855 2.424 3.313-.146.735-.565 1.791-1.778 2.252-1.192.452-2.053.953-2.646 1.536-.593-.583-1.453-1.084-2.646-1.536-1.213-.461-1.633-1.517-1.778-2.252C8.978 8.355 10 7.052 10 5.5 10 3.57 8.43 2 6.5 2S3 3.57 3 5.5c0 1.602 1.088 2.941 2.559 3.355zM17.5 4c.827 0 1.5.673 1.5 1.5S18.327 7 17.5 7 16 6.327 16 5.5 16.673 4 17.5 4zm-4 14.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5.673-1.5 1.5-1.5 1.5.673 1.5 1.5zM6.5 4C7.327 4 8 4.673 8 5.5S7.327 7 6.5 7 5 6.327 5 5.5 5.673 4 6.5 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGitPullRequest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.01 15.163V7.997C19.005 6.391 17.933 4 15 4V2l-4 3 4 3V6c1.829 0 2.001 1.539 2.01 2v7.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337zm-1 4.837c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zM9.5 5.5C9.5 3.57 7.93 2 6 2S2.5 3.57 2.5 5.5c0 1.58 1.06 2.903 2.5 3.337v6.326c-1.44.434-2.5 1.757-2.5 3.337C2.5 20.43 4.07 22 6 22s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337V8.837C8.44 8.403 9.5 7.08 9.5 5.5zm-5 0C4.5 4.673 5.173 4 6 4s1.5.673 1.5 1.5S6.827 7 6 7s-1.5-.673-1.5-1.5zm3 13c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5S5.173 17 6 17s1.5.673 1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGitMerge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 18.5C2.5 20.43 4.07 22 6 22s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337v-3.488c.244.273.509.527.813.744 1.18.844 2.617 1.098 3.918 1.098.966 0 1.853-.14 2.506-.281a3.5 3.5 0 0 0 3.264 2.265c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5a3.5 3.5 0 0 0-3.404 2.718c-1.297.321-3.664.616-5.119-.426-.666-.477-1.09-1.239-1.306-2.236C8.755 7.96 9.5 6.821 9.5 5.5 9.5 3.57 7.93 2 6 2S2.5 3.57 2.5 5.5c0 1.58 1.06 2.903 2.5 3.337v6.326c-1.44.434-2.5 1.757-2.5 3.337zm15-8c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5S16 12.827 16 12s.673-1.5 1.5-1.5zm-10 8c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5S5.173 17 6 17s1.5.673 1.5 1.5zm-3-13C4.5 4.673 5.173 4 6 4s1.5.673 1.5 1.5S6.827 7 6 7s-1.5-.673-1.5-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGitCompare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.01 2c-1.93 0-3.5 1.57-3.5 3.5 0 1.58 1.06 2.903 2.5 3.337v7.16c-.001.179.027 1.781 1.174 2.931C6.892 19.64 7.84 20 9 20v2l4-3-4-3v2c-1.823 0-1.984-1.534-1.99-2V8.837c1.44-.434 2.5-1.757 2.5-3.337 0-1.93-1.571-3.5-3.5-3.5zm0 5c-.827 0-1.5-.673-1.5-1.5S5.183 4 6.01 4s1.5.673 1.5 1.5S6.837 7 6.01 7zm13 8.163V7.997C19.005 6.391 17.933 4 15 4V2l-4 3 4 3V6c1.829 0 2.001 1.539 2.01 2v7.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337zm-1 4.837c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGitCommit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-2.967 0-5.431 2.167-5.909 5H2v2h4.092c.479 2.832 2.942 4.998 5.909 4.998s5.43-2.166 5.909-4.998H22v-2h-4.09c-.478-2.833-2.942-5-5.91-5zm0 9.998c-2.205 0-3.999-1.794-3.999-3.999S9.795 8 12 8c2.206 0 4 1.794 4 3.999s-1.794 3.999-4 3.999z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGitBranch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 4C15.57 4 14 5.57 14 7.5c0 1.554 1.025 2.859 2.43 3.315-.146.932-.547 1.7-1.23 2.323-1.946 1.773-5.527 1.935-7.2 1.907V8.837c1.44-.434 2.5-1.757 2.5-3.337C10.5 3.57 8.93 2 7 2S3.5 3.57 3.5 5.5c0 1.58 1.06 2.903 2.5 3.337v6.326c-1.44.434-2.5 1.757-2.5 3.337C3.5 20.43 5.07 22 7 22s3.5-1.57 3.5-3.5c0-.551-.14-1.065-.367-1.529 2.06-.186 4.657-.757 6.409-2.35 1.097-.997 1.731-2.264 1.904-3.768C19.915 10.438 21 9.1 21 7.5 21 5.57 19.43 4 17.5 4zm-12 1.5C5.5 4.673 6.173 4 7 4s1.5.673 1.5 1.5S7.827 7 7 7s-1.5-.673-1.5-1.5zM7 20c-.827 0-1.5-.673-1.5-1.5a1.5 1.5 0 0 1 1.482-1.498l.13.01A1.495 1.495 0 0 1 7 20zM17.5 9c-.827 0-1.5-.673-1.5-1.5S16.673 6 17.5 6s1.5.673 1.5 1.5S18.327 9 17.5 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-1.209A4.92 4.92 0 0 0 19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H4c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm-4.5-3c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.478c.511-1.576 1.253-3 1.978-3zM7 5.5C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM4 9h7v2H4V9zm2 11v-7h5v7H6zm12 0h-5v-7h5v7zm-5-9V9.085L13.017 9H20l.001 2H13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGhost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.963 0-9 4.038-9 9v8h.051c.245 1.691 1.69 3 3.449 3 1.174 0 2.074-.417 2.672-1.174a3.99 3.99 0 0 0 5.668-.014c.601.762 1.504 1.188 2.66 1.188 1.93 0 3.5-1.57 3.5-3.5V11c0-4.962-4.037-9-9-9zm7 16.5c0 .827-.673 1.5-1.5 1.5-.449 0-1.5 0-1.5-2v-1h-2v1c0 1.103-.897 2-2 2s-2-.897-2-2v-1H8v1c0 1.845-.774 2-1.5 2-.827 0-1.5-.673-1.5-1.5V11c0-3.86 3.141-7 7-7s7 3.14 7 7v7.5z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGasPump(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.616 6.48.014-.017-4-3.24-1.26 1.554 2.067 1.674a2.99 2.99 0 0 0-1.395 3.058c.149.899.766 1.676 1.565 2.112.897.49 1.685.446 2.384.197L18.976 18a.996.996 0 0 1-1.39.922.995.995 0 0 1-.318-.217.996.996 0 0 1-.291-.705L17 16a2.98 2.98 0 0 0-.877-2.119A3 3 0 0 0 14 13h-1V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h7c1.103 0 2-.897 2-2v-4h1c.136 0 .267.027.391.078a1.028 1.028 0 0 1 .531.533A.994.994 0 0 1 15 16l-.024 2c0 .406.079.799.236 1.168.151.359.368.68.641.951a2.97 2.97 0 0 0 2.123.881c.406 0 .798-.078 1.168-.236.358-.15.68-.367.951-.641A2.983 2.983 0 0 0 20.976 18L21 9a2.997 2.997 0 0 0-1.384-2.52zM4 5h7l.001 4H4V5zm0 14v-8h7.001l.001 8H4zm14-9a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiGame(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.937 7.53C19.227 4.119 15.803 2 12 2 6.486 2 2 6.486 2 12s4.486 10 10 10c3.803 0 7.227-2.119 8.937-5.53a1 1 0 0 0-.397-1.316L15.017 12l5.522-3.153c.461-.264.636-.842.398-1.317zm-8.433 3.602a.999.999 0 0 0 0 1.736l6.173 3.525A7.949 7.949 0 0 1 12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8a7.95 7.95 0 0 1 6.677 3.606l-6.173 3.526z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "7.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFullscreen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h5V3H3v7h2zm5 14H5v-5H3v7h7zm11-5h-2v5h-5v2h7zm-2-4h2V3h-7v2h5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFridge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 2 .001 5H10V7H8v2H6V4h12zM6 20v-9h2v3h2v-3h8.001l.001 9H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFork(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.47 13.77-1.41-1.42 5.66-5.65-1.42-1.42-5.65 5.66-1.42-1.41 5.66-5.66-1.42-1.42-6.36 6.37a3 3 0 0 0 0 4.24l.71.71-6.37 6.36 1.42 1.42 6.36-6.37.71.71a3 3 0 0 0 4.24 0l6.37-6.36-1.42-1.42z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFootball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 4.929a9.936 9.936 0 0 0-7.07-2.938 9.943 9.943 0 0 0-7.072 2.938c-3.899 3.898-3.899 10.243 0 14.142a9.94 9.94 0 0 0 7.073 2.938 9.936 9.936 0 0 0 7.07-2.937c3.899-3.898 3.899-10.243-.001-14.143zM12.181 4h-.359c.061-.001.119-.009.18-.009s.118.008.179.009zm6.062 13H16l-1.258 2.516a7.956 7.956 0 0 1-2.741.493 7.96 7.96 0 0 1-2.746-.494L8 17.01H5.765a7.96 7.96 0 0 1-1.623-3.532L6 11 4.784 8.567a7.936 7.936 0 0 1 1.559-2.224 7.994 7.994 0 0 1 3.22-1.969L12 6l2.438-1.625a8.01 8.01 0 0 1 3.22 1.968 7.94 7.94 0 0 1 1.558 2.221L18 11l1.858 2.478A7.952 7.952 0 0 1 18.243 17z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 11 1.5 4h4l1.5-4L12 8.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFoodTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H5V5h14v14z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFoodMenu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h2v20H3zm7 4h7v2h-7zm0 4h7v2h-7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6v20h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 18H8V4h11v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFont(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.307 4-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16h-2.387zm-1.239 9L12.5 6.515 14.932 13h-4.864z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFontSize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m22 6-3-4-3 4h2v4h-2l3 4 3-4h-2V6zM9.307 4l-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16H9.307zm-1.239 9L10.5 6.515 12.932 13H8.068z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFontFamily(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h7v2h-7zm1 4h6v2h-6zm2 4h4v2h-4zM9.307 4l-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16H9.307zm-1.239 9L10.5 6.515 12.932 13H8.068z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFontColor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18h14v3H5zm7.5-14h-1c-.401 0-.764.24-.921.609L5.745 16h2.173l1.273-3h5.604l1.268 3h2.171L13.421 4.61A1 1 0 0 0 12.5 4zm-2.46 7 1.959-4.616L13.95 11h-3.91z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-8.586L9.707 3.293A.997.997 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFolderPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-8.586L9.707 3.293A.996.996 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.165 19.551c.186.28.499.449.835.449h15c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 11h-1V7c0-1.103-.897-2-2-2h-6.1L9.616 3.213A.997.997 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14h.007a1 1 0 0 0 .158.551zM17.341 18H4.517l2.143-5h12.824l-2.143 5zM18 7v4H6c-.4 0-.762.238-.919.606L4 14.129V7h14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFolderMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-8.586L9.707 3.293A.996.996 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.874 12h8v2h-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H6V2H4v18H3v2h4v-2H6v-5h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 9H6V6h12v7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFirstPage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.293 17.707 1.414-1.414L13.414 12l4.293-4.293-1.414-1.414L10.586 12zM7 6h2v12H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFirstAid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM9 4h6v2H9V4zM4 18V8h16l.001 10H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFingerprint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.962 17.674C7 19.331 7 20.567 7 22h2c0-1.521 0-3.244-1.343-5.389l-1.695 1.063zM16.504 3.387C13.977 1.91 7.55.926 4.281 4.305c-3.368 3.481-2.249 9.072.001 11.392.118.122.244.229.369.333.072.061.146.116.205.184l1.494-1.33a3.918 3.918 0 0 0-.419-.391c-.072-.06-.146-.119-.214-.188-1.66-1.711-2.506-6.017.001-8.608 2.525-2.611 8.068-1.579 9.777-.581 2.691 1.569 4.097 4.308 4.109 4.333l1.789-.895c-.065-.135-1.668-3.289-4.889-5.167z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.34 12.822c-1.03-1.26-1.787-2.317-1.392-3.506.263-.785.813-1.325 1.637-1.604 1.224-.41 2.92-.16 4.04.601l1.123-1.654c-1.648-1.12-3.982-1.457-5.804-.841-1.408.476-2.435 1.495-2.892 2.866-.776 2.328.799 4.254 1.74 5.405.149.183.29.354.409.512C11 18.323 11 20.109 11 22h2c0-2.036 0-4.345-3.201-8.601a19.71 19.71 0 0 0-.459-.577zm5.791-3.344c1.835 1.764 3.034 4.447 3.889 8.701l1.961-.395c-.939-4.678-2.316-7.685-4.463-9.748l-1.387 1.442z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.556 9.169-1.115 1.66c.027.019 2.711 1.88 3.801 5.724l1.924-.545c-1.299-4.582-4.476-6.749-4.61-6.839zm3.132 9.29c.21 1.168.312 2.326.312 3.541h2c0-1.335-.112-2.608-.343-3.895l-1.969.354z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFilter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h10v2H7zM4 7h16v2H4zm6 8h4v2h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFilterAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H5a1 1 0 0 0-1 1v2.59c0 .523.213 1.037.583 1.407L10 13.414V21a1.001 1.001 0 0 0 1.447.895l4-2c.339-.17.553-.516.553-.895v-5.586l5.417-5.417c.37-.37.583-.884.583-1.407V4a1 1 0 0 0-1-1zm-6.707 9.293A.996.996 0 0 0 14 13v5.382l-2 1V13a.996.996 0 0 0-.293-.707L6 6.59V5h14.001l.002 1.583-5.71 5.71z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM9 11V5h6v6H9zm6 2v6H9v-6h6zM5 5h2v2H5V5zm0 4h2v2H5V9zm0 4h2v2H5v-2zm0 4h2v2H5v-2zm14.002 2H17v-2h2.002v2zm-.001-4H17v-2h2.001v2zm0-4H17V9h2.001v2zM17 7V5h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.903 8.586a.997.997 0 0 0-.196-.293l-6-6a.997.997 0 0 0-.293-.196c-.03-.014-.062-.022-.094-.033a.991.991 0 0 0-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a.952.952 0 0 0-.051-.259c-.01-.032-.019-.063-.033-.093zM16.586 8H14V5.414L16.586 8zM6 20V4h6v5a1 1 0 0 0 1 1h5l.002 10H6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8v2H8zm0 4h8v2H8zm0-8h2v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFileFind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 2.293A.996.996 0 0 0 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9a.996.996 0 0 0-.293-.707l-6-6zM6 4h6.586L18 9.414l.002 9.174-2.568-2.568c.35-.595.566-1.281.566-2.02 0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4c.739 0 1.425-.216 2.02-.566L16.586 20H6V4zm6 12c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFileBlank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.937 8.68c-.011-.032-.02-.063-.033-.094a.997.997 0 0 0-.196-.293l-6-6a.997.997 0 0 0-.293-.196c-.03-.014-.062-.022-.094-.033a.991.991 0 0 0-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a.99.99 0 0 0-.05-.258zM16.586 8H14V5.414L16.586 8zM6 20V4h6v5a1 1 0 0 0 1 1h5l.002 10H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFemale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.948 7.684A.997.997 0 0 0 14 7h-4a.998.998 0 0 0-.948.684l-2 6 1.775.593L8 18h2v4h4v-4h2l-.827-3.724 1.775-.593-2-5.999z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFemaleSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.691 2 6 4.691 6 8c0 2.967 2.167 5.432 5 5.91V17H8v2h3v2.988h2V19h3v-2h-3v-3.09c2.833-.479 5-2.943 5-5.91 0-3.309-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFastForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 12-7-5v10zM5 7v10l7-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFastForwardCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 16 5-4-5-4zm-6 0 5-4-5-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiFace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 2c3.213 0 5.982 1.908 7.254 4.648a7.8 7.8 0 0 1-.895-.498c-.409-.258-.873-.551-1.46-.772-.669-.255-1.4-.378-2.234-.378s-1.565.123-2.234.377c-.587.223-1.051.516-1.472.781-.378.237-.703.443-1.103.594C9.41 8.921 8.926 9 8.33 9c-.595 0-1.079-.079-1.524-.248-.4-.151-.728-.358-1.106-.598-.161-.101-.34-.208-.52-.313C6.587 5.542 9.113 4 12 4zm0 16c-4.411 0-8-3.589-8-8 0-.81.123-1.59.348-2.327.094.058.185.11.283.173.411.26.876.554 1.466.776.669.255 1.399.378 2.233.378.833 0 1.564-.123 2.235-.377.587-.223 1.051-.516 1.472-.781.378-.237.703-.443 1.103-.595.445-.168.929-.247 1.525-.247s1.08.079 1.525.248c.399.15.725.356 1.114.602.409.258.873.551 1.46.773.363.138.748.229 1.153.291.049.357.083.717.083 1.086 0 4.411-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "13.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "13.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiExtension(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10V7c0-1.103-.897-2-2-2h-3c0-1.654-1.346-3-3-3S8 3.346 8 5H5c-1.103 0-2 .897-2 2v3.881l.659.239C4.461 11.41 5 12.166 5 13s-.539 1.59-1.341 1.88L3 15.119V19c0 1.103.897 2 2 2h3.881l.239-.659C9.41 19.539 10.166 19 11 19s1.59.539 1.88 1.341l.239.659H17c1.103 0 2-.897 2-2v-3c1.654 0 3-1.346 3-3s-1.346-3-3-3zm0 4h-2l-.003 5h-2.545c-.711-1.22-2.022-2-3.452-2s-2.741.78-3.452 2H5v-2.548C6.22 15.741 7 14.43 7 13s-.78-2.741-2-3.452V7h5V5a1 1 0 0 1 2 0v2h5v5h2a1 1 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiExport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h2V7h3l-4-5-4 5h3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-4v2h4v9H5v-9h4V9H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiExpand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21 15.344-2.121 2.121-3.172-3.172-1.414 1.414 3.172 3.172L15.344 21H21zM3 8.656l2.121-2.121 3.172 3.172 1.414-1.414-3.172-3.172L8.656 3H3zM21 3h-5.656l2.121 2.121-3.172 3.172 1.414 1.414 3.172-3.172L21 8.656zM3 21h5.656l-2.121-2.121 3.172-3.172-1.414-1.414-3.172 3.172L3 15.344z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiExpandVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 19.24-4.95-4.95-1.41 1.42L12 22.07l6.36-6.36-1.41-1.42L12 19.24zM5.64 8.29l1.41 1.42L12 4.76l4.95 4.95 1.41-1.42L12 1.93 5.64 8.29z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiExpandHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.29 5.64 1.93 12l6.36 6.36 1.42-1.41L4.76 12l4.95-4.95-1.42-1.41zm6 1.41L19.24 12l-4.95 4.95 1.42 1.41L22.07 12l-6.36-6.36-1.42 1.41z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiExpandAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H3v9h9v-2H5zm7-7h7v7h2V3h-9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiExit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.002 3h-14c-1.103 0-2 .897-2 2v4h2V5h14v14h-14v-4h-2v4c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.898-2-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 16 5-4-5-4v3.001H3v2h8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiExitFullscreen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4H8v4H4v2h6zM8 20h2v-6H4v2h4zm12-6h-6v6h2v-4h4zm0-6h-4V4h-2v6h6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiExclude(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2zm-4 7H9V9h6v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiEuro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.464 6c1.43 0 2.779.613 3.799 1.726l1.475-1.352C17.334 4.843 15.461 4 13.464 4c-1.998 0-3.87.843-5.272 2.375A8.034 8.034 0 0 0 6.589 9H4v2h2.114c-.038.33-.064.663-.064 1s.026.67.064 1H4v2h2.589c.362.97.901 1.861 1.603 2.626C9.594 19.157 11.466 20 13.464 20c1.997 0 3.87-.843 5.273-2.374l-1.475-1.352C16.243 17.387 14.894 18 13.464 18s-2.778-.612-3.798-1.726A5.937 5.937 0 0 1 8.801 15H13v-2H8.139c-.05-.328-.089-.66-.089-1s.039-.672.089-1H13V9H8.801c.24-.457.516-.893.865-1.274C10.686 6.613 12.034 6 13.464 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.001 10h2v5h-2zM11 16h2v2h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.768 4.2C13.42 3.545 12.742 3.138 12 3.138s-1.42.407-1.768 1.063L2.894 18.064a1.986 1.986 0 0 0 .054 1.968A1.984 1.984 0 0 0 4.661 21h14.678c.708 0 1.349-.362 1.714-.968a1.989 1.989 0 0 0 .054-1.968L13.768 4.2zM4.661 19 12 5.137 19.344 19H4.661z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiErrorCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v7h-2zm0 8h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiErrorAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v7h-2zm0 8h2v2h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 7.293-5-5A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707zM20 15.586 15.586 20H8.414L4 15.586V8.414L8.414 4h7.172L20 8.414v7.172z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiEraser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.586 15.408 4.299 4.299a.996.996 0 0 0 .707.293h12.001v-2h-6.958l7.222-7.222c.78-.779.78-2.049 0-2.828L14.906 3a2.003 2.003 0 0 0-2.828 0l-4.75 4.749-4.754 4.843a2.007 2.007 0 0 0 .012 2.816zM13.492 4.414l4.95 4.95-2.586 2.586L10.906 7l2.586-2.586zM8.749 9.156l.743-.742 4.95 4.95-4.557 4.557a1.026 1.026 0 0 0-.069.079h-1.81l-4.005-4.007 4.748-4.837z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiEqualizer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v6h-2zm4-3h2v12h-2zM7 4h2v16H7zm12 7h2v2h-2zM3 10h2v4H3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044 20.002 18H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.555 8.168-9-6a1 1 0 0 0-1.109 0l-9 6A1 1 0 0 0 2 9v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V9c0-.334-.167-.646-.445-.832zM12 4.202 19.197 9 12 13.798 4.803 9 12 4.202zM4 20v-9.131l7.445 4.963a1 1 0 0 0 1.11 0L20 10.869 19.997 20H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 17.013 4.413-.015 9.632-9.54c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.756-.756-2.075-.752-2.825-.003L7 12.583v4.43zM18.045 4.458l1.589 1.583-1.597 1.582-1.586-1.585 1.594-1.58zM9 13.417l6.03-5.973 1.586 1.586-6.029 5.971L9 15.006v-1.589z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2v-8.668l-2 2V19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiEditAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDuplicate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10H9v3H6v2h3v3h2v-3h3v-2h-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h12c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2zM4 8h12l.002 12H4V8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8v2h12v12h2V4c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDumbbell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5v14h3v-6h6v6h3V5h-3v6H9V5zM3 15a1 1 0 0 0 1 1h1V8H4a1 1 0 0 0-1 1v2H2v2h1v2zm18-6a1 1 0 0 0-1-1h-1v8h1a1 1 0 0 0 1-1v-2h1v-2h-1V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDroplet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c4.636 0 8-3.468 8-8.246C20 7.522 12.882 2.4 12.579 2.185a1 1 0 0 0-1.156-.001C11.12 2.397 4 7.503 4 13.75 4 18.53 7.364 22 12 22zm-.001-17.74C13.604 5.55 18 9.474 18 13.754 18 17.432 15.532 20 12 20s-6-2.57-6-6.25c0-4.29 4.394-8.203 5.999-9.49z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDrink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.832 4.555A1 1 0 0 0 20 3H4a1 1 0 0 0-.832 1.554L11 16.303V20H8v2h8v-2h-3v-3.697l7.832-11.748zM12 14.197 8.535 9h6.93L12 14.197zM18.132 5l-1.333 2H7.201L5.868 5h12.264z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDownvote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.901 10.566A1.001 1.001 0 0 0 20 10h-4V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v7H4a1.001 1.001 0 0 0-.781 1.625l8 10a1 1 0 0 0 1.562 0l8-10c.24-.301.286-.712.12-1.059zM12 19.399 6.081 12H10V4h4v8h3.919L12 19.399z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 4-5h-3V4h-2v7H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDownArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.886 5.536A1.002 1.002 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13a.998.998 0 0 0 1.644 0l9-13a.998.998 0 0 0 .064-1.033zM12 17.243 4.908 7h14.184L12 17.243z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDownArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1.993C6.486 1.994 2 6.48 2 11.994c0 5.513 4.486 9.999 10 10 5.514 0 10-4.486 10-10s-4.485-10-10-10.001zm0 18.001c-4.411-.001-8-3.59-8-8 0-4.411 3.589-8 8-8.001 4.411.001 8 3.59 8 8.001s-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8h-2v4H7.991l4.005 4.005L16 12h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDownArrowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.707 12.707-1.414-1.414L13 15.586V6h-2v9.586l-4.293-4.293-1.414 1.414L12 19.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDoughnutChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9h-3.032A5.013 5.013 0 0 0 13 7.102V4.069A8.008 8.008 0 0 1 19.931 11zM12 9c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 11c-4.411 0-8-3.589-8-8 0-4.072 3.061-7.436 7-7.931v3.032A5.009 5.009 0 0 0 7 12c0 2.757 2.243 5 5 5a5.007 5.007 0 0 0 4.898-4h3.032c-.494 3.939-3.858 7-7.93 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDotsVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10h4v4h-4zm0-6h4v4h-4zm0 12h4v4h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDotsVerticalRounded(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDotsHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10h4v4h-4zm6 0h4v4h-4zM4 10h4v4H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDotsHorizontalRounded(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDoorOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.385 21.788a.997.997 0 0 0 .857.182l8-2A.999.999 0 0 0 20 19V5a1 1 0 0 0-.758-.97l-8-2A1.003 1.003 0 0 0 10 3v1H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4v1c0 .308.142.599.385.788zM12 4.281l6 1.5v12.438l-6 1.5V4.281zM7 18V6h3v12H7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.242 13.159c.446-.112.758-.512.758-.971v-.377a1 1 0 1 0-2 .001v.377a1 1 0 0 0 1.242.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDonateHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h9.62a3.995 3.995 0 0 0 3.037-1.397l5.102-5.952a1 1 0 0 0-.442-1.6l-1.968-.656a3.043 3.043 0 0 0-2.823.503l-3.185 2.547-.617-1.235A3.98 3.98 0 0 0 9.146 11H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h5.146c.763 0 1.448.423 1.789 1.105l.447.895H7v2h6.014a.996.996 0 0 0 .442-.11l.003-.001.004-.002h.003l.002-.001h.004l.001-.001c.009.003.003-.001.003-.001.01 0 .002-.001.002-.001h.001l.002-.001.003-.001.002-.001.002-.001.003-.001.002-.001c.003 0 .001-.001.002-.001l.003-.002.002-.001.002-.001.003-.001.002-.001h.001l.002-.001h.001l.002-.001.002-.001c.009-.001.003-.001.003-.001l.002-.001a.915.915 0 0 0 .11-.078l4.146-3.317c.262-.208.623-.273.94-.167l.557.186-4.133 4.823a2.029 2.029 0 0 1-1.52.688H4v-6zM16 2h-.017c-.163.002-1.006.039-1.983.705-.951-.648-1.774-.7-1.968-.704L12.002 2h-.004c-.801 0-1.555.313-2.119.878C9.313 3.445 9 4.198 9 5s.313 1.555.861 2.104l3.414 3.586a1.006 1.006 0 0 0 1.45-.001l3.396-3.568C18.688 6.555 19 5.802 19 5s-.313-1.555-.878-2.121A2.978 2.978 0 0 0 16.002 2H16zm1 3c0 .267-.104.518-.311.725L14 8.55l-2.707-2.843C11.104 5.518 11 5.267 11 5s.104-.518.294-.708A.977.977 0 0 1 11.979 4c.025.001.502.032 1.067.485.081.065.163.139.247.222l.707.707.707-.707c.084-.083.166-.157.247-.222.529-.425.976-.478 1.052-.484a.987.987 0 0 1 .701.292c.189.189.293.44.293.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDonateBlood(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h9.62a3.995 3.995 0 0 0 3.037-1.397l5.102-5.952a1 1 0 0 0-.442-1.6l-1.968-.656a3.043 3.043 0 0 0-2.823.503l-3.185 2.547-.617-1.235A3.98 3.98 0 0 0 9.146 11H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h5.146c.763 0 1.448.423 1.789 1.105l.447.895H7v2h6.014a.996.996 0 0 0 .442-.11l.003-.001.004-.002h.003l.002-.001h.004l.001-.001c.011.003.003-.001.003-.001.012 0 .002-.001.002-.001h.001l.002-.001.003-.001.002-.001.002-.001.003-.001.002-.001.002-.001.003-.002.002-.001.002-.001.003-.001.002-.001h.001l.002-.001h.001l.002-.001.002-.001c.011-.001.003-.001.003-.001l.002-.001a.915.915 0 0 0 .11-.078l4.146-3.317c.261-.208.623-.273.94-.167l.557.186-4.133 4.823a2.029 2.029 0 0 1-1.52.688H4v-6zm9.761-10.674C13.3 2.832 11 5.457 11 7.5c0 1.93 1.57 3.5 3.5 3.5S18 9.43 18 7.5c0-2.043-2.3-4.668-2.761-5.174-.379-.416-1.099-.416-1.478 0zM16 7.5c0 .827-.673 1.5-1.5 1.5S13 8.327 13 7.5c0-.708.738-1.934 1.5-2.934.762 1 1.5 2.226 1.5 2.934z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.999 8.5h2c0-2.837-2.755-4.131-5-4.429V2h-2v2.071c-2.245.298-5 1.592-5 4.429 0 2.706 2.666 4.113 5 4.43v4.97c-1.448-.251-3-1.024-3-2.4h-2c0 2.589 2.425 4.119 5 4.436V22h2v-2.07c2.245-.298 5-1.593 5-4.43s-2.755-4.131-5-4.429V6.1c1.33.239 3 .941 3 2.4zm-8 0c0-1.459 1.67-2.161 3-2.4v4.799c-1.371-.253-3-1.002-3-2.399zm8 7c0 1.459-1.67 2.161-3 2.4v-4.8c1.33.239 3 .941 3 2.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDollarCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDockTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v3H5V5zM5 19v-9h14v9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDockRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 5h9v14H5zm11 14V5h3v14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDockLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 5h3v14H5zm5 14V5h9v14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDockBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v9H5V5zM5 19v-3h14v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDna(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.794 11.09c.332-.263.648-.542.947-.84l.136-.142c.283-.293.552-.598.801-.919l.062-.075c.255-.335.486-.688.702-1.049l.128-.22c.205-.364.395-.737.559-1.123.02-.047.035-.095.055-.142.147-.361.274-.731.383-1.109.021-.07.044-.14.063-.211.107-.402.189-.813.251-1.229.013-.087.021-.175.032-.263.051-.432.087-.869.087-1.311V2h-2v.457c0 .184-.031.361-.042.543H6.022C6.012 2.819 6 2.64 6 2.457V2H4v.457c0 4.876 3.269 9.218 7.952 10.569l.028.009c2.881.823 5.056 3.146 5.769 5.965H6.251l.799-2h7.607a7.416 7.416 0 0 0-2.063-2h-4c.445-.424.956-.774 1.491-1.09a9.922 9.922 0 0 1-2.08-1.014C5.55 14.812 4 17.779 4 21.015V23h2v-1.985L6.001 21h11.998l.001.015V23h2v-1.985c0-3.83-2.159-7.303-5.443-9.07a11.1 11.1 0 0 0 1.072-.729c.055-.042.11-.082.165-.126zm-1.19-1.604a8.945 8.945 0 0 1-2.325 1.348c-.092.036-.185.068-.278.102A8.95 8.95 0 0 1 8.836 9h6.292c-.171.161-.332.333-.517.48l-.007.006zM17.619 5c-.005.016-.007.033-.012.049l-.044.151a9.089 9.089 0 0 1-.513 1.252c-.096.19-.213.365-.321.548h-9.48a9.066 9.066 0 0 1-.871-2h11.241z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDizzy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.707 12.293 9.414 11l1.293-1.293-1.414-1.414L8 9.586 6.707 8.293 5.293 9.707 6.586 11l-1.293 1.293 1.414 1.414L8 12.414l1.293 1.293zm6.586-4L16 9.586l-1.293-1.293-1.414 1.414L14.586 11l-1.293 1.293 1.414 1.414L16 12.414l1.293 1.293 1.414-1.414L17.414 11l1.293-1.293zM10 16h4v2h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDislike(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H6.693A2.01 2.01 0 0 0 4.82 4.298l-2.757 7.351A1 1 0 0 0 2 12v2c0 1.103.897 2 2 2h5.612L8.49 19.367a2.004 2.004 0 0 0 .274 1.802c.376.52.982.831 1.624.831H12c.297 0 .578-.132.769-.36l4.7-5.64H20c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-8.469 17h-1.145l1.562-4.684A1 1 0 0 0 11 14H4v-1.819L6.693 5H16v9.638L11.531 20zM18 14V5h2l.001 9H18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15c0-4.625-3.507-8.441-8-8.941V4h-2v2.059c-4.493.5-8 4.316-8 8.941v2h18v-2zM5 15c0-3.859 3.141-7 7-7s7 3.141 7 7H5zm-3 3h20v2H2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDisc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDirections(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.781 13.875-2-2.5A1 1 0 0 0 19 11h-6V9h6c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5a1 1 0 0 0-.781.375l-2 2.5a1.001 1.001 0 0 0 0 1.25l2 2.5A1 1 0 0 0 5 9h6v2H5c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h6v4h2v-4h6a1 1 0 0 0 .781-.375l2-2.5a1.001 1.001 0 0 0 0-1.25zM4.281 5.5 5.48 4H19l.002 3H5.48L4.281 5.5zM18.52 16H5v-3h13.52l1.2 1.5-1.2 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDice6(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "12",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDice5(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDice4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDice3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDice2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "12",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "12",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDice1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDiamond(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.813 3.838A2 2 0 0 0 16.187 3H7.813c-.644 0-1.252.313-1.667.899l-4 6.581a.999.999 0 0 0 .111 1.188l9 10a.995.995 0 0 0 1.486.001l9-10a.997.997 0 0 0 .111-1.188l-4.041-6.643zM12 19.505 5.245 12h13.509L12 19.505zM4.777 10l3.036-5 8.332-.062L19.222 10H4.777z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDialpad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3h4v3h-4zm0 5h4v3h-4zm0 5h4v3h-4zm6-10h4v3h-4zm0 5h4v3h-4zm0 5h4v3h-4zM4 3h4v3H4zm0 5h4v3H4zm0 5h4v3H4zm6 5h4v3h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDialpadAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDevices(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H7c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM9.997 19H4V9h6l-.003 10zm10-2H12V9c0-1.103-.897-2-2-2H7V5h13l-.003 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V5h16l.002 14H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h12v2H6zm0 4h12v2H6zm0 4h6v2H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiDesktop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h7v2H8v2h8v-2h-3v-2h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 14V5h16l.002 9H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiData(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17V7c0-2.168-3.663-4-8-4S4 4.832 4 7v10c0 2.168 3.663 4 8 4s8-1.832 8-4zM12 5c3.691 0 5.931 1.507 6 1.994C17.931 7.493 15.691 9 12 9S6.069 7.493 6 7.006C6.069 6.507 8.309 5 12 5zM6 9.607C7.479 10.454 9.637 11 12 11s4.521-.546 6-1.393v2.387c-.069.499-2.309 2.006-6 2.006s-5.931-1.507-6-2V9.607zM6 17v-2.393C7.479 15.454 9.637 16 12 16s4.521-.546 6-1.393v2.387c-.069.499-2.309 2.006-6 2.006s-5.931-1.507-6-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCylinder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.131 0 9-1.935 9-4.5V7h-.053c.033-.164.053-.33.053-.5C21 3.935 17.131 2 12 2 7.209 2 3.52 3.688 3.053 6H3v11.5c0 2.565 3.869 4.5 9 4.5zm0-2c-4.273 0-7-1.48-7-2.5V9.394C6.623 10.387 9.111 11 12 11s5.377-.613 7-1.606V17.5c0 1.02-2.727 2.5-7 2.5zm0-16c4.273 0 7 1.48 7 2.5S16.273 9 12 9 5 7.52 5 6.5 7.727 4 12 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCycling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15.414V20h2v-4.586c0-.526-.214-1.042-.586-1.414l-2-2L13 9.414l2 2c.372.372.888.586 1.414.586H20v-2h-3.586l-3.707-3.707a.999.999 0 0 0-1.414 0L8 9.586c-.378.378-.586.88-.586 1.414s.208 1.036.586 1.414l3 3z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "5",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM6 22c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6.5C10 4.57 8.43 3 6.5 3S3 4.57 3 6.5 4.57 10 6.5 10a3.45 3.45 0 0 0 1.613-.413l2.357 2.528-2.318 2.318A3.46 3.46 0 0 0 6.5 14C4.57 14 3 15.57 3 17.5S4.57 21 6.5 21s3.5-1.57 3.5-3.5c0-.601-.166-1.158-.434-1.652l2.269-2.268L17 19.121a3 3 0 0 0 2.121.879H22L9.35 8.518c.406-.572.65-1.265.65-2.018zM6.5 8C5.673 8 5 7.327 5 6.5S5.673 5 6.5 5 8 5.673 8 6.5 7.327 8 6.5 8zm0 11c-.827 0-1.5-.673-1.5-1.5S5.673 16 6.5 16s1.5.673 1.5 1.5S7.327 19 6.5 19z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 4.879-3.707 4.414 1.414 1.414L22 4h-2.879A3 3 0 0 0 17 4.879z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCustomize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4H5V5zm15-2h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6zm-5-6h4v4H5v-4zm13-1h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCurrentLocation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.069V2h-2v2.069A8.01 8.01 0 0 0 4.069 11H2v2h2.069A8.008 8.008 0 0 0 11 19.931V22h2v-2.069A8.007 8.007 0 0 0 19.931 13H22v-2h-2.069A8.008 8.008 0 0 0 13 4.069zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCuboid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8c-.414 0-.785.255-.934.641l-5 13a.999.999 0 0 0 .227 1.066l5 5A.996.996 0 0 0 8 22h8c.414 0 .785-.255.934-.641l5-13a.999.999 0 0 0-.227-1.066l-5-5zM18.585 7h-5.171l-3-3h5.172l2.999 3zM8.381 4.795l3.438 3.438-4.462 10.71-3.19-3.191L8.381 4.795zM15.313 20h-6.23l4.583-11h5.878l-4.231 11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.406 6.086-9-4a1.001 1.001 0 0 0-.813 0l-9 4c-.02.009-.034.024-.054.035-.028.014-.058.023-.084.04-.022.015-.039.034-.06.05a.87.87 0 0 0-.19.194c-.02.028-.041.053-.059.081a1.119 1.119 0 0 0-.076.165c-.009.027-.023.052-.031.079A1.013 1.013 0 0 0 2 7v10c0 .396.232.753.594.914l9 4c.13.058.268.086.406.086a.997.997 0 0 0 .402-.096l.004.01 9-4A.999.999 0 0 0 22 17V7a.999.999 0 0 0-.594-.914zM12 4.095 18.538 7 12 9.905l-1.308-.581L5.463 7 12 4.095zM4 16.351V8.539l7 3.111v7.811l-7-3.11zm9 3.11V11.65l7-3.111v7.812l-7 3.11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCubeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.895 3.553A1.001 1.001 0 0 0 17 3H7c-.379 0-.725.214-.895.553l-4 8a1 1 0 0 0 0 .895l4 8c.17.338.516.552.895.552h10c.379 0 .725-.214.895-.553l4-8a1 1 0 0 0 0-.895l-4-7.999zM19.382 11h-7.764l-3-6h7.764l3 6zM4.118 12 7 6.236 9.882 12 7 17.764 4.118 12zm12.264 7H8.618l3-6h7.764l-3 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.219 3.375 8 7.399 4.781 3.375A1.002 1.002 0 0 0 3 4v15c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4a1.002 1.002 0 0 0-1.781-.625L16 7.399l-3.219-4.024c-.381-.474-1.181-.474-1.562 0zM5 19v-2h14.001v2H5zm10.219-9.375c.381.475 1.182.475 1.563 0L19 6.851 19.001 15H5V6.851l2.219 2.774c.381.475 1.182.475 1.563 0L12 5.601l3.219 4.024z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCrosshair(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 17.931V17h-2v2.931A8.008 8.008 0 0 1 4.069 13H7v-2H4.069A8.008 8.008 0 0 1 11 4.069V7h2V4.069A8.007 8.007 0 0 1 19.931 11H17v2h2.931A8.008 8.008 0 0 1 13 19.931z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCross(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h2v7h-2zm0 13h2v7h-2zm4-4h7v2h-7zM2 11h7v2H2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCrop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.103-.897-2-2-2H7V2H5v3H2v2h15v15h2v-3h3v-2h-3V7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9v8c0 1.103.897 2 2 2h8v-2H7V9H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCricketBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93A10 10 0 0 0 4.93 19.07 10 10 0 0 0 19.07 4.93zM6.34 6.34a8 8 0 0 1 8.78-1.71l-.29.3.71.71.52-.53a9.53 9.53 0 0 1 .84.57L5.68 16.9a9.53 9.53 0 0 1-.57-.84l.53-.52-.71-.71-.29.29a8 8 0 0 1 1.7-8.78zm11.32 11.32a8 8 0 0 1-8.78 1.71l.29-.3-.71-.71-.52.53a9.53 9.53 0 0 1-.84-.57L18.32 7.1a9.53 9.53 0 0 1 .57.84l-.53.52.71.71.29-.29a8 8 0 0 1-1.7 8.78zm-6.37-2.12.71.7-1.41 1.42-.71-.66zm2.83-2.83.71.7-1.42 1.42-.7-.71zM17 9.88l.71.71L16.24 12l-.7-.71zm-4.29-1.42-.71-.7 1.41-1.42.71.71zm-2.83 2.83-.71-.7 1.42-1.42.7.71zm-2.83 2.83-.71-.71L7.76 12l.7.71z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 6h16v2H4V6zm0 12v-6h16.001l.001 6H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h6v2H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCreditCardFront(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.001 12H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 11h3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5zM6 14h6v2.001H6zm7 0h5v2.001h-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCreditCardAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "13.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.5c0-.815.396-1.532 1-1.988A2.47 2.47 0 0 0 11.5 11a2.5 2.5 0 1 0 0 5 2.47 2.47 0 0 0 1.5-.512 2.486 2.486 0 0 1-1-1.988z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCopyright(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.421 0 10-4.579 10-10S17.421 2 12 2 2 6.579 2 12s4.579 10 10 10zm0-18c4.337 0 8 3.663 8 8s-3.663 8-8 8-8-3.663-8-8 3.663-8 8-8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c.901 0 2.581-.168 3.707-1.292l-1.414-1.416C13.85 14.735 12.992 15 12 15c-1.626 0-3-1.374-3-3s1.374-3 3-3c.993 0 1.851.265 2.293.707l1.414-1.414C14.582 7.168 12.901 7 12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCopyAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h6v2H6zm0 4h6v2H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.683 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.035 6.035 0 0 0 3.542-.35 6.048 6.048 0 0 0 1.907-1.284c.272-.271.52-.571.734-.889l-1.658-1.119a4.147 4.147 0 0 1-.489.592z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 2c2.953 0 5.531 1.613 6.918 4H5.082C6.469 5.613 9.047 4 12 4zm0 16c-4.411 0-8-3.589-8-8 0-.691.098-1.359.264-2H5v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2h2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1h.736c.166.641.264 1.309.264 2 0 4.411-3.589 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCookie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3.003-2.937.005-.034.016-.136.017-.17a.998.998 0 0 0-1.254-1.006A2.963 2.963 0 0 1 15 7c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.716a1 1 0 0 0-1.067-1.236A9.956 9.956 0 0 0 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-.049-.003-.097-.007-.16a1.004 1.004 0 0 0-.395-.776zM12 20c-4.411 0-8-3.589-8-8a7.962 7.962 0 0 1 6.006-7.75A5.006 5.006 0 0 0 15 9l.101-.001a5.007 5.007 0 0 0 4.837 4C19.444 16.941 16.073 20 12 20z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.5",
                    "cy": "11.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "8.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "12.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "15.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "16.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiConversation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14h.5c.827 0 1.5-.673 1.5-1.5v-9c0-.827-.673-1.5-1.5-1.5h-13C2.673 2 2 2.673 2 3.5V18l5.333-4H16zm-9.333-2L4 14V4h12v8H6.667z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 8H20v6.001c0 1.1-.893 1.993-1.99 1.999H8v.5c0 .827.673 1.5 1.5 1.5h7.167L22 22V9.5c0-.827-.673-1.5-1.5-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiConfused(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.124 16.992-.248-1.984 8-1 .248 1.984z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 16 5.991-2L16 8l-6 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiComment(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCommentX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707 12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293-1.414-1.414L12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCommentMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCommentError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zm0 6h2v2h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCommentEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.771 9.123-1.399-1.398-3.869 3.864v1.398h1.398zM14.098 6l1.398 1.398-1.067 1.067-1.398-1.398z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCommentDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCommentDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCommentCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.207 8.207-1.414-1.414L11 11.586 8.707 9.293l-1.414 1.414L11 14.414z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCommentAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCommand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14c-2.206 0-4 1.794-4 4s1.794 4 4 4a4.003 4.003 0 0 0 3.998-3.98H10V16h4v2.039h.004A4.002 4.002 0 0 0 18 22c2.206 0 4-1.794 4-4s-1.794-4-4-4h-2v-4h2c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4v2h-4V5.98h-.002A4.003 4.003 0 0 0 6 2C3.794 2 2 3.794 2 6s1.794 4 4 4h2v4H6zm2 4c0 1.122-.879 2-2 2s-2-.878-2-2 .879-2 2-2h2v2zm10-2c1.121 0 2 .878 2 2s-.879 2-2 2-2-.878-2-2v-2h2zM16 6c0-1.122.879-2 2-2s2 .878 2 2-.879 2-2 2h-2V6zM6 8c-1.121 0-2-.878-2-2s.879-2 2-2 2 .878 2 2v2H6zm4 2h4v4h-4v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiColumns(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.893 3.001H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h15.893c1.103 0 2-.897 2-2V5a2.003 2.003 0 0 0-2-1.999zM8 19.001H4V8h4v11.001zm6 0h-4V8h4v11.001zm2 0V8h3.893l.001 11.001H16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiColor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 13a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm2.75-7.17A5 5 0 0 0 13 7.1v-3a7.94 7.94 0 0 1 3.9 1.62zM11 7.1a5 5 0 0 0-1.75.73L7.1 5.69A7.94 7.94 0 0 1 11 4.07zM7.83 9.25A5 5 0 0 0 7.1 11h-3a7.94 7.94 0 0 1 1.59-3.9zM7.1 13a5 5 0 0 0 .73 1.75L5.69 16.9A7.94 7.94 0 0 1 4.07 13zm2.15 3.17a5 5 0 0 0 1.75.73v3a7.94 7.94 0 0 1-3.9-1.62zm3.75.73a5 5 0 0 0 1.75-.73l2.15 2.14a7.94 7.94 0 0 1-3.9 1.62zm3.17-2.15A5 5 0 0 0 16.9 13h3a7.94 7.94 0 0 1-1.62 3.9zM16.9 11a5 5 0 0 0-.73-1.75l2.14-2.15a7.94 7.94 0 0 1 1.62 3.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiColorFill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13.998c-.092.065-2 2.083-2 3.5 0 1.494.949 2.448 2 2.5.906.044 2-.891 2-2.5 0-1.5-1.908-3.435-2-3.5zm-16.586-1c0 .534.208 1.036.586 1.414l5.586 5.586c.378.378.88.586 1.414.586s1.036-.208 1.414-.586l7-7-.707-.707L11 4.584 8.707 2.291 7.293 3.705l2.293 2.293L4 11.584c-.378.378-.586.88-.586 1.414zM11 7.412l5.586 5.586L11 18.584h.001l-.001 1v-1l-5.586-5.586L11 7.412z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCollection(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10H5c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2zM5 20v-8h14l.002 8H5zM5 6h14v2H5zm2-4h10v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCollapse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.121 6.465 14 4.344V10h5.656l-2.121-2.121 3.172-3.172-1.414-1.414zM4.707 3.293 3.293 4.707l3.172 3.172L4.344 10H10V4.344L7.879 6.465zM19.656 14H14v5.656l2.121-2.121 3.172 3.172 1.414-1.414-3.172-3.172zM6.465 16.121l-3.172 3.172 1.414 1.414 3.172-3.172L10 19.656V14H4.344z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCollapseVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.59 7.05 2.64 5.64 4.05 12 10.41l6.36-6.36-1.41-1.41L12 7.59zM5.64 19.95l1.41 1.41L12 16.41l4.95 4.95 1.41-1.41L12 13.59l-6.36 6.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCollapseHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.95 5.64 13.59 12l6.36 6.36 1.41-1.41L16.41 12l4.95-4.95-1.41-1.41zM2.64 7.05 7.59 12l-4.95 4.95 1.41 1.41L10.41 12 4.05 5.64 2.64 7.05z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCollapseAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15h7v7h2v-9H2v2zM15 2h-2v9h9V9h-7V2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCoin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6C7.03 6 2 7.546 2 10.5v4C2 17.454 7.03 19 12 19s10-1.546 10-4.5v-4C22 7.546 16.97 6 12 6zm-8 8.5v-1.197a9.989 9.989 0 0 0 2 .86v1.881c-1.312-.514-2-1.126-2-1.544zm12 .148v1.971c-.867.179-1.867.31-3 .358v-2a21.75 21.75 0 0 0 3-.329zm-5 2.33a18.788 18.788 0 0 1-3-.358v-1.971c.959.174 1.972.287 3 .33v1.999zm7-.934v-1.881a9.931 9.931 0 0 0 2-.86V14.5c0 .418-.687 1.03-2 1.544zM12 13c-5.177 0-8-1.651-8-2.5S6.823 8 12 8s8 1.651 8 2.5-2.823 2.5-8 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCoinStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c3.976 0 8-1.374 8-4V6c0-2.626-4.024-4-8-4S4 3.374 4 6v12c0 2.626 4.024 4 8 4zm0-2c-3.722 0-6-1.295-6-2v-1.268C7.541 17.57 9.777 18 12 18s4.459-.43 6-1.268V18c0 .705-2.278 2-6 2zm0-16c3.722 0 6 1.295 6 2s-2.278 2-6 2-6-1.295-6-2 2.278-2 6-2zM6 8.732C7.541 9.57 9.777 10 12 10s4.459-.43 6-1.268V10c0 .705-2.278 2-6 2s-6-1.295-6-2V8.732zm0 4C7.541 13.57 9.777 14 12 14s4.459-.43 6-1.268V14c0 .705-2.278 2-6 2s-6-1.295-6-2v-1.268z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.084 0 2 .916 2 2s-.916 2-2 2-2-.916-2-2 .916-2 2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2.845 16.136 1 1.73c.531.917 1.809 1.261 2.73.73l.529-.306A8.1 8.1 0 0 0 9 19.402V20c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-.598a8.132 8.132 0 0 0 1.896-1.111l.529.306c.923.53 2.198.188 2.731-.731l.999-1.729a2.001 2.001 0 0 0-.731-2.732l-.505-.292a7.718 7.718 0 0 0 0-2.224l.505-.292a2.002 2.002 0 0 0 .731-2.732l-.999-1.729c-.531-.92-1.808-1.265-2.731-.732l-.529.306A8.1 8.1 0 0 0 15 4.598V4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v.598a8.132 8.132 0 0 0-1.896 1.111l-.529-.306c-.924-.531-2.2-.187-2.731.732l-.999 1.729a2.001 2.001 0 0 0 .731 2.732l.505.292a7.683 7.683 0 0 0 0 2.223l-.505.292a2.003 2.003 0 0 0-.731 2.733zm3.326-2.758A5.703 5.703 0 0 1 6 12c0-.462.058-.926.17-1.378a.999.999 0 0 0-.47-1.108l-1.123-.65.998-1.729 1.145.662a.997.997 0 0 0 1.188-.142 6.071 6.071 0 0 1 2.384-1.399A1 1 0 0 0 11 5.3V4h2v1.3a1 1 0 0 0 .708.956 6.083 6.083 0 0 1 2.384 1.399.999.999 0 0 0 1.188.142l1.144-.661 1 1.729-1.124.649a1 1 0 0 0-.47 1.108c.112.452.17.916.17 1.378 0 .461-.058.925-.171 1.378a1 1 0 0 0 .471 1.108l1.123.649-.998 1.729-1.145-.661a.996.996 0 0 0-1.188.142 6.071 6.071 0 0 1-2.384 1.399A1 1 0 0 0 13 18.7l.002 1.3H11v-1.3a1 1 0 0 0-.708-.956 6.083 6.083 0 0 1-2.384-1.399.992.992 0 0 0-1.188-.141l-1.144.662-1-1.729 1.124-.651a1 1 0 0 0 .471-1.108z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCoffee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h2v3H5zm4 0h2v3H9zm4 0h2v3h-2zm6 7h-2V7H3v11c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3h2c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2zm-4 9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9h10v9zm2-2v-5h2l.002 5H17z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCoffeeTogo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22h10a1 1 0 0 0 .99-.858L19.867 8H21V6h-1.382l-1.724-3.447A.998.998 0 0 0 17 2H7c-.379 0-.725.214-.895.553L4.382 6H3v2h1.133L6.01 21.142A1 1 0 0 0 7 22zm10.418-11H6.582l-.429-3h11.693l-.428 3zm-9.551 9-.429-3h9.123l-.429 3H7.867zM7.618 4h8.764l1 2H6.618l1-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.293 6.293 2.586 12l5.707 5.707 1.414-1.414L5.414 12l4.293-4.293zm7.414 11.414L21.414 12l-5.707-5.707-1.414 1.414L18.586 12l-4.293 4.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCodeCurly(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 22h1v-2h-.989C8.703 19.994 6 19.827 6 16c0-1.993-.665-3.246-1.502-4C5.335 11.246 6 9.993 6 8c0-3.827 2.703-3.994 3-4h1V2H8.998C7.269 2.004 4 3.264 4 8c0 2.8-1.678 2.99-2.014 3L2 13c.082 0 2 .034 2 3 0 4.736 3.269 5.996 5 6zm13-11c-.082 0-2-.034-2-3 0-4.736-3.269-5.996-5-6h-1v2h.989c.308.006 3.011.173 3.011 4 0 1.993.665 3.246 1.502 4-.837.754-1.502 2.007-1.502 4 0 3.827-2.703 3.994-3 4h-1v2h1.002C16.731 21.996 20 20.736 20 16c0-2.8 1.678-2.99 2.014-3L22 11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCodeBlock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 9.293 5.586 13l3.707 3.707 1.414-1.414L8.414 13l2.293-2.293zm5.414 0-1.414 1.414L15.586 13l-2.293 2.293 1.414 1.414L18.414 13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCodeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.375 16.781 1.25-1.562L4.601 12l4.024-3.219-1.25-1.562-5 4a1 1 0 0 0 0 1.562l5 4zm9.25-9.562-1.25 1.562L19.399 12l-4.024 3.219 1.25 1.562 5-4a1 1 0 0 0 0-1.562l-5-4zm-1.649-4.003-4 18-1.953-.434 4-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5h11c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888zM18 17H7c-1.654 0-3-1.346-3-3 0-1.404 1.199-2.756 2.673-3.015l.581-.102.192-.558C8.149 8.274 9.895 7 12 7c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCloudUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 19v-4h3l-4-5-4 5h3v4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h2v-2H7c-1.654 0-3-1.346-3-3 0-1.404 1.199-2.756 2.673-3.015l.581-.102.192-.558C8.149 8.274 9.895 7 12 7c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-3v2h3c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCloudSnow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "16",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "21",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "16",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCloudRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h2v7H8zm3 2h2v7h-2zm3-2h2v7h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.113C18.507 6.671 15.56 4.001 12 4.001c-2.756 0-5.15 1.611-6.243 4.15C3.609 8.793 2 10.82 2 13.001c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.274 9.895 6.001 12 6.001c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCloudLightning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 13-1 5h2v4l3.975-6H13l1-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCloudLightRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h2v4H8zm0 5h2v2H8zm3-3h2v4h-2zm0 5h2v2h-2zm3-7h2v4h-2zm0 5h2v2h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCloudDrizzle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h2v3H8zm0 4h2v3H8zm3-2h2v3h-2zm0 4h2v3h-2zm3-6h2v3h-2zm0 4h2v3h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.245 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.582-.103.191-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCloudDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.948 11.112C18.511 7.67 15.563 5 12.004 5c-2.756 0-5.15 1.611-6.243 4.15-2.148.642-3.757 2.67-3.757 4.85 0 2.757 2.243 5 5 5h1v-2h-1c-1.654 0-3-1.346-3-3 0-1.404 1.199-2.757 2.673-3.016l.581-.102.192-.558C8.153 8.273 9.898 7 12.004 7c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-2v2h2c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.004 14v-4h-2v4h-3l4 5 4-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCloset(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10.551v-.678A4.005 4.005 0 0 0 16 6c0-2.206-1.794-4-4-4S8 3.794 8 6h2c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2a1 1 0 0 0-1 1v1.551l-8.665 7.702A1.001 1.001 0 0 0 3 20h18a1.001 1.001 0 0 0 .664-1.748L13 10.551zM5.63 18 12 12.338 18.37 18H5.63z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-2.25a1 1 0 0 0-1-1h-7.5a1 1 0 0 0-1 1H5c-1.103 0-2 .897-2 2v15c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 17H5V5h2v2h10V5h2v15z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiClinic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.707 2.293a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a.999.999 0 0 0 .707-1.707l-9-9zM18.001 20H6v-9.586l6-6 6 6V15l.001 5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c.001 5.515 4.487 10.001 10 10.001 5.514 0 10-4.486 10.001-10.001 0-5.514-4.486-10-10.001-10zm0 18.001c-4.41 0-7.999-3.589-8-8.001 0-4.411 3.589-8 8-8 4.412 0 8.001 3.589 8.001 8-.001 4.412-3.59 8.001-8.001 8.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCircleThreeQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v9H2v1a10 10 0 0 0 17.07 7.07A10 10 0 0 0 12 2zm5.66 15.66A8 8 0 0 1 4.06 13H13V4.06a8 8 0 0 1 4.66 13.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCircleQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v11h11v-1A10 10 0 0 0 12 2zm1 9V4.06A8 8 0 0 1 19.94 11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCircleHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v20h1a10 10 0 0 0 0-20zm1 17.94V4.06a8 8 0 0 1 0 15.88z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChurch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.447 14.105 18 12.382V12a1 1 0 0 0-.485-.857L13 8.434V6h2V4h-2V2h-2v2H9v2h2v2.434l-4.515 2.709A1 1 0 0 0 6 12v.382l-3.447 1.724A.998.998 0 0 0 2 15v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-6c0-.379-.214-.725-.553-.895zM4 15.618l2-1V20H4v-4.382zM12 15a2 2 0 0 0-2 2v3H8v-7.434l4-2.4 4 2.4V20h-2v-3a2 2 0 0 0-2-2zm8 5h-2v-5.382l2 1V20z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v6H9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6c0-1.103-.897-2-2-2h-2V2h-2v2h-4V2H8v2H6c-1.103 0-2 .897-2 2v2H2v2h2v4H2v2h2v2c0 1.103.897 2 2 2h2v2h2v-2h4v2h2v-2h2c1.103 0 2-.897 2-2v-2h2v-2h-2v-4h2V8h-2V6zM6 18V6h12l.002 12H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChild(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-4a1 1 0 0 0-.8.4l-3 4 1.6 1.2L9 13v7h2v-4h2v4h2v-7l1.2 1.6 1.6-1.2-3-4A1 1 0 0 0 14 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronsUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 11.293 1.414 1.414L12 8.414l4.293 4.293 1.414-1.414L12 5.586z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 16.293 1.414 1.414L12 13.414l4.293 4.293 1.414-1.414L12 10.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronsRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.296 7.71 14.621 12l-4.325 4.29 1.408 1.42L17.461 12l-5.757-5.71z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.704 6.29 5.296 7.71 9.621 12l-4.325 4.29 1.408 1.42L12.461 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronsLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.707 7.707-1.414-1.414L5.586 12l5.707 5.707 1.414-1.414L8.414 12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.293 6.293 10.586 12l5.707 5.707 1.414-1.414L13.414 12l4.293-4.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronsDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 15.586-4.293-4.293-1.414 1.414L12 18.414l5.707-5.707-1.414-1.414z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.707 7.707-1.414-1.414L12 10.586 7.707 6.293 6.293 7.707 12 13.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronUpSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronUpCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronRightSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 7.707 13.586 12l-4.293 4.293 1.414 1.414L16.414 12l-5.707-5.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronRightCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 7.707 13.586 12l-4.293 4.293 1.414 1.414L16.414 12l-5.707-5.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronLeftSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronLeftCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronDownSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707-1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChevronDownCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707-1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCheese(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.16 2a1 1 0 0 0-.66.13l-12 7a.64.64 0 0 0-.13.1l-.1.08a1.17 1.17 0 0 0-.17.26.84.84 0 0 0-.1.43v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V10a8.08 8.08 0 0 0-6.84-8zm0 2.05A6.07 6.07 0 0 1 19.93 9H6.7zM20 19H4v-8h16z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "16.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "13.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "16",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCheckbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCheckboxSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v6H9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 17V7c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2zM7 7h10l.002 10H7V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCheckboxMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.01 11h6v2h-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM7 17V7h10v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCheckboxChecked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.996 12.556 9.7 11.285l-1.4 1.43 2.704 2.647 4.699-4.651-1.406-1.422z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCheckSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.933 13.519-2.226-2.226-1.414 1.414 3.774 3.774 5.702-6.84-1.538-1.282z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCheckShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.995 6.9a.998.998 0 0 0-.548-.795l-8-4a1 1 0 0 0-.895 0l-8 4a1.002 1.002 0 0 0-.547.795c-.011.107-.961 10.767 8.589 15.014a.987.987 0 0 0 .812 0c9.55-4.247 8.6-14.906 8.589-15.014zM12 19.897C5.231 16.625 4.911 9.642 4.966 7.635L12 4.118l7.029 3.515c.037 1.989-.328 9.018-7.029 12.264z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 12.586-2.293-2.293-1.414 1.414L11 15.414l5.707-5.707-1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCheckDouble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18v3.766l1.515-.909L11.277 18H16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h1zM4 8h12v8h-5.277L7 18.234V16H4V8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2h12c1.103 0 2 .897 2 2v8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.553 11.658-4-2-2.448 4.895 1.79.894 1.552-3.105 4 2 2.448-4.895-1.79-.894z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChalkboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h4l-1.8 2.4 1.6 1.2 2.7-3.6h3l2.7 3.6 1.6-1.2L16 18h4c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 16V5h16l.001 11H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h4v2H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiChair(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13V4c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2v9a1 1 0 0 0-1 1v8h2v-5h12v5h2v-8a1 1 0 0 0-1-1zm-2-9v9h-2V4h2zm-4 0v9h-2V4h2zM7 4h2v9H7V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCertification(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.06 14.68a1 1 0 0 0 .46.6l1.91 1.11v2.2a1 1 0 0 0 1 1h2.2l1.11 1.91a1 1 0 0 0 .86.5 1 1 0 0 0 .51-.14l1.9-1.1 1.91 1.1a1 1 0 0 0 1.37-.36l1.1-1.91h2.2a1 1 0 0 0 1-1v-2.2l1.91-1.11a1 1 0 0 0 .37-1.36L20.76 12l1.11-1.91a1 1 0 0 0-.37-1.36l-1.91-1.1v-2.2a1 1 0 0 0-1-1h-2.2l-1.1-1.91a1 1 0 0 0-.61-.46 1 1 0 0 0-.76.1L12 3.26l-1.9-1.1a1 1 0 0 0-1.36.36L7.63 4.43h-2.2a1 1 0 0 0-1 1v2.2l-1.9 1.1a1 1 0 0 0-.37 1.37l1.1 1.9-1.1 1.91a1 1 0 0 0-.1.77zm3.22-3.17L4.39 10l1.55-.9a1 1 0 0 0 .49-.86V6.43h1.78a1 1 0 0 0 .87-.5L10 4.39l1.54.89a1 1 0 0 0 1 0l1.55-.89.91 1.54a1 1 0 0 0 .87.5h1.77v1.78a1 1 0 0 0 .5.86l1.54.9-.89 1.54a1 1 0 0 0 0 1l.89 1.54-1.54.9a1 1 0 0 0-.5.86v1.78h-1.83a1 1 0 0 0-.86.5l-.89 1.54-1.55-.89a1 1 0 0 0-1 0l-1.51.89-.89-1.54a1 1 0 0 0-.87-.5H6.43v-1.78a1 1 0 0 0-.49-.81l-1.55-.9.89-1.54a1 1 0 0 0 0-1.05z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCctv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.916 9.564a.998.998 0 0 0-.513-1.316L7.328 2.492c-.995-.438-2.22.051-2.645 1.042l-2.21 5.154a2.001 2.001 0 0 0 1.052 2.624L9.563 13.9 8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054 5.205 2.23a1 1 0 0 0 1.31-.517l.312-.71 1.701.68 2-5-1.536-.613.523-1.194zm-4.434 5.126L4.313 9.475l2.208-5.152 12.162 5.354-2.201 5.013z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCategory(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11-6h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 4H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6H5v-4h4v4zm8-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCategoryAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11 4h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6h-4v-4h4v4zM17 3c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM7 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21.001h2C13 14.935 8.065 10 2 10v2c4.962 0 9 4.038 9 9.001z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21.001h2C9 17.141 5.86 14 2 14v2c2.757 0 5 2.243 5 5.001z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v2.052c.68.025 1.349.094 2 .217V6h16v13h-5.269c.123.651.191 1.32.217 2H20c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.822 7.431A1 1 0 0 0 21 7H7.333L6.179 4.23A1.994 1.994 0 0 0 4.333 3H2v2h2.333l4.744 11.385A1 1 0 0 0 10 17h8c.417 0 .79-.259.937-.648l3-8a1 1 0 0 0-.115-.921zM17.307 15h-6.64l-2.5-6h11.39l-2.25 6z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCartDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 13.99 4-5h-3v-4h-2v4h-3l4 5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.31 15h-6.64L6.18 4.23A2 2 0 0 0 4.33 3H2v2h2.33l4.75 11.38A1 1 0 0 0 10 17h8a1 1 0 0 0 .93-.64L21.76 9h-2.14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCartAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H2v2h2.3l3.28 9a3 3 0 0 0 2.82 2H19v-2h-8.6a1 1 0 0 1-.94-.66L9 13h9.28a2 2 0 0 0 1.92-1.45L22 5.27A1 1 0 0 0 21.27 4 .84.84 0 0 0 21 4zm-2.75 7h-10L6.43 6h13.24z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCartAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13h2v-2.99h2.99v-2H15V5.03h-2v2.98h-2.99v2H13V13z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17h8a1 1 0 0 0 .93-.64L21.76 9h-2.14l-2.31 6h-6.64L6.18 4.23A2 2 0 0 0 4.33 3H2v2h2.33l4.75 11.38A1 1 0 0 0 10 17z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCarousel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h2c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2h2c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2h-2c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2zM20 7v10h-2V7h2zM8 5h8l.001 14H8V5zM4 7h2v10H4V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h14l-7-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretUpSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h10l-5-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretUpCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h10l-5-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 19 8-7-8-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretRightSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 17 6-5-6-5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretRightCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 17 6-5-6-5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19V5l-8 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretLeftSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17V7l-6 5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretLeftCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17V7l-6 5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.998 17 7-8h-14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretDownSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 5-6H7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaretDownCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 5-6H7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.999 17c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-12c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12zm-12-12h12l.002 10H5.999V5zm-2 14h16v2h-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.156-1.368-4.105A2.995 2.995 0 0 0 16.559 4H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.105A2.003 2.003 0 0 0 2 12v5c0 .753.423 1.402 1.039 1.743-.013.066-.039.126-.039.195V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.062c0-.069-.026-.13-.039-.195A1.993 1.993 0 0 0 22 17v-5c0-.829-.508-1.541-1.228-1.844zM4 17v-5h16l.002 5H4zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "14.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "14.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCaptions(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10v4c0 1.103.897 2 2 2h3v-2H8v-4h3V8H8c-1.103 0-2 .897-2 2zm7 0v4c0 1.103.897 2 2 2h3v-2h-3v-4h3V8h-3c-1.103 0-2 .897-2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCapsule(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.999 20.133a4.969 4.969 0 0 0 3.536-1.465l7.134-7.133a5.007 5.007 0 0 0-.001-7.072C18.723 3.52 17.467 3 16.132 3s-2.591.52-3.534 1.464l-7.134 7.134a5.009 5.009 0 0 0 0 7.072 4.97 4.97 0 0 0 3.535 1.463zm5.013-14.255A2.979 2.979 0 0 1 16.132 5c.802 0 1.556.313 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892L11.12 8.77l2.892-2.892zm-7.134 7.134 2.828-2.828 4.242 4.243-2.827 2.827c-1.133 1.133-3.11 1.132-4.243.001a3.005 3.005 0 0 1 0-4.243z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCandles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h1v3h2v-3h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H9V2H7v3H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1zM7 7h2v10H7zm7 10h1v3h2v-3h1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1V4h-2v3h-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm1-8h2v6h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.168 0-4 1.832-4 4s1.832 4 4 4 4-1.832 4-4-1.832-4-4-4zm0 6c-1.065 0-2-.935-2-2s.935-2 2-2 2 .935 2 2-.935 2-2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 18V7h3c.266 0 .52-.105.707-.293L10.414 4h3.172l2.707 2.707A.996.996 0 0 0 17 7h3l.002 11H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCameraOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.014 12.135c.074 2.062 1.789 3.777 3.851 3.851l-3.851-3.851z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h11.879l-2-2H4V8.121L2.144 6.265A1.976 1.976 0 0 0 2 7v11c0 1.103.897 2 2 2zM20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.997.997 0 0 0-.707.293L6.586 5h-.172L3.707 2.293 2.293 3.707l18 18 1.414-1.414-.626-.626A1.98 1.98 0 0 0 22 18V7c0-1.103-.897-2-2-2zm-6.081 7.505-2.424-2.425c.163-.046.331-.08.505-.08 1.065 0 2 .935 2 2 0 .174-.033.342-.081.505zm1.502 1.501A3.881 3.881 0 0 0 16 12c0-2.168-1.832-4-4-4-.729 0-1.412.22-2.007.579L7.914 6.5l2.5-2.5h3.172l2.707 2.707A.996.996 0 0 0 17 7l3-.001V18h-.586l-3.993-3.994z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCameraMovie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c0-.959-.68-1.761-1.581-1.954C16.779 8.445 17 7.75 17 7c0-2.206-1.794-4-4-4-1.517 0-2.821.857-3.5 2.104C8.821 3.857 7.517 3 6 3 3.794 3 2 4.794 2 7c0 .902.312 1.727.817 2.396A1.994 1.994 0 0 0 2 11v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-2.638l4 2v-7l-4 2V11zm-5-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM6 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM4 19v-8h12l.002 8H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCameraHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.125 2H5.875A1.877 1.877 0 0 0 4 3.875v12.25C4 17.159 4.841 18 5.875 18H11v2H7v2h10v-2h-4v-2h5.125A1.877 1.877 0 0 0 20 16.125V3.875A1.877 1.877 0 0 0 18.125 2zM18 16H6V4h12v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 8l.001 12H5V8h14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.293 16.293 1.414 1.414L12 15.414l2.293 2.293 1.414-1.414L13.414 14l2.293-2.293-1.414-1.414L12 12.586l-2.293-2.293-1.414 1.414L10.586 14z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarWeek(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 20V7h14V6l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10v2h10V9H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9.981 14.811-.467 2.726 2.449-1.287 2.449 1.287-.468-2.726 1.982-1.932-2.738-.398L11.963 10l-1.225 2.481L8 12.879z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h3v3h2v-3h3v-2h-3v-3h-2v3H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h8v2H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.648 14.711 11.997 18l3.35-3.289a2.129 2.129 0 0 0 0-3.069 2.225 2.225 0 0 0-3.126 0l-.224.219-.224-.219a2.224 2.224 0 0 0-3.125 0 2.129 2.129 0 0 0 0 3.069z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10h2v5h-2zm0 6h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarEvent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12h6v6h-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.001 16H5V8h14l.001 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 20V7h14V6l.002 14H5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.628 12.183-1.8-1.799 1.37-1.371 1.8 1.799zm-7.623 4.018V18h1.799l4.976-4.97-1.799-1.799z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 17.414 5.707-5.707-1.414-1.414L11 14.586l-2.293-2.293-1.414 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalendarAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H9V2H7v2H5a2 2 0 0 0-2 2zm16 14H5V8h14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM5 20V4h14l.001 16H5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zM7 6h10v4H7zm4 10h2v2h-2zm4-4h2v6h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-6V2h-2v3H5C3.346 5 2 6.346 2 8v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.654-1.346-3-3-3zM5 7h14a1 1 0 0 1 1 1l.001 3.12c-.896.228-1.469.734-1.916 1.132-.507.45-.842.748-1.588.748-.745 0-1.08-.298-1.587-.747-.595-.529-1.409-1.253-2.915-1.253-1.505 0-2.319.724-2.914 1.253-.507.45-.841.747-1.586.747-.743 0-1.077-.297-1.582-.747-.447-.398-1.018-.905-1.913-1.133V8a1 1 0 0 1 1-1zM4 18v-4.714c.191.123.374.274.583.461C5.178 14.276 5.991 15 7.495 15c1.505 0 2.319-.724 2.914-1.253.507-.45.841-.747 1.586-.747s1.08.298 1.587.747c.595.529 1.409 1.253 2.915 1.253s2.321-.724 2.916-1.253c.211-.188.395-.34.588-.464L20.002 18H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCableCar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 9.76 9-2.45V10H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-4V6.76l9-2.45V2.24L2 7.69zM11 12v3H7v-3zm6 0v8H7v-3h10v-2h-4v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiCabinet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4zM5 4h14v7H5V4zm0 16v-7h14.001v7H5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4V6H8v3h8V6h-2zm0 8v1h-4v-1H8v3h8v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.004 7.975V6c0-2.206-1.794-4-4-4h-10c-2.206 0-4 1.794-4 4v1.998l-.076.004A1 1 0 0 0 2 9v2a1 1 0 0 0 1 1h.004v6c0 .735.403 1.372.996 1.72V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.276A1.994 1.994 0 0 0 21.004 18v-6a1 1 0 0 0 1-1V9.062a1.006 1.006 0 0 0-.072-.455c-.203-.487-.635-.604-.928-.632zM19.006 18H5.004v-5h14.001l.001 5zM11.004 7v4h-6V7h6zm8 0v4h-6V7h6zm-12-3h10c.736 0 1.375.405 1.722 1H5.282c.347-.595.986-1 1.722-1z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "15.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "15.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBusSchool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.259 11.948A.986.986 0 0 0 22 11V8a.999.999 0 0 0-.996-.999V6H21c0-2.206-1.794-4-4-4H7C4.794 2 3 3.794 3 6v1a1 1 0 0 0-1 1v3c0 .461.317.832.742.948a3.953 3.953 0 0 0-.741 2.298l.004 3.757c.001.733.404 1.369.995 1.716V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.274a2.02 2.02 0 0 0 .421-.313c.377-.378.585-.881.584-1.415l-.004-3.759a3.966 3.966 0 0 0-.742-2.291zM5 18h-.995l-.004-3.757c-.001-.459.161-.89.443-1.243h15.111c.283.353.445.783.446 1.242L20.006 18H5zm6.004-10v3H5V8h6.004zM19 11h-5.996V8H19v3zM7 4h10c1.103 0 2 .897 2 2h-4V5H9v1H5c0-1.103.897-2 2-2z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "15.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "15.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBuoy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.411 7H16v.031A5.037 5.037 0 0 0 14.969 8H15V4.589A8.039 8.039 0 0 1 19.411 9zM12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm1-10.931v3.032a4.988 4.988 0 0 0-2 0V4.069c.328-.041.66-.069 1-.069s.672.028 1 .069zm-4 .52V8h.031A5.037 5.037 0 0 0 8 9.031V9H4.589C5.402 7 6.999 5.402 9 4.589zM4.069 11h3.032a4.995 4.995 0 0 0 .001 2H4.069C4.028 12.672 4 12.339 4 12s.028-.672.069-1zm.52 4H8v-.031c.284.381.621.718 1 1.005v3.437A8.039 8.039 0 0 1 4.589 15zM11 19.931v-3.032a4.988 4.988 0 0 0 2 0v3.032c-.328.041-.66.069-1 .069s-.672-.028-1-.069zm4-.52v-3.437a5.038 5.038 0 0 0 1-1.005V15h3.411A8.039 8.039 0 0 1 15 19.411zM19.931 13h-3.032a4.995 4.995 0 0 0-.001-2h3.032c.042.328.07.661.07 1s-.028.672-.069 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBullseye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm0 18c-4.337 0-8-3.663-8-8s3.663-8 8-8 8 3.663 8 8-3.663 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.081 0-2 .919-2 2s.919 2 2 2 2-.919 2-2-.919-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20h6v2H9zm7.906-6.288C17.936 12.506 19 11.259 19 9c0-3.859-3.141-7-7-7S5 5.141 5 9c0 2.285 1.067 3.528 2.101 4.73.358.418.729.851 1.084 1.349.144.206.38.996.591 1.921H8v2h8v-2h-.774c.213-.927.45-1.719.593-1.925.352-.503.726-.94 1.087-1.363zm-2.724.213c-.434.617-.796 2.075-1.006 3.075h-2.351c-.209-1.002-.572-2.463-1.011-3.08a20.502 20.502 0 0 0-1.196-1.492C7.644 11.294 7 10.544 7 9c0-2.757 2.243-5 5-5s5 2.243 5 5c0 1.521-.643 2.274-1.615 3.413-.373.438-.796.933-1.203 1.512z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBuildings(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H9c-1.103 0-2 .897-2 2v6H5c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zM5 12h6v8H5v-8zm14 8h-6v-8c0-1.103-.897-2-2-2H9V4h10v16z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 .001h2v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBuilding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zm0 18H6V4h12v16z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h3v2H8zm5 0h3v2h-3zm-5 4h3v2H8zm5 .031h3V12h-3zM8 14h3v2H8zm5 0h3v2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBuildingHouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H9c-1.103 0-2 .897-2 2v5.586l-4.707 4.707A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zm-8 18H5v-5.586l3-3 3 3V20zm8 0h-6v-4a.999.999 0 0 0 .707-1.707L9 9.586V4h10v16z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 1h2v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.895 6.519 2.813-2.812-1.414-1.414-2.846 2.846a6.575 6.575 0 0 0-.723-.454 5.778 5.778 0 0 0-5.45 0c-.25.132-.488.287-.722.453L5.707 2.293 4.293 3.707l2.813 2.812A8.473 8.473 0 0 0 5.756 9H2v2h2.307c-.065.495-.107.997-.107 1.5 0 .507.042 1.013.107 1.511H2v2h2.753c.013.039.021.08.034.118.188.555.421 1.093.695 1.6.044.081.095.155.141.234l-2.33 2.33 1.414 1.414 2.11-2.111a7.477 7.477 0 0 0 2.068 1.619c.479.253.982.449 1.496.58a6.515 6.515 0 0 0 3.237.001 6.812 6.812 0 0 0 1.496-.58c.465-.246.914-.55 1.333-.904.258-.218.5-.462.734-.716l2.111 2.111 1.414-1.414-2.33-2.33c.047-.08.098-.155.142-.236.273-.505.507-1.043.694-1.599.013-.039.021-.079.034-.118H22v-2h-2.308c.065-.499.107-1.004.107-1.511 0-.503-.042-1.005-.106-1.5H22V9h-3.756a8.494 8.494 0 0 0-1.349-2.481zM8.681 7.748c.445-.558.96-.993 1.528-1.294a3.773 3.773 0 0 1 3.581 0 4.894 4.894 0 0 1 1.53 1.295c.299.373.54.8.753 1.251H7.927c.214-.451.454-.879.754-1.252zM17.8 12.5c0 .522-.042 1.044-.126 1.553-.079.49-.199.973-.355 1.436a8.28 8.28 0 0 1-.559 1.288 7.59 7.59 0 0 1-.733 1.11c-.267.333-.56.636-.869.898-.31.261-.639.484-.979.664s-.695.317-1.057.41c-.04.01-.082.014-.122.023V14h-2v5.881c-.04-.009-.082-.013-.122-.023-.361-.093-.717-.23-1.057-.41s-.669-.403-.978-.664a6.462 6.462 0 0 1-.871-.899 7.402 7.402 0 0 1-.731-1.108 8.337 8.337 0 0 1-.56-1.289 9.075 9.075 0 0 1-.356-1.438A9.61 9.61 0 0 1 6.319 11H17.68c.079.491.12.995.12 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBugAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v2H9zm0 4h6v2H9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 5.414 1.707-1.707-1.414-1.414-1.563 1.562C15.483 2.708 13.824 2 12 2s-3.483.708-4.73 1.855L5.707 2.293 4.293 3.707 6 5.414A6.937 6.937 0 0 0 5 9H3v2h2v2H3v2h2c0 3.86 3.141 7 7 7s7-3.14 7-7h2v-2h-2v-2h2V9h-2a6.937 6.937 0 0 0-1-3.586zM17 13v2c0 2.757-2.243 5-5 5s-5-2.243-5-5V9c0-2.757 2.243-5 5-5s5 2.243 5 5v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 2.293a.999.999 0 0 0-1.414 0l-5.84 5.84c-.015-.001-.029-.009-.044-.009a.997.997 0 0 0-.707.293L4.288 9.831a2.985 2.985 0 0 0-.878 2.122c0 .802.313 1.556.879 2.121l.707.707-2.122 2.122A2.92 2.92 0 0 0 2 19.012a2.968 2.968 0 0 0 1.063 2.308c.519.439 1.188.68 1.885.68.834 0 1.654-.341 2.25-.937l2.04-2.039.707.706c1.134 1.133 3.109 1.134 4.242.001l1.415-1.414a.997.997 0 0 0 .293-.707c0-.026-.013-.05-.015-.076l5.827-5.827a.999.999 0 0 0 0-1.414l-8-8zm-.935 16.024a1.023 1.023 0 0 1-1.414-.001l-1.414-1.413a.999.999 0 0 0-1.414 0l-2.746 2.745a1.19 1.19 0 0 1-.836.352.91.91 0 0 1-.594-.208A.978.978 0 0 1 4 19.01a.959.959 0 0 1 .287-.692l2.829-2.829a.999.999 0 0 0 0-1.414L5.701 12.66a.99.99 0 0 1-.292-.706c0-.268.104-.519.293-.708l.707-.707 7.071 7.072-.708.706zm1.889-2.392L8.075 9.339 13 4.414 19.586 11l-4.925 4.925z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBrushAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8.001h-4V4.999a2.92 2.92 0 0 0-.874-2.108 2.943 2.943 0 0 0-2.39-.879C10.202 2.144 9 3.508 9 5.117V8H5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-9.999c0-1.103-.897-2-2-2zM5 10h6V5.117c0-.57.407-1.07 1.002-1.117.266 0 .512.103.712.307a.956.956 0 0 1 .286.692V10h.995l.005.001h5V12H5v-2zm0 10v-6h14l.002 6H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBroadcast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.707 4.293-1.414 1.414c2.733 2.733 2.733 7.353 0 10.086l1.414 1.414c3.5-3.5 3.5-9.414 0-12.914zm-4.414 4.414c.566.566.879 1.292.879 2.043s-.313 1.477-.879 2.043l1.414 1.414c.944-.943 1.465-2.172 1.465-3.457s-.521-2.514-1.465-3.457l-1.414 1.414zm-9.086-3L4.793 4.293c-3.5 3.5-3.5 9.414 0 12.914l1.414-1.414c-2.733-2.733-2.733-7.353 0-10.086z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 7.293c-.944.943-1.465 2.172-1.465 3.457s.521 2.514 1.465 3.457l1.414-1.414c-.566-.566-.879-1.292-.879-2.043s.313-1.477.879-2.043L7.293 7.293zM14 10.5a2 2 0 0 0-4 0 1.993 1.993 0 0 0 .895 1.666L10.002 22h3.996l-.893-9.835c.54-.358.895-.97.895-1.665z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBrightness(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.707 9.293 19 8.586V6a1 1 0 0 0-1-1h-2.586l-.707-.707-2-2a.999.999 0 0 0-1.414 0l-2 2L8.586 5H6a1 1 0 0 0-1 1v2.586l-.707.707-2 2a.999.999 0 0 0 0 1.414l2 2 .707.707V18a1 1 0 0 0 1 1h2.586l.707.707 2 2a.997.997 0 0 0 1.414 0l2-2 .707-.707H18a1 1 0 0 0 1-1v-2.586l.707-.707 2-2a.999.999 0 0 0 0-1.414l-2-2zm-2.414 5-.293.293V17h-2.414l-.293.293-1 1L12 19.586l-1.293-1.293-1-1L9.414 17H7v-2.414l-.293-.293-1-1L4.414 12l1.293-1.293 1-1L7 9.414V7h2.414l.293-.293 1-1L12 4.414l1.293 1.293 1 1 .293.293H17v2.414l.293.293 1 1L19.586 12l-1.293 1.293-1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBrightnessHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 11.293-2-2L19 8.586V6a1 1 0 0 0-1-1h-2.586l-.707-.707-2-2a.999.999 0 0 0-1.414 0l-2 2L8.586 5H6a1 1 0 0 0-1 1v2.586l-.707.707-2 2a.999.999 0 0 0 0 1.414l2 2 .707.707V18a1 1 0 0 0 1 1h2.586l.707.707 2 2a.997.997 0 0 0 1.414 0l2-2 .707-.707H18a1 1 0 0 0 1-1v-2.586l.707-.707 2-2a.999.999 0 0 0 0-1.414zm-4.414 3-.293.293V17h-2.414l-.293.293-1 1L12 19.586l-1.293-1.293-1-1L9.414 17H7v-2.414l-.293-.293-1-1L4.414 12l1.293-1.293 1-1L7 9.414V7h2.414l.293-.293 1-1L12 4.414l1.293 1.293 1 1 .293.293H17v2.414l.293.293 1 1L19.586 12l-1.293 1.293-1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8c2.206 0 4-1.794 4-4s-1.794-4-4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-5-2v2H9V4h6zM8 8h12v3H4V8h4zM4 19v-6h6v2h4v-2h6l.001 6H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBriefcaseAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-4 2v11H8V8h8zm-1-4v2H9V4h6zM4 8h2v11H4V8zm14 11V8h2l.001 11H18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBriefcaseAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-5-2v2H9V4h6zM4 8h16v4h-3v-2h-2v2H9v-2H7v2H4V8zm0 11v-5h3v2h2v-2h6v2h2v-2h3.001v5H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBrain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.864 8.465a3.505 3.505 0 0 0-3.03-4.449A3.005 3.005 0 0 0 14 2a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 10 2c-1.301 0-2.41.831-2.825 2.015a3.505 3.505 0 0 0-3.039 4.45A4.028 4.028 0 0 0 2 12c0 1.075.428 2.086 1.172 2.832A4.067 4.067 0 0 0 3 16c0 1.957 1.412 3.59 3.306 3.934A3.515 3.515 0 0 0 9.5 22c.979 0 1.864-.407 2.5-1.059A3.484 3.484 0 0 0 14.5 22a3.51 3.51 0 0 0 3.19-2.06 4.006 4.006 0 0 0 3.138-5.108A4.003 4.003 0 0 0 22 12a4.028 4.028 0 0 0-2.136-3.535zM9.5 20c-.711 0-1.33-.504-1.47-1.198L7.818 18H7c-1.103 0-2-.897-2-2 0-.352.085-.682.253-.981l.456-.816-.784-.51A2.019 2.019 0 0 1 4 12c0-.977.723-1.824 1.682-1.972l1.693-.26-1.059-1.346a1.502 1.502 0 0 1 1.498-2.39L9 6.207V5a1 1 0 0 1 2 0v13.5c0 .827-.673 1.5-1.5 1.5zm9.575-6.308-.784.51.456.816c.168.3.253.63.253.982 0 1.103-.897 2-2.05 2h-.818l-.162.802A1.502 1.502 0 0 1 14.5 20c-.827 0-1.5-.673-1.5-1.5V5c0-.552.448-1 1-1s1 .448 1 1.05v1.207l1.186-.225a1.502 1.502 0 0 1 1.498 2.39l-1.059 1.347 1.693.26A2.002 2.002 0 0 1 20 12c0 .683-.346 1.315-.925 1.692z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBraille(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "7",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "7",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "17",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "7",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "17",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBracket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4V2H4v20h6v-2H6V4zm4 16v2h6V2h-6v2h4v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v2a2 2 0 0 0 1 1.72V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.72A2 2 0 0 0 22 7V5a2 2 0 0 0-2-2zM4 5h16v2H4zm1 14V9h14v10z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBowlingBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "10.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "7.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "11.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBowlRice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1 3.58 3.58 0 0 0-1.8-3 3.66 3.66 0 0 0-3.63-3.13 3.86 3.86 0 0 0-1 .13 3.7 3.7 0 0 0-5.11 0 3.86 3.86 0 0 0-1-.13A3.66 3.66 0 0 0 4.81 7 3.58 3.58 0 0 0 3 10a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66zm-.89-11 .83-.26-.16-.9a1.64 1.64 0 0 1 1.66-1.62 1.78 1.78 0 0 1 .83.2l.81.45.5-.77a1.71 1.71 0 0 1 2.84 0l.5.77.81-.45a1.78 1.78 0 0 1 .83-.2 1.65 1.65 0 0 1 1.67 1.6l-.16.85.82.28A1.59 1.59 0 0 1 19 10H5a1.59 1.59 0 0 1 1.11-1.39zM19.94 12a8 8 0 0 1-4.39 6.16 1 1 0 0 0-.55.9V20H9v-.94a1 1 0 0 0-.55-.9A8 8 0 0 1 4.06 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBowlHot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H3a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1zm-5.45 8.16a1 1 0 0 0-.55.9V20H9v-.94a1 1 0 0 0-.55-.9A8 8 0 0 1 4.06 12h15.88a8 8 0 0 1-4.39 6.16zM9 9V7.93a4.53 4.53 0 0 0-1.28-3.15A2.49 2.49 0 0 1 7 3V2H5v1a4.53 4.53 0 0 0 1.28 3.17A2.49 2.49 0 0 1 7 7.93V9zm4 0V7.93a4.53 4.53 0 0 0-1.28-3.15A2.49 2.49 0 0 1 11 3V2H9v1a4.53 4.53 0 0 0 1.28 3.15A2.49 2.49 0 0 1 11 7.93V9zm4 0V7.93a4.53 4.53 0 0 0-1.28-3.15A2.49 2.49 0 0 1 15 3V2h-2v1a4.53 4.53 0 0 0 1.28 3.15A2.49 2.49 0 0 1 15 7.93V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.928 11.607c-.202-.488-.635-.605-.928-.633V8c0-1.103-.897-2-2-2h-6V4.61c.305-.274.5-.668.5-1.11a1.5 1.5 0 0 0-3 0c0 .442.195.836.5 1.11V6H5c-1.103 0-2 .897-2 2v2.997l-.082.006A1 1 0 0 0 1.99 12v2a1 1 0 0 0 1 1H3v5c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5a1 1 0 0 0 1-1v-1.938a1.006 1.006 0 0 0-.072-.455zM5 20V8h14l.001 3.996L19 12v2l.001.005.001 5.995H5z"
                },
                "child": []
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "8.5",
                    "cy": "12",
                    "rx": "1.5",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "15.5",
                    "cy": "12",
                    "rx": "1.5",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h8v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBorderTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zm0 12h2v2h-2zm-8 0h2v2h-2zm4 0h2v2h-2zm-8 0h2v2H7zm-4 0h2v2H3zm0-8h2v2H3zm0 4h2v2H3zm0-8h2v2H3zm4 4h2v2H7zm8 0h2v2h-2zm-4-4h2v2h-2zm0 8h2v2h-2zm0-4h2v2h-2zm10-8H3v2h18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBorderRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19h2v2h-2zm-4 0h2v2h-2zm-4 0h2v2H7zm-4 0h2v2H3zM3 7h2v2H3zm0 8h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm12 0h2v2h-2zm-4 0h2v2h-2zM7 3h2v2H7zm4 4h2v2h-2zm0 8h2v2h-2zm-4-4h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2zm8-6v16h2V3h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBorderRadius(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2zM7 19h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2zm-8 0h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm0 4h2v2H3zm0-8h2v2H3zm4 0h2v2H7zm12 12h2v2h-2zM16 3h-5v2h5c1.654 0 3 1.346 3 3v5h2V8c0-2.757-2.243-5-5-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBorderOuter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2zm0 8h2v2h-2zm-4-4h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H3v18h18V3h-2zm0 4v12H5V5h14v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBorderNone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2zm-8 0h2v2h-2zm4 0h2v2h-2zm-8 0h2v2H7zm-4 0h2v2H3zM3 7h2v2H3zm0 8h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm4 0h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm-8-8h2v2h-2zm0 8h2v2h-2zm-4-4h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBorderLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3h2v2h-2zm4 0h2v2h-2zM7 3h2v2H7zm12 0h2v2h-2zm0 8h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zm0 12h2v2h-2zm-4 0h2v2h-2zm-8 0h2v2H7zm4 0h2v2h-2zm0-4h2v2h-2zm0-8h2v2h-2zm4 4h2v2h-2zm-8 0h2v2H7zm4 0h2v2h-2zM3 5v16h2V3H3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBorderInner(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2zM7 19h2v2H7zm8 0h2v2h-2zM3 19h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm0-4h2v2H3zm12 0h2v2h-2zM7 3h2v2H7zm12 0h2v2h-2zm0 12h2v2h-2zm0-8h2v2h-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13h6v8h2v-8h8v-2h-8V3h-2v8H3v2h1.93z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBorderBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7h2v2H3zm0 4h2v2H3zm0 4h2v2H3zM3 3h2v2H3zm8 0h2v2h-2zM7 3h2v2H7zm8 0h2v2h-2zm4 0h2v2h-2zm0 12h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm-4 4h2v2h-2zm-8 0h2v2H7zm4-4h2v2h-2zm0 8h2v2h-2zm0-4h2v2h-2zm6 8H3v2h18v-2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBorderAll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h12V3H3v18h6zm10-4v2h-6v-6h6v4zM15 5h4v6h-6V5h2zM5 7V5h6v6H5V7zm0 12v-6h6v6H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookmarks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5H6c-1.103 0-2 .897-2 2v16l6-3.601L16 23V7c0-1.103-.897-2-2-2zm0 14.467-4-2.399-4 2.399V7h8v12.467z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1h-8c-1.103 0-2 .897-2 2h8c1.103 0 2 .897 2 2v10.443l2 2.489V3c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22V4c0-1.103-.897-2-2-2zm0 16.553-6-3.428-6 3.428V4h12v14.553z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookmarkPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14v-3h3V9h-3V6h-2v3H8v2h3v3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22V4c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22zM6 10V4h12v14.553l-6-3.428-6 3.428V10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookmarkMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22V4c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22zM6 10V4h12v14.553l-6-3.428-6 3.428V10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookmarkHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22V4c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22zM6 10V4h12v14.553l-6-3.428-6 3.428V10z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.409 9.512c.361-.372.585-.888.585-1.456s-.223-1.083-.585-1.456a1.962 1.962 0 0 0-1.412-.603S13.001 5.994 12 7.026c-1.001-1.032-1.997-1.029-1.997-1.029-.552 0-1.051.23-1.412.603-.362.373-.585.887-.585 1.456s.223 1.084.585 1.456L12 13.203l3.409-3.691z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookmarkAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM15 18.764l-5-2.5-5 2.5V5.5C5 4.673 5.673 4 6.5 4h8.852A3.451 3.451 0 0 0 15 5.5v13.264zM20 11h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookmarkAltPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM15 18.764l-5-2.5-5 2.5V5.5C5 4.673 5.673 4 6.5 4h8.852A3.451 3.451 0 0 0 15 5.5v13.264zM20 11h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H9v2H7v2h2v2h2v-2h2V9h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookmarkAltMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM15 18.764l-5-2.5-5 2.5V5.5C5 4.673 5.673 4 6.5 4h8.852A3.451 3.451 0 0 0 15 5.5v13.264zM20 11h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h6v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3zM5 8V5c0-.805.55-.988 1-1h13v12H5V8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h9v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookReader(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8c-.202 0-4.85.029-9 2.008C7.85 8.029 3.202 8 3 8a1 1 0 0 0-1 1v9.883a1 1 0 0 0 .305.719c.195.188.48.305.729.28l.127-.001c.683 0 4.296.098 8.416 2.025.016.008.034.005.05.011.119.049.244.083.373.083s.254-.034.374-.083c.016-.006.034-.003.05-.011 4.12-1.928 7.733-2.025 8.416-2.025l.127.001c.238.025.533-.092.729-.28.194-.189.304-.449.304-.719V9a1 1 0 0 0-1-1zM4 10.049c1.485.111 4.381.48 7 1.692v7.742c-3-1.175-5.59-1.494-7-1.576v-7.858zm16 7.858c-1.41.082-4 .401-7 1.576v-7.742c2.619-1.212 5.515-1.581 7-1.692v7.858z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3h-7a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 10 3H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h5.758c.526 0 1.042.214 1.414.586l1.121 1.121c.009.009.021.012.03.021.086.079.182.149.294.196h.002a.996.996 0 0 0 .762 0h.002c.112-.047.208-.117.294-.196.009-.009.021-.012.03-.021l1.121-1.121A2.015 2.015 0 0 1 15.242 20H21a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8.758 18H4V5h6c.552 0 1 .449 1 1v12.689A4.032 4.032 0 0 0 8.758 18zM20 18h-4.758c-.799 0-1.584.246-2.242.689V6c0-.551.448-1 1-1h6v13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8v11c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v3zm3-4h13v12H5V5c0-.806.55-.988 1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.997 14 3.35-3.289a2.129 2.129 0 0 0 0-3.069 2.225 2.225 0 0 0-3.126 0l-.224.218-.224-.219a2.224 2.224 0 0 0-3.125 0 2.129 2.129 0 0 0 0 3.069L11.997 14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookContent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V5h7v14H4zm9 0V5h7l.001 14H13z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h3v2h-3zm0 4h3v2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2.01H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.998 5 19.815 5 19.01c0-.101.009-.191.024-.273.112-.575.583-.717.987-.727H20c.018 0 .031-.009.049-.01H21V4.01c0-1.103-.897-2-2-2zm0 14H5v-11c0-.806.55-.988 1-1h7v7l2-1 2 1v-7h2v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2zm0 14H5V5c0-.806.55-.988 1-1h13v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBookAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8v11c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19c0-.101.009-.191.024-.273.112-.576.584-.717.988-.727H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v3zm3-4h13v12H5V5c0-.806.55-.988 1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.293 8.293-2.069 2.069A7.017 7.017 0 0 0 15 8.681V4h1V2H8v2h1v4.681A7.01 7.01 0 0 0 5 15c0 3.859 3.141 7 7 7s7-3.141 7-7a6.958 6.958 0 0 0-.652-2.934l2.359-2.359-1.414-1.414zm-8.959 1.998.666-.235V4h2v6.056l.666.235A5.006 5.006 0 0 1 16.886 14H7.114a5.006 5.006 0 0 1 3.22-3.709zM12 20a5.007 5.007 0 0 1-4.898-4h9.797A5.009 5.009 0 0 1 12 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.049 4.951a3.953 3.953 0 0 0-1.028-1.801c-1.51-1.51-4.146-1.51-5.656 0a4.009 4.009 0 0 0-.618 4.86l-3.714 3.714c-1.505-.89-3.591-.649-4.86.618a4.004 4.004 0 0 0 0 5.657 3.946 3.946 0 0 0 1.8 1.028c.178.681.53 1.302 1.028 1.8A3.966 3.966 0 0 0 8.829 22a3.973 3.973 0 0 0 2.828-1.172 4.007 4.007 0 0 0 .617-4.859l3.714-3.714c1.507.891 3.593.65 4.861-.619a4.003 4.003 0 0 0 0-5.656 3.942 3.942 0 0 0-1.8-1.029zm.387 5.271c-.756.755-2.073.756-2.829 0l-.707-.707-6.363 6.364.707.707a2.003 2.003 0 0 1 0 2.828c-.757.757-2.074.755-2.829 0a1.963 1.963 0 0 1-.571-1.31l-.047-.9-.9-.047a1.972 1.972 0 0 1-1.31-.571 2.003 2.003 0 0 1 0-2.829c.377-.377.879-.585 1.413-.585s1.036.208 1.414.585l.707.707 6.364-6.363-.707-.707a2.003 2.003 0 0 1 0-2.829c.756-.754 2.072-.754 2.828 0 .343.343.546.809.572 1.312l.048.897.897.048c.503.026.969.229 1.312.572.377.378.585.88.585 1.414s-.207 1.036-.584 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBomb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3.001c-1.4 0-2.584 1.167-2.707 1.293L17.207 5.38l-1.091-1.088a.999.999 0 0 0-1.413.001L13.46 5.537A8.353 8.353 0 0 0 10.5 5C5.813 5 2 8.813 2 13.5S5.813 22 10.5 22s8.5-3.813 8.5-8.5c0-.909-.144-1.8-.428-2.658l1.345-1.345a1.002 1.002 0 0 0-.001-1.415l-1.293-1.29 1.088-1.088c.229-.229.845-.703 1.289-.703h1v-2h-1zm-4.511 7.978c.339.804.511 1.652.511 2.521 0 3.584-2.916 6.5-6.5 6.5S4 17.084 4 13.5 6.916 7 10.5 7c.96 0 1.89.21 2.762.624.381.181.837.103 1.136-.196l1.014-1.014 2.384 2.377-1.092 1.092a.998.998 0 0 0-.215 1.096z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13.5a4.47 4.47 0 0 0 1.318 3.182l1.414-1.414C8.26 14.795 8 14.168 8 13.5s.26-1.295.732-1.768A2.484 2.484 0 0 1 10.5 11V9a4.469 4.469 0 0 0-3.182 1.318A4.47 4.47 0 0 0 6 13.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBoltCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 6-6 7h4v5l6-7h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBold(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.061 11.22A4.46 4.46 0 0 0 18 8.5C18 6.019 15.981 4 13.5 4H6v15h8c2.481 0 4.5-2.019 4.5-4.5a4.48 4.48 0 0 0-1.439-3.28zM13.5 7c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V7h4.5zm.5 9H9v-3h5c.827 0 1.5.673 1.5 1.5S14.827 16 14 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBody(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22V9h5V7H4v2h5v13h2v-7h2v7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBluetooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4.41 16.192 1.18 1.615L10 14.584V21a1 1 0 0 0 1.541.841l7-4.5a.999.999 0 0 0 .049-1.649L13.537 12l5.053-3.692a1.002 1.002 0 0 0-.049-1.65l-7-4.5a1.002 1.002 0 0 0-1.021-.037c-.32.176-.52.513-.52.879v6.416L5.59 6.192 4.41 7.808 10 11.893v.215l-5.59 4.084zM12 4.832l4.232 2.721L12 10.646V4.832zm0 8.522 4.232 3.093L12 19.168v-5.814z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBlock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM4 12c0-1.846.634-3.542 1.688-4.897l11.209 11.209A7.946 7.946 0 0 1 12 20c-4.411 0-8-3.589-8-8zm14.312 4.897L7.103 5.688A7.948 7.948 0 0 1 12 4c4.411 0 8 3.589 8 8a7.954 7.954 0 0 1-1.688 4.897z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBlanket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h12c1.654 0 3-1.346 3-3s-1.346-3-3-3H6v2h13a1 1 0 0 1 0 2H7c-1.654 0-3-1.346-3-3s1.346-3 3-3h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 10H7a4.973 4.973 0 0 0-3 1.002V7c0-1.654 1.346-3 3-3h13v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBitcoin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13v4H6v2h3v2h2v-2h2v2h2v-2.051c1.968-.249 3.5-1.915 3.5-3.949 0-1.32-.65-2.484-1.64-3.213A3.982 3.982 0 0 0 18 9c0-1.858-1.279-3.411-3-3.858V3h-2v2h-2V3H9v2H6v2h2v6zm6.5 4H10v-4h4.5c1.103 0 2 .897 2 2s-.897 2-2 2zM10 7h4c1.103 0 2 .897 2 2s-.897 2-2 2h-4V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBible(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3zM5 8V5c0-.805.55-.988 1-1h13v12H5V8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-4h2V8h-2V6h-2v2H9v2h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707L19 13.586zM19 17H5v-.586l1.707-1.707A.996.996 0 0 0 7 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBellPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.037h-2V10H8.037v2H11v2.963h2V12h2.963v-2H13z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707L19 13.586zM19 17H5v-.586l1.707-1.707A.996.996 0 0 0 7 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBellOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm9-4v-2a.996.996 0 0 0-.293-.707L19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258c-1.323.364-2.463 1.128-3.346 2.127L3.707 2.293 2.293 3.707l18 18 1.414-1.414-1.362-1.362A.993.993 0 0 0 21 18zM12 5c2.757 0 5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17h-.586L8.207 6.793C9.12 5.705 10.471 5 12 5zm-5.293 9.707A.996.996 0 0 0 7 14v-2.879L5.068 9.189C5.037 9.457 5 9.724 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h10.879l-2-2H5v-.586l1.707-1.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBellMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.707 15.293 19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707zM19 17H5v-.586l1.707-1.707A.996.996 0 0 0 7 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.037 10h7.926v2H8.037z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBeer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v15c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-1h2c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-4 13c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1V5h12v14zm4-3h-2V8h2v8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h2v10H6zm6 0h2v10h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBeenHere(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995c-.029 6.445 7.116 11.604 7.42 11.819a.998.998 0 0 0 1.16 0C12.884 21.599 20.029 16.44 20 10c0-4.411-3.589-8-8-8zm0 17.735C10.389 18.427 5.979 14.441 6 10c0-3.309 2.691-6 6-6s6 2.691 6 6.005c.021 4.437-4.388 8.423-6 9.73z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.586 8.707 9.293l-1.414 1.414L11 14.414l5.707-5.707-1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9.557V3h-2v2H6V3H4v6.557C2.81 10.25 2 11.525 2 13v4a1 1 0 0 0 1 1h1v4h2v-4h12v4h2v-4h1a1 1 0 0 0 1-1v-4c0-1.475-.811-2.75-2-3.443zM18 7v2h-5V7h5zM6 7h5v2H6V7zm14 9H4v-3c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBattery(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h14c1.103 0 2-.897 2-2v-2h2v-4h-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2zM4 8h14l.002 8H4V8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H7V7c0-1.103.897-2 2-2s2 .897 2 2h2c0-2.206-1.794-4-4-4S5 4.794 5 7v3H3a1 1 0 0 0-1 1v2c0 2.606 1.674 4.823 4 5.65V22h2v-3h8v3h2v-3.35c2.326-.827 4-3.044 4-5.65v-2a1 1 0 0 0-1-1zm-1 3c0 2.206-1.794 4-4 4H8c-2.206 0-4-1.794-4-4v-1h16v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBasketball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 19.071c1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.899-3.899 3.899-10.243 0-14.143C17.177 3.034 14.665 1.99 12 1.99S6.823 3.034 4.929 4.929c-3.899 3.898-3.899 10.243 0 14.142zm7.38-15.065a7.912 7.912 0 0 1 4.594 1.678L12 10.586l-1.46-1.46c1.161-1.479 1.792-3.308 1.769-5.12zM9.11 7.696 7.098 5.684a7.929 7.929 0 0 1 3.218-1.51c-.015 1.236-.445 2.477-1.206 3.522zM7.686 9.1a6.065 6.065 0 0 1-3.459 1.057 7.923 7.923 0 0 1 1.458-3.058L7.686 9.1zm-3.675 3.046c.077.002.154.014.231.014a8.05 8.05 0 0 0 4.877-1.626L10.586 12l-4.901 4.901a7.972 7.972 0 0 1-1.674-4.755zm12.294 2.745c1.042-.758 2.28-1.188 3.508-1.206a7.947 7.947 0 0 1-1.497 3.217l-2.011-2.011zm.597 3.425a7.935 7.935 0 0 1-3.059 1.47 6.05 6.05 0 0 1 1.057-3.472l2.002 2.002zm-5.044 1.686a7.922 7.922 0 0 1-4.761-1.686L12 13.414l1.463 1.463c-1.103 1.444-1.659 3.266-1.605 5.125zm8.124-8.31c-1.807-.018-3.633.61-5.108 1.768L13.414 12l4.901-4.901a7.968 7.968 0 0 1 1.667 4.593z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBasket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9h-1.42l-3.712-6.496-1.736.992L17.277 9H6.723l3.146-5.504-1.737-.992L4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.264A2.005 2.005 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9zm-3.764 11v1-1H6.764L4.31 11h15.38l-2.454 9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13h2v5H9zm4 0h2v5h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBaseball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2a9.937 9.937 0 0 0-7.071 2.938c-3.898 3.898-3.898 10.243 0 14.143 1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.899-3.899 3.899-10.244 0-14.143A9.937 9.937 0 0 0 11.99 2zm5.657 15.667a7.957 7.957 0 0 1-3.816 2.129l-.001-.037a6.199 6.199 0 0 1 .421-2.259l-1.863-.729a8.188 8.188 0 0 0-.552 3.239 7.953 7.953 0 0 1-5.503-2.344 7.965 7.965 0 0 1-2.332-5.503c.08.002.16.005.24.005a8.16 8.16 0 0 0 2.988-.558l-.73-1.862a6.156 6.156 0 0 1-2.281.412 7.936 7.936 0 0 1 2.115-3.809 7.963 7.963 0 0 1 3.972-2.168 5.974 5.974 0 0 1-.357 1.95l1.881.681a7.92 7.92 0 0 0 .482-2.701c0-.033-.004-.065-.005-.098 2.013.079 3.9.896 5.342 2.336a7.959 7.959 0 0 1 2.324 5.348 7.908 7.908 0 0 0-2.787.473l.684 1.88a5.91 5.91 0 0 1 1.935-.361 7.953 7.953 0 0 1-2.157 3.976z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.112 14.13a7.599 7.599 0 0 0-.926 1.121l1.656 1.12c.2-.296.43-.574.683-.826a6.428 6.428 0 0 1 1.178-.929l-1.049-1.703a8.408 8.408 0 0 0-1.542 1.217zM8.456 8.474a5.713 5.713 0 0 1-.827.681l1.119 1.658a7.72 7.72 0 0 0 1.122-.926 8.501 8.501 0 0 0 1.217-1.542L9.384 7.297a6.519 6.519 0 0 1-.928 1.177z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBarcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 18V6h16v12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h2v8H6zm3 0h1v8H9zm8 0h1v8h-1zm-4 0h3v8h-3zm-2 0h1v8h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBarcodeReader(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7h2v10H5zm9 0h1v10h-1zm-4 0h3v10h-3zM8 7h1v10H8zm8 0h3v10h-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5h4V3H4c-1.103 0-2 .897-2 2v4h2V5zm0 16h4v-2H4v-4H2v4c0 1.103.897 2 2 2zM20 3h-4v2h4v4h2V5c0-1.103-.897-2-2-2zm0 16h-4v2h4c1.103 0 2-.897 2-2v-4h-2v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBarChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6h2v14H9zm4 2h2v12h-2zm4-4h2v16h-2zM5 12h2v8H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBarChartSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm16.001 14H5V5h14l.001 14z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v10h-2zm4 3h2v7h-2zm-8 2h2v5H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBarChartAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h2v11h-2zm4-3h2v14h-2zM9 9h2v8H9zM4 19h16v2H4zm1-7h2v5H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBarChartAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-4V4c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H4c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9c0-1.103-.897-2-2-2zM4 11h4v8H4v-8zm6-1V4h4v15h-4v-9zm10 9h-4V9h4v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBandAid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.111 21.889a5.962 5.962 0 0 0 4.242-1.757l7.778-7.778a6.007 6.007 0 0 0 0-8.485 5.965 5.965 0 0 0-4.243-1.757 5.962 5.962 0 0 0-4.242 1.757l-7.778 7.778a6.007 6.007 0 0 0 0 8.485 5.965 5.965 0 0 0 4.243 1.757zm-2.829-8.828 7.778-7.778a3.976 3.976 0 0 1 2.828-1.171c1.069 0 2.073.416 2.829 1.171a4.006 4.006 0 0 1 0 5.657l-7.778 7.778a3.976 3.976 0 0 1-2.828 1.171 3.977 3.977 0 0 1-2.829-1.171 4.008 4.008 0 0 1 0-5.657z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "15",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.76 21a17.68 17.68 0 0 0 4 .43 13.89 13.89 0 0 0 9.93-3.69C23 12.37 21.06 4.11 21 3.76a1 1 0 0 0-.76-.76 17.91 17.91 0 0 0-4-.43 13.82 13.82 0 0 0-9.96 3.71C.94 11.63 2.94 19.89 3 20.24a1 1 0 0 0 .76.76zM7.7 7.7a11.86 11.86 0 0 1 8.49-3.1 17.57 17.57 0 0 1 3 .25c.31 1.87.91 7.67-2.86 11.44a11.91 11.91 0 0 1-8.55 3.11 17.16 17.16 0 0 1-2.93-.25c-.32-1.88-.92-7.67 2.85-11.45z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.29 15.29 1.42 1.42 1.79-1.79 1.79 1.79 1.42-1.42-1.8-1.79 1.59-1.59 1.79 1.8 1.42-1.42-1.8-1.79 1.8-1.79-1.42-1.42-1.79 1.8-1.79-1.8-1.42 1.42 1.8 1.79-1.59 1.59-1.79-1.8-1.42 1.42 1.8 1.79z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBaguette(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.64 21.71a8 8 0 0 0 5.6-2.47l6-6c2.87-2.87 3.31-7.11 1-9.45s-6.58-1.91-9.45 1l-6 6c-2.87 2.87-3.31 7.11-1 9.45a5.38 5.38 0 0 0 3.85 1.47zm-2-9 2.78 2.79 1.42-1.42-2.79-2.79 1.41-1.41 2.83 2.83 1.42-1.42-2.83-2.83 1.41-1.41 2.83 2.83 1.42-1.42-2.79-2.78c2-1.61 4.65-1.87 6-.47s1.09 4.56-1 6.62l-6 6c-2.06 2.05-5.09 2.5-6.62 1s-1.06-4.07.55-6.08z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.965 8.521C19.988 8.347 20 8.173 20 8c0-2.378-2.143-4.288-4.521-3.964C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.036C6.138 3.712 4 5.622 4 8c0 .173.012.347.035.521C2.802 9.214 2 10.535 2 12s.802 2.786 2.035 3.479A3.976 3.976 0 0 0 4 16c0 2.378 2.138 4.284 4.521 3.964C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.036C17.857 20.284 20 18.378 20 16c0-.173-.012-.347-.035-.521C21.198 14.786 22 13.465 22 12s-.802-2.786-2.035-3.479zm-1.442 5.403-1.102.293.434 1.053c.095.23.145.483.145.73 0 1.103-.897 2-2 2-.247 0-.499-.05-.73-.145l-1.054-.434-.293 1.102a1.99 1.99 0 0 1-3.846 0l-.293-1.102-1.054.434A1.935 1.935 0 0 1 8 18c-1.103 0-2-.897-2-2 0-.247.05-.5.145-.73l.434-1.053-1.102-.293a1.993 1.993 0 0 1 0-3.848l1.102-.293-.434-1.053A1.932 1.932 0 0 1 6 8c0-1.103.897-2 2-2 .247 0 .499.05.73.145l1.054.434.293-1.102a1.99 1.99 0 0 1 3.846 0l.293 1.102 1.054-.434C15.501 6.05 15.753 6 16 6c1.103 0 2 .897 2 2 0 .247-.05.5-.145.73l-.434 1.053 1.102.293a1.993 1.993 0 0 1 0 3.848z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiBadgeCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.035 15.479A3.976 3.976 0 0 0 4 16c0 2.378 2.138 4.284 4.521 3.964C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.036C17.857 20.284 20 18.378 20 16c0-.173-.012-.347-.035-.521C21.198 14.786 22 13.465 22 12s-.802-2.786-2.035-3.479C19.988 8.347 20 8.173 20 8c0-2.378-2.143-4.288-4.521-3.964C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.036C6.138 3.712 4 5.622 4 8c0 .173.012.347.035.521C2.802 9.214 2 10.535 2 12s.802 2.786 2.035 3.479zm1.442-5.403 1.102-.293-.434-1.053A1.932 1.932 0 0 1 6 8c0-1.103.897-2 2-2 .247 0 .499.05.73.145l1.054.434.293-1.102a1.99 1.99 0 0 1 3.846 0l.293 1.102 1.054-.434C15.501 6.05 15.753 6 16 6c1.103 0 2 .897 2 2 0 .247-.05.5-.145.73l-.434 1.053 1.102.293a1.993 1.993 0 0 1 0 3.848l-1.102.293.434 1.053c.095.23.145.483.145.73 0 1.103-.897 2-2 2-.247 0-.499-.05-.73-.145l-1.054-.434-.293 1.102a1.99 1.99 0 0 1-3.846 0l-.293-1.102-1.054.434A1.935 1.935 0 0 1 8 18c-1.103 0-2-.897-2-2 0-.247.05-.5.145-.73l.434-1.053-1.102-.293a1.993 1.993 0 0 1 0-3.848z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.742 10.71-1.408-1.42-3.331 3.299-1.296-1.296-1.414 1.414 2.704 2.704z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8.999c0 1.902.765 3.627 2 4.89V21a.998.998 0 0 0 1.447.895L12 20.118l3.553 1.776a.992.992 0 0 0 .972-.043c.295-.183.475-.504.475-.851v-7.11a6.976 6.976 0 0 0 2-4.891C19 5.14 15.86 2 12 2S5 5.14 5 8.999zm7.447 9.106a1 1 0 0 0-.895 0L9 19.382v-4.067c.911.434 1.926.685 3 .685s2.089-.25 3-.685v4.066l-2.553-1.276zM12 4c2.756 0 5 2.242 5 4.999A5.006 5.006 0 0 1 12 14c-2.757 0-5-2.243-5-5.001A5.005 5.005 0 0 1 12 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAtom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.102 20.898c.698.699 1.696 1.068 2.887 1.068 1.742 0 3.855-.778 6.012-2.127 2.156 1.35 4.27 2.127 6.012 2.127 1.19 0 2.188-.369 2.887-1.068 1.269-1.269 1.411-3.413.401-6.039-.358-.932-.854-1.895-1.457-2.859a16.792 16.792 0 0 0 1.457-2.859c1.01-2.626.867-4.771-.401-6.039-.698-.699-1.696-1.068-2.887-1.068-1.742 0-3.855.778-6.012 2.127-2.156-1.35-4.27-2.127-6.012-2.127-1.19 0-2.188.369-2.887 1.068C1.833 4.371 1.69 6.515 2.7 9.141c.359.932.854 1.895 1.457 2.859A16.792 16.792 0 0 0 2.7 14.859c-1.01 2.626-.867 4.77.402 6.039zm16.331-5.321c.689 1.79.708 3.251.052 3.907-.32.32-.815.482-1.473.482-1.167 0-2.646-.503-4.208-1.38a26.611 26.611 0 0 0 4.783-4.784c.336.601.623 1.196.846 1.775zM12 17.417a23.568 23.568 0 0 1-2.934-2.483A23.998 23.998 0 0 1 6.566 12 23.74 23.74 0 0 1 12 6.583a23.568 23.568 0 0 1 2.934 2.483 23.998 23.998 0 0 1 2.5 2.934A23.74 23.74 0 0 1 12 17.417zm6.012-13.383c.657 0 1.152.162 1.473.482.656.656.638 2.117-.052 3.907-.223.579-.51 1.174-.846 1.775a26.448 26.448 0 0 0-4.783-4.784c1.562-.876 3.041-1.38 4.208-1.38zM4.567 8.423c-.689-1.79-.708-3.251-.052-3.907.32-.32.815-.482 1.473-.482 1.167 0 2.646.503 4.208 1.38a26.448 26.448 0 0 0-4.783 4.784 13.934 13.934 0 0 1-.846-1.775zm0 7.154c.223-.579.51-1.174.846-1.775a26.448 26.448 0 0 0 4.783 4.784c-1.563.877-3.041 1.38-4.208 1.38-.657 0-1.152-.162-1.473-.482-.656-.656-.637-2.117.052-3.907z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2.574"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10c1.466 0 2.961-.371 4.442-1.104l-.885-1.793C14.353 19.698 13.156 20 12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8v1c0 .692-.313 2-1.5 2-1.396 0-1.494-1.819-1.5-2V8h-2v.025A4.954 4.954 0 0 0 12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5c1.45 0 2.748-.631 3.662-1.621.524.89 1.408 1.621 2.838 1.621 2.273 0 3.5-2.061 3.5-4v-1c0-5.514-4.486-10-10-10zm0 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArrowToTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm.707 11.707L11 11.414V20h2v-8.586l4.293 4.293 1.414-1.414L12 7.586l-6.707 6.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArrowToRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zM4 13h8.586l-4.293 4.293 1.414 1.414L16.414 12 9.707 5.293 8.293 6.707 12.586 11H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArrowToLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm10.293-.707L7.586 12l6.707 6.707 1.414-1.414L11.414 13H20v-2h-8.586l4.293-4.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArrowToBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm5-14v8.586L6.707 8.293 5.293 9.707 12 16.414l6.707-6.707-1.414-1.414L13 12.586V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArrowFromTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm6 16.414 6.707-6.707-1.414-1.414L13 16.586V8h-2v8.586l-4.293-4.293-1.414 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArrowFromRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zm-2 5H7.414l4.293-4.293-1.414-1.414L3.586 12l6.707 6.707 1.414-1.414L7.414 13H16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArrowFromLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm4 7h8.586l-4.293 4.293 1.414 1.414L20.414 12l-6.707-6.707-1.414 1.414L16.586 11H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArrowFromBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm6-14.414-6.707 6.707 1.414 1.414L11 7.414V16h2V7.414l4.293 4.293 1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArrowBack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArea(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm16.002 14H5V5h14l.002 14z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h2V7h-5v2h3zm-3 3H9v-3H7v5h5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.291-2.999-2.998A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.291A.994.994 0 0 0 2 5.999V19c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5.999a.994.994 0 0 0-.294-.708zM6.414 4h11.172l.999.999H5.415L6.414 4zM4 19V6.999h16L20.002 19H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12H9v-2H7v4h10v-4h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArchiveOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.292A.994.994 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM4 19V7h16l.002 12H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h3v3h4v-3h3l-5-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArchiveIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.292A.994.994 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM4 19V7h16l.002 12H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-4v3H7l5 5 5-5h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiArch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22h1v-6.995c.006-.502.177-3.005 3-3.005s2.994 2.503 3 3v7h7v-2h-1V4h1V2H2v2h1v16H2v2h6zM19 4v2H5V4h14zM5 8h14v12h-2v-5c0-1.729-1.045-5-5-5s-5 3.271-5 5v5H5V8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAperture(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm2.113 13H9.986l-1.723-3.094L10.202 9h3.736l1.871 3.062L14.113 15zM4 12c0-.953.186-1.87.508-2.727L7.696 15H4.61A7.757 7.757 0 0 1 4 12zm12.283-3h3.106A7.74 7.74 0 0 1 20 12c0 .844-.143 1.66-.397 2.432L16.283 9zm1.905-2h-6.653l1.905-2.857c1.886.359 3.562 1.403 4.748 2.857zm-7.095-2.941L9.132 7H9v.197L7.17 9.942 5.65 7.214c1.3-1.703 3.249-2.895 5.443-3.155zM5.812 17h7.147l-1.709 2.961C9.084 19.748 7.141 18.63 5.812 17zm7.828 2.82 3.357-5.815 1.544 2.526c-1.154 1.642-2.901 2.854-4.901 3.289z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAngry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-3 0-4 3-4 3h8s-1-3-4-3zm-2.439-2.439c.014-.014.023-.03.037-.044l1.031.413.742-1.857-5-2-.742 1.856 1.373.549L7 10.5a1.499 1.499 0 0 0 2.561 1.061zm3.068-1.49.742 1.857 1.037-.415c.011.011.019.024.029.035a1.488 1.488 0 0 0 2.112 0c.271-.271.438-.644.438-1.056l-.001-.01 1.386-.554-.742-1.857-5.001 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAnchor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m22 15-3-4-3 4h1.906c-.436 2.469-2.438 4.471-4.906 4.906V13h2v-2h-2V9.336c1.543-.459 2.714-1.923 2.714-3.621C15.714 3.666 14.048 2 12 2S8.286 3.666 8.286 5.715c0 1.698 1.171 3.162 2.714 3.621V11H9v2h2v6.906C8.531 19.471 6.529 17.469 6.094 15H8l-3-4-3 4h2.073c.511 3.885 3.929 7 7.927 7s7.416-3.115 7.927-7H22zM10.286 5.715C10.286 4.77 11.055 4 12 4s1.714.77 1.714 1.715c0 .951-.801 1.785-1.714 1.785s-1.714-.834-1.714-1.785z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAnalyse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h2a7.986 7.986 0 0 1 2.337-5.663 7.91 7.91 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.488 2.488 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059a9.928 9.928 0 0 0-3.18 2.139 9.92 9.92 0 0 0-2.14 3.179A10.005 10.005 0 0 0 2 12zm17.373 3.122c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.965 9.965 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538s4.538-2.036 4.538-4.538S14.502 7.462 12 7.462zm0 7.076c-1.399 0-2.538-1.139-2.538-2.538S10.601 9.462 12 9.462s2.538 1.139 2.538 2.538-1.139 2.538-2.538 2.538z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAlignRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zm5-4h11v2H9zm-5-4h16v2H4zm0-8h16v2H4zm5 4h11v2H9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAlignMiddle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zm3-4h10v2H7zm-3-4h16v2H4zm0-8h16v2H4zm3 4h10v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAlignLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zm0-4h11v2H4zm0-4h16v2H4zm0-8h16v2H4zm0 4h11v2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAlignJustify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h16v2H4zm0-4h16v2H4zm0 8h16v2H4zm0 4h16v2H4zm2 4h12v2H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAlbum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.99",
                    "cy": "11.99",
                    "r": "2.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a6 6 0 0 0-6 6h2a4 4 0 0 1 4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAlarm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm0 16c-3.794 0-7-3.206-7-7s3.206-7 7-7 7 3.206 7 7-3.206 7-7 7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12V8h-2v6h6v-2zm4.284-8.293 1.412-1.416 3.01 3-1.413 1.417zm-10.586 0-2.99 2.999L2.29 5.294l2.99-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAlarmSnooze(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm0 16c-3.794 0-7-3.206-7-7s3.206-7 7-7 7 3.206 7 7-3.206 7-7 7zm8.292-13.292-3.01-3 1.412-1.417 3.01 3zM6.698 3.707l-2.99 2.999L2.29 5.294l2.99-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.832 10.555A1 1 0 0 0 14 9H9v2h3.132l-2.964 4.445A1 1 0 0 0 10 17h5v-2h-3.132l2.964-4.445z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAlarmOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.292 6.708-3.01-3 1.412-1.417 3.01 3zm1.415 13.585-2.287-2.287C20.409 16.563 21 14.838 21 13c0-4.879-4.121-9-9-9-1.838 0-3.563.591-5.006 1.58L5.91 4.496l.788-.79-1.416-1.412-.786.788-.789-.789-1.414 1.414 18 18 1.414-1.414zM12 6c3.794 0 7 3.206 7 7 0 1.292-.387 2.507-1.027 3.559L15.414 14H17v-2h-3.586L13 11.586V8h-2v1.586L8.441 7.027C9.493 6.387 10.708 6 12 6zM4.305 8.426A8.792 8.792 0 0 0 3 13c0 4.879 4.121 9 9 9a8.792 8.792 0 0 0 4.574-1.305l-1.461-1.461A6.801 6.801 0 0 1 12 20c-3.794 0-7-3.206-7-7 0-1.111.281-2.169.766-3.113L4.305 8.426z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAlarmExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c4.879 0 9-4.121 9-9s-4.121-9-9-9-9 4.121-9 9 4.121 9 9 9zm0-16c3.794 0 7 3.206 7 7s-3.206 7-7 7-7-3.206-7-7 3.206-7 7-7zm5.284-2.293 1.412-1.416 3.01 3-1.413 1.417zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v5h-2zm0 6h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAlarmAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm0 16c-3.794 0-7-3.206-7-7s3.206-7 7-7 7 3.206 7 7-3.206 7-7 7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8h-2v4H7v2h4v4h2v-4h4v-2h-4zm7.292-1.292-3.01-3 1.412-1.417 3.01 3zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAdjust(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12a7 7 0 0 0-7-7v14a7 7 0 0 0 7-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAddToQueue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm11-2h-2v3h-3v2h3v3h2v-3h3V9h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAccessibility(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.836 12.014-4.345.725 3.29-4.113a1 1 0 0 0-.227-1.457l-6-4a.999.999 0 0 0-1.262.125l-4 4 1.414 1.414 3.42-3.42 2.584 1.723-2.681 3.352a5.913 5.913 0 0 0-5.5.752l1.451 1.451A3.972 3.972 0 0 1 8 12c2.206 0 4 1.794 4 4 0 .739-.216 1.425-.566 2.02l1.451 1.451A5.961 5.961 0 0 0 14 16c0-.445-.053-.878-.145-1.295L17 14.181V20h2v-7a.998.998 0 0 0-1.164-.986zM8 20c-2.206 0-4-1.794-4-4 0-.739.216-1.425.566-2.02l-1.451-1.451A5.961 5.961 0 0 0 2 16c0 3.309 2.691 6 6 6 1.294 0 2.49-.416 3.471-1.115l-1.451-1.451A3.972 3.972 0 0 1 8 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiAbacus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h2v18H2zm18 0h2v18h-2zM5 13h2v1h2v-1h2v1h2v-1h4v1h2v-4h-2v1h-4v-1h-2v1H9v-1H7v1H5zm0-9v4h2V7h8v1h2V7h2V5h-2V4h-2v1H7V4zm0 13v3h2v-1h2v1h2v-1h8v-2h-8v-1H9v1H7v-1H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidZoomOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zM6 9h8v2H6V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidZoomIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8zm4 9h-3v3H9v-3H6V9h3V6h2v3h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidZap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.98 11.802a.995.995 0 0 0-.738-.771l-6.86-1.716 2.537-5.921a.998.998 0 0 0-.317-1.192.996.996 0 0 0-1.234.024l-11 9a1 1 0 0 0 .39 1.744l6.719 1.681-3.345 5.854A1.001 1.001 0 0 0 8 22a.995.995 0 0 0 .6-.2l12-9a1 1 0 0 0 .38-.998z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidYinYang(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.062 4.938A9.942 9.942 0 0 0 12.016 2h-.026a9.94 9.94 0 0 0-7.071 2.938c-3.898 3.898-3.898 10.243 0 14.143 1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.9-3.899 3.9-10.243.001-14.143zM13.5 15a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 13.5 15zM6.333 6.353A7.953 7.953 0 0 1 11.99 4l.026.001c1.652.008 3.242 1.066 3.55 2.371.366 1.552-1.098 3.278-4.018 4.737-5.113 2.555-5.312 5.333-4.975 6.762l.008.021c-.082-.075-.169-.146-.249-.226-3.118-3.119-3.118-8.194.001-11.313z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "7.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidXSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5zm-4.793 9.793-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidXCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWrench(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.512 6.112-3.89 3.889-3.535-3.536 3.889-3.889a6.501 6.501 0 0 0-8.484 8.486l-6.276 6.275a.999.999 0 0 0 0 1.414l2.122 2.122a.999.999 0 0 0 1.414 0l6.275-6.276a6.501 6.501 0 0 0 7.071-1.414 6.504 6.504 0 0 0 1.414-7.071z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWinkTongue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19v-4h-4v4c0 1.103.897 2 2 2s2-.897 2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c0 4.434 2.903 8.198 6.906 9.505A3.969 3.969 0 0 1 8 19v-2.499C6.412 15.027 6 13 6 13h12s-.411 2.027-2 3.501V19c0 .953-.349 1.816-.906 2.504C19.097 20.197 22 16.434 22 12c0-5.514-4.486-10-10-10zm-3.5 9a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8.5 11zm4.5 0s.5-2 2.5-2c1.999 0 2.5 2 2.5 2h-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWinkSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 9zm7.741 7.244a5.982 5.982 0 0 1-3.034 1.634 6.042 6.042 0 0 1-3.541-.349 5.997 5.997 0 0 1-2.642-2.176l1.658-1.117c.143.211.307.41.488.59a3.988 3.988 0 0 0 1.273.86c.243.102.495.181.749.232a4.108 4.108 0 0 0 1.616 0c.253-.052.505-.131.75-.233.234-.1.464-.224.679-.368.208-.142.407-.306.591-.489.183-.182.347-.381.489-.592l1.658 1.117c-.214.32-.461.62-.734.891zM13 12s.5-2 2.5-2c1.999 0 2.5 2 2.5 2h-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17.916V20H9v2h6v-2h-2v-2.084c3.162-.402 5.849-2.66 6.713-5.793.264-.952.312-2.03.143-3.206l-.866-6.059A1 1 0 0 0 18 2H6a1 1 0 0 0-.99.858l-.865 6.058c-.169 1.177-.121 2.255.143 3.206.863 3.134 3.55 5.392 6.712 5.794zM17.133 4l.57 4H6.296l.571-4h10.266z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWindowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-3 3h2v2h-2V6zm-3 0h2v2h-2V6zM4 19v-9h16.001l.001 9H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWidget(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm0 10h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm7.293-14.707-3.586-3.586a.999.999 0 0 0-1.414 0l-3.586 3.586a.999.999 0 0 0 0 1.414l3.586 3.586a.999.999 0 0 0 1.414 0l3.586-3.586a.999.999 0 0 0 0-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWebcam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.963 0-9 4.037-9 9 0 3.328 1.82 6.232 4.513 7.79l-2.067 1.378A1 1 0 0 0 6 22h12a1 1 0 0 0 .555-1.832l-2.067-1.378C19.18 17.232 21 14.328 21 11c0-4.963-4.037-9-9-9zm0 16c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm-1.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 10.5 11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8h-2v5h5v-2h-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.999 12c0-2.953-1.612-5.53-3.999-6.916V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2.083C5.613 6.469 4.001 9.047 4.001 12a8.003 8.003 0 0 0 4.136 7H8v2.041a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V19h-.139a8 8 0 0 0 4.138-7zm-8 5.999A6.005 6.005 0 0 1 6.001 12a6.005 6.005 0 0 1 5.998-5.999c3.31 0 6 2.691 6 5.999a6.005 6.005 0 0 1-6 5.999z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWatchAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c0-.909-.613-1.67-1.445-1.912l-1.31-3.443A1 1 0 0 0 14.311 2H8.689a1 1 0 0 0-.934.645l-1.31 3.443A1.996 1.996 0 0 0 5 8v8c0 .909.613 1.67 1.445 1.912l1.31 3.443a1 1 0 0 0 .934.645h5.621c.415 0 .787-.257.935-.645l1.31-3.443A1.996 1.996 0 0 0 18 16v-2h1v-4h-1V8zm-1.998 8H7V8h9l.002 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWasher(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16a1 1 0 0 0 1-1V5c0-1.654-1.346-3-3-3H6C4.346 2 3 3.346 3 5v16a1 1 0 0 0 1 1zM18 3.924a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 7c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.766 16.929c1.399-.261 2.571-1.315 3.023-2.665a3.853 3.853 0 0 0-.153-2.893.482.482 0 0 0-.544-.266c-.604.149-1.019.448-1.5.801-.786.577-1.765 1.294-3.592 1.294-.813 0-1.45-.146-1.984-.354l-.013.009a4.006 4.006 0 0 0 4.763 4.074z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm-2 9h-2v-4h2v4zM5 7a1.001 1.001 0 0 1 0-2h13v2H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidWalletAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h8v6h-8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h15c1.103 0 2-.897 2-2v-2h-8c-1.103 0-2-.897-2-2V9c0-1.103.897-2 2-2h8V5c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVolume(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697L14 21.868V2.132L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVolumeMute(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.727 6.313-4.02-4.02-1.414 1.414 18 18 1.414-1.414-2.02-2.02A9.578 9.578 0 0 0 21.999 12c0-4.091-2.472-7.453-5.999-9v2c2.387 1.386 3.999 4.047 3.999 7a8.13 8.13 0 0 1-1.671 4.914l-1.286-1.286C17.644 14.536 18 13.19 18 12c0-1.771-.775-3.9-2-5v7.586l-2-2V2.132L7.727 6.313zM4 17h2.697L14 21.868v-3.747L3.102 7.223A1.995 1.995 0 0 0 2 9v6c0 1.103.897 2 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVolumeLow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697L14 21.868V2.132L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zM16 7v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVolumeFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21c3.527-1.547 5.999-4.909 5.999-9S19.527 4.547 16 3v2c2.387 1.386 3.999 4.047 3.999 7S18.387 17.614 16 19v2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5zM4 17h2.697L14 21.868V2.132L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11h-.17c-1.053 0-1.958-.669-2.357-1.644l-.021-.049c-.408-.977-.249-2.097.5-2.846l.119-.119a.999.999 0 1 0-1.414-1.414l-.119.119c-.749.749-1.869.908-2.846.5l-.049-.021C13.669 5.128 13 4.218 13 3.165v-.081C13 2.447 12.553 2 12 2s-1 .447-1 1v.036c0 1.096-.66 2.084-1.673 2.503l-.006.003a2.71 2.71 0 0 1-2.953-.588l-.025-.025a.999.999 0 1 0-1.414 1.414l.036.036a2.69 2.69 0 0 1 .583 2.929l-.027.064A2.638 2.638 0 0 1 3.085 11h-.001C2.447 11 2 11.447 2 12s.447 1 1 1h.068a2.66 2.66 0 0 1 2.459 1.644l.021.049a2.69 2.69 0 0 1-.583 2.929l-.036.036a.999.999 0 1 0 1.414 1.414l.036-.036a2.689 2.689 0 0 1 2.929-.583l.143.06A2.505 2.505 0 0 1 11 20.83v.085c0 .638.447 1.085 1 1.085s1-.448 1-1v-.17c0-1.015.611-1.93 1.55-2.318l.252-.104a2.508 2.508 0 0 1 2.736.545l.119.119a.999.999 0 1 0 1.414-1.414l-.119-.119c-.749-.749-.908-1.869-.5-2.846l.021-.049c.399-.975 1.309-1.644 2.362-1.644h.08c.638 0 1.085-.447 1.085-1s-.447-1-1-1zM8 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm5 3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1-4.5a2 2 0 1 1 .001-4.001A2 2 0 0 1 14 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVirusBlock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.952 17.538c-.749-.749-.908-1.869-.5-2.846l.021-.049c.399-.974 1.309-1.643 2.362-1.643h.08c.638 0 1.085-.447 1.085-1s-.447-1-1-1h-.17c-1.053 0-1.958-.669-2.357-1.644l-.021-.049c-.408-.977-.249-2.097.5-2.846l.119-.119a.999.999 0 1 0-1.414-1.414l-.119.119c-.749.749-1.869.908-2.846.5l-.049-.021C13.669 5.128 13 4.218 13 3.165v-.081C13 2.447 12.553 2 12 2s-1 .447-1 1v.036c0 1.096-.66 2.084-1.673 2.503l-.006.003a2.71 2.71 0 0 1-2.953-.588l-.025-.025-2.636-2.636-1.414 1.414 18 18 1.414-1.414-2.636-2.636-.119-.119zM12 10a2 2 0 1 1 2 2c-.257 0-.501-.053-.728-.142l-1.131-1.131A1.998 1.998 0 0 1 12 10zm-4 3a1 1 0 0 1-1-1 .99.99 0 0 1 .244-.635L5.431 9.552A2.634 2.634 0 0 1 3.085 11h-.001C2.447 11 2 11.447 2 12s.447 1 1 1h.068a2.66 2.66 0 0 1 2.459 1.644l.021.049a2.69 2.69 0 0 1-.583 2.929l-.036.036a.999.999 0 1 0 1.414 1.414l.036-.036a2.689 2.689 0 0 1 2.929-.583l.143.06A2.505 2.505 0 0 1 11 20.83v.085c0 .638.447 1.085 1 1.085s1-.448 1-1v-.17c0-.976.568-1.853 1.443-2.266l-5.809-5.809A.98.98 0 0 1 8 13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVideos(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12a2 2 0 0 0 2 2h12v-2H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-9 12V6l7 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVideoRecording(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9c0-1.103-.897-2-2-2h-1.434l-2.418-4.029A2.008 2.008 0 0 0 10.434 2H5v2h5.434l1.8 3H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3l4 2v-7l-4 2V9zm-7 8H5v-2h6v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVideoPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3.333L22 17V7l-4 3.333V7zm-4 6h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVideoOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h10.879L2.145 6.265A1.977 1.977 0 0 0 2 7v10c0 1.103.897 2 2 2zM18 7c0-1.103-.897-2-2-2H6.414L3.707 2.293 2.293 3.707l18 18 1.414-1.414L18 16.586v-2.919L22 17V7l-4 3.333V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVial(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22a4.965 4.965 0 0 0 3.535-1.465l9.193-9.193.707.708 1.414-1.414-8.485-8.486-1.414 1.414.708.707-9.193 9.193C2.521 14.408 2 15.664 2 17s.521 2.592 1.465 3.535A4.965 4.965 0 0 0 7 22zM18.314 9.928 15.242 13H6.758l7.314-7.314 4.242 4.242z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidVector(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.277 8c.347.596.985 1 1.723 1a2 2 0 0 0 0-4c-.738 0-1.376.404-1.723 1H16V4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H5.723C5.376 5.404 4.738 5 4 5a2 2 0 0 0 0 4c.738 0 1.376-.404 1.723-1H8v.368C5.134 9.839 4.319 12.534 4.092 14H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.877c.197-.959.718-2.406 2.085-3.418A.984.984 0 0 0 9 11h6a.98.98 0 0 0 .792-.419c1.373 1.013 1.895 2.458 2.089 3.419H17a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.092c-.227-1.466-1.042-4.161-3.908-5.632V8h2.277zM14 9h-4V5h4v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.052c1.995 0 3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5 1.505 3.5 3.5 3.5zM9 13H7c-2.757 0-5 2.243-5 5v1h12v-1c0-2.757-2.243-5-5-5zm11.293-4.707L18 10.586l-2.293-2.293-1.414 1.414 2.292 2.292-2.293 2.293 1.414 1.414 2.293-2.293 2.294 2.294 1.414-1.414L19.414 12l2.293-2.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserVoice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.052c1.995 0 3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5 1.505 3.5 3.5 3.5zM9 13H7c-2.757 0-5 2.243-5 5v1h12v-1c0-2.757-2.243-5-5-5zm9.364-10.364L16.95 4.05C18.271 5.373 19 7.131 19 9s-.729 3.627-2.05 4.95l1.414 1.414C20.064 13.663 21 11.403 21 9s-.936-4.663-2.636-6.364z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 5.464 14.121 6.88C14.688 7.445 15 8.198 15 9s-.312 1.555-.879 2.12l1.414 1.416C16.479 11.592 17 10.337 17 9s-.521-2.592-1.465-3.536z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h1zm6-17.001c1.647 0 3 1.351 3 3C15 9.647 13.647 11 12 11S9 9.647 9 7.999c0-1.649 1.353-3 3-3zM6 17.25c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5V18H6v-.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 8.552c0 1.995 1.505 3.5 3.5 3.5s3.5-1.505 3.5-3.5-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5zM19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h4l3 3 3-3h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-7 3c1.727 0 3 1.272 3 3s-1.273 3-3 3c-1.726 0-3-1.272-3-3s1.274-3 3-3zM7.177 16c.558-1.723 2.496-3 4.823-3s4.266 1.277 4.823 3H7.177z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11h8v2h-8zM4.5 8.552c0 1.995 1.505 3.5 3.5 3.5s3.5-1.505 3.5-3.5-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5 4.5 6.505 4.5 8.5 6.005 12 8 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm0 5c1.727 0 3 1.272 3 3s-1.273 3-3 3c-1.726 0-3-1.272-3-3s1.274-3 3-3zm-5.106 9.772c.897-1.32 2.393-2.2 4.106-2.2h2c1.714 0 3.209.88 4.106 2.2C15.828 18.14 14.015 19 12 19s-3.828-.86-5.106-2.228z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.052c1.995 0 3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5 1.505 3.5 3.5 3.5zM9 13H7c-2.757 0-5 2.243-5 5v1h12v-1c0-2.757-2.243-5-5-5zm11.294-4.708-4.3 4.292-1.292-1.292-1.414 1.414 2.706 2.704 5.712-5.702z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.988 22a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h11.988zM9 5h6v2H9V5zm5.25 6.25A2.26 2.26 0 0 1 12 13.501c-1.235 0-2.25-1.015-2.25-2.251S10.765 9 12 9a2.259 2.259 0 0 1 2.25 2.25zM7.5 18.188c0-1.664 2.028-3.375 4.5-3.375s4.5 1.711 4.5 3.375v.563h-9v-.563z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUserAccount(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-6 2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM19 15H9v-.25C9 12.901 11.254 11 14 11s5 1.901 5 3.75V15z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUpvote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14h4v7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7h4a1.001 1.001 0 0 0 .781-1.625l-8-10c-.381-.475-1.181-.475-1.562 0l-8 10A1.001 1.001 0 0 0 4 14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUpsideDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8.507 15a1.494 1.494 0 1 1 .001-2.987A1.494 1.494 0 0 1 8.507 15zm4.301-6.919a4.108 4.108 0 0 0-1.616 0 4.12 4.12 0 0 0-.751.233c-.234.1-.463.224-.678.368a4.077 4.077 0 0 0-1.08 1.082L7.024 8.646a6.026 6.026 0 0 1 2.639-2.175 6.097 6.097 0 0 1 1.128-.35 6.061 6.061 0 0 1 2.415 0 5.919 5.919 0 0 1 2.148.903 6.078 6.078 0 0 1 1.621 1.622l-1.658 1.117a3.994 3.994 0 0 0-.488-.59 3.988 3.988 0 0 0-2.021-1.092zM15.5 15a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 15.5 15z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUpArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUpArrowSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm7-14 5 5h-4v5h-2v-5H7l5-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUpArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-15 5 5h-4v5h-2v-5H7l5-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUpArrowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18v-6h5l-6-7-6 7h5v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidUniversalAccess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 3.33A1.67 1.67 0 1 1 10.33 7 1.67 1.67 0 0 1 12 5.33zm3.33 12.5-1.66.84-1.39-3.89h-.56l-1.39 3.89-1.66-.84 1.66-4.72v-1.66L7 10.33l.56-1.66 3.33 1.11h2.22l3.33-1.11.56 1.66-3.33 1.12v1.66z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-5.586l2.293-2.293-1.414-1.414L12 5.586 8.707 2.293 7.293 3.707 9.586 6H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTruck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.15 8a2 2 0 0 0-1.72-1H15V5a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 1 1.73 3.49 3.49 0 0 0 7 .27h3.1a3.48 3.48 0 0 0 6.9 0 2 2 0 0 0 2-2v-3a1.07 1.07 0 0 0-.14-.52zM15 9h2.43l1.8 3H15zM6.5 19A1.5 1.5 0 1 1 8 17.5 1.5 1.5 0 0 1 6.5 19zm10 0a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTrophy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v3c0 4.31 1.8 6.91 4.82 7A6 6 0 0 0 11 17.91V20H9v2h6v-2h-2v-2.09A6 6 0 0 0 17.18 15c3-.1 4.82-2.7 4.82-7V5a1 1 0 0 0-1-1zM4 8V6h2v6.83C4.22 12.08 4 9.3 4 8zm14 4.83V6h2v2c0 1.3-.22 4.08-2 4.83z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20 18-4-5h3l-4-5h2l-5-6-5 6h2l-4 5h3l-4 5h7v4h2v-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTreeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 10-6-8-6 8h3l-5 8h7v4h2v-4h7l-5-8h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H5v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7H6zm4 12H8v-9h2v9zm6 0h-2v-9h2v9zm.618-15L15 2H9L7.382 4H3v2h18V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTrashAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H5v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7H6zm10.618-3L15 2H9L7.382 4H3v2h18V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTrain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.375 2H7.621c-.224 0-1.399.065-2.503 1.351C4.031 4.616 4 5.862 4 6v11a2 2 0 0 0 2 2h1l-2 3h2.353l.667-1h8l.677 1H19l-2-3h1a2 2 0 0 0 2-2V6c.001-.188-.032-1.434-1.129-2.665C17.715 2.037 16.509 2 16.375 2zM10 4h4v2h-4V4zM7.5 17a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 7.5 17zm9 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16.5 17zm1.5-5H6V8h12v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTraffic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.958 16 .043 1.042c.005.12.142 2.255 2.999 3.338v1.12a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1.12c2.857-1.083 2.994-3.218 2.999-3.338L21.043 16H18v-1.62c2.857-1.083 2.994-3.218 2.999-3.338L21.043 10H18V8.38c2.857-1.083 2.994-3.218 2.999-3.338L21.043 4H18V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V4H2.958l.043 1.042c.005.12.142 2.255 2.999 3.338V10H2.958l.043 1.042c.005.12.142 2.255 2.999 3.338V16H2.958zM12 4a2 2 0 1 1-.001 4.001A2 2 0 0 1 12 4zm0 6a2 2 0 1 1-.001 4.001A2 2 0 0 1 12 10zm0 6a2 2 0 1 1-.001 4.001A2 2 0 0 1 12 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTrafficCone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.649 16H5.352l-1.06 3H2v2h20v-2h-2.292zM6.057 14h11.886l-1.412-4H7.469zM13 2h-2a1 1 0 0 0-.943.667L8.175 8h7.65l-1.882-5.333A1 1 0 0 0 13 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTrafficBarrier(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-2V3h-2v3H7V3H5v3H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2v6h2v-6h10v6h2v-6h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM4.42 13l2.857-5H9.58l-2.857 5H4.42zm7.857-5h2.303l-2.857 5H9.42l2.857-5zm5 0h2.303l-2.857 5H14.42l2.857-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTorch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11.648V20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-8.352c1.067-.552 3-1.928 3-4.648V5H5v2c0 2.72 1.933 4.096 3 4.648zM11 11h2v3h-2v-3zM5 2h14v2H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1 9H4.069a7.965 7.965 0 0 1 .52-2H11v2zm0 4H4.589a7.965 7.965 0 0 1-.52-2H11v2zm0-10.931V7H5.765A7.996 7.996 0 0 1 11 4.069zM5.765 17H11v2.931A7.996 7.996 0 0 1 5.765 17z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidToggleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.296 0-5.982 2.682-6 5.986v.042A6.01 6.01 0 0 0 8 18h8c3.309 0 6-2.691 6-6s-2.691-6-6-6zm0 9c-1.627 0-3-1.373-3-3s1.373-3 3-3 3 1.373 3 3-1.373 3-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidToggleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.296 0-5.982 2.682-6 5.986v.042A6.01 6.01 0 0 0 8 18h8a6.01 6.01 0 0 0 6-5.994v-.018C21.985 8.685 19.297 6 16 6zm-8 9c-1.627 0-3-1.373-3-3s1.373-3 3-3 3 1.373 3 3-1.373 3-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidToTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h4v6h6v-6h4l-7-8zM4 3h16v2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-6.447 9.105 2.459-1.229-1.567-1.044 1.109-1.664 3 2a1 1 0 0 1-.108 1.727l-4 2-.893-1.79zM8 17s1-3 4-3 4 3 4 3H8zm9.553-4.105-4-2a1 1 0 0 1-.108-1.727l3-2 1.109 1.664-1.566 1.044 2.459 1.229-.894 1.79z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTimer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3h4v2h-4zM3 8h4v2H3zm0 8h4v2H3zm-1-4h3.99v2H2zm19.707-5.293-1.414-1.414L18.586 7A6.937 6.937 0 0 0 15 6c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7a6.968 6.968 0 0 0-1.855-4.73l1.562-1.563zM16 14h-2V8.958h2V14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTime(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.25 2c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zM18 13h-6.75V6h2v5H18v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTimeFive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3.293 14.707L11 12.414V6h2v5.586l3.707 3.707-1.414 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidThermometer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16a3.001 3.001 0 0 0 6 0c0-.353-.072-.686-.184-1H9.184A2.962 2.962 0 0 0 9 16z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V4h-3.185A2.995 2.995 0 0 0 12 2c-1.654 0-3 1.346-3 3v5.8A6.027 6.027 0 0 0 6 16c0 3.309 2.691 6 6 6s6-2.691 6-6a6.027 6.027 0 0 0-3-5.2V10h3V8h-3V6h3zm-4.405 6.324A4.033 4.033 0 0 1 16 16c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-1.585.944-3.027 2.405-3.676l.595-.263V5a1 1 0 0 1 2 0v7.061l.595.263z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTerminal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6.414 15.707 5 14.293 7.293 12 5 9.707l1.414-1.414L10.121 12l-3.707 3.707zM19 16h-7v-2h7v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTennisBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 19.071a9.953 9.953 0 0 0 6.692 2.906c-.463-2.773.365-5.721 2.5-7.856 2.136-2.135 5.083-2.963 7.856-2.5-.092-2.433-1.053-4.839-2.906-6.692s-4.26-2.814-6.692-2.906c.463 2.773-.365 5.721-2.5 7.856-2.136 2.135-5.083 2.963-7.856 2.5a9.944 9.944 0 0 0 2.906 6.692z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 15.535a6.996 6.996 0 0 0-1.911 6.318 9.929 9.929 0 0 0 8.229-8.229 6.999 6.999 0 0 0-6.318 1.911zm-7.07-7.07a6.996 6.996 0 0 0 1.911-6.318 9.929 9.929 0 0 0-8.23 8.229 7 7 0 0 0 6.319-1.911z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTaxi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.155-1.368-4.104A2.995 2.995 0 0 0 16.559 4H14V2h-4v2H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2 2 0 0 0 2 12v5c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.277A1.99 1.99 0 0 0 22 17v-5a2 2 0 0 0-1.228-1.845zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6zM5.5 16a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 16zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.842 6.218a1.977 1.977 0 0 0-.424-.628A1.99 1.99 0 0 0 20 5H8c-.297 0-.578.132-.769.359l-5 6c-.309.371-.309.91 0 1.281l5 6c.191.228.472.36.769.36h12a1.977 1.977 0 0 0 1.41-.582A1.99 1.99 0 0 0 22 17V7c0-.266-.052-.525-.158-.782z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTagX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.842 6.218a1.977 1.977 0 0 0-.424-.628A1.99 1.99 0 0 0 20 5H8c-.297 0-.578.132-.769.359l-5 6c-.309.371-.309.91 0 1.281l5 6c.191.228.472.36.769.36h12a1.977 1.977 0 0 0 1.41-.582A1.99 1.99 0 0 0 22 17V7c0-.266-.052-.525-.158-.782zm-4.135 8.075-1.414 1.414L14 13.414l-2.293 2.293-1.414-1.414L12.586 12l-2.293-2.293 1.414-1.414L14 10.586l2.293-2.293 1.414 1.414L15.414 12l2.293 2.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTagAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.868 11.504-4-7A1 1 0 0 0 17 4H3a1 1 0 0 0-.868 1.496L5.849 12l-3.717 6.504A1 1 0 0 0 3 20h14a1 1 0 0 0 .868-.504l4-7a.998.998 0 0 0 0-.992z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTachometer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C6.486 4 2 8.486 2 14a9.89 9.89 0 0 0 1.051 4.445c.17.34.516.555.895.555h16.107c.379 0 .726-.215.896-.555A9.89 9.89 0 0 0 22 14c0-5.514-4.486-10-10-10zm5.022 5.022L13.06 15.06a1.53 1.53 0 0 1-2.121.44 1.53 1.53 0 0 1 0-2.561l6.038-3.962a.033.033 0 0 1 .045.01.034.034 0 0 1 0 .035z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidTShirt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.316 4.055C19.556 3.478 15 1.985 15 2a3 3 0 1 1-6 0c0-.015-4.556 1.478-6.317 2.055A.992.992 0 0 0 2 5.003v3.716a1 1 0 0 0 1.242.97L6 9v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9l2.758.689A1 1 0 0 0 22 8.719V5.003a.992.992 0 0 0-.684-.948z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSushi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12.07",
                    "cy": "7",
                    "rx": "3",
                    "ry": "1.71"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.07 22c4.48 0 8-2.2 8-5V7c0-2.8-3.52-5-8-5s-8 2.2-8 5v10c0 2.8 3.51 5 8 5zm0-18c3.53 0 6 1.58 6 3a2 2 0 0 1-.29.87c-.68 1-2.53 2-5 2.12h-1.39C8.88 9.83 7 8.89 6.35 7.84a2.16 2.16 0 0 1-.28-.76V7c0-1.42 2.46-3 6-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.995 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007-2.246-5.007-5.007-5.007S6.995 9.239 6.995 12zM11 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2H2zm17 0h3v2h-3zM5.637 19.778l-1.414-1.414 2.121-2.121 1.414 1.414zM16.242 6.344l2.122-2.122 1.414 1.414-2.122 2.122zM6.344 7.759 4.223 5.637l1.415-1.414 2.12 2.122zm13.434 10.605-1.414 1.414-2.122-2.122 1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidStore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.999 8a.997.997 0 0 0-.143-.515L19.147 2.97A2.01 2.01 0 0 0 17.433 2H6.565c-.698 0-1.355.372-1.714.971L2.142 7.485A.997.997 0 0 0 1.999 8c0 1.005.386 1.914 1 2.618V20a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5h4v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9.382c.614-.704 1-1.613 1-2.618zm-2.016.251A2.002 2.002 0 0 1 17.999 10c-1.103 0-2-.897-2-2 0-.068-.025-.128-.039-.192l.02-.004L15.219 4h2.214l2.55 4.251zm-9.977-.186L10.818 4h2.361l.813 4.065C13.957 9.138 13.079 10 11.999 10s-1.958-.862-1.993-1.935zM6.565 4h2.214l-.76 3.804.02.004c-.015.064-.04.124-.04.192 0 1.103-.897 2-2 2a2.002 2.002 0 0 1-1.984-1.749L6.565 4zm3.434 12h-4v-3h4v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidStoreAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5C3.346 2 2 3.346 2 5v2.831c0 1.053.382 2.01 1 2.746V20a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5h4v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9.424c.618-.735 1-1.692 1-2.746V5c0-1.654-1.346-3-3-3zm1 3v2.831c0 1.14-.849 2.112-1.891 2.167L18 10c-1.103 0-2-.897-2-2V4h3c.552 0 1 .449 1 1zM10 8V4h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zM4 5c0-.551.448-1 1-1h3v4c0 1.103-.897 2-2 2l-.109-.003C4.849 9.943 4 8.971 4 7.831V5zm6 11H6v-3h4v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidStopwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm1 8h-2V8h2v5zM9 2h6v2H9zm9.707 2.293 2 2-1.414 1.414-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSticker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 11c-4.136 0-7.5 3.364-7.5 7.5 0 .871.157 1.704.432 2.482l9.551-9.551A7.462 7.462 0 0 0 18.5 11z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c0 4.583 3.158 8.585 7.563 9.69A9.431 9.431 0 0 1 9 18.5C9 13.262 13.262 9 18.5 9c1.12 0 2.191.205 3.19.563C20.585 5.158 16.583 2 12 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.947 9.179a1.001 1.001 0 0 0-.868-.676l-5.701-.453-2.467-5.461a.998.998 0 0 0-1.822-.001L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.213 4.107-1.49 6.452a1 1 0 0 0 1.53 1.057L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082c.297-.268.406-.686.278-1.065z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidStarHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.025 20.775A.998.998 0 0 0 6 22a1 1 0 0 0 .555-.168L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082a1 1 0 0 0-.59-1.74l-5.701-.454-2.467-5.461a.998.998 0 0 0-1.822-.001L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.214 4.107-1.491 6.452zM12 5.429l2.042 4.521.588.047h.001l3.972.315-3.271 2.944-.001.002-.463.416.171.597v.003l1.253 4.385L12 15.798V5.429z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSquareRounded(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSpreadsheet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm7 2h8v2h-8V7zm0 4h8v2h-8v-2zm0 4h8v2h-8v-2zM6 7h2v2H6V7zm0 4h2v2H6v-2zm0 4h2v2H6v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSprayCan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.003 3h2v2h-2zM16 3h2v2h-2zm0 3h2v2h-2zm3-3h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zM4.012 12v9a1 1 0 0 0 1 1H13a1 1 0 0 0 1-1v-9a4 4 0 0 0-4-4H8.012a4 4 0 0 0-4 4zM7.003 2h4v4h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSpeaker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "15",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-6 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm0 16a5 5 0 1 1 5-5 5 5 0 0 1-5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSpa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16.114c-3.998-5.951-8.574-7.043-8.78-7.09L2 8.75V10c0 7.29 3.925 12 10 12 5.981 0 10-4.822 10-12V8.75l-1.22.274c-.206.047-4.782 1.139-8.78 7.09z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.274 3.767c-1.799 1.898-2.84 3.775-3.443 5.295 1.329.784 2.781 1.943 4.159 3.685 1.364-1.76 2.826-2.925 4.17-3.709-.605-1.515-1.646-3.383-3.435-5.271L12 3l-.726.767z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSortAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.227 11h11.547c.862 0 1.32-1.02.747-1.665L12.748 2.84a.998.998 0 0 0-1.494 0L5.479 9.335C4.906 9.98 5.364 11 6.227 11zm5.026 10.159a.998.998 0 0 0 1.494 0l5.773-6.495c.574-.644.116-1.664-.747-1.664H6.227c-.862 0-1.32 1.02-.747 1.665l5.773 6.494z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm3.493-13a1.494 1.494 0 1 1-.001 2.987A1.494 1.494 0 0 1 15.493 9zm-4.301 6.919a4.108 4.108 0 0 0 1.616 0c.253-.052.505-.131.75-.233.234-.1.464-.224.679-.368.208-.142.407-.306.591-.489.183-.182.347-.381.489-.592l1.658 1.117a6.027 6.027 0 0 1-1.619 1.621 6.003 6.003 0 0 1-2.149.904 6.116 6.116 0 0 1-2.414-.001 5.919 5.919 0 0 1-2.148-.903 6.078 6.078 0 0 1-1.621-1.622l1.658-1.117c.143.211.307.41.488.59a3.988 3.988 0 0 0 2.022 1.093zM8.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSlideshow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h7v3H8v2h8v-2h-3v-3h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM10 13V7l5 3-5 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSleepy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-4 9.01-2-.02C6.017 9.386 7.095 7 10 7v2c-1.924 0-1.998 1.805-2 2.01zM12 18c-1.657 0-3-1.119-3-2.5s1.343-2.5 3-2.5 3 1.119 3 2.5-1.343 2.5-3 2.5zm5-7-1 .008C15.992 10.536 15.826 9 14 9V7c2.935 0 4 2.393 4 4h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSkull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C5.505 2 2 6.637 2 11c0 2.129 1.009 3.979 3 5.508V21h3v-3h2v3h4v-3h2v3h3v-4.493c1.991-1.528 3-3.379 3-5.507 0-4.363-3.505-9-10-9zM8 13c-1.121 0-2-1.098-2-2.5S6.879 8 8 8s2 1.098 2 2.5S9.121 13 8 13zm8 0c-1.121 0-2-1.098-2-2.5S14.879 8 16 8s2 1.098 2 2.5-.879 2.5-2 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSkipPreviousCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10c5.515 0 10-4.486 10-10S17.515 2 12 2zm4 14-6-4v4H8V8h2v4l6-4v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSkipNextCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4 14h-2v-4l-6 4V8l6 4V8h2v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18.33A6.78 6.78 0 0 0 19.5 15a6.73 6.73 0 0 0-1.5 3.33 1.51 1.51 0 1 0 3 0zM11 20.33A6.78 6.78 0 0 0 9.5 17 6.73 6.73 0 0 0 8 20.33 1.59 1.59 0 0 0 9.5 22a1.59 1.59 0 0 0 1.5-1.67zM16 20.33A6.78 6.78 0 0 0 14.5 17a6.73 6.73 0 0 0-1.5 3.33A1.59 1.59 0 0 0 14.5 22a1.59 1.59 0 0 0 1.5-1.67zM6 18.33A6.78 6.78 0 0 0 4.5 15 6.73 6.73 0 0 0 3 18.33 1.59 1.59 0 0 0 4.5 20 1.59 1.59 0 0 0 6 18.33zM2 12h20v2H2zM13 4.07V2h-2v2.07A8 8 0 0 0 4.07 11h15.86A8 8 0 0 0 13 4.07z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 11c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.084 0-2 .916-2 2s.916 2 2 2 2-.916 2-2-.916-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShoppingBags(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h2V10a1 1 0 0 1 1-1h12V7a1 1 0 0 0-1-1h-3.051c-.252-2.244-2.139-4-4.449-4S6.303 3.756 6.051 6H3a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2zm6.5-16c1.207 0 2.218.86 2.45 2h-4.9c.232-1.14 1.243-2 2.45-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H9a1 1 0 0 0-1 1v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a1 1 0 0 0-1-1zm-6 7c-2.757 0-5-2.243-5-5h2c0 1.654 1.346 3 3 3s3-1.346 3-3h2c0 2.757-2.243 5-5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShoppingBag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14a2 2 0 0 0 2-2V9a1 1 0 0 0-1-1h-3v-.777c0-2.609-1.903-4.945-4.5-5.198A5.005 5.005 0 0 0 7 7v1H4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2zm12-12v2h-2v-2h2zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v1H9V7zm-2 3h2v2H7v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShoppingBagAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3a1 1 0 0 0-1 1v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a1 1 0 0 0-1-1zm-9 9c-3.309 0-6-2.691-6-6h2c0 2.206 1.794 4 4 4s4-1.794 4-4h2c0 3.309-2.691 6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShocked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zm5 7.5c-1.657 0-3-1.119-3-2.5s1.343-2.5 3-2.5 3 1.119 3 2.5-1.343 2.5-3 2.5zm3.493-6.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.997 20c-.899 0-1.288-.311-1.876-.781-.68-.543-1.525-1.219-3.127-1.219-1.601 0-2.446.676-3.125 1.22-.587.469-.975.78-1.874.78-.897 0-1.285-.311-1.872-.78C4.444 18.676 3.601 18 2 18v2c.898 0 1.286.311 1.873.78.679.544 1.523 1.22 3.122 1.22 1.601 0 2.445-.676 3.124-1.219.588-.47.976-.781 1.875-.781.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219s2.446-.676 3.125-1.219C20.689 20.328 21.1 20 22 20v-2c-1.602 0-2.447.676-3.127 1.219-.588.47-.977.781-1.876.781zM6 8.5 4 9l2 8h.995c1.601 0 2.445-.676 3.124-1.219.588-.47.976-.781 1.875-.781.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219H18l.027-.107.313-1.252L20 9l-2-.5V5.001a1 1 0 0 0-.804-.981L13 3.181V2h-2v1.181l-4.196.839A1 1 0 0 0 6 5.001V8.5zm2-2.681 4-.8 4 .8V8l-4-1-4 1V5.819z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.496 6.106-7.973-4a.997.997 0 0 0-.895-.002l-8.027 4c-.297.15-.502.437-.544.767-.013.097-1.145 9.741 8.541 15.008a.995.995 0 0 0 .969-.009c9.307-5.259 8.514-14.573 8.476-14.967a1 1 0 0 0-.547-.797z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShieldX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.492 21.771c.294.157.663.157.957-.001 8.012-4.304 8.581-12.713 8.574-15.104a.988.988 0 0 0-.596-.903l-8.051-3.565a1.005 1.005 0 0 0-.813.001L3.57 5.765a.988.988 0 0 0-.592.891c-.034 2.379.445 10.806 8.514 15.115zM8.293 9.707l1.414-1.414L12 10.586l2.293-2.293 1.414 1.414L13.414 12l2.293 2.293-1.414 1.414L12 13.414l-2.293 2.293-1.414-1.414L10.586 12 8.293 9.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShieldPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.43 5.76-8-3.56a1 1 0 0 0-.82 0l-8 3.56a1 1 0 0 0-.59.9c0 2.37.44 10.8 8.51 15.11a1 1 0 0 0 1 0c8-4.3 8.58-12.71 8.57-15.1a1 1 0 0 0-.67-.91zm-4.43 7h-3v3h-2v-3H8v-2h3v-3h2v3h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShieldMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.43 5.76-8-3.56a1 1 0 0 0-.82 0l-8 3.56a1 1 0 0 0-.59.9c0 2.37.44 10.8 8.51 15.11a1 1 0 0 0 1 0c8-4.3 8.58-12.71 8.57-15.1a1 1 0 0 0-.67-.91zm-4.43 7H8v-2h8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShieldAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.881 5.223a.496.496 0 0 0-.747-.412c-.672.392-1.718.898-2.643.898-.421 0-.849-.064-1.289-.198a5.712 5.712 0 0 1-.808-.309c-1.338-.639-2.567-1.767-3.696-2.889a1.008 1.008 0 0 0-.698-.29 1.008 1.008 0 0 0-.698.29c-1.129 1.122-2.358 2.25-3.696 2.889h-.001a5.655 5.655 0 0 1-.807.309c-.44.134-.869.198-1.289.198-.925 0-1.971-.507-2.643-.898a.496.496 0 0 0-.747.412c-.061 1.538-.077 4.84.688 7.444 1.399 4.763 4.48 7.976 8.91 9.292l.14.041.14-.014V22v-.014H12l.143.014.14-.041c4.43-1.316 7.511-4.529 8.91-9.292.765-2.604.748-5.906.688-7.444z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.914V2.586L6.293 7.293l-3.774 3.774 3.841 3.201L11 18.135V13.9c8.146-.614 11 4.1 11 4.1 0-2.937-.242-5.985-2.551-8.293C16.765 7.022 12.878 6.832 11 6.914z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShareAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12c0 1.654 1.346 3 3 3 .794 0 1.512-.315 2.049-.82l5.991 3.424c-.018.13-.04.26-.04.396 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-.794 0-1.512.315-2.049.82L8.96 12.397c.018-.131.04-.261.04-.397s-.022-.266-.04-.397l5.991-3.423c.537.505 1.255.82 2.049.82 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .136.022.266.04.397L8.049 9.82A2.982 2.982 0 0 0 6 9c-1.654 0-3 1.346-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidShapes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.867 2.504c-.355-.624-1.381-.623-1.736 0l-3.999 7A1 1 0 0 0 13 11h8a1.001 1.001 0 0 0 .868-1.496l-4.001-7zM3 22h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1zm14.5-9c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidServer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-5 5h-2V6h2zm4 0h-2V6h2zm1 5H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-5 5h-2v-2h2zm4 0h-2v-2h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSend(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.426 11.095-17-8A1 1 0 0 0 3.03 4.242l1.212 4.849L12 12l-7.758 2.909-1.212 4.849a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSelectMultiple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-6.933 12.481-3.274-3.274 1.414-1.414 1.726 1.726 4.299-5.159 1.537 1.281-5.702 6.84z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h11v-2H4V8H2v12c0 1.103.897 2 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSearch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSearchAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16c1.763 0 3.37-.66 4.603-1.739l1.337 2.8s.275.224.653.596c.387.363.896.854 1.384 1.367l1.358 1.392.604.646 2.121-2.121-.646-.604-1.392-1.358a35.13 35.13 0 0 1-1.367-1.384c-.372-.378-.596-.653-.596-.653l-2.8-1.337A6.967 6.967 0 0 0 16 9c0-3.859-3.141-7-7-7S2 5.141 2 9s3.141 7 7 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSchool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-2V4h1V2H4v2h1v6H3a1 1 0 0 0-1 1v9h20v-9a1 1 0 0 0-1-1zm-7 8v-4h-4v4H7V4h10v14h-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6h2v2H9zm4 0h2v2h-2zm-4 4h2v2H9zm4 0h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V8l-5-5H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zM7 5h4v2h2V5h2v4H7V5zm0 8h10v6H7v-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidSad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zM8 17s1-3 4-3 4 3 4 3H8zm7.493-5.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRuler(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.875 7H3.125C1.953 7 1 7.897 1 9v6c0 1.103.953 2 2.125 2h17.75C22.047 17 23 16.103 23 15V9c0-1.103-.953-2-2.125-2zM7 12H5V9h2v3zm4 1H9V9h2v4zm4-1h-2V9h2v3zm4 1h-2V9h2v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRocket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.78 15.84S18.64 13 19.61 12c3.07-3 1.54-9.18 1.54-9.18S15 1.29 12 4.36C9.66 6.64 8.14 8.22 8.14 8.22S4.3 7.42 2 9.72L14.25 22c2.3-2.33 1.53-6.16 1.53-6.16zm-1.5-9a2 2 0 0 1 2.83 0 2 2 0 1 1-2.83 0zM3 21a7.81 7.81 0 0 0 5-2l-3-3c-2 1-2 5-2 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRightTopArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 4.929c-3.899-3.898-10.243-3.898-14.143 0-3.898 3.899-3.898 10.244 0 14.143 3.899 3.898 10.243 3.898 14.143 0 3.899-3.9 3.899-10.244 0-14.143zm-3.536 10.607-2.828-2.829-3.535 3.536-1.414-1.414 3.535-3.536-2.828-2.829h7.07v7.072z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRightDownArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 4.929c-3.898 3.899-3.898 10.244 0 14.143 3.899 3.898 10.243 3.898 14.143 0 3.898-3.899 3.898-10.244 0-14.143-3.9-3.899-10.244-3.899-14.143 0zm10.606 10.607h-7.07l2.828-2.829-3.535-3.536 1.414-1.414 3.535 3.536 2.828-2.829v7.072z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRightArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRightArrowSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm4 6h5V7l5 5-5 5v-4H7v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRightArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 15v-4H7v-2h5V7l5 5-5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRightArrowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 12-7-6v5H6v2h6v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRewindCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.485 2 12s4.486 10 10 10c5.515 0 10-4.485 10-10S17.515 2 12 2zm5 14-6-4v4l-6-4 6-4v4l6-4v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidReport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20 8-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM9 19H7v-9h2v9zm4 0h-2v-6h2v6zm4 0h-2v-3h2v3zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRename(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5.995h-1v12h1c1.103 0 2-.897 2-2v-8c0-1.102-.897-2-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17.995V4h2.995V2h-8v2H15v1.995H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h11V20h-3.005v2h8v-2H17v-2.005zm-11-4v-4h9v4H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRegistered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-3v2h3a1 1 0 0 0 0-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm2.13 15-2.67-4H10v4H8V7h5a3 3 0 0 1 .79 5.88L16.54 17z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRectangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidReceipt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12v6a1 1 0 0 1-2 0V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-6h-2zm-6-1v2H6v-2h8zM6 9V7h8v2H6zm8 6v2h-3v-2h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRadio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.249 5.025-7.897-2.962-.703 1.873L14.484 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7c0-1.02-.766-1.851-1.751-1.975zM10 17H6v-2h4v2zm6.5 1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm3.5-7H4V7h16v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidRadiation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.912 8.531 7.121 3.877a.501.501 0 0 0-.704-.166 9.982 9.982 0 0 0-4.396 7.604.505.505 0 0 0 .497.528l5.421.09a4.042 4.042 0 0 1 1.973-3.402zm8.109-4.51a.504.504 0 0 0-.729.151L14.499 8.83a4.03 4.03 0 0 1 1.546 3.112l5.419-.09a.507.507 0 0 0 .499-.53 9.986 9.986 0 0 0-3.942-7.301zm-4.067 11.511a4.015 4.015 0 0 1-1.962.526 4.016 4.016 0 0 1-1.963-.526l-2.642 4.755a.5.5 0 0 0 .207.692A9.948 9.948 0 0 0 11.992 22a9.94 9.94 0 0 0 4.396-1.021.5.5 0 0 0 .207-.692l-2.641-4.755z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidQuoteSingleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.804 17.02 8 17.18V20h1c2.783 0 4.906-.771 6.309-2.292C17.196 15.66 17.006 13.03 17 13V5a1 1 0 0 0-1-1H9c-1.103 0-2 .897-2 2v7a1 1 0 0 0 1 1h4.078a2.89 2.89 0 0 1-.429 1.396c-.507.801-1.464 1.347-2.845 1.624z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidQuoteSingleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.203 6.98.804-.161V4h-1c-2.784 0-4.906.771-6.309 2.292C6.81 8.34 7 10.97 7.006 11v8a1 1 0 0 0 1 1h7c1.103 0 2-.897 2-2v-7a1 1 0 0 0-1-1h-4.079c.022-.402.123-.912.429-1.396.509-.801 1.466-1.347 2.847-1.624z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidQuoteRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.309 17.708C22.196 15.66 22.006 13.03 22 13V5a1 1 0 0 0-1-1h-6c-1.103 0-2 .897-2 2v7a1 1 0 0 0 1 1h3.078a2.89 2.89 0 0 1-.429 1.396c-.508.801-1.465 1.348-2.846 1.624l-.803.16V20h1c2.783 0 4.906-.771 6.309-2.292zm-11.007 0C11.19 15.66 10.999 13.03 10.993 13V5a1 1 0 0 0-1-1h-6c-1.103 0-2 .897-2 2v7a1 1 0 0 0 1 1h3.078a2.89 2.89 0 0 1-.429 1.396c-.508.801-1.465 1.348-2.846 1.624l-.803.16V20h1c2.783 0 4.906-.771 6.309-2.292z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidQuoteLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.691 6.292C5.094 4.771 7.217 4 10 4h1v2.819l-.804.161c-1.37.274-2.323.813-2.833 1.604A2.902 2.902 0 0 0 6.925 10H10a1 1 0 0 1 1 1v7c0 1.103-.897 2-2 2H3a1 1 0 0 1-1-1v-5l.003-2.919c-.009-.111-.199-2.741 1.688-4.789zM20 20h-6a1 1 0 0 1-1-1v-5l.003-2.919c-.009-.111-.199-2.741 1.688-4.789C16.094 4.771 18.217 4 21 4h1v2.819l-.804.161c-1.37.274-2.323.813-2.833 1.604A2.902 2.902 0 0 0 17.925 10H21a1 1 0 0 1 1 1v7c0 1.103-.897 2-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidQuoteAltRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.95 8.721-.025-.168-.026.006A4.5 4.5 0 1 0 17.5 14c.223 0 .437-.034.65-.065-.069.232-.14.468-.254.68-.114.308-.292.575-.469.844-.148.291-.409.488-.601.737-.201.242-.475.403-.692.604-.213.21-.492.315-.714.463-.232.133-.434.28-.65.35l-.539.222-.474.197.484 1.939.597-.144c.191-.048.424-.104.689-.171.271-.05.56-.187.882-.312.317-.143.686-.238 1.028-.467.344-.218.741-.4 1.091-.692.339-.301.748-.562 1.05-.944.33-.358.656-.734.909-1.162.293-.408.492-.856.702-1.299.19-.443.343-.896.468-1.336.237-.882.343-1.72.384-2.437.034-.718.014-1.315-.028-1.747a7.028 7.028 0 0 0-.063-.539zm-11 0-.025-.168-.026.006A4.5 4.5 0 1 0 6.5 14c.223 0 .437-.034.65-.065-.069.232-.14.468-.254.68-.114.308-.292.575-.469.844-.148.291-.409.488-.601.737-.201.242-.475.403-.692.604-.213.21-.492.315-.714.463-.232.133-.434.28-.65.35l-.539.222c-.301.123-.473.195-.473.195l.484 1.939.597-.144c.191-.048.424-.104.689-.171.271-.05.56-.187.882-.312.317-.143.686-.238 1.028-.467.344-.218.741-.4 1.091-.692.339-.301.748-.562 1.05-.944.33-.358.656-.734.909-1.162.293-.408.492-.856.702-1.299.19-.443.343-.896.468-1.336.237-.882.343-1.72.384-2.437.034-.718.014-1.315-.028-1.747a7.571 7.571 0 0 0-.064-.537z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidQuoteAltLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.318.142-.686.238-1.028.466-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.945-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 6.5 10zm11 0c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.317.143-.686.238-1.028.467-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.944-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 17.5 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPyramid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.445 21.832a1 1 0 0 0 1.11 0l9-6A.998.998 0 0 0 21.8 14.4l-9-12c-.377-.504-1.223-.504-1.6 0l-9 12a1 1 0 0 0 .245 1.432l9 6zm8.12-7.078L12 19.798V4.667l7.565 10.087z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPurchaseTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8 8a2 2 0 0 0 2.828 0l7.172-7.172a2 2 0 0 0 0-2.828l-8-8zM7 9a2 2 0 1 1 .001-4.001A2 2 0 0 1 7 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPurchaseTagAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.707 2.293A.996.996 0 0 0 11 2H6a.996.996 0 0 0-.707.293l-3 3A.996.996 0 0 0 2 6v5c0 .266.105.52.293.707l10 10a.997.997 0 0 0 1.414 0l8-8a.999.999 0 0 0 0-1.414l-10-10zM8.353 10a1.647 1.647 0 1 1-.001-3.293A1.647 1.647 0 0 1 8.353 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPrinter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-1V2H6v5H5a3 3 0 0 0-3 3v7a2 2 0 0 0 2 2h2v3h12v-3h2a2 2 0 0 0 2-2v-7a3 3 0 0 0-3-3zM8 4h8v3H8V4zm0 16v-4h8v4H8zm11-8h-4v-2h4v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPopsicle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4a7 7 0 0 0-9.9 0l-7.82 7.82a1 1 0 0 0 0 1.41l3.54 3.54-3.54 3.53 1.42 1.42 3.53-3.54 3.54 3.54a1 1 0 0 0 1.41 0L20 13.94A7 7 0 0 0 20 4zm-2.7 2.7a3.33 3.33 0 0 0-4.6 0l-1.06-1.06a4.76 4.76 0 0 1 6.72 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPolygon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 7.293-5-5A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.978 13.21a1 1 0 0 0-.396-1.024l-14-10a.999.999 0 0 0-1.575.931l2 17a1 1 0 0 0 1.767.516l3.612-4.416 3.377 5.46 1.701-1.052-3.357-5.428 6.089-1.218a.995.995 0 0 0 .782-.769z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPlusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm2-10h4V7h2v4h4v2h-4v4h-2v-4H7v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPlusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPlug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8h2v5c0 2.206 1.794 4 4 4h2v5h2v-5h2c2.206 0 4-1.794 4-4V8h2V6H3v2zm4-6h2v3H7zm8 0h2v3h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPlaylist(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16.493C13 18.427 14.573 20 16.507 20s3.507-1.573 3.507-3.507c0-.177-.027-.347-.053-.517H20V6h2V4h-3a1 1 0 0 0-1 1v8.333a3.465 3.465 0 0 0-1.493-.346A3.51 3.51 0 0 0 13 16.493zM2 5h14v2H2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9h14v2H2zm0 4h9v2H2zm0 4h9v2H2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPlanet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.165 15.582c4.587-4.073 8.141-9.424 6.057-11.771-.661-.744-1.584-1.089-2.575-.983-.832.091-1.687.502-2.549 1.192a8.922 8.922 0 0 0-8.712.282 8.917 8.917 0 0 0-4.109 5.515 8.892 8.892 0 0 0 .306 5.325c-1.065 1.203-2.054 3.677-.823 5.063.517.581 1.257.841 2.147.841 2.707 0 6.808-2.399 10.258-5.464zm3.699-10.767c.358-.034.632.064.861.323.231.261.169.946-.252 1.929a9.059 9.059 0 0 0-1.617-1.853c.431-.262.776-.373 1.008-.399zM4.633 17.118a8.979 8.979 0 0 0 1.568 1.737c-1.025.303-1.714.283-1.945.021-.217-.243.002-1.069.377-1.758zm16.31-5.869c-1.215 1.797-2.906 3.671-4.778 5.333-1.934 1.719-4.066 3.208-6.05 4.202a9.082 9.082 0 0 0 1.874.212 8.986 8.986 0 0 0 4.616-1.282 8.915 8.915 0 0 0 4.338-8.465z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.21v-1.895L14 8V4a2 2 0 0 0-4 0v4.105L2 14.42v1.789l8-2.81V18l-3 2v2l5-2 5 2v-2l-3-2v-4.685l8 2.895z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPlaneTakeOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h18v2H3zm18.509-9.473a1.61 1.61 0 0 0-2.036-1.019L15 9 7 6 5 7l6 4-4 2-4-2-1 1 4 4 14.547-5.455a1.611 1.611 0 0 0 .962-2.018z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPlaneLand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.842 15.296a1.61 1.61 0 0 0 1.892-1.189v-.001a1.609 1.609 0 0 0-1.177-1.949l-4.576-1.133L9.825 4.21l-2.224-.225 2.931 6.589-4.449-.449-2.312-3.829-1.38.31 1.24 5.52 15.211 3.17zM3 18h18v2H3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPlaneAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.414 13.778 2 15.192l4.949 2.121 2.122 4.95 1.414-1.414-.707-3.536L13.091 14l3.61 7.704 1.339-1.339-1.19-10.123 2.828-2.829a2 2 0 1 0-2.828-2.828l-2.903 2.903L3.824 6.297 2.559 7.563l7.644 3.67-3.253 3.253-3.536-.708z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPizza(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.76 2.021a.995.995 0 0 0-.989.703L3.579 19.166a1 1 0 0 0 1.255 1.255l16.442-5.192a.991.991 0 0 0 .702-.988C21.6 7.666 16.334 2.4 9.76 2.021zM10 16a2 2 0 1 1 .001-4.001A2 2 0 0 1 10 16zm6-2a2 2 0 1 1 .001-4.001A2 2 0 0 1 16 14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11.586V6h2V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2h2v5.586l-2.707 1.707A.996.996 0 0 0 6 14v2a1 1 0 0 0 1 1h4v3l1 2 1-2v-3h4a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707L15 11.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPieChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 10V5c4 0 7 3 7 7h-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPieChartAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 4.929A9.97 9.97 0 0 0 12 2a9.936 9.936 0 0 0-7.071 2.929C3.04 6.818 2 9.33 2 12s1.04 5.182 2.929 7.071C6.818 20.96 9.33 22 12 22s5.182-1.04 7.071-2.929A9.936 9.936 0 0 0 22 12a9.97 9.97 0 0 0-2.929-7.071zm-1.414 12.728C16.146 19.168 14.137 20 12 20s-4.146-.832-5.657-2.343C4.832 16.146 4 14.137 4 12s.832-4.146 2.343-5.657A7.948 7.948 0 0 1 12 4v8h8a7.948 7.948 0 0 1-2.343 5.657z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPieChartAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.051V11h8.949c-.47-4.717-4.232-8.479-8.949-8.949zm4.969 17.953c2.189-1.637 3.694-4.14 3.98-7.004h-8.183l4.203 7.004z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12V2.051C5.954 2.555 2 6.824 2 12c0 5.514 4.486 10 10 10a9.93 9.93 0 0 0 4.255-.964s-5.253-8.915-5.254-9.031A.02.02 0 0 0 11 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPiano(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3zm0 16H5a1 1 0 0 1-1-1v-6h2v4h2v-4h1v4h2v-4h1v4h2v-4h2v4h2v-4h2v6a1 1 0 0 1-1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPhotoAlbum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V3a1 1 0 0 0-1-1zM9.503 5a1.503 1.503 0 1 1 0 3.006 1.503 1.503 0 0 1 0-3.006zM12 13H7l3-3 1.5 1.399L14.5 8l3.5 5h-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.487 17.14-4.065-3.696a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a.997.997 0 0 0-.085-1.39z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPhoneOutgoing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.793 5.793-4.5 4.5 1.414 1.414 4.5-4.5L21 10V3h-7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.422 13.446a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.516a1 1 0 0 0-1.391-.087L3.299 5.29a.996.996 0 0 0-.291.648c-.015.25-.301 6.172 4.291 10.766 4.006 4.006 9.024 4.299 10.406 4.299.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a1 1 0 0 0-.086-1.391l-4.064-3.696z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPhoneOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 13.42a5.24 5.24 0 0 1-.93-2.06L10.7 9a1 1 0 0 0 0-1.39l-3.65-4.1a1 1 0 0 0-1.4-.08L3.48 5.29a1 1 0 0 0-.29.65 15.25 15.25 0 0 0 3.54 9.92l-4.44 4.43 1.42 1.42 18-18-1.42-1.42zm7.44.02a1 1 0 0 0-1.39.05L12.82 16a4.07 4.07 0 0 1-.51-.14l-2.66 2.61A15.46 15.46 0 0 0 17.89 21h.36a1 1 0 0 0 .65-.29l1.86-2.17a1 1 0 0 0-.09-1.39z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPhoneIncoming(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.793 6.793 13 4v7h7l-2.793-2.793 4.5-4.5-1.414-1.414z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.422 13.443a1.001 1.001 0 0 0-1.391.043l-2.392 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.86 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1.001 1.001 0 0 0-.291.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.324 21 17.705 21c.203 0 .326-.006.359-.008a.99.99 0 0 0 .648-.291l1.861-2.171a1.001 1.001 0 0 0-.086-1.391l-4.065-3.696z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPhoneCall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a1 1 0 0 0-.086-1.391l-4.064-3.696z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPencil(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 19.707 18 10.414 13.586 6l-9.293 9.293a1.003 1.003 0 0 0-.263.464L3 21l5.242-1.03c.176-.044.337-.135.465-.263zM21 7.414a2 2 0 0 0 0-2.828L19.414 3a2 2 0 0 0-2.828 0L15 4.586 19.414 9 21 7.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.587 6.999H7.702a2 2 0 0 0-1.88 1.316l-3.76 10.342c-.133.365-.042.774.232 1.049l.293.293 6.422-6.422c-.001-.026-.008-.052-.008-.078a1.5 1.5 0 1 1 1.5 1.5c-.026 0-.052-.007-.078-.008l-6.422 6.422.293.293a.997.997 0 0 0 1.049.232l10.342-3.761a2 2 0 0 0 1.316-1.88v-3.885L19 10.414 13.586 5l-1.999 1.999zm8.353 2.062-5-5 2.12-2.121 5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.12 22a7.71 7.71 0 0 0 6.57-5 7.23 7.23 0 0 0 .46-3.21 3.26 3.26 0 0 1 1-2.57l.61-.61A3.89 3.89 0 0 0 19.43 6l2.28-2.28-1.42-1.43L18 4.55a3.82 3.82 0 0 0-4.66.57l-.75.75a3.22 3.22 0 0 1-2.52 1 7.05 7.05 0 0 0-3.32.57A7.75 7.75 0 0 0 2 14.11 7.59 7.59 0 0 0 10.12 22zM9.5 9.25v1.5a3.75 3.75 0 0 0-3.75 3.75h-1.5A5.26 5.26 0 0 1 9.5 9.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPaste(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4h6v2H9zm11 7h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9V6a2 2 0 0 0-2-2h-2a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4v-9a2 2 0 0 1 2-2h10zM9 6V4h6v2H9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidParty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 7a8.44 8.44 0 0 0-5 1.31c-.36-.41-.73-.82-1.12-1.21l-.29-.27.14-.12a3.15 3.15 0 0 0 .9-3.49A3.9 3.9 0 0 0 14 1v2a2 2 0 0 1 1.76 1c.17.4 0 .84-.47 1.31l-.23.21a16.71 16.71 0 0 0-3.41-2.2c-2.53-1.14-3.83-.61-4.47 0a2.18 2.18 0 0 0-.46.68l-.18.53L5.1 8.87C6.24 11.71 9 16.76 15 18.94l5-1.66a1 1 0 0 0 .43-.31l.21-.18c1.43-1.44.51-4.21-1.41-6.9A6.63 6.63 0 0 1 23 9zm-3.79 8.37h-.06c-.69.37-3.55-.57-6.79-3.81-.34-.34-.66-.67-.95-1-.1-.11-.19-.23-.29-.35l-.53-.64-.28-.39c-.14-.19-.28-.38-.4-.56s-.16-.26-.24-.39-.22-.34-.31-.51-.13-.24-.19-.37-.17-.28-.23-.42-.09-.23-.14-.34-.11-.27-.15-.4S8.6 6 8.58 5.9s-.06-.24-.08-.34a2 2 0 0 1 0-.24 1.15 1.15 0 0 1 0-.26l.11-.31c.17-.18.91-.23 2.23.37a13.83 13.83 0 0 1 2.49 1.54A4.17 4.17 0 0 1 12 7v2a6.43 6.43 0 0 0 3-.94l.49.46c.44.43.83.86 1.19 1.27A5.31 5.31 0 0 0 16 13.2l2-.39a3.23 3.23 0 0 1 0-1.14c1.29 1.97 1.53 3.39 1.21 3.7zM4.4 11l-2.23 6.7A3.28 3.28 0 0 0 5.28 22a3.21 3.21 0 0 0 1-.17l6.52-2.17A18.7 18.7 0 0 1 4.4 11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidParking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3H5v18h4v-5h4.5c3.584 0 6.5-2.916 6.5-6.5S17.084 3 13.5 3zm0 9H9V7h4.5C14.879 7 16 8.121 16 9.5S14.879 12 13.5 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPaperPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.6 13.083 3.452 1.511L16 9.167l-6 7 8.6 3.916a1 1 0 0 0 1.399-.85l1-15a1.002 1.002 0 0 0-1.424-.972l-17 8a1.002 1.002 0 0 0 .025 1.822zM8 22.167l4.776-2.316L8 17.623z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPalette(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.38 21.646A9.985 9.985 0 0 0 12 22l.141-.001a2.998 2.998 0 0 0 2.515-1.425c.542-.876.6-1.953.153-2.88l-.198-.415c-.453-.942-.097-1.796.388-2.281.485-.485 1.341-.841 2.28-.388h.001l.413.199a2.99 2.99 0 0 0 2.881-.153A2.997 2.997 0 0 0 22 12.141a9.926 9.926 0 0 0-.353-2.76c-1.038-3.827-4.353-6.754-8.246-7.285-3.149-.427-6.241.602-8.471 2.833S1.666 10.247 2.096 13.4c.53 3.894 3.458 7.208 7.284 8.246zM15.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM9 15.506a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-2.5-6.5a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 6.5 9.006z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPaint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.084 2.914c-1.178-1.179-3.234-1.179-4.412 0l-8.379 8.379a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0l8.379-8.379a3.123 3.123 0 0 0-.002-4.414zm-1.412 3L12 13.586 10.414 12l7.672-7.672a1.146 1.146 0 0 1 1.586.002 1.123 1.123 0 0 1 0 1.584zM8 15c-1.265-.634-3.5 0-3.5 2 0 1.197.5 2-1.5 3 0 0 3.25 2.25 5.5 0 1.274-1.274 1.494-4-.5-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPaintRoll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H7c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h11c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15v-2c0-1.103-.897-2-2-2H4V5c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h7v2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidPackage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.993 7.95a.96.96 0 0 0-.029-.214c-.007-.025-.021-.049-.03-.074-.021-.057-.04-.113-.07-.165-.016-.027-.038-.049-.057-.075-.032-.045-.063-.091-.102-.13-.023-.022-.053-.04-.078-.061-.039-.032-.075-.067-.12-.094-.004-.003-.009-.003-.014-.006l-.008-.006-8.979-4.99a1.002 1.002 0 0 0-.97-.001l-9.021 4.99c-.003.003-.006.007-.011.01l-.01.004c-.035.02-.061.049-.094.073-.036.027-.074.051-.106.082-.03.031-.053.067-.079.102-.027.035-.057.066-.079.104-.026.043-.04.092-.059.139-.014.033-.032.064-.041.1a.975.975 0 0 0-.029.21c-.001.017-.007.032-.007.05V16c0 .363.197.698.515.874l8.978 4.987.001.001.002.001.02.011c.043.024.09.037.135.054.032.013.063.03.097.039a1.013 1.013 0 0 0 .506 0c.033-.009.064-.026.097-.039.045-.017.092-.029.135-.054l.02-.011.002-.001.001-.001 8.978-4.987c.316-.176.513-.511.513-.874V7.998c0-.017-.006-.031-.007-.048zm-10.021 3.922L5.058 8.005 7.82 6.477l6.834 3.905-2.682 1.49zm.048-7.719L18.941 8l-2.244 1.247-6.83-3.903 2.153-1.191zM13 19.301l.002-5.679L16 11.944V15l2-1v-3.175l2-1.119v5.705l-7 3.89z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidOffer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.749 12 1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104 1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zm.3 9.6-1.6-1.199 6-8 1.6 1.199-6 8zm4.7.4a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidObjectsVerticalTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h20v2H2z"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "6",
                    "width": "6",
                    "height": "16",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "6",
                    "width": "6",
                    "height": "12",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidObjectsVerticalCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4h-2V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v6H2v2h3v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-6h2v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4h3v-2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidObjectsVerticalBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v2H2z"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "2",
                    "width": "6",
                    "height": "16",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "6",
                    "width": "6",
                    "height": "12",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidObjectsHorizontalRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v20h-2z"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "13",
                    "width": "16",
                    "height": "6",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "5",
                    "width": "12",
                    "height": "6",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidObjectsHorizontalLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h2v20H2z"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "13",
                    "width": "16",
                    "height": "6",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "5",
                    "width": "12",
                    "height": "6",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidObjectsHorizontalCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13h-6v-2h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4V2h-2v3H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4v2H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6v3h2v-3h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidNotification(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6c0-.712.153-1.387.422-2H6c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7.422A4.962 4.962 0 0 1 18 11a5 5 0 0 1-5-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidNotificationOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-7.422A4.962 4.962 0 0 1 18 11a5 5 0 0 1-5-5c0-.712.153-1.387.422-2H6c-.178 0-.347.031-.51.076L3.707 2.293 2.293 3.707l18 18 1.414-1.414-1.783-1.783c.045-.163.076-.332.076-.51zM4 18c0 1.103.897 2 2 2h9.879L4 8.121V18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidNotepad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-7 10H7v-2h5v2zm5-4H7V8h10v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8l8-8V5a2 2 0 0 0-2-2zm-7 16v-7h7l-7 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidNoEntry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 12H7v-4h10v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidNews(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17a1 1 0 0 1-2 0V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v13a2 2 0 0 0 2 2h15c1.654 0 3-1.346 3-3V7h-2v10zM12 7h3v2h-3V7zm0 4h3v2h-3v-2zM5 7h5v6H5V7zm0 10v-2h10v2H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidNetworkChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 3A2.502 2.502 0 0 0 17 5.5c0 .357.078.696.214 1.005l-1.955 2.199A3.977 3.977 0 0 0 13 8c-.74 0-1.424.216-2.019.566L8.707 6.293l-.023.023C8.88 5.918 9 5.475 9 5a3 3 0 1 0-3 3c.475 0 .917-.12 1.316-.316l-.023.023L9.567 9.98A3.956 3.956 0 0 0 9 12c0 .997.38 1.899.985 2.601l-2.577 2.576A2.472 2.472 0 0 0 6.5 17C5.122 17 4 18.121 4 19.5S5.122 22 6.5 22 9 20.879 9 19.5c0-.321-.066-.626-.177-.909l2.838-2.838c.421.15.867.247 1.339.247 2.206 0 4-1.794 4-4 0-.636-.163-1.229-.428-1.764l2.117-2.383c.256.088.526.147.811.147C20.879 8 22 6.879 22 5.5S20.879 3 19.5 3zM13 14c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidNavigation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.002 9.538c-.023.411.207.794.581.966l7.504 3.442 3.442 7.503c.164.356.52.583.909.583l.057-.002a1 1 0 0 0 .894-.686l5.595-17.032c.117-.358.023-.753-.243-1.02s-.66-.358-1.02-.243L2.688 8.645a.997.997 0 0 0-.686.893z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMusic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18.573c2.206 0 4-1.794 4-4V4.428L19 7.7v7.43a3.953 3.953 0 0 0-2-.557c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4V7a.998.998 0 0 0-.658-.939l-11-4A.999.999 0 0 0 8 3v8.13a3.953 3.953 0 0 0-2-.557c-2.206 0-4 1.794-4 4s1.794 4 4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMovie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.466l-2.667-4H20l.001 4zm-5.466 0-2.667-4h2.596l2.667 4h-2.596zm-2.404 0H9.535L6.869 5h2.596l2.666 4zM4 5h.465l2.667 4H4V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMoviePlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.465l-2.667-4H20l.001 4zM15.5 15 10 18v-6l5.5 3zm-.964-6-2.667-4h2.596l2.667 4h-2.596zm-2.404 0H9.536L6.869 5h2.596l2.667 4zM4 5h.465l2.667 4H4V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.975 22H12c3.859 0 7-3.14 7-7V9c0-3.841-3.127-6.974-6.981-7h-.06C8.119 2.022 5 5.157 5 9v6c0 3.86 3.129 7 6.975 7zM11 6h2v6h-2V6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMouseAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2v8h6V8c0-3.309-2.691-6-6-6zM5 16c0 3.309 2.691 6 6 6h2c3.309 0 6-2.691 6-6v-4H5v4zm0-8v2h6V2C7.691 2 5 4.691 5 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.807A9.002 9.002 0 0 1 10.049 2a9.942 9.942 0 0 0-5.12 2.735c-3.905 3.905-3.905 10.237 0 14.142 3.906 3.906 10.237 3.905 14.143 0a9.946 9.946 0 0 0 2.735-5.119A9.003 9.003 0 0 1 12 11.807z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h10zm-5-5a1 1 0 1 1 0 2 1 1 0 1 1 0-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMobileVibration(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 2.808a2.003 2.003 0 0 0-2.828 0l-9.899 9.899a2.001 2.001 0 0 0 0 2.828l5.657 5.657c.39.39.902.585 1.414.585s1.024-.195 1.414-.585l9.899-9.899c.78-.779.78-2.049 0-2.828l-5.657-5.657zM8.707 16.707a.999.999 0 1 1-1.414-1.414.999.999 0 1 1 1.414 1.414zm7 5-1.414-1.414 6-6 1.414 1.415zM8.293 2.293l1.414 1.414-6 6-1.414-1.415z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMinusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5zm12 10H7v-2h10v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMinusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11H7v-2h10v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMicrophone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c2.206 0 4-1.794 4-4V6c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6v6c0 2.206 1.794 4 4 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6H4c0 4.072 3.061 7.436 7 7.931z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMicrophoneOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 20.293-3.4-3.4A7.93 7.93 0 0 0 20 12h-2a5.945 5.945 0 0 1-1.119 3.467l-1.449-1.45A3.926 3.926 0 0 0 16 12V6c0-2.217-1.785-4.021-3.979-4.021-.07 0-.14.009-.209.025A4.006 4.006 0 0 0 8 6v.586L3.707 2.293 2.293 3.707l18 18 1.414-1.414zM6 12H4c0 4.072 3.06 7.436 7 7.931V22h2v-2.069a7.935 7.935 0 0 0 2.241-.63l-1.549-1.548A5.983 5.983 0 0 1 12 18c-3.309 0-6-2.691-6-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.007 12.067a3.996 3.996 0 0 0 3.926 3.926l-3.926-3.926z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMicrophoneAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12H4c0 4.072 3.061 7.436 7 7.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12c0 2.206 1.794 4 4 4s4-1.794 4-4h-2v-2h2V8h-2V6h2c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6h4v2H8v2h4v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMicrochip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.999 22h8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2h-8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2zm-5-15h2V5h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1zm-18 6h2V9h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1zm-18 6h2v-2h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1zm-18 6h2v-2h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMeteor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.507 2.138a1 1 0 0 0-1.155.102L4.196 9.197c-2.924 2.924-2.924 7.682 0 10.606a7.472 7.472 0 0 0 5.3 2.192c1.924 0 3.85-.734 5.317-2.202l6.903-7.096A1 1 0 0 0 21 11h-3.301l4.175-7.514a1.001 1.001 0 0 0-1.359-1.36l-7.11 3.95.576-2.879a1.002 1.002 0 0 0-.474-1.059zM14 14.5a4.5 4.5 0 0 1-9 0c0-1.57.807-2.949 2.025-3.754-.01.084-.025.167-.025.254a2 2 0 1 0 3.845-.772C12.669 10.802 14 12.486 14 14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-3.293 11.293-1.414 1.414L12 11.414l-3.293 3.293-1.414-1.414L10.586 10 7.293 6.707l1.414-1.414L12 8.586l3.293-3.293 1.414 1.414L13.414 10l3.293 3.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageSquareX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm.706 13.293-1.414 1.414L12 13.415l-3.292 3.292-1.414-1.414 3.292-3.292-3.292-3.292 1.414-1.414L12 10.587l3.292-3.292 1.414 1.414-3.292 3.292 3.292 3.292z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageSquareMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm0 11H8v-2h8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageSquareError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-3 16h-2v-2h2v2zm0-4h-2V6h2v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageSquareEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zM8.999 17H7v-1.999l5.53-5.522 1.999 1.999L8.999 17zm6.473-6.465-1.999-1.999 1.524-1.523 1.999 1.999-1.524 1.523z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageSquareDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-5 10.5A1.5 1.5 0 0 1 9.5 14c-.086 0-.168-.011-.25-.025-.083.01-.164.025-.25.025a2 2 0 1 1 2-2c0 .085-.015.167-.025.25.013.082.025.164.025.25zm4 1.5c-.086 0-.167-.015-.25-.025a1.471 1.471 0 0 1-.25.025 1.5 1.5 0 0 1-1.5-1.5c0-.085.012-.168.025-.25-.01-.083-.025-.164-.025-.25a2 2 0 1 1 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageSquareDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-2 13H7v-2h7v2zm3-4H7V9h10v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageSquareCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-5 14.414-3.707-3.707 1.414-1.414L11 13.586l4.793-4.793 1.414 1.414L11 16.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageSquareAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm1 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageRounded(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageRoundedX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm3.707 10.293-1.414 1.414L12 11.414l-2.293 2.293-1.414-1.414L10.586 10 8.293 7.707l1.414-1.414L12 8.586l2.293-2.293 1.414 1.414L13.414 10l2.293 2.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageRoundedMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm4 9H8V9h8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageRoundedError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.516 5 6.934V22l5.34-4.005C17.697 17.854 22 14.32 22 10c0-4.411-4.486-8-10-8zm1 12h-2v-2h2v2zm0-4h-2V5h2v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageRoundedEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.516 5 6.934V22l5.34-4.005C17.697 17.854 22 14.32 22 10c0-4.411-4.486-8-10-8zM9.302 13.986H7.503v-1.798l4.976-4.97 1.798 1.799-4.975 4.969zm5.823-5.816-1.799-1.798 1.372-1.371 1.799 1.798-1.372 1.371z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageRoundedDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.897 5.516 5 6.934V22l5.34-4.004C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm-2.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageRoundedDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm2 11H7v-2h7v2zm3-4H7V7h10v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageRoundedCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm-1 12.414-3.707-3.707 1.414-1.414L11 11.586l4.793-4.793 1.414 1.414L11 14.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageRoundedAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm4 9h-3v3h-2v-3H8V9h3V6h2v3h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-4 9H8V9h8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-7 13h-2v-2h2v2zm0-4h-2V5h2v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zM8.999 14.999H7V13l5.53-5.522 1.998 1.999-5.529 5.522zm6.472-6.464-1.999-1.999 1.524-1.523 1.999 1.999-1.524 1.523z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.017C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-9 8a2 2 0 1 1-2-2c.086 0 .167.015.25.025.082-.014.164-.025.25-.025A1.5 1.5 0 0 1 11 9.5c0 .086-.012.168-.025.25.01.083.025.165.025.25zm4 2a2 2 0 0 1-2-2c0-.086.015-.167.025-.25A1.592 1.592 0 0 1 13 9.5 1.5 1.5 0 0 1 14.5 8c.086 0 .168.011.25.025.083-.01.164-.025.25-.025a2 2 0 0 1 0 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-6 11H7v-2h7v2zm3-4H7V7h10v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-9 11.914-3.707-3.707 1.414-1.414L11 11.086l4.793-4.793 1.414 1.414L11 13.914z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.999 2h-14c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4h3.5c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageAltX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 18 3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5zM7.293 6.707l1.414-1.414L12 8.586l3.293-3.293 1.414 1.414L13.414 10l3.293 3.293-1.414 1.414L12 11.414l-3.293 3.293-1.414-1.414L10.586 10 7.293 6.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageAltMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm11 9H8V9h8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageAltError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm8 1h2v6h-2V5zm0 8h2v2h-2v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageAltEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm4.302 11.987h-1.8v-1.799l4.978-4.97 1.798 1.799-4.976 4.97zm5.823-5.817-1.798-1.799L14.698 5l1.8 1.799-1.373 1.371z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageAltDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM9 12a2 2 0 1 1 .001-4.001A2 2 0 0 1 9 12zm6 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 15 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageAltDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 18 3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5zM7 7h10v2H7V7zm0 4h7v2H7v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageAltCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm5.707 4.293L11 10.586l4.793-4.793 1.414 1.414L11 13.414 7.293 9.707l1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageAltAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 18 3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5zM7 9h4V5h2v4h4v2h-4v4h-2v-4H7V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMessageAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-3 9h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMemoryCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V7l-5-5zm-6 8H7V6h2v4zm3 0h-2V6h2v4zm3 0h-2V6h2v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMeh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zm9 6.5H7.974v-2H16v2zm-.507-5.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMehBlank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8.5 12a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8.5 12zm6.993-.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMehAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-6 8h4v2H6v-2zm10 7H7.974v-2H16v2zm2-5h-4v-2h4v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMegaphone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.664 3.478 8 8v7l.748.267-1.127 2.254a1.999 1.999 0 0 0 1.156 2.792l4.084 1.361a2.015 2.015 0 0 0 2.421-1.003l1.303-2.606 4.079 1.457A1 1 0 0 0 22 18.581V4.419a1 1 0 0 0-1.336-.941zm-7.171 16.299L9.41 18.416l1.235-2.471 4.042 1.444-1.194 2.388zM4 15h2V8H4c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMedal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2h-4v4.059a8.946 8.946 0 0 1 4 1.459V2zm-6 0H7v5.518a8.946 8.946 0 0 1 4-1.459V2zm1 20a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm-1.225-8.519L12 11l1.225 2.481 2.738.397-1.981 1.932.468 2.727L12 17.25l-2.449 1.287.468-2.727-1.981-1.932 2.737-.397z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H5C3.346 6 2 7.346 2 9v5c0 2.206 1.794 4 4 4h1.637c1.166 0 2.28-.557 2.981-1.491.66-.879 2.104-.88 2.764.001A3.744 3.744 0 0 0 16.363 18H18c2.206 0 4-1.794 4-4V9c0-1.654-1.346-3-3-3zM7.5 13C6.119 13 5 12.328 5 11.5S6.119 10 7.5 10s2.5.672 2.5 1.5S8.881 13 7.5 13zm9 0c-1.381 0-2.5-.672-2.5-1.5s1.119-1.5 2.5-1.5 2.5.672 2.5 1.5-1.119 1.5-2.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995 3.971 16.44 11.696 21.784 12 22c0 0 8.029-5.56 8-12 0-4.411-3.589-8-8-8zm0 12c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMapPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 17 1-2V9.858c1.721-.447 3-2 3-3.858 0-2.206-1.794-4-4-4S8 3.794 8 6c0 1.858 1.279 3.411 3 3.858V15l1 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.267 10.563-.533 1.928C18.325 13.207 20 14.584 20 16c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.416 1.675-2.793 4.267-3.51l-.533-1.928C4.197 11.54 2 13.623 2 16c0 3.364 4.393 6 10 6s10-2.636 10-6c0-2.377-2.197-4.46-5.733-5.437z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMapAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 6.882-7-3.5v13.236l7 3.5 6-3 7 3.5V7.382l-7-3.5-6 3zM15 15l-6 3V9l6-3v9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMagnet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H5a1 1 0 0 0-1 1v3h5V4a1 1 0 0 0-1-1zm7 1v3h5V4a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1zm0 10a3 3 0 0 1-6 0V9H4v5a8 8 0 0 0 16 0V9h-5v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidMagicWand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11 4-.5-1-.5 1-1 .125.834.708L9.5 6l1-.666 1 .666-.334-1.167.834-.708zm8.334 10.666L18.5 13l-.834 1.666-1.666.209 1.389 1.181L16.834 18l1.666-1.111L20.166 18l-.555-1.944L21 14.875zM6.667 6.333 6 5l-.667 1.333L4 6.5l1.111.944L4.667 9 6 8.111 7.333 9l-.444-1.556L8 6.5zM3.414 17c0 .534.208 1.036.586 1.414L5.586 20c.378.378.88.586 1.414.586s1.036-.208 1.414-.586L20 8.414c.378-.378.586-.88.586-1.414S20.378 5.964 20 5.586L18.414 4c-.756-.756-2.072-.756-2.828 0L4 15.586c-.378.378-.586.88-.586 1.414zM17 5.414 18.586 7 15 10.586 13.414 9 17 5.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLowVision(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.998c-1.836 0-3.356.389-4.617.971L3.707 2.293 2.293 3.707l3.315 3.315c-2.613 1.952-3.543 4.618-3.557 4.66l-.105.316.105.316C2.073 12.382 4.367 19 12 19c1.835 0 3.354-.389 4.615-.971l3.678 3.678 1.414-1.414-3.317-3.317c2.614-1.952 3.545-4.618 3.559-4.66l.105-.316-.105-.316c-.022-.068-2.316-6.686-9.949-6.686zM12.043 7H12a5 5 0 0 1 5 5 4.894 4.894 0 0 1-.852 2.734l-.721-.721A3.919 3.919 0 0 0 16 11.999c0-.474-.099-.925-.255-1.349A.985.985 0 0 1 15 11a1 1 0 0 1-1-1c0-.439.288-.802.682-.936A3.965 3.965 0 0 0 12 7.999c-.735 0-1.419.218-2.015.572l-.72-.72C10.053 7.326 10.982 7 12 7h-.043L12 6.998l.043.002zm-7.969 4.999c.103-.235.274-.586.521-.989l5.867 5.867c-4.213-.647-5.939-3.842-6.388-4.878zm9.247 4.908-7.48-7.48a8.146 8.146 0 0 1 1.188-.984l8.055 8.055a8.835 8.835 0 0 1-1.763.409z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLogOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6a1 1 0 0 0-1 1v9l5-4v3h6v2h-6v3l-5-4v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLogOutCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.963 0-9 4.037-9 9v.001l5-4v3h7v2H8v3l-5-4C3.001 16.964 7.037 21 12 21s9-4.037 9-9-4.037-9-9-9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLogIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-13a.5.5 0 0 0-.5.5V11h6V8l5 4-5 4v-3H5v8.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-19a.5.5 0 0 0-.5-.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLogInCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.625 0-8.442 3.507-8.941 8.001H10v-3l5 4-5 4v-3H3.06C3.56 17.494 7.376 21 12 21c4.963 0 9-4.037 9-9s-4.037-9-9-9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C9.243 2 7 4.243 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9V7zm4 10.723V20h-2v-2.277a1.993 1.993 0 0 1 .567-3.677A2.001 2.001 0 0 1 14 16a1.99 1.99 0 0 1-1 1.723z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLockOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3h2c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-7.939 5.499A2.002 2.002 0 0 1 14 16a1.99 1.99 0 0 1-1 1.723V20h-2v-2.277a1.992 1.992 0 0 1-.939-2.224z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLockOpenAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8V7c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3v1h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLockAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLocationPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22s8.029-5.56 8-12c0-4.411-3.589-8-8-8S4 5.589 4 9.995C3.971 16.44 11.696 21.784 12 22zM8 9h3V6h2v3h3v2h-3v3h-2v-3H8V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLike(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h1V8H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2zM20 8h-7l1.122-3.368A2 2 0 0 0 12.225 2H12L7 7.438V21h11l3.912-8.596L22 12v-2a2 2 0 0 0-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLemon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.45 8.74A2.23 2.23 0 0 1 21.64 7a3.51 3.51 0 0 0 .24-2.47 3.55 3.55 0 0 0-2.45-2.45 3.51 3.51 0 0 0-2.43.28 2.23 2.23 0 0 1-1.7.19 10.07 10.07 0 0 0-6.53 0 9.87 9.87 0 0 0-6.23 6.18 10.07 10.07 0 0 0 0 6.53A2.23 2.23 0 0 1 2.36 17a3.51 3.51 0 0 0-.24 2.47 3.55 3.55 0 0 0 2.45 2.45A3.51 3.51 0 0 0 7 21.64a2.23 2.23 0 0 1 1.7-.19A9.83 9.83 0 0 0 12 22a10.33 10.33 0 0 0 3.27-.54 9.87 9.87 0 0 0 6.19-6.19 10.07 10.07 0 0 0-.01-6.53zM12 7a5 5 0 0 0-5 5H5a7 7 0 0 1 7-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLeftTopArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 19.071c3.898-3.899 3.898-10.244 0-14.143-3.899-3.898-10.243-3.898-14.143 0-3.898 3.899-3.898 10.244 0 14.143 3.9 3.899 10.244 3.899 14.143 0zM8.465 8.464h7.07l-2.828 2.829 3.535 3.536-1.414 1.414-3.535-3.536-2.828 2.829V8.464z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLeftDownArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 19.071c3.898-3.899 3.898-10.244 0-14.143-3.899-3.899-10.244-3.898-14.143 0-3.898 3.899-3.899 10.243 0 14.143 3.9 3.899 10.244 3.899 14.143 0zM8.464 8.464l2.829 2.829 3.535-3.536 1.414 1.414-3.535 3.536 2.828 2.829H8.464V8.464z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLeftArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4.431 12.822 13 9A1 1 0 0 0 19 21V3a1 1 0 0 0-1.569-.823l-13 9a1.003 1.003 0 0 0 0 1.645z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLeftArrowSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14zM12 7v4h5v2h-5v4l-5-5 5-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLeftArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11h-5v4l-5-5 5-5v4h5v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLeftArrowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5 12 7 6v-5h6v-2h-6V6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m22 3.41-.12-1.26-1.2.4a13.84 13.84 0 0 1-6.41.64 11.87 11.87 0 0 0-6.68.9A7.23 7.23 0 0 0 3.3 9.5a9 9 0 0 0 .39 4.58 16.6 16.6 0 0 1 1.18-2.2 9.85 9.85 0 0 1 4.07-3.43 11.16 11.16 0 0 1 5.06-1A12.08 12.08 0 0 0 9.34 9.2a9.48 9.48 0 0 0-1.86 1.53 11.38 11.38 0 0 0-1.39 1.91 16.39 16.39 0 0 0-1.57 4.54A26.42 26.42 0 0 0 4 22h2a30.69 30.69 0 0 1 .59-4.32 9.25 9.25 0 0 0 4.52 1.11 11 11 0 0 0 4.28-.87C23 14.67 22 3.86 22 3.41z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLayout(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v4h18V5c0-1.103-.897-2-2-2zM3 19c0 1.103.897 2 2 2h8V11H3v8zm12 2h4c1.103 0 2-.897 2-2v-8h-6v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLayer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.484 7.125-9.022-5a1.003 1.003 0 0 0-.968 0l-8.978 4.96a1 1 0 0 0-.003 1.748l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 15.856-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 15.856z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 19.856-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLayerPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.513 12.833 9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749l-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.485 15.126-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856l-8.515-4.73zM20 8V6h2V4h-2V2h-2v2h-2v2h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLayerMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.484 11.125-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.515 15.126 12 19.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748zM16 4h6v2h-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLaugh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-6.447 9.105 2.459-1.229-1.567-1.044 1.109-1.664 3 2a1 1 0 0 1-.108 1.727l-4 2-.893-1.79zM12 18c-4 0-5-4-5-4h10s-1 4-5 4zm5.553-5.105-4-2a1 1 0 0 1-.108-1.727l3-2 1.109 1.664-1.566 1.044 2.459 1.229-.894 1.79z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLandscape(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 7-5.223 8.487L7 13l-5 7h20z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLandmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17h-2V9h2V7a.998.998 0 0 0-.594-.914l-9.432-4.191-8.421 4.21A1 1 0 0 0 2 7v2h2v8H2v4h19v-4zm-5-8v8h-3V9h3zM7 9h3v8H7V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidLabel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.813 4.419A.997.997 0 0 0 16 4H3a1 1 0 0 0-.813 1.581L6.771 12l-4.585 6.419A1 1 0 0 0 3 20h13a.997.997 0 0 0 .813-.419l5-7a.997.997 0 0 0 0-1.162l-5-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidKeyboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm-8 2h2v2h-2V7zm0 4h2v2h-2v-2zM9 7h2v2H9V7zm0 4h2v2H9v-2zM5 7h2v2H5V7zm0 4h2v2H5v-2zm12 6H7v-2h10v2zm2-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.433 17.325 3.079 19.8a1 1 0 0 0 1.131 1.131l2.475-.354C7.06 20.524 8 18 8 18s.472.405.665.466c.412.13.813-.274.948-.684L10 16.01s.577.292.786.335c.266.055.524-.109.707-.293a.988.988 0 0 0 .241-.391L12 14.01s.675.187.906.214c.263.03.519-.104.707-.293l1.138-1.137a5.502 5.502 0 0 0 5.581-1.338 5.507 5.507 0 0 0 0-7.778 5.507 5.507 0 0 0-7.778 0 5.5 5.5 0 0 0-1.338 5.581l-7.501 7.5a.994.994 0 0 0-.282.566zM18.504 5.506a2.919 2.919 0 0 1 0 4.122l-4.122-4.122a2.919 2.919 0 0 1 4.122 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidJoystick(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.986 9.74a3.193 3.193 0 0 0-.008-.088A5.003 5.003 0 0 0 17 5H7a4.97 4.97 0 0 0-4.987 4.737c-.01.079-.013.161-.013.253v6.51c0 .925.373 1.828 1.022 2.476A3.524 3.524 0 0 0 5.5 20c1.8 0 2.504-1 3.5-3 .146-.292.992-2 3-2 1.996 0 2.853 1.707 3 2 1.004 2 1.7 3 3.5 3 .925 0 1.828-.373 2.476-1.022A3.524 3.524 0 0 0 22 16.5V10c0-.095-.004-.18-.014-.26zM7 12.031a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 12.031zm10-5a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-2 4a1 1 0 1 1 0-2 1 1 0 1 1 0 2zm2 2a1 1 0 1 1 0-2 1 1 0 1 1 0 2zm2-2a1 1 0 1 1 0-2 1 1 0 1 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidJoystickButton(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-4V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM7 14l-3-2 3-2v4zm5 6-2-3h4l-2 3zm0-6a2 2 0 1 1 .001-4.001A2 2 0 0 1 12 14zm-2-7 2-3 2 3h-4zm7 7v-4l3 2-3 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidJoystickAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8a6 6 0 0 0 0 12h8a6 6 0 0 0 0-12zm-5 7H9v2H7v-2H5v-2h2V9h2v2h2v2zm3.5 2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3-3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidInvader(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3h2v2H6zm2 16h3v2H8zm8-16h2v2h-2zm-3 16h3v2h-3zm7-8V9h-2V7h-2V5h-2v2h-4V5H8v2H6v2H4v2H2v8h2v-4h2v4h2v-3h8v3h2v-4h2v4h2v-8zm-10 1H8V9h2zm6 0h-2V9h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidInstitution(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.857 8.485-3-5A.997.997 0 0 0 18 3h-4.586l-.707-.707a.999.999 0 0 0-1.414 0L10.586 3H6a.997.997 0 0 0-.857.485l-3 5A1.001 1.001 0 0 0 2.002 9H2v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9h-.002c0-.178-.046-.356-.141-.515zM20 18h-6v-4h-4v4H4v-8h2.414l.293-.293 2-2L12 4.414l4.293 4.293 1 1 .293.293H20v8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.895",
                    "cy": "9.895",
                    "r": "2.105"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h2v3H6zm10 0h2v3h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidInjection(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.61 9.24 8.35l3.31 3.31-1.06 1.06-3.31-3.31-1.77 1.77 3.31 3.31-1.06 1.06-3.31-3.31-2 2A2 2 0 0 0 3 16.66l1 1.89-2.25 2.29 1.41 1.41L5.45 20l1.89 1a2 2 0 0 0 1 .26 2 2 0 0 0 1.42-.59L18.39 12zm7.8 3.59-1.79-1.8 1.42-1.41 1.41 1.41 1.41-1.41-4.24-4.24-1.41 1.41 1.41 1.42-1.41 1.41-1.8-1.79-1.74-1.75-1.41 1.42 1.03 1.03v.01l6.41 6.41h.01l1.03 1.03 1.42-1.41-1.74-1.74h-.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidInfoSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1zm8 3h2v2h-2V7zm0 4h2v6h-2v-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidInfoCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidInbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5c0-1.103-.897-2-2-2zm-1 9h-3.142c-.446 1.722-1.997 3-3.858 3s-3.412-1.278-3.858-3H4V5h16v7h-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.999 4h-16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-13.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm5.5 10h-7l4-5 1.5 2 3-4 5.5 7h-7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidImageAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm3-7 2.363 2.363L14 11l5 7H5l3-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidImageAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 13 3-4 3 4.5V12h4V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8v-4H5l3-4 1 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidIdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM8.715 8c1.151 0 2 .849 2 2s-.849 2-2 2-2-.849-2-2 .848-2 2-2zm3.715 8H5v-.465c0-1.373 1.676-2.785 3.715-2.785s3.715 1.412 3.715 2.785V16zM19 15h-4v-2h4v2zm0-4h-5V9h5v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHourglass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 22h1v-2h-1v-1a7.014 7.014 0 0 0-3.433-6.02c-.355-.21-.567-.547-.567-.901v-.158c0-.354.212-.691.566-.9A7.016 7.016 0 0 0 19 5V4h1V2H4v2h1v1a7.016 7.016 0 0 0 3.434 6.021c.354.209.566.545.566.9v.158c0 .354-.212.691-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h15zM17 4v1a5.005 5.005 0 0 1-1.004 3H8.004A5.005 5.005 0 0 1 7 5V4h10zM9.45 14.702c.971-.574 1.55-1.554 1.55-2.623V12h2v.079c0 1.068.579 2.049 1.551 2.623A4.98 4.98 0 0 1 16.573 17H7.427a4.977 4.977 0 0 1 2.023-2.298z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHourglassTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.566 11.021A7.016 7.016 0 0 0 19 5V4h1V2H4v2h1v1a7.016 7.016 0 0 0 3.434 6.021c.354.208.566.545.566.9v.158c0 .354-.212.69-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h16v-2h-1v-1a7.014 7.014 0 0 0-3.433-6.02c-.355-.21-.567-.547-.567-.901v-.158c0-.355.212-.692.566-.9zM17 19v1H7v-1a5.01 5.01 0 0 1 2.45-4.299A3.111 3.111 0 0 0 10.834 13h2.332c.23.691.704 1.3 1.385 1.702A5.008 5.008 0 0 1 17 19z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHourglassBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H4v2h1v1a7.014 7.014 0 0 0 3.433 6.02c.355.21.567.547.567.901v.158c0 .354-.212.691-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h16v-2h-1v-1a7.016 7.016 0 0 0-3.434-6.021c-.354-.208-.566-.545-.566-.9v-.158c0-.354.212-.69.566-.9A7.016 7.016 0 0 0 19 5V4h1V2H5zm12 3a5.01 5.01 0 0 1-2.45 4.299A3.107 3.107 0 0 0 13.166 11h-2.332a3.114 3.114 0 0 0-1.385-1.702A5.008 5.008 0 0 1 7 5V4h10v1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHotel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "11",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.205 7H12v8H4V6H2v14h2v-3h16v3h2v-4c0-.009-.005-.016-.005-.024H22V11c0-2.096-1.698-4-3.795-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 8c0 1.5-.5 3.5-2.9 4.3.7-1.7.8-3.4.3-5-.7-2.1-3-3.7-4.6-4.6-.4-.3-1.1.1-1 .7 0 1.1-.3 2.7-2 4.4C4.1 10 3 12.3 3 14.5 3 17.4 5 21 9 21c-4-4-1-7.5-1-7.5.8 5.9 5 7.5 7 7.5 1.7 0 5-1.2 5-6.4 0-3.1-1.3-5.5-2.4-6.9-.3-.5-1-.2-1.1.3"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHomeSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .913-.593.998.998 0 0 0-.17-1.076l-9-10c-.379-.422-1.107-.422-1.486 0l-9 10A1 1 0 0 0 3 14zm5.949-.316C8.98 13.779 9.762 16 12 16c2.269 0 3.042-2.287 3.05-2.311l1.9.621C16.901 14.461 15.703 18 12 18s-4.901-3.539-4.95-3.689l1.899-.627z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHomeHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .913-.593.998.998 0 0 0-.17-1.076l-9-10c-.379-.422-1.107-.422-1.486 0l-9 10A1 1 0 0 0 3 14zm5.653-2.359a2.224 2.224 0 0 1 3.125 0l.224.22.223-.22a2.225 2.225 0 0 1 3.126 0 2.13 2.13 0 0 1 0 3.07L12.002 18l-3.349-3.289a2.13 2.13 0 0 1 0-3.07z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHomeCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10A1 1 0 0 0 3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669zM12 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHomeAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.74 2.32a1 1 0 0 0-1.48 0l-9 10A1 1 0 0 0 3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a1 1 0 0 0 1-1 1 1 0 0 0-.26-.68z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.073 12.194 4.212 8.333c-1.52 1.657-2.096 3.317-2.106 3.351L2 12l.105.316C2.127 12.383 4.421 19 12.054 19c.929 0 1.775-.102 2.552-.273l-2.746-2.746a3.987 3.987 0 0 1-3.787-3.787zM12.054 5c-1.855 0-3.375.404-4.642.998L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.298-3.298c2.638-1.953 3.579-4.637 3.593-4.679l.105-.316-.105-.316C21.98 11.617 19.687 5 12.054 5zm1.906 7.546c.187-.677.028-1.439-.492-1.96s-1.283-.679-1.96-.492L10 8.586A3.955 3.955 0 0 1 12.054 8c2.206 0 4 1.794 4 4a3.94 3.94 0 0 1-.587 2.053l-1.507-1.507z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHelpCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 16h-2v-2h2v2zm.976-4.885c-.196.158-.385.309-.535.459-.408.407-.44.777-.441.793v.133h-2v-.167c0-.118.029-1.177 1.026-2.174.195-.195.437-.393.691-.599.734-.595 1.216-1.029 1.216-1.627a1.934 1.934 0 0 0-3.867.001h-2C8.066 7.765 9.831 6 12 6s3.934 1.765 3.934 3.934c0 1.597-1.179 2.55-1.958 3.181z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.205 4.791a5.938 5.938 0 0 0-4.209-1.754A5.906 5.906 0 0 0 12 4.595a5.904 5.904 0 0 0-3.996-1.558 5.942 5.942 0 0 0-4.213 1.758c-2.353 2.363-2.352 6.059.002 8.412L12 21.414l8.207-8.207c2.354-2.353 2.355-6.049-.002-8.416z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHeartSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1zM7.812 8.907a2.746 2.746 0 0 1 3.907 0l.279.279.278-.279a2.746 2.746 0 0 1 3.907 0 2.745 2.745 0 0 1 0 3.907L11.998 17l-4.187-4.186a2.747 2.747 0 0 1 .001-3.907z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHeartCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.186 10.74L12 16.926 7.814 12.74a2.745 2.745 0 0 1 0-3.907 2.745 2.745 0 0 1 3.906 0l.28.279.279-.279a2.745 2.745 0 0 1 3.906 0 2.745 2.745 0 0 1 .001 3.907z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-4 5h-2v-2h2v2zm4 0h-2v-2h2v2zm.775-7H21l-1.652-7.434A2 2 0 0 0 17.396 2H6.604a2 2 0 0 0-1.952 1.566L3 11h17.775z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHardHat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-3a8 8 0 0 0-5-7.4V13h-1V5h-4v8H9V7.6A8 8 0 0 0 4 15v3H2v2h20v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHappy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3.493 7a1.494 1.494 0 1 1-.001 2.987A1.494 1.494 0 0 1 15.493 9zM8.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 9zm3.5 9c-4 0-5-4-5-4h10s-1 4-5 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHappyHeartEyes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM6.435 8.467A1.49 1.49 0 0 1 8.502 8.4a1.49 1.49 0 0 1 2.065.033c.597.592.604 1.521.018 2.118l-2.05 2.083-2.082-2.05a1.484 1.484 0 0 1-.018-2.117zM12 18c-4 0-5-4-5-4h10s-1 4-5 4zm5.585-7.449-2.05 2.083-2.082-2.05a1.485 1.485 0 0 1-.019-2.117 1.49 1.49 0 0 1 2.068-.067 1.49 1.49 0 0 1 2.065.033c.597.591.605 1.521.018 2.118z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHappyBeaming(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8 9c2.201 0 3 1.794 3 3H9c-.012-.45-.194-1-1-1s-.988.55-1 1.012L5 12c0-1.206.799-3 3-3zm4 9c-4 0-5-4-5-4h10s-1 4-5 4zm5-6c-.012-.45-.194-1-1-1s-.988.55-1 1.012L13 12c0-1.206.799-3 3-3s3 1.794 3 3h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHappyAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3.493 6a1.494 1.494 0 1 1-.001 2.987A1.494 1.494 0 0 1 15.493 8zM8.5 8a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 8zM12 18c-5 0-6-5-6-5h12s-1 5-6 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 5A1.5 1.5 0 0 0 19 6.5V11h-1V4.5a1.5 1.5 0 0 0-3 0V11h-1V3.5a1.5 1.5 0 0 0-3 0V11h-1V5.5a1.5 1.5 0 0 0-3 0v10.81l-2.22-3.6a1.5 1.5 0 0 0-2.56 1.58l3.31 5.34A5 5 0 0 0 9.78 22H17a5 5 0 0 0 5-5V6.5A1.5 1.5 0 0 0 20.5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHandUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.221 10.803 12 10V4a2 2 0 0 0-4 0v12l-3.031-1.212a2 2 0 0 0-2.64 1.225l-.113.34a.998.998 0 0 0 .309 1.084l5.197 4.332c.179.149.406.231.64.231H19a2 2 0 0 0 2-2v-7.21a2 2 0 0 0-1.779-1.987z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHandRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8H8l1.212-3.03a2 2 0 0 0-1.225-2.641l-.34-.113a.998.998 0 0 0-1.084.309L2.231 7.722a1.001 1.001 0 0 0-.231.64V19a2 2 0 0 0 2 2h7.21a2 2 0 0 0 1.987-1.779L14 12h6a2 2 0 0 0 0-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHandLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-7.21a2 2 0 0 0-1.987 1.779L10 12H4a2 2 0 0 0 0 4h12l-1.212 3.03a2.001 2.001 0 0 0 1.225 2.641l.34.113a.998.998 0 0 0 1.084-.309l4.332-5.197c.149-.179.231-.406.231-.64V5a2 2 0 0 0-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidHandDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.278 2.231a1.001 1.001 0 0 0-.64-.231H5a2 2 0 0 0-2 2v7.21a2 2 0 0 0 1.779 1.987L12 14v6a2 2 0 0 0 4 0V8l3.03 1.212a2.001 2.001 0 0 0 2.641-1.225l.113-.34a.998.998 0 0 0-.309-1.084l-5.197-4.332z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidGuitarAmp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM8 4h8v2H8V4zM6 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2-4H4V8h16v4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h2v2h-2zm3 0h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm1.5 1H8c-3.309 0-6 2.691-6 6v1h15v-1c0-3.309-2.691-6-6-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.604 11.048a5.67 5.67 0 0 0 .751-3.44c-.179-1.784-1.175-3.361-2.803-4.44l-1.105 1.666c1.119.742 1.8 1.799 1.918 2.974a3.693 3.693 0 0 1-1.072 2.986l-1.192 1.192 1.618.475C18.951 13.701 19 17.957 19 18h2c0-1.789-.956-5.285-4.396-6.952z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidGrid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zM4 10h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zM4 16h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidGridAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zM4 21h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidGraduation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v1l11 4 9-4V7L11 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11v4.267c0 1.621 4.001 3.893 9 3.734 4-.126 6.586-1.972 7-3.467.024-.089.037-.178.037-.268V11L13 14l-5-1.667v3.213l-1-.364V12l-3-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H4v8a2 2 0 0 0 2 2h5V12H5zm13 0h-5v10h5a2 2 0 0 0 2-2v-8h-2zm.791-5A4.92 4.92 0 0 0 19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H2v4h9V9h2v2h9V7h-3.209zM7 5.5C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM15.5 4c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.477c.51-1.576 1.251-3 1.977-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidGhost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11v8h.051c.245 1.692 1.69 3 3.449 3 1.174 0 2.074-.417 2.672-1.174a3.99 3.99 0 0 0 5.668-.014c.601.762 1.504 1.188 2.66 1.188 1.93 0 3.5-1.57 3.5-3.5V11c0-4.962-4.037-9-9-9s-9 4.038-9 9zm6 1c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm6-4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidGasPump(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.616 6.48.014-.017-4-3.24-1.26 1.554 2.067 1.674a2.99 2.99 0 0 0-1.394 3.062c.15.899.769 1.676 1.57 2.111.895.487 1.68.442 2.378.194L18.976 18a.996.996 0 0 1-1.39.922.995.995 0 0 1-.318-.217.996.996 0 0 1-.291-.705L17 16a2.98 2.98 0 0 0-.877-2.119A3 3 0 0 0 14 13h-1V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-4h1c.136 0 .267.027.391.078a1.028 1.028 0 0 1 .531.533A.994.994 0 0 1 15 16l-.024 2c0 .406.079.799.236 1.168.151.359.368.68.641.951a2.97 2.97 0 0 0 2.123.881c.406 0 .798-.078 1.168-.236.358-.15.68-.367.951-.641A2.983 2.983 0 0 0 20.976 18L21 9a2.997 2.997 0 0 0-1.384-2.52zM11 8H4V5h7v3zm7 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidGame(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c3.719 0 7.063-2.035 8.809-5.314L13 12l7.809-4.686C19.063 4.035 15.719 2 12 2 6.486 2 2 6.486 2 12s4.486 10 10 10zm-.5-16a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 11.5 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFridge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v5h4V6h2v3h10V4c0-1.103-.897-2-2-2zm-8 13H8v-5H4v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V10H10v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFoodMenu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h2v20H3zm16 0H6v20h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-1 10H9v-2h9v2zm0-4H9V6h9v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFolderPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-4 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.165 19.551c.186.28.499.449.835.449h15c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 11h-1V8c0-1.103-.897-2-2-2h-6.655L8.789 4H4c-1.103 0-2 .897-2 2v13h.007a1 1 0 0 0 .158.551zM18 8v3H6c-.4 0-.762.238-.919.606L4 14.129V8h14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFolderMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-4 9H8v-2h8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFlorist(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.84 21.871 12 22a10.221 10.221 0 0 0-9.013-8.891L2 13l.021.173a10.001 10.001 0 0 0 8.819 8.698zm11.139-8.698L22 13l-.987.109c-4.7.523-8.427 4.2-9.013 8.891l1.16-.129a10.001 10.001 0 0 0 8.819-8.698zM18.063 5.5a2.5 2.5 0 0 0-3.415-.915c-.062.035-.111.081-.168.121.005-.069.02-.136.02-.206a2.5 2.5 0 1 0-5 0c0 .07.015.137.021.206-.057-.04-.107-.086-.168-.121a2.5 2.5 0 0 0-2.5 4.33c.061.035.126.056.188.085-.062.029-.127.05-.188.085a2.5 2.5 0 0 0 2.5 4.33c.062-.035.111-.081.168-.121-.006.069-.021.136-.021.206a2.5 2.5 0 1 0 5 0c0-.07-.015-.137-.021-.206.057.04.106.086.168.121a2.5 2.5 0 0 0 2.5-4.33c-.061-.035-.126-.056-.188-.085.063-.029.127-.05.188-.085a2.5 2.5 0 0 0 .916-3.415zM12 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFlask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.783V4h1V2H8v2h1v5.783l-4.268 9.389a1.992 1.992 0 0 0 .14 1.911A1.99 1.99 0 0 0 6.553 22h10.895a1.99 1.99 0 0 0 1.681-.917c.37-.574.423-1.289.14-1.911L15 9.783zm-4.09.631c.06-.13.09-.271.09-.414V4h2v6c0 .143.03.284.09.414L15.177 15H8.825l2.085-4.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFlame(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.579 2.393a.982.982 0 0 0-1.153.006C9.592 3.728 4 8.252 4 14c0 3.247 1.948 6.043 4.734 7.296A3.971 3.971 0 0 1 8 19c-.017-3.221 3.558-6.893 3.71-7a.497.497 0 0 1 .579 0c.152.107 3.711 2.974 3.711 7.002 0 .854-.275 1.643-.733 2.294C18.052 20.043 20 17.248 20 14.005c0-5.861-5.582-10.307-7.421-11.612z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H6V2H4v18H3v2h4v-2H6v-5h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFlagCheckered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v18H3v2h4v-2H6v-5h13a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6V2H4zm4 3v2h2V5h2v2h2V5h2v2h2v2h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H8v-2H6V9h2V7H6V5h2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h2v2H8zm4 0h2v2h-2zm-2-2h2v2h-2zm4 0h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFlagAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.303 6-3-2H6V2H4v20h2v-8h4.697l3 2H20V6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFirstAid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM9 4h6v2H9zm7 10h-3v3h-2v-3H8v-2h3V9h2v3h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFilterAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 20v-4.586L20.414 8c.375-.375.586-.884.586-1.415V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2.585c0 .531.211 1.04.586 1.415L11 15.414V22l2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4v1h-2V3H7v2H5V3H3v18h2v-2h2v2h10v-2h2v2h2V3h-2v1zM5 7h2v2H5V7zm0 4h2v2H5v-2zm0 6v-2h2v2H5zm12 0v-2h2v2h-2zm2-4h-2v-2h2v2zm-2-4V7h2v2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12zM13 4l5 5h-5V4zM7 8h3v2H7V8zm0 4h10v2H7v-2zm0 4h10v2H7v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileTxt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.998 14.768H8.895v3.274h-.917v-3.274H6.893V14h3.105v.768zm2.725 3.274-.365-.731c-.15-.282-.246-.492-.359-.726h-.013c-.083.233-.185.443-.312.726l-.335.731h-1.045l1.171-2.045L10.336 14h1.05l.354.738c.121.245.21.443.306.671h.013c.096-.258.174-.438.276-.671l.341-.738h1.043l-1.139 1.973 1.198 2.069h-1.055zm4.384-3.274h-1.104v3.274h-.917v-3.274h-1.085V14h3.105v.768zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFilePng(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.782 14.576c-.186 0-.312.018-.377.036v1.193c.077.018.174.023.306.023.485 0 .785-.246.785-.659 0-.371-.258-.593-.714-.593z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.03 16.105c-.313.293-.774.426-1.313.426-.12 0-.229-.007-.312-.019v1.445h-.906V13.97a7.504 7.504 0 0 1 1.235-.083c.563 0 .966.107 1.235.323.258.204.432.54.432.936s-.131.731-.371.959zm4.302 1.853h-.96l-.863-1.56c-.24-.432-.504-.953-.701-1.427l-.019.006c.024.534.036 1.104.036 1.763v1.218h-.84v-4.042h1.067l.84 1.481c.24.426.479.93.659 1.385h.019a14.746 14.746 0 0 1-.078-1.685v-1.182h.84v4.043zm4.169-.186a4.512 4.512 0 0 1-1.349.228c-.737 0-1.271-.186-1.644-.546-.371-.348-.575-.875-.569-1.469.006-1.344.983-2.111 2.309-2.111.521 0 .924.103 1.121.198l-.191.731c-.222-.096-.498-.174-.941-.174-.762 0-1.338.432-1.338 1.308 0 .833.522 1.325 1.271 1.325.21 0 .378-.024.45-.061v-.846h-.624v-.713h1.505v2.13zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFilePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2zm7-18 5 5h-5V4zM8 14h3v-3h2v3h3v2h-3v3h-2v-3H8v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFilePdf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.267 14.68c-.184 0-.308.018-.372.036v1.178c.076.018.171.023.302.023.479 0 .774-.242.774-.651 0-.366-.254-.586-.704-.586zm3.487.012c-.2 0-.33.018-.407.036v2.61c.077.018.201.018.313.018.817.006 1.349-.444 1.349-1.396.006-.83-.479-1.268-1.255-1.268z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.498 16.19c-.309.29-.765.42-1.296.42a2.23 2.23 0 0 1-.308-.018v1.426H7v-3.936A7.558 7.558 0 0 1 8.219 14c.557 0 .953.106 1.22.319.254.202.426.533.426.923-.001.392-.131.723-.367.948zm3.807 1.355c-.42.349-1.059.515-1.84.515-.468 0-.799-.03-1.024-.06v-3.917A7.947 7.947 0 0 1 11.66 14c.757 0 1.249.136 1.633.426.415.308.675.799.675 1.504 0 .763-.279 1.29-.663 1.615zM17 14.77h-1.532v.911H16.9v.734h-1.432v1.604h-.906V14.03H17v.74zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileMd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.481 14.015c-.238 0-.393.021-.483.042v3.089c.091.021.237.021.371.021.966.007 1.597-.525 1.597-1.653.007-.981-.568-1.499-1.485-1.499z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-2.934 15.951-.07-1.807a53.142 53.142 0 0 1-.042-1.94h-.021a26.098 26.098 0 0 1-.525 1.828l-.574 1.842H9l-.504-1.828a21.996 21.996 0 0 1-.428-1.842h-.013c-.028.638-.049 1.366-.084 1.954l-.084 1.793h-.988L7.2 13.23h1.422l.462 1.576c.147.546.295 1.135.399 1.688h.021a39.87 39.87 0 0 1 .448-1.694l.504-1.569h1.394l.26 4.721h-1.044zm5.25-.56c-.498.413-1.253.609-2.178.609a9.27 9.27 0 0 1-1.212-.07v-4.636a9.535 9.535 0 0 1 1.443-.099c.896 0 1.478.161 1.933.505.49.364.799.945.799 1.778 0 .904-.33 1.528-.785 1.913zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileJson(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.823 15.122c-.517 0-.816.491-.816 1.146 0 .661.311 1.126.82 1.126.517 0 .812-.49.812-1.146 0-.604-.291-1.126-.816-1.126z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM8.022 16.704c0 .961-.461 1.296-1.2 1.296-.176 0-.406-.029-.557-.08l.086-.615c.104.035.239.06.391.06.319 0 .52-.145.52-.67v-2.122h.761v2.131zm1.459 1.291c-.385 0-.766-.1-.955-.205l.155-.631c.204.105.521.211.846.211.35 0 .534-.146.534-.365 0-.211-.159-.331-.564-.476-.562-.195-.927-.506-.927-.996 0-.576.481-1.017 1.277-1.017.38 0 .659.08.861.171l-.172.615c-.135-.065-.375-.16-.705-.16s-.491.15-.491.325c0 .215.19.311.627.476.596.22.876.53.876 1.006.001.566-.436 1.046-1.362 1.046zm3.306.005c-1.001 0-1.586-.755-1.586-1.716 0-1.012.646-1.768 1.642-1.768 1.035 0 1.601.776 1.601 1.707C14.443 17.33 13.773 18 12.787 18zm4.947-.055h-.802l-.721-1.302a12.64 12.64 0 0 1-.585-1.19l-.016.005c.021.445.031.921.031 1.472v1.016h-.701v-3.373h.891l.701 1.236c.2.354.4.775.552 1.155h.014c-.05-.445-.065-.9-.065-1.406v-.985h.702v3.372zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileJs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-2.745 14.186c0 1.345-.644 1.814-1.681 1.814-.245 0-.567-.042-.777-.112l.119-.861c.147.049.336.084.546.084.448 0 .729-.203.729-.938v-2.97h1.064v2.983zm2.043 1.807c-.539 0-1.071-.141-1.337-.287l.217-.883c.287.147.729.294 1.184.294.491 0 .749-.203.749-.511 0-.295-.224-.463-.791-.666-.784-.272-1.295-.707-1.295-1.394 0-.806.672-1.422 1.786-1.422.533 0 .925.112 1.205.238l-.238.861c-.189-.091-.525-.224-.987-.224s-.687.21-.687.455c0 .301.267.435.875.665.834.309 1.226.742 1.226 1.408-.002.793-.61 1.466-1.907 1.466zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileJpg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.239 16.446c0 1.152-.551 1.554-1.438 1.554-.21 0-.486-.036-.665-.097l.101-.737c.127.042.289.072.469.072.384 0 .623-.174.623-.804v-2.543h.911v2.555zm3.294-.365c-.313.293-.773.426-1.313.426-.12 0-.228-.007-.312-.019v1.445h-.906v-3.988a7.528 7.528 0 0 1 1.236-.083c.563 0 .965.107 1.234.323.259.204.433.54.433.936s-.133.732-.372.96zm4.331 1.667c-.28.096-.815.228-1.349.228-.737 0-1.271-.186-1.643-.546-.371-.348-.575-.875-.57-1.469.007-1.344.983-2.111 2.309-2.111.521 0 .924.103 1.121.198l-.191.731c-.222-.096-.497-.174-.941-.174-.761 0-1.338.432-1.338 1.308 0 .833.523 1.325 1.271 1.325.211 0 .378-.024.451-.061v-.846h-.624v-.713h1.504v2.13zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.285 14.552c-.186 0-.312.018-.377.036v1.193c.077.018.174.023.307.023.484 0 .784-.246.784-.659 0-.372-.257-.593-.714-.593z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileImport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4h-7v3l-5-4 5-4v3h7zM13 4l5 5h-5V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2zm7-18 5 5h-5V4zm-4.5 7a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 11zm.5 5 1.597 1.363L13 13l4 6H7l2-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileHtml(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2 5 5h-5V4zM8.531 18h-.76v-1.411H6.515V18h-.767v-3.373h.767v1.296h1.257v-1.296h.76V18zm3-2.732h-.921V18h-.766v-2.732h-.905v-.641h2.592v.641zM14.818 18l-.05-1.291c-.017-.405-.03-.896-.03-1.387h-.016c-.104.431-.245.911-.375 1.307l-.41 1.316h-.597l-.359-1.307a15.154 15.154 0 0 1-.306-1.316h-.011c-.021.456-.034.976-.059 1.396L12.545 18h-.705l.216-3.373h1.015l.331 1.126c.104.391.21.811.284 1.206h.017c.095-.391.209-.836.32-1.211l.359-1.121h.996L15.563 18h-.745zm3.434 0h-2.108v-3.373h.767v2.732h1.342V18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileGif(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-2.667 15.772A4.512 4.512 0 0 1 9.984 18c-.737 0-1.271-.186-1.644-.546-.371-.348-.575-.875-.569-1.469.006-1.344.983-2.111 2.309-2.111.521 0 .924.103 1.121.198l-.191.731c-.222-.096-.498-.174-.941-.174-.762 0-1.338.432-1.338 1.308 0 .833.522 1.325 1.271 1.325.21 0 .378-.024.45-.061v-.846h-.624v-.713h1.505v2.13zm1.634.186h-.918v-4.042h.918v4.042zm3.262-3.292h-1.553v.923h1.451v.744h-1.451v1.625h-.918v-4.042h2.471v.75zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileFind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12c.178 0 .348-.03.512-.074l-3.759-3.759A4.966 4.966 0 0 1 12 19c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5a4.964 4.964 0 0 1-.833 2.753l3.759 3.759c.044-.164.074-.334.074-.512V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileExport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22a2 2 0 0 0 2-2v-5l-5 4v-3H8v-2h7v-3l5 4V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12zM13 4l5 5h-5V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileDoc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.186 14.552c-.617 0-.977.587-.977 1.373 0 .791.371 1.35.983 1.35.617 0 .971-.588.971-1.374 0-.726-.348-1.349-.977-1.349z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.155 17.454c-.426.354-1.073.521-1.864.521-.475 0-.81-.03-1.038-.06v-3.971a8.16 8.16 0 0 1 1.235-.083c.768 0 1.266.138 1.655.432.42.312.684.81.684 1.522 0 .775-.282 1.309-.672 1.639zm2.99.546c-1.2 0-1.901-.906-1.901-2.058 0-1.211.773-2.116 1.967-2.116 1.241 0 1.919.929 1.919 2.045-.001 1.325-.805 2.129-1.985 2.129zm4.655-.762c.275 0 .581-.061.762-.132l.138.713c-.168.084-.546.174-1.037.174-1.397 0-2.117-.869-2.117-2.021 0-1.379.983-2.146 2.207-2.146.474 0 .833.096.995.18l-.186.726a1.979 1.979 0 0 0-.768-.15c-.726 0-1.29.438-1.29 1.338 0 .809.48 1.318 1.296 1.318zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.584 14.563c-.203 0-.335.018-.413.036v2.645c.078.018.204.018.317.018.828.006 1.367-.449 1.367-1.415.006-.84-.485-1.284-1.271-1.284z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileCss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.446 17.412c.275 0 .581-.061.762-.132l.138.713c-.168.084-.546.174-1.037.174-1.397 0-2.117-.869-2.117-2.021C7.191 14.768 8.175 14 9.398 14c.474 0 .833.096.995.18l-.186.726a1.98 1.98 0 0 0-.768-.149c-.726 0-1.29.438-1.29 1.337.001.808.482 1.318 1.297 1.318zm2.491.755c-.461 0-.917-.119-1.145-.245l.186-.756c.246.126.624.252 1.014.252.42 0 .642-.174.642-.438 0-.252-.192-.396-.678-.57-.672-.234-1.109-.605-1.109-1.193 0-.689.575-1.217 1.529-1.217.455 0 .791.096 1.031.203l-.204.738a1.919 1.919 0 0 0-.846-.192c-.396 0-.587.181-.587.39 0 .258.228.372.749.57.714.264 1.05.636 1.05 1.205-.001.678-.523 1.253-1.632 1.253zm3.24 0c-.461 0-.917-.119-1.145-.245l.186-.756c.246.126.624.252 1.014.252.42 0 .642-.174.642-.438 0-.252-.192-.396-.678-.57-.672-.234-1.109-.605-1.109-1.193 0-.689.575-1.217 1.529-1.217.455 0 .791.096 1.031.203l-.204.738a1.919 1.919 0 0 0-.846-.192c-.396 0-.587.181-.587.39 0 .258.228.372.749.57.714.264 1.05.636 1.05 1.205 0 .678-.523 1.253-1.632 1.253zM14 9h-1V4l5 5h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileBlank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6zm8 7h-1V4l5 5h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFileArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6h-3v2H9v2h2v2H9v2h2v8H7v-6h2v-2H7V8h2V6H7V4h2V2H6zm7 2 5 5h-5V4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h2v2H8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFastForwardCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.485 2 2 6.485 2 12s4.485 10 10 10c5.514 0 10-4.485 10-10S17.514 2 12 2zm1 14v-4l-6 4V8l6 4V8l6 4-6 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFactory(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10V6l-5 4V6l-5 4V4H2v16h20V6l-5 4zm-8 7H7v-3h2v3zm5 0h-2v-3h2v3zm5 0h-2v-3h2v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8 0-1.168.258-2.275.709-3.276.154.09.308.182.456.276.396.25.791.5 1.286.688.494.187 1.088.312 1.879.312.792 0 1.386-.125 1.881-.313s.891-.437 1.287-.687.792-.5 1.287-.688c.494-.187 1.088-.312 1.88-.312s1.386.125 1.88.313c.495.187.891.437 1.287.687s.792.5 1.287.688c.178.067.374.122.581.171.191.682.3 1.398.3 2.141 0 4.411-3.589 8-8 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "12.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "12.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidFaceMask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c0 2.521.945 4.82 2.49 6.582 1.24 1.52 3.266 3.066 6.439 3.358a9.731 9.731 0 0 0 2.141 0c3.174-.292 5.199-1.839 6.439-3.358A9.948 9.948 0 0 0 22 12c0-5.514-4.486-10-10-10zM4.709 8.724c.154.09.308.182.456.276.396.25.791.5 1.286.688.494.187 1.088.312 1.879.312.792 0 1.386-.125 1.881-.313s.891-.437 1.287-.687.792-.5 1.287-.688c.494-.187 1.088-.312 1.88-.312s1.386.125 1.88.313c.495.187.891.437 1.287.687s.792.5 1.287.688c.178.067.374.122.581.171.191.682.3 1.398.3 2.141 0 .843-.133 1.654-.375 2.417-.261.195-.733.474-1.577.756-.769.256-1.672.458-2.685.602a25.337 25.337 0 0 1-6.727 0c-1.013-.144-1.916-.346-2.685-.602-.844-.282-1.316-.561-1.577-.756a7.953 7.953 0 0 1 .335-5.693z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "12.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "12.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidEyedropper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4 15.76-1 4A1 1 0 0 0 3.75 21a1 1 0 0 0 .49 0l4-1a1 1 0 0 0 .47-.26L17 11.41l1.29 1.3 1.42-1.42-1.3-1.29L21 7.41a2 2 0 0 0 0-2.82L19.41 3a2 2 0 0 0-2.82 0L14 5.59l-1.3-1.3-1.42 1.42L12.58 7l-8.29 8.29a1 1 0 0 0-.29.47zm1.87.75L14 8.42 15.58 10l-8.09 8.1-2.12.53z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidExtension(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10V7c0-1.103-.897-2-2-2h-3c0-1.654-1.346-3-3-3S8 3.346 8 5H5c-1.103 0-2 .897-2 2v4h1a2 2 0 0 1 0 4H3v4c0 1.103.897 2 2 2h4v-1a2 2 0 0 1 4 0v1h4c1.103 0 2-.897 2-2v-3c1.654 0 3-1.346 3-3s-1.346-3-3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidExit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.002 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-14c-1.103 0-2 .897-2 2v6.001H10V7l6 5-6 5v-3.999H3.002V19c0 1.103.897 2 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidEvStation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.616 6.48.014-.017-4-3.24-1.26 1.554 2.067 1.674a2.99 2.99 0 0 0-1.394 3.062c.15.899.769 1.676 1.57 2.111.895.487 1.68.442 2.378.194L18.976 18a.996.996 0 0 1-1.39.922.995.995 0 0 1-.318-.217.996.996 0 0 1-.291-.705L17 16a2.98 2.98 0 0 0-.877-2.119A3 3 0 0 0 14 13h-1V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-4h1c.136 0 .267.027.391.078a1.028 1.028 0 0 1 .531.533A.994.994 0 0 1 15 16l-.024 2c0 .406.079.799.236 1.168.151.359.368.68.641.951a2.97 2.97 0 0 0 2.123.881c.406 0 .798-.078 1.168-.236.358-.15.68-.367.951-.641A2.983 2.983 0 0 0 20.976 18L21 9a2.997 2.997 0 0 0-1.384-2.52zM6 18l1-5H4l5-7-1 5h3l-5 7zm12-8a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.884 2.532c-.346-.654-1.422-.654-1.768 0l-9 17A.999.999 0 0 0 3 21h18a.998.998 0 0 0 .883-1.467L12.884 2.532zM13 18h-2v-2h2v2zm-2-4V9h2l.001 5H11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidErrorCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidErrorAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707l-5-5zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidEraser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.48 3 7.73 7.75 3 12.59a2 2 0 0 0 0 2.82l4.3 4.3A1 1 0 0 0 8 20h12v-2h-7l7.22-7.22a2 2 0 0 0 0-2.83L15.31 3a2 2 0 0 0-2.83 0zM8.41 18l-4-4 4.75-4.84.74-.75 4.95 4.95-4.56 4.56-.07.08z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4.7-8 5.334L4 8.7V6.297l8 5.333 8-5.333V8.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.555 8.168-9-6a1 1 0 0 0-1.109 0l-9 6A.995.995 0 0 0 2.004 9H2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9h-.004a.997.997 0 0 0-.441-.832zM20 12.7 12 17l-8-4.3v-2.403l8 4.299 8-4.299V12.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidEject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 6-6 8h12zM6 16h12v2H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.988 2.012 3 3L19.701 7.3l-3-3zM8 16h3l7.287-7.287-3-3L8 13z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .896-2 2v14c0 1.104.897 2 2 2h14a2 2 0 0 0 2-2v-8.668l-2 2V19z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidEditLocation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995 3.971 16.44 11.696 21.784 12 22c0 0 8.029-5.56 8-12 0-4.411-3.589-8-8-8zM9.799 14.987H8v-1.799l4.977-4.97 1.799 1.799-4.977 4.97zm5.824-5.817-1.799-1.799L15.196 6l1.799 1.799-1.372 1.371z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidEditAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 2.012 3 3L16.713 7.3l-3-3zM4 14v3h3l8.299-8.287-3-3zm0 6h16v2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDuplicate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2zm2-9h3v-3h2v3h3v2h-3v3H9v-3H6v-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8v2h12v12h2V4c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDryer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16a1 1 0 0 0 1-1V5c0-1.654-1.346-3-3-3H6C4.346 2 3 3.346 3 5v16a1 1 0 0 0 1 1zM18 3.924a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3 3.117c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.32 12.265c-.415.384-1.041.964-1.041 2.067 0 1.104.626 1.684 1.041 2.068.352.325.4.398.4.6h2c0-1.104-.626-1.684-1.041-2.068-.352-.325-.4-.398-.4-.6s.048-.275.4-.6c.414-.384 1.041-.964 1.041-2.068 0-1.103-.626-1.683-1.041-2.066-.351-.325-.399-.397-.399-.598h-2c0 1.104.627 1.683 1.042 2.066.351.324.399.396.399.597-.001.203-.05.276-.401.602zm4 0c-.414.384-1.04.964-1.04 2.067s.626 1.684 1.04 2.067c.351.325.399.398.399.601h2c0-1.104-.626-1.684-1.04-2.067-.351-.325-.399-.398-.399-.601s.049-.275.399-.601c.414-.384 1.04-.964 1.04-2.068 0-1.103-.626-1.682-1.04-2.065-.35-.324-.399-.397-.399-.598h-2c0 1.103.626 1.683 1.041 2.066.35.324.398.397.398.598.001.202-.048.275-.399.601z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDroplet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.6 2.4c-.4-.3-.9-.3-1.2 0C9.5 3.9 4 8.5 4 14c0 4.4 3.6 8 8 8s8-3.6 8-8c0-5.4-5.5-10.1-7.4-11.6"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDropletHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.578 2.184a1.004 1.004 0 0 0-1.156 0C11.119 2.398 4 7.513 4 13.75 4 18.53 7.364 22 12 22s8-3.468 8-8.246c0-6.241-7.119-11.356-7.422-11.57zM6 13.75c0-4.283 4.395-8.201 6-9.49V20c-3.533 0-6-2.57-6-6.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDrink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.832 4.555A1 1 0 0 0 20 3H4a1 1 0 0 0-.832 1.554L11 16.303V20H8v2h8v-2h-3v-3.697l7.832-11.748zm-2.7.445-2 3H7.868l-2-3h12.264z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDownvote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.901 10.566A1.001 1.001 0 0 0 20 10h-4V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v7H4a1.001 1.001 0 0 0-.781 1.625l8 10a1 1 0 0 0 1.562 0l8-10c.24-.301.286-.712.12-1.059z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4V3H9v6H5l7 8zM4 19h16v2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDownArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDownArrowSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14zm-8-9V7h2v5h4l-5 5-5-5h4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDownArrowCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 15-5-5h4V7h2v5h4l-5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDownArrowAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12h-5V6h-2v6H6l6 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDoughnutChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6c2.507.423 4.577 2.493 5 5h4c-.471-4.717-4.283-8.529-9-9v4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-.478 2.833-2.982 4.949-5.949 4.949-3.309 0-6-2.691-6-6C6.051 8.982 8.167 6.478 11 6V2c-5.046.504-8.949 4.773-8.949 9.949 0 5.514 4.486 10 10 10 5.176 0 9.445-3.903 9.949-8.949h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDoorOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5v14a1 1 0 0 0 1 1h3v-2H7V6h2V4H6a1 1 0 0 0-1 1zm14.242-.97-8-2A1 1 0 0 0 10 3v18a.998.998 0 0 0 1.242.97l8-2A1 1 0 0 0 20 19V5a1 1 0 0 0-.758-.97zM15 12.188a1.001 1.001 0 0 1-2 0v-.377a1 1 0 1 1 2 .001v.376z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDonateHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.726 13.02 14 16H9v-1h4.065a.5.5 0 0 0 .416-.777l-.888-1.332A1.995 1.995 0 0 0 10.93 12H3a1 1 0 0 0-1 1v6a2 2 0 0 0 2 2h9.639a3 3 0 0 0 2.258-1.024L22 13l-1.452-.484a2.998 2.998 0 0 0-2.822.504zm1.532-5.63c.451-.465.73-1.108.73-1.818s-.279-1.353-.73-1.818A2.447 2.447 0 0 0 17.494 3S16.25 2.997 15 4.286C13.75 2.997 12.506 3 12.506 3a2.45 2.45 0 0 0-1.764.753c-.451.466-.73 1.108-.73 1.818s.279 1.354.73 1.818L15 12l4.258-4.61z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDonateBlood(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.726 13.02 14 16H9v-1h4.065a.5.5 0 0 0 .416-.777l-.888-1.332A1.995 1.995 0 0 0 10.93 12H3a1 1 0 0 0-1 1v6a2 2 0 0 0 2 2h9.639a3 3 0 0 0 2.258-1.024L22 13l-1.452-.484a2.998 2.998 0 0 0-2.822.504zM15.403 12a3 3 0 0 0 3-3c0-2.708-3-6-3-6s-3 3.271-3 6a3 3 0 0 0 3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDollarCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 14.915V18h-2v-1.08c-2.339-.367-3-2.002-3-2.92h2c.011.143.159 1 2 1 1.38 0 2-.585 2-1 0-.324 0-1-2-1-3.48 0-4-1.88-4-3 0-1.288 1.029-2.584 3-2.915V6.012h2v1.109c1.734.41 2.4 1.853 2.4 2.879h-1l-1 .018C13.386 9.638 13.185 9 12 9c-1.299 0-2 .516-2 1 0 .374 0 1 2 1 3.48 0 4 1.88 4 3 0 1.288-1.029 2.584-3 2.915z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-2l-1.27-1.27A2.49 2.49 0 0 0 16 4h-2.5A2.64 2.64 0 0 0 11 2v6.36a4.38 4.38 0 0 0 1.13 2.72 6.57 6.57 0 0 0 4.13 1.82l3.45-1.38a3 3 0 0 0 1.73-1.84L22 8.15a1.06 1.06 0 0 0 0-.31V7a1 1 0 0 0-1-1zm-5 2a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.38 11.74A5.24 5.24 0 0 1 10.07 9H6a1.88 1.88 0 0 1-2-2 1 1 0 0 0-2 0 4.69 4.69 0 0 0 .48 2A3.58 3.58 0 0 0 4 10.53V22h3v-5h6v5h3v-8.13a7.35 7.35 0 0 1-4.62-2.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDockTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm2 14v-9h14.001l.001 9H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDockRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5zM5 5h9v14H5V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDockLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2zm-11 0V5h9l.002 14H10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDockBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 5l.001 9H5V5h14z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDizzy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8 12.414l-1.293 1.293-1.414-1.414L6.586 11 5.293 9.707l1.414-1.414L8 9.586l1.293-1.293 1.414 1.414L9.414 11l1.293 1.293-1.414 1.414L8 12.414zM14 18h-4v-2h4v2zm4.707-5.707-1.414 1.414L16 12.414l-1.293 1.293-1.414-1.414L14.586 11l-1.293-1.293 1.414-1.414L16 9.586l1.293-1.293 1.414 1.414L17.414 11l1.293 1.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDislike(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-1v13h1a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM4 16h7l-1.122 3.368A2 2 0 0 0 11.775 22H12l5-5.438V3H6l-3.937 8.649-.063.293V14a2 2 0 0 0 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15c0-4.625-3.507-8.441-8-8.941V4h-2v2.059c-4.493.5-8 4.316-8 8.941v2h18v-2zM2 18h20v2H2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDiscount(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM9 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-.8 6.4 6-8 1.6 1.2-6 8-1.6-1.2zM15 15a1 1 0 1 1 0-2 1 1 0 1 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDisc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 14c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.998",
                    "cy": "11.998",
                    "r": "2.002"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDirections(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-6V8h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5L2 5l3 3h6v3H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6v5h2v-5h6l3-3-3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDirectionRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.295 12.707 8.978 9c.389.39 1.025.391 1.414.002l9.021-9a1 1 0 0 0 0-1.416l-9.021-9a.999.999 0 0 0-1.414.002l-8.978 9a.998.998 0 0 0 0 1.412zm6.707-2.706h5v-2l3 3-3 3v-2h-3v4h-2v-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDirectionLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 11.294-8.978-9a1.001 1.001 0 0 0-1.415-.002l-9.021 9a1 1 0 0 0 0 1.416l9.021 9c.39.389 1.026.388 1.415-.002l8.978-9a.998.998 0 0 0 0-1.412zM15 16h-2v-4h-3v2l-3-3 3-3v2h5v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDice6(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 17.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 17.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 13.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm8 8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 13.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 9.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDice5(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 17.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12 13.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 9.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDice4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 17.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm8 8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 9.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDice3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 9.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12 13.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDice2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM9.5 13.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 9.5 13.5zm5 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 14.5 13.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDice1(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-7 10.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDiamond(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.445 3h-8.89c-.345 0-.666.178-.849.47L3.25 9h17.5l-3.456-5.53a1.003 1.003 0 0 0-.849-.47zM11.26 21.186a1 1 0 0 0 1.48 0L22 11H2l9.26 10.186z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDevices(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H7c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM6 9h4l-.003 9H4V9h2zm6 8V9c0-1.103-.897-2-2-2H7V5h11v12h-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-9 14H5v-2h6v2zm8-4H5v-2h14v2zm0-4H5V7h14v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidData(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6c0-2.168-3.663-4-8-4S4 3.832 4 6v2c0 2.168 3.663 4 8 4s8-1.832 8-4V6zm-8 13c-4.337 0-8-1.832-8-4v3c0 2.168 3.663 4 8 4s8-1.832 8-4v-3c0 2.168-3.663 4-8 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10c0 2.168-3.663 4-8 4s-8-1.832-8-4v3c0 2.168 3.663 4 8 4s8-1.832 8-4v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidDashboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm-1 7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4zm10 0a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v7zm1-10h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCylinder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.131 0 9-1.935 9-4.5V7c0-.051-.024-.097-.033-.146.016-.117.033-.234.033-.354C21 3.935 17.131 2 12 2S3 3.935 3 6.5v11c0 2.565 3.869 4.5 9 4.5zm0-18c4.273 0 7 1.48 7 2.5a.683.683 0 0 1-.025.158c-.004.01-.012.018-.015.027-.274.848-2.29 1.98-5.496 2.253l-.05.003C12.965 8.979 12.494 9 12 9 7.727 9 5 7.52 5 6.5S7.727 4 12 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCustomize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 0h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM10 13H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm8 1h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCuboid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8c-.414 0-.785.255-.934.641l-5 13a.999.999 0 0 0 .227 1.066l5 5A.996.996 0 0 0 8 22h8c.414 0 .785-.255.934-.641l5-13a.999.999 0 0 0-.227-1.066l-5-5zM18.585 7h-5.171l-3-3h5.172l2.999 3zm-3.272 13h-6.23l4.583-11h5.878l-4.231 11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.406 6.086-9-4a1.001 1.001 0 0 0-.813 0l-9 4c-.02.009-.034.024-.054.035-.028.014-.058.023-.084.04-.022.015-.039.034-.06.05a.87.87 0 0 0-.19.194c-.02.028-.041.053-.059.081a1.119 1.119 0 0 0-.076.165c-.009.027-.023.052-.031.079A1.013 1.013 0 0 0 2 7v10c0 .396.232.753.594.914l9 4c.13.058.268.086.406.086a.997.997 0 0 0 .402-.096l.004.01 9-4A.999.999 0 0 0 22 17V7a.999.999 0 0 0-.594-.914zM12 4.095 18.538 7 12 9.905l-1.308-.581L5.463 7 12 4.095zm1 15.366V11.65l7-3.111v7.812l-7 3.11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCubeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.895 3.553A1.001 1.001 0 0 0 17 3H7c-.379 0-.725.214-.895.553l-4 8a1 1 0 0 0 0 .895l4 8c.17.338.516.552.895.552h10c.379 0 .725-.214.895-.553l4-8a1 1 0 0 0 0-.895l-4-7.999zM19.382 11h-7.764l-3-6h7.764l3 6zm-3 8H8.618l3-6h7.764l-3 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21 2-5 5-4-5-4 5-5-5v13h18zM5 21h14a2 2 0 0 0 2-2v-2H3v2a2 2 0 0 0 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCrop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7.5C19 6.121 17.879 5 16.5 5H8V2H5v3H2v3h14v14h3v-3h3v-3h-3V7.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10H5v6.5C5 17.879 6.121 19 7.5 19H14v-3H8v-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCricketBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.67 16.26.54.53-.62.61a9 9 0 0 0 .84 1.11L18.51 4.42a10.93 10.93 0 0 0-1.1-.83l-.62.61-.53-.53.48-.48A10 10 0 0 0 3.2 16.74zM14.86 5.07l.53.53L14 7l-.53-.53zm-2.79 2.8.52.53-1.39 1.4-.53-.53zm-2.8 2.8.53.53-1.4 1.39-.53-.53zm-2.8 2.79L7 14l-1.4 1.4-.53-.53zm.12 6.95.62-.61.53.53-.48.48A10 10 0 0 0 20.8 7.26l-.47.48-.54-.53.62-.61a9 9 0 0 0-.84-1.11L5.49 19.58a10.93 10.93 0 0 0 1.1.83zM18.4 8.61l.53.53-1.4 1.4L17 10zm-2.8 2.8.53.53-1.4 1.39-.53-.53zm-2.8 2.79.53.53-1.39 1.4-.54-.53zM10 17l.53.53-1.4 1.4-.53-.53z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v2h20V6c0-1.103-.897-2-2-2zM2 18c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-6H2v6zm3-3h6v2H5v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCreditCardFront(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2zm6 7.5H5v-2h6v2zm8 0h-6v-2h6v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCreditCardAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-7.5 12a2.5 2.5 0 1 1 0-5 2.47 2.47 0 0 1 1.5.512c-.604.456-1 1.173-1 1.988s.396 1.532 1 1.988a2.47 2.47 0 0 1-1.5.512zm4 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCoupon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM11 17H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V7h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCopyright(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.58 2 12s4.579 10 10 10 10-4.58 10-10S17.421 2 12 2zm0 13c.992 0 1.85-.265 2.293-.708l1.414 1.415C14.581 16.832 12.901 17 12 17c-2.757 0-5-2.243-5-5s2.243-5 5-5c.901 0 2.582.168 3.707 1.293l-1.414 1.414C13.851 9.264 12.993 9 12 9c-1.626 0-3 1.374-3 3s1.374 3 3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCopyAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2zm2-10h6v2H6v-2zm0 4h6v2H6v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.095 14.244a5.982 5.982 0 0 1-3.034 1.634 6.05 6.05 0 0 1-2.414 0 5.919 5.919 0 0 1-2.148-.903 6.078 6.078 0 0 1-1.621-1.622l1.658-1.117c.143.211.307.41.488.59a3.988 3.988 0 0 0 1.273.86c.243.102.495.181.749.232a4.108 4.108 0 0 0 1.616 0c.253-.052.505-.131.75-.233.234-.1.464-.224.679-.368.208-.142.407-.306.591-.489.183-.182.347-.381.489-.592l1.658 1.117c-.215.32-.462.62-.734.891zM19 10a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2h-2a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8h14v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCookie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3.003-2.938.005-.034.016-.134.017-.168a.998.998 0 0 0-1.254-1.006A3.002 3.002 0 0 1 15 7c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.716a1 1 0 0 0-1.067-1.236A9.956 9.956 0 0 0 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-.049-.003-.097-.007-.16a1.004 1.004 0 0 0-.395-.776zM8.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-2 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm2.5-6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm3.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidConversation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14h3.5c.827 0 1.5-.673 1.5-1.5v-9c0-.827-.673-1.5-1.5-1.5h-13C2.673 2 2 2.673 2 3.5V18l5.333-4H13zm-9-.1.154-.016L4 14v-.1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 8H20v6.001c0 1.1-.893 1.993-1.99 1.999H8v.5c0 .827.673 1.5 1.5 1.5h7.167L22 22V9.5c0-.827-.673-1.5-1.5-1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidContact(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H6a2 2 0 0 0-2 2v3H2v2h2v2H2v2h2v2H2v2h2v3a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-8 2.999c1.648 0 3 1.351 3 3A3.012 3.012 0 0 1 13 11c-1.647 0-3-1.353-3-3.001 0-1.649 1.353-3 3-3zM19 18H7v-.75c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5V18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidConfused(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zm1.124 6.492-.248-1.984 8-1 .248 1.984-8 1zm7.369-5.006a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidComponent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.553 18.895 4 2a1.001 1.001 0 0 0 .894 0L12 19.118l3.553 1.776a.99.99 0 0 0 .894.001l4-2c.339-.17.553-.516.553-.895v-5c0-.379-.214-.725-.553-.895L17 10.382V6c0-.379-.214-.725-.553-.895l-4-2a1 1 0 0 0-.895 0l-4 2C7.214 5.275 7 5.621 7 6v4.382l-3.447 1.724A.998.998 0 0 0 3 13v5c0 .379.214.725.553.895zM8 12.118l2.264 1.132-2.913 1.457-2.264-1.132L8 12.118zm4-2.5 3-1.5v2.264l-3 1.5V9.618zm6.264 3.632-2.882 1.441-2.264-1.132L16 12.118l2.264 1.132zM8 18.882l-.062-.031V16.65L11 15.118v2.264l-3 1.5zm8 0v-2.264l3-1.5v2.264l-3 1.5zM12 5.118l2.264 1.132-2.882 1.441-2.264-1.132L12 5.118z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3 13-8 2 2-8 8-2-2 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidComment(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCommentX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-3.294 11.543-1.414 1.414-3.293-3.292-3.292 3.292-1.414-1.414 3.292-3.292-3.292-3.293 1.414-1.414 3.292 3.292 3.293-3.292 1.414 1.414-3.292 3.293 3.292 3.292z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCommentMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-4 9H8V9h8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCommentError(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-7 13h-2v-2h2v2zm0-4h-2V5h2v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCommentEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8.999 14.987H7v-1.999l5.53-5.522 1.998 1.999-5.529 5.522zm6.472-6.464-1.999-1.999 1.524-1.523L16.995 7l-1.524 1.523z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCommentDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM9 12a2 2 0 1 1 .001-4.001A2 2 0 0 1 9 12zm6 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 15 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCommentDetail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1.999H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2v-12c0-1.103-.897-2-2-2zm-6 11H7v-2h7v2zm3-4H7v-2h10v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCommentCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-9 11.914-3.707-3.707 1.414-1.414L11 11.086l4.793-4.793 1.414 1.414L11 13.914z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCommentAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-3 9h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidColor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.08 11.25A4.84 4.84 0 0 1 8 9.05L4.43 5.49A9.88 9.88 0 0 0 2 11.25zM9.05 8a4.84 4.84 0 0 1 2.2-.91V2a9.88 9.88 0 0 0-5.76 2.43zm3.7-6v5A4.84 4.84 0 0 1 15 8l3.56-3.56A9.88 9.88 0 0 0 12.75 2zM8 15a4.84 4.84 0 0 1-.91-2.2H2a9.88 9.88 0 0 0 2.39 5.76zm3.25 1.92a4.84 4.84 0 0 1-2.2-.92l-3.56 3.57A9.88 9.88 0 0 0 11.25 22zM16 9.05a4.84 4.84 0 0 1 .91 2.2h5a9.88 9.88 0 0 0-2.39-5.76zM15 16a4.84 4.84 0 0 1-2.2.91v5a9.88 9.88 0 0 0 5.76-2.39zm1.92-3.25A4.84 4.84 0 0 1 16 15l3.56 3.56A9.88 9.88 0 0 0 22 12.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidColorFill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14c-.092.064-2 2.083-2 3.5 0 1.494.949 2.448 2 2.5.906.044 2-.891 2-2.5 0-1.5-1.908-3.436-2-3.5zM9.586 20c.378.378.88.586 1.414.586s1.036-.208 1.414-.586l7-7-.707-.707L11 4.586 8.707 2.293 7.293 3.707 9.586 6 4 11.586c-.378.378-.586.88-.586 1.414s.208 1.036.586 1.414L9.586 20zM11 7.414 16.586 13H5.414L11 7.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCollection(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10H5c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2zM5 6h14v2H5zm2-4h10v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCoin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C7.031 5 2 6.546 2 9.5S7.031 14 12 14c4.97 0 10-1.546 10-4.5S16.97 5 12 5zm-5 9.938v3c1.237.299 2.605.482 4 .541v-3a21.166 21.166 0 0 1-4-.541zm6 .54v3a20.994 20.994 0 0 0 4-.541v-3a20.994 20.994 0 0 1-4 .541zm6-1.181v3c1.801-.755 3-1.857 3-3.297v-3c0 1.44-1.199 2.542-3 3.297zm-14 3v-3C3.2 13.542 2 12.439 2 11v3c0 1.439 1.2 2.542 3 3.297z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCoinStack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c3.976 0 8-1.374 8-4s-4.024-4-8-4-8 1.374-8 4 4.024 4 8 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c0 2.626 4.024 4 8 4s8-1.374 8-4V8c0 2.626-4.024 4-8 4s-8-1.374-8-4v2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14c0 2.626 4.024 4 8 4s8-1.374 8-4v-2c0 2.626-4.024 4-8 4s-8-1.374-8-4v2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18c0 2.626 4.024 4 8 4s8-1.374 8-4v-2c0 2.626-4.024 4-8 4s-8-1.374-8-4v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.344 15.271 2 3.46a1 1 0 0 0 1.366.365l1.396-.806c.58.457 1.221.832 1.895 1.112V21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.598a8.094 8.094 0 0 0 1.895-1.112l1.396.806c.477.275 1.091.11 1.366-.365l2-3.46a1.004 1.004 0 0 0-.365-1.366l-1.372-.793a7.683 7.683 0 0 0-.002-2.224l1.372-.793c.476-.275.641-.89.365-1.366l-2-3.46a1 1 0 0 0-1.366-.365l-1.396.806A8.034 8.034 0 0 0 15 4.598V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1.598A8.094 8.094 0 0 0 7.105 5.71L5.71 4.904a.999.999 0 0 0-1.366.365l-2 3.46a1.004 1.004 0 0 0 .365 1.366l1.372.793a7.683 7.683 0 0 0 0 2.224l-1.372.793c-.476.275-.641.89-.365 1.366zM12 8c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCoffee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h2v3H5zm4 0h2v3H9zm4 0h2v3h-2zm6 7h-2V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h2c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2zm-2 7v-5h2l.002 5H17z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCoffeeTogo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.5 5-1.224-2.447A1 1 0 0 0 16.382 2H7.618a1 1 0 0 0-.894.553L5.5 5H3v2h18V5h-2.5zM6.734 21.142c.071.492.493.858.991.858h8.551a1 1 0 0 0 .99-.858L19 9H5l1.734 12.142zM16 12l-.714 5H8.714L8 12h8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCoffeeBean(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18a6.06 6.06 0 0 0 5.17-6 7.62 7.62 0 0 1 6.52-7.51l2.59-.37c-.07-.08-.13-.16-.21-.24-3.26-3.26-9.52-2.28-14 2.18C2.28 9.9 1 15 2.76 18.46z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.73 12a7.63 7.63 0 0 1-6.51 7.52l-2.46.35.15.17c3.26 3.26 9.52 2.29 14-2.17C21.68 14.11 23 9 21.25 5.59l-3.34.48A6.05 6.05 0 0 0 12.73 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCoffeeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-1V4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v9a4 4 0 0 0 4 4h6c1.858 0 3.411-1.279 3.858-3H19a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3zm1 6a1 1 0 0 1-1 1h-1V7h1a1 1 0 0 1 1 1v3zm-2 8H3c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5h11c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCloudUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5h11c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888zM13 14v3h-2v-3H8l4-5 4 5h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCloudRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.82 2 13c0 2.757 2.243 5 5 5h1v3h2v-3h4v3h2v-3h2c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19h2v3h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCloudLightning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.82 2 13c0 2.757 2.243 5 5 5h1.333L10 13h4l-2 3h2.975l-1.325 2H18c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888zM11 18H8.333L8 19h3v3l2.649-4H11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCloudDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.61 5.757 9.149 3.609 9.792 2 11.82 2 14c0 2.657 2.089 4.815 4.708 4.971V19H17.99v-.003L18 19c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888zM8 12h3V9h2v3h3l-4 5-4-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidClinic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669zM16 15h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-4V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM6 18H4v-2h2v2zm0-4H4v-2h2v2zm5 4H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V8h2v2zm0-4H9V4h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V8h2v2zm0-4h-2V4h2v2zm5 12h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V8h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCircleThreeQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v9H2v1a10 10 0 0 0 17.07 7.07A10 10 0 0 0 12 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCircleQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v11h11v-1A10 10 0 0 0 12 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCircleHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v20h1a10 10 0 0 0 0-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChurch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22v-4a2 2 0 0 1 4 0v4h4V12a1 1 0 0 0-.485-.857L13 8.434V6h2V4h-2V2h-2v2H9v2h2v2.434l-4.515 2.709A1 1 0 0 0 6 12v10h4zm-7 0h2v-8.118l-2.447 1.224A.998.998 0 0 0 2 16v5a1 1 0 0 0 1 1zm18.447-6.895L19 13.882V22h2a1 1 0 0 0 1-1v-5c0-.379-.214-.725-.553-.895z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7a2 2 0 0 0-2-2h-1V2h-2v3h-4V2H8v3H7a2 2 0 0 0-2 2v1H2v2h3v4H2v2h3v1a2 2 0 0 0 2 2h1v3h2v-3h4v3h2v-3h1a2 2 0 0 0 2-2v-1h3v-2h-3v-4h3V8h-3V7zm-4 8H9V9h6v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronsUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 3.879-7.061 7.06 2.122 2.122L12 8.121l4.939 4.94 2.122-2.122z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.939 17.939 2.122 2.122L12 15.121l4.939 4.94 2.122-2.122L12 10.879z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronsRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.061 4.939-2.122 2.122L15.879 12l-4.94 4.939 2.122 2.122L20.121 12z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.061 19.061 13.121 12l-7.06-7.061-2.122 2.122L8.879 12l-4.94 4.939z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronsLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.121 12 4.94-4.939-2.122-2.122L3.879 12l7.06 7.061 2.122-2.122z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.939 4.939 10.879 12l7.06 7.061 2.122-2.122L15.121 12l4.94-4.939z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronsDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.939 10.939 12 15.879l-4.939-4.94-2.122 2.122L12 20.121l7.061-7.06z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.939 3.939 12 8.879l-4.939-4.94-2.122 2.122L12 13.121l7.061-7.06z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 6.879-7.061 7.06 2.122 2.122L12 11.121l4.939 4.94 2.122-2.122z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronUpSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm7-13.414 5.707 5.707-1.414 1.414L12 10.414l-4.293 4.293-1.414-1.414L12 7.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronUpCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.293 12.707L12 10.414l-4.293 4.293-1.414-1.414L12 7.586l5.707 5.707-1.414 1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.061 19.061 17.121 12l-7.06-7.061-2.122 2.122L12.879 12l-4.94 4.939z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronRightSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm6.293 2.707 1.414-1.414L16.414 12l-5.707 5.707-1.414-1.414L13.586 12 9.293 7.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronRightCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.293 15.707-1.414-1.414L13.586 12 9.293 7.707l1.414-1.414L16.414 12l-5.707 5.707z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.939 4.939 6.879 12l7.06 7.061 2.122-2.122L11.121 12l4.94-4.939z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronLeftSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5zm9.707 13.293-1.414 1.414L7.586 12l5.707-5.707 1.414 1.414L10.414 12l4.293 4.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronLeftCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm2.707 14.293-1.414 1.414L7.586 12l5.707-5.707 1.414 1.414L10.414 12l4.293 4.293z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.939 7.939 12 12.879l-4.939-4.94-2.122 2.122L12 17.121l7.061-7.06z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronDownSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM7.707 9.293 12 13.586l4.293-4.293 1.414 1.414L12 16.414l-5.707-5.707 1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChevronDownCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 14.414-5.707-5.707 1.414-1.414L12 13.586l4.293-4.293 1.414 1.414L12 16.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 6h-4v4h4v4h-4v4h-4v-4H8v4H4v-4h4v-4H4V8h4V4h4v4h4V4h4v4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8h4v4H8zm4 4h4v4h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCheese(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.16 2a1 1 0 0 0-.66.13l-12 7a.64.64 0 0 0-.13.1l-.1.08a1.17 1.17 0 0 0-.17.26.84.84 0 0 0-.1.43v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V10a8.08 8.08 0 0 0-6.84-8zm0 2.05A6.07 6.07 0 0 1 19.93 9H6.7zM6.5 18A1.5 1.5 0 1 1 8 16.5 1.5 1.5 0 0 1 6.5 18zm5-3a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm5.5 3a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCheckbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCheckboxMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm-1 8H8v-2h8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCheckboxChecked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7zm4 10.414-2.707-2.707 1.414-1.414L11 12.586l3.793-3.793 1.414 1.414L11 15.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCheckSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-7.933 13.481-3.774-3.774 1.414-1.414 2.226 2.226 4.299-5.159 1.537 1.28-5.702 6.841z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCheckShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.488 21.754c.294.157.663.156.957-.001 8.012-4.304 8.581-12.713 8.574-15.104a.988.988 0 0 0-.596-.903l-8.05-3.566a1.005 1.005 0 0 0-.813.001L3.566 5.747a.99.99 0 0 0-.592.892c-.034 2.379.445 10.806 8.514 15.115zM8.674 10.293l2.293 2.293 4.293-4.293 1.414 1.414-5.707 5.707-3.707-3.707 1.414-1.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.999 14.413-3.713-3.705L7.7 11.292l2.299 2.295 5.294-5.294 1.414 1.414-6.706 6.706z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h2v4.081L11.101 18H16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2h12c1.103 0 2 .897 2 2v8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14zM9.553 9.658l4 2 1.553-3.105 1.789.895-2.447 4.895-4-2-1.553 3.105-1.789-.895 2.447-4.895z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidChalkboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h4l-1.8 2.4 1.6 1.2 2.7-3.6h3l2.7 3.6 1.6-1.2L16 18h4c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 13h4v2H5v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCertification(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.047 14.667a.992.992 0 0 0 .466.607l1.909 1.104v2.199a1 1 0 0 0 1 1h2.199l1.104 1.91a1.002 1.002 0 0 0 1.366.366L12 20.75l1.91 1.104a1.002 1.002 0 0 0 1.366-.366l1.103-1.909h2.199a1 1 0 0 0 1-1V16.38l1.909-1.104a.999.999 0 0 0 .366-1.366L20.75 12l1.104-1.909a1 1 0 0 0-.366-1.366l-1.909-1.104V5.422a1 1 0 0 0-1-1H16.38l-1.103-1.909a1.004 1.004 0 0 0-.607-.466.994.994 0 0 0-.759.1L12 3.25l-1.909-1.104a.998.998 0 0 0-1.366.365l-1.104 1.91H5.422a1 1 0 0 0-1 1V7.62L2.513 8.725a1.001 1.001 0 0 0-.365 1.366L3.251 12l-1.104 1.909a1.003 1.003 0 0 0-.1.758z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCctv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.618 7.462 6.403 2.085a1.007 1.007 0 0 0-.77-.016 1.002 1.002 0 0 0-.552.537l-3 7a1 1 0 0 0 .525 1.313L9.563 13.9 8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054 3.419 1.465a1 1 0 0 0 1.311-.518l3-6.857a1 1 0 0 0-.513-1.316zm1.312 8.91-1.858-.742 1.998-5 1.858.741z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCategory(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zM4 21h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm13 0c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCategoryAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 10h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zM17 3c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM7 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14a5 5 0 0 0 2.71-.81L20 13a3.16 3.16 0 0 0 .45-.37l.21-.2a4.48 4.48 0 0 0 .48-.58l.06-.08a4.28 4.28 0 0 0 .41-.76 1.57 1.57 0 0 0 .09-.23 4.21 4.21 0 0 0 .2-.63l.06-.25A5.5 5.5 0 0 0 22 9V2l-3 3h-4l-3-3v7a5 5 0 0 0 5 5zm2-7a1 1 0 1 1-1 1 1 1 0 0 1 1-1zm-4 0a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 22v-5H8v5H5V11.9a3.49 3.49 0 0 1-2.48-1.64A3.59 3.59 0 0 1 2 8.5 3.65 3.65 0 0 1 6 5a1.89 1.89 0 0 0 2-2 1 1 0 0 1 1-1 1 1 0 0 1 1 1 3.89 3.89 0 0 1-4 4C4.19 7 4 8.16 4 8.51S4.18 10 6 10h5.09A6 6 0 0 0 19 14.65V22h-3v-5h-2v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCastle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11h-2V6h1V2h-2v2h-1V2h-2v2h-1V2h-2v2h-1V2H8v2H7V2H5v4h1v5H4V9H2v12h7v-5a3 3 0 0 1 6 0v5h7V9h-2zm-10-1H8V7h2zm6 0h-2V7h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.822 7.431A1 1 0 0 0 21 7H7.333L6.179 4.23A1.994 1.994 0 0 0 4.333 3H2v2h2.333l4.744 11.385A1 1 0 0 0 10 17h8c.417 0 .79-.259.937-.648l3-8a1 1 0 0 0-.115-.921z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCartDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7H7.334L6.18 4.23A1.995 1.995 0 0 0 4.333 3H2v2h2.334l4.743 11.385c.155.372.52.615.923.615h8c.417 0 .79-.259.937-.648l3-8A1.003 1.003 0 0 0 21 7zm-7 8-3-3h2V9h2v3h2l-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCartAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H2v2h2.3l3.521 9.683A2.004 2.004 0 0 0 9.7 17H18v-2H9.7l-.728-2H18c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 4z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCartAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7H7.334L6.18 4.23A1.995 1.995 0 0 0 4.333 3H2v2h2.334l4.743 11.385c.155.372.52.615.923.615h8c.417 0 .79-.259.937-.648l3-8A1.003 1.003 0 0 0 21 7zm-4 6h-2v2h-2v-2h-2v-2h2V9h2v2h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCarousel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3H8c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM2 7v10c0 1.103.897 2 2 2V5c-1.103 0-2 .897-2 2zm18-2v14c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCaretUpSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm7-13 5 6H7l5-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCaretUpCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.485 2 2 6.486 2 12s4.485 10 10 10c5.514 0 10-4.486 10-10S17.514 2 12 2zM7 14l5-6 5 6H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCaretRightSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm5-14 6 5-6 5V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCaretRightCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zM10 7l6 5-6 5V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCaretLeftSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm9-14v10l-6-5 6-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCaretLeftCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm2 15-6-5 6-5v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCaretDownSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm12-11-5 6-5-6h10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCaretDownCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10c5.515 0 10-4.486 10-10S17.515 2 12 2zm0 14-5-6h10l-5 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12zM4 19h16v2H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.155-1.368-4.104A2.995 2.995 0 0 0 16.559 4H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2 2 0 0 0 2 12v5c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.277A1.99 1.99 0 0 0 22 17v-5a2 2 0 0 0-1.228-1.845zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6zM5.5 16a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 16zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCarWash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 13.155-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM9 4.378c.005-1.088-1.037-2.051-1.387-2.344a.176.176 0 0 0-.228 0C7.033 2.325 5.995 3.271 6 4.377 6 5.272 6.673 6 7.5 6S9 5.272 9 4.378zm4.5 0c.005-1.088-1.037-2.052-1.387-2.344a.176.176 0 0 0-.228 0c-.353.291-1.391 1.238-1.386 2.344C10.5 5.272 11.173 6 12 6s1.5-.728 1.5-1.622zm4.5 0c.005-1.088-1.037-2.052-1.387-2.344a.176.176 0 0 0-.228 0c-.352.291-1.39 1.237-1.385 2.343C15 5.272 15.673 6 16.5 6S18 5.272 18 4.378z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCarMechanic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 13.155-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM5.277 5c.347.595.985 1 1.723 1s1.376-.405 1.723-1h6.555c.346.595.984 1 1.722 1s1.376-.405 1.723-1H17V3h1.723c-.347-.595-.985-1-1.723-1s-1.376.405-1.723 1H8.723C8.376 2.405 7.738 2 7 2s-1.376.405-1.723 1H7v2H5.277z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCarGarage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845l-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.388V5.279l-9.684-3.228a.996.996 0 0 0-.658.009L2 5.572V7.7l10.015-3.642L22 7.388z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCarCrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.634 17.918a1.765 1.765 0 0 0 1.201 1.291l.18.791H4v2h16v-2H6.683a.84.84 0 0 0-.007-.278l-.196-.863 10.357-2.356.196.863a.886.886 0 0 0 1.06.667l.863-.197a.885.885 0 0 0 .667-1.06l-.251-1.103c.446-.416.67-1.046.525-1.683l-.59-2.59a1.76 1.76 0 0 0-1.262-1.307l-2.049-3.378a2.774 2.774 0 0 0-2.982-1.263l-7.868 1.79a2.769 2.769 0 0 0-2.144 2.43l-.387 3.932a1.76 1.76 0 0 0-.57 1.724l.589 2.59zm3.02-.688a1.327 1.327 0 1 1-.59-2.589 1.327 1.327 0 0 1 .59 2.589zm11.222-2.552a1.328 1.328 0 1 1-.59-2.587 1.328 1.328 0 0 1 .59 2.587zM5.589 9.192l7.869-1.791a.773.773 0 0 1 .83.351l1.585 2.613-.566.129-10.046 2.287-.568.129.299-3.042a.772.772 0 0 1 .597-.676zM18.405 4 17 2l-.5 3L19 9l3 1-2-2.539 2-.933-2-.933L22 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCarBattery(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM9 14H4v-2h5v2zm11 0h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2zM4 3h4v2H4zm12 0h4v2h-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCaptions(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-9 6H8v4h3v2H8c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h3v2zm7 0h-3v4h3v2h-3c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCapsule(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.434 20.566c1.335 0 2.591-.52 3.535-1.464l7.134-7.133a5.008 5.008 0 0 0-.001-7.072 4.969 4.969 0 0 0-3.536-1.463c-1.335 0-2.59.52-3.534 1.464l-7.134 7.133a5.01 5.01 0 0 0-.001 7.072 4.971 4.971 0 0 0 3.537 1.463zm5.011-14.254a2.979 2.979 0 0 1 2.12-.878c.802 0 1.556.312 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892-4.242-4.244 2.892-2.891z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-1.626 0-3 1.374-3 3s1.374 3 3 3 3-1.374 3-3-1.374-3-3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-8 12c-2.71 0-5-2.29-5-5s2.29-5 5-5 5 2.29 5 5-2.29 5-5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCameraPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-8 12c-2.71 0-5-2.29-5-5 0-2.711 2.29-5 5-5s5 2.289 5 5c0 2.71-2.29 5-5 5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v2H9v2h2v2h2v-2h2v-2h-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCameraOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h11.879l-3.083-3.083A4.774 4.774 0 0 1 12 17c-2.71 0-5-2.29-5-5 0-.271.039-.535.083-.796L2.144 6.265C2.054 6.493 2 6.74 2 7v11c0 1.103.897 2 2 2zM20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5h-.172L3.707 2.293 2.293 3.707l18 18 1.414-1.414-.626-.626A1.98 1.98 0 0 0 22 18V7c0-1.103-.897-2-2-2zm-5.312 8.274A2.86 2.86 0 0 0 15 12c0-1.626-1.374-3-3-3-.456 0-.884.12-1.274.312l-1.46-1.46A4.88 4.88 0 0 1 12 7c2.71 0 5 2.29 5 5a4.88 4.88 0 0 1-.852 2.734l-1.46-1.46z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCameraMovie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c0-.959-.68-1.761-1.581-1.954C16.779 8.445 17 7.75 17 7c0-2.206-1.794-4-4-4-1.516 0-2.822.857-3.5 2.104C8.822 3.857 7.516 3 6 3 3.794 3 2 4.794 2 7c0 .902.312 1.726.817 2.396A1.993 1.993 0 0 0 2 11v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-2.637l4 2v-7l-4 2V11zm-5-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM6 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCameraHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.125 2H5.875A1.877 1.877 0 0 0 4 3.875v12.25C4 17.159 4.841 18 5.875 18H11v2H7v2h10v-2h-4v-2h5.125A1.877 1.877 0 0 0 20 16.125V3.875A1.877 1.877 0 0 0 18.125 2zM12 15c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 20V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2zM9 18H7v-2h2v2zm0-4H7v-2h2v2zm4 4h-2v-2h2v2zm0-4h-2v-2h2v2zm4 4h-2v-2h2v2zm0-4h-2v-2h2v2zm2-5H5V7h14v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarX(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm10.707-4.707-1.414 1.414L12 16.414l-2.293 2.293-1.414-1.414L10.586 15l-2.293-2.293 1.414-1.414L12 13.586l2.293-2.293 1.414 1.414L13.414 15l2.293 2.293zM5 7h14v2H5V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarWeek(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-2 8v2H7v-3h10v1zm2-3H5V7h14v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-4.588 15-2.449-1.288L9.514 19l.468-2.728L8 14.342l2.738-.398 1.225-2.48 1.225 2.48 2.738.398-1.981 1.931.467 2.727zM19 9H5V7h14v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm11-6h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zM5 7h14v2H5V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm11-6H8v-2h8v2zM5 7h14v2H5V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-3.648 11.711L12.002 19l-3.349-3.289a2.129 2.129 0 0 1 0-3.069 2.224 2.224 0 0 1 3.125 0l.224.219.224-.219a2.225 2.225 0 0 1 3.126 0 2.129 2.129 0 0 1 0 3.069zM19 9H5V7h14v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-6 16h-2v-2h2v2zm0-4h-2v-5h2v5zm6-7H5V7h14v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarEvent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-1 15h-6v-6h6v6zm1-10H5V7h14v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm4.799-2.013H8v-1.799l4.977-4.97 1.799 1.799-4.977 4.97zm5.824-5.817-1.799-1.799L15.196 11l1.799 1.799-1.372 1.371zM5 7h14v2H5V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm6-3.586-3.707-3.707 1.414-1.414L11 15.586l4.293-4.293 1.414 1.414L11 18.414zM5 7h14v2H5V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalendarAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 7h14v2H5V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2zm3-3H7v-2h2v2zm0-4H7v-2h2v2zm0-4H7V9h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm4 8h-2v-6h2v6zm0-8h-2V9h2v2zM6 4h12v3H6V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.997 15c-1.601 0-2.446-.676-3.125-1.219-.567-.453-.977-.781-1.878-.781-.898 0-1.287.311-1.874.78-.679.544-1.524 1.22-3.125 1.22s-2.444-.676-3.123-1.22C3.285 13.311 2.897 13 2 13v5c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-5c-.899 0-1.288.311-1.876.781-.68.543-1.525 1.219-3.127 1.219zM19 5h-6V2h-2v3H5C3.346 5 2 6.346 2 8v3c1.6 0 2.443.676 3.122 1.22.587.469.975.78 1.873.78.899 0 1.287-.311 1.875-.781.679-.543 1.524-1.219 3.124-1.219 1.602 0 2.447.676 3.127 1.219.588.47.977.781 1.876.781.9 0 1.311-.328 1.878-.781C19.554 11.676 20.399 11 22 11V8c0-1.654-1.346-3-3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCableCar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 9.76 9-2.45V10H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-4V6.76l9-2.45V2.24L2 7.69zM11 12v3H7v-3zm6 0v3h-4v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidCabinet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v7h18V4zm-5 4H8V5h2v1h4V5h2v3zM5 22h14c1.103 0 2-.897 2-2v-7H3v7c0 1.103.897 2 2 2zm3-6h2v1h4v-1h2v3H8v-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBusiness(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-6a1 1 0 0 0-1 1v3h-2V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM8 6h2v2H8V6zM6 16H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V6h2v2zm4 8H8v-2h2v2zm0-4H8v-2h2v2zm9 4h-2v-2h2v2zm0-4h-2v-2h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.021c.003-.146-.007-1.465-1.3-2.735C18.427 2.036 17.143 2 17 2H6.996c-.239 0-1.493.063-2.708 1.302C3.036 4.578 3 5.859 3 6v3H2v3h1v6c0 .734.406 1.373 1 1.721V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 21 18v-6h1V9h-1V6.021zM9 4h6v2H9V4zM6.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 18zm4.5-5H5V8h6v5zm6.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 17.5 18zm1.5-5h-6V8h6v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBusSchool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.597V11h1V8h-1V6c0-2.206-1.794-4-4-4H7C4.794 2 3 3.794 3 6v2H2v3h1v.597a3.97 3.97 0 0 0-.999 2.648l.004 3.758c.001.733.404 1.369.995 1.716V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.274a2.02 2.02 0 0 0 .421-.313c.377-.378.585-.881.584-1.415l-.004-3.759A3.965 3.965 0 0 0 21 11.597zM8 4h8v2H8V4zM6.5 17a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 17zm4.5-5H5V8h6v4zm6.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 17.5 17zm1.5-5h-6V8h6v4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBuoy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.736 8h-3.16A5.02 5.02 0 0 0 14 7.424V4.263A8.015 8.015 0 0 1 19.736 10zM12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM10 4.263v3.161A5.02 5.02 0 0 0 7.424 10h-3.16A8.015 8.015 0 0 1 10 4.263zM4.264 14h3.16A5.02 5.02 0 0 0 10 16.576v3.161A8.015 8.015 0 0 1 4.264 14zM14 19.737v-3.161A5.02 5.02 0 0 0 16.576 14h3.16A8.015 8.015 0 0 1 14 19.737z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBullseye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 17c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 7c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20h6v2H9zm7.906-6.288C17.936 12.506 19 11.259 19 9c0-3.859-3.141-7-7-7S5 5.141 5 9c0 2.285 1.067 3.528 2.101 4.73.358.418.729.851 1.084 1.349.144.206.38.996.591 1.921h-.792v2h8.032v-2h-.79c.213-.927.45-1.719.593-1.925.352-.503.726-.94 1.087-1.363z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBuildings(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14.001h2v2H7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-8a2 2 0 0 0-2 2v6H5c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2zM5 20v-8h6v8H5zm9-12h-2V6h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V6h2v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBuilding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7a2 2 0 0 0-2 2v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2zm-6 14H8v-2h3v2zm0-4H8v-2h3v2zm0-4H8V6h3v2zm5 8h-3v-2h3v2zm0-4h-3v-2h3v2zm0-4h-3V6h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBuildingHouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.991 2H9.01C7.899 2 7 2.899 7 4.01v5.637l-4.702 4.642A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4.009C21 2.899 20.102 2 18.991 2zm-8.069 13.111V20H5v-5.568l2.987-2.949 2.935 3.003v.625zM13 9h-2V7h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h2v2H7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.787 7h10.426c-.108-.158-.201-.331-.318-.481l2.813-2.812-1.414-1.414-2.846 2.846a6.575 6.575 0 0 0-.723-.454 5.778 5.778 0 0 0-5.45 0c-.25.132-.488.287-.722.453L5.707 2.293 4.293 3.707l2.813 2.812c-.118.151-.21.323-.319.481zM5.756 9H2v2h2.307c-.065.495-.107.997-.107 1.5 0 .507.042 1.013.107 1.511H2v2h2.753c.013.039.021.08.034.118.188.555.421 1.093.695 1.6.044.081.095.155.141.234l-2.33 2.33 1.414 1.414 2.11-2.111a7.477 7.477 0 0 0 2.068 1.619c.479.253.982.449 1.496.58.204.052.411.085.618.118V16h2v5.914a6.23 6.23 0 0 0 .618-.118 6.812 6.812 0 0 0 1.496-.58c.465-.246.914-.55 1.333-.904.258-.218.5-.462.734-.716l2.111 2.111 1.414-1.414-2.33-2.33c.047-.08.098-.155.142-.236.273-.505.507-1.043.694-1.599.013-.039.021-.079.034-.118H22v-2h-2.308c.065-.499.107-1.004.107-1.511 0-.503-.042-1.005-.106-1.5H22V9H5.756z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBugAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 5.414 1.707-1.707-1.414-1.414-1.563 1.562C15.483 2.708 13.824 2 12 2s-3.483.708-4.73 1.855L5.707 2.293 4.293 3.707 6 5.414A6.937 6.937 0 0 0 5 9H3v2h2v2H3v2h2c0 3.86 3.141 7 7 7s7-3.14 7-7h2v-2h-2v-2h2V9h-2a6.937 6.937 0 0 0-1-3.586zM15 15H9v-2h6v2zm0-4H9V9h6v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.207 11.278-2.035-2.035-1.415-1.415-5.035-5.035a.999.999 0 0 0-1.414 0L6.151 7.949 4.736 9.363a2.985 2.985 0 0 0-.878 2.122c0 .802.313 1.556.879 2.121l.707.707-2.122 2.122a2.925 2.925 0 0 0-.873 2.108 2.968 2.968 0 0 0 1.063 2.308 2.92 2.92 0 0 0 1.886.681c.834 0 1.654-.341 2.25-.937l2.039-2.039.707.706c1.133 1.133 3.107 1.134 4.242.001l.708-.707.569-.569.138-.138 5.156-5.157a.999.999 0 0 0 0-1.414zm-7.277 5.865-.708.706a1.021 1.021 0 0 1-1.414 0l-1.414-1.413a.999.999 0 0 0-1.414 0l-2.746 2.745a1.192 1.192 0 0 1-.836.352.914.914 0 0 1-.595-.208.981.981 0 0 1-.354-.782.955.955 0 0 1 .287-.692l2.829-2.829a.999.999 0 0 0 0-1.414l-1.414-1.415c-.189-.188-.293-.438-.293-.706s.104-.519.293-.708l.707-.707 3.536 3.536 3.536 3.535z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBrushAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8.001h-2V8h-1V4.999a2.92 2.92 0 0 0-.874-2.108 2.943 2.943 0 0 0-2.39-.879C10.202 2.144 9 3.508 9 5.117V8H6c-1.103 0-2 .897-2 2v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V10.001c0-1.103-.897-2-2-2zM6 12v-2h5V5.117c0-.57.407-1.07 1.002-1.117.266 0 .512.103.712.307a.956.956 0 0 1 .286.692V10h.995l.005.001h4V12H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBrightness(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.546 11.646 19 9.101V5.5a.5.5 0 0 0-.5-.5h-3.601l-2.546-2.546a.5.5 0 0 0-.707 0L9.101 5H5.5a.5.5 0 0 0-.5.5v3.601l-2.546 2.546a.5.5 0 0 0 0 .707L5 14.899V18.5a.5.5 0 0 0 .5.5h3.601l2.546 2.546a.5.5 0 0 0 .707 0L14.899 19H18.5a.5.5 0 0 0 .5-.5v-3.601l2.546-2.546a.5.5 0 0 0 0-.707zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBrightnessHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.546 11.646 19 9.101V5.5a.5.5 0 0 0-.5-.5h-3.601l-2.546-2.546a.5.5 0 0 0-.707 0L9.101 5H5.5a.5.5 0 0 0-.5.5v3.601l-2.546 2.546a.5.5 0 0 0 0 .707L5 14.899V18.5a.5.5 0 0 0 .5.5h3.601l2.546 2.546a.5.5 0 0 0 .707 0L14.899 19H18.5a.5.5 0 0 0 .5-.5v-3.601l2.546-2.546a.5.5 0 0 0 0-.707zM12 8a4 4 0 0 1 0 8"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v3h20V8c0-1.103-.897-2-2-2zM9 4h6v2H9V4zm5 10h-4v-2H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBriefcaseAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM6 8h2v11H6V8zm12 11h-2V8h2v11zM15 4v2H9V4h6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBriefcaseAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v4h5v-2h2v2h6v-2h2v2h5V8c0-1.103-.897-2-2-2zM9 4h6v2H9V4zm8 11h-2v-2H9v2H7v-2H2v6c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-6h-5v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBrain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.299 17.596c.432 1.332 1.745 2.182 3.146 2.182H6.5A2.78 2.78 0 0 0 9.223 22c.457 0 .884-.115 1.262-.313a.992.992 0 0 0 .515-.882V3.027a.997.997 0 0 0-.785-.983 2.324 2.324 0 0 0-1.479.201c-.744.356-1.18 1.151-1.18 1.978v.055a2.778 2.778 0 0 0-2.744 4.433A3.327 3.327 0 0 0 2 12c0 1.178.611 2.211 1.533 2.812-.43.771-.571 1.746-.234 2.784zm15.889-8.885a2.778 2.778 0 0 0-2.744-4.433v-.055c0-.826-.437-1.622-1.181-1.978a2.32 2.32 0 0 0-1.478-.201.998.998 0 0 0-.785.983v17.777c0 .365.192.712.516.882.378.199.804.314 1.261.314a2.78 2.78 0 0 0 2.723-2.223h.056c1.4 0 2.714-.85 3.146-2.182.337-1.038.196-2.013-.234-2.784A3.35 3.35 0 0 0 22 12a3.327 3.327 0 0 0-2.812-3.289z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h20v4H2zm17 5H3v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8h-2zm-3 6H8v-2h8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBowlingBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM6.5 12a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 12zM9 6.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 9 6.5zm2.5 6.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 11.5 13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBowlRice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10a3.58 3.58 0 0 0-1.8-3 3.66 3.66 0 0 0-3.63-3.13 3.86 3.86 0 0 0-1 .13 3.7 3.7 0 0 0-5.11 0 3.86 3.86 0 0 0-1-.13A3.66 3.66 0 0 0 4.81 7 3.58 3.58 0 0 0 3 10a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1zM5 10a1.59 1.59 0 0 1 1.11-1.39l.83-.26-.16-.85a1.64 1.64 0 0 1 1.66-1.62 1.78 1.78 0 0 1 .83.2l.81.45.5-.77a1.71 1.71 0 0 1 2.84 0l.5.77.81-.45a1.78 1.78 0 0 1 .83-.2 1.65 1.65 0 0 1 1.67 1.6l-.16.85.82.28A1.59 1.59 0 0 1 19 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBowlHot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H3a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1zM9 9V7.93a4.51 4.51 0 0 0-1.28-3.15A2.49 2.49 0 0 1 7 3V2H5v1a4.51 4.51 0 0 0 1.28 3.17A2.49 2.49 0 0 1 7 7.93V9zm4 0V7.93a4.51 4.51 0 0 0-1.28-3.15A2.49 2.49 0 0 1 11 3V2H9v1a4.51 4.51 0 0 0 1.28 3.15A2.49 2.49 0 0 1 11 7.93V9zm4 0V7.93a4.51 4.51 0 0 0-1.28-3.15A2.49 2.49 0 0 1 15 3V2h-2v1a4.51 4.51 0 0 0 1.28 3.15A2.49 2.49 0 0 1 15 7.93V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.975V8a2 2 0 0 0-2-2h-6V4.688c.305-.274.5-.668.5-1.11a1.5 1.5 0 0 0-3 0c0 .442.195.836.5 1.11V6H5a2 2 0 0 0-2 2v2.998l-.072.005A.999.999 0 0 0 2 12v2a1 1 0 0 0 1 1v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a1 1 0 0 0 1-1v-1.938a1.004 1.004 0 0 0-.072-.455c-.202-.488-.635-.605-.928-.632zM7 12c0-1.104.672-2 1.5-2s1.5.896 1.5 2-.672 2-1.5 2S7 13.104 7 12zm8.998 6c-1.001-.003-7.997 0-7.998 0v-2s7.001-.002 8.002 0l-.004 2zm-.498-4c-.828 0-1.5-.896-1.5-2s.672-2 1.5-2 1.5.896 1.5 2-.672 2-1.5 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookmarks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.999 23V7c0-1.103-.897-2-2-2h-8c-1.103 0-2 .897-2 2v16l6-3.601 6 3.601z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.585 3h1.414c1.103 0 2 .897 2 2v10.443l2 2.489V3c0-1.103-.897-2-2-2h-8c-1.103 0-2 .897-2 2h6.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10.132v-6c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2V22l7-4.666L19 22V10.132z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookmarkStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.222 14.667 13l-.89-3.111L16 8l-2.667-.333L12 5l-1.333 2.667L8 8l2.223 1.889L9.333 13z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.723V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v17.723l7-4.571 7 4.571zM8 8l2.667-.333L12 5l1.333 2.667L16 8l-2.223 1.889.89 3.111L12 11.222 9.333 13l.89-3.111L8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookmarkPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7a2 2 0 0 0-2 2v18l7-4.848L19 22V4a2 2 0 0 0-2-2zm-1 9h-3v3h-2v-3H8V9h3V6h2v3h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookmarkMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7a2 2 0 0 0-2 2v18l7-4.848L19 22V4a2 2 0 0 0-2-2zm-1 9H8V9h8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookmarkHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 22V4c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2v18l7-4.666L19 22zM8.006 8.056c0-.568.224-1.083.585-1.456.361-.372.86-.603 1.412-.603 0 0 .996-.003 1.997 1.029 1.001-1.032 1.997-1.029 1.997-1.029.552 0 1.051.23 1.412.603s.585.888.585 1.456-.224 1.084-.585 1.456L12 13.203 8.591 9.512a2.083 2.083 0 0 1-.585-1.456z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookmarkAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zm1.5 9h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookmarkAltPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM13 11h-2v2H9v-2H7V9h2V7h2v2h2v2zm7 0h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookmarkAltMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM13 11H7V9h6v2zm7 0h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.012 18H21V4a2 2 0 0 0-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1zM8 6h9v2H8V6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookReader(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8v11.529S6.621 19.357 12 22c5.379-2.643 10-2.471 10-2.471V8s-5.454 0-10 2.471C7.454 8 2 8 2 8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3h-7a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 10 3H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h5.758a2.01 2.01 0 0 1 1.414.586l1.121 1.121c.009.009.021.012.03.021.086.08.182.15.294.196h.002a.996.996 0 0 0 .762 0h.002c.112-.046.208-.117.294-.196.009-.009.021-.012.03-.021l1.121-1.121A2.01 2.01 0 0 1 15.242 20H21a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 15h-4.758a4.03 4.03 0 0 0-2.242.689V6c0-.551.448-1 1-1h6v13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.012 18H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19c0-.101.009-.191.024-.273.112-.576.584-.717.988-.727zM8.648 7.642a2.224 2.224 0 0 1 3.125 0l.224.219.223-.219a2.225 2.225 0 0 1 3.126 0 2.129 2.129 0 0 1 0 3.069L11.998 14l-3.349-3.289a2.128 2.128 0 0 1-.001-3.069z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookContent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-1 4v2h-5V7h5zm-5 4h5v2h-5v-2zM4 19V5h7v14H4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19c0-.101.009-.191.024-.273.112-.576.584-.717.988-.727H21V4a2 2 0 0 0-2-2zm0 9-2-1-2 1V4h4v7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBookAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.012 18H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1zM8 9h3V6h2v3h3v2h-3v3h-2v-3H8V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.293 8.293-2.069 2.069A7.017 7.017 0 0 0 15 8.681V4h1V2H8v2h1v4.681A7.01 7.01 0 0 0 5 15c0 3.859 3.141 7 7 7s7-3.141 7-7a6.958 6.958 0 0 0-.652-2.934l2.359-2.359-1.414-1.414zm-8.959 1.998.666-.235V4h2v6.056l.666.235A5.006 5.006 0 0 1 16.886 14H7.114a5.006 5.006 0 0 1 3.22-3.709z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.852 5.148a3.317 3.317 0 0 0-.96-2.183 3.333 3.333 0 1 0-4.713 4.714l-5.499 5.5a3.333 3.333 0 1 0-4.714 4.713c.606.606 1.39.918 2.183.96.042.793.354 1.576.96 2.183a3.333 3.333 0 1 0 4.713-4.714l5.499-5.499a3.333 3.333 0 1 0 4.714-4.713 3.313 3.313 0 0 0-2.183-.961z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBomb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.293 4.293-1.086 1.086-1.086-1.086a.999.999 0 0 0-1.414 0l-1.249 1.249A8.427 8.427 0 0 0 10.499 5C5.813 5 2 8.813 2 13.5S5.813 22 10.499 22s8.5-3.813 8.5-8.5a8.42 8.42 0 0 0-.431-2.654L19.914 9.5a.999.999 0 0 0 0-1.414l-1.293-1.293 1.09-1.09C19.94 5.474 20.556 5 21 5h1V3h-1c-1.4 0-2.584 1.167-2.707 1.293zM10.499 10c-.935 0-1.813.364-2.475 1.025A3.48 3.48 0 0 0 7 13.5H5c0-1.468.571-2.849 1.609-3.888A5.464 5.464 0 0 1 10.499 8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.168 8H13l.806-4.835A1 1 0 0 0 12.819 2H7.667a1 1 0 0 0-.986.835l-1.667 10A1 1 0 0 0 6 14h4v8l8.01-12.459A1 1 0 0 0 17.168 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBoltCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1 16v-5H7l6-7v5h4l-6 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBlanket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h12c1.654 0 3-1.346 3-3s-1.346-3-3-3H6v2h13a1 1 0 0 1 0 2H7c-1.654 0-3-1.346-3-3s1.346-3 3-3h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 13h.003L4 13.002V13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBinoculars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.447 5.345A3.27 3.27 0 0 0 16.29 3a3.293 3.293 0 0 0-3.277 3h-2.025a3.297 3.297 0 0 0-3.284-3 3.268 3.268 0 0 0-3.151 2.345l-2.511 8.368A1.027 1.027 0 0 0 2 14v1a5.006 5.006 0 0 0 5.001 5 5.003 5.003 0 0 0 4.576-3h.846a5.003 5.003 0 0 0 4.576 3A5.006 5.006 0 0 0 22 14.999V14c0-.098-.015-.194-.042-.287l-2.511-8.368zM7.001 18A3.005 3.005 0 0 1 4 15c0-.076.017-.147.022-.222A2.995 2.995 0 0 1 7 12a3 3 0 0 1 3 3v.009A3.004 3.004 0 0 1 7.001 18zm9.998 0A3.004 3.004 0 0 1 14 15.009V15a3 3 0 0 1 6-.001A3.005 3.005 0 0 1 16.999 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBible(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1H21V4a2 2 0 0 0-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3zM8 7h3V5h2v2h3v2h-3v6h-2V9H8V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm7-7.414V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.996.996 0 0 0-.293-.707L19 14.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBellRing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.705 3.71-1.41-1.42C1 5.563 1 7.935 1 11h1l1-.063C3 8.009 3 6.396 5.705 3.71zm13.999-1.42-1.408 1.42C21 6.396 21 8.009 21 11l2-.063c0-3.002 0-5.374-3.296-8.647zM12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm7-7.414V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.184 4.073 5 6.783 5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.996.996 0 0 0-.293-.707L19 14.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBellPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm8.707-5.707L19 14.586V10c0-3.217-2.185-5.926-5.145-6.743C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v4.586l-1.707 1.707A.997.997 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.997.997 0 0 0-.293-.707zM16 12h-3v3h-2v-3H8v-2h3V7h2v3h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBellOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.345 18.931A.993.993 0 0 0 21 18v-1a.996.996 0 0 0-.293-.707L19 14.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258c-1.323.364-2.463 1.128-3.346 2.127L3.707 2.293 2.293 3.707l18 18 1.414-1.414-1.362-1.362zM12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zM5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h10.879L5.068 9.189C5.037 9.457 5 9.724 5 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBellMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm8.707-5.707L19 14.586V10c0-3.217-2.185-5.926-5.145-6.743C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v4.586l-1.707 1.707A.997.997 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.997.997 0 0 0-.293-.707zM16 12H8v-2h8v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBeer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v15c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-1h2c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM8 17H6V7h2v10zm6 0h-2V7h2v10zm6-1h-2V8h2v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBeenHere(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995 3.971 16.44 11.696 21.784 12 22c0 0 8.029-5.56 8-12 0-4.411-3.589-8-8-8zm-1 13.414-3.707-3.707 1.414-1.414L11 12.586l5.293-5.293 1.414 1.414L11 15.414z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9.556V3h-2v2H6V3H4v6.557C2.81 10.25 2 11.526 2 13v4a1 1 0 0 0 1 1h1v4h2v-4h12v4h2v-4h1a1 1 0 0 0 1-1v-4c0-1.474-.811-2.75-2-3.444zM11 9H6V7h5v2zm7 0h-5V7h5v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBattery(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-4h-2V8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBatteryLow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-4h-2V8zM5 15V9h3l4 6H5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBatteryFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h14a2 2 0 0 0 2-2v-2h2v-4h-2V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2zm1-9h12v6H5V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBatteryCharging(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-4h-2zM9 17l2-3.89L7 12l6-5-1 3.89L16 12l-7 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H7V7.113c0-.997.678-1.923 1.661-2.085A2.003 2.003 0 0 1 11 7h2a4.003 4.003 0 0 0-4.398-3.98C6.523 3.222 5 5.089 5 7.178V10H3a1 1 0 0 0-1 1v2c0 2.606 1.674 4.823 4 5.65V22h2v-3h8v3h2v-3.35c2.326-.827 4-3.044 4-5.65v-2a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBasketball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.328 4.258a9.953 9.953 0 0 0-5.949-2.235 8.99 8.99 0 0 1-1.835 7.107L12 10.586l6.328-6.328zM7.701 9.115 4.258 5.672a9.938 9.938 0 0 0-2.112 4.704 7.007 7.007 0 0 0 5.555-1.261zm12.041-3.443L13.414 12l1.456 1.456a8.993 8.993 0 0 1 7.107-1.835 9.953 9.953 0 0 0-2.235-5.949zm2.112 7.952a7.007 7.007 0 0 0-5.555 1.261l3.443 3.443a9.924 9.924 0 0 0 2.112-4.704zM9.115 7.701a7.007 7.007 0 0 0 1.261-5.555 9.928 9.928 0 0 0-4.704 2.112l3.443 3.443zm4.509 14.153a9.936 9.936 0 0 0 4.704-2.111L14.885 16.3a7.003 7.003 0 0 0-1.261 5.554zM12 13.414l-6.328 6.328a9.953 9.953 0 0 0 5.949 2.235 8.99 8.99 0 0 1 1.835-7.107L12 13.414zm-7.742 4.914L10.586 12 9.13 10.544a8.993 8.993 0 0 1-7.107 1.835 9.953 9.953 0 0 0 2.235 5.949z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBasket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.132 2.504 4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.263A2.004 2.004 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9h-1.42l-3.712-6.496-1.736.992L17.277 9H6.723l3.145-5.504-1.736-.992zM14 13h2v5h-2v-5zm-6 0h2v5H8v-5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBaseball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.984 12.236a9.966 9.966 0 0 0-2.913-7.308 9.966 9.966 0 0 0-7.308-2.913 9.04 9.04 0 0 1-.673 4.313l-1.84-.78a7.044 7.044 0 0 0 .526-3.284 9.927 9.927 0 0 0-4.847 2.665 9.924 9.924 0 0 0-2.666 4.852 7.082 7.082 0 0 0 2.576-.276l.575 1.916c-1.1.33-2.257.443-3.398.344a9.964 9.964 0 0 0 2.913 7.307 9.965 9.965 0 0 0 7.307 2.913 9.079 9.079 0 0 1 .344-3.398l1.916.575a7.06 7.06 0 0 0-.276 2.576 9.927 9.927 0 0 0 4.853-2.666 9.926 9.926 0 0 0 2.665-4.848 7.056 7.056 0 0 0-3.284.526l-.78-1.841a9.025 9.025 0 0 1 4.31-.673zM9.17 9.173a9.017 9.017 0 0 1-2.192 1.612l-.927-1.772a7.01 7.01 0 0 0 2.576-2.314l1.663 1.113c-.328.49-.705.948-1.12 1.361zm7.074 7.068a6.991 6.991 0 0 0-1.257 1.708l-1.772-.927a9.025 9.025 0 0 1 2.972-3.312l1.113 1.663a6.987 6.987 0 0 0-1.056.868z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBarcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM8 17H5V7h3zm2 0H9V7h1zm2 0h-1V7h1zm4 0h-3V7h3zm3 0h-2V7h2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBarChartSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM9 18H7v-6h2v6zm4 0h-2V7h2v11zm4 0h-2v-8h2v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBarChartAlt2(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21H3a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1zm7 0h-3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1zm7 0h-3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8v4.001h1V18H2v3h16l3 .001V21h1v-3h-1v-5.999h1V8L12 2 2 8zm4 10v-5.999h2V18H6zm5 0v-5.999h2V18h-2zm7 0h-2v-5.999h2V18zM14 8a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBandAid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.646 3.868-7.778 7.778a6.007 6.007 0 0 0 0 8.485 5.984 5.984 0 0 0 4.242 1.754 5.984 5.984 0 0 0 4.243-1.754l7.778-7.778a6.007 6.007 0 0 0 0-8.485 6.008 6.008 0 0 0-8.485 0zM9 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBalloon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19.91 10 22h4l-1-2.09c4-.65 7-5.28 7-9.91a8 8 0 0 0-16 0c0 4.63 3.08 9.26 7 9.91zm1-15.66v1.5A4.26 4.26 0 0 0 7.75 10h-1.5A5.76 5.76 0 0 1 12 4.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.247 3.034c-.069-.018-1.742-.433-4.052-.433-2.842 0-6.868.64-9.91 3.687-5.34 5.349-3.34 13.61-3.252 13.96a1 1 0 0 0 .728.726c.069.018 1.726.426 4.018.426 2.849 0 6.884-.641 9.932-3.688 5.335-5.335 3.351-13.6 3.264-13.949a1.005 1.005 0 0 0-.728-.729zm-3.537 9.262-1.414 1.414-1.793-1.792-1.586 1.586 1.792 1.793-1.414 1.414-1.792-1.793-1.793 1.793-1.414-1.414 1.793-1.793-1.793-1.794 1.414-1.414 1.793 1.794 1.586-1.586-1.794-1.793 1.414-1.414 1.794 1.793 1.793-1.793 1.414 1.414-1.793 1.793 1.793 1.792z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBaguette(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.13 4.41 4.23 4.23L14.3 9.7l-4.24-4.24-1.77 1.77 4.24 4.24-1.06 1.06-4.24-4.24-1.77 1.77L9.7 14.3l-1.06 1.06-4.23-4.23C1.86 14 1.55 18 3.79 20.21a5.38 5.38 0 0 0 3.85 1.5 8 8 0 0 0 5.6-2.47l6-6c2.87-2.87 3.31-7.11 1-9.45s-6.24-1.93-9.11.62z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.965 8.521C19.988 8.347 20 8.173 20 8c0-2.379-2.143-4.288-4.521-3.965C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.035C6.138 3.712 4 5.621 4 8c0 .173.012.347.035.521C2.802 9.215 2 10.535 2 12s.802 2.785 2.035 3.479A3.976 3.976 0 0 0 4 16c0 2.379 2.138 4.283 4.521 3.965C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.035C17.857 20.283 20 18.379 20 16c0-.173-.012-.347-.035-.521C21.198 14.785 22 13.465 22 12s-.802-2.785-2.035-3.479z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBadgeDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.047 14.668a.994.994 0 0 0 .465.607l1.91 1.104v2.199a1 1 0 0 0 1 1h2.199l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135L12 20.75l1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1V16.38l1.91-1.104a1 1 0 0 0 .365-1.367L20.75 12l1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1H16.38l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.25l-1.909-1.104a1 1 0 0 0-1.366.365l-1.104 1.91H5.422a1 1 0 0 0-1 1V7.62l-1.91 1.104a1.003 1.003 0 0 0-.365 1.368L3.251 12l-1.104 1.908a1.009 1.009 0 0 0-.1.76zM12 13c-3.48 0-4-1.879-4-3 0-1.287 1.029-2.583 3-2.915V6.012h2v1.109c1.734.41 2.4 1.853 2.4 2.879h-1l-1 .018C13.386 9.638 13.185 9 12 9c-1.299 0-2 .515-2 1 0 .374 0 1 2 1 3.48 0 4 1.879 4 3 0 1.287-1.029 2.583-3 2.915V18h-2v-1.08c-2.339-.367-3-2.003-3-2.92h2c.011.143.159 1 2 1 1.38 0 2-.585 2-1 0-.325 0-1-2-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBadgeCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.965 8.521C19.988 8.347 20 8.173 20 8c0-2.379-2.143-4.288-4.521-3.965C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.035C6.138 3.712 4 5.621 4 8c0 .173.012.347.035.521C2.802 9.215 2 10.535 2 12s.802 2.785 2.035 3.479A3.976 3.976 0 0 0 4 16c0 2.379 2.138 4.283 4.521 3.965C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.035C17.857 20.283 20 18.379 20 16c0-.173-.012-.347-.035-.521C21.198 14.785 22 13.465 22 12s-.802-2.785-2.035-3.479zm-9.01 7.895-3.667-3.714 1.424-1.404 2.257 2.286 4.327-4.294 1.408 1.42-5.749 5.706z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBackpack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15a1 1 0 0 0-1-1H9c-.551 0-1 .448-1 1v2h8v-2zm-8 4h8v3H8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12c0-2.967-2.167-5.432-5-5.91V5c0-1.654-1.346-3-3-3h-2C9.346 2 8 3.346 8 5v1.09C5.167 6.568 3 9.033 3 12v8c0 1.103.897 2 2 2h1v-7c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3v7h1c1.103 0 2-.897 2-2v-8zM10 5c0-.552.449-1 1-1h2a1 1 0 0 1 1 1v1h-4V5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidBabyCarriage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.666 12.277a7.72 7.72 0 0 0 .171-.665c.003-.017.004-.033.008-.05.02-.098.029-.199.045-.298.025-.157.055-.313.07-.471a7.979 7.979 0 0 0-2.303-6.45A7.979 7.979 0 0 0 14 2v8H6.517l-.858-2H2v2h2.341l1.828 4.266A3.504 3.504 0 0 0 4 17.5C4 19.43 5.57 21 7.5 21c1.759 0 3.204-1.309 3.449-3h2.102c.245 1.691 1.69 3 3.449 3 1.93 0 3.5-1.57 3.5-3.5 0-.63-.181-1.213-.473-1.725.042-.041.089-.077.131-.119.36-.361.688-.759.977-1.184.288-.43.536-.886.736-1.359.016-.037.026-.076.041-.113h.001l.015-.042c.088-.22.168-.441.235-.668l.003-.013zM7.5 19c-.827 0-1.5-.673-1.5-1.5S6.673 16 7.5 16s1.5.673 1.5 1.5S8.327 19 7.5 19zm9 0c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8.999a6.99 6.99 0 0 0 2.879 5.646l.001.001a6.972 6.972 0 0 0 1.881.979l.051.019a6.906 6.906 0 0 0 1.163.271 6.79 6.79 0 0 0 1.024.085H12c.35 0 .69-.034 1.027-.084l.182-.028c.336-.059.664-.139.981-.243l.042-.016C17 14.693 19 12.078 19 8.999 19 5.14 15.86 2 12 2S5 5.14 5 8.999zM12 4c2.756 0 5 2.242 5 4.999h-2A3.003 3.003 0 0 0 12 6V4zM7.521 16.795V22L12 20.5l4.479 1.5.001-5.205a8.932 8.932 0 0 1-8.959 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArrowToTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm5 10v6h2v-6h5l-6-6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArrowToRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zm-8 5H4v2h6v5l6-6-6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArrowToLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm10 7h6v-2h-6V6l-6 6 6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArrowToBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm5-14v6H6l6 6 6-6h-5V4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArrowFromTop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm5 4v6H6l6 6 6-6h-5V8z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArrowFromRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zm-8 12v-5h6v-2h-6V6l-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArrowFromLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm10 5H8v2h6v5l6-6-6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArrowFromBottom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm6-14-6 6h5v6h2v-6h5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArea(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14zm9-13h6v6h-2V8h-4V6zm-6 6h2v4h4v2H6v-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.704 5.29-2.997-2.997A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.296 5.29A.994.994 0 0 0 2 5.999V19a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5.999a.994.994 0 0 0-.296-.709zM6.414 4h11.172l1 1H5.414l1-1zM17 13v1H7v-4h2v2h6v-2h2v3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArchiveOut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.292A.994.994 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM14 14v3h-4v-3H7l5-5 5 5h-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArchiveIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.997.997 0 0 0-.707.293L2.294 5.292A.996.996 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM12 18l-5-5h3v-3h4v3h3l-5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidArch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8V6H3v14H2v2h6v-7c0-.163.046-4 4-4 3.821 0 3.993 3.602 4 4v7h6v-2h-1V8zM2 2h20v2H2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAngry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5.002-.022-1.373-.549.742-1.857 5 2-.742 1.857-1.031-.413c-.014.014-.023.031-.037.044A1.499 1.499 0 0 1 7 10.5zM8 17s1-3 4-3 4 3 4 3H8zm8.986-6.507c0 .412-.167.785-.438 1.056a1.488 1.488 0 0 1-2.112 0c-.011-.011-.019-.024-.029-.035l-1.037.415-.742-1.857 5-2 .742 1.857-1.386.554a.036.036 0 0 1 .002.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAnalyse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.626 8.878a7.937 7.937 0 0 1 1.71-2.541 7.92 7.92 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.49 2.49 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059-1.19.5-2.26 1.22-3.18 2.139A9.98 9.98 0 0 0 2 12h2c0-1.086.211-2.136.626-3.122zm14.747 6.244c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.973 9.973 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538c2.502 0 4.538-2.036 4.538-4.538S14.502 7.462 12 7.462z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAmbulance(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.86 12.48 19.15 8a2 2 0 0 0-1.72-1H15V5a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 1 1.73 3.49 3.49 0 0 0 7 .27h3.1a3.48 3.48 0 0 0 6.9 0 2 2 0 0 0 2-2v-3a1.07 1.07 0 0 0-.14-.52zM6.5 19A1.5 1.5 0 1 1 8 17.5 1.5 1.5 0 0 1 6.5 19zm5.5-8h-2v2H8v-2H6V9h2V7h2v2h2zm4.5 8a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zM15 12V9h2.43l1.8 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAlbum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-4.607 8.055A4.956 4.956 0 0 0 7 12H5a6.978 6.978 0 0 1 2.051-4.95 6.978 6.978 0 0 1 2.225-1.5l.779 1.842c-.596.252-1.13.612-1.59 1.072s-.82.995-1.072 1.591zm4.6 3.945a2.007 2.007 0 1 1 0-4.014 2.007 2.007 0 0 1 0 4.014z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAlarm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.878 0-9 4.122-9 9s4.122 9 9 9c4.879 0 9-4.122 9-9s-4.121-9-9-9zm5 10h-6V8h2v4h4v2zm3.292-7.292-3.01-3 1.412-1.417 3.01 3zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAlarmSnooze(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.284 3.707 1.412-1.416 3.01 3-1.413 1.417zm-10.586 0-2.99 2.999L2.29 5.294l2.99-3zM12 4c-4.878 0-9 4.121-9 9s4.122 9 9 9c4.879 0 9-4.121 9-9s-4.121-9-9-9zm4 13H8.131l4-6H8V9h7.868l-1.035 1.554-.001.001L11.869 15H16v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAlarmOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.292 6.708-3.01-3 1.412-1.417 3.01 3zm1.415 13.585-2.287-2.288C20.409 16.563 21 14.837 21 13c0-4.878-4.121-9-9-9-1.838 0-3.563.59-5.006 1.581L5.91 4.496l.788-.79-1.416-1.412-.786.788-.789-.789-1.414 1.414 18 18 1.414-1.414zM17 14h-1.586l-2-2H17v2zm-6-6h2v3.586l-2-2V8zm1 14c1.658 0 3.224-.485 4.574-1.305L4.305 8.426A8.794 8.794 0 0 0 3 13c0 4.878 4.122 9 9 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAlarmExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.284 3.707 1.412-1.416 3.01 3-1.413 1.417zm-10.586 0-2.99 2.999L2.29 5.294l2.99-3zM12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm1 14h-2v-2h2v2zm0-4h-2V8h2v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAlarmAdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm4 10h-3v3h-2v-3H8v-2h3V9h2v3h3v2zm1.284-10.293 1.412-1.416 3.01 3-1.413 1.417zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAdjust(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.58 2 12s4.579 10 10 10 10-4.58 10-10S17.421 2 12 2zm0 17V5c3.829 0 7 3.169 7 7 0 3.828-3.171 7-7 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAdjustAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 19.071c3.833-3.833 3.833-10.31 0-14.143s-10.31-3.833-14.143 0-3.833 10.31 0 14.143 10.31 3.833 14.143 0zM7.051 7.051c2.706-2.707 7.191-2.708 9.898 0l-9.898 9.898c-2.708-2.707-2.71-7.19 0-9.898z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiSolidAddToQueue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h12v-2H4V8H2v12c0 1.103.897 2 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-2 9h-3v3h-2v-3h-3V9h3V6h2v3h3v2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoZoom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.984 7.506v6.74c.006 1.524 1.361 2.75 3.014 2.745h10.693c.303 0 .549-.225.549-.498v-6.74c-.008-1.523-1.363-2.75-3.014-2.744H2.531c-.302 0-.547.224-.547.497zm14.936 2.63 4.416-2.963c.383-.292.68-.219.68.309v9.036c0 .601-.363.528-.68.309L16.92 13.87v-3.734z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoYoutube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.593 7.203a2.506 2.506 0 0 0-1.762-1.766C18.265 5.007 12 5 12 5s-6.264-.007-7.831.404a2.56 2.56 0 0 0-1.766 1.778c-.413 1.566-.417 4.814-.417 4.814s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765 1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.515 2.515 0 0 0 1.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831zM9.996 15.005l.005-6 5.207 3.005-5.212 2.995z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoYelp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.824 16.675c-.105.726-1.587 2.609-2.269 2.882-.232.093-.457.07-.637-.068-.116-.09-.235-.272-1.833-2.866l-.475-.773c-.183-.277-.148-.642.078-.92.223-.27.549-.37.832-.262.016.008 1.195.397 1.195.397 2.688.883 2.775.917 2.891 1.002.17.139.249.356.214.608h.004zm-5.386-3.946c-.19-.289-.187-.63.01-.865l.746-1.019c1.642-2.235 1.732-2.353 1.843-2.431a.636.636 0 0 1 .652-.024c.651.316 1.966 2.269 2.045 3.019v.025a.623.623 0 0 1-.259.587c-.123.079-.235.125-3.291.866-.483.123-.752.19-.91.247l.021-.023c-.302.091-.64-.055-.831-.357l-.026-.025zm-1.875-1.159c-.146.046-.591.185-1.139-.702 0 0-3.694-5.813-3.78-5.992-.053-.201.011-.429.19-.613.55-.569 3.534-1.405 4.315-1.215.255.066.43.227.491.453.045.25.408 5.646.46 6.854.051 1.034-.392 1.171-.537 1.215zm.487 5.913c-.008 2.827-.015 2.922-.061 3.056-.079.211-.26.352-.51.398-.72.122-2.972-.71-3.441-1.267a.739.739 0 0 1-.157-.37c-.013-.09 0-.18.033-.259.057-.146.135-.259 2.158-2.63l.594-.706c.203-.26.563-.338.899-.204.325.124.528.405.506.708v1.259l-.021.015zm-6.13-1.808c-.222-.006-.42-.14-.535-.358-.083-.162-.142-.428-.18-.752-.102-.974.023-2.444.314-2.911.138-.214.338-.327.559-.319.146 0 .276.046 3.167 1.236l.848.337c.302.111.489.427.472.787-.022.348-.224.616-.521.696l-1.202.382c-2.689.864-2.778.888-2.919.877l-.003.025zm11.22 5.322h-.004l-.003.003.007-.003z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoYahoo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.131 21s-.63-.114-1.138-.114c-.457 0-1.142.114-1.142.114l.143-7.646C9.933 11.52 6.814 5.933 4.868 3c.979.223 1.391.209 2.374 0l.015.025c1.239 2.194 3.135 5.254 4.736 7.905C13.575 8.325 16.064 4.258 16.74 3c.765.201 1.536.193 2.392 0-.9 1.213-4.175 6.88-6.153 10.354L13.125 21h.006z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoXing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6a.4.4 0 0 0-.38.62l2 3.38-3.06 5.4a.45.45 0 0 0 0 .45.43.43 0 0 0 .38.19h2.87a.89.89 0 0 0 .79-.55s3-5.31 3.11-5.51l-2-3.46A.91.91 0 0 0 7.92 6zm12.16-4a.84.84 0 0 0-.77.55L10 13.93l4.09 7.52a.91.91 0 0 0 .81.55h2.88a.43.43 0 0 0 .38-.18.45.45 0 0 0 0-.45l-4.07-7.43 6.36-11.31a.45.45 0 0 0 0-.45.44.44 0 0 0-.38-.18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoWordpress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.891 7.788a8.966 8.966 0 0 1 1.099 4.313 8.986 8.986 0 0 1-4.47 7.771l2.746-7.939c.513-1.282.684-2.309.684-3.219a7.165 7.165 0 0 0-.059-.926m-6.651.087a14.14 14.14 0 0 0 1.026-.088c.485-.063.428-.775-.056-.749 0 0-1.463.112-2.4.112-.887 0-2.375-.125-2.375-.125-.487-.024-.55.713-.061.738 0 0 .449.052.938.075l1.399 3.838-1.975 5.899-3.274-9.724a17.006 17.006 0 0 0 1.028-.083c.487-.063.43-.775-.055-.747 0 0-1.455.115-2.395.115-.167 0-.365-.007-.575-.013C6.093 4.726 8.862 3.113 12 3.113c2.341 0 4.471.894 6.071 2.36-.038-.002-.076-.008-.117-.008-.883 0-1.51.77-1.51 1.596 0 .741.427 1.369.883 2.108.343.601.742 1.37.742 2.481 0 .763-.295 1.662-.685 2.899l-.896 2.987-3.25-9.675.002.014zM12 21.087a8.983 8.983 0 0 1-2.54-.364l2.697-7.838 2.763 7.572c.021.044.042.085.065.124a9.016 9.016 0 0 1-2.985.508m-8.99-8.988a8.94 8.94 0 0 1 .778-3.658l4.287 11.749a8.993 8.993 0 0 1-5.065-8.091m8.99-10c-5.513 0-10 4.487-10 10s4.487 10 10 10 10-4.487 10-10-4.487-10-10-10"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoWix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.444 8.256c-.4.212-.544.562-.544 1.53 0 0 .202-.194.499-.303a2.01 2.01 0 0 0 .512-.275c.338-.247.385-.562.385-1.096 0 0-.553-.016-.852.144zm-2.349.229c-.32.286-.418.739-.418.739l-1.078 4.141L8.71 9.97c-.087-.355-.246-.808-.495-1.107-.31-.378-.944-.401-1.015-.401-.068 0-.709.023-1.026.407-.246.303-.406.751-.493 1.108l-.889 3.395-1.066-4.147s-.092-.459-.418-.739c-.529-.465-1.314-.367-1.314-.367l2.048 7.764s.677.052 1.015-.126c.441-.224.659-.401.929-1.463.241-.94.912-3.704.974-3.905.029-.098.07-.332.241-.332.179 0 .214.229.241.332.064.195.729 2.965.976 3.905.268 1.055.481 1.227.929 1.463.338.178 1.015.126 1.015.126l2.048-7.759c-.002 0-.789-.099-1.315.361zm3.201.9s-.129.195-.42.367c-.188.104-.367.178-.562.271-.323.154-.414.332-.414.595v5.266s.522.063.854-.104c.436-.222.533-.435.541-1.404V9.385zm5.112 2.632 2.599-3.875s-1.096-.189-1.641.309c-.35.315-.738.885-.738.885l-.952 1.386c-.053.069-.104.15-.2.15-.099 0-.161-.075-.202-.15l-.962-1.382s-.385-.568-.74-.884c-.54-.499-1.641-.31-1.641-.31l2.603 3.865-2.603 3.858s1.146.149 1.688-.35c.35-.315.688-.837.688-.837l.95-1.383c.053-.068.104-.147.2-.147.1 0 .161.075.202.147l.952 1.383s.355.51.7.837c.538.499 1.667.35 1.667.35l-2.57-3.852z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoWindows(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 5.557 7.357-1.002.004 7.097-7.354.042L3 5.557zm7.354 6.913.006 7.103-7.354-1.011v-6.14l7.348.048zm.892-8.046L21.001 3v8.562l-9.755.077V4.424zm9.758 8.113-.003 8.523-9.755-1.378-.014-7.161 9.772.016z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoWikipedia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.081 12.932c-.78 1.611-1.849 3.792-2.379 4.776-.513.896-.94.776-1.278.024-1.172-2.77-3.58-7.625-4.712-10.347-.209-.502-.367-.823-.516-.95-.151-.125-.462-.2-.936-.227-.174-.019-.26-.061-.26-.131v-.379l.043-.038c.771-.004 4.503 0 4.503 0l.042.038v.362c0 .1-.063.147-.188.147l-.47.024c-.403.026-.605.137-.605.365 0 .112.044.275.139.501.902 2.206 4.017 8.772 4.017 8.772l.114.039 2.01-4.012-.402-.89L9.82 8.285s-.265-.545-.357-.727c-.607-1.203-.593-1.265-1.206-1.347-.173-.02-.261-.042-.261-.125v-.39l.05-.037h3.578l.095.03v.376c0 .088-.063.125-.189.125l-.257.039c-.66.051-.551.318-.113 1.186l1.319 2.712 1.465-2.922c.244-.533.194-.668.093-.789-.058-.07-.255-.185-.677-.2l-.168-.018a.191.191 0 0 1-.121-.043.125.125 0 0 1-.056-.107v-.357l.051-.037c1.04-.007 3.371 0 3.371 0l.05.037v.364c0 .101-.05.148-.161.148-.539.024-.652.079-.854.366-.1.154-.313.49-.538.865l-1.919 3.563-.054.112 2.328 4.763.142.041 3.665-8.704c.129-.352.107-.602-.053-.746-.165-.144-.289-.228-.716-.246l-.35-.014a.211.211 0 0 1-.127-.037.128.128 0 0 1-.06-.1v-.361l.049-.038h4.137l.034.038v.364c0 .1-.062.15-.174.15-.541.024-.94.15-1.203.351-.263.213-.465.514-.614.89 0 0-3.371 7.72-4.524 10.289-.438.84-.878.765-1.253-.026-.477-.977-1.478-3.156-2.206-4.761l.045-.03z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoWhatsapp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoWhatsappSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.043 6.925a4.985 4.985 0 0 0-4.98 4.979c-.001.94.263 1.856.761 2.649l.118.188-.503 1.837 1.885-.494.181.108a4.97 4.97 0 0 0 2.535.693h.001a4.986 4.986 0 0 0 4.979-4.978 4.946 4.946 0 0 0-1.456-3.522 4.946 4.946 0 0 0-3.521-1.46zm2.928 7.118c-.125.35-.723.668-1.01.711a2.044 2.044 0 0 1-.943-.059 8.51 8.51 0 0 1-.853-.315c-1.502-.648-2.482-2.159-2.558-2.26-.074-.1-.61-.812-.61-1.548 0-.737.386-1.099.523-1.249a.552.552 0 0 1 .4-.186c.1 0 .199.001.287.005.092.004.215-.035.336.257.125.3.425 1.036.462 1.111.037.074.062.162.013.262-.05.101-.074.162-.15.25-.074.088-.157.195-.224.263-.075.074-.153.155-.066.305.088.149.388.64.832 1.037.572.51 1.055.667 1.204.743.15.074.237.063.325-.038.087-.101.374-.437.474-.586.1-.15.199-.125.337-.076.137.051.873.412 1.022.487.148.074.249.112.287.175.036.062.036.361-.088.711z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-7.96 14.896h-.002a5.98 5.98 0 0 1-2.862-.729L6 18l.85-3.104a5.991 5.991 0 0 1 5.19-8.983 5.95 5.95 0 0 1 4.238 1.757 5.95 5.95 0 0 1 1.751 4.237 5.998 5.998 0 0 1-5.989 5.989z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoVuejs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 12.765 5.592-9.437h-3.276L12 7.33v.002L9.688 3.328h-3.28z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.461 3.332 12 14.235 5.539 3.332H1.992L12 20.672l10.008-17.34z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoVk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.579 6.855c.14-.465 0-.806-.662-.806h-2.193c-.558 0-.813.295-.953.619 0 0-1.115 2.719-2.695 4.482-.51.513-.743.675-1.021.675-.139 0-.341-.162-.341-.627V6.855c0-.558-.161-.806-.626-.806H9.642c-.348 0-.558.258-.558.504 0 .528.79.65.871 2.138v3.228c0 .707-.127.836-.407.836-.743 0-2.551-2.729-3.624-5.853-.209-.607-.42-.852-.98-.852H2.752c-.627 0-.752.295-.752.619 0 .582.743 3.462 3.461 7.271 1.812 2.601 4.363 4.011 6.687 4.011 1.393 0 1.565-.313 1.565-.853v-1.966c0-.626.133-.752.574-.752.324 0 .882.164 2.183 1.417 1.486 1.486 1.732 2.153 2.567 2.153h2.192c.626 0 .939-.313.759-.931-.197-.615-.907-1.51-1.849-2.569-.512-.604-1.277-1.254-1.51-1.579-.325-.419-.231-.604 0-.976.001.001 2.672-3.761 2.95-5.04z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoVisualStudio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.29 4.1-4.12-2a1.36 1.36 0 0 0-.48-.1h-.08a1.18 1.18 0 0 0-.72.24l-.14.12-7.88 7.19L4.44 7a.83.83 0 0 0-.54-.17.88.88 0 0 0-.53.17l-1.1 1a.8.8 0 0 0-.27.61.84.84 0 0 0 .27.62l3 2.71-3 2.72a.84.84 0 0 0 0 1.23l1.1 1a.89.89 0 0 0 .6.22.93.93 0 0 0 .47-.17l3.43-2.61 7.88 7.19a1.2 1.2 0 0 0 .76.36h.17a1 1 0 0 0 .49-.12l4.12-2a1.25 1.25 0 0 0 .71-1.1V5.23a1.26 1.26 0 0 0-.71-1.13zM17 16.47l-6-4.53 6-4.53z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoVisa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.539 9.186a4.155 4.155 0 0 0-1.451-.251c-1.6 0-2.73.806-2.738 1.963-.01.85.803 1.329 1.418 1.613.631.292.842.476.84.737-.004.397-.504.577-.969.577-.639 0-.988-.089-1.525-.312l-.199-.093-.227 1.332c.389.162 1.09.301 1.814.313 1.701 0 2.813-.801 2.826-2.032.014-.679-.426-1.192-1.352-1.616-.563-.275-.912-.459-.912-.738 0-.247.299-.511.924-.511a2.95 2.95 0 0 1 1.213.229l.15.067.227-1.287-.039.009zm4.152-.143h-1.25c-.389 0-.682.107-.852.493l-2.404 5.446h1.701l.34-.893 2.076.002c.049.209.199.891.199.891h1.5l-1.31-5.939zm-10.642-.05h1.621l-1.014 5.942H9.037l1.012-5.944v.002zm-4.115 3.275.168.825 1.584-4.05h1.717l-2.551 5.931H5.139l-1.4-5.022a.339.339 0 0 0-.149-.199 6.948 6.948 0 0 0-1.592-.589l.022-.125h2.609c.354.014.639.125.734.503l.57 2.729v-.003zm12.757.606.646-1.662c-.008.018.133-.343.215-.566l.111.513.375 1.714H18.69v.001h.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoVimeo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.062 10.414c-2.036 4.349-6.949 10.267-10.054 10.267-3.06 0-3.501-6.527-5.173-10.869-.823-2.138-1.354-1.646-2.896-.567L2 8.031c2.248-1.976 4.499-4.272 5.88-4.399 1.559-.148 2.517.916 2.873 3.193.475 2.994 1.137 7.641 2.291 7.641.9 0 3.117-3.686 3.232-5.004.203-1.93-1.421-1.989-2.828-1.387 2.228-7.295 11.494-5.95 7.614 2.339z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoVenmo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3.27a7.49 7.49 0 0 1 .66 3.35c0 2.72-1.93 6.72-3.49 9.27L9.53 2.44l-6.91.65L5.79 22h7.88c3.45-4.54 7.71-11 7.71-16a7.3 7.3 0 0 0-1.06-4z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoUpwork(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.47 6.07a4.54 4.54 0 0 0-4.38 3.69 19.9 19.9 0 0 1-2.28-4.9H8.55v6a2.14 2.14 0 1 1-4.28 0v-6L2 4.91v6a4.4 4.4 0 1 0 8.8-.05v-1a20.55 20.55 0 0 0 1.65 2.7l-1.38 6.61h2.32l1-4.81a5.61 5.61 0 0 0 3.11.89 4.57 4.57 0 0 0 0-9.14zm0 6.83a4.09 4.09 0 0 1-2.55-1l.23-.91v-.05c.16-1 .66-2.6 2.35-2.6a2.25 2.25 0 0 1 2.27 2.24 2.41 2.41 0 0 1-2.27 2.32z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoUnsplash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.625 8.063V3h6.75v5.063h-6.75zm6.75 2.812H21V21H3V10.875h5.625v5.063h6.75v-5.063z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoUnity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.4 17.8 1.21 2.07L19.77 22 22 14.08 20.72 12 22 10l-2.23-8-8.16 2.13L10.4 6.2H8L2 12l6 5.81zm9.92-5.8-1.73 6L15 12l3.59-6zM10.6 6.54 16.84 5l-3.59 6H6.08zM13.27 13l3.59 6-6.26-1.55L6.1 13z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoTypescript(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.24 3H4.76A1.76 1.76 0 0 0 3 4.76v14.48A1.76 1.76 0 0 0 4.76 21h14.48A1.76 1.76 0 0 0 21 19.24V4.76A1.76 1.76 0 0 0 19.24 3zm-5.8 10h-2.25v6.44H9.4V13H7.15v-1.46h6.29zm5.8 5.28a1.71 1.71 0 0 1-.67.74 3 3 0 0 1-1 .39 5.81 5.81 0 0 1-1.2.12 7 7 0 0 1-1.23-.11 4.52 4.52 0 0 1-1-.33v-1.71l-.06-.06h.06v.07a3.41 3.41 0 0 0 1 .54 3.06 3.06 0 0 0 1.13.2 2.58 2.58 0 0 0 .6-.06 1.47 1.47 0 0 0 .42-.17.75.75 0 0 0 .25-.25.69.69 0 0 0-.06-.74 1.24 1.24 0 0 0-.35-.33 3.12 3.12 0 0 0-.53-.3l-.67-.28a3.57 3.57 0 0 1-1.37-1 2 2 0 0 1-.46-1.33 2.16 2.16 0 0 1 .24-1.06 2.09 2.09 0 0 1 .66-.71 2.88 2.88 0 0 1 1-.42 5.11 5.11 0 0 1 1.19-.13 7 7 0 0 1 1.09.07 4.53 4.53 0 0 1 .88.23v1.65a2.42 2.42 0 0 0-.42-.24 3.58 3.58 0 0 0-.49-.17 3 3 0 0 0-.49-.1 2.45 2.45 0 0 0-.46 0 2.29 2.29 0 0 0-.56.06 1.54 1.54 0 0 0-.43.16.78.78 0 0 0-.26.25.63.63 0 0 0-.09.33.62.62 0 0 0 .1.35 1.19 1.19 0 0 0 .3.29 2.15 2.15 0 0 0 .46.28l.63.28a6.56 6.56 0 0 1 .84.42 2.65 2.65 0 0 1 .64.49 1.79 1.79 0 0 1 .42.63 2.48 2.48 0 0 1 .14.85 2.68 2.68 0 0 1-.25 1.08z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoTwitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoTwitch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.265 3 3 6.236v13.223h4.502V21l2.531.85 2.392-2.391h3.658l4.923-4.924V3H4.265zm15.052 10.691-2.813 2.814h-4.502l-2.391 2.391v-2.391H5.813V4.688h13.504v9.003zm-2.812-5.767v4.923h-1.688V7.924h1.688zm-4.502 0v4.923h-1.688V7.924h1.688z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoTux(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.642 8.084c-.364.189-.79.42-1.242.42s-.81-.209-1.066-.413c-.13-.101-.234-.202-.313-.276-.137-.108-.12-.259-.064-.254.094.012.108.136.168.191.08.075.18.172.302.269.243.192.567.38.973.38s.878-.238 1.167-.4c.163-.092.371-.256.541-.381.13-.095.125-.21.232-.198.107.013.028.127-.122.258a3.404 3.404 0 0 1-.576.404z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.649 17.77c-.142-.16-.209-.456-.281-.771s-.153-.654-.411-.874l-.002-.001a1.054 1.054 0 0 0-.317-.192c.359-1.065.219-2.126-.145-3.084-.444-1.177-1.222-2.202-1.815-2.903-.664-.838-1.313-1.633-1.301-2.808.021-1.793.197-5.118-2.958-5.122a4.66 4.66 0 0 0-.401.017c-3.526.283-2.59 4.008-2.643 5.255-.064.912-.249 1.631-.877 2.523-.736.876-1.774 2.295-2.266 3.771-.232.697-.342 1.407-.241 2.08a1.9 1.9 0 0 0-.091.089c-.216.231-.376.511-.555.699-.166.167-.403.229-.664.323s-.547.231-.721.565l-.001.002a1 1 0 0 0-.108.484c0 .154.023.311.046.461.048.313.097.609.032.81-.206.564-.232.954-.087 1.237.146.284.444.409.783.479.676.141 1.592.106 2.314.489l.062-.117-.061.118c.773.404 1.557.547 2.182.405.454-.104.821-.374 1.011-.789.489-.002 1.025-.209 1.885-.256.583-.047 1.312.207 2.149.16a1.119 1.119 0 0 0 .099.264c.324.649.928.946 1.571.896s1.329-.43 1.883-1.089l-.102-.085.102.084c.527-.64 1.403-.905 1.984-1.255.29-.175.525-.395.544-.713.018-.318-.169-.675-.599-1.152zm-7.79-11.708c-.003-.234.036-.435.126-.639s.201-.351.358-.47.312-.174.494-.176h.009c.179 0 .332.053.489.167.159.116.274.261.366.463a1.493 1.493 0 0 1 .141.636c.002.235-.038.435-.127.639a1.23 1.23 0 0 1-.18.299l-.074-.033c-.089-.038-.167-.069-.237-.096s-.124-.044-.181-.064c.041-.049.122-.108.151-.181a.943.943 0 0 0 .072-.347l.002-.016a.953.953 0 0 0-.05-.337c-.038-.113-.086-.195-.155-.263s-.139-.099-.223-.101h-.011a.324.324 0 0 0-.217.086.618.618 0 0 0-.174.25.944.944 0 0 0-.072.348l-.001.015a.992.992 0 0 0 .014.2 2.463 2.463 0 0 0-.507-.171 1.681 1.681 0 0 1-.014-.19v-.019zm-2.144.052c-.012-.202.009-.376.064-.556s.13-.311.238-.418a.516.516 0 0 1 .349-.168h.03c.118 0 .225.04.335.127a.968.968 0 0 1 .284.389c.076.171.116.343.127.545v.002a1.51 1.51 0 0 1-.002.243c-.023.006-.046.014-.068.021-.128.044-.23.093-.328.158a.845.845 0 0 0 .003-.214v-.012a.95.95 0 0 0-.068-.274.523.523 0 0 0-.138-.203c-.052-.044-.1-.065-.153-.064l-.017.001c-.061.005-.11.034-.157.092a.536.536 0 0 0-.101.223.912.912 0 0 0-.019.293l.001.012c.01.103.031.189.067.275a.528.528 0 0 0 .166.224c-.059.045-.098.078-.146.113l-.11.081a.995.995 0 0 1-.229-.342 1.528 1.528 0 0 1-.128-.546v-.002zm.155 1.228c.187-.14.315-.234.402-.298.086-.063.121-.086.148-.112h.001c.14-.132.362-.374.699-.49.115-.04.245-.065.39-.066.275-.001.608.089 1.01.348.247.16.439.174.882.363h.001c.213.087.338.202.399.321.061.12.063.25.012.387-.103.273-.429.562-.887.705h-.001c-.224.072-.418.233-.647.364a1.449 1.449 0 0 1-.842.217 1.105 1.105 0 0 1-.374-.083 1.202 1.202 0 0 1-.27-.167c-.161-.131-.303-.295-.51-.416h-.002c-.333-.19-.515-.408-.573-.598-.057-.189-.003-.351.162-.475zm.131 13.018v.001c-.047.623-.398.961-.938 1.085-.539.123-1.27 0-1.999-.381h-.001c-.808-.427-1.768-.385-2.384-.514-.308-.064-.509-.161-.602-.341-.092-.18-.094-.494.102-1.028l.001-.002.001-.002c.097-.299.025-.626-.021-.934-.047-.307-.07-.586.034-.781l.001-.002c.135-.259.332-.352.576-.439.245-.088.534-.157.764-.386l.001-.001.001-.001c.212-.223.371-.503.557-.702.157-.167.314-.279.551-.28h.009c.041 0 .085.003.132.011.314.047.588.268.853.625l.762 1.389h.001c.202.423.631.89.994 1.365.362.475.644.952.607 1.317l-.002.001zm-.063-1.01a6.721 6.721 0 0 0-.333-.469 13.467 13.467 0 0 0-.229-.293c.151 0 .28-.024.384-.072a.486.486 0 0 0 .266-.274c.09-.242 0-.583-.288-.973-.29-.39-.778-.83-1.494-1.269-.527-.328-.821-.729-.959-1.165s-.119-.907-.013-1.373c.204-.894.729-1.762 1.063-2.308.09-.066.032.123-.339.811-.332.629-.953 2.081-.103 3.214a6.722 6.722 0 0 1 .538-2.398c.472-1.067 1.456-2.919 1.534-4.395.041.029.18.123.241.158.182.106.316.262.492.403.177.142.396.264.729.283l.093.003c.343 0 .61-.112.833-.239.242-.138.436-.292.618-.351h.001c.387-.122.694-.335.869-.585.302 1.186 1.001 2.897 1.45 3.733.239.443.715 1.385.92 2.52.13-.004.273.015.427.054.537-1.393-.455-2.892-.909-3.31-.184-.178-.192-.258-.102-.254.492.436 1.139 1.311 1.374 2.3.107.451.13.925.016 1.393.056.023.113.048.171.076.862.42 1.181.785 1.027 1.283-.05-.002-.1-.001-.148 0h-.014c.125-.395-.151-.687-.889-1.02-.764-.336-1.373-.303-1.476.379a1.302 1.302 0 0 0-.017.109c-.057.02-.114.045-.172.076-.358.197-.555.553-.664.99-.108.437-.14.964-.17 1.558-.019.298-.141.702-.266 1.129-1.249.897-2.986 1.283-4.461.276zm9.628.057c-.524.317-1.456.593-2.05 1.313-.517.615-1.146.952-1.7.996-.555.044-1.033-.186-1.315-.752v-.001l-.001-.003c-.175-.333-.102-.858.045-1.412.147-.554.359-1.123.388-1.585v-.001c.03-.592.063-1.11.163-1.509.1-.399.256-.669.533-.821l.039-.02c.031.513.285 1.036.734 1.149.491.129 1.199-.292 1.498-.636.06-.002.118-.006.175-.007.262-.006.481.009.707.205v.001h.001c.173.146.255.423.326.733.071.31.128.647.342.888h.001c.41.456.542.764.531.96-.011.198-.153.344-.417.502z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.738 6.762c.015.048.093.04.138.063.04.02.071.065.116.066.042.001.107-.015.113-.057.008-.056-.073-.091-.126-.111-.067-.026-.153-.039-.216-.004-.014.008-.03.027-.025.043zm-.46 0c-.016.048-.094.04-.139.063-.039.02-.071.065-.115.066-.042.001-.108-.015-.114-.057-.007-.056.074-.091.126-.111.067-.026.153-.039.217-.004.015.008.03.027.025.043z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoTumblr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.078 20.953c-2.692 0-4.699-1.385-4.699-4.7v-5.308H6.931V8.07c2.694-.699 3.821-3.017 3.95-5.023h2.796v4.558h3.263v3.34h-3.263v4.622c0 1.386.699 1.864 1.813 1.864h1.58v3.522h-2.992z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoTripAdvisor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.31 10.28a2.5 2.5 0 1 0 2.5 2.49 2.5 2.5 0 0 0-2.5-2.49zm0 3.8a1.31 1.31 0 1 1 0-2.61 1.31 1.31 0 1 1 0 2.61zm7.38-3.8a2.5 2.5 0 1 0 2.5 2.49 2.5 2.5 0 0 0-2.5-2.49zM17 12.77a1.31 1.31 0 1 1-1.31-1.3 1.31 1.31 0 0 1 1.31 1.3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm7.38 10.77a3.69 3.69 0 0 1-6.2 2.71L12 16.77l-1.18-1.29a3.69 3.69 0 1 1-5-5.44l-1.2-1.3H7.3a8.33 8.33 0 0 1 9.41 0h2.67l-1.2 1.31a3.71 3.71 0 0 1 1.2 2.72z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.77 9.05a7.19 7.19 0 0 0-5.54 0A4.06 4.06 0 0 1 12 12.7a4.08 4.08 0 0 1 2.77-3.65z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoTrello(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.75 3H5.25A2.25 2.25 0 0 0 3 5.25v13.5A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V5.25A2.25 2.25 0 0 0 18.75 3zm-7.92 13.635a1.08 1.08 0 0 1-1.08 1.08H6.42a1.08 1.08 0 0 1-1.08-1.08V6.42c0-.597.483-1.08 1.08-1.08h3.33c.596 0 1.08.483 1.08 1.08v10.215zm7.83-4.5a1.08 1.08 0 0 1-1.08 1.08h-3.33a1.08 1.08 0 0 1-1.08-1.08V6.42c0-.597.484-1.08 1.08-1.08h3.33c.597 0 1.08.483 1.08 1.08v5.715z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoTiktok(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoTelegram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.665 3.717-17.73 6.837c-1.21.486-1.203 1.161-.222 1.462l4.552 1.42 10.532-6.645c.498-.303.953-.14.579.192l-8.533 7.701h-.002l.002.001-.314 4.692c.46 0 .663-.211.921-.46l2.211-2.15 4.599 3.397c.848.467 1.457.227 1.668-.785l3.019-14.228c.309-1.239-.473-1.8-1.282-1.434z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoTailwindCss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 9.51a4.22 4.22 0 0 1-1.91-1.34A5.77 5.77 0 0 0 12 6a4.72 4.72 0 0 0-5 4 3.23 3.23 0 0 1 3.5-1.49 4.32 4.32 0 0 1 1.91 1.35A5.77 5.77 0 0 0 17 12a4.72 4.72 0 0 0 5-4 3.2 3.2 0 0 1-3.5 1.51zm-13 4.98a4.22 4.22 0 0 1 1.91 1.34A5.77 5.77 0 0 0 12 18a4.72 4.72 0 0 0 5-4 3.23 3.23 0 0 1-3.5 1.49 4.32 4.32 0 0 1-1.91-1.35A5.8 5.8 0 0 0 7 12a4.72 4.72 0 0 0-5 4 3.2 3.2 0 0 1 3.5-1.51z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoStripe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.479 9.883c-1.626-.604-2.512-1.067-2.512-1.803 0-.622.511-.977 1.423-.977 1.667 0 3.379.642 4.558 1.22l.666-4.111c-.935-.446-2.847-1.177-5.49-1.177-1.87 0-3.425.489-4.536 1.401-1.155.954-1.757 2.334-1.757 4 0 3.023 1.847 4.312 4.847 5.403 1.936.688 2.579 1.178 2.579 1.934 0 .732-.629 1.155-1.762 1.155-1.403 0-3.716-.689-5.231-1.578l-.674 4.157c1.304.732 3.705 1.488 6.197 1.488 1.976 0 3.624-.467 4.735-1.356 1.245-.977 1.89-2.422 1.89-4.289 0-3.091-1.889-4.38-4.935-5.468h.002z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSteam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.21 17.32 7 16.8a2.13 2.13 0 1 0 1.17-2.93l1.28.53a1.58 1.58 0 0 1-1.22 2.92z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 0 0-10 9.34l5.38 2.21a2.31 2.31 0 0 1 .47-.24A2.62 2.62 0 0 1 9 13.1l2.44-3.56a3.8 3.8 0 1 1 3.8 3.8h-.08l-3.51 2.5a2.77 2.77 0 0 1-5.47.68l-3.77-1.6A10 10 0 1 0 12 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.79 9.5a2.53 2.53 0 1 0-2.53 2.5 2.54 2.54 0 0 0 2.53-2.5zm-4.42 0a1.9 1.9 0 1 1 1.9 1.91 1.9 1.9 0 0 1-1.9-1.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoStackOverflow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.24 19.399v-4.804h1.6V21H4.381v-6.405h1.598v4.804H17.24zM7.582 17.8h8.055v-1.604H7.582V17.8zm.195-3.64 7.859 1.641.34-1.552-7.861-1.642-.338 1.553zm1.018-3.794 7.281 3.398.678-1.463-7.281-3.399-.678 1.454v.01zm2.037-3.589 6.166 5.142 1.018-1.216-6.162-5.14-1.016 1.213-.006.001zm3.982-3.778-1.311.969 4.803 6.454 1.313-.971-4.807-6.452h.002z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSquarespace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.886 9.264c-1.502-1.5-3.941-1.5-5.475 0l-6.13 6.131a.981.981 0 0 0 0 1.377.982.982 0 0 0 1.376 0l6.13-6.131a1.925 1.925 0 0 1 2.722 2.723l-6.037 6.035c.751.75 1.971.75 2.723 0l4.66-4.66c1.531-1.534 1.531-3.973.031-5.475zm-2.064 2.033a.982.982 0 0 0-1.376 0l-6.134 6.162c-.751.75-1.97.75-2.72 0-.376-.375-1.002-.375-1.377 0s-.375 1.002 0 1.375c1.502 1.502 3.942 1.502 5.475 0l6.131-6.129c.375-.406.375-1.033.001-1.408zm-2.035-6.129c-1.501-1.502-3.941-1.502-5.475 0l-6.131 6.129a.98.98 0 0 0 0 1.375.98.98 0 0 0 1.377 0l6.168-6.129a1.934 1.934 0 0 1 2.727 0 .982.982 0 0 0 1.376 0c.352-.406.352-1-.024-1.375h-.018zm-2.063 2.031a.978.978 0 0 0-1.376 0l-6.131 6.164a1.933 1.933 0 0 1-2.723 0 1.927 1.927 0 0 1 0-2.723l6.037-6.039a1.928 1.928 0 0 0-2.722 0L3.118 9.264c-1.501 1.502-1.501 3.941 0 5.475 1.501 1.502 3.94 1.502 5.475 0l6.129-6.131c.377-.408.377-1.033 0-1.408h.002z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSpringBoot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.205 16.392c-2.469 3.289-7.741 2.179-11.122 2.338 0 0-.599.034-1.201.133 0 0 .228-.097.519-.198 2.374-.821 3.496-.986 4.939-1.727 2.71-1.388 5.408-4.413 5.957-7.555-1.032 3.022-4.17 5.623-7.027 6.679-1.955.722-5.492 1.424-5.493 1.424a5.28 5.28 0 0 1-.143-.076c-2.405-1.17-2.475-6.38 1.894-8.059 1.916-.736 3.747-.332 5.818-.825 2.208-.525 4.766-2.18 5.805-4.344 1.165 3.458 2.565 8.866.054 12.21zm.042-13.28a9.212 9.212 0 0 1-1.065 1.89 9.982 9.982 0 0 0-7.167-3.031C6.492 1.971 2 6.463 2 11.985a9.983 9.983 0 0 0 3.205 7.334l.22.194a.856.856 0 1 1 .001.001l.149.132A9.96 9.96 0 0 0 12.015 22c5.278 0 9.613-4.108 9.984-9.292.274-2.539-.476-5.763-1.752-9.596"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSpotify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 2.019c-5.495 0-9.991 4.496-9.991 9.991 0 5.494 4.496 9.99 9.991 9.99 5.494 0 9.99-4.496 9.99-9.99 0-5.495-4.446-9.991-9.99-9.991zm4.595 14.436c-.199.299-.549.4-.85.201-2.349-1.45-5.296-1.75-8.793-.951-.348.102-.648-.148-.748-.449-.101-.35.149-.648.45-.749 3.795-.85 7.093-.499 9.69 1.1.35.149.4.548.251.848zm1.2-2.747c-.251.349-.7.499-1.051.249-2.697-1.646-6.792-2.148-9.939-1.148-.398.101-.85-.1-.949-.498-.101-.402.1-.852.499-.952 3.646-1.098 8.143-.548 11.239 1.351.3.149.45.648.201.998zm.099-2.799c-3.197-1.897-8.542-2.097-11.59-1.146a.938.938 0 0 1-1.148-.6.937.937 0 0 1 .599-1.151c3.547-1.049 9.392-.85 13.089 1.351.449.249.599.849.349 1.298-.25.35-.849.498-1.299.248z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSoundcloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.971 12.188c-.041 0-.078.038-.083.082l-.194 1.797.194 1.756c.005.049.042.082.083.082s.075-.033.084-.082l.211-1.756-.225-1.797c0-.046-.037-.082-.074-.082m-.75.691c-.051 0-.076.03-.088.079l-.138 1.109.138 1.092c0 .046.037.078.075.078.039 0 .073-.038.087-.087l.176-1.1-.176-1.112c0-.051-.037-.076-.075-.076m1.526-1.025c-.052 0-.1.039-.1.087l-.176 2.139.188 2.051c0 .049.037.1.099.1.052 0 .089-.051.102-.1l.211-2.064-.211-2.126c-.013-.049-.052-.1-.102-.1m.79-.075c-.063 0-.114.051-.126.113l-.161 2.201.177 2.123c.012.063.061.114.122.114.064 0 .113-.051.125-.124l.201-2.113-.201-2.187a.11.11 0 0 0-.111-.112l-.026-.015zm.962.301a.128.128 0 0 0-.133-.125.134.134 0 0 0-.137.125l-.182 2.026.169 2.138a.13.13 0 0 0 .132.131c.062 0 .123-.055.123-.132l.189-2.139-.189-2.036.028.012zm.674-1.426a.154.154 0 0 0-.148.15l-.176 3.3.156 2.139c0 .077.066.137.15.137.078 0 .145-.074.15-.15l.174-2.137-.173-3.313c-.007-.088-.074-.152-.15-.152m.8-.762a.178.178 0 0 0-.17.163l-.15 4.063.138 2.125c0 .1.075.174.163.174.086 0 .161-.074.174-.174l.162-2.125-.161-4.052c-.013-.1-.088-.175-.175-.175m.826-.372c-.102 0-.176.073-.188.173l-.139 4.4.139 2.102c.012.1.086.188.188.188a.193.193 0 0 0 .187-.188l.163-2.102-.164-4.4c0-.1-.087-.188-.188-.188m1.038.038a.196.196 0 0 0-.199-.199.205.205 0 0 0-.201.199l-.125 4.538.124 2.089c.015.111.101.199.214.199s.201-.088.201-.199l.136-2.089-.136-4.55-.014.012zm.625-.111c-.113 0-.213.1-.213.211l-.125 4.439.125 2.063c0 .125.1.213.213.213a.221.221 0 0 0 .214-.224l.125-2.064-.14-4.428c0-.122-.1-.225-.225-.225m.838.139a.236.236 0 0 0-.237.237l-.086 4.29.113 2.063c0 .124.1.231.236.231.125 0 .227-.1.237-.237l.101-2.038-.112-4.265c-.01-.137-.113-.238-.237-.238m.988-.786a.27.27 0 0 0-.139-.037c-.05 0-.1.013-.137.037a.25.25 0 0 0-.125.214v.05l-.086 5.044.096 2.043v.007c.006.05.024.112.06.15.05.051.12.086.196.086a.28.28 0 0 0 .175-.074.262.262 0 0 0 .076-.188l.013-.201.097-1.838-.113-5.075a.24.24 0 0 0-.111-.199l-.002-.019zm.837-.457a.155.155 0 0 0-.124-.052.283.283 0 0 0-.174.052.265.265 0 0 0-.1.201v.023l-.114 5.513.063 1.014.052.988a.274.274 0 0 0 .548-.012l.125-2.013-.125-5.536a.273.273 0 0 0-.138-.231m7.452 3.15c-.336 0-.663.072-.949.193a4.34 4.34 0 0 0-5.902-3.651c-.188.075-.227.151-.238.301v7.812a.31.31 0 0 0 .275.29h6.827a2.428 2.428 0 0 0 2.45-2.438 2.457 2.457 0 0 0-2.45-2.463"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSnapchat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.166 3c.796 0 3.495.223 4.769 3.073.426.959.324 2.589.24 3.898l-.002.047c-.011.146-.018.278-.024.41a.62.62 0 0 0 .322.072c.241-.013.53-.096.831-.241a.81.81 0 0 1 .373-.084c.146 0 .289.023.409.072.361.12.59.385.59.674.013.361-.313.675-.975.939-.071.023-.169.061-.276.096-.363.109-.917.289-1.073.651-.072.181-.049.421.098.697l.012.013c.048.109 1.228 2.795 3.854 3.229a.401.401 0 0 1 .337.409c0 .06-.013.119-.036.181-.193.457-1.023.795-2.53 1.021-.047.073-.096.302-.132.459-.022.144-.06.289-.107.444-.061.218-.217.325-.446.325h-.024a2.45 2.45 0 0 1-.433-.059 4.799 4.799 0 0 0-1.024-.108c-.24 0-.48.012-.732.06-.483.084-.904.373-1.386.71-.687.481-1.469 1.036-2.649 1.036-.048 0-.096-.012-.146-.012h-.119c-1.181 0-1.951-.543-2.637-1.036-.481-.338-.89-.626-1.373-.711a5.507 5.507 0 0 0-.745-.06c-.435 0-.771.072-1.023.12-.17.035-.314.059-.435.059a.45.45 0 0 1-.47-.337c-.048-.154-.071-.313-.107-.456-.038-.146-.085-.396-.133-.458-1.543-.179-2.373-.517-2.565-.986a.473.473 0 0 1-.044-.181.398.398 0 0 1 .337-.409c2.625-.434 3.805-3.119 3.854-3.232l.013-.023c.145-.277.18-.52.096-.699-.156-.349-.711-.529-1.07-.65a1.759 1.759 0 0 1-.279-.096c-.89-.35-1.011-.748-.962-1.024.072-.384.541-.637.939-.637.117 0 .217.023.308.06.337.155.635.241.888.241a.742.742 0 0 0 .373-.085l-.041-.458c-.08-1.307-.182-2.935.247-3.889 1.236-2.836 3.929-3.054 4.724-3.054L12.117 3h.049z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSlack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.194 14.644c0 1.16-.943 2.107-2.103 2.107a2.11 2.11 0 0 1-2.104-2.107 2.11 2.11 0 0 1 2.104-2.106h2.103v2.106zm1.061 0c0-1.16.944-2.106 2.104-2.106a2.11 2.11 0 0 1 2.103 2.106v5.274a2.11 2.11 0 0 1-2.103 2.106 2.108 2.108 0 0 1-2.104-2.106v-5.274zm2.104-8.455c-1.16 0-2.104-.948-2.104-2.107s.944-2.106 2.104-2.106a2.11 2.11 0 0 1 2.103 2.106v2.107H9.359zm0 1.06a2.11 2.11 0 0 1 2.103 2.107 2.11 2.11 0 0 1-2.103 2.106H4.092a2.11 2.11 0 0 1-2.104-2.106 2.11 2.11 0 0 1 2.104-2.107h5.267zm8.447 2.107c0-1.16.943-2.107 2.103-2.107a2.11 2.11 0 0 1 2.104 2.107 2.11 2.11 0 0 1-2.104 2.106h-2.103V9.356zm-1.061 0c0 1.16-.944 2.106-2.104 2.106a2.11 2.11 0 0 1-2.103-2.106V4.082a2.11 2.11 0 0 1 2.103-2.106c1.16 0 2.104.946 2.104 2.106v5.274zm-2.104 8.455c1.16 0 2.104.948 2.104 2.107s-.944 2.106-2.104 2.106a2.11 2.11 0 0 1-2.103-2.106v-2.107h2.103zm0-1.06a2.11 2.11 0 0 1-2.103-2.107 2.11 2.11 0 0 1 2.103-2.106h5.268a2.11 2.11 0 0 1 2.104 2.106 2.11 2.11 0 0 1-2.104 2.107h-5.268z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSlackOld(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.935 12.646a1.617 1.617 0 0 0-2.022-1.034l-1.632.532c-.355-1.099-.735-2.268-1.092-3.365l.006-.002-.004-.008 1.613-.523a1.62 1.62 0 0 0 1.035-2.023 1.62 1.62 0 0 0-2.025-1.034l-1.621.527-.519-1.604a1.619 1.619 0 0 0-2.024-1.034 1.618 1.618 0 0 0-1.033 2.024l.522 1.609-3.368 1.092-.524-1.611a1.618 1.618 0 0 0-2.022-1.034 1.617 1.617 0 0 0-1.034 2.023l.524 1.616-1.662.541a1.602 1.602 0 0 0-.988 1.95c.25.856 1.152 1.373 1.979 1.092.006 0 .658-.209 1.665-.536l1.099 3.386h-.002v.002l-1.67.545a1.599 1.599 0 0 0-.987 1.949c.25.857 1.15 1.374 1.979 1.093.007 0 .659-.211 1.665-.538l.003.005a.024.024 0 0 0 .008-.002l.539 1.657a1.6 1.6 0 0 0 1.949.989c.857-.25 1.373-1.151 1.094-1.979 0-.006-.209-.654-.533-1.654l-.003-.009c1.104-.358 2.276-.739 3.376-1.098l.543 1.668a1.602 1.602 0 0 0 1.949.989c.856-.251 1.374-1.152 1.092-1.979 0-.007-.209-.659-.535-1.663l.019-.006-.003-.007 1.609-.522a1.62 1.62 0 0 0 1.035-2.024zM10.86 14.238l-1.097-3.377a.02.02 0 0 0 .005-.001v-.006c1.098-.356 2.268-.735 3.363-1.092l1.098 3.377-3.369 1.099z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSkype(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.857 17.417c-2.947 0-4.294-1.524-4.294-2.641 0-.266.108-.521.298-.705a.946.946 0 0 1 .71-.264c1.261 0 .931 1.92 3.286 1.92 1.203 0 1.91-.736 1.91-1.425 0-.415-.234-.889-1.028-1.079l-2.629-.673c-2.111-.545-2.479-1.737-2.479-2.842 0-2.293 2.068-3.124 4.036-3.124 1.814 0 3.97 1.016 3.97 2.391 0 .592-.488.91-1.055.91-1.078 0-.897-1.536-3.063-1.536-1.077 0-1.645.513-1.645 1.23s.839.96 1.574 1.123l1.941.445c2.126.486 2.691 1.751 2.691 2.963 0 1.865-1.423 3.305-4.226 3.305m8.139-3.942c.086-.49.128-.986.128-1.482a8.472 8.472 0 0 0-2.952-6.474 8.211 8.211 0 0 0-6.788-1.856A4.818 4.818 0 0 0 7.935 3a4.954 4.954 0 0 0-4.27 2.519 5.103 5.103 0 0 0-.015 5.011 8.51 8.51 0 0 0 2.282 7.453 8.23 8.23 0 0 0 7.333 2.355 4.823 4.823 0 0 0 2.443.662 4.954 4.954 0 0 0 4.269-2.518 5.095 5.095 0 0 0 .016-5.009"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSketch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.42 9.87 12 20.78l5.58-10.91H6.42zM5.9 4.01 2 9.24h3.62l.28-5.23zm6.1-.59L6.63 9.24h10.74L12 3.42zM2.04 9.87l9.09 10.58L5.72 9.87H2.04zM11.53 3h-.15l-4.84.51a.09.09 0 0 1 0 .05l-.27 5.15zm1.34 17.45 9.09-10.58h-3.68l-5.41 10.58zm4.58-16.87a.09.09 0 0 1 0-.05l-4-.42-1-.11 5.26 5.71zm.65.43.28 5.23H22l-2.22-2.98-1.68-2.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoShopify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.49 20.937 5.381-1.166S17.93 6.633 17.914 6.546c-.016-.086-.086-.144-.158-.144s-1.439-.101-1.439-.101-.949-.949-1.064-1.05c-.027-.029-.057-.043-.086-.058l-.677 15.744zm.446-15.772c-.016 0-.043.014-.057.014-.016 0-.217.059-.533.158-.318-.919-.879-1.768-1.871-1.768h-.086c-.289-.361-.633-.519-.936-.519-2.316 0-3.426 2.892-3.77 4.359-.892.275-1.538.476-1.613.505-.504.158-.517.172-.574.648-.057.344-1.367 10.489-1.367 10.489l10.117 1.899.69-15.785zm-2.635.704v.102c-.559.173-1.178.36-1.783.547.346-1.323.992-1.972 1.553-2.217.146.375.23.878.23 1.568zm-.92-2.2c.1 0 .201.028.303.102-.732.344-1.539 1.222-1.871 2.978a59.11 59.11 0 0 1-1.411.432c.389-1.339 1.325-3.512 2.979-3.512zm.402 7.812s-.604-.315-1.322-.315c-1.08 0-1.123.676-1.123.849 0 .921 2.418 1.28 2.418 3.453 0 1.712-1.08 2.806-2.547 2.806-1.756 0-2.648-1.094-2.648-1.094l.475-1.554s.922.792 1.697.792a.693.693 0 0 0 .721-.69c0-1.209-1.986-1.268-1.986-3.252 0-1.669 1.195-3.295 3.627-3.295.936 0 1.395.272 1.395.272l-.707 2.028zm.922-7.281c.518.06.85.648 1.064 1.311-.258.087-.547.173-.863.273v-.187c0-.561-.072-1.022-.201-1.397z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoSass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c5.522 0 10 4.478 10 10s-4.478 10-10 10S2 17.522 2 12 6.478 2 12 2zm-1.987 13.332c.146.537.13 1.039-.021 1.493l-.054.15a2.803 2.803 0 0 1-.527.821c-.582.633-1.394.872-1.742.671-.375-.219-.188-1.112.487-1.825.726-.765 1.766-1.258 1.766-1.258v-.002l.091-.05zm8.258-9.051c-.452-1.777-3.397-2.362-6.185-1.371-1.656.589-3.453 1.515-4.743 2.723-1.536 1.434-1.78 2.684-1.68 3.206.355 1.843 2.881 3.048 3.92 3.942v.005c-.307.149-2.548 1.274-3.072 2.438-.563 1.225.088 2.101.513 2.212 1.313.363 2.662-.3 3.388-1.374.699-1.051.638-2.4.337-3.063.413-.112.899-.162 1.524-.086 1.751.199 2.101 1.3 2.024 1.75-.074.449-.436.711-.561.786-.126.076-.163.101-.151.151.013.074.076.074.175.063.138-.025.914-.375.951-1.227.037-1.074-.988-2.273-2.813-2.25-.75.014-1.226.076-1.563.214a.295.295 0 0 0-.088-.088c-1.125-1.213-3.213-2.063-3.125-3.675.025-.588.237-2.137 4-4.012 3.088-1.538 5.551-1.112 5.977-.175.61 1.336-1.314 3.825-4.526 4.187-1.225.138-1.862-.337-2.026-.513-.174-.188-.198-.2-.261-.161-.101.05-.038.212 0 .313.1.249.487.688 1.163.912.587.188 2.024.299 3.75-.375 1.937-.749 3.449-2.838 3.012-4.588l.06.056z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoRedux(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.661 15.549a1.315 1.315 0 0 0 1.185-1.386 1.363 1.363 0 0 0-1.35-1.302h-.048a1.352 1.352 0 0 0-1.303 1.397c.024.379.179.687.391.911-.827 1.609-2.07 2.794-3.954 3.788-1.266.663-2.604.912-3.905.734-1.089-.153-1.94-.64-2.463-1.421-.78-1.185-.852-2.462-.201-3.74a5.597 5.597 0 0 1 1.658-1.931 7.88 7.88 0 0 1-.331-1.218c-3.506 2.51-3.148 5.942-2.084 7.564.794 1.184 2.415 1.941 4.19 1.941.474 0 .972-.035 1.457-.154 3.077-.592 5.409-2.438 6.747-5.16l.011-.023z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.887 12.589c-1.834-2.154-4.533-3.337-7.611-3.337h-.403c-.2-.438-.661-.711-1.183-.711h-.036c-.744 0-1.325.64-1.301 1.385.023.71.627 1.302 1.35 1.302h.059a1.332 1.332 0 0 0 1.183-.828h.439c1.824 0 3.551.532 5.126 1.574 1.206.792 2.072 1.834 2.557 3.077.425 1.019.402 2.013-.035 2.843-.675 1.302-1.812 1.988-3.314 1.988-.947 0-1.871-.296-2.345-.509-.283.235-.758.626-1.102.863 1.042.473 2.096.746 3.113.746 2.309 0 4.023-1.302 4.676-2.557.709-1.422.651-3.813-1.161-5.859l-.012.023z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.647 15.975c.023.71.626 1.302 1.35 1.302h.048a1.334 1.334 0 0 0 1.302-1.397c0-.71-.616-1.301-1.338-1.301h-.048c-.048 0-.118 0-.178.022-.982-1.657-1.397-3.434-1.242-5.349.094-1.445.567-2.7 1.42-3.742.71-.888 2.048-1.326 2.96-1.35 2.556-.048 3.622 3.138 3.704 4.404l1.184.354C16.536 5.036 14.122 3 11.813 3 9.647 3 7.647 4.574 6.842 6.884c-1.102 3.077-.379 6.036.971 8.404-.118.154-.189.426-.166.687z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoReddit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.67",
                    "cy": "13",
                    "r": "1.001"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.09 15.391A3.28 3.28 0 0 1 12 16a3.271 3.271 0 0 1-2.081-.63.27.27 0 0 0-.379.38c.71.535 1.582.809 2.471.77a3.811 3.811 0 0 0 2.469-.77v.04a.284.284 0 0 0 .006-.396.28.28 0 0 0-.396-.003zm.209-3.351a1 1 0 0 0 0 2l-.008.039c.016.002.033 0 .051 0a1 1 0 0 0 .958-1.038 1 1 0 0 0-1.001-1.001z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.479 2 2 6.477 2 12c0 5.521 4.479 10 10 10s10-4.479 10-10c0-5.523-4.479-10-10-10zm5.859 11.33c.012.146.012.293 0 .439 0 2.24-2.609 4.062-5.83 4.062s-5.83-1.82-5.83-4.062a2.681 2.681 0 0 1 0-.439 1.46 1.46 0 0 1-.455-2.327 1.458 1.458 0 0 1 2.063-.063 7.145 7.145 0 0 1 3.899-1.23l.743-3.47v-.004A.313.313 0 0 1 12.82 6l2.449.49a1.001 1.001 0 1 1-.131.61L13 6.65l-.649 3.12a7.123 7.123 0 0 1 3.85 1.23 1.46 1.46 0 0 1 2.469 1c.01.563-.307 1.08-.811 1.33z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoRedbubble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.002 2.005 12 2.004c-5.52 0-9.996 4.475-9.996 9.995 0 5.521 4.477 9.998 9.996 9.998 5.521 0 9.996-4.475 9.996-9.997 0-5.52-4.475-9.995-9.994-9.995zm.162 13.53a.267.267 0 0 1-.174.066v.001H6.455a.268.268 0 0 1-.266-.268V8.646c0-.148.119-.268.266-.268h2.589c1.612 0 2.576.87 2.576 2.327 0 .969-.486 1.729-1.272 2.039l1.842 2.413a.269.269 0 0 1-.026.378zm3.695.068h-2.665a.268.268 0 0 1-.266-.269V8.646c0-.148.119-.267.266-.267h2.472c1.853 0 2.242 1.091 2.242 2.007 0 .529-.141.949-.421 1.258.681.28 1.047.913 1.047 1.827 0 1.335-1.001 2.132-2.675 2.132z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoReact(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11.245",
                    "r": "1.785"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.002 14.794-.395-.101c-2.934-.741-4.617-2.001-4.617-3.452 0-1.452 1.684-2.711 4.617-3.452l.395-.1.111.391a19.507 19.507 0 0 0 1.136 2.983l.085.178-.085.178c-.46.963-.841 1.961-1.136 2.985l-.111.39zm-.577-6.095c-2.229.628-3.598 1.586-3.598 2.542 0 .954 1.368 1.913 3.598 2.54.273-.868.603-1.717.985-2.54a20.356 20.356 0 0 1-.985-2.542zm10.572 6.095-.11-.392a19.628 19.628 0 0 0-1.137-2.984l-.085-.177.085-.179c.46-.961.839-1.96 1.137-2.984l.11-.39.395.1c2.935.741 4.617 2 4.617 3.453 0 1.452-1.683 2.711-4.617 3.452l-.395.101zm-.41-3.553c.4.866.733 1.718.987 2.54 2.23-.627 3.599-1.586 3.599-2.54 0-.956-1.368-1.913-3.599-2.542a20.683 20.683 0 0 1-.987 2.542z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.419 8.695-.11-.39c-.826-2.908-.576-4.991.687-5.717 1.235-.715 3.222.13 5.303 2.265l.284.292-.284.291a19.718 19.718 0 0 0-2.02 2.474l-.113.162-.196.016a19.646 19.646 0 0 0-3.157.509l-.394.098zm1.582-5.529c-.224 0-.422.049-.589.145-.828.477-.974 2.138-.404 4.38.891-.197 1.79-.338 2.696-.417a21.058 21.058 0 0 1 1.713-2.123c-1.303-1.267-2.533-1.985-3.416-1.985zm7.997 16.984c-1.188 0-2.714-.896-4.298-2.522l-.283-.291.283-.29a19.827 19.827 0 0 0 2.021-2.477l.112-.16.194-.019a19.473 19.473 0 0 0 3.158-.507l.395-.1.111.391c.822 2.906.573 4.992-.688 5.718a1.978 1.978 0 0 1-1.005.257zm-3.415-2.82c1.302 1.267 2.533 1.986 3.415 1.986.225 0 .423-.05.589-.145.829-.478.976-2.142.404-4.384-.89.198-1.79.34-2.698.419a20.526 20.526 0 0 1-1.71 2.124z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.58 8.695-.395-.099a19.477 19.477 0 0 0-3.158-.509l-.194-.017-.112-.162A19.551 19.551 0 0 0 11.7 5.434l-.283-.291.283-.29c2.08-2.134 4.066-2.979 5.303-2.265 1.262.727 1.513 2.81.688 5.717l-.111.39zm-3.287-1.421c.954.085 1.858.228 2.698.417.571-2.242.425-3.903-.404-4.381-.824-.477-2.375.253-4.004 1.841.616.67 1.188 1.378 1.71 2.123zM8.001 20.15a1.983 1.983 0 0 1-1.005-.257c-1.263-.726-1.513-2.811-.688-5.718l.108-.391.395.1c.964.243 2.026.414 3.158.507l.194.019.113.16c.604.878 1.28 1.707 2.02 2.477l.284.29-.284.291c-1.583 1.627-3.109 2.522-4.295 2.522zm-.993-5.362c-.57 2.242-.424 3.906.404 4.384.825.47 2.371-.255 4.005-1.842a21.17 21.17 0 0 1-1.713-2.123 20.692 20.692 0 0 1-2.696-.419z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15.313c-.687 0-1.392-.029-2.1-.088l-.196-.017-.113-.162a25.697 25.697 0 0 1-1.126-1.769 26.028 26.028 0 0 1-.971-1.859l-.084-.177.084-.179c.299-.632.622-1.252.971-1.858.347-.596.726-1.192 1.126-1.77l.113-.16.196-.018a25.148 25.148 0 0 1 4.198 0l.194.019.113.16a25.136 25.136 0 0 1 2.1 3.628l.083.179-.083.177a24.742 24.742 0 0 1-2.1 3.628l-.113.162-.194.017c-.706.057-1.412.087-2.098.087zm-1.834-.904c1.235.093 2.433.093 3.667 0a24.469 24.469 0 0 0 1.832-3.168 23.916 23.916 0 0 0-1.832-3.168 23.877 23.877 0 0 0-3.667 0 23.743 23.743 0 0 0-1.832 3.168 24.82 24.82 0 0 0 1.832 3.168z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoQuora(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.555 17.025c-.624-1.227-1.354-2.465-2.781-2.465-.271 0-.546.046-.795.157l-.484-.967c.59-.509 1.544-.911 2.77-.911 1.908 0 2.889.922 3.667 2.094.459-1.001.678-2.354.678-4.03 0-4.188-1.308-6.336-4.366-6.336-3.014 0-4.318 2.148-4.318 6.336 0 4.164 1.305 6.291 4.318 6.291.478 0 .913-.051 1.311-.169zm.747 1.461a7.977 7.977 0 0 1-2.059.274c-4.014 0-7.941-3.202-7.941-7.858C3.303 6.203 7.229 3 11.243 3c4.081 0 7.972 3.179 7.972 7.903 0 2.628-1.226 4.763-3.007 6.143.572.861 1.157 1.436 1.988 1.436.899 0 1.261-.687 1.328-1.236h1.167c.07.73-.301 3.754-3.574 3.754-1.989 0-3.035-1.146-3.822-2.496l.007-.018z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoPython(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.585 11.692h4.328s2.432.039 2.432-2.35V5.391S16.714 3 11.936 3C7.362 3 7.647 4.983 7.647 4.983l.006 2.055h4.363v.617H5.92s-2.927-.332-2.927 4.282 2.555 4.45 2.555 4.45h1.524v-2.141s-.083-2.554 2.513-2.554zm-.056-5.74a.784.784 0 1 1 0-1.57.784.784 0 1 1 0 1.57z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.452 7.532h-1.524v2.141s.083 2.554-2.513 2.554h-4.328s-2.432-.04-2.432 2.35v3.951s-.369 2.391 4.409 2.391c4.573 0 4.288-1.983 4.288-1.983l-.006-2.054h-4.363v-.617h6.097s2.927.332 2.927-4.282-2.555-4.451-2.555-4.451zm-3.981 10.436a.784.784 0 1 1 0 1.57.784.784 0 1 1 0-1.57z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoProductHunt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.337 9h-2.838v3h2.838a1.501 1.501 0 1 0 0-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm1.337 12h-2.838v3H8.501V7h4.837a3.498 3.498 0 0 1 3.499 3.499 3.499 3.499 0 0 1-3.5 3.501z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoPostgresql(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.74 12.89v-.11c.06-.15.12-.29.19-.43a5.15 5.15 0 0 0 .26-3.74.86.86 0 0 0-.66-.74 3.12 3.12 0 0 0-2.08.61v.18a11.34 11.34 0 0 1-.06 2.41 2.37 2.37 0 0 0 .62 2 2 2 0 0 0 1.43.63 8.05 8.05 0 0 1 .3-.81zM10 8.58a.36.36 0 0 1-.09-.23.19.19 0 0 1 .09-.12.74.74 0 0 1 .48-.07c.25 0 .5.16.48.34a.51.51 0 0 1-.49.33h-.06a.63.63 0 0 1-.41-.25z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 11a12.58 12.58 0 0 0 .06-2.3v-.28a7 7 0 0 1 1.54-4.55c-1-.32-3.4-1-4.87.1-.9.64-1.32 1.84-1.23 3.55a24.85 24.85 0 0 0 1 4.4c.68 2.22 1.45 3.62 2.11 3.85.1 0 .41.13.86-.41.64-.76 1.23-1.41 1.5-1.7l-.19-.19A2.89 2.89 0 0 1 7.88 11zm3.5 3.4c-.16-.06-.24-.1-.42.11a2.52 2.52 0 0 0-.29.35c-.35.43-.5.58-1.51.79a2 2 0 0 0-.4.11 1 1 0 0 0 .37.16 2.21 2.21 0 0 0 2.5-.8.41.41 0 0 0 0-.35.59.59 0 0 0-.25-.37zm6.29-5.82a5.29 5.29 0 0 0 .08-.79c-.66-.08-1.42-.07-1.72.36-.58.83.56 2.88 1 3.75a4.34 4.34 0 0 1 .26.48 1.79 1.79 0 0 0 .15.31 3.72 3.72 0 0 0 .16-2.13 7.51 7.51 0 0 1-.07-1.05 6 6 0 0 1 .14-.93zm-.56-.16a.6.6 0 0 1-.32.17h-.06a.47.47 0 0 1-.44-.3c0-.14.2-.24.44-.28s.48 0 .5.15a.38.38 0 0 1-.12.26z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4.88a6.06 6.06 0 0 1 1.37 2.57.71.71 0 0 1 0 .15 5.67 5.67 0 0 1-.09 1.06 7.11 7.11 0 0 0-.09.86 6.61 6.61 0 0 0 .07 1 4 4 0 0 1-.36 2.71l.07.08c2.22-3.49 3-7.54 2.29-8.43a4.77 4.77 0 0 0-3.81-1.8 7.34 7.34 0 0 0-1.63.16A6.17 6.17 0 0 1 17 4.88z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.65 14c-.07-.2-.37-.85-1.47-.62a6.28 6.28 0 0 1-1 .13 19.74 19.74 0 0 0 2.06-4.88c.37-1.45.66-3.39-.11-4.38A5.91 5.91 0 0 0 16.37 2a8.44 8.44 0 0 0-2.46.35 9.38 9.38 0 0 0-1.45-.14 4.8 4.8 0 0 0-2.46.62 12.22 12.22 0 0 0-1.77-.44A5.44 5.44 0 0 0 4 3.05c-1.24.87-1.81 2.39-1.71 4.52a26.28 26.28 0 0 0 1 4.67A15.76 15.76 0 0 0 4.4 15a3.39 3.39 0 0 0 1.75 1.83 1.71 1.71 0 0 0 1.69-.37 2 2 0 0 0 1 .59 3.65 3.65 0 0 0 2.35-.14v.81a8.46 8.46 0 0 0 .31 2.36 1 1 0 0 1 0 .13 3 3 0 0 0 .71 1.24 2.08 2.08 0 0 0 1.49.56 3 3 0 0 0 .7-.08 3.27 3.27 0 0 0 2.21-1.27 7.34 7.34 0 0 0 .91-4v-.26h.17a5.24 5.24 0 0 0 2.4-.4c.45-.23 1.91-1 1.56-2zm-1.81 1.47a4.7 4.7 0 0 1-1.8.34 2.62 2.62 0 0 1-.79-.1c-.1.94-.32 2.69-.45 3.42a2.47 2.47 0 0 1-2.25 2.3 3.23 3.23 0 0 1-.66.07A2 2 0 0 1 12 20a16.77 16.77 0 0 1-.28-4.06 2.56 2.56 0 0 1-1.78.66 3.94 3.94 0 0 1-.94-.13c-.09 0-.87-.23-.86-.73s.66-.59.9-.64c.86-.18.92-.25 1.19-.59a2.79 2.79 0 0 1 .19-.24 2.56 2.56 0 0 1-1.11-.3c-.23.25-.86.93-1.54 1.74a1.43 1.43 0 0 1-1.11.63 1.23 1.23 0 0 1-.35 0C5.43 16 4.6 14.55 3.84 12a25.21 25.21 0 0 1-1-4.53c-.1-1.92.4-3.28 1.47-4 1.92-1.36 5-.31 5.7-.06a4 4 0 0 1 2.41-.66 5.58 5.58 0 0 1 1.4.18 7.51 7.51 0 0 1 2.5-.4 5.35 5.35 0 0 1 4.32 2c.69.88.23 3 0 3.89a18.84 18.84 0 0 1-2.41 5.41c.16.11.65.31 2 0 .46-.1.73 0 .82.25.22.55-.7 1.13-1.21 1.37z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.43 13.59a4 4 0 0 1-.62-1c0-.07-.12-.24-.23-.43-.58-1-1.79-3.22-1-4.34a2.16 2.16 0 0 1 2.12-.61 6.28 6.28 0 0 0-1.13-1.94 5.41 5.41 0 0 0-4.13-2 3.34 3.34 0 0 0-2.55.95A5.82 5.82 0 0 0 8.51 7.8l.15-.08A3.7 3.7 0 0 1 10 7.3a1.45 1.45 0 0 1 1.76 1.19 5.73 5.73 0 0 1-.29 4.09 3.29 3.29 0 0 0-.17.39v.11c-.1.27-.19.52-.25.73a.94.94 0 0 1 .57.07 1.16 1.16 0 0 1 .62.74v.16a.28.28 0 0 1 0 .09 22.22 22.22 0 0 0 .22 4.9 1.5 1.5 0 0 0 2 1.09A1.92 1.92 0 0 0 16.25 19c.15-.88.45-3.35.49-3.88 0-1.06.52-1.27.84-1.36z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 14.33-.08-.06h-.12c-.26.07-.5.14-.47.8a1.9 1.9 0 0 0 .93.12 4.29 4.29 0 0 0 1.38-.29 3 3 0 0 0 .79-.52 3.47 3.47 0 0 1-2.43-.05z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoPocket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.327 3.983H4.746c-.947 0-1.736.726-1.736 1.673v5.396c0 4.892 4.04 8.964 9.026 8.964 4.955 0 8.964-4.072 8.964-8.964V5.656c0-.947-.758-1.673-1.673-1.673zm-2.178 6.691-4.293 4.04c-.221.253-.567.348-.82.348-.315 0-.631-.095-.884-.348l-4.229-4.04c-.441-.473-.504-1.262 0-1.768.475-.441 1.263-.504 1.736 0l3.377 3.251 3.44-3.251c.441-.504 1.23-.441 1.673 0 .442.506.442 1.295 0 1.768z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoPlayStore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.954 11.616 2.957-2.957L6.36 3.291c-.633-.342-1.226-.39-1.746-.016l8.34 8.341zm3.461 3.462 3.074-1.729c.6-.336.929-.812.929-1.34 0-.527-.329-1.004-.928-1.34l-2.783-1.563-3.133 3.132 2.841 2.84zM4.1 4.002c-.064.197-.1.417-.1.658v14.705c0 .381.084.709.236.97l8.097-8.098L4.1 4.002zm8.854 8.855L4.902 20.91c.154.059.32.09.495.09.312 0 .637-.092.968-.276l9.255-5.197-2.666-2.67z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoPinterest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.472 2 2 6.473 2 11.99c0 4.232 2.633 7.85 6.35 9.306-.088-.79-.166-2.006.034-2.868.182-.78 1.172-4.966 1.172-4.966s-.299-.599-.299-1.484c0-1.388.805-2.425 1.808-2.425.853 0 1.264.64 1.264 1.407 0 .858-.546 2.139-.827 3.327-.235.994.499 1.805 1.479 1.805 1.775 0 3.141-1.872 3.141-4.575 0-2.392-1.719-4.064-4.173-4.064-2.843 0-4.512 2.132-4.512 4.335 0 .858.331 1.779.744 2.28a.3.3 0 0 1 .069.286c-.076.315-.245.994-.277 1.133-.044.183-.145.222-.335.134-1.247-.581-2.027-2.405-2.027-3.871 0-3.151 2.289-6.045 6.601-6.045 3.466 0 6.159 2.469 6.159 5.77 0 3.444-2.171 6.213-5.184 6.213-1.013 0-1.964-.525-2.29-1.146l-.623 2.374c-.225.868-.834 1.956-1.241 2.62a10 10 0 0 0 2.958.445c5.517 0 9.99-4.473 9.99-9.99S17.507 2 11.99 2"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoPinterestAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.077 9.457c0-.778.136-1.513.404-2.199a5.63 5.63 0 0 1 1.121-1.802 7.614 7.614 0 0 1 1.644-1.329 7.513 7.513 0 0 1 2.002-.844 8.57 8.57 0 0 1 2.185-.281c1.139 0 2.199.241 3.182.721a6.021 6.021 0 0 1 2.391 2.094c.614.915.919 1.95.919 3.104 0 .692-.068 1.369-.207 2.031a8.28 8.28 0 0 1-.646 1.913 6.605 6.605 0 0 1-1.082 1.617 4.723 4.723 0 0 1-1.568 1.114 4.962 4.962 0 0 1-2.045.417c-.489 0-.977-.115-1.459-.346-.482-.23-.828-.546-1.036-.951-.073.281-.173.687-.306 1.218-.128.53-.214.872-.252 1.027-.04.154-.114.411-.222.767a5.183 5.183 0 0 1-.281.769l-.344.674a7.98 7.98 0 0 1-.498.838c-.181.262-.405.575-.672.935l-.149.053-.099-.108c-.107-1.133-.162-1.811-.162-2.035 0-.663.079-1.407.235-2.233.153-.825.395-1.862.72-3.109.325-1.246.511-1.979.561-2.196-.229-.467-.345-1.077-.345-1.827 0-.599.187-1.16.562-1.688.376-.526.851-.789 1.427-.789.441 0 .783.146 1.028.439.246.292.366.66.366 1.109 0 .476-.158 1.165-.476 2.066-.318.902-.476 1.575-.476 2.022 0 .453.162.832.486 1.129a1.68 1.68 0 0 0 1.179.449c.396 0 .763-.09 1.104-.271a2.46 2.46 0 0 0 .849-.733 6.123 6.123 0 0 0 1.017-2.225c.096-.422.17-.823.216-1.2.049-.379.07-.737.07-1.077 0-1.247-.396-2.219-1.183-2.915-.791-.696-1.821-1.042-3.088-1.042-1.441 0-2.646.466-3.611 1.401-.966.932-1.452 2.117-1.452 3.554 0 .317.048.623.139.919.089.295.186.53.291.704.104.171.202.338.291.492.09.154.137.264.137.33 0 .202-.053.465-.16.79-.111.325-.242.487-.4.487-.015 0-.077-.011-.185-.034a2.21 2.21 0 0 1-.979-.605 3.17 3.17 0 0 1-.659-1.022 6.986 6.986 0 0 1-.352-1.169 4.884 4.884 0 0 1-.132-1.153z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoPhp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.15 16.78h1.57a.14.14 0 0 0 .14-.12l.35-1.82h1.22a4.88 4.88 0 0 0 1.51-.2A2.79 2.79 0 0 0 8 14a3.18 3.18 0 0 0 .67-.85 3.43 3.43 0 0 0 .36-1 2.43 2.43 0 0 0-.41-2.16 2.64 2.64 0 0 0-2.09-.78h-3a.16.16 0 0 0-.15.13L2 16.6a.19.19 0 0 0 0 .13.17.17 0 0 0 .15.05zM5 10.62h1a1.45 1.45 0 0 1 1.08.29c.17.18.2.52.11 1a1.81 1.81 0 0 1-.57 1.12 2.17 2.17 0 0 1-1.33.33h-.8zm9.8-.95a2.7 2.7 0 0 0-1.88-.51h-1.19l.33-1.76a.15.15 0 0 0 0-.13.16.16 0 0 0-.11 0h-1.57a.14.14 0 0 0-.14.12l-1.38 7.27a.13.13 0 0 0 0 .12.13.13 0 0 0 .11.06h1.54a.14.14 0 0 0 .14-.13l.77-4.07h1.11c.45 0 .61.1.66.16a.81.81 0 0 1 0 .62l-.61 3.24a.13.13 0 0 0 0 .12.14.14 0 0 0 .11.06h1.56a.16.16 0 0 0 .15-.13l.64-3.4a1.7 1.7 0 0 0-.24-1.64zm4.52-.51h-3.13a.14.14 0 0 0-.15.13l-1.46 7.31a.16.16 0 0 0 0 .13.14.14 0 0 0 .11.05h1.63a.14.14 0 0 0 .15-.12l.37-1.82h1.27a5.28 5.28 0 0 0 1.56-.2 3 3 0 0 0 1.18-.64 3.31 3.31 0 0 0 .7-.85 3.45 3.45 0 0 0 .37-1 2.38 2.38 0 0 0-.42-2.16 2.81 2.81 0 0 0-2.18-.83zm.62 2.77a1.83 1.83 0 0 1-.6 1.12 2.28 2.28 0 0 1-1.37.33h-.8l.54-2.76h1a1.6 1.6 0 0 1 1.13.29c.16.18.16.52.1 1.02z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoPeriscope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.102 21c1.406 0 6.985-6.329 6.985-10.571C19.087 6.368 15.915 3 12.102 3c-4.017 0-7.188 3.366-7.188 7.429C4.913 14.67 10.492 21 12.102 21zM10.979 5.885a4.696 4.696 0 0 1 1.143-.139c2.25 0 4.186 1.913 4.186 4.398 0 2.238-1.936 4.151-4.196 4.151-2.509 0-4.444-1.913-4.444-4.151 0-1.047.338-1.98.922-2.723v.022c0 .934.755 1.676 1.688 1.676.933.002 1.722-.764 1.722-1.697a1.68 1.68 0 0 0-1.02-1.54l-.001.003z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoPaypal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.554 9.488c.121.563.106 1.246-.04 2.051-.582 2.978-2.477 4.466-5.683 4.466h-.442a.666.666 0 0 0-.444.166.72.72 0 0 0-.239.427l-.041.189-.553 3.479-.021.151a.706.706 0 0 1-.247.426.666.666 0 0 1-.447.166H8.874a.395.395 0 0 1-.331-.15.457.457 0 0 1-.09-.363c.061-.373.148-.938.267-1.689.117-.75.206-1.314.267-1.689s.15-.938.272-1.685c.121-.748.212-1.31.271-1.685.033-.248.179-.371.433-.371h1.316c.893.013 1.682-.057 2.375-.211 1.172-.262 2.134-.744 2.886-1.449.685-.637 1.203-1.462 1.56-2.473.162-.47.277-.917.352-1.338.006-.041.014-.066.025-.074.008-.011.022-.014.035-.011a.378.378 0 0 1 .062.035c.524.398.854.941.98 1.632zm-1.728-2.836c0 .717-.154 1.508-.465 2.374-.537 1.562-1.547 2.618-3.037 3.168-.758.269-1.602.408-2.535.425 0 .006-.301.007-.904.007l-.903-.007c-.672 0-1.067.32-1.187.964-.013.053-.298 1.83-.855 5.329-.008.066-.048.102-.121.102H4.854a.473.473 0 0 1-.369-.165.469.469 0 0 1-.115-.39L6.702 3.664a.784.784 0 0 1 .276-.483.785.785 0 0 1 .519-.19h6.014c.228 0 .555.044.979.131.428.084.801.194 1.123.321.718.274 1.266.688 1.645 1.237.379.552.568 1.207.568 1.972z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoPatreon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.508",
                    "cy": "9.831",
                    "r": "6.496"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.996 3.335H6.17v17.33H2.996z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoOpera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.71 6.366C7.604 7.67 6.888 9.602 6.838 11.765v.471c.05 2.165.766 4.094 1.872 5.397 1.434 1.865 3.564 3.046 5.948 3.046a7.218 7.218 0 0 0 4.006-1.225 9.943 9.943 0 0 1-7.139 2.533A9.995 9.995 0 0 1 2 12C2 6.477 6.478 2 12 2h.038a9.971 9.971 0 0 1 6.627 2.545c-1.173-.773-2.543-1.225-4.009-1.225-2.382 0-4.514 1.184-5.95 3.046h.004zM22 12a9.971 9.971 0 0 1-3.335 7.455c-2.564 1.25-4.954.375-5.747-.172 2.52-.553 4.422-3.6 4.422-7.283 0-3.686-1.901-6.73-4.422-7.283.792-.545 3.183-1.42 5.747-.172A9.971 9.971 0 0 1 22 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoOkRu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.986 12.341c-2.825 0-5.173-2.346-5.173-5.122C6.813 4.347 9.161 2 11.987 2c2.922 0 5.173 2.346 5.173 5.219a5.142 5.142 0 0 1-5.157 5.123l-.017-.001zm0-7.324c-1.196 0-2.106 1.005-2.106 2.203 0 1.196.91 2.106 2.107 2.106 1.245 0 2.107-.91 2.107-2.106.001-1.199-.862-2.203-2.108-2.203zm2.06 11.586 2.923 2.825c.575.621.575 1.531 0 2.106-.622.621-1.581.621-2.06 0l-2.922-2.873-2.826 2.873c-.287.287-.671.43-1.103.43-.335 0-.718-.144-1.054-.43-.575-.575-.575-1.485 0-2.107l2.97-2.825a13.49 13.49 0 0 1-3.063-1.339c-.719-.383-.862-1.34-.479-2.059.479-.718 1.341-.909 2.108-.43a6.62 6.62 0 0 0 6.897 0c.767-.479 1.676-.288 2.107.43.432.719.239 1.675-.432 2.059-.909.575-1.963 1.006-3.065 1.341l-.001-.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoNodejs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.985c-.275 0-.532-.074-.772-.202l-2.439-1.448c-.365-.203-.182-.277-.072-.314.496-.165.588-.201 1.101-.493.056-.037.129-.02.185.017l1.87 1.12c.074.036.166.036.221 0l7.319-4.237c.074-.036.11-.11.11-.202V7.768c0-.091-.036-.165-.11-.201l-7.319-4.219c-.073-.037-.165-.037-.221 0L4.552 7.566c-.073.036-.11.129-.11.201v8.457c0 .073.037.166.11.202l2 1.157c1.082.548 1.762-.095 1.762-.735V8.502c0-.11.091-.221.22-.221h.936c.108 0 .22.092.22.221v8.347c0 1.449-.788 2.294-2.164 2.294-.422 0-.752 0-1.688-.46l-1.925-1.099a1.55 1.55 0 0 1-.771-1.34V7.786c0-.55.293-1.064.771-1.339l7.316-4.237a1.637 1.637 0 0 1 1.544 0l7.317 4.237c.479.274.771.789.771 1.339v8.458c0 .549-.293 1.063-.771 1.34l-7.317 4.236c-.241.11-.516.165-.773.165zm2.256-5.816c-3.21 0-3.87-1.468-3.87-2.714 0-.11.092-.221.22-.221h.954c.11 0 .201.073.201.184.147.971.568 1.449 2.514 1.449 1.54 0 2.202-.35 2.202-1.175 0-.477-.185-.825-2.587-1.063-1.999-.2-3.246-.643-3.246-2.238 0-1.485 1.247-2.366 3.339-2.366 2.347 0 3.503.809 3.649 2.568a.297.297 0 0 1-.056.165c-.037.036-.091.073-.146.073h-.953a.212.212 0 0 1-.202-.164c-.221-1.012-.789-1.34-2.292-1.34-1.689 0-1.891.587-1.891 1.027 0 .531.237.696 2.514.99 2.256.293 3.32.715 3.32 2.294-.02 1.615-1.339 2.531-3.67 2.531z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoNetlify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.13 9.68 22 11.8v-.11c-.07-.24-.28-.45-.7-.87l-2-2-2.07.87zM12.2 7.24a1.31 1.31 0 0 1 .16.47l3 1.29a1.11 1.11 0 0 1 .29-.14l.48-3-2-2-1.95 3.3s0 .05.02.08zM10.61 7a1.1 1.1 0 0 1 1-.2h.05l2.16-3.34-.66-.66c-.42-.42-.63-.63-.87-.7a1 1 0 0 0-.63 0c-.24.07-.45.28-.87.7l-3 3c.31.14 2.5 1.06 2.78 1.19zm-3.12 5.29h.27a1.45 1.45 0 0 1 .29 0l2.38-3.68v-.06a1 1 0 0 1-.27-.95L9 7l-1.7-.73L5 8.61l2.51 3.66zm7.62-2.44v-.08a.59.59 0 0 1 0-.14l-2.86-1.27h-.05a1.05 1.05 0 0 1-.88.47h-.17s-.05 0-.06.05L8.73 12.5v.05l6.33-2.7s.05.02.05 0zm1.36-.91a.83.83 0 0 1 .26.19l2-.84-1.89-1.87-.4 2.47zm-2.29 5.54A.91.91 0 0 1 15 14v-.05l.54-3.37-.09-.08L9 13.15a2.76 2.76 0 0 1 .08.27zM2 11.95zm12.14 3.18L8.92 14v.06L13.47 21l.42-.43c.15-.92.71-4.33.78-4.72a.9.9 0 0 1-.53-.72zm1.65.32a.88.88 0 0 1-.36.27l-.64 3.94L18.43 16zm1.07-5.13a.07.07 0 0 0-.06 0 .92.92 0 0 1-.61.34v.06l-.55 3.4a.88.88 0 0 1 .34.62h.06l2.95.61 2.28-2.28a4.22 4.22 0 0 0 .65-.74zM8.3 14.59a1.27 1.27 0 0 1-.86 0l-1.22 1.9 4.69 4.68a2.68 2.68 0 0 0 .87.71 1 1 0 0 0 .63 0 1.86 1.86 0 0 0 .7-.54l-4.69-6.8zm4.71 6.82zm-6.62-7.82s.06 0 .06-.05 0 0-.06 0l-4.14-.86a7.07 7.07 0 0 0 .51.54l1.36 1.36 2.27-1zm.28-.66a1.05 1.05 0 0 1 .2-.27v-.06C6.1 11.4 5.3 10.24 4.5 9.07l-1.75 1.75c-.42.42-.63.63-.7.87A.75.75 0 0 0 2 12l4.67 1zm.17 1.33a.61.61 0 0 1-.07-.1L4.59 15l1.08 1.1 1.17-1.82s.01-.02 0-.02z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMongodb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.74 4.23c-.84-1-1.57-2-1.71-2.22H12c-.14.21-.87 1.22-1.71 2.22-7.2 9.19 1.14 15.39 1.14 15.39l.07.05c.06.95.22 2.33.22 2.33h.62s.15-1.37.21-2.33l.07-.06s8.32-6.19 1.12-15.38zM12 19.48a3.48 3.48 0 0 1-.48-.48L12 9l.45 10a3.57 3.57 0 0 1-.45.48z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMicrosoft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.55 21H3v-8.55h8.55V21zM21 21h-8.55v-8.55H21V21zm-9.45-9.45H3V3h8.55v8.55zm9.45 0h-8.55V3H21v8.55z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMicrosoftTeams(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "20.288",
                    "cy": "8.344",
                    "r": "1.707"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.581 11.513h3.413v3.656c0 .942-.765 1.706-1.707 1.706h-1.706v-5.362zM2.006 4.2v15.6l11.213 1.979V2.221L2.006 4.2zm8.288 5.411-1.95.049v5.752H6.881V9.757l-1.949.098V8.539l5.362-.292v1.364zm3.899.439v8.288h1.95c.808 0 1.463-.655 1.463-1.462V10.05h-3.413zm1.463-4.875c-.586 0-1.105.264-1.463.673v2.555c.357.409.877.673 1.463.673a1.95 1.95 0 0 0 0-3.901z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMeta(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.26 7.8a4.82 4.82 0 0 0-3.93-2.44 3.91 3.91 0 0 0-2.54 1.09 10.58 10.58 0 0 0-1.52 1.71 11 11 0 0 0-1.63-1.72 4.39 4.39 0 0 0-2.88-1.08A5 5 0 0 0 3.7 8 11.49 11.49 0 0 0 2 14a7 7 0 0 0 .18 1.64A4.44 4.44 0 0 0 2.71 17a3.23 3.23 0 0 0 3 1.6c1.25 0 2.19-.56 3.3-2a26.4 26.4 0 0 0 2.21-3.6l.63-1.12c.06-.09.11-.18.16-.27l.15.25 1.79 3A14.77 14.77 0 0 0 16 17.63a3.38 3.38 0 0 0 2.55 1 3 3 0 0 0 2.54-1.23 2.2 2.2 0 0 0 .18-.28 4.1 4.1 0 0 0 .31-.63l.12-.35A6.53 6.53 0 0 0 22 15a9 9 0 0 0 0-1 11.15 11.15 0 0 0-1.74-6.2zm-10.12 3.56c-.64 1-1.57 2.51-2.37 3.61-1 1.37-1.51 1.51-2.07 1.51a1.29 1.29 0 0 1-1.15-.66 3.3 3.3 0 0 1-.39-1.7A9.74 9.74 0 0 1 5.54 9a2.8 2.8 0 0 1 2.19-1.47A3 3 0 0 1 10 8.74a14.07 14.07 0 0 1 1 1.31zm8.42 5.12c-.48 0-.85-.19-1.38-.83A34.87 34.87 0 0 1 14.82 12l-.52-.86c-.36-.61-.71-1.16-1-1.65a2.46 2.46 0 0 1 .17-.27c.94-1.39 1.77-2.17 2.8-2.17a3.12 3.12 0 0 1 2.49 1.66 10.17 10.17 0 0 1 1.37 5.34c-.04 1.31-.34 2.43-1.57 2.43z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMessenger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.92 0-8.91 3.729-8.91 8.332 0 2.616 1.291 4.952 3.311 6.479V21l3.041-1.687c.811.228 1.668.35 2.559.35 4.92 0 8.91-3.73 8.91-8.331C20.91 6.729 16.92 3 12 3zm.938 11.172-2.305-2.394-4.438 2.454 4.865-5.163 2.305 2.395 4.439-2.455-4.866 5.163z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMedium(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.285 7.269a.733.733 0 0 0-.24-.619l-1.77-2.133v-.32h5.498l4.25 9.32 3.736-9.32H21v.319l-1.515 1.451a.45.45 0 0 0-.168.425v10.666a.448.448 0 0 0 .168.425l1.479 1.451v.319h-7.436v-.319l1.529-1.487c.152-.15.152-.195.152-.424V8.401L10.95 19.218h-.575L5.417 8.401v7.249c-.041.305.06.612.275.833L7.684 18.9v.319H2.036V18.9l1.992-2.417a.971.971 0 0 0 .257-.833V7.269z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMediumSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-2.046 4.265-.966.925a.28.28 0 0 0-.106.271v6.801a.28.28 0 0 0 .106.271l.942.926v.204h-4.741v-.204l.977-.948c.097-.096.097-.125.097-.271V9.742l-2.716 6.896h-.368L8.018 9.742v4.622a.644.644 0 0 0 .176.531l1.271 1.541v.203H5.861v-.203l1.271-1.541a.618.618 0 0 0 .164-.531V9.02a.468.468 0 0 0-.152-.395l-1.13-1.36v-.203H9.52l2.71 5.943 2.382-5.943h3.343v.203z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMediumOld(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.957 6.73a.073.073 0 0 0-.019-.097c-.004-.004-.008-.008-.012-.01l-.006-.002-6.033-3.018a.729.729 0 0 0-.292-.067.692.692 0 0 0-.586.317l-3.474 5.646 4.359 7.083 6.063-9.852zm-1.064 13.543c.611.306 1.107.092 1.107-.478V8.483l-5.809 9.439 4.702 2.351zM9.622 8.213v6.426l5.711 2.855zm-7.068 9.558 5.19 2.595a.845.845 0 0 0 .374.098c.323 0 .549-.25.549-.669V6.701a.067.067 0 0 0-.035-.059L2.739 3.697a.669.669 0 0 0-.3-.079c-.258 0-.439.199-.439.534v12.723c0 .341.25.744.554.896z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMastodon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17.24c2.5-.3 4.69-1.84 5-3.25a33.59 33.59 0 0 0 .4-5.42C21.33 4.23 18.48 3 18.48 3A17.64 17.64 0 0 0 12 2a17.64 17.64 0 0 0-6.48 1S2.68 4.23 2.68 8.57v3.44c.1 4.24.78 8.42 4.7 9.46A14.73 14.73 0 0 0 12 22a9.21 9.21 0 0 0 3.54-.81l-.07-1.64A11.41 11.41 0 0 1 12 20c-1.8-.06-3.71-.19-4-2.4a4.26 4.26 0 0 1 0-.63 22.68 22.68 0 0 0 4 .54 23.6 23.6 0 0 0 4-.27zm-6.54-9.8q-1.35 0-1.35 1.62v5.1H6V8.9a3.78 3.78 0 0 1 .82-2.56 2.85 2.85 0 0 1 2.23-1 2.68 2.68 0 0 1 2.4 1.23l.52.87.52-.87a2.68 2.68 0 0 1 2.4-1.23 2.85 2.85 0 0 1 2.23 1A3.78 3.78 0 0 1 18 8.9v5.26h-2.11v-5.1q0-1.62-1.35-1.62c-1 0-1.51.64-1.51 1.92v2.79H11V9.36c0-1.28-.54-1.92-1.54-1.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMastercard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.454 17.021c.048.041.1.082.151.122a6.173 6.173 0 0 1-3.42 1.03A6.17 6.17 0 0 1 2.01 12a6.175 6.175 0 0 1 9.592-5.144c-.05.043-.1.082-.138.126A6.633 6.633 0 0 0 9.166 12c0 1.925.833 3.755 2.288 5.021zm4.361-11.195a6.14 6.14 0 0 0-3.416 1.03c.049.043.099.082.137.126 1.462 1.263 2.299 3.094 2.299 5.018s-.835 3.753-2.288 5.021c-.049.041-.101.082-.151.122a6.162 6.162 0 0 0 3.418 1.03 6.174 6.174 0 1 0 .001-12.347zM12 7.15A6.152 6.152 0 0 0 9.644 12 6.15 6.15 0 0 0 12 16.853 6.157 6.157 0 0 0 14.357 12 6.15 6.15 0 0 0 12 7.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMarkdown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.553 18.15H3.447a1.443 1.443 0 0 1-1.442-1.441V7.291c0-.795.647-1.441 1.442-1.441h17.105c.795 0 1.442.646 1.442 1.441v9.418a1.441 1.441 0 0 1-1.441 1.441zM6.811 15.268V11.52l1.922 2.402 1.922-2.402v3.748h1.922V8.732h-1.922l-1.922 2.403-1.922-2.403H4.889v6.535h1.922zM19.688 12h-1.922V8.732h-1.923V12h-1.922l2.884 3.364L19.688 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMailchimp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.279 11.506c.132-.016.257-.018.373 0 .066-.154.078-.419.019-.708-.09-.429-.211-.688-.461-.646-.251.04-.261.35-.17.779.05.24.14.446.239.575zm-2.149.339c.18.078.29.129.331.086.029-.028.021-.084-.022-.154a1.05 1.05 0 0 0-.464-.371 1.26 1.26 0 0 0-1.228.146c-.119.088-.232.209-.218.283.007.023.023.042.065.05.099.011.444-.164.843-.188.282-.02.513.068.693.148zm-.361.205c-.232.037-.361.113-.443.187-.071.062-.113.128-.113.177l.018.042.037.014c.053 0 .171-.046.171-.046.324-.115.539-.102.752-.078.117.014.172.02.198-.02.007-.012.018-.035-.007-.074-.056-.091-.291-.24-.613-.202zm1.784.756c.159.078.333.046.39-.069.059-.115-.024-.272-.183-.349-.158-.079-.333-.049-.39.066-.057.115.026.274.183.352zm1.018-.891c-.128-.002-.234.138-.238.316-.003.177.1.321.229.322.129.002.235-.139.238-.315s-.099-.32-.229-.323zm-8.644 3.183c-.032-.04-.085-.029-.136-.015-.036.007-.076.017-.119.016a.265.265 0 0 1-.221-.111c-.059-.09-.056-.225.01-.378l.03-.069c.104-.231.275-.619.082-.988a.88.88 0 0 0-.671-.488.861.861 0 0 0-.739.267c-.284.313-.327.741-.273.893.021.056.053.071.075.074.048.007.119-.029.164-.15l.014-.038c.02-.064.057-.184.118-.278a.518.518 0 0 1 .717-.15c.2.131.275.375.19.608-.044.121-.115.351-.1.54.032.383.27.537.48.556.206.007.35-.108.387-.193.021-.053.003-.084-.008-.096z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.821 14.397c-.009-.029-.061-.216-.13-.44l-.144-.384c.281-.423.286-.799.249-1.013a1.284 1.284 0 0 0-.372-.724c-.222-.232-.677-.472-1.315-.651l-.335-.093c-.002-.015-.018-.79-.031-1.123-.011-.24-.031-.616-.148-.986-.14-.502-.381-.938-.684-1.221.835-.864 1.355-1.817 1.354-2.634-.003-1.571-1.933-2.049-4.312-1.063l-.503.214c-.002-.002-.911-.894-.924-.905-2.714-2.366-11.192 7.06-8.48 9.349l.593.501a2.916 2.916 0 0 0-.166 1.345c.065.631.389 1.234.915 1.701.5.442 1.159.724 1.796.723 1.055 2.432 3.465 3.922 6.291 4.007 3.032.09 5.576-1.333 6.644-3.889.069-.179.365-.987.365-1.7-.001-.718-.406-1.015-.663-1.014zM7.416 16.309a1.38 1.38 0 0 1-.28.021c-.916-.026-1.905-.85-2.003-1.827-.109-1.08.443-1.912 1.421-2.108.116-.025.258-.038.41-.031.548.032 1.354.452 1.539 1.645.164 1.055-.096 2.132-1.087 2.3zm-1.021-4.562a2.325 2.325 0 0 0-1.473.94c-.197-.164-.562-.48-.626-.604-.524-.994.571-2.928 1.337-4.02 1.889-2.698 4.851-4.739 6.223-4.371.222.064.96.921.96.921s-1.37.759-2.642 1.819c-1.711 1.32-3.006 3.236-3.779 5.315zm9.611 4.158a.05.05 0 0 0 .03-.054.05.05 0 0 0-.056-.045s-1.434.212-2.789-.283c.147-.479.541-.308 1.134-.259a8.287 8.287 0 0 0 2.735-.296c.613-.177 1.419-.524 2.045-1.018.212.465.286.975.286.975s.163-.029.3.055c.13.08.224.245.16.671-.133.798-.471 1.445-1.042 2.041a4.259 4.259 0 0 1-1.249.934 5.337 5.337 0 0 1-.814.346c-2.149.701-4.349-.07-5.058-1.727a2.761 2.761 0 0 1-.142-.392c-.302-1.092-.046-2.4.755-3.226v-.001c.051-.052.102-.113.102-.191 0-.064-.042-.133-.077-.183-.28-.406-1.253-1.099-1.057-2.44.139-.964.982-1.642 1.768-1.602l.2.012c.34.02.637.063.917.076.47.019.891-.049 1.391-.465.169-.142.304-.263.532-.301.024-.006.084-.025.203-.021a.681.681 0 0 1 .343.109c.4.266.457.912.479 1.385.012.269.045.922.055 1.108.026.428.139.489.365.563.129.044.248.074.423.125.529.147.845.3 1.043.493a.637.637 0 0 1 .188.372c.065.457-.353 1.021-1.455 1.533-1.206.559-2.669.701-3.679.588l-.354-.04c-.81-.108-1.269.936-.784 1.651.313.461 1.164.761 2.017.761 1.953.002 3.455-.832 4.015-1.554l.044-.063c.026-.042.005-.063-.03-.041-.455.312-2.483 1.552-4.651 1.18 0 0-.264-.044-.504-.138-.19-.072-.591-.258-.639-.668 1.747.543 2.85.031 2.85.03zm-2.773-.327zM9.886 8.053c.672-.776 1.499-1.452 2.241-1.83.025-.014.052.015.038.038a2.125 2.125 0 0 0-.208.508c-.006.027.023.049.046.032.462-.314 1.264-.651 1.968-.693a.03.03 0 0 1 .021.055 1.66 1.66 0 0 0-.31.311c-.014.02-.001.049.024.049.494.003 1.191.175 1.644.43.03.018.008.077-.025.069-.688-.157-1.811-.277-2.979.008-1.044.254-1.84.646-2.419 1.069-.03.02-.065-.019-.041-.046z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoMagento(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 22.019-3.717-2.146V9.863l2.479-1.43v10.01l1.238.753 1.238-.753V8.434l2.479 1.43v10.01L12 22.019zm8.666-15.014v10.009l-2.475 1.43V8.434L12 4.861 5.807 8.434v10.01l-2.473-1.43V7.005L12 2l8.666 5.005z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoLinkedin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.983",
                    "cy": "5.009",
                    "r": "2.188"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoLinkedinSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8.339 18.337H5.667v-8.59h2.672v8.59zM7.003 8.574a1.548 1.548 0 1 1 0-3.096 1.548 1.548 0 0 1 0 3.096zm11.335 9.763h-2.669V14.16c0-.996-.018-2.277-1.388-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248h-2.667v-8.59h2.56v1.174h.037c.355-.675 1.227-1.387 2.524-1.387 2.704 0 3.203 1.778 3.203 4.092v4.71z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoLess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.142 10.843c0-.64.098-1.018.098-1.707 0-1.067-.393-1.411-1.263-1.411h-.641v.755h.196c.444 0 .542.147.542.689 0 .509-.049 1.018-.049 1.608 0 .755.246 1.05.739 1.165v.049c-.493.116-.739.411-.739 1.166 0 .591.049 1.067.049 1.608 0 .558-.114.705-.542.705v.017h-.196v.788h.641c.87 0 1.263-.344 1.263-1.411 0-.706-.098-1.067-.098-1.707 0-.345.213-.706.854-.739v-.853c-.642-.016-.854-.377-.854-.722zm-3.299 1.001c-.493-.196-.952-.312-.952-.64 0-.246.197-.395.558-.395.361 0 .689.148 1.05.411l.657-.87c-.409-.313-.968-.641-1.724-.641-1.115 0-1.871.641-1.871 1.544 0 .804.706 1.214 1.298 1.443.508.196 1.001.361 1.001.689 0 .246-.197.41-.641.41-.41 0-.821-.164-1.263-.509l-.657.952c.492.41 1.247.689 1.871.689 1.313 0 2.019-.689 2.019-1.592-.001-.9-.707-1.277-1.346-1.491zm-11.21 1.854c-.114 0-.262-.098-.262-.41V7.725H4.039c-.886 0-1.279.344-1.279 1.411 0 .706.099 1.101.099 1.707 0 .345-.213.706-.854.739v.853c.641.017.854.378.854.723 0 .606-.099.968-.099 1.674 0 1.067.394 1.411 1.264 1.411h.64v-.755h-.197c-.411 0-.542-.164-.542-.706 0-.541.049-1.001.049-1.607 0-.756-.245-1.05-.738-1.165v-.051c.493-.114.738-.409.738-1.165 0-.59-.049-1.066-.049-1.607 0-.542.114-.689.542-.689h.442v4.711c0 1.001.345 1.657 1.346 1.657.313 0 .559-.05.739-.115l-.165-1.066c-.098.013-.146.013-.196.013zm7.238-1.854c-.509-.196-.969-.312-.969-.64 0-.246.197-.395.558-.395.361 0 .689.148 1.051.411l.656-.87c-.41-.313-.968-.641-1.723-.641-1.116 0-1.872.641-1.872 1.544 0 .804.707 1.214 1.297 1.443.51.196 1.002.361 1.002.689 0 .246-.197.41-.641.41-.41 0-.82-.164-1.264-.509l-.64.952c.492.41 1.247.689 1.871.689 1.313 0 2.019-.689 2.019-1.592.001-.9-.705-1.277-1.345-1.491zm-4.842-2.15c-1.198 0-2.347 1.001-2.314 2.577 0 1.624 1.066 2.576 2.479 2.576.591 0 1.247-.214 1.756-.558l-.492-.87c-.36.213-.706.312-1.066.312-.657 0-1.165-.312-1.297-1.066h2.971c.017-.115.049-.345.049-.607.016-1.33-.707-2.364-2.086-2.364zm-.935 2.068c.099-.655.492-.969.951-.969.592 0 .821.411.821.969H8.094z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoKubernetes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.013 13.738-2.254.387a4.475 4.475 0 0 0 1.753 2.231l.865-2.095a.27.27 0 0 0 .022-.228c-.022-.18-.204-.295-.386-.295zm.865-2.914c.205 0 .387-.159.387-.364l.114-2.277-.456.091a4.516 4.516 0 0 0-2.118 1.162l1.89 1.343c.069.022.115.045.183.045zm-1.002 1.48a.366.366 0 0 0-.045-.524l-1.685-1.503a4.797 4.797 0 0 0-.661 2.778l2.209-.637c.091-.023.137-.046.182-.114zm1.457.797.616.296.614-.296.16-.661-.433-.546h-.683l-.433.546zm1.344-2.436c.114.159.341.182.5.091l1.867-1.32a4.286 4.286 0 0 0-2.573-1.23l.137 2.3a.215.215 0 0 0 .069.159z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.944 14.103-1.73-7.446c-.113-.364-.387-.66-.729-.842L12.541 2.49c-.182-.091-.387-.114-.569-.114s-.387 0-.569.045L4.457 5.769a1.22 1.22 0 0 0-.683.842l-1.708 7.492c-.068.387.023.774.25 1.093l4.805 5.943c.273.273.66.456 1.047.479h7.651c.41.045.797-.137 1.048-.479l4.805-5.943c.227-.319.318-.706.272-1.093zm-2.845.501c-.046 0-.068 0-.114-.023-.022-.023-.022-.023-.045-.023-.046 0-.068-.022-.092-.022-.091-.023-.159-.068-.25-.114a.32.32 0 0 1-.137-.045h-.022a3.91 3.91 0 0 0-.729-.205h-.022a.26.26 0 0 0-.182.068s0 .023-.023.023l-.183-.024a5.628 5.628 0 0 1-2.46 3.097l.068.182s-.022 0-.022.022a.264.264 0 0 0-.022.228c.091.228.205.455.364.66v.045a.396.396 0 0 1 .091.114.81.81 0 0 1 .159.228c.023.022.046.045.046.068 0 0 .022 0 .022.022a.582.582 0 0 1 .023.342.38.38 0 0 1-.205.25c-.068.022-.114.045-.183.045a.511.511 0 0 1-.433-.273c-.022 0-.022-.022-.022-.022-.022-.023-.022-.045-.046-.068-.045-.068-.068-.159-.091-.25l-.046-.137v-.022a3.816 3.816 0 0 0-.296-.706.353.353 0 0 0-.182-.137c0-.023 0-.023-.023-.023l-.091-.159c-.228.068-.479.159-.729.205-.41.114-.82.159-1.229.159a5.368 5.368 0 0 1-1.981-.364l-.091.182c0 .023 0 .023-.023.023a.35.35 0 0 0-.182.137c-.114.228-.228.455-.296.706l-.045.137c-.023.091-.068.159-.091.25-.022.023-.045.045-.045.068-.023 0-.023.022-.023.022a.508.508 0 0 1-.433.273.434.434 0 0 1-.159-.045.469.469 0 0 1-.182-.615c.023 0 .023-.023.023-.023.022-.023.022-.045.045-.068.068-.091.114-.182.159-.228s.068-.068.091-.114v-.023a3.73 3.73 0 0 0 .364-.66.268.268 0 0 0-.023-.228s-.022 0-.022-.022l.114-.16a3.578 3.578 0 0 1-.615-.41 5.493 5.493 0 0 1-1.867-2.664l-.205.022s0-.022-.023-.022a.256.256 0 0 0-.182-.068h-.022a4.015 4.015 0 0 0-.751.205h-.024c-.045 0-.091.023-.137.046-.068.022-.159.068-.25.091-.022 0-.091-.022-.091 0 0 .023 0 .023-.023.023-.045.023-.068.023-.114.023a.424.424 0 0 1-.456-.319.445.445 0 0 1 .364-.524c.023-.023.023-.023.046-.023.045 0 .068-.022.091-.022.091 0 .182-.023.273-.023.045-.022.091-.022.137-.022a4.2 4.2 0 0 0 .774-.137c.068-.046.137-.091.16-.16 0 0 .022 0 .022-.022l.182-.046c-.205-1.298.091-2.618.797-3.734.022-.045.045-.068.068-.114l-.131-.132a.106.106 0 0 1-.004.019v-.023l.004.004c.01-.065-.031-.145-.072-.186-.182-.182-.41-.319-.638-.455l-.136-.069a2.587 2.587 0 0 1-.251-.136c-.022 0-.068-.045-.068-.045s0-.023-.022-.023a.49.49 0 0 1-.092-.639c.068-.114.182-.159.319-.159a.54.54 0 0 1 .319.114l.023.023c.022.022.045.022.068.045.068.069.114.137.182.205.023.022.068.045.091.091.159.182.364.364.569.524.045.022.091.045.137.045.045 0 .068-.023.091-.023h.023l.137.091a5.426 5.426 0 0 1 2.801-1.594c.273-.046.523-.091.774-.114l.023-.182v-.045c.068-.045.091-.114.114-.182 0-.273 0-.524-.045-.774v-.023c0-.045 0-.091-.023-.137a1.129 1.129 0 0 1-.045-.273v-.113c0-.114.045-.228.137-.319.114-.114.25-.182.387-.159a.45.45 0 0 1 .387.478v.137c-.023.091-.023.182-.045.273 0 .045-.023.091-.023.136v.023c-.048.273-.048.524-.048.774.023.068.045.136.114.182v-.023l.023.182a5.84 5.84 0 0 1 2.96 1.184c.183.182.387.364.569.546l.183-.114h.022c.022.023.068.023.091.023.046 0 .091-.023.137-.045.205-.137.41-.319.569-.501.022-.023.068-.046.091-.091.046-.068.114-.137.183-.205.022 0 .045-.022.068-.045l.022-.023a.546.546 0 0 1 .318-.114c.114 0 .251.068.319.16.159.205.113.478-.091.637 0 .023.022.023 0 .046-.023.022-.046.022-.068.045-.092.045-.16.091-.251.137l-.137.068a4.104 4.104 0 0 0-.638.455c-.045.046-.068.137-.068.205v.023l-.136.137c.364.569.638 1.207.797 1.867.137.66.182 1.343.091 2.003l.182.046a.278.278 0 0 0 .16.159c.25.068.523.114.773.137h.023a.297.297 0 0 0 .137.022c.091 0 .182 0 .272.023.046 0 .092 0 .092.023 0 .022.022.022.045.022a.537.537 0 0 1 .41.479.49.49 0 0 1-.453.32z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.085 14.718a.352.352 0 0 0-.455.091l-1.116 2.027c.456.136.957.228 1.435.228.341 0 .66-.045.979-.114.159-.045.296-.068.433-.091l-1.093-1.981c-.069-.069-.115-.115-.183-.16zm3.644-4.441-1.708 1.548a.36.36 0 0 0-.091.16c-.046.205.068.41.273.455l2.163.615a4.375 4.375 0 0 0-.092-1.435 4.63 4.63 0 0 0-.545-1.343zm-2.073 3.484a.371.371 0 0 0-.205.433l.889 2.141a4.366 4.366 0 0 0 1.366-1.366c.182-.25.318-.547.433-.865l-2.277-.387a.634.634 0 0 0-.206.044z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoKickstarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.198 9.127 3.309-4.799c.628-.902 1.434-1.354 2.427-1.354.806 0 1.506.287 2.097.861.59.574.885 1.26.885 2.059 0 .59-.155 1.113-.469 1.563l-2.983 4.34 3.649 4.627c.363.461.547 1 .547 1.617 0 .816-.286 1.518-.86 2.105a2.81 2.81 0 0 1-2.084.879c-.895 0-1.577-.291-2.047-.873L10.2 14.574v3.074c0 .879-.152 1.561-.457 2.049-.555.885-1.356 1.328-2.417 1.328-.963 0-1.711-.328-2.24-.977-.496-.602-.744-1.396-.744-2.387V6.258c0-.936.253-1.709.755-2.318.525-.643 1.255-.965 2.186-.965.887 0 1.624.322 2.216.965.329.357.537.717.625 1.082.053.227.079.646.079 1.266v2.84h-.005z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoJsfiddle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.58 11.375c.008-.117.018-.231.018-.35 0-3.243-2.668-5.871-5.959-5.871A5.966 5.966 0 0 0 8.26 8.502a2.732 2.732 0 0 0-1.674-.568c-1.521 0-2.752 1.21-2.752 2.704 0 .283.043.554.125.808a3.957 3.957 0 0 0-1.98 3.418c0 2.173 1.773 3.938 3.975 3.972h11.898c.074 0 .15.012.227.012 2.178 0 3.943-1.739 3.943-3.893a3.885 3.885 0 0 0-2.432-3.579h-.01v-.001zM7.355 15.842a2.329 2.329 0 0 1-.748-1.318 2.865 2.865 0 0 1-.053-.544c0-.74.27-1.347.809-1.827.537-.48 1.221-.722 2.049-.722.854 0 1.654.32 2.363.957.176.158.352.338.514.536l.912 1.071c.158.217.324.399.5.56.471.422.977.632 1.408.632.365 0 .67-.112.912-.336.209-.19.336-.45.363-.73l.008-.123a1.054 1.054 0 0 0-.055-.347 1.275 1.275 0 0 0-1.238-.838c-.453 0-.902.153-1.396.631l-.807-.95-.088-.108c.713-.691 1.414-.95 2.367-.95.838 0 1.525.237 2.037.712l.014.014c.539.474.801 1.089.801 1.842a2.6 2.6 0 0 1-.049.528 2.38 2.38 0 0 1-.74 1.301 2.685 2.685 0 0 1-1.428.677 4.505 4.505 0 0 1-.588.038c-.863 0-1.676-.313-2.365-.938a4.866 4.866 0 0 1-.537-.576l-.914-1.065a3.58 3.58 0 0 0-.488-.563c-.463-.425-.977-.626-1.428-.626-.129 0-.26.018-.389.051a1.19 1.19 0 0 0-.523.289c-.232.216-.365.52-.365.839 0 .324.113.6.352.825l.014.013c.25.227.563.338.926.338.463 0 .914-.162 1.4-.639l.801.938.088.099c-.725.703-1.428.965-2.342.965-.838 0-1.525-.238-2.051-.713l-.046.057z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoJquery(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.345 6.935c-1.756 2.523-1.538 5.806-.196 8.487l.098.19c.021.04.041.082.063.121.012.024.026.047.039.069a7.842 7.842 0 0 0 .198.344l.073.12a9.14 9.14 0 0 0 .211.33 10.179 10.179 0 0 0 .221.319l.036.049c.063.088.129.175.196.261l.074.094.182.223.069.082c.082.097.167.194.252.289l.005.005c.004.004.007.006.01.011.083.091.17.181.256.271l.083.083.205.201.084.08c.092.087.186.172.281.256l.004.004.049.041c.083.073.169.145.255.215l.105.084a11.03 11.03 0 0 0 .565.424c.029.021.057.042.087.062l.024.017c.076.053.154.103.231.153.033.022.066.045.101.067a10.975 10.975 0 0 0 .886.509c.065.034.129.068.195.101l.045.022.08.039c.102.048.205.097.308.143l.066.029c.119.052.239.102.36.149l.088.035a13.895 13.895 0 0 0 .382.142c.125.044.252.085.38.124l.092.028c.128.039.256.085.39.11 8.492 1.548 10.958-5.102 10.958-5.102-2.072 2.698-5.748 3.41-9.232 2.618-.132-.03-.261-.071-.39-.109l-.097-.029a10.929 10.929 0 0 1-.755-.264l-.093-.036c-.12-.047-.239-.097-.356-.148l-.071-.031a11.932 11.932 0 0 1-.301-.14l-.087-.042c-.078-.038-.155-.079-.232-.118-.051-.027-.104-.053-.155-.082a8.294 8.294 0 0 1-.278-.156l-.094-.052a11.4 11.4 0 0 1-.363-.223l-.098-.065a10.557 10.557 0 0 1-.259-.172l-.083-.059c-.082-.058-.164-.116-.244-.176a11.921 11.921 0 0 1-.328-.255l-.099-.079c-.092-.076-.184-.152-.274-.231a12.01 12.01 0 0 1-.319-.288c-.028-.026-.055-.051-.081-.078a7.985 7.985 0 0 1-.208-.203l-.081-.081a10.76 10.76 0 0 1-.254-.269l-.012-.012a11.75 11.75 0 0 1-.258-.293l-.067-.081a10.313 10.313 0 0 1-.254-.313 11.855 11.855 0 0 1-.215-.286C3.864 11.825 3.17 8.186 4.715 5.198"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.794 4.809c-1.27 1.827-1.2 4.273-.21 6.205.166.324.353.639.561.938.191.273.401.597.654.816.092.101.187.199.284.295l.076.074c.094.092.19.182.291.271l.011.01.003.002c.111.097.224.19.34.281l.078.06a8.281 8.281 0 0 0 .366.268c.053.037.108.072.161.107.026.017.051.035.078.051a7.14 7.14 0 0 0 .301.184c.076.044.155.087.233.13.026.015.055.029.082.043.055.028.108.057.163.083a9.645 9.645 0 0 0 .365.171l.074.031c.093.039.186.077.281.113l.117.044c.086.032.171.06.256.089l.117.037c.121.038.243.085.37.107 6.556 1.086 8.068-3.961 8.068-3.961-1.364 1.964-4.006 2.902-6.825 2.17a7.866 7.866 0 0 1-.743-.232l-.118-.043a7.629 7.629 0 0 1-.353-.145 8.79 8.79 0 0 1-.344-.159c-.057-.028-.113-.058-.17-.087l-.099-.051a9.352 9.352 0 0 1-.533-.313l-.08-.053a7.65 7.65 0 0 1-.602-.435c-1.234-.974-2.213-2.306-2.678-3.815-.488-1.566-.382-3.323.462-4.75"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.379 3.221c-.749 1.102-.823 2.469-.304 3.686.548 1.292 1.671 2.304 2.981 2.785a3.85 3.85 0 0 0 .234.079c.077.024.152.053.233.067 3.62.699 4.601-1.857 4.862-2.234-.86 1.239-2.306 1.536-4.078 1.105a5.403 5.403 0 0 1-.939-.344 5.39 5.39 0 0 1-.895-.545c-1.585-1.204-2.573-3.501-1.536-5.372"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoJoomla(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.539 14.059-1.874 1.875-1.777 1.777-.347.35a3.993 3.993 0 0 1-3.785 1.048A2.41 2.41 0 0 1 3 18.567c0-1.138.792-2.092 1.852-2.342a3.993 3.993 0 0 1 1.047-3.811l.135-.135 1.777 1.778-.138.135a1.48 1.48 0 0 0 0 2.092 1.462 1.462 0 0 0 2.09 0l.349-.349 1.775-1.778 1.877-1.879 1.775 1.781zm.693 4.988a3.986 3.986 0 0 1-3.996-.988l-.135-.139 1.773-1.777.135.139a1.48 1.48 0 0 0 2.09 0 1.474 1.474 0 0 0-.002-2.086l-.35-.349-1.773-1.777-1.877-1.878 1.777-1.776 1.875 1.879 1.774 1.777.349.349a3.962 3.962 0 0 1 1.058 3.766 2.407 2.407 0 0 1-.336 4.79 2.392 2.392 0 0 1-2.352-1.924l-.01-.006zm-8.001-8.962 1.881-1.879 1.777-1.777.347-.346a3.972 3.972 0 0 1 3.949-1.002 2.408 2.408 0 1 1 2.699 2.716 3.98 3.98 0 0 1-1.012 3.925l-.137.139-1.777-1.777.139-.138a1.474 1.474 0 1 0-2.086-2.085l-.347.346-1.777 1.776-1.879 1.876-1.777-1.774zm-1.99 1.984-.346-.347a3.984 3.984 0 0 1-.999-3.965 2.414 2.414 0 0 1-1.874-2.35A2.41 2.41 0 0 1 5.43 3c1.197 0 2.19.875 2.378 2.019a3.99 3.99 0 0 1 3.734 1.061l.138.14-1.778 1.776-.137-.136a1.481 1.481 0 0 0-2.088 0 1.481 1.481 0 0 0-.004 2.092l.349.35 1.777 1.777 1.879 1.879-1.775 1.777-1.883-1.879-1.778-1.777v-.01h-.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoJavascript(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v18H3V3zm16.525 13.707c-.131-.821-.666-1.511-2.252-2.155-.552-.259-1.165-.438-1.349-.854-.068-.248-.078-.382-.034-.529.113-.484.687-.629 1.137-.495.293.09.563.315.732.676.775-.507.775-.507 1.316-.844-.203-.314-.304-.451-.439-.586-.473-.528-1.103-.798-2.126-.775l-.528.067c-.507.124-.991.395-1.283.754-.855.968-.608 2.655.427 3.354 1.023.765 2.521.933 2.712 1.653.18.878-.652 1.159-1.475 1.058-.607-.136-.945-.439-1.316-1.002l-1.372.788c.157.359.337.517.607.832 1.305 1.316 4.568 1.249 5.153-.754.021-.067.18-.528.056-1.237l.034.049zm-6.737-5.434h-1.686c0 1.453-.007 2.898-.007 4.354 0 .924.047 1.772-.104 2.033-.247.517-.886.451-1.175.359-.297-.146-.448-.349-.623-.641-.047-.078-.082-.146-.095-.146l-1.368.844c.229.473.563.879.994 1.137.641.383 1.502.507 2.404.305.588-.17 1.095-.519 1.358-1.059.384-.697.302-1.553.299-2.509.008-1.541 0-3.083 0-4.635l.003-.042z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoJava(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.37 17.51c-3.09.86 1.87 2.64 5.8 1a7.18 7.18 0 0 1-1.1-.54 11.59 11.59 0 0 1-4.16.18c-1.31-.15-.54-.64-.54-.64zm5.33-1.68a16.27 16.27 0 0 1-5.36.26c-1.31-.14-.45-.77-.45-.77-3.4 1.12 1.89 2.4 6.64 1a2.25 2.25 0 0 1-.83-.49zm1.82-9.73s-6.87 1.71-3.59 5.49a1.47 1.47 0 0 1-.25 2.12s2.46-1.27 1.33-2.86-1.86-2.22 2.51-4.75z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.13 19.14s.56.46-.63.82c-2.27.69-9.43.9-11.42 0-.72-.31.62-.74 1-.83a2.54 2.54 0 0 1 .69-.08c-.8-.56-5.15 1.1-2.21 1.58 8.05 1.37 14.64-.56 12.57-1.49zm-2.76-4.88a7 7 0 0 1 .92-.49s-1.51.27-3 .4a28.11 28.11 0 0 1-4.82.05C6.09 13.91 9.74 13 9.74 13a6.81 6.81 0 0 0-3.16.75c-2.06 1.03 5.09 1.48 8.79.51zm.91 2.44a.39.39 0 0 1-.08.09c5-1.32 3.18-4.65.78-3.81a.71.71 0 0 0-.33.25s.14-.05.43-.12c1.22-.25 2.92 1.63-.8 3.59zM12 13c-.74-1.67-3.26-3.14 0-5.71C16.09 4.08 14 2 14 2c.84 3.31-3 4.31-4.34 6.37-.93 1.41.47 2.92 2.34 4.63z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.41 21.32a29.75 29.75 0 0 1-9.14.14s.46.38 2.84.53c3.61.23 9.15-.12 9.29-1.83 0 0-.26.64-2.99 1.16z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoInvision(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.361 3.008H4.638c-.901 0-1.63.729-1.63 1.63v14.724c0 .9.729 1.631 1.63 1.631h14.724c.9 0 1.631-.73 1.631-1.631V4.638a1.63 1.63 0 0 0-1.632-1.63zM9.018 6.505c.597 0 1.098.472 1.098 1.078 0 .616-.501 1.08-1.098 1.08v.022c-.604 0-1.09-.486-1.09-1.088 0-.605.486-1.092 1.09-1.092zm7.354 10.352c-1.112 0-1.651-.662-1.651-1.566 0-.26.033-.533.114-.812l.528-1.906c.068-.208.086-.405.086-.581 0-.615-.375-.984-.971-.984-.761 0-1.26.543-1.52 1.598l-1.033 4.146h-1.811l.327-1.303c-.534.873-1.271 1.412-2.183 1.412-1.102 0-1.617-.632-1.617-1.584a4.02 4.02 0 0 1 .096-.811l.826-3.366H6.285l.388-1.43h3.075l-1.216 4.804c-.08.309-.11.559-.11.738 0 .307.148.396.385.452.146.03 1.295.011 1.918-1.376l.798-3.188h-1.294l.391-1.404h2.787l-.359 1.617c.484-.899 1.452-1.762 2.406-1.762 1.012 0 1.855.728 1.855 2.111 0 .4-.063.796-.18 1.18l-.52 1.858a2.286 2.286 0 0 0-.075.492c0 .326.136.484.368.484.238 0 .553-.181.899-1.172l.708.272c-.414 1.473-1.182 2.081-2.137 2.081z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoInternetExplorer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.154 8.514c.85-2.039.906-3.738-.113-4.757-1.133-1.132-3.852-.792-6.737.565h-.341c-2.037 0-4.02.738-5.492 2.039-1.244 1.133-2.15 2.605-2.547 4.246.283-.337 1.869-2.207 3.68-3.226.058 0 .51-.283.51-.283-.057 0-.905.85-1.074 1.02-3.965 4.076-6.285 10.248-4.473 12.059 1.188 1.189 3.34.906 5.831-.452 1.075.51 2.265.735 3.565.735 1.699 0 3.285-.453 4.643-1.359 1.416-.906 2.436-2.319 3.059-3.962h-4.416c-.566 1.075-1.869 1.812-3.227 1.812-1.926 0-3.512-1.586-3.568-3.397v-.169h11.551v-.17c0-.283.057-.623.057-.848-.001-1.362-.341-2.664-.908-3.853zM4.811 19.838c-.906-.906-.621-2.662.453-4.756.51 1.416 1.359 2.662 2.435 3.567.341.282.735.565 1.133.792-1.814.963-3.285 1.133-4.021.397zm11.606-8.606H9.51v-.057c.113-1.756 1.754-3.285 3.681-3.285 1.812 0 3.284 1.416 3.397 3.285v.057h-.171zm3.454-3.171a6.948 6.948 0 0 0-1.303-1.585 8.445 8.445 0 0 0-2.718-1.699c1.813-.849 3.341-.961 4.134-.169.623.736.567 1.981-.113 3.453 0 .057 0 .057 0 0 0 .057 0 .057 0 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoInstagram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.999 7.377a4.623 4.623 0 1 0 0 9.248 4.623 4.623 0 0 0 0-9.248zm0 7.627a3.004 3.004 0 1 1 0-6.008 3.004 3.004 0 0 1 0 6.008z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.806",
                    "cy": "7.207",
                    "r": "1.078"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.533 6.111A4.605 4.605 0 0 0 17.9 3.479a6.606 6.606 0 0 0-2.186-.42c-.963-.042-1.268-.054-3.71-.054s-2.755 0-3.71.054a6.554 6.554 0 0 0-2.184.42 4.6 4.6 0 0 0-2.633 2.632 6.585 6.585 0 0 0-.419 2.186c-.043.962-.056 1.267-.056 3.71 0 2.442 0 2.753.056 3.71.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632 6.584 6.584 0 0 0 2.185.45c.963.042 1.268.055 3.71.055s2.755 0 3.71-.055a6.615 6.615 0 0 0 2.186-.419 4.613 4.613 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.186.043-.962.056-1.267.056-3.71s0-2.753-.056-3.71a6.581 6.581 0 0 0-.421-2.217zm-1.218 9.532a5.043 5.043 0 0 1-.311 1.688 2.987 2.987 0 0 1-1.712 1.711 4.985 4.985 0 0 1-1.67.311c-.95.044-1.218.055-3.654.055-2.438 0-2.687 0-3.655-.055a4.96 4.96 0 0 1-1.669-.311 2.985 2.985 0 0 1-1.719-1.711 5.08 5.08 0 0 1-.311-1.669c-.043-.95-.053-1.218-.053-3.654 0-2.437 0-2.686.053-3.655a5.038 5.038 0 0 1 .311-1.687c.305-.789.93-1.41 1.719-1.712a5.01 5.01 0 0 1 1.669-.311c.951-.043 1.218-.055 3.655-.055s2.687 0 3.654.055a4.96 4.96 0 0 1 1.67.311 2.991 2.991 0 0 1 1.712 1.712 5.08 5.08 0 0 1 .311 1.669c.043.951.054 1.218.054 3.655 0 2.436 0 2.698-.043 3.654h-.011z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoInstagramAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.947 8.305a6.53 6.53 0 0 0-.419-2.216 4.61 4.61 0 0 0-2.633-2.633 6.606 6.606 0 0 0-2.186-.42c-.962-.043-1.267-.055-3.709-.055s-2.755 0-3.71.055a6.606 6.606 0 0 0-2.185.42 4.607 4.607 0 0 0-2.633 2.633 6.554 6.554 0 0 0-.419 2.185c-.043.963-.056 1.268-.056 3.71s0 2.754.056 3.71c.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632 6.584 6.584 0 0 0 2.185.45c.963.043 1.268.056 3.71.056s2.755 0 3.71-.056a6.59 6.59 0 0 0 2.186-.419 4.615 4.615 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.187.043-.962.056-1.267.056-3.71-.002-2.442-.002-2.752-.058-3.709zm-8.953 8.297c-2.554 0-4.623-2.069-4.623-4.623s2.069-4.623 4.623-4.623a4.623 4.623 0 0 1 0 9.246zm4.807-8.339a1.077 1.077 0 0 1-1.078-1.078 1.077 1.077 0 1 1 2.155 0c0 .596-.482 1.078-1.077 1.078z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.994",
                    "cy": "11.979",
                    "r": "3.003"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoImdb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.646 10.237c-.057-.032-.16-.048-.313-.048v3.542c.201 0 .324-.041.371-.122s.07-.301.07-.66v-2.092c0-.244-.008-.4-.023-.469a.223.223 0 0 0-.105-.151zm3.499 1.182c-.082 0-.137.031-.162.091-.025.061-.037.214-.037.46v1.426c0 .237.014.389.041.456.029.066.086.1.168.1.086 0 .199-.035.225-.103.027-.069.039-.234.039-.495V11.97c0-.228-.014-.377-.043-.447-.032-.069-.147-.104-.231-.104z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM6.631 14.663H5.229V9.266h1.402v5.397zm4.822 0H10.23l-.006-3.643-.49 3.643h-.875L8.342 11.1l-.004 3.563H7.111V9.266H8.93c.051.327.107.71.166 1.15l.201 1.371.324-2.521h1.832v5.397zm3.664-1.601c0 .484-.027.808-.072.97a.728.728 0 0 1-.238.383.996.996 0 0 1-.422.193c-.166.037-.418.055-.754.055h-1.699V9.266h1.047c.678 0 1.07.031 1.309.093.24.062.422.164.545.306.125.142.203.3.234.475.031.174.051.516.051 1.026v1.896zm3.654.362c0 .324-.023.565-.066.723a.757.757 0 0 1-.309.413.947.947 0 0 1-.572.174c-.158 0-.365-.035-.502-.104a1.144 1.144 0 0 1-.377-.312l-.088.344h-1.262V9.266h1.35v1.755a1.09 1.09 0 0 1 .375-.289c.137-.064.344-.096.504-.096.186 0 .348.029.484.087a.716.716 0 0 1 .44.549c.016.1.023.313.023.638v1.514z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoHtml5(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.136 3.012h15.729l-1.431 16.15-6.451 1.826-6.414-1.826-1.433-16.15zm5.266 7.302-.173-2.035 7.533.002.173-1.963-9.87-.002.522 5.998h6.835l-.243 2.566-2.179.602-2.214-.605-.141-1.58H7.691l.247 3.123L12 17.506l4.028-1.08.558-6.111H9.402v-.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoHeroku(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.17 2H4.83A1.79 1.79 0 0 0 3 3.8v16.4A1.79 1.79 0 0 0 4.83 22h14.34A1.8 1.8 0 0 0 21 20.2V3.8A1.8 1.8 0 0 0 19.17 2zM20 20.2a.8.8 0 0 1-.81.8H4.83a.79.79 0 0 1-.8-.8V3.8a.79.79 0 0 1 .8-.8h14.34a.8.8 0 0 1 .81.8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.53 19 2.25-2-2.25-2v4zm5.69-9a12 12 0 0 0-3.75.7V5h-2v8.65L8.88 13a12.3 12.3 0 0 1 4.29-1c1 0 1.25.55 1.25 1.05v6h2V13a2.68 2.68 0 0 0-.8-2.1 3.27 3.27 0 0 0-2.4-.9zM13 8.25h2A5.89 5.89 0 0 0 16.47 5h-2A7.17 7.17 0 0 1 13 8.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoGraphql(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.1 14.56a2.07 2.07 0 0 0-.47-.18V9.62a1.64 1.64 0 0 0 .48-.18 1.78 1.78 0 0 0-1.78-3.09 1.62 1.62 0 0 0-.41.32l-4.11-2.38a1.7 1.7 0 0 0 .07-.51 1.78 1.78 0 0 0-3.56 0 1.7 1.7 0 0 0 .07.51L6.28 6.66a1.58 1.58 0 0 0-.41-.31 1.78 1.78 0 0 0-1.78 3.09 1.64 1.64 0 0 0 .48.18v4.76a2.07 2.07 0 0 0-.47.18 1.78 1.78 0 1 0 1.78 3.09 1.72 1.72 0 0 0 .4-.31l4.11 2.37a1.7 1.7 0 0 0-.07.51 1.78 1.78 0 0 0 3.56 0 1.69 1.69 0 0 0-.09-.56l4.09-2.36a1.7 1.7 0 0 0 .44.35 1.78 1.78 0 1 0 1.78-3.09zM6.72 15.69a1.72 1.72 0 0 0-.19-.47 1.53 1.53 0 0 0-.31-.4l5.38-9.33a1.82 1.82 0 0 0 1 0l5.4 9.33a1.53 1.53 0 0 0-.31.4 1.72 1.72 0 0 0-.19.47zM17.5 7.4a1.81 1.81 0 0 0 .17 1.38 1.75 1.75 0 0 0 1.12.84v4.76h-.07l-5.39-9.31.05-.07zM10.82 5a.12.12 0 0 0 0 .05L5.48 14.4h-.07V9.62a1.75 1.75 0 0 0 1.12-.84A1.81 1.81 0 0 0 6.7 7.4zm2.6 14a1.78 1.78 0 0 0-1.32-.58 1.75 1.75 0 0 0-1.28.54L6.7 16.6v-.06h10.78v.11z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoGoogle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.283 10.356h-8.327v3.451h4.792c-.446 2.193-2.313 3.453-4.792 3.453a5.27 5.27 0 0 1-5.279-5.28 5.27 5.27 0 0 1 5.279-5.279c1.259 0 2.397.447 3.29 1.178l2.6-2.599c-1.584-1.381-3.615-2.233-5.89-2.233a8.908 8.908 0 0 0-8.934 8.934 8.907 8.907 0 0 0 8.934 8.934c4.467 0 8.529-3.249 8.529-8.934 0-.528-.081-1.097-.202-1.625z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoGooglePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.545 15.025v-2.421h2.422v-1.815h-2.422V8.368H17.73v2.421h-2.421v1.815h2.421v2.421zM8.052 8.302c1.133 0 1.896.484 2.33.896l1.722-1.67c-1.048-.98-2.415-1.58-4.052-1.58C4.714 5.947 2 8.659 2 12s2.714 6.053 6.052 6.053c3.493 0 5.812-2.457 5.812-5.913 0-.503-.064-.86-.153-1.24H8.049v2.256h3.332c-.158.951-1.011 2.556-3.329 2.556-2.003 0-3.637-1.665-3.637-3.704 0-2.042 1.634-3.706 3.637-3.706z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoGooglePlusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.014 11.974C21.996 6.462 17.521 2 12.008 2 6.493 2 2.019 6.462 2.001 11.974L2 11.948v.112l.001-.023c.017 5.513 4.491 9.977 10.007 9.977 5.514 0 9.988-4.462 10.006-9.974l.001.026v-.118l-.001.026zM9.281 16.557c-2.509 0-4.548-2.039-4.548-4.549s2.039-4.549 4.548-4.549c1.23 0 2.258.451 3.046 1.188l-1.295 1.255c-.325-.309-.899-.673-1.751-.673-1.505 0-2.733 1.251-2.733 2.785 0 1.533 1.229 2.784 2.733 2.784 1.742 0 2.384-1.206 2.502-1.92H9.279V11.18h4.255c.066.286.115.554.115.932 0 2.597-1.742 4.445-4.368 4.445zm10.458-4.095H17.92v1.819h-1.364v-1.819h-1.82v-1.364h1.82v-1.82h1.364v1.82h1.819v1.364z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoGoogleCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.511 9.722a7.833 7.833 0 0 0-2.359-3.804l-.035.035.005-.042A7.81 7.81 0 0 0 4.418 9.722c.031-.013.066-.013.099-.023a5.643 5.643 0 0 0-.306 9.166l.006-.006-.006.024a5.612 5.612 0 0 0 3.407 1.134h4.321l.024.024h4.341a5.644 5.644 0 0 0 3.207-10.319zm-3.206 6.845h-4.341l-.006.006v-.031h-4.34c-.308 0-.611-.066-.892-.193l.002-.001a2.17 2.17 0 1 1 2.87-2.871l2.518-2.518a5.634 5.634 0 0 0-3.396-2.1c.018-.009.035-.024.05-.021a4.334 4.334 0 0 1 5.931-.451h.046a4.334 4.334 0 0 1 1.558 3.407v.433a2.17 2.17 0 1 1 0 4.34z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoGoLang(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.79 10.17a.18.18 0 0 0-.11 0l-.2.27H7a.15.15 0 0 0 .1-.06l.17-.26v-.05zm-1.47.89a.14.14 0 0 0-.11 0l-.2.26v.05h4.6a.09.09 0 0 0 .09-.06l.08-.23v-.06zM4.6 12a.13.13 0 0 0-.1.06l-.13.24v.06h2.15a.08.08 0 0 0 .07-.07v-.23s0-.07-.06-.07zm15.99-3.07a3.62 3.62 0 0 0-2.78-.5 4.09 4.09 0 0 0-2.72 1.63 4 4 0 0 0-.67 1.26h-3.14a.25.25 0 0 0-.24.16c-.14.25-.37.76-.5 1.06s0 .29.18.29h1.88a2.8 2.8 0 0 1-.26.36 1.81 1.81 0 0 1-1.65.65 1.53 1.53 0 0 1-1.32-1.53 2.07 2.07 0 0 1 1-1.85 1.71 1.71 0 0 1 1.77-.15 1.36 1.36 0 0 1 .45.37c.13.15.14.14.29.1l1.63-.43c.12 0 .16-.08.1-.16a3 3 0 0 0-1.13-1.38 3.35 3.35 0 0 0-2.58-.47A4.31 4.31 0 0 0 8.16 10a3.81 3.81 0 0 0-.82 2.85A3 3 0 0 0 8.57 15a3.46 3.46 0 0 0 2.62.65A4.06 4.06 0 0 0 14 14a4.33 4.33 0 0 0 .41-.69 3 3 0 0 0 1 1.55 3.68 3.68 0 0 0 2.38.86c.25 0 .51 0 .78-.09a4.51 4.51 0 0 0 2.33-1.25A3.72 3.72 0 0 0 22 11.1a3 3 0 0 0-1.41-2.17zm-1.78 4.73a1.81 1.81 0 0 1-1.59.06 1.61 1.61 0 0 1-.9-1.84A2.12 2.12 0 0 1 18 10.19a1.59 1.59 0 0 1 2 1.29 2.91 2.91 0 0 1 0 .32 2.11 2.11 0 0 1-1.19 1.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoGmail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.73 5.41-1.28 1L12 10.46 6.55 6.37l-1.28-1A2 2 0 0 0 2 7.05v11.59A1.36 1.36 0 0 0 3.36 20h3.19v-7.72L12 16.37l5.45-4.09V20h3.19A1.36 1.36 0 0 0 22 18.64V7.05a2 2 0 0 0-3.27-1.64z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoGitlab(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.892 9.889a.664.664 0 0 0-.025-.087l-2.104-6.479a.84.84 0 0 0-.8-.57.822.822 0 0 0-.789.575l-2.006 6.175H8.834L6.826 3.327a.823.823 0 0 0-.786-.575h-.006a.837.837 0 0 0-.795.575L3.133 9.815c0 .005-.005.01-.007.016l-1.067 3.281a1.195 1.195 0 0 0 .435 1.34l9.227 6.706c.167.121.393.12.558-.003l9.229-6.703a1.2 1.2 0 0 0 .435-1.34l-1.051-3.223zM17.97 3.936l1.809 5.566H16.16l1.81-5.566zm-11.94 0 1.812 5.566H4.228L6.03 3.936zm-2.982 9.752a.253.253 0 0 1-.093-.284l.793-2.437 5.817 7.456-6.517-4.735zm1.499-3.239h3.601l2.573 7.916-6.174-7.916zm7.452 8.794-2.856-8.798h5.718l-1.792 5.515-1.07 3.283zm1.282-.877 2.467-7.588.106-.329h3.604l-5.586 7.156-.591.761zm7.671-4.678-6.519 4.733.022-.029 5.794-7.425.792 2.436a.25.25 0 0 1-.089.285z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoGithub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.026 2c-5.509 0-9.974 4.465-9.974 9.974 0 4.406 2.857 8.145 6.821 9.465.499.09.679-.217.679-.481 0-.237-.008-.865-.011-1.696-2.775.602-3.361-1.338-3.361-1.338-.452-1.152-1.107-1.459-1.107-1.459-.905-.619.069-.605.069-.605 1.002.07 1.527 1.028 1.527 1.028.89 1.524 2.336 1.084 2.902.829.091-.645.351-1.085.635-1.334-2.214-.251-4.542-1.107-4.542-4.93 0-1.087.389-1.979 1.024-2.675-.101-.253-.446-1.268.099-2.64 0 0 .837-.269 2.742 1.021a9.582 9.582 0 0 1 2.496-.336 9.554 9.554 0 0 1 2.496.336c1.906-1.291 2.742-1.021 2.742-1.021.545 1.372.203 2.387.099 2.64.64.696 1.024 1.587 1.024 2.675 0 3.833-2.33 4.675-4.552 4.922.355.308.675.916.675 1.846 0 1.334-.012 2.41-.012 2.737 0 .267.178.577.687.479C19.146 20.115 22 16.379 22 11.974 22 6.465 17.535 2 12.026 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoGit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.62 11.108-8.731-8.729a1.292 1.292 0 0 0-1.823 0L9.257 4.19l2.299 2.3a1.532 1.532 0 0 1 1.939 1.95l2.214 2.217a1.53 1.53 0 0 1 1.583 2.531c-.599.6-1.566.6-2.166 0a1.536 1.536 0 0 1-.337-1.662l-2.074-2.063V14.9c.146.071.286.169.407.29a1.537 1.537 0 0 1 0 2.166 1.536 1.536 0 0 1-2.174 0 1.528 1.528 0 0 1 0-2.164c.152-.15.322-.264.504-.339v-5.49a1.529 1.529 0 0 1-.83-2.008l-2.26-2.271-5.987 5.982c-.5.504-.5 1.32 0 1.824l8.731 8.729a1.286 1.286 0 0 0 1.821 0l8.69-8.689a1.284 1.284 0 0 0 .003-1.822"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFoursquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.549 5.557-.403 2.113c-.049.229-.337.47-.605.47h-3.76c-.425 0-.729.296-.729.714v.463c0 .43.307.725.73.725h3.194c.298 0 .591.33.524.646l-.404 2.083c-.037.181-.237.475-.592.475h-2.609c-.477 0-.617.069-.936.454-.316.395-3.175 3.827-3.175 3.827-.026.033-.054.022-.054-.011V5.522c0-.271.234-.588.586-.588h7.756c.283 0 .549.269.477.618v.005zm.341 8.288c.111-.437 1.319-6.63 1.722-8.593m-1.489-2.311H8.457c-1.33 0-1.723 1.002-1.723 1.635v15.353c0 .71.381.975.596 1.062.214.087.807.161 1.163-.247 0 0 4.563-5.296 4.64-5.373.125-.118.125-.118.238-.118h2.954c1.245 0 1.438-.885 1.574-1.405.114-.429 1.325-6.622 1.721-8.595.307-1.496-.079-2.311-1.495-2.311h-.002z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFlutter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 2.01 3.9 12l3.09 3.09 2.71-2.7L20.09 2l-6.19.01zm.82 14.6 5.39-5.38h-5.93c-.11 0-.26 0-.34.07l-2.23 2.23-3.09 3.07 3.09 3.1 2.15 2.15c.07.07.14.17.26.15h6.07z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFlickr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.157 12a4.573 4.573 0 1 1-9.147 0 4.573 4.573 0 0 1 9.147 0zm10.833 0a4.573 4.573 0 1 1-9.147 0 4.573 4.573 0 0 1 9.147 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFlickrSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8.747 14.746A2.745 2.745 0 1 1 11.494 12a2.744 2.744 0 0 1-2.747 2.746zm6.506 0a2.746 2.746 0 1 1-.001-5.493 2.746 2.746 0 0 1 .001 5.493z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFlask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.78 18.29c0 .12.15 0 0 0zm-3.35-2.7c.39.17-.31-.6 0 0zm-5.03.28c.15.26 0-.12 0 0zm5.6.39c-.27-.42-.2.06 0 .32.48.47.18-.26 0-.32z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.24 19.06c-.53.63-1-.07-1.63.13-1.1 0 .09-.5.06-1-.58-.45-1.24.61-1.62.9a10.75 10.75 0 0 1-2.67-.83 8 8 0 0 1-2.6-1.94 8.36 8.36 0 0 1-1.87-2.84 21.36 21.36 0 0 1-.84-5.74c.07-1.3 1.44.14 2-.33-.21-.67-1.29-.88-1.89-1.16-.58 0-.79-.55-1.4-.59 0-.73-1.13-.33-1.56-.84.42-1.08-1.37 0-1.23-.91.58-1.2-1.78-1-.8.06.95.54-.93.93-.38 1.29a.59.59 0 0 1-.53.86c-.74.07-.67 1.09.06.55.81-.25.14.11-.25.18a1.3 1.3 0 0 0-.95 1.9 35.32 35.32 0 0 1 1 3.42A16.25 16.25 0 0 0 5.84 17 9.78 9.78 0 0 0 8 19a9.89 9.89 0 0 0 2.43 1.22 18 18 0 0 0 4.73.73 16.53 16.53 0 0 0 2.9-.24c.87.09 1.49-.65 2.26-.26.48-.42 1.16-.23 1.63-.54.32-1.22-1.22-.27-1.71-.85zm-1.74-.74c-.22 0 .05-.34 0 0zm-7.63-11c-.1 0-.08-.12-.16-.15-.8-.37.39-.23.16.19zm6.76 11.39c-.35-.08.28-.25 0 0zm-2.81.11c-.23 0 .18-.14 0 0zm-1.88-1.18c-.13 0 0-.13 0 0zm-.22-.17c-.36 0-.09-.23 0 0zm-.42-.36c-.33.08 0-.34 0 0zm-6-11.66c-.53-.28.11.33-.34.32-.24 0-.69-.52-.54-.78.3.16.83.21.92.5zm-.92-.81h-.11c-.03-.27.87-.06.15.04zm-1.02-.79c-.42-.19 0-.93.44-.58.51.73-.95-.08-.44.58zm.49.69c-.27.11.16-.21 0 0zm.48.92c.6.46-.34 0-.72.29-.61.06.66-.34.72-.29zm.17.6c.35 0 1.88-.69 1.37-.07.47.55.1.37-.21 0 .28.19.06 1-.37.45s-.5-.18-.17.21C5.8 6 4.88 6.28 4.21 6.5c-.43-.04 1.13-.37 1.29-.44zM3.58 7.51c-.16.4.24.53.62.6.62-.17-.41-.28.06-.44.26 0-.82-.26.08-.38S6.09 6.77 7 6.58a8.71 8.71 0 0 1 2.35-.19c.3.35-.23.94-.77 1a8.61 8.61 0 0 1-2 .39c-.8-.1-1.37.61-2.19.7.22-.4-.18-.14-.59-.16.21.82-1.47-.21-.48-.41-.74-.26-.75.52-.67 1-.65-.91.07-1.29.93-1.4zm1.88 1.08c-.22-.05.17-.2 0 0zm-.72.88s-.34-.08-.2-.17c1 .13-.9-.33.13-.22.66-.02.44.36.07.39zm.33.17c-.12.12 0-.24 0 0zm-.71 0c-.44-.09.21-.22 0 0zm-.06 1.43c-.07.1-.1-.08 0 0zM4 10.9c-.55-.19 0-.21 0 0zm-.12 1.28c-.26-.09-.25-.5-.37-.72-.38-1.03.41.4.33.72zm.23-1.49c-.69-.08-.05-.49 0 0zm0-.34h-.09c-.76-.35.45-.17-.02 0zM4 9.56c-.61-.31.58-.36 0 0zm.21.26c-.34.06.05-.32 0 0zm-1.3.07c-.12.08 0-.23 0 0zM3 9.75c-.16 0 0-.27 0 0zm.08-1c-.4-.1.33-.25 0 0zm.26 2c-.44-.1-.12-.65 0 0zm.3 1.25c.42.51.26.79.69 1.41-.56-.35-.67-1.2-1-1.75-.41-.9.23-.01.31.34zm4.09 6.38c-.34-.07-.57-.43-.81-.66a4.88 4.88 0 0 1-1.57-1.94 12.26 12.26 0 0 1-1.46-2.38c-.41-.92.25.07.35.42.21.68.88 1.07.94 1.52.74.42.36 1.12 1 1.31.27-.14.3.84.89.64-.33.15.13.33.3.61.35-.05 1.17.82.36.52zM4.62 12c-.31-.07.33-.11 0 0zm.2.47c-.55-.14.52-.2 0 0zm1.39.47c.4-.17.16.78.55.9.76 1-.53 0-1-.07.06 0-.38-.12-.19-.16-.14-.15-.45-.66.26-.32.6.24.65.06.38-.39zm1.31 1.76c0 .15-.72.13-.06.42-.38 0-.5 0 0 .3-.22.17.43.31.21.57.66.52-.12.13-.4-.08s-.85-.35-.75-.5c.81.42.21 0-.15-.3.65.16-.51-.48.1-.31.19.05-.27-.38.33-.07-.54-.52.47-.12.72-.07zm.48-.17c-.61-.14 0-.34 0 0zm-.17 2c-.61-.26.39 0 0 0zm-.45-.17c-.71-.23.52 0 0 0zm-.09.11c-.22 0 0-.17 0 0zm-1.08-1.55c-.72-.3-.2-.33 0 0zm-.54-.35c-.58-.33-.08-.33 0 0zm0 .65c-.57-.44-.07-.25 0 0zm-.15-1.34c-.35 0 .13-.2 0 0zM8 17.38c-.51-.15 0-.14 0 0zM7.63 17h-.16c-.68-.54.31-.38.75-.14.97.14-.22.39-.59.14zm2.7 1.65c-.68-.16.16-.27 0 0zm-.17-.52c-.05 0-.1-.11 0 0zm-.86-1.34c-.59-.14.21-.19.36 0 1.02.21-.06.26-.36 0zM9.51 18H9.4l-.13-.06c-.56-.59 1.19.28.24.06zm-.28.69c-.15.06 0-.14 0 0zm.29-1.19-.16-.05c-.66-.45.84.09.16 0zm.16 1.72c-.4-.16.26-.25 0 0zm.1-.74c-.58-.14.36-.13 0 0zm.13-.61c-.44-.06.05-.21 0 0zm-.72-.88c.46.06.47.27 0 .14-.09 0-.24 0-.28-.17-.76-.5.03-.25.28-.02zm-.06 2c-.2.12 0-.22 0 0zm-.31-.51c-.53 0 .4-.26 0 0zm-.12.35c-.26-.1.17-.08 0 0zm.3-.89c-.52-.14.25-.18 0 0zm-.16-.57c-.28 0-.06-.16 0 0zm-.54-.95c-.57-.46 1.18.38 0 0zm-.06.19c0 .06-.11-.09 0 0zm3.65 3.78a9.4 9.4 0 0 1-2.56-.85l-.33-.2c-.57-.31-.5-.38.06-.07.19.16 1.59.73.93.35-.29-.07-1.9-.95-.84-.57a20.92 20.92 0 0 0 2.74 1.21 7.14 7.14 0 0 0 2.43.15c.65.33 1.33-.08 2 .21a13.05 13.05 0 0 1-4.45-.23zm-1.25-.7c-.51-.09.16-.23 0 0zm.73-1c-.58-.11.6-.23 0 0zm.84 1.31c1 .37-.6.12-.93-.09-.92-.38.72.09.93.09zm-1.06-1.1c-.81-.12.9 0 0 0zm1.52.85c-.29.23 0-.3 0 0zm.29.05c-.15.06 0-.17 0 0zm.27-.38c-.16.2 0-.23 0 0zm.31 0c-.45.17.47-.39 0 0zm.14 0c.49-.42.51-.22.5.13-.43.48-.17-.2-.44.06s-.19-.1-.06-.17zm.83.45c-.5 0 .51-.54 0 0zm0 .18c-.2.05 0-.13 0 0zm-.16-.35c-.39-.26.94-.61 0 0zm.57.09h-.08c-.03-.23.54-.27.08.02zm.15.19c-.3-.08.47-.4 0 0zm.36-.1c-.51.18.48-.4 0 0zm.22.11-.12.08c-.23-.14.71-.48.12-.07zm-.43-.53c-.54-.18-1.4-.76-2-.37-.8.51.41-.56-.24-.08-.66.79-.45-.5-1.09-.11 0-.12-.57-.16-.17-.37-.36 0-.13-.05 0-.34-.16 0-1 0-1.36-.29-.4-.52.07-.3.48-.23-.67.12.24.5.68.29-.2-.09-.43-.52-1-.9a18.83 18.83 0 0 0-2.13-1c-.84-.5.18-.18.47.08.84.37.51-.51 0-.74-.54 0-.67-.59-1.1-.56.67.11 1.14-.17.39-.85s.3.63-.11.44c-.19-.25-.05-.6-.65-.73 0 .23-.08.58-.21.1-.17 0-.36.21-.5-.28.13-.57-.56-.7-.67-1.06.6.38.87.08.45-.33s-.33-.11-.49 0c-.59.6-.06-1-.32-.56-.26 0-.11.29-.1.65-.86-.21.2.45.45.81-.39-.4-.32.31-.65 0-.11-.3-.12-.77-.67-.85.62-.22-.36-.65-.28-.67.35-.32.4-.76.82-.07-.53 0 0 .88.12.6 0-.47.22-1-.59-1.19-.24.32-.65-.63-.18-.43-.06-.63.74-.26.69-.53.42-.18-.5-.77 0-1 .38.24 1.36-.36.7-.44.42 0 .75.18.79-.24.33.07 1.24.36.42-.09a3.45 3.45 0 0 1 1.13-.25c.79-.61.63 1 .45 1.45.3-.21.24.94.14 1.37.16-.22.23.36 0 .77 0-.07.4-.13.12.35-.22-.47-.31 1-.17.32.37-.61.28 0 .39.24.08.55.32 1.06.4 1.56.35.35-.15.11-.15.59.11-.14.58.19.57.68 0-.78.09-.18.47 0a5.48 5.48 0 0 0 1 1.42c.37.43 0 .13.14.39a3.19 3.19 0 0 0 2.09 1.28 1.46 1.46 0 0 0 1.57.7c-.6.37 1.68.47.91.67-.23.16-.62-.2-1.01-.18zM8.7 15.89c-.24 0 0-.2 0 0zm.38.22c-.18 0-.12-.24 0 0zm-2.61-3.65c-.24-.07.1-.09 0 0zm-.59 0c-.26 0 0-.34 0 0zm-.3-.08c-.1.05 0-.11 0 0zm11 8.25c-.39-.07.32-.22 0 0zm.73-1.05h-.3c.06-.45 1.33-.1 1.85-.09-.16.34-1.13.04-1.55.13zm2 0c-.27 0 .12-.32 0 0zm1-.09c-.25.13 0-.3 0 0zm.48.11c-.52-.12.24-.12.4-.14.94.02 0 .16-.47.16z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.51 7.11c1-.2-.38-.33-.69 0 .18.13.41-.21.69 0zm-.82.13c0 .19.18-.22 0 0zm2.62-.48c.67-.11.11-.41-.09.1.07.14.11-.05.09-.1zm-.62.1c.93.36-.05-1 0 0zm-2.92.93a.51.51 0 0 1 .33.1c.75.52-.1-.84-.33-.1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.81 7.43c.16.13.29-.21 0 0zm.37.01.14.12c.68.06-.11-.46-.14-.12zM10.69 16c.09.3 0-.39 0 0zm-4.78-5c.1.18.18-.18 0 0zm.09.61c.19.34 0-.51 0 0zm.21-.49c.33.21-.28-.52 0 0zm-.41-.82c.07.15.24.16.37.2 1.32.61-.95-1-.37-.2zm.54 1.43c.31.53.18-.37 0 0zm.48-.16c.37.92-.23-.12-.3-.43a2.11 2.11 0 0 0 .28 1c.34.51.19-.28.55.23-.2-.45.1-.2.06-.4s-1-1.17-.59-.4zm.36 1.78c.09.31.18 0 0 0zM5.85 9c.06.14.11 0 0 0zm.67.42c.32.41.17-.36 0 0zm-.89 1.14.14.15c.99.29-1.05-.95-.14-.15zm.7-.37c1 .41-.09-.27-.44-.2.11.13.32.07.44.2zm-.18-.44c.18.18.82.51.31.06.32-.06 0-.16-.24-.32-.44-.67.07.06-.07.26z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.51 10.64c-.53-.44.16.21-.06.2-.55-.4-.32-.11 0 .2.33.5.6-.3.06-.4zm2.14.64c.12.11-.06-.68 0 0zm1.02-3.5c0 .12.07-.1 0 0zM9 12.47c0 .21 0-.18 0 0zm-.29-1.22c.08.46.1-.78 0 0zm.14.22v.1c.21-.51.04-.79 0-.1zm-.1-2.7c-.14.7-.27.41-.08-.11-.05-.67-.45.41-.27.72.29.47.6-1.16.35-.61zm1.01 5.98c.13.35.11-.42 0 0zm-1.35-4.28c0 .2 0-.14 0 0zm.64 1.7c0 .26.11-.38 0 0zM9.5 14l.07.11c.14-.49-.36-.79-.07-.11zm-1.56-.52c.27.22-.13-.23 0 0zm1.23-.85c.08.29 0-.42 0 0zM8.14 9.81c.15.33-.05-.27 0 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.3 10.23c.24.34-.26-.64 0 0zm-.06 1.15c-.13-1-.42.45 0 .69.13.34.25.2.3-.19-.32 0 .08-.62-.3-.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFirefox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.634 11.138a2.16 2.16 0 0 0-.06-.286l-.187.236a6.354 6.354 0 0 0-.228-1.274 8.66 8.66 0 0 0-.591-1.511 5.33 5.33 0 0 0-.54-.92c-.109-.17-.203-.296-.221-.322-.362-.589-.767-.947-1.249-1.621a4.942 4.942 0 0 1-.615-1.679 6.091 6.091 0 0 0-.303 1.097c-.483-.489-.913-.846-1.168-1.08-1.267-1.183-1.113-1.79-1.113-1.79s-2.364 2.635-1.342 5.377a5.278 5.278 0 0 0 1.764 2.347c.989.813 2.052 1.452 2.609 3.101a5.2 5.2 0 0 0-1.967-2.087c.253.602.38 1.232.371 1.884a4.468 4.468 0 0 1-4.476 4.465 4.28 4.28 0 0 1-.985-.109 4.117 4.117 0 0 1-1.107-.379 4.4 4.4 0 0 1-1.334-1.226v-.007a.372.372 0 0 0 .075.024c.187.067.372.118.567.153a3.558 3.558 0 0 0 2.245-.263c.708-.396 1.139-.685 1.484-.574.348.109.608-.22.373-.565a1.853 1.853 0 0 0-1.79-.692c-.711.101-1.36.599-2.28.117-.067-.032-.117-.066-.176-.101-.06-.042.202.051.134.009a4.138 4.138 0 0 1-.582-.347c-.009-.009.145.043.126.033a2.235 2.235 0 0 1-.608-.614 1.118 1.118 0 0 1-.04-.973.844.844 0 0 1 .38-.354l.192.1s-.059-.1-.085-.151c.01-.008.019 0 .035-.008.102.042.329.159.455.236a.6.6 0 0 1 .212.186s.043-.017.009-.108a.511.511 0 0 0-.221-.263h.018c.093.051.178.102.261.167.076-.186.119-.368.112-.563a.825.825 0 0 0-.043-.313c-.035-.067.017-.093.075-.025a.545.545 0 0 0-.051-.152s.034-.051.051-.062c.043-.04.084-.082.136-.107.293-.185.599-.347.92-.474a6.52 6.52 0 0 0 .515-.228c.067-.042.127-.084.186-.136.22-.185.364-.438.413-.718.01-.04.01-.074.01-.107v-.069c-.034-.144-.279-.245-1.553-.372a1.104 1.104 0 0 1-.911-.852v.007a2.035 2.035 0 0 0-.051.146c.016-.053.033-.094.051-.146v-.007a3.257 3.257 0 0 1 1.249-1.553c.031-.025-.126.007-.093-.017.102-.051.211-.103.329-.145.059-.018-.245-.134-.515-.11a1.545 1.545 0 0 0-.473.11c.067-.049.252-.118.21-.118a2.837 2.837 0 0 0-.97.363c0-.033.01-.06.018-.083a1.474 1.474 0 0 0-.6.464v-.112a2.706 2.706 0 0 0-.295.28h-.008a3.92 3.92 0 0 0-2.205-.184l-.008-.009h.008a1.684 1.684 0 0 1-.387-.439l-.01.007-.015-.016c-.053-.068-.093-.152-.147-.246-.04-.06-.074-.136-.116-.21 0 0 0-.008-.008-.008-.01 0-.026.077-.033.049a2.668 2.668 0 0 1-.179-1.053H5.28a1.12 1.12 0 0 0-.448.589c-.041.086-.067.128-.092.179v-.028l.024-.125c-.006.009-.006.017-.017.025a1.06 1.06 0 0 0-.15.23 1.117 1.117 0 0 0-.103.243v-.042c0-.034.009-.085 0-.067l-.009.023a5.968 5.968 0 0 0-.506 1.902c-.016.118-.016.228-.016.337v.018a4.422 4.422 0 0 0-.514.683 9.703 9.703 0 0 0-1.082 2.659c.161-.354.354-.701.583-1.021a9.332 9.332 0 0 0-.659 3.454c.076-.346.169-.684.278-1.022a8.737 8.737 0 0 0 .787 4.062 9.397 9.397 0 0 0 3.738 4.229 8.052 8.052 0 0 0 2.169 1.048c.102.033.213.074.313.109-.034-.018-.059-.035-.092-.042a9.912 9.912 0 0 0 2.818.413c3.387 0 4.501-1.292 4.61-1.418.16-.151.303-.331.396-.541.068-.024.127-.05.195-.084l.041-.016c.051-.026.075-.034.075-.034a7.11 7.11 0 0 0 1.437-.896 3.475 3.475 0 0 0 1.326-1.951c.125-.286.125-.6.024-.894.05-.084.094-.161.101-.178a7.954 7.954 0 0 0 1.199-3.876v-.116a4.918 4.918 0 0 0-.072-.872z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFirebase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.239 15.063 7.21 2.381a.453.453 0 0 1 .847-.145l2.12 3.979-4.938 8.848zM19.24 18.14 17.363 6.469a.454.454 0 0 0-.766-.246L4.76 18.14l6.55 3.691c.411.23.912.23 1.323 0l6.607-3.691zM13.917 7.955 12.4 5.052a.452.452 0 0 0-.8 0L4.939 16.989l8.978-9.034z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFigma(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.332 8.668a3.333 3.333 0 0 0 0-6.663H8.668a3.333 3.333 0 0 0 0 6.663 3.333 3.333 0 0 0 0 6.665 3.333 3.333 0 0 0 0 6.664A3.334 3.334 0 0 0 12 18.664V8.668h3.332z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.332",
                    "cy": "12",
                    "r": "3.332"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFacebook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFacebookSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h8.615v-6.96h-2.338v-2.725h2.338v-2c0-2.325 1.42-3.592 3.5-3.592.699-.002 1.399.034 2.095.107v2.42h-1.435c-1.128 0-1.348.538-1.348 1.325v1.735h2.697l-.35 2.725h-2.348V21H20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoFacebookCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2.002c-5.522 0-9.999 4.477-9.999 9.999 0 4.99 3.656 9.126 8.437 9.879v-6.988h-2.54v-2.891h2.54V9.798c0-2.508 1.493-3.891 3.776-3.891 1.094 0 2.24.195 2.24.195v2.459h-1.264c-1.24 0-1.628.772-1.628 1.563v1.875h2.771l-.443 2.891h-2.328v6.988C18.344 21.129 22 16.992 22 12.001c0-5.522-4.477-9.999-9.999-9.999z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoEtsy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.139 14.058c-.438 0-.693-.294-.693-1.058v-2.696l1.456.112.074-.694-1.496.074v-1.53h-.438c-.216 1.201-.759 1.638-1.488 1.712v.364h.869v3.062c0 .836.588 1.271 1.313 1.271.585 0 1.202-.255 1.418-.763l-.217-.255c-.108.18-.402.401-.798.401zm-3.494-.803c-.294.69-.767.729-1.24.729h-1.53c-.508 0-.729-.186-.729-.62v-2.258s1.092 0 1.457.039c.291.035.438.109.546.473l.108.511h.438l-.039-1.309.074-1.278h-.434l-.147.585c-.073.399-.147.438-.546.508-.508.038-1.457.038-1.457.038V7.979c0-.112 0-.147.185-.147h2.291c.402 0 .62.326.763.98l.147.512h.399c.039-1.457.074-2.074.074-2.074s-.981.105-1.562.105H3.53L2 7.324v.399l.508.107c.367.074.475.147.475.473 0 0 .039.984.039 2.619 0 1.639-.039 2.623-.039 2.623 0 .291-.108.399-.475.473L2 14.131v.396l1.565-.035h2.623c.581 0 1.965.035 1.965.035.034-.361.216-1.964.255-2.146H8.04l-.395.874zm6.04-2.622c0-.474.437-.655.875-.655.36 0 .653.147.729.325l.255.729.361-.035c0-.364.038-.838.111-1.201-.328-.147-.983-.221-1.421-.221-.984 0-1.747.441-1.747 1.387 0 1.674 2.44 1.31 2.44 2.549 0 .399-.256.729-.876.729-.581 0-.837-.294-.945-.585l-.29-.693h-.369c.04.476.074.948 0 1.382 0 0 .767.294 1.531.294 1.022 0 1.858-.507 1.858-1.457 0-1.674-2.512-1.421-2.512-2.548zm6.369-.945v.364l.259.074c.252.07.36.178.36.363 0 .108-.034.144-.073.291-.108.291-.802 2.003-1.162 2.767a75.566 75.566 0 0 1-1.093-2.949c-.035-.073-.035-.108-.035-.146 0-.148.105-.292.361-.326l.329-.074v-.364l-1.346.073-1.096-.039v.368l.187.069c.251.074.287.11.469.512.693 1.53 1.457 3.529 1.716 4.15-.584 1.019-1.204 1.309-1.677 1.309-.291 0-.399-.147-.435-.329l-.146-.763-.4.035c-.073.477-.147.984-.255 1.383.287.182.616.294 1.053.293.691 0 1.675-.182 2.623-2.332l1.601-3.747c.145-.293.182-.329.546-.476l.183-.144v-.362l-.945.034-1.024-.034z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoEdge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.349 13.684H8.874c0 .433.063.825.195 1.178a3.334 3.334 0 0 0 1.381 1.634c.309.196.646.359 1.005.484.356.13.729.226 1.107.288.821.13 1.658.123 2.477-.021a9.79 9.79 0 0 0 2.421-.783c.393-.18.79-.376 1.201-.594v3.805a13.453 13.453 0 0 1-2.711.978c-.457.112-.92.196-1.396.246-.486.054-.975.079-1.464.079a8.185 8.185 0 0 1-1.95-.232 7.679 7.679 0 0 1-1.762-.668 7.29 7.29 0 0 1-1.51-1.062 6.67 6.67 0 0 1-1.941-3.103 6.978 6.978 0 0 1-.267-1.953c0-.737.101-1.439.303-2.11a6.718 6.718 0 0 1 2.264-3.342 7.38 7.38 0 0 1 1.847-1.066 3.891 3.891 0 0 0-.869 1.329 5.682 5.682 0 0 0-.401 1.538h6.391c0-.646-.063-1.207-.196-1.689-.131-.484-.342-.885-.637-1.201A2.64 2.64 0 0 0 13.23 6.7c-.462-.16-1.021-.241-1.675-.241-.771 0-1.543.111-2.314.344a9.804 9.804 0 0 0-2.2.955c-.695.412-1.335.897-1.919 1.452a9.167 9.167 0 0 0-1.474 1.819c.084-.742.247-1.474.485-2.18a9.304 9.304 0 0 1 .912-1.938 8.622 8.622 0 0 1 1.303-1.609 7.735 7.735 0 0 1 1.655-1.235 8.45 8.45 0 0 1 1.955-.792 10.042 10.042 0 0 1 2.233-.254c.46 0 .917.041 1.375.124.457.084.903.196 1.339.342a8.012 8.012 0 0 1 2.315 1.239 7.95 7.95 0 0 1 1.711 1.833c.463.692.813 1.459 1.055 2.292s.365 1.701.365 2.602v2.23h-.002z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoEbay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.021 12.111V8.004h1.001v2.525c.493-.586 1.17-.756 1.838-.756 1.118 0 2.361.754 2.361 2.383 0 .195-.014.381-.051.559.2-.797 1.063-1.09 2.418-1.123.426-.016.914-.016 1.302-.016v-.111c0-.738-.464-1.039-1.276-1.039-.602 0-1.04.25-1.09.676H12.46c.113-1.076 1.253-1.352 2.242-1.352.889 0 1.666.225 2.017.852l-.365-.702h1.177l1.716 3.443 1.716-3.445H22l-3.105 6.098h-1.124l.894-1.703-1.945-3.656c.108.213.167.465.167.777v2.055c0 .289.009.574.034.838h-.931a5.478 5.478 0 0 1-.038-.639c-.503.613-1.103.803-1.937.803-1.236 0-1.897-.652-1.897-1.416 0-.125.013-.236.031-.338-.251 1.041-1.135 1.74-2.31 1.74-.727 0-1.414-.262-1.837-.775 0 .201-.013.412-.033.611h-.986c.018-.324.034-.713.034-1.037v-.877H2.985c.054.914.683 1.451 1.547 1.451.599 0 1.131-.25 1.309-.775h1.035c-.2 1.078-1.344 1.439-2.329 1.439-1.789.018-2.582-.973-2.582-2.301 0-1.463.819-2.428 2.602-2.428 1.409 0 2.445.738 2.454 2.342v.004zm7.627.153c-.915.027-1.479.193-1.479.793 0 .389.301.809 1.09.809 1.052 0 1.615-.574 1.615-1.514v-.109c-.376 0-.826.006-1.239.02h.011l.002.001zm-5.059 1.564c.927 0 1.566-.672 1.566-1.686s-.642-1.686-1.58-1.686c-.928 0-1.578.672-1.578 1.686s.639 1.686 1.565 1.686h.027zM5.958 11.73c-.037-.939-.714-1.291-1.44-1.291-.788 0-1.414.395-1.516 1.291h2.956z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDrupal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.474 14.42a3.162 3.162 0 1 0 0 6.324 3.162 3.162 0 0 0 0-6.324zm3.936-.606a5.433 5.433 0 0 1 1.513 3.769 5.441 5.441 0 0 1-2.335 4.47c2.609-.803 4.771-2.767 5.737-5.142 1.338-3.288.09-5.761-1.999-8.005.066.288.103.592.103.898a4.175 4.175 0 0 1-3.019 4.01zm-3.577-4.003c0 1.34 1.087 2.419 2.42 2.419s2.423-1.087 2.423-2.419a2.418 2.418 0 0 0-2.417-2.417 2.425 2.425 0 0 0-2.426 2.417z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.303 21.093a5.435 5.435 0 0 1-1.276-3.51 5.441 5.441 0 0 1 4.8-5.408 4.162 4.162 0 0 1 3.99-6.492c-1.361-1.176-2.724-2.369-3.799-3.672.547 5.714-5.2 3.638-7.332 8.904-1.422 3.527-.138 7.892 3.617 10.178z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDropbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.004 3.5 2 6.689l5.004 3.186 5.002-3.186zm10.005 0-5.003 3.189 5.003 3.186 5.003-3.186zM2 13.062l5.004 3.187 5.002-3.187-5.002-3.187zm15.009-3.187-5.003 3.187 5.003 3.187 5.003-3.187zM7.004 17.311l5.002 3.189 5.003-3.189-5.003-3.186z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDribbble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.66 6.98a9.932 9.932 0 0 0-3.641-3.64C15.486 2.447 13.813 2 12 2s-3.486.447-5.02 1.34c-1.533.893-2.747 2.107-3.64 3.64S2 10.187 2 12s.446 3.487 1.34 5.02a9.924 9.924 0 0 0 3.641 3.64C8.514 21.553 10.187 22 12 22s3.486-.447 5.02-1.34a9.932 9.932 0 0 0 3.641-3.64C21.554 15.487 22 13.813 22 12s-.446-3.487-1.34-5.02zM12 3.66c2 0 3.772.64 5.32 1.919-.92 1.174-2.286 2.14-4.1 2.9-1.002-1.813-2.088-3.327-3.261-4.54A7.715 7.715 0 0 1 12 3.66zM5.51 6.8a8.116 8.116 0 0 1 2.711-2.22c1.212 1.201 2.325 2.7 3.34 4.5-2 .6-4.114.9-6.341.9-.573 0-1.006-.013-1.3-.04A8.549 8.549 0 0 1 5.51 6.8zM3.66 12c0-.054.003-.12.01-.2.007-.08.01-.146.01-.2.254.014.641.02 1.161.02 2.666 0 5.146-.367 7.439-1.1.187.373.381.793.58 1.26-1.32.293-2.674 1.006-4.061 2.14S6.4 16.247 5.76 17.5c-1.4-1.587-2.1-3.42-2.1-5.5zM12 20.34c-1.894 0-3.594-.587-5.101-1.759.601-1.187 1.524-2.322 2.771-3.401 1.246-1.08 2.483-1.753 3.71-2.02a29.441 29.441 0 0 1 1.56 6.62 8.166 8.166 0 0 1-2.94.56zm7.08-3.96a8.351 8.351 0 0 1-2.58 2.621c-.24-2.08-.7-4.107-1.379-6.081.932-.066 1.765-.1 2.5-.1.799 0 1.686.034 2.659.1a8.098 8.098 0 0 1-1.2 3.46zm-1.24-5c-1.16 0-2.233.047-3.22.14a27.053 27.053 0 0 0-.68-1.62c2.066-.906 3.532-2.006 4.399-3.3 1.2 1.414 1.854 3.027 1.96 4.84-.812-.04-1.632-.06-2.459-.06z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDocker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.17 9.82a4.76 4.76 0 0 0-.84.07 3.12 3.12 0 0 0-1.43-2.14l-.28-.16-.19.27a3.7 3.7 0 0 0-.51 1.19 2.84 2.84 0 0 0 .33 2.22 4.11 4.11 0 0 1-1.45.35H2.63a.63.63 0 0 0-.63.62 9.6 9.6 0 0 0 .58 3.39 5 5 0 0 0 2 2.6 8.86 8.86 0 0 0 4.42.95 13.27 13.27 0 0 0 2.42-.18 10.09 10.09 0 0 0 3.19-1.15A8.9 8.9 0 0 0 16.78 16a11.94 11.94 0 0 0 2.13-3.67h.19a3.08 3.08 0 0 0 2.23-.84 2.36 2.36 0 0 0 .59-.87l.08-.22-.2-.16a2.69 2.69 0 0 0-1.63-.42z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.61 9.35H3.85a.16.16 0 0 0-.16.15v1.58a.16.16 0 0 0 .16.15h1.76a.16.16 0 0 0 .16-.15V9.5a.16.16 0 0 0-.16-.15zm2.44 0H6.28a.16.16 0 0 0-.16.15v1.58a.16.16 0 0 0 .16.15h1.77a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15zm2.47 0H8.75a.15.15 0 0 0-.15.15v1.58a.15.15 0 0 0 .15.15h1.77a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15zm.67 0a.15.15 0 0 0-.19.15v1.58a.15.15 0 0 0 .15.15H13a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15zM6.28 7.09H8a.16.16 0 0 1 .16.16v1.56A.16.16 0 0 1 8 9H6.28a.15.15 0 0 1-.15-.15V7.24a.15.15 0 0 1 .15-.15zm2.47 0h1.77a.15.15 0 0 1 .15.15v1.57a.16.16 0 0 1-.16.16H8.75a.15.15 0 0 1-.15-.15V7.24a.15.15 0 0 1 .15-.15zm2.44 0H13a.15.15 0 0 1 .15.15v1.57A.15.15 0 0 1 13 9h-1.81a.16.16 0 0 1-.19-.19V7.24a.15.15 0 0 1 .19-.15z"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "11.04",
                    "y": "4.82",
                    "width": "2.07",
                    "height": "1.88",
                    "rx": ".15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.65 9.35a.15.15 0 0 0-.15.15v1.58a.15.15 0 0 0 .15.15h1.77a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDjango(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.533 12.249c-.011 1.985 1.445 3.168 3.768 2.63V9.618c-2.352-.716-3.758.733-3.768 2.631m3.839-10.238h3.199v15.143c-3.066.501-6.004.819-8.104-.355-2.705-1.513-2.923-6.319-.782-8.46 1.085-1.085 3.271-1.85 5.616-1.351V2.225c-.006-.101-.012-.202.071-.214m8.389 3.342h-3.199V2.011h3.199v3.342z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.761 7.044c-.003 2.356-.003 4.048-.003 6.911-.136 2.813-.104 5.052-1.135 6.398-.203.266-.634.652-.995.924-.303.228-.881.691-1.208.711-.331.021-1.18-.459-1.564-.64-.505-.237-.971-.553-1.493-.71 1.218-.754 2.372-1.32 2.844-2.844.41-1.326.355-3.247.355-5.119 0-1.849.009-3.998.009-5.63l3.19-.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDiscourse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.077 3C7.149 3 3 6.96 3 11.843V21l9.075-.01c4.928 0 8.925-4.11 8.925-8.993C21 7.113 17 3 12.077 3zm3.92 12.859a5.568 5.568 0 0 1-6.102 1.043l-3.595.805 1.001-3.192a5.435 5.435 0 0 1 .11-5.415 5.55 5.55 0 0 1 4.753-2.678v.001h.006a5.533 5.533 0 0 1 5.131 3.438 5.442 5.442 0 0 1-1.304 5.998z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDiscord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.593 10.971c-.542 0-.969.475-.969 1.055 0 .578.437 1.055.969 1.055.541 0 .968-.477.968-1.055.011-.581-.427-1.055-.968-1.055zm3.468 0c-.542 0-.969.475-.969 1.055 0 .578.437 1.055.969 1.055.541 0 .968-.477.968-1.055-.001-.581-.427-1.055-.968-1.055z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.678 3H4.947A1.952 1.952 0 0 0 3 4.957v12.844c0 1.083.874 1.957 1.947 1.957H15.72l-.505-1.759 1.217 1.131 1.149 1.064L19.625 22V4.957A1.952 1.952 0 0 0 17.678 3zM14.01 15.407s-.342-.408-.626-.771c1.244-.352 1.719-1.13 1.719-1.13-.39.256-.76.438-1.093.562a6.679 6.679 0 0 1-3.838.398 7.944 7.944 0 0 1-1.396-.41 5.402 5.402 0 0 1-.693-.321c-.029-.021-.057-.029-.085-.048a.117.117 0 0 1-.039-.03c-.171-.094-.266-.16-.266-.16s.456.76 1.663 1.121c-.285.36-.637.789-.637.789-2.099-.067-2.896-1.444-2.896-1.444 0-3.059 1.368-5.538 1.368-5.538 1.368-1.027 2.669-.998 2.669-.998l.095.114c-1.71.495-2.499 1.245-2.499 1.245s.21-.114.561-.275c1.016-.446 1.823-.57 2.156-.599.057-.009.105-.019.162-.019a7.756 7.756 0 0 1 4.778.893s-.751-.712-2.366-1.206l.133-.152s1.302-.029 2.669.998c0 0 1.368 2.479 1.368 5.538 0-.001-.807 1.376-2.907 1.443z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDiscordAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.82 4.26a10.14 10.14 0 0 0-.53 1.1 14.66 14.66 0 0 0-4.58 0 10.14 10.14 0 0 0-.53-1.1 16 16 0 0 0-4.13 1.3 17.33 17.33 0 0 0-3 11.59 16.6 16.6 0 0 0 5.07 2.59A12.89 12.89 0 0 0 8.23 18a9.65 9.65 0 0 1-1.71-.83 3.39 3.39 0 0 0 .42-.33 11.66 11.66 0 0 0 10.12 0q.21.18.42.33a10.84 10.84 0 0 1-1.71.84 12.41 12.41 0 0 0 1.08 1.78 16.44 16.44 0 0 0 5.06-2.59 17.22 17.22 0 0 0-3-11.59 16.09 16.09 0 0 0-4.09-1.35zM8.68 14.81a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.93 1.93 0 0 1 1.8 2 1.93 1.93 0 0 1-1.8 2zm6.64 0a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.92 1.92 0 0 1 1.8 2 1.92 1.92 0 0 1-1.8 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDigitalocean(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.005 21.992v-3.877c4.104 0 7.288-4.068 5.714-8.388a5.81 5.81 0 0 0-3.457-3.446c-4.319-1.563-8.389 1.61-8.389 5.714H2.008c0-6.541 6.325-11.642 13.184-9.499 2.991.94 5.383 3.321 6.313 6.313 2.141 6.858-2.96 13.183-9.5 13.183z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.017 18.139H8.152v-3.866h3.865zm-3.865 2.959H5.193v-2.959h2.959zm-2.959-2.959H2.711v-2.483h2.482v2.483z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDigg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.803 8.8v6.801h3.2v.799h-3.2v1.602h5.2V8.8h-5.2zm-6 0v6.801h3.199v.799h-3.199v1.602h5.199V8.8h-5.199zM5.2 5.999V8.8H2v6.801h5.201V5.999H5.2zM10.001 8.8h-2v6.801h2V8.8zM20.003 14h-1.2v-3.601h1.2V14zM5.2 14H4v-3.601h1.2V14zm8.802 0h-1.2v-3.601h1.2V14zm-4.001-8.001h-2v2h2v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDeviantart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.57 3h-3.271l-.326.33-1.544 2.942-.486.327H6.432v4.495h3.03l.27.327-3.3 6.305v3.273h3.272l.327-.33 1.543-2.943.486-.326h5.511v-4.495h-3.03l-.269-.329 3.299-6.303L17.57 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDevTo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.826 10.083a.784.784 0 0 0-.468-.175h-.701v4.198h.701a.786.786 0 0 0 .469-.175c.155-.117.233-.292.233-.525v-2.798c.001-.233-.079-.408-.234-.525zM19.236 3H4.764C3.791 3 3.002 3.787 3 4.76v14.48c.002.973.791 1.76 1.764 1.76h14.473c.973 0 1.762-.787 1.764-1.76V4.76A1.765 1.765 0 0 0 19.236 3zM9.195 13.414c0 .755-.466 1.901-1.942 1.898H5.389V8.665h1.903c1.424 0 1.902 1.144 1.903 1.899v2.85zm4.045-3.562H11.1v1.544h1.309v1.188H11.1v1.543h2.142v1.188h-2.498a.813.813 0 0 1-.833-.792V9.497a.813.813 0 0 1 .792-.832h2.539l-.002 1.187zm4.165 4.632c-.531 1.235-1.481.99-1.906 0l-1.548-5.818h1.309l1.193 4.569 1.188-4.569h1.31l-1.546 5.818z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDeezer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.68 5.47H22V8h-4.32zm0 3.51H22v2.53h-4.32zm0 3.51H22v2.53h-4.32zM2 16h4.32v2.53H2zm5.22 0h4.32v2.53H7.22zm5.23 0h4.32v2.53h-4.32zm5.23 0H22v2.53h-4.32zm-5.23-3.51h4.32v2.53h-4.32zm-5.23 0h4.32v2.53H7.22zm0-3.51h4.32v2.53H7.22z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoDailymotion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.551 11.485a2.327 2.327 0 0 0-2.328 2.332c0 1.314 1.013 2.313 2.441 2.313l-.012.002c1.192 0 2.193-.983 2.193-2.28.001-1.349-1.001-2.367-2.294-2.367z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm15.52 15.605h-2.682v-1.058c-.825.81-1.667 1.103-2.786 1.103-1.142 0-2.124-.371-2.947-1.114-1.086-.956-1.648-2.227-1.648-3.701 0-1.351.524-2.561 1.507-3.506.878-.859 1.946-1.298 3.139-1.298 1.14 0 2.018.385 2.647 1.192V6.118l2.77-.574v-.002l.002.003h-.002v13.06z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoCss3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.192 3.143h15.615l-1.42 16.034-6.404 1.812-6.369-1.813L4.192 3.143zM16.9 6.424l-9.8-.002.158 1.949 7.529.002-.189 2.02H9.66l.179 1.913h4.597l-.272 2.62-2.164.598-2.197-.603-.141-1.569h-1.94l.216 2.867L12 17.484l3.995-1.137.905-9.923z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoCreativeCommons(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.354 6.479a10.021 10.021 0 0 0-7.421-4.429c-3.108-.294-6.031.771-8.123 2.963C3.533 6.35 2.699 7.839 2.21 9.66c-.217.805-.247 1.104-.244 2.396.002 1.293.034 1.599.255 2.432a10.232 10.232 0 0 0 7.451 7.332c.315.078.702.16.859.182.696.097 2.381.056 3.131-.075 3.088-.538 5.832-2.531 7.24-5.258 1.644-3.181 1.426-7.222-.548-10.19zm-.41 7.688c-.808 2.99-3.263 5.272-6.361 5.912-4.831.997-9.538-2.658-9.839-7.641-.194-3.217 1.755-6.446 4.745-7.863 1.133-.536 2.045-.733 3.425-.738 1.327-.004 2.064.132 3.223.596 2.324.931 4.146 3.04 4.816 5.573.281 1.06.276 3.103-.009 4.161z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.042 14.955c-.915-.324-1.616-1.275-1.74-2.36-.183-1.607.422-2.856 1.654-3.415.669-.303 1.882-.296 2.603.016.438.19 1.261.933 1.261 1.139 0 .033-.284.201-.631.372l-.632.312-.337-.337c-.187-.188-.475-.363-.649-.396-.433-.082-.952.111-1.187.44-.389.546-.415 1.972-.048 2.533.191.291.512.494.813.518.635.05.796-.006 1.172-.401l.379-.398.488.269c.269.148.527.305.575.347.164.148-.592.92-1.199 1.224-.517.259-.679.293-1.358.286-.425-.006-.949-.074-1.164-.149zm5.816 0c-.901-.32-1.591-1.241-1.739-2.325-.215-1.569.419-2.888 1.654-3.45.717-.324 1.934-.3 2.661.056.45.221 1.201.911 1.201 1.104 0 .034-.295.203-.654.377l-.654.317-.341-.37c-.304-.332-.385-.369-.802-.369-.576 0-.945.225-1.145.698-.18.423-.201 1.461-.043 1.934.324.961 1.505 1.188 2.175.419l.304-.346.58.294c.32.161.582.319.582.352 0 .219-.75.918-1.256 1.17-.517.259-.679.293-1.358.287-.425-.005-.949-.073-1.165-.148z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoCodepen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.838 8.445c0-.001-.001-.001 0 0l-.003-.004-.001-.001v-.001a.809.809 0 0 0-.235-.228l-9.164-6.08a.834.834 0 0 0-.898 0L2.371 8.214A.786.786 0 0 0 2 8.897v6.16a.789.789 0 0 0 .131.448v.001l.002.002.01.015v.002h.001l.001.001.001.001c.063.088.14.16.226.215l9.165 6.082a.787.787 0 0 0 .448.139.784.784 0 0 0 .45-.139l9.165-6.082a.794.794 0 0 0 .371-.685v-6.16a.793.793 0 0 0-.133-.452zm-9.057-4.172 6.953 4.613-3.183 2.112-3.771-2.536V4.273zm-1.592 0v4.189l-3.771 2.536-3.181-2.111 6.952-4.614zm-7.595 6.098 2.395 1.59-2.395 1.611v-3.201zm7.595 9.311-6.96-4.617 3.195-2.15 3.765 2.498v4.269zm.795-5.653-3.128-2.078 3.128-2.105 3.131 2.105-3.131 2.078zm.797 5.653v-4.27l3.766-2.498 3.193 2.15-6.959 4.618zm7.597-6.11-2.396-1.611 2.396-1.59v3.201z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoChrome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.742 2.04c-1.404.183-3.06.808-4.281 1.626-1.01.664-2.397 2.02-2.309 2.251.193.501 3.28 5.658 3.33 5.562.038-.067.095-.279.123-.49.25-1.385 1.425-2.704 2.897-3.253.568-.221.683-.221 5.495-.27l4.917-.047-.395-.646c-1.385-2.26-3.522-3.819-6.197-4.512-.731-.193-2.81-.318-3.58-.22z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.2 7.217c-.453.799-.983 2.415-1.107 3.358-.588 4.273 1.568 8.4 5.379 10.315.894.452 2.174.885 2.732.933l.356.029 1.674-2.838c.915-1.559 1.655-2.849 1.636-2.868-.02-.019-.231.039-.481.125-1.569.53-3.387.086-4.57-1.116-.424-.424-1.002-1.357-2.84-4.542C4.71 8.41 3.642 6.601 3.603 6.601c-.028 0-.211.279-.403.616z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.15 8.804c1.222 1.242 1.655 3.003 1.116 4.59-.086.26-1.212 2.271-2.501 4.485-1.29 2.203-2.349 4.031-2.349 4.06 0 .115 1.328.057 2.175-.087 4.32-.74 7.573-4.002 8.265-8.276.26-1.558.164-2.925-.307-4.503l-.25-.837h-6.707l.557.568z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.608 8.563C9.598 8.987 8.905 9.7 8.53 10.71c-.173.453-.202.713-.173 1.424.03.75.068.963.347 1.511.366.75.962 1.329 1.751 1.703.462.221.654.25 1.54.25.895 0 1.077-.029 1.559-.26.712-.326 1.462-1.077 1.79-1.79.23-.48.259-.663.259-1.558 0-.886-.029-1.078-.25-1.54-.375-.788-.952-1.386-1.703-1.75-.568-.28-.742-.318-1.56-.348-.788-.019-.99.01-1.48.212z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoCPlusPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.66 7a1.51 1.51 0 0 0-.55-.57l-7.34-4.24a1.67 1.67 0 0 0-1.54 0L3.89 6.43a1.68 1.68 0 0 0-.77 1.33v8.48a1.57 1.57 0 0 0 .22.76 1.51 1.51 0 0 0 .55.57l7.34 4.24a1.67 1.67 0 0 0 1.54 0l7.34-4.24a1.51 1.51 0 0 0 .55-.57 1.57 1.57 0 0 0 .22-.76V7.76a1.57 1.57 0 0 0-.22-.76zM12 17.92A5.92 5.92 0 1 1 17.13 9L16 9.71l-.36.2-1 .61A3 3 0 0 0 9 12a2.88 2.88 0 0 0 .4 1.48 3 3 0 0 0 5.13 0l2.6 1.52A5.94 5.94 0 0 1 12 17.92zm5.92-5.59h-.66V13h-.65v-.66H16v-.66h.66V11h.65v.66h.66zm2.47 0h-.66V13h-.66v-.66h-.65v-.66h.65V11h.66v.66h.66z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoBootstrap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.002 2.997H5.999A3.011 3.011 0 0 0 2.997 6v12.002a3.012 3.012 0 0 0 3.002 3.001h12.003a3.012 3.012 0 0 0 3.001-3.001V6a3.012 3.012 0 0 0-3.001-3.003zm-1.64 12.647c-.152.36-.389.68-.693.927a3.594 3.594 0 0 1-1.206.614c-.49.151-1.074.229-1.75.229H7.888V6.909h5.103c.943 0 1.7.213 2.267.646.569.436.854 1.082.854 1.958 0 .528-.13.983-.389 1.357-.259.373-.63.664-1.111.868v.034c.642.135 1.137.438 1.464.912.327.473.493 1.069.493 1.789 0 .405-.078.788-.225 1.147l.02.021v.003zm-2.084-2.589c-.309-.282-.739-.419-1.297-.419H9.737v3.276h3.253c.554 0 .991-.144 1.298-.435.308-.289.464-.701.464-1.229-.005-.518-.156-.919-.464-1.193h-.014.004zm-.451-2.119c.299-.251.444-.613.444-1.084 0-.526-.131-.902-.397-1.116-.264-.214-.646-.326-1.146-.326H9.727v2.898h3.001c.436.001.81-.127 1.099-.372z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoBlogger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.954 10.667c-.072-.322-.272-.621-.502-.745-.07-.039-.522-.088-1.004-.109-.809-.036-.898-.052-1.152-.201-.405-.237-.516-.493-.518-1.187-.002-1.327-.554-2.559-1.646-3.67-.776-.793-1.645-1.329-2.634-1.629-.236-.072-.768-.097-2.545-.118-2.787-.033-3.405.024-4.356.402-1.748.697-3.008 2.166-3.465 4.05-.087.353-.103.92-.124 4.177-.025 4.08.004 4.68.258 5.488.212.668.425 1.077.861 1.657.835 1.108 2.083 1.907 3.334 2.133.595.107 7.931.135 8.683.032 1.306-.178 2.331-.702 3.293-1.684.694-.71 1.129-1.479 1.414-2.499.117-.424.127-.63.149-3.117.017-1.878.002-2.758-.046-2.98zM8.007 8.108c.313-.316.399-.329 2.364-.329 1.764 0 1.822.004 2.081.134.375.189.538.456.538.88 0 .384-.153.653-.493.869-.184.115-.293.123-2.021.133-1.067.007-1.916-.013-2.043-.048-.669-.184-.918-1.143-.426-1.639zm7.706 8.037-.597.098-3.114.035c-2.736.033-3.511-.018-3.652-.08-.288-.124-.554-.472-.602-.78-.042-.292.104-.696.33-.9.285-.257.409-.266 3.911-.27 3.602-.002 3.583-.003 3.925.315.482.45.381 1.251-.201 1.582z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoBlender(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.427 13.011c.037-.667.363-1.254.856-1.671a2.855 2.855 0 0 1 1.844-.66c.71 0 1.36.25 1.845.66.492.417.819 1.005.856 1.671.038.686-.237 1.323-.721 1.795a2.829 2.829 0 0 1-1.979.782 2.83 2.83 0 0 1-1.981-.782c-.483-.472-.759-1.109-.72-1.795z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.124 14.361c.005.26.089.767.213 1.164a6.156 6.156 0 0 0 1.328 2.299 6.833 6.833 0 0 0 2.323 1.667 7.465 7.465 0 0 0 3.05.635 7.495 7.495 0 0 0 3.051-.645 6.913 6.913 0 0 0 2.321-1.675 6.196 6.196 0 0 0 1.326-2.303 5.76 5.76 0 0 0 .25-1.285 5.942 5.942 0 0 0-.888-3.594 6.496 6.496 0 0 0-1.545-1.703l.001-.001-6.249-4.799-.016-.014c-.411-.314-1.101-.313-1.551.002-.457.319-.508.846-.104 1.18l-.001.001 2.606 2.121-7.943.009h-.012c-.656 0-1.287.432-1.412.976-.128.555.318 1.015 1.001 1.017l-.001.003 4.027-.008-7.188 5.516-.027.021c-.677.519-.896 1.382-.47 1.929.434.556 1.354.556 2.04.002l3.922-3.209c.001 0-.056.433-.052.694zm10.078 1.45c-.808.824-1.938 1.291-3.163 1.293-1.226.002-2.356-.461-3.165-1.283a3.739 3.739 0 0 1-.864-1.352 3.503 3.503 0 0 1-.199-1.511c.044-.505.193-.987.434-1.422.236-.429.562-.815.962-1.144a4.477 4.477 0 0 1 2.832-.988 4.478 4.478 0 0 1 2.832.98c.399.326.725.711.961 1.139.24.436.39.916.434 1.421a3.52 3.52 0 0 1-.198 1.511 3.804 3.804 0 0 1-.866 1.356z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoBitcoin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.953 8.819-.547 2.19c.619.154 2.529.784 2.838-.456.322-1.291-1.673-1.579-2.291-1.734zm-.822 3.296-.603 2.415c.743.185 3.037.921 3.376-.441.355-1.422-2.029-1.789-2.773-1.974z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.421 2.299C9.064.964 3.641 4.224 2.306 9.581.97 14.936 4.23 20.361 9.583 21.697c5.357 1.335 10.783-1.924 12.117-7.281 1.336-5.356-1.924-10.781-7.279-12.117zm1.991 8.275c-.145.974-.686 1.445-1.402 1.611.985.512 1.485 1.298 1.009 2.661-.592 1.691-1.998 1.834-3.87 1.48l-.454 1.82-1.096-.273.447-1.794a44.624 44.624 0 0 1-.875-.228l-.449 1.804-1.095-.275.454-1.823c-.257-.066-.517-.136-.782-.202L6.87 15l.546-1.256s.808.215.797.199c.311.077.448-.125.502-.261l.719-2.875.115.029a.864.864 0 0 0-.114-.037l.512-2.053c.013-.234-.066-.528-.511-.639.018-.011-.797-.198-.797-.198l.291-1.172 1.514.378-.001.005c.227.057.461.111.7.165l.449-1.802 1.097.273-.44 1.766c.294.067.591.135.879.207l.438-1.755 1.097.273-.449 1.802c1.384.479 2.396 1.195 2.198 2.525z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoBing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.71 3 3.593 1.264v12.645l5.061-2.919-2.48-1.165-1.566-3.897 7.974 2.802v4.073l-8.984 5.183-3.595-2L5.71 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoBehance(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.803 5.731c.589 0 1.119.051 1.605.155.483.103.895.273 1.243.508.343.235.611.547.804.939.187.387.28.871.28 1.443 0 .62-.14 1.138-.421 1.551-.283.414-.7.753-1.256 1.015.757.219 1.318.602 1.69 1.146.374.549.557 1.206.557 1.976 0 .625-.119 1.162-.358 1.613a3.11 3.11 0 0 1-.974 1.114 4.315 4.315 0 0 1-1.399.64 6.287 6.287 0 0 1-1.609.206H2V5.731h5.803zm-.351 4.972c.48 0 .878-.114 1.192-.345.312-.228.463-.604.463-1.119 0-.286-.051-.522-.151-.707a1.114 1.114 0 0 0-.417-.428 1.683 1.683 0 0 0-.597-.215 3.609 3.609 0 0 0-.697-.061H4.71v2.875h2.742zm.151 5.239c.267 0 .521-.023.76-.077.241-.052.455-.136.637-.261.182-.12.332-.283.44-.491.109-.206.162-.475.162-.798 0-.634-.179-1.085-.533-1.358-.355-.27-.831-.404-1.414-.404H4.71v3.39h2.893zm8.565-.041c.367.358.896.538 1.584.538.493 0 .919-.125 1.278-.373.354-.249.57-.515.653-.79h2.155c-.346 1.072-.871 1.838-1.589 2.299-.709.463-1.572.693-2.58.693-.702 0-1.334-.113-1.9-.337a4.033 4.033 0 0 1-1.439-.958 4.37 4.37 0 0 1-.905-1.485 5.433 5.433 0 0 1-.32-1.899c0-.666.111-1.289.329-1.864a4.376 4.376 0 0 1 .934-1.493c.405-.42.885-.751 1.444-.994a4.634 4.634 0 0 1 1.858-.362c.754 0 1.413.146 1.979.44a3.967 3.967 0 0 1 1.39 1.182c.363.493.622 1.058.783 1.691.161.632.217 1.292.171 1.983h-6.431c.001.704.238 1.371.606 1.729zm2.812-4.681c-.291-.322-.783-.496-1.385-.496-.391 0-.714.065-.974.199a1.97 1.97 0 0 0-.62.491 1.772 1.772 0 0 0-.328.628 2.82 2.82 0 0 0-.111.587h3.982c-.058-.624-.272-1.085-.564-1.409zm-3.918-4.663h4.989v1.215h-4.989z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoBaidu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.217 12.486c1.964-.422 1.693-2.772 1.637-3.287-.096-.788-1.028-2.172-2.291-2.061-1.588.141-1.821 2.44-1.821 2.44-.216 1.06.515 3.33 2.475 2.908m3.646-3.944c1.084 0 1.959-1.251 1.959-2.792 0-1.537-.871-2.785-1.955-2.785-1.086 0-1.966 1.242-1.966 2.785s.88 2.792 1.965 2.792m4.671.186c1.454.195 2.38-1.355 2.568-2.53.188-1.166-.754-2.528-1.776-2.763-1.031-.237-2.303 1.411-2.431 2.484-.136 1.318.188 2.627 1.634 2.813m5.751 1.973c0-.562-.46-2.253-2.19-2.253-1.729 0-1.965 1.596-1.965 2.726 0 1.077.089 2.573 2.247 2.528 2.148-.052 1.913-2.438 1.913-3.002M18.1 15.626s-2.247-1.739-3.557-3.613c-1.776-2.768-4.304-1.64-5.144-.239-.845 1.418-2.153 2.306-2.339 2.544-.188.232-2.709 1.596-2.147 4.079.563 2.483 2.528 2.439 2.528 2.439s1.446.142 3.133-.234c1.686-.375 3.13.091 3.13.091s3.92 1.317 5.005-1.212c1.072-2.537-.61-3.847-.61-3.847"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoAws(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.75 11.35a4.32 4.32 0 0 1-.79-.08 3.9 3.9 0 0 1-.73-.23l-.17-.04h-.12q-.15 0-.15.21v.33a.43.43 0 0 0 0 .19.5.5 0 0 0 .21.19 3 3 0 0 0 .76.26 4.38 4.38 0 0 0 1 .12 3 3 0 0 0 1-.14 1.94 1.94 0 0 0 .73-.37 1.81 1.81 0 0 0 .49-.58 1.79 1.79 0 0 0 .17-.78 1.54 1.54 0 0 0-.3-.93 2.15 2.15 0 0 0-1-.64l-.95-.3a2 2 0 0 1-.73-.36.65.65 0 0 1-.2-.47.66.66 0 0 1 .31-.6 1.82 1.82 0 0 1 .89-.18 2.89 2.89 0 0 1 1.27.26.79.79 0 0 0 .26.08c.1 0 .15-.08.15-.22v-.36a.38.38 0 0 0-.06-.22.56.56 0 0 0-.2-.16 1.55 1.55 0 0 0-.28-.12 3.44 3.44 0 0 0-.38-.11l-.44-.1A3.4 3.4 0 0 0 19 6a2.82 2.82 0 0 0-.83.11 2.19 2.19 0 0 0-.7.35A1.61 1.61 0 0 0 17 7a1.5 1.5 0 0 0-.18.74 1.6 1.6 0 0 0 .33 1 2.08 2.08 0 0 0 1.06.68l1 .3a1.58 1.58 0 0 1 .67.34.66.66 0 0 1 .18.47.72.72 0 0 1-.35.63 1.83 1.83 0 0 1-.96.19zM12.94 6.5a.48.48 0 0 0-.13-.26.37.37 0 0 0-.26-.07H12a.43.43 0 0 0-.26.07.42.42 0 0 0-.13.26l-1 4.4-1.14-4.4a.48.48 0 0 0-.14-.26s-.13-.07-.26-.07h-.65c-.11 0-.16.06-.16.17a1.22 1.22 0 0 0 .06.27l1.56 5.14A.61.61 0 0 0 10 12a.45.45 0 0 0 .26.06h.57a.49.49 0 0 0 .27-.06.57.57 0 0 0 .12-.27l1-4.28 1 4.29a.42.42 0 0 0 .12.26.4.4 0 0 0 .27.07h.57a.41.41 0 0 0 .25-.07.44.44 0 0 0 .14-.26l1.61-5.14a.73.73 0 0 0 0-.16.52.52 0 0 0 0-.11.15.15 0 0 0-.17-.17h-.62a.45.45 0 0 0-.26.07.68.68 0 0 0-.13.26L14 11zM5.77 8.63a5.92 5.92 0 0 0-.71-.05 2.42 2.42 0 0 0-1.63.52 1.72 1.72 0 0 0-.6 1.37 1.7 1.7 0 0 0 .49 1.28 1.82 1.82 0 0 0 1.33.48 2.48 2.48 0 0 0 2-.92 3.5 3.5 0 0 0 .2.39 2.34 2.34 0 0 0 .24.31.26.26 0 0 0 .37 0l.42-.28a.28.28 0 0 0 .13-.2.27.27 0 0 0 0-.16 3.63 3.63 0 0 1-.21-.47 2 2 0 0 1-.07-.6V8.19a2.2 2.2 0 0 0-.55-1.64A2.42 2.42 0 0 0 5.33 6a3.9 3.9 0 0 0-1 .13 3.9 3.9 0 0 0-.84.3.47.47 0 0 0-.18.14.37.37 0 0 0 0 .23v.33c0 .14 0 .2.14.2a.26.26 0 0 0 .11 0l.23-.08A4.32 4.32 0 0 1 4.42 7a3 3 0 0 1 .72-.09 1.5 1.5 0 0 1 1.08.31 1.46 1.46 0 0 1 .31 1.06v.49zm.78.9v.27a2.36 2.36 0 0 1-.07.58 1.06 1.06 0 0 1-.23.43 1.38 1.38 0 0 1-.63.42 2.12 2.12 0 0 1-.68.12.94.94 0 0 1-.7-.24.92.92 0 0 1-.24-.71.92.92 0 0 1 .33-.76 1.52 1.52 0 0 1 1-.27h.62a5.67 5.67 0 0 1 .6.16zM19.76 15a19.68 19.68 0 0 1-7.55 1.54 20 20 0 0 1-9.9-2.62c-.24-.15-.43.1-.22.29A14.68 14.68 0 0 0 12 18a14.4 14.4 0 0 0 8.1-2.47c.34-.31.03-.72-.34-.53z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.38 14.06c-.19.14-.16.33.05.3.71-.09 2.28-.27 2.56.09s-.31 1.83-.58 2.49c-.08.2.1.28.28.13a3.9 3.9 0 0 0 1.23-3.34 3.94 3.94 0 0 0-3.54.33z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoAudible(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.005 10.238v1.69l10.002 6.254 9.988-6.254v-1.69l-9.988 6.229z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.938 12.469 1.465-.938c-1.161-1.701-3.153-2.876-5.396-2.876-2.257 0-4.236 1.135-5.371 2.89.093-.093.146-.146.238-.211 2.811-2.336 6.86-1.808 9.064 1.135z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.051 13.063a2.99 2.99 0 0 1 1.78-.58c1.083 0 2.047.554 2.692 1.49l1.399-.871c-.607-.963-1.688-1.557-2.916-1.557-1.226 0-2.309.62-2.955 1.518zM5.25 9.012c4.117-3.246 9.937-2.362 13.037 1.953l.026.026 1.517-.938a9.337 9.337 0 0 0-7.823-4.235 9.35 9.35 0 0 0-7.825 4.235c.304-.342.686-.751 1.068-1.041z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoApple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.665 16.811a10.316 10.316 0 0 1-1.021 1.837c-.537.767-.978 1.297-1.316 1.592-.525.482-1.089.73-1.692.744-.432 0-.954-.123-1.562-.373-.61-.249-1.17-.371-1.683-.371-.537 0-1.113.122-1.73.371-.616.25-1.114.381-1.495.393-.577.025-1.154-.229-1.729-.764-.367-.32-.826-.87-1.377-1.648-.59-.829-1.075-1.794-1.455-2.891-.407-1.187-.611-2.335-.611-3.447 0-1.273.275-2.372.826-3.292a4.857 4.857 0 0 1 1.73-1.751 4.65 4.65 0 0 1 2.34-.662c.46 0 1.063.142 1.81.422s1.227.422 1.436.422c.158 0 .689-.167 1.593-.498.853-.307 1.573-.434 2.163-.384 1.6.129 2.801.759 3.6 1.895-1.43.867-2.137 2.08-2.123 3.637.012 1.213.453 2.222 1.317 3.023a4.33 4.33 0 0 0 1.315.863c-.106.307-.218.6-.336.882zM15.998 2.38c0 .95-.348 1.838-1.039 2.659-.836.976-1.846 1.541-2.941 1.452a2.955 2.955 0 0 1-.021-.36c0-.913.396-1.889 1.103-2.688.352-.404.8-.741 1.343-1.009.542-.264 1.054-.41 1.536-.435.013.128.019.255.019.381z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoAngular(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.483 12.482h3.034L12 8.831z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.074 3.689 6.038l1.268 10.987 7.043 3.9 7.043-3.9 1.268-10.987L12 3.074zm5.187 13.621H15.25l-1.045-2.606h-4.41L8.75 16.695H6.813L12 5.047l5.187 11.648z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoAndroid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.344 8.71c-.707 0-1.279.572-1.279 1.278v4.53a1.278 1.278 0 1 0 2.558 0v-4.53c0-.706-.572-1.278-1.279-1.278zm-12.688 0c-.707 0-1.279.572-1.279 1.278v4.53a1.278 1.278 0 1 0 2.558 0v-4.53A1.277 1.277 0 0 0 5.656 8.71zm8.889-3.809.768-1.388a.343.343 0 0 0-.133-.47.344.344 0 0 0-.471.135l-.789 1.42c-.588-.235-1.236-.368-1.92-.368s-1.332.132-1.92.367l-.789-1.418a.344.344 0 0 0-.471-.135.345.345 0 0 0-.133.47l.768 1.388C8.072 5.69 7.148 7.099 7.148 8.71c0 .011 0 .021.002.034-.002.006-.002.013-.002.019v.001h9.703V8.71c.001-1.611-.923-3.019-2.306-3.809zM9.76 6.869a.346.346 0 1 1 .005-.693.346.346 0 0 1-.005.693zm4.48 0a.347.347 0 0 1 0-.692.346.346 0 0 1 0 .692zM7.148 16.12c0 .646.525 1.171 1.174 1.171h.586v2.401a1.279 1.279 0 0 0 2.558 0v-2.401h1.066v2.401c0 .707.572 1.278 1.277 1.278.709 0 1.281-.571 1.281-1.278v-2.401h.586c.648 0 1.174-.524 1.174-1.171V9.028H7.148v7.092z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoAmazon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.027 17.023c.061-.098.156-.105.289-.02 3.035 1.76 6.338 2.645 9.906 2.645 2.381 0 4.73-.447 7.051-1.332l.262-.117c.115-.051.195-.084.244-.109.189-.074.326-.037.438.109.102.143.076.279-.1.4-.213.158-.5.342-.84.545-1.037.619-2.203 1.098-3.492 1.441a14.815 14.815 0 0 1-3.77.508c-1.889 0-3.68-.33-5.369-.99a14.875 14.875 0 0 1-4.531-2.797c-.084-.061-.125-.123-.125-.184 0-.039.016-.074.041-.109l-.004.01zm5.479-5.189c0-.84.207-1.555.619-2.152.414-.592.977-1.041 1.703-1.346.666-.281 1.465-.48 2.43-.602.326-.037.861-.086 1.6-.145v-.31c0-.773-.084-1.299-.248-1.564-.252-.359-.65-.541-1.203-.541h-.15c-.4.039-.746.162-1.039.383a1.51 1.51 0 0 0-.564.916c-.049.25-.172.387-.361.426l-2.105-.264c-.209-.051-.311-.15-.311-.326 0-.037.006-.074.018-.123.209-1.078.715-1.881 1.52-2.404.814-.514 1.752-.814 2.828-.875h.451c1.379 0 2.469.361 3.244 1.076.115.123.227.25.34.398.1.139.188.264.234.377.063.111.127.275.164.475.051.213.088.352.113.426.023.086.051.25.064.514.006.262.016.41.016.461v4.406c0 .314.049.602.137.865.088.26.174.451.262.563l.428.561a.598.598 0 0 1 .111.303c0 .102-.049.188-.148.26-1.002.877-1.553 1.352-1.639 1.428-.137.113-.313.125-.525.039a5.397 5.397 0 0 1-.439-.414l-.258-.291c-.051-.063-.141-.174-.266-.352l-.25-.363c-.676.74-1.338 1.205-2.002 1.393-.414.125-.914.188-1.529.188-.926 0-1.701-.285-2.303-.863-.598-.576-.9-1.389-.9-2.453l-.043-.063.001-.007zm3.131-.367c0 .475.117.852.355 1.139.236.285.563.428.965.428.035 0 .088-.008.16-.018.078-.012.111-.02.141-.02.512-.133.902-.461 1.189-.982a2.62 2.62 0 0 0 .299-.758c.076-.268.1-.494.111-.666.016-.166.016-.453.016-.84v-.451c-.703 0-1.24.049-1.604.148-1.063.303-1.604.977-1.604 2.029l-.029-.016v.007zm7.646 5.865c.025-.051.063-.092.109-.143.301-.201.596-.342.877-.416a6.597 6.597 0 0 1 1.344-.201c.117-.01.234 0 .346.025.539.051.873.141.977.273.053.078.074.191.074.328v.125c0 .426-.117.926-.348 1.502s-.553 1.041-.963 1.402c-.061.049-.115.074-.164.074-.025 0-.051 0-.074-.01-.076-.037-.09-.1-.055-.201.451-1.051.672-1.787.672-2.201 0-.127-.025-.227-.074-.289-.119-.137-.457-.217-1.02-.217a9.42 9.42 0 0 0-.727.039c-.303.041-.582.078-.834.115-.074 0-.123-.014-.15-.037-.025-.025-.031-.039-.018-.064 0-.014.006-.025.018-.053v-.049l.01-.002z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoAlgolia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.177 9.059a3.582 3.582 0 0 0-3.576 3.584 3.584 3.584 0 0 0 3.576 3.585 3.578 3.578 0 0 0 3.575-3.585 3.582 3.582 0 0 0-3.575-3.584zm2.518 2.268-2.366 1.229c-.07.039-.153-.017-.153-.093V9.791h.001c0-.06.054-.104.109-.104a2.943 2.943 0 0 1 2.452 1.492c.028.055.011.121-.043.148z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.578 3H5.361A2.363 2.363 0 0 0 3 5.366v13.277a2.368 2.368 0 0 0 2.361 2.371h13.217a2.367 2.367 0 0 0 2.361-2.372V5.372A2.368 2.368 0 0 0 18.578 3zm-8.112 3.404a.78.78 0 0 1 .779-.781h1.815c.43 0 .778.35.778.781v.618a.106.106 0 0 1-.131.104 5.677 5.677 0 0 0-3.106.017c-.07.016-.136-.033-.136-.104v-.635zM7.08 8.993a.78.78 0 0 1 .001-1.103l.371-.371.002-.002a.776.776 0 0 1 1.099.002l.31.311c.043.05.038.127-.017.159a5.82 5.82 0 0 0-1.296 1.3c-.044.049-.114.06-.163.011l-.306-.306-.001-.001zm5.097 8.737a5.078 5.078 0 0 1-5.074-5.087c0-2.813 2.272-5.092 5.074-5.092a5.074 5.074 0 0 1 5.074 5.086c0 2.815-2.272 5.093-5.074 5.093z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoAirbnb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 16.709c-1.013-1.271-1.609-2.386-1.808-3.34-.197-.769-.12-1.385.218-1.848.357-.532.89-.791 1.589-.791s1.231.259 1.589.796c.335.458.419 1.075.215 1.848-.218.974-.813 2.087-1.808 3.341l.005-.006zm7.196.855c-.14.934-.775 1.708-1.65 2.085-1.687.734-3.359-.437-4.789-2.026 2.365-2.961 2.803-5.268 1.787-6.758-.596-.855-1.449-1.271-2.544-1.271-2.206 0-3.419 1.867-2.942 4.034.276 1.173 1.013 2.506 2.186 3.996-.735.813-1.432 1.391-2.047 1.748-.478.258-.934.418-1.37.456-2.008.299-3.582-1.647-2.867-3.656.1-.259.297-.734.634-1.471l.019-.039c1.097-2.382 2.43-5.088 3.961-8.09l.039-.1.435-.836c.338-.616.477-.892 1.014-1.231.258-.157.576-.235.934-.235.715 0 1.271.418 1.511.753.118.18.259.419.436.716l.419.815.06.119c1.53 3.001 2.863 5.702 3.955 8.089l.02.019.401.915.237.573c.183.459.221.915.16 1.393l.001.002zm.913-1.791c-.139-.438-.378-.953-.675-1.569v-.022a262.99 262.99 0 0 0-3.976-8.128l-.084-.121C14.486 4.109 13.849 3.014 12 3.014c-1.827 0-2.604 1.27-3.397 2.922l-.061.119c-1.251 2.426-2.564 5.128-3.975 8.13v.039l-.418.914c-.158.378-.237.575-.259.636C2.878 18.556 4.964 21 7.489 21c.021 0 .099 0 .198-.021h.278c1.313-.159 2.664-.993 4.035-2.485 1.371 1.49 2.725 2.326 4.033 2.485h.279c.1.021.18.021.2.021 2.525.002 4.61-2.444 3.598-5.227z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogoAdobe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.966V4.034h-6.654zM3 4.034v15.932L9.658 4.034zM9.092 16.76h3.104l1.268 3.205h2.778L12.003 9.904z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogo99Designs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.93 10.61A2.7 2.7 0 0 0 19 10a2.74 2.74 0 0 0-1.1-.19 3.28 3.28 0 0 0-2.16.76v-.05a3.67 3.67 0 0 0-5.09-3.39 3.61 3.61 0 0 0-1.78 1.56 3.67 3.67 0 0 0-3.12-1.86 3.74 3.74 0 0 0-1.82.44 3.66 3.66 0 0 0-1.37 1.28A3.77 3.77 0 0 0 2 10.34a3.67 3.67 0 0 0 3.42 3.83l-1.6 2.76h2.39l2.65-4.59a3.63 3.63 0 0 0 2.93 1.84l-1.59 2.76h2.4l1.86-3.23a3.53 3.53 0 0 0 2.07 3.19 3.52 3.52 0 0 0 2.61.05 2.58 2.58 0 0 0 .9-.74v.73h2V7.06h-2.11zm-12.78.72a1.69 1.69 0 0 1-1.46.83 1.72 1.72 0 0 1-.86-.16 1.75 1.75 0 0 1-.62-.62 1.78 1.78 0 0 1-.21-.87 1.69 1.69 0 0 1 1.67-1.69 1.63 1.63 0 0 1 .84.23 1.58 1.58 0 0 1 .62.61 1.62 1.62 0 0 1 .23.83 1.72 1.72 0 0 1-.21.84zm6.38 0a1.58 1.58 0 0 1-.62.61 1.53 1.53 0 0 1-.84.22 1.78 1.78 0 0 1-.84-.22 1.65 1.65 0 0 1-.61-.62 1.67 1.67 0 0 1 0-1.69 1.73 1.73 0 0 1 .62-.61 1.63 1.63 0 0 1 .84-.23 1.69 1.69 0 0 1 .84.23 1.69 1.69 0 0 1 .63 2.28zm6.3 3a1.72 1.72 0 0 1-2 .85 1.72 1.72 0 0 1-1-.7 1.75 1.75 0 0 1-.29-1.15 1.77 1.77 0 0 1 .51-1.07 1.75 1.75 0 0 1 2.35-.11 1.73 1.73 0 0 1 .43 2.18z"
                },
                "child": []
            }
        ]
    })(props);
}
function BiLogo500Px(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.379 14.791c.004.01.098.269.151.396a5.859 5.859 0 0 0 1.258 1.865 5.86 5.86 0 0 0 6.437 1.259 5.876 5.876 0 0 0 3.124-3.125 5.802 5.802 0 0 0 .461-2.285c0-.793-.153-1.563-.461-2.287a5.862 5.862 0 0 0-1.257-1.864 5.86 5.86 0 0 0-4.152-1.72 6 6 0 0 0-2.318.461c-.57.241-1.536.862-2.102 1.446l-.002.002V4.107h8.117c.295-.003.295-.417.295-.55 0-.137 0-.549-.296-.553H7.857a.387.387 0 0 0-.388.384v6.801c0 .221.273.379.527.434.496.104.61-.053.732-.222l.015-.021c.187-.275.767-.858.771-.863a4.776 4.776 0 0 1 3.406-1.403 4.76 4.76 0 0 1 3.394 1.403 4.75 4.75 0 0 1 1.408 3.385c0 1.28-.498 2.483-1.4 3.385a4.858 4.858 0 0 1-3.416 1.403 4.656 4.656 0 0 1-2.42-.668l.004-4.137c0-.552.238-1.151.64-1.604a2.351 2.351 0 0 1 1.778-.803c.667 0 1.291.254 1.754.714.46.455.714 1.064.714 1.711a2.443 2.443 0 0 1-2.474 2.466c-.268 0-.753-.117-.773-.123-.281-.084-.4.305-.439.435-.151.492.077.59.122.604.448.138.741.164 1.124.164a3.555 3.555 0 0 0 3.551-3.553c0-1.943-1.592-3.526-3.548-3.526a3.59 3.59 0 0 0-2.536 1.033c-.644.632-1.013 1.478-1.013 2.317v.021c-.004.105-.004 2.583-.005 3.398l-.005-.006c-.368-.407-.731-1.029-.973-1.668-.097-.25-.309-.206-.601-.116-.127.04-.514.159-.429.438l.002.004zm4.172-.972c.002.118.111.223.175.286l.021.019c.111.11.217.164.315.164.081 0 .13-.037.148-.054.05-.046.604-.608.658-.662l.618.618c.058.064.12.097.192.098.1 0 .207-.058.32-.174.267-.272.134-.42.069-.49l-.628-.63.655-.658c.144-.155.017-.32-.111-.446-.183-.184-.359-.23-.474-.127l-.65.652-.657-.658a.183.183 0 0 0-.128-.051c-.087 0-.191.06-.308.177-.202.201-.246.341-.141.453l.657.656-.653.655a.247.247 0 0 0-.078.172m1.434-8.891c-1.053 0-2.171.211-2.992.566a.23.23 0 0 0-.151.205c-.011.093.013.216.076.377.051.131.187.478.449.376a7.566 7.566 0 0 1 2.618-.498c.96 0 1.892.188 2.768.558.696.296 1.354.721 2.068 1.341a.243.243 0 0 0 .165.068c.138 0 .271-.137.386-.266.191-.214.321-.392.135-.569a7.674 7.674 0 0 0-2.354-1.52 8.088 8.088 0 0 0-3.168-.638m5.668 12.986c-.127-.126-.235-.199-.33-.228a.24.24 0 0 0-.247.059l-.063.062a7.07 7.07 0 0 1-5.018 2.081 7.09 7.09 0 0 1-5.02-2.081 6.794 6.794 0 0 1-1.521-2.255 7.618 7.618 0 0 1-.462-1.596c-.004-.018-.005-.031-.009-.041-.044-.232-.257-.249-.564-.202-.127.019-.517.078-.479.358l.002.006a8.104 8.104 0 0 0 2.288 4.478 8.089 8.089 0 0 0 2.59 1.747 8.093 8.093 0 0 0 3.175.642 8.062 8.062 0 0 0 3.172-.643 8.129 8.129 0 0 0 2.658-1.813c.083-.09.154-.248-.172-.574"
                },
                "child": []
            }
        ]
    })(props);
}

},{"../lib/index.mjs":"c1xBV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1dUjC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinaningCorrectionRequired);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _button = require("Core/components/Button");
var _hi2 = require("react-icons/hi2");
var _postExchangeBanner = require("Modules/financing/components/PostExchangeBanner");
var _postExchangeBannerDefault = parcelHelpers.interopDefault(_postExchangeBanner);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _useProviderSync = require("Modules/financing/hooks/useProviderSync");
var _useProviderSyncDefault = parcelHelpers.interopDefault(_useProviderSync);
function FinaningCorrectionRequired({ application }) {
    document.title = 'Payment Portal - Correction Required';
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    // Only the refreshed application state matters here, not its links
    const { mutateAsync: syncProvider, isLoading: isProviderSyncLoading } = (0, _useProviderSyncDefault.default)({
        isReady: (data)=>Boolean(data?.next_action)
    });
    const navigateToVerificationLink = async (e)=>{
        e.preventDefault();
        // Reload after the provider sync finishes or times out, so the page shows the latest state
        await syncProvider();
        window.location.reload();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        children: [
            isProviderSyncLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('financing.nextgen.correctionRequired.syncLoadingText')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mx-auto max-w-4xl px-4 mt-10",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _postExchangeBannerDefault.default), {
                        application: application
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                        className: "relative overflow-hidden !px-0 !py-0",
                        cardPadding: "sm",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "h-1 bg-amber-500"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "px-8 md:px-14 pt-12 pb-12",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex justify-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            "aria-hidden": "true",
                                            className: "flex items-center justify-center h-14 w-14 rounded-full bg-amber-50 ring-1 ring-amber-100",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineExclamationTriangle), {
                                                className: "h-7 w-7 text-amber-600"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        className: "mt-6 text-center text-3xl md:text-[2rem] font-semibold tracking-tight text-slate-900 leading-tight",
                                        "data-testid": "title-correction-required",
                                        children: t('common.newApplication')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        "aria-hidden": "true",
                                        className: "mt-7 h-[3px] w-full rounded-full bg-amber-300"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-7 mx-auto max-w-2xl text-center whitespace-pre-line text-base md:text-lg leading-relaxed text-slate-600",
                                        "data-testid": "correction-required-message",
                                        children: t('synchrony.correctionRequired')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-10 flex justify-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                            "data-testid": "btn-verify",
                                            size: "tall",
                                            rounded: true,
                                            className: "!px-12",
                                            onClick: navigateToVerificationLink,
                                            disabled: isProviderSyncLoading,
                                            children: t('common.retry')
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react":"2o0ib","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Button":"6YNzH","react-icons/hi2":"krCLn","Modules/financing/components/PostExchangeBanner":"eth8c","Core/components/Loader":"6S7S4","Modules/financing/hooks/useProviderSync":"4YW9r","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lyzU7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFinancingPath", ()=>createFinancingPath);
parcelHelpers.export(exports, "financingPath", ()=>financingPath);
parcelHelpers.export(exports, "financingSuccessPath", ()=>financingSuccessPath);
parcelHelpers.export(exports, "financingErrorPath", ()=>financingErrorPath);
parcelHelpers.export(exports, "paymentOptionsPath", ()=>paymentOptionsPath);
parcelHelpers.export(exports, "createSecondaryFinancingPath", ()=>createSecondaryFinancingPath);
parcelHelpers.export(exports, "financingRequalifyPath", ()=>financingRequalifyPath);
parcelHelpers.export(exports, "mixedAvailableCreditPath", ()=>mixedAvailableCreditPath);
parcelHelpers.export(exports, "mixedDownPaymentCheckoutPath", ()=>mixedDownPaymentCheckoutPath);
parcelHelpers.export(exports, "mixedFinancingPath", ()=>mixedFinancingPath);
parcelHelpers.export(exports, "mixedSuccessPath", ()=>mixedSuccessPath);
parcelHelpers.export(exports, "mixedErrorPath", ()=>mixedErrorPath);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _financingRedirect = require("Modules/patientfi/routes/FinancingRedirect");
var _financingRedirectDefault = parcelHelpers.interopDefault(_financingRedirect);
var _financingSuccess = require("Modules/patientfi/routes/FinancingSuccess");
var _financingSuccessDefault = parcelHelpers.interopDefault(_financingSuccess);
var _financingDeclined = require("Modules/patientfi/routes/FinancingDeclined");
var _financingDeclinedDefault = parcelHelpers.interopDefault(_financingDeclined);
var _financing = require("Modules/patientfi/routes/Financing");
var _financingDefault = parcelHelpers.interopDefault(_financing);
var _createApplication = require("./routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _financingRequalify = require("Modules/patientfi/routes/FinancingRequalify");
var _financingRequalifyDefault = parcelHelpers.interopDefault(_financingRequalify);
var _payment = require("Modules/cardPayment/routes/Payment");
var _mixedSuccess = require("Modules/patientfi/routes/MixedSuccess");
var _mixedSuccessDefault = parcelHelpers.interopDefault(_mixedSuccess);
var _mixedError = require("Modules/patientfi/routes/MixedError");
var _mixedErrorDefault = parcelHelpers.interopDefault(_mixedError);
const createFinancingPath = '/financing-patientfi/financing';
const financingPath = '/financing-patientfi/office/finance';
const financingSuccessPath = '/financing-patientfi/funded';
const financingErrorPath = '/financing-patientfi/declined';
const paymentOptionsPath = '/card-payment/cards';
const createSecondaryFinancingPath = '/financing-patientfi/financing/secondary';
const financingRequalifyPath = '/financing-patientfi/requalify';
const mixedAvailableCreditPath = '/financing-patientfi/mixed/available-credit';
const mixedDownPaymentCheckoutPath = '/financing-patientfi/mixed/down-payment/checkout';
const mixedFinancingPath = '/financing-patientfi/mixed/financing';
const mixedSuccessPath = '/financing-patientfi/mixed/success';
const mixedErrorPath = '/financing-patientfi/mixed/error';
const routes = [
    {
        path: createFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingRedirectDefault.default), {})
    },
    {
        path: createSecondaryFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
            type: "secondary"
        })
    },
    {
        path: financingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDefault.default), {
            nextRoutes: {
                success: financingSuccessPath,
                error: financingErrorPath
            }
        })
    },
    {
        path: financingSuccessPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSuccessDefault.default), {})
    },
    {
        path: financingErrorPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {})
    },
    {
        path: financingRequalifyPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingRequalifyDefault.default), {})
    },
    {
        path: mixedDownPaymentCheckoutPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _payment.Payment), {
            paymentType: "downPayment",
            nextRoutes: {
                success: mixedFinancingPath,
                error: mixedErrorPath
            }
        })
    },
    {
        path: mixedFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDefault.default), {
            nextRoutes: {
                success: mixedSuccessPath,
                error: mixedErrorPath
            }
        })
    },
    {
        path: mixedSuccessPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mixedSuccessDefault.default), {})
    },
    {
        path: mixedErrorPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mixedErrorDefault.default), {})
    }
];

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/patientfi/routes/FinancingRedirect":"65DJb","Modules/patientfi/routes/FinancingSuccess":"e24n1","Modules/patientfi/routes/FinancingDeclined":"lpG8X","Modules/patientfi/routes/Financing":"8WSTE","./routes/CreateApplication":"jL3P4","Modules/patientfi/routes/FinancingRequalify":"icLoD","Modules/cardPayment/routes/Payment":"gn9UA","Modules/patientfi/routes/MixedSuccess":"h5T1p","Modules/patientfi/routes/MixedError":"iOzDS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"65DJb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingRedirect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _createApplication = require("Modules/patientfi/routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _financingPreparation = require("Modules/patientfi/components/FinancingPreparation");
var _financingPreparationDefault = parcelHelpers.interopDefault(_financingPreparation);
var _useGetNextStep = require("Modules/patientfi/hooks/useGetNextStep");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _financingSuccess = require("Modules/patientfi/routes/FinancingSuccess");
var _financingSuccessDefault = parcelHelpers.interopDefault(_financingSuccess);
var _financingApproved = require("Modules/patientfi/routes/FinancingApproved");
var _financingApprovedDefault = parcelHelpers.interopDefault(_financingApproved);
var _returnTracking = require("Modules/patientfi/components/ReturnTracking");
var _returnTrackingDefault = parcelHelpers.interopDefault(_returnTracking);
var _financingStatusMessage = require("Modules/patientfi/components/FinancingStatusMessage");
var _financingStatusMessageDefault = parcelHelpers.interopDefault(_financingStatusMessage);
var _financingDeclined = require("Modules/patientfi/routes/FinancingDeclined");
var _financingDeclinedDefault = parcelHelpers.interopDefault(_financingDeclined);
var _financingExceptions = require("Modules/patientfi/routes/FinancingExceptions");
var _financingExceptionsDefault = parcelHelpers.interopDefault(_financingExceptions);
var _financingExistingAccount = require("Modules/patientfi/routes/FinancingExistingAccount");
var _financingExistingAccountDefault = parcelHelpers.interopDefault(_financingExistingAccount);
var _financingDenied = require("Modules/patientfi/routes/ExistingAccount/FinancingDenied");
var _financingDeniedDefault = parcelHelpers.interopDefault(_financingDenied);
// import FinancingDecisionPending from 'Modules/patientfi/routes/FinancingDecisionPending';
var _routes = require("Modules/cardPayment/routes");
var _constants = require("Modules/patientfi/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _routes1 = require("Modules/patientfi/routes");
var _routes2 = require("Core/routes");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactLocation = require("react-location");
var _routes3 = require("Modules/financing/routes");
function FinancingRedirect() {
    const routes = {
        paymentOptions: (0, _routes.cardPreferenceCenterPath),
        financing: (0, _routes1.financingPath),
        mixed: (0, _routes1.mixedDownPaymentCheckoutPath),
        financingSuccessPath: (0, _routes1.financingSuccessPath),
        financingErrorPath: (0, _routes1.financingErrorPath),
        payment: (0, _routes.paymentPath),
        allegroFinancing: (0, _routes3.createFinancingPath)
    };
    const navigate = (0, _reactLocation.useNavigate)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const { t } = (0, _reactI18Next.useTranslation)();
    const rawSessionStorageItem = sessionStorage.getItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY);
    const cachedApp = rawSessionStorageItem && rawSessionStorageItem !== 'undefined' ? JSON.parse(rawSessionStorageItem) : null;
    const { data: newApp, isLoading, isError, error } = (0, _useGetNextStep.useGetNextStep)(false, !cachedApp);
    const application = cachedApp || newApp;
    sessionStorage.removeItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY);
    const { next_action = 'CREATE_APPLICATION' } = application || {};
    const { data: { amount_to_pay, customer_id = '', provider = '' } = {}, isLoading: isPaymentInfoLoading, isError: isPaymentInfoError } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
    else if (provider && provider !== 'PATIENTFI') navigate({
        to: routes.allegroFinancing,
        search: true
    });
    else if (isError || error?.response?.status === 404 || !application?.next_action) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
        customer_id: customer_id
    });
    else if (application?.next_action) switch(next_action){
        case 'CREATE_APPLICATION':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
                type: "primary",
                customer_id: customer_id
            });
        case 'SELECT_OFFER':
        case 'UPDATE_OFFER':
        case 'SIGN_CONTRACT':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingPreparationDefault.default), {
                application: cachedApp,
                routes: routes
            });
        case 'CORRECTION_REQUIRED':
        case 'DECLINED':
        case 'DECISION_PENDING':
        case 'INCOMPLETE':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingExceptionsDefault.default), {
                customer_id: customer_id,
                application: application,
                nextAction: next_action
            });
        case 'UPDATE_EXISTING_ACCOUNT':
            if (application?.payload?.existing_account?.account_status === 'DENIED') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeniedDefault.default), {
                application: application
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingExistingAccountDefault.default), {
                application: application
            });
        case 'UPDATE_AMOUNT':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingApprovedDefault.default), {});
        case 'CANCELLED':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {
                application: application
            });
        case 'DONE':
        case 'FUND_APPLICATION':
        case 'PENDING_DOWN_PAYMENT':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSuccessDefault.default), {});
        case 'RETURN_APPROVED':
        case 'RETURN_REQUESTED':
        case 'RETURN_PROCESSING':
        case 'RETURN_COMPLETE':
        case 'RETURN_CANCELED':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _returnTrackingDefault.default), {
                nextAction: next_action
            });
        case 'NO_DECISION':
        case 'APPLICATION_CLOSED':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingStatusMessageDefault.default), {
                nextAction: next_action
            });
        default:
            setError(t('status.error.getFinancingApplicationFailed'));
            navigate({
                to: (0, _routes2.errorPath),
                search: true
            });
    }
    if (!isPaymentInfoError && !isPaymentInfoLoading && !amount_to_pay) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingApprovedDefault.default), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Modules/patientfi/routes/CreateApplication":"jL3P4","Modules/patientfi/components/FinancingPreparation":"eIUDR","Modules/patientfi/hooks/useGetNextStep":"4nfRQ","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Core/components/Loader":"6S7S4","Modules/patientfi/routes/FinancingSuccess":"e24n1","Modules/patientfi/routes/FinancingApproved":"gX6j5","Modules/patientfi/components/ReturnTracking":"dgo0G","Modules/patientfi/components/FinancingStatusMessage":"3MuqE","Modules/patientfi/routes/FinancingDeclined":"lpG8X","Modules/patientfi/routes/FinancingExceptions":"13akA","Modules/patientfi/routes/FinancingExistingAccount":"hY1in","Modules/patientfi/routes/ExistingAccount/FinancingDenied":"5bAr2","Modules/cardPayment/routes":"kPsar","Modules/patientfi/config/constants":"i3i7l","Modules/patientfi/routes":"lyzU7","Core/routes":"iddMu","Core/stores/error":"38MVH","react-location":"8hNco","Modules/financing/routes":"5ZPtj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jL3P4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _reactI18Next = require("react-i18next");
var _selectMenu = require("Core/components/FormElements/SelectMenu");
var _selectMenuDefault = parcelHelpers.interopDefault(_selectMenu);
var _alert = require("Core/components/Alert");
var _infoBox = require("Core/components/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _button = require("Core/components/Button");
var _usStates = require("Modules/creditDebit/config/usStates");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _birthDateInput = require("Core/components/FormElements/BirthDateInput");
var _birthDateInputDefault = parcelHelpers.interopDefault(_birthDateInput);
var _layout = require("Core/components/Layout");
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _reactLocation = require("react-location");
var _useCreateApplicationForm = require("Modules/patientfi/hooks/useCreateApplicationForm");
var _useCreateApplicationFormDefault = parcelHelpers.interopDefault(_useCreateApplicationForm);
var _useCreateApplication = require("Modules/patientfi/hooks/useCreateApplication");
var _useCreateApplicationDefault = parcelHelpers.interopDefault(_useCreateApplication);
var _useGetCustomerInfo = require("Modules/patientfi/hooks/useGetCustomerInfo");
var _useGetCustomerInfoDefault = parcelHelpers.interopDefault(_useGetCustomerInfo);
var _useGetApplication = require("Modules/patientfi/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _fa6 = require("react-icons/fa6");
var _quote = require("Core/components/Quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
var _useScrollTop = require("Core/hooks/useScrollTop");
var _relationTypes = require("../config/relationTypes");
var _im = require("react-icons/im");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _mapCustomerData = require("Modules/patientfi/utils/mapCustomerData");
var _logger = require("Core/utils/logger");
var _constants = require("../config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _reactQuery = require("react-query");
// import useInitialAppStatusStore, { initialAppStatusSelector, setInitialAppStatusSelector } from 'Modules/core/stores/initialAppStatus';
const dateFormat = 'yyyy-MM-dd';
const CreateApplication = ({ type = 'primary', customer_id = '', purpose = 'create', errorConfig = {} })=>{
    document.title = 'Payment Portal - Create Application';
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const scroll = (0, _useScrollTop.useScrollTop)();
    const { mutateAsync: createApplication, isLoading: isCreateAppLoading } = (0, _useCreateApplicationDefault.default)(purpose);
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const [showSsn, setShowSsn] = (0, _reactDefault.default).useState(false);
    const [showRelationField, setshowRelationField] = (0, _reactDefault.default).useState(type !== 'primary'); // false
    const [createApplicationPolling, setCreateApplicationPolling] = (0, _reactDefault.default).useState(false);
    const { isSuccess: isGetAppSuccess, isLoading: isGetAppLoading, data: getAppData } = (0, _useGetApplicationDefault.default)(requestId, createApplicationPolling ? 3000 : false);
    const { data: customerInfo } = (0, _useGetCustomerInfoDefault.default)();
    const [dobDefaults, setDobDefaults] = (0, _reactDefault.default).useState({
        day: '01',
        month: '01',
        year: ''
    });
    const [isFinanceAppLoading, setIsFinanceAppLoading] = (0, _reactDefault.default).useState(false);
    const [initialAppStatus, setInitialAppStatus] = (0, _reactDefault.default).useState({
        nextAction: null,
        message: null,
        status: null
    });
    const { register, handleSubmit, setValue, watch, reset, formState: { errors, isSubmitted } } = (0, _useCreateApplicationFormDefault.default)(errorConfig);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const selectedRelationship = watch('relationship');
    const relationshipSessionStorageString = sessionStorage.getItem('relationship');
    const previousRelationship = JSON.parse(relationshipSessionStorageString)?.relationship || '';
    const sessionStorageCustomerId = JSON.parse(relationshipSessionStorageString)?.customer_id || '';
    const filteredRelationTypes = (0, _relationTypes.relationTypes).filter((item)=>!previousRelationship || type === 'primary' ? true : item.value !== previousRelationship);
    const showUpdateFormMessage = !!errorConfig.type;
    const initializeAppStatus = (appData)=>{
        const { correction_required: { status = '', message = '' } = {} } = appData?.payload || {};
        setInitialAppStatus({
            nextAction: appData?.next_action,
            message,
            status
        });
    };
    // React.useEffect(() => {
    //   initializeAppStatus(getAppData);
    // });
    (0, _reactDefault.default).useEffect(()=>{
        const isAppStatusChanged = ()=>{
            return getAppData?.next_action !== initialAppStatus.nextAction || getAppData?.message !== initialAppStatus.message || getAppData?.status !== initialAppStatus.status;
        };
        // Only navigate if we're actively polling AND status changed
        if (isGetAppSuccess && createApplicationPolling && isAppStatusChanged()) {
            sessionStorage.setItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY, JSON.stringify(getAppData));
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
            // navigate({ to: financingPath, search: true, replace: true });
            setRequestId('');
            setCreateApplicationPolling(false);
            setIsFinanceAppLoading(false);
        }
    }, [
        isGetAppSuccess,
        getAppData,
        navigate,
        createApplicationPolling,
        requestId,
        initialAppStatus
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetAppLoading) setIsFinanceAppLoading(true);
    }, [
        isGetAppLoading
    ]);
    // Cleanup effect to clear requestId and cache on component unmount
    (0, _reactDefault.default).useEffect(()=>{
        return ()=>{
            // Cleanup on unmount
            setRequestId('');
            queryClient.removeQueries((0, _cacheKeysDefault.default).patientfiGetApplication);
        };
    }, [
        queryClient
    ]);
    const parseDateOfBirth = (dateOfBirth)=>{
        let year, day, month;
        if (Array.isArray(dateOfBirth)) {
            [year] = dateOfBirth;
            [, day, month] = dateOfBirth;
            if (month > 0 && month < 10) month = '0' + month;
            if (day > 0 && day < 10) day = '0' + day;
        } else if (typeof dateOfBirth === 'string') [year, month, day] = dateOfBirth.split('-');
        return {
            day,
            month,
            year
        };
    };
    (0, _reactDefault.default).useEffect(()=>{
        const mappedCustomerData = (0, _mapCustomerData.mapCustomerData)(customerInfo, customer_id);
        if (mappedCustomerData) {
            if (mappedCustomerData.relationship === previousRelationship && sessionStorageCustomerId === customer_id && type !== 'primary') mappedCustomerData.relationship = null;
            Object.keys(mappedCustomerData).forEach((field)=>setValue(field, mappedCustomerData[field]));
            const finalDateOfBirth = mappedCustomerData.date_of_birth || mappedCustomerData.dateOfBirth;
            if (finalDateOfBirth) {
                const { day, month, year } = parseDateOfBirth(finalDateOfBirth);
                setDobDefaults({
                    day,
                    month,
                    year
                });
            }
        } else {
            setDobDefaults({
                day: '01',
                month: '01',
                year: ''
            });
            reset((0, _mapCustomerData.mapCustomerData)({}, customer_id));
        }
    }, [
        customerInfo,
        reset,
        setValue,
        isGetAppSuccess,
        isGetAppLoading,
        navigate,
        requestId,
        getAppData?.next_action,
        customer_id,
        previousRelationship,
        sessionStorageCustomerId,
        type
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        const errorFields = Object.keys(errors);
        if (errorFields?.length) {
            const errorMap = errorFields.map((field)=>{
                return {
                    field,
                    message: errors[field].message
                };
            });
            console.log('form errors!', errorMap);
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                action: (0, _logger.actions).createApplicationFormError,
                errors: errorMap
            });
        }
    }, [
        errors
    ]);
    const handleRelationshipChange = ()=>{
        if (customerInfo && customerInfo.relationship === selectedRelationship) {
            const customerData = (0, _mapCustomerData.mapCustomerData)(customerInfo, customer_id);
            Object.keys(customerData).forEach((field)=>setValue(field, customerData[field]));
            if (customerData.date_of_birth || customerData.dateOfBirth) {
                const finalDateOfBirth = customerData.date_of_birth || customerData.dateOfBirth;
                const { day, month, year } = parseDateOfBirth(finalDateOfBirth);
                setDobDefaults({
                    day,
                    month,
                    year
                });
            }
        } else {
            setDobDefaults({
                day: '01',
                month: '01',
                year: ''
            });
            reset((0, _mapCustomerData.mapCustomerData)({}, customer_id));
        }
    };
    const ssn = watch('socialSecurityNumber');
    (0, _reactDefault.default).useEffect(()=>{
        setValue('socialSecurityNumber', ssn?.replace(/\D+/g, ''));
    }, [
        setValue,
        ssn
    ]);
    const phone = watch('phone');
    (0, _reactDefault.default).useEffect(()=>{
        if (phone?.startsWith('+1')) setValue('phone', phone.replace(/^\+1/, ''));
    }, [
        setValue,
        phone
    ]);
    const hasFormErrors = Object.keys(errors).length > 0;
    const storeCustomerInfo = (formData)=>{
        const filteredFormData = JSON.parse(JSON.stringify(formData));
        delete filteredFormData.socialSecurityNumber;
        delete filteredFormData.annualIncome;
        sessionStorage.setItem((0, _constantsDefault.default).SESS_STORAGE_CUSTOMER_INFO_KEY, JSON.stringify({
            ...filteredFormData,
            customer_id
        }));
    };
    const onSubmit = async (formData)=>{
        setRequestId(''); // Clear old requestId first
        initializeAppStatus();
        storeCustomerInfo(formData);
        setCreateApplicationPolling(true);
        scroll.top();
        const { headers: { request_id } } = await createApplication(formData);
        setRequestId(request_id);
    };
    const toggleSsnDisplay = ()=>{
        setShowSsn(!showSsn);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.createFinancingApplication.header'),
        subtitle: t('page.createFinancingApplication.subtitlePatientfi'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: [
            isCreateAppLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('patientfi.createApplication.loaderText')
            }),
            isFinanceAppLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('status.loading.financingApplication')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                name: "patientfiCreateApplication",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    hasFormErrors && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                        type: "error",
                        children: t('status.error.checkErrors')
                    }),
                    showUpdateFormMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                        type: "error",
                        children: errorConfig.message
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    !showRelationField && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "text-gray-500",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center my-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "inline-block pr-2",
                                                    children: [
                                                        ' ',
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _im.ImInfo), {})
                                                    ]
                                                }),
                                                "Filling the application for someone else?",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "text-blue-500 hover:underline mx-1",
                                                    type: "button",
                                                    onClick: ()=>setshowRelationField(true),
                                                    children: "Click here"
                                                }),
                                                ' ',
                                                "to change relationship"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!mb-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                            type: "infoLight",
                                            children: t('patientfi.createApplication.enterLegalNames')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: (0, _classnamesDefault.default)('md:!flex-col-6', {
                                            hidden: !showRelationField
                                        }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                                            register: register,
                                            label: t('common.relationship'),
                                            name: "relationship",
                                            items: filteredRelationTypes,
                                            onChange: handleRelationshipChange,
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!mb-2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.firstName'),
                                            name: "firstName",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.lastName'),
                                            name: "lastName",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.street'),
                                            name: "address",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.city'),
                                            name: "city",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                                            register: register,
                                            label: t('common.state'),
                                            name: "state",
                                            items: (0, _usStates.usStates),
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.postalCode'),
                                            name: "zip",
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.phone'),
                                            name: "phone",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.email'),
                                            name: "email",
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6 flex items-end",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            className: "!rounded-r-none",
                                            register: register,
                                            label: t('patientfi.formlabel.ssn'),
                                            name: "socialSecurityNumber",
                                            errors: errors,
                                            onAppendClick: toggleSsnDisplay,
                                            appendText: showSsn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa6.FaEyeSlash), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa6.FaEye), {}),
                                            type: showSsn ? 'text' : 'password'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _birthDateInputDefault.default), {
                                            format: dateFormat,
                                            register: register,
                                            name: "dateOfBirth",
                                            padZeros: true,
                                            onChange: (value)=>{
                                                setValue('dateOfBirth', value, {
                                                    shouldValidate: isSubmitted
                                                });
                                            },
                                            defaultValues: dobDefaults,
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.annualIncome'),
                                            name: "annualIncome",
                                            type: "number",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-12",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteDefault.default), {
                                            showWhitespace: true,
                                            children: t('patientfi.createApplication.readToCustomer.note2')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: t('common.noticeToApplicants')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                        type: "warning",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-semibold text-sm text-black",
                                            children: t('common.readToCustomer.doubleTitle')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                            showBorder: true,
                                            children: t('patientfi.createApplication.readToCustomer.note3')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                            showBorder: true,
                                            children: t('patientfi.createApplication.readToCustomer.note4')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _termsInputDefault.default), {
                                name: "terms",
                                register: register,
                                errors: errors,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        children: t('financing.nextgen.createApplication.terms')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ol", {
                                        className: "list-decimal ml-4 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: t('patientfi.createApplication.terms.note1')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: t('patientfi.createApplication.terms.note2')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "md:!flex-col-12 !flex gap-1 !justify-end",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                type: "submit",
                                "data-testid": "submit-application",
                                children: t('common.submitPrequalificationApplication')
                            })
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = CreateApplication;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/InputField":"6BJmW","react-i18next":"244ua","Core/components/FormElements/SelectMenu":"hsUsp","Core/components/Alert":"fmmNR","Core/components/InfoBox":"4Lj47","Core/components/Button":"6YNzH","Modules/creditDebit/config/usStates":"2i8MO","Core/components/Page":"4xeqH","Core/components/FormElements/BirthDateInput":"36m4y","Core/components/Layout":"hweet","Core/components/FormElements/formElements.styled":"45aFS","Core/components/FormElements/TermsInput":"2LJBE","Core/components/Loader":"6S7S4","react-location":"8hNco","Modules/patientfi/hooks/useCreateApplicationForm":"9lb1M","Modules/patientfi/hooks/useCreateApplication":"ybsnU","Modules/patientfi/hooks/useGetCustomerInfo":"iu7aV","Modules/patientfi/hooks/useGetApplication":"ijipp","react-icons/fa6":"1emil","Core/components/Quote":"aL5Js","Core/hooks/useScrollTop":"cBwQW","../config/relationTypes":"6MoWK","react-icons/im":"ek0E7","classnames":"f971Y","Modules/patientfi/utils/mapCustomerData":"5MprH","Core/utils/logger":"cWDKQ","../config/constants":"i3i7l","Core/hooks/queries/cacheKeys":"i5IL7","react-query":"ksTpv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9lb1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSocialSecurityNumberRegex", ()=>getSocialSecurityNumberRegex);
parcelHelpers.export(exports, "validateISODateFormat", ()=>validateISODateFormat);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _dateFns = require("date-fns");
var _reactHookForm = require("react-hook-form");
var _relationTypes = require("Modules/financing/config/relationTypes");
const getSocialSecurityNumberRegex = (requiresFullSsn = false)=>requiresFullSsn ? /^\d{3}-?\d{2}-?\d{4}$/ : /^(?:\d{3}-?\d{2}-?\d{4}|\d{4})$/;
const validateISODateFormat = (val)=>{
    return val ? (0, _dateFns.isValid)((0, _dateFns.parseISO)(val)) : true;
};
const relationValues = (0, _relationTypes.relationTypes).map((item)=>item.value);
const useCreateApplicationForm = (errorConfig = {})=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            // salutation: z.string().min(1,{ message: t('common.requiredSalutation') }),
            firstName: _v3.string().min(1, {
                message: t('common.requiredFieldFirstName')
            }),
            lastName: _v3.string().min(1, {
                message: t('common.requiredFieldLastName')
            }),
            address: _v3.string().min(1, {
                message: t('common.requiredFieldStreet')
            }),
            city: _v3.string().min(1, {
                message: t('common.requiredFieldCity')
            }),
            state: _v3.string().min(1, {
                message: t('common.requiredFieldState')
            }),
            zip: _v3.string().min(1, {
                message: t('common.requiredFieldPostalCode')
            }),
            relationship: _v3.enum(relationValues, {
                errorMap: ()=>{
                    return {
                        message: 'relationship is required'
                    };
                }
            }),
            // country: z.string().min(1,{ message: t('common.requiredFieldCountry') }),
            email: _v3.string().min(1, {
                message: t('common.requiredFieldEmail')
            }).email({
                message: t('common.invalidFormatEmail')
            }),
            socialSecurityNumber: _v3.string().min(1, {
                message: t('common.requiredFieldSSN')
            }).refine((val)=>{
                const regex = getSocialSecurityNumberRegex(errorConfig.requiresFullSsn);
                return regex.test(val);
            }, {
                message: errorConfig.requiresFullSsn ? t('patientfi.formlabel.fullSsnRequired', 'Please enter your full 9-digit Social Security Number') : t('patientfi.formlabel.invalidFormatSSN')
            }),
            phone: _v3.string().min(1, {
                message: t('common.requiredFieldPhone')
            }).regex(/^\d{10}$/, {
                message: 'Please provide a valid phone number with 10 digits'
            }),
            dateOfBirth: _v3.any().refine(validateISODateFormat, {
                message: t('common.invalidDateFormat')
            }),
            annualIncome: _v3.string().transform(parseInt).refine((val)=>val >= 1, {
                message: t('common.requiredFieldAnnualIncome')
            }),
            terms: _v3.boolean().refine((val)=>val, {
                message: t('common.requiredFieldTerms')
            })
        });
    }, [
        t,
        errorConfig.requiresFullSsn
    ]);
    const form = (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema)
    });
    const { setError } = form;
    // Set initial errors based on errorConfig
    (0, _reactDefault.default).useEffect(()=>{
        if (errorConfig.affectedFields && Array.isArray(errorConfig.affectedFields)) errorConfig.affectedFields.forEach((fieldName)=>{
            // Set a generic error message or use a custom one from errorConfig
            const errorMessage = errorConfig.message || t('common.fieldHasError');
            setError(fieldName, {
                type: 'manual',
                message: errorMessage
            });
        });
    }, [
        errorConfig,
        setError,
        t
    ]);
    return form;
};
exports.default = useCreateApplicationForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","date-fns":[["isValid","jCEss","default"],["parseISO","3xgI2","default"]],"react-hook-form":"53GLT","Modules/financing/config/relationTypes":"aeCnv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ybsnU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCreateApplication);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _reactI18Next = require("react-i18next");
var _logger = require("Core/utils/logger");
var _utils = require("Core/utils/utils");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function transformPayload({ firstName, lastName, address, city, state, zip, email, phone: number, socialSecurityNumber, dateOfBirth, annualIncome, customer_id, external_reference_id, purpose, provider, payment_option, relationship }) {
    return {
        payment_id: (0, _utils.getUrlParam)('payment-id'),
        external_reference_id,
        purpose,
        payment_option,
        provider,
        payload: {
            customer_id,
            first_name: firstName,
            middle_name: '',
            last_name: lastName,
            email,
            date_of_birth: dateOfBirth,
            customer_identity_number: socialSecurityNumber,
            monthly_income: Math.floor(annualIncome / 12),
            relationship,
            address_line: address,
            city,
            state,
            zip,
            phone_number: number,
            phone_type: 'mobile',
            agree_to_terms: true,
            authorized_representative: 'jose.vargas@hear.com'
        }
    };
}
function useCreateApplication(purpose = 'create') {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>{
        const httpMethod = purpose === 'update' ? (0, _platformApi.putWithHeaders) : (0, _platformApi.postWithHeaders);
        return httpMethod(`/financing/application`, transformPayload({
            ...payload,
            customer_id: paymentInfo.customer_id,
            external_reference_id: paymentInfo.external_reference_id,
            purpose: paymentInfo.purpose,
            provider: paymentInfo.provider,
            payment_option: paymentInfo.payment_option
        }));
    }, {
        throwOnError: true,
        retry: 2,
        enabled: Boolean(paymentInfo),
        onSuccess (data) {
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                status: 'success'
            });
            clearAlert();
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            return data;
        },
        onError (error) {
            setErrorAlert(t('status.error.createApplicationRequestFailed') + `(${error?.response?.data?.message})`);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","react-i18next":"244ua","Core/utils/logger":"cWDKQ","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iu7aV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetCustomerInfo);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _routes = require("Core/routes");
var _reactLocation = require("react-location");
function useGetCustomerInfo() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).financingCustomerInfo
    ], ()=>(0, _platformApi.get)(`/customer/search`), {
        onError (e) {
            if (e?.response?.status !== 404) {
                const message = e?.response?.data?.message ? ` - ${e?.response?.data?.message}` : '';
                setError(t('status.error.getFinancingApplicationFailed') + message);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        },
        retry: 1
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/error":"38MVH","Core/routes":"iddMu","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ijipp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetApplication);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _routes = require("Core/routes");
var _reactLocation = require("react-location");
var _logger = require("Core/utils/logger");
const DATA_NOT_READY = 'Data not ready';
function useGetApplication(requestId, refetchInterval = false) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).patientfiGetApplication,
        requestId
    ], async ()=>{
        const data = await (0, _platformApi.get)(`/application`, {
            headers: {
                request_id: requestId
            }
        });
        if (!data?.next_action) throw new Error(DATA_NOT_READY);
        return data;
    }, {
        enabled: Boolean(requestId),
        retry: (failureCount, error)=>{
            if (error.message === DATA_NOT_READY) return failureCount < 30;
            return false;
        },
        retryDelay: 3000,
        refetchInterval,
        staleTime: 0,
        cacheTime: 300000,
        onError (e) {
            if (e.message === DATA_NOT_READY) {
                setErrorAlert(t('status.error.getFinancingApplicationFailed'));
                return;
            }
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                action: (0, _logger.actions).createApplicationTimeout
            });
            const message = e?.message ? ` - ${e?.message}` : '';
            setError(t('status.error.getFinancingApplicationFailed') + message);
            navigate({
                to: (0, _routes.errorPath),
                search: true
            });
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","Core/stores/error":"38MVH","Core/routes":"iddMu","react-location":"8hNco","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6MoWK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "relationTypes", ()=>relationTypes);
const relationTypes = [
    {
        value: '',
        label: '--',
        disabled: true
    },
    {
        value: 'SELF',
        label: 'Self'
    },
    {
        value: 'SPOUSE',
        label: 'Spouse'
    },
    {
        value: 'PARENT',
        label: 'Parent'
    },
    {
        value: 'SIBLING',
        label: 'Sibling'
    },
    {
        value: 'CHILD',
        label: 'Child'
    },
    {
        value: 'OTHER',
        label: 'Other'
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5MprH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapCustomerData", ()=>mapCustomerData);
var _getStateAbbreviation = require("../hooks/getStateAbbreviation");
var _getStateAbbreviationDefault = parcelHelpers.interopDefault(_getStateAbbreviation);
var _constants = require("../config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
const mapCustomerData = (customerData, customer_id)=>{
    const sessionStorageCustomerData = sessionStorage.getItem((0, _constantsDefault.default).SESS_STORAGE_CUSTOMER_INFO_KEY);
    if (sessionStorageCustomerData) {
        const parsedCustomerData = JSON.parse(sessionStorageCustomerData);
        if (parsedCustomerData.customer_id === customer_id) return parsedCustomerData;
    }
    if (customerData) return {
        ...customerData,
        firstName: customerData.first_name ?? '',
        lastName: customerData.last_name ?? '',
        address: customerData.address_line ?? '',
        city: customerData.city ?? '',
        state: (0, _getStateAbbreviationDefault.default)(customerData.state) ?? '',
        zip: customerData.zip ?? '',
        country: customerData.country ?? '',
        email: customerData.email ?? '',
        socialSecurityNumber: customerData.customer_identity_number ?? '',
        phone: (customerData.phone_number ?? '').replace(/^\+1/, ''),
        annualIncome: (customerData.monthly_income ? customerData.monthly_income * 12 : '').toString(),
        relationship: customerData.relationship ?? 'SELF'
    };
    return {};
};

},{"../hooks/getStateAbbreviation":"7N0bY","../config/constants":"i3i7l","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7N0bY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getStateAbbreviation);
var _usStates = require("Modules/creditDebit/config/usStates");
function getStateAbbreviation(input) {
    if (!input || !input.toLowerCase()) return input;
    const stateByLabel = (0, _usStates.usStates).find((state)=>input.toLowerCase() === state.label.toLowerCase());
    const stateByValue = (0, _usStates.usStates).find((state)=>input.toLowerCase() === state.value.toLowerCase());
    if (stateByValue) return input;
    else if (stateByLabel) return stateByLabel.value;
    return input;
}

},{"Modules/creditDebit/config/usStates":"2i8MO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i3i7l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    SESS_STORAGE_CUSTOMER_INFO_KEY: 'CUSTOMER_INFO_FORM_DATA',
    SESS_STORAGE_APPLICATION_KEY: 'APPLICATION',
    SESS_STORAGE_RELATIONSHIP_KEY: 'RELATIONSHIP'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eIUDR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _layout = require("Core/components/Layout");
var _tabset = require("Core/components/Tabset/Tabset");
var _tabsetDefault = parcelHelpers.interopDefault(_tabset);
var _tooltip = require("Core/components/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _useScrollBottom = require("Core/hooks/useScrollBottom");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _calendarInputField = require("Core/components/FormElements/CalendarInputField");
var _calendarInputFieldDefault = parcelHelpers.interopDefault(_calendarInputField);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _numberFormat = require("Core/utils/numberFormat");
var _appConfig = require("Core/config/appConfig");
var _financingTabNames = require("Modules/patientfi/config/financingTabNames");
var _useSelectOfferForm = require("Modules/patientfi/hooks/useSelectOfferForm");
var _useSelectOfferFormDefault = parcelHelpers.interopDefault(_useSelectOfferForm);
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _useUpdateOffer = require("Modules/patientfi/hooks/useUpdateOffer");
var _useUpdateOfferDefault = parcelHelpers.interopDefault(_useUpdateOffer);
var _useGetApplication = require("Modules/patientfi/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _useGetNextStep = require("Modules/patientfi/hooks/useGetNextStep");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _reactQuery = require("react-query");
var _finalizeOffer = require("Modules/patientfi/FinalizeOffer");
var _finalizeOfferDefault = parcelHelpers.interopDefault(_finalizeOffer);
var _updateAchModal = require("Modules/patientfi/components/UpdateAchModal");
var _updateAchModalDefault = parcelHelpers.interopDefault(_updateAchModal);
var _tabs = require("Core/stores/tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _selectOffer = require("Modules/patientfi/SelectOffer");
var _selectOfferDefault = parcelHelpers.interopDefault(_selectOffer);
const FinancingPreparation = ({ application, routes })=>{
    document.title = 'Payment Portal - Prepare Application';
    const { dateFormat } = (0, _appConfig.getAppConfig)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const scroll = (0, _useScrollBottom.useScrollBottom)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const DEFAULT_TAB_CONFIG = [
        {
            id: (0, _financingTabNames.financingTabNames).SELECT_OFFER,
            label: t('financing.nextgen.setOffer.headline-1'),
            pageHeader: t('page.selectFinancingOffer.header'),
            isActive: true,
            isDisabled: false
        },
        {
            id: (0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY,
            label: t('financing.nextgen.setOffer.headline-2'),
            pageHeader: t('page.selectFinancingOffer.header'),
            isActive: false,
            isDisabled: true
        },
        {
            id: (0, _financingTabNames.financingTabNames).FINALIZE_OFFER,
            label: t('financing.nextgen.setOffer.headline-3'),
            pageHeader: t('page.completeFinancing.header'),
            isActive: false,
            isDisabled: false
        }
    ];
    const [tabConfig, setTabConfig] = (0, _reactDefault.default).useState(DEFAULT_TAB_CONFIG);
    const [isLoading, setIsLoading] = (0, _reactDefault.default).useState(false);
    const [selectedOffer, setSelectedOffer] = (0, _reactDefault.default).useState({
        id: '',
        amount_min: 0,
        require_downpayment_percent: 0,
        type: ''
    });
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const [enableSignContract, setEnableSignContract] = (0, _reactDefault.default).useState(false);
    const activeTab = (0, _tabsDefault.default)((state)=>state.activeTab);
    const setActiveTab = (0, _tabsDefault.default)((state)=>state.setActiveTab);
    const [activeTabId, setActiveTabId] = (0, _reactDefault.default).useState(activeTab || (0, _financingTabNames.financingTabNames).SELECT_OFFER);
    const [refetchInterval, setRefetchInterval] = (0, _reactDefault.default).useState(false);
    const [isUpdateButtonDisabled, setIsUpdateButtonDisabled] = (0, _reactDefault.default).useState(false);
    const [isUpdateAchModalOpen, setIsUpdateAchModalOpen] = (0, _reactDefault.default).useState(false);
    const [isUpdateButtonPressed, setIsUpdateButtonPressed] = (0, _reactDefault.default).useState(false);
    const { mutateAsync: updateOffer, isFetching: isLoadingUpdateOffer } = (0, _useUpdateOfferDefault.default)();
    const { data: { amount_to_pay = 0 } = {} } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const { data: getAppData, isLoading: isGetAppLoading, isFetching: isGetAppFetching } = (0, _useGetApplicationDefault.default)(requestId);
    const { data: getNextStepData } = (0, _useGetNextStep.useGetNextStep)(refetchInterval, refetchInterval);
    const latestApp = getNextStepData || getAppData || application || {};
    const { next_action, payload: { offers, selected_offer_id, already_paid_amount = 0, additional_payment = 0, minimum_additional_payment = 0, links: { app: appLink } = {} } = {} } = latestApp;
    const priceInfo = latestApp?.payload?.offer_term?.price;
    const today = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    });
    const [{ delivery_date = today } = {}] = priceInfo?.products ? JSON.parse(priceInfo?.products) : [];
    const minimumDownPayment = Math.max(amount_to_pay * selectedOffer.require_downpayment_percent, minimum_additional_payment, already_paid_amount);
    const maximumDownPayment = amount_to_pay - selectedOffer.amount_min;
    const { register, handleSubmit, formState: { errors, isDirty }, watch, setValue, control, reset } = (0, _useSelectOfferFormDefault.default)({
        minimumDownPayment,
        maximumDownPayment,
        dateFormat
    });
    const setDownPaymentLabel = (minAmount, maxAmount)=>{
        const downPaymentMinLabel = (0, _numberFormat.formatCurrency)(minAmount, {
            withDecimals: false
        });
        const downPaymentMaxLabel = (0, _numberFormat.formatCurrency)(maxAmount, {
            withDecimals: false
        });
        return selectedOffer.id ? `Down Payment (${downPaymentMinLabel} - ${downPaymentMaxLabel})` : '';
    };
    const downPaymentLabel = setDownPaymentLabel(minimumDownPayment, maximumDownPayment);
    const inputDownPayment = watch('downPayment') || 0;
    const calculatedAmountToCollect = Math.round((inputDownPayment - already_paid_amount) * 100) / 100;
    const openAchWindow = ()=>{
        if (appLink) window.open(appLink, '_target');
    };
    const navigateToFinalizeTab = ()=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>{
                tab.isActive = tab.id === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER;
                setActiveTabId((0, _financingTabNames.financingTabNames).FINALIZE_OFFER);
                setEnableSignContract(true);
                return tab;
            });
        });
    };
    const handleAchConfirm = ()=>{
        navigateToFinalizeTab();
        setIsUpdateAchModalOpen(false);
        openAchWindow();
    };
    const handleAchSkipped = ()=>{
        navigateToFinalizeTab();
        setIsUpdateAchModalOpen(false);
    };
    (0, _reactDefault.default).useEffect(()=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>{
                if (tab.id === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER) tab.isDisabled = isDirty || next_action === (0, _financingTabNames.financingTabNames).SELECT_OFFER;
                return tab;
            });
        });
        if (next_action === 'SIGN_CONTRACT') {
            setRefetchInterval(false);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).transactionHistory);
        }
    }, [
        isDirty,
        next_action,
        queryClient
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>{
                if (tab.id === (0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY) {
                    tab.isDisabled = !enableSignContract && !selectedOffer.id || next_action === 'SIGN_CONTRACT';
                    if (!enableSignContract && !selectedOffer.id || next_action === 'SIGN_CONTRACT') setIsUpdateButtonDisabled(true);
                    else setIsUpdateButtonDisabled(false);
                }
                return tab;
            });
        });
    }, [
        enableSignContract,
        selectedOffer.id,
        next_action
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setValue('deliveryDate', delivery_date);
        setValue('downPayment', Math.max(additional_payment, minimumDownPayment));
    }, [
        additional_payment,
        delivery_date,
        minimumDownPayment,
        setValue,
        selectedOffer.id
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (!isGetAppFetching) switch(next_action){
            case (0, _financingTabNames.financingTabNames).SELECT_OFFER:
                break;
            case 'UPDATE_OFFER':
                setEnableSignContract(true);
                if (isUpdateButtonPressed) {
                    if (priceInfo?.payment_method === '') setIsUpdateAchModalOpen(true);
                    else {
                        navigateToFinalizeTab();
                        setIsUpdateAchModalOpen(false);
                    }
                    setIsUpdateButtonPressed(false);
                } else {
                    navigateToFinalizeTab();
                    setIsUpdateAchModalOpen(false);
                }
                break;
            case 'SIGN_CONTRACT':
                setTabConfig((currentTabConfig)=>{
                    return currentTabConfig.map((tab)=>{
                        tab.isDisabled = tab.id !== (0, _financingTabNames.financingTabNames).FINALIZE_OFFER;
                        tab.isActive = tab.id === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER;
                        setActiveTabId((0, _financingTabNames.financingTabNames).FINALIZE_OFFER);
                        setEnableSignContract(true);
                        return tab;
                    });
                });
                break;
            default:
                break;
        }
    }, [
        next_action,
        isGetAppFetching,
        priceInfo?.payment_method
    ]);
    const handleTabChange = (tabId)=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>({
                    ...tab,
                    isActive: tabId === tab.id
                }));
        });
        setActiveTabId(tabId);
    };
    const onFocus = (event)=>event.target.select();
    const onSubmit = async (values)=>{
        scroll.bottom();
        setIsUpdateButtonPressed(true);
        setIsUpdateButtonDisabled(true);
        setActiveTab(activeTabId);
        setRequestId('');
        try {
            const result = await updateOffer({
                offer_id: selectedOffer.id,
                auto_pay: 'false',
                default_waived_interest: 'false',
                payment_date: 22,
                additional_payment: Number(watch('downPayment')) || 0,
                financing_down_payment: calculatedAmountToCollect,
                products: [
                    {
                        delivery_date: (0, _dateFns.formatISO)((0, _dateFns.parse)(values.deliveryDate, dateFormat, new Date()), {
                            representation: 'date'
                        }),
                        type: 'Medical Product',
                        description: 'Hearing Aids',
                        serial_number: null
                    }
                ]
            });
            setIsUpdateButtonDisabled(false);
            setRequestId(result.headers.request_id);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            reset(values);
            clearAlert();
        } catch (err) {
            setErrorAlert(err.message);
            setIsUpdateButtonDisabled(false);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.initializingFinancing')
    });
    const finalizeProps = {
        application: latestApp,
        routes,
        enableSignContract,
        watch,
        setIsLoading,
        setRefetchInterval
    };
    const selectOfferProps = {
        offers,
        selectedOffer,
        setSelectedOffer,
        enableSignContract,
        handleTabChange,
        amount_to_pay,
        already_paid_amount,
        routes,
        selected_offer_id
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        branding: "patientfi",
        title: tabConfig.find((tab)=>tab.id === activeTabId)?.pageHeader || t('page.completeFinancing.header'),
        withStepProgress: false,
        stickyFooter: true,
        children: [
            (isLoadingUpdateOffer || isGetAppLoading || isGetAppFetching) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('patientfi.updateApplication.loaderText')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                className: "bg-slate-300",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                    className: "flex-wrap content-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "md:!flex-col-8 mb-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "!mb-0",
                                children: t('payment.totalAmountLabel')
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "md:!flex-col-4 text-right mb-0 pr-5 font-bold text-md",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                i18nKey: `{{amount}}`,
                                values: {
                                    amount: (0, _numberFormat.formatCurrency)(amount_to_pay, {
                                        withDecimals: true
                                    })
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                className: "bg-stone-100 !pt-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsetDefault.default), {
                        tabConfig: tabConfig,
                        onTabChange: handleTabChange
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            activeTabId === (0, _financingTabNames.financingTabNames).SELECT_OFFER && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectOfferDefault.default), {
                                ...selectOfferProps
                            }),
                            activeTabId === (0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                name: "selectOfferForm",
                                onSubmit: handleSubmit(onSubmit),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "!mt-4",
                                        children: t('common.updateDownPayment')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                                                    className: "md:!flex-col-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "mr-2",
                                                                    "data-testid": "value-available-credit",
                                                                    children: t('common.alreadyPaidAmount')
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                                    content: t('common.availableCreditTooltip'),
                                                                    "data-testid": "tooltip-available-credit"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mt-1 text-lg font-semibold",
                                                            children: (0, _numberFormat.formatCurrency)(already_paid_amount)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                                    className: "md:!flex-col-6 lg:!flex-col-4",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                                        register: register,
                                                        label: downPaymentLabel,
                                                        "data-testid": "input-down-payment",
                                                        prependText: "$",
                                                        name: "downPayment",
                                                        type: "number",
                                                        disabled: !selectedOffer.id,
                                                        errors: errors,
                                                        onFocus: onFocus
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "!mt-4 hidden",
                                        children: t('common.updateDeliveryDate')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                                        className: "hidden",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                                            className: "justify-between items-end",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                                className: "md:!flex-col-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
                                                    name: "deliveryDate",
                                                    control: control,
                                                    rules: {
                                                        required: t('common.requiredFieldDeliveryDate')
                                                    },
                                                    render: ({ field: { onChange, onBlur, name, value } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarInputFieldDefault.default), {
                                                            label: t('common.deliveryDate'),
                                                            name: name,
                                                            value: value,
                                                            onBlur: onBlur,
                                                            "data-testid": "input-delivery-date",
                                                            onChange: onChange,
                                                            dayPickerProps: {
                                                                disabledDays: {
                                                                    before: new Date(),
                                                                    after: (0, _dateFns.add)(new Date(), {
                                                                        days: 60
                                                                    })
                                                                }
                                                            },
                                                            errors: errors
                                                        })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateAchModalDefault.default), {
                                        isModalOpen: isUpdateAchModalOpen,
                                        onModalConfirm: handleAchConfirm,
                                        onModalClose: handleAchSkipped
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                                        className: "flex justify-end mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                            className: "md:!flex-col-4 !flex !items-end",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                                block: true,
                                                type: "submit",
                                                "data-testid": "update-offer",
                                                disabled: !selectedOffer.id || isUpdateButtonDisabled,
                                                children: t('common.updateOffer')
                                            })
                                        })
                                    })
                                ]
                            }),
                            activeTabId === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _finalizeOfferDefault.default), {
                                ...finalizeProps
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = FinancingPreparation;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-hook-form":"53GLT","date-fns":[["add","1Oe4T","default"],["formatISO","5S5YG","default"],["parse","jBRYJ","default"]],"Core/components/FormElements/InputField":"6BJmW","Core/components/Page":"4xeqH","Core/components/Button":"6YNzH","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"Core/components/FormElements/Card":"23G8S","Core/components/Layout":"hweet","Core/components/Tabset/Tabset":"2cELS","Core/components/Tooltip":"ew5TJ","Core/hooks/useScrollBottom":"4561s","Core/components/Loader":"6S7S4","Core/components/FormElements/CalendarInputField":"50zwN","Core/stores/alert":"fPz3p","Core/utils/numberFormat":"6T56F","Core/config/appConfig":"7qX5H","Modules/patientfi/config/financingTabNames":"1esTv","Modules/patientfi/hooks/useSelectOfferForm":"ixFMt","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/patientfi/hooks/useUpdateOffer":"a7c40","Modules/patientfi/hooks/useGetApplication":"ijipp","Modules/patientfi/hooks/useGetNextStep":"4nfRQ","Core/hooks/queries/cacheKeys":"i5IL7","react-query":"ksTpv","Modules/patientfi/FinalizeOffer":"7Uepa","Modules/patientfi/components/UpdateAchModal":"ifOBJ","Core/stores/tabs":"gZ09A","Modules/patientfi/SelectOffer":"9wNEJ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1esTv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "financingTabNames", ()=>financingTabNames);
const financingTabNames = {
    SELECT_OFFER: 'SELECT_OFFER',
    DOWN_PAYMENT_AND_DELIVERY: 'DOWN_PAYMENT_AND_DELIVERY',
    FINALIZE_OFFER: 'FINALIZE_OFFER',
    CONTRACT_STATUS: 'CONTRACT_STATUS'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ixFMt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateDownPaymentAmount", ()=>validateDownPaymentAmount);
parcelHelpers.export(exports, "validateCustomDateFormat", ()=>validateCustomDateFormat);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
const validateDownPaymentAmount = (minimumDownPayment, maximumDownPayment)=>(value)=>{
        return value !== '' && value >= minimumDownPayment && value <= maximumDownPayment;
    };
const validateCustomDateFormat = (dateFormat)=>(val)=>{
        return val ? (0, _dateFns.isValid)((0, _dateFns.parse)(val, dateFormat, new Date())) : true;
    };
const useSelectOfferForm = ({ minimumDownPayment, maximumDownPayment, dateFormat })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            deliveryDate: _v3.any().refine(validateCustomDateFormat(dateFormat), {
                message: t('common.invalidDateFormat')
            }),
            downPayment: _v3.any().transform(parseFloat).refine(validateDownPaymentAmount(minimumDownPayment, maximumDownPayment), {
                message: t('common.invalidValueRange', {
                    min: minimumDownPayment,
                    max: maximumDownPayment
                })
            })
        });
    }, [
        t,
        minimumDownPayment,
        maximumDownPayment,
        dateFormat
    ]);
    return (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        defaultValues: {
            downPayment: minimumDownPayment,
            deliveryDate: (0, _dateFns.format)(new Date(), dateFormat)
        }
    });
};
exports.default = useSelectOfferForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","react-hook-form":"53GLT","date-fns":[["format","7JNRj","default"],["isValid","jCEss","default"],["parse","jBRYJ","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"a7c40":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdateOffer);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
function useUpdateOffer() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>(0, _platformApi.putWithHeaders)(`/financing/update-offer`, payload), {
        throwOnError: true,
        retry: 3,
        onSuccess: ()=>{
            queryClient.removeQueries((0, _cacheKeysDefault.default).financingNextStep);
            return queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4nfRQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetNextStep", ()=>useGetNextStep);
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _platformApi = require("Core/utils/platformApi");
function useGetNextStep(refetchInterval, enabled = true) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const validator = (data)=>Boolean(data) && Boolean(data?.next_action);
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).financingNextStep, ()=>(0, _platformApi.get)('/application/next-step', {}, validator), {
        refetchInterval,
        enabled: Boolean(enabled),
        onError (e) {
            if (e) setError(t('status.error.getPaymentInfoFailed') + ` - (${e})`);
        }
    });
}

},{"react-i18next":"244ua","Core/stores/error":"38MVH","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/platformApi":"9RrWs","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7Uepa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinalizerOffer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layout = require("Core/components/Layout");
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
var _alert = require("Core/components/Alert");
var _useGetNextStep = require("Modules/financing/hooks/useGetNextStep");
var _spinner = require("Core/components/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _financingSummary = require("./FinancingSummary");
var _financingSummaryDefault = parcelHelpers.interopDefault(_financingSummary);
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _sendLinkSources = require("Modules/financing/config/sendLinkSources");
var _sendLink = require("Modules/financing/FinalizeOffer/SendLink");
var _sendLinkDefault = parcelHelpers.interopDefault(_sendLink);
var _logger = require("Core/utils/logger");
var _utils = require("Core/utils/utils");
var _financingModal = require("Core/components/FinancingModal/FinancingModal");
var _financingModalDefault = parcelHelpers.interopDefault(_financingModal);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
function FinalizerOffer({ application, enableSignContract, watch, setRefetchInterval, routes }) {
    const [state, setState] = (0, _reactDefault.default).useState({
        refetchInterval: false,
        financingWindow: null,
        isSignContractLoading: false,
        isError: false,
        isModalOpen: false
    });
    const { t } = (0, _reactI18Next.useTranslation)();
    const [showSendLinkFeature, setShowSendLinkFeature] = (0, _reactDefault.default).useState(false);
    const [isTeleaudiology, setIsTeleaudiology] = (0, _reactDefault.default).useState(false);
    const blockFinalizeOfferForFinalQuote = (0, _utils.getUrlParamIgnoreCase)('blockFinalizeOfferForFinalQuote') === 'true';
    const { data: nextStepApp } = (0, _useGetNextStep.useGetNextStep)(state.refetchInterval);
    const { data: { source = '' } = {} } = (0, _useGetPaymentInfo.useGetPaymentInfo)() || {};
    const finalApp = nextStepApp || application || {};
    const { external_reference_id = '', payload: { links: { cart: redirection_link }, application_id = '', payment_id = '' } } = finalApp;
    (0, _reactDefault.default).useEffect(()=>{
        // let isSourceForTA = false;
        if (source) {
            const cleanedSource = source.includes('::') ? source.split('::')[0] : source;
            if ((0, _sendLinkSources.SEND_LINK_SOURCES).includes(cleanedSource)) setShowSendLinkFeature(true);
            else setShowSendLinkFeature(false);
        }
        const isSamePageFlow = (0, _utils.getUrlParamIgnoreCase)('samePageFlow') === 'true';
        setIsTeleaudiology(!!isSamePageFlow);
    }, [
        source
    ]);
    const openFinancingWindow = (e)=>{
        (0, _logger.postLogMessage)({
            feature: (0, _logger.features).financingSignContract,
            action: (0, _logger.actions).signContractButtonClicked,
            status: 'success',
            payment_id,
            external_reference_id,
            application_id
        });
        e.preventDefault();
        if (redirection_link) {
            if (isTeleaudiology) {
                const financingWindow = window.open(redirection_link, '_self');
                setState({
                    ...state,
                    refetchInterval: 5000,
                    financingWindow,
                    isSignContractLoading: true
                });
            } else {
                // Original behavior - open in new tab
                const financingWindow = window.open(redirection_link, '_blank');
                setState({
                    ...state,
                    refetchInterval: 5000,
                    financingWindow,
                    isSignContractLoading: true
                });
            }
        }
    };
    const closeModal = ()=>{
        setState({
            ...state,
            isModalOpen: false
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full m-auto",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                            type: "shade",
                            "data-testid": "notification-financing-intro",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-sm w-full",
                                children: t('patientfi.signContract.intro')
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSummaryDefault.default), {
                            watch: watch,
                            setRefetchInterval: setRefetchInterval,
                            routes: routes,
                            application: application
                        }),
                        state.isSignContractLoading && isTeleaudiology && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                            type: "overlay",
                            message: "Redirecting to Contract page..."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                            className: "px-2 mt-4 items-center justify-center",
                            children: state.isSignContractLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                className: "flex justify-center items-center w-full mx-0",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                                        className: "!flex-col-12 text-center mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                                                small: true,
                                                className: "!w-6 !h-6 !text-primary"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "pl-4 text-lg font-semibold",
                                                children: t('financing.nextgen.signContract.loadingText')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!flex-col-6 text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                                            block: true,
                                            "data-testid": "set-offer",
                                            onClick: openFinancingWindow,
                                            disabled: !enableSignContract,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-sm",
                                                children: t('patientfi.reOpenFinalizeOffer')
                                            })
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                className: "flex justify-center items-center w-full px-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!flex-col-1 lg:!flex-col-3 px-0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "lg:!flex-col-6 px-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                            block: true,
                                            "data-testid": "set-offer",
                                            onClick: openFinancingWindow,
                                            disabled: !enableSignContract || blockFinalizeOfferForFinalQuote,
                                            children: t('common.acceptOffer')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!flex-col-3 text-right mb-2"
                                    }),
                                    showSendLinkFeature && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "lg:!flex-col-6 px-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendLinkDefault.default), {
                                            className: "m-auto"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingModalDefault.default), {
                isOpen: state.isModalOpen,
                onClose: closeModal,
                url: redirection_link
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Layout":"hweet","Core/components/Button":"6YNzH","react-i18next":"244ua","Core/components/Alert":"fmmNR","Modules/financing/hooks/useGetNextStep":"fWBFC","Core/components/Spinner":"bZo5I","./FinancingSummary":"8JCPF","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/financing/config/sendLinkSources":"hEKtX","Modules/financing/FinalizeOffer/SendLink":"l5A5K","Core/utils/logger":"cWDKQ","Core/utils/utils":"hwOBZ","Core/components/FinancingModal/FinancingModal":"koo6T","Core/components/Loader":"6S7S4","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8JCPF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layout = require("Core/components/Layout");
var _dropdown = require("Core/components/Dropdown/Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _icon = require("Core/components/Icon/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _numberFormat = require("Core/utils/numberFormat");
var _utils = require("Core/utils/utils");
var _useGetTransactionHistory = require("Core/hooks/platform/useGetTransactionHistory");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _reactQuery = require("react-query");
var _reactLocation = require("react-location");
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
function FinancingSummary({ routes, watch, application, setRefetchInterval }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const navigate = (0, _reactLocation.useNavigate)();
    const [isCollectPaymentLoading, setIsCollectPaymentLoading] = (0, _reactDefault.default).useState(false);
    const { data: transactions } = (0, _useGetTransactionHistory.useGetTransactionHistory)();
    const [receiptList, setReceiptList] = (0, _reactDefault.default).useState([]);
    const { next_action, payload: { already_paid_amount = 0 } = {} } = application ?? {};
    const priceInfo = application?.payload?.offer_term?.price;
    const { financed, monthly_payment = '' } = priceInfo || {};
    const availableCredit = watch('downPayment') - already_paid_amount;
    const handleUnload = (e)=>{
        const message = '';
        (e || window.event).returnValue = message;
        return message;
    };
    (0, _reactDefault.default).useEffect(()=>{
        if (transactions && transactions.length > 0) setReceiptList(transactions.map((item, idx, arr)=>{
            const receiptNum = arr.length === 1 ? '' : idx + 1;
            return {
                label: 'Receipt ' + receiptNum,
                key: item?.payment_id,
                url: item?.receipt?.url
            };
        }));
    }, [
        transactions
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (next_action === 'SIGN_CONTRACT') setIsCollectPaymentLoading(false);
        else if (next_action === 'DONE' || next_action === 'PENDING_DOWN_PAYMENT') navigate({
            to: routes.financing,
            search: true
        });
        return ()=>{
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, [
        next_action,
        navigate,
        routes.financing
    ]);
    const onCollectPayment = ()=>{
        const url = (0, _utils.generateURL)({
            url: routes.mixed
        });
        setIsCollectPaymentLoading(true);
        setRefetchInterval(5000);
        queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
        setTimeout(()=>setIsCollectPaymentLoading(false), 300000);
        window.open(url, '_blank')?.focus();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "text-center mb-4",
                children: t('common.summary')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-1 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-funding-by-allegro",
                        children: t('patientfi.fundingByPatientFi')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2",
                        "data-testid": "value-funding-by-allegro",
                        children: isNaN(financed) ? '-' : (0, _numberFormat.formatCurrency)(financed % 1 > 0 ? financed.toFixed(2) : financed)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-1 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-monthly-payment",
                        children: t('financing.monthlyPayment')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2 ",
                        "data-testid": "value-monthly-payment",
                        children: (0, _numberFormat.formatCurrency)(monthly_payment, {
                            withDecimals: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-1 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-available-credit",
                        children: t('common.availableCredit')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2 ",
                        "data-testid": "value-available-credit",
                        children: (0, _numberFormat.formatCurrency)(already_paid_amount)
                    })
                ]
            }),
            next_action === 'SIGN_CONTRACT' && availableCredit > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "items-center mx-0 flex-nowrap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-additional-collected-amount",
                        children: t('financing.additionalCollectedAmount')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                        className: "!flex-col-2 flex justify-end items-center px-2",
                        "data-testid": "value-additional-collected-amount",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                type: "success"
                            }),
                            (0, _numberFormat.formatCurrency)(availableCredit)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-3 text-left",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                transactions && transactions.length === 1 && receiptList.map(({ url, key })=>{
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "bg-transparent text-primary hover:bg-gray-100 p-2 rounded text-sm",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "data-testid": "receipt-item",
                                        href: url,
                                        children: t('common.viewReceipt')
                                    }, key);
                                }),
                                receiptList && receiptList.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default), {
                                    label: t('common.viewReceipt'),
                                    list: receiptList
                                })
                            ]
                        })
                    })
                ]
            }),
            next_action !== 'SIGN_CONTRACT' && availableCredit > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "items-center mx-0  flex-nowrap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left text-amber-700",
                        "data-testid": "label-amount-to-collect",
                        children: t('financing.amountToBeCollected')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                        className: "!flex-col-2 text-right flex justify-end items-center px-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "!hidden lg:!block",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                    type: "warning",
                                    className: "mr-3"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-amber-700",
                                "data-testid": "value-amount-to-collect",
                                children: (0, _numberFormat.formatCurrency)(availableCredit)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-3 text-left",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.TextButton), {
                            disabled: isCollectPaymentLoading,
                            onClick: onCollectPayment,
                            "data-testid": "btn-collect-payment",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex",
                                children: [
                                    isCollectPaymentLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "inline-block mr-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                            type: "spinner"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "!hidden lg:!block",
                                        children: t('financing.collectPayment')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "!block lg:!hidden",
                                        children: 'Collect'
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-4 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-total-down-payment",
                        children: t('financing.totalDownPayment')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2",
                        "data-testid": "value-total-down-payment",
                        children: (0, _numberFormat.formatCurrency)(watch('downPayment') || 0)
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Layout":"hweet","Core/components/Dropdown/Dropdown":"g18oR","Core/components/Icon/Icon":"cAPHo","Core/utils/numberFormat":"6T56F","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetTransactionHistory":"3gwu1","Core/hooks/queries/cacheKeys":"i5IL7","react-query":"ksTpv","react-location":"8hNco","Core/components/Button":"6YNzH","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hEKtX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SOURCE_TA", ()=>SOURCE_TA);
parcelHelpers.export(exports, "SEND_LINK_SOURCES", ()=>SEND_LINK_SOURCES);
const SOURCE_TA = 'TELEAUDIOLOGY';
const SEND_LINK_SOURCES = [
    'Salesforce.Opportunity.ab - Sales Consulting Console',
    'Salesforce.Opportunity.ab - Sales Consulting Manager Console',
    'Salesforce.Opportunity.ab - Invoicing',
    'Salesforce.Opportunity.ab - Quality Manager',
    'Salesforce.Opportunity.ab - Partner Manager',
    'Salesforce.Opportunity.ab - Business Development (without admin)',
    'Salesforce.Opportunity.ab - Quality Management',
    'Salesforce.Lead.ab - Sales Consulting Console',
    'Salesforce.Lead.ab - Sales Consulting Manager Console'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ifOBJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateAchModal);
var _jsxRuntime = require("react/jsx-runtime");
var _alert = require("Core/components/Alert");
var _button = require("Core/components/Button");
var _layout = require("Core/components/Layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function UpdateAchModal({ isModalOpen, onModalClose, onModalConfirm }) {
    const handleConfirm = (e)=>{
        if (onModalConfirm) onModalConfirm(e);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
        isOpen: isModalOpen,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "font-bold text-center",
                children: "Add ACH?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "p-6 text-center",
                "data-testid": "title-autopay-redirect",
                children: "You can update the payment method to potentially lower your APR. Do you want to navigate to the Allegro portal to update it?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                    type: "shade",
                    "data-testid": "note-autopay-redirect",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: "Note: "
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            children: [
                                "If you click on ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                    className: "font-bold",
                                    children: "Add AutoPay"
                                }),
                                " you will be redirected to the Allegro portal. Please add ACH information and return to this page thereafter."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-end justify-end gap-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                        type: "button",
                        onClick: onModalClose,
                        "data-testid": "btn-skip-autopay",
                        children: "Skip Autopay and Finalize Contract"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                        type: "button",
                        onClick: handleConfirm,
                        "data-testid": "btn-add-autopay",
                        children: "Add AutoPay"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","Core/components/Alert":"fmmNR","Core/components/Button":"6YNzH","Core/components/Layout":"hweet","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9wNEJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectOffer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _financingNotEligible = require("Modules/patientfi/components/FinancingNotEligible");
var _financingNotEligibleDefault = parcelHelpers.interopDefault(_financingNotEligible);
var _offerOptions = require("../components/OfferOptions");
var _offerOptionsDefault = parcelHelpers.interopDefault(_offerOptions);
var _button = require("Core/components/Button");
var _financingTabNames = require("../config/financingTabNames");
var _fa = require("react-icons/fa");
function SelectOffer({ offers, selectedOffer, setSelectedOffer, enableSignContract, handleTabChange, amount_to_pay, already_paid_amount, routes, selected_offer_id }) {
    const [isAnyOfferValid, setIsAnyOfferValid] = (0, _reactDefault.default).useState(true);
    const [showOfferDetails, setShowOfferDetails] = (0, _reactDefault.default).useState(false);
    (0, _reactDefault.default).useEffect(()=>{
        if (offers?.installment) {
            if (selected_offer_id) {
                const { type = '', terms = [] } = offers.installment.find((item)=>item.terms[0].id === selected_offer_id) || {};
                setSelectedOffer({
                    id: selected_offer_id,
                    amount_min: terms[0]?.amount_min,
                    require_downpayment_percent: terms[0]?.require_downpayment_percent,
                    type
                });
            } else if (offers.installment.length > 0) {
                const anyValid = offers.installment.some(({ terms })=>{
                    const [{ amount_min, require_downpayment_percent }] = terms;
                    const finalAmountMin = Math.max(amount_min, amount_to_pay * require_downpayment_percent);
                    return amount_to_pay - already_paid_amount > finalAmountMin;
                });
                setIsAnyOfferValid(anyValid);
            }
        }
    }, [
        already_paid_amount,
        amount_to_pay,
        offers?.installment,
        selected_offer_id,
        setSelectedOffer
    ]);
    const toggleOfferDetails = ()=>{
        setShowOfferDetails((prev)=>!prev);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex justify-center flex-wrap",
                children: isAnyOfferValid ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offerOptionsDefault.default), {
                    offers: offers,
                    selectedOffer: selectedOffer,
                    setSelectedOffer: setSelectedOffer,
                    amount_to_pay: amount_to_pay,
                    already_paid_amount: already_paid_amount,
                    showOfferDetails: showOfferDetails
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingNotEligibleDefault.default), {
                    already_paid_amount: already_paid_amount,
                    amount_to_pay: amount_to_pay,
                    routes: routes
                })
            }),
            isAnyOfferValid && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex justify-center pt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.LinkButton), {
                            onClick: toggleOfferDetails,
                            children: showOfferDetails ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaChevronUp), {}),
                                    " Hide Offer Details"
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaChevronDown), {}),
                                    " Show Offer Details"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            "data-testid": "btn-next",
                            disabled: !enableSignContract && !selectedOffer.id,
                            className: "w-48 mt-4",
                            onClick: ()=>handleTabChange((0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY),
                            children: "Next"
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/patientfi/components/FinancingNotEligible":"cbLAg","../components/OfferOptions":"i6QOx","Core/components/Button":"6YNzH","../config/financingTabNames":"1esTv","react-icons/fa":"9Vrsi","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cbLAg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingNotEligible);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _numberFormat = require("Core/utils/numberFormat");
var _layout = require("Core/components/Layout");
var _utils = require("Core/utils/utils");
var _alert = require("Core/components/Alert");
var _button = require("Core/components/Button");
function FinancingNotEligible({ already_paid_amount, amount_to_pay, routes }) {
    const [isModalOpen, setIsModalOpen] = (0, _reactDefault.default).useState(false);
    const onOpenConfirmationPopup = ()=>{
        setIsModalOpen(true);
    };
    const onCollectPayment = ()=>{
        const url = (0, _utils.generateURL)({
            url: routes?.payment
        });
        window.open(url, '_self');
    };
    const onModalClose = ()=>{
        setIsModalOpen(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "justify-center flex-col items-center w-full",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "font-regular text-large w-full",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                            showIcon: true,
                            type: "warningLight",
                            title: "correction required",
                            "data-testid": "message-not-eligible",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "font-bold",
                                    children: "Financing amount too low!"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Your application is approved. However, you have an available credit of\xa0"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "font-bold",
                                    children: [
                                        "(",
                                        (0, _numberFormat.formatCurrency)(already_paid_amount),
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "\xa0so the amount to be financed\xa0"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "font-bold",
                                    children: [
                                        "(",
                                        (0, _numberFormat.formatCurrency)(amount_to_pay - already_paid_amount),
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "\xa0is lower than the minimum eligible amount that can be financed. You can click on the button below to complete the remaining amount instead of financing it."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "text-center text-gray-400 w-1/3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            "data-testid": "btn-collect-payment",
                            block: true,
                            onClick: onOpenConfirmationPopup,
                            children: "Collect Payment"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
                isOpen: isModalOpen,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "font-bold text-center",
                        children: "Are you sure you want to proceed to Payment Collection?"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-6 text-center",
                        "data-testid": "title-autopay-redirect",
                        children: "You will leave the financing application and be redirected to the payment collection portal"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-end justify-end gap-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                                type: "button",
                                onClick: onModalClose,
                                "data-testid": "btn-modal-cancel",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                type: "button",
                                onClick: onCollectPayment,
                                "data-testid": "btn-modal-confirm",
                                children: "Confirm"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/utils/numberFormat":"6T56F","Core/components/Layout":"hweet","Core/utils/utils":"hwOBZ","Core/components/Alert":"fmmNR","Core/components/Button":"6YNzH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i6QOx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OfferOptions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _numberFormat = require("Core/utils/numberFormat");
var _modernRadioOption = require("Core/components/ModernOption/ModernRadioOption");
var _modernRadioOptionDefault = parcelHelpers.interopDefault(_modernRadioOption);
var _richTextDescriptionItem = require("Core/components/RichTextDescriptionItem");
var _richTextDescriptionItemDefault = parcelHelpers.interopDefault(_richTextDescriptionItem);
var _button = require("Core/components/Button");
var _fa = require("react-icons/fa");
var _im = require("react-icons/im");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function OfferOptions({ offers, selectedOffer, setSelectedOffer, amount_to_pay, already_paid_amount, showOfferDetails }) {
    return offers.installment.map(({ terms, type, rich_text_descriptions }, idx)=>{
        const richTextDescriptions = rich_text_descriptions || [];
        const [{ id, term: fixedTerm, apr: autoPayApr, apr_max: regularApr, amount_min, require_downpayment_percent, promo: { monthly_premium = '', term: promoTerm = '' } = {} }] = terms;
        const isPromo = promoTerm && monthly_premium;
        const checked = selectedOffer.id === id;
        const isDisabled = amount_to_pay - already_paid_amount < amount_min;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "!flex-col-12 min-h-[15em] first:pl-0 last:pr-0 px-2 mb-4 lg:!flex-col-4",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modernRadioOptionDefault.default), {
                className: "mb-3",
                name: "offer",
                value: id,
                checked: checked,
                disabled: isDisabled,
                variant: isPromo ? 'success' : 'branding',
                "data-testid": 'select-offer-radio-' + idx,
                onChange: (e)=>{
                    setSelectedOffer({
                        id: e.target.value,
                        amount_min,
                        require_downpayment_percent,
                        type
                    });
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col justify-around radio-header h-128",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: (0, _classnamesDefault.default)('flex justify-between  px-2 py-4 items-center', {
                                    'bg-gray-300': !isPromo && !checked,
                                    'bg-blue-200': !isPromo && checked,
                                    'bg-patientfi-bg': isPromo
                                }),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-center font-bold text-xl px-2 leading-tight text-gray-600",
                                        children: fixedTerm + ' Months'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-center font-semibold text-sm px-2 tracking-wide",
                                        children: isPromo ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rounded-full bg-gray-200 text-teal-600 px-2 py-2 font-bold",
                                            children: promoTerm + ' Month promo'
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rounded-full bg-gray-200 text-gray-500 px-2 py-2",
                                            children: "Fixed term"
                                        })
                                    })
                                ]
                            }),
                            isPromo && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: (0, _classnamesDefault.default)('border flex gap-2 justify-between border-slate-300 rounded-xl p-3 m-2 items-center flex-wrap'),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        className: "w-1/2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "font-normal text-sm mb-1 text-gray-500",
                                                children: [
                                                    "Suggested Payment",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-sm text-red-500 pl-1",
                                                        children: isPromo ? '*' : ''
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-bold text-2xl tracking-tight",
                                                children: (0, _numberFormat.formatCurrency)(monthly_premium, {
                                                    withDecimals: true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        className: "text-right",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-normal text-sm text-gray-500",
                                                children: "PROMO APR"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-bold text-lg tracking-tight text-slate-500",
                                                children: "0%"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isPromo && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-full my-1 text-center text-gray-500",
                                children: "OR"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "border flex gap-2 justify-between border-slate-300 rounded-xl p-3 m-2 items-center flex-wrap",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "font-normal text-sm text-gray-500 mb-1",
                                                children: [
                                                    "Minimum Monthly",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-sm text-red-500 pl-1",
                                                        children: isPromo ? '*' : ''
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-bold text-2xl tracking-tight",
                                                children: (0, _numberFormat.formatCurrency)(amount_min, {
                                                    withDecimals: true
                                                })
                                            })
                                        ]
                                    }),
                                    !isPromo && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        className: "text-right",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-normal text-sm text-gray-500",
                                                children: "FIXED APR"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "font-bold text-lg tracking-tight text-slate-500",
                                                children: [
                                                    regularApr,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: " text-sm text-gray-500 tracking-tight",
                                                children: [
                                                    autoPayApr,
                                                    "% with Autopay"
                                                ]
                                            })
                                        ]
                                    }),
                                    isPromo && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        className: "text-right",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-normal text-sm text-gray-500",
                                                children: "POST PROMO APR"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "font-bold text-lg tracking-tight text-slate-500",
                                                children: [
                                                    regularApr,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: " text-sm text-gray-500 tracking-tight",
                                                children: [
                                                    autoPayApr,
                                                    "% with Autopay"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !checked ? !isDisabled ? !isPromo ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mt-28 pt-14"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mt-5 pt-4"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-3 mt-auto text-gray-400 flex items-center justify-center text-base",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "inline-block",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _im.ImBlocked), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "ml-2 font-medium",
                                        children: "Not Eligible"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.TextButton), {
                                className: (0, _classnamesDefault.default)('pointer-events-none flex items-center justify-center  relative bottom-0', {
                                    'mt-16 mb-16': !isPromo
                                }),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaCheckCircle), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "ml-2 text-base font-medium",
                                        children: "Selected"
                                    })
                                ]
                            })
                        ]
                    }),
                    isPromo && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "text-xs leading-relaxed px-3 pb-1 mt-2 text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-xs text-red-500",
                                children: "*"
                            }),
                            "Final monthly payment can be selected before the final step."
                        ]
                    }),
                    showOfferDetails && richTextDescriptions?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "h-full px-4 radio-description text-sm flex flex-col justify-start pt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                            children: richTextDescriptions.map((item)=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richTextDescriptionItemDefault.default), {
                                    id: item.id,
                                    iconName: item.icon_name,
                                    title: item.title,
                                    text: item.text
                                }, item.id);
                            })
                        })
                    })
                ]
            }, id)
        }, id);
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/utils/numberFormat":"6T56F","Core/components/ModernOption/ModernRadioOption":"h4Rpv","Core/components/RichTextDescriptionItem":"iD9M8","Core/components/Button":"6YNzH","react-icons/fa":"9Vrsi","react-icons/im":"ek0E7","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h4Rpv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ModernRadioOption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modernRadioOptionStyled = require("./ModernRadioOption.styled");
function ModernRadioOption({ name, value, checked, disabled, testid, onChange, children, variant = 'branding' }) {
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modernRadioOptionStyled.StyledLabel), {
        htmlFor: id,
        "data-testid": testid || id,
        variant: variant,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernRadioOptionStyled.StyledInput), {
                type: "radio",
                name: name,
                value: value,
                id: id,
                checked: checked,
                disabled: disabled,
                onChange: onChange,
                role: "radio"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernRadioOptionStyled.StyledBody), {
                variant: variant,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "w-full flex flex-col h-full",
                    children: children
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","./ModernRadioOption.styled":"7Od92","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7Od92":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLabel", ()=>StyledLabel);
parcelHelpers.export(exports, "StyledCheckbox", ()=>StyledCheckbox);
parcelHelpers.export(exports, "StyledBody", ()=>StyledBody);
parcelHelpers.export(exports, "StyledButton", ()=>StyledButton);
parcelHelpers.export(exports, "StyledInput", ()=>StyledInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const StyledLabel = ({ children, variant, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
        className: (0, _classnamesDefault.default)('radio-option radio-vertical h-full !rounded-lg', {
            'bg-green-500': variant === 'success',
            'bg-red-500': variant === 'branding'
        }),
        ...rest,
        children: children
    });
const StyledCheckbox = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "radio-option-checkbox",
        children: children
    });
const StyledBody = ({ children, variant })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _classnamesDefault.default)('radio-option-body h-full !p-0 flex-col rounded-lg', {
            'bg-green-500': variant === 'success',
            'bg-red-500': variant === 'branding'
        }),
        children: children
    });
const StyledButton = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "rounded-full border-primary bg-none",
        children: children
    });
const StyledInput = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        ...props,
        className: 'radio-option-input'
    });

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iD9M8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RichTextDescriptionItem);
var _jsxRuntime = require("react/jsx-runtime");
var _fa6 = require("react-icons/fa6");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function RichTextDescriptionItem({ id, iconName, title, text }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex px-1 pb-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-xs mt-1 text-gray-500 mr-1",
                children: /*#__PURE__*/ (0, _reactDefault.default).createElement(_fa6[`${iconName}`])
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pl-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "h-full font-bold text-xs rich-text-weak-content justify-start text-justify",
                        children: [
                            title,
                            ":",
                            ' '
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "h-full text-xs rich-text-weak-content justify-start text-justify",
                        children: text
                    })
                ]
            })
        ]
    }, id);
}

},{"react/jsx-runtime":"9x2lT","react-icons/fa6":"1emil","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"e24n1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _canvasConfetti = require("canvas-confetti");
var _canvasConfettiDefault = parcelHelpers.interopDefault(_canvasConfetti);
var _hi2 = require("react-icons/hi2");
var _useGetTransactionHistory = require("Core/hooks/platform/useGetTransactionHistory");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _useGetNextStep = require("../hooks/useGetNextStep");
var _button = require("Core/components/Button");
var _utils = require("Core/utils/utils");
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _routes = require("Modules/patientfi/routes");
var _icon = require("Core/components/Icon/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _numberFormat = require("Core/utils/numberFormat");
var _useGetContract = require("../hooks/useGetContract");
var _useGetContractDefault = parcelHelpers.interopDefault(_useGetContract);
var _logger = require("Core/utils/logger");
// TODO: re-enable once the financing contract document is available again
const SHOW_CONTRACT_DOWNLOAD = false;
const documentTileClasses = 'group flex max-w-sm flex-1 items-center gap-3.5 rounded-xl border border-slate-200 bg-gradient-to-b from-slate-50 to-slate-100/60 px-4 py-3.5 text-left text-slate-900 no-underline transition [flex-basis:260px] hover:-translate-y-px hover:border-green-400 hover:from-green-50 hover:to-green-100/60 hover:shadow-md disabled:pointer-events-none disabled:opacity-60';
const fireConfetti = ()=>{
    const colors = [
        '#10b981',
        '#34d399',
        '#6ee7b7',
        '#fde68a',
        '#ffffff'
    ];
    (0, _canvasConfettiDefault.default)({
        particleCount: 120,
        spread: 80,
        startVelocity: 45,
        origin: {
            x: 0.5,
            y: 0.1
        },
        colors
    });
    setTimeout(()=>{
        (0, _canvasConfettiDefault.default)({
            particleCount: 60,
            angle: 60,
            spread: 55,
            origin: {
                x: 0,
                y: 0.3
            },
            colors
        });
        (0, _canvasConfettiDefault.default)({
            particleCount: 60,
            angle: 120,
            spread: 55,
            origin: {
                x: 1,
                y: 0.3
            },
            colors
        });
    }, 250);
};
const FinancingSuccess = ()=>{
    document.title = 'Payment Portal - Success';
    const { t } = (0, _reactI18Next.useTranslation)();
    const routes = {
        mixed: (0, _routes.mixedDownPaymentCheckoutPath)
    };
    const { data: transactions } = (0, _useGetTransactionHistory.useGetTransactionHistory)();
    const checklistItems = [
        {
            label: t('page.financing.checklist.approved'),
            Icon: (0, _hi2.HiOutlineShieldCheck)
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            Icon: (0, _hi2.HiOutlinePencilSquare)
        },
        {
            label: t('page.financing.checklist.funded'),
            Icon: (0, _hi2.HiOutlineCheckBadge)
        }
    ];
    const [isCollectPaymentLoading, setIsCollectPaymentLoading] = (0, _reactDefault.default).useState(false);
    const [refetchInterval, setRefetchInterval] = (0, _reactDefault.default).useState(false);
    const { data: application, isSuccess: isGetNextStepSuccess } = (0, _useGetNextStep.useGetNextStep)(refetchInterval);
    const { next_action, external_reference_id = '', payload: { financing_down_payment = 0, payment_id = '', application_id = '' } = {} } = application;
    const { mutateAsync: getContract, data: pdfData } = (0, _useGetContractDefault.default)();
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetNextStepSuccess && payment_id && application_id && external_reference_id) (0, _logger.postLogMessage)({
            feature: (0, _logger.features).financingSignContract,
            action: (0, _logger.actions).financingSuccessScreenDisplayed,
            payment_id,
            application_id,
            external_reference_id
        });
    }, [
        isGetNextStepSuccess
    ]);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const confettiFiredRef = (0, _reactDefault.default).useRef(false);
    const onCollectPayment = ()=>{
        const payId = (0, _utils.getUrlParam)('payment-id');
        const web_code = (0, _utils.getUrlParam)('web-code');
        const url = (0, _utils.generateURL)({
            url: routes.mixed,
            params: {
                'payment-id': payId,
                'web-code': web_code
            }
        });
        setIsCollectPaymentLoading(true);
        setRefetchInterval(5000);
        queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
        setTimeout(()=>setIsCollectPaymentLoading(false), 300000);
        window.open(url, '_blank')?.focus();
    };
    (0, _reactDefault.default).useEffect(()=>{
        if (next_action === 'DONE') {
            setRefetchInterval(false);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).transactionHistory);
        }
    }, [
        next_action,
        queryClient
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (confettiFiredRef.current) return;
        if (typeof window === 'undefined') return;
        confettiFiredRef.current = true;
        const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        if (reduced) return;
        fireConfetti();
    }, []);
    const downloadContract = async ()=>{
        const resp = await getContract();
        const uriContent = URL.createObjectURL(new Blob([
            resp
        ]));
        const downloadLink = document.createElement('a');
        const fileName = 'contract.pdf';
        downloadLink.href = uriContent;
        downloadLink.download = fileName;
        downloadLink.click();
    };
    const hasReceipts = Boolean(transactions && transactions.length > 0);
    const hasDocuments = SHOW_CONTRACT_DOWNLOAD || hasReceipts;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "mx-auto flex max-w-4xl flex-col gap-5 px-4 pb-10 pt-5 text-slate-900",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "flex flex-col items-center gap-2 pt-1 text-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "relative mb-1 flex h-24 w-24 items-center justify-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "absolute inset-0 rounded-full bg-green-400/20 blur-md",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "absolute inset-2.5 rounded-full border-2 border-green-500/50 animate-ping motion-reduce:animate-none",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "relative z-10 flex h-[72px] w-[72px] items-center justify-center rounded-full bg-green-100 text-green-600",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineCheckCircle), {
                                        className: "h-10 w-10"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "m-0 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl",
                            children: t('page.financing.financingFunded.infobox')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "mx-auto max-w-xl text-sm leading-relaxed text-slate-500",
                            children: t('page.financing.financingFunded.intro')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "rounded-2xl border border-slate-200 bg-white px-6 py-6 shadow-sm sm:px-7",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-col gap-1",
                            children: checklistItems.map(({ label, Icon: StepIcon })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    "data-testid": "checklist-item-done",
                                    className: "flex items-center gap-3.5 py-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepIcon, {
                                                className: "h-[18px] w-[18px]"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-base text-slate-900",
                                            children: label
                                        })
                                    ]
                                }, label))
                        }),
                        hasDocuments && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                    className: "my-5 border-0 border-t border-slate-200"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "m-0 mb-3.5 text-base font-bold tracking-tight text-slate-900",
                                    children: "Documents"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-wrap gap-3.5",
                                    children: [
                                        SHOW_CONTRACT_DOWNLOAD && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            type: "button",
                                            onClick: downloadContract,
                                            disabled: Boolean(pdfData),
                                            "data-testid": "contract-download",
                                            className: documentTileClasses,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] bg-green-100 text-green-600",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineDocumentText), {
                                                        className: "h-5 w-5"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex-1 text-sm font-semibold text-slate-900",
                                                    children: "Financing Contract"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "shrink-0 text-slate-400 transition-colors group-hover:text-green-600",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineArrowDownTray), {
                                                        className: "h-[18px] w-[18px]"
                                                    })
                                                })
                                            ]
                                        }),
                                        hasReceipts && transactions.map(({ payment_id: paymentId, receipt: { url = '' } = {} }, idx, arr)=>{
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: url,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                "data-testid": 'receipt-download-' + idx,
                                                className: documentTileClasses,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] bg-green-100 text-green-600",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineDocumentText), {
                                                            className: "h-5 w-5"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "flex-1 text-sm font-semibold text-slate-900",
                                                        children: [
                                                            "Down Payment Receipt ",
                                                            arr.length > 1 ? idx + 1 : ''
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "shrink-0 text-slate-400 transition-colors group-hover:text-green-600",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineArrowDownTray), {
                                                            className: "h-[18px] w-[18px]"
                                                        })
                                                    })
                                                ]
                                            }, paymentId);
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                next_action === 'PENDING_DOWN_PAYMENT' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    "data-testid": "correction-required-message",
                    className: "rounded-xl border border-amber-300 bg-amber-50 px-5 py-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-2.5 flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hi2.HiOutlineClock), {
                                        className: "h-[18px] w-[18px]"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-xs font-bold uppercase tracking-wider text-amber-700",
                                    children: "correction required"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-wrap items-center justify-between gap-4 text-[0.95rem] leading-snug text-amber-900",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "flex-1 [flex-basis:280px]",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                        i18nKey: "financing.downPayment.outstandingMessage",
                                        values: {
                                            amount: (0, _numberFormat.formatCurrency)(financing_down_payment, {
                                                withDecimals: false
                                            })
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "min-w-[160px] shrink-0",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.PrimaryButton), {
                                        "data-testid": "btn-verify",
                                        block: true,
                                        onClick: onCollectPayment,
                                        disabled: isCollectPaymentLoading,
                                        children: [
                                            isCollectPaymentLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                type: "spinner",
                                                className: "mr-4"
                                            }),
                                            "Collect Payment"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = FinancingSuccess;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"canvas-confetti":"gv1mE","react-icons/hi2":"krCLn","Core/hooks/platform/useGetTransactionHistory":"3gwu1","Core/components/Page":"4xeqH","../hooks/useGetNextStep":"4nfRQ","Core/components/Button":"6YNzH","Core/utils/utils":"hwOBZ","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Modules/patientfi/routes":"lyzU7","Core/components/Icon/Icon":"cAPHo","Core/utils/numberFormat":"6T56F","../hooks/useGetContract":"kU6Kh","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kU6Kh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetContract);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function useGetContract() {
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    return (0, _reactQuery.useMutation)(()=>(0, _platformApi.get)(`/download/contract`, {
            headers: {
                external_reference_id: paymentInfo?.external_reference_id,
                'Content-Type': 'application/pdf'
            },
            responseType: 'arraybuffer'
        }), {
        throwOnError: true,
        retry: 3,
        enabled: Boolean(paymentInfo?.external_reference_id)
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gX6j5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingApproved);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
// import { PrimaryButton } from 'Core/components/Button';
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _column = require("Core/components/Layout/Column");
var _columnDefault = parcelHelpers.interopDefault(_column);
function FinancingApproved() {
    document.title = 'Payment Portal - Application Approved';
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
            className: "justify-center text-center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
                    className: "justify-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "font-regular",
                        "data-testid": "title-finance-approved",
                        children: t('common.newApplication')
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
                    className: "justify-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _columnDefault.default), {
                            className: "text-center p-7 font-extralight text-2xl",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "mr-4",
                                    children: "\u2705"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    "data-testid": "message-finance-approved",
                                    children: t('financing.applicationApproved')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "md:!flex-col-4 text-center text-gray-400",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: t('common.closeWindow')
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react":"2o0ib","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Layout/Row":"8YqFQ","Core/components/Layout/Column":"hnQnj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dgo0G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReturnTracking);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _paperworkSvg = require("url:Images/illustrations/paperwork.svg");
var _paperworkSvgDefault = parcelHelpers.interopDefault(_paperworkSvg);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _fa = require("react-icons/fa");
function ReturnTracking({ nextAction }) {
    document.title = 'Payment Portal - Financing';
    const { t } = (0, _reactI18Next.useTranslation)();
    (0, _useScrollTop.useScrollTop)();
    const [steps, setSteps] = (0, _reactDefault.default).useState([
        {
            id: 'RETURN_REQUESTED',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_PROCESSING',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_APPROVED',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_COMPLETE',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_CANCELED',
            isHidden: true,
            isActive: false,
            isComplete: false
        }
    ]);
    const [activeStep, setActiveStep] = (0, _reactDefault.default).useState({});
    (0, _reactDefault.default).useEffect(()=>{
        setSteps((currentSteps)=>{
            const tempSteps = [
                ...currentSteps
            ];
            const activeStepIndex = tempSteps.findIndex((step)=>step.id === nextAction);
            tempSteps.forEach((step, idx)=>{
                if (step.id === 'RETURN_COMPLETE' || step.id === 'RETURN_APPROVED') step.isHidden = nextAction === 'RETURN_CANCELED';
                if (step.id === 'RETURN_CANCELED') step.isHidden = nextAction !== 'RETURN_CANCELED';
                if (idx === activeStepIndex) {
                    step.isActive = true;
                    step.isHidden = false;
                    step.isComplete = false;
                } else if (idx < activeStepIndex) {
                    step.isActive = false;
                    step.isComplete = true;
                } else {
                    step.isActive = false;
                    step.isComplete = false;
                }
            });
            return tempSteps;
        });
    }, [
        nextAction,
        setActiveStep
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setActiveStep(steps.find((step)=>step.isActive));
    }, [
        steps
    ]);
    function StepIcon({ id, isActive, isComplete }) {
        if (isComplete) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaCheck), {
            color: "white"
        });
        else if (isActive) {
            if (id === 'RETURN_CANCELED') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaExclamation), {
                color: "white"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaCheck), {
                color: "white"
            });
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: "Financing",
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
            className: "justify-center mt-8",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "p-8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        "data-testid": "step-progress-container",
                        className: "flex flex-nowrap justify-between mb-4 p-0",
                        children: steps.filter((s)=>!s.isHidden).map(({ id, isActive, isComplete })=>{
                            const testid = isActive ? `step-progress-active` : `step-progress`;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _classnamesDefault.default)("flex flex-col items-center justify-center relative w-full text-sm whitespace-nowrap before:content-[''] before:border-t-2 before:border-gray-300 before:absolute before:[right:calc(50%_+_15px)] before:[top:15px] before:[width:calc(100%_-_30px)] first-of-type:before:border-0 before:border-solid"),
                                "data-testid": `return-step-${id}`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _classnamesDefault.default)('border-2 border-solid border-gray-300 rounded-full flex justify-center items-center font-bold [height:30px] [width:30px] [line-height:26px]', {
                                            'bg-green-700 text-white': id !== 'RETURN_CANCELED' && isActive,
                                            'bg-gray-200': !isActive && !isComplete,
                                            'bg-green-400': isComplete,
                                            'bg-red-500': id === 'RETURN_CANCELED'
                                        }),
                                        "data-testid": testid,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepIcon, {
                                            id: id,
                                            isActive: isActive,
                                            isComplete: isComplete
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        "data-testid": "step-label",
                                        className: (0, _classnamesDefault.default)('hidden sm:flex mt-4 text-sm md:text-lg', {
                                            'font-semibold': isActive,
                                            ' font-extralight': !isActive
                                        }),
                                        children: t(`page.financing.${id}.title`)
                                    })
                                ]
                            }, id);
                        })
                    }),
                    activeStep && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col items-center w-100",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "mt-6",
                                alt: "application-declined",
                                width: "150em",
                                src: (0, _paperworkSvgDefault.default)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "mt-8 text-2xl",
                                children: t(`page.financing.${nextAction}.title`)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mt-4 text-regular text-gray-500",
                                children: t(`page.financing.${nextAction}.description`)
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"9x2lT","classnames":"f971Y","react":"2o0ib","url:Images/illustrations/paperwork.svg":"9Iyib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","react-icons/fa":"9Vrsi","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3MuqE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingStatusMessage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _column = require("Core/components/Layout/Column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _paperworkSvg = require("url:Images/illustrations/paperwork.svg");
var _paperworkSvgDefault = parcelHelpers.interopDefault(_paperworkSvg);
function FinancingStatusMessage({ nextAction, message = '' }) {
    document.title = 'Payment Portal - Financing';
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const text_pageHeader = 'Financing';
    const text_title = t(`page.financing.${nextAction}.title`);
    const text_description = t([
        `patientfi.page.financing.${nextAction}.description`,
        `page.financing.${nextAction}.description`
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: text_pageHeader,
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
            className: "justify-center mt-8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
                    className: "justify-center items-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "font-regular",
                        "data-testid": "title-finance-approved",
                        children: text_title
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
                    className: "justify-center items-center my-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "!flex-col-2 flex justify-end",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "relative top-2",
                                alt: "application-declined",
                                width: "150em",
                                src: (0, _paperworkSvgDefault.default)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "!flex-col-8 !mb-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-0 w-full whitespace-pre-line text-xl leading-loose",
                                children: message ? message : text_description
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react":"2o0ib","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Layout/Row":"8YqFQ","Core/components/Layout/Column":"hnQnj","url:Images/illustrations/paperwork.svg":"9Iyib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lpG8X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingDeclined);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _column = require("Core/components/Layout/Column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _warningSvg = require("url:Images/illustrations/warning.svg");
var _warningSvgDefault = parcelHelpers.interopDefault(_warningSvg);
var _routes = require("Modules/patientfi/routes");
var _infoBox = require("Core/components/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _errorCodes = require("Modules/patientfi/utils/errorCodes");
var _button = require("Core/components/Button");
var _reactLocation = require("react-location");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function FinancingDeclined({ allowCreateApplication = false, application = {} }) {
    document.title = 'Payment Portal - Application Declined';
    const { t } = (0, _reactI18Next.useTranslation)();
    (0, _useScrollTop.useScrollTop)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { customer_id = '', payload: { relationship = '', correction_required: { message = '' } = {} } = {} } = application;
    const handleCreateApplication = ()=>{
        const relationshipObj = JSON.stringify({
            relationship,
            customer_id
        });
        sessionStorage.setItem('relationship', relationshipObj);
        navigate({
            to: (0, _routes.createSecondaryFinancingPath),
            search: true
        });
    };
    const descriptionLabel = allowCreateApplication ? 'financing.nextgen.declined.introWithNewApp' : 'financing.nextgen.declined.intro';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
            className: "justify-center !p-4 !pb-4 mt-8 mx-48",
            cardPadding: "sm",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "!flex-col-3"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "font-light text-amber-600 flex gap-2 items-center ml-4",
                            "data-testid": "title-finance-declined",
                            children: t('common.nextgen.financingDeclined.title')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                        className: "mb-0"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
                    className: "items-start justify-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "!flex-col-3 flex justify-center mt-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                alt: "application-declined",
                                width: "200em",
                                src: (0, _warningSvgDefault.default)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _columnDefault.default), {
                            className: "!flex-col-9 !mb-0",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _classnamesDefault.default)('mb-0 w-full whitespace-pre-line text-lg leading-loose font-light mt-4'),
                                    children: t(descriptionLabel)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _infoBoxDefault.default), {
                                        type: "warningLite",
                                        showBorder: true,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-bold mr-2 text-yellow-700 mb-0 inline-block",
                                                children: "Reason:"
                                            }),
                                            ' ',
                                            (0, _errorCodes.stripErrorCodes)(message)
                                        ]
                                    })
                                }),
                                allowCreateApplication && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                    "data-testid": "btn-create-secondary-application",
                                    className: "mt-6 px-12",
                                    onClick: handleCreateApplication,
                                    children: t('common.reapply')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "!flex-col-3"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "!flex-col-3"
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Layout/Row":"8YqFQ","Core/components/Layout/Column":"hnQnj","url:Images/illustrations/warning.svg":"cx7tC","Modules/patientfi/routes":"lyzU7","Core/components/InfoBox":"4Lj47","Modules/patientfi/utils/errorCodes":"4X0ST","Core/components/Button":"6YNzH","react-location":"8hNco","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cx7tC":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("CDRKO");

},{}],"4X0ST":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractErrorCodes", ()=>extractErrorCodes);
parcelHelpers.export(exports, "stripErrorCodes", ()=>stripErrorCodes);
const ERROR_CODE_PATTERN = /\{([^}]+)\}\s*/g;
const extractErrorCodes = (message = '')=>[
        ...message.matchAll(ERROR_CODE_PATTERN)
    ].map((match)=>match[1]);
const stripErrorCodes = (message = '')=>message.replace(ERROR_CODE_PATTERN, '').trim();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"13akA":[function(require,module,exports,__globalThis) {
// import { useTranslation } from 'react-i18next';
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingExceptions);
var _jsxRuntime = require("react/jsx-runtime");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _financingStatusMessage = require("Modules/patientfi/components/FinancingStatusMessage");
var _financingStatusMessageDefault = parcelHelpers.interopDefault(_financingStatusMessage);
var _useGetErrorConfig = require("Modules/patientfi/hooks/useGetErrorConfig");
var _createApplication = require("Modules/patientfi/routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _financingRequalify = require("Modules/patientfi/routes/FinancingRequalify");
var _financingRequalifyDefault = parcelHelpers.interopDefault(_financingRequalify);
var _financingDeclined = require("Modules/patientfi/routes/FinancingDeclined");
var _financingDeclinedDefault = parcelHelpers.interopDefault(_financingDeclined);
var _financingVerificationRequired = require("Modules/patientfi/routes/FinancingVerificationRequired");
var _financingVerificationRequiredDefault = parcelHelpers.interopDefault(_financingVerificationRequired);
var _financingSupportRequired = require("Modules/patientfi/routes/FinancingSupportRequired");
var _financingSupportRequiredDefault = parcelHelpers.interopDefault(_financingSupportRequired);
var _appStatusMap = require("Modules/patientfi/config/appStatusMap");
const isFrozenCreditCase = (application, nextAction)=>{
    const correctionRequired = application?.payload?.correction_required;
    return nextAction === 'CORRECTION_REQUIRED' && correctionRequired?.message?.includes('{FROZEN_CREDIT}');
};
const isReviewDeclinedCase = (application, nextAction)=>{
    const correctionRequired = application?.payload?.correction_required;
    return nextAction === 'DECISION_PENDING' && correctionRequired?.status === 'REVIEW' && correctionRequired?.message === 'Invalid request for application-requalify: Application status must be incomplete';
};
const isIdVerificationFailedCase = (application, nextAction)=>{
    const correctionRequired = application?.payload?.correction_required;
    return nextAction === 'DECLINED' && correctionRequired?.status === 'REJECTED' && correctionRequired?.message === 'truvalidateIDVFailed';
};
const isAccountDetailsMismatchCase = (application)=>application?.payload?.correction_required?.status === (0, _appStatusMap.ACCOUNT_DETAILS_MISMATCH);
const isSupportRequiredCase = (application)=>Boolean(application?.payload?.existing_account?.available_actions?.includes('REFRESH'));
function FinancingExceptions({ customer_id, application, nextAction }) {
    document.title = 'Payment Portal - Financing';
    (0, _useScrollTop.useScrollTop)();
    const purpose = nextAction === 'DECISION_PENDING' || isAccountDetailsMismatchCase(application) ? 'create' : 'update';
    const errorConfig = (0, _useGetErrorConfig.useGetErrorConfig)(application);
    if (isSupportRequiredCase(application)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSupportRequiredDefault.default), {
        customer_id: customer_id,
        application: application
    });
    // Check for frozen credit case - redirect to requalify flow
    if (isFrozenCreditCase(application, nextAction)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingRequalifyDefault.default), {});
    // Check for review/declined case - show declined page without reapply option
    if (isReviewDeclinedCase(application, nextAction)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {
        allowCreateApplication: false,
        application: application
    });
    // Check for ID verification failed case - show verification required flow
    if (isIdVerificationFailedCase(application, nextAction)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingVerificationRequiredDefault.default), {});
    // For DECLINED cases that don't match specific exceptions, show declined page
    if (nextAction === 'DECLINED') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {
        application: application
    });
    if (errorConfig?.message) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
        type: "primary",
        customer_id: customer_id,
        purpose: purpose,
        errorConfig: errorConfig
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingStatusMessageDefault.default), {
        nextAction: nextAction,
        message: errorConfig.message
    });
}

},{"react/jsx-runtime":"9x2lT","Core/hooks/useScrollTop":"cBwQW","react":"2o0ib","Modules/patientfi/components/FinancingStatusMessage":"3MuqE","Modules/patientfi/hooks/useGetErrorConfig":"94d2v","Modules/patientfi/routes/CreateApplication":"jL3P4","Modules/patientfi/routes/FinancingRequalify":"icLoD","Modules/patientfi/routes/FinancingDeclined":"lpG8X","Modules/patientfi/routes/FinancingVerificationRequired":"a2JKn","Modules/patientfi/routes/FinancingSupportRequired":"9WRYE","Modules/patientfi/config/appStatusMap":"8kpDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"94d2v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetErrorConfig", ()=>useGetErrorConfig);
var _react = require("react");
var _appStatusMap = require("Modules/patientfi/config/appStatusMap");
var _errorCodes = require("Modules/patientfi/utils/errorCodes");
const useGetErrorConfig = (application)=>{
    return (0, _react.useMemo)(()=>{
        if (!application || !application.payload || !application.payload.correction_required) return {
            type: 'GENERIC',
            status: '',
            message: '',
            errorCode: null,
            affectedFields: [],
            requiresFullSsn: false
        };
        const { status = '', message = '' } = application.payload.correction_required;
        // Extract error codes from message if they exist in curly braces
        const errorCodes = (0, _errorCodes.extractErrorCodes)(message);
        const errorCode = errorCodes[0] || null;
        // Clean the message by removing every error code part
        const cleanMessage = errorCode ? (0, _errorCodes.stripErrorCodes)(message) : message;
        const error = (0, _appStatusMap.ERROR_MAPPING).find((e)=>e.status === status && e.message === cleanMessage);
        const codeFields = status === (0, _appStatusMap.ACCOUNT_DETAILS_MISMATCH) ? [
            ...new Set(errorCodes.flatMap((code)=>(0, _appStatusMap.ERROR_CODE_FIELDS)[code] || []))
        ] : [];
        const errorType = error?.errorType || (codeFields.length ? status : 'GENERIC');
        return {
            type: errorType,
            status,
            message: cleanMessage ? cleanMessage : message,
            errorCode,
            affectedFields: error?.affectedFields || codeFields,
            requiresFullSsn: status === 'INCOMPLETE' && (errorCodes.includes('SSN_MISMATCH') || Boolean(application.payload.existing_account))
        };
    }, [
        application
    ]);
};

},{"react":"2o0ib","Modules/patientfi/config/appStatusMap":"8kpDQ","Modules/patientfi/utils/errorCodes":"4X0ST","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8kpDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCOUNT_DETAILS_MISMATCH", ()=>ACCOUNT_DETAILS_MISMATCH);
parcelHelpers.export(exports, "ERROR_MAPPING", ()=>ERROR_MAPPING);
parcelHelpers.export(exports, "ERROR_CODE_FIELDS", ()=>ERROR_CODE_FIELDS);
parcelHelpers.export(exports, "ERROR_TYPES", ()=>ERROR_TYPES);
const ERROR_MAPPING = [
    {
        status: 'INCOMPLETE',
        message: 'Please verify and update your date of birth',
        errorType: 'INVALID_DATE_OF_BIRTH',
        affectedFields: [
            'dateOfBirth'
        ]
    },
    {
        status: 'REVIEW',
        message: 'Invalid request for application-qualify: Phone number is already in use',
        errorType: 'PHONE_NUMBER_ALREADY_IN_USE',
        affectedFields: [
            'phone'
        ]
    },
    {
        status: 'REVIEW',
        message: 'Invalid request for application-qualify: SSN already in use',
        errorType: 'SSN_ALREADY_IN_USE',
        affectedFields: [
            'socialSecurityNumber'
        ]
    },
    {
        status: 'REVIEW',
        message: 'Invalid request for application-qualify: Invalid field: ValidationError: Only phone numbers with 10 digits are accepted. [Code: 2028]',
        errorType: 'PHONE_NUMBER_INVALID',
        affectedFields: [
            'phone'
        ]
    },
    {
        status: 'REVIEW',
        message: 'Invalid request for application-qualify: Email is already in use and phone number is already in use',
        errorType: 'PHONE_NUMBER_INVALID',
        affectedFields: [
            'phone',
            'email'
        ]
    }
];
const ACCOUNT_DETAILS_MISMATCH = 'ACCOUNT_DETAILS_MISMATCH';
const ERROR_CODE_FIELDS = {
    FIRST_NAME_MISMATCH: [
        'firstName'
    ],
    LAST_NAME_MISMATCH: [
        'lastName'
    ],
    DATE_OF_BIRTH_MISMATCH: [
        'dateOfBirth'
    ]
};
const ERROR_TYPES = {
    PHONE_NUMBER_ALREADY_IN_USE: 'PHONE_NUMBER_ALREADY_IN_USE',
    SSN_ALREADY_IN_USE: 'SSN_ALREADY_IN_USE'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"icLoD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingRequalify);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _reactQuery = require("react-query");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _button = require("Core/components/Button");
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _alert = require("Core/components/Alert");
var _portal = require("Core/components/Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _fa = require("react-icons/fa");
var _reactLocation = require("react-location");
var _phoneCard = require("Modules/patientfi/components/PhoneCard");
var _phoneCardDefault = parcelHelpers.interopDefault(_phoneCard);
var _useRequalifyApplication = require("Modules/patientfi/hooks/useRequalifyApplication");
var _useRequalifyApplicationDefault = parcelHelpers.interopDefault(_useRequalifyApplication);
var _useRequalifyForm = require("Modules/patientfi/hooks/useRequalifyForm");
var _useRequalifyFormDefault = parcelHelpers.interopDefault(_useRequalifyForm);
var _useGetApplication = require("Modules/patientfi/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _routes = require("Modules/patientfi/routes");
var _constants = require("Modules/patientfi/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
const ConfirmationModal = ({ isOpen, onConfirm, onCancel, t })=>{
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "z-50 inset-0 fixed items-center justify-center flex bg-black/50 backdrop-blur-sm",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "bg-white rounded-lg shadow-2xl max-w-3xl w-full mx-4 overflow-hidden animate-in fade-in zoom-in duration-200",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaExclamationTriangle), {
                                        className: "text-white text-2xl"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "text-xl font-bold text-white",
                                    children: t('patientfi.requalify.modal.title')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "p-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-md mb-6",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-amber-800 font-medium",
                                    children: t('patientfi.requalify.modal.warningMessage')
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-gray-600 text-sm mb-6",
                                children: t('patientfi.requalify.modal.confirmQuestion')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col-reverse sm:flex-row gap-3 sm:justify-end",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SecondaryOutlineButton), {
                                        onClick: onCancel,
                                        className: "!px-6",
                                        "data-testid": "modal-cancel",
                                        children: t('patientfi.requalify.modal.cancelButton')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                        onClick: onConfirm,
                                        className: "!px-6",
                                        "data-testid": "modal-confirm",
                                        children: t('patientfi.requalify.modal.confirmButton')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
function FinancingRequalify() {
    const { t } = (0, _reactI18Next.useTranslation)();
    document.title = t('patientfi.requalify.pageTitle');
    const navigate = (0, _reactLocation.useNavigate)();
    const scroll = (0, _useScrollTop.useScrollTop)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const [showSsn, setShowSsn] = (0, _reactDefault.default).useState(false);
    const [submitError, setSubmitError] = (0, _reactDefault.default).useState(null);
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const [requalifyPolling, setRequalifyPolling] = (0, _reactDefault.default).useState(false);
    const [isPollingLoading, setIsPollingLoading] = (0, _reactDefault.default).useState(false);
    const [showConfirmModal, setShowConfirmModal] = (0, _reactDefault.default).useState(false);
    const [pendingFormData, setPendingFormData] = (0, _reactDefault.default).useState(null);
    const { register, handleSubmit, setValue, watch, formState: { errors, isValid } } = (0, _useRequalifyFormDefault.default)();
    const { mutateAsync: requalifyApplication, isLoading: isRequalifyLoading } = (0, _useRequalifyApplicationDefault.default)();
    const { isSuccess: isGetAppSuccess, isLoading: isGetAppLoading, data: getAppData } = (0, _useGetApplicationDefault.default)(requestId, requalifyPolling ? 3000 : false);
    const ssn = watch('socialSecurityNumber');
    (0, _reactDefault.default).useEffect(()=>{
        setValue('socialSecurityNumber', ssn?.replace(/\D+/g, ''), {
            shouldValidate: true
        });
    }, [
        setValue,
        ssn
    ]);
    // Handle polling response
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetAppSuccess && requalifyPolling && getAppData?.next_action) {
            // Store app data in session storage
            sessionStorage.setItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY, JSON.stringify(getAppData));
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
            // Stop polling and reset
            setRequestId('');
            setRequalifyPolling(false);
            setIsPollingLoading(false);
            // Navigate to financing redirect to handle the next action
            navigate({
                to: (0, _routes.createFinancingPath),
                search: true,
                replace: true
            });
        }
    }, [
        isGetAppSuccess,
        getAppData,
        requalifyPolling,
        navigate,
        queryClient
    ]);
    // Update loading state when polling starts
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetAppLoading) setIsPollingLoading(true);
    }, [
        isGetAppLoading
    ]);
    // Cleanup on unmount
    (0, _reactDefault.default).useEffect(()=>{
        return ()=>{
            setRequestId('');
            queryClient.removeQueries((0, _cacheKeysDefault.default).patientfiGetApplication);
        };
    }, [
        queryClient
    ]);
    const toggleSsnDisplay = ()=>{
        setShowSsn(!showSsn);
    };
    const handleFormSubmit = (formData)=>{
        // Store form data and show confirmation modal
        setPendingFormData(formData);
        setShowConfirmModal(true);
    };
    const handleConfirmRequalify = async ()=>{
        setShowConfirmModal(false);
        if (!pendingFormData) return;
        setSubmitError(null);
        setRequestId(''); // Clear old requestId first
        scroll.top();
        try {
            setRequalifyPolling(true);
            const { headers: { request_id } } = await requalifyApplication({
                customer_identity_number: pendingFormData.socialSecurityNumber
            });
            setRequestId(request_id);
        } catch (error) {
            setRequalifyPolling(false);
            setSubmitError(error?.response?.data?.message || t('status.error.requalifyFailed'));
        }
        setPendingFormData(null);
    };
    const handleCancelConfirm = ()=>{
        setShowConfirmModal(false);
        setPendingFormData(null);
    };
    const isLoading = isRequalifyLoading || isPollingLoading;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: [
            isRequalifyLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('status.loading.requalifyApplication')
            }),
            isPollingLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('status.loading.financingApplication')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfirmationModal, {
                isOpen: showConfirmModal,
                onConfirm: handleConfirmRequalify,
                onCancel: handleCancelConfirm,
                t: t
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "max-w-4xl mx-auto mt-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                    className: "!p-0 overflow-hidden",
                    cardPadding: "none",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-5",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaSnowflake), {
                                            className: "text-white text-xl"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                className: "text-xl font-semibold text-white",
                                                "data-testid": "title-credit-freeze",
                                                children: t('patientfi.requalify.title')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-amber-100 text-sm",
                                                children: t('patientfi.requalify.subtitle')
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "p-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    children: t('patientfi.requalify.description')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "space-y-3 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2 mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium text-gray-700",
                                                    children: t('patientfi.requalify.step1Instruction')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _phoneCardDefault.default), {
                                            title: t('patientfi.requalify.transUnionTitle'),
                                            phone: t('patientfi.requalify.phoneNumbers.transUnion'),
                                            description: t('patientfi.requalify.transUnionDescription')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "space-y-3 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2 mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                                    children: "2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium text-gray-700",
                                                    children: t('patientfi.requalify.step2newInstruction')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "p-4 bg-slate-50 border border-slate-200 rounded-lg",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex-shrink-0 w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaUserCheck), {
                                                            className: "text-blue-600 text-lg"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "font-medium text-gray-900",
                                                                children: t('patientfi.requalify.confirmFreezeLifted')
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "text-sm text-gray-500 mt-0.5",
                                                                children: t('patientfi.requalify.confirmFreezeLiftedDescription')
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                    className: "my-6"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                            children: "3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-medium text-gray-700",
                                            children: t('patientfi.requalify.step3Instruction')
                                        })
                                    ]
                                }),
                                submitError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                                    className: "mb-4",
                                    "data-testid": "requalify-error",
                                    children: submitError
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                                    onSubmit: handleSubmit(handleFormSubmit),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "bg-gray-50 rounded-lg p-4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-sm text-gray-600 mb-3",
                                                children: t('patientfi.requalify.ssnInstruction')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "max-w-md col-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                                    register: register,
                                                    name: "socialSecurityNumber",
                                                    errors: errors,
                                                    onAppendClick: toggleSsnDisplay,
                                                    appendText: showSsn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaEyeSlash), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaEye), {}),
                                                    type: showSsn ? 'text' : 'password'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "max-w-md mt-4 col-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                                    type: "submit",
                                                    block: true,
                                                    "data-testid": "btn-requalify",
                                                    disabled: isLoading || !isValid,
                                                    children: t('patientfi.requalify.submitButton')
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react-query":"ksTpv","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Button":"6YNzH","Core/components/FormElements/InputField":"6BJmW","Core/components/Loader":"6S7S4","Core/components/Alert":"fmmNR","Core/components/Portal":"3MZth","react-icons/fa":"9Vrsi","react-location":"8hNco","Modules/patientfi/components/PhoneCard":"jobco","Modules/patientfi/hooks/useRequalifyApplication":"42hvM","Modules/patientfi/hooks/useRequalifyForm":"hf1yp","Modules/patientfi/hooks/useGetApplication":"ijipp","Modules/patientfi/routes":"lyzU7","Modules/patientfi/config/constants":"i3i7l","Core/hooks/queries/cacheKeys":"i5IL7","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jobco":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fa = require("react-icons/fa");
const PhoneCard = ({ title, phone, description, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: `tel:${phone}`,
        className: "block p-4 bg-slate-50 border border-slate-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 hover:shadow-md transition-all duration-200 group",
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-shrink-0 w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center group-hover:bg-blue-100 transition-colors",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaPhoneAlt), {
                        className: "text-blue-600"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-medium text-gray-900",
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-blue-600 font-semibold",
                            children: phone
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-gray-500 mt-0.5",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
exports.default = PhoneCard;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-icons/fa":"9Vrsi","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"42hvM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRequalifyApplication);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _reactI18Next = require("react-i18next");
var _logger = require("Core/utils/logger");
var _utils = require("Core/utils/utils");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function transformPayload({ customer_id, customer_identity_number, external_reference_id, purpose, provider, payment_option }) {
    return {
        payment_id: (0, _utils.getUrlParam)('payment-id'),
        external_reference_id,
        purpose,
        payment_option,
        provider,
        payload: {
            customer_id,
            customer_identity_number
        }
    };
}
function useRequalifyApplication() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>{
        return (0, _platformApi.postWithHeaders)(`/financing/application-requalify`, transformPayload({
            ...payload,
            customer_id: paymentInfo.customer_id,
            external_reference_id: paymentInfo.external_reference_id,
            purpose: paymentInfo.purpose,
            provider: paymentInfo.provider,
            payment_option: paymentInfo.payment_option
        }));
    }, {
        throwOnError: true,
        retry: 2,
        enabled: Boolean(paymentInfo),
        onSuccess (data) {
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).requalifyApp,
                status: 'success'
            });
            clearAlert();
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
            return data;
        },
        onError (error) {
            setErrorAlert(t('status.error.requalifyApplicationRequestFailed') + `(${error?.response?.data?.message})`);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","react-i18next":"244ua","Core/utils/logger":"cWDKQ","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hf1yp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSocialSecurityNumberRegex", ()=>getSocialSecurityNumberRegex);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _reactHookForm = require("react-hook-form");
const getSocialSecurityNumberRegex = ()=>/^\d{9}$/;
const useRequalifyForm = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            socialSecurityNumber: _v3.string().min(1, {
                message: t('common.requiredFieldSSN')
            }).refine((val)=>{
                const regex = getSocialSecurityNumberRegex();
                return regex.test(val);
            }, {
                message: t('patientfi.formlabel.invalidFormatSSN')
            })
        });
    }, [
        t
    ]);
    const form = (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        mode: 'onChange',
        defaultValues: {
            socialSecurityNumber: ''
        }
    });
    return form;
};
exports.default = useRequalifyForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","react-hook-form":"53GLT","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"a2JKn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingVerificationRequired);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _fa = require("react-icons/fa");
const PhoneCard = ({ title, phone, description })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: `tel:${phone}`,
        className: "block p-4 bg-slate-50 border border-slate-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 hover:shadow-md transition-all duration-200 group",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-shrink-0 w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center group-hover:bg-blue-100 transition-colors",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaPhoneAlt), {
                        className: "text-blue-600"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-medium text-gray-900",
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-blue-600 font-semibold",
                            children: phone
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-gray-500 mt-0.5",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
const InfoCard = ({ icon: Icon, title, description, iconBgColor = 'bg-amber-50', iconColor = 'text-amber-600' })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "block p-4 bg-slate-50 border border-slate-200 rounded-lg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `flex-shrink-0 w-10 h-10 ${iconBgColor} rounded-full flex items-center justify-center`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                        className: iconColor
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-medium text-gray-900",
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-gray-500 mt-0.5",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
function FinancingVerificationRequired() {
    const { t } = (0, _reactI18Next.useTranslation)();
    document.title = t('patientfi.verificationRequired.pageTitle');
    (0, _useScrollTop.useScrollTop)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "max-w-4xl mx-auto mt-6",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                className: "!p-0 overflow-hidden",
                cardPadding: "none",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-5",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaExclamationTriangle), {
                                        className: "text-white text-xl"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "text-xl font-semibold text-white",
                                            "data-testid": "title-verification-required",
                                            children: t('patientfi.verificationRequired.title')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-amber-100 text-sm",
                                            children: t('patientfi.verificationRequired.subtitle')
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "p-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-gray-600 mb-6",
                                children: t('patientfi.verificationRequired.description')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-3 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                                children: "1"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-medium text-gray-700",
                                                children: t('patientfi.verificationRequired.step1Instruction')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PhoneCard, {
                                        title: t('patientfi.requalify.patientFiTitle'),
                                        phone: t('patientfi.requalify.phoneNumbers.patientFi'),
                                        description: t('patientfi.verificationRequired.patientFiDescription')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-3 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                                children: "2"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-medium text-gray-700",
                                                children: t('patientfi.verificationRequired.step2Instruction')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InfoCard, {
                                        icon: (0, _fa.FaBan),
                                        title: t('patientfi.verificationRequired.disableTransactionTitle'),
                                        description: t('patientfi.verificationRequired.disableTransactionDescription'),
                                        iconBgColor: "bg-red-50",
                                        iconColor: "text-red-600"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                                children: "3"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-medium text-gray-700",
                                                children: t('patientfi.verificationRequired.step3Instruction')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InfoCard, {
                                        icon: (0, _fa.FaRedo),
                                        title: t('patientfi.verificationRequired.newApplicationTitle'),
                                        description: t('patientfi.verificationRequired.newApplicationDescription'),
                                        iconBgColor: "bg-green-50",
                                        iconColor: "text-green-600"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","react-icons/fa":"9Vrsi","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9WRYE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingSupportRequired);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _fa = require("react-icons/fa");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _button = require("Core/components/Button");
var _createApplication = require("Modules/patientfi/routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _phoneCard = require("Modules/patientfi/components/PhoneCard");
var _phoneCardDefault = parcelHelpers.interopDefault(_phoneCard);
var _errorCodes = require("Modules/patientfi/utils/errorCodes");
const ACCOUNT_STATUS_LABELS = {
    REVIEW: [
        'patientfi.supportRequired.accountStatus.review',
        'Under review'
    ],
    SUSPENDED: [
        'patientfi.supportRequired.accountStatus.suspended',
        'Suspended'
    ],
    ON_HOLD: [
        'patientfi.supportRequired.accountStatus.onHold',
        'On hold'
    ],
    EXPIRED: [
        'patientfi.supportRequired.accountStatus.expired',
        'Expired'
    ],
    INCOMPLETE: [
        'patientfi.supportRequired.accountStatus.incomplete',
        'Incomplete'
    ]
};
const REASON_DESCRIPTIONS = {
    ACCOUNT_SUSPENDED: [
        'patientfi.supportRequired.reason.accountSuspended',
        'PatientFi has suspended your account, so it cannot be used for this purchase until the suspension is resolved.'
    ],
    ACCOUNT_ON_HOLD: [
        'patientfi.supportRequired.reason.accountOnHold',
        'PatientFi has placed a hold on your account, so it cannot be used for this purchase until the hold is removed.'
    ],
    ACCOUNT_IN_REVIEW: [
        'patientfi.supportRequired.reason.accountInReview',
        'PatientFi is currently reviewing your account, so it cannot be used for this purchase until the review is complete.'
    ],
    ACCOUNT_INCOMPLETE: [
        'patientfi.supportRequired.reason.accountIncomplete',
        'PatientFi needs more information to complete your account before it can be used for this purchase.'
    ],
    ACCOUNT_LINKED_TO_OTHER_CUSTOMER: [
        'patientfi.supportRequired.reason.accountLinkedToOtherCustomer',
        'Your PatientFi account is already linked to another customer record with us, so it cannot be used for this purchase until this is resolved.'
    ],
    ACCOUNT_NEEDS_SUPPORT: [
        'patientfi.supportRequired.reason.accountNeedsSupport',
        'We could not continue with your PatientFi account, so it cannot be used for this purchase until PatientFi support has resolved the issue.'
    ]
};
const StepHeading = ({ number, children })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2 mb-3",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                children: number
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-medium text-gray-700",
                children: children
            })
        ]
    });
const InfoTile = ({ Icon, iconClassName, title, description, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "p-4 bg-slate-50 border border-slate-200 rounded-lg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${iconClassName}`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                        className: "text-lg"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-medium text-gray-900",
                            "data-testid": `${dataTestId}-title`,
                            children: title
                        }),
                        description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-gray-500 mt-0.5",
                            "data-testid": dataTestId,
                            children: description
                        })
                    ]
                })
            ]
        })
    });
function FinancingSupportRequired({ customer_id, application = {} }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    document.title = t('patientfi.supportRequired.pageTitle', 'Payment Portal - Contact PatientFi');
    (0, _useScrollTop.useScrollTop)();
    const [refreshedFrom, setRefreshedFrom] = (0, _reactDefault.default).useState(null);
    const refresh = refreshedFrom === application;
    const { payload: { correction_required: { message = '' } = {}, existing_account: existingAccount } = {} } = application;
    const accountNumber = existingAccount?.account_number;
    const recheckLabel = t('patientfi.supportRequired.recheckEligibilityButton', 'Recheck eligibility');
    const accountStatusLabel = ACCOUNT_STATUS_LABELS[existingAccount?.account_status];
    const reasonDescription = REASON_DESCRIPTIONS[(0, _errorCodes.extractErrorCodes)(message ?? '')[0]];
    if (refresh) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
        type: "primary",
        customer_id: customer_id,
        purpose: "create"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "max-w-4xl mx-auto mt-6",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                className: "!p-0 overflow-hidden",
                cardPadding: "none",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-5",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaHeadset), {
                                        className: "text-white text-xl"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "text-xl font-semibold text-white",
                                    "data-testid": "title-support-required",
                                    children: t('patientfi.supportRequired.title', 'Please contact PatientFi support')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "p-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepHeading, {
                                        number: 1,
                                        children: t('patientfi.supportRequired.step1Instruction', 'Existing PatientFi account was found')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InfoTile, {
                                        Icon: (0, _fa.FaIdCard),
                                        iconClassName: "bg-blue-50 text-blue-600",
                                        title: t('patientfi.supportRequired.existingAccountTitle', 'Account Details'),
                                        description: (accountNumber || accountStatusLabel) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                accountNumber && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "block",
                                                    children: [
                                                        t('patientfi.supportRequired.accountNumber', 'PatientFi account'),
                                                        ": \u2022\u2022\u2022\u2022",
                                                        ' ',
                                                        String(accountNumber).slice(-4)
                                                    ]
                                                }),
                                                accountStatusLabel && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "block",
                                                    "data-testid": "support-required-account-status",
                                                    children: [
                                                        t('patientfi.supportRequired.accountStatusLabel', 'Account status'),
                                                        ":",
                                                        ' ',
                                                        t(...accountStatusLabel)
                                                    ]
                                                })
                                            ]
                                        }),
                                        "data-testid": "support-required-account"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepHeading, {
                                        number: 2,
                                        children: t('patientfi.supportRequired.step2Instruction', 'Your account status')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InfoTile, {
                                        Icon: (0, _fa.FaExclamationTriangle),
                                        iconClassName: "bg-amber-50 text-amber-600",
                                        description: reasonDescription ? t(...reasonDescription) : (0, _errorCodes.stripErrorCodes)(message),
                                        "data-testid": "support-required-reason"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepHeading, {
                                        number: 3,
                                        children: t('patientfi.supportRequired.step3Instruction', 'Call PatientFi support to resolve it')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _phoneCardDefault.default), {
                                        title: t('patientfi.supportRequired.phoneTitle', 'PatientFi support'),
                                        phone: t('patientfi.supportPhoneNumber', '866-734-5979'),
                                        description: t('patientfi.supportRequired.phoneDescription', 'Please have your account details ready when you call.'),
                                        "data-testid": "support-required-phone"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "my-6"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepHeading, {
                                number: 4,
                                children: t('patientfi.supportRequired.step4Instruction', 'Once PatientFi support has resolved it, Click on the {{button}} button to check updated eligibility', {
                                    button: recheckLabel
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                className: "mt-2 px-12",
                                "data-testid": "btn-support-required-refresh",
                                onClick: ()=>setRefreshedFrom(application),
                                children: recheckLabel
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","react-icons/fa":"9Vrsi","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Button":"6YNzH","Modules/patientfi/routes/CreateApplication":"jL3P4","Modules/patientfi/components/PhoneCard":"jobco","Modules/patientfi/utils/errorCodes":"4X0ST","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hY1in":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACTIONS", ()=>ACTIONS);
parcelHelpers.export(exports, "default", ()=>FinancingExistingAccount);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _fa = require("react-icons/fa");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _button = require("Core/components/Button");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _alert = require("Core/components/Alert");
var _infoBox = require("Core/components/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _numberFormat = require("Core/utils/numberFormat");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _useExistingAccountSubmit = require("Modules/patientfi/hooks/useExistingAccountSubmit");
var _useExistingAccountSubmitDefault = parcelHelpers.interopDefault(_useExistingAccountSubmit);
var _accountDate = require("Modules/patientfi/utils/accountDate");
var _errorCodes = require("Modules/patientfi/utils/errorCodes");
const ACTIONS = {
    CONTINUE: 'CONTINUE',
    REQUEST_INCREASE: 'REQUEST_INCREASE',
    REAPPLY: 'REAPPLY'
};
const WARNING = 'WARNING';
const maskAccountNumber = (accountNumber)=>accountNumber ? `\u{2022}\u{2022}\u{2022}\u{2022} ${String(accountNumber).slice(-4)}` : null;
const money = (value)=>typeof value === 'number' ? (0, _numberFormat.formatCurrency)(value) : null;
const DetailRow = ({ label, value, testId })=>!value ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex justify-between py-2 border-b border-slate-100 last:border-b-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-gray-600",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-medium text-gray-900",
                "data-testid": testId,
                children: value
            })
        ]
    });
function getDescription(t, accountStatus, actions, increaseAmount) {
    if (accountStatus === 'DENIED') return t('patientfi.existingAccount.description.reapply', 'Your previous PatientFi application was declined, and you can now reapply. If you reapply and are approved, you can use your PatientFi credit for this purchase.');
    if (actions.includes(ACTIONS.REQUEST_INCREASE) && !actions.includes(ACTIONS.CONTINUE)) return t('patientfi.existingAccount.description.increaseRequired', 'Your available PatientFi credit is below the minimum financing amount. To use PatientFi for this purchase, ask PatientFi to increase your limit to cover the full amount of {{amount}}. Asking for an increase is a soft credit check.', {
        amount: increaseAmount
    });
    if (actions.includes(ACTIONS.REQUEST_INCREASE)) return t('patientfi.existingAccount.description.increaseOptional', 'Your available PatientFi credit does not cover the full purchase. You can continue with your current limit and pay the rest as a down payment, or ask PatientFi to increase your limit to cover the full amount of {{amount}}. Asking for an increase is a soft credit check.', {
        amount: increaseAmount
    });
    return t('patientfi.existingAccount.description.continue', 'You already have an approved PatientFi credit line. You can use it for this purchase without a new application.');
}
function FinancingExistingAccount({ application = {} }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    document.title = t('patientfi.existingAccount.pageTitle', 'Payment Portal - PatientFi Account');
    (0, _useScrollTop.useScrollTop)();
    const { payload: { existing_account: existingAccount = {}, financing_down_payment: financingDownPayment, already_paid_amount: alreadyPaidAmount = 0, correction_required: correctionRequired } = {} } = application;
    const { account_number: accountNumber, account_status: accountStatus, approved_amount: approvedAmount, available_balance: availableBalance, reapply_date: reapplyDate, matched_by: matchedBy, available_actions: actions = [] } = existingAccount || {};
    const { data: { amount_to_pay: amountToPay } = {} } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const { submit, submitError, busy } = (0, _useExistingAccountSubmitDefault.default)();
    const canContinue = actions.includes(ACTIONS.CONTINUE);
    const canIncrease = actions.includes(ACTIONS.REQUEST_INCREASE);
    const isWarning = correctionRequired?.status === WARNING;
    const matchedByLabel = matchedBy === 'EMAIL' ? t('patientfi.existingAccount.matchedBy.email', 'We found this account using your email address.') : t('patientfi.existingAccount.matchedBy.phone', 'We found this account using your phone number.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: [
            busy && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('patientfi.existingAccount.loading', 'Checking your PatientFi account. This can take a moment.')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "max-w-4xl mx-auto mt-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                    className: "!p-0 overflow-hidden",
                    cardPadding: "none",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "bg-gradient-to-r from-sky-600 to-teal-500 px-6 py-5",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaIdCard), {
                                            className: "text-white text-xl"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                className: "text-xl font-semibold text-white",
                                                "data-testid": "title-existing-account",
                                                children: t('patientfi.existingAccount.title', 'We found your PatientFi account')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-sky-100 text-sm",
                                                children: matchedByLabel
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "p-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    "data-testid": "existing-account-description",
                                    children: getDescription(t, accountStatus, actions, typeof amountToPay === 'number' ? money(Math.max(amountToPay - alreadyPaidAmount, 0)) : t('patientfi.existingAccount.thisPurchase', 'this purchase'))
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "bg-slate-50 border border-slate-200 rounded-lg px-4 py-2 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DetailRow, {
                                            label: t('patientfi.existingAccount.accountNumber', 'Account number'),
                                            value: maskAccountNumber(accountNumber),
                                            testId: "existing-account-number"
                                        }),
                                        accountStatus === 'APPROVED' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(DetailRow, {
                                                    label: t('patientfi.existingAccount.approvedAmount', 'Approved credit line'),
                                                    value: money(approvedAmount),
                                                    testId: "existing-account-approved"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(DetailRow, {
                                                    label: t('patientfi.existingAccount.availableBalance', 'Available credit'),
                                                    value: money(availableBalance),
                                                    testId: "existing-account-available"
                                                }),
                                                actions.includes(ACTIONS.CONTINUE) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DetailRow, {
                                                    label: t('patientfi.existingAccount.downPayment', 'Down payment due today'),
                                                    value: money(financingDownPayment),
                                                    testId: "existing-account-down-payment"
                                                })
                                            ]
                                        }),
                                        accountStatus === 'DENIED' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DetailRow, {
                                            label: t('patientfi.existingAccount.reapplyDate', 'Eligible to reapply since'),
                                            value: (0, _accountDate.formatAccountDate)(reapplyDate),
                                            testId: "existing-account-reapply-date"
                                        })
                                    ]
                                }),
                                isWarning && correctionRequired.message && !submitError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mb-4",
                                    "data-testid": "existing-account-warning",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                        type: "warningLite",
                                        showBorder: true,
                                        children: (0, _errorCodes.stripErrorCodes)(correctionRequired.message)
                                    })
                                }),
                                !isWarning && correctionRequired?.message && !submitError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                                    className: "mb-4",
                                    "data-testid": "existing-account-previous-error",
                                    children: t('patientfi.existingAccount.error.previousAttemptFailed', 'We could not finish this step with PatientFi. Please try again.')
                                }),
                                submitError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                                    className: "mb-4",
                                    "data-testid": "existing-account-error",
                                    children: submitError
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                    type: "message",
                                    showBorder: true,
                                    children: t('patientfi.existingAccount.consent', 'By continuing, you agree that we link this PatientFi account to your purchase with us.')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col sm:flex-row gap-3 mt-6",
                                    children: [
                                        canContinue && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                            "data-testid": "btn-existing-account-continue",
                                            disabled: busy,
                                            onClick: ()=>submit(false),
                                            children: canIncrease ? t('patientfi.existingAccount.continueCurrentLimitButton', 'Continue with current limit') : t('patientfi.existingAccount.continueButton', 'Continue with this account')
                                        }),
                                        canIncrease && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                            "data-testid": "btn-existing-account-increase",
                                            disabled: busy,
                                            onClick: ()=>submit(true),
                                            children: t('patientfi.existingAccount.continueIncreasedLimitButton', 'Continue with increased limit')
                                        }),
                                        actions.includes(ACTIONS.REAPPLY) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                            "data-testid": "btn-existing-account-reapply",
                                            disabled: busy,
                                            onClick: ()=>submit(false),
                                            children: t('patientfi.existingAccount.reapplyButton', 'Reapply with this account')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","react-icons/fa":"9Vrsi","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Button":"6YNzH","Core/components/Loader":"6S7S4","Core/components/Alert":"fmmNR","Core/components/InfoBox":"4Lj47","Core/utils/numberFormat":"6T56F","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/patientfi/hooks/useExistingAccountSubmit":"5CCF9","Modules/patientfi/utils/accountDate":"87tdD","Modules/patientfi/utils/errorCodes":"4X0ST","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5CCF9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useExistingAccountSubmit);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactQuery = require("react-query");
var _reactLocation = require("react-location");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _useUpdateExistingAccount = require("Modules/patientfi/hooks/useUpdateExistingAccount");
var _useUpdateExistingAccountDefault = parcelHelpers.interopDefault(_useUpdateExistingAccount);
var _useGetApplication = require("Modules/patientfi/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _routes = require("Modules/patientfi/routes");
var _constants = require("Modules/patientfi/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
function useExistingAccountSubmit() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactLocation.useNavigate)();
    const scroll = (0, _useScrollTop.useScrollTop)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const [polling, setPolling] = (0, _reactDefault.default).useState(false);
    const [submitError, setSubmitError] = (0, _reactDefault.default).useState(null);
    const { mutateAsync: updateExistingAccount, isLoading: isSubmitting } = (0, _useUpdateExistingAccountDefault.default)();
    const { isSuccess, data: polledApp } = (0, _useGetApplicationDefault.default)(requestId, polling ? 3000 : false);
    (0, _reactDefault.default).useEffect(()=>{
        if (isSuccess && polling && polledApp?.next_action) {
            sessionStorage.setItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY, JSON.stringify(polledApp));
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
            setRequestId('');
            setPolling(false);
            navigate({
                to: (0, _routes.createFinancingPath),
                search: true,
                replace: true
            });
        }
    }, [
        isSuccess,
        polledApp,
        polling,
        navigate,
        queryClient
    ]);
    (0, _reactDefault.default).useEffect(()=>()=>{
            queryClient.removeQueries((0, _cacheKeysDefault.default).patientfiGetApplication);
        }, [
        queryClient
    ]);
    const submit = async (requestIncrease)=>{
        setSubmitError(null);
        setRequestId('');
        scroll.top();
        try {
            setPolling(true);
            const { headers: { request_id } } = await updateExistingAccount({
                request_increase: requestIncrease
            });
            setRequestId(request_id);
        } catch (error) {
            setPolling(false);
            setSubmitError(error?.response?.data?.message || t('patientfi.existingAccount.error.requestFailed', 'We could not continue with your PatientFi account. Please try again.'));
        }
    };
    return {
        submit,
        submitError,
        busy: isSubmitting || polling
    };
}

},{"react":"2o0ib","react-i18next":"244ua","react-query":"ksTpv","react-location":"8hNco","Core/hooks/useScrollTop":"cBwQW","Core/hooks/queries/cacheKeys":"i5IL7","Modules/patientfi/hooks/useUpdateExistingAccount":"8IZN3","Modules/patientfi/hooks/useGetApplication":"ijipp","Modules/patientfi/routes":"lyzU7","Modules/patientfi/config/constants":"i3i7l","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8IZN3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdateExistingAccount);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _reactI18Next = require("react-i18next");
var _utils = require("Core/utils/utils");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function transformPayload({ customer_id, external_reference_id, purpose, provider, payment_option, request_increase }) {
    return {
        payment_id: (0, _utils.getUrlParam)('payment-id'),
        external_reference_id,
        purpose,
        payment_option,
        provider,
        payload: {
            customer_id,
            request_increase
        }
    };
}
function useUpdateExistingAccount() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(({ request_increase = false } = {})=>(0, _platformApi.putWithHeaders)(`/financing/application/existing-account`, transformPayload({
            request_increase,
            customer_id: paymentInfo.customer_id,
            external_reference_id: paymentInfo.external_reference_id,
            purpose: paymentInfo.purpose,
            provider: paymentInfo.provider,
            payment_option: paymentInfo.payment_option
        })), {
        throwOnError: true,
        onSuccess (data) {
            clearAlert();
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
            return data;
        },
        onError (error) {
            setErrorAlert(t('patientfi.existingAccount.error.requestFailed', 'We could not continue with your PatientFi account. Please try again.') + (error?.response?.data?.message ? ` (${error.response.data.message})` : ''));
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","react-i18next":"244ua","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"87tdD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toIsoDate", ()=>toIsoDate);
parcelHelpers.export(exports, "isReapplyOpen", ()=>isReapplyOpen);
parcelHelpers.export(exports, "formatAccountDate", ()=>formatAccountDate);
const pad = (value)=>String(value).padStart(2, '0');
const toIsoDate = (value)=>{
    if (Array.isArray(value) && value.length === 3) {
        const [year, month, day] = value;
        return `${year}-${pad(month)}-${pad(day)}`;
    }
    return typeof value === 'string' && value ? value.slice(0, 10) : null;
};
const isReapplyOpen = (reapplyDate, now = new Date())=>{
    const isoDate = toIsoDate(reapplyDate);
    return !isoDate || isoDate <= now.toISOString().slice(0, 10);
};
const formatAccountDate = (value)=>{
    const isoDate = toIsoDate(value);
    return isoDate ? new Intl.DateTimeFormat('en-US', {
        dateStyle: 'long',
        timeZone: 'UTC'
    }).format(new Date(`${isoDate}T00:00:00Z`)) : null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5bAr2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingDenied);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _fa = require("react-icons/fa");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _button = require("Core/components/Button");
var _infoBox = require("Core/components/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _alert = require("Core/components/Alert");
var _useExistingAccountSubmit = require("Modules/patientfi/hooks/useExistingAccountSubmit");
var _useExistingAccountSubmitDefault = parcelHelpers.interopDefault(_useExistingAccountSubmit);
var _accountDate = require("Modules/patientfi/utils/accountDate");
function FinancingDenied({ application = {} }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    document.title = t('patientfi.existingAccount.pageTitle', 'Payment Portal - PatientFi Account');
    (0, _useScrollTop.useScrollTop)();
    const { payload: { existing_account: existingAccount } = {} } = application;
    const { reapply_date: reapplyDate, matched_by: matchedBy } = existingAccount || {};
    const canReapply = (0, _accountDate.isReapplyOpen)(reapplyDate);
    const reapplyDateLabel = (0, _accountDate.formatAccountDate)(reapplyDate);
    const { submit, submitError, busy } = (0, _useExistingAccountSubmitDefault.default)();
    const matchedByLabel = matchedBy === 'EMAIL' ? t('patientfi.existingAccount.matchedBy.email', 'We found this account using your email address.') : t('patientfi.existingAccount.matchedBy.phone', 'We found this account using your phone number.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: [
            busy && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('patientfi.existingAccount.loading', 'Checking your PatientFi account. This can take a moment.')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "max-w-4xl mx-auto mt-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                    className: "!p-0 overflow-hidden",
                    cardPadding: "none",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "bg-gradient-to-r from-sky-600 to-teal-500 px-6 py-5",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaIdCard), {
                                            className: "text-white text-xl"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                className: "text-xl font-semibold text-white",
                                                "data-testid": "title-existing-denied",
                                                children: t('patientfi.existingAccount.title', 'We found your PatientFi account')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-sky-100 text-sm",
                                                children: matchedByLabel
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "p-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    "data-testid": "existing-denied-description",
                                    children: canReapply ? t('patientfi.existingAccount.denied.canReapply', 'Your previous PatientFi application was not approved. The good news is that you are now eligible to reapply. If you are approved, you can use your PatientFi credit for this purchase.') : t('patientfi.existingAccount.denied.waitToReapply', 'Your previous PatientFi application was not approved recently, so a new application is not possible just yet. You can reapply on or after {{date}}. In the meantime, please choose another payment option or contact us if you have any questions.', {
                                        date: reapplyDateLabel
                                    })
                                }),
                                !canReapply && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _infoBoxDefault.default), {
                                    type: "warningLite",
                                    showBorder: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "font-bold mr-2",
                                            children: [
                                                t('patientfi.existingAccount.denied.reapplyOn', 'Eligible to reapply on'),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            "data-testid": "existing-denied-reapply-date",
                                            children: reapplyDateLabel
                                        })
                                    ]
                                }),
                                submitError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                                    className: "mt-4",
                                    "data-testid": "existing-denied-error",
                                    children: submitError
                                }),
                                canReapply && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                    className: "mt-6 px-12",
                                    "data-testid": "btn-existing-denied-reapply",
                                    disabled: busy,
                                    onClick: ()=>submit(false),
                                    children: t('common.reapply')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","react-icons/fa":"9Vrsi","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Button":"6YNzH","Core/components/InfoBox":"4Lj47","Core/components/Loader":"6S7S4","Core/components/Alert":"fmmNR","Modules/patientfi/hooks/useExistingAccountSubmit":"5CCF9","Modules/patientfi/utils/accountDate":"87tdD","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8WSTE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _reactLocation = require("react-location");
var _alert = require("Core/components/Alert");
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _footer = require("Core/components/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _button = require("Core/components/Button");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _routes = require("Modules/patientfi/routes");
var _useGetNextStep = require("Modules/patientfi/hooks/useGetNextStep");
const Financing = ({ nextRoutes })=>{
    (0, _useScrollTop.useScrollTop)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    // const shouldShowSidebar = useShowSidebar();
    const [state, setState] = (0, _reactDefault.default).useState({
        refetchInterval: false,
        financingWindow: null,
        approved: 'done',
        approvedSigned: 'idle',
        funded: 'idle',
        isError: false,
        isModalOpen: false
    });
    const { data: { next_action, payload: { links: { cart: redirection_link } }, isError } } = (0, _useGetNextStep.useGetNextStep)(state.refetchInterval);
    (0, _reactDefault.default).useEffect(()=>{
        if (!next_action) return;
        if (isError) {
            setState({
                refetchInterval: 5000,
                approvedSigned: 'error',
                funded: 'error'
            });
            return;
        } else if (next_action === 'FUND_APPLICATION') setState({
            ...state,
            approvedSigned: 'done'
        });
        else if (next_action === 'DONE') {
            setState({
                ...state,
                approvedSigned: 'done',
                funded: 'done'
            });
            return;
        } else if (next_action === 'PENDING_DOWN_PAYMENT') {
            setState({
                ...state,
                approvedSigned: 'done',
                funded: 'done'
            });
            return;
        }
        if (next_action === 'FUNDED') navigate({
            to: nextRoutes.success,
            search: true
        });
        else if (next_action === 'DECLINED') navigate({
            to: nextRoutes.error,
            search: true
        });
    }, [
        isError,
        state,
        next_action,
        nextRoutes.success,
        nextRoutes.error,
        navigate
    ]);
    if (!next_action) return null;
    const openFinancingWindow = (e)=>{
        e.preventDefault();
        const financingWindow = window.open(redirection_link, '_blank');
        setState({
            ...state,
            refetchInterval: 5000,
            financingWindow,
            approvedSigned: 'loading',
            funded: 'loading'
        });
    };
    const checklistItems = [
        {
            label: t('page.financing.checklist.approved'),
            status: state.approved
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: state.approvedSigned
        },
        {
            label: t('page.financing.checklist.funded'),
            status: state.funded
        }
    ];
    // TODO find a better solution for this ...
    const infobox = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
        type: "infoLight",
        "data-testid": "infobox",
        showIcon: true,
        children: t('patientfi.financingApproved.infobox')
    });
    const mixedQuestion = '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "patientfi",
        children: [
            state.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                children: t('status.error.failedToRequestPatientFiApplicationState')
            }),
            infobox,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t('patientfi.financingApproved.intro')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    }),
                    next_action !== 'DONE' && next_action !== 'PENDING_DOWN_PAYMENT' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "py-2 text-center w-1/3 m-auto mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            block: true,
                            tall: true,
                            onClick: openFinancingWindow,
                            "data-testid": "finalize-financing",
                            children: t('page.financing.openFinancingPartnerWindow')
                        })
                    }),
                    next_action === 'PENDING_DOWN_PAYMENT' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                        type: "warning",
                        className: " bg-yellow-200 mt-8 mb-8",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                "You have a pending down payment. Please collect this as soon as possible.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                    onClick: openFinancingWindow,
                                    "data-testid": "collect-payment",
                                    children: "Collect Payment"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: t('patientfi.whereIsTheTab.question')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            t('patientfi.whereIsTheTab.answer')
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: t('page.financing.troubleFinalizing.question')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            t('page.financing.troubleFinalizing.answer')
                        ]
                    }),
                    mixedQuestion
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                hasPrev: false,
                labelPrev: t('common.back'),
                onPrev: ()=>navigate({
                        to: (0, _routes.paymentOptionsPath),
                        search: true
                    })
            })
        ]
    });
};
// TODO solve this hack!
const FinancingApplicationCheck = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data, isLoading, isError } = (0, _useGetNextStep.useGetNextStep)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Navigate), {
        to: (0, _routes.createFinancingPath),
        search: true
    });
    if (data?.next_action !== 'UPDATE_OFFER' && data?.next_action !== 'SIGN_CONTRACT') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Navigate), {
        to: (0, _routes.createFinancingPath),
        search: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Financing, {
        ...props
    });
};
exports.default = FinancingApplicationCheck;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react-location":"8hNco","Core/components/Alert":"fmmNR","Core/components/FormElements/Card":"23G8S","Core/components/Footer":"ixeAp","Core/components/Button":"6YNzH","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Page":"4xeqH","Core/components/Loader":"6S7S4","Modules/patientfi/routes":"lyzU7","Modules/patientfi/hooks/useGetNextStep":"4nfRQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cdvA9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Checklist);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _checkListItem = require("./CheckListItem");
var _checkListItemDefault = parcelHelpers.interopDefault(_checkListItem);
var _indicatorCheckmark = require("./IndicatorCheckmark");
var _indicatorCheckmarkDefault = parcelHelpers.interopDefault(_indicatorCheckmark);
var _indicatorWarn = require("./IndicatorWarn");
var _indicatorWarnDefault = parcelHelpers.interopDefault(_indicatorWarn);
var _indicatorError = require("./IndicatorError");
var _indicatorErrorDefault = parcelHelpers.interopDefault(_indicatorError);
var _indicatorLoading = require("./IndicatorLoading");
var _indicatorLoadingDefault = parcelHelpers.interopDefault(_indicatorLoading);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const indicatorList = {
    done: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicatorCheckmarkDefault.default), {
        color: "green"
    }),
    loading: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicatorLoadingDefault.default), {}),
    warn: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicatorWarnDefault.default), {
        color: "orange"
    }),
    error: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicatorErrorDefault.default), {
        color: "red"
    }),
    idle: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicatorCheckmarkDefault.default), {
        color: "gray"
    })
};
function Checklist({ items }) {
    const checklist = items.map((item)=>{
        const status = item.status.toLowerCase();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkListItemDefault.default), {
            label: item.label,
            "data-testid": `checklist-item-${status}`,
            children: indicatorList[status]
        }, item.label);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "inline-block",
        children: checklist
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","./CheckListItem":"dujLY","./IndicatorCheckmark":"37q82","./IndicatorWarn":"6muiF","./IndicatorError":"9W6aN","./IndicatorLoading":"b2f5n","prop-types":"bPwP3","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dujLY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const CheckListItem = ({ label, children, ...rest })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "items-center flex flex-nowrap py-2 whitespace-pre-line",
        ...rest,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-4",
                children: label
            })
        ]
    });
};
exports.default = CheckListItem;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6muiF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _checklistStyled = require("Modules/creditDebit/components/Checklist/Checklist.styled");
const IndicatorWarn = ({ color })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistStyled.StyledIndicator), {
        color: color,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "inline-block w-7 h-7 relative [top:5px] [left:-3px]",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bg-yellow-500 absolute [top:0] [left:14px] [width:2px] [height:10px]"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bg-yellow-500 absolute [top:12px] [left:14px] [width:2px] [height:2px]"
                })
            ]
        })
    });
};
exports.default = IndicatorWarn;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","Modules/creditDebit/components/Checklist/Checklist.styled":"40i0q","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9W6aN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _checklistStyled = require("Modules/creditDebit/components/Checklist/Checklist.styled");
const IndicatorError = ({ color })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistStyled.StyledIndicator), {
        color: color,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "inline-block relative origin-center [top:3px] [left:-3px] [transform:rotate(45deg)] [width:26px] [height:26px]",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: 'bg-error absolute [height:16px] [width:2px] [top:0] [left:10px]'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: 'bg-error absolute [height:2px] [width:16px] [top:7px] [left:3px]'
                })
            ]
        })
    });
};
exports.default = IndicatorError;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","Modules/creditDebit/components/Checklist/Checklist.styled":"40i0q","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"b2f5n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _checklistStyled = require("Modules/creditDebit/components/Checklist/Checklist.styled");
var _spinner = require("Core/components/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
const IndicatorLoading = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistStyled.StyledIndicator), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
            small: true,
            className: "!w-7 !h-7 !text-primary"
        })
    });
};
exports.default = IndicatorLoading;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/creditDebit/components/Checklist/Checklist.styled":"40i0q","Core/components/Spinner":"bZo5I","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"h5T1p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
const MixedSuccess = ()=>{
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const checklistItems = [
        {
            label: t('mixed.financingApproved.checklist.downPayment'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approved'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.funded'),
            status: 'done'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.mixed.success.header'),
        stickyFooter: true,
        branding: "patientfi",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertSuccess), {
                children: t('page.mixed.success.infobox')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t('page.mixed.success.intro')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                ]
            })
        ]
    });
};
exports.default = MixedSuccess;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Page":"4xeqH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iOzDS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _button = require("Core/components/Button");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _reactLocation = require("react-location");
var _routes = require("Modules/cardPayment/routes");
const MixedError = ()=>{
    const navigate = (0, _reactLocation.useNavigate)();
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const checklistItems = [
        {
            label: t('mixed.financingApproved.checklist.downPayment'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approved'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.funded'),
            status: 'error'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.mixed.error.header'),
        stickyFooter: true,
        branding: "patientfi",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                children: t('page.mixed.error.infobox')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t('page.mixed.error.intro')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `py-2 text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            onClick: ()=>navigate({
                                    to: (0, _routes.cardPreferenceCenterPath),
                                    search: true
                                }),
                            children: t('common.useAnotherPaymentOption')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                ]
            })
        ]
    });
};
exports.default = MixedError;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Button":"6YNzH","Core/components/Page":"4xeqH","react-location":"8hNco","Modules/cardPayment/routes":"kPsar","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ghX2G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _reactLocation = require("react-location");
var _alert = require("Core/components/Alert");
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _footer = require("Core/components/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _button = require("Core/components/Button");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _routes = require("Modules/financing/routes");
var _useGetNextStep = require("Modules/financing/hooks/useGetNextStep");
const Financing = ({ nextRoutes })=>{
    (0, _useScrollTop.useScrollTop)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    // const shouldShowSidebar = useShowSidebar();
    const [state, setState] = (0, _reactDefault.default).useState({
        refetchInterval: false,
        financingWindow: null,
        approved: 'done',
        approvedSigned: 'idle',
        funded: 'idle',
        isError: false
    });
    const { data: { next_action, payload: { links: { cart: redirection_link } }, isError } } = (0, _useGetNextStep.useGetNextStep)(state.refetchInterval);
    (0, _reactDefault.default).useEffect(()=>{
        if (!next_action) return;
        if (isError) {
            setState({
                refetchInterval: 5000,
                approvedSigned: 'error',
                funded: 'error'
            });
            return;
        } else if (next_action === 'FUND_APPLICATION') setState({
            ...state,
            approvedSigned: 'done'
        });
        else if (next_action === 'DONE') {
            setState({
                ...state,
                approvedSigned: 'done',
                funded: 'done'
            });
            return;
        } else if (next_action === 'PENDING_DOWN_PAYMENT') {
            setState({
                ...state,
                approvedSigned: 'done',
                funded: 'done'
            });
            return;
        }
        if (next_action === 'FUNDED') navigate({
            to: nextRoutes.success,
            search: true
        });
        else if (next_action === 'DECLINED') navigate({
            to: nextRoutes.error,
            search: true
        });
    }, [
        isError,
        state,
        next_action,
        nextRoutes.success,
        nextRoutes.error,
        navigate
    ]);
    if (!next_action) return null;
    const openFinancingWindow = (e)=>{
        e.preventDefault();
        const financingWindow = window.open(redirection_link, '_blank');
        setState({
            ...state,
            refetchInterval: 5000,
            financingWindow,
            approvedSigned: 'loading',
            funded: 'loading'
        });
    };
    const checklistItems = [
        {
            label: t('page.financing.checklist.approved'),
            status: state.approved
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: state.approvedSigned
        },
        {
            label: t('page.financing.checklist.funded'),
            status: state.funded
        }
    ];
    // TODO find a better solution for this ...
    const infobox = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
        type: "infoLight",
        "data-testid": "infobox",
        showIcon: true,
        children: t('synchrony.financingApproved.infobox')
    });
    const mixedQuestion = '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        children: [
            state.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                children: t('synchrony.failedToRequestFinancingApplicationState')
            }),
            infobox,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t('synchrony.financingApproved.intro2')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    }),
                    next_action !== 'DONE' && next_action !== 'PENDING_DOWN_PAYMENT' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "py-2 text-center w-1/3 m-auto mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            block: true,
                            tall: true,
                            onClick: openFinancingWindow,
                            "data-testid": "finalize-financing",
                            children: t('page.financing.openFinancingPartnerWindow')
                        })
                    }),
                    next_action === 'PENDING_DOWN_PAYMENT' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                        type: "warning",
                        className: " bg-yellow-200 mt-8 mb-8",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                "You have a pending down payment. Please collect this as soon as possible.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                    onClick: openFinancingWindow,
                                    "data-testid": "collect-payment",
                                    children: "Collect Payment"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: t('synchrony.whereIsTheTab')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            t('page.financing.whereIsTheTab.answer')
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: t('page.financing.troubleFinalizing.question')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            t('page.financing.troubleFinalizing.answer')
                        ]
                    }),
                    mixedQuestion
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                hasPrev: false,
                labelPrev: t('common.back'),
                onPrev: ()=>navigate({
                        to: (0, _routes.paymentOptionsPath),
                        search: true
                    })
            })
        ]
    });
};
// TODO solve this hack!
const FinancingApplicationCheck = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data, isLoading, isError } = (0, _useGetNextStep.useGetNextStep)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Navigate), {
        to: (0, _routes.createFinancingPath),
        search: true
    });
    if (data?.next_action !== 'UPDATE_OFFER' && data?.next_action !== 'SIGN_CONTRACT') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Navigate), {
        to: (0, _routes.createFinancingPath),
        search: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Financing, {
        ...props
    });
};
exports.default = FinancingApplicationCheck;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react-location":"8hNco","Core/components/Alert":"fmmNR","Core/components/FormElements/Card":"23G8S","Core/components/Footer":"ixeAp","Core/components/Button":"6YNzH","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Page":"4xeqH","Core/components/Loader":"6S7S4","Modules/financing/routes":"5ZPtj","Modules/financing/hooks/useGetNextStep":"fWBFC","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kfLWb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
const MixedSuccess = ()=>{
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const checklistItems = [
        {
            label: t('mixed.financingApproved.checklist.downPayment'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approved'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.funded'),
            status: 'done'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.mixed.success.header'),
        stickyFooter: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertSuccess), {
                children: t('page.mixed.success.infobox')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t('page.mixed.success.intro')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                ]
            })
        ]
    });
};
exports.default = MixedSuccess;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Page":"4xeqH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"34O6k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _button = require("Core/components/Button");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _reactLocation = require("react-location");
var _routes = require("Modules/cardPayment/routes");
var _postExchangeBanner = require("Modules/financing/components/PostExchangeBanner");
var _postExchangeBannerDefault = parcelHelpers.interopDefault(_postExchangeBanner);
const MixedError = ()=>{
    const navigate = (0, _reactLocation.useNavigate)();
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const checklistItems = [
        {
            label: t('mixed.financingApproved.checklist.downPayment'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approved'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.funded'),
            status: 'error'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.mixed.error.header'),
        stickyFooter: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _postExchangeBannerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                children: t('page.mixed.error.infobox')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t('page.mixed.error.intro')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `py-2 text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            onClick: ()=>navigate({
                                    to: (0, _routes.cardPreferenceCenterPath),
                                    search: true
                                }),
                            children: t('common.useAnotherPaymentOption')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                ]
            })
        ]
    });
};
exports.default = MixedError;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Button":"6YNzH","Core/components/Page":"4xeqH","react-location":"8hNco","Modules/cardPayment/routes":"kPsar","Modules/financing/components/PostExchangeBanner":"eth8c","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6CCT1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFinancingPath", ()=>createFinancingPath);
parcelHelpers.export(exports, "financingPath", ()=>financingPath);
parcelHelpers.export(exports, "financingSuccessPath", ()=>financingSuccessPath);
parcelHelpers.export(exports, "financingErrorPath", ()=>financingErrorPath);
parcelHelpers.export(exports, "paymentOptionsPath", ()=>paymentOptionsPath);
parcelHelpers.export(exports, "createSecondaryFinancingPath", ()=>createSecondaryFinancingPath);
parcelHelpers.export(exports, "financingRequalifyPath", ()=>financingRequalifyPath);
parcelHelpers.export(exports, "mixedAvailableCreditPath", ()=>mixedAvailableCreditPath);
parcelHelpers.export(exports, "mixedDownPaymentCheckoutPath", ()=>mixedDownPaymentCheckoutPath);
parcelHelpers.export(exports, "mixedFinancingPath", ()=>mixedFinancingPath);
parcelHelpers.export(exports, "mixedSuccessPath", ()=>mixedSuccessPath);
parcelHelpers.export(exports, "mixedErrorPath", ()=>mixedErrorPath);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _financingRedirect = require("Modules/fortiva/routes/FinancingRedirect");
var _financingRedirectDefault = parcelHelpers.interopDefault(_financingRedirect);
var _financingSuccess = require("Modules/fortiva/routes/FinancingSuccess");
var _financingSuccessDefault = parcelHelpers.interopDefault(_financingSuccess);
var _financingDeclined = require("Modules/fortiva/routes/FinancingDeclined");
var _financingDeclinedDefault = parcelHelpers.interopDefault(_financingDeclined);
var _financing = require("Modules/fortiva/routes/Financing");
var _financingDefault = parcelHelpers.interopDefault(_financing);
var _createApplication = require("./routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _financingRequalify = require("Modules/fortiva/routes/FinancingRequalify");
var _financingRequalifyDefault = parcelHelpers.interopDefault(_financingRequalify);
var _payment = require("Modules/cardPayment/routes/Payment");
var _mixedSuccess = require("Modules/fortiva/routes/MixedSuccess");
var _mixedSuccessDefault = parcelHelpers.interopDefault(_mixedSuccess);
var _mixedError = require("Modules/fortiva/routes/MixedError");
var _mixedErrorDefault = parcelHelpers.interopDefault(_mixedError);
const createFinancingPath = '/financing-fortiva/financing';
const financingPath = '/financing-fortiva/office/finance';
const financingSuccessPath = '/financing-fortiva/funded';
const financingErrorPath = '/financing-fortiva/declined';
const paymentOptionsPath = '/card-payment/cards';
const createSecondaryFinancingPath = '/financing-fortiva/financing/secondary';
const financingRequalifyPath = '/financing-fortiva/requalify';
const mixedAvailableCreditPath = '/financing-fortiva/mixed/available-credit';
const mixedDownPaymentCheckoutPath = '/financing-fortiva/mixed/down-payment/checkout';
const mixedFinancingPath = '/financing-fortiva/mixed/financing';
const mixedSuccessPath = '/financing-fortiva/mixed/success';
const mixedErrorPath = '/financing-fortiva/mixed/error';
const routes = [
    {
        path: createFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingRedirectDefault.default), {})
    },
    {
        path: createSecondaryFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
            type: "secondary"
        })
    },
    {
        path: financingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDefault.default), {
            nextRoutes: {
                success: financingSuccessPath,
                error: financingErrorPath
            }
        })
    },
    {
        path: financingSuccessPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSuccessDefault.default), {})
    },
    {
        path: financingErrorPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {})
    },
    {
        path: financingRequalifyPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingRequalifyDefault.default), {})
    },
    {
        path: mixedDownPaymentCheckoutPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _payment.Payment), {
            paymentType: "downPayment",
            autoCloseOnlyAfterPayment: true,
            nextRoutes: {
                success: mixedFinancingPath,
                error: mixedErrorPath
            }
        })
    },
    {
        path: mixedFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDefault.default), {
            nextRoutes: {
                success: mixedSuccessPath,
                error: mixedErrorPath
            }
        })
    },
    {
        path: mixedSuccessPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mixedSuccessDefault.default), {})
    },
    {
        path: mixedErrorPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mixedErrorDefault.default), {})
    }
];

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/fortiva/routes/FinancingRedirect":"2XCQH","Modules/fortiva/routes/FinancingSuccess":"eoIyg","Modules/fortiva/routes/FinancingDeclined":"8zooa","Modules/fortiva/routes/Financing":"aL08u","./routes/CreateApplication":"9OFYo","Modules/fortiva/routes/FinancingRequalify":"8Pcon","Modules/cardPayment/routes/Payment":"gn9UA","Modules/fortiva/routes/MixedSuccess":"2Tccr","Modules/fortiva/routes/MixedError":"jCIbF","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2XCQH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingRedirect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _createApplication = require("Modules/fortiva/routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _financingPreparation = require("Modules/fortiva/components/FinancingPreparation");
var _financingPreparationDefault = parcelHelpers.interopDefault(_financingPreparation);
var _useGetNextStep = require("Modules/fortiva/hooks/useGetNextStep");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _financingSuccess = require("Modules/fortiva/routes/FinancingSuccess");
var _financingSuccessDefault = parcelHelpers.interopDefault(_financingSuccess);
var _financingApproved = require("Modules/fortiva/routes/FinancingApproved");
var _financingApprovedDefault = parcelHelpers.interopDefault(_financingApproved);
var _returnTracking = require("Modules/fortiva/components/ReturnTracking");
var _returnTrackingDefault = parcelHelpers.interopDefault(_returnTracking);
var _financingStatusMessage = require("Modules/fortiva/components/FinancingStatusMessage");
var _financingStatusMessageDefault = parcelHelpers.interopDefault(_financingStatusMessage);
var _financingDeclined = require("Modules/fortiva/routes/FinancingDeclined");
var _financingDeclinedDefault = parcelHelpers.interopDefault(_financingDeclined);
var _financingAlreadyProcessed = require("Modules/fortiva/routes/FinancingAlreadyProcessed");
var _financingAlreadyProcessedDefault = parcelHelpers.interopDefault(_financingAlreadyProcessed);
var _financingExceptions = require("Modules/fortiva/routes/FinancingExceptions");
var _financingExceptionsDefault = parcelHelpers.interopDefault(_financingExceptions);
var _routes = require("Modules/cardPayment/routes");
var _constants = require("Modules/fortiva/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _routes1 = require("Modules/fortiva/routes");
var _routes2 = require("Core/routes");
var _correctionStatus = require("Modules/fortiva/utils/correctionStatus");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactLocation = require("react-location");
var _routes3 = require("Modules/financing/routes");
function FinancingRedirect() {
    const routes = {
        paymentOptions: (0, _routes.cardPreferenceCenterPath),
        financing: (0, _routes1.financingPath),
        mixed: (0, _routes1.mixedDownPaymentCheckoutPath),
        financingSuccessPath: (0, _routes1.financingSuccessPath),
        financingErrorPath: (0, _routes1.financingErrorPath),
        payment: (0, _routes.paymentPath),
        allegroFinancing: (0, _routes3.createFinancingPath)
    };
    const navigate = (0, _reactLocation.useNavigate)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const { t } = (0, _reactI18Next.useTranslation)();
    const [customerIdentityNumber, setCustomerIdentityNumber] = (0, _reactDefault.default).useState('');
    const rawSessionStorageItem = sessionStorage.getItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY);
    const cachedApp = rawSessionStorageItem && rawSessionStorageItem !== 'undefined' ? JSON.parse(rawSessionStorageItem) : null;
    const { data: newApp, isLoading, isError, error } = (0, _useGetNextStep.useGetNextStep)(false, !cachedApp);
    const application = cachedApp || newApp;
    sessionStorage.removeItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY);
    const { next_action = 'CREATE_APPLICATION' } = application || {};
    const { data: { amount_to_pay, customer_id = '' } = {}, isLoading: isPaymentInfoLoading, isError: isPaymentInfoError } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
    else if (isError || error?.response?.status === 404 || !application?.next_action) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
        customer_id: customer_id,
        onCustomerIdentityNumber: setCustomerIdentityNumber
    });
    else if (application?.next_action) switch(next_action){
        case 'CREATE_APPLICATION':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
                type: "primary",
                customer_id: customer_id,
                onCustomerIdentityNumber: setCustomerIdentityNumber
            });
        case 'SELECT_OFFER':
        case 'SIGN_CONTRACT':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingPreparationDefault.default), {
                application: application,
                routes: routes,
                customerIdentityNumber: customerIdentityNumber
            });
        case 'UPDATE_OFFER':
            // Existing customer match on offer update -> show the already-processed page
            if ((0, _correctionStatus.hasExistingCustomer)(application)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingAlreadyProcessedDefault.default), {});
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingPreparationDefault.default), {
                application: application,
                routes: routes,
                customerIdentityNumber: customerIdentityNumber
            });
        case 'ERROR':
            // Invalid OTP -> let the user re-enter the code on the finalize tab
            if ((0, _correctionStatus.hasOtpMismatch)(application)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingPreparationDefault.default), {
                application: application,
                routes: routes,
                customerIdentityNumber: customerIdentityNumber
            });
            // Customer already has an account -> application was already processed
            if ((0, _correctionStatus.hasAlreadyHasAccount)(application)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingAlreadyProcessedDefault.default), {});
            setError(t('status.error.getFinancingApplicationFailed'));
            navigate({
                to: (0, _routes2.errorPath),
                search: true
            });
            break;
        case 'CORRECTION_REQUIRED':
        case 'DECLINED':
        case 'DECISION_PENDING':
        case 'INCOMPLETE':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingExceptionsDefault.default), {
                customer_id: customer_id,
                application: application,
                nextAction: next_action,
                onCustomerIdentityNumber: setCustomerIdentityNumber
            });
        case 'UPDATE_AMOUNT':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingApprovedDefault.default), {});
        case 'CANCELLED':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {
                application: application
            });
        case 'DONE':
        case 'FUND_APPLICATION':
        case 'PENDING_DOWN_PAYMENT':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSuccessDefault.default), {});
        case 'RETURN_APPROVED':
        case 'RETURN_REQUESTED':
        case 'RETURN_PROCESSING':
        case 'RETURN_COMPLETE':
        case 'RETURN_CANCELED':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _returnTrackingDefault.default), {
                nextAction: next_action
            });
        case 'APPLICATION_CLOSED':
            if (application?.payload?.application_status === 'Rejected') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {
                application: application,
                isRejected: true
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingStatusMessageDefault.default), {
                nextAction: next_action
            });
        case 'NO_DECISION':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingStatusMessageDefault.default), {
                nextAction: next_action
            });
        default:
            setError(t('status.error.getFinancingApplicationFailed'));
            navigate({
                to: (0, _routes2.errorPath),
                search: true
            });
    }
    if (!isPaymentInfoError && !isPaymentInfoLoading && !amount_to_pay) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingApprovedDefault.default), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Modules/fortiva/routes/CreateApplication":"9OFYo","Modules/fortiva/components/FinancingPreparation":"83Bdr","Modules/fortiva/hooks/useGetNextStep":"38IW2","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Core/components/Loader":"6S7S4","Modules/fortiva/routes/FinancingSuccess":"eoIyg","Modules/fortiva/routes/FinancingApproved":"bilPz","Modules/fortiva/components/ReturnTracking":"4B58m","Modules/fortiva/components/FinancingStatusMessage":"bKm9s","Modules/fortiva/routes/FinancingDeclined":"8zooa","Modules/fortiva/routes/FinancingAlreadyProcessed":"UdIqn","Modules/fortiva/routes/FinancingExceptions":"iGuyQ","Modules/cardPayment/routes":"kPsar","Modules/fortiva/config/constants":"lb4iD","Modules/fortiva/routes":"6CCT1","Core/routes":"iddMu","Modules/fortiva/utils/correctionStatus":"kl0of","Core/stores/error":"38MVH","react-location":"8hNco","Modules/financing/routes":"5ZPtj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9OFYo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _reactI18Next = require("react-i18next");
var _selectMenu = require("Core/components/FormElements/SelectMenu");
var _selectMenuDefault = parcelHelpers.interopDefault(_selectMenu);
var _alert = require("Core/components/Alert");
var _infoBox = require("Core/components/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _button = require("Core/components/Button");
var _usStates = require("Modules/creditDebit/config/usStates");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _birthDateInput = require("Core/components/FormElements/BirthDateInput");
var _birthDateInputDefault = parcelHelpers.interopDefault(_birthDateInput);
var _layout = require("Core/components/Layout");
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _reactLocation = require("react-location");
var _useCreateApplicationForm = require("Modules/fortiva/hooks/useCreateApplicationForm");
var _useCreateApplicationFormDefault = parcelHelpers.interopDefault(_useCreateApplicationForm);
var _useCreateApplication = require("Modules/fortiva/hooks/useCreateApplication");
var _useCreateApplicationDefault = parcelHelpers.interopDefault(_useCreateApplication);
var _useGetCustomerInfo = require("Modules/fortiva/hooks/useGetCustomerInfo");
var _useGetCustomerInfoDefault = parcelHelpers.interopDefault(_useGetCustomerInfo);
var _useGetApplication = require("Modules/fortiva/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _fa6 = require("react-icons/fa6");
var _quote = require("Core/components/Quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
var _useScrollTop = require("Core/hooks/useScrollTop");
var _mapCustomerData = require("Modules/fortiva/utils/mapCustomerData");
var _logger = require("Core/utils/logger");
var _constants = require("../config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _reactQuery = require("react-query");
const dateFormat = 'yyyy-MM-dd';
const CreateApplication = ({ customer_id = '', purpose = 'create', errorConfig = {}, onCustomerIdentityNumber })=>{
    document.title = 'Payment Portal - Create Application';
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const scroll = (0, _useScrollTop.useScrollTop)();
    const effectivePurpose = errorConfig?.errorCode === 'EXISTING_CUSTOMER' ? 'update' : purpose;
    const { mutateAsync: createApplication, isLoading: isCreateAppLoading } = (0, _useCreateApplicationDefault.default)(effectivePurpose);
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const [showSsn, setShowSsn] = (0, _reactDefault.default).useState(false);
    const [createApplicationPolling, setCreateApplicationPolling] = (0, _reactDefault.default).useState(false);
    const { isSuccess: isGetAppSuccess, isLoading: isGetAppLoading, data: getAppData } = (0, _useGetApplicationDefault.default)(requestId, createApplicationPolling ? 3000 : false);
    const { data: customerInfo } = (0, _useGetCustomerInfoDefault.default)();
    const [dobDefaults, setDobDefaults] = (0, _reactDefault.default).useState({
        day: '01',
        month: '01',
        year: ''
    });
    const [isFinanceAppLoading, setIsFinanceAppLoading] = (0, _reactDefault.default).useState(false);
    const [initialAppStatus, setInitialAppStatus] = (0, _reactDefault.default).useState({
        nextAction: null,
        message: null,
        status: null
    });
    const { register, handleSubmit, setValue, watch, reset, formState: { errors, isSubmitted } } = (0, _useCreateApplicationFormDefault.default)(errorConfig);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const showUpdateFormMessage = !!errorConfig.type;
    const initializeAppStatus = (appData)=>{
        const { correction_required: { status = '', message = '' } = {} } = appData?.payload || {};
        setInitialAppStatus({
            nextAction: appData?.next_action,
            message,
            status
        });
    };
    (0, _reactDefault.default).useEffect(()=>{
        const isAppStatusChanged = ()=>{
            return getAppData?.next_action !== initialAppStatus.nextAction || getAppData?.message !== initialAppStatus.message || getAppData?.status !== initialAppStatus.status;
        };
        // Only navigate if we're actively polling AND status changed
        if (isGetAppSuccess && createApplicationPolling && isAppStatusChanged()) {
            sessionStorage.setItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY, JSON.stringify(getAppData));
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
            setRequestId('');
            setCreateApplicationPolling(false);
            setIsFinanceAppLoading(false);
        }
    }, [
        isGetAppSuccess,
        getAppData,
        navigate,
        createApplicationPolling,
        requestId,
        initialAppStatus,
        queryClient
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetAppLoading) setIsFinanceAppLoading(true);
    }, [
        isGetAppLoading
    ]);
    // Cleanup effect to clear requestId and cache on component unmount
    (0, _reactDefault.default).useEffect(()=>{
        return ()=>{
            // Cleanup on unmount
            setRequestId('');
            queryClient.removeQueries((0, _cacheKeysDefault.default).fortivaGetApplication);
        };
    }, [
        queryClient
    ]);
    const parseDateOfBirth = (dateOfBirth)=>{
        let year, day, month;
        if (Array.isArray(dateOfBirth)) {
            [year] = dateOfBirth;
            [, day, month] = dateOfBirth;
            if (month > 0 && month < 10) month = '0' + month;
            if (day > 0 && day < 10) day = '0' + day;
        } else if (typeof dateOfBirth === 'string') [year, month, day] = dateOfBirth.split('-');
        return {
            day,
            month,
            year
        };
    };
    (0, _reactDefault.default).useEffect(()=>{
        const mappedCustomerData = (0, _mapCustomerData.mapCustomerData)(customerInfo, customer_id);
        if (mappedCustomerData) {
            Object.keys(mappedCustomerData).forEach((field)=>setValue(field, mappedCustomerData[field]));
            const finalDateOfBirth = mappedCustomerData.date_of_birth || mappedCustomerData.dateOfBirth;
            if (finalDateOfBirth) {
                const { day, month, year } = parseDateOfBirth(finalDateOfBirth);
                setDobDefaults({
                    day,
                    month,
                    year
                });
            }
        } else {
            setDobDefaults({
                day: '01',
                month: '01',
                year: ''
            });
            reset((0, _mapCustomerData.mapCustomerData)({}, customer_id));
        }
    }, [
        customerInfo,
        reset,
        setValue,
        isGetAppSuccess,
        isGetAppLoading,
        navigate,
        requestId,
        getAppData?.next_action,
        customer_id
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        const errorFields = Object.keys(errors);
        if (errorFields?.length) {
            const errorMap = errorFields.map((field)=>{
                return {
                    field,
                    message: errors[field].message
                };
            });
            console.log('form errors!', errorMap);
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                action: (0, _logger.actions).createApplicationFormError,
                errors: errorMap
            });
        }
    }, [
        errors
    ]);
    const ssn = watch('socialSecurityNumber');
    (0, _reactDefault.default).useEffect(()=>{
        setValue('socialSecurityNumber', ssn?.replace(/\D+/g, ''));
    }, [
        setValue,
        ssn
    ]);
    const phone = watch('phone');
    (0, _reactDefault.default).useEffect(()=>{
        if (phone?.startsWith('+1')) setValue('phone', phone.replace(/^\+1/, ''));
    }, [
        setValue,
        phone
    ]);
    const hasFormErrors = Object.keys(errors).length > 0;
    const storeCustomerInfo = (formData)=>{
        const filteredFormData = JSON.parse(JSON.stringify(formData));
        delete filteredFormData.socialSecurityNumber;
        delete filteredFormData.annualIncome;
        sessionStorage.setItem((0, _constantsDefault.default).SESS_STORAGE_CUSTOMER_INFO_KEY, JSON.stringify({
            ...filteredFormData,
            customer_id
        }));
    };
    const onSubmit = async (formData)=>{
        setRequestId(''); // Clear old requestId first
        initializeAppStatus();
        storeCustomerInfo(formData);
        // Lift the CIN into in-memory state upstream; it is never persisted.
        onCustomerIdentityNumber?.(formData.socialSecurityNumber);
        setCreateApplicationPolling(true);
        scroll.top();
        const { headers: { request_id } } = await createApplication(formData);
        setRequestId(request_id);
    };
    const toggleSsnDisplay = ()=>{
        setShowSsn(!showSsn);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.createFinancingApplication.header'),
        subtitle: t('page.createFinancingApplication.subtitleFortiva'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "fortiva",
        children: [
            isCreateAppLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('fortiva.createApplication.loaderText')
            }),
            isFinanceAppLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('status.loading.financingApplication')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                name: "fortivaCreateApplication",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    hasFormErrors && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                        type: "error",
                        children: t('status.error.checkErrors')
                    }),
                    showUpdateFormMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                        type: "error",
                        children: errorConfig.message
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!mb-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                            type: "infoLight",
                                            children: t('fortiva.createApplication.enterLegalNames')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!mb-2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.firstName'),
                                            name: "firstName",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.lastName'),
                                            name: "lastName",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.street'),
                                            name: "address",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.city'),
                                            name: "city",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                                            register: register,
                                            label: t('common.state'),
                                            name: "state",
                                            items: (0, _usStates.usStates),
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.postalCode'),
                                            name: "zip",
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.email'),
                                            name: "email",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.phone'),
                                            name: "phone",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-12",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                            showBorder: true,
                                            children: t('fortiva.phoneEmail.disclaimer')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6 flex items-end",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            className: "!rounded-r-none",
                                            register: register,
                                            label: t('fortiva.formlabel.ssn'),
                                            name: "socialSecurityNumber",
                                            errors: errors,
                                            onAppendClick: toggleSsnDisplay,
                                            appendText: showSsn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa6.FaEyeSlash), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa6.FaEye), {}),
                                            type: showSsn ? 'text' : 'password'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _birthDateInputDefault.default), {
                                            format: dateFormat,
                                            register: register,
                                            name: "dateOfBirth",
                                            padZeros: true,
                                            onChange: (value)=>{
                                                setValue('dateOfBirth', value, {
                                                    shouldValidate: isSubmitted
                                                });
                                            },
                                            defaultValues: dobDefaults,
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.annualGrossIncome'),
                                            name: "annualIncome",
                                            type: "number",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-12",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteDefault.default), {
                                            showWhitespace: true,
                                            children: t('fortiva.createApplication.readToCustomer.note2')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: t('common.noticeToApplicants')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                        type: "warning",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-semibold text-sm text-black",
                                            children: t('common.readToCustomer.doubleTitle')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                            showBorder: true,
                                            children: t('fortiva.createApplication.readToCustomer.note3')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                            showBorder: true,
                                            children: t('fortiva.createApplication.readToCustomer.note4')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _termsInputDefault.default), {
                                name: "terms",
                                register: register,
                                errors: errors,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                    children: t('fortiva.nextgen.createApplication.terms')
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "md:!flex-col-12 !flex gap-1 !justify-end",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                type: "submit",
                                "data-testid": "submit-application",
                                children: t('common.submitPrequalificationApplication')
                            })
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = CreateApplication;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/InputField":"6BJmW","react-i18next":"244ua","Core/components/FormElements/SelectMenu":"hsUsp","Core/components/Alert":"fmmNR","Core/components/InfoBox":"4Lj47","Core/components/Button":"6YNzH","Modules/creditDebit/config/usStates":"2i8MO","Core/components/Page":"4xeqH","Core/components/FormElements/BirthDateInput":"36m4y","Core/components/Layout":"hweet","Core/components/FormElements/formElements.styled":"45aFS","Core/components/FormElements/TermsInput":"2LJBE","Core/components/Loader":"6S7S4","react-location":"8hNco","Modules/fortiva/hooks/useCreateApplicationForm":"btnxr","Modules/fortiva/hooks/useCreateApplication":"fxccU","Modules/fortiva/hooks/useGetCustomerInfo":"8vgWF","Modules/fortiva/hooks/useGetApplication":"d6izJ","react-icons/fa6":"1emil","Core/components/Quote":"aL5Js","Core/hooks/useScrollTop":"cBwQW","Modules/fortiva/utils/mapCustomerData":"lG0Q2","Core/utils/logger":"cWDKQ","../config/constants":"lb4iD","Core/hooks/queries/cacheKeys":"i5IL7","react-query":"ksTpv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"btnxr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSocialSecurityNumberRegex", ()=>getSocialSecurityNumberRegex);
parcelHelpers.export(exports, "validateISODateFormat", ()=>validateISODateFormat);
parcelHelpers.export(exports, "validateMinimumAge", ()=>validateMinimumAge);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _dateFns = require("date-fns");
var _reactHookForm = require("react-hook-form");
const getSocialSecurityNumberRegex = ()=>/^(?:\d{3}-?\d{2}-?\d{4}|\d{4})$/;
const validateISODateFormat = (val)=>{
    return val ? (0, _dateFns.isValid)((0, _dateFns.parseISO)(val)) : true;
};
const validateMinimumAge = (val)=>{
    if (!val) return true;
    const date = (0, _dateFns.parseISO)(val);
    if (!(0, _dateFns.isValid)(date)) return true;
    return (0, _dateFns.differenceInYears)(new Date(), date) >= 18;
};
const useCreateApplicationForm = (errorConfig = {})=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            // salutation: z.string().min(1,{ message: t('common.requiredSalutation') }),
            firstName: _v3.string().min(1, {
                message: t('common.requiredFieldFirstName')
            }),
            lastName: _v3.string().min(1, {
                message: t('common.requiredFieldLastName')
            }),
            address: _v3.string().min(1, {
                message: t('common.requiredFieldStreet')
            }),
            city: _v3.string().min(1, {
                message: t('common.requiredFieldCity')
            }),
            state: _v3.string().min(1, {
                message: t('common.requiredFieldState')
            }),
            zip: _v3.string().min(1, {
                message: t('common.requiredFieldPostalCode')
            }),
            // country: z.string().min(1,{ message: t('common.requiredFieldCountry') }),
            email: _v3.string().min(1, {
                message: t('common.requiredFieldEmail')
            }).email({
                message: t('common.invalidFormatEmail')
            }),
            socialSecurityNumber: _v3.string().min(1, {
                message: t('common.requiredFieldSSN')
            }).refine((val)=>{
                const regex = getSocialSecurityNumberRegex();
                return regex.test(val);
            }, {
                message: t('fortiva.formlabel.invalidFormatSSN')
            }),
            phone: _v3.string().min(1, {
                message: t('common.requiredFieldPhone')
            }).regex(/^\d{10}$/, {
                message: 'Please provide a valid phone number with 10 digits'
            }),
            dateOfBirth: _v3.any().refine(validateISODateFormat, {
                message: t('common.invalidDateFormat')
            }).refine(validateMinimumAge, {
                message: 'You must be at least 18 years old to apply'
            }),
            annualIncome: _v3.string().transform(parseInt).refine((val)=>val >= 1, {
                message: t('common.requiredFieldAnnualIncome')
            }),
            terms: _v3.boolean().refine((val)=>val, {
                message: t('common.requiredFieldTerms')
            })
        });
    }, [
        t
    ]);
    const form = (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema)
    });
    const { setError } = form;
    // Set initial errors based on errorConfig
    (0, _reactDefault.default).useEffect(()=>{
        if (errorConfig.affectedFields && Array.isArray(errorConfig.affectedFields)) errorConfig.affectedFields.forEach((fieldName)=>{
            // Set a generic error message or use a custom one from errorConfig
            const errorMessage = errorConfig.message || t('common.fieldHasError');
            setError(fieldName, {
                type: 'manual',
                message: errorMessage
            });
        });
    }, [
        errorConfig,
        setError,
        t
    ]);
    return form;
};
exports.default = useCreateApplicationForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","date-fns":[["differenceInYears","fPB0B","default"],["isValid","jCEss","default"],["parseISO","3xgI2","default"]],"react-hook-form":"53GLT","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fPB0B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInYears);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarYears/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault3.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = (0, _indexJsDefault2.default)(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, _indexJsDefault2.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"iBeGL","../differenceInCalendarYears/index.js":"8Ft2J","../compareAsc/index.js":"8fxq0","../_lib/requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8Ft2J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarYears);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

},{"../toDate/index.js":"iBeGL","../_lib/requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8fxq0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>compareAsc);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function compareAsc(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

},{"../toDate/index.js":"iBeGL","../_lib/requiredArgs/index.js":"hVUyW","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fxccU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCreateApplication);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _reactI18Next = require("react-i18next");
var _logger = require("Core/utils/logger");
var _utils = require("Core/utils/utils");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function transformPayload({ firstName, lastName, address, city, state, zip, email, phone: number, socialSecurityNumber, dateOfBirth, annualIncome, customer_id, external_reference_id, purpose, provider, payment_option }) {
    return {
        payment_id: (0, _utils.getUrlParam)('payment-id'),
        external_reference_id,
        purpose,
        payment_option,
        provider,
        payload: {
            customer_id,
            first_name: firstName,
            middle_name: '',
            last_name: lastName,
            email,
            date_of_birth: dateOfBirth,
            customer_identity_number: socialSecurityNumber,
            monthly_income: Math.floor(annualIncome / 12),
            relationship: 'SELF',
            address_line: address,
            city,
            state,
            zip,
            phone_number: number,
            phone_type: 'mobile',
            agree_to_terms: true,
            authorized_representative: 'jose.vargas@hear.com'
        }
    };
}
function useCreateApplication(purpose = 'create') {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>{
        const httpMethod = purpose === 'update' ? (0, _platformApi.putWithHeaders) : (0, _platformApi.postWithHeaders);
        return httpMethod(`/financing/application`, transformPayload({
            ...payload,
            customer_id: paymentInfo.customer_id,
            external_reference_id: paymentInfo.external_reference_id,
            purpose: paymentInfo.purpose,
            provider: paymentInfo.provider,
            payment_option: paymentInfo.payment_option
        }));
    }, {
        throwOnError: true,
        retry: 2,
        enabled: Boolean(paymentInfo),
        onSuccess (data) {
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                status: 'success'
            });
            clearAlert();
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            return data;
        },
        onError (error) {
            setErrorAlert(t('status.error.createApplicationRequestFailed') + `(${error?.response?.data?.message})`);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","react-i18next":"244ua","Core/utils/logger":"cWDKQ","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8vgWF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetCustomerInfo);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _routes = require("Core/routes");
var _reactLocation = require("react-location");
function useGetCustomerInfo() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).financingCustomerInfo
    ], ()=>(0, _platformApi.get)(`/customer/search`), {
        onError (e) {
            if (e?.response?.status !== 404) {
                const message = e?.response?.data?.message ? ` - ${e?.response?.data?.message}` : '';
                setError(t('status.error.getFinancingApplicationFailed') + message);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        },
        retry: 1
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/error":"38MVH","Core/routes":"iddMu","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"d6izJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetApplication);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _routes = require("Core/routes");
var _reactLocation = require("react-location");
var _logger = require("Core/utils/logger");
const DATA_NOT_READY = 'Data not ready';
function useGetApplication(requestId, refetchInterval = false) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).fortivaGetApplication,
        requestId
    ], async ()=>{
        const data = await (0, _platformApi.get)(`/application`, {
            headers: {
                request_id: requestId
            }
        });
        if (!data?.next_action) throw new Error(DATA_NOT_READY);
        return data;
    }, {
        enabled: Boolean(requestId),
        retry: (failureCount, error)=>{
            if (error.message === DATA_NOT_READY) return failureCount < 30;
            return false;
        },
        retryDelay: 3000,
        refetchInterval,
        staleTime: 0,
        cacheTime: 300000,
        onError (e) {
            if (e.message === DATA_NOT_READY) {
                setErrorAlert(t('status.error.getFinancingApplicationFailed'));
                return;
            }
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                action: (0, _logger.actions).createApplicationTimeout
            });
            const message = e?.message ? ` - ${e?.message}` : '';
            setError(t('status.error.getFinancingApplicationFailed') + message);
            navigate({
                to: (0, _routes.errorPath),
                search: true
            });
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","Core/stores/error":"38MVH","Core/routes":"iddMu","react-location":"8hNco","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lG0Q2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapCustomerData", ()=>mapCustomerData);
var _getStateAbbreviation = require("../hooks/getStateAbbreviation");
var _getStateAbbreviationDefault = parcelHelpers.interopDefault(_getStateAbbreviation);
var _constants = require("../config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
const mapCustomerData = (customerData, customer_id)=>{
    const sessionStorageCustomerData = sessionStorage.getItem((0, _constantsDefault.default).SESS_STORAGE_CUSTOMER_INFO_KEY);
    if (sessionStorageCustomerData) {
        const parsedCustomerData = JSON.parse(sessionStorageCustomerData);
        if (parsedCustomerData.customer_id === customer_id) return parsedCustomerData;
    }
    if (customerData) return {
        ...customerData,
        firstName: customerData.first_name ?? '',
        lastName: customerData.last_name ?? '',
        address: customerData.address_line ?? '',
        city: customerData.city ?? '',
        state: (0, _getStateAbbreviationDefault.default)(customerData.state) ?? '',
        zip: customerData.zip ?? '',
        country: customerData.country ?? '',
        email: customerData.email ?? '',
        socialSecurityNumber: customerData.customer_identity_number ?? '',
        phone: (customerData.phone_number ?? '').replace(/^\+1/, ''),
        annualIncome: (customerData.monthly_income ? customerData.monthly_income * 12 : '').toString(),
        relationship: customerData.relationship ?? 'SELF'
    };
    return {};
};

},{"../hooks/getStateAbbreviation":"6g44L","../config/constants":"lb4iD","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6g44L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getStateAbbreviation);
var _usStates = require("Modules/creditDebit/config/usStates");
function getStateAbbreviation(input) {
    if (!input || !input.toLowerCase()) return input;
    const stateByLabel = (0, _usStates.usStates).find((state)=>input.toLowerCase() === state.label.toLowerCase());
    const stateByValue = (0, _usStates.usStates).find((state)=>input.toLowerCase() === state.value.toLowerCase());
    if (stateByValue) return input;
    else if (stateByLabel) return stateByLabel.value;
    return input;
}

},{"Modules/creditDebit/config/usStates":"2i8MO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lb4iD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    SESS_STORAGE_CUSTOMER_INFO_KEY: 'FORTIVA_CUSTOMER_INFO_FORM_DATA',
    SESS_STORAGE_APPLICATION_KEY: 'FORTIVA_APPLICATION',
    SESS_STORAGE_RELATIONSHIP_KEY: 'FORTIVA_RELATIONSHIP',
    UPDATE_OFFER_BUFFER_DELAY_MS: 2000
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"83Bdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _layout = require("Core/components/Layout");
var _tabset = require("Core/components/Tabset/Tabset");
var _tabsetDefault = parcelHelpers.interopDefault(_tabset);
var _tooltip = require("Core/components/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _infoBox = require("Core/components/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _useScrollBottom = require("Core/hooks/useScrollBottom");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _calendarInputField = require("Core/components/FormElements/CalendarInputField");
var _calendarInputFieldDefault = parcelHelpers.interopDefault(_calendarInputField);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _numberFormat = require("Core/utils/numberFormat");
var _appConfig = require("Core/config/appConfig");
var _financingTabNames = require("Modules/fortiva/config/financingTabNames");
var _useSelectOfferForm = require("Modules/fortiva/hooks/useSelectOfferForm");
var _useSelectOfferFormDefault = parcelHelpers.interopDefault(_useSelectOfferForm);
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _useGetApplication = require("Modules/fortiva/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _useGetNextStep = require("Modules/fortiva/hooks/useGetNextStep");
var _correctionStatus = require("Modules/fortiva/utils/correctionStatus");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _reactQuery = require("react-query");
var _finalizeOffer = require("Modules/fortiva/FinalizeOffer");
var _finalizeOfferDefault = parcelHelpers.interopDefault(_finalizeOffer);
var _updateAchModal = require("Modules/fortiva/components/UpdateAchModal");
var _updateAchModalDefault = parcelHelpers.interopDefault(_updateAchModal);
var _tabs = require("Core/stores/tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _selectOffer = require("Modules/fortiva/SelectOffer");
var _selectOfferDefault = parcelHelpers.interopDefault(_selectOffer);
const FinancingPreparation = ({ application, routes, customerIdentityNumber })=>{
    document.title = 'Payment Portal - Prepare Application';
    const { dateFormat } = (0, _appConfig.getAppConfig)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const scroll = (0, _useScrollBottom.useScrollBottom)();
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const DEFAULT_TAB_CONFIG = [
        {
            id: (0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY,
            label: t('fortiva.financing.tabs.headline-1'),
            pageHeader: t('page.selectFinancingOffer.header'),
            isActive: true,
            isDisabled: false
        },
        {
            id: (0, _financingTabNames.financingTabNames).SELECT_OFFER,
            label: t('fortiva.financing.tabs.headline-2'),
            pageHeader: t('page.selectFinancingOffer.header'),
            isActive: false,
            isDisabled: false
        },
        {
            id: (0, _financingTabNames.financingTabNames).FINALIZE_OFFER,
            label: t('fortiva.financing.tabs.headline-3'),
            pageHeader: t('page.completeFinancing.header'),
            isActive: false,
            isDisabled: false
        }
    ];
    const [tabConfig, setTabConfig] = (0, _reactDefault.default).useState(DEFAULT_TAB_CONFIG);
    const [isLoading, setIsLoading] = (0, _reactDefault.default).useState(false);
    const [selectedOffer, setSelectedOffer] = (0, _reactDefault.default).useState({
        id: '',
        require_downpayment_percent: 0,
        type: ''
    });
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const [enableSignContract, setEnableSignContract] = (0, _reactDefault.default).useState(false);
    const activeTab = (0, _tabsDefault.default)((state)=>state.activeTab);
    const setActiveTab = (0, _tabsDefault.default)((state)=>state.setActiveTab);
    const [activeTabId, setActiveTabId] = (0, _reactDefault.default).useState(activeTab || (0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY);
    const [refetchInterval, setRefetchInterval] = (0, _reactDefault.default).useState(false);
    const [isUpdateButtonDisabled, setIsUpdateButtonDisabled] = (0, _reactDefault.default).useState(false);
    const [isUpdateAchModalOpen, setIsUpdateAchModalOpen] = (0, _reactDefault.default).useState(false);
    const [pendingFinalize, setPendingFinalize] = (0, _reactDefault.default).useState(null);
    const { data: { amount_to_pay = 0 } = {} } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const { data: getAppData, isLoading: isGetAppLoading, isFetching: isGetAppFetching } = (0, _useGetApplicationDefault.default)(requestId);
    const { data: getNextStepData } = (0, _useGetNextStep.useGetNextStep)(refetchInterval, refetchInterval);
    const latestApp = getNextStepData || getAppData || application || {};
    const { next_action, payload: { offers, selected_offer_id, already_paid_amount = 0, additional_payment = 0, minimum_additional_payment = 0, approval = 0, down_payment_status, links: { app: appLink } = {} } = {} } = latestApp;
    const isDownPaymentPaid = down_payment_status === 'PAID';
    const priceInfo = latestApp?.payload?.offer_term?.price;
    const today = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    });
    const [{ delivery_date = today } = {}] = priceInfo?.products ? JSON.parse(priceInfo?.products) : [];
    const firstTermDownPaymentPercent = offers?.installment?.[0]?.terms?.[0]?.require_downpayment_percent || 0;
    const effectiveDownPaymentPercent = selectedOffer.require_downpayment_percent || firstTermDownPaymentPercent;
    const exceedsLimit = Boolean(approval) && amount_to_pay > Number(approval);
    const approvalGapMinimum = exceedsLimit ? amount_to_pay - Number(approval) : 0;
    const minimumDownPayment = Math.max(amount_to_pay * effectiveDownPaymentPercent, minimum_additional_payment, already_paid_amount, approvalGapMinimum);
    const maximumDownPayment = amount_to_pay;
    const { register, handleSubmit, formState: { errors, isDirty }, watch, setValue, getValues, control, reset } = (0, _useSelectOfferFormDefault.default)({
        minimumDownPayment,
        maximumDownPayment,
        dateFormat
    });
    const setDownPaymentLabel = (minAmount, maxAmount)=>{
        const downPaymentMinLabel = (0, _numberFormat.formatCurrency)(minAmount, {
            withDecimals: false
        });
        const downPaymentMaxLabel = (0, _numberFormat.formatCurrency)(maxAmount, {
            withDecimals: false
        });
        const hasOfferData = Boolean(offers?.installment?.[0]?.terms?.[0]?.id);
        return hasOfferData ? `Down Payment (${downPaymentMinLabel} - ${downPaymentMaxLabel})` : '';
    };
    const downPaymentLabel = setDownPaymentLabel(minimumDownPayment, maximumDownPayment);
    const inputDownPayment = watch('downPayment') || 0;
    const calculatedAmountToCollect = Math.round((inputDownPayment - already_paid_amount) * 100) / 100;
    const openAchWindow = ()=>{
        if (appLink) window.open(appLink, '_target');
    };
    const navigateToFinalizeTab = ()=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>{
                tab.isActive = tab.id === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER;
                setActiveTabId((0, _financingTabNames.financingTabNames).FINALIZE_OFFER);
                setEnableSignContract(true);
                return tab;
            });
        });
    };
    const handleAchConfirm = ()=>{
        navigateToFinalizeTab();
        setIsUpdateAchModalOpen(false);
        openAchWindow();
    };
    const handleAchSkipped = ()=>{
        navigateToFinalizeTab();
        setIsUpdateAchModalOpen(false);
    };
    (0, _reactDefault.default).useEffect(()=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>{
                if (tab.id === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER) tab.isDisabled = isDirty || next_action === (0, _financingTabNames.financingTabNames).SELECT_OFFER;
                return tab;
            });
        });
        if (down_payment_status === 'PAID') {
            setRefetchInterval(false);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).transactionHistory);
        }
    }, [
        isDirty,
        next_action,
        down_payment_status,
        queryClient
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>{
                if (tab.id === (0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY) {
                    tab.isDisabled = isDownPaymentPaid;
                    setIsUpdateButtonDisabled(isDownPaymentPaid);
                }
                return tab;
            });
        });
        // Once the down payment is collected, the down-payment tab must stay
        // unreachable — land on the finalize tab (also covers page refresh).
        if (isDownPaymentPaid) navigateToFinalizeTab();
    }, [
        isDownPaymentPaid
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setValue('deliveryDate', delivery_date);
        // Enforce the (possibly offer-specific) minimum without clobbering a value the
        // user has already entered. Re-running on selectedOffer.id would otherwise reset
        // the user's down payment the first time an offer gets selected.
        const floor = Math.max(additional_payment, minimumDownPayment);
        const current = Number(getValues('downPayment'));
        if (!Number.isFinite(current) || current < floor) setValue('downPayment', floor);
    }, [
        additional_payment,
        delivery_date,
        minimumDownPayment,
        setValue,
        getValues,
        selectedOffer.id
    ]);
    const otpMismatchPresent = (0, _correctionStatus.hasOtpMismatch)(latestApp);
    const existingCustomerPresent = (0, _correctionStatus.hasExistingCustomer)(latestApp);
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetAppFetching) return;
        if (otpMismatchPresent) {
            setTabConfig((currentTabConfig)=>currentTabConfig.map((tab)=>({
                        ...tab,
                        isActive: tab.id === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER,
                        isDisabled: tab.id !== (0, _financingTabNames.financingTabNames).FINALIZE_OFFER
                    })));
            setActiveTabId((0, _financingTabNames.financingTabNames).FINALIZE_OFFER);
            setEnableSignContract(true);
            setIsUpdateAchModalOpen(false);
            return;
        }
        switch(next_action){
            case (0, _financingTabNames.financingTabNames).SELECT_OFFER:
                break;
            case 'UPDATE_OFFER':
                setEnableSignContract(true);
                if (priceInfo?.payment_method === '') setIsUpdateAchModalOpen(true);
                else setIsUpdateAchModalOpen(false);
                break;
            case 'SIGN_CONTRACT':
                setTabConfig((currentTabConfig)=>{
                    return currentTabConfig.map((tab)=>{
                        tab.isDisabled = tab.id !== (0, _financingTabNames.financingTabNames).FINALIZE_OFFER;
                        tab.isActive = tab.id === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER;
                        setActiveTabId((0, _financingTabNames.financingTabNames).FINALIZE_OFFER);
                        setEnableSignContract(true);
                        return tab;
                    });
                });
                break;
            default:
                break;
        }
    }, [
        next_action,
        isGetAppFetching,
        priceInfo?.payment_method,
        otpMismatchPresent
    ]);
    const handleTabChange = (tabId)=>{
        setTabConfig((currentTabConfig)=>{
            return currentTabConfig.map((tab)=>({
                    ...tab,
                    isActive: tabId === tab.id
                }));
        });
        setActiveTabId(tabId);
    };
    const onFocus = (event)=>event.target.select();
    const onSubmit = (values)=>{
        scroll.bottom();
        setActiveTab(activeTabId);
        setPendingFinalize({
            downPayment: Number(values.downPayment) || 0,
            deliveryDate: values.deliveryDate,
            amountToCollect: calculatedAmountToCollect
        });
        reset(values);
        clearAlert();
        handleTabChange((0, _financingTabNames.financingTabNames).SELECT_OFFER);
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.initializingFinancing')
    });
    const finalizeProps = {
        application: latestApp,
        customerIdentityNumber,
        routes,
        enableSignContract,
        watch,
        pendingFinalize,
        selectedOffer,
        setRequestId,
        setIsLoading,
        setRefetchInterval,
        onBack: ()=>handleTabChange((0, _financingTabNames.financingTabNames).SELECT_OFFER)
    };
    const selectOfferProps = {
        offers,
        selectedOffer,
        setSelectedOffer,
        enableSignContract,
        navigateToFinalizeTab,
        amount_to_pay,
        already_paid_amount,
        approval,
        routes,
        selected_offer_id,
        downPayment: Number(inputDownPayment) || 0,
        // No way back to the down-payment tab once the down payment is collected.
        onBack: isDownPaymentPaid ? null : ()=>handleTabChange((0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY)
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        branding: "fortiva",
        title: tabConfig.find((tab)=>tab.id === activeTabId)?.pageHeader || t('page.completeFinancing.header'),
        withStepProgress: false,
        stickyFooter: true,
        children: [
            (isGetAppLoading || isGetAppFetching) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('fortiva.updateApplication.loaderText')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                className: "bg-slate-300",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                    className: "flex-wrap content-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "md:!flex-col-8 mb-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "!mb-0",
                                children: t('payment.totalAmountLabel')
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "md:!flex-col-4 text-right mb-0 pr-5 font-bold text-md",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                i18nKey: `{{amount}}`,
                                values: {
                                    amount: (0, _numberFormat.formatCurrency)(amount_to_pay, {
                                        withDecimals: true
                                    })
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                className: "bg-stone-100 !pt-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsetDefault.default), {
                        tabConfig: tabConfig,
                        onTabChange: handleTabChange,
                        interactive: false
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            activeTabId === (0, _financingTabNames.financingTabNames).SELECT_OFFER && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectOfferDefault.default), {
                                ...selectOfferProps
                            }),
                            activeTabId === (0, _financingTabNames.financingTabNames).DOWN_PAYMENT_AND_DELIVERY && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                name: "selectOfferForm",
                                onSubmit: handleSubmit(onSubmit),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "bg-slate-50 border border-slate-200 rounded-lg px-6 py-4 mt-4",
                                        children: existingCustomerPresent ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                    className: "!mt-0.5 !mb-2 text-xl font-serif font-bold text-gray-900",
                                                    "data-testid": "title-existing-customer",
                                                    children: "Existing account found"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "!mb-0 text-sm text-gray-500 leading-snug",
                                                    children: "It looks like this customer already has a Fortiva account on file. Enter a down payment below to continue with their existing account."
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                    className: "!mt-0.5 !mb-2 text-xl font-serif font-bold text-gray-900",
                                                    "data-testid": "approval-title",
                                                    children: "Congratulations, you're approved!"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                                    className: "!mb-0 text-sm text-gray-500 leading-snug",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mb-4",
                                                            children: t('fortiva.downpayment.terms.note1')
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            children: t('fortiva.downpayment.terms.note2')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "!mt-4",
                                        children: t('common.updateDownPayment')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                                                        className: "md:!flex-col-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "flex items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "mr-2",
                                                                        "data-testid": "value-available-credit",
                                                                        children: t('common.alreadyPaidAmount')
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                                        content: t('common.availableCreditTooltip'),
                                                                        "data-testid": "tooltip-available-credit"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mt-1 text-lg font-semibold",
                                                                children: (0, _numberFormat.formatCurrency)(already_paid_amount)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                                        className: "md:!flex-col-6 lg:!flex-col-4",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                                            register: register,
                                                            label: downPaymentLabel,
                                                            "data-testid": "input-down-payment",
                                                            prependText: "$",
                                                            name: "downPayment",
                                                            type: "number",
                                                            disabled: isUpdateButtonDisabled,
                                                            errors: errors,
                                                            onFocus: onFocus
                                                        })
                                                    })
                                                ]
                                            }),
                                            exceedsLimit && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _infoBoxDefault.default), {
                                                showBorder: true,
                                                children: [
                                                    "Approved amount (",
                                                    (0, _numberFormat.formatCurrency)(approval, {
                                                        withDecimals: true
                                                    }),
                                                    ") is lower than the total amount (",
                                                    (0, _numberFormat.formatCurrency)(amount_to_pay, {
                                                        withDecimals: true
                                                    }),
                                                    "). You could pay the difference of",
                                                    ' ',
                                                    (0, _numberFormat.formatCurrency)(approvalGapMinimum, {
                                                        withDecimals: true
                                                    }),
                                                    " using a down payment (using another payment source) or use a different payment method."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "!mt-4 hidden",
                                        children: t('common.updateDeliveryDate')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                                        className: "hidden",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                                            className: "justify-between items-end",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                                className: "md:!flex-col-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
                                                    name: "deliveryDate",
                                                    control: control,
                                                    rules: {
                                                        required: t('common.requiredFieldDeliveryDate')
                                                    },
                                                    render: ({ field: { onChange, onBlur, name, value } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarInputFieldDefault.default), {
                                                            label: t('common.deliveryDate'),
                                                            name: name,
                                                            value: value,
                                                            onBlur: onBlur,
                                                            "data-testid": "input-delivery-date",
                                                            onChange: onChange,
                                                            dayPickerProps: {
                                                                disabledDays: {
                                                                    before: new Date(),
                                                                    after: (0, _dateFns.add)(new Date(), {
                                                                        days: 60
                                                                    })
                                                                }
                                                            },
                                                            errors: errors
                                                        })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateAchModalDefault.default), {
                                        isModalOpen: isUpdateAchModalOpen,
                                        onModalConfirm: handleAchConfirm,
                                        onModalClose: handleAchSkipped
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                                        className: "flex justify-end mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                            className: "md:!flex-col-4 !flex !items-end",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                                block: true,
                                                type: "submit",
                                                "data-testid": "continue-to-finalize",
                                                disabled: isUpdateButtonDisabled,
                                                children: t('fortiva.continue')
                                            })
                                        })
                                    })
                                ]
                            }),
                            activeTabId === (0, _financingTabNames.financingTabNames).FINALIZE_OFFER && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _finalizeOfferDefault.default), {
                                ...finalizeProps
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = FinancingPreparation;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-hook-form":"53GLT","date-fns":[["add","1Oe4T","default"]],"Core/components/FormElements/InputField":"6BJmW","Core/components/Page":"4xeqH","Core/components/Button":"6YNzH","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"Core/components/FormElements/Card":"23G8S","Core/components/Layout":"hweet","Core/components/Tabset/Tabset":"2cELS","Core/components/Tooltip":"ew5TJ","Core/components/InfoBox":"4Lj47","Core/hooks/useScrollBottom":"4561s","Core/components/Loader":"6S7S4","Core/components/FormElements/CalendarInputField":"50zwN","Core/stores/alert":"fPz3p","Core/utils/numberFormat":"6T56F","Core/config/appConfig":"7qX5H","Modules/fortiva/config/financingTabNames":"kH7LT","Modules/fortiva/hooks/useSelectOfferForm":"i86Yk","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/fortiva/hooks/useGetApplication":"d6izJ","Modules/fortiva/hooks/useGetNextStep":"38IW2","Modules/fortiva/utils/correctionStatus":"kl0of","Core/hooks/queries/cacheKeys":"i5IL7","react-query":"ksTpv","Modules/fortiva/FinalizeOffer":"eEm8E","Modules/fortiva/components/UpdateAchModal":"ce36X","Core/stores/tabs":"gZ09A","Modules/fortiva/SelectOffer":"ivfCt","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kH7LT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "financingTabNames", ()=>financingTabNames);
const financingTabNames = {
    SELECT_OFFER: 'SELECT_OFFER',
    DOWN_PAYMENT_AND_DELIVERY: 'DOWN_PAYMENT_AND_DELIVERY',
    FINALIZE_OFFER: 'FINALIZE_OFFER',
    CONTRACT_STATUS: 'CONTRACT_STATUS'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i86Yk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateDownPaymentAmount", ()=>validateDownPaymentAmount);
parcelHelpers.export(exports, "validateCustomDateFormat", ()=>validateCustomDateFormat);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
const validateDownPaymentAmount = (minimumDownPayment, maximumDownPayment)=>(value)=>{
        return value !== '' && value >= minimumDownPayment && value <= maximumDownPayment;
    };
const validateCustomDateFormat = (dateFormat)=>(val)=>{
        return val ? (0, _dateFns.isValid)((0, _dateFns.parse)(val, dateFormat, new Date())) : true;
    };
const useSelectOfferForm = ({ minimumDownPayment, maximumDownPayment, dateFormat })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            deliveryDate: _v3.any().refine(validateCustomDateFormat(dateFormat), {
                message: t('common.invalidDateFormat')
            }),
            downPayment: _v3.any().transform(parseFloat).refine(validateDownPaymentAmount(minimumDownPayment, maximumDownPayment), {
                message: t('common.invalidValueRange', {
                    min: minimumDownPayment,
                    max: maximumDownPayment
                })
            })
        });
    }, [
        t,
        minimumDownPayment,
        maximumDownPayment,
        dateFormat
    ]);
    return (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        defaultValues: {
            downPayment: minimumDownPayment,
            deliveryDate: (0, _dateFns.format)(new Date(), dateFormat)
        }
    });
};
exports.default = useSelectOfferForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","react-hook-form":"53GLT","date-fns":[["format","7JNRj","default"],["isValid","jCEss","default"],["parse","jBRYJ","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"38IW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetNextStep", ()=>useGetNextStep);
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _platformApi = require("Core/utils/platformApi");
function useGetNextStep(refetchInterval, enabled = true) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const validator = (data)=>Boolean(data) && Boolean(data?.next_action);
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).financingNextStep, ()=>(0, _platformApi.get)('/application/next-step', {}, validator), {
        refetchInterval,
        enabled: Boolean(enabled),
        onError (e) {
            if (e) setError(t('status.error.getPaymentInfoFailed') + ` - (${e})`);
        }
    });
}

},{"react-i18next":"244ua","Core/stores/error":"38MVH","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/platformApi":"9RrWs","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"kl0of":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OTP_MISMATCH_STATUS", ()=>OTP_MISMATCH_STATUS);
parcelHelpers.export(exports, "ALREADY_HAS_ACCOUNT_STATUS", ()=>ALREADY_HAS_ACCOUNT_STATUS);
parcelHelpers.export(exports, "getCorrectionStatus", ()=>getCorrectionStatus);
parcelHelpers.export(exports, "isOtpMismatchStatus", ()=>isOtpMismatchStatus);
parcelHelpers.export(exports, "hasOtpMismatch", ()=>hasOtpMismatch);
parcelHelpers.export(exports, "isAlreadyHasAccountStatus", ()=>isAlreadyHasAccountStatus);
parcelHelpers.export(exports, "hasAlreadyHasAccount", ()=>hasAlreadyHasAccount);
parcelHelpers.export(exports, "EXISTING_CUSTOMER_MARKER", ()=>EXISTING_CUSTOMER_MARKER);
parcelHelpers.export(exports, "EXISTING_CUSTOMER_STATUS", ()=>EXISTING_CUSTOMER_STATUS);
parcelHelpers.export(exports, "isExistingCustomerStatus", ()=>isExistingCustomerStatus);
parcelHelpers.export(exports, "hasExistingCustomer", ()=>hasExistingCustomer);
const OTP_MISMATCH_STATUS = 'UNIQUE CODE DOES NOT MATCH THE OFFER SELECTED';
const ALREADY_HAS_ACCOUNT_STATUS = 'USER ALREADY HAS AN ACCOUNT';
const getCorrectionStatus = (app)=>app?.payload?.correction_required?.status ?? null;
const isOtpMismatchStatus = (status)=>typeof status === 'string' && status.trim().toUpperCase() === OTP_MISMATCH_STATUS;
const hasOtpMismatch = (app)=>isOtpMismatchStatus(getCorrectionStatus(app));
const isAlreadyHasAccountStatus = (status)=>typeof status === 'string' && status.trim().toUpperCase() === ALREADY_HAS_ACCOUNT_STATUS;
const hasAlreadyHasAccount = (app)=>isAlreadyHasAccountStatus(getCorrectionStatus(app));
const EXISTING_CUSTOMER_MARKER = '{EXISTING_CUSTOMER}';
const EXISTING_CUSTOMER_STATUS = 'EXISTING_CUSTOMER';
const isExistingCustomerStatus = (status)=>typeof status === 'string' && status.trim().toUpperCase() === EXISTING_CUSTOMER_STATUS;
const hasExistingCustomer = (app)=>isExistingCustomerStatus(getCorrectionStatus(app)) || Boolean(app?.payload?.correction_required?.message?.includes(EXISTING_CUSTOMER_MARKER));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eEm8E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinalizerOffer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _reactLocation = require("react-location");
var _reactToastify = require("react-toastify");
var _layout = require("Core/components/Layout");
var _button = require("Core/components/Button");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _utils = require("Core/utils/utils");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _useUpdateOffer = require("Modules/fortiva/hooks/useUpdateOffer");
var _useUpdateOfferDefault = parcelHelpers.interopDefault(_useUpdateOffer);
var _useGetApplication = require("Modules/fortiva/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _useAccountLookup = require("Modules/fortiva/hooks/useAccountLookup");
var _useAccountLookupDefault = parcelHelpers.interopDefault(_useAccountLookup);
var _otpInput = require("Modules/fortiva/components/OtpInput");
var _otpInputDefault = parcelHelpers.interopDefault(_otpInput);
var _offerTermsAndConditions = require("Modules/fortiva/components/OfferTermsAndConditions");
var _offerTermsAndConditionsDefault = parcelHelpers.interopDefault(_offerTermsAndConditions);
var _constants = require("Modules/fortiva/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _routes = require("Modules/fortiva/routes");
var _correctionStatus = require("Modules/fortiva/utils/correctionStatus");
var _financingSummary = require("./FinancingSummary");
var _financingSummaryDefault = parcelHelpers.interopDefault(_financingSummary);
const OFFER_ID_LENGTH = 6;
const UPDATE_OFFER_POLL_INTERVAL = 3000;
function FinalizerOffer({ application, customerIdentityNumber, watch, pendingFinalize, selectedOffer, setRefetchInterval, routes, onBack }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactLocation.useNavigate)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)() || {};
    const maskedEmail = paymentInfo?.masked_email || paymentInfo?.email || '';
    const nextAction = application?.next_action;
    const isUpdateOffer = nextAction === 'UPDATE_OFFER';
    const { mutateAsync: updateOffer, isLoading: isUpdating } = (0, _useUpdateOfferDefault.default)();
    const { mutate: accountLookup, isLoading: isResendingOtp } = (0, _useAccountLookupDefault.default)();
    const handleResendOtp = ()=>{
        accountLookup(customerIdentityNumber, {
            onSuccess: ()=>(0, _reactToastify.toast).success(t('fortiva.finalize.otp.resendToast', {
                    defaultValue: 'OTP sent!'
                }))
        });
    };
    const [offerCode, setOfferCode] = (0, _reactDefault.default).useState('');
    const [terms, setTerms] = (0, _reactDefault.default).useState([
        false,
        false,
        false,
        false
    ]);
    const [otpError, setOtpError] = (0, _reactDefault.default).useState(()=>(0, _correctionStatus.hasOtpMismatch)(application) ? t('fortiva.finalize.otp.invalidCode') : '');
    const handleOfferCodeChange = (next)=>{
        if (otpError) setOtpError('');
        setOfferCode(next);
    };
    const [updateOfferRequestId, setUpdateOfferRequestId] = (0, _reactDefault.default).useState('');
    const [isPollingUpdateOffer, setIsPollingUpdateOffer] = (0, _reactDefault.default).useState(false);
    const getCorrectionStatus = (app)=>app?.payload?.correction_required?.status ?? null;
    const { data: polledApp, isSuccess: isPolledAppSuccess } = (0, _useGetApplicationDefault.default)(updateOfferRequestId, isPollingUpdateOffer ? UPDATE_OFFER_POLL_INTERVAL : false);
    (0, _reactDefault.default).useEffect(()=>{
        if (!isPollingUpdateOffer || !isPolledAppSuccess || !polledApp) return;
        setIsPollingUpdateOffer(false);
        setUpdateOfferRequestId('');
        if ((0, _correctionStatus.isOtpMismatchStatus)(getCorrectionStatus(polledApp))) {
            setOtpError(t('fortiva.finalize.otp.invalidCode'));
            setOfferCode('');
            return;
        }
        sessionStorage.setItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY, JSON.stringify(polledApp));
        queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
        navigate({
            to: (0, _routes.createFinancingPath),
            search: true
        });
    }, [
        isPollingUpdateOffer,
        isPolledAppSuccess,
        polledApp,
        queryClient,
        navigate,
        t
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        return ()=>{
            setUpdateOfferRequestId('');
            queryClient.removeQueries((0, _cacheKeysDefault.default).fortivaGetApplication);
        };
    }, [
        queryClient
    ]);
    const blockFinalizeOfferForFinalQuote = (0, _utils.getUrlParamIgnoreCase)('blockFinalizeOfferForFinalQuote') === 'true';
    const allTermsAccepted = terms.every(Boolean);
    const offerCodeValid = offerCode.length === OFFER_ID_LENGTH;
    const canFinalize = !blockFinalizeOfferForFinalQuote && allTermsAccepted && (isUpdateOffer || offerCodeValid);
    const getOfferDetails = ()=>{
        if (pendingFinalize) return pendingFinalize;
        if (typeof watch !== 'function') return null;
        const downPayment = Number(watch('downPayment')) || 0;
        const deliveryDate = watch('deliveryDate');
        if (!deliveryDate) return null;
        const alreadyPaid = application?.payload?.already_paid_amount ?? 0;
        return {
            downPayment,
            deliveryDate,
            amountToCollect: Math.round((downPayment - alreadyPaid) * 100) / 100
        };
    };
    const prepareCollectPayment = async ()=>{
        const offerDetails = getOfferDetails();
        if (!offerDetails) {
            setErrorAlert(t('fortiva.finalize.missingOfferDetails'));
            throw new Error('missing offer details');
        }
        try {
            setOtpError('');
            await updateOffer({
                offerId: '',
                processSale: false,
                additionalPayment: offerDetails.downPayment,
                financingDownPayment: offerDetails.amountToCollect,
                deliveryDate: offerDetails.deliveryDate
            });
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            clearAlert();
        } catch (err) {
            setErrorAlert(err.message);
            throw err;
        }
    };
    const handleFinalize = async ()=>{
        const offerDetails = getOfferDetails();
        if (!offerDetails) {
            setErrorAlert(t('fortiva.finalize.missingOfferDetails'));
            return;
        }
        try {
            setOtpError('');
            const result = await updateOffer({
                offerId: isUpdateOffer ? '' : offerCode,
                processSale: nextAction === 'SELECT_OFFER' || nextAction === 'UPDATE_OFFER',
                additionalPayment: offerDetails.downPayment,
                // Fortiva expects only the amount collected in the down-payment step,
                // i.e. the entered down payment minus the already-paid amount.
                financingDownPayment: offerDetails.amountToCollect,
                deliveryDate: offerDetails.deliveryDate
            });
            const requestId = result?.headers?.request_id;
            if (requestId) {
                setUpdateOfferRequestId(requestId);
                setIsPollingUpdateOffer(true);
            }
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            clearAlert();
        } catch (err) {
            setErrorAlert(err.message);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (isUpdating || isPollingUpdateOffer) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('fortiva.updateApplication.loaderText')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "w-full m-auto",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSummaryDefault.default), {
                        watch: watch,
                        setRefetchInterval: setRefetchInterval,
                        routes: routes,
                        application: application,
                        selectedOffer: selectedOffer,
                        onPrepareCollectPayment: prepareCollectPayment
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-4 space-y-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offerTermsAndConditionsDefault.default), {
                                value: terms,
                                onChange: setTerms
                            }),
                            !isUpdateOffer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _otpInputDefault.default), {
                                value: offerCode,
                                onChange: handleOfferCodeChange,
                                maskedEmail: maskedEmail,
                                error: otpError,
                                onResend: handleResendOtp,
                                isResending: isResendingOtp
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rounded-xl border border-slate-300 bg-gradient-to-br from-slate-50 to-blue-50/40 px-4 py-3 text-sm text-slate-700 leading-relaxed",
                                "data-testid": "finalize-authorization-note",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-bold text-slate-900",
                                        children: "Note:"
                                    }),
                                    " Fortiva\xae Retail Credit is itself a credit account, so a separate $98 authorization hold is not required. Click below to finalize the account."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                        className: "flex items-center justify-between mt-4 px-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                className: "md:!flex-col-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                                    block: true,
                                    type: "button",
                                    "data-testid": "back-to-down-payment",
                                    onClick: onBack,
                                    children: t('fortiva.back')
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                className: "md:!flex-col-6",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                    block: true,
                                    "data-testid": "finalize-fortiva-offer",
                                    onClick: handleFinalize,
                                    disabled: !canFinalize || isUpdating,
                                    children: t('fortiva.finalize.cta')
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-query":"ksTpv","react-i18next":"244ua","react-location":"8hNco","react-toastify":"8eTVO","Core/components/Layout":"hweet","Core/components/Button":"6YNzH","Core/components/Loader":"6S7S4","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/fortiva/hooks/useUpdateOffer":"gF79z","Modules/fortiva/hooks/useGetApplication":"d6izJ","Modules/fortiva/hooks/useAccountLookup":"jC6BZ","Modules/fortiva/components/OtpInput":"jPaCx","Modules/fortiva/components/OfferTermsAndConditions":"e28DO","Modules/fortiva/config/constants":"lb4iD","Modules/fortiva/routes":"6CCT1","Modules/fortiva/utils/correctionStatus":"kl0of","./FinancingSummary":"3hq6Q","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gF79z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdateOffer);
var _reactQuery = require("react-query");
var _dateFns = require("date-fns");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _appConfig = require("Core/config/appConfig");
const FORTIVA_OFFER_DEFAULTS = {
    auto_pay: 'false',
    default_waived_interest: 'false',
    payment_date: 22
};
const FORTIVA_PRODUCT_DEFAULTS = {
    type: 'Medical Product',
    description: 'Hearing Aids',
    serial_number: null
};
function useUpdateOffer() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(({ offerId, additionalPayment, financingDownPayment, deliveryDate, processSale })=>{
        const { dateFormat } = (0, _appConfig.getAppConfig)();
        const isoDeliveryDate = (0, _dateFns.formatISO)((0, _dateFns.parse)(deliveryDate, dateFormat, new Date()), {
            representation: 'date'
        });
        const payload = {
            ...FORTIVA_OFFER_DEFAULTS,
            offer_id: offerId,
            process_sale: processSale,
            additional_payment: additionalPayment,
            financing_down_payment: financingDownPayment,
            products: [
                {
                    ...FORTIVA_PRODUCT_DEFAULTS,
                    delivery_date: isoDeliveryDate
                }
            ]
        };
        return (0, _platformApi.putWithHeaders)(`/financing/update-offer`, payload);
    }, {
        throwOnError: true,
        retry: 3,
        onSuccess: ()=>{
            queryClient.removeQueries((0, _cacheKeysDefault.default).financingNextStep);
            return queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
        }
    });
}

},{"react-query":"ksTpv","date-fns":[["formatISO","5S5YG","default"],["parse","jBRYJ","default"]],"Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/config/appConfig":"7qX5H","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jC6BZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAccountLookup);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function useAccountLookup() {
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    return (0, _reactQuery.useMutation)((customerIdentityNumber)=>(0, _platformApi.postWithHeaders)(`send-otp`, customerIdentityNumber ? {
            customer_identity_number: customerIdentityNumber
        } : {}, {
            headers: {
                external_reference_id: paymentInfo?.external_reference_id
            }
        }));
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jPaCx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OtpInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactI18Next = require("react-i18next");
var _icon = require("Core/components/Icon/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const OTP_LENGTH = 6;
const ALNUM = /^[A-Za-z0-9]$/;
const RESEND_COOLDOWN_SECONDS = 90;
const RESEND_TS_KEY = 'fortiva.otp.resendStartedAt';
const computeSecondsLeft = ()=>{
    const startedAt = Number(sessionStorage.getItem(RESEND_TS_KEY));
    if (!startedAt) return 0;
    const elapsed = Math.floor((Date.now() - startedAt) / 1000);
    return Math.max(0, RESEND_COOLDOWN_SECONDS - elapsed);
};
const sanitize = (str)=>(str || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, OTP_LENGTH);
function OtpInput({ value = '', onChange, maskedEmail = '', error = '', onResend, isResending = false }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const refs = (0, _reactDefault.default).useRef([]);
    const chars = value.padEnd(OTP_LENGTH, ' ').split('');
    const [secondsLeft, setSecondsLeft] = (0, _reactDefault.default).useState(computeSecondsLeft);
    const intervalRef = (0, _reactDefault.default).useRef(null);
    const startTicking = (0, _reactDefault.default).useCallback(()=>{
        if (intervalRef.current) return;
        intervalRef.current = setInterval(()=>{
            const left = computeSecondsLeft();
            setSecondsLeft(left);
            if (left <= 0 && intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }, 1000);
    }, []);
    // Resume the countdown after a page refresh (timestamp lives in sessionStorage).
    (0, _reactDefault.default).useEffect(()=>{
        if (computeSecondsLeft() > 0) startTicking();
        return ()=>{
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [
        startTicking
    ]);
    const handleResendClick = ()=>{
        if (isResending || secondsLeft > 0) return;
        sessionStorage.setItem(RESEND_TS_KEY, String(Date.now()));
        setSecondsLeft(RESEND_COOLDOWN_SECONDS);
        startTicking();
        onResend();
    };
    const resendDisabled = isResending || secondsLeft > 0;
    const setAt = (idx, next)=>{
        const merged = chars.slice();
        merged[idx] = next || ' ';
        onChange(sanitize(merged.join('')));
    };
    const handleChange = (idx)=>(e)=>{
            const raw = e.target.value;
            if (raw.length > 1) {
                const cleaned = sanitize(raw);
                onChange(cleaned);
                const focusIdx = Math.min(cleaned.length, OTP_LENGTH - 1);
                refs.current[focusIdx]?.focus();
                return;
            }
            if (raw === '' || ALNUM.test(raw)) {
                setAt(idx, raw.toUpperCase());
                if (raw && idx < OTP_LENGTH - 1) refs.current[idx + 1]?.focus();
            }
        };
    const handleKeyDown = (idx)=>(e)=>{
            if (e.key === 'Backspace' && !chars[idx].trim() && idx > 0) refs.current[idx - 1]?.focus();
            else if (e.key === 'ArrowLeft' && idx > 0) refs.current[idx - 1]?.focus();
            else if (e.key === 'ArrowRight' && idx < OTP_LENGTH - 1) refs.current[idx + 1]?.focus();
        };
    const handlePaste = (e)=>{
        e.preventDefault();
        const pasted = sanitize(e.clipboardData.getData('text'));
        onChange(pasted);
        const focusIdx = Math.min(pasted.length, OTP_LENGTH - 1);
        refs.current[focusIdx]?.focus();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "rounded-xl border border-slate-300 bg-gradient-to-br from-slate-50 to-blue-50/40 p-5",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                className: "!mt-0 !mb-1 text-sm font-bold text-gray-900 text-center",
                children: t('fortiva.finalize.otp.heading')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "!mt-0 !mb-3 text-xs text-gray-600 text-center",
                children: t('fortiva.finalize.otp.subheading', {
                    maskedEmail
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex gap-2",
                        children: Array.from({
                            length: OTP_LENGTH
                        }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                ref: (el)=>refs.current[i] = el,
                                value: chars[i].trim(),
                                maxLength: OTP_LENGTH,
                                inputMode: "text",
                                autoComplete: "one-time-code",
                                "data-testid": `otp-input-${i}`,
                                onChange: handleChange(i),
                                onKeyDown: handleKeyDown(i),
                                onPaste: handlePaste,
                                "aria-invalid": Boolean(error),
                                className: (0, _classnamesDefault.default)('w-10 h-12 text-center text-lg font-mono uppercase', 'border rounded', 'focus:outline-none focus:ring-2', error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-slate-300 focus:ring-fortiva-bg focus:border-fortiva-bg')
                            }, i))
                    }),
                    onResend && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                onClick: handleResendClick,
                                disabled: resendDisabled,
                                "data-testid": "otp-resend-button",
                                className: (0, _classnamesDefault.default)('inline-flex items-center gap-2 text-sm font-medium underline underline-offset-2', 'focus:outline-none focus:ring-2 focus:ring-fortiva-bg rounded', resendDisabled ? 'text-slate-400 cursor-not-allowed no-underline' : 'text-fortiva-bg hover:text-fortiva-bg/80 cursor-pointer'),
                                children: [
                                    isResending && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        type: "spinner",
                                        className: "!h-4 !w-4"
                                    }),
                                    secondsLeft > 0 ? t('fortiva.finalize.otp.resendCountdown', {
                                        seconds: secondsLeft,
                                        defaultValue: 'Re-send OTP in {{seconds}}s'
                                    }) : t('fortiva.finalize.otp.resend')
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "!mt-0 !mb-0 text-xs text-gray-500 text-center",
                                "data-testid": "otp-resend-note",
                                children: t('fortiva.finalize.otp.resendWaitNote', {
                                    defaultValue: 'Please wait a few minutes for the code to arrive before requesting a new one.'
                                })
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mt-2 text-xs text-red-600 text-center",
                role: "alert",
                "data-testid": "otp-input-error",
                children: error
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","react-i18next":"244ua","Core/components/Icon/Icon":"cAPHo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"e28DO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OfferTermsAndConditions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
const TERM_STATEMENTS = [
    'Do you acknowledge that you have received, reviewed, and agree to the Consent to Receive Electronic Disclosures from Fortiva?',
    'Do you acknowledge that you have received, reviewed, and agree to the Fortiva Application Disclosures? CA Residents: If married, you may apply for a separate account.',
    "Do you acknowledge that you have received, reviewed, and agree to the Cardholder Agreement that will govern your Fortiva\xae Retail Credit card?",
    'Do you confirm you are at least 18 years of age, that everything you stated is true and accurate, and that you do not presently have a petition filed under federal bankruptcy laws and do not anticipate filing one? If approved, do you agree to be bound by the Fortiva Cardholder Agreement and authorize The Bank of Missouri, its successors, assigns, and agents to investigate your creditworthiness and obtain a full credit report (hard inquiry) to open your account?'
];
function OfferTermsAndConditions({ value, onChange }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const toggle = (idx)=>(e)=>{
            const next = value.slice();
            next[idx] = e.target.checked;
            onChange(next);
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "rounded-xl border border-slate-300 bg-gradient-to-br from-slate-50 to-blue-50/40 p-5",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                className: "!mt-0 !mb-2 text-sm font-bold text-gray-900",
                children: t('fortiva.finalize.terms.heading')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "!mt-0 !mb-3 text-xs text-gray-700 leading-snug",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-bold text-gray-900",
                        children: "Consultant: "
                    }),
                    "Direct the customer to the Fortiva Retail Credit Offer Email and read each statement aloud to the customer and obtain their verbal consent before checking the box on their behalf."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: "space-y-3",
                children: TERM_STATEMENTS.map((statement, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        className: "flex items-start gap-2 text-xs text-gray-700 leading-snug",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "checkbox",
                                id: `fortiva-term-${idx + 1}`,
                                "data-testid": `fortiva-term-${idx + 1}`,
                                checked: Boolean(value[idx]),
                                onChange: toggle(idx),
                                className: "mt-1 w-4 h-4 shrink-0 border-gray-300 rounded cursor-pointer"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                htmlFor: `fortiva-term-${idx + 1}`,
                                className: "flex-1 cursor-pointer select-none",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "!my-0 text-gray-800",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-bold text-gray-900",
                                                children: "Read to customer: "
                                            }),
                                            "\u201C",
                                            statement,
                                            "\u201D"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-[11px] italic text-gray-400 mt-1",
                                        children: "Check this box to confirm the customer verbally consented."
                                    })
                                ]
                            })
                        ]
                    }, idx))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "mt-4 pt-3 border-t border-slate-200 text-[11px] italic text-gray-500 leading-snug",
                "data-testid": "monthly-payment-disclaimer",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": "true",
                        children: "*"
                    }),
                    "Based on your requested financing amount, your Estimated Initial Monthly Payment does not include payments for Promotional Financing plans. Minimum payments are based on your outstanding balance and may vary accordingly. Minimum payments will be due until you pay your balance in full. Interest will be charged to your account and included in your outstanding balance due."
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3hq6Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layout = require("Core/components/Layout");
var _dropdown = require("Core/components/Dropdown/Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _icon = require("Core/components/Icon/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _numberFormat = require("Core/utils/numberFormat");
var _utils = require("Core/utils/utils");
var _useGetTransactionHistory = require("Core/hooks/platform/useGetTransactionHistory");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _calcMonthlyPayment = require("Modules/fortiva/utils/calcMonthlyPayment");
var _constants = require("Modules/fortiva/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _reactQuery = require("react-query");
var _reactLocation = require("react-location");
var _button = require("Core/components/Button");
var _tooltip = require("Core/components/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _reactI18Next = require("react-i18next");
// Temporarily disabled: down payment is collected after the application is
// submitted, so the inline Collect Payment button is hidden for now.
const SHOW_COLLECT_PAYMENT_BUTTON = false;
function FinancingSummary({ routes, watch, application, setRefetchInterval, selectedOffer, onPrepareCollectPayment }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const navigate = (0, _reactLocation.useNavigate)();
    const [isCollectPaymentLoading, setIsCollectPaymentLoading] = (0, _reactDefault.default).useState(false);
    const { data: transactions } = (0, _useGetTransactionHistory.useGetTransactionHistory)();
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)() || {};
    const [receiptList, setReceiptList] = (0, _reactDefault.default).useState([]);
    const { next_action, payload: { already_paid_amount = 0, approval = 0, offers, selected_offer_id, down_payment_status } = {} } = application ?? {};
    const isDownPaymentPaid = down_payment_status === 'PAID';
    const priceInfo = application?.payload?.offer_term?.price;
    const amountToPay = Number(paymentInfo?.amount_to_pay) || 0;
    const downPayment = Number(watch('downPayment')) || 0;
    const selectedTermId = selected_offer_id || selectedOffer?.id;
    const financed = priceInfo?.financed ?? Math.max(amountToPay - downPayment, 0);
    const backendMonthly = Number(priceInfo?.monthly_payment);
    // min_payment_pct always wins when present; backend value and amortization are fallbacks.
    const monthlyPayment = (0, _calcMonthlyPayment.getEstimatedMonthlyPayment)({
        offers,
        selectedOfferId: selectedTermId,
        financed,
        backendMonthly
    });
    const availableCredit = Number(approval) || 0;
    const additionalCollectedAmount = downPayment - already_paid_amount;
    const handleUnload = (e)=>{
        const message = '';
        (e || window.event).returnValue = message;
        return message;
    };
    (0, _reactDefault.default).useEffect(()=>{
        if (transactions && transactions.length > 0) setReceiptList(transactions.map((item, idx, arr)=>{
            const receiptNum = arr.length === 1 ? '' : idx + 1;
            return {
                label: 'Receipt ' + receiptNum,
                key: item?.payment_id,
                url: item?.receipt?.url
            };
        }));
    }, [
        transactions
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (isDownPaymentPaid) setIsCollectPaymentLoading(false);
        if (next_action === 'DONE' || next_action === 'PENDING_DOWN_PAYMENT') navigate({
            to: routes.financing,
            search: true
        });
        return ()=>{
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, [
        isDownPaymentPaid,
        next_action,
        navigate,
        routes.financing
    ]);
    const onCollectPayment = async ()=>{
        setIsCollectPaymentLoading(true);
        try {
            await onPrepareCollectPayment();
        } catch  {
            setIsCollectPaymentLoading(false);
            return;
        }
        // Buffer before opening the payment URL so the backend has settled and we don't read stale data.
        await new Promise((resolve)=>{
            setTimeout(resolve, (0, _constantsDefault.default).UPDATE_OFFER_BUFFER_DELAY_MS);
        });
        const url = (0, _utils.generateURL)({
            url: routes.mixed
        });
        setRefetchInterval(5000);
        queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
        setTimeout(()=>setIsCollectPaymentLoading(false), 300000);
        window.open(url, '_blank')?.focus();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "text-center mb-4",
                children: t('common.summary')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-1 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-available-credit",
                        children: t('common.availableCredit')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2 ",
                        "data-testid": "value-available-credit",
                        children: availableCredit > 0 ? (0, _numberFormat.formatCurrency)(availableCredit) : '-'
                    })
                ]
            }),
            isDownPaymentPaid && additionalCollectedAmount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "items-center mx-0 flex-nowrap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-additional-collected-amount",
                        children: t('financing.additionalCollectedAmount')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                        className: "!flex-col-2 flex justify-end items-center px-2",
                        "data-testid": "value-additional-collected-amount",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                type: "success"
                            }),
                            (0, _numberFormat.formatCurrency)(additionalCollectedAmount)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-3 text-left",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                transactions && transactions.length === 1 && receiptList.map(({ url, key })=>{
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "bg-transparent text-primary hover:bg-gray-100 p-2 rounded text-sm",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "data-testid": "receipt-item",
                                        href: url,
                                        children: t('common.viewReceipt')
                                    }, key);
                                }),
                                receiptList && receiptList.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default), {
                                    label: t('common.viewReceipt'),
                                    list: receiptList
                                })
                            ]
                        })
                    })
                ]
            }),
            !isDownPaymentPaid && additionalCollectedAmount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "items-center mx-0  flex-nowrap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left font-semibold",
                        "data-testid": "label-amount-to-collect",
                        children: t('fortiva.finalize.summary.amountToBeCollected')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right flex justify-end items-center px-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-semibold",
                            "data-testid": "value-amount-to-collect",
                            children: (0, _numberFormat.formatCurrency)(additionalCollectedAmount)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-3 text-left",
                        children: SHOW_COLLECT_PAYMENT_BUTTON ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.TextButton), {
                            disabled: isCollectPaymentLoading,
                            onClick: onCollectPayment,
                            "data-testid": "btn-collect-payment",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex",
                                children: [
                                    isCollectPaymentLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "inline-block mr-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                            type: "spinner"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "!hidden lg:!block",
                                        children: t('financing.collectPayment')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "!block lg:!hidden",
                                        children: 'Collect'
                                    })
                                ]
                            })
                        }) : // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- hidden admin test shortcut, intentionally not exposed as an interactive control
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            "data-testid": "down-payment-info-tooltip",
                            onClick: (e)=>{
                                // Admin test shortcut: shift-click launches the collect-payment flow
                                // while the regular button is disabled.
                                if (e.shiftKey && !isCollectPaymentLoading) onCollectPayment();
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                content: t('fortiva.finalize.summary.downPaymentInfo', {
                                    defaultValue: 'Down payment can be processed after submitting the application'
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-4 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-total-down-payment",
                        children: t('financing.totalDownPayment')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2",
                        "data-testid": "value-total-down-payment",
                        children: (0, _numberFormat.formatCurrency)(watch('downPayment') || 0)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-1 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2 "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-funding-by-allegro",
                        children: t('fortiva.fundingByFortiva')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2",
                        "data-testid": "value-funding-by-allegro",
                        children: Number.isFinite(financed) ? (0, _numberFormat.formatCurrency)(financed, {
                            withDecimals: financed % 1 > 0
                        }) : '-'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "mb-1 mx-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-none lg:!flex-col-3 px-2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Column), {
                        className: "!flex-col-7 lg:!flex-col-4 px-2 text-left",
                        "data-testid": "label-monthly-payment",
                        children: [
                            "Estimated Initial Monthly Payment",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                "aria-hidden": "true",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex-col-2 text-right px-2 ",
                        "data-testid": "value-monthly-payment",
                        children: Number.isFinite(monthlyPayment) && monthlyPayment > 0 ? (0, _numberFormat.formatCurrency)(monthlyPayment, {
                            withDecimals: true
                        }) : '-'
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Layout":"hweet","Core/components/Dropdown/Dropdown":"g18oR","Core/components/Icon/Icon":"cAPHo","Core/utils/numberFormat":"6T56F","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetTransactionHistory":"3gwu1","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/fortiva/utils/calcMonthlyPayment":"8i0iH","Modules/fortiva/config/constants":"lb4iD","Core/hooks/queries/cacheKeys":"i5IL7","react-query":"ksTpv","react-location":"8hNco","Core/components/Button":"6YNzH","Core/components/Tooltip":"ew5TJ","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8i0iH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSelectedTerm", ()=>getSelectedTerm);
parcelHelpers.export(exports, "calcMonthlyPayment", ()=>calcMonthlyPayment);
parcelHelpers.export(exports, "getEstimatedMonthlyPayment", ()=>getEstimatedMonthlyPayment);
function getSelectedTerm(offers, selectedOfferId) {
    const installments = offers?.installment || [];
    if (selectedOfferId) for (const installment of installments){
        const match = (installment?.terms || []).find((t)=>t?.id === selectedOfferId);
        if (match) return match;
    }
    if (installments.length === 1 && (installments[0]?.terms || []).length === 1) return installments[0].terms[0];
    return null;
}
function calcMonthlyPayment({ principal, apr, termMonths }) {
    const P = Number(principal) || 0;
    const n = Number(termMonths) || 0;
    const r = (Number(apr) || 0) / 100 / 12;
    if (P <= 0 || n <= 0) return 0;
    if (r === 0) return P / n;
    const factor = Math.pow(1 + r, n);
    return P * r * factor / (factor - 1);
}
function getEstimatedMonthlyPayment({ offers, selectedOfferId, financed, backendMonthly }) {
    const term = getSelectedTerm(offers, selectedOfferId);
    // Fortiva is revolving credit: the estimated initial minimum monthly payment is
    // the financed amount multiplied by the offer's minimum payment factor (a percent).
    // This always wins when present; everything below is fallback.
    const minPaymentPct = Number(term?.fees?.min_payment_pct);
    if (minPaymentPct > 0) return (Number(financed) || 0) * (minPaymentPct / 100);
    // Fallback 1: a value computed by the backend.
    const backend = Number(backendMonthly);
    if (backend > 0) return backend;
    if (!term) return null;
    // Fallback 2: promo monthly premium.
    const promoMonthly = Number(term?.promo?.monthly_premium);
    if (promoMonthly > 0) return promoMonthly;
    // Last resort: amortize over the fixed term.
    const apr = Number(term.apr_max) || Number(term.apr) || 0;
    return calcMonthlyPayment({
        principal: financed,
        apr,
        termMonths: term.term
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ce36X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateAchModal);
var _jsxRuntime = require("react/jsx-runtime");
var _alert = require("Core/components/Alert");
var _button = require("Core/components/Button");
var _layout = require("Core/components/Layout");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function UpdateAchModal({ isModalOpen, onModalClose, onModalConfirm }) {
    const handleConfirm = (e)=>{
        if (onModalConfirm) onModalConfirm(e);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
        isOpen: isModalOpen,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "font-bold text-center",
                children: "Add ACH?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "p-6 text-center",
                "data-testid": "title-autopay-redirect",
                children: "You can update the payment method to potentially lower your APR. Do you want to navigate to the Allegro portal to update it?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                    type: "shade",
                    "data-testid": "note-autopay-redirect",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: "Note: "
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            children: [
                                "If you click on ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                    className: "font-bold",
                                    children: "Add AutoPay"
                                }),
                                " you will be redirected to the Allegro portal. Please add ACH information and return to this page thereafter."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-end justify-end gap-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                        type: "button",
                        onClick: onModalClose,
                        "data-testid": "btn-skip-autopay",
                        children: "Skip Autopay and Finalize Contract"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                        type: "button",
                        onClick: handleConfirm,
                        "data-testid": "btn-add-autopay",
                        children: "Add AutoPay"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","Core/components/Alert":"fmmNR","Core/components/Button":"6YNzH","Core/components/Layout":"hweet","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ivfCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectOffer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _financingNotEligible = require("Modules/fortiva/components/FinancingNotEligible");
var _financingNotEligibleDefault = parcelHelpers.interopDefault(_financingNotEligible);
var _offerAgreement = require("Modules/fortiva/components/OfferAgreement");
var _offerAgreementDefault = parcelHelpers.interopDefault(_offerAgreement);
function SelectOffer({ offers, selectedOffer, setSelectedOffer, enableSignContract, navigateToFinalizeTab, amount_to_pay, already_paid_amount, approval, routes, selected_offer_id, downPayment = 0, onBack }) {
    const installment = offers?.installment?.[0];
    const offerType = installment?.type || '';
    const term = installment?.terms?.[0] || {};
    const { id, require_downpayment_percent = 0 } = term;
    const downPaymentValue = Number(downPayment) || 0;
    const financedAmount = Math.max(amount_to_pay - already_paid_amount - downPaymentValue, 0);
    const isEligible = Boolean(id) && financedAmount > 0;
    const isSelected = selectedOffer?.id === id;
    const installmentList = offers?.installment || [];
    const isSingleOffer = installmentList.length === 1 && (installmentList[0]?.terms || []).length === 1;
    (0, _reactDefault.default).useEffect(()=>{
        if (!id) return;
        const matchesPersisted = selected_offer_id && selected_offer_id === id;
        if (!matchesPersisted && !isSingleOffer) return;
        setSelectedOffer({
            id,
            require_downpayment_percent,
            type: offerType
        });
    }, [
        id,
        selected_offer_id,
        require_downpayment_percent,
        offerType,
        setSelectedOffer,
        isSingleOffer
    ]);
    const handleSelectOffer = ()=>{
        if (!isSelected) setSelectedOffer({
            id,
            require_downpayment_percent,
            type: offerType
        });
        navigateToFinalizeTab?.();
    };
    if (!installment) return null;
    if (!isEligible && !enableSignContract) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex justify-center flex-wrap",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingNotEligibleDefault.default), {
            already_paid_amount: already_paid_amount,
            amount_to_pay: amount_to_pay,
            routes: routes,
            exceedsCreditLimit: false,
            approval: approval,
            financedAmount: financedAmount
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offerAgreementDefault.default), {
        installment: installment,
        amount_to_pay: amount_to_pay,
        already_paid_amount: already_paid_amount,
        downPayment: downPaymentValue,
        approval: approval,
        isSelected: isSelected,
        onSelectOffer: handleSelectOffer,
        onBack: onBack,
        canSelect: enableSignContract || isEligible
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/fortiva/components/FinancingNotEligible":"a3nHt","Modules/fortiva/components/OfferAgreement":"aA1IN","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"a3nHt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingNotEligible);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _numberFormat = require("Core/utils/numberFormat");
var _layout = require("Core/components/Layout");
var _utils = require("Core/utils/utils");
var _alert = require("Core/components/Alert");
var _button = require("Core/components/Button");
function AmountRow({ label, value, highlight }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center justify-between border-b border-gray-200 py-2 last:border-b-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-gray-700",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: highlight ? 'font-bold text-primary' : 'font-semibold',
                children: (0, _numberFormat.formatCurrency)(value)
            })
        ]
    });
}
function ExceedsCreditLimitContent({ approval, financedAmount }) {
    const differenceToPay = Math.max(financedAmount - Number(approval), 0);
    const amountLeftToFinance = Number(approval);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
        showIcon: true,
        type: "warningLight",
        title: "approved amount too low",
        "data-testid": "message-exceeds-credit-limit",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "font-bold mb-2",
                children: "Approved credit is lower than the financing amount"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mb-3",
                children: "Good news \u2014 your application is approved! However, the approved credit limit doesn't fully cover the amount you wanted to finance."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "bg-white rounded-md p-3 my-3 border border-gray-200",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmountRow, {
                        label: "Total amount to be financed",
                        value: financedAmount
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmountRow, {
                        label: "Approved credit limit",
                        value: amountLeftToFinance
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(AmountRow, {
                        label: "Balance to pay by credit card",
                        value: differenceToPay,
                        highlight: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "mt-3",
                children: [
                    "You can pay the balance of",
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-bold",
                        children: (0, _numberFormat.formatCurrency)(differenceToPay)
                    }),
                    " using a credit card, and proceed with financing for the remaining",
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-bold",
                        children: (0, _numberFormat.formatCurrency)(amountLeftToFinance)
                    }),
                    "."
                ]
            })
        ]
    });
}
function FinancingTooLowContent({ already_paid_amount, amount_to_pay }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
        showIcon: true,
        type: "warningLight",
        title: "correction required",
        "data-testid": "message-not-eligible",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "font-bold",
                children: "Financing amount too low!"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "Your application is approved. However, you have an available credit of\xa0"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "font-bold",
                children: [
                    "(",
                    (0, _numberFormat.formatCurrency)(already_paid_amount),
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "\xa0so the amount to be financed\xa0"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "font-bold",
                children: [
                    "(",
                    (0, _numberFormat.formatCurrency)(amount_to_pay - already_paid_amount),
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "\xa0is lower than the minimum eligible amount that can be financed. You can click on the button below to complete the remaining amount instead of financing it."
            })
        ]
    });
}
function FinancingNotEligible({ already_paid_amount, amount_to_pay, exceedsCreditLimit, approval, financedAmount, routes }) {
    const [isModalOpen, setIsModalOpen] = (0, _reactDefault.default).useState(false);
    const onOpenConfirmationPopup = ()=>{
        setIsModalOpen(true);
    };
    const onCollectPayment = ()=>{
        const url = (0, _utils.generateURL)({
            url: routes?.payment
        });
        window.open(url, '_self');
    };
    const onModalClose = ()=>{
        setIsModalOpen(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: "justify-center flex-col items-center w-full",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "font-regular text-large w-full",
                        children: exceedsCreditLimit ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExceedsCreditLimitContent, {
                            approval: approval,
                            financedAmount: financedAmount
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(FinancingTooLowContent, {
                            already_paid_amount: already_paid_amount,
                            amount_to_pay: amount_to_pay
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "text-center text-gray-400 w-1/3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            "data-testid": "btn-collect-payment",
                            block: true,
                            onClick: onOpenConfirmationPopup,
                            children: exceedsCreditLimit ? 'Pay Balance & Continue' : 'Collect Payment'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Modal), {
                isOpen: isModalOpen,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "font-bold text-center",
                        children: "Are you sure you want to proceed to Payment Collection?"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-6 text-center",
                        "data-testid": "title-autopay-redirect",
                        children: "You will leave the financing application and be redirected to the payment collection portal"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-end justify-end gap-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                                type: "button",
                                onClick: onModalClose,
                                "data-testid": "btn-modal-cancel",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                type: "button",
                                onClick: onCollectPayment,
                                "data-testid": "btn-modal-confirm",
                                children: "Confirm"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/utils/numberFormat":"6T56F","Core/components/Layout":"hweet","Core/utils/utils":"hwOBZ","Core/components/Alert":"fmmNR","Core/components/Button":"6YNzH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aA1IN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OfferAgreement);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _fa = require("react-icons/fa");
var _reactI18Next = require("react-i18next");
var _richTextDescriptionItem = require("Core/components/RichTextDescriptionItem");
var _richTextDescriptionItemDefault = parcelHelpers.interopDefault(_richTextDescriptionItem);
var _button = require("Core/components/Button");
var _numberFormat = require("Core/utils/numberFormat");
const formatPercent = (value, fractionDigits = 2)=>{
    if (value === null || Number.isNaN(Number(value))) return "\u2014";
    return `${Number(value).toFixed(fractionDigits)}%`;
};
const formatMoney = (value)=>{
    if (value === null || Number.isNaN(Number(value))) return "\u2014";
    return (0, _numberFormat.formatCurrency)(value, {
        withDecimals: true
    });
};
const AgreementSection = ({ title, children })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: "py-3 border-t border-slate-200 first:border-t-0 first:pt-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "!mt-0 !mb-2 text-xs font-bold uppercase tracking-[0.18em] text-gray-500",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dl", {
                className: "divide-y divide-slate-100",
                children: children
            })
        ]
    });
const AgreementRow = ({ label, value, sublabel, emphasize = false, testId })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex justify-between items-start py-1.5 gap-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dt", {
                className: "text-sm text-gray-700 max-w-[60%] leading-snug",
                children: [
                    label,
                    sublabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-xs text-gray-400 mt-0.5 leading-snug",
                        children: sublabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                className: (0, _classnamesDefault.default)('text-right whitespace-nowrap', emphasize ? 'text-sm font-bold text-gray-900' : 'text-sm font-semibold text-gray-800'),
                "data-testid": testId,
                children: value
            })
        ]
    });
function OfferAgreement({ installment, amount_to_pay, already_paid_amount, downPayment = 0, approval, isSelected, onSelectOffer, onBack, canSelect }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { program = 'Fortiva', type = '', rich_text_descriptions: richTextDescriptions, terms = [] } = installment || {};
    const term = terms[0] || {};
    const { id, apr, waived_interest: waivedInterest, fees } = term;
    const { annual_fee = 0 } = fees || {};
    const { days: waivedDays = 0, text: waivedText = '' } = waivedInterest || {};
    const hasWaivedInterest = Number(waivedDays) > 0 || Boolean(waivedText);
    const downPaymentValue = Number(downPayment) || 0;
    const financedAmount = Math.max(amount_to_pay - already_paid_amount - downPaymentValue, 0);
    const today = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "w-full max-w-3xl mx-auto mt-3 mb-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
            className: (0, _classnamesDefault.default)('bg-white rounded-lg border shadow-md overflow-hidden', isSelected ? 'border-fortiva-bg ring-1 ring-fortiva-bg' : 'border-slate-300'),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                    className: "bg-slate-50 border-b border-slate-200 px-6 py-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-start justify-between gap-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center text-gray-500 text-xs uppercase tracking-[0.2em] font-semibold",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaFileContract), {
                                                className: "mr-2"
                                            }),
                                            "Credit Agreement"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                        className: "!mt-0.5 !mb-0.5 text-xl font-serif font-bold text-gray-900",
                                        "data-testid": "agreement-title",
                                        children: [
                                            program,
                                            " Personal Credit Account"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "!mb-0 text-xs text-gray-500 leading-snug",
                                        children: "Congratulations, you're prequalified for a Fortiva Retail Credit revolving credit card issued by The Bank of Missouri, Perryville, MO. You should have received an offer email that summarizes the terms and conditions of your account and includes a unique offer code."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "text-right text-xs text-gray-500 shrink-0 leading-snug",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "uppercase tracking-wider font-semibold text-gray-400",
                                                children: "Reference"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "text-gray-700 font-mono",
                                                "data-testid": "agreement-ref",
                                                children: [
                                                    "#",
                                                    id || "\u2014"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mt-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "uppercase tracking-wider font-semibold text-gray-400",
                                                children: "Issued"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-gray-700",
                                                children: today
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "px-6 py-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AgreementSection, {
                            title: "Account Summary",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementRow, {
                                    label: "Lender",
                                    value: program
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementRow, {
                                    label: "Account Type",
                                    value: type || "\u2014",
                                    testId: "agreement-type"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementRow, {
                                    label: "Approved Credit Limit",
                                    value: formatMoney(approval),
                                    emphasize: true,
                                    testId: "agreement-credit-limit"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementSection, {
                            title: "Interest Rates and Charges",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementRow, {
                                label: "Annual Percentage Rate (APR)",
                                sublabel: "Applies to all balances unless a promotional rate is in effect.",
                                value: formatPercent(apr),
                                emphasize: true,
                                testId: "agreement-apr"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementSection, {
                            title: "Fee Schedule",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementRow, {
                                label: "Annual Fee",
                                value: formatMoney(annual_fee)
                            })
                        }),
                        hasWaivedInterest && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AgreementSection, {
                            title: "Promotional Terms",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementRow, {
                                    label: "Waived Interest Period",
                                    value: waivedDays ? `${waivedDays} days` : "\u2014"
                                }),
                                waivedText && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "py-1.5 text-xs text-gray-600 italic leading-snug",
                                    children: waivedText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AgreementSection, {
                            title: "Transaction Summary",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementRow, {
                                    label: "Total Purchase Amount",
                                    value: formatMoney(amount_to_pay),
                                    testId: "agreement-purchase-amount"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementRow, {
                                    label: "Already Paid",
                                    value: formatMoney(already_paid_amount)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementRow, {
                                    label: "Down Payment",
                                    value: formatMoney(downPaymentValue),
                                    testId: "agreement-down-payment"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementRow, {
                                    label: "Amount to be Financed",
                                    value: formatMoney(financedAmount),
                                    emphasize: true,
                                    testId: "agreement-financed-amount"
                                })
                            ]
                        }),
                        Array.isArray(richTextDescriptions) && richTextDescriptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(AgreementSection, {
                            title: "Additional Disclosures",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                className: "pt-1",
                                children: richTextDescriptions.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richTextDescriptionItemDefault.default), {
                                        id: item.id,
                                        iconName: item.icon_name,
                                        title: item.title,
                                        text: item.text
                                    }, item.id))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("footer", {
                    className: "bg-slate-50 border-t border-slate-200 px-6 py-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-xs text-gray-500 leading-snug mb-3",
                            children: [
                                "By selecting this offer, you acknowledge that you have reviewed the terms listed above, including the Annual Percentage Rate, fee schedule, and repayment obligations, and you wish to proceed with this ",
                                program,
                                " credit account. Final acceptance requires signing the full disclosure in the next step."
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center justify-between flex-wrap gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex items-center text-sm text-gray-600",
                                    children: isSelected ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaCheckCircle), {
                                                className: "text-green-500 mr-2"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-medium",
                                                children: "Offer selected. Continue to the next step."
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Review the terms above, then select the offer to continue."
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        onBack && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.OutlineButton), {
                                            "data-testid": "btn-select-offer-back",
                                            className: "w-32",
                                            onClick: onBack,
                                            children: t('fortiva.back')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                            "data-testid": "btn-select-offer",
                                            disabled: !canSelect,
                                            className: "w-48",
                                            onClick: onSelectOffer,
                                            children: t('fortiva.continue')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","classnames":"f971Y","react-icons/fa":"9Vrsi","react-i18next":"244ua","Core/components/RichTextDescriptionItem":"iD9M8","Core/components/Button":"6YNzH","Core/utils/numberFormat":"6T56F","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eoIyg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactLocation = require("react-location");
var _canvasConfetti = require("canvas-confetti");
var _canvasConfettiDefault = parcelHelpers.interopDefault(_canvasConfetti);
var _routes = require("Modules/fortiva/routes");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _numberFormat = require("Core/utils/numberFormat");
var _logger = require("Core/utils/logger");
var _useGetNextStep = require("../hooks/useGetNextStep");
var _useGetCustomerInfo = require("../hooks/useGetCustomerInfo");
var _useGetCustomerInfoDefault = parcelHelpers.interopDefault(_useGetCustomerInfo);
var _financingPendingDownPayment = require("../components/FinancingPendingDownPayment");
var _financingPendingDownPaymentDefault = parcelHelpers.interopDefault(_financingPendingDownPayment);
var _financingSuccessCss = require("./FinancingSuccess.css");
const DATA = {
    amount: 1249.0
};
const CheckCircleIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "m9 12 2 2 4-4"
            })
        ]
    });
const ReceiptIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M12 17.5v-11"
            })
        ]
    });
const CreditCardIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "5",
                rx: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                x1: "2",
                x2: "22",
                y1: "10",
                y2: "10"
            })
        ]
    });
const RefreshIcon = ({ className = '' })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M21 12a9 9 0 1 1-2.64-6.36"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M21 3v6h-6"
            })
        ]
    });
// Statuses this success screen is responsible for rendering. Anything else
// (e.g. a refund surfacing as a RETURN_* status) should go back through
// FinancingRedirect so it can route to the right place.
const HANDLED_ACTIONS = [
    'DONE',
    'FUND_APPLICATION',
    'PENDING_DOWN_PAYMENT'
];
const ClockHoldIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M12 6v6l3 2"
            })
        ]
    });
const Row = ({ label, value })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "fs-row",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "fs-row__label",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "fs-row__value",
                children: value
            })
        ]
    });
const formatDate = (d = new Date())=>{
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${mm}/${dd}/${d.getFullYear()}`;
};
const fireConfetti = ()=>{
    const colors = [
        '#10b981',
        '#34d399',
        '#6ee7b7',
        '#fde68a',
        '#ffffff'
    ];
    (0, _canvasConfettiDefault.default)({
        particleCount: 120,
        spread: 80,
        startVelocity: 45,
        origin: {
            x: 0.5,
            y: 0.1
        },
        colors
    });
    setTimeout(()=>{
        (0, _canvasConfettiDefault.default)({
            particleCount: 60,
            angle: 60,
            spread: 55,
            origin: {
                x: 0,
                y: 0.3
            },
            colors
        });
        (0, _canvasConfettiDefault.default)({
            particleCount: 60,
            angle: 120,
            spread: 55,
            origin: {
                x: 1,
                y: 0.3
            },
            colors
        });
    }, 250);
};
const FinancingSuccess = ()=>{
    document.title = 'Financing Approved';
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactLocation.useNavigate)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const [refetchInterval, setRefetchInterval] = (0, _reactDefault.default).useState(false);
    const confettiFiredRef = (0, _reactDefault.default).useRef(false);
    const { data: application, isSuccess: isGetNextStepSuccess, refetch, isFetching } = (0, _useGetNextStep.useGetNextStep)(refetchInterval);
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const { data: customerInfo, isFetching: isCustomerFetching } = (0, _useGetCustomerInfoDefault.default)();
    const { next_action, external_reference_id = '', payload: { payment_id = '', application_id = '', financing_down_payment = 0, additional_payment = 0, application_status = '' } = {} } = application || {};
    const isPendingDownPayment = next_action === 'PENDING_DOWN_PAYMENT';
    const isFullyComplete = next_action === 'DONE';
    // Show the "Funds on Hold" section while funding the application or whenever
    // the application is held — including alongside a pending down payment.
    const isFundApplication = !isFullyComplete && (next_action === 'FUND_APPLICATION' || application_status === 'Held');
    // Hide the name until the fresh customer-search has settled, so a stale name is never shown.
    const firstName = isCustomerFetching ? '' : customerInfo?.first_name;
    const customerName = isCustomerFetching ? '' : [
        customerInfo?.first_name,
        customerInfo?.last_name
    ].filter(Boolean).join(' ').trim();
    const amount = Number(paymentInfo?.amount_to_pay) || DATA.amount;
    // Same derivation as the finalize summary: backend-computed financed amount,
    // falling back to the total minus the down payment.
    const financedAmount = Number(application?.payload?.offer_term?.price?.financed ?? Math.max(amount - (Number(additional_payment) || 0), 0));
    const formattedAmount = (0, _numberFormat.formatCurrency)(financedAmount, {
        withDecimals: true
    });
    const dateStr = formatDate(new Date());
    // Flush any previously-cached customer-search result so the success screen
    // always refetches fresh and never renders a stale name from a prior application.
    (0, _reactDefault.default).useEffect(()=>{
        queryClient.removeQueries([
            (0, _cacheKeysDefault.default).financingCustomerInfo
        ]);
    }, [
        queryClient
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (confettiFiredRef.current) return;
        if (typeof window === 'undefined') return;
        confettiFiredRef.current = true;
        const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        if (reduced) return;
        fireConfetti();
    }, []);
    (0, _reactDefault.default).useEffect(()=>{
        if (isFundApplication) setRefetchInterval(5000);
    }, [
        isFundApplication
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (isFullyComplete) {
            setRefetchInterval(false);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).transactionHistory);
        }
    }, [
        isFullyComplete,
        queryClient
    ]);
    // If a manual refresh reveals the status has moved on from what this screen
    // handles (e.g. a refund), hand back to FinancingRedirect to re-route.
    (0, _reactDefault.default).useEffect(()=>{
        if (next_action && !HANDLED_ACTIONS.includes(next_action)) navigate({
            to: (0, _routes.createFinancingPath),
            search: true
        });
    }, [
        next_action,
        navigate
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetNextStepSuccess && payment_id && application_id && external_reference_id) (0, _logger.postLogMessage)({
            feature: (0, _logger.features).financingSignContract,
            action: (0, _logger.actions).financingSuccessScreenDisplayed,
            payment_id,
            application_id,
            external_reference_id
        });
    }, [
        isGetNextStepSuccess,
        payment_id,
        application_id,
        external_reference_id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "fortiva",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "fs-shell relative",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    onClick: ()=>refetch(),
                    disabled: isFetching,
                    title: "Refresh status",
                    "aria-label": "Refresh status",
                    "data-testid": "refresh-status-button",
                    className: "absolute top-3 right-3 z-10 p-1 text-gray-400 hover:text-gray-600 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-gray-300 rounded",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RefreshIcon, {
                        className: `h-4 w-4 ${isFetching ? 'animate-spin' : ''}`
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "fs-hero fs-anim-fade",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "fs-hero__icon-wrap",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "fs-hero__halo",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "fs-hero__ping",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "fs-hero__icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckCircleIcon, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "fs-hero__title",
                            children: firstName ? `Congratulations ${firstName}!` : 'Congratulations!'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "fs-hero__subtext",
                            children: "Your financing application has been approved. A summary of your transaction is below."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "fs-hero__disclaimer",
                            children: "This receipt constitutes future delivery of goods or services that will be provided. You will receive your final receipt once your delivery has been received or services rendered."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "fs-hero__date",
                            children: [
                                "Date: ",
                                dateStr
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "fs-section fs-anim-scale",
                    "data-testid": "payment-summary",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                            className: "fs-section__head",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "fs-section__icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CreditCardIcon, {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "fs-section__title",
                                    children: "Payment Summary"
                                })
                            ]
                        }),
                        customerName && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Row, {
                            label: "Account Holder's Name",
                            value: customerName
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "fs-section__paragraph",
                            children: [
                                "As you agreed, the above transaction, in the amount of",
                                ' ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: formattedAmount
                                }),
                                ", will be financed by your Fortiva Retail Credit Account in accordance with the Terms and Conditions previously provided to you."
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                            className: "fs-section__divider"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                            className: "fs-section__head fs-section__head--sub",
                            "data-testid": "transaction-summary",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "fs-section__icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReceiptIcon, {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "fs-section__title",
                                    children: "Transaction Summary"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Row, {
                            label: "Transaction Date",
                            value: dateStr
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                            className: "fs-sep"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Row, {
                            label: "Transaction Amount (Debit)",
                            value: formattedAmount
                        }),
                        isPendingDownPayment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingPendingDownPaymentDefault.default), {
                            amount: financing_down_payment,
                            setRefetchInterval: setRefetchInterval
                        }),
                        isFundApplication && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "fs-warning-block",
                            "data-testid": "funds-on-hold",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                                    className: "fs-section__head fs-section__head--sub",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "fs-section__icon",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockHoldIcon, {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "fs-section__heading",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "fs-eyebrow",
                                                    children: "Pending Release"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "fs-section__title",
                                                    children: "Funds on Hold Until Delivery"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "fs-section__paragraph",
                                    children: [
                                        "Your financing amount of ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: formattedAmount
                                        }),
                                        " has been authorized and is currently being held. Funds will be released to the provider once your product has been delivered or your services have been rendered."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = FinancingSuccess;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","react-location":"8hNco","canvas-confetti":"gv1mE","Modules/fortiva/routes":"6CCT1","Core/components/Page":"4xeqH","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Core/utils/numberFormat":"6T56F","Core/utils/logger":"cWDKQ","../hooks/useGetNextStep":"38IW2","../hooks/useGetCustomerInfo":"8vgWF","../components/FinancingPendingDownPayment":"e5dSg","./FinancingSuccess.css":"f0qbM","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"e5dSg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingPendingDownPayment);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _numberFormat = require("Core/utils/numberFormat");
var _utils = require("Core/utils/utils");
var _routes = require("Modules/fortiva/routes");
const WalletIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M19 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0 0 4h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M16 12h.01"
            })
        ]
    });
const SpinnerIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: "fs-spin",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M21 12a9 9 0 1 1-6.219-8.56"
        })
    });
function FinancingPendingDownPayment({ amount = 0, setRefetchInterval }) {
    const queryClient = (0, _reactQuery.useQueryClient)();
    const [isCollectPaymentLoading, setIsCollectPaymentLoading] = (0, _reactDefault.default).useState(false);
    // Same collect-payment behavior as the finalize screen, but without the
    // update-offer call — the offer is already finalized at this point, so we
    // only open the down-payment checkout in a new tab.
    const onCollectPayment = ()=>{
        setIsCollectPaymentLoading(true);
        const url = (0, _utils.generateURL)({
            url: (0, _routes.mixedDownPaymentCheckoutPath)
        });
        setRefetchInterval?.(5000);
        queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
        setTimeout(()=>setIsCollectPaymentLoading(false), 300000);
        window.open(url, '_blank')?.focus();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "fs-warning-block",
        "data-testid": "pending-down-payment",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                className: "fs-section__head fs-section__head--sub",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "fs-section__icon",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(WalletIcon, {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "fs-section__heading",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "fs-eyebrow",
                                children: "Action Required"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "fs-section__title",
                                children: "Down Payment Pending"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "fs-section__paragraph",
                children: [
                    "A down payment of",
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        "data-testid": "value-pending-down-payment",
                        children: (0, _numberFormat.formatCurrency)(amount, {
                            withDecimals: true
                        })
                    }),
                    ' ',
                    "still needs to be collected to complete this transaction."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: "fs-collect-btn",
                onClick: onCollectPayment,
                disabled: isCollectPaymentLoading,
                "data-testid": "btn-collect-down-payment",
                children: [
                    isCollectPaymentLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SpinnerIcon, {}),
                    "Collect Payment"
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/numberFormat":"6T56F","Core/utils/utils":"hwOBZ","Modules/fortiva/routes":"6CCT1","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"f0qbM":[function() {},{}],"bilPz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingApproved);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _column = require("Core/components/Layout/Column");
var _columnDefault = parcelHelpers.interopDefault(_column);
function FinancingApproved() {
    document.title = 'Payment Portal - Application Approved';
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "fortiva",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
            className: "justify-center text-center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
                    className: "justify-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "font-regular",
                        "data-testid": "title-finance-approved",
                        children: t('common.newApplication')
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
                    className: "justify-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _columnDefault.default), {
                            className: "text-center p-7 font-extralight text-2xl",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "mr-4",
                                    children: "\u2705"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    "data-testid": "message-finance-approved",
                                    children: t('financing.applicationApproved')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "md:!flex-col-4 text-center text-gray-400",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: t('common.closeWindow')
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react":"2o0ib","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Layout/Row":"8YqFQ","Core/components/Layout/Column":"hnQnj","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4B58m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReturnTracking);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _paperworkSvg = require("url:Images/illustrations/paperwork.svg");
var _paperworkSvgDefault = parcelHelpers.interopDefault(_paperworkSvg);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _fa = require("react-icons/fa");
function ReturnTracking({ nextAction }) {
    document.title = 'Payment Portal - Financing';
    const { t } = (0, _reactI18Next.useTranslation)();
    (0, _useScrollTop.useScrollTop)();
    const [steps, setSteps] = (0, _reactDefault.default).useState([
        {
            id: 'RETURN_REQUESTED',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_PROCESSING',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_APPROVED',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_COMPLETE',
            isHidden: false,
            isActive: false,
            isComplete: false
        },
        {
            id: 'RETURN_CANCELED',
            isHidden: true,
            isActive: false,
            isComplete: false
        }
    ]);
    const [activeStep, setActiveStep] = (0, _reactDefault.default).useState({});
    (0, _reactDefault.default).useEffect(()=>{
        setSteps((currentSteps)=>{
            const tempSteps = [
                ...currentSteps
            ];
            const activeStepIndex = tempSteps.findIndex((step)=>step.id === nextAction);
            tempSteps.forEach((step, idx)=>{
                if (step.id === 'RETURN_COMPLETE' || step.id === 'RETURN_APPROVED') step.isHidden = nextAction === 'RETURN_CANCELED';
                if (step.id === 'RETURN_CANCELED') step.isHidden = nextAction !== 'RETURN_CANCELED';
                if (idx === activeStepIndex) {
                    step.isActive = true;
                    step.isHidden = false;
                    step.isComplete = false;
                } else if (idx < activeStepIndex) {
                    step.isActive = false;
                    step.isComplete = true;
                } else {
                    step.isActive = false;
                    step.isComplete = false;
                }
            });
            return tempSteps;
        });
    }, [
        nextAction,
        setActiveStep
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setActiveStep(steps.find((step)=>step.isActive));
    }, [
        steps
    ]);
    function StepIcon({ id, isActive, isComplete }) {
        if (isComplete) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaCheck), {
            color: "white"
        });
        else if (isActive) {
            if (id === 'RETURN_CANCELED') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaExclamation), {
                color: "white"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaCheck), {
                color: "white"
            });
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: "Financing",
        withStepProgress: false,
        stickyFooter: true,
        branding: "fortiva",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
            className: "justify-center mt-8",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "p-8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        "data-testid": "step-progress-container",
                        className: "flex flex-nowrap justify-between mb-4 p-0",
                        children: steps.filter((s)=>!s.isHidden).map(({ id, isActive, isComplete })=>{
                            const testid = isActive ? `step-progress-active` : `step-progress`;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _classnamesDefault.default)("flex flex-col items-center justify-center relative w-full text-sm whitespace-nowrap before:content-[''] before:border-t-2 before:border-gray-300 before:absolute before:[right:calc(50%_+_15px)] before:[top:15px] before:[width:calc(100%_-_30px)] first-of-type:before:border-0 before:border-solid"),
                                "data-testid": `return-step-${id}`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _classnamesDefault.default)('border-2 border-solid border-gray-300 rounded-full flex justify-center items-center font-bold [height:30px] [width:30px] [line-height:26px]', {
                                            'bg-green-700 text-white': id !== 'RETURN_CANCELED' && isActive,
                                            'bg-gray-200': !isActive && !isComplete,
                                            'bg-green-400': isComplete,
                                            'bg-red-500': id === 'RETURN_CANCELED'
                                        }),
                                        "data-testid": testid,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepIcon, {
                                            id: id,
                                            isActive: isActive,
                                            isComplete: isComplete
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        "data-testid": "step-label",
                                        className: (0, _classnamesDefault.default)('hidden sm:flex mt-4 text-sm md:text-lg', {
                                            'font-semibold': isActive,
                                            ' font-extralight': !isActive
                                        }),
                                        children: t(`page.financing.${id}.title`)
                                    })
                                ]
                            }, id);
                        })
                    }),
                    activeStep && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col items-center w-100",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "mt-6",
                                alt: "application-declined",
                                width: "150em",
                                src: (0, _paperworkSvgDefault.default)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "mt-8 text-2xl",
                                children: t(`page.financing.${nextAction}.title`)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mt-4 text-regular text-gray-500",
                                children: t(`page.financing.${nextAction}.description`)
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"9x2lT","classnames":"f971Y","react":"2o0ib","url:Images/illustrations/paperwork.svg":"9Iyib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","react-icons/fa":"9Vrsi","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bKm9s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingStatusMessage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _column = require("Core/components/Layout/Column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _paperworkSvg = require("url:Images/illustrations/paperwork.svg");
var _paperworkSvgDefault = parcelHelpers.interopDefault(_paperworkSvg);
function FinancingStatusMessage({ nextAction, message = '' }) {
    document.title = 'Payment Portal - Financing';
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const text_pageHeader = 'Financing';
    const text_title = t(`page.financing.${nextAction}.title`);
    const text_description = t([
        `fortiva.page.financing.${nextAction}.description`,
        `page.financing.${nextAction}.description`
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: text_pageHeader,
        withStepProgress: false,
        stickyFooter: true,
        branding: "fortiva",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
            className: "justify-center mt-8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowDefault.default), {
                    className: "justify-center items-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "font-regular",
                        "data-testid": "title-finance-approved",
                        children: text_title
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
                    className: "justify-center items-center my-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "!flex-col-2 flex justify-end",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "relative top-2",
                                alt: "application-declined",
                                width: "150em",
                                src: (0, _paperworkSvgDefault.default)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "!flex-col-8 !mb-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-0 w-full whitespace-pre-line text-xl leading-loose",
                                children: message ? message : text_description
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react":"2o0ib","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Layout/Row":"8YqFQ","Core/components/Layout/Column":"hnQnj","url:Images/illustrations/paperwork.svg":"9Iyib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8zooa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingDeclined);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _row = require("Core/components/Layout/Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _column = require("Core/components/Layout/Column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _warningSvg = require("url:Images/illustrations/warning.svg");
var _warningSvgDefault = parcelHelpers.interopDefault(_warningSvg);
var _routes = require("Modules/fortiva/routes");
var _infoBox = require("Core/components/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _button = require("Core/components/Button");
var _reactLocation = require("react-location");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
// Toggle to show/hide the rejection reason on the declined page.
const SHOW_REJECTION_REASON = false;
function FinancingDeclined({ allowCreateApplication = false, application = {}, isRejected = false }) {
    document.title = 'Payment Portal - Application Declined';
    const { t } = (0, _reactI18Next.useTranslation)();
    (0, _useScrollTop.useScrollTop)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { customer_id = '', payload: { relationship = '' } = {} } = application;
    const message = application?.payload?.correction_required?.message || '';
    const reasonMessage = message.replace(/\{[^}]*\}/g, '').trim();
    const handleCreateApplication = ()=>{
        const relationshipObj = JSON.stringify({
            relationship,
            customer_id
        });
        sessionStorage.setItem('relationship', relationshipObj);
        navigate({
            to: (0, _routes.createSecondaryFinancingPath),
            search: true
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "fortiva",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
            className: "justify-center !p-6 !pb-6 mt-8 mx-48",
            cardPadding: "sm",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                    className: "relative pb-4 mb-4 border-b border-slate-200",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "block text-[0.7rem] font-bold tracking-[0.18em] uppercase text-amber-600",
                            children: "Fortiva Retail Credit"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "!mt-1 !mb-0 text-2xl md:text-3xl font-semibold tracking-tight text-slate-800",
                            "data-testid": "title-finance-declined",
                            children: isRejected ? 'Financing Application Rejected' : t('common.nextgen.financingDeclined.title')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            "aria-hidden": "true",
                            className: "absolute left-0 -bottom-px h-[2px] w-28 rounded bg-gradient-to-r from-amber-500 via-amber-600 to-transparent"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _rowDefault.default), {
                    className: "items-start justify-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnDefault.default), {
                            className: "!flex-col-3 flex justify-center mt-0 !mb-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                alt: "application-declined",
                                width: "200em",
                                src: (0, _warningSvgDefault.default)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _columnDefault.default), {
                            className: "!flex-col-9 !mb-0",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _classnamesDefault.default)('mb-0 w-full whitespace-pre-line text-lg leading-loose font-light mt-4'),
                                    children: "Fortiva is unable to prequalify you at this time. You will receive written information related to this request in 7-10 days."
                                }),
                                SHOW_REJECTION_REASON && isRejected && reasonMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _infoBoxDefault.default), {
                                        type: "warningLite",
                                        showBorder: true,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-bold mr-2 text-yellow-700 mb-0 inline-block",
                                                children: "Reason:"
                                            }),
                                            ' ',
                                            reasonMessage
                                        ]
                                    })
                                }),
                                allowCreateApplication && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                    "data-testid": "btn-create-secondary-application",
                                    className: "mt-6 px-12",
                                    onClick: handleCreateApplication,
                                    children: t('common.reapply')
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Layout/Row":"8YqFQ","Core/components/Layout/Column":"hnQnj","url:Images/illustrations/warning.svg":"cx7tC","Modules/fortiva/routes":"6CCT1","Core/components/InfoBox":"4Lj47","Core/components/Button":"6YNzH","react-location":"8hNco","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"UdIqn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingAlreadyProcessed);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _fa = require("react-icons/fa");
var _financingExceptionPage = require("Modules/fortiva/components/FinancingExceptionPage");
var _financingExceptionPageDefault = parcelHelpers.interopDefault(_financingExceptionPage);
function FinancingAlreadyProcessed() {
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingExceptionPageDefault.default), {
        pageTitle: t('fortiva.alreadyProcessed.pageTitle', 'Payment Portal - Application Processed'),
        icon: (0, _fa.FaCheckCircle),
        testId: "title-already-processed",
        gradientClass: "from-emerald-500 to-teal-500",
        subtitleColorClass: "text-emerald-100",
        badgeClass: "bg-emerald-100 text-emerald-700",
        title: t('fortiva.alreadyProcessed.title', 'This application has already been processed'),
        subtitle: t('fortiva.alreadyProcessed.subtitle', 'It looks like an account already exists for this customer.'),
        description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "font-medium text-gray-800 !mb-2",
                    children: "Thank You for your Interest!"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "!mb-0",
                    children: "Our systems indicate that you have an existing Fortiva Retail Credit account."
                })
            ]
        }),
        infoCard: {
            icon: (0, _fa.FaCreditCard),
            iconBgColor: 'bg-emerald-50',
            iconColor: 'text-emerald-600',
            title: 'View your virtual card',
            description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "To view your credit card account number, please visit",
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "https://www.myfortiva.com/my-account",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "text-blue-600 font-medium underline",
                        children: "www.myfortiva.com/my-account"
                    }),
                    ' ',
                    "and select \u201CView Virtual Card.\u201D"
                ]
            })
        }
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","react-icons/fa":"9Vrsi","Modules/fortiva/components/FinancingExceptionPage":"eqdEC","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eqdEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingExceptionPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _fa = require("react-icons/fa");
const PhoneCard = ({ title, phone, description })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: `tel:${phone}`,
        className: "block p-5 bg-slate-50 border border-slate-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 hover:shadow-md transition-all duration-200 group",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-shrink-0 w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center group-hover:bg-blue-100 transition-colors",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaPhoneAlt), {
                        className: "text-blue-600"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-medium text-gray-900",
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-blue-600 font-semibold",
                            children: phone
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-gray-500 mt-0.5",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
const InfoCard = ({ icon: Icon, title, description, iconBgColor = 'bg-sky-50', iconColor = 'text-sky-600' })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-start gap-4 p-5 bg-slate-50 border border-slate-200 rounded-lg",
        children: [
            Icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `flex-shrink-0 w-12 h-12 ${iconBgColor} rounded-full flex items-center justify-center`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                    className: `${iconColor} text-lg`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "font-medium text-gray-900 mb-1",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-gray-600 leading-relaxed",
                        children: description
                    })
                ]
            })
        ]
    });
function FinancingExceptionPage({ pageTitle, icon: Icon, title, subtitle, description, testId, gradientClass = 'from-emerald-500 to-teal-500', gradientStyle, subtitleColorClass = 'text-emerald-100', badgeClass = 'bg-emerald-100 text-emerald-700', infoCard, contact }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    if (pageTitle) document.title = pageTitle;
    (0, _useScrollTop.useScrollTop)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "fortiva",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "max-w-3xl mx-auto mt-8",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                className: "!p-0 overflow-hidden",
                cardPadding: "none",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `${gradientStyle ? '' : `bg-gradient-to-r ${gradientClass}`} px-8 py-7`,
                        style: gradientStyle ? {
                            background: gradientStyle
                        } : {},
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-14 h-14 bg-white/20 rounded-full flex items-center justify-center",
                                    children: Icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                                        className: "text-white text-2xl"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "text-2xl font-semibold text-white",
                                            "data-testid": testId,
                                            children: title
                                        }),
                                        subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: `${subtitleColorClass} text-base mt-1`,
                                            children: subtitle
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "p-8 md:p-10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-gray-600 text-lg leading-relaxed mb-6",
                                children: description
                            }),
                            infoCard && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InfoCard, {
                                ...infoCard
                            }),
                            contact && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-3",
                                children: [
                                    contact.instruction && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            contact.icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `w-8 h-8 ${badgeClass} rounded-full flex items-center justify-center`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(contact.icon, {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-medium text-gray-700",
                                                children: contact.instruction
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PhoneCard, {
                                        title: contact.title,
                                        phone: contact.phone,
                                        description: contact.description
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","react-icons/fa":"9Vrsi","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iGuyQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingExceptions);
var _jsxRuntime = require("react/jsx-runtime");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _financingStatusMessage = require("Modules/fortiva/components/FinancingStatusMessage");
var _financingStatusMessageDefault = parcelHelpers.interopDefault(_financingStatusMessage);
var _useGetErrorConfig = require("Modules/fortiva/hooks/useGetErrorConfig");
var _createApplication = require("Modules/fortiva/routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _financingRequalify = require("Modules/fortiva/routes/FinancingRequalify");
var _financingRequalifyDefault = parcelHelpers.interopDefault(_financingRequalify);
var _financingDeclined = require("Modules/fortiva/routes/FinancingDeclined");
var _financingDeclinedDefault = parcelHelpers.interopDefault(_financingDeclined);
var _financingVerificationRequired = require("Modules/fortiva/routes/FinancingVerificationRequired");
var _financingVerificationRequiredDefault = parcelHelpers.interopDefault(_financingVerificationRequired);
var _financingAlreadyProcessed = require("Modules/fortiva/routes/FinancingAlreadyProcessed");
var _financingAlreadyProcessedDefault = parcelHelpers.interopDefault(_financingAlreadyProcessed);
var _financingDecisionPending = require("Modules/fortiva/routes/FinancingDecisionPending");
var _financingDecisionPendingDefault = parcelHelpers.interopDefault(_financingDecisionPending);
const isFrozenCreditCase = (application, nextAction)=>{
    const correctionRequired = application?.payload?.correction_required;
    return nextAction === 'CORRECTION_REQUIRED' && correctionRequired?.message?.includes('{FROZEN_CREDIT}');
};
const isReviewDeclinedCase = (application, nextAction)=>{
    const correctionRequired = application?.payload?.correction_required;
    return nextAction === 'DECISION_PENDING' && correctionRequired?.status === 'REVIEW' && correctionRequired?.message === 'Invalid request for application-requalify: Application status must be incomplete';
};
const isApplicationPendingCase = (application, nextAction)=>{
    const correctionRequired = application?.payload?.correction_required;
    return nextAction === 'DECISION_PENDING' && correctionRequired?.status === 'APPLICATION_PENDING';
};
const isExistingCustomerCase = (application, nextAction)=>{
    const correctionRequired = application?.payload?.correction_required;
    return nextAction === 'DECISION_PENDING' && correctionRequired?.message?.includes('{EXISTING_CUSTOMER}');
};
const isIdVerificationFailedCase = (application, nextAction)=>{
    const correctionRequired = application?.payload?.correction_required;
    return nextAction === 'DECLINED' && correctionRequired?.status === 'REJECTED' && correctionRequired?.message === 'truvalidateIDVFailed';
};
function FinancingExceptions({ customer_id, application, nextAction, onCustomerIdentityNumber }) {
    document.title = 'Payment Portal - Financing';
    (0, _useScrollTop.useScrollTop)();
    const purpose = nextAction === 'DECISION_PENDING' ? 'create' : 'update';
    const errorConfig = (0, _useGetErrorConfig.useGetErrorConfig)(application);
    // Check for frozen credit case - redirect to requalify flow
    if (isFrozenCreditCase(application, nextAction)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingRequalifyDefault.default), {});
    // Existing customer match while decision is pending - show the already-processed page
    if (isExistingCustomerCase(application, nextAction)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingAlreadyProcessedDefault.default), {});
    // Application is still awaiting a decision from Fortiva - show "check back later" page
    if (isApplicationPendingCase(application, nextAction)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDecisionPendingDefault.default), {});
    // Check for review/declined case - show declined page without reapply option
    if (isReviewDeclinedCase(application, nextAction)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {
        allowCreateApplication: false,
        application: application
    });
    // Check for ID verification failed case - show verification required flow
    if (isIdVerificationFailedCase(application, nextAction)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingVerificationRequiredDefault.default), {});
    // For DECLINED cases that don't match specific exceptions, show declined page
    if (nextAction === 'DECLINED') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDeclinedDefault.default), {
        application: application
    });
    if (errorConfig?.message) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
        type: "primary",
        customer_id: customer_id,
        purpose: purpose,
        errorConfig: errorConfig,
        onCustomerIdentityNumber: onCustomerIdentityNumber
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingStatusMessageDefault.default), {
        nextAction: nextAction,
        message: errorConfig.message
    });
}

},{"react/jsx-runtime":"9x2lT","Core/hooks/useScrollTop":"cBwQW","react":"2o0ib","Modules/fortiva/components/FinancingStatusMessage":"bKm9s","Modules/fortiva/hooks/useGetErrorConfig":"hObq7","Modules/fortiva/routes/CreateApplication":"9OFYo","Modules/fortiva/routes/FinancingRequalify":"8Pcon","Modules/fortiva/routes/FinancingDeclined":"8zooa","Modules/fortiva/routes/FinancingVerificationRequired":"lg0LM","Modules/fortiva/routes/FinancingAlreadyProcessed":"UdIqn","Modules/fortiva/routes/FinancingDecisionPending":"dU3E0","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hObq7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetErrorConfig", ()=>useGetErrorConfig);
var _react = require("react");
var _appStatusMap = require("Modules/fortiva/config/appStatusMap");
const useGetErrorConfig = (application)=>{
    return (0, _react.useMemo)(()=>{
        if (!application || !application.payload || !application.payload.correction_required) return {
            type: 'GENERIC',
            status: '',
            message: '',
            errorCode: null,
            affectedFields: []
        };
        const { status = '', message = '' } = application.payload.correction_required;
        // Extract error code from message if it exists in curly braces
        const errorCodeMatch = message.match(/\{([^}]+)\}/);
        const errorCode = errorCodeMatch ? errorCodeMatch[1] : null;
        // Clean the message by removing the error code part
        const cleanMessage = errorCode ? message.replace(/\{[^}]+\}\s*/, '').trim() : message;
        const error = (0, _appStatusMap.ERROR_MAPPING).find((e)=>e.status === status && e.message === cleanMessage);
        const errorType = error?.errorType || 'GENERIC';
        return {
            type: errorType,
            status,
            message: cleanMessage ? cleanMessage : message,
            errorCode,
            affectedFields: error?.affectedFields || []
        };
    }, [
        application
    ]);
};

},{"react":"2o0ib","Modules/fortiva/config/appStatusMap":"dPDuU","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dPDuU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERROR_MAPPING", ()=>ERROR_MAPPING);
parcelHelpers.export(exports, "ERROR_TYPES", ()=>ERROR_TYPES);
const ERROR_MAPPING = [
    {
        status: 'INCOMPLETE',
        message: 'Please verify and update your date of birth',
        errorType: 'INVALID_DATE_OF_BIRTH',
        affectedFields: [
            'dateOfBirth'
        ]
    },
    {
        status: 'REVIEW',
        message: 'Invalid request for application-qualify: Phone number is already in use',
        errorType: 'PHONE_NUMBER_ALREADY_IN_USE',
        affectedFields: [
            'phone'
        ]
    },
    {
        status: 'REVIEW',
        message: 'Invalid request for application-qualify: SSN already in use',
        errorType: 'SSN_ALREADY_IN_USE',
        affectedFields: [
            'socialSecurityNumber'
        ]
    },
    {
        status: 'REVIEW',
        message: 'Invalid request for application-qualify: Invalid field: ValidationError: Only phone numbers with 10 digits are accepted. [Code: 2028]',
        errorType: 'PHONE_NUMBER_INVALID',
        affectedFields: [
            'phone'
        ]
    },
    {
        status: 'REVIEW',
        message: 'Invalid request for application-qualify: Email is already in use and phone number is already in use',
        errorType: 'PHONE_NUMBER_INVALID',
        affectedFields: [
            'phone',
            'email'
        ]
    }
];
const ERROR_TYPES = {
    PHONE_NUMBER_ALREADY_IN_USE: 'PHONE_NUMBER_ALREADY_IN_USE',
    SSN_ALREADY_IN_USE: 'SSN_ALREADY_IN_USE'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8Pcon":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingRequalify);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _reactQuery = require("react-query");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _button = require("Core/components/Button");
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _alert = require("Core/components/Alert");
var _portal = require("Core/components/Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _fa = require("react-icons/fa");
var _reactLocation = require("react-location");
var _useRequalifyApplication = require("Modules/fortiva/hooks/useRequalifyApplication");
var _useRequalifyApplicationDefault = parcelHelpers.interopDefault(_useRequalifyApplication);
var _useRequalifyForm = require("Modules/fortiva/hooks/useRequalifyForm");
var _useRequalifyFormDefault = parcelHelpers.interopDefault(_useRequalifyForm);
var _useGetApplication = require("Modules/fortiva/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _routes = require("Modules/fortiva/routes");
var _constants = require("Modules/fortiva/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
const PhoneCard = ({ title, phone, description })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: `tel:${phone}`,
        className: "block p-4 bg-slate-50 border border-slate-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 hover:shadow-md transition-all duration-200 group",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-shrink-0 w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center group-hover:bg-blue-100 transition-colors",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaPhoneAlt), {
                        className: "text-blue-600"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-medium text-gray-900",
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-blue-600 font-semibold",
                            children: phone
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-gray-500 mt-0.5",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
const ConfirmationModal = ({ isOpen, onConfirm, onCancel, t })=>{
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "z-50 inset-0 fixed items-center justify-center flex bg-black/50 backdrop-blur-sm",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "bg-white rounded-lg shadow-2xl max-w-3xl w-full mx-4 overflow-hidden animate-in fade-in zoom-in duration-200",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaExclamationTriangle), {
                                        className: "text-white text-2xl"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "text-xl font-bold text-white",
                                    children: t('fortiva.requalify.modal.title')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "p-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-md mb-6",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-amber-800 font-medium",
                                    children: t('fortiva.requalify.modal.warningMessage')
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-gray-600 text-sm mb-6",
                                children: t('fortiva.requalify.modal.confirmQuestion')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col-reverse sm:flex-row gap-3 sm:justify-end",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SecondaryOutlineButton), {
                                        onClick: onCancel,
                                        className: "!px-6",
                                        "data-testid": "modal-cancel",
                                        children: t('fortiva.requalify.modal.cancelButton')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                        onClick: onConfirm,
                                        className: "!px-6",
                                        "data-testid": "modal-confirm",
                                        children: t('fortiva.requalify.modal.confirmButton')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
function FinancingRequalify() {
    const { t } = (0, _reactI18Next.useTranslation)();
    document.title = t('fortiva.requalify.pageTitle');
    const navigate = (0, _reactLocation.useNavigate)();
    const scroll = (0, _useScrollTop.useScrollTop)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const [showSsn, setShowSsn] = (0, _reactDefault.default).useState(false);
    const [submitError, setSubmitError] = (0, _reactDefault.default).useState(null);
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const [requalifyPolling, setRequalifyPolling] = (0, _reactDefault.default).useState(false);
    const [isPollingLoading, setIsPollingLoading] = (0, _reactDefault.default).useState(false);
    const [showConfirmModal, setShowConfirmModal] = (0, _reactDefault.default).useState(false);
    const [pendingFormData, setPendingFormData] = (0, _reactDefault.default).useState(null);
    const { register, handleSubmit, setValue, watch, formState: { errors, isValid } } = (0, _useRequalifyFormDefault.default)();
    const { mutateAsync: requalifyApplication, isLoading: isRequalifyLoading } = (0, _useRequalifyApplicationDefault.default)();
    const { isSuccess: isGetAppSuccess, isLoading: isGetAppLoading, data: getAppData } = (0, _useGetApplicationDefault.default)(requestId, requalifyPolling ? 3000 : false);
    const ssn = watch('socialSecurityNumber');
    (0, _reactDefault.default).useEffect(()=>{
        setValue('socialSecurityNumber', ssn?.replace(/\D+/g, ''), {
            shouldValidate: true
        });
    }, [
        setValue,
        ssn
    ]);
    // Handle polling response
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetAppSuccess && requalifyPolling && getAppData?.next_action) {
            // Store app data in session storage
            sessionStorage.setItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY, JSON.stringify(getAppData));
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
            // Stop polling and reset
            setRequestId('');
            setRequalifyPolling(false);
            setIsPollingLoading(false);
            // Navigate to financing redirect to handle the next action
            navigate({
                to: (0, _routes.createFinancingPath),
                search: true,
                replace: true
            });
        }
    }, [
        isGetAppSuccess,
        getAppData,
        requalifyPolling,
        navigate,
        queryClient
    ]);
    // Update loading state when polling starts
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetAppLoading) setIsPollingLoading(true);
    }, [
        isGetAppLoading
    ]);
    // Cleanup on unmount
    (0, _reactDefault.default).useEffect(()=>{
        return ()=>{
            setRequestId('');
            queryClient.removeQueries((0, _cacheKeysDefault.default).fortivaGetApplication);
        };
    }, [
        queryClient
    ]);
    const toggleSsnDisplay = ()=>{
        setShowSsn(!showSsn);
    };
    const handleFormSubmit = (formData)=>{
        // Store form data and show confirmation modal
        setPendingFormData(formData);
        setShowConfirmModal(true);
    };
    const handleConfirmRequalify = async ()=>{
        setShowConfirmModal(false);
        if (!pendingFormData) return;
        setSubmitError(null);
        setRequestId(''); // Clear old requestId first
        scroll.top();
        try {
            setRequalifyPolling(true);
            const { headers: { request_id } } = await requalifyApplication({
                customer_identity_number: pendingFormData.socialSecurityNumber
            });
            setRequestId(request_id);
        } catch (error) {
            setRequalifyPolling(false);
            setSubmitError(error?.response?.data?.message || t('status.error.requalifyFailed'));
        }
        setPendingFormData(null);
    };
    const handleCancelConfirm = ()=>{
        setShowConfirmModal(false);
        setPendingFormData(null);
    };
    const isLoading = isRequalifyLoading || isPollingLoading;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "fortiva",
        children: [
            isRequalifyLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('status.loading.requalifyApplication')
            }),
            isPollingLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('status.loading.financingApplication')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfirmationModal, {
                isOpen: showConfirmModal,
                onConfirm: handleConfirmRequalify,
                onCancel: handleCancelConfirm,
                t: t
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "max-w-4xl mx-auto mt-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                    className: "!p-0 overflow-hidden",
                    cardPadding: "none",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-5",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaSnowflake), {
                                            className: "text-white text-xl"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                className: "text-xl font-semibold text-white",
                                                "data-testid": "title-credit-freeze",
                                                children: t('fortiva.requalify.title')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-amber-100 text-sm",
                                                children: t('fortiva.requalify.subtitle')
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "p-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    children: t('fortiva.requalify.description')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "space-y-3 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2 mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium text-gray-700",
                                                    children: t('fortiva.requalify.step1Instruction')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(PhoneCard, {
                                            title: t('fortiva.requalify.transUnionTitle'),
                                            phone: t('fortiva.requalify.phoneNumbers.transUnion'),
                                            description: t('fortiva.requalify.transUnionDescription')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "space-y-3 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2 mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                                    children: "2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium text-gray-700",
                                                    children: t('fortiva.requalify.step2newInstruction')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "p-4 bg-slate-50 border border-slate-200 rounded-lg",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex-shrink-0 w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaUserCheck), {
                                                            className: "text-blue-600 text-lg"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "font-medium text-gray-900",
                                                                children: t('fortiva.requalify.confirmFreezeLifted')
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "text-sm text-gray-500 mt-0.5",
                                                                children: t('fortiva.requalify.confirmFreezeLiftedDescription')
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                    className: "my-6"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                            children: "3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-medium text-gray-700",
                                            children: t('fortiva.requalify.step3Instruction')
                                        })
                                    ]
                                }),
                                submitError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                                    className: "mb-4",
                                    "data-testid": "requalify-error",
                                    children: submitError
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                                    onSubmit: handleSubmit(handleFormSubmit),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "bg-gray-50 rounded-lg p-4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-sm text-gray-600 mb-3",
                                                children: t('fortiva.requalify.ssnInstruction')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "max-w-md col-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                                    register: register,
                                                    name: "socialSecurityNumber",
                                                    errors: errors,
                                                    onAppendClick: toggleSsnDisplay,
                                                    appendText: showSsn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaEyeSlash), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaEye), {}),
                                                    type: showSsn ? 'text' : 'password'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "max-w-md mt-4 col-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                                    type: "submit",
                                                    block: true,
                                                    "data-testid": "btn-requalify",
                                                    disabled: isLoading || !isValid,
                                                    children: t('fortiva.requalify.submitButton')
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react-query":"ksTpv","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","Core/components/Button":"6YNzH","Core/components/FormElements/InputField":"6BJmW","Core/components/Loader":"6S7S4","Core/components/Alert":"fmmNR","Core/components/Portal":"3MZth","react-icons/fa":"9Vrsi","react-location":"8hNco","Modules/fortiva/hooks/useRequalifyApplication":"1pUR7","Modules/fortiva/hooks/useRequalifyForm":"5lhVT","Modules/fortiva/hooks/useGetApplication":"d6izJ","Modules/fortiva/routes":"6CCT1","Modules/fortiva/config/constants":"lb4iD","Core/hooks/queries/cacheKeys":"i5IL7","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1pUR7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRequalifyApplication);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _reactI18Next = require("react-i18next");
var _logger = require("Core/utils/logger");
var _utils = require("Core/utils/utils");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
function transformPayload({ customer_id, customer_identity_number, external_reference_id, purpose, provider, payment_option }) {
    return {
        payment_id: (0, _utils.getUrlParam)('payment-id'),
        external_reference_id,
        purpose,
        payment_option,
        provider,
        payload: {
            customer_id,
            customer_identity_number
        }
    };
}
function useRequalifyApplication() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>{
        return (0, _platformApi.postWithHeaders)(`/financing/application-requalify`, transformPayload({
            ...payload,
            customer_id: paymentInfo.customer_id,
            external_reference_id: paymentInfo.external_reference_id,
            purpose: paymentInfo.purpose,
            provider: paymentInfo.provider,
            payment_option: paymentInfo.payment_option
        }));
    }, {
        throwOnError: true,
        retry: 2,
        enabled: Boolean(paymentInfo),
        onSuccess (data) {
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).requalifyApp,
                status: 'success'
            });
            clearAlert();
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
            return data;
        },
        onError (error) {
            setErrorAlert(t('status.error.requalifyApplicationRequestFailed') + `(${error?.response?.data?.message})`);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","react-i18next":"244ua","Core/utils/logger":"cWDKQ","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetPaymentInfo":"aXmHV","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5lhVT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSocialSecurityNumberRegex", ()=>getSocialSecurityNumberRegex);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _reactHookForm = require("react-hook-form");
const getSocialSecurityNumberRegex = ()=>/^(?:\d{9}|\d{4})$/;
const useRequalifyForm = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            socialSecurityNumber: _v3.string().min(1, {
                message: t('common.requiredFieldSSN')
            }).refine((val)=>{
                const regex = getSocialSecurityNumberRegex();
                return regex.test(val);
            }, {
                message: t('fortiva.formlabel.invalidFormatSSN')
            })
        });
    }, [
        t
    ]);
    const form = (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        mode: 'onChange',
        defaultValues: {
            socialSecurityNumber: ''
        }
    });
    return form;
};
exports.default = useRequalifyForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","react-hook-form":"53GLT","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"lg0LM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingVerificationRequired);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _fa = require("react-icons/fa");
const PhoneCard = ({ title, phone, description })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: `tel:${phone}`,
        className: "block p-4 bg-slate-50 border border-slate-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 hover:shadow-md transition-all duration-200 group",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-shrink-0 w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center group-hover:bg-blue-100 transition-colors",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaPhoneAlt), {
                        className: "text-blue-600"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-medium text-gray-900",
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-blue-600 font-semibold",
                            children: phone
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-gray-500 mt-0.5",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
const InfoCard = ({ icon: Icon, title, description, iconBgColor = 'bg-amber-50', iconColor = 'text-amber-600' })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "block p-4 bg-slate-50 border border-slate-200 rounded-lg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `flex-shrink-0 w-10 h-10 ${iconBgColor} rounded-full flex items-center justify-center`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                        className: iconColor
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-medium text-gray-900",
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-gray-500 mt-0.5",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
function FinancingVerificationRequired() {
    const { t } = (0, _reactI18Next.useTranslation)();
    document.title = t('fortiva.verificationRequired.pageTitle');
    (0, _useScrollTop.useScrollTop)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "fortiva",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "max-w-4xl mx-auto mt-6",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                className: "!p-0 overflow-hidden",
                cardPadding: "none",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-5",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaExclamationTriangle), {
                                        className: "text-white text-xl"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "text-xl font-semibold text-white",
                                            "data-testid": "title-verification-required",
                                            children: t('fortiva.verificationRequired.title')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-amber-100 text-sm",
                                            children: t('fortiva.verificationRequired.subtitle')
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "p-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-gray-600 mb-6",
                                children: t('fortiva.verificationRequired.description')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-3 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                                children: "1"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-medium text-gray-700",
                                                children: t('fortiva.verificationRequired.step1Instruction')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PhoneCard, {
                                        title: t('fortiva.requalify.fortivaTitle'),
                                        phone: t('fortiva.requalify.phoneNumbers.fortiva'),
                                        description: t('fortiva.verificationRequired.fortivaDescription')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-3 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                                children: "2"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-medium text-gray-700",
                                                children: t('fortiva.verificationRequired.step2Instruction')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InfoCard, {
                                        icon: (0, _fa.FaBan),
                                        title: t('fortiva.verificationRequired.disableTransactionTitle'),
                                        description: t('fortiva.verificationRequired.disableTransactionDescription'),
                                        iconBgColor: "bg-red-50",
                                        iconColor: "text-red-600"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold",
                                                children: "3"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-medium text-gray-700",
                                                children: t('fortiva.verificationRequired.step3Instruction')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InfoCard, {
                                        icon: (0, _fa.FaRedo),
                                        title: t('fortiva.verificationRequired.newApplicationTitle'),
                                        description: t('fortiva.verificationRequired.newApplicationDescription'),
                                        iconBgColor: "bg-green-50",
                                        iconColor: "text-green-600"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Page":"4xeqH","Core/components/FormElements/Card":"23G8S","react-icons/fa":"9Vrsi","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dU3E0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingDecisionPending);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _fa = require("react-icons/fa");
var _financingExceptionPage = require("Modules/fortiva/components/FinancingExceptionPage");
var _financingExceptionPageDefault = parcelHelpers.interopDefault(_financingExceptionPage);
function FinancingDecisionPending() {
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingExceptionPageDefault.default), {
        pageTitle: t('fortiva.decisionPending.pageTitle', 'Payment Portal - Application Pending'),
        icon: (0, _fa.FaRegClock),
        testId: "title-decision-pending",
        gradientStyle: "linear-gradient(to right, rgb(218, 97, 56), rgb(126, 68, 125))",
        subtitleColorClass: "text-orange-50",
        title: t('fortiva.decisionPending.title', 'A little more information is needed'),
        subtitle: t('fortiva.decisionPending.subtitle', 'We need some additional details to continue processing your application.'),
        description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-gray-900 text-xl font-medium mb-3",
                    children: t('fortiva.decisionPending.lead', 'Thank you for getting started with your application.')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-base",
                    children: t('fortiva.decisionPending.description', 'However, we need a few additional details from you before we can process it.')
                })
            ]
        }),
        infoCard: {
            icon: (0, _fa.FaEnvelopeOpenText),
            iconBgColor: 'bg-sky-50',
            iconColor: 'text-sky-600',
            title: t('fortiva.decisionPending.emailTitle', 'Check your email to continue'),
            description: t('fortiva.decisionPending.emailDescription', 'Open the email we just sent and follow the detailed instructions to provide the information we need and complete your application.')
        }
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","react-icons/fa":"9Vrsi","Modules/fortiva/components/FinancingExceptionPage":"eqdEC","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"aL08u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _reactLocation = require("react-location");
var _alert = require("Core/components/Alert");
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _footer = require("Core/components/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _button = require("Core/components/Button");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _routes = require("Modules/fortiva/routes");
var _useGetNextStep = require("Modules/fortiva/hooks/useGetNextStep");
const Financing = ({ nextRoutes })=>{
    (0, _useScrollTop.useScrollTop)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const [state, setState] = (0, _reactDefault.default).useState({
        refetchInterval: false,
        financingWindow: null,
        approved: 'done',
        approvedSigned: 'idle',
        funded: 'idle',
        isError: false,
        isModalOpen: false
    });
    const { data: { next_action, payload: { links: { cart: redirection_link } }, isError } } = (0, _useGetNextStep.useGetNextStep)(state.refetchInterval);
    (0, _reactDefault.default).useEffect(()=>{
        if (!next_action) return;
        if (isError) {
            setState({
                refetchInterval: 5000,
                approvedSigned: 'error',
                funded: 'error'
            });
            return;
        } else if (next_action === 'FUND_APPLICATION') setState({
            ...state,
            approvedSigned: 'done'
        });
        else if (next_action === 'DONE') {
            setState({
                ...state,
                approvedSigned: 'done',
                funded: 'done'
            });
            return;
        } else if (next_action === 'PENDING_DOWN_PAYMENT') {
            setState({
                ...state,
                approvedSigned: 'done',
                funded: 'done'
            });
            return;
        }
        if (next_action === 'FUNDED' || next_action === 'FUND_APPLICATION') navigate({
            to: nextRoutes.success,
            search: true
        });
        else if (next_action === 'DECLINED') navigate({
            to: nextRoutes.error,
            search: true
        });
    }, [
        isError,
        state,
        next_action,
        nextRoutes.success,
        nextRoutes.error,
        navigate
    ]);
    if (!next_action) return null;
    const openFinancingWindow = (e)=>{
        e.preventDefault();
        const financingWindow = window.open(redirection_link, '_blank');
        setState({
            ...state,
            refetchInterval: 5000,
            financingWindow,
            approvedSigned: 'loading',
            funded: 'loading'
        });
    };
    const checklistItems = [
        {
            label: t('page.financing.checklist.approved'),
            status: state.approved
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: state.approvedSigned
        },
        {
            label: t('page.financing.checklist.funded'),
            status: state.funded
        }
    ];
    const infobox = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
        type: "infoLight",
        "data-testid": "infobox",
        showIcon: true,
        children: t('fortiva.financingApproved.infobox')
    });
    const mixedQuestion = '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withStepProgress: false,
        stickyFooter: true,
        branding: "fortiva",
        children: [
            state.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                children: t('status.error.failedToRequestPatientFiApplicationState')
            }),
            infobox,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t('fortiva.financingApproved.intro')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    }),
                    next_action !== 'DONE' && next_action !== 'PENDING_DOWN_PAYMENT' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "py-2 text-center w-1/3 m-auto mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            block: true,
                            tall: true,
                            onClick: openFinancingWindow,
                            "data-testid": "finalize-financing",
                            children: t('page.financing.openFinancingPartnerWindow')
                        })
                    }),
                    next_action === 'PENDING_DOWN_PAYMENT' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                        type: "warning",
                        className: " bg-yellow-200 mt-8 mb-8",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                "You have a pending down payment. Please collect this as soon as possible.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                    onClick: openFinancingWindow,
                                    "data-testid": "collect-payment",
                                    children: "Collect Payment"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: t('fortiva.whereIsTheTab.question')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            t('fortiva.whereIsTheTab.answer')
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: t('page.financing.troubleFinalizing.question')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            t('page.financing.troubleFinalizing.answer')
                        ]
                    }),
                    mixedQuestion
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                hasPrev: false,
                labelPrev: t('common.back'),
                onPrev: ()=>navigate({
                        to: (0, _routes.paymentOptionsPath),
                        search: true
                    })
            })
        ]
    });
};
// TODO solve this hack!
const FinancingApplicationCheck = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data, isLoading, isError } = (0, _useGetNextStep.useGetNextStep)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Navigate), {
        to: (0, _routes.createFinancingPath),
        search: true
    });
    if (data?.next_action !== 'UPDATE_OFFER' && data?.next_action !== 'SIGN_CONTRACT') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Navigate), {
        to: (0, _routes.createFinancingPath),
        search: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Financing, {
        ...props
    });
};
exports.default = FinancingApplicationCheck;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","react-location":"8hNco","Core/components/Alert":"fmmNR","Core/components/FormElements/Card":"23G8S","Core/components/Footer":"ixeAp","Core/components/Button":"6YNzH","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Page":"4xeqH","Core/components/Loader":"6S7S4","Modules/fortiva/routes":"6CCT1","Modules/fortiva/hooks/useGetNextStep":"38IW2","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2Tccr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
const MixedSuccess = ()=>{
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const checklistItems = [
        {
            label: t('mixed.financingApproved.checklist.downPayment'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approved'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.funded'),
            status: 'done'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.mixed.success.header'),
        stickyFooter: true,
        branding: "fortiva",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertSuccess), {
                children: t('page.mixed.success.infobox')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t('page.mixed.success.intro')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                ]
            })
        ]
    });
};
exports.default = MixedSuccess;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Page":"4xeqH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jCIbF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _button = require("Core/components/Button");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _reactLocation = require("react-location");
var _routes = require("Modules/cardPayment/routes");
const MixedError = ()=>{
    const navigate = (0, _reactLocation.useNavigate)();
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const checklistItems = [
        {
            label: t('mixed.financingApproved.checklist.downPayment'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approved'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.funded'),
            status: 'error'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.mixed.error.header'),
        stickyFooter: true,
        branding: "fortiva",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                children: t('page.mixed.error.infobox')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t('page.mixed.error.intro')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `py-2 text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            onClick: ()=>navigate({
                                    to: (0, _routes.cardPreferenceCenterPath),
                                    search: true
                                }),
                            children: t('common.useAnotherPaymentOption')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                ]
            })
        ]
    });
};
exports.default = MixedError;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Button":"6YNzH","Core/components/Page":"4xeqH","react-location":"8hNco","Modules/cardPayment/routes":"kPsar","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"epDqx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lendFlowHomePath", ()=>lendFlowHomePath);
parcelHelpers.export(exports, "createFinancingPath", ()=>createFinancingPath);
parcelHelpers.export(exports, "createLendFlowApplicationPath", ()=>createLendFlowApplicationPath);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _financingRedirect = require("Modules/lendFlow/routes/FinancingRedirect");
var _financingRedirectDefault = parcelHelpers.interopDefault(_financingRedirect);
var _homeScreen = require("Modules/lendFlow/routes/HomeScreen");
var _homeScreenDefault = parcelHelpers.interopDefault(_homeScreen);
var _createApplication = require("./routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
const lendFlowHomePath = '/financing-lendflow/home';
const createFinancingPath = '/financing-lendflow/financing';
const createLendFlowApplicationPath = '/financing-lendflow/create-application';
const routes = [
    {
        path: lendFlowHomePath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeScreenDefault.default), {})
    },
    {
        path: createFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingRedirectDefault.default), {})
    },
    {
        path: createLendFlowApplicationPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {})
    }
];

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/lendFlow/routes/FinancingRedirect":"6N2MC","Modules/lendFlow/routes/HomeScreen":"hTHr8","./routes/CreateApplication":"4eS68","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6N2MC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingRedirect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _createApplication = require("Modules/lendFlow/routes/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _useGetNextStep = require("Modules/lendFlow/hooks/useGetNextStep");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _constants = require("Modules/lendFlow/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _routes = require("Core/routes");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactLocation = require("react-location");
var _routes1 = require("Modules/financing/routes");
var _routes2 = require("Modules/patientfi/routes");
function FinancingRedirect() {
    const navigate = (0, _reactLocation.useNavigate)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const { t } = (0, _reactI18Next.useTranslation)();
    const rawSessionStorageItem = sessionStorage.getItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY);
    const cachedApp = rawSessionStorageItem && rawSessionStorageItem !== 'undefined' ? JSON.parse(rawSessionStorageItem) : null;
    const { data: newApp, isLoading, isError, error } = (0, _useGetNextStep.useGetNextStep)(false, !cachedApp);
    const application = cachedApp || newApp;
    sessionStorage.removeItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY);
    const { next_action = 'CREATE_APPLICATION' } = application || {};
    const { data: { customer_id = '', provider = '', payment_option = '' } = {} } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
    else if (payment_option && payment_option.toUpperCase() !== 'GLOBAL') {
        // Redirect to appropriate module if payment_option is not GLOBAL
        if (provider === 'PATIENTFI') navigate({
            to: (0, _routes2.createFinancingPath),
            search: true
        });
        else navigate({
            to: (0, _routes1.createFinancingPath),
            search: true
        });
    } else if (isError || error?.response?.status === 404 || !application?.next_action) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
        customer_id: customer_id
    });
    else if (application?.next_action) switch(next_action){
        case 'CREATE_APPLICATION':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
                type: "primary",
                customer_id: customer_id
            });
        default:
            // For now, only CreateApplication is supported in LendFlow
            // Further steps (SELECT_OFFER, etc.) will be added later
            setError(t('status.error.getFinancingApplicationFailed'));
            navigate({
                to: (0, _routes.errorPath),
                search: true
            });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Modules/lendFlow/routes/CreateApplication":"4eS68","Modules/lendFlow/hooks/useGetNextStep":"iCBXr","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Core/components/Loader":"6S7S4","Modules/lendFlow/config/constants":"ltf4N","Core/routes":"iddMu","Core/stores/error":"38MVH","react-location":"8hNco","Modules/financing/routes":"5ZPtj","Modules/patientfi/routes":"lyzU7","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4eS68":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _reactI18Next = require("react-i18next");
var _selectMenu = require("Core/components/FormElements/SelectMenu");
var _selectMenuDefault = parcelHelpers.interopDefault(_selectMenu);
var _alert = require("Core/components/Alert");
var _infoBox = require("Core/components/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _button = require("Core/components/Button");
var _usStates = require("Modules/creditDebit/config/usStates");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _birthDateInput = require("Core/components/FormElements/BirthDateInput");
var _birthDateInputDefault = parcelHelpers.interopDefault(_birthDateInput);
var _layout = require("Core/components/Layout");
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _reactLocation = require("react-location");
var _useCreateApplicationForm = require("Modules/lendFlow/hooks/useCreateApplicationForm");
var _useCreateApplicationFormDefault = parcelHelpers.interopDefault(_useCreateApplicationForm);
var _useCreateApplication = require("Modules/lendFlow/hooks/useCreateApplication");
var _useCreateApplicationDefault = parcelHelpers.interopDefault(_useCreateApplication);
var _useGetCustomerInfo = require("Modules/lendFlow/hooks/useGetCustomerInfo");
var _useGetCustomerInfoDefault = parcelHelpers.interopDefault(_useGetCustomerInfo);
var _useGetApplication = require("Modules/lendFlow/hooks/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _fa6 = require("react-icons/fa6");
var _quote = require("Core/components/Quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
var _useScrollTop = require("Core/hooks/useScrollTop");
var _relationTypes = require("../config/relationTypes");
var _im = require("react-icons/im");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _mapCustomerData = require("Modules/lendFlow/utils/mapCustomerData");
var _logger = require("Core/utils/logger");
var _constants = require("../config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _reactQuery = require("react-query");
const dateFormat = 'yyyy-MM-dd';
const CreateApplication = ({ type = 'primary', customer_id = '', purpose = 'create', errorConfig = {} })=>{
    document.title = 'Payment Portal - LendFlow Application';
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const scroll = (0, _useScrollTop.useScrollTop)();
    const { mutateAsync: createApplication, isLoading: isCreateAppLoading } = (0, _useCreateApplicationDefault.default)(purpose);
    const [requestId, setRequestId] = (0, _reactDefault.default).useState('');
    const [showSsn, setShowSsn] = (0, _reactDefault.default).useState(false);
    const [showRelationField, setshowRelationField] = (0, _reactDefault.default).useState(type !== 'primary');
    const [createApplicationPolling, setCreateApplicationPolling] = (0, _reactDefault.default).useState(false);
    const { isSuccess: isGetAppSuccess, isLoading: isGetAppLoading, data: getAppData } = (0, _useGetApplicationDefault.default)(requestId, createApplicationPolling ? 3000 : false);
    const { data: customerInfo } = (0, _useGetCustomerInfoDefault.default)();
    const [dobDefaults, setDobDefaults] = (0, _reactDefault.default).useState({
        day: '01',
        month: '01',
        year: ''
    });
    const [isFinanceAppLoading, setIsFinanceAppLoading] = (0, _reactDefault.default).useState(false);
    const [initialAppStatus, setInitialAppStatus] = (0, _reactDefault.default).useState({
        nextAction: null,
        message: null,
        status: null
    });
    const { register, handleSubmit, setValue, watch, reset, formState: { errors, isSubmitted } } = (0, _useCreateApplicationFormDefault.default)(errorConfig);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const selectedRelationship = watch('relationship');
    const relationshipSessionStorageString = sessionStorage.getItem('relationship');
    const previousRelationship = JSON.parse(relationshipSessionStorageString)?.relationship || '';
    const sessionStorageCustomerId = JSON.parse(relationshipSessionStorageString)?.customer_id || '';
    const filteredRelationTypes = (0, _relationTypes.relationTypes).filter((item)=>!previousRelationship || type === 'primary' ? true : item.value !== previousRelationship);
    const showUpdateFormMessage = !!errorConfig.type;
    const initializeAppStatus = (appData)=>{
        const { correction_required: { status = '', message = '' } = {} } = appData?.payload || {};
        setInitialAppStatus({
            nextAction: appData?.next_action,
            message,
            status
        });
    };
    (0, _reactDefault.default).useEffect(()=>{
        const isAppStatusChanged = ()=>{
            return getAppData?.next_action !== initialAppStatus.nextAction || getAppData?.message !== initialAppStatus.message || getAppData?.status !== initialAppStatus.status;
        };
        if (isGetAppSuccess && createApplicationPolling && isAppStatusChanged()) {
            sessionStorage.setItem((0, _constantsDefault.default).SESS_STORAGE_APPLICATION_KEY, JSON.stringify(getAppData));
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingNextStep);
            setRequestId('');
            setCreateApplicationPolling(false);
            setIsFinanceAppLoading(false);
        }
    }, [
        isGetAppSuccess,
        getAppData,
        navigate,
        createApplicationPolling,
        requestId,
        initialAppStatus
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (isGetAppLoading) setIsFinanceAppLoading(true);
    }, [
        isGetAppLoading
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        return ()=>{
            setRequestId('');
            queryClient.removeQueries((0, _cacheKeysDefault.default).lendflowGetApplication);
        };
    }, [
        queryClient
    ]);
    const parseDateOfBirth = (dateOfBirth)=>{
        let year, day, month;
        if (Array.isArray(dateOfBirth)) {
            [year] = dateOfBirth;
            [, day, month] = dateOfBirth;
            if (month > 0 && month < 10) month = '0' + month;
            if (day > 0 && day < 10) day = '0' + day;
        } else if (typeof dateOfBirth === 'string') [year, month, day] = dateOfBirth.split('-');
        return {
            day,
            month,
            year
        };
    };
    (0, _reactDefault.default).useEffect(()=>{
        const mappedCustomerData = (0, _mapCustomerData.mapCustomerData)(customerInfo, customer_id);
        if (mappedCustomerData) {
            if (mappedCustomerData.relationship === previousRelationship && sessionStorageCustomerId === customer_id && type !== 'primary') mappedCustomerData.relationship = null;
            Object.keys(mappedCustomerData).forEach((field)=>setValue(field, mappedCustomerData[field]));
            const finalDateOfBirth = mappedCustomerData.date_of_birth || mappedCustomerData.dateOfBirth;
            if (finalDateOfBirth) {
                const { day, month, year } = parseDateOfBirth(finalDateOfBirth);
                setDobDefaults({
                    day,
                    month,
                    year
                });
            }
        } else {
            setDobDefaults({
                day: '01',
                month: '01',
                year: ''
            });
            reset((0, _mapCustomerData.mapCustomerData)({}, customer_id));
        }
    }, [
        customerInfo,
        reset,
        setValue,
        isGetAppSuccess,
        isGetAppLoading,
        navigate,
        requestId,
        getAppData?.next_action,
        customer_id,
        previousRelationship,
        sessionStorageCustomerId,
        type
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        const errorFields = Object.keys(errors);
        if (errorFields?.length) {
            const errorMap = errorFields.map((field)=>{
                return {
                    field,
                    message: errors[field].message
                };
            });
            console.log('form errors!', errorMap);
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                action: (0, _logger.actions).createApplicationFormError,
                errors: errorMap
            });
        }
    }, [
        errors
    ]);
    const handleRelationshipChange = ()=>{
        if (customerInfo && customerInfo.relationship === selectedRelationship) {
            const customerData = (0, _mapCustomerData.mapCustomerData)(customerInfo, customer_id);
            Object.keys(customerData).forEach((field)=>setValue(field, customerData[field]));
            if (customerData.date_of_birth || customerData.dateOfBirth) {
                const finalDateOfBirth = customerData.date_of_birth || customerData.dateOfBirth;
                const { day, month, year } = parseDateOfBirth(finalDateOfBirth);
                setDobDefaults({
                    day,
                    month,
                    year
                });
            }
        } else {
            setDobDefaults({
                day: '01',
                month: '01',
                year: ''
            });
            reset((0, _mapCustomerData.mapCustomerData)({}, customer_id));
        }
    };
    const ssn = watch('socialSecurityNumber');
    (0, _reactDefault.default).useEffect(()=>{
        setValue('socialSecurityNumber', ssn?.replace(/\D+/g, ''));
    }, [
        setValue,
        ssn
    ]);
    const phone = watch('phone');
    (0, _reactDefault.default).useEffect(()=>{
        if (phone?.startsWith('+1')) setValue('phone', phone.replace(/^\+1/, ''));
    }, [
        setValue,
        phone
    ]);
    const hasFormErrors = Object.keys(errors).length > 0;
    const storeCustomerInfo = (formData)=>{
        const filteredFormData = JSON.parse(JSON.stringify(formData));
        delete filteredFormData.socialSecurityNumber;
        delete filteredFormData.annualIncome;
        sessionStorage.setItem((0, _constantsDefault.default).SESS_STORAGE_CUSTOMER_INFO_KEY, JSON.stringify({
            ...filteredFormData,
            customer_id
        }));
    };
    const onSubmit = async (formData)=>{
        setRequestId('');
        initializeAppStatus();
        storeCustomerInfo(formData);
        setCreateApplicationPolling(true);
        scroll.top();
        const { headers: { request_id } } = await createApplication(formData);
        setRequestId(request_id);
    };
    const toggleSsnDisplay = ()=>{
        setShowSsn(!showSsn);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: "LendFlow - Create Application",
        subtitle: "Global Multi-Provider Financing Application",
        withStepProgress: false,
        stickyFooter: true,
        branding: "lendflow",
        children: [
            isCreateAppLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: "Submitting your application to providers..."
            }),
            isFinanceAppLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('status.loading.financingApplication')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bg-lendflow-surface border-l-4 border-lendflow-bg rounded-r-lg p-4 mb-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-sm text-lendflow-dark font-medium",
                    children: "Your application will be evaluated by multiple financing providers to find the best terms for you."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                name: "lendFlowCreateApplication",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    hasFormErrors && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                        type: "error",
                        children: t('status.error.checkErrors')
                    }),
                    showUpdateFormMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                        type: "error",
                        children: errorConfig.message
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    !showRelationField && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "text-gray-500",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center my-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "inline-block pr-2",
                                                    children: [
                                                        ' ',
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _im.ImInfo), {})
                                                    ]
                                                }),
                                                "Filling the application for someone else?",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "text-lendflow-bg hover:text-lendflow-dark hover:underline mx-1 font-medium",
                                                    type: "button",
                                                    onClick: ()=>setshowRelationField(true),
                                                    children: "Click here"
                                                }),
                                                ' ',
                                                "to change relationship"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!mb-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                            type: "infoLight",
                                            children: t('patientfi.createApplication.enterLegalNames')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: (0, _classnamesDefault.default)('md:!flex-col-6', {
                                            hidden: !showRelationField
                                        }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                                            register: register,
                                            label: t('common.relationship'),
                                            name: "relationship",
                                            items: filteredRelationTypes,
                                            onChange: handleRelationshipChange,
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "!mb-2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.firstName'),
                                            name: "firstName",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.lastName'),
                                            name: "lastName",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.street'),
                                            name: "address",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.city'),
                                            name: "city",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                                            register: register,
                                            label: t('common.state'),
                                            name: "state",
                                            items: (0, _usStates.usStates),
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.postalCode'),
                                            name: "zip",
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.phone'),
                                            name: "phone",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.email'),
                                            name: "email",
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6 flex items-end",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            className: "!rounded-r-none",
                                            register: register,
                                            label: t('patientfi.formlabel.ssn'),
                                            name: "socialSecurityNumber",
                                            errors: errors,
                                            onAppendClick: toggleSsnDisplay,
                                            appendText: showSsn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa6.FaEyeSlash), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa6.FaEye), {}),
                                            type: showSsn ? 'text' : 'password'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _birthDateInputDefault.default), {
                                            format: dateFormat,
                                            register: register,
                                            name: "dateOfBirth",
                                            padZeros: true,
                                            onChange: (value)=>{
                                                setValue('dateOfBirth', value, {
                                                    shouldValidate: isSubmitted
                                                });
                                            },
                                            defaultValues: dobDefaults,
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.annualIncome'),
                                            name: "annualIncome",
                                            type: "number",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-12",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteDefault.default), {
                                            showWhitespace: true,
                                            children: t('patientfi.createApplication.readToCustomer.note2')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: t('common.noticeToApplicants')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                        type: "warning",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-semibold text-sm text-black",
                                            children: t('common.readToCustomer.doubleTitle')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                            showBorder: true,
                                            children: t('patientfi.createApplication.readToCustomer.note3')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                            showBorder: true,
                                            children: t('patientfi.createApplication.readToCustomer.note4')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _termsInputDefault.default), {
                                name: "terms",
                                register: register,
                                errors: errors,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        children: t('financing.nextgen.createApplication.terms')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ol", {
                                        className: "list-decimal ml-4 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: t('patientfi.createApplication.terms.note1')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: t('patientfi.createApplication.terms.note2')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            className: "md:!flex-col-12 !flex gap-1 !justify-end",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                type: "submit",
                                "data-testid": "submit-lendflow-application",
                                children: t('common.submitPrequalificationApplication')
                            })
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = CreateApplication;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/InputField":"6BJmW","react-i18next":"244ua","Core/components/FormElements/SelectMenu":"hsUsp","Core/components/Alert":"fmmNR","Core/components/InfoBox":"4Lj47","Core/components/Button":"6YNzH","Modules/creditDebit/config/usStates":"2i8MO","Core/components/Page":"4xeqH","Core/components/FormElements/BirthDateInput":"36m4y","Core/components/Layout":"hweet","Core/components/FormElements/formElements.styled":"45aFS","Core/components/FormElements/TermsInput":"2LJBE","Core/components/Loader":"6S7S4","react-location":"8hNco","Modules/lendFlow/hooks/useCreateApplicationForm":"ZUNhe","Modules/lendFlow/hooks/useCreateApplication":"i5lZj","Modules/lendFlow/hooks/useGetCustomerInfo":"4hoVE","Modules/lendFlow/hooks/useGetApplication":"7VftX","react-icons/fa6":"1emil","Core/components/Quote":"aL5Js","Core/hooks/useScrollTop":"cBwQW","../config/relationTypes":"bP2N5","react-icons/im":"ek0E7","classnames":"f971Y","Modules/lendFlow/utils/mapCustomerData":"9OGJO","Core/utils/logger":"cWDKQ","../config/constants":"ltf4N","Core/hooks/queries/cacheKeys":"i5IL7","react-query":"ksTpv","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ZUNhe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSocialSecurityNumberRegex", ()=>getSocialSecurityNumberRegex);
parcelHelpers.export(exports, "validateISODateFormat", ()=>validateISODateFormat);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _dateFns = require("date-fns");
var _reactHookForm = require("react-hook-form");
var _relationTypes = require("Modules/lendFlow/config/relationTypes");
const getSocialSecurityNumberRegex = ()=>/^(?:\d{3}-?\d{2}-?\d{4}|\d{4})$/;
const validateISODateFormat = (val)=>{
    return val ? (0, _dateFns.isValid)((0, _dateFns.parseISO)(val)) : true;
};
const relationValues = (0, _relationTypes.relationTypes).map((item)=>item.value);
const useCreateApplicationForm = (errorConfig = {})=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            firstName: _v3.string().min(1, {
                message: t('common.requiredFieldFirstName')
            }),
            lastName: _v3.string().min(1, {
                message: t('common.requiredFieldLastName')
            }),
            address: _v3.string().min(1, {
                message: t('common.requiredFieldStreet')
            }),
            city: _v3.string().min(1, {
                message: t('common.requiredFieldCity')
            }),
            state: _v3.string().min(1, {
                message: t('common.requiredFieldState')
            }),
            zip: _v3.string().min(1, {
                message: t('common.requiredFieldPostalCode')
            }),
            relationship: _v3.enum(relationValues, {
                errorMap: ()=>{
                    return {
                        message: 'relationship is required'
                    };
                }
            }),
            email: _v3.string().min(1, {
                message: t('common.requiredFieldEmail')
            }).email({
                message: t('common.invalidFormatEmail')
            }),
            socialSecurityNumber: _v3.string().min(1, {
                message: t('common.requiredFieldSSN')
            }).refine((val)=>{
                const regex = getSocialSecurityNumberRegex();
                return regex.test(val);
            }, {
                message: t('patientfi.formlabel.invalidFormatSSN')
            }),
            phone: _v3.string().min(1, {
                message: t('common.requiredFieldPhone')
            }).regex(/^\d{10}$/, {
                message: 'Please provide a valid phone number with 10 digits'
            }),
            dateOfBirth: _v3.any().refine(validateISODateFormat, {
                message: t('common.invalidDateFormat')
            }),
            annualIncome: _v3.string().transform(parseInt).refine((val)=>val >= 1, {
                message: t('common.requiredFieldAnnualIncome')
            }),
            terms: _v3.boolean().refine((val)=>val, {
                message: t('common.requiredFieldTerms')
            })
        });
    }, [
        t
    ]);
    const form = (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema)
    });
    const { setError } = form;
    (0, _reactDefault.default).useEffect(()=>{
        if (errorConfig.affectedFields && Array.isArray(errorConfig.affectedFields)) errorConfig.affectedFields.forEach((fieldName)=>{
            const errorMessage = errorConfig.message || t('common.fieldHasError');
            setError(fieldName, {
                type: 'manual',
                message: errorMessage
            });
        });
    }, [
        errorConfig,
        setError,
        t
    ]);
    return form;
};
exports.default = useCreateApplicationForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","date-fns":[["isValid","jCEss","default"],["parseISO","3xgI2","default"]],"react-hook-form":"53GLT","Modules/lendFlow/config/relationTypes":"bP2N5","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bP2N5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "relationTypes", ()=>relationTypes);
const relationTypes = [
    {
        value: '',
        label: '--',
        disabled: true
    },
    {
        value: 'SELF',
        label: 'Self'
    },
    {
        value: 'SPOUSE',
        label: 'Spouse'
    },
    {
        value: 'PARENT',
        label: 'Parent'
    },
    {
        value: 'SIBLING',
        label: 'Sibling'
    },
    {
        value: 'CHILD',
        label: 'Child'
    },
    {
        value: 'OTHER',
        label: 'Other'
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"i5lZj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCreateApplication);
var _reactQuery = require("react-query");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _reactI18Next = require("react-i18next");
var _logger = require("Core/utils/logger");
var _utils = require("Core/utils/utils");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _providerConfig = require("Modules/lendFlow/config/providerConfig");
function transformPayload({ firstName, lastName, address, city, state, zip, email, phone: number, socialSecurityNumber, dateOfBirth, annualIncome, customer_id, external_reference_id, purpose, provider, payment_option, relationship }) {
    return {
        payment_id: (0, _utils.getUrlParam)('payment-id'),
        external_reference_id,
        purpose,
        payment_option,
        provider,
        payload: {
            customer_id,
            first_name: firstName,
            middle_name: '',
            last_name: lastName,
            email,
            date_of_birth: dateOfBirth,
            customer_identity_number: socialSecurityNumber,
            monthly_income: Math.floor(annualIncome / 12),
            relationship,
            address_line: address,
            city,
            state,
            zip,
            phone_number: number,
            phone_type: 'mobile',
            agree_to_terms: true,
            authorized_representative: 'jose.vargas@hear.com'
        }
    };
}
function useCreateApplication(purpose = 'create') {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>{
        const httpMethod = purpose === 'update' ? (0, _platformApi.putWithHeaders) : (0, _platformApi.postWithHeaders);
        const isGlobal = paymentInfo.payment_option === 'GLOBAL';
        const creditRating = paymentInfo.credit_rating_estimate;
        const providers = isGlobal && creditRating ? (0, _providerConfig.providerSequence)[creditRating] : null;
        return httpMethod(`/financing/application`, transformPayload({
            ...payload,
            customer_id: paymentInfo.customer_id,
            external_reference_id: paymentInfo.external_reference_id,
            purpose: paymentInfo.purpose,
            provider: providers ? providers[0] : paymentInfo.provider,
            payment_option: isGlobal ? 'GLOBAL' : paymentInfo.payment_option
        }));
    }, {
        throwOnError: true,
        retry: 2,
        enabled: Boolean(paymentInfo),
        onSuccess (data) {
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                status: 'success'
            });
            clearAlert();
            queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingPlatformApplication);
            return data;
        },
        onError (error) {
            setErrorAlert(t('status.error.createApplicationRequestFailed') + `(${error?.response?.data?.message})`);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","react-i18next":"244ua","Core/utils/logger":"cWDKQ","Core/utils/utils":"hwOBZ","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/lendFlow/config/providerConfig":"4ay19","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4ay19":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "providerPaymentOption", ()=>providerPaymentOption);
parcelHelpers.export(exports, "providerSequence", ()=>providerSequence);
const providerPaymentOption = {
    PATIENTFI: 'PATIENTFI',
    ALLEGRO: 'REGULAR'
};
const providerSequence = {
    EXCELLENT: [
        'PATIENTFI',
        'ALLEGRO',
        'FORTIVA'
    ],
    GOOD: [
        'ALLEGRO',
        'PATIENTFI'
    ],
    BAD: [
        'PATIENTFI'
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4hoVE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetCustomerInfo);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _routes = require("Core/routes");
var _reactLocation = require("react-location");
function useGetCustomerInfo() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).financingCustomerInfo
    ], ()=>(0, _platformApi.get)(`/customer/search`), {
        onError (e) {
            if (e?.response?.status !== 404) {
                const message = e?.response?.data?.message ? ` - ${e?.response?.data?.message}` : '';
                setError(t('status.error.getFinancingApplicationFailed') + message);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        },
        retry: 1
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/error":"38MVH","Core/routes":"iddMu","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7VftX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetApplication);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _platformApi = require("Core/utils/platformApi");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _routes = require("Core/routes");
var _reactLocation = require("react-location");
var _logger = require("Core/utils/logger");
const DATA_NOT_READY = 'Data not ready';
function useGetApplication(requestId, refetchInterval = false) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).lendflowGetApplication,
        requestId
    ], async ()=>{
        const data = await (0, _platformApi.get)(`/application`, {
            headers: {
                request_id: requestId
            }
        });
        if (!data?.next_action) throw new Error(DATA_NOT_READY);
        return data;
    }, {
        enabled: Boolean(requestId),
        retry: (failureCount, error)=>{
            if (error.message === DATA_NOT_READY) return failureCount < 30;
            return false;
        },
        retryDelay: 3000,
        refetchInterval,
        staleTime: 0,
        cacheTime: 300000,
        onError (e) {
            if (e.message === DATA_NOT_READY) {
                setErrorAlert(t('status.error.getFinancingApplicationFailed'));
                return;
            }
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                action: (0, _logger.actions).createApplicationTimeout
            });
            const message = e?.message ? ` - ${e?.message}` : '';
            setError(t('status.error.getFinancingApplicationFailed') + message);
            navigate({
                to: (0, _routes.errorPath),
                search: true
            });
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/utils/platformApi":"9RrWs","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","Core/stores/error":"38MVH","Core/routes":"iddMu","react-location":"8hNco","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9OGJO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapCustomerData", ()=>mapCustomerData);
var _getStateAbbreviation = require("../hooks/getStateAbbreviation");
var _getStateAbbreviationDefault = parcelHelpers.interopDefault(_getStateAbbreviation);
var _constants = require("../config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
const mapCustomerData = (customerData, customer_id)=>{
    const sessionStorageCustomerData = sessionStorage.getItem((0, _constantsDefault.default).SESS_STORAGE_CUSTOMER_INFO_KEY);
    if (sessionStorageCustomerData) {
        const parsedCustomerData = JSON.parse(sessionStorageCustomerData);
        if (parsedCustomerData.customer_id === customer_id) return parsedCustomerData;
    }
    if (customerData) return {
        ...customerData,
        firstName: customerData.first_name ?? '',
        lastName: customerData.last_name ?? '',
        address: customerData.address_line ?? '',
        city: customerData.city ?? '',
        state: (0, _getStateAbbreviationDefault.default)(customerData.state) ?? '',
        zip: customerData.zip ?? '',
        country: customerData.country ?? '',
        email: customerData.email ?? '',
        socialSecurityNumber: customerData.customer_identity_number ?? '',
        phone: (customerData.phone_number ?? '').replace(/^\+1/, ''),
        annualIncome: (customerData.monthly_income ? customerData.monthly_income * 12 : '').toString(),
        relationship: customerData.relationship ?? 'SELF'
    };
    return {};
};

},{"../hooks/getStateAbbreviation":"gFEtj","../config/constants":"ltf4N","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gFEtj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getStateAbbreviation);
var _usStates = require("Modules/creditDebit/config/usStates");
function getStateAbbreviation(input) {
    if (!input || !input.toLowerCase()) return input;
    const stateByLabel = (0, _usStates.usStates).find((state)=>input.toLowerCase() === state.label.toLowerCase());
    const stateByValue = (0, _usStates.usStates).find((state)=>input.toLowerCase() === state.value.toLowerCase());
    if (stateByValue) return input;
    else if (stateByLabel) return stateByLabel.value;
    return input;
}

},{"Modules/creditDebit/config/usStates":"2i8MO","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ltf4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    SESS_STORAGE_CUSTOMER_INFO_KEY: 'LENDFLOW_CUSTOMER_INFO_FORM_DATA',
    SESS_STORAGE_APPLICATION_KEY: 'LENDFLOW_APPLICATION',
    SESS_STORAGE_RELATIONSHIP_KEY: 'LENDFLOW_RELATIONSHIP'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iCBXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetNextStep", ()=>useGetNextStep);
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactQuery = require("react-query");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _platformApi = require("Core/utils/platformApi");
function useGetNextStep(refetchInterval, enabled = true) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const validator = (data)=>Boolean(data) && Boolean(data?.next_action);
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).financingNextStep, ()=>(0, _platformApi.get)('/application/next-step', {}, validator), {
        refetchInterval,
        enabled: Boolean(enabled),
        onError (e) {
            if (e) setError(t('status.error.getPaymentInfoFailed') + ` - (${e})`);
        }
    });
}

},{"react-i18next":"244ua","Core/stores/error":"38MVH","react-query":"ksTpv","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/platformApi":"9RrWs","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hTHr8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactLocation = require("react-location");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _button = require("Core/components/Button");
var _layout = require("Core/components/Layout");
var _routes = require("Modules/lendFlow/routes");
var _useGetPaymentInfo = require("Core/hooks/platform/useGetPaymentInfo");
var _providerConfig = require("Modules/lendFlow/config/providerConfig");
const HomeScreen = ()=>{
    document.title = 'Payment Portal - LendFlow';
    const navigate = (0, _reactLocation.useNavigate)();
    const { data: paymentInfo } = (0, _useGetPaymentInfo.useGetPaymentInfo)();
    const creditRating = paymentInfo?.credit_rating_estimate;
    const matchedProviders = creditRating ? (0, _providerConfig.providerSequence)[creditRating] : null;
    const handleStartApplication = ()=>{
        navigate({
            to: (0, _routes.createLendFlowApplicationPath),
            search: true
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageDefault.default), {
        title: "LendFlow Financing",
        subtitle: "Global Multi-Provider Financing",
        withStepProgress: false,
        stickyFooter: true,
        branding: "lendflow",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "max-w-2xl mx-auto py-8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-2xl bg-gradient-to-br from-lendflow-bg to-lendflow-dark p-8 text-white mb-8 shadow-lg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "text-2xl font-bold mb-3",
                            children: "Multi-Provider Financing"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "text-lg opacity-90 leading-relaxed",
                            children: [
                                "This flow is for the ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-semibold",
                                    children: "GLOBAL"
                                }),
                                " financing option. Your application will be submitted to multiple financing providers sequentially, matched based on your credit profile to find the best available offer."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "bg-lendflow-surface rounded-xl p-6 mb-8 border border-lendflow-accent/20",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "text-lg font-semibold text-lendflow-dark mb-4",
                            children: "How It Works"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-start gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex-shrink-0 w-8 h-8 rounded-full bg-lendflow-bg text-white flex items-center justify-center text-sm font-bold",
                                            children: "1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "font-medium text-gray-800",
                                                    children: "Submit Your Application"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-sm text-gray-600",
                                                    children: "Complete a single application with your personal and financial details."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-start gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex-shrink-0 w-8 h-8 rounded-full bg-lendflow-bg text-white flex items-center justify-center text-sm font-bold",
                                            children: "2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "font-medium text-gray-800",
                                                    children: "Automated Provider Matching"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-sm text-gray-600",
                                                    children: "Your application is evaluated by multiple financing providers based on your credit score."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-start gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex-shrink-0 w-8 h-8 rounded-full bg-lendflow-bg text-white flex items-center justify-center text-sm font-bold",
                                            children: "3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "font-medium text-gray-800",
                                                    children: "Best Offer Selection"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-sm text-gray-600",
                                                    children: "You will receive the most favorable financing terms available to you."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bg-amber-50 border border-amber-200 rounded-lg p-4 mb-8",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "text-sm text-amber-800",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "font-semibold",
                                children: "Disclaimer:"
                            }),
                            " By proceeding, you authorize us to submit your application to multiple financing providers. A soft credit inquiry may be performed initially, followed by a hard inquiry if you choose to accept an offer. Terms and approval are subject to each provider's criteria."
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "md:!flex-col-12 !flex !justify-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            onClick: handleStartApplication,
                            "data-testid": "start-lendflow-application",
                            className: "!bg-lendflow-bg hover:!bg-lendflow-dark !text-white !px-8 !py-3 !rounded-lg !text-base !font-semibold !shadow-md hover:!shadow-lg !transition-all",
                            children: "Start Financing Application"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mt-8 border-2 border-dashed border-red-400 rounded-xl p-6 bg-red-50",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2 mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "bg-red-500 text-white text-xs font-bold px-2 py-1 rounded",
                                    children: "DEV ONLY"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "text-lg font-semibold text-red-700",
                                    children: "Provider Sequence (Credit Rating Debug)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "text-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-medium",
                                            children: "Credit Rating Estimate:"
                                        }),
                                        ' ',
                                        creditRating ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-mono bg-gray-100 px-2 py-0.5 rounded",
                                            children: creditRating
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "italic text-gray-400",
                                            children: "Not available"
                                        })
                                    ]
                                }),
                                matchedProviders ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "font-medium text-gray-700 mb-2",
                                            children: "Provider Order:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ol", {
                                            className: "list-decimal list-inside space-y-1",
                                            children: matchedProviders.map((provider)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    className: "font-mono bg-white px-3 py-1.5 rounded border border-gray-200",
                                                    children: provider
                                                }, provider))
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "italic text-gray-400",
                                    children: creditRating ? `No provider sequence configured for rating: "${creditRating}"` : 'Waiting for payment info...'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = HomeScreen;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-location":"8hNco","Core/components/Page":"4xeqH","Core/components/Button":"6YNzH","Core/components/Layout":"hweet","Modules/lendFlow/routes":"epDqx","Core/hooks/platform/useGetPaymentInfo":"aXmHV","Modules/lendFlow/config/providerConfig":"4ay19","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4vxt9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotFound", ()=>NotFound);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
const NotFound = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.error.header'),
        withStepProgress: false,
        withSidebar: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: t('common.error404')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: t('status.error.pageNotFound')
            })
        ]
    });
};

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/components/Page":"4xeqH","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jNmG4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Teleaudiology);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetNextSteps = require("Core/hooks/queries/order/useGetNextSteps");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _reactI18Next = require("react-i18next");
var _usePutPaymentOption = require("Core/hooks/queries/payment/usePutPaymentOption");
var _usePutPaymentOptionDefault = parcelHelpers.interopDefault(_usePutPaymentOption);
var _routes = require("Modules/creditDebit/routes");
var _reactLocation = require("react-location");
const routes = {
    'credit-debit': {
        creditDebit: (0, _routes.creditDebitCheckoutPath)
    },
    mixed: {
        downPayment: (0, _routes.mixedDownPaymentCheckoutPath),
        signFinancingApplication: (0, _routes.mixedFinancingPath)
    },
    financing: {
        signFinancingApplication: (0, _routes.financingPath)
    }
};
function Teleaudiology() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { mutateAsync: setPaymentOption } = (0, _usePutPaymentOptionDefault.default)();
    const { data: nextSteps, isLoading } = (0, _useGetNextSteps.useGetNextSteps)();
    const navigate = (0, _reactLocation.useNavigate)();
    const updateAndRoute = (0, _react.useCallback)(async ()=>{
        const { paymentOption, steps } = nextSteps;
        if (paymentOption && paymentOption !== 'N/A') await setPaymentOption(paymentOption);
        if (steps.length === 0) return navigate({
            to: (0, _routes.paymentOptionsPath),
            search: true
        });
        const [{ id }] = steps;
        return navigate({
            to: routes[paymentOption][id],
            search: true
        });
    }, [
        navigate,
        nextSteps,
        setPaymentOption
    ]);
    (0, _react.useEffect)(()=>{
        if (nextSteps) updateAndRoute().then();
    }, [
        nextSteps,
        updateAndRoute
    ]);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.nextSteps')
    });
    return null;
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/hooks/queries/order/useGetNextSteps":"1pGmV","Core/components/Loader":"6S7S4","react-i18next":"244ua","Core/hooks/queries/payment/usePutPaymentOption":"iygdF","Modules/creditDebit/routes":"yRzgP","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1pGmV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetNextSteps", ()=>useGetNextSteps);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _api = require("Core/utils/api");
function useGetNextSteps() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data: order } = (0, _useOrderDefault.default)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).nextSteps, ()=>(0, _api.get)(`/api/orders/${order.orderId}/next-steps`), {
        enabled: Boolean(order),
        onError (e) {
            setErrorAlert(t('status.error.getNextStepsFailed'));
            throw e;
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/stores/alert":"fPz3p","Core/hooks/queries/cacheKeys":"i5IL7","Core/hooks/queries/order/useOrder":"7ieVC","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7ieVC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOrder);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
var _reactLocation = require("react-location");
var _routes = require("Core/routes");
function useOrder({ enabled = true } = {}) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactLocation.useNavigate)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).order, ()=>(0, _api.get)(`/api/orders`), {
        enabled,
        onError (e) {
            const message = e?.response?.data?.message ? ` - ${e?.response?.data?.message}` : '';
            setError(t('status.error.orderServiceFailed') + message);
            navigate({
                to: (0, _routes.errorPath)
            });
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/stores/error":"38MVH","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","react-location":"8hNco","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iygdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePutPaymentOption);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
function usePutPaymentOption() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    return (0, _reactQuery.useMutation)((option)=>{
        const { orderId } = queryClient.getQueryData('order');
        return (0, _api.put)(`/api/payment-options`, {
            orderId,
            option
        });
    }, {
        onSuccess () {
            return Promise.all([
                queryClient.invalidateQueries((0, _cacheKeysDefault.default).paymentSummary),
                queryClient.invalidateQueries((0, _cacheKeysDefault.default).order)
            ]);
        },
        onError () {
            setErrorAlert(t('status.error.putPaymentOptionQueryFailed'));
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/stores/alert":"fPz3p","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"yRzgP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dashboardPath", ()=>dashboardPath);
parcelHelpers.export(exports, "paymentOptionsPath", ()=>paymentOptionsPath);
parcelHelpers.export(exports, "creditDebitCheckoutPath", ()=>creditDebitCheckoutPath);
parcelHelpers.export(exports, "creditDebitSuccessPath", ()=>creditDebitSuccessPath);
parcelHelpers.export(exports, "creditDebitErrorPath", ()=>creditDebitErrorPath);
parcelHelpers.export(exports, "createFinancingPath", ()=>createFinancingPath);
parcelHelpers.export(exports, "financingPath", ()=>financingPath);
parcelHelpers.export(exports, "financingSuccessPath", ()=>financingSuccessPath);
parcelHelpers.export(exports, "financingErrorPath", ()=>financingErrorPath);
parcelHelpers.export(exports, "mixedAvailableCreditPath", ()=>mixedAvailableCreditPath);
parcelHelpers.export(exports, "mixedDownPaymentCheckoutPath", ()=>mixedDownPaymentCheckoutPath);
parcelHelpers.export(exports, "mixedFinancingPath", ()=>mixedFinancingPath);
parcelHelpers.export(exports, "mixedSuccessPath", ()=>mixedSuccessPath);
parcelHelpers.export(exports, "mixedErrorPath", ()=>mixedErrorPath);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dashboard = require("Modules/creditDebit/routes/Dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _paymentOptions = require("Modules/creditDebit/routes/PaymentOptions");
var _paymentOptionsDefault = parcelHelpers.interopDefault(_paymentOptions);
var _checkout = require("Modules/creditDebit/routes/Checkout");
var _checkoutDefault = parcelHelpers.interopDefault(_checkout);
var _success = require("Modules/creditDebit/routes/Success");
var _successDefault = parcelHelpers.interopDefault(_success);
var _error = require("Modules/creditDebit/routes/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _financingRedirect = require("Modules/creditDebit/routes/FinancingRedirect");
var _financingRedirectDefault = parcelHelpers.interopDefault(_financingRedirect);
var _financingSuccess = require("Modules/creditDebit/routes/FinancingSuccess");
var _financingSuccessDefault = parcelHelpers.interopDefault(_financingSuccess);
var _financingError = require("Modules/creditDebit/routes/FinancingError");
var _financingErrorDefault = parcelHelpers.interopDefault(_financingError);
var _financing = require("Modules/creditDebit/routes/Financing");
var _financingDefault = parcelHelpers.interopDefault(_financing);
var _orderData = require("Core/./components/Data/OrderData");
var _orderDataDefault = parcelHelpers.interopDefault(_orderData);
var _availableCredit = require("Modules/creditDebit/routes/AvailableCredit");
var _availableCreditDefault = parcelHelpers.interopDefault(_availableCredit);
var _mixedSuccess = require("Modules/creditDebit/routes/MixedSuccess");
var _mixedSuccessDefault = parcelHelpers.interopDefault(_mixedSuccess);
var _mixedError = require("Modules/creditDebit/routes/MixedError");
var _mixedErrorDefault = parcelHelpers.interopDefault(_mixedError);
const dashboardPath = '/office';
const paymentOptionsPath = '/';
const creditDebitCheckoutPath = '/credit-debit/checkout';
const creditDebitSuccessPath = '/credit-debit/success';
const creditDebitErrorPath = '/credit-debit/error';
const createFinancingPath = '/office/financing';
const financingPath = '/financing';
const financingSuccessPath = '/financing/funded';
const financingErrorPath = '/financing/declined';
const mixedAvailableCreditPath = '/mixed/available-credit';
const mixedDownPaymentCheckoutPath = '/mixed/down-payment/checkout';
const mixedFinancingPath = '/mixed/financing';
const mixedSuccessPath = '/mixed/success';
const mixedErrorPath = '/mixed/error';
const routes = [
    {
        path: dashboardPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardDefault.default), {})
        })
    },
    {
        path: paymentOptionsPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentOptionsDefault.default), {})
        })
    },
    {
        path: creditDebitCheckoutPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkoutDefault.default), {
                nextRoutes: {
                    success: creditDebitSuccessPath,
                    error: creditDebitErrorPath
                }
            })
        })
    },
    {
        path: creditDebitSuccessPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _successDefault.default), {})
        })
    },
    {
        path: creditDebitErrorPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {})
        })
    },
    {
        path: createFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingRedirectDefault.default), {})
    },
    {
        path: financingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDefault.default), {
                nextRoutes: {
                    success: financingSuccessPath,
                    error: financingErrorPath
                }
            })
        })
    },
    {
        path: financingSuccessPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingSuccessDefault.default), {})
        })
    },
    {
        path: financingErrorPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingErrorDefault.default), {})
        })
    },
    {
        path: mixedAvailableCreditPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _availableCreditDefault.default), {})
        })
    },
    {
        path: mixedDownPaymentCheckoutPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkoutDefault.default), {
                nextRoutes: {
                    success: mixedFinancingPath,
                    error: mixedErrorPath
                }
            })
        })
    },
    {
        path: mixedFinancingPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _financingDefault.default), {
                nextRoutes: {
                    success: mixedSuccessPath,
                    error: mixedErrorPath
                }
            })
        })
    },
    {
        path: mixedSuccessPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mixedSuccessDefault.default), {})
        })
    },
    {
        path: mixedErrorPath,
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mixedErrorDefault.default), {})
        })
    }
];

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/creditDebit/routes/Dashboard":"2w0Rx","Modules/creditDebit/routes/PaymentOptions":"cae7Q","Modules/creditDebit/routes/Checkout":"bEerd","Modules/creditDebit/routes/Success":"iazyi","Modules/creditDebit/routes/Error":"cNOI3","Modules/creditDebit/routes/FinancingRedirect":"6aSIU","Modules/creditDebit/routes/FinancingSuccess":"394BH","Modules/creditDebit/routes/FinancingError":"2dFe2","Modules/creditDebit/routes/Financing":"fmUAN","Core/./components/Data/OrderData":"jg54z","Modules/creditDebit/routes/AvailableCredit":"gnIMU","Modules/creditDebit/routes/MixedSuccess":"4ARYe","Modules/creditDebit/routes/MixedError":"40NOf","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2w0Rx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Dashboard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _shoppingCart = require("Core/components/ShoppingCart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
var _collectPaymentPanel = require("Core/components/Panels/CollectPaymentPanel");
var _collectPaymentPanelDefault = parcelHelpers.interopDefault(_collectPaymentPanel);
var _sendPaymentLinkPanel = require("Core/components/Panels/SendPaymentLinkPanel");
var _sendPaymentLinkPanelDefault = parcelHelpers.interopDefault(_sendPaymentLinkPanel);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _page1 = require("Core/stores/page");
var _pageDefault1 = parcelHelpers.interopDefault(_page1);
var _layout = require("Core/components/Layout");
var _reactLocation = require("react-location");
var _routes = require("Modules/creditDebit/routes");
function Dashboard() {
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const setIsOfficeUser = (0, _pageDefault1.default)((state)=>state.setIsOfficeUser);
    const navigate = (0, _reactLocation.useNavigate)();
    (0, _reactDefault.default).useEffect(()=>{
        setIsOfficeUser(true);
    }, [
        setIsOfficeUser
    ]);
    function gotoNext() {
        navigate({
            to: (0, _routes.paymentOptionsPath),
            search: true
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.dashboard.header'),
        withStepProgress: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                "data-testid": "infobox",
                children: t('page.dashboard.infobox')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shoppingCartDefault.default), {
                withTitle: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex md:!flex-col-6",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendPaymentLinkPanelDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: "!flex md:!flex-col-6",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectPaymentPanelDefault.default), {
                            gotoNext: gotoNext
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Core/components/ShoppingCart":"2uMp1","Core/components/Panels/CollectPaymentPanel":"amxSR","Core/components/Panels/SendPaymentLinkPanel":"inIDp","Core/components/Page":"4xeqH","Core/stores/page":"bdfbS","Core/components/Layout":"hweet","react-location":"8hNco","Modules/creditDebit/routes":"yRzgP","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2uMp1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _shoppingCart = require("./ShoppingCart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
exports.default = (0, _shoppingCartDefault.default);

},{"./ShoppingCart":"dKGpo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dKGpo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _utils = require("Core/utils/utils");
var _cartHeader = require("./CartHeader");
var _cartHeaderDefault = parcelHelpers.interopDefault(_cartHeader);
var _cartItems = require("./CartItems");
var _cartItemsDefault = parcelHelpers.interopDefault(_cartItems);
var _cartFooter = require("./CartFooter");
var _cartFooterDefault = parcelHelpers.interopDefault(_cartFooter);
var _disclaimer = require("./Disclaimer");
var _disclaimerDefault = parcelHelpers.interopDefault(_disclaimer);
var _useGetPaymentSummary = require("Core/hooks/queries/payment/useGetPaymentSummary");
var _useGetPaymentSummaryDefault = parcelHelpers.interopDefault(_useGetPaymentSummary);
var _item = require("Core/components/ShoppingCart/CartItems/Item");
var _itemDefault = parcelHelpers.interopDefault(_item);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function StyledCart({ withElevation, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)('bg-white rounded p-2 mb-4', {
            'box-shadow: 0 7px 7px -3px #c3c3c3': withElevation
        }),
        children: children
    });
}
const ShoppingCart = ({ withTitle = false, withElevation = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data: paymentSummary } = (0, _useGetPaymentSummaryDefault.default)();
    if (!paymentSummary) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledCart, {
        withElevation: withElevation,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartHeaderDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemDefault.default), {})
                ]
            })
        ]
    });
    const { quoteDetails: { items }, insuranceBenefit } = paymentSummary;
    const hasInsuranceBenefit = insuranceBenefit > 0;
    const sortedItems = items.concat([]).sort((0, _utils.multiSortByObjectProp)('-unitPrice', 'description'));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            withTitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                "data-testid": "shopping-cart-headline",
                children: t('common.shoppingCart')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledCart, {
                withElevation: withElevation,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartHeaderDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartItemsDefault.default), {
                        items: sortedItems
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartFooterDefault.default), {
                        paymentSummary: paymentSummary
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclaimerDefault.default), {
                        content: t('common.insuranceBenefitDisclaimer'),
                        show: hasInsuranceBenefit
                    })
                ]
            })
        ]
    });
};
exports.default = ShoppingCart;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/utils/utils":"hwOBZ","./CartHeader":"3IdMW","./CartItems":"f524B","./CartFooter":"k7WdJ","./Disclaimer":"k64pA","Core/hooks/queries/payment/useGetPaymentSummary":"2UTqE","Core/components/ShoppingCart/CartItems/Item":"6q05N","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"3IdMW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cartHeader = require("./CartHeader");
var _cartHeaderDefault = parcelHelpers.interopDefault(_cartHeader);
exports.default = (0, _cartHeaderDefault.default);

},{"./CartHeader":"ly2ou","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"ly2ou":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
const CartHeader = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: 'flex flex-nowrap text-right text-sm py-0.5 px-1 font-bold',
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-left px-1 [width:45%]",
                children: t('common.item')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "px-1 [width:25%]",
                children: t('common.quantity')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "px-1 [width:30%]",
                children: t('common.total')
            })
        ]
    });
};
exports.default = CartHeader;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"f524B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cartItems = require("./CartItems");
var _cartItemsDefault = parcelHelpers.interopDefault(_cartItems);
exports.default = (0, _cartItemsDefault.default);

},{"./CartItems":"juNTA","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"juNTA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _item = require("./Item");
var _itemDefault = parcelHelpers.interopDefault(_item);
const CartItems = ({ items })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: items.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemDefault.default), {
                label: item.description,
                quantity: item.quantity,
                amount: item.amount
            }, `cart-item-${index}`))
    });
};
exports.default = CartItems;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","./Item":"6q05N","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6q05N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _numberFormat = require("Core/utils/numberFormat");
function Skeleton() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "h-5 rounded w-full bg-gray-200 animate-pulse"
    });
}
const Item = ({ amount, label, quantity = null })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: 'flex flex-nowrap text-right text-sm py-2 px-1 bg-white border-t border-solid border-gray-300',
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-left px-1 [width:45%]",
                children: label || /*#__PURE__*/ (0, _jsxRuntime.jsx)(Skeleton, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "px-1 [width:25%]",
                children: quantity ?? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Skeleton, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "px-1 font-bold [width:30%]",
                children: typeof amount === 'number' ? (0, _numberFormat.formatCurrency)(amount) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Skeleton, {})
            })
        ]
    });
};
exports.default = Item;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","Core/utils/numberFormat":"6T56F","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"k7WdJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cartFooter = require("./CartFooter");
var _cartFooterDefault = parcelHelpers.interopDefault(_cartFooter);
exports.default = (0, _cartFooterDefault.default);

},{"./CartFooter":"bM9AC","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bM9AC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _footerBlock = require("./FooterBlock");
var _footerBlockDefault = parcelHelpers.interopDefault(_footerBlock);
var _footerItem = require("./FooterItem");
var _footerItemDefault = parcelHelpers.interopDefault(_footerItem);
var _constants = require("Core/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _numberFormat = require("Core/utils/numberFormat");
const CartFooter = ({ paymentSummary })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data: order } = (0, _useOrderDefault.default)();
    const { quoteDetails: { totalAmount, totalDiscountAmount }, amountAlreadyPaid, payments, totalAmountToPay, insuranceBenefit, hearingTestFee = 0 } = paymentSummary;
    const isMixedPayment = order.optionSelected === (0, _constantsDefault.default).paymentOptions.MIXED;
    const hasDiscount = totalDiscountAmount > 0;
    const hasDeposit = payments.length && payments.find((payment)=>payment.purpose.toLowerCase() === 'deposit');
    const hasInsuranceBenefit = insuranceBenefit > 0;
    const showAvailableCredit = !isMixedPayment && hasDeposit && amountAlreadyPaid > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _footerBlockDefault.default), {
                testid: "static-cart-footer-block",
                children: [
                    hasDiscount ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerItemDefault.default), {
                        label: t('common.discountIncluded'),
                        amount: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            "data-testid": "discount",
                            className: "text-success",
                            children: (0, _numberFormat.formatCurrency)(-totalDiscountAmount)
                        })
                    }) : null,
                    showAvailableCredit ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerItemDefault.default), {
                        label: t('common.availableCredit'),
                        amount: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            "data-testid": "availableCredit",
                            className: "text-success",
                            children: (0, _numberFormat.formatCurrency)(-amountAlreadyPaid)
                        })
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerItemDefault.default), {
                        label: t('common.total'),
                        amount: (0, _numberFormat.formatCurrency)(totalAmount)
                    }),
                    hearingTestFee > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerItemDefault.default), {
                        label: t('common.hearingTestFee'),
                        amount: (0, _numberFormat.formatCurrency)(-hearingTestFee)
                    }) : null
                ]
            }),
            hasInsuranceBenefit ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _footerBlockDefault.default), {
                testid: "insurance-cart-footer-block",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerItemDefault.default), {
                        label: t('common.expectedInsuranceBenefit'),
                        amount: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            "data-testid": "expectedInsuranceBenefit",
                            className: "text-success",
                            children: (0, _numberFormat.formatCurrency)(-insuranceBenefit)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerItemDefault.default), {
                        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: t('common.amountDue')
                        }),
                        amount: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: (0, _numberFormat.formatCurrency)(totalAmountToPay)
                        })
                    })
                ]
            }) : null
        ]
    });
};
exports.default = CartFooter;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/queries/order/useOrder":"7ieVC","./FooterBlock":"5S2uS","./FooterItem":"e8Fmu","Core/config/constants":"ad5OP","Core/utils/numberFormat":"6T56F","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5S2uS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const FooterBlock = ({ children, testid = '' })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: 'px-1 my-2 last:mb-0',
        "data-testid": testid,
        children: children
    });
};
exports.default = FooterBlock;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"e8Fmu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const FooterItem = ({ label, amount })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-wrap text-sm text-right",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-3/4 px-2 ",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-1/4 px-2 ",
                children: amount
            })
        ]
    });
};
exports.default = FooterItem;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"k64pA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const Disclaimer = ({ content, show = false })=>{
    return show && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "pt-2 mt-2 border-t border-solid border-gray-300 text-xxs",
        children: content
    });
};
exports.default = Disclaimer;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2UTqE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryFn", ()=>queryFn);
parcelHelpers.export(exports, "default", ()=>useGetPaymentSummary);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
const queryFn = (orderId)=>(0, _api.get)(`/api/orders/${orderId}/payment-summary`);
function useGetPaymentSummary() {
    const { data: order } = (0, _useOrderDefault.default)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).paymentSummary, ()=>queryFn(order.orderId), {
        enabled: Boolean(order),
        onError (e) {
            setErrorAlert(t('status.error.paymentSummaryQueryFailed'));
            throw e;
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/hooks/queries/order/useOrder":"7ieVC","Core/stores/alert":"fPz3p","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"amxSR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CollectPaymentPanel);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _button = require("Core/components/Button");
var _creditCardLogos = require("Core/components/CreditCardLogos");
var _creditCardLogosDefault = parcelHelpers.interopDefault(_creditCardLogos);
var _allegroLogoPng = require("url:Images/allegro-logo.png");
var _allegroLogoPngDefault = parcelHelpers.interopDefault(_allegroLogoPng);
var _panels = require("Core/components/Panels/Panels");
function CollectPaymentPanel({ gotoNext }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _panels.StyledCard), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _panels.StyledCardHeader), {
                children: t('page.dashboard.panel.collectPaymentTitle')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _panels.StyledCardBody), {
                children: [
                    t('page.dashboard.panel.collectPaymentBody'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col justify-center h-full",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creditCardLogosDefault.default), {
                                size: "large"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mt-4 text-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: (0, _allegroLogoPngDefault.default),
                                    style: {
                                        height: '48px',
                                        margin: 'auto'
                                    },
                                    alt: "hear.com"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _panels.StyledCardFooter), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                    block: true,
                    size: "small",
                    "data-testid": "continue",
                    onClick: ()=>gotoNext(),
                    children: t('page.dashboard.panel.collectPaymentButton')
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/components/Button":"6YNzH","Core/components/CreditCardLogos":"dnezw","url:Images/allegro-logo.png":"cvMSa","Core/components/Panels/Panels":"eOGox","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cvMSa":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("9Mym1");

},{}],"eOGox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCard", ()=>StyledCard);
parcelHelpers.export(exports, "StyledCardHeader", ()=>StyledCardHeader);
parcelHelpers.export(exports, "StyledCardBody", ()=>StyledCardBody);
parcelHelpers.export(exports, "StyledCardFooter", ()=>StyledCardFooter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const StyledCard = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col border border-solid rounded border-gray-300 break-words bg-white bg-clip-border w-full",
        children: children
    });
const StyledCardHeader = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "font-bold p-2 bg-gray-100 border-0 border-b rounded-t border-solid border-gray-300",
        children: children
    });
const StyledCardBody = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col flex-1 p-2",
        children: children
    });
const StyledCardFooter = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "p-2",
        children: children
    });

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"inIDp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SendPaymentLinkPanel);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _button = require("Core/components/Button");
var _copyField = require("Core/components/FormElements/CopyField");
var _copyFieldDefault = parcelHelpers.interopDefault(_copyField);
var _utils = require("Core/utils/utils");
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _usePostPaymentInvitation = require("Core/hooks/queries/payment/usePostPaymentInvitation");
var _usePostPaymentInvitationDefault = parcelHelpers.interopDefault(_usePostPaymentInvitation);
var _panels = require("Core/components/Panels/Panels");
var _textArea = require("Core/components/FormElements/TextArea");
var _textAreaDefault = parcelHelpers.interopDefault(_textArea);
var _spinner = require("Core/components/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _reactHookForm = require("react-hook-form");
var _zod = require("@hookform/resolvers/zod");
var _v3 = require("zod/v3");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function SendPaymentLinkPanel() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data: order } = (0, _useOrderDefault.default)();
    const { mutateAsync: sendPaymentInvitation, isLoading, status } = (0, _usePostPaymentInvitationDefault.default)();
    const [statusMessage, setStatusMessage] = (0, _reactDefault.default).useState();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            emails: _v3.string().transform((text)=>text.split('\n')).refine((emails)=>{
                const { success } = _v3.array(_v3.string().email()).safeParse(emails);
                return success;
            }, {
                message: t('status.error.invalidEmailAddress')
            }).refine((emails)=>[
                    ...new Set(emails)
                ].length === emails.length, {
                message: t('status.error.duplicateEmailAddress')
            })
        });
    }, [
        t
    ]);
    const { register, handleSubmit, reset, watch, formState: { errors, isSubmitSuccessful } } = (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        defaultValues: {
            emails: ''
        },
        shouldUnregister: true
    });
    const statusMessageStyle = status === 'error' || !(0, _utils.isEmpty)(errors) ? `text-error` : status === 'success' ? `text-success` : ``;
    (0, _reactDefault.default).useEffect(()=>{
        isSubmitSuccessful && reset();
    }, [
        isSubmitSuccessful,
        reset
    ]);
    async function onSubmit(formData) {
        setStatusMessage(t('status.loading.submitInviteEmail'));
        try {
            await sendPaymentInvitation({
                orderId: order.orderId,
                emailList: formData.emails
            });
            reset();
            setStatusMessage(t('status.success.sendingPaymentInviteEmail'));
        } catch (_) {
            setStatusMessage(t('status.error.sendingPaymentInviteEmail'));
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
        name: "sendPaymentLinkForm",
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _panels.StyledCard), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _panels.StyledCardHeader), {
                    children: t('page.dashboard.panel.sendInviteEmailTitle')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _panels.StyledCardBody), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAreaDefault.default), {
                            register: register,
                            label: t('page.dashboard.panel.sendInviteEmailBody'),
                            name: "emails"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _classnamesDefault.default)(`py-1 text-xs`, statusMessageStyle),
                            children: errors?.emails?.message || statusMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _panels.StyledCardFooter), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.PrimaryButton), {
                        block: true,
                        size: "small",
                        "data-testid": "send-emails",
                        type: "submit",
                        disabled: isLoading || !watch('emails'),
                        children: [
                            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                                small: true
                            }),
                            isLoading ? t('status.loading.submitInviteEmail') : t('page.dashboard.panel.sendInviteEmailButton')
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _panels.StyledCardFooter), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyFieldDefault.default), {
                        value: (0, _utils.getPaymentPortalUrl)(window.location.href),
                        testid: "paymentPortalUrlCopy"
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/components/Button":"6YNzH","Core/components/FormElements/CopyField":"l6wUj","Core/utils/utils":"hwOBZ","Core/hooks/queries/order/useOrder":"7ieVC","Core/hooks/queries/payment/usePostPaymentInvitation":"bWYuc","Core/components/Panels/Panels":"eOGox","Core/components/FormElements/TextArea":"4x6Sp","Core/components/Spinner":"bZo5I","react-hook-form":"53GLT","@hookform/resolvers/zod":"c0M5u","zod/v3":"kXNSc","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"l6wUj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useClipboardCopy = require("use-clipboard-copy");
var _button = require("Core/components/Button");
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
const CopyField = ({ value, testid })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const clipboard = (0, _useClipboardCopy.useClipboard)({
        copiedTimeout: 3000
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formElementsStyled.StyledFormElement), {
                className: "!mr-1",
                size: "small",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    "aria-label": t('aria.paymentUrl'),
                    "data-testid": `${testid}Field`,
                    value: value,
                    ref: clipboard.target,
                    readOnly: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                size: "small",
                "data-testid": `${testid}Button`,
                "data-toggle": "button",
                "aria-pressed": clipboard.copied ? 'true' : 'false',
                onClick: clipboard.copy,
                children: clipboard.copied ? t('common.copied') : t('common.copy')
            })
        ]
    });
};
exports.default = CopyField;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","use-clipboard-copy":"gpYgD","Core/components/Button":"6YNzH","Core/components/FormElements/formElements.styled":"45aFS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gpYgD":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useClipboard = void 0;
var clipboard_copy_1 = __importDefault(require("443715bad34490cd"));
var react_1 = require("b71db22d5ce907a1");
var useTimedToggle_1 = require("f581e9702aa92779");
function isInputLike(node) {
    return node && (node.nodeName === 'TEXTAREA' || node.nodeName === 'INPUT');
}
function useClipboard(options) {
    if (options === void 0) options = {};
    var _a = useTimedToggle_1.useTimedToggle(false), copied = _a[0], toggleCopied = _a[1];
    var targetRef = react_1.useRef(null);
    var optionsRef = react_1.useRef(options);
    optionsRef.current = options;
    function isSupported() {
        return !!navigator.clipboard || typeof document.execCommand === 'function' && typeof document.queryCommandSupported === 'function' && document.queryCommandSupported('copy');
    }
    var copyHandler = react_1.useCallback(function(text) {
        var opts = optionsRef.current;
        var target = targetRef.current;
        function handleSuccess() {
            if (opts.onSuccess) opts.onSuccess();
            if (opts.copiedTimeout) toggleCopied(opts.copiedTimeout);
            if (opts.selectOnCopy && isInputLike(target)) target.select();
        }
        function handleError() {
            if (opts.onError) opts.onError();
            if (opts.selectOnError !== false && isInputLike(target)) target.select();
        }
        function copy(value) {
            clipboard_copy_1.default(value).then(handleSuccess).catch(handleError);
        }
        if (typeof text === 'string') copy(text);
        else if (target) copy(target.value);
    }, []);
    return {
        copied: copied,
        copy: copyHandler,
        isSupported: isSupported,
        target: targetRef
    };
}
exports.useClipboard = useClipboard;

},{"443715bad34490cd":"8UDMV","b71db22d5ce907a1":"2o0ib","f581e9702aa92779":"2ZyS7"}],"8UDMV":[function(require,module,exports,__globalThis) {
/*! clipboard-copy. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* global DOMException */ module.exports = clipboardCopy;
function clipboardCopy(text) {
    // Use the Async Clipboard API when available. Requires a secure browsing
    // context (i.e. HTTPS)
    if (navigator.clipboard) return navigator.clipboard.writeText(text).catch(function(err) {
        throw err !== undefined ? err : new DOMException('The request is not allowed', 'NotAllowedError');
    });
    // ...Otherwise, use document.execCommand() fallback
    // Put the text to copy into a <span>
    var span = document.createElement('span');
    span.textContent = text;
    // Preserve consecutive spaces and newlines
    span.style.whiteSpace = 'pre';
    span.style.webkitUserSelect = 'auto';
    span.style.userSelect = 'all';
    // Add the <span> to the page
    document.body.appendChild(span);
    // Make a selection object representing the range of text selected by the user
    var selection = window.getSelection();
    var range = window.document.createRange();
    selection.removeAllRanges();
    range.selectNode(span);
    selection.addRange(range);
    // Copy text to the clipboard
    var success = false;
    try {
        success = window.document.execCommand('copy');
    } catch (err) {
        console.log('error', err);
    }
    // Cleanup
    selection.removeAllRanges();
    window.document.body.removeChild(span);
    return success ? Promise.resolve() : Promise.reject(new DOMException('The request is not allowed', 'NotAllowedError'));
}

},{}],"2ZyS7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTimedToggle = void 0;
var react_1 = require("b5c0ff6de38a1fe");
function useTimedToggle(initialValue) {
    var _a = react_1.useState(false), value = _a[0], setValue = _a[1];
    var timeoutRef = react_1.useRef();
    var initialValueRef = react_1.useRef(initialValue);
    var toggleValue = function(timeout) {
        clearTimeout(timeoutRef.current);
        setValue(!initialValueRef.current);
        timeoutRef.current = window.setTimeout(function() {
            return setValue(initialValueRef.current);
        }, timeout);
    };
    react_1.useEffect(function() {
        return function() {
            return clearTimeout(timeoutRef.current);
        };
    }, []);
    return [
        value,
        toggleValue
    ];
}
exports.useTimedToggle = useTimedToggle;

},{"b5c0ff6de38a1fe":"2o0ib"}],"bWYuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePostPaymentInvitation);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _api = require("Core/utils/api");
var _logger = require("Core/utils/logger");
function usePostPaymentInvitation() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    return (0, _reactQuery.useMutation)(({ orderId, emailList = [] })=>(0, _api.post)(`/api/payment-invitations/sendInvitation`, {
            orderId,
            email: emailList
        }), {
        onError (e) {
            setErrorAlert(t('status.error.sendingPaymentInviteEmail'));
            throw e;
        },
        onSuccess () {
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).sendPaymentLink,
                status: 'success'
            });
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/stores/alert":"fPz3p","Core/utils/api":"cC5Cp","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4x6Sp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _error = require("./Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
const TextArea = (props)=>{
    const { className, disabled = false, error = '', name = '', id = name, label, maxLength = 64, rows = 3, valid = true, value, register } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormElement), {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                id: id,
                name: name,
                value: value,
                maxLength: maxLength,
                rows: rows,
                disabled: disabled,
                style: {
                    resize: 'none'
                },
                ...register(name)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                message: error,
                show: !valid
            })
        ]
    });
};
exports.default = TextArea;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","./Error":"dyj9l","Core/components/FormElements/formElements.styled":"45aFS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bdfbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _zustand = require("zustand");
exports.default = (0, _zustand.create)((set)=>({
        isOfficeUser: false,
        setIsOfficeUser: (isOfficeUser)=>set({
                isOfficeUser
            })
    }));

},{"zustand":"61uwS","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cae7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentOptions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _constants = require("Core/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _footer = require("Core/components/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _alert = require("Core/components/Alert");
var _optionsList = require("Core/components/OptionsList");
var _optionsListDefault = parcelHelpers.interopDefault(_optionsList);
var _options = require("Core/components/Options");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _creditCardLogos = require("Core/components/CreditCardLogos");
var _creditCardLogosDefault = parcelHelpers.interopDefault(_creditCardLogos);
var _allegroLogoPng = require("url:Images/allegro-logo.png");
var _allegroLogoPngDefault = parcelHelpers.interopDefault(_allegroLogoPng);
var _alert1 = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert1);
var _payment = require("Core/stores/payment");
var _paymentDefault = parcelHelpers.interopDefault(_payment);
var _shallow = require("zustand/shallow");
var _shallowDefault = parcelHelpers.interopDefault(_shallow);
var _useGetPaymentSummary = require("Core/hooks/queries/payment/useGetPaymentSummary");
var _useGetPaymentSummaryDefault = parcelHelpers.interopDefault(_useGetPaymentSummary);
var _page = require("Core/stores/page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _useGetPaymentOptions = require("Core/hooks/queries/payment/useGetPaymentOptions");
var _useGetPaymentOptionsDefault = parcelHelpers.interopDefault(_useGetPaymentOptions);
var _usePutPaymentOption = require("Core/hooks/queries/payment/usePutPaymentOption");
var _usePutPaymentOptionDefault = parcelHelpers.interopDefault(_usePutPaymentOption);
var _usePostCaptureAvailableCredit = require("Core/hooks/queries/payment/usePostCaptureAvailableCredit");
var _usePostCaptureAvailableCreditDefault = parcelHelpers.interopDefault(_usePostCaptureAvailableCredit);
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _page1 = require("Core/components/Page");
var _pageDefault1 = parcelHelpers.interopDefault(_page1);
var _useShowSidebar = require("Core/hooks/useShowSidebar");
var _shoppingCart = require("Core/components/ShoppingCart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
var _layout = require("Core/components/Layout");
var _routes = require("Modules/creditDebit/routes");
var _reactLocation = require("react-location");
function getEnabledPaymentOptions(statusList, paymentOptionList) {
    return statusList.map((status)=>{
        const paymentOption = paymentOptionList.filter((item)=>item.option === status.option).pop() || {};
        return {
            ...paymentOption,
            ...status,
            disabled: !!status.message
        };
    }).filter(({ enabled, message })=>enabled || message);
}
const paymentSelector = ({ selectedOption, setPaymentState })=>({
        selectedOption,
        setPaymentState
    });
const checkDepositCoversDownPayment = ({ amountAlreadyPaid, downPayment, payments })=>{
    const hasDeposit = payments.length && payments.find((payment)=>payment.purpose.toLowerCase() === 'deposit');
    return hasDeposit && amountAlreadyPaid >= downPayment;
};
function PaymentOptions() {
    (0, _useScrollTop.useScrollTop)();
    const shouldShowSidebar = (0, _useShowSidebar.useShowSidebar)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const payment = (0, _paymentDefault.default)(paymentSelector, (0, _shallowDefault.default));
    const clearAlert = (0, _alertDefault.default)((0, _alert1.clearAlertSelector));
    const setErrorAlert = (0, _alertDefault.default)((0, _alert1.setErrorAlertSelector));
    const isOfficeUser = (0, _pageDefault.default)((state)=>state.isOfficeUser);
    const navigate = (0, _reactLocation.useNavigate)();
    // server state
    const { data: order } = (0, _useOrderDefault.default)();
    const { data: paymentSummary, isLoading: isPaymentSummaryLoading } = (0, _useGetPaymentSummaryDefault.default)();
    const { data: paymentOptions, isLoading: isPaymentOptionsLoading } = (0, _useGetPaymentOptionsDefault.default)();
    const { mutateAsync: setPaymentOption, isSuccess: isSetPaymentOptionSuccess, isLoading: isSetPaymentOptionLoading } = (0, _usePutPaymentOptionDefault.default)();
    const { mutateAsync: chargeAvailableCredit, isLoading: isPostCaptureAvailableCreditLoading } = (0, _usePostCaptureAvailableCreditDefault.default)();
    if (isPaymentSummaryLoading || isPaymentOptionsLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.paymentOptions')
    });
    if (isSetPaymentOptionLoading || isSetPaymentOptionSuccess || isPostCaptureAvailableCreditLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.savingPaymentOption')
    });
    if (!order && !paymentSummary && !paymentOptions) return null;
    const onSelectPaymentOption = (option)=>{
        clearAlert();
        payment.setPaymentState({
            selectedOption: option
        });
    };
    const gotoPrevPage = ()=>{
        clearAlert();
        const route = isOfficeUser ? (0, _routes.dashboardPath) : (0, _routes.paymentOptionsPath);
        navigate({
            to: route,
            search: true
        });
    };
    const gotoNextPage = async ()=>{
        clearAlert();
        if (!payment.selectedOption) {
            setErrorAlert(t('status.error.noPaymentOptionSelected'));
            return;
        }
        // skip checkout and jump directly to the financing part
        if (payment.selectedOption === (0, _constantsDefault.default).paymentOptions.MIXED && order.status === (0, _constantsDefault.default).orderStatus.IN_PROGRESS) return navigate({
            to: (0, _routes.mixedFinancingPath),
            search: true
        });
        await setPaymentOption(payment.selectedOption);
        const updatedPaymentSummary = queryClient.getQueryData((0, _cacheKeysDefault.default).paymentSummary);
        const hasAvailableCredit = checkDepositCoversDownPayment(updatedPaymentSummary);
        // when the user has paid a deposit that is greater than or equal to the down payment amount,
        // try to capture the deposit, redirect and inform the user that we captured the deposit as a
        // down payment
        if (payment.selectedOption === (0, _constantsDefault.default).paymentOptions.MIXED && hasAvailableCredit) {
            await chargeAvailableCredit();
            return navigate({
                to: (0, _routes.mixedAvailableCreditPath),
                search: true
            });
        }
        const targets = {
            'credit-debit': (0, _routes.creditDebitCheckoutPath),
            financing: (0, _routes.financingPath),
            mixed: (0, _routes.mixedDownPaymentCheckoutPath)
        };
        navigate({
            to: targets[payment.selectedOption],
            search: true
        });
    };
    const showAvailableCreditNote = checkDepositCoversDownPayment(paymentSummary);
    const paymentOptionConfig = [
        {
            option: (0, _constantsDefault.default).paymentOptions.CREDIT_DEBIT,
            image: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creditCardLogosDefault.default), {
                size: "small"
            }),
            label: t('page.paymentOptions.creditDebitTitle'),
            description: t('page.paymentOptions.creditDebitDescription')
        },
        {
            option: (0, _constantsDefault.default).paymentOptions.FINANCING,
            label: t('page.paymentOptions.financingTitle'),
            image: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _allegroLogoPngDefault.default),
                alt: t('page.paymentOptions.financingTitle')
            }),
            description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    t('page.paymentOptions.financingDescription'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: t('page.paymentOptions.financingNote')
                    })
                ]
            })
        },
        {
            option: (0, _constantsDefault.default).paymentOptions.MIXED,
            label: t('page.paymentOptions.mixedTitle'),
            image: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creditCardLogosDefault.default), {
                size: "small",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: (0, _allegroLogoPngDefault.default),
                    alt: t('page.paymentOptions.financingTitle')
                })
            }),
            description: showAvailableCreditNote ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    t('page.paymentOptions.mixedDescription'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `mt-2 p-2 bg-yellow-100 border border-solid border-yellow-200 rounded`,
                        children: t('page.paymentOptions.availableCreditNote')
                    })
                ]
            }) : t('page.paymentOptions.mixedDescription')
        }
    ];
    const enabledPaymentOptions = getEnabledPaymentOptions(paymentOptions, paymentOptionConfig);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault1.default), {
        title: t('page.paymentOptions.header'),
        stepProgressProps: {
            type: 'n/a'
        },
        withSidebar: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                "data-testid": "payment-options-info",
                children: t('page.paymentOptions.infobox')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionsListDefault.default), {
                        options: enabledPaymentOptions,
                        optionComponent: (0, _options.PaymentOption),
                        compareKey: "option",
                        selectedOption: payment.selectedOption,
                        onSelect: onSelectPaymentOption,
                        "data-testid": "payment-option"
                    })
                })
            }),
            !shouldShowSidebar && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shoppingCartDefault.default), {
                withTitle: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                hasPrev: isOfficeUser,
                labelPrev: t('common.back'),
                labelNext: t('common.continue'),
                onPrev: gotoPrevPage,
                onNext: gotoNextPage
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-query":"ksTpv","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/config/constants":"ad5OP","Core/components/Footer":"ixeAp","Core/components/Alert":"fmmNR","Core/components/OptionsList":"7Iw21","Core/components/Options":"7gfpc","Core/components/Loader":"6S7S4","Core/components/CreditCardLogos":"dnezw","url:Images/allegro-logo.png":"cvMSa","Core/stores/alert":"fPz3p","Core/stores/payment":"cVa46","zustand/shallow":"g59RU","Core/hooks/queries/payment/useGetPaymentSummary":"2UTqE","Core/stores/page":"bdfbS","Core/hooks/queries/payment/useGetPaymentOptions":"9UMm9","Core/hooks/queries/payment/usePutPaymentOption":"iygdF","Core/hooks/queries/payment/usePostCaptureAvailableCredit":"77uIa","Core/hooks/queries/order/useOrder":"7ieVC","Core/hooks/queries/cacheKeys":"i5IL7","Core/components/Page":"4xeqH","Core/hooks/useShowSidebar":"as56L","Core/components/ShoppingCart":"2uMp1","Core/components/Layout":"hweet","Modules/creditDebit/routes":"yRzgP","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7Iw21":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _optionsList = require("./OptionsList");
var _optionsListDefault = parcelHelpers.interopDefault(_optionsList);
exports.default = (0, _optionsListDefault.default);

},{"./OptionsList":"d4tTC","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"d4tTC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function StyledOptionsList({ isSelected, isDisabled, children, ...rest }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...rest,
        className: (0, _classnamesDefault.default)(`options-list flex flex-nowrap items-start
        bg-white
        border-2 border-solid border-gray-300 rounded
        p-2
        mb-2
        transition-colors
        cursor-pointer
        hover:border-gray-500 last:mb-4`, {
            'border-primary hover:border-primary options-list__is-selected': isSelected,
            'cursor-not-allowed bg-gray-200 border-gray-200 hover:border-gray-200 options-list__is-disabled': isDisabled
        }),
        children: children
    });
}
const OptionsList = (props)=>{
    const { options, compareKey, disabledKey = 'disabled', selectedOption, onSelect, optionComponent: Option } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        role: "listbox",
        children: options.map((option)=>{
            const optionValue = option[compareKey];
            const isSelected = selectedOption === optionValue;
            const isDisabled = option[disabledKey];
            const selectOption = ()=>{
                !isDisabled && onSelect(optionValue, option);
            };
            const tabIndex = isDisabled ? '-1' : '0';
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledOptionsList, {
                isSelected: isSelected,
                isDisabled: isDisabled,
                onClick: selectOption,
                "data-testid": props['data-testid'],
                role: "option",
                "aria-selected": isSelected,
                "aria-disabled": isDisabled,
                tabIndex: tabIndex,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "options-list__checkbox"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Option, {
                            isSelected: isSelected,
                            ...option
                        })
                    })
                ]
            }, optionValue);
        })
    });
};
exports.default = OptionsList;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","classnames":"f971Y","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"7gfpc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentOption", ()=>(0, _paymentOptionDefault.default));
var _paymentOption = require("./PaymentOption");
var _paymentOptionDefault = parcelHelpers.interopDefault(_paymentOption);

},{"./PaymentOption":"gaWVo","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gaWVo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const PaymentOption = ({ option, label, description, message, image, isSelected })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: 'payment-option flex items-start flex-col md:flex-row justify-between md:items-center mb-2 font-bold',
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        "data-testid": `payment-option-${option}`,
                        "data-is-selected": `${isSelected}`,
                        children: label
                    }),
                    image
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: description
            }),
            message ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `text-sm text-error`,
                "data-testid": "payment-option-message",
                children: message
            }) : null
        ]
    });
exports.default = PaymentOption;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"g59RU":[function(require,module,exports,__globalThis) {
'use strict';
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function shallow$1(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = _createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = _createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var _i = 0, _keysA = keysA; _i < _keysA.length; _i++){
        var keyA = _keysA[_i];
        if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) return false;
    }
    return true;
}
var shallow = function(objA, objB) {
    console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { shallow } from 'zustand/shallow'`.");
    return shallow$1(objA, objB);
};
exports.default = shallow;
exports.shallow = shallow$1;
module.exports = shallow;
module.exports.shallow = shallow$1;
exports.default = module.exports;

},{}],"9UMm9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryFn", ()=>queryFn);
parcelHelpers.export(exports, "default", ()=>useGetPaymentOptions);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
const queryFn = (orderId)=>(0, _api.get)(`/api/payment-options/${orderId}`);
function useGetPaymentOptions() {
    const { data: order } = (0, _useOrderDefault.default)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).paymentOptions, ()=>queryFn(order.orderId), {
        enabled: Boolean(order),
        onError (e) {
            setErrorAlert(t('status.error.getPaymentOptionsQueryFailed'));
            throw e;
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/hooks/queries/order/useOrder":"7ieVC","Core/stores/alert":"fPz3p","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"77uIa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePostCaptureAvailableCredit);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _api = require("Core/utils/api");
function usePostCaptureAvailableCredit() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    return (0, _reactQuery.useMutation)(()=>{
        const { orderId } = queryClient.getQueryData('order');
        return (0, _api.post)(`/api/orders/${orderId}/payments/capture`);
    }, {
        onSuccess () {
            return Promise.resolve();
        },
        onError (e) {
            const text = e?.response?.data?.errors?.map((item)=>item.message).join('\n') || t('status.error.postCaptureAvailableCreditQueryFailed');
            setErrorAlert(text);
            throw e;
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/stores/alert":"fPz3p","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bEerd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _alert = require("Core/components/Alert");
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _constants = require("Core/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _alert1 = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert1);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _multiCardForm = require("Modules/creditDebit/components/MultiCardForm");
var _multiCardFormDefault = parcelHelpers.interopDefault(_multiCardForm);
var _useCardCheckoutPageData = require("Core/hooks/queries/useCardCheckoutPageData");
var _useCardCheckoutPageDataDefault = parcelHelpers.interopDefault(_useCardCheckoutPageData);
var _useScrollTop = require("Core/hooks/useScrollTop");
var _usePostCreatePaymentMethods = require("Core/hooks/queries/stripe/usePostCreatePaymentMethods");
var _usePostCreatePaymentMethodsDefault = parcelHelpers.interopDefault(_usePostCreatePaymentMethods);
var _reactStripeJs = require("@stripe/react-stripe-js");
var _usePostChargeCards = require("Core/hooks/queries/payment/usePostChargeCards");
var _usePostChargeCardsDefault = parcelHelpers.interopDefault(_usePostChargeCards);
var _dialog = require("Core/stores/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _utils = require("Core/utils/utils");
var _status = require("Core/components/Status");
var _statusDefault = parcelHelpers.interopDefault(_status);
var _usePostCancelCardPayment = require("Core/hooks/queries/payment/usePostCancelCardPayment");
var _usePostCancelCardPaymentDefault = parcelHelpers.interopDefault(_usePostCancelCardPayment);
var _reactLocation = require("react-location");
var _routes = require("Modules/creditDebit/routes");
const Checkout = ({ nextRoutes })=>{
    const scroll = (0, _useScrollTop.useScrollTop)();
    const stripe = (0, _reactStripeJs.useStripe)();
    const [cardErrors, setCardErrors] = (0, _reactDefault.default).useState();
    const [status, setStatus] = (0, _reactDefault.default).useState({
        type: '',
        text: ''
    });
    const [failedPaymentAttempts, setFailedPaymentAttempts] = (0, _reactDefault.default).useState(0);
    const showDialog = (0, _dialogDefault.default)((0, _dialog.showDialogSelector));
    const setWarningAlert = (0, _alertDefault.default)((0, _alert1.setWarningAlertSelector));
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { mutateAsync: createPaymentMethods } = (0, _usePostCreatePaymentMethodsDefault.default)();
    const { mutateAsync: cancelCardPayment } = (0, _usePostCancelCardPaymentDefault.default)();
    const { mutateAsync: chargeCards } = (0, _usePostChargeCardsDefault.default)();
    const { data, isSuccess } = (0, _useCardCheckoutPageDataDefault.default)();
    (0, _reactDefault.default).useEffect(()=>{
        if (data?.paymentSummary) {
            if (data.paymentSummary.totalAmountToPay === 0) navigate({
                to: nextRoutes.success,
                search: true
            });
        }
    }, [
        data
    ]);
    if (!isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.shoppingCart')
    });
    const { order, paymentMethods: savedPaymentMethods, paymentSummary } = data;
    async function onSubmit(formData) {
        scroll.top();
        let paymentMethods;
        setStatus({
            type: 'loading',
            text: t('status.loading.submitPaymentInformation')
        });
        const paymentMethodData = formData.cards.map((card, index)=>{
            const amount = index === 0 ? +card.amount + formData.decimals : +card.amount;
            if (card.paymentMethodId) return {
                amount,
                paymentMethodId: card.paymentMethodId
            };
            return {
                amount,
                stripeElement: card.stripeElement,
                billingDetails: {
                    name: `${card.firstName} ${card.lastName}`,
                    address: {
                        postal_code: card.postalCode
                    }
                }
            };
        });
        try {
            paymentMethods = await createPaymentMethods({
                stripe,
                data: paymentMethodData
            });
        } catch  {
            return setStatus({
                type: 'error',
                text: t('status.error.failedToCreatePaymentMethods')
            });
        }
        try {
            await chargeCards({
                receiptEmail: formData.email,
                paymentMethods
            });
            navigate({
                to: nextRoutes.success,
                search: true
            });
        } catch (error) {
            const detailedErrorMessage = error?.response?.data?.message || t('status.error.failedToChargeCard');
            setStatus({
                type: 'error',
                text: detailedErrorMessage
            });
            const updatedFailedAttempts = failedPaymentAttempts + 1;
            setFailedPaymentAttempts(updatedFailedAttempts);
            if (updatedFailedAttempts >= (0, _constantsDefault.default).limit.FAILED_PAYMENT_ATTEMPTS) navigate({
                to: nextRoutes.error,
                search: true
            });
            if (error.response.data.hasOwnProperty('errors')) {
                const errors = paymentMethods.map(({ paymentMethodId })=>{
                    const cardError = (0, _utils.findByPropertyValue)(error.response.data.errors, 'paymentMethodId', paymentMethodId);
                    return cardError || {};
                });
                setCardErrors(errors);
            }
        }
    }
    const onCancel = ()=>{
        showDialog({
            title: t('common.cancelPaymentProcess'),
            description: t('common.confirmCardPaymentCancellation'),
            confirmButtonLabel: t('common.yes'),
            cancelButtonLabel: t('common.no'),
            confirmCallback: ()=>{
                cancelCardPayment();
                setWarningAlert(t('status.error.paymentCanceled') + '\n' + t('status.error.paymentAuthorizationsCanceled'));
                navigate({
                    to: (0, _routes.paymentOptionsPath),
                    search: true
                });
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t(`${order?.optionSelected}.checkout.standard.header`),
        withSidebar: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                "data-testid": "infobox",
                children: t(`${order.optionSelected}.checkout.standard.infobox`)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusDefault.default), {
                ...status
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiCardFormDefault.default), {
                paymentMethods: savedPaymentMethods,
                paymentSummary: paymentSummary,
                order: order,
                onCancel: onCancel,
                onSubmit: onSubmit,
                cardErrors: cardErrors
            })
        ]
    });
};
exports.default = Checkout;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/components/Alert":"fmmNR","Core/components/Loader":"6S7S4","Core/config/constants":"ad5OP","Core/stores/alert":"fPz3p","Core/components/Page":"4xeqH","Modules/creditDebit/components/MultiCardForm":"9MdYq","Core/hooks/queries/useCardCheckoutPageData":"fmHU3","Core/hooks/useScrollTop":"cBwQW","Core/hooks/queries/stripe/usePostCreatePaymentMethods":"gEPFe","@stripe/react-stripe-js":"jEv7X","Core/hooks/queries/payment/usePostChargeCards":"gHapT","Core/stores/dialog":"6IfFO","Core/utils/utils":"hwOBZ","Core/components/Status":"5UE3N","Core/hooks/queries/payment/usePostCancelCardPayment":"2GEuL","react-location":"8hNco","Modules/creditDebit/routes":"yRzgP","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9MdYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMultiCardForm = require("Modules/creditDebit/hooks/useMultiCardForm");
var _useMultiCardFormDefault = parcelHelpers.interopDefault(_useMultiCardForm);
var _button = require("Core/components/Button");
var _reactHookForm = require("react-hook-form");
var _utils = require("Core/utils/utils");
var _cardSelector = require("Core/components/CardSelector");
var _cardSelectorDefault = parcelHelpers.interopDefault(_cardSelector);
var _amountSplitter = require("Modules/creditDebit/components/AmountSplitter");
var _amountSplitterDefault = parcelHelpers.interopDefault(_amountSplitter);
var _styledFormGroup = require("Core/components/FormElements/StyledFormGroup");
var _styledFormGroupDefault = parcelHelpers.interopDefault(_styledFormGroup);
var _downPayment = require("Core/components/ShoppingCart/DownPayment");
var _downPaymentDefault = parcelHelpers.interopDefault(_downPayment);
var _shoppingCart = require("Core/components/ShoppingCart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
var _useShowSidebar = require("Core/hooks/useShowSidebar");
var _layout = require("Core/components/Layout");
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _reactI18Next = require("react-i18next");
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _numberFormat = require("Core/utils/numberFormat");
const MultiCardForm = ({ paymentMethods, paymentSummary, order, onCancel, onSubmit, cardErrors })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const shouldShowSidebar = (0, _useShowSidebar.useShowSidebar)();
    const isMixedPayment = order.optionSelected === 'mixed';
    const { downPayment, totalAmountToPay: totalAmount } = paymentSummary;
    const showDownPayment = isMixedPayment && downPayment > 0;
    //We do this to manage decimals separately in the onSubmit handler
    const totalAmountInteger = Math.floor(totalAmount);
    const { paymentMethodId } = (0, _utils.getPreferredPaymentMethod)(paymentMethods);
    const defaultCardValues = paymentMethodId ? {
        paymentMethodId,
        amount: totalAmountInteger.toString()
    } : {
        firstName: '',
        lastName: '',
        postalCode: '',
        cardNumber: '',
        cardExpiry: '',
        cardCvc: '',
        amount: totalAmountInteger.toString()
    };
    const form = (0, _useMultiCardFormDefault.default)(defaultCardValues, {
        decimals: (0, _utils.getDecimals)(totalAmount, 6)
    });
    const { register, handleSubmit, control, setValue } = form;
    const { fields, append, remove } = (0, _reactHookForm.useFieldArray)({
        control,
        name: 'cards'
    });
    const remainingToCharge = totalAmountInteger - form.watch('cards').reduce((acc, curr)=>acc + (curr.amount ? parseInt(curr.amount, 10) : 0), 0);
    //This is necessary to update the form state when you remove a card.
    //You cannot call 2 actions together and need to wait for a rerender
    (0, _reactDefault.default).useEffect(()=>{
        if (fields.length === 1) setValue('cards[0].amount', totalAmountInteger.toString());
    }, [
        fields.length,
        setValue,
        totalAmountInteger
    ]);
    //Set remaining to form
    (0, _reactDefault.default).useEffect(()=>{
        setValue('remaining', remainingToCharge, {
            shouldValidate: true
        });
    }, [
        remainingToCharge,
        setValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        name: "multiCardForm",
        onSubmit: handleSubmit(onSubmit),
        children: [
            showDownPayment ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downPaymentDefault.default), {}) : null,
            fields.map(({ id, ...field }, i)=>{
                const cardError = cardErrors?.[i]?.message;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledFormGroupDefault.default), {
                    error: cardError,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardSelectorDefault.default), {
                        cardError: cardError,
                        defaultValues: field,
                        namePrefix: `cards`,
                        cardCount: fields.length,
                        index: i,
                        form: form,
                        paymentMethods: paymentMethods,
                        onRemove: ()=>remove(i),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountSplitterDefault.default), {
                                decimals: form.getValues('decimals'),
                                totalAmount: totalAmountInteger,
                                form: form,
                                index: i,
                                cardCount: fields.length
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "hidden",
                                ...register('decimals')
                            })
                        ]
                    })
                }, id);
            }),
            form.formState?.errors?.remaining && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "text-error mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                    i18nKey: `payment.remainingAmountToCharge`,
                    values: {
                        amount: (0, _numberFormat.formatCurrency)(remainingToCharge, {
                            withDecimals: false
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "p-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                    className: "!bg-gray-300 !pt-4 !rounded !flex-nowrap",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            noFlex: true,
                            className: "!flex-grow",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: t('common.addCardControlLabel')
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                            noFlex: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                "data-testid": "add-card",
                                onClick: ()=>{
                                    append({
                                        paymentMethodId: '',
                                        firstName: '',
                                        lastName: '',
                                        postalCode: '',
                                        cardNumber: '',
                                        cardExpiry: '',
                                        cardCvc: '',
                                        amount: ''
                                    });
                                },
                                children: t('common.addCard')
                            })
                        })
                    ]
                })
            }),
            !shouldShowSidebar && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shoppingCartDefault.default), {
                withTitle: true
            }),
            showDownPayment && !shouldShowSidebar ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downPaymentDefault.default), {}) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                    className: "md:!flex-col-6",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                        register: register,
                        label: t('common.receiptEmail'),
                        name: `email`,
                        error: form.formState.errors?.email?.message
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _termsInputDefault.default), {
                name: "terms",
                register: register,
                errors: form.formState.errors,
                label: t('common.termsAndConditions'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "mb-0",
                    children: t('terms.card.charge')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                className: `!justify-between`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: `!flex-col-6 md:!flex-col-4 lg:!flex-col-3`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SecondaryOutlineButton), {
                            block: true,
                            type: "reset",
                            onClick: onCancel,
                            "data-testid": "cancel",
                            children: t('common.cancel')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                        className: `!flex-col-6 md:!flex-col-4 lg:!flex-col-3`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            type: "submit",
                            block: true,
                            "data-testid": "checkout",
                            children: t('common.checkout')
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = MultiCardForm;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Modules/creditDebit/hooks/useMultiCardForm":"jgeag","Core/components/Button":"6YNzH","react-hook-form":"53GLT","Core/utils/utils":"hwOBZ","Core/components/CardSelector":"4d8Tr","Modules/creditDebit/components/AmountSplitter":"6ZAWy","Core/components/FormElements/StyledFormGroup":"6lnq9","Core/components/ShoppingCart/DownPayment":"gBW2f","Core/components/ShoppingCart":"2uMp1","Core/hooks/useShowSidebar":"as56L","Core/components/Layout":"hweet","Core/components/FormElements/InputField":"6BJmW","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"Core/components/FormElements/TermsInput":"2LJBE","Core/utils/numberFormat":"6T56F","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gBW2f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _downPayment = require("./DownPayment");
var _downPaymentDefault = parcelHelpers.interopDefault(_downPayment);
exports.default = (0, _downPaymentDefault.default);

},{"./DownPayment":"gnoZc","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gnoZc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _downPaymentItem = require("./DownPaymentItem");
var _downPaymentItemDefault = parcelHelpers.interopDefault(_downPaymentItem);
var _numberFormat = require("Core/utils/numberFormat");
var _useGetPaymentSummary = require("Core/hooks/queries/payment/useGetPaymentSummary");
var _useGetPaymentSummaryDefault = parcelHelpers.interopDefault(_useGetPaymentSummary);
const DownPayment = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data: paymentSummary } = (0, _useGetPaymentSummaryDefault.default)();
    if (!paymentSummary) return null;
    const { downPayment, totalAmountToPay, amountToBeFinanced, amountAlreadyPaid, payments } = paymentSummary;
    const hasDeposit = payments.length && payments.find((payment)=>payment.purpose.toLowerCase() === 'deposit');
    const showAvailableCredit = hasDeposit && amountAlreadyPaid > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: t('common.downPayment')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                "data-testid": "down-payment",
                className: "p-2 mb-4 bg-yellow-100 border border-solid border-yellow-200 rounded",
                children: [
                    showAvailableCredit ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downPaymentItemDefault.default), {
                                label: t('common.availableCredit'),
                                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                    className: "text-success",
                                    children: (0, _numberFormat.formatCurrency)(-amountAlreadyPaid)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downPaymentItemDefault.default), {
                                label: t('common.downPayment'),
                                value: (0, _numberFormat.formatCurrency)(downPayment)
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downPaymentItemDefault.default), {
                        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: t('common.downPaymentWithCreditCard')
                        }),
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: (0, _numberFormat.formatCurrency)(totalAmountToPay)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downPaymentItemDefault.default), {
                        label: t('common.resdiualFinancingAmount'),
                        value: (0, _numberFormat.formatCurrency)(amountToBeFinanced)
                    })
                ]
            })
        ]
    });
};
exports.default = DownPayment;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","./DownPaymentItem":"bwdTO","Core/utils/numberFormat":"6T56F","Core/hooks/queries/payment/useGetPaymentSummary":"2UTqE","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"bwdTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const DownPaymentItem = ({ label, value })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        "data-testid": "down-payment-item",
        className: "flex text-sm",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `text-right px-1 w-3/4`,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `text-right px-1 w-1/4`,
                children: value
            })
        ]
    });
};
exports.default = DownPaymentItem;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fmHU3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCardCheckoutPageData);
var _useGetSavedPaymentMethods = require("Core/hooks/queries/payment/useGetSavedPaymentMethods");
var _useGetSavedPaymentMethodsDefault = parcelHelpers.interopDefault(_useGetSavedPaymentMethods);
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _useGetPaymentSummary = require("Core/hooks/queries/payment/useGetPaymentSummary");
var _useGetPaymentSummaryDefault = parcelHelpers.interopDefault(_useGetPaymentSummary);
function useCardCheckoutPageData() {
    const orderQuery = (0, _useOrderDefault.default)();
    const paymentSummaryQuery = (0, _useGetPaymentSummaryDefault.default)();
    const paymentMethodsQuery = (0, _useGetSavedPaymentMethodsDefault.default)();
    return {
        data: {
            order: orderQuery.data,
            paymentSummary: paymentSummaryQuery.data,
            paymentMethods: paymentMethodsQuery.data
        },
        isSuccess: orderQuery.isSuccess && paymentSummaryQuery.isSuccess && paymentMethodsQuery.isSuccess
    };
}

},{"Core/hooks/queries/payment/useGetSavedPaymentMethods":"bIUV0","Core/hooks/queries/order/useOrder":"7ieVC","Core/hooks/queries/payment/useGetPaymentSummary":"2UTqE","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gHapT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePostChargeCards);
var _reactQuery = require("react-query");
var _api = require("Core/utils/api");
var _logger = require("Core/utils/logger");
function usePostChargeCards() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(({ receiptEmail, paymentMethods })=>{
        const { orderId } = queryClient.getQueryData('order');
        return (0, _api.post)(`/api/orders/${orderId}/payments/checkout`, {
            receiptEmail,
            paymentMethods
        });
    }, {
        onSuccess (data, variables) {
            const { optionSelected } = queryClient.getQueryData('order');
            if (optionSelected === 'credit-debit') (0, _logger.postLogMessage)({
                amount: variables.paymentMethods.reduce((totalAmount, paymentMethod)=>{
                    return totalAmount + paymentMethod.amount;
                }, 0),
                feature: (0, _logger.features).creditDebitCheckout,
                status: 'success'
            });
            return Promise.resolve();
        },
        throwOnError: true
    });
}

},{"react-query":"ksTpv","Core/utils/api":"cC5Cp","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2GEuL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePostCancelCardPayment);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _api = require("Core/utils/api");
function usePostCancelCardPayment() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    return (0, _reactQuery.useMutation)(()=>{
        const { orderId } = queryClient.getQueryData('order');
        return (0, _api.post)(`/api/orders/${orderId}/payments/cancel`);
    }, {
        onSuccess () {
            return Promise.resolve();
        },
        onError (e) {
            setErrorAlert(t('status.error.failedToCancelCardPayment'));
            throw e;
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/stores/alert":"fPz3p","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iazyi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Success);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _card = require("Core/components/FormElements/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _orderReceipts = require("Core/components/Receipts/OrderReceipts");
var _orderReceiptsDefault = parcelHelpers.interopDefault(_orderReceipts);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _orderData = require("Core/components/Data/OrderData");
var _orderDataDefault = parcelHelpers.interopDefault(_orderData);
function Success() {
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
            title: t(`page.creditDebit.success.header`),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertSuccess), {
                    children: t('page.creditDebit.success.infobox')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                    className: "justify-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-center",
                            children: t('page.creditDebit.success.intro')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderReceiptsDefault.default), {
                            title: t('page.creditDebit.success.clickToViewReceipt')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Core/components/FormElements/Card":"23G8S","Core/components/Receipts/OrderReceipts":"4WrBV","Core/components/Page":"4xeqH","Core/components/Data/OrderData":"jg54z","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4WrBV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useGetOrderReceiptUrls = require("Core/hooks/queries/order/useGetOrderReceiptUrls");
var _receipt = require("./Receipt");
var _receiptDefault = parcelHelpers.interopDefault(_receipt);
const OrderReceipts = ({ title = '' })=>{
    const queryResponse = (0, _useGetOrderReceiptUrls.useGetOrderReceiptUrls)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _receiptDefault.default), {
        title: title,
        ...queryResponse
    });
};
exports.default = OrderReceipts;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","prop-types":"bPwP3","Core/hooks/queries/order/useGetOrderReceiptUrls":"iZ3Nh","./Receipt":"cOsaf","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iZ3Nh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetOrderReceiptUrls", ()=>useGetOrderReceiptUrls);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _api = require("Core/utils/api");
function useGetOrderReceiptUrls() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data: order } = (0, _useOrderDefault.default)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    return (0, _reactQuery.useQuery)((0, _cacheKeysDefault.default).orderReceipts, ()=>(0, _api.get)(`/api/orders/${order.orderId}/payments/receipts`), {
        enabled: Boolean(order),
        onError (e) {
            setErrorAlert(t('status.error.getPaymentReceiptUrlQueryFailed'));
            throw e;
        }
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/stores/alert":"fPz3p","Core/hooks/queries/cacheKeys":"i5IL7","Core/hooks/queries/order/useOrder":"7ieVC","Core/utils/api":"cC5Cp","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jg54z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OrderData);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _usePaymentInitializer = require("Core/hooks/usePaymentInitializer");
var _usePaymentInitializerDefault = parcelHelpers.interopDefault(_usePaymentInitializer);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _constants = require("Core/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _routes = require("Modules/creditDebit/routes");
var _reactLocation = require("react-location");
var _routes1 = require("Core/routes");
function OrderData({ children }) {
    const successRoutes = {
        [(0, _constantsDefault.default).paymentOptions.CREDIT_DEBIT]: (0, _routes.creditDebitSuccessPath),
        [(0, _constantsDefault.default).paymentOptions.FINANCING]: (0, _routes.financingSuccessPath),
        [(0, _constantsDefault.default).paymentOptions.MIXED]: (0, _routes.mixedSuccessPath),
        [(0, _constantsDefault.default).paymentOptions.NA]: (0, _routes.creditDebitSuccessPath)
    };
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data: order, isLoading } = (0, _usePaymentInitializerDefault.default)();
    const navigate = (0, _reactLocation.useNavigate)();
    const orderStatus = order?.status;
    const orderOptionSelected = order?.optionSelected;
    (0, _reactDefault.default).useEffect(()=>{
        if (orderStatus && orderOptionSelected) {
            if (orderStatus === (0, _constantsDefault.default).orderStatus.PAID) return navigate({
                to: successRoutes[orderOptionSelected],
                search: true
            });
            if (orderStatus === (0, _constantsDefault.default).orderStatus.CLOSED || orderStatus === (0, _constantsDefault.default).orderStatus.FAILED) return navigate({
                to: (0, _routes1.errorPath),
                search: true
            });
        }
    }, [
        orderStatus,
        orderOptionSelected,
        navigate
    ]);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.orderData')
    });
    if (!order) return null;
    return children;
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/usePaymentInitializer":"iFJB4","Core/components/Loader":"6S7S4","Core/config/constants":"ad5OP","Modules/creditDebit/routes":"yRzgP","react-location":"8hNco","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"iFJB4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePaymentInitializer);
var _reactQuery = require("react-query");
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _useGetPaymentSummary = require("Core/hooks/queries/payment/useGetPaymentSummary");
var _useGetPaymentOptions = require("Core/hooks/queries/payment/useGetPaymentOptions");
var _useGetSavedPaymentMethods = require("Core/hooks/queries/payment/useGetSavedPaymentMethods");
var _reactLocation = require("react-location");
var _routes = require("Core/routes");
function usePaymentInitializer() {
    const { data: order } = (0, _useOrderDefault.default)();
    const navigate = (0, _reactLocation.useNavigate)();
    const requests = (0, _reactQuery.useQueries)([
        {
            queryKey: (0, _cacheKeysDefault.default).paymentSummary,
            queryFn: ()=>(0, _useGetPaymentSummary.queryFn)(order.orderId),
            enabled: Boolean(order?.orderId)
        },
        {
            queryKey: (0, _cacheKeysDefault.default).paymentOptions,
            queryFn: ()=>(0, _useGetPaymentOptions.queryFn)(order.orderId),
            enabled: Boolean(order?.orderId)
        },
        {
            queryKey: (0, _cacheKeysDefault.default).savedPaymentMethods,
            queryFn: (0, _useGetSavedPaymentMethods.queryFn),
            enabled: Boolean(order?.orderId)
        }
    ]);
    const isLoading = requests.some((req)=>req.isLoading);
    const isError = requests.some((req)=>req.isError);
    if (isError) return navigate({
        to: (0, _routes.errorPath),
        search: true
    });
    return {
        isLoading,
        isError,
        data: order
    };
}

},{"react-query":"ksTpv","Core/hooks/queries/order/useOrder":"7ieVC","Core/hooks/queries/cacheKeys":"i5IL7","Core/hooks/queries/payment/useGetPaymentSummary":"2UTqE","Core/hooks/queries/payment/useGetPaymentOptions":"9UMm9","Core/hooks/queries/payment/useGetSavedPaymentMethods":"bIUV0","react-location":"8hNco","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cNOI3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Error);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _usePostCancelCardPayment = require("Core/hooks/queries/payment/usePostCancelCardPayment");
var _usePostCancelCardPaymentDefault = parcelHelpers.interopDefault(_usePostCancelCardPayment);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _orderData = require("Core/components/Data/OrderData");
var _orderDataDefault = parcelHelpers.interopDefault(_orderData);
function Error() {
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { mutateAsync: cancelCardPayment } = (0, _usePostCancelCardPaymentDefault.default)();
    (0, _reactDefault.default).useEffect(()=>{
        cancelCardPayment();
    }, [
        cancelCardPayment
    ]);
    const checklistItems = [
        {
            label: t('status.error.paymentAuthorizationsCanceled'),
            status: 'done'
        },
        {
            label: t('page.creditDebit.error.intro'),
            status: 'warn'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
            title: t(`page.creditDebit.error.header`),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                    children: t('page.creditDebit.error.infobox')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: '200px'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist":"cdvA9","Core/hooks/queries/payment/usePostCancelCardPayment":"2GEuL","Core/components/Page":"4xeqH","Core/components/Data/OrderData":"jg54z","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6aSIU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinancingOffice);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _createApplication = require("Modules/creditDebit/components/Financing/allegro/CreateApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _selectOffer = require("Modules/creditDebit/components/Financing/allegro/SelectOffer");
var _selectOfferDefault = parcelHelpers.interopDefault(_selectOffer);
var _useGetApplication = require("Modules/creditDebit/components/Financing/allegro/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _orderData = require("Core/components/Data/OrderData");
var _orderDataDefault = parcelHelpers.interopDefault(_orderData);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _applicationStatus = require("Modules/creditDebit/components/Financing/allegro/ApplicationStatus");
var _applicationStatusDefault = parcelHelpers.interopDefault(_applicationStatus);
var _routes = require("Modules/creditDebit/routes");
// TODO solve this hack!
const FinancingRedirect = ()=>{
    const routes = {
        paymentOptions: (0, _routes.paymentOptionsPath),
        financing: (0, _routes.financingPath),
        mixed: (0, _routes.mixedDownPaymentCheckoutPath)
    };
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data: application, isLoading, error } = (0, _useGetApplicationDefault.default)(); // <-- PARTNER-ID REQUIRED
    const { nextAction = 'createApplication' } = application || {};
    // No application found? -> Show form to create one
    if (error?.response?.status === 404) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
        routes: {
            paymentOptions: routes.paymentOptions
        }
    });
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
    if (application?.nextAction) switch(nextAction){
        case 'createApplication':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createApplicationDefault.default), {
                routes: {
                    paymentOptions: routes.paymentOptions
                }
            });
        case 'selectOffer':
        case 'readyToBeSigned':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectOfferDefault.default), {
                    application: application,
                    routes: routes
                })
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _applicationStatusDefault.default), {
                application: application,
                routes: {
                    paymentOptions: routes.paymentOptions
                }
            });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _applicationStatusDefault.default), {
        application: application,
        routes: {
            paymentOptions: routes.paymentOptions
        }
    });
};
function FinancingOffice() {
    const { data: order } = (0, _useOrderDefault.default)();
    if (!order) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FinancingRedirect, {});
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/queries/order/useOrder":"7ieVC","Modules/creditDebit/components/Financing/allegro/CreateApplication":"jHq4M","Modules/creditDebit/components/Financing/allegro/SelectOffer":"dTosU","Modules/creditDebit/components/Financing/allegro/useGetApplication":"hRLw9","Core/components/Data/OrderData":"jg54z","Core/components/Loader":"6S7S4","Modules/creditDebit/components/Financing/allegro/ApplicationStatus":"jfNx6","Modules/creditDebit/routes":"yRzgP","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jHq4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _reactI18Next = require("react-i18next");
var _selectMenu = require("Core/components/FormElements/SelectMenu");
var _selectMenuDefault = parcelHelpers.interopDefault(_selectMenu);
var _alert = require("Core/components/Alert");
var _infoBox = require("Core/components/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _button = require("Core/components/Button");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _usStates = require("Modules/creditDebit/config/usStates");
var _useCreateApplicationForm = require("./useCreateApplicationForm");
var _useCreateApplicationFormDefault = parcelHelpers.interopDefault(_useCreateApplicationForm);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _useCreateApplication = require("Modules/creditDebit/components/Financing/allegro/useCreateApplication");
var _useCreateApplicationDefault = parcelHelpers.interopDefault(_useCreateApplication);
var _birthDateInput = require("Core/components/FormElements/BirthDateInput");
var _birthDateInputDefault = parcelHelpers.interopDefault(_birthDateInput);
var _layout = require("Core/components/Layout");
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _termsInput = require("Core/components/FormElements/TermsInput");
var _termsInputDefault = parcelHelpers.interopDefault(_termsInput);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _useGetApplication = require("Modules/creditDebit/components/Financing/allegro/useGetApplication");
var _useGetApplicationDefault = parcelHelpers.interopDefault(_useGetApplication);
var _reactLocation = require("react-location");
const dateFormat = 'yyyy-MM-dd';
const mapCustomerData = (customerData)=>{
    return {
        ...customerData,
        phone: customerData.phoneNumber,
        annualIncome: (customerData.monthlyIncome * 12).toString()
    };
};
const CreateApplication = ({ routes })=>{
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const scroll = (0, _useScrollTop.useScrollTop)();
    const { mutateAsync: createApplication, isLoading } = (0, _useCreateApplicationDefault.default)();
    const { data: applicationDetails } = (0, _useGetApplicationDefault.default)();
    const { customerInfo } = applicationDetails || {};
    const [dobDefaults, setDobDefaults] = (0, _reactDefault.default).useState({});
    const { register, handleSubmit, setValue, formState: { errors, isSubmitted } } = (0, _useCreateApplicationFormDefault.default)();
    (0, _reactDefault.default).useEffect(()=>{
        if (customerInfo) {
            const customerData = mapCustomerData(customerInfo);
            Object.keys(customerData).forEach((field)=>setValue(field, customerData[field]));
            const [year, month, day] = customerData.dateOfBirth.split('-');
            setDobDefaults({
                day,
                month,
                year
            });
        }
    }, [
        customerInfo,
        setValue
    ]);
    const hasFormErrors = Object.keys(errors).length > 0;
    const onSubmit = async (formData)=>{
        scroll.top();
        await createApplication(formData);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.createFinancingApplication.header'),
        withStepProgress: false,
        children: [
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('allegro.createApplication.loaderText')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                name: "allegroCreateApplication",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    hasFormErrors && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                        type: "error",
                        children: t('status.error.checkErrors')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                children: t('allegro.createApplication.enterLegalNames')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.firstName'),
                                            name: "firstName",
                                            errors: errors,
                                            defaultValue: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.lastName'),
                                            name: "lastName",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.street'),
                                            name: "address",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.city'),
                                            name: "city",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectMenuDefault.default), {
                                            register: register,
                                            label: t('common.state'),
                                            name: "state",
                                            items: (0, _usStates.usStates),
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.postalCode'),
                                            name: "zip",
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.email'),
                                            name: "email",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.phone'),
                                            name: "phone",
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                title: t('common.readToCustomer.title'),
                                children: t('allegro.createApplication.readToCustomer.note1')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: t('common.ssn'),
                                            name: "socialSecurityNumber",
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _birthDateInputDefault.default), {
                                            format: dateFormat,
                                            register: register,
                                            name: "dateOfBirth",
                                            onChange: (value)=>{
                                                setValue('dateOfBirth', value, {
                                                    shouldValidate: isSubmitted
                                                });
                                            },
                                            defaultValues: dobDefaults,
                                            errors: errors
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                    className: "md:!flex-col-6",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                        register: register,
                                        label: t('common.annualIncome'),
                                        name: "annualIncome",
                                        type: "number",
                                        errors: errors
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                title: t('common.readToCustomer.title'),
                                children: t('allegro.createApplication.readToCustomer.note2')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: t('common.noticeToApplicants')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBoxDefault.default), {
                                title: t('common.readToCustomer.title'),
                                children: t('allegro.createApplication.readToCustomer.note3')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _termsInputDefault.default), {
                                name: "terms",
                                register: register,
                                errors: errors,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        children: t('allegro.createApplication.terms')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: t('allegro.createApplication.terms.note1')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: t('allegro.createApplication.terms.note2')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                className: "md:!flex-col-6",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SecondaryOutlineButton), {
                                    "data-testid": "cancel",
                                    onClick: ()=>navigate({
                                            to: routes.paymentOptions,
                                            search: true,
                                            replace: true
                                        }),
                                    children: t('common.cancel')
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                className: "md:!flex-col-6 !flex gap-1 !justify-end",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                    type: "submit",
                                    "data-testid": "submit-application",
                                    children: t('common.submitApplication')
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = CreateApplication;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/FormElements/InputField":"6BJmW","react-i18next":"244ua","Core/components/FormElements/SelectMenu":"hsUsp","Core/components/Alert":"fmmNR","Core/components/InfoBox":"4Lj47","Core/components/Button":"6YNzH","Core/hooks/useScrollTop":"cBwQW","Modules/creditDebit/config/usStates":"2i8MO","./useCreateApplicationForm":"4CJpJ","Core/components/Page":"4xeqH","Modules/creditDebit/components/Financing/allegro/useCreateApplication":"eZP9m","Core/components/FormElements/BirthDateInput":"36m4y","Core/components/Layout":"hweet","Core/components/FormElements/formElements.styled":"45aFS","Core/components/FormElements/TermsInput":"2LJBE","Core/components/Loader":"6S7S4","Modules/creditDebit/components/Financing/allegro/useGetApplication":"hRLw9","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4CJpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSocialSecurityNumberRegex", ()=>getSocialSecurityNumberRegex);
parcelHelpers.export(exports, "validateISODateFormat", ()=>validateISODateFormat);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _dateFns = require("date-fns");
var _reactHookForm = require("react-hook-form");
const getSocialSecurityNumberRegex = ()=>/^\d{3}-?\d{2}-?\d{4}$/;
const validateISODateFormat = (val)=>{
    return val ? (0, _dateFns.isValid)((0, _dateFns.parseISO)(val)) : true;
};
const useCreateApplicationForm = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            firstName: _v3.string().nonempty({
                message: t('common.requiredFieldFirstName')
            }),
            lastName: _v3.string().nonempty({
                message: t('common.requiredFieldLastName')
            }),
            address: _v3.string().nonempty({
                message: t('common.requiredFieldStreet')
            }),
            city: _v3.string().nonempty({
                message: t('common.requiredFieldCity')
            }),
            state: _v3.string().nonempty({
                message: t('common.requiredFieldState')
            }),
            zip: _v3.string().nonempty({
                message: t('common.requiredFieldPostalCode')
            }),
            email: _v3.string().nonempty({
                message: t('common.requiredFieldEmail')
            }).email({
                message: t('common.invalidFormatEmail')
            }),
            socialSecurityNumber: _v3.string().nonempty({
                message: t('common.requiredFieldSSN')
            }).refine((val)=>{
                const regex = getSocialSecurityNumberRegex();
                return regex.test(val);
            }, {
                message: t('common.invalidFormatSSN')
            }),
            phone: _v3.string().nonempty({
                message: t('common.requiredFieldPhone')
            }),
            dateOfBirth: _v3.any().refine(validateISODateFormat, {
                message: t('common.invalidDateFormat')
            }),
            annualIncome: _v3.string().transform(parseInt).refine((val)=>val >= 1, {
                message: t('common.requiredFieldAnnualIncome')
            }),
            terms: _v3.boolean().refine((val)=>val, {
                message: t('common.requiredFieldTerms')
            })
        });
    }, [
        t
    ]);
    return (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema)
    });
};
exports.default = useCreateApplicationForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","date-fns":[["isValid","jCEss","default"],["parseISO","3xgI2","default"]],"react-hook-form":"53GLT","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"eZP9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCreateApplication);
var _reactQuery = require("react-query");
var _api = require("Core/utils/api");
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _reactI18Next = require("react-i18next");
var _logger = require("Core/utils/logger");
function transformPayload({ firstName, lastName, address, city, state, zip, email, phone: number, socialSecurityNumber, dateOfBirth, annualIncome }) {
    return {
        firstName,
        lastName,
        dateOfBirth,
        socialSecurityNumber,
        email,
        phones: [
            {
                number,
                type: 'mobile'
            }
        ],
        mailingAddress: {
            address,
            city,
            state,
            zip
        },
        monthlyIncome: Math.floor(annualIncome / 12),
        agreeToTerms: true
    };
}
function useCreateApplication() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const { data: order } = (0, _useOrderDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>(0, _api.post)(`/api/orders/${order.orderId}/financing/application`, transformPayload(payload)), {
        throwOnError: true,
        retry: 2,
        onSuccess () {
            (0, _logger.postLogMessage)({
                feature: (0, _logger.features).createAllegroApp,
                status: 'success'
            });
            clearAlert();
            return queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingApplication);
        },
        onError (error) {
            setErrorAlert(t('status.error.createApplicationRequestFailed') + `(${error?.response?.data?.message})`);
        }
    });
}

},{"react-query":"ksTpv","Core/utils/api":"cC5Cp","Core/hooks/queries/order/useOrder":"7ieVC","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/alert":"fPz3p","react-i18next":"244ua","Core/utils/logger":"cWDKQ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hRLw9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetApplication);
var _reactQuery = require("react-query");
var _reactI18Next = require("react-i18next");
var _api = require("Core/utils/api");
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _routes = require("Core/routes");
var _reactLocation = require("react-location");
function useGetApplication() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
    const { data: order } = (0, _useOrderDefault.default)();
    const navigate = (0, _reactLocation.useNavigate)();
    return (0, _reactQuery.useQuery)([
        (0, _cacheKeysDefault.default).financingApplication,
        order.orderId
    ], ()=>(0, _api.get)(`/api/orders/${order.orderId}/financing/application`), {
        onError (e) {
            if (e?.response?.status !== 404) {
                const message = e?.response?.data?.message ? ` - ${e?.response?.data?.message}` : '';
                setError(t('status.error.getFinancingApplicationFailed') + message);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        },
        retry: 1
    });
}

},{"react-query":"ksTpv","react-i18next":"244ua","Core/utils/api":"cC5Cp","Core/hooks/queries/order/useOrder":"7ieVC","Core/hooks/queries/cacheKeys":"i5IL7","Core/stores/error":"38MVH","Core/routes":"iddMu","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"dTosU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
var _radioOption = require("Core/components/Option/RadioOption");
var _radioOptionDefault = parcelHelpers.interopDefault(_radioOption);
var _inputField = require("Core/components/FormElements/InputField");
var _inputFieldDefault = parcelHelpers.interopDefault(_inputField);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _button = require("Core/components/Button");
var _reactI18Next = require("react-i18next");
var _formElementsStyled = require("Core/components/FormElements/formElements.styled");
var _layout = require("Core/components/Layout");
var _useSelectOfferForm = require("Modules/creditDebit/components/Financing/allegro/useSelectOfferForm");
var _useSelectOfferFormDefault = parcelHelpers.interopDefault(_useSelectOfferForm);
var _usePutPaymentOption = require("Core/hooks/queries/payment/usePutPaymentOption");
var _usePutPaymentOptionDefault = parcelHelpers.interopDefault(_usePutPaymentOption);
var _useGetPaymentSummary = require("Core/hooks/queries/payment/useGetPaymentSummary");
var _useGetPaymentSummaryDefault = parcelHelpers.interopDefault(_useGetPaymentSummary);
var _useScrollTop = require("Core/hooks/useScrollTop");
var _useUpdateOffer = require("Modules/creditDebit/components/Financing/allegro/useUpdateOffer");
var _useUpdateOfferDefault = parcelHelpers.interopDefault(_useUpdateOffer);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _calendarInputField = require("Core/components/FormElements/CalendarInputField");
var _calendarInputFieldDefault = parcelHelpers.interopDefault(_calendarInputField);
var _alert = require("Core/stores/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _alert1 = require("Core/components/Alert");
var _numberFormat = require("Core/utils/numberFormat");
var _utils = require("Core/utils/utils");
var _appConfig = require("Core/config/appConfig");
var _constants = require("Core/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _useGetPaymentOptions = require("Core/hooks/queries/payment/useGetPaymentOptions");
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _reactLocation = require("react-location");
const SelectOffer = ({ application, routes })=>{
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const scroll = (0, _useScrollTop.useScrollTop)();
    const setErrorAlert = (0, _alertDefault.default)((0, _alert.setErrorAlertSelector));
    const clearAlert = (0, _alertDefault.default)((0, _alert.clearAlertSelector));
    const [isLoading, setIsLoading] = (0, _reactDefault.default).useState(false);
    const [selectedOffer, setSelectedOffer] = (0, _reactDefault.default).useState({
        id: '',
        minimumFinancedAmount: 0,
        type: ''
    });
    const [offer, setOffer] = (0, _reactDefault.default).useState(null);
    const { offers, minimumDownPayment = 0 } = application;
    const { data: { totalAmount = 0 } = {} } = (0, _useGetPaymentSummaryDefault.default)();
    let maximumDownPayment = totalAmount - selectedOffer.minimumFinancedAmount;
    maximumDownPayment = maximumDownPayment < minimumDownPayment ? minimumDownPayment : maximumDownPayment;
    const { dateFormat } = (0, _appConfig.getAppConfig)();
    const { register, handleSubmit, formState: { errors }, watch, control } = (0, _useSelectOfferFormDefault.default)({
        minimumDownPayment,
        maximumDownPayment,
        dateFormat
    });
    const { mutateAsync: updateOffer, isLoading: isLoadingUpdateOffer } = (0, _useUpdateOfferDefault.default)();
    const { mutateAsync: setPaymentOption, isLoading: isSetPaymentOptionLoading } = (0, _usePutPaymentOptionDefault.default)();
    const { data: order } = (0, _useOrderDefault.default)();
    const fundingAmount = totalAmount - (watch('downPayment') || 0);
    const downPaymentLabel = 'Down Payment' + (selectedOffer.id ? ` (${(0, _numberFormat.formatCurrency)(minimumDownPayment, {
        withDecimals: false
    })} - ${(0, _numberFormat.formatCurrency)(maximumDownPayment, {
        withDecimals: false
    })})` : '');
    const isContingentFunding = selectedOffer.type.toLowerCase() === 'contingent funding';
    const onFocus = (event)=>event.target.select();
    const onSubmit = async ({ downPayment, deliveryDate })=>{
        scroll.top();
        try {
            const result = await updateOffer({
                offerId: selectedOffer.id,
                downPayment: parseInt(downPayment, 10),
                autoPay: false,
                deliveryDate: (0, _dateFns.formatISO)((0, _dateFns.parse)(deliveryDate, dateFormat, new Date()), {
                    representation: 'date'
                })
            });
            setOffer(result);
            clearAlert();
        } catch (err) {
            setErrorAlert(err.message);
        }
    };
    const onCancel = ()=>{
        clearAlert();
        navigate({
            to: routes.paymentOptions,
            replace: true,
            search: true
        });
    };
    const onContinue = async ()=>{
        const downPayment = (0, _utils.getPropValue)(offer, 'price.downPayment');
        setIsLoading(true);
        try {
            // hacky hack to make the next call work ¯\_(ツ)_/¯
            await (0, _useGetPaymentOptions.queryFn)(order.orderId);
            await setPaymentOption(downPayment > 0 ? (0, _constantsDefault.default).paymentOptions.MIXED : (0, _constantsDefault.default).paymentOptions.FINANCING);
            return navigate({
                to: downPayment > 0 ? routes.mixed : routes.financing,
                replace: true,
                search: true
            });
        } catch (err) {
            setIsLoading(false);
            setErrorAlert(err);
        }
    };
    if (isLoading || isSetPaymentOptionLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.initializingFinancing')
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.selectFinancingOffer.header'),
        withStepProgress: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: t('allegro.setOffer.headline-1')
            }),
            isLoadingUpdateOffer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                message: t('allegro.updateApplication.loaderText')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                name: "selectOfferForm",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    offers.installment.map(({ program, terms, description, type })=>{
                        const [{ id, minimumFinancedAmount }] = terms;
                        const checked = selectedOffer.id === id;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioOptionDefault.default), {
                            className: "mb-3",
                            name: "offer",
                            value: id,
                            checked: checked,
                            onChange: (e)=>{
                                setSelectedOffer({
                                    id: e.target.value,
                                    minimumFinancedAmount,
                                    type
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "mb-1",
                                    children: program
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-sm",
                                    children: typeof description === 'string' ? description.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '').split('\n').map((line, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                            children: [
                                                i > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                line
                                            ]
                                        }, i)) : description ?? null
                                })
                            ]
                        }, id);
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "mt-4",
                        children: t('allegro.setOffer.headline-2')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formElementsStyled.StyledFormSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            label: `Cash Price`,
                                            prependText: "$",
                                            name: "price",
                                            type: "text",
                                            defaultValue: totalAmount,
                                            disabled: true,
                                            errors: errors,
                                            onFocus: onFocus
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            label: "Funding by Allegro",
                                            prependText: "$",
                                            name: "funding",
                                            type: "text",
                                            value: fundingAmount % 1 > 0 ? fundingAmount.toFixed(2) : fundingAmount,
                                            disabled: true,
                                            errors: {}
                                        })
                                    })
                                ]
                            }),
                            isContingentFunding ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert1.AlertWarning), {
                                className: "!my-2",
                                children: t('allegro.contigentFunding.downPaymentNote')
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                            register: register,
                                            label: downPaymentLabel,
                                            prependText: "$",
                                            name: "downPayment",
                                            type: "number",
                                            disabled: !selectedOffer.id,
                                            errors: errors,
                                            onFocus: onFocus
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
                                            name: "deliveryDate",
                                            control: control,
                                            rules: {
                                                required: t('common.requiredFieldDeliveryDate')
                                            },
                                            render: ({ field: { onChange, onBlur, name, value } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarInputFieldDefault.default), {
                                                    label: t('common.deliveryDate'),
                                                    name: name,
                                                    value: value,
                                                    onBlur: onBlur,
                                                    onChange: onChange,
                                                    dayPickerProps: {
                                                        disabledDays: {
                                                            before: new Date(),
                                                            after: (0, _dateFns.add)(new Date(), {
                                                                days: 60
                                                            })
                                                        }
                                                    },
                                                    errors: errors
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                        className: "md:!flex-col-3 !flex !items-end",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                            type: "submit",
                                            "data-testid": "update-offer",
                                            disabled: !selectedOffer.id,
                                            children: t('common.updateOffer')
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "!mt-4",
                        children: t('allegro.setOffer.headline-3')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formElementsStyled.StyledFormSection), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Row), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                className: "md:!flex-col-6",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputFieldDefault.default), {
                                    label: "Monthly Payment",
                                    prependText: "$",
                                    name: "monthlyPayment",
                                    type: "text",
                                    value: (0, _utils.getPropValue)(offer, 'price.monthlyPayment', ''),
                                    disabled: true,
                                    errors: {}
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                className: "md:!flex-col-6",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.SecondaryOutlineButton), {
                                    "data-testid": "cancel",
                                    onClick: onCancel,
                                    children: t('common.cancel')
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Column), {
                                className: "md:!flex-col-6 !flex !gap-1 !justify-end",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                    "data-testid": "set-offer",
                                    disabled: !offer,
                                    onClick: onContinue,
                                    children: t('common.continue')
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = SelectOffer;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-hook-form":"53GLT","date-fns":[["add","1Oe4T","default"],["formatISO","5S5YG","default"],["parse","jBRYJ","default"]],"Core/components/Option/RadioOption":"1sjrr","Core/components/FormElements/InputField":"6BJmW","Core/components/Page":"4xeqH","Core/components/Button":"6YNzH","react-i18next":"244ua","Core/components/FormElements/formElements.styled":"45aFS","Core/components/Layout":"hweet","Modules/creditDebit/components/Financing/allegro/useSelectOfferForm":"edtIv","Core/hooks/queries/payment/usePutPaymentOption":"iygdF","Core/hooks/queries/payment/useGetPaymentSummary":"2UTqE","Core/hooks/useScrollTop":"cBwQW","Modules/creditDebit/components/Financing/allegro/useUpdateOffer":"fsohJ","Core/components/Loader":"6S7S4","Core/components/FormElements/CalendarInputField":"50zwN","Core/stores/alert":"fPz3p","Core/components/Alert":"fmmNR","Core/utils/numberFormat":"6T56F","Core/utils/utils":"hwOBZ","Core/config/appConfig":"7qX5H","Core/config/constants":"ad5OP","Core/hooks/queries/payment/useGetPaymentOptions":"9UMm9","Core/hooks/queries/order/useOrder":"7ieVC","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"1sjrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RadioOption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _radioOptionStyled = require("./RadioOption.styled");
function RadioOption({ name, value, checked, disabled, testid, onChange, children }) {
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioOptionStyled.StyledLabel), {
        htmlFor: id,
        "data-testid": testid || id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioOptionStyled.StyledInput), {
                type: "radio",
                name: name,
                value: value,
                id: id,
                checked: checked,
                disabled: disabled,
                onChange: onChange,
                role: "radio"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioOptionStyled.StyledBody), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioOptionStyled.StyledCheckbox), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "w-full",
                        children: children
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","./RadioOption.styled":"jx0yn","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jx0yn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLabel", ()=>StyledLabel);
parcelHelpers.export(exports, "StyledCheckbox", ()=>StyledCheckbox);
parcelHelpers.export(exports, "StyledBody", ()=>StyledBody);
parcelHelpers.export(exports, "StyledInput", ()=>StyledInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const StyledLabel = ({ children, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
        className: "radio-option grid",
        ...rest,
        children: children
    });
const StyledCheckbox = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "radio-option-checkbox",
        children: children
    });
const StyledBody = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: 'radio-option-body',
        children: children
    });
const StyledInput = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        ...props,
        className: 'radio-option-input'
    });

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"edtIv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateDownPaymentAmount", ()=>validateDownPaymentAmount);
parcelHelpers.export(exports, "validateCustomDateFormat", ()=>validateCustomDateFormat);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _v3 = require("zod/v3");
var _zod = require("@hookform/resolvers/zod");
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
const validateDownPaymentAmount = (minimumDownPayment, maximumDownPayment)=>(value)=>{
        return value !== '' && value >= minimumDownPayment && value <= maximumDownPayment;
    };
const validateCustomDateFormat = (dateFormat)=>(val)=>{
        return val ? (0, _dateFns.isValid)((0, _dateFns.parse)(val, dateFormat, new Date())) : true;
    };
const useSelectOfferForm = ({ minimumDownPayment, maximumDownPayment, dateFormat })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const schema = (0, _reactDefault.default).useMemo(()=>{
        return _v3.object({
            deliveryDate: _v3.any().refine(validateCustomDateFormat(dateFormat), {
                message: t('common.invalidDateFormat')
            }),
            downPayment: _v3.any().transform(parseFloat).refine(validateDownPaymentAmount(minimumDownPayment, maximumDownPayment), {
                message: t('common.invalidValueRange', {
                    min: minimumDownPayment,
                    max: maximumDownPayment
                })
            })
        });
    }, [
        t,
        minimumDownPayment,
        maximumDownPayment,
        dateFormat
    ]);
    return (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(schema),
        defaultValues: {
            downPayment: minimumDownPayment,
            deliveryDate: (0, _dateFns.format)(new Date(), dateFormat)
        }
    });
};
exports.default = useSelectOfferForm;

},{"react":"2o0ib","react-i18next":"244ua","zod/v3":"kXNSc","@hookform/resolvers/zod":"c0M5u","react-hook-form":"53GLT","date-fns":[["format","7JNRj","default"],["isValid","jCEss","default"],["parse","jBRYJ","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fsohJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdateOffer);
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _reactQuery = require("react-query");
var _api = require("Core/utils/api");
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
function useUpdateOffer() {
    const { data: order } = (0, _useOrderDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((payload)=>(0, _api.put)(`/api/orders/${order.orderId}/financing/application`, payload), {
        throwOnError: true,
        retry: 3,
        onSuccess: ()=>{
            queryClient.removeQueries((0, _cacheKeysDefault.default).financingApplicationDetails);
            return queryClient.invalidateQueries((0, _cacheKeysDefault.default).financingApplication);
        }
    });
}

},{"Core/hooks/queries/order/useOrder":"7ieVC","react-query":"ksTpv","Core/utils/api":"cC5Cp","Core/hooks/queries/cacheKeys":"i5IL7","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"jfNx6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _footer = require("Core/components/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _alert = require("Core/components/Alert");
var _reactLocation = require("react-location");
const ApplicationStatus = ({ application, routes })=>{
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { id, status } = application;
    const getStatusMessage = ()=>{
        switch(status.toLowerCase()){
            case 'created':
            case 'contact':
            case 'prequalified':
            case 'prequalify':
            case 'no decision':
            case 'pending':
            case 'review':
                return t('allegro.application.status.additionalInputNeeded');
            case 'rejected':
            case 'declined':
                return t('allegro.application.status.notEligible');
            default:
                return t('allegro.application.status.processCanceled');
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.applicationStatus.header'),
        withStepProgress: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertWarning), {
                children: t('allegro.application.status.intro')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                    i18nKey: "allegro.application.status",
                    values: {
                        id,
                        status
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                children: getStatusMessage()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                hasNext: true,
                labelNext: t('common.goBackToPaymentOptions'),
                onNext: ()=>navigate({
                        to: routes.paymentOptions,
                        search: true
                    })
            })
        ]
    });
};
exports.default = ApplicationStatus;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":[["Trans","1d4RI"],["useTranslation","244ua"]],"Core/components/Page":"4xeqH","Core/components/Footer":"ixeAp","Core/components/Alert":"fmmNR","react-location":"8hNco","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"394BH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _orderReceipts = require("Core/components/Receipts/OrderReceipts");
var _orderReceiptsDefault = parcelHelpers.interopDefault(_orderReceipts);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _orderData = require("Core/components/Data/OrderData");
var _orderDataDefault = parcelHelpers.interopDefault(_orderData);
const FinancingSuccess = ()=>{
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const checklistItems = [
        {
            label: t('page.financing.checklist.approved'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.funded'),
            status: 'done'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
            title: t('page.financing.header'),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertSuccess), {
                    children: t('page.financing.financingFunded.infobox')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: t('page.financing.financingFunded.intro')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `text-center`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                                items: checklistItems
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderReceiptsDefault.default), {
                            title: t('page.creditDebit.success.clickToViewReceipt')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                    ]
                })
            ]
        })
    });
};
exports.default = FinancingSuccess;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Receipts/OrderReceipts":"4WrBV","Core/components/Page":"4xeqH","Core/components/Data/OrderData":"jg54z","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"2dFe2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _orderData = require("Core/components/Data/OrderData");
var _orderDataDefault = parcelHelpers.interopDefault(_orderData);
const FinancingError = ()=>{
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
            title: t('page.financing.header'),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                    children: t('page.financing.financingDeclined.infobox')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: t('page.financing.financingDeclined.intro')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                    ]
                })
            ]
        })
    });
};
exports.default = FinancingError;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Core/components/Page":"4xeqH","Core/components/Data/OrderData":"jg54z","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fmUAN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _useShowSidebar = require("Core/hooks/useShowSidebar");
var _alert = require("Core/components/Alert");
var _footer = require("Core/components/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _button = require("Core/components/Button");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _useGetFinancingApplicationDetails = require("Core/hooks/queries/payment/useGetFinancingApplicationDetails");
var _useGetFinancingApplicationDetailsDefault = parcelHelpers.interopDefault(_useGetFinancingApplicationDetails);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _shoppingCart = require("Core/components/ShoppingCart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
var _constants = require("Core/config/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _logger = require("Core/utils/logger");
var _useGetPaymentSummary = require("Core/hooks/queries/payment/useGetPaymentSummary");
var _useGetPaymentSummaryDefault = parcelHelpers.interopDefault(_useGetPaymentSummary);
var _reactLocation = require("react-location");
var _routes = require("Modules/creditDebit/routes");
const Financing = ({ nextRoutes })=>{
    (0, _useScrollTop.useScrollTop)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const shouldShowSidebar = (0, _useShowSidebar.useShowSidebar)();
    const [state, setState] = (0, _reactDefault.default).useState({
        refetchInterval: false,
        financingWindow: null,
        approved: 'done',
        approvedSigned: 'idle',
        funded: 'idle',
        isError: false
    });
    const { data: order } = (0, _useOrderDefault.default)();
    const { data: paymentSummary } = (0, _useGetPaymentSummaryDefault.default)();
    const { data: financingApplicationDetails, isError } = (0, _useGetFinancingApplicationDetailsDefault.default)(state.refetchInterval);
    (0, _reactDefault.default).useEffect(()=>{
        if (!financingApplicationDetails) return;
        const { status } = financingApplicationDetails;
        const financingStatus = status.toLowerCase();
        if (isError) {
            setState({
                refetchInterval: false,
                approvedSigned: 'error',
                funded: 'error'
            });
            return;
        }
        if (financingStatus === 'approved & signed' && state.approvedSigned !== 'done') {
            setState({
                ...state,
                approvedSigned: 'done'
            });
            return;
        }
        if (financingStatus === 'funded') {
            const featureList = {
                financing: (0, _logger.features).financingCheckout,
                mixed: (0, _logger.features).mixedPaymentCheckout
            };
            (0, _logger.postLogMessage)({
                amount: paymentSummary.totalAmountToPay,
                feature: featureList[order.optionSelected],
                status: 'success'
            });
            navigate({
                to: nextRoutes.success,
                search: true
            });
        } else if (financingStatus === 'declined') navigate({
            to: nextRoutes.error,
            search: true
        });
    }, [
        isError,
        state,
        financingApplicationDetails,
        nextRoutes.success,
        nextRoutes.error,
        paymentSummary.totalAmountToPay,
        order.optionSelected,
        navigate
    ]);
    if (!order || !paymentSummary || !financingApplicationDetails) return null;
    const openFinancingWindow = (e)=>{
        e.preventDefault();
        const financingWindow = window.open(financingApplicationDetails.windowUrl, '_blank');
        setState({
            ...state,
            refetchInterval: 5000,
            financingWindow,
            approvedSigned: 'loading',
            funded: 'loading'
        });
    };
    const checklistItems = [
        {
            label: t('page.financing.checklist.approved'),
            status: state.approved
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: state.approvedSigned
        },
        {
            label: t('page.financing.checklist.funded'),
            status: state.funded
        }
    ];
    // TODO find a better solution for this ...
    let infobox = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
        "data-testid": "infobox",
        children: t('page.financing.financingApproved.infobox')
    });
    let mixedQuestion = '';
    if (order.optionSelected === 'mixed') {
        checklistItems.unshift({
            label: t('financingApproved.checklist.downPayment'),
            status: 'done'
        });
        infobox = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertSuccess), {
            children: t('page.financing.financingApproved.infobox')
        });
        mixedQuestion = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                    children: t('page.financing.failedFinancing.question')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                t('page.financing.failedFinancing.answer')
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
        title: t('page.financing.header'),
        withSidebar: true,
        children: [
            state.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                children: t('status.error.failedToRequestFinancingApplicationState')
            }),
            infobox,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: t('page.financing.financingApproved.intro')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: checklistItems
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `py-2 text-center`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                            onClick: openFinancingWindow,
                            "data-testid": "finalize-financing",
                            children: t('page.financing.openFinancingPartnerWindow')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: t('page.financing.whereIsTheTab.question')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            t('page.financing.whereIsTheTab.answer')
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: t('page.financing.troubleFinalizing.question')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            t('page.financing.troubleFinalizing.answer')
                        ]
                    }),
                    mixedQuestion
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                hasPrev: order.optionSelected === (0, _constantsDefault.default).paymentOptions.FINANCING,
                labelPrev: t('common.back'),
                onPrev: ()=>navigate({
                        to: (0, _routes.paymentOptionsPath),
                        search: true
                    })
            }),
            !shouldShowSidebar && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shoppingCartDefault.default), {
                withTitle: true
            })
        ]
    });
};
// TODO solve this hack!
const FinancingApplicationCheck = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { data, isLoading, isError } = (0, _useGetFinancingApplicationDetailsDefault.default)(); // <-- PUBLIC
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading.financingApplication')
    });
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Navigate), {
        to: (0, _routes.createFinancingPath),
        search: true
    });
    if (data?.nextAction === 'createApplication' || data?.nextAction === 'selectOffer') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLocation.Navigate), {
        to: (0, _routes.createFinancingPath),
        search: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Financing, {
        ...props
    });
};
exports.default = FinancingApplicationCheck;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/hooks/useShowSidebar":"as56L","Core/components/Alert":"fmmNR","Core/components/Footer":"ixeAp","Core/components/Button":"6YNzH","Modules/creditDebit/components/Checklist":"cdvA9","Core/hooks/queries/order/useOrder":"7ieVC","Core/hooks/queries/payment/useGetFinancingApplicationDetails":"hMOJe","Core/components/Page":"4xeqH","Core/components/ShoppingCart":"2uMp1","Core/config/constants":"ad5OP","Core/components/Loader":"6S7S4","Core/utils/logger":"cWDKQ","Core/hooks/queries/payment/useGetPaymentSummary":"2UTqE","react-location":"8hNco","Modules/creditDebit/routes":"yRzgP","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"hMOJe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(refetchInterval = false) {
        const { t } = (0, _reactI18Next.useTranslation)();
        const setError = (0, _errorDefault.default)((0, _error.setErrorActionSelector));
        const { data: order } = (0, _useOrderDefault.default)();
        const navigate = (0, _reactLocation.useNavigate)();
        return (0, _reactQuery.useQuery)([
            (0, _cacheKeysDefault.default).financingApplicationDetails,
            order.orderId
        ], ()=>(0, _api.get)(`/api/application-details/${order.orderId}`), {
            enabled: Boolean(order),
            refetchInterval,
            onError (e) {
                const message = e?.response?.data?.message ? ` - ${e?.response?.data?.message}` : '';
                setError(t('status.error.getFinancingApplicationFailed') + message);
                navigate({
                    to: (0, _routes.errorPath),
                    search: true
                });
            }
        });
    });
var _reactI18Next = require("react-i18next");
var _reactQuery = require("react-query");
var _useOrder = require("Core/hooks/queries/order/useOrder");
var _useOrderDefault = parcelHelpers.interopDefault(_useOrder);
var _cacheKeys = require("Core/hooks/queries/cacheKeys");
var _cacheKeysDefault = parcelHelpers.interopDefault(_cacheKeys);
var _api = require("Core/utils/api");
var _error = require("Core/stores/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactLocation = require("react-location");
var _routes = require("Core/routes");

},{"react-i18next":"244ua","react-query":"ksTpv","Core/hooks/queries/order/useOrder":"7ieVC","Core/hooks/queries/cacheKeys":"i5IL7","Core/utils/api":"cC5Cp","Core/stores/error":"38MVH","react-location":"8hNco","Core/routes":"iddMu","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"gnIMU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useShowSidebar = require("Core/hooks/useShowSidebar");
var _alert = require("Core/components/Alert");
var _shoppingCart = require("Core/components/ShoppingCart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
var _downPayment = require("Core/components/ShoppingCart/DownPayment");
var _downPaymentDefault = parcelHelpers.interopDefault(_downPayment);
var _footer = require("Core/components/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _dialog = require("Core/stores/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _reactLocation = require("react-location");
var _routes = require("Modules/creditDebit/routes");
var _orderData = require("Core/components/Data/OrderData");
var _orderDataDefault = parcelHelpers.interopDefault(_orderData);
const AvailableCredit = ()=>{
    const navigate = (0, _reactLocation.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const shouldShowSidebar = (0, _useShowSidebar.useShowSidebar)();
    const showDialog = (0, _dialogDefault.default)((0, _dialog.showDialogSelector));
    function onCancel() {
        showDialog({
            title: t('common.cancelPaymentProcess'),
            description: t('common.confirmDownPaymentCancellation'),
            confirmButtonLabel: t('common.yes'),
            cancelButtonLabel: t('common.no'),
            confirmCallback: ()=>navigate({
                    to: (0, _routes.paymentOptionsPath),
                    search: true
                })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
            title: t('page.availableCredit.header'),
            withSidebar: true,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                    "data-testid": "infobox",
                    children: t('page.availableCredit.infobox')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downPaymentDefault.default), {}),
                !shouldShowSidebar && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shoppingCartDefault.default), {
                    withTitle: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                    labelPrev: t('common.cancel'),
                    labelNext: t('common.continue'),
                    onPrev: onCancel,
                    onNext: ()=>navigate({
                            to: (0, _routes.mixedFinancingPath),
                            search: true
                        })
                })
            ]
        })
    });
};
exports.default = AvailableCredit;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useShowSidebar":"as56L","Core/components/Alert":"fmmNR","Core/components/ShoppingCart":"2uMp1","Core/components/ShoppingCart/DownPayment":"gBW2f","Core/components/Footer":"ixeAp","Core/stores/dialog":"6IfFO","Core/components/Page":"4xeqH","react-location":"8hNco","Modules/creditDebit/routes":"yRzgP","Core/components/Data/OrderData":"jg54z","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4ARYe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _orderReceipts = require("Core/components/Receipts/OrderReceipts");
var _orderReceiptsDefault = parcelHelpers.interopDefault(_orderReceipts);
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _orderData = require("Core/components/Data/OrderData");
var _orderDataDefault = parcelHelpers.interopDefault(_orderData);
const MixedSuccess = ()=>{
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const checklistItems = [
        {
            label: t('mixed.financingApproved.checklist.downPayment'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approved'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.funded'),
            status: 'done'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
            title: t('page.mixed.success.header'),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertSuccess), {
                    children: t('page.mixed.success.infobox')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: t('page.mixed.success.intro')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `text-center`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                                items: checklistItems
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderReceiptsDefault.default), {
                            title: t('page.creditDebit.success.clickToViewReceipt')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                    ]
                })
            ]
        })
    });
};
exports.default = MixedSuccess;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Receipts/OrderReceipts":"4WrBV","Core/components/Page":"4xeqH","Core/components/Data/OrderData":"jg54z","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"40NOf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _useScrollTop = require("Core/hooks/useScrollTop");
var _alert = require("Core/components/Alert");
var _checklist = require("Modules/creditDebit/components/Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _button = require("Core/components/Button");
var _page = require("Core/components/Page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _reactLocation = require("react-location");
var _routes = require("Modules/creditDebit/routes");
var _orderData = require("Core/components/Data/OrderData");
var _orderDataDefault = parcelHelpers.interopDefault(_orderData);
const MixedError = ()=>{
    const navigate = (0, _reactLocation.useNavigate)();
    (0, _useScrollTop.useScrollTop)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const checklistItems = [
        {
            label: t('mixed.financingApproved.checklist.downPayment'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approved'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.approvedSigned'),
            status: 'done'
        },
        {
            label: t('page.financing.checklist.funded'),
            status: 'error'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDataDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageDefault.default), {
            title: t('page.mixed.error.header'),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.AlertError), {
                    children: t('page.mixed.error.infobox')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alert.Alert), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: t('page.mixed.error.intro')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `text-center`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                                items: checklistItems
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `py-2 text-center`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.PrimaryButton), {
                                onClick: ()=>navigate({
                                        to: (0, _routes.paymentOptionsPath),
                                        search: true
                                    }),
                                children: t('common.useAnotherPaymentOption')
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                    ]
                })
            ]
        })
    });
};
exports.default = MixedError;

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","react-i18next":"244ua","Core/hooks/useScrollTop":"cBwQW","Core/components/Alert":"fmmNR","Modules/creditDebit/components/Checklist":"cdvA9","Core/components/Button":"6YNzH","Core/components/Page":"4xeqH","react-location":"8hNco","Modules/creditDebit/routes":"yRzgP","Core/components/Data/OrderData":"jg54z","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"j9PjZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Collect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loader = require("Core/components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _reactI18Next = require("react-i18next");
var _usePutPaymentOption = require("Core/hooks/queries/payment/usePutPaymentOption");
var _usePutPaymentOptionDefault = parcelHelpers.interopDefault(_usePutPaymentOption);
var _routes = require("Modules/creditDebit/routes");
var _reactLocation = require("react-location");
var _routes1 = require("Core/routes");
var _useGetPaymentSummary = require("Core/hooks/queries/payment/useGetPaymentSummary");
var _useGetPaymentSummaryDefault = parcelHelpers.interopDefault(_useGetPaymentSummary);
const routes = {
    'credit-debit': (0, _routes.creditDebitCheckoutPath),
    mixed: (0, _routes.mixedDownPaymentCheckoutPath),
    financing: (0, _routes.financingPath)
};
function Collect() {
    const { paymentOption } = (0, _reactLocation.useSearch)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { mutateAsync: setPaymentOption } = (0, _usePutPaymentOptionDefault.default)();
    const navigate = (0, _reactLocation.useNavigate)();
    const { data: paymentSummary } = (0, _useGetPaymentSummaryDefault.default)();
    const updateAndRoute = (0, _react.useCallback)(async ()=>{
        let option = paymentOption;
        if (!paymentSummary) return;
        if (!option) return navigate({
            to: (0, _routes.paymentOptionsPath),
            search: true
        });
        try {
            //if there downpayment then redirect financing to mixed.
            if (paymentSummary.downPayment > 0 && option === 'financing') option = 'mixed';
            await setPaymentOption(option);
            return navigate({
                to: routes[option],
                search: true
            });
        } catch (_) {
            return navigate({
                to: (0, _routes1.errorPath),
                search: true
            });
        }
    }, [
        navigate,
        paymentOption,
        setPaymentOption,
        paymentSummary
    ]);
    (0, _react.useEffect)(()=>{
        updateAndRoute().then();
    }, [
        updateAndRoute
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
        message: t('status.loading')
    });
}

},{"react/jsx-runtime":"9x2lT","react":"2o0ib","Core/components/Loader":"6S7S4","react-i18next":"244ua","Core/hooks/queries/payment/usePutPaymentOption":"iygdF","Modules/creditDebit/routes":"yRzgP","react-location":"8hNco","Core/routes":"iddMu","Core/hooks/queries/payment/useGetPaymentSummary":"2UTqE","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"4DOSg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _i18Next = require("i18next");
var _i18NextDefault = parcelHelpers.interopDefault(_i18Next);
var _reactI18Next = require("react-i18next");
var _i18NextLocizeBackend = require("i18next-locize-backend");
var _i18NextLocizeBackendDefault = parcelHelpers.interopDefault(_i18NextLocizeBackend);
var _i18NextBrowserLanguagedetector = require("i18next-browser-languagedetector");
var _i18NextBrowserLanguagedetectorDefault = parcelHelpers.interopDefault(_i18NextBrowserLanguagedetector);
var _appConfig = require("Core/config/appConfig");
var _numberFormat = require("Core/utils/numberFormat");
(0, _i18NextDefault.default).use((0, _i18NextLocizeBackendDefault.default)).use((0, _reactI18Next.initReactI18next)).use((0, _i18NextBrowserLanguagedetectorDefault.default)).init({
    backend: {
        projectId: "6f0ce073-6d30-460b-afa6-f45750b3986e",
        apiKey: "1cc8c51e-8246-4ef4-bbde-ffc426ebb74c",
        referenceLng: 'en-US',
        allowedAddOrUpdateHosts: [
            'localhost'
        ],
        cdnType: 'pro'
    },
    lng: (0, _appConfig.getAppConfig)().locale,
    fallbackLng: 'en-US',
    load: 'currentOnly',
    debug: false,
    interpolation: {
        escapeValue: false,
        format: (data, format)=>{
            switch(format){
                case 'formatCurrency':
                    return (0, _numberFormat.formatCurrency)(data);
                default:
                    return data;
            }
        }
    },
    nsSeparator: false,
    keySeparator: false,
    defaultNS: 'default',
    saveMissing: "0"
});
exports.default = (0, _i18NextDefault.default);

},{"i18next":"5Rp6F","react-i18next":"5E9U1","i18next-locize-backend":"fCAxi","i18next-browser-languagedetector":"kqmNz","Core/config/appConfig":"7qX5H","Core/utils/numberFormat":"6T56F","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5Rp6F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "changeLanguage", ()=>changeLanguage);
parcelHelpers.export(exports, "createInstance", ()=>createInstance);
parcelHelpers.export(exports, "exists", ()=>exists);
parcelHelpers.export(exports, "getFixedT", ()=>getFixedT);
parcelHelpers.export(exports, "hasLoadedNamespace", ()=>hasLoadedNamespace);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "loadLanguages", ()=>loadLanguages);
parcelHelpers.export(exports, "loadNamespaces", ()=>loadNamespaces);
parcelHelpers.export(exports, "loadResources", ()=>loadResources);
parcelHelpers.export(exports, "reloadResources", ()=>reloadResources);
parcelHelpers.export(exports, "setDefaultNamespace", ()=>setDefaultNamespace);
parcelHelpers.export(exports, "t", ()=>t);
parcelHelpers.export(exports, "use", ()=>use);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _possibleConstructorReturn = require("@babel/runtime/helpers/esm/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/esm/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _toArray = require("@babel/runtime/helpers/esm/toArray");
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var consoleLogger = {
    type: 'logger',
    log: function log(args) {
        this.output('log', args);
    },
    warn: function warn(args) {
        this.output('warn', args);
    },
    error: function error(args) {
        this.output('error', args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, _classCallCheckDefault.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, _createClassDefault.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _objectSpread(_objectSpread({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
    function EventEmitter() {
        (0, _classCallCheckDefault.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, _createClassDefault.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers['*']) {
                    var _cloned = [].concat(this.observers['*']);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === '?' ? '\\?' : c;
    }).join('|'), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$1(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfDefault.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfDefault.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnDefault.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === 'string') return mix;
                if (p && typeof mix[p] === 'string') return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var ResourceStore = function(_EventEmitter) {
    (0, _inheritsDefault.default)(ResourceStore, _EventEmitter);
    var _super = _createSuper(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, _classCallCheckDefault.default)(this, ResourceStore);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, _assertThisInitializedDefault.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, _createClassDefault.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== 'string') path = path.concat(key);
                if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) path = lng.split('.');
                var result = getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
                return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = '.';
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$2(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfDefault.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfDefault.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnDefault.default)(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
    (0, _inheritsDefault.default)(Translator, _EventEmitter);
    var _super = _createSuper$1(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, _classCallCheckDefault.default)(this, Translator);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, _assertThisInitializedDefault.default)(_this));
        copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, (0, _assertThisInitializedDefault.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = baseLogger.create('translator');
        return _this;
    }
    (0, _createClassDefault.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, _typeofDefault.default)(options) !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return '';
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) {
                            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
                            return resolved;
                        }
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) {
                        resolved.res = key;
                        return resolved;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === '[object Array]';
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
                        interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === 'string' ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === 'string') keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = 'defaultValue';
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, _classCallCheckDefault.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create('languageUtils');
    }
    (0, _createClassDefault.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === 'x') return null;
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    var specialCases = [
                        'hans',
                        'hant',
                        'latn',
                        'cyrl',
                        'cans',
                        'mong',
                        'arab'
                    ];
                    var p = code.split('-');
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
                    }
                    return p.join('-');
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
                if (typeof fallbacks === 'string') fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var _rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var deprecatedJsonVersions = [
    'v1',
    'v2',
    'v3'
];
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    var rules = {};
    sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, _classCallCheckDefault.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = createRules();
    }
    (0, _createClassDefault.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? 'ordinal' : 'cardinal'
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return '';
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = 'plural';
                    else if (suffix === 1) suffix = '';
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === 'v1') {
                    if (suffix === 1) return '';
                    if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$3(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _classCallCheckDefault.default)(this, Interpolator);
        this.logger = baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, _createClassDefault.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
                this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
                this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
                this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
                this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, 'g');
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, '$$$$');
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === 'function') {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === 'string' ? temp : '';
                            } else if (options && options.hasOwnProperty(matchedVar)) value = '';
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = '';
                            }
                        } else if (typeof value !== 'string' && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = _objectSpread$3({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== 'string') return value;
                    if (typeof value !== 'string') value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$4(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        var p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(';');
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(':'), _opt$split2 = (0, _toArrayDefault.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === 'false') formatOptions[key.trim()] = false;
                if (val === 'true') formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _classCallCheckDefault.default)(this, Formatter);
        this.logger = baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, options);
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
                    style: 'currency'
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val, options.range || 'day');
                };
            }),
            list: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, _createClassDefault.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng, options) {
                var _this = this;
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$5(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfDefault.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfDefault.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnDefault.default)(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var Connector = function(_EventEmitter) {
    (0, _inheritsDefault.default)(Connector, _EventEmitter);
    var _super = _createSuper$2(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, _classCallCheckDefault.default)(this, Connector);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, _assertThisInitializedDefault.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create('backendConnector');
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, _createClassDefault.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(ns) {
                                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit('loaded', loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                return this.backend[fcName](lng, ns, function(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, 'read', undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                }
                if (key === undefined || key === null || key === '') return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, _typeofDefault.default)(args[1]) === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if ((0, _typeofDefault.default)(args[2]) === 'object' || (0, _typeofDefault.default)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$6(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfDefault.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfDefault.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnDefault.default)(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function noop() {}
function bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
}
var I18n = function(_EventEmitter) {
    (0, _inheritsDefault.default)(I18n, _EventEmitter);
    var _super = _createSuper$3(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, _classCallCheckDefault.default)(this, I18n);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, _assertThisInitializedDefault.default)(_this));
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions((0, _assertThisInitializedDefault.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, _possibleConstructorReturnDefault.default)(_this, (0, _assertThisInitializedDefault.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, _createClassDefault.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === 'string') options.defaultNS = options.ns;
                    else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));
                if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== 'undefined') formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on('*', function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
                var storeApi = [
                    'getResource',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle'
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
                        _this2.emit('initialized', _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = typeof language === 'string' ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
                if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') postProcessor.addPostProcessor(module);
                if (module.type === 'formatter') this.modules.formatter = module;
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    'cimode',
                    'dev'
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        'cimode',
                        'dev'
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit('languageChanging', lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit('languageChanged', l);
                        _this4.logger.log('languageChanged', l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, _typeofDefault.default)(opts) !== 'object') {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = _objectSpread$6({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || '.';
                    var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === 'string') fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === 'string') ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = defer();
                if (typeof lngs === 'string') lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return 'rtl';
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ug',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam',
                    'ckb'
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = _objectSpread$6({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new Translator(clone.services, clone.options);
                clone.translator.on('*', function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}(EventEmitter);
(0, _definePropertyDefault.default)(I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;
exports.default = instance;

},{"@babel/runtime/helpers/esm/typeof":"h3CKR","@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@babel/runtime/helpers/esm/assertThisInitialized":"iiPVd","@babel/runtime/helpers/esm/inherits":"g1vjz","@babel/runtime/helpers/esm/possibleConstructorReturn":"43WJR","@babel/runtime/helpers/esm/getPrototypeOf":"hl5B9","@babel/runtime/helpers/esm/defineProperty":"le3Cp","@babel/runtime/helpers/esm/toArray":"9m461","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"9m461":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toArray);
var _arrayWithHolesJs = require("./arrayWithHoles.js");
var _arrayWithHolesJsDefault = parcelHelpers.interopDefault(_arrayWithHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableRestJs = require("./nonIterableRest.js");
var _nonIterableRestJsDefault = parcelHelpers.interopDefault(_nonIterableRestJs);
function _toArray(r) {
    return (0, _arrayWithHolesJsDefault.default)(r) || (0, _iterableToArrayJsDefault.default)(r) || (0, _unsupportedIterableToArrayJsDefault.default)(r) || (0, _nonIterableRestJsDefault.default)();
}

},{"./arrayWithHoles.js":"6zIYh","./iterableToArray.js":"cs8Pa","./unsupportedIterableToArray.js":"i7TZP","./nonIterableRest.js":"c14iJ","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"6zIYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithHoles);
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"cs8Pa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArray);
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"c14iJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableRest);
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"fCAxi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _requestJs = require("./request.js");
var _requestJsDefault = parcelHelpers.interopDefault(_requestJs);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getApiPaths = function getApiPaths(cdnType) {
    if (!cdnType) cdnType = 'standard';
    return {
        loadPath: "https://api".concat(cdnType === 'standard' ? '.lite' : '', ".locize.app/{{projectId}}/{{version}}/{{lng}}/{{ns}}"),
        privatePath: "https://api".concat(cdnType === 'standard' ? '.lite' : '', ".locize.app/private/{{projectId}}/{{version}}/{{lng}}/{{ns}}"),
        getLanguagesPath: "https://api".concat(cdnType === 'standard' ? '.lite' : '', ".locize.app/languages/{{projectId}}"),
        addPath: "https://api".concat(cdnType === 'standard' ? '.lite' : '', ".locize.app/missing/{{projectId}}/{{version}}/{{lng}}/{{ns}}"),
        updatePath: "https://api".concat(cdnType === 'standard' ? '.lite' : '', ".locize.app/update/{{projectId}}/{{version}}/{{lng}}/{{ns}}")
    };
};
var getDefaults = function getDefaults(cdnType) {
    if (!cdnType) cdnType = 'standard';
    return (0, _utilsJs.defaults)({
        cdnType: cdnType,
        noCache: false,
        referenceLng: 'en',
        crossDomain: true,
        setContentTypeJSON: false,
        version: 'latest',
        private: false,
        translatedPercentageThreshold: 0.9,
        failLoadingOnEmptyJSON: false,
        allowedAddOrUpdateHosts: [
            'localhost'
        ],
        onSaved: false,
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        checkForProjectTimeout: 3000,
        storageExpiration: 3600000,
        writeDebounce: 5000,
        useCacheLayer: typeof window === 'undefined'
    }, getApiPaths(cdnType));
};
var hasLocalStorageSupport;
try {
    hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
    var testKey = 'notExistingLocizeProject';
    window.localStorage.setItem(testKey, 'foo');
    window.localStorage.removeItem(testKey);
} catch (e) {
    hasLocalStorageSupport = false;
}
function getStorage(storageExpiration) {
    var setProjectNotExisting = function setProjectNotExisting() {};
    var isProjectNotExisting = function isProjectNotExisting() {};
    if (hasLocalStorageSupport) {
        setProjectNotExisting = function setProjectNotExisting(projectId) {
            window.localStorage.setItem("notExistingLocizeProject_".concat(projectId), Date.now());
        };
        isProjectNotExisting = function isProjectNotExisting(projectId) {
            var ret = window.localStorage.getItem("notExistingLocizeProject_".concat(projectId));
            if (!ret) return false;
            if (Date.now() - ret > storageExpiration) {
                window.localStorage.removeItem("notExistingLocizeProject_".concat(projectId));
                return false;
            }
            return true;
        };
    } else if (typeof document !== 'undefined') {
        setProjectNotExisting = function setProjectNotExisting(projectId) {
            var date = new Date();
            date.setTime(date.getTime() + storageExpiration);
            var expires = "; expires=".concat(date.toGMTString());
            var name = "notExistingLocizeProject_".concat(projectId);
            try {
                document.cookie = "".concat(name, "=").concat(Date.now()).concat(expires, ";path=/");
            } catch (err) {}
        };
        isProjectNotExisting = function isProjectNotExisting(projectId) {
            var name = "notExistingLocizeProject_".concat(projectId);
            var nameEQ = "".concat(name, "=");
            try {
                var ca = document.cookie.split(';');
                for(var i = 0; i < ca.length; i++){
                    var c = ca[i];
                    while(c.charAt(0) === ' ')c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) === 0) return true;
                }
            } catch (err) {}
            return false;
        };
    }
    return {
        setProjectNotExisting: setProjectNotExisting,
        isProjectNotExisting: isProjectNotExisting
    };
}
var getCustomRequestInfo = function getCustomRequestInfo(url, options, payload) {
    var headers = {};
    if (options.authorize && options.apiKey) headers.Authorization = options.apiKey;
    if (payload || options.setContentTypeJSON) headers['Content-Type'] = 'application/json';
    return {
        method: payload ? 'POST' : 'GET',
        url: url,
        headers: headers,
        body: payload
    };
};
var handleCustomRequest = function handleCustomRequest(opt, info, cb) {
    if (opt.request.length === 1) {
        try {
            var r = opt.request(info);
            if (r && typeof r.then === 'function') r.then(function(data) {
                return cb(null, data);
            }).catch(cb);
            else cb(null, r);
        } catch (err) {
            cb(err);
        }
        return;
    }
    opt.request(info, cb);
};
function randomizeTimeout(base) {
    var variance = base * 0.25;
    var min = Math.max(0, base - variance);
    var max = base + variance;
    return Math.floor(min + Math.random() * (max - min));
}
var I18NextLocizeBackend = function() {
    function I18NextLocizeBackend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var callback = arguments.length > 3 ? arguments[3] : undefined;
        _classCallCheck(this, I18NextLocizeBackend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        if (services && services.projectId) this.init(null, services, allOptions, options);
        else this.init(services, options, allOptions, callback);
    }
    return _createClass(I18NextLocizeBackend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!options.referenceLng && allOptions.fallbackLng && Array.isArray(allOptions.fallbackLng) && allOptions.fallbackLng[0] !== 'dev') options.referenceLng = allOptions.fallbackLng[0];
                this.services = services;
                var orgPassedOptions = (0, _utilsJs.defaults)({}, options);
                var passedOpt = (0, _utilsJs.defaults)(options, this.options || {});
                var defOpt = getDefaults(passedOpt.cdnType);
                if (passedOpt.reloadInterval && passedOpt.reloadInterval < 300000) {
                    console.warn('Your configured reloadInterval option is to low.');
                    passedOpt.reloadInterval = defOpt.reloadInterval;
                }
                this.options = (0, _utilsJs.defaults)(options, this.options || {}, defOpt);
                this.allOptions = allOptions;
                this.somethingLoaded = false;
                this.isProjectNotExisting = false;
                this.storage = getStorage(this.options.storageExpiration);
                var apiPaths = getApiPaths(this.options.cdnType);
                Object.keys(apiPaths).forEach(function(ap) {
                    if (!orgPassedOptions[ap]) _this.options[ap] = apiPaths[ap];
                });
                if (allOptions.debug && orgPassedOptions.noCache === undefined && this.options.cdnType === 'standard') this.options.noCache = true;
                if (this.options.noCache && this.options.cdnType !== 'standard') console.warn("The 'noCache' option is not available for 'cdnType' '".concat(this.options.cdnType, "'!"));
                var hostname = typeof window !== 'undefined' && window.location && window.location.hostname;
                if (hostname) {
                    this.isAddOrUpdateAllowed = typeof this.options.allowedAddOrUpdateHosts === 'function' ? this.options.allowedAddOrUpdateHosts(hostname) : this.options.allowedAddOrUpdateHosts.indexOf(hostname) > -1;
                    if (services && services.logger && (allOptions.saveMissing || allOptions.updateMissing)) {
                        if (!this.isAddOrUpdateAllowed) services.logger.warn(typeof this.options.allowedAddOrUpdateHosts === 'function' ? "locize-backend: will not save or update missings because allowedAddOrUpdateHosts returned false for the host \"".concat(hostname, "\".") : "locize-backend: will not save or update missings because the host \"".concat(hostname, "\" was not in the list of allowedAddOrUpdateHosts: ").concat(this.options.allowedAddOrUpdateHosts.join(', '), " (matches need to be exact)."));
                        else if (hostname !== 'localhost') services.logger.warn("locize-backend: you are using the save or update missings feature from this host \"".concat(hostname, "\".\nMake sure you will not use it in production!\nhttps://www.locize.com/docs/going-to-production"));
                    }
                } else this.isAddOrUpdateAllowed = true;
                if (typeof callback === 'function') this.getOptions(function(err, opts, languages) {
                    if (err) return callback(err);
                    _this.options.referenceLng = options.referenceLng || opts.referenceLng || _this.options.referenceLng;
                    callback(null, opts, languages);
                });
                this.queuedWrites = {
                    pending: {}
                };
                this.debouncedProcess = (0, _utilsJs.debounce)(this.process, this.options.writeDebounce);
                if (this.interval) clearInterval(this.interval);
                if (this.options.reloadInterval && this.options.projectId) {
                    this.interval = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if (_typeof(this.interval) === 'object' && typeof this.interval.unref === 'function') this.interval.unref();
                }
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this2 = this;
                var _ref = this.services || {
                    logger: console
                }, backendConnector = _ref.backendConnector, languageUtils = _ref.languageUtils, logger = _ref.logger;
                if (!backendConnector) return;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this2.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        },
        {
            key: "getLanguages",
            value: function getLanguages(callback) {
                var _this3 = this;
                var deferred;
                if (!callback) {
                    deferred = (0, _utilsJs.defer)();
                    callback = function callback(err, ret) {
                        if (err) return deferred.reject(err);
                        deferred.resolve(ret);
                    };
                }
                var isMissing = (0, _utilsJs.isMissingOption)(this.options, [
                    'projectId'
                ]);
                if (isMissing) {
                    callback(new Error(isMissing));
                    return deferred;
                }
                var url = (0, _utilsJs.interpolateUrl)(this.options.getLanguagesPath, {
                    projectId: this.options.projectId
                });
                if (url == null) {
                    callback(new Error("i18next-locize-backend: unsafe projectId \u2014 refusing to build request URL for projectId=" + (0, _utilsJs.sanitizeLogValue)(String(this.options.projectId))));
                    return deferred;
                }
                if (!this.isProjectNotExisting && this.storage.isProjectNotExisting(this.options.projectId)) this.isProjectNotExisting = true;
                if (this.isProjectNotExisting) {
                    callback(new Error(this.isProjectNotExistingErrorMessage || "Locize project ".concat(this.options.projectId, " does not exist!")));
                    return deferred;
                }
                this.getLanguagesCalls = this.getLanguagesCalls || [];
                this.getLanguagesCalls.push(callback);
                if (this.getLanguagesCalls.length > 1) return deferred;
                this.loadUrl({}, url, function(err, ret, info) {
                    if (!_this3.somethingLoaded && info && info.resourceNotExisting) {
                        _this3.isProjectNotExisting = true;
                        var errMsg = "Locize project ".concat(_this3.options.projectId, " does not exist!");
                        _this3.isProjectNotExistingErrorMessage = errMsg;
                        var cdnTypeAlt = _this3.options.cdnType === 'standard' ? 'pro' : 'standard';
                        var otherEndpointApiPaths = getApiPaths(cdnTypeAlt);
                        var urlAlt = (0, _utilsJs.interpolateUrl)(otherEndpointApiPaths.getLanguagesPath, {
                            projectId: _this3.options.projectId
                        });
                        if (urlAlt == null) return;
                        _this3.loadUrl({}, urlAlt, function(errAlt, retAlt, infoAlt) {
                            if (!errAlt && retAlt && (!infoAlt || !infoAlt.resourceNotExisting)) {
                                errMsg += " It seems you're using the wrong cdnType. Your Locize project is configured to use \"".concat(cdnTypeAlt, "\" but here you've configured \"").concat(_this3.options.cdnType, "\".");
                                _this3.isProjectNotExistingErrorMessage = errMsg;
                            } else if (!_this3.somethingLoaded && infoAlt && infoAlt.resourceNotExisting) {
                                _this3.isProjectNotExisting = true;
                                _this3.storage.setProjectNotExisting(_this3.options.projectId);
                            }
                            var e = new Error(errMsg);
                            var clbs = _this3.getLanguagesCalls;
                            _this3.getLanguagesCalls = [];
                            clbs.forEach(function(clb) {
                                return clb(e);
                            });
                        });
                        return;
                    }
                    if (ret) {
                        _this3.loadedLanguages = Object.keys(ret);
                        var referenceLng = _this3.loadedLanguages.reduce(function(mem, k) {
                            var item = ret[k];
                            if (item.isReferenceLanguage) mem = k;
                            return mem;
                        }, '');
                        if (referenceLng && _this3.options.referenceLng !== referenceLng) _this3.options.referenceLng = referenceLng;
                    }
                    _this3.somethingLoaded = true;
                    var clbs = _this3.getLanguagesCalls;
                    _this3.getLanguagesCalls = [];
                    clbs.forEach(function(clb) {
                        return clb(err, ret);
                    });
                });
                return deferred;
            }
        },
        {
            key: "getOptions",
            value: function getOptions(callback) {
                var _this4 = this;
                var deferred;
                if (!callback) {
                    deferred = (0, _utilsJs.defer)();
                    callback = function callback(err, ret) {
                        if (err) return deferred.reject(err);
                        deferred.resolve(ret);
                    };
                }
                this.getLanguages(function(err, data) {
                    if (err) return callback(err);
                    var keys = Object.keys(data);
                    if (!keys.length) return callback(new Error('was unable to load languages via API'));
                    var lngs = keys.reduce(function(mem, k) {
                        var item = data[k];
                        if (item.translated[_this4.options.version] && item.translated[_this4.options.version] >= _this4.options.translatedPercentageThreshold) mem.push(k);
                        return mem;
                    }, []);
                    var hasRegion = keys.reduce(function(mem, k) {
                        if (k.indexOf('-') > -1) return true;
                        return mem;
                    }, false);
                    callback(null, {
                        fallbackLng: _this4.options.referenceLng,
                        referenceLng: _this4.options.referenceLng,
                        supportedLngs: lngs.length === 0 && _this4.options.referenceLng ? [
                            _this4.options.referenceLng
                        ] : lngs,
                        load: hasRegion ? 'all' : 'languageOnly'
                    }, data);
                });
                return deferred;
            }
        },
        {
            key: "checkIfProjectExists",
            value: function checkIfProjectExists(callback) {
                var _this5 = this;
                var _ref2 = this.services || {
                    logger: console
                }, logger = _ref2.logger;
                if (this.somethingLoaded) {
                    if (callback) callback(null);
                    return;
                }
                if (this.alreadyRequestedCheckIfProjectExists) {
                    setTimeout(function() {
                        return _this5.checkIfProjectExists(callback);
                    }, randomizeTimeout(this.options.checkForProjectTimeout));
                    return;
                }
                this.alreadyRequestedCheckIfProjectExists = true;
                this.getLanguages(function(err) {
                    if (err && err.message && err.message.indexOf('does not exist') > 0) {
                        if (logger) logger.error(err.message);
                    }
                    if (callback) callback(err);
                });
            }
        },
        {
            key: "checkIfLanguagesLoaded",
            value: function checkIfLanguagesLoaded(callback) {
                var _ref3 = this.services || {
                    logger: console
                }, logger = _ref3.logger;
                if (this.loadedLanguages) {
                    if (callback) callback(null);
                    return;
                }
                this.getLanguages(function(err) {
                    if (err && err.message && err.message.indexOf('does not exist') > 0) {
                        if (logger) logger.error(err.message);
                    }
                    if (callback) callback(err);
                });
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                var _this6 = this;
                var _ref4 = this.services || {
                    logger: console
                }, logger = _ref4.logger;
                var url;
                var options = {};
                if (this.options.private) {
                    var isMissing = (0, _utilsJs.isMissingOption)(this.options, [
                        'projectId',
                        'version',
                        'apiKey'
                    ]);
                    if (isMissing) return callback(new Error(isMissing), false);
                    url = (0, _utilsJs.interpolateUrl)(this.options.privatePath, {
                        lng: language,
                        ns: namespace,
                        projectId: this.options.projectId,
                        version: this.options.version
                    });
                    options = {
                        authorize: true
                    };
                } else {
                    var _isMissing = (0, _utilsJs.isMissingOption)(this.options, [
                        'projectId',
                        'version'
                    ]);
                    if (_isMissing) return callback(new Error(_isMissing), false);
                    url = (0, _utilsJs.interpolateUrl)(this.options.loadPath, {
                        lng: language,
                        ns: namespace,
                        projectId: this.options.projectId,
                        version: this.options.version
                    });
                }
                if (url == null) return callback(new Error("i18next-locize-backend: unsafe lng/ns/projectId/version \u2014 refusing to build request URL for lng=" + (0, _utilsJs.sanitizeLogValue)(String(language)) + ' ns=' + (0, _utilsJs.sanitizeLogValue)(String(namespace))), false);
                if (!this.isProjectNotExisting && this.storage.isProjectNotExisting(this.options.projectId)) this.isProjectNotExisting = true;
                if (this.isProjectNotExisting) {
                    var err = new Error(this.isProjectNotExistingErrorMessage || "Locize project ".concat(this.options.projectId, " does not exist!"));
                    if (logger) logger.error(err.message);
                    if (callback) callback(err);
                    return;
                }
                if (this.warnedLanguages && this.warnedLanguages.indexOf(language) > -1) {
                    var _err = new Error("Will not continue to load language \"".concat(language, "\" since it is not available in Locize project ").concat(this.options.projectId, "!"));
                    if (logger) logger.error(_err.message);
                    if (callback) callback(_err);
                    return;
                }
                this.loadUrl(options, url, function(err, ret, info) {
                    var resourceNotExisting = info && info.resourceNotExisting;
                    if (!resourceNotExisting) {
                        _this6.hasResourcesForLng || (_this6.hasResourcesForLng = {});
                        _this6.hasResourcesForLng[language] = true;
                    }
                    if (resourceNotExisting && (!_this6.hasResourcesForLng || !_this6.hasResourcesForLng[language])) setTimeout(function() {
                        _this6.checkIfLanguagesLoaded(function() {
                            if (!_this6.loadedLanguages) return;
                            if (_this6.loadedLanguages.indexOf(language) > -1) return;
                            if (_this6.warnedLanguages && _this6.warnedLanguages.indexOf(language) > -1) return;
                            _this6.warnedLanguages || (_this6.warnedLanguages = []);
                            _this6.warnedLanguages.push(language);
                            if (logger) logger.error("Language \"".concat(language, "\" is not available in Locize project ").concat(_this6.options.projectId, "!"));
                        });
                    }, randomizeTimeout(_this6.options.checkForProjectTimeout));
                    if (!_this6.somethingLoaded) {
                        if (resourceNotExisting) setTimeout(function() {
                            return _this6.checkIfProjectExists();
                        }, randomizeTimeout(_this6.options.checkForProjectTimeout));
                        else _this6.somethingLoaded = true;
                    }
                    callback(err, ret);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(options, url, payload, callback) {
                var _this7 = this;
                options = (0, _utilsJs.defaults)(options, this.options);
                if (typeof payload === 'function') {
                    callback = payload;
                    payload = undefined;
                }
                callback = callback || function() {};
                var clb = function clb(err, res) {
                    var resourceNotExisting = res && res.resourceNotExisting;
                    if (res && (res.status === 408 || res.status === 400)) return callback('failed loading ' + url, true, {
                        resourceNotExisting: resourceNotExisting
                    });
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url, true, {
                        resourceNotExisting: resourceNotExisting
                    });
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url, false, {
                        resourceNotExisting: resourceNotExisting
                    });
                    if (!res && err && err.message) {
                        var errorMessage = err.message.toLowerCase();
                        var isNetworkError = [
                            'failed',
                            'fetch',
                            'network',
                            'load'
                        ].find(function(term) {
                            return errorMessage.indexOf(term) > -1;
                        });
                        if (isNetworkError) return callback('failed loading ' + url + ': ' + err.message, true, {
                            resourceNotExisting: resourceNotExisting
                        });
                    }
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = JSON.parse(res.data);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + url + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    if (_this7.options.failLoadingOnEmptyJSON && !Object.keys(ret).length) return callback('loaded result empty for ' + url, false, {
                        resourceNotExisting: resourceNotExisting
                    });
                    callback(null, ret, {
                        resourceNotExisting: resourceNotExisting
                    });
                };
                if (!this.options.request || url.indexOf("/languages/".concat(options.projectId)) > 0) return (0, _requestJsDefault.default)(options, url, payload, clb);
                var info = getCustomRequestInfo(url, options, payload);
                handleCustomRequest(this.options, info, clb);
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback, options) {
                var _this8 = this;
                if (typeof callback !== 'function') callback = function callback() {};
                this.checkIfProjectExists(function(err) {
                    if (err) return callback(err);
                    var isMissing = (0, _utilsJs.isMissingOption)(_this8.options, [
                        'projectId',
                        'version',
                        'apiKey',
                        'referenceLng'
                    ]);
                    if (isMissing) return callback(new Error(isMissing));
                    if (!_this8.isAddOrUpdateAllowed) return callback('host is not allowed to create key.');
                    if (typeof languages === 'string') languages = [
                        languages
                    ];
                    if (languages.filter(function(l) {
                        return l === _this8.options.referenceLng;
                    }).length < 1) _this8.services && _this8.services.logger && _this8.services.logger.warn("locize-backend: will not save missings because the reference language \"".concat(_this8.options.referenceLng, "\" was not in the list of to save languages: ").concat(languages.join(', '), " (open your site in the reference language to save missings)."));
                    languages.forEach(function(lng) {
                        if (lng === _this8.options.referenceLng) _this8.queue.call(_this8, _this8.options.referenceLng, namespace, key, fallbackValue, callback, options);
                    });
                });
            }
        },
        {
            key: "update",
            value: function update(languages, namespace, key, fallbackValue, callback, options) {
                var _this9 = this;
                if (typeof callback !== 'function') callback = function callback() {};
                this.checkIfProjectExists(function(err) {
                    if (err) return callback(err);
                    var isMissing = (0, _utilsJs.isMissingOption)(_this9.options, [
                        'projectId',
                        'version',
                        'apiKey',
                        'referenceLng'
                    ]);
                    if (isMissing) return callback(new Error(isMissing));
                    if (!_this9.isAddOrUpdateAllowed) return callback('host is not allowed to update key.');
                    if (!options) options = {};
                    if (typeof languages === 'string') languages = [
                        languages
                    ];
                    options.isUpdate = true;
                    languages.forEach(function(lng) {
                        if (lng === _this9.options.referenceLng) _this9.queue.call(_this9, _this9.options.referenceLng, namespace, key, fallbackValue, callback, options);
                    });
                });
            }
        },
        {
            key: "writePage",
            value: function writePage(lng, namespace, missings, callback) {
                var missingUrl = (0, _utilsJs.interpolateUrl)(this.options.addPath, {
                    lng: lng,
                    ns: namespace,
                    projectId: this.options.projectId,
                    version: this.options.version
                });
                var updatesUrl = (0, _utilsJs.interpolateUrl)(this.options.updatePath, {
                    lng: lng,
                    ns: namespace,
                    projectId: this.options.projectId,
                    version: this.options.version
                });
                if (missingUrl == null || updatesUrl == null) {
                    if (typeof callback === 'function') callback(new Error("i18next-locize-backend: unsafe lng/ns/projectId/version \u2014 refusing to persist missing keys for lng=" + (0, _utilsJs.sanitizeLogValue)(String(lng)) + ' ns=' + (0, _utilsJs.sanitizeLogValue)(String(namespace))));
                    return;
                }
                var hasMissing = false;
                var hasUpdates = false;
                var payloadMissing = {};
                var payloadUpdate = {};
                missings.forEach(function(item) {
                    var value = item.options && item.options.tDescription ? {
                        value: item.fallbackValue || '',
                        context: {
                            text: item.options.tDescription
                        }
                    } : item.fallbackValue || '';
                    if (item.options && item.options.isUpdate) {
                        if (!hasUpdates) hasUpdates = true;
                        payloadUpdate[item.key] = value;
                    } else {
                        if (!hasMissing) hasMissing = true;
                        payloadMissing[item.key] = value;
                    }
                });
                var todo = 0;
                if (hasMissing) todo++;
                if (hasUpdates) todo++;
                var doneOne = function doneOne(err) {
                    todo--;
                    if (!todo) callback(err);
                };
                if (!todo) doneOne();
                if (hasMissing) {
                    if (!this.options.request) (0, _requestJsDefault.default)((0, _utilsJs.defaults)({
                        authorize: true
                    }, this.options), missingUrl, payloadMissing, doneOne);
                    else {
                        var info = getCustomRequestInfo(missingUrl, (0, _utilsJs.defaults)({
                            authorize: true
                        }, this.options), payloadMissing);
                        handleCustomRequest(this.options, info, doneOne);
                    }
                }
                if (hasUpdates) {
                    if (!this.options.request) (0, _requestJsDefault.default)((0, _utilsJs.defaults)({
                        authorize: true
                    }, this.options), updatesUrl, payloadUpdate, doneOne);
                    else {
                        var _info = getCustomRequestInfo(updatesUrl, (0, _utilsJs.defaults)({
                            authorize: true
                        }, this.options), payloadUpdate);
                        handleCustomRequest(this.options, _info, doneOne);
                    }
                }
            }
        },
        {
            key: "write",
            value: function write(lng, namespace) {
                var _this0 = this;
                var lock = (0, _utilsJs.getPath)(this.queuedWrites, [
                    'locks',
                    lng,
                    namespace
                ]);
                if (lock) return;
                var missings = (0, _utilsJs.getPath)(this.queuedWrites, [
                    lng,
                    namespace
                ]);
                (0, _utilsJs.setPath)(this.queuedWrites, [
                    lng,
                    namespace
                ], []);
                var pageSize = 1000;
                var clbs = missings.filter(function(m) {
                    return m.callback;
                }).map(function(missing) {
                    return missing.callback;
                });
                if (missings.length) {
                    (0, _utilsJs.setPath)(this.queuedWrites, [
                        'locks',
                        lng,
                        namespace
                    ], true);
                    var namespaceSaved = function namespaceSaved() {
                        (0, _utilsJs.setPath)(_this0.queuedWrites, [
                            'locks',
                            lng,
                            namespace
                        ], false);
                        clbs.forEach(function(clb) {
                            return clb();
                        });
                        if (_this0.options.onSaved) _this0.options.onSaved(lng, namespace);
                        _this0.debouncedProcess(lng, namespace);
                    };
                    var amountOfPages = missings.length / pageSize;
                    var pagesDone = 0;
                    var page = missings.splice(0, pageSize);
                    this.writePage(lng, namespace, page, function() {
                        pagesDone++;
                        if (pagesDone >= amountOfPages) namespaceSaved();
                    });
                    while(page.length === pageSize){
                        page = missings.splice(0, pageSize);
                        if (page.length) this.writePage(lng, namespace, page, function() {
                            pagesDone++;
                            if (pagesDone >= amountOfPages) namespaceSaved();
                        });
                    }
                }
            }
        },
        {
            key: "process",
            value: function process() {
                var _this1 = this;
                Object.keys(this.queuedWrites).forEach(function(lng) {
                    if (lng === 'locks') return;
                    Object.keys(_this1.queuedWrites[lng]).forEach(function(ns) {
                        var todo = _this1.queuedWrites[lng][ns];
                        if (todo.length) _this1.write(lng, ns);
                    });
                });
            }
        },
        {
            key: "queue",
            value: function queue(lng, namespace, key, fallbackValue, callback, options) {
                (0, _utilsJs.pushPath)(this.queuedWrites, [
                    lng,
                    namespace
                ], {
                    key: key,
                    fallbackValue: fallbackValue || '',
                    callback: callback,
                    options: options
                });
                this.debouncedProcess();
            }
        }
    ]);
}();
I18NextLocizeBackend.type = 'backend';
exports.default = I18NextLocizeBackend;

},{"./utils.js":"8LxxV","./request.js":"5cvts","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"8LxxV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNSAFE_KEYS", ()=>UNSAFE_KEYS);
parcelHelpers.export(exports, "defaults", ()=>defaults);
parcelHelpers.export(exports, "isSafeUrlSegment", ()=>isSafeUrlSegment);
parcelHelpers.export(exports, "sanitizeLogValue", ()=>sanitizeLogValue);
parcelHelpers.export(exports, "redactUrlCredentials", ()=>redactUrlCredentials);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "setPath", ()=>setPath);
parcelHelpers.export(exports, "pushPath", ()=>pushPath);
parcelHelpers.export(exports, "getPath", ()=>getPath);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
parcelHelpers.export(exports, "interpolateUrl", ()=>interpolateUrl);
parcelHelpers.export(exports, "isMissingOption", ()=>isMissingOption);
parcelHelpers.export(exports, "optionExist", ()=>optionExist);
parcelHelpers.export(exports, "defer", ()=>defer);
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
var UNSAFE_KEYS = [
    '__proto__',
    'constructor',
    'prototype'
];
function defaults(obj) {
    each.call(slice.call(arguments, 1), function(source) {
        if (source) for(var _i = 0, _Object$keys = Object.keys(source); _i < _Object$keys.length; _i++){
            var prop = _Object$keys[_i];
            if (UNSAFE_KEYS.indexOf(prop) > -1) continue;
            if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function isSafeUrlSegment(v) {
    if (typeof v !== 'string') return false;
    if (v.length === 0 || v.length > 128) return false;
    if (UNSAFE_KEYS.indexOf(v) > -1) return false;
    if (v.indexOf('..') > -1) return false;
    if (v.indexOf('/') > -1 || v.indexOf('\\') > -1) return false;
    if (/[?#%\s@]/.test(v)) return false;
    if (/[\x00-\x1F\x7F]/.test(v)) return false;
    return true;
}
function sanitizeLogValue(v) {
    if (typeof v !== 'string') return v;
    return v.replace(/[\r\n\x00-\x1F\x7F]/g, ' ');
}
function redactUrlCredentials(u) {
    if (typeof u !== 'string' || u.length === 0) return u;
    try {
        var parsed = new URL(u);
        if (parsed.username || parsed.password) {
            parsed.username = '';
            parsed.password = '';
            return parsed.toString();
        }
        return u;
    } catch (e) {
        return u.replace(/(\/\/)[^/@\s]+@/g, '$1');
    }
}
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this;
        var args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (!object) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        object = object[key];
    }
    if (!object) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
var regexp = new RegExp('{{(.+?)}}', 'g');
function makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function interpolate(str, data, lng) {
    var match, value;
    function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
    }
    while(match = regexp.exec(str)){
        value = match[1].trim();
        if (typeof value !== 'string') value = makeString(value);
        if (!value) value = '';
        value = regexSafe(value);
        var subst = UNSAFE_KEYS.indexOf(value) > -1 ? value : data[value] || value;
        str = str.replace(match[0], subst);
        regexp.lastIndex = 0;
    }
    return str;
}
function interpolateUrl(str, data) {
    var match;
    var unsafe = false;
    while(match = regexp.exec(str)){
        var key = match[1].trim();
        if (UNSAFE_KEYS.indexOf(key) > -1) {
            regexp.lastIndex = 0;
            continue;
        }
        var raw = data[key];
        if (raw == null) {
            regexp.lastIndex = 0;
            continue;
        }
        var value = makeString(raw);
        var segments = value.split('+');
        var segmentsOk = true;
        var _iterator = _createForOfIteratorHelper(segments), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var seg = _step.value;
                if (!isSafeUrlSegment(seg)) {
                    segmentsOk = false;
                    break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (!segmentsOk) {
            unsafe = true;
            break;
        }
        str = str.replace(match[0], segments.join('+'));
        regexp.lastIndex = 0;
    }
    regexp.lastIndex = 0;
    return unsafe ? null : str;
}
function isMissingOption(obj, props) {
    return props.reduce(function(mem, p) {
        if (mem) return mem;
        if (!obj || !obj[p] || typeof obj[p] !== 'string' || !obj[p].toLowerCase() === p.toLowerCase()) {
            var err = "i18next-locize-backend :: got \"".concat(obj[p], "\" in options for ").concat(p, " which is invalid.");
            console.warn(err);
            return err;
        }
        return false;
    }, false);
}
function optionExist(obj, props) {
    return !isMissingOption(obj, props);
}
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"5cvts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof global !== 'undefined' && global.fetch) fetchApi = global.fetch;
else if (typeof window !== 'undefined' && window.fetch) fetchApi = window.fetch;
var XmlHttpRequestApi;
if (typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof(XMLHttpRequest)) === 'object') {
    if (typeof global !== 'undefined' && global.XMLHttpRequest) XmlHttpRequestApi = global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) XmlHttpRequestApi = window.XMLHttpRequest;
}
var ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof global !== 'undefined' && global.ActiveXObject) ActiveXObjectApi = global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) ActiveXObjectApi = window.ActiveXObject;
}
if (typeof fetchApi !== 'function') fetchApi = undefined;
if (!fetchApi && !XmlHttpRequestApi && !ActiveXObjectApi) try {
    require("e3d9870ecf77907b").then(function(mod) {
        fetchApi = mod.default;
    }).catch(function() {});
} catch (e) {}
var storage = {};
var parseMaxAge = function parseMaxAge(headerString) {
    if (!headerString) return 0;
    var matches = headerString.match(/max-age=([0-9]+)/);
    return matches ? parseInt(matches[1], 10) : 0;
};
var requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    var headers = {};
    if (typeof window === 'undefined' && typeof global !== 'undefined' && typeof global.process !== 'undefined' && global.process.versions && global.process.versions.node) headers['User-Agent'] = "i18next-locize-backend (node/".concat(global.process.version, "; ").concat(global.process.platform, " ").concat(global.process.arch, ")");
    if (options.authorize && options.apiKey) headers.Authorization = options.apiKey;
    if (payload || options.setContentTypeJSON) headers['Content-Type'] = 'application/json';
    var resolver = function resolver(response) {
        var resourceNotExisting = response.headers && response.headers.get('x-cache') === 'Error from cloudfront';
        if (options.cdnType === 'standard' && response.status === 404 && (!response.headers || !response.headers.get('x-cache'))) {
            resourceNotExisting = true;
            return callback(null, {
                status: 200,
                data: '{}',
                resourceNotExisting: resourceNotExisting
            });
        }
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status,
            resourceNotExisting: resourceNotExisting
        });
        var cacheControl = response.headers && response.headers.get('cache-control');
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data,
                resourceNotExisting: resourceNotExisting,
                cacheControl: cacheControl
            });
        }).catch(callback);
    };
    if (typeof fetch === 'function') fetch(url, {
        method: payload ? 'POST' : 'GET',
        body: payload ? JSON.stringify(payload) : undefined,
        headers: headers
    }).then(resolver).catch(callback);
    else fetchApi(url, {
        method: payload ? 'POST' : 'GET',
        body: payload ? JSON.stringify(payload) : undefined,
        headers: headers
    }).then(resolver).catch(callback);
};
var requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    try {
        var x = XmlHttpRequestApi ? new XmlHttpRequestApi() : new ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        if (options.authorize && options.apiKey) x.setRequestHeader('Authorization', options.apiKey);
        if (payload || options.setContentTypeJSON) x.setRequestHeader('Content-Type', 'application/json');
        x.onreadystatechange = function() {
            var resourceNotExisting = x.getResponseHeader('x-cache') === 'Error from cloudfront';
            if (options.cdnType === 'standard' && x.status === 404 && !x.getResponseHeader('x-cache')) {
                resourceNotExisting = true;
                return x.readyState > 3 && callback(null, {
                    status: 200,
                    data: '{}',
                    resourceNotExisting: resourceNotExisting
                });
            }
            var cacheControl = x.getResponseHeader('Cache-Control');
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText,
                resourceNotExisting: resourceNotExisting,
                cacheControl: cacheControl
            });
        };
        x.send(JSON.stringify(payload));
    } catch (e) {
        console && console.log(e);
    }
};
var request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    var useCacheLayer = typeof window === 'undefined' && options.useCacheLayer;
    if (useCacheLayer && !payload && !options.noCache && storage[url] && storage[url].expires > Date.now()) return callback(null, storage[url].data);
    var originalCallback = callback;
    callback = function callback(err, res) {
        if (useCacheLayer && !err && res && !payload && res.cacheControl) {
            var maxAge = parseMaxAge(res.cacheControl);
            if (maxAge > 0) storage[url] = {
                data: res,
                expires: Date.now() + maxAge * 1000
            };
        }
        originalCallback(err, res);
    };
    if (!payload && options.noCache && options.cdnType === 'standard') url += (url.indexOf('?') >= 0 ? '&' : '?') + 'cache=no';
    if (fetchApi) return requestWithFetch(options, url, payload, callback);
    if (typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof(XMLHttpRequest)) === 'object' || typeof ActiveXObject === 'function') return requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
exports.default = request;

},{"e3d9870ecf77907b":"f0clI","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}],"f0clI":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.load("kvkdd").then(()=>module.bundle.root('hoVg3'));

},{}],"kqmNz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Browser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
    each.call(slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || '/';
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
var cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, '', -1);
    }
};
var cookie$1 = {
    name: 'cookie',
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== 'undefined') {
            var c = cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== 'undefined') cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var querystring = {
    name: 'querystring',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            var query = search.substring(1);
            var params = query.split('&');
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf('=');
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var hasLocalStorageSupport = null;
var localStorageAvailable = function localStorageAvailable() {
    if (hasLocalStorageSupport !== null) return hasLocalStorageSupport;
    try {
        hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        hasLocalStorageSupport = false;
    }
    return hasLocalStorageSupport;
};
var localStorage = {
    name: 'localStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var hasSessionStorageSupport = null;
var sessionStorageAvailable = function sessionStorageAvailable() {
    if (hasSessionStorageSupport !== null) return hasSessionStorageSupport;
    try {
        hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        hasSessionStorageSupport = false;
    }
    return hasSessionStorageSupport;
};
var sessionStorage = {
    name: 'sessionStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var navigator$1 = {
    name: 'navigator',
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== 'undefined') {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var htmlTag = {
    name: 'htmlTag',
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === 'function') found = htmlTag.getAttribute('lang');
        return found;
    }
};
var path = {
    name: 'path',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') return undefined;
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else found = language[0].replace('/', '');
            }
        }
        return found;
    }
};
var subdomain = {
    name: 'subdomain',
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1; // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i); // if there is no match (null) return undefined
        if (!language) return undefined; // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function getDefaults() {
    return {
        order: [
            'querystring',
            'cookie',
            'localStorage',
            'sessionStorage',
            'navigator',
            'htmlTag'
        ],
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ] // cookieMinutes: 10,
    };
}
var Browser = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, _classCallCheckDefault.default)(this, Browser);
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    (0, _createClassDefault.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = defaults(options, this.options || {}, getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector(cookie$1);
                this.addDetector(querystring);
                this.addDetector(localStorage);
                this.addDetector(sessionStorage);
                this.addDetector(navigator$1);
                this.addDetector(htmlTag);
                this.addDetector(path);
                this.addDetector(subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === 'string') lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
Browser.type = 'languageDetector';

},{"@babel/runtime/helpers/esm/classCallCheck":"lY0Dw","@babel/runtime/helpers/esm/createClass":"25kt1","@parcel/transformer-js/src/esmodule-helpers.js":"bn6EL"}]},["cOeZF","3ef6L"], "3ef6L", "parcelRequire7046", {}, "./", "/")

//# sourceMappingURL=repo.33ad47cc.js.map
